(function() {
  'use strict';

  angular
    .module('icarus.planner', []);

})();

(function() {
  'use strict';

  angular
    .module('icarus.planner')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations('es', {
      'Revised_route_modal': {
        'title': 'Esta ruta ya fue previamente revisada',
        'body_first_line': '¿Deseas realizar nuevos cambios? ',
        'body_second_line': 'Si estás seguro, da clic en continuar.'
      }
    });
    $translateProvider.translations('en', {
      'Revised_route_modal': {
        'title': 'This route has been previously reviewed',
        'body_first_line': 'Do you want to make new changes?',
        'body_second_line': 'If you are sure, click continue.'
      }
    });
    $translateProvider.translations('pt', {
      'Revised_route_modal': {
        'title': 'Esta rota já foi revisto anteriormente',
        'body_first_line': 'Pretende efetuar alguma alteração?',
        'body_second_line': 'Se tiver a certeza, clique em continuar.'
      }
    });
  }
})();


(function() {
  'use strict';

  angular
    .module('icarus', [
      'ngAnimate',
      'ngMessages',
      'angular-storage',
      'duScroll',
      'ngCsv',
      'cgBusy',
      'pascalprecht.translate',
      'stripe.checkout',
      'ui.bootstrap',
      'ui.router',
      'ui.tree',
      'ngDialog',
      'countrySelect',
      'ngCookies',
      'icarus.bulk',
      'icarus.shared',
      'icarus.authentication',
      'icarus.settings',
      'icarus.planner',
      'icarus.plans',
      'icarus.chat',
      'icarus.extensions',
      'bcPhoneNumber',
      'angularPayments',
      'tmh.dynamicLocale',
      'angular-stripe',
      'ngFileSaver',
      'icarus.extraFieldDefinition',
      'icarus.log',
      'rzModule',
      'nvd3',
      'icarus.dashboard',
      'ngTagsInput',
      'icarus.assigner',
      'ngIdle',
      'icarus.main',
      'icarus.simpliPlanner',
      'icarus.tracking',
      'icarus.documents',
      'icarus.transportationProviderPayment'
      ]);
})();

(function() {
  'use strict';

  angular
    .module('icarus')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {

    //// Translate keys.
    $translateProvider.translations('es', {
        'ConfirmCompletePlan': {
            'title' : '¿Estás seguro que deseas finalizar este Plan?',
            'message' : 'Recuerda que una vez lo finalices se bloqueará la edición y sólo podrás eliminar rutas.',
            'confirm' : 'Confirmar',
            'cancel': 'Cancelar'
        }
    });
    $translateProvider.translations('en', {
        'ConfirmCompletePlan': {
            'title' : 'Are you sure you want to end this Plan?',
            'message' : 'Remember that once you finish it, editing will be blocked and you will only be able to delete routes.',
            'confirm' : 'Confirm',
            'cancel': 'Cancel'
        }
    });
    $translateProvider.translations('pt', {
        'ConfirmCompletePlan': {
            'title' : 'Tem certeza de que deseja encerrar este Plano?',
            'message' : 'Lembre-se que ao terminar a edição será bloqueada e você só poderá deletar rotas.',
            'confirm' : 'Confirme',
            'cancel': 'Cancelar'
        }
    });
  }

})();


(function() {
  'use strict';

  angular
    .module('icarus')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {

    //// Translate keys.
    $translateProvider.translations('es', {
        'Reoptimizer_modal': {
            'reoptimizer_title' :  'RUTAS SIN OPTIMIZAR',
            'reoptimizer_message' :  'Vas a guardar un plan con rutas editadas que no han sido optimizadas.',
            'reoptimizer_question' : '¿Deseas continuar?',
            'button_not_reoptimizer': 'Continuar de todas formas',
            'button_reoptimizer': 'Reoptimizar y guardar'
        }

    });
    $translateProvider.translations('en', {
        'Reoptimizer_modal': {
            'reoptimizer_title' :  'ROUTES NOT OPTIMIZED',
            'reoptimizer_message' :  'You are going to save a plan with edited routes that have not been optimized.',
            'reoptimizer_question' : '¿Do you want to continue?',
            'button_not_reoptimizer': 'Continue anyway',
            'button_reoptimizer': 'Reoptimize and save'
        }

    });
    $translateProvider.translations('pt', {
        'Reoptimizer_modal': {
            'reoptimizer_title' :  'ROTAS NÃO OTIMIZADAS',
            'reoptimizer_message' :  'Você vai salvar um plano com rotas editadas que não foram otimizadas.',
            'reoptimizer_question' : '¿Você quer continuar?',
            'button_not_reoptimizer': 'Continue de qualquer maneira',
            'button_reoptimizer': 'Reotimizar e salvar'
        }
    });
  }

})();


(function () {
  'use strict';
  angular
    .module('icarus.planner')
    .controller('ReoptimizerModal', ReoptimizerModal);

  /** @ngInject */
  function ReoptimizerModal($scope,MODAL_REOPTIMIZER_OPTION,MODAL_CANCEL_OPTION,MODAL_CONTINUE_OPTION) {
    var vm = this;
    vm.MODAL_REOPTIMIZER_OPTION=MODAL_REOPTIMIZER_OPTION;
    vm.MODAL_CANCEL_OPTION=MODAL_CANCEL_OPTION;
    vm.MODAL_CONTINUE_OPTION=MODAL_CONTINUE_OPTION;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .component('visitSimilarityMarker', {
      controller: VisitSimilarityMarkerController,
      templateUrl: 'app/planner/routes/components/visitSimilarityMarker/visitSimilarityMarker.html',
      bindings: {
        currentVisit: '<',
        previousVisit: '<',
        nextVisit: '<',
        vehicleColor: '<',
        joinSimilar: '<'
      }
    });

  /** @ngInject */
  function VisitSimilarityMarkerController(plannerService) {
    var ctrl = this;

    ctrl.areSimilarVisits = function (visit, visitToCompare) {
      if (!ctrl.joinSimilar || !visitToCompare || !plannerService.visitSimilarGraph) {
        return false;
      }

      return plannerService.visitSimilarGraph.isSimilar(visit, visitToCompare);
    };

    ctrl.shouldShowVisitMarker = function () {
      return (
        !ctrl.areSimilarVisits(ctrl.currentVisit, ctrl.previousVisit) ||
        !ctrl.areSimilarVisits(ctrl.currentVisit, ctrl.nextVisit)
      );
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .component('savePlanErrorModal', {
      controller: savePlanErrorModalController,
      templateUrl: 'app/planner/routes/components/savePlanErrorModal/savePlanErrorModal.html',
      bindings: {
        visitsTitles: '<',
        notSavedPlan: '=',
        isErrorInPlanInstance: '=',
        removeCanceledVisits: '&',
        closeModal: '&',
        savePlanErrorType: '=',
        savePlan: '&'
      }
    });

  /** @ngInject */
  function savePlanErrorModalController($filter, SAVE_PLAN_ERROR_BASE_TRANSLATE_PATH, INVALID_VISITS,
                                        CANCELED_VISITS) {
    var ctrl = this;
    var $translate = $filter('translate');

    ctrl.getModalFirstSentence = getModalFirstSentence;
    ctrl.getGoBackBtnText = getGoBackBtnText;
    ctrl.areInvalidVisits = areInvalidVisits;
    ctrl.areCanceledVisits = areCanceledVisits;
    ctrl.goBack = goBack;
    ctrl.confirm = confirm;

    function getModalFirstSentence() {
      var firstSentenceTranslateKey = SAVE_PLAN_ERROR_BASE_TRANSLATE_PATH + 'first_sentence.' +
        ctrl.savePlanErrorType;
      return $translate(firstSentenceTranslateKey);
    }

    function getGoBackBtnText() {
      var goBackBtnTextTranslateKey = SAVE_PLAN_ERROR_BASE_TRANSLATE_PATH + 'go_back_btn_text.' +
        ctrl.savePlanErrorType;
      return $translate(goBackBtnTextTranslateKey);
    }

    function areInvalidVisits() {
      return (ctrl.savePlanErrorType === INVALID_VISITS);
    }

    function areCanceledVisits() {
      return (ctrl.savePlanErrorType === CANCELED_VISITS);
    }

    function goBack() {
      ctrl.notSavedPlan = null;
      ctrl.isErrorInPlanInstance = false;
      ctrl.areCanceledVisits() && ctrl.removeCanceledVisits();
      ctrl.closeModal();
    }

    function confirm() {
      ctrl.notSavedPlan = null;
      ctrl.isErrorInPlanInstance = false;
      ctrl.savePlanErrorType = false;
      ctrl.savePlan({forceSave: true});
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.planner')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations('es', {
      'Routes' : {
        'save_plan_error_modal': {
          'first_sentence': {
            'invalid_visits': 'Las siguientes visitas fueron eliminadas mientras ruteabas:',
            'canceled_visits': 'Mientras ruteabas las siguientes visitas fueron canceladas y no formarán parte de ' +
              'tus rutas:'
          },
          'list_heading': 'Título',
          'second_sentence': '¿Quieres guardar el plan de todas formas?',
          'go_back_btn_text': {
            'invalid_visits': 'Volver',
            'canceled_visits': 'Entendido'
          },
          'confirm_btn_text': 'Confirmar'
        }
      }
    });
    $translateProvider.translations('en', {
      'Routes' : {
        'save_plan_error_modal': {
          'first_sentence': {
            'invalid_visits': 'The following visits were deleted while routing:',
            'canceled_visits': 'While you were routing the following visits were cancelled and will not be part of ' +
              'your routes:'
          },
          'list_heading': 'Title',
          'second_sentence': 'Do you want to save the plan anyway?',
          'go_back_btn_text': {
            'invalid_visits': 'Back',
            'canceled_visits': 'I understand'
          },
          'confirm_btn_text': 'Confirm'
        }
      }
    });
    $translateProvider.translations('pt', {
      'Routes' : {
        'save_plan_error_modal': {
          'first_sentence': {
            'invalid_visits': 'As seguintes visitas foram excluídas durante o roteamento:',
            'canceled_visits': 'Enquanto você estava fazendo a rota, as seguintes visitas foram canceladas e não ' +
              'farão parte de suas rotas:'
          },
          'list_heading': 'Título',
          'second_sentence': 'Deseja salvar o plano de qualquer maneira?',
          'go_back_btn_text': {
            'invalid_visits': 'Voltar',
            'canceled_visits': 'Entendido'
          },
          'confirm_btn_text': 'Confirme'
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .constant('SAVE_PLAN_ERROR_BASE_TRANSLATE_PATH', 'Routes.save_plan_error_modal.')
    .constant('INVALID_VISITS', 'invalid_visits')
    .constant('CANCELED_VISITS', 'canceled_visits');
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("browserBasedSaveDraftPlanStrategy", browserBasedSaveDraftPlanStrategy);

  /** @ngInject */
  function browserBasedSaveDraftPlanStrategy(__env, $q, indexedDbStorageSaveDraftPlanService, moment, DRAFT_FOR_APOLLO,
                                             PLAN_SUMMARIES_STORE_NAME, FULL_PLANS_STORE_NAME, ORIGINAL_PLANS_STORE_NAME,
                                             PLAN_SAVE_PENDING) {

    var service = {
      // Get a list of all plans that have a draft saved.
      getSavedPlans: getSavedPlans,

      // True if the given plan has already been prepared for autosave.
      isPlanInitializedForSaveDraftPlan: isPlanInitializedForSaveDraftPlan,

      // Prepare a plan for future autosave operations. Only needs to happen once.
      // Implies storing the first version of the plan draft along with the original (unchanged) plan state.
      initializeSaveDraftPlan: initializeSaveDraftPlan,

      // Save, load, delete autosave data for a plan.
      loadDraftPlan: loadDraftPlan,
      saveDraftPlan: saveDraftPlan,
      deleteDraftPlan: deleteDraftPlan,

      getByPrefix: getByPrefix,
      deleteByPlanKeys: deleteByPlanKeys
    };

    var EXPIRATION_MINUTES = __env.LOCAL_PLAN_AUTOSAVE_EXPIRATION_MINUTES;
    var storageService = indexedDbStorageSaveDraftPlanService;

    return service;

    function getSavedPlans() {
      return storageService.getSavedPlans()
        .then(_removeExpiredSaveDraftPlanData);
    }

    function isPlanInitializedForSaveDraftPlan(planId) {
      return storageService.getFullPlan(planId)
        .then(function (fullPlan) {
          return Boolean(fullPlan);
        });
    }

    function initializeSaveDraftPlan(planId, draftPlanObject, originalPlan, expirationMinutes) {
      var isEdited = draftPlanObject.summary.isNewPlan || planId === DRAFT_FOR_APOLLO || planId.indexOf(PLAN_SAVE_PENDING) === 0;
      draftPlanObject.summary.edited = isEdited;
      draftPlanObject.summary.expiration = _getExpiration(expirationMinutes);
      return $q.all([
        // Store locally for faster access
        storageService.saveFullPlan(planId, draftPlanObject),
        storageService.saveSummary(planId, draftPlanObject.summary),
        storageService.saveOriginalPlan(planId, originalPlan)
      ]);
    }

    function loadDraftPlan(planId) {
      return storageService.getFullPlan(planId)
        .then(_processExpiration)
        .then(function (saveDraftPlanResponse) {
          if (!saveDraftPlanResponse || !saveDraftPlanResponse.summary.edited) {
            return null;
          }

          return storageService.getOriginalPlan(planId)
            .then(function (originalPlanResponse) {
              saveDraftPlanResponse.originalPlan = originalPlanResponse;
              return saveDraftPlanResponse;
          });
        });
    }

    function saveDraftPlan(planId, draftPlanObject) {
      draftPlanObject.summary.edited = true;
      draftPlanObject.summary.expiration = _getExpiration();
      return $q.all([
        storageService.saveFullPlan(planId, draftPlanObject),
        storageService.saveSummary(planId, draftPlanObject.summary)]);
    }

    function deleteDraftPlan(planId) {
      return $q.all([
        storageService.deleteFullPlan(planId),
        storageService.deleteDelta(planId),
        storageService.deleteOriginalPlan(planId),
        storageService.deleteSummary(planId)]);
    }

    function getByPrefix(prefix) {
      return storageService.getByPrefix(PLAN_SUMMARIES_STORE_NAME, prefix)
        .then(function (results) {
          var planKeysToDelete = [];
          var filteredResults = [];

          results.forEach(function (result) {
            if (_isExpired(result.value.expiration)) {
              planKeysToDelete.push(result.key);
            } else {
              filteredResults.push(result.value);
            }
          });

          storageService.deleteByPlanKeys(FULL_PLANS_STORE_NAME, planKeysToDelete);
          storageService.deleteByPlanKeys(PLAN_SUMMARIES_STORE_NAME, planKeysToDelete);
          storageService.deleteByPlanKeys(ORIGINAL_PLANS_STORE_NAME, planKeysToDelete);

          return filteredResults;
        });
    }

    function deleteByPlanKeys(planKeysToDelete) {
      return $q.all([
        storageService.deleteByPlanKeys(FULL_PLANS_STORE_NAME, planKeysToDelete),
        storageService.deleteByPlanKeys(PLAN_SUMMARIES_STORE_NAME, planKeysToDelete),
        storageService.deleteByPlanKeys(ORIGINAL_PLANS_STORE_NAME, planKeysToDelete)
      ]);
    }

    // Private Methods

    /**
     * Remove expired autosave data from the list.
     *
     * Expiration is not automatic in indexedDb. Instead, we use the expiration
     * timestamp on the plan data and, if it's in the past, delete it at that point,
     * while also discarding it from the list.
     *
     * @param {Object} autosaveSummariesList
     * @returns
     */
     function _removeExpiredSaveDraftPlanData(autosaveSummariesList) {
      return autosaveSummariesList.map(function (planSummary) {
        if (_isExpired(planSummary.expiration)) {
          deleteDraftPlan(planSummary.id);
          return null;
        }

        return planSummary;
      })
      .filter(function (planSummary) {
        return planSummary !== null;
      });
    }

    function _processExpiration(fullPlan) {
      if (fullPlan && _isExpired(fullPlan.summary.expiration)) {
        deleteDraftPlan(fullPlan.summary.id);
        return null;
      }

      return fullPlan;
    }

    function _getExpiration(expirationMinutes) {
      var currentExpirationMinutes = expirationMinutes || EXPIRATION_MINUTES;
      return moment().add(currentExpirationMinutes, "minutes").unix();
    }

    function _isExpired(timestamp) {
      return moment().unix() >= timestamp;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("indexedDbStorageSaveDraftPlanService", indexedDbStorageSaveDraftPlanService);

  /** @ngInject */
  function indexedDbStorageSaveDraftPlanService(__env, $q, INDEXED_DB_DATABASE_NAME, INDEXED_DB_VERSION_NUMBER, TRANSACTION_READ_ONLY,
                                                TRANSACTION_READ_WRITE, ORIGINAL_PLANS_STORE_NAME, PLAN_SUMMARIES_STORE_NAME,
                                                FULL_PLANS_STORE_NAME, DELTAS_STORE_NAME, PLAN_SAVE_PENDING) {
    var service = {
      // Original status of the plan, before any draft has been saved
      getOriginalPlan: getOriginalPlan,
      saveOriginalPlan: saveOriginalPlan,
      deleteOriginalPlan: deleteOriginalPlan,

      // Differences between full plan and currently editing plan
      getDelta: getDelta,
      saveDelta: saveDelta,
      deleteDelta: deleteDelta,

      // Basic plan info like name, dates, etc. No route or visit details.
      saveSummary: saveSummary,
      deleteSummary: deleteSummary,
      getSavedPlans: getSavedPlans, // List of Summary of currently saved plans

      // Full current state of the plan, including visits and routes.
      getFullPlan: getFullPlan,
      saveFullPlan: saveFullPlan,
      deleteFullPlan: deleteFullPlan,

      getByPrefix: getByPrefix,
      deleteByPlanKeys: deleteByPlanKeys
    };

    var openDBPromise = null;

    return service;

    // Get

    function getSavedPlans() {
      return _getNewTransaction(PLAN_SUMMARIES_STORE_NAME, TRANSACTION_READ_ONLY)
        .then(function (tx) {
          var cursor = tx.objectStore(PLAN_SUMMARIES_STORE_NAME).openCursor();
          var summaries = [];

          return _cursorAsPromise(cursor, function (current, deferred) {
            if (!current) {
              deferred.resolve(summaries);
              return;
            }

            if (current.key.toString().indexOf(PLAN_SAVE_PENDING) !== 0) {
              summaries.push(current.value);
            }

            current.continue();
          });
        });
    }

    function getFullPlan(planId) {
      return _getNewTransaction(FULL_PLANS_STORE_NAME, TRANSACTION_READ_ONLY).then(function (tx) {
        var request = tx.objectStore(FULL_PLANS_STORE_NAME).get(planId);
        return _requestAsPromise(request);
      });
    }

    function getOriginalPlan(planId) {
      return _getNewTransaction(ORIGINAL_PLANS_STORE_NAME, TRANSACTION_READ_ONLY).then(function (tx) {
        var request = tx.objectStore(ORIGINAL_PLANS_STORE_NAME).get(planId);
        return _requestAsPromise(request);
      });
    }

    function getDelta(planId) {
      return _getNewTransaction(DELTAS_STORE_NAME, TRANSACTION_READ_ONLY).then(function (tx) {
        var request = tx.objectStore(DELTAS_STORE_NAME).get(planId);
        return _requestAsPromise(request);
      });
    }

    // Save

    function saveDelta(planId, delta) {
      return _getNewTransaction(DELTAS_STORE_NAME, TRANSACTION_READ_WRITE).then(function (tx) {
        tx.objectStore(DELTAS_STORE_NAME).put(delta, planId);
        return _transactionAsPromise(tx);
      });
    }

    function saveSummary(planId, summary) {
      return _getNewTransaction(PLAN_SUMMARIES_STORE_NAME, TRANSACTION_READ_WRITE).then(function (tx) {
        tx.objectStore(PLAN_SUMMARIES_STORE_NAME).put(summary, planId);
        return _transactionAsPromise(tx);
      });
    }

    function saveFullPlan(planId, fullPlan) {
      return _getNewTransaction(FULL_PLANS_STORE_NAME, TRANSACTION_READ_WRITE).then(function (tx) {
        tx.objectStore(FULL_PLANS_STORE_NAME).put(fullPlan, planId);
        return _transactionAsPromise(tx);
      });
    }

    function saveOriginalPlan(planId, originalPlan) {
      return _getNewTransaction(ORIGINAL_PLANS_STORE_NAME, TRANSACTION_READ_WRITE).then(function (tx) {
        tx.objectStore(ORIGINAL_PLANS_STORE_NAME).put(originalPlan, planId);
        return _transactionAsPromise(tx);
      });
    }

    // Delete

    function deleteDelta(planId) {
      return _getNewTransaction(DELTAS_STORE_NAME, TRANSACTION_READ_WRITE).then(function (tx) {
        tx.objectStore(DELTAS_STORE_NAME).delete(planId);
        return _transactionAsPromise(tx);
      });
    }

    function deleteFullPlan(planId) {
      return _getNewTransaction(FULL_PLANS_STORE_NAME, TRANSACTION_READ_WRITE).then(function (tx) {
        tx.objectStore(FULL_PLANS_STORE_NAME).delete(planId);
        return _transactionAsPromise(tx);
      });
    }

    function deleteOriginalPlan(planId) {
      return _getNewTransaction(ORIGINAL_PLANS_STORE_NAME, TRANSACTION_READ_WRITE).then(function (tx) {
        tx.objectStore(ORIGINAL_PLANS_STORE_NAME).delete(planId);
        return _transactionAsPromise(tx);
      });
    }

    function deleteSummary(planId) {
      return _getNewTransaction(PLAN_SUMMARIES_STORE_NAME, TRANSACTION_READ_WRITE).then(function (tx) {
        tx.objectStore(PLAN_SUMMARIES_STORE_NAME).delete(planId);
        return _transactionAsPromise(tx);
      });
    }

    function getByPrefix(storeName, prefix) {
      return _getNewTransaction(storeName, TRANSACTION_READ_ONLY)
        .then(function (tx) {
          var cursor = tx.objectStore(storeName).openCursor();
          var results = [];

          return _cursorAsPromise(cursor, function (current, deferred) {
            if (!current) {
              deferred.resolve(results);
              return;
            }

            var key = current.key;

            if (key.toString().indexOf(prefix) === 0) {
              results.push({
                key: key,
                value: current.value
              });
            }

            current.continue();
          });
        });
    }

    function deleteByPlanKeys(storeName, planKeysToDelete) {
      if (!angular.isArray(planKeysToDelete) || planKeysToDelete.length === 0) {
        return $q.when(null);
      }

      return _getNewTransaction(storeName, TRANSACTION_READ_WRITE)
        .then(function (tx) {
          var objectStore = tx.objectStore(storeName);

          planKeysToDelete.forEach(function (planKeyToDelete) {
            objectStore.delete(planKeyToDelete);
          });

          return _transactionAsPromise(tx);
        });
    }

    // Private Methods

    function _openIndexedDB() {
      if (openDBPromise) {
        return openDBPromise;
      }

      var deferred = $q.defer();
      var request = indexedDB.open(INDEXED_DB_DATABASE_NAME, INDEXED_DB_VERSION_NUMBER);

      request.onsuccess = function (event) {
        var db = event.target.result;
        deferred.resolve(db);
      };

      request.onupgradeneeded = function (event) {
        var db = event.target.result;

        [
          ORIGINAL_PLANS_STORE_NAME,
          PLAN_SUMMARIES_STORE_NAME,
          FULL_PLANS_STORE_NAME,
          DELTAS_STORE_NAME
        ].forEach(function (objectStoreName) {
          if (!db.objectStoreNames.contains(objectStoreName)) {
            db.createObjectStore(objectStoreName);
          }
        });
      };

      request.onerror = function (error) {
        console.error("Error opening DB: ", error);
        deferred.reject(error);
      };

      openDBPromise = deferred.promise;
      return openDBPromise;
    }

    function _getNewTransaction(storeName, transaction) {
      return _openIndexedDB().then(function (db) {
        var typeOfTransaction = transaction || TRANSACTION_READ_ONLY;
        return db.transaction(storeName, typeOfTransaction);
      });
    }

    function _cursorAsPromise(cursor, onSuccess) {
      var deferred = $q.defer();
      cursor.onsuccess = function (event) {
        onSuccess(event.target.result, deferred);
      };

      cursor.onerror = function (event) {
          deferred.reject(event.target.errorCode);
      };

      return deferred.promise;
    }

    function _transactionAsPromise(tx) {
      var deferred = $q.defer();
      tx.oncomplete = function (event) {
        deferred.resolve(event.target.result);
      };

      tx.onerror = function (event) {
        deferred.reject(event.target.errorCode);
      };

      return deferred.promise;
    }

    function _requestAsPromise(req) {
      var deferred = $q.defer();
      req.onsuccess = function (event) {
        deferred.resolve(event.target.result);
      };

      req.onerror = function (event) {
        deferred.reject(event.target.errorCode);
      };

      return deferred.promise;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .constant("INDEXED_DB_DATABASE_NAME", "autosave")
    .constant("INDEXED_DB_VERSION_NUMBER", 1)
    .constant("TRANSACTION_READ_ONLY", "readonly")
    .constant("TRANSACTION_READ_WRITE", "readwrite")
    .constant("ORIGINAL_PLANS_STORE_NAME", "originalPlans")
    .constant("PLAN_SUMMARIES_STORE_NAME", "planSummaries")
    .constant("FULL_PLANS_STORE_NAME", "fullPlans")
    .constant("DELTAS_STORE_NAME", "deltas");
})();

(function () {
  "use strict";

  angular
    .module("icarus.main", []);
})();

(function () {
  "use strict";

  angular
    .module("icarus.main")
    .component("trial", {
      templateUrl: "app/main/components/trial/trial.html",
      controller: TrialController,
      bindings: {
        showTrial: "<",
        accountActiveUntil: "<",
        goStateUprofile: "&",
        closeTrial: "&"
      }
    });

    /** @ngInject */
  function TrialController($filter, moment) {
    var ctrl = this;
    var $translate = $filter("translate");

    ctrl.getTrialMessage = function () {
      return $translate("Trial.test_will_end") + " " + moment(ctrl.accountActiveUntil).fromNow() + ".";
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations("es", {
      Trial: {
        test_will_end: "Tu prueba gratuita terminará",
        test_active_account: "Activa tu cuenta aquí"
      }
    });

    $translateProvider.translations("en", {
      Trial: {
        test_will_end: "Your free trial will end",
        test_active_account: "Activate your account here"
      }
    });

    $translateProvider.translations("pt", {
      Trial: {
        test_will_end: "Seu teste gratuito finalizará",
        test_active_account: "Ativar sua conta aqui"
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.main")
    .component("submenu", {
      templateUrl: "app/main/components/submenu/submenu.html",
      controller: SubmenuController,
      bindings: {
        parentItem: "<",
        goToModule: '&'
      }
    });

  /** @ngInject */
  function SubmenuController() {
    var ctrl = this;

    ctrl.callGoToModule = function (item) {
      ctrl.goToModule({item: item});
    };

    ctrl.closeSubmenu = function () {
      ctrl.parentItem.isSubmenuOpen = false;
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .constant("TIME_TO_CLOSE_SUBMENU_MILLISECONDS", 500);
})();

(function () {
  "use strict";

  angular
    .module("icarus.main")
    .component("sidebar", {
      templateUrl: "app/main/components/sidebar/sidebar.html",
      controller: SidebarController,
      bindings: {
        sectionsToDisplay: "<",
        profile: "<"
      }
    });

  /** @ngInject */
  function SidebarController($rootScope, sidebarUtils, plannerService, $location, $state, STATE, $timeout,
                              TIME_TO_EXPAND_SIDEBAR_MILLISECONDS) {
    var ctrl = this;
    var hoverTimeout;
    ctrl.isSidebarExpanded = false;
    ctrl.isSidebarFixed = false;
    ctrl.currentIndex = null;

    function shouldOpenCancelEditPlanModal() {
      return (
        $state.includes(STATE.ROUTES) &&
        plannerService.getPlanId() && !plannerService.isPlanEditable()
      );
    }

    ctrl.handleMouseEnter = function () {
      if (!ctrl.isSidebarExpanded && !ctrl.isSidebarFixed) {
          hoverTimeout = $timeout(function () {
            ctrl.isSidebarExpanded = true;
          }, TIME_TO_EXPAND_SIDEBAR_MILLISECONDS);
      }
    };

    ctrl.handleMouseLeave = function () {
      if(!ctrl.isSidebarFixed) {
        $timeout.cancel(hoverTimeout);
        ctrl.isSidebarExpanded = false;
      }
    };

    ctrl.toggleFixedSidebar = function () {
      ctrl.isSidebarFixed = !ctrl.isSidebarFixed;
      ctrl.isSidebarExpanded = ctrl.isSidebarFixed;
    };

    ctrl.goToModule = function (item) {

      if (item.disabled) {
        return;
      }

      if (shouldOpenCancelEditPlanModal()) {
        $rootScope.$broadcast('Planner:openModalCancelEditPlan');
        return;
      }

      ctrl.isSidebarExpanded = false;
      ctrl.isSidebarFixed = false;
      ctrl.profile.isSubmenuOpen = false;
      sidebarUtils.goToModule(item);
    };

    ctrl.onToggle = function (itemIndex) {
      ctrl.currentIndex = ctrl.currentIndex === itemIndex ? null : itemIndex;
    };

    ctrl.isNavbarHeightExceeded = sidebarUtils.isNavbarHeightExceeded;
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .constant("TIME_TO_EXPAND_SIDEBAR_MILLISECONDS", 1000);
})();

(function () {
  "use strict";

  angular
    .module("icarus.main")
    .component("profile", {
      templateUrl: "app/main/components/profile/profile.html",
      controller: ProfileController,
      bindings: {
        item: "<",
        isSidebarExpanded: '<',
        goToModule: '&'
      }
    });

  /** @ngInject */
  function ProfileController() {
    var ctrl = this;

    ctrl.toggleSubmenu = function () {
      ctrl.item.isSubmenuOpen = !ctrl.item.isSubmenuOpen;
    };

    ctrl.callGoToModule = function (item) {
      ctrl.goToModule({item: item});
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.main")
    .factory("notFoundPageService", notFoundPageService);

  /** @ngInject */
  function notFoundPageService() {

    var notFoundPageStatus = false;

    return {
      setNotFoundPageStatus: setNotFoundPageStatus,
      getNotFoundPageStatus: getNotFoundPageStatus
    };

    function setNotFoundPageStatus(status) {
      notFoundPageStatus = status;
    }

    function getNotFoundPageStatus() {
      return notFoundPageStatus;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.main")
    .component("notFoundPage", {
      templateUrl: "app/main/components/notFoundPage/notFoundPage.html",
      controller: notFoundPageController,
      bindings: {}
    });
     /** @ngInject */
  function notFoundPageController($window, apolloAuthService, moduleHelpersService) {
    var ctrl = this;

    ctrl.handleGoToProfile = function () {
      $window.location.href = apolloAuthService.buildRedirectURL(moduleHelpersService.getCurrentLanguage() + "/profile");
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations("es", {
      NotFoundPage: {
        title: "ERROR 404: DESTINO NO ENCONTRADO",
        text1: "Parece que te desviaste del plan de ruta. No te preocupes,",
        text2: "hasta los mejores GPS a veces fallan. Mientras recalibramos,",
        text3: "aquí tienes un atajo a tu perfil.",
        button: "Ir a mi perfil"
      }
    });

    $translateProvider.translations("en", {
      NotFoundPage: {
        title: "ERROR 404: DESTINATION NOT FOUND",
        text1: "It looks like you've deviated from your route plan. Don't worry,",
        text2: "even the best GPS sometimes fails. While we recalibrate,",
        text3: "here's a shortcut to your profile.",
        button: "Go to my profile"
      }
    });

    $translateProvider.translations("pt", {
      NotFoundPage: {
        title: "ERRO 404: DESTINO NÃO ENCONTRADO",
        text1: "Parece que você se desviou do plano de rota. Não se preocupe,",
        text2: "mesmo o melhor GPS às vezes falha. Enquanto recalibramos,",
        text3: "aqui está um atalho para seu perfil.",
        button: "Ir para meu perfil"
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.main")
    .component("navSubitem", {
      templateUrl: "app/main/components/navSubitem/navSubitem.html",
      controller: navSubitemController,
      bindings: {
        item: "<",
        goToModule: "&"
      }
    });
     /** @ngInject */
  function navSubitemController(sidebarUtils) {
    var ctrl = this;

    ctrl.isItemActive = function () {
      return sidebarUtils.isItemActive(ctrl.item);
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations("es", {
      NavSubitem: {
        Uprofile_title: "Ir a mi perfil",
        update_passphrase_title: "Cambiar palabra secreta",
        switch_account_title: "Cambiar cuenta",
        logout_title: "Salir",
        plans_title: "Mis planes",
        planner_title: 'Ruteador',
        assigner_title: "Asignador",
        tracking_title: "Seguimiento",
        visits_title: "Visitas",
        documents_title: "Gestión documental",
        documentation_title: "Documentación",
        document_management_title: "Gestión Documental",
        control_plane_title: "Panel de Control",
        transportation_provider_payment_title: "Pago proveedores",
        forceField_title: "Gestión de cartera",
        projects_title: "Proyectos",
        live_routing_title: "Ruteo en vivo"
      }
    });

    $translateProvider.translations("en", {
      NavSubitem: {
        Uprofile_title: "Go to my profile",
        update_passphrase_title: "Change passphrase",
        switch_account_title: "Switch account",
        logout_title: "Exit",
        plans_title: "My plans",
        planner_title: 'Router',
        assigner_title: "Assigner",
        tracking_title: "Tracking",
        visits_title: "Visits",
        documents_title: "Document management",
        documentation_title: "Documentation",
        document_management_title: "Document Management",
        control_plane_title: "Control Plane",
        transportation_provider_payment_title: "Supplier payment",
        forceField_title: "Portfolio Management",
        projects_title: "Projects",
        live_routing_title: "Live routing"
      }
    });

    $translateProvider.translations("pt", {
      NavSubitem: {
        Uprofile_title: "Vá ao meu perfil",
        update_passphrase_title: "Mudar palavra secreta",
        switch_account_title: "Mudar de conta",
        logout_title: "Sair",
        plans_title: "Meus planos",
        planner_title: 'Roteador',
        assigner_title: "Designador",
        tracking_title: "Rastreamento",
        visits_title: "Visitas",
        documents_title: "Gerenciamento de documentos",
        documentation_title: "Documentação",
        document_management_title: "Gerenciamento Documental",
        control_plane_title: "Painel de Controle",
        transportation_provider_payment_title: "Pagamento de fornecedores",
        forceField_title: "Gestão de Portfólio",
        projects_title: "Projetos",
        live_routing_title: "Roteamento ao vivo"
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.main")
    .component("navItem", {
      templateUrl: "app/main/components/navItem/navItem.html",
      controller: NavItemController,
      bindings: {
        item: "<",
        isSidebarExpanded: '<',
        goToModule: "&",
        onToggle: '&',
        indexItem: "<",
        currentIndex: '<'
      }
    });

  /** @ngInject */
  function NavItemController(sidebarUtils, $translate) {
    var ctrl = this;
    var language = $translate.use();
    ctrl.isItemExpanded = false;

    ctrl.isItemActive = function () {
      return sidebarUtils.isItemActive(ctrl.item);
    };

    ctrl.callGoToModule = function (item) {
      ctrl.goToModule({item: item});
    };

    ctrl.handleItemSelection = function() {
      ctrl.onToggle({indexItem: ctrl.indexItem});
      if(ctrl.item.href) {
        ctrl.callGoToModule(ctrl.item);
      }
    };

    ctrl.$onInit = function () {
      ctrl.currentLanguage = ['es', 'en', 'pt'].includes(language) ? language : 'en';
      if (sidebarUtils.isItemActive(ctrl.item)) {
        ctrl.onToggle({indexItem: ctrl.indexItem});
      }
    };

    ctrl.$onChanges = function (changes) {
      if (changes.currentIndex) {
        ctrl.isItemExpanded = ctrl.indexItem === ctrl.currentIndex;
      }
    };

    ctrl.getExpandIconURL = function () {
      return ctrl.isItemExpanded ? '/assets/images/minus.svg' : '/assets/images/plus.svg';
    };

    ctrl.shouldShowSubsections = function () {
      return ctrl.isSidebarExpanded && ctrl.item.subsections && ctrl.isItemExpanded;
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations("es", {
      NavItem: {
        routes_title: "Rutas",
        tracking_title: "Seguimiento",
        dashboard_title: "Reportes",
        chat_title: "Chat",
        clients_title: "Clientes",
        extensions_title: "Extensiones",
        simpliPlanner_title: "ForceField",
        fleet_management_title: "Gestión de flotas",
        settings_title: "Ajustes",
        help_title: "Ayuda",
        profile: "Mi perfil",
        ada_title: "Ada",
        integrations_title: "Integraciones"
      }
    });

    $translateProvider.translations("en", {
      NavItem: {
        routes_title: "Routes",
        tracking_title: "Tracking",
        dashboard_title: "Reports",
        chat_title: "Chat",
        clients_title: "Clients",
        extensions_title: "Extensions",
        simpliPlanner_title: "ForceField",
        fleet_management_title: "Fleet management",
        settings_title: "Settings",
        help_title: "Help",
        profile: "My profile",
        ada_title: "Ada",
        integrations_title: "Integrations"
      }
    });

    $translateProvider.translations("pt", {
      NavItem: {
        routes_title: "Rotas",
        tracking_title: "Rastreamento",
        dashboard_title: "Relatórios",
        chat_title: "Chat",
        clients_title: "Clientes",
        extensions_title: "Extensões",
        simpliPlanner_title: "ForceField",
        fleet_management_title: "Gerenciamento de frotas",
        settings_title: "Configurações",
        help_title: "Ajuda",
        profile: "Meu perfil",
        ada_title: "Ada",
        integrations_title: "Integrações"
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.main")
    .component("mobileSidebar", {
      templateUrl: "app/main/components/mobileSidebar/mobileSidebar.html",
      controller: MobileSidebarController,
      bindings: {
        sectionsToDisplay: "<",
        profile: "<"
      }
    });

  /** @ngInject */
  function MobileSidebarController(sidebarUtils, $state, SECTIONS) {
    var ctrl = this;
    ctrl.currentIndex = null;

    ctrl.$onInit = function () {
      ctrl.isMobileSidebarDisplayed = false;
      ctrl.sectionTitle = $state.current.name.split('.',1).join('').toLowerCase();
    };

    ctrl.openMobileSidebar = function () {
      ctrl.isMobileSidebarDisplayed = true;
    };

    ctrl.closeMobileSidebarThroughButton = function () {
      ctrl.isMobileSidebarDisplayed = false;
      ctrl.currentIndex = null;
    };

    ctrl.closeMobileSidebarThroughBackground = function (event) {
      var container = document.getElementById("mobile-sidebar-menu");
      if (container.contains(event.target)) {
        return;
      }

      ctrl.profile.isSubmenuOpen = false;
      ctrl.isMobileSidebarDisplayed = false;
      ctrl.currentIndex = null;
    };

    ctrl.goToModule = function (item) {
      if (item.disabled) {
        return;
      }

      var sectionTitle = item.title.toLowerCase();
      if (sectionTitle !== SECTIONS.HELP) {
        ctrl.sectionTitle = sectionTitle;
      }

      ctrl.isMobileSidebarDisplayed = false;
      ctrl.profile.isSubmenuOpen = false;
      ctrl.currentIndex = null;
      sidebarUtils.goToModule(item);
    };

    ctrl.onToggle = function (itemIndex) {
      ctrl.currentIndex = ctrl.currentIndex === itemIndex ? null : itemIndex;
    };

    ctrl.isNavbarHeightExceeded = sidebarUtils.isNavbarHeightExceeded;

  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations("es", {
      MobileHeader: {
        planner_title: "Ruteador",
        assigner_title: "Asignador",
        tracking_title: "Seguimiento",
        plans_title: "Mis planes",
        dashboard_title: "Reportes",
        chat_title: "Chat",
        clients_title: "Clientes",
        visits_title: "Visitas",
        extensions_title: "Extensiones",
        simpliplanner_title: "ForceField",
        documents_title: "Gestión documental",
        documentation_title: "Documentación",
        document_management_title: "Gestión Documental",
        control_plane_title: "Panel de Control",
        transportation_provider_payment_title: "Pago proveedores",
        settings_title: "Ajustes",
        help_title: "Ayuda",
        uprofile_title: "Perfil",
        update_passphrase_title: "Cambiar palabra secreta",
        switch_account_title: "Cambiar cuenta",
        logout_title: "Salir",
        forcefield_title: "Gestión de cartera",
        projects_title: "Proyectos"
      }
    });

    $translateProvider.translations("en", {
      MobileHeader: {
        planner_title: "Router",
        assigner_title: "Assigner",
        tracking_title: "Tracking",
        plans_title: "My plans",
        dashboard_title: "Dashboards",
        chat_title: "Chat",
        clients_title: "Clients",
        visits_title: "Visits",
        extensions_title: "Extensions",
        simpliplanner_title: "ForceField",
        documents_title: "Document management",
        documentation_title: "Documentation",
        document_management_title: "Document Management",
        control_plane_title: "Control Plane",
        transportation_provider_payment_title: "Supplier payment",
        settings_title: "Settings",
        help_title: "Help",
        uprofile_title: "Profile",
        update_passphrase_title: "Change passphrase",
        switch_account_title: "Change account",
        logout_title: "Logout",
        forcefield_title: "Portfolio Management",
        projects_title: "Projects"
      }
    });

    $translateProvider.translations("pt", {
      MobileHeader: {
        planner_title: "Roteador",
        assigner_title: "Designador",
        tracking_title: "Rastreamento",
        plans_title: "Meus planos",
        dashboard_title: "Painel",
        chat_title: "Chat",
        clients_title: "Clientes",
        visits_title: "Visitas",
        extensions_title: "Extensões",
        simpliplanner_title: "ForceField",
        documents_title: "Gestão documental",
        documentation_title: "Documentação",
        document_management_title: "Gerenciamento Documental",
        control_plane_title: "Painel de Controle",
        transportation_provider_payment_title: "Pagamento de fornecedores",
        settings_title: "Configurações",
        help_title: "Ajuda",
        uprofile_title: "Perfil",
        update_passphrase_title: "Mudar palavra secreta",
        switch_account_title: "Mudar de conta",
        logout_title: "Sair",
        forcefield_title: "Gestão de Portfólio",
        projects_title: "Projetos"
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  "use strict";

  angular.module("icarus.main").component("mobileCompatibilityMessage", {
    templateUrl: "app/main/components/mobileCompatibilityMessage/mobileCompatibilityMessage.html",
    controller: MobileCompatibilityMessageController
  });

  /** @ngInject */
  function MobileCompatibilityMessageController(mobileCompatibilityMessageService) {
    var ctrl = this;

    ctrl.onContinueWithMobile = mobileCompatibilityMessageService.setContinueWithMobile;
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations("es", {
      mobileCompatibilityMessage: {
        title: "Al parecer estás ingresando desde un smartphone o tablet",
        description: "Usa SimpliRoute desde un dispositivo de escritorio para que tengas una mejor experiencia.",
        buttonLabel: 'Continuar de todas formas'

      }
    });

    $translateProvider.translations("en", {
      mobileCompatibilityMessage: {
        title: "It appears you are logging in from a smartphone or tablet",
        description: "Use SimpliRoute from a desktop device for a better experience.",
        buttonLabel: "Continue anyway"
      }
    });

    $translateProvider.translations("pt", {
      mobileCompatibilityMessage: {
        title: "Parece que você está fazendo login em um smartphone ou tablet",
        description: "Use o SimpliRoute em um dispositivo desktop para ter uma experiência melhor.",
        buttonLabel: 'Continue de qualquer maneira'

      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.main")
    .component("logo", {
      templateUrl: "app/main/components/logo/logo.html"
    });
})();

(function() {
  'use strict';

  angular
    .module('icarus.tracking', []);

})();

(function () {
  'use strict';

  angular
    .module('icarus.tracking')
    .component('subItemsDetailsTable', {
      controller: subItemsDetailsTableController,
      templateUrl: 'app/tracking/components/subItemsDetailsTable/subItemsDetailsTable.html',
      bindings: {
        item: '<'
      }
    });

  /** @ngInject */
  function subItemsDetailsTableController($scope, ITEMS_COLUMN_BASE_CLASS) {
    var vm = this;

    $scope.item = vm.item;

    function setStyleClasses() {
      $scope.subItemsDetailColumnClass = ITEMS_COLUMN_BASE_CLASS + ' col-flex-1_2';
      $scope.subItemsQuantityColumnClass = ITEMS_COLUMN_BASE_CLASS + ' col-flex-3';
    }

    $scope.activate = function () {
      setStyleClasses();
    };
    $scope.activate();
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.tracking')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations('es', {
      'Items' : {
        'sub_items_detail'                : 'Detalle de subítems',
        'sub_items_quantity'              : 'Cantidad subítems'
      }
    });
    $translateProvider.translations('en', {
      'Items' : {
        'sub_items_detail'                : 'Subitems detail',
        'sub_items_quantity'              : 'Number of subitems'
      }
    });
    $translateProvider.translations('pt', {
      'Items' : {
        'sub_items_detail'                : 'Detalhe dos subitens',
        'sub_items_quantity'              : 'Número de subitens'
      }
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('icarus.tracking')
    .component('itemsDetailsTable', {
      controller: itemsDetailsTableController,
      templateUrl: 'app/tracking/components/itemsDetailsTable/itemsDetailsTable.html',
      bindings: {
        areItemsDetailsVisible: '=',
        itemsType: '<',
        itemsQuantitySummary: '<',
        items: '<',
        visitStatus: '<',
        itemsStatistics: '<'
      }
    });

  /** @ngInject */
  function itemsDetailsTableController($filter, $scope, ITEMS, PICKUP_ITEMS, ITEMS_BASE_TRANSLATE_PATH,
                                       ITEMS_COLUMN_BASE_CLASS, ITEMS_TABLE_ROW_BASE_CLASS,
                                       ITEMS_STATUS_DEFAULT_NG_CLASS, ITEMS_STATUS_ICON_PATH, ITEMS_STATUS_DELIVERED,
                                       ITEMS_STATUS_UNDELIVERED, PICKUP_ITEMS_STATUS_SUCCESSFUL,
                                       PICKUP_ITEMS_STATUS_FAILED, ITEMS_TABLE_FOOTER_BASE_CLASS) {
    var vm = this;
    var $translate = $filter('translate');

    $scope.itemsType = vm.itemsType;
    $scope.itemsQuantitySummary = vm.itemsQuantitySummary;
    $scope.items = vm.items;
    $scope.visitStatus = vm.visitStatus;
    $scope.itemsStatistics = vm.itemsStatistics;

    $scope.areSubItemsDetailsVisible = false;
    $scope.currentExpandedItem = null;

    $scope.goBack = function () {
      vm.areItemsDetailsVisible = false;
    };

    function arePickupItems() {
      return ($scope.itemsType === PICKUP_ITEMS);
    }

    $scope.shouldShowSubItemsColumn = function() {
      return arePickupItems() && Boolean($scope.itemsStatistics.totalSubItemsQuantityCollected);
    };

    function hasAnySubItems(item) {
      return arePickupItems() && item.sub_items.length;
    }

    $scope.getItemRowClass = function (item) {
      var styleClass = ITEMS_TABLE_ROW_BASE_CLASS;
      if (hasAnySubItems(item)) {
        styleClass += ' clickable-row';
        if ($scope.shouldShowSubItemsDetails(item)) {
          styleClass += ' clicked-row';
        }
      }
      return styleClass;
    };

    $scope.getItemTitle = function (item) {
      if (arePickupItems()) {
        return item.type_name;
      }
      return item.title;
    };

    $scope.getItemFractionQuantity = function (item) {
      if (arePickupItems()) {
        return item.quantity_collected;
      }
      return item.quantity_delivered;
    };

    $scope.getTranslatedItemStatus = function (item) {
      var translateKey;
      if ($scope.itemStatusTranslateKeys[item.status]) {
        translateKey = 'status.' + $scope.itemStatusTranslateKeys[item.status];
      } else {
        translateKey = 'status.' + item.status;
      }
      return $translate(ITEMS_BASE_TRANSLATE_PATH + translateKey);
    };

    $scope.getItemStatusNgClass = function (item) {
      var ngClassDict = Object.assign({}, ITEMS_STATUS_DEFAULT_NG_CLASS);
      ngClassDict['status-' + item.status] = true;
      return ngClassDict;
    };

    $scope.getItemStatusIconPath = function (item) {
      return ITEMS_STATUS_ICON_PATH['status-' + item.status];
    };

    $scope.showSubItemsDetailsTable = function (item) {
      if (!hasAnySubItems(item)) {
        return;
      }

      if ($scope.currentExpandedItem) {
        $scope.areSubItemsDetailsVisible = (item.id !== $scope.currentExpandedItem.id);
      } else {
        $scope.areSubItemsDetailsVisible = !$scope.areSubItemsDetailsVisible;
      }

      $scope.currentExpandedItem = $scope.areSubItemsDetailsVisible ? item : null;
    };

    $scope.shouldShowSubItemsDetails = function (item) {
      return Boolean($scope.currentExpandedItem) && item.id === $scope.currentExpandedItem.id;
    };

    function setTableContent() {
      if (arePickupItems()) {
        $scope.tableTitle = $translate(ITEMS_BASE_TRANSLATE_PATH + 'collected');
        $scope.fractionQuantityColumnHeader = $translate(ITEMS_BASE_TRANSLATE_PATH + 'quantity_collected');
        $scope.totalFractionQuantity = $scope.itemsStatistics.totalQuantityCollected;
      } else {
        $scope.tableTitle = $translate(ITEMS_BASE_TRANSLATE_PATH + 'dispatched');
        $scope.fractionQuantityColumnHeader = $translate(ITEMS_BASE_TRANSLATE_PATH + 'quantity_delivered');
        $scope.totalFractionQuantity = $scope.itemsStatistics.totalQuantityDelivered;
      }
    }

    function setStyleClasses() {
      if ($scope.shouldShowSubItemsColumn()) {
        $scope.itemsColumnHeaderClass = ITEMS_COLUMN_BASE_CLASS + ' col-flex-1_3';
        $scope.subItemsColumnClass = ITEMS_COLUMN_BASE_CLASS + ' col-flex-0_7';
        $scope.subItemsButtonClass = ITEMS_COLUMN_BASE_CLASS + ' col-flex-0_2';
      } else {
        $scope.itemsColumnHeaderClass = ITEMS_COLUMN_BASE_CLASS + ' col-flex-2';
      }

      $scope.itemsColumnElementsClass = $scope.itemsColumnHeaderClass + ' item';
      $scope.middleColumnsClass = ITEMS_COLUMN_BASE_CLASS + ' col-flex-1';
      $scope.statusColumnClass = $scope.middleColumnsClass + ' item-status';
      $scope.tableFooterClass = ITEMS_TABLE_FOOTER_BASE_CLASS + $scope.visitStatus;
    }

    $scope.activate = function () {
      setTableContent();
      setStyleClasses();
      $scope.itemStatusTranslateKeys = {
        completed: arePickupItems() ? PICKUP_ITEMS_STATUS_SUCCESSFUL : ITEMS_STATUS_DELIVERED,
        failed: arePickupItems() ? PICKUP_ITEMS_STATUS_FAILED : ITEMS_STATUS_UNDELIVERED
      };
    };
    $scope.activate();
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.tracking')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations('es', {
      'Items' : {
        'go_back'                : 'Volver',
        'collected'              : 'Ítems recolectados',
        'dispatched'             : 'Ítems despachados',
        'items_table'            : 'ÍTEMS',
        'sub_items_header'       : 'SUBÍTEMS',
        'quantity_planned'       : 'CANTIDAD \nPROGRAMADA',
        'quantity_collected'     : 'CANTIDAD \nRECOLECTADA',
        'quantity_delivered'     : 'CANTIDAD \nENTREGADA',
        'status'                 : {
          'header'               : 'ESTADO',
          'pending'              : 'Pendiente',
          'delivered'            : 'Entregado',
          'partial'              : 'Parcial',
          'undelivered'          : 'No entregado',
          'successful'           : 'Exitoso',
          'failed'               : 'Fallido'
        },
        'total'                  : 'TOTAL'
      }
    });
    $translateProvider.translations('en', {
      'Items' : {
        'go_back'                : 'Go back',
        'collected'              : 'Collected items',
        'dispatched'             : 'Items dispatched',
        'items_table'            : 'ITEMS',
        'sub_items_header'       : 'SUBITEMS',
        'quantity_planned'       : 'QUANTITY \nPLANNED',
        'quantity_collected'     : 'QUANTITY \nCOLLECTED',
        'quantity_delivered'     : 'QUANTITY \nDELIVERED',
        'status'                 : {
          'header'               : 'STATUS',
          'pending'              : 'Pending',
          'delivered'            : 'Delivered',
          'partial'              : 'Partial',
          'undelivered'          : 'Not delivered',
          'successful'           : 'Successful',
          'failed'               : 'Failed'
        },
        'total'                  : 'TOTAL'
      }
    });
    $translateProvider.translations('pt', {
      'Items' : {
        'go_back'                : 'Voltar',
        'collected'              : 'Itens recolhidos',
        'dispatched'             : 'Itens expedidos',
        'items_table'            : 'ITENS',
        'sub_items_header'       : 'SUBITENS',
        'quantity_planned'       : 'QUANTIDADE \nPROGRAMADA',
        'quantity_collected'     : 'QUANTIDADE \nRECOLHIDA',
        'quantity_delivered'     : 'QUANTIDADE \nENTREGUE',
        'status'                 : {
          'header'               : 'ESTADO',
          'pending'              : 'Pendente',
          'delivered'            : 'Concluído',
          'partial'              : 'Parcial',
          'undelivered'          : 'Não entregue',
          'successful'           : 'Bem-sucedido',
          'failed'               : 'Falhado'
        },
        'total'                  : 'TOTAL'
      }
    });
  }

})();

(function () {
  "use strict";

  angular
    .module("icarus.tracking")
    .component("retoolWidget", {
      templateUrl: "app/tracking/components/retoolWidget/retoolWidget.html",
      controller: retoolWidget,
      bindings: {
        url: "<"
      }
    });

  /** @ngInject */
  function retoolWidget () {
    var ctrl = this;
    ctrl.isOpen = false;

    ctrl.openRetool = function() {
      ctrl.isOpen = true;
    };
    ctrl.closeRetool = function() {
      ctrl.isOpen = false;
    };
  }

})();


(function() {
  'use strict';

  angular
    .module('icarus.tracking')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations('es', {
      'Invoices' : {
        'go_back'                : 'Volver',
        'invoice'                : 'Documento',
        'document_type'          : 'Tipo de documento',
        'payment_type'           : 'Tipo de pago',
        'payment_method'         : 'Método de pago',
        'payment_method_details' : 'Detalle medio de pago',
        'failed_invoice'         : 'Motivo de fallo',
        'collected'              : 'Ítems recolectados',
        'dispatched'             : 'Ítems despachados',
        'delivered_products'     : 'productos entregados de',
        'items'                  : 'Ítems',
        'quantity_planned'       : 'Cantidad planificada',
        'quantity_delivered'     : 'Cantidad entregada',
        'price'                  : 'Precio unitario',
        'motive'                 : 'Motivo',
        'next'                   : 'Siguiente documento',
        'prev'                   : 'Documento anterior',
        'total'                  : 'Total',
        'none'                   : '',
        'see_invoices'           : 'Ver documentos',
        'amount_delivered'       : 'Monto total entregado',
        'cash'                   : 'Efectivo',
        'check'                  : 'Cheque',
        'credit_card'            : 'Tarjeta de crédito',
        'debit_card'             : 'Tarjeta de débito',
        'transfer'               : 'Transferencia',
        'dated_check'            : 'Cheque postdatado',
        'credit'                 : 'Crédito',
        'status'                 : 'Estado',
        'pending'                : 'Pendiente',
        'delivered'              : 'Entregada',
        'successful'             : 'Exitoso',
        'failed'                 : 'Fallido',
        'canceled'               : 'Cancelado',
        'partial'                : 'Parcial',
        'completed'              : 'Completado',
        'bill'                   : 'Factura',
        'credit_note'            : 'Nota de crédito',
        'debit_note'             : 'Nota de débito',
        'delivery_note'          : 'Numero de guía',
        'pickup_note'            : 'Factura de retiro'
      }
    });
    $translateProvider.translations('en', {
      'Invoices' : {
        'go_back'                : 'Go back',
        'invoice'                : 'Document',
        'document_type'          : 'Document type',
        'payment_type'           : 'Payment type',
        'payment_method'         : 'Payment method',
        'payment_method_details' : 'Payment detail',
        'failed_invoice'         : 'Reason for failure',
        'collected'              : 'Collected items',
        'dispatched'             : 'Dispatched items',
        'delivered_products'     : 'products delivered of',
        'items'                  : 'Items',
        'quantity_planned'       : 'Quantity planned',
        'quantity_delivered'     : 'Quantity delivered',
        'price'                  : 'Unitary price',
        'motive'                 : 'Reason',
        'next'                   : 'Next document',
        'prev'                   : 'Previous document',
        'total'                  : 'Total',
        'none'                   : '',
        'see_invoices'           : 'View invoices',
        'amount_delivered'       : 'Total amount delivered',
        'cash'                   : 'Cash',
        'check'                  : 'Check',
        'credit_card'            : 'Credit card',
        'debit_card'             : 'Debit card',
        'transfer'               : 'Transfer',
        'dated_check'            : 'Dated check',
        'credit'                 : 'Credit',
        'status'                 : 'State',
        'pending'                : 'Pending',
        'delivered'              : 'Delivered',
        'successful'             : 'Successful',
        'failed'                 : 'Failed',
        'canceled'               : 'Canceled',
        'partial'                : 'Parcial',
        'completed'              : 'Completed',
        'bill'                   : 'Bill',
        'credit_note'            : 'Credit note',
        'debit_note'             : 'Debit note',
        'delivery_note'          : 'Guide number',
        'pickup_note'            : 'Withdrawal invoice'
      }
    });
    $translateProvider.translations('pt', {
      'Invoices' : {
        'go_back'                : 'Voltar',
        'invoice'                : 'Documento',
        'document_type'          : 'Tipo de documento',
        'payment_type'           : 'Tipo de pagamento',
        'payment_method'         : 'Método de pagamento',
        'payment_method_details' : 'detalhe de pagamento',
        'failed_invoice'         : 'Motivo de falha',
        'collected'              : 'Itens recolhidos',
        'dispatched'             : 'Itens despachados',
        'delivered_products'     : 'produtos entregues de',
        'items'                  : 'Itens',
        'quantity_planned'       : 'Quantidade planejada',
        'quantity_delivered'     : 'Quantidade entregue',
        'price'                  : 'Preço unitário',
        'motive'                 : 'Motivo',
        'next'                   : 'Documento anterior',
        'prev'                   : 'Próximo documento',
        'total'                  : 'Total',
        'none'                   : '',
        'see_invoices'           : 'Ver documentos',
        'amount_delivered'       : 'Montante total entregue',
        'cash'                   : 'Dinheiro',
        'check'                  : 'Cheque',
        'credit_card'            : 'Cartão de crédito',
        'debit_card'             : 'Cartão de débito',
        'transfer'               : 'Transferência',
        'dated_check'            : 'Cheque pré-datado',
        'credit'                 : 'Crédito',
        'status'                 : 'Estado',
        'pending'                : 'Pendente',
        'delivered'              : 'Entregue',
        'successful'             : 'Bem-sucedido',
        'failed'                 : 'Falhou',
        'canceled'               : 'Cancelado',
        'partial'                : 'Parcial',
        'completed'              : 'Concluído',
        'bill'                   : 'Fatura',
        'credit_note'            : 'Nota de crédito',
        'debit_note'             : 'Nota de débito',
        'delivery_note'          : 'Número do guia',
        'pickup_note'            : 'Fatura de retirada'
      }
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('icarus.tracking')
    .component('invoiceDetailsTable', {
      controller: invoiceDetailsTableController,
      templateUrl: 'app/tracking/components/invoiceDetailsTable/invoiceDetailsTable.html',
      bindings: {
        visit: '<'
      }
    });

  /** @ngInject */
  function invoiceDetailsTableController($filter, deliveryIssueService) {
    var ctrl = this;

    var $translate = $filter('translate');

    ctrl.deliveryIssues = [];
    ctrl.invoices = [];
    ctrl.invoiceIndex = 0;
    ctrl.currentInvoice = null;
    ctrl.total_prices = 0;
    ctrl.deliveredCount = 0;
    ctrl.invoicesItemsCount = 0;

    ctrl.$onInit = function () {
      loadInvoices();
      loadDeliveryIssues();
    };

    ctrl.$onChanges = function (changes) {
      if (changes.visit) {
        loadInvoices();
      }
    };

    function loadInvoices() {
      if (ctrl.visit) {
        ctrl.invoices = ctrl.visit.invoices || [];
        ctrl.invoiceIndex = 0;
        ctrl.currentInvoice = ctrl.invoices[ctrl.invoiceIndex];
        ctrl.invoicesItemsCount = (ctrl.currentInvoice && ctrl.currentInvoice.items) ? ctrl.currentInvoice.items.length : 0;
      }
    }

    function loadDeliveryIssues() {
      deliveryIssueService.getDeliveryIssues().then(function (deliveryIssueData) {
        ctrl.deliveryIssues = deliveryIssueData;
      });
    }

    ctrl.trimString = trimString;
    ctrl.nextInvoice = nextInvoice;
    ctrl.prevInvoice = prevInvoice;
    ctrl.getTotalPrices = getTotalPrices;
    ctrl.getTotalDeliveredUnits = getTotalDeliveredUnits;
    ctrl.getTotalDeliveredAmount = getTotalDeliveredAmount;
    ctrl.getTotalInvoiceAmount = getTotalInvoiceAmount;
    ctrl.totalInvoiceUnits = totalInvoiceUnits;
    ctrl.totalInvoiceDeliveredUnits = totalInvoiceDeliveredUnits;
    ctrl.getTotalPlannedQuantities = getTotalPlannedQuantities;
    ctrl.translateDetailOfInvoice = translateDetailOfInvoice;
    ctrl.changeNoneValue = changeNoneValue;
    ctrl.getDeliveryIssue = getDeliveryIssue;
    ctrl.changeCompletedStatus = changeCompletedStatus;
    ctrl.formatCurrency = formatCurrency;

    function nextInvoice() {
      if (ctrl.invoices === undefined) {
        return;
      }
      if (ctrl.invoiceIndex < ctrl.invoices.length - 1) {
        ctrl.invoiceIndex += 1;
        ctrl.currentInvoice = ctrl.invoices[ctrl.invoiceIndex];
      }
    }

    function prevInvoice() {
      if (ctrl.invoiceIndex === undefined || ctrl.invoices === undefined) {
        return;
      }
      if (ctrl.invoiceIndex > 0) {
        ctrl.invoiceIndex -= 1;
        ctrl.currentInvoice = ctrl.invoices[ctrl.invoiceIndex];
      }
    }

    function getDeliveryIssue(itemId) {
      var found = ctrl.deliveryIssues.find(function (issue) {
        return issue.id === itemId;
      });
      return found ? found.description : '';
    }

    function trimString(str) {
      if (str === null || str === undefined) {
        return '-';
      }
      if (str.length > 10) {
        return str.substring(0, 10) + '...';
      }
      return str;
    }

    function getTotalPrices() {
      var total = 0;
      if (ctrl.currentInvoice && ctrl.currentInvoice.items) {
        ctrl.currentInvoice.items.forEach(function (item) {
          if (item.unit_price) {
            total += item.unit_price;
          }
        });
      }
      ctrl.total_prices = total;
      return total;
    }

    function getTotalPlannedQuantities() {
      var total = 0;
      if (ctrl.currentInvoice && ctrl.currentInvoice.items) {
        ctrl.currentInvoice.items.forEach(function (item) {
          if (item.planned_units) {
            total += item.planned_units;
          }
        });
      }
      return total;
    }

    function getTotalDeliveredUnits() {
      var total = 0;
      if (ctrl.currentInvoice && ctrl.currentInvoice.items) {
        ctrl.currentInvoice.items.forEach(function (item) {
          if (item.delivered_units) {
            total += item.delivered_units;
          }
        });
      }
      return total;
    }

    function getTotalDeliveredAmount() {
      var total = 0;
      if (ctrl.currentInvoice && ctrl.currentInvoice.items) {
        ctrl.currentInvoice.items.forEach(function (item) {
          if (item.unit_price && item.delivered_units) {
            total += item.delivered_units * item.unit_price;
          }
        });
      }
      return total;
    }

    function getTotalInvoiceAmount() {
      var total = 0;
      if (ctrl.currentInvoice && ctrl.currentInvoice.items) {
        ctrl.currentInvoice.items.forEach(function (item) {
          if (item.unit_price) {
            total += item.planned_units * item.unit_price;
          }
        });
      }
      return total;
    }

    function totalInvoiceUnits() {
      var plannedQuantity = 0;
      ctrl.currentInvoice.items.forEach(function (item) {
        plannedQuantity += item.planned_units;
      });
      return plannedQuantity;
    }

    function totalInvoiceDeliveredUnits() {
      var deliveredQuantity = 0;
      ctrl.currentInvoice.items.forEach(function (item) {
        deliveredQuantity += item.delivered_units;
      });
      return deliveredQuantity;
    }

    function translateDetailOfInvoice(detail) {
      if (!detail || detail.toLowerCase() === 'none') {
        return;
      }
      if ($translate('Invoices.' + detail).startsWith('Invoices.')) {
        return detail;
      }
      return $translate('Invoices.' + detail.toLowerCase());
    }

    function formatCurrency(number) {
      return new Intl.NumberFormat('es-CL', {
        currency: 'CLP',
        minimumFractionDigits: 0
      }).format(number);
    }

    function changeCompletedStatus(method) {
      if (!method) {
        return;
      }

      if (method === $translate('Invoices.completed')) {
        return $translate('Invoices.delivered');
      }
      return method;
    }

    function changeNoneValue(method) {
      if (!method) return method;
      if (method.toLowerCase() === 'none') return '';
      return method;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .service("sidebarModulesService", sidebarModulesService);

  function sidebarModulesService(__env, SUBSECTIONS, apolloAuthService, $state, SECTIONS,
                                 TRANSPORTATION_PROVIDER_PAYMENT_URL_ADD_ON_PROPERTY_KEY, chatService, store,
                                 $document, $window, moduleHelpersService, modulesPermissionService, STATES) {

    var showVirtualAssistantChat = false;

    return {
      setModulesToDisplay: setModulesToDisplay,
      destroyAdaChatScript: destroyAdaChatScript
    };

    function setModulesToDisplay(moduleProps) {
      return _setModulesToDisplay(moduleProps);
    }

    function destroyAdaChatScript() {
      var scriptElement = $document[0].getElementById("ada-chat-script");
      if (scriptElement) {
        scriptElement.remove();
      }

      var containerElement = $document[0].getElementById("ada-chat-container");
      if (containerElement) {
        containerElement.remove();
      }

      delete $window.adaChatLoaded;

      showVirtualAssistantChat = false;
    }

    function _setModulesToDisplay(moduleProps) {
      var currentLanguage = moduleHelpersService.getCurrentLanguage();

      var modules = [];

      modules = _addRoutesModule(moduleProps, currentLanguage, modules);

      modules = _addTrackingModule(moduleProps, currentLanguage, modules);

      modules = _addDashboardModule(moduleProps, currentLanguage, modules);

      modules = _addClientsModule(moduleProps, currentLanguage, modules);

      modules = _addExtensionsModule(moduleProps, currentLanguage, modules);

      modules = _addFleetManagementModule(moduleProps, currentLanguage, modules);

      modules = _addSimpliPlannerModule(moduleProps, currentLanguage, modules);

      modules = _addIntegrationsModule(moduleProps, currentLanguage, modules);

      modules = _addChatModule(moduleProps, currentLanguage, modules);

      var configs = [];

      configs = _addVirtualAssistantModule(moduleProps, currentLanguage, configs);

      configs = _addSettingsModule(moduleProps, currentLanguage, configs);

      var helpModule = moduleHelpersService.getModule({
        icon: SECTIONS.HELP,
        title: SECTIONS.HELP,
        href: chatService.initChat
      });

      configs.push(helpModule);

      return {
        modules: modules,
        configs: configs
      };
    }

    function _addRoutesModule(moduleProps, currentLanguage, modules) {
      var newModules = Array.from(modules);

      var items = [];

      items = _addPlansSubModule(moduleProps, items);

      items = _addPlannerSubModule(moduleProps, currentLanguage, items);

      items = _addAssignerSubModule(moduleProps, items);

      if (items.length > 0) {
        var routesModule = moduleHelpersService.getModule({
          icon: SECTIONS.ROUTES,
          title: SECTIONS.ROUTES,
          href: "",
          disabled: moduleProps.isAccountCanceled
        });

        routesModule.subsections = {
          items: items
        };

        newModules.push(routesModule);
      }

      return newModules;
    }

    function _addTrackingModule(moduleProps, currentLanguage, modules) {
      var newModules = Array.from(modules);

      var items = [];

      items = _addTrackingSubModule(moduleProps, currentLanguage, items);

      items = _addVisitsSubModule(moduleProps, currentLanguage, items);

      if (items.length > 0) {
        var trackingModule = moduleHelpersService.getModule({
          icon: SECTIONS.TRACKING,
          title: SECTIONS.TRACKING,
          href: "",
          disabled: moduleProps.isAccountCanceled
        });

        trackingModule.subsections = {
          items: items
        };

        newModules.push(trackingModule);
      }

      return newModules;

    }

    function _addDashboardModule(moduleProps, currentLanguage, modules) {
      var newModules = Array.from(modules);

      if (!modulesPermissionService.isDashboardModuleAvailable(moduleProps)) {
        return newModules;
      }

      var dashboardHref = apolloAuthService.buildRedirectURL(currentLanguage + "/reports");
      var dashboardModule = moduleHelpersService.getModule({
        icon: SECTIONS.DASHBOARD,
        title: SECTIONS.DASHBOARD,
        href: moduleHelpersService.resolveHref(dashboardHref, moduleProps.user),
        disabled: moduleProps.isAccountCanceled
      });

      newModules.push(dashboardModule);

      return newModules;
    }

    function _addClientsModule(moduleProps, currentLanguage, modules) {
      var newModules = Array.from(modules);

      if (!modulesPermissionService.isClientsModuleAvailable(moduleProps)) {
        return newModules;
      }

      var clientsHref = apolloAuthService.buildRedirectURL(currentLanguage + "/clients");
      var clientsModule = moduleHelpersService.getModule({
        icon: SECTIONS.CLIENTS,
        title: SECTIONS.CLIENTS,
        href: moduleHelpersService.resolveHref(clientsHref, moduleProps.user),
        disabled: moduleProps.isAccountCanceled
      });

      newModules.push(clientsModule);

      return newModules;
    }

    function _addExtensionsModule(moduleProps, currentLanguage, modules) {
      var newModules = Array.from(modules);

      if (!modulesPermissionService.isEnableExtensionsModuleAvailable(moduleProps)) {
        return newModules;
      }

      var extensionsHref = apolloAuthService.buildRedirectURL(currentLanguage + "/extensions");
      var extensionsModule = moduleHelpersService.getModule({
        icon: SECTIONS.EXTENSIONS,
        title: SECTIONS.EXTENSIONS,
        href: moduleHelpersService.resolveHref(extensionsHref, moduleProps.user),
        disabled: moduleProps.isAccountCanceled
      });

      newModules.push(extensionsModule);

      return newModules;
    }

    function _addFleetManagementModule(moduleProps, currentLanguage, modules) {
      var newModules = Array.from(modules);

      var items = [];

      items = _addDocumentsSubModule(moduleProps, items);

      items = _addTmsSubmodule(moduleProps, currentLanguage, items);

      items = _addTransportationProviderPaymentSubModule(moduleProps, items);

      if (items.length > 0) {
        var fleetManagementModule = moduleHelpersService.getModule({
          icon: SECTIONS.FLEET_MANAGEMENT,
          title: SECTIONS.FLEET_MANAGEMENT,
          href: "",
          disabled: !moduleProps.tmsAddOn.enabled || moduleProps.isAccountCanceled
        });

        fleetManagementModule.subsections = {
          items: items
        };

        newModules.push(fleetManagementModule);
      }

      return newModules;
    }

    function _addSimpliPlannerModule(moduleProps, currentLanguage, modules) {
      var newModules = Array.from(modules);

      var simpliPlannerModule = null;

      // Start legacy logic
      if (!moduleProps.isForceFieldEnabled) {
        if (!moduleProps.userHasRouterPermissions) {
          return newModules;
        }

        var simpliPlannerModuleHref = _openSimpliPlannerModule(moduleProps);
        simpliPlannerModule = moduleHelpersService.getModule({
          icon: SECTIONS.SIMPLI_PLANNER,
          title: SECTIONS.SIMPLI_PLANNER,
          href: moduleHelpersService.resolveHref(simpliPlannerModuleHref, moduleProps.user),
          disabled: !moduleProps.isTerritoryPlannerEnabled || moduleProps.isAccountCanceled
        });

        newModules.push(simpliPlannerModule);

        return newModules;
      }
      // End legacy logic

      var items = [];

      items = _addForceFieldSubModule(moduleProps, currentLanguage, items);

      items = _addProjectsSubModule(moduleProps, currentLanguage, items);

      if (items.length > 0) {
        simpliPlannerModule = moduleHelpersService.getModule({
          icon: SECTIONS.SIMPLI_PLANNER,
          title: SECTIONS.SIMPLI_PLANNER,
          href: "",
          disabled: moduleProps.isAccountCanceled
        });

        simpliPlannerModule.subsections = {
          items: items
        };

        newModules.push(simpliPlannerModule);
      }

      return newModules;
    }

    function _addIntegrationsModule(moduleProps, currentLanguage, modules) {
      var newModules = Array.from(modules);

      if (!modulesPermissionService.isIntegrationsModuleAvailable(moduleProps)) {
        return newModules;
      }

      var integrationsHref = apolloAuthService.buildRedirectURL(currentLanguage + "/integrations");
      var integrationsModule = moduleHelpersService.getModule({
        icon: SECTIONS.INTEGRATIONS,
        title: SECTIONS.INTEGRATIONS,
        href: moduleHelpersService.resolveHref(integrationsHref, moduleProps.user),
        disabled: moduleProps.isAccountCanceled
      });

      newModules.push(integrationsModule);

      return newModules;
    }

    function _addChatModule(moduleProps, currentLanguage, modules) {
      var newModules = Array.from(modules);

      if (!modulesPermissionService.isChatModuleAvailable(moduleProps)) {
        return newModules;
      }

      var chatHref = apolloAuthService.buildRedirectURL(currentLanguage + "/chat");
      var chatModule = moduleHelpersService.getModule({
        icon: SECTIONS.CHAT,
        title: SECTIONS.CHAT,
        href: moduleHelpersService.resolveHref(chatHref, moduleProps.user),
        disabled: moduleProps.isAccountCanceled
      });

      newModules.push(chatModule);

      return newModules;
    }

    function _addVirtualAssistantModule(moduleProps, currentLanguage, configs) {
      var newConfigs = Array.from(configs);

      if (!modulesPermissionService.isVirtualAssistantModuleAvailable(moduleProps)) {
        return newConfigs;
      }

      var virtualAssistantModule = moduleHelpersService.getModule({
        icon: SECTIONS.ADA,
        title: SECTIONS.ADA,
        href: _showVirtualAssistant(currentLanguage),
        disabled: moduleProps.isAccountCanceled
      });

      newConfigs.push(virtualAssistantModule);

      return newConfigs;
    }

    function _addSettingsModule(moduleProps, currentLanguage, configs) {
      var newConfigs = Array.from(configs);

      if (!modulesPermissionService.isSettingsModuleAvailable(moduleProps)) {
        return newConfigs;
      }

      var settingsHref = moduleProps.user.is_router && moduleProps.enableSettingsModuleForRouterUser
        ? "settings.generals.list"
        : _getSettingsInitURL(moduleProps, currentLanguage);

      var settingsModule = moduleHelpersService.getModule({
        icon: SECTIONS.SETTINGS,
        title: SECTIONS.SETTINGS,
        href: moduleHelpersService.resolveHref(settingsHref, moduleProps.user),
        disabled: moduleProps.isAccountCanceled
      });

      newConfigs.push(settingsModule);

      return newConfigs;
    }

    function _addPlansSubModule(moduleProps, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isPlansSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var plans = {
        title: SUBSECTIONS.ROUTES.PLANS,
        href: moduleHelpersService.resolveHref(SUBSECTIONS.ROUTES.PLANS, moduleProps.user),
        disabled: moduleProps.isAccountCanceled
      };

      newItems.push(plans);

      return newItems;
    }

    function _addPlannerSubModule(moduleProps, currentLanguage, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isPlannerSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var apolloPlannerHref = apolloAuthService.buildRedirectURL(currentLanguage + "/pathfinder/planner");
      var plannerHref = moduleProps.hasApolloRdAccess
        ? moduleHelpersService.resolveHref(apolloPlannerHref, moduleProps.user)
        : STATES.VEHICLES_LIST;

      var planner = {
        title: SUBSECTIONS.ROUTES.PLANNER,
        href: plannerHref,
        disabled: moduleProps.isAccountCanceled
      };

      newItems.push(planner);

      return newItems;
    }

    function _addAssignerSubModule(moduleProps, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isAssignerSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var plans = {
        title: SUBSECTIONS.ROUTES.ASSIGNER,
        href: moduleHelpersService.resolveHref(SUBSECTIONS.ROUTES.ASSIGNER, moduleProps.user),
        disabled: moduleProps.isAccountCanceled
      };

      newItems.push(plans);

      return newItems;
    }

    function _addTrackingSubModule(moduleProps, currentLanguage, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isTrackingSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var title = moduleProps.enableLiveRouting ? SUBSECTIONS.TRACKING.LIVE_ROUTING : SUBSECTIONS.TRACKING.TRACKING;

      var trackingHref = apolloAuthService.buildRedirectURL(currentLanguage + "/tracking");
      var tracking = {
        title: title,
        href: moduleHelpersService.resolveHref(trackingHref, moduleProps.user),
        disabled: moduleProps.isAccountCanceled
      };

      newItems.push(tracking);

      return newItems;
    }

    function _addVisitsSubModule(moduleProps, currentLanguage, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isVisitsSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var visitsHref = apolloAuthService.buildRedirectURL(currentLanguage + "/visits");
      var visits = {
        title: SUBSECTIONS.TRACKING.VISITS,
        href: moduleHelpersService.resolveHref(visitsHref, moduleProps.user),
        disabled: moduleProps.isAccountCanceled
      };

      newItems.push(visits);

      return newItems;
    }

    function _addTmsSubmodule(moduleProps, currentLanguage, items) {
      var newItems = Array.from(items);

      if (modulesPermissionService.isDocumentManagementV1Available(moduleProps)) {
        var documentsdHref = apolloAuthService.buildRedirectURL(currentLanguage + "/resources/documentation");

        newItems.push({
          title: SUBSECTIONS.FLEET_MANAGEMENT.DOCUMENTATION,
          href: moduleHelpersService.resolveHref(documentsdHref, moduleProps.user),
          disabled: !moduleProps.tmsAddOn.enabled || moduleProps.isAccountCanceled
        });

        var managementHref = apolloAuthService.buildRedirectURL(currentLanguage + "/resources/ajustes-de-documentos");

        newItems.push({
          title: SUBSECTIONS.FLEET_MANAGEMENT.DOCUMENT_MANAGEMENT,
          href: moduleHelpersService.resolveHref(managementHref, moduleProps.user),
          disabled: !moduleProps.tmsAddOn.enabled || moduleProps.isAccountCanceled
        });
      }

      if (modulesPermissionService.isControlPlaneAvailable(moduleProps)) {
        var controlPlaneHref = apolloAuthService.buildRedirectURL(currentLanguage + "/resources/control-plane");

        newItems.push({
          title: SUBSECTIONS.FLEET_MANAGEMENT.CONTROL_PLANE,
          href: moduleHelpersService.resolveHref(controlPlaneHref, moduleProps.user),
          disabled: moduleProps.isAccountCanceled
        });
      }

      return newItems;
    }

    function _addDocumentsSubModule(moduleProps, items) {
      var newItems = Array.from(items);

      if (modulesPermissionService.isDocumentManagementV1Available(moduleProps)) {
        return newItems;
      }

      if (!modulesPermissionService.isDocumentsSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var documents = {
        title: SUBSECTIONS.FLEET_MANAGEMENT.DOCUMENTS,
        href: moduleHelpersService.resolveHref(SUBSECTIONS.FLEET_MANAGEMENT.DOCUMENTS, moduleProps.user),
        disabled: !moduleProps.tmsAddOn.enabled || moduleProps.isAccountCanceled
      };

      newItems.push(documents);

      return newItems;
    }

    function _addTransportationProviderPaymentSubModule(moduleProps, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isTransportationProviderPaymentSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var transportationProviderPaymentHref = _openTransportationProviderPaymentSubModule(moduleProps);
      var isTransportationProviderPaymentDisabled = !_isTransportationProviderPaymentSubModuleEnabled(moduleProps);
      var transportationProviderPayment = {
        title: SUBSECTIONS.FLEET_MANAGEMENT.TRANSPORTATION_PROVIDER_PAYMENT,
        href: moduleHelpersService.resolveHref(transportationProviderPaymentHref, moduleProps.user),
        disabled: isTransportationProviderPaymentDisabled || moduleProps.isAccountCanceled
      };

      newItems.push(transportationProviderPayment);

      return newItems;
    }

    function _addForceFieldSubModule(moduleProps, currentLanguage, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isForceFieldSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var forceFieldHref = apolloAuthService.buildRedirectURL(currentLanguage + "/forcefield");
      var forceField = {
        title: SUBSECTIONS.SIMPLI_PLANNER.FORCE_FIELD,
        href: moduleHelpersService.resolveHref(forceFieldHref, moduleProps.user),
        disabled: moduleProps.isAccountCanceled
      };

      newItems.push(forceField);

      return newItems;
    }

    function _addProjectsSubModule(moduleProps, currentLanguage, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isProjectsSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var projectsHref = apolloAuthService.buildRedirectURL(currentLanguage + "/forcefield/projects");
      var projects = {
        title: SUBSECTIONS.SIMPLI_PLANNER.PROJECTS,
        href: moduleHelpersService.resolveHref(projectsHref, moduleProps.user),
        disabled: moduleProps.isAccountCanceled
      };

      newItems.push(projects);

      return newItems;
    }

    function _openTransportationProviderPaymentSubModule(moduleProps) {
      var transportationProviderPaymentParams = {
        baseUrl: _getTransportationProviderPaymentBaseUrl(moduleProps),
        stripeCustomerId: moduleProps.user.account.stripe_customer_id,
        userToken: moduleProps.user.api_token
      };

      return function () {
        $state.go(SUBSECTIONS.FLEET_MANAGEMENT.TRANSPORTATION_PROVIDER_PAYMENT, transportationProviderPaymentParams);
      };
    }

    function _getTransportationProviderPaymentBaseUrl(moduleProps) {
      var transportationProviderPaymentUrlProperty = moduleProps.tmsAddOn.properties.find(function (property) {
        return property.key === TRANSPORTATION_PROVIDER_PAYMENT_URL_ADD_ON_PROPERTY_KEY;
      });

      return transportationProviderPaymentUrlProperty ? transportationProviderPaymentUrlProperty.value : null;
    }

    function _isTransportationProviderPaymentSubModuleEnabled(moduleProps) {
      return moduleProps.tmsAddOn.enabled && moduleProps.tmsAddOn.properties.some(function (property) {
        return property.key === TRANSPORTATION_PROVIDER_PAYMENT_URL_ADD_ON_PROPERTY_KEY;
      });
    }


    function _openSimpliPlannerModule(moduleProps) {
      var simpliPlannerModule = moduleProps.user.modules.find(function (userModule) {
        return userModule.label === SECTIONS.SIMPLI_PLANNER;
      });

      if (!simpliPlannerModule) {
        return "";
      }

      var simpliPlannerParams = {
        url: simpliPlannerModule.url,
        user: moduleProps.user
      };

      return function () {
        $state.go(SECTIONS.SIMPLI_PLANNER, simpliPlannerParams);
      };
    }

    function _showVirtualAssistant(currentLanguage) {
      return function () {
        if (showVirtualAssistantChat) {
          destroyAdaChatScript();
          return;
        }

        var token = store.get("token");

        if (!token) {
          return;
        }

        var baseUrl = __env.ADA_CHAT_URL;

        var chatUrl = baseUrl + "?token=" + token + "&locale=" + currentLanguage;

        var script = $document[0].createElement("script");

        script.setAttribute("type", "text/javascript");
        script.setAttribute("id", "ada-chat-script");
        script.setAttribute("src", __env.ADA_CHAT_URL_INITIATION_URL);
        script.setAttribute("data-url", chatUrl);
        script.setAttribute("async", true);
        script.setAttribute("defer", true);
        $document[0].body.appendChild(script);

        showVirtualAssistantChat = true;
      };
    }

    function _getSettingsInitURL(moduleProps, currentLanguage) {
      if (!moduleProps.user.role) {
        return apolloAuthService.buildRedirectURL(currentLanguage + "/settings/users");
      }

      return moduleHelpersService.getSettingsInitURLWithPermissions(moduleProps.user.role.permissions, currentLanguage);
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .service("settingsModulesService", settingsModulesService);

  function settingsModulesService(apolloAuthService, $filter, moduleHelpersService, modulesPermissionService) {

    var $translateText = $filter("translate");

    return {
      setModulesToDisplay: setModulesToDisplay
    };

    function setModulesToDisplay(moduleProps) {
      return _setModulesToDisplay(moduleProps);
    }

    function _setModulesToDisplay(moduleProps) {
      var currentLanguage = moduleHelpersService.getCurrentLanguage();

      var modules = {};

      if (moduleProps.enableSettingsModuleForRouterUser) {
        modules = _addZonesModule(moduleProps, currentLanguage, modules);

        modules = _addOptimizersModule(moduleProps, currentLanguage, modules);

        return modules;
      }

      modules = _addUsersModule(moduleProps, currentLanguage, modules);

      modules = _addVehiclesModule(moduleProps, currentLanguage, modules);

      modules = _addMobileModule(moduleProps, currentLanguage, modules);

      modules = _addSecurityModule(moduleProps, currentLanguage, modules);

      modules = _addCommunicationsModule(moduleProps, currentLanguage, modules);

      modules = _addZonesModule(moduleProps, currentLanguage, modules);

      modules = _addAutomationsModule(moduleProps, currentLanguage, modules);

      modules = _addOptimizersModule(moduleProps, currentLanguage, modules);

      modules = _addCustomizationModule(moduleProps, modules);

      return modules;
    }

    function _addZonesModule(moduleProps, currentLanguage, modules) {
      var newModules = Object.assign({}, modules);

      if (!modulesPermissionService.isZonesModuleAvailable(moduleProps)) {
        return newModules;
      }

      newModules.zones = {
        title: $translateText("zones"),
        icon: "/assets/images/map.svg",
        href: apolloAuthService.buildRedirectURL(currentLanguage + "/settings/zones"),
        isVisible: true
      };

      return newModules;
    }

    function _addOptimizersModule(moduleProps, currentLanguage, modules) {
      var newModules = Object.assign({}, modules);

      if (!modulesPermissionService.isOptimizersModuleAvailable(moduleProps)) {
        return newModules;
      }

      newModules.optimizers = {
        title: $translateText("optimizers"),
        icon: "/assets/images/rocket.svg",
        href: apolloAuthService.buildRedirectURL(currentLanguage + "/settings/optimizers"),
        isVisible: true
      };

      return newModules;
    }

    function _addUsersModule(moduleProps, currentLanguage, modules) {
      var newModules = Object.assign({}, modules);

      var items = [];

      items = _addUsersDetailsSubModule(moduleProps, currentLanguage, items);

      items = _addUsersRolesSubModule(moduleProps, currentLanguage, items);

       if (items.length > 0) {
        newModules.users = {
          title: $translateText("users"),
          icon: "/assets/images/users.svg",
          href: "",
          isVisible: true,
          submenu: {
            items: items,
            isExpanded: false
          }
        };
      }

      return newModules;
    }

    function _addVehiclesModule(moduleProps, currentLanguage, modules) {
      var newModules = Object.assign({}, modules);

      var items = [];

      items = _addMyVehiclesSubModule(moduleProps, currentLanguage, items);

      items = _addSkillsSubModule(moduleProps, currentLanguage, items);

      items = _addFleetsSubModule(moduleProps, currentLanguage, items);

      if (items.length > 0) {
        newModules.vehicles = {
          title: $translateText("vehicles"),
          icon: "/assets/images/vehicle.svg",
          href: "",
          isVisible: true,
          submenu: {
            items: items,
            isExpanded: false
          }
        };
      }

      return newModules;
    }

    function _addMobileModule(moduleProps, currentLanguage, modules) {
      var newModules = Object.assign({}, modules);

      var items = [];

      items = _addMobileConfigSubModule(moduleProps, currentLanguage, items);

      items = _addMobileFormSubModule(moduleProps, currentLanguage, items);

      if (items.length > 0) {
        newModules.mobile = {
          title: $translateText("mobile"),
          icon: "/assets/images/mobile.svg",
          href: "",
          isVisible: true,
          submenu: {
            items: items,
            isExpanded: false
          }
        };
      }

      return newModules;
    }

    function _addSecurityModule(moduleProps, currentLanguage, modules) {
      var newModules = Object.assign({}, modules);

      if (!modulesPermissionService.isSecurityModuleAvailable(moduleProps)) {
        return newModules;
      }

      newModules.security = {
        title: $translateText("security"),
        icon: "/assets/images/lock-close.svg",
        href: apolloAuthService.buildRedirectURL(currentLanguage + "/settings/security"),
        isVisible: true
      };

      return newModules;
    }

    function _addCommunicationsModule(moduleProps, currentLanguage, modules) {
      var newModules = Object.assign({}, modules);

      var items = [];

      items = _addCommunicationsSubModule(moduleProps, items);

      items = _addWhatsAppProSubModule(moduleProps, currentLanguage, items);

      if (items.length > 0) {
        newModules.communications = {
          title: $translateText("communications"),
          icon: "/assets/images/chat-bubble.svg",
          href: "",
          isVisible: true,
          submenu: {
            items: items,
            isExpanded: false
          }
        };
      }

      return newModules;
    }

    function _addAutomationsModule(moduleProps, currentLanguage, modules) {
      var newModules = Object.assign({}, modules);

      if (!modulesPermissionService.isAutomationsModuleAvailable(moduleProps)) {
        return newModules;
      }

      newModules.automations = {
        title: $translateText("automations"),
        icon: "/assets/images/magic.svg",
        href: apolloAuthService.buildRedirectURL(currentLanguage + "/settings/automations"),
        isVisible: true
      };

      return newModules;
    }

    function _addCustomizationModule(moduleProps, modules) {
      var newModules = Object.assign({}, modules);

      var items = [];

      if (!modulesPermissionService.isCustomizationModuleAvailable(moduleProps)) {
        return newModules;
      }

      items = _addMainSubModule(moduleProps, moduleHelpersService.getCurrentLanguage(), items);

      items = _addLTCustomizationSubModule(moduleProps, moduleHelpersService.getCurrentLanguage(), items);

      if (items.length > 0) {
        newModules.customization = {
          title: $translateText("customization"),
          icon: "/assets/images/tool.svg",
          href: "",
          isVisible: true,
          submenu: {
            items: items,
            isExpanded: false
          }
        };
      }

      return newModules;
    }

    function _addUsersDetailsSubModule(moduleProps, currentLanguage, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isUsersDetailsSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var usersDetails = {
        title: $translateText("usersDetails"),
        href: apolloAuthService.buildRedirectURL(currentLanguage + "/settings/users"),
        isVisible: true
      };

      newItems.push(usersDetails);

      return newItems;
    }

    function _addUsersRolesSubModule(moduleProps, currentLanguage, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isUsersRolesSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var usersRoles = {
        title: $translateText("usersRoles"),
        href: apolloAuthService.buildRedirectURL(currentLanguage + "/settings/roles"),
        isVisible: true
      };

      newItems.push(usersRoles);

      return newItems;
    }

    function _addMyVehiclesSubModule(moduleProps, currentLanguage, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isMyVehiclesSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var myVehicles = {
        title: $translateText("Vehicles.my_vehicles"),
        href: apolloAuthService.buildRedirectURL(currentLanguage + "/settings/vehicles"),
        isVisible: true
      };

      newItems.push(myVehicles);

      return newItems;
    }

    function _addSkillsSubModule(moduleProps, currentLanguage, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isSkillsSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var skills = {
        title: $translateText("skills"),
        href: apolloAuthService.buildRedirectURL(currentLanguage + "/settings/vehicles/skills"),
        isVisible: true
      };

      newItems.push(skills);

      return newItems;
    }

    function _addFleetsSubModule(moduleProps, currentLanguage, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isFleetsSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var fleets = {
        title: $translateText("fleets"),
        href: apolloAuthService.buildRedirectURL(currentLanguage + "/settings/fleets"),
        isVisible: true
      };

      newItems.push(fleets);

      return newItems;
    }

    function _addMobileConfigSubModule(moduleProps, currentLanguage, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isMobileConfigSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var mobileConfig = {
        title: $translateText("Mobile_general.mobile_section_title"),
        href: apolloAuthService.buildRedirectURL(currentLanguage + "/settings/mobile/config"),
        isVisible: true
      };

      newItems.push(mobileConfig);

      return newItems;
    }

    function _addMobileFormSubModule(moduleProps, currentLanguage, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isMobileFormSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var mobileForm = {
        title: $translateText("Mobile_general.mobile_checkout_form"),
        href: apolloAuthService.buildRedirectURL(currentLanguage + "/settings/mobile/form"),
        isVisible: true
      };

      newItems.push(mobileForm);

      return newItems;
    }

    function _addCommunicationsSubModule(moduleProps, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isCommunicationsSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var communications = {
        title: $translateText("communications"),
        href: "#/settings/communication/",
        isVisible: true
      };

      newItems.push(communications);

      return newItems;
    }

    function _addWhatsAppProSubModule(moduleProps, currentLanguage, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isWhatsAppProSubModuleAvailable(moduleProps)) {
        return newItems;
      }

      var whatsAppPro = {
        title: $translateText("whatsAppPro"),
        href: apolloAuthService.buildRedirectURL(currentLanguage + "/settings/communication/whatsApp-pro"),
        isVisible: true,
        isDisabled: !modulesPermissionService.isWhatsAppProSubModuleEnabled(moduleProps),
        id: "nav-item-action-whatsApp-pro"
      };

      newItems.push(whatsAppPro);

      return newItems;
    }

    function _addMainSubModule(moduleProps, currentLanguage, items) {
      var newItems = Array.from(items);

      var main = {
        title: $translateText("customizationMain"),
        href: "#/settings/account/",
        isVisible: true
      };

      newItems.push(main);

      return newItems;
    }

    function _addLTCustomizationSubModule(moduleProps, currentLanguage, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isCustomizationModuleAvailable(moduleProps)) {
        return newItems;
      }

      var livetracking = {
        title: $translateText("customizationLivetracking"),
        href: apolloAuthService.buildRedirectURL(currentLanguage + "/settings/customization/livetracking"),
        isVisible: true,
        isDisabled: !modulesPermissionService.isLTCustomizationSubModuleEnabled(moduleProps),
      };

      newItems.push(livetracking);

      return newItems;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .service("profileModulesService", profileModulesService);

  function profileModulesService(apolloAuthService, SECTIONS, $state, moduleHelpersService, modulesPermissionService) {

    return {
      setModulesToDisplay: setModulesToDisplay
    };

    function setModulesToDisplay(moduleProps) {
      return _setModulesToDisplay(moduleProps);
    }

    function _setModulesToDisplay(moduleProps) {
      var profileHref = apolloAuthService.buildRedirectURL(moduleHelpersService.getCurrentLanguage() + "/profile");
      var profileItem = moduleHelpersService.getModule({
        icon: SECTIONS.PROFILE,
        title: SECTIONS.PROFILE,
        href: moduleHelpersService.resolveHref(profileHref, moduleProps.user)
      });

      var submenu = {
        titles: [moduleProps.user.name],
        items: [profileItem]
      };

      submenu.items = _addEncryptionPassphraseModule(moduleProps, submenu.items);

      submenu = _addSwitchAccountModule(moduleProps, submenu);

      var logoutItem = moduleHelpersService.getModule({
        icon: "logout",
        title: "logout",
        href: moduleProps.logout
      });

      submenu.items.push(logoutItem);

      return {
        nameInitials: moduleProps.user.name.charAt(0),
        isSubmenuOpen: false,
        submenu: submenu
      };
    }

    function _addEncryptionPassphraseModule(moduleProps, items) {
      var newItems = Array.from(items);

      if (!modulesPermissionService.isEncryptionPassphraseModuleAvailable(moduleProps)) {
        return newItems;
      }

      var encryptionPassphraseItem = moduleHelpersService.getModule({
        icon: "update_passphrase",
        title: "update_passphrase",
        href: _goToUpdatePassphrase
      });

      newItems.push(encryptionPassphraseItem);

      return newItems;
    }

    function _addSwitchAccountModule(moduleProps, submenu) {
      var newSubmenu = Object.assign({}, submenu);

      if (!modulesPermissionService.isSwitchAccountModuleAvailable(moduleProps)) {
        return newSubmenu;
      }

      var switchAccountItem = moduleHelpersService.getModule({
        icon: "switch_account",
        title: "switch_account",
        href: moduleProps.switchAccount
      });

      newSubmenu.titles.push(moduleProps.user.account.name);
      newSubmenu.items.push(switchAccountItem);

      return newSubmenu;
    }

    function _goToUpdatePassphrase() {
      $state.go("auth.encryption-passphrase");
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .service("modulesPermissionService", modulesPermissionService);

  function modulesPermissionService(__env, PERMISSION_KEYS, moduleHelpersService,
                                    ENABLE_DOCUMENT_MANAGEMENT_V1_ADD_ON_PROPERTY_KEY, ENABLE_CONTROL_PLANE_ADD_ON_PROPERTY_KEY
                                  ) {

    return {
      isEncryptionPassphraseModuleAvailable: isEncryptionPassphraseModuleAvailable,
      isSwitchAccountModuleAvailable: isSwitchAccountModuleAvailable,
      isFleetsSubModuleAvailable: isFleetsSubModuleAvailable,
      isCommunicationsSubModuleAvailable: isCommunicationsSubModuleAvailable,
      isWhatsAppProSubModuleAvailable: isWhatsAppProSubModuleAvailable,
      isWhatsAppProSubModuleEnabled: isWhatsAppProSubModuleEnabled,
      isLTCustomizationSubModuleEnabled: isLTCustomizationSubModuleEnabled,
      isUsersDetailsSubModuleAvailable: isUsersDetailsSubModuleAvailable,
      isUsersRolesSubModuleAvailable: isUsersRolesSubModuleAvailable,
      isSecurityModuleAvailable: isSecurityModuleAvailable,
      isZonesModuleAvailable: isZonesModuleAvailable,
      isOptimizersModuleAvailable: isOptimizersModuleAvailable,
      isAutomationsModuleAvailable: isAutomationsModuleAvailable,
      isCustomizationModuleAvailable: isCustomizationModuleAvailable,
      isMyVehiclesSubModuleAvailable: isMyVehiclesSubModuleAvailable,
      isSkillsSubModuleAvailable: isSkillsSubModuleAvailable,
      isMobileConfigSubModuleAvailable: isMobileConfigSubModuleAvailable,
      isMobileFormSubModuleAvailable: isMobileFormSubModuleAvailable,
      isPlansSubModuleAvailable: isPlansSubModuleAvailable,
      isPlannerSubModuleAvailable: isPlannerSubModuleAvailable,
      isAssignerSubModuleAvailable: isAssignerSubModuleAvailable,
      isTrackingSubModuleAvailable: isTrackingSubModuleAvailable,
      isVisitsSubModuleAvailable: isVisitsSubModuleAvailable,
      isDashboardModuleAvailable: isDashboardModuleAvailable,
      isClientsModuleAvailable: isClientsModuleAvailable,
      isEnableExtensionsModuleAvailable: isEnableExtensionsModuleAvailable,
      isDocumentsSubModuleAvailable: isDocumentsSubModuleAvailable,
      isDocumentManagementV1Available: isDocumentManagementV1Available,
      isControlPlaneAvailable: isControlPlaneAvailable,
      isTransportationProviderPaymentSubModuleAvailable: isTransportationProviderPaymentSubModuleAvailable,
      isForceFieldSubModuleAvailable: isForceFieldSubModuleAvailable,
      isProjectsSubModuleAvailable: isProjectsSubModuleAvailable,
      isIntegrationsModuleAvailable: isIntegrationsModuleAvailable,
      isChatModuleAvailable: isChatModuleAvailable,
      isVirtualAssistantModuleAvailable: isVirtualAssistantModuleAvailable,
      isSettingsModuleAvailable: isSettingsModuleAvailable
    };

    function isEncryptionPassphraseModuleAvailable(moduleProps) {
      return moduleProps.isDataEncryptionEnabled;
    }

    function isSwitchAccountModuleAvailable(moduleProps) {
      return moduleProps.canSwitchAccount;
    }

    function isUsersDetailsSubModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return true;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.SETTINGS.USERS);
    }

    function isUsersRolesSubModuleAvailable(moduleProps) {
      return moduleProps.enableRoles && moduleProps.user.is_admin && !moduleProps.user.role;
    }

    function isSecurityModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return true;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.SETTINGS.SECURITY);
    }

    function isZonesModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return moduleProps.enableZones;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.SETTINGS.ZONES);
    }

    function isOptimizersModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return true;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.SETTINGS.OPTIMIZERS);
    }

    function isAutomationsModuleAvailable(moduleProps) {
      return moduleProps.enableActivepieces;
    }

    function isCustomizationModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return true;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.SETTINGS.CUSTOMIZATION);
    }

    function isMyVehiclesSubModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return true;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.SETTINGS.VEHICLES);
    }

    function isSkillsSubModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return true;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.SETTINGS.VEHICLES);
    }

    function isFleetsSubModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return moduleProps.enableFleets;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.SETTINGS.VEHICLES_FLEETS);
    }

    function isMobileConfigSubModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return true;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.SETTINGS.MOBILE);
    }

    function isMobileFormSubModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return true;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.SETTINGS.MOBILE);
    }

    function isCommunicationsSubModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return moduleProps.enableLiveTracking;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.SETTINGS.COMMUNICATIONS_LIVE_TRACKING);
    }

    function isWhatsAppProSubModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return moduleProps.enableLiveTracking;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.SETTINGS.COMMUNICATIONS_LIVE_TRACKING);
    }

    function isWhatsAppProSubModuleEnabled(moduleProps) {
      if (!moduleProps.user.role) {
        return moduleProps.enableWSP;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.SETTINGS.COMMUNICATIONS_WSP_PRO);
    }

    function isLTCustomizationSubModuleEnabled(moduleProps) {
      return moduleProps.enableLTCustomization;
    }

    function isPlansSubModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
      return moduleProps.enablePlans && (moduleProps.userHasAdminPermissions || moduleProps.user.is_coordinator);
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.PATHFINDER.PLANS);
    }

    function isPlannerSubModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return moduleProps.enableRouteDesigner && moduleProps.userHasRouterAndRouterJrPermissions;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.PATHFINDER.ROUTER);
    }

    function isAssignerSubModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return moduleProps.enableAssigner && moduleProps.userHasRouterAndRouterJrPermissions;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.PATHFINDER.ASSIGNER);
    }

    function isTrackingSubModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return moduleProps.isNotDriver;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.WATCHTOWER.TRACKING);
    }

    function isVisitsSubModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return __env.ENABLE_VISITS_MODULE_FEATURE && (moduleProps.userHasRouterAndMonitorPermissions || moduleProps.user.is_seller_viewer || moduleProps.user.is_seller);
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.WATCHTOWER.VISITS);
    }

    function isDashboardModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return moduleProps.isNotDriver;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.REPORTS);
    }

    function isClientsModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return moduleProps.enableClientsModule && moduleProps.userHasRouterPermissions;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.CLIENTS);
    }

    function isEnableExtensionsModuleAvailable(moduleProps) {
      return moduleProps.enableExtensions;
    }

    function isDocumentsSubModuleAvailable(moduleProps) {
      return moduleProps.userHasRouterPermissions;
    }

    function isDocumentManagementV1Available(moduleProps) {
      if (!moduleProps.tmsAddOn || !moduleProps.tmsAddOn.enabled) {
        return false;
      }

      var property = moduleProps.tmsAddOn.properties.find(function (p) {
        return p.key === ENABLE_DOCUMENT_MANAGEMENT_V1_ADD_ON_PROPERTY_KEY;
      });

      return !!property && String(property.value).toLowerCase() === 'true';
    }

    function isControlPlaneAvailable(moduleProps) {
      if (!moduleProps.tmsAddOn || !moduleProps.tmsAddOn.enabled) {
        return false;
      }

      var property = moduleProps.tmsAddOn.properties.find(function (p) {
        return p.key === ENABLE_CONTROL_PLANE_ADD_ON_PROPERTY_KEY;
      });

      return !!property && String(property.value).toLowerCase() === 'true';
    }

    function isTransportationProviderPaymentSubModuleAvailable(moduleProps) {
      return moduleProps.userHasRouterPermissions;
    }

    function isForceFieldSubModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return moduleProps.isForceFieldEnabled && moduleProps.userHasRouterPermissions;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.FORCE_FIELD);
    }

    function isProjectsSubModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return moduleProps.isForceFieldEnabled && moduleProps.userHasRouterPermissions;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.FORCE_FIELD);
    }

    function isIntegrationsModuleAvailable(moduleProps) {
      return moduleProps.userHasAdminPermissions;
    }

    function isChatModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return (moduleProps.simpliChatAddOn.enabled && moduleProps.isNotDriver) || moduleProps.simpliChatForSellerRolesEnabled;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.CHAT);
    }

    function isVirtualAssistantModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return moduleProps.enableVirtualAssistant;
      }

      return moduleHelpersService.isModuleAvailable(moduleProps.user.role.permissions, PERMISSION_KEYS.ADA);
    }

    function isSettingsModuleAvailable(moduleProps) {
      if (!moduleProps.user.role) {
        return moduleProps.userHasAdminPermissions || (moduleProps.user.is_router && moduleProps.enableSettingsModuleForRouterUser);
      }

      return moduleHelpersService.isSettingsModuleAvailable(moduleProps.user.role.permissions);
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .constant("PERMISSION_KEYS", {
      SETTINGS: {
        USERS: "settings.users",
        VEHICLES: "settings.vehicles",
        VEHICLES_FLEETS: "settings.vehicles.fleets",
        MOBILE: "settings.mobile",
        SECURITY: "settings.security",
        ZONES: "settings.zones",
        OPTIMIZERS: "settings.optimizers",
        CUSTOMIZATION: "settings.customization",
        COMMUNICATIONS_WSP_PRO: "settings.communications.wsp_pro",
        COMMUNICATIONS_LIVE_TRACKING: "settings.communications.live_tracking"
      },
      PATHFINDER: {
        PLANS: "pathfinder.plans",
        ROUTER: "pathfinder.router",
        ASSIGNER: "pathfinder.assigner"
      },
      WATCHTOWER: {
        TRACKING: "watchtower.tracking",
        VISITS: "watchtower.visits"
      },
      CLIENTS: "clients",
      REPORTS: "reports",
      FORCE_FIELD: "forcefield",
      CHAT: "chat",
      ADA: "ada"
    })
    .constant("ROUTE_STATES", {
      PLANS: "plans",
      PLANNER: "planner",
      ASSIGNER: "assigner",
      SETTINGS_COMMUNICATION: "settings.communication",
      SETTINGS_ACCOUNT: "settings.account",
      DOCUMENTS: "documents",
      SIMPLI_PLANNER: "simpliPlanner",
      TRANSPORTATION_PROVIDER_PAYMENT: "transportation_provider_payment",
      AUTH: "auth",
      TRACKING: "tracking",
      CHAT: "chat",
      DASHBOARD: "dashboard",
      EXTENSIONS: "extensions",
      SETTINGS: "settings",
      PROFILE: "uprofile"
    });
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .service("moduleHelpersService", moduleHelpersService);

  function moduleHelpersService($translate, sessionService, __env, PERMISSION_KEYS, apolloAuthService, STATES) {

    return {
      getModule: getModule,
      getCurrentLanguage: getCurrentLanguage,
      resolveHref: resolveHref,
      isModuleAvailable: isModuleAvailable,
      isSettingsModuleAvailable: isSettingsModuleAvailable,
      getSettingsInitURLWithPermissions: getSettingsInitURLWithPermissions
    };

    function getModule(params) {
      var args = {
        icon: _getBasePathOfImage(params.icon),
        title: params.title,
        href: params.href,
        disabled: params.disabled
      };

      return _getModuleInterface(args);
    }

    function getCurrentLanguage() {
      var language = $translate.use();
      return ["es", "en", "pt"].includes(language) ? language : "en";
    }

    function resolveHref(defaultHref, user) {
      if (sessionService.isEmbedded() && user) {
        return __env.URL_ROOT + "#/login/sso?token=" + user.api_token;
      }

      return defaultHref;
    }

    function isModuleAvailable(permissions, moduleName) {
      return permissions.some(function (permission) {
        return permission.key === moduleName + ".edit";
      });
    }

    function isSettingsModuleAvailable(permissions) {
      var permissionKeyValues = Object.values(PERMISSION_KEYS.SETTINGS);
      return permissions.some(function (permission) {
        return permissionKeyValues.some(function (key) {
          return permission.key.indexOf(key) === 0;
        });
      });
    }

    function getSettingsInitURLWithPermissions(permissions, currentLanguage) {
      if (isModuleAvailable(permissions, PERMISSION_KEYS.SETTINGS.USERS)) {
        return apolloAuthService.buildRedirectURL(currentLanguage + "/settings/users");
      }

      if (isModuleAvailable(permissions, PERMISSION_KEYS.SETTINGS.VEHICLES)) {
        return apolloAuthService.buildRedirectURL(currentLanguage + "/settings/vehicles");
      }

      if (isModuleAvailable(permissions, PERMISSION_KEYS.SETTINGS.VEHICLES_FLEETS)) {
        return apolloAuthService.buildRedirectURL(currentLanguage + "/settings/fleets");
      }

      if (isModuleAvailable(permissions, PERMISSION_KEYS.SETTINGS.MOBILE)) {
        return apolloAuthService.buildRedirectURL(currentLanguage + "/settings/mobile/config");
      }

      if (isModuleAvailable(permissions, PERMISSION_KEYS.SETTINGS.SECURITY)) {
        return apolloAuthService.buildRedirectURL(currentLanguage + "/settings/security");
      }

      if (isModuleAvailable(permissions, PERMISSION_KEYS.SETTINGS.COMMUNICATIONS_LIVE_TRACKING)) {
        return apolloAuthService.buildRedirectURL(currentLanguage + "/settings/communication");
      }

      if (isModuleAvailable(permissions, PERMISSION_KEYS.SETTINGS.COMMUNICATIONS_WSP_PRO)) {
        return apolloAuthService.buildRedirectURL(currentLanguage + "/settings/communication/whatsApp-pro");
      }

      if (isModuleAvailable(permissions, PERMISSION_KEYS.SETTINGS.ZONES)) {
        return apolloAuthService.buildRedirectURL(currentLanguage + "/settings/zones");
      }

      if (isModuleAvailable(permissions, PERMISSION_KEYS.SETTINGS.OPTIMIZERS)) {
        return apolloAuthService.buildRedirectURL(currentLanguage + "/settings/optimizers");
      }

      if (isModuleAvailable(permissions, PERMISSION_KEYS.SETTINGS.CUSTOMIZATION)) {
        return STATES.ACCOUNT_LIST;
      }
    }

    function _getBasePathOfImage(imageName) {
      return "/assets/images/modules/" + imageName + ".svg";
    }

    function _getModuleInterface(params) {
      return {
        icon: params.icon,
        title: params.title,
        href: params.href || null,
        active: params.active || false,
        disabled: params.disabled || false
      };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('arrayHelperService', arrayHelperService);

  /** @ngInject */
  function arrayHelperService() {
    return {
      chunkArray: chunkArray,
      indexByProperty: indexByProperty,
      arrayDifference: arrayDifference
    };


    /**
     * Splits an input array into smaller arrays (chunks) of a specified size.
     * @param {Array} array - The input array to be chunked.
     * @param {number} chunk_size - The size of each chunk.
     * @returns {Array} An array of smaller arrays (chunks), each containing elements from the input array.
     */
    function chunkArray(array, chunk_size) {
      var results = [];

      while (array.length) {
        results.push(array.splice(0, chunk_size));
      }

      return results;
    }

    /**
     * Creates an object with keys based on the specified property of the objects in the input array.
     * @param {Array} array - The input array containing objects.
     * @param {string} key - The property to use as the key in the resulting object.
     * @returns {Object} An object indexed by the specified property of the input objects.
     */
    function indexByProperty(array, key) {
      var obj = {};
      for (var i = 0; i < array.length; ++i) {
        obj[array[i][key]] = array[i];
      }
      return obj;
    }

    /**
     * Returns the difference between two arrays.
     * @param {Array} arr1 - The first array.
     * @param {Array} arr2 - The second array.
     * @returns {Array} The difference between the two arrays.
     */
    function arrayDifference(arr1, arr2) {
      return arr1.filter(function (item) {
        return arr2.indexOf(item) === -1;
      });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.shared', []);

})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('HereDrawingManagerModel', HereDrawingManagerModel);

  /** @ngInject */
  function HereDrawingManagerModel(MAP_EVENTS, CIRCLE_MARKER_URL, utilsService, CURSOR, MAP_CONTROL) {
    var HAND_MODE = 'hand';
    var POLYGON_MODE = 'polygon';
    var DRAWING_MODES = {
      polygon: {
        typeCursor: CURSOR.CROSSHAIR,
        makeButton: _makePolygonButton,
        draw: _drawPolygon,
      }
    };

    function _removeSelectedClassForControlChildren(children) {
      children.forEach(function (button) {
        button.removeClass('selected');
      });
    }

    function _removePointermoveHandler(manager) {
      if (!manager.pointermoveHandler) {
        return;
      }

      manager.map.removeEventListener(MAP_EVENTS.POINTERMOVE, manager.pointermoveHandler);
      manager.pointermoveHandler = null;
    }

    function _removeDrawingLayer(manager) {
      if (!manager.drawingLayer) {
        return;
      }

      manager.map.removeObject(manager.drawingLayer.mainGroup);
      manager.drawingLayer = null;
    }

    function _handlerPolygonButtonSelected(manager) {
      return function (e) {
        var button = e.currentTarget;
        if (button.getState() === H.ui.base.Button.State.DOWN) {
          return;
        }

        if (manager.drawingMode === POLYGON_MODE) {
          _removePointermoveHandler(manager);
          _removeDrawingLayer(manager);
          return;
        }

        _removePointermoveHandler(manager);
        _removeDrawingLayer(manager);
        _removeSelectedClassForControlChildren(manager.control.getChildren());
        manager.drawingMode = POLYGON_MODE;
        button.addClass('selected');
        manager.mapElement.style.cursor = DRAWING_MODES[POLYGON_MODE].typeCursor;
      };
    }

    function _makePolygonButton(manager) {
      var polygonButton = new H.ui.base.Button({
        label: '<div class="H_btn_container"><img class="H_btn_polygon" src="/assets/images/drawing_modes.png" /></div>',
        onStateChange: _handlerPolygonButtonSelected(manager)
      });

      polygonButton.setData({ mode: POLYGON_MODE });
      polygonButton.addClass('H_btn_drawing');
      return polygonButton;
    }

    function _isMarkerClicked(eventTarget, drawingLayer) {
      return eventTarget instanceof H.map.Marker && drawingLayer && drawingLayer.vertexGroup.getObjects().includes(eventTarget);
    }

    function _drawPolygon(e, manager) {
      _removePointermoveHandler(manager);
      if (_isMarkerClicked(e.target, manager.drawingLayer)) {
        var pathCoords = manager.drawingLayer.vertexGroup.getObjects().map(function (vertex) {
          var position = vertex.getGeometry();
          return {
            latitude: position.lat,
            longitude: position.lng
          };
        });

        var options = Object.assign({}, manager.polygonOptions, { pathCoords: pathCoords });
        var polygon = manager.makePolygon(manager.map, options);
        if (manager.polygoncompleteHandler) {
          manager.polygoncompleteHandler(polygon);
        }

        _removeDrawingLayer(manager);
        manager.mapElement.style.cursor = CURSOR.GRAB;
        return;
      }

      if (!manager.drawingLayer) {
        var vertexGroup = new H.map.Group();
        vertexGroup.addEventListener(MAP_EVENTS.POINTERENTER, function () {
          manager.mapElement.style.cursor = CURSOR.POINTER;
        }, true);

        vertexGroup.addEventListener(MAP_EVENTS.POINTERLEAVE, function () {
          manager.mapElement.style.cursor = DRAWING_MODES[POLYGON_MODE].typeCursor;
        }, true);

        var mainGroup = new H.map.Group({ objects: [vertexGroup] });
        manager.drawingLayer = {
          mainGroup: mainGroup,
          vertexGroup: vertexGroup
        };

        manager.map.addObject(mainGroup);
      }

      var currentGeoPoint = manager.map.screenToGeo(e.currentPointer.viewportX, e.currentPointer.viewportY);
      var currentVertex = new H.map.Marker(
        { lat: currentGeoPoint.lat, lng: currentGeoPoint.lng },
        { icon: new H.map.Icon(CIRCLE_MARKER_URL, { anchor: { x: 8, y: 8 } }) }
      );

      manager.drawingLayer.vertexGroup.addObject(currentVertex);
      var initLineString = new H.geo.LineString();
      initLineString.pushPoint(currentGeoPoint);
      initLineString.pushPoint(currentGeoPoint);
      var polygonOptions = manager.polygonOptions;
      var polylineOptions = {
        style: {
          strokeColor: utilsService.convertHexToRGBA(polygonOptions.fillColor, polygonOptions.fillOpacity),
          lineWidth: polygonOptions.strokeWeight
        }
      };

      var polyline = new H.map.Polyline(initLineString, polylineOptions);
      manager.drawingLayer.mainGroup.addObject(polyline);
      manager.pointermoveHandler = function (e) {
        var lineString = new H.geo.LineString();
        lineString.pushPoint(currentGeoPoint);
        lineString.pushPoint(manager.map.screenToGeo(e.currentPointer.viewportX, e.currentPointer.viewportY));
        polyline.setGeometry(lineString);
      };

      manager.map.addEventListener(MAP_EVENTS.POINTERMOVE, manager.pointermoveHandler);
    }

    function _handlerHandButtonSelected(manager) {
      return function (e) {
        var button = e.currentTarget;
        if (button.getState() === 'down' || !manager.drawingMode) {
          return;
        }

        _removePointermoveHandler(manager);
        _removeDrawingLayer(manager);
        _removeSelectedClassForControlChildren(manager.control.getChildren());
        manager.drawingMode = null;
        button.addClass('selected');
        manager.mapElement.style.cursor = CURSOR.GRAB;
      };
    }

    function _createDrawingControl(manager) {
      var control = new H.ui.Control();
      control.addClass('H_drawing');
      control.setAlignment(manager.drawingControlOptions.position);

      var handButton = new H.ui.base.Button({
        label: '<div class="H_btn_container"><img class="H_btn_hand" src="/assets/images/drawing_modes.png" /></div>',
        onStateChange: _handlerHandButtonSelected(manager)
      });

      handButton.setData({ mode: HAND_MODE });
      handButton.addClass('H_btn_drawing');
      handButton.addClass('selected');
      control.addChild(handButton);

      manager.drawingControlOptions.drawingModes.forEach(function (mode) {
        control.addChild(DRAWING_MODES[mode].makeButton(manager));
      });

      manager.map.addEventListener(MAP_EVENTS.TAP, function (e) {
        var drawingMode = manager.drawingMode;
        if (!drawingMode) {
          return;
        }

        DRAWING_MODES[drawingMode].draw(e, manager);
      });

      if (manager.drawingControl) {
        manager.map.$ui.addControl(MAP_CONTROL.DRAWING, control);
      }

      return control;
    }

    function HereDrawingManager(options) {
      this.drawingMode = options.drawingMode;
      this.drawingControl = options.drawingControl;
      this.drawingControlOptions = options.drawingControlOptions;
      this.polygonOptions = options.polygonOptions;
      this.makePolygon = options.makePolygon;
      this.map = options.map;
      this.mapElement = this.map.getElement();
      this.drawingLayer = null;
      this.polygoncompleteHandler = null;
      this.pointermoveHandler = null;
      this.control = _createDrawingControl(this);
    }

    function _updateDrawingControl(manager) {
      if (manager.map.$ui.getControl(MAP_CONTROL.DRAWING)) {
        if (!manager.drawingControl) {
          manager.map.$ui.removeControl(MAP_CONTROL.DRAWING);
        }
      } else if (manager.drawingControl) {
        manager.map.$ui.addControl(MAP_CONTROL.DRAWING, manager.control);
      }

      var controlChildren = manager.control.getChildren();
      _removeSelectedClassForControlChildren(controlChildren);
      var mode = manager.drawingMode || HAND_MODE;
      var buttonFound = controlChildren.find(function (button) {
        var buttonData = button.getData();
        return buttonData && buttonData.mode === mode;
      });

      if (buttonFound) {
        buttonFound.addClass('selected');
      }

      manager.mapElement.style.cursor = DRAWING_MODES[mode] !== undefined ? DRAWING_MODES[mode].typeCursor : CURSOR.GRAB;
    }

    HereDrawingManager.prototype.setOptions = function (options) {
      this.drawingMode = options.drawingMode !== undefined ? options.drawingMode : this.drawingMode;
      this.drawingControl = options.drawingControl !== undefined ? options.drawingControl : this.drawingControl;
      this.drawingControlOptions = options.drawingControlOptions !== undefined ? options.drawingControlOptions : this.drawingControlOptions;
      this.polygonOptions = options.polygonOptions !== undefined ? options.polygonOptions : this.polygonOptions;
      _updateDrawingControl(this);
    };

    HereDrawingManager.prototype.setListenerToCompletedPolygon = function (callback) {
      this.polygoncompleteHandler = callback;
    };

    return HereDrawingManager;
  }
})();
(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .component('staticMap', {
      controller: StaticMapController,
      templateUrl: 'app/shared/map-components/static-map/static-map.html',
      bindings: {
        width: '<',
        height: '<',
        markers: '<',
        zone: '<',
        mapProvider: '<'
      },
    });

  /** @ngInject */
  function StaticMapController(MapModel) {
    var ctrl = this;

    function _getStaticUrl() {
      var options = {
        width: ctrl.width,
        height: ctrl.height,
        markers: ctrl.markers,
        zone: ctrl.zone
      };

      return MapModel.getStaticUrl(ctrl.mapProvider, options);
    }

    ctrl.$onInit = function () {
      ctrl.url = _getStaticUrl();
    };

    ctrl.$onChanges = function () {
      ctrl.url = _getStaticUrl();
    };
  }
})();

(function () {
    'use strict';

    angular
      .module('icarus.shared')
      .component('toggleSwitch', {
        controller: toggleSwitchController,
        templateUrl: 'app/shared/components/toggleSwitch/toggleSwitch.html',
        bindings: {
            inputId: '@',
            inputName: '@',
            labelText: '@',
            isActive: '<',
            isDisabled: '<',
            onChange: '&'
        }
      });

    /** @ngInject */
    function toggleSwitchController() {
        var ctrl = this;

        ctrl.save = function (id, name, isActive) {
          ctrl.onChange({ id: id, name: name, isActive: isActive });
        };
    }
  })();

(function () {
    "use strict";
  
    angular.module("icarus").config(config);
  
    /** @ngInject */
    function config($translateProvider) {
  
      $translateProvider.translations("es", {
        toggleSwitch: {
            enabled: "Activado",
            disabled: "Desactivado"
        }
      });
  
      $translateProvider.translations("en", {
        toggleSwitch: {
            enabled: "Enabled",
            disabled: "Disabled"
        }
      });
  
      $translateProvider.translations("pt", {
        toggleSwitch: {
            enabled: "Ativado",
            disabled: "Desativado"
        }
      });
  
      $translateProvider.determinePreferredLanguage();
    }
  })();
(function () {
  "use strict";

  angular.module("icarus.shared").component("weekdayCheckboxGroup", {
    controller: weekdayCheckboxGroup,
    templateUrl:
      "app/shared/components/weekdayCheckboxGroup/weekdayCheckboxGroup.html",
    bindings: {
      title: "@",
      componentId: "@",
      onChange: "&",
    },
  });

  /** @ngInject */
  function weekdayCheckboxGroup($filter, WEEKDAYS) {
    var ctrl = this;
    ctrl.translate = $filter("translate");
    ctrl.isEveryDaySelected = true;
    ctrl.weekdays = WEEKDAYS.reduce(function (acc, day) {
      acc[day] = ctrl.isEveryDaySelected;
      return acc;
    }, {});

    ctrl.onDaySelectionChanged = function (checkboxState) {
      var selectedDayName = checkboxState.name.replace(ctrl.componentId + "-", "");
      if (selectedDayName === "every-day") {
        ctrl.isEveryDaySelected = checkboxState.isChecked;
        WEEKDAYS.forEach(function (day) {
          ctrl.weekdays[day] = checkboxState.isChecked;
        });
      } else {
        ctrl.weekdays[selectedDayName] = checkboxState.isChecked;
        ctrl.isEveryDaySelected = WEEKDAYS.every(function (day) {
          return ctrl.weekdays[day];
        });
      }
      var selectedWeekdays = WEEKDAYS.filter(function (day) {
        return ctrl.weekdays[day];
      });
      ctrl.onChange({ selectedWeekdays: selectedWeekdays });
    };
  }
})();

(function () {
  "use strict";

  angular
  .module("icarus.shared")
    .component("srCheckbox", {
      controller: checkboxCtrl,
      templateUrl: "app/shared/components/checkbox/checkbox.html",
      bindings: {
        inputId: '@',
        inputName: '@',
        labelText: '@',
        isChecked: '<',
        onChange: '&'
      }
    });

  /** @ngInject */
  function checkboxCtrl() {
    var ctrl = this;
    ctrl.onCheckboxStateChanged = function(id, name, isChecked) {
      ctrl.onChange({ checkboxState: { id: id, name: name, isChecked: isChecked }});
    };
  }
})();

(function () {
  "use strict";

  angular
  .module("icarus.shared")
    .component("chipErrorPlan", {
      controller: ChipErrorPlanController,
      templateUrl: "app/shared/components/chipErrorPlan/chipErrorPlan.html",
      bindings: {
        showRecoveryBtn: "<",
        planId: "<"
      }
    });

  /** @ngInject */
  function ChipErrorPlanController(planService, $state) {
    var ctrl = this;

    ctrl.recoverPlan = function (event) {
      event.stopPropagation();
      var draftPlanKey = planService.getDraftPlanKey(ctrl.planId);
      $state.go("planner.redirect-routes", { draftPlanKey: draftPlanKey });
    };
  }
})();

(function () {
    'use strict';

    angular
      .module('icarus.shared')
      .component('autocomplete', {
        controller: autocompleteController,
        templateUrl: 'app/shared/components/autocomplete/autocomplete.html',
        bindings: {
          address: '=',
          inputName: '<',
          inputId: '<',
          updateAddress: '&',
          onFocus: '&',
          isRequired: '<'
        }
      });

    /** @ngInject */
    function autocompleteController(googleService, hereService, accountConfigsService, MapModel,
                                    $log, sessionService, plannerService, ACCOUNT_CONFIGS,
                                    DEFAULT_AUTOCOMPLETE_PROVIDER) {
        var ctrl = this;
        var countryCodes;
        ctrl.getPlaces = getPlaces;
        ctrl.selectPlace = selectPlace;
        ctrl.getTypeaheadExpression = getTypeaheadExpression;
        ctrl.autocompleteProvider = DEFAULT_AUTOCOMPLETE_PROVIDER;

        var AUTOCOMPLETE_PROVIDERS = {
          google: {
            service: googleService,
            getTypeaheadExpression: function (place) {
              if (!place)return;
              return  place.description || ctrl.address;
            }
          },
          here: {
            service: hereService,
            getTypeaheadExpression: function (place) {
              if (!place)return;
              return place.address ? place.address.label: ctrl.address;
            }
          }
        };

        function getPlaces(value) {
          return AUTOCOMPLETE_PROVIDERS[ctrl.autocompleteProvider].service.getAutocompleteSuggestions(value, countryCodes);
        }

        function selectPlace(item) {
          if (!ctrl.address) {
            return;
          }
          AUTOCOMPLETE_PROVIDERS[ctrl.autocompleteProvider].service.geocodeLocation(item, ctrl.address)
            .then(function (location) {
              ctrl.updateAddress({location: location, address: ctrl.address});
            })
            .catch(function (err) {
              $log.error(err);
            });
        }

        function getTypeaheadExpression(place) {
          return AUTOCOMPLETE_PROVIDERS[ctrl.autocompleteProvider].getTypeaheadExpression(place);
        }

        ctrl.$onInit = function () {
          var autocompleteProviderConfig = accountConfigsService.getConfigRawValue(ACCOUNT_CONFIGS.AUTOCOMPLETE_PROVIDER);
          ctrl.autocompleteProvider =  MapModel.getCurrentProviderName(autocompleteProviderConfig, DEFAULT_AUTOCOMPLETE_PROVIDER);
          if (angular.isUndefined(ctrl.isRequired) ) {
            ctrl.isRequired = true;
          };

          sessionService.getUser()
            .then(function (user) {
              countryCodes = {alpha2: user.country, alpha3: user.countryCodeIsoAlpha3};
            });
        };
    }
  })();

(function () {
    "use strict";
  
    angular.module("icarus.shared").config(config);
  
    /** @ngInject */
    function config($translateProvider) {
  
      $translateProvider.translations("es", {
        Autocomplete: {
            placeholder: "Calle, Número, Departamento, Ciudad, País."
        }
      });
  
      $translateProvider.translations("en", {
        Autocomplete: {
            placeholder: "Street, Number, Apartment, City, Country."
        }
      });
  
      $translateProvider.translations("pt", {
        Autocomplete: {
            placeholder: "Rua, Número, Apartamento, Cidade, País."
        }
      });
  
      $translateProvider.determinePreferredLanguage();
    }
  })();
(function () {
    'use strict';
  
    angular
      .module('icarus')
      .constant('DEFAULT_AUTOCOMPLETE_PROVIDER', 'google');
  })();
/* global angular */
/**
 * Usage:
 * <iframe-directive site-url="siteUrl" />
 */
(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .directive('iframeDirective', iframeDirective);

  /** @ngInject */
  function iframeDirective () {
    return {
      restrict: 'E',
      templateUrl: 'app/shared/directives/iframe/iframe-template.html',
      scope: {
        siteUrl: '@siteUrl',
        loading: '&loading'
      },
      controller: function($scope, $sce) {
        $scope.embedUrl = $sce.trustAsResourceUrl($scope.siteUrl);
      }
    };
  }

  })();

(function () {
  'use strict';

  angular
    .module('icarus')
    .constant('MODAL_REOPTIMIZER_OPTION', 'reoptimize')
    .constant('MODAL_CANCEL_OPTION', '$closeButton')
    .constant('MODAL_CONTINUE_OPTION', 'continue')
    .constant('ROUTES_MODALS_FOLDER_PATH', 'app/planner/routes/routes-modals/');
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('visitsRelationshipService', visitsRelationshipService);

  /** @ngInject */
  function visitsRelationshipService(DEPOT_KEY, RELATIONSHIP_TYPE) {
    var service = {
      buildVisitsPickupAndDeliveryObject: buildVisitsPickupAndDeliveryObject,
      removeVisitPickupAndDeliveryRelationship: removeVisitPickupAndDeliveryRelationship
    };
    /**
     * It takes an array of visits and returns an object where the keys are the visit IDs and the values
     * are the visits
     * @param visits - An array of objects, each represents a visit.
     * @returns An object with the visit id as the key and the visit as the value.
     */
    function _visitsToObject(visits) {
      return Object.fromEntries(visits.map(function (visit) {
        return [visit.id, visit];
      }));
    }

    /**
     * It takes an array of visit IDs and an object of visits, and returns an array of visits
     * @param visitsId - an array of visit ids
     * @param visitsObject - This is the object that contains all the visits.
     * @returns An array of objects.
     */
    function _findVisitsIdObject(visitsId, visitsObject) {
      var visits = [];
      visitsId.forEach(function (visitId) {
        var visit = visitsObject[visitId];
        if (visit) {
          visits.push(visit);
        }
      });

      return visits;
    }

    /**
     * It removes the given visit ids from the given memorized visit ids
     * @param visitIds - an array of visitIds to remove from the memorize
     * @param visitsIdsMemorize - This is the object that stores the visitIds that have been processed.
     */
    function _removeVisitIdsFromMemorize(visitIds, visitsIdsMemorize) {
      visitIds.forEach(function (visitId) {
        delete visitsIdsMemorize[visitId];
      });
    }

    /**
     * Build an object that maps delivery and pickup visits.
     * @param {Array} visitsRelationship - objects that contain the relationship types of visits.
     * @param {Array} visits - visits saved in plannerService and having backendId.
     * @returns {Object} - the expected object will have the delivery visit ids and
     * the DEPOT keyword as keys. Each delivery visit will save its pickup visit,
     * while the DEPOT key will save pickup visits that are not associated with a delivery.
     */
    function buildVisitsPickupAndDeliveryObject(visitsRelationship, visits) {
      var visitsPickupAndDeliveryObject = {};
      var visitsObject = _visitsToObject(visits);

      var visitsIdsMemorize = {};
      visits.forEach(function (visit) {
        if (visit.backendId) {
          visitsIdsMemorize[visit.id] = true;
        }
      });

      visitsRelationship.forEach(function (visit) {
        if (visit.properties.delivery_type !== RELATIONSHIP_TYPE.DELIVERY) {
          return;
        }

        var picksFrom = visit.relationships.picks_from;
        visitsPickupAndDeliveryObject[visit.id] = {
          picks_from: _findVisitsIdObject(picksFrom, visitsObject)
        };

        var visitIdsToRemove = picksFrom.concat(visit.id);
        _removeVisitIdsFromMemorize(visitIdsToRemove, visitsIdsMemorize);
      });

      visitsPickupAndDeliveryObject[DEPOT_KEY] = {
        picks_from: Object.keys(visitsIdsMemorize).map(function (visitId) {
          return visitsObject[visitId];
        })
      };

      return visitsPickupAndDeliveryObject;
    }

    function removeVisitPickupAndDeliveryRelationship(visitsRelationship, visit) {
      if (visitsRelationship[visit.id]) {
        delete visitsRelationship[visit.id];
      } else {
        var keyFound = Object.keys(visitsRelationship).find(function (key) {
          return visitsRelationship[key].picks_from.find(function (pick){
            return pick.id === visit.id;
          });
        });

        if (keyFound !== DEPOT_KEY) {
          delete visitsRelationship[keyFound];
        } else {
          var visitIndex = visitsRelationship[DEPOT_KEY].picks_from.indexOf(visit);
          visitsRelationship[DEPOT_KEY].picks_from.splice(visitIndex, 1);
          if (!visitsRelationship[DEPOT_KEY].picks_from.length) {
            delete visitsRelationship[DEPOT_KEY];
          }
        }
      }

      return visitsRelationship;
    }

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .service('visitsMarkersService', visitsMarkersService);

  /** @ngInject */
  function visitsMarkersService($rootScope, EVENT_CREATE_VISITS_FROM_ARRAY, EVENT_REMOVE_VISITS_FROM_ARRAY, $state,
                                EVENT_CREATE_MARKERS_LIGHT_FROM_ARRAY, SWITCH_MARKERS_ON, VISITS_OUT_OF_ROUTE_LIST_ID,
                                VISIT_OUT_OF_ROUTE_VISUAL_STATE_ID, STATE, accountConfigsService, ACCOUNT_CONFIGS,
                                IMAGES_BORDERLESS_MARKER_PATH, IMAGES_MARKER_PATH, IMAGES_BORDERLESS_BIG_MARKER_PATH,
                                IMAGES_BIG_MARKER_PATH) {

    var areMarkersVisibleInStepThree = { status: SWITCH_MARKERS_ON };

    var service = {
      showVisitsOnMap: showVisitsOnMap,
      showVisitOnMap: showVisitOnMap,
      setVisibleInVisits: setVisibleInVisits,
      createVisitsOnMap: createVisitsOnMap,
      removeVisitsOnMap: removeVisitsOnMap,
      updateVisitsOnMap: updateVisitsOnMap,
      shouldVisitsInRouteBeVisible: shouldVisitsInRouteBeVisible,
      shouldUpdateMarkersWhenCollapsingRoute: shouldUpdateMarkersWhenCollapsingRoute,
      getAreMarkersVisibleInStepThree: getAreMarkersVisibleInStepThree,
      setAreMarkersVisibleInStepThree: setAreMarkersVisibleInStepThree,
      getCurrentVisitsOnMap: getCurrentVisitsOnMap,
      getImagesMarkerPath: getImagesMarkerPath,
      setOpacityInVisits: setOpacityInVisits
    };

    function showVisitsOnMap(visits, areVisible, mustRenderSmallMarkers) {
      if (!visits.length) {
        return;
      }

      var mustUpdateMarkers = false;
      service.setVisibleInVisits(visits, areVisible, mustUpdateMarkers);

      if (areVisible) {
        service.createVisitsOnMap(visits, mustRenderSmallMarkers);
      } else {
        service.removeVisitsOnMap(visits);
      }
    }

    function showVisitOnMap(visit, isVisible) {
      var mustUpdateMarker = false;
      visit.setVisible(isVisible, mustUpdateMarker);

      if (isVisible) {
        visit.actionCreate(visit);
      } else {
        visit.actionRemove(visit);
      }
    }

    function setVisibleInVisits(visits, areVisible, mustUpdateMarkers) {
      visits.forEach(function (visit) {
        visit.setVisible(areVisible, mustUpdateMarkers);
      });
    }

    function createVisitsOnMap(visits, mustRenderSmallMarkers) {
      if (!visits.length) {
        return;
      }

      var eventUpdateMarkers = mustRenderSmallMarkers ? EVENT_CREATE_MARKERS_LIGHT_FROM_ARRAY :
        EVENT_CREATE_VISITS_FROM_ARRAY;
      $rootScope.$broadcast(eventUpdateMarkers, { visits: visits });
    }

    function removeVisitsOnMap(visits) {
      if (!visits.length) {
        return;
      }

      $rootScope.$broadcast(EVENT_REMOVE_VISITS_FROM_ARRAY, {visits: visits});
    }

    function updateVisitsOnMap(visits, visible) {
      if (!visits.length) {
        return;
      }

      var mustUpdateVisitsVisible = visits[0].options.visible !== visible;
      if (mustUpdateVisitsVisible) {
        service.setVisibleInVisits(visits, visible, false);
      }

      if (visible) {
        service.createVisitsOnMap(visits);
        return;
      }
      service.removeVisitsOnMap(visits);
    }

    function shouldVisitsInRouteBeVisible(route, routesVisualStatePerVehicle) {
      return route.areVisitsMarkersVisible && areMarkersVisibleInStepThree.status &&
        routesVisualStatePerVehicle[parseInt(route.vehicleId)] &&
        (!$rootScope.drawCluster || ($rootScope.drawCluster && !route.collapse));
    }

    function shouldUpdateMarkersWhenCollapsingRoute(route, routesVisualStatePerVehicle) {
      if (route.id === VISITS_OUT_OF_ROUTE_LIST_ID) {
        return routesVisualStatePerVehicle[VISIT_OUT_OF_ROUTE_VISUAL_STATE_ID] && $rootScope.isHighDemandRouteDesigner
          && !$rootScope.drawCluster;
      }
      return route.areVisitsMarkersVisible && areMarkersVisibleInStepThree.status &&
        routesVisualStatePerVehicle[parseInt(route.vehicleId)] &&
        ($rootScope.isHighDemandRouteDesigner || $rootScope.drawCluster);
    }

    function getAreMarkersVisibleInStepThree() {
      return areMarkersVisibleInStepThree;
    }

    function setAreMarkersVisibleInStepThree(areMarkersVisibleValue) {
      areMarkersVisibleInStepThree.status = areMarkersVisibleValue;
    }

    function getCurrentVisitsOnMap(data) {
      var isStepOneActive = data.isStepOneActive;
      if (isStepOneActive) {
        return [];
      }

      var isStepThreeActive = data.isStepThreeActive;
      var visits = data.visits;
      if (!isStepThreeActive) {
        return visits;
      }

      var routesVisualStatePerVehicle = data.routesVisualStatePerVehicle;
      var visitsOffRouteCollapsed = data.visitsOffRouteCollapsed;
      var visitsOutOfRoute = data.visitsOutOfRoute;
      var uncollapsedRoute = data.uncollapsedRoute;

      var mustShowVisitsOutOfRoute = routesVisualStatePerVehicle[VISIT_OUT_OF_ROUTE_VISUAL_STATE_ID];
      if ($state.includes(STATE.ROUTES)) {
        if (visitsOffRouteCollapsed && uncollapsedRoute) {
          return service.shouldVisitsInRouteBeVisible(uncollapsedRoute, routesVisualStatePerVehicle) ?
            uncollapsedRoute.visits : [];
        }
        if (!visitsOffRouteCollapsed) {
          return mustShowVisitsOutOfRoute ? visitsOutOfRoute : [];
        }
      }

      var routes = data.routes;
      var currentVisitsOnMap = [];

      routes.forEach(function (route) {
        if (service.shouldVisitsInRouteBeVisible(route, routesVisualStatePerVehicle)) {
          Array.prototype.push.apply(currentVisitsOnMap, route.visits);
        }
      });
      if (mustShowVisitsOutOfRoute) {
        Array.prototype.push.apply(currentVisitsOnMap, visitsOutOfRoute);
      }
      return currentVisitsOnMap;
    }

    function getImagesMarkerPath() {
      var areBorderlessMarkersEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.BORDERLESS_MARKERS);
      if (accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_BIG_MARKER_IN_ROUTE_DESIGNER)) {
        return areBorderlessMarkersEnabled ? IMAGES_BORDERLESS_BIG_MARKER_PATH : IMAGES_BIG_MARKER_PATH;
      }

      return areBorderlessMarkersEnabled ? IMAGES_BORDERLESS_MARKER_PATH : IMAGES_MARKER_PATH;
    }

    function setOpacityInVisits(visits, opacity, mustUpdateMarkers) {
      visits.forEach(function (visit) {
        visit.setOpacity(opacity, mustUpdateMarkers);
      });
    }

    return service;
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .constant("SWITCH_MARKERS_ON", true)
    .constant("VISITS_OUT_OF_ROUTE_LIST_ID", "visitsOffRoute")
    .constant("VISIT_OUT_OF_ROUTE_VISUAL_STATE_ID", "outOfRoutes");
})();

(function () {
    'use strict';

    angular
      .module('icarus.planner')
      .service('visitJoinerService', visitJoinerService);

    /** @ngInject */
    function visitJoinerService(VISIT_JOINER_PARAMETER_DEFAULT, METERS_TO_KILOMETERS_CONVERSION_FACTOR) {

      var service = {
        getVisitJoinerOptimizationParameter: getVisitJoinerOptimizationParameter,
        isDistanceToJoinVisitsEnabled: isDistanceToJoinVisitsEnabled
      };

      function getVisitJoinerOptimizationParameter(distanceToJoinVisits) {
        var visitJoinerParam = Object.assign({}, VISIT_JOINER_PARAMETER_DEFAULT);
        visitJoinerParam.enable_visit_join = service.isDistanceToJoinVisitsEnabled(distanceToJoinVisits);
        visitJoinerParam.maximum_distance = Number(distanceToJoinVisits) / METERS_TO_KILOMETERS_CONVERSION_FACTOR;
        return visitJoinerParam;
      }

      function isDistanceToJoinVisitsEnabled(distanceToJoinVisits) {
        return distanceToJoinVisits !== null;
      }

      return service;
    }
  })();

(function () {
    'use strict';

    angular
      .module('icarus')
      .constant('METERS_TO_KILOMETERS_CONVERSION_FACTOR', 1000)
      .constant('VISIT_JOINER_PARAMETER_DEFAULT', {
        enable_visit_join: false,
        maximum_distance: 0,
        match_skills: true,
        match_zones: true,
        match_time_windows: true
      });
  })();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .service('visitItemsService', visitItemsService);

  /** @ngInject */
  function visitItemsService(REQUEST_STATUS, lodash, comparatorService) {
    var service = {
      getItemsObject: getItemsObject,
      getDeletedItems: getDeletedItems,
      isItemEdited: isItemEdited,
      getItemRequestStatus: getItemRequestStatus,
      getItemDataForRequest: getItemDataForRequest,
      getItemsDataForRequest: getItemsDataForRequest
    };

    function getItemsObject(itemsArray) {
      var itemsObject = {};
      itemsArray.forEach(function(item) {
        itemsObject[item.id] = item;
      });
      return itemsObject;
    }

    function getDeletedItems(originalItems, currentItems) {
      var deletedItems = [];
      originalItems.forEach(function(item) {
        if (!currentItems[item.id]) {
          deletedItems.push({
            id: item.id,
            request_status: REQUEST_STATUS.DELETED
          });
        }
      });
      return deletedItems;
    }

    function isItemEdited(originalItem, currentItem) {
      return (originalItem.title !== currentItem.title) ||
        (originalItem.quantity_planned !== currentItem.quantity_planned);
    }

    function getItemRequestStatus(originalItem, currentItem) {
      if (!originalItem) {
        return REQUEST_STATUS.CREATED;
      }
      if (service.isItemEdited(originalItem, currentItem)) {
        return REQUEST_STATUS.EDITED;
      }
      return REQUEST_STATUS.NOT_EDITED;
    }

    function getItemDataForRequest(originalItem, currentItem) {
      var itemData = lodash.pick(currentItem, ['id', 'title', 'quantity_planned', 'request_status', 'reference']);
      if (currentItem.request_status === REQUEST_STATUS.EDITED) {
        return comparatorService.getObjectDifferences(
          originalItem, itemData, ['id'], comparatorService.validateItemFields);
      }
      if (currentItem.request_status === REQUEST_STATUS.CREATED) {
        itemData.id = null;
      }
      return itemData;
    }

    function getItemsDataForRequest(originalVisit, currentVisit) {
      var originalItems = originalVisit.items || [];
      var currentItems = currentVisit.items || [];
      if (!originalItems.length && !currentItems.length) {
        return [];
      }

      var originalItemsObject = service.getItemsObject(originalItems);
      var currentItemsObject = service.getItemsObject(currentItems);
      var itemsData = service.getDeletedItems(originalItems, currentItemsObject);

      currentItems.forEach(function(item) {
        var originalItem = originalItemsObject[item.id];
        item.request_status = service.getItemRequestStatus(originalItem, item);

        if (item.request_status !== REQUEST_STATUS.NOT_EDITED) {
          itemsData.push(service.getItemDataForRequest(originalItem, item));
        }
      });

      return itemsData;
    }

    return service;
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("saveDraftPlanUtilService", saveDraftPlanUtilService);

  /** @ngInject */
  function saveDraftPlanUtilService(ngDialog) {

    /** @ngInject */
    function DialogController(plan, deletePlan) {
      var vm = this;
      vm.plan = plan;
      vm.deletePlan = deletePlan;
      vm.checkDeletePlan = false;
    }

    function showDeleteModal(event, resolve) {
      event.stopPropagation();

      ngDialog.openConfirm({
        template: "app/planner/plans/draft-plans-delete-modal.html",
        controller: DialogController,
        controllerAs: "vm",
        resolve: resolve,
      });
    }
    return {
      showDeleteModal: showDeleteModal
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("saveDraftPlanService", saveDraftPlanService);

  /** @ngInject */
  function saveDraftPlanService(__env, moment, $q, browserBasedSaveDraftPlanStrategy, accountConfigsService,
                                PLAN_STATUS, DRAFT_FOR_APOLLO, visitListFilterService, PLAN_SAVE_PENDING) {

    var ENABLE_PLAN_AUTOSAVE = "enable_plan_autosave";
    var UNROUTED  = 'unrouted';

    var saveDraftPlanResponse = {};
    var hasDraftPlanCached = false;

    var storageStrategy = browserBasedSaveDraftPlanStrategy;

    var service = {
      isEnabled: isEnabled,

      // Prepare a plan for autosave.
      // Called the first time a plan is opened, saves the initial data that enables autosave.
      // In particular the original state of the plan before any changes.
      setOriginalPlanAndSaveDraftPlanFormat: setOriginalPlanAndSaveDraftPlanFormat,

      // Return the original plan for this draft, that is, the state of the plan before any changes
      // were made.
      getOriginalPlan: getOriginalPlan,

      // Save the current status of the plan .
      saveDraftPlan: saveDraftPlan,
      hasDraftPlan: hasDraftPlan,
      deleteDraftPlan: deleteDraftPlan,

      // Return a list of all new draft plans.
      getNewPlans: getNewPlans,

      // Load the last saved status of the plan draft.
      loadDraftPlan: loadDraftPlan,

      // Returns the different parts of the currently loaded plan draft.
      getPlanDetail: getPlanDetail,
      getRoutesDetail: getRoutesDetail,
      getVisitsDetail: getVisitsDetail,
      getEventsDetail: getEventsDetail,
      getOriginalVisitsDetail: getOriginalVisitsDetail,
      unrouted: UNROUTED, // Constant representing when a visit is out of route.
      getVisitList: getVisitList,
      getVehiclesDetail: getVehiclesDetail,
      isDraftPlanSaved: isDraftPlanSaved,
      getDraftPlanIdsByPrefix: getDraftPlanIdsByPrefix,
      deleteDraftPlansByPlanKeys: deleteDraftPlansByPlanKeys
    };

    return service;

    function getNewPlans() {
      if (!_isSaveDraftPlanEnabled()) {
        return $q.when([]);
      }

      return storageStrategy.getSavedPlans()
        .then(function (response) {
          return response
          .filter(function (planSummary) {
            return planSummary.isNewPlan;
          })
          .map(function (planSummary) {
            return {
              created: null,
              startDate: planSummary.start_date,
              endDate: planSummary.end_date,
              fleet: planSummary.fleet,
              id: planSummary.id,
              name: planSummary.name,
              totalRoutes: planSummary.routes.length
            };
          });
        });
    }

    function isEnabled() {
      return _isSaveDraftPlanEnabled();
    }

    /**
     * Perform autosave of the current plan state. Overwrites previous state.
     * @param {*} planDataSource
     * @returns
     */
    function saveDraftPlan(planDataSource) {
      if(!_isSaveDraftPlanEnabled()) {
        return $q.when(null);
      }

      var draftPlanObject = _generatePlanDraftObject(planDataSource);
      var planId = planDataSource.getPlanId();

      return storageStrategy.saveDraftPlan(planId, draftPlanObject);
    }

    /**
     * Performs first time initialization of autosave data. Idempotent (only needs to happen once).
     * @param {*} planDataSource
     * @param {string} expirationMinutes
     * @returns
     */
    function setOriginalPlanAndSaveDraftPlanFormat(planDataSource, planId, expirationMinutes) {
      if (!_isSaveDraftPlanEnabled(planId)) {
        return $q.when(null);
      }

      var currentPlanId = planId || planDataSource.getPlanId();
      return storageStrategy.isPlanInitializedForSaveDraftPlan(currentPlanId)
        .then(function (isInitialized) {
          if (isInitialized) {
            return null;
          }

          var draftPlanObject = _generatePlanDraftObject(planDataSource);
          var originalPlan = planDataSource.getOriginalPlan();
          return storageStrategy.initializeSaveDraftPlan(currentPlanId, draftPlanObject, originalPlan, expirationMinutes);
        });
    }

    /**
     * Load autosave data, if available, for the given plan ID.
     * Returns a promise for the operation; autosave data is available via the getter methods of the service,
     * not as part of this method's response.
     *
     * Previously loaded autosave data is cleared first.
     *
     * @param {*} planId
     * @returns promise for the loading of the autosave data
     */
    function loadDraftPlan(planId) {
      saveDraftPlanResponse = {};
      hasDraftPlanCached = false;

      if (!_isSaveDraftPlanEnabled(planId)) {
        return $q.when(null);
      }

      return storageStrategy.loadDraftPlan(planId)
        .then(function (response) {
          if (!response) {
            return;
          }

          saveDraftPlanResponse = response;
          hasDraftPlanCached = true;
          saveDraftPlanResponse.visitList = saveDraftPlanResponse.visitsDetails;
          //
          // Adapt format for easier access.
          //

          saveDraftPlanResponse.visitsDetails = _generateVisitsByRoute(saveDraftPlanResponse.visitsDetails);
        });
    }

    function getPlanDetail() {
      return saveDraftPlanResponse.summary;
    }

    function getRoutesDetail() {
      return saveDraftPlanResponse.routesDetails;
    }

    function getEventsDetail() {
      return saveDraftPlanResponse.eventsDetails;
    }

    function getOriginalPlan() {
      return saveDraftPlanResponse.originalPlan;
    }

    function getOriginalVisitsDetail() {
      return saveDraftPlanResponse.originalVisitsDetail;
    }

    function hasDraftPlan() {
      return hasDraftPlanCached;
    }

    function deleteDraftPlan(planId) {
      if (!_isSaveDraftPlanEnabled(planId)) {
        return $q.when(null);
      }

      // Only clear current autosave data if we're deleting the same that we have currently in memory.
      if (saveDraftPlanResponse.summary && (planId === saveDraftPlanResponse.summary.id || planId === DRAFT_FOR_APOLLO)) {
        saveDraftPlanResponse = {};
        hasDraftPlanCached = false;
      }

      return storageStrategy.deleteDraftPlan(planId);
    }

    function getVisitsDetail(routeId) {
      var visitsDetail = saveDraftPlanResponse.visitsDetails[routeId];
      return visitsDetail || [];
    }

    function getVisitList() {
      return saveDraftPlanResponse.visitList;
    }

    function getVehiclesDetail() {
      return saveDraftPlanResponse.vehiclesDetails;
    }

    function formatTime(time) {
      return (time) ? moment(time, ["YYYY-MM-DDTHH:mm", "HH:mm:ss", "HH:mm"]).format("HH:mm:ss") : null;
    }

    function formatVisitDuration(minutes) {
      var duration = moment.duration(minutes*60*1000);
      var formattedDuration = [duration.hours(), duration.minutes(), duration.seconds()].join(":");
      return formatTime(formattedDuration);
    }

    function isDraftPlanSaved(planId) {
      return storageStrategy.isPlanInitializedForSaveDraftPlan(planId);
    }

    function getDraftPlanIdsByPrefix(prefix) {
      return storageStrategy.getByPrefix(prefix)
        .then(function (draftPlans) {
          return draftPlans.map(function (draftPlan) {
            return draftPlan.id;
          });
        });
    }

    function deleteDraftPlansByPlanKeys(planKeysToDelete) {
      if (planKeysToDelete.length === 0) {
        return $q.when([]);
      }

      return storageStrategy.deleteByPlanKeys(planKeysToDelete);
    }

    ///// Private methods /////

    function _isSaveDraftPlanEnabled(planId) {
      if (accountConfigsService.isConfigEnabled(ENABLE_PLAN_AUTOSAVE)) {
        return true;
      }

      if (!planId) {
        return false;
      }

      return planId === DRAFT_FOR_APOLLO  || planId.indexOf(PLAN_SAVE_PENDING) === 0;
    }

    function _generateRoutesDetails(planId, routes) {
      var routesDetails = {
        ids: [],
        routesMap: []
      };

      routes.forEach(function (route) {
        var routeId = route.id;
        var vehicleId = Number(route.vehicleId);
        var routeMap = {
          id: routeId,
          vehicle: vehicleId,
          driver: route.driver ? Number(route.driver) : null,
          plan: planId,
          planned_date: route.plannedDate,
          estimated_time_start: moment(route.estimatedTimeStart).format("HH:mm:ss"),
          estimated_time_end: moment(route.estimatedTimeEnd).format("HH:mm:ss"),
          total_duration: route.totalTime,
          total_distance: Number((route.totalDistance * 1000).toFixed(0)),
          total_load: route.totalLoad,
          total_load_percentage: Number(parseFloat(route.totalLoadPercentage).toFixed(0)),
          total_load_2: route.totalLoad2,
          total_load_2_percentage: Number(parseFloat(route.totalLoadPercentage2).toFixed(0)),
          total_load_3: route.totalLoad3,
          total_load_3_percentage: Number(parseFloat(route.totalLoadPercentage3).toFixed(0)),
          location_start_address: route.locationStart.address,
          location_start_latitude: String(route.locationStart.latitude),
          location_start_longitude: String(route.locationStart.longitude),
          location_end_address: route.locationEnd.address,
          location_end_latitude: String(route.locationEnd.latitude),
          location_end_longitude: String(route.locationEnd.longitude),
          comment: route.comment,
          start_time: route.startTime,
          end_time: route.endTime,
          total_visits: route.visits.length,
          is_revised: route.isRevised,
          visible: route.visible,
          timeError: route.timeError,
          collapse: route.collapse,
          status: route.status
        };

        if (!route.backendId) {
          routeMap.new_route = true;
        }

        routesDetails.ids.push(routeId);
        routesDetails.routesMap.push(routeMap);
      });

      return routesDetails;
    }

    function _generateVisitsByRoute(visits) {
      var visitsByRoute = {};
      visits.forEach(function (visit) {
        var routeId = (visit.route !== null) ? visit.route : UNROUTED;
        if(!visitsByRoute[routeId]) {
          visitsByRoute[routeId] = [];
        }
        visitsByRoute[routeId].push({
          id: visit.id,
          order: visit.order,
          status: visit.status,
          title: visit.title,
          address: visit.address,
          latitude: visit.latitude,
          longitude: visit.longitude,
          load: visit.load,
          load_2: visit.load_2,
          load_3: visit.load_3,
          window_start: visit.window_start,
          window_end: visit.window_end,
          window_start_2: visit.window_start_2,
          window_end_2: visit.window_end_2,
          duration: visit.duration,
          contact_name: visit.contact_name,
          contact_phone: visit.contact_phone,
          contact_email: visit.contact_email,
          reference: visit.reference,
          notes: visit.notes,
          skills_required: visit.skills_required,
          skills_optional: visit.skills_optional,
          planned_date: visit.planned_date,
          programmed_date: visit.programmed_date,
          route: visit.route,
          sourceRouteId: visit.sourceRouteId,
          estimated_time_arrival: visit.estimated_time_arrival,
          estimated_time_departure: visit.estimated_time_departure,
          vehicle: visit.vehicle,
          priority: visit.priority,
          priority_level: visit.priority_level,
          visit_type: visit.visit_type,
          request_status: visit.request_status,
          checkout_time: visit.checkout_time,
          properties: visit.properties,
          relationships: visit.relationships,
          error: visit.error,
          pickLoad: visit.pickLoad,
          pickLoad2: visit.pickLoad2,
          pickLoad3: visit.pickLoad3,
          items: visit.items,
          hashValue: visit.hashValue,
          geocodeAlert: visit.geocodeAlert,
          timeError: visit.timeError,
          addedInCurrentRouting: visit.addedInCurrentRouting,
          addressStatistics: visit.addressStatistics
        });

      });

      return visitsByRoute;
    }

    function _generateVisitsList(visits){
      var visitsList = [];
      visits.forEach(function (visit) {
        var checkoutTime = formatTime(visit.checkoutTime);
        var estimatedTimeArrival = formatTime(visit.estimatedTimeArrival);
        var estimatedTimeDeparture = formatTime(visit.estimatedTimeDeparture);
        var windowStart = formatTime(visit.windowStart);
        var windowStart2 = formatTime(visit.windowStart2);
        var windowEnd = formatTime(visit.windowEnd);
        var windowEnd2 = formatTime(visit.windowEnd2);
        var durationVisit = formatVisitDuration(visit.duration);

        visitsList.push({
          id: visit.id,
          order: visit.order,
          status: visit.status,
          title: visit.title,
          address: visit.address,
          latitude: visit.latitude,
          longitude: visit.longitude,
          load: visit.load,
          load_2: visit.load2,
          load_3: visit.load3,
          load_4: visit.load4,
          window_start: windowStart,
          window_end: windowEnd,
          window_start_2: windowStart2,
          window_end_2: windowEnd2,
          duration: durationVisit,
          contact_name: visit.contactName,
          contact_phone: visit.contactPhone,
          contact_email: visit.contactEmail,
          reference: visit.reference,
          notes: visit.notes,
          skills_required: visit.skills_required,
          skills_optional: visit.skills_optional,
          planned_date: visit.plannedDate,
          programmed_date: visit.programmedDate,
          route: visit.routeId,
          sourceRouteId: visit.sourceRouteId,
          estimated_time_arrival: estimatedTimeArrival,
          estimated_time_departure: estimatedTimeDeparture,
          vehicle: visit.vehicle,
          priority: visit.priority,
          priority_level: visit.priorityLevel,
          visit_type: visit.visitType,
          request_status: visit.request_status,
          checkout_time: checkoutTime,
          properties: visit.properties,
          relationships: visit.relationships,
          error: visit.error,
          pickLoad: visit.pickLoad,
          pickLoad2: visit.pickLoad2,
          pickLoad3: visit.pickLoad3,
          items: visit.items,
          hashValue: visit.hashValue,
          geocodeAlert: visit.geocodeAlert,
          timeError: visit.timeError,
          addedInCurrentRouting: visit.addedInCurrentRouting,
          addressStatistics: visit.addressStatistics
        });
      });

      return visitsList;
    }

    function _generateVehicleList(vehicles){
      var vehiclesList = [];
      vehicles.forEach(function (vehicle) {
        vehiclesList.push({
          id: vehicle.id,
          name: vehicle.name,
          capacity: vehicle.capacity,
          capacity2: vehicle.capacity2,
          capacity3: vehicle.capacity3,
          capacity4: vehicle.capacity4,
          driverId: vehicle.driverId,
          driver: vehicle.driver,
          shift: vehicle.shift,
          locationStart: vehicle.locationStart,
          locationEnd: vehicle.locationEnd,
          skills: vehicle.skills,
          isShiftTemporarilyEdited: vehicle.isShiftTemporarilyEdited,
          modified: vehicle.modified,
          active: vehicle.active,
          showRoutes: vehicle.showRoutes
        });
      });

      return vehiclesList;
    }

    function _generatePlanDraftObject(planDataSource) {
      var originalPlan = planDataSource.getOriginalPlan();
      var originalVisitsDetail = planDataSource.getOriginalVisits();
      var localOptimizationOptions = planDataSource.getLocalOptimizationOptions();
      var shift = planDataSource.getShift();
      var fleetId = planDataSource.getFleetId();
      var planMetadata = planDataSource.getPlanMetadata();
      var planId = planDataSource.getPlanId();
      var routes = planDataSource.getRoutes();
      var routesDetails = _generateRoutesDetails(planId, routes);
      var visits = _generateVisitsList(planDataSource.getVisits());
      var isNewPlan = planDataSource.isNewPlan();
      var planInfo = planDataSource.getPlanInfo();
      var events = planDataSource.getEvents();
      var vehicles = _generateVehicleList(planDataSource.getVehicles());
      var activeVisitFilter = visitListFilterService.getMatchValue();
      var optimizationResults = planDataSource.getOptimizationResults();

      return {
        summary: {
          isNewPlan: isNewPlan,
          id: planId,
          name: originalPlan.name || moment().format('D-MM-YYYY HH:mm:ss'),
          start_date: originalPlan.start_date || planInfo.startDate,
          end_date: originalPlan.end_date || planInfo.endDate,
          reset_day: originalPlan.reset_day,
          is_cluster: localOptimizationOptions.big_cluster,
          routes: routesDetails.ids,
          fleet: fleetId,
          plan_metadata: planMetadata,
          start_time: shift.start,
          end_time: shift.end,
          status: isNewPlan ? PLAN_STATUS.draft : originalPlan.status,
          activeVisitFilter: activeVisitFilter,
          optimizationResults: optimizationResults
        },
        visitsDetails: visits,
        originalVisitsDetail: originalVisitsDetail,
        routesDetails: routesDetails.routesMap,
        eventsDetails: events,
        vehiclesDetails: vehicles
      };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module("icarus.planner")
    .factory("routesOptimizationUtils", routesOptimizationUtils);

  /** @ngInject */
  function routesOptimizationUtils(timeUtils, zoneService, RELATIONSHIP_TYPE, plannerService, moment, PATH_FINDER_ADD_ON_PROPERTIES) {
    var service = {};

    var DAY_START_TIME = "00:00";
    var DAY_END_TIME = "23:59";

    /**
     * Build array of time windows for current visit. Should only run when multi day routes are enabled.
     * If the visit has a valid programmed date, then the array of time windows will only have one value
     * matching the date input.
     *
     * @param {Object} planDate - Array with 2 values. Start & End Days. YYYY-MM-DD format.
     * @param {number} planInHours - (Number of days where plan is active - 1) * 24
     * @param {Object} visit - The current visit we are building
     * @return {string[]} result - Array elements composed by a pair of strings.
     *
     */
    function buildArrayOfTimeWindows(planDate, planInHours, visit) {
      var result = [];
      var hoursToAdd = 0;
      var planDateStart = (planDate && planDate.start) ? planDate.start : 0;
      var planDateEnd = (planDate && planDate.end) ? planDate.end : 0;
      var visitHasValidProgrammedDate = (
        visit.programmedDate
        && timeUtils.diff(planDateEnd, visit.programmedDate, 'days') >= 0
        && timeUtils.diff(visit.programmedDate, planDateStart, 'days') >= 0
      );
      var firstWindowValid = (visit.windowStart || visit.windowEnd) && (visit.windowStart !== visit.windowEnd);
      var secondWindowValid = (visit.windowStart2 || visit.windowEnd2) && (visit.windowStart2 !== visit.windowEnd2);

      var visitHasOutOfRangeProgrammedDate = (
        visit.programmedDate && (
          timeUtils.diff(planDateEnd, visit.programmedDate, 'days') < 0
          || timeUtils.diff(visit.programmedDate, planDateStart, 'days') < 0
        )
      );

      if (visitHasOutOfRangeProgrammedDate) {
        result.push([DAY_START_TIME, DAY_START_TIME]);
        return result;
      }

      if (visitHasValidProgrammedDate) {
        hoursToAdd = timeUtils.diff(visit.programmedDate, planDate.start, 'hours');
        var planStartDate = planDateStart ? moment(planDateStart).format('YYYY-MM-DD') : null;
        var planEndDate = planDateEnd ? moment(planDateEnd).format('YYYY-MM-DD') : null;
        var planStartTime = plannerService.getPlanStartTime();

        if (firstWindowValid) {
          var fixedWindowStart = visit.windowStart || DAY_START_TIME;
          var fixedWindowEnd = visit.windowEnd || DAY_END_TIME;
          if (getSkipTimeValidation()) {
            var adjustedTimes = plannerService.adjustWindowTimesWithPlanDatesAndAcrossMidnight({
              windowStart: fixedWindowStart,
              windowEnd: fixedWindowEnd,
              planStartDate: planStartDate,
              planEndDate: planEndDate,
              planStartTime: planStartTime
            });
            if (adjustedTimes.windows) {
              adjustedTimes.windows.forEach(function(window) {
                result.push(window);
              });
            } else {
              result.push([adjustedTimes.windowStart, adjustedTimes.windowEnd]);
            }
          } else {
            result.push([timeUtils.addHours(fixedWindowStart, hoursToAdd), timeUtils.addHours(fixedWindowEnd, hoursToAdd)]);
          }
        }
        if (secondWindowValid) {
          var fixedWindowStart2 = visit.windowStart2 || DAY_START_TIME;
          var fixedWindowEnd2 = visit.windowEnd2 || DAY_END_TIME;
          if (getSkipTimeValidation()) {
            var adjustedTimes2 = plannerService.adjustWindowTimesWithPlanDatesAndAcrossMidnight({
              windowStart: fixedWindowStart2,
              windowEnd: fixedWindowEnd2,
              planStartDate: planStartDate,
              planEndDate: planEndDate,
              planStartTime: planStartTime
            });
            if (adjustedTimes2.windows) {
              adjustedTimes2.windows.forEach(function(window) {
                result.push(window);
              });
            } else {
              result.push([adjustedTimes2.windowStart, adjustedTimes2.windowEnd]);
            }
          } else {
            result.push([timeUtils.addHours(fixedWindowStart2, hoursToAdd), timeUtils.addHours(fixedWindowEnd2, hoursToAdd)]);
          }
        }
      } else {
        arrayOfTimeWindowsWithoutProgrammedDate(planInHours, firstWindowValid, secondWindowValid, visit, result, planDate);
      }

      return result;
    }

    /**
     * Gets skip time validation value from pathfinder properties
     * @returns {boolean} true if skip time validation is enabled
     */
    function getSkipTimeValidation() {
      var pathFinderProperties = plannerService.getPathFinderProperties();
      var skipTimeValidationValue = pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.SKIP_TIME_VALIDATION];
      return skipTimeValidationValue && skipTimeValidationValue.toLowerCase() === 'true';
    }

    function arrayOfTimeWindowsWithoutProgrammedDate(planInHours, firstWindowValid, secondWindowValid, visit, result, planDate) {
      var planDateStart = (planDate && planDate.start) ? planDate.start : 0;
      var planDateEnd = (planDate && planDate.end) ? planDate.end : 0;
      var planStartDate = planDateStart ? moment(planDateStart).format('YYYY-MM-DD') : null;
      var planEndDate = planDateEnd ? moment(planDateEnd).format('YYYY-MM-DD') : null;
      var planStartTime = plannerService.getPlanStartTime();

      if (getSkipTimeValidation()) {
        if (firstWindowValid) {
          var fixedWindowStart = visit.windowStart || DAY_START_TIME;
          var fixedWindowEnd = visit.windowEnd || DAY_END_TIME;
          var adjustedTimes = plannerService.adjustWindowTimesWithPlanDatesAndAcrossMidnight({
            windowStart: fixedWindowStart,
            windowEnd: fixedWindowEnd,
            planStartDate: planStartDate,
            planEndDate: planEndDate,
            planStartTime: planStartTime
          });
          if (adjustedTimes.windows) {
            adjustedTimes.windows.forEach(function(window) {
              result.push(window);
            });
          } else {
            result.push([adjustedTimes.windowStart, adjustedTimes.windowEnd]);
          }
        }
        if (secondWindowValid) {
          var fixedWindowStart2 = visit.windowStart2 || DAY_START_TIME;
          var fixedWindowEnd2 = visit.windowEnd2 || DAY_END_TIME;
          var adjustedTimes2 = plannerService.adjustWindowTimesWithPlanDatesAndAcrossMidnight({
            windowStart: fixedWindowStart2,
            windowEnd: fixedWindowEnd2,
            planStartDate: planStartDate,
            planEndDate: planEndDate,
            planStartTime: planStartTime
          });
          if (adjustedTimes2.windows) {
            adjustedTimes2.windows.forEach(function(window) {
              result.push(window);
            });
          } else {
            result.push([adjustedTimes2.windowStart, adjustedTimes2.windowEnd]);
          }
        }
      } else {
        for (var i = 0; i <= planInHours / 24; i++) {
          if (firstWindowValid) {
            var fixedWindowStart = visit.windowStart || DAY_START_TIME;
            var fixedWindowEnd = visit.windowEnd || DAY_END_TIME;
            result.push([timeUtils.addHours(fixedWindowStart, i * 24), timeUtils.addHours(fixedWindowEnd, i * 24)]);
          }
          if (secondWindowValid) {
            var fixedWindowStart2 = visit.windowStart2 || DAY_START_TIME;
            var fixedWindowEnd2 = visit.windowEnd2 || DAY_END_TIME;
            result.push([timeUtils.addHours(fixedWindowStart2, i * 24), timeUtils.addHours(fixedWindowEnd2, i * 24)]);
          }
        }
      }
      return result;
    }

    function getNewestTimeWindow(windowStartFromVisit, windowStartFromNode) {
      if (windowStartFromVisit && !windowStartFromNode) {
        return windowStartFromVisit;
      } else if (windowStartFromVisit && windowStartFromNode) {
        if (windowStartFromVisit > windowStartFromNode) {
          return windowStartFromVisit;
        }
      }
      return windowStartFromNode;
    }

    function sumLoads(visitLoad, nodeLoad) {
      if (visitLoad) {
        nodeLoad += angular.isString(visitLoad) ? 0 : visitLoad;
      }
      return nodeLoad;
    }

    service.getDefaultDataFromVehicle = function(vehicle) {
      return {
        ident: vehicle.id,
        location_start: {
          ident: "vehicle-start-" + vehicle.id,
          lat: vehicle.locationStart.latitude,
          lon: vehicle.locationStart.longitude
        },
        location_end: {
          ident: "vehicle-end-" + vehicle.id,
          lat: vehicle.locationEnd.latitude,
          lon: vehicle.locationEnd.longitude
        },
        skills: vehicle.skills.map(Number),
        refill: parseInt(vehicle.refill),
        max_number_of_routes: vehicle.max_number_of_routes
      };
    };

    service.getCapacityFromVehicle = function (vehicle) {
      return {
        capacity: vehicle.capacity,
        capacity_2: (!vehicle.capacity2 || vehicle.capacity2 === 0) ? 0 : vehicle.capacity2,
        capacity_3: (!vehicle.capacity3 || vehicle.capacity3 === 0) ? 0 : vehicle.capacity3,
        capacity_4: (!vehicle.capacity4 || vehicle.capacity4 === 0) ? 0 : vehicle.capacity4
      };
    };

    service.getShiftFromVehicle = function (vehicle, longRoutes, planInHours) {
      return {
        shift_start: vehicle.shift.start,
        shift_end: longRoutes
          ? timeUtils.addHours(vehicle.shift.end, planInHours || 0)
          : vehicle.shift.end
      };
    };

    service.getLoadsFromVehicle = function (vehicle) {
      return {
        cost: vehicle.cost,
        min_load: vehicle.minLoad,
        min_load_2: vehicle.minLoad2,
        min_load_3: vehicle.minLoad3,
        max_visit: vehicle.maxVisit
      };
    };

    service.getRestTimeFormVehicle = function (vehicle) {
      return {
        rest_time_start: vehicle.restTimeStart,
        rest_time_end: vehicle.restTimeEnd,
        rest_time_duration: vehicle.restTimeDuration
      };
    };

    service.getMaxRouteDistanceFromVehicle = function (vehicle) {
      var maxRouteDistance = vehicle.max_route_distance;

      // If is null, undefined, 0 or less/equal to 0, send 0 (does not apply restriction)
      if (maxRouteDistance == null || isNaN(maxRouteDistance) || Number(maxRouteDistance) <= 0) {
        return {
          max_route_distance: 0
        };
      }

      return {
        max_route_distance: parseFloat(Number(maxRouteDistance).toFixed(2))
      };
    };

    service.getPartialToursFromVehicle = function (vehicle, isPartialTour, isJoinVisitEnabled, visitSimilarGraph) {
      if (!isPartialTour) {
        return {};
      }

      return {
        partial_tour: {
          ident: vehicle.id,
          partial_routes: vehicle.routes.reduce(function(partialRoutes, route) {
            if (!route.isRevised) {
              partialRoutes.push(service.getPartialRoute(route, isJoinVisitEnabled, visitSimilarGraph));
            }
            return partialRoutes;
          }, [])
        }
      };
    };

    service.getPartialRoute = function(route, isJoinVisitEnabled, visitSimilarGraph) {
      var partialRoute = {
        // PLAN-529: must keep fixed_nodes_number in value 0 as first step.
        fixed_nodes_number: 0
      };

      if (isJoinVisitEnabled) {
        partialRoute.nodes = service.getPartialNodesFromVehicle(route.visits, visitSimilarGraph);
      } else {
        partialRoute.nodes = route.visits.map(function(visit) {
          return visit.id;
        });
      }

      return partialRoute;
    };

    service.getPartialNodesFromVehicle = function (visits, visitSimilarGraph) {
      var similarNodes = {};
      return visits.reduce(function (ids, visit) {
        if (!similarNodes[visit.id]) {
          similarNodes[visit.id] = true;
          visitSimilarGraph.getSimilar(visit).forEach(function (similar) {
            similarNodes[similar.id] = true;
          });

          ids.push(visit.id);
        }

        return ids;
      }, []);
    };

    service.getNodeDataFromVisit = function (visit, similarVisits, partialNodes) {
      var visitId = visit.id;
      var foundSimilarVisit = null;
      if (similarVisits.length > 0 && !partialNodes.includes(visitId)) {
        foundSimilarVisit = similarVisits.find(function (similarVisit) {
          return partialNodes.includes(similarVisit.id);
        });
      }

      return {
        ident: foundSimilarVisit ? foundSimilarVisit.id : visitId,
        group: [visitId],
        group_id: null,
        address: visit.address,
        lat: visit.latitude,
        lon: visit.longitude,
        duration: visit.duration,
        load: 0,
        load_2: 0,
        load_3: 0,
        load_4: 0,
        cluster: 0,
        priority_level: visit.getPriority()
      };
    };

    service.getTimeWindowFromVisit = function (visit) {
      return {
        window_start: visit.windowStart || DAY_START_TIME,
        window_end: visit.windowEnd || DAY_END_TIME,
        window_start_2: visit.windowStart2 || DAY_END_TIME,
        window_end_2: visit.windowEnd2 || DAY_END_TIME,
        programmedDate: visit.programmedDate || ""
      };
    };

    service.getCPriorityFromVisit = function (visit, isJDH) {
      return isJDH
        ? {}
        : {
            priority: visit.getCPriority()
          };
    };

    service.getSkillsFromVisit = function (visit, reorderRoute) {
      return {
        skills_required: reorderRoute ? [] : visit.skills_required,
        skills_optional: reorderRoute ? [] : visit.skills_optional
      };
    };

    service.getZonesFromVisit = function (visit, zones, reorderRoute, isOneSellerPerVehicleEnabled) {
      if (isOneSellerPerVehicleEnabled && visit.seller_id && !reorderRoute) {
        var seller = plannerService.getSellerById(visit.seller_id);
        if (seller) {
          return { zones: [seller.localIntId] };
        }
      }
      var result = {
        zones:  reorderRoute || zones.length === 0 ? [] : zoneService.getActiveZonesVisit(visit)
      };

      var isRestrictionTypeAddonPropertyEnabled =
          zoneService.isRestrictionTypeAddonPropertyEnabled();

      if (isRestrictionTypeAddonPropertyEnabled) {
        result.flexible_zones = result.zones.filter(function (zoneId) {
          var zone = zoneService.findZoneById(zones, zoneId);
          return zone && zone.restriction_type === "flexible";
        });

        result.zones = result.zones.filter(function (zoneId) {
          var zone = zoneService.findZoneById(zones, zoneId);
          return zone && zone.restriction_type !== "flexible";
        });
      }

      return result;
    };

    service.getTimeWindowListForLongRoutes = function (longRoutes, visit, planDate, planInHours) {
      return {
        arrayOfTimeWindows: longRoutes
          ? buildArrayOfTimeWindows(planDate, planInHours, visit)
          : []
      };
    };

    service.getDurationFromVisitOrNode = function (node, visit) {
      if (!visit.duration || !node.duration){
        return {
          duration: visit.duration || node.duration
        };
      }
      return {
        duration: Math.max(visit.duration, node.duration)
      };
    };

    service.getLoadsFromNodeWhenIsReorderRoute = function (node, visit, reorderRoute) {
      if (visit.properties.delivery_type === RELATIONSHIP_TYPE.PICK) {
        return {};
      }

      return reorderRoute
        ? {
          load: node.load,
          load_2: node.load_2,
          load_3: node.load_3,
          load_4: node.load_4
        }
        : {
          load: sumLoads(visit.load, node.load),
          load_2: sumLoads(visit.load2, node.load_2),
          load_3: sumLoads(visit.load3, node.load_3),
          load_4: sumLoads(visit.load4, node.load_4)
        };
    };

    service.getPickLoads = function (node, visit, reorderRoute) {
      if (visit.properties.delivery_type === RELATIONSHIP_TYPE.PICK) {
        return {
          pickLoad: sumLoads(visit.load, node.pickLoad || 0),
          pickLoad_2: sumLoads(visit.load2, node.pickLoad_2 || 0),
          pickLoad_3: sumLoads(visit.load3, node.pickLoad_3 || 0)
        };
      }
      return reorderRoute ? {} : {
        pickLoad: visit.pickLoad,
        pickLoad_2: visit.pickLoad2,
        pickLoad_3: visit.pickLoad3
      };
    };

    service.getNewestTimeWindowsBetweenNodeAndVisit = function (visit, node) {
      return {
        window_start: getNewestTimeWindow(visit.window_start, node.window_start),
        window_end: getNewestTimeWindow(visit.window_end, node.window_end),
        window_start_2: getNewestTimeWindow(
          visit.window_start_2,
          node.window_start_2
        ),
        window_end_2: getNewestTimeWindow(visit.window_end_2, node.window_end_2)
      };
    };

    service.getPartialNodesFromVehicles = function (vehicleRequest, isPartialTour) {
      if (!isPartialTour) {
        return [];
      }

      var partialNodes = vehicleRequest.reduce(function (nodeAcc, vehicle) {
        var partialTour = vehicle.partial_tour;
        if (!partialTour) {
          return nodeAcc;
        }

        partialTour.partial_routes.forEach(function (partialRoute) {
          partialRoute.nodes.forEach(function (node) {
            if (!nodeAcc[node]) {
              nodeAcc[node] = true;
            }
          });
        });

        return nodeAcc;
      }, {});

      return Object.keys(partialNodes);
    };

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module("icarus.planner")
    .factory("routesOptimizationService", routesOptimizationService);
  /** @ngInject */
  function routesOptimizationService(
    plannerService, $http, __env, routesOptimizationUtils, zoneService, timeUtils,
    vehicleTypeUtils, optimizationUtilsService, visitsUtils
  ) {
    var service = {};

    var OPTIMIZE_JDH_PATH = __env.VRP_URL + "vrp/optimize/sync/";
    var OPTIMIZE_BIG_VRP_PATH = __env.VRP_URL + "big-vrp/optimize/sync/";
    var OPTIMIZE_VEHICLE_RESTRICTIONS_PATH = __env.ROUTER_MS_URL + 'v2/optimize/vrp/vehicle_restrictions';

    function convertVisitToOptimizationNode(visit, zones, planParams, similarVisits, partialNodes) {
      return Object.assign(
        {},
        routesOptimizationUtils.getNodeDataFromVisit(visit, similarVisits || [], partialNodes || []),
        routesOptimizationUtils.getTimeWindowFromVisit(visit),
        routesOptimizationUtils.getCPriorityFromVisit(visit, planParams.isJDH),
        routesOptimizationUtils.getSkillsFromVisit(visit, planParams.reorderRoute),
        routesOptimizationUtils.getZonesFromVisit(visit, zones, planParams.reorderRoute, planParams.isOneSellerPerVehicleEnabled),
        routesOptimizationUtils.getTimeWindowListForLongRoutes(
          planParams.longRoutes,
          visit,
          planParams.planDate,
          planParams.planInHours
        )
      );
    }

    function getNodeWithVisitData(node, visit, planParams) {
      return Object.assign(
        {},
        routesOptimizationUtils.getDurationFromVisitOrNode(node, visit),
        routesOptimizationUtils.getLoadsFromNodeWhenIsReorderRoute(node, visit, planParams.reorderRoute),
        routesOptimizationUtils.getPickLoads(node, visit, planParams.reorderRoute),
        routesOptimizationUtils.getNewestTimeWindowsBetweenNodeAndVisit(visit, node)
      );
    }

    service.getOptimizationParams = function (options, planParams) {
      var result = {
        vehicles: [],
        nodes: [],
        balance: options.balance,
        all_vehicles: options.all_vehicles,
        big_cluster: options.big_cluster,
        join: options.join,
        join_v2: options.join_v2,
        open_ended: options.open_ended,
        fmv: options.fmv,
        fmb: options.fmb,
        single_tour: options.single_tour,
        beauty: options.beauty,
        use_euclidean_distance: options.use_euclidean_distance,
        autoZone: options.autoZone,
        country: options.country,
        longRoutes: (options.longRoutes && !options.big_cluster) || false,
        enable_graphs: options.enable_graphs,
        auto_reorder: options.auto_reorder,
        insertion_intensification: options.insertion_intensification,
        intensive_intra: options.intensive_intra,
        open_routes_logic: options.open_routes_logic,
        vehicle_capacities_increment: options.vehicle_capacities_increment,
        vehicle_journey_extention: options.vehicle_journey_extention,
        enable_rest_time: options.enable_rest_time,
        enable_soft_window: options.enable_soft_window,
        wave_routing: options.wave_routing,
        load_balance: options.load_balance,
        time_balance: options.time_balance,
        avoid_tolls: options.avoid_tolls,
        maximize_attended_load: options.maximize_attended_load
      };

      if (options.max_client && 0 <= options.max_client) {
        result.max_client = options.max_client;
      }

      if (optimizationUtilsService.isMinLoadValid(options.min_load)) {
        result.min_load = options.min_load;
      }

      if (options.disable_soft_window) {
        result.disable_soft_window = options.disable_soft_window;
      }

      if (options.one_vehicle_zone) {
        result.one_vehicle_zone = options.one_vehicle_zone;
      }

      if (planParams.incrementalRouting) {
        result.incremental_routing = planParams.incrementalRouting;
      }

      if (planParams.reorderRoute && planParams.isJDH) {
        result.isReorder = true;
      }

      if (options.wave_routing) {
        result.plan_id = planParams.plan_id;
        result.previous_optimization_id = planParams.previous_optimization_id;
        result.planned_date = timeUtils.toIsoStringByDate(planParams.planDate.start);
        result.wave_time =  timeUtils.toIsoStringByDate(timeUtils.createTimeUTC(planParams.cutoffTime, "HH:mm:ss"));
        result.last_wave = planParams.lastWave;
      }

      if (!planParams.reorderRoute) {
        result.oneSellerPerVehicle = options.one_seller_per_vehicle;
      }

      return result;
    };

    service.getVehicleAsOptimizationData = function (vehicle, zones, options, planParams) {
      var vehiclesZones = options.one_seller_per_vehicle ? [] : zoneService.getActiveZonesVehicle(vehicle, zones);
      var vehicleData = Object.assign(
        {},
        routesOptimizationUtils.getDefaultDataFromVehicle(vehicle),
        routesOptimizationUtils.getCapacityFromVehicle(vehicle),
        routesOptimizationUtils.getShiftFromVehicle(
          vehicle,
          options.longRoutes,
          planParams.planInHours
        ),
        routesOptimizationUtils.getLoadsFromVehicle(vehicle),
        routesOptimizationUtils.getRestTimeFormVehicle(vehicle),
        routesOptimizationUtils.getMaxRouteDistanceFromVehicle(vehicle),
        routesOptimizationUtils.getPartialToursFromVehicle(
          vehicle,
          planParams.incrementalRouting,
          options.join,
          plannerService.visitSimilarGraph
        ),
        {
          zones: vehiclesZones,
          open_start: options.open_start
        }
      );

      var isRestrictionTypeAddonPropertyEnabled =
        zoneService.isRestrictionTypeAddonPropertyEnabled();

      if (isRestrictionTypeAddonPropertyEnabled && !options.one_seller_per_vehicle) {
        vehicleData.flexible_zones = vehicleData.zones.filter(function (zoneId) {
          var zone = zoneService.findZoneById(zones, zoneId);
          return zone && zone.restriction_type === "flexible";
        });

        vehicleData.zones = vehicleData.zones.filter(function (zoneId) {
          var zone = zoneService.findZoneById(zones, zoneId);
          return zone && zone.restriction_type !== "flexible";
        });
      }

      if (vehicleTypeUtils.shouldAddVehicleType(options)) {
        vehicleData.type = vehicleTypeUtils.getVehicleType(options);
      }

      return vehicleData;
    };

    service.getVehiclesRequestData = function (vehicles, zones, options, planParams) {
      return vehicles.map(function (vehicle) {
        return service.getVehicleAsOptimizationData(
          vehicle,
          zones,
          options,
          planParams
        );
      });
    };

    service.visitsToOptimizationNodes = function (visits, zones, planParams) {
      return visits.map(function (visit) {
        var node = convertVisitToOptimizationNode(visit, zones, planParams);
        return Object.assign({}, node, getNodeWithVisitData(node, visit, planParams));
      });
    };

    service.visitsToOptimizationNodesJoinedV1 = function (visits, zones, planParams, partialNodes) {
      var similarNodes = {};
      return visits.reduce(function (nodes, visit) {
        if (!similarNodes[visit.id]) {
          var similarVisits = plannerService.visitSimilarGraph.getSimilar(visit);

          // Filter out visits that don't match the current visit's type (legacy/new)
          var isLegacyVisit = visit.id.indexOf('-') === -1;
          similarVisits = similarVisits.filter(function(similar) {
            var isSimilarLegacy = similar.id.indexOf('-') === -1;
            return isLegacyVisit === isSimilarLegacy;
          });


          var node = convertVisitToOptimizationNode(visit, zones, planParams, similarVisits, partialNodes);
          similarNodes[visit.id] = node;
          similarVisits.forEach(function (similar) {
            if (!planParams.incrementalRouting || visitsUtils.areVisitsFromSameOrNoSourceRoute(visit, similar)) {
              similarNodes[similar.id] = node;
              node.group.push(similar.id);
              node.duration = Math.max(node.duration, similar.duration);
            }
          });

          nodes.push(node);
        }

        Object.assign(similarNodes[visit.id], getNodeWithVisitData(similarNodes[visit.id], visit, planParams));
        return nodes;
      }, []);
    };

    service.visitsToOptimizationNodesJoinedV2 = function (visits, zones, planParams) {
      var similarNodes = {};
      return visits.reduce(function (nodes, visit) {
        var node = convertVisitToOptimizationNode(visit, zones, planParams);
        if (!similarNodes[visit.id]) {
          var similarVisits = plannerService.visitSimilarGraph.getSimilar(visit);
          similarNodes[visit.id] = node;
          similarVisits.forEach(function (similar) {
            similarNodes[similar.id] = node;
          });
          Object.assign(similarNodes[visit.id], getNodeWithVisitData(similarNodes[visit.id], visit, planParams));
        } else {
          Object.assign(similarNodes[visit.id], getNodeWithVisitData(similarNodes[visit.id], visit, planParams));
          var groupId = similarNodes[visit.id].ident;
          similarNodes[visit.id].group_id = groupId;
          node.group_id = groupId;
        }
        return nodes.concat(node);
      }, []);
    };

    service.getVisitsRequestData = function (visits, zones, optimizationOptions, planParam, partialNodes) {
      if (optimizationOptions.join_v2) {
        return service.visitsToOptimizationNodesJoinedV2(visits, zones, planParam);
      }

      if (optimizationOptions.join) {
        return service.visitsToOptimizationNodesJoinedV1(visits, zones, planParam, partialNodes);
      }

      return service.visitsToOptimizationNodes(visits, zones, planParam);
    };

    service.optimizePlan = function (vehicles, visits, zones, options, planParams) {
      var requestData = service.getOptimizationParams(options, planParams);

      requestData.vehicles = service.getVehiclesRequestData(
        vehicles,
        zones,
        options,
        planParams
      );

      var partialNodesFromVehicles = routesOptimizationUtils.getPartialNodesFromVehicles(requestData.vehicles, planParams.incrementalRouting);
      requestData.nodes = service.getVisitsRequestData(
        visits,
        zones,
        options,
        planParams,
        partialNodesFromVehicles
      );

      requestData.start_time = plannerService.getPlanStartTime();

      var url = '';
      if (planParams.isVehicularRestrictionEnabled) {
        url = OPTIMIZE_VEHICLE_RESTRICTIONS_PATH;
      } else if (options.big_vrp) {
        url = OPTIMIZE_BIG_VRP_PATH;
      } else {
        url = OPTIMIZE_JDH_PATH;
      }

      return $http.post(url, requestData);
    };

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .service('routesGroupMarkersPositionService', routesGroupMarkersPositionService);

  /** @ngInject */
  function routesGroupMarkersPositionService(POLYLINE_SAMPLE_SIZE_PERCENTAGE, lodash) {
    var service = {
      getMidpoint: getMidpoint,
      getMidpointCoordinates: getMidpointCoordinates,
      translatePointToPolyline: translatePointToPolyline
    };

    function getMidpoint(arrivals, polyline) {
      var midpointCoordinates = service.getMidpointCoordinates(arrivals);
      return service.translatePointToPolyline(midpointCoordinates, polyline);
    }

    function getMidpointCoordinates(arrivals) {
      if (arrivals.length === 1) {
        return _getArrivalCoordinates(arrivals[0]);
      }

      var medianIndex = Math.floor(arrivals.length / 2);
      var startPoint = _getArrivalCoordinates(arrivals[medianIndex - 1]);
      var endPoint = _getArrivalCoordinates(arrivals[medianIndex]);

      var midpointLatitude = (startPoint.latitude + endPoint.latitude) / 2;
      var midpointLongitude = (startPoint.longitude + endPoint.longitude) / 2;

      return {
        latitude: midpointLatitude,
        longitude: midpointLongitude
      };
    }

    function _getArrivalCoordinates(arrival) {
      var arrivalElement = angular.isArray(arrival) ? arrival[0] : arrival;
      return {
        latitude: arrivalElement.latitude,
        longitude: arrivalElement.longitude
      };
    }

    function translatePointToPolyline(pointToTranslate, polyline) {
      var polylineSample = _getPolylineSample(polyline);
      var minimalDistance = Number.MAX_VALUE;
      var distance, translatedPoint;

      polylineSample.forEach(function(polylinePoint) {
        distance = _getDistance(pointToTranslate, polylinePoint);
        if (distance < minimalDistance) {
          minimalDistance = distance;
          translatedPoint = polylinePoint;
        }
      });

      return translatedPoint;
    }

    function _getPolylineSample(polyline) {
      var polylineSampleSize = Math.floor(polyline.length * POLYLINE_SAMPLE_SIZE_PERCENTAGE);
      var polylineSample = lodash.sampleSize(polyline, polylineSampleSize);

      return polylineSample.map(function(polylinePoint) {
        return {
          latitude: polylinePoint.lat(),
          longitude: polylinePoint.lng()
        };
      });
    }

    function _getDistance(firstPoint, secondPoint) {
      var x = secondPoint.latitude - firstPoint.latitude;
      var y = secondPoint.longitude - firstPoint.longitude;
      return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    }

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .service('routesGroupMarkersService', routesGroupMarkersService);

  /** @ngInject */
  function routesGroupMarkersService($state, STATE, $rootScope, plannerService, googleService, ROUTE_GROUP_MARKER_WIDTH,
                                     ROUTE_GROUP_MARKER_HEIGHT, ROUTE_GROUP_MARKER_FILL_OPACITY,
                                     ROUTE_GROUP_MARKER_ICON_PATH, ROUTE_GROUP_MARKER_TEXT_COLOR,
                                     ROUTE_GROUP_MARKER_STROKE_WEIGHT, ROUTE_GROUP_MARKER_FONT_SIZE,
                                     ROUTE_GROUP_MARKER_FONT_WEIGHT, MULTIPLYING_FACTOR_FOR_DISTINCT_LATITUDE,
                                     ROUTE_GROUP_MARKER_BASE_ZINDEX, routesGroupMarkersPositionService) {

    var GROUP_MARKER_CENTER_POINT = {
      xCoordinate: ROUTE_GROUP_MARKER_WIDTH / 2,
      yCoordinate: ROUTE_GROUP_MARKER_HEIGHT / 2
    };
    var service = {
      areGroupMarkersEnabled: areGroupMarkersEnabled,
      getOptionsToCreateGroupMarker: getOptionsToCreateGroupMarker,
      getOptionsToUpdateGroupMarker: getOptionsToUpdateGroupMarker,
      getGroupMarkerIcon: getGroupMarkerIcon,
      getGroupMarkerLabel: getGroupMarkerLabel,
      getGroupMarkerPosition: getGroupMarkerPosition,
      getGroupMarkerZIndex: getGroupMarkerZIndex
    };

    function areGroupMarkersEnabled() {
      return $state.includes(STATE.ROUTES_DETAIL) && $rootScope.isEnableRoutesGroupMarkers &&
        $rootScope.isHighDemandRouteDesigner && !$rootScope.drawCluster;
    }

    function getOptionsToCreateGroupMarker(route) {
      var arrivals = plannerService.getTotalArrivalsCached(route.visits, route.id);
      var position = service.getGroupMarkerPosition(arrivals, route);

      return {
        icon: service.getGroupMarkerIcon(route.stroke.color),
        ident: route.id,
        label: service.getGroupMarkerLabel(arrivals),
        map: plannerService.getGmap(),
        position: position,
        visible: route.visible,
        zIndex: service.getGroupMarkerZIndex(position.lat())
      };
    }

    function getOptionsToUpdateGroupMarker(route) {
      var arrivals = plannerService.getTotalArrivalsCached(route.visits, route.id);
      var position = service.getGroupMarkerPosition(arrivals, route);

      return {
        icon: service.getGroupMarkerIcon(route.stroke.color),
        label: service.getGroupMarkerLabel(arrivals),
        position: position,
        visible: route.visible,
        zIndex: service.getGroupMarkerZIndex(position.lat()),
        opacity: route.stroke.opacity
      };
    }

    function getGroupMarkerIcon(routeColor) {
      var groupMarkerCenterPoint = googleService.createPoint(
        GROUP_MARKER_CENTER_POINT.xCoordinate, GROUP_MARKER_CENTER_POINT.yCoordinate
      );
      return {
        anchor: groupMarkerCenterPoint,
        fillColor: routeColor,
        fillOpacity: ROUTE_GROUP_MARKER_FILL_OPACITY,
        labelOrigin: groupMarkerCenterPoint,
        path: ROUTE_GROUP_MARKER_ICON_PATH,
        strokeColor: ROUTE_GROUP_MARKER_TEXT_COLOR,
        strokeWeight: ROUTE_GROUP_MARKER_STROKE_WEIGHT
      };
    }

    function getGroupMarkerLabel(arrivals) {
      return {
        color: ROUTE_GROUP_MARKER_TEXT_COLOR,
        fontSize: ROUTE_GROUP_MARKER_FONT_SIZE,
        fontWeight: ROUTE_GROUP_MARKER_FONT_WEIGHT,
        text: String(arrivals.length)
      };
    }

    function getGroupMarkerPosition(arrivals, route) {
      var position;

      if (!arrivals.length) {
        var vehicle = plannerService.getVehicleById(route.vehicleId);
        position = vehicle.locationStart;
      } else {
        position = routesGroupMarkersPositionService.getMidpoint(arrivals, route.path);
      }

      return googleService.getGoogleMapsLatLng(position.latitude, position.longitude);
    }

    function getGroupMarkerZIndex(latitude) {
      // Z-index is set to the vertical coordinate of the marker. This is in keeping with the default stacking order for
      // Google Maps: markers to the south are in front of markers to the north.
      var latitudeToAddToZIndex = Math.floor(Math.abs(latitude) * MULTIPLYING_FACTOR_FOR_DISTINCT_LATITUDE);
      return ROUTE_GROUP_MARKER_BASE_ZINDEX + latitudeToAddToZIndex;
    }

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .constant('ROUTE_GROUP_MARKER_ICON_PATH', 'M36 0.5H12C5.64873 0.5 0.5 5.64873 0.5 12C0.5 18.3513 5.64873 23.5 12 ' +
      '23.5H36C42.3513 23.5 47.5 18.3513 47.5 12C47.5 5.64873 42.3513 0.5 36 0.5Z')
    .constant('ROUTE_GROUP_MARKER_TEXT_COLOR', 'white')
    .constant('ROUTE_GROUP_MARKER_FONT_SIZE', '16px')
    .constant('ROUTE_GROUP_MARKER_FONT_WEIGHT', '600')
    .constant('ROUTE_GROUP_MARKER_FILL_OPACITY', 1)
    .constant('ROUTE_GROUP_MARKER_STROKE_WEIGHT', 2)
    .constant('ROUTE_GROUP_MARKER_HEIGHT', 24)
    .constant('ROUTE_GROUP_MARKER_WIDTH', 48)
    .constant('ROUTE_GROUP_MARKER_BASE_ZINDEX', 2100000001)
    .constant('POLYLINE_SAMPLE_SIZE_PERCENTAGE', 0.2)
    .constant('MULTIPLYING_FACTOR_FOR_DISTINCT_LATITUDE', 10000);
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .service('revisedRoutesService', revisedRoutesService);

  /** @ngInject */
  function revisedRoutesService(ROUTE_REVISED_OPACITY, ROUTE_VISIBLE_OPACITY, visitsMarkersService,
                                plannerUtilsService) {
    var service = {
      getVehicleOpacity: getVehicleOpacity,
      getRouteOpacity: getRouteOpacity,
      updateRouteOpacityOnMap: updateRouteOpacityOnMap,
      isRouteRevised: isRouteRevised
    };

    function getVehicleOpacity(vehicle) {
      return vehicle.areAllRoutesRevised ? ROUTE_REVISED_OPACITY : ROUTE_VISIBLE_OPACITY;
    }

    function getRouteOpacity(route) {
      return route.isRevised ? ROUTE_REVISED_OPACITY : ROUTE_VISIBLE_OPACITY;
    }

    function updateRouteOpacityOnMap(route, routesVisualStatePerVehicle) {
      var opacity = service.getRouteOpacity(route);

      route.setOpacity(opacity);
      visitsMarkersService.setOpacityInVisits(route.visits, opacity, false);

      var visitsAreVisible = visitsMarkersService.shouldVisitsInRouteBeVisible(route, routesVisualStatePerVehicle);
      visitsMarkersService.updateVisitsOnMap(route.visits, visitsAreVisible);
    }

    function isRouteRevised(route) {
      return route.isRevised && plannerUtilsService.isEditModeActive();
    }

    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.planner')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations('es', {
      'Revised_routes': {
        'mark_revised': 'Marcar como revisada',
        'edit_route': 'Editar ruta'
      }
    });
    $translateProvider.translations('en', {
      'Revised_routes': {
        'mark_revised': 'Mark as reviewed',
        'edit_route': 'Edit route'
      }
    });
    $translateProvider.translations('pt', {
      'Revised_routes': {
        'mark_revised': 'Marcar como revisado',
        'edit_route': 'Editar rota'
      }
    });
  }
})();


(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("optimizationUtilsService", optimizationUtilsService);

  /** @ngInject */
  function optimizationUtilsService(
    MIN_MIN_LOAD_VALUE, MAX_MIN_LOAD_VALUE,
    NEGATIVE_MIN_LOAD_VALUE, VALID_MIN_LOAD_TYPE
  ) {
    var service = {
      isMinLoadValid: isMinLoadValid
    };

    function isMinLoadValid(min_load) {
      return (
        min_load === NEGATIVE_MIN_LOAD_VALUE ||
        typeof min_load === VALID_MIN_LOAD_TYPE &&
        (MIN_MIN_LOAD_VALUE <= min_load && min_load <= MAX_MIN_LOAD_VALUE)
      );
    }

    return service;
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .constant("MIN_MIN_LOAD_VALUE", 0)
    .constant("MAX_MIN_LOAD_VALUE", 100)
    .constant("NEGATIVE_MIN_LOAD_VALUE", "-1")
    .constant("VALID_MIN_LOAD_TYPE", "number");
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("mapHandlerService", mapHandlerService);

  /** @ngInject */
  function mapHandlerService(googleService) {

    var service = {
      isCoordinateInViewPort: isCoordinateInViewPort,
      getVisitsToShowAndHideOnMap: getVisitsToShowAndHideOnMap,
      getVisitsInViewport: getVisitsInViewport,
      isRouteGroupMarkerInViewport: isRouteGroupMarkerInViewport
    };

    /**
     * If the coordinate is within the bounds of the map, return true, otherwise return false.
     * @param coordinate - The coordinate to check if it's in the viewport.
     * @param bounds - The bounds of the map.
     * @returns A boolean value.
     */
    function isCoordinateInViewPort(coordinate, bounds) {
      var position = googleService.getGoogleMapsLatLng(coordinate.latitude, coordinate.longitude);
      return bounds.contains(position);
    }

    function getVisitsToShowAndHideOnMap(data) {
      var bounds = data.bounds;
      var visitsMarkers = data.visitsMarkers;
      var currentVisitsOnMap = data.currentVisitsOnMap;

      return _resolveVisitsToShowAndHide(currentVisitsOnMap, visitsMarkers, bounds);
    }

    function getVisitsInViewport(visits, bounds) {
      return visits.filter(function (visit) {
        return service.isCoordinateInViewPort(visit, bounds);
      });
    }

    function isRouteGroupMarkerInViewport(positionRoutesGroupMarker, bounds) {
      var coordinatesOfRoutesGroupMarker = {latitude: positionRoutesGroupMarker.lat(), longitude: positionRoutesGroupMarker.lng()};
      return service.isCoordinateInViewPort(coordinatesOfRoutesGroupMarker, bounds);
    }

    /**
     * It takes a list of visits and a list of markers and returns a list of visits that should be shown
     * and a list of visits that should be hidden
     * @param visits - an array of visits to be shown or hidden
     * @param visitsMarkers - This is an object that contains all the visits that are currently being
     * displayed on the map.
     * @param bounds - The current viewport bounds.
     * @returns An object with two properties: showVisits and hideVisits.
     */
    function _resolveVisitsToShowAndHide(visits, visitsMarkers, bounds) {
      var showVisits = [];
      var hideVisits = [];

      visits.forEach(function (visit) {
        var isVisitInVisitMarkersObject = visit.id in visitsMarkers;
        var isVisitCoordinateInViewPort = service.isCoordinateInViewPort(visit, bounds);

        if (isVisitCoordinateInViewPort && !isVisitInVisitMarkersObject) {
          showVisits.push(visit);
        } else if (!isVisitCoordinateInViewPort && isVisitInVisitMarkersObject) {
          hideVisits.push(visit);
        }
      });

      return {
        showVisits: showVisits,
        hideVisits: hideVisits
      };
    }

    return service;
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("polylineEventService", polylineEventService);

  /** @ngInject */
  function polylineEventService(
    plannerService, revisedRoutesService, $state,
    EVENT_CLICK, EVENT_WHEEL, $rootScope, $timeout, addonsService,
    PATH_FINDER_ADD_ON_KEY, EVENT_MOUSEOVER,
    PATH_FINDER_ADD_ON_PROPERTIES
  ) {

    var hasRouteColorOverwrite = false;
    var TOLERANCE_METERS = 20;
    var STEPS = 20;
    var ContextMenu = null;
    var moveVisitsRoutePathFinder = false;
    var MILISECONDS_TO_PREVENT_VISUAL_RELOAD = 500;

    addonsService.isAddonPropertyEnabled(PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES.MOVE_VISITS_ROUTE, function (addonProperty) {
      return addonProperty.value.toLowerCase() === "true";
    }).then(function (isAddonPropertyEnabled) {
      moveVisitsRoutePathFinder = isAddonPropertyEnabled;
    });

    addonsService.isAddonPropertyEnabled(PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES.ROUTE_COLOR_OVERWRITE, function (addonProperty) {
      return addonProperty.value.toLowerCase() === "true";
    }).then(function (isAddonPropertyEnabled) {
      hasRouteColorOverwrite = isAddonPropertyEnabled;
    });

    var clickHandler = null;
    var wheelHandler = null;
    var initialContextDataValues = {
      showContextMenu: false,
      routeId: null,
      vehicleId: null,
      routesInArea: []
    };
    var service = {
      contextMenu: contextMenu,
      closeContextMenu: closeContextMenu,
      highlightRouteOnHover: highlightRouteOnHover
    };

    function contextMenu(
      event, route, routesPolylines, setContextMenu,
      showColorPicker // TODO: Move this function to this service
    ) {
      if (!$state.includes("*.routes-detail")) {
        return;
      }
      setContextMenu(initialContextDataValues);
      var isRouteRevised = revisedRoutesService.isRouteRevised(route);
      if (isRouteRevised && !moveVisitsRoutePathFinder) {
        return;
      }
      var selectedVisits = plannerService.getSelectedVisits();

      if (selectedVisits.length === 0) {
        if (hasRouteColorOverwrite && !isRouteRevised) {
          handlePickColor(event, showColorPicker, route);
        }
        return;
      }

      if (moveVisitsRoutePathFinder) {
        $timeout(function () {
          showContextmenuPathFinder(
            event, routesPolylines, route,
            setContextMenu, isRouteRevised
          );
        }, MILISECONDS_TO_PREVENT_VISUAL_RELOAD);
      } else {
        showContextmenu(event, [route], setContextMenu);
      }

    }

    function handlePickColor(event, showColorPicker, route) {
      var positionColorPicker = {
        top: event.domEvent.clientY,
        left: event.domEvent.clientX
      };

      var mapContainer = document.getElementById('map');
      var mapBounds = mapContainer.getBoundingClientRect();
      // Simula un clic en el contenedor `.pickr` para abrir el selector de colores
      var pickrElement = document.querySelector('.pickr');
      if (pickrElement) {
        pickrElement.click();
      }
      // Mueve el selector de color a la posición del clic
      var pcrApp = document.querySelector('.pcr-app');
      if (pcrApp) {
        var pickerWidth = pcrApp.offsetWidth;
        var pickerHeight = pcrApp.offsetHeight;

        if (positionColorPicker.left + pickerWidth > mapBounds.right) {
          positionColorPicker.left = mapBounds.right - pickerWidth - 10;
        }
        if (positionColorPicker.top + pickerHeight > mapBounds.bottom) {
          positionColorPicker.top = mapBounds.bottom - pickerHeight - 10;
        }
        if (positionColorPicker.left < mapBounds.left) {
          positionColorPicker.left = mapBounds.left + 10;
        }
        if (positionColorPicker.top < mapBounds.top) {
          positionColorPicker.top = mapBounds.top + 10;
        }

        // Aplica la posición ajustada al color picker
        pcrApp.style.position = 'absolute';
        pcrApp.style.top = positionColorPicker.top + 'px';
        pcrApp.style.left = positionColorPicker.left + 'px';
        pcrApp.style.zIndex = 1000;
        pcrApp.style.display = 'block';
        pcrApp.classList.add('visible');
      }
      showColorPicker(route);
      return;
    }

    function someRouteAreNotRevised(routes) {
      return routes.some(function (route){
        return !revisedRoutesService.isRouteRevised(route);
      });
    };

    function showContextmenu(event, routes, setContextMenu) {
      var elementId = moveVisitsRoutePathFinder ? 'polylineMapContextMenu' : 'mapContextMenu';
      if (routes.length > 1 && !someRouteAreNotRevised(routes)) {
        return;
      }

      clickHandler = function () {
        closeContextMenu(setContextMenu);
      };
      wheelHandler = function () {
        closeContextMenu(setContextMenu);
      };

      ContextMenu = document.getElementById(elementId);
      var positionMenu = getPositionContextMenu(event);
      if (!ContextMenu) {
        return;
      }
      ContextMenu.style.top = (positionMenu.positionY) + "px";
      ContextMenu.style.left = (positionMenu.positionX) + "px";

      var route = routes[0];

      setContextMenu({
        showContextMenu: !moveVisitsRoutePathFinder,
        routesInArea: routes,
        routeId: route.id,
        vehicleId: route.vehicleId
      });
      document.addEventListener(EVENT_CLICK, clickHandler);
      document.addEventListener(EVENT_WHEEL, wheelHandler);
    }

    function getPositionContextMenu(event) {
      var sizeMenu = {
        height: 42,
        width: 127
      };
      var elementOut = {
        positionX: 100,
        positionY: 50
      };
      var outOfScreen = {
        positionX: 250,
        positionY: 150
      };
      var positionX = event.domEvent.clientX - elementOut.positionX;
      if (event.domEvent.clientX > (window.innerWidth - outOfScreen.positionX)) {
        positionX = event.domEvent.clientX - elementOut.positionX - sizeMenu.width;
      }
      var positionY = event.domEvent.clientY - elementOut.positionY;
      if (event.domEvent.clientY > (window.innerHeight - outOfScreen.positionY)) {
        positionY = event.domEvent.clientY - elementOut.positionY - sizeMenu.height;
      }
      return { positionX: positionX, positionY: positionY };
    }

    function closeContextMenu(setContextMenu) {
      setContextMenu(initialContextDataValues);
      ContextMenu = null;
      document.removeEventListener(EVENT_CLICK, clickHandler);
      document.removeEventListener(EVENT_WHEEL, wheelHandler);
    }

    function getRoutesInArea(routesPolylines, currentRoute, clickLatLng) {
      var matchingRoutes = Object.keys(routesPolylines).filter(function (routeId) {
        var polyline = routesPolylines[routeId];
        return polyline && isPointNearPolyline(clickLatLng, polyline, TOLERANCE_METERS);
      });

      return plannerService.getRoutes().filter(function (route) {
        return matchingRoutes.includes(route.id) || route.id === currentRoute.id;
      }).sort(function (routeA, routeB) {
        var vehicleNameA = plannerService.getVehicleName(routeA.vehicleId);
        var vehicleNameB = plannerService.getVehicleName(routeB.vehicleId);
        if (vehicleNameA < vehicleNameB) return -1;
        if (vehicleNameA > vehicleNameB) return 1;
        if (routeA.comment < routeB.comment) return -1;
        if (routeA.comment > routeB.comment) return 1;
        return 0;
      });
    }

    function showContextmenuPathFinder(
      event, routesPolylines, currentRoute,
      setContextMenu, isRouteRevised
    ) {
      var clickLatLng = event.latLng;
      var routesInArea = getRoutesInArea(routesPolylines, currentRoute, clickLatLng);
      if (routesInArea.length === 1 && isRouteRevised) {
        return;
      }
      if (routesInArea.length === 1) {
        var route = routesInArea[0];
        $rootScope.$broadcast("Planner:Route:moveVisitsToRoute", {
          route_id: route.id,
          vehicle_id: route.vehicleId
        });
        return;
      }
      showContextmenu(event, routesInArea, setContextMenu);
    }

    function isPointNearPolyline(point, polyline, toleranceMeters) {
      var path = polyline.getPath().getArray();

      for (var i = 0; i < path.length - 1; i++) {
        var start = path[i];
        var end = path[i + 1];
        if (isPointNearSegment(point, start, end, toleranceMeters)) {
          return true;
        }
      }

      return false;
    }

    function isPointNearSegment(point, start, end, toleranceMeters) {
      for (var i = 0; i <= STEPS; i++) {
        var fraction = i / STEPS;
        var interpPoint = google.maps.geometry.spherical.interpolate(start, end, fraction);
        var distance = google.maps.geometry.spherical.computeDistanceBetween(point, interpPoint);

        if (distance <= toleranceMeters) {
          return true;
        }
      }

      return false;
    }

    function highlightRouteOnHover(event, routeId, routesPolylines) {
      var DEFAULT_ROUTE_STROKE_WEIGHT = 3;
      var HOVER_ROUTE_STROKE_WEIGHT = 5;
      var routeElement = routesPolylines[routeId];
      if (!routeElement) {
        return;
      }
      var strokeWeightToApply = event === EVENT_MOUSEOVER ? HOVER_ROUTE_STROKE_WEIGHT : DEFAULT_ROUTE_STROKE_WEIGHT;

      var hasStyle = routeElement.icons && routeElement.icons.length;
      if (hasStyle) {
        var iconStyle = routeElement.icons[0];
        routeElement.setOptions({
          icons: [{
            icon: {
              path: iconStyle.icon.path,
              strokeOpacity: iconStyle.icon.strokeOpacity,
              strokeWeight: strokeWeightToApply,
              scale: iconStyle.icon.scale
            },
            offset: iconStyle.offset,
            repeat: iconStyle.repeat
          }]
        });
      } else {
        routeElement.setOptions({ strokeWeight: strokeWeightToApply });
      }
    }

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .service('driverSelectMapper', driverSelectMapper);

  /** @ngInject */
  function driverSelectMapper($filter) {
    var $translation = $filter('translate');
    var service = {
      formatList: formatList
    };

    function formatdriver(driver) {
      var hasExpiredDocs = driver.expired_documents && driver.expired_documents.length > 0;

      var result = {
        id: driver.id,
        title: driver.name,
        selected: driver.selected,
        disabled: driver.status === "blocked",
        description: ""
      };

      if (driver.status === "active") {
        if (hasExpiredDocs) {
          result.description = $translation('CustomSelect.requires_documentation_update');
        } else {
          result.description = $translation('CustomSelect.documentation_up_to_date');
        }
      }
      if (driver.status === "blocked") {
        if (hasExpiredDocs) {
          result.description = $translation('CustomSelect.documentation_not_current');
        } else {
          result.description = $translation('CustomSelect.vehicle_blocked');
        }
      }

      return result;
    }

    function formatList(drivers) {
      if (!drivers || !Array.isArray(drivers)) return [];
      return drivers.map(formatdriver);
    }

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('routeComparatorService', routeComparatorService);

  /** @ngInject */
  function routeComparatorService(timeUtils, ESTIMATED_TIME_FORMAT, colorAssignerService) {
    var service = {
      isEstimatedTimeStartUpdated: isEstimatedTimeStartUpdated,
      isEstimatedTimeEndUpdated: isEstimatedTimeEndUpdated,
      isDriverUpdated: isDriverUpdated,
      isCodriversUpdated: isCodriversUpdated,
      areRoutesEventsUpdated: areRoutesEventsUpdated,
      isRestTimeUpdated: isRestTimeUpdated,
      isColorUpdated: isColorUpdated,
      isRevisedStatusUpdated: isRevisedStatusUpdated,
      isVehicleUpdated: isVehicleUpdated,
      isRouteUpdated: isRouteUpdated
    };

    function isEstimatedTimeStartUpdated(originalRoute, currentRoute) {
      return (originalRoute.estimated_time_start !== timeUtils.formatTime(currentRoute.estimatedTimeStart,
        ESTIMATED_TIME_FORMAT));
    }

    function isEstimatedTimeEndUpdated(originalRoute, currentRoute) {
      return (originalRoute.estimated_time_end !== timeUtils.formatTime(currentRoute.estimatedTimeEnd,
        ESTIMATED_TIME_FORMAT));
    }

    function isDriverUpdated(originalRoute, currentRoute) {
      var originalDriverId = originalRoute.driver ? Number(originalRoute.driver) : null;
      var currentDriver = currentRoute.driver;
      var currentDriverId = currentDriver ? Number(currentDriver) : null;

      return (originalDriverId !== currentDriverId);
    }

    function isCodriversUpdated(originalRoute, currentRoute) {
      var originalCodrivers = (originalRoute.codrivers || []).map(Number).sort();
      var currentCodrivers = (currentRoute.codrivers || []).map(Number).sort();
      
      if (originalCodrivers.length !== currentCodrivers.length) {
        return true;
      }
      
      return originalCodrivers.join(',') !== currentCodrivers.join(',');
    }

    function areRoutesEventsUpdated(originalRoute, currentRoute) {
      var originalRouteEvent = originalRoute.events[0];
      var currentRouteEvent = currentRoute.events[0];

      return (originalRouteEvent.latitude !== currentRouteEvent.latitude) ||
        (originalRouteEvent.longitude !== currentRouteEvent.longitude) ||
        (originalRouteEvent.start_time !== currentRouteEvent.start_time) ||
        (originalRouteEvent.end_time !== currentRouteEvent.end_time);
    }

    function isRestTimeUpdated(originalRoute, currentRoute) {
      var isRestTimeUpdated;

      // if restTime is defined for the first time or is deleted
      if ((originalRoute.events && !currentRoute.events) || (!originalRoute.events && currentRoute.events)) {
        isRestTimeUpdated = true;
      }
      // no rest time and events
      else if (!originalRoute.events && !currentRoute.events) {
        isRestTimeUpdated = false;
      }

      // else compare every value
      else {
        // easy path, event route array has one element
        isRestTimeUpdated = service.areRoutesEventsUpdated(originalRoute, currentRoute);
      }

      return isRestTimeUpdated;
    }

    function isColorUpdated() {
      return colorAssignerService.areColorsEnabled() && colorAssignerService.areColorsReassigned();
    }

    function isRevisedStatusUpdated(originalRoute, currentRoute) {
      return (currentRoute.isRevised !== originalRoute.is_revised);
    }

    function isVehicleUpdated(originalRoute, currentRoute) {
      var currentVehicleId = parseInt(currentRoute.vehicleId);
      var originalVehicleId = originalRoute.vehicle;

      return (currentVehicleId !== originalVehicleId);
    }

    function isRouteUpdated(originalRoute, currentRoute) {
      return service.isEstimatedTimeStartUpdated(originalRoute, currentRoute) ||
        service.isEstimatedTimeEndUpdated(originalRoute, currentRoute) ||
        service.isDriverUpdated(originalRoute, currentRoute) ||
        service.isCodriversUpdated(originalRoute, currentRoute) ||
        service.isRestTimeUpdated(originalRoute, currentRoute) ||
        service.isColorUpdated() ||
        service.isRevisedStatusUpdated(originalRoute, currentRoute) ||
        service.isVehicleUpdated(originalRoute, currentRoute);
    }

    return service;
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .constant("WINDOW_ORIGINAL_LENGTH", 8)
    .constant("WINDOW_NEW_LENGTH", 5)
    .constant("WINDOW_ORIGINAL_SLICE_START", 0)
    .constant("WINDOW_ORIGINAL_SLICE_END", 5)

    .constant("ESTIMATED_TIME_ORIGINAL_LENGTH", 8)
    .constant("ESTIMATED_TIME_NEW_LENGTH", 15)
    .constant("ESTIMATED_TIME_ORIGINAL_SLICE_START", 0)
    .constant("ESTIMATED_TIME_ORIGINAL_SLICE_END", 5)
    .constant("ESTIMATED_TIME_NEW_SLICE_START", 11)
    .constant("ESTIMATED_TIME_NEW_SLICE_END", 16);
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("comparatorService", comparatorService);

  /** @ngInject */
  function comparatorService(WINDOW_ORIGINAL_LENGTH, WINDOW_NEW_LENGTH, WINDOW_ORIGINAL_SLICE_START,
                             WINDOW_ORIGINAL_SLICE_END, ESTIMATED_TIME_ORIGINAL_LENGTH,
                             ESTIMATED_TIME_NEW_LENGTH, ESTIMATED_TIME_ORIGINAL_SLICE_START,
                             ESTIMATED_TIME_ORIGINAL_SLICE_END, ESTIMATED_TIME_NEW_SLICE_START,
                             ESTIMATED_TIME_NEW_SLICE_END, timeUtils) {
    var service = {
      getObjectDifferences: getObjectDifferences,
      validateVisitFields: validateVisitFields,
      validateRouteFields: validateRouteFields,
      validateItemFields: validateItemFields
    };

    function getObjectDifferences(originalObject, newObject, noOptionalKeys, validateFieldsFunction) {
      var objectWithDifferences = {};
      var objectKeys = Object.keys(newObject);
      objectKeys.forEach(function (key) {
        if (noOptionalKeys.includes(key) || validateFieldsFunction(key, originalObject[key], newObject[key])) {
          objectWithDifferences[key] = newObject[key];
        }
      });
      return objectWithDifferences;
    }

    function windowValidation(originalValue, newValue) {
      if (!originalValue || !newValue) {
        return originalValue !== newValue;
      }

      if (originalValue.length !== WINDOW_ORIGINAL_LENGTH && newValue.length !== WINDOW_NEW_LENGTH) {
        return originalValue !== newValue;
      }

      originalValue = originalValue.slice(WINDOW_ORIGINAL_SLICE_START, WINDOW_ORIGINAL_SLICE_END);
      return originalValue !== newValue;
    }

    // Durations come in mixed formats (back: 'HH:MM:SS' / '1 02:00:00';
    // front: 'HH:MM:SS' from formatVisitDuration), so compare the parsed
    // whole-minute value instead of the raw strings.
    function durationValidation(originalValue, newValue) {
      return timeUtils.parseVisitDuration(originalValue) !== timeUtils.parseVisitDuration(newValue);
    }

    function estimatedTimeValidation(originalValue, newValue) {
      if (!originalValue || !newValue) {
        return originalValue !== newValue;
      }

      if (originalValue.length !== ESTIMATED_TIME_ORIGINAL_LENGTH && newValue.length !== ESTIMATED_TIME_NEW_LENGTH) {
        return originalValue !== newValue;
      }

      originalValue = originalValue.slice(ESTIMATED_TIME_ORIGINAL_SLICE_START, ESTIMATED_TIME_ORIGINAL_SLICE_END);
      newValue = newValue.slice(ESTIMATED_TIME_NEW_SLICE_START, ESTIMATED_TIME_NEW_SLICE_END);
      return originalValue !== newValue;
    }

    function numberValidation(originalValue, newValue) {
      if (!originalValue || !newValue) {
        return originalValue !== newValue;
      }
      return parseInt(originalValue) !== parseInt(newValue);
    }

    function floatValidation(originalValue, newValue) {
      if (!originalValue || !newValue) {
        return originalValue !== newValue;
      }
      return parseFloat(originalValue) !== parseFloat(newValue);
    }

    function arrayValidation (originalValue, newValue) {
      if (!originalValue || !newValue) {
        return originalValue !== newValue;
      }
      if (originalValue.length !== newValue.length) {
        return true;
      }
      return originalValue.sort().toString() !== newValue.sort().toString();
    }

    function routePropertyValidation(originalValue, newValue) {

      var originalColor = (originalValue && typeof originalValue === 'object') ? originalValue.color : null;
      var newColor = (newValue && typeof newValue === 'object') ? newValue.color : null;

      return originalColor !== newColor;
    }

    function validateVisitFields(fieldName, originalValue, newValue) {
      var fieldsValidation = {
        "window_end": windowValidation,
        "window_end_2": windowValidation,
        "window_start": windowValidation,
        "window_start_2": windowValidation,
        "estimated_time_arrival": estimatedTimeValidation,
        "estimated_time_departure": estimatedTimeValidation,
        "duration": durationValidation,
        "skills_optional": arrayValidation,
        "skills_required": arrayValidation
      };

      var validationFunction = fieldsValidation[fieldName];
      if (validationFunction) {
        return validationFunction(originalValue, newValue);
      }
      return originalValue !== newValue;
    }

    function validateRouteFields(fieldName, originalValue, newValue) {
      var fieldsValidation = {
        "vehicle": numberValidation,
        "driver": numberValidation,
        "codrivers": arrayValidation,
        "total_distance": numberValidation,
        "estimated_time_start": estimatedTimeValidation,
        "estimated_time_end": estimatedTimeValidation,
        "location_start_latitude": floatValidation,
        "location_start_longitude": floatValidation,
        "location_end_latitude": floatValidation,
        "location_end_longitude": floatValidation,
        "properties": routePropertyValidation
      };
      var validationFunction = fieldsValidation[fieldName];   
      if (validationFunction) {
        return validationFunction(originalValue, newValue);
      }
      return originalValue !== newValue;
    }

    function validateItemFields(fieldName, originalValue, newValue) {
      var fieldsValidation = {
        "quantity_planned": floatValidation
      };

      var validationFunction = fieldsValidation[fieldName];
      if (validationFunction) {
        return validationFunction(originalValue, newValue);
      }
      return originalValue !== newValue;
    }

    return service;
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("colorAssignerService", colorAssignerService);

  /** @ngInject */
  function colorAssignerService(
    $http, $q, __env, accountConfigsService, COLORS_BY_TONE,
    ACCOUNT_CONFIGS, MIN_GRAPH_COLORER_LENGTH, MAX_COLOR_INDEX
  ) {

    var COLORS_BY_HEX_CODE = {};
    var _defaultVehiclesColorCache = {};
    var _planVehiclesColors = {};
    var _vehiclesByColorDefaultValue = {
      'blue': [],
      'red': [],
      'yellow': [],
      'purple': [],
      'pink': [],
      'green': [],
      'sky blue': []
    };
    var _vehiclesByColor = angular.copy(_vehiclesByColorDefaultValue);
    var _areColorsEnabled = null;
    var _areColorReassigned = false;

    var _lastGraphColors = {};
    var _mustUpdateColor = false;

    var service = {
      assignVehiclesColor: assignVehiclesColor,
      generateGraphColorRequest: generateGraphColorRequest,
      setDefaultVehicleColorCache: setDefaultVehicleColorCache,
      getDefaultVehiclesColorCache: getDefaultVehiclesColorCache,
      setPlanVehicleColor: setPlanVehicleColor,
      getVehicleColor: getVehicleColor,
      getPlanVehiclesColors: getPlanVehiclesColors,
      pushNewVehicleByColor: pushNewVehicleByColor,
      clearPlanVehiclesColorsDependencies: clearPlanVehiclesColorsDependencies,
      clearDefaultVehicleColorCache: clearDefaultVehicleColorCache,
      generatePlanVehiclesColor: generatePlanVehiclesColor,
      areColorsEnabled: areColorsEnabled,
      clearColorLogic: clearColorLogic,
      addNewVehicleColor: addNewVehicleColor,
      generatePlanVehiclesColorWithoutGraphColor: generatePlanVehiclesColorWithoutGraphColor,
      vehiclesModelToGraphColorRequest: vehiclesModelToGraphColorRequest,
      assignVehiclesColorFromRouteProperties: assignVehiclesColorFromRouteProperties,
      initializeService: initializeService,
      getColorsByHexCode: getColorsByHexCode,
      areColorsReassigned: areColorsReassigned,
      getLastGraphColors: getLastGraphColors,
      setLastGraphColors: setLastGraphColors,
      specifyVehicleColorById: specifyVehicleColorById,
      setMustUpdateColor: setMustUpdateColor,
      getMustUpdateColor: getMustUpdateColor,
      clearVehiclesByColor: clearVehiclesByColor
    };

    function initializeService() {
      COLORS_BY_HEX_CODE = _generateColorsByHexCode();
    }

    function _generateColorsByHexCode() {
      var colorsByHexCode = {};
      Object.keys(COLORS_BY_TONE).forEach(function(tone) {
        var hexCodesArray = COLORS_BY_TONE[tone];
        hexCodesArray.forEach(function(hexCode) {
          colorsByHexCode[hexCode] = tone;
        });
      });
      return colorsByHexCode;
    }

    function getColorsByHexCode() {
      return COLORS_BY_HEX_CODE;
    }

    function areColorsEnabled() {
      if (_areColorsEnabled !== null) {
        return _areColorsEnabled;
      }

      _areColorsEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_COLORS_FOR_CONTIGUOUS_ROUTES);
      return _areColorsEnabled;
    }

    function getDefaultVehiclesColorCache() {
      return _defaultVehiclesColorCache;
    }

    function setDefaultVehicleColorCache(vehicleId, color) {
      _defaultVehiclesColorCache[vehicleId] = color;
    }

    function clearDefaultVehicleColorCache() {
      _defaultVehiclesColorCache = {};
    }

    function getVehicleColor(vehicleId) {
      if (!areColorsEnabled()) {
        return _defaultVehiclesColorCache[vehicleId];
      }

      return _planVehiclesColors[vehicleId] || _defaultVehiclesColorCache[vehicleId];
    }

    function getPlanVehiclesColors() {
      return _planVehiclesColors;
    }

    function setPlanVehicleColor(vehicleId, color) {
      _planVehiclesColors[vehicleId] = color;
    }

    function pushNewVehicleByColor(colorKey, vehicleId) {
      _vehiclesByColor[colorKey].push(vehicleId);
    }

    function areColorsReassigned () {
      return _areColorReassigned;
    }

    function clearPlanVehiclesColorsDependencies() {
      _lastGraphColors = {};
      _mustUpdateColor = false;
      _planVehiclesColors = {};
      _vehiclesByColor = angular.copy(_vehiclesByColorDefaultValue);
    }

    function _callGraphColorer(request) {
      return $http.post(__env.GRAPH_COLORER_URL, request);
    }

    function setLastGraphColors(colors) {
      _lastGraphColors = colors;
    }

    function getLastGraphColors() {
        return _lastGraphColors;
    }

    function setMustUpdateColor(value) {
      _mustUpdateColor = value;
    }

    function getMustUpdateColor() {
      return _mustUpdateColor;
  }

    function vehiclesModelToGraphColorRequest(vehicles) {

      return vehicles
        .map(function (vehicle) {
          var tours = vehicle.routes.map(function (route) {
            var nodes = route.visits.map(function (visit) {
              return {
                latitude: parseFloat(visit.latitude),
                longitude: parseFloat(visit.longitude)
              };
            });
            return nodes;
          });
          return {
            ident: vehicle.id,
            tours: tours
          };
        });
    }

    function generateGraphColorRequest(vehicles) {
      var START_TOUR_NODE = 0;
      var END_TOUR_NODE = 0;
      return vehicles
        .map(function (vehicle) {
          var tours = vehicle.tours.map(function (tour) {
            if (tour.nodes.length > 2) {
              END_TOUR_NODE = tour.nodes.length - 1;
            }
            var nodes = tour.nodes.filter(function (node, nodeIndex) {
              if (nodeIndex !== START_TOUR_NODE && nodeIndex !== END_TOUR_NODE) {
                return node;
              }
            }).map(function (node) {
              return {
                latitude: node.lat,
                longitude: node.lon
              };
            });

            return nodes;
          });

          return {
            ident: vehicle.ident,
            tours: tours
          };
        });

    }

    function __resolvePromise(deferred) {
      deferred.resolve();
      return deferred.promise;
    }

    function specifyVehicleColorById(vehiclesFromPlan) {

      var deferred = $q.defer();

      _areColorReassigned = true;

      if (!areColorsEnabled() || !(vehiclesFromPlan.length > MIN_GRAPH_COLORER_LENGTH) ) {
        return __resolvePromise(deferred);
      }

      var request = vehiclesModelToGraphColorRequest(vehiclesFromPlan);

      if (Object.keys(_lastGraphColors).length > 0){
        request = request.map(function (node) {
          var weightColor = _lastGraphColors[node.ident];
          node['color'] = angular.isUndefined(weightColor) ? -1 : weightColor;
          return node;
        });

      } else {
        _mustUpdateColor = true;
      }

      return _callGraphColorer(request)
        .then(function (response) {
          _lastGraphColors = response.data;
          clearVehiclesByColor(response.data);
          generatePlanVehiclesColor(response.data);
        });
    }

    function assignVehiclesColor(vehiclesFromOptimization, vehiclesFromPlan) {
      var deferred = $q.defer();

      var vehiclesFromPlanRequest = null;
      if (!areColorsEnabled() || !vehiclesFromOptimization) {
        return __resolvePromise(deferred);
      }

      clearPlanVehiclesColorsDependencies();

      var vehicles = vehiclesFromOptimization.filter(function (vehicle) {
        return vehicle.tours.length;
      });
      var vehiclesLength = vehicles.length;
      var vehiclesFromPlanLength = vehiclesFromPlan ? vehiclesFromPlan.length : 0;
      var totalVehicles = vehiclesLength + vehiclesFromPlanLength;
      _areColorReassigned = true;

      if (totalVehicles < MIN_GRAPH_COLORER_LENGTH) {
        if (vehiclesFromPlanLength) {
          vehiclesFromPlan.forEach(function (vehicleFromPlan) {
            vehicles.push({
              ident: vehicleFromPlan.id
            });
          });
        }
        generatePlanVehiclesColorWithoutGraphColor(vehicles);
        return __resolvePromise(deferred);
      }

      if (vehiclesFromPlanLength) {
        vehiclesFromPlanRequest = vehiclesModelToGraphColorRequest(vehiclesFromPlan);
      }
      var request = generateGraphColorRequest(vehicles);

      if (vehiclesFromPlanRequest && request) {
        request = vehiclesFromPlanRequest.concat(request);
      }

      _callGraphColorer(request)
        .then(function (response) {
          clearPlanVehiclesColorsDependencies();
          generatePlanVehiclesColor(response.data);
          _lastGraphColors = response.data;
          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function assignVehiclesColorFromRouteProperties(vehicles) {

      if (!service.areColorsEnabled()) {
        return;
      }
      _areColorReassigned = false;

      service.clearPlanVehiclesColorsDependencies();

      vehicles.forEach(function(vehicle) {
        var routes = vehicle.routes;
        if (routes.length && routes[0].properties && routes[0].properties.color) {
          var colorHexCode = routes[0].properties.color;
          service.setPlanVehicleColor(vehicle.id, colorHexCode);

          var colorTone = COLORS_BY_HEX_CODE[colorHexCode];
          service.pushNewVehicleByColor(colorTone, vehicle.id);
        }
      });
    }

    function generatePlanVehiclesColorWithoutGraphColor (vehicles) {
      vehicles.forEach(function (vehicle){
        addNewVehicleColor(vehicle.ident);
      });
    }

    function _loadVehiclesByColor(vehicles) {
      var colorsKeys = Object.keys(COLORS_BY_TONE);
      Object.keys(vehicles).forEach(function (vehicleId) {
        var graphIndex = vehicles[vehicleId];
        var colorIndex = graphIndex > MAX_COLOR_INDEX ?
          graphIndex % (MAX_COLOR_INDEX + 1)
          : graphIndex;
        var colorKey = colorsKeys[colorIndex];
        pushNewVehicleByColor(colorKey, vehicleId);
      });
    }

    function generatePlanVehiclesColor(vehicles) {
      _loadVehiclesByColor(vehicles);
      Object.keys(_vehiclesByColor).forEach(function (colorKey) {
        var vehiclesIds = _vehiclesByColor[colorKey];
        var color = COLORS_BY_TONE[colorKey];
        var color_length = color.length;
        vehiclesIds.forEach(function (vehicleId, vehicleIndex) {
          var color_index = vehicleIndex % color_length;
          setPlanVehicleColor(vehicleId, color[color_index]);
        });
      });
    }

    function _checkSmallVehiclesAggrupation () {
      var smallColor = null;
      var smallVehicleLength = 0;
      Object.keys(_vehiclesByColor).forEach(function (colorKey, index) {
        var vehiclesIds = _vehiclesByColor[colorKey];
        var vehicleLength = vehiclesIds.length;
        if (index === 0 || smallVehicleLength > vehicleLength) {
          smallColor = colorKey;
          smallVehicleLength = vehicleLength;
        }
      });
      return smallColor;
    }

    function addNewVehicleColor(vehicleId) {
      var smallColorAggrupation = _checkSmallVehiclesAggrupation();
      var colors = COLORS_BY_TONE[smallColorAggrupation];
      var vehiclesByColor = _vehiclesByColor[smallColorAggrupation];
      var colorAssigned = colors[vehiclesByColor.length % colors.length];
      setPlanVehicleColor(vehicleId, colorAssigned);
      vehiclesByColor.push(vehicleId);
    }

    function clearColorLogic() {
      clearDefaultVehicleColorCache();
      clearPlanVehiclesColorsDependencies();
      _areColorsEnabled = null;
      _areColorReassigned = false;
    }

    function clearVehiclesByColor(vehicles) {
      Object.keys(_vehiclesByColor).forEach(function (colorKey) {
        var vehiclesIds = _vehiclesByColor[colorKey];
        _vehiclesByColor[colorKey] = vehiclesIds.filter(function (vehicleId) {
          return !vehicles.hasOwnProperty(vehicleId);
        });
      });
    }

    return service;
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .constant("MAX_COLOR_INDEX", 6)
    .constant("MIN_GRAPH_COLORER_LENGTH", 15)
    .constant("COLORS_BY_TONE", {
      "blue": ["#0000FF", "#3873A6", "#3A468B", "#00008B", "#1254AB", "#1B333C", "#006580", "#0000B3", "#037C8A",
        "#006161", "#002FB2", "#232A53", "#0E4389", "#090973", "#003D4D"],
      "red": ["#D50000", "#821D01", "#FF3D00", "#BE2F34", "#8B0000", "#B32B00", "#721C1F", "#E44704", "#D55023",
        "#E36514", "#FF6905", "#FF8C00", "#FFA500"],
      "yellow": ["#FFD000", "#CFCB10", "#B37300", "#B39200", "#FFC114", "#FCAD3D", "#918E0B", "#B36200", "#936E10",
        "#D29D17"],
      "purple": ["#9400D3", "#960067", "#9168C4", "#6641B0", "#640075", "#4B0082", "#360087", "#B232C9", "#CB0ACB",
        "#5C21FF", "#A700C4", "#A31A58"],
      "pink": ["#FF6969", "#FF00FF", "#E47E5C", "#FF0883", "#F86AF8", "#D67AD6", "#FC834F", "#DE317F", "#F163B6",
        "#FA6997", "#DA1488", "#E88484"],
      "green": ["#006400", "#334416", "#658900", "#008000", "#00B049", "#68B826", "#1BA170", "#03B500", "#4B6420",
        "#004D00", "#007B33"],
      "sky blue": ["#40C4FF", "#08BDD1", "#009ADF", "#02BFA3", "#008B8B", "#2962FF", "#4D5BF7"]
    });
})();

(function () {
  'use strict';
  angular
    .module('icarus.planner')
    .factory('autosaveDraftPlanService', autosaveDraftPlanService);

  /** @ngInject */
  function autosaveDraftPlanService($state, plannerService, AUTOSAVE_PLAN_INTERVAL) {

    var service = {
      startAutoSavePlan: startAutoSavePlan,
      cancelAutoSavePlan: cancelAutoSavePlan,
      isSaveDraftProcessRunning: isSaveDraftProcessRunning,
      setSaveDraftProcessRunning: setSaveDraftProcessRunning
    };

    var interval = null;
    var isFunctionRunning = false;

    function isSaveDraftProcessRunning() {
      return isFunctionRunning;
    }

    function setSaveDraftProcessRunning(value) {
      isFunctionRunning = value;
    }

    /**
     * "Start the auto-save interval."
     * 
     * The function is called when the user starts editing a plan
     */
    function startAutoSavePlan() {
      if (interval) { return; }
      interval = setInterval(function () {
        if (!$state.includes('*.routes-detail')) {
          return cancelAutoSavePlan();
        }

        if (isFunctionRunning) {
          return;
        }

        isFunctionRunning = true;
        plannerService.saveDraftPlan().finally(function () {
          isFunctionRunning = false;
        });
      }, AUTOSAVE_PLAN_INTERVAL);
    }

    function cancelAutoSavePlan() {
      if (!interval) { return; }
      clearInterval(interval);
      interval = null;
      isFunctionRunning = false;
    }

    return service;
  }

})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .service('addressStatsService', addressStatsService);

  /** @ngInject */
  function addressStatsService($http, __env, $log, $q, VISIT_ADDRESS_STATUS, $timeout) {
    var ADDRESS_STATS_SERVICE_PATH = __env.FEATURE_STORE_API_URL + 'stats/address';
    var MAX_RETRIES = 1;
    var RETRY_DELAY = 1000;
    var service = {
      fetchAndProcessAddressStats: fetchAndProcessAddressStats
    };

    function fetchAndProcessAddressStats(visits, retryCount) {
      retryCount = retryCount || 0;
      var visitsObject = _createVisitsObject(visits);
      var requestData = _createRequestData(visits);
      return $http.post(ADDRESS_STATS_SERVICE_PATH, requestData)
        .then(function (response) {
          return _handleResponseData(response, visitsObject);
          })
          .catch(function (error) {
            if (retryCount < MAX_RETRIES) {
              return $timeout(function () {
                return fetchAndProcessAddressStats(visits, retryCount + 1);
              }, RETRY_DELAY);
            } else {
              $log.info('Max retries reached. Request failed:', error);
              var visitsWithoutLocation = visits.filter(function (visit) {
                return !visit.latitude && !visit.longitude;
              });
              return $q.when(
                {visitsWithoutLocation: visitsWithoutLocation, visitsWithUpdatedLocation: []}
              );
            }
          });
    }

    function _createVisitsObject(visits) {
      return visits.reduce(function (map, visit) {
        map[visit.id] = visit;
        return map;
      }, {});
    }

    function _createRequestData(visits) {
      return visits.map(function (visit) {
        return visit.latitude && visit.longitude ? {
          id: visit.id,
          address: visit.address,
          longitude: visit.longitude,
          latitude: visit.latitude
        } : {
          id: visit.id,
          address: visit.address
        };
      });
    }

    function _handleResponseData(response, visitsObject) {
      var visitsWithoutLocation = [];
      var visitsWithUpdatedLocation = [];
      response.data.forEach(function (stats) {
        var visit = visitsObject[stats.id];
        visit.addressStatistics.status = stats.status;

        if (stats.stat) {
          visit.addressStatistics.last_latitude = stats.stat.last_latitude;
          visit.addressStatistics.last_longitude = stats.stat.last_longitude;

          if (!visit.latitude && !visit.longitude) {
            visit.latitude = stats.stat.last_latitude;
            visit.longitude = stats.stat.last_longitude;
            visitsWithUpdatedLocation.push(visit);
          }
        } else if (stats.status === VISIT_ADDRESS_STATUS.NEW && !visit.latitude && !visit.longitude) {
          visitsWithoutLocation.push(visit);
        }
      });
      return $q.when({visitsWithoutLocation: visitsWithoutLocation, visitsWithUpdatedLocation: visitsWithUpdatedLocation});
    }

    return service;
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .component("widgetCoDriver", {
      templateUrl: "app/planner/components/widgetCoDriver/widgetCoDriver.html",
      controller: WidgetCoDriverController,
      bindings: {
        coDrivers: '<',
        isEditable: '<',
        goToCoDrivers: '&'
      }
    });

  /** @ngInject */
  function WidgetCoDriverController(MAX_CO_DRIVERS_LIMIT) {
    var ctrl = this;
    ctrl.MAX_CO_DRIVERS_LIMIT = MAX_CO_DRIVERS_LIMIT;

    ctrl.hasCoDrivers = function () {
      return ctrl.coDrivers && Array.isArray(ctrl.coDrivers) && ctrl.coDrivers.length > 0;
    };

    ctrl.getCoDriversCount = function () {
      if (!ctrl.coDrivers || !Array.isArray(ctrl.coDrivers)) {
        return 0;
      }
      return ctrl.coDrivers.length;
    };

    ctrl.hasExceededCoDriversLimit = function () {
      return ctrl.coDrivers.length > ctrl.MAX_CO_DRIVERS_LIMIT;
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .constant("MAX_CO_DRIVERS_LIMIT", 9);
})();

(function () {
    'use strict';

    angular
      .module('icarus.planner')
      .component('visitReference', {
        controller: visitReferenceController,
        templateUrl: 'app/planner/components/visitReference/visitReference.html',
        bindings: {
            visit: '<'
        }
      });

    /** @ngInject */
    function visitReferenceController($filter, $scope, naturalService) {
        var ctrl = this;
        ctrl.shouldDisplayTooltip = shouldDisplayTooltip;

        function shouldDisplayTooltip(elementId) {
            var element = document.getElementById('ref-'+elementId);
            if (element.scrollWidth > element.clientWidth) {
                return true;
            }
            return false;
        }
    }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .component("visitFilter", {
      controller: VisitFilterController,
      templateUrl: "app/planner/components/visitFilter/visitFilter.html",
      bindings: {
        activeFilter: "<",
        previousMinSliderTime: "<",
        previousMaxSliderTime: "<",
        filteredVisits: "<",
        totalVisits: "<",
        filterVisits: "&",
      },
    });

  /** @ngInject */
  function VisitFilterController(SLIDER_TIME_STEPS) {
    var ctrl = this;

    ctrl.open = false;
    ctrl.sliderTime = _getSliderTime(ctrl.previousMinSliderTime, ctrl.previousMaxSliderTime, SLIDER_TIME_STEPS);

    ctrl.toggleFilter = function () {
      ctrl.open = !ctrl.open;
      if (!ctrl.open) {
        _applyFilter(ctrl.previousMinSliderTime, ctrl.previousMaxSliderTime, ctrl.sliderTime);
      }
    };

    //// Private methods ////

    function _getSliderTime(minValue, maxValue, steps) {
      return {
        min: minValue,
        max: maxValue,
        options: {
          hideLimitLabels: true,
          pushRange: true,
          stepsArray: steps,
        },
      };
    }

    function _applyFilter(previousMinLimit, previousMaxLimit, sliderTime) {
      var currentMinLimit = sliderTime.min;
      var currentMaxLimit = sliderTime.max;

      if (_haveLimitsBeenChanged(previousMinLimit, previousMaxLimit, currentMinLimit, currentMaxLimit)) {
        var props = {
          minSliderTime: currentMinLimit,
          maxSliderTime: currentMaxLimit,
        };
        ctrl.filterVisits(props);
      }
    }

    function _haveLimitsBeenChanged(previousMinLimit, previousMaxLimit, currentMinLimit, currentMaxLimit) {
      return (currentMinLimit !== previousMinLimit || currentMaxLimit !== previousMaxLimit);
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations("es", {
      VisitFilter: {
        filter_button: "Filtrar",
        time_window: "Ventana horaria",
        number_of_visits_shown: "Mostrando {{filteredVisits}} de {{totalVisits}}",
      },
    });

    $translateProvider.translations("en", {
      VisitFilter: {
        filter_button: "Filter",
        time_window: "Time window",
        number_of_visits_shown: "Showing {{filteredVisits}} of {{totalVisits}}",
      },
    });

    $translateProvider.translations("pt", {
      VisitFilter: {
        filter_button: "Filtro",
        time_window: "Janela de tempo",
        number_of_visits_shown: "Mostrando {{filteredVisits}} de {{totalVisits}}",
      },
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  "use strict";

  function vehicleSortByController(naturalService) {
    var ctrl = this;
    var INITIAL_VALUE = "";
    var DEFAULT_KEY_TO_SORT = "LHN";

    ctrl.sortDistance = sortDistance;
    ctrl.sortLoadByType = sortLoadByType;
    ctrl.sortDuration = sortDuration;
    ctrl.sortByName = sortByName;
    ctrl.vehicleSort = {
      HLK: {
        algorithm: sortDistance,
        desc: true,
      },
      LHK: {
        algorithm: sortDistance,
        desc: false,
      },
      HLC: {
        algorithm: sortLoadByType(""),
        desc: true,
      },
      LHC: {
        algorithm: sortLoadByType(""),
        desc: false,
      },
      HLC2: {
        algorithm: sortLoadByType("2"),
        desc: true,
      },
      LHC2: {
        algorithm: sortLoadByType("2"),
        desc: false,
      },
      HLC3: {
        algorithm: sortLoadByType("3"),
        desc: true,
      },
      LHC3: {
        algorithm: sortLoadByType("3"),
        desc: false,
      },
      HLV: {
        algorithm: sortDuration,
        desc: true,
      },
      LHV: {
        algorithm: sortDuration,
        desc: false,
      },
      LHN: {
        algorithm: sortByName,
        desc: false,
      },
    };
    ctrl.sortKey = ctrl.sortKey || INITIAL_VALUE;
    ctrl.sortBy = ctrl.sortKey;
    var initialKeyToSort = ctrl.sortBy || DEFAULT_KEY_TO_SORT;
    ctrl.algorithm = ctrl.vehicleSort[initialKeyToSort]["algorithm"];
    ctrl.desc = ctrl.vehicleSort[initialKeyToSort]["desc"];

    ctrl.handleChange = function () {
      ctrl.algorithm = ctrl.vehicleSort[ctrl.sortBy]["algorithm"];
      ctrl.desc = ctrl.vehicleSort[ctrl.sortBy]["desc"];
      ctrl.sortKey = ctrl.sortBy;
    };

    function sortByName(item) {
      return naturalService.naturalValue(item["name"]);
    }

    function sortDistance(item) {
      return item.routes.reduce(function (acc, value) {
        return acc + value.totalDistance;
      }, 0);
    }

    function sortLoadByType(type) {
      return function sortLoad(item) {
        return item.routes.reduce(function (acc, value) {
          return acc + parseFloat(value["totalLoadPercentage" + type]);
        }, 0);
      };
    }

    function sortDuration(item) {
      return item.routes.reduce(function (acc, value) {
        return acc + moment.duration(value.totalTimeFormatted).asMinutes();
      }, 0);
    }
  }

  var vehicleSortBy = {
    templateUrl: "app/planner/components/vehicleSortBy/vehicleSortBy.html",
    controller: ["naturalService", vehicleSortByController],
    bindings: {
      algorithm: "=",
      desc: "=",
      sortKey: "=",
      totalLoads: "<"
    },
  };
  angular.module("icarus.planner").component("vehicleSortBy", vehicleSortBy);
})();

(function () {
  'use strict';
  angular
  .module('icarus.planner')
  .component('toolSelectionOnMap', {
    templateUrl: 'app/planner/components/toolSelectionOnMap/toolSelectionOnMap.html',
    controller: toolSelectionOnMapController,
    bindings: {
      isCollapsed: '<',
      onCollapse: '&',
      alertData: '<',
      alertCallToAction: '&'
    },
    transclude: true
  });

/** @ngInject */

  function toolSelectionOnMapController () {
    var ctrl = this;
    ctrl.deselectSelection = deselectSelection;

    ctrl.toggleCollapse = function () {
      ctrl.onCollapse();
    };

    function deselectSelection() {
      ctrl.alertData.msg = null;
      ctrl.alertData.load = null;
      ctrl.alertData.load2 = null;
      ctrl.alertData.load3 = null;
      ctrl.alertData.load4 = null;
      ctrl.alertCallToAction();
    }

    ctrl.$onChanges = function(changes) {
      if (changes.alertData && changes.alertData.currentValue) {
        ctrl.msg = changes.alertData.currentValue.msg;
        ctrl.loads = {
          load: changes.alertData.currentValue.load,
          load2: changes.alertData.currentValue.load2,
          load3: changes.alertData.currentValue.load3,
          load4: changes.alertData.currentValue.load4
        };
      }
    };



  }

})();

(function () {
  "use strict";

  angular.module("icarus.planner").config(config);

  /** @ngInject */
  function config($translateProvider) {

    $translateProvider.translations("es", {
      ToolSelectionOnMap: {
          title: "Herramientas",
          hand_drawing_selection_mode: "Selección lazo"
      }
    });

    $translateProvider.translations("en", {
      ToolSelectionOnMap: {
          title: "Tools",
          hand_drawing_selection_mode: "Lasso selection"
      }
    });

    $translateProvider.translations("pt", {
      ToolSelectionOnMap: {
          title: "Ferramentas",
          hand_drawing_selection_mode: "Seleção do laço"
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .component('toastRoutes', {
      controller: toastRoutesController,
      templateUrl: 'app/planner/components/toastRoutes/toastRoutes.html',
      bindings: {
        text: '<',
      }
    });

  /** @ngInject */
  function toastRoutesController(toastService) {
    var ctrl = this;
    var intervalId = null;

    function getToast() {
      return document.querySelector('.toast_routes');
    }

    function getLoading () {
      return document.querySelector('.toast_loading');
    }

    ctrl.close = function () {
      var toastDocument = getToast();
      var loadingDocument = getLoading();
      if (toastDocument) {
        toastDocument.classList.remove('toast_routes_active');
      }
      if (loadingDocument) {
        loadingDocument.classList.remove('toast_loading_active');
      }
      if (intervalId) {
        clearInterval(intervalId);
      }
    };

    ctrl.$onInit = function() {
      intervalId = toastService.toastActivate(getToast(), getLoading(), 'toast_routes_active', 'toast_loading_active', ctrl.close);
    };
  }
})();

(function () {
  "use strict";

  angular.module("icarus.planner").config(config);

  /** @ngInject */
  function config($translateProvider) {

    $translateProvider.translations("es", {
      ToastRoutes: {
        title: 'Información',
        description: 'Recuerda que estás revisando tus planes confirmados, por lo cuál sólo podrás visualizar y eliminar rutas'
      },
    });

    $translateProvider.translations("en", {
      ToastRoutes: {
        title: 'Information',
        description: 'Remember that you are reviewing your confirmed plans, so you will only be able to view and delete routes'
      },
    });

    $translateProvider.translations("pt", {
      ToastRoutes: {
        title: 'Informação',
        description: 'Lembre-se que você está revisando seus planos confirmados, portanto só poderá visualizar e excluir rotas'
      },
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .component('toastFinish', {
      controller: toastFinishController,
      templateUrl: 'app/planner/components/toastFinish/toastFinish.html',
      bindings: {
        text: '<',
      }
    });

  /** @ngInject */
  function toastFinishController(toastService) {
    var ctrl = this;
    var intervalId = null;

    function getToast() {
      return document.querySelector('.toast_finish');
    }

    function getLoading () {
      return document.querySelector('.toast_finish_loading');
    }

    ctrl.close = function () {
      var toastDocument = getToast();
      var loadingDocument = getLoading();
      if (toastDocument) {
        toastDocument.classList.remove('toast_finish_active');
      }
      if (loadingDocument) {
        loadingDocument.classList.remove('toast_finish_loading_active');
      }
      if (intervalId) {
        clearInterval(intervalId);
      }
    };

    ctrl.$onInit = function() {
      intervalId = toastService.toastActivate(getToast(), getLoading(), 'toast_finish_active', 'toast_finish_loading_active', ctrl.close);
    };
  }
})();

(function () {
  "use strict";

  angular.module("icarus.planner").config(config);

  /** @ngInject */
  function config($translateProvider) {

    $translateProvider.translations("es", {
      ToastFinish: {
        info: 'Recuerda, si deseas realizar ediciones más adelante, siempre guárdalo como borrador. Por otro lado, si consideras que la información está lista para ser enviada, márcalo como finalizado, ya que después de esto no podrás realizar más ediciones.'
      }
    });

    $translateProvider.translations("en", {
      ToastFinish: {
        info: 'Remember, if you want to make edits later, always save it as a draft. On the other hand, if you consider that the information is ready to be sent, mark it as finished, since after this you will not be able to make any more edits.'
      }
    });

    $translateProvider.translations("pt", {
      ToastFinish: {
        info: 'Lembre-se, se quiser fazer edições mais tarde, sempre salve-o como rascunho. Por outro lado, se considerar que a informação está pronta para ser enviada, marque-a como finalizada, pois depois disso não poderá mais fazer edições.'
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
    'use strict';

    angular
      .module('icarus.planner')
      .component('skillsSummary', {
        controller: skillsSummaryController,
        templateUrl: 'app/planner/components/skillsSummary/skillsSummary.html',
        bindings: {
            visit: '<'
        }
      });

    /** @ngInject */
    function skillsSummaryController(plannerService) {
        var ctrl = this;
        var MAX_SKILLS_TO_SHOW = 3;


        /**
         * Limits the number of skills displayed in the user interface
         * according to predefined maximum values. When the total number of skills
         * exceeds the specified limits, the function determines whether summaries
         * for required and optional skills should be shown, and adjusts the
         * corresponding variables.
         */
        function limitSkillsToShow() {
            ctrl.limitRequiredSkills =  Math.min(ctrl.requiredSkills.length, MAX_SKILLS_TO_SHOW);
            ctrl.limitOptionalSkills =  Math.min(ctrl.optionalSkills.length, MAX_SKILLS_TO_SHOW);
            ctrl.showRemainingRequired = ctrl.requiredSkills.length > MAX_SKILLS_TO_SHOW;
            ctrl.showRemainingOptional = ctrl.optionalSkills.length > MAX_SKILLS_TO_SHOW;

            if ((ctrl.requiredSkills.length + ctrl.optionalSkills.length) > MAX_SKILLS_TO_SHOW && 
                (ctrl.optionalSkills.length && ctrl.requiredSkills.length)) {
                
                ctrl.limitRequiredSkills = ctrl.optionalSkills.length === 1 ? 2 : 1;
                ctrl.limitOptionalSkills = ctrl.requiredSkills.length === 1 ? 2 : 1;

                ctrl.showRemainingRequired = ctrl.requiredSkills.length >= 2;
                ctrl.showRemainingOptional = ctrl.optionalSkills.length >= 2;
            }
            setRemainingSkill();
        }

        function setRemainingSkill() {
            ctrl.remainingRequiredSkill = ctrl.requiredSkills.slice(ctrl.limitRequiredSkills).map(function (skill) {
                return skill.name;}).join(', ');
            ctrl.remainingOptionalSkill = ctrl.optionalSkills.slice(ctrl.limitOptionalSkills).map(function (skill) {
                return skill.name;}).join(', ');
        }

        ctrl.$onInit = function () {
            ctrl.skillsError = ctrl.visit.skillsError && plannerService.isStepThreeActive();
            var skills = plannerService.getSkills();
            ctrl.requiredSkills = skills.filter(function(skill) {
                return ctrl.visit.skills_required.includes(skill.id);
            });
            ctrl.optionalSkills = skills.filter(function(skill) {
                return ctrl.visit.skills_optional.includes(skill.id);
            });
            limitSkillsToShow();
        };
    }
})();

/* global angular */

/**
 * Usage:
 * <search-bar></search-bar>
 */
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .component('searchBar', {
      controller: searchBarController,
      templateUrl: 'app/planner/components/searchBar/search-bar-template.html',
      bindings: {
        data: '<',
        filters: '<',
        onClick: '=',
        onRemove: '=',
        noResultsFoundText: '<',
        minText: '<',
        placeholder: '<',
        mustReturnAllMatchedResult: '<',
        matchedValue: '<',
        toReset: '&'
      }
    });

  /** @ngInject */
  function searchBarController($filter, $scope, $location, $anchorScroll) {
    var vm = this;
    var MIN_ACTIVATION_LENGTH = 3;
    //keyCodes that triggered in the onkeypress event
    var ESC_KEY = 27;
    var UP_KEY = 38;
    var DOWN_KEY = 40;
    var ENTER_KEY = 13;

    var mapIndexResults = [];
    var $translate = $filter('translate');
    var inputValueBkp = "";

    $scope.matchedValues = [];
    $scope.results = {};
    $scope.inputValue = vm.matchedValue || '';
    $scope.activeOptions = Boolean(vm.matchedValue);
    $scope.resultsFound = false;
    $scope.noResultsFoundText = $translate(vm.noResultsFoundText);
    $scope.minText = $translate(vm.minText);
    $scope.placeholder = $translate(vm.placeholder);
    $scope.filters = this.filters;
    $scope.mustReturnAllMatchedResult = vm.mustReturnAllMatchedResult;

    $scope.listFocusHandler = {
      index: -1,
      indexNomenclature: 0,
      focusIndex: ''
    };

    function search(data, pattern, filters) {
      var matchedValues = [];
      var resultsByFilterCategory = {};

      for (var filter in filters) {
        var result = filters[filter].filter(data, pattern).reduce(function (acc, value) {
          var matchedValue = value[filters[filter].attrShowed];
          if (!acc.hasOwnProperty(matchedValue)) {
            acc[matchedValue] = [];
          }
          acc[matchedValue].push(value);
          matchedValues.push(value);
          return acc;
        }, {});
        if (Object.keys(result).length) {
          resultsByFilterCategory[filter] = result;
        }
      }
      return {
        matchedValues: matchedValues,
        resultsByFilterCategory: resultsByFilterCategory
      };
    }

    $scope.onChangeSearchInput = function () {
      if (inputValueBkp && inputValueBkp != $scope.inputValue) {
        inputValueBkp = "";
        vm.onRemove();
      }
      if ($scope.isPastMinActivationLength()) {
        $scope.activeOptions = true;
        var results = search(vm.data, $scope.inputValue, vm.filters);
        $scope.results = results.resultsByFilterCategory;
        $scope.matchedValues = results.matchedValues;
        $scope.resultsFound = Object.keys($scope.results).length > 0;
        mapIndexResults = mapperIndexOfResults($scope.results);
      } else {
        cleanFilter();
      }
    };

    $scope.isBetweenMinActivationLength = function () {
      return $scope.inputValue.length > 0 && $scope.inputValue.length < MIN_ACTIVATION_LENGTH;
    };

    $scope.isPastMinActivationLength = function () {
      return $scope.inputValue.length >= MIN_ACTIVATION_LENGTH;
    };

    $scope.onFocusSearchInput = function () {
      $scope.onFocus = true;
      if ($scope.isPastMinActivationLength()) {
        $scope.activeOptions = true;
      }
    };

    $scope.onBlurSearchInput = function () {
      if (inputValueBkp) {
        $scope.inputValue = inputValueBkp;
      }
      $scope.onFocus = false;
      $scope.activeOptions = false;
    };

    $scope.onMouseDown = function (values, item, type, mustNotOverrideResults) {
      inputValueBkp = item;
      $scope.inputValue = item;

      if (!mustNotOverrideResults) {
        $scope.results = {};
        $scope.matchedValues = [];
        $scope.results[type] = {};
        $scope.results[type][item] = values;
        mapIndexResults = mapperIndexOfResults($scope.results);
      }

      var result = {
        type: type,
        matchedValue: item,
        elements: values
      };
      vm.onClick(result);
    };

    $scope.removeFilter = function () {
      $scope.inputValue = "";
      inputValueBkp = "";
      cleanFilter();
      vm.onRemove();
    };

    function cleanFilter() {
      $scope.results = {};
      $scope.matchedValues = [];
      $scope.resultsFound = false;
      $scope.activeOptions = false;
    }

    $scope.navigateResults = function (step) {
      var coordinate;
      if (!$scope.activeOptions) {
        return;
      }

      coordinate = nextCoordinate(
        mapIndexResults,
        [
          $scope.listFocusHandler.indexNomenclature,
          $scope.listFocusHandler.index
        ],
        step
      );
      $scope.moveToResultIndex(coordinate);
    };

    $scope.moveToResultIndex = function (coordinate) {
      $scope.listFocusHandler.indexNomenclature = coordinate[0];
      $scope.listFocusHandler.index = coordinate[1];
      $scope.listFocusHandler.focusIndex = $scope.listFocusHandler.indexNomenclature + '-' + $scope.listFocusHandler.index;
      $location.hash($scope.listFocusHandler.focusIndex);
      $anchorScroll();
    };

    $scope.keyHandlers = {};
    $scope.keyHandlers[ESC_KEY] = function (element) {
      $scope.removeFilter();
      $scope.activeOptions = false;
    };
    $scope.keyHandlers[UP_KEY] = function (element) {
      $scope.navigateResults(-1);
    };
    $scope.keyHandlers[DOWN_KEY] = function (element) {
      $scope.navigateResults(1);
    };
    $scope.keyHandlers[ENTER_KEY] = function (element) {
      applyMatchedValues();
      element.blur();
    };

    $scope.onKeyUp = function (event) {
      if ($scope.keyHandlers.hasOwnProperty(event.keyCode)) {
        $scope.keyHandlers[event.keyCode](event.currentTarget);
      }
    };

    function applyMatchedValues() {
      if (!$scope.resultsFound) {
        return;
      }
      var indexes = !$scope.listFocusHandler.focusIndex ? [0, 0] : $scope.listFocusHandler.focusIndex.split("-");
      var indexTypeOfFilter = parseInt(indexes[0]);
      var indexItem = parseInt(indexes[1]);

      var mustNotOverrideResults = false;
      var type = Object.keys($scope.results)[indexTypeOfFilter];
      var items = $scope.results[type];
      var matched, values;

      if ($scope.mustReturnAllMatchedResult && !$scope.listFocusHandler.focusIndex) {
        matched = $scope.inputValue;
        values = $scope.matchedValues;
        mustNotOverrideResults = true;
      } else {
        matched = Object.keys(items)[indexItem];
        values = items[matched];
      }

      if (inputValueBkp !== matched) {
        $scope.onMouseDown(values, matched, type, mustNotOverrideResults);
      }
      $scope.listFocusHandler.focusIndex = '';
    }

    function mapperIndexOfResults(data) {
      return Object.keys(data).map(function (key) {
        return Object.keys(data[key]).length;
      });
    }

    function nextCoordinate(indexesMapped, currentCoordinate, step) {
      var row = currentCoordinate[0];
      var col = currentCoordinate[1];

      col += step;

      if (col < 0) {
        row = --row < 0 ? indexesMapped.length - 1 : row;
        col = indexesMapped[row] - 1;
      }

      if (col > indexesMapped[row] - 1) {
        row = ++row > indexesMapped.length - 1 ? 0 : row;
        col = 0;
      }

      return [row, col];
    }

    $scope.activate = function () {
      if ($scope.inputValue) {
        $scope.onChangeSearchInput();
        applyMatchedValues();
      }
      vm.toReset({reset: $scope.removeFilter});
    };
    $scope.activate();

  }
})();

(function () {
  "use strict";

  angular.module("icarus.planner").config(config);

  /** @ngInject */
  function config($translateProvider) {

    $translateProvider.translations("es", {
      SearchBar: {
        Results: {
          visits: "Visitas",
          title: "Título",
          address: "Dirección",
          vehicles: "Vehículos",
          reference: "Referencias",
        },
        Routes: {
          placeholder: "Buscar por visita, vehículo o referencia",
          minText: "Ingresar al menos 3 letras.",
          noResultsFound: "No se encontraron resultados."
        },
        Visits: {
          placeholder: "Buscar por título, dirección o referencia",
          minText: "Ingresar al menos 3 letras.",
          noResultsFound: "No se encontraron resultados.",
        }
      },
    });

    $translateProvider.translations("en", {
      SearchBar: {
        Results: {
          visits: "Visits",
          title: "Title",
          address: "Address",
          vehicles: "Vehicles",
          reference: "References",
        },
        Routes: {
          placeholder: "Search by visit, vehicle or reference",
          minText: "Please enter at least 3 letters.",
          noResultsFound: "No results found.",
        },
        Visits: {
          placeholder: "Search by title, address or reference",
          minText: "Please enter at least 3 letters",
          noResultsFound: "No results found.",
        }
      },
    });

    $translateProvider.translations("pt", {
      SearchBar: {
        Results: {
          visits: "Visitas",
          title: "Título",
          address: "Endereço",
          vehicles: "Veículos",
          reference: "Referências",
        },
        Routes: {
          placeholder: "Pesquisar por visita, veículo ou referência",
          minText: "Por favor, insira pelo menos 3 letras.",
          noResultsFound: "Nenhum resultado para a sua pesquisa."
        },
        Visits: {
          placeholder: "Persquisar por título, endereço ou referência",
          minText: "Por favor, insira pelo menos 3 letras",
          noResultsFound: "Nenhum resultado para a sua pesquisa.",
        }
      },
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .component("routingSummaryTable", {
      templateUrl: "app/planner/components/routingSummaryTable/routingSummaryTable.html",
      controller: RoutingSummaryTableController,
      bindings: {
        vehicles: '<',
        drivers: '<',
        coDrivers: '<',
        showComments: '<',
        isFieldEditable: '<',
        goToCoDrivers: '&',
        joinSimilar: '<'
      }
    });

  /** @ngInject */
  function RoutingSummaryTableController($filter, routesUtils, plannerService,
                                         accountConfigsService, ACCOUNT_CONFIGS, driverSelectMapper,
                                         addonsService, TMS_ADD_ON_KEY, $rootScope, sortDriversByDocStatusService) {
    var ctrl = this;
    var $translate = $filter("translate");
    ctrl.isTmsEnable = false;
    ctrl.sortedDrivers = [];
    ctrl.driverSelectInfo = {
      drivers: [],
      onClickOption: onChangeDriverSelect
    };

    ctrl.$onInit = function () {
      ctrl.sortedDrivers = sortDriversByDocStatusService.sort(ctrl.drivers || [], 'name');
      ctrl.driverSelectInfo = {
        drivers: driverSelectMapper.formatList(ctrl.sortedDrivers),
        selectedId: null,
        onClickOption: onChangeDriverSelect
      };
      ctrl.isMultiDriversConfigEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_MULTI_DRIVERS);
      ctrl.isCustomRouteNameConfigEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.CUSTOM_ROUTE_NAME);

      if (ctrl.isCustomRouteNameConfigEnabled) {
        _putRouteNamesInComments(ctrl.vehicles);
      }
      addonsService.isAddonEnable(TMS_ADD_ON_KEY).then(function(isTmsEnable) {
        ctrl.isTmsEnable = isTmsEnable;
      });
    };

    ctrl.$onChanges = function (changes) {
      if (changes.drivers && changes.drivers.currentValue) {
        ctrl.sortedDrivers = sortDriversByDocStatusService.sort(changes.drivers.currentValue, 'name');
        ctrl.driverSelectInfo.drivers = driverSelectMapper.formatList(ctrl.sortedDrivers);
      }
      if (ctrl.isCustomRouteNameConfigEnabled && changes.vehicles) {
        var vehicles = changes.vehicles.currentValue || [];
        _putRouteNamesInComments(vehicles);
      }
    };

    ctrl.getRouteName = function (route, routePosition) {
      var defaultRouteName = $translate("RoutingSummaryTable.route") + " " + routePosition;
      if (!ctrl.isCustomRouteNameConfigEnabled) {
        return defaultRouteName;
      }

      return plannerService.getRouteName(route) || defaultRouteName;
    };

    ctrl.onChangeDriverPerRoute = function (vehicle, route) {
      routesUtils.setVehicleDriver(vehicle, route, ctrl.drivers);
      routesUtils.updateSelectedDrivers(ctrl.vehicles, ctrl.drivers);
      ctrl.driverSelectInfo.drivers = driverSelectMapper.formatList(ctrl.drivers || []);
    };

    ctrl.onChangeDriverPerVehicle = function (vehicle) {
      routesUtils.updateVehicleDriver(vehicle, ctrl.drivers);
      routesUtils.updateSelectedDrivers(ctrl.vehicles, ctrl.drivers);
      ctrl.driverSelectInfo.drivers = driverSelectMapper.formatList(ctrl.drivers || []);
    };

    ctrl.checkRouteComments = function (routes) {
      var comment = routes[0].comment;
      routes.forEach(function (route) {
        route.comment = comment;
      });
    };

    ctrl.getVehicleTotalVisits = function (vehicle) {
      return vehicle.routes.reduce(function (totalVisits, route) {
        var routeTotalVisits = ctrl.getRouteTotalVisits(route);
        return totalVisits + routeTotalVisits;
      }, 0);
    };

    ctrl.getVehicleTotalDistance = function (vehicle) {
      return vehicle.routes.reduce(function (totalDistance, route) {
        var routeTotalDistance = ctrl.getRouteTotalDistance(route);
        return totalDistance + Number(routeTotalDistance.toFixed(1));
      }, 0).toFixed(1);
    };

    ctrl.getVehicleTotalTime = function (vehicle) {
      var totalMinutes = 0;
      vehicle.routes.forEach(function (route) {
        var routeTotalTime = ctrl.getRouteTotalTime(route);
        var splitTime = null;
        var splitTimeFirst = routeTotalTime.split(" ");
        if (splitTimeFirst.length > 1) {
          var days = splitTimeFirst[0];
          totalMinutes += ((parseInt(days) * 24) * 60);
          splitTime = splitTimeFirst[1].split(":");
        } else {
          splitTime = splitTimeFirst[0].split(":");
        }

        var hours = splitTime[0];
        var minutes = splitTime[1];
        var timeMinutes = parseInt(hours) * 60 + parseInt(minutes);
        totalMinutes += timeMinutes;
      });

      var minutes = totalMinutes % 60;
      var hours = Math.floor(totalMinutes / 60);
      var totalTimeFormatted = hours + ":" + ("0" + minutes).slice(-2);
      if (hours > 9) {
        return totalTimeFormatted;
      }

      return "0" + totalTimeFormatted;
    };

    ctrl.showCoDrivers = function () {
      return Boolean(ctrl.coDrivers) && ctrl.coDrivers.length > 0;
    };

    ctrl.getRouteTotalVisits = function (route) {
      return route.hasOwnProperty('total_visits') ? route.total_visits : route.visits.length;
    };

    ctrl.getRouteTotalDistance = function (route) {
      if (route.hasOwnProperty('total_distance')) {
        return route.total_distance / 1000;
      }

      return route.totalDistance;
    };

    ctrl.getRouteTotalTime = function (route) {
      if (route.total_duration) {
        return _removeSeconds(route.total_duration);
      }

      return route.totalTime;
    };

    ctrl.hasMultipleRoutes = function (vehicle) {
      return vehicle.routes.length > 1;
    };

    ctrl.getSummaryColumnClass = function () {
      var classMap = {
        'true-true-true':    'summary-complete-stops',
        'true-true-false':   'summary-complete',
        'true-false-true':   'summary-no-co-drivers-stops',
        'true-false-false':  'summary-no-co-drivers',
        'false-true-true':   'summary-no-comments-stops',
        'false-true-false':  'summary-no-comments',
        'false-false-true':  'summary-no-comments-or-co-drivers-stops',
        'false-false-false': 'summary-no-comments-or-co-drivers'
      };

      var key = String(ctrl.showComments) + '-'
              + String(ctrl.showCoDrivers()) + '-'
              + String(Boolean(ctrl.joinSimilar));
      return classMap[key] || '';
    };

    ctrl.getRouteStops = function (route) {
      if (!ctrl.joinSimilar) { return 0; }
      if (route.arrivals) { return route.arrivals.length; }
      var arrivals = plannerService.getTotalArrivalsCached(route.visits, route.id);
      route.arrivals = arrivals;
      return arrivals.length;
    };

    ctrl.getVehicleTotalStops = function (vehicle) {
      return vehicle.routes.reduce(function (total, route) {
        return total + ctrl.getRouteStops(route);
      }, 0);
    };

    ctrl.getInitColumnClass = function () {
      var showCoDrivers = ctrl.showCoDrivers();
      return {
        'start-third-column': showCoDrivers,
        'start-second-column': !showCoDrivers
      };
    };

    function _putRouteNamesInComments(vehicles) {
      vehicles.forEach(function (vehicle) {
        vehicle.routes.forEach(function (route, index) {
          route.comment = ctrl.getRouteName(route, index + 1);
        });
      });
    }

    function _removeSeconds(totalDuration) {
      // It handles edge cases such as '99 23:59:00' or
      // '9 23:59:00' or '23:59:00' or '23:59'
      return totalDuration.replace(/(\d{1,2}:\d{2}):\d{2}$/, '$1');
    }

    function onChangeDriverSelect(selectedId, context) {
      context.route.driver = selectedId;
      ctrl.onChangeDriverPerRoute(context.vehicle, context.route);
      $rootScope.$broadcast('drivers-selected:updated', ctrl.drivers);
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations("es", {
      RoutingSummaryTable: {
        vehicle: "Vehículo",
        driver: "Conductor",
        routes: "Rutas",
        route: "Ruta",
        visits: "Visitas",
        stops: "Paradas",
        time: "Tiempo",
        comment_route: "Comentario",
        total: "Total",
        select_driver: "--- Selecciona un conductor ---",
        co_driver: 'Copiloto'
      }
    });

    $translateProvider.translations("en", {
      RoutingSummaryTable: {
        vehicle: "Vehicle",
        driver: "Driver",
        routes: "Routes",
        route: "Route",
        visits: "Visits",
        stops: "Stops",
        time: "Time",
        comment_route: "Comment",
        total: "Total",
        select_driver: "--- Select a driver ---",
        co_driver: 'Co-driver'
      }
    });

    $translateProvider.translations("pt", {
      RoutingSummaryTable: {
        vehicle: "Veículo",
        driver: "Motorista",
        routes: "Rotas",
        route: "Rota",
        visits: "Visitas",
        stops: "Pontos",
        time: "Tempo",
        comment_route: "Comentario",
        total: "Total",
        select_driver: "--- Selecione um motorista ---",
        co_driver: 'Co-piloto'
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .component('routeMenuDropdown', {
      controller: routeMenuDropdownController,
      templateUrl: 'app/planner/components/routeMenuDropdown/routeMenuDropdown.html',
      bindings: {
        route: '<',
        toggleOptionsMenu: '&',
        markAsRevised: '&',
        reorderRoute: '&',
        goToDeleteRoute: '&',
        reverseRouteOrder: '&',
        prioritizeLoad: '&'
      }
    });

  /** @ngInject */
  function routeMenuDropdownController($state, STATE, plannerService) {
    var ctrl = this;

    ctrl.isRouteProcessed = plannerService.isRouteProcessed(ctrl.route);
    ctrl.isPrioritizeLoadActive = plannerService.isPrioritizeLoadOptionEnabled();

    ctrl.canRouteBeRemoved = function () {
      return plannerService.isRouteEditable(ctrl.route.id);
    };

    ctrl.activeOptions = function () {
      return !$state.includes(STATE.ROUTES);
    };
  }
})();

(function () {
  "use strict";

  angular.module("icarus.planner").component("reorderRoutes", {
    templateUrl: "app/planner/components/reorderRoutes/reorderRoutes.html",
    controller: reorderRoutesController,
    bindings: {
      onClick: "="
    },
  });

  /** @ngInject */
  function reorderRoutesController() {
    var ctrl = this;
    ctrl.buttonAction = ctrl.onClick;
  }
})();

(function () {
  "use strict";

  angular.module("icarus.planner").config(config);

  /** @ngInject */
  function config($translateProvider) {

    $translateProvider.translations("es", {
      ReorderRoutes: {
        route_optimize: "Reoptimizar edición",

      },
    });

    $translateProvider.translations("en", {
      ReorderRoutes: {
        route_optimize: "Reoptimize edition",
      },
    });

    $translateProvider.translations("pt", {
      ReorderRoutes: {
        route_optimize: "Reotimizar ediçao",
      },
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .component('richSelect', {
      bindings: {
        displayData: '<',
        onClick: '&',
        onInterchangeRoute: '&',
        currentSelectedItem: '<'
      },
      templateUrl: 'app/planner/components/richSelect/richSelect.html',
      controller: richSelectController
    });

  /** @ngInject */
  function richSelectController() {
    var ctrl = this;
    var MAX_TAGS = 3;

    ctrl.toggleCollapse = toggleCollapse;
    ctrl.itemSelected = itemSelected;
    ctrl.getVisibleTags = getVisibleTags;
    ctrl.hasMoreTags = hasMoreTags;
    ctrl.getHiddenTags = getHiddenTags;

    function toggleCollapse (category) {
      category.isCollapsed = !category.isCollapsed;
    }

    function itemSelected (item) {
      ctrl.onClick({item:item});
      ctrl.onInterchangeRoute({vehicleId: item.identity});
    }

    function getVisibleTags (tags) {
      return tags.slice(0, MAX_TAGS);
    }

    function hasMoreTags (tags) {
      return tags.length > MAX_TAGS;
    }

    function getHiddenTags(tags) {
      return tags.slice(MAX_TAGS);
    }

  }


})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .component("restTimeCard", {
      templateUrl: "app/planner/components/restTimeCard/restTimeCard.html",
      controller: RestTimeCardController,
      bindings: {
        restTime: "<",
        showDragHandle: "<",
        isEventFromProcessedRoute: "<",
        vehicle: "<"
      }
    });

  /** @ngInject */
  function RestTimeCardController(moment, $filter) {
    var ctrl = this;

    /**
     * Formats extended time (HH:mm with hours >= 24) to display format
     * Normalizes hours >= 24 to wrap around (e.g., 25:13 → 1:13, 24:16 → 0:16)
     * @param {string} timeString - Time in HH:mm format (supports hours >= 24)
     * @returns {string} Formatted time for display
     */
    function formatExtendedTimeForDisplay(timeString) {
      if (!timeString) {
        return "";
      }

      var parts = timeString.split(":");
      if (parts.length !== 2) {
        return timeString;
      }

      var hours = parseInt(parts[0], 10);
      var minutes = parts[1];

      // Normalize hours >= 24 to wrap around (e.g., 25 → 1, 24 → 0)
      var normalizedHours = hours % 24;
      var normalizedTime = normalizedHours + ":" + minutes;

      // Use moment to format consistently with visit times
      var parsed = moment(normalizedTime, "H:mm");
      return parsed.isValid() ? parsed.format("LT") : timeString;
    }

    ctrl.$onInit = function () {
      ctrl.restTimeArrival = formatExtendedTimeForDisplay(ctrl.restTime.arrival);
      ctrl.restTimeDeparture = formatExtendedTimeForDisplay(ctrl.restTime.departure);

      ctrl.vehicleRestTimeStart = ctrl.vehicle.restTimeStart ? moment(ctrl.vehicle.restTimeStart, "HH:mm").format("LT") : "";
      ctrl.vehicleRestTimeEnd = ctrl.vehicle.restTimeEnd ? moment(ctrl.vehicle.restTimeEnd, "HH:mm").format("LT") : "";

      ctrl.alertTooltip = $filter("translate")("RestTimeCard.alert", {
        vehicleRestTimeStart: ctrl.vehicleRestTimeStart,
        vehicleRestTimeEnd: ctrl.vehicleRestTimeEnd
      });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .config(config);

  /** @ngInject */
  function config($translateProvider) {

    $translateProvider.translations("es", {
      RestTimeCard: {
        title: "Hora de descanso",
        to: "a",
        alert: "Hora de descanso fuera de la ventana horaria definida ({{vehicleRestTimeStart}} a {{vehicleRestTimeEnd}})."
      }
    });

    $translateProvider.translations("en", {
      RestTimeCard: {
        title: "Break time",
        to: "to",
        alert: "Break time outside the defined time window ({{vehicleRestTimeStart}} to {{vehicleRestTimeEnd}})."
      }
    });

    $translateProvider.translations("pt", {
      RestTimeCard: {
        title: "Hora de descanso",
        to: "às",
        alert: "Horário de pausa fora da janela de tempo definida ({{vehicleRestTimeStart}} às {{vehicleRestTimeEnd}})."
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .component('rdMigrationBanner', {
      controller: rdMigrationBannerController,
      templateUrl: 'app/planner/components/rdMigrationBanner/rdMigrationBanner.html'
    });

  /** @ngInject */
  function rdMigrationBannerController($scope, $interval, $window, $log, $filter,
                                       sessionService, apolloAuthService,
                                       moduleHelpersService, ngDialog,
                                       rdMigrationOptinService) {
    var ctrl = this;
    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_DAY = 24 * MS_PER_HOUR;
    var WHATS_NEW_URL = 'https://simpliroute.com/es/novedades/nuevo-routedesigner';

    var tickPromise = null;

    ctrl.ready = false;
    ctrl.collapsed = false;
    ctrl.state = 'urgency';
    ctrl.countdown = { days: 0, hours: 0, minutes: 0, seconds: 0 };
    ctrl.deadlineDate = null;
    ctrl.whatsNewUrl = WHATS_NEW_URL;
    ctrl.user = null;

    ctrl.toggleCollapsed = toggleCollapsed;
    ctrl.openOptInModal = openOptInModal;
    ctrl.pad = pad;

    ctrl.$onInit = function () {
      var currentUser = null;
      sessionService.getUser()
        .then(function (user) {
          if (!user || !rdMigrationOptinService.canOptIn(user)) {
            return false;
          }
          currentUser = user;
          return rdMigrationOptinService.isBannerEnabled();
        })
        .then(function (enabled) {
          if (!enabled) return null;
          ctrl.user = currentUser;
          return rdMigrationOptinService.getDeadline();
        })
        .then(function (deadlineIso) {
          if (!deadlineIso) return;
          var deadline = new Date(deadlineIso);
          if (isNaN(deadline.getTime())) return;
          ctrl.deadlineDate = deadline;
          _refreshState();
          ctrl.ready = true;
        })
        .catch(function (err) {
          $log.warn('rdMigrationBanner: init failed', err);
        });
    };

    ctrl.$onDestroy = function () {
      _stopTick();
    };

    function pad(n) {
      var num = n || 0;
      return num < 10 ? '0' + num : String(num);
    }

    function toggleCollapsed() {
      ctrl.collapsed = !ctrl.collapsed;
    }

    function openOptInModal() {
      var modalScope = $scope.$new(true);
      modalScope.loading = false;
      modalScope.errorKey = null;
      modalScope.deadlineFormatted = $filter('date')(ctrl.deadlineDate, 'longDate', 'UTC');

      var dialog = ngDialog.open({
        template: 'app/planner/components/rdMigrationBanner/rdMigrationBanner.modal.html',
        className: 'ngdialog-theme-default sp-rd-migration-dialog',
        scope: modalScope,
        closeByEscape: true,
        closeByDocument: true,
        showClose: false
      });

      modalScope.cancel = function () {
        if (modalScope.loading) return;
        dialog.close();
      };

      modalScope.confirm = function () {
        if (modalScope.loading) return;
        modalScope.loading = true;
        modalScope.errorKey = null;

        rdMigrationOptinService.optIn()
          .then(function () {
            dialog.close();
            _redirectToApollo();
          })
          .catch(function (err) {
            $log.warn('rdMigrationBanner: optIn failed', err);
            modalScope.loading = false;
            modalScope.errorKey = 'RdMigrationBanner.modal_error';
          });
      };
    }

    function _redirectToApollo() {
      var currentLanguage = moduleHelpersService.getCurrentLanguage();
      $window.location.href = apolloAuthService.buildRedirectURL(currentLanguage + '/pathfinder/planner');
    }

    function _refreshState() {
      var msLeft = Math.max(0, ctrl.deadlineDate.getTime() - Date.now());
      var isCritical = msLeft <= MS_PER_DAY;
      ctrl.state = isCritical ? 'critical' : 'urgency';

      if (isCritical) {
        _updateCountdown(msLeft);
        _startTick();
      } else {
        _updateCountdown(msLeft);
        _stopTick();
      }
    }

    function _updateCountdown(msLeft) {
      ctrl.countdown.days = Math.floor(msLeft / MS_PER_DAY);
      ctrl.countdown.hours = Math.floor((msLeft % MS_PER_DAY) / MS_PER_HOUR);
      ctrl.countdown.minutes = Math.floor((msLeft % MS_PER_HOUR) / MS_PER_MINUTE);
      ctrl.countdown.seconds = Math.floor((msLeft % MS_PER_MINUTE) / MS_PER_SECOND);
    }

    function _startTick() {
      if (tickPromise) return;
      tickPromise = $interval(function () {
        var msLeft = Math.max(0, ctrl.deadlineDate.getTime() - Date.now());
        _updateCountdown(msLeft);
      }, MS_PER_SECOND);
    }

    function _stopTick() {
      if (tickPromise) {
        $interval.cancel(tickPromise);
        tickPromise = null;
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('icarus.planner').config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations('es', {
      RdMigrationBanner: {
        urgency_title: 'Quedan {{N}} días para migrar a la nueva versión de Route Designer.',
        urgency_body_prefix: 'El ',
        urgency_body_suffix: ' será obligatorio para todos, así que te recomendamos probarlo hoy para llegar sin apuros.',
        critical_title: 'Hoy es el último día de la versión anterior de Route Designer.',
        critical_body: 'Mañana el nuevo RD será obligatorio para todos. Empieza a usarlo hoy para llegar con ventaja.',
        whats_new: 'Ver qué hay de nuevo',
        cta_try: 'Probar nuevo Route Designer',
        cta_go: 'Ir al nuevo Route Designer',
        days: 'Días',
        hours: 'Horas',
        minutes: 'Min',
        seconds: 'Seg',
        collapse: 'Colapsar',
        expand: 'Expandir',
        modal_title: 'Activar la nueva versión de Route Designer',
        modal_body_p1_prefix: 'Vas a cambiar a la ',
        modal_body_p1_highlight: 'nueva versión de Route Designer',
        modal_body_p1_middle: '. Podrás volver a la versión anterior cuando quieras hasta el ',
        modal_body_p1_suffix: '.',
        modal_body_p2: 'Tu configuración actual, planes y visitas no se verán afectados por el cambio de versión.',
        modal_cancel: 'Cancelar',
        modal_confirm: 'Ir al nuevo Route Designer',
        modal_loading: 'Activando…',
        modal_error: 'No pudimos activar el nuevo Route Designer. Intentá de nuevo.'
      }
    });

    $translateProvider.translations('en', {
      RdMigrationBanner: {
        urgency_title: '{{N}} days left to migrate to the new Route Designer.',
        urgency_body_prefix: 'Starting ',
        urgency_body_suffix: ' it will be required for everyone — we recommend trying it today to get ahead.',
        critical_title: 'Today is the last day of the previous Route Designer.',
        critical_body: 'Tomorrow the new RD will be required for everyone. Start using it today to get ahead.',
        whats_new: 'See what\'s new',
        cta_try: 'Try new Route Designer',
        cta_go: 'Go to the new Route Designer now',
        days: 'Days',
        hours: 'Hours',
        minutes: 'Min',
        seconds: 'Sec',
        collapse: 'Collapse',
        expand: 'Expand',
        modal_title: 'Activate the new Route Designer',
        modal_body_p1_prefix: 'You\'re about to switch to the ',
        modal_body_p1_highlight: 'new version of Route Designer',
        modal_body_p1_middle: '. You can go back to the previous version anytime until ',
        modal_body_p1_suffix: '.',
        modal_body_p2: 'Your current settings, plans, and visits will not be affected by the version change.',
        modal_cancel: 'Cancel',
        modal_confirm: 'Go to the new Route Designer',
        modal_loading: 'Activating…',
        modal_error: 'We couldn\'t activate the new Route Designer. Please try again.'
      }
    });

    $translateProvider.translations('pt', {
      RdMigrationBanner: {
        urgency_title: 'Faltam {{N}} dias para migrar para o novo Route Designer.',
        urgency_body_prefix: 'A partir de ',
        urgency_body_suffix: ' será obrigatório para todos. Recomendamos experimentá-lo hoje para chegar preparado.',
        critical_title: 'Hoje é o último dia do Route Designer anterior.',
        critical_body: 'Amanhã o novo RD será obrigatório para todos. Comece a usá-lo hoje para sair na frente.',
        whats_new: 'Ver o que há de novo',
        cta_try: 'Experimentar novo Route Designer',
        cta_go: 'Ir para o novo Route Designer agora',
        days: 'Dias',
        hours: 'Horas',
        minutes: 'Min',
        seconds: 'Seg',
        collapse: 'Recolher',
        expand: 'Expandir',
        modal_title: 'Ativar a nova versão do Route Designer',
        modal_body_p1_prefix: 'Você vai mudar para a ',
        modal_body_p1_highlight: 'nova versão do Route Designer',
        modal_body_p1_middle: '. Você poderá voltar à versão anterior quando quiser, até ',
        modal_body_p1_suffix: '.',
        modal_body_p2: 'Sua configuração atual, planos e visitas não serão afetados pela mudança de versão.',
        modal_cancel: 'Cancelar',
        modal_confirm: 'Ir para o novo Route Designer',
        modal_loading: 'Ativando…',
        modal_error: 'Não foi possível ativar o novo Route Designer. Tente novamente.'
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  'use strict';

  function multipleSelectionOnMapController (googleService, $scope) {
    var ctrl = this;
    ctrl.drawingManager = null;
    ctrl.isPolygonalSelectionModeActivated = false;
    ctrl.isHandDrawingSelectionModeActivated = false;

    ctrl.enterOnMultipleEditingMode = enterOnMultipleEditingMode;
    ctrl.exitMultipleEditingMode = exitMultipleEditingMode;
    ctrl.initDrawingPolygon = initDrawingPolygon;
    ctrl.clearDrawingManager = clearDrawingManager;
    ctrl.deselectSelection = deselectSelection;
    ctrl.isCollapsed = !ctrl.defaultPolygonOption;
    ctrl.updateMoveToMode = updateMoveToMode;
    ctrl.previouslyPolygonalModeActivated = false;
    ctrl.previouslyHandDrawingModeActivated = false;
    ctrl.isSingleSelectModeActivated = isSingleSelectModeActivated;
    ctrl.initHandDrawing = initHandDrawing;
    ctrl.clearHandDrawing = clearHandDrawing;
    ctrl.clearDrawing = clearDrawing;


    $scope.$on('Planner:MSOMC:CLEAR_DRAWING_MANAGER', exitMultipleEditingMode);

    function enterOnMultipleEditingMode() {
      ctrl.onEnterOnMode();
      ctrl.isCollapsed = false;
      if (ctrl.defaultPolygonOption) {
        ctrl.initDrawingPolygon();
      }
    }

    function exitMultipleEditingMode() {
      ctrl.clearDrawing();
      ctrl.onExitMode();
      ctrl.isCollapsed = true;
    }

    function initDrawingPolygon() {
      if (!ctrl.drawingManager) {
        ctrl.onMoveToMode({status: false});
        ctrl.clearHandDrawing();
        ctrl.isPolygonalSelectionModeActivated = true;
        ctrl.drawingManager = setDrawing(ctrl.map);
        googleService.listenerLimitDrawingPolygon(ctrl.drawingManager, onSelectionCompleted);
      }
    }

    function setDrawing(map) {
      var drawingManager;
      var drawingOptions = getDrawingOptions();
      drawingManager = googleService.createDrawing(map, drawingOptions.modesOptions, drawingOptions.drawingModes,
        drawingOptions.drawingModeInit, drawingOptions.drawingShowControl);

      return drawingManager;
    }

    function initHandDrawing() {
      if (!ctrl.isHandDrawingSelectionModeActivated) {
        ctrl.onMoveToMode({status: false});
        ctrl.clearDrawingManager();
        ctrl.isHandDrawingSelectionModeActivated = true;
        setDefaultCursorOnMap();
        googleService.createHandDrawing(ctrl.map, ctrl.onMultipleSelectionCompleted);
      }
    }

    function clearHandDrawing() {
      ctrl.isHandDrawingSelectionModeActivated = false;
      googleService.clearListenerHandDrawing(ctrl.map);
      setInitialCursorOnMap();
    } 

    function clearDrawingManager() {
      ctrl.isPolygonalSelectionModeActivated = false;
      if (ctrl.drawingManager) {
        ctrl.drawingManager.setMap(null);
      }
      ctrl.drawingManager = null;
      googleService.clearListenerLimitDrawingPolygon(ctrl.map);
    }

    function clearDrawing() {
      ctrl.clearDrawingManager();
      ctrl.clearHandDrawing();
    }

    function getDrawingOptions() {
      var modesOptions = {
        polygonOptions: {
          fillColor: '#000000',
          fillOpacity: 1,
          strokeWeight: 2,
          strokeOpacity: 0,
          clickable: false,
          editable: false,
          draggable: false,
          zIndex: 1
        }
      };

      var drawingModes = ['polygon'];

      var drawingModeInit = googleService.overlayTypePolygon();

      var drawingControl = false;

      return {
        modesOptions: modesOptions,
        drawingModes: drawingModes,
        drawingModeInit: drawingModeInit,
        drawingShowControl: drawingControl
      };
    }

    function onSelectionCompleted(polygon) {
      var polygonObj = googleService.createPolygon({path: polygon.getPath()});
      polygon.setMap(null);
      ctrl.onMultipleSelectionCompleted({polygon: polygonObj});
    }

    function deselectSelection() {
      ctrl.alertData.msg = null;
      ctrl.alertCallToAction();
    }

    function updateMoveToMode(isOnMoveTo) {
      ctrl.previouslyPolygonalModeActivated = isOnMoveTo ? ctrl.isPolygonalSelectionModeActivated : false;
      ctrl.previouslyHandDrawingModeActivated = isOnMoveTo ? ctrl.isHandDrawingSelectionModeActivated : false;
      ctrl.onMoveToMode({status: isOnMoveTo});
      ctrl.clearDrawing();
      if (!isOnMoveTo) {
        setDefaultCursorOnMap();
      }
    }

    function isSingleSelectModeActivated() {
      return (
        !ctrl.isPolygonalSelectionModeActivated &&
        !ctrl.isHandDrawingSelectionModeActivated &&
        !ctrl.isMoveToModeActivated
      );
    }

    function setDefaultCursorOnMap() {
      ctrl.map.setOptions({
        draggableCursor: "default"
      });
    }

    function setInitialCursorOnMap() {
      ctrl.map.setOptions({
        draggableCursor: ""
      });
    }

    ctrl.$onChanges = function (obj) {
      if (ctrl.defaultPolygonOption && obj.showIf && obj.showIf.currentValue){
        ctrl.enterOnMultipleEditingMode();
      }

      if (ctrl.previouslyPolygonalModeActivated && !ctrl.isMoveToModeActivated) {
        ctrl.previouslyPolygonalModeActivated = false;
        ctrl.initDrawingPolygon();
      }

      if (ctrl.previouslyHandDrawingModeActivated && !ctrl.isMoveToModeActivated) {
        ctrl.previouslyHandDrawingModeActivated = false;
        ctrl.initHandDrawing();
      }

      if (obj.map) {
        ctrl.map = obj.map.currentValue;
      } else if (obj.alertData) {
        ctrl.alertData = obj.alertData.currentValue;
      }
    };

    ctrl.$onDestroy = function () {
      ctrl.clearDrawing();
      ctrl.onExitMode();
    };

  }

  var multipleSelectionOnMap = {
    templateUrl: 'app/planner/components/multipleSelectionOnMap/multipleSelectionOnMap.html',
    controller: ['googleService', '$scope', multipleSelectionOnMapController],
    bindings: {
      map: '<',
      showIf: '<',
      onMultipleSelectionCompleted: '&',
      onEnterOnMode: '&',
      onExitMode: '&',
      alertData: '<',
      alertCallToAction: '&',
      defaultPolygonOption: '<',
      pickupAndDeliveryMode: '<',
      isMoveToModeActivated: '<',
      onMoveToMode: '&'
    }
  };

  angular
    .module('icarus.planner')
    .component('multipleSelectionOnMap', multipleSelectionOnMap);

})();

(function () {
    "use strict";
  
    angular.module("icarus.planner").config(config);
  
    /** @ngInject */
    function config($translateProvider) {
  
      $translateProvider.translations("es", {
        MultipleSelectionOnMap: {
            title: "Herramientas",
            single_select_mode: "Selección unitaria",
            polygonal_selection_mode: "Selección poligonal",
            hand_drawing_selection_mode: "Selección lazo",
            move_to_mode: "Mover a"
        }
      });
  
      $translateProvider.translations("en", {
        MultipleSelectionOnMap: {
            title: "Tools",
            single_select_mode: "Single select",
            polygonal_selection_mode: "Polygonal selection",
            hand_drawing_selection_mode: "Lasso selection",
            move_to_mode: "Move to"
        }
      });
  
      $translateProvider.translations("pt", {
        MultipleSelectionOnMap: {
            title: "Ferramentas",
            single_select_mode: "Seleção única",
            polygonal_selection_mode: "Seleção poligonal",
            hand_drawing_selection_mode: "Seleção do laço",
            move_to_mode: "Mover para"
        }
      });
  
      $translateProvider.determinePreferredLanguage();
    }
  })();
  
(function () {
    'use strict';

    angular
      .module('icarus.planner')
      .component('progressBar', {
        controller: progressBarController,
        templateUrl: 'app/planner/components/progressBar/progressBar.html',
        bindings: {
            usedCapacity: '<',
            availableCapacity: '<',
            typeLoad: '<',
            updateOverloads: '&'
        }
      });

    /** @ngInject */
    function progressBarController(routeHelperService) {
        var ctrl = this;
        var MAX_PERCENTAGE = 100;
        var DECIMAL_PLACES = 2;

        ctrl.usedCapacity = this.usedCapacity;
        ctrl.availableCapacity = this.availableCapacity;
        ctrl.percentageOfCapacityUsed = 0;
        ctrl.typeLoad = this.typeLoad;
        ctrl.overload = false;
        ctrl.iconUrl = {
            load_1 : '/assets/images/weight/weight_filled_16.svg',
            load_2 : '/assets/images/volume/volume_filled_16.svg',
            load_3 : '/assets/images/money/money_filled_16.svg',
            load_4 : '/assets/images/box_filled.svg'
        };

        function _updatePercentageOfCapacityUsed(previousOverload){
            ctrl.percentageOfCapacityUsed = Math.ceil((ctrl.usedCapacity / ctrl.availableCapacity) * 100);
            _updateOverload(previousOverload);
        }

        function _updateOverload(previousOverload) {
            ctrl.overload = ctrl.percentageOfCapacityUsed > MAX_PERCENTAGE;
            if((previousOverload && !ctrl.overload) || ctrl.overload){
                ctrl.updateOverloads({typeLoad: ctrl.typeLoad, load: Number(ctrl.overload)});
            }
        }

        ctrl.$onInit = function () {
            _updatePercentageOfCapacityUsed();
        };

        ctrl.$onChanges = function () {
            _updatePercentageOfCapacityUsed(ctrl.overload);
        };

        ctrl.$onDestroy = function () {
            ctrl.updateOverloads({typeLoad: ctrl.typeLoad, load: 0});
        };

        ctrl.round = function (load) {
            return routeHelperService.round(load, DECIMAL_PLACES);
        };
    }
  })();

(function () {
    "use strict";
    angular.module("icarus.planner").config(config);
    /** @ngInject */
    function config($translateProvider) {
      $translateProvider.translations("es", {
        progressBar: {
            load_1: "Carga 1",
            load_2: "Carga 2",
            load_3: "Carga 3",
            load_4: "Carga 4"
        }
      });
      $translateProvider.translations("en", {
        progressBar: {
            load_1: "Load 1",
            load_2: "Load 2",
            load_3: "Load 3",
            load_4: "Load 4"
        }
      });
      $translateProvider.translations("pt", {
        progressBar: {
            load_1: "Carga 1",
            load_2: "Carga 2",
            load_3: "Carga 3",
            load_4: "Carga 4"
        }
      });
      $translateProvider.determinePreferredLanguage();
    }
  })();

(function () {
    "use strict";

    angular
      .module("icarus.planner")
      .component("polylineContextMenu", {
        controller: PolylineContextMenuController,
        templateUrl: "app/planner/components/polylineContextMenu/polylineContextMenu.html",
        bindings: {
          moveVisitsToRoute: "<",
          contextMenu: '<',
        }
      });
      /** @ngInject */
      function PolylineContextMenuController (revisedRoutesService) {
        var ctrl = this;
        ctrl.isRouteRevised = revisedRoutesService.isRouteRevised;
      };
  })();

(function () {
    "use strict";

    angular
      .module("icarus.planner")
      .config(config);
  
    /** @ngInject */
    function config($translateProvider) {
      $translateProvider.translations("es", {
        PolylineContextMenu: {
          move_here_option: "Mover a"
        }
      });

      $translateProvider.translations("en", {
        PolylineContextMenu: {
          move_here_option: "Move to"
        }
      });

      $translateProvider.translations("pt", {
        PolylineContextMenu: {
          move_here_option: "Mudar para"
        }
      });

      $translateProvider.determinePreferredLanguage();
    }
  })();
  
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .component('optimizationResultsDropdown', {
      controller: optimizationResultsDropdownController,
      templateUrl: 'app/planner/components/optimizationResultsDropdown/optimizationResultsDropdown.html',
      bindings: {
        optimizationResultsOptions: '<',
        updateOptimizationResult: '&'
      }
    });

  /** @ngInject */
  function optimizationResultsDropdownController($translate) {
    var ctrl = this;
    ctrl.isCollapsed = true;

    ctrl.$onInit = function () {
      setCurrentOptimizationId();
    };

    ctrl.$onChanges = function () {
      setCurrentOptimizationId();
    };

    ctrl.getTypeLabel = function (type) {
      return translateOrFallback('OptimizationResults.types.', type);
    };

    ctrl.getTypeDescription = function (type) {
      return translateOrFallback('OptimizationResults.descriptions.', type);
    };

    ctrl.selectOptimizationAlternative = function(optimizationId) {
      ctrl.optimizationResultsOptions.forEach(function (optimization) {
        optimization.isCurrentOptimization = optimization.problem_id === optimizationId;
      });
      setCurrentOptimizationId();
      ctrl.updateOptimizationResult({optimizationId: optimizationId});
    };

    function setCurrentOptimizationId() {
      ctrl.currentOptimizationOption = ctrl.optimizationResultsOptions.find(function (optimization) {
        return optimization.isCurrentOptimization;
      });
    }

    // Si el backend agrega una variante cuyo nombre/descripción aún no existe
    // en las traducciones de este proyecto, $translate.instant devuelve la
    // propia clave. En ese caso usamos una traducción de fallback genérica.
    function translateOrFallback(prefix, type) {
      var key = prefix + type;
      var translation = $translate.instant(key);
      return translation === key ? $translate.instant(prefix + 'fallback') : translation;
    }
  }
})();

(function () {
  "use strict";

  angular.module("icarus.planner").config(config);

  /** @ngInject */
  function config($translateProvider) {

    $translateProvider.translations("es", {
      OptimizationResults: {
          title: "Estás viendo la opción",
          fleet: "{{qty}}% de tu flota",
          load_1: "{{qty}}% carga promedio",
          out_of_route: "{{qty}} fuera de ruta",
          types: {
            original: "Original",
            simplify: "Simplificada",
            load_balance_switched: "Balance de carga",
            time_balance_switched: "Balance de tiempo",
            min_load_switched: "Carga mínima",
            min_load_and_load_balance_switched: "Carga mínima y balance",
            open_routes_logic_switched: "Rutas abiertas",
            radial_routing_switched: "Ruteo radial",
            euclidean_distance_switched: "Distancia euclidiana",
            coverage_variant: "Cobertura",
            historical_adjustments: "Ajustes históricos",
            fallback: "Nueva variante"
          },
          descriptions: {
            fallback: "Variante de optimización aún no disponible en esta versión de la aplicación.",
            original: "Solución generada con la configuración exacta enviada.",
            simplify: "Genera rutas geográficamente más compactas y ordenadas.",
            load_balance_switched: "Activa o desactiva la configuración de balanceo de carga.",
            time_balance_switched: "Activa o desactiva la configuración de balanceo de tiempo.",
            min_load_switched: "Activa o desactiva la exigencia de ocupación mínima por vehículo.",
            min_load_and_load_balance_switched: "Activa o desactiva simultáneamente la ocupación mínima por vehículo y el balanceo de carga.",
            open_routes_logic_switched: "Activa o desactiva la lógica de fin de ruta.",
            radial_routing_switched: "Activa o desactiva el patrón radial de las visitas.",
            euclidean_distance_switched: "Activa o desactiva el tipo de distancia usado para optimizar.",
            coverage_variant: "Prioriza insertar todas las visitas pendientes por sobre cualquier otra restricción. Relaja las limitaciones del problema.",
            historical_adjustments: "Relaja las limitaciones del problema basándose en el comportamiento histórico de las restricciones rotas."
          }
      }
    });

    $translateProvider.translations("en", {
      OptimizationResults: {
          title: "You’re looking at option",
          fleet: "{{qty}}% of your fleet",
          load_1: "{{qty}}% average load",
          out_of_route: "{{qty}} out of route",
          types: {
            original: "Original",
            simplify: "Simplified",
            load_balance_switched: "Load balance",
            time_balance_switched: "Time balance",
            min_load_switched: "Min load",
            min_load_and_load_balance_switched: "Min load & balance",
            open_routes_logic_switched: "Open routes",
            radial_routing_switched: "Radial routing",
            euclidean_distance_switched: "Euclidean distance",
            coverage_variant: "Coverage",
            historical_adjustments: "Historical adjustments",
            fallback: "New variant"
          },
          descriptions: {
            fallback: "Optimization variant not yet available in this version of the app.",
            original: "Solution generated with the exact configuration submitted.",
            simplify: "Generates geographically more compact and orderly routes.",
            load_balance_switched: "Toggles the load balancing configuration.",
            time_balance_switched: "Toggles the time balancing configuration.",
            min_load_switched: "Toggles the minimum vehicle occupancy requirement.",
            min_load_and_load_balance_switched: "Simultaneously toggles the minimum vehicle occupancy and load balancing.",
            open_routes_logic_switched: "Toggles the route-end logic.",
            radial_routing_switched: "Toggles the radial pattern of visits.",
            euclidean_distance_switched: "Toggles the type of distance used to optimize.",
            coverage_variant: "Prioritizes inserting all pending visits above any other constraint. Relaxes problem limitations.",
            historical_adjustments: "Relaxes problem limitations based on historical behavior of broken constraints."
          }
      }
    });

    $translateProvider.translations("pt", {
      OptimizationResults: {
          title: "Você está vendo a opção",
          fleet: "{{qty}}% da sua frota",
          load_1: "{{qty}}% carga média",
          out_of_route: "{{qty}} fora da rota",
          types: {
            original: "Original",
            simplify: "Simplificada",
            load_balance_switched: "Balanceamento de carga",
            time_balance_switched: "Balanceamento de tempo",
            min_load_switched: "Carga mínima",
            min_load_and_load_balance_switched: "Carga mínima e balanceamento",
            open_routes_logic_switched: "Rotas abertas",
            radial_routing_switched: "Roteamento radial",
            euclidean_distance_switched: "Distância euclidiana",
            coverage_variant: "Cobertura",
            historical_adjustments: "Ajustes históricos",
            fallback: "Nova variante"
          },
          descriptions: {
            fallback: "Variante de otimização ainda não disponível nesta versão do aplicativo.",
            original: "Solução gerada com a configuração exata enviada.",
            simplify: "Gera rotas geograficamente mais compactas e ordenadas.",
            load_balance_switched: "Ativa ou desativa a configuração de balanceamento de carga.",
            time_balance_switched: "Ativa ou desativa a configuração de balanceamento de tempo.",
            min_load_switched: "Ativa ou desativa a exigência de ocupação mínima por veículo.",
            min_load_and_load_balance_switched: "Ativa ou desativa simultaneamente a ocupação mínima por veículo e o balanceamento de carga.",
            open_routes_logic_switched: "Ativa ou desativa a lógica de fim de rota.",
            radial_routing_switched: "Ativa ou desativa o padrão radial das visitas.",
            euclidean_distance_switched: "Ativa ou desativa o tipo de distância usado para otimizar.",
            coverage_variant: "Prioriza inserir todas as visitas pendentes acima de qualquer outra restrição. Relaxa as limitações do problema.",
            historical_adjustments: "Relaxa as limitações do problema com base no comportamento histórico de restrições quebradas."
          }
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
    'use strict';

    angular
      .module('icarus.planner')
      .component('itemsTable', {
        controller: itemsTableController,
        templateUrl: 'app/planner/components/itemsTable/itemsTable.html',
        bindings: {
            items: '<',
            onDelete: '&',
            onAdd: '&',
            onChange: '&'
        }
      });

    /** @ngInject */
    function itemsTableController(naturalService, $filter, $scope, PAGINATION_OF_VISIT_ITEMS, ITEM_PROPERTIES, $timeout) {
        var ctrl = this;
        var MIN_INPUT_HEIGHT = 35;
        ctrl.ITEM_PROPERTIES = ITEM_PROPERTIES;
        ctrl.orderProperty = ITEM_PROPERTIES.TITLE;
        ctrl.pagination = PAGINATION_OF_VISIT_ITEMS;
        ctrl.editingItemProperty = null;
        ctrl.editingItemId = null;
        ctrl.itemSortDesc = false;
        ctrl.itemsCurrentPage = [];
        ctrl.sortedItems = [];
        ctrl.areAllItemsSelected = false;
        ctrl.isAnyItemSelected = false;

        ctrl.sortItemsBy = sortItemsBy;
        ctrl.isEditingItemProperty = isEditingItemProperty;
        ctrl.activateEditMode = activateEditMode;
        ctrl.adjustElementHeight = adjustElementHeight;
        ctrl.handleChanges = handleChanges;
        ctrl.getItemsPerPage = getItemsPerPage;
        ctrl.toggleAllItems = toggleAllItems;
        ctrl.updateSelectionStatus = updateSelectionStatus;
        ctrl.exitEditMode = exitEditMode;
        ctrl.deleteItems = deleteItems;

        function getItemsPerPage() {
            var startIndex = (ctrl.pagination.CURRENT_PAGE - 1) * ctrl.pagination.ITEMS_PER_PAGE;
            var endIndex = ctrl.pagination.CURRENT_PAGE * ctrl.pagination.ITEMS_PER_PAGE;
            ctrl.itemsCurrentPage = ctrl.sortedItems.slice(startIndex, endIndex);
        }

        function naturalSort(field) {
            return function (item) {
                return naturalService.naturalValue(item[field]);
            };
        }

        function sortItemsBy(property, isDescendingOrder) {
            ctrl.itemSortDesc = isDescendingOrder;
            ctrl.sortedItems = $filter('orderBy')(
                ctrl.items,naturalSort(property), ctrl.itemSortDesc);
            getItemsPerPage();
        }

        function isEditingItemProperty(property, itemId) {
            return ctrl.editingItemProperty === property && ctrl.editingItemId === itemId;
        }

        function activateEditMode(property, itemId) {
            ctrl.editingItemProperty = property;
            ctrl.editingItemId = itemId;
            var element = document.getElementById('item-'+property+'-'+itemId);
            $timeout(function () {
                element.focus();
            });
        }

        function adjustElementHeight(event) {
            var element = event.target;
            element.style.height = (element.scrollHeight > MIN_INPUT_HEIGHT)
                                    ? element.scrollHeight+"px" : MIN_INPUT_HEIGHT+"px";
        }

        function handleChanges() {
            ctrl.onChange({itemFormValidationStatus: ctrl.itemForm.$invalid});
            exitEditMode();
        }

        function exitEditMode() {
            ctrl.editingItemId = null;
            ctrl.editingItemProperty = null;
        }

        function toggleAllItems() {
            ctrl.isAnyItemSelected = ctrl.areAllItemsSelected;
            ctrl.itemsCurrentPage.forEach(function (item) {
                item.selected = ctrl.areAllItemsSelected;
            });
        }

        function updateSelectionStatus() {
            ctrl.isAnyItemSelected = ctrl.itemsCurrentPage.some(function (item) {
                return item.selected;
            });

            ctrl.areAllItemsSelected = ctrl.itemsCurrentPage.every(function (item) {
                return item.selected;
            });
        }

        ctrl.$onInit = function () {
            sortItemsBy(ITEM_PROPERTIES.TITLE, ctrl.itemSortDesc);
        };

        function deleteItems() {
            ctrl.onDelete();
            ctrl.isAnyItemSelected = false;
            ctrl.areAllItemsSelected = false;
        }
        $scope.$watchCollection(function () {
            return ctrl.items;
          }, function (newItems, oldItems) {
            if (newItems.length !== oldItems.length) {
                sortItemsBy(ITEM_PROPERTIES.TITLE, ctrl.itemSortDesc);
            }
        });
    }
})();

(function() {
    'use strict';
  
    angular
      .module('icarus.planner')
      .config(config);
  
    /** @ngInject */
    function config($translateProvider) {
      $translateProvider.translations('es', {
        'Items_table' : {
            'btn_delete': 'Eliminar',
            'btn_add': 'Nuevo Item',
            'title': 'Items',
            'amount': 'Cantidad',
            'new_item': 'Nuevo ítem',
            'error_required': 'La cantidad es requerida',
            'error_min': 'La cantidad debe ser mayor a 0',
            'error_number': 'Ingresa un valor numérico válido'
        }
      });
      $translateProvider.translations('en', {
        'Items_table' : {
          'btn_delete': 'Delete',
					'btn_add': 'Add Item',
					'title': 'Items',
					'amount': 'Amount',
          'new_item': 'New item',
          'error_required': 'Quantity is required',
          'error_min': 'Quantity must be greater than 0',
          'error_number': 'Enter a valid numeric value'
        }
      });
      $translateProvider.translations('pt', {
        'Items_table' : {
          'btn_delete': 'Excluir',
					'btn_add': 'Adicionar Item',
					'title': 'Unid',
					'amount': 'Quantia',
          'new_item': 'Novo item',
          'error_required': 'A quantidade é obrigatória',
          'error_min': 'A quantidade deve ser maior que 0',
          'error_number': 'Insira um valor numérico válido'
        }
      });
    }
  })();
  
(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .component("multiTagInput", {
      controller: MultiTagInputController,
      templateUrl: "app/planner/components/multiTagInput/multi-tag-input.html",
      bindings: {
        tags: '<',
        handleSearch: '<',
        cleanSearch: '<',
        isSearchActive: '<',
        notFoundAlert: '<',
        placeholder: '<',
        getSuggestion: '<'
      }
    });
  /** @ngInject */
  function MultiTagInputController($scope, $sanitize, lodash) {
    var CONTAINER_WIDTH = 392;
    var TAG_MARGIN = 6;
    var MIN_VISIBLE_TAGS = 1;
    var BASE_COUNT_WIDTH = 53;
    var COUNT_WIDTH_PER_DIGIT = 10;
    var ctrl = this;
    ctrl.suggestions = [];
    ctrl.tags = Array.isArray(ctrl.tags) ? ctrl.tags : [];
    ctrl.inputValue = '';
    ctrl.showClearButton = ctrl.isSearchActive || false;
    ctrl.compactMode = ctrl.isSearchActive || false;
    ctrl.visibleTags = ctrl.tags;
    ctrl.hiddenTagsCount = 0;

    ctrl.calculateVisibleTags = function () {
      var totalWidth = 0;
      var visibleCount = 0;
      var hiddenCount = Math.max(MIN_VISIBLE_TAGS, ctrl.tags.length - 1);
      var estimatedCountTagWidth = BASE_COUNT_WIDTH + Math.floor(Math.log10(hiddenCount)) * COUNT_WIDTH_PER_DIGIT;
      var tagRefs = document.querySelectorAll('div.tags-and-input-wrapper>div.tag');
      for (var i = 0; i < tagRefs.length; i++) {
        var tagEl = tagRefs[i];
        var tagWidth = tagEl.offsetWidth + TAG_MARGIN;
        var isLastTag = tagRefs.length === (i + 1);
        var projectedWidthWithNextTag = totalWidth + tagWidth + (isLastTag ? 0 : estimatedCountTagWidth);
        if (i > 0 && projectedWidthWithNextTag > CONTAINER_WIDTH) {
          break;
        }
        totalWidth += tagWidth;
        visibleCount++;
      }

      visibleCount = Math.max(MIN_VISIBLE_TAGS, visibleCount);
      ctrl.visibleTags = ctrl.tags.slice(0, visibleCount);
      ctrl.hiddenTagsCount = ctrl.tags.length - visibleCount;

      $scope.$applyAsync();
    };

    ctrl.removeTag = function (index, $event) {
      if ($event && $event.stopPropagation) $event.stopPropagation();
      ctrl.tags.splice(index, 1);
      if (!ctrl.tags.length) {
        return ctrl.clearAllTags();
      };
      ctrl.syncVisibleTags();
    };

    ctrl.handleKeyDown = function ($event) {
      var key = $event.key;
      var inputValue = ctrl.inputValue && ctrl.inputValue.trim();
      if (key === 'Enter') {
        if ($event.shiftKey) return;
        $event.preventDefault();
        addNewTag(inputValue);
        if (ctrl.tags.length && !ctrl.compactMode) {
          return setTimeout(function () {
            ctrl.toggleSearchAndClear();
          }, 0);
        }
      } else if (key === 'Tab' && inputValue) {
        $event.preventDefault();
        addNewTag(inputValue);
        setTimeout(function () {
          var el = document.getElementById('tags-and-input-wrapper');
          el.scrollTop = el.scrollHeight;
        }, 0);
      } else if (key === 'Backspace' && !inputValue && ctrl.tags.length) {
        $event.preventDefault();
        ctrl.tags.pop();
        if (!ctrl.tags.length) {
          return ctrl.clearAllTags();
        };
      }
      ctrl.syncVisibleTags();
    };

    ctrl.handlePaste = function ($event) {
      $event.preventDefault();
      var text = $event.clipboardData.getData('text');

      if (text.indexOf('\n') !== -1) {
        var lines = text.split('\n');
        for (var i = 0; i < lines.length; i++) {
          var t = lines[i].trim();
          if (t) ctrl.tags.push($sanitize(t));
        }
      } else {
        ctrl.inputValue += text;
      }
      ctrl.syncVisibleTags();
    };

    ctrl.handleInputClick = function ($event) {
      if ($event && $event.stopPropagation) $event.stopPropagation();
      if (!ctrl.compactMode) {
        return;
      }
      ctrl.exitCompactMode();
    };

    function addNewTag(inputValue) {
      if (!inputValue) { 
        return;
      }
      ctrl.tags.push($sanitize(inputValue));
      ctrl.inputValue = '';
      ctrl.suggestions = [];
      $scope.$applyAsync();
    };

    ctrl.toggleSearchAndClear = function () {
      var inputValue = ctrl.inputValue && ctrl.inputValue.trim();
      addNewTag(inputValue);
      if (ctrl.tags.length) {
        ctrl.showClearButton = true;
        ctrl.compactMode = true;
        ctrl.syncVisibleTags();
        ctrl.handleSearch(ctrl.tags);
      }
    };

    ctrl.clearAllTags = function () {
      ctrl.tags = [];
      ctrl.visibleTags = [];
      ctrl.hiddenTagsCount = 0;
      ctrl.showClearButton = false;
      ctrl.compactMode = false;
      ctrl.suggestions = [];
      ctrl.cleanSearch();
    };

    ctrl.handleHiddenTagsClick = function () {
      ctrl.exitCompactMode();
    };

    ctrl.exitCompactMode = function ($event) {
      if ($event && $event.stopPropagation) $event.stopPropagation();
      ctrl.compactMode = false;
      ctrl.showClearButton = false;
      ctrl.hiddenTagsCount = 0;
      ctrl.suggestions = [];
      ctrl.syncVisibleTags();
    };

    ctrl.syncVisibleTags = function () {
      if (ctrl.showClearButton) {
        ctrl.calculateVisibleTags();
        return;
      }
      ctrl.visibleTags = ctrl.tags;
    };

    ctrl.onClickSuggestion = function (suggestionText) {
      ctrl.tags.push(suggestionText);
      ctrl.inputValue = '';
      ctrl.suggestions = [];
    };

    ctrl.handleInputChange = function () {
      ctrl.suggestions = [];
      var inputValue = ctrl.inputValue && ctrl.inputValue.trim();
      if (!inputValue) {
        return;
      }
      ctrl.suggestions = ctrl.getSuggestion(inputValue);
    };
  };
})();

(function () {
  "use strict";

  angular.module("icarus.planner").config(config);

  /** @ngInject */
  function config($translateProvider) {

    $translateProvider.translations("es", {
      multiTagInputVehicle: {
        placeholder: "Busca o copia y pega el o los vehículos a seleccionar....",
        notFoundAlert: "No se ha encontrado ningún vehículo que coincida con la búsqueda, por favor intenta nuevamente.",
        foundVehiclesMessage: "Mostrando {{notFoundLength}} resultados de la búsqueda.",
        notFoundAllSearch: "No se han encontrado algunos de los vehículos que buscaste, por favor intenta nuevamente."
      }
    });

    $translateProvider.translations("en", {
      multiTagInputVehicle: {
        placeholder: "Search or copy and paste the vehicle(s) to select...",
        notFoundAlert: "No vehicle found matching the search, please try again.",
        foundVehiclesMessage: "Showing {{notFoundLength}} search results.",
        notFoundAllSearch: "Some of the vehicles you searched for were not found, please try again."
      }
    });

    $translateProvider.translations("pt", {
      multiTagInputVehicle: {
        placeholder: "Procure ou copie e cole o(s) veículo(s) a selecionar...",
        notFoundAlert: "Nenhum veículo encontrado que corresponda à pesquisa, por favor tente novamente.",
        foundVehiclesMessage: "Mostrando {{notFoundLength}} resultados da busca.",
        notFoundAllSearch: "Alguns dos veículos que você buscou não foram encontrados, por favor tente novamente."
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .component('moveToOptions', {
      controller: moveToOptionsController,
      templateUrl: 'app/planner/components/moveToOptions/moveToOptions.html',
      bindings: {
        options: '<',
        moveVisitTo: '&',
        fillCircleOption: '&',
        isRevisedOption: '<',
        isContainerCollapsed: '<'
      }
    });

    /** @ngInject */
    function moveToOptionsController(naturalService, $filter) {
      var $translate = $filter('translate');
      var ctrl = this;
      ctrl.handleMouseEvent = handleMouseEvent;
      ctrl.naturalSort = naturalSort;
      ctrl.onMoveVisitTo = onMoveVisitTo;

      function handleMouseEvent(route, fill) {
        ctrl.fillCircleOption({route: route, highlight: fill});
      }

      function onMoveVisitTo(vehicleId, routeId) {
        ctrl.moveVisitTo({vehicleId: vehicleId, routeId: routeId});
      }

      ctrl.$onInit = function () {
        ctrl.isCollapsed = !!ctrl.isRevisedOption;
        ctrl.title = ctrl.isRevisedOption ? $translate('MoveToOptions.revised') : $translate('MoveToOptions.available');
      };

      ctrl.$onChanges = function (changes) {
        if (changes.isContainerCollapsed) {
          ctrl.isCollapsed = !!ctrl.isRevisedOption;
        }
      };

      function naturalSort(field) {
        return function (item) {
          return naturalService.naturalValue(item[field]);
        };
      }
    }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .config(config);

    /** @ngInject */
    function config($translateProvider) {

      $translateProvider.translations("es", {
        MoveToOptions: {
          available: "Rutas disponibles",
          revised: "Rutas revisadas"
        }
      });

      $translateProvider.translations("en", {
        MoveToOptions: {
          available: "Available routes",
          revised: "Revised routes"
        }
      });

      $translateProvider.translations("pt", {
        MoveToOptions: {
          available: "Rotas disponíveis",
          revised: "Rotas revistas"
        }
      });

      $translateProvider.determinePreferredLanguage();
    }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .component('loadsTable', {
      controller: loadsTableController,
      templateUrl: 'app/planner/components/loadsTable/loadsTable.html',
      bindings: {
        joinSimilar: '<',
        route: '<',
        headerText: '<',
        reverseOrder: "=",
        showTable: "=",
        close: '&',
        selectVisit: '&',
        selectRoute: '&'
      }
    });

  /** @ngInject */
  function loadsTableController(
    plannerService, $scope, LOADS_TABLE_COLUMNS, loadTableService, START_TIME_WINDOW, END_TIME_WINDOW,
    $timeout
  ) {
    var ctrl = this;
    var SCROLL_THRESHOLD = 200;
    var scrollDiv = null;
    var COLUMN_KEYS_TO_STORAGE = ['visible', 'position', 'style'];

    ctrl.LIMIT = 50;
    ctrl.visibleVisits = [];
    ctrl.currentPage = 1;
    ctrl.visits = [];
    ctrl.orderBy = 'totalLoad';
    ctrl.hoveredColumnKey = null;
    ctrl.showColumnsOptions = false;
    ctrl.columns = [];
    ctrl.accountSkills = {};
    ctrl.tableColumns = angular.copy(LOADS_TABLE_COLUMNS);
    ctrl.generalIndicatorsHidden = false;
    ctrl.detailedIndicatorsEnabled = false;

    ctrl.eventGeneralIndicatorsChange = null;

    ctrl.$onInit = function() {
      ctrl.currentPage = 1;
      ctrl.setColumns();
      ctrl.setAccountSkills();
      if (ctrl.route && ctrl.route.visits && ctrl.route.visits.length) {
        onRouteUpdate(ctrl.route);
      }
      $timeout(function () {
        scrollDiv = document.getElementById('loads-table-container');
        if (scrollDiv) {
          scrollDiv.addEventListener('scroll', ctrl.onScroll, { passive: true });
        };
      }, 0);

      // Listener for visibility of general indicators
      var eventGeneralIndicatorsChange = $scope.$on('Planner:GeneralIndicatorsHideStateChange', function (_e, payload) {
        ctrl.generalIndicatorsHidden = !!(payload && payload.hide);
        ctrl.detailedIndicatorsEnabled = !!(payload && payload.detailedIndicatorsEnabled);
      });
      ctrl.eventGeneralIndicatorsChange = eventGeneralIndicatorsChange;
      $scope.$emit('Planner:RequestGeneralIndicatorsState');
    };

    ctrl.$onChanges = function(changes) {
      if (changes.showTable && changes.showTable.currentValue) {
        onRouteUpdate(ctrl.route);
      }
    };

    ctrl.changeOrder = function (selectedField, orderable) {
      if (!orderable) {
        return;
      }
      if (ctrl.orderBy === selectedField) {
        ctrl.reverseOrder = !ctrl.reverseOrder;
      } else {
        ctrl.orderBy = selectedField;
        ctrl.reverseOrder = false;
      }
      ctrl.currentPage = 1;
      ctrl.sortVisits();
      $timeout(function () {
        if (scrollDiv) {
          scrollDiv.scrollTop = 0;
        };
      }, 0);
      ctrl.lazyLoadVisits();
    };

    ctrl.sortVisits = function () {
      ctrl.visits = ctrl.visits.sort(function (a, b) {
        var va = a[ctrl.orderBy];
        var vb = b[ctrl.orderBy];

        if (va == null && vb == null) return 0;
        if (va == null) return 1;
        if (vb == null) return -1;

        if (va < vb) return ctrl.reverseOrder ? 1 : -1;
        if (va > vb) return ctrl.reverseOrder ? -1 : 1;
        return 0;
      });
    };

    ctrl.select = function (visit) {
      ctrl.selectVisit({ routeId: ctrl.route.id, visit: visit, deselectSimilar: true });
    };

    ctrl.selectAll = function () {
      ctrl.selectRoute({ route: ctrl.route });
    };

    function onRouteUpdate(route, shouldResetScrollAndPage) {
      if (!route) {
        return;
      }

      if (route.visits.length === 0) {
        ctrl.showTable = false;
        return;
      }

      if (ctrl.joinSimilar) {
        var visitsGroupBySimilar = plannerService.visitSimilarGraph.getVisitsGroupedBySimilar(route.visits);
        ctrl.visits = visitsGroupBySimilar.map(function (visitGroup) {
          var leadVisit = visitGroup[0];
          leadVisit.totalSimilar = visitGroup.length;
          leadVisit.totalLoad = visitGroup.reduce(function (acc, visit) {
            return acc + visit.load;
          }, 0);

          leadVisit.totalLoad2 = visitGroup.reduce(function (acc, visit) {
            return acc + visit.load2;
          }, 0);

          leadVisit.totalLoad3 = visitGroup.reduce(function (acc, visit) {
            return acc + visit.load3;
          }, 0);

          leadVisit.skills_required = ctrl.getUniqueSkills(visitGroup, 'skills_required');
          leadVisit.skills_optional = ctrl.getUniqueSkills(visitGroup, 'skills_optional');

          return leadVisit;
        });
      } else {
        ctrl.visits = route.visits.map(function (visit) {
          visit.totalLoad = visit.load;
          visit.totalLoad2 = visit.load2;
          visit.totalLoad3 = visit.load3;
          return visit;
        });
      }

      ctrl.visits = ctrl.nullifyDefaultTimeWindows(ctrl.visits);
      if (route.totalLoad3 > 0) {
        ctrl.orderBy = 'totalLoad3';
      }

      if (route.totalLoad2 > 0) {
        ctrl.orderBy = 'totalLoad2';
      }

      if (route.totalLoad > 0) {
        ctrl.orderBy = 'totalLoad';
      }
      ctrl.sortVisits();
      if (shouldResetScrollAndPage) {
        ctrl.currentPage = 1;
        $timeout(function () {
          if (scrollDiv) {
            scrollDiv.scrollTop = 0;
          };
        }, 0);
      }
      ctrl.lazyLoadVisits();
    }

    ctrl.getUniqueSkills = function (visitGroup, skillType) {
      return visitGroup.reduce(function (allSkills, visit) {
        return allSkills.concat(visit[skillType]).reduce(function (combinedSkills, skill) {
          if (combinedSkills.indexOf(skill) < 0) {
            combinedSkills.push(skill);
          }
          return combinedSkills;
        }, []);
      }, []);
    };

    ctrl.nullifyDefaultTimeWindows = function (visits) {
      visits.forEach(function (visit) {
        if (
          visit.windowStart === START_TIME_WINDOW && visit.windowEnd === END_TIME_WINDOW
          || visit.windowStart === END_TIME_WINDOW
        ) {
          visit.windowStart = null;
          visit.windowEnd = null;
        }
        if (
          visit.windowStart2 === START_TIME_WINDOW && visit.windowEnd2 === END_TIME_WINDOW
          || visit.windowStart2 === END_TIME_WINDOW
        ) {
          visit.windowStart2 = null;
          visit.windowEnd2 = null;
        }
      });
      return visits;
    };

    ctrl.toggleColumnsOptions = function () {
      ctrl.showColumnsOptions = !ctrl.showColumnsOptions;
    };

    ctrl.setColumns = function () {
      var configs = loadTableService.getLoadsTableConfigs();
      ctrl.columns = Object.keys(ctrl.tableColumns).map(function (key) {
          var columnSaved = configs[key] || {};
          return Object.assign(ctrl.tableColumns[key], columnSaved);
        });
    };

    ctrl.updateColumn = function (columnKey, column) {
      var newColumn = {};
      newColumn[columnKey] = column;
      ctrl.tableColumns = Object.assign({}, ctrl.tableColumns, newColumn);
      ctrl.columns = Object.values(ctrl.tableColumns);
      loadTableService.saveColumnInLocalStore(columnKey, ctrl._parseLoadTableColumn(column));
    };

    ctrl.updateColumnsArray = function (columns) {
      columns.forEach(function (column) {
        ctrl.updateColumn(column.columnKey, column);
      });
      ctrl.setColumns();
    };

    ctrl.resetColumnsWidth = function () {
      ctrl.showColumnsOptions = false;
    };

    ctrl.setAccountSkills = function () {
      ctrl.accountSkills = plannerService.getSkills().reduce(function (acc, val) {
        acc[val.id] = val.name;
        return acc;
      }, {});
    };

    ctrl._parseLoadTableColumn = function (column) {
      return COLUMN_KEYS_TO_STORAGE.reduce(function (acc, key) {
        acc[key] = angular.copy(column[key]);
        return acc;
      }, {});
    };

    ctrl.lazyLoadVisits = function () {
      var end = ctrl.currentPage * ctrl.LIMIT;
      ctrl.visibleVisits = ctrl.visits.slice(0, end);
    };

    ctrl.loadMore = function () {
      ctrl.currentPage++;
      ctrl.lazyLoadVisits();
    };

    ctrl.onScroll = function () {
      if (!scrollDiv) return;
      if (scrollDiv.scrollTop + scrollDiv.clientHeight >= scrollDiv.scrollHeight - SCROLL_THRESHOLD) {
        ctrl.loadMore();
        $scope.$applyAsync();
      }
    };

    $scope.$on('$destroy', function () {
      if (scrollDiv) {
        scrollDiv.removeEventListener('scroll', ctrl.onScroll);
      }

      // Clean up event listeners
      if (ctrl.eventGeneralIndicatorsChange) {  
        ctrl.eventGeneralIndicatorsChange();
      }
    });

    function getRouteIdInVisits (visits) {
      if (!Array.isArray(visits) || visits.length === 0) {
        return null;
      };
      return visits[0].routeId;
    };

    $scope.$watchCollection(
      function () {
        return ctrl.route ? ctrl.route.visits : null;
      },
      function (newVisits, oldVisits) {
        var newRouteId = getRouteIdInVisits(newVisits);
        var oldRouteId = getRouteIdInVisits(oldVisits);
        if (newVisits !== oldVisits) {
          onRouteUpdate(ctrl.route, newRouteId !== oldRouteId);
        }
      }
    );
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations("es", {
      LoadsTable: {
        visit_order: "Orden de visitas"
      },
      ColumnsList: {
        reset: "Restablecer",
        displayed: "Mostrado en tabla",
        hidden: "Oculto en tabla"
      }
    });

    $translateProvider.translations("en", {
      LoadsTable: {
        visit_order: "Visit order"
      },
      ColumnsList: {
        reset: "Reset",
        displayed: "Displayed in table",
        hidden: "Hidden in table"
      } 
    });

    $translateProvider.translations("pt", {
      LoadsTable: {
        visit_order: "Ordem das visitas"
      },
      ColumnsList: {
        reset: "Reiniciar",
        displayed: "Exibido na tabela",
        hidden: "Oculto na tabela"
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .constant("MAX_LENGTH_OF_VISIT_TITLE", 10)
    .constant("LOADS_TABLE_COLUMNS", {
      title: {
        metaId: "loads-table-title-header",
        label: "Visits.lbl_title",
        changeOrder: false,
        propertyName: 'title',
        canBeHidden: false,
        visible: true,
        isVisible: function (joinSimilar) {
          return this.visible && !joinSimilar;
        },
        position: 0,
        style: {
          width: '195px'
        }
      },
      stops: {
        metaId: "loads-table-stop-header",
        label: "Visits.lbl_stop",
        propertyName: 'title',
        changeOrder: false,
        canBeHidden: false,
        visible: true,
        isVisible: function (joinSimilar) {
          return this.visible && joinSimilar;
        },
        position: 0,
        style: {
          width: '120px'
        }
      },
      count: {
        metaId: "loads-table-count-header",
        label: "Visits.title",
        propertyName: 'totalSimilar',
        canBeHidden: false,
        visible: true,
        isVisible: function (joinSimilar) {
          return this.visible && joinSimilar;
        },
        position: 1,
        style: {
          width: "70px"
        }
      },
      totalLoad: {
        metaId: "loads-table-total-load-header",
        label: "Visits.lbl_load",
        changeOrder: true,
        propertyName: "totalLoad",
        canBeHidden: true,
        visible: true,
        isVisible: function () {
          return this.visible;
        },
        position: 2,
        style: {
          width: "90px"
        }
      },
      totalLoad2: {
        metaId: "loads-table-total-load2-header",
        label: "Visits.lbl_load_2",
        changeOrder: true,
        propertyName: "totalLoad2",
        canBeHidden: true,
        visible: true,
        isVisible: function () {
          return this.visible;
        },
        position: 3,
        style: {
          width: "90px"
        }
      },
      totalLoad3: {
        metaId: "loads-table-total-load3-header",
        label: "Visits.lbl_load_3",
        changeOrder: true,
        propertyName: "totalLoad3",
        canBeHidden: true,
        visible: true,
        isVisible: function () {
          return this.visible;
        },
        position: 4,
        style: {
          width: "90px"
        }
      },
      windowStart: {
        metaId: "loads-table-window-start-header",
        label: "Visits.start_time_window_1",
        changeOrder: true,
        propertyName: "windowStart",
        canBeHidden: true,
        visible: false,
        isVisible: function () {
          return this.visible;
        },
        position: 5,
        style: {
          width: "170px"
        }
      },
      windowEnd: {
        metaId: "loads-table-window-end-header",
        label: "Visits.end_time_window_1",
        changeOrder: true,
        propertyName: "windowEnd",
        canBeHidden: true,
        visible: false,
        isVisible: function () {
          return this.visible;
        },
        position: 6,
        style: {
          width: "170px"
        }
      },
      windowStart2: {
        metaId: "loads-table-window-start_2-header",
        label: "Visits.start_time_window_2",
        changeOrder: true,
        propertyName: "windowStart2",
        canBeHidden: true,
        visible: false,
        isVisible: function () {
          return this.visible;
        },
        position: 7,
        style: {
          width: "170px"
        }
      },
      windowEnd2: {
        metaId: "loads-table-window-end_2-header",
        label: "Visits.end_time_window_2",
        changeOrder: true,
        propertyName: "windowEnd2",
        canBeHidden: true,
        visible: false,
        isVisible: function () {
          return this.visible;
        },
        position: 8,
        style: {
          width: "170px"
        }
      },
      duration: {
        metaId: "loads-table-service_time-header",
        label: "Visits.lbl_service",
        changeOrder: true,
        propertyName: "duration",
        canBeHidden: true,
        visible: false,
        isVisible: function () {
          return this.visible;
        },
        position: 9,
        style: {
          width: "120px",
        }
      },
      priorityLevel: {
        metaId: "loads-table-priority-header",
        label: "Visits.lbl_priority",
        changeOrder: true,
        propertyName: "priorityLevel",
        canBeHidden: true,
        visible: false,
        isVisible: function () {
          return this.visible;
        },
        position: 10,
        style: {
          width: "90px"
        }
      },
      skillsRequired: {
        type: 'list',
        metaId: "loads-table-skills_required-header",
        label: "Visits.required_skills",
        propertyName: "skills_required",
        getValue: function (item, raw, accountSkills) {
          if (!item.skills_required.length) {
            return null;
          }
          var skillIds = raw ? item.skills_required : [item.skills_required[0]];
          var skillsNames = skillIds.map(function (skillId) {
              var skill = accountSkills.find(function (skill) {
                return skillId === skill.id;
              });
              return skill ? skill.name : skillId;
            });

          return raw ? skillsNames : skillsNames[0];
        },
        canBeHidden: true,
        visible: false,
        isVisible: function () {
          return this.visible;
        },
        position: 11,
        style: {
          width: "120px"
        }
      },
      skillsOptional: {
        type: 'list',
        metaId: "loads-table-skills_optional-header",
        label: "Visits.optional_skills",
        propertyName: "skills_optional",
        getValue: function (item, raw, accountSkills) {
          if (!item.skills_optional.length) {
            return null;
          }
          var skillIds = raw ? item.skills_optional : [item.skills_optional[0]];
          var skillsNames = skillIds.map(function (skillId) {
              var skill = accountSkills.find(function (skill) {
                return skillId === skill.id;
              });
              return skill ? skill.name : skillId;
            });

          return raw ? skillsNames : skillsNames[0];
        },

        canBeHidden: true,
        visible: false,
        isVisible: function () {
          return this.visible;
        },
        position: 12,
        style: {
          width: "120px"
        }
      }
    });
})();

(function () {
  'use strict';
  angular
    .module('icarus.shared')
    .factory('loadTableService', loadTableService);


  /** @ngInject */
  function loadTableService(store) {
    var service = {};

    var LOADS_TABLE_CONFIGS_KEY = 'LOADS_TABLE_CONFIGS';

    service.saveColumnInLocalStore = function (columnKey, column) {
      var configs = service.getLoadsTableConfigs();
      configs[columnKey] = column;
      store.set(LOADS_TABLE_CONFIGS_KEY, configs);
    };

    service.getLoadsTableConfigs = function () {
      var configs = store.get(LOADS_TABLE_CONFIGS_KEY);
      if (!configs) {
        configs = {};
      }
      return configs;
    };

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .directive('columnsListResizer', columnsListResizer);

  columnsListResizer.$inject = ['$document'];
  function columnsListResizer($document) {
    return {
      restrict: 'A',
      scope: {
        column: '=columnsListResizer',
        clrUpdateColumn: '&?',
        clrHoveredColumnKey: '='
      },
      link: function (scope, element) {
        var startX, startWidth;
        var defaultWidth = { minWidth: 55, maxWidth: 500 };

        var resizer = angular.element('<div class="column-resizer"></div>');
        element.css('position', 'relative');
        resizer.css({
          position: 'absolute',
          right: 0,
          top: 0,
          width: '7px',
          height: '100%',
          cursor: 'col-resize',
          'z-index': 10
        });
        element.append(resizer);

        resizer.on('mousedown', onMouseDown);
        resizer.on('mouseenter', onMouseEnter);
        resizer.on('mouseleave', onMouseLeave);

        scope.$on('$destroy', cleanup);

        function onMouseDown(event) {
          event.preventDefault();
          startX = event.pageX;
          startWidth = element[0].offsetWidth;
          $document.on('mousemove', onMouseMove);
          $document.on('mouseup', onMouseUp);
        }

        function onMouseMove(event) {
          event.preventDefault();
          var w = startWidth + (event.pageX - startX);
          var minW = getStyleWidth('minWidth');
          var maxW = getStyleWidth('maxWidth');
          w = Math.max(minW, Math.min(maxW, w));
          applyWidth(w);
        }

        function onMouseUp(event) {
          event.preventDefault();
          $document.off('mousemove', onMouseMove);
          $document.off('mouseup', onMouseUp);
        }

        function onMouseEnter (event) {
          event.preventDefault();
          scope.$apply(function () {
            scope.clrHoveredColumnKey = scope.column.columnKey;
          });
        }

        function onMouseLeave (event) {
          event.preventDefault();
          scope.$apply(function () {
            scope.clrHoveredColumnKey = null;
          });
        }

        function getStyleWidth(prop) {
          var style = scope.column.style || {};
          var val = parseInt(style[prop], 10);
          return isNaN(val) ? defaultWidth[prop] : val;
        }

        function applyWidth(w) {
          scope.$apply(function () {
            var wpx = w + 'px';
            scope.column.style = scope.column.style || {};
            scope.column.style.width = wpx;
            if (angular.isFunction(scope.clrUpdateColumn)) {
              scope.clrUpdateColumn({
                columnKey: scope.column.columnKey,
                column: scope.column
              });
            }
          });
        }

        scope.$watch(
          function () {
            return scope.clrHoveredColumnKey === scope.column.columnKey;
          },
          function (isHovered) {
            if (isHovered) {
              resizer.css("background-color", "rgba(0, 123, 255, 0.5)");
            } else {
              resizer.css("background-color", "transparent");
            }
          }
        );

        function cleanup() {
          resizer.off('mousedown', onMouseDown);
          resizer.off('mouseenter', onMouseEnter);
          resizer.off('mouseleave', onMouseLeave);

          $document.off('mousemove', onMouseMove);
          $document.off('mouseup', onMouseUp);
        }
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .component('columnsList', {
      controller: columnsListController,
      templateUrl: 'app/planner/components/loadsTable/columnsList.html',
      bindings: {
        tableColumns: '<',
        joinSimilar: '<',
        updateColumn: '&',
        updateColumnsArray: '&',
        resetColumnsWidth: '&'
      }
    });

  /** @ngInject */
  function columnsListController(LOADS_TABLE_COLUMNS, $element, $timeout) {
    var ctrl = this;
    ctrl.columns = [];
    ctrl.draggedItem = null;

    ctrl.$onInit = function () {
      ctrl.setColumns();
    };

    ctrl.$onChanges = function (changes) {
      if (changes.tableColumns) {
        ctrl.setColumns();
        $timeout(ctrl.setupDragAndDrop);
      }
    };

    ctrl.$postLink = function () {
      $timeout(ctrl.setupDragAndDrop);
    };

    ctrl.setColumns = function () {
      for (var key in ctrl.tableColumns) {
        ctrl.tableColumns[key].columnKey = key;
      }
      ctrl.columns = Object.values(ctrl.tableColumns).sort(function (a, b) {
        return a.position - b.position;
      });
    };

    ctrl.toggleVisible = function (column) {
      var updatedColumn = Object.assign({}, ctrl.tableColumns[column.columnKey]);
      updatedColumn.visible = !updatedColumn.visible;
      ctrl.updateColumn({ columnKey: updatedColumn.columnKey, column: updatedColumn });
    };

    ctrl.resetColumnsList = function () {
      var loadTableColumns = angular.copy(LOADS_TABLE_COLUMNS);
      Object.keys(loadTableColumns).forEach(function (key) {
        var column = Object.assign({}, loadTableColumns[key]);
        ctrl.updateColumn({ columnKey: key, column: column });
      });
      ctrl.resetColumnsWidth();
      $timeout(function () {
        ctrl.setupDragAndDrop();
        ctrl.setColumns();
      });
    };

    ctrl.setupDragAndDrop = function () {
      var listItems = $element[0].querySelectorAll('#show-columns-list .draggable-column');

      Array.prototype.forEach.call(listItems, function (item) {
        var scope = angular.element(item).scope();
        var column = scope.column;

        item.removeEventListener('dragstart', item._dragStartListener);
        item.removeEventListener('dragover', item._dragOverListener);
        item.removeEventListener('drop', item._dropListener);

        item._dragStartListener = function () {
          ctrl.draggedItem = column;
        };

        item._dragOverListener = function (e) {
          e.preventDefault();
        };

        item._dropListener = function () {
          ctrl.reorderColumns(ctrl.draggedItem, column);
          scope.$apply();
        };

        item.setAttribute('draggable', true);
        item.addEventListener('dragstart', item._dragStartListener);
        item.addEventListener('dragover', item._dragOverListener);
        item.addEventListener('drop', item._dropListener);
      });
    };

    ctrl.reorderColumns = function (dragged, target) {
      if (!dragged || !target || dragged === target) return;

      var draggedPos = dragged.position;
      var targetPos = target.position;

      ctrl.columns.forEach(function (col) {
        if (draggedPos < targetPos) {
          if (col.position > draggedPos && col.position <= targetPos) {
            col.position--;
          }
        } else {
          if (col.position < draggedPos && col.position >= targetPos) {
            col.position++;
          }
        }
      });

      dragged.position = targetPos;

      ctrl.updateColumnsArray({ columns: ctrl.columns });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .component('cellLoadTable', {
      controller: cellLoadTable,
      templateUrl: 'app/planner/components/loadsTable/cellLoadTable.html',
      bindings: {
        data: '<',
        propertyName: '<',
        fixed: '<',
        skills: '<'
      }
    });

  /** @ngInject */
  function cellLoadTable() {
    var ctrl = this;
    var MAX_STRING_LENGTH = 20;
    ctrl.isTruncated = false;
    ctrl.value = null;
    ctrl.isArray = false;
    ctrl.otherSkills = [];

    ctrl.$onInit = function () {
      ctrl.isArray = Array.isArray(ctrl.data[ctrl.propertyName]);
      ctrl.setValue();
      ctrl._checkTruncate();
    };

    ctrl._checkTruncate = function () {
      ctrl.isTruncated = ctrl.value && String(ctrl.value).length > MAX_STRING_LENGTH;
    };

    ctrl.setValue = function () {
      var value = ctrl.data[ctrl.propertyName];

      if (!ctrl.isArray) {
        ctrl.value = value;
        return;
      }

      if (!value.length) {
        return;
      }

      if (value.length > 1) {
        ctrl.otherSkills = value.slice(1).map(function (skillId) {
          return ctrl.skills[skillId];
        });
      }

      ctrl.value = ctrl.skills[value[0]];
    };

  }

})();

(function () {
    'use strict';

    angular
      .module('icarus.planner')
      .component('loadCapacity', {
        controller: loadCapacityController,
        templateUrl: 'app/planner/components/loadCapacity/loadCapacity.html',
        bindings: {
          totalLoads: '<',
          totalCapacity: '<'
        }
      });

    /** @ngInject */
    function loadCapacityController(plannerService, utilsService, PATH_FINDER_ADD_ON_PROPERTIES) {
        var ctrl = this;
        ctrl.typeOfLoads = ['load_1', 'load_2', 'load_3','load_4'];
        ctrl.collapse = true;
        ctrl.totalLoads = this.totalLoads;
        ctrl.totalCapacity = this.totalCapacity;
        ctrl.overloadByTypeOfLoad = [0,0,0];
        ctrl.totalOverloads = 0;
        ctrl.updateTotalOverloads = updateTotalOverloads;
        ctrl.isMixLoadAddonEnabled = function() {
          var pathFinderProperties = plannerService.getPathFinderProperties();
          return utilsService.isAddonPropertyEnabled(
            pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD]
          );
        };

        function updateTotalOverloads(typeLoad, overload){
          typeLoad = ctrl.typeOfLoads.indexOf(typeLoad);
          ctrl.overloadByTypeOfLoad[typeLoad] = overload;
          ctrl.totalOverloads = ctrl.overloadByTypeOfLoad.reduce(function (acc, overload){
                return acc + overload;
          },0);
        }
    }
  })();

(function () {
    "use strict";
  
    angular.module("icarus.planner").config(config);
  
    /** @ngInject */
    function config($translateProvider) {
  
      $translateProvider.translations("es", {
        LoadCapacity: {
            title: "Capacidad de carga",
        }
      });
  
      $translateProvider.translations("en", {
        LoadCapacity: {
            title: "Load capacity",
        }
      });
  
      $translateProvider.translations("pt", {
        LoadCapacity: {
            title: "Capacidade de carga",
        }
      });
  
      $translateProvider.determinePreferredLanguage();
    }
  })();
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .component('itemsSummaryInVisitCard', {
      controller: itemsSummaryInVisitCardController,
      templateUrl: 'app/planner/components/itemsSummaryInVisitCard/itemsSummaryInVisitCard.html',
      bindings: {
        items: '<'
      }
    });

  /** @ngInject */
  function itemsSummaryInVisitCardController($filter, $scope, ITEMS_SUMMARY_ICON_PATH, MAX_ITEMS_IN_SUMMARY_LIST,
                                             ITEMS_SUMMARY_LIST_SEPARATOR, ITEMS_SUMMARY_BASE_TRANSLATE_PATH, __env) {
    var vm = this;
    var $translate = $filter('translate');

    $scope.ITEMS_SUMMARY_ICON_PATH = ITEMS_SUMMARY_ICON_PATH;
    $scope.ITEMS_SUMMARY_LIST_SEPARATOR = ITEMS_SUMMARY_LIST_SEPARATOR;
    $scope.items = vm.items;

    $scope.shouldShowItemsSummaryContainer = function(items) {
      return items && items.length && __env.VISUALIZE_VISIT_ITEMS;
    };

    $scope.shouldShowItemsSummaryList = function(items) {
      return items.length <= MAX_ITEMS_IN_SUMMARY_LIST;
    };

    function getItemsTotalQuantityPlanned(items) {
      return items.reduce(function(accumulatedQuantity, item) {
        accumulatedQuantity += (item.quantity_planned || 0);
        return accumulatedQuantity;
      }, 0);
    }

    function getItemsTotalQuantityPlannedSummary(items) {
      var itemsTotalQuantityPlanned = getItemsTotalQuantityPlanned(items);
      var translateKey = ITEMS_SUMMARY_BASE_TRANSLATE_PATH + 'items';
      return itemsTotalQuantityPlanned + ' ' + $translate(translateKey);
    }

    $scope.activate = function() {
      if (!$scope.shouldShowItemsSummaryList($scope.items)) {
        $scope.itemsTotalQuantityPlannedSummary = getItemsTotalQuantityPlannedSummary($scope.items);
      }
    };

    $scope.activate();
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.planner')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations('es', {
      'Items_summary' : {
        'items' : 'ítems'
      }
    });
    $translateProvider.translations('en', {
      'Items_summary' : {
        'items' : 'items'
      }
    });
    $translateProvider.translations('pt', {
      'Items_summary' : {
        'items' : 'itens'
      }
    });
  }
})();

 (function () {
    'use strict';

    angular
      .module('icarus.planner')
      .component('driver', {
        controller: driverController,
        templateUrl: 'app/planner/components/driver/driver.html',
        bindings: {
          driverId: '<',
          drivers: '<',
          onChange: '&',
          isDriverAssignmentDisabled: '<'
        }
      });

    /** @ngInject */
    function driverController(
      $filter, $scope, sortDriversByDocStatusService, CURSOR_CSS_PROPERTY, driverSelectMapper, addonsService, TMS_ADD_ON_KEY
    ) {
      var ctrl = this;
      ctrl.isTmsEnable = false;
      var sortedDrivers = [];

      function updateDriverIdCustomSelect (driverId) {
        ctrl.driverId = driverId;
        ctrl.onChange({selectedDriver: driverId});
        ctrl.driverSelectInfo.drivers = driverSelectMapper.formatList(sortedDrivers);
        $scope.$evalAsync();
      }

      $scope.$on('drivers-selected:updated', function(event, drivers) {
        sortedDrivers = sortDriversByDocStatusService.sort(drivers, 'name');
        ctrl.driverSelectInfo.drivers = driverSelectMapper.formatList(sortedDrivers);
        $scope.$evalAsync();
      });

      ctrl.updateDriverId = function () {
        ctrl.onChange({selectedDriver: ctrl.driverId});
      };

      ctrl.driverSelectInfo = {
        drivers: [],
        selectedId: null,
        onClickOption: updateDriverIdCustomSelect
      };

      ctrl.$onInit = function () {
        sortedDrivers = sortDriversByDocStatusService.sort(ctrl.drivers, 'name');
        $scope.drivers = sortedDrivers;
        ctrl.isDriverDropdownDisplayed = false;
        ctrl.driverSelectInfo.drivers = sortedDrivers ? driverSelectMapper.formatList(sortedDrivers): [];
        ctrl.selectedId = ctrl.driverId;
        addonsService.isAddonEnable(TMS_ADD_ON_KEY).then(function(isTmsEnable) {
          ctrl.isTmsEnable = isTmsEnable;
        });
      };

      ctrl.isVehicleDriversListOpen = function () {
        return ctrl.isDriverDropdownDisplayed;
      };

      ctrl.toggleVehicleDriversList = function () {
        event.stopPropagation();
        if (ctrl.isDriverAssignmentDisabled) {
          return;
        }

        ctrl.isDriverDropdownDisplayed = !ctrl.isVehicleDriversListOpen();
      };

      ctrl.getNameDriverAssigned = function () {
        if (!ctrl.driverId) {
          return $filter('translate')('Driver.assign_driver');
        }

        var foundDriver = ctrl.drivers.find(function (driver) {
          return driver.id === ctrl.driverId;
        });

        if (foundDriver) {
          return foundDriver.name;
        }
      };

      ctrl.getDriverComponentNgStyle = function () {
        var ngStyle = {};
        if (ctrl.isVehicleDriversListOpen()) {
          ngStyle['column-gap'] = '8px';
          ngStyle.width = '200px';
        } else {
          ngStyle['padding-top'] = '2px';
        }

        return ngStyle;
      };

      ctrl.getDriverIconNgStyle = function () {
        return {'cursor': ctrl.isDriverAssignmentDisabled ? CURSOR_CSS_PROPERTY.DEFAULT : CURSOR_CSS_PROPERTY.POINTER};
      };

      ctrl.getDriverIconNgClass = function () {
        return {
          'route-with-driver': ctrl.driverId,
          'route-without-driver': !ctrl.driverId,
          'title-less-visible': ctrl.isDriverAssignmentDisabled
        };
      };
    }
})();

(function () {
    "use strict";
  
    angular.module("icarus.planner").config(config);
  
    /** @ngInject */
    function config($translateProvider) {
  
      $translateProvider.translations("es", {
        Driver: {
            select_driver: "--- Seleccione un conductor ---",
            assign_driver: "Asignar conductor",
            assigned_group: "✓",
            available_group: ""
        }
      });
  
      $translateProvider.translations("en", {
        Driver: {
            select_driver: "--- Select a driver ---",
            assign_driver: "Assign driver",
            assigned_group: "✓",
            available_group: ""
        }
      });
  
      $translateProvider.translations("pt", {
        Driver: {
            select_driver: "--- Selecione um motorista ---",
            assign_driver: "Atribuir co-pilotos",
            assigned_group: "✓",
            available_group: ""
        }
      });
  
      $translateProvider.determinePreferredLanguage();
    }
  })();
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .component('detailedIndicatorsCollapsed', {
      controller: detailedIndicatorsCollapsedController,
      templateUrl: 'app/planner/components/detailedIndicatorsCollapsed/detailedIndicatorsCollapsed.html',
      bindings: {
        joinSimilar: '<',
        data: '<'
      }
    });

  /** @ngInject */
  function detailedIndicatorsCollapsedController(accountConfigsService, revisedRoutesService, ACCOUNT_CONFIGS) {
    var ctrl = this;
    ctrl.isRouteRevised = revisedRoutesService.isRouteRevised;

    ctrl.$onInit = function () {
      ctrl.enablePickupAndDeliveryMode = accountConfigsService.isConfigEnabled(
        ACCOUNT_CONFIGS.ENABLE_PICKUP_AND_DELIVERY_MODE);
    };

    ctrl.getVisitIconForRouteIndicator = function () {
      if (ctrl.joinSimilar) {
        return '/assets/images/vehicle_stats/marker_filled_16.svg';
      }

      return '/assets/images/vehicle_stats/location_filled_16.svg';
    };

    ctrl.getVisitCountForRouteIndicator = function () {
      if (ctrl.joinSimilar) {
        return ctrl.data.route.arrivals.length;
      }

      return ctrl.data.route.visits.length;
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations('es', {
      'indicators' : {
        'indicators'          : 'Indicadores',
        'route'               : 'Ruta',
        'collapsed_tooltip'   : 'Mueve el mouse sobre una ruta o visita para ver los indicadores detallados',
        'revised_route_info'  : 'Recuerda que esta ruta ya está revisada.'
      }
    });

    $translateProvider.translations('en', {
      'indicators' : {
        'indicators'          : 'Indicators',
        'route'               : 'Route',
        'collapsed_tooltip'   : 'Mouse over a route or visit to see detailed indicators',
        'revised_route_info'  : 'Remember that this route is already revised.'
      }
    });

    $translateProvider.translations('pt', {
      'indicators' : {
        'indicators'          : 'Indicadores',
        'route'               : 'Rota',
        'collapsed_tooltip'   : 'Passe o mouse sobre uma rota ou uma visita para ver os indicadores detalhados',
        'revised_route_info'  : 'Recorde-se que esta rota já foi revisto.'
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .component('detailedIndicators', {
      templateUrl: 'app/planner/components/detailedIndicators/detailedIndicators.html',
      bindings: {
          joinSimilar: '<',
          data: '<',
          areIndicatorsPerVehicleShown: '<',
          shouldMoveToTop: '<'
      }
    });
})();

(function () {
    "use strict";

    angular
      .module("icarus.planner")
      .component("contextMenuOnMap", {
        templateUrl: "app/planner/components/contextMenuOnMap/contextMenuOnMap.html",
        bindings: {
          contextMenu: "<",
          moveVisitsToRoute: "&"
        }
      });
  })();
(function () {
    "use strict";

    angular
      .module("icarus.planner")
      .config(config);
  
    /** @ngInject */
    function config($translateProvider) {
      $translateProvider.translations("es", {
        ContextMenu: {
          move_here_option: "Mover aquí"
        }
      });

      $translateProvider.translations("en", {
        ContextMenu: {
          move_here_option: "Move here"
        }
      });

      $translateProvider.translations("pt", {
        ContextMenu: {
          move_here_option: "Mover aqui"
        }
      });

      $translateProvider.determinePreferredLanguage();
    }
  })();
  
/* global angular */

/**
 * Usage:
 * <custom-select></custom-select>
 */
(function () {
  "use strict";

  angular.module("icarus.planner").component("customSelect", {
    controller: customSelectController,
    templateUrl: "app/planner/components/customSelect/customSelect.html",
    bindings: {
      data: "<",
      selectedId: "<",
      onClickOption: "=",
      context: "<",
      additionalWidth: "<",
      isAbsolute: "<"
    },
  });

  /** @ngInject */
  function customSelectController($timeout, $element, $window, $scope, $document) {
    var ctrl = this;
    var scrollHandler = null;
    var clickHandler = null;
    ctrl.selectListStyle = {};

    ctrl.openSelect = false;
    ctrl.onClick = function () {
      ctrl.openSelect = !ctrl.openSelect;
      if (ctrl.openSelect) {
        registerListeners();
        $timeout(function() {
          var selectWrapper = $element[0].querySelector('.custom-select-wrapper');
          if (!selectWrapper) {
            return;
          }
          var rect = selectWrapper.getBoundingClientRect();
          var baseWidth = rect.width;
          if (ctrl.additionalWidth) {
            baseWidth += ctrl.additionalWidth;
          }
          var customSelectListStyle = {
            top: rect.bottom + 'px',
            left: rect.left + 'px',
            width: baseWidth + 'px',
            display: 'block'
          };
          if (ctrl.isAbsolute) {
            customSelectListStyle.position = 'absolute';
            customSelectListStyle.right = 0;
            customSelectListStyle.left = 'unset';
            customSelectListStyle.top = 'auto';
          }
          ctrl.selectListStyle = customSelectListStyle;
        });
      }
    };

    function registerClickOutside() {
      clickHandler = function (event) {
        var rootEl = $element[0];

        if (rootEl.contains(event.target)) {
          return;
        }
        ctrl.openSelect = false;
        $scope.$applyAsync();
        unregisterListeners();
      };
      $document[0].addEventListener("click", clickHandler, true);
    }

    function registerListeners() {
      registerClickOutside();
      if (ctrl.isAbsolute) {
        return;
      }
      scrollHandler = function (event) {
      var rootEl = $element[0];
      if (rootEl.contains(event.target)) {
        return;
      }
      ctrl.openSelect = false;
      $scope.$applyAsync();
      unregisterListeners();
      };
      $window.addEventListener('scroll', scrollHandler, true);
    }

    function unregisterListeners() {
      if (scrollHandler) {
        $window.removeEventListener('scroll', scrollHandler, true);
        scrollHandler = null;
      }
      if (clickHandler) {
        $document[0].removeEventListener("click", clickHandler, true);
        clickHandler = null;
      }
    }

    ctrl.$onDestroy = function () {
      unregisterListeners();
    };

    ctrl.onClickSelectOption = function (selectedId) {
      ctrl.selectedId = selectedId;
      if (ctrl.onClickOption) {
        ctrl.onClickOption(ctrl.selectedId, ctrl.context);
      }
      ctrl.openSelect = false;
    };

    ctrl.getSelectedItem = function () {
      if (!ctrl.data) {
        return null;
      }
      var foundElement = ctrl.data.find(function (element) {
        if (element.id === ctrl.selectedId) {
          return element;
        }
      });
      if (foundElement) {
        return foundElement;
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations("es", {
      CustomSelect: {
        requires_documentation_update: "Requiere actualizar documentación",
        documentation_up_to_date: "Documentación al día",
        documentation_not_current: "Documentación no vigente",
        vehicle_blocked: "Conductor bloqueado"
      }
    });

    $translateProvider.translations("en", {
      CustomSelect: {
        requires_documentation_update: "Requires documentation update",
        documentation_up_to_date: "Documentation up to date",
        documentation_not_current: "Documentation not current",
        vehicle_blocked: "Driver blocked"
      }
    });

    $translateProvider.translations("pt", {
      CustomSelect: {
        requires_documentation_update: "Requer atualização de documentação",
        documentation_up_to_date: "Documentação atualizada",
        documentation_not_current: "Documentação não está atualizada",
        vehicle_blocked: "Motorista bloqueado"
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  'use strict';
  angular
  .module('icarus.planner')
  .component('buttonItem', {
    templateUrl: 'app/planner/components/buttonItem/buttonItem.html',
    bindings: {
      onClick: '&',
      isButtonActive: '<',
      iconPath: '@',
      isVisitsLoaded: '<'
    },
    controller: buttonItemController
  });

/** @ngInject */

  function buttonItemController () {
    var ctrl = this;

    ctrl.clickButton = function () {
      ctrl.onClick();
    };
  }

})();


(function () {
  "use strict";

  angular
    .module('icarus.main')
    .factory('sidebarUtils', sidebarUtils);

  /** @ngInject */
  function sidebarUtils(__env, $state, $window, plannerService, DRAFT_FOR_APOLLO) {
    return {
      isItemActive: isItemActive,
      goToModule: goToModule,
      isNavbarHeightExceeded: isNavbarHeightExceeded,
      handleNavigation: handleNavigation
    };

    function isItemActive(item) {
      if (item.subsections) {
        return item.subsections.items.some(function (item) {
          return $state.includes(item.title);
        });
      }

      return $state.includes(item.title) || false;
    }

    function goToModule(item) {
      item.active = true;
      var href = item.href;
      var hrefTypeOf = typeof href;
      if (hrefTypeOf === "function") {
        href();
      } else if (hrefTypeOf === "string") {
        if (href.includes("http")) {
          handleNavigation(href);
          return;
        }
        $state.go(href);
      }
    }

    function isNavbarHeightExceeded() {
      var element = document.getElementById('nav-bar-modules-list');
      return element.scrollHeight > element.clientHeight;
    }

    function handleNavigation(href) {
      if (href.includes(__env.APOLLO_URI)) {
        if (plannerService.getActiveVehicles().length > 0) {
          return plannerService.setOriginalPlanAndSaveDraftPlanFormat(DRAFT_FOR_APOLLO)
            .finally(function () {
              $window.open(href, '_self');
            });
        }

        $window.open(href, '_self');
      } else if (href.includes(__env.URL_ROOT)) {
        $window.open(href, '_blank');
      } else if (href.startsWith('#')) {
        var path = href.substring(2);
        path = path.replace(/\/$/, '');

        var stateParts = path.split('/');
        if (stateParts[0] === 'settings') {
          var state = 'settings.' + stateParts[1] + '.list';
          $state.go(state);
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.planner')
    .filter('trusted', trusted);

  /** @ngInject */
  function trusted($sce){
    return function(url) {
        return $sce.trustAsResourceUrl(url);
    };
  }

})();

/* global FileReader:false */
(function(){
  'use strict';

  angular
    .module('icarus')
    .controller('UprofilePaymentController', UprofilePaymentController);

  /** @ngInject */
  function  UprofilePaymentController ($log, $scope, $state, sessionService, vehicleService,
                                       AMOUNT_PER_VEHICLE,
                                       $rootScope, ngDialog, plannerService) {
    var vm = this;

    vm.errorPayment = false;
    vm.errorCoupon = false;
    vm.successPayment = false;
    vm.expiry_invalid = false;
    vm.enable_discount_code = false;
    vm.discount_code = null;

    vm.goBack = goBack;
    vm.AMOUNT_PER_VEHICLE = AMOUNT_PER_VEHICLE;

    activate();

    function activate () {
      sessionService.getUser().then(function (user) {
        vm.user = user;
        vehicleService.list().then(function (vehicles) {
          vm.minVehicle = vehicles.length;

          // Si el usuario no tiene vehiculos el pago minimo es de 1
          if (vehicles.length === 0){
            vm.planQuantity = 1;
            vm.minVehicle = 1;
          } else {
            vm.planQuantity = vehicles.length;
          }

          // Si el usuario pago mas de los vehiculos que tiene
          // esta es la cantidad que se muestra
          if (vm.user.account.plan_quantity > vm.planQuantity && vm.user.account.status !== 'trialing') {
            vm.planQuantity = vm.user.account.plan_quantity;
          }
        });
      });
    }

    $scope.stripeCallback = function (code, result) {
      if (result.error) {
        vm.expiry_invalid = true;
      } else {

        $rootScope.isLoading = true;
        vm.user.account.plan_quantity = vm.planQuantity;
        if (!vm.enable_discount_code) {
          vm.discount_code = null;
        }
        sessionService.setSubscription(vm.user.account.plan_quantity, result.id, vm.discount_code)
          .then(function processUpgradeSuccess() {
            vm.successPayment = true;
            if (vm.user.account.plan_quantity < vm.minVehicle) {
              for (var i = vm.minVehicle + 1; i < vm.user.account.plan_quantity + 1; i++) {
                vehicleService.create({name: 'Vehicle ' + i, capacity: 1});
              }
            }
            $rootScope.isLoading = false;
            vm.successPayment = false;
            vm.errorPayment = false;
            vm.errorCoupon = false;
            $rootScope.showTrial = false;

            sessionService.changeStatusAccount();
            plannerService.clearPlanPromise();
            $state.go("^");
            _showDialogSuccessBox();
          })
          .catch(function processChangeCardError (error) {
            $rootScope.isLoading = false;
            $log.info(error);

            if (String(error).toLowerCase().indexOf(String('No such coupon').toLowerCase()) !== -1 ||
              (String(error).toLowerCase().indexOf(String('This coupon is not valid').toLowerCase()) !== -1)) {
              vm.errorCoupon = true;
            }else{
              vm.errorPayment = true;
            }
          });
      }
    };

    function goBack () {

      $state.go("^");
    }

    function _showDialogSuccessBox () {
      ngDialog.open({
        template: 'app/uprofile/payment/payment-success-modal.html',
        scope: $rootScope
      });
    }

  }
})();

/* global FileReader:false */
(function(){
  'use strict';

  angular
    .module('icarus')
    .controller('UprofileSubscriptionController', UprofileSubscriptionController);

  /** @ngInject */
  function  UprofileSubscriptionController ($scope, $log, $state, sessionService, $uibModalInstance, $rootScope) {
    var vm = this;
    vm.cancelSubscription = cancelSubscription;


    function cancelSubscription () {
      $rootScope.isLoading = true;
      sessionService.cancelSubscription()
      .catch(function (error) {
        $rootScope.isLoading = false;
        $log.info(error);
      })
      .finally(function () {
        $uibModalInstance.dismiss('close');
        $rootScope.isLoading = false;
      });

    }

  }
})();

/* global FileReader:false */
(function(){
  'use strict';

  angular
    .module('icarus')
    .controller('UprofileChangePassController', UprofileChangePassController);

  /** @ngInject */
  function  UprofileChangePassController ($state, $filter, sessionService, $timeout, securityService, Toasts, $log) {
    var vm = this;
    var $translate = $filter('translate');
    vm.error_match_password = false;
    vm.error_invalid_password = false;
    vm.error_invalid_password_policies = false;

    vm.user = {};
    vm.password = {};
    vm.new_password = {};
    vm.confirm_password = {};
    vm.validation = {};
    vm.policies = {};

    vm.validatePassword = validatePassword;
    vm.goBack = goBack;
    vm.saveData = saveData;
    vm.changeTypeInput = changeTypeInput;

    activate();

    var passwordStates = {
      value: '',
      type: 'password',
      error: null,
      error_txt: null,
      success_txt: null
    };

    function activate() {
      sessionService.getUser().then(function (user) {
        vm.user = user;
        angular.extend(vm.password, passwordStates);
        angular.extend(vm.new_password, passwordStates);
        angular.extend(vm.confirm_password, passwordStates);
        _getSecuritySetting();
        showPoliciesInForm();
      });
    }

    function goBack() {
      $state.go("^");
    }

    function changeTypeInput(obj) {
      if (obj.type === 'password') {
        obj.type = 'text';
      } else {
        obj.type = 'password';
      }
    }

    function saveData() {
      if (securityService.formPasswordValidation(vm.validation)) {
        vm.error_invalid_password_policies = true;
        return;
      }
      //Obtener la contrasena del usuario
      if (vm.new_password.value === vm.confirm_password.value) {
        sessionService.changePassword(vm.new_password.value, vm.password.value).then(
          function success() {
            vm.success_change_password = true;
          })
          .catch(function fail() {
            vm.error_invalid_password = true;
          }).finally(function () {
            $timeout(function () {
          }, 2000).then(function () {
            vm.error_invalid_password = false;
            if (vm.success_change_password) {
              vm.success_change_password = false;
              $state.go("^");
            }
          });
        });
      } else {
        vm.error_match_password = true;
        $timeout(function () {
        }, 2000).then(function () {
          vm.error_match_password = false;
        });
      }
    }

    function _isUserDriverOrCodriver(user) {
      return !(user.is_admin || user.is_coordinator || user.is_monitor || user.is_router
        || user.is_router_jr || user.is_staff || user.is_owner) && (user.is_driver || user.is_codriver);
    }

    function _getSecuritySetting() {
      securityService.get({}).then(function (res) {
        if (res.status !== 200) {
          vm.policies = {
            "length": 8,
            "uppercase": false,
            "lowercase": false,
            "number": false,
            "symbol": false
          };
        } else {
          var driver = _isUserDriverOrCodriver(vm.user);
          securityService.buildBodyToShow(res.data, driver, vm.policies);
        }
        securityService.buildValidation(vm.validation, vm.policies);
        if (res.status !== 204 && res.status !== 200) {
          throw 'Unexpected response status: ' + res.status;
        }
      }).catch(function (err) {
        Toasts.push('error', $translate('Security.settings_retrieval_error'));
        $log.error(err);
      });
    }

    function validatePassword() {
      securityService.validatePassword(vm.new_password.value, vm.validation, vm.policies);
    }

    function showPoliciesInForm() {
      var form = document.getElementById('change-password-form');
      var input = document.getElementById('change-password-input');
      var policies = document.getElementById('change-password-policies');
      var exceptions = document.getElementsByClassName('except_policies_hidden');
      if (form !== null && input !== null && policies !== null && exceptions !== null) {
        input.addEventListener('focus', function (event) {
          policies.style.display = "block";
        });
        form.addEventListener('click', function (event) {
          for (var i = 0; i < exceptions.length; i++) {
            if (exceptions[i] === event.target) {
              return;
            }
            ;
          }
          policies.style.display = "none";
        });
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .controller('VehiclesController', VehiclesController);

  /** @ngInject */
  function VehiclesController($scope, $rootScope, $state, $stateParams, moment, $anchorScroll,
                              trackingService, planService, accountConfigsService,TRACKING_EVENTS, $filter, TRACKING_CONSTANTS) {
    var vm = this;
    var trackingDate = $stateParams.trackingDate;
    var $translate = $filter('translate');
    vm.loadingData = false;
    vm.vehiclesFilters = [];
    vm.vehicles = [];
    vm.activeVehicles = [];
    vm.inactiveVehicles = [];
    vm.drivers = [];
    vm.selectedVehicleId = null;
    vm.selectedVehicleDriver = null;
    vm.searchKeyword = '';
    vm.checkKey = checkKey;
    vm.filterVehicles = filterVehicles;
    vm.loadProgressByVehicles = _loadProgressByVehicles;
    vm.clearFilter = clearFilter;
    vm.codriverTranslate = $translate('Vehicle.codriver');
    vm.visitAlert = $translate('Visits.alerts');
    vm.routeFinishedTranslation = $translate('Events.gps_route_finished');
    vm.toggleListVehicleDriver = toggleListVehicleDriver;
    vm._scrollToVehicle = _scrollToVehicle;
    vm.vehiclesSortOptions = [
      {
        label: $translate('Vehicle.vehicle_sort_by_name_asc'),
        value: TRACKING_CONSTANTS.FILTER_OPTIONS.NAME_ASC
      },
      {
        label: $translate('Vehicle.vehicle_sort_by_name_desc'),
        value: TRACKING_CONSTANTS.FILTER_OPTIONS.NAME_DESC
      },
      {
        label: $translate('Vehicle.vehicle_sort_by_progress_asc'),
        value: TRACKING_CONSTANTS.FILTER_OPTIONS.PROGRESS_ASC
      },
      {
        label: $translate('Vehicle.vehicle_sort_by_progress_desc'),
        value: TRACKING_CONSTANTS.FILTER_OPTIONS.PROGRESS_DESC
      },
      {
        label: $translate('Vehicle.vehicle_sort_by_start_time_asc'),
        value: TRACKING_CONSTANTS.FILTER_OPTIONS.ROUTE_ASC
      },
      {
        label: $translate('Vehicle.vehicle_sort_by_start_time_desc'),
        value: TRACKING_CONSTANTS.FILTER_OPTIONS.ROUTE_DESC
      }
    ];
    vm.vehicleSort = TRACKING_CONSTANTS.FILTER_OPTIONS.NAME_ASC;
    vm.sortVehicles = sortVehicles;
    activate();

    var listenerGeneralProgressChanged = $scope.$on(TRACKING_EVENTS.REFRESH.GENERAL_PROGRESS_CHANGED, _refreshData);
    var listenerChangeVehicleSelected = $scope.$on(TRACKING_EVENTS.REFRESH.CHANGE_VEHICLE_SELECTED, _changeSelectedVehicle);
    var listenerDateChanged = $scope.$on(TRACKING_EVENTS.REFRESH.DATE_CHANGED, _refreshDataOnDateChanged);
    var listenerDataReady = $scope.$on(TRACKING_EVENTS.VEHICLES.VEHICLES_READY, _refreshDataOnVehiclesReady);
    var listenerGetVehicleDriverActive = $scope.$on(TRACKING_EVENTS.VEHICLES.GET_VEHICLE_DRIVER_ACTIVE, _returnDriverVehiceActive);
    var listenerScrollToVehicle = $scope.$on(TRACKING_EVENTS.VEHICLES.SCROLL_TO_VEHICLE, _scrollToVehicle);
    $scope.$on('$destroy', _stopVehiclesController);

    ///////////////////////////////////////////////////////

    function activate() {
      vm.vehicles = $rootScope.trackingVehicles;
      vm.canCreateCoDriver = accountConfigsService.isConfigEnabled("can_create_co_driver");
      vm.vehiclesFilters = $rootScope.trackingVehicles;
      if ($rootScope.trackingVehicles.length > 0){
        _loadProgressByVehicles(trackingDate);
        $scope.$emit(TRACKING_EVENTS.MAP.LOAD_VEHICLES_LAST_POSITION, {date:trackingDate, fitboundsFlag: true});
        vm.vehicleSort = TRACKING_CONSTANTS.FILTER_OPTIONS.NAME_ASC;
        vm.sortVehicles(vm.vehiclesFilters);
      }
    }

    function _scrollToVehicle(event, elementId) {
      $anchorScroll(elementId);
    }

    function filterVehicles() {
      if (vm.selectedVehicleId !== null) {
        vm.selectedVehicleId = null;
        vm.selectedVehicleDriver = null;
      }
      vm.vehiclesFilters = $filter('trackingSearchVehicles')(vm.vehicles, vm.searchKeyword);
    }

    function checkKey(event) {
      if (!vm.searchKeyword) {
        clearFilter();
      } else {
        if (event.keyCode === 13) {
          filterVehicles();
        }
      }

    }

    function clearFilter() {
      vm.searchKeyword = '';
      vm.vehiclesFilters = vm.vehicles;
    }

    function toggleListVehicleDriver(vehicle) {
      if (vehicle.id === vm.selectedVehicleId) {
        vm.selectedVehicleId = null;
        vm.selectedVehicleDriver = null;
        $scope.$emit(TRACKING_EVENTS.MAP.FIT_BOUNDS_VEHICLES_LAST_POSITION);
        $scope.$emit(TRACKING_EVENTS.MAP.SET_DEFAULT_TIME_FILTER);
        $state.go('^');
      } else {
        vm.selectedVehicleDriver = vehicle.driver instanceof Object ? vehicle.driver.id : null;
        var params = {
          vehicleId: vehicle.id,
          driverId: vm.selectedVehicleDriver
        };

        trackingService.selectVehicle(vehicle);
        $state.go('tracking.vehicles.driver-dispatchs', params);
      }
    }

    function sortVehicles(vehicles) {
      return vehicles.sort(function (a, b) {
        switch(vm.vehicleSort) {
          case TRACKING_CONSTANTS.FILTER_OPTIONS.NAME_ASC:
            return a.name.localeCompare(b.name);

          case TRACKING_CONSTANTS.FILTER_OPTIONS.NAME_DESC:
            return b.name.localeCompare(a.name);

          case TRACKING_CONSTANTS.FILTER_OPTIONS.PROGRESS_ASC:
            if (a.progress === b.progress) {
              return a.name.localeCompare(b.name);
            }
            return a.progress - b.progress;

          case TRACKING_CONSTANTS.FILTER_OPTIONS.PROGRESS_DESC:
            if (a.progress === b.progress) {
              return a.name.localeCompare(b.name);
            }
            return b.progress - a.progress;

          case TRACKING_CONSTANTS.FILTER_OPTIONS.ROUTE_ASC:
            var ascA = a.startTime ? moment(a.startTime) : moment().endOf('day');
            var ascB = b.startTime ? moment(b.startTime) : moment().endOf('day');
            if (ascA === ascB) {
              return b.name.localeCompare(a.name);
            }
            return ascA.diff(ascB);

          case TRACKING_CONSTANTS.FILTER_OPTIONS.ROUTE_DESC:
            var descA = a.startTime ? moment(a.startTime) : moment().startOf('day');
            var descB = b.startTime ? moment(b.startTime) : moment().startOf('day');
            if (descA === descB) {
              return b.name.localeCompare(a.name);
            }
            return descB.diff(descA);
        }
      }
      );
    }

    function _isSelectedVehicleNotInList(selectedVehicleId, vehicles) {
      return selectedVehicleId && vehicles.every(function (vehicle) {
        return vehicle.id !== selectedVehicleId;
      });
    }

    function _refreshData(event, data) {
      vm.vehiclesFilters = $rootScope.trackingVehicles;
      vm.vehicles = $rootScope.trackingVehicles;
      _loadProgressByVehicles(data.date, data.fleet);
      $scope.$emit(TRACKING_EVENTS.MAP.LOAD_VEHICLES_LAST_POSITION, { date:data.date, fitboundsFlag: false });
      vm.vehicleSort = TRACKING_CONSTANTS.FILTER_OPTIONS.NAME_ASC;
      vm.sortVehicles(vm.vehiclesFilters);
    }

    function _refreshDataOnVehiclesReady(event, data) {
      _refreshData(event, data);
      if (_isSelectedVehicleNotInList(vm.selectedVehicleId, vm.vehicles)) {
        vm.selectedVehicleId = null;
        vm.selectedVehicleDriver = null;
        $scope.$emit(TRACKING_EVENTS.MAP.FIT_BOUNDS_VEHICLES_LAST_POSITION);
        $scope.$emit(TRACKING_EVENTS.MAP.SET_DEFAULT_TIME_FILTER);
        $state.go('^');
      }
    }

    function _refreshDataOnDateChanged(event, data) {
      _refreshData('dateChange', data);
      $rootScope.$broadcast(TRACKING_EVENTS.REFRESH.DATE_CHANGED_REFRESH_VISITS, {
        vehicles: vm.vehicles,
        date: data.date
      });
    }

    function _stopVehiclesController() {
      _clearVehicles();
      _clearEvents();
    }

    function _clearVehicles() {
      $scope.$emit(TRACKING_EVENTS.MAP.CLEAR_VEHICLE_MARKERS);
      vm.selectedVehicleId = null;
      vm.selectedVehicleDriver = null;
    }

    function _clearEvents () {
      listenerGeneralProgressChanged();
      listenerChangeVehicleSelected();
      listenerDateChanged();
      listenerDataReady();
      listenerGetVehicleDriverActive();
      listenerScrollToVehicle();
    }

    function _calculateProgressPercentage(progress) {
      return progress.total ? Math.round(((progress.completed + progress.failed + progress.partial) / progress.total) * 100) : 0;
    }

    function _loadProgressByVehicles(date, fleet) {
      angular.forEach(vm.vehicles, function (vehicle) {
        vehicle.hasFailedVisits = false;
      });
      planService.getProgressVehicleByDateAndFleet(date, fleet)
        .then(function (response) {
          angular.forEach(response.data, function (progressInfo) {
            var vehicle = vm.vehicles.find(function (vehicle) {
              if (!accountConfigsService.isConfigEnabled('enable_multi_drivers')) {
                return vehicle.id === progressInfo.id;
              } else {
                var bothVehiclesWithoutDriver = vehicle.driver === null && progressInfo.driver === null;
                var bothVehiclesWithSameDriver = vehicle.driver ? vehicle.driver.id === progressInfo.driver : false;
                return vehicle.id === progressInfo.vehicle && (bothVehiclesWithoutDriver || bothVehiclesWithSameDriver);
              }
            });

            var progressData = progressInfo.progress;
            var progressRoutesStatus = progressData.routes_status;
            var someRouteStarted = !!Object.keys(progressRoutesStatus).find(function (route) {
              return progressRoutesStatus[route] === 'started' || progressRoutesStatus[route] === 'completed';
            });
            vehicle.countAlertedVisits = _calculateAlertsByVehicle(progressData);
            vehicle.hasAlertedVisits = !!progressData.alerts || !!progressData.failed;
            vehicle.startTime = progressData.last_route_start_time;
            vehicle.formatStartTime = progressData.last_route_start_time ?
              moment(progressData.last_route_start_time).format('HH:mm') : null;
            vehicle.progress = _calculateProgressPercentage(progressData);
            vehicle.totalVisits = progressData.total;
            vehicle.madeVisits = progressData.completed + progressData.failed + progressData.partial;
            vehicle.out_of_window = progressData.out_of_window;
            var hasUnfinishedRoutes = !!Object.keys(progressRoutesStatus).find(function (route) {
              return progressRoutesStatus[route] !== 'completed';
            });
            vehicle.hasUnfinishedRoutes = hasUnfinishedRoutes;
            if (vehicle.progress > 0 || (someRouteStarted && vehicle.progress < 100)) {
              vehicle.isActive = true;
            }
          });
        });
    }

    function _changeSelectedVehicle(event, data) {
      var vehicleId = data.vehicleId;
      vm.selectedVehicleId = vehicleId;
      vm.selectedVehicleDriver = data.driverId;
    }

    function _returnDriverVehiceActive() {
      $scope.$emit(TRACKING_EVENTS.VEHICLES.RETURN_VEHICLE_DRIVER_ACTIVE, {});
    }

    function _calculateAlertsByVehicle(data) {
      return parseInt(data.alerts + data.failed) > 0 ? parseInt(data.alerts + data.failed) : '';
    }

  }
})();

/* global google:false*/
(function () {
  'use strict';

  angular
    .module('icarus')
    .factory('trackingService', trackingService);

  /** @ngInject */
  function trackingService($q, $http, $stateParams, __env, moment, $rootScope, planService, extraFieldsService) {

    var VISITS_PATH = __env.API_URL + 'routes/visits/';
    var LOCATIONS_PATH = __env.API_TRACK_URL + 'tracking/locations/';
    var LAST_LOCATION_PATH = __env.API_TRACK_URL + 'tracking/locations/latest/';
    var ROUTE_EVENTS_PATH = __env.API_URL + 'routes/';

    var vehicleSelected = null;
    var visitSelected = null;
    var _locationsGps = [];

    var service = {
      getVehicleByIdAndDriver: getVehicleByIdAndDriver,
      getLocationsByVehicleOrDriver: getLocationsByVehicleOrDriver,
      getVehicleRestTime: getVehicleRestTime,
      selectVehicle: selectVehicle,
      selectVisit: selectVisit,
      downloadAttachment: downloadAttachment,
      filterVisits: filterVisits,
      filterVehicleLastPosition: filterVehicleLastPosition,
      getLastVehiclesLocation: getLastVehiclesLocation,
      setLocationsGps: setLocationsGps,
      getLocationGps: getLocationGps,
      manageGetVisitForTrackingDetail: manageGetVisitForTrackingDetail
    };

    return service;

    ////////

    function selectVehicle(vehicle) {
      vehicleSelected = vehicle;
    }

    function selectVisit(visit) {
      visitSelected = visit;
    }

    function loadLastVehicleLocationByDate(date) {
      var httpConfig = {params: {date: date}};
      return $http.get(LAST_LOCATION_PATH, httpConfig);
    }

    function getVehicleByIdAndDriver(vehicleId, driverId) {
      if ($rootScope.trackingDate !== $stateParams.trackingDate) {
        vehicleSelected = null;
      }

      if (vehicleSelected && vehicleSelected.id === vehicleId) {
        return $q.when(vehicleSelected);
      }
      driverId = driverId ? driverId : "null";

      return planService.getVehicleByIDAndDriverAndDate($rootScope.trackingDate, vehicleId, driverId);
    }

    function manageGetVisitForTrackingDetail(visitID) {
      var deferred = $q.defer();

      planService.getVisitDetailByID(visitID)
        .then(function (visit) {
          selectVisit(visit);
          if (Object.keys(visit.extra_field_values).length > 0) {
            extraFieldsService.getExtraFields()
              .then(function (extraFieldsDefinition) {
                var extraFields = [];
                for (var i = 0; i < extraFieldsDefinition.length; i++) {
                  var key = extraFieldsDefinition[i].key;
                  var label = extraFieldsDefinition[i].label;
                  var type = extraFieldsDefinition[i].type;

                  if (visit.extra_field_values[key]) {
                    if (type !== 'RDD') {
                      var extraFieldProperties = {
                        key: key,
                        label: label,
                        type: type,
                        value: visit.extra_field_values[key]
                      };

                      if (type === 'PIC') {
                        extraFieldProperties.url = extraFieldsService.parseFieldUrls(visit.extra_field_values[key]);
                      }

                     extraFields.push(extraFieldProperties);
                    } else {
                      var rddLabels = label.split('|');
                      var rddFields = Object.keys(visit.extra_field_values[key]);
                      rddFields.forEach(function(extrafield) {
                        var rddFieldProperties = {
                          key: key,
                          topLabel: rddLabels[0],
                          topLabelValue: extrafield,
                          secondLabel: rddLabels[1],
                          secondLabelValue: Object.values(visit.extra_field_values[key][extrafield]).join(', '),
                          type: type
                        };

                        extraFields.push(rddFieldProperties);
                      });
                    }
                  }
                }

                visit.extra_field_values = extraFields;
                deferred.resolve(visit);
              }).finally(function () {
                deferred.resolve(visit);
              });
          } else {
            deferred.resolve(visit);
          }
        })
        .catch(function (error) {
          deferred.resolve(null);
        });

      return deferred.promise;
    }

    function getVehicleRestTime(vehicleId, date) {
      var deferred = $q.defer();
      $http.get(ROUTE_EVENTS_PATH + 'vehicles/' + vehicleId + '/events/' + date + '/?type=rest_time')
        .then(function routeEventsSuccess(response) {
          deferred.resolve(response.data);
        })
        .catch(function routeEventsError(error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function getLocationsByVehicleOrDriver(trackingDate, vehicleID, driverID) {
      var params = {};

      if (vehicleID && driverID) {
        params = {
          "driver_id": driverID,
          "vehicle_id": vehicleID
        };
      } else if (driverID) {
        params = {
          "driver_id": driverID
        };
      } else if (vehicleID) {
        params = {
          "vehicle_id": vehicleID
        };
      }

      return $http.get(LOCATIONS_PATH + trackingDate + '/', {params: params});
    }

    function downloadAttachment(visitId) {
      return $http.get(VISITS_PATH + visitId + '/download-attachment/',
        {
          responseType: 'arraybuffer',
          headers: {'Content-Type': 'application/zip'}
        });
    }

    function filterVisits(visits, start_time, end_time) {
      var momentStartTime = moment(start_time, "HH:mm");
      var momentEndTime = moment(end_time, "HH:mm");
      var output = [];
      visits.forEach(function(visit) {
        var estimatedTimeArrival = moment(visit.estimated_time_arrival, "HH:mm");
        if (estimatedTimeArrival.isBetween(momentStartTime, momentEndTime, null, '[]')) {
          output.push(visit.id);
        }
      });
      return output;
    }

    function filterVehicleLastPosition(vehicles, start_time, end_time) {
      var momentStartTime = moment(start_time, "HH:mm");
      var momentEndTime = moment(end_time, "HH:mm");
      var output = [];
      vehicles.forEach(function(vehicle) {
        var timestamp = moment(vehicle.timeStamp).format("HH:mm");
        var locationTime = moment(timestamp, "HH:mm");
        if (locationTime.isBetween(momentStartTime, momentEndTime, null, '[]')) {
          output.push({vehicle: vehicle.vehicleId, driver: vehicle.driverId});
        }
      });
      return output;
    }

    function lastVehicleLocationsWithFleetsUrl(fleetId) {
      return LOCATIONS_PATH + 'fleet/' + fleetId + '/latest/';
    }

    function loadLastVehicleLocationByFleetAndDate(fleetId, date) {
        var httpConfig = {params: {date: date}};
        return $http.get(lastVehicleLocationsWithFleetsUrl(fleetId), httpConfig);
    }

    function getLastVehiclesLocation(date, opts) {
      var promise;

      opts = opts ? opts : { useFleets: false, fleetId: null };

      if (opts.useFleets && opts.fleetId) {
        promise = loadLastVehicleLocationByFleetAndDate(opts.fleetId, date);
      }else {
        promise = loadLastVehicleLocationByDate(date);
      }
      return promise;
    }

    function setLocationsGps(locations) {
      _locationsGps = locations;
    }

    function getLocationGps() {
      return _locationsGps;
    }
  }
})();

/**
 * Created by rodrigo on 08-02-17.
 */
(function() {
  'use strict';

  angular
    .module('icarus')
    .factory('TrackingMapService', trackingMapService);

  /*@ngInject*/
  function trackingMapService(moment, tinycolor, lodash, $filter, $sanitize, TRACKING_IMAGES_FOLDER_PATH,
                              VISIT_STATUS_PENDING, TRACKING_VISIT_MARKER_SIZE_IDENTIFIER) {

    var $translate = $filter('translate');
    var defaultColor = '#73768c';
    var completedColor = '#41D3BD';
    var partialColor = '#FCBA03';
    var failedColor = '#FF5252';
    var canceledColor = '#607D8B';
    var markerDefaultZIndex = 100;
    var markerCheckoutZIndex = 9999;
    var vehicleMarkerDefaultZIndex = 999999;

    return {
      updateMarker: updateMarker,
      fitBoundsToMarkers: fitBoundsToMarkers,
      fitBoundsToVehicleMarkers: fitBoundsToVehicleMarkers,
      fitBoundsToPolylines: fitBoundsToPolylines,
      getVisitMarkerOptions: getVisitMarkerOptions,
      getVehicleMarkerOptions: getVehicleMarkerOptions,
      getPolylineOptions: getPolylineOptions,
      getPolylineContent: getPolylineContent,
      getMarkerIcon: getMarkerIcon
    };

    function _getColorsByStatus(status) {
      var markerColor;
      var markerStrokeColor;

      switch (status) {
        case 'completed':
          markerColor = completedColor;
          markerStrokeColor = tinycolor(completedColor).darken(15).toString();
          break;
        case 'partial':
          markerColor = partialColor;
          markerStrokeColor = tinycolor(partialColor).darken(15).toString();
          break;
        case 'failed':
          markerColor = failedColor;
          markerStrokeColor = tinycolor(failedColor).darken(15).toString();
          break;
        case 'canceled':
          markerColor = canceledColor;
          markerStrokeColor = tinycolor(canceledColor).darken(15).toString();
          break;
        default:
          markerColor = defaultColor;
          markerStrokeColor = '#324376';
      }

      return {
        strokeColor: markerStrokeColor,
        fillColor: markerColor
      };
    }

    function getMarkerIcon(visit, hasOnlyCheckinTime, isInCurrentRoute, isHoverIndicator) {
      var markerIcon = {url: _getMarkerIconUrl(hasOnlyCheckinTime, isInCurrentRoute, isHoverIndicator)};

      if (hasOnlyCheckinTime) {
        lodash.merge(markerIcon, {fillColor: defaultColor, anchor: {x: 8, y: 35}});
      } else {
        lodash.merge(markerIcon, _getColorsByStatus(visit.status), {anchor: {x: 10, y: 31}});
      }

      return markerIcon;
    }

    function _getMarkerIconUrl(hasOnlyCheckinTime, isInCurrentRoute, isHoverIndicator) {
      var iconFileName;
      var markerSize = isInCurrentRoute ? TRACKING_VISIT_MARKER_SIZE_IDENTIFIER.LARGE :
        TRACKING_VISIT_MARKER_SIZE_IDENTIFIER.SMALL;

      if (isHoverIndicator) {
        iconFileName = 'visit_' + markerSize + '_hover_indicator.svg';
      } else {
        iconFileName = 'visit_' + markerSize + '_marker' + (hasOnlyCheckinTime ? '_with_circle.svg': '.svg');
      }

      return TRACKING_IMAGES_FOLDER_PATH + iconFileName;
    }

    function getVisitMarkerOptions(visit, hasOnlyCheckinTime, isInCurrentRoute, isHoverIndicator) {
      isInCurrentRoute = angular.isUndefined(isInCurrentRoute) || isInCurrentRoute;

      return {
        position: {
          latitude: visit.latitude,
          longitude: visit.longitude
        },
        icon: getMarkerIcon(visit, hasOnlyCheckinTime, isInCurrentRoute, isHoverIndicator),
        zIndex: getMarkerZIndex(visit, isHoverIndicator)
      };
    }

    function getMarkerZIndex(visit, isHoverIndicator) {
      if (visit.status !== VISIT_STATUS_PENDING) {
        return markerCheckoutZIndex  + (visit.order * 2);
      }
      var zIndex = markerDefaultZIndex  + (visit.order * 2);
      return isHoverIndicator ?  zIndex - 1 : zIndex;
    }

    function getVehicleMarkerOptions(data, vehicleIndex) {
      return {
        position: {
          latitude: parseFloat(data.latitude),
          longitude: parseFloat(data.longitude)
        },
        icon: {
          url: TRACKING_IMAGES_FOLDER_PATH + 'vehicle_marker.svg',
          fillColor: data.color,
          anchor: {
            x: 13,
            y: 20
          }
        },
        zIndex: vehicleMarkerDefaultZIndex + vehicleIndex
      };
    }

    function _getPolylinePath(locations) {
      return locations.map(function (location) {
        return {
          latitude: parseFloat(location.latitude).toFixed(6),
          longitude: parseFloat(location.longitude).toFixed(6)
        };
      });
    }

    function getPolylineOptions(pathCoords, color) {
      return {
        pathCoords: _getPolylinePath(pathCoords),
        strokeColor: color,
        strokeWeight: 4,
        geodesic: true
      };
    }

    function _getOrientation(angle) {
      var result = {
        direction: null,
        icon: ''
      };

      switch (true) {
        case (angle > -22.5 && angle < 22.5):
          result.direction = $translate('Directions.north');
          result.icon = "fa fa-long-arrow-up";
          break;
        case (angle > 22.5 && angle < 67.5):
          result.direction = $translate('Directions.northeast');
          result.icon = "fa fa-long-arrow-up rotate-noreste";
          break;
        case angle > 67.5 && angle < 112.5:
          result.direction = $translate('Directions.east');
          result.icon = "fa fa-long-arrow-right";
          break;
        case angle > 112.5 && angle < 157.5:
          result.direction = $translate('Directions.southeast');
          result.icon = "fa fa-long-arrow-up rotate-sureste";
          break;
        case (angle > 157.5 && angle < 180) || (angle >= -180 && angle < -157.5):
          result.direction = $translate('Directions.south');
          result.icon = "fa fa-long-arrow-down";
          break;
        case (angle > -157.5 && angle < -112.5):
          result.direction = $translate('Directions.southwest');
          result.icon = "fa fa-long-arrow-up rotate-suroeste";
          break;
        case (angle > -112.5 && angle < -67.5):
          result.direction = $translate('Directions.west');
          result.icon = "fa fa-long-arrow-left";
          break;
        case (angle > -67.5 && angle < -22.5):
          result.direction = $translate('Directions.northwest');
          result.icon = "fa fa-long-arrow-up rotate-noroeste";
          break;
        default:
          result.direction = $translate('Directions.noInfo');
          break;
      }

      return result;
    }

    function getPolylineContent(map, pathCoords, eventPosition, driverName) {
      var minDist = Number.MAX_VALUE;
      var index = 0;
      var heading = 0;
      var temperatureString = "";

      pathCoords.forEach(function (coord, coordIndex) {
        var endPosition = {
          latitude: parseFloat(coord.latitude),
          longitude: parseFloat(coord.longitude)
        };

        var distance = map.getDistanceBetweenPoints(eventPosition, endPosition);
        if (distance < minDist) {
          minDist = distance;
          index = coordIndex;
        }
      });

      var currentPathCoord = pathCoords[index];
      if (currentPathCoord.alerts) {
        var temperatureInfo = currentPathCoord.alerts.find(function (element) {
          return element.name === "temperature";
          }
        );

        if (temperatureInfo && temperatureInfo.value) {
          temperatureString = '<i class="sp-icon-notifications"></i> Temp: ' +
            temperatureInfo.value + temperatureInfo.type + '<br>';
        }
      }

      var nextPathCoord = pathCoords[index + 1];
      if (nextPathCoord) {
        var startPosition = {
          latitude: parseFloat(currentPathCoord.latitude),
          longitude: parseFloat(currentPathCoord.longitude)
        };

        var endPosition = {
          latitude: parseFloat(nextPathCoord.latitude),
          longitude: parseFloat(nextPathCoord.longitude)
        };

        heading = map.getHeading(startPosition, endPosition);
      }

      var orientation = _getOrientation(heading);
      var contentString = '<b><i class="sp-icon-vehiculos"></i> '+ driverName +'</b><br>' +
        '<i class="sp-icon-tiempo-servicio"></i> ' + moment(currentPathCoord.timestamp).format('HH:mm:ss') +'<br>' +
        '<i class="sp-icon-rutas"></i> ' + orientation.direction + ' <i class="'+ orientation.icon +'"></i> <br>' +
        temperatureString +
        'Lat:  ' + currentPathCoord.latitude + '<br>' +
        'Lng: ' + currentPathCoord.longitude + '<br>';

      return $sanitize(contentString);
    }

    function updateMarker(marker, visit) {
      if (visit.position && visit.position.latitude && visit.position.longitude) {
        marker.setPosition(parseFloat(visit.position.latitude), parseFloat(visit.position.longitude));
      }

      if (typeof visit.visible !== "undefined") {
        marker.setVisible(visit.visible);
      }

      if (typeof visit.status !== "undefined") {
        marker.setIcon(_getColorsByStatus(visit.status));
      }
    }

    function fitBoundsToMarkers(map, bounds, markers) {
      if (!bounds.bounds) {
        bounds.bounds = [];
      }

      for (var key in markers) {
        if (markers[key].getVisible()) {
          bounds.bounds.push(markers[key].getPosition());
        }
      }

      if (bounds.bounds.length > 0) {
        map.fitBounds(bounds.bounds);
      }
    }

    function fitBoundsToVehicleMarkers(map, bounds, vehicleOptions) {
      if (!bounds.bounds) {
        bounds.bounds = [];
      }

      for (var key in vehicleOptions) {
        if (vehicleOptions[key].marker) {
          bounds.bounds.push(vehicleOptions[key].marker.getPosition());
        }
      }

      if (bounds.bounds.length > 0) {
        map.fitBounds(bounds.bounds);
      }
    }

    function fitBoundsToPolylines(map, bounds, polylines) {
      if (!bounds.bounds) {
        bounds.bounds = [];
      }

      for (var key in polylines) {
        polylines[key].forEach(function(polyline) {
          polyline.getPath().forEach(function(point) {
            bounds.bounds.push(point);
          });
        });
      }

      if (bounds.bounds.length > 0) {
        map.fitBounds(bounds.bounds);
      }
    }
  }
})();

/* global FileReader:false */
(function () {
  'use strict';

  angular
    .module('icarus')
    .controller('TrackingInfoController', TrackingInfoController);

  /** @ngInject */
  function TrackingInfoController($state, $uibModalInstance) {
    var vm = this;
    vm.state = $state;
    vm.redirect = redirect;

    function redirect(bool) {
      if (bool) {
        $state.go('planner.vehicles-list');
      }

      $uibModalInstance.dismiss('close');
    }
  }
})();

(function() {
'use strict';
angular
  .module('icarus')
  .filter('trackingSearchVisits', trackingSearchVisits);

/** @ngInject */
function trackingSearchVisits ($rootScope) {
    return function(arr, searchString){
        if(!searchString){
            return arr;
        }

        var result = [];
        searchString = searchString.toLowerCase();
        angular.forEach(arr, function(item){
            // buscar por reference id
            if(item.reference.toLowerCase().indexOf(searchString) !== -1){
                result.push(item);
            } else if (item.title.toLowerCase().indexOf(searchString) !== -1) {
                // buscar por titulo
                result.push(item);
            } else if (item.address.toLowerCase().indexOf(searchString) !== -1) {
                // buscar por direccion
                result.push(item);
            }
        });

        // evento para activar vista de las visitas vacias luego del filtrado
        $rootScope.$broadcast('visitsFilters', result);

        return result;
    };
}
})();

(function () {
  'use strict';
  angular
    .module('icarus.shared')
    .filter('trackingSearchVehicles', trackingSearchVehicles);

  /** @ngInject */
  function trackingSearchVehicles(lodash) {
    return function (arr, searchString) {
      var lowerCaseString = searchString.toLowerCase();
      return lodash.filter(arr, function(vehicle) {
        var lowerCaseVehicleName = vehicle.name.toLowerCase();
        var lowerCaseDriverName = vehicle.driver && vehicle.driver.name ? vehicle.driver.name.toLowerCase() : '';
        return (lowerCaseVehicleName.indexOf(lowerCaseString) !== -1) || (lowerCaseDriverName.indexOf(lowerCaseString) !== -1);
      });
    };
  }
})();

(function() {
'use strict';

angular
  .module('icarus')
  .filter('trackingOrderVehicles', trackingOrderVehicles);

/** @ngInject */
function trackingOrderVehicles () {
  return function(items) {
    var withRouteVisits = [];
    var withoutRouteVisits = [];

    angular.forEach(items, function(item) {

      if (item.routes.length) {
        withRouteVisits.push(item);
      }
      if (!item.routes.length) {
        withoutRouteVisits.push(item);
      }
    });

    withRouteVisits.sort(sortByName);
    withoutRouteVisits.sort(sortByName);

    return [].concat(withRouteVisits).concat(withoutRouteVisits);
  };

  function sortByName (a, b) {
    return a.name < b.name ? -1 : 1;
  }

}
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .controller('EventsController', EventsController);

  /** @ngInject */
  function EventsController($scope, $log,__env, $stateParams, planService, DATE_FORMAT, TRACKING_EVENTS, $rootScope, $filter, moment) {
    var vm = this;
    var trackingDate = $stateParams.trackingDate;
    var $translate = $filter('translate');
    vm.previousEventsTranslate = $translate('Events.previous_tooltip');
    vm.nextEventsTranslate = $translate('Events.next_tooltip');
    vm.loadingData = false;
    vm.eventsFilter = [];
    vm.events = [];
    vm.next = null;
    vm.previous = null;
    vm.count = 0;
    vm.loadPaginationEvents = loadPaginationEvents;

    activate();

    var listenerGeneralProgress = $scope.$on(TRACKING_EVENTS.REFRESH.GENERAL_PROGRESS_CHANGED, refreshData);
    var listenerDateChanged = $scope.$on(TRACKING_EVENTS.REFRESH.DATE_CHANGED, refreshData);
    var listenerFleetsReady;

    $scope.$on('$destroy', stopEventsController);

    ///////////////////////////////////////////////////////
    function activate() {
      if ($stateParams.fromTracking) {
        decideLoading(trackingDate);
      } else {
        listenerFleetsReady = $scope.$on(TRACKING_EVENTS.FLEETS.READY, fleetsReady);
      }
    }

    function decideLoading(trackDate) {
      if ($scope.$parent.vm.fleetSelected) {
        loadEventsByDateAndFleet(trackDate, $scope.$parent.vm.fleetSelected.id);
      }
      else {
        loadEvents(trackDate);
      }
    }

    function loadEventsByDateAndFleet(date, fleetId) {
      startLoading();
      planService.getAllEventsByDateAndFleet(date, fleetId)
        .then(successGetEvents, errorGetEvents)
        .finally(stopLoading);
    }

    function loadEvents(date) {
      startLoading();
      planService.getEventsByDate(date)
        .then(successGetEvents, errorGetEvents)
        .finally(stopLoading);
    }

    function loadPaginationEvents(url, pagination) {
      if (!url) {
        return;
      }
      
      startLoading();
      vm.events = [];
      vm.nextPagination = pagination;
      url = __env.API_URL + url;
      planService.getEventsByUrl(url)
        .then(successGetEvents, errorGetEvents)
        .finally(stopLoading);
    }

    function startLoading() {
      vm.loadingData = true;
    }

    function stopLoading() {
      vm.loadingData = false;
    }

    function successGetEvents(data) {
      vm.previous = data.previous;
      vm.next = data.next;
      vm.count = data.count;

      if (!vm.nextPagination) {
        vm.currentLow = 1;
        vm.currentTop = (vm.count > 10) ? 10 : vm.count;
      }

      if (vm.nextPagination == 'previous') {
        vm.currentTop = (vm.currentTop === vm.count) ? (Math.floor(vm.count/10) * 10) : (vm.currentTop - 10);
        vm.currentLow -= 10;
      }

      if (vm.nextPagination == 'next') {
        vm.currentTop = (vm.count > (vm.currentTop + 10)) ? (vm.currentTop + 10) : vm.count;
        vm.currentLow += 10;
      }

      addEvents(data.events);
    }

    function errorGetEvents(error) {
      $log.error(error);
      vm.events.length = 0;
    }

    function refreshData(event, data) {
      vm.events.length = 0;
      vm.eventsFilter.length = 0;
      var dateMoment = moment(data.date);
      var dateString = dateMoment.format(DATE_FORMAT);
      refreshEvents(dateString);
    }

    function refreshEvents (newDate) {
      decideLoading(newDate);
    }

    function fleetsReady() {
      decideLoading(trackingDate);
    }

    function stopEventsController() {
      clearEvents();
    }

    function clearEvents () {
      vm.events.length = 0;
      vm.eventsFilter.length = 0;
      listenerGeneralProgress();
      listenerDateChanged();
      if (listenerFleetsReady) {
        listenerFleetsReady();
      }
    }

    function addEvents(events) {
      events.forEach(function (event) {
        var ifExist = false;
        for (var i=0; i < vm.events.length; i++) {
          if (vm.events[i].aggregate_id === event.aggregate_id && vm.events[i].version === event.version) {
            ifExist = true;
            break;
          }
        }
        if (!ifExist) {
          if($rootScope.trackingVehiclesColor){
            event.data['vehicle_color'] = $rootScope.trackingVehiclesColor[event.data.vehicle_id];
          }
          vm.events.push(event);
        }
      });
      vm.eventsFilters = vm.events;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .controller('TrackingDriverDispatchListController', TrackingDriverDispatchListController);

  /** @ngInject */
  function TrackingDriverDispatchListController($scope, $log, $state, $stateParams, $q, __env, planService, trackingService,
                                                $rootScope, $filter, TRACKING_EVENTS, timeUtils, accountConfigsService,
                                                moment, VISIT_STATUS_PENDING, VISIT_STATUS_COMPLETED,
                                                VISIT_STATUS_PARTIAL, VISIT_STATUS_FAILED, VISIT_STATUS_CANCELED,
                                                CANCELED_VISIT_DEFAULT_COLOR) {

    var vm = this;
    var vehicles = [];
    var TIME_FORMAT = 'HH:mm';
    var $translate = $filter('translate');

    vm.visits = [];
    vm.events = [];
    vm.routes = [];
    vm.routesData = {};

    vm.vehicle = null;
    vm.restTimeData = null;
    vm.visitBeforeRestTime = null;
    vm.loadingData = false;
    vm.visitsTabSelected = true;
    vm.eventsTabSelected = false;
    vm.enableVisitItems = false;
    vm.orderVisitsProperty = 'order';

    vm.openModal = openModal;
    vm.selectTab = _selectTab;
    vm.getRouteDiffTime = getRouteDiffTime;
    vm.recalculateVisitsETA = recalculateVisitsETA;
    vm.setRoutesDiffTimeSeconds = setRoutesDiffTimeSeconds;
    vm.showRouteIndicators = showRouteIndicators;
    vm.orderVisitsBy = orderVisitsBy;
    vm.isWindowBroken = isWindowBroken;
    vm.calculateETA = calculateETA;
    vm.checkBatteryLevel = checkBatteryLevel;
    vm.buildJoinedVisitGroup = buildJoinedVisitGroup;
    vm.joinSimilarVisits = joinSimilarVisits;
    vm.generateVisitItemsInformation = generateVisitItemsInformation;
    vm.getVisitBeforeRestTime = getVisitBeforeRestTime;
    vm.getReferenceById = getReferenceById;
    vm.shortRefNumber = shortRefNumber;
    vm.getRestTimePeriod = getRestTimePeriod;
    vm.handleShowJoinedDropDown = handleShowJoinedDropDown;
    vm.getVisitNgClass = getVisitNgClass;
    vm.getTimelineNumberBackgroundColor = getTimelineNumberBackgroundColor;
    vm.getVisitCheckoutTime = getVisitCheckoutTime;

    vm.driverTranslate = $translate('Driver.driver');
    vm.vehicleRestTimeConector = $translate('Vehicle.rest_time_conector');
    vm.codriverTranslate = $translate('Vehicle.codriver');

    vm.visitIconTooltipMessages = {
      pending: $translate('Visits.pending'),
      partial: $translate('Visits.partial'),
      completed: $translate('Visits.completed'),
      failed: $translate('Visits.failed'),
      canceled: $translate('Visits.canceled')
    };

    vm.showSimilars = $translate('Visits.show_similar_visits');
    vm.loadPaginationEvents = loadPaginationEvents;
    vm.previousEventsTranslate = $translate('Events.previous_tooltip');
    vm.nextEventsTranslate = $translate('Events.next_tooltip');

    var listenerDateChanged = $scope.$on(TRACKING_EVENTS.REFRESH.DATE_CHANGED_REFRESH_VISITS, _onDateChange);
    $scope.$on('$destroy', _destroyDriverDispatchListController);
    var listenerGeneralProgress = $scope.$on(TRACKING_EVENTS.REFRESH.GENERAL_PROGRESS_CHANGED, _generalProgressChanged);
    var listenerVehiclesMarkersCreated = $scope.$on(TRACKING_EVENTS.READY.VEHICLES_MARKERS_CREATED, _showVehicleOrDriverLastPosition);
    var listenerFilterVisitMarkers = $scope.$on(TRACKING_EVENTS.VISITS.FILTER_VISIT_MARKERS_BY_TIME, _filterVisitsMarkersByTime);
    var listenerFilterPolylines = $scope.$on(TRACKING_EVENTS.MAP.FILTER_POLYLINES_BY_TIME, _filterPolylinesByTime);
    var listenerGetVehicleDriverActive = $scope.$on(TRACKING_EVENTS.VEHICLES.GET_VEHICLE_DRIVER_ACTIVE, _returnDriverVehiceActive);
    var listenerRefreshPolylines = $scope.$on(TRACKING_EVENTS.REFRESH.POLYLINES, refreshPolylines);

    activate();

    ///////////////////////////////////////////////

    function activate() {
      $scope.$emit(TRACKING_EVENTS.REFRESH.VEHICLE_SELECTED_CHANGE, { vehicleId: $stateParams.vehicleId, driverId: parseInt($stateParams.driverId) });
      $scope.$emit(TRACKING_EVENTS.MAP.HIDE_MARKERS);
      $scope.$emit(TRACKING_EVENTS.MAP.CLEAR_POLYLINES);
      _getListDriverDispatch();
    }

    function _getListDriverDispatch() {
      vm.loadingData = true;
      vm.vehicleId = $stateParams.vehicleId;
      vm.driverId = $stateParams.driverId;

      trackingService
        .getVehicleByIdAndDriver($stateParams.vehicleId, $stateParams.driverId)
        .then(successGetVehicleById)
        .catch(function () {
          vm.loadingData = false;
        });
    }

    function successGetVehicleById(vehicle, fitboundsFlag) {
      var driverId;
      var locationsGps = trackingService.getLocationGps();

      for (var i = 0; i < locationsGps.length; i++) {
        if (vehicle.driver && locationsGps[i].id === vehicle.driver.id) {
          vehicle.driver.batteryLevel = locationsGps[i].battery_level;
          break;
        }
      }

      fitboundsFlag = fitboundsFlag || true;

      if (!vehicle || vehicle.length === 0) {
        vm.vehicleWithoutRoute = true;
        $rootScope.isLoading = false;
        vm.loadingData = false;
        return;
      }

      // Check color vehicle
      vehicles.forEach(function (vehicleItem) {
        if (vehicleItem.id === vehicle.id) {
          vehicle.color = vehicleItem.color;
        }
      });

      vm.vehicleWithoutRoute = false;
      vm.vehicle = vehicle;

      _getVisitsByVehicle(vehicle)
        .then(function (visits) {
          vm.enable_rest_time = accountConfigsService.isConfigEnabled('enable_rest_time');
          vm.enableVisitItems = accountConfigsService.isConfigEnabled('enable_visit_items');
          if (vm.enable_rest_time) {
            trackingService.getVehicleRestTime(vehicle.id, $rootScope.trackingDate).then(function (restTimeData) {
              // TODO: Support more than one rest_time per vehicle per day, this could be the case if, for example, multidrivers is active.
              if (restTimeData && restTimeData.length === 1) {
                vm.restTimeData = restTimeData[0];
                vm.visitBeforeRestTime = getVisitBeforeRestTime(visits, vm.restTimeData);
              }
            });
          }

          visits.forEach(function (visit) {
            if (visit.checkout_time) {
              visit.checkout_time = timeUtils.convertDateToFormatString(visit.checkout_time, TIME_FORMAT);
            }
          });
          _setVisits(visits);
          $scope.$emit(TRACKING_EVENTS.MAP.DRAW_VISITS, vm.visitsToList, fitboundsFlag, vm.routesData);
          refreshPolylines(null, fitboundsFlag);
          $scope.$emit(TRACKING_EVENTS.VISITS.CALL_VISIT_FILTER);
          _returnDriverVehiceActive();
        })
        .catch(function (error) {
          $log.error(error);
          vm.vehicleWithoutRoute = true;
          $rootScope.isLoading = false;
        })
        .finally(function () {
          $rootScope.isLoading = false;
          vm.loadingData = false;
        });

      vehicle.driver ? driverId = vehicle.driver.id : driverId = null;
      $scope.$emit(TRACKING_EVENTS.VEHICLES.RETURN_VEHICLE_DRIVER_ACTIVE, { vehicleId: vm.vehicle.id, driverId: driverId });
    }

    function getReferenceById (aggregateId) {
      var route = vm.routes.find(function(route) {
        return route.id === aggregateId;
      });

      return route && route.reference != 'None' ? route.reference : '';
    }

    function shortRefNumber(ref) {
      if(ref == 'None'){
        return "";
      }

      return ref.length > 7 ? ref.slice(0,7) + "..." : ref;
    }

    function getVisitBeforeRestTime(visits, restTimeData) {
      var visitBeforeRestTime;
      var closestVisitTime;

      if (!restTimeData.start_time || !restTimeData.end_time) {
        return null;
      }

      visits.forEach(function (visit) {
        if (visit.estimated_time_arrival.localeCompare(restTimeData.start_time) === -1) {
          var diff = moment(restTimeData.start_time, 'HH:mm:ss') - moment(visit.estimated_time_arrival, 'HH:mm:ss');

          if (!visitBeforeRestTime) {
            visitBeforeRestTime = visit.id;
            closestVisitTime = diff;
          } else {
            if (closestVisitTime > diff) {
              visitBeforeRestTime = visit.id;
              closestVisitTime = diff;
            }
          }
        }
      });

      return visitBeforeRestTime;
    }

    function getRestTimePeriod() {
      var startTime = moment(vm.restTimeData.start_time, 'HH:mm:ss').format('HH:mm');
      var endTime = moment(vm.restTimeData.end_time, 'HH:mm:ss').format('HH:mm');

      return (startTime + vm.vehicleRestTimeConector + endTime);
    }

    function refreshPolylines(event, fitboundsFlag) {
      $scope.$emit(TRACKING_EVENTS.MAP.DRAW_ROUTE_POLYLINE, vm.vehicle, vm.vehicle.driver, fitboundsFlag || false, vm.routesData);
    }

    function openModal(visit, fatherVisit, subVisitPosition) {
      $state.go(
        "tracking.vehicles.driver-dispatchs.detail",
        {
          dispatchsId: angular.isObject(visit) ? visit.id : visit,
          fatherVisit: fatherVisit,
          subVisitPosition: subVisitPosition
        },
        { notify: false }
      );
    }

    function startLoading() {
      vm.loadingData = true;
    }

    function stopLoading() {
      vm.loadingData = false;
    }

    function _getVisitsByVehicle(vehicle) {
      var routesPromises = [];
      vm.routes = [];
      var deferred = $q.defer();
      vehicle.routes.forEach(function (route) {
        routesPromises.push(planService.getRouteByID(route.id));
      });

      $q.all(routesPromises).then(function (routes) {
        var visitsPromises = [];
        routes.forEach(function (route) {
          vm.routes.push(route);
          visitsPromises.push(planService.getVisitsByRouteID(route.id));
        });

        _sortRoutes();
        _setRoutesData();
        setRoutesDiffTimeSeconds(vm.routes);

        _getEventsByRoutes(routes)
          .then(function success(data) {
            _setEvents(data);
            $q.all(visitsPromises).then(function (visitsArray) {
              deferred.resolve([].concat.apply([], visitsArray));
            });
          });
      });
      return deferred.promise;
    }

    function _setRoutesData() {
      vm.routes.forEach(function(route, i) {
        vm.routesData[route.id] = {position: i + 1, status: route.status, startTime: route.startTime, endTime: route.endTime};
      });
    }

    function _getEventsByRoutes(routes) {
      vm.events = [];
      vm.routesIdRequest = {
        routes: []
      };
      routes.forEach(function (route) {
        vm.routesIdRequest.routes.push(route.id);
      });

      return planService.getEventsByRoutes(vm.routesIdRequest);
    }

    function loadPaginationEvents(url, pagination) {
      if (!url) {
        return;
      }
      url = __env.API_URL + url;
      startLoading();
      vm.events = [];
      vm.nextPagination = pagination;

      planService.getRouteEventsByUrl(vm.routesIdRequest, url)
        .then(_setEvents, errorGetEvents)
        .finally(stopLoading());
    }

    function errorGetEvents(error) {
      $log.error(error);
      vm.events.length = 0;
    }

    function _destroyDriverDispatchListController() {
      _clearData();
      _clearEvents();
    }

    function _clearData() {
      vm.visits.length = 0;
      vm.events.length = 0;
      $scope.$emit(TRACKING_EVENTS.MAP.CLEAR_MARKERS);
      $scope.$emit(TRACKING_EVENTS.MAP.CLEAR_POLYLINES);
      $scope.$emit(TRACKING_EVENTS.VEHICLES.CLEAR_VEHICLE_DRIVER_ACTIVE);
      vm.vehicleId = null;
      vm.driverId = null;
      vm.routesData = {};
    }

    function _clearEvents() {
      listenerDateChanged();
      listenerGeneralProgress();
      listenerVehiclesMarkersCreated();
      listenerFilterVisitMarkers();
      listenerFilterPolylines();
      listenerGetVehicleDriverActive();
      listenerRefreshPolylines();
    }

    function _onDateChange(event, data) {
      vehicles = data.vehicles;
      _clearData();
      _getListDriverDispatch();
    }

    function _generalProgressChanged() {
      if ($stateParams.vehicleId) {
        _getVisitsByVehicle(vm.vehicle)
          .then(function (visits) {
            visits.forEach(function (visit) {
              if (visit.checkout_time) {
                visit.checkout_time = timeUtils.convertDateToFormatString(visit.checkout_time, TIME_FORMAT);
              }
            });
            _setVisits(visits);
            $scope.$emit(TRACKING_EVENTS.MAP.DRAW_VISITS, vm.visitsToList, false, vm.routesData);
            $scope.$emit(TRACKING_EVENTS.MAP.CALL_POLYLINES_FILTER, vm.vehicle, vm.vehicle.driver, vm.routesData);
          })
          .catch(function (error) {
            $log.error(error);
            vm.vehicleWithoutRoute = true;
          });
      }
    }

    function generateVisitItemsInformation(visits) {
      var itemsInformation = {
        'quantity': 0,
        'pending': 0,
        'completed': 0,
        'partial': 0,
        'failed': 0
      };

      visits.forEach(function (visit) {
        visit.items.forEach(function (item) {
          itemsInformation[item.status] += 1;
          itemsInformation.quantity += 1;
        });
      });

      itemsInformation.completedPercentage = itemsInformation.completed > 0 ? Math.round((itemsInformation.completed * 100) / itemsInformation.quantity) : 0;
      itemsInformation.partialPercentage = itemsInformation.partial > 0 ? Math.round((itemsInformation.partial * 100) / itemsInformation.quantity) : 0;
      itemsInformation.failedPercentage = (100 - (parseFloat(itemsInformation.partialPercentage) + parseFloat(itemsInformation.completedPercentage)));

      return itemsInformation;
    }

    function _setVisits(visits) {
      vm.visits = visits;

      if (vm.enableVisitItems) {
        vm.itemsInformation = generateVisitItemsInformation(visits);
        vm.showItemsInformation = vm.itemsInformation.quantity > 0 ? true : false;
      }

      vm.vehicleWithoutRoute = (vm.visits.length === 0);

      vm.visits.sort(function (a, b) {
        // Visits ordered not only by order number but also by route name (doesn't matter which route comes first)
        return b.route_id.localeCompare(a.route_id) || a.order - b.order;
      });

      vm.recalculateVisitsETA();
      vm.visitsToList = joinSimilarVisits(vm.visits);
    }

    function joinSimilarVisits(visits) {
      var allVisitsJoined = [];
      var currentVisitsToJoin = [];
      var joinToPrevious = false;

      for (var i = 0; i < visits.length; i++) {
        if (visits[i].title.length > 20) {
          visits[i].displayTitle = visits[i].title.slice(0, 20) + '...';
        } else {
          visits[i].displayTitle = visits[i].title;
        }

        if (visits[i + 1] && visits[i].estimated_time_arrival === visits[i + 1].estimated_time_arrival
          && visits[i].address === visits[i + 1].address
          && visits[i].route_id === visits[i + 1].route_id) {
          currentVisitsToJoin.push(visits[i]);
          joinToPrevious = true;
          continue;
        } else if (currentVisitsToJoin.length) {
          joinToPrevious ? currentVisitsToJoin.push(visits[i]) : null;
          allVisitsJoined.push(buildJoinedVisitGroup(currentVisitsToJoin));
          currentVisitsToJoin = [];
          joinToPrevious = false;
          continue;
        } else {
          allVisitsJoined.push(visits[i]);
        }
      }

      return allVisitsJoined;
    }

    function buildJoinedVisitGroup(visitsToJoin) {
      if (!visitsToJoin.length && !visitsToJoin[0].id) {
        return null;
      }

      var result = {
        id: visitsToJoin[0].id,
        address: visitsToJoin[0].address,
        estimated_time_arrival: visitsToJoin[0].estimated_time_arrival,
        route_id: visitsToJoin[0].route_id,
        order: visitsToJoin[0].order,
        longitude: visitsToJoin[0].longitude,
        latitude: visitsToJoin[0].latitude,
        color: vm.vehicle.color,
        status: VISIT_STATUS_PENDING
      };

      result.subVisitStates = {
        pending: 0,
        completed: 0,
        partial: 0,
        failed: 0,
        canceled: 0
      };

      var checkout_time = null;
      var current_eta = null;
      var ETARecalculated = null;

      visitsToJoin.forEach(function (subVisit) {
        if (subVisit.status && typeof (subVisit.status === "string")) {
          result.subVisitStates[subVisit.status] += 1;
        }

        if (subVisit.checkout_time) {
          if (checkout_time && subVisit.checkout_time < checkout_time) {
            checkout_time = subVisit.checkout_time;
          }  else if (!checkout_time) {
            checkout_time = subVisit.checkout_time;
          }
        }

        if (subVisit.current_eta) {
          subVisit.ETARecalculated = timeUtils.convertDateToFormatString(subVisit.current_eta, 'HH:mm');

          if ((current_eta && subVisit.current_eta > current_eta) || !current_eta) {
            current_eta = subVisit.current_eta;
            ETARecalculated = timeUtils.convertDateToFormatString(current_eta, 'HH:mm');
          }
        }
      });

      result.checkout_time = checkout_time;
      result.current_eta = current_eta;
      result.ETARecalculated = ETARecalculated;
      result.showJoinedVisits = false;
      result.joinedVisits = visitsToJoin;

      if (result.subVisitStates.completed === visitsToJoin.length) {
        result.status = VISIT_STATUS_COMPLETED;
      }

      if (result.subVisitStates.canceled === visitsToJoin.length) {
        result.status = VISIT_STATUS_CANCELED;
      }

      if (result.subVisitStates.partial > 0) {
        result.status = VISIT_STATUS_PARTIAL;
      }

      if (result.subVisitStates.failed > 0) {
        result.status = VISIT_STATUS_FAILED;
      }

      return result;
    }

    function handleShowJoinedDropDown(visit) {
      visit.showJoinedVisits = !visit.showJoinedVisits;
    }

    function _setEvents(data) {
      vm.previous = data.previous;
      vm.next = data.next;
      vm.count = data.count;

      data.events.forEach(function (event) {
        event.occurred_on = timeUtils.convertDateToFormatString(event.occurred_on, 'HH:mm');
      });

      if (!vm.nextPagination) {
        vm.currentLow = 1;
        vm.currentTop = (vm.count > 10) ? 10 : vm.count;
      }

      if (vm.nextPagination === 'previous') {
        vm.currentTop = (vm.currentTop === vm.count) ? (Math.floor(vm.count / 10) * 10) : (vm.currentTop - 10);
        vm.currentLow -= 10;
      }

      if (vm.nextPagination === 'next') {
        vm.currentTop = (vm.count > (vm.currentTop + 10)) ? (vm.currentTop + 10) : vm.count;
        vm.currentLow += 10;
      }

      vm.events = data.events;
    }

    function _selectTab(tabName) {
      if (tabName === 'visits') {
        vm.eventsTabSelected = false;
        vm.visitsTabSelected = true;
      } else if (tabName === 'events') {
        vm.visitsTabSelected = false;
        vm.eventsTabSelected = true;
      }
    }

    function _showVehicleOrDriverLastPosition() {
      var vehicleId = $stateParams.vehicleId;
      var driverId;
      $stateParams.driverId ? driverId = $stateParams.driverId : driverId = null;
      $scope.$emit(TRACKING_EVENTS.VEHICLES.RETURN_VEHICLE_DRIVER_ACTIVE, { vehicleId: vehicleId, driverId: driverId });
    }

    function _sortRoutes() {
      vm.routes.sort(function (a, b) {
        if (a.estimatedTimeStart < b.estimatedTimeStart) { return -1; }
        if (a.estimatedTimeStart > b.estimatedTimeStart) { return 1; }
        return 0;
      });
    }

    function _filterVisitsMarkersByTime(event, data) {
      var filteredVisits = trackingService.filterVisits(vm.visits, data.startDate, data.endDate);
      $scope.$emit(TRACKING_EVENTS.MAP.UPDATE_FILTERED_VISIT_MARKERS, { visitIds: filteredVisits });
    }

    function _returnDriverVehiceActive() {
      var data = {
        vehicleId: vm.vehicleId,
        driverId: vm.driverId
      };

      $scope.$emit(TRACKING_EVENTS.VEHICLES.RETURN_VEHICLE_DRIVER_ACTIVE, data);
    }

    function _filterPolylinesByTime(event, data) {
      $scope.$emit(TRACKING_EVENTS.MAP.CALL_POLYLINES_FILTER, vm.vehicle, vm.vehicle.driver, vm.routesData);
    }

    function getRouteDiffTime(route) {
      var diffSeconds = 0;
      if (route.startTime) {
        var startTimeSplited = route.startTime.split(" ");
        var date = startTimeSplited[0];
        var ms = timeUtils.createTimeUTC(route.startTime, "YYYY/MM/DD HH:mm:ssZ")
          .diff(timeUtils.createTime(date + ' ' + route.estimatedTimeStart, "YYYY/MM/DD HH:mm:ss"));
        var d = timeUtils.duration(ms);
        diffSeconds = timeUtils.asSeconds(d);
      }
      return diffSeconds;
    }

    function setRoutesDiffTimeSeconds(routes) {
      routes.map(function (route) {
        route.diffTimeInSeconds = getRouteDiffTime(route);
      });
    }

    function recalculateVisitsETA() {
      vm.updateETAOnCheckout = accountConfigsService.isConfigEnabled('update_eta_on_checkout');
      vm.updateETAOnRouteStart = accountConfigsService.isConfigEnabled('update_eta_on_start_route');

      vm.visits.forEach(function (visit) {
        if (visit.current_eta != null) {
          visit.ETARecalculated = visit.current_eta.format("HH:mm");
        }
      });
    }

    function showRouteIndicators(route) {
      route.expandedIndicators = !route.expandedIndicators;
    }

    function orderVisitsBy(property) {
      vm.orderVisitsProperty = property;
    }

    function isWindowBroken(visit) {
      if (visit.current_eta === null) {
        return false;
      } else if (visit.windowStart !== null && visit.windowEnd !== null) {
        var currentEta = visit.current_eta.format('HH:mm:ss');
        if (currentEta < visit.windowStart || currentEta > visit.windowEnd) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    function calculateETA(estimated_time_arrival, ETARecalculated) {
      if (!estimated_time_arrival) {
        return null;
      }

      return (vm.updateETAOnCheckout || vm.updateETAOnRouteStart) && ETARecalculated
        ? ETARecalculated
        : estimated_time_arrival.substring(0, 5);
    }

    function checkBatteryLevel(BatteryLevel) {
      if (BatteryLevel >= 0 && BatteryLevel <= 19) {
        return "BatteryEmpty.svg";
      } else if (BatteryLevel >= 20 && BatteryLevel <= 69) {
        return "BatteryMed.svg";
      } else if (BatteryLevel >= 70) {
        return "BatteryFull.svg";
      } else {
        return undefined;
      }
    }

    function getVisitNgClass(visit) {
      return {'title-less-visible': (visit.status === VISIT_STATUS_CANCELED)};
    }

    function getTimelineNumberBackgroundColor(visit, vehicle) {
      return (visit.status === VISIT_STATUS_CANCELED) ? CANCELED_VISIT_DEFAULT_COLOR : vehicle.color;
    }

    function getVisitCheckoutTime(visit) {
      return (visit.status === VISIT_STATUS_CANCELED) ? visit.status_changed : visit.checkout_time;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .controller('TrackingDispatchDetailController', TrackingDispatchDetailController);

  /** @ngInject */
  function TrackingDispatchDetailController($scope, $stateParams, $interval, lodash, FileSaver, $log, ITEMS,
    visit, trackingService, __env, planService, accountConfigsService,
    timeUtils, helperColor, $filter, MapModel, ACCOUNT_CONFIGS, PICKUP_ITEMS,
    ITEMS_BASE_TRANSLATE_PATH, addonsService) {
    var vm = this;
    var $translate = $filter('translate');
    var DEFAULT_WINDOW = '23:59';
    var interval = startUpdateData();
    var TIME_FORMAT = 'HH:mm YYYY-MM-DD';

    vm.ITEMS = ITEMS;
    vm.PICKUP_ITEMS = PICKUP_ITEMS;

    vm.visit = visit;
    vm.markers = null;
    vm.mapProvider = null;
    vm.interval = null;
    vm.enableMoreData = false;
    vm.showLeftArrow = false;
    vm.visitStatusTranslation = '';
    vm.showRightArrow = false;
    vm.extraFields = [];
    vm.visitsOnListDisplay = [];
    vm.visitGroup = [];
    vm.hasSecondTimeWindow = false;
    vm.calculateETA = calculateETA;
    vm.changeVisit = changeVisit;
    vm.changeVisitsOnDisplay = changeVisitsOnDisplay;
    vm.shouldShowItemsRow = shouldShowItemsRow;
    vm.shouldShowInvoicesBtn = shouldShowInvoicesBtn;
    vm.isInvoicesTableVisible = false;
    vm.showInvoicesTable = showInvoicesTable;
    vm.hideInvoicesTable = hideInvoicesTable;
    vm.showItemsDetailsTable = showItemsDetailsTable;
    vm.totalInvoicesUnits = totalInvoicesUnits;
    vm.totalInvoicesDeliveredUnits = totalInvoicesDeliveredUnits;
    vm.addons = [];

    vm.download = download;
    activate();
    $scope.$on('$destroy', _onDestroy);

    /////////////////////////////////////

    function activate() {
      if (!vm.visit) {
        return;
      }

      function addons() {
        addonsService.listAddons()
          .then(function successGetAddon(addons) {
            addons.forEach(function (addon) {
              vm.addons.push(addon);
            });
          });
      }

      var trackingMapProvider = accountConfigsService.getConfigRawValue(ACCOUNT_CONFIGS.TRACKING_MAP_PROVIDER);
      vm.mapProvider = MapModel.getCurrentProviderName(trackingMapProvider, __env.DEFAULT_NAME_OF_TRACKING_MAP_PROVIDER);
      vm.visitStatusTranslation = $translate('Visits.modal_title_visit_' + vm.visit.status);

      if (vm.visit.notes || vm.visit.load || vm.visit.load2 || vm.visit.load3) {
        vm.visit.notes = vm.visit.notes.replace(/&#10;/g, '\n');
        vm.enableMoreData = true;
      }

      if (vm.shouldShowItemsRow(visit, ITEMS)) {
        vm.visit.itemsQuantitySummary = _getItemsQuantitySummary(vm.visit.itemsStatistics, ITEMS);
      }

      if (vm.shouldShowItemsRow(visit, PICKUP_ITEMS)) {
        vm.visit.pickupItemsQuantitySummary = _getItemsQuantitySummary(vm.visit.pickupItemsStatistics, PICKUP_ITEMS);
      }

      vm.updateETAOnCheckout = accountConfigsService.getAccountConfigValue('update_eta_on_checkout');
      vm.updateETAOnRouteStart = accountConfigsService.getAccountConfigValue('update_eta_on_start_route');
      vm.showContactInfo = accountConfigsService.getAccountConfigValue('show_contact_info_on_tracking');

      vm.extraFields = vm.visit.extra_field_values;
      vm.enableMoreData = _checkExtraFieldValues();
      _checkSecondWindow();
      _getDistanceCheckout();
      _drawMapDetailVisit();
      addons();
      vm.visit.checkin_time = timeUtils.convertDateToFormatString(vm.visit.checkin_time, TIME_FORMAT);
      vm.visit.checkout_time = timeUtils.convertDateToFormatString(vm.visit.checkout_time, TIME_FORMAT);

      // Return if we are just changing from one visit to another on Join Similar Display
      if (vm.visitGroup.length) {
        return;
      }

      if (typeof $stateParams.subVisitPosition === 'number' && $stateParams.fatherVisit) {
        vm.visitGroup = $stateParams.fatherVisit.joinedVisits;
        vm.color = $stateParams.fatherVisit.color;
        vm.lighterColor = helperColor.lightenDarkenColor(vm.color, 200);

        if (vm.visitGroup.length >= 4) {
          if ($stateParams.subVisitPosition <= 3) {
            vm.visitsOnListDisplay = vm.visitGroup.slice(0, 4);
            vm.displayPosition = 3;
          } else {
            vm.visitsOnListDisplay = vm.visitGroup.slice($stateParams.subVisitPosition - 3, $stateParams.subVisitPosition + 1);
            vm.displayPosition = $stateParams.subVisitPosition;
          }

          checkNavigationVisibility();
        } else {
          vm.visitsOnListDisplay = vm.visitGroup;
        }
      }
    }

    function _getItemsQuantitySummary(itemsStatistics, itemsType) {
      var fractionQuantity, messageTranslatePath;
      if (itemsType === ITEMS) {
        fractionQuantity = itemsStatistics.totalQuantityDelivered;
        messageTranslatePath = ITEMS_BASE_TRANSLATE_PATH + 'quantity_summary';
      } else {
        fractionQuantity = itemsStatistics.totalQuantityCollected;
        messageTranslatePath = ITEMS_BASE_TRANSLATE_PATH + 'pickup_quantity_summary';
      }

      return [fractionQuantity, $translate(messageTranslatePath), itemsStatistics.totalQuantityPlanned].join(' ');
    }

    function shouldShowItemsRow(visit, itemsType) {
      if (itemsType === ITEMS) {
        return Boolean(visit.items && visit.items.length);
      }
      return Boolean(visit.pickupItems && visit.pickupItems.length);
    }

    function shouldShowInvoicesBtn() {
      var foundAddon = vm.addons.find(function (addon) {
        return addon.key === "accounting";
      });

      return Boolean(foundAddon) && vm.visit.invoices.length > 0;
    }

    function totalInvoicesDeliveredUnits() {
      var delivered = 0;
      vm.visit.invoices.forEach(function(invoice) {
          invoice.items.forEach(function(item) {
              delivered += item.delivered_units;
          });
      });
      return delivered;
  }

    function totalInvoicesUnits() {
      var planned = 0;
      vm.visit.invoices.forEach(function(invoice) {
          invoice.items.forEach(function(item) {
              planned += item.planned_units;
          });
      });
      return planned;
  }

    function showInvoicesTable() {
      vm.isInvoicesTableVisible = true;
    }

    function hideInvoicesTable() {
      vm.isInvoicesTableVisible = false;
    }

    function showItemsDetailsTable(visit, itemsType) {
      vm.areItemsDetailsVisible = true;
      vm.itemsType = itemsType;

      if (itemsType === ITEMS) {
        vm.itemsQuantitySummary = visit.itemsQuantitySummary;
        vm.items = visit.items;
        vm.itemsStatistics = visit.itemsStatistics;
      } else {
        vm.itemsQuantitySummary = visit.pickupItemsQuantitySummary;
        vm.items = visit.pickupItems;
        vm.itemsStatistics = visit.pickupItemsStatistics;
      }
    }

    function changeVisit(id) {
      if (id === vm.visit.id) {
        return;
      }

      trackingService.manageGetVisitForTrackingDetail(id)
        .then(function (response) {
          vm.visit = response;
          activate();
        }
      );
      vm.isInvoicesTableVisible = false;
    }

    function checkNavigationVisibility() {
      vm.showLeftArrow = vm.displayPosition >= 4;
      vm.showRightArrow = vm.visitGroup[vm.visitGroup.length - 1].id !== vm.visitsOnListDisplay[vm.visitsOnListDisplay.length - 1].id;
    }

    function changeVisitsOnDisplay(direction) {
      switch (direction) {
        case 'left':
          vm.displayPosition -= 1;
          vm.visitsOnListDisplay = vm.visitGroup.slice(vm.displayPosition - 3, vm.displayPosition + 1);
          checkNavigationVisibility();
          break;
        case 'right':
          vm.displayPosition += 1;
          vm.visitsOnListDisplay = vm.visitGroup.slice(vm.displayPosition - 3, vm.displayPosition + 1);
          checkNavigationVisibility();
          break;
      }
    }

    function startUpdateData() {
      return $interval(_refreshData, __env.TRACKING_REFRESH_TIME * 1000);
    }

    function download(visit) {
      if (visit.id) {
        trackingService.downloadAttachment(vm.visit.id)
          .then(function (response) {
            var blob = new Blob([response.data], { type: 'application/zip' });
            var zipName = visit.id + '_' + visit.title + '.zip';
            FileSaver.saveAs(blob, zipName);
          })
          .catch(function (response) {
            $log.error('status: %d, response: %o ', response.status, response.data);
          });
      }
    }

    function _checkExtraFieldValues() {
      if (vm.enableMoreData) {
        return vm.enableMoreData;
      }
      return lodash.some(vm.extraFields, function (value) {
        return value;
      });
    }

    function _checkSecondWindow() {
      if (vm.visit) {
        if (!(vm.visit.window_start_2 === DEFAULT_WINDOW && vm.visit.window_end_2 === DEFAULT_WINDOW)) {
          vm.hasSecondTimeWindow = true;
        }
      }
    }

    function _onDestroy() {
      _stopInterval(interval);
    }

    function _stopInterval(interval) {
      $interval.cancel(interval);
    }

    function _refreshData() {
      _getUpdateVisitData($stateParams.dispatchsId);
    }

    function _getUpdateVisitData(visitID) {
      planService.getVisitDetailByID(visitID)
        .then(function successGetVisitDetailById(visit) {
          trackingService.selectVisit(visit);
          if (visit.notes) {
            visit.notes = visit.notes.replace(/&#10;/g, '\n');
          }
          vm.visit = visit;
          vm.visit.checkin_time = timeUtils.convertDateToFormatString(vm.visit.checkin_time, TIME_FORMAT);
          vm.visit.checkout_time = timeUtils.convertDateToFormatString(vm.visit.checkout_time, TIME_FORMAT);
        });
    }

    function _getDistanceCheckout() {
      if (!_enableInfoCheckoutVisitToDraw()) {
        return;
      }

      var startPosition = {
        latitude: parseFloat(visit.latitude),
        longitude: parseFloat(visit.longitude)
      };

      var endPosition = {
        latitude: parseFloat(visit.checkout_latitude),
        longitude: parseFloat(visit.checkout_longitude)
      };

      vm.distanceCheckoutVisit = (MapModel.getDistanceBetweenPoints(vm.mapProvider, startPosition, endPosition) / 1000).toFixed(2) + ' Km';
    }

    function _getColorByStatus(status) {
      switch (status) {
        case 'completed':
          return '0x41D3BD';
        case 'partial':
          return '0xFCBA03';
        case 'failed':
          return '0xFF5252';
        default:
          return '0x868da5';
      }
    }

    function _drawMapDetailVisit() {
      if (visit.checkout_time && (!visit.checkout_latitude || !visit.checkout_longitude)) {
        vm.infoNotCheckoutLatLng = true;
        return;
      }

      if (_enableInfoCheckoutVisitToDraw()) {
        vm.showMap = true;
        vm.markers = [
          {
            color: _getColorByStatus(visit.status),
            latitude: visit.latitude,
            longitude: visit.longitude
          },
          {
            color: '0x656565',
            latitude: visit.checkout_latitude,
            longitude: visit.checkout_longitude,
          }
        ];
      } else {
        vm.infoNotCheckout = true;
      }
    }

    function _enableInfoCheckoutVisitToDraw() {
      return ((visit.latitude && visit.longitude) && (visit.checkout_latitude && visit.checkout_longitude));
    }

    function calculateETA() {
      return (vm.updateETAOnCheckout || vm.updateETAOnRouteStart) && vm.visit.current_eta != null
        ? vm.visit.current_eta.format('HH:mm')
        : vm.visit.estimated_time_arrival;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .controller('TrackingDispatchListController', TrackingDispatchListController);

  /** @ngInject */
  function TrackingDispatchListController($log, $scope, $rootScope, $state, $stateParams, planService, $filter,
                                          TRACKING_EVENTS, Toasts, trackingService, VISIT_STATUS_PENDING,
                                          VISIT_STATUS_CANCELED) {
    var vm = this;
    var $translate = null;
    var visitsBackup = [];
    vm.withoutVisits = true;
    $scope.searchKeyword = '';

    vm.visits = [];
    vm.loadingData = false;
    vm.openModal = openModal;
    vm.searchVisit = searchVisit;
    vm.clearInputVisit = clearInputVisit;
    vm.checkClearKeyWord = checkClearKeyWord;
    vm.getVisitNgClass = getVisitNgClass;

    var listenerDateChanged = $scope.$on(TRACKING_EVENTS.REFRESH.DATE_CHANGED, onDataChange);
    $scope.$on('$destroy', destroyDispatchListController);
    var listenerGeneralProgressChanged = $scope.$on(TRACKING_EVENTS.REFRESH.GENERAL_PROGRESS_CHANGED, onProgressChange);
    var listenerFilterVisitMarkers = $scope.$on(TRACKING_EVENTS.VISITS.FILTER_VISIT_MARKERS_BY_TIME, filterVisitsMarkersByTime);
    var listenerGetVehicleDriverActive = $scope.$on(TRACKING_EVENTS.VEHICLES.GET_VEHICLE_DRIVER_ACTIVE, returnDriverVehiceActive);
    var listenerFleetsReady;

    activate();

    //////////////////////////////////////////////

    function activate() {
      $translate = $filter('translate');
      vm.placeHolderSearchVisit = $translate('Visits.search');
      if ($stateParams.fromTracking) {
        decideLoading($stateParams.trackingDate);
      } else {
        listenerFleetsReady = $scope.$on(TRACKING_EVENTS.FLEETS.READY, fleetsReady);
      }
    }

    function getAllVisits(date, onRefresh) {
      onRefresh = !onRefresh;
      vm.loadingData = onRefresh;
      planService.getAllVisitsByDate(date)
        .then(processVisits(onRefresh, date))
        .catch(handleVisitError)
        .finally(endLoading);
    }

    function getAllVisitsByFleet(date, onRefresh, fleetId) {
      onRefresh = !onRefresh;
      vm.loadingData = onRefresh;
      $scope.$emit(TRACKING_EVENTS.MAP.CLEAR_ALL_VISITS);
      planService.getAllVisitsByDateAndFleet(date, fleetId)
        .then(processVisits(onRefresh, date))
        .catch(handleVisitError)
        .finally(endLoading);
    }

    function processVisits(onRefresh, date) {
      return function (visits) {
        vm.visits = visits;
        visitsBackup = vm.visits;
        vm.withoutVisits = visits.length === 0;
        $scope.$emit(TRACKING_EVENTS.MAP.DRAW_ALL_VISITS, visits, onRefresh);
        $scope.$emit(TRACKING_EVENTS.MAP.LOAD_VEHICLES_LAST_POSITION, { date: date, fitboundsFlag: false });
        $scope.$emit(TRACKING_EVENTS.VISITS.CALL_VISIT_FILTER);
      };
    }

    function handleVisitError (error) {
      vm.withoutVisits = true;
      $log.error(error);
      $state.go('^', {}, { notify: false, reload: false });
    }

    function fleetsReady() {
      decideLoading($stateParams.trackingDate);
    }

    function endLoading () {
      vm.loadingData = false;
    }

    function decideLoading(trackDate) {
      if ($scope.$parent.vm.fleetSelected) {
        getAllVisitsByFleet(trackDate, false, $scope.$parent.vm.fleetSelected.id);
      } else {
        getAllVisits(trackDate, false);
      }
    }

    function onDataChange(event, data) {
      $scope.$emit(TRACKING_EVENTS.MAP.CLEAR_ALL_VISITS);
      decideLoading(data.date);
    }

    function destroyDispatchListController() {
      clearEvents();
      $scope.$emit(TRACKING_EVENTS.MAP.CLEAR_VEHICLE_MARKERS);
      $scope.$emit(TRACKING_EVENTS.MAP.CLEAR_ALL_VISITS);
    }

    function onProgressChange(event, data) {
      decideLoading(data.date);
    }

    function openModal(visitId) {
      $state.go('.detail', {
        dispatchsId: visitId
      });
    }

    function searchVisit() {
      decideSearchVisits($stateParams.trackingDate);
    }

    function searchVisitsByDate(trackingDate) {
      vm.loadingData = true;
      vm.visitsFiltersEmpty = false;
      planService.searchVisit(vm.searchKeyword, trackingDate)
        .then(processVisitsFromSearch)
        .finally(endLoading);
    }

    function searchVisitsByDateAndFleet(trackingDate, fleetId) {
      vm.loadingData = true;
      vm.visitsFiltersEmpty = false;
      planService.searchVisitByFleet(vm.searchKeyword, trackingDate, fleetId)
        .then(processVisitsFromSearch)
        .finally(endLoading);
    }

    function processVisitsFromSearch(data) {
      vm.visits = [];
      vm.visitsFiltersEmpty = data.length === 0;
      data.forEach(function (visit) {
        vm.visits.push(visit);
      });
      $scope.$emit(TRACKING_EVENTS.MAP.FIT_BOUNDS_VISITS_MARKERS, vm.visits);
    }

    function decideSearchVisits(trackingDate) {
      if ($scope.$parent.vm.fleetSelected) {
        searchVisitsByDateAndFleet(trackingDate, $scope.$parent.vm.fleetSelected.id);
      }
      else {
        searchVisitsByDate(trackingDate);
      }
    }

    function clearInputVisit() {
      restoreDataFilter();
    }

    function checkClearKeyWord() {
      if (vm.searchKeyword === '') {
        restoreDataFilter();
      }
    }

    function restoreDataFilter() {
      vm.visits = visitsBackup;
      vm.searchKeyword = '';
      vm.visitsFiltersEmpty = false;
      $scope.$emit(TRACKING_EVENTS.MAP.FIT_BOUNDS_VISITS_MARKERS, vm.visits);
    }

    function clearEvents() {
      listenerDateChanged();
      listenerGeneralProgressChanged();
      listenerFilterVisitMarkers();
      listenerGetVehicleDriverActive();
      if (listenerFleetsReady) {
        listenerFleetsReady();
      }
    }

    function filterVisitsMarkersByTime(event, data) {
      var filteredVisits = trackingService.filterVisits(vm.visits, data.startDate, data.endDate);
      $scope.$emit(TRACKING_EVENTS.MAP.UPDATE_FILTERED_VISIT_MARKERS, { visitIds: filteredVisits });
    }

    function returnDriverVehiceActive() {
      $scope.$emit(TRACKING_EVENTS.VEHICLES.RETURN_VEHICLE_DRIVER_ACTIVE, {});
    }

    function getVisitNgClass(visit) {
      return {
        'disabled': (visit.status === VISIT_STATUS_PENDING),
        'title-less-visible': (visit.status === VISIT_STATUS_CANCELED)
      };
    }

  }
})();

(function () {
  'use strict';

  angular
    .module("icarus.tracking")
    .constant("VISIT_STATUS_PENDING", "pending")
    .constant("VISIT_STATUS_COMPLETED", "completed")
    .constant("VISIT_STATUS_PARTIAL", "partial")
    .constant("VISIT_STATUS_FAILED", "failed")
    .constant("VISIT_STATUS_CANCELED", "canceled")
    .constant("CANCELED_VISIT_DEFAULT_COLOR", "#A4A4A4");
})();

(function () {
  'use strict';

  angular
    .module('icarus.tracking')
    .constant('ITEMS', 'ITEMS')
    .constant('PICKUP_ITEMS', 'PICKUP_ITEMS')
    .constant('ITEMS_BASE_TRANSLATE_PATH', 'Items.')
    .constant('ITEMS_COLUMN_BASE_CLASS', 'column')
    .constant('ITEMS_TABLE_ROW_BASE_CLASS', 'items-table-row')
    .constant('ITEMS_STATUS_DEFAULT_NG_CLASS', {
      'status-pending': false,
      'status-partial': false,
      'status-failed': false,
      'status-completed': false
    })
    .constant('ITEMS_STATUS_ICON_PATH', {
      'status-pending': '/assets/images/clock_filled.svg',
      'status-partial': '/assets/images/clock_filled.svg',
      'status-failed': '/assets/images/close_circle_filled.svg',
      'status-completed': '/assets/images/check_circle_filled.svg'
    })
    .constant('ITEMS_STATUS_DELIVERED', 'delivered')
    .constant('ITEMS_STATUS_UNDELIVERED', 'undelivered')
    .constant('PICKUP_ITEMS_STATUS_SUCCESSFUL', 'successful')
    .constant('PICKUP_ITEMS_STATUS_FAILED', 'failed')
    .constant('ITEMS_TABLE_FOOTER_BASE_CLASS', 'items-table-footer footer-');
})();

(function() {
  'use strict';

  angular
    .module('icarus')
    .factory('Toasts', Toasts);

  /** @ngInject */
  function Toasts ($rootScope, $timeout) {
    //'error', 'message','warning','success'

    $rootScope.toasts = [];

    var service = {
      push: push,
      remove: remove,
      stillAlive: stillAlive,
      removeAll: removeAll,
      get: get,
      getCurrents: getCurrents
    };

    return service;

    ////////////
    function push (type, message, dismiss, noDismiss) {

      if(angular.isUndefined(noDismiss)){
        noDismiss = false;
      }

      var toast = {
        type: type,
        message: message,
        dismiss: dismiss
      };

      $rootScope.toasts.push(toast);

      if (!dismiss && !noDismiss){
        $timeout(function () {
          $rootScope.toasts.splice($rootScope.toasts.indexOf(toast), 1);
        }, 4000 );
      }

      return toast;
    }

    function remove (toast) {
      $rootScope.toasts.splice($rootScope.toasts.indexOf(toast), 1);
    }

    function removeAll() {
      $rootScope.toasts.length = 0;
    }

    function getCurrents() {
      return $rootScope.toasts;
    }

    function stillAlive (toast) {
      return $rootScope.toasts.indexOf(toast) > -1;
    }

    /**
      * @param properties   object with pair (key,value) to search in $rootScope.toasts
      *
      * @description      return one or more Toast that match with the search options
      **/
    function get(properties) {
      var toasts = [];
      var length = 0;
      var count = 0;

      //Exit if properties isn't an Object or is empty
      if(properties instanceof Object) {
        for(var key in properties) {
          length++;
        }
        if(!length){
          return;
        }
      }else {
        return;
      }

      for(var i = 0; i < $rootScope.toasts.length ; i++) {
        for(var attr in properties) {
          if( attr === 'type' && ($rootScope.toasts[i].type === properties[attr] )){
            count++;
          }else if(attr === 'message' && ($rootScope.toasts[i].message.search(properties[attr]) !== -1)) {
            count++;
          }else if( attr === 'dismiss' && ($rootScope.toasts[i].dismiss === properties[attr])) {
            count++;
          }else {
            //Do nothing
          }
        }

        if(count === length) {
          toasts.push($rootScope.toasts[i]);
        }

        count = 0;
      }

      return toasts.length > 0 ? toasts : [];
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus')
    .config(toastTranslate);

  /** @ngInject */
  function toastTranslate($translateProvider) {
    // Enable log

    //// Translate keys.
    $translateProvider.translations('es', {
      'Toast' : {
        'accept'                  : 'aceptar',
        'error_unauthorized'      : 'Error en la autenticación',
        'error_path_tracking'     : 'Error para acceder a la ruta',
        'error_permissions'       : 'No posees los permisos para acceder',
        'error_get_options_map_1' : 'Error en sintaxis del mapa',
        'error_get_options_map_2' : 'Error: mapa no encontrado.',
        'error_get_map_offline'   : 'Error al visualizar el mapa, por favor revisa tu conexión a Internet',
        'error_connection_internet': 'No es posible conectarse con SimpliRoute, por favor revisa tu conexión a Internet y recarga la página'
      }
    });
    $translateProvider.translations('en', {
      'Toast' : {
        'accept'                    : 'accept',
        'error_unauthorized'        : 'Authentication error',
        'error_path_tracking'       : 'Failed to access the route',
        'error_permissions'         : 'You do not have permission to access',
        'error_get_options_map_1'   : 'Error: Syntax map',
        'error_get_options_map_2'   : 'Error: map not found.',
        'error_get_map_offline'     : 'Failed to view the map, please check your Internet connection',
        'error_connection_internet'  : 'Could not connect to SimpliRoute, please check your Internet connection and reload page'
      }
    });
    $translateProvider.translations('pt', {
      'Toast' : {
        'accept'                  : 'aceitar',
        'error_unauthorized'      : 'Erro de autenticação',
        'error_path_tracking'     : 'Erro ao acessar a rota',
        'error_permissions'       : 'Você não tem permissão para acessar',
        'error_get_options_map_1' : 'Erro de sintaxe do mapa',
        'error_get_options_map_2' : 'Erro: mapa não encontrado',
        'error_get_map_offline'   : 'Falha na visualização do mapa, favor verificar sua conexão de Internet',
        'error_connection_internet': 'Não foi possível conectar-se ao SimpliRoute, favor verificar sua conexão com a Internet e recarregar a página'
      }
    });
  }

})();

(function(){
  'use strict';

  angular
    .module('icarus')
    .directive('toast', toast);

  /** @ngInject */
  function toast ($rootScope) {

    function link(scope) {
      scope.toasts = $rootScope.toasts;


      //'error', 'message','warning','success'
      scope.getIcon = function (type){
        switch(type){
          case 'error':
            return 'fa-ban';
          case 'message':
            return 'fa-comment';
          case 'warning':
            return 'fa-warning';
          case 'success':
            return 'fa-check';
        }
      };

      scope.remove  = function (toast) {
        $rootScope.toasts.splice($rootScope.toasts.indexOf(toast), 1);
      };
    }

    var directive = {
      restrict: 'EA',
      link: link,
      replace: true,
      templateUrl: 'app/shared/toast/toast.html' ,
      scope: {}
    };

    return directive;

   }
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .directive('spTrackScroll', spTrackScroll);

  /** @ngInject */
  function spTrackScroll($timeout) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        function handler(event) {
          scope.$apply(function () {
            scope.$eval(attrs.spTrackScroll, { $event: event });
          });
        }
        element.on('scroll', handler);
        // Synthesize an initial event so the consumer can capture the element
        // and compute the initial state (e.g. progress = 100% when content fits
        // without scroll). $timeout fires after the current digest AND after
        // the browser has laid out the element — by then scrollHeight reflects
        // the actual content height, not just the element's CSS height.
        var initialTick = $timeout(function () {
          scope.$eval(attrs.spTrackScroll, { $event: { target: element[0] } });
        }, 0);
        scope.$on('$destroy', function () {
          $timeout.cancel(initialTick);
          element.off('scroll', handler);
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .directive('spFileChange', spFileChange);

  /**
   * Reemplaza los manejadores de cambio inline de los inputs de carga de
   * archivos (antes via atributo onchange). Permite quitar 'unsafe-inline' y
   * 'unsafe-hashes' de la CSP. La expresion recibe `$files` (el FileList).
   *
   * Uso: <input type="file" sp-file-change="vm.importExcel($files, vm.type)">
   */
  /** @ngInject */
  function spFileChange() {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        function handler() {
          var files = element[0].files;
          scope.$apply(function () {
            scope.$eval(attrs.spFileChange, { $files: files });
          });
          // Reset para permitir volver a seleccionar el mismo archivo,
          // igual que el `.val(null)` del onchange inline anterior.
          element.val(null);
        }
        element.on('change', handler);
        scope.$on('$destroy', function () {
          element.off('change', handler);
        });
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('validationService', validationService);

  function validationService() {
    var LATITUDE_MAX_LIMIT = 90;
    var LATITUDE_MIN_LIMIT = -90;
    var LONGITUDE_MAX_LIMIT = 180;
    var LONGITUDE_MIN_LIMIT = -180;
    var COORDINATE_REGEX = /^(-?\d+(\.\d+)?)$/;

    return {
      validateRestTime: validateRestTime,
      validateTimeFormat: validateTimeFormat,
      validateLatitude: validateLatitude,
      validateLongitude: validateLongitude
    };

    function validateTimeFormat(time) {
      var regEx = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;

      return regEx.test(time);
    }

    function validateRestTime(restTimeSettings) {
      var duration = restTimeSettings.rest_time_duration;

      var hasStart = restTimeSettings.rest_time_start ? true : false;
      var hasEnd = restTimeSettings.rest_time_end ? true : false;
      var hasDuration = duration || duration === 0 ? true : false;
      var hasShiftStart = restTimeSettings.shift_start ? true : false;
      var hasShiftEnd = restTimeSettings.shift_end ? true : false;
      var hasPeriod = hasStart && hasEnd;
      var hasAny = hasStart || hasEnd || hasDuration;
      var hasBothStart = hasStart && hasShiftStart;
      var hasBothEnd =  hasEnd && hasShiftEnd;

      var periodLength = 0;
      var periodCorrect = true;
      var periodExceeded = false;
      var validFormat = true;
      var validStart = true;
      var validEnd = true;
      var validShiftStart = true;
      var validShiftEnd = true;
      var validDuration = true;
      var validDifferenceShiftRestStart = true;
      var validDifferenceShiftRestEnd = true;

      var restTimeStart = null;
      var restTimeEnd = null;
      var shiftStart = null;
      var shiftEnd = null;

      if(hasStart) {
        restTimeStart = moment(restTimeSettings.rest_time_start, 'HH:mm');

        validStart = restTimeStart.isValid();
      }

      if(hasEnd) {
        restTimeEnd = moment(restTimeSettings.rest_time_end, 'HH:mm');

        validEnd = restTimeEnd.isValid();
      }

      if(hasShiftStart) {
        shiftStart = moment(restTimeSettings.shift_start, 'HH:mm');

        validShiftStart = shiftStart.isValid();
      }

      if(hasShiftEnd) {
        shiftEnd = moment(restTimeSettings.shift_end, "HH:mm");

        validShiftEnd = shiftEnd.isValid();
      }

      if(hasPeriod) {

        validFormat = validStart && validEnd;

        if(validFormat) {
          periodLength = moment.duration(restTimeEnd-restTimeStart).asMinutes();
          periodCorrect = restTimeStart < restTimeEnd;
        }
      }

      if(validFormat && hasPeriod && periodCorrect && hasDuration) {
        periodExceeded = periodLength < duration;
      }

      if(hasDuration) {
        validDuration = duration > 0 && duration <= 1440;
      }

      if(hasBothStart && validStart && validShiftStart) {
        var transformShiftStart = moment.duration(restTimeSettings.shift_start).asMinutes();
        var transformRestTimeStart = moment.duration(restTimeSettings.rest_time_start).asMinutes();
        validDifferenceShiftRestStart = transformRestTimeStart >= transformShiftStart;
      }

      if(hasBothEnd && validEnd && validShiftEnd) {
        var transformShiftEnd = moment.duration(restTimeSettings.shift_end).asMinutes();
        var transformRestTimeEnd = moment.duration(restTimeSettings.rest_time_end).asMinutes();
        validDifferenceShiftRestEnd = transformRestTimeEnd <= transformShiftEnd;
      }

      var status = {
        invalidRestTime: !validFormat,
        restTimeBetweenDate: !periodCorrect,
        emptyRestTime: hasAny && !hasPeriod,
        emptyRestTimeDuration: hasAny && !hasDuration,
        exceedsRestTimeDuration: periodExceeded,
        invalidDuration: !validDuration,
        invalidDifferenceShiftRestStart: !validDifferenceShiftRestStart,
        invalidDifferenceShiftRestEnd: !validDifferenceShiftRestEnd
      };

      status.isValid = !status.invalidRestTime
        && !status.restTimeBetweenDate
        && !status.emptyRestTime
        && !status.emptyRestTimeDuration
        && !status.exceedsRestTimeDuration
        && !status.invalidDuration
        && !status.invalidDifferenceShiftRestStart
        && !status.invalidDifferenceShiftRestEnd;

      return status;
    }

    function validateLatitude(lat) {
      return (
        COORDINATE_REGEX.test(lat) &&
        parseFloat(lat) >= LATITUDE_MIN_LIMIT &&
        parseFloat(lat) <= LATITUDE_MAX_LIMIT
      );
    }
    
    function validateLongitude(long) {
      return (
        COORDINATE_REGEX.test(long) &&
        parseFloat(long) >= LONGITUDE_MIN_LIMIT &&
        parseFloat(long) <= LONGITUDE_MAX_LIMIT
      );
    }
  }
})();

(function() {
    'use strict';

    angular
      .module('icarus.shared')
      .factory('utilsService', utilsService);

    /** @ngInject */
    function utilsService($window, timeUtils) {
      var DEFAULT_TIME = '00:00';
      var HEXADECIMAL_BASE = 16;
      var DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm";
      var TIME_FORMAT = "HH:mm";

      var service = {
        guid: guid,
        convertHexToRGBA: convertHexToRGBA,
        getEstimatedTimesAsDateTime: getEstimatedTimesAsDateTime,
        formatMinutesToHHMM: formatMinutesToHHMM,
        isAddonPropertyEnabled: isAddonPropertyEnabled
      };

      return service;

      function guid() {
        return $window.crypto && $window.crypto.randomUUID
          ? $window.crypto.randomUUID()
          : s4() +
          s4() +
          "-" +
          s4() +
          "-" +
          s4() +
          "-" +
          s4() +
          "-" +
          s4() +
          s4() +
          s4();

        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }
      }

      function convertHexToRGBA(hexColor, opacity) {
        hexColor = hexColor.replace('#', '');
        opacity = opacity !== undefined ? opacity : 1;

        var red = parseInt(hexColor.substring(0, 2), HEXADECIMAL_BASE);
        var green = parseInt(hexColor.substring(2, 4), HEXADECIMAL_BASE);
        var blue = parseInt(hexColor.substring(4, 6), HEXADECIMAL_BASE);

        return 'rgba(' + red + ', ' + green + ', ' + blue + ', ' + opacity + ')';
      }

      function getEstimatedTimesAsDateTime(planDate, estimatedStartTime, estimatedEndTime) {
        var planDateTime = timeUtils.createTime(planDate);
        var startTime = timeUtils.createTime(estimatedStartTime, TIME_FORMAT);
        var endTime = timeUtils.createTime(estimatedEndTime, TIME_FORMAT);

        return {
          start: timeUtils.addTimeToDate(planDateTime, startTime).format(DATE_TIME_FORMAT),
          end: timeUtils.addTimeToDate(planDateTime, endTime).format(DATE_TIME_FORMAT)
        };
      }

      function formatMinutesToHHMM(minutesToTransform) {
        if (!minutesToTransform) {
          return DEFAULT_TIME;
        };
        var hours = Math.floor(minutesToTransform / 60);
        var minutes = minutesToTransform % 60;
        return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0');
      };

      function isAddonPropertyEnabled(prop) {
        return angular.isDefined(prop) && String(prop).toLowerCase() === "true";
      }
    }
  })();

(function () {
  'use strict';

  angular
    .module('icarus')
    .factory('timeUtils', timeUtils);

  function timeUtils(moment, store) {

    var DATA_AVAILABILITY_MAX_DASY_BEFORE = 124;
    var MILLISECONDS_PER_DAY = 86400000;
    var MILLISECONDS_PER_HOUR = 3600000;
    var MILLISECONDS_PER_MINUTE = 60000;
    var SECONDS_PER_MINUTE = 60;

    return {
      createTime: createTime,
      formatTime: formatTime,
      isBetween: isBetween,
      isAfter: isAfter,
      isSame: isSame,
      today: today,
      validateStartDate: validateStartDate,
      validateDateRange: validateDateRange,
      lastDateByMonth: lastDateByMonth,
      toIsoString: toIsoString,
      toIsoStringByDate: toIsoStringByDate,
      createTimeUTC: createTimeUTC,
      duration: duration,
      asSeconds: asSeconds,
      asHours: asHours,
      asMinutes: asMinutes,
      asDays: asDays,
      getTime: getTime,
      getTimeDate: getTimeDate,
      getUnixTime: getUnixTime,
      todayByDate: todayByDate,
      diff: diff,
      isValidMoment: isValidMoment,
      newDate: newDate,
      minDateDataAvailavility: minDateDataAvailavility,
      addMinutes: addMinutes,
      addHours: addHours,
      parseMinutesToNumber: parseMinutesToNumber,
      diffWithFormat: diffWithFormat,
      timestampDiffInSeconds: timestampDiffInSeconds,
      getTimeFromISODatetime: getTimeFromISODatetime,
      formatDuration: formatDuration,
      convertTimestampFromUTCToTimezone: convertTimestampFromUTCToTimezone,
      getBrowserTimezone: getBrowserTimezone,
      getAccountTimezone: getAccountTimezone,
      convertUTCStringTimeFieldsToMomentTimezone: convertUTCStringTimeFieldsToMomentTimezone,
      convertDateToFormatString: convertDateToFormatString,
      addTimeToDate: addTimeToDate,
      convertUnixTimeToTimezone: convertUnixTimeToTimezone,
      toTimeOfDay: toTimeOfDay,
      isAValidTimeFormat: isAValidTimeFormat,
      isExtendedTimeFormat: isExtendedTimeFormat,
      parseExtendedTimeToMinutes: parseExtendedTimeToMinutes,
      compareExtendedTimes: compareExtendedTimes,
      formatMinutesToExtendedTime: formatMinutesToExtendedTime,
      formatExtendedTime: formatExtendedTime,
      adjustRestTimeForExtendedFormat: adjustRestTimeForExtendedFormat,
      parseVisitDuration: parseVisitDuration,
      formatVisitDuration: formatVisitDuration
    };

    function minDateDataAvailavility() {
      var minDay = new Date();
      minDay.setDate(minDay.getDate() - DATA_AVAILABILITY_MAX_DASY_BEFORE);
      return minDay;
    }

    function createTime(time, format) {
      var newTime;
      if (format) {
        newTime = moment(time, format);
      } else {
        newTime = moment(time);
      }
      return newTime;
    }

    function formatTime(time, formatString) {
      return moment(time).format(formatString);
    }

    function isBetween(time, startTime, endTime) {
      return time.isBetween(startTime, endTime, null, '[]');
    }

    function isAfter(start, end) {
      return start.isAfter(end);
    }

    function isSame(start, end) {
      return start.isSame(end);
    }

    function today() {
      return moment().toDate();
    }

    function validateStartDate(start, end) {
      start = moment(start);
      end = moment(end);
      return start.isSameOrBefore(end);
    }

    function validateDateRange(start, end, days) {
      start = moment(start);
      end = moment(end);
      return moment.duration(end.diff(start)).asDays() <= days;
    }

    /**
     * The function checks if a given string matches the format of a valid time in 24-hour notation.
     * @param time - The input parameter "time" is a string representing a time in the format "HH:MM",
     * where HH is the hour in 24-hour format (00-23) and MM is the minute (00-59).
     * @returns The function `isAValidTimeFormat` is returning a boolean value indicating whether the input
     * `time` matches the specified pattern for a valid time format (hh:mm).
     */
    function isAValidTimeFormat(time) {
      var pattern = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
      return pattern.test(time);
    }

    function lastDateByMonth(date, value) {
      return moment(date).subtract(value, "month").format('YYYY-MM');
    }

    function toIsoString() {
      return moment().toISOString();
    }

    function toIsoStringByDate(date) {
      return moment(date).toISOString();
    }

    function createTimeUTC(time, format) {
      var newTime;
      if (format) {
        newTime = moment.utc(time, format);
      } else {
        newTime = moment.utc(time);
      }
      return newTime;
    }

    function duration(time) {
      return moment.duration(time);
    }

    function asSeconds(duration) {
      return duration.asSeconds();
    }

    function asMinutes(duration) {
      return duration.asMinutes();
    }

    function asHours(duration) {
      return duration.asHours();
    }

    function asDays(duration) {
      return duration.asDays();
    }

    function getTime(today) {
      return today.getTime();
    }

    function getTimeDate() {
     return (new Date()).getTime();
    }

    function todayByDate(date) {
      return date.toDate();
    }

    function diff(now, then, unit) {
      return moment(now).diff(moment(then), unit);
    }

    function isValidMoment(date) {
      return moment(date).isValid();
    }

    function newDate(date) {
      return new Date(date);
    }

    function addMinutes(time, minutes) {
      return moment(time, 'HH:mm').add(minutes, 'minutes').format('HH:mm');
    }

    function addHours(timeStr, hoursToAdd) {
      var hours = moment(timeStr, 'HH:mm').hours();
      var minutes = moment(timeStr, 'HH:mm').minutes();
      hours += hoursToAdd;
      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes: minutes;
      return hours + ':' + minutes;
    }

    function parseMinutesToNumber(duration) {
      return moment.duration(duration).asMinutes() / 60;
    }

    function diffWithFormat(startTime, endTime, format) {
      var start = moment(startTime, format);
      var end = moment(endTime, format);
      var minutes = end.diff(start, 'minutes');
      var interval = moment().hour(0).minute(minutes).second(0);
      return interval.format(format);
    }

    function timestampDiffInSeconds(startTime, endTime) {
      var start = moment(startTime);
      var end = moment(endTime);
      return parseFloat(end.diff(start, 'seconds', true));
    }

    function getTimeFromISODatetime(datetime) {
      return datetime.split('T')[1].substring(0, 5);
    }

    /**
     * Given an amount of milliseconds,
     * format the duration to get a user-readable date
     * @param {Number} millis: For example 18960000
     * @return {String} The result of the example is 05:16
     */

    function formatDuration(millis) {
      var days;

      if(millis >= MILLISECONDS_PER_DAY) {
        days = Math.floor(millis / MILLISECONDS_PER_DAY);
        millis = millis % MILLISECONDS_PER_DAY;
      }
      var hours = Math.floor(millis / MILLISECONDS_PER_HOUR);
      millis = millis % MILLISECONDS_PER_HOUR;
      var minutes = Math.floor(millis / MILLISECONDS_PER_MINUTE);
      var formatDay = (hours < 10 ? "0" : "") + hours + ":" + (minutes < 10 ? "0" : "") + minutes;

      return days ? (days + " " + formatDay) : formatDay;
    }

    /**
     * Convert a timestamp string to a moment object with specific timezone associated
     * @param {Moment} timestamp: the object to which the timezone will be set.
     * @param {String} timezone: any timezone string
     * @returns {Moment} with the specific timezone.
     */
    function convertTimestampFromUTCToTimezone(timestamp, timezone){
      return timestamp.tz(timezone);
    }

    /**
     * Get the browser timezone
     * @returns {string} with the current timezone of the browser
     */
    function getBrowserTimezone(){
      return moment.tz.guess();
    }

    /**
     * Get the account timezone stored in LocalStorage. If not exist, return the browser timezone.
     * @returns {string} with the user timezone or the browser timezone if the first wasn't stored.
     */
    function getAccountTimezone(){
      var accountTimezone = store.get('accountTimezone');
      if(!accountTimezone){
        accountTimezone = getBrowserTimezone();
      }
      return accountTimezone;
    }

    /**
     * Given a specific list of fields which each might be available in the source object or not,
     * read them and convert from UTC String to Moment Timezone using the given timezone.
     * @param {VisitModel|VisitDetailModel|Event}  source: the object with
     * @param {String[]} fieldList: a list of field where each might be inside the object
     * @param {String} timezone: the timezone to use if the field exists
     */
    function convertUTCStringTimeFieldsToMomentTimezone(source, fieldList, timezone){
      fieldList.forEach(function(field){
        if(source[field]){
          source[field] = moment.utc(source[field]).tz(timezone);
        }
      });
    }

    /**
     * Convert a Moment object to a string with a specific format.
     * @param {Moment|String|Undefined} field: moment object that will be converted
     * @param {String} formatString: the format that will be used
     * @returns {String|Undefined}: string formatted date or undefined
     */
    function convertDateToFormatString(field, formatString){
      if(moment.isMoment(field)){
        return field.format(formatString).toString();
      }
      return field;
    }

    function addTimeToDate(date, time) {
      return date.clone().set({'hour': time.hour(), 'minute': time.minute()});
    }

    function getUnixTime(date) {
      return moment(date).unix();
    }

    function convertUnixTimeToTimezone(unixTime, timezoneOffset) {
      return unixTime + SECONDS_PER_MINUTE * timezoneOffset;
    }

    /**
     * Convert a timeString a format 'HH:mm'.
     * Example:
     * 2022-09-28 10:23:35 to 10:23
     * 2022-09-28          to 00:00
     * 2022-09-28T10:23    to 10:23
     * 10:23:00            to 10:23
     *
     * @param {String} timeString: the format that will be used
     * @returns {String|Undefined}: string formatted date or undefined
     */
    function toTimeOfDay(timeString) {
      return moment(timeString).isValid() ? moment(timeString).format('HH:mm'): moment(timeString,'HH:mm').format('HH:mm');
    }

    /**
     * Checks if time is in extended format (hours >= 24)
     * @param {string} time - Time in HH:mm format
     * @returns {boolean} true if hours >= 24
     */
    function isExtendedTimeFormat(time) {
      if (!time || typeof time !== 'string') {
        return false;
      }
      var hours = parseInt(time.split(':')[0]);
      return hours >= 24;
    }

    /**
     * Parses extended time format to total minutes for comparison
     * @param {string} time - Time in HH:mm format (supports extended hours like 25:30)
     * @returns {number} Total minutes from 00:00
     */
    function parseExtendedTimeToMinutes(time) {
      if (!time || typeof time !== 'string') {
        return 0;
      }
      var parts = time.split(':');
      return parseInt(parts[0]) * 60 + parseInt(parts[1]);
    }

    /**
     * Compares two times supporting extended format
     * @param {string} time1 - First time in HH:mm format
     * @param {string} time2 - Second time in HH:mm format
     * @returns {number} Negative if time1 < time2, positive if time1 > time2, 0 if equal
     */
    function compareExtendedTimes(time1, time2) {
      var mins1 = parseExtendedTimeToMinutes(time1);
      var mins2 = parseExtendedTimeToMinutes(time2);
      return mins1 - mins2;
    }

    /**
     * Formats total minutes back to HH:mm (supporting extended hours)
     * @param {number} totalMinutes - Total minutes from 00:00
     * @returns {string} Time in HH:mm format (can be extended like 25:30)
     */
    function formatMinutesToExtendedTime(totalMinutes) {
      var hours = Math.floor(totalMinutes / 60);
      var minutes = totalMinutes % 60;
      return hours + ':' + (minutes < 10 ? '0' : '') + minutes;
    }

    /**
     * Formats a datetime or time string to HH:mm format, supporting extended hours
     * @param {string} timeString - Time string (ISO datetime or HH:mm format)
     * @returns {string} Time in HH:mm format (supports extended hours)
     */
    function formatExtendedTime(timeString) {
      if (!timeString) {
        return '00:00';
      }
      // If already in extended format (contains only HH:mm with hours >= 24), return as is
      if (isExtendedTimeFormat(timeString)) {
        return timeString;
      }
      // If it's an ISO datetime string, extract time portion
      if (timeString.indexOf('T') !== -1) {
        var timePart = timeString.split('T')[1];
        return timePart ? timePart.substring(0, 5) : '00:00';
      }
      // If it's already HH:mm format
      if (timeString.indexOf(':') !== -1 && timeString.length <= 8) {
        return timeString.substring(0, 5);
      }
      // Fallback to moment for other formats
      return moment(timeString).isValid() ? moment(timeString).format('HH:mm') : '00:00';
    }

    /**
     * Adjusts rest time windows for extended format when crossing midnight.
     * Converts times like 00:30-02:30 to 24:30-26:30 when the window crosses midnight.
     *
     * @param {string} restTimeStart - Rest time start in HH:mm format
     * @param {string} restTimeEnd - Rest time end in HH:mm format
     * @returns {Object} Object with adjusted start and end times in extended format
     */
    function adjustRestTimeForExtendedFormat(restTimeStart, restTimeEnd) {
      if (!restTimeStart || !restTimeEnd) {
        return { start: restTimeStart, end: restTimeEnd };
      }

      var startMinutes = parseExtendedTimeToMinutes(restTimeStart);
      var endMinutes = parseExtendedTimeToMinutes(restTimeEnd);

      // If end time is before start time, it means the window crosses midnight
      // Convert to extended format: 00:30 becomes 24:30
      if (endMinutes < startMinutes) {
        endMinutes += 24 * 60;
      }

      return {
        start: formatMinutesToExtendedTime(startMinutes),
        end: formatMinutesToExtendedTime(endMinutes)
      };
    }

    /**
     * Parses a visit `duration` into integer minutes.
     *
     * Front contract: visit duration is always HH:MM[:SS], never MM:SS,
     * matching the rest of the front's time-field convention.
     *  - HH:MM     -> hours * 60 + minutes (e.g. '01:50' -> 110, '04:00' -> 240)
     *  - HH:MM:SS  -> hours * 60 + minutes, +1 minute when seconds > 0
     *                 (e.g. '00:40:30' -> 41, '00:40:00' -> 40)
     *  - number / numeric string -> rounded to nearest integer
     *  - invalid ('01:60', '00:99', 'abc', etc.) -> null
     *
     * Also accepts the day-prefixed outputs the back sends for >= 24h:
     *  - '1 day, 2:00:00'  (str(timedelta))      -> days * 24 * 60 + rest (-> 1560)
     *  - '1 02:00:00'      (DRF duration_string) -> same (-> 1560)
     *  - '0:00:30.000500'  -> microseconds count as a sub-minute remainder (ceil)
     */
    function parseVisitDuration(input) {
      if (input === null || input === undefined) {
        return null;
      }

      if (typeof input === 'number') {
        return isFinite(input) ? Math.round(input) : null;
      }

      var str = String(input).trim();
      if (str === '') {
        return null;
      }

      if (/^-?\d+(\.\d+)?$/.test(str)) {
        var n = Number(str);
        return isFinite(n) ? Math.round(n) : null;
      }

      var days = 0;
      var daysMatch = str.match(/^(\d+)\s+(?:days?,\s+)?(.*)$/);
      if (daysMatch) {
        days = Number(daysMatch[1]);
        str = daysMatch[2];
      }

      var match = str.match(/^(\d{1,3}):(\d{1,2})(?::(\d{1,2})(?:\.(\d+))?)?$/);
      if (!match) {
        return null;
      }

      var hours = Number(match[1]);
      var minutes = Number(match[2]);
      var seconds = match[3] != null ? Number(match[3]) : 0;
      var microseconds = match[4] != null ? Number(match[4]) : 0;

      if (minutes >= 60 || seconds >= 60) {
        return null;
      }

      var total = days * 24 * 60 + hours * 60 + minutes;
      return seconds > 0 || microseconds > 0 ? total + 1 : total;
    }

    // Inverse of parseVisitDuration: whole minutes -> zero-padded "HH:MM:SS".
    function formatVisitDuration(minutes) {
      if (minutes === null || minutes === undefined || isNaN(minutes)) {
        return null;
      }
      var total = Math.max(0, Math.round(minutes));
      var hours = Math.floor(total / 60);
      var mins = total % 60;
      function pad(value) {
        return (value < 10 ? '0' : '') + value;
      }
      return pad(hours) + ':' + pad(mins) + ':00';
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('ssoChannelsService', ssoChannelsService);

  /** @ngInject */
  function ssoChannelsService($log) {
    var service = {
      hasWebSso: hasWebSso,
      excludesWebSso: excludesWebSso
    };

    return service;

    function hasWebSso(ssoDomain, ssoChannels) {
      if (!ssoDomain) {
        return false;
      }
      if (!angular.isArray(ssoChannels)) {
        // Backwards-compat: backend may not expose sso_channels yet.
        $log.warn('[sso] sso_channels missing — using legacy fallback', { ssoDomain: ssoDomain });
        return true;
      }
      return ssoChannels.indexOf('web') !== -1;
    }

    // True only when the account explicitly excludes the web channel.
    function excludesWebSso(ssoDomain, ssoChannels) {
      if (!ssoDomain) {
        return false;
      }
      if (!angular.isArray(ssoChannels)) {
        return false;
      }
      return ssoChannels.indexOf('web') === -1;
    }
  }
})();

(function (){
  'use strict';

  angular
  .module('icarus.shared')
  .factory('routeService', routeService);

  function routeService(__env, $q, $http){
    var ROUTES_PATH = __env.API_URL + 'routes/routes/';
    return {
      patchRoute: patchRoute
    };

    function patchRoute(requestData, route_id){
      if (Object.keys(requestData).length !== 0) {
        return $http.patch(ROUTES_PATH + route_id + '/', requestData);
      }
      return $q.when(requestData);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .factory('requestService', requestService);

  /** @ngInject */
  function requestService($http, lodash, asyncUtils) {

    var START_PAGE_DEFAULT = 1;
    var PAGE_SIZE_DEFAULT = 500;
    var REQUEST_PAGINATION_CONCURRENCY = 5;

    return {
      httpGetPaginated: httpGetPaginated,
      convertOptionsToQueryParams: convertOptionsToQueryParams
    };

    function convertOptionsToQueryParams(options) {
      return Object.keys(options)
        .map(function (k) {
          return encodeURIComponent(k) + "=" + encodeURIComponent(options[k]);
        })
        .join("&");
    }

    function _getRequestByPageList(response, httpOptions) {
      var pageCount = Math.ceil(response.data.count / httpOptions.params.page_size);
      var requestByPageList = [];
      for (var pageNumber = httpOptions.params.page + 1; pageNumber <= pageCount; pageNumber++) {
        var pagingOptions = angular.copy(httpOptions);
        pagingOptions.params = angular.merge(
          {}, httpOptions.params, { page: pageNumber }
        );
        requestByPageList.push({
          url: response.config.url,
          options: pagingOptions
        });
      }
      return requestByPageList;
    }

    function httpGetPaginated(url, options) {
      var httpOptions;

      var defaultParams = {
        page: START_PAGE_DEFAULT,
        page_size: PAGE_SIZE_DEFAULT
      };

      if (angular.isUndefined(options)) {
        httpOptions = {
          params: defaultParams
        };
      }
      else {
        httpOptions = angular.merge({}, options);
        httpOptions.params = angular.merge(
          {}, defaultParams, options.params
        );
      }

      return $http.get(url, httpOptions)
        .then(function (response) {
          if (response.data.next) {
            var requestParamsList = _getRequestByPageList(response, httpOptions);
            var httpCallback = function (params) {
              return $http.get(params.url, params.options)
                .then(function (request) {
                  return request.data.results;
                });
            };
            return asyncUtils.promiseMap(requestParamsList, httpCallback, REQUEST_PAGINATION_CONCURRENCY)
              .then(function (data) {
                response.data = lodash.concat(response.data.results, lodash.flatten(data));
                return response;
              });
          }
          else {
            response.data = response.data.results;
            return response;
          }
        });
    }
  }
})();

/**
 * Created by guiulianaheran on 21-02-17.
 */
(function () {
  'use strict';

  angular
    .module('icarus')
    .factory('polylineService', polylineService);

  /** @ngInject */
  function polylineService(moment, lodash, __env, timeUtils) {
    var typeSimpliGps = 'simpli';
    var distanceDefaultpermitted = 2500; //meters
    var velocityDefault = _metersPerSeconds(100);
    var MAX_ALLOWED_DISTANCE_BETWEEN_GPS = 2000;
    var MIN_DISTANCE_FOR_SPEED_CALCULATION = 200;
    var MAX_ALLOWED_SPEED_BETWEEN_GPS = 200;

    return {
      calculatePolylines: calculatePolylines,
      calculatePolylines1: calculatePolylines1,
      calculatePolylines2: calculatePolylines2,
      cleanGpsPoints2: cleanGpsPoints2,
      buildPolylines: buildPolylines
    };

    //////////////////////////////////////////
    // Privates Methodsº
    /////////////////////////////////////////

    function _deg2rad(deg) {
      return deg * (Math.PI / 180);
    }

    function calculateDistance(location1, location2) {
      var R = 6371; // Radius of the earth in km
      var dLat = _deg2rad(location2.latitude - location1.latitude);  // _deg2rad below
      var dLon = _deg2rad(location2.longitude - location1.longitude);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(_deg2rad(location1.latitude)) * Math.cos(_deg2rad(location2.latitude)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
      ;
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c; // Distance in km
      return d * 1000;
    }

    function _calculateTime(location1, location2) {
      var a = moment(location2.timestamp).diff(moment(location1.timestamp));
      var b = moment.duration(a).asSeconds();
      return b;
    }

    function _metersPerSeconds(km) {
      return ((km * 1000) / 3600);
    }

    function _calculateArrayPolylines(data, functionLogicGps) {
      var prevLocation = null;
      var locationsArray = [];
      data.forEach(function (location) {
        var actualLocation = {
          latitude: location.latitude,
          longitude: location.longitude,
          timestamp: location.timestamp
        };

        if (prevLocation && (prevLocation.timestamp === actualLocation.timestamp)) {
          return;
        }

        // primer item
        if (locationsArray.length === 0) {
          locationsArray.push([actualLocation]);
          prevLocation = {
            latitude: actualLocation.latitude,
            longitude: actualLocation.longitude,
            timestamp: actualLocation.timestamp
          };
          return;
        }

        functionLogicGps(locationsArray, actualLocation, prevLocation);
        prevLocation = {
          latitude: actualLocation.latitude,
          longitude: actualLocation.longitude,
          timestamp: actualLocation.timestamp
        };
      });
      return locationsArray;
    }

    function _logicSimpliGps(locationsArray, actualLocation, prevLocation) {
      var t2 = moment(actualLocation.timestamp);
      var t1 = moment(prevLocation.timestamp);
      var distance, time;


      distance = calculateDistance(prevLocation, actualLocation);

      if (moment.duration(t2.diff(t1)).asSeconds() > 20) {
        if (distance < distanceDefaultpermitted) {
          time = _calculateTime(actualLocation, prevLocation);
          if ((distance / time) < velocityDefault) {
            locationsArray[locationsArray.length - 1].push(actualLocation);
          }
        } else {
          locationsArray.push([actualLocation]);
        }
      }
    }

    function _logicExternalProviderGps(locationsArray, actualLocation) {
      locationsArray[locationsArray.length - 1].push(actualLocation);
    }

    function _cleanGpsPoints(locations) {
      var data = lodash.clone(locations);

      data.sort(function(a,b) {
        if (a.timestamp < b.timestamp) {
          return -1;
        }
        if (a.timestamp > b.timestamp) {
          return 1;
        }
        return 0;
      });
      var indexes = [];
      data.forEach(function (location, index) {
        if (data[index + 1]) {
          var distance = calculateDistance(data[index], data[index + 1]);
          if (distance > distanceDefaultpermitted) {
            indexes.push(index);
          }
        }
      });
      indexes = lodash.uniq(indexes);

      indexes.forEach(function (index) {
        delete data[index];
      });

      data = data.filter(function (val) {
        return val;
      });

      return data;
    }


    ////////////////////////////////////////////
    // Public Methods
    ////////////////////////////////////////////

    function cleanGpsPoints2(locations) {
      var defaultMin = __env.DEFAULT_ACCURACY_MIN_VALUE;
      var minValuesByActivityType = __env.GPS_ACCURACY_MIN_VALUES;
      locations = locations || [];

      return locations.filter(function (location) {
        if (location.activity_type === '') {
          return true;
        }
        var minValue = minValuesByActivityType[location.activity_type] || defaultMin;
        return (location.accuracy <= minValue);
      });

    }


    function calculatePolylines(data) {
      return __env.NEW_GPS_RENDERER ? calculatePolylines2(data) :
        calculatePolylines1(data);
    }


    function calculatePolylines1(data) {
      var typeGps;
      var polylines = [];
      var logicSimpliGps = _logicSimpliGps;
      var logicExternalProviderGps = _logicExternalProviderGps;

      var locations = _cleanGpsPoints(data);

      locations.length > 0 ? typeGps = locations[0].type : typeGps = null;

      if (typeGps === typeSimpliGps) {
        polylines = _calculateArrayPolylines(locations, logicSimpliGps);
      } else {
        polylines = _calculateArrayPolylines(locations, logicExternalProviderGps);
      }
      return polylines;
    }

    // New polylines calculation function using  NEW_GPS_RENDERER flag
    function calculatePolylines2(data) {
      var typeGps = data.length ? data[0].type : null;
      var polylines = [];
      var logicExternalProviderGps = _logicExternalProviderGps;

      if (typeGps === typeSimpliGps) {
        // Using new clean function NEW_GPS_RENDERER = true
        polylines = buildPolylines(
          cleanGpsPoints2(data)
        );
      }
      else {
        // Keep the same logic that the old renderer => NEW_GPS_RENDERER = false
        polylines = _calculateArrayPolylines(
          _cleanGpsPoints(data),
          logicExternalProviderGps
        );
      }

      return polylines;
    }

    function calculateSpeed(distance, time) {
      var distanceInKm = distance / 1000;
      var timeInHours = time / 3600;
      return (distanceInKm / timeInHours);
    }

    function addLocationToSection(polylineSection, filteredPoints, i) {
      if (!polylineSection.length) {
        polylineSection.push(filteredPoints[i]);
      }
      polylineSection.push(filteredPoints[i + 1]);
    }

    function addAndResetSection(polylines, polylineSection) {
      if (polylineSection.length) {
        polylines.push(polylineSection);
      }
      polylineSection = [];
      return polylineSection;
    }

    function isLastFilteredLocation(i, filteredPoints) {
      return i + 1 === filteredPoints.length - 1;
    }

    function buildLocation(filteredPoints, i) {
      return {
        latitude: parseFloat(filteredPoints[i].latitude),
        longitude: parseFloat(filteredPoints[i].longitude),
        timestamp: filteredPoints[i].timestamp
      };
    }

    /**
     *
     * @param location1
     * @param location2
     * @param distance
     * @returns km/h
     */
    function calculateMovingSpeed(location1, location2, distance) {
      var time = timeUtils.timestampDiffInSeconds(location1.timestamp, location2.timestamp);
      return calculateSpeed(distance, time);
    }

    function buildPolylines(filteredPoints) {
      var polylines = [];
      var polylineSection = [];

      for (var i = 0; i < filteredPoints.length - 1; i++) {
        var location1 = buildLocation(filteredPoints, i);
        var location2 =  buildLocation(filteredPoints, i + 1);

        var distance = calculateDistance(location1, location2);

        if (distance <= MAX_ALLOWED_DISTANCE_BETWEEN_GPS) {
          if (distance >= MIN_DISTANCE_FOR_SPEED_CALCULATION) {
            var speed = calculateMovingSpeed(location1, location2, distance);
            if (speed <= MAX_ALLOWED_SPEED_BETWEEN_GPS) {
              addLocationToSection(polylineSection, filteredPoints, i);
            } else {
              polylineSection = addAndResetSection(polylines, polylineSection);
            }
          } else {
            addLocationToSection(polylineSection, filteredPoints, i);
          }
          if (isLastFilteredLocation(i, filteredPoints)) {
            polylineSection = addAndResetSection(polylines, polylineSection);
          }
        } else {
          if (polylineSection.length) {
            polylineSection = addAndResetSection(polylines, polylineSection);
          }
        }
      }
      return polylines;
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('icarus.shared')
    .factory('osrmService', osrmService);

  /** @ngInject */
  function osrmService($http, __env, $q, timeUtils, dnsUtilsService, OSRMStatus, store, DEFAULT_SHIFT_START,
                       accountConfigsService, $log, googleService, vehicleTypeUtils) {

    var DECIMAL_SECONDS = 600;
    var VIAROUTE_URL = __env.OSRM_VIAROUTE_URL;
    var VIAROUTE_COUNT = __env.OSRM_VIAROUTE_COUNT;
    var DISTANCE_TABLE_URL = __env.OSRM_URL + 'table';
    var ENABLE_UTURNS = 'enable_uturns';
    var VIAROUTE_ROUTER_MS_URL = __env.ROUTER_MS_URL + 'v2/viaroute';

    var service = {
      callOSRMForDistance: callOSRMForDistance,
      callOSRMViaroute: callOSRMViaroute,
      addETAandETDToVisits: addETAandETDToVisits,
      callOSRMTable: callOSRMTable
    };
    return service;

    ////////////////////////////////////////////
    // Public Methods
    ////////////////////////////////////////////

    function getCurrentCountryOrNull() {
      var country = store.get('country');
      return country || null;
    }

    function callOSRMViaroute(coordinates, uturns, optimizationOptions, startTime, isVehicularRestrictionEnabled, vehicleId) {
      var request = {
        loc: coordinates,
        uturns: uturns,
        country: getCurrentCountryOrNull(),
        start_time: startTime
      };

      if (optimizationOptions && optimizationOptions.avoid_tolls === true) {
        request.avoid = "tolls";
      }

      var viarouteBaseUrl = '';
      if (isVehicularRestrictionEnabled && vehicleId) {
        viarouteBaseUrl = VIAROUTE_ROUTER_MS_URL;
        request.vehicle_id = vehicleId;
      } else {
        viarouteBaseUrl = VIAROUTE_URL;
      }

      var viarouteEndpoint = dnsUtilsService.getURLByRndDNSNum(viarouteBaseUrl, VIAROUTE_COUNT);
      if (vehicleTypeUtils.shouldAddVehicleType(optimizationOptions)) {
        var vehicleType = vehicleTypeUtils.getVehicleType(optimizationOptions);
        viarouteEndpoint = viarouteEndpoint + "/" + vehicleType;
      }

      return $http.post(viarouteEndpoint, request)
        .then(function(response) {
          if (response.data.status === OSRMStatus.NO_ROUTES_BETWEEN_POINTS) {
            return response;
          }

          response.data.route_summary = {
            end_point: response.data.summary.endPoint,
            start_point: response.data.summary.startPoint,
            total_time: response.data.summary.totalTime,
            total_distance: response.data.summary.totalDistance
          };

          response.data.route_geometry = response.data.geometry;

          return response;
        });
    }

    function callOSRMTable(coordinates, speedRate) {
      return $http.post(DISTANCE_TABLE_URL, {
        loc: coordinates,
        speedRate: speedRate,
        country: getCurrentCountryOrNull()
      })
      .then(function(response) {
        return {
          data: {
            distance_table: response.data.matrix
          }
        };
      });
    }

    function addETAandETDToVisits(shiftStart, visits, speedRate) {
      var travelTime, arrivalTime, departureTime, times;
      var startTime = shiftStart ? shiftStart : DEFAULT_SHIFT_START;
      var deferred = $q.defer();
      var usedCoordsIndexes = [];
      var coordinates = [];

      visits.forEach(function (visit, i) {
        if (visit.latitude !== 0 && visit.longitude !== 0) {
          usedCoordsIndexes.push(i);
          coordinates.push(visit.latitude + "," + visit.longitude);
        }
      });

      if (coordinates.length > 1 ) {
        callOSRMTable(coordinates, speedRate)
          .then(function (response) {
            var distanceTable = response.data.distance_table;

            times = visits.map(function (visit, k) {
              var j = usedCoordsIndexes.indexOf(k);
              var i = j === 0 ? 0 : j - 1;

              if (j !== -1) {
                travelTime = distanceTable[i][j] / DECIMAL_SECONDS;
                arrivalTime = timeUtils.addMinutes(startTime, travelTime);
              }else {
                arrivalTime = startTime;
              }

              departureTime = timeUtils.addMinutes(arrivalTime, timeUtils.parseMinutesToNumber(visit.duration));
              startTime = departureTime;

              return {estimatedTimeArrival: arrivalTime, estimatedTimeDeparture: departureTime};
            });

            deferred.resolve(times);
          })
          .catch(function(error) {
            deferred.reject(error);
          });
      } else {
        times = visits.map(function(visit) {
          arrivalTime = startTime;
          departureTime = timeUtils.addMinutes(arrivalTime, timeUtils.parseMinutesToNumber(visit.duration));
          startTime = departureTime;

          return {estimatedTimeArrival: arrivalTime, estimatedTimeDeparture: departureTime};
        });

        deferred.resolve(times);
      }

      return deferred.promise;
    }

    function callOSRMForDistance(route, coordinates, isBigOrDrawClusterActive, optimizationOptions, startTime, isVehicularRestrictionEnabled, vehicleId, activeUturns) {
      if (coordinates.length < 2) {
        route.totalDistance = 0;
        return $q.when();
      }
      var isUturnsEnabled = accountConfigsService.isConfigEnabled(ENABLE_UTURNS);
      var uturns = isUturnsEnabled || Boolean(activeUturns);

      return service.callOSRMViaroute(coordinates, uturns, optimizationOptions, startTime, isVehicularRestrictionEnabled, vehicleId)
        .then(function (response) {
          if (response.data.route_geometry) {
            route.polyline = response.data.route_geometry;
          }
          if (response.data.status === OSRMStatus.NO_ROUTES_BETWEEN_POINTS && !uturns) {
            service.callOSRMForDistance(route, coordinates, isBigOrDrawClusterActive, optimizationOptions, startTime, isVehicularRestrictionEnabled, vehicleId, true);
          } else if (response.data.status === OSRMStatus.FOUND_ROUTE_BETWEEN_POINTS) {
            var summary = response.data.route_summary;
            if (summary && angular.isDefined(summary.total_distance)) {
              route.totalDistance = (summary.total_distance / 1000);
            }
            if (!isBigOrDrawClusterActive) {
              route.path = _decodeGeometry(response.data.route_geometry, 6);
            }
            route.actionUpdate(route);
          }
        })
        .catch(function (objError) {
          $log.info('Error callOSRMForDistance', objError);
        });
    }

    function _decodeGeometry(encoded, precision) {
      precision = Math.pow(10, -precision);
      var len = encoded ? encoded.length : 0, index = 0, lat = 0, lng = 0, array = [];
      while (index < len) {
        var b, shift = 0, result = 0;
        do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        var dlat = ((result & 1) ? ~(result >> 1) : (result >> 1));
        lat += dlat;
        shift = 0;
        result = 0;
        do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        var dlng = ((result & 1) ? ~(result >> 1) : (result >> 1));
        lng += dlng;
        var point = {
          latitude: lat * precision,
          longitude: lng * precision
        };
        array.push(googleService.getGoogleMapsLatLng(point.latitude, point.longitude));
      }
      return array;
    }
  }
})();

(function(){
  'use strict';
  angular
    .module('icarus.shared')
    .factory('LogService', LogService);

  /** @ngInject */
  function LogService ($log, $http, __env, Log, sessionService) {

    ////////////

    var service = {
      createLogForPlan: createLogForPlan
    };

    return service;

    function _getUrlCreatePost() {
      return __env.API_URL + 'logs/';
    }

    function _createLog(logData) {
      var request = {
        account: logData.accountId,
        user_id: logData.userId,
        username: logData.username,
        json: JSON.stringify(logData.json),
        type_action: logData.typeAction
      };

      $http.post(_getUrlCreatePost(), request).then(function () {
        $log.info('Saved successful');
      }).catch(function (error) {
        $log.error('failed save log', error);
      });
    }

    ////////////////////////////////////////////
    // Public Methods
    ////////////////////////////////////////////

    function createLogForPlan(plan, action) {
      sessionService.getUser().then(function (user) {
        var dataLog = {
          account_id: user.account.id,
          user_id: user.id,
          username: user.username,
          type_action: action,
          json: {
            plan_id: plan.id,
            username: user.username,
            name_plan: plan.name,
            start_date_plan: plan.startDate,
            end_date_plan: plan.endDate
          }
        };

        var logModel = Log.fromJson(dataLog);

        _createLog(logModel);
      });
    }



  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('geocoderService', geocoderService );

  /** @ngInject*/
  function geocoderService($http, __env) {
    var GEOCODE_PATH = 'directory/geocode/';

    return {
      geocode: geocode,
      geocodeBatch: geocodeBatch
    };

    function geocode(address) {
      var data = {
        ref_id: "1",
        address: address,
        district: ""
      };

      return $http.post(__env.APIV2_URL + GEOCODE_PATH, data);
    }

    function geocodeBatch(country, quality_level, visits) {
      var data = {
        country: country,
        qualityLevel: quality_level,
        addresses: {}
      };
      visits.forEach(function(visit) {
        data.addresses[visit.id] = {
          rawAddress: visit.address
        };

        if (country === 'CO') {
          if (visit.city && visit.city !== '') {
            data.addresses[visit.id].city = visit.city;
          }
        }
      });

      return $http.post(__env.BASE_URL_NEW_GEOCODER + __env.NEW_GEOCODER_PATH, data);
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('fleetService', fleetService);

  function fleetService(__env, $http, $cacheFactory, $q, vehicleService, naturalService, colorAssignerService) {
    var cache = $cacheFactory('fleets');
    var fleetsUrl = __env.API_URL + 'fleets/';
    return {
      getFleets: getFleets,
      getVehiclesByFleets: getVehiclesByFleets,
      getVehiclesListByFleet: getVehiclesListByFleet,
      listVehicles: listVehicles,
      createFleet: createFleet,
      deleteFleet: deleteFleet,
      updateFleet: updateFleet,
      getMyFleets: getMyFleets,
      paintVehiclesByFleet: paintVehiclesByFleet,
      clearCache: clearCache
    };

    function getDetailUrl(fleetId) {
      return fleetsUrl + fleetId + '/';
    }

    function getMyFleetsUrl() {
      return fleetsUrl + 'my-fleets/';
    }

    function getFleets() {
      return $http.get(fleetsUrl, {cache: cache})
        .then(function (response) {
          var fleets = response.data;
          fleets.sort(sortByName);
          return fleets;
        });
    }

    function getVehiclesByFleets(vehicles, fleets) {
      var vehiclesByFleets = {};
      var vehiclesFound;

      fleets.forEach(function (fleet) {
        if (fleet.vehicles.length > 0) {

          vehiclesFound = vehicles.filter(function (vehicle) {
            return fleet.vehicles.indexOf(parseInt(vehicle.id)) !== -1;
          });

          if (vehiclesFound.length > 0) {
            vehiclesByFleets[fleet.id] = [];
            angular.forEach(vehiclesFound, function(item) {
              vehiclesByFleets[fleet.id].push(item);
            });
            vehiclesByFleets[fleet.id].sort(sortByNaturalName);
          }
        }
      });

      return vehiclesByFleets;
    }

    function paintVehiclesByFleet(vehicles, fleet) {
      vehicles.forEach(function(vehicle, index) {
        var color = fleet.colors[index % fleet.colors.length];
        colorAssignerService.setDefaultVehicleColorCache(vehicle.id, color);
      });
    }

    function sortByName(a, b) {
      return a.name < b.name ? -1 : (a.name > b.name ? 1 : 0);
    }

    function sortByNaturalName(a, b) {
      function naturalOrder(item) {
        return naturalService.naturalValue(item.name.toLowerCase());
      }
      var na = naturalOrder(a);
      var nb = naturalOrder(b);
      return na < nb ? -1 : (na > nb ? 1 : 0);
    }

    function getVehiclesListByFleet(vehicles, fleet) {
      return vehicles.filter(function (vehicle) {
        return fleet.vehicles.find(function (fleetVehicle) {
          return fleetVehicle === parseInt(vehicle.id);
        });
      });
    }

    function listVehicles() {
      var deferred = $q.defer();
      var vehicles = [];
      vehicleService.list().then(function (data) {
        data.forEach(function (vehicle) {
          vehicles.push({
            id: vehicle.id,
            name: vehicle.name,
          });
        });
        deferred.resolve(vehicles);
      }).catch(function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function createFleet(fleet) {
      return $http.post(fleetsUrl, fleet).then(
        function (resp) {
          $cacheFactory.get('fleets').removeAll();
          return resp.data;
        });
    }

    function deleteFleet(fleetId) {
      return $http.delete(getDetailUrl(fleetId))
        .then(function() {
          $cacheFactory.get('fleets').removeAll();
        });
    }

    function updateFleet(fleetId, data) {
      return $http.put(getDetailUrl(fleetId), data)
        .then(function(response) {
          $cacheFactory.get('fleets').removeAll();
          return response.data;
        });
    }

    function getMyFleets() {
      return $http.get(getMyFleetsUrl(), {cache: cache}).then(function(response) {
        return response.data.sort(sortByName);
      });
    }

    function clearCache() {
      $cacheFactory.get('fleets').removeAll();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.bulk', []);
})();

(function () {
  'use strict';

  angular
    .module('icarus.bulk')
    .factory('fileDownloaderService', FileDownloaderService);

  /** @ngInject */
  function FileDownloaderService(FileSaver) {

    return {
      downloadXLSX: downloadXLSX,
      donwloadFile: donwloadFile
    };

    function downloadXLSX(workbookFile, fileName) {
      FileSaver.saveAs(new Blob([s2ab(workbookFile)], {type: ''}), fileName);
    }

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
      }
      return buf;
    }

    function donwloadFile(data, fileName) {
      FileSaver.saveAs(data, fileName);
    }


  }
})();


(function (){
  'use strict';

  angular
  .module('icarus.shared')
  .factory('deliveryIssueService', deliveryIssueService);

  /** @ngInject*/
  function deliveryIssueService(__env, $http,  $cacheFactory, CACHE_KEYS) {
    var servicePath = __env.API_URL + 'accounting/invoices/delivery-issues/';
    var cache = $cacheFactory(CACHE_KEYS.CACHE_DELIVERY_ISSUE);

    var serviceMethods = {
      getDeliveryIssues: getDeliveryIssues,
      removeCache: removeCache,
    };

    function getDeliveryIssues() {
      var httpOptions = {
        cache: cache
      };

      return $http.get(servicePath, httpOptions)
        .then(function (response) {
          return response.data;
        });
    }

    function removeCache() {
      if ($cacheFactory.get(CACHE_KEYS.CACHE_DELIVERY_ISSUE)) {
        $cacheFactory.get(CACHE_KEYS.CACHE_DELIVERY_ISSUE).removeAll();
      }
    }

    return serviceMethods;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .factory('asyncUtils', asyncUtils);

  function asyncUtils($q, lodash) {

    var service = {
      promiseMap: promiseMap,
      promiseMapSeries: promiseMapSeries,
    };

    /**
     * Given an Iterable (an array, for example), or a promise of an Iterable, iterates
     * serially over all the values in it, executing the given mapper on each element.
     * @param {Array} iterable An Array or other iterable object.
     * @param {Function} callback A function to be run for each element in the iterable array.
     * @returns Promise
     */
    function promiseMapSeries(iterable, callback) {
      return iterable.reduce(function (promise, item) {
        return promise.then(function (acc) {
          return $q.when(item)
            .then(callback)
            .then(function (result) {
              return acc.concat(result);
            });
        });
      }, $q.when([]));
    }

    /**
     * Given an Iterable (an array, for example), or a promise of an Iterable, iterates
     * over all the values in it, executing the given mapper on each element.
     * @param {Array} iterable An Array or other iterable object.
     * @param {Function} callback A function to be run for each element in the iterable array.
     * @param {Integer} [concurrency] can be used for concurrency coordination.
     * @returns Promise
     */
    function promiseMap(iterable, callback, concurrency) {
      if (angular.isUndefined(concurrency)) {
        concurrency = iterable.length;
      }
      var batches = lodash.chunk(iterable, Math.ceil(iterable.length / concurrency));
      var results = Array(batches.length);
      return $q.all(batches.map(function (batch, i) {
        return service.promiseMapSeries(batch, callback)
          .then(function (data) {
            results[i] = data;
          });
      }))
        .then(function () {
          return lodash.flatten(results);
        });
    }

    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.shared')
    .service('apolloAuthService', apolloAuthService);

  /** @ngInject */
  function apolloAuthService(__env, store, $location, $window, PASSPHRASE_IDENTIFIER) {

    var APOLLO_VALIDATION = {
      clientId: 'simpliroute',
      scope: 'openid',
      responseType: 'code',
      redirectUri: __env.APOLLO_REDIRECT_URI
    };

    var service = {
      areAuthParamsValid: areAuthParamsValid,
      buildRedirectURL: buildRedirectURL,
      buildAuthURL: buildAuthURL,
      redirect: redirect
    };

    return service;

    function areAuthParamsValid()  {
      var token = store.get('token');
      var queryParams = $location.search();

      return  token !== undefined &&
              queryParams.client_id === APOLLO_VALIDATION.clientId &&
              queryParams.scope === APOLLO_VALIDATION.scope &&
              queryParams.response_type === APOLLO_VALIDATION.responseType &&
              queryParams.redirect_uri === APOLLO_VALIDATION.redirectUri;
    }

    function buildAuthURL(state) {
      var relatedAccount = store.get('account');
      var token = store.get('token');
      var accessToken = relatedAccount ? token + relatedAccount : token;
      var passphrase = store.get(PASSPHRASE_IDENTIFIER);
      if (passphrase) {
        accessToken += ':' + btoa(passphrase);
      }

      store.set('apollo-session', true);
      var authURL = __env.APOLLO_REDIRECT_URI+ '?access_token=' + accessToken + '&state=' + state;
      return  authURL;
    }

    function buildRedirectURL(path) {
      var redirectURL = __env.APOLLO_URI + path;
      var specialParams = {};
      // ID of the currently selected related account within the user's organization (for users with multiple accounts)
      var relatedAccount = store.get('account');
      if (relatedAccount) {
        specialParams['related-account'] = relatedAccount;
      }

      var passphrase = store.get(PASSPHRASE_IDENTIFIER);
      if (passphrase) {
        specialParams[PASSPHRASE_IDENTIFIER] = btoa(passphrase);
      }

      if (Object.keys(specialParams).length) {
        var searchParams = new URLSearchParams(specialParams);
        redirectURL += '?' + searchParams.toString();
      }

      return redirectURL;
    }

    function redirect(url) {
      $window.location.href = url;
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('icarus.shared')
    .factory('mapService', mapService);

  /** @ngInject */
  function mapService($http, $q, __env, sessionService, $rootScope) {

    return {
      getMapOptions: getMapOptions
    };

    function _setMapOptions(map) {
      var deferred = $q.defer();
      if ($rootScope.mapInitCoord) {
        map.center.latitude = parseFloat($rootScope.mapInitCoord.latitude);
        map.center.longitude = parseFloat($rootScope.mapInitCoord.longitude);
        deferred.resolve(map);
        return deferred.promise;
      }

      sessionService.getUser()
        .then(function (user) {
          if (!user.account.country) {
            return;
          }

          var address = bcCountries.getCountryByIso2Code(user.account.country.toLowerCase());
          return $http.post(__env.APIV2_URL + 'directory/geocode/', { address: address.name });
        })
        .then(function (response) {
          if (!response) {
            return;
          }

          map.center.latitude = parseFloat(response.data.latitude);
          map.center.longitude = parseFloat(response.data.longitude);
        })
        .finally(function () {
          deferred.resolve(map);
        });

      return deferred.promise;
    }

    function getMapOptions() {
      var deferred = $q.defer();
      $http.get(__env.GOOGLE_MAP_OPTIONS)
        .then(function (response) {
          return _setMapOptions(response.data);
        })
        .then(deferred.resolve)
        .catch(deferred.reject);

      return deferred.promise;
    }
  }
})();

(function () {
    "use strict";

    angular
      .module("icarus")
      .constant("BOUND_MARGIN", 0.1)
      .constant("HERE_MAPS_STATIC_URL", "https://image.maps.hereapi.com/mia/v3")
      .constant("FULLSCREEN_ENABLED_NAME", "fullscreenEnabled")
      .constant("OPEN_LABEL", "open")
      .constant("CLOSE_LABEL", "close")
      .constant("AUTOCOMPLETE_URL", "https://autocomplete.search.hereapi.com/v1/autocomplete")
      .constant("LOOKUP_URL", "https://lookup.search.hereapi.com/v1/lookup")
      .constant("REQUEST_HEADERS", {
        'Authorization': undefined,
        'Related-Account': undefined
      })
      .constant("MIN_MAP_ZOOM_LEVEL", 0)
      .constant("MAX_MAP_ZOOM_LEVEL", 22);
  })();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('hereService', hereService);

  /** @ngInject */
  function hereService(__env, $q, $window, MAP_EVENTS, imageHandler, HereDrawingManagerModel, CIRCLE_MARKER_URL,
                       utilsService, CURSOR, CIRCLE_MARKER_WITH_OPACITY_URL, $filter, MAP_CONTROL, $http,
                       BOUND_MARGIN, HERE_MAPS_STATIC_URL, FULLSCREEN_ENABLED_NAME, OPEN_LABEL, CLOSE_LABEL,
                       AUTOCOMPLETE_URL, LOOKUP_URL, REQUEST_HEADERS, MIN_MAP_ZOOM_LEVEL, MAX_MAP_ZOOM_LEVEL) {

    var $translate = $filter('translate');
    var resizeHandler = null;
    var fullscreenchangeHandler = null;

    return {
      initializeMap: initializeMap,
      makeMarker: makeMarker,
      getMapCenter: getMapCenter,
      setMapCenter: setMapCenter,
      getMarkerPosition: getMarkerPosition,
      setMarkerPosition: setMarkerPosition,
      setMarkerEvent: setMarkerEvent,
      getMarkerVisible: getMarkerVisible,
      setMarkerVisible: setMarkerVisible,
      fitMapBounds: fitMapBounds,
      getMapZoom: getMapZoom,
      setMapZoom: setMapZoom,
      destroyMap: destroyMap,
      makePolyline: makePolyline,
      makeInfoWindow: makeInfoWindow,
      setPolylinePopup: setPolylinePopup,
      getEventPosition: getEventPosition,
      getMapDistanceBetweenPoints: getMapDistanceBetweenPoints,
      getMapHeading: getMapHeading,
      getMapStaticUrl: getMapStaticUrl,
      destroyMarker: destroyMarker,
      destroyPolyline: destroyPolyline,
      setMarkerIcon: setMarkerIcon,
      getPolylinePath: getPolylinePath,
      makeDrawingManager: makeDrawingManager,
      setDrawingManagerOptions: setDrawingManagerOptions,
      setListenerToCompletedPolygon: setListenerToCompletedPolygon,
      makePolygon: makePolygon,
      makeResizablePolygon: makeResizablePolygon,
      getPolygonPath: getPolygonPath,
      destroyPolygon: destroyPolygon,
      getAutocompleteSuggestions: getAutocompleteSuggestions,
      geocodeLocation: geocodeLocation
    };

    function _handlerLayerButtonSelected(map, control, layer) {
      return function (e) {
        var button = e.currentTarget;
        if (button.getState() === H.ui.base.Button.State.DOWN) {
          return;
        }

        control.getChildren().forEach(function (childButton) {
          childButton.removeClass('selected');
        });

        button.addClass('selected');
        map.setBaseLayer(layer);
      };
    }

    function _createCustomMapsettingsControl(map, baseLayers) {
      var control = new H.ui.Control();
      control.addClass('H_custom_mappsettings');
      baseLayers.forEach(function (baseLayer, index) {
        var layerButton = new H.ui.base.Button({
          label: baseLayer.label,
          onStateChange: _handlerLayerButtonSelected(map, control, baseLayer.layer)
        });

        layerButton.addClass('H_btn_custom_mappsetings');
        if (index === 0) {
          layerButton.addClass('selected');
        }

        control.addChild(layerButton);
      });

      return control;
    }

    function _getFullscreenchangeEvent() {
      // The webkit prefix is supported by the Safari browser
      return FULLSCREEN_ENABLED_NAME in document ? MAP_EVENTS.FULLSCREENCHANGE : MAP_EVENTS.WEBKITFULLSCREENCHANGE;
    }

    function _handlerFullscreenButton(mapElement) {
      return function (e) {
        var button = e.currentTarget;
        if (button.getState() === H.ui.base.Button.State.DOWN) {
          return;
        }

        if (document.fullscreenElement || document.webkitFullscreenElement) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          }
        } else {
          if (mapElement.requestFullscreen) {
            mapElement.requestFullscreen();
          } else if (mapElement.webkitRequestFullscreen) {
            mapElement.webkitRequestFullscreen();
          }
        }
      };
    }

    function _getFullscreenLabel(state) {
      var path = state === OPEN_LABEL
        ? 'M0 0v6h2V2h4V0H0zm16 0h-4v2h4v4h2V0h-2zm0 16h-4v2h6v-6h-2v4zM2 12H0v6h6v-2H2v-4z'
        : 'M4 4H0v2h6V0H4v4zm10 0V0h-2v6h6V4h-4zm-2 14h2v-4h4v-2h-6v6zM0 14h4v4h2v-6H0v2z';

      return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="' + path +'"/></svg>';
    }

    function _createFullscreenControl(map) {
      var openFullscreenLabel = _getFullscreenLabel(OPEN_LABEL);
      var closeFullsreenLabel = _getFullscreenLabel(CLOSE_LABEL);
      var fullscreenButton = new H.ui.base.Button({
        label: openFullscreenLabel,
        onStateChange: _handlerFullscreenButton(map.getElement())
      });

      fullscreenButton.addClass('H_btn_fullscreen');
      fullscreenchangeHandler = function () {
        if (document.fullscreenElement || document.webkitFullscreenElement) {
          fullscreenButton.setLabel(closeFullsreenLabel);
        } else {
          fullscreenButton.setLabel(openFullscreenLabel);
        }

        map.getViewPort().resize();
      };

      document.addEventListener(_getFullscreenchangeEvent(), fullscreenchangeHandler);

      var control = new H.ui.Control();
      control.addChild(fullscreenButton);
      return control;
    }

    function initializeMap(htmlElementRef, options) {
      var deferred = $q.defer();
      var platform = new H.service.Platform({ apikey: __env.HERE_MAPS_KEY });
      var engineType = H.Map.EngineType['HARP'];
      var defaultLayers = platform.createDefaultLayers({ engineType: engineType });
      var style = new H.map.render.harp.Style(__env.HERE_MAP_OPTIONS);
      var vectorTileService = platform.getOMVService();
      var vectorTileProvider = new H.service.omv.Provider(vectorTileService, style, { engineType: engineType });
      var layerOptions = {
        min: MIN_MAP_ZOOM_LEVEL,
        max: MAX_MAP_ZOOM_LEVEL
      };
      var vectorTileLayer = new H.map.layer.TileLayer(vectorTileProvider, layerOptions);
      var map = new H.Map(
        htmlElementRef,
        vectorTileLayer,
        {
          engineType: engineType,
          pixelRatio: $window.devicePixelRatio || 1,
          center: {
            lat: options.center.latitude,
            lng: options.center.longitude
          },
          zoom: options.zoom
        }
      );

      map.$behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
      var ui = H.ui.UI.createDefault(map, defaultLayers);

      ui.removeControl(MAP_CONTROL.MAPSETTINGS);
      var baseLayers = [
        {
          label: $translate('Map.map_label'),
          layer: vectorTileLayer
        },
        {
          label: $translate('Map.satellite_label'),
          layer: defaultLayers.hybrid.day.raster
        }
      ];

      var customMapsettingsControl = _createCustomMapsettingsControl(map, baseLayers);
      ui.addControl(MAP_CONTROL.CUSTOM_MAPSETTINGS, customMapsettingsControl);
      customMapsettingsControl.setAlignment(H.ui.LayoutAlignment.TOP_RIGHT);

      var fullscreenControl = _createFullscreenControl(map);
      ui.addControl(MAP_CONTROL.FULLSCREEN, fullscreenControl);
      fullscreenControl.setAlignment(H.ui.LayoutAlignment.RIGHT_BOTTOM);

      ui.getControl(MAP_CONTROL.ZOOM).setAlignment(H.ui.LayoutAlignment.RIGHT_BOTTOM);
      ui.getControl(MAP_CONTROL.SCALEBAR).addClass('H_custom_mt');
      map.$ui = ui;

      var mapElement = map.getElement();
      mapElement.style.cursor = CURSOR.GRAB;

      map.addEventListener(MAP_EVENTS.DRAGSTART, function () {
        mapElement.classList.add('H_map_grabbing_cursor');
      }, false);

      map.addEventListener(MAP_EVENTS.DRAGEND, function () {
        mapElement.classList.remove('H_map_grabbing_cursor');
      }, false);

      resizeHandler = function () {
        map.getViewPort().resize();
      };

      $window.addEventListener(MAP_EVENTS.RESIZE, resizeHandler);

      var mapViewChangeEndHandler = function () {
        setMapCenter(map, options.center.latitude, options.center.longitude);
        map.removeEventListener(MAP_EVENTS.MAPVIEWCHANGEEND, mapViewChangeEndHandler);
        deferred.resolve(map);
      };

      map.addEventListener(MAP_EVENTS.MAPVIEWCHANGEEND, mapViewChangeEndHandler);
      return deferred.promise;
    }

    function setMarkerIcon(marker, icon, asPng, isCached) {
      var cachedIcon = imageHandler.getCachedIcon(icon.url, icon.fillColor || '', icon.labelContent || '');
      if (cachedIcon) {
        marker.setIcon(cachedIcon);
        return;
      }

      if (!icon.labelContent && !icon.fillColor) {
        var iconInstance = icon.anchor ? new H.map.Icon(icon.url, { anchor: icon.anchor }) : new H.map.Icon(icon.url);
        if (isCached) {
          imageHandler.setIconInCache(icon.url, '', '', iconInstance);
        }

        marker.setIcon(iconInstance);
        return;
      }

      var options = {
        label: icon.labelContent,
        labelX: icon.labelX,
        labelY: icon.labelY,
        asPng: asPng
      };

      imageHandler.makeIconFromSvg(icon.url, icon.fillColor, options)
        .then(function (iconUrl) {
          var iconInstance = icon.anchor ? new H.map.Icon(iconUrl, { anchor: icon.anchor }) : new H.map.Icon(iconUrl);
          marker.setIcon(iconInstance);
          if (isCached) {
            imageHandler.setIconInCache(icon.url, icon.fillColor || '', icon.labelContent || '', iconInstance);
          }
        });
    }

    function makeMarker(map, options, asPng, isCached) {
      var position = options.position;
      var markerPosition = {
        lat: position && position.latitude ? parseFloat(position.latitude) : map.getCenter().lat,
        lng: position && position.longitude ? parseFloat(position.longitude) : map.getCenter().lng
      };

      var markerOptions = {
        volatility: true,
        zIndex: options.zIndex
      };

      var marker = new H.map.Marker(markerPosition, markerOptions);
      var icon = options.icon;
      if (icon) {
        setMarkerIcon(marker, icon, asPng, isCached);
      }

      marker.draggable = options.draggable || false;
      map.addObject(marker);
      return marker;
    }

    function getMapCenter(map) {
      return {
        latitude: map.getCenter().lat,
        longitude: map.getCenter().lng
      };
    }

    function setMapCenter(map, latitude, longitude) {
      map.setCenter(new H.geo.Point(latitude, longitude));
    }

    function getMarkerPosition(marker) {
      return {
        latitude: marker.getGeometry().lat,
        longitude: marker.getGeometry().lng
      };
    }

    function setMarkerPosition(marker, latitude, longitude) {
      marker.setGeometry(new H.geo.Point(latitude, longitude));
    }

    function _setDragendEventToMarker(map, marker, callback) {
      marker.addEventListener(MAP_EVENTS.DRAGSTART, function (ev) {
        var pointer = ev.currentPointer;
        var targetPosition = map.geoToScreen(marker.getGeometry());
        marker['offset'] = new H.math.Point(pointer.viewportX - targetPosition.x, pointer.viewportY - targetPosition.y);
        map.$behavior.disable();
      }, false);

      marker.addEventListener(MAP_EVENTS.DRAG, function (ev) {
        var pointer = ev.currentPointer;
        marker.setGeometry(map.screenToGeo(pointer.viewportX - marker['offset'].x, pointer.viewportY - marker['offset'].y));
      }, false);

      marker.addEventListener(MAP_EVENTS.DRAGEND, function (ev) {
        callback(ev);
        map.$behavior.enable();
      }, false);
    }

    function setMarkerEvent(options) {
      var eventType = options.eventType;
      if (eventType === MAP_EVENTS.DRAGEND) {
        _setDragendEventToMarker(options.map, options.marker, options.callback);
        return;
      }

      if (eventType === MAP_EVENTS.CLICK) {
        eventType = MAP_EVENTS.TAP;
      }

      if (eventType === MAP_EVENTS.MOUSEOVER) {
        eventType = MAP_EVENTS.POINTERENTER;
      }

      if (eventType === MAP_EVENTS.MOUSEOUT) {
        eventType = MAP_EVENTS.POINTERLEAVE;
      }

      options.marker.addEventListener(eventType, options.callback, false);
    }

    function getMarkerVisible(marker) {
      return marker.getVisibility();
    }

    function setMarkerVisible(marker, isVisible) {
      marker.setVisibility(isVisible);
    }

    function fitMapBounds(map, positions) {
      var startPosition = positions[0];
      var rect = new H.geo.Rect(startPosition.latitude, startPosition.longitude, startPosition.latitude, startPosition.longitude);
      for (var i = 1; i < positions.length; i++) {
        rect = rect.mergePoint(new H.geo.Point(positions[i].latitude, positions[i].longitude));
      }

      var latDiff = rect.getTop() - rect.getBottom();
      var lngDiff = rect.getRight() - rect.getLeft();
      var newNorth = rect.getTop() + latDiff * BOUND_MARGIN;
      var newSouth = rect.getBottom() - latDiff * BOUND_MARGIN;
      var newEast = rect.getRight() + lngDiff * BOUND_MARGIN;
      var newWest = rect.getLeft() - lngDiff * BOUND_MARGIN;
      map.getViewModel().setLookAtData({ bounds: new H.geo.Rect(newNorth, newWest, newSouth, newEast) });
    }

    function getMapZoom(map) {
      return map.getZoom();
    }

    function setMapZoom(map, zoom) {
      map.setZoom(zoom);
    }

    function destroyMap(map) {
      $window.removeEventListener(MAP_EVENTS.RESIZE, resizeHandler);
      if (fullscreenchangeHandler) {
        document.removeEventListener(_getFullscreenchangeEvent(), fullscreenchangeHandler);
        fullscreenchangeHandler =  null;
      }

      resizeHandler = null;
      map = null;
    }

    function makePolyline(map, options, isCurrentRoute) {
      var lineString = new H.geo.LineString();
      options.pathCoords.forEach(function (position) {
        lineString.pushPoint(new H.geo.Point(parseFloat(position.latitude), parseFloat(position.longitude)));
      });

      var polylineOptions = {
        style: {
          strokeColor: utilsService.convertHexToRGBA(options.strokeColor, options.strokeOpacity),
          lineWidth: options.strokeWeight,
          lineDash: isCurrentRoute ? [] : [1, 1]
        }
      };

      var polyline = new H.map.Polyline(lineString, polylineOptions);
      map.addObject(polyline);
      return polyline;
    }

    function setPolylinePopup(map, polyline, infoWindow, callback) {
      polyline.addEventListener(MAP_EVENTS.TAP, function (evt) {
        var content = callback(evt);
        var position = map.screenToGeo(evt.currentPointer.viewportX, evt.currentPointer.viewportY);
        if (infoWindow.bubble) {
          infoWindow.bubble.setContent(content);
          infoWindow.bubble.setPosition(position);
          infoWindow.bubble.open();
        } else {
          var bubble = new H.ui.InfoBubble(position, { content: content });
          infoWindow.bubble = bubble;
          map.$ui.addBubble(bubble);
        }
      }, false);
    }

    function makeInfoWindow() {
      return {
        bubble: null
      };
    }

    function getEventPosition(event, map) {
      var position = map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
      return {
        latitude: position.lat,
        longitude: position.lng
      };
    }

    function getMapDistanceBetweenPoints(startPosition, endPosition) {
      var startPoint = new H.geo.Point(startPosition.latitude, startPosition.longitude);
      var endPoint = new H.geo.Point(endPosition.latitude, endPosition.longitude);
      return startPoint.distance(endPoint);
    }

    function _radians(degrees) {
      return degrees * (Math.PI / 180);
    }

    function _calculateBearing(startLat, startLng, destLat, destLng){
      startLat = _radians(startLat);
      startLng = _radians(startLng);
      destLat = _radians(destLat);
      destLng = _radians(destLng);

      var x = Math.cos(destLat) * Math.sin(destLng - startLng);
      var y = Math.cos(startLat) * Math.sin(destLat) - Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng);
      return Math.atan2(x, y);
    }

    function _calculateDegreesClockwise(bearing) {
      return bearing * 180 / Math.PI;
    }

    function getMapHeading(startPosition, endPosition) {
      var bearing = _calculateBearing(startPosition.latitude, startPosition.longitude, endPosition.latitude, endPosition.longitude);
      return _calculateDegreesClockwise(bearing);
    }

    function _getPolygonCoords(coords) {
      return coords.map(function(coord) {
        return [parseFloat(coord.lat), parseFloat(coord.lng)];
      });
    }

    function _getMarkerColor(marker, index) {
      var markerColor = marker.color.replace('0x', '#');
      var darkColor = String(tinycolor(markerColor).darken(25));
      return index === 1 ? darkColor : markerColor;
    }

    function getMapStaticUrl(options) {
      var mapImageDimensions = options.width + 'x' + options.height + '/png';
      var mapImageApiKey = '?apiKey=' + __env.HERE_MAPS_KEY;
      var mapImageStyle = '&style=logistics.day';

      if (options.markers) {
        var markersPath = '';

        if (options.markers.length === 2) {
          var minLat = Math.min(parseFloat(options.markers[0].latitude), parseFloat(options.markers[1].latitude));
          var maxLat = Math.max(parseFloat(options.markers[0].latitude), parseFloat(options.markers[1].latitude));
          var minLng = Math.min(parseFloat(options.markers[0].longitude), parseFloat(options.markers[1].longitude));
          var maxLng = Math.max(parseFloat(options.markers[0].longitude), parseFloat(options.markers[1].longitude));
          
          var latPadding = (maxLat - minLat) * 0.1;
          var lngPadding = (maxLng - minLng) * 0.1;
          
          var bbox = [
            minLng - lngPadding,  // West
            minLat - latPadding,  // South
            maxLng + lngPadding,  // East
            maxLat + latPadding   // North
          ].join(',');

          markersPath += '/base/mc/bbox:' + bbox + '/' + mapImageDimensions + mapImageApiKey + mapImageStyle;

          var markersGeoJson = {
            type: "FeatureCollection",
            features: options.markers.map(function getFeatures(marker, index) {
              return {
                type: "Feature",
                properties: {
                  icon: "pin",
                  color: _getMarkerColor(marker, index),
                  "outline-color": "#FFF",
                  "text-color": "#FFF",
                  "outline-width": 1,
                  size: "large"
                },
                geometry: {
                  type: "Point",
                  coordinates: [
                    parseFloat(marker.longitude),
                    parseFloat(marker.latitude)
                  ]
                }
              };
            })
          };

          markersPath += "&geojson=" + encodeURIComponent(JSON.stringify(markersGeoJson));

          return HERE_MAPS_STATIC_URL + markersPath;
        }
      } else if (options.zone) {
        var zone = options.zone;
        var zoneColor = zone.color.replace('0x', '');
        var zonePath = '/base/mc/overlay:padding=15/' + mapImageDimensions +
        mapImageApiKey + mapImageStyle +
          '&overlay=polygon:' + _getPolygonCoords(zone.coordinates) +
          ';color=' + '%23' + (zone.opacity * 100) + zoneColor;

        return HERE_MAPS_STATIC_URL + zonePath;
      }
    }

    function getPolylinePath(polyline) {
      var pathCoords = [];
      polyline.getGeometry().eachLatLngAlt(function (lat, lng) {
        pathCoords.push({ latitude: lat, longitude: lng });
      });

      return pathCoords;
    }

    function destroyMarker(marker, map) {
      map.removeObject(marker);
      marker = null;
    }

    function destroyPolyline(polyline, map) {
      map.removeObject(polyline);
      polyline = null;
    }

    function makeDrawingManager(map, options) {
      var drawingControlOptions = options.drawingControlOptions;
      drawingControlOptions.position = H.ui.LayoutAlignment[drawingControlOptions.position];
      return new HereDrawingManagerModel(Object.assign({ map: map, makePolygon: makePolygon }, options));
    }

    function setDrawingManagerOptions(drawingManager, options) {
      drawingManager.setOptions(options);
    }

    function setListenerToCompletedPolygon(drawingManager, listenerCallback) {
      drawingManager.setListenerToCompletedPolygon(listenerCallback);
    }

    function makePolygon(map, options) {
      var lineString = new H.geo.LineString();
      options.pathCoords.forEach(function (position) {
        lineString.pushPoint(new H.geo.Point(parseFloat(position.latitude), parseFloat(position.longitude)));
      });

      var styleOptions = {
        fillColor: utilsService.convertHexToRGBA(options.fillColor, options.fillOpacity),
        lineWidth: options.strokeOpacity === 0 ? 0 : options.strokeWeight,
      };

      if (options.strokeColor) {
        styleOptions.strokeColor = utilsService.convertHexToRGBA(options.strokeColor, options.strokeOpacity);
      }

      var polygonOptions = {
        style: styleOptions,
        zIndex: options.zIndex
      };

      var polygon = new H.map.Polygon(lineString, polygonOptions);
      polygon.draggable = options.editable || options.draggable || false;
      map.addObject(polygon);
      return polygon;
    }

    function _isAExtremeVertex(vertexIndex) {
      return vertexIndex % 2 === 0;
    }

    function _calculateIntermediatePointBetweenPositions(startPosition, endPosition) {
      return {
        lat: (startPosition.lat + endPosition.lat) / 2,
        lng: (startPosition.lng + endPosition.lng) / 2
      };
    }

    function _getElementsToDrawResizablePolygon(polygonLineString) {
      var vertexList = [];
      var mainLineString = new H.geo.LineString();
      var extremeVertexGroup = new H.map.Group();
      var intermediateVertexGroup = new H.map.Group();

      polygonLineString.eachLatLngAlt(function(lat, lng) {
        var extremeVertex = new H.map.Marker(
          { lat: lat, lng: lng },
          { icon: new H.map.Icon(CIRCLE_MARKER_URL, { anchor: { x: 8, y: 8 } }) }
        );

        extremeVertex.draggable = true;
        extremeVertexGroup.addObject(extremeVertex);
      });

      var extremeVertices = extremeVertexGroup.getObjects();
      var extremeVerticesLength = extremeVertices.length;
      extremeVertices.forEach(function (extremeVertex, index) {
        var nextIndex = index + 1;
        var nextExtremeVertex = extremeVerticesLength === nextIndex ? extremeVertices[0] : extremeVertices[nextIndex];
        var intermediatePoint = _calculateIntermediatePointBetweenPositions(extremeVertex.getGeometry(), nextExtremeVertex.getGeometry());
        var intermediateVertex = new H.map.Marker(
          { lat: intermediatePoint.lat, lng: intermediatePoint.lng },
          { icon: new H.map.Icon(CIRCLE_MARKER_WITH_OPACITY_URL, { anchor: { x: 8, y: 8 } }) }
        );

        vertexList.push(extremeVertex);
        vertexList.push(intermediateVertex);

        mainLineString.pushPoint(extremeVertex.getGeometry());
        mainLineString.pushPoint(intermediateVertex.getGeometry());

        var extremeVertexIndex = index * 2;
        extremeVertex.setData({ vertexIndex: extremeVertexIndex });
        intermediateVertex.setData({ vertexIndex: extremeVertexIndex + 1 });

        intermediateVertex.draggable = true;
        intermediateVertexGroup.addObject(intermediateVertex);
      });

      return {
        vertexList: vertexList,
        extremeVertexGroup: extremeVertexGroup,
        intermediateVertexGroup: intermediateVertexGroup,
        mainLineString: mainLineString
      };
    }

    function makeResizablePolygon(polygon, resizableCallback, map, options) {
      var vertexElements = _getElementsToDrawResizablePolygon(polygon.getGeometry().getExterior());
      var vertexGroup = new H.map.Group({
        objects: [vertexElements.extremeVertexGroup, vertexElements.intermediateVertexGroup]
      });

      var polylineGroup = new H.map.Group();
      var mainGroup = new H.map.Group({
        volatility: true,
        objects: [polygon, vertexGroup, polylineGroup]
      });

      var polylineOptions = {
        style: {
          strokeColor: utilsService.convertHexToRGBA(options.fillColor, options.fillOpacity),
          lineWidth: options.strokeWeight
        }
      };

      var firstExtremeVertexPosition = vertexElements.extremeVertexGroup.getObjects()[0].getGeometry();
      var initLineString = new H.geo.LineString();
      initLineString.pushPoint(firstExtremeVertexPosition);
      initLineString.pushPoint(firstExtremeVertexPosition);
      var startPolyline = new H.map.Polyline(initLineString, polylineOptions);
      polylineGroup.addObject(startPolyline);
      var endPolyline = new H.map.Polyline(initLineString, polylineOptions);
      polylineGroup.addObject(endPolyline);

      map.addObject(mainGroup);
      polygon.setData({ parentId: mainGroup.getId() });

      var mapElement = map.getElement();
      vertexGroup.addEventListener(MAP_EVENTS.POINTERENTER, function () {
        mapElement.classList.add('H_map_not_grabbing_cursor');
        mapElement.style.cursor = CURSOR.POINTER;
      }, true);

      vertexGroup.addEventListener(MAP_EVENTS.POINTERLEAVE, function () {
        mapElement.classList.remove('H_map_not_grabbing_cursor');
        mapElement.style.cursor = CURSOR.GRAB;
      }, true);

      var currentVertexIndex = 0;
      var startVertexIndex = 0;
      var endVertexIndex = 0;
      vertexGroup.addEventListener(MAP_EVENTS.DRAGSTART, function (evt) {
        var vertexListLength = vertexElements.vertexList.length;
        currentVertexIndex = evt.target.getData().vertexIndex;
        if (_isAExtremeVertex(currentVertexIndex)) {
          startVertexIndex = currentVertexIndex === 0 ? vertexListLength - 2 : currentVertexIndex - 2;
          endVertexIndex = vertexListLength - 2 === currentVertexIndex ? 0 : currentVertexIndex + 2;
        } else {
          startVertexIndex = currentVertexIndex - 1;
          endVertexIndex = vertexListLength - 1 === currentVertexIndex ? 0 : currentVertexIndex + 1;
        }
      }, true);

      vertexGroup.addEventListener(MAP_EVENTS.DRAG, function (evt) {
        var pointer = evt.currentPointer;
        var geoPoint = map.screenToGeo(pointer.viewportX, pointer.viewportY);
        evt.target.setGeometry(geoPoint);

        var startLineString = new H.geo.LineString();
        startLineString.pushPoint(vertexElements.vertexList[startVertexIndex].getGeometry());
        startLineString.pushPoint(geoPoint);
        startPolyline.setGeometry(startLineString);

        var endLineString = new H.geo.LineString();
        endLineString.pushPoint(vertexElements.vertexList[endVertexIndex].getGeometry());
        endLineString.pushPoint(geoPoint);
        endPolyline.setGeometry(endLineString);

        evt.stopPropagation();
      }, true);

      vertexGroup.addEventListener(MAP_EVENTS.DRAGEND, function (evt) {
        vertexElements.mainLineString.removePoint(currentVertexIndex);
        vertexElements.mainLineString.insertPoint(currentVertexIndex, evt.target.getGeometry());

        var polygonLineString = new H.geo.LineString();
        vertexElements.mainLineString.eachLatLngAlt(function (lat, lng, _, index) {
          if (_isAExtremeVertex(index) || currentVertexIndex === index) {
            polygonLineString.pushPoint(new H.geo.Point(lat, lng));
          }
        });

        polygon.setGeometry(new H.geo.Polygon(polygonLineString));
        startPolyline.setGeometry(initLineString);
        endPolyline.setGeometry(initLineString);

        vertexGroup.removeObjects([vertexElements.extremeVertexGroup, vertexElements.intermediateVertexGroup]);
        vertexElements = _getElementsToDrawResizablePolygon(polygonLineString);
        vertexGroup.addObjects([vertexElements.extremeVertexGroup, vertexElements.intermediateVertexGroup]);

        resizableCallback();
      }, true);
    }

    function getPolygonPath(polygon) {
      var pathCoords = [];
      polygon.getGeometry().getExterior().eachLatLngAlt(function (lat, lng) {
        pathCoords.push({ latitude: lat, longitude: lng });
      });

      return pathCoords;
    }

    function destroyPolygon(polygon, map) {
      var polygonData = polygon.getData();
      var parentId = polygonData ? polygonData.parentId : null;
      if (parentId) {
        var parentObject = map.getObjects().find(function (mapObject) {
          return mapObject.getId() === parentId;
        });

        if (parentObject) {
          map.removeObject(parentObject);
        }
      } else {
        map.removeObject(polygon);
      }

      polygon = null;
    }

    function getAutocompleteSuggestions(value, countryCode) {
      var deferred = $q.defer();
      var countryCode = 'countryCode:' + countryCode.alpha3;
      var suggestions = [];
      var params = {
          q: value,
          apiKey: __env.HERE_MAPS_KEY,
          in: countryCode
      };
      var requestOptions = {
        params: params,
        headers: REQUEST_HEADERS
      };

      $http.get(AUTOCOMPLETE_URL, requestOptions)
        .then(function (response) {
            suggestions = response.data;
            deferred.resolve(suggestions.items);
        })
        .catch(function (error) {
            deferred.reject(error);
        });

      return deferred.promise;
    }

    function geocodeLocation(item) {
      var deferred = $q.defer();
      var params = {
        id: item.id,
        apiKey: __env.HERE_MAPS_KEY
      };
      var requestOptions = {
        params: params,
        headers: REQUEST_HEADERS
      };

      $http.get(LOOKUP_URL, requestOptions)
      .then(function (response) {
        var position = response.data.position;
        deferred.resolve({latitude: position.lat, longitude: position.lng});
      })
      .catch(function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    }
  }
})();

(function () {
    "use strict";
  
    angular
      .module("icarus")
      .constant("AUTOCOMPLETE_SESSION_TOKEN_EXPIRATON_MINUTES", 3)
      .constant("LEFT_MOUSE_BUTTON_EVENT_NUMBER", 0)
      .constant("GOOGLE_MAPS_STATIC_URL", "https://maps.googleapis.com");
  })();
  
/* global google:false */
(function() {
  'use strict';

  angular
    .module('icarus')
    .factory('googleService', googleService);

  function googleService(__env, $rootScope, $http, helperMap, imageHandler, MAP_EVENTS, MAP_OPTIONS, $q,
                          AUTOCOMPLETE_SESSION_TOKEN_EXPIRATON_MINUTES, LEFT_MOUSE_BUTTON_EVENT_NUMBER, GOOGLE_MAPS_STATIC_URL) {

    var DASH_SYMBOL = {
      path: 'M 0,-1 0,1',
      strokeOpacity: 1,
      strokeWeight: 4,
      scale: 1
    };

    var geocoderService = null;
    var autocompleteService = null;
    var autocompleteSessionToken = null;

    return {
      createGeocode: createGeocode,
      geocoderStatusOK: geocoderStatusOK,
      getGoogleMapsLatLng: getGoogleMapsLatLng,
      googleMapsAnimationDrop: googleMapsAnimationDrop,
      createPolygon: createPolygon,
      createPolyline: createPolyline,
      googleMapsMarkerMaxZIndex: googleMapsMarkerMaxZIndex,
      googleMapsAddListener: googleMapsAddListener,
      googleMapsRemoveListener: googleMapsRemoveListener,
      createMap: createMap,
      googleMapsEventTrigger: googleMapsEventTrigger,
      createInfoWindow: createInfoWindow,
      getLatLngBounds: getLatLngBounds,
      createAutoCompleteService: createAutoCompleteService,
      createPlacesService: createPlacesService,
      placesServiceStatusOk: placesServiceStatusOk,
      createPoint: createPoint,
      createMarker: createMarker,
      symbolMapCircle: symbolMapCircle,
      geometryComputeDistanceBetween: geometryComputeDistanceBetween,
      geometryComputeHeading: geometryComputeHeading,
      createMapSize: createMapSize,
      getLatLngBoundsOnPoint: getLatLngBoundsOnPoint,
      createDrawing: createDrawing,
      listenerLimitDrawingPolygon: listenerLimitDrawingPolygon,
      getZoomControlOptions: getZoomControlOptions,
      overlayTypePolygon: overlayTypePolygon,
      clearListenerLimitDrawingPolygon:clearListenerLimitDrawingPolygon,
      createHandDrawing: createHandDrawing,
      clearListenerHandDrawing: clearListenerHandDrawing,
      createAutocompleteSessionToken: createAutocompleteSessionToken,
      initializeMap: initializeMap,
      makeMarker: makeMarker,
      getMapCenter: getMapCenter,
      setMapCenter: setMapCenter,
      getMarkerPosition: getMarkerPosition,
      setMarkerPosition: setMarkerPosition,
      setMarkerEvent: setMarkerEvent,
      getMarkerVisible: getMarkerVisible,
      setMarkerVisible: setMarkerVisible,
      fitMapBounds: fitMapBounds,
      getMapZoom: getMapZoom,
      setMapZoom: setMapZoom,
      destroyMap: destroyMap,
      makePolyline: makePolyline,
      getMapStaticUrl: getMapStaticUrl,
      makeInfoWindow: makeInfoWindow,
      setPolylinePopup: setPolylinePopup,
      getEventPosition: getEventPosition,
      getMapDistanceBetweenPoints: getMapDistanceBetweenPoints,
      getMapHeading: getMapHeading,
      destroyMarker: destroyMarker,
      destroyPolyline: destroyPolyline,
      setMarkerIcon: setMarkerIcon,
      getPolylinePath: getPolylinePath,
      makeDrawingManager: makeDrawingManager,
      setDrawingManagerOptions: setDrawingManagerOptions,
      setListenerToCompletedPolygon: setListenerToCompletedPolygon,
      makePolygon: makePolygon,
      makeResizablePolygon: makeResizablePolygon,
      getPolygonPath: getPolygonPath,
      destroyPolygon: destroyPolygon,
      initializeGeocoderService: initializeGeocoderService,
      initializeAutocompleteService: initializeAutocompleteService,
      getAutocompleteSuggestions: getAutocompleteSuggestions,
      geocodeLocation: geocodeLocation,
      getAutocompleteSessionToken: getAutocompleteSessionToken
    };

    function bounds() {
      if (!google.maps.Polygon.prototype.getBounds) {
        google.maps.Polygon.prototype.getBounds = function () {
          var bounds = new google.maps.LatLngBounds();
          this.getPath().forEach(function (element) {
            bounds.extend(element);
          });

          return bounds;
        };
      }
    }

    function polygonContains() {
      if (!google.maps.Polygon.prototype.contains) {
        bounds();
        google.maps.Polygon.prototype.contains = function (latLng) {
          // Outside the bounds means outside the polygon
          if (this.getBounds && !this.getBounds().contains(latLng)) {
            return false;
          }

          var lat = latLng.lat();
          var lng = latLng.lng();
          var paths = this.getPaths();
          var path, pathLength, inPath, i, j, vertex1, vertex2;

          // Walk all the paths
          for (var p = 0; p < paths.getLength(); p++) {
            path = paths.getAt(p);
            pathLength = path.getLength();
            j = pathLength - 1;
            inPath = false;
            for (i = 0; i < pathLength; i++) {
              vertex1 = path.getAt(i);
              vertex2 = path.getAt(j);
              if (vertex1.lng() < lng && vertex2.lng() >= lng || vertex2.lng() < lng && vertex1.lng() >= lng) {
                if (vertex1.lat() + (lng - vertex1.lng()) / (vertex2.lng() - vertex1.lng()) * (vertex2.lat() - vertex1.lat()) < lat) {
                  inPath = !inPath;
                }
              }

              j = i;
            }

            if (inPath) {
              return true;
            }
          }

          return false;
        };
      }
    }

    function createGeocode() {
      return new google.maps.Geocoder();
    }

    function createPolygon(config) {
      polygonContains();
      return new google.maps.Polygon(config);
    }

    function createPolyline(config) {
      return new google.maps.Polyline(config);
    }

    function geocoderStatusOK() {
      return google.maps.GeocoderStatus.OK;
    }

    function googleMapsAnimationDrop() {
      return google.maps.Animation.DROP;
    }

    function getGoogleMapsLatLng(lat, lng) {
      return new google.maps.LatLng(lat, lng);
    }

    function googleMapsMarkerMaxZIndex() {
      return Number(google.maps.Marker.MAX_ZINDEX);
    }

    function googleMapsAddListener(elem, event, callback) {
      return google.maps.event.addListener(elem, event, callback);
    }

    function googleMapsRemoveListener(listener) {
      return google.maps.event.removeListener(listener);
    }

    function createMap(elem, config) {
      return new google.maps.Map(elem, config);
    }

    function googleMapsEventTrigger(mapInstance, event) {
      return google.maps.event.trigger(mapInstance, event);
    }

    function createInfoWindow(config) {
      return new google.maps.InfoWindow(config);
    }

    function getLatLngBounds() {
      return new google.maps.LatLngBounds();
    }

    function getLatLngBoundsOnPoint(point) {
      return  new google.maps.LatLngBounds(point);
    }

    function createAutoCompleteService() {
      return new google.maps.places.AutocompleteService();
    }

    function createPlacesService(elem) {
      return new google.maps.places.PlacesService(elem);
    }

    function placesServiceStatusOk() {
      return google.maps.places.PlacesServiceStatus.OK;
    }

    function createPoint(x, y) {
      return new google.maps.Point(x, y);
    }

    function createMarker(config) {
      return new google.maps.Marker(config);
    }

    function symbolMapCircle() {
      return google.maps.SymbolPath.CIRCLE;
    }

    function geometryComputeDistanceBetween(latlng, point) {
      return google.maps.geometry.spherical.computeDistanceBetween(latlng, point);
    }

    function geometryComputeHeading(p1, p2) {
      return google.maps.geometry.spherical.computeHeading(p1, p2);
    }

    function createMapSize(p1, p2) {
      return new google.maps.Size(p1, p2);
    }

    function getZoomControlOptions(position) {
      return  google.maps.ControlPosition[position];
    }

    function createDrawing(map, modesOptions, drawingModes, drawingModeInit, drawingControl) {
      var options = {
        drawingMode: drawingModeInit,
        drawingControl: drawingControl,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: drawingModes
        }
      };

      angular.extend(options, modesOptions);
      var drawingManager = new google.maps.drawing.DrawingManager(options);
      drawingManager.setMap(map);
      return drawingManager;
    }

    function createHandDrawing(map, selectionComplete) {
      map.setOptions({ clickableIcons: false });
      $rootScope.$broadcast("Planner:Routes:toggleClickPolygons", { isClickable: false });
      google.maps.event.addListener(map, "mousedown", function (e) {
        if (e.domEvent && e.domEvent.button !== LEFT_MOUSE_BUTTON_EVENT_NUMBER) {
          return;
        }

        map.setOptions({ gestureHandling: "none" });
        var drawingPoly = createPolyline({ map: map, clickable: false, zIndex: 5 });
        var move = google.maps.event.addListener(map, "mousemove", function (e) {
          drawingPoly.getPath().push(e.latLng);
        });

        google.maps.event.addListenerOnce(map, "mouseup", function(e) {
          google.maps.event.removeListener(move);
          var path = drawingPoly.getPath();
          drawingPoly.setMap(null);
          var drawingPolygon = createPolygon({path: path});
          drawingPolygon.setMap(null);
          selectionComplete({ polygon: drawingPolygon });
          map.setOptions({ gestureHandling: "auto" });
        });
      });
    }

    function listenerLimitDrawingPolygon(drawingManager, callback) {
      google.maps.event.addListener(drawingManager, 'polygoncomplete', callback);
    }

    function overlayTypePolygon() {
      return google.maps.drawing.OverlayType.POLYGON;
    }

    function clearListenerLimitDrawingPolygon(map) {
      google.maps.event.clearListeners(map, 'polygoncomplete');
    }

    function clearListenerHandDrawing(map) {
      google.maps.event.clearListeners(map, "mousedown");
      map.setOptions({ clickableIcons: true });
      $rootScope.$broadcast("Planner:Routes:toggleClickPolygons", { isClickable: true });
    }

    function createAutocompleteSessionToken() {
      return new google.maps.places.AutocompleteSessionToken();
    }

    function initializeMap(htmlElementRef, options) {
      return $http.get(__env.GOOGLE_MAP_OPTIONS)
        .then(function (response) {
          var data = response.data;
          data.options.zoom = options.zoom;
          var map = createMap(htmlElementRef, data.options);
          setMapCenter(map, options.center.latitude, options.center.longitude);
          return map;
        });
    }

    function setMarkerIcon(marker, icon, asPng, isCached) {
      var cachedIcon = imageHandler.getCachedIcon(icon.url, icon.fillColor || '', icon.labelContent || '');
      if (cachedIcon) {
        marker.setIcon(cachedIcon);
        return;
      }

      var iconInstance = {
        url: icon.url
      };

      if (icon.anchor) {
        iconInstance.anchor = createPoint(icon.anchor.x, icon.anchor.y);
      }

      if (!icon.labelContent && !icon.fillColor) {
        if (isCached) {
          imageHandler.setIconInCache(icon.url, '', '', iconInstance);
        }

        marker.setIcon(iconInstance);
        return;
      }

      var options = {
        label: icon.labelContent,
        labelX: icon.labelX,
        labelY: icon.labelY,
        asPng: asPng
      };

      imageHandler.makeIconFromSvg(icon.url, icon.fillColor, options)
        .then(function (iconUrl) {
          iconInstance.url = iconUrl;
          marker.setIcon(iconInstance);
          if (isCached) {
            imageHandler.setIconInCache(icon.url, icon.fillColor || '', icon.labelContent || '', iconInstance);
          }
        });
    }

    function makeMarker(map, options, asPng, isCached) {
      var position = options.position;
      var markerOptions = {
        map: map,
        position: {
          lat: position && position.latitude ? parseFloat(position.latitude) : map.getCenter().lat(),
          lng: position && position.longitude ? parseFloat(position.longitude) : map.getCenter().lng()
        },
        draggable: options.draggable || false,
        zIndex: options.zIndex || null
      };

      var marker = createMarker(markerOptions);
      var icon = options.icon;
      if (icon) {
        setMarkerIcon(marker, icon, asPng, isCached);
      }

      return marker;
    }

    function getMapCenter(map) {
      return {
        latitude: map.getCenter().lat(),
        longitude: map.getCenter().lng()
      };
    }

    function setMapCenter(map, latitude, longitude) {
      map.setCenter(getGoogleMapsLatLng(latitude, longitude));
    }

    function getMarkerPosition(marker) {
      return {
        latitude: marker.getPosition().lat(),
        longitude: marker.getPosition().lng()
      };
    }

    function setMarkerPosition(marker, latitude, longitude) {
      marker.setPosition(getGoogleMapsLatLng(latitude, longitude));
    }

    function setMarkerEvent(options) {
      googleMapsAddListener(options.marker, options.eventType, options.callback);
    }

    function getMarkerVisible(marker) {
      return marker.getVisible();
    }

    function setMarkerVisible(marker, isVisible) {
      marker.setVisible(isVisible);
    }

    function fitMapBounds(map, positions) {
      var bounds = getLatLngBounds();
      positions.forEach(function (position) {
        bounds.extend(getGoogleMapsLatLng(position.latitude, position.longitude));
      });

      map.fitBounds(bounds);
    }

    function getMapZoom(map) {
      return map.getZoom();
    }

    function setMapZoom(map, zoom) {
      map.setZoom(zoom);
    }

    function destroyMap(map) {
      map = null;
    }

    function makePolyline(map, options, isCurrentRoute) {
      var polylineOptions = {
        map: map,
        path: options.pathCoords.map(function (position) {
          return getGoogleMapsLatLng(parseFloat(position.latitude), parseFloat(position.longitude));
        }),
        strokeColor: options.strokeColor,
        strokeWeight: options.strokeWeight,
        geodesic: options.geodesic
      };

      if (!isCurrentRoute) {
        polylineOptions.strokeOpacity = 0;
        polylineOptions.icons = [{icon: DASH_SYMBOL, offset: '0', repeat: '10px'}];
      }

      return createPolyline(polylineOptions);
    }

    function setPolylinePopup(map, polyline, infoWindow, callback) {
      googleMapsAddListener(polyline, MAP_EVENTS.CLICK, function (ev) {
        var content = callback(ev);
        infoWindow.setContent(content);
        infoWindow.setPosition(ev.latLng);
        infoWindow.open(map);
      });
    }

    function makeInfoWindow() {
      return createInfoWindow();
    }

    function getEventPosition(event) {
      return {
        latitude: event.latLng.lat(),
        longitude: event.latLng.lng()
      };
    }

    function getMapDistanceBetweenPoints(startPosition, endPosition) {
      var startPoint = getGoogleMapsLatLng(startPosition.latitude, startPosition.longitude);
      var endPoint = getGoogleMapsLatLng(endPosition.latitude, endPosition.longitude);
      return geometryComputeDistanceBetween(startPoint, endPoint);
    }

    function getMapHeading(startPosition, endPosition) {
      var startPoint = getGoogleMapsLatLng(startPosition.latitude, startPosition.longitude);
      var endPoint = getGoogleMapsLatLng(endPosition.latitude, endPosition.longitude);
      return geometryComputeHeading(startPoint, endPoint);
    }

    function _getOptionsParse(options) {
      var output = '';
      options.styles.forEach(function (style) {
        var key = Object.keys(style.stylers[0])[0];
        var value = style.stylers[0][key].replace('#', '0x');
        output += '&style=feature:' + style.featureType + '%7Celement:' + style.elementType + '%7C' + key + ':' + value;
      });

      return output;
    }

    function _getPolygonCoords(coords) {
      var result = '';
      coords.forEach(function (coord) {
        result += coord.lat + ',' + coord.lng + '|';
      });

      return result + coords[0].lat + ',' + coords[0].lng;
    }

    function getMapStaticUrl(options) {
      var style = _getOptionsParse(MAP_OPTIONS.options);
      var path = '/maps/api/staticmap?key=' + __env.GOOGLE_MAPS_KEY_PAY + '&size=' + options.width + 'x' + options.height + '&format=png';
      if (options.markers) {
        options.markers.forEach(function (marker) {
          path += '&markers=color:' + marker.color + '%7C' + marker.latitude + "," + marker.longitude;
        });
      } else if (options.zone) {
        var zone = options.zone;
        path += '&path=fillcolor:' + zone.color + '|color:' + zone.color + '|weight:' + zone.weight + '|' + _getPolygonCoords(zone.coordinates);
      }

      return GOOGLE_MAPS_STATIC_URL + helperMap.sign(path + style, __env.GOOGLE_MAPS_SECRET_KEY_PAY);
    }

    function getPolylinePath(polyline) {
      var pathCoords = [];
      polyline.getPath().forEach(function (position) {
        pathCoords.push({ latitude: position.lat(), longitude: position.lng() });
      });

      return pathCoords;
    }

    function destroyMarker(marker) {
      marker.setMap(null);
      marker = null;
    }

    function destroyPolyline(polyline) {
      polyline.setMap(null);
      polyline = null;
    }

    function makeDrawingManager(map, options) {
      var drawingControlOptions = options.drawingControlOptions;
      drawingControlOptions.position = google.maps.ControlPosition[drawingControlOptions.position];
      return new google.maps.drawing.DrawingManager(Object.assign({ map: map }, options));
    }

    function setDrawingManagerOptions(drawingManager, options) {
      drawingManager.setOptions(options);
    }

    function setListenerToCompletedPolygon(drawingManager, listenerCallback) {
      listenerLimitDrawingPolygon(drawingManager, listenerCallback);
    }

    function makePolygon(map, options) {
      var polygonOptions = {
        map: map,
        path: options.pathCoords.map(function (position) {
          return getGoogleMapsLatLng(parseFloat(position.latitude), parseFloat(position.longitude));
        }),
        fillColor: options.fillColor,
        fillOpacity: options.fillOpacity,
        strokeColor: options.strokeColor,
        strokeOpacity: options.strokeOpacity,
        strokeWeight: options.strokeWeight,
        clickable: options.clickable || true,
        editable: options.editable || false,
        draggable: options.draggable || false,
        zIndex: options.zIndex
      };

      return createPolygon(polygonOptions);
    }

    function makeResizablePolygon(polygon, resizableCallback) {
      googleMapsAddListener(polygon.getPath(), MAP_EVENTS.SET_AT, resizableCallback);
      googleMapsAddListener(polygon.getPath(), MAP_EVENTS.INSERT_AT, resizableCallback);
      googleMapsAddListener(polygon.getPath(), MAP_EVENTS.REMOVE_AT, resizableCallback);
    }

    function getPolygonPath(polygon) {
      var pathCoords = [];
      polygon.getPath().forEach(function (position) {
        pathCoords.push({ latitude: position.lat(), longitude: position.lng() });
      });

      return pathCoords;
    }

    function destroyPolygon(polygon) {
      polygon.setMap(null);
      polygon = null;
    }

    function initializeGeocoderService() {
      if (!geocoderService) {
        geocoderService = createGeocode();
      }
    }

    function initializeAutocompleteService() {
      if (!autocompleteService) {
        autocompleteService = createAutoCompleteService();
      }
    }

    function getAutocompleteSessionToken() {
      if (!autocompleteSessionToken || isAutocompleteSessionTokenExpired(autocompleteSessionToken.expiration)) {
        autocompleteSessionToken = refreshAutocompleteSessionToken();
      }

      return autocompleteSessionToken;
    }

    function isAutocompleteSessionTokenExpired(timestamp) {
      return moment().unix() >= timestamp;
    }

    function refreshAutocompleteSessionToken() {
      return {
        token: createAutocompleteSessionToken(),
        expiration: moment().add(AUTOCOMPLETE_SESSION_TOKEN_EXPIRATON_MINUTES, "minutes").unix()
      };
    }

    function getAutocompleteSuggestions(value, countryCode) {
      initializeAutocompleteService();
      var deferred = $q.defer();
      var token = getAutocompleteSessionToken().token;
      autocompleteService.getPlacePredictions({
          input: value,
          types: ['address'],
          sessionToken: token,
          componentRestrictions: {country: countryCode.alpha2},
        }, function (predictions, status) {
          if (status === placesServiceStatusOk()) {
            deferred.resolve(predictions);
          } else {
            deferred.reject(status);
          }
      });

      return deferred.promise;
    }

    function geocodeLocation(item, address) {
      initializeGeocoderService();
      var deferred = $q.defer();
      var request = item ? { placeId: item.place_id } : { address: address };
      geocoderService.geocode(request)
        .then(function (response) {
          var results = response.results;
          var location = results[0].geometry.location;
          deferred.resolve({latitude: location.lat(), longitude: location.lng()});
         })
         .catch(function (e) {
          deferred.reject(e);
        });

      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('PolylineModel', PolylineModel);

  /** @ngInject */
  function PolylineModel() {
    function Polyline(mapModel, polyline, options) {
      this.mapModel = mapModel || null;
      this.map = mapModel ? mapModel.map : null;
      this.provider = mapModel ? mapModel.provider : null;
      this.polyline = polyline || null;
      this.options = options || null;
    }

    Polyline.prototype.setPopup = function (callback) {
      this.provider.setPolylinePopup(this.map, this.polyline, this.mapModel.infoWindow, callback);
    };

    Polyline.prototype.getPath = function () {
      return this.provider.getPolylinePath(this.polyline);
    };

    Polyline.prototype.destroy = function () {
      this.provider.destroyPolyline(this.polyline, this.map);
      this.mapModel = null;
      this.map = null;
      this.provider = null;
      this.polyline = null;
      this.options = null;
    };

    return Polyline;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('PolygonModel', PolygonModel);

  /** @ngInject */
  function PolygonModel() {
    function Polygon(mapModel, polygon, options) {
      this.mapModel = mapModel;
      this.map = mapModel.map;
      this.provider = mapModel.provider;
      this.polygon = polygon;
      this.options = options || null;
    }

    Polygon.prototype.getPath = function () {
      return this.provider.getPolygonPath(this.polygon);
    };

    Polygon.prototype.setOptions = function (updatedOptions) {
      this.options = Object.assign(this.options || {},  updatedOptions);
    };

    Polygon.prototype.makeResizable = function (resizableCallback) {
      this.provider.makeResizablePolygon(this.polygon, resizableCallback, this.map, this.options);
    };

    Polygon.prototype.destroy = function () {
      this.provider.destroyPolygon(this.polygon, this.map);
      this.mapModel = null;
      this.map = null;
      this.provider = null;
      this.polygon = null;
      this.options = null;
    };

    return Polygon;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('MarkerModel', MarkerModel);

  /** @ngInject */
  function MarkerModel() {
    function Marker(mapModel, marker, options) {
      this.mapModel = mapModel || null;
      this.map = mapModel ? mapModel.map : null;
      this.provider = mapModel ? mapModel.provider :  null;
      this.marker = marker || null;
      this.options = options || null;
    }

    Marker.prototype.setEvent = function (eventType, callback) {
      var eventOptions = {
        marker: this.marker,
        map: this.map,
        eventType: eventType,
        callback: callback
      };

      this.provider.setMarkerEvent(eventOptions);
    };

    Marker.prototype.getPosition = function () {
      return this.provider.getMarkerPosition(this.marker);
    };

    Marker.prototype.setPosition = function (latitude, longitude) {
      this.provider.setMarkerPosition(this.marker, latitude, longitude);
    };

    Marker.prototype.getVisible = function () {
      return this.provider.getMarkerVisible(this.marker);
    };

    Marker.prototype.setVisible = function (isVisible) {
      this.provider.setMarkerVisible(this.marker, isVisible);
    };

    Marker.prototype.setIcon = function (iconOptions, asPng, isCached) {
      Object.assign(this.options, { icon: Object.assign(this.options.icon || {}, iconOptions)});
      this.provider.setMarkerIcon(this.marker, this.options.icon, asPng, isCached);
    };

    Marker.prototype.destroy = function () {
      this.provider.destroyMarker(this.marker, this.map);
      this.mapModel = null;
      this.map = null;
      this.provider = null;
      this.marker = null;
      this.options = null;
    };

    return Marker;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('MapModel', MapModel);

  /** @ngInject */
  function MapModel(__env, $http, $q, $rootScope, $log, sessionService, googleService, hereService, MarkerModel,
                    PolylineModel, imageHandler, PolygonModel) {

    var MAP_PROVIDERS = {
      google: googleService,
      here: hereService
    };

    var DEFAULT_OPTIONS = {
      center: {
        latitude: -33.4217454,
        longitude: -70.6072
      },
      zoom: 11
    };

    function Map(map, providerName) {
      this.map = map || null;
      this.providerName = providerName || null;
      this.provider = MAP_PROVIDERS[providerName] || null;
      this.infoWindow = this.provider ? this.provider.makeInfoWindow() : null;
      this.drawingManager = null;
    }

    Map.getCurrentProviderName = function (providerName, defaultProviderName) {
      return providerName && MAP_PROVIDERS.hasOwnProperty(providerName) ? providerName : defaultProviderName;
    };

    function _getMapCenter() {
      if ($rootScope.mapInitCoord) {
        var center = {
          latitude: parseFloat($rootScope.mapInitCoord.latitude),
          longitude: parseFloat($rootScope.mapInitCoord.longitude)
        };

        return $q.when(center);
      }

      return sessionService.getUser()
        .then(function (user) {
          if (!user.account.country) {
            return;
          }

          var address = bcCountries.getCountryByIso2Code(user.account.country.toLowerCase());
          return $http.post(__env.APIV2_URL + 'directory/geocode/', { address: address.name });
        })
        .then(function (response) {
          if (!response) {
            return DEFAULT_OPTIONS.center;
          }

          return {
            latitude: parseFloat(response.data.latitude),
            longitude: parseFloat(response.data.longitude)
          };
        }).catch(function (error) {
          $log.error(error);
          return DEFAULT_OPTIONS.center;
        });
    }

    Map.createInstance = function (providerName, defaultProviderName, htmlElementRef, options) {
      var currentProviderName = Map.getCurrentProviderName(providerName, defaultProviderName);
      return _getMapCenter()
        .then(function (center) {
          var extendedOptions = Object.assign(
            {},
            DEFAULT_OPTIONS,
            { center: center },
            options || {}
          );

          return MAP_PROVIDERS[currentProviderName].initializeMap(htmlElementRef, extendedOptions);
        })
        .then(function (map) {
          return new Map(map, currentProviderName);
        });
    };

    Map.getStaticUrl = function (providerName, options) {
      return MAP_PROVIDERS[providerName].getMapStaticUrl(options);
    };

    Map.getDistanceBetweenPoints = function (providerName, startPosition, endPosition) {
      return MAP_PROVIDERS[providerName].getMapDistanceBetweenPoints(startPosition, endPosition);
    };

    Map.prototype.makeMarker = function (options, asPng, isCached) {
      var marker = this.provider.makeMarker(this.map, options, asPng, isCached);
      return new MarkerModel(this, marker, options);
    };

    Map.prototype.getCenter = function () {
      return this.provider.getMapCenter(this.map);
    };

    Map.prototype.setCenter = function (latitude, longitude) {
      this.provider.setMapCenter(this.map, latitude, longitude);
    };

    Map.prototype.fitBounds = function (positions) {
      this.provider.fitMapBounds(this.map, positions);
    };

    Map.prototype.getZoom = function () {
      return this.provider.getMapZoom(this.map);
    };

    Map.prototype.setZoom = function (zoom) {
      this.provider.setMapZoom(this.map, zoom);
    };

    Map.prototype.makePolyline = function (options, isCurrentRoute) {
      if (!options.pathCoords || options.pathCoords.length <= 1) {
        return;
      }

      var polyline = this.provider.makePolyline(this.map, options, isCurrentRoute);
      return new PolylineModel(this, polyline, options);
    };

    Map.prototype.getEventPosition = function (event) {
      return this.provider.getEventPosition(event, this.map);
    };

    Map.prototype.getDistanceBetweenPoints = function (startPosition, endPosition) {
      return Map.getDistanceBetweenPoints(this.providerName, startPosition, endPosition);
    };

    Map.prototype.getHeading = function (startPosition, endPosition) {
      return this.provider.getMapHeading(startPosition, endPosition);
    };

    Map.prototype.makeDrawingManager = function (options) {
      this.drawingManager = this.provider.makeDrawingManager(this.map, options);
    };

    Map.prototype.setDrawingManagerOptions = function (options) {
      this.provider.setDrawingManagerOptions(this.drawingManager, options);
    };

    Map.prototype.setListenerToCompletedPolygon = function (callback) {
      var mapModel = this;
      var drawingManager = this.drawingManager;
      var listenerCallback = function (polygon) {
        var polygonInstance = new PolygonModel(mapModel, polygon);
        var options = Object.assign({}, drawingManager.polygonOptions, { pathCoords: polygonInstance.getPath() });
        polygonInstance.setOptions(options);
        callback(polygonInstance);
      };

      this.provider.setListenerToCompletedPolygon(drawingManager, listenerCallback);
    };

    Map.prototype.makePolygon = function (options) {
      if (!options.pathCoords || options.pathCoords.length === 0) {
        return;
      }

      var polygon = this.provider.makePolygon(this.map, options);
      return new PolygonModel(this, polygon, options);
    };

    Map.prototype.destroy = function () {
      this.provider.destroyMap(this.map);
      this.map = null;
      this.providerName = null;
      this.provider = null;
      this.infoWindow = null;
      this.drawingManager = null;
      imageHandler.clearIconCache();
    };

    return Map;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('imageHandler', imageHandler);

  /** @ngInject */
  function imageHandler($http, $cacheFactory) {
    var SVG_FILE_TYPE = 'image/svg+xml';
    var ICON_CACHE = {};

    var cache = $cacheFactory('svgUrl');

    return {
      makeIconFromSvg: makeIconFromSvg,
      setIconInCache: setIconInCache,
      getCachedIcon: getCachedIcon,
      clearIconCache: clearIconCache,
    };

    function _transformSvgToBlobPng(svg, width, height) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
          var canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          var context = canvas.getContext('2d');
          context.drawImage(img, 0, 0, width, height);
          canvas.toBlob(function (blob) {
            URL.revokeObjectURL(img.src);
            resolve(blob);
          }, 'image/png');
        };

        img.onerror = function() {
          URL.revokeObjectURL(img.src);
          reject(new Error('Failed to load image'));
        };

        img.src = URL.createObjectURL(new Blob([svg.outerHTML], { type: SVG_FILE_TYPE }));
      });
    }

    function _getLabelNode(options) {
      var textElement = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      textElement.textContent = options.label;
      for (var key in options) {
        if (options.hasOwnProperty(key) && key.startsWith('label') && key !== 'label') {
          var newKey = key.replace(/([A-Z])/g, "-$1").toLowerCase().substring(6);
          textElement.setAttribute(newKey, options[key]);
        }
      }

      return textElement;
    }

    function _getBlob(svgAsText, options, asPng) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(svgAsText, SVG_FILE_TYPE);
      var path = doc.querySelector('path');
      if (path) {
        path.setAttribute('fill', options.color);
        path.setAttribute('stroke', tinycolor(options.color).darken(15).toString());
      } else {
        var circle = doc.querySelector('circle');
        if (circle) {
          circle.setAttribute('stroke', options.color);
        }
      }

      var svg = doc.querySelector('svg');
      if (options.label) {
        svg.appendChild(_getLabelNode(options));
      }

      if (asPng) {
        return _transformSvgToBlobPng(svg, Number(svg.getAttribute('width')), Number(svg.getAttribute('height')));
      }

      return new Blob([svg.outerHTML], { type: SVG_FILE_TYPE });
    }

    function makeIconFromSvg(fileUrl, color, options) {
      options = options || {};

      return $http.get(fileUrl, { cache: cache })
        .then(function (response) {
          return response.data;
        })
        .then(function (svgAsText) {
          var svgOptions = {
            color: color
          };

          if (options.label) {
            svgOptions.label = options.label;
            svgOptions.labelX = options.labelX;
            svgOptions.labelY = options.labelY;
            svgOptions.labelFontSize = _getIconLabelFontSize(fileUrl);
            svgOptions.labelFontFamily = 'Arial';
            svgOptions.labelFontWeight = '600';
            svgOptions.labelTextAnchor = 'middle';
            svgOptions.labelFill = '#ffffff';
          }

          return _getBlob(svgAsText, svgOptions, options.asPng);
        })
        .then(function (blob) {
          return URL.createObjectURL(blob);
        })
        .catch(console.error);
    }

    function _getIconLabelFontSize(fileUrl) {

      var hoverIndicatorPattern = '_hover_indicator.svg';
      var isIconHoverIndicator = new RegExp(hoverIndicatorPattern).test(fileUrl);
      if (isIconHoverIndicator) {
        return '8pt';
      }

      return '10pt';
    }

    function _hashIconCacheKey(url, color, label) {
      return url + color + label;
    }

    function setIconInCache(url, color, label, icon) {
      ICON_CACHE[_hashIconCacheKey(url, color, label)] = icon;
    }

    function getCachedIcon(url, color, label) {
      return ICON_CACHE[_hashIconCacheKey(url, color, label)] || null;
    }

    function clearIconCache() {
      ICON_CACHE = {};
      var svgUrlCache = $cacheFactory.get('svgUrl');
      if (svgUrlCache) {
        svgUrlCache.removeAll();
      }
    }
  }
})();

(function () {
  'use strict';

  function selectableItemsListController ($scope, $state, ngDialog, naturalService) {
    var ctrl = this;

    ctrl.currentPage = 1;
    ctrl.maxSize = 3;
    ctrl.itemsPerPage = 20;
    ctrl.data.itemsSelected = ctrl.itemsSelected;

    ctrl.listFilter = [];
    ctrl.pageChanged = pageChanged;
    ctrl.goToAction = goToAction;
    ctrl.updateItemSelected = updateItemSelected;
    ctrl.naturalSort = naturalSort;

    this.$onChanges = function(obj) {
      if (angular.isDefined(obj.itemsSelected)) {
        ctrl.data.itemsSelected = obj.itemsSelected.currentValue;
      }
      if (angular.isDefined(obj.itemsPerPage) && obj.itemsPerPage.currentValue !== undefined) {
        ctrl.itemsPerPage = obj.itemsPerPage.currentValue;
      }
    };

    function pageChanged() {
      $scope.$index = (ctrl.currentPage - 1) * ctrl.itemsPerPage;
    }

    function goToAction() {
      ngDialog.closeAll();
      $state.go(ctrl.data.callActionUrl);
    }

    function updateItemSelected(value) {
      value ? ++ctrl.data.itemsSelected : --ctrl.data.itemsSelected;
    }

    function naturalSort (field) {
      return function (item) {
        return naturalService.naturalValue(item[field]);
      };
    }
  }

  var selectableItemsList = {
    templateUrl: 'app/shared/components/selectableItemsList.html',
    controller: ['$scope', '$state', 'ngDialog', 'naturalService', selectableItemsListController],
    bindings: {
      data: '<',
      itemsSelected: '<',
      itemsPerPage: '='
    }
  };

  angular
    .module('icarus.shared')
    .component('selectableItemsList', selectableItemsList);

})();

(function() {
  'use strict';

  function editableInputController($scope) {
    var ctrl = this;

    ctrl.enableEdition = Boolean(ctrl.editionAtStart);
    ctrl.setEdition = setEdition;

    function setEdition(flag) {
      ctrl.enableEdition = flag;
    }
  }

  var editableInputComponent = {
    templateUrl: 'app/shared/components/editableInput.html',
    controller: ['$scope', editableInputController],
    bindings: {
      model: '=',
      editionAtStart: '<',
      editionDisabled: '<'
    }
  };

  angular
    .module('icarus.shared')
    .component('editableInput', editableInputComponent);
})();

(function() {
  'use strict';

  angular
    .module('icarus.settings', [
      'ngSanitize',
      'ui.select',
      'icarus.shared',
      'icarus.bulk'
    ]);

})();

(function(){
  'use strict';

  angular
    .module('icarus.settings')
    .controller('SkillsListController', SkillsListController);

  /** @ngInject */
  function  SkillsListController ($log, $rootScope, skillsService, $timeout, $filter, Toasts) {
    var vm = this;
    var $translate = $filter('translate');

    $rootScope.isLoading = true;

    vm.editing = false;
    vm.select_all_skills = false;
    vm.formSkillsform = {};
    vm.skills_vehicle = {};
    vm.skills_checkbox = {};

    vm.cancel = cancel;
    vm.saveSkills = saveSkills;
    vm.deletSkills = deletSkills;
    vm.selectSkill = selectSkill;
    vm.activeCheckbox = activeCheckbox;
    vm.selectAllSkills = selectAllSkills;
    vm.selectAllSkillsHref = selectAllSkillsHref;
    activate();

    ////////////

    function activate () {
      skillsService.list().then(
        function successSkillsList (skills) {
        $rootScope.isLoading = false;
        vm.skills = skills;

      }, function errorSkillsList (error) {
        $rootScope.isLoading = false;
        $log.info('error con la lista de skills', error);
        Toasts.push('error', $translate('Toast_vehicles.error_path_skills'));
      });
    }

    function saveSkills () {
      // Buscar skills en la lista actual
      if (!vm.skill) {
        return;
      }

      var exist = false;
      for (var i = 0; i < vm.skills.length; i++) {
        if (vm.skills[i].skill === vm.skill.name) {
          exist = true;
          break;
        }
      }

      if (exist) {
        vm.formSkills.name.$error.invalid = true;
        $timeout(function() {}, 3000).then(function() {
          vm.formSkills.name.$error.invalid = false;
        });

      } else {
        skillsService.create(vm.skill.name).then(
          function successCreateSkill () {
            vm.skill.name = "";
            vm.formSkills.$setPristine();
            vm.formSkills.$setUntouched();
          },
          function errorCreateSkill (error) {
            $log.info('error creando skill', error);
          });
      }
    }

    function selectSkill () {
      var select_all = true;

      for ( var i = 0; i < vm.skills.length; i++) {
        vm.skills_vehicle[vm.skills[i].id] = vm.skills[i].isChecked;
        if (!vm.skills[i].isChecked) {
          select_all = false;
        }
      }
      if (select_all) {
        vm.select_all_skills = true;
      }
    }

    function selectAllSkills () {
      for ( var i = 0; i < vm.skills.length; i++) {
        vm.skills_vehicle[vm.skills[i].id] = vm.select_all_skills;
        vm.skills[i].isChecked = vm.select_all_skills;
      }
    }

    function selectAllSkillsHref () {
      vm.select_all_skills = true;
      for ( var i = 0; i < vm.skills.length; i++) {
        vm.skills_vehicle[vm.skills[i].id] = vm.select_all_skills;
        vm.skills[i].isChecked = vm.select_all_skills;
      }
    }

    function deletSkills () {
      var unselected = false;

      vm.skills.forEach( function (skill) {
        if (skill.isChecked) {
          unselected = true;
          skillsService.remove(skill).then(
            function successDeleteSkill () {
              vm.editing = false;
            },
            function errorDeleteSkill (error) {
              $log.info('error eliminado skill', error);
            });
        }
      });

      if (!unselected) {
        Toasts.push('error', $translate('Toast_skill.unselected_skill'));
        return;
      }
    }

    function activeCheckbox () {
      for (var skill in vm.skills_vehicle) {
        for (var i = 0; i < vm.skills.length; i++) {
          if (vm.skills[i].id === parseInt(skill)) {
            vm.skills[i].isChecked = vm.skills_vehicle[skill];
            break;
          }
        }
      }
    }

    function cancel(){
      vm.editing = false;
      for ( var i = 0; i < vm.skills.length; i++) {
        vm.skills_vehicle[vm.skills[i].id] = false;
        vm.skills[i].isChecked = false;
      }

      vm.select_all_skills = false;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .controller('ZonesController', ZonesController);

  /** @ngInject */
  function ZonesController(zoneService, xlsWriterService, $log, $rootScope, ngDialog, $scope, Toasts, $filter,
                           fileDownloaderService, xlsUploaderService, xlsParserService, naturalService, $q,
                           addonsService, accountConfigsService, ACCOUNT_CONFIGS, WEEKDAYS) {
    var $translate = $filter('translate');
    var vm = this;

    // Actions Zones
    var keyUseZonesToOptimization = 'use_zones_to_optimization';

    var keyUseAutoZonesToOptimization = 'use_auto_zones_in_optimization';

    // Excel Import Error Constants
    var OK = 'OK';
    var NO_DATA = 'NO_DATA';
    var WITH_ERRORS = 'WITH_ERRORS';
    var VEHICLE_NOT_FOUND = 'VEHICLE_NOT_FOUND';
    var ZONE_NOT_FOUND = 'ZONE_NOT_FOUND';

    vm.zones = [];
    vm.vehicles = [];

    var ACTION_USE_ZONES = 'settings-zones-toggle-use-zones';
    var ACTION_USE_AUTO_ZONES = 'settings-zones-toggle-use-auto-zones';

    vm.selectedWeekdays = WEEKDAYS.slice();

    vm.actionUseZones = {
      id: null,
      title: $translate('Zones.Actions.use_zones.title'),
      btn1: {
        title: $translate('Zones.Actions.use_zones.use_zones')
      },
      btn2: {
        title: $translate('Zones.Actions.use_zones.hide_zones')
      },
      key: keyUseZonesToOptimization,
      value: false,
      description: 'Usar zonas en optimizacion',
      zonesAddonId: null,
      inputName: ACTION_USE_ZONES,
      inputId: ACTION_USE_ZONES + '-id'
    };

    vm.actionUseAutoZones = {
      id: null,
      title: $translate('Zones.Actions.auto_zones.title'),
      btn1: {
        title: $translate('Zones.Actions.auto_zones.enable_auto_zones')
      },
      btn2: {
        title: $translate('Zones.Actions.auto_zones.disable_auto_zones')
      },
      key: keyUseAutoZonesToOptimization,
      value: false,
      description: 'Usar auto zonas en optimizacion',
      zonesAddonId: null,
      inputName: ACTION_USE_AUTO_ZONES,
      inputId: ACTION_USE_AUTO_ZONES + '-id'
    };

    vm.addZone = addZone;
    vm.editZone = editZone;
    vm.confirmDelete = confirmDelete;
    vm.deleteZone = deleteZone;
    vm.saveZoneAddonsProps = saveZoneAddonsProps;
    vm.downloadZones = downloadZones;
    vm.importZones = importZones;
    vm.naturalSort = naturalSort;
    vm.updateZone = updateZone;
    vm.filterTitle = $translate('Zones.view_zones');

    vm.onSelectedWeekdaysChanged = onSelectedWeekdaysChanged;
    vm.handleZoneSwitchChange = handleZoneSwitchChange;
    vm.translate = $translate;

    vm.isMultidayRouteEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.MULTI_DAY_ROUTES);
    vm.isZoneConfigMenuOpen = false;

    var addEvent = $scope.$on("ZONE:UPDATELIST", updateZonesList);

    $scope.$on("$destroy", function () {
      addEvent();
    });

    activate();

    function activate() {
      getZonesAndVehicles();
      checkIfUseZonesToOptimization();
      checkIfAutozonesIsEnabled();
    }

    function getZonesAndVehicles() {
      listZones();
      getVehicles();
    }

    function listZones(zonesFilter) {
      $rootScope.isLoading = true;
      return zoneService.listZones(zonesFilter)
        .then(function (zones) {
          $rootScope.isLoading = false;
          vm.zones = zones;
        }).catch(function (err) {
        $log.error(err);
        $rootScope.isLoading = false;
      });
    }

    function getVehicles() {
      $rootScope.isLoading = true;
      return zoneService.listVehicles().then(function (resp) {
        $rootScope.isLoading = false;
        vm.vehicles = resp;
      });
    }

    function checkIfUseZonesToOptimization() {
      zoneService.isEnableZonesProperty()
        .then(function (data) {
          setDataActionUseZones(data);
        }).catch(function (e) {
        $log.error(e);
      });
    }

    function checkIfAutozonesIsEnabled() {
      zoneService.isAutoZonesEnabled()
        .then(function(data) {
          vm.actionUseAutoZones.zonesAddonId = data.addonId;
          vm.actionUseAutoZones.id = data.id;
          vm.actionUseAutoZones.value = data.isAutoZoneEnabled;
        })
        .catch(function(e) {
          $log.error(e);
        });
    }

    function addZone() {
      ngDialog.open({
        template: 'app/settings/zones/zone-edit.html',
        controller: 'ZoneEditController',
        controllerAs: 'vm',
        className: 'ngdialog-theme-default custom-width-800 zone-modal',
        resolve: {
          zoneObj: function () {
            return null;
          }
        }
      });
    }

    function editZone(zone) {
      ngDialog.open({
        template: 'app/settings/zones/zone-edit.html',
        controller: 'ZoneEditController',
        controllerAs: 'vm',
        className: 'ngdialog-theme-default custom-width-800 zone-modal',
        resolve: {
          zoneObj: function () {
            return zone;
          }
        }
      });
    }

    function updateZonesList(event, data) {
      zoneService.removeCache();
      data.data.coordinates = zoneService.parseFromStringToArray(data.data.coordinates);
      var zone = zoneService.createZone(data.data);

      var zoneIndex = vm.zones.findIndex(function(zoneSrc) {
        return zoneSrc.id === zone.id;
      });

      var hasCommonDays = zone.schedules.some(function(day) {
        return vm.selectedWeekdays.includes(day);
      });

      if (hasCommonDays) {
        if (zoneIndex !== -1) {
          // Extend the existing zone with the new zone data
          angular.extend(vm.zones[zoneIndex], zone);
        } else {
          // Add the new zone if no existing one with the same id was found
          vm.zones.push(zone);
        }
      } else if (zoneIndex !== -1) {
        // Remove the existing zone if it doesn't have common days
        vm.zones.splice(zoneIndex, 1);
      }
    }

    function findZoneIndexById(zoneId) {
      return vm.zones.findIndex(function (zone) {
        return zone.id === zoneId;
      });
    }

    function confirmDelete(zoneId) {
      ngDialog.openConfirm({
        template: 'app/settings/zones/zone-delete-modal.html'
      }).then(function () {
        deleteZone(zoneId);
      });
    }

    function deleteZonesSuccess(zoneId) {
      $rootScope.isLoading = false;
      vm.zones.splice(findZoneIndexById(zoneId), 1);
      zoneService.removeCache();
      Toasts.push('success', $translate('Zones.Delete.delete_success'));
    }

    function deleteZonesFailure() {
      $rootScope.isLoading = false;
      $log.error('Error on delete request');
      Toasts.push('error', $translate('Zones.Delete.delete_fail'));
    }

    function deleteZone(zoneId) {
      $rootScope.isLoading = true;
      zoneService.deleteZone(zoneId)
        .then(deleteZonesSuccess.bind(null, zoneId))
        .catch(deleteZonesFailure);
    }

    function saveZoneAddonsProps() {
      $rootScope.isLoading = true;
      return $q.all([
        saveZoneProperties(),
        saveAutoZoneProperties()
      ]).then(function(result) {

        if (result[0] && result[0].id) {
          vm.actionUseZones.id = result[0].id;
        }
        if (result[1] && result[1].id) {
          vm.actionUseAutoZones.id = result[1].id;
        }

        $rootScope.isLoading = false;
        Toasts.push('success', $translate('Zones.Actions.success_zone_property'));

        addonsService.removeCache();
      })
      .catch(function(error) {
        $log.error(error);
        $rootScope.isLoading = false;
        Toasts.push('error', $translate('Zones.Actions.error_zone_property'));
      });
    }

    function saveZoneProperties() {
      var requestData = buildUsingZonesRequestData();
      return vm.actionUseZones.id ? zoneService.updateZoneProperties(requestData) :
        zoneService.createZoneProperties(requestData);
    }

    function saveAutoZoneProperties() {
      var requestData = buildAutoZonesAddOnRequest();
      return vm.actionUseAutoZones.id ? zoneService.updateZoneProperties(requestData) :
        zoneService.createZoneProperties(requestData);
    }

    function buildAutoZonesAddOnRequest() {
      return {
        id: vm.actionUseAutoZones.id,
        title: vm.actionUseAutoZones.title,
        key: vm.actionUseAutoZones.key,
        value: String(vm.actionUseAutoZones.value),
        description: vm.actionUseAutoZones.description,
        add_on_id: parseInt(vm.actionUseAutoZones.zonesAddonId)
      };
    }

    function setDataActionUseZones(data) {
      vm.actionUseZones.zonesAddonId = data.addonId;
      vm.actionUseZones.id = data.id;
      vm.actionUseZones.value = data.useZones;
    }

    function buildUsingZonesRequestData() {
      return {
        id: vm.actionUseZones.id,
        title: vm.actionUseZones.title,
        key: vm.actionUseZones.key,
        value: String(vm.actionUseZones.value),
        description: vm.actionUseZones.description,
        add_on_id: parseInt(vm.actionUseZones.zonesAddonId)
      };
    }

    function findVehicleZones(vehicle) {
      var zones = vm.zones.filter(function (zone) {
        return zone.vehicles.indexOf(vehicle.id) !== -1;
      }).map(function (result) {
        return result.name;
      }).join();
      return zones;
    }

    function transformCoordinates(coordinates) {
      var result = "[";
      coordinates.forEach(function (coordinate) {
        result += "(" + coordinate['lat'] + "," + coordinate['lng'] + ")";
      });
      return result + "]";
    }

    function buildExcelVehicle(vehicleList) {
      var vehicleGrid = [];
      vehicleList.forEach(function (vehicle) {
        var row = {
          vehicle: vehicle.name,
          zones: findVehicleZones(vehicle),
        };
        vehicleGrid.push(row);
      });
      return vehicleGrid;
    }

    function buildExcelZone(zoneList) {
      var zoneGrid = [];
      zoneList.forEach(function (zone) {
        var row = {
          zones: zone.name,
          coordinates: transformCoordinates(zone.coordinates)
        };
        zoneGrid.push(row);
      });
      return zoneGrid;
    }

    function getVehicleId(name) {
      var vehicle = vm.vehicles.find(function(veh) {
        return veh.name === name;
      });
      return vehicle ? vehicle.id : -1;
    }

    function getZoneId(name) {
      var zone = vm.zones.find(function(zone) {
        return zone.name === name;
      });
      return zone ? zone.id : -1;
    }

    function splitZones(zonesNames) {
      return zonesNames.split(',').map(function(name) {
        return name.trim();
      });
    }

    function validateZones(zonesNames) {
      var result = {
        zonesIds: [],
        errors: []
      };

      var zonesList = splitZones(zonesNames);

      zonesList.forEach(function(zoneName) {
        if (zoneName) {
          var zoneId = getZoneId(zoneName);
          if (zoneId !== -1) {
            result.zonesIds.push(zoneId);
          } else {
            var zoneError = {
              value: zoneName,
              desc: ZONE_NOT_FOUND
            };
            result.errors.push(zoneError);
          }
        }

      });

      return result;
    }

    function validateVehicle(vehicleName) {
      var result = {
        vehicleId: -1,
        errors: []
      };
      var vehicleId = getVehicleId(vehicleName);
      if (vehicleId !== -1) {
        result.vehicleId = vehicleId;
      } else {
        result.errors.push({
          value: vehicleName,
          desc: VEHICLE_NOT_FOUND
        });
      }
      return result;
    }

    function processRow(row) {
      var processStatus = {
        rowData: {},
        rowErrors: []
      };
      var vehicleValidation = validateVehicle(row.vehicle);
      var zonesValidation = validateZones(row.zones);
      processStatus.rowData.vehicle = vehicleValidation.vehicleId;
      processStatus.rowData.zones = zonesValidation.zonesIds;
      processStatus.rowErrors = vehicleValidation.errors.concat(zonesValidation.errors);
      return processStatus;
    }

    function buildBulkRequest(list) {
      var validatedData = {
        validRequest: OK,
        requestData: [],
        rowErrors: []
      };

      list.forEach(function(row) {
        var validatedRow = processRow(row);
        var rowError = {
          validRow: true,
          rowNumber: row['!row'],
          errors: validatedRow.rowErrors
        };

        if (validatedRow.rowErrors.length) {
          validatedData.validRequest = WITH_ERRORS;
        }

        if (validatedRow.rowData.vehicle !== -1) {
          validatedData.requestData.push(validatedRow.rowData);
        } else {
          rowError.validRow = false;
        }
        validatedData.rowErrors.push(rowError);
      });
      if (!validatedData.requestData.length) {
        validatedData.validRequest = NO_DATA;
      }
      return validatedData;
    }

    function showResultsModal(errorInfo, validRequest) {
      $scope.errorInfo = errorInfo;
      $scope.validRequest = validRequest;
      var dialog = ngDialog.open({
        template: 'app/settings/zones/zones-bulk-modal.html',
        className: 'ngdialog-theme-default custom-width-800 zone-modal',
        scope: $scope
      });
      dialog.closePromise.then(function() {
          getZonesAndVehicles();
      });

    }

    function sendBulkRequest(validatedData) {
      $rootScope.isLoading = true;
      zoneService.updateAssignations(validatedData.requestData).then(function() {
        zoneService.removeCache();
        $rootScope.isLoading = false;
        showResultsModal(validatedData.rowErrors, validatedData.validRequest);

      }).catch(function (error) {
        $log.error(error);
        $rootScope.isLoading = false;
        Toasts.push('error', $translate('Zones.Bulk.error_upload_failure'));

      });
    }

    function downloadZones() {
      // Zone regard Vehicle
      var headersVehicles = [
        $translate('Zones.Bulk.excel_header_vehicles'),
        $translate('Zones.Bulk.excel_header_zones'),
      ];
      var grid_page_vehicle = xlsWriterService.listToGrid(buildExcelVehicle(vm.vehicles), headersVehicles);

      // Coordinates in zone
      var headersZones = [
        $translate('Zones.Bulk.excel_header_zones'),
        $translate('Zones.Bulk.excel_header_coordinates'),
      ];
      var grid_page_zone = xlsWriterService.listToGrid(buildExcelZone(vm.zones), headersZones);

      // generate woorbook using the two grids
      var workbook = xlsWriterService.createWorkbooks(
        ['Vehicles', 'Zones'],
        [grid_page_vehicle, grid_page_zone]
      );
      var file = xlsWriterService.writeWorkbook(workbook);
      fileDownloaderService.downloadXLSX(file, 'zones.xlsx');
    }

    function importZones(files) {
      xlsUploaderService.handleFile(files[0]).then(function (workbook) {
        var headers = ['vehicle', 'zones'];
        var grid = xlsParserService.createGrid(workbook, headers);
        var list = xlsParserService.gridToList(grid);
        var validatedData = buildBulkRequest(list);
        if (!validatedData.requestData.length) {
          Toasts.push('error', $translate('Zones.Bulk.error_no_data'));
        } else {
         sendBulkRequest(validatedData);
        }
      });
    }

    function naturalSort(field) {
      return function (item) {
        return naturalService.naturalValue(item[field]);
      };
    }

    function updateZone (zone) {
      function successSaveZone () {
        Toasts.push('success', $translate('Zones.Edit.save_success'));
      }

      function errorSaveZone () {
        Toasts.push('error', $translate('Zones.Edit.save_fail'));
      }

      zoneService.updateZone(zone)
        .then(successSaveZone).catch(errorSaveZone);
    }

    function onSelectedWeekdaysChanged(selectedWeekdays) {
      vm.selectedWeekdays = selectedWeekdays;
      if (!selectedWeekdays.length) {
        vm.zones = [];
        return;
      }

      var zonesFilter = {
        schedules: selectedWeekdays.join(',')
      };

      listZones(zonesFilter);
    }

    function handleZoneSwitchChange(switchName, isEnabled) {
      if (switchName === ACTION_USE_ZONES) {
        vm.actionUseZones.value = isEnabled;
        if (!isEnabled) {
          vm.actionUseAutoZones.value = false;
        }
      }
      if (switchName === ACTION_USE_AUTO_ZONES) {
        vm.actionUseAutoZones.value = isEnabled;
      }
      vm.saveZoneAddonsProps();
    }
  }

})();

(function () {
  'use strict';
  angular
    .module('icarus.settings')
    .controller('ZoneEditController', ZoneEditController);

  /** @ngInject */
  function ZoneEditController(ngDialog, $log, zoneService, Toasts, $filter, $rootScope, 
    zoneObj, $q, WEEKDAYS, accountConfigsService, ACCOUNT_CONFIGS) {

    var vm = this;
    var $translate = $filter('translate');
    var EVERY_WEEKDAY = WEEKDAYS.length;

    vm.zone = {
      coordinates: null,
      name: null,
      vehicles: [], 
      schedules: WEEKDAYS
    };
    vm.nameError = false;
    var zones = [];
    var originalZone = null;
    var vehiclesSelected = [];
    vm.dataSelectableItemsList = {
      items: vm.zone.vehicles,
      title: $translate('Zones.Items_list.title'),
      icon: "sp-icon-vehiculos",
      msgItemsEmpty: $translate('Zones.Items_list.msg_items_empty'),
      callAction: $translate('Zones.Items_list.call_action'),
      callActionUrl: 'settings.vehicles.create',
      itemsSelected: 0
    };
    vm.dataSelectableItemsSelected = 0;

    vm.saveZone = saveZone;
    vm.closeModal = closeModal;
    vm.weekdays =  WEEKDAYS.reduce(function (acc, day) {
      return acc.concat([{name: day, checked: false}]);
    }, []);

    vm.isEveryDaySelected = false;
    vm.updateZoneSchedules = updateZoneSchedules;
    vm.selectEveryDay = selectEveryDay;
    vm.isMultidayRouteEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.MULTI_DAY_ROUTES);

    activate();

    ///////////////////////////////////////////////

    function activate() {
      if (zoneObj) {
        vm.zone = angular.copy(zoneObj);
        originalZone = angular.copy(zoneObj);
        vehiclesSelected = vm.zone.vehicles;
      }

      vm.weekdays.forEach(function (day) {
        if(vm.zone.schedules.includes(day.name)) {
          day.checked = true;
        }
      });

      vm.isEveryDaySelected = vm.zone.schedules.length === EVERY_WEEKDAY;
      $q.all([zoneService.listZones(), zoneService.listVehicles()])
        .then(function (results) {
          zones = results[0];
          successVehicles(results[1]);
        }).catch(function (err) {
        $log.error(err);
      });
    }

    function successVehicles(vehicles) {
      vm.zone.vehicles = vehicles;
      vm.dataSelectableItemsList.items = vm.zone.vehicles.map(function (vehicle) {
        if (isVehicleSelected(vehicle.id)) {
          vehicle.activate = true;
          vm.dataSelectableItemsSelected++;
        }

        return vehicle;
      });
    }

    function isVehicleSelected (vehicleId) {
      return (vehiclesSelected.indexOf(vehicleId) !== -1);
    }

    function saveZone() {
      var zoneFound = findZoneByName(vm.zone.name);
      if (!zoneFound || (zoneFound && originalZone && zoneFound.name === originalZone.name)) {
        $rootScope.isLoading = true;
        vm.nameError = false;
        if (vm.zone.id) {
          updateZone(vm.zone);
        } else {
          createZone(vm.zone);
        }
      } else {
        vm.nameError = true;
      }
    }

    function createZone(zone) {
      zoneService.saveZone(zone)
        .then(successSaveZone)
        .catch(errorSaveZone);
    }

    function updateZone(zone) {
      zoneService.updateZone(zone)
        .then(successSaveZone)
        .catch(errorSaveZone);
    }

    function successSaveZone(data) {
      $rootScope.isLoading = false;
      Toasts.push('success', $translate('Zones.Edit.save_success'));
      ngDialog.closeAll();
      $rootScope.$broadcast("ZONE:UPDATELIST", data);
    }

    function errorSaveZone(err) {
      $rootScope.isLoading = false;
      $log.error(err);
      Toasts.push('error', $translate('Zones.Edit.save_fail'));
    }

    function closeModal() {
      ngDialog.closeAll();
    }

    function findZoneByName(zoneName) {
      return zones.find(function (zone) {
        return zone.name === zoneName;
      });
    }

    function updateZoneSchedules(day) {
      if (vm.zone.schedules.includes(day)) {
        vm.zone.schedules.splice(vm.zone.schedules.indexOf(day), 1);
      } else {
        vm.zone.schedules.push(day);
      }

      vm.isEveryDaySelected = vm.zone.schedules.length === EVERY_WEEKDAY;
    }

    function selectEveryDay() {
      vm.zone.schedules = [];
      vm.weekdays.forEach(function (day) {
        if (vm.isEveryDaySelected) {
          vm.zone.schedules.push(day.name);
        }

        day.checked = vm.isEveryDaySelected;
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .controller('VehiclesListController', VehiclesListController);

  /** @ngInject */
  function VehiclesListController($scope, $log, $state, $filter, lodash, sessionService, vehicleService,
                                  driverService, skillsService, Toasts, xlsWriterService, fileDownloaderService,
                                  xlsUploaderService, xlsParserService, bulkService, ngDialog, chatService,
                                  validationService, moment) {

    var vm = this;
    var $translate = $filter('translate');

    //data error constants

    var DATA_FORMAT_ERROR = 'DATA_FORMAT_ERROR';
    var VEHICLE_ID_ERROR = 'VEHICLE_ID_ERROR';
    var LOCATION_ERROR = 'LOCATION_ERROR';
    var VEHICLE_NAME_DUPLICATE = 'VEHICLE_NAME_DUPLICATE';
    var PLAN_VEHICLE_EXCEEDED = 'PLAN_VEHICLE_EXCEEDED';
    var INVALID_MAX_TIME = 'INVALID_MAX_TIME';
    vm.creating = false;
    vm.errorPath = false;
    vm.bulkCreate = true;

    vm.chatInit = chatInit;
    vm.index = 0;
    vm.vehicles = [];
    vm.newVehicle = {capacity: 1};
    vm.safeSrcVehicles = [];
    vm.searchText = "";
    vm.searching = false;
    vm.totalQuantityVehiclePlan = 0;
    vm.excelVehiclesQuantity = 1;
    vm.modalUpgradePlanContent = "";
    vm.enableRestTime = false;

    vm.drivers = [];
    vm.skills = [];
    vm.state = $state;
    vm.createVehicle = createVehicle;
    vm.getDriverName = getDriverName;
    vm.getDriverId = getDriverId;
    vm.downloadList = downloadList;
    vm.vehiclesList = vehiclesList;
    vm.importVehicles = importVehicles;
    vm.onChangeSearch = onChangeSearch;
    vm.cleanSearch = cleanSearch;
    vm.showUpdatePlanModal = showUpdatePlanModal;

    vm.validateShiftTime = validateShiftTime;
    vm.validateRestTime = validateRestTime;
    vm.validateMaxTime = validateMaxTime;

    vm.pagination = {
      currentPage: 1,
      itemsPerPage: 15,
      maxSize: 3,
      pageChanged : function() {
        $scope.$index = (vm.pagination.currentPage - 1) * vm.pagination.itemsPerPage;
      }
    };


    activate();

    ////////////

    function showUpdatePlanModal() {
      vm.modalUpgradePlanContent = $translate('Vehicles.modal_content_upgrade_plan').replace("@:vehicles_created", vm.safeSrcVehicles.length);

      ngDialog.open({
        template: 'app/settings/vehicles/vehicle-update-plan-modal.html',
        scope: $scope
      });
    }

    function chatInit() {
      chatService.initChat();
    }

    function activate() {
      vm.promiseLoading = vehicleService.list().then(successListVehicles, errorListVehicles);
      sessionService.getUser().then(function (user) {
        vm.totalQuantityVehiclePlan = user.account.plan_quantity;
        if (user.subscription) {
          vm.maxVehicles = user.subscription.quantity;
        }
      });

      sessionService.getAccountConfigs()
        .then(function(configs) {
          var filteredConfigs = configs.filter(function(config) {
            return config.key === 'enable_rest_time';
          });

          if( filteredConfigs.length > 0) {
            var enableRestTime = false;

            filteredConfigs.forEach(function(config) {
              enableRestTime = config.key === 'enable_rest_time' ? config.value : enableRestTime;
            });
            vm.enableRestTime = enableRestTime;
          }else {
            vm.enableRestTime = false;
          }
        })
        .catch(function(error) {
          vm.enableRestTime = false;
        });

    }

    function successListVehicles(vehicles) {
      driverService.list().then(function _successListDrivers(driversList) {
        vm.drivers = driversList;
        vm.vehicles = vehicles;
        vm.safeSrcVehicles = angular.copy(vm.vehicles);
        vm.safeSrcVehicles.sort(function(vehicleA, vehicleB){
          return  vehicleA.name.localeCompare(vehicleB.name, undefined, {sensitivity: 'base', numeric: true});
        });
        skillsService.list().then(successListSkills, errorListSkills);
      });
    }

    function errorListVehicles(error) {
      vm.ready = true;
      $log.info(error);
      if (error.status === 403) {
        $state.go('uprofile.info');
      }
      if (error.status === 404) {
        vm.errorPath = true;
        Toasts.push('error', $translate('Toast_vehicles.error_path_vehicles'));
      }
    }

    function successListSkills(skills) {
      vm.skills = skills;
      vm.ready = true;
    }

    function errorListSkills(error) {
      $log.info(error);
      Toasts.push('error', $translate('Toast_vehicles.error_path_skills'));
    }


    var onDeactivateListener = $scope.$on('$stateChangeStart', function (event, toState) {
      if (toState.name !== 'settings.vehicles.list') {
        Toasts.removeAll();
      }
    });
    $scope.$on('$destroy', onDeactivateListener);

    function validateNames(vehicles) {
      var errorVehicleName = '';
      lodash.every(vehicles, function (vehicle) {
        if (lodash.findIndex(vm.vehicles, {name: vehicle.name}) === -1) {
          return true;
        } else {
          errorVehicleName = vehicle.name;
          return false;
        }
      });
      return errorVehicleName;
    }

    function validateColumns(sheet, headers) {
      if (sheet['!ref']) {
        var columns = XLSX.utils.decode_range(sheet['!ref']).e.c + 1;
        if (columns !== headers.length) {
          return false;
        }
      } else {
        return false;
      }
      return true;
    }

    function _filterSkills(vehicles) {
      vehicles = xlsParserService.convertToArray(vehicles, ['skills']);
      return vehicles.map(function (vehicle) {
        var filteredSkills = [];
        vehicle.skills.forEach(function (skill) {
          var found = lodash.find(vm.skills, {skill: skill});
          if (found) {
            filteredSkills.push(found.id);
          }
        });
        vehicle.skills = filteredSkills;
        return vehicle;
      });
    }

    function validateVehiclesId(list) {
      return list.every(function(vehicleToAdd) {
        return vm.vehicles.find(function(vehicle) {
          return vehicle.id === parseInt(vehicleToAdd.id);
        });
      });
    }

    function validateCapacities(vehicles) {
      return vehicles.every(function (vehicle) {
        return (!vehicle.capacity || !isNaN(vehicle.capacity)) && (!vehicle.capacity_2 || !isNaN(vehicle.capacity_2)) &&
          (!vehicle.capacity_3 || !isNaN(vehicle.capacity_3)) && (!isNaN(vehicle.cost));
      });
    }


    function validateShiftTime(vehicles) {
      return lodash.every(vehicles, function (vehicle) {

        if(!vehicle.shift_start && !vehicle.shift_end) {
          return true;
        }

        var isValidShiftStart = validationService.validateTimeFormat(vehicle.shift_start);
        var isValidShiftEnd = validationService.validateTimeFormat(vehicle.shift_end);

        if(isValidShiftStart && isValidShiftEnd) {
          var shiftStartAsMinutes = moment.duration(vehicle.shift_start).asMinutes();
          var shiftEndAsMinutes = moment.duration(vehicle.shift_end).asMinutes();

          return (shiftEndAsMinutes > shiftStartAsMinutes);
        }

        return false;
      });
    }

    function validateRestTime(vehicles) {
      return lodash.every(vehicles, function (vehicle) {

        var bothExist = vehicle.rest_time_start && vehicle.rest_time_end;
        var isValidRestTimeStart = validationService.validateTimeFormat(vehicle.rest_time_start);
        var isValidRestTimeEnd = validationService.validateTimeFormat(vehicle.rest_time_end);

        if(bothExist && (!isValidRestTimeStart || !isValidRestTimeEnd)) {
          return false;
        }

        var restTimeSettings = {
          rest_time_start: vehicle.rest_time_start,
          rest_time_end: vehicle.rest_time_end,
          rest_time_duration: vehicle.rest_time_duration,
          shift_start: vehicle.shift_start,
          shift_end: vehicle.shift_end
        };

        var status = validationService.validateRestTime(restTimeSettings);

        return status.isValid;
      });
    }

    function validateMaxTime(vehicles) {
      var offenderVehicle = undefined;
      lodash.every(vehicles, function (vehicle) {
        if (vehicle.max_time !== "") {
          var maxTime = typeof vehicle.max_time == 'boolean' ?
            null : Number(vehicle.max_time);
          if (isNaN(maxTime) ||
              (maxTime <= 0 || !Number.isInteger(maxTime))) {
            offenderVehicle = vehicle;
            // Break on first invalid number (return false).
            return false;
          } else {
            // Continue on valid number (return true).
            return true;
          }
        } else {
          // Continue on empty string (allowed value, return true).
          return true;
        }
      });
      return offenderVehicle;
    }

    function _setLocationAddress(vehicles) {
      return vehicles.map(function (vehicle) {
        vehicle.location_end_address = vehicle.location_end_address ? vehicle.location_end_address : vehicle.location_start_address;
        return vehicle;
      });
    }

    function validateData(list) {
      var errorObject = { error: false };
      if (vm.bulkCreate) {
        if (!validateShiftTime(list) || !validateRestTime(list)) {
          errorObject.error = true;
          errorObject.type = DATA_FORMAT_ERROR;
        }

        var vehicleName = validateNames(list);
        if (vehicleName) {
          errorObject.error = true;
          errorObject.type = VEHICLE_NAME_DUPLICATE;
          errorObject.vehicleName = vehicleName;
        }
        // Validate max_time on bulk create.
        var offenderVehicle = validateMaxTime(list);
        if (offenderVehicle) {
          errorObject.error = true;
          errorObject.type = INVALID_MAX_TIME;
          errorObject.vehicleName = offenderVehicle.name;
        }
      } else {
        if (!validateVehiclesId(list)) {
          errorObject.error = true;
          errorObject.type = VEHICLE_ID_ERROR;
        } else {
          if (!validateCapacities(list) || !validateShiftTime(list) || !validateRestTime(list)) {
            errorObject.error = true;
            errorObject.type = DATA_FORMAT_ERROR;
          }
          // Validate max_time on bulk update.
          var offenderVehicle = validateMaxTime(list);
          if (offenderVehicle) {
            errorObject.error = true;
            errorObject.type = INVALID_MAX_TIME;
            errorObject.vehicleName = offenderVehicle.name;
          }
        }
      }
      if (errorObject.error) {
        errorUploadVehicles(errorObject);
      }
      return errorObject;

    }

    function importVehicles(files) {
      var headers;
      xlsUploaderService.handleFile(files[0]).then(function (workbook) {
        headers = getHeaders();
        if (validateColumns(workbook.Sheets[workbook.SheetNames[0]], headers)) {
          var grid = xlsParserService.createGrid(workbook, headers);
          var list = xlsParserService.gridToList(grid);
          vm.excelVehiclesQuantity = list.length;
          vm.vehicleAvailableCreate = vm.totalQuantityVehiclePlan - vm.safeSrcVehicles.length;
          if(vm.bulkCreate && (vm.excelVehiclesQuantity + vm.safeSrcVehicles.length) > vm.totalQuantityVehiclePlan){
            errorUploadVehicles({error: true, type: PLAN_VEHICLE_EXCEEDED});
            return;
          }

          var validData = validateData(list);
          if (!validData.error) {
            var vehicles = _addDrivers(list);
            vehicles = _filterSkills(vehicles);
            vehicles = _setLocationAddress(vehicles);
            vehicles = vehicles.reverse();
            vm.ready = false;
            if (vm.bulkCreate) {
              vm.promiseLoading = bulkService.uploadVehicles(vehicles).then(successUploadVehicles, errorUploadVehicles);
            } else {
              vm.promiseLoading = bulkService.updateVehicles(vehicles).then(successUploadVehicles, errorUploadVehicles);
            }
          }
        } else {
          errorUploadVehicles({error: true, type: DATA_FORMAT_ERROR});
        }
      });

    }

    function getHeaders(){
       var headers_result = ['name', 'capacity','capacity_2', 'capacity_3', 'location_start_address', 'location_end_address', 'shift_start', 'shift_end', 'default_driver', 'skills', 'reference_id', 'cost', 'max_visit', 'min_load', 'min_load_2', 'min_load_3','location_start_latitude', 'location_start_longitude',
        'location_end_latitude', 'location_end_longitude', 'max_time'];

      if (!vm.bulkCreate) {
        headers_result.unshift('id');
      }

      if (vm.enableRestTime) {
        headers_result.push('rest_time_start', 'rest_time_end', 'rest_time_duration');
      }
      return headers_result;
    }

    function successUploadVehicles(response) {
      vm.ready = true;
      Toasts.push('success', $translate('Toast_vehicles.success_import_vehicles'));
      vehicleService.clear();
      vm.promiseLoading = vehicleService.list().then(successListVehicles, errorListVehicles);
    }

    function _addDrivers(list) {
      var newList = [];
      for (var i = 0; i < list.length; i++) {
        if (list[i].default_driver) {
          var driver = lodash.find(vm.drivers, {name: list[i].default_driver});
          if (driver) {
            list[i].default_driver = driver.id;
            newList.push(list[i]);
          } else {
            list[i].default_driver = null;
            newList.push(list[i]);
          }
        } else {
          list[i].default_driver = null;
          newList.push(list[i]);
        }
      }
      return newList;
    }

    function errorUploadVehicles(err) {
      vm.ready = true;
      var errorMessage;
      switch (err.type) {
        case VEHICLE_ID_ERROR:
          errorMessage = $translate('Toast_vehicles.invalid_vehicles_ids');
          break;
        case LOCATION_ERROR:
          errorMessage = $translate('Toast_vehicles.error_invalid_address_1') + ' "' + err.location.address +
            '" ' + $translate('Toast_vehicles.error_invalid_address_2');
          break;
        case DATA_FORMAT_ERROR:
          errorMessage = $translate('Toast_vehicles.error_data_format');
          break;
        case PLAN_VEHICLE_EXCEEDED:
          errorMessage = $translate('Toast_vehicles.plan_vehicle_exceeded').
                         replace("@:vehicle_excel_quantity", vm.excelVehiclesQuantity).
                         replace("@:vehicle_available_create", vm.vehicleAvailableCreate).
                         replace("@:vehicle_total_plan", vm.totalQuantityVehiclePlan);
          break;
        case VEHICLE_NAME_DUPLICATE:
          errorMessage = $translate('Toast_vehicles.error_duplicate_vehicle_name_1') + ' "' + err.vehicleName +
            '" ' + $translate('Toast_vehicles.error_duplicate_vehicle_name_2');
          break;
        case INVALID_MAX_TIME:
          errorMessage = $translate('Toast_vehicles.invalid_max_time').
                         replace("@:vehicle", err.vehicleName);
          break;
        default:
          errorMessage = $translate('Toast_vehicles.error_import');
          break;
      }

      Toasts.push('error', errorMessage);
    }

    function createVehicle() {
      vm.state.go('settings.vehicles.create');
    }
    $scope.$on('$stateChangeSuccess',
      function(event, toState, toParams, fromState) {
        if (fromState && toState
            && (fromState.name == "settings.vehicles.create"
                || fromState.name == "settings.vehicles.detail")
            && toState.name == "settings.vehicles.list")
        {
          vm.promiseLoading = vehicleService.list().then(successListVehicles, errorListVehicles);
        }
      }
    );

    function downloadList() {
      var headers = [$translate('General.excel_headers_id'), $translate('Vehicles.title_table_header'),
        $translate('Vehicles.capacity_table_header'), $translate('Vehicles.capacity_2_table_header'),
        $translate('Vehicles.capacity_3_table_header'), $translate('Vehicles.origin_table_header'),
        $translate('Vehicles.destination_table_header'), $translate('Vehicles.shift_start_table_header'),
        $translate('Vehicles.shift_end_table_header'), $translate('Vehicles.driver_table_header'),
        $translate('Vehicles.skills_table_header'), $translate('Vehicles.reference_id_table_header'),
        $translate('Vehicles.cost_table_header'), $translate('Vehicles.max_visit_table_header'),
        $translate('Vehicles.min_load_table_header'), $translate('Vehicles.min_load_2_table_header'),
        $translate('Vehicles.min_load_3_table_header'),$translate('Vehicles.origin_latitude_table_header'),
        $translate('Vehicles.origin_longitude_table_header'),$translate('Vehicles.destination_latitude_table_header'),
        $translate('Vehicles.destination_longitude_table_header'),
        $translate('Vehicles.max_time_header')
      ];

      if(vm.enableRestTime) {
        headers.push(
          $translate('Vehicles.rest_time_start_table_header'),
          $translate('Vehicles.rest_time_end_table_header'),
          $translate('Vehicles.rest_time_duration_table_header')
        );
      }

      if (vm.vehicles.length === 0) {
        Toasts.push('error', $translate('Toast_vehicles.error_empty_vehicles_list'));
      } else {
        var vehiclesGrid = xlsWriterService.listToGrid(vehiclesList(), headers);
        xlsWriterService.addHeadersComments(vehiclesGrid, [
          null,
          $translate('Vehicles.title_table_header_comment'),
          $translate('Vehicles.capacity_table_header_comment'),
          null,
          null,
          $translate('Vehicles.origin_table_header_comment')
        ]);
        var workbook = xlsWriterService.createWorkbook('Vehicles', vehiclesGrid);
        var file = xlsWriterService.writeWorkbook(workbook);
        fileDownloaderService.downloadXLSX(file, 'vehicles.xlsx');
      }
    }

    function getSkillsNames(skillsKeys) {
      if (skillsKeys.length > 0) {
        var skillsNames = '';
        for (var i = 0; i < skillsKeys.length; i++) {
          if (typeof skillsKeys[i] === 'string') {
            skillsKeys[i] = parseInt(skillsKeys[i]);
          }
          var skill = lodash.find(vm.skills, {id: skillsKeys[i]});
          if (!skill) {
            return;
          }

          if (i < skillsKeys.length - 1) {
            skillsNames += skill.skill + ', ';
          } else {
            skillsNames += skill.skill;
          }
        }
        return skillsNames;
      }
      return '';
    }

    function onChangeSearch() {
      var text = vm.searchText.toLowerCase();

      vm.searching = text.length > 0;
      vm.safeSrcVehicles = vm.vehicles.filter(function (vehicle) {
        return vehicle.name.toLowerCase().includes(text);
      })
      .sort(function(vehicleA, vehicleB){
        return  vehicleA.name.localeCompare(vehicleB.name, undefined, {sensitivity: 'base', numeric: true});
      });
    }

    function cleanSearch() {
      vm.searchText = "";
      onChangeSearch();
    }

    function vehiclesList() {
      var output = [];

      for (var i = 0; i < vm.vehicles.length; i++) {
        var vehicle = vm.safeSrcVehicles[i];
        var filteredDataVehicle = {
          id: vehicle.id,
          name: vehicle.name ? vehicle.name : '',
          capacity: vehicle.capacity ? vehicle.capacity : '',
          capacity_2: vehicle.capacity_2 ? vehicle.capacity_2 : '',
          capacity_3: vehicle.capacity_3 ? vehicle.capacity_3 : '',
          location_start_address: vehicle.location_start_address ? vehicle.location_start_address : '',
          location_end_address: vehicle.location_end_address ? vehicle.location_end_address : '',
          shift_start: vehicle.shift_start ? vehicle.shift_start.slice(0, -3) : '',
          shift_end: vehicle.shift_end ? vehicle.shift_end.slice(0, -3) : '',
          default_driver: vehicle.default_driver ? vm.getDriverName(vehicle.default_driver) : '',
          skills: getSkillsNames(vehicle.skills),
          reference_id: vehicle.reference_id ? vehicle.reference_id : '',
          cost: vehicle.cost ? vehicle.cost : '',
          max_visit: vehicle.max_visit ? vehicle.max_visit : '',
          min_load: vehicle.min_load ? vehicle.min_load : '',
          min_load_2: vehicle.min_load_2 ? vehicle.min_load_2 : '',
          min_load_3: vehicle.min_load_3 ? vehicle.min_load_3 : '',
          location_start_latitude: vehicle.location_start_latitude ? vehicle.location_start_latitude : '',
          location_start_longitude: vehicle.location_start_longitude ? vehicle.location_start_longitude : '',
          location_end_latitude: vehicle.location_end_latitude ? vehicle.location_end_latitude : '',
          location_end_longitude: vehicle.location_end_longitude ? vehicle.location_end_longitude : '',
          max_time: vehicle.max_time ? vehicle.max_time : ''
        };

        if(vm.enableRestTime) {
          filteredDataVehicle.rest_time_start = vehicle.rest_time_start ? vehicle.rest_time_start : '';
          filteredDataVehicle.rest_time_end = vehicle.rest_time_end ? vehicle.rest_time_end : '';
          filteredDataVehicle.rest_time_duration = vehicle.rest_time_duration ? vehicle.rest_time_duration : '';
        }

        output.push(filteredDataVehicle);
      }
      return output;
    }

    function getDriverId(driverName) {
      var driver = lodash.find(vm.drivers, {name: driverName});
      return driver ? driver.id : '';
    }

    function getDriverName(driverId) {
      var driver = lodash.find(vm.drivers, {id: driverId});
      return driver ? driver.name : '';
    }

  }
})();

/* global google:false */
(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .controller('VehiclesDetailController', VehiclesDetailController);

  /** @ngInject */
  function VehiclesDetailController($log, $rootScope, $scope, $state, $stateParams,
                                    vehicleService, driversService, skillsService,
                                    ngDialog, $timeout, $filter, Toasts, lodash, moment,
                                    naturalService, sessionService, chatService,
                                    validationService, $cacheFactory,
                                    codriverService, HTTP_STATUS_CODE, accountConfigsService, MapModel,
                                    ACCOUNT_CONFIGS, locationResolverService, __env, ZOOM_NUMBER_TO_CENTER_MARKER) {
    var vm = this;

    var $translate = $filter('translate');
    var showGoToRoutesMessage = false;
    var DUPLICATE_NAME_ERROR_MESSAGE = "This name has already been used";
    var DIFFERENT_COUNTRY_ERROR_MESSAGE = "Diferente pais";
    var ORIGIN_ERROR_MESSAGE = "origen";
    var DESTINATION_ERROR_MESSAGE = "destino";
    var LATITUDE_LONGITUDE_ZERO_ERROR_MESSAGE = "lat lng 0";
    var ZERO_RESULTS_ERROR_MESSAGE = "ZERO_RESULTS";
    var ORIGIN_TEXT = 'origin';
    var DESTINATION_TEXT = 'destination';
    var VEHICLE_ORIGIN_MARKER_Z_INDEX = 999998;
    var VEHICLE_DESTINATION_MARKER_Z_INDEX = VEHICLE_ORIGIN_MARKER_Z_INDEX + 1;

    vm.error = false;
    vm.form = {};
    vm.vehicle = {
      name: null,
      capacity: null,
      capacity2: null,
      capacity3: null,
      cost: null,
      shift_start: null,
      shift_end: null,
      location_start_address: null,
      location_end_address: null,
      reference_id: null,
      default_driver: null,
      min_load: 0,
      min_load_2: 0,
      min_load_3: 0,
      max_visit: null,
      max_time: null,
      rest_time_start: null,
      rest_time_end: null,
      rest_time_duration: null,
      codrivers: [],
    };

    vm.skills_vehicle = {};

    vm.drivers = {
      "type": "select",
      "name": "",
      "value": "",
      "values": []
    };

    vm.state = $state;
    vm.stateParams = $stateParams;
    vm.vehicleId = null;
    if (!angular.isUndefined($stateParams.vehicleId)) {
      vm.vehicleId = $stateParams.vehicleId;
    }


    vm.skills = null;
    vm.drivers = null;
    vm.ready = false;
    vm.invalidLocations = false;
    vm.moreLoads = true;
    vm.shouldMirrorAddresses = false;
    vm.map = null;
    vm.addressEnd = {
      marker: null,
      focus: true
    };

    vm.addressOrigin = {
      marker: null,
      focus: true
    };

    vm.redirectToAssigner = false;
    vm.enableRestTime = false;
    vm.invalidDate = false;
    vm.timeBetweenDate = false;
    vm.emptyDate = false;
    vm.isValidTimeWindows = true;

    // rest time validation
    vm.invalidRestTime = false;
    vm.restTimeBetweenDate = false;
    vm.emptyRestTime = false;
    vm.exceedsRestTimeDuration = false;
    vm.emptyRestTimeDuration = false;

    vm.invalidDuration = false;
    vm.invalidDifferenceShiftRestStart = false;
    vm.invalidDifferenceShiftRestEnd = false;

    vm.save = save;
    vm.cancel = cancel;
    vm.getVehicle = getVehicle;
    vm.validateTime = validateTime;
    vm.changeMarker = changeMarker;
    vm.deleteVehicle = deleteVehicle;
    vm.showDeleteModal = showDeleteModal;
    vm.setPositionMarker = setPositionMarker;
    vm.changeState = changeState;
    vm.setDecimals = setDecimals;
    vm.naturalSort = naturalSort;
    vm.mirrorAddresses = mirrorAddresses;
    vm.validateIsInteger = validateIsInteger;
    // rest time validation
    vm.validateRestTime = validateRestTime;
    vm.validateAddresses = validateAddresses;

    // Codrivers related settings.
    vm.codrivers = [];
    vm.showCodriversModal = showCodriversModal;
    vm.updateStartLocation = updateStartLocation;
    vm.updateEndLocation = updateEndLocation;

    var locationStartWatcher = $scope.$watch('vm.vehicle.location_start_address', mirrorAddresses);
    $scope.$on('$destroy', onDestroy);

    activate();

    ////////////

    function activate() {
      Toasts.removeAll();
      _initializeMap();

      // Si se esta editando el vehiculo
      if (vm.vehicleId) {
        vm.getVehicle(vm.vehicleId);
      } else {
        //inicializar locations y skills;
        vm.vehicle.skills = [];
        vm.vehicle.location_end_latitude = "";
        vm.vehicle.location_end_longitude = "";
        vm.vehicle.location_start_latitude = "";
        vm.vehicle.location_start_longitude = "";

        skillsService.list().then(function success(skills) {
          vm.skills = skills;
        }, function errorGetSkills(error) {
          $log.info(error);
          if (error.status === HTTP_STATUS_CODE.NOT_FOUND) {
            Toasts.push('error', $translate('Toast_vehicles.error_path_skills'));
          }

        });
      }

      // drivers charges
      if (!vm.drivers) {
        driversService.list().then(function success(drivers) {
          vm.drivers = drivers;
        }, function errorGetDrivers(error) {
          $log.info(error);
          if (error.status === HTTP_STATUS_CODE.NOT_FOUND) {
            Toasts.push('error', $translate('Toast_vehicles.error_path_drivers'));
          }
        });
      }

      sessionService.getAccountConfigs()
        .then(function(configs) {
          var filteredConfigs = configs.filter(function(config) {
            return  config.key === 'enable_assigner' ||
                    config.key === 'enable_route_designer' ||
                    config.key === 'enable_rest_time';});

          if( filteredConfigs.length > 0) {
            var enableAssigner = false;
            var enableRouteDesigner = false;
            var enableRestTime = false;

            filteredConfigs.forEach(function(config) {
              enableAssigner = config.key === 'enable_assigner'? config.value : enableAssigner;
              enableRouteDesigner = config.key === 'enable_route_designer' ? config.value : enableRouteDesigner;
              enableRestTime = config.key === 'enable_rest_time' ? config.value : enableRestTime;
            });

            vm.redirectToAssigner = enableAssigner ? !enableRouteDesigner : false;
            vm.enableRestTime = enableRestTime;
          }else {
            vm.redirectToAssigner = false;
          }
        })
        .catch(function(error) {
          vm.redirectToAssigner = false;
        });

      // Codrivers retrieval.
      codriverService.list().then(function codriversSuccess(codrivers) {
        vm.codrivers = codrivers;
      }, function codriversError(error) {
        $log.error(error);
        Toasts.push('error',
                    $translate('Toast_vehicles.codrivers_retrieval_error'));
      });
    }

    function getVehicle(vehicleId) {
      return vehicleService.getVehicleById(Number(vehicleId)).then(function (vehicle) {
        // activate collapse more field
        _viewCollapsed(vehicle);
        vm.vehicle = angular.copy(vehicle);
        vm.vehicle.capacity = _formatIntegerToLocalNumber(vm.vehicle.capacity);
        vm.vehicle.capacity2 = _formatIntegerToLocalNumber(vm.vehicle.capacity_2);
        vm.vehicle.capacity3 = _formatIntegerToLocalNumber(vm.vehicle.capacity_3);
        vm.vehicle.cost = _formatIntegerToLocalNumber(vm.vehicle.cost);
        vm.vehicle.min_load = _formatIntegerToLocalNumber(vm.vehicle.min_load);
        vm.vehicle.min_load_2 = _formatIntegerToLocalNumber(vm.vehicle.min_load_2);
        vm.vehicle.min_load_3 = _formatIntegerToLocalNumber(vm.vehicle.min_load_3);
        vm.vehicle.max_visit = _formatIntegerToLocalNumber(vm.vehicle.max_visit);
        vm.vehicle.rest_time_end = !vm.vehicle.rest_time_end ? null : moment(vm.vehicle.rest_time_end, 'HH:mm').format('HH:mm');
        vm.vehicle.rest_time_start = !vm.vehicle.rest_time_start ? null : moment(vm.vehicle.rest_time_start, 'HH:mm').format('HH:mm');

        if (!vm.vehicle.shift_start) {
          vm.vehicle.shift_start = null;
        } else {
          vm.vehicle.shift_start = vm.vehicle.shift_start.split(':');
          vm.vehicle.shift_start = vm.vehicle.shift_start[0] + ':' + vm.vehicle.shift_start[1];
        }

        if (!vm.vehicle.shift_end) {
          vm.vehicle.shift_end = null;
        } else {
          vm.vehicle.shift_end = vm.vehicle.shift_end.split(':');
          vm.vehicle.shift_end = vm.vehicle.shift_end[0] + ':' + vm.vehicle.shift_end[1];
        }

        // get name's driver for default
        if (vm.vehicle.default_driver) {
          getDriverName(vm.vehicle.default_driver).then(function success(driver) {
            vm.vehicle.default_driver = driver;
          });
        }

        skillsService.list().then(function success(skills) {
          vm.skills = skills;

          // Active skills
          for (var i = 0; i < vm.vehicle.skills.length; i++) {
            var skill = vm.vehicle.skills[i];
            var index = lodash.find(vm.skills, function (obj) {
              return parseInt(obj.id) === parseInt(skill);
            });

            if (index) {
              vm.skills_vehicle[index.id] = true;
            }
          }

        }, function errorGetSkills(error) {
          $log.info(error);
          Toasts.push('error', $translate('Toast_vehicles.error_path_skills'));
        });

      }, function errorGetVehicle(error) {
        if (error.status === HTTP_STATUS_CODE.NOT_FOUND) {
          $log.info(error);
          Toasts.push('error', $translate('Toast_vehicles.vehicle_not_found'));
          $state.go('^');
          return;
        }
      });
    }

    function save() {
      vm.form.$valid = vm.error;
      var operation = vm.vehicleId ? 'Editar vehículo' : 'Crear vehículo';

      if (!vm.form.$valid) {
        var continueProcess = _showErrorInput();
        if (!continueProcess) {
          return;
        }
      }

      vm.vehicle.capacity = _formatLocalNumberToInteger(vm.vehicle.capacity);
      vm.vehicle.capacity_2 = (vm.vehicle.capacity2) ? _formatLocalNumberToInteger(vm.vehicle.capacity2) : 0;
      vm.vehicle.capacity_3 = (vm.vehicle.capacity3) ? _formatLocalNumberToInteger(vm.vehicle.capacity3) : 0;
      vm.vehicle.cost = (vm.vehicle.cost) ? _formatLocalNumberToInteger(vm.vehicle.cost) : null;
      vm.vehicle.min_load = (vm.vehicle.min_load) ? _formatLocalNumberToInteger(vm.vehicle.min_load) : 0;
      vm.vehicle.min_load_2 = (vm.vehicle.min_load_2) ? _formatLocalNumberToInteger(vm.vehicle.min_load_2) : 0;
      vm.vehicle.min_load_3 = (vm.vehicle.min_load_3) ? _formatLocalNumberToInteger(vm.vehicle.min_load_3) : 0;
      vm.vehicle.max_visit = (vm.vehicle.max_visit) ? _formatLocalNumberToInteger(vm.vehicle.max_visit) || null : null;
      vm.vehicle.capacity2 = vm.vehicle.capacity_2;
      vm.vehicle.capacity3 = vm.vehicle.capacity_3;
      vm.vehicle.rest_time_duration = (vm.vehicle.rest_time_duration) ? vm.vehicle.rest_time_duration : null;
      vm.vehicle.rest_time_end = (vm.vehicle.rest_time_end) ? vm.vehicle.rest_time_end : null;
      vm.vehicle.rest_time_start = (vm.vehicle.rest_time_start) ? vm.vehicle.rest_time_start : null;
      vm.vehicle.location_start_longitude = (vm.vehicle.location_start_longitude) ? vm.vehicle.location_start_longitude : null;
      vm.vehicle.location_start_latitude = (vm.vehicle.location_start_latitude) ? vm.vehicle.location_start_latitude : null;

      if (vm.vehicle.default_driver) {
        vm.vehicle.default_driver = vm.vehicle.default_driver.id;
      } else {
        vm.vehicle.default_driver = null;
      }

      // get skills' list
      _getEnabledSkills();

      // validate address with inputs
      if (document.getElementById("latitude_origin").value !== vm.vehicle.location_start_latitude) {
        if (document.getElementById("latitude_origin").value === "" &&
          document.getElementById("location_start_address").value === "") {
          vm.form.originLatitude.$error.required = true;
          return;
        }
        vm.vehicle.location_start_latitude = document.getElementById("latitude_origin").value;
      }

      if (document.getElementById("longitude_origin").value !== vm.vehicle.location_start_longitude) {
        if (document.getElementById("longitude_origin").value === "" &&
          document.getElementById("location_start_address").value === "") {
          vm.form.originLatitude.$error.required = true;
          return;
        }
        vm.vehicle.location_start_longitude = document.getElementById("longitude_origin").value;
      }

      if (document.getElementById("latitude_destination").value !== vm.vehicle.location_end_latitude) {
        vm.vehicle.location_end_latitude = document.getElementById("latitude_destination").value;
      }

      if (document.getElementById("longitude_destination").value !== vm.vehicle.location_end_longitude) {
        vm.vehicle.location_end_longitude = document.getElementById("longitude_destination").value;
      }

      // put lat and long end equal to lat and long origin
      if ((!vm.vehicle.location_end_latitude || vm.vehicle.location_end_latitude === '0' ||
          !vm.vehicle.location_end_latitude||vm.vehicle.location_end_latitude === '0') &&
        !vm.vehicle.location_end_address) {
        vm.vehicle.location_end_latitude = vm.vehicle.location_start_latitude;
        vm.vehicle.location_end_longitude = vm.vehicle.location_start_longitude;
      }

      // put end address equal to origin address if it is empty
      if (!vm.vehicle.location_end_address) {
        vm.vehicle.location_end_address = vm.vehicle.location_start_address;
      }

      // Set value from "" to null
      if (document.getElementById("max_time").value === "" ) {
        vm.vehicle.max_time = null;
      }

      if (vm.vehicleId) {
        vehicleService.update(vm.vehicle)
          .then(function success(response) {
            $log.info(response);
            vm.state.go('^');
          }, function errorUpdateVehicle(error) {
            $log.info(error);

            _validateAddressNotFound(error);

            if (error.status === HTTP_STATUS_CODE.BAD_REQUEST) {
              if (error.data.capacity) {
                vm.form.capacity.$error.invalid = true;
                vm.vehicle.capacity = _formatIntegerToLocalNumber(vm.vehicle.capacity);
              }
              if (error.data.capacity_2) {
                vm.form.capacity_2.$error.invalid = true;
                vm.vehicle.capacity2 = _formatIntegerToLocalNumber(vm.vehicle.capacity2);
              }
              if (error.data.capacity_3) {
                vm.form.capacity_3.$error.invalid = true;
                vm.vehicle.capacity3 = _formatIntegerToLocalNumber(vm.vehicle.capacity3);
              }
              if (error.data.cost) {
                vm.form.cost.$error.invalid = true;
                vm.vehicle.cost = _formatIntegerToLocalNumber(vm.vehicle.cost);
              }
              if (error.data.default_driver) {
                vm.form.default_driver.$error.invalid = true;
                vm.vehicle.default_driver = null;
              }

              var nonFieldErrors = error.data.non_field_errors;
              if (nonFieldErrors) {
                if (nonFieldErrors.includes(DUPLICATE_NAME_ERROR_MESSAGE)) {
                  vm.form.title.$error.deleted = true;
                } else {
                  vm.form.title.$error.invalid = true;
                }
              }
            }

            _validateGeocodingError(error);

            $timeout(function () {
            }, 3000).then(function () {
              vm.form.capacity.$error.invalid = false;
              vm.form.capacity_2.$error.invalid = false;
              vm.form.capacity_3.$error.invalid = false;
              vm.form.cost.$error.invalid = false;
              vm.form.default_driver.$error.invalid = false;
              vm.form.title.$error.invalid = false;
              vm.form.title.$error.deleted = false;
            });
          });
      } else {
        vehicleService.list().then(function (vehicles) {
          showGoToRoutesMessage = (vehicles.length === 0);

          vehicleService.create(vm.vehicle)
            .then(function success(response) {
              $log.info(response);
              chatService.notifyVehicleCreated(response);
              if (showGoToRoutesMessage) {
                var link = vm.redirectToAssigner ? '"#/assigner"' : '"#/planner"';
                Toasts.push('success', '<a class="sp-link-white" href='+ link +'>' + $translate('Toast_vehicles.can_create_routes') + '</a>', false, true);
              }
              vm.state.go('^');
            }, function errorCreateVehicle(error) {
              $log.info(error);

              _validateAddressNotFound(error);

              if (error.status === HTTP_STATUS_CODE.BAD_REQUEST) {
                if (error.data.capacity) {
                  vm.form.capacity.$error.invalid = true;
                }
                if (error.data.capacity_2) {
                  vm.form.capacity_2.$error.invalid = true;
                }
                if (error.data.capacity_3) {
                  vm.form.capacity_3.$error.invalid = true;
                }
                if (error.data.cost) {
                  vm.form.cost.$error.invalid = true;
                }

                var nonFieldErrors = error.data.non_field_errors;
                if (nonFieldErrors) {
                  if (nonFieldErrors.includes(DUPLICATE_NAME_ERROR_MESSAGE)) {
                    vm.form.title.$error.deleted = true;
                  } else {
                    vm.form.title.$error.invalid = true;
                  }
                }
              }

              _validateGeocodingError(error);

              vm.vehicle.capacity = _formatIntegerToLocalNumber(vm.vehicle.capacity);
              vm.vehicle.capacity2 = _formatIntegerToLocalNumber(vm.vehicle.capacity2);
              vm.vehicle.capacity3 = _formatIntegerToLocalNumber(vm.vehicle.capacity3);
              vm.vehicle.cost = _formatIntegerToLocalNumber(vm.vehicle.cost);
              vm.invalidLocations = true;
              $timeout(function () {
              }, 4000).then(function () {
                vm.invalidLocations = false;
                vm.form.capacity.$error.invalid = false;
                vm.form.capacity_2.$error.invalid = false;
                vm.form.capacity_3.$error.invalid = false;
                vm.form.cost.$error.invalid = false;
                vm.form.title.$error.invalid = false;
                vm.form.title.$error.deleted = false;
              });
            });
        });
      }
    }

    function _validateAddressNotFound(error) {
      if (error === ZERO_RESULTS_ERROR_MESSAGE) {
        Toasts.push('error', $translate('Toast_vehicles.error_set_address'));
      }
    }

    function _validateGeocodingError(error) {
      if (angular.isArray(error) && error.indexOf(DIFFERENT_COUNTRY_ERROR_MESSAGE) > -1) {
        if (error.indexOf(ORIGIN_ERROR_MESSAGE) > -1) {
          Toasts.push('error', $translate('Toast_vehicles.error_set_address_origin_country'));
        }
        if (error.indexOf(DESTINATION_ERROR_MESSAGE) > -1) {
          Toasts.push('error', $translate('Toast_vehicles.error_set_address_destiny_country'));
        }
      }

      if (angular.isArray(error) &&  error.indexOf(LATITUDE_LONGITUDE_ZERO_ERROR_MESSAGE) > -1) {
        if (error.indexOf(ORIGIN_ERROR_MESSAGE) > -1) {
          Toasts.push('error', $translate('Toast_vehicles.error_set_address_origin_latlng0'));
        }
        if (error.indexOf(DESTINATION_ERROR_MESSAGE) > -1) {
          Toasts.push('error', $translate('Toast_vehicles.error_set_address_destiny_latlng0'));
        }
      }
    }

    function deleteVehicle() {
      vehicleService.delete(vm.vehicle)
        .then(function () {
          var fleetsCache = $cacheFactory.get("fleets");
          if (fleetsCache) {
            fleetsCache.removeAll();
          }

          var zonesCache = $cacheFactory.get("zones");
          if (zonesCache) {
            zonesCache.removeAll();
          }

          $state.go('^');
        })
        .catch(function (error) {
          $log.info(error);
          if (error.status === HTTP_STATUS_CODE.CONFLICT) {
            $scope.error = error.data;
            ngDialog.open({
              template: 'app/settings/vehicles/vehicle-cannot-delete-modal.html',
              scope: $scope
            });
          }
        });
    }

    function showDeleteModal() {
      $scope.deleteVehicle = deleteVehicle;

      ngDialog.open({
        template: 'app/settings/vehicles/vehicle-delete-modal.html',
        scope: $scope
      });
    }

    function _getEnabledSkills() {
      vm.vehicle.skills.length = 0;
      if (Object.keys(vm.skills_vehicle).length > 0) {

        for (var skill in vm.skills_vehicle) {
          if (vm.skills_vehicle[skill]) {
            vm.vehicle.skills.push(parseInt(skill));
          }
        }

      }
    }

    function validateIsInteger(num) {
      var parsedNumber = Number(num);
      vm.form.max_visit.$error.integer = num ? (!Number.isInteger(parsedNumber) || parsedNumber <= 0) : false;
    }

    function mirrorAddresses() {
      var locationEndInput = document.getElementById("location_end_address");
      if(locationEndInput) {
        locationEndInput.disabled = vm.shouldMirrorAddresses;
      }
      if (vm.shouldMirrorAddresses) {
        vm.vehicle.location_end_address = vm.vehicle.location_start_address;
        vm.vehicle.location_end_latitude = vm.vehicle.location_start_latitude;
        vm.vehicle.location_end_longitude = vm.vehicle.location_start_longitude;
      }
    }

    function validateAddresses() {
      vm.form.originAddress.$error.required = false;
      // validate always exist origin address
      if(!document.getElementById("location_start_address").value) {
        vm.form.originAddress.$error.required = true;
      }


      vm.form.endAddress.$error.required = false;
      // validate always end origin address, if exist end coordinates
      if(document.getElementById("latitude_destination").value &&
        document.getElementById("longitude_destination").value &&
        !(document.getElementById("location_end_address").value )){
        vm.form.endAddress.$error.required = true;
      }
    }

    function cancel() {
      vm.state.go('^');
    }

    function _centerMaptoMarker(map, markerPosition) {
      map.setCenter(markerPosition.latitude, markerPosition.longitude);
      map.setZoom(ZOOM_NUMBER_TO_CENTER_MARKER);
    }

    function changeMarker(input) {
      if (vm.addressOrigin.marker && input === 'end' && !vm.addressEnd.marker) {
        vm.addressOrigin.marker.setVisible(false);
        var destinationMarker = vm.map.makeMarker(_getVehicleDestinationOptions(vm.vehicle));
        destinationMarker.setEvent('dragend', _getCallbackForDestinationMarker(destinationMarker, vm.vehicle));
        vm.addressEnd.marker = destinationMarker;
        _centerMaptoMarker(vm.map, destinationMarker.getPosition());
      } else if (input === 'end') {
        if (vm.addressOrigin.marker) {
          vm.addressOrigin.marker.setVisible(false);
        }

        if (vm.addressEnd.marker) {
          vm.addressEnd.marker.setVisible(true);
          _centerMaptoMarker(vm.map, vm.addressEnd.marker.getPosition());
        }
      } else if (input === ORIGIN_TEXT) {
        if (vm.addressOrigin.marker) {
          vm.addressOrigin.marker.setVisible(true);
          _centerMaptoMarker(vm.map, vm.addressOrigin.marker.getPosition());
        }

        if (vm.addressEnd.marker) {
          vm.addressEnd.marker.setVisible(false);
        }
      }
    }

    function setDecimals(point){
      var lat = point === ORIGIN_TEXT ? document.getElementById("latitude_origin").value
        : document.getElementById("latitude_destination").value;
      var lng = point === ORIGIN_TEXT ? document.getElementById("longitude_origin").value
        : document.getElementById("longitude_destination").value;

      if (lat  && /^-?\d+\.?\d*$/.test(lat)){
        if (point === ORIGIN_TEXT) {
          vm.vehicle.location_start_latitude = _convertToSixDecimals(lat).toString();
        } else {
          vm.vehicle.location_end_latitude = _convertToSixDecimals(lat).toString();
        }
      }

      if (lng && /^-?\d+\.?\d*$/.test(lng)){
        if (point=== ORIGIN_TEXT) {
          vm.vehicle.location_start_longitude= _convertToSixDecimals(lng).toString();
        } else{
          vm.vehicle.location_end_longitude= _convertToSixDecimals(lng).toString();
        }
      }

      mirrorAddresses();
    }

    function updateStartLocation(location, address) {
      vm.addressOrigin.marker.setPosition(location.latitude, location.longitude);
      vm.vehicle.location_start_latitude = location.latitude.toFixed(6);
      vm.vehicle.location_start_longitude = location.longitude.toFixed(6);
      vm.vehicle.location_start_address = address;

      if (vm.shouldMirrorAddresses) {
        mirrorAddresses();
      }
      _centerMaptoMarker(vm.map, location);
      vm.form["originLatitude"].$error.pattern = false;
    }

    function updateEndLocation(location, address) {
      vm.addressEnd.marker.setPosition(location.latitude, location.longitude);
      vm.vehicle.location_end_latitude = location.latitude.toFixed(6);
      vm.vehicle.location_end_longitude = location.longitude.toFixed(6);
      vm.vehicle.location_end_address = address;

      _centerMaptoMarker(vm.map, location);
      vm.form["destinationLatitude"].$error.pattern = false;
    }

    function setPositionMarker(address, _lat, _lng, position) {
      // validate pattern when we use coordinates
      if (!_validatePattern(position) &&  validateAddresses()) {
        return;
      }

      if (_lat && _lng &&
        _lat.length > 4 && _lng.length > 4  &&
        /^(-?\d+(\.\d{0,6})?)$/.test(_lat) &&
        /^(-?\d+(\.\d{0,6})?)$/.test(_lng)
      ) {

        var markerPosition = {
          latitude: parseFloat(_lat),
          longitude: parseFloat(_lng)
        };

        if (position === ORIGIN_TEXT) {
          vm.addressOrigin.marker.setPosition(markerPosition.latitude, markerPosition.longitude);
          _centerMaptoMarker(vm.map, markerPosition);
        }

        if (position === DESTINATION_TEXT) {
          vm.addressEnd.marker.setPosition(markerPosition.latitude, markerPosition.longitude);
          _centerMaptoMarker(vm.map, markerPosition);
        }
      }

      mirrorAddresses();
    }

    function validateRestTime() {
      var restTimeStartAsMoment = moment(vm.vehicle.rest_time_start, "HH:mm");
      var restTimeEndAsMoment = moment(vm.vehicle.rest_time_end, "HH:mm");

      if (restTimeStartAsMoment.isValid()) {
        vm.vehicle.rest_time_start = restTimeStartAsMoment.format("HH:mm");
      }

      if (restTimeEndAsMoment.isValid()) {
        vm.vehicle.rest_time_end = restTimeEndAsMoment.format("HH:mm");
      }

      var status = validationService.validateRestTime({
        rest_time_start: vm.vehicle.rest_time_start,
        rest_time_end: vm.vehicle.rest_time_end,
        rest_time_duration: _formatLocalNumberToInteger(vm.vehicle.rest_time_duration),
        shift_start: vm.vehicle.shift_start,
        shift_end: vm.vehicle.shift_end
      });

      vm.invalidRestTime = status.invalidRestTime;
      vm.restTimeBetweenDate = status.restTimeBetweenDate;
      vm.emptyRestTime = status.emptyRestTime;
      vm.emptyRestTimeDuration = status.emptyRestTimeDuration;
      vm.exceedsRestTimeDuration = status.exceedsRestTimeDuration;
      vm.invalidDuration = status.invalidDuration;
      vm.invalidDifferenceShiftRestStart = status.invalidDifferenceShiftRestStart;
      vm.invalidDifferenceShiftRestEnd = status.invalidDifferenceShiftRestEnd;
      vm.isValidTimeWindows = status.isValid && !vm.invalidDate && !vm.timeBetweenDate && !vm.emptyDate;

      return vm.isValidTimeWindows;
    }

    function validateTime() {
      vm.invalidDate = false;
      vm.timeBetweenDate = false;
      vm.emptyDate = false;
      vm.invalidDifferenceShiftRestStart = false;
      vm.invalidDifferenceShiftRestEnd = false;

      vm.isValidTimeWindows = true;

      if (!vm.vehicle.shift_start && !vm.vehicle.shift_end) {
        vm.vehicle.shift_start = null;
        vm.vehicle.shift_end = null;
        return;
      }

      var isValidShiftStart = moment(vm.vehicle.shift_start, "HH:mm").isValid();
      var isValidShiftEnd = moment(vm.vehicle.shift_end, "HH:mm").isValid();

      // validar hora de inicio
      if (vm.vehicle.shift_start) {
        if (isValidShiftStart) {
          vm.vehicle.shift_start = moment(vm.vehicle.shift_start, "HH:mm").format("HH:mm");
        } else {
          vm.isValidTimeWindows = false;
          vm.invalidDate = true;
        }
      }

      // validar hora final
      if (vm.vehicle.shift_end) {
        if (isValidShiftEnd) {
          vm.vehicle.shift_end = moment(vm.vehicle.shift_end, "HH:mm").format("HH:mm");
        } else {
          vm.isValidTimeWindows = false;
          vm.invalidDate = true;
        }
      }

      if (!vm.vehicle.shift_start && isValidShiftEnd || isValidShiftStart && !vm.vehicle.shift_end) {
        vm.isValidTimeWindows = false;
        vm.emptyDate = true;
      }

      if(isValidShiftStart && isValidShiftEnd) {
        var shiftStartAsMinutes = moment.duration(vm.vehicle.shift_start).asMinutes();
        var shiftEndAsMinutes = moment.duration(vm.vehicle.shift_end).asMinutes();

        if (shiftStartAsMinutes > shiftEndAsMinutes || shiftStartAsMinutes === shiftEndAsMinutes) {
          vm.isValidTimeWindows = false;
          vm.timeBetweenDate = true;
        }
      }

      // Some changes in the active shift of the vehicle affect rest time validation,
      // so we must redo it here
      validateRestTime();
    }

    function getDriverName(driverId) {
      return driversService.getDriverById(driverId);
    }

    function _formatLocalNumberToInteger(capacity) {
      capacity = String(capacity);

      var locale = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);

      if (locale.substring(0, 2).toLowerCase() === 'es') {
        capacity = capacity.split('.').join("").replace(",", ".");
        return parseFloat(capacity);
      } else {
        capacity = capacity.split(',').join("");
        return parseFloat(capacity);
      }
    }

    function _formatIntegerToLocalNumber(capacity) {
      capacity = String(capacity);
      var locale = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);

      if (locale.substring(0, 2).toLowerCase() === 'es') {
        return capacity.replace(".", ",");
      } else {
        return capacity;
      }
    }

    function _getVehicleOriginOptions(vehicle) {
      var options = {
        icon: {
          url: '/assets/images/vehicle_origin_marker.svg',
          anchor: {
            x: 16,
            y: 41
          }
        },
        draggable: true,
        zIndex: VEHICLE_ORIGIN_MARKER_Z_INDEX
      };

      if (vehicle) {
        options.position = {
          latitude: vehicle.location_start_latitude,
          longitude: vehicle.location_start_longitude
        };
      }

      return options;
    }

    function _getVehicleDestinationOptions(vehicle) {
      var options = {
        icon: {
          url: '/assets/images/vehicle_destination_marker.svg',
          anchor: {
            x: 16,
            y: 41
          }
        },
        draggable: true,
        zIndex: VEHICLE_DESTINATION_MARKER_Z_INDEX
      };

      if (vehicle) {
        options.position = {
          latitude: vehicle.location_end_latitude,
          longitude: vehicle.location_end_longitude
        };
      }

      return options;
    }

    function _getCallbackForOriginMarker(marker, vehicle) {
      return function () {
        var markerPosition = marker.getPosition();
        return locationResolverService.getAddressByLatLng(markerPosition.latitude, markerPosition.longitude)
          .then(function (address) {
            if (address) {
              vehicle.location_start_latitude = markerPosition.latitude.toFixed(6);
              vehicle.location_start_longitude = markerPosition.longitude.toFixed(6);
            } else {
              Toasts.push('error', $translate('Toast_vehicles.error_set_position_marker'));
            }
          });
      };
    }

    function _getCallbackForDestinationMarker(marker, vehicle) {
      return function () {
        var markerPosition = marker.getPosition();
        return locationResolverService.getAddressByLatLng(markerPosition.latitude, markerPosition.longitude)
          .then(function (address) {
            if (address) {
              vehicle.location_end_latitude = markerPosition.latitude.toFixed(6);
              vehicle.location_end_longitude = markerPosition.longitude.toFixed(6);
            } else {
              Toasts.push('error', $translate('Toast_vehicles.error_set_position_marker'));
            }
          });
      };
    }

    function _activateForEditing(map, vehicle, addressOrigin, addressEnd) {
      if (!vehicle.location_start_latitude || !vehicle.location_start_longitude) {
        return;
      }

      var originMarker = map.makeMarker(_getVehicleOriginOptions(vehicle));
      originMarker.setEvent('dragend', _getCallbackForOriginMarker(originMarker, vehicle));
      addressOrigin.marker = originMarker;
      var destinationMarker = map.makeMarker(_getVehicleDestinationOptions(vehicle));
      destinationMarker.setEvent('dragend', _getCallbackForDestinationMarker(destinationMarker, vehicle));
      addressEnd.marker = destinationMarker;
      map.setCenter(parseFloat(vehicle.location_start_latitude), parseFloat(vehicle.location_start_longitude));
    }

    function _activateForCreating(map, vehicle, addressOrigin) {
      var originMarker = map.makeMarker(_getVehicleOriginOptions(null));
      originMarker.setEvent('dragend', _getCallbackForOriginMarker(originMarker, vehicle));
      addressOrigin.marker = originMarker;
    }

    function _initializeMap() {
      var vehicleMapProvider = accountConfigsService.getConfigRawValue(ACCOUNT_CONFIGS.MAP_PROVIDER);
      var htmlElementRef = document.getElementById('map');
      var options = { zoom: 16 };
      return MapModel.createInstance(vehicleMapProvider, __env.DEFAULT_NAME_OF_VEHICLE_MAP_PROVIDER, htmlElementRef, options)
        .then(function (map) {
          vm.map = map;
          if (vm.vehicleId) {
            _activateForEditing(map, vm.vehicle, vm.addressOrigin, vm.addressEnd);
          } else {
            _activateForCreating(map, vm.vehicle, vm.addressOrigin);
          }
        });
    }

    function _showErrorInput() {
      var continueProcess = true;

      if (document.getElementById("max_time").value !== ""){
        var isInteger = Number(document.getElementById("max_time").value);
        if ( isNaN(isInteger)
          || (isInteger <= 0 || !Number.isInteger(isInteger))){
          vm.form.max_visit.$error.integer = true;
          continueProcess = false;
        }
      }


      if (vm.invalidDate || vm.timeBetweenDate || vm.emptyDate) {
        continueProcess = false;
      }

      if (!vm.vehicle.name) {
        vm.form.title.$error.required = true;
        continueProcess = false;
      }

      if (!vm.vehicle.capacity) {
        vm.form.capacity.$error.required = true;
        continueProcess = false;
      } else {
        vm.vehicle.capacity = String(vm.vehicle.capacity);
      }

      // validate always exist origin address
      if(!document.getElementById("location_start_address").value) {
        vm.form.originAddress.$error.required = true;
        continueProcess = false;
      }

      // validate always end origin address, if exist end coordinates
      if(document.getElementById("latitude_destination").value &&
        document.getElementById("longitude_destination").value &&
        !(document.getElementById("location_end_address").value )){
        vm.form.endAddress.$error.required = true;
        continueProcess = false;
      }

      var continueProcessCord = _validatePattern(ORIGIN_TEXT) && _validatePattern(DESTINATION_TEXT);

      if(continueProcess && continueProcessCord && !validateRestTime()){
        continueProcess = false;
        vm.form.$valid = false;
      }

      return continueProcess && continueProcessCord;
    }

    function _validatePattern(position) {
      var patternValid = true;

      // Validate coordinates has the pattern 0.0

      if((document.getElementById("latitude_" + position).value ||
          document.getElementById("longitude_" + position).value) &&
        (_coordinateValidateRange(document.getElementById("latitude_" + position).value, 90) ||
          _coordinateValidateRange(document.getElementById("longitude_" + position).value, 180))){
        vm.form[position + "Latitude"].$error.pattern = true;
        patternValid = false;
        vm.form.$valid = false;
      }else {
        vm.form[position + "Latitude"].$error.pattern = false;
      }

      return patternValid;
    }

    function _coordinateValidateRange(lat, limit) {
      return !/^(-?\d+(\.\d+)?)$/.test(lat) || parseFloat(lat) > limit || parseFloat(lat) < limit * -1;
    }

    function changeState(state) {
      if (vm.form.$dirty) {
        ngDialog.openConfirm({
          template: 'app/settings/vehicles/vehicles-confirm-leave.html',
          controller: ['changeStateVehicle', 'state', DialogController],
          controllerAs: 'vm',
          resolve: {
            changeStateVehicle: function () {
              return changeStateVehicle;
            },
            state: function () {
              return state;
            }
          }
        });

      } else {
        $state.go(state);
      }

      function DialogController(changeStateVehicle, state) {
        var vm = this;
        vm.changeStateVehicle = changeStateVehicle;
        vm.state = state;

        if (lodash.includes(state, 'skills')) {
          vm.skillsMessageLeave = true;
        }
        if (lodash.includes(state, 'drivers')) {
          vm.driverMessageLeave = true;
        }
      }
    }

    function changeStateVehicle(state) {
      $state.go(state);
    }

    function _convertToSixDecimals(str){
      return Number(str).toFixed(6);
    }

    function _viewCollapsed(vehicle) {
      if (vehicle.capacity_3 !== 1 || vehicle.capacity_2 !== 1 ||
        vehicle.location_end_address !== vehicle.location_start_address) {
        vm.moreLoads = false;
      }
    }

    $rootScope.$on('positionNavigator', function () {
      if (!$rootScope.mapInitCoord || (vm.vehicle.location_start_latitude && vm.vehicle.location_start_longitude)) {
        return;
      }

      var latitude = parseFloat($rootScope.mapInitCoord.latitude);
      var longitude = parseFloat($rootScope.mapInitCoord.longitude);
      if (vm.map) {
        vm.map.setCenter(latitude, longitude);
      }

      if (vm.addressOrigin.marker) {
        vm.addressOrigin.marker.setPosition(latitude, longitude);
      }
    });

    function naturalSort(field) {
      return function (item) {
        return naturalService.naturalValue(item[field]);
      };
    }

    function onDestroy() {
      locationStartWatcher();
      if (vm.map) {
        vm.map.destroy();
      }
    }

    function showCodriversModal(vehicleName, vehicleCodrivers, availableCodrivers) {
      var dialog = ngDialog.open({
        template: 'app/settings/vehicles/vehicle-codrivers-modal.html',
        className: 'ngdialog-theme-default custom-width-800',
        controller: 'VehicleCodriversModalController',
        controllerAs: 'vm',
        showClose: false,
        closeByEscape: false,
        closeByDocument: false,
        resolve: {
          vehicleName: function () {
            return vehicleName;
          },
          vehicleCodrivers: function () {
            return vehicleCodrivers;
          },
          availableCodrivers: function () {
            return availableCodrivers;
          }
        }
      });
      // Modal's controller return value set current vehicle codrivers
      // selection, but proper codrivers assignment is not done until
      // successful vehicle save.
      return dialog.closePromise.then(function (response) {
               vm.vehicle.codrivers = response.value;
             });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .controller('VehicleCodriversModalController',
                VehicleCodriversModalController);

    function VehicleCodriversModalController(vehicleName, vehicleCodrivers,
                                             availableCodrivers, lodash) {
      // Set current vehicle codrivers selection, but proper codrivers
      // assignment is not done until successful vehicle save.
      var vm = this;
      vm.availableCodrivers = {
        plansModule: true,
        itemsSelected: 0,
        items: [],
      };

      vm.setCodrivers = setCodrivers;
      vm.cancelAndCloseModal = cancelAndCloseModal;
      vm.vehicleCodrivers = vehicleCodrivers;
      vm.vehicleName = vehicleName;

      activate();

      function activate() {
        // For vehicles being created, initial vehicleCodrivers is always empty.
        // For vehicles being updated, initial vehicleCodrivers include
        // already assigned codrivers.
        // A new codrivers selection is only assigned after successful
        // vehicle save.
        vm.availableCodrivers.items = availableCodrivers.map(function (availableCodriver) {
          var selected = vm.vehicleCodrivers.some(function (currentCodriver) {
            return currentCodriver.id == availableCodriver.id;
          });
          return {
            id: availableCodriver.id,
            name: availableCodriver.name,
            activate: Boolean(selected)
          };
        });
      }

      function setCodrivers() {
        // Returns new codrivers selection.
        var newVehicleCodrivers = vm.availableCodrivers.items.reduce(
          function (codriversSelection, availableCodriver) {
            return availableCodriver.activate ?
              codriversSelection.concat(lodash.pick(availableCodriver, ['id'])) :
              codriversSelection;
        }, []);
        return newVehicleCodrivers;
      }

      function cancelAndCloseModal() {
        // Returns original codrivers selection.
        return vm.vehicleCodrivers;
      }
    }

})();

(function(){
  'use strict';
  angular
    .module('icarus.settings')
    .controller('UsersListController', UsersListController);

    /** @ngInject */
    function UsersListController($log, $scope, $state, userService,
                                 sessionService, __env,
                                 orderUsersSettingsFilter,
                                 $q, plannerService, ngDialog, xlsWriterService,
                                 fileDownloaderService, bulkService,
                                 xlsUploaderService, xlsParserService, lodash,
                                 $filter, Toasts) {

      var vm = this;
      var $translate = $filter('translate');

      var DATA_FORMAT_ERROR = 'DATA_FORMAT_ERROR';
      var DUPLICATED_USERNAME_ERROR = 'DUPLICATED_USERNAME_ERROR';
      var INVALID_ID_ERROR = 'INVALID_ID_ERROR';
      var DUPLICATED_EMAIL_ERROR = 'DUPLICATED_EMAIL_ERROR';

      vm.users = [];
      vm.errorMsg = null;
      vm.searchText = "";
      vm.searching = false;
      vm.user = {};
      vm.safeSrcUsers = [];
      vm.creating = false;
      vm.showMore = false;
      vm.showErrorPassword = false;
      vm.state = $state;
      vm.maxSize = 3;
      vm.currentPage = 1;
      vm.itemsPerPage = 15;
      vm.justDriver = true;
      vm.showNotUsersMessage = false;
      vm.bulkCreate = true;
      vm.onChangeSearch = onChangeSearch;
      vm.cleanSearch = cleanSearch;

      vm.downloadList = downloadList;
      vm.downloadTemplate = downloadTemplate;
      vm.importUsers = importUsers;

      vm.androidAppLink = __env.APP_MOBILE_GOOGLEPLAY_LINK;
      vm.appStoreAppLink = __env.APP_MOBILE_APPSTORE_LINK;
      vm.createUser = createUser;
      vm.openDeleteModal = openDeleteModal;
      vm.openUnlockModal = openUnlockModal;

      activate();

      $scope.$on('SAVE_USER', _saveUser);
      $scope.$on('DELETE_USER', _deleteUser);

      /////////////////////////

      function activate() {
        vm.promiseLoading = userService.listUsers().then(successListUsers, errorListUsers);
        var sessionUserPromise = sessionService.getUser().then(successRetrieveUser, errorRetrieveUSer);

        $q.all([vm.promiseLoading, sessionUserPromise])
          .then(function (results) {
            vm.users = orderUsersSettingsFilter(results[0], results[1]);

            createSafeList();
            vm.showNotUsersMessage = !vm.safeSrcUsers.length;
          });

        /* Moved successListUsers, errorListUsers, successRetrieveUser and
        errorRetrieveUSer. */

      }

      // Session user callbacks

      function successRetrieveUser(user) {
        return {
          id: user.id,
          role: user.is_owner ? 0 : user.is_admin ? 1 : 2,
        };
      }

      function errorRetrieveUSer (error) {
        $log.info(error);
      }

      function successListUsers(users) {
        vm.ready = true;

        // Activar aviso de usuarios solo conductores
        for (var i = 0; i < users.length; i++) {
          if (users[i].is_admin || users[i].is_owner) {
            vm.justDriver = false;
            continue;
          }
          if (users[i].is_driver) {
            vm.justDriver = true;
            break;
          }
        }

        return users;
      }

      function errorListUsers(error) {
        vm.ready = true;
        vm.showNotUsersMessage = true;
        $log.info(error);
        if (error.status === 403) {
          $state.go('uprofile.info');
        }
      }

      function createSafeList() {
        vm.safeSrcUsers = angular.copy(vm.users);
        vm.safeSrcUsers.sort(function (userA, userB) {
          return userA.name.localeCompare(userB.name, undefined, {sensitivity: 'base', numeric: true});
        });
      }

      function createUser() {
        vm.state.go('settings.users.create');
      }

      $scope.$on('$stateChangeSuccess',
        function (event, toState, toParams, fromState, fromParams) {
          if (fromState && toState
            && (fromState.name == "settings.users.create"
              || fromState.name == "settings.users.detail")
            && toState.name == "settings.users.list") {
            activate();
          }
        }
      );

      function _saveUser(event, data) {
        var userIndex = vm.users.findIndex(function (user) {
          return user.id === data.id;
        });
        if (userIndex !== -1 && angular.isDefined(userIndex)) {
          vm.users[userIndex] = data;
        } else {
          vm.users.push(data);
        }

        updateDriverPlannerService(data);
        createSafeList();
        vm.showNotUsersMessage = !vm.safeSrcUsers.length;
      }

      function updateDriverPlannerService(data) {
        if (data.isDriver) {
          plannerService.updateListDriver(data);
        }
      }

      function _deleteUser(event, data) {
        for (var i = 0; i < vm.users.length; i++) {
          var user = vm.users[i];
          if (user.id === data.id) {
            vm.users.splice(i, 1);
            if (user.isDriver) {
              plannerService.removeDriver(String(data.id));
            }

            if (user.isCodriver) {
              plannerService.removeCodriver(String(data.id));
            }

            break;
          }
        }

        createSafeList();
        vm.showNotUsersMessage = !vm.safeSrcUsers.length;
      }

      function onChangeSearch() {
        var text = vm.searchText.toLowerCase();

        vm.searching = text.length > 0;
        vm.safeSrcUsers = vm.users.filter(function (user) {
          return user.name.toLowerCase().includes(text);
        })
          .sort(function (userA, userB) {
            return userA.name.localeCompare(userB.name, undefined, {sensitivity: 'base', numeric: true});
          });
      }

      function cleanSearch() {
        vm.searchText = "";
        onChangeSearch();
      }

      function openDeleteModal(user) {
        function deleteUser() {
          if (user.isOwner) {
            return;
          }

          user.typeUser = userService.getTypeUser(user);
          userService.removeUser(user)
            .then(function () {
              /*
              - Any deleted driver or codriver assigned to vehicles has to be
                unassigned from them.
              - Vehicle cache clearing needed for proper vehicle update after
                deletion.
              - Vehicle cache clearing performed through vehicleService.clear().
              */
              if (user.isDriver || user.isCodriver) {
                vehicleService.clear();
              }

              _deleteUser({}, {id: user.id});
            })
            .catch(function (e) {
              $log.info(e);
            });
        }

        $scope.deleteUser = deleteUser;
        ngDialog.open({
          template: 'app/settings/users/users-delete-modal.html',
          scope: $scope
        });
      }

      function openUnlockModal(user) {
        $scope.user = user;
        ngDialog.open({
          template: 'app/settings/users/users-unlock-modal.html',
          controller: 'UnlockModalController',
          controllerAs: 'vm',
          scope: $scope
        });
      }

      function downloadList() {
        if (vm.users.length === 0) {
          Toasts.push('error', $translate('Toast_users.no_users_error'));
          return;
        }

        var headers = [
          $translate('General.excel_headers_id'),
          $translate('Users.username_table_header'),
          $translate('Users.name_table_header'),
          $translate('Users.phone_table_header'),
          $translate('Users.email_table_header'),
          $translate('Users.role_table_header')
        ];

        bulkService.listUsers()
          .then(function (webUsers) {
            var usersGrid = xlsWriterService.listToGrid(webUsers, headers);
            xlsWriterService.addHeadersComments(usersGrid, [
              null,
              $translate('Users.username_table_header_comment'),
              $translate('Users.name_table_header_comment'),
              null,
              null,
              $translate('Users.role_table_header_comment')
            ]);
            var workbook = xlsWriterService.createWorkbook('Users', usersGrid);
            var file = xlsWriterService.writeWorkbook(workbook);
            fileDownloaderService.downloadXLSX(file, 'users.xlsx');
          });
      }

      function downloadTemplate() {
        var headers = [$translate('Users.username_table_header'),
                       $translate('Users.name_table_header'),
                       $translate('Users.phone_table_header'),
                       $translate('Users.email_table_header'),
                       $translate('Users.role_table_header'),
                       $translate('Users.password_table_header')];
        var usersGrid = xlsWriterService.listToGrid([], headers, false);
        xlsWriterService.addHeadersComments(usersGrid, [
          $translate('Users.username_table_header_comment'),
          $translate('Users.name_table_header_comment'),
          null,
          null,
          $translate('Users.role_table_header_comment'),
          $translate('Users.password_table_header_comment'),
        ]);
        var workbook = xlsWriterService.createWorkbook('Users', usersGrid);
        var file = xlsWriterService.writeWorkbook(workbook);
        fileDownloaderService.downloadXLSX(file, 'users_template.xlsx');
      }

      function importUsers(files) {
        var headers;
        xlsUploaderService.handleFile(files[0]).then(function (workbook) {
          if (vm.bulkCreate) {
            headers = ['username','name','phone','email','role', 'password'];
          } else {
            headers = ['id','username','name','phone','email','role'];
          }

          if (validateColumns(workbook.Sheets[workbook.SheetNames[0]], headers)) {
            var grid = xlsParserService.createGrid(workbook, headers);
            var list = xlsParserService.gridToList(grid);

            var validData = validateData(list);

            if (!validData.error) {
              var users = list;

              vm.ready = false;
              if (vm.bulkCreate) {
                vm.promiseLoading = bulkService.createUsers(users).then(
                  successBulkOperationUsers, errorBulkOperationUsers
                );
              } else {
                vm.promiseLoading = bulkService.updateUsers(users).then(
                  successBulkOperationUsers, errorBulkOperationUsers
                );
              }
            }

          } else {
            errorBulkOperationUsers({error: true, type: DATA_FORMAT_ERROR});
          }

        });

      }

      function validateColumns(sheet, headers) {
        if (sheet['!ref']) {
          var columns = XLSX.utils.decode_range(sheet['!ref']).e.c + 1;
          return columns === headers.length;
        }
        return false;
      }

      function validateData(list) {
        var errorObject = { error: false };
        if (vm.bulkCreate) {

          var duplicatedUsername = validateUniqueUsernames(list);
          if (duplicatedUsername) {
            errorObject.error = true;
            errorObject.type = DUPLICATED_USERNAME_ERROR;
            errorObject.username = duplicatedUsername;
          }
          var duplicatedEmail = validateUniqueEmails(list);
          if (duplicatedEmail) {
            errorObject.error = true;
            errorObject.type = DUPLICATED_EMAIL_ERROR;
            errorObject.email = duplicatedEmail;
          }
        } else {

          if (!validateUserIds(list)) {
            errorObject.error = true;
            errorObject.type = INVALID_ID_ERROR;
          } else {
            // Subsequent validations.
            var duplicatedUsername = validateUniqueUsernames(list);
            if (duplicatedUsername) {
              errorObject.error = true;
              errorObject.type = DUPLICATED_USERNAME_ERROR;
              errorObject.username = duplicatedUsername;
            }
            var duplicatedEmail = validateUniqueEmails(list);
            if (duplicatedEmail) {
              errorObject.error = true;
              errorObject.type = DUPLICATED_EMAIL_ERROR;
              errorObject.email = duplicatedEmail;
            }
          }

        }
        if (errorObject.error) {
          errorBulkOperationUsers(errorObject);
        }
        return errorObject;

      }

      function validateUniqueUsernames(users) {
        var duplicatedUsername = '';
        lodash.every(users, function (user) {
          var vmUsers = Array.from(vm.users);
          // Remove current user on update.
          if (!vm.bulkCreate) {
            lodash.remove(vmUsers, function(vmUser) {
              return vmUser.id == user.id;
            });
          }
          if (lodash.findIndex(vmUsers, {username: user.username}) === -1) {
            return true;
          } else {
            duplicatedUsername = user.username;
            return false;
          }
        });
        return duplicatedUsername;
      }

      function validateUniqueEmails(users) {
        var duplicatedEmail = '';
        lodash.every(users, function (user) {
          var vmUsers = Array.from(vm.users);
          // Remove current user on update.
          if (!vm.bulkCreate) {
            lodash.remove(vmUsers, function(vmUser) {
              return vmUser.id == user.id;
            });
          }
          if (lodash.findIndex(vmUsers, {email: user.email}) === -1) {
            return true;
          } else {
            duplicatedEmail = user.email;
            return false;
          }
        });
        return duplicatedEmail;
      }

      function validateUserIds(list) {
        return list.every(function(userToAdd) {
          return vm.users.find(function(user) {
            return user.id === parseInt(userToAdd.id);
          });
        });
      }

      function successBulkOperationUsers(response) {
        vm.ready = true;
        if (response) {_sendInfo(response);}
        Toasts.push('success', $translate('Toast_users.successful_import'));
        vm.promiseLoading = userService.listUsers().then(successListUsers, errorListUsers);
        var sessionUserPromise = sessionService.getUser().then(
          successRetrieveUser, errorRetrieveUSer
        );
        $q.all([vm.promiseLoading, sessionUserPromise])
          .then(function(results) {
            vm.users = orderUsersSettingsFilter(results[0], results[1]);
            createSafeList();
            vm.showNotUsersMessage = !vm.safeSrcUsers.length;
          });
      }

      function errorBulkOperationUsers(error) {
        vm.ready = true;
        if (error && !error.error) { _sendInfo(error); }
        var errorMessage;
        switch (error.type) {
          case INVALID_ID_ERROR:
            errorMessage = $translate('Toast_users.invalid_id_error');
            break;
          case DATA_FORMAT_ERROR:
            errorMessage = $translate('Toast_users.data_format_error');
            break;
          case DUPLICATED_USERNAME_ERROR:
            errorMessage = $translate('Toast_users.duplicate_username_error_1') +
              ' "' + error.username +
              '" ' + $translate('Toast_users.duplicate_username_error_2');
            break;
          case DUPLICATED_EMAIL_ERROR:
            errorMessage = $translate('Toast_users.duplicate_email_error_1') +
              ' "' + error.email +
              '" ' + $translate('Toast_users.duplicate_email_error_2');
            break;
          default:
            errorMessage = $translate('Toast_users.unsuccessful_import');
            break;
        }
        Toasts.push('error', errorMessage);
      }

      function _sendInfo(response) {
        var title = vm.bulkCreate ? 'Respuesta carga masiva de usuarios' : 'Respuesta edición masiva de usuarios';
        var fields = vm.bulkCreate ? ['username','name','phone','email','role', 'password']
          :['id','username','name','phone','email','role'];

        var info = {
          fields: JSON.stringify(fields)
        };

        if(response.data ) {
          info["details"] = JSON.stringify(response.data);
          info["http_code"] = response.status;
          info["count"] = response.config.data.length;
        }else {
          info["http_code"] = 200;
          info["count"] = vm.bulkCreate ?  response["users_uploaded"].length : response["users_updated"].length;
          info["ids"] = vm.bulkCreate ? JSON.stringify(response["users_uploaded"]) :
          JSON.stringify(response["users_updated"]);
        }
      }
    }
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .controller('UsersDetailController', UsersDetailController);

  /** @ngInject */
  function UsersDetailController($log, $scope, $filter, $state, $stateParams, $timeout,
                                 userService, sessionService, ngDialog,
                                 Toasts, driversService, chatService,
                                 accountConfigsService, store, securityService,
                                 vehicleService, USER_ROLE, plannerService) {

    var vm = this;
    vm.userOwner = false;
    vm.showViewAdmin = false;
    vm.changePassword = false;
    vm.moreInfo = false;

    vm.user = {typeUser: 'driver'};
    vm.user.password = {};
    vm.user.newPassword = {};
    vm.user.confirmNewPassword = {};
    vm.user.phoneIsValid = true;

    vm.state = $state;
    vm.stateParams = $stateParams;

    vm.save = save;
    vm.cancel = cancel;
    vm.getUser = getUser;
    vm.deleteUser = deleteUser;
    vm.checkUsername = checkUsername;
    vm.changeTypeInput = changeTypeInput;
    vm.showDeleteModal = showDeleteModal;
    vm.supportsPassword = supportsPassword;
    vm.isDriverOrCodriver = isUserDriverOrCodriver;
    vm.validatePassword = validatePassword;
    vm.changePolicies = changePolicies;
    vm.enableCoordinator = false;
    vm.canCreateRouterJr = false;
    vm.canCreateCoDriver = false;
    vm.ssoUsers = false;
    vm.policies = {};
    vm.validation = {};

    vm.isAdmin = {value: false, id: ''};
    vm.isDriver = {value: false, id: ''};
    vm.isCodriver = {value: false, id: ''};
    vm.isOwner = {value: false, id: ''};
    vm.isCoordinator = {value: false, id: ''};
    vm.isRouter = {value: false, id: ''};
    vm.isRouterJr = {value: false, id: ''};

    var $translate = $filter('translate');
    var passwordStates = {
      value: null,
      type: 'password',
      error: null,
      error_txt: null,
      success_txt: null
    };
    var originalStateOfUser = {};

    activate();

    $scope.$watch('vm.user.username', function () {
      if (angular.isDefined(vm.user.username) && vm.user.username !== null) {
        vm.user.username = vm.user.username.toLowerCase();
      }
    });

    function activate() {
      vm.canCreateRouterJr = accountConfigsService.getValueByKeyFrom(
        'can_create_router_jr',
        store.get('accountConfigs')
      );
      vm.canCreateCoDriver = accountConfigsService.getValueByKeyFrom(
        'can_create_co_driver',
        store.get('accountConfigs')
      );
      vm.ssoUsers = accountConfigsService.getValueByKeyFrom(
        'sso_users',
        store.get('accountConfigs')
      );
      angular.extend(vm.user.newPassword, passwordStates);
      angular.extend(vm.user.confirmNewPassword, passwordStates);
      if (vm.stateParams.userId) {
        vm.getUser(Number(vm.stateParams.userId));
      }
      sessionService.getUser()
        .then(function success(user) {
          if (user.is_owner) {
            vm.isOwner.value = true;
            vm.isOwner.id = user.id;
          } else if (user.is_coordinator) {
            vm.isCoordinator.value = true;
            vm.isCoordinator.id = user.id;
          } else if (user.is_admin) {
            vm.isAdmin.id = user.id;
            vm.isAdmin.value = true;
          } else if (user.is_router) {
            vm.isRouter.id = user.id;
            vm.isRouter.value = true;
          } else if (user.is_router_jr) {
            vm.isRouterJr.id = user.id;
            vm.isRouterJr.value = true;
          }

        }, function error(e) {
          $log.info(e);
        });
      vm.enableCoordinator = shouldEnableCoordinator();
      _getSecuritySetting();
      showPoliciesInForm();
    }

    function getUser(userId) {
      userService.getUserById(userId)
        .then(function (user) {
          originalStateOfUser = user;
          vm.user = angular.copy(user);
          vm.user.newPassword = {};
          vm.user.confirmNewPassword = {};
          angular.extend(vm.user.newPassword, passwordStates);
          angular.extend(vm.user.confirmNewPassword, passwordStates);
          var typeUser = userService.getTypeUser(user);
          vm.user.typeUser = typeUser;
          originalStateOfUser.typeUser = typeUser;
        })
        .catch(function (error) {
          $log.info(error);
          Toasts.push('error', 'Usuario no existe');
          $state.go('^');
        });
    }

    function save() {
      var updatingUser = !!vm.stateParams.userId;
      if (!_validateFormAndDisplayErrors()) {
        var details = 'Invalid values:';
        if (vm.user.usernameRequired) { details += ' Username'; }
        if (vm.user.nameRequired) { details += ' Name'; }
        if (vm.user.emailRequired) { details += ' Email'; }
        if (vm.user.passwordRequired) { details += ' Password'; }
        if (!vm.user.phoneIsValid) { details += ' Phone'; }
        return;
      }

      updatingUser ? _updateUser() : _createUser();
    }

    function changeTypeInput(obj) {
      obj.type === 'password' ? obj.type = 'text' : obj.type = 'password';
    }

    function checkUsername(user) {
      if (!!user.username) {
        driversService.checkUsername(user)
          .then(_successChecked)
          .catch(_errorChecked);
      } else {
        vm.user.usernameDuplicated = false;
      }

      function _successChecked(response) {
        response.data.exist ? vm.user.usernameDuplicated = true : vm.user.usernameDuplicated = false;
      }

      function _errorChecked() {
      }
    }

    function deleteUser() {
      if (vm.user.isOwner) {
        vm.errorDeleteOwner = true;
        return;
      }

      userService.removeUser(originalStateOfUser)
        .then(function (response) {
          $scope.$emit('DELETE_USER', response);
          /*
          - Any deleted driver or codriver assigned to vehicles has to be
            unassigned from them.
          - Vehicle cache clearing needed for proper vehicle update after
            deletion.
          - Vehicle cache clearing performed through vehicleService.clear().
          */
          if (originalStateOfUser.isDriver || originalStateOfUser.isCodriver) {
            vehicleService.clear();
          }

          $state.go('^');
        })
        .catch(function (e) {
          $log.info(e);
        });
    }

    function showDeleteModal() {
      $scope.deleteUser = deleteUser;
      ngDialog.open({
        template: 'app/settings/users/users-delete-modal.html',
        scope: $scope
      });
    }

    function cancel() {
      vm.state.go('^');
    }

    function isUserDriverOrCodriver(user) {
      return user.typeUser === 'driver' || user.typeUser === 'codriver';
    }

    function supportsPassword(user) {
      return !vm.ssoUsers || isUserDriverOrCodriver(user);
    }

    function _validateFormAndDisplayErrors() {
      var continueProcess = true;
      vm.user.passwordRequired = false;

      if (vm.user.phone) {
        if (!vm.user.phoneIsValid) {
          var phone = vm.user.phone.split('+')[1];
          try {
            var code = bcCountries.getDialCodeByDigits(phone);
            if (code === phone) {
              vm.form.$valid = true;
              vm.form.$invalid = false;
            } else {
              vm.form.$valid = false;
              vm.form.$invalid = true;
            }
            vm.user.phoneIsValid = vm.form.$valid;
            continueProcess = vm.form.$valid;
          } catch (e) {
            vm.form.$invalid = true;
            continueProcess = false;
          }
        }
      }
      if (!vm.user.username) {
        vm.user.usernameRequired = true;
        continueProcess = false;
      }
      if (!vm.user.name) {
        vm.user.nameRequired = true;
        continueProcess = false;
      }
      if (vm.ssoUsers && !isUserDriverOrCodriver(vm.user) && (!vm.form.email.$valid || !vm.user.email)) {
        vm.user.emailRequired = true;
        continueProcess = false;
      }
      if ((!vm.stateParams.userId || vm.changePassword) && supportsPassword(vm.user)) {
        if (securityService.formPasswordValidation(vm.validation)) {
          vm.user.passwordRequired = true;
          continueProcess = false;
        }
      }

      return continueProcess;
    }

    function _createUser() {
      var requiresPassword = supportsPassword(vm.user);

      if (requiresPassword && vm.user.newPassword.value !== vm.user.confirmNewPassword.value) {
        vm.errorMatchPassword = true;
        $timeout(function () {
        }, 4000).then(function () {
          vm.errorMatchPassword = false;
        });
        return;
      }

      vm.user.password = requiresPassword ? vm.user.newPassword.value : null;
      userService.createUser(vm.user)
        .then(function (user) {
          chatService.notifyUserCreated(user);
          vm.state.go('^');
          $scope.$emit('SAVE_USER', user);
        }, function (error) {
          var details = '';
          if (error.status === 400) {
            if (error.data.email) {
              vm.user.emailError = true;
              details += error.data.email[0];
            }
            if (error.data.username) {
              vm.user.usernameError = true;
              details += error.data.username[0];
            }
          }
          if (error.data.non_field_errors) {
            details += error.data.non_field_errors[0];
          }
        })
        .finally(function () {
          $timeout(function () {
          }, 4000).then(function () {
            vm.user.usernameError = false;
            vm.user.emailError = false;
          });
        });
    }

    function _updateUser() {
      var canUpdatePassword = supportsPassword(vm.user);

      if (canUpdatePassword && vm.changePassword && vm.user.newPassword.value !== vm.user.confirmNewPassword.value) {
        vm.errorMatchPassword = true;
        $timeout(function () {
        }, 3000).then(function () {
          vm.errorMatchPassword = false;
        });
        return;
      }

      vm.user.password = canUpdatePassword && vm.changePassword ? vm.user.newPassword.value : null;
      userService.updateUser(vm.user)
        .then(function (user) {
          $scope.$emit('SAVE_USER', user);
          /*
          - If any driver or codriver is already assigned to vehicles and changes its role,
            it has to be unassigned from them.
          - Vehicle cache clearing needed for proper vehicle update after role change.
          - Vehicle cache clearing performed through vehicleService.clear().
          */
          var wasDriverChanged = originalStateOfUser.isDriver && vm.user.typeUser !== USER_ROLE.DRIVER;
          if (wasDriverChanged) {
            vehicleService.clear();
            plannerService.removeDriver(String(originalStateOfUser.id));
          }

          var wasCodriverChanged = originalStateOfUser.isCodriver && vm.user.typeUser !== USER_ROLE.CODRIVER;
          if (wasCodriverChanged) {
            vehicleService.clear();
            plannerService.removeCodriver(String(originalStateOfUser.id));
          }

          vm.state.go('^');
        }, function (error) {
          var details = '';
          if (error.data.email) {
            vm.user.emailError = true;
            details += error.data.email[0];
          }
          if (error.data.username) {
            vm.user.usernameError = true;
            details += error.data.username[0];
          }
          if (error.data.non_field_errors) {
            details += error.data.non_field_errors[0];
          }
        })
        .finally(function () {
          $timeout(function () {
          }, 3000).then(function () {
            vm.errorUpdate = false;
            vm.user.usernameError = false;
            vm.user.emailError = false;
          });
        });
    }

    function shouldEnableCoordinator() {
      return !!store.get('accountConfigs').find(function (config) {
        return config.key === 'enable_plans' && config.value;
      });
    }

    function changePolicies() {
      _getSecuritySetting();
      vm.user.newPassword.value = "";
      vm.user.confirmNewPassword.value = "";
    }

    function _getSecuritySetting() {
      securityService.get({}).then(function (res) {
        if (res.status !== 200) {
          vm.policies = {
            "length": 8,
            "uppercase": false,
            "lowercase": false,
            "number": false,
            "symbol": false,
          };
        } else {
          var driver = isUserDriverOrCodriver(vm.user);
          securityService.buildBodyToShow(res.data, driver, vm.policies);
        }
        securityService.buildValidation(vm.validation, vm.policies);
        if (res.status !== 204 && res.status !== 200) {
          throw 'Unexpected response status: ' + res.status;
        }
      }).catch(function (err) {
        Toasts.push('error', $translate('Security.settings_retrieval_error'));
        $log.error(err);
      });
    }

    function validatePassword() {
      securityService.validatePassword(vm.user.newPassword.value, vm.validation, vm.policies);
    }

    function showPoliciesInForm() {
      var form = document.getElementById('user-detail-form');
      var input = document.getElementById('user-detail-password');
      var policies = document.getElementById('user-detail-policies');
      var exceptions = document.getElementsByClassName('except_policies_hidden');
      if (form !== null && input !== null && policies !== null && exceptions !== null) {
        input.addEventListener('focus', function (event) {
          policies.style.display = "block";
        });
        form.addEventListener('click', function (event) {
          for (var i = 0; i < exceptions.length; i++) {
            if (exceptions[i] === event.target) {
              return;
            }
            ;
          }
          policies.style.display = "none";
        });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .controller('UnlockModalController', UnlockModalController);

  /** @ngInject */
  function UnlockModalController($scope, userService, Toasts, $filter) {
    var vm = this;
    var $translate = $filter('translate');

    vm.user = $scope.user;
    vm.emailCopy = vm.user.email;
    vm.emailInputEnabled = !vm.user.email;
    vm.editEmail = editEmail;
    vm.unlockUser = unlockUser;

    function editEmail() {
      vm.emailInputEnabled = true;
    }

    function unlockUser() {
      if (!vm.form.email.$valid) {
        return;
      }
      var requestData = {
        user: vm.user.id
      };
      if (vm.emailCopy !== vm.user.email) {
        requestData.email = vm.emailCopy;
      }
      userService.unlockUser(requestData)
        .then(function (response) {
          vm.user.email = vm.emailCopy;
          Toasts.push('success', $translate('Drivers.unlock_user_success'));
        }, function (error) {
          Toasts.push('error', $translate('Drivers.unlock_user_error'));
        });
      $scope.closeThisDialog(0);
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.settings")
    .controller("AccountController", AccountController);

  /** @ngInject */
  function AccountController(
    sessionService,
    $q,
    accountConfigsService,
    $log,
    $rootScope,
    $filter,
    Toasts,
    ACCOUNT_CONFIGS
  ) {
    var vm = this;
    var $translate = $filter("translate");

    var CONFIGS = [
      ACCOUNT_CONFIGS.SEND_GPS,
      ACCOUNT_CONFIGS.ENABLE_OBSERVATIONS,
    ];

    vm.SEND_GPS = ACCOUNT_CONFIGS.SEND_GPS;
    vm.ENABLE_OBSERVATIONS = ACCOUNT_CONFIGS.ENABLE_OBSERVATIONS;

    vm.accountConfigs = {};

    vm.saveAccountConfigs = saveAccountConfigs;

    activate();

    function activate() {
      return accountConfigsService
        .getAllPublicConfigs()
        .then(function (publicConfigs) {
          CONFIGS.forEach(function (config) {
            if (publicConfigs.hasOwnProperty(config)) {
              vm.accountConfigs[config] = publicConfigs[config];
            }
          });
        });
    }

    function _saveAllConfigs(configsRequest) {
      return sessionService.saveAccountConfigs(configsRequest);
    }

    function saveAccountConfigs() {
      var request = [];
      $rootScope.isLoading = true;
      for (var item in vm.accountConfigs) {
        request.push({
          key: item,
          value: vm.accountConfigs[item],
        });
      }

      return _saveAllConfigs(request)
        .then(function (response) {
          $log.info(response);
          Toasts.push("success", $translate("Account.configs_saved_success"));
        })
        .catch(function (error) {
          $log.info(error);
          Toasts.push("error", $translate("Account.configs_saved_fail"));
        })
        .finally(function () {
          $rootScope.isLoading = false;
        });
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('icarus.settings')
    .controller('BillingUpgradeController', BillingUpgradeController);

  /** @ngInject */
  function  BillingUpgradeController ($log, $http, $state, user, vehicles,
                                sessionService, Vehicle, AMOUNT_PER_VEHICLE) {
    var vm = this;

    vm.AMOUNT_PER_VEHICLE = AMOUNT_PER_VEHICLE;

    vm.user = user;
    vm.vehiclesQty = null;
    vm.minVehiclesQty = null;
    vm.upgrading = false;
    vm.upgraded = false;

    vm.processUpgrade = processUpgrade;

    var currentVehiclesQty;

    activate();

    ////////////

    function activate () {
      if (user.account.status === 'active') {
        $state.go('^.info');
      }

      currentVehiclesQty = vehicles.length;
      vm.vehiclesQty = currentVehiclesQty;
      if (vm.vehiclesQty === 0) {
        vm.vehiclesQty = 1;
      }
      vm.minVehiclesQty = vm.vehiclesQty;
    }

    function processUpgrade(stripe_data) {
      vm.upgrading = true;
      sessionService.setSubscription(vm.vehiclesQty, stripe_data.id)
      .then(function processUpgradeSuccess() {
        vm.upgraded = true;
        if (currentVehiclesQty < vm.vehiclesQty) {
          for (var i = currentVehiclesQty + 1; i < vm.vehiclesQty + 1; i++) {
            Vehicle.create({name: 'Vehicle ' + i, capacity: 1});
          }
        }
        $state.go('^.info');
      }).catch(function processUpgradeError(error) {
          // Toasts.push('error', error[0]);
        }
      ).finally(function () {
        vm.upgrading = false;
      });
    }

  }
})();

(function(){
  'use strict';

  angular
    .module('icarus.settings')
    .controller('BillingInfoController', BillingInfoController);

  /** @ngInject */
  function  BillingInfoController ($http, $log, $window, moment,
                             user, sessionService) {
    var vm = this;

    vm.user = user;
    vm.trialExpireTime = null;
    vm.processChangeCard = processChangeCard;
    vm.cancel = cancel;

    activate();

    ////////////

    function activate () {
      vm.trialExpireTime = vm.user.account.active_until.fromNow();
      vm.nextBillingCycle = vm.user.account.active_until.format('LL');
    }

    function processChangeCard (stripe_data) {
      vm.changingCard = true;
      sessionService.setSubscription(vm.user.account.plan_quantity, stripe_data.id).then(
        function processChangeCardSuccess () {
        }
      ).catch(function processChangeCardError (error) {
        // Toasts.push('error', error[0]);
      })
      .finally(function () {
        vm.changingCard = false;
      });
    }

    function cancel() {
      vm.canceling = true;
      sessionService.cancelSubscription()
      .catch(function (error) {
        // Toasts.push('error', error[0]);
      })
      .finally(function () {
        vm.canceling = false;
      });
    }

  }
})();

(function(){
  'use strict';

  angular
    .module('icarus.settings')
    .controller('BillingChangePlanController', BillingChangePlanController);

  /** @ngInject */
  function  BillingChangePlanController (  $state, user, vehicles,
                                   sessionService, AMOUNT_PER_VEHICLE) {
    var vm = this;

    vm.AMOUNT_PER_VEHICLE = AMOUNT_PER_VEHICLE;

    vm.vehiclesQty = null;
    vm.minVehiclesQty = null;
    vm.updating = false;

    vm.updatePlan = updatePlan;

    activate();

    ////////////

    function activate () {
      vm.vehiclesQty = user.account.plan_quantity;
      vm.minVehiclesQty = vehicles.length;
    }

    function updatePlan(quantity) {
      vm.updating = true;
      sessionService.setSubscription(quantity)
      .then(function updatePlanSuccess() {
        $state.go('^.info');
      }).catch(function updatePlanError(error) {
          // Toasts.push('error', error[0]);
        }
      ).finally(function () {
        vm.updating = false;
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .controller('CommunicationController', CommunicationController);

  /** @ngInject */
  function CommunicationController(sessionService, addonsService, accountConfigsService, $log, $state, $filter, $scope, ngDialog, __env, $sce, $q,
      elementsService
  ) {
    var vm = this;
    var key = 'live_tracking';
    var $translate = $filter('translate');
    var logoPath = __env.URL_ROOT + 'assets/images/simpliroute_logo.png';
    var liveTrackingPath = __env.LIVE_TRACKING_URL + 'widget/';

    var onItsWayEvent = {
      label: $translate('Communication.on_its_way'), propertyKey: 'on_its_way', addonId: '',
      sms: {id: '', value: '', key: 'on_its_way_sms_body'},
      email: {id: '', value: '', key: 'on_its_way_email_body'},
      wsp: {id: '', value: '', key: 'on_its_way_wsp_body'},
    };

    vm.state = $state;
    vm.activeRows = {};
    vm.ready = false;

    vm.addonProperties = [{
      label: $translate('Communication.visit_scheduled'), propertyKey: 'visit_scheduled', addonId: '',
      sms: {id: '', value: '', key: 'visit_scheduled_sms_body'},
      email: {id: '', value: '', key: 'visit_scheduled_email_body'},
      wsp: {id: '', value: '', key: 'visit_scheduled_wsp_body'}
    }, {
      label: $translate('Communication.route_started'), propertyKey: 'route_started', addonId: '',
      sms: {id: '', value: '', key: 'route_started_sms_body'},
      email: {id: '', value: '', key: 'route_started_email_body'},
      wsp: {id: '', value: '', key: 'route_started_wsp_body'},
    }, {
      label: $translate('Communication.checkout_success'), propertyKey: 'checkout_success', addonId: '',
      sms: {id: '', value: '', key: 'checkout_success_sms_body'},
      email: {id: '', value: '', key: 'checkout_success_email_body'},
      wsp: {id: '', value: '', key: 'checkout_success_wsp_body'}
    }, {
      label: $translate('Communication.checkout_failed'), propertyKey: 'checkout_failed', addonId: '',
      sms: {id: '', value: '', key: 'checkout_failed_sms_body'},
      email: {id: '', value: '', key: 'checkout_failed_email_body'},
      wsp: {id: '', value: '', key: 'checkout_failed_wsp_body'}
    }
    ];

    vm.changeStateToDetail = changeStateToDetail;
    vm.showWidgetModal = showWidgetModal;
    vm.saveCustomTrackingConfig = saveCustomTrackingConfig;
    vm.customTrackingCode = false;
    vm.onItsWayEnabled = false;
    vm.enableSms = false;
    vm.enableWsp = false;
    vm.email = false;
    vm.name = false;
    vm.msg = false;
    vm.disableMsg = disableMsg;
    vm.saveProperty = saveProperty;

    vm.addonsProps = {
      email_from_name: {
        id: '',
        addonId: '',
        key: 'email_from_name',
        value: '',
        title: 'titulo del email from_name property',
        description: 'descripcion del email from_name property'
      },
      email_from_email: {
        id: '',
        addonId: '',
        key: 'email_from_email',
        value: '',
        title: 'titulo del email from_email property',
        description: 'descripcion del email from_email property'
      }
    };

    var customTrackingCodeElement = document.getElementById("toggle-button-custom-tracking-code");
    elementsService.attachEvent(customTrackingCodeElement, "change", vm.saveCustomTrackingConfig);

    activate();

    $scope.$on('UPDATE_PROPERTIES', _updateProperties);
    $scope.$on('DELETE_PROPERTY', _deleteProperty);
    $scope.$on('DEACTIVATE_ROWS', _deactivateRows);


    ////////////

    function onItsWayEnabled (value) {
      if (value) {
        vm.addonProperties.push(onItsWayEvent);
      }
    }

    function activate() {
      addonsService.getInfoAddonAndPropertiesByKey(key)
        .then(function (info) {
          return accountConfigsService.getConfigByKey('on_its_way_enabled')
            .then(function (value) {
              onItsWayEnabled(value);
              _setValuesToProperties(info);
              setValuesProps(info);
              vm.ready = true;
            });
        }).catch(function (error) {
        $log.error(error);
        vm.ready = true;
      });

      accountConfigsService.getConfigByKey('custom_tracking_code')
        .then(function (value) {
          vm.customTrackingCode = value;
          customTrackingCodeElement.checked = vm.customTrackingCode;
        });

      accountConfigsService.getConfigByKey('enable_sms')
        .then(function (value) {
          vm.enableSms = value;
        });

      accountConfigsService.getConfigByKey('enable_wsp')
        .then(function (value) {
          vm.enableWsp = value;
        });
    }

    function saveCustomTrackingConfig(event) {
      vm.customTrackingCode = event.detail;
      accountConfigsService.createOrSaveConfigs({
        key: 'custom_tracking_code',
        value: vm.customTrackingCode
      });
    }

    function changeStateToDetail(addonId, propertykey) {
      vm.activeRows = {};
      vm.state.go('settings.communication.detail', {addonId: addonId, addonPropertyKey: propertykey});
      vm.activeRows[propertykey] = true;
    }



    function _setValuesToProperties(info) {
      vm.addonProperties.forEach(function (localProperty) {
        localProperty.addonId = info.addon.id;
        info.properties.forEach(function (property) {
          if (localProperty.sms.key === property.key) {
            localProperty.sms.value = property.value;
            localProperty.sms.id = property.id;
          } else if(localProperty.email.key === property.key) {
            localProperty.email.value = property.value;
            localProperty.email.id = property.id;
          } else if(localProperty.wsp.key === property.key) {
            localProperty.wsp.value = property.value;
            localProperty.wsp.id = property.id;
          }
        });
      });

      var firstInKeyOrder = ["visit_scheduled", "route_started", "on_its_way", "checkout_success", "checkout_failed"];
      firstInKeyOrder.reverse().forEach(function(key) {
        var j = vm.addonProperties.findIndex(function (property) {
          return property.propertyKey === key;
        });
        if (angular.isDefined(j)) {
          for (var i = j; i > 0; --i) {
            var t = vm.addonProperties[i - 1];
            vm.addonProperties[i - 1] = vm.addonProperties[i];
            vm.addonProperties[i] = t;
          }
        }
      });
    }

    function setValuesProps(info) {
      Object.keys(vm.addonsProps).forEach(function (key) {
        var prop = vm.addonsProps[key];
        prop.addonId = info.addon.id;
        info.properties.forEach(function (property) {
          if(prop.key === property.key) {
            prop.id = property.id;
            prop.value = property.value;
          };
        });
      });
    };

    function _updateProperties(event, properties) {
      properties.forEach(function (item) {
        // Obtener la propieda al actualizar del arreglo vm.addonProperties
        if (item) {
          var property = _getPropertyLocalByKey(item.key);
          if (property) {
            vm.addonProperties[property.index][property.key].value = item.value;
            vm.addonProperties[property.index][property.key].id = item.id;
          }
        }
      });
    }

    function _deleteProperty(event, key) {
      var item = _getPropertyLocalByKey(key);
      if (item) {
        vm.addonProperties[item.index][item.key].value = '';
      }
    }

    function _getPropertyLocalByKey(item) {
      var key, index = null;

      for (var i = 0; i < vm.addonProperties.length; i++) {
        if (item.includes(vm.addonProperties[i].propertyKey)) {
          if(item === vm.addonProperties[i].sms.key) {
            key = 'sms';
            index = i;
            break;
          } else if (item === vm.addonProperties[i].email.key) {
            key = 'email';
            index = i;
            break;
          } else if (item === vm.addonProperties[i].wsp.key) {
            key = 'wsp';
            index = i;
            break;
          }
        }
      }
      var response = null;
      if(!(angular.isUndefined(index) || index === null ) && key) {
        response = {index: index, key: key};
      }

      return response;
    }

    function _deactivateRows() {
      vm.activeRows = {};
    }

    function setWidgetCode(idAccount) {
      var accountStr = idAccount.toString();
      return $sce.trustAsHtml('<div style="width: 300px; display: flex; flex-direction: column; align-items: center;">' +
        '<form style="display: flex; margin-bottom: 10px;" onsubmit="sendForm()" name="sp-tracking-code-search" id="sp-tracking-code-search" target="_blank">' +
        '<input title="code" id="tracking-code" style="width: 200px; height: 30px; border: 1px solid #73768C; border-radius: 5px; margin-right: 5px;">' +
        '<button type="button" style="color: #fff; background-color: #4C3BEF; border: 0; border-radius: 5px; font-size: 12px; font-family: sans-serif;"' +
        'onclick="sendForm()" id="send" name="send">' +
        $translate('Communication.search') +
        '</button>' +
        '</form>' +
        '<div style="color: black; font-size: 10px; display: flex; width: 100%; justify-content: center; align-items: center;">' +
        '<span style="font-family: sans-serif; margin-right: 10px;">Powered by </span>' +
        '<a href="http://simpliroute.com"><img style="width: 100px" src="' + logoPath + '\"/></a>' +
        '</div>' +
        '<script>' +
        "function sendForm(){" +
        "var form = document.getElementById('sp-tracking-code-search');" +
        "var input = document.getElementById('tracking-code');" +
        "var code = input.value;" +
        "form.action = '" + liveTrackingPath + 'account/' + accountStr + '/tracking/' + "' + code" + ";" +
        "form.submit();" +
        "}" +
        '</script>' +
        '</div>');
    }


    function showWidgetModal() {
      sessionService.getUser().then(function (user) {
        if (user) {
          $scope.widgetCode = setWidgetCode(user.account.id);
          ngDialog.open({
            template: 'app/settings/communication/widget-code-modal.html',
            className: 'ngdialog-theme-default custom-width-800',
            scope: $scope
          });
        }
      });
    }

    function saveProperty() {
      var promises = [];
      Object.keys(vm.addonsProps).forEach(function (key) {

        var property = vm.addonsProps[key];
        property.add_on_id = property.addonId;

        if (property.id) {
          updateProperty(promises, property);
        } else {
          createProperty(promises, property);
        }
      });

      $q.all(promises)
        .then(function (data) {
          $log.info(data);
          editMessage(data);
          updateData(data);
        }).catch(function (error) {
        $log.error(error);
      });
    }

    function editMessage(data){
      data.forEach(function(addon){
        if(addon.value !== ''){
          if(addon.key === 'email_from_name'){
            vm.name = true;
          }else if(addon.key === 'email_from_email'){
            vm.email = true;
          }
        }
      });

      if(vm.name || vm.email){
        vm.msg = true;
      }
      clearNameEmail();
    }

    function clearNameEmail(){
      vm.name = false;
      vm.email = false;
    }

    function disableMsg(){
      vm.msg = false;
    }

    function updateData(data){
      data.forEach(function(addon){
        vm.addonsProps[addon.key].id = addon.id;
      });
    }

    function updateProperty(promises, property) {
      promises.push(addonsService.updateAddonProperty(property));
    }

    function createProperty(promises, property) {
      if (property.title && property.description && property.value) {
        promises.push(addonsService.createAddonProperty(property));
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .controller('CommunicationDetailController', CommunicationDetailController);

  /** @ngInject */
  function CommunicationDetailController($scope, $sanitize, $q, $state, $stateParams, sessionService, ngDialog, $log, __env, ACCOUNT_CONFIGS,
    addonsService, $filter, extraFieldsService, Toasts, accountConfigsService, MAX_PREVIEW_EMAILS_INPUT, JOINED_EMAILS_MAX_LENGTH) {

    var $translate = $filter('translate');

    var vm = this;

    var base64map = "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";

    var latinMap = JSON.parse(decodeURIComponent(escape(atob(base64map))));
    var DEFAULT_TIME = '08:00 - 10:00';
    var ETA_CONFIGURATION = 'ETA_live_tracking_configs';

    var draftWsp = {
      address: "Pasaje  #1343",
      etaRange: "18:00",
      accountName: "",
      trackingNumber: "R123213C321",
      idReference: "SKU123213C321",
      visitTitle: "Nombre cliente"
    };

    vm.getIterations = function(num) {
        return new Array(num);
    };

    vm.whatsappTemplateQuantity = {
      visit_scheduled:
        {
          orders: 2,
          services: 3,
          visits: 3
        },
      route_started:
        {
          orders: 4,
          services: 6,
          visits: 6
        },
      on_its_way:
        {
          orders: 2,
          services: 6,
          visits: 6
        },
      checkout_success:
        {
          orders: 2,
          services: 6,
          visits: 6
        },
      checkout_failed:
        {
          orders: 2,
          services: 6,
          visits: 6
        }
    };

    vm.tabWsp = false;
    vm.tabSms = false;
    vm.tabEmail = true;

    vm.etaEnabled = false;
    vm.enableSms = false;
    vm.enableWsp = false;
    vm.enableVisitItems = false;
    vm.deleteWsp = true;
    vm.showWspTemplates = showWspTemplates;
    vm.buildWspTemplate = buildWspTemplate;
    vm.templatesToShow = {
      orders: false,
      services: false,
      visits: false
    };

    vm.counter = 0;

    vm.addonPropertyKey = '';
    vm.sendAttachment = {
      init: false,
      value: false
    };

    vm.properties = {
      wspBody: {
        id: null,
        addonId: $stateParams.addonId,
        key: $stateParams.addonPropertyKey + '_wsp_body',
        value: '',
        title: 'titulo del wsp property',
        description: 'descripcion del wsp property'
      },
      smsBody: {
        id: null,
        addonId: $stateParams.addonId,
        key: $stateParams.addonPropertyKey + '_sms_body',
        value: '',
        title: 'titulo del sms property',
        description: 'descripcion del sms property'
      },
      emailSubject: {
        id: null,
        addonId: $stateParams.addonId,
        key: $stateParams.addonPropertyKey + '_email_subject',
        value: '',
        title: 'titulo del email subject property',
        description: 'descripcion del email subject property'
      },
      emailBody: {
        id: null,
        addonId: $stateParams.addonId,
        key: $stateParams.addonPropertyKey + '_email_body',
        value: '',
        title: 'titulo del email body property',
        description: 'descripcion del email body property'
      }
    };

    var renderingTypeProperties = {
      id: null,
      addonId: $stateParams.addonId,
      key: $stateParams.addonPropertyKey + '_email_rendering_type',
      title: 'Tipo de rederizado',
      value: 'html',
      description: 'Tipo de renderizado, HTML o PDF'
    };

    vm.emailPropertiesAttachment = {
      images: {
        id: null,
        addonId: $stateParams.addonId,
        key: $stateParams.addonPropertyKey + '_email_attachment_images',
        title: 'Imagenes de la visita',
        value: 'Imagenes',
        description: 'Imagenes'
      }
    };

    vm.tags = {
      TRACKING_URL: {
        id: '{TRACKING_URL}',
        label: 'TrackingUrl',
        values: {
          sms: 'https://kaduh6.info/QC1pP1X',
          email: 'https://tracking.dev.simpliroute.com/#/tracking/SR12345678910111'
        },
        propertyKeys: {
          visit_scheduled: true,
          route_started: true,
          checkout_success: true,
          checkout_failed: true,
          on_its_way: true
        },
        checked: false
      },
      DATE_VISIT: {
        id: '{PLANNED_DATE_DDMMYYYY}',
        label: $translate('Communication.visit_date_label'),
        values: {
          sms: $translate('Communication.visit_date_preview'),
          email: $translate('Communication.visit_date_preview')
        },
        propertyKeys: {
          visit_scheduled: true,
          route_started: true,
          checkout_success: false,
          checkout_failed: false,
          on_its_way: true
        },
        checked: false
      },
      NOTES: {
        id: '{NOTES}',
        label: $translate('General.notes'),
        values: {
          email: $translate('General.notes'),
          sms: $translate('General.notes')
        },
        propertyKeys: {
          visit_scheduled: true,
          route_started: true,
          checkout_success: true,
          checkout_failed: true,
          on_its_way: true
        },
        checked: false
      },
      CHECKOUT_COMMENT: {
        id: '{CHECKOUT_COMMENT}',
        label: $translate('Communication.comments'),
        values: {
          email: $translate('Communication.comments')
        },
        propertyKeys: {
          visit_scheduled: false,
          route_started: false,
          checkout_success: true,
          checkout_failed: true,
          on_its_way: false
        },
        checked: false
      },
      ID_REFERENCE: {
        id: '{ID_REFERENCE}',
        label: 'ID',
        values: {
          email: $translate('Communication.id_reference')
        },
        propertyKeys: {
          visit_scheduled: true,
          route_started: true,
          checkout_success: true,
          checkout_failed: true,
          on_its_way: true
        },
        checked: false
      },
      USER_CHECKOUT: {
        id: '{USER_CHECKOUT}',
        label: $translate('Communication.user_checkout_label'),
        values: {
          sms: $translate('Communication.user_checkout_label'),
          email: $translate('Communication.user_checkout_label')
        },
        propertyKeys: {
          visit_scheduled: false,
          route_started: false,
          checkout_success: true,
          checkout_failed: true,
          on_its_way: false
        },
        checked: false
      },
      VISIT_TITLE: {
        id: '{VISIT_TITLE}',
        label: $translate('Communication.visit_title'),
        values: {
          email: $translate('Communication.visit_title')
        },
        propertyKeys: {
          visit_scheduled: true,
          route_started: true,
          checkout_success: true,
          checkout_failed: true,
          on_its_way: true
        },
        checked: false
      },
      VISIT_ADDRESS: {
        id: '{VISIT_ADDRESS}',
        label: $translate('Communication.visit_address'),
        values: {
          email: $translate('Communication.visit_address')
        },
        propertyKeys: {
          visit_scheduled: true,
          route_started: true,
          checkout_success: true,
          checkout_failed: true,
          on_its_way: true
        },
        checked: false
      },
      VISIT_OBSERVATION: {
        id: '{VISIT_OBSERVATION}',
        label: $translate('Communication.visit_observation'),
        values: {
          email: $translate('Communication.visit_observation')
        },
        propertyKeys: {
          visit_scheduled: false,
          route_started: false,
          checkout_success: true,
          checkout_failed: true,
          on_its_way: false
        },
        checked: false
      },
      SIGNATURE_LINK: {
        id: '{SIGNATURE_LINK}',
        label: $translate('Communication.signature_link'),
        values: {
          email: $translate('Communication.signature_link')
        },
        propertyKeys: {
          visit_scheduled: false,
          route_started: false,
          checkout_success: true,
          checkout_failed: true,
          on_its_way: false
        },
        checked: false
      },
      TIMELINE: {
        id: '{TIMELINE}',
        label: $translate('Communication.timeline'),
        values: {
          email: $translate('Communication.timeline')
        },
        propertyKeys: {
          visit_scheduled: true,
          route_started: true,
          checkout_success: true,
          checkout_failed: true,
          on_its_way: true
        },
        checked: false
      },
      DELIVERY_TIME_RANGE: {
        id: '{DELIVERY_TIME_RANGE}',
        label: $translate('Communication.delivery_time_range_label'),
        values: {
          sms: $translate('Communication.delivery_time_range_preview'),
          email: $translate('Communication.delivery_time_range_preview')
        },
        propertyKeys: {
          visit_scheduled: true,
          route_started: true,
          checkout_success: false,
          checkout_failed: false,
          on_its_way: true
        },
        checked: false
      }
    };

    vm.tagsSubject = {
      ID_REFERENCE: {
        id: '{ID_REFERENCE}',
        label: 'ID',
        propertyKeys: {
          visit_scheduled: true,
          route_started: true,
          checkout_success: true,
          checkout_failed: true,
          on_its_way: true
        },
        checked: false
      },
      VISIT_TITLE: {
        id: '{VISIT_TITLE}',
        label: $translate('Communication.visit_title'),
        propertyKeys: {
          visit_scheduled: true,
          route_started: true,
          checkout_success: true,
          checkout_failed: true,
          on_its_way: true
        },
        checked: false
      },
      VISIT_ADDRESS: {
        id: '{VISIT_ADDRESS}',
        label: $translate('Communication.visit_address'),
        propertyKeys: {
          visit_scheduled: true,
          route_started: true,
          checkout_success: true,
          checkout_failed: true,
          on_its_way: true
        },
        checked: false
      }
    };

    vm.textSmsPreview = '';
    vm.textEmailPreview = '';
    vm.templateWsp = '';
    vm.textWspPreview = '';
    vm.extraFields = [];
    vm.readTypeExtraFields = [];
    vm.showExtraFields = false;
    vm.emails = [];
    vm.maxEmails = MAX_PREVIEW_EMAILS_INPUT;
    vm.validateEmailInput = validateEmailInput;
    vm.emailSentSuccess = false;
    vm.emailSentFailed = false;
    vm.emailInputError = {
      invalidFormat: false,
      maxQuantity: false,
      maxLength: false
    };

    vm.cancel = cancel;
    vm.saveProperty = saveProperty;
    vm.savePropertyEventHandler = savePropertyEventHandler;
    vm.showDeleteModal = showDeleteModal;
    vm.addTagToInputValue = addTagToInputValue;
    vm.addTagToInputValueFromExtraField = addTagToInputValueFromExtraField;
    vm.updateTextPreview = updateTextPreview;
    vm.replaceHtml = replaceHtml;
    vm.checkRadioWsp = checkRadioWsp;
    vm.navigateTab = navigateTab;
    vm.addTagToInputSubjectValue = addTagToInputSubjectValue;
    vm.validatePDF = validatePDF;
    vm.isRenderingTypePDF = isRenderingTypePDF;
    vm.showNotificationErrorOrFailWhenValidatingPDF = showNotificationErrorOrFailWhenValidatingPDF;
    vm.updateWspPreview = updateWspPreview;
    vm.processEmailPreview = processEmailPreview;

    activate();

    function activate() {
      vm.addonPropertyKey = $stateParams.addonPropertyKey;
      var addonId = $stateParams.addonId;
      var keySmsProperty = vm.addonPropertyKey + '_sms_body';
      var keyEmailSubjectProperty = vm.addonPropertyKey + '_email_subject';
      var keyEmailBodyProperty = vm.addonPropertyKey + '_email_body';
      var keyEmailAttachmentImages = vm.addonPropertyKey + '_email_attachment_images';
      var keyEmailRenderingType = vm.addonPropertyKey + '_email_rendering_type';
      var keywspProperty = vm.addonPropertyKey + '_wsp_body';
      var keys = [keySmsProperty, keyEmailSubjectProperty, keyEmailBodyProperty, keyEmailAttachmentImages, keyEmailRenderingType, keywspProperty];
      checkValueAddonsToSendAttachmentEmail($stateParams.addonPropertyKey);

      setRenderingTypeProperty(vm.addonPropertyKey);

      addonsService.getAddonByIdAndPropertiesByKeys(addonId, keys).then(function (response) {
        _updateProperties(addonId, response);

        if (vm.properties.wspBody.value) {
          _checkWspDropDown(vm.properties.wspBody.value);
        }
      });

      extraFieldsService.getExtraFields()
        .then(function (response) {
          vm.extraFields = response.filter(function (extraField) {
            return extraField.enable === true;
          }) || [];

          vm.readTypeExtraFields = vm.extraFields.filter(function (extraField) {
            return extraField.is_read === true;
          });

          if ((vm.addonPropertyKey !== 'visit_scheduled' && vm.extraFields.length > 0)
            || (vm.addonPropertyKey == 'visit_scheduled' && vm.readTypeExtraFields.length > 0)) {
            vm.showExtraFields = true;
          }

        })
        .catch(function () {
          vm.extraFields = [];
          vm.readTypeExtraFields = [];
        });

      vm.etaEnabled = accountConfigsService.isConfigEnabled(ETA_CONFIGURATION);
      vm.enableVisitItems = accountConfigsService.isConfigEnabled('enable_visit_items');
      vm.enableCheckoutStatusPDF = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_CHECKOUT_STATUS_PDF);

      if (vm.etaEnabled) {
        vm.tags.ETA_RANGE = {
          id: '{ETA_RANGE}',
          label: $translate('Communication.eta_range'),
          values: {
            sms: DEFAULT_TIME,
            email: DEFAULT_TIME
          },
          propertyKeys: {
            visit_scheduled: true,
            route_started: true,
            checkout_success: false,
            checkout_failed: false,
            on_its_way: true
          }
        };
      }

      if (vm.enableCheckoutStatusPDF) {
        vm.tags.CHECKOUT_STATUS_PDF = {
          id: '{CHECKOUT_STATUS_PDF}',
          label: $translate('Communication.checkout_status_pdf'),
          values: {
            email: $translate('Communication.checkout_status_pdf')
          },
          propertyKeys: {
            visit_scheduled: false,
            route_started: false,
            checkout_success: true,
            checkout_failed: true,
            on_its_way: false
          },
          checked: false
        };
      }

      addonsService.isAddonEnable("accounting")
        .then(function (enable) {
          if(enable || vm.enableVisitItems) {
            vm.tags.ITEMS_TABLE = {
              id: '{ITEMS_TABLE}',
              label: $translate('Communication.items_table'),
              values: {
                email: $translate('Communication.items_table')
              },
              propertyKeys: {
                visit_scheduled: true,
                route_started: true,
                checkout_success: true,
                checkout_failed: true,
                on_its_way: true
              },
              checked: false
            };
          }
        });

      accountConfigsService.getConfigByKey('enable_sms')
        .then(function (value) {
          vm.enableSms = value;
        });

      accountConfigsService.getConfigByKey('enable_wsp')
        .then(function (value) {
          vm.enableWsp = value;
        });

      sessionService.getUser()
        .then(function (userInfo) {
          draftWsp.accountName = userInfo.account.name;
          vm.accountStatus = userInfo.status;
        });

      addonsService.isAddonEnable("data_encryption")
        .then(function (enable) {
          if (enable) {
            delete(vm.tags.TRACKING_URL);
          }
        });

    }

    /**
     * Add style to improve UX from whatsapp templates to choose from
     * @param  {String} text The raw text from a template to show the user
     * @return {String}      Template text with correct styles
     */
    function replaceHtml(index, type) {
      var text = buildWspTemplate(vm.addonPropertyKey, type, index);

      return text.replace("{ACCOUNT_NAME}", $sanitize("<span class='text-wsp'>{account name}</span>"))
        .replace("{VISIT_ADDRESS}", $sanitize("<span class='text-wsp'>{address}</span>"))
        .replace("{ETA_RANGE}", $sanitize("<span class='text-wsp'>{ETA range}</span>"))
        .replace("{TRACKING_URL}", $sanitize("<span class='text-wsp'>{tracking number}</span>"))
        .replace("{ID_REFERENCE}", $sanitize("<span class='text-wsp'>{id reference}</span>"))
        .replace("{VISIT_TITLE}", $sanitize("<span class='text-wsp'>{visit title}</span>"));
    }

    function showWspTemplates(type) {
      vm.templatesToShow[type] = !vm.templatesToShow[type];
    }

    function cancel() {
      $state.go('^');
      $scope.$emit('DEACTIVATE_ROWS');
    }

    /**
     * Add draft words to preview of the template selected by the user
     * @param  {String} wspText Text from template selected by the user
     * @return {String}      Text with tags replaced with draft values
     */
    function replaceWspTags(wspText) {
      return wspText.replace("{ACCOUNT_NAME}", draftWsp.accountName)
        .replace("{VISIT_ADDRESS}", draftWsp.address)
        .replace("{ETA_RANGE}", draftWsp.etaRange)
        .replace("{TRACKING_URL}", draftWsp.trackingNumber)
        .replace("{ID_REFERENCE}", draftWsp.idReference)
        .replace("{VISIT_TITLE}", draftWsp.visitTitle);
    }

    function updateWspPreview(index, type) {
      var templateTranslation = buildWspTemplate(vm.addonPropertyKey, type, index);

      vm.textWspPreview = replaceWspTags(templateTranslation);
      vm.properties.wspBody.value = templateTranslation;
    }

    function saveProperty() {
      var promises = [];
      var addonId = parseInt($stateParams.addonId);
      Object.keys(vm.properties).forEach(function (key) {
        var property = vm.properties[key];
        property.add_on_id = addonId;
        property.value = setValuePropertySms(property);
        if (property.id) {
          updateProperty(promises, property);
        } else {
          createProperty(promises, property);
        }
      });

      $q.all(promises)
        .then(function (data) {
          $log.info(data);
          $scope.$emit('UPDATE_PROPERTIES', data);
        }).catch(function (error) {
          $log.error(error);
        }).finally(function () {
          $state.go('^');
          $scope.$emit('DEACTIVATE_ROWS');
        });
    }

    function navigateTab(tabName) {
      switch (tabName) {
        case "sms":
          vm.tabSms = true;
          vm.tabWsp = false;
          vm.tabEmail = false;
          break;
        case "wsp":
          vm.tabWsp = true;
          vm.tabSms = false;
          vm.tabEmail = false;
          break;
        case "email":
          vm.tabEmail = true;
          vm.tabSms = false;
          vm.tabWsp = false;
          break;
        default:
          vm.tabEmail = true;
          vm.tabSms = false;
          vm.tabWsp = false;
          break;
      }
    }

    function showDeleteModal(addonProperties) {
      $scope.addonProperties = getPropertiesToDelete(addonProperties);
      $scope.deleteAddonProperty = deleteAddonProperty;

      ngDialog.open({
        template: 'app/settings/communication/communication-delete-modal.html',
        scope: $scope
      });
    }

    function buildWspTemplate(propertyKey, type, index) {
      var template = $translate('Communication.wsp.' + propertyKey + '.' + type + '.template' + (index + 1));

      return template;
    }

    function checkRadioWsp(wspBodyValue, index, type) {
      var text = buildWspTemplate(vm.addonPropertyKey, type, index);

      if (wspBodyValue === text) {
        return true;
      }

      return false;
    }

    function updateTextPreview(index) {
      if (index === 'emailBody') {
        vm.textEmailPreview = replaceAllTags(vm.properties[index].value, 'email');
      } else if (index === 'smsBody') {
        vm.textSmsPreview = replaceAllTags(vm.properties[index].value, 'sms');
      } else if ((index === 'wspBody')) {
        vm.textWspPreview = replaceAllTags(vm.properties[index].value, 'wsp');
      }

      vm.textWspPreview = replaceWspTags(latiniseString(vm.textWspPreview));
      vm.textEmailPreview = latiniseString(vm.textEmailPreview);
      vm.textSmsPreview = latiniseString(vm.textSmsPreview);
    }

    function addTagToInputValue(index, tagId) {
      addTagText(index, tagId);
      updateTextPreview(index);
    }

    function addTagToInputValueFromExtraField(index, tagId) {
      addTagTextFromExtraField(index, tagId);
    }

    function addTagToInputSubjectValue(tagId) {
      if (vm.properties['emailSubject'].value.search(tagId) > -1) {
        vm.repeatedSubjectTag = true;
      } else {
        addTagText('emailSubject', tagId);
        vm.repeatedSubjectTag = false;
      }
    }

    function updateProperty(promises, property) {
      promises.push(addonsService.updateAddonProperty(property));
      checkIfSendAttachment(promises, property);
    }

    function createProperty(promises, property) {
      if (property.title && property.description && property.value) {
        promises.push(addonsService.createAddonProperty(property));
        checkIfSendAttachment(promises, property);
      }
    }

    function deleteAddonProperty() {
      var promises = [];
      $scope.addonProperties.forEach(function (property) {
        promises.push(addonsService.deleteProperty(property.addonId, property.id)
          .then(function () {
            $scope.$emit('DELETE_PROPERTY', property.key);
          }).catch(function (error) {
            $log.error(error);
          }));
      });

      $q.all(promises)
        .then(function () {
          $state.go('^');
        })
        .catch(function (error) {
          $log.error(error);
        })
        .finally(function () {
          $scope.$emit('DEACTIVATE_ROWS');
        });
    }

    function getPropertiesToDelete(properties) {
      if (vm.properties.renderingType && vm.properties.renderingType.id) {
        properties.push({
          'addonId': vm.properties.renderingType.addonId,
          'id': vm.properties.renderingType.id,
          'key': vm.properties.renderingType.key
        });
      }

      if (vm.sendAttachment && vm.emailPropertiesAttachment.images.id) {
        properties.push({
          'addonId': vm.emailPropertiesAttachment.images.addonId,
          'id': vm.emailPropertiesAttachment.images.id,
          'key': vm.emailPropertiesAttachment.images.key
        });
      }
      return properties;
    }

    function replaceAllTags(text, valueAttr) {
      var textPreview = text ? text : '';
      for (var key in vm.tags) {
        if (vm.tags[key].values.hasOwnProperty(valueAttr)) {
          textPreview = textPreview.replace(new RegExp(vm.tags[key].id, 'g'), vm.tags[key].values[valueAttr]);
        }
      }
      return textPreview;
    }

    function processEmailPreview() {
      var emailList = [];
      vm.emails.forEach(function (email) {
        emailList.push(email.text);
      });

      var payload = {
        message: vm.properties.emailBody.value,
        state: $stateParams.addonPropertyKey,
        email: emailList
      };

      if (vm.accountStatus !== 'active') {
        vm.emailNotActive = true;
        vm.emailSentSuccess = false;
        vm.emailSentFailed = false;

        return;
      }

      addonsService.sendEmailPreview(payload)
          .then(function () {
            vm.emailNotActive = false;
            vm.emailSentFailed = false;
            vm.emailSentSuccess = true;
          }).catch(function (error) {
            vm.emailNotActive = false;
            vm.emailSentSuccess = false;
            vm.emailSentFailed = true;
            $log.error(error);
          });
    }

    function setAllTags(text, valueAttr) {
      var valueProperty = text;
      for (var key in vm.tags) {
        if (vm.tags[key].values.hasOwnProperty(valueAttr)) {
          valueProperty = valueProperty.replace(new RegExp(vm.tags[key].values[valueAttr], 'g'), vm.tags[key].id);
        }
      }
      return valueProperty;
    }

    function latiniseString(string) {
      return string.replace(/[^A-Za-z0-9^ñ^Ç^ç[\] ]/g, function (x) {
        return latinMap[x] || x;
      });
    }

    function _updateProperties(addonId, response) {
      response.forEach(function (item) {
        setValueAttachment(item.data[0]);

        Object.keys(vm.properties).forEach(function (key) {
          var property = vm.properties[key];
          if (item.data[0] && item.data[0].key === property.key) {
            property.value = !item.data[0].value ? item.data[0].value : _changeFormatText(item.data[0]);
            property.id = item.data[0].id;
            property.addonId = addonId;
            property.title = item.data[0].title;
            property.description = item.data[0].description;
            property.key = item.data[0].key;
          }

          updateTextPreview(key);
        });
      });
    }

    function _checkWspDropDown(wspText) {
      var orderKeys = ['pedido', 'order'];
      var serviceKeys = ['servicio', 'service', 'serviço'];

      if (orderKeys.some(function(word) { return wspText.indexOf(word) >= 0; })) {
        vm.templatesToShow.orders = true;
        return;
      }

      if (serviceKeys.some(function(word) { return wspText.indexOf(word) >= 0; })) {
        vm.templatesToShow.services = true;
        return;
      }

      vm.templatesToShow.visits = true;
    }

    function setValueAttachment(property) {
      if (property && property.key === vm.emailPropertiesAttachment.images.key) {
        vm.sendAttachment.init = true;
        vm.sendAttachment.value = true;
        vm.emailPropertiesAttachment.images.id = property.id;
      }
    }

    function setValuePropertySms(property) {

      var value = property.value;
      if (property.key.includes('sms')) {
        value = setAllTags(value, 'sms');
      }
      if (property.key.includes('wsp')) {
        value = setAllTags(value, 'wsp');
      }
      return value;
    }

    function _changeFormatText(item) {
      if (item.key.includes('sms')) {
        item.value = item.value.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '{TRACKING_URL}');
      }
      if (item.key.includes('wsp')) {
        item.value = item.value.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '{TRACKING_URL}');
      }
      return item.value;

    }

    function checkValueAddonsToSendAttachmentEmail(property) {
      if (property === 'checkout_success' || property === 'checkout_failed') {
        vm.enableSendAttachment = true;
      }
    }

    function setRenderingTypeProperty(property) {
      var isCheckoutSuccess = property === 'checkout_success';
      var isCheckoutFailed = property === 'checkout_failed';

      if ((isCheckoutSuccess || isCheckoutFailed)) {
        vm.properties["renderingType"] = renderingTypeProperties;
      }
    }

    function checkIfSendAttachment(promises, property) {
      vm.emailPropertiesAttachment.images.add_on_id = vm.emailPropertiesAttachment.images.addonId;
      if (vm.sendAttachment.value &&
        (property.key === 'checkout_success_email_body' ||
          property.key === 'checkout_failed_email_body')) {
        promises.push(addonsService.createAddonProperty(vm.emailPropertiesAttachment.images));

      } else if (!vm.sendAttachment.value && vm.sendAttachment.init &&
        (property.key === 'checkout_success_email_body' ||
          property.key === 'checkout_failed_email_body')) {
        promises.push(addonsService.deleteProperty(vm.emailPropertiesAttachment.images.addonId,
          vm.emailPropertiesAttachment.images.id));
      }
    }

    function addTagText(index, tagId) {
      vm.properties[index].value = (vm.properties[index].value ? vm.properties[index].value : '')
        + ' ' + tagId + ' ';
    }

    function addTagTextFromExtraField(index, tagId) {

      vm.properties[index].value = (vm.properties[index].value ? vm.properties[index].value : '')
        + ' {EXTRA_FIELD_' + tagId.toUpperCase() + '} ';
    }

    function savePropertyEventHandler() {
      return $q
        .resolve(isRenderingTypePDF(vm.properties))
        .then(function (isPDF) {
          if (isPDF) {
            return validatePDF(vm.properties);
          }
        })
        .then(function () {
          return vm.saveProperty();
        })
        .catch(function (e) {
          return showNotificationErrorOrFailWhenValidatingPDF(e);
        });
    }

    function isRenderingTypePDF(properties) {
      return (properties.hasOwnProperty('renderingType') && (properties.renderingType.value === 'pdf'));
    }

    function validatePDF(properties) {
      return addonsService
        .validatePDF(properties.emailBody.value);
    }

    function showNotificationErrorOrFailWhenValidatingPDF(e) {
      Toasts.push('error', $translate('Communication.validate_pdf.' + ((e.status === 400) ? 'fail' : 'error')));
    }

    function validateEmailInput(tag) {
      var validEmailInput = validateEmail(tag) && validateEmailsLength(tag) && validateEmailsQuantity();
      return validEmailInput;
    }

    function validateEmail(tag) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var validEmail = re.test(tag.text);
      vm.emailInputError.invalidFormat = !validEmail;
      return validEmail;
    }

    function joinEmails(emailsList) {
      return emailsList.map(function (email) {
        return email.text;
      }).join(',');
    }

    function validateEmailsLength(tag) {
      var emailsCopy = JSON.parse(JSON.stringify(vm.emails));
      emailsCopy.push(tag);
      var joinedEmails = joinEmails(emailsCopy);
      var validLength = joinedEmails.length <= JOINED_EMAILS_MAX_LENGTH;
      vm.emailInputError.maxLength = !validLength;
      return validLength;
    }

    function validateEmailsQuantity() {
      var validEmailsQuantity = vm.emails.length < MAX_PREVIEW_EMAILS_INPUT;
      vm.emailInputError.maxQuantity = !validEmailsQuantity;
      return validEmailsQuantity;
    }
  }
})
  ();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .factory('zoneService', zoneService);

  /** @ngInject */
  function zoneService($http, $q, __env, $log, lodash, $window, $cacheFactory, ZoneModel,
                       vehicleService, zoneMapService, addonsService) {

    var ZONE_PATH = __env.API_URL + 'zones/';
    var cache = $cacheFactory('zones');

    var isRestrictionTypeAddonPropertyEnabled = false;

    var OPTIMIZATION_ZONE_PROPERTY_KEY = 'use_zones_to_optimization';
    var AUTOZONE_ADDONPROPERTY_KEY = 'use_auto_zones_in_optimization';
    var ZONE_ADDON_PROPERTY_RESTRICTION_TYPE_CONTROL = 'zones_restriction_type_control';

    var ZONE_ADDON_KEY = 'zones';

    var service = {
      listZones: listZones,
      getCoordinatesOfAllZones: getCoordinatesOfAllZones,
      listVehicles: listVehicles,
      saveZone: saveZone,
      createZone: createZone,
      removeCache: removeCache,
      parseFromStringToArray: parseFromStringToArray,
      getZonesIntoVisit: getZonesIntoVisit,
      buildPolygonsFromZones: buildPolygonsFromZones,
      getZonesIfProceed: getZonesIfProceed,
      updateZone: updateZone,
      deleteZone: deleteZone,
      isEnableZonesProperty: isEnableZonesProperty,
      isAutoZonesEnabled: isAutoZonesEnabled,
      createZoneProperties: createZoneProperties,
      updateZoneProperties: updateZoneProperties,
      updateAssignations: updateAssignations,
      getActiveZones: getActiveZones,
      getActiveZonesVehicle: getActiveZonesVehicle,
      getActiveZonesVisit: getActiveZonesVisit,
      findZoneById: findZoneById,
      isRestrictionTypeAddonPropertyEnabled: function() {
        return isRestrictionTypeAddonPropertyEnabled;
      },
      initializeRestrictionTypeAddonPropertyCheck: initializeRestrictionTypeAddonPropertyCheck,
      clearRestrictionTypeAddonProperty: clearRestrictionTypeAddonProperty
    };

    $window.zoneService = service;
    return service;

    //////////////////////////////////////////
    // Public Methods
    /////////////////////////////////////////

    function listZones(zonesFilter) {
      function success(response) {
        var zones = [];

        angular.forEach(response.data, function (data) {
          var zone = ZoneModel.fromJson(data);
          zones.push(zone);
        });

        return zones;
      }

      var httpOptions = {
        cache: cache
      };

      if (zonesFilter) {
        httpOptions.params = zonesFilter;
      }

      return getInstanceUsingCallbacks($http.get, [getZonesUrl(), httpOptions], success);
    }

    function getCoordinatesOfAllZones(zoneEdited) {
      var deferred = $q.defer();
      var zonesCoordinates = [];
      listZones().then(function (zones) {
        zones.forEach(function (zone) {
          if((zoneEdited && zoneEdited.id !== zone.id) || !zoneEdited) {
            zonesCoordinates.push(zone.coordinates);
          }
        });
        deferred.resolve(zonesCoordinates);
      }).catch(function (err) {
        $log.error(err);
        deferred.reject(zonesCoordinates);
      });

      return deferred.promise;
    }

    function listVehicles() {
      var deferred = $q.defer();
      var vehicles = [];
      vehicleService.list().then(function (data) {
        data.forEach(function (vehicle) {
          vehicles.push({id: vehicle.id, name: vehicle.name, activate: false});
        });

        deferred.resolve(vehicles);
      }).catch(function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    }

    function saveZone(zone) {
      return $http.post(ZONE_PATH, getRequestDataPostZone(zone));
    }

    function createZone(data) {
      return ZoneModel.fromJson(data);
    }

    function removeCache() {
      if ($cacheFactory.get('zones')) {
        $cacheFactory.get('zones').removeAll();
      }
    }

    function parseFromStringToArray(coordString) {
      var coordArray = JSON.parse(coordString.replace(/'/g, '"'));
      coordArray.forEach(function (coord) {
        coord.lat = parseFloat(coord.lat);
        coord.lng = parseFloat(coord.lng);
      });
      return coordArray;
    }

    function getZonesIntoVisit(zones, lat, lng) {
      return zoneMapService.getZonesIntoVisit(zones, lat, lng);
    }

    function buildPolygonsFromZones(zones) {
      return zoneMapService.buildPolygonsFromZones(zones);
    }

    /**
     * Retrieves zones if the specified addon is enabled.
     * If the addon is not enabled or an error occurs, an empty array is returned.
     * @param {object} zonesFilter - Filter criteria to apply when retrieving the active zones.
     * @returns A promise that resolves to an array of zones.
     */
    function getZonesIfProceed(zonesFilter) {
      var emptyZones = [];
      return isEnableZonesProperty(ZONE_ADDON_KEY, OPTIMIZATION_ZONE_PROPERTY_KEY)
        .then(function(data) {
          if (data.useZones) {
            return listZones(zonesFilter);
          }
          return emptyZones;
        })
        .catch(function(error) {
          $log.error(error);
          return emptyZones;
        });
    }

    function updateZone(zone) {
      service.removeCache();
      return $http.put(ZONE_PATH + zone.id, getRequestDataUpdateZone(zone));
    }

    function deleteZone(zoneId) {
      return $http.delete(ZONE_PATH + zoneId);
    }

    function isAddonPropertyEnabled (addon, property) {
      return addonsService.getInfoAddonAndPropertiesByKey(addon)
        .then(function(data) {
          var response = {
            id: null,
            addonId: null,
            isPropertyEnabled : false
          };

          // Filter required property in the list of property of this addon
          var searchProp = findProperty(data.properties, property);

          response.addonId = data.addon.id;
          if (searchProp) {
            response.id  = searchProp.id;
            response.isPropertyEnabled = searchProp.value === 'true' || searchProp.value === 'True';
          }
          return response;
        });
    }

    function isAutoZonesEnabled()  {
      var response = {
        id: null,
        addonId: null,
        isAutoZoneEnabled: false
      };

      return isAddonPropertyEnabled(ZONE_ADDON_KEY, AUTOZONE_ADDONPROPERTY_KEY)
        .then(function(data) {
            response.addonId = data.addonId;

            if (data.id) {
              response.id = data.id;
              response.isAutoZoneEnabled = data.isPropertyEnabled;
            }

            return response;
        })
        .catch(function(error) {
          $log.error(error);
          return response;
        });
    }

    function isEnableZonesProperty() {
      return isAddonPropertyEnabled(ZONE_ADDON_KEY, OPTIMIZATION_ZONE_PROPERTY_KEY)
        .then(function(data) {
          var response = {
            id: null,
            useZones: false,
            addonId: null
          };

          response.addonId = data.addonId;
          if (data.id) {
            response.id = data.id;
            response.useZones = data.isPropertyEnabled;
          }

          return response;
        });
    }

    function createZoneProperties(property) {
      var deferred = $q.defer();

      addonsService.createAddonProperty(property)
        .then(function (data) {
          deferred.resolve(data);
        }).catch(function (e) {
        deferred.reject(e);
      });

      return deferred.promise;
    }

    function updateZoneProperties(property) {
      var deferred = $q.defer();

      addonsService.updateAddonProperty(property)
        .then(function (data) {
          deferred.resolve(data);
        }).catch(function (e) {
        deferred.reject(e);
      });

      return deferred.promise;
    }

    function updateAssignations(request) {
        return $http.post(getZonesUrl() + 'bulk/', request);
    }


    //////////////////////////////////////////
    // Privates Methodsº
    /////////////////////////////////////////

    function initializeRestrictionTypeAddonPropertyCheck() {
      addonsService
        .getInfoAddonAndPropertiesByKey(ZONE_ADDON_KEY)
        .then(function (data) {
          var property = lodash.find(data.properties, function (obj) {
            return obj.key === ZONE_ADDON_PROPERTY_RESTRICTION_TYPE_CONTROL;
          });

          isRestrictionTypeAddonPropertyEnabled = property ? 
            (property.value === "true" || property.value === "True") : 
            false;
        })
        .catch(function () {
          isRestrictionTypeAddonPropertyEnabled = false;
        });
    }

    function clearRestrictionTypeAddonProperty() {
      isRestrictionTypeAddonPropertyEnabled = false;
    }

    function getZonesUrl() {
      return ZONE_PATH;
    }

    function getInstanceUsingCallbacks(method, args, successCallback, errorCallback) {
      var deferred = $q.defer();
      if (!errorCallback) {
        errorCallback = function (e) {
          var error = angular.isObject(e) ? e.data : e;
          deferred.reject(error);
        };
      }

      method.apply(this, args)
        .then(function (response) {
          $q.when(successCallback(response))
            .then(function (models) {
              deferred.resolve(models);
            });
        })
        .catch(errorCallback);
      return deferred.promise;

    }

    function getRequestDataPostZone(zone) {
      var requestData = {
        name: zone.name,
        coordinates: zone.coordinates,
        vehicles: [],
        schedules: zone.schedules
      };

      zone.vehicles.forEach(function (vehicle) {
        if (vehicle.activate) {
          requestData.vehicles.push(vehicle.id);
        }
      });

      return requestData;
    }

    function getRequestDataUpdateZone(zone) {
      var requestData = {
        name: zone.name,
        coordinates: zone.coordinates,
        enabled: zone.enabled,
        schedules: zone.schedules
      };

      if (zone.vehicles) {
        requestData.vehicles = [];
        zone.vehicles.forEach(function (vehicle) {
          if (vehicle.activate) {
            requestData.vehicles.push(vehicle.id);
          }
        });
      }

      return requestData;
    }

    function findProperty(properties, key) {
      return lodash.find(properties, function(obj) {
        return obj.key === key;
      });
    }

    function getActiveZones(zones) {
      return zones.filter(function(zone) {
        return zone.enabled;
      });
    }

    function getActiveZonesVehicle(vehicle, zones) {
      var activeZones = service.getActiveZones(zones);
      var result = activeZones.reduce(function (zoneIdList, zone) {
        var vehicleId = zone.vehicles.find(function (_vehicleId) {
          return parseInt(_vehicleId) === parseInt(vehicle.id);
        });
        return vehicleId ? zoneIdList.concat(parseInt(zone.id)) : zoneIdList;
      }, []);
      return result;
    }

    function findZoneById(zones, id) {
      return lodash.find(zones, function (zone) {
        return parseInt(zone.id) === parseInt(id);
      });
    }

    function getActiveZonesVisit(visit) {
      var activeZones = service.getActiveZones(visit.zones);
      return activeZones.map(function (zone) {
        return parseInt(zone.id);
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .factory('zoneMapService', zoneMapService);

  /** @ngInject */
  function zoneMapService($window, googleService) {
    var service = {
      getDrawingManagerOptions: getDrawingManagerOptions,
      getZoneOptions: getZoneOptions,
      getZonesIntoVisit: getZonesIntoVisit,
      buildPolygonsFromZones: buildPolygonsFromZones
    };

    $window.drawingMapService = service;
    return service;

    //////////////////////////

    function getDrawingManagerOptions(polygonOptions) {
      return {
        drawingMode: null,
        drawingControl: true,
        drawingControlOptions: {
          position: 'TOP_CENTER',
          drawingModes: ['polygon']
        },
        polygonOptions: polygonOptions
      };
    }

    function getZoneOptions(polygonOptions, coordinates) {
      var pathCoords = coordinates.map(function (coordinate) {
        return {
          latitude: coordinate.lat,
          longitude: coordinate.lng
        };
      });

      return Object.assign({}, polygonOptions, { pathCoords: pathCoords });
    }

    function buildPolygonsFromZones(zones) {
      return zones.map(function (zone) {
        var zonePath = zone.coordinates.map(function (coordinate) {
          return googleService.getGoogleMapsLatLng(coordinate.lat, coordinate.lng);
        });

        return {
          id: zone.id,
          name: zone.name,
          enabled: zone.enabled,
          restriction_type: zone.restriction_type,
          polygon: googleService.createPolygon({ path: zonePath })
        };
      });
    }

    function getZonesIntoVisit(polygons, lat, lng) {
      var point = googleService.getGoogleMapsLatLng(lat, lng);
      var resultZones = [];
      for (var i = 0; i < polygons.length; i++) {
        if (polygons[i].polygon.contains(point)) {
          resultZones.push({
            id: polygons[i].id,
            name: polygons[i].name,
            enabled: polygons[i].enabled,
            restriction_type: polygons[i].restriction_type
          });
          break;
        }
      }

      return resultZones;
    }
  }
})();

/* global google:false, MarkerWithLabel:false */
(function() {
  'use strict';

  angular
    .module('icarus.settings')
    .factory('vehicleService', vehicleService);

  /** @ngInject */
  function vehicleService($q, $http, $log, __env, $window, driversService, PlannerVehicleModel, plannerService,
                          sessionService, $stateParams, googleService, lodash, colorAssignerService) {

    var VEHICLES_PATH = __env.API_URL + 'routes/vehicles/';

    var vehicles = [];
    var drivers = [];
    var userAccount = null;
    var initPromise = null;
    var getPromise = null;

    var service = {
      getVehicleById: getVehicleById,
      create: create,
      update: update,
      list: list,
      clear: clear,
      getEnabledDriver: getEnabledDriver,
      delete:_delete,
      getDataVehicle: _getDataVehicle,
    };

    init();
    getUser();
    $window.vehicleService = service;
    return service;

    ////////

    function init() {
      if (initPromise) {
        return initPromise;
      }

      if (localStorage.getItem('token') ) {
        initPromise = list();
      }
      return initPromise;
    }

    function getUser() {
      sessionService.getUser().then( function (user) {
        userAccount = user;
      }, function error(e){
        $log.info(e);
      });

    }

    function getVehicles () {
      if (getPromise) {
        return getPromise;
      }
      getPromise = init();
      return getPromise;
    }

    function create(vehicle) {
      var deferred = $q.defer();
      if(angular.isUndefined(userAccount) || !userAccount){
        getUser();
      }
      _geocoding(vehicle).then(function () {
        $http.post(VEHICLES_PATH, vehicle).then(
          function success (resp) {
            var dataVehicle = resp.data;
            vehicles.push(dataVehicle);
            _sortVehicles();

            var vehicle = new PlannerVehicleModel(dataVehicle.id.toString());
            // Default codrivers assignment doesn't work properly
            // setting codrivers attribute through vehicle_temp.
            vehicle.codrivers = dataVehicle.codrivers;
            var vehicle_temp = _getDataVehicle(dataVehicle);
            colorAssignerService.setDefaultVehicleColorCache(vehicle.id, dataVehicle.color);
            vehicle.shift.start = dataVehicle.shift_start;
            vehicle.shift.end = dataVehicle.shift_end;

            plannerService.returnVehicles().then( function (vehiclesPlanner) {

              if (dataVehicle.default_driver) {
                driversService.getDriverById(dataVehicle.default_driver).then( function (driver) {

                  var driverData = {
                    id: String(driver.id),
                    name: driver.name,
                    username: driver.username
                  };

                  vehicle.driver = driverData;
                  lodash.merge(vehicle, vehicle_temp);
                  vehiclesPlanner.push(vehicle);
                });
              } else {
                vehicle.driver = null;
                lodash.merge(vehicle, vehicle_temp);
                vehiclesPlanner.push(vehicle);
              }

            });

            deferred.resolve(resp);
          },
          function errorCreateVehicle (error) {
            deferred.reject(error);
          }
        );
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function update(vehicle){
      var deferred = $q.defer();
      if (angular.isUndefined(userAccount) || !userAccount){
        getUser();
      }

      _geocoding(vehicle).then(function () {
        $http.put(VEHICLES_PATH+vehicle.id+'/', vehicle).then(
          function success (resp) {
            var dataVehicle = resp.data;
            vehicles.map(function(vehicle, index){
              if (vehicle.id === dataVehicle.id) {
                var color  = vehicles[index].color;
                vehicles[index] = dataVehicle;
                vehicles[index].color = color;
              }
            });

            _sortVehicles();

            plannerService.getVehicle(String(vehicle.id)).then(function (vehicle) {
              // Default codrivers assignment doesn't work properly
              // setting codrivers attribute through vehicle_temp.
              vehicle.codrivers = dataVehicle.codrivers;
              var vehicle_temp = _getDataVehicle(dataVehicle);
              colorAssignerService.setDefaultVehicleColorCache(vehicle.id, dataVehicle.color);
              if (dataVehicle.default_driver) {
                driversService.getDriverById(dataVehicle.default_driver).then(function (driver) {
                  var driverData = {
                    id: String(driver.id),
                    name: driver.name,
                    username: driver.username
                  };

                  vehicle.driver = driverData;
                  lodash.merge(vehicle, vehicle_temp);
                });
              } else {
                vehicle.driver = null;
                lodash.merge(vehicle, vehicle_temp);
              }
            });
            deferred.resolve(resp);
          },
          function errorUpdateVehicle(err){
            deferred.reject(err);
          }
        );
      },
      function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function list(){
      if (vehicles.length !== 0){
        return $q.when(vehicles);
      }

      var deferred  = $q.defer();

      $http.get(VEHICLES_PATH).then(
        function success(response){
          vehicles.length = 0;
          for (var i = response.data.length - 1; i >= 0 ; i--) {
            var vehicle = response.data[i];
            vehicle.active = true;
            vehicles.push(vehicle);
          }
          _sortVehicles();
          deferred.resolve(vehicles);
        },
        function errorListVehicles (error) {
          deferred.reject(error);
        }
      );


      return deferred.promise;
    }

    function _delete(vehicle){
      var deferred = $q.defer();

      $http.delete(VEHICLES_PATH+vehicle.id+'/').then(
        function success(resp){
          for (var i = 0; i < vehicles.length; i++){
            var _vehi = vehicles[i];

            if (_vehi.id === vehicle.id){
              vehicles.splice(i, 1);

              plannerService.returnVehicles().then( function (vehiclesPlanner) {
                for (var i = 0; i < vehiclesPlanner.length; i++) {
                  if (vehiclesPlanner[i].id === String(vehicle.id)) {
                    plannerService.removeVehicle(vehiclesPlanner[i]);
                    vehiclesPlanner.splice(i,1);
                  }
                }
              });

              break;
            }
          }
          deferred.resolve(resp);
        },
        function errorDeleteVehicle(err){
          deferred.reject(err);
        }
      );

      return deferred.promise;
    }

    function getVehicleById (vehicleId) {

      return getVehicles().then(
        function (vehicles) {
          for (var i = 0; i < vehicles.length; i++) {
            if (vehicles[i].id === vehicleId) {
              return vehicles[i];
            }
          }
          var data = {status: 404};
          return $q.reject(data);
        },
        function error (e) {
          return $q.reject(e);
        });
    }

    function getEnabledDriver () {
      var deferred = $q.defer();
      var if_exits = false;
      list().then( function success (vehicles) {
        driversService.list().then( function successDrivers (drivers) {
          var drivers_enable = [];

          for (var i = 0; i < drivers.length; i++) {
            if (drivers[i].is_owner) {
              continue;
            }
            for (var j = 0; j < vehicles.length; j++) {
              if (vehicles[j].default_driver === drivers[i].id) {
                if (vehicles[j].id !== parseInt($stateParams.vehicleId)) {
                  if_exits = true;
                  break;
                }
              } else {
                if_exits = false;
              }
            }
            if (!if_exits) {
              drivers_enable.push(drivers[i]);
            }
          }

          deferred.resolve(drivers_enable);
        }, function errorDrivers (error){
          deferred.reject(error);
        });
      }, function error (e){
        deferred.reject(e);
      });

      return deferred.promise;
    }

    function clear () {
      vehicles.length = 0;
      drivers.length = 0;
      userAccount = null;
      initPromise = null;
      getPromise = null;
    }

    ///////////

    function _getDataVehicle(data) {
      var shift = plannerService.getShift();
      var shiftStart = data.shift_start ? data.shift_start.slice(0, 5) : shift.start;
      var shiftEnd = data.shift_end ? data.shift_end.slice(0, 5) : shift.end;
      var shiftDefault = PlannerVehicleModel.getShiftDefault(shiftStart, shiftEnd, data);

      var restTimeStart = null;
      var restTimeEnd = null;

      // convertir id de los skills a string
      for (var i = 0; i < data.skills.length; i++) {
        data.skills[i] = String(data.skills[i]);
      }

      var locationStart = {
        address: data.location_start_address,
        latitude: parseFloat(data.location_start_latitude) || 0,
        longitude: parseFloat(data.location_start_longitude) || 0
      };

      var locationEnd = {
        address: data.location_end_address,
        latitude: parseFloat(data.location_end_latitude) || 0,
        longitude: parseFloat(data.location_end_longitude) || 0
      };

      if (data.rest_time_start) {
        restTimeStart = data.rest_time_start.split(':');
        restTimeStart = restTimeStart[0]+ ':' + restTimeStart[1];
      }

      if (data.rest_time_end) {
        restTimeEnd = data.rest_time_end.split(':');
        restTimeEnd = restTimeEnd[0]+ ':' + restTimeEnd[1];
      }

      var dataVehicle = {
        active: false,
        isShiftTemporarilyEdited: false,
        backendId: null,
        capacity: data.capacity,
        capacity2: data.capacity_2,
        capacity3: data.capacity_3,
        collapsed: true,
        driverId: null,
        id: String(data.id),
        initials: "",
        locationEnd: locationEnd,
        locationEndMarker: null,
        locationStart: locationStart,
        locationStartMarker: null,
        name: data.name,
        skills:  data.skills,
        shift: { start: shiftStart, end: shiftEnd },
        shiftDefault: shiftDefault,
        cost: data.cost,
        restTimeDuration: data.rest_time_duration,
        restTimeEnd: restTimeEnd,
        restTimeStart: restTimeStart
      };

      return dataVehicle;
    }

    function _geocoding(vehicle) {
      var deferred = $q.defer();
      var  geocoder = null;
      var originData = null;

      // if exist origin, define data to send
      if(vehicle.location_start_latitude && vehicle.location_start_longitude){
        originData = {'location':{
            lat: parseFloat(vehicle.location_start_latitude),
            lng: parseFloat(vehicle.location_start_longitude),
          }};
      }else if(vehicle.location_start_address){
        originData = {'address': vehicle.location_start_address };
      }

      // if exist originData, make request to google services and get information of origin address
      if (originData) {
        geocoder = googleService.createGeocode();
        geocoder.geocode( originData,
          function(results, status) {
            var sameCountry = true;
            if (status === googleService.geocoderStatusOK()) {
              sameCountry = _getCountry(results[0]);

              if (!sameCountry) {
                deferred.reject('error: Diferente pais direccion origen');
                return deferred.promise;
              }

              if (results[0].geometry.location.lat() === "0" || results[0].geometry.location.lat() === 0) {
                deferred.reject('error: Direccion origen con lat lng 0');
                return deferred.promise;
              }

              if(originData["address"]){
                vehicle.location_start_latitude = results[0].geometry.location.lat().toFixed(6);
                vehicle.location_start_longitude = results[0].geometry.location.lng().toFixed(6);
              }

              // if exist destination, define data to send
              var destinationData = null;
              if(vehicle.location_end_latitude && vehicle.location_end_longitude){
                destinationData = {'location':{
                    lat: parseFloat(vehicle.location_end_latitude),
                    lng: parseFloat(vehicle.location_end_longitude),
                  }};
              }else if(vehicle.location_end_address){
                destinationData = {'address': vehicle.location_end_address };
              }

              //  if exist destinationData, make request to google services and get information of final address
              if (destinationData) {
                geocoder = googleService.createGeocode();
                geocoder.geocode( destinationData,
                  function(results, status) {
                    var sameCountry = true;
                    if (status === googleService.geocoderStatusOK()) {
                      sameCountry = _getCountry(results[0]);
                      if (!sameCountry) {
                        deferred.reject('error: Diferente pais direccion destino');
                        return deferred.promise;
                      }
                      if (results[0].geometry.location.lat() === "0" || results[0].geometry.location.lat() === 0) {
                        deferred.reject('error: Direccion destino con lat lng 0');
                        return deferred.promise;
                      }
                      if(destinationData["address"]){
                        vehicle.location_end_latitude = results[0].geometry.location.lat().toFixed(6);
                        vehicle.location_end_longitude = results[0].geometry.location.lng().toFixed(6);
                      }

                      // resolve vehicles with latitude and longitude
                      deferred.resolve(vehicle);

                    } else {
                      deferred.reject(status); // if end address calculation fails
                    }
                });
              } else {
                deferred.reject('error: no hay latitud o longitud final, ni dirección final');
              }
            } else {
              deferred.reject(status); // if origin  address calculation fails
          }
        });
      } else {
        deferred.reject('error: no hay latitud o longitud inicial, ni dirección inicial');
      }

      return deferred.promise;
    }

    function _sortVehicles() {
      vehicles.sort(function (a,b) {
        return a.name < b.name ? -1: 1;
      });
    }

    function _getCountry(result) {
      var isCountry = false;
      var sameCountry = true;
      result.address_components.forEach( function (item) {
        isCountry = false;
        item.types.forEach( function (type) {
          if (type === "country") {
            isCountry = true;
          }
        });
        if (isCountry) {
          if (userAccount.account.country !== item.short_name) {
            sameCountry = false;
          }
        }
      });

      return sameCountry;
    }
   }
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .factory('userService', userService);

  /** @ngInject */
  function userService($http, __env, UserModel, $q, USER_ROLE, USER_STATUS, apolloAuthService, $window, moduleHelpersService, PERMISSION_KEYS, STATES) {
    return {
      getTypeUser: getTypeUser,
      isActiveUser: isActiveUser,
      listUsers: listUsers,
      createUser: createUser,
      updateUser: updateUser,
      removeUser: removeUser,
      getUserById: getUserById,
      listWebUsers: listWebUsers,
      unlockUser: unlockUser,
      getRedirectStateByUserRole: getRedirectStateByUserRole,
      hasMultiAccount: hasMultiAccount
    };

    //////////////////////////////////////////
    // Privates Methodsº
    /////////////////////////////////////////

    function _getUsersUrl() {
      return __env.API_URL + 'accounts/users/';
    }

    function _getUnlockUrl() {
      return __env.APIV2_URL + 'auth/reset/';
    }


    function _getInstanceUsingCallbacks(method, args, successCallback, errorCallback) {
      var deferred = $q.defer();
      if (!errorCallback) {
        errorCallback = function (e) {
          var error = angular.isObject(e) ? e.data : e;
          deferred.reject(error);
        };
      }

      method.apply(this, args)
        .then(function (response) {
          $q.when(successCallback(response))
            .then(function (models) {
              deferred.resolve(models);
            });
        })
        .catch(errorCallback);
      return deferred.promise;
    }

    function _getInstance(url, opts, modelFromJson) {
      var deferred = $q.defer();
      $http.get(url, opts)
        .then(function (response) {
          try {
            deferred.resolve(modelFromJson(response.data));
          } catch (e) {
            deferred.reject(e.message);
          }
        })
        .catch(function (response) {
          deferred.reject(response);
        });
      return deferred.promise;
    }

    function _getUserRequest(user) {
      return {
        name: user.name,
        username: user.username,
        phone: user.phone || "",
        email: user.email || "",
        is_admin: user.typeUser === USER_ROLE.ADMIN,
        is_driver: user.typeUser === USER_ROLE.DRIVER,
        is_codriver: user.typeUser === USER_ROLE.CODRIVER,
        is_monitor: user.typeUser === USER_ROLE.MONITOR || user.typeUser === USER_ROLE.MONITOR_COORDINATOR,
        is_coordinator: user.typeUser === USER_ROLE.COORDINATOR || user.typeUser === USER_ROLE.MONITOR_COORDINATOR,
        is_router: user.typeUser === USER_ROLE.ROUTER,
        is_router_jr: user.typeUser === USER_ROLE.ROUTER_JR,
        is_seller: user.typeUser === USER_ROLE.SELLER,
        is_seller_viewer: user.typeUser === USER_ROLE.SELLER_VIEWER
      };
    }

    ////////////////////////////////////////////
    // Public Methods
    ////////////////////////////////////////////

    function getTypeUser(user) {
      if (user.isAdmin) {
        return USER_ROLE.ADMIN;
      }

      if (user.isDriver) {
        return USER_ROLE.DRIVER;
      }

      if (user.isCodriver) {
        return USER_ROLE.CODRIVER;
      }

      if (user.isCoordinator && user.isMonitor) {
        return USER_ROLE.MONITOR_COORDINATOR;
      }

      if (user.isCoordinator) {
        return USER_ROLE.COORDINATOR;
      }

      if (user.isRouter) {
        return USER_ROLE.ROUTER;
      }

      if (user.isRouterJr) {
        return USER_ROLE.ROUTER_JR;
      }

      return USER_ROLE.MONITOR;
    }

    function isActiveUser(user) {
      return [USER_STATUS.ACTIVE, USER_STATUS.BLOCKED].includes(user.status);
    }

    function listWebUsers() {
      return $http.get(__env.API_URL + 'accounts/web-users/', null)
        .then(function(response) {
          return response.data;
        });
    }

    function listUsers() {
      function success(response) {
        var users = [];

        angular.forEach(response.data, function (data) {
          if (isActiveUser(data)) {
            var user = UserModel.fromJson(data);
            users.push(user);
          }
        });

        return users;
      }

      return _getInstanceUsingCallbacks($http.get, [_getUsersUrl()], success);
    }

    function createUser(data) {
      var deferred = $q.defer();
      var requestData = _getUserRequest(data);
      if (data.password) {
        requestData.password = data.password;
      }

      $http.post(_getUsersUrl(), requestData)
        .then(
          function successSaveUser(response) {
            var newUser = UserModel.fromJson(response.data);
            deferred.resolve(newUser);

          }, function errorSaveUser(error) {
            deferred.reject(error);
          });

      return deferred.promise;
    }

    function getUserById(id) {
      return _getInstance(_getUsersUrl() + id + '/', null, UserModel.fromJson);
    }

    function updateUser(data) {
      var deferred = $q.defer();
      var requestData = _getUserRequest(data);
      if (data.password) {
        requestData.password = data.password;
      }

      $http.put(_getUsersUrl() + data.id + '/', requestData)
        .then(
          function successSaveUser(response) {
            var newUser = UserModel.fromJson(response.data);
            deferred.resolve(newUser);

          }, function errorSaveUser(error) {
            deferred.reject(error);
          });

      return deferred.promise;
    }

    function removeUser(data) {
      var deferred = $q.defer();
      var requestData = _getUserRequest(data);
      requestData["status"] = USER_STATUS.DELETED;
      $http.put(_getUsersUrl() + data.id + '/', requestData)
        .then(function () {
          deferred.resolve(data);
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function unlockUser(data) {
      var deferred = $q.defer();
      var requestData = {
        user: data.user
      };
      if (data.email) {
        requestData.email = data.email;
      }

      $http.post(_getUnlockUrl(), requestData)
        .then(
          function successSaveUser(response) {
            deferred.resolve(response.data);
          }, function errorSaveUser(error) {
            deferred.reject(error);
          });

      return deferred.promise;
    }

    function getRedirectStateByUserRole(user, isRouteDesignerEnabled, isApolloRouteDesignerEnabled) {
      var currentLanguage = moduleHelpersService.getCurrentLanguage();

      if (user.role) {
        var stateToRedirect = _getStateToRedirectFromUserPermissions(user.role.permissions, currentLanguage, isApolloRouteDesignerEnabled);
        if (stateToRedirect.indexOf(__env.APOLLO_URI) === 0) {
          $window.location.href = stateToRedirect;
          return;
        }

        return stateToRedirect;
      }

      if (user.is_seller || user.is_seller_viewer) {
        $window.location.href = apolloAuthService.buildRedirectURL(currentLanguage + "/visits");
        return;
      }

      if (user.is_coordinator) {
        return STATES.PLANS;
      }

      var isAdminOrOwner = user.is_admin || user.is_owner;

      if (user.is_monitor && !isAdminOrOwner) {
        $window.location.href = apolloAuthService.buildRedirectURL(currentLanguage + "/tracking");
        return;
      }

      if (!user.is_monitor && (isAdminOrOwner || user.is_router || user.is_router_jr)) {
        if (isRouteDesignerEnabled) {
          if (isApolloRouteDesignerEnabled) {
            $window.location.href = apolloAuthService.buildRedirectURL(currentLanguage + "/pathfinder/planner");
            return;
          }

          return STATES.VEHICLES_LIST;
        }

        return STATES.ASSIGNER;
      }

      $window.location.href = apolloAuthService.buildRedirectURL(currentLanguage + "/profile");
    }

    function hasMultiAccount(user) {
      return user.organization && user.organization.accounts && user.organization.accounts.length > 1;
    }

    function _getStateToRedirectFromUserPermissions(permissions, currentLanguage, isApolloRouteDesignerEnabled) {
      if (moduleHelpersService.isModuleAvailable(permissions, PERMISSION_KEYS.PATHFINDER.PLANS)) {
        return STATES.PLANS;
      }

      if (moduleHelpersService.isModuleAvailable(permissions, PERMISSION_KEYS.PATHFINDER.ROUTER)) {
        if (isApolloRouteDesignerEnabled) {
          return apolloAuthService.buildRedirectURL(currentLanguage + "/pathfinder/planner");
        }

        return STATES.VEHICLES_LIST;
      }

      if (moduleHelpersService.isModuleAvailable(permissions, PERMISSION_KEYS.PATHFINDER.ASSIGNER)) {
        return STATES.ASSIGNER;
      }

      if (moduleHelpersService.isModuleAvailable(permissions, PERMISSION_KEYS.WATCHTOWER.TRACKING)) {
        return apolloAuthService.buildRedirectURL(currentLanguage + "/tracking");
      }

      if (moduleHelpersService.isModuleAvailable(permissions, PERMISSION_KEYS.WATCHTOWER.VISITS)) {
        return apolloAuthService.buildRedirectURL(currentLanguage + "/visits");
      }

      if (moduleHelpersService.isModuleAvailable(permissions, PERMISSION_KEYS.REPORTS)) {
        return apolloAuthService.buildRedirectURL(currentLanguage + "/reports");
      }

      if (moduleHelpersService.isModuleAvailable(permissions, PERMISSION_KEYS.CLIENTS)) {
        return apolloAuthService.buildRedirectURL(currentLanguage + "/clients");
      }

      if (moduleHelpersService.isModuleAvailable(permissions, PERMISSION_KEYS.FORCE_FIELD)) {
        return apolloAuthService.buildRedirectURL(currentLanguage + "/forcefield");
      }

      if (moduleHelpersService.isModuleAvailable(permissions, PERMISSION_KEYS.CHAT)) {
        return apolloAuthService.buildRedirectURL(currentLanguage + "/chat");
      }

      if (moduleHelpersService.isSettingsModuleAvailable(permissions)) {
        return moduleHelpersService.getSettingsInitURLWithPermissions(permissions, currentLanguage);
      }

      return apolloAuthService.buildRedirectURL(currentLanguage + "/profile");
    }
  }
})();

(function(){
	'use strict';

	angular
		.module('icarus.settings')
		.factory('skillsService', skillsService);

	/** @ngInject */
	function skillsService($http, $q, __env, $window, plannerService, store) {

		var SKILLS_PATH = __env.API_URL + 'routes/skills/';

		var skills = [];
		var initPromise = null;

		var service = {
			list: list,
			get: get,
			create: create,
			update: update,
			remove: remove,
			clear: clear
		};

		init();
    $window.skillsService = service;
		return service;

		//////////////////////////
		function init () {
      if (initPromise) {
        return initPromise;
      }

      var token = store.get('token');

      if (!token) {
        return $q.when([]);
      }

      initPromise = list();
      return initPromise;
    }

		function list () {
      var token = store.get('token');

			if (!token) {
				return $q.reject('NOT_AUTHENTICATED');
			}

			var deferred = null;

			if (skills.length > 0) {
				return $q.when(skills);
			}

			deferred = $q.defer();

			$http.get(SKILLS_PATH)
				.then(function skillListSuccess (response) {
					skills = [];
					for (var i = 0; i < response.data.length ; i++) {
						skills.push(response.data[i]);
					}
					deferred.resolve(skills);
				})
				.catch(function skillListError (response) {
					deferred.reject(response);
				});

				return deferred.promise;
		}

		function get (skillId) {
			return list().then(function (skills) {
				for (var i = 0; i < skills.length ; i++) {
					if (skills[i].id === skillId) {
						return skills[i];
					}
				}
				return $q.reject();
			});
		}

		function create (skillData) {
			var deferred = $q.defer();

			$http.post(SKILLS_PATH, {skill: skillData})
				.then( function skillCreateSuccess (response) {
					skills.push(response.data);

					plannerService.returnSkills().then( function (skillsPlanner) {
						var data = {id: response.data.id, name: response.data.skill};

						skillsPlanner.push(data);
					});

					deferred.resolve(response.data);
				})
				.catch( function skillCreateError (response) {
					deferred.reject(response);
				});

			return deferred.promise;
		}

		function update (skill, skillNewData) {
			var deferred = $q.defer();

			$http.put(SKILLS_PATH + skill.id + '/', skillNewData)
				.then(function skillUpdateSuccess(response) {
					skills.map(function(skill, index){
						if (skill.id === response.data.id) {
							skills[index] = response.data;
						}
					});
					deferred.resolve(skill);
				})
				.catch(function skillUpdateError(response) {
					deferred.reject(response);
				});

			return deferred.promise;
		}

		function remove (skill) {
			var deferred = $q.defer();

			$http.delete(SKILLS_PATH + skill.id + '/').then(
				function skillRemoveSuccess (response) {

					for(var i = 0; i < skills.length; i++) {

						if (skills[i].id === skill.id) {
							skills.splice(i, 1);
						}

					}
					deferred.resolve(response);

				})
				.catch(function skillRemoveSuccess (response) {
					deferred.reject(response);
				});

			return deferred.promise;
		}

		function clear() {
			skills.length = 0;
      initPromise = null;
		}

	}
})();

(function(){
  'use strict';

  angular
    .module('icarus.settings')
    .factory('settingsService', settingsService);

  /** @ngInject */
  function settingsService($http, __env) {

    var REPORTS_URL = __env.API_URL + 'routes/reports/';
    var REPORTS_URL_NEW =  __env.API_URL + 'reports/';
    var REPORT_TIMESERVICE_NAME = 'time-service';
    var REPORT_KILOMETERS_NAME = 'kilometers';

    var GEOFENSE_RADIUS_DEFAULT = 500;

    return {
      getkilometersTraveling: getkilometersTraveling,
      getTimeServiceVisits: getTimeServiceVisits
    };

    function _reportUrl(clientId, reportName, date) {
      return REPORTS_URL + 'client/'+ clientId + '/' + reportName +'/' + date + '/';
    }

    // Nombre de funcion deberia ser cambiado cuando se migre los reportes desde la app de routes a la app de reports
    function _reportUrlKm(reportName, date) {
      return REPORTS_URL_NEW + reportName +'/' + date + '/';
    }

    //////////////////////////

    function getkilometersTraveling(params) {
      return $http.get(
        _reportUrlKm(REPORT_KILOMETERS_NAME, params.date),
        {params: {'from': params.from, 'to': params.to}}
      );
    }

    function getTimeServiceVisits(params) {
      return $http.get(
        _reportUrl(params.clientId, REPORT_TIMESERVICE_NAME, params.date),
        {params: {'geofense_radius': params.geofenseRadius || GEOFENSE_RADIUS_DEFAULT,
          'from': params.from, 'to': params.to}}
      );
    }

  }
})();

(function(){
  'use strict';

  angular
    .module('icarus.settings')
    .factory('securityService', securityService);

  /** @ngInject */
  function securityService($http, $q, __env, $window) {

    var SECURITY_PATH = __env.API_URL + 'addons/password_security/';
    var SECURITY_PATH_WITH_TEMPORARY_TOKEN = __env.API_URL + 'auth/password/reset/policy/';
    var PASSWORD_RENEWAL_PATH = __env.API_URL + 'auth/password/renewal/';

    var security = [];

    var service = {
      get: get,
      create: create,
      update: update,
      buildBodyToShow: buildBodyToShow,
      buildValidation: buildValidation,
      validatePassword: validatePassword,
      formPasswordValidation: formPasswordValidation,
      passwordRenewal: passwordRenewal
    };

    $window.securityService = service;
    return service;

    //////////////////////////

    function list (data) {
      var deferred = null;

      if (security.length > 0) {
        return $q.when(security);
      }

      deferred = $q.defer();

      if( Object.entries(data).length === 0 ) {
        $http.get(SECURITY_PATH)
          .then(function securityGetSuccess (response) {
            deferred.resolve(response);
          })
          .catch(function securityGetError (error) {
            deferred.reject(error);
          });
      }else {
        $http.post(SECURITY_PATH_WITH_TEMPORARY_TOKEN, data)
          .then(function securityGetSuccess (response) {
            deferred.resolve(response);
          })
          .catch(function securityGetError (error) {
            deferred.reject(error);
          });
      }

      return deferred.promise;
    }

    function get(data) {
      return list(data).then(function (response) {
        return response;
      }).catch( function (error){
        return error;
      });
    }

    function create (securityData) {
      var deferred = $q.defer();

      $http.post(SECURITY_PATH, securityData)
        .then( function securityCreateSuccess (response) {
          deferred.resolve(response.data);
        })
        .catch( function securityCreateError (response) {
          deferred.reject(response);
        });

      return deferred.promise;
    }

    function update (securityData) {
      var deferred = $q.defer();

      $http.put(SECURITY_PATH, securityData)
        .then(function securityUpdateSuccess(response) {
          deferred.resolve(response);
        })
        .catch(function securityUpdateError  (response) {
          deferred.reject(response);
        });

      return deferred.promise;
    }

    function buildBodyToShow(addon, driverOrCodriver, policies) {
      var properties = {};

      addon.add_on_properties.forEach( function(prop) {
        properties[prop.key] = prop.value;
      });

      var type = "web";
      if (driverOrCodriver){
        type = "mobile";
      }

      policies["length"] = properties[type + '_length'];
      policies["uppercase"] = properties[type + '_uppercase'];
      policies["lowercase"] = properties[type + '_lowercase'];
      policies["number"] = properties[type + '_number'];
      policies["symbol"] = properties[type + '_symbol'];
    }

    function buildValidation(validation, policies) {
      validation["length"] = false;
      validation["uppercase"] = !policies['uppercase'];
      validation["lowercase"] = !policies['lowercase'];
      validation["number"] = !policies['number'];
      validation["symbol"] = !policies['symbol'];
    }

    function validatePassword(newPassword, validation, policies) {
      var password = newPassword;

      validation.length = password && policies.length <= password.length;
      if(policies.uppercase){validation.uppercase = password && password.match(/[A-Z]/g);}
      if(policies.lowercase){validation.lowercase = password && password.match(/[a-z]/g);}
      if(policies.number){validation.number = password && password.match(/[0-9]/g);}
      if(policies.symbol){validation.symbol = password && password.match(/[^a-zA-Z0-9\s]/g);}
    }

    function formPasswordValidation(validation) {
      var passwordIsInvalid = false;
      Object.values(validation).forEach( function (val) {
        if(!val){
          passwordIsInvalid= true;
        }
      });

      return passwordIsInvalid;
    }

    function passwordRenewal(uid, token, new_password) {
      var requestData = {
        uid: uid,
        token: token,
        new_password: new_password
      };
      var deferred = $q.defer();
      $http.post(PASSWORD_RENEWAL_PATH, requestData).then(
        function passwordRenewalSuccess(response) {
          deferred.resolve(response.data);
        },
        function passwordRenewalSuccess(error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

  }
})();

(function(){
	'use strict';

	angular
		.module('icarus.settings')
		.factory('mobileGeneralService', mobileGeneralService);

	/** @ngInject */
	function mobileGeneralService($http, $q, __env, $window) {

		var OBSERVATIONS_PATH = __env.API_URL + 'routes/observations/';

		var observations = null;

		var service = {
			listObservations: listObservations,
			createObservation: createObservation,
			updateObservation: updateObservation,
			removeObservation: removeObservation,
			clear: clear
		};

		$window.mobileGeneralService = service;
		return service;

		//////////////////////////

		function listObservations () {
			var deferred = null;

			if (observations !== null){
				return $q.when(observations);
			}

			deferred = $q.defer();

			$http.get(OBSERVATIONS_PATH)
				.then(function observationListSuccess (response) {
					observations = [];
					response.data.forEach( function (observation) {
						observations.push(observation);
					});

					deferred.resolve(observations);
				})
				.catch(function observationListError (response) {
					deferred.reject(response);
				});

			return deferred.promise;
		}

		function createObservation (observationData) {
			var deferred = $q.defer();

			$http.post(OBSERVATIONS_PATH, observationData)
				.then( function observationCreateSuccess (response) {
					observations.push(response.data);
					deferred.resolve(response.data);
				})
				.catch( function observationCreateError (response) {
					deferred.reject(response);
				});

			return deferred.promise;
		}

		function updateObservation (observation, observationNewData) {
			var deferred = $q.defer();
			var item = null;
			$http.put(OBSERVATIONS_PATH + observation.id + '/', observationNewData)
				.then(function observationUpdateSuccess(response) {
					observations.map(function(observation, index){
						if (observation.id === response.data.id) {
							observations[index] = response.data;
							item = index;
						}
					});
					deferred.resolve(response.data);
				})
				.catch(function observationUpdateError(response) {
					deferred.reject(response);
				});

			return deferred.promise;
		}

		function removeObservation (observation) {
			var deferred = $q.defer();

			$http.delete(OBSERVATIONS_PATH + observation.id + '/').then(
				function observationRemoveSuccess (response) {
					/*var index = drivers.indexOf(driver.id);*/
					for(var i = 0; i < observations.length; i++) {
						if (observations[i].id === observation.id) {
							observations.splice(i, 1);
              break;
						}
					}
					deferred.resolve(response);
				})
				.catch(function observationRemoveSuccess (response) {
					deferred.reject(response);
				});

			return deferred.promise;
		}

		function clear () {
			observations = null;
		}
	}
})();

(function(){
	'use strict';

	angular
		.module('icarus.settings')
		.factory('driversService', driversService);

	/** @ngInject */
	function driversService($http, $q, __env, $window, userService) {

		var DRIVERS_PATH = __env.API_URL + 'accounts/drivers/';
		var USERNAME_EXIST = __env.API_URL + 'accounts/user-exist/';

		var drivers = null;
		var service = {
			list: list,
			getDriverById: getDriverById,
			clear: clear,
			checkUsername: checkUsername,
      getDrivers: getDrivers
		};

		$window.driversService = service;
		return service;

		//////////////////////////

		function list() {
			var deferred = null;
			deferred = $q.defer();

			$http.get(DRIVERS_PATH)
				.then(function (response) {
					drivers = response.data.filter(function (driver) {
            return userService.isActiveUser(driver);
          });

					deferred.resolve(drivers);
				})
				.catch(function (error) {
					deferred.reject(error);
				});

				return deferred.promise;
		}

		function getDriverById(driverId) {
			return list().then(function (drivers) {
				for (var i = 0; i < drivers.length ; i++) {
					if (drivers[i].id === driverId) {
						return drivers[i];
					}
				}
				return $q.reject();
			});
		}

		function checkUsername(driver) {
			var deferred =  $q.defer();

			$http.get(USERNAME_EXIST, {params: {username: driver.username}}).then(
				function succesUsername (response) {
					deferred.resolve(response);
				})
				.catch( function errorUsername (error) {
					deferred.reject(error);
				});

			return deferred.promise;
		}

		function clear() {
			drivers = null;
		}

		function getDrivers() {
      return drivers;
    }
	}
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .factory('accountConfigsService', accountConfigsService);

  /** @ngInject */
  function accountConfigsService($http, __env, $log, $q, store, $cacheFactory) {

    var cache = $cacheFactory("accountConfigs");

    return {
      createOrSaveConfigs: createOrSaveConfigs,
      getAllPublicConfigs: getAllPublicConfigs,
      getConfigByKey: getConfigByKey,
      getValueByKeyFrom: getValueByKeyFrom,
      getValueNumericByKeyFrom: getValueNumericByKeyFrom,
      saveAllConfigs: saveAllConfigs,
      getAllConfigs: getAllConfigs,
      getLogoUrl: getLogoUrl,
      uploadLogo: uploadLogo,
      getAccountConfigValue: getAccountConfigValue,
      isConfigEnabled: isConfigEnabled,
      getConfigRawValue: getConfigRawValue,
      removeCache: removeCache
    };

    /////////////////////////////////////////////
    // Public Methods
    ////////////////////////////////////////////

    function createOrSaveConfigs(requestData) {
      removeCache();
      return $http.post(_accountConfigsUrl(), requestData);
    }

    function getAllPublicConfigs() {
      var deferred = $q.defer();
      $http.get(_accountConfigsUrl()).then(function(response) {
        var publicConfigs = response.data.filter(function(config) {
          return config.is_public;
        });
        deferred.resolve(buildConfigsObject(publicConfigs));
      }, function(error) {
        $log.error('Error retrieving configs');
        deferred.reject(error);
      });
      return deferred.promise;
    }

    function getConfigByKey(key) {
      var deferred = $q.defer();
      $http.get(_accountConfigsUrl(), {cache: cache}).then(function(response) {
        var config = response.data.find(function(row) {
          return row.key === key;
        });
        deferred.resolve(config ? config.value : null);
      }, function(error) {
        $log.error('Error retrieving configs');
        deferred.reject(error);
      });
      return deferred.promise;
    }

    function saveAllConfigs(configs) {
      removeCache();
      var configsPromises = [];

      for (var item in configs) {
        configsPromises.push($http.post(_accountConfigsUrl(), {
          key: item,
          value: configs[item]
        }));
      }

      return $q.all(configsPromises);
    }

    function getAllConfigs() {
      var deferred = $q.defer();
      $http.get(_accountConfigsUrl()).then(function(response) {
        deferred.resolve(buildConfigsObject(response.data));
      }, function(error) {
        $log.error('Error retrieving configs');
        deferred.reject(error);
      });
      return deferred.promise;
    }

    function getLogoUrl() {
      return $http.get(accountLogoUrl());
    }

    function uploadLogo(logo) {
      var formData = new FormData();
      formData.append("logo", logo);
      return $http.post(uploadAccountLogoUrl(), formData, {
        headers: {
        'Content-Type': undefined
        }
      });
    }

    function isConfigEnabled(configToFind) {
      var accountConfigs = store.get('accountConfigs');
      var result = null;
      if (accountConfigs) {
        result = accountConfigs.find(function (config) {
          return config.key === configToFind;
        });
      }

      return result ? result.value : false;
    }

    function getConfigRawValue(configKey) {
      var accountConfigs = store.get('accountConfigs');
      if (!accountConfigs) {
        return null;
      }

      var foundConfig = accountConfigs.find(function (config) {
        return config.key === configKey;
      });

      return foundConfig ? foundConfig.value : null;
    }

    ////////////////////////////////////////////
    // Private Methods
    ////////////////////////////////////////////

    function _accountConfigsUrl() {
      return __env.API_URL + 'accounts/configs/';
    }

    function accountLogoUrl() {
      return __env.API_URL + 'accounts/account/logo/';
    }

    function uploadAccountLogoUrl() {
      return __env.API_URL + 'accounts/account/upload-logo/';
    }

    function buildConfigsObject(configs) {
      var configsObject = {};
      configs.forEach(function(config) {
        configsObject[config.key] = config.value;
      });
      return configsObject;
    }

    function getValueByKeyFrom(key, configs) {
      if (configs instanceof Array) {
        return Boolean(configs.find(function(config) {
          return config.key === key && config.value;
        }));
      }
      return false;
    }
    /**
     * obtains a numerical type value for a selected key.
     * @param {string} key - key with which the value will be sought.
     * @param {object|Array} configs - list of objects that contain a key value.
     * @return {number} search result value.
     */
    function getValueNumericByKeyFrom(key, configs) {
      if (angular.isArray(configs)) {
        var config = configs.find(function(config) {
          return config.key === key && config.value;
        });
        return Number(config ? config.value: -1);
      }
      return -1;
    }

    function getAccountConfigValue(config_name){
      var storedAccountConfigs = store.get('accountConfigs');
      if (storedAccountConfigs) {
        var accountConfig = storedAccountConfigs.find(function (config) {
          return config.key === config_name;
        });
        return accountConfig != null ? accountConfig.value : false;
      }
      return getConfigByKey(config_name);
    }

    function removeCache() {
      if ($cacheFactory.get("accountConfigs")) {
        $cacheFactory.get("accountConfigs").removeAll();
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .controller('SecurityController', SecurityController);

  /** @ngInject */
  function SecurityController($log, $filter, securityService, Toasts, __env,
                              lodash, Idle) {
    var sm = this;
    var $translate = $filter('translate');

    sm.webLengthDisabled = sm.webUppercaseDisabled = sm.webLowercaseDisabled
      = sm.webNumberDisabled = sm.webSymbolDisabled = sm.mobileLengthDisabled
      = sm.mobileUppercaseDisabled = sm.mobileLowercaseDisabled
      = sm.mobileNumberDisabled = sm.mobileSymbolDisabled
      = sm.passwordExpirationDisabled = sm.idleTimeoutDisabled = false;

    sm.addonFound = true;
    sm.security = {};
    sm.saveSecuritySetting = saveSecuritySetting;

    var defaultSettings = {
      'web_length': __env.DEFAULT_MIN_PASSWORD_LENGTH,
      'web_uppercase': false,
      'web_lowercase': false,
      'web_number': false,
      'web_symbol': false,
      'mobile_length': __env.DEFAULT_MIN_PASSWORD_LENGTH,
      'mobile_uppercase': false,
      'mobile_lowercase': false,
      'mobile_number': false,
      'mobile_symbol': false,
      'password_expiration': '0',
      'idle_timeout': '60'
    };

    init();

    ///////////////////////////

    function init() {
      _getSecuritySetting();
    }

    function saveSecuritySetting(data) {
      var body = _buildBodyToSave(data);
      if(!sm.addonFound) {
        securityService.create(body)
          .then(function(res) {
            _updateIdleTimeout();
            Toasts.push('success', $translate('Security.successful_message'));
            // addonFound = true is needed only the second time ever the user
            // save settings, and if that action is made without change tabs.
            sm.addonFound = true;
          })
          .catch(function(err) {
            Toasts.push('error', $translate('Security.error_message'));
            $log.error(err);
          });
      } else {
        securityService.update(body)
          .then(function(res) {
            _updateIdleTimeout();
            Toasts.push('success', $translate('Security.successful_message'));
          })
          .catch(function (err) {
            Toasts.push('error', $translate('Security.error_message'));
            $log.error(err);
          });
      }
    }

    function _buildBodyToSave(data) {
      return {
        'properties': [
          {
            'value': data.web_lowercase,
            'key': 'web_lowercase',
          },
          {
            'value': data.web_uppercase,
            'key': 'web_uppercase',
          },
          {
            'value': data.web_number,
            'key': 'web_number',
          },
          {
            'value': data.web_symbol,
            'key': 'web_symbol',
          },
          {
            'value': data.web_length,
            'key': 'web_length',
          },
          {
            'value': data.mobile_lowercase,
            'key': 'mobile_lowercase',
          },
          {
            'value': data.mobile_uppercase,
            'key': 'mobile_uppercase',
          },
          {
            'value': data.mobile_number,
            'key': 'mobile_number',
          },
          {
            'value': data.mobile_symbol,
            'key': 'mobile_symbol',
          },
          {
            'value': data.mobile_length,
            'key': 'mobile_length',
          },
          {
            'value': parseInt(data.password_expiration),
            'key': 'password_expiration',
          },
          {
            'value': parseInt(data.idle_timeout),
            'key': 'idle_timeout',
          }
        ]
      };
    }

    function _buildBodyToShow(res) {
      var existingPropertyKeys = [];
      res.add_on_properties.forEach(function(property) {
        // 'password_expiration' and 'idle_timeout' select box value
        // is sent as int, but populates the form as string.
        sm.security[property.key] = ['password_expiration', 'idle_timeout'].indexOf(property.key) >= 0 ?
          property.value.toString() : property.value;
        existingPropertyKeys.push(property.key);
      });
      // Default values are set for new security settings
      // (the ones that doesn't exist as part of the current
      // addon and properties).
      var missingPropertyKeys = lodash.difference(
        Object.keys(defaultSettings), existingPropertyKeys
      );
      missingPropertyKeys.forEach(function(missingPropertyKey) {
        sm.security[missingPropertyKey] = defaultSettings[missingPropertyKey];
      });
    }

    function _getSecuritySetting() {
      securityService.get({})
        .then(function (res){
          if (res.status !== 200) {
            if (res.status !== 204) {
              throw 'Unexpected response status: ' + res.status;
            }
            sm.security = defaultSettings;
            sm.addonFound = false;
            return;
          }
          _buildBodyToShow(res.data);
        })
        .catch(function(err) {
          sm.webLengthDisabled = sm.webUppercaseDisabled = sm.webLowercaseDisabled
            = sm.webNumberDisabled = sm.webSymbolDisabled = sm.mobileLengthDisabled
            = sm.mobileUppercaseDisabled = sm.mobileLowercaseDisabled
            = sm.mobileNumberDisabled = sm.mobileSymbolDisabled
            = sm.passwordExpirationDisabled = sm.idleTimeoutDisabled = true;
          Toasts.push('error', $translate('Security.settings_retrieval_error'));
          $log.error(err);
        });
    }

    function _updateIdleTimeout() {
      var minutesUntilAlert = parseInt(sm.security.idle_timeout) - __env.DEFAULT_IDLE_WARNING_FOR_LOGOUT;
      minutesUntilAlert = minutesUntilAlert < 1 ? 1 : minutesUntilAlert;
      Idle.setIdle(60 * minutesUntilAlert);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .factory('ZoneModel', ZoneModel);

  function ZoneModel() {
    function ZoneModel(id, name, coordinates, vehicles, enabled, schedules, restriction_type) {
      this.id = id;
      this.name = name;
      this.coordinates = coordinates;
      this.vehicles = vehicles;
      this.enabled = enabled;
      this.schedules = schedules;
      this.restriction_type = restriction_type; // Will be 'flexible' or null
    }

    ZoneModel.fromJson = function (data) {
      if (!data || !data.id || !data.name || !data.coordinates || !data.vehicles || !Array.isArray(data.vehicles)) {
        throw new Error('Json is not a valid ZoneModel');
      }

      return new ZoneModel(
        data.id,
        data.name,
        data.coordinates,
        data.vehicles,
        data.enabled,
        data.schedules || [],
        data.restriction_type // Keep as is - will be 'flexible' or null
      );
    };

    ZoneModel.fromStringJson = function (stringJson) {
      var data = angular.fromJson(stringJson);
      return ZoneModel.fromJson(data);
    };

    return ZoneModel;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .factory('UserModel', UserModel);

  function UserModel () {
    function UserModel (id, name, username, phone, email, isAdmin, isDriver, isCodriver, isMonitor,
                        isStaff, isCoordinator, isRouter, isRouterJr, blocked, status) {
      this.id = id;
      this.name = name;
      this.username = username;
      this.phone = phone;
      this.email = email;
      this.isAdmin = isAdmin;
      this.isDriver = isDriver;
      this.isCodriver = isCodriver;
      this.isMonitor = isMonitor;
      this.isStaff = isStaff;
      this.isCoordinator = isCoordinator;
      this.isRouter = isRouter;
      this.isRouterJr = isRouterJr;
      this.blocked = blocked;
      this.status = status;
    }

    UserModel.fromJson = function (data) {
      if (!data || !data.id || !data.name || !data.username) {
        throw new Error('Json is not a valid UserModel');
      }
      return new UserModel(
        data.id,
        data.name,
        data.username,
        data.phone,
        data.email,
        data.is_admin,
        data.is_driver,
        data.is_codriver,
        data.is_monitor,
        data.is_staff,
        data.is_coordinator,
        data.is_router,
        data.is_router_jr,
        data.blocked,
        data.status
      );
    };

    UserModel.fromStringJson = function (stringJson) {
      var data = angular.fromJson(stringJson);
      return UserModel.fromJson(data);
    };

    return UserModel;

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .controller('MobileGeneralsListController', MobileGeneralsListController);

  /** @ngInject */
  function MobileGeneralsListController($scope, $log, $filter, $rootScope, mobileGeneralService,
                                        sessionService, accountConfigsService, ngDialog, Toasts, $timeout) {

    var vm = this;
    var $translate = $filter('translate');
    var observations = [];
    var account = null;

    vm.form = {};
    vm.mobile = {label: null, type: null};
    vm.typeObservation = [
      {id: 'completed', name: $translate('Mobile_general.completed')},
      {id: 'failed', name: $translate('Mobile_general.failed')}];
    vm.maxSize = 3;
    vm.currentPage = 1;
    vm.itemsPerPage = 15;
    vm.accountConfigs = {
      enable_observations: false,
      checkout_similars: false,
      enable_signature: false,
      mandatory_success_checkout_picture: false,
      mandatory_failed_checkout_picture: false

    };
    vm.mandatory_checkout_picture = false;

    vm.save = save;
    vm.showDeleteModal = showDeleteModal;
    vm.editObservation = editObservation;
    vm.saveAccountConfig = saveAccountConfig;
    vm.saveConfigsMobile = saveConfigsMobile;
    vm.checkMandatoryPictureOptions = checkMandatoryPictureOptions;
    vm.toggleMandatoryCheckoutPictures = toggleMandatoryCheckoutPictures;

    activate();

    function activate() {
      mobileGeneralService.listObservations().then(successGetObservations, errorGetObservations);
      sessionService.getUser().then(successGetUser, errorGetUser);

      function successGetObservations(observations) {
        vm.observations = observations;
        _checkEnableActivationObservation();
      }

      function errorGetObservations(error) {
        $log.info('errorGetObservations', error);
      }
    }

    //////////////////////////////////////////
    // Public Methodsº
    /////////////////////////////////////////

    function save() {
      if (vm.form.$invalid) {
        return;
      }
      observations = {label: vm.mobile.label, type: vm.mobile.type.id};
      vm.editing ? _editObservation(observations) : _createObservation(observations);
    }

    function showDeleteModal() {
      $scope.deleteObservation = deleteObservation;

      ngDialog.open({
        template: 'app/settings/mobile-general/observation-delete-modal.html',
        scope: $scope
      });
    }

    function editObservation(observacion) {
      vm.observationEdit = observacion;
      vm.mobile.label = observacion.label;
      vm.mobile.type = _searchType(observacion.type);
      vm.editing = true;
    }

    function saveAccountConfig(key) {
      if (!account) {
        return;
      }

      var requestData = {
        key: key,
        value: vm.accountConfigs[key]
      };

      vm.accountConfigsLoader = true;
      accountConfigsService.createOrSaveConfigs(requestData)
        .then(function successConfig(response) {
          $log.info(response.data);
          sessionService.changeAccountConfigs(requestData);
        }).catch(function (error) {
        $log.error(error);
        Toasts.push('error', $translate('Mobile_general.Accounts_settings.error_save_configs'));
      }).finally(function () {
        $timeout(function () {
          vm.accountConfigsLoader = false;
        }, 3000);
      });

    }

    function saveConfigsMobile() {
      $rootScope.isLoading = true;
      accountConfigsService.saveAllConfigs(vm.accountConfigs)
        .then(function (data) {
          $log.info(data);
          Toasts.push('success', $translate('Account.configs_saved_success'));
        }).catch(function (error) {
        $log.info(error);
        Toasts.push('error', $translate('Account.configs_saved_fail'));
      }).finally(function () {
        $rootScope.isLoading = false;
      });

    }

    function checkMandatoryPictureOptions() {
      vm.mandatory_checkout_picture = (
        vm.accountConfigs.mandatory_failed_checkout_picture || vm.accountConfigs.mandatory_success_checkout_picture
      );
    }

    function toggleMandatoryCheckoutPictures() {
      vm.accountConfigs.mandatory_success_checkout_picture = vm.mandatory_checkout_picture;
      vm.accountConfigs.mandatory_failed_checkout_picture = vm.mandatory_checkout_picture;
    }

    //////////////////////////////////////////
    // Privates Methodsº
    /////////////////////////////////////////


    function successGetUser(user) {
      account = user.account;
      accountConfigsService.getAllPublicConfigs().then(function (configs) {
        setConfigsValueLocal(configs);
      });
    }

    function errorGetUser(error) {
      $log.info(error);
    }

    function setConfigsValueLocal(configs){
      vm.accountConfigs.enable_signature = configs.enable_signature;
      vm.accountConfigs.checkout_similars = configs.checkout_similars;
      vm.accountConfigs.mandatory_success_checkout_picture = configs.mandatory_success_checkout_picture;
      vm.accountConfigs.mandatory_failed_checkout_picture = configs.mandatory_failed_checkout_picture;
      vm.mandatory_checkout_picture = configs.mandatory_success_checkout_picture || configs.mandatory_failed_checkout_picture;
      if (angular.isDefined(vm.accountConfigs.enable_observations)) {
        vm.accountConfigs.enable_observations = configs.enable_observations;
      }
    }

    function deleteObservation() {
      mobileGeneralService.removeObservation(vm.observationEdit)
        .then(
          function successRemoveObservation() {
            vm.mobile = {};
            vm.form.$setPristine();
            vm.form.$setUntouched();
            vm.form.$submitted = false;
            _checkEnableActivationObservation();
          },
          function errorRemoveObservation(error) {
            $log.info('errorRemoveObservation', error);
            Toasts.push('error', $translate('Mobile_general.error_delete_observations'));
          });
      vm.editing = false;
    }

    function _createObservation() {
      mobileGeneralService.createObservation(observations)
        .then(_successCreateOrSaveObservation, _errorCreateOrSaveObservation);
    }

    function _editObservation() {
      mobileGeneralService.updateObservation(vm.observationEdit, observations)
        .then(_successCreateOrSaveObservation, _errorCreateOrSaveObservation);
    }

    function _successCreateOrSaveObservation() {
      vm.mobile = {};
      vm.form.$setPristine();
      vm.form.$setUntouched();
      vm.form.$submitted = false;
      vm.editing = false;
      _checkEnableActivationObservation();
    }

    function _errorCreateOrSaveObservation(error) {
      $log.info('errorCreateObservation', error);
      if (error.status === 400 && error.data.non_field_errors) {
        Toasts.push('error', $translate('Mobile_general.error_duplicated_observations'));
      } else {
        vm.mobile = {};
        vm.form.$setPristine();
        vm.form.$setUntouched();
        vm.form.$submitted = false;
        Toasts.push('error', $translate('Mobile_general.error_create_observations'));
      }
    }

    function _searchType(type) {
      for (var i = 0; i < vm.typeObservation.length; i++) {
        if (type === vm.typeObservation[i].id) {
          return vm.typeObservation[i];
        }
      }
    }

    function _checkEnableActivationObservation() {
      if (vm.observations.length === 0) {
        delete vm.accountConfigs['enable_observations'];
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .constant('FMB_ROUTING_OPTION', 'fmb')
    .constant('FMV_ROUTING_OPTION', 'fmv')
    .constant('BASE_TRANSLATE_PATH', 'General.optimization.')
    .constant('SETTINGS_OPTIMIZATION_OPTIONS', {
      ALL_VEHICLES: 'all_vehicles',
      AUTO_REORDER: 'auto_reorder',
      BALANCE: 'balance',
      BEAUTY: 'beauty',
      BEAUTY_FACTOR: 'beauty_factor',
      BIG_VRP: 'big_vrp',
      DISTANCE_TO_JOIN_VISITS: 'distance_to_join_visits',
      ENABLE_GRAPHS: 'enable_graphs',
      ENABLE_SOFT_WINDOW: 'enable_soft_window',
      JOIN: 'join',
      JOIN_V2: 'join_v2',
      OPEN_ENDED: 'open_ended',
      OPEN_START: 'open_start',
      SINGLE_TOUR: 'single_tour',
      TRAFFIC_FACTOR: 'traffic_factor',
      USE_EUCLIDEAN_DISTANCE: 'use_euclidean_distance'
    })
    .constant('MIN_DISTANCE_TO_JOIN_VISITS_METERS', 0)
    .constant('MAX_DISTANCE_TO_JOIN_VISITS_METERS', 100)
    .constant('DISTANCE_TO_JOIN_VISITS_INPUT_ID', 'distance-to-join-visits-input')
    .constant('DISTANCE_TO_JOIN_VISITS_INPUT_STEP', 1);
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .controller('GeneralsListController', GeneralsListController);

  /** @ngInject */
  function GeneralsListController(plannerService, sessionService, accountConfigsService, $filter, $scope, $timeout, FMB_ROUTING_OPTION,
                                  FMV_ROUTING_OPTION, BASE_TRANSLATE_PATH, SETTINGS_OPTIMIZATION_OPTIONS,
                                  MIN_DISTANCE_TO_JOIN_VISITS_METERS, MAX_DISTANCE_TO_JOIN_VISITS_METERS,
                                  visitJoinerService, DISTANCE_TO_JOIN_VISITS_INPUT_ID,
                                  DISTANCE_TO_JOIN_VISITS_INPUT_STEP, __env) {
    //TODO: agregar validacion, hacer consulta y crear xlsx
    var vm = this;
    var DISTANCE_TO_JOIN_VISITS_INPUT_TRANSLATE_PATH = BASE_TRANSLATE_PATH + 'distance_to_join_visits_input.';
    var TOOLTIP_MESSAGES_TRANSLATE_PATH = BASE_TRANSLATE_PATH + 'tooltip.';
    var lastOptimizationOptions = null;
    var $translate = $filter('translate');

    vm.ALL_VEHICLES_OPTION = SETTINGS_OPTIMIZATION_OPTIONS.ALL_VEHICLES;
    vm.DISTANCE_TO_JOIN_VISITS_OPTION = SETTINGS_OPTIMIZATION_OPTIONS.DISTANCE_TO_JOIN_VISITS;
    vm.MIN_DISTANCE_TO_JOIN_VISITS = MIN_DISTANCE_TO_JOIN_VISITS_METERS;
    vm.MAX_DISTANCE_TO_JOIN_VISITS = MAX_DISTANCE_TO_JOIN_VISITS_METERS;
    vm.DISTANCE_TO_JOIN_VISITS_INPUT_ID = DISTANCE_TO_JOIN_VISITS_INPUT_ID;
    vm.DISTANCE_TO_JOIN_VISITS_INPUT_STEP = DISTANCE_TO_JOIN_VISITS_INPUT_STEP;

    vm.optimizationOptions = {
      balance: {editable: false, value: false},
      all_vehicles: {editable: false, value: true},
      open_start: {editable: false, value: false},
      open_ended: {editable: false, value: false},
      join: {editable: false, value: false},
      join_v2: {editable: false, value: false},
      fmv: {editable: true, value: 1.5},
      fmb: {editable: true, value: 3.0},
      single_tour: {editable: false, value: false},
      beauty: {editable: false, value: false},
      big_vrp: {editable: false, value: false},
      use_euclidean_distance: {editable: false, value: false},
      enable_graphs: {editable: false, value: false},
      auto_reorder: {editable: false, value: false},
      enable_soft_window: {editable: false, value: false},
      distance_to_join_visits: {editable: false, value: null, isEnabled: false}
    };

    vm.distanceToJoinVisitsInputMessages = {
      title: $translate(DISTANCE_TO_JOIN_VISITS_INPUT_TRANSLATE_PATH + 'title'),
      placeholder: $translate(DISTANCE_TO_JOIN_VISITS_INPUT_TRANSLATE_PATH + 'placeholder'),
      error_required: $translate(DISTANCE_TO_JOIN_VISITS_INPUT_TRANSLATE_PATH + 'error_required'),
      error_max_value: $translate(DISTANCE_TO_JOIN_VISITS_INPUT_TRANSLATE_PATH + 'error_max_value')
    };

    vm.trafficSlider = {
      options: {
        floor: 3,
        ceil: 0,
        showSelectionBar: true,
        hideLimitLabels: true,
        hidePointerLabels: true,
        stepsArray: [
          { value: 3 },
          { value: 2 },
          { value: 1.5 },
          { value: 1 }
        ]
      }
    };

    vm.beautySlider = {
      options: {
        floor: 1,
        ceil: 5,
        showSelectionBar: true,
        hideLimitLabels: true,
        hidePointerLabels: true,
        stepsArray: [
          { value: 1 },
          { value: 2 },
          { value: 3 },
          { value: 4 },
          { value: 5 }
        ]
      }
    };

    vm.isPressed = false;

    vm.optimizationChanged = optimizationChanged;
    vm.checkOptions = checkOptions;
    vm.isNumericOptimizationOption = isNumericOptimizationOption;
    vm.getOptimizationOptionId = getOptimizationOptionId;
    vm.getTranslatedOptimizationOption = getTranslatedOptimizationOption;
    vm.mustShowDistanceToJoinVisitsInput = mustShowDistanceToJoinVisitsInput;
    vm.validateDistanceToJoinVisitsInput = validateDistanceToJoinVisitsInput;

    activate();

    /////////////////////////////////////////////////////////////////////////

    function activate() {
      vm.tooltipMessages = _generateTooltipMessages();
      accountConfigsService.getAllConfigs()
        .then(function (accountConfigs) {
          var accountConfigsForRoutingOptions = plannerService.ACCOUNT_CONFIGS_FOR_ROUTING_OPTIONS;
          accountConfigsForRoutingOptions.forEach(function(config) {
            if (!accountConfigs[config.name]) {
              _removeConfig(config.option, vm.optimizationOptions);
              plannerService.removeDefaultRoutingOption(config.option);
            }
          });
          $timeout(function(){
            updateOptions();
            updateDefaultRoutingOptions(vm.optimizationOptions);
        }, 650);
        });
      broadcast();
    }

    function broadcast() {
      $timeout(function(){
          $scope.$broadcast('reCalcViewDimensions');
      }, 450);
    }  

    function _generateTooltipMessages() {
      var tooltipMessages = {};
      Object.values(SETTINGS_OPTIMIZATION_OPTIONS).forEach(function(optimizationOption) {
        tooltipMessages[optimizationOption] = $translate(TOOLTIP_MESSAGES_TRANSLATE_PATH + optimizationOption);
      });
      return tooltipMessages;
    }

    function updateOptions() {
      // set the optimization options in order to be selected in step 2
      var displayedOptions = plannerService.getOptimizationOptionsDisplayed();
      angular.forEach(plannerService.optimizationOptions, function (v, k) {
        if (vm.optimizationOptions.hasOwnProperty(k)) {
          if (displayedOptions.indexOf(k) !== -1) {
            vm.optimizationOptions[k].editable = true;
          }
          vm.optimizationOptions[k].value = v;
        }
      });

      vm.optimizationOptions.distance_to_join_visits.isEnabled = visitJoinerService.isDistanceToJoinVisitsEnabled(
        vm.optimizationOptions.distance_to_join_visits.value);

      for (var key in vm.optimizationOptions) {
        vm.checkOptions(key);
      }
      // backup values in case of rollback
      lastOptimizationOptions = angular.copy(vm.optimizationOptions);
    }

    function updateDefaultRoutingOptions(optimizationOptions) {
      var routingOptions = Object.keys(optimizationOptions).reduce(function (routingOptionsAcc, key) {
        if (!vm.isNumericOptimizationOption(key)) {
          routingOptionsAcc[key] = optimizationOptions[key].value;
        }

        return routingOptionsAcc;
      }, {});

      plannerService.setDefaultRoutingOptions(routingOptions);
    }

    function checkOptions(key) {
      switch (key) {
        case SETTINGS_OPTIMIZATION_OPTIONS.OPEN_START:
          if (vm.optimizationOptions.open_start.value) {
            vm.optimizationOptions.enable_soft_window.value = false;
          }
          break;
        case SETTINGS_OPTIMIZATION_OPTIONS.OPEN_ENDED:
          if (vm.optimizationOptions.open_ended.value) {
            vm.optimizationOptions.enable_soft_window.value = false;
          }
          break;
        case SETTINGS_OPTIMIZATION_OPTIONS.JOIN_V2:
          if (vm.optimizationOptions.join.value && vm.optimizationOptions.join_v2.value) {
            vm.optimizationOptions.join.value = false;
          }
          break;
        case SETTINGS_OPTIMIZATION_OPTIONS.JOIN:
          if (vm.optimizationOptions.join.value && vm.optimizationOptions.join_v2 && vm.optimizationOptions.join_v2.value) {
            vm.optimizationOptions.join_v2.value = false;
          }
          break;
        case SETTINGS_OPTIMIZATION_OPTIONS.ENABLE_SOFT_WINDOW:
          if (vm.optimizationOptions.enable_soft_window.value) {
            vm.optimizationOptions.open_start.value = false;
            vm.optimizationOptions.open_ended.value = false;
          }
          break;
        case SETTINGS_OPTIMIZATION_OPTIONS.DISTANCE_TO_JOIN_VISITS:
          if (!vm.optimizationOptions.distance_to_join_visits.isEnabled) {
            _resetDistanceToJoinVisitsOption();
          }
          break;
      }
    }

    function _resetDistanceToJoinVisitsOption() {
      vm.optimizationOptions.distance_to_join_visits.editable = false;
      vm.optimizationOptions.distance_to_join_visits.value = null;
    }

    function optimizationChanged(options) {
      var newOptions = {displayed_options: []};
      angular.forEach(options, function (v, k) {
        if (v.editable && !vm.isNumericOptimizationOption(k)) {
          newOptions.displayed_options.push(k);
        }
        newOptions[k] = v.value;
      });

      // Show loader
      vm.optimizationOptionsLoader = true;
      sessionService.updateOptimizationOptions(newOptions)
        .then(function (response) {
          vm.optimizationOptionsLoader = false;
          vm.isPressed = false;
          // Copy updated options to localOptions used in plannerService
          angular.forEach(newOptions, function (v, k) {
            if (plannerService.localOptimizationOptions.hasOwnProperty(k)) {
              var value = vm.isNumericOptimizationOption(k) ? parseFloat(v) : v;
              plannerService.localOptimizationOptions[k] = value;
              plannerService.optimizationOptions[k] = value;
            } else {
              // only different attribute 'displayed_options'
              plannerService.setOptimizationOptionsDisplayed(v);
            }
          });
          // Retrieve account and accept changes
          lastOptimizationOptions = options;
          // Update optimization options because user is a local var
          sessionService.setOptimizationOptions(response.data.optimization_options);
          plannerService.setDefaultRoutingOptions(response.data.optimization_options);
        })
        .catch(function () {
          vm.optimizationOptionsLoader = false;
          // Show alert

          //rollback changes
          vm.optimizationOptions = angular.copy(lastOptimizationOptions);
        });
    }

    function _removeConfig(option, optimizationOptions) {
      delete optimizationOptions[option];
    }

    function isNumericOptimizationOption(option) {
      return (option === FMV_ROUTING_OPTION || option === FMB_ROUTING_OPTION);
    }

    function getOptimizationOptionId(option) {
      return option.replaceAll('_', '-') + '-label';
    }

    function getTranslatedOptimizationOption(option) {
      return $translate(BASE_TRANSLATE_PATH + option);
    }

    function mustShowDistanceToJoinVisitsInput(optimizationOption, isOptionEnabled) {
      return optimizationOption === SETTINGS_OPTIMIZATION_OPTIONS.DISTANCE_TO_JOIN_VISITS && isOptionEnabled;
    }

    function validateDistanceToJoinVisitsInput() {
      var inputElement = document.getElementById(DISTANCE_TO_JOIN_VISITS_INPUT_ID);
      var inputValue = inputElement.value.toString();
      var isInputInvalid = (inputValue === '-0') || inputElement.validity.stepMismatch;
      isInputInvalid && vm.form.distanceToJoinVisitsInput.$setValidity('number', false);
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .controller('FleetsController', FleetsController);

  /** @ngInject */
  function FleetsController($scope, $rootScope, fleetService, $filter, Toasts, ngDialog, plannerService, userService) {

    var $translate = $filter('translate');
    var vm = this;

    vm.fleets   = [];
    vm.vehicles = [];
    vm.webUsers = [];
    vm.newFleetName = '';

    vm.selectedFleet = null;

    vm.dataSelectableItemsVehicles = {
      items: vm.vehicles,
      title: $translate('Fleets.vehicles'),
      icon: 'sp-icon-vehiculos',
      msgItemsEmpty: $translate('Fleets.vehicles'),
      callAction: $translate('Fleets.create_vehicle'),
      callActionUrl: 'settings.vehicles.create',
      itemsSelected: 0
    };

    vm.dataSelectableItemsUsers = {
      items: vm.webUsers,
      title: $translate('Fleets.users'),
      icon: 'sp-icon-user',
      msgItemsEmpty: $translate('Fleets.users'),
      callAction: $translate('Fleets.create_user'),
      callActionUrl: 'settings.users.create',
      itemsSelected: 0
    };

    vm.showVehicleList = false;
    vm.fleetNameEdited = null;
    vm.enableEdition = true;

    vm.saveFleet = saveFleet;
    vm.selectFleet = selectFleet;
    vm.isSaveEnabled = isSaveEnabled;
    vm.cancel = cancel;
    vm.openVehicleListForNewFleet = openVehicleListForNewFleet;
    vm.openDeleteConfirmModal = openDeleteConfirmModal;

    activate();
    ////////////
    function activate() {
      fleetService.listVehicles().then(function(vehicles) {
        vm.vehicles = vehicles;
        vm.dataSelectableItemsVehicles.items = vm.vehicles.map(function (vehicle) {
            vehicle.activate = false;
            return vehicle;
        });
        loadFleets();
      }).catch(function() {
        vm.vehicles = [];
      });

      userService.listWebUsers().then(function(webUsers) {
        vm.webUsers = webUsers;
        vm.dataSelectableItemsUsers.items = vm.webUsers.map(function (users) {
          users.activate = false;
          return users;
        });
      });
    }

    function loadFleets() {
      return fleetService.getFleets().then(function(fleets) {
        vm.fleets = fleets;
      }).catch(function() {
        vm.fleets = [];
      });
    }

    function deactivateAllVehicles() {
      vm.dataSelectableItemsVehicles.itemsSelected = 0;
      vm.vehicles.forEach(function(vehicle) {
        vehicle.activate = false;
      });
    }

    function deactivateAllAdminUsers() {
      vm.dataSelectableItemsUsers.itemsSelected = 0;
      vm.webUsers.forEach(function (user) {
          user.activate = false;
      });
    }

    function selectFleet (fleet) {
      vm.selectedFleet = fleet;
      vm.fleetNameEdited = fleet.name;
      vm.enableEdition = true;
      vm.showVehicleList = true;
      vm.newFleetName = '';
      deactivateAllVehicles();
      deactivateAllAdminUsers();
      vm.selectedFleet.vehicles.forEach(function(vehicleId) {
        var vehicleIndex = vm.vehicles.findIndex(function(vehicle) {
          return vehicle.id === vehicleId;
        });
        if (vehicleIndex !== -1 && angular.isDefined(vehicleIndex)) {
          vm.vehicles[vehicleIndex].activate = true;
          vm.dataSelectableItemsVehicles.itemsSelected++;
        }
      });
      vm.selectedFleet.users.forEach(function (userId) {
        var userIndex = vm.webUsers.findIndex(function (user) {
          return user.id === userId;
        });
        if (userIndex !== -1 && angular.isDefined(userIndex)) {
          vm.webUsers[userIndex].activate = true;
          vm.dataSelectableItemsUsers.itemsSelected++;
        }
      });
    }

    function buildFleetData(id, name) {
      var fleetData = {
        name: name ?  name : vm.newFleetName,
        vehicles: vm.vehicles.filter(function(vehicle) {
          return vehicle.activate;
        }).map(function(vehicle) {
          return vehicle.id;
        }),
        users: vm.webUsers.reduce(function(acc, user) {
          if (user.activate) {
            acc.push(user.id);
          }
          return acc;
        }, [])
      };

      fleetData = id ? angular.extend({}, fleetData, {id: id}) : fleetData;
      return fleetData;
    }

    function updateSelectedFleet() {
      loadFleets().then(function() {
        vm.selectedFleet = vm.fleets.find(function(fleet) {
          return fleet.name === vm.newFleetName;
        });
        if (vm.selectedFleet) {
          vm.newFleetName = '';
        }
      });

    }

    function createFleet() {
      var newFleetData = buildFleetData();
      if (newFleetData.vehicles.length) {
        $rootScope.isLoading = true;
        fleetService.createFleet(newFleetData).then(function () {
          updateSelectedFleet();
          Toasts.push('success', $translate('Fleets.create_fleet_success_msg'));
        }).catch(function(error) {
          var errorTranslateKey = error.data.indexOf('duplicate key') !== -1 ?
            'Fleets.create_fleet_duplicate_name_error_msg' : 'Fleets.create_fleet_error_msg';
          Toasts.push('error', $translate(errorTranslateKey));
        }).finally(function () {
          $rootScope.isLoading = false;
          vm.enableEdition = true;
        });
      }
    }

    function isSaveEnabled() {

      var isEnabled = false;

      var isSelected = function(item) {
        return item.activate;
      };

      var areVehiclesAndUsersSelected = vm.vehicles.find(isSelected) &&
        vm.webUsers.find(isSelected);

      if (vm.selectedFleet) {
        isEnabled = (areVehiclesAndUsersSelected &&
          (vm.fleetNameEdited || vm.selectedFleet.name));
      }
      else {
        isEnabled = (areVehiclesAndUsersSelected && vm.newFleetName);
      }

      return Boolean(isEnabled);
    }

    function openVehicleListForNewFleet() {
      vm.selectedFleet = null;
      deactivateAllVehicles();
      deactivateAllAdminUsers();
      vm.showVehicleList = true;
      vm.enableEdition = false;
      vm.fleetNameEdited = vm.newFleetName;
    }

    function deleteFleet(fleetId) {
      $rootScope.isLoading = true;
      fleetService.deleteFleet(fleetId).then(function () {
        var fleetSelected = plannerService.getSelectedFleet();
        if (fleetSelected && parseInt(fleetSelected.id) === parseInt(fleetId)) {
          plannerService.setSelectedFleet(null);
        }
        vm.showVehicleList = false;
        loadFleets();
        Toasts.push('success', $translate('Fleets.delete_fleet_success_msg'));
      }).catch(function (error) {
        Toasts.push('error', $translate('Fleets.delete_fleet_error_msg'));
      }).finally(function () {
        $rootScope.isLoading = false;
      });
    }

    function openDeleteConfirmModal() {
      ngDialog.openConfirm({
        template: 'app/settings/fleets/confirm-delete-fleet.modal.html'
      }).then(function () {
        deleteFleet(vm.selectedFleet.id);
      });
    }

    function updateFleet() {
      var fleetName = vm.fleetNameEdited ? vm.fleetNameEdited : vm.selectedFleet.name;
      var newFleetData = buildFleetData(vm.selectedFleet.id, fleetName);

      $rootScope.isLoading = true;

      vm.enableEdition = true;
      fleetService.updateFleet(newFleetData.id, newFleetData)
        .then(function() {
          vm.selectedFleet = newFleetData;
          vm.fleets = vm.fleets.map(function(fleet) {
            return fleet.id === newFleetData.id ? newFleetData : fleet;
          });

          Toasts.push('success', $translate('Fleets.update_fleet_success_msg'));
        })
        .catch(function(response) {
          var error = response && response.data;
          Toasts.push('error', $translate(getErrorKey(error)));
        })
        .finally(function() {
          $rootScope.isLoading = false;
        });
    }

    function saveFleet() {
      if (!vm.selectedFleet) {
        createFleet();
      }else {
        updateFleet();
      }
    }

    function getErrorKey(error) {
      var errorKey = 'Fleets.update_fleet_error_default';
      if (error && error instanceof Object) {
        var keys = Object.keys(error);
        var key = keys.length > 0 ? keys[0] : null;
        var fleetDoesntExist = /matching(.|\s)+not\sexist/gi;
        var vehiclesDontExist = /vehicles.+exist/gi;
        var duplicatedName = /unique/gi;

        if (key === 'non_fields_errors' && fleetDoesntExist.test(error[key][0])) {
          errorKey = 'Fleets.update_fleet_error_not_exist_msg';
        }else if (key === 'vehicles' && vehiclesDontExist.test(error[key][0])) {
          errorKey = 'Fleets.update_fleet_error_vehicles_not_exists_msg';
        }else if (key === 'name' && duplicatedName.test(error[key][0])) {
          errorKey = 'Fleets.update_fleet_error_duplicated_name_msg';
        }
      }

      return errorKey;
    }

    function cancel() {
      vm.selectedFleet = null;
      vm.newFleetName = '';
      vm.fleetNameEdited = null;
      vm.enableEdition = true;
      vm.showVehicleList = false;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.settings')
    .filter('orderUsersSettings', orderUsersSettings);

  /** @ngInject */
  function orderUsersSettings (orderByFilter) {
    return function(users, currentUser) {
      var filteredUsers = users.filter(function(user) {
        // If currentUser is admin then exclude all admins and owners
        // Else if currentUser is Owner then only exclude it self

        return (!((currentUser.role === 1 && (user.isAdmin || user.isOwner)) ||
               (currentUser.role === 0 && currentUser.id === user.id)));
      });

      return orderByFilter(filteredUsers, '+name');
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.settings')
    .filter('orderObservationsSettings', orderObservationsSettings);

  /** @ngInject */
  function orderObservationsSettings () {
    return function(items) {
      var failed = [];
      var completed = [];

      angular.forEach(items, function(item) {

        if (item.type === 'completed') {
          completed.push(item);
          return;
        }
        
        if (item.type === 'failed') {
          failed.push(item);
          return;
        }
        
      });

      // ordernar alfabeticamente cada lista
      failed.sort( function (a,b) {
        return a.label < b.label ? -1: 1;
      });
      completed.sort( function (a,b) {
        return a.label < b.label ? -1: 1;
      });

      return [].concat(completed).concat(failed);
    };


  }
})();                         
(function() {
  'use strict';

  angular
    .module('icarus')
    .directive('spToggle', ['__env', spToggle]);

  /** @ngInject */
  function spToggle(__env){
    var toggles = __env.TOGGLES;
    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        scope.toggle = attr.spToggle;
        scope.$watch('toggle', function (value) {
          if(toggles[value]) {
            element.show();
          } else {
            element.hide();
          }
        }, true);
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('icarus')
    .directive('spToggleConfig', ['__env', spToggleConfig]);

  /** @ngInject */
  function spToggleConfig(){
    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        attr.$observe('spToggleConfig', function(value){
          var active = (value === 'true');
          if (active) {
            element.show();
          } else {
            element.hide();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('icarus')
    .directive('spCopy', ['$window', spCopy]);

  /** @ngInject */
  function copy ($window, toCopy) {
      var body = angular.element(window.document.body);
      var textarea = angular.element('<textarea/>');
      textarea.css({
        position: 'fixed',
        opacity: '0'
      });
      textarea.val(toCopy);
      body.append(textarea);
      textarea[0].select();

      try {
        var successful = document.execCommand('copy');
      } catch (err) {
        $window.prompt("Copy to clipboard: Ctrl+C, Enter", toCopy);
      }

      textarea.remove();
  }

  function spCopy($window){
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind('click', function (e) {
          copy($window, attrs.spCopy);
        });
      }
    };
  }

})();

(function() {
	'use strict';

	angular
		.module('icarus.settings')
		.directive('percentageInputFormat', [percentageInputFormat]);

	/** @ngInject */
	function percentageInputFormat(){
		return {
			require: 'ngModel',
			link: function (scope, element, attr, ngModelCtrl) {

				function percentageParserFormatter(text) {
					var textInput = "0";
					if (text) {
						textInput = text.replace(/(?!\d)./g, "");
						var number = parseInt(textInput) || 0;
						if (number > 100) {
							textInput = number.toString().slice(0, -1);
							ngModelCtrl.$setValidity('invalid', false);
						}
						else {
							textInput = number.toString();
						}
					}
					if (textInput !== text) {
						ngModelCtrl.$setViewValue(textInput);
						ngModelCtrl.$render();
					}
					return textInput;
				}
				ngModelCtrl.$formatters.unshift(percentageParserFormatter);
				ngModelCtrl.$parsers.unshift(percentageParserFormatter);
			}
		};
	}

})();

(function() {
	'use strict';

	angular
		.module('icarus.settings')
		.directive('capacityInputFormat', ['$filter','$translate', capacityInputFormat]);

	/** @ngInject */
	function capacityInputFormat($filter, $translate){
		var languageEs = "es";
		var language = $translate.use();

		return {
			require: 'ngModel',
			link: function (scope, element, attr, ngModelCtrl) {
				function fromUser(text) {
					if (text) {
						var textDecimal = null;
						
						var transformedInput = null;
						if (language === languageEs && typeof text === 'number') {
							text = String(text).replace(".",",");
						}

						if (language === languageEs) {
							text =  String(text).replace(/[^0-9\.,]/g, '').split('.').join('');
							if (text.indexOf(',')>-1) {
								textDecimal = ","+text.split(',')[1].substring(0, 2);
							} else {
								textDecimal = "";
							}

							text = text.split(',')[0];
							transformedInput = text.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
						} else {
							text =  String(text).replace(/[^0-9.]/g, "");
							if (text.indexOf('.')>-1) {
								textDecimal = "."+text.split('.')[1].substring(0, 2);
							} else {
								textDecimal = "";
							}

							text = text.split('.')[0];
							transformedInput = text.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
						}
						
						transformedInput = transformedInput+textDecimal;
						//if(transformedInput !== text){
						ngModelCtrl.$setViewValue(transformedInput);
						ngModelCtrl.$render();
						//}
						return transformedInput;
					}
					return undefined;
				}
				ngModelCtrl.$formatters.push(fromUser);
				ngModelCtrl.$parsers.push(fromUser);
			}
		};
	}

})();
(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .component('zoneMap', {
      controller: zoneMapController,
      templateUrl: 'app/settings/components/zoneMap.html',
      bindings: {
        data: '<'
      }
    });

  /** @ngInject */
  function zoneMapController(__env, $log, $rootScope, $scope, zoneService, zoneMapService, MapModel,
                             accountConfigsService, ACCOUNT_CONFIGS) {
    var ctrl = this;
    var polygonOptions = {
      fillColor: '#335F72',
      fillOpacity: 0.5,
      strokeOpacity: 0,
      strokeWeight: 1,
      editable: true,
      zIndex: 1
    };

    var adjacentPolygonOptions = {
      fillColor: '#999999',
      fillOpacity: 0.5,
      strokeWeight: 0
    };

    ctrl.map = null;
    ctrl.polygon = null;
    ctrl.resetAvailable = false;
    ctrl.resetZone = resetZone;

    activate();

    function _getCoordinatesParse(polygon) {
      var result = polygon.getPath().map(function (position) {
        return {
          lat: position.latitude.toFixed(6),
          lng: position.longitude.toFixed(6)
        };
      });

      ctrl.data.coordinates = JSON.stringify(result).replace(/"/g, "'");
    }

    function _polygonChanged() {
      _getCoordinatesParse(ctrl.polygon);
    }

    function _onZoneCompleted(polygon) {
      ctrl.polygon = polygon;
      polygon.makeResizable(_polygonChanged);
      _getCoordinatesParse(polygon);
      ctrl.map.setDrawingManagerOptions({ drawingControl: false, drawingMode: null });
      $scope.$apply(function () {
        ctrl.resetAvailable = true;
      });
    }

    function _drawZone(map) {
      var polygon = map.makePolygon(zoneMapService.getZoneOptions(polygonOptions, ctrl.data.coordinates));
      ctrl.polygon = polygon;
      polygon.makeResizable(_polygonChanged);
      _getCoordinatesParse(polygon);
      map.fitBounds(polygon.getPath());
    }

    function _initDrawing(map) {
      if (ctrl.data.coordinates && ctrl.data.coordinates.length > 0) {
        _drawZone(map);
      } else {
        map.makeDrawingManager(zoneMapService.getDrawingManagerOptions(polygonOptions));
        map.setListenerToCompletedPolygon(_onZoneCompleted);
      }

      zoneService.getCoordinatesOfAllZones(ctrl.data)
        .then(function (adjacentZones) {
          adjacentZones.forEach(function (coordinates) {
            map.makePolygon(zoneMapService.getZoneOptions(adjacentPolygonOptions, coordinates));
          });
        })
        .catch($log.error);
    }

    function activate() {
      $rootScope.isLoading = true;
      var zoneMapProvider = accountConfigsService.getConfigRawValue(ACCOUNT_CONFIGS.ZONE_MAP_PROVIDER);
      var htmlElementRef = document.getElementById('map');
      return MapModel.createInstance(zoneMapProvider, __env.DEFAULT_NAME_OF_ZONE_MAP_PROVIDER, htmlElementRef)
        .then(function (map) {
          ctrl.map = map;
          _initDrawing(map);
          $rootScope.isLoading = false;
        });
    }

    function resetZone() {
      ctrl.map.setDrawingManagerOptions({ drawingControl: true });
      ctrl.resetAvailable = false;
      if (ctrl.polygon) {
        ctrl.polygon.destroy();
        ctrl.polygon = null;
      }

      ctrl.data.coordinates = [];
    }

    ctrl.$onDestroy = function () {
      if (ctrl.map) {
        ctrl.map.destroy();
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .component('zone', {
      templateUrl: 'app/settings/components/zone.html',
      controller: zoneController,
      bindings: {
        data: '<',
        callToEdit: '&',
        callToDelete: '&',
        callToSave: '&',
        schedules: '<',
        coordinates: '<'
      }
    });

  /** @ngInject */
  function zoneController(__env, $filter, WEEKDAYS, accountConfigsService, ACCOUNT_CONFIGS, MapModel) {
    var ctrl = this;
    var $translate = $filter('translate');

    ctrl.edit = function () {
      ctrl.callToEdit({ 'zoneObj': ctrl.data });
    };

    ctrl.delete = function () {
      ctrl.callToDelete({ 'zoneId': ctrl.data.id });
    };

    ctrl.save = function (statusOn) {
      var zoneObj = {
        id: ctrl.data.id,
        name: ctrl.data.name,
        enabled: statusOn,
        coordinates: JSON.stringify(ctrl.coordinates).replace(/"/g, "'")
      };

      ctrl.callToSave({ 'zoneObj': zoneObj });
    };

    function _sortDaysAsc(a, b) { 
      return WEEKDAYS.indexOf(a) - WEEKDAYS.indexOf(b);
    }

    function _createZoneMap() {
      return {
        color: '0x656565',
        weight: 1,
        opacity: 0.8,
        coordinates: ctrl.coordinates
      };
    }

    function _formatSchedules() {
      var sortedSchedules = ctrl.schedules.sort(_sortDaysAsc);
      ctrl.zoneSchedules = sortedSchedules.map(function (day) {
        return $translate('Zones.weekdays.' + day);
      }).join(", ");
    }

    ctrl.$onInit = function () {
      ctrl.isMultidayRouteEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.MULTI_DAY_ROUTES);
      var zoneMapProvider = accountConfigsService.getConfigRawValue(ACCOUNT_CONFIGS.ZONE_MAP_PROVIDER);
      ctrl.mapProvider = MapModel.getCurrentProviderName(zoneMapProvider, __env.DEFAULT_NAME_OF_ZONE_MAP_PROVIDER);
      _formatSchedules();
      ctrl.zone = _createZoneMap();
    };

    ctrl.$onChanges = function () {
      _formatSchedules();
      ctrl.zone = _createZoneMap();
    };
  }
})();

(function() {
  'use strict';

  function  passwordPolicyCtrl() {
    var ctrl = this;
  }

  var passwordPoliciesConfig = {
    templateUrl: 'app/settings/components/passwordPolicy.template.html',
    bindings: {
      data: '=',
      validation: '='
    },
    controller: passwordPolicyCtrl,
  };

  angular
    .module('icarus.settings')
    .component('passwordPolicies', passwordPoliciesConfig);

})();

(function() {
  'use strict';

  function fleetListCtrl($scope) {
    var ctrl = this;
  }

  var fleetListConfig = {
    templateUrl: 'app/settings/components/fleetList.template.html',
    controller: ['$scope', fleetListCtrl],
    bindings: {
      data: '<',
      selectedFleet: '<',
      selectFleetHandler: '='
    }
  };

  angular
    .module('icarus.settings')
    .component('fleetList', fleetListConfig);

})();

(function () {
  'use strict';

  function actionsZonesController () {
    var ctrl = this;

  }

  var actionsZones = {
    templateUrl: 'app/settings/components/actions-zones.html',
    controller: actionsZonesController,
    bindings: {
      data: '<'
    }
  };

  angular
    .module('icarus.settings')
    .component('actionsZones', actionsZones);

})();

(function () {
  "use strict";
  angular
    .module("icarus.planner")
    .controller("PlannerPlansController", PlannerPlansController);
  /** @ngInject */
  function PlannerPlansController(
    $log,
    $state,
    plannerService,
    moment,
    $rootScope,
    ngDialog,
    $filter,
    Toasts,
    LogService,
    fleetService,
    store,
    saveDraftPlanService,
    accountConfigsService,
    ACCOUNT_CONFIGS,
    sessionService,
    planService,
    $q
  ) {
    var FIRST_PAGE = 1;
    var PAGE_SIZE = 5;
    var ORDER_BY = "-start_date,-name";
    var vm = this;
    var $translate = $filter("translate");
    var ENABLE_FLEETS = "enable_fleets";
    var ENABLE_BLOCK_PLANS_DELETION = "enable_block_plans_deletion";
    vm.plans = [];
    vm.safeSrcPlans = [];
    vm.currentPlanEditing = {};
    vm.searchText = "";
    vm.planNameInEdition = null;
    vm.enabledFleetsConfig = false;
    vm.disableDuplicationPlan = false;
    vm.isNonBlockingSavingEnabled = false;
    vm.activeDraftPlanIds = [];
    vm.isEditing = false;
    vm.duplicatePlan = duplicatePlan;
    vm.goToDetail = goToDetail;
    vm.showDeleteModal = showDeleteModal;
    vm.deletePlan = deletePlan;
    vm.onChangeSearch = onChangeSearch;
    vm.fleets = undefined;
    vm.isEditingCurrentPlan = false;
    vm.pagination = {
      totalItems: 0,
      currentPage: 1,
      itemsPerPage: 5,
      maxSize: 3,
      pageChanged: function () {
        getPaginatedPlans();
      }
    };
    vm.blockPlanDeletionEnabled = false;
    vm.isPlanStatusEnabled = false;

    activate();

    function activate() {
      $rootScope.isLoading = true;
      vm.enabledFleetsConfig = isFleetsEnabled();
      vm.blockPlanDeletionEnabled = accountConfigsService.isConfigEnabled(
        ENABLE_BLOCK_PLANS_DELETION
      );

      vm.isPlanStatusEnabled = accountConfigsService.isConfigEnabled(
        ACCOUNT_CONFIGS.ENABLE_PLAN_STATUS
      );

      return $q.all({
        disableDuplicationPlan: isDisableDuplicationPlan(),
        isNonBlockingSavingEnabled: planService.isNonBlockingSavingEnabled()
      })
        .then(function (results) {
          vm.disableDuplicationPlan = results.disableDuplicationPlan;
          vm.isNonBlockingSavingEnabled = results.isNonBlockingSavingEnabled;

          return planService.getPendingDraftPlanIds(vm.isNonBlockingSavingEnabled);
        })
        .then(function (draftPlanIds) {
          vm.activeDraftPlanIds = draftPlanIds;

          if (!vm.enabledFleetsConfig) {
            return getPaginatedPlans();
          }

          return fleetService.getMyFleets()
            .then(function (fleets) {
              vm.fleets = fleets.map(function (fleet) {
                return fleet.id;
              });

              return getPaginatedPlans();
            })
            .catch(function () {
              reject($translate("errors.unable_to_fetch_fleets"));
            });
        });
    }

    function getPaginatedPlans() {
      $rootScope.isLoading = true;
      vm.currentPlanEditing = plannerService.getCurrentPlanEditing();
      var params = {
        page: vm.pagination.currentPage,
        page_size: PAGE_SIZE,
        ordering: ORDER_BY
      };

      if (vm.searchText) {
        params.search_text = vm.searchText;
      }

      if (vm.enabledFleetsConfig) {
        params.fleet_null = "1";
        if (vm.fleets.length) {
          params.fleets = vm.fleets;
        }
      }

      return plannerService.getPaginatedPlans(params)
        .then(successGetPlans)
        .catch(errorGetPlans)
        .finally(function () {
          $rootScope.isLoading = false;
        });

      function successGetPlans(response) {
        vm.plans = response.results;
        vm.pagination.totalItems = response.count;
        vm.safeSrcPlans = angular.copy(vm.plans);
        vm.activeDraftPlanIds = planService.getActiveDraftPlanIds(vm.isNonBlockingSavingEnabled, vm.safeSrcPlans, vm.activeDraftPlanIds);
        vm.planNameInEdition = plannerService.getPlanName();
        vm.isEditing = Boolean(vm.planNameInEdition);
      }

      function errorGetPlans(error) {
        $log.info(error);
        if (error.status === 404) {
          Toasts.push("error", $translate("Planner_toast.error_get_plans_1"));
        }
        if (error.status === 500) {
          Toasts.push("error", $translate("Planner_toast.error_get_plans_2"));
        }
        $state.go("^");
        return [];
      }
    }

    function isFleetsEnabled() {
      var accountConfigs = store.get("accountConfigs");
      var enableFleetConfig;
      if (accountConfigs) {
        enableFleetConfig = accountConfigs.find(function (config) {
          return config.key === ENABLE_FLEETS;
        });
      }
      return enableFleetConfig ? enableFleetConfig.value : false;
    }

    function isDisableDuplicationPlan() {
      return sessionService.getUser()
        .then(function (user) {
          return (user.is_router || user.is_router_jr) && accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.DISABLE_DUPLICATION_PLAN);
        });
    }

    function goToDetail(planId) {
      $state.go("planner.vehicles-list.plans-detail", { planId: planId });
    }

    /** @ngInject */
    function DialogController(isEditingCurrentPlan, plan, deletePlan) {
      var vm = this;
      vm.isEditingCurrentPlan = isEditingCurrentPlan;
      vm.plan = plan;
      vm.deletePlan = deletePlan;
      vm.checkDeletePlan = false;
      vm.deleteVisits = false;
    }

    function onChangeSearch() {
      vm.pagination.currentPage = FIRST_PAGE;
      getPaginatedPlans();
    }

    function showDeleteModal(event, planId) {
      vm.isEditingCurrentPlan = false;
      event.stopPropagation();

      var plan = vm.plans.find(function (plan) {
        return plan.id === planId;
      });

      if (plan) {
        plan.canBeDeleted = true;
        var idPlanPlannerService = plannerService.getPlanId();

        if (idPlanPlannerService === planId && vm.planNameInEdition) {
          vm.isEditingCurrentPlan = true;
        }

        ngDialog.openConfirm({
          template: "app/planner/plans/plans-delete-modal.html",
          controller: DialogController,
          controllerAs: "vm",
          resolve: {
            isEditingCurrentPlan: function () {
              return vm.isEditingCurrentPlan;
            },
            plan: function () {
              return plan;
            },
            deletePlan: function () {
              return deletePlan;
            }
          }
        });
      }
    }

    function deletePlan(planToDelete, deleteVisits) {
      $rootScope.isLoading = true;
      plannerService.deletePlan(planToDelete.id, deleteVisits)
        .then(function () {
          ngDialog.close();
          saveDraftPlanService.deleteDraftPlan(planToDelete.id);

          if (vm.isNonBlockingSavingEnabled && vm.activeDraftPlanIds.includes(planToDelete.id)) {
            var draftPlanKeyToDelete = planService.getDraftPlanKey(planToDelete.id);
            var activeDraftPlanIdIndex = vm.activeDraftPlanIds.indexOf(planToDelete.id);

            saveDraftPlanService.deleteDraftPlan(draftPlanKeyToDelete);
            vm.activeDraftPlanIds.splice(activeDraftPlanIdIndex, 1);
          }

          vm.plans = vm.plans.filter(function (plan) {
            return plan.id !== planToDelete.id;
          });

          if (vm.isEditingCurrentPlan) {
            $rootScope.$broadcast("Planner:Clear:Map");
            plannerService.clearPlanner();
            plannerService.planDate.start = moment().toDate();
            plannerService.planDate.end = moment().toDate();
          }

          $rootScope.isLoading = false;
          $rootScope.$broadcast("Vehicles:Init-activate");

          _createLogForDeletedPlan(planToDelete);
          onChangeSearch();
        })
        .catch(function (error) {
          $log.info(error);
          $rootScope.isLoading = false;
          if (error) {
            if (
              error.status === 400 &&
              vm.blockPlanDeletionEnabled &&
              error.data[0] ===
                "It is not possible to delete Plans in progress."
            ) {
              planToDelete.canBeDeleted = false;
            } else {
              Toasts.push(
                "error",
                $translate("Planner_toast.error_delete_plan")
              );
            }
          }
        });
    }

    function duplicatePlan(event, planId) {
      if (!vm.disableDuplicationPlan) {
        event.stopPropagation();
        $state.go("planner.vehicles-list.plans-detail", {
          planId: planId,
          isCopy: true
        });
      }
    }

    function _createLogForDeletedPlan(plan) {
      LogService.createLogForPlan(plan, $translate("Log.actions.delete_plan"));
    }

  }
})();

/* global XLSX:false, saveAs:false */
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .controller('PlannerPlansDetailController', PlannerPlansDetailController);

  /** @ngInject */
  function PlannerPlansDetailController($log, $http, $state, $stateParams, $scope, plannerService, tagService,
                                        visitService, moment, $rootScope, __env, $q, $filter, $timeout, Utils,
                                        Toasts, timeUtils, JOINED_EMAILS_MAX_LENGTH, MAX_EMAILS_INPUT,
                                        extraFieldsService, routeService, accountConfigsService, saveDraftPlanService,
                                        saveDraftPlanUtilService, PLAN_STATUS, ACCOUNT_CONFIGS, loadPlanService,
                                        xlsWriterService, routesUtils, utilsService, PATH_FINDER_ADD_ON_PROPERTIES,
                                        codriverService, sortDriversByDocStatusService) {
    var PLAN_PATH = __env.API_URL + 'routes/plans/';
    var DATE_FORMAT = 'YYYY-MM-DD';
    var ERROR_PLAN_NAME_MSJ = 'plan_name';
    var ERROR_PLANNED_DATE_MSJ = 'planned_date';
    var ENABLE_ENHANCED_PLAN_EDIT_MODE = "enable_enhanced_plan_edit_mode";

    var vm = this;
    var $translate = $filter('translate');

    vm.visits = [];
    vm.isCopy = $stateParams.isCopy === 'true';
    vm.isDraft = $stateParams.isDraft === 'true';
    vm.pathToPreviousView = "planner.vehicles-list.plans" + (vm.isDraft ? "-draft" : "");
    vm.isDraft = false;
    vm.plan = {};
    vm.originalRouteDrivers = {};
    vm.vehicles = [];
    vm.drivers = [];
    vm.codrivers = [];
    vm.skills = [];
    vm.driversAfterEdit = [];
    var visitsToEdit = [];
    vm.visitsNotUpdated = [];
    vm.dateOptions = null;
    vm.planDate = {};
    vm.weekend_days = [];
    vm.resetDay = null;
    vm.dateOptions = null;
    vm.popupPlanDateStart = null;
    vm.popupPlanDateEnd = null;
    vm.validatePlanDate = validatePlanDate;
    vm.activateSaveBtn = true;
    vm.planUpdated = null;
    vm.planUploaded = false;
    vm.visitsUpdated = 0;
    vm.totalExcelVisits = 0;
    vm.visitsChangedButNotUpdated = 0;
    vm.openPopupPlanDateStart = openPopupPlanDateStart;
    vm.openPopupPlanDateEnd = openPopupPlanDateEnd;
    vm.updatePlanData = updatePlanData;
    vm.loadPlan = loadPlan;
    vm.exportPlan = exportPlan;
    vm.uploadExcel = uploadExcel;
    vm.goToPlans = goToPlans;
    vm.goToCodrivers = goToCodrivers;
    vm.showDeleteModal = showDeleteModal;
    vm.duplicatePlan = duplicatePlan;
    vm.formatContactEmail = formatContactEmail;
    vm.updateRows = updateRows;
    vm.filterExtrafieldWriteOnly = filterExtrafieldWriteOnly;
    vm.tags = [];

    vm.visitRows = [];

    vm.writeWorkbook = writeWorkbook;

    vm.editedPlanName = '';
    vm.showToasts = true;
    vm.showErrorPlanNameExist = false;
    vm.validateNonFieldErrors = validateNonFieldErrors;

    vm.enhancedPlanEditMode = accountConfigsService.isConfigEnabled(ENABLE_ENHANCED_PLAN_EDIT_MODE);
    vm.isEnabledConfigToCodrivers = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.CAN_CREATE_CO_DRIVER);
    vm.isMultiDriversConfigEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_MULTI_DRIVERS);

    activate();

    function activate() {
      latinizeString();
      vm.dateOptions = {
        formatYear: 'yyyy',
        formatDayHeader: 'EEE',
        formatDayTitle: 'MMMM',
        formatDay: 'd',
        showWeeks: false,
        maxMode: 'day',
        startingDay: 0,
        minDate: new Date()
      };

      vm.popupPlanDateStart = {
        opened: false
      };

      vm.popupPlanDateEnd = {
        opened: false
      };

      $rootScope.isLoading = true;
      _fillWeekendDays();
      return $q.all([
        plannerService.getPlan(),
        loadPlanService.loadPlanResume($stateParams.planId),
        tagService.getTags(),
        plannerService.getVisitTypes()
      ])
        .then(function (responses) {
          vm.plan = responses[1].plan;
          vm.tags = responses[2];
          vm.plan.name = vm.isCopy ? '' : vm.plan.name;
          vm.editedPlanName = vm.plan.name;
          vm.resetDay = vm.plan.reset_day;
          vm.isDraft = saveDraftPlanService.hasDraftPlan();
          vm.planDate.start = moment(vm.plan.start_date).toDate();
          vm.planDate.end = moment(vm.plan.end_date).toDate();
          angular.copy(plannerService.getCodrivers(), vm.codrivers);
          angular.copy(plannerService.getDrivers(), vm.drivers);
          vm.drivers = sortDriversByDocStatusService.sort(vm.drivers, 'name');
          angular.copy(plannerService.getSkills(), vm.skills);
          vm.originalRouteDrivers = _mapRouteToOriginalDrivers(vm.plan.routes);
          vm.vehicles = vm.plan.vehicles;
          routesUtils.updateSelectedDrivers(vm.vehicles, vm.drivers);
          _matchSelectedWeekendDay();
        })
        .catch(function (error) {
          $log.info(error);
          if (error.status === 404) {
            Toasts.push('error', $translate('Planner_toast.error_get_plans_3'));
          }

          $state.go('^');
        })
        .finally(function () {
          $rootScope.isLoading = false;
        });
    }

    vm.isPlanEditable = function () {
      return !accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_PLAN_STATUS) || vm.plan.status === PLAN_STATUS.draft;
    };

    function _loadRouteProperties(routesArray) {
      var routesMap = {};
      routesArray.forEach(function(route) {
        routesMap[route.id] = route;
      });

      return plannerService.loadRouteProperties(Object.keys(routesMap))
        .then(function(response) {
          response.data.forEach(function(routeProperty) {
            var routeObject = routesMap[routeProperty.route];
            if (routeObject) {
              routeObject.properties = {
                color: routeProperty.color
              };
            }
          });

          return routesArray;
        });
    }

    function _getSkillByID(skillId) {
      for (var i = 0; i < vm.skills.length; i++) {
        if (vm.skills[i].id.toString() === skillId) {
          return vm.skills[i];
        }
      }

      return null;
    }

    function _getTagByID(tagId) {
      for (var i = 0; i < vm.tags.length; i++) {
        if (vm.tags[i].id.toString() === tagId) {
          return vm.tags[i];
        }
      }

      return null;
    }

    function openPopupPlanDateStart() {
      vm.popupPlanDateStart.opened = true;
    }

    function openPopupPlanDateEnd() {
      vm.popupPlanDateEnd.opened = true;
    }

    function _getTotalPlanVisits() {
      return vm.plan.routes.reduce(function (totalVisits, route) {
        return route.total_visits + totalVisits;
      }, 0);
    }

    function updatePlanData() {
      vm.activateSaveBtn = false;
      $q.all([
        _updatePlan(),
        _updateRoutes()
      ]).then(_successUpdate, _errorUpdate);

      function _successUpdate() {
        vm.plan.name = vm.editedPlanName;
        vm.activateSaveBtn = true;
        vm.planUpdated = true;
        $rootScope.$broadcast("checkRoutes");
        $timeout(function () {
          vm.planUpdated = null;
        }, 2500);
      }

      function _errorUpdate(response) {
        $log.error(response);
        vm.activateSaveBtn = true;
        if (response.status === 400 && response.data.non_field_errors) {
          vm.showToasts = false;
          validateNonFieldErrors(response.data.non_field_errors);
        } else {
          vm.planUpdated = false;
        }

        $timeout(function () {
          vm.planUpdated = null;
          vm.showErrorPlanNameExist = false;
          vm.showToasts = true;
        }, 3000);

        if (response.status === 404) {
          Toasts.push('error', $translate('Planner_toast.error_put_plan_found'));
        }
        if (response.status === 500) {
          Toasts.push('error', $translate('Planner_toast.error_put_plan_found'));
        }
      }
    }

    function _updatePlan() {
      var defered = $q.defer();

      var request_data = {
        'name': vm.editedPlanName,
        'start_date': moment(vm.planDate.start).format(DATE_FORMAT),
        'end_date': moment(vm.planDate.end).format(DATE_FORMAT),
        'reset_day': vm.resetDay.id
      };

      $http.put(PLAN_PATH + vm.plan.id + '/', request_data)
        .then(_successPlanUpdate, _errorPlanUpdate);

      function _successPlanUpdate() {
        vm.plan.start_date = moment(vm.planDate.start).format(DATE_FORMAT);
        vm.plan.end_date = moment(vm.planDate.end).format(DATE_FORMAT);
        defered.resolve();
      }

      function _errorPlanUpdate(response) {
        $log.error(response);
        defered.reject(response);
      }

      return defered.promise;
    }

    function _addPlannedDateChange(startDate) {
      var formattedStartDate = moment(startDate).format(DATE_FORMAT);
      var formattedCurrentDate = moment().format(DATE_FORMAT);
      if (moment(formattedStartDate).isSameOrAfter(moment(formattedCurrentDate))) {
        return formattedStartDate;
      }
    }

    function _updateRoutes() {
      var routePromises = [];
      var plannedDate = _addPlannedDateChange(vm.planDate.start);
      vm.vehicles.forEach(function (vehicle) {
        vehicle.routes.forEach(function (route) {
          var routeRequest = {};
          if (plannedDate && plannedDate !== route.planned_date) {
            routeRequest.planned_date = plannedDate;
            route.planned_date = plannedDate;
          }

          var originalRouteDriver = vm.originalRouteDrivers[route.id];
          if (originalRouteDriver !== route.driver) {
            routeRequest.driver = route.driver;
            vm.originalRouteDrivers[route.id] = route.driver;
          }

          var patchRoutePromise = routeService.patchRoute(routeRequest, route.id);
          routePromises.push(patchRoutePromise);
        });
      });

      return $q.all(routePromises);
    }

    function duplicatePlan() {
      $rootScope.isLoading = true;
      var routes = vm.plan.routes;

      plannerService.setOriginalPlan({});
      return _loadRouteProperties(routes)
        .then(loadPlanService.loadVisits)
        .then(function () {
          return loadPlanService.coloringRoutes(routes, vm.vehicles);
        })
        .then(function() {
          var planCopy = angular.copy(vm.plan);
          return _cleanDataPlan(planCopy)
            .then(function (cleanedPlan) {
              return plannerService.mergePreviousPlan(cleanedPlan, vm.isCopy)
                .then(function () {
                  var duplicatedPlanStatus = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_PLAN_STATUS) ? PLAN_STATUS.draft : PLAN_STATUS.completed;
                  return plannerService.createPlan(cleanedPlan.name, $scope.isMultiDayRouteEnabled, false, cleanedPlan.plan_metadata, duplicatedPlanStatus)
                    .then(function() {
                      $rootScope.$broadcast("Planner:Clear:Map");
                      plannerService.clearPlanner();
                      $rootScope.$broadcast("Vehicles:Init-activate");
                      $rootScope.isLoading = false;
                      $state.go('planner.vehicles-list.plans');
                    });
                });
            });
        })
        .catch(function(error) {
          $rootScope.isLoading = false;
          errorPlanSave(error);
        });
    }

    function errorPlanSave(error) {
      vm.saving = false;
      vm.notSavedPlan = true;
      if (has(error, 'vehicle')) {
        plannerService.getVehicle(error.vehicle).then(function (result) {
          vm.failedVehicle = result;
        });
      }
      if (error.status === 500) {
        Toasts.push('error', $translate('Planner_toast.error_save_plan_finish'));
      }
      if (error.status === 400) {
        if (error.data.non_field_errors) {
          validateNonFieldErrors(error.data.non_field_errors);
        } else {
          Toasts.push('error', $translate('Planner_toast.error_save_plan_finish'));
        }
      }

      $log.error(error);
    }

    function has(object, key) {
      return object ? hasOwnProperty.call(object, key) : false;
    }

    function validateNonFieldErrors(data) {
      var error = false;

      data.forEach(function (msj) {
        if (msj.includes("account") && msj.includes("name")) {
          error = ERROR_PLAN_NAME_MSJ;
          vm.showErrorPlanNameExist = !vm.showToasts;
        }
        if (msj.includes("planned_date")) {
          error = ERROR_PLANNED_DATE_MSJ;
        }
      });

      if(vm.showToasts) {
        showToastsErrors(error);
      }
    }

    function showToastsErrors(msj) {

      switch (msj) {
        case 'plan_name':
          Toasts.push('error', $translate('Planner_toast.error_save_plan_finish_plan_name'));
          break;
        case 'planned_date':
          Toasts.push('error', $translate('Planner_toast.error_save_plan_finish_planned_date'));
          break;
        default:
          Toasts.push('error', $translate('Planner_toast.error_save_plan_finish'));
      }
    }

    function filterExtrafieldWriteOnly(extrafields, extraFieldValues) {

      var filteredExtrafields = angular.copy(extraFieldValues);

      for (var key in extraFieldValues) {
        var extrafield = extrafields.find(function (extrafieldItem) {
          return extrafieldItem.key === key;
        });

        if (extrafield.is_read === false && extrafield.is_write === true) {
          delete filteredExtrafields[key];
        }
      }

      return filteredExtrafields;
    }

    function _cleanDataPlan(plan) {
      return extraFieldsService.getExtraFields().then(function (extrafields) {

        plan.modified = timeUtils.toIsoString();
        plan.start_date = timeUtils.toIsoStringByDate(vm.planDate.start);
        plan.end_date = vm.isCopy ? vm.planDate.start : vm.planDate.end;
        plan.end_date = timeUtils.toIsoStringByDate(plan.end_date);
        plan.id = '';

        for (var i = 0; i < plan.routes.length; i++) {
          var route = plan.routes[i];
          route.plan = null;
          route.id = null;
          route.planned_date = moment(vm.planDate.start).format(DATE_FORMAT);
          route.start_time = null;
          route.end_time = null;

          if (vm.isCopy) {
            route.codrivers = route.codrivers || [];
          }

          for (var j = 0; j < route.visits.length; j++) {

            var extraFieldValuesFiltered = vm.filterExtrafieldWriteOnly(extrafields, route.visits[j].extra_field_values);

            var visit = route.visits[j];
            visit.checkin_time = null;
            visit.checkin_latitude = null;
            visit.checkin_longitude = null;
            visit.checkout_comment = '';
            visit.checkout_latitude = null;
            visit.checkout_longitude = null;
            visit.checkout_observation = null;
            visit.checkout_time = null;
            visit.pictures.length = 0;
            visit.signature = null;
            visit.id = null;
            visit.extra_field_values = extraFieldValuesFiltered || {};
          }
        }
        return plan;
      });
    }

    function loadPlan() {
      $rootScope.isLoading = true;
      _updateToOriginalRouteDrivers(vm.plan.routes);
      var pathFinderProperties = plannerService.getPathFinderProperties();
      var positiveSelectionVisitsEnabled = utilsService.isAddonPropertyEnabled(pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.POSITIVE_SELECTION_VISITS]);

      return loadPlanService.loadPlan(vm.plan)
        .then(function () {
          $state.go('planner.routes', {
            positiveSelectedVisits: positiveSelectionVisitsEnabled,
            isOpeningPlanToEdit: true,
            isEnhancedPlanEditModeEnabled: Boolean(vm.enhancedPlanEditMode)
          });

          $rootScope.isLoading = false;
        })
        .catch(function (error) {
          $log.error(error);
          $log.error('Error cargando el plan');
          $rootScope.isLoading = false;
          if (error.status === 400) {
            Toasts.push('error', $translate('Planner_toast.error_call_osrm'));
          }
        });
    }

    function exportPlan() {
      $rootScope.isLoading = true;
      return loadPlanService.loadVisits(vm.plan.routes)
        .then(function (response) {
          vm.visits = response;
          _loadExportPlan();
        })
        .finally(function () {
          $rootScope.isLoading = false;
        });
    }

    function _loadExportPlan() {
      vm.visitRows = [];
      var workbook = {
        Sheets: {},
        SheetNames: []
      };

      var HEADERS = [
        $filter('translate')('Excel_Header.driver'),
        $filter('translate')('Excel_Header.vehicle'),
        $filter('translate')('Excel_Header.route_Index'),
        $filter('translate')('Excel_Header.stop'),
        $filter('translate')('Excel_Header.arrival_Time'),
        $filter('translate')('Excel_Header.title'),
        $filter('translate')('Excel_Header.address'),
        $filter('translate')('Excel_Header.load'),
        $filter('translate')('Excel_Header.window_Start'),
        $filter('translate')('Excel_Header.window_End'),
        $filter('translate')('Excel_Header.service_Time'),
        $filter('translate')('Excel_Header.notes'),
        $filter('translate')('Excel_Header.latitude'),
        $filter('translate')('Excel_Header.longitude'),
        $filter('translate')('Excel_Header.reference'),
        $filter('translate')('Excel_Header.requires_Skills'),
        $filter('translate')('Excel_Header.optional_Skills'),
        $filter('translate')('Excel_Header.contact_Name'),
        $filter('translate')('Excel_Header.contact_Phone'),
        'Id',
        'RID',
        'VID',
        'DID',
        $filter('translate')('Excel_Header.window_Start2'),
        $filter('translate')('Excel_Header.window_End2'),
        $filter('translate')('Excel_Header.visit_load2'),
        $filter('translate')('Excel_Header.visit_load3'),
        $filter('translate')('Excel_Header.contact_email'),
        $filter('translate')('Excel_Header.tags')
      ];

      vm.vehicles.forEach(function (vehicle) {
        vehicle.routes.forEach(function (route, routeIndex) {
          routeIndex = routeIndex + 1;
          //get driver
          var foundDriver = null;

          if (route.driver) {
            foundDriver = vm.drivers.find(function (driver) {
              return String(driver.id) === String(route.driver);
            });
          }

          //get vehicle
          var vehicleSearched = plannerService.getVehicleById(String(route.vehicle));
          //we sort the visits array before sending it to excel
          route.visits.sort(function (a, b) {
            if (a.order > b.order) {
              return 1;
            }
            if (a.order < b.order) {
              return -1;
            }
            // a must be equal to b
            return 0;
          });

          route.visits.forEach(function (visit) {
            //Prepare required skills
            var requiredSkills = '';
            for (var i = 0; i < visit.skills_required.length; i++) {
              if (i === (visit.skills_required.length - 1)) {
                requiredSkills += _getSkillByID(visit.skills_required[i].toString()).name;
              } else {
                requiredSkills += _getSkillByID(visit.skills_required[i].toString()).name + ', ';
              }
            }

            //Prepare optional skills
            var optionalSkills = '';
            for (var i = 0; i < visit.skills_optional.length; i++) {
              if (i === (visit.skills_optional.length - 1)) {
                optionalSkills += _getSkillByID(visit.skills_optional[i].toString()).name;
              } else {
                optionalSkills += _getSkillByID(visit.skills_optional[i].toString()).name + ', ';
              }
            }

            //Prepare tags
            var tags = '';
            for (var i = 0; i < visit.tags.length; i++) {
              if (i === (visit.tags.length - 1)) {
                tags += _getTagByID(visit.tags[i].toString()).label;
              } else {
                tags += _getTagByID(visit.tags[i].toString()).label + ', ';
              }
            }

            vm.visitRows.push([
              foundDriver ? foundDriver.name : "",
              vehicleSearched.name,
              $filter('translate')('Routes.route_text') + routeIndex,
              visit.order,
              visit.estimated_time_arrival,
              visit.title,
              visit.address,
              visit.load,
              visit.window_start,
              visit.window_end,
              visit.duration,
              visit.notes,
              parseFloat(visit.latitude),
              parseFloat(visit.longitude),
              visit.reference,
              requiredSkills,
              optionalSkills,
              visit.contact_name,
              visit.contact_phone,
              visit.id,
              visit.route,
              visit.vehicle,
              visit.driver,
              visit.window_start2,
              visit.window_end2,
              visit.load_2,
              visit.load_3,
              visit.contact_email,
              tags
            ]);
          });
        });
      });

      workbook.Sheets['Plan'] = _sheetFromArrayOfArrays([HEADERS].concat(vm.visitRows));
      workbook.SheetNames.push('Plan');

      vm.drivers.forEach(function (driver) {
        var driverRows = vm.visitRows.filter(function (row) {
          return row[0] === driver.name;
        });

        if (driverRows.length > 0) {
          var fullSheetName = workbook.SheetNames.length + '. ' + xlsWriterService.sanitizeSheetName(driver.name);
          var sheetName = fullSheetName.trim().slice(0, 20);
          workbook.Sheets[sheetName] = _sheetFromArrayOfArrays([HEADERS].concat(driverRows));
          workbook.SheetNames.push(sheetName);
        }
      });

      vm.writeWorkbook(workbook, 'SimpliRoute_Plan_' + moment(vm.planDate.start).format('YYYY-MM-DDTHH:mm'));
      return vm.visitRows;
    }

    function _sheetFromArrayOfArrays(data) {
      // Reference: http://sheetjs.com/demos/writexlsx.html
      var ws = {};
      var range = {s: {c: 10000000, r: 10000000}, e: {c: 0, r: 0}};
      for (var R = 0; R !== data.length; ++R) {
        for (var C = 0; C !== data[R].length; ++C) {
          if (range.s.r > R) {
            range.s.r = R;
          }
          if (range.s.c > C) {
            range.s.c = C;
          }
          if (range.e.r < R) {
            range.e.r = R;
          }
          if (range.e.c < C) {
            range.e.c = C;
          }
          var cell = {v: data[R][C]};
          if (cell.v === null) {
            continue;
          }
          var cell_ref = XLSX.utils.encode_cell({c: C, r: R});

          if (angular.isNumber(cell.v)) {
            cell.t = 'n';
          } else if (typeof cell.v === 'boolean') {
            cell.t = 'b';
          } else if (cell.v instanceof Date) {
            cell.t = 'n';
            cell.z = XLSX.SSF._table[14];
            cell.v = datenum(cell.v);
          } else {
            cell.t = 's';
          }

          ws[cell_ref] = cell;
        }
      }
      if (range.s.c < 10000000) {
        ws['!ref'] = XLSX.utils.encode_range(range);
      }
      return ws;

      function datenum(v, date1904) {
        if (date1904) {
          v += 1462;
        }
        var epoch = Date.parse(v);
        return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
      }
    }

    function writeWorkbook(workbook, filename) {
      // Reference: http://sheetjs.com/demos/writexlsx.html
      var wopts = {bookType: 'xlsx', bookSST: false, type: 'binary'};
      var wbout = XLSX.write(workbook, wopts);
      /* the saveAs call downloads a file on the local machine */
      saveAs(new Blob([s2ab(wbout)], {type: ''}), filename + '.xlsx');

      function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i !== s.length; ++i) {
          view[i] = s.charCodeAt(i) & 0xFF;
        }
        return buf;
      }
    }

    function uploadExcel(files) {
      $rootScope.isLoading = true;
      var reader = new FileReader();
      var rABS = true;

      //Verify if FileReader.prototype.readAsBinaryString is defined
      if (FileReader !== undefined || FileReader.prototype !== undefined || !(FileReader.prototype.readAsBinaryString instanceof Function)) {
        rABS = false;
      }

      reader.onload = function (e) {
        vm.totalExcelVisits = 0;
        vm.driversAfterEdit = [];
        var data = e.target.result;
        var workbook = null;
        var worksheet = null;

        if (rABS) {
          workbook = XLSX.read(data, {type: 'binary'});
        } else {
          workbook = XLSX.read(btoa(_fixData(data)), {type: 'base64'});
        }

        worksheet = workbook.Sheets[workbook.SheetNames[0]];
        var rows = XLSX.utils.sheet_to_json(worksheet, {header: 'A'});
        vm.totalExcelVisits = rows.length - 1;
        updateRows(rows, 1);
      };

      if (rABS) {
        reader.readAsBinaryString(files[0]);
      } else {
        reader.readAsArrayBuffer(files[0]);
      }
    }

    function _fixData(data) {
      var o = "", l = 0, w = 10240;
      for (; l < data.byteLength / w; ++l) {
        o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
      }
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    }

    function updateRows(rows, index) {

      var visitError = null;

      for (var i = index; i < rows.length; i++) {
        // Substracts 1 for the header row
        vm.importingVisitsPercentage = i / rows.length * 100;

        var row = rows[i];
        var visitId = parseInt(row.T);
        var title = row.F;
        var address = row.G;
        var lat = row.M;
        var lng = row.N;
        var routeId = row.U;
        var vehicleId = parseInt(row.V);
        var driverId = isNaN(row.W) ? null : parseInt(row.W);
        if (driverId && vm.driversAfterEdit.indexOf(driverId) === -1) {
          vm.driversAfterEdit.push(driverId);
        }
        var latlngPattern = new RegExp(Utils.latlngPattern);

        if (typeof visitId === "undefined" || typeof lat === "undefined" || typeof lng === "undefined" || typeof routeId === "undefined" || typeof vehicleId === "undefined" || typeof driverId === "undefined" || !latlngPattern.test(lat + ', ' + lng)) {
          visitError = {
            index: i
          };
          vm.visitsNotUpdated.push(visitError);
          continue;
        }

        var driverName = row.A || '';
        var vehicleName = row.B || '';
        var routeIndex = row.C || '';
        var visitOrder = isNaN(row.D) ? null : parseInt(row.D);
        var visitETA = moment(row.E, 'HH:mm:ss').isValid() ? moment(row.E, 'HH:mm:ss').format('HH:mm:ss') : null;
        var load = isNaN(row.H) ? 0 : parseFloat(parseFloat(row.H).toFixed(2));
        var windowStart = moment(row.I, 'HH:mm:ss').isValid() ? moment(row.I, 'HH:mm:ss').format('HH:mm:ss') : null; //row.D || '';
        var windowEnd = moment(row.J, 'HH:mm:ss').isValid() ? moment(row.J, 'HH:mm:ss').format('HH:mm:ss') : null; //row.E || '';
        var duration = moment(row.K, 'HH:mm:ss').isValid() ? moment(row.K, 'HH:mm:ss').format('HH:mm:ss') : null;
        var notes = row.L || '';
        var referenceId = row.O || '';
        var skillsRequiredNames = row.P ? row.P.split(',') : [];
        var skillsOptionalNames = row.Q ? row.Q.split(',') : [];
        var contactName = row.R || '';
        var contactPhone = row.S || '';
        var contactEmail = row.AB ? formatContactEmail(row.AB) : '';
        var tags = row.AC ? row.AC.split(',') : [];

        var windowStart2 = moment(row.X, 'HH:mm:ss').isValid() ? moment(row.X, 'HH:mm:ss').format('HH:mm:ss') : null; //row.X || '';
        var windowEnd2 = moment(row.Y, 'HH:mm:ss').isValid() ? moment(row.Y, 'HH:mm:ss').format('HH:mm:ss') : null; //row.Y || '';
        var load2 = isNaN(row.Z) ? 0 : parseFloat(parseFloat(row.Z).toFixed(2));
        var load3 = isNaN(row.AA) ? 0 : parseFloat(parseFloat(row.AA).toFixed(2));

        // parseamos las skills a sus IDs, las que no se encuentren sencillamente no se agregan a la visita
        var skillsRequired = [];
        skillsRequiredNames.map(function (skillName) {
          for (var i = 0; i < vm.skills.length; i++) {
            if (vm.skills[i].name === skillName.trim()) {
              skillsRequired.push(vm.skills[i].id);
            }
          }
        });

        var skillsOptional = [];
        skillsOptionalNames.map(function (skillName) {
          for (var i = 0; i < vm.skills.length; i++) {
            if (vm.skills[i].name === skillName.trim()) {
              skillsOptional.push(vm.skills[i].id);
            }
          }
        });

        var tagsIds = [];
        tags.map(function (excelTag) {
          for (var i = 0; i < vm.tags.length; i++) {
            if (vm.tags[i].label.toLowerCase() === excelTag.trim().toLowerCase()) {
              tagsIds.push(vm.tags[i].id);
            }
          }
        });

        //Hacemos el match del vehiculo a ver si cambio
        var visit = {
          id: visitId,
          title: title,
          address: address,
          load: load,
          duration: duration,
          notes: notes,
          reference: referenceId,
          estimated_time_arrival: visitETA,
          window_start: windowStart,
          window_end: windowEnd,
          window_start2: windowStart2,
          window_end2: windowEnd2,
          skills_required: skillsRequired,
          skills_optional: skillsOptional,
          contact_name: contactName,
          contact_phone: contactPhone,
          contact_email: contactEmail,
          route: routeId,
          vehicle: vehicleId,
          driver: driverId,
          order: visitOrder,
          load_2: load2,
          load_3: load3,
          tags: tagsIds
        };

        // buscamos la visita dentro de las visitas del plan
        var localVisit = {};
        for (var k = 0; k < vm.visits.length; k++) {
          if (vm.visits[k].id === visit.id) {
            localVisit = vm.visits[k];
            break;
          }
        }

        if (localVisit) {
          //recorremos las propiedades a ver si tienen algun cambio y vamos creando el request_data
          var request_data = {};
          var visitChangedProps = 0;
          for (var property in localVisit) {
            if (localVisit.hasOwnProperty(property) && visit.hasOwnProperty(property)) {
              if (localVisit[property] instanceof Array) {
                if (!localVisit[property].equals(visit[property])) {
                  request_data[property] = visit[property];
                  visitChangedProps++;
                }
                continue;
              }
              if (localVisit[property] !== visit[property]) {
                request_data[property] = visit[property];
                visitChangedProps++;
              }
            }
          }
          if (visitChangedProps > 0) {
            request_data.id = visit.id;
            visitsToEdit.push(request_data);
            continue;
          } else {
            continue;
          }
        } else {
          visitError = {
            index: i
          };
          vm.visitsNotUpdated.push(visitError);
          continue;
        }
      }

      if (visitsToEdit.length > 0) {
        visitService.patchVisits(visitsToEdit).then(function () {
          $rootScope.isLoading = false;
          vm.visitsUpdated = visitsToEdit.length;
          vm.planUploaded = true;
          visitsToEdit.length = 0;
        }).catch(function () {
          $log.info(error);
          visitsToEdit.length = 0;
          $rootScope.isLoading = false;
          vm.planUploaded = false;
          Toasts.push('error', $translate('Planner_toast.error_visit_update_plan'));
        });

      } else if (visitsToEdit.length === 0) {
        $rootScope.isLoading = false;
        vm.visitsUpdated = visitsToEdit.length;
        vm.planUploaded = true;
      }
      $scope.$apply();
      return;
    }

    function goToPlans() {
      $state.go('planner.vehicles-list.plans');
    }

    Array.prototype.inArray = function (searchFor, property) {
      var retVal = -1;
      var self = this;
      for (var index = 0; index < self.length; index++) {
        var item = self[index];
        if (item.hasOwnProperty(property)) {
          if (item[property].toLowerCase() === searchFor.toLowerCase()) {
            retVal = index;
            return retVal;
          }
        }
      }
      return retVal;
    };

    Array.prototype.equals = function (array) {
      // if the other array is a falsy value, return
      if (!array) {
        return false;
      }
      // compare lengths - can save a lot of time
      if (this.length !== array.length) {
        return false;
      }

      for (var i = 0, l = this.length; i < l; i++) {
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
          // recurse into the nested arrays
          if (!this[i].equals(array[i])) {
            return false;
          }
        } else if (this[i] !== array[i]) {
          // Warning - two different object instances will never be equal: {x:20} != {x:20}
          return false;
        }
      }
      return true;
    };

    function _fillWeekendDays() {
      vm.weekend_days = [
        {
          id: 0,
          name: $filter('translate')('Planner.sunday')
        },
        {
          id: 1,
          name: $filter('translate')('Planner.monday')
        },
        {
          id: 2,
          name: $filter('translate')('Planner.tuesday')
        },
        {
          id: 3,
          name: $filter('translate')('Planner.wednesday')
        },
        {
          id: 4,
          name: $filter('translate')('Planner.thursday')
        },
        {
          id: 5,
          name: $filter('translate')('Planner.friday')
        },
        {
          id: 6,
          name: $filter('translate')('Planner.saturday')
        },
        {
          id: 100,
          name: $filter('translate')('Planner.no_day')
        }
      ];
    }

    function _matchSelectedWeekendDay() {
      switch (parseInt(vm.resetDay)) {
        case 0:
          vm.resetDay = {
            id: 0,
            name: $filter('translate')('Planner.sunday')
          };
          break;
        case 1:
          vm.resetDay = {
            id: 1,
            name: $filter('translate')('Planner.monday')
          };
          break;
        case 2:
          vm.resetDay = {
            id: 2,
            name: $filter('translate')('Planner.tuesday')
          };
          break;
        case 3:
          vm.resetDay = {
            id: 3,
            name: $filter('translate')('Planner.wednesday')
          };
          break;
        case 4:
          vm.resetDay = {
            id: 4,
            name: $filter('translate')('Planner.thursday')
          };
          break;
        case 5:
          vm.resetDay = {
            id: 5,
            name: $filter('translate')('Planner.friday')
          };
          break;
        case 6:
          vm.resetDay = {
            id: 6,
            name: $filter('translate')('Planner.saturday')
          };
          break;
        case 100:
          vm.resetDay = {
            id: 100,
            name: $filter('translate')('Planner.no_day')
          };
          break;
        default:
          vm.resetDay = {
            id: 1,
            name: $filter('translate')('Planner.monday')
          };
      }
    }

    $scope.$on('$destroy', onDestroy);

    function onDestroy() {
      if (vm.isCopy) {
        plannerService.clearPlanner();
      }
    }

    function validateEmailsLength(emailsList, input) {
      var emailsListLength = emailsList.join(',').length;
      return emailsListLength + input.length + 1 <= JOINED_EMAILS_MAX_LENGTH;
    }

    function validateEmailsQuantity(emailsList) {
      return emailsList.length < MAX_EMAILS_INPUT;
    }

    function formatContactEmail(contactEmail) {
      var validEmails = [];
      var result = '';
      if (contactEmail) {
        contactEmail.split(',').forEach(function (email) {
          if (validateEmailsQuantity(validEmails)) {
            var cleaned = email.trim().replace(" ", "").latinize();
            if (validateEmail(cleaned) && validateEmailsLength(validEmails, cleaned)) {
              validEmails.push(cleaned);
            }
          }
        });
        result = validEmails.join(',');
      }
      return result;
    }

    function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    function validatePlanDate(start, end) {
      start = timeUtils.createTime(start);
      end = timeUtils.createTime(end);

      // Error 1: start date is greater than end date
      if (!vm.isCopy && timeUtils.isAfter(start, end)) {
        vm.activateSaveBtn = false;
        vm.settingsErrorDateStart = true;
        return;
      }

      // All ok, activate save button
      vm.activateSaveBtn = true;
      vm.settingsErrorDateStart = false;
    }

    function goToCodrivers(vehicle) {
      
      var specificRoute = null;
      
      // Si vehicle es un objeto con vehicle (viene de routingSummaryTable)
      if (vehicle && vehicle.vehicle) {
        specificRoute = vehicle.route || null;
        vehicle = vehicle.vehicle;
      }
      
      if (!vehicle) {
        return;
      }
      
      var routesToEdit = specificRoute && vm.isMultiDriversConfigEnabled ? [specificRoute] : vehicle.routes;
      
      $state.go("planner.vehicles-list.plans-detail.codrivers", {
        planId: $stateParams.planId,
        vehicleId: vehicle.id,
        routes: routesToEdit
      });
    }

    function _deleteDraftPlan(plan) {
      saveDraftPlanService.deleteDraftPlan(plan.id);
      $state.go(vm.pathToPreviousView);
    }

    function showDeleteModal(event, plan) {
      saveDraftPlanUtilService.showDeleteModal(event, {
        plan: function () {
          return plan;
        },
        deletePlan: function () {
          return _deleteDraftPlan;
        }
      });
    }

    function latinizeString() {
      var Latinise = {};
      Latinise.latin_map = {
        "Á": "A",
        "Ă": "A",
        "Ắ": "A",
        "Ặ": "A",
        "Ằ": "A",
        "Ẳ": "A",
        "Ẵ": "A",
        "Ǎ": "A",
        "Â": "A",
        "Ấ": "A",
        "Ậ": "A",
        "Ầ": "A",
        "Ẩ": "A",
        "Ẫ": "A",
        "Ä": "A",
        "Ǟ": "A",
        "Ȧ": "A",
        "Ǡ": "A",
        "Ạ": "A",
        "Ȁ": "A",
        "À": "A",
        "Ả": "A",
        "Ȃ": "A",
        "Ā": "A",
        "Ą": "A",
        "Å": "A",
        "Ǻ": "A",
        "Ḁ": "A",
        "Ⱥ": "A",
        "Ã": "A",
        "Ꜳ": "AA",
        "Æ": "AE",
        "Ǽ": "AE",
        "Ǣ": "AE",
        "Ꜵ": "AO",
        "Ꜷ": "AU",
        "Ꜹ": "AV",
        "Ꜻ": "AV",
        "Ꜽ": "AY",
        "Ḃ": "B",
        "Ḅ": "B",
        "Ɓ": "B",
        "Ḇ": "B",
        "Ƀ": "B",
        "Ƃ": "B",
        "Ć": "C",
        "Č": "C",
        "Ç": "C",
        "Ḉ": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Ƈ": "C",
        "Ȼ": "C",
        "Ď": "D",
        "Ḑ": "D",
        "Ḓ": "D",
        "Ḋ": "D",
        "Ḍ": "D",
        "Ɗ": "D",
        "Ḏ": "D",
        "ǲ": "D",
        "ǅ": "D",
        "Đ": "D",
        "Ƌ": "D",
        "Ǳ": "DZ",
        "Ǆ": "DZ",
        "É": "E",
        "Ĕ": "E",
        "Ě": "E",
        "Ȩ": "E",
        "Ḝ": "E",
        "Ê": "E",
        "Ế": "E",
        "Ệ": "E",
        "Ề": "E",
        "Ể": "E",
        "Ễ": "E",
        "Ḙ": "E",
        "Ë": "E",
        "Ė": "E",
        "Ẹ": "E",
        "Ȅ": "E",
        "È": "E",
        "Ẻ": "E",
        "Ȇ": "E",
        "Ē": "E",
        "Ḗ": "E",
        "Ḕ": "E",
        "Ę": "E",
        "Ɇ": "E",
        "Ẽ": "E",
        "Ḛ": "E",
        "Ꝫ": "ET",
        "Ḟ": "F",
        "Ƒ": "F",
        "Ǵ": "G",
        "Ğ": "G",
        "Ǧ": "G",
        "Ģ": "G",
        "Ĝ": "G",
        "Ġ": "G",
        "Ɠ": "G",
        "Ḡ": "G",
        "Ǥ": "G",
        "Ḫ": "H",
        "Ȟ": "H",
        "Ḩ": "H",
        "Ĥ": "H",
        "Ⱨ": "H",
        "Ḧ": "H",
        "Ḣ": "H",
        "Ḥ": "H",
        "Ħ": "H",
        "Í": "I",
        "Ĭ": "I",
        "Ǐ": "I",
        "Î": "I",
        "Ï": "I",
        "Ḯ": "I",
        "İ": "I",
        "Ị": "I",
        "Ȉ": "I",
        "Ì": "I",
        "Ỉ": "I",
        "Ȋ": "I",
        "Ī": "I",
        "Į": "I",
        "Ɨ": "I",
        "Ĩ": "I",
        "Ḭ": "I",
        "Ꝺ": "D",
        "Ꝼ": "F",
        "Ᵹ": "G",
        "Ꞃ": "R",
        "Ꞅ": "S",
        "Ꞇ": "T",
        "Ꝭ": "IS",
        "Ĵ": "J",
        "Ɉ": "J",
        "Ḱ": "K",
        "Ǩ": "K",
        "Ķ": "K",
        "Ⱪ": "K",
        "Ꝃ": "K",
        "Ḳ": "K",
        "Ƙ": "K",
        "Ḵ": "K",
        "Ꝁ": "K",
        "Ꝅ": "K",
        "Ĺ": "L",
        "Ƚ": "L",
        "Ľ": "L",
        "Ļ": "L",
        "Ḽ": "L",
        "Ḷ": "L",
        "Ḹ": "L",
        "Ⱡ": "L",
        "Ꝉ": "L",
        "Ḻ": "L",
        "Ŀ": "L",
        "Ɫ": "L",
        "ǈ": "L",
        "Ł": "L",
        "Ǉ": "LJ",
        "Ḿ": "M",
        "Ṁ": "M",
        "Ṃ": "M",
        "Ɱ": "M",
        "Ń": "N",
        "Ň": "N",
        "Ņ": "N",
        "Ṋ": "N",
        "Ṅ": "N",
        "Ṇ": "N",
        "Ǹ": "N",
        "Ɲ": "N",
        "Ṉ": "N",
        "Ƞ": "N",
        "ǋ": "N",
        "Ñ": "N",
        "Ǌ": "NJ",
        "Ó": "O",
        "Ŏ": "O",
        "Ǒ": "O",
        "Ô": "O",
        "Ố": "O",
        "Ộ": "O",
        "Ồ": "O",
        "Ổ": "O",
        "Ỗ": "O",
        "Ö": "O",
        "Ȫ": "O",
        "Ȯ": "O",
        "Ȱ": "O",
        "Ọ": "O",
        "Ő": "O",
        "Ȍ": "O",
        "Ò": "O",
        "Ỏ": "O",
        "Ơ": "O",
        "Ớ": "O",
        "Ợ": "O",
        "Ờ": "O",
        "Ở": "O",
        "Ỡ": "O",
        "Ȏ": "O",
        "Ꝋ": "O",
        "Ꝍ": "O",
        "Ō": "O",
        "Ṓ": "O",
        "Ṑ": "O",
        "Ɵ": "O",
        "Ǫ": "O",
        "Ǭ": "O",
        "Ø": "O",
        "Ǿ": "O",
        "Õ": "O",
        "Ṍ": "O",
        "Ṏ": "O",
        "Ȭ": "O",
        "Ƣ": "OI",
        "Ꝏ": "OO",
        "Ɛ": "E",
        "Ɔ": "O",
        "Ȣ": "OU",
        "Ṕ": "P",
        "Ṗ": "P",
        "Ꝓ": "P",
        "Ƥ": "P",
        "Ꝕ": "P",
        "Ᵽ": "P",
        "Ꝑ": "P",
        "Ꝙ": "Q",
        "Ꝗ": "Q",
        "Ŕ": "R",
        "Ř": "R",
        "Ŗ": "R",
        "Ṙ": "R",
        "Ṛ": "R",
        "Ṝ": "R",
        "Ȑ": "R",
        "Ȓ": "R",
        "Ṟ": "R",
        "Ɍ": "R",
        "Ɽ": "R",
        "Ꜿ": "C",
        "Ǝ": "E",
        "Ś": "S",
        "Ṥ": "S",
        "Š": "S",
        "Ṧ": "S",
        "Ş": "S",
        "Ŝ": "S",
        "Ș": "S",
        "Ṡ": "S",
        "Ṣ": "S",
        "Ṩ": "S",
        "Ť": "T",
        "Ţ": "T",
        "Ṱ": "T",
        "Ț": "T",
        "Ⱦ": "T",
        "Ṫ": "T",
        "Ṭ": "T",
        "Ƭ": "T",
        "Ṯ": "T",
        "Ʈ": "T",
        "Ŧ": "T",
        "Ɐ": "A",
        "Ꞁ": "L",
        "Ɯ": "M",
        "Ʌ": "V",
        "Ꜩ": "TZ",
        "Ú": "U",
        "Ŭ": "U",
        "Ǔ": "U",
        "Û": "U",
        "Ṷ": "U",
        "Ü": "U",
        "Ǘ": "U",
        "Ǚ": "U",
        "Ǜ": "U",
        "Ǖ": "U",
        "Ṳ": "U",
        "Ụ": "U",
        "Ű": "U",
        "Ȕ": "U",
        "Ù": "U",
        "Ủ": "U",
        "Ư": "U",
        "Ứ": "U",
        "Ự": "U",
        "Ừ": "U",
        "Ử": "U",
        "Ữ": "U",
        "Ȗ": "U",
        "Ū": "U",
        "Ṻ": "U",
        "Ų": "U",
        "Ů": "U",
        "Ũ": "U",
        "Ṹ": "U",
        "Ṵ": "U",
        "Ꝟ": "V",
        "Ṿ": "V",
        "Ʋ": "V",
        "Ṽ": "V",
        "Ꝡ": "VY",
        "Ẃ": "W",
        "Ŵ": "W",
        "Ẅ": "W",
        "Ẇ": "W",
        "Ẉ": "W",
        "Ẁ": "W",
        "Ⱳ": "W",
        "Ẍ": "X",
        "Ẋ": "X",
        "Ý": "Y",
        "Ŷ": "Y",
        "Ÿ": "Y",
        "Ẏ": "Y",
        "Ỵ": "Y",
        "Ỳ": "Y",
        "Ƴ": "Y",
        "Ỷ": "Y",
        "Ỿ": "Y",
        "Ȳ": "Y",
        "Ɏ": "Y",
        "Ỹ": "Y",
        "Ź": "Z",
        "Ž": "Z",
        "Ẑ": "Z",
        "Ⱬ": "Z",
        "Ż": "Z",
        "Ẓ": "Z",
        "Ȥ": "Z",
        "Ẕ": "Z",
        "Ƶ": "Z",
        "Ĳ": "IJ",
        "Œ": "OE",
        "ᴀ": "A",
        "ᴁ": "AE",
        "ʙ": "B",
        "ᴃ": "B",
        "ᴄ": "C",
        "ᴅ": "D",
        "ᴇ": "E",
        "ꜰ": "F",
        "ɢ": "G",
        "ʛ": "G",
        "ʜ": "H",
        "ɪ": "I",
        "ʁ": "R",
        "ᴊ": "J",
        "ᴋ": "K",
        "ʟ": "L",
        "ᴌ": "L",
        "ᴍ": "M",
        "ɴ": "N",
        "ᴏ": "O",
        "ɶ": "OE",
        "ᴐ": "O",
        "ᴕ": "OU",
        "ᴘ": "P",
        "ʀ": "R",
        "ᴎ": "N",
        "ᴙ": "R",
        "ꜱ": "S",
        "ᴛ": "T",
        "ⱻ": "E",
        "ᴚ": "R",
        "ᴜ": "U",
        "ᴠ": "V",
        "ᴡ": "W",
        "ʏ": "Y",
        "ᴢ": "Z",
        "á": "a",
        "ă": "a",
        "ắ": "a",
        "ặ": "a",
        "ằ": "a",
        "ẳ": "a",
        "ẵ": "a",
        "ǎ": "a",
        "â": "a",
        "ấ": "a",
        "ậ": "a",
        "ầ": "a",
        "ẩ": "a",
        "ẫ": "a",
        "ä": "a",
        "ǟ": "a",
        "ȧ": "a",
        "ǡ": "a",
        "ạ": "a",
        "ȁ": "a",
        "à": "a",
        "ả": "a",
        "ȃ": "a",
        "ā": "a",
        "ą": "a",
        "ᶏ": "a",
        "ẚ": "a",
        "å": "a",
        "ǻ": "a",
        "ḁ": "a",
        "ⱥ": "a",
        "ã": "a",
        "ꜳ": "aa",
        "æ": "ae",
        "ǽ": "ae",
        "ǣ": "ae",
        "ꜵ": "ao",
        "ꜷ": "au",
        "ꜹ": "av",
        "ꜻ": "av",
        "ꜽ": "ay",
        "ḃ": "b",
        "ḅ": "b",
        "ɓ": "b",
        "ḇ": "b",
        "ᵬ": "b",
        "ᶀ": "b",
        "ƀ": "b",
        "ƃ": "b",
        "ɵ": "o",
        "ć": "c",
        "č": "c",
        "ç": "c",
        "ḉ": "c",
        "ĉ": "c",
        "ɕ": "c",
        "ċ": "c",
        "ƈ": "c",
        "ȼ": "c",
        "ď": "d",
        "ḑ": "d",
        "ḓ": "d",
        "ȡ": "d",
        "ḋ": "d",
        "ḍ": "d",
        "ɗ": "d",
        "ᶑ": "d",
        "ḏ": "d",
        "ᵭ": "d",
        "ᶁ": "d",
        "đ": "d",
        "ɖ": "d",
        "ƌ": "d",
        "ı": "i",
        "ȷ": "j",
        "ɟ": "j",
        "ʄ": "j",
        "ǳ": "dz",
        "ǆ": "dz",
        "é": "e",
        "ĕ": "e",
        "ě": "e",
        "ȩ": "e",
        "ḝ": "e",
        "ê": "e",
        "ế": "e",
        "ệ": "e",
        "ề": "e",
        "ể": "e",
        "ễ": "e",
        "ḙ": "e",
        "ë": "e",
        "ė": "e",
        "ẹ": "e",
        "ȅ": "e",
        "è": "e",
        "ẻ": "e",
        "ȇ": "e",
        "ē": "e",
        "ḗ": "e",
        "ḕ": "e",
        "ⱸ": "e",
        "ę": "e",
        "ᶒ": "e",
        "ɇ": "e",
        "ẽ": "e",
        "ḛ": "e",
        "ꝫ": "et",
        "ḟ": "f",
        "ƒ": "f",
        "ᵮ": "f",
        "ᶂ": "f",
        "ǵ": "g",
        "ğ": "g",
        "ǧ": "g",
        "ģ": "g",
        "ĝ": "g",
        "ġ": "g",
        "ɠ": "g",
        "ḡ": "g",
        "ᶃ": "g",
        "ǥ": "g",
        "ḫ": "h",
        "ȟ": "h",
        "ḩ": "h",
        "ĥ": "h",
        "ⱨ": "h",
        "ḧ": "h",
        "ḣ": "h",
        "ḥ": "h",
        "ɦ": "h",
        "ẖ": "h",
        "ħ": "h",
        "ƕ": "hv",
        "í": "i",
        "ĭ": "i",
        "ǐ": "i",
        "î": "i",
        "ï": "i",
        "ḯ": "i",
        "ị": "i",
        "ȉ": "i",
        "ì": "i",
        "ỉ": "i",
        "ȋ": "i",
        "ī": "i",
        "į": "i",
        "ᶖ": "i",
        "ɨ": "i",
        "ĩ": "i",
        "ḭ": "i",
        "ꝺ": "d",
        "ꝼ": "f",
        "ᵹ": "g",
        "ꞃ": "r",
        "ꞅ": "s",
        "ꞇ": "t",
        "ꝭ": "is",
        "ǰ": "j",
        "ĵ": "j",
        "ʝ": "j",
        "ɉ": "j",
        "ḱ": "k",
        "ǩ": "k",
        "ķ": "k",
        "ⱪ": "k",
        "ꝃ": "k",
        "ḳ": "k",
        "ƙ": "k",
        "ḵ": "k",
        "ᶄ": "k",
        "ꝁ": "k",
        "ꝅ": "k",
        "ĺ": "l",
        "ƚ": "l",
        "ɬ": "l",
        "ľ": "l",
        "ļ": "l",
        "ḽ": "l",
        "ȴ": "l",
        "ḷ": "l",
        "ḹ": "l",
        "ⱡ": "l",
        "ꝉ": "l",
        "ḻ": "l",
        "ŀ": "l",
        "ɫ": "l",
        "ᶅ": "l",
        "ɭ": "l",
        "ł": "l",
        "ǉ": "lj",
        "ſ": "s",
        "ẜ": "s",
        "ẛ": "s",
        "ẝ": "s",
        "ḿ": "m",
        "ṁ": "m",
        "ṃ": "m",
        "ɱ": "m",
        "ᵯ": "m",
        "ᶆ": "m",
        "ń": "n",
        "ň": "n",
        "ņ": "n",
        "ṋ": "n",
        "ȵ": "n",
        "ṅ": "n",
        "ṇ": "n",
        "ǹ": "n",
        "ɲ": "n",
        "ṉ": "n",
        "ƞ": "n",
        "ᵰ": "n",
        "ᶇ": "n",
        "ɳ": "n",
        "ñ": "n",
        "ǌ": "nj",
        "ó": "o",
        "ŏ": "o",
        "ǒ": "o",
        "ô": "o",
        "ố": "o",
        "ộ": "o",
        "ồ": "o",
        "ổ": "o",
        "ỗ": "o",
        "ö": "o",
        "ȫ": "o",
        "ȯ": "o",
        "ȱ": "o",
        "ọ": "o",
        "ő": "o",
        "ȍ": "o",
        "ò": "o",
        "ỏ": "o",
        "ơ": "o",
        "ớ": "o",
        "ợ": "o",
        "ờ": "o",
        "ở": "o",
        "ỡ": "o",
        "ȏ": "o",
        "ꝋ": "o",
        "ꝍ": "o",
        "ⱺ": "o",
        "ō": "o",
        "ṓ": "o",
        "ṑ": "o",
        "ǫ": "o",
        "ǭ": "o",
        "ø": "o",
        "ǿ": "o",
        "õ": "o",
        "ṍ": "o",
        "ṏ": "o",
        "ȭ": "o",
        "ƣ": "oi",
        "ꝏ": "oo",
        "ɛ": "e",
        "ᶓ": "e",
        "ɔ": "o",
        "ᶗ": "o",
        "ȣ": "ou",
        "ṕ": "p",
        "ṗ": "p",
        "ꝓ": "p",
        "ƥ": "p",
        "ᵱ": "p",
        "ᶈ": "p",
        "ꝕ": "p",
        "ᵽ": "p",
        "ꝑ": "p",
        "ꝙ": "q",
        "ʠ": "q",
        "ɋ": "q",
        "ꝗ": "q",
        "ŕ": "r",
        "ř": "r",
        "ŗ": "r",
        "ṙ": "r",
        "ṛ": "r",
        "ṝ": "r",
        "ȑ": "r",
        "ɾ": "r",
        "ᵳ": "r",
        "ȓ": "r",
        "ṟ": "r",
        "ɼ": "r",
        "ᵲ": "r",
        "ᶉ": "r",
        "ɍ": "r",
        "ɽ": "r",
        "ↄ": "c",
        "ꜿ": "c",
        "ɘ": "e",
        "ɿ": "r",
        "ś": "s",
        "ṥ": "s",
        "š": "s",
        "ṧ": "s",
        "ş": "s",
        "ŝ": "s",
        "ș": "s",
        "ṡ": "s",
        "ṣ": "s",
        "ṩ": "s",
        "ʂ": "s",
        "ᵴ": "s",
        "ᶊ": "s",
        "ȿ": "s",
        "ɡ": "g",
        "ᴑ": "o",
        "ᴓ": "o",
        "ᴝ": "u",
        "ť": "t",
        "ţ": "t",
        "ṱ": "t",
        "ț": "t",
        "ȶ": "t",
        "ẗ": "t",
        "ⱦ": "t",
        "ṫ": "t",
        "ṭ": "t",
        "ƭ": "t",
        "ṯ": "t",
        "ᵵ": "t",
        "ƫ": "t",
        "ʈ": "t",
        "ŧ": "t",
        "ᵺ": "th",
        "ɐ": "a",
        "ᴂ": "ae",
        "ǝ": "e",
        "ᵷ": "g",
        "ɥ": "h",
        "ʮ": "h",
        "ʯ": "h",
        "ᴉ": "i",
        "ʞ": "k",
        "ꞁ": "l",
        "ɯ": "m",
        "ɰ": "m",
        "ᴔ": "oe",
        "ɹ": "r",
        "ɻ": "r",
        "ɺ": "r",
        "ⱹ": "r",
        "ʇ": "t",
        "ʌ": "v",
        "ʍ": "w",
        "ʎ": "y",
        "ꜩ": "tz",
        "ú": "u",
        "ŭ": "u",
        "ǔ": "u",
        "û": "u",
        "ṷ": "u",
        "ü": "u",
        "ǘ": "u",
        "ǚ": "u",
        "ǜ": "u",
        "ǖ": "u",
        "ṳ": "u",
        "ụ": "u",
        "ű": "u",
        "ȕ": "u",
        "ù": "u",
        "ủ": "u",
        "ư": "u",
        "ứ": "u",
        "ự": "u",
        "ừ": "u",
        "ử": "u",
        "ữ": "u",
        "ȗ": "u",
        "ū": "u",
        "ṻ": "u",
        "ų": "u",
        "ᶙ": "u",
        "ů": "u",
        "ũ": "u",
        "ṹ": "u",
        "ṵ": "u",
        "ᵫ": "ue",
        "ꝸ": "um",
        "ⱴ": "v",
        "ꝟ": "v",
        "ṿ": "v",
        "ʋ": "v",
        "ᶌ": "v",
        "ⱱ": "v",
        "ṽ": "v",
        "ꝡ": "vy",
        "ẃ": "w",
        "ŵ": "w",
        "ẅ": "w",
        "ẇ": "w",
        "ẉ": "w",
        "ẁ": "w",
        "ⱳ": "w",
        "ẘ": "w",
        "ẍ": "x",
        "ẋ": "x",
        "ᶍ": "x",
        "ý": "y",
        "ŷ": "y",
        "ÿ": "y",
        "ẏ": "y",
        "ỵ": "y",
        "ỳ": "y",
        "ƴ": "y",
        "ỷ": "y",
        "ỿ": "y",
        "ȳ": "y",
        "ẙ": "y",
        "ɏ": "y",
        "ỹ": "y",
        "ź": "z",
        "ž": "z",
        "ẑ": "z",
        "ʑ": "z",
        "ⱬ": "z",
        "ż": "z",
        "ẓ": "z",
        "ȥ": "z",
        "ẕ": "z",
        "ᵶ": "z",
        "ᶎ": "z",
        "ʐ": "z",
        "ƶ": "z",
        "ɀ": "z",
        "ﬀ": "ff",
        "ﬃ": "ffi",
        "ﬄ": "ffl",
        "ﬁ": "fi",
        "ﬂ": "fl",
        "ĳ": "ij",
        "œ": "oe",
        "ﬆ": "st",
        "ₐ": "a",
        "ₑ": "e",
        "ᵢ": "i",
        "ⱼ": "j",
        "ₒ": "o",
        "ᵣ": "r",
        "ᵤ": "u",
        "ᵥ": "v",
        "ₓ": "x"
      };

      String.prototype.latinize = function () {
        return this.replace(/[^A-Za-z0-9\[\] ]/g, function (a) {
          return Latinise.latin_map[a] || a;
        });
      };
    }

    function _mapRouteToOriginalDrivers(routes) {
      var originalRouteDrivers = {};
      routes.forEach(function (route) {
        originalRouteDrivers[route.id] = route.driver;
      });

      return originalRouteDrivers;
    }

    function _updateToOriginalRouteDrivers(routes) {
      routes.forEach(function (route) {
        var originalRouteDriver = vm.originalRouteDrivers[route.id];
        if (originalRouteDriver !== route.driver) {
          route.driver = originalRouteDriver;
        }
      });
    }
  }
})();

(function () {
  "use strict";
  angular
    .module("icarus.planner")
    .controller("PlannerDraftPlansController", PlannerDraftPlansController);
  /** @ngInject */
  function PlannerDraftPlansController(
    $state,
    $rootScope,
    saveDraftPlanService,
    saveDraftPlanUtilService
  ) {
    var vm = this;
    vm.goToDetail = goToDetail;
    vm.showDeleteModal = showDeleteModal;

    activate();

    function activate() {
      $rootScope.isLoading = true;
      return saveDraftPlanService
        .getNewPlans()
        .then(successGetPlans)
        .catch(errorGetPlans)
        .finally(function () {
          $rootScope.isLoading = false;
        });

      function successGetPlans(newPlans) {
        vm.draftPlans = newPlans;
      }

      function errorGetPlans(error) {
        console.error("Error getting draft plans", error);
        $state.go("^");
        return [];
      }
    }

    function goToDetail(planId) {
      $state.go("planner.vehicles-list.plans-detail", {
        planId: planId,
        isDraft: true
      });
    }

    function _deleteDraftPlan(plan) {
      saveDraftPlanService.deleteDraftPlan(plan.id);
      activate();
    }

    function showDeleteModal(event, plan) {
      saveDraftPlanUtilService.showDeleteModal(event, {
        plan: function () {
          return plan;
        },
        deletePlan: function () {
          return _deleteDraftPlan;
        },
      });
    }
  }
})();

(function () {
  "use strict";
  angular
    .module("icarus.planner")
    .controller(
      "PlannerPlansCodriversDetailController",
      PlannerPlansCodriversDetailController
    );

  /** @ngInject */
  function PlannerPlansCodriversDetailController(
    $state,
    $stateParams,
    plannerService,
    __env,
    CODDRIVERS_ITEMS_PER_PAGE
  ) {
    var vm = this;

    vm.codrivers = [];
    vm.routes = [];
    vm.selectedCodrivers = [];
    vm.selectableCodrivers = [];
    vm.itemsPerPage = CODDRIVERS_ITEMS_PER_PAGE;

    vm.saveCodrivers = saveCodrivers;
    vm.buildCodriversBody = buildCodriversBody;

    activate();

    function activate() {
      vm.codrivers = plannerService.getCodrivers();
      vm.routes = $stateParams.routes;

      if (vm.codrivers.length === 0 && vm.routes) {
        $state.go("planner.vehicles-list.plans-detail");
      }

      vm.selectedCodrivers = vm.routes[0].codrivers;
      vm.selectableCodrivers = {
        msgItemsEmpty: "",
        itemsSelected: 0,
      };

      vm.selectableCodrivers.items = vm.codrivers.map(function (codriver) {
        return {
          id: codriver.id,
          name: codriver.name,
          activate: vm.selectedCodrivers.indexOf(parseInt(codriver.id)) > -1
        };
      });
    }

    function saveCodrivers() {
      var codriversBody = vm.buildCodriversBody();
      var selectedCodrivers = codriversBody[0].codriver_ids;
      
      plannerService.saveCodrivers(codriversBody)
        .then(function() {
          var planId = $stateParams.planId;
          if (planId) {
            return plannerService.setCodriversByPlan(planId);
          }
          return null;
        })
        .then(function() {
          var routesCodrivers = plannerService.getCodriversPlan() || [];
          
          vm.routes.forEach(function(route) {
            var routeBackendId = route.backendId || route.id;
            var foundCodrivers = routesCodrivers.find(function(codriverPlan) {
              return String(codriverPlan.route_id) === String(routeBackendId);
            });
            
            if (foundCodrivers) {
              route.codrivers = (foundCodrivers.codrivers || []).map(String).slice();
            } else {
              route.codrivers = [];
            }
            
            var originalPlan = plannerService.getOriginalPlan();
            if (originalPlan && originalPlan.routes) {
              var originalRoute = originalPlan.routes.find(function(r) {
                return String(r.id) === String(route.id);
              });
              if (originalRoute) {
                var originalRouteBackendId = originalRoute.id;
                var foundOriginalCodrivers = routesCodrivers.find(function(codriverPlan) {
                  return String(codriverPlan.route_id) === String(originalRouteBackendId);
                });
                if (foundOriginalCodrivers) {
                  originalRoute.codrivers = (foundOriginalCodrivers.codrivers || []).slice();
                } else {
                  originalRoute.codrivers = [];
                }
              }
            }
          });
          
          var originalPlan = plannerService.getOriginalPlan();
          if (originalPlan && originalPlan.routes && originalPlan.routes.length > 0) {
            plannerService.setVehiclesCodrivers();
          }
          
          $state.go("planner.vehicles-list.plans-detail");
        });
    }

    function buildCodriversBody() {
      var selectedCodrivers = vm.selectableCodrivers.items.filter(function (
        codriver
      ) {
        return codriver.activate;
      });
      selectedCodrivers = selectedCodrivers.map(function (codriver) {
        return codriver.id;
      });
      var routes = vm.routes.map(function (route) {
        return route.id;
      });
      return [{ route_ids: routes, codriver_ids: selectedCodrivers }];
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('icarus.planner')
    .service('routesUtils', routesUtils);

  /** @ngInject */
  function routesUtils($filter, timeUtils, utilsService, VISIT_SOURCE, VISIT_TYPE) {
    var DIFF_FORMAT = "milliseconds";
    var valueHighlightVisitByWeight = 0;
    var valueHighlightVisitByWeight2 = 0;
    var valueHighlightVisitByWeight3 = 0;
    var $translate = $filter('translate');

    var service = {
      getStyleByLoadLimit: getStyleByLoadLimit,
      getHighlightConfigurations: getHighlightConfigurations,
      setHighlightConfigurations: setHighlightConfigurations,
      valueHighlightVisitByWeight: valueHighlightVisitByWeight,
      valueHighlightVisitByWeight2: valueHighlightVisitByWeight2,
      valueHighlightVisitByWeight3: valueHighlightVisitByWeight3,
      onMouseHoverVisit: onMouseHoverVisit,
      onMouseLeaveVisit: onMouseLeaveVisit,
      adjustRouteTimes: adjustRouteTimes,
      toggleVisibleAllRoutesHandler: toggleVisibleAllRoutesHandler,
      updateSelectedDrivers: updateSelectedDrivers,
      scrollToElement: scrollToElement,
      updateVehicleDriver: updateVehicleDriver,
      calculateClientCount: calculateClientCount,
      setVehicleDriver: setVehicleDriver,
      getDriverFullName: getDriverFullName,
      haveSameDriver: haveSameDriver,
      getPreviousVisit: getPreviousVisit,
      getNextVisit: getNextVisit,
      doesRouteExceedMaxDistance: doesRouteExceedMaxDistance,
      doesVehicleHaveRouteExceedingMaxDistance: doesVehicleHaveRouteExceedingMaxDistance
    };

    return service;
    /**
     * Set highlight values
     * @param {number} configLoad
     * @param {number} configLoad2
     * @param {number} configLoad3
     */
    function setHighlightConfigurations (configLoad, configLoad2, configLoad3) {
      valueHighlightVisitByWeight = configLoad;
      valueHighlightVisitByWeight2 = configLoad2;
      valueHighlightVisitByWeight3 = configLoad3;
    }

    /**
     * Return all highlight values
     */
    function getHighlightConfigurations() {
      return {
        valueHighlightVisitByWeight: valueHighlightVisitByWeight,
        valueHighlightVisitByWeight2: valueHighlightVisitByWeight2,
        valueHighlightVisitByWeight3: valueHighlightVisitByWeight3
      };
    }
    /**
     * determines whether or not the style is highlighted according to the color of the visit, the status of the cell, the weight of the load and whether the highlightvisitbyweigh account setting is enabled.
     * @param {number} visitLoad - Weight of the load of the visit.
     * @param {string} eventState - state of the event.
     * @return {Object} object with the selected styles.
     */
    function getStyleByLoadLimit(visit, eventState) {
      var isValidVisitWeight =  valueHighlightVisitByWeight < 1 || visit.load < valueHighlightVisitByWeight;
      var isValidVisitWeight2 =  valueHighlightVisitByWeight2 < 1 || visit.load2 < valueHighlightVisitByWeight2;
      var isValidVisitWeight3 =  valueHighlightVisitByWeight3 < 1 || visit.load3 < valueHighlightVisitByWeight3;
      if (isValidVisitWeight && isValidVisitWeight2 && isValidVisitWeight3) {
        return;
      }

      if (eventState === 'over') {
        return {'background-color': '#aab8a6'};
      }

      return {'background-color': '#DFF7D8'};
    }

    function onMouseHoverVisit (visit, activeFilter, isCurrentVisitFilter, setHoverActiveAnotherVisit) {
      if(activeFilter && !isCurrentVisitFilter){
        setHoverActiveAnotherVisit(true);
      }
      visit.setDarkerHighlight(true, true);
    }

    function onMouseLeaveVisit (visit, activeFilter, setHoverActiveAnotherVisit) {
      if(activeFilter){
        setHoverActiveAnotherVisit(false);
      }
      visit.setDarkerHighlight(false, true);
    }

    function scrollToElement (element) {
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start'});
      }
    }

    function adjustRouteTimes(route, isTheFirstRoute, isTheLastRoute, planDate, vehicleShiftTime, optimizationOptions) {
      var anyVisitTimeError = false;
      var lastVisitIndex = route.visits.length - 1;
      var estimatedTimes = utilsService.getEstimatedTimesAsDateTime(
        planDate, route.estimatedTimeStart, route.estimatedTimeEnd
      );

      route.estimatedTimeStart = estimatedTimes.start;
      route.estimatedTimeEnd = estimatedTimes.end;

      route.visits.forEach(function (visit, index) {
        visit.adjustToTimeWindow();

        if (visit.timeError) {
          anyVisitTimeError = true;
        } else if (_isETASameOrAfterVehicleShiftEnd(visit.estimatedTimeArrival, vehicleShiftTime.end)) {
          anyVisitTimeError = true;
          visit.timeError = true;
        }

        if (index === 0 && isTheFirstRoute && optimizationOptions.open_start) {
          route.estimatedTimeStart = visit.estimatedTimeArrival;
        }

        if (index === lastVisitIndex && isTheLastRoute && optimizationOptions.open_ended) {
          route.estimatedTimeEnd = visit.estimatedTimeDeparture;
        }
      });

      var diff = timeUtils.diff(route.estimatedTimeEnd, route.estimatedTimeStart, DIFF_FORMAT);
      route.totalTime = timeUtils.formatDuration(diff);
      route.totalTimeFormatted = route.totalTime;
      route.timeError = anyVisitTimeError;
    }

    function toggleVisibleAllRoutesHandler(vehicles) {
      return  vehicles.some(function (vehicle) {
        return vehicle.showRoutes;
      });
    }

    function updateSelectedDrivers(vehicles, drivers) {
      var selectedDriverIds = [];
      vehicles.forEach(function (vehicle) {
        var driverId = vehicle.driverId;
        if (driverId) {
          selectedDriverIds.push(driverId);
          return;
        }

        vehicle.routes.forEach(function (route) {
          var driverId = route.driver;
          if (driverId) {
            selectedDriverIds.push(driverId);
          }
        });
      });

      drivers.forEach(function (driver) {
        var isDriverSelected = selectedDriverIds.some(function (driverId) {
          return driverId === driver.id;
        });

        driver.group = isDriverSelected ? $translate("Driver.group_assigned") : $translate("Driver.group_available");
        driver.selected = isDriverSelected;
      });
    }

    function updateVehicleDriver(vehicle, drivers) {
      var driverId = vehicle.driverId;
      if (driverId) {
        var foundDriver = drivers.find(function (driver) {
          return driver.id === driverId;
        });

        if (foundDriver) {
          vehicle.driver = foundDriver;
        }
      } else {
        vehicle.driver = null;
      }

      vehicle.routes.forEach(function (route) {
        route.driver = driverId;
      });
    }

    function setVehicleDriver(vehicle, route, drivers) {
      vehicle.driver = null;
      vehicle.driverId = null;
      var driverId = route ? route.driver : null;
      if (!driverId || !haveSameDriver(vehicle.routes, driverId)) {
        return;
      }

      var foundDriver = drivers.find(function (driver) {
        return driver.id === driverId;
      });

      if (foundDriver) {
        vehicle.driver = foundDriver;
        vehicle.driverId = driverId;
      }
    }

    function calculateClientCount(visits) {
      var clientKeys = {};
      visits.forEach(function (visit) {
        var visitSource = visit.properties.source;
        var sourceIdent = visit.properties.source_ident;
        if (visitSource && visitSource.toUpperCase() === VISIT_SOURCE.CLIENT && !clientKeys[sourceIdent]) {
            clientKeys[sourceIdent] = true;
        }
      });

      return Object.keys(clientKeys).length;
    }

    function haveSameDriver(routes, routeDriverId) {
      return routes.every(function (route) {
        return route.driver === routeDriverId;
      });
    }

    /**
     * Get the full name of a driver by ID
     * @param {string} driverId - The ID of the driver
     * @param {Array} drivers - Array of driver objects
     * @returns {string} The driver's full name or empty string if not found
     */
    function getDriverFullName(driverId, drivers) {
      if (!driverId || !drivers) {
        return '';
      }

      for (var i = 0; i < drivers.length; i++) {
        if (drivers[i].id === driverId) {
          return drivers[i].name;
        }
      }
      return '';
    }

    function getPreviousVisit(visitsAndEvents, currentIndex) {
      for (var i = currentIndex - 1; i >= 0; i--) {
        if (visitsAndEvents[i].type === VISIT_TYPE.VISIT) {
          return visitsAndEvents[i];
        }
      }

      return null;
    }

    function getNextVisit(visitsAndEvents, currentIndex) {
      for (var i = currentIndex + 1; i < visitsAndEvents.length; i++) {
        if (visitsAndEvents[i].type === VISIT_TYPE.VISIT) {
          return visitsAndEvents[i];
        }
      }

      return null;
    }

    /**
     * Checks if a route exceeds the maximum route distance configured for a vehicle
     * @param {Object} route - The route to check
     * @param {Object} vehicle - The vehicle that has the route
     * @returns {boolean} - True if the route distance exceeds max_route_distance
     */
    function doesRouteExceedMaxDistance(route, vehicle) {
      if (!route || !vehicle || !vehicle.max_route_distance || vehicle.max_route_distance <= 0) {
        return false;
      }
      return route.totalDistance != null && route.totalDistance > vehicle.max_route_distance;
    }

    /**
     * Checks if a vehicle has any route that exceeds the maximum route distance
     * @param {Object} vehicle - The vehicle to check
     * @returns {boolean} - True if any route exceeds max_route_distance
     */
    function doesVehicleHaveRouteExceedingMaxDistance(vehicle) {
      if (!vehicle || !vehicle.routes || !Array.isArray(vehicle.routes)) {
        return false;
      }
      return vehicle.routes.some(function(route) {
        return doesRouteExceedMaxDistance(route, vehicle);
      });
    }

    ///// Private methods /////

    function _isETASameOrAfterVehicleShiftEnd(eta, shiftEnd) {
      var momentETA = timeUtils.createTime(eta);
      var momentShiftEnd = timeUtils.createTime(shiftEnd);

      return !momentETA.isBefore(momentShiftEnd);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('icarus.planner')
    .controller('PlannerRoutesController', PlannerRoutesController);

  /** @ngInject */
  function PlannerRoutesController($log, $q, $stateParams, $scope, plannerService, moment, $rootScope,
                                   $filter, ngDialog, $timeout, $interval, naturalService,
                                   Toasts, $state, sessionService, plannerReportsService, visitSimilarService,
                                   optimizeService, zoneService, accountConfigsService, store,
                                   timeUtils, routesUtils, statisticsService,
                                   routeDesignFilterService, routesOptimizationService, utilsService,
                                   ENABLE_PICKUP_AND_DELIVERY_MODE, ACCOUNT_CONFIGS, visitFilterService, visitsUtils,
                                   vehicleTypeUtils, EVENT_CREATE_MARKERS_LIGHT_FROM_ARRAY,
                                   EVENT_CREATE_VISITS_FROM_ARRAY, EVENT_REMOVE_VISITS_FROM_ARRAY,
                                   ROUTE_VISIBLE_OPACITY, ROUTE_TRANSLUCENT_POLYGON_OPACITY,
                                   VISIT_OUT_OF_ROUTE_VISUAL_STATE_ID, SHOW_VISIT_WINDOWS, visitsMarkersService,
                                   colorAssignerService, visitJoinerService, __env, optimizationUtilsService,
                                   VISIT_OUT_OF_ROUTE_DEFAULT_COLOR, VISIT_OUT_OF_ROUTE_ORDER, addonsService, accountingService,
                                   ExpandModalService, SELLER_MANAGEMENT_ADD_ON_KEY, VISIT_TYPE, PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES) {

    var vm = this;
    var UPDATE_SECONDS = 400;
    var REST_TIME = 'BreakVisit';
    var intervalPromise = null;
    var $translate = $filter('translate');
    var ENABLE_NOTES_IN_ROUTE_DESIGNER = 'enable_notes_in_route_designer';
    var VISITS_OUT_OF_ROUTE = 'visitsOFR';

    vm.planDate = null;
    vm.routes = null;
    vm.visitsOutOfRouteActions = {
      id: 'visitsOffRoute',
      _collapse: true
    };

    vm.show_visit_windows = accountConfigsService.isConfigEnabled(SHOW_VISIT_WINDOWS);

    Object.defineProperty(vm.visitsOutOfRouteActions, 'visits', {
      get: function() {
        // Should return the full or filtered list of the rendered visits.
        return vm.visitFilterHandler.activeFilter ? vm.visitFilterHandler.visits : vm.visitsOutOfRoute;
      }
    });

    Object.defineProperty(vm.visitsOutOfRouteActions, 'collapse', {
      get: function() {
        return this._collapse;
      },
      set: function(value) {
        this._collapse = value;
        $scope.$emit('Planner:visit-off-route:collapsed', {
          collapse: value
        });
      }
    });

    vm.editMode = false;
    vm.visitsOutOfRoute = [];
    vm.visitsOutOfRouteFormattedLoads = {
      load: 0,
      load2: 0,
      load3: 0
    };
    vm.selectAllVisitsOutOfRoute = false;
    vm.showVisitsOutOfRoutes = true;
    vm.visibleAllRoutes = true;
    vm.vehicles = [];
    vm.allVehicles = [];
    vm.moveToOptions = [];
    vm.enableNotesInRouteDesigner = false;
    vm.optionOutOfRoute = {
      name: $filter('translate')('Routes.out_of_route'),
      vehicleId: -1,
      routeId: -1,
      color: "#A4A4A4",
      background_color: 'none'
    };
    vm.jdh = 0;
    vm.optimize = 0;
    vm.isDirectEditingModeEnabled = false;

    vm.optimizationOptions = {
      balance: false,
      all_vehicles: true,
      big_cluster: false,
      join: false,
      open_ended: false
    };

    vm.drivers = [];
    vm.codrivers = [];

    // style dynamic del icono en el loading
    vm.widthDynamic = "0%";
    vm.routesCompleted = 0;
    vm.planName = null;
    vm.report = {excel: false, pdf: false, txt: false, summarizedPdf: false};
    vm.routeComment = null;
    vm.lastExpandedRoute = null;
    vm.isVisitsOutOfRouteListExpanded = false;
    vm.vehiclesToSeeRoutesInDetail = {};
    vm.isRouterJr = false;
    vm.isSellerManagementEnabled = false;

    vm.areVisitsMarkersVisible = true;
    vm.toggleShowRoutes = toggleShowRoutes;
    vm.toggleCollapseRoute = toggleCollapseRoute;
    vm.deployFinishModal = deployFinishModal;
    vm.toggleVisitsOutOfRoutes = toggleVisitsOutOfRoutes;
    vm.toggleVisibleAllRoutes = toggleVisibleAllRoutes;
    vm.fillVehiclesOptions = fillVehiclesOptions;
    vm.collapseOrExpandVisitsOutOfRoute = collapseOrExpandVisitsOutOfRoute;
    vm.naturalSort = naturalSort;
    vm.isEditingPlan = isEditingPlan;
    vm.calculateRouteArrivals = calculateRouteArrivals;
    vm.calculateRouteClients = calculateRouteClients;
    vm.calculateArrivalsOutOfRoute = calculateArrivalsOutOfRoute;
    vm.clearPlan = clearPlan;
    vm.downloadReport = downloadReport;
    vm.getPlanUnoptimized = getPlanUnoptimized;
    vm.reoptimizePlan = reoptimizePlan;
    vm.updateStepsPlanner = updateStepsPlanner;
    vm.updatePlannerIndicators = updatePlannerIndicators;
    vm.goToRoutesDetail = goToRoutesDetail;
    vm.openInfoModal = openInfoModal;
    vm.calculateTimeDiff = calculateTimeDiff;
    vm.optimizePlan = optimizePlan;
    vm.partialOptimization = partialOptimization;
    vm.getVehiclesForReoptimize = getVehiclesForReoptimize;
    vm.getRouteName = getRouteName;
    vm.customRouteNameConfig = false;
    vm.isMultidayRouteEnabled = false;
    vm.isVisitsOutOfRouteFilterEnabled = false;
    vm.isLoadBalanceEnabled = false;
    vm.isTimeBalanceEnabled = false;
    vm.isMultiDriversConfigEnabled = false;
    vm.highlightVisitByWeight = 0;
    vm.highlightVisitByWeight2 = 0;
    vm.highlightVisitByWeight3 = 0;
    vm.moment = moment;
    vm.isEnableNotesInRouteDesigner = isEnableNotesInRouteDesigner;
    vm.routesUtils = routesUtils;
    vm.createRoutesAfterOptimize = createRoutesAfterOptimize;
    vm.isPlanEditable = plannerService.isPlanEditable;
    vm.doesRouteExceedMaxDistance = routesUtils.doesRouteExceedMaxDistance;
    vm.doesVehicleHaveRouteExceedingMaxDistance = routesUtils.doesVehicleHaveRouteExceedingMaxDistance;

    vm.routeCodes = {};
    vm.dataByVehicle = statisticsService.dataByVehicle;
    vm.vehicleSortKey = $stateParams.vehicle_sort_key;
    vm.totalRoutedLoads = statisticsService.getTotalRoutedLoads();
    vm.setVehicleDriver = plannerService.setVehicleDriver;
    vm.updateVehicleDriver = updateVehicleDriver;
    vm.isVisitsOutOfRouteFilterVisible = isVisitsOutOfRouteFilterVisible;
    vm.filterVisitsOutOfRoute = filterVisitsOutOfRoute;
    vm.planId = plannerService.getPlanId();
    vm.visitFilterHandler = visitFilterService.getHandlerState();
    vm.mustShowVisitWindows = mustShowVisitWindows;
    vm.displayWindows = displayWindows;
    vm.toggleOptionsMenu = toggleOptionsMenu;
    vm.goToDeleteRoute = goToDeleteRoute;
    vm.goToVisitList = goToVisitList;
    vm.hasMultipleRoute = hasMultipleRoute;
    vm.isMultiDriverVehicle = isMultiDriverVehicle;
    vm.expandVisit = expandVisit;
    vm.getDriverFullName = getDriverFullName;
    vm.getPreviousVisit = routesUtils.getPreviousVisit;
    vm.getNextVisit = routesUtils.getNextVisit;
    vm.VISIT_TYPE = VISIT_TYPE;
    vm.skipTimeValidation = false;
    vm.isMixLoadAddonEnabled = isMixLoadAddonEnabled;


    /////////////////////////////////////////////////////////////
    // Search Visit And Vehicle
    ////////////////////////////////////////////////////////////

    var callbackToGetVehicles = function () {
      return vm.vehicles;
    };

    vm.searchData = routeDesignFilterService.getSearchDataBinding(
      callbackToGetVehicles, plannerService.visits
    );
    vm.filterHandler = routeDesignFilterService.filterStatusHandler;
    vm.filters = routeDesignFilterService.filters;

    vm.onClick = function (result) {
      var route;
      routeDesignFilterService.applyResultToVM(vm, result);
      if(result.type === "vehicles"){
        return;
      }
      if(!vm.filterHandler.visitsOffRoute){
        var vehicleSorted = $filter('orderBy')(vm.vehicles, vm.vehicleSort, vm.vehicleSortDesc);
        route = null;
        for(var i = 0; i < vehicleSorted.length; i++){
          route = vehicleSorted[i].routes.find(function(route){
            return vm.filterHandler.routes[route.id];
          });
          if(route){
            break;
          }
        }
        route.collapse = true;
        vm.visitsOutOfRouteActions.collapse = true;
        vm.toggleCollapseRoute(route);
      } else {
        route = vm.visitsOutOfRouteActions;
        vm.collapseOrExpandVisitsOutOfRoute(false);
      }
      routeDesignFilterService.moveToFirstResult(route);
    };

    vm.onRemove = function () {
      routeDesignFilterService.removeResultFromVM(vm);
    };

    vm.onMouseHoverVisit = function (visit, activeFilter, isCurrentVisitFilter) {
      routesUtils.onMouseHoverVisit(
        visit, activeFilter, isCurrentVisitFilter,
        routeDesignFilterService.setHoverActiveAnotherVisit
      );
    };

    vm.onMouseLeaveVisit = function (visit, activeFilter) {
      routesUtils.onMouseLeaveVisit(
        visit, activeFilter,
        routeDesignFilterService.setHoverActiveAnotherVisit
      );
    };

    /////////////////////////////////////////////////////////////
    // Watchers & Listeners
    ////////////////////////////////////////////////////////////

    $scope.$on('$destroy', function () {
      if (!$state.includes("*.routes-detail")) {
        vm.visitFilterHandler.clear();
        if (vm.routes) {
          plannerService.clearMapRoutes();
        }
      }
      vm.filterHandler.clear();
      clickOnRoute();
    });

    var clickOnRoute = $rootScope.$on("Planner:Routes:toggleCollapseRoute:clickOnRoute", function (args, data) {
      var route = vm.routes.find(function (route) {
        return route.id === data.route_id;
      });

      if (route) {
        toggleCollapseRoute(route);
        var vehicleElement = document.getElementById("vehicle-list-item-" + data.vehicle_id);
        routesUtils.scrollToElement(vehicleElement);
        $scope.$apply();
      }
    });

    $scope.$on("Planner:Route:toggleCollapseRoute", function (args, data) {
      var route = data.route;
      toggleCollapseRoute(route);
      if (!$scope.$$phase) {
        $scope.$apply();
      }
    });

    $scope.$on("Planner:Routes:updateOptimizationResult", function (args, data) {
      var optimizationElements = _getElementsForOptimization(plannerService.getVehicles(), plannerService.getVisits());
      plannerService.clearMapVisitsAndRoutes();
      plannerService.hideVehicles();
      $rootScope.isLoading = true;
      optimizeService.retrieveOptimizationResults(data.optimization_id)
        .then(function (response) {
          return colorAssignerService.assignVehiclesColor(response.data.vehicles)
            .finally(function () {
              successOptimizePlan(response, optimizationElements);
            });
        })
        .catch(errorOptimizePlan)
        .finally(finallyOptimizePlan);
    });

    function isSkipTimeValidationEnabled() {
      return addonsService.isAddonPropertyEnabled(PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES.SKIP_TIME_VALIDATION, function (addonProperty) {
        return addonProperty.value.toLowerCase() === "true";
      }).then(function (isAddonPropertyEnabled) {
        return isAddonPropertyEnabled;
      });
    }

    activate();

    /////////////////////////////////////////////////////////////
    // Public methods
    ////////////////////////////////////////////////////////////

    function activate() {
      $scope.$emit('Planner:clearListenerHandDrawing');
      sessionService.getUser()
        .then(function (user) {
          vm.isRouterJr = user.is_router_jr;
          _checkoutJdhEnableConfig(user.account.configs);
        });

      vm.jdh = $stateParams.jdh;
      vm.optimize = $stateParams.optimize;
      vm.isDirectEditingModeEnabled = $stateParams.isEnhancedPlanEditModeEnabled;
      vm.planDate = null;
      vm.routes = null;
      vm.editMode = false;
      vm.visitsOutOfRoute = [];
      vm.visitsOutOfRouteFormattedLoads = {
        load: 0,
        load2: 0,
        load3: 0,
        load4: 0
      };
      vm.selectAllVisitsOutOfRoute = false;
      vm.allVehicles = [];
      vm.moveToOptions = [];
      vm.customRouteNameConfig = accountConfigsService.getValueByKeyFrom(
        'custom_route_name' ,
        store.get('accountConfigs')
      );
      vm.isMultidayRouteEnabled = accountConfigsService.getValueByKeyFrom(
        'enable_multi_day_routes' ,
        store.get('accountConfigs')
      );
      vm.highlightVisitByWeight = accountConfigsService.getValueNumericByKeyFrom(
        'highlight_visit_by_weight' ,
        store.get('accountConfigs')
      );
      vm.highlightVisitByWeight2 = accountConfigsService.getValueNumericByKeyFrom(
        'highlight_visit_by_weight_2' ,
        store.get('accountConfigs')
      );
      vm.highlightVisitByWeight3 = accountConfigsService.getValueNumericByKeyFrom(
        'highlight_visit_by_weight_3' ,
        store.get('accountConfigs')
      );
      vm.splitByPriority = accountConfigsService.getValueByKeyFrom(
        'similars_by_priority' ,
        store.get('accountConfigs')
      );
      vm.incrementalRouting = accountConfigsService.getValueByKeyFrom(
        'incremental_routing' ,
        store.get('accountConfigs')
      );
      vm.enablePickupAndDeliveryMode = accountConfigsService.isConfigEnabled(ENABLE_PICKUP_AND_DELIVERY_MODE);
      vm.isVisitsOutOfRouteFilterEnabled = accountConfigsService.isConfigEnabled(
        ACCOUNT_CONFIGS.ENABLE_VISITS_OUT_OF_ROUTE_FILTER
      );
      vm.isLoadBalanceEnabled = accountConfigsService.isConfigEnabled(
        ACCOUNT_CONFIGS.ENABLE_LOAD_BALANCE
      );
      vm.isTimeBalanceEnabled = accountConfigsService.isConfigEnabled(
        ACCOUNT_CONFIGS.ENABLE_TIME_BALANCE
      );
      vm.enableOrderByVisibility = accountConfigsService.isConfigEnabled('enable_order_by_visibility');
      vm.isClientsModuleEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_CLIENTS_MODULE);
      vm.isMultiResultsEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.MULTI_RESULTS);
      vm.isMultiDriversConfigEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_MULTI_DRIVERS);

      routesUtils.setHighlightConfigurations(vm.highlightVisitByWeight, vm.highlightVisitByWeight2, vm.highlightVisitByWeight3);

      vm.enableNotesInRouteDesigner = isEnableNotesInRouteDesigner();

      addonsService.isAddonEnable(SELLER_MANAGEMENT_ADD_ON_KEY)
        .then(function (isEnabled) {
          vm.isSellerManagementEnabled = isEnabled;
        });

      $rootScope.isLoading = true;
      plannerService.disableStep.vehicleDisabled = false;
      vm.divideByVisibilityOptions = vm.enableOrderByVisibility ? [true, false] : [true];
      vm.drivers = plannerService.getDrivers();
      plannerService.clearMapVisits();

      return plannerService.getPlan()
        .then(function (plan) {
          return isSkipTimeValidationEnabled().then(function (isSkipTimeValidationEnabled) {
            vm.skipTimeValidation = isSkipTimeValidationEnabled;
            return plan;
          });
        })
        .then(successGetPlan)
        .catch(function () {
          $rootScope.isLoading = false;
        });

      function successGetPlan(plan) {
        if (plannerService.getVisits() === 0 && plan.routes.length === 0) {
          $state.go('planner.visits-list');
          return;
        }
        var visits = plannerService.getVisits();

        // Update Zones on Map by plan
        $scope.$emit("planner:drawZonesOnMap");

        if(vm.planId === null){
          vm.planId = utilsService.guid();
          plannerService.setPlanId(vm.planId);
        }

        // Do only after retrieve user optimization options
        vm.optimizationOptions = plannerService.localOptimizationOptions;
        plannerService.hideVehicles();
        plannerService.hideInfoWindow();

        if (vm.optimizationOptions.join || vm.optimizationOptions.join_v2) {
          plannerService.totalArrivalsCache = {};
          plannerService.visitSimilarGraph = new visitSimilarService.VisitSimilarGraph({
            splitByPriority: vm.splitByPriority
          });
          visits.forEach(plannerService.visitSimilarGraph.set);
        }

        vm.planName = plannerService.getPlanName();
        if (angular.isDefined($stateParams.optimize)) {
          if (parseInt($stateParams.optimize) === 1) {
            if (visits.length > 0 && plannerService.vehicles.length > 0) {
              statisticsService.saveHistory();
              optimizePlan();
            }
          } else if (parseInt($stateParams.optimize) === 2) {
            statisticsService.saveHistory();
            reoptimizePlan();
          } else if (parseInt($stateParams.optimize) === 3) {
            if (visits.length > 0 && plannerService.vehicles.length > 0) {
              statisticsService.saveHistory();
              partialOptimization();
            }
          } else {
            getPlanUnoptimized();
          }
        } else {
          getPlanUnoptimized();
        }
        if (plannerService.vehicles.length > 0) {
          vm.allVehicles = plannerService.vehicles;
        }

        vm.routes = plannerService.routes;
        vm.planDate = moment(plan.planDate.start).format('DD MMMM, YYYY');
        vm.shift = plan.shift;
        angular.copy(plannerService.getCodrivers(), vm.codrivers);
        vm.updateStepsPlanner(plan);
      }
    }

    function getDriverFullName(driverId) {
      return routesUtils.getDriverFullName(driverId, vm.drivers);
  }

    function updateStepsPlanner(plan) {
      $scope.$emit("Planner:Plan:info", {
        planDate: plan.planDate.start,
        planName: vm.planName
      });
      $scope.$emit("Planner:Plan:steps", {key: 'vehicle', value: true});
      $scope.$emit("Planner:Plan:steps", {key: 'visit', value: true});
      $scope.$emit("Planner:Plan:steps", {key: 'route', value: true});
    }

    function optimizePlan() {
      var planDate = plannerService.getPlanDate();
      var diff = 0;
      try {
        diff = vm.calculateTimeDiff(planDate.start, planDate.end);
      } catch (e) {
        $log.error(e.message);
      }
      var optimizationOptions = plannerService.getOptimizationOptions();

      var params = {
        optimizationOptions: optimizationOptions,
        isJDH: _isJDHActive(),
        planName: plannerService.getPlanName(),
        planEditingSelected: plannerService.getPlanEditingSelected(),
        isBigVrp: optimizationOptions.big_vrp,
        use_euclidean_distance: optimizationOptions.use_euclidean_distance,
        enable_graphs: optimizationOptions.enable_graphs,
        auto_reorder: optimizationOptions.auto_reorder,
        planInHours: diff,
        planDate: planDate || 0,
        longRoutes: $scope.isMultiDayRouteEnabled || vm.skipTimeValidation,
        one_vehicle_zone: optimizationOptions.one_vehicle_zone,
        load_balance: vm.isLoadBalanceEnabled,
        time_balance: vm.isTimeBalanceEnabled,
        isVehicularRestrictionEnabled: plannerService.isVehicularRestrictionEnabled()
      };

      var waveRoutingData = plannerService.getWaveRoutingData();
      if (waveRoutingData) {
        params.cutoffTime = waveRoutingData.cutoffTime;
        params.lastWave = waveRoutingData.lastWave;
        params.plan_id = vm.planId;
        params.previous_optimization_id = plannerService.getLastOptimizationId();

      }

      vm.optimizationOptions.longRoutes = $scope.isMultiDayRouteEnabled;
      var zonesFilter = {
        schedules: plannerService.getScheduledPlanDaysOfWeek(),
        enabled: true
      };

      zoneService.getZonesIfProceed(zonesFilter)
        .then(function (zones) {
          zoneService.isAutoZonesEnabled().then(function (response) {
            params.optimizationOptions.autoZone = zones.length ?
              response.isAutoZoneEnabled : false;

            optimize(zones, params);
          });
        });
    }

    function _getElementsForPartialOptimization(vehicles, visits) {
      /*
      In partial optimization, revised routes must remain intact. Therefore, only routes that are not revised are added
      to the request.
      */
      var unchangeableRoutes = [];
      var changeableRoutes = [];
      var changeableVisits = [];

      vehicles.forEach(function(vehicle) {
        vehicle.routes.forEach(function(route) {
          if (route.isRevised) {
            unchangeableRoutes.push(route);
          } else {
            changeableRoutes.push(route);
            Array.prototype.push.apply(changeableVisits, route.visits);
          }
        });
      });

      var unassignedVisits = plannerService.getVisitsOutOfRoute(visits);
      Array.prototype.push.apply(changeableVisits, unassignedVisits);

      return {
        unchangeableRoutes: unchangeableRoutes,
        changeableVehicles: vehicles,
        changeableRoutes: changeableRoutes,
        changeableVisits: changeableVisits
      };
    }

    function partialOptimization() {
      var zonesFilter = {
        schedules: plannerService.getScheduledPlanDaysOfWeek(),
        enabled: true
      };

      var optimizationElements = _getElementsForPartialOptimization(plannerService.getVehicles(), plannerService.getVisits());
      var planDate = plannerService.getPlanDate();
      var baseOptimizationOptions = plannerService.getOptimizationOptions();
      var planParams = {
        isJDH: _isJDHActive(),
        planInHours: vm.calculateTimeDiff(planDate.start, planDate.end),
        planDate: planDate || 0,
        longRoutes: $scope.isMultiDayRouteEnabled,
        incrementalRouting: !vm.isTimeBalanceEnabled,
        reorderRoute: false,
        isVehicularRestrictionEnabled: plannerService.isVehicularRestrictionEnabled(),
        isOneSellerPerVehicleEnabled: baseOptimizationOptions.one_seller_per_vehicle
      };

        if (vm.isMultiResultsEnabled) {
          plannerService.setOptimizationResults([]);
        }

      $q.all([
        zoneService.getZonesIfProceed(zonesFilter),
        zoneService.isAutoZonesEnabled()
      ])
      .then(function (result) {
        return {
          autoZone: result[0].length ? result[1].isAutoZoneEnabled : false,
          zones: result[0]
        };
      })
      .then(function (zoneResult) {
        var activeVehicles = optimizationElements.changeableVehicles.filter(function (vehicle) {
          return vehicle.active;
        });

        var optimizationOptions = Object.assign(
          {},
          baseOptimizationOptions,
          {
            autoZone: zoneResult.autoZone || baseOptimizationOptions.one_seller_per_vehicle,
            country: store.get("country"),
            longRoutes: $scope.isMultiDayRouteEnabled,
            load_balance: vm.isLoadBalanceEnabled,
            time_balance: vm.isTimeBalanceEnabled
          }
        );

        var waveRoutingData = plannerService.getWaveRoutingData();
        if (waveRoutingData) {
          planParams.cutoffTime = waveRoutingData.cutoffTime;
          planParams.lastWave = waveRoutingData.lastWave;
          planParams.plan_id = vm.planId;
          planParams.previous_optimization_id = plannerService.getLastOptimizationId();
        }

        return routesOptimizationService.optimizePlan(
          activeVehicles,
          optimizationElements.changeableVisits,
          zoneResult.zones,
          optimizationOptions,
          planParams
        );
      })
      .then(function (response) {
        return colorAssignerService.assignVehiclesColor(response.data.vehicles)
          .finally(function () {
            successOptimizePlan(response, optimizationElements, planParams);
        });
      })
      .catch(errorOptimizePlan)
      .finally(finallyOptimizePlan);
    }

    function _getElementsForOptimization(vehicles, visits) {
      /*
      In optimization, vehicles with at least one revised route must not suffer any changes. Therefore, only vehicles
      with unrevised routes are added to the request.
      */
      var unchangeableRoutes = [];
      var changeableVehicles = [];
      var changeableRoutes = [];
      var changeableVisits = [];
      var visitIdsPositiveSelected = visits.map(function (visit) {
        return visit.id;
      });

      vehicles.forEach(function(vehicle) {
        if (vehicle.isAnyRouteRevised()) {
          Array.prototype.push.apply(unchangeableRoutes, vehicle.routes);
        } else {
          changeableVehicles.push(vehicle);
          Array.prototype.push.apply(changeableRoutes, vehicle.routes);

          vehicle.routes.forEach(function(route) {
            Array.prototype.push.apply(changeableVisits, route.visits.filter(function (visit) {
              return visitIdsPositiveSelected.includes(visit.id);
            }));
          });
        }
      });

      var unassignedVisits = plannerService.getVisitsOutOfRoute(visits);
      Array.prototype.push.apply(changeableVisits, unassignedVisits);

      return {
        unchangeableRoutes: unchangeableRoutes,
        changeableVehicles: changeableVehicles,
        changeableRoutes: changeableRoutes,
        changeableVisits: changeableVisits
      };
    }

    function getOptimizationFunction(optimizationOptions) {
      var mustCallPickupAndDeliveryOptimization = vm.enablePickupAndDeliveryMode &&
        plannerService.isTherePickupAndDelivery();

      if (vm.isMultiResultsEnabled && !optimizationOptions.wave_routing && !mustCallPickupAndDeliveryOptimization) {
        return optimizeService.optimizeMultiResultsPlan;
      }

      return !mustCallPickupAndDeliveryOptimization ?
        optimizeService.optimizePlan : optimizeService.optimizePickupAndDeliveryPlan;
    }

    function optimize(zones, params) {
      var optimizeFunction = getOptimizationFunction(params.optimizationOptions);
      var optimizationElements = _getElementsForOptimization(plannerService.getVehicles(), plannerService.getVisits());
      params.optimizationOptions.country = store.get('country');

      optimizeFunction(
        optimizationElements.changeableVehicles,
        optimizationElements.changeableVisits,
        zones,
        params
      )
        .then(function (response) {
          return colorAssignerService.assignVehiclesColor(response.data.vehicles)
            .finally(function () {
              successOptimizePlan(response, optimizationElements);
            });
        })
        .catch(errorOptimizePlan)
        .finally(finallyOptimizePlan);
    }

    function successOptimizePlan(response, optimizationElements, planParams) {
      var responseData = response.data;
      if (responseData.id) {
        plannerService.addOptimizationId(responseData.id);
        plannerService.setCurrentOptimizationId(responseData.id);
      }

      vm.createRoutesAfterOptimize(
        responseData,
        optimizationElements.changeableVehicles,
        optimizationElements.changeableRoutes,
        optimizationElements.unchangeableRoutes,
        optimizationElements.changeableVisits,
        planParams
      );

      _recalculateAllRoutes()
        .then(function () {
          setUserVisualStates();
          setAllVehiclesToSeeRoutesInDetail();
          if (!vm.isDirectEditingModeEnabled) {
            createMapElements();
          }
        })
        .finally(function () {
          // Wait until initial data is set to indexedDB
          plannerService.setOriginalPlanAndSaveDraftPlanFormat()
            .finally(function () {
              if (vm.isDirectEditingModeEnabled && plannerService.isPlanEditable()) {
                vm.goToRoutesDetail();
              } else {
                $rootScope.isLoading = false;
              }
            });
        });

      _fillMoveToSelect(vm.vehicles);

      vm.visitsOutOfRoute = plannerService.getVisitsOutOfRoute(plannerService.getVisits());
      vm.visitsOutOfRoute = plannerService.setVisitsOutOfRouteAttributes(vm.visitsOutOfRoute);

      vm.visitsOutOfRouteFormattedLoads = statisticsService.calculateVisitsTotalLoads(vm.visitsOutOfRoute, Boolean(
        vm.optimizationOptions.big_cluster));

      plannerService.mapFitBoundAllVisits();

      function _recalculateAllRoutes() {
        vm.vehicles = plannerService.vehicles.filter(function (vehicle) {
          return vehicle.routes.length;
        });
        var promises = _getRecalculateAllRoutesPromises(vm.vehicles, true);
        var deferred = $q.defer();

        $q.all(promises)
          .finally(function () {
            deferred.resolve();
          });

        return deferred.promise;
      }
    }

    function errorOptimizePlan(error) {
      $log.error('Error optimizePlan', error);
      $rootScope.isLoading = false;
      Toasts.push('error', $translate('Planner_toast.error_optimize_500'));

      if (vm.isMultiResultsEnabled) {
        plannerService.setOptimizationResults([]);
      }

      var response = {
        data: {
          vehicles: []
        }
      };

      var optimizationElements = _getElementsForOptimization(plannerService.getVehicles(), plannerService.getVisits());
      successOptimizePlan(response, optimizationElements);
    }

    function finallyOptimizePlan() {
      routesUtils.updateSelectedDrivers(vm.vehicles, vm.drivers);
      vm.updatePlannerIndicators();
    }

    function createRoutesAfterOptimize(data, vehicles, changeableRoutes, unchangeableRoutes, visits, planParams) {
      var optimizationOptions = plannerService.getOptimizationOptions();
      var planDate = plannerService.getPlanDate();
      var planInHours = 0;

      try {
        planInHours = vm.calculateTimeDiff(planDate.start, planDate.end);
      } catch (e) {
        $log.error(e.message);
      }

      var params = {
        optimizationOptions: optimizationOptions,
        isJDH: _isJDHActive(),
        planName: plannerService.getPlanName(),
        planEditingSelected: plannerService.getPlanEditingSelected(),
        isBigVrp: optimizationOptions.big_vrp,
        use_euclidean_distance: optimizationOptions.use_euclidean_distance,
        enable_graphs: optimizationOptions.enable_graphs,
        auto_reorder: optimizationOptions.auto_reorder,
        planInHours: (planParams && planParams.planInHours) || planInHours,
        planDate: (planParams && planParams.planDate) || planDate,
        longRoutes: $scope.isMultiDayRouteEnabled,
        one_vehicle_zone: optimizationOptions.one_vehicle_zone,
        load_balance: vm.isLoadBalanceEnabled,
        time_balance: vm.isTimeBalanceEnabled,
        incrementalRouting: Boolean(planParams) && planParams.incrementalRouting
      };

      var nodesMap = optimizeService.getVisitsRequestData(visits, params, false, []);
      var originalRoutes = JSON.parse(JSON.stringify(changeableRoutes));

      // Remove every changeable route
      vehicles.forEach(function (vehicle) {
        vehicle.color = null;
        vehicle.removeUnrevisedRoutes();
      });
      plannerService.routes.length = 0;
      Array.prototype.push.apply(plannerService.routes, unchangeableRoutes);

      data.vehicles.forEach(function (vehicleOpt) {
        var vehicle = vehicles.find(function (vehicleInFind) {
          return vehicleInFind.id === vehicleOpt.ident;
        });

        vehicle.setColor(colorAssignerService.getVehicleColor(vehicle.id));

        // Iterate through each route of the vehicle
        vehicleOpt.tours.forEach(function (tour) {
          var route = plannerService.createRoute(vehicle.id);
          route.actionCreate(route);

          // Remove first node representing origin depot & last node representing destination depot
          route.estimatedTimeStart = tour.nodes.shift().arrival;
          route.estimatedTimeEnd = tour.nodes.pop().arrival;
          route.routeDistance = tour.route_distance || null;

          // Iterate through each visit of the route
          var restTimeNode = null;
          tour.nodes.forEach(function (node) {
            if (node.ident === REST_TIME) {
              restTimeNode = plannerService.parseOptimizationRestTimeNode(node, vehicle);
              return;
            }

            var visit = null;
            var nodeVisit = nodesMap.find(function (nodeTmp) {
              return nodeTmp.ident === node.ident || nodeTmp.group.includes(node.ident);
            });

            // Iterate through similar visits
            nodeVisit.group.forEach(function (visitId) {
              visit = visits.find(function (visitPlan) {
                return visitPlan.id === visitId;
              });

              visit.setDefaultColor(vehicle.color);
              visit.estimatedTimeArrival = node.arrival;
              visit.estimatedTimeDeparture = node.departure;
              visit.stopId = node.stop_id;
              route.addVisit(visit, false, false);
            });

          });

          var originalRoute;
          for (var i = 0; i < originalRoutes.length; i++) {
            if (originalRoutes[i].vehicleId === route.vehicleId) {
              originalRoute = originalRoutes[i];
              originalRoutes.splice(i, 1);
              break;
            }
          }

          if (originalRoute) {
            route.id = originalRoute.id || route.id;
            route.backendId = originalRoute.backendId || route.backendId;
            route.codrivers = originalRoute.codrivers || route.codrivers || [];

            route.visits.forEach(function (visit) {
              visit.routeId = route.id;
            });
          }

          vehicle.addRoute(route);

          if (restTimeNode) {
            plannerService.setRestTimeByRouteId(route.id, restTimeNode);
          } else {
            plannerService.clearRestTimes(route.id);
          }
        });
      });

      if (originalRoutes.length) {
        originalRoutes.forEach(function (route) {
          plannerService.routeMarkAsRemoved(route);
        });
      }
    }

    function setAllVehiclesToSeeRoutesInDetail() {
      vm.vehiclesToSeeRoutesInDetail = plannerService.getUserVisualState();

      vm.vehicles.forEach(function (vehicle) {
        if (angular.isDefined(vm.vehiclesToSeeRoutesInDetail[parseInt(vehicle.id)])) {
          vehicle.showRoutes = vm.vehiclesToSeeRoutesInDetail[parseInt(vehicle.id)];
        } else {
          vehicle.showRoutes = true;
          vm.vehiclesToSeeRoutesInDetail[parseInt(vehicle.id)] = true;
        }
      });

      if (vm.vehiclesToSeeRoutesInDetail.hasOwnProperty(VISIT_OUT_OF_ROUTE_VISUAL_STATE_ID)) {
        vm.showVisitsOutOfRoutes = vm.vehiclesToSeeRoutesInDetail[VISIT_OUT_OF_ROUTE_VISUAL_STATE_ID];
      } else {
        vm.vehiclesToSeeRoutesInDetail[VISIT_OUT_OF_ROUTE_VISUAL_STATE_ID] = vm.showVisitsOutOfRoutes;
      }
    }

    function updatePlannerIndicators() {
      $scope.$emit("Planner:Plan:recalculate-statistics");
    }

    function _getRecalculateAllRoutesPromises(vehicles, isAfterOptimization) {
      var recalculateAllRoutesPromises = [];

      vehicles.forEach(function (vehicle) {
        vehicle.routes.forEach(function (route) {
          route.setHasManualChanges(false);
          route.visits.forEach(function (visit) {
            visit.setDefaultColor(vehicle.color);
          });
        });

        if (!vm.isDirectEditingModeEnabled) {
          vehicle.setIconFillColorWithVehicleColor();
        }
        if (!$stateParams.comingFromEditMode || isAfterOptimization) {
          recalculateAllRoutesPromises.push(vehicle.recalculateAllRoutes(vm.optimizationOptions, plannerService));
        }
      });

      return recalculateAllRoutesPromises;
    }

    function getPlanUnoptimized() {
      vm.vehicles = plannerService.vehicles.filter(function (vehicle) {
        return vehicle.routes.length;
      });
      var vehiclePromises = _getRecalculateAllRoutesPromises(vm.vehicles);

      $q.all(vehiclePromises)
        .finally(function() {

          if ($stateParams.isOpeningPlanToEdit) {
            // Wait until initial data is set to indexedDB
            plannerService.setOriginalPlanAndSaveDraftPlanFormat()
              .finally(function () {
                $rootScope.isLoading = false;

                if (vm.isDirectEditingModeEnabled && plannerService.isPlanEditable()) {
                  vm.goToRoutesDetail();
                }
              });
          } else if (vm.isDirectEditingModeEnabled && plannerService.isPlanEditable()) {
            vm.goToRoutesDetail();
          }
        });

      _fillMoveToSelect(vm.vehicles);

      if ($stateParams.positiveSelectedVisits) {
        plannerService.getVisits().forEach(function(visit) {
          plannerService.visitsForRouting.push(visit.id);
        });
      }

      vm.visitsOutOfRoute = plannerService.getVisitsOutOfRoute(plannerService.getVisits());
      vm.visitsOutOfRoute = plannerService.setVisitsOutOfRouteAttributes(vm.visitsOutOfRoute);

      vm.visitsOutOfRouteFormattedLoads = statisticsService.calculateVisitsTotalLoads(vm.visitsOutOfRoute,
        Boolean(vm.optimizationOptions.big_cluster));

      routesUtils.updateSelectedDrivers(vm.vehicles, vm.drivers);
      vm.updatePlannerIndicators();
      setAllVehiclesToSeeRoutesInDetail();
      createMapElements();
      vm.visibleAllRoutes = routesUtils.toggleVisibleAllRoutesHandler(vm.vehicles);
      $scope.$emit("Planner:Plan-editing", {value: plannerService.getPlanName()});

      if (!$stateParams.isOpeningPlanToEdit) {
        $rootScope.isLoading = parseInt(vm.optimize) === 2;
      }

      if (!$stateParams.comingFromEditMode) {
        plannerService.mapFitBoundAllVisits();
      }
    }

    function createMapElements() {
      if (vm.isDirectEditingModeEnabled) {
        return;
      }
      var areVisible;
      var visitsWithVisibleVehicle = [];

      vm.vehicles.forEach(function (vehicle) {
        areVisible = vm.vehiclesToSeeRoutesInDetail[parseInt(vehicle.id)];
        vehicle.setOpacity(ROUTE_VISIBLE_OPACITY, false);
        vehicle.setVisible(areVisible, areVisible && vm.optimizationOptions.open_ended);

        if (areVisible && vehicle.routes.length !== 0) {
          vehicle.routes.forEach(function (route) {
            _createRouteVector(route);
            visitsWithVisibleVehicle = visitsWithVisibleVehicle.concat(route.visits);
          });
        }

      });

      createOrUpdateVisitsMarkersLight(visitsWithVisibleVehicle);
    }

    function _createRouteVector(route) {
      route.actionCreate(route);

      var mustUpdateRouteOpacity = (route.stroke.opacity !== ROUTE_VISIBLE_OPACITY);
      if (mustUpdateRouteOpacity) {
        route.setOpacity(ROUTE_VISIBLE_OPACITY, false);
      }
      var mustUpdateRouteVisible = !route.visible;
      if (mustUpdateRouteVisible) {
        route.setVisible(true, false);
      }

      if (mustUpdateRouteOpacity || mustUpdateRouteVisible) {
        route.actionUpdate(route);
      }
    }

    function expandVisit(visit, route) {
      var initialTabs = [{
        id: 'information',
        name: $translate('Expand_modal.tabs.information'),
        active: true
      }];

      var modalInstance = ExpandModalService.open({
        template: 'app/planner/routes/expand-modal.html',
        scope: {
          vm: {
            visit: visit,
            route: route,
            vehicles: vm.vehicles,
            routeCodes: vm.routeCodes,
            routeIndex: vm.routeIndex,
            activeTab: 'information',
            tabs: initialTabs,
            isSellerManagementEnabled: vm.isSellerManagementEnabled,
            isMixLoadAddonEnabled: vm.isMixLoadAddonEnabled,
            close: function() {
              modalInstance.close();
            },
            switchTab: function(tabId) {
                this.activeTab = tabId;
                this.tabs.forEach(function(tab) {
                    tab.active = tab.id === tabId;
                });
            },
            isTabActive: function(tabId) {
                return this.activeTab === tabId;
            },
            getFilteredItems: function() {
              if (!this.visit.items || !this.visit.items.length) {
                return [];
              }
              return this.route.id === 0 ?
                this.visit.items.filter(function(item) {
                  return item.parentId === 1;
                }) :
                this.visit.items;
            }
          }
        }
      });

      if (visit.items && visit.items.length > 0 && __env.VISUALIZE_VISIT_ITEMS) {
        modalInstance.scope.vm.tabs.push({
          id: 'items',
          name: $translate('Expand_modal.tabs.items'),
          active: false,
          count: visit.items.length
        });
      }

      // Helper function to check if visit is completed
      function isCompletedVisit(visitId) {
        return visitId && visitId.indexOf('-') === -1; // If ID doesn't contain hyphens, it's a completed visit
      }

      // First check if accounting addon is enabled
      addonsService.isAddonEnable("accounting")
        .then(function(enabled) {
          if (enabled && isCompletedVisit(visit.id)) {
            // Only fetch invoices if visit is completed
            modalInstance.scope.vm.isLoadingInvoices = true; // Show loading state
            return accountingService.getInvoicesByVisit(visit.id)
              .then(function(invoices) {
                if (invoices && invoices.length > 0) {
                  // Set the invoices in the modal scope
                  modalInstance.scope.vm.invoices = invoices;

                  modalInstance.scope.vm.tabs.push({
                    id: 'document',
                    name: $translate('Expand_modal.document.title'),
                    active: false
                  });
                }
              })
              .finally(function() {
                modalInstance.scope.vm.isLoadingInvoices = false; // Hide loading state
              });
          }
        })
        .catch(function(error) {
          $log.error("Error checking accounting addon:", error);
          modalInstance.scope.vm.isLoadingInvoices = false; // Hide loading state on error
        });
    }

    function toggleShowRoutes(vehicle) {
      vehicle.showRoutes = !vehicle.showRoutes;
      if (vm.optimizationOptions.big_cluster) {
        vehicle.showAllRoutes(vehicle.showRoutes, false, vm.optimizationOptions);
      } else {
        vehicle.showAllRoutes(vehicle.showRoutes, true, vm.optimizationOptions);
      }
      vm.visibleAllRoutes = routesUtils.toggleVisibleAllRoutesHandler(vm.vehicles);
      updateVehiclesToSeeRoutesInDetail(vehicle.showRoutes, vehicle.id);
    }

    function toggleCollapseRoute(route) {
      var vehicle = plannerService.getVehicleById(route.vehicleId);

      var mustCollapseRoute = !route.collapse;
      route.collapse = mustCollapseRoute;
      route.setVisitsListed(!mustCollapseRoute);

      if (!$rootScope.drawCluster) {
        plannerService.clearMapVisitsAndRoutes();
        //Colapsamos las demas rutas que esten !collapsed
        if (!route.collapse) {
          plannerService.collapseOtherRoutes(route, vm.optimizationOptions.open_ended);

          route.setVisible(true, false);
          route.actionCreate(route);
          route.createVisitsMarkers();
          route.visits.forEach(function (visit) {
            visit.setVisible(route.visible);
          });
          vehicle.setVisible(route.visible, vm.optimizationOptions.open_ended);
        } else {
          plannerService.createRoutesPolyline();
          createOrUpdateVisitsMarkersLight();
          showVehicles();
        }
      } else {
        var isOpenEnded = vm.optimizationOptions.open_ended;

        var mustCollapseLastRoute = !mustCollapseRoute && vm.lastExpandedRoute && !vm.lastExpandedRoute.collapse;
        if (mustCollapseLastRoute) {
          var lastExpandedRouteVehicle = (route.vehicleId === vm.lastExpandedRoute.vehicleId) ? vehicle :
            plannerService.getVehicleById(vm.lastExpandedRoute.vehicleId);

          _collapseRoute(vm.lastExpandedRoute, lastExpandedRouteVehicle, isOpenEnded);
        }

        if (route.visible) {
          var areMarkersVisible = !mustCollapseRoute;
          var mustUpdateMarkers = false;
          visitsMarkersService.setVisibleInVisits(route.visits, areMarkersVisible, mustUpdateMarkers);

          if (areMarkersVisible) {
            var mustRenderSmallMarkers = false;
            createVisitsOnMap(route.visits, mustRenderSmallMarkers);
          } else {
            removeVisitsOnMap(route.visits);
          }

          route.setOpacity(ROUTE_VISIBLE_OPACITY);
          var opacity = mustCollapseRoute ? ROUTE_VISIBLE_OPACITY : ROUTE_TRANSLUCENT_POLYGON_OPACITY;
          plannerService.routes.forEach(function (routeToUpdate) {
            if (routeToUpdate.id !== route.id) {
              routeToUpdate.setOpacity(opacity);
            }
          });

          if (!mustCollapseRoute) {
            var areDepotsVisible = false;
            plannerService.vehicles.forEach(function (vehicleToUpdate) {
              if (vehicleToUpdate.id !== vehicle.id) {
                vehicleToUpdate.setVisible(areDepotsVisible, isOpenEnded);
              }
            });
          }
        }
      }

      if (mustCollapseRoute) {
        vm.lastExpandedRoute = null;
      } else {
        vm.lastExpandedRoute = route;
        vm.filterHandler.activeFilter && routeDesignFilterService.moveToFirstResult(route);
      }
    }

    function _collapseRoute(route, vehicle, isRouteOpenEnded) {
      route.collapse = true;
      route.setVisitsListed(false);

      var areMarkersVisible = false;
      vehicle.setVisible(areMarkersVisible, isRouteOpenEnded);

      var mustUpdateMarkers = false;
      visitsMarkersService.setVisibleInVisits(route.visits, areMarkersVisible, mustUpdateMarkers);
      removeVisitsOnMap(route.visits);
    }

    function updateVehiclesToSeeRoutesInDetail(value, id) {
      vm.vehiclesToSeeRoutesInDetail[id] = value;
    }

    function showVehicles() {
      vm.vehicles.forEach(function (vehicle) {
        if (vm.vehiclesToSeeRoutesInDetail[parseInt(vehicle.id)]) {
          vehicle.options.visible = vehicle.showRoutes;
        }
        vehicle.setVisible(vehicle.options.visible, vm.optimizationOptions.open_ended);
      });
    }

    function exportPlanTxt() {
      plannerService.exportPlanTxt();
    }

    function exportPlanExcel() {
      plannerService.exportPlanExcel();
      $log.info('Descargado reporte excel');
    }

    function exportPlanPdf() {
      plannerService.exportPlanPdf();
      $log.info('Descargado reporte pdf');
    }

    function exportSummarizedPlanPdf() {
      var date = plannerService.getPlanDate();
      plannerReportsService.exportSummarizedPlanPdf(vm.vehicles, date.start);
      $log.info('Descargado reporte pdf resumido');
    }

    function deployFinishModal() {
      var scope = $scope.$new();
      scope.isMultiDayRouteEnabled = $scope.isMultiDayRouteEnabled;
      ngDialog.open({
        template: 'app/planner/routes/finish-modal.html',
        controller: 'FinishPlanController',
        controllerAs: 'vm',
        scope: scope,
        showClose: false,
        closeByEscape: false,
        closeByDocument: false,
        className: 'ngdialog-theme-default custom-width-800 ngdialog-finish-plan'
      });
    }

    function toggleVisitsOutOfRoutes(ev) {
      vm.showVisitsOutOfRoutes = !vm.showVisitsOutOfRoutes;

      if (ev) {
        ev.stopPropagation();
      }

      updateVehiclesToSeeRoutesInDetail(vm.showVisitsOutOfRoutes, VISIT_OUT_OF_ROUTE_VISUAL_STATE_ID);

      var mustUpdateMarkers = false;
      visitsMarkersService.setVisibleInVisits(vm.visitsOutOfRouteActions.visits, vm.showVisitsOutOfRoutes,
        mustUpdateMarkers);

      if (vm.showVisitsOutOfRoutes) {
        var mustRenderSmallMarkers = vm.visitsOutOfRouteActions.collapse;
        createVisitsOnMap(vm.visitsOutOfRouteActions.visits, mustRenderSmallMarkers);
      } else {
        removeVisitsOnMap(vm.visitsOutOfRouteActions.visits);
      }
    }

    function createVisitsOnMap(visits, mustRenderSmallMarkers) {
      if (!visits.length) {
        return;
      }

      var eventUpdateMarkers = mustRenderSmallMarkers ? EVENT_CREATE_MARKERS_LIGHT_FROM_ARRAY :
          EVENT_CREATE_VISITS_FROM_ARRAY;
      $rootScope.$broadcast(eventUpdateMarkers, {visits: visits});
    }

    function removeVisitsOnMap(visits) {
      if (!visits.length) {
        return;
      }

      $rootScope.$broadcast(EVENT_REMOVE_VISITS_FROM_ARRAY, {visits: visits});
    }

    function getVehicleById(vehicleId) {
      return function (vehicle) {
        return vehicle.id === vehicleId;
      };
    }

    function toggleVisibleAllRoutes() {
      vm.visibleAllRoutes = !vm.visibleAllRoutes;

      vm.vehicles.forEach(function (vehicle) {
        vehicle.showRoutes = vm.visibleAllRoutes;
        if (vm.optimizationOptions.big_cluster) {
          vehicle.showAllRoutes(vm.visibleAllRoutes, false, vm.optimizationOptions);
        } else {
          vehicle.showAllRoutes(vm.visibleAllRoutes, vm.visibleAllRoutes, vm.optimizationOptions);
        }

        updateVehiclesToSeeRoutesInDetail(vm.visibleAllRoutes, vehicle.id);
      });

    }


    function fillVehiclesOptions(vehicle, fill) {
      if (fill) {
        vehicle.optionCircleFillColor = vehicle.color;
      } else {
        vehicle.optionCircleFillColor = 'none';
      }
    }

    function collapseOrExpandVisitsOutOfRoute(mustCollapseList) {
      vm.visitsOutOfRouteActions.collapse = mustCollapseList;
      vm.isVisitsOutOfRouteListExpanded = !vm.visitsOutOfRouteActions.collapse;

      if (!vm.optimizationOptions.big_cluster && !$rootScope.drawCluster) {
        showVisitsOutOfRouteMarkerPro();
      } else {
        var mustRenderSmallMarkers = vm.visitsOutOfRouteActions.collapse;
        updateVisitsMarkersSize(vm.visitsOutOfRouteActions.visits, vm.showVisitsOutOfRoutes, mustRenderSmallMarkers);
      }
    }

    function showVisitsOutOfRouteMarkerPro() {
      if (vm.visitsOutOfRouteActions.collapse) {
        plannerService.clearMapVisitsAndRoutes();
        plannerService.createRoutesPolyline();
        createOrUpdateVisitsMarkersLight();
        checkIfSetVisibleVehicles();
      } else {
        plannerService.hideVehicles();
        plannerService.clearMapVisitsAndRoutes();
        sendCollapseEvent(EVENT_CREATE_VISITS_FROM_ARRAY);
      }
    }

    function sendCollapseEvent(broadcastEvent) {
      if (!vm.showVisitsOutOfRoutes) {
        return;
      }
      var visits = vm.visitsOutOfRouteActions.visits;
      visitsMarkersService.setVisibleInVisits(
        visits,
        broadcastEvent === 'Planner:CreateVisitsFromArray:Visit',
        false
      );
      $rootScope.$broadcast(broadcastEvent, {
        visits: visits
      });
    }

    function updateVisitsMarkersSize(visits, areMarkersVisible, mustRenderSmallMarkers) {
      if (!visits.length || !areMarkersVisible) {
        return;
      }

      removeVisitsOnMap(visits);
      createVisitsOnMap(visits, mustRenderSmallMarkers);
    }


    function checkIfSetVisibleVehicles() {
      vm.vehicles.forEach(function (vehicle) {
        vehicle.setVisible(vehicle.showRoutes);
      });
    }

    function isEditingPlan() {
      return (plannerService.getPlanName() !== null);
    }

    function calculateRouteArrivals(route) {
      if (!route) {
        return 0;
      }

      var arrivals = plannerService.getTotalArrivalsCached(route.visits, route.id);
      route.arrivals = arrivals;
      return arrivals.length;
    }

    function calculateRouteClients(route) {
      if (!route) {
        return 0;
      }

      var clientCount = routesUtils.calculateClientCount(route.visits);
      route.clientCount = clientCount;
      return clientCount;
    }

    function calculateArrivalsOutOfRoute(visits) {
      var arrivals = plannerService.getTotalArrivalsCached(visits, VISITS_OUT_OF_ROUTE);
      return arrivals.length;
    }

    function clearPlan() {
      plannerService.clearPlan();
    }

    function downloadReport() {
      if (vm.report.txt) {
        vm.report.txt = false;
        vm.report.excel = false;
        vm.report.pdf = false;
        vm.report.summarizedPdf = false;
        $log.info('Descargando reporte txt');
        exportPlanTxt();
        return;
      }

      if (vm.report.excel) {
        vm.report.excel = false;
        vm.report.pdf = false;
        vm.report.summarizedPdf = false;
        $log.info('Descargando reporte excel');
        exportPlanExcel();
        return;
      }
      if (vm.report.pdf) {
        vm.report.excel = false;
        vm.report.pdf = false;
        vm.report.summarizedPdf = false;
        $log.info('Descargando reporte pdf');
        exportPlanPdf();
        return;
      }
      if (vm.report.summarizedPdf) {
        vm.report.excel = false;
        vm.report.pdf = false;
        vm.report.summarizedPdf = false;
        $log.info('Descargando reporte resumido pdf');
        exportSummarizedPlanPdf();
        return;
      }
    }

    function naturalSort(field) {
      return function (item) {
        return naturalService.naturalValue(item[field]);
      };
    }

    function getVehiclesForReoptimize(isMultiDayRouteEnabled) {
      if (isMultiDayRouteEnabled) {
        return $q.resolve(
          plannerService.getActiveVehiclesWithoutRoutesInPlan()
        );
      }
      return plannerService.getVehiclesAvailableWithRoutes();
    }

    function reoptimizePlan() {
      var vehicles = [];
      $rootScope.isLoading = true;

      var visitsOutOfRoute = plannerService.getVisitsOutOfRoute(plannerService.getVisits());
      if (visitsOutOfRoute.length === 0) {
        vm.getPlanUnoptimized();
        $rootScope.isLoading = false;
        Toasts.push('error', $translate('Planner_toast.error_no_visits_for_reoptimize'));
        return;
      }

      var vehiclesWithoutRoutesInPlan = plannerService.getActiveVehiclesWithoutRoutesInPlan();
      if (vehiclesWithoutRoutesInPlan.length === 0) {
        vm.getPlanUnoptimized();
        $rootScope.isLoading = false;
        Toasts.push('error', $translate('Planner_toast.error_no_selected_vehicles_for_reoptimize'));
        return;
      }

      var planDate = plannerService.getPlanDate();
      var diff = 0;

      try {
        diff = vm.calculateTimeDiff(planDate.start, planDate.end);
      } catch (e) {
        $log.error(e.message);
      }

      var nodesMap = [];
      var longRoutes = $scope.isMultiDayRouteEnabled && !vm.optimizationOptions.big_cluster;
      var optimizationOptions = plannerService.getOptimizationOptions();
      var isOneSellerPerVehicleEnabled = optimizationOptions.one_seller_per_vehicle;

      var requestData = {
        vehicles: [],
        nodes: [],
        balance: vm.optimizationOptions.balance,
        all_vehicles: vm.optimizationOptions.all_vehicles,
        big_cluster: optimizationOptions.big_cluster,
        join: vm.optimizationOptions.join,
        join_v2: vm.optimizationOptions.join_v2,
        open_ended: vm.optimizationOptions.open_ended,
        fmv: vm.optimizationOptions.fmv,
        fmb: vm.optimizationOptions.fmb,
        single_tour: optimizationOptions.single_tour,
        beauty: optimizationOptions.beauty,
        use_euclidean_distance: vm.optimizationOptions.use_euclidean_distance,
        country: store.get('country'),
        longRoutes: longRoutes,
        one_vehicle_zone: optimizationOptions.one_vehicle_zone,
        auto_reorder: optimizationOptions.auto_reorder,
        enable_graphs: optimizationOptions.enable_graphs,
        insertion_intensification: optimizationOptions.insertion_intensification,
        intensive_intra: optimizationOptions.intensive_intra,
        open_routes_logic: optimizationOptions.open_routes_logic,
        vehicle_capacities_increment: optimizationOptions.vehicle_capacities_increment,
        vehicle_journey_extention: optimizationOptions.vehicle_journey_extention,
        enable_rest_time: optimizationOptions.enable_rest_time,
        enable_soft_window: optimizationOptions.enable_soft_window,
        wave_routing: optimizationOptions.wave_routing,
        load_balance: vm.isLoadBalanceEnabled,
        time_balance: vm.isTimeBalanceEnabled,
        visit_joiner: visitJoinerService.getVisitJoinerOptimizationParameter(optimizationOptions.distance_to_join_visits),
        avoid_tolls: optimizationOptions.avoid_tolls,
        maximize_attended_load: optimizationOptions.maximize_attended_load,
        oneSellerPerVehicle: isOneSellerPerVehicleEnabled
      };

      if (optimizationUtilsService.isMinLoadValid(optimizationOptions.min_load)) {
        requestData.min_load = optimizationOptions.min_load;
      }

      vm.optimizationOptions.longRoutes = longRoutes;
      vm.optimizationOptions.oneSellerPerVehicle = isOneSellerPerVehicleEnabled;

      var parseStr2Int = function (strNumber) {
        return parseInt(strNumber);
      };

      if (vm.isMultiResultsEnabled) {
        plannerService.setOptimizationResults([]);
      }

      vm.getVehiclesForReoptimize(longRoutes)
        .then(function (data) {
          vehicles = data;
          if (vehicles.length === 0) {
            vm.getPlanUnoptimized();
            $rootScope.isLoading = false;
            Toasts.push('error', $translate('Planner_toast.error_no_vehicles_for_reoptimize'));
            return;
          }

          var zonesFilter = {
            schedules: plannerService.getScheduledPlanDaysOfWeek(),
            enabled: true
          };

          zoneService.getZonesIfProceed(zonesFilter)
            .then(function (zones) {
              zoneService.isAutoZonesEnabled()
                .then(function (response) {
                  var autoZone = zones.length ? response.isAutoZoneEnabled : false;
                  requestData.autoZone = autoZone || optimizationOptions.one_seller_per_vehicle;
                  var params = angular.merge({}, requestData);
                  params.optimizationOptions = vm.optimizationOptions;
                  params.planDate = planDate;
                  params.planInHours = diff;
                  nodesMap = optimizeService.getVisitsRequestData(visitsOutOfRoute, params, false, zones);

                  var mustCallPickupAndDeliveryOptimization = vm.enablePickupAndDeliveryMode &&
                  plannerService.isTherePickupAndDelivery();
                  if (mustCallPickupAndDeliveryOptimization) {
                    reOptimizePickupAndDelivery(vehicles, visitsOutOfRoute, zones, autoZone);
                    return;
                  }

                  vehicles.forEach(function (vehicle) {
                    var vehicleBody = {
                      ident: vehicle.id,
                      location_start: {
                        ident: 'vehicle-start-' + vehicle.id,
                        lat: vehicle.locationStart.latitude,
                        lon: vehicle.locationStart.longitude
                      },
                      location_end: {
                        ident: 'vehicle-end-' + vehicle.id,
                        lat: vehicle.locationEnd.latitude,
                        lon: vehicle.locationEnd.longitude
                      },
                      capacity: vehicle.capacity,
                      capacity_2: (!vehicle.capacity2 || vehicle.capacity2 === 0) ? 0 : vehicle.capacity2,
                      capacity_3: (!vehicle.capacity3 || vehicle.capacity3 === 0) ? 0 : vehicle.capacity3,
                      shift_start: vehicle.shift.start,
                      shift_end: requestData.longRoutes ? timeUtils.addHours(vehicle.shift.end, diff) : vehicle.shift.end,
                      max_tour_duration: vehicle.shiftDefault.maximumTime,
                      skills: vehicle.skills && vehicle.skills.length ? vehicle.skills.map(parseStr2Int) : [],
                      refill: parseInt(vehicle.refill),
                      cost: vehicle.cost,
                      min_load: vehicle.minLoad,
                      min_load_2: vehicle.minLoad2,
                      min_load_3: vehicle.minLoad3,
                      max_visit: vehicle.maxVisit,
                      rest_time_start: vehicle.restTimeStart,
                      rest_time_end: vehicle.restTimeEnd,
                      rest_time_duration: vehicle.restTimeDuration,
                      open_start: vm.optimizationOptions.open_start,
                      max_number_of_routes: vehicle.max_number_of_routes,
                      max_route_distance: vehicle.max_route_distance != null && !isNaN(vehicle.max_route_distance) && Number(vehicle.max_route_distance) > 0 ? parseFloat(Number(vehicle.max_route_distance).toFixed(2)) : 0
                    };

                    vehicleBody.zones = isOneSellerPerVehicleEnabled ? [] : zoneService.getActiveZonesVehicle(vehicle, zones);

                    if (vehicleTypeUtils.shouldAddVehicleType(vm.optimizationOptions)) {
                      vehicleBody.type = vehicleTypeUtils.getVehicleType(vm.optimizationOptions);
                    }

                    requestData.vehicles.push(vehicleBody);
                  });

                  requestData.nodes = nodesMap;
                  reOptimize(requestData, optimizationOptions.big_vrp);
                });
            });
        })
        .catch(function (e) {
          $log.error(e);
          vm.getPlanUnoptimized();
          $rootScope.isLoading = false;
        });

      function reOptimize(requestData, isBigVrp) {
        var isVehicularRestrictionEnabled = plannerService.isVehicularRestrictionEnabled();
        optimizeService.reoptimizePlan(vm.optimizationOptions, requestData, isBigVrp, isVehicularRestrictionEnabled)
          .then(function (response) {
            var vehiclesFromPlan = plannerService.getVehicles().filter(function (vehicle) {
              return vehicle.routes.length;
            });
            return colorAssignerService.assignVehiclesColor(response.data.vehicles, vehiclesFromPlan)
              .finally(function () {
                successReoptimizePlan(response);
              });
          })
          .catch(errorReoptimizePlan);
      }

      function reOptimizePickupAndDelivery(vehicles, visits, zones, autoZone) {
        var optimizationOptions = plannerService.getOptimizationOptions();
        optimizationOptions.country = store.get('country');
        optimizationOptions.autoZone = autoZone;
        var params = {
          optimizationOptions: optimizationOptions,
          isJDH: _isJDHActive(),
          planName: plannerService.getPlanName(),
          planEditingSelected: plannerService.getPlanEditingSelected(),
          isBigVrp: optimizationOptions.big_vrp,
          use_euclidean_distance: optimizationOptions.use_euclidean_distance,
          enable_graphs: optimizationOptions.enable_graphs,
          auto_reorder: optimizationOptions.auto_reorder,
          planInHours: diff,
          planDate: planDate || 0,
          longRoutes: $scope.isMultiDayRouteEnabled,
          one_vehicle_zone: optimizationOptions.one_vehicle_zone,
          load_balance: vm.isLoadBalanceEnabled,
          time_balance: vm.isTimeBalanceEnabled,
          isVehicularRestrictionEnabled: plannerService.isVehicularRestrictionEnabled(),
        };
        optimizeService.optimizePickupAndDeliveryPlan(vehicles,visits,zones,params)
          .then(function (response) {
            var vehiclesFromPlan = plannerService.getVehicles().filter(function (vehicle) {
              return vehicle.routes.length;
            });
            return colorAssignerService.assignVehiclesColor(response.data.vehicles, vehiclesFromPlan)
              .finally(function () {
                successReoptimizePlan(response);
              });
          })
          .catch(errorReoptimizePlan);
      }

      function successReoptimizePlan(response) {
        if (response.data.id) {
          plannerService.addOptimizationId(response.data.id);
          plannerService.setCurrentOptimizationId(response.data.id);
        }

        if (vm.optimizationOptions.big_cluster) {
          $rootScope.isLoadingBigData = true;
        }

        response.data.vehicles.forEach(function (vehicleOpt) {
          if (!vehicleOpt.tours.length) {
            return;
          }

          var vehicle = null;
          for (var i = 0; i < vehicles.length; i++) {
            if (vehicles[i].id === vehicleOpt.ident) {
              vehicle = vehicles[i];
              break;
            }
          }

          var orderAux = 1;
          vehicle.setColor(colorAssignerService.getVehicleColor(vehicle.id));

          vehicleOpt.tours.forEach(function (tour) {
            var route = plannerService.createRoute(vehicle.id);
            // Remove first node representing origin depot
            route.estimatedTimeStart = tour.nodes.shift().arrival;
            // Remove last node representing destination depot
            route.estimatedTimeEnd = tour.nodes.pop().arrival;
            route.routeDistance = tour.route_distance || null;

            var restTimeNode = null;
            tour.nodes.forEach(function (node) {

              if (node.ident === REST_TIME) {
                restTimeNode = plannerService.parseOptimizationRestTimeNode(node, vehicle);
                return;
              }

              var visit = null;
              var nodeVisit = nodesMap.filter(function (nodeTmp) {
                return nodeTmp.ident === node.ident;
              })[0];

              nodeVisit.group.forEach(function (visitId, index) {
                for (var i = 0; i < visitsOutOfRoute.length; i++) {
                  if (visitsOutOfRoute[i].id === visitId) {
                    visit = visitsOutOfRoute[i];
                    break;
                  }
                }

                if (index === nodeVisit.group.length - 1) {
                  visit.updateOrder(orderAux, !$rootScope.drawCluster);
                } else {
                  visit.updateOrder(node.order, !$rootScope.drawCluster);
                }

                visit.estimatedTimeArrival = node.arrival;
                visit.estimatedTimeDeparture = node.departure;
                visit.stopId = node.stop_id;

                if (vm.optimizationOptions.big_cluster) {
                  //Evaluamos que la visita que se va a agregar a la ruta de el vehiculo, este habilitada mediante skills para estar en ese vehiculo
                  var skillError = vehicle.validateVisitSkills(visit);
                  if (skillError) {
                    route.skillsError = true;
                    visit.skillsError = true;
                  }
                }

                visit.setIconFillColor(vehicle.color, !$rootScope.drawCluster);
                visit.setDefaultColor(vehicle.color);
                route.addVisit(visit, false, !$rootScope.drawCluster);
                orderAux++;
              });
            });

            //adding the route to vehicle
            vehicle.addRoute(route);
            if(restTimeNode) {
              plannerService.setRestTimeByRouteId(route.id, restTimeNode);
            } else {
              plannerService.clearRestTimes(route.id);
            }
          });
        });

        _recalculateAllRoutesNew()
          .then(function () {
            // Reordenamos las rutas si esta opcion de cluster con optimizacion esta seleccionada como true
            if (vm.optimizationOptions.big_cluster) {
              var routes = [], index = 0;
              $rootScope.isLoadingBigData = true;
              vm.vehicles.map(function (vehicle) {
                vehicle.routes.map(function (route) {
                  routes.push(route);
                });
              });

              if (intervalPromise) {
                $interval.cancel(intervalPromise);
              }

              vm.maxProgressBar = routes.length;
              _reorderRoutesOptimization(routes, index);
              intervalPromise = $interval(_updatePromiseBar, UPDATE_SECONDS);
            }
          })
          .finally(function () {
            $rootScope.isLoading = false;
          });

        vm.getPlanUnoptimized();
      }

      function errorReoptimizePlan(objError) {
        $log.info('Routes ReoptimizePlan', objError);

        if (objError.status === 400 && _isThereAnyVehicleCapacityError(objError.data.vehicles)) {
          Toasts.push('error', $translate('Planner_toast.error_optimize_capacity_vehicles'));
        } else {
          Toasts.push('error', $translate('Planner_toast.error_optimize_500'));
        }

        var response = {
          data: {
            vehicles: []
          }
        };

        successReoptimizePlan(response);
      }
    }

    /////////////////////////////////////////////////////////////
    // Private methods
    ////////////////////////////////////////////////////////////

    //Se encapsulo en una funcion el recorrido de vehiculos para recalcular sus rutas porque se necesita que una promesa
    //retorne success al terminar de recalcular todas las rutas disponibles.
    //Funcion nueva, debe hacerse el refactor de optimize para eliminar la otra
    function _recalculateAllRoutesNew() {
      var deferred = $q.defer(), i = 0, vehicles_used = 0;
      plannerService.vehicles.forEach(function (vehicle) {
        if (vehicle.routes.length > 0) {
          vehicles_used++;
          vehicle.recalculateAllRoutes(vm.optimizationOptions, plannerService)
            .then(function () {
              if (colorAssignerService.areColorsEnabled()) {
                vehicle.setRelativePlanColor(
                  colorAssignerService.getVehicleColor(vehicle.id),
                  true
                );
              }

              vehicle.routes.forEach(function (route) {
                route.setVisible();
                route.setHasManualChanges(false);
                if (!vm.optimizationOptions.big_cluster) {
                  route.visits.forEach(function (visit) {
                    visit.setVisible(true, !$rootScope.drawCluster);
                  });
                }
              });
              i++;
              if (i === vehicles_used) {
                deferred.resolve();
              }
            })
            .finally(function () {
              vm.updatePlannerIndicators();
            });

          if (!vm.isDirectEditingModeEnabled) {
            if (!vm.optimizationOptions.big_cluster) {
              vehicle.setVisible(true, vm.optimizationOptions.open_ended, false);
            }
            vehicle.setIconFillColorWithVehicleColor();
          }
        }
      });
      setUserVisualStates();
      return deferred.promise;
    }

    function _fillMoveToSelect(vehicles) {
      vm.moveToOptions = [];
      // agregamos la opcion de poder mover las visitas de una ruta al array de visitas fuera de ruta
      vehicles.map(function (vehicle) {
        angular.forEach(vehicle.routes, function (value, key) {
          var option = {
            name: [vehicle.name, ' -- ', $filter('translate')('Routes.route_text'), key + 1].join(''),
            vehicleId: vehicle.id,
            routeId: value.id,
            color: vehicle.color,
            background_color: 'none'
          };
          vm.moveToOptions.push(option);
        });
      });
    }

    function _reorderRoutesOptimization(routes, index) {
      if (routes.length === index) {
        _cancelLoading();
        return;
      }
      var route = routes[index];
      var drawCluster = (vm.optimizationOptions.big_cluster || $rootScope.drawCluster);

      if (drawCluster) {
        var isJDH = _isJDHActive();
        var visits = plannerService.getVisits();
        var vehicle = plannerService.getVehicleById(route.vehicleId);

        var planDate = plannerService.getPlanDate();
        var planInHours = vm.calculateTimeDiff(planDate.start, planDate.end);

        var params = {
          optimizationOptions: vm.optimizationOptions,
          isJDH: isJDH,
          longRoutes: $scope.isMultiDayRouteEnabled,
          planDate: planDate,
          planInHours: planInHours,
          isVehicularRestrictionEnabled: plannerService.isVehicularRestrictionEnabled()
        };

        optimizeService.reorderRoute(vehicle, route, visits, params)
          .then(function (response) {
            plannerService.addOptimizationId(response.optimizationId);
            var vehicle = plannerService.vehicles.filter(getVehicleById(route.vehicleId))[0];
            vehicle.recalculateRouteStartingAt(route, vm.optimizationOptions, plannerService)
              .then(function () {
                if (vm.maxProgressBar > vm.routesCompleted) {
                  vm.routesCompleted = index + 1;
                  var temporal = (vm.routesCompleted / vm.maxProgressBar) * 100;
                  vm.widthDynamic = String(temporal) + "%";
                }
                index = index + 1;
                _reorderRoutesOptimization(routes, index);
              })
              .catch(function (fail) {
                $log.info(fail);
                $rootScope.isLoadingBigData = false;
              });
          })
          .catch(function (error) {
            $log.info(error);
            _cancelLoading();
            Toasts.push('error', $translate('Planner_toast.error_order_route'));
          });
      }
    }

    function _updatePromiseBar() {
      if ($rootScope.isLoadingBigData) {
        if (vm.maxProgressBar > vm.routesCompleted) {
          var temporal = ((vm.routesCompleted + 1) / vm.maxProgressBar) * 100;
          var tmp = vm.widthDynamic.split('%');
          if (tmp[0] < temporal) {
            tmp = parseFloat(tmp[0]) + 0.1;
            vm.widthDynamic = String(tmp) + "%";
          }
        } else {
          _cancelLoading();
        }
      } else {
        _cancelLoading();
      }
    }

    function _cancelLoading() {
      // Apagar Loading y vaciar elementos de condicion
      $timeout(function () {
        $rootScope.isLoadingBigData = false;
        vm.widthDynamic = "0%";
        vm.routesCompleted = 0;
        if (intervalPromise) {
          $interval.cancel(intervalPromise);
        }
      }, 10);
    }

    function _isJDHActive() {
      var isJDH = false;
      if (parseInt($stateParams.jdh) === 1) {
        isJDH = true;
      } else {
        isJDH = vm.enableJdhConfigAccount;
      }
      return isJDH;
    }

    function _checkoutJdhEnableConfig(configs) {
      configs.forEach(function (config) {
        if (config.key === 'enable_jdh') {
          vm.enableJdhConfigAccount = config.value;
        }
      });
    }

    function _isThereAnyVehicleCapacityError(vehicles) {
      return vehicles && vehicles.some(function (vehicle) {
        return vehicle.capacity;
      });
    }

    function openInfoModal() {
      var scope = $scope.$new();
      ngDialog.open({
        template: 'app/planner/routes/info-modal.html',
        controller: 'InfoTableController',
        controllerAs: 'vm',
        scope: scope,
        showClose: false,
        closeByEscape: false,
        closeByDocument: false,
        className: 'ngdialog-theme-default custom-width-100-height-100'
      });
    }

    function goToRoutesDetail() {
      setUserVisualStates();

      $state.go("planner.routes-detail", {
          route_opened: vm.lastExpandedRoute ? vm.lastExpandedRoute.id : '',
          out_of_route_opened: vm.isVisitsOutOfRouteListExpanded,
          vehicle_sort_key: vm.vehicleSortKey
        }
      );
    }

    function setUserVisualStates() {
      plannerService.setUserVisualState(vm.vehiclesToSeeRoutesInDetail);
    }

    function calculateTimeDiff(startDate, endDate) {
      var diff = timeUtils.diff(endDate, startDate, 'hours');
      if (0 > diff) {
        throw new Error('Invalid plan date diff. endDate is less than startDate');
      }
      return diff;
    }

    function getRouteName(route, index) {
      var routeCode;

      if (vm.customRouteNameConfig) {
        routeCode = plannerService.getRouteName(route) || index;
      } else {
        routeCode = index;
      }

      vm.routeCodes[route.id] = $translate("Routes.route_text") + routeCode;

      $scope.$emit('Planner:UpdateRouteCodes', {
        routeId: route.id,
        routeCode: vm.routeCodes[route.id]
      });

      return vm.routeCodes[route.id];
    }

    function isEnableNotesInRouteDesigner() {
      var accountConfigs = store.get('accountConfigs');
      var enableNotesInRouteDesigner;
      if (accountConfigs) {
        enableNotesInRouteDesigner = accountConfigs.find(function (config) {
          return config.key === ENABLE_NOTES_IN_ROUTE_DESIGNER;
        });
      }
      return enableNotesInRouteDesigner ? enableNotesInRouteDesigner.value : false;
    }

    function createOrUpdateVisitsMarkersLight(visitsWithVisibleVehicle) {
      var areClustersEnabled = $rootScope.drawCluster;
      var areMarkersVisible = true;
      var mustUpdateMarkers = !areClustersEnabled;

      if (areClustersEnabled) {
        if (vm.showVisitsOutOfRoutes) {
          visitsMarkersService.setVisibleInVisits(vm.visitsOutOfRouteActions.visits, areMarkersVisible,
            mustUpdateMarkers);
          var mustRenderSmallMarkers = true;
          createVisitsOnMap(vm.visitsOutOfRouteActions.visits, mustRenderSmallMarkers);
        }
      } else {
        var visitsToCreateOrUpdateMarkers = vm.showVisitsOutOfRoutes ? vm.visitsOutOfRouteActions.visits : [];
        if (vm.areVisitsMarkersVisible) {
          var visitsBelongingAnyRoute = visitsWithVisibleVehicle || plannerService.getVisitsBelongingAnyRoute();
          visitsToCreateOrUpdateMarkers = visitsToCreateOrUpdateMarkers.concat(visitsBelongingAnyRoute);
        }

        visitsMarkersService.setOpacityInVisits(visitsToCreateOrUpdateMarkers, ROUTE_VISIBLE_OPACITY, false);
        visitsMarkersService.setVisibleInVisits(visitsToCreateOrUpdateMarkers, areMarkersVisible, mustUpdateMarkers);
      }
    }

    function isVisitsOutOfRouteFilterVisible() {
      return (
        vm.isVisitsOutOfRouteFilterEnabled &&
        vm.visitsOutOfRoute.length > 0 &&
        !$scope.isMultiDayRouteEnabled
      );
    }

    function filterVisitsOutOfRoute(minSliderTime, maxSliderTime) {
      vm.visitsOutOfRoute.forEach(function (visit) {
        visit.setVisible(false, !$rootScope.drawCluster);
        visit.actionRemove(visit);
      });

      var visible = $rootScope.drawCluster ? !vm.visitsOutOfRouteActions.collapse : true;
      visitsUtils.filterVisits(
        vm.visitFilterHandler, visitFilterService.getFilters(), vm.visitsOutOfRoute,
        visible, minSliderTime, maxSliderTime
      );
    }

    function mustShowVisitWindows(windowStart, windowEnd) {
      return vm.show_visit_windows && plannerService.mustShowVisitWindows(windowStart, windowEnd);
    }

    function displayWindowsFormat(windowStart, windowEnd) {
      if (!windowStart || !windowEnd) {
        return;
      }
      return windowStart + ' ' + $translate('Planner.infowindow_to') + ' ' + windowEnd;
    }

    function displayWindows(visit) {
      var isValidWindows = mustShowVisitWindows(visit.windowStart, visit.windowEnd);
      var isValidWindows2 = mustShowVisitWindows(visit.windowStart2, visit.windowEnd2);
      if (isValidWindows && isValidWindows2) {
        return (
          displayWindowsFormat(visit.windowStart, visit.windowEnd) + ' | ' +
          displayWindowsFormat(visit.windowStart2, visit.windowEnd2)
        );
      }
      return isValidWindows ? displayWindowsFormat(visit.windowStart, visit.windowEnd) :
        displayWindowsFormat(visit.windowStart2, visit.windowEnd2);
    }

    function toggleOptionsMenu(route) {
      event.stopPropagation();
      route.isOptionsMenuOpen = !route.isOptionsMenuOpen;
    }

    function deleteRoute(vehicle, route) {
      $rootScope.isLoading = true;
      plannerService.setBackupRoute(route);
      if (route.visits.length > 0) {
        route.visits.forEach(function (visit) {
          if (vm.visitsOutOfRoute.indexOf(visit) === -1) {
            visit.routeId = null;
            visit.setDefaultColor(VISIT_OUT_OF_ROUTE_DEFAULT_COLOR);
            visit.updateOrder(VISIT_OUT_OF_ROUTE_ORDER, false);
            visitsMarkersService.showVisitOnMap(visit, vm.vehiclesToSeeRoutesInDetail[
              VISIT_OUT_OF_ROUTE_VISUAL_STATE_ID]);
            vm.visitsOutOfRoute.push(visit);
          }
        });

        vm.visitsOutOfRouteFormattedLoads = statisticsService.calculateVisitsTotalLoads(vm.visitsOutOfRoute, Boolean(
          vm.optimizationOptions.big_cluster));
        if (vm.visitFilterHandler.activeFilter) {
          vm.filterVisitsOutOfRoute(vm.visitFilterHandler.minSliderTime, vm.visitFilterHandler.maxSliderTime);
        }

        $rootScope.$broadcast("Planner:Update:InfoBoxColors", {color: VISIT_OUT_OF_ROUTE_DEFAULT_COLOR,
          visits: angular.copy(route.visits)});
      }

      plannerService.routeMarkAsRemoved(route);
      plannerService.removeVehicleRoute(vehicle, route);
      if (vehicle.routes.length === 1) {
        var driverid = vehicle.routes[0].driver;
        if (vehicle.driverId !== driverid) {
          vm.updateVehicleDriver(vehicle, driverid, vm.vehicles);
        }
      }

      if (vehicle.routes.length === 0) {
        vm.vehicles.splice(vm.vehicles.indexOf(vehicle), 1);
        vehicle.setVisible(false);
      }

      vm.updatePlannerIndicators();
      $rootScope.isLoading = false;
      vm.filterHandler.activeFilter && routeDesignFilterService.applyResultToVM(vm, vm.searchResults);
    }

    function goToVisitList() {
      if (!plannerService.isPlanEditable()) {
        $rootScope.$broadcast('Planner:openModalCancelEditPlan');
      } else {
        $state.go('planner.visits-list');
      }
    }

    function goToDeleteRoute(ev, vehicle, route, routeIndex) {
      if (ev) {
        ev.stopPropagation();
      }

      route.isOptionsMenuOpen = false;
      if (route.visits.length > 0) {
        $scope.deleteRoute = deleteRoute;
        $scope.vehicle = vehicle;
        $scope.route = route;
        $scope.routeName = vm.getRouteName(route, routeIndex);
        ngDialog.open({
          template: 'app/planner/routes/routes-modals/route-delete-modal/route-delete-modal.html',
          scope: $scope
        });
      }
    }

    function hasMultipleRoute(vehicle) {
      return vehicle.routes.length > 1;
    }

    function isMultiDriverVehicle(vehicle) {
      return vm.isMultiDriversConfigEnabled && hasMultipleRoute(vehicle);
    }

    function updateVehicleDriver (vehicle, selectedDriver, vehicles) {
      plannerService.updateVehicleDriver(vehicle, selectedDriver, vehicles);
      $scope.$broadcast('drivers-selected:updated', vm.drivers);
    }

    function isMixLoadAddonEnabled() {
      var pathFinderProperties = plannerService.getPathFinderProperties();
      var enabledMaxLoad = pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD];
      return enabledMaxLoad && enabledMaxLoad.toLowerCase() === 'true';
    }
  }
})();

/* global moment:false */
(function () {
  'use strict';
  angular
    .module('icarus.planner')
    .controller('PlannerRoutesDetailController', PlannerRoutesDetailController);

  /** @ngInject */
  function PlannerRoutesDetailController($filter, $rootScope, $log, $q, $state, $scope, ngDialog, Toasts, lodash,
                                         $timeout, $anchorScroll, alertNotificationService, plannerService, timeUtils,
                                         store, sessionService, naturalService, $stateParams, routesGroupMarkersService,
                                         optimizeService, accountConfigsService, routesUtils, statisticsService,
                                         routeDesignFilterService, asyncUtils, vtcService, saveDraftPlanService,
                                         rebalanceRoutesHelper, autosaveDraftPlanService, ACCOUNT_CONFIGS, NONE_STRING,
                                         visitFilterService, visitsUtils, ENABLE_PICKUP_AND_DELIVERY_MODE,
                                         MODAL_REOPTIMIZER_OPTION, MODAL_CANCEL_OPTION, MODAL_CONTINUE_OPTION,
                                         VISIT_OUT_OF_ROUTE_VISUAL_STATE_ID, SHOW_VISIT_WINDOWS, ROUTE_VISIBLE_OPACITY,
                                         ROUTE_REVISED_OPACITY, visitsMarkersService, VISIT_OUT_OF_ROUTE_DEFAULT_COLOR,
                                         VISIT_OUT_OF_ROUTE_ORDER, VISITS_OUT_OF_ROUTE_LIST_ID, colorAssignerService,
                                         EVENT_CLEAR_ROUTES_GROUP_MARKERS, ROUTES_MODALS_FOLDER_PATH,
                                         revisedRoutesService, vehicleAvailabilityService, AVAILABILITY_ICON_URL,
                                         $sanitize, __env, addonsService, ExpandModalService, accountingService,
                                         ROUTE_FINISHED_STATUSES, SELLER_MANAGEMENT_ADD_ON_KEY, VISIT_TYPE,
                                         START_TIME_WINDOW, END_TIME_WINDOW, planService, ROUTE_STATUS_CHECK_DEBOUNCE,
                                         ROUTE_STATUS_TOAST_DEBOUNCE, PATH_FINDER_ADD_ON_PROPERTIES) {
    var vm = this;
    var dragTimeOut = -1;
    var FORMAT_DATE = 'DD MMMM, YYYY';
    var $translate = $filter('translate');
    var ENABLE_NOTES_IN_ROUTE_DESIGNER = 'enable_notes_in_route_designer';
    var VISITS_OUT_OF_ROUTE = 'visitsOFR';
    var MOVEMENT_INSIDE_ROUTE = "Inside route";
    var MOVEMENT_TO_OUT_OF_ROUTE = "To out of route";
    var MOVEMENT_MIX = "Mix";
    var MOVEMENT_TO_ROUTE = "To route";
    var MOVEMENT_BETWEEN_ROUTES = "Between routes";
    var NUMBER_OF_MOVED_VISITS_INSIDE_ROUTE = 1;
    var REQUEST_CONCURRENCY = 6;
    var ENABLE_REORDER_ON_MOVE_VISITS = "enable_reorder_on_move_visits";
    var ENABLE_BLOCK_VEHICLE_CHANGE = 'enable_block_vehicle_change';
    var ENABLE_REBALANCE_ROUTES = "enable_rebalance_routes";

    vm.routes = null;
    vm.planDate = null;
    vm.isEditingPlan = false;
    vm.visibleAllRoutes = true;
    vm.selectAllVisitsOutOfRoute = false;
    vm.isMultipleEditingModeActivated = false;
    vm.showVehicleList = {};
    vm.enableNotesInRouteDesigner = false;
    vm.draftsEnabled = false;
    vm.rebalanceRoutesEnabled = false;
    vm.isMultiDriversConfigEnabled = false;
    vm.enableOrganizationSyncService = false;
    vm.drivers = [];
    vm.vehicles = [];
    vm.allVehicles = [];
    vm.vehiclesAvailable = [];
    vm.moveToOptions = [];
    vm.visitsOutOfRoute = [];
    vm.priorityLevels = [];
    vm.interchangeableVehicles = [];
    vm.visitsOutOfRouteFormattedLoads = {
      load: 0,
      load2: 0,
      load3: 0
    };
    vm.selectedVisitOutOfRoute = {
      load: 0,
      load2: 0,
      load3: 0,
      load4: 0
    };
    vm.lastExpandedRoute = null;
    vm.blockVehicleChangeEnabled = false;
    vm.startedRoutes = {};
    vm.routeStatusCheckDebounceTimer = null;
    vm.lastToastMessage = null;
    vm.toastDebounceTimer = null;
    vm.optionOutOfRoute = {
      name: $translate('Routes.out_of_route'),
      vehicleId: -1,
      routeId: -1,
      color: "#A4A4A4",
      background_color: NONE_STRING
    };

    vm.visitsOutOfRouteActions = {
      id: VISITS_OUT_OF_ROUTE_LIST_ID,
      _collapse: true,
      areVisitsListed: false,
      setVisitsListed: function (areVisitsListed) {
        this.areVisitsListed = areVisitsListed;
      }
    };

    vm.visitsOutOfRouteForLoadTable = {
      id: VISITS_OUT_OF_ROUTE_LIST_ID,
      hasLoads: function () {
        return this.totalLoad > 0 || this.totalLoad2 > 0 || this.totalLoad3 > 0;
      }
    };

    vm.show_visit_windows = accountConfigsService.isConfigEnabled(SHOW_VISIT_WINDOWS);

    vm.headerTextForLoadTable = null;
    vm.showLoadsTable = false;
    vm.selectedRouteForLoads = null;
    vm.reverseOrderLoadsTable = false;
    vm.isMoveToCollapsed = true;


    vm.buildDisplayVehiclesList = buildDisplayVehiclesList;
    vm.displayVehiclesList = {
      actions: [],
      categories: []
    };
    vm.skills = {};
    vm.kpis = {};
    vm.expandVisit = expandVisit;
    vm.getDriverFullName = getDriverFullName;
    vm.isSellerManagementEnabled = false;

    vm.isNewRoute = [];

     // Add property to track current open vehicle
     vm.openVehicleIndex = null;

    vm.selectVehicleId = function (item) {
      vm.selectedItemId = item.identity;
      //vm.showVehicleList = {};
    };

    Object.defineProperty(vm.visitsOutOfRouteActions, 'visits', {
      get: function() {
        // Should return the full or filtered list of the rendered visits.
        return vm.visitFilterHandler.activeFilter ? vm.visitFilterHandler.visits : vm.visitsOutOfRoute;
      }
    });

    Object.defineProperty(vm.visitsOutOfRouteActions, 'collapse', {
      get: function() {
        return this._collapse;
      },
      set: function (value) {
        $scope.$emit('Planner:visit-off-route:collapsed', {
          collapse: value
        });
        this._collapse = value;
      }
    });

    Object.defineProperty(vm.visitsOutOfRouteForLoadTable, "totalLoad", {
      get: function () {
        return vm.visitsOutOfRoute.reduce(function (acc, visit) {
          return acc + visit.load;
        }, 0);
      }
    });

    Object.defineProperty(vm.visitsOutOfRouteForLoadTable, "totalLoad2", {
      get: function () {
        return vm.visitsOutOfRoute.reduce(function (acc, visit) {
          return acc + visit.load2;
        }, 0);
      }
    });

    Object.defineProperty(vm.visitsOutOfRouteForLoadTable, "totalLoad3", {
      get: function () {
        return vm.visitsOutOfRoute.reduce(function (acc, visit) {
          return acc + visit.load3;
        }, 0);
      }
    });

    Object.defineProperty(vm.visitsOutOfRouteForLoadTable, "editingSelected", {
      get: function () {
        return vm.selectAllVisitsOutOfRoute;
      },
      set: function (value) {
        vm.selectAllVisitsOutOfRoute = value;
      }
    });

    Object.defineProperty(vm.visitsOutOfRouteForLoadTable, "visits", {
      get: function () {
        return Array.from(vm.visitsOutOfRoute);
      }
    });

    vm.optimizationOptions = {
      balance: false,
      all_vehicles: true,
      big_cluster: false,
      join: false,
      open_ended: false,
      use_euclidean_distance: false,
      max_client: 0,
      min_load: 0,
      disable_soft_window: false
    };

    vm.node = {
      collapsed: true,
      expandOnHover: true,
      isDraggin: false,
      nodeFrom: 0,
      position: 0
    };

    vm.routeCodes = {};

    vm.moment = moment;
    plannerService.disableStep.vehicleDisabled = false;
    vm.fillCircleOption = fillCircleOption;
    vm.moveVisitTo = moveVisitTo;
    vm.toggleCollapseRoute = toggleCollapseRoute;
    vm.toggleEditingVisitsOfRoute = toggleEditingVisitsOfRoute;
    vm.collapseOrExpandVisitsOutOfRoute = collapseOrExpandVisitsOutOfRoute;
    vm.toggleSelectAllVisitsOutOfRoute = toggleSelectAllVisitsOutOfRoute;
    vm.addRouteToVehicle = addRouteToVehicle;
    vm.confirmEditingChanges = confirmEditingChanges;
    vm.confirmEditingChangesForSaveDraftPlan = confirmEditingChangesForSaveDraftPlan;
    vm.reorderRoute = reorderRoute;
    vm.reorderEditedRoutes = reorderEditedRoutes;
    vm.toggleSelectedEditVisit = toggleSelectedEditVisit;
    vm.goToDeleteRoute = goToDeleteRoute;
    vm.cancelEditing = cancelEditing;
    vm.naturalSort = naturalSort;
    vm.toggleVisitOutOfRoute = toggleVisitOutOfRoute;
    vm.calculateRouteArrivals = calculateRouteArrivals;
    vm.calculateRouteClients = calculateRouteClients;
    vm.calculateArrivalsOutOfRoute = calculateArrivalsOutOfRoute;
    vm.getPlanUnoptimized = getPlanUnoptimized;
    vm.updatePlannerIndicators = updatePlannerIndicators;
    vm.toggleShowRoutes = toggleShowRoutes;
    vm.toggleVisitsOutOfRoutes = toggleVisitsOutOfRoutes;
    vm.sendToInfoBox = sendToInfoBox;
    vm.getRouteName = getRouteName;
    vm.toggleVisibleAllRoutes = toggleVisibleAllRoutes;
    vm.interchangeRoute = interchangeRoute;
    vm.toggleShowVehicleList = toggleShowVehicleList;
    vm.isEnableNotesInRouteDesigner = isEnableNotesInRouteDesigner;
    vm.toggleSelectedEditVisitFromMap = toggleSelectedEditVisitFromMap;
    vm.showOrHideSelectedNotification = showOrHideSelectedNotification;
    vm.showOrRemoveNotification = showOrRemoveNotification;
    vm.getVisitsAndRoutesSelected = getVisitsAndRoutesSelected;
    vm.getRouteById = getRouteById;
    vm.customRouteNameConfig = false;
    vm.isMultidayRouteEnabled = false;
    vm.isVisitsOutOfRouteFilterEnabled = false;
    vm.showRoutesDiv = true;
    vm.highlightVisitByWeight = 0;
    vm.highlightVisitByWeight2 = 0;
    vm.highlightVisitByWeight3 = 0;
    vm.recalculateAllRoutesFailed = recalculateAllRoutesFailed;
    vm.routesUtils = routesUtils;
    vm.canVehicleBeInterchanged = canVehicleBeInterchanged;
    vm.reAssignAllPlanVehiclesColor = reAssignAllPlanVehiclesColor;

    vm.dragControlListeners = {
      accept: acceptListener,
      dropped: droppedListener,
      dragStart: dragStartListener,
      dragStop: dragStopListener,
      dragMove: dragMoveListener
    };

    vm.vehiclesToSeeRoutesInDetail = plannerService.getUserVisualState();
    vm.getVehicleNameWithRouteMarking = getVehicleNameWithRouteMarking;
    vm.recalculateRoutesTimes = recalculateRoutesTimes;
    vm.getMovableAndUnmovableVisits = getMovableAndUnmovableVisits;

    vm.dataByVehicle = statisticsService.dataByVehicle;
    vm.vehicleSortKey = $stateParams.vehicle_sort_key;
    vm.totalRoutedLoads = statisticsService.getTotalRoutedLoads();
    vm.setVehicleDriver = plannerService.setVehicleDriver;
    vm.updateVehicleDriver = updateVehicleDriver;

    vm.movedVisitsCollection = {
      movement_type: "",
      number_of_moved_visits: 0,
      polygon: false,
      blocked_visits: false
    };

    vm.visitFilterHandler = visitFilterService.getHandlerState();
    vm.mustShowVisitWindows = mustShowVisitWindows;
    vm.displayWindows = displayWindows;
    vm.areVisitsMarkersVisible = visitsMarkersService.getAreMarkersVisibleInStepThree();
    vm.getAvailabilityIconUrl = getAvailabilityIconUrl;
    vm.getPreviousVisit = routesUtils.getPreviousVisit;
    vm.getNextVisit = routesUtils.getNextVisit;
    vm.VISIT_TYPE = VISIT_TYPE;

    // These functions determine whether to display information for a vehicle based on its availability.
    // It can be used if it is "available", "partially available", or "with expired documents".
    vm.shouldDisplayAvailableVehicleData = vehicleAvailabilityService.shouldDisplayAvailableVehicleData;
    vm.shouldDisplayPartiallyAvailableVehicleData = vehicleAvailabilityService.shouldDisplayPartiallyAvailableVehicleData;
    vm.shouldDisplayVehicleWithExpiredDocumentsData = vehicleAvailabilityService.shouldDisplayVehicleWithExpiredDocumentsData;

    vm.isMixLoadAddonEnabled = isMixLoadAddonEnabled;

    /////////////////////////////////////////////////////////////
    // Search Visit And Vehicle
    ////////////////////////////////////////////////////////////

    var callbackToGetVehicles = function () {
      return vm.vehicles;
    };

    vm.searchData = routeDesignFilterService.getSearchDataBinding(
      callbackToGetVehicles, plannerService.visits
    );

    vm.filterHandler = routeDesignFilterService.filterStatusHandler;
    vm.filters = routeDesignFilterService.filters;

    vm.searchResults = null;
    vm.reorderOnMoveVisitsConfig = false;
    vm.reorderRouteOnMoveVisits = reorderRouteOnMoveVisits;
    vm.reorderRouteStartingAt = reorderRouteStartingAt;
    vm.rebalanceRoutes = rebalanceRoutes;
    vm.isVisitsOutOfRouteFilterVisible = isVisitsOutOfRouteFilterVisible;
    vm.filterVisitsOutOfRoute = filterVisitsOutOfRoute;
    vm.planVehicleHaveBeenUpdated = false;

    vm.setLoadsTableRoute = setLoadsTableRoute;
    vm.closeLoadsTable = closeLoadsTable;
    vm.selectVisitForLoadTable = selectVisitForLoadTable;
    vm.selectRouteForLoadTable = selectRouteForLoadTable;

    vm.toggleOptionsMenu = toggleOptionsMenu;
    vm.markRouteAsRevised = markRouteAsRevised;
    vm.disableRouteCard = disableRouteCard;
    vm.disableVehicleCard = disableVehicleCard;
    vm.getVehicleNameNgClass = getVehicleNameNgClass;
    vm.getVehicleStatisticsNgClass = getVehicleStatisticsNgClass;
    vm.highlightRoute = highlightRoute;
    vm.markRouteAsUnrevised = markRouteAsUnrevised;
    vm.openRevisedRouteModal = openRevisedRouteModal;
    vm.fillMoveToSelect = fillMoveToSelect;
    vm.reverseRouteOrder = reverseRouteOrder;
    vm.hasMultipleRoute = hasMultipleRoute;
    vm.doesRouteExceedMaxDistance = routesUtils.doesRouteExceedMaxDistance;
    vm.doesVehicleHaveRouteExceedingMaxDistance = routesUtils.doesVehicleHaveRouteExceedingMaxDistance;
    vm.isMultiDriverVehicle = isMultiDriverVehicle;
    vm.isVisitFromProcessedRoute = plannerService.isVisitFromProcessedRoute;
    vm.hasPlanRoutesProcessed = plannerService.hasPlanRoutesProcessed();
    vm.isPrioritizeLoadOptionEnabled = plannerService.isPrioritizeLoadOptionEnabled();

    vm.onClick = function (result) {
      var route;
      vm.searchResults = result;
      routeDesignFilterService.applyResultToVM(vm, result);
      if(result.type === "vehicles"){
        return;
      }
      if(!vm.filterHandler.visitsOffRoute) {
        var vehicleSorted = $filter('orderBy')(vm.vehicles, vm.vehicleSort, vm.vehicleSortDesc);
        route = null;
        for(var i = 0; i < vehicleSorted.length; i++){
          route = vehicleSorted[i].routes.find(function(route){
            return vm.filterHandler.routes[route.id];
          });
          if(route){
            break;
          }
        }
        route.collapse = true;
        vm.visitsOutOfRouteActions.collapse = true;
        vm.toggleCollapseRoute(route);
      } else {
        route = vm.visitsOutOfRouteActions;
        vm.collapseOrExpandVisitsOutOfRoute(false);
      }
      routeDesignFilterService.moveToFirstResult(route);
    };

    vm.onRemove = function () {
      vm.searchResults = null;
      routeDesignFilterService.removeResultFromVM(vm);
    };

    vm.onMouseHoverVisit = function (visit, activeFilter, isCurrentVisitFilter) {
      routesUtils.onMouseHoverVisit(
        visit, activeFilter, isCurrentVisitFilter,
        routeDesignFilterService.setHoverActiveAnotherVisit
      );
    };

    vm.onMouseLeaveVisit = function (visit, activeFilter) {
      routesUtils.onMouseLeaveVisit(
        visit, activeFilter,
        routeDesignFilterService.setHoverActiveAnotherVisit
      );
    };

    /////////////////////////////////////////////////////////////
    // END Search Visit And Vehicle
    ////////////////////////////////////////////////////////////

    $scope.$on("Planner:Route:toggleCollapseRoute", function (_, data) {
      var route = data.route;
      toggleCollapseRoute(route);
      if (!$scope.$$phase) {
        $scope.$apply();
      }
    });

    $scope.$on("Planner:Visit:toggleSelectedEditVisit", function (_, data) {
      var visit = data.visit;
      var multipleSelectionMode = data.multipleSelectionMode;
      vm.toggleSelectedEditVisitFromMap(visit, multipleSelectionMode);
      if (!$scope.$$phase) {
        $scope.$apply();
      }
    });

    $scope.$on("Planner:Visit:deselectEditVisit", function (args, data) {
      var visitId = data.visitId;
      var visit = plannerService.visits.find(function (visit) {
        return visit.id === visitId;
      });

      visit.selected = false;
      vm.toggleSelectedEditVisitFromMap(visit);
    });

    $scope.$on('$destroy', function () {
      if (!$state.includes("*.routes")) {
        vm.visitFilterHandler.clear();
      }
      autosaveDraftPlanService.cancelAutoSavePlan();
      vm.filterHandler.clear();

      plannerService.setEditMode(false);
      $scope.$emit('Planner:Reset:InfoBoxContainer');
      vm.searchResults = null;
      eventReturnIsMultipleEditingModeActivated();
      eventSetIsPolygonCreated();
      eventUpdateVehiclesList();

      if (vm.routeStatusCheckDebounceTimer) {
        $timeout.cancel(vm.routeStatusCheckDebounceTimer);
        vm.routeStatusCheckDebounceTimer = null;
      }
      if (vm.toastDebounceTimer) {
        $timeout.cancel(vm.toastDebounceTimer);
        vm.toastDebounceTimer = null;
      }
      if (vm.routes) {
        vm.routes.forEach(function (route) {
          route.setHasManualChanges(false);
        });
        $scope.$emit(EVENT_CLEAR_ROUTES_GROUP_MARKERS);
      }
      updatePlannerIndicators();
    });

    $scope.$on("Planner:Routes:toggleCollapseRoute:clickOnRoute", function (args, data) {
      var route = vm.routes.find(function (route) {
        return route.id === data.route_id;
      });

      if (route) {
        toggleCollapseRoute(route);
        var vehicleElement = document.getElementById("vehicle-list-item-" + data.vehicle_id);
        routesUtils.scrollToElement(vehicleElement);
        $scope.$apply();
      }
    });

    $scope.$on("Planner:Route:moveVisitsToRoute", function (args, data) {
      vm.moveVisitTo(data.vehicle_id, data.route_id);
    });

    var eventReturnIsMultipleEditingModeActivated = $scope.$on('Planner:Plan:returnIsMultipleEditingModeActivated', setIsMultipleEditingModeActivated);

    var eventSetIsPolygonCreated = $scope.$on("Planner:Visit:setIsPolygonCreated", function (_args, data) {
      vm.movedVisitsCollection.polygon = data.isPolygonCreated;
    });

    var eventUpdateVehiclesList = $scope.$on('Planner:UpdateVehicleLists', function () {
      buildDisplayVehiclesList();
      fillMoveToSelect(vm.vehicles);
    });

    activate();

    ///////////////////////////////////////////////

    function setVehiclesAvailability() {
      $rootScope.isLoading = true;
      vehicleAvailabilityService.getAvailability(vm.enableOrganizationSyncService)
        .then(function (response) {
          var vehiclesResponse = response.data;
          var vehicles = plannerService.vehicles;
          vm.vehiclesAvailable = [];
          vehicles.forEach(function (vehicle) {
            var id = vehicle.id;
            if (!vehiclesResponse[id]) {
              return;
            }

            vehicleAvailabilityService.setAvailability(vehicle, vehiclesResponse[id], $scope.isMultiDayRouteEnabled, vm.enableOrganizationSyncService);
            if (!vehicle.availability.isAvailable && !vehicle.active) {
              return;
            }

            if (!vehicle.color) {
              colorAssignerService.addNewVehicleColor(vehicle.id);
              vehicle.setColor(
                colorAssignerService.getVehicleColor(vehicle.id)
              );
            }

            vm.vehiclesAvailable.push(vehicle);
            if (canVehicleBeInterchanged(vehicle)) {
              vm.interchangeableVehicles.push(vehicle);
            }
          });
        })
        .catch(function (error) {
          $log.info(error);
        })
        .finally(function () {
          buildDisplayVehiclesList();
          $rootScope.isLoading = false;
        });
    }

    function activate() {
      vm.selectedVisitsOutOfRouteCount = 0;
      vm.selectedVisitOutOfRoute = {
        load: 0,
        load2: 0,
        load3: 0,
        load4: 0
      };

      vm.searchResults = null;
      vm.enableNotesInRouteDesigner = isEnableNotesInRouteDesigner();
      vm.enableOrganizationSyncService = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_ORGANIZATION_SYNC_SERVICE);
      vm.draftsEnabled = saveDraftPlanService.isEnabled();
      plannerService.backupPlan();
      plannerService.setEditMode(true);
      vm.isEditingPlan = (plannerService.getPlanName() !== null);

      $rootScope.isLoading = true;
      vm.drivers = plannerService.getDrivers();

      vm.customRouteNameConfig = accountConfigsService.getValueByKeyFrom(
        'custom_route_name' ,
        store.get('accountConfigs')
      );
      vm.isMultidayRouteEnabled = accountConfigsService.getValueByKeyFrom(
        'enable_multi_day_routes' ,
        store.get('accountConfigs')
      );
      vm.highlightVisitByWeight = accountConfigsService.getValueNumericByKeyFrom(
        'highlight_visit_by_weight' ,
        store.get('accountConfigs')
      );
      vm.highlightVisitByWeight2 = accountConfigsService.getValueNumericByKeyFrom(
        'highlight_visit_by_weight_2' ,
        store.get('accountConfigs')
      );
      vm.highlightVisitByWeight3 = accountConfigsService.getValueNumericByKeyFrom(
        'highlight_visit_by_weight_3' ,
        store.get('accountConfigs')
      );
      vm.isVisitsOutOfRouteFilterEnabled = accountConfigsService.isConfigEnabled(
        ACCOUNT_CONFIGS.ENABLE_VISITS_OUT_OF_ROUTE_FILTER
      );
      vm.isOrderByVisibilityEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_ORDER_BY_VISIBILITY);
      vm.reorderOnMoveVisitsConfig = accountConfigsService.isConfigEnabled(ENABLE_REORDER_ON_MOVE_VISITS);
      vm.isClientsModuleEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_CLIENTS_MODULE);

      routesUtils.setHighlightConfigurations(vm.highlightVisitByWeight, vm.highlightVisitByWeight2, vm.highlightVisitByWeight3);
      vm.blockVehicleChangeEnabled = accountConfigsService.isConfigEnabled(ENABLE_BLOCK_VEHICLE_CHANGE);
      vm.rebalanceRoutesEnabled = accountConfigsService.isConfigEnabled(ENABLE_REBALANCE_ROUTES);
      vm.enablePickupAndDeliveryMode = accountConfigsService.isConfigEnabled(ENABLE_PICKUP_AND_DELIVERY_MODE);
      vm.isDisableEditProcessedRoutes = accountConfigsService.isConfigEnabled(
        ACCOUNT_CONFIGS.DISABLE_EDIT_FOR_ACTIVE_AND_FINISHED_ROUTES
      );
      vm.shouldCheckRouteStatus = vm.isDisableEditProcessedRoutes || accountConfigsService.isConfigEnabled(
        ACCOUNT_CONFIGS.ENABLE_SAFETY_MODE
      ) || accountConfigsService.isConfigEnabled(
        ACCOUNT_CONFIGS.ENABLE_ENHANCED_SAFETY_MODE
      );
      vm.isMultiDriversConfigEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_MULTI_DRIVERS);
      vm.vehiclesGroupingCriteria = _getVehiclesGroupingCriteria();
      plannerService.getSkills().forEach(function(skill){
        vm.skills[skill.id] = skill;

      });

      addonsService.isAddonEnable(SELLER_MANAGEMENT_ADD_ON_KEY)
        .then(function (isEnabled) {
          vm.isSellerManagementEnabled = isEnabled;
        });

      return plannerService.getPlan()
        .then(successGetPlan)
        .catch(function () {
          $rootScope.isLoading = false;
        }).finally(function () {
          if (vm.draftsEnabled) {
            autosaveDraftPlanService.startAutoSavePlan();
          }
        });

      function successGetPlan(plan) {
        if (plan.visits.length === 0 && plan.routes.length === 0) {
          $state.go('planner.visits-list');
          return;
        }

        if (routesGroupMarkersService.areGroupMarkersEnabled()) {
          $scope.$emit('Planner:Add:boundsChangedEvent');
        }

        vm.startedRoutes = plannerService.getStartedRoutes();
        sessionService.getUser()
          .then(function (user) {
            checkoutJdhEnableConfig(user.account.configs);
          });

        // Do only after retrieve user optimization options
        vm.optimizationOptions = plannerService.localOptimizationOptions;

        plannerService.hideInfoWindow();

        vm.planName = plannerService.getPlanName();

        vm.visitsOutOfRouteActions.collapse = ($stateParams.out_of_route_opened === 'false');
        if (!vm.visitsOutOfRouteActions.collapse) {
          vm.lastExpandedRoute = vm.visitsOutOfRouteActions;
        }
        else if ($stateParams.route_opened) {
          vm.lastExpandedRoute = plannerService.getRouteById($stateParams.route_opened);
        }

        vm.getPlanUnoptimized();

        if (plannerService.vehicles.length > 0) {
          setVehiclesAvailability();
        }

        vm.routes = plannerService.routes;

        vm.planDate = timeUtils.formatTime(plan.planDate.start, FORMAT_DATE);
        vm.shift = plan.shift;

        $timeout(function () {
          $anchorScroll($stateParams.route_opened);
        });
        vm.priorityLevels = plannerService.getPriorityLevels();

        vm.visibleAllRoutes = routesUtils.toggleVisibleAllRoutesHandler(vm.vehicles);
      }
    }

    function _getVehiclesGroupingCriteria() {
      var mainCriterion = function(vehicle) {
        return vehicle.areAllRoutesRevised;
      };
      var mainGroupingCriteria = [
        lodash.negate(mainCriterion),
        mainCriterion
      ];

      if (!vm.isOrderByVisibilityEnabled) {
        return mainGroupingCriteria;
      }

      var secondaryCriterion = function(vehicle) {
        return vehicle.showRoutes;
      };
      var mainAndSecondaryCriterion, mainAndNegatedSecondaryCriterion;
      var composedGroupingCriteria = [];

      mainGroupingCriteria.forEach(function(mainCriterion) {
        mainAndSecondaryCriterion = function(vehicle) {
          return mainCriterion(vehicle) && secondaryCriterion(vehicle);
        };
        mainAndNegatedSecondaryCriterion = function(vehicle) {
          return mainCriterion(vehicle) && !secondaryCriterion(vehicle);
        };
        composedGroupingCriteria.push(mainAndSecondaryCriterion);
        composedGroupingCriteria.push(mainAndNegatedSecondaryCriterion);
      });

      return composedGroupingCriteria;
    }

    function fillCircleOption(route, fill) {
      highlightRoute(route.routeId, fill);
      route.background_color = fill ? route.color : NONE_STRING;
    }

    function highlightRoute(routeId, highlight) {
      var visits;
      if (routeId !== -1) {
        var route = vm.routes.find(function (route) {
          return route.id === routeId;
        });
        if (route) {
          visits = route.visits;
        }
      } else {
        visits = vm.visitsOutOfRouteActions.visits;
      }
      if (visits) {
        visits.forEach(function (visit) {
          visit.setDarkerHighlight(highlight, true);
        });
      }
    }

    function isMovingOutOfRoute(vehicleId, routeId) {
      return vehicleId === -1 && routeId === -1;
    }

    function getOriginalRoute(visit) {
      var routeSrc = vm.routes.filter(vm.getRouteById(visit.routeId))[0];
      var routeId = null;
      if (!routeSrc) {
        routeSrc = vm.routes.find(function (route) {
          return route.vehicleId === visit.vehicle;
        });
        routeId = (routeSrc && routeSrc.id) ? routeSrc.id : null;
      }
      return {'routeSrc': routeSrc, 'routeId': routeId};
    }

    /**
     *
     * @param visitsToMove
     * @param visit
     * @param routeSrc
     * @param routesSrcs
     * @returns {{visit: *, routeSrc: *}}
     */
    function moveVisitOutOfRoute(visitsToMove, visit, routeSrc, routesSrcs) {
      var movedVisitsCount = 0;
      var joinSimilar = vm.optimizationOptions.join;
      var joinSimilarV2 = vm.optimizationOptions.join_v2;
      var similarVisits = [];

      plannerService.setVisitsOutOfRouteAttributes(visitsToMove);

      //Recorro todas las visitas
      for (var k = 0; k < visitsToMove.length; k++) {
        visit = visitsToMove[k];
        if (joinSimilar || joinSimilarV2) {
          similarVisits =  plannerService.visitSimilarGraph.getSimilarByRoute(visit);
        }
        //si la visita pertenece a una ruta
        if (visit.routeId) {
          movedVisitsCount++;
          var originalRoute = getOriginalRoute(visit);
          routeSrc = originalRoute.routeSrc;
          if (originalRoute.routeId) {
            visit.routeId = originalRoute.routeId;
          }

          if (routeSrc) {
            //elimino la visita de la ruta
            routeSrc.removeVisit(visit);
            routeSrc.setHasManualChanges(true);
            //Si la ruta ya esta vacia de visitas la desmarco de editingSelected
            if (routeSrc.visits.length === 0) {
              routeSrc.editingSelected = false;
            }

            //Si la ruta no esta en mi arreglo routesSrcs la inserto
            if (routesSrcs.indexOf(routeSrc) === -1) {
              routesSrcs.push(routeSrc);
            }
          }
          visit.removeIndicatorsErrors();
        } else {
          //Si no tiene ruta, quiere decir que ya esta en "fuera de ruta"
          visit.setSelected(false);
          $rootScope.isLoading = false;
          continue;
        }

        visit.routeId = null;
        visit.setSelected(false);
        visitsMarkersService.showVisitOnMap(visit, vm.showVisitsOutOfRoutes);

        if(similarVisits.length){
          visit.actionUpdate(similarVisits[0]);
        }
        setInVisitsOutOfRouteList(visit);
      }

      vm.visitsOutOfRouteFormattedLoads = statisticsService.calculateVisitsTotalLoads(vm.visitsOutOfRoute, Boolean(
        vm.optimizationOptions.big_cluster));

      vm.movedVisitsCollection.movement_type = MOVEMENT_TO_OUT_OF_ROUTE;
      vm.movedVisitsCollection.number_of_moved_visits = movedVisitsCount;

      return {visit: visit, routeSrc: routeSrc};
    }

    /**
     * Set a visit in visits off route list.
     * If the visit is similar, it will be set together to its similars
     * @param {Object} visit
     */
    function setInVisitsOutOfRouteList(visit) {
      var joinSimilar = plannerService.visitSimilarGraph && (vm.optimizationOptions.join || vm.optimizationOptions.join_v2);
      if (vm.visitsOutOfRoute.length === 0 || !joinSimilar) {
        vm.visitsOutOfRoute.push(visit);
      } else {
        var found = false;
        for (var i = 0; i < vm.visitsOutOfRoute.length; i++) {
          if (plannerService.visitSimilarGraph.isSimilar(vm.visitsOutOfRoute[i], visit)) {
            vm.visitsOutOfRoute.splice(i, 0, visit);
            found = true;
            break;
          }
        }
        if (!found) {
          vm.visitsOutOfRoute.splice(i, 0, visit);
        }
      }
    }

    /**
     *
     * @param visitsToMove
     * @param vehicleDestinationId
     * @param vehicle
     * @param routeDestinationId
     * @param route
     * @param visit
     * @param routeSrc
     * @param routesSrcs
     * @returns {{vehicle: *, route: *, visit: *, routeSrc: *}}
     */
    function moveVisitIntoRoute(visitsToMove, vehicleDestinationId, vehicle, routeDestinationId, route, visit, routeSrc, routesSrcs) {

      if (!visitsToMove.length > 0) {
        return {vehicle: vehicle, route: route, visit: visit, routeSrc: routeSrc};
      }
      var movedVisitsCount = 0;
      var movementBetweenRoutes = false;
      var movementToRoute = false;
      var joinSimilar = vm.optimizationOptions.join;
      var joinSimilarV2 = vm.optimizationOptions.join_v2;
      var similarVisits = [];

      var shouldVisitsBeVisible;

      //por cada vehiculo
      for (var i = 0; i < plannerService.vehicles.length; i++) {
        //Si el vehiculo destino esta en el arreglo de vehiculos
        if (plannerService.vehicles[i].id === vehicleDestinationId) {
          //Lo instancio
          vehicle = plannerService.vehicles[i];

          //por cada ruta
          for (var j = 0; j < vehicle.routes.length; j++) {
            //si la ruta del vehiculo es la ruta destino
            if (vehicle.routes[j].id === routeDestinationId) {
              //Instancio la ruta
              route = vehicle.routes[j];
              shouldVisitsBeVisible = visitsMarkersService.shouldVisitsInRouteBeVisible(route,
                vm.vehiclesToSeeRoutesInDetail);

              //Por cada visita
              for (var m = 0; m < visitsToMove.length; m++) {
                //instancio la visita
                visit = visitsToMove[m];
                //Si esta seleccionada
                if(joinSimilar || joinSimilarV2){
                  similarVisits =  plannerService.visitSimilarGraph.getSimilarByRoute(visit);
                }
                //y la visita pertenece a una ruta
                if (visit.routeId) {
                  if (visit.routeId !== routeDestinationId) {
                    movedVisitsCount++;
                    movementBetweenRoutes = true;
                  }

                  routeSrc = vm.routes.find(function (filterRoute) {
                    var visitFound = filterRoute.visits.find(function (filterVisit) {
                      return visit.id === filterVisit.id;
                    });
                    if (visitFound) {
                      return visitFound;
                    }
                  });
                  if (routeSrc) {
                    routeSrc.removeVisit(visit);
                    routeSrc.setHasManualChanges(true);
                    if (routeSrc.visits.length === 0) {
                      routeSrc.editingSelected = false;
                    }

                    if (routesSrcs.indexOf(routeSrc) === -1) {
                      routesSrcs.push(routeSrc);
                    }
                  }

                } else {
                  //Sino quiere decir que estaba en fuera de ruta
                  movedVisitsCount++;
                  movementToRoute = true;
                  vm.visitsOutOfRoute.splice(vm.visitsOutOfRoute.indexOf(visit), 1);
                  if (vm.visitsOutOfRoute.length === 0) {
                    vm.selectAllVisitsOutOfRoute = false;
                  }
                  vm.visitsOutOfRouteFormattedLoads = statisticsService.calculateVisitsTotalLoads(vm.visitsOutOfRoute,
                    Boolean(vm.optimizationOptions.big_cluster));
                }

                //Evaluamos que la visita que se va a agregar a la ruta de el vehiculo, este habilitada mediante skills para estar en ese vehiculo
                var skillError = vehicle.validateVisitSkills(visit);
                if (skillError) {
                  route.skillsError = true;
                  visit.skillsError = true;
                }

                route.addVisitToRoute(visit);
                route.setHasManualChanges(true);

                visit.setDefaultColor(vehicle.color);
                visit.setSelected(false);
                visitsMarkersService.showVisitOnMap(visit, shouldVisitsBeVisible);

                if (similarVisits.length) {
                  visit.actionUpdate(similarVisits[0]);
                }
              }
              //Ruta encontrado, retornamos
              break;
            }
          }
          //Vehiculo encontrado, retornamos
          break;
        }
      }

      if (movementBetweenRoutes && movementToRoute) {
        vm.movedVisitsCollection.movement_type = MOVEMENT_MIX;
      } else {
        vm.movedVisitsCollection.movement_type = movementToRoute ? MOVEMENT_TO_ROUTE : MOVEMENT_BETWEEN_ROUTES;
      }

      vm.movedVisitsCollection.number_of_moved_visits = movedVisitsCount;

      return {vehicle: vehicle, route: route, visit: visit, routeSrc: routeSrc};
    }

    function recalculateRoutesTimes(routesSrcs) {
      var deferred = $q.defer();
      var promises = routesSrcs.map(function (routeObj) {
        var vehicleSrc = plannerService.vehicles.filter(getVehicleById(routeObj.vehicleId))[0];
        return vm.reorderRouteOnMoveVisits(vehicleSrc, routeObj, vm.optimizationOptions, plannerService);
      });

      $q.all(promises).then(function () {
        deferred.resolve();
      }).catch(function () {
        deferred.reject();
      });

      return deferred.promise;
    }

    function reorderRouteStartingAt(vehicle, route, optimizationOptions, plannerService) {
      var routeIndex = vehicle.routes.indexOf(route);
      var isTheFirstRoute = routeIndex === 0;
      var isTheLastRoute = routeIndex === vehicle.routes.length - 1;
      var planDate = plannerService.getPlanDate().start;
      var vehicleShiftTime = plannerService.getVehicleShiftTime(vehicle);

      return _reorderRoute(route)
        .then(function (routeResponse) {
          routesUtils.adjustRouteTimes(
            routeResponse, isTheFirstRoute, isTheLastRoute, planDate, vehicleShiftTime, optimizationOptions
          );
          return routeResponse.calculatePath(vehicle, optimizationOptions, plannerService.getPlanStartTime(), plannerService.isVehicularRestrictionEnabled());
        })
        .then(function () {
          if (vehicle.routes.length >= 1) {
            return vtcService.callVTC(vehicle, optimizationOptions, plannerService);
          }
        })
        .catch(function (error) {
          $log.info(error);
          Toasts.push('error', $translate('Planner_toast.error_order_route'));
        })
        .finally(function () {
          vehicle.recalculateMetricsAndErrors(plannerService);
          vehicle.updateRouteVisitsAndEvents(plannerService);
        });
    }

    function reorderRouteOnMoveVisits(vehicle, route, optimizationOptions, plannerService) {
      if (vm.reorderOnMoveVisitsConfig) {
        return vm.reorderRouteStartingAt(vehicle, route, optimizationOptions, plannerService);
      }
      return vehicle.recalculateRouteStartingAt(route, optimizationOptions, plannerService);
    }

    function getMovableAndUnmovableVisits(visits) {
      if (!plannerService.shouldValidateEditableRoutes() && !vm.isDisableEditProcessedRoutes) {
        return {
          movableVisits: visits,
          unmovableVisits: []
        };
      }

      var movableVisits = [];
      var unmovableVisits = [];
      visits.forEach(function(visit) {
        if (!plannerService.isRouteEditable(visit.routeId) || plannerService.isVisitFromProcessedRoute(visit)) {
          visit.setSelected(false);
          visit.actionUpdate(visit);
          unmovableVisits.push(visit);
        } else {
          movableVisits.push(visit);
        }
      });
      return {
        movableVisits: movableVisits,
        unmovableVisits: unmovableVisits
      };
    }

    function _showMoveVisitsToast(anyUnmovableVisit, visitsWereMoved) {
      if (anyUnmovableVisit) {
        Toasts.push('error', $translate('Planner_toast.error_move_visits'));
      } else if (visitsWereMoved) {
        Toasts.push('success', $translate('Planner_toast.success_move_visits'));
      }
    }

    /**
     * Moves selected visits to a vehicle-route pair
     * a vehicle can have multiple routes
     * vehicle id = -1 and route id = -1 mean out of route
     * @param vehicleDestinationId id of the vehicle
     * @param routeDestinationId id of the route
     */
    function moveVisitTo(vehicleDestinationId, routeDestinationId) {
      if (!plannerService.isRouteEditableToMoveVisits(routeDestinationId)) {
        Toasts.push("error", $translate("Planner_toast.error_move_visits_to_started_or_finished_route"));
        return;
      }

      vm.isMoveToCollapsed = true;
      $rootScope.isLoading = true;


      // Initializing temporary values
      var move = null;
      // Instance of vehicle to which visits will be moved to in the event of them not being out of route
      var vehicle = {};
      var visit = {};
      // Instance of route to which visits will be moved to in the event of them not being out of route
      var route = {};
      var routeSrc = null;
      // Array of routes to which visits belonged to before being moved
      var routesSrcs = [];
      var selectedVisits = plannerService.getSelectedVisits();
      var movableAndUnmovableVisits = vm.getMovableAndUnmovableVisits(selectedVisits);
      var movableVisits = movableAndUnmovableVisits.movableVisits;
      var unmovableVisits = movableAndUnmovableVisits.unmovableVisits;
      var anyUnmovableVisit = unmovableVisits.length > 0;
      var visitsWereMoved = false;

      if (isMovingOutOfRoute(vehicleDestinationId, routeDestinationId)) {
        move = moveVisitOutOfRoute(movableVisits, visit, routeSrc, routesSrcs);
      } else {
        move = moveVisitIntoRoute(movableVisits, vehicleDestinationId, vehicle, routeDestinationId, route, visit, routeSrc, routesSrcs);
        vehicle = move.vehicle;
        route = move.route;
        // If the visit is moved to a route, new color is assigned to the vehicle only when plan has more than 15 routes
        var vehiclesFromPlan = plannerService.getVehicles().filter(function (vehicle) {
          return vehicle.routes.length;
        });

        if (vm.isNewRoute.includes(vehicleDestinationId)) {
          colorAssignerService.specifyVehicleColorById(vehiclesFromPlan)
          .then(function() {
              vehicle.setRelativePlanColor(
                colorAssignerService.getVehicleColor(vehicle.id),
                true
              );
            fillMoveToSelect(vm.vehicles);
            reAssignAllPlanVehiclesColor(vehiclesFromPlan);
            vm.isNewRoute = vm.isNewRoute.filter(function(id) {
              return id !== vehicleDestinationId;
            });
          });
        }
      }
      vm.movedVisitsCollection.blocked_visits = anyUnmovableVisit;

      if (routesSrcs.length > 0) {
        visitsWereMoved = true;
        vm.recalculateRoutesTimes(routesSrcs)
          .then(function () {
            if (isMovingOutOfRoute(vehicleDestinationId, routeDestinationId)) {
              return  [];
            }

            return vm.reorderRouteOnMoveVisits(vehicle, route, vm.optimizationOptions, plannerService);
          })
          .then(function () {
            if (isMovingOutOfRoute(vehicleDestinationId, routeDestinationId)) {
              routesSrcs.forEach(function (routeObj) {
                routeObj.actionUpdate(routeObj);
              });
            }
            $log.info('Successful recalculation of routes');
          })
          .catch(function (e) {
            $log.error('Failed recalculation of routes', e);
          })
          .finally(function () {
            vm.updatePlannerIndicators();
            buildDisplayVehiclesList();
            $rootScope.isLoading = false;
            _showMoveVisitsToast(anyUnmovableVisit, visitsWereMoved);
          });
      } else {
        if (vehicleDestinationId !== -1 && routeDestinationId !== -1 && movableVisits.length > 0) {
          visitsWereMoved = true;
          vm.reorderRouteOnMoveVisits(vehicle, route, vm.optimizationOptions, plannerService)
            .then(function () {
              $log.info('Successful recalculation of routes (out of route case)');
            })
            .catch(function () {
              $log.info('Failed recalculation of routes');
            })
            .finally(function () {
              vm.updatePlannerIndicators();
              buildDisplayVehiclesList();
              $rootScope.isLoading = false;
              _showMoveVisitsToast(anyUnmovableVisit, visitsWereMoved);
            });
        } else {
          vm.updatePlannerIndicators();
          buildDisplayVehiclesList();
          $rootScope.isLoading = false;
          _showMoveVisitsToast(anyUnmovableVisit, visitsWereMoved);
        }
      }


      vm.selectedVisitsOutOfRouteCount = 0;
      vm.selectedVisitOutOfRoute = {
        load: 0,
        load2: 0,
        load3: 0,
        load4: 0
      };
      $rootScope.$broadcast('Planner:Reset:InfoBoxContainer');
      vm.showOrRemoveNotification(null, true);
      vm.filterHandler.activeFilter && routeDesignFilterService.applyResultToVM(vm, vm.searchResults);
      if (vm.visitFilterHandler.activeFilter) {
        vm.filterVisitsOutOfRoute(vm.visitFilterHandler.minSliderTime, vm.visitFilterHandler.maxSliderTime);
      }
    }

    function reAssignAllPlanVehiclesColor (vehiclesFromPlan) {

      if (!colorAssignerService.getMustUpdateColor()) {
          return;
      }
      vehiclesFromPlan.forEach(function(vehicle) {
          var newColor = colorAssignerService.getVehicleColor(vehicle.id);
          if (vehicle.color !== newColor) {
            vehicle.setRelativePlanColor(newColor, true);
          }
      });
      fillMoveToSelect(vm.vehicles);
      colorAssignerService.setMustUpdateColor(false);
    }

    function updatePlannerIndicators() {
      $scope.$emit("Planner:Plan:recalculate-statistics");
    }

    function getPlanUnoptimized() {
      vm.vehicles = plannerService.vehicles.filter(function (vehicle) {
        return vehicle.routes.length;
      });

      fillMoveToSelect(vm.vehicles);
      vm.visitsOutOfRoute = plannerService.getVisitsOutOfRoute(plannerService.getVisits());
      vm.visitsOutOfRoute = plannerService.setVisitsOutOfRouteAttributes(vm.visitsOutOfRoute);

      vm.visitsOutOfRouteFormattedLoads = statisticsService.calculateVisitsTotalLoads(vm.visitsOutOfRoute, Boolean(
        vm.optimizationOptions.big_cluster));
      vm.showVisitsOutOfRoutes = vm.vehiclesToSeeRoutesInDetail[VISIT_OUT_OF_ROUTE_VISUAL_STATE_ID];

      createMapElements();

      vm.updatePlannerIndicators();
      $rootScope.isLoading = false;
    }

    function createMapElements() {
      var shouldShowMapElements;
      var areVisible = true;
      var mustUpdate = false;

      vm.vehicles.forEach(function (vehicle) {
        shouldShowMapElements = vm.vehiclesToSeeRoutesInDetail[vehicle.id];
        _createVehicleDepots(vehicle, shouldShowMapElements, areVisible, mustUpdate);

        vehicle.routes.forEach(function (route) {
          _createRouteVector(route, shouldShowMapElements, areVisible, mustUpdate);

          if (!$rootScope.drawCluster && vm.areVisitsMarkersVisible.status) {
            _updateVisitsMarkers(route, shouldShowMapElements, !routesGroupMarkersService.areGroupMarkersEnabled(),
              mustUpdate);
          }
        });
      });

      _updateVisitsMarkers(vm.visitsOutOfRouteActions, vm.showVisitsOutOfRoutes, areVisible, mustUpdate);
    }

    function _createVehicleDepots(vehicle, shouldShowDepots, areVisible, mustUpdate) {
      var mustUpdateVehicleVisible = shouldShowDepots && !vehicle.options.visible;
      if (mustUpdateVehicleVisible) {
        vehicle.setVisible(areVisible, vm.optimizationOptions.open_ended, mustUpdate);
        vehicle.setIconFillColorWithVehicleColor(mustUpdate);
      }

      var mustUpdateVehicleOpacity = mustUpdateVehicleVisible || vehicle.areAllRoutesRevised;
      if (mustUpdateVehicleOpacity) {
        var opacity = revisedRoutesService.getVehicleOpacity(vehicle);
        vehicle.setOpacity(opacity, mustUpdate);
      }

      if (mustUpdateVehicleVisible || mustUpdateVehicleOpacity) {
        vehicle.actionUpdate(vehicle);
      }
    }

    function _createRouteVector(route, shouldShowRoute, isVisible, mustUpdate) {
      route.actionCreate(route);
      route.areVisitsMarkersVisible = !routesGroupMarkersService.areGroupMarkersEnabled();

      if (route.isRevised && !route.collapse) {
        _collapseRoute(route);
        vm.lastExpandedRoute = null;
      }

      var mustUpdateRouteOpacity = (route.stroke.opacity !== ROUTE_VISIBLE_OPACITY) || route.isRevised;
      if (mustUpdateRouteOpacity) {
        var opacity = revisedRoutesService.getRouteOpacity(route);
        route.setOpacity(opacity, mustUpdate);
      }

      var mustUpdateRouteVisible = shouldShowRoute && !route.visible;
      if (mustUpdateRouteVisible) {
        route.setVisible(isVisible, mustUpdate);
      }

      if (mustUpdateRouteOpacity || mustUpdateRouteVisible) {
        route.actionUpdate(route);
      }
    }

    function _updateVisitsMarkers(route, shouldShowMarkers, areVisible, mustUpdate) {
      var visits = route.visits;
      if (!visits.length || !shouldShowMarkers) {
        return;
      }

      var mustUpdateVisitsOpacity = route.isRevised;
      if (mustUpdateVisitsOpacity) {
        visitsMarkersService.setOpacityInVisits(visits, ROUTE_REVISED_OPACITY, mustUpdate);
      }

      var mustUpdateVisitsVisible = (visits[0].options.visible !== areVisible);
      if (mustUpdateVisitsVisible) {
        visitsMarkersService.setVisibleInVisits(visits, areVisible, mustUpdate);
      }

      var mustUpdateVisitsMarkersSize = areVisible && !$rootScope.isHighDemandRouteDesigner && route.collapse;

      if (mustUpdateVisitsOpacity || mustUpdateVisitsVisible || mustUpdateVisitsMarkersSize) {
        if (areVisible) {
          visitsMarkersService.createVisitsOnMap(visits);
        } else {
          visitsMarkersService.removeVisitsOnMap(visits);
        }
      }
    }

    function toggleCollapseRoute(route) {
      if (route.isRevised) {
        return;
      }

      var mustCollapseRoute = !route.collapse;
      var mustCollapseLastRoute = !mustCollapseRoute && vm.lastExpandedRoute && !vm.lastExpandedRoute.collapse;
      var routesVehicleId = parseInt(route.vehicleId);

      if (mustCollapseLastRoute) {
        _collapseRoute(vm.lastExpandedRoute);
      }

      route.setVisitsListed(!mustCollapseRoute);
      route.collapse = mustCollapseRoute;

      if (visitsMarkersService.shouldUpdateMarkersWhenCollapsingRoute(route, vm.vehiclesToSeeRoutesInDetail)) {
        var visitsAreVisible = visitsMarkersService.shouldVisitsInRouteBeVisible(route, vm.vehiclesToSeeRoutesInDetail);
        visitsMarkersService.updateVisitsOnMap(route.visits, visitsAreVisible);
      }

      if (mustCollapseRoute) {
        vm.lastExpandedRoute = null;
      } else {
        vm.lastExpandedRoute = route;
        vm.filterHandler.activeFilter && routeDesignFilterService.moveToFirstResult(route);
        _checkRouteStatusOnExpand(route);
      }

      if (!$rootScope.drawCluster) {
        var vehiclesToUpdate = vm.vehicles.filter(function (vehicle) {
          var vehicleId = parseInt(vehicle.id);
          if (routesVehicleId === vehicleId && vm.vehiclesToSeeRoutesInDetail[vehicleId] && !vehicle.options.visible) {
            vehicle.setVisible(true, vm.optimizationOptions.open_ended);
            return;
          }
          return vehicleId !== routesVehicleId && vm.vehiclesToSeeRoutesInDetail[vehicleId];
        });
        plannerService.setVisibleInVehicles(vehiclesToUpdate, mustCollapseRoute, vm.optimizationOptions.open_ended);
      }
    }

    function _collapseRoute(route) {
      route.collapse = true;
      route.setVisitsListed(false);

      if (visitsMarkersService.shouldUpdateMarkersWhenCollapsingRoute(route, vm.vehiclesToSeeRoutesInDetail)) {
        var visitsAreVisible = visitsMarkersService.shouldVisitsInRouteBeVisible(route, vm.vehiclesToSeeRoutesInDetail);
        visitsMarkersService.updateVisitsOnMap(route.visits, visitsAreVisible);
      }
    }

    function _checkRouteStatusOnExpand(route) {
      if (!vm.isEditingPlan || !vm.shouldCheckRouteStatus) {
        return;
      }

      var planId = plannerService.getPlanId();
      if (!planId) {
        return;
      }

      if (vm.routeStatusCheckDebounceTimer) {
        $timeout.cancel(vm.routeStatusCheckDebounceTimer);
        vm.routeStatusCheckDebounceTimer = null;
      }

      vm.routeStatusCheckDebounceTimer = $timeout(function() {
        planService.getRoutesStatus(planId)
          .then(function(response) {
            _handleRoutesStatusResponse(response, route);
          })
          .catch(function(error) {
            $log.error(error);
            Toasts.push('error', $translate('Planner_toast.error_check_routes_status'));
          });
        vm.routeStatusCheckDebounceTimer = null;
      }, ROUTE_STATUS_CHECK_DEBOUNCE);
    }

    function _handleRoutesStatusResponse(response, expandedRoute) {
      vm.routes.forEach(function(route) {
        var routeId = route.id;
        var newStatus = response.routes_status[routeId];

        route.status = newStatus;
        route.isLocked = response.locked_route_ids.includes(routeId);
        route.lockedDueToStatus = response.locked_due_to_started_or_finished.includes(routeId);
        route.lockedDueToVisits = response.locked_due_to_checked_out_visits.includes(routeId);
      });

      if (expandedRoute) {
        var messageKey = _getRouteStatusAlertMessageKey(expandedRoute);
        messageKey && _showToastWithDebounce(messageKey);
      }
    }

    function _getRouteStatusAlertMessageKey(route) {
      // If the route is not locked, check the status
      if (!route.isLocked) {
        switch (route.status) {
          case 'started':
            return 'Routes.warning.started';
          case 'completed':
            return 'Routes.warning.finished';
          case 'finished':
            return 'Routes.warning.finished';
          default:
            return null;
        }
      }

      // If the route is locked, prioritize the reasons
      if (route.lockedDueToStatus) {
        return route.status === 'started'
          ? 'Routes.warning.started'
          : 'Routes.warning.finished';
      }
      if (route.lockedDueToVisits) {
        return 'Routes.warning.finished';
      }

      return null;
    }

    function _showToastWithDebounce(messageKey) {
      var message = $translate(messageKey);

      if (vm.lastToastMessage === message && vm.toastDebounceTimer) {
        return;
      }

      if (vm.toastDebounceTimer) {
        $timeout.cancel(vm.toastDebounceTimer);
      }

      vm.lastToastMessage = message;

      vm.toastDebounceTimer = $timeout(function() {
        Toasts.removeAll();
        Toasts.push('warning', message);
        vm.lastToastMessage = null;
        vm.toastDebounceTimer = null;
      }, ROUTE_STATUS_TOAST_DEBOUNCE);
    }

    function toggleEditingVisitsOfRoute(route) {
      var toggledVisits = [];
      route.visits.forEach(function (visit) {
        if (visit.selected !== route.editingSelected) {
          visit.setSelected(route.editingSelected, true);
          toggledVisits.push(visit);
        }
      });

      _updateToggledVisitsInInfoBox(vm.isMultipleEditingModeActivated, toggledVisits);
    }

    function collapseOrExpandVisitsOutOfRoute(mustCollapseList) {

      vm.visitsOutOfRouteActions.collapse = mustCollapseList;
      var mustCollapseLastRoute = !mustCollapseList && vm.lastExpandedRoute && !vm.lastExpandedRoute.collapse;

      if (mustCollapseLastRoute && vm.lastExpandedRoute && vm.lastExpandedRoute.id !== VISITS_OUT_OF_ROUTE_LIST_ID) {
        _collapseRoute(vm.lastExpandedRoute);

        var vehiclesToUpdate = vm.vehicles.filter(function (vehicle) {
          var vehicleId = parseInt(vehicle.id);
          return vm.vehiclesToSeeRoutesInDetail[vehicleId];
        });
        plannerService.setVisibleInVehicles(vehiclesToUpdate, true, vm.optimizationOptions.open_ended);
      }

      if (visitsMarkersService.shouldUpdateMarkersWhenCollapsingRoute(vm.visitsOutOfRouteActions,
        vm.vehiclesToSeeRoutesInDetail)) {
        visitsMarkersService.updateVisitsOnMap(vm.visitsOutOfRouteActions.visits, vm.showVisitsOutOfRoutes);
      }

      vm.lastExpandedRoute = !mustCollapseList ? vm.visitsOutOfRouteActions : null;
    }

    function toggleSelectAllVisitsOutOfRoute() {
      var toggledVisits = [];
      var visits = vm.visitsOutOfRouteActions.visits;
      var loads = {
        load: 0,
        load2: 0,
        load3: 0,
        load4: 0
      };

      visits.forEach(function (visit) {
        if (vm.selectAllVisitsOutOfRoute) {
          loads.load += visit.load;
          loads.load2 += visit.load2;
          loads.load3 += visit.load3;
          loads.load4 += visit.load4;
        }

        visit.setSelected(vm.selectAllVisitsOutOfRoute, true);
        toggledVisits.push(visit);
      });

      vm.selectedVisitOutOfRoute = {
        load: loads.load,
        load2: loads.load2,
        load3: loads.load3,
        load4: loads.load4
      };

      _updateToggledVisitsInInfoBox(vm.isMultipleEditingModeActivated, toggledVisits);
      vm.selectedVisitsOutOfRouteCount = vm.selectAllVisitsOutOfRoute ? visits.length : 0;
    }

    function addRouteToVehicle(vehicle) {
      var route = plannerService.createRoute(vehicle.id);
      route.setHasManualChanges(true);
      route.areVisitsMarkersVisible = !routesGroupMarkersService.areGroupMarkersEnabled();

      var isVehicleInCurrentPlan = vm.vehicles.some(findVehicle(vehicle));
      if (!isVehicleInCurrentPlan) {
        vehicle = plannerService.vehicles.find(findVehicle(vehicle));
        vm.isNewRoute.push(vehicle.id);
        vehicle.activate();
        vehicle.showRoutes = true;
        updateVehiclesToSeeRoutesInDetail(vehicle.showRoutes, vehicle.id);

        vehicle.setIconFillColorWithVehicleColor(false);
        vehicle.setVisible(true, vm.optimizationOptions.open_ended, false);
        vehicle.actionUpdate(vehicle);

        vm.vehicles.push(vehicle);
        vm.planVehicleHaveBeenUpdated = true;
      }

      if (vehicle.routes.length > 0) {
        var lastRoute = vehicle.routes[vehicle.routes.length - 1];
        route.comment = lastRoute.comment;
        route.estimatedTimeStart = lastRoute.estimatedTimeEnd;
      } else {
        var currentDateTime = plannerService.planDate.start + 'T' + vehicle.shift.start;
        var estimatedTime = vm.moment(currentDateTime).format('YYYY-MM-DDTHH:mm');
        route.estimatedTimeStart = estimatedTime;
        route.estimatedTimeEnd = estimatedTime;
      }

      vehicle.addRoute(route);
      vehicle.collapseRoutes = false;
      vehicle.areAllRoutesRevised = false;
      route.actionCreate(route);

      vm.updatePlannerIndicators();
      buildDisplayVehiclesList();

      fillMoveToSelect(vm.vehicles);

      function findVehicle(vehicleToFind) {
        return function (vehicle) {
          return vehicle.id === vehicleToFind.id;
        };
      }
    }

    function _reorderRoute(route, shouldSendPrioritizeLoad) {
      if (route.visits.length === 0) {
        return $q.when(route);
      }

      var isJDH = vm.enableJdhConfigAccount;
      var visits = plannerService.getVisits();
      var vehicle = plannerService.getVehicleById(route.vehicleId);
      var optimizationOptions = Object.assign(
        {},
        vm.optimizationOptions,
        {
          country: store.get("country"),
        }
      );

      if (shouldSendPrioritizeLoad === true) {
        optimizationOptions.prioritize_load = true;
      }

      var planDate = plannerService.getPlanDate();
      var planInHours = timeUtils.diff(planDate.end, planDate.start, 'hours');

      var params = {
        optimizationOptions: optimizationOptions,
        isJDH: isJDH,
        longRoutes: $scope.isMultiDayRouteEnabled,
        planDate: planDate,
        planInHours: planInHours,
        isReorderOnMoveVisitsEnabled: vm.reorderOnMoveVisitsConfig,
        isVehicularRestrictionEnabled: plannerService.isVehicularRestrictionEnabled()
      };

      var areVisitsVisible = visitsMarkersService.shouldVisitsInRouteBeVisible(route, vm.vehiclesToSeeRoutesInDetail);
      return optimizeService.reorderRoute(vehicle, route, visits, params, areVisitsVisible)
        .then(function (response) {
          var routeResponse = response.route;
          plannerService.addOptimizationId(response.optimizationId);
          routeResponse.setHasManualChanges(false);
          plannerService.clearTotalArrivalsCachedByRoute(route.id);
          return routeResponse;
        });
    }

    function reorderRoute(route, shouldSendPrioritizeLoad) {
      route.isOptionsMenuOpen = false;
      $rootScope.isLoading = true;

      return _reorderRoute(route, shouldSendPrioritizeLoad)
        .then(function (routeResponse) {
          var vehicle = plannerService.vehicles.filter(getVehicleById(routeResponse.vehicleId))[0];
          return vehicle.recalculateRouteStartingAt(routeResponse, vm.optimizationOptions, plannerService);
        })
        .then(function () {
          // Update the list of visits out of route after the reordering
          vm.visitsOutOfRoute = plannerService.getVisitsOutOfRoute(plannerService.getVisits());
          vm.visitsOutOfRoute = plannerService.setVisitsOutOfRouteAttributes(vm.visitsOutOfRoute);
          vm.visitsOutOfRouteFormattedLoads = statisticsService.calculateVisitsTotalLoads(vm.visitsOutOfRoute, Boolean(vm.optimizationOptions.big_cluster));
        })
        .catch(function (error) {
          $log.info(error);
          Toasts.push('error', $translate('Planner_toast.error_order_route'));
        })
        .finally(function () {
          vm.updatePlannerIndicators();
          buildDisplayVehiclesList();
          $rootScope.isLoading = false;
        });
    }

    function setIsMultipleEditingModeActivated(event, data) {
      vm.isMultipleEditingModeActivated = data.isMultipleEditingModeActivated;
      if (data.selectedVisits.length) {
        _updateToggledVisitsInInfoBox(vm.isMultipleEditingModeActivated, data.selectedVisits);
      }
    }

    function toggleSelectedEditVisit(visit, deselectSimilar) {
      var matchVisits = [];
      var route = null;

      if (visit.selected || deselectSimilar) {
        //Obtenemos las visitas a las que se hizo click para editar
        // y se seleccionan las similares si la opcion de unir similares esta activa
        if (vm.optimizationOptions.join || vm.optimizationOptions.join_v2) {
          matchVisits = plannerService.visitSimilarGraph.getSimilarByRoute(visit);
          matchVisits.forEach(function (visitObj) {
            visitObj.setSelected(visit.selected, true);
          });
        }
      }

      if (visit.routeId) {
        route = plannerService.routes.filter(vm.getRouteById(visit.routeId))[0];
        if (route) {
          route.editingSelected = route.visits.every(function (visit) {
            return visit.selected;
          });
        }
      }

      visit.setSelected(visit.selected, true);
      var allVisitsToViewInfoBox = matchVisits.concat(visit);
      _updateToggledVisitsInInfoBox(vm.isMultipleEditingModeActivated, allVisitsToViewInfoBox);
    }

    function openInfoBox(visits) {
      visits.forEach(function (visit) {
        vm.sendToInfoBox(visit);
      });
    }

    function goToDeleteRoute(ev, vehicle, route, routeIndex) {
      if (ev) {
        ev.stopPropagation();
      }

      route.isOptionsMenuOpen = false;
      if (route.visits.length > 0) {
        var template = ROUTES_MODALS_FOLDER_PATH + 'delete-route-modal/delete-route-modal.html';
        $scope.deleteRoute = deleteRoute;
        $scope.vehicle = vehicle;
        $scope.route = route;
        $scope.routeName = vm.getRouteName(route, routeIndex);
        ngDialog.open({
          template: template,
          scope: $scope
        });
      } else {
        deleteRoute(vehicle, route);
      }
    }

    function cancelEditing() {
      plannerService.restorePlan();
      plannerService.saveDraftPlan();
      plannerService.clearMapRoutes();
      plannerService.clearRoutesOnMapCache();
      plannerService.clearTotalArrivalsCached();
      clearSelectedRoutesAndVisits();
      fillVisitsOutRoute();
      alertNotificationService.removeAlertNotification();
      plannerService.routes.forEach(function (obj) {
        obj.collapse = true;
      });
      plannerService.setEditMode(false);
      plannerService.setUserVisualState(vm.vehiclesToSeeRoutesInDetail);
      plannerService.updateVehicleRouteVisitsAndEvents();
      $state.go('planner.routes', {
        vehicle_sort_key: vm.vehicleSortKey,
        comingFromEditMode: true
      });
    }

    function confirmEditingChanges() {
      var isThereRouteWithManualChanges = vm.routes.some(function (route) {
        return route.hasManualChanges;
      });

      $q.when()
        .then(function () {
          if (isThereRouteWithManualChanges) {
            return openReoptimizerModal();
          }
          else {
            return $q.when(MODAL_CONTINUE_OPTION);
          }
        })
        .then(function (response) {
          if (response === MODAL_REOPTIMIZER_OPTION) {
            return vm.reorderEditedRoutes().then(function () {
              return response;
            });
          }
          return response;
        }).then(function (response) {
          if (response !== MODAL_CANCEL_OPTION){
            vm.visitsOutOfRouteActions.collapse = true;
            plannerService.saveDraftPlan();
            exitEditMode();
          }
        });
    }

    function openReoptimizerModal() {
      var template = ROUTES_MODALS_FOLDER_PATH + 'reoptimizer-modal/reoptimizer-modal.html';
      var dialog = ngDialog.open({
        template: template,
        controllerAs: 'vm',
        controller: 'ReoptimizerModal'
      });
      return dialog.closePromise.then(function (response) {
        return response.value;
      });
    }

    /**
     * It saves the draft plan and starts the autosave process
     * @returns a function.
     */
    function confirmEditingChangesForSaveDraftPlan() {
      $rootScope.isLoading = true;
      if (autosaveDraftPlanService.isSaveDraftProcessRunning()) {
        $rootScope.isLoading = false;
        return;
      }

      autosaveDraftPlanService.setSaveDraftProcessRunning(true);
      plannerService.saveDraftPlan().finally(function () {
        autosaveDraftPlanService.setSaveDraftProcessRunning(false);
        $rootScope.isLoading = false;
      });

      autosaveDraftPlanService.startAutoSavePlan();
    }

    function toggleSelectedEditVisitFromMap(visit, multipleSelectionMode) {
      if (angular.isUndefined(multipleSelectionMode)) {
        multipleSelectionMode = false;
      }

      if (visit.routeId) {
        var route = plannerService.routes.filter(vm.getRouteById(visit.routeId))[0];
        if (route) {
          route.editingSelected = route.visits.every(function (visit) {
            return visit.selected;
          });
        }
      } else {
        vm.selectAllVisitsOutOfRoute = vm.visitsOutOfRouteActions.visits.every(function (visit) {
          return visit.selected;
        });
      }

      visit.setSelected(visit.selected, true);
      if (multipleSelectionMode) {
        var visitsAndRoutesSelected = vm.getVisitsAndRoutesSelected();
        vm.showOrHideSelectedNotification(visitsAndRoutesSelected, multipleSelectionMode);
      } else {
        vm.sendToInfoBox(visit);
      }

      if (!visit.routeId) {
        if (visit.selected) {
          vm.selectedVisitsOutOfRouteCount++;
        } else {
          vm.selectedVisitsOutOfRouteCount--;
        }
      }
    }

    /////////////////////////////////////////////////////////////
    // Private methods
    ////////////////////////////////////////////////////////////

    function sendToInfoBox(visit) {
      var routeIndex, routeObj;

      if (visit.routeId) {
        routeIndex = plannerService.getRouteIndex(plannerService.getVehicleRoutes(visit.vehicle), visit.routeId);
        routeObj = plannerService.getRouteObjById(visit.routeId);
      }

      $rootScope.$broadcast("Planner:AddVisitInfoBoxContainer:Visit", {
        visitObj: visit,
        color: visit.defaultColor,
        notes: vm.enableNotesInRouteDesigner ? visit.notes : '',
        routeName: routeObj && routeIndex ? vm.getRouteName(routeObj, routeIndex) : '',
        priorityLevel: visit.priorityLevel ? vm.priorityLevels[visit.priorityLevel - 1] : {value: 0},
        vehicleName: plannerService.getVehicleName(visit.vehicle),
      });
    }

    function getVisitsAndRoutesSelected() {
      var response = {
        visits: 0,
        routes: 0,
        load: 0,
        load2: 0,
        load3: 0,
        load4: 0
      };
      var routes = [];
      var visits = plannerService.getVisits();
      for (var i = 0; i < visits.length; i++) {
        if (visits[i].selected) {
          response.visits += 1;
          response.load += visits[i].load;
          response.load2 += visits[i].load2;
          response.load3 += visits[i].load3;
          response.load4 += visits[i].load4;
          if (visits[i].routeId) {
            if (routes.indexOf(visits[i].routeId) === -1) {
              response.routes += 1;
              routes.push(visits[i].routeId);
            }
          }
        }
      }
      return response;
    }


    function showOrHideSelectedNotification(selected, multipleSelectionMode) {
      var msg = null;
      if (selected.visits > 0) {
        var loadString = selected.load > 0 ? $translate('Routes.load1') + ':' + ' ' + selected.load : '';
        var load2String = selected.load2 > 0 ? $translate('Routes.load2') + ':' + ' ' + selected.load2 : '';
        var load3String = selected.load3 > 0 ? $translate('Routes.load3') + ':' +  ' ' + selected.load3 : '';
        var load4String = selected.load4 > 0 ? $translate('Routes.load4') + ':' +  ' ' + selected.load4 : '';
        msg = {
          type: 1,
          msg: selected.visits + ' ' + $translate('Routes.visits_and') + ' ' + selected.routes + ' ' + $translate('Routes.selected_routes'),
          load: loadString,
          load2: load2String,
          load3: load3String,
          load4: load4String
        };
      } else {
        // When there are no visits selected in multiple
        // selection mode, reset the polygon value
        vm.movedVisitsCollection.polygon = false;
      }

      vm.showOrRemoveNotification(msg, multipleSelectionMode);
    }

    function showOrRemoveNotification(msg, multipleSelectionMode) {
      if (multipleSelectionMode) {
        $scope.$emit('Planner:Plan:ShowAlertMSC', {msg: msg});
      }
    }

    function getVehicleById(vehicleId) {
      return function (vehicle) {
        return vehicle.id === vehicleId;
      };
    }

    function getRouteById(routeId) {
      return function (route) {
        return route.id === routeId;
      };
    }

    function fillMoveToSelect(vehicles) {

      vm.revisedRoutes = [];
      vm.moveToOptions = [];

      vehicles.forEach(function (vehicle) {
        vehicle.routes.forEach(function (route, index) {
          var option = {
            name: [vehicle.name, ' -- ', vm.getRouteName(route, index + 1)].join(''),
            vehicleId: vehicle.id,
            routeId: route.id,
            background_color: NONE_STRING
          };
          if (vm.isDisableEditProcessedRoutes && ROUTE_FINISHED_STATUSES.includes(route.status)) {
            return;
          }
          if (route.isRevised) {
            option.color = NONE_STRING;
            vm.revisedRoutes.push(option);
          } else {
            option.color = vehicle.color;
            vm.moveToOptions.push(option);
          }
        });
      });
    }

    function exitEditMode() {
      clearSelectedRoutesAndVisits();
      alertNotificationService.removeAlertNotification();
      plannerService.routes.forEach(function (obj) {
        obj.collapse = true;
      });
      plannerService.setEditMode(false);
      plannerService.setUserVisualState(vm.vehiclesToSeeRoutesInDetail);
      plannerService.setBackupData({}, {}, {});
      plannerService.setOptimizationResults([]);
      if(vm.planVehicleHaveBeenUpdated) {
        statisticsService.updateTotalVehiclesCapacity(vm.vehicles);
      }
      $state.go('planner.routes', {
        vehicle_sort_key: vm.vehicleSortKey,
        comingFromEditMode: true
      });
    }

    function clearSelectedRoutesAndVisits() {
      vm.selectAllVisitsOutOfRoute = false;
      plannerService.visits.forEach(function (visit) {
        visit.setSelected(false, true, false);
      });

      plannerService.routes.forEach(function (route) {
        route.editingSelected = false;
      });

      if (vm.optimizationOptions.big_cluster) {
        $rootScope.$broadcast('Planner:Clear:Map');
      }
    }

    function checkoutJdhEnableConfig(configs) {
      configs.forEach(function (config) {
        if (config.key === 'enable_jdh') {
          vm.enableJdhConfigAccount = config.value;
        }
      });
    }

    function droppedListener(eventObj) {
      $timeout(function () {
        if (eventObj.dest.index === eventObj.source.index) {
          return;
        }

        $rootScope.isLoading = true;

        var route = eventObj.dest.nodesScope.$parent.route;

        route.setHasManualChanges(true);

        var updatedVisitsAndEvents = eventObj.dest.nodesScope.$modelValue;
        var currentVisit = updatedVisitsAndEvents[eventObj.dest.index];


        if (currentVisit.type === VISIT_TYPE.VISIT) {
          route.updateVisits(updatedVisitsAndEvents);
        } else {
          var eventByRoute = plannerService.getRestTimeByRouteId(route.id);

          eventByRoute.order = eventObj.dest.index;
          eventByRoute.startTime = START_TIME_WINDOW;
          eventByRoute.endTime = END_TIME_WINDOW;

          plannerService.setRestTimeByRouteId(route.id, eventByRoute);
        }

        vm.movedVisitsCollection.movement_type = MOVEMENT_INSIDE_ROUTE;
        vm.movedVisitsCollection.number_of_moved_visits = NUMBER_OF_MOVED_VISITS_INSIDE_ROUTE;

        var vehicle = eventObj.dest.nodesScope.$parent.$parent.vehicle;

        vehicle.recalculateRouteStartingAt(route, vm.optimizationOptions, plannerService)
          .catch(function (fail) {
            $log.info(fail);
          })
          .finally(function () {
            vm.updatePlannerIndicators();
            buildDisplayVehiclesList();
            $rootScope.isLoading = false;
          });

        delete plannerService.totalArrivalsCache[route.id];
      });
    }

    function acceptListener(sourceNodes, destNodes, destIndex) {
      var sourceVisit = sourceNodes.$modelValue;
      var visitsAndEvents = destNodes.$modelValue;
      var destinationVisit = visitsAndEvents[destIndex];

      if (sourceVisit.type === VISIT_TYPE.EVENT && (vm.optimizationOptions.join || vm.optimizationOptions.join_v2)) {
        var previousVisit = destIndex > 0 ? visitsAndEvents[destIndex - 1] : null;

        if (previousVisit &&  plannerService.visitSimilarGraph.isSimilar(destinationVisit, previousVisit)) {
          return false;
        }

        var nextVisit = destIndex < (visitsAndEvents.length - 1) ? visitsAndEvents[destIndex + 1] : null;

        if (nextVisit &&  plannerService.visitSimilarGraph.isSimilar(destinationVisit, nextVisit)) {
          return false;
        }
      }

      var routeStatus = destNodes.$element.attr("route-in-drag-status");
      var isRouteProcessed = plannerService.isRouteProcessed({status: routeStatus});
      var destType = destNodes.$element.attr("data-type");

      if (!isRouteProcessed) {
        return "visit" === destType;
      }

      var isDestinationVisitRouteProcessed = plannerService.isRouteProcessed(
        plannerService.getRouteObjById(destinationVisit.sourceRouteId)
      );

      if (destIndex === 0 && isDestinationVisitRouteProcessed) {
        return false;
      }

      var isPreviusVisitRouteProcessed = plannerService.isRouteProcessed(
        plannerService.getRouteObjById(visitsAndEvents[destIndex - 1].sourceRouteId)
      );

      if (isPreviusVisitRouteProcessed && isDestinationVisitRouteProcessed) {
        return false;
      }

      return "visit" === destType;
    }

    function dragStartListener(event) {
      vm.node.isDraggin = true;
      vm.node.nodeFrom = event.source.nodesScope.$parent.$id;
    }

    function dragMoveListener(event) {
      var elemDest = event.dest.nodesScope.$element[0];
      var elem = event.elements.dragging[0];
      var destOffsetTop = elemDest.offsetTop;
      var elemOffsetTop = elem.offsetTop;
      var height = elemDest.clientHeight;
      var position = elemOffsetTop;
      if ((position > vm.node.position + 5) || (position < vm.node.position - 5)) {
        if ((elemOffsetTop) > destOffsetTop + height + 30) {
          elemDest.scrollTop += 60;
        } else if ((elemOffsetTop - destOffsetTop) < 30) {
          elemDest.scrollTop -= 60;
        }
        vm.node.position = position;
      }
    }

    function dragStopListener(event) {
      vm.node.isDraggin = false;
      vm.node.position = 0;
      $timeout.cancel(dragTimeOut);
    }

    function deleteRoute(vehicle, route) {
      $rootScope.isLoading = true;
      plannerService.setBackupRoute(route);
      if (route.visits.length > 0) {
        route.visits.forEach(function (visit) {
          if (vm.visitsOutOfRoute.indexOf(visit) === -1) {
            visit.routeId = null;
            visit.setDefaultColor(VISIT_OUT_OF_ROUTE_DEFAULT_COLOR);
            visit.updateOrder(VISIT_OUT_OF_ROUTE_ORDER, false);
            visitsMarkersService.showVisitOnMap(visit, vm.vehiclesToSeeRoutesInDetail[
              VISIT_OUT_OF_ROUTE_VISUAL_STATE_ID]);
            vm.visitsOutOfRoute.push(visit);
          }
        });

        vm.visitsOutOfRouteFormattedLoads = statisticsService.calculateVisitsTotalLoads(vm.visitsOutOfRoute, Boolean(
          vm.optimizationOptions.big_cluster));
        if (vm.visitFilterHandler.activeFilter) {
          vm.filterVisitsOutOfRoute(vm.visitFilterHandler.minSliderTime, vm.visitFilterHandler.maxSliderTime);
        }

        $rootScope.$broadcast("Planner:Update:InfoBoxColors", {color: VISIT_OUT_OF_ROUTE_DEFAULT_COLOR,
          visits: angular.copy(route.visits)});
      }

      plannerService.routeMarkAsRemoved(route);
      plannerService.removeVehicleRoute(vehicle, route);
      if (vehicle.routes.length === 1) {
        var driverid = vehicle.routes[0].driver;
        if (vehicle.driverId !== driverid) {
          vm.updateVehicleDriver(vehicle, driverid, vm.vehicles);
        }
      }

      vehicle.setAreAllRoutesRevised();
      vehicle.recalculateAllRoutes(vm.optimizationOptions, plannerService)
        .then(function () {
          if (vehicle.routes.length === 0) {
            vm.vehicles.splice(vm.vehicles.indexOf(vehicle), 1);
            vehicle.setVisible(false);
          }

          fillMoveToSelect(vm.vehicles);
        })
        .catch(function (error) {
          Toasts.push('error', $translate('Planner_toast.error_delete_route'));
          $log.info(error);
        })
        .finally(function () {
          vm.updatePlannerIndicators();
          buildDisplayVehiclesList();
          $rootScope.isLoading = false;
          vm.filterHandler.activeFilter && routeDesignFilterService.applyResultToVM(vm, vm.searchResults);
        });
    }

    function fillVisitsOutRoute() {
      vm.visitsOutOfRoute = [];
      plannerService.visits.forEach(function (visit) {
        if (visit.routeId === null) {
          visit.setDefaultColor('#A4A4A4');
          visit.setVisible(true, false);
          visit.setLabelContent(null, !$rootScope.drawCluster);
          vm.visitsOutOfRoute.push(visit);
        }
      });
      vm.visitsOutOfRouteFormattedLoads = statisticsService.calculateVisitsTotalLoads(vm.visitsOutOfRoute, Boolean(
        vm.optimizationOptions.big_cluster));
      if (vm.visitFilterHandler.activeFilter) {
        vm.filterVisitsOutOfRoute(vm.visitFilterHandler.minSliderTime, vm.visitFilterHandler.maxSliderTime);
      }
    }

    function naturalSort(field) {
      return function (item) {
        return naturalService.naturalValue(item[field]);
      };
    }

    function toggleVisitOutOfRoute(visit, deselectSimilar) {
      var selected = visit.selected;
      var matchVisits = [];
      if (selected || deselectSimilar) {
        if (vm.optimizationOptions.join || vm.optimizationOptions.join_v2) {
          matchVisits = plannerService.visitSimilarGraph.getSimilarByRoute(visit);
          matchVisits.forEach(function (visit) {
            visit.setSelected(selected, true);
          });
        }
      }

      visit.setSelected(selected, true);
      var allVisitsToViewInfoBox = matchVisits.concat(visit);
      _updateToggledVisitsInInfoBox(vm.isMultipleEditingModeActivated, allVisitsToViewInfoBox);
      var selectedVisitsList =  vm.visitsOutOfRouteActions.visits.filter(function (visit) {
        return visit.selected;
      });

      var selectedVisitMap = {
        load: 0,
        load2: 0,
        load3: 0,
        load4: 0
      };

      selectedVisitsList.forEach(function (visit) {
        selectedVisitMap.load += visit.load;
        selectedVisitMap.load2 += visit.load2;
        selectedVisitMap.load3 += visit.load3;
        selectedVisitMap.load4 += visit.load4;
      });

      vm.selectedVisitOutOfRoute = {
        load: selectedVisitMap.load,
        load2: selectedVisitMap.load2,
        load3: selectedVisitMap.load3,
        load4: selectedVisitMap.load4
      };

      vm.selectedVisitsOutOfRouteCount = selectedVisitsList.length;
      vm.selectAllVisitsOutOfRoute = vm.selectedVisitsOutOfRouteCount === vm.visitsOutOfRouteActions.visits.length;
    }

    function calculateRouteArrivals(route) {
      if (!route) {
        return 0;
      }

      var arrivals = plannerService.getTotalArrivalsCached(route.visits, route.id);
      route.arrivals = arrivals;
      return arrivals.length;
    }

    function calculateRouteClients(route) {
      if (!route) {
        return 0;
      }

      var clientCount = routesUtils.calculateClientCount(route.visits);
      route.clientCount = clientCount;
      return clientCount;
    }

    function calculateArrivalsOutOfRoute(visits) {
      var arrivals = plannerService.getTotalArrivalsCached(visits, VISITS_OUT_OF_ROUTE);
      return arrivals.length;
    }

    function expandVisit(visit, route) {
      var initialTabs = [{
        id: 'information',
        name: $translate('Expand_modal.tabs.information'),
        active: true
      }];

      var modalInstance = ExpandModalService.open({
        template: 'app/planner/routes/expand-modal.html',
        scope: {
          vm: {
            visit: visit,
            route: route,
            vehicles: vm.vehicles,
            routeCodes: vm.routeCodes,
            routeIndex: vm.routeIndex,
            activeTab: 'information',
            tabs: initialTabs,
            isSellerManagementEnabled: vm.isSellerManagementEnabled,
            isMixLoadAddonEnabled: vm.isMixLoadAddonEnabled,
            close: function() {
              modalInstance.close();
            },
            switchTab: function(tabId) {
                this.activeTab = tabId;
                this.tabs.forEach(function(tab) {
                    tab.active = tab.id === tabId;
                });
            },
            isTabActive: function(tabId) {
                return this.activeTab === tabId;
            },
            getFilteredItems: function() {
              if (!this.visit.items || !this.visit.items.length) {
                return [];
              }
              return this.route.id === 0 ?
                this.visit.items.filter(function(item) {
                  return item.parentId === 1;
                }) :
                this.visit.items;
            }
          }
        }
      });

      if (visit.items && visit.items.length > 0 && __env.VISUALIZE_VISIT_ITEMS) {
        modalInstance.scope.vm.tabs.push({
          id: 'items',
          name: $translate('Expand_modal.tabs.items'),
          active: false,
          count: visit.items.length
        });
      }

      // Helper function to check if visit is completed
      function isCompletedVisit(visitId) {
        return visitId && visitId.indexOf('-') === -1; // If ID doesn't contain hyphens, it's a completed visit
      }

      // First check if accounting addon is enabled
      addonsService.isAddonEnable("accounting")
        .then(function(enabled) {
          if (enabled && isCompletedVisit(visit.id)) {
            // Only fetch invoices if visit is completed
            modalInstance.scope.vm.isLoadingInvoices = true; // Show loading state
            return accountingService.getInvoicesByVisit(visit.id)
              .then(function(invoices) {
                if (invoices && invoices.length > 0) {
                  // Set the invoices in the modal scope
                  modalInstance.scope.vm.invoices = invoices;

                  modalInstance.scope.vm.tabs.push({
                    id: 'document',
                    name: $translate('Expand_modal.document.title'),
                    active: false
                  });
                }
              })
              .finally(function() {
                modalInstance.scope.vm.isLoadingInvoices = false; // Hide loading state
              });
          }
        })
        .catch(function(error) {
          $log.error("Error checking accounting addon:", error);
          modalInstance.scope.vm.isLoadingInvoices = false; // Hide loading state on error
        });
    }

    function getDriverFullName(driverId) {
      return routesUtils.getDriverFullName(driverId, vm.drivers);
    }

    function toggleShowRoutes(vehicle) {
      vehicle.showAllRoutesV2(!vehicle.showRoutes, vm.optimizationOptions, routesGroupMarkersService.areGroupMarkersEnabled());
      updateVehiclesToSeeRoutesInDetail(vehicle.showRoutes, vehicle.id);
      vm.visibleAllRoutes = routesUtils.toggleVisibleAllRoutesHandler(vm.vehicles);
    }

    function updateVehiclesToSeeRoutesInDetail(value, id) {
      vm.vehiclesToSeeRoutesInDetail[id] = value;
    }

    function toggleVisitsOutOfRoutes(ev) {
      vm.showVisitsOutOfRoutes = !vm.showVisitsOutOfRoutes;

      if (ev) {
        ev.stopPropagation();
      }

      updateVehiclesToSeeRoutesInDetail(vm.showVisitsOutOfRoutes, VISIT_OUT_OF_ROUTE_VISUAL_STATE_ID);

      visitsMarkersService.showVisitsOnMap(vm.visitsOutOfRouteActions.visits, vm.showVisitsOutOfRoutes);
    }

    function getRouteName(route, index) {
      var routeNameWithPosition = $translate("Routes.route_text") + index;

      if (vm.customRouteNameConfig) {
        vm.routeCodes[route.id] = plannerService.getRouteName(route) || routeNameWithPosition;
      } else {
        vm.routeCodes[route.id] = routeNameWithPosition;
      }

      $scope.$emit('Planner:UpdateRouteCodes', {
        routeId: route.id,
        routeCode: vm.routeCodes[route.id]
      });

      return vm.routeCodes[route.id];
    }

    function toggleVisibleAllRoutes() {
      vm.visibleAllRoutes = !vm.visibleAllRoutes;

      var vehiclesToUpdate = vm.vehicles;
      if (!vm.visibleAllRoutes) {
        vehiclesToUpdate = vm.vehicles.filter(function (vehicle) {
          return vehicle.showRoutes;
        });
      }

      vehiclesToUpdate.forEach(function (vehicle) {
        vehicle.showAllRoutesV2(vm.visibleAllRoutes, vm.optimizationOptions, routesGroupMarkersService.areGroupMarkersEnabled());
        updateVehiclesToSeeRoutesInDetail(vm.visibleAllRoutes, vehicle.id);
      });
    }

    function toggleShowVehicleList(index) {
      if (vm.openVehicleIndex !== null && vm.openVehicleIndex !== index) {
            vm.showVehicleList[vm.openVehicleIndex] = false;
        }
      var values = vm.showVehicleList;
      values[index] = !values[index];
      vm.openVehicleIndex = vm.showVehicleList[index] ? index : null;
      vm.showVehicleList = values;
    }

    function _findIndexById(list, id) {
      return lodash.findIndex(list, function(element) {
        return element.id === id;
      });
    }

    function _changeVehicleRoutes(vehicleRoutes, vehicleSrc, vehicleDest) {
      vehicleRoutes.forEach(function (route) {
        route.changeVehicle(vehicleSrc, vehicleDest);
        route.setHasManualChanges(true);
      });
    }

    function interchangeRoute(originVehicleId, targetVehicleId) {
      if (originVehicleId === targetVehicleId) {
        return;
      }
      $rootScope.isLoading = true;
      var originVehicleIndex = _findIndexById(vm.vehicles, String(originVehicleId));
      var originVehicle = vm.vehicles[originVehicleIndex];
      var routesFromOriginVehicle = Array.from(originVehicle.routes);

      var toAvailableVehicle = false;
      var targetVehicle;
      var routesFromTargetVehicle = [];
      var targetVehicleIndex = _findIndexById(vm.vehicles, String(targetVehicleId));

      if (targetVehicleIndex >= 0) {
        targetVehicle = vm.vehicles[targetVehicleIndex];
        routesFromTargetVehicle = Array.from(targetVehicle.routes);
      } else {
        toAvailableVehicle = true;
        targetVehicleIndex = _findIndexById(vm.interchangeableVehicles, String(targetVehicleId));
        targetVehicle = vm.interchangeableVehicles[targetVehicleIndex];
        targetVehicle.showRoutes = true;
        updateVehiclesToSeeRoutesInDetail(targetVehicle.showRoutes, targetVehicle.id);
        originVehicle.setVisible(false, vm.optimizationOptions.open_ended);
      }

      _changeVehicleRoutes(routesFromOriginVehicle, originVehicle, targetVehicle);
      _changeVehicleRoutes(routesFromTargetVehicle, targetVehicle, originVehicle);

      var recalculatePromises = [];
      targetVehicle.setVisible(true, vm.optimizationOptions.open_ended);
      targetVehicle.setAreAllRoutesRevised();
      originVehicle.setAreAllRoutesRevised();

      recalculatePromises.push(
        targetVehicle.recalculateAllRoutes(vm.optimizationOptions, plannerService)
      );

      if (toAvailableVehicle) {
        vm.vehicles.splice(originVehicleIndex, 1);
        vm.vehicles.push(targetVehicle);
        if(!targetVehicle.active) {
          originVehicle.active = false;
          targetVehicle.active = true;
          vm.planVehicleHaveBeenUpdated = true;
        }
      } else {
        recalculatePromises.push(
          originVehicle.recalculateAllRoutes(vm.optimizationOptions, plannerService)
        );
      }

      $q.all(recalculatePromises)
        .then(recalculateAllRoutesSuccess)
        .catch(vm.recalculateAllRoutesFailed)
        .finally(function () {
          statisticsService.resetDataByVehicle();
          vm.updatePlannerIndicators();
          buildDisplayVehiclesList();
          routesUtils.updateSelectedDrivers(vm.vehicles, vm.drivers);
          vm.showVehicleList = {};
          $rootScope.isLoading = false;
        });

      function recalculateAllRoutesSuccess() {
        vm.filterHandler.activeFilter && routeDesignFilterService.applyResultToVM(vm, vm.searchResults);
        fillMoveToSelect(vm.vehicles);

        // Force ng-repeat
        vm.showRoutesDiv = false;
        vm.areVisitsListed = false;
        $timeout(function () {
          vm.showRoutesDiv = true;
          vm.areVisitsListed = true;
        }, 1);
      }
    }

    function recalculateAllRoutesFailed(error) {
      Toasts.push('error', $translate('Planner_toast.error_delete_route'));
      $log.error(error);
    }

    function isEnableNotesInRouteDesigner () {
      var accountConfigs = store.get('accountConfigs');
      var enableNotesInRouteDesigner;
      if (accountConfigs) {
        enableNotesInRouteDesigner = accountConfigs.find(function (config) {
          return config.key === ENABLE_NOTES_IN_ROUTE_DESIGNER;
        });
      }
      return enableNotesInRouteDesigner ? enableNotesInRouteDesigner.value : false;
    }

    function getVehicleNameWithRouteMarking(vehicle) {
      if (!vehicle) {
        return;
      }

      if (vehicle.routes && vehicle.routes.length) {
        return vehicle.name + "(*)";
      }

      return vehicle.name;
    }

    function reorderEditedRoutes() {
      $rootScope.isLoading = true;
      var editedRoutes = vm.routes.filter(function(route) {
        return route.hasManualChanges && !route.isRevised && !plannerService.isRouteProcessed(route);
      });

      var reorderRouteCallBack = function (route) {
        return _reorderRoute(route)
          .then(function (routeResponse) {
            var vehicle = plannerService.vehicles.filter(getVehicleById(routeResponse.vehicleId))[0];
            return vehicle.recalculateRouteStartingAt(
              routeResponse, vm.optimizationOptions, plannerService
            );
          });
      };

      return asyncUtils.promiseMap(editedRoutes, reorderRouteCallBack, REQUEST_CONCURRENCY)
        .catch(function (error) {
          $log.info(error);
          Toasts.push('error', $translate('Planner_toast.error_order_route'));
        })
        .finally(function () {
          vm.updatePlannerIndicators();
          buildDisplayVehiclesList();
          $rootScope.isLoading = false;
        });
    }

    function RebalanceRoutesSource() {
      return {
        vehicles: vm.vehicles,
        visitsOutOfRoute: vm.visitsOutOfRouteActions.visits,
        multiDayRouteEnabled: $scope.isMultiDayRouteEnabled
      };
    }

    function rebalanceRoutes() {
      $rootScope.isLoading = true;
      var haveRoutesBeenRebalanced = false;
      return rebalanceRoutesHelper.rebalanceRoutes(RebalanceRoutesSource())
        .then(function (response) {
          if (!response || !response.haveRoutesBeenRebalanced) {
            return;
          }
          haveRoutesBeenRebalanced = response.haveRoutesBeenRebalanced;
          fillMoveToSelect(vm.vehicles);
          _updateVisitsOutOfRoute(response.affectedVisits);
          _collapseLastOpenRoute();
          _clearInfoBox();
        })
        .finally(function () {
          if (haveRoutesBeenRebalanced) {
            vm.updatePlannerIndicators();
            buildDisplayVehiclesList();
          }
          $rootScope.isLoading = false;
        });
    }

    function _updateVisitsOutOfRoute(visits) {
      _addVisitsToOutOfRoute(visits);
      vm.selectAllVisitsOutOfRoute = false;
      vm.selectedVisitsOutOfRouteCount = 0;
      vm.selectedVisitOutOfRoute = {
        load: 0,
        load2: 0,
        load3: 0,
        load4: 0
      };
      vm.visitsOutOfRouteFormattedLoads = statisticsService.calculateVisitsTotalLoads(vm.visitsOutOfRoute,
        Boolean(vm.optimizationOptions.big_cluster));
      if (vm.visitFilterHandler.activeFilter) {
        vm.filterVisitsOutOfRoute(vm.visitFilterHandler.minSliderTime, vm.visitFilterHandler.maxSliderTime);
      }
    }

    function _addVisitsToOutOfRoute(visits) {
      var visitsOutOfRoute = plannerService.getVisitsOutOfRoute(visits);
      var mustUpdateMarkers = false;

      visitsOutOfRoute.forEach(function (visit) {
        visit.setDefaultColor(VISIT_OUT_OF_ROUTE_DEFAULT_COLOR);
        visit.updateOrder(VISIT_OUT_OF_ROUTE_ORDER, mustUpdateMarkers);
        visit.removeIndicatorsErrors();
        visit.setSelected(false);
        visitsMarkersService.showVisitOnMap(visit, vm.showVisitsOutOfRoutes);
        setInVisitsOutOfRouteList(visit);
      });
    }

    function _clearInfoBox() {
      vm.showOrHideSelectedNotification({}, true);
      $rootScope.$broadcast('Planner:Reset:InfoBoxContainer');
    }

    function _collapseLastOpenRoute() {
      if (vm.lastExpandedRoute && !vm.lastExpandedRoute.collapse) {
        if (vm.lastExpandedRoute.id === VISITS_OUT_OF_ROUTE_LIST_ID) {
          collapseOrExpandVisitsOutOfRoute(true);
        } else {
          toggleCollapseRoute(vm.lastExpandedRoute);
        }
      }
    }

    function canVehicleBeInterchanged(vehicle) {
      if (!vm.blockVehicleChangeEnabled) {
        return true;
      }
      var hasAnyRouteStarted = vehicle.routes.some(function (route) {
        return vm.startedRoutes.hasOwnProperty(route.id);
      });
      return !hasAnyRouteStarted;
    }

    function _updateToggledVisitsInInfoBox(multipleSelectionMode, toggledVisits) {
      if (multipleSelectionMode) {
        vm.showOrHideSelectedNotification(vm.getVisitsAndRoutesSelected(), multipleSelectionMode);
      } else {
        openInfoBox(toggledVisits);
      }
    }

    function isVisitsOutOfRouteFilterVisible() {
      return (
        vm.isVisitsOutOfRouteFilterEnabled &&
        vm.visitsOutOfRoute.length > 0 &&
        !$scope.isMultiDayRouteEnabled
      );
    }

    function filterVisitsOutOfRoute(minSliderTime, maxSliderTime) {
      var unselectedVisits = [];
      vm.visitsOutOfRoute.forEach(function (visit) {
        if (visit.selected) {
          visit.setSelected(false, true);
          unselectedVisits.push(visit);
        }

        visit.setVisible(false, !$rootScope.drawCluster);
        visit.actionRemove(visit);
      });

      vm.selectAllVisitsOutOfRoute = false;
      vm.selectedVisitsOutOfRouteCount = 0;
      vm.selectedVisitOutOfRoute = {
        load: 0,
        load2: 0,
        load3: 0,
        load4: 0
      };
      _updateToggledVisitsInInfoBox(vm.isMultipleEditingModeActivated, unselectedVisits);

      var visible = $rootScope.drawCluster ? !vm.visitsOutOfRouteActions.collapse : true;
      visitsUtils.filterVisits(
        vm.visitFilterHandler, visitFilterService.getFilters(), vm.visitsOutOfRoute,
        visible, minSliderTime, maxSliderTime
      );
    }

    function mustShowVisitWindows(windowStart, windowEnd) {
      return vm.show_visit_windows && plannerService.mustShowVisitWindows(windowStart, windowEnd);
    }

    function displayWindowsFormat(windowStart, windowEnd) {
      if (!windowStart || !windowEnd) {
        return;
      }
      return windowStart + ' ' + $translate('Planner.infowindow_to') + ' ' + windowEnd;
    }

    function displayWindows(visit) {
      var isValidWindows = mustShowVisitWindows(visit.windowStart, visit.windowEnd);
      var isValidWindows2 = mustShowVisitWindows(visit.windowStart2, visit.windowEnd2);
      if (isValidWindows && isValidWindows2) {
        return (
          displayWindowsFormat(visit.windowStart, visit.windowEnd) + ' | ' +
          displayWindowsFormat(visit.windowStart2, visit.windowEnd2)
        );
      }
      return isValidWindows ? displayWindowsFormat(visit.windowStart, visit.windowEnd) :
        displayWindowsFormat(visit.windowStart2, visit.windowEnd2);
    }

    function _getHeaderTextForLoadTable(route, routeIndex) {
      var headerText = "";
      if (route.id === VISITS_OUT_OF_ROUTE_LIST_ID) {
        headerText = "<span>" + $translate("Routes.visits_out_of_route_title") + "</span>";
      } else {
        var routeOrder = routeIndex + 1;
        var vehicle = plannerService.getVehicleById(route.vehicleId);
        var vehicleName = vehicle ? vehicle.name : "";
        headerText = (
          "<span>" + $translate("Routes.route_name") + "</span>" +
          "<span> " + routeOrder + " </span>" +
          "/" +
          "<span class='table-title-vehicle'> " + vehicleName + " </span>"
        );
      }

      return $sanitize(headerText);
    }

    function closeLoadsTable() {
      vm.showLoadsTable = false;
      vm.headerTextForLoadTable = null;
      vm.selectedRouteForLoads = null;
      vm.reverseOrderLoadsTable = false;
    }

    function _isRouteLoadsTableDisplayed(route) {
      return vm.selectedRouteForLoads && vm.selectedRouteForLoads.id === route.id;
    }

    function setLoadsTableRoute(route, routeIndex) {
      event.stopPropagation();

      if (_isRouteLoadsTableDisplayed(route)) {
        closeLoadsTable();
      } else {
        vm.showLoadsTable = true;
        vm.headerTextForLoadTable = _getHeaderTextForLoadTable(route, routeIndex);
        vm.selectedRouteForLoads = route;
      }
    }

    function selectVisitForLoadTable(routeId, visit, deselectSimilar) {
      if (routeId === VISITS_OUT_OF_ROUTE_LIST_ID) {
        toggleVisitOutOfRoute(visit, deselectSimilar);
      } else {
        toggleSelectedEditVisit(visit, deselectSimilar);
      }
    }

    function selectRouteForLoadTable(route) {
      if (route.id === VISITS_OUT_OF_ROUTE_LIST_ID) {
        toggleSelectAllVisitsOutOfRoute();
      } else {
        toggleEditingVisitsOfRoute(route);
      }
    }

    function toggleOptionsMenu(route) {
      event.stopPropagation();
      route.isOptionsMenuOpen = !route.isOptionsMenuOpen;
    }

    function markRouteAsRevised(route) {
      event.stopPropagation();
      route.isOptionsMenuOpen = false;
      vm.disableRouteCard(route);

      var vehicle = plannerService.getVehicleById(route.vehicleId);
      vm.disableVehicleCard(vehicle);
      vm.fillMoveToSelect(vm.vehicles);
    }

    function disableRouteCard(route) {
      route.editingSelected = false;
      route.hasManualChanges = false;
      vm.toggleEditingVisitsOfRoute(route);
      if (!route.collapse) {
        vm.toggleCollapseRoute(route);
      }

      if (_isRouteLoadsTableDisplayed(route)) {
        vm.closeLoadsTable();
      }

      route.isRevised = true;
      revisedRoutesService.updateRouteOpacityOnMap(route, vm.vehiclesToSeeRoutesInDetail);
    }

    function disableVehicleCard(vehicle) {
      vehicle.setAreAllRoutesRevised();
      if (!vehicle.areAllRoutesRevised) {
        return;
      }

      var vehicleIndex = _findIndexById(vm.vehicles, vehicle.id);
      if (vm.showVehicleList[vehicleIndex]) {
        vm.toggleShowVehicleList(vehicleIndex);
      }

      vehicle.setOpacity(ROUTE_REVISED_OPACITY);
    }

    function getVehicleNameNgClass(vehicle) {
      return {
        'title-less-visible': !vehicle.showRoutes || vehicle.areAllRoutesRevised,
        'element-disabled': vehicle.areAllRoutesRevised
      };
    }

    function getVehicleStatisticsNgClass(vehicle) {
      return {
        'title-less-visible': vehicle.areAllRoutesRevised
      };
    }

    function markRouteAsUnrevised(route) {
      route.isRevised = false;
      revisedRoutesService.updateRouteOpacityOnMap(route, vm.vehiclesToSeeRoutesInDetail);

      var vehicle = plannerService.getVehicleById(route.vehicleId);
      if (vehicle.areAllRoutesRevised) {
        vehicle.setOpacity(ROUTE_VISIBLE_OPACITY);
      }
      vehicle.areAllRoutesRevised = false;
      vm.fillMoveToSelect(vm.vehicles);
    }

    function openRevisedRouteModal(route) {
      var template = ROUTES_MODALS_FOLDER_PATH + 'revised-route-modal/revised-route-modal.html';
      $scope.route = route;
      $scope.markRouteAsUnrevised = markRouteAsUnrevised;

      ngDialog.open({
        template: template,
        scope: $scope
      });
    }

    function getAvailabilityIconUrl(vehicleAvailability) {
      if (vm.shouldDisplayPartiallyAvailableVehicleData(vehicleAvailability)) {
        return AVAILABILITY_ICON_URL.PARTIALLY_AVAILABLE;
      }

      if (vm.shouldDisplayVehicleWithExpiredDocumentsData(vehicleAvailability)) {
        return AVAILABILITY_ICON_URL.WITH_EXPIRED_DOCUMENTS;
      }

      return AVAILABILITY_ICON_URL.AVAILABLE;
    }

    function reverseRouteOrder(vehicle, route) {
      route.isOptionsMenuOpen = false;
      $rootScope.isLoading = true;

      route.reverseVisits(plannerService);

      return vehicle.recalculateAllRoutes(vm.optimizationOptions, plannerService)
        .finally(function () {
          vm.updatePlannerIndicators();
          buildDisplayVehiclesList();
          $rootScope.isLoading = false;
          Toasts.push('success', $translate('Routes.reverse_route_order_success_title') + ': ' + $translate('Routes.reverse_route_order_success_msg'));
        });
    }

    function hasMultipleRoute(vehicle) {
      return vehicle.routes.length > 1;
    }

    function isMultiDriverVehicle(vehicle) {
      return vm.isMultiDriversConfigEnabled && hasMultipleRoute(vehicle);
    }

    function updateVehicleDriver (vehicle, selectedDriver, vehicles) {
      plannerService.updateVehicleDriver(vehicle, selectedDriver, vehicles);
      $scope.$broadcast('drivers-selected:updated', vm.drivers);
    }

    function buildDisplayVehiclesList() {

      vm.displayVehiclesList.actions.length = 0;
      vm.displayVehiclesList.categories.length = 0;

      var allVehicles = [];
      var availableVehicles = [];
      var occupiedVehicles = [];

      var getSkillsName = function (vehicleSkills) {
        var skills = [];
        vehicleSkills.forEach(function (skillId) {
          if(vm.skills[skillId]) {
            skills.push(vm.skills[skillId].name);
          }
        });
        return skills;
      };

      var getKpis = function(vehicleId) {
        var dataByVehicle = vm.dataByVehicle[vehicleId];

        var kpis = {
          totalLoadPercentage: 0,
          totalLoadPercentage2: 0,
          totalLoadPercentage3: 0
        };

        if (dataByVehicle) {
          kpis.totalLoadPercentage = dataByVehicle.averageLoadsPercentage[0];
          kpis.totalLoadPercentage2 = dataByVehicle.averageLoadsPercentage[1];
          kpis.totalLoadPercentage3 = dataByVehicle.averageLoadsPercentage[2];
        }
        return kpis;
      };

      var getClassError = function(routes) {
        var classError = {
          capacityError: false,
          capacityError2: false,
          capacityError3: false,
          capacityError4: false
        };

        routes.forEach(function(route) {
          if(route.capacityError) {
            classError.capacityError = true;
          }
          if(route.capacityError2) {
            classError.capacityError2 = true;
          }
          if(route.capacityError3) {
            classError.capacityError3 = true;
          }
          if(route.capacityError4) {
            classError.capacityError4 = true;
          }
        });

        return classError;
      };

      var getTooltipMessages = function(vehicle) {
        var tooltipMessages = {
          totalLoad: '',
          totalLoad2: '',
          totalLoad3: '',
          totalLoad4: ''
        };

        var loadProperties = [
          { total: 'totalLoad', formatted: 'formattedLoad', error: 'capacityError', message: $translate('Routes.tooltips.charge_error_one'), tooltip: 'totalLoad' },
          { total: 'totalLoad2', formatted: 'formattedLoad2', error: 'capacityError2', message: $translate('Routes.tooltips.charge_error_two'), tooltip: 'totalLoad2' },
          { total: 'totalLoad3', formatted: 'formattedLoad3', error: 'capacityError3', message: $translate('Routes.tooltips.charge_error_three'), tooltip: 'totalLoad3' },
          { total: 'totalLoad4', formatted: 'formattedLoad4', error: 'capacityError4', message: $translate('Routes.tooltips.charge_error_four'), tooltip: 'totalLoad4' }
        ];

        vehicle.routes.forEach(function(route) {
          loadProperties.forEach(function(load) {
            if (route[load.total] > 0 && route[load.formatted]) {
              if (route[load.error]) {
                tooltipMessages[load.tooltip] += load.message + '\n' + route[load.formatted] + '\n';
              } else {
                tooltipMessages[load.tooltip] += route[load.formatted] + '\n';
              }
            }
          });
        });

        // Elimina el último salto de línea de cada mensaje
        tooltipMessages.totalLoad = tooltipMessages.totalLoad.trim();
        tooltipMessages.totalLoad2 = tooltipMessages.totalLoad2.trim();
        tooltipMessages.totalLoad3 = tooltipMessages.totalLoad3.trim();
        tooltipMessages.totalLoad4 = tooltipMessages.totalLoad4.trim();

        return tooltipMessages;
      };

      // Filtra los vehículos que no tienen rutas procesadas
      vm.vehiclesAvailable = vm.vehiclesAvailable.filter(function(vehicle) {
        return !plannerService.hasVehicleRoutesProcessed(vehicle) && !vehicle.routes.some(function(route) {
          return vm.startedRoutes.hasOwnProperty(route.id);
        });
      });

      vm.vehiclesAvailable.forEach(function(vehicle) {

        var MAX_TAGS = 3;
        var getKpisValue = getKpis(vehicle.id);
        var getClassErrors = getClassError(vehicle.routes);
        var tooltipMessages = getTooltipMessages(vehicle);
        var tags = getSkillsName(vehicle.skills);
        var status = vehicle.routes.length > 0
                    ? $translate('Routes.displayVehiclesList.vehicle_status_occupied')
                    : $translate('Routes.displayVehiclesList.vehicle_status_available');

        var displayVehicle = {
          identity: vehicle.id,
          title: vehicle.name,
          color: vehicle.color,
          kpis: [
            {
              icon: 'sp-icon-carga',
              value: getKpisValue.totalLoadPercentage,
              classError: getClassErrors.capacityError,
              description: tooltipMessages.totalLoad
            },
            {
              icon:'sp-icon-carga-volumen',
              value: getKpisValue.totalLoadPercentage2,
              classError: getClassErrors.capacityError2,
              description: tooltipMessages.totalLoad2
            },
            {
              icon: 'sp-icon-carga-valor',
              value: getKpisValue.totalLoadPercentage3,
              classError: getClassErrors.capacityError3,
              description: tooltipMessages.totalLoad3
            }
          ],
          tags: tags.map(function(tag) {
              return { value: tag };
          }),
          hiddenTagsTooltip: tags.slice(MAX_TAGS).map(function(skill) {
            return skill;
          }).join(', '),
          status: {
            value: status,
            color: status === $translate('Routes.displayVehiclesList.vehicle_status_occupied') ? '#C8E9FA' : '#F7F7F8'
          }
        };

        allVehicles.push(displayVehicle);
        if(vehicle.routes.length) {
          occupiedVehicles.push(displayVehicle);
        } else {
          availableVehicles.push(displayVehicle);
        }

      });

      vm.displayVehiclesList.categories.push({
        title: $translate('Routes.displayVehiclesList.categories.all_vehicles'),
        isCollapsed: false,
        items: allVehicles
      });

      vm.displayVehiclesList.categories.push({
        title: $translate('Routes.displayVehiclesList.categories.available_vehicles'),
        isCollapsed: true,
        items: availableVehicles
      });

      vm.displayVehiclesList.categories.push({
        title: $translate('Routes.displayVehiclesList.categories.occupied_vehicles'),
        isCollapsed: true,
        items: occupiedVehicles
      });
    }

    function isMixLoadAddonEnabled() {
      var pathFinderProperties = plannerService.getPathFinderProperties();
      var enabledMaxLoad = pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD];
      return enabledMaxLoad && enabledMaxLoad.toLowerCase() === 'true';
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .controller("PlannerRedirectRoutesController", PlannerRedirectRoutesController);

  /** @ngInject */
  function PlannerRedirectRoutesController(loadPlanService, $state, $rootScope, plannerService, $stateParams) {
    activate();

    function activate() {
      $rootScope.isLoading = true;

      if (!$stateParams.draftPlanKey) {
        $state.go("planner.vehicles-list");
        $rootScope.isLoading = false;
        return;
      }

      return plannerService.getPlan()
        .then(function () {
          return loadPlanService.loadPlanResume($stateParams.draftPlanKey);
        })
        .then(function (response) {
          return loadPlanService.loadPlan(response.plan);
        })
        .then(function () {
          $state.go("planner.routes");
        })
        .finally(function () {
          $rootScope.isLoading = false;
        });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .service("rebalanceRoutesHelper", rebalanceRoutesHelper);

  /** @ngInject */
  function rebalanceRoutesHelper($q, store, plannerService, optimizeService, timeUtils, visitsMarkersService) {
    var REST_TIME = "BreakVisit";
    var TIME_UNIT = "hours";

    var vehiclesToRecalculate = [];
    var vehiclesToRebalance = [];
    var visitsToRebalance = [];
    var selectedUnroutedVisits = [];
    var summaryPerVehicle = {};
    var partiallySelectedRoutes = {};
    var coDriversPerVehicle = {};
    var optimizationOptions = {};

    return {
      rebalanceRoutes: rebalanceRoutes
    };

    function rebalanceRoutes(rebalanceRoutesSource) {
      _initializeGlobalVariables();
      var vehicles = rebalanceRoutesSource.vehicles;
      var visitsOutOfRoute = rebalanceRoutesSource.visitsOutOfRoute;
      vehicles.forEach(function (vehicle) {
        summaryPerVehicle[vehicle.id] = {
          vehicle: vehicle,
          selectedRoutes: [],
          haveAnySelectedVisit: false,
        };

        _fillDataToRebalance(vehicle);

        var totalRoutesSelected = summaryPerVehicle[vehicle.id].selectedRoutes.length;
        if (totalRoutesSelected === vehicle.routes.length) {
          vehiclesToRebalance.push(vehicle);
        }

        if (summaryPerVehicle[vehicle.id].haveAnySelectedVisit) {
          vehiclesToRecalculate.push(vehicle);
        }
      });

      if (vehiclesToRebalance.length === 0) {
        return $q.when({haveRoutesBeenRebalanced: false, affectedVisits: []});
      }

      visitsOutOfRoute.forEach(function (visit) {
        if (visit.selected) {
          selectedUnroutedVisits.push(visit);
          visitsToRebalance.push(visit);
        }
      });

      return _rebalance(rebalanceRoutesSource.multiDayRouteEnabled)
        .then(function (response) {
          if (response.data.id) {
            plannerService.addOptimizationId(response.data.id);
          }

          _removeRoutes();
          _removeVisitsFromPartiallySelectedRoutes(rebalanceRoutesSource);
          _removeVisitsFromOutOfRouteList(visitsOutOfRoute);
          _createRoutesAfterRebalance(response.data, rebalanceRoutesSource);
          var vehiclePromises = _recalculateOrRemoveVehicles(vehicles);
          return $q.all(vehiclePromises);
        })
        .then(function () {
          return {haveRoutesBeenRebalanced: true, affectedVisits: visitsToRebalance};
        })
        .catch(function (error) {
          console.error("Error rebalanceRoutes", error);
        });
    }

    function _initializeGlobalVariables() {
      vehiclesToRecalculate = [];
      vehiclesToRebalance = [];
      visitsToRebalance = [];
      selectedUnroutedVisits = [];
      summaryPerVehicle = {};
      partiallySelectedRoutes = {};
      coDriversPerVehicle = {};
      optimizationOptions = Object.assign(
        {},
        plannerService.getlocalOptimizationOptions(),
        {
          big_vrp: true,
          beauty: false,
          autoZone: false,
          one_vehicle_zone: false,
          country: store.get('country'),
        }
      );
    }

    function _fillDataToRebalance(vehicle) {
      vehicle.routes.forEach(function (route) {
        if (route.editingSelected) {
          visitsToRebalance = visitsToRebalance.concat(route.visits);
          summaryPerVehicle[vehicle.id].selectedRoutes.push(route);
          summaryPerVehicle[vehicle.id].haveAnySelectedVisit = true;
          return;
        }

        _fillDataFromPartiallySelectedRoutes(route, vehicle.id);
      });
    }

    function _fillDataFromPartiallySelectedRoutes(route, vehicleId) {
      var selectedVisits = [];
      route.visits.forEach(function (visit) {
        if (visit.selected) {
          selectedVisits.push(visit);
          visitsToRebalance.push(visit);
        }
      });

      if (selectedVisits.length) {
        summaryPerVehicle[vehicleId].haveAnySelectedVisit = true;
        partiallySelectedRoutes[route.id] = {
          route: route,
          selectedVisits: selectedVisits
        };
      }
    }

    function _rebalance(multiDayRouteEnabled) {
      var zones = [];
      var params = _generateParams(multiDayRouteEnabled);
      return optimizeService.optimizePlan(vehiclesToRebalance, visitsToRebalance, zones, params);
    }

    function _removeRoutes() {
      var backupRoutes = plannerService.getBackupRoutes();
      for (var vehicleId in summaryPerVehicle) {
        var vehicle = summaryPerVehicle[vehicleId].vehicle;

        summaryPerVehicle[vehicleId].selectedRoutes.forEach(function (route) {
          if (backupRoutes.hasOwnProperty(route.id)) {
            plannerService.setBackupRoute(route);
          }

          coDriversPerVehicle[vehicleId] = route.codrivers || [];
          plannerService.removeVehicleRoute(vehicle, route);
        });
      }
    }

    function _removeVisitsFromPartiallySelectedRoutes() {
      for (var routeId in partiallySelectedRoutes) {
        var route = partiallySelectedRoutes[routeId].route;
        partiallySelectedRoutes[routeId].selectedVisits.forEach(function (visit) {
          route.removeVisit(visit);
        });
      }
    }

    function _removeVisitsFromOutOfRouteList(visitsOutOfRoute) {
      selectedUnroutedVisits.forEach(function (visit) {
        var visitIndex = visitsOutOfRoute.indexOf(visit);
        visitsOutOfRoute.splice(visitIndex, 1);
      });
    }

    function _createRoutesAfterRebalance(optimizationData, rebalanceRoutesSource) {
      var params = _generateParams(rebalanceRoutesSource.multiDayRouteEnabled);
      var reorderRoute = false;
      var zones = [];
      var nodesMap = optimizeService.getVisitsRequestData(visitsToRebalance, params, reorderRoute, zones);

      var routesVisualStatePerVehicle = plannerService.getUserVisualState();
      var isRouteVisible;
      var mustUpdateRoutesInMap = false;
      var shouldVisitsBeVisible;

      optimizationData.vehicles.forEach(function (vehicleOpt) {
        var vehicle = vehiclesToRebalance.find(function (vehicleInFind) {
          return vehicleInFind.id === vehicleOpt.ident;
        });

        vehicleOpt.tours.forEach(function (tour) {
          var route = plannerService.createRoute(vehicle.id);
          route.codrivers = coDriversPerVehicle[vehicle.id] || [];
          vehicle.addRoute(route);

          isRouteVisible = routesVisualStatePerVehicle[parseInt(route.vehicleId)];
          route.setVisible(isRouteVisible, mustUpdateRoutesInMap);
          route.actionCreate(route);

          shouldVisitsBeVisible = visitsMarkersService.shouldVisitsInRouteBeVisible(route, routesVisualStatePerVehicle);

          route.estimatedTimeStart = tour.nodes.shift().departure;
          route.estimatedTimeEnd = tour.nodes.pop().arrival;
          route.routeDistance = tour.route_distance || null;

          var restTimeNode = null;
          tour.nodes.forEach(function (node) {
            if (node.ident === REST_TIME) {
              restTimeNode = plannerService.parseOptimizationRestTimeNode(node, vehicle);
              return;
            }

            var visit = null;
            var nodeVisit = nodesMap.find(function (nodeTmp) {
              return nodeTmp.ident === node.ident;
            });

            nodeVisit.group.forEach(function (visitId) {
              visit = visitsToRebalance.find(function (visitPlan) {
                return visitPlan.id === visitId;
              });

              visit.estimatedTimeArrival = node.arrival;
              visit.estimatedTimeDeparture = node.departure;

              visit.setDefaultColor(vehicle.color);
              route.addVisitToRoute(visit);
              visit.setSelected(false);
              visitsMarkersService.showVisitOnMap(visit, shouldVisitsBeVisible);
            });
          });

          if (restTimeNode) {
            plannerService.setRestTimeByRouteId(route.id, restTimeNode);
          } else {
            plannerService.clearRestTimes(route.id);
          }
        });
      });
    }

    function _recalculateOrRemoveVehicles(vehicles) {
      var vehiclePromises = [];
      vehiclesToRecalculate.forEach(function (vehicle) {
        if (vehicle.routes.length === 0) {
          var vehicleIndex = vehicles.indexOf(vehicle);
          vehicles.splice(vehicleIndex, 1);
          vehicle.setVisible(false);
          return;
        }

        var promise = vehicle.recalculateAllRoutes(optimizationOptions, plannerService);
        vehiclePromises.push(promise);
      });

      return vehiclePromises;
    }

    function _generateParams(multiDayRouteEnabled) {
      var planDate = plannerService.getPlanDate();
      var diff = timeUtils.diff(planDate.end, planDate.start, TIME_UNIT);
      var planInHours = 0 > diff ? 0 : diff;

      return {
        optimizationOptions: optimizationOptions,
        isJDH: true,
        planName: plannerService.getPlanName(),
        planEditingSelected: plannerService.getPlanEditingSelected(),
        isBigVrp: optimizationOptions.big_vrp,
        use_euclidean_distance: optimizationOptions.use_euclidean_distance,
        enable_graphs: optimizationOptions.enable_graphs,
        auto_reorder: optimizationOptions.auto_reorder,
        planInHours: planInHours,
        planDate: planDate || 0,
        longRoutes: multiDayRouteEnabled,
        one_vehicle_zone: optimizationOptions.one_vehicle_zone,
        isVehicularRestrictionEnabled: plannerService.isVehicularRestrictionEnabled(),
        // As a task requirement, this feature does not send zones or
        // skills to the optimizer.
        disableZones: true,
        disableSkills: true
      };
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('icarus.planner')
    .controller('InfoTableController', InfoTableController);

  /** @ngInject */
  function InfoTableController(plannerService, moment, $filter, naturalService, __env, accountConfigsService,
                              store, reportService, routeHelperService, PATH_FINDER_ADD_ON_PROPERTIES) {

    var vm = this;
    var VEHICLE_NAME_EXCEL_INDEX = 1;
    var DISTANCE_EXCEL_INDEX = 7;
    var VISITS_EXCEL_INDEX = 9;
    var LOAD_1_EXCEL_INDEX = 10;
    var LOAD_2_EXCEL_INDEX = 12;
    var LOAD_3_EXCEL_INDEX = 14;
    var LOAD_4_EXCEL_INDEX = 16;
    var EXCEL_COL_NUM = 18;

    var round = routeHelperService.round;
    var getValidLoad = routeHelperService.getValidLoad;
    var getValidLoadPercentage = routeHelperService.getValidLoadPercentage;

    vm.vehicles = [];
    vm.customRoutesNames = false;

    vm.getVehicleTotalVisits = getVehicleTotalVisits;
    vm.getVehicleTotalDistance = getVehicleTotalDistance;
    vm.getVehicleTotalTime = getVehicleTotalTime;
    vm.getVehicleTotalLoad1 = getVehicleTotalLoad1;
    vm.getVehicleTotalLoad2 = getVehicleTotalLoad2;
    vm.getVehicleTotalLoad3 = getVehicleTotalLoad3;
    vm.getVehicleTotalLoad4 = getVehicleTotalLoad4;


    vm.getTotalVisits = getTotalVisits;
    vm.getTotalDistance = getTotalDistance;
    vm.getAverageTime = getAverageTime;
    vm.getTotalLoad1 = getTotalLoad1;
    vm.getTotalLoad2 = getTotalLoad2;
    vm.getTotalLoad3 = getTotalLoad3;
    vm.getTotalLoad4 = getTotalLoad4;

    vm.naturalSort = naturalSort;
    vm.formatTime = formatTime;

    vm.getTotal = getTotal;
    vm.getVehicleTotal = getVehicleTotal;
    vm.getMinutes = getMinutes;
    vm.getRouteName = getRouteName;
    vm.formatToTime = formatToTime;

    vm.downloadRouteSummary = downloadRouteSummary;
    vm.getDriverName = plannerService.getDriverName;

    vm.isMixLoadAddonEnabled = false;

    activate();

    ///////////////////////////////////////////////

    function activate() {
      vm.vehicles = plannerService.getVehicles();
      recomputeTotalLoads();
      vm.isMixLoadAddonEnabled = checkMixLoadAddon();
      var accountConfigs = store.get('accountConfigs');
      vm.customRoutesNames = accountConfigsService.getValueByKeyFrom('custom_route_name', accountConfigs);
    }

    function checkMixLoadAddon() {
      var pathFinderProperties = plannerService.getPathFinderProperties();
      if (pathFinderProperties && pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD]) {
        var enabledMaxLoad = pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD];
        return enabledMaxLoad.toLowerCase() === 'true';
      }
      return false;
    }

    function recomputeTotalLoads() {
      vm.vehicles.forEach(function (vehicle) {
        vehicle.routes.forEach(function (route) {
          route.totalLoad = route.visits.reduce(
            function (sum, visit) {
                return sum + visit.load;
            },
            0
          );

          route.totalLoad2 = route.visits.reduce(
            function (sum, visit) {
              return sum + visit.load2;
            },
            0
          );

          route.totalLoad3 = route.visits.reduce(
            function (sum, visit) {
              return sum + visit.load3;
            },
            0
          );

          route.totalLoad4 = route.visits.reduce(
            function (sum, visit) {
              return sum + visit.load4;
            },
            0
          );
        });
      });
    }

    function getTotal(attribute) {
      return vm.vehicles.reduce(
        function (partialSum, vehicle) {
          if (vehicle.routes.length > 0) {
            return partialSum + getVehicleTotal(vehicle, attribute);
          }

          return partialSum;
        },
        0
      );
    }

    function getAverageTime() {
      var pair =  vm.vehicles.reduce(
        function (partialSum, vehicle) {
          if (vehicle.routes.length > 0) {
            return [partialSum[0] + getVehicleTotalTime(vehicle), partialSum[1]+1];
          }

          return partialSum;
        },
        [0, 0]
      );

      return Math.round(pair[0]/pair[1]);
    }

    function getTotalVisits() {
      return vm.vehicles.reduce(
        function (partialSum, vehicle) {
          if (vehicle.routes.length > 0) {
            return partialSum + getVehicleTotalVisits(vehicle);
          }

          return partialSum;
        },
        0
      );
    }
    function getTotalLoad1() {
      return getTotal('totalLoad');
    }

    function getTotalLoad2() {
      return getTotal('totalLoad2');
    }

    function getTotalLoad3() {
      return getTotal('totalLoad3');
    }

    function getTotalLoad4() {
      return getTotal('totalLoad4');
    }

    function getTotalDistance() {
      return getTotal('totalDistance');
    }

    function getVehicleTotal(vehicle, attribute) {
      return vehicle.routes.reduce(
        function (partialSum, route) {
          return partialSum + route[attribute];
        },
        0
      );
    }

    function getVehicleTotalLoad1(vehicle) {
      return getVehicleTotal(vehicle, 'totalLoad');
    }

    function getVehicleTotalLoad2(vehicle) {
      return getVehicleTotal(vehicle, 'totalLoad2');
    }

    function getVehicleTotalLoad3(vehicle) {
      return getVehicleTotal(vehicle, 'totalLoad3');
    }

    function getVehicleTotalLoad4(vehicle) {
      return getVehicleTotal(vehicle, 'totalLoad4');
    }

    function getVehicleTotalDistance(vehicle) {
      return getVehicleTotal(vehicle, 'totalDistance');
    }

    function getVehicleTotalVisits(vehicle) {
      return vehicle.routes.reduce(
        function (partialSum, route) {
          return partialSum + route.visits.length;
        },
        0
      );
    }

    function formatTime(minutes) {
      return ("0"+Math.floor(minutes/60)).slice(-2) + ':' +("0"+(minutes%60)).slice(-2);
    }

    function getMinutes(totalTime) {
      var totalMinutes = 0;
      var splitTimeFirst = totalTime.split(' ');
      if (splitTimeFirst.length > 1) {
        totalMinutes += ((parseInt(splitTimeFirst[0]) * 24) * 60);
        splitTimeFirst[0] = splitTimeFirst[1];
      }

      var splitTime = splitTimeFirst[0].split(':');
      return totalMinutes + parseInt(splitTime[0] * 60) + parseInt(splitTime[1]);
    }

    function getVehicleTotalTime(vehicle) {
      return vehicle.routes.reduce(
        function (partialMinutes, route) {
          return partialMinutes + getMinutes(route.totalTime);
          },
        0
      );
    }

    function naturalSort(field) {
      return function (item) {
        return naturalService.naturalValue(item[field]);
      };
    }

    function getRouteName(route, index) {
      if (!vm.customRoutesNames) {
        return $filter('translate')('Routes.route_text') + (index+1);
      }

      var computedName = plannerService.getRouteName(route);
      return computedName ? computedName : $filter('translate')('Routes.route_text') + (index+1);
    }

    function formatToTime(datetime) {
      return moment(datetime).format('LT');
    }

    function _getRouteSummaryRow(vehicle, route, routeIndex, isJoinSimilarActive) {
      var data =  [
        '',
        vehicle.name,
        getRouteName(route, routeIndex),
        route.locationStart.address,
        plannerService.getDriverName(route.driver),
        formatToTime(route.estimatedTimeStart),
        formatToTime(route.estimatedTimeEnd),
        round(route.totalDistance, 2),
        route.totalTime,
        route.visits.length,
        getValidLoad(route.totalLoad),
        getValidLoad(route.totalLoad) + '/' + round(getValidLoadPercentage(route.totalLoad, vehicle.capacity), 2) + '%',
        getValidLoad(route.totalLoad2),
        getValidLoad(route.totalLoad2) + '/' + round(getValidLoadPercentage(route.totalLoad2, vehicle.capacity2), 2) + '%',
        getValidLoad(route.totalLoad3),
        getValidLoad(route.totalLoad3) + '/' + round(getValidLoadPercentage(route.totalLoad3, vehicle.capacity3), 2) + '%',
      ];

      if (vm.isMixLoadAddonEnabled) {
        data.push(getValidLoad(route.totalLoad4));
        data.push(getValidLoad(route.totalLoad4) + '/' + round(getValidLoadPercentage(route.totalLoad4, vehicle.capacity4), 2) + '%');
      }

      if(isJoinSimilarActive) {
        data.push(plannerService.getTotalArrivalsCached(route.visits, route.id).length);
      }
      return data;
    }

    function _getTotalizerRowByVehicle(vehicle) {
      var totalLabel = $filter('translate')('Excel_Header.total').toUpperCase();
      var totalizerRow = Array(EXCEL_COL_NUM).fill('');

      totalizerRow[VEHICLE_NAME_EXCEL_INDEX] = totalLabel;
      totalizerRow[DISTANCE_EXCEL_INDEX] = round(getVehicleTotalDistance(vehicle), 2);
      totalizerRow[VISITS_EXCEL_INDEX] = getVehicleTotalVisits(vehicle);
      totalizerRow[LOAD_1_EXCEL_INDEX] = getVehicleTotalLoad1(vehicle);
      totalizerRow[LOAD_2_EXCEL_INDEX] = getVehicleTotalLoad2(vehicle);
      totalizerRow[LOAD_3_EXCEL_INDEX] = getVehicleTotalLoad3(vehicle);

      if (vm.isMixLoadAddonEnabled) {
        totalizerRow[LOAD_4_EXCEL_INDEX] = getVehicleTotalLoad4(vehicle);
      }

      return totalizerRow;
    }

    function _getTotalizerRowByAllVehicles(vehicles) {
      var totalDistance = 0;
      var totalVisits = 0;
      var totalLoad1 = 0;
      var totalLoad2 = 0;
      var totalLoad3 = 0;
      var totalLoad4 = 0;

      vehicles.forEach(function (vehicle) {
        totalDistance += getVehicleTotalDistance(vehicle);
        totalVisits += getVehicleTotalVisits(vehicle);
        totalLoad1 += getVehicleTotalLoad1(vehicle);
        totalLoad2 += getVehicleTotalLoad2(vehicle);
        totalLoad3 += getVehicleTotalLoad3(vehicle);
        totalLoad4 += getVehicleTotalLoad4(vehicle);
      });

      var totalizerRow = Array(EXCEL_COL_NUM).fill('');
      totalizerRow[VEHICLE_NAME_EXCEL_INDEX] = $filter('translate')('Excel_Header.total_routes_summary'),
      totalizerRow[DISTANCE_EXCEL_INDEX] = round(totalDistance, 2);
      totalizerRow[VISITS_EXCEL_INDEX] = totalVisits;
      totalizerRow[LOAD_1_EXCEL_INDEX] = totalLoad1;
      totalizerRow[LOAD_2_EXCEL_INDEX] = totalLoad2;
      totalizerRow[LOAD_3_EXCEL_INDEX] = totalLoad3;
      if (vm.isMixLoadAddonEnabled) {
        totalizerRow[LOAD_4_EXCEL_INDEX] = totalLoad4;
      }

      return totalizerRow;
    }

    function downloadRouteSummary() {
      var vehiclesSortedByName = naturalService.naturalSort(vm.vehicles, 'name', false);
      var isJoinSimilarActive = plannerService.getlocalOptimizationOptions().join || plannerService.getlocalOptimizationOptions().join_v2;
      var data = [];

      vehiclesSortedByName.forEach(function (vehicle) {
        if (vehicle.routes.length > 0) {
          vehicle.routes.forEach(function (route, index) {
            data.push(_getRouteSummaryRow(vehicle, route, index, isJoinSimilarActive));
          });

          data.push(_getTotalizerRowByVehicle(vehicle));
        }
      });

      data.push(_getTotalizerRowByAllVehicles(vehiclesSortedByName));
      reportService.downloadRouteSummaryAsExcel(data, isJoinSimilarActive, vm.isMixLoadAddonEnabled);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('icarus.planner')
    .controller('FinishPlanController', FinishPlanController);

  /** @ngInject */
  function FinishPlanController($log, $state, $scope, plannerService, moment, ngDialog, Toasts, $filter, PLAN_STATUS,
                                $rootScope, __env, $q, $location, LogService, plannerReportsService, chatService, routesUtils,
                                accountConfigsService, webEventService, lodash, ACCOUNT_CONFIGS, HTTP_STATUS_CODE,
                                INVALID_VISITS, CANCELED_VISITS, EVENT_RECALCULATE_STATISTICS, WEB_EVENTS,
                                visitsMarkersService, $window, apolloAuthService, $translate, planService,
                                ROUTE_STARTED_OR_FINISHED_ERROR_CODE, vehicleAvailabilityService, VEHICLE_UNAVAILABLE_ERROR_CODE) {
    var vm = this;
    var $translations = $filter('translate');

    vm.plannedDate = 'null';
    vm.planName = '';
    vm.planStatus = PLAN_STATUS.completed;

    vm.vehicles = [];
    vm.drivers = [];
    vm.codrivers = [];
    vm.isEnabledConfigToCodrivers = false;
    vm.enableOrganizationSyncService = false;

    vm.saving = false;
    vm.savedPlan = null;
    vm.notSavedPlan = null;

    vm.savePlanErrorData = {
      type: null,
      visits: null,
      visitsTitles: []
    };

    vm.isErrorInPlanInstance = false;
    vm.isErrorDataFormat = false;
    vm.isDefaultError = false;
    vm.planMergedName = null;
    vm.isNonBlockingSavingEnabled = false;

    vm.androidAppLink = __env.APP_MOBILE_GOOGLEPLAY_LINK;
    vm.appStoreAppLink = __env.APP_MOBILE_APPSTORE_LINK;

    vm.dateOptions = {
      formatYear: 'yyyy',
      formatDayHeader: 'EEE',
      formatDayTitle: 'MMMM',
      formatDay: 'd',
      showWeeks: false,
      startingDay: 0,
      minDate: moment().toDate()
    };
    vm.dataError = {};
    vm.isMultiDayRouteEnabled = $scope.isMultiDayRouteEnabled;
    vm.isPlanStatusEnabled = false;
    vm.resolveConfirmation = null;

    vm.savePlan = savePlan;
    vm.closeModal = closeModal;
    vm.clearPlan = clearPlan;
    vm.clearAndGoTo = clearAndGoTo;
    vm.changeDate = changeDate;
    vm.setDate = setDate;

    vm.downloadReportTxt = downloadReportTxt;
    vm.downloadReportExcel = downloadReportExcel;
    vm.downloadReportPdf = downloadReportPdf;
    vm.downloadReportSummarizedPdf = downloadReportSummarizedPdf;

    vm.confirmCompletePlan = confirmCompletePlan;
    vm.removeCanceledVisits = removeCanceledVisits;
    vm.goToCodrivers = goToCodrivers;

    vm.isPlanEditable = plannerService.isPlanEditable;

    activate();

    function activate() {
      vm.savedPlan = null;
      vm.notSavedPlan = null;

      vm.savePlanErrorData = {
        type: null,
        visits: null,
        visitsTitles: []
      };

      vm.planName = moment().format('D-MM-YYYY HH:mm:ss');
      vm.editing = (plannerService.getPlanName() !== null);
      vm.isPlanStatusEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_PLAN_STATUS);
      vm.isEnabledConfigToCodrivers = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.CAN_CREATE_CO_DRIVER);
      vm.isMultiDriversConfigEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_MULTI_DRIVERS);
      vm.enableOrganizationSyncService = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_ORGANIZATION_SYNC_SERVICE);

      return $q.all({
        plan: plannerService.getPlan(),
        isNonBlockingSavingEnabled: planService.isNonBlockingSavingEnabled()
      })
        .then(function (results) {
          vm.isNonBlockingSavingEnabled = results.isNonBlockingSavingEnabled;

          return successGetPlan(results.plan);
        });

      function successGetPlan(plan) {
        vm.vehicles = plannerService.vehicles.filter(function (vehicle) {
          return vehicle.routes.length > 0;
        });

        vm.plannedDate = moment(plan.planDate.start).format('LL');
        vm.plannedDateLabel = moment(plan.planDate.start).format('LL');
        vm.drivers = plannerService.getDrivers();
        vm.planMergedName = plannerService.getPlanName();
        if (vm.planMergedName) {
          vm.planName = vm.planMergedName;
        }

        vm.planStatus = plan.planStatus;
        vm.joinSimilar = plannerService.localOptimizationOptions.join || plannerService.localOptimizationOptions.join_v2;
        routesUtils.updateSelectedDrivers(vm.vehicles, vm.drivers);

        if (vm.isEnabledConfigToCodrivers) {
          vm.codrivers = plannerService.getCodrivers();
          _initializeCodriversFromPlanner();
        }
      }
    }

    function savePlan(forceSave, status) {
      vm.saving = true;

      vm.savePlanErrorData = {
        type: null,
        visits: null,
        visitsTitles: []
      };

      //Check if there are empty routes and deleted
      _checkAndDeleteEmptyRoutes();

      var draftPlanId = plannerService.getPlanId();

      $rootScope.isLoading = true;

      var availabilityPromise = vm.enableOrganizationSyncService
        ? vehicleAvailabilityService.getAvailability(vm.enableOrganizationSyncService)
        : $q.when(null);

      availabilityPromise
        .then(function (response) {
          if (response) {
            var vehicleIdsWithRoutes = [];

            plannerService.vehicles.forEach(function (vehicle) {
              if (vehicle.routes && vehicle.routes.length > 0) {
                vehicleIdsWithRoutes.push(Number(vehicle.id));
              }
            });

            if (vehicleAvailabilityService.isThereAnyVehicleUnavailable(response.data, vehicleIdsWithRoutes)) {
              var error = new Error();
              error.status = HTTP_STATUS_CODE.BAD_REQUEST;
              error.data = {
                detail: {
                  code: VEHICLE_UNAVAILABLE_ERROR_CODE
                }
              };

              throw error;
            }
          }

          // createPlan is the new service
          var editingPlan = plannerService.getEditingPlan();
          if (editingPlan.status && !plannerService.isNewPlan()) {
            webEventService.post($location.path(), WEB_EVENTS.PLAN_EDITED,  draftPlanId);
            return plannerService.editPlan(vm.planName, vm.planMergedName, forceSave, status);
          }

          webEventService.post($location.path(), WEB_EVENTS.PLAN_CREATED,  draftPlanId);
          return plannerService.createPlan(vm.planName, $scope.isMultiDayRouteEnabled, forceSave, undefined, status);
        })
        .then(function () {
          plannerService.clearDraftPlanData(draftPlanId);
          $log.info("Plan saved succesfully");
          chatService.notifySavePlan({name: vm.planName});
          vm.savedPlan = true;
          vm.saving = false;
          var plan = plannerService.getPlanInfo(vm.planName);
          LogService.createLogForPlan(plan, $translations('Log.actions.editing_plan'));
          plannerService.setlocalOptimizationOptions(plannerService.optimizationOptions);
          webEventService.post($location.path(), WEB_EVENTS.PLAN_SAVED, draftPlanId);
          var optimizationResults = plannerService.getOptimizationResults();
          var selectedResult = optimizationResults && optimizationResults.find(function(r) { return r.isCurrentOptimization; });
          if (selectedResult) {
            webEventService.post($location.path(), WEB_EVENTS.MULTIVRP_SELECTED, draftPlanId, { variant_name: selectedResult.type });
          }
        })
        .catch(function (error) {
          vm.saving = false;
          vm.notSavedPlan = true;
          $log.error(error);

          if (error.status === HTTP_STATUS_CODE.BAD_REQUEST) {
            _handleSavePlanError(error.data);
          } else {
            ngDialog.closeAll();
            Toasts.push('error', $translations('Planner_toast.error_save_plan_finish'));
          }
          webEventService.post($location.path(), WEB_EVENTS.PLAN_FAILED, draftPlanId);
        })
        .finally(function () {
          $rootScope.isLoading = false;
        });
    }

    function _handleSavePlanError(error) {
      if (error.invalid_visits && error.invalid_visits.length > 0) {
        vm.savePlanErrorData = {
          type: INVALID_VISITS,
          visits: error.invalid_visits,
          visitsTitles: error.invalid_visits.map(function (visit) {
            return visit.title;
          })
        };
      } else if (error.canceled_visits && !lodash.isEmpty(error.canceled_visits)) {
        vm.savePlanErrorData = {
          type: CANCELED_VISITS,
          visits: error.canceled_visits,
          visitsTitles: Object.values(error.canceled_visits)
        };
      } else {
        var nonFieldErrors = error.non_field_errors || (error.detail && error.detail.non_field_errors);
        if (nonFieldErrors) {
          nonFieldErrors.forEach(function (message) {
            if (message.includes('account') && message.includes('name')) {
              vm.dataError.title = $translations('Routes.assignments.plan_name_error.title');
            } else {
              vm.dataError.title = $translations('Routes.assignments.default_error.title');
            }
          });
          vm.dataError.msg = $translations('Routes.assignments.default_error.message');
        } else if (error.planned_date) {
          vm.dataError.title = $translations('Routes.assignments.isErrorInPlanInstance');
          vm.dataError.msg = $translations('Routes.pleaseCorrects');
        } else if (error.detail && error.detail.code) {
          if (error.detail.code === ROUTE_STARTED_OR_FINISHED_ERROR_CODE) {
            vm.dataError.title = $translations("Routes.assignments.route_started_or_finished_error.title");
            vm.dataError.msg = $translations("Routes.assignments.route_started_or_finished_error.message");
          } else if (error.detail.code === VEHICLE_UNAVAILABLE_ERROR_CODE) {
            vm.dataError.title = $translations("Routes.assignments.vehicle_unavailable_error.title");
            vm.dataError.msg = $translations("Routes.assignments.vehicle_unavailable_error.message");
          }
        } else {
          vm.dataError.title = $translations('Routes.assignments.default_error.title');
          vm.dataError.msg = $translations('Routes.assignments.default_error.message');
        }
      }
    }

    function removeCanceledVisits() {
      if (vm.savePlanErrorData.type !== CANCELED_VISITS) {
        return;
      }
      _checkAndDeleteEmptyRoutes();
      _removeCanceledVisitsFromAllVisits();
      _removeCanceledVisitsFromVehicles();
      plannerService.clearPlanPromise();
    }

    function _removeCanceledVisitsFromAllVisits() {
      var canceledVisits = [];
      var nonCanceledVisits = [];
      var visits = planService.getVisits();

      visits.forEach(function(visit) {
        if (vm.savePlanErrorData.visits[visit.id]) {
          canceledVisits.push(visit);
        } else {
          nonCanceledVisits.push(visit);
        }
      });

      visitsMarkersService.removeVisitsOnMap(canceledVisits);
      visits.length = 0;
      Array.prototype.push.apply(visits, nonCanceledVisits);
    }

    function _removeCanceledVisitsFromVehicles() {
      var recalculateRouteStartingAtPromises = [];

      plannerService.vehicles.forEach(function(vehicle) {
        vehicle.routes.forEach(function(route) {
          var isAnyVisitCanceled = route.visits.some(function(visit) {
            return vm.savePlanErrorData.visits[visit.id];
          });
          if (!isAnyVisitCanceled) {
            return;
          }

          route.visits = route.visits.filter(function(visit) {
            return !vm.savePlanErrorData.visits[visit.id];
          });
          recalculateRouteStartingAtPromises.push(vehicle.recalculateRouteStartingAt(
            route, plannerService.optimizationOptions, plannerService));
        });
      });

      $q.all(recalculateRouteStartingAtPromises)
        .finally(function() {
          $scope.$emit(EVENT_RECALCULATE_STATISTICS);
        });
    }

    function _initializeCodriversFromPlanner() {
      function normalizeCodriverId(codriver) {
        return String(codriver.id || codriver);
      }

      function getVehicleCodrivers(vehicle) {
        if (vehicle.codrivers && Array.isArray(vehicle.codrivers)) {
          return vehicle.codrivers;
        }
        var vehicleCodrivers = plannerService.getCodriversByVehicleId(vehicle.id);
        if (vehicleCodrivers && Array.isArray(vehicleCodrivers)) {
          return vehicleCodrivers;
        }
        return [];
      }

      vm.vehicles.forEach(function(vehicle) {
        vehicle.routes.forEach(function(route) {
          if (route.codrivers.length === 0 && !route.backendId) {
            var vehicleCodrivers = getVehicleCodrivers(vehicle);
            route.codrivers = vehicleCodrivers.map(normalizeCodriverId);
          } else {
            route.codrivers = route.codrivers.map(normalizeCodriverId);
          }
        });
      });
    }

    function goToCodrivers(vehicle) {
      var specificRoute = null;

      if (vehicle && vehicle.vehicle) {
        specificRoute = vehicle.route || null;
        vehicle = vehicle.vehicle;
      }

      if (!vm.isEnabledConfigToCodrivers || !vehicle) {
        return;
      }

      var routesToEdit = specificRoute && vm.isMultiDriversConfigEnabled ? [specificRoute] : vehicle.routes;

      var vehicleCodriversIds = [];
      routesToEdit.forEach(function(route) {
        if (route.codrivers && Array.isArray(route.codrivers)) {
          route.codrivers.forEach(function(codriverId) {
            var normalizedId = String(codriverId);
            if (vehicleCodriversIds.indexOf(normalizedId) === -1) {
              vehicleCodriversIds.push(normalizedId);
            }
          });
        }
      });

      var availableCodrivers = {
        plansModule: true,
        itemsSelected: 0,
        items: [],
        msgItemsEmpty: ""
      };

      availableCodrivers.items = vm.codrivers.map(function(codriver) {
        var codriverId = String(codriver.id);
        var isSelected = vehicleCodriversIds.indexOf(codriverId) !== -1;
        return {
          id: codriverId,
          name: codriver.name,
          activated: isSelected
        };
      });

      availableCodrivers.itemsSelected = availableCodrivers.items.filter(function(item) {
        return item.activated;
      }).length;

      var dialog = ngDialog.open({
        template: 'app/planner/routes/finish-codrivers-modal.html',
        className: 'ngdialog-theme-default custom-width-1056',
        controller: 'FinishCodriversModalController',
        controllerAs: 'vm',
        showClose: false,
        closeByEscape: true,
        closeByDocument: false,
        resolve: {
          vehicle: function() {
            return vehicle;
          },
          availableCodrivers: function() {
            return availableCodrivers;
          },
          routes: function() {
            return routesToEdit;
          }
        }
      });

      dialog.closePromise.then(function(response) {
        if (response.value && response.value.codrivers) {
          var selectedCodrivers = response.value.codrivers;
          routesToEdit.forEach(function(route) {
            route.codrivers = selectedCodrivers.map(function(codriver) {
              return String(codriver.id || codriver);
            }).slice();
          });
        }
      });
    }

    function closeModal() {
      ngDialog.closeAll();
    }

    function _checkAndDeleteEmptyRoutes() {
      plannerService.vehicles.forEach(function (vehicle) {
        vehicle.routes.forEach(function (route) {
          if (route.visits.length === 0) {
            plannerService.removeVehicleRoute(vehicle, route);
          }
        });
      });
    }

    function clearPlan() {
      $rootScope.$broadcast("Planner:Clear:Map");
      plannerService.clearPlan();
      plannerService.setUserVisualState({});
    }

    function clearAndGoTo(state) {
      var language = $translate.use();
      var currentLanguage = ['es', 'en', 'pt'].includes(language) ? language : 'es';
      clearPlan();
      if (state === 'tracking') {
        $window.location.href = apolloAuthService.buildRedirectURL(currentLanguage + '/tracking');
      } else {
        $state.go(state, {});
      }
      $rootScope.$broadcast("planner:drawZonesOnMap");
      $rootScope.$broadcast("Planner:Plan:steps-reset");
      $rootScope.$broadcast("Planner:Plan-editing", {value: false});
    }

    function changeDate() {
      if (vm.popupOpened) {
        vm.popupOpened = false;
      } else {
        vm.popupOpened = true;
      }
    }

    function setDate() {
      plannerService.changeDateModal(moment(vm.plannedDate).format('YYYY-MM-DD'));
      vm.plannedDateLabel = moment(vm.plannedDate).format('LL');
    }

    function downloadReportTxt() {
      plannerService.exportPlanTxt();
    }

    function downloadReportExcel() {
      plannerService.exportPlanExcel();
    }

    function downloadReportPdf() {
      plannerService.exportPlanPdf();
    }

    function downloadReportSummarizedPdf() {
      var date = plannerService.getPlanDate();
      plannerReportsService.exportSummarizedPlanPdf(vm.vehicles, date.start);
    }

    function confirmCompletePlan() {
      var finishModal = document.getElementsByClassName('ngdialog-finish-plan')[0];
      finishModal.style.visibility = 'hidden';
      var confirmModal = ngDialog.open({
        template: 'app/planner/routes/routes-modals/confirm-complete-modal/confirm-complete-modal.html',
        showClose: false,
        closeByEscape: false,
        closeByDocument: false
      });
      vm.resolveConfirmation = confirmModal.closePromise;
      vm.resolveConfirmation.then(function (data) {
        var opCode = data.value;
        if (opCode === 1) {
          // Confirm plan
          finishModal.style.visibility = 'visible';
          savePlan(false, 'completed');
          return;
        }
        closeModal();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .controller('FinishCodriversModalController', FinishCodriversModalController);

  /** @ngInject */
  function FinishCodriversModalController(vehicle, availableCodrivers, routes, CODDRIVERS_ITEMS_PER_PAGE, sortDriversByDocStatusService) {
    var vm = this;

    vm.selectableCodrivers = {
      plansModule: true,
      itemsSelected: 0,
      items: [],
      msgItemsEmpty: ""
    };
    vm.itemsPerPage = CODDRIVERS_ITEMS_PER_PAGE;
    vm.vehicle = vehicle;
    vm.routes = routes;
    vm.originalCodrivers = [];

    vm.saveCodrivers = saveCodrivers;
    vm.cancelAndCloseModal = cancelAndCloseModal;

    activate();

    function activate() {
      vm.routes.forEach(function(route) {
        if (route.codrivers && Array.isArray(route.codrivers)) {
          route.codrivers.forEach(function(codriverId) {
            var normalizedId = String(codriverId);
            if (vm.originalCodrivers.indexOf(normalizedId) === -1) {
              vm.originalCodrivers.push(normalizedId);
            }
          });
        }
      });

      var sortedCodrivers = sortDriversByDocStatusService.sort(availableCodrivers.items, 'name');
      vm.selectableCodrivers.items = sortedCodrivers.map(function(codriver) {
        return {
          id: codriver.id,
          name: codriver.name,
          activate: codriver.activated
        };
      });
      vm.selectableCodrivers.itemsSelected = availableCodrivers.itemsSelected;
    }

    function saveCodrivers() {
      var selectedCodrivers = vm.selectableCodrivers.items.filter(function(codriver) {
        return codriver.activate;
      }).map(function(codriver) {
        return {
          id: codriver.id,
          name: codriver.name
        };
      });

      return {
        codrivers: selectedCodrivers
      };
    }

    function cancelAndCloseModal() {
      var originalCodrivers = vm.originalCodrivers.map(function(codriverId) {
        var codriver = availableCodrivers.items.find(function(item) {
          return String(item.id) === String(codriverId);
        });
        return {
          id: codriverId,
          name: codriver ? codriver.name : ''
        };
      });
      return {
        codrivers: originalCodrivers
      };
    }
  }
})();


(function() {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('ExpandModalService', ExpandModalService);

  /** @ngInject */
  function ExpandModalService($document, $compile, $rootScope) {
    var body = angular.element($document[0].body);

    var service = {
      open: open,
      close: close
    };

    return service;

    function open(options) {
      var modalScope = $rootScope.$new();
      angular.extend(modalScope, options.scope);

      var backdrop = angular.element($document[0].createElement('div'));
      backdrop.addClass('modal-backdrop');
      body.append(backdrop);

      var modalWrapper = angular.element($document[0].createElement('div'));
      modalWrapper.addClass('modal-wrapper');
      body.append(modalWrapper);

      var modalElement = angular.element($document[0].createElement('div'));
      modalElement.attr('ng-include', "'" + options.template + "'");
      var compiledModal = $compile(modalElement)(modalScope);
      modalWrapper.append(compiledModal);

      modalScope.closeModal = function() {
        close(modalWrapper, modalScope, backdrop);
      };

      function handleEscape(event) {
        if (event.keyCode === 27) {
          modalScope.$apply(function() {
            modalScope.closeModal();
          });
        }
      }

      body.on('keydown', handleEscape);

      return {
        close: modalScope.closeModal,
        scope: modalScope
      };
    }

    function close(modalWrapper, scope, backdrop) {
      modalWrapper.remove();
      backdrop.remove();
      scope.$destroy();
      body.off('keydown');
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.planner')
    .controller('ExpandModalController', ExpandModalController);

  /** @ngInject */
  function ExpandModalController($scope, $log, tagService, skillsService, plannerService, $translate,
    visitTypeService, $q, utilsService) {
    var vm = $scope.vm;
    vm.matchedTags = [];
    vm.matchedRequiredSkills = [];
    vm.matchedOptionalSkills = [];
    vm.priorityLevels = [];
    vm.visitTypes = [];
    vm.invoices = [];
    vm.isLoadingInvoices = false;
    vm.currentInvoiceIndex = 0;
    vm.formatMinutesToHHMM = utilsService.formatMinutesToHHMM;
    vm.sellerName = '';


    vm.priorityLevels = plannerService.getPriorityLevels();
    activate();

    // Add event listeners for idle and logout
    var idleWarningListener = $scope.$on('idleWarningShown', function() {
      if (angular.isFunction(vm.close)) {
        vm.close();
      }
    });

    var logoutListener = $scope.$on('userLoggedOut', function() {
      if (angular.isFunction(vm.close)) {
        vm.close();
      }
    });

    // Clean up listeners when controller is destroyed
    $scope.$on('$destroy', function() {
      if (angular.isFunction(idleWarningListener)) {
        idleWarningListener();
      }
      if (angular.isFunction(logoutListener)) {
        logoutListener();
      }
    });

    ////

    vm.getVisitTypeName = function(visitTypeKey) {
    if (!visitTypeKey || !vm.visitTypes) {
      return '';
    }
    var visitType = vm.visitTypes.find(function(type) {
      return type.key === visitTypeKey;
    });
    return visitType ? visitType.label : '';
  };

    vm.nextInvoice = function() {
      if (vm.currentInvoiceIndex < vm.invoices.length - 1) {
        vm.currentInvoiceIndex++;
      }
    };

    vm.previousInvoice = function() {
      if (vm.currentInvoiceIndex > 0) {
        vm.currentInvoiceIndex--;
      }
    };

    vm.hasNextInvoice = function() {
      return vm.currentInvoiceIndex < vm.invoices.length - 1;
    };

    vm.hasPreviousInvoice = function() {
      return vm.currentInvoiceIndex > 0;
    };

    vm.getPriorityName = function(value) {
      var priority = vm.priorityLevels.find(function(level) {
        return level.value === parseInt(value);
      });
      return priority ? priority.name : '';
    };

    vm.getVehicleName = function(vehicleId) {
        if(!vm.vehicles || !vehicleId){
          return '';
        }

        var vehicle = plannerService.getVehicleById(vehicleId);

        return vehicle ? vehicle.name : '';
    };


    vm.formatTimeWindow = function(start, end) {
      if (!start || !end) {
        return '';
      }

      return $translate.instant('Expand_modal.time_format.from') + ' ' +
             start + ' ' +
             $translate.instant('Expand_modal.time_format.to') + ' ' +
             end;
    };

    function activate() {
      vm.isLoading = true;
      var sellers = plannerService.getSellers();

      if (sellers && vm.visit.seller_id) {
        var seller = sellers.find(function(seller) {
          return seller.id === vm.visit.seller_id;
        });
        vm.sellerName = seller ? seller.name : '';
      }

      $q.all({
        tags: tagService.getTags(),
        skills: skillsService.list(),
        visitTypes: visitTypeService.getVisitTypes()
      })
      .then(function(results) {
        vm.visitTypes = results.visitTypes;

        if (vm.visit.tags) {
          vm.matchedTags = vm.visit.tags.map(function(tagId) {
            return results.tags.find(function(tag) {
              return tag.id === tagId;
            });
          }).filter(Boolean);
        }

        if (vm.visit.skills_required) {
          vm.matchedRequiredSkills = vm.visit.skills_required.map(function(skillId) {
            return results.skills.find(function(skill) {
              return skill.id.toString() === skillId.toString();
            });
          }).filter(Boolean);
        }

        if (vm.visit.skills_optional) {
          vm.matchedOptionalSkills = vm.visit.skills_optional.map(function(skillId) {
            return results.skills.find(function(skill) {
              return skill.id.toString() === skillId.toString();
            });
          }).filter(Boolean);
        }
      })
      .catch(function(error) {
        $log.error('Error fetching data:', error);
      })
      .finally(function() {
        vm.isLoading = false;
      });
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.planner')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations('es', {
      'Expand_modal': {
        'visit': 'Visita',
        'loads': 'Cargas',
        'address': 'Dirección',
        'seller': 'Seller',
        'time_windows': {
          'title_1': 'Ventana horaria 1',
          'title_2': 'Ventana horaria 2'
        },
        'service_time': 'Tiempo de servicio',
        'priority': 'Prioridad',
        'notes': 'Notas',
        'visit_type': 'Tipo de visita',
        'tags': 'Etiquetas',
        'contact': {
          'title': 'Contacto',
          'name': 'Nombre de contacto',
          'email': 'Correo electrónico',
          'phone': 'Teléfono'
        },
        'skills': {
          'title': 'Habilidades',
          'required': 'Habilidades requeridas',
          'optional': 'Habilidades opcionales'
        },
        'tabs': {
          'information': 'Información',
          'documents': 'Documentos',
          'items': 'Ítems'
        },
        'items': {
          'item': 'Ítem',
          'quantity': 'Cantidad'
        },
        'time_format': {
          'from': 'De',
          'to': 'A'
        },
        'document': {
          'title': 'Documentos',
          'reference': 'Referencia',
          'type': 'Tipo',
          'status': 'Estado',
          'payment_method': 'Método de pago',
          'previous': 'Anterior documento',
          'next': 'Siguiente documento',
          'no_invoices': 'No hay documentos'
        }
      },
      'credit_note': 'Nota de crédito',
      'invoice': 'Factura',
      'pending': 'Pendiente',
      'completed': 'Completado',
      'check': 'Cheque',
      'cash': 'Efectivo',
      'credit_card': 'Tarjeta de crédito'
    });

    $translateProvider.translations('en', {
      'Expand_modal': {
        'visit': 'Visit',
        'loads': 'Loads',
        'address': 'Address',
        'seller': 'Seller',
        'time_windows': {
          'title_1': 'Time Window 1',
          'title_2': 'Time Window 2'
        },
        'service_time': 'Service Time',
        'priority': 'Priority',
        'notes': 'Notes',
        'visit_type': 'Visit Type',
        'tags': 'Tags',
        'contact': {
          'title': 'Contact',
          'name': 'Contact Name',
          'email': 'Email',
          'phone': 'Phone'
        },
        'skills': {
          'title': 'Skills',
          'required': 'Required Skills',
          'optional': 'Optional Skills'
        },
        'tabs': {
          'information': 'Information',
          'documents': 'Documents',
          'items': 'Items'
        },
        'items': {
          'item': 'Item',
          'quantity': 'Quantity'
        },
        'time_format': {
          'from': 'From',
          'to': 'to'
        },
        'document': {
          'title': 'Documents',
          'reference': 'Reference',
          'type': 'Type',
          'status': 'Status',
          'payment_method': 'Payment Method',
          'previous': 'Previous document',
          'next': 'Next document',
          'no_invoices': 'No documents found'
        }
      },
      'credit_note': 'Credit Note',
      'invoice': 'Invoice',
      'pending': 'Pending',
      'completed': 'Completed',
      'check': 'Check',
      'cash': 'Cash',
      'credit_card': 'Credit Card'
    });

    $translateProvider.translations('pt', {
      'Expand_modal': {
        'visit': 'Visita',
        'loads': 'Cargas',
        'address': 'Endereço',
        'seller': 'Seller',
        'time_windows': {
          'title_1': 'Janela de tempo 1',
          'title_2': 'Janela de tempo 2'
        },
        'service_time': 'Tempo de serviço',
        'priority': 'Prioridade',
        'notes': 'Notas',
        'visit_type': 'Tipo de visita',
        'tags': 'Etiquetas',
        'contact': {
          'title': 'Contato',
          'name': 'Nome do contato',
          'email': 'Email',
          'phone': 'Telefone'
        },
        'skills': {
          'title': 'Habilidades',
          'required': 'Habilidades requeridas',
          'optional': 'Habilidades opcionais'
        },
        'tabs': {
          'information': 'Informação',
          'documents': 'Documentos',
          'items': 'Items'
        },
        'items': {
          'item': 'Item',
          'quantity': 'Quantidade'
        },
        'time_format': {
          'from': 'De',
          'to': 'até'
        },
        'document': {
          'title': 'Documentos',
          'reference': 'Referência',
          'type': 'Tipo',
          'status': 'Estado',
          'payment_method': 'Método de pagamento',
          'previous': 'Documento anterior',
          'next': 'Próximo documento',
          'no_invoices': 'Nenhum documento encontrado'
        }
      },
      'credit_note': 'Nota de crédito',
      'invoice': 'Fatura',
      'pending': 'Pendente',
      'completed': 'Concluído',
      'check': 'Cheque',
      'cash': 'Dinheiro',
      'credit_card': 'Cartão de crédito'
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.planner')
    .directive('ellipsisTooltip', ellipsisTooltip);

  ellipsisTooltip.$inject = ['$timeout', '$window'];

  function ellipsisTooltip($timeout, $window) {
    return {
      restrict: 'A',
      scope: true,
      link: function(scope, element) {
        function checkEllipsis() {
          scope.$applyAsync(function() {
            var el = element[0];
            var isLoadsContainer = el.classList.contains('sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content-wrapper-left__top');

            if (isLoadsContainer) {
              var pTags = el.getElementsByTagName('p');
              scope.showTooltip = Array.from(pTags).some(function(p) {
                var isOverflowing = p.offsetWidth < p.scrollWidth;
                return isOverflowing && p.textContent.trim().length > 0;
              });
            } else {
              scope.showTooltip = el.offsetWidth < el.scrollWidth;
            }
          });
        }

        $timeout(checkEllipsis, 1000);
        $timeout(checkEllipsis, 1500);

        angular.element($window).on('resize', checkEllipsis);

        scope.$on('$destroy', function() {
          angular.element($window).off('resize', checkEllipsis);
        });

        scope.$watch(function() {
          return element.text();
        }, checkEllipsis);
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('accountingService', accountingService);

  /** @ngInject */
  function accountingService($http, $q, __env, $log) {
    var ACCOUNTING_API_PATH = __env.API_URL + 'accounting/';

    var service = {
      getInvoicesByVisit: getInvoicesByVisit
    };

    return service;

    ////////////

    function getInvoicesByVisit(visitId) {
      if (!visitId) {
        return $q.reject('No visit ID provided');
      }

      return $http.get(ACCOUNTING_API_PATH + 'invoices', {
        params: {
          visit_id: visitId
        }
      })
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        $log.error('Error fetching invoices:', error);
        return $q.reject(error);
      });
    }
  }
})();

(function () {
  "use strict";

  angular.module("icarus.planner").service("visitsUtils", visitsUtils);

  /** @ngInject */
  function visitsUtils(
    timeUtils,
    $filter,
    __env,
    MAX_EMAILS_INPUT,
    JOINED_EMAILS_MAX_LENGTH
  ) {
    var TIME_FORMAT = "HH:mm";
    var $translate = $filter("translate");

    return {
      isWithinTimeWindow: isWithinTimeWindow,
      getAlertString: getAlertString,
      filterVisits: filterVisits,
      areValidVisitWindowTimes: areValidVisitWindowTimes,
      areValidVisitWindowTimesWithOvernightSupport:
        areValidVisitWindowTimesWithOvernightSupport,
      isValidTimeService: isValidTimeService,
      validateEmailsLength: validateEmailsLength,
      validateEmailsQuantity: validateEmailsQuantity,
      validateEmailFormat: validateEmailFormat,
      joinEmails: joinEmails,
      checkTimeWindow: checkTimeWindow,
      checkTimeWindowWithOvernightSupport: checkTimeWindowWithOvernightSupport,
      skillsHandler: skillsHandler,
      isSkillSelected: isSkillSelected,
      tagSelectedHandler: tagSelectedHandler,
      isTagSelected: isTagSelected,
      areVisitsFromSameOrNoSourceRoute: areVisitsFromSameOrNoSourceRoute,
    };

    function isWithinTimeWindow(windowStart, windowEnd, estimatedTimeArrival) {
      var momentWindowStart = timeUtils.createTime(windowStart, TIME_FORMAT);
      var momentWindowEnd = timeUtils.createTime(windowEnd, TIME_FORMAT);
      var etaWithFormat = timeUtils
        .createTime(estimatedTimeArrival)
        .format(TIME_FORMAT);
      var etaResult = timeUtils.createTime(etaWithFormat, TIME_FORMAT);

      return timeUtils.isBetween(etaResult, momentWindowStart, momentWindowEnd);
    }

    function getAlertString(visit) {
      var alerts = [
        "capacityError",
        "capacityError2",
        "capacityError3",
        "maximumTimeError",
        "skillsError",
        "timeError",
      ];

      var visitAlerts = alerts.reduce(function (acc, alert) {
        if (visit[alert]) {
          acc.push($translate("Visits.visits_utils." + alert));
        }
        return acc;
      }, []);

      return visitAlerts.join(",");
    }

    function filterVisits(handler, filters, visits, visible, minTime, maxTime) {
      var filteredVisits = filters.filterByTimeWindow(visits, minTime, maxTime);
      filteredVisits.forEach(function (visit) {
        if (visible) {
          visit.setVisible(visible, false);
          visit.actionCreate(visit);
        }
      });

      handler.setActiveFilter(true);
      handler.setMinSliderTime(minTime);
      handler.setMaxSliderTime(maxTime);
      handler.setVisits(filteredVisits);
    }

    function areValidVisitWindowTimes(visit) {
      visit.windowOneError = false;
      visit.windowTwoError = false;
      visit.OverlappingWindowError = false;

      var areValid = true;
      var momentWindowStart = visit.windowStart
        ? moment(visit.windowStart, "HH:mm")
        : null;
      var momentWindowEnd = visit.windowEnd
        ? moment(visit.windowEnd, "HH:mm")
        : null;
      var momentWindowStart2 = visit.windowStart2
        ? moment(visit.windowStart2, "HH:mm")
        : null;
      var momentWindowEnd2 = visit.windowEnd2
        ? moment(visit.windowEnd2, "HH:mm")
        : null;

      if (
        visit.windowStart &&
        visit.windowEnd &&
        momentWindowStart.isAfter(momentWindowEnd)
      ) {
        visit.windowOneError = true;
        visit.status = 4;
        visit.error = {
          type: 4,
          msg: $filter("translate")("Visits.alert_notification.error_window"),
        };
        areValid = false;
      } else if (
        visit.windowStart2 &&
        visit.windowEnd2 &&
        momentWindowStart2.isAfter(momentWindowEnd2)
      ) {
        visit.windowTwoError = true;
        visit.status = 4;
        visit.error = {
          type: 4,
          msg: $filter("translate")("Visits.alert_notification.error_window"),
        };
        areValid = false;
      } else if (
        visit.windowStart &&
        visit.windowEnd &&
        visit.windowStart2 &&
        visit.windowEnd2 &&
        momentWindowEnd.isAfter(momentWindowStart2)
      ) {
        visit.OverlappingWindowError = true;
        visit.status = 4;
        visit.error = {
          type: 4,
          msg: $filter("translate")("Visits.alert_notification.error_window"),
        };
        areValid = false;
      } else if (
        (visit.windowStart || visit.windowEnd) &&
        (visit.windowStart2 || visit.windowEnd2) &&
        !(
          visit.windowStart &&
          visit.windowEnd &&
          visit.windowStart2 &&
          visit.windowEnd2
        ) &&
        !(
          (!visit.windowStart &&
            visit.windowEnd &&
            visit.windowStart2 &&
            !visit.windowEnd2) ||
          (visit.windowStart &&
            visit.windowEnd &&
            visit.windowStart2 &&
            !visit.windowEnd2) ||
          (!visit.windowStart &&
            visit.windowEnd &&
            visit.windowStart2 &&
            visit.windowEnd2)
        )
      ) {
        visit.OverlappingWindowError = true;
        visit.status = 4;
        visit.error = {
          type: 4,
          msg: $filter("translate")("Visits.alert_notification.error_window"),
        };
        areValid = false;
      }

      return areValid;
    }

    function isValidTimeService(visit) {
      var serviceTimeError = isNaN(visit.duration);
      if (!serviceTimeError) {
        serviceTimeError = _checkTimeServiceInvalidRange(visit);
      }

      return serviceTimeError;
    }

    function validateEmailsLength(tag, emails) {
      var emailsCopy = JSON.parse(JSON.stringify(emails));
      emailsCopy.push(tag);
      var joinedEmails = joinEmails(emailsCopy);
      var validLength = joinedEmails.length <= JOINED_EMAILS_MAX_LENGTH;
      return validLength;
    }

    function validateEmailsQuantity(emails) {
      var validEmailsQuantity = emails.length < MAX_EMAILS_INPUT;
      return validEmailsQuantity;
    }

    function validateEmailFormat(tag) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var validEmail = re.test(tag.text);
      return validEmail;
    }

    function joinEmails(emailsList) {
      return emailsList
        .map(function (email) {
          return email.text;
        })
        .join(",");
    }

    /**
     * Validates time window format and logic with shared common functionality
     * @param {number} timeWindowId - The time window ID (1 or 2)
     * @param {Object} visit - The visit object containing time window data
     * @param {function} timeComparisonFn - Function to determine if times are invalid
     * @returns {Object} Time validation results
     */
    function _validateTimeWindow(timeWindowId, visit, timeComparisonFn) {
      var re = /^([0-1]?[0-9]|2[0-3])(:[0-5][0-9])?$/;
      var startName = timeWindowId > 1 ? "windowStart2" : "windowStart";
      var endName = timeWindowId > 1 ? "windowEnd2" : "windowEnd";
      var suffix = timeWindowId > 1 ? "2" : "";

      var timeValidations = {};

      // Check for invalid time format
      if (
        (visit[startName] && !re.test(visit[startName])) ||
        (visit[endName] && !re.test(visit[endName]))
      ) {
        timeValidations["invalidDate" + suffix] = true;
        timeValidations["emptyDate" + suffix] = false;
        timeValidations["timeBetweenDate" + suffix] = false;
      }
      // Check for incomplete time pairs
      else if (
        (visit[startName] && !visit[endName]) ||
        (!visit[startName] && visit[endName])
      ) {
        timeValidations["emptyDate" + suffix] = true;
        timeValidations["invalidDate" + suffix] = false;
        timeValidations["timeBetweenDate" + suffix] = false;
      }
      // Check time logic using provided comparison function
      else if (
        visit[startName] &&
        visit[endName] &&
        timeComparisonFn(
          moment(visit[startName], "HH:mm"),
          moment(visit[endName], "HH:mm")
        )
      ) {
        timeValidations["invalidDate" + suffix] = false;
        timeValidations["emptyDate" + suffix] = false;
        timeValidations["timeBetweenDate" + suffix] = true;
      }
      // Valid time window
      else {
        timeValidations["invalidDate" + suffix] = false;
        timeValidations["emptyDate" + suffix] = false;
        timeValidations["timeBetweenDate" + suffix] = false;
      }

      // Format valid times
      if (visit[startName] && re.test(visit[startName])) {
        visit[startName] = moment(visit[startName], "HH:mm").format("HH:mm");
      }

      if (visit[endName] && re.test(visit[endName])) {
        visit[endName] = moment(visit[endName], "HH:mm").format("HH:mm");
      }

      return timeValidations;
    }

    function checkTimeWindow(timeWindowId, visit) {
      return _validateTimeWindow(
        timeWindowId,
        visit,
        function (startMoment, endMoment) {
          return startMoment.isSameOrAfter(endMoment);
        }
      );
    }

    /**
     * Validates time windows with support for overnight windows (e.g., 22:00 - 06:00)
     */
    function checkTimeWindowWithOvernightSupport(timeWindowId, visit) {
      return _validateTimeWindow(
        timeWindowId,
        visit,
        function (startMoment, endMoment) {
          return startMoment.isSame(endMoment);
        }
      );
    }

    function _checkTimeServiceInvalidRange(visit) {
      return (
        visit.duration < 0 || visit.duration > __env.MAX_TIME_SERVICE_VALUE
      );
    }

    /**
     * Handles the selection of skills and the visibility of opposing skills.
     * @param {string} skillId - The ID of the skill being handled.
     * @param {Array} visitSkills - Array of visit skills being handled.
     * @param {Array} opposingSkills - Array of opposing skills.
     */
    function skillsHandler(skillId, visitSkills, opposingSkills) {
      if (isSkillSelected(skillId, visitSkills)) {
        visitSkills.splice(visitSkills.indexOf(skillId), 1);
      } else {
        visitSkills.push(skillId);
      }

      opposingSkills.forEach(function (opposingSkill) {
        if (opposingSkill.id === skillId) {
          opposingSkill.visible = !opposingSkill.visible;
        }
      });
    }

    function isSkillSelected(skillId, skillsList) {
      return skillsList ? skillsList.indexOf(skillId) !== -1 : false;
    }

    function tagSelectedHandler(tagId, visitTags) {
      if (isTagSelected(tagId, visitTags)) {
        visitTags.splice(visitTags.indexOf(tagId), 1);
      } else {
        visitTags.push(tagId);
      }
    }

    function isTagSelected(tagId, visitTags) {
      return visitTags ? visitTags.indexOf(tagId) !== -1 : false;
    }

    function areVisitsFromSameOrNoSourceRoute(visit, similarVisit) {
      return (
        !visit.sourceRouteId ||
        !similarVisit.sourceRouteId ||
        visit.sourceRouteId === similarVisit.sourceRouteId
      );
    }

    /**
     * Validates visit window times with support for overnight windows
     */
    function areValidVisitWindowTimesWithOvernightSupport(visit) {
      visit.windowOneError = false;
      visit.windowTwoError = false;
      visit.OverlappingWindowError = false;

      var areValid = true;
      var momentWindowStart = visit.windowStart
        ? moment(visit.windowStart, "HH:mm")
        : null;
      var momentWindowEnd = visit.windowEnd
        ? moment(visit.windowEnd, "HH:mm")
        : null;
      var momentWindowStart2 = visit.windowStart2
        ? moment(visit.windowStart2, "HH:mm")
        : null;
      var momentWindowEnd2 = visit.windowEnd2
        ? moment(visit.windowEnd2, "HH:mm")
        : null;

      if (
        visit.windowStart &&
        visit.windowEnd &&
        momentWindowStart.isSame(momentWindowEnd)
      ) {
        visit.windowOneError = true;
        visit.status = 4;
        visit.error = {
          type: 4,
          msg: $filter("translate")("Visits.alert_notification.error_window"),
        };
        areValid = false;
      } else if (
        visit.windowStart2 &&
        visit.windowEnd2 &&
        momentWindowStart2.isSame(momentWindowEnd2)
      ) {
        visit.windowTwoError = true;
        visit.status = 4;
        visit.error = {
          type: 4,
          msg: $filter("translate")("Visits.alert_notification.error_window"),
        };
        areValid = false;
      } else if (
        visit.windowStart &&
        visit.windowEnd &&
        visit.windowStart2 &&
        visit.windowEnd2 &&
        _checkOvernightWindowsOverlap(visit)
      ) {
        visit.OverlappingWindowError = true;
        visit.status = 4;
        visit.error = {
          type: 4,
          msg: $filter("translate")("Visits.alert_notification.error_window"),
        };
        areValid = false;
      } else if (
        (visit.windowStart || visit.windowEnd) &&
        (visit.windowStart2 || visit.windowEnd2) &&
        !(
          visit.windowStart &&
          visit.windowEnd &&
          visit.windowStart2 &&
          visit.windowEnd2
        ) &&
        !(
          (!visit.windowStart &&
            visit.windowEnd &&
            visit.windowStart2 &&
            !visit.windowEnd2) ||
          (visit.windowStart &&
            visit.windowEnd &&
            visit.windowStart2 &&
            !visit.windowEnd2) ||
          (!visit.windowStart &&
            visit.windowEnd &&
            visit.windowStart2 &&
            visit.windowEnd2)
        )
      ) {
        visit.OverlappingWindowError = true;
        visit.status = 4;
        visit.error = {
          type: 4,
          msg: $filter("translate")("Visits.alert_notification.error_window"),
        };
        areValid = false;
      }

      return areValid;
    }

    /**
     * Helper function to check overlap with overnight window support
     */
    function _checkOvernightWindowsOverlap(visit) {
      var window1Start = moment(visit.windowStart, "HH:mm");
      var window1End = moment(visit.windowEnd, "HH:mm");
      var window2Start = moment(visit.windowStart2, "HH:mm");
      var window2End = moment(visit.windowEnd2, "HH:mm");

      var window1IsOvernight = window1Start.isAfter(window1End);
      var window2IsOvernight = window2Start.isAfter(window2End);

      if (!window1IsOvernight && !window2IsOvernight) {
        return window1End.isAfter(window2Start);
      }

      if (window1IsOvernight && !window2IsOvernight) {
        return !(
          window2End.isBefore(window1Start) && window2Start.isAfter(window1End)
        );
      }

      if (!window1IsOvernight && window2IsOvernight) {
        return !(
          window1End.isBefore(window2Start) && window1Start.isAfter(window2End)
        );
      }

      return true;
    }
  }
})();

/* XLSX:false, ArrayBuffer:false, Uint8Array:false, ConvexHullGrahamScan:false */
(function() {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('xlsxService', xlsxService);

  /** @ngInject */
  function xlsxService () {
    var service = {
      getCustomExampleData: getCustomExampleData
    };

    var customData = {
      'CL' : [
        {
          'excel_title': 'CONFITERIA SAN RODRIGO',
          'excel_address': 'SANTA MARIA 2670, PROVIDENCIA, Santiago',
          'excel_load': '50',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '20',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Paulina Muñoz',
          'excel_contact_phone': '965847147',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'paulinamunoz@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': '',
          'excel_city': ''
        },
        {
          'excel_title': 'JUGUETES JIMENEZ',
          'excel_address': 'MARTIN DE ZAMORA 2964, LAS CONDES, Santiago',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '10',
          'excel_notes': 'Cuidado con el perro',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'David Rosales',
          'excel_contact_phone': '994345856',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'davidrosales@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': '',
          'excel_city': ''
        },
        {
          'excel_title': 'INDUMECANICA SA',
          'excel_address': 'Américo Vespucio 2680, Pudahuel, Región Metropolitana, Chile',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Sergio Aguilera',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'sergioaguilera@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': '',
          'excel_city': ''
        },
        {
          'excel_title': 'COMPUMUNDO HIPER MEGA RED',
          'excel_address': 'PRESIDENTE RIESCO 5561, LAS CONDES, Santiago',
          'excel_load': '25',
          'excel_hour_start': '10:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Lucas Uribe',
          'excel_contact_phone': '977586912',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'lucasuribe@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': '',
          'excel_city': ''
        },
        {
          'excel_title': 'CONGLOM-O',
          'excel_address': 'ANDRES BELLO 2711, LAS CONDES, Santiago',
          'excel_load': '35',
          'excel_hour_start': '10:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Alonso Olate',
          'excel_contact_phone': '973625489',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'alonsoolate@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': '',
          'excel_city': ''
        }
      ],
      'PE' : [
        {
          'excel_title': 'CONFITERIA SAN RODRIGO',
          'excel_address': 'Av. Nicolás de Piérola 262, Lima',
          'excel_load': '50',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '20',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Paulina Muñoz',
          'excel_contact_phone': '965847147',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'paulinamunoz@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'JUGUETES JIMENEZ',
          'excel_address': 'Avenida Uruguay 512, Distrito de Lima',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '10',
          'excel_notes': 'Cuidado con el perro',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'David Rosales',
          'excel_contact_phone': '994345856',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'davidrosales@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'INDUMECANICA SA',
          'excel_address': 'Jirón Joaquín Capello 2749, Distrito de Lima',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Sergio Aguilera',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'sergioaguilera@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'COMPUMUNDO HIPER MEGA RED',
          'excel_address': 'Avenida Simón Bolivar 1515, Lima',
          'excel_load': '25',
          'excel_hour_start': '10:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Lucas Uribe',
          'excel_contact_phone': '977586912',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'lucasuribe@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'CONGLOM-O',
          'excel_address': 'Valdez 621, Lima',
          'excel_load': '35',
          'excel_hour_start': '10:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Alonso Olate',
          'excel_contact_phone': '973625489',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'alonsoolate@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        }
      ],
      'IN' : [
        {
          'excel_title': 'Saint Patrick Beers',
          'excel_address': '1, Amrita Shergill Marg, Rabindra Nagar, New Delhi',
          'excel_load': '50',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '20',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Paulina Muñoz',
          'excel_contact_phone': '965847147',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'paulinamunoz@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'Jameson Toys',
          'excel_address': 'Rahim Khan Marg, Nizamuddin, Jaipur Estata, Nizamuddin East, New Delhi',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '10',
          'excel_notes': 'Watch out with the dog!',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'David Rosales',
          'excel_contact_phone': '994345856',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'davidrosales@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'Mechanics INC',
          'excel_address': 'C-178, Doctor Ramlal Verma Marg, New Delhi',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Sergio Aguilera',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'sergioaguilera@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'Super High Speed Net',
          'excel_address': 'E-68, Kalka Devi Marg, Block E, Amar Colony, Lajpat Nagar 4, New Delhi',
          'excel_load': '25',
          'excel_hour_start': '10:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Lucas Uribe',
          'excel_contact_phone': '977586912',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'lucasuribe@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'CONGLOM-O',
          'excel_address': 'Tigri Bank Road, Deoli Gaon Nai Basti, Sangam Vihar, New Delhi, Delhi 110044',
          'excel_load': '35',
          'excel_hour_start': '10:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Alonso Olate',
          'excel_contact_phone': '973625489',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'alonsoolate@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        }
      ],
      'US' : [
        {
          'excel_title': 'Mr Smith',
          'excel_address': '1152 Valencia St, San Francisco, CA 94110',
          'excel_load': '50',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '20',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Pauline Muniz',
          'excel_contact_phone': '965847147',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'paulinemuniz@example.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'Red Lantern',
          'excel_address': '5801 Geary Blvd, San Francisco, CA 94121',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '10',
          'excel_notes': 'Watch out with the dog!',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'David Flowers',
          'excel_contact_phone': '994345856',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'davidrosales@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'Saru Sushi Bar',
          'excel_address': '3856 24th St, San Francisco, CA 94114',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Serge Wingers',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'sergewingers@example.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'Sushi Zone',
          'excel_address': '1815 Market St, San Francisco, CA 94103',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '15',
          'excel_notes': '7th floor',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Lucas Urib',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'lucasuribe@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'Akiko’s Restaurant',
          'excel_address': '431 Bush St, San Francisco, CA 94108',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Al Olatte',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'alolatte@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        }
      ],
      'AU' : [
        {
          'excel_title': 'Saint Patrick Beers',
          'excel_address': '417 Pitt St, Sydney',
          'excel_load': '50',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '20',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Pauline Muniz',
          'excel_contact_phone': '965847147',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'paulinemuniz@example.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'Jameson Toys',
          'excel_address': '88 Crown St, Woolloomooloo, Sydney',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '10',
          'excel_notes': 'Watch out with the dog!',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'David Flowers',
          'excel_contact_phone': '994345856',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'davidrosales@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'Mechanics INC',
          'excel_address': '100/136 Barcom Ave Darlinghurst, Sydney',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Serge Wingers',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'sergewingers@example.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'Super High Speed Net',
          'excel_address': '245 Oxford St, Paddington, Sydney',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '15',
          'excel_notes': '7th floor',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Lucas Urib',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'lucasuribe@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'Conglom-o',
          'excel_address': '189 Jones St, Ultimo, Sydney',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Al Olatte',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'alolatte@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        }
      ],
      'CO' : [
        {
          'excel_title': 'CONFITERIA SAN RODRIGO',
          'excel_address': 'Calle 125 #52A-17, Bogotá',
          'excel_load': '50',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '20',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Paulina Muñoz',
          'excel_contact_phone': '965847147',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'paulinamunoz@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'JUGUETES JIMENEZ',
          'excel_address': 'Calle 115 #48-1, Bogotá',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '10',
          'excel_notes': 'Watch out with the dog!',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'David Rosales',
          'excel_contact_phone': '994345856',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'davidrosales@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'INDUMECANICA SA',
          'excel_address': 'Carrera 13 Bis #109-2, Bogotá',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Serge Aguilera',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'sergeaguilera@example.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'COMPUMUNDO HIPER MEGA RED',
          'excel_address': 'Calle 2a #69f-2, Bogotá',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '15',
          'excel_notes': '7th floor',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Lucas Uribe',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'lucasuribe@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'Conglom-o',
          'excel_address': 'Calle 39g Sur #68g-1, Bogotá',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Al Olatte',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'alolatte@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        }
      ],
      'AR' : [
        {
          'excel_title': 'CONFITERIA SAN RODRIGO',
          'excel_address': 'Avenida Juan B. Justo 5556, Buenos Aires',
          'excel_load': '50',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '20',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Paulina Muñoz',
          'excel_contact_phone': '965847147',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'paulinamunoz@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'JUGUETES JIMENEZ',
          'excel_address': 'Balbastro 770, Buenos Aires',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '10',
          'excel_notes': 'Watch out with the dog!',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'David Rosales',
          'excel_contact_phone': '994345856',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'davidrosales@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'INDUMECANICA SA',
          'excel_address': 'Alta Gracia 3330, Buenos Aires',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Serge Aguilera',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'sergeaguilera@example.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'COMPUMUNDO HIPER MEGA RED',
          'excel_address': 'Elpidio González 5010, Buenos Aires',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '15',
          'excel_notes': '7th floor',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Lucas Uribe',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'lucasuribe@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'Conglom-o',
          'excel_address': 'Figueroa Alcorta 4128, Buenos Aires',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Al Olatte',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'alolatte@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        }
      ],
      'MX' : [
        {
          'excel_title': 'CONFITERIA SAN RODRIGO',
          'excel_address': 'Pintores 129,  Emilio Carranza, Ciudad de Mexico',
          'excel_load': '50',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '20',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Paulina Muñoz',
          'excel_contact_phone': '965847147',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'paulinamunoz@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'JUGUETES JIMENEZ',
          'excel_address': 'Cuauhtémoc 138,  Aragón La Villa(Aragón), Ciudad de Mexico',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '10',
          'excel_notes': 'Watch out with the dog!',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'David Rosales',
          'excel_contact_phone': '994345856',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'davidrosales@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'INDUMECANICA SA',
          'excel_address': 'Tezonapa 10, San Sebastian, Ciudad de Mexico',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Serge Aguilera',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'sergeaguilera@example.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'COMPUMUNDO HIPER MEGA RED',
          'excel_address': 'Calle Camino a Nextengo 512, Santiago Ahuizotla, Ciudad de Mexico',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '15',
          'excel_notes': '7th floor',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Lucas Uribe',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'lucasuribe@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'Conglom-o',
          'excel_address': 'Gumersindo Esquer 80, Asturias, Ciudad de Mexico',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Al Olatte',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'alolatte@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        }
      ],
      'BR' : [
        {
          'excel_title': 'CONFEITARIA SAN RODRIGO',
          'excel_address': 'Rua da Mooca  620 - Mooca, São Paulo',
          'excel_load': '50',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '20',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Paulina Muñoz',
          'excel_contact_phone': '965847147',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'paulinamunoz@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'JUGUETES JIMENEZ',
          'excel_address': 'Cuauhtémoc 138,  Aragón La Villa(Aragón), Ciudad de Mexico',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '10',
          'excel_notes': 'Watch out with the dog!',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'David Rosales',
          'excel_contact_phone': '994345856',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'davidrosales@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'INDUMECANICA SA',
          'excel_address': 'R. Augusta, 449 - Consolação, São Paulo',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Serge Aguilera',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'sergeaguilera@example.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'COMPUMUNDO',
          'excel_address': 'R. Mário, 140 - Vila Romana, São Paulo',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '15',
          'excel_notes': '7th floor',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Lucas Uribe',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'lucasuribe@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'Conglom-o',
          'excel_address': 'R. Gomes Nogueira, 462 - Ipiranga, São Paulo',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Al Olatte',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'alolatte@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        }
      ],
      'ES' : [
        {
          'excel_title': 'CONFITERIA SAN RODRIGO',
          'excel_address': 'Calle de Alcalá 4, Madrid',
          'excel_load': '50',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '20',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Paulina Muñoz',
          'excel_contact_phone': '965847147',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'paulinamunoz@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'JUGUETES JIMENEZ',
          'excel_address': 'Calle San Leonardo 5, Madrid',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '10',
          'excel_notes': 'Watch out with the dog!',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'David Rosales',
          'excel_contact_phone': '994345856',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'davidrosales@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'INDUMECANICA SA',
          'excel_address': 'Calle Juan de la Hoz 17, Madrid',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Serge Aguilera',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'sergeaguilera@example.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'COMPUMUNDO HIPER MEGA RED',
          'excel_address': 'Calle de Padre Damián 34, Madrid',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '17:00',
          'excel_service_time': '15',
          'excel_notes': '7th floor',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Lucas Uribe',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'lucasuribe@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        },
        {
          'excel_title': 'Conglom-o',
          'excel_address': 'Calle Águila 3, Madrid ',
          'excel_load': '25',
          'excel_hour_start': '9:00',
          'excel_hour_end': '19:00',
          'excel_service_time': '15',
          'excel_notes': '',
          'excel_latitude': '',
          'excel_longitude': '',
          'excel_reference': '',
          'excel_requires_skills': '',
          'excel_optional_skills': '',
          'excel_contact_name': 'Al Olatte',
          'excel_contact_phone': '961483569',
          'excel_hour_start_2': '',
          'excel_hour_end_2': '',
          'excel_load_2': '',
          'excel_load_3': '',
          'excel_priority': '',
          'excel_sms': '',
          'excel_contact_email': 'alolatte@ejemplo.com',
          'excel_load_pick_1': '',
          'excel_load_pick_2': '',
          'excel_load_pick_3': '',
          'excel_programmed_date': '',
          'excel_visit_type': ''
        }
      ]
    };

    function getCustomExampleData(country){
      return customData[country] || customData['US'];
    }

    return service;
  }
})();

/* global angular:false*/
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .controller('VisitsWaveRoutingModalController', VisitsWaveRoutingModalController);

  /** @ngInject */
  function VisitsWaveRoutingModalController($scope, validationService, plannerService) {
    var vm = this;
    var DEFAULT_CUTOFF_TIME = "10:00";
    var ROUTES_REOPTIMIZATION_EVENT = "Re-optimizar rutas paso 2";
    vm.actionOptimize = {
      "REOPTIMIZE_AND_OVERWRITE_PLAN": {
        value: 1,
        optionForHeap: "Overwrite routes"
      },
      "REOPTIMIZE_PARTIALS": {
        value: 3,
        optionForHeap: "Incremental routing"
      }
    };
    vm.cutoffTime = DEFAULT_CUTOFF_TIME;
    vm.editingPlan = plannerService.getEditingPlan().status;
    vm.lastWave = false;
    vm.timeInputCssClass = "form-control wave-routing-time-input";
    vm.invalidTimeInputCssClass = "form-control wave-routing-invalid-time-input";
    vm.timeFormatError = false;
    vm.executeAction = executeAction;
    vm.validateTimeFormat = validateTimeFormat;


    function executeAction(callback) {
      var action = vm.editingPlan ? "REOPTIMIZE_PARTIALS" : "REOPTIMIZE_AND_OVERWRITE_PLAN";
      var numCallback = vm.actionOptimize[action].value;
      plannerService.setWaveRoutingData({
        cutoffTime: vm.cutoffTime,
        lastWave: vm.lastWave
      });
      callback(numCallback);
    }

    function validateTimeFormat(time) {
      vm.timeFormatError = !validationService.validateTimeFormat(time);
    }
  }
})();

/* global angular:false*/
(function () {
  'use strict';
  angular
    .module('icarus.planner')
    .controller('VisitsWarningCheckedVisitsModalController', VisitsWarningCheckedVisitsModalController);

  /** @ngInject */
  function VisitsWarningCheckedVisitsModalController($scope, plannerService, OPTION_FOR_HEAP ) {
    var vm = this;
    vm.executeAction = executeAction;
    vm.checkedCount = plannerService.visitsForRouting.length;
    vm.totalCount = plannerService.getAllVisits().length;

    vm.actionOptimize = {
      REOPTIMIZE_AND_OVERWRITE_PLAN: {
        value: 1,
        optionForHeap: OPTION_FOR_HEAP.OVERWRITE_ROUTES
      }
    };

    function executeAction(callback) {
      var action = "REOPTIMIZE_AND_OVERWRITE_PLAN";
      var numCallback = vm.actionOptimize[action].value;
      plannerService.optimizationOptions.reoptimization_action = numCallback;
      callback(numCallback);
    }

  }




})();

/* global angular:false*/
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .controller('VisitsRemoveRouteModalController', VisitsRemoveRouteModalController);

  /** @ngInject */
  function VisitsRemoveRouteModalController($scope, accountConfigsService, store, plannerService, visitJoinerService,
                                            REOPTIMIZE_PARTIALS, ROUTES_REOPTIMIZATION_EVENT, REOPTIMIZE_AND_OVERWRITE_PLAN,
                                            OPTION_FOR_HEAP, KEEP_PLAN_AND_REOPTIMIZE, ACCOUNT_CONFIGS, PATH_FINDER_ADD_ON_PROPERTIES) {
    var vm = this;
    var optimizationOptions = plannerService.getOptimizationOptions();

    vm.action = null;
    vm.executeAction = executeAction;
    vm.updateDistanceToJoinVisitsMsgVisibility = updateDistanceToJoinVisitsMsgVisibility;
    vm.showMsgForDistanceToJoinVisits = false;
    vm.isDistanceToJoinVisitsEnabled = visitJoinerService.isDistanceToJoinVisitsEnabled(optimizationOptions.distance_to_join_visits);
    vm.incrementalRouting = accountConfigsService.getValueByKeyFrom(
      ACCOUNT_CONFIGS.INCREMENTAL_ROUTING, store.get(ACCOUNT_CONFIGS.CONFIGS)
    );
    vm.hasPlanRoutesProcessed = plannerService.hasPlanRoutesProcessed();

    vm.checkedCount = plannerService.visitsForRouting.length;
    vm.totalCount = plannerService.getAllVisits().length;
    vm.isAllVisitsChecked = vm.checkedCount === vm.totalCount;
    vm.isEditingPlan = plannerService.getEditingPlan();
    vm.isPositiveSelectionVisitsActive = String(plannerService.getPathFinderProperties()[PATH_FINDER_ADD_ON_PROPERTIES.POSITIVE_SELECTION_VISITS]).toLowerCase() === 'true';

    vm.actionOptimize = {
      REOPTIMIZE_AND_OVERWRITE_PLAN: {
        value: 1,
        optionForHeap: OPTION_FOR_HEAP.OVERWRITE_ROUTES
      },
      KEEP_PLAN_AND_REOPTIMIZE: {
        value: 2,
        optionForHeap: OPTION_FOR_HEAP.KEEP_ROUTES
      },
      REOPTIMIZE_PARTIALS: {
        value: 3,
        optionForHeap: OPTION_FOR_HEAP.INCREMENTAL_ROUTING
      }
    };

    function executeAction(callback) {
      var numCallback = vm.actionOptimize[vm.action].value;
      plannerService.optimizationOptions.reoptimization_action = numCallback;
      callback(numCallback);
    }

    function updateDistanceToJoinVisitsMsgVisibility() {
      vm.showMsgForDistanceToJoinVisits = vm.action === REOPTIMIZE_PARTIALS && vm.isDistanceToJoinVisitsEnabled;
    }
  }

})();

/* global google:false, Uint8Array:false , saveAs: false*/
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .controller('PlannerVisitsListController', PlannerVisitsListController);

  /** @ngInject */
  function PlannerVisitsListController($log, $filter, $rootScope, $anchorScroll, $q, $state, DISABLED_CHECKBOX_STYLE,
                                       $stateParams, $timeout, moment, lodash, ngDialog, $scope, $location,
                                       DISABLED_LABEL_STYLE, plannerService, alertNotificationService, XLSX, __env, Utils,
                                       $interval, Toasts, sessionService, xlsxService, webEventService,
                                       $translate, googleService, cleanerService, STEP_TWO_OPTIMIZATION_OPTIONS,PATH_FINDER_ADD_ON_PROPERTIES,
                                       PATH_FINDER_ADD_ON_KEY, validatorGeoreferenceService, newValidatorGeoreferenceService,
                                       zoneService, JOINED_EMAILS_MAX_LENGTH, MAX_EMAILS_INPUT, DISABLED_SPAN_STYLE,
                                       chatService, store, helperExcel, accountConfigsService,
                                       utilsService, statisticsService, visitsMarkersService,
                                       ENABLE_PICKUP_AND_DELIVERY_MODE, VISIT_CARDS_PER_PAGE, VEHICLE_TYPE,
                                       visitListFilterService, SHOW_VISIT_WINDOWS, ACCOUNT_CONFIGS, addressStatsService,
                                       VISIT_ADDRESS_STATUS_ICON_URL, addonsService, SEQUENCER_ROUTING_OPTIONS, WEB_EVENTS,
                                       VISIT_FOR_ROUTING_CARDS_PER_PAGE, SELLER_MANAGEMENT_ADD_ON_KEY, SELLER_MANAGEMENT_ADD_ON_PROPERTIES) {
    var vm = this;
    var intervalPromise = null;
    var UPDATE_SECONDS = 400;
    var importRowsLength = 0;
    var _$translate = $filter('translate');
    var lastActiveVisit = null;
    var ENABLE_NOTES_IN_ROUTE_DESIGNER = 'enable_notes_in_route_designer';
    var ENABLE_JDH = 'enable_jdh';
    var ENABLE_NEW_GEOCODER_ALERTS = 'enable_new_geocoder_alerts';
    var ENABLE_ENHANCED_PLAN_EDIT_MODE = "enable_enhanced_plan_edit_mode";
    var ENABLE_WAVE_ROUTING = "enable_wave_routing";

    var EXCEL_DROPDOWN_LOAD_TYPE = "Excel_dropdown_Superior";
    var EXCEL_BUTTON_LOAD_TYPE = "Excel_btn_Panel";
    var DEFAULT_SORTING_OPTIONS = ['-status','-addedInCurrentRouting', 'title'];
    var COUNTRY_CODE_COLOMBIA = 'CO';

    vm.DISABLED_CHECKBOX_STYLE = DISABLED_CHECKBOX_STYLE;
    vm.DISABLED_LABEL_STYLE = DISABLED_LABEL_STYLE;
    vm.DISABLED_SPAN_STYLE = DISABLED_SPAN_STYLE;
    vm.DROPDOWN_OPTIMIZATION_OPTIONS = Object.values(STEP_TWO_OPTIMIZATION_OPTIONS);
    vm.DEFAULT_TYPE_OF_SORT = 'sort_asc';
    vm.DEFAULT_PROPERTY_TO_SORT = 'title';
    vm.DEFAULT_TITLE_FOR_ORDER_BUTTON = 'sort';

    vm.excelDropdownLoadType = EXCEL_DROPDOWN_LOAD_TYPE;
    vm.excelButtonLoadType = EXCEL_BUTTON_LOAD_TYPE;

    // style dynamic del icono en el loading
    vm.widthDynamic = "0%";
    vm.lenghtBatchs = [];
    vm.visitsGeoreference = 0;
    vm.currentVisitCardsPage = 1;
    vm.currentVisitForRoutingCardsPage = 1;

    vm.menuVisitIsOpen = false;

    var cities = Utils.cities.chile;
    var FILTERS = {
      ALL: 1,
      WARNINGS: 2,
      ERRORS: 3
    };
    var ERROR_DOUBT = 'Dirección dudosa';
    var geocoder = null;
    var skills = [];
    var visitClickedOnMapEvent = null;
    var countriesUsingCleaner = ['PE', 'CL', 'CO', 'MX', 'BR', 'UY', 'AR'];
    var ACCOUNT_MAX_DISTANCE = null;
    var isSellerManagementEnabled = false;
    var isThereVisitForRoutingWithErrorCache = null;
    var isThereVisitForRoutingWithWarningCache = null;

    vm.FILTERS = FILTERS;

    // When enable_pickup_and_delivery_mode is activated, there can be pickup&delivery relationship visits loaded and
    // shown in the page. These type of visits are grouped in the same card, therefore, it is important to focus on
    // visit cards (instead of visit elements), when dealing with items per page restrictions.
    vm.VISIT_CARDS_PER_PAGE = VISIT_CARDS_PER_PAGE;
    vm.visitCardsCurrentPage = [];
    vm.visitForRoutingCardsCurrentPage = [];

    vm.activeVisit = null;
    vm.planDate = null;
    vm.importErrors = [];
    vm.importWarnings = [];
    vm.optimizationOptions = angular.copy(plannerService.localOptimizationOptions);
    vm.radialRoutingOption = vm.optimizationOptions.radial_routing || 0;
    vm.prioritizeLoadOption = vm.optimizationOptions.prioritize_load || false;
    vm.sequencerRoutingOption = 0;
    vm.nextStep = false;
    vm.location_start = {
      country_code: 'CL'
    };
    vm.warningVisitsQty = 0;
    vm.errorVisitsQty = 0;
    vm.activeFilter = FILTERS.ALL;
    vm.enableJdh = true;

    // It's necessary to keep track of total amount of loaded visits, because if this number surpasses the amount of
    // items allowed per page, the list of loaded visits will be divided into multiple pages.
    vm.totalLoadedVisitCards = 0;
    vm.totalLoadedVisitForRoutingCards = 0;

    vm.planName = null;

    // params for integration visits
    vm.dateOptions = {
      formatYear: 'yyyy',
      formatDayHeader: 'EEE',
      formatDayTitle: 'MMMM',
      formatDay: 'd',
      showWeeks: false,
      maxMode: 'day',
      startingDay: 0
    };

    vm.popupCalendar = false;

    var planStartDate = moment(plannerService.planDate.start).toDate();
    vm.dateToGetIntegrationVisits = planStartDate;
    vm.dateToGetIntegrationVisitsNotCompleted = planStartDate;

    vm.bulkEdition = false;
    vm.allVisitsChecked = false;

    vm.dataVisitsImport = {};
    vm.dataVisitsImportNotCompleted = {};

    vm.accountToViewZones = false;
    vm.listZones = [];
    vm.vehicles = plannerService.getActiveVehicles();

    vm.enhancedPlanEditMode = accountConfigsService.isConfigEnabled(ENABLE_ENHANCED_PLAN_EDIT_MODE);
    vm.enablePickupAndDeliveryMode = accountConfigsService.isConfigEnabled(ENABLE_PICKUP_AND_DELIVERY_MODE);
    vm.show_visit_windows = accountConfigsService.isConfigEnabled(SHOW_VISIT_WINDOWS);
    vm.enableRadialRouting = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_RADIAL_ROUTING);
    vm.reuseVisits = false;

    vm.remove = remove;
    vm.goNext = goNext;
    vm.removeAlert = removeAlert;
    vm.activateVisit = activateVisit;
    vm.importExcel = importExcelVisits;
    vm._cancelLoading = _cancelLoading;
    vm.showDeleteModal = showDeleteModal;
    vm.deleteAllVisits = deleteAllVisits;
    vm.downloadExcelVisit = downloadExcelVisit;
    vm.checkOptionOptimize = checkOptionOptimize;
    vm.refreshVisits = refreshVisits;
    vm.isEditingPlan = isEditingPlan;
    vm.showRemoveWarningVisitsModal = showRemoveWarningVisitsModal;
    vm.showRemoveErrorVisitsModal = showRemoveErrorVisitsModal;
    vm.goToAlertVisits = goToAlertVisits;
    vm.goToErrorVisits = goToErrorVisits;
    vm.isAllowedToDisplayOption = isAllowedToDisplayOption;
    vm.isOptimizationOptionDisabled = isOptimizationOptionDisabled;
    vm.getOptimizationOptionTrueValue = getOptimizationOptionTrueValue;
    vm.getOptimizationOptionFalseValue = getOptimizationOptionFalseValue;
    vm.showAvoidTollsOption = false;
    vm.showMaximizeAttendedLoadOption = false;
    vm.isPrioritizeLoadOptionEnabled = false;
    vm.showOneSellerPerVehicleOption = false;
    vm.getRowsFromExcel = getRowsFromExcel;
    vm.getVisitsIntegration = getVisitsIntegration;
    vm.checkOptions = checkOptions;
    vm.checkAllVisits = checkAllVisits;
    vm.goToEdit = goToEdit;
    vm.checkVisit = checkVisit;
    vm.openMenuToAddVisits = openMenuToAddVisits;
    vm.openComponentVisitsIntegration = openComponentVisitsIntegration;
    vm.closeMenuVisitsImport = closeMenuVisitsImport;
    vm.updatePlannerStepsInfo = updatePlannerStepsInfo;
    vm.openComponentVisitsIntegrationNotCompleted = openComponentVisitsIntegrationNotCompleted;
    vm.formatContactEmail = formatContactEmail;
    vm.getVisitTypeKey = getVisitTypeKey;
    vm.isEnableAccountConfiguration = isEnableAccountConfiguration;
    vm.enableNewGeocoderAlerts = false;
    vm.buildVisitToGeoreferenceRequest = buildVisitToGeoreferenceRequest;
    vm.createVisitObj = createVisitObj;
    vm.loadIncompleteVisits = loadIncompleteVisits;
    vm.loadUnroutedVisits = loadUnroutedVisits;
    vm.selectedOptimizationOption = selectedOptimizationOption;
    vm.waitGeocode = waitGeocode;
    vm.canVisitBeEditedOrRemoved = canVisitBeEditedOrRemoved;
    vm.setCountryCodeFromVehicle = setCountryCodeFromVehicle;
    vm.userData = null;
    vm.disableManualIntakeVisits = false;
    vm.vehicleType = null;
    vm.isOnFootRoutingDisabled = false;
    vm.originalPlan = {};
    vm.waveRouting = null;
    vm.isWaveRoutingNotNull = false;
    vm.typeOfSort = vm.DEFAULT_TYPE_OF_SORT;
    vm.propertyToSort = vm.DEFAULT_PROPERTY_TO_SORT;
    vm.showOptionsToSort = false;
    vm.optionsToSortingVisits = {
      properties: ['load','load2','load3','title'],
      typeOfSort: ['sort_asc', 'sort_desc']
    };

    vm.currentSortOptions = DEFAULT_SORTING_OPTIONS;
    vm.selectedVisits = [];
    vm.areVisitsEditable = true;
    vm.titleForOrderButton = vm.DEFAULT_TITLE_FOR_ORDER_BUTTON;
    vm.totalRenderedVisits = 0;
    vm.totalSelectedVisits = 0;
    vm.checkedVisits = [];
    vm.positiveSelectionVisitsEnabled = false;
    vm.isMixLoadAddonEnabled = false;

    vm.searchData = visitListFilterService.getSearchDataBinding(plannerService.visits);
    vm.filterHandler = visitListFilterService.filterStatusHandler;
    vm.filters = visitListFilterService.filters;
    vm.onClickSearch = onClickSearch;
    vm.onRemoveSearch = onRemoveSearch;
    vm.setResetSearchBar = setResetSearchBar;
    vm.resetSearchBar = null;
    vm.mustShowVisitWindows = mustShowVisitWindows;
    vm.displayWindows = displayWindows;
    vm.selectRadialOption = selectRadialOption;
    vm.updateSortingOptions = updateSortingOptions;
    vm.removeSortingOptions = removeSortingOptions;
    vm.getTextOfSelectedVisits = getTextOfSelectedVisits;
    vm.getAlertStatsIconURL = getAlertStatsIconURL;
    vm.changeLocation = changeLocation;
    vm.skipTimeValidation = false;
    var optimizationDependencies = { // use keys to compare with optimizationOptions from the backend
      maximize_attended_load: ['single_tour']
    };
    vm.selectSequencerRoutingOption = selectSequencerRoutingOption;
    vm.routingSequencers = [];
    vm.isVisitsForRoutingCollapsed = false;
    vm.isPendingVisitsCollapsed = false;
    vm.showVisitsForRoutingOnMap = true;
    vm.showPendingVisitsOnMap = true;
    vm.allVisitsForRoutingChecked = false;
    vm.allPendingVisitsChecked = false;
    vm.addingVisitsToVisitsForRouting = addingVisitsToVisitsForRouting;
    vm.removingVisitsToVisitsForRouting = removingVisitsToVisitsForRouting;
    vm.showNextStepCheckbox = showNextStepCheckbox;
    vm.isGoNextDisabled = isGoNextDisabled;

    vm.toggleVisitsForRoutingCollapse = function() {
      vm.isVisitsForRoutingCollapsed = !vm.isVisitsForRoutingCollapsed;
    };

    vm.togglePendingVisitsCollapse = function() {
      vm.isPendingVisitsCollapsed = !vm.isPendingVisitsCollapsed;
    };

    vm.toggleVisitsForRoutingVisibility = function(ev) {
      vm.showVisitsForRoutingOnMap = !vm.showVisitsForRoutingOnMap;

      if (ev) {
        ev.stopPropagation();
      }

      var currentPageVisitIds = {};
      var currentPageVisits = vm.visitForRoutingCardsCurrentPage || [];

      visitsMarkersService.showVisitsOnMap(currentPageVisits, vm.showVisitsForRoutingOnMap);

      currentPageVisits.forEach(function (visit) {
        currentPageVisitIds[visit.id] = true;
      });

      vm.selectedVisits.forEach(function (visit) {
        if (currentPageVisitIds[visit.id]) {
          visit.checked = true;
          $scope.$emit("Planner:Highlight:Visit", { visit: visit });
        }
      });
    };

    vm.togglePendingVisitsVisibility = function(ev) {
      vm.showPendingVisitsOnMap = !vm.showPendingVisitsOnMap;

      if (ev) {
        ev.stopPropagation();
      }

      var currentPageVisitIds = {};
      var currentPageVisits = vm.visitCardsCurrentPage || [];

      visitsMarkersService.showVisitsOnMap(currentPageVisits, vm.showPendingVisitsOnMap);

      currentPageVisits.forEach(function (visit) {
        currentPageVisitIds[visit.id] = true;
      });

      vm.selectedVisits.forEach(function (visit) {
        if (currentPageVisitIds[visit.id]) {
          visit.checked = true;
          $scope.$emit("Planner:Highlight:Visit", { visit: visit });
        }
      });
    };

    vm.checkAllVisitsForRouting = function() {
      var allVisitsForRouting = _getAllVisitsForRoutingToRender();

      if (!allVisitsForRouting || allVisitsForRouting.length === 0) {
        return;
      }

      allVisitsForRouting.forEach(function (visit) {
        if (vm.canVisitBeEditedOrRemoved(visit)) {
          visit.checked = vm.allVisitsForRoutingChecked;
          // Handle marker colors based on checked state
          if (vm.allVisitsForRoutingChecked) {
            $scope.$emit("Planner:Highlight:Visit", {visit: visit});
          } else {
            $scope.$emit("Planner:notHighlight:Visit", {visit: visit});
            $rootScope.$broadcast('visits:hideAlertBarSelectedVisits');
          }

          updateSelectedVisits(visit);
        }
      });

      updateTotalOfSelectedAndRenderedVisits();

      // Handle navbar visibility
      if (vm.selectedVisits.length === 0) {
        $rootScope.$broadcast('visits:hideAlertBarSelectedVisits');
      } else {
        plannerUpdateToolSelectionOnMap();
      }
    };

    vm.checkAllPendingVisits = function() {
      var allPendingVisits = _getAllVisitsToRender();

      if (!allPendingVisits || allPendingVisits.length === 0) {
        return;
      }

      allPendingVisits.forEach(function (visit) {
        if (vm.canVisitBeEditedOrRemoved(visit)) {
          visit.checked = vm.allPendingVisitsChecked;
          // Handle marker colors based on checked state
          if (vm.allPendingVisitsChecked) {
            $scope.$emit("Planner:Highlight:Visit", {visit: visit});
          } else {
            $scope.$emit("Planner:notHighlight:Visit", {visit: visit});
            $rootScope.$broadcast('visits:hideAlertBarSelectedVisits');
          }

          updateSelectedVisits(visit);
        }
      });

      updateTotalOfSelectedAndRenderedVisits();

      // Handle navbar visibility
      if (vm.selectedVisits.length === 0) {
        $rootScope.$broadcast('visits:hideAlertBarSelectedVisits');
      } else {
        plannerUpdateToolSelectionOnMap();
      }
    };

    vm.shouldShowVisitSections = function() {
      return vm.positiveSelectionVisitsEnabled && (vm.visitCardsCurrentPage.length > 0 || vm.visitForRoutingCardsCurrentPage.length > 0);
    };

    function addingVisitsToVisitsForRouting() {
      var totalVisitCardsBeforeRemoving = vm.totalLoadedVisitCards;
      var totalVisitForRoutingCardsBeforeRemoving = vm.totalLoadedVisitForRoutingCards;
      plannerService.visits.forEach(function (visit) {
        if (visit.checked && !plannerService.visitsForRouting.includes(visit.id)) {
          plannerService.visitsForRouting.push(visit.id);
        }

        visit.checked = false;
        $scope.$emit("Planner:notHighlight:Visit", { visit: visit });

      });

      isThereVisitForRoutingWithErrorCache = null;
      isThereVisitForRoutingWithWarningCache = null;
      vm.selectedVisits = [];
      refreshVisits();
      vm.totalSelectedVisits = 0;
      vm.allVisitsChecked = false;
      vm.allPendingVisitsChecked = false;
      vm.allVisitsForRoutingChecked = false;
      vm.totalLoadedVisitForRoutingCards = plannerService.visitsForRouting.length;
      vm.totalLoadedVisitCards = _getAllPendingVisits().length;
      $rootScope.$broadcast('visits:hideAlertBarSelectedVisits');
      _handlePaginatedHelper(totalVisitCardsBeforeRemoving, totalVisitForRoutingCardsBeforeRemoving);
    }

    function removingVisitsToVisitsForRouting() {
      var totalVisitCardsBeforeRemoving = vm.totalLoadedVisitCards;
      var totalVisitForRoutingCardsBeforeRemoving = vm.totalLoadedVisitForRoutingCards;
      plannerService.visits.forEach(function (visit) {
        if (visit.checked && plannerService.visitsForRouting.includes(visit.id)) {
          var index = plannerService.visitsForRouting.indexOf(visit.id);
          plannerService.visitsForRouting.splice(index, 1);
        }

        visit.checked = false;
        $scope.$emit("Planner:notHighlight:Visit", { visit: visit });
      });

      isThereVisitForRoutingWithErrorCache = null;
      isThereVisitForRoutingWithWarningCache = null;
      vm.selectedVisits = [];
      refreshVisits();
      vm.totalSelectedVisits = 0;
      vm.allVisitsChecked = false;
      vm.allPendingVisitsChecked = false;
      vm.allVisitsForRoutingChecked = false;
      vm.totalLoadedVisitForRoutingCards = plannerService.visitsForRouting.length;
      vm.totalLoadedVisitCards = _getAllPendingVisits().length;
      $rootScope.$broadcast('visits:hideAlertBarSelectedVisits');
      _handlePaginatedHelper(totalVisitCardsBeforeRemoving, totalVisitForRoutingCardsBeforeRemoving);
    }


    ///////////////////////////////////////////////////////
    // Watchers & Listeners.
    //////////////////////////////////////////////////////

    visitClickedOnMapEvent = $rootScope.$on("visitClickedOnMap", function (args, data) {
      alertNotificationService.removeAlertNotification();
      $anchorScroll(data.visit.id);
      if (angular.isDefined(data.visit.error)) {
        alertNotificationService.addAlertNotification(data.visit.error);
        if (!$scope.$$phase) {
          $scope.$apply();
        }
      }
    });

    var checkVisitEvent = $rootScope.$on("visitController:Visit:check", function (event, data) {

      if (data.visits) {
        data.visits.forEach(function(visit) {
          var visitSelected = null;
          var isFromVisitsForRouting = false;

          visitSelected = vm.visitCardsCurrentPage.find(function (visitCard) {
            return visitCard.id === visit.id;
          });

          if (!visitSelected && vm.visitForRoutingCardsCurrentPage) {
            visitSelected = vm.visitForRoutingCardsCurrentPage.find(function (visitCard) {
              return visitCard.id === visit.id;
            });
            isFromVisitsForRouting = !!visitSelected;
          }

          if (visitSelected && visitSelected.checked) {
            return;
          }

          if (visitSelected && !visitSelected.checked) {
            visitSelected.checked = true;
            $scope.$emit("Planner:Highlight:Visit", {visit: visitSelected});

            updateSelectedVisits(visitSelected);

            if (isFromVisitsForRouting) {
              var allForRoutingChecked = vm.visitForRoutingCardsCurrentPage.every(function(v) {
                return v.checked || !vm.canVisitBeEditedOrRemoved(v);
              });
              vm.allVisitsForRoutingChecked = allForRoutingChecked;
            } else {
              var allPendingChecked = vm.visitCardsCurrentPage.every(function(v) {
                return v.checked || !vm.canVisitBeEditedOrRemoved(v);
              });
              vm.allPendingVisitsChecked = allPendingChecked;
            }
          }
        });

        $timeout(function () {
          data.visits.forEach(function(visit) {
            if (!vm.selectedVisits.some(function (selectedVisit) {
              return selectedVisit.id === visit.id;
            })) {
              var foundVisit = vm.visitCardsCurrentPage.find(function(v) {
                return v.id === visit.id;
              });

              if (!foundVisit && vm.visitForRoutingCardsCurrentPage) {
                foundVisit = vm.visitForRoutingCardsCurrentPage.find(function(v) {
                  return v.id === visit.id;
                });
              }

              if (foundVisit) {
                vm.checkVisit(foundVisit);
              }
            }
          });

          plannerUpdateToolSelectionOnMap();
          updateTotalOfSelectedAndRenderedVisits();
        });
      }
    });

    var deselectVisitsChecked = $scope.$on('visits:deselectVisitsChecked', function() {
      var allVisits = _getAllVisitsToRender();
      var allVisitsForRouting = _getAllVisitsForRoutingToRender();

      allVisits.forEach(function (visit) {
        if (visit.checked) {
          visit.checked = false;
          $scope.$emit("Planner:notHighlight:Visit", { visit: visit });
        }
      });

      allVisitsForRouting.forEach(function (visit) {
        if (visit.checked) {
          visit.checked = false;
          $scope.$emit("Planner:notHighlight:Visit", { visit: visit });
        }
      });

      vm.selectedVisits.length = 0;
      vm.allPendingVisitsChecked = false;
      vm.allVisitsForRoutingChecked = false;
      updateTotalOfSelectedAndRenderedVisits();
    });


    function plannerUpdateToolSelectionOnMap() {
      if (vm.selectedVisits && vm.selectedVisits.length > 0) {
        var allSelectedVisits = [];

        var allPendingVisits = _getAllVisitsToRender();

        allPendingVisits.forEach(function(visit) {
          if (visit.checked && vm.selectedVisits.indexOf(visit) !== -1) {
            allSelectedVisits.push(visit);
          }
        });

        var allVisitsForRouting = _getAllVisitsForRoutingToRender();

        if (allVisitsForRouting) {
          allVisitsForRouting.forEach(function(visit) {
            if (visit.checked && vm.selectedVisits.indexOf(visit) !== -1) {
              allSelectedVisits.push(visit);
            }
          });
        }

        $scope.$emit('planner:update:toolSelectionOnMapNavbar', {
          visits: allSelectedVisits.length > 0 ? allSelectedVisits : vm.selectedVisits
        });
      } else {
        $rootScope.$broadcast('visits:hideNavbarSelectedVisits');
      }
    }

    $scope.$watch(function() {
      return vm.errorVisitsQty;
    }, function(newErrorVisitsQty, oldErrorVisitsQty) {
      if (newErrorVisitsQty !== oldErrorVisitsQty) {
        isThereVisitForRoutingWithErrorCache = null;
      }
    });

    $scope.$watch(function() {
      return vm.warningVisitsQty;
    }, function(newWarningVisitsQty, oldWarningVisitsQty) {
      if (newWarningVisitsQty !== oldWarningVisitsQty) {
        isThereVisitForRoutingWithWarningCache = null;
      }
    });

    $scope.$on('$destroy', function () {
      $rootScope.isLoadingPlanner = false;
      alertNotificationService.removeAlertNotification();
      if (lastActiveVisit) {
        lastActiveVisit.activate = false;
      }
      visitClickedOnMapEvent();
      checkVisitEvent();
      deselectVisitsChecked();
      if ($state.current.name === 'planner.vehicles-list') {
        $scope.$emit("Planner:Plan:steps", {key: 'visit', value: false});
      }
    });

    function isSkipTimeValidationEnabled() {
      return addonsService.isAddonPropertyEnabled(PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES.SKIP_TIME_VALIDATION, function (addonProperty) {
        return addonProperty.value.toLowerCase() === "true";
      }).then(function (isAddonPropertyEnabled) {
        return isAddonPropertyEnabled;
      });
    }

    activate();

    function activate() {

      var amountActiveVehicles = vm.vehicles.length;
      if (!amountActiveVehicles) {
        $state.go('planner.vehicles-list');
        return;
      }

      if(plannerService.getPlanId() === null){
        vm.planId = utilsService.guid();
        plannerService.setPlanId(vm.planId);
      }

      webEventService.post($location.path(), WEB_EVENTS.STEP2_ARRIVAL,  plannerService.getPlanId());

      if (!plannerService.getShouldClearVisitSelectionsOnReturn()){
        var checkedVisits = plannerService.getCheckedVisits();
        vm.selectedVisits = checkedVisits;
        vm.totalSelectedVisits = checkedVisits.length;
        // Update UI to reflect checked state
        $timeout(function() {
          checkedVisits.forEach(function(visit) {
            var visitInList = vm.visitCardsCurrentPage.find(function(v) {
              return v.id === visit.id;
            });

            if (visitInList) {
              visitInList.checked = true;
              $scope.$emit("Planner:Highlight:Visit", {visit: visit});
            }
          });

          // Update toolbar if visits selected
          if (vm.totalSelectedVisits > 0) {
            plannerUpdateToolSelectionOnMap();
            updateTotalOfSelectedAndRenderedVisits();
          }
        });
      }

      plannerService.setShouldClearVisitSelectionsOnReturn(false); // Reset flag

      var pathFinderProperties = plannerService.getPathFinderProperties();

      vm.isPrioritizeLoadOptionEnabled = utilsService.isAddonPropertyEnabled(pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_PRIORITIZE_LOAD]);

      vm.showMaximizeAttendedLoadOption =
        utilsService.isAddonPropertyEnabled(pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MAXIMIZE_ATTENDED_LOAD]);

      vm.positiveSelectionVisitsEnabled = utilsService.isAddonPropertyEnabled(pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.POSITIVE_SELECTION_VISITS]);

      vm.isMixLoadAddonEnabled = utilsService.isAddonPropertyEnabled(pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD]);
      if (vm.isMixLoadAddonEnabled) {
        vm.optionsToSortingVisits.properties.push('load4');
      }
      addonsService.isAddonPropertyEnabled(
        SELLER_MANAGEMENT_ADD_ON_KEY, SELLER_MANAGEMENT_ADD_ON_PROPERTIES.ENABLE_ONE_SELLER_PER_VEHICLE, function (addonProperty) {
        return addonProperty.value.toLowerCase() === "true";
      })
        .then(function (isAddonPropertyEnabled) {
          vm.showOneSellerPerVehicleOption = isAddonPropertyEnabled;
        })
        .catch(function () {
          vm.showOneSellerPerVehicleOption = false;
        });

      addonsService.isAddonEnable('accounting')
        .then(function (isAccountingEnabled) {
            vm.reuseVisits = isAccountingEnabled || accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_VISIT_ITEMS);
        })
        .catch(function () {
          vm.reuseVisits = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_VISIT_ITEMS);
        });

      sessionService.getUser()
        .then(function (user) {
          vm.userData = user;
          ACCOUNT_MAX_DISTANCE = lodash.find(vm.userData.account.configs, {key: 'max_distance'}) || {};
          vm.showAvoidTollsOption =
            utilsService.isAddonPropertyEnabled(pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_AVOID_TOLLS]) && vm.userData.country === "MX";
          vm.disableManualIntakeVisits =
            utilsService.isAddonPropertyEnabled(pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.DISABLE_MANUAL_INTAKE_VISITS]) &&
            (vm.userData.is_router || vm.userData.is_router_jr);
        });

      setRoutingSequencers();

      vm.enableNotesInRouteDesigner = isEnableAccountConfiguration(ENABLE_NOTES_IN_ROUTE_DESIGNER, false);
      vm.enableNewGeocoderAlerts = isEnableAccountConfiguration(ENABLE_NEW_GEOCODER_ALERTS, false);

      isSkipTimeValidationEnabled().then(function (skipValidation) {
        vm.skipTimeValidation = skipValidation;
      });

      latinizeString();
      isSellerVisitEnabled();

      //Obtenemos la pagina en la que estabamos si es que estabamos
      //y si tenemos los suficientes elementos en plannerService para mostrar esta pagina
      if ($stateParams.page && plannerService.visits[(parseInt($stateParams.page) - 1) * vm.VISIT_CARDS_PER_PAGE]) {
        vm.currentVisitCardsPage = parseInt($stateParams.page);
      }

      plannerService.getVisitTypes();

      return plannerService.getPlan()
        .then(successGetPlan)
        .catch(errorGetPlan);

      function successGetPlan(plan) {
        activeWithoutLoadVisits(plan);

        vm.userAccountCountry = vm.userData.country;
        vm.userAccountGeocoderQualityLevel = vm.userData.geocoder_quality_level;
        cleanerService.setConfig(vm.userAccountCountry);
        vm.enableJdh = isEnableAccountConfiguration(ENABLE_JDH, true);
        vm.optimizationOptions = angular.copy(plannerService.localOptimizationOptions);
        vm.planName = plannerService.getPlanName();
        // By default originalPlan is an empty object
        vm.originalPlan = plannerService.getOriginalPlan();
        var planMetadata = vm.originalPlan.plan_metadata;
        vm.vehicleType = planMetadata ? planMetadata.vehicle_type.toLowerCase() : null;
        vm.isOnFootRoutingDisabled = Boolean(vm.vehicleType);
        vm.waveRouting = planMetadata ? planMetadata.wave_routing : null;
        vm.isWaveRoutingNotNull = vm.waveRouting !== null;
        vm.optimizationOptions.wave_routing = vm.isWaveRoutingNotNull ?
          vm.waveRouting :
          accountConfigsService.isConfigEnabled(
            ENABLE_WAVE_ROUTING
          );

        if (angular.isUndefined(vm.optimizationOptions.distance_to_join_visits)) {
          vm.optimizationOptions.distance_to_join_visits = null;
        }

        checkConfigsOption();
        vm.updatePlannerStepsInfo(plan);
      }

      function errorGetPlan(error) {
        $log.info(angular.toJson(error));
        if (plannerService.visits.length > 0) {
          refreshVisits();
          vm.totalLoadedVisitCards = _getAllPendingVisits().length;
          vm.totalLoadedVisitForRoutingCards = plannerService.visitsForRouting.length;
        }
      }
    }

    // TODO extract function into a centralized spot (like a utils file somewhere) and use it in PlannerRoutesController as well as PlannerRoutesDetailController, instead of isEnableNotesInRouteDesigner function (which needs to be removed)
    function isEnableAccountConfiguration(accountConfiguration, defaultValue) {
      var accountConfigurations = store.get('accountConfigs');
      var enableAccountConfiguration;
      if (accountConfigurations) {
        enableAccountConfiguration = accountConfigurations.find(function (config) {
          return config.key === accountConfiguration;
        });
      }
      return enableAccountConfiguration ? enableAccountConfiguration.value : defaultValue;
    }

    function checkConfigsOption() {
      var zonesFilter = {
        schedules: plannerService.getScheduledPlanDaysOfWeek(),
        enabled: true
      };
      return zoneService.getZonesIfProceed(zonesFilter)
        .then(function success(zones) {
          vm.listZones = zoneService.buildPolygonsFromZones(zones);
        });
    }

    function updatePlannerStepsInfo(plan) {
      $scope.$emit("Planner:Plan:info", {planDate: plan.planDate.start, planName: vm.planName});
      $scope.$emit("Planner:Plan:steps", {key: 'vehicle', value: true});
      $scope.$emit("Planner:Plan:steps", {key: 'visit', value: true});
      $scope.$emit("Planner:Plan:steps", {key: 'route', value: false});
    }

    function analyzeVisitsForError() {
      vm.warningVisitsQty = 0;
      vm.errorVisitsQty = 0;
      plannerService.visits.forEach(function (visit) {
        if (angular.isUndefined(visit.error) || visit.error === null) {
          return;
        }

        if (visit.error.type === 2 || visit.error.type === 3) {
          vm.warningVisitsQty++;
        } else if (visit.error.type === 4) {
          vm.errorVisitsQty++;
        }
      });
    }

    function _removeVisitHelper(visit) {
      var objVisits = {
        isFromVisitCardsCurrentPage: false,
        isFromVisitForRoutingCardsCurrentPage: false
      };
      var visitCardsCurrentPageIndex = vm.visitCardsCurrentPage.indexOf(visit);
      if (visitCardsCurrentPageIndex >= 0) {
        vm.visitCardsCurrentPage.splice(visitCardsCurrentPageIndex, 1);
        objVisits.isFromVisitCardsCurrentPage = true;
        return objVisits;
      }

      var visitForRoutingCardsCurrentPageIndex = vm.visitForRoutingCardsCurrentPage.indexOf(visit);
      if (visitForRoutingCardsCurrentPageIndex >= 0) {
        vm.visitForRoutingCardsCurrentPage.splice(visitForRoutingCardsCurrentPageIndex, 1);
        objVisits.isFromVisitForRoutingCardsCurrentPage = true;
        return objVisits;
      }
      return objVisits;
    }

    function _getAllPendingVisits() {
      return plannerService.visits.filter(function (visit) {
        return !plannerService.visitsForRouting.includes(visit.id);
      });
    }

    function _handlePaginatedHelper(totalVisitCardsBeforeRemoving, totalVisitForRoutingCardsBeforeRemoving, visitRemoved) {
      var totalNumberOfPages = 0;
      var isNextPage = false;

      if (!visitRemoved) {
        if (vm.visitCardsCurrentPage.length === 0 && vm.currentVisitCardsPage > 1) {
          // If current page becomes empty, return to previous page.
          vm.currentVisitCardsPage -= 1;
          vm.refreshVisits();
        } else if (vm.visitCardsCurrentPage.length < vm.VISIT_CARDS_PER_PAGE) {
          // If removing visit frees up space in the current page and there are more visits in the next page, one of them
          // is added to the current page.
          totalNumberOfPages = Math.ceil(totalVisitCardsBeforeRemoving / vm.VISIT_CARDS_PER_PAGE);
          isNextPage = vm.currentVisitCardsPage < totalNumberOfPages;
          if (isNextPage) {
            _addVisitFromNextPage(vm.currentVisitCardsPage, vm.visitCardsCurrentPage, _getAllVisitsToRender());
          }
        }

        if (vm.visitForRoutingCardsCurrentPage.length === 0 && vm.currentVisitForRoutingCardsPage > 1) {
          // If current page becomes empty, return to previous page.
          vm.currentVisitForRoutingCardsPage -= 1;
          vm.refreshVisits();
        } else if (vm.visitForRoutingCardsCurrentPage.length < vm.VISIT_CARDS_PER_PAGE) {
          // If removing visit frees up space in the current page and there are more visits in the next page, one of them
          // is added to the current page.
          totalNumberOfPages = Math.ceil(totalVisitForRoutingCardsBeforeRemoving / vm.VISIT_CARDS_PER_PAGE);
          isNextPage = vm.currentVisitForRoutingCardsPage < totalNumberOfPages;
          if (isNextPage) {
            _addVisitFromNextPage(vm.currentVisitForRoutingCardsPage, vm.visitForRoutingCardsCurrentPage, _getAllVisitsForRoutingToRender());
          }
        }

        return;

      }

      if (visitRemoved.isFromVisitCardsCurrentPage) {
        if (vm.visitCardsCurrentPage.length === 0 && vm.currentVisitCardsPage > 1) {
          // If current page becomes empty, return to previous page.
          vm.currentVisitCardsPage -= 1;
          vm.refreshVisits();
        } else if (vm.visitCardsCurrentPage.length < vm.VISIT_CARDS_PER_PAGE) {
          // If removing visit frees up space in the current page and there are more visits in the next page, one of them
          // is added to the current page.
          totalNumberOfPages = Math.ceil(totalVisitCardsBeforeRemoving / vm.VISIT_CARDS_PER_PAGE);
          isNextPage = vm.currentVisitCardsPage < totalNumberOfPages;
          if (isNextPage) {
            _addVisitFromNextPage(vm.currentVisitCardsPage, vm.visitCardsCurrentPage, _getAllVisitsToRender());
          }

          _mapFitboundVisits(vm.visitCardsCurrentPage);
          updateEditableVisitsStatus();
        }
      } else if (visitRemoved.isFromVisitForRoutingCardsCurrentPage) {
        if (vm.visitForRoutingCardsCurrentPage.length === 0 && vm.currentVisitForRoutingCardsPage > 1) {
          // If current page becomes empty, return to previous page.
          vm.currentVisitForRoutingCardsPage -= 1;
          vm.refreshVisits();
        } else if (vm.visitForRoutingCardsCurrentPage.length < vm.VISIT_CARDS_PER_PAGE) {
          // If removing visit frees up space in the current page and there are more visits in the next page, one of them
          // is added to the current page.
          totalNumberOfPages = Math.ceil(totalVisitForRoutingCardsBeforeRemoving / vm.VISIT_CARDS_PER_PAGE);
          isNextPage = vm.currentVisitForRoutingCardsPage < totalNumberOfPages;
          if (isNextPage) {
            _addVisitFromNextPage(vm.currentVisitForRoutingCardsPage, vm.visitForRoutingCardsCurrentPage, _getAllVisitsForRoutingToRender());
          }

          _mapFitboundVisits(vm.visitForRoutingCardsCurrentPage);
          updateEditableVisitsStatus();
        }
      }
    }

    function remove(visit) {
      var totalVisitCardsBeforeRemoving = vm.totalLoadedVisitCards;
      var totalVisitForRoutingCardsBeforeRemoving = vm.totalLoadedVisitForRoutingCards;

      if (visit.error) {
        if (visit.error.type === 2 || visit.error.type === 3) {
          vm.warningVisitsQty--;
        } else if (visit.error.type === 4) {
          vm.errorVisitsQty--;
        }
      }

      if (vm.enablePickupAndDeliveryMode) {
        plannerService.getVisitRelationships(visit).forEach(function (relationship) {
          if (relationship) {
            _removeVisitHelper(relationship);
          }
        });

        plannerService.removeVisitPickupAndDeliveryRelationship(visit);
      }

      var visitForRoutingIndex = plannerService.visitsForRouting.indexOf(visit.id);
      if (visitForRoutingIndex !== -1) {
        plannerService.visitsForRouting.splice(visitForRoutingIndex, 1);
      }

      var visitRemoved = _removeVisitHelper(visit);
      vm.filterHandler.activeFilter && vm.filterHandler.removeVisit(visit.id);
      plannerService.removeVisit(visit);
      statisticsService.decreaseTotalLoads(visit);
      vm.totalLoadedVisitCards = _getAllPendingVisits().length;
      vm.totalLoadedVisitForRoutingCards = plannerService.visitsForRouting.length;
      _handlePaginatedHelper(totalVisitCardsBeforeRemoving, totalVisitForRoutingCardsBeforeRemoving, visitRemoved);
    }

    function removeWithoutAddNewVisit(visit) {
      if (visit.error) {
        if (visit.error.type === 2 || visit.error.type === 3) {
          vm.warningVisitsQty--;
        } else if (visit.error.type === 4) {
          vm.errorVisitsQty--;
        }
      }

      var visitForRoutingIndex = plannerService.visitsForRouting.indexOf(visit.id);
      if (visitForRoutingIndex !== -1) {
        plannerService.visitsForRouting.splice(visitForRoutingIndex, 1);
      }

      _removeVisitHelper(visit);
      plannerService.removeVisit(visit);
      statisticsService.decreaseTotalLoads(visit);
      vm.totalLoadedVisitCards = _getAllPendingVisits().length;
      vm.totalLoadedVisitForRoutingCards = plannerService.visitsForRouting.length;
    }

    function setResetSearchBar(resetMethod){
      vm.resetSearchBar = resetMethod;
    }

    function deleteAllVisits() {
      var allPendingVisits = _getAllVisitsToRender();
      var allVisitsForRouting = _getAllVisitsForRoutingToRender();

      var visits = allPendingVisits.concat(allVisitsForRouting);

      //it is necessary to traverse the visits array in descending order to be able to delete all the visits
      //since otherwise there will be visits left without deleting
      //because the indices of the remaining visits are updated in the visits array of the plannerService
      for (var i = visits.length - 1; i >= 0; i--) {
        statisticsService.decreaseTotalLoads(visits[i]);
        plannerService.removeVisit(visits[i], false);
      }

      if (vm.filterHandler.activeFilter) {
        vm.resetSearchBar();
      } else {
        //it is necessary to traverse the routes array in descending order to be able to delete all the routes
        //since otherwise there will be routes left without deleting
        //because the indices of the remaining routes are updated in the routes array of the plannerService
        for (var j = plannerService.routes.length - 1; j >= 0; j--) {
          plannerService.removeRoute(plannerService.routes[j]);
        }

        plannerService.routes.length = 0;
        plannerService.visits.length = 0;
        vm.visitCardsCurrentPage.length = 0;
        vm.visitForRoutingCardsCurrentPage.length = 0;
        plannerService.visitsForRouting.length = 0;
        $scope.$emit("Planner:Plan:reset-statistics", {totalVehiclesCapacity: true});
      }

      vm.currentVisitCardsPage = 1;
      vm.currentVisitForRoutingCardsPage = 1;
      vm.totalLoadedVisitCards = _getAllPendingVisits().length;
      vm.totalLoadedVisitForRoutingCards = plannerService.visitsForRouting.length;
      vm.allVisitsChecked = false;
      vm.allPendingVisitsChecked = false;
      vm.allVisitsForRoutingChecked = false;
      vm.selectedVisits = [];
      vm.totalSelectedVisits = 0;
      vm.totalRenderedVisits = _getAllVisitsToRender().length;
      analyzeVisitsForError();

      $rootScope.$broadcast('visits:hideAlertBarSelectedVisits');
      Toasts.push('success', _$translate('Visits.toolSelectionOnMapNavbar.toast_delete_selected_visits_success'));
      $scope.$emit('Planner:disabledHandDrawingButton', {disabled: true});
    }

    function refreshVisits() {
      plannerService.clearMapVisits();
      alertNotificationService.removeAlertNotification();
      _fillVisitsFiltered();
      var mergedVisitCards = vm.visitCardsCurrentPage.concat(vm.visitForRoutingCardsCurrentPage);

      mergedVisitCards.forEach(function (visit) {
        visit.actionPaintOnMap();
      });

      if (vm.positiveSelectionVisitsEnabled) {
        visitsMarkersService.showVisitsOnMap(vm.visitCardsCurrentPage || [], vm.showPendingVisitsOnMap);
        visitsMarkersService.showVisitsOnMap(vm.visitForRoutingCardsCurrentPage || [], vm.showVisitsForRoutingOnMap);
      }

      vm.selectedVisits.forEach(function (visit) {
        visit.checked = true;
        $scope.$emit("Planner:Highlight:Visit", { visit: visit });
      });

      if (mergedVisitCards.length > 0) {
        _mapFitboundVisits(mergedVisitCards);
      }

      updateTotalOfSelectedAndRenderedVisits();
      updateEditableVisitsStatus();

      if (vm.selectedVisits.length === 0) {
        $rootScope.$broadcast('visits:hideAlertBarSelectedVisits');
      } else {
        plannerUpdateToolSelectionOnMap();
      }
    }

    function showDeleteModal() {
      var hasPendingVisits = vm.visitCardsCurrentPage && vm.visitCardsCurrentPage.length > 0;
      var hasVisitsForRouting = vm.visitForRoutingCardsCurrentPage && vm.visitForRoutingCardsCurrentPage.length > 0;

      if (!hasPendingVisits && !hasVisitsForRouting) {
        return;
      }

      $scope.deleteAllVisits = deleteAllVisits;
      $scope.removeSelectedVisits = removeSelectedVisits;
      $scope.allVisitsChecked = vm.allVisitsChecked;

      ngDialog.open({
        template: 'app/planner/visits/visits-delete-modal.html',
        scope: $scope
      });
    }

    function removeSelectedVisits() {
      vm.allVisitsChecked = false;
      vm.selectedVisits.forEach(function (visit) {
        vm.remove(visit);
      });
      vm.selectedVisits = [];
      vm.totalSelectedVisits = 0;
      vm.totalRenderedVisits = _getAllVisitsToRender().length + _getAllVisitsForRoutingToRender().length;
      vm.allPendingVisitsChecked = false;
      vm.allVisitsForRoutingChecked = false;

      $rootScope.$broadcast('visits:hideAlertBarSelectedVisits');
      Toasts.push('success', _$translate('Visits.toolSelectionOnMapNavbar.toast_delete_selected_visits_success'));
    }

    function removeAlert(ev, visit) {
      ev.stopPropagation();

      if (visit.error.type === 3 || visit.error.type === 2) {
        vm.warningVisitsQty--;
      } else if (visit.error.type === 4) {
        vm.errorVisitsQty--;
      }

      visit.removeError();
    }

    function goNext() {
      chatService.notifyRouteCreated();
      vm.checkOptions()
        .then(function (option) {
          var params = {
            optimize: option,
            isEnhancedPlanEditModeEnabled: Boolean(vm.enhancedPlanEditMode)
          };

          if (vm.enableJdh) {
            params['jdh'] = '1';
          }

          $state.go('^.routes', params);
        })
        .catch(function (error) {
          try {
            if (error.hasOwnProperty('message')) {
              // Error with structure {'code': <int>, 'data': <anything>}
              error = angular.fromJson(error.message);
            }
          } catch (e) {
            // Do nothing prevent raises error
          }
          switch (error.code) {
            case 0:
              // User don't want to delete current routes
              // Safetly exit
              // Restore original vehicles shift

              break;
            case 1:
              // User select last_position_optimize to optimize
              // and the plan date isn't the current date
              ngDialog.open({
                template: 'app/planner/visits/visits-date-error-visits-modal.html',
                scope: $scope
              });
              break;
            case 2:
              // User select last_position_optimize to optimize
              // and the system doesn't have last locations of selected vehicles
              ngDialog.open({
                template: 'app/planner/visits/visits-incompleted-vehicles-error-visits-modal.html',
                scope: $scope
              });
              break;
            case 3:
              // Show vehicles that exceed workday
              var scope = $scope.$new();
              scope.vehicles = angular.copy(error.data);
              ngDialog.open({
                template: 'app/planner/visits/visits-workday-exceeded-visits-modal.html',
                scope: scope
              });

              break;
            default:
              // TODO: Translate backend error
              // Receive a response object
              alertNotificationService.addAlertNotification(error.data);
          }
        });
    }

    function isLupapGeocoderProvider() {
      var geoCoder = accountConfigsService.getConfigRawValue(
        ACCOUNT_CONFIGS.GEOCODER_PROVIDER
      );

      var isLupapProvider = false;

      if (
        geoCoder &&
        angular.isString(geoCoder) &&
        geoCoder.includes('"primary"')
      ) {
        try {
          var geoCoderObj = angular.fromJson(geoCoder);
          if (geoCoderObj && geoCoderObj.primary) {
            isLupapProvider = geoCoderObj.primary.toLowerCase() === "lupap";
          }
        } catch (e) {
          $log.error("Error parsing geocoder provider:", e);
        }
      }
      else if (geoCoder && angular.isString(geoCoder)) {
        isLupapProvider = geoCoder.toLowerCase() === "lupap";
      }
      else if (vm.geocoder_provider) {
        if (
          angular.isObject(vm.geocoder_provider) &&
          vm.geocoder_provider.primary
        ) {
          isLupapProvider =
            vm.geocoder_provider.primary.toLowerCase() === "lupap";
        } else if (angular.isString(vm.geocoder_provider)) {
          isLupapProvider = vm.geocoder_provider.toLowerCase() === "lupap";
        }
      }

      return isLupapProvider;
    }

    function activateVisit(visit) {
      if (angular.isDefined(visit.error)) {
        alertNotificationService.removeAlertNotification();
        alertNotificationService.addAlertNotification(visit.error);
      }

      if (lastActiveVisit) {
        lastActiveVisit.activate = false;
      }

      $scope.$emit('Planner:Visit:showInfoWindow', {
        visit: visit
      });

      plannerService.setMapCenterOn(visit);
      visit.activate = !visit.activate;
      lastActiveVisit = visit;
    }

    function isSellerVisitEnabled() {
      addonsService.isAddonEnable('seller_management')
        .then(function (isEnabled) {
          isSellerManagementEnabled = isEnabled;
        })
        .catch(function (error) {
          $log.error('Error checking if seller management is enabled: ', error);
        });
    }

    function downloadExcelVisit() {
      var workbook = {
        Sheets: {},
        SheetNames: []
      };

      var wscols = [{wch: 105}, {wch: 15}, {wch: 15}, {wch: 15}, {wch: 15}, {wch: 15}, {wch: 15}, {wch: 15},
        {wch: 15}, {wch: 15}, {wch: 15}, {wch: 15}, {wch: 15}, {wch: 15}, {wch: 15}, {wch: 15},
        {wch: 15}, {wch: 15}];

      var isMixLoadAddonEnabled = vm.isMixLoadAddonEnabled;

      var HEADERS = [
        _$translate('Visits.excel_title'),
        _$translate('Visits.excel_address'),
        _$translate('Visits.excel_load'),
        _$translate('Visits.excel_hour_start'),
        _$translate('Visits.excel_hour_end'),
        _$translate('Visits.excel_service_time'),
        _$translate('Visits.excel_notes'),
        _$translate('Visits.excel_latitude'),
        _$translate('Visits.excel_longitude'),
        _$translate('Visits.excel_reference'),
        _$translate('Visits.excel_requires_skills'),
        _$translate('Visits.excel_optional_skills'),
        _$translate('Visits.excel_contact_name'),
        _$translate('Visits.excel_contact_phone'),
        _$translate('Visits.excel_hour_start_2'),
        _$translate('Visits.excel_hour_end_2'),
        _$translate('Visits.excel_load_2'),
        _$translate('Visits.excel_load_3'),
      ];

      if (isMixLoadAddonEnabled) {
        HEADERS.push(_$translate('Visits.excel_load_4'));
      }

      HEADERS.push(
        _$translate('Visits.excel_priority'),
        _$translate('Visits.excel_sms'),
        _$translate('Visits.excel_contact_email'),
        _$translate('Visits.excel_load_pick_1'),
        _$translate('Visits.excel_load_pick_2'),
        _$translate('Visits.excel_load_pick_3'),
        _$translate('Visits.excel_programmed_date'),
        _$translate('Visits.excel_visit_type')
      );

      if (isSellerManagementEnabled) {
        HEADERS.push(_$translate('Visits.excel_seller'));
      }

      if (
        vm.userAccountCountry === COUNTRY_CODE_COLOMBIA &&
        isLupapGeocoderProvider()
      ) {
        HEADERS.push(_$translate("Visits.excel_city"));
      }

      if (isMixLoadAddonEnabled) {
        wscols.push({wch: 15});
      }


      var arrayOfArrays = [];
      arrayOfArrays.push(HEADERS);

      var nameFile = $translate.use() + '_' + vm.userAccountCountry + '_' + _$translate('Visits.excel_name');
      var customData = xlsxService.getCustomExampleData(vm.userAccountCountry);
      for (var i = 0; i < customData.length; i++) {

        var obj = customData[i];
        var dataArray = [];
        for (var key in obj) {
          var attrValue = obj[key];
          dataArray.push(attrValue);
        }
        arrayOfArrays.push(dataArray);
      }

      workbook.Sheets['VisitExcel'] = _sheetFromArrayOfArrays(arrayOfArrays);
      workbook.SheetNames.push('VisitExcel');
      workbook['!cols'] = wscols;
      _writeWorkbook(workbook, nameFile.toLowerCase());
    }

    function getTimeFromExcel(datetime) {
      if (datetime) {
        var splitDatetime = datetime.split(' ');
        return splitDatetime.length > 1 ? splitDatetime[1] : splitDatetime[0];
      }
      return '';
    }

    function getDateFromExcel(datetime) {
      var parsedDatetime = moment(datetime, 'YYYY-MM-DD HH:mm:ss');
      return parsedDatetime.isValid() ? parsedDatetime.format('YYYY-MM-DD') : '';
    }

    function getRowsFromExcel(files) {
      var deferred = $q.defer();
      var reader = new FileReader();
      var rABS = true;
      var rows = [];

      //Verify if FileReader.prototype.readAsBinaryString is defined
      if (angular.isDefined(FileReader) || angular.isDefined(FileReader.prototype) || !angular.isFunction(FileReader.prototype.readAsBinaryString)) {
        rABS = false;
      }

      reader.onload = function (e) {
        var data = e.target.result;
        var workbook = null;
        var worksheet;

        if (rABS) {
          workbook = XLSX.read(data, {type: 'binary', cellDates: true, cellText: false});
        } else {
          workbook = XLSX.read(btoa(_fixData(data)), {type: 'base64', cellDates: true, cellText: false});
        }

        worksheet = workbook.Sheets[workbook.SheetNames[0]];
        rows = helperExcel.sheet_to_json_simpli(worksheet, {header: 'A', dateNF: 'YYYY"-"MM"-"DD HH":"mm":"ss', raw: false, rawColum: 'J'});
        deferred.resolve(rows);
      };

      if (rABS) {
        reader.readAsBinaryString(files[0]);
      } else {
        reader.readAsArrayBuffer(files[0]);
      }
      return deferred.promise;
    }

    ///// Refactor Se aplica el servicio de Geocode Batch 08/08/2016

    function importExcelVisits(files, loadType) {
      closeMenuVisitsImport();

      vm.errorAddress = null;
      vm.importWarnings.length = 0;
      vm.importErrors.length = 0;
      vm.currentLoadTotalVisits = 0;
      vm.currentLoadWarningVisitsQty = 0;
      vm.currentLoadErrorVisitsQty = 0;

      var totalBatch = [];
      var maxBatch = __env.DEFAULT_BATCH_GEOCODER_SERVICE || 500;

      vm.widthDynamic = "0%";
      vm.visitsGeoreference = 0;
      $rootScope.isLoadingPlanner = true;

      if (intervalPromise) {
        $interval.cancel(intervalPromise);
      }
      intervalPromise = $interval(_updatePromiseBar, UPDATE_SECONDS);
      vm.getRowsFromExcel(files)
        .then(function (rows) {
          vm.rows = rows;
          vm.maxProgressBar = rows.length - 1;
          vm.currentLoadTotalVisits = vm.maxProgressBar;
          // if the excel file is empty
          if (rows.length === 1) {
            $log.info('Excel file empty');
            Toasts.push('warning', _$translate('Planner_toast.empty_file_excel'));
            _cancelLoading();
            return;
          }

          // divide the entire array of visits in amount of required batchs
          rows = rows.splice(1, rows.length);
          var visitsFromExcel = proccessFileWithLatLng(rows);
          return addressStatsService.fetchAndProcessAddressStats(visitsFromExcel);
        })
        .then(function (data) {
          createGeoreferencedVisits(data.visitsWithUpdatedLocation);
          if (!data.visitsWithoutLocation.length) {
            return;
          }

          totalBatch = data.visitsWithoutLocation.length > maxBatch ?
                      lodash.chunk(data.visitsWithoutLocation, maxBatch)
                      : [data.visitsWithoutLocation];

          if(totalBatch.length == 1){
            return vm.waitGeocode(data.visitsWithoutLocation);
          }else{
            //proccess bath of[500] sequencially, create colecction for visitPromise to reduce later(sequencialRequestAtTime)
            var dataAllBatchGeocoder = totalBatch.map(function(batch){
              return batch;
            });
            return sequencialRequestAtTime(dataAllBatchGeocoder);
          }
        })
        .then(function () {
          $log.info("excel terminado");
        })
        .catch(function (err) {
          $log.error(err);
        })
        .finally(function () {
          _cancelLoading();
        });
    }

  function waitGeocode(visits) {
  var accountCountry = vm.userData.country;
  var userAccountGeocoderQualityLevel = vm.userData.geocoder_quality_level;
  var addressesToGeoReference = [];
  var visitsDict = {};

  // Determinar si el provider es lupap usando la función auxiliar
  var isLupapProvider = isLupapGeocoderProvider();

  visits.forEach(function (visit) {
    var addressData = {
      address: visit.addressFull.full_address
        ? visit.addressFull.full_address
        : visit.address,
      id: visit.id
    };

    if (accountCountry === COUNTRY_CODE_COLOMBIA && isLupapProvider) {
      if (visit.city && visit.city.trim() !== "") {
        addressData.city = visit.city;
      }
    }

    addressesToGeoReference.push(addressData);
    visitsDict[visit.id] = visit;
  });

  return plannerService.tryPreGeoreferenceBatch(
    addressesToGeoReference,
    accountCountry,
    userAccountGeocoderQualityLevel
  ).then(
    function (data) {
      if (!data) {
        return;
      }

      Object.keys(data).forEach(function (key) {
        var visit = visitsDict[key];
        var temporal = 0;
        var item = data[key];

        if (!vm.enableNewGeocoderAlerts && item.provider === "google") {
          if (vm.userAccountCountry === "CL") {
            verifyGeocoderAddressAccuracy(item, visit);
          }
        }
        visit.administrative_area = item.administrativeArea;
        lodash.merge(visit, item);
        importRowsLength++;

        if (vm.maxProgressBar > vm.visitsGeoreference) {
          vm.visitsGeoreference = vm.visitsGeoreference + 1;
          temporal = (vm.visitsGeoreference / vm.maxProgressBar) * 100;
          vm.widthDynamic = String(temporal) + "%";
        }
      });
      createGeoreferencedVisits(visits);
    },
    function errorGeocodeBatch(error) {
      if (error.status) {
        _cancelLoading();
      }
    }
  );
}

    function verifyGeocoderAddressAccuracy(item, visit) {
      var streetArray = [];
      var originalStreet = item.cleanedAddress.split(',')[0];
      if (item.streetName) {
        streetArray = item.streetName.split(" ");
      } else {
        $log.info('item sin address', item);
      }

      var matches = [];
      var candidates = [];
      var key;
      for (var j = 0; j < streetArray.length; j++) {
        key = streetArray[j];
        matches = getAddressData(key);
        if (matches.length === 0) {
          continue;
        }
        if (matches.length === 1) {
          var words = matches[0].key.split(" ");
          if (words.length > 1) {
            if (streetArray.length > j + 1) {
              var word = streetArray[j] + ' ' + streetArray[j + 1];
              word = word.replace('(', "");
              word = word.replace(')', "");
              var expression = "^\\b(" + word.latinize() + ")\\b";
              var reg = new RegExp(expression, "i");
              if (reg.test(matches[0].key.latinize())) {
                candidates.push(matches[0]);
                continue;
              }
            }
          } else {
            candidates.push(matches[0]);
            continue;
          }
        } else {
          for (var k = 0; k < matches.length; k++) {
            if (streetArray.length > j + 1) {
              var word = streetArray[j] + ' ' + streetArray[j + 1];
              word = word.replace('(', "");
              word = word.replace(')', "");
              var expression = "^\\b(" + word.latinize() + ")\\b";
              var reg = new RegExp(expression, "i");
              if (reg.test(matches[k].key.latinize())) {
                candidates.push(matches[k]);
              }
            }
          }
        }
      }

      var check = false;
      if (candidates.length) {
        check = true;
        for (var j = 0; j < candidates.length; j++) {
          var latinize = candidates[j].key.latinize().toLowerCase();
          latinize = latinize.replace(/'/g, '');

          if (originalStreet.indexOf(latinize) !== -1 ||
            originalStreet.indexOf(candidates[j].key.toLowerCase()) !== -1) {
            check = false;
          }
        }
      }

      if (check) {
        $log.log('***********************');
        $log.log('ALERT ERROR DOUBT');
        $log.log('Original street: ', item.cleanedAddress);
        $log.log('Provider response: ', item.streetName);
        $log.log('Match', candidates[0].key);
        $log.log('***********************');
        visit.status = 2;
        visit.error = {
          type: 4,
          msg: ERROR_DOUBT
        };
      }
    }

 function proccessFileWithLatLng(rows) {
  var processedVisits = [];
  var visistsWithError = 0;
  var visistsWithoutCity = 0;

  var isLupapProvider = isLupapGeocoderProvider();

  rows.forEach(function (row, index) {
    var title = row.A || _$translate('Visits.no_title');
    var address = row.B || _$translate('Visits.import_no_address');

    if (typeof title === "undefined" && address === _$translate('Visits.import_no_address')) {
      var visitError = { index: index };
      vm.importErrors.push(visitError);
      return;
    }

    if (typeof address === "undefined") {
      vm.errorAddress = true;
      vm.importErrors.push({ index: index });
      vm.maxProgressBar = vm.maxProgressBar - 1;
      return;
    }

    var latlngPattern = new RegExp(Utils.latlngPattern);
    var lat = row.H;
    var lng = row.I;

    var visit = createVisitObj(
      title, address, row, lat, lng, "", 1, {}, vm.userAccountCountry, vm.isMixLoadAddonEnabled
    );

    if (isSellerManagementEnabled) {
      var sellerColumn = vm.isMixLoadAddonEnabled ? 'AB' : 'AA';
      var sellerName = row[sellerColumn] || null;
      if (sellerName) {
        var sellers = plannerService.getSellers();
        var sellerObj = lodash.find(sellers, { name: sellerName });
        if (sellerObj) {
          visit.seller_id = sellerObj.id;
        } else {
          visit.seller_id = null;
          visistsWithError++;
        }
      }
    }

    if (vm.userAccountCountry === COUNTRY_CODE_COLOMBIA && isLupapProvider) {
      var hasCity = false;
      var cityColumn;

      if (isSellerManagementEnabled) {
        cityColumn = vm.isMixLoadAddonEnabled ? 'AC' : 'AB';
      } else {
        cityColumn = vm.isMixLoadAddonEnabled ? 'AB' : 'AA';
      }

      if (row.hasOwnProperty(cityColumn) && row[cityColumn] && row[cityColumn].trim() !== "") {
        visit.city = row[cityColumn].trim();
        hasCity = true;
      }

      if (!hasCity) {
        visistsWithoutCity++;
        return;
      }

    }

    if (lat && lng && latlngPattern.test(lat + ', ' + lng)) {
      visit.latitude = parseFloat(lat.trim());
      visit.longitude = parseFloat(lng.trim());
      var newVisit = createNewVisit(visit);
      processedVisits.push(newVisit);
    } else {
      if (isNewCleanerEnable()) {
        visit.addressFull = {
          full_address: cleanerService.cleanAddress(visit.address)
        };
      } else {
        visit.addressFull = _cleanUp(visit.address);
      }

      visit.latitude = null;
      visit.longitude = null;
      visit.id = utilsService.guid();
      processedVisits.push(visit);
    }
  });

  if (visistsWithoutCity > 0 && vm.userAccountCountry === COUNTRY_CODE_COLOMBIA && isLupapProvider) {
    Toasts.push(
      "warning",
      _$translate("Planner_toast.error_city", { count: visistsWithoutCity })
    );
  }

  if (visistsWithError > 0) {
    Toasts.push(
      "warning",
      _$translate("Planner_toast.error_seller", { count: visistsWithError })
    );
  }

  return processedVisits;
}

    function createNewVisit(visit) {
      var newVisit = plannerService.createVisit();
      lodash.merge(newVisit, visit);
      statisticsService.increaseTotalLoads(newVisit);
      newVisit.setAddedInCurrentRouting(true);
      newVisit.priority = newVisit.getCPriority();
      newVisit.priorityLevel = newVisit.getPriority();
      newVisit.procureVisitStatus();

      newVisit.zones = zoneService.getZonesIntoVisit(
        vm.listZones,
        newVisit.latitude,
        newVisit.longitude
      );

      _validatorGeoreferenceVisit(newVisit);
      _validateTimeWindows(newVisit);
      return newVisit;
    }

    function createGeoreferencedVisits(visits) {
      visits.forEach(function (visit) {
        createNewVisit(visit);
      });
    }

    function _validateTimeWindows(visit) {
      var visitHasWarning = false;
      var visitHasError = false;
      if (visit.status === 2 || visit.status === 3) {
        visitHasWarning = true;
      } else if (visit.status === 4) {
        visitHasError = true;
      }

      var areValid;
      if (vm.skipTimeValidation && $scope.isMultiDayRouteEnabled) {
        areValid = visit.areValidVisitWindowTimesWithOvernightSupport();
      } else {
        areValid = visit.areValidVisitWindowTimes();
      }

      if (!areValid) {
        if (visitHasWarning) {
          vm.warningVisitsQty--;
          vm.currentLoadWarningVisitsQty--;
        }
        if (!visitHasError) {
          vm.errorVisitsQty++;
          vm.currentLoadErrorVisitsQty++;
        }
      }
    }

    function sequencialRequestAtTime(totalBatchs) {
      var results =  [];
      var defer = $q.defer();

      //one batch represent batch[500] with index 500 or DEFAULT_BATCH_GEOCODER_SERVICE
      totalBatchs.reduce(function(visitPromise, oneBatch) {
        return visitPromise.then(function() {
            return waitGeocode(oneBatch).then(function(result){
              results.push(result);
              return true;
            });
        });
      }, $q.when(true))
        .then(function() {
            defer.resolve(results);
        }, function(err) {
            defer.reject(err);
        });

      return defer.promise;
    }

    function checkOptionOptimize(checkbox) {
      switch (checkbox) {
        case STEP_TWO_OPTIMIZATION_OPTIONS.OPEN_START:
          if (vm.optimizationOptions.open_start) {
            vm.optimizationOptions.enable_soft_window = false;
          }
          break;
        case STEP_TWO_OPTIMIZATION_OPTIONS.OPEN_ENDED:
          if (vm.optimizationOptions.open_ended) {
            vm.optimizationOptions.enable_soft_window = false;
          }
          break;
        case STEP_TWO_OPTIMIZATION_OPTIONS.JOIN_V2:
          if (vm.optimizationOptions.join_v2 && vm.optimizationOptions.join) {
            vm.optimizationOptions.join = false;
          }
          if (vm.optimizationOptions.join_v2 && vm.optimizationOptions.one_seller_per_vehicle) {
            vm.optimizationOptions.one_seller_per_vehicle = false;
          }
          break;
        case STEP_TWO_OPTIMIZATION_OPTIONS.JOIN:
          if (vm.optimizationOptions.join_v2 && vm.optimizationOptions.join) {
            vm.optimizationOptions.join_v2 = false;
          }
          break;
        case STEP_TWO_OPTIMIZATION_OPTIONS.ONE_SELLER_PER_VEHICLE:
          if (vm.optimizationOptions.join_v2 && vm.optimizationOptions.one_seller_per_vehicle) {
            vm.optimizationOptions.join_v2 = false;
          }
          break;
        case STEP_TWO_OPTIMIZATION_OPTIONS.ENABLE_SOFT_WINDOW:
          if (vm.optimizationOptions.enable_soft_window) {
            vm.optimizationOptions.open_start = false;
            vm.optimizationOptions.open_ended = false;
          }
          break;
        case STEP_TWO_OPTIMIZATION_OPTIONS.ON_FOOT:
          if (vm.isOnFootRoutingDisabled) {
            vm.optimizationOptions.on_foot = vm.vehicleType === VEHICLE_TYPE.FOOT;
          }
          break;
        case STEP_TWO_OPTIMIZATION_OPTIONS.WAVE_ROUTING:
          if (vm.waveRouting) {
            vm.optimizationOptions.wave_routing = vm.waveRouting;
          }
          break;
        case STEP_TWO_OPTIMIZATION_OPTIONS.DISTANCE_TO_JOIN_VISITS:
          if (angular.isUndefined(vm.optimizationOptions.distance_to_join_visits)) {
            vm.optimizationOptions.distance_to_join_visits = null;
          }
          break;
      }
      if (vm.optimizationOptions[checkbox] && optimizationDependencies[checkbox]) {
        optimizationDependencies[checkbox].forEach(function (dep) {
          vm.optimizationOptions[dep] = true;
        });
      }

    }

    function isAllowedToDisplayOption(key) {
      var displayedOptimizationOptions =
        plannerService.getOptimizationOptionsDisplayed();
      var isAllowed = displayedOptimizationOptions.indexOf(key) !== -1;

      if (key === STEP_TWO_OPTIMIZATION_OPTIONS.AVOID_TOLLS) {
        return isAllowed && !!vm.showAvoidTollsOption;
      }
      if (key === STEP_TWO_OPTIMIZATION_OPTIONS.MAXIMIZE_ATTENDED_LOAD) {
        return isAllowed && !!vm.showMaximizeAttendedLoadOption;
      }
      if (key === STEP_TWO_OPTIMIZATION_OPTIONS.ONE_SELLER_PER_VEHICLE) {
        return isAllowed && !!vm.showOneSellerPerVehicleOption;
      }

      return isAllowed;
    }

    function isOptimizationOptionDisabled(option) {
      switch (option) {
        case STEP_TWO_OPTIMIZATION_OPTIONS.ON_FOOT:
          return vm.isOnFootRoutingDisabled;
        case STEP_TWO_OPTIMIZATION_OPTIONS.WAVE_ROUTING:
          return vm.isWaveRoutingNotNull;
      }

      for (var key in optimizationDependencies) {
        if (optimizationDependencies[key].includes(option) && vm.optimizationOptions[key]) {
          return true;
        }
      }
      return false;
    }

    function getOptimizationOptionTrueValue(option) {
      switch (option) {
        case STEP_TWO_OPTIMIZATION_OPTIONS.ALL_VEHICLES:
          return false;
        case STEP_TWO_OPTIMIZATION_OPTIONS.DISTANCE_TO_JOIN_VISITS:
          return _getDistanceToJoinVisitsOptionTrueValue(vm.originalPlan.plan_metadata);
        default:
          return true;
      }
    }

    function _getDistanceToJoinVisitsOptionTrueValue(planMetadata) {
      if (planMetadata && planMetadata.routing_options.distance_to_join_visits) {
        return planMetadata.routing_options.distance_to_join_visits;
      }
      return plannerService.optimizationOptions.distance_to_join_visits;
    }

    function getOptimizationOptionFalseValue(option) {
      switch (option) {
        case STEP_TWO_OPTIMIZATION_OPTIONS.ALL_VEHICLES:
          return true;
        case STEP_TWO_OPTIMIZATION_OPTIONS.DISTANCE_TO_JOIN_VISITS:
          return null;
        default:
          return false;
      }
    }

    function specialReplacing(string) {
      var replaced = '';
      replaced = string.replace('ciudad empresarial', 'huechuraba');
      replaced = string.replace('11 de Septiembre', 'Nueva Providencia');
      replaced = string.replace('2 avenida', 'segunda avenida');

      return replaced;
    }

    function isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function getAddressData(address) {

      var address_array = address.split(/[\s,]+/);
      var coincidences = [];

      for (var i = 0; i < address_array.length; i++) {
        var word = address_array[i];
        word = word.replace('(', "");
        word = word.replace(')', "");
        var expression = "^\\b(" + word.latinize() + ")\\b";   //|("+word+"\s+.*+)
        var reg = new RegExp(expression, "i");

        for (var key in cities) {
          if (reg.test(key.latinize())) {
            var match = {'key': key, 'city': cities[key]};
            coincidences.push(match);
          }
        }
      }
      return coincidences;
    }

    function isEditingPlan() {
      return plannerService.getPlanName() !== null;
    }

    function showRemoveWarningVisitsModal() {
      var noVisits = (!vm.visitCardsCurrentPage || vm.visitCardsCurrentPage.length === 0) && (!vm.visitForRoutingCardsCurrentPage || vm.visitForRoutingCardsCurrentPage.length === 0);
      if (noVisits) {
        return;
      }

      $scope.removeWarningVisits = removeWarningVisits;

      ngDialog.open({
        template: 'app/planner/visits/visits-remove-warning-visits-modal.html',
        scope: $scope
      });
    }

    function showRemoveErrorVisitsModal() {
      var noVisits = (!vm.visitCardsCurrentPage || vm.visitCardsCurrentPage.length === 0) && (!vm.visitForRoutingCardsCurrentPage || vm.visitForRoutingCardsCurrentPage.length === 0);
      if (noVisits) {
        return;
      }

      $scope.removeErrorVisits = removeErrorVisits;

      ngDialog.open({
        template: 'app/planner/visits/visits-remove-error-visits-modal.html',
        scope: $scope
      });
    }

    function removeWarningVisits() {
      var visits = plannerService.visits.filter(function (tmpVisit) {
        return (tmpVisit.status === 2 || tmpVisit.status === 3);
      });

      visits.forEach(function (visit) {
        removeWithoutAddNewVisit(visit);
        var indexVisit = vm.selectedVisits.indexOf(visit);
        if (indexVisit !== -1) {
          vm.selectedVisits.splice(indexVisit, 1);
        }
      });

      refreshVisits();
    }

    function removeErrorVisits() {
      var visits = plannerService.visits.filter(function (tmpVisit) {
        return (tmpVisit.status === 4);
      });

      visits.forEach(function (visit) {
        removeWithoutAddNewVisit(visit);
        var indexVisit = vm.selectedVisits.indexOf(visit);
        if (indexVisit !== -1) {
          vm.selectedVisits.splice(indexVisit, 1);
        }
      });

      refreshVisits();
    }

    function goToAlertVisits() {
      var visits = [];
      angular.copy(vm.visitCardsCurrentPage, visits);
      visits.sort(sortByField('title'));
      if (vm.warningVisitsQty > 0) {
        var visitId = null;
        for (var i = 0; i < visits.length; i++) {
          if (visits[i].status === 2 || visits[i].status === 3) {
            visitId = visits[i].id;
            break;
          }
        }
        if (visitId) {
          $timeout(function () {
            $anchorScroll(visitId);
          });
        }
      }
    }

    function goToErrorVisits() {
      var visits = [];
      angular.copy(vm.visitCardsCurrentPage, visits);
      visits.sort(sortByField('title'));
      if (vm.errorVisitsQty > 0) {
        var visitId = null;
        for (var i = 0; i < visits.length; i++) {
          if (visits[i].status === 4) {
            visitId = visits[i].id;
            break;
          }
        }
        if (visitId) {
          $timeout(function () {
            $anchorScroll(visitId);
          });
        }
      }
    }

    function sortByField(field) {
      return function (a, b) {
        if (a.status < b.status) {
          return 1;
        }
        if (a.status > b.status) {
          return -1;
        }
        if (a[field] < b[field]) {
          return -1;
        }
        if (a[field] > b[field]) {
          return 1;
        }
        return 0;
      };
    }

    function activeLoadVisits(plan, start_date, end_date, status, visitTypes, assignedToRoute, duplicateVisits, reuseVisits) {
      $rootScope.isLoading = true;

      var startDateVisitIntegration = moment(start_date).format('YYYY-MM-DD');
      var endDateVisitIntegration = moment(end_date).format('YYYY-MM-DD');

      var isCourierEnabled = plannerService.isCourierEnabled();

      return plannerService.loadVisits(startDateVisitIntegration, status, visitTypes, assignedToRoute, duplicateVisits, isCourierEnabled, endDateVisitIntegration, reuseVisits)
        .then(function (loadedVisits) {
          vm.currentLoadTotalVisits = loadedVisits.length;
          loadedVisits.forEach(function (visit) {
            if (vm.enableNewGeocoderAlerts) {
              var maxDistanceAlert = newValidatorGeoreferenceService.validateMaxDistance(
                visit, vm.vehicles, ACCOUNT_MAX_DISTANCE.value
              );
              maxDistanceAlert && visit.setAlert(maxDistanceAlert);
            }
            visit.setAddedInCurrentRouting(true);
            statisticsService.increaseTotalLoads(visit);
          });
          setZonesToVisits(plan.visits);

          skills = plannerService.getSkills();
          geocoder = googleService.createGeocode();
          plannerService.hideRoutes();
          plannerService.hideVehicles();
          plannerService.resetVisitLook();
          vm.visitCardsCurrentPage = [];
          // Execute anchorScroll in next $digest, after visits list has been set
          $timeout(function () {
            $anchorScroll($stateParams.recent);
          });

          vm.setCountryCodeFromVehicle(vm.vehicles[0], geocoder);

          analyzeVisitsForError();

          if (plan.visits.length > 0) {
            plannerService.orderVisitsByStatus();
            vm.refreshVisits();
            vm.totalLoadedVisitCards = _getAllPendingVisits().length;
            vm.totalLoadedVisitForRoutingCards = plannerService.visitsForRouting.length;
          }

          if (loadedVisits) {
            Toasts.push('success', _$translate('Planner_toast.visits_imported') + vm.currentLoadTotalVisits);
          }
          return addressStatsService.fetchAndProcessAddressStats(loadedVisits);
        })
        .catch(function (error) {
          $log.error(error);
        })
        .finally(function () {
          $rootScope.isLoading = false;
        });
    }

    function setCountryCodeFromVehicle(vehicle, geocoder) {
      var latlng = {
        lat: parseFloat(vehicle.locationStart.latitude),
        lng: parseFloat(vehicle.locationStart.longitude)
      };
      geocoder.geocode({
        'location': latlng
      }, function (results, status) {
        if (status === googleService.geocoderStatusOK()) {
          var place = results[0];
          var countryComponent = place.address_components.find(function(component) {
            return component.types[0] === 'country';
          });
          if (countryComponent) {
            vm.location_start.country_code = countryComponent.short_name;
          }
        } else {
          $log.warn('Error: no se pudo obtener el país de los vehículos activos.');
        }
      });
    }

    function setZonesToVisits(visits) {
      visits.forEach(function (visit) {
        visit.zones = zoneService.getZonesIntoVisit(vm.listZones, visit.latitude, visit.longitude);
      });
    }

    function activeWithoutLoadVisits(plan) {
      skills = plannerService.getSkills();
      geocoder = googleService.createGeocode();
      plannerService.hideRoutes();
      plannerService.hideVehicles();
      plannerService.resetVisitLook();
      vm.visitCardsCurrentPage = [];
      // Execute anchorScroll in next $digest, after visits list has been set
      $timeout(function () {
        $anchorScroll($stateParams.recent);
      });

      vm.setCountryCodeFromVehicle(vm.vehicles[0], geocoder);
      if ($stateParams.recent) {
        var foundVisit = plannerService.getVisits().find(function (visit) {
          return visit.id === $stateParams.recent;
        });

        if (foundVisit) {
          validatorGeoreferenceService.validateVisit(
            foundVisit, {}, vm.vehicles, vm.userData.country, ACCOUNT_MAX_DISTANCE.value
          );
        }
      }

      analyzeVisitsForError();
      if (plan.visits.length > 0) {
        plannerService.orderVisitsByStatus();
        vm.refreshVisits();
        vm.totalLoadedVisitCards = _getAllPendingVisits().length;
        vm.totalLoadedVisitForRoutingCards = plannerService.visitsForRouting.length;
      }

      $rootScope.isLoading = false;
    }

    function loadIncompleteVisits(start_date, end_date, status, visitTypes) {
      var assignedToRoute = true;
      var duplicateVisits = true;
      getVisitsIntegration(start_date, end_date, status, visitTypes, assignedToRoute, duplicateVisits, vm.reuseVisits);
    }

    function updateEditableVisitsStatus() {
      vm.areVisitsEditable =  plannerService.getVisits().some(function (visit) {
        return canVisitBeEditedOrRemoved(visit);
      });
    }

    function loadUnroutedVisits(start_date, end_date, visitTypes) {
      var status = 'pending';
      var assignedToRoute = false;
      var duplicateVisits = false;
      var reuseVisits = false;
      vm.currentLoadTotalVisits = 0;
      vm.currentLoadWarningVisitsQty = 0;
      vm.currentLoadErrorVisitsQty = 0;
      vm.getVisitsIntegration(start_date, end_date, status, visitTypes, assignedToRoute, duplicateVisits, reuseVisits)
        .then(function() {
          if (vm.enablePickupAndDeliveryMode) {
            plannerService.loadVisitsPickupAndDeliveryRelationship()
              .catch(function (error) {
                $log.error(error);
              });
          }
        });
    }

    function getVisitsIntegration(start_date, end_date, status, visitTypes, assignedToRoute, duplicateVisits, reuseVisits) {
      vm.closeMenuVisitsImport();
      return plannerService.getPlan()
        .then(function (plan) {
          return activeLoadVisits(plan, start_date, end_date, status, visitTypes, assignedToRoute, duplicateVisits, reuseVisits);
        });
    }

    function checkOptions() {
      // Clear unusual combination of options
      for (var key in vm.optimizationOptions) {
        vm.checkOptionOptimize(key);
      }
      if (vm.enableRadialRouting) {
        vm.optimizationOptions.radial_routing = vm.radialRoutingOption;
      }
      if (vm.isPrioritizeLoadOptionEnabled) {
        vm.optimizationOptions.prioritize_load = vm.prioritizeLoadOption;
      }
      plannerService.setlocalOptimizationOptions(vm.optimizationOptions);
      return _askForRemoveRoutes();

    }

    function openMenuToAddVisits() {
      vm.menuVisitIsOpen = !vm.menuVisitIsOpen;
      vm.popupCalendar = false;
    }

    function openComponentVisitsIntegration() {
      vm.popupVisitsIntegrationNotCompleted = false;
      vm.popupVisitsIntegration = !vm.popupVisitsIntegration;
      vm.dataVisitsImport = {
        title: $filter('translate')('Visits.component_visits_import.title_visits_integration'),
        titleVisitTypeList: $filter('translate')('Visits.component_visits_import.title_visit_type_list'),
        checkbox: null,
        calendar: {
          startDate: vm.dateToGetIntegrationVisits,
          endDate: vm.dateToGetIntegrationVisits,
          options: vm.dateOptions
        },
        button: {
          title: $filter('translate')('Visits.component_visits_import.button_title')
        },
        visitTypeList: plannerService.getVisitTypes(),
        visitStatusList: [],
        closePopupVisitsIntegration: function () {
          vm.popupVisitsIntegration = false;
        }
      };
    }

    function openComponentVisitsIntegrationNotCompleted() {
      vm.popupVisitsIntegration = false;
      vm.popupVisitsIntegrationNotCompleted = !vm.popupVisitsIntegrationNotCompleted;
      vm.dataVisitsImportNotCompleted = {
        title: $filter('translate')('Visits.component_visits_import.title_visits_integration_not_completed'),
        checkbox: null,
        calendar: {
          startDate: vm.dateToGetIntegrationVisitsNotCompleted,
          endDate: vm.dateToGetIntegrationVisitsNotCompleted,
          options: vm.dateOptions
        },
        button: {
          title: $filter('translate')('Visits.component_visits_import.button_title')
        },
        visitStatusList: [
          {
            id: 'pending',
            label: $filter('translate')('Visits.component_visits_import.visits_pending_label'),
            selected: false
          },
          {
            id: 'failed',
            label: $filter('translate')('Visits.component_visits_import.visits_failed_label'),
            selected: false
          }
        ],
        visitTypeList: plannerService.getVisitTypes(),
        closePopupVisitsIntegration: function () {
          vm.popupVisitsIntegrationNotCompleted = false;
        }
      };
    }

    function closeMenuVisitsImport() {
      vm.popupVisitsIntegration = false;
      vm.popupVisitsIntegrationNotCompleted = false;
      vm.menuVisitIsOpen = false;
    }

    function onClickSearch(result) {
      visitListFilterService.applyResultToVM(result);
      refreshVisits();
    }

    function onRemoveSearch() {
      visitListFilterService.removeResultFromVM();
      vm.refreshVisits();
    }

    ///////////////////////////////////////////////////////
    // Private methods
    //////////////////////////////////////////////////////

    function _cleanUp(_address) {
      var address_object = {
        full_address: '',
        street_address: '',
        administrative_area: '',
        original_address: _address,
        cleaned_array: []
      };

      if (vm.location_start.country_code !== 'CL') {
        address_object.full_address = _address;
        return address_object;
      }


      var AVENIDA = 'avenida';
      var DEPARTAMENTO = 'departamento';
      var OFICINA = 'oficina';
      var PISO = 'piso';
      var PASAJE = 'pasaje';
      var PASEO = 'paseo';
      var CALLE = 'calle';
      var MODULO = 'modulo';
      var CIUDAD = 'ciudad';
      var PARQUE = 'parque';
      var INDUSTRIAL = 'industrial';
      var SANTIAGO = 'santiago';
      var BLOCK = 'block';
      var POBLACION = 'población';

      var abbrev_dictionary = {
        'ave': AVENIDA,
        'av': AVENIDA,
        'aven': AVENIDA,
        'aveni': AVENIDA,
        'avda': AVENIDA,
        'brdo': 'bernardo',
        'blk': BLOCK,
        'blck': BLOCK,
        'blok': BLOCK,
        'cuidad': CIUDAD,
        'call': CALLE,
        'cale': CALLE,
        'd': DEPARTAMENTO,
        'depto': DEPARTAMENTO,
        'dep': DEPARTAMENTO,
        'dp': DEPARTAMENTO,
        'dpto': DEPARTAMENTO,
        'indus': INDUSTRIAL,
        'lib': 'libertador',
        'mod': MODULO,
        'n': '',
        'of': OFICINA,
        'ofna': OFICINA,
        '0ficina': OFICINA,
        'ohggins': "O'higgins",
        'p': PISO,
        'pob': POBLACION,
        'pobl': POBLACION,
        'pobla': POBLACION,
        'poblacion': POBLACION,
        'parq': PARQUE,
        'parqu': PARQUE,
        'pj': PASAJE,
        'psj': PASAJE,
        'pje': PASAJE,
        'psaje': PASAJE,
        'ppsje': PASAJE,
        'psje': PASAJE,
        'pseo': PASEO,
        'stgo': SANTIAGO,
        'santiag': SANTIAGO,
        'prof': 'profesor'

      };

      var address = _address.replace(/[,.:;\/\"\'?¿!|¡_#$*(){}\[\]%@^`~\-]/g, ' ').replace('.', ' ').replace('\u00BA', ' ').replace('\u00B0', ' ').replace(/ *\([^)]*\) */g, " ").toLowerCase();
      address = address.replace(/\./g, ' ');
      address = address.replace(/\,/g, ' ');
      address = address.replace(/\),\(/g, ' ');
      address = address.replace(/\s\s+/g, ' ');
      address = address.replace(/\),\(/g, ' ');
      address = address.replace(/[\])}[{(]/g, '');
      address = address.replace(/\s\s+/g, ' ');
      address = address.replace(/\*/g, '');

      var address_array = address.split(/[ ,]+/).filter(Boolean); //  address.split(/[\s,]+/);
      var cleaned_array = [];

      var number = false;
      var lastIndex = 0;

      for (var i = 0; i < address_array.length; i++) {
        var word = address_array[i].replace(/^.*#/, '');
        word = abbrev_dictionary[word] || word;
        //word  = abbrev_dictionary[address_array[i]] || address_array[i];
        address_array[i] = word;

        if (address_array[i] === OFICINA || address_array[i] === DEPARTAMENTO ||
          address_array[i] === PISO || address_array[i] === MODULO || address_array[i] === BLOCK || address_array[i] === POBLACION) {
          address_array.splice(i + 1, 1);
          address_array.splice(i, 1);
          i--;
          continue;
        }
        if (address_array[i] === PASAJE) {

          if (!!address_array[i + 1] && (!isNumber(parseInt(address_array[i + 1]))) && address_array[i + 1].length > 1) {
            address_array.splice(i, 1);
            i--;
            continue;
          }
        }

        if (number) {
          if (address_array[i] !== 'norte' &&
            address_array[i] !== 'sur' &&
            address_array[i] !== 'poniente' &&
            address_array[i] !== 'oriente' && !isNumber(parseInt(address_array[i])) &&
            address_array[i] !== 'de' || cleaned_array.length > 0) {

            var street_address = '';
            if (cleaned_array.length === 0) {
              for (var j = lastIndex; j < i; j++) {
                street_address += address_array[j] + ' ';
              }
              cleaned_array.push(street_address.trim());
              cleaned_array.push(address_array[i]);
              lastIndex = i;
            } else {
              cleaned_array.push(address_array[i]);
            }
          } else {
            number = false;
          }
        } else if (isNumber(parseInt(address_array[i])) && i > 0) {
          number = true;
        }
      }

      var key;
      var matches = [];
      var candidates = [];
      for (var i = 1; i < cleaned_array.length; i++) {
        key = cleaned_array[i];
        matches = getAddressData(key);
        if (matches.length === 0) {
          continue;
        }
        if (matches.length === 1) {
          var words = matches[0].key.split(" ");
          if (words.length > 1) {
            if (cleaned_array.length > i + 1) {
              var word = cleaned_array[i] + ' ' + cleaned_array[i + 1];
              word = word.replace('(', "");
              word = word.replace(')', "");
              var expression = "^\\b(" + word.latinize() + ")\\b";   //|("+word+"\s+.*+)
              var reg = new RegExp(expression, "i");
              if (reg.test(matches[0].key.latinize())) {
                candidates.push(matches[0]);
                continue;
              }
            }
          } else {
            candidates.push(matches[0]);
            continue;
          }
        } else {
          for (var j = 0; j < matches.length; j++) {
            if (cleaned_array.length > i + 1) {
              var word = cleaned_array[i] + ' ' + cleaned_array[i + 1];
              word = word.replace('(', "");
              word = word.replace(')', "");
              var expression = "^\\b(" + word.latinize() + ")\\b";   //|("+word+"\s+.*+)
              var reg = new RegExp(expression, "i");
              if (reg.test(matches[j].key.latinize())) {
                candidates.push(matches[j]);
              }
            }
          }
        }
      }

      if (cleaned_array.length > 0) {
        var lateClean = cleaned_array[0].split(/[ ,]+/).filter(Boolean);
        for (var i = 0; i < lateClean.length; i++) {
          var word = lateClean[i];
          if (word === 'villa' || word === 'población') {
            if (lateClean.length > i + 1) {
              if (lateClean[i + 1] === 'el' || lateClean[i + 1] === 'la' || lateClean[i + 1] === 'los' || lateClean[i + 1] === 'las' || lateClean[i + 1] === 'san') {
                if (lateClean.length > i + 2) {
                  lateClean.splice(i + 2, 1);
                  lateClean.splice(i + 1, 1);
                  lateClean.splice(i, 1);
                } else {
                  lateClean.splice(i + 1, 1);
                  lateClean.splice(i, 1);
                }
              } else {
                lateClean.splice(i + 1, 1);
                lateClean.splice(i, 1);
              }
            } else {
              lateClean.splice(i, 1);
            }
          }
        }
        cleaned_array[0] = lateClean.join(' ');
      }


      var formated_address = '';

      if (candidates.length > 0) {
        cleaned_array[0] = specialReplacing(cleaned_array[0]);
        formated_address = candidates[0].key === "Quilicura" ? cleaned_array[0] + ', ' + candidates[0].key :
          cleaned_array[0] + ', ' + candidates[0].key + ', ' + candidates[0].city.city;

        address_object.full_address = formated_address;
        address_object.street_address = cleaned_array[0];
        address_object.administrative_area = candidates[0].key;
        address_object.administrative_location = candidates[0].city.location;

        return address_object;
      }

      var joined = address_array.join(' ');

      address_object.full_address = specialReplacing(joined);
      address_object.street_address = cleaned_array[0];
      address_object.administrative_area = null;
      address_object.administrative_location = null;


      return address_object;
    }

    function _validateSkills(skillsArray) {
      var response = [];
      for (var j = 0; j < skillsArray.length; j++) {
        var skillName;

        try {
          skillName = skillsArray[j].trim();
        } catch (error) {
          skillName = skillsArray[j];
        }

        var skill = skills.find(function (_skill) {
          return _skill.name === skillName || _skill.id.toString() === skillName;
        });

        if (skill) {
          response.push(String(skill.name));
        }
      }

      return response;
    }

    function _isNaNorEmpty(value) {
      return (isNaN(value) || value === '' || value === null || !isNumber(value));
    }


    function _addVisitFromNextPage(currentVisitCardsPage, visitCardsCurrentPage, visitsToRender) {
      // If there is free space in the current page, and there are more visits in the next page, add one of them to the
      // current page.
      var amountItemsLastPages = (currentVisitCardsPage - 1) * vm.VISIT_CARDS_PER_PAGE;
      var indexVisitToAdd = amountItemsLastPages + visitCardsCurrentPage.length;
      var visitToAdd =  visitsToRender[indexVisitToAdd];
      if (visitToAdd) {
        visitToAdd.actionPaintOnMap();
        visitCardsCurrentPage.push(visitToAdd);
      }
    }

    function _fillVisitsFiltered() {
      vm.visitCardsCurrentPage = [];
      vm.visitForRoutingCardsCurrentPage = [];

      var visitCards = _getAllVisitsToRender();
      var visitForRoutingCards = _getAllVisitsForRoutingToRender();

      if (visitCards.length === 0 || visitForRoutingCards.length === 0) {
        vm.VISIT_CARDS_PER_PAGE = VISIT_CARDS_PER_PAGE;
      } else {
        vm.VISIT_CARDS_PER_PAGE = VISIT_FOR_ROUTING_CARDS_PER_PAGE;
      }

      if (vm.filterHandler.activeFilter) {
        vm.currentVisitCardsPage = 1;
        vm.currentVisitForRoutingCardsPage = 1;
      }

      var visitCardsLimit = vm.currentVisitCardsPage * vm.VISIT_CARDS_PER_PAGE;
      if (visitCards.length < visitCardsLimit) {
        visitCardsLimit = visitCards.length;
      }

      var i = (vm.currentVisitCardsPage - 1) * vm.VISIT_CARDS_PER_PAGE;
      var j = 0;

      for (; i < visitCardsLimit; i++) {
        if (visitCards[i]) {
          vm.visitCardsCurrentPage[j] = visitCards[i];
          j++;
        } else {
          break;
        }
      }

      var visitForRoutingCardsLimit = vm.currentVisitForRoutingCardsPage * vm.VISIT_CARDS_PER_PAGE;
      if (visitForRoutingCards.length < visitForRoutingCardsLimit) {
        visitForRoutingCardsLimit = visitForRoutingCards.length;
      }

      var k = (vm.currentVisitForRoutingCardsPage - 1) * vm.VISIT_CARDS_PER_PAGE;
      var l = 0;

      for (; k < visitForRoutingCardsLimit; k++) {
        if (visitForRoutingCards[k]) {
          vm.visitForRoutingCardsCurrentPage[l] = visitForRoutingCards[k];
          l++;
        } else {
          break;
        }
      }
    }

    function getSortOptions() {
      return {
        identities: vm.currentSortOptions.map(function (option) {
          return option.replace('-', '');
        }),
        orders: vm.currentSortOptions.map(function (option) {
          return option.startsWith('-') ? 'desc' : 'asc';
        })
      };
    }

    /**
     * "If there's no active filter, return all visits, otherwise return all the visits that are in the active
     * filter."
     *
     * @returns An array of visits.
     */
    function _getAllVisitsToRender() {
      var visits = [];
      var sortOptions = getSortOptions();

      if (!vm.filterHandler.activeFilter) {
        visits = lodash.orderBy(plannerService.visits, sortOptions.identities, sortOptions.orders);
      } else {
        visits = lodash.orderBy(Object.values(vm.filterHandler.visits), sortOptions.identities, sortOptions.orders);
      }

      if (vm.positiveSelectionVisitsEnabled) {
        return visits.filter(function (visit) {
          return !plannerService.visitsForRouting.includes(visit.id);
        });
      }

      return visits;
    }


    function _getAllVisitsForRoutingToRender() {
      if (!vm.positiveSelectionVisitsEnabled) {
        return [];
      }

      var visits = [];
      var sortOptions = getSortOptions();

      if (!vm.filterHandler.activeFilter) {
        visits = lodash.orderBy(plannerService.visits, sortOptions.identities, sortOptions.orders);
      } else {
        visits = lodash.orderBy(Object.values(vm.filterHandler.visits), sortOptions.identities, sortOptions.orders);
      }

      return visits.filter(function (visit) {
        return plannerService.visitsForRouting.includes(visit.id);
      });
    }

    function _mapFitboundVisits(visits) {
      try {
        var bounds = googleService.getLatLngBounds();
        var googleMap = plannerService.getGmap();
        visits.forEach(function (visit) {
          var position = googleService.getGoogleMapsLatLng(visit.latitude, visit.longitude);
          bounds.extend(position);
        });

        googleMap.fitBounds(bounds);
        if (visits.length <= 3) {
          if (visits.length === 0) {
            googleMap.setCenter(googleService.getGoogleMapsLatLng(-33.45, -70.666667));
            googleMap.setZoom(11);
            return;
          }
          googleMap.setZoom(12);
        }
        googleMap.panBy(1, 0);
      } catch (error) {
        $log.info(error);
      }
    }

    function _askForRemoveRoutes() {
      var CLOSE_DIALOG = new Error(0);
      var REOPTIMIZE_AND_OVERWRITE_PLAN = 1;
      var dialog = null;
      var deferred = $q.defer();
      var modePlan = plannerService.getEditingPlan();

      if (vm.optimizationOptions.wave_routing) {
        dialog = ngDialog.open({
          template: 'app/planner/visits/visits-wave-routing-modal.html',
          controller: 'VisitsWaveRoutingModalController',
          controllerAs: 'vm',
          scope: $scope
        });
        dialog.closePromise.then(function (obj) {
          if ([1,3].includes(obj.value)) {
            deferred.resolve(obj.value);
          } else {
            deferred.reject(CLOSE_DIALOG);
          }
        });
      } else if (vm.positiveSelectionVisitsEnabled && plannerService.visitsForRouting.length > 0  && modePlan.status === false) {
        if (modePlan.status === false) {
          dialog = ngDialog.open({
            template: 'app/planner/visits/visits-warning-checked-visits-modal.html',
            controller: 'VisitsWarningCheckedVisitsModalController',
            controllerAs: 'vm',
            scope: $scope
          });
          dialog.closePromise.then(function (obj) {
            if ([1].includes(obj.value)) {
              deferred.resolve(obj.value);
            } else {
              deferred.reject(CLOSE_DIALOG);
            }
          });
        }
      } else {
        var modePlan = plannerService.getEditingPlan();
        if (plannerService.routes.length > 0 && modePlan.status === true) {
          dialog = ngDialog.open({
            template: 'app/planner/visits/visits-remove-route-modal.html',
            controller: 'VisitsRemoveRouteModalController',
            controllerAs: 'vm',
            scope: $scope
          });
          dialog.closePromise.then(function (obj) {
            if ([1,2,3].includes(obj.value)) {
              deferred.resolve(obj.value);
            } else {
              deferred.reject(CLOSE_DIALOG);
            }
          });
        } else {
          deferred.resolve(REOPTIMIZE_AND_OVERWRITE_PLAN);
        }
      }
      return deferred.promise;
    }

    function _fixData(data) {
      var o = "", l = 0, w = 10240;
      for (; l < data.byteLength / w; ++l) {
        o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
      }
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    }

    function _sheetFromArrayOfArrays(data) {
      // Reference: http://sheetjs.com/demos/writexlsx.html
      var ws = {};
      var range = {s: {c: 10000000, r: 10000000}, e: {c: 0, r: 0}};
      for (var R = 0; R !== data.length; ++R) {
        for (var C = 0; C !== data[R].length; ++C) {
          if (range.s.r > R) {
            range.s.r = R;
          }
          if (range.s.c > C) {
            range.s.c = C;
          }
          if (range.e.r < R) {
            range.e.r = R;
          }
          if (range.e.c < C) {
            range.e.c = C;
          }
          var cell = {v: data[R][C]};
          if (cell.v === null) {
            continue;
          }
          var cell_ref = XLSX.utils.encode_cell({c: C, r: R});

          if (angular.isNumber(cell.v)) {
            cell.t = 'n';
          } else if (typeof cell.v === 'boolean') {
            cell.t = 'b';
          } else if (cell.v instanceof Date) {
            cell.t = 'n';
            cell.z = XLSX.SSF._table[14];
            cell.v = datenum(cell.v);
          } else {
            cell.t = 's';
          }

          ws[cell_ref] = cell;
        }
      }
      if (range.s.c < 10000000) {
        ws['!ref'] = XLSX.utils.encode_range(range);
      }
      return ws;

      function datenum(v, date1904) {
        if (date1904) {
          v += 1462;
        }
        var epoch = Date.parse(v);
        return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
      }
    }

    function _writeWorkbook(workbook, filename) {
      // Reference: http://sheetjs.com/demos/writexlsx.html
      var wopts = {bookType: 'xlsx', bookSST: false, type: 'binary'};
      var wbout = XLSX.write(workbook, wopts);
      /* the saveAs call downloads a file on the local machine */
      saveAs(new Blob([s2ab(wbout)], {type: ''}), filename + '.xlsx');

      function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i !== s.length; ++i) {
          view[i] = s.charCodeAt(i) & 0xFF;
        }
        return buf;
      }
    }

    function isNewCleanerEnable() {
      return countriesUsingCleaner.indexOf(vm.userAccountCountry) !== -1;
    }

    function getVisitTypeKey(label) {
      if (!label) {
        return null;
      }
      var visitType = plannerService.getVisitTypes().find(function (type) {
        return label.toLowerCase().trim() === type.label.toLowerCase().trim();
      });

      return visitType ? visitType.key : null;
    }

    function formatTimeWindow(window) {
      if (window.isValid()) {
        // Back to string
        window = window.format('HH:mm');
      } else {
        window = null;
      }
      return window;
    }

    function fixStringSkills(skillsArray){
      var skillName = '';
      // skillsArray is iterated looking for skills that are in string format
      for (var j = 0; j < skillsArray.length; j++) {
        if (typeof skillsArray[j] === "string") {
          skillName = skillsArray[j].trim();
          skillsArray.splice(j, 1);
          for (var k = 0; k < skills.length; k++) {
            if (skills[k].name === skillName) {
              skillsArray.splice(j, 0, skills[k].id);
            }
          }
        }
      }
      return skillsArray;
    }

    function createVisitObj(title, address, visit, latitude, longitude, administrativeArea, status, error, country, isMixLoadEnabled) {
      var load = secureParseToFloat(visit.C, 0);
      var windowStart = moment(getTimeFromExcel(visit.D), ['HH:mm', 'HH:mm:ss']);
      var windowEnd = moment(getTimeFromExcel(visit.E), ['HH:mm', 'HH:mm:ss']);
      var duration = _isNaNorEmpty(visit.F) ? 10 : parseInt(visit.F);
      var notes = visit.G || '';
      var referenceId = visit.J || '';
      var skillsRequired = visit.K ? visit.K.split(',') : [];
      var skillsOptional = visit.L ? visit.L.split(',') : [];
      var contactName = visit.M || '';
      var contactPhone = visit.N || '';
      var windowStart2 = moment(getTimeFromExcel(visit.O), ['HH:mm', 'HH:mm:ss']);
      var windowEnd2 = moment(getTimeFromExcel(visit.P), ['HH:mm', 'HH:mm:ss']);
      var load2 = secureParseToFloat(visit.Q, 0);
      var load3 = secureParseToFloat(visit.R, 0);
      var load4, priority, contactEmail, priorityLevel, pickLoad, pickLoad2, pickLoad3, programmedDate, visitType;

      if (isMixLoadEnabled) {
        load4 = secureParseToFloat(visit.S, 0);
        priority = (!isNaN(parseInt(visit.T))) ? parseInt(visit.T) : 0;
        contactEmail = visit.V ? formatContactEmail(visit.V) : '';
        priorityLevel = (!isNaN(parseInt(visit.T))) ? parseInt(visit.T) : 0;
        pickLoad = secureParseToFloat(visit.W, 0);
        pickLoad2 = secureParseToFloat(visit.X, 0);
        pickLoad3 = secureParseToFloat(visit.Y, 0);
        programmedDate = getDateFromExcel(visit.Z);
        visitType = getVisitTypeKey(visit.AA) || null;
      } else {
        load4 = 0;
        priority = (!isNaN(parseInt(visit.S))) ? parseInt(visit.S) : 0;
        contactEmail = visit.U ? formatContactEmail(visit.U) : '';
        priorityLevel = (!isNaN(parseInt(visit.S))) ? parseInt(visit.S) : 0;
        pickLoad = secureParseToFloat(visit.V, 0);
        pickLoad2 = secureParseToFloat(visit.W, 0);
        pickLoad3 = secureParseToFloat(visit.X, 0);
        programmedDate = getDateFromExcel(visit.Y);
        visitType = getVisitTypeKey(visit.Z) || null;
      }

      if (_isNaNorEmpty(visit.C)) {
        $log.warn("Error in the visit's capacity format " + title);
      }

      if (_isNaNorEmpty(visit.F)) {
        $log.warn("Error in the visit's duration format " + title);
      }

      // Validate window_start and window_end formats
      windowStart = formatTimeWindow(windowStart);
      windowEnd = formatTimeWindow(windowEnd);

      windowStart2 = formatTimeWindow(windowStart2);
      windowEnd2 = formatTimeWindow(windowEnd2);

      skillsRequired = _validateSkills(skillsRequired);
      skillsOptional = _validateSkills(skillsOptional);

      skillsRequired = fixStringSkills(skillsRequired);
      skillsOptional = fixStringSkills(skillsOptional);

      var visitObj = {
        title: title,
        address: address,
        latitude: latitude,
        longitude: longitude,
        addressFull: '',
        load: load,
        load2: load2,
        load3: load3,
        load4: load4,
        duration: duration,
        notes: notes,
        reference: referenceId,
        windowStart: windowStart,
        windowEnd: windowEnd,
        windowStart2: windowStart2,
        windowEnd2: windowEnd2,
        administrative_area: administrativeArea,
        status: status,
        error: error,
        country: country,
        skills_required: skillsRequired,
        skills_optional: skillsOptional,
        contactName: contactName,
        contactPhone: contactPhone,
        priority: priority,
        contactEmail: contactEmail,
        priorityLevel: priorityLevel,
        pickLoad: pickLoad,
        pickLoad2: pickLoad2,
        pickLoad3: pickLoad3,
        request_status: 'created',
        programmedDate: programmedDate,
        visitType: visitType,
        addressStatistics: {
          status: '',
          last_latitude: null,
          last_longitude: null
        },
        seller_id: null,
        city: ''
      };
      return visitObj;
    }

    function buildVisitToGeoreferenceRequest(visit) {
      return {
        address: visit.addressFull.full_address ? visit.addressFull.full_address : visit.address,
        id: utilsService.guid(),
      };

    }

    function _validatorGeoreferenceVisit(visit) {
      var georeferenceInaccuracy = visit.georeferenceInaccuracy;
      if (vm.enableNewGeocoderAlerts && georeferenceInaccuracy) {
        newValidatorGeoreferenceService.validateVisit(
          visit, georeferenceInaccuracy, vm.vehicles, ACCOUNT_MAX_DISTANCE.value
        );
      } else {
        var cleaned = visit.rawAddress ? _cleanUp(visit.address) : {};
        validatorGeoreferenceService.validateVisit(
          visit, cleaned, vm.vehicles, vm.userData.country, ACCOUNT_MAX_DISTANCE.value
        );
      }

      // Set the number of warnings or errors tab
      if (visit.error && visit.error.type === 4) {
        vm.errorVisitsQty++;
        vm.currentLoadErrorVisitsQty++;
      } else if (visit.error && (visit.error.type === 2 || visit.error.type === 3)) {
        vm.warningVisitsQty++;
        vm.currentLoadWarningVisitsQty++;
      }
    }

    function _updatePromiseBar() {
      if ($rootScope.isLoadingPlanner) {
        if (vm.maxProgressBar > vm.visitsGeoreference) {
          if (vm.lenghtBatchs) {
            if (lodash.indexOf(vm.lenghtBatchs, vm.visitsGeoreference) === -1) {
              vm.visitsGeoreference = vm.visitsGeoreference + 1;
              var temporal = (vm.visitsGeoreference / vm.maxProgressBar) * 100;
              vm.widthDynamic = String(temporal) + "%";
            }
          }
        } else if (importRowsLength === vm.maxProgressBar) {
          _cancelLoading();
        }
      } else {
        _cancelLoading();
      }
    }

    function _cancelLoading() {
      if (vm.errorAddress) {
        Toasts.push('warning', _$translate('Planner_toast.wrong_row_excel'));
      }
      // Apagar Loading y vaciar elementos de condicion
      $timeout(function () {
        importRowsLength = 0;
        plannerService.orderVisitsByStatus();
        refreshVisits();
        vm.totalLoadedVisitCards = _getAllPendingVisits().length;
        vm.totalLoadedVisitForRoutingCards = plannerService.visitsForRouting.length;
        $rootScope.isLoadingPlanner = false;
        vm.visitsGeoreference = 0;
        vm.widthDynamic = "0%";
        vm.lenghtBatchs = [];
        if (intervalPromise) {
          $interval.cancel(intervalPromise);
        }

      }, 10);
    }

    function checkAllVisits() {
      _getAllVisitsToRender().forEach(function (visit) {
        if (canVisitBeEditedOrRemoved(visit)) {
          visit.checked = vm.allVisitsChecked;
          // Handle marker colors based on checked state
          if (vm.allVisitsChecked) {
            $scope.$emit("Planner:Highlight:Visit", {visit: visit});
          } else {
            $scope.$emit("Planner:notHighlight:Visit", {visit: visit});
            $rootScope.$broadcast('visits:hideAlertBarSelectedVisits');
          }
          updateSelectedVisits(visit);
        }
      });
      updateTotalOfSelectedAndRenderedVisits();
       // Handle navbar visibility
      if (vm.selectedVisits.length === 0) {
        $rootScope.$broadcast('visits:hideAlertBarSelectedVisits');
      } else {
        plannerUpdateToolSelectionOnMap();
      }
    }

    function checkVisit(visit) {
      if (visit.checked) {
        // Highlight when checked
        $scope.$emit("Planner:Highlight:Visit", {visit: visit});
      } else {
        // Remove highlight when unchecked
        $scope.$emit("Planner:notHighlight:Visit", {visit: visit});
      }

      if (!visit.checked) {
        vm.allVisitsChecked = false;

        var isPendingVisit = vm.visitCardsCurrentPage.find(function(v) {
          return v.id === visit.id;
        });

        var isForRoutingVisit = vm.visitForRoutingCardsCurrentPage && vm.visitForRoutingCardsCurrentPage.find(function(v) {
          return v.id === visit.id;
        });

        if (isPendingVisit) {
          vm.allPendingVisitsChecked = false;
        }

        if (isForRoutingVisit) {
          vm.allVisitsForRoutingChecked = false;
        }
      } else {

        var isPendingVisit = vm.visitCardsCurrentPage.find(function(v) {
          return v.id === visit.id;
        });

        var isForRoutingVisit = vm.visitForRoutingCardsCurrentPage && vm.visitForRoutingCardsCurrentPage.find(function(v) {
          return v.id === visit.id;
        });

        if (isPendingVisit) {
          var allPendingChecked = vm.visitCardsCurrentPage.every(function(v) {
            return v.checked || !vm.canVisitBeEditedOrRemoved(v);
          });

          vm.allPendingVisitsChecked = allPendingChecked;
        }

        if (isForRoutingVisit) {
          var allForRoutingChecked = vm.visitForRoutingCardsCurrentPage.every(function(v) {
            return v.checked || !vm.canVisitBeEditedOrRemoved(v);
          });

          vm.allVisitsForRoutingChecked = allForRoutingChecked;
        }

        var allVisitsInBothLists = vm.visitCardsCurrentPage.concat(vm.visitForRoutingCardsCurrentPage || []);
        var allChecked = allVisitsInBothLists.every(function(v) {
          return v.checked || !vm.canVisitBeEditedOrRemoved(v);
        });

        vm.allVisitsChecked = allChecked;
      }

      updateSelectedVisits(visit);
      updateTotalOfSelectedAndRenderedVisits();

      // Hide navbar if no visits selected
      if (vm.selectedVisits.length === 0) {
        $rootScope.$broadcast('visits:hideAlertBarSelectedVisits');
      } else {
        plannerUpdateToolSelectionOnMap();
      }
    }

    function goToEdit() {
      var visitIds = [];
      vm.selectedVisits.forEach(function (visit) {
        visitIds.push(visit.id);
        visit.checked = true;
      });

      if (visitIds.length > 1) {
        $state.go('^.visits-bulk-edit', {visitsId: visitIds, page: vm.currentVisitCardsPage});
      } else {
        $state.go('^.visits-detail', {visitId: visitIds[0], fstatus: vm.activeFilter, page: vm.currentVisitCardsPage});
      }
    }

    function latinizeString() {
      var Latinise = {};
      Latinise.latin_map = {
        "Á": "A",
        "Ă": "A",
        "Ắ": "A",
        "Ặ": "A",
        "Ằ": "A",
        "Ẳ": "A",
        "Ẵ": "A",
        "Ǎ": "A",
        "Â": "A",
        "Ấ": "A",
        "Ậ": "A",
        "Ầ": "A",
        "Ẩ": "A",
        "Ẫ": "A",
        "Ä": "A",
        "Ǟ": "A",
        "Ȧ": "A",
        "Ǡ": "A",
        "Ạ": "A",
        "Ȁ": "A",
        "À": "A",
        "Ả": "A",
        "Ȃ": "A",
        "Ā": "A",
        "Ą": "A",
        "Å": "A",
        "Ǻ": "A",
        "Ḁ": "A",
        "Ⱥ": "A",
        "Ã": "A",
        "Ꜳ": "AA",
        "Æ": "AE",
        "Ǽ": "AE",
        "Ǣ": "AE",
        "Ꜵ": "AO",
        "Ꜷ": "AU",
        "Ꜹ": "AV",
        "Ꜻ": "AV",
        "Ꜽ": "AY",
        "Ḃ": "B",
        "Ḅ": "B",
        "Ɓ": "B",
        "Ḇ": "B",
        "Ƀ": "B",
        "Ƃ": "B",
        "Ć": "C",
        "Č": "C",
        "Ç": "C",
        "Ḉ": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Ƈ": "C",
        "Ȼ": "C",
        "Ď": "D",
        "Ḑ": "D",
        "Ḓ": "D",
        "Ḋ": "D",
        "Ḍ": "D",
        "Ɗ": "D",
        "Ḏ": "D",
        "ǲ": "D",
        "ǅ": "D",
        "Đ": "D",
        "Ƌ": "D",
        "Ǳ": "DZ",
        "Ǆ": "DZ",
        "É": "E",
        "Ĕ": "E",
        "Ě": "E",
        "Ȩ": "E",
        "Ḝ": "E",
        "Ê": "E",
        "Ế": "E",
        "Ệ": "E",
        "Ề": "E",
        "Ể": "E",
        "Ễ": "E",
        "Ḙ": "E",
        "Ë": "E",
        "Ė": "E",
        "Ẹ": "E",
        "Ȅ": "E",
        "È": "E",
        "Ẻ": "E",
        "Ȇ": "E",
        "Ē": "E",
        "Ḗ": "E",
        "Ḕ": "E",
        "Ę": "E",
        "Ɇ": "E",
        "Ẽ": "E",
        "Ḛ": "E",
        "Ꝫ": "ET",
        "Ḟ": "F",
        "Ƒ": "F",
        "Ǵ": "G",
        "Ğ": "G",
        "Ǧ": "G",
        "Ģ": "G",
        "Ĝ": "G",
        "Ġ": "G",
        "Ɠ": "G",
        "Ḡ": "G",
        "Ǥ": "G",
        "Ḫ": "H",
        "Ȟ": "H",
        "Ḩ": "H",
        "Ĥ": "H",
        "Ⱨ": "H",
        "Ḧ": "H",
        "Ḣ": "H",
        "Ḥ": "H",
        "Ħ": "H",
        "Í": "I",
        "Ĭ": "I",
        "Ǐ": "I",
        "Î": "I",
        "Ï": "I",
        "Ḯ": "I",
        "İ": "I",
        "Ị": "I",
        "Ȉ": "I",
        "Ì": "I",
        "Ỉ": "I",
        "Ȋ": "I",
        "Ī": "I",
        "Į": "I",
        "Ɨ": "I",
        "Ĩ": "I",
        "Ḭ": "I",
        "Ꝺ": "D",
        "Ꝼ": "F",
        "Ᵹ": "G",
        "Ꞃ": "R",
        "Ꞅ": "S",
        "Ꞇ": "T",
        "Ꝭ": "IS",
        "Ĵ": "J",
        "Ɉ": "J",
        "Ḱ": "K",
        "Ǩ": "K",
        "Ķ": "K",
        "Ⱪ": "K",
        "Ꝃ": "K",
        "Ḳ": "K",
        "Ƙ": "K",
        "Ḵ": "K",
        "Ꝁ": "K",
        "Ꝅ": "K",
        "Ĺ": "L",
        "Ƚ": "L",
        "Ľ": "L",
        "Ļ": "L",
        "Ḽ": "L",
        "Ḷ": "L",
        "Ḹ": "L",
        "Ⱡ": "L",
        "Ꝉ": "L",
        "Ḻ": "L",
        "Ŀ": "L",
        "Ɫ": "L",
        "ǈ": "L",
        "Ł": "L",
        "Ǉ": "LJ",
        "Ḿ": "M",
        "Ṁ": "M",
        "Ṃ": "M",
        "Ɱ": "M",
        "Ń": "N",
        "Ň": "N",
        "Ņ": "N",
        "Ṋ": "N",
        "Ṅ": "N",
        "Ṇ": "N",
        "Ǹ": "N",
        "Ɲ": "N",
        "Ṉ": "N",
        "Ƞ": "N",
        "ǋ": "N",
        "Ñ": "N",
        "Ǌ": "NJ",
        "Ó": "O",
        "Ŏ": "O",
        "Ǒ": "O",
        "Ô": "O",
        "Ố": "O",
        "Ộ": "O",
        "Ồ": "O",
        "Ổ": "O",
        "Ỗ": "O",
        "Ö": "O",
        "Ȫ": "O",
        "Ȯ": "O",
        "Ȱ": "O",
        "Ọ": "O",
        "Ő": "O",
        "Ȍ": "O",
        "Ò": "O",
        "Ỏ": "O",
        "Ơ": "O",
        "Ớ": "O",
        "Ợ": "O",
        "Ờ": "O",
        "Ở": "O",
        "Ỡ": "O",
        "Ȏ": "O",
        "Ꝋ": "O",
        "Ꝍ": "O",
        "Ō": "O",
        "Ṓ": "O",
        "Ṑ": "O",
        "Ɵ": "O",
        "Ǫ": "O",
        "Ǭ": "O",
        "Ø": "O",
        "Ǿ": "O",
        "Õ": "O",
        "Ṍ": "O",
        "Ṏ": "O",
        "Ȭ": "O",
        "Ƣ": "OI",
        "Ꝏ": "OO",
        "Ɛ": "E",
        "Ɔ": "O",
        "Ȣ": "OU",
        "Ṕ": "P",
        "Ṗ": "P",
        "Ꝓ": "P",
        "Ƥ": "P",
        "Ꝕ": "P",
        "Ᵽ": "P",
        "Ꝑ": "P",
        "Ꝙ": "Q",
        "Ꝗ": "Q",
        "Ŕ": "R",
        "Ř": "R",
        "Ŗ": "R",
        "Ṙ": "R",
        "Ṛ": "R",
        "Ṝ": "R",
        "Ȑ": "R",
        "Ȓ": "R",
        "Ṟ": "R",
        "Ɍ": "R",
        "Ɽ": "R",
        "Ꜿ": "C",
        "Ǝ": "E",
        "Ś": "S",
        "Ṥ": "S",
        "Š": "S",
        "Ṧ": "S",
        "Ş": "S",
        "Ŝ": "S",
        "Ș": "S",
        "Ṡ": "S",
        "Ṣ": "S",
        "Ṩ": "S",
        "Ť": "T",
        "Ţ": "T",
        "Ṱ": "T",
        "Ț": "T",
        "Ⱦ": "T",
        "Ṫ": "T",
        "Ṭ": "T",
        "Ƭ": "T",
        "Ṯ": "T",
        "Ʈ": "T",
        "Ŧ": "T",
        "Ɐ": "A",
        "Ꞁ": "L",
        "Ɯ": "M",
        "Ʌ": "V",
        "Ꜩ": "TZ",
        "Ú": "U",
        "Ŭ": "U",
        "Ǔ": "U",
        "Û": "U",
        "Ṷ": "U",
        "Ü": "U",
        "Ǘ": "U",
        "Ǚ": "U",
        "Ǜ": "U",
        "Ǖ": "U",
        "Ṳ": "U",
        "Ụ": "U",
        "Ű": "U",
        "Ȕ": "U",
        "Ù": "U",
        "Ủ": "U",
        "Ư": "U",
        "Ứ": "U",
        "Ự": "U",
        "Ừ": "U",
        "Ử": "U",
        "Ữ": "U",
        "Ȗ": "U",
        "Ū": "U",
        "Ṻ": "U",
        "Ų": "U",
        "Ů": "U",
        "Ũ": "U",
        "Ṹ": "U",
        "Ṵ": "U",
        "Ꝟ": "V",
        "Ṿ": "V",
        "Ʋ": "V",
        "Ṽ": "V",
        "Ꝡ": "VY",
        "Ẃ": "W",
        "Ŵ": "W",
        "Ẅ": "W",
        "Ẇ": "W",
        "Ẉ": "W",
        "Ẁ": "W",
        "Ⱳ": "W",
        "Ẍ": "X",
        "Ẋ": "X",
        "Ý": "Y",
        "Ŷ": "Y",
        "Ÿ": "Y",
        "Ẏ": "Y",
        "Ỵ": "Y",
        "Ỳ": "Y",
        "Ƴ": "Y",
        "Ỷ": "Y",
        "Ỿ": "Y",
        "Ȳ": "Y",
        "Ɏ": "Y",
        "Ỹ": "Y",
        "Ź": "Z",
        "Ž": "Z",
        "Ẑ": "Z",
        "Ⱬ": "Z",
        "Ż": "Z",
        "Ẓ": "Z",
        "Ȥ": "Z",
        "Ẕ": "Z",
        "Ƶ": "Z",
        "Ĳ": "IJ",
        "Œ": "OE",
        "ᴀ": "A",
        "ᴁ": "AE",
        "ʙ": "B",
        "ᴃ": "B",
        "ᴄ": "C",
        "ᴅ": "D",
        "ᴇ": "E",
        "ꜰ": "F",
        "ɢ": "G",
        "ʛ": "G",
        "ʜ": "H",
        "ɪ": "I",
        "ʁ": "R",
        "ᴊ": "J",
        "ᴋ": "K",
        "ʟ": "L",
        "ᴌ": "L",
        "ᴍ": "M",
        "ɴ": "N",
        "ᴏ": "O",
        "ɶ": "OE",
        "ᴐ": "O",
        "ᴕ": "OU",
        "ᴘ": "P",
        "ʀ": "R",
        "ᴎ": "N",
        "ᴙ": "R",
        "ꜱ": "S",
        "ᴛ": "T",
        "ⱻ": "E",
        "ᴚ": "R",
        "ᴜ": "U",
        "ᴠ": "V",
        "ᴡ": "W",
        "ʏ": "Y",
        "ᴢ": "Z",
        "á": "a",
        "ă": "a",
        "ắ": "a",
        "ặ": "a",
        "ằ": "a",
        "ẳ": "a",
        "ẵ": "a",
        "ǎ": "a",
        "â": "a",
        "ấ": "a",
        "ậ": "a",
        "ầ": "a",
        "ẩ": "a",
        "ẫ": "a",
        "ä": "a",
        "ǟ": "a",
        "ȧ": "a",
        "ǡ": "a",
        "ạ": "a",
        "ȁ": "a",
        "à": "a",
        "ả": "a",
        "ȃ": "a",
        "ā": "a",
        "ą": "a",
        "ᶏ": "a",
        "ẚ": "a",
        "å": "a",
        "ǻ": "a",
        "ḁ": "a",
        "ⱥ": "a",
        "ã": "a",
        "ꜳ": "aa",
        "æ": "ae",
        "ǽ": "ae",
        "ǣ": "ae",
        "ꜵ": "ao",
        "ꜷ": "au",
        "ꜹ": "av",
        "ꜻ": "av",
        "ꜽ": "ay",
        "ḃ": "b",
        "ḅ": "b",
        "ɓ": "b",
        "ḇ": "b",
        "ᵬ": "b",
        "ᶀ": "b",
        "ƀ": "b",
        "ƃ": "b",
        "ɵ": "o",
        "ć": "c",
        "č": "c",
        "ç": "c",
        "ḉ": "c",
        "ĉ": "c",
        "ɕ": "c",
        "ċ": "c",
        "ƈ": "c",
        "ȼ": "c",
        "ď": "d",
        "ḑ": "d",
        "ḓ": "d",
        "ȡ": "d",
        "ḋ": "d",
        "ḍ": "d",
        "ɗ": "d",
        "ᶑ": "d",
        "ḏ": "d",
        "ᵭ": "d",
        "ᶁ": "d",
        "đ": "d",
        "ɖ": "d",
        "ƌ": "d",
        "ı": "i",
        "ȷ": "j",
        "ɟ": "j",
        "ʄ": "j",
        "ǳ": "dz",
        "ǆ": "dz",
        "é": "e",
        "ĕ": "e",
        "ě": "e",
        "ȩ": "e",
        "ḝ": "e",
        "ê": "e",
        "ế": "e",
        "ệ": "e",
        "ề": "e",
        "ể": "e",
        "ễ": "e",
        "ḙ": "e",
        "ë": "e",
        "ė": "e",
        "ẹ": "e",
        "ȅ": "e",
        "è": "e",
        "ẻ": "e",
        "ȇ": "e",
        "ē": "e",
        "ḗ": "e",
        "ḕ": "e",
        "ⱸ": "e",
        "ę": "e",
        "ᶒ": "e",
        "ɇ": "e",
        "ẽ": "e",
        "ḛ": "e",
        "ꝫ": "et",
        "ḟ": "f",
        "ƒ": "f",
        "ᵮ": "f",
        "ᶂ": "f",
        "ǵ": "g",
        "ğ": "g",
        "ǧ": "g",
        "ģ": "g",
        "ĝ": "g",
        "ġ": "g",
        "ɠ": "g",
        "ḡ": "g",
        "ᶃ": "g",
        "ǥ": "g",
        "ḫ": "h",
        "ȟ": "h",
        "ḩ": "h",
        "ĥ": "h",
        "ⱨ": "h",
        "ḧ": "h",
        "ḣ": "h",
        "ḥ": "h",
        "ɦ": "h",
        "ẖ": "h",
        "ħ": "h",
        "ƕ": "hv",
        "í": "i",
        "ĭ": "i",
        "ǐ": "i",
        "î": "i",
        "ï": "i",
        "ḯ": "i",
        "ị": "i",
        "ȉ": "i",
        "ì": "i",
        "ỉ": "i",
        "ȋ": "i",
        "ī": "i",
        "į": "i",
        "ᶖ": "i",
        "ɨ": "i",
        "ĩ": "i",
        "ḭ": "i",
        "ꝺ": "d",
        "ꝼ": "f",
        "ᵹ": "g",
        "ꞃ": "r",
        "ꞅ": "s",
        "ꞇ": "t",
        "ꝭ": "is",
        "ǰ": "j",
        "ĵ": "j",
        "ʝ": "j",
        "ɉ": "j",
        "ḱ": "k",
        "ǩ": "k",
        "ķ": "k",
        "ⱪ": "k",
        "ꝃ": "k",
        "ḳ": "k",
        "ƙ": "k",
        "ḵ": "k",
        "ᶄ": "k",
        "ꝁ": "k",
        "ꝅ": "k",
        "ĺ": "l",
        "ƚ": "l",
        "ɬ": "l",
        "ľ": "l",
        "ļ": "l",
        "ḽ": "l",
        "ȴ": "l",
        "ḷ": "l",
        "ḹ": "l",
        "ⱡ": "l",
        "ꝉ": "l",
        "ḻ": "l",
        "ŀ": "l",
        "ɫ": "l",
        "ᶅ": "l",
        "ɭ": "l",
        "ł": "l",
        "ǉ": "lj",
        "ſ": "s",
        "ẜ": "s",
        "ẛ": "s",
        "ẝ": "s",
        "ḿ": "m",
        "ṁ": "m",
        "ṃ": "m",
        "ɱ": "m",
        "ᵯ": "m",
        "ᶆ": "m",
        "ń": "n",
        "ň": "n",
        "ņ": "n",
        "ṋ": "n",
        "ȵ": "n",
        "ṅ": "n",
        "ṇ": "n",
        "ǹ": "n",
        "ɲ": "n",
        "ṉ": "n",
        "ƞ": "n",
        "ᵰ": "n",
        "ᶇ": "n",
        "ɳ": "n",
        "ñ": "n",
        "ǌ": "nj",
        "ó": "o",
        "ŏ": "o",
        "ǒ": "o",
        "ô": "o",
        "ố": "o",
        "ộ": "o",
        "ồ": "o",
        "ổ": "o",
        "ỗ": "o",
        "ö": "o",
        "ȫ": "o",
        "ȯ": "o",
        "ȱ": "o",
        "ọ": "o",
        "ő": "o",
        "ȍ": "o",
        "ò": "o",
        "ỏ": "o",
        "ơ": "o",
        "ớ": "o",
        "ợ": "o",
        "ờ": "o",
        "ở": "o",
        "ỡ": "o",
        "ȏ": "o",
        "ꝋ": "o",
        "ꝍ": "o",
        "ⱺ": "o",
        "ō": "o",
        "ṓ": "o",
        "ṑ": "o",
        "ǫ": "o",
        "ǭ": "o",
        "ø": "o",
        "ǿ": "o",
        "õ": "o",
        "ṍ": "o",
        "ṏ": "o",
        "ȭ": "o",
        "ƣ": "oi",
        "ꝏ": "oo",
        "ɛ": "e",
        "ᶓ": "e",
        "ɔ": "o",
        "ᶗ": "o",
        "ȣ": "ou",
        "ṕ": "p",
        "ṗ": "p",
        "ꝓ": "p",
        "ƥ": "p",
        "ᵱ": "p",
        "ᶈ": "p",
        "ꝕ": "p",
        "ᵽ": "p",
        "ꝑ": "p",
        "ꝙ": "q",
        "ʠ": "q",
        "ɋ": "q",
        "ꝗ": "q",
        "ŕ": "r",
        "ř": "r",
        "ŗ": "r",
        "ṙ": "r",
        "ṛ": "r",
        "ṝ": "r",
        "ȑ": "r",
        "ɾ": "r",
        "ᵳ": "r",
        "ȓ": "r",
        "ṟ": "r",
        "ɼ": "r",
        "ᵲ": "r",
        "ᶉ": "r",
        "ɍ": "r",
        "ɽ": "r",
        "ↄ": "c",
        "ꜿ": "c",
        "ɘ": "e",
        "ɿ": "r",
        "ś": "s",
        "ṥ": "s",
        "š": "s",
        "ṧ": "s",
        "ş": "s",
        "ŝ": "s",
        "ș": "s",
        "ṡ": "s",
        "ṣ": "s",
        "ṩ": "s",
        "ʂ": "s",
        "ᵴ": "s",
        "ᶊ": "s",
        "ȿ": "s",
        "ɡ": "g",
        "ᴑ": "o",
        "ᴓ": "o",
        "ᴝ": "u",
        "ť": "t",
        "ţ": "t",
        "ṱ": "t",
        "ț": "t",
        "ȶ": "t",
        "ẗ": "t",
        "ⱦ": "t",
        "ṫ": "t",
        "ṭ": "t",
        "ƭ": "t",
        "ṯ": "t",
        "ᵵ": "t",
        "ƫ": "t",
        "ʈ": "t",
        "ŧ": "t",
        "ᵺ": "th",
        "ɐ": "a",
        "ᴂ": "ae",
        "ǝ": "e",
        "ᵷ": "g",
        "ɥ": "h",
        "ʮ": "h",
        "ʯ": "h",
        "ᴉ": "i",
        "ʞ": "k",
        "ꞁ": "l",
        "ɯ": "m",
        "ɰ": "m",
        "ᴔ": "oe",
        "ɹ": "r",
        "ɻ": "r",
        "ɺ": "r",
        "ⱹ": "r",
        "ʇ": "t",
        "ʌ": "v",
        "ʍ": "w",
        "ʎ": "y",
        "ꜩ": "tz",
        "ú": "u",
        "ŭ": "u",
        "ǔ": "u",
        "û": "u",
        "ṷ": "u",
        "ü": "u",
        "ǘ": "u",
        "ǚ": "u",
        "ǜ": "u",
        "ǖ": "u",
        "ṳ": "u",
        "ụ": "u",
        "ű": "u",
        "ȕ": "u",
        "ù": "u",
        "ủ": "u",
        "ư": "u",
        "ứ": "u",
        "ự": "u",
        "ừ": "u",
        "ử": "u",
        "ữ": "u",
        "ȗ": "u",
        "ū": "u",
        "ṻ": "u",
        "ų": "u",
        "ᶙ": "u",
        "ů": "u",
        "ũ": "u",
        "ṹ": "u",
        "ṵ": "u",
        "ᵫ": "ue",
        "ꝸ": "um",
        "ⱴ": "v",
        "ꝟ": "v",
        "ṿ": "v",
        "ʋ": "v",
        "ᶌ": "v",
        "ⱱ": "v",
        "ṽ": "v",
        "ꝡ": "vy",
        "ẃ": "w",
        "ŵ": "w",
        "ẅ": "w",
        "ẇ": "w",
        "ẉ": "w",
        "ẁ": "w",
        "ⱳ": "w",
        "ẘ": "w",
        "ẍ": "x",
        "ẋ": "x",
        "ᶍ": "x",
        "ý": "y",
        "ŷ": "y",
        "ÿ": "y",
        "ẏ": "y",
        "ỵ": "y",
        "ỳ": "y",
        "ƴ": "y",
        "ỷ": "y",
        "ỿ": "y",
        "ȳ": "y",
        "ẙ": "y",
        "ɏ": "y",
        "ỹ": "y",
        "ź": "z",
        "ž": "z",
        "ẑ": "z",
        "ʑ": "z",
        "ⱬ": "z",
        "ż": "z",
        "ẓ": "z",
        "ȥ": "z",
        "ẕ": "z",
        "ᵶ": "z",
        "ᶎ": "z",
        "ʐ": "z",
        "ƶ": "z",
        "ɀ": "z",
        "ﬀ": "ff",
        "ﬃ": "ffi",
        "ﬄ": "ffl",
        "ﬁ": "fi",
        "ﬂ": "fl",
        "ĳ": "ij",
        "œ": "oe",
        "ﬆ": "st",
        "ₐ": "a",
        "ₑ": "e",
        "ᵢ": "i",
        "ⱼ": "j",
        "ₒ": "o",
        "ᵣ": "r",
        "ᵤ": "u",
        "ᵥ": "v",
        "ₓ": "x"
      };
      String.prototype.latinise = function () {
        return this.replace(/[^A-Za-z0-9\[\] ]/g, function (a) {
          return Latinise.latin_map[a] || a;
        });
      };

      String.prototype.latinize = String.prototype.latinise;
      String.prototype.isLatin = function () {
        return this === this.latinise();
      };
    }

    function validateEmailsLength(emailsList, input) {
      var emailsListLength = emailsList.join(',').length;
      return emailsListLength + input.length + 1 <= JOINED_EMAILS_MAX_LENGTH;
    }

    function validateEmailsQuantity(emailsList) {
      return emailsList.length < MAX_EMAILS_INPUT;
    }

    function formatContactEmail(contactEmail) {
      var validEmails = [];
      var result = '';
      if (contactEmail) {
        contactEmail.split(',').forEach(function (email) {
          if (validateEmailsQuantity(validEmails)) {
            var cleaned = email.trim().replace(" ", "").latinize();
            if (validateEmail(cleaned) && validateEmailsLength(validEmails, cleaned)) {
              validEmails.push(cleaned);
            }
          }
        });
        result = validEmails.join(',');
      }
      return result;
    }

    function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    function secureParseToFloat(num, defaultValue) {
      var newNum;
      try {
        newNum = num ? parseFloat(parseFloat(num).toFixed(2)) : defaultValue;
        newNum = _isNaNorEmpty(num) ? 0 : newNum;
      } catch (e) {
        newNum = defaultValue;
      }
      return newNum;
    }

    function selectedOptimizationOption(option, event) {
      var isOnFootAlreadyUsed = (option === STEP_TWO_OPTIMIZATION_OPTIONS.ON_FOOT) && vm.isOnFootRoutingDisabled;
      var isWaveRoutingAlreadyUsed = (option === STEP_TWO_OPTIMIZATION_OPTIONS.WAVE_ROUTING)
        && vm.waveRouting;
      if (isOnFootAlreadyUsed || isWaveRoutingAlreadyUsed) {
        return;
      }

      event.stopPropagation();

      var optionTrueValue = vm.getOptimizationOptionTrueValue(option);
      vm.optimizationOptions[option] = (vm.optimizationOptions[option] === optionTrueValue) ?
        vm.getOptimizationOptionFalseValue(option) : optionTrueValue;
      if (option === STEP_TWO_OPTIMIZATION_OPTIONS.DISTANCE_TO_JOIN_VISITS) {
        return;
      }

      vm.checkOptionOptimize(option);
    }

    function canVisitBeEditedOrRemoved(visit) {
      return plannerService.isRouteEditable(visit.routeId);
    }

    function mustShowVisitWindows(windowStart, windowEnd) {
      return vm.show_visit_windows && plannerService.mustShowVisitWindows(
        windowStart, windowEnd
      );
    }

    function displayWindowsFormat(windowStart, windowEnd) {
      if (!windowStart || !windowEnd) {
        return;
      }
      return windowStart + ' ' + _$translate('Planner.infowindow_to') + ' ' + windowEnd;
    }

    function displayWindows(visit) {
      var isValidWindows = mustShowVisitWindows(visit.windowStart, visit.windowEnd);
      var isValidWindows2 = mustShowVisitWindows(visit.windowStart2, visit.windowEnd2);
      if (isValidWindows && isValidWindows2) {
        return (
          displayWindowsFormat(visit.windowStart, visit.windowEnd) + ' | ' +
          displayWindowsFormat(visit.windowStart2, visit.windowEnd2)
        );
      }
      return isValidWindows ? displayWindowsFormat(visit.windowStart, visit.windowEnd) :
        displayWindowsFormat(visit.windowStart2, visit.windowEnd2);
    }

    function selectRadialOption(value, event) {
      vm.radialRoutingOption = value;
      event.stopPropagation();
    }

    function selectSequencerRoutingOption(value, event) {
      vm.sequencerRoutingOption = value;
      if (value < SEQUENCER_ROUTING_OPTIONS.PRIORITIZE_LOAD) {
        vm.radialRoutingOption = value;
        vm.prioritizeLoadOption = false;
      } else if (value === SEQUENCER_ROUTING_OPTIONS.PRIORITIZE_LOAD) {
        vm.radialRoutingOption = 0;
        vm.prioritizeLoadOption = true;
      }
      event.stopPropagation();
    }

    function updateSortingOptions() {
      var selectedSortingOption = vm.typeOfSort === 'sort_desc' ? '-'+vm.propertyToSort : vm.propertyToSort;
      vm.currentSortOptions = ['-status', selectedSortingOption];
      vm.titleForOrderButton = vm.propertyToSort;
      refreshVisits();
    }

    function removeSortingOptions() {
      vm.currentSortOptions = DEFAULT_SORTING_OPTIONS;
      vm.typeOfSort = vm.DEFAULT_TYPE_OF_SORT;
      vm.propertyToSort = vm.DEFAULT_PROPERTY_TO_SORT;
      vm.titleForOrderButton = vm.DEFAULT_TITLE_FOR_ORDER_BUTTON;
      refreshVisits();
    }

    function updateTotalOfSelectedAndRenderedVisits() {
      var renderedVisits = _getAllVisitsToRender();
      var renderedVisitsForRouting = _getAllVisitsForRoutingToRender();
      var allVisitsInBothLists = renderedVisits.concat(renderedVisitsForRouting);

      var selectedVisits = vm.selectedVisits.length;
      if (vm.filterHandler.activeFilter) {
        selectedVisits = 0;
        allVisitsInBothLists.forEach(function (visit) {
          if (visit.checked) {
            selectedVisits += 1;
          }
        });
      }
      vm.totalRenderedVisits = allVisitsInBothLists.length;
      vm.totalSelectedVisits = selectedVisits;

      if (vm.positiveSelectionVisitsEnabled) {
        if (renderedVisits.length > 0) {
          vm.allPendingVisitsChecked = renderedVisits.every(function(v) {
            return v.checked || !vm.canVisitBeEditedOrRemoved(v);
          });
        } else {
          vm.allPendingVisitsChecked = false;
        }

        if (renderedVisitsForRouting.length > 0) {
          vm.allVisitsForRoutingChecked = renderedVisitsForRouting.every(function(v) {
            return v.checked || !vm.canVisitBeEditedOrRemoved(v);
          });
        } else {
          vm.allVisitsForRoutingChecked = false;
        }

        vm.allVisitsChecked = vm.allPendingVisitsChecked && vm.allVisitsForRoutingChecked &&
                              (renderedVisits.length > 0 || renderedVisitsForRouting.length > 0);
      } else {
        vm.allVisitsChecked = vm.totalSelectedVisits === vm.totalRenderedVisits && vm.totalRenderedVisits > 0;
      }
    }

    function getTextOfSelectedVisits() {
      var selectedText = vm.totalSelectedVisits > 1 ? _$translate("Visits.selected_plural") : _$translate("Visits.selected_singular");
      return selectedText + ' ' + vm.totalSelectedVisits + ' / ' + vm.totalRenderedVisits;
    }

    function updateSelectedVisits(visit) {
      var indexVisit = vm.selectedVisits.indexOf(visit);
      if (visit.checked) {
        if (indexVisit === -1) {
          vm.selectedVisits.push(visit);
        }
      } else {
        if (indexVisit !== -1) {
          vm.selectedVisits.splice(indexVisit, 1);
        }
      }
    }

    function getAlertStatsIconURL(visit) {
      return VISIT_ADDRESS_STATUS_ICON_URL[visit.addressStatistics.status];

    }

    function changeLocation(visit) {
      var tempLat = visit.latitude;
      var tempLong = visit.longitude;
      var stats = visit.addressStatistics;

      visit.latitude = stats.last_latitude;
      visit.longitude = stats.last_longitude;

      stats.last_latitude = tempLat;
      stats.last_longitude = tempLong;
      stats.was_location_changed = !stats.was_location_changed;
    }

    function setSequencerRoutingOption() {
      if (vm.radialRoutingOption !== SEQUENCER_ROUTING_OPTIONS.DEFAULT) {
        vm.sequencerRoutingOption = vm.radialRoutingOption;
      } else if (vm.prioritizeLoadOption) {
        vm.sequencerRoutingOption = SEQUENCER_ROUTING_OPTIONS.PRIORITIZE_LOAD;
      }
    }

    function setRoutingSequencers() {
      if (!vm.isPrioritizeLoadOptionEnabled && !vm.enableRadialRouting) {
        return;
      }
        vm.routingSequencers.push({
          option: 'radial_default',
          value: 0
        });

      if (vm.enableRadialRouting) {
        vm.routingSequencers.push(
          {
            option: 'radial_to_near',
            value: -1
          },
          {
            option: 'radial_to_far',
            value: 1
          }
        );
      }

      if (vm.isPrioritizeLoadOptionEnabled) {
        vm.routingSequencers.push({
          option: 'prioritize_load',
          value: 2
        });
      }

      setSequencerRoutingOption();
    }

    function showNextStepCheckbox() {
      if (!vm.visitForRoutingCardsCurrentPage || vm.visitForRoutingCardsCurrentPage.length === 0) {
        return vm.warningVisitsQty > 0;
      }

      if (vm.warningVisitsQty === 0) {
        return false;
      }

      if (isThereVisitForRoutingWithWarningCache !== null) {
        return isThereVisitForRoutingWithWarningCache;
      }

      var isAnyVisitForRoutingWithWarning = plannerService.visits.some(function (visit) {
        return (
          visit.error &&
          (visit.error.type === 2 || visit.error.type === 3) &&
          plannerService.visitsForRouting.includes(visit.id)
        );
      });

      isThereVisitForRoutingWithWarningCache = isAnyVisitForRoutingWithWarning;
      return isAnyVisitForRoutingWithWarning;
    }

    function isGoNextDisabled() {
      if (!vm.visitForRoutingCardsCurrentPage || vm.visitForRoutingCardsCurrentPage.length === 0) {
        return vm.visitCardsCurrentPage.length === 0 || vm.errorVisitsQty > 0 || (vm.warningVisitsQty > 0 && !vm.nextStep);
      }

      if (vm.errorVisitsQty === 0 && (vm.warningVisitsQty === 0 || vm.nextStep)) {
        return false;
      }

      if (isThereVisitForRoutingWithErrorCache) {
        return true;
      }

      if (isThereVisitForRoutingWithErrorCache === null) {
        var isAnyVisitForRoutingWithError = plannerService.visits.some(function (visit) {
          return (
            visit.error &&
            visit.error.type === 4 &&
            plannerService.visitsForRouting.includes(visit.id)
          );
        });

        isThereVisitForRoutingWithErrorCache = isAnyVisitForRoutingWithError;

        if (isAnyVisitForRoutingWithError) {
          return true;
        }
      }

      if (isThereVisitForRoutingWithWarningCache !== null) {
        return isThereVisitForRoutingWithWarningCache;
      }

      var isAnyVisitForRoutingWithWarning = plannerService.visits.some(function (visit) {
        return (
          visit.error &&
          (visit.error.type === 2 || visit.error.type === 3) &&
          plannerService.visitsForRouting.includes(visit.id)
        );
      });

      isThereVisitForRoutingWithWarningCache = isAnyVisitForRoutingWithWarning;
      return isAnyVisitForRoutingWithWarning;
    }
  }
})();

/* global google:false */
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .controller('PlannerVisitsDetailController', PlannerVisitsDetailController);

  /** @ngInject */
  function PlannerVisitsDetailController($log, $q, $scope, $state, $stateParams, plannerService, alertNotificationService,
                                         googleService, lodash, zoneService, MAX_EMAILS_INPUT,
                                         statisticsService, __env, validationService, accountConfigsService, ACCOUNT_CONFIGS,
                                         $rootScope, utilsService, VISIT_TABS, visitsUtils, visitTypeService, tagService,
                                         addressStatsService, addonsService, moment, addonsUtilsService,
                                         PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES) {
    var vm = this;

    var DEFAULT_COORDINATE_VALUE = "0.0";

    var originalVisit = null;
    var geocoderService;
    var previousFilterStatus = 1;
    var currentPage = 1;
    var saveButtonPressed = false;

    vm.emailInputError = {
      invalidFormat: false,
      maxQuantity: false,
      maxLength: false
    };

    vm.invalidDate = false;
    vm.invalidDate2 = false;
    vm.emptyDate = false;
    vm.emptyDate2 = false;
    vm.timeBetweenDate = false;
    vm.timeBetweenDate2 = false;
    vm.validForm = { time: true, coords: true };
    vm.maxEmails = MAX_EMAILS_INPUT;

    vm.form = {};
    vm.emails = [];
    vm.visit = { skills_optional: [], skills_required: [], items: [], seller_id: null };
    vm.saving = false;
    vm.serviceTimeError = false;
    vm.moreOptions = true;
    vm.requiredSkills = [];
    vm.optionalSkills = [];
    vm.priorityLevels = [];

    vm.isVisitBeingEdited = $stateParams.visitId;
    vm.enableHidingVisitNotes = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_HIDING_VISIT_NOTES);
    vm.enableManageVisitItems = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_MANAGE_VISIT_ITEMS);

    vm.isSellerManagementEnabled = false;

    vm.save = save;
    vm.cancel = cancel;
    vm.coordsChanged = coordsChanged;
    vm.skillsHandler = visitsUtils.skillsHandler;
    vm.isSkillSelected = visitsUtils.isSkillSelected;
    vm.validateTime = validateTime;
    vm.validateTimeService = validateTimeService;
    vm.validateWindowTimes = validateWindowTimes;
    vm.validateEmailInput = validateEmailInput;
    vm.setZones = setZones;
    vm.updateVisitLocation = updateVisitLocation;
    vm.selectedTab = VISIT_TABS.DETAILS;
    vm.VISIT_TABS = VISIT_TABS;
    vm.deleteVisitItems = deleteVisitItems;
    vm.addVisitItem = addVisitItem;
    vm.invalidateItemForm = invalidateItemForm;
    vm.isItemFormInvalid = false;
    vm.isInvalidForm = isInvalidForm;
    vm.cancelButtonPressed = false;
    vm.visitTypes = [];
    vm.tags = [];
    vm.tagSelectedHandler = visitsUtils.tagSelectedHandler;
    vm.isTagSelected = visitsUtils.isTagSelected;
    vm.sellers = [];
    vm.skipTimeValidation = false;
    vm.isMixLoadAddonEnabled = false;

    // Add listener for uncheck action
    var unCheckVisitEvent = $scope.$on('visits:uncheckVisit', function() {
      vm.visit.checked = false;
      if (originalVisit) {
        originalVisit.options.visible = true;
        originalVisit.checked = false;
      }
      plannerService.setShouldClearVisitSelectionsOnReturn(true);
    });

    activate();

    ////////////

    function activate() {
      plannerService.hideVehicles();
      plannerService.hideVisits();
      plannerService.hideRoutes();
      plannerService.hideInfoWindow();
      plannerService.deactivateVisits();
      previousFilterStatus = $stateParams.fstatus || 1;
      currentPage = $stateParams.page || 1;
      vm.priorityLevels = plannerService.getPriorityLevels();
      // TODO Remove when autocomplete directive is ready
      try {
        geocoderService = googleService.createGeocode();
      } catch (error) {
        $log.error(error);
      }

      $rootScope.isLoading = true;

      return $q.all([plannerService.getPlan(), tagService.getTags(), visitTypeService.getVisitTypes(), addonsUtilsService.isSkipTimeValidationEnabled(), isMixLoadAddonEnabled()])
        .then(function ( results ) {
          vm.tags = results[1];
          vm.visitTypes = results[2];
          vm.skipTimeValidation = results[3];
          vm.isMixLoadAddonEnabled = results[4];

          if ($stateParams.visitId) {
            activateForEditing();
          } else {
            activateForCreating();
          }
          vm.requiredSkills = makeCopy(plannerService.getSkills());
          vm.optionalSkills = makeCopy(plannerService.getSkills());
          vm.sellers = plannerService.getSellers();
          vm.requiredSkills.forEach(function (skill) {
            skill.visible = true;
          });

          vm.optionalSkills.forEach(function (skill) {
            skill.visible = true;
          });
          isSellerVisitEnabled();

        })
        .catch(function (fail) {
          $log.info(fail);
        })
        .finally(function () {
          $rootScope.isLoading = false;
        });
    }

    function makeCopy(list) {
      return list.map(function (element) {
        return Object.assign({}, element);
      });
    }

    function isMixLoadAddonEnabled() {
      return addonsService.isAddonPropertyEnabled(PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD, function (addonProperty) {
        return addonProperty.value.toLowerCase() === "true";
      }).then(function (isAddonPropertyEnabled) {
        return isAddonPropertyEnabled;
      });
    }

    function onDestroyHandler() {
      unCheckVisitEvent();
      eventResetValidFormCoords();
      if (!originalVisit) {
        if (!vm.visit.backendId && (!vm.visit.title || !vm.visit.address) && !vm.cancelButtonPressed) {
          plannerService.removeVisit(vm.visit);
        }
      }
      else if (!saveButtonPressed && !vm.cancelButtonPressed) {
        lodash.merge(vm.visit, originalVisit);
        vm.visit.items = originalVisit.items;
      }
    }

    var eventResetValidFormCoords = $scope.$on("Planner:Visits:resetValidFormCoords", function () {
      vm.validForm.coords = true;
    });

    $scope.$on('$destroy', onDestroyHandler);

    function save() {
      $rootScope.$broadcast('visits:hideAlertBarSelectedVisits');
      $rootScope.$broadcast('visits:uncheckVisit');
      plannerService.setShouldClearVisitSelectionsOnReturn(true);
      if (vm.form.$invalid || !vm.validForm.time || !vm.validForm.coords) {
        return;
      }
      vm.visit.contactEmail = visitsUtils.joinEmails(vm.emails);
      setZones().then(function () {
        vm.serviceTimeError = false;
        vm.visit.load = isNaN(vm.visit.load) || !vm.visit.load ? 0 : parseFloat(parseFloat(vm.visit.load).toFixed(2));
        vm.saving = true;
        $rootScope.isLoading = true;
        vm.visit.request_status = vm.visit.backendId === null ? 'created' : 'edited';
        if (originalVisit) {
          vm.visit.request_status = vm.visit.request_status === 'created' ? vm.visit.request_status : 'edited';
          if (originalVisit.address.toLowerCase().replace(/\s/g, '') !== vm.visit.address.toLowerCase().replace(/\s/g, '')) {
            vm.visit.removeError();
          }
        }
        saveButtonPressed = true;
        statisticsService.increaseTotalLoads(_calculateLoads());
        return addressStatsService.fetchAndProcessAddressStats([vm.visit]);
      })
      .then(function () {
        vm.visit.setEditMode(false);
        vm.saving = false;
        $rootScope.isLoading = false;
        $state.go('^.visits-list', { recent: vm.visit.id, fstatus: previousFilterStatus, page: currentPage });
      })
      .catch(function (error) {
        $log.error(error);
        $rootScope.isLoading = false;
      });
    }

    function setZones() {
      var deferred = $q.defer();
      vm.visit.zones = [];
      var zonesFilter = {
        schedules: plannerService.getScheduledPlanDaysOfWeek(),
        enabled: true
      };
      zoneService.getZonesIfProceed(zonesFilter)
        .then(function success(zones) {
          var polygons = zoneService.buildPolygonsFromZones(zones);
          vm.visit.zones = zoneService.getZonesIntoVisit(polygons, vm.visit.latitude, vm.visit.longitude);
          deferred.resolve();
        });
      return deferred.promise;
    }

    function cancel() {
      vm.cancelButtonPressed = true;
      if (!originalVisit) {
        plannerService.removeVisit(vm.visit);
        $state.go('^.visits-list', {fstatus: previousFilterStatus, page: currentPage });
      } else {
        lodash.merge(vm.visit, originalVisit);
        vm.visit.items = originalVisit.items;
        $state.go('^.visits-list', {recent: vm.visit.id, fstatus: previousFilterStatus, page: currentPage });
      }
    }

    function coordsChanged(visit) {
      if (!visit.latitude) {
        visit.latitude = DEFAULT_COORDINATE_VALUE;
      }

      if (!visit.longitude) {
        visit.longitude = DEFAULT_COORDINATE_VALUE;
      }

      if (!validationService.validateLatitude(visit.latitude)) {
        vm.validForm.coords = false;
        return;
      }

      if (!validationService.validateLongitude(visit.longitude)) {
        vm.validForm.coords = false;
        return;
      }

      vm.validForm.coords = true;
      var latlng = {
        lat: parseFloat(visit.latitude),
        lng: parseFloat(visit.longitude)
      };

      geocoderService.geocode({ location: latlng }, function (results, status) {
        visit.setPosition(visit.latitude, visit.longitude);
        if (status === googleService.geocoderStatusOK()) {
          visit.address = results[0].formatted_address;
        }

        plannerService.setMapCenterOn(visit);
        $scope.$apply();
        plannerService.setMapCenterOn(visit);
      });
    }

    function updateVisitLocation(location, address) {
      vm.validForm.coords = true;
      vm.visit.setPosition(location.latitude, location.longitude);
      vm.visit.address = address;
      plannerService.setMapCenterOn(vm.visit);
    }

    function validateTime() {
      var validationTimeWindow1, validationTimeWindow2;

      if (vm.skipTimeValidation && $scope.isMultiDayRouteEnabled) {
        validationTimeWindow1 = visitsUtils.checkTimeWindowWithOvernightSupport(1, vm.visit);
        validationTimeWindow2 = visitsUtils.checkTimeWindowWithOvernightSupport(2, vm.visit);
      } else {
        validationTimeWindow1 = visitsUtils.checkTimeWindow(1, vm.visit);
        validationTimeWindow2 = visitsUtils.checkTimeWindow(2, vm.visit);
      }

      vm.validForm.time = false;
      vm.emptyDate = validationTimeWindow1.emptyDate;
      vm.emptyDate2 = validationTimeWindow2.emptyDate2;
      vm.invalidDate = validationTimeWindow1.invalidDate;
      vm.invalidDate2 = validationTimeWindow2.invalidDate2;
      vm.timeBetweenDate = validationTimeWindow1.timeBetweenDate;
      vm.timeBetweenDate2 = validationTimeWindow2.timeBetweenDate2;

      if (!vm.emptyDate && !vm.emptyDate2 && !vm.invalidDate && !vm.invalidDate2 &&
        !vm.timeBetweenDate && !vm.timeBetweenDate2) {
        vm.validForm.time = true;
      }
    }

    function validateTimeService() {
      vm.serviceTimeError = isNaN(vm.visit.duration);
      if (!vm.serviceTimeError) {
        vm.serviceTimeError = checkTimeServiceInvalidRange();
      }
    }

    function checkTimeServiceInvalidRange() {
      return vm.visit.duration < 0 || vm.visit.duration > __env.MAX_TIME_SERVICE_VALUE;
    }

    function activateForCreating() {
      try {
        var mapCenter = plannerService.getGmap().getCenter();
        vm.visit = plannerService.createVisit(mapCenter.lat(), mapCenter.lng());
        vm.visit.plannedDate = plannerService.planDate.start;
        vm.visit.actionCreate(vm.visit);
        vm.visit.setEditMode(true);
        vm.visit.setAddedInCurrentRouting(true);
      } catch (error) {
        $log.error(error);
      }
    }

    function activateForEditing() {
      var visit = plannerService.getVisit($stateParams.visitId);

      originalVisit = angular.copy(visit);
      if (visit.error) {
        alertNotificationService.addAlertNotification(visit.error);
      }
      vm.visit = visit;
      if (vm.visit.contactEmail) {
        visit.contactEmail.split(',').map(function (email) {
          vm.emails.push({ text: email });
        });
      }

      vm.visit.setEditMode(true);

      if (vm.visit.windowOneError) {
        vm.timeBetweenDate = true;
      }
      if (vm.visit.windowTwoError) {
        vm.timeBetweenDate2 = true;
      }
      if ((vm.visit.load2 || vm.visit.load3) || (vm.visit.windowStart2 || vm.visit.windowEnd2) ||
        vm.visit.load || (vm.visit.windowStart || vm.visit.windowEnd) || (vm.visit.duration !== 10) ||
        vm.visit.reference || vm.visit.priorityLevel || vm.visit.contactName || vm.visit.contactPhone ||
        vm.visit.notes || vm.visit.skills_required.length > 0 || vm.visit.skills_optional.length > 0) {
        vm.moreOptions = false;
      }

      plannerService.centerVisit(vm.visit, false);
    }

    function validateWindowTimes() {
      if (vm.skipTimeValidation && vm.isMultiDayRouteEnabled) {
        if (
          vm.invalidDate ||
          vm.invalidDate2 ||
          vm.emptyDate ||
          vm.emptyDate2
        ) {
          return;
        }
      } else {
        if (
          vm.invalidDate ||
          vm.invalidDate2 ||
          vm.emptyDate ||
          vm.emptyDate2 ||
          vm.timeBetweenDate ||
          vm.timeBetweenDate2
        ) {
          return;
        }
      }

      var areValid;

      if (vm.skipTimeValidation && $scope.isMultiDayRouteEnabled) {
        areValid = vm.visit.areValidVisitWindowTimesWithOvernightSupport();
      } else {
        areValid = vm.visit.areValidVisitWindowTimes();
      }

      if (areValid) {
        vm.visit.status = 1;
        vm.visit.error = null;
        vm.validForm.time = true;
        alertNotificationService.removeAlertNotification();

        if (vm.skipTimeValidation && $scope.isMultiDayRouteEnabled) {
          if (
            vm.timeBetweenDate &&
            _isValidOvernightWindow(vm.visit.windowStart, vm.visit.windowEnd)
          ) {
            vm.timeBetweenDate = false;
          }
          if (
            vm.timeBetweenDate2 &&
            _isValidOvernightWindow(vm.visit.windowStart2, vm.visit.windowEnd2)
          ) {
            vm.timeBetweenDate2 = false;
          }
        }
      } else {
        vm.validForm.time = false;
        alertNotificationService.addAlertNotification(vm.visit.error);
      }

      vm.visit.procureVisitStatus();
      vm.visit.actionUpdate(vm.visit);
    }

    function validateEmailInput(tag) {
      var isEmailFormatValid = visitsUtils.validateEmailFormat(tag);
      vm.emailInputError.invalidFormat = !isEmailFormatValid;
      var isLengthFormatValid = visitsUtils.validateEmailsLength(tag, vm.emails);
      vm.emailInputError.maxLength = !isLengthFormatValid;
      var isEmailsQuantityValid = visitsUtils.validateEmailsQuantity(vm.emails);
      vm.emailInputError.maxQuantity = !isEmailsQuantityValid;

      var validEmailInput = isEmailFormatValid && isLengthFormatValid && isEmailsQuantityValid;
      vm.form.$invalid = !validEmailInput;
      return validEmailInput;
    }

    function _calculateLoads() {
      return {
        load: originalVisit ? Number(vm.visit.load) - Number(originalVisit.load) : vm.visit.load,
        load2: originalVisit ? Number(vm.visit.load2) - Number(originalVisit.load2) : vm.visit.load2,
        load3: originalVisit ? Number(vm.visit.load3) - Number(originalVisit.load3) : vm.visit.load3,
        load4: originalVisit ? Number(vm.visit.load4) - Number(originalVisit.load4) : vm.visit.load4
      };
    }

    function deleteVisitItems() {
      vm.visit.items = vm.visit.items.filter(function (item) {
        return !item.selected;
      });

      if (!vm.visit.items.length) {
        vm.invalidateItemForm(false);
      }
    }

    function addVisitItem() {
      var newItem = {
        id: utilsService.guid(),
        title: '',
        quantity_planned: null
      };
      vm.visit.items.push(newItem);
      vm.invalidateItemForm(true);
    }

    function invalidateItemForm(itemFormValidationStatus) {
      vm.isItemFormInvalid = itemFormValidationStatus;
    }

    function isInvalidForm() {
      return vm.form.$invalid || !vm.validForm.time || !vm.validForm.coords || vm.saving || vm.isItemFormInvalid || vm.serviceTimeError;
    }

    function isSellerVisitEnabled() {
      addonsService.isAddonEnable('seller_management')
        .then(function (isEnabled) {
          vm.isSellerManagementEnabled = isEnabled;
        })
        .catch(function (error) {
          $log.error('Error checking if seller management is enabled: ', error);
        });
    }

    /**
     * Helper function to determine if a time window represents a valid overnight window
     */
    function _isValidOvernightWindow(startTime, endTime) {
      if (!startTime || !endTime) return false;
      var start = moment(startTime, "HH:mm");
      var end = moment(endTime, "HH:mm");
      return start.isAfter(end) && !start.isSame(end);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .controller('PlannerVisitsBulkEditController', PlannerVisitsBulkEditController);

  /** @ngInject */
  function PlannerVisitsBulkEditController($scope, $q, $rootScope, $state, $stateParams,
                                           plannerService, PlannerVisitModel, zoneService, accountConfigsService,
                                           validationService, $log, googleService, visitsUtils, ngDialog, $sce,
                                           MAX_EMAILS_INPUT, ACCOUNT_CONFIGS, visitTypeService, tagService, addonsService,
                                           addonsUtilsService, moment, alertNotificationService,
                                          PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES) {
    var vm = this;
    var DEFAULT_COORDINATE_VALUE = "0.0";
    var EXCLUDED_PRIORITIES = [1, 2];
    var MAX_VISITS_FOR_SUMMARY = 8;
    var visitsId = $stateParams.visitsId;
    var geocoderService;

    vm.MAX_VISITS_TO_SHOW = 3;
    vm.form = {};
    vm.visits = [];
    vm.visit = {
      title: null,
      address: null,
      latitude: null,
      longitude: null,
      contactName: null,
      contactPhone: null,
      contactEmail: null,
      duration: null,
      notes: null,
      reference: null,
      load: null,
      load2: null,
      load3: null,
      load4: null,
      visitTypes: null,
      tags: null,
      priority: null,
      windowStart: null,
      windowEnd: null,
      windowStart2: null,
      windowEnd2: null,
      skills_required: null,
      skills_optional: null,
      error: null,
      status: null,
      seller: null
    };
    vm.dummyVisit = {};
    vm.visitsQty = 0;
    vm.requiredSkills = [];
    vm.optionalSkills = [];
    vm.priorityLevels = [];
    vm.emails = [];
    vm.maxEmails = MAX_EMAILS_INPUT;
    vm.validForm = { time: true, coords: true };
    vm.invalidDate = false;
    vm.invalidDate2 = false;
    vm.emptyDate = false;
    vm.emptyDate2 = false;
    vm.timeBetweenDate = false;
    vm.timeBetweenDate2 = false;
    vm.serviceTimeError = false;
    vm.emailInputError = {
      invalidFormat: false,
      maxQuantity: false,
      maxLength: false
    };
    vm.summaryVisits = '';

    vm.save = save;
    vm.cancel = cancel;
    vm.updateVisitLocation = updateVisitLocation;
    vm.skillsHandler = skillsHandler;
    vm.isSkillSelected = visitsUtils.isSkillSelected;
    vm.coordsChanged = coordsChanged;
    vm.validateTime = validateTime;
    vm.validateWindowTimes = validateWindowTimes;
    vm.validateTimeService = validateTimeService;
    vm.validateEmailInput = validateEmailInput;
    vm.isVisitBeingEdited = $stateParams.visitId;
    vm.enableHidingVisitNotes = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_HIDING_VISIT_NOTES);
    vm.enableManageVisitItems = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_MANAGE_VISIT_ITEMS);
    vm.isInvalidForm = isInvalidForm;
    vm.showSaveModal = showSaveModal;

    vm.visitTypes = [];
    vm.tags = [];
    vm.tagsHandler = tagsHandler;
    vm.isTagSelected = visitsUtils.isTagSelected;
    vm.sellers = [];
    vm.isSellerManagementEnabled = false;
    vm.skipTimeValidation = false;
    vm.isMixLoadAddonEnabled = false;

    var unCheckVisitEvent = $scope.$on('visits:uncheckVisit', function() {
      // Handle multiple visits
      visitsId.forEach(function(id) {
        var visit = plannerService.getVisit(id);
        if (visit) {
          visit.checked = false;
          visit.options.visible = true;
        }
      });
      plannerService.setShouldClearVisitSelectionsOnReturn(true);
    });

    activate();

    $scope.$on('$destroy', onDeactivateListener);

    function _setCoordinates(latitude, longitude) {
      vm.visit.latitude = latitude;
      vm.visit.longitude = longitude;
    }

    function makeCopy(list) {
      return list.map(function (element) {
        return Object.assign({}, element);
      });
    }

    function activate() {
      vm.visitsQty = visitsId.length;
      plannerService.clearMapVisits();
      vm.requiredSkills = makeCopy(plannerService.getSkills());
      vm.optionalSkills = makeCopy(plannerService.getSkills());
      vm.sellers = plannerService.getSellers();

      vm.requiredSkills.forEach(function (skill) {
        skill.visible = true;
      });
      vm.optionalSkills.forEach(function (skill) {
        skill.visible = true;
      });

      vm.priorityLevels = plannerService.getPriorityLevels().filter(function (priority) {
        return !(EXCLUDED_PRIORITIES.includes(priority.value));
      });

      try {
        geocoderService = googleService.createGeocode();
      } catch (error) {
        $log.error(error);
      }

      vm.visits = plannerService.visits.filter(function (visit) {
        return visitsId.indexOf(visit.id) !== -1;
      });

      vm.summaryVisits =  $sce.trustAsHtml(getSummaryVisits());

      isSellerVisitEnabled();

      $rootScope.isLoading = true;

      return $q.all([tagService.getTags(), visitTypeService.getVisitTypes(), addonsUtilsService.isSkipTimeValidationEnabled(), isMixLoadAddonEnabled()])
        .then(function ( results ) {
          vm.tags = results[0];
          vm.visitTypes = results[1];
          vm.skipTimeValidation = results[2];
          vm.isMixLoadAddonEnabled = results[3];
        })
        .catch(function (fail) {
          $log.info(fail);
        })
        .finally(function () {
          $rootScope.isLoading = false;
        });
    }

    function onDeactivateListener() {
      unCheckVisitEvent();
      $rootScope.$broadcast("Planner:RemoveVisitsFromArray:Visit", {
        visits: [vm.dummyVisit]
      });
      plannerService.mapFitBoundAllVisits();

    }

    function _createDummyVisit(latitude,longitude, address) {
      vm.dummyVisit = new PlannerVisitModel();
      vm.dummyVisit.id = 'dummy';
      vm.dummyVisit.address = address;
      vm.dummyVisit.latitude = latitude;
      vm.dummyVisit.longitude = longitude;
      $rootScope.$broadcast("Planner:Visit:Create", {
        visit: vm.dummyVisit
      });
    }

    function updateVisitLocation(location, address) {
      vm.validForm.coords = true;
      _createDummyVisit(location.latitude, location.longitude, address);
      _setCoordinates(location.latitude, location.longitude);
      plannerService.centerVisit(vm.dummyVisit);
    }

    function _checkIfAddressHasChanged() {
      if (vm.visit.address) {
        vm.visit.status = 1;
        vm.visit.error = null;
      }
    }

    function _checkIfEmailHasBeenChanged() {
      if (vm.emails.length) {
        vm.visit.contactEmail = visitsUtils.joinEmails(vm.emails);
      }
    }

    function deletePropertiesNotUpdated() {
      Object.keys(vm.visit).forEach(function (prop) {
        if (!vm.visit[prop]) {
          delete vm.visit[prop];
        }
      });
    }

    function isMixLoadAddonEnabled() {
      return addonsService.isAddonPropertyEnabled(PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD, function (addonProperty) {
        return addonProperty.value.toLowerCase() === "true";
      }).then(function (isAddonPropertyEnabled) {
        return isAddonPropertyEnabled;
      });
    }

    function save() {
      deletePropertiesNotUpdated();
      _checkIfAddressHasChanged();
      _checkIfEmailHasBeenChanged();
      var zonesFilter = {
        schedules: plannerService.getScheduledPlanDaysOfWeek(),
        enabled: true
      };
      zoneService.getZonesIfProceed(zonesFilter).then(function (zones) {
        var polygons = zoneService.buildPolygonsFromZones(zones);
        vm.saving = true;
        $rootScope.isLoading = true;

        plannerService.visitsBulkEdit(visitsId, vm.visit);
        plannerService.getVisits().forEach(function (visit) {
          visit.zones = zoneService.getZonesIntoVisit(polygons, visit.latitude, visit.longitude);
        });
        $rootScope.isLoading = false;
        $state.go('^.visits-list', {page: $stateParams.currentPage});
      });
      $rootScope.$broadcast('visits:hideAlertBarSelectedVisits');
      $rootScope.$broadcast('visits:uncheckVisit');
      plannerService.setShouldClearVisitSelectionsOnReturn(true);
    }

    function cancel() {
      $state.go('^.visits-list', {page: $stateParams.currentPage});
    }

    function skillsHandler(skillId, typeOfSkills, opposingSkills) {
      if (!vm.visit[typeOfSkills]) {
        vm.visit[typeOfSkills] = [];
      }
      visitsUtils.skillsHandler(skillId, vm.visit[typeOfSkills], opposingSkills);
      // If the skills list is empty, sets it to null so as not to update the skills when the changes are saved
      if(!vm.visit[typeOfSkills].length) {
        vm.visit[typeOfSkills] = null;
      }
    }

    function tagsHandler(tagId) {
      if (!vm.visit.tags) {
        vm.visit.tags = [];
      }
      visitsUtils.tagSelectedHandler(tagId, vm.visit.tags);
      if(!vm.visit.tags.length) {
        vm.visit.tags = null;
      }
    }

    function coordsChanged(visit) {
      if (!visit.latitude) {
        visit.latitude = DEFAULT_COORDINATE_VALUE;
      }

      if (!visit.longitude) {
        visit.longitude = DEFAULT_COORDINATE_VALUE;
      }

      if (!validationService.validateLatitude(visit.latitude)) {
        vm.validForm.coords = false;
        return;
      }

      if (!validationService.validateLongitude(visit.longitude)) {
        vm.validForm.coords = false;
        return;
      }

      vm.validForm.coords = true;
      var latlng = {
        lat: parseFloat(visit.latitude),
        lng: parseFloat(visit.longitude)
      };

      geocoderService.geocode({ location: latlng }, function (results, status) {
        $rootScope.$broadcast("Planner:Visit:Update", {
          visit: visit
        });
        if (status === googleService.geocoderStatusOK()) {
          visit.address = results[0].formatted_address;
        }

        plannerService.setMapCenterOn(visit);
        $scope.$apply();
        plannerService.setMapCenterOn(visit);
      });
    }

    function validateTime() {
      var validationTimeWindow1, validationTimeWindow2;
      if (vm.skipTimeValidation && $scope.isMultiDayRouteEnabled) {
        validationTimeWindow1 = visitsUtils.checkTimeWindowWithOvernightSupport(1, vm.visit);
        validationTimeWindow2 = visitsUtils.checkTimeWindowWithOvernightSupport(2, vm.visit);
      } else {
        validationTimeWindow1 = visitsUtils.checkTimeWindow(1, vm.visit);
        validationTimeWindow2 = visitsUtils.checkTimeWindow(2, vm.visit);
      }

      vm.validForm.time = false;
      vm.emptyDate = validationTimeWindow1.emptyDate;
      vm.emptyDate2 = validationTimeWindow2.emptyDate2;
      vm.invalidDate = validationTimeWindow1.invalidDate;
      vm.invalidDate2 = validationTimeWindow2.invalidDate2;
      vm.timeBetweenDate = validationTimeWindow1.timeBetweenDate;
      vm.timeBetweenDate2 = validationTimeWindow2.timeBetweenDate2;

      if (!vm.emptyDate && !vm.emptyDate2 && !vm.invalidDate && !vm.invalidDate2 &&
        !vm.timeBetweenDate && !vm.timeBetweenDate2) {
        vm.validForm.time = true;
      }
    }

    function validateWindowTimes() {
      if (vm.skipTimeValidation && vm.isMultiDayRouteEnabled) {
        if (
          vm.invalidDate ||
          vm.invalidDate2 ||
          vm.emptyDate ||
          vm.emptyDate2
        ) {
          return;
        }
      }
      if (vm.invalidDate || vm.invalidDate2 || vm.emptyDate || vm.emptyDate2 ||
        vm.timeBetweenDate || vm.timeBetweenDate2) {
        return;
      }
      var areValid;

      if (vm.skipTimeValidation && $scope.isMultiDayRouteEnabled) {
        areValid = visitsUtils.areValidVisitWindowTimesWithOvernightSupport(vm.visit);
      } else {
        areValid = visitsUtils.areValidVisitWindowTimes(vm.visit);
      }

      if (areValid) {
        vm.visit.status = 1;
        vm.visit.error = null;
        vm.validForm.time = true;
        alertNotificationService.removeAlertNotification();
        if (vm.skipTimeValidation && $scope.isMultiDayRouteEnabled) {
          if (
            vm.timeBetweenDate &&
            _isValidOvernightWindow(vm.visit.windowStart, vm.visit.windowEnd)
          ) {
            vm.timeBetweenDate = false;
          }
          if (
            vm.timeBetweenDate2 &&
            _isValidOvernightWindow(vm.visit.windowStart2, vm.visit.windowEnd2)
          ) {
            vm.timeBetweenDate2 = false;
          }
        }
      } else {
        vm.validForm.time = false;
        alertNotificationService.addAlertNotification(vm.visit.error);
      }
    }

    function validateTimeService() {
      vm.serviceTimeError = visitsUtils.isValidTimeService(vm.visit);
    }

    function validateEmailInput(tag) {
      var isEmailFormatValid = visitsUtils.validateEmailFormat(tag);
      vm.emailInputError.invalidFormat = !isEmailFormatValid;
      var isLengthFormatValid = visitsUtils.validateEmailsLength(tag, vm.emails);
      vm.emailInputError.maxLength = !isLengthFormatValid;
      var isEmailsQuantityValid = visitsUtils.validateEmailsQuantity(vm.emails);
      vm.emailInputError.maxQuantity = !isEmailsQuantityValid;

      var validEmailInput = isEmailFormatValid && isLengthFormatValid && isEmailsQuantityValid;
      vm.form.$invalid = !validEmailInput;
      return validEmailInput;
    }

    function getSummaryVisits() {
      if (vm.visits.length > vm.MAX_VISITS_TO_SHOW) {
        vm.totalVisitsNotShow = vm.visits.length - vm.MAX_VISITS_TO_SHOW;
        var summaryVisits = vm.visits.slice(vm.MAX_VISITS_TO_SHOW, MAX_VISITS_FOR_SUMMARY).map(function (visit) {
          return visit.title;
        }).join(', <br>');
        if (vm.visits.length > MAX_VISITS_FOR_SUMMARY) {
          summaryVisits += '<br> ...';
        }
        return summaryVisits;
      }
      return null;
    }

    function isInvalidForm() {
      var areAnyPropertiesUpdated = Object.values(vm.visit).some(function (prop) {
        return prop !== null;
      });

      areAnyPropertiesUpdated = areAnyPropertiesUpdated || vm.emails.length;

      return !areAnyPropertiesUpdated || vm.form.$invalid || !vm.validForm.time ||
              !vm.validForm.coords || vm.saving || vm.isItemFormInvalid || vm.serviceTimeError;
    }

    function showSaveModal() {
      if (isInvalidForm()) {
        return;
      }
      $scope.save = save;
      $scope.totalVisitsToEdit = visitsId.length;
      ngDialog.open({
        template: 'app/planner/visits/visits-save-bulk-edit-modal.html',
        scope: $scope
      });
    }

    function isSellerVisitEnabled() {
      addonsService.isAddonEnable('seller_management')
        .then(function (isEnabled) {
          vm.isSellerManagementEnabled = isEnabled;
        })
        .catch(function (error) {
          $log.error('Error checking if seller management is enabled: ', error);
        });
    }

    function _isValidOvernightWindow(startTime, endTime) {
      if (!startTime || !endTime) return false;
      var start = moment(startTime, "HH:mm");
      var end = moment(endTime, "HH:mm");
      return start.isAfter(end) && !start.isSame(end);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .controller('PlannerVehiclesListController', PlannerVehiclesListController);

  /** @ngInject */
  function PlannerVehiclesListController($q, $log, $state, moment, plannerService, $rootScope, naturalService,
                                         saveDraftPlanService, $filter,
                                         accountConfigsService, $scope, fleetService, store, sessionService,
                                         statisticsService, vehicleAvailabilityService,
                                         AVAILABILITY_ICON_URL, $sanitize,
                                         addonsService, PATH_FINDER_ADD_ON_KEY,
                                         PATH_FINDER_ADD_ON_PROPERTIES,
                                         $translate, loadPlanService, apolloAuthService, __env, $window, ACCOUNT_CONFIGS) {
    var vm = this;
    var $translateText = $filter('translate');

    vm.isMultiDayRouteEnabled = $scope.isMultiDayRouteEnabled;
    vm.planDate = null;
    vm.invalidDate = false;
    vm.shift = null;
    vm.startDateOptions = {
      formatYear: "yyyy",
      formatDayHeader: "EEE",
      formatDayTitle: "MMMM",
      formatDay: "d",
      showWeeks: false,
      maxMode: "day",
      startingDay: 0,
      minDate: new Date()
    };
    vm.endDateOptions = {
      formatYear: "yyyy",
      formatDayHeader: "EEE",
      formatDayTitle: "MMMM",
      formatDay: "d",
      showWeeks: false,
      maxMode: "day",
      startingDay: 0,
      minDate: new Date()
    };
    vm.popupPlanDate = {
      start: false,
      end: false
    };
    vm.selectedVehicle = null;
    vm.seeAllVehicles = false;
    vm.vehiclesRendered = [];
    vm.fleetSelected = null;
    vm.fleets = [];
    vm.enableFleetLogic = false;
    vm.enableOrganizationSyncService = false;
    vm.vehiclesByFleets = {};
    vm.selectFleet = selectFleet;
    vm.openPopupPlanDate = openPopupPlanDate;
    vm.selectDate = selectDate;
    vm.updateEndDateOptions = updateEndDateOptions;
    vm.updateEndDateOptionsOnLoad = updateEndDateOptionsOnLoad;
    vm.areAllVehiclesSelected = areAllVehiclesSelected;
    vm.toggleAllVehicles = toggleAllVehicles;
    vm.areAvailableSelected = areAvailableSelected;
    vm.toggleAvailable = toggleAvailable;
    vm.arePartiallyAvailableSelected = arePartiallyAvailableSelected;
    vm.togglePartiallyAvailable = togglePartiallyAvailable;
    vm.goNext = goNext;
    vm.toggleVehicle = toggleVehicle;
    vm.getVehiclesActive = getVehiclesActive;
    vm.getVehiclesAvailable = getVehiclesAvailable;
    vm.getVehiclesActiveAndAvailable = getVehiclesActiveAndAvailable;
    vm.getVehiclesPartiallyAvailable = getVehiclesPartiallyAvailable;
    vm.getVehiclesActiveAndPartiallyAvailable = getVehiclesActiveAndPartiallyAvailable;
    vm.toggleSelectedVehicle = toggleSelectedVehicle;
    vm.naturalSort = naturalSort;
    vm.validateTime = validateTime;
    vm.validateTimeErrors = validateTimeErrors;
    vm.validateDates = validateDates;
    vm.setVehiclesRefill = setVehiclesRefill;
    vm.selectDateOneDayPlanner = selectDateOneDayPlanner;
    vm.existAnErrorOnVehiclesSelected = existAnErrorOnVehiclesSelected;
    vm.isVehicleAvailable = isVehicleAvailable;
    vm.isVehiclePartiallyAvailable = isVehiclePartiallyAvailable;
    vm.getTextOfActiveVehicles = getTextOfActiveVehicles;
    vm.isEditingPlan = false;
    vm.plannerService = plannerService;
    vm.errorMissingOriginOrDestiny = false;
    vm.errorVehicleUnavailable = false;
    vm.errorVehiclesNotSelected = false;
    vm.showManageVehicles = false;
    vm.isRouterJr = false;
    vm.draftsEnabled = false;
    vm.customOrderByAvailability = customOrderByAvailability;
    vm.getAvailabilityIconUrl = getAvailabilityIconUrl;
    vm.onClickManageVehiclesLink = onClickManageVehiclesLink;
    vm.handleSearch = handleSearch;
    vm.cleanSearch = cleanSearch;

    // These functions determine whether to display information for a vehicle based on its availability.
    // A vehicle cannot be used for route creation if its availability is "unavailable" or "blocked".
    // It can be used if it is "available", "partially available", or "with expired documents".
    vm.shouldDisplayAvailableVehicleData = vehicleAvailabilityService.shouldDisplayAvailableVehicleData;
    vm.shouldDisplayPartiallyAvailableVehicleData = vehicleAvailabilityService.shouldDisplayPartiallyAvailableVehicleData;
    vm.shouldDisplayVehicleWithExpiredDocumentsData = vehicleAvailabilityService.shouldDisplayVehicleWithExpiredDocumentsData;
    vm.shouldDisplayUnavailableVehicleData = vehicleAvailabilityService.shouldDisplayUnavailableVehicleData;
    vm.shouldDisplayBlockedVehicleData = vehicleAvailabilityService.shouldDisplayBlockedVehicleData;
    vm.hasPlanRoutesProcessed = plannerService.hasPlanRoutesProcessed();
    vm.hasVehicleRoutesProcessed = plannerService.hasVehicleRoutesProcessed;
    vm.searchHasNotFoundVehicles = searchHasNotFoundVehicles;
    vm.filterBySearchResult = filterBySearchResult;
    vm.getVehicleSuggestions = getVehicleSuggestions;
    vm.vehicleSearchInfo = {
      isSearchTrigger: false,
      searchValues: [],
      foundIdsOnSearch: [],
      notFoundSearchValues: []
    };
    vm.skipTimeValidation = false;

    var activateWatcher = $scope.$on("Vehicles:Init-activate", activate);

    $scope.$on('$destroy', function () {
      activateWatcher();
      checkRoutesWatcher();
    });

    activate();

    function activate() {
      $scope.$emit('Planner:clearListenerHandDrawing');
      sessionService.getUser()
        .then(function (user) {
          vm.isRouterJr = user.is_router_jr;
          vm.showManageVehicles = user.is_admin || user.is_owner;
          vm.user = user;
        });

      vm.enableOrganizationSyncService = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_ORGANIZATION_SYNC_SERVICE);
      vm.draftsEnabled = saveDraftPlanService.isEnabled();

      $rootScope.isLoading = true;

      return $q.all({
        plan: loadPlanService.handleDraftPlanLoad(),
        skipTimeValidation: isSkipTimeValidationEnabled()
      })
        .then(function (results) {
          var isSkipTimeValidationActivated = results.skipTimeValidation && $scope.isMultiDayRouteEnabled;
          vm.skipTimeValidation = isSkipTimeValidationActivated;

          updateEndDateOptionsOnLoad(isSkipTimeValidationActivated);

          return successGetPlan(results.plan);
        })
        .catch(failGetPlan)
        .finally(function() {
          $rootScope.isLoading = false;
          $scope.$emit("Planner:Plan:steps-reset");
        });

      function successGetPlan(plan) {
        plannerService.hideVehicles();
        plannerService.clearMapVisits();
        plannerService.hideRoutes();
        plannerService.hideInfoWindow();
        plannerService.deactivateVisits();
        vm.isEditingPlan = Boolean(plannerService.getPlanName());
        var planDate = plannerService.getPlanDate();
        vm.planDate = {
          start: moment(planDate.start).toDate(),
          end: moment(planDate.end).toDate()
        };
        vm.shift = plannerService.getShift();

        //check if any vehicle active is compromised
        setVehiclesRefill();

        return $q.when()
          .then(function() {
            if (!isFleetsEnabled()) {
              return plannerService.vehicles;
            }

            return fleetService.getMyFleets()
              .then(function (fleets) {
                vm.enableFleetLogic = shouldApplyFleetLogic(fleets);
                if (!vm.enableFleetLogic) {
                  return plannerService.vehicles;
                }

                vm.vehiclesByFleets = fleetService.getVehiclesByFleets(plannerService.vehicles, fleets);
                vm.fleetSelected = fleets[0];
                var selectedFleet = plannerService.getSelectedFleet();
                if (selectedFleet) {
                  vm.fleetSelected = fleets.find(function (fleet) {
                    return fleet.id === selectedFleet.id;
                  });
                }

                fleetService.paintVehiclesByFleet(vm.vehiclesByFleets[vm.fleetSelected.id], vm.fleetSelected);
                vm.fleets = fleets;
                plannerService.setSelectedFleet(vm.fleetSelected);
                plannerService.setFleetId(vm.fleetSelected.id);
                return vm.vehiclesByFleets[vm.fleetSelected.id] || [];
              })
              .catch(function () {
                return plannerService.vehicles;
              });
          })
          .then(function(vehicles) {
            vm.vehiclesRendered = vehicles;
            selectDate();
            updateVehiclesRendered();
            $scope.$emit("Planner:Plan:change-fleet", {
              currentVehicles: vehicles
            });
          });
      }

      function failGetPlan(e) {
        $log.error(e);
      }
    }

    function isSkipTimeValidationEnabled() {
      return addonsService.isAddonPropertyEnabled(PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES.SKIP_TIME_VALIDATION, function (addonProperty) {
        return addonProperty.value.toLowerCase() === "true";
      }).then(function (isAddonPropertyEnabled) {
        return isAddonPropertyEnabled;
      });
    }

    function updateVehiclesRendered() {
      vm.errorMissingOriginOrDestiny = !allVehiclesActivatedHaveOriginAndDestiny(vm.vehiclesRendered);
      vm.errorVehiclesNotSelected =  vm.getVehiclesActive(vm.vehiclesRendered).length === 0;
    }

    function isFleetsEnabled() {
      var accountConfigs = store.get('accountConfigs');
      var enableFleetConfig;
      if (accountConfigs) {
        enableFleetConfig = accountConfigs.find(function (config) {
          return config.key === 'enable_fleets';
        });
      }

      return enableFleetConfig ? enableFleetConfig.value : false;
    }

    function toggleVehicle(vehicle) {
      vm.errorVehicleUnavailable = existVehicleActiveUnavailable(vm.vehiclesRendered);
      vm.errorMissingOriginOrDestiny = existVehiclesActiveWithoutLatLng(vm.vehiclesRendered);
      vm.errorVehiclesNotSelected = vm.getVehiclesActive(vm.vehiclesRendered).length === 0;

      if (existAnErrorOnVehiclesSelected()) {
        plannerService.disableStep.next = false;
        plannerService.disableStep.vehicleDisabled = true;
      }

      // The vehicle was inactive, and has just been activated
      if (vehicle.active) {
        return;
      }

      if (vm.isEditingPlan) {
        plannerService.setVehiclesEnableEditPlan(true);
      }
    }

    function toggleSelectedVehicle(vehicle) {
      plannerService.getGmap().setZoom(11);
      if (vehicle === vm.selectedVehicle) {
        vehicle.setVisible(false);
        plannerService.getCenter();
        vm.selectedVehicle = null;
        return;
      }

      vm.selectedVehicle = vehicle;

      plannerService.vehicles.forEach(function (plannerVehicle) {
        if (plannerVehicle !== vehicle) {
          plannerVehicle.setVisible(false);
        }
      });

      vehicle.setOpacity(1.0);
      plannerService.centerVehicle(vehicle);
    }

    function checkRoutes(vehicles) {
      var disabled = false;
      vm.errorVehicleUnavailable = disabled;
      plannerService.disableStep.next = disabled;
      plannerService.disableStep.vehicleDisabled = disabled;

      vehicleAvailabilityService.getAvailability(vm.enableOrganizationSyncService)
        .then(function (response) {
          var vehiclesAvailabilityInfo = response.data;
          vehicles.forEach(function (vehicle) {
            var id = vehicle.id;
            if (!vehiclesAvailabilityInfo[id]) {
              return;
            }

            vehicleAvailabilityService.setAvailability(vehicle, vehiclesAvailabilityInfo[id], vm.isMultiDayRouteEnabled, vm.enableOrganizationSyncService);
            if (!vehicle.availability.isAvailable && vehicle.active) {
              disabled = true;
              vm.errorVehicleUnavailable = disabled;
              plannerService.disableStep.vehicleDisabled = disabled;
            }
          });

          _updateVehicleAndPlanState();
        });
    }

    function isVehicleAvailable(vehicleAvailability) {
      return vehicleAvailability.isAvailable && !vehicleAvailability.isPartiallyAvailable;
    }

    function getVehiclesAvailable(vehicles) {
      return vehicles.filter(function (vehicle) {
        return isVehicleAvailable(vehicle.availability);
      });
    }

    function getVehiclesActiveAndAvailable(vehicles) {
      return vehicles.filter(function (vehicle) {
        return vehicle.active && isVehicleAvailable(vehicle.availability);
      });
    }

    function isVehiclePartiallyAvailable(vehicleAvailability) {
      return vehicleAvailability.isAvailable && vehicleAvailability.isPartiallyAvailable;
    }

    function getVehiclesPartiallyAvailable(vehicles) {
      var vehiclesOnSearch = filterAllVehiclesBySearchResult(vehicles);
      return vehiclesOnSearch.filter(function (vehicle) {
        return isVehiclePartiallyAvailable(vehicle.availability);
      });
    }

    function getVehiclesActiveAndPartiallyAvailable(vehicles) {
      return vehicles.filter(function (vehicle) {
        return vehicle.active && isVehiclePartiallyAvailable(vehicle.availability);
      });
    }

    function getVehiclesActive(vehicles) {
      return vehicles.filter(function (vehicle) {
        return vehicle.active;
      });
    }

    var checkRoutesWatcher = $rootScope.$on('checkRoutes', function () {
      selectDate();
    });

    function _updateVehicleAndPlanState() {
      vm.errorMissingOriginOrDestiny = !allVehiclesActivatedHaveOriginAndDestiny(vm.vehiclesRendered);
      vm.errorVehiclesNotSelected = vm.getVehiclesActive(vm.vehiclesRendered).length === 0;
      if (existAnErrorOnVehiclesSelected()) {
        plannerService.disableStep.next = false;
        plannerService.disableStep.vehicleDisabled = true;
      }

      if (vm.isEditingPlan) {
        plannerService.setVehiclesEnableEditPlan(true);
      }

    }

    function areAvailableSelected() {
      var availableVehicles = vm.getVehiclesAvailable(vm.vehiclesRendered);
      var vehicles = filterAllVehiclesBySearchResult(availableVehicles);
      return vehicles.length > 0 && vehicles.every(function (vehicle) {
        return vehicle.active;
      });
    }

    function toggleAvailable() {
      var areAvailableSelected = vm.areAvailableSelected();
      var availableVehicles = vm.getVehiclesAvailable(vm.vehiclesRendered);
      var vehicles = filterAllVehiclesBySearchResult(availableVehicles);
      vehicles.forEach(function (vehicle) {
        vehicle.active = !areAvailableSelected;
      });

      _updateVehicleAndPlanState();
    }

    function arePartiallyAvailableSelected() {
      var partiallyAvailableVehicles = vm.getVehiclesPartiallyAvailable(vm.vehiclesRendered);
      var vehicles = filterAllVehiclesBySearchResult(partiallyAvailableVehicles);
      return vehicles.length > 0 && vehicles.every(function (vehicle) {
        return vehicle.active;
      });
    }

    function togglePartiallyAvailable() {
      var arePartiallyAvailableSelected = vm.arePartiallyAvailableSelected();
      var partiallyAvailableVehicles = vm.getVehiclesPartiallyAvailable(vm.vehiclesRendered);
      var vehicles = filterAllVehiclesBySearchResult(partiallyAvailableVehicles);
      vehicles.forEach(function (vehicle) {
        vehicle.active = !arePartiallyAvailableSelected;
      });

      _updateVehicleAndPlanState();
    }

    function areAllVehiclesSelected() {
      var vehicles = filterAllVehiclesBySearchResult(vm.vehiclesRendered);
      return vehicles.every(function (vehicle) {
        return !vehicle.availability.isAvailable || vehicle.active;
      });
    }

    function toggleAllVehicles() {
      var areAllVehiclesSelected = vm.areAllVehiclesSelected();
      var vehicles = filterAllVehiclesBySearchResult(vm.vehiclesRendered);
      vehicles.forEach(function (vehicle) {
        vehicle.active = vehicle.availability.isAvailable && !areAllVehiclesSelected;
      });

      _updateVehicleAndPlanState();
    }

    function allVehiclesActivatedHaveOriginAndDestiny(vehicles) {
      var check = vehicles.length > 0;
      for (var i = 0; i < vehicles.length; i++) {
        if (vehicles[i].active && (!vehicles[i].locationStart.latitude ||
          !vehicles[i].locationStart.longitude ||
          !vehicles[i].locationEnd.latitude ||
          !vehicles[i].locationEnd.longitude)) {
          check = false;
          break;
        }
      }

      return check;
    }

    function openPopupPlanDate(key) {
      vm.popupPlanDate[key] = !vm.popupPlanDate[key];
    }

    function selectDate() {
      var date = {
        start: moment(vm.planDate.start).format("YYYY-MM-DD"),
        end: moment(vm.planDate.end || vm.planDate.start).format("YYYY-MM-DD")
      };

      plannerService.setPlanDate(moment(date.start), moment(date.end));
      plannerService.routesAccount.length = 0;
      checkRoutes(vm.vehiclesRendered);
    }

    function replicateChangesIntoPlannerService() {
      var wasInitialShiftChanged = plannerService.wasInitialShiftChanged();
      plannerService.vehicles.forEach(function (vehicle) {
        if (wasInitialShiftChanged && !vehicle.isShiftTemporarilyEdited && !vehicle.availability.isPartiallyAvailable) {
          vehicle.shift.start = vehicle.shiftDefault.start || vm.shift.start;
          vehicle.shift.end = vehicle.shiftDefault.end || vm.shift.end;
        }
      });
    }

    function goNext() {
      replicateChangesIntoPlannerService();
      statisticsService.updateTotalVehiclesCapacity(vm.getVehiclesActive(vm.vehiclesRendered));
      $state.go('^.visits-list');
    }

    function naturalSort(field) {
      return function (item) {
        return naturalService.naturalValue(item[field]);
      };
    }

    function _updateVehicleShift(vehicles, shift) {
      vehicles.forEach(function (vehicle) {
        if (!vehicle.isShiftTemporarilyEdited) {
          vehicle.shift.start = vehicle.shiftDefault.start || shift.start;
          vehicle.shift.end = vehicle.shiftDefault.end || shift.end;
        }
      });
    }

    function validateTimeErrors(dates, times) {
      var result = false, m;
      var re = /^\s*([01]?\d|2[0-3]):?([0-5]\d)\s*$/;

      // validar hora de inicio
      if ((m = times.start.match(re))) {
        vm.scheduleForm.$invalid = false;
        vm.invalidTimeFormat = false;
        result = (m[1].length === 2 ? "" : "0") + m[1] + ":" + m[2];
        if (!result) {
          vm.scheduleForm.$invalid = true;
          vm.invalidTimeFormat = true;
          return true;
        }
      } else {
        vm.scheduleForm.$invalid = true;
        vm.invalidTimeFormat = true;
        return true;
      }

      // validar hora final
      if ((m = times.end.match(re))) {
        vm.scheduleForm.$invalid = false;
        vm.invalidTimeFormat = false;
        result = (m[1].length === 2 ? "" : "0") + m[1] + ":" + m[2];
        if (!result) {
          vm.scheduleForm.$invalid = true;
          vm.invalidTimeFormat = true;
          return true;
        }
      } else {
        vm.scheduleForm.$invalid = true;
        vm.invalidTimeFormat = true;
        return true;
      }

      // validar tiempos entre horas
      if (times.start) {
        times.start = moment(times.start, "HH:mm").format("HH:mm");
      }

      if (times.end) {
        times.end = moment(times.end, "HH:mm").format("HH:mm");
      }

      if (((times.start > times.end) || times.start === times.end)
        && moment(dates.end).diff(moment(dates.start), 'days') === 0) {
        vm.scheduleForm.$invalid = true;
        vm.timeBetweenDate = true;
        return true;
      }

      return false;
    }

    function validateTime(dates, times) {
      if (validateTimeErrors(dates, times)) {
        return;
      }

      vm.scheduleForm.$invalid = false;
      vm.timeBetweenDate = false;
      plannerService.setShift(times.start, times.end);
      if (vm.enableFleetLogic) {
        for (var key in vm.vehiclesByFleets) {
          _updateVehicleShift(vm.vehiclesByFleets[key], times);
        }
      } else {
        _updateVehicleShift(vm.vehiclesRendered, times);
      }

      _deactivateVehicles(vm.vehiclesRendered);
      checkRoutes(vm.vehiclesRendered);
    }

    function setVehiclesRefill() {
      accountConfigsService.getConfigByKey('vehicle_refill_time')
        .then(function (value) {
          plannerService.vehicles.forEach(function (vehicle) {
            vehicle.refill = value || 0;
          });
        });
    }

    function selectFleet(fleet) {
      var selectedFleet = plannerService.getSelectedFleet();
      if (selectedFleet && selectedFleet.id === fleet.id) {
        return;
      }

      vm.fleetSelected = fleet;
      plannerService.setSelectedFleet(fleet);
      plannerService.setFleetId(fleet.id);
      fleetService.paintVehiclesByFleet(vm.vehiclesByFleets[fleet.id], fleet);
      _deactivateVehicles(vm.vehiclesRendered);
      vm.vehiclesRendered = Array.from(vm.vehiclesByFleets[fleet.id]);
      vm.nextStep = allVehiclesActivatedHaveOriginAndDestiny(vm.vehiclesRendered);
      checkRoutes(vm.vehiclesRendered);
      vm.errorVehiclesNotSelected = vm.getVehiclesActive(vm.vehiclesRendered).length === 0;
      $scope.$emit("Planner:Plan:change-fleet", {
        currentVehicles: vm.vehiclesByFleets[fleet.id]
      });
      if (vm.vehicleSearchInfo.searchValues && vm.vehicleSearchInfo.searchValues.length) {
        vm.handleSearch(vm.vehicleSearchInfo.searchValues);
      };
    }

    function shouldApplyFleetLogic(fleets) {
      return fleets.some(function (fleet) {
        return fleet.vehicles.length > 0;
      });
    }

    function existAnErrorOnVehiclesSelected() {
      return vm.errorVehiclesNotSelected || vm.errorMissingOriginOrDestiny || vm.errorVehicleUnavailable;
    }

    function existVehiclesActiveWithoutLatLng(vehicles) {
      return vehicles.some(function (vehicle) {
        return (
          vehicle.active &&
          ((
            vehicle.locationStart &&
            vehicle.locationEnd &&
            !vehicle.locationStart.latitude || !vehicle.locationStart.longitude ||
            !vehicle.locationEnd.latitude || !vehicle.locationEnd.longitude
          ) || (!vehicle.locationStart || !vehicle.locationEnd)));
      });
    }

    function existVehicleActiveUnavailable(vehicles) {
      return vehicles.some(function (vehicle) {
        return vehicle.active && !vehicle.availability.isAvailable;
      });
    }

    function validateDates(dates) {
      updateEndDateOptions();
      if (dates.start instanceof Date
        && dates.end instanceof Date
        && moment(dates.start).isAfter(moment(dates.end))
      ) {
        vm.invalidDate = true;
        vm.scheduleForm.$invalid = true;
      } else {

        plannerService.setPlanDate(moment(dates.start), moment(dates.end));
        vm.invalidDate = false;
        vm.scheduleForm.$invalid = false;
        if (!vm.validateTimeErrors(dates, vm.shift)) {
          _deactivateVehicles(vm.vehiclesRendered);
          checkRoutes(vm.vehiclesRendered);
        }
      }
    }

    function selectDateOneDayPlanner() {
      var date = {
        start: moment(vm.planDate.start).format("YYYY-MM-DD"),
        end: moment(vm.planDate.start).format("YYYY-MM-DD")
      };

      plannerService.setPlanDate(moment(date.start), moment(date.end));
      $scope.$emit("planner:drawZonesOnMap");
      plannerService.routesAccount.length = 0;
      _deactivateVehicles(vm.vehiclesRendered);
      checkRoutes(vm.vehiclesRendered);
    }

    function getTextOfActiveVehicles() {
      var renderedVehiclesLength = vm.vehiclesRendered.length;
      var vehiclesText = renderedVehiclesLength > 1 ? $translateText("Vehicles.vehicles_plural") : $translateText("Vehicles.vehicles_singular");
      var renderedVehiclesText = renderedVehiclesLength + " " + vehiclesText;
      var defaultSpanTag = "<span>" + renderedVehiclesText + "</span>";
      var activeVehiclesLength = vm.getVehiclesActive(vm.vehiclesRendered).length;
      if (activeVehiclesLength === 0) {
        return $sanitize(defaultSpanTag);
      }

      var selectedText = activeVehiclesLength > 1 ? $translateText("Vehicles.selected_plural") : $translateText("Vehicles.selected_singular");
      var selectedVehiclesSpanTag = "<span class='sp-selected-vehicles'>" + selectedText + " " + activeVehiclesLength + "</span>";
      var renderedVehiclesSpanTag = "<span>" + $translateText("Vehicles.of") + " " + renderedVehiclesText + "</span>";
      return $sanitize(selectedVehiclesSpanTag + renderedVehiclesSpanTag);
    }

    function customOrderByAvailability(vehicle) {
      if (!vehicle.availability.isAvailable) {
        return 2;
      }

      if (vehicle.availability.isPartiallyAvailable) {
        return 1;
      }

      return 0;
    }

    function _deactivateVehicles(vehicles) {
      vehicles.forEach(function (vehicle) {
        vehicle.active = false;
      });
    }

    function getAvailabilityIconUrl(vehicleAvailability) {
      if (vm.shouldDisplayPartiallyAvailableVehicleData(vehicleAvailability)) {
        return AVAILABILITY_ICON_URL.PARTIALLY_AVAILABLE;
      }

      if (vm.shouldDisplayUnavailableVehicleData(vehicleAvailability)) {
        return AVAILABILITY_ICON_URL.UNAVAILABLE;
      }

      if (vm.shouldDisplayVehicleWithExpiredDocumentsData(vehicleAvailability)) {
        return AVAILABILITY_ICON_URL.WITH_EXPIRED_DOCUMENTS;
      }

      if (vm.shouldDisplayBlockedVehicleData(vehicleAvailability)) {
        return AVAILABILITY_ICON_URL.BLOCKED;
      }

      return AVAILABILITY_ICON_URL.AVAILABLE;
    }

    function onClickManageVehiclesLink(vehicleUrl) {
      if (sessionService.isEmbedded() && vm.user) {
        var url = __env.URL_ROOT + '#/login/sso?token=' + vm.user.api_token;
        $window.open(url, '_blank');
        return;
      }

      var language = $translate.use();
      var currentLanguage = ['es', 'en', 'pt'].includes(language) ? language : 'en';

      var url = apolloAuthService.buildRedirectURL(
        currentLanguage + vehicleUrl
      );

      apolloAuthService.redirect(url);
    }

    function handleSearch(searchVehicles) {
      var foundIds = new Set();
      var foundSearchValues = new Set();

      vm.vehiclesRendered.forEach(function(vehicle) {
        var fields = [
          vehicle.name && vehicle.name.toLowerCase(),
          vehicle.referenceId && vehicle.referenceId.toLowerCase(),
          vehicle.driver && vehicle.driver.name.toLowerCase(),
          vehicle.licensePlate && vehicle.licensePlate.toLowerCase()
        ];
        searchVehicles.forEach(function(searchText) {
          var searchTextToLowerCase = searchText.toLowerCase();

          var foundVehicle = fields.some(function (field) {
            if (!field) {
              return null;
            }
            return field.indexOf(searchTextToLowerCase) !== -1;
          });
          if (foundVehicle) {
            foundIds.add(vehicle.id);
            foundSearchValues.add(searchText);
          }
        });
      });
      vm.vehicleSearchInfo.foundIdsOnSearch = Array.from(foundIds);
      vm.vehicleSearchInfo.isSearchTrigger = true;
      vm.vehicleSearchInfo.searchValues = searchVehicles;
      vm.vehicleSearchInfo.notFoundSearchValues = searchVehicles.filter(function(v) {
        return !foundSearchValues.has(v);
      });
    }

    function cleanSearch() {
      vm.vehicleSearchInfo.foundIdsOnSearch = [];
      vm.vehicleSearchInfo.isSearchTrigger = false;
      vm.vehicleSearchInfo.searchValues = [];
      vm.vehicleSearchInfo.notFoundSearchValues = [];
    };

    function isSearchActive() {
      return vm.vehicleSearchInfo.isSearchTrigger && vm.vehicleSearchInfo.foundIdsOnSearch.length > 0;
    };

    function searchHasNotFoundVehicles() {
      return (
        vm.vehicleSearchInfo.isSearchTrigger
        && !vm.vehicleSearchInfo.foundIdsOnSearch.length
      );
    };

    function filterBySearchResult(vehicle) {
      var foundVehicleIdsOnSearch = vm.vehicleSearchInfo.foundIdsOnSearch;
      if (!foundVehicleIdsOnSearch || foundVehicleIdsOnSearch.length === 0) {
        return true;
      }
      return foundVehicleIdsOnSearch.includes(vehicle.id);
    };

    function filterAllVehiclesBySearchResult(vehicles) {
      return !isSearchActive() ? vehicles : vehicles.filter(function (vehicle) {
        return vm.filterBySearchResult(vehicle);
      });
    }

    function getVehicleSuggestions(searchValue) {
      var text = searchValue.toLowerCase();
      var suggestions = new Set();
      vm.vehiclesRendered.forEach(function (vehicle) {
        var fields = [
          vehicle.name && vehicle.name.toLowerCase(),
          vehicle.referenceId && vehicle.referenceId.toLowerCase(),
          vehicle.driver && vehicle.driver.name.toLowerCase(),
          vehicle.licensePlate && vehicle.licensePlate.toLowerCase()
        ];
        fields.forEach(function (value) {
          var suggestion = retrieveSuggestion(text, value && value.toLowerCase());
          if (!suggestion) {
            return;
          }
          var foundSuggestionObj = suggestions.some(function (suggestionObj) {
            return suggestion.matchValue === suggestionObj.matchValue;
          });
          if (!foundSuggestionObj) {
            suggestions.add(suggestion);
          };
        });
      });
      return Array.from(suggestions);
    };

    function retrieveSuggestion(searchValue, matchValue) {
      if (!matchValue) {
        return null;
      }
      var index = matchValue.indexOf(searchValue);
      if (index === -1) {
        return null;
      };
      var start = index;
      var end = index + searchValue.length - 1;
      return {
        matchValue: matchValue,
        before: matchValue.slice(0, start),
        match: matchValue.slice(start, end + 1),
        after: matchValue.slice(end + 1)
      };
    };

    /**
     * Updates end date options based on start date and skipTimeValidation flag
     */
    function updateEndDateOptions() {
      if (!vm.planDate || !vm.planDate.start) {
        return;
      }

      // Set minDate of end date to match start date
      vm.endDateOptions.minDate = new Date(vm.planDate.start);

      // If skipTimeValidation is enabled, restrict end date to max one day after start
      if (vm.skipTimeValidation) {
        var maxEndDate = new Date(vm.planDate.start);
        maxEndDate.setDate(maxEndDate.getDate() + 1);
        vm.endDateOptions.maxDate = maxEndDate;
      } else {
        // Remove max date restriction if skipTimeValidation is disabled
        vm.endDateOptions.maxDate = undefined;
      }
    }

    function updateEndDateOptionsOnLoad(skipTimeValidation) {
      if (!skipTimeValidation) {
        return;
      }

      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      vm.endDateOptions.maxDate = tomorrow;
    }
  }
})();

/* global google:false */
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .controller('PlannerVehiclesDetailController', PlannerVehiclesDetailController);

  /** @ngInject */
  function PlannerVehiclesDetailController($log, $scope, $q, $state, $stateParams, plannerService, $filter, Toasts, lodash,
                                           routesUtils, addonsService, PATH_FINDER_ADD_ON_KEY,
                                           PATH_FINDER_ADD_ON_PROPERTIES, driverSelectMapper, TMS_ADD_ON_KEY) {

    var vm = this;
    var $translate = $filter('translate');
    var backupData = null;
    var saved = false;

    vm.vehicle = null;
    vm.drivers = null;
    vm.skills = [];
    vm.skillsVehicle = {};

    vm.form = {};
    vm.save = save;
    vm.isTmsEnable = false;
    vm.validateTime = validateTime;
    vm.updateVehicleLocation = updateVehicleLocation;
    vm.isStartLocation = true;
    vm.skipTimeValidation = false;
    vm.driverSelectInfo = {
      drivers: [],
      selectedId: null,
      onClickOption: onChangeDriverSelect
    };

    vm.isMixLoadAddonEnabled = false;

    activate();

    ////////////

    function activate() {

      return $q.all({
        vehicle: plannerService.getVehicle($stateParams.vehicleId),
        drivers: plannerService.getDrivers(),
        skills: plannerService.getSkills(),
        skipTimeValidation: isSkipTimeValidationEnabled()
      }).then(successActivate, errorActivate);

      function successActivate(results) {
        plannerService.clearMapVisits();
        plannerService.hideRoutes();
        vm.vehicle = results.vehicle;
        vm.vehicle.setEditMode();
        vm.skipTimeValidation = results.skipTimeValidation && $scope.isMultiDayRouteEnabled;
        plannerService.centerVehicle(vm.vehicle);
        //Creamos una copia del vehiculo por si el usuario le da cancelar
        backupData = {
          name: vm.vehicle.name,
          capacity: vm.vehicle.capacity,
          reference_id: vm.vehicle.reference_id,
          capacity2: vm.vehicle.capacity2,
          capacity3: vm.vehicle.capacity3,
          capacity4: vm.vehicle.capacity4,
          driverId: vm.vehicle.driverId,
          locationStart: {
            address: vm.vehicle.locationStart.address,
            latitude: vm.vehicle.locationStart.latitude,
            longitude: vm.vehicle.locationStart.longitude
          },
          locationEnd: {
            address: vm.vehicle.locationEnd.address,
            latitude: vm.vehicle.locationEnd.latitude,
            longitude: vm.vehicle.locationEnd.longitude
          },
          shift: {
            start: vm.vehicle.shift.start,
            end: vm.vehicle.shift.end
          },
          skills: [],
          cost: vm.vehicle.cost
        };
        vm.driverSelectInfo.selectedId = vm.vehicle.driverId;
        angular.copy(vm.vehicle.skills, backupData.skills);
        vm.drivers = results.drivers;
        vm.driverSelectInfo.drivers = vm.drivers ? driverSelectMapper.formatList(vm.drivers): [];
        vm.skills = results.skills;
        vm.skills.forEach(function (skill) {
          skill.id = String(skill.id);
        });

        _getEnableSkill();
        addonsService.isAddonEnable(TMS_ADD_ON_KEY).then(function(isTmsEnable) {
          vm.isTmsEnable = isTmsEnable;
        });
        isMixLoadAddonEnabled();

        function isMixLoadAddonEnabled() {
          return addonsService.isAddonPropertyEnabled(PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD, function (addonProperty) {
            return addonProperty.value.toLowerCase() === "true";
          }).then(function (isAddonPropertyEnabled) {
            vm.isMixLoadAddonEnabled = isAddonPropertyEnabled;
          });
        }
      }

      function errorActivate(error) {
        $log.info(error);
        if (error.status === 404) {
          Toasts.push('error', $translate('Planner_toast.vehicle_not_found'));
          $state.go('^');
        }
      }
    }

    function isSkipTimeValidationEnabled() {
      return addonsService.isAddonPropertyEnabled(PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES.SKIP_TIME_VALIDATION, function (addonProperty) {
        return addonProperty.value.toLowerCase() === "true";
      }).then(function (isAddonPropertyEnabled) {
        return isAddonPropertyEnabled;
      });
    }

    function updateVehicleLocation(location, address, isStartLocation) {
      plannerService.getGmap().setZoom(11);
      var lat = parseFloat(location.latitude.toFixed(6));
      var lng = parseFloat(location.longitude.toFixed(6));
      if (isStartLocation) {
        vm.vehicle.setLocationStart(address, lat, lng);
      } else {
        vm.vehicle.setLocationEnd(address, lat, lng);
      }
      plannerService.centerVehicle(vm.vehicle);
    }

    function validateTime() {
      var result = false, m;
      //var re = /^\s*([01]?\d|2[0-3]):?([0-5]\d)\s*$/;
      var re = /^([0-1]?[0-9]|2[0-3])(:[0-5][0-9])?$/;

      // validar hora de inicio
      if (vm.vehicle.shift.start) {
        if ((m = vm.vehicle.shift.start.match(re))) {
          vm.form.$valid = true;
          vm.invalidDate = false;
        } else {
          vm.form.$valid = false;
          vm.invalidDate = true;
          return;
        }
      } else {
        vm.form.$valid = true;
        vm.invalidDate = false;
        vm.vehicle.shift.start = null;
      }

      // validar hora final
      if (vm.vehicle.shift.end) {
        if ((m = vm.vehicle.shift.end.match(re))) {
          vm.form.$valid = true;
          vm.invalidDate = false;
        } else {
          vm.form.$valid = false;
          vm.invalidDate = true;
          return;
        }
      } else {
        vm.form.$valid = true;
        vm.invalidDate = false;
        vm.vehicle.shift.end = null;
      }

      // validar tiempos entre horas
      if (vm.vehicle.shift.start) {
        vm.vehicle.shift.start = moment(vm.vehicle.shift.start, "HH:mm").format("HH:mm");
      }

      if (vm.vehicle.shift.end) {
        vm.vehicle.shift.end = moment(vm.vehicle.shift.end, "HH:mm").format("HH:mm");
      }

      if (!vm.vehicle.shift.start && !vm.vehicle.shift.end) {
        vm.emptyDate = false;
        vm.timeBetweenDate = false;
        return;
      }

      var isSameTime = vm.vehicle.shift.start === vm.vehicle.shift.end;
      if (isSameTime) {
        vm.form.$valid = false;
        vm.timeBetweenDate = true;
        return;
      }

      var isEndBeforeStart = vm.vehicle.shift.start > vm.vehicle.shift.end;
      if (isEndBeforeStart && !vm.skipTimeValidation) {
        vm.form.$valid = false;
        vm.timeBetweenDate = true;
        return;
      }

      vm.form.$valid = true;
      vm.timeBetweenDate = false;

      if (!vm.vehicle.shift.start && vm.vehicle.shift.end || vm.vehicle.shift.start && !vm.vehicle.shift.end) {
        vm.form.$valid = false;
        vm.emptyDate = true;
      } else {
        vm.form.$valid = true;
        vm.emptyDate = false;
      }
    }

    function save() {
      _checkForm();
      if (!vm.form.$valid) {
        return;
      }

      _saveSkills();
      vm.vehicle.capacity = _changeFormatCapacity(vm.vehicle.capacity);
      vm.vehicle.capacity2 = (vm.vehicle.capacity2) ? _changeFormatCapacity(vm.vehicle.capacity2) : 0;
      vm.vehicle.capacity3 = (vm.vehicle.capacity3) ? _changeFormatCapacity(vm.vehicle.capacity3) : 0;
      vm.vehicle.capacity4 = (vm.vehicle.capacity4) ? _changeFormatCapacity(vm.vehicle.capacity4) : 0;
      vm.vehicle.shift.start = vm.vehicle.shift.start || plannerService.shift.start;
      vm.vehicle.shift.end = vm.vehicle.shift.end || plannerService.shift.end;
      vm.vehicle.setIsShiftTemporarilyEdited(backupData.shift);
      if (vm.vehicle.driverId !== backupData.driverId) {
        routesUtils.updateVehicleDriver(vm.vehicle, vm.drivers);
      }

      saved = true;
      $state.go('^.vehicles-list');
    }

    function cleanSkills() {
      var skills = vm.vehicle.skills;
      skills.forEach(function (skill) {
        if (!skill) {
          vm.vehicle.skills.splice(vm.vehicle.skills.indexOf(skill), 1);
        }
      });
    }

    function _getEnableSkill() {
      for (var i = 0; i < vm.vehicle.skills.length; i++) {
        var skill = vm.vehicle.skills[i];
        var index = lodash.find(vm.skills, function (obj) {
          return obj.id === skill;
        });

        if (index) {
          vm.skillsVehicle[index.id] = true;
        }
      }
    }

    function _saveSkills() {
      Object.keys(vm.skillsVehicle).forEach(function (key) {
        if (vm.vehicle.skills.indexOf(key) === -1 && vm.skillsVehicle[key]) {
          vm.vehicle.skills.push(key);
        } else if (vm.vehicle.skills.indexOf(key) > -1 && !vm.skillsVehicle[key]) {
          vm.vehicle.skills.splice(vm.vehicle.skills.indexOf(key), 1);
        }
      });
    }

    function _checkForm() {
      vm.form.$valid = (
        !vm.invalidDate &&
        !vm.timeBetweenDate &&
        !vm.emptyDate &&
        Boolean(vm.vehicle.name) &&
        Boolean(vm.vehicle.capacity) &&
        Boolean(vm.vehicle.locationStart.address) &&
        Boolean(vm.vehicle.locationEnd.address)
      );
    }

    function _changeFormatCapacity(capacity) {
      capacity = String(capacity);

      var locale = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);
      if (locale.substring(0, 2).toLowerCase() === 'es') {
        capacity = capacity.split('.').join("").replace(",", ".");
        return parseFloat(capacity);
      }

      capacity = capacity.split(',').join("");
      return parseFloat(capacity);
    }

    $scope.$on('$destroy', function () {
      vm.vehicle.options.animation = 0;
      vm.vehicle.setEditMode(false);
      vm.vehicle.selected = false;
      if (saved) {
        cleanSkills();
      } else {
        lodash.merge(vm.vehicle, backupData);
      }
    });

    function onChangeDriverSelect (driverId) {
      vm.vehicle.driverId = driverId;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module('icarus.planner')
    .factory('vtcService', vtcService);

  /** @ngInject */
  function vtcService($http, $q, __env, dnsUtilsService, store, timeUtils, vehicleTypeUtils, moment, PATH_FINDER_ADD_ON_PROPERTIES, $timeout) {
    var VTC_URL = __env.VISIT_TIME_CALC_URL;
    var VTC_COUNT = __env.VISIT_TIME_CALC_URL_COUNT;
    var DAY_START_TIME = '00:00';
    var DAY_END_TIME = '23:59';
    var REST_TIME = 'BreakVisit';
    var VTC_ROUTER_MS_URL = __env.ROUTER_MS_URL + 'v2/vtc';

    return {
      getSchedule: getSchedule,
      createVTCBody: createVTCBody,
      processVTCAnswer: processVTCAnswer,
      createRestTimeVisit: createRestTimeVisit,
      callVTC: callVTC
    };

    function getSchedule(body, isVehicularRestrictionEnabled) {
      var vtcBaseUrl = isVehicularRestrictionEnabled ? VTC_ROUTER_MS_URL : VTC_URL;
      var url = dnsUtilsService.getURLByRndDNSNum(vtcBaseUrl, VTC_COUNT);
      var maxRetries = 3;

      function makeRequest(retries) {
        return $http.post(url, body).catch(function (error) {
          if ((error.status >= 500 || error.status === 429 || error.status === 444 || error.status === 408 || error.status === 499 || error.status <= 0) && retries > 0) {
            var delay = Math.pow(2, maxRetries - retries) * 1000;
            return $timeout(function () {
              return makeRequest(retries - 1);
            }, delay);
          }
          throw error;
        });
      }

      return makeRequest(maxRetries);
    }

    /**
     * Gets skip time validation value from pathfinder properties
     * @param {Object} plannerService - The planner service instance
     * @returns {boolean} true if skip time validation is enabled
     */
    function getSkipTimeValidation(plannerService) {
      var pathFinderProperties = plannerService.getPathFinderProperties();
      var skipTimeValidationValue = pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.SKIP_TIME_VALIDATION];
      return skipTimeValidationValue && skipTimeValidationValue.toLowerCase() === 'true';
    }

    /**
     * Second visit window is disabled when start equals end (same rule as planner PDF: no second range).
     * Prevents API default 23:59/23:59 from becoming extra multi-day VTC windows.
     * @param {string} windowStart2 - Second window start HH:mm
     * @param {string} windowEnd2 - Second window end HH:mm
     * @returns {boolean} True when second window must not be sent to VTC
     */
    function isVisitSecondWindowDisabledForVtc(windowStart2, windowEnd2) {
      return windowStart2 === windowEnd2;
    }

    /**
     * Extracts time from ETA string, supporting extended format (hours >= 24)
     * @param {string} etaString - ETA string (can be ISO datetime, HH:mm, or extended format)
     * @returns {string} Time in HH:mm format (supports extended hours)
     */
    function extractTimeFromETA(etaString) {
      if (!etaString) {
        return '00:00';
      }
      // If already in extended format, return as-is
      if (timeUtils.isExtendedTimeFormat(etaString)) {
        return etaString;
      }
      // If it's a simple HH:mm format
      if (/^\d{1,2}:\d{2}$/.test(etaString)) {
        return etaString;
      }
      // If it contains 'T' (ISO format), extract time part
      if (etaString.indexOf('T') !== -1) {
        var timePart = etaString.split('T')[1];
        return timePart ? timePart.substring(0, 5) : '00:00';
      }
      // Fallback: try to use formatExtendedTime
      return timeUtils.formatExtendedTime(etaString);
    }

    /**
     * Determines which day a time belongs to relative to plan dates
     * @param {string} timeString - Time string (can be ISO datetime or HH:mm)
     * @param {string} programmedDate - Visit programmed date in YYYY-MM-DD format (optional)
     * @param {string} planStartDate - Plan start date in YYYY-MM-DD format
     * @param {string} planEndDate - Plan end date in YYYY-MM-DD format
     * @returns {number} Day offset (0 = plan start day, 1 = next day, etc.)
     */
    function getDayOffsetFromPlanDates(timeString, programmedDate, planStartDate, planEndDate) {
      if (!timeString || !planStartDate) {
        return 0;
      }

      // If visit has programmedDate, use it to determine day
      if (programmedDate) {
        var visitDate = moment(programmedDate, 'YYYY-MM-DD');
        var startDate = moment(planStartDate, 'YYYY-MM-DD');
        var daysDiff = visitDate.diff(startDate, 'days');
        return Math.max(0, daysDiff);
      }

      // If timeString is ISO datetime, extract date from it
      if (timeString.indexOf('T') !== -1) {
        var isoMoment = moment(timeString);
        if (isoMoment.isValid()) {
          var timeDate = isoMoment.format('YYYY-MM-DD');
          var startDate = moment(planStartDate, 'YYYY-MM-DD');
          var daysDiff = moment(timeDate, 'YYYY-MM-DD').diff(startDate, 'days');
          return Math.max(0, daysDiff);
        }
      }

      // If timeString is in extended format, calculate day from hours
      if (timeUtils.isExtendedTimeFormat(timeString)) {
        var minutes = timeUtils.parseExtendedTimeToMinutes(timeString);
        return Math.floor(minutes / (24 * 60));
      }

      // Default: assume same day (day 0)
      return 0;
    }

    /**
     * Detects if rest time crosses midnight and adjusts day offset accordingly
     * @param {Object} restTime - Rest time object with arrival and departure
     * @param {string} restDeparture - Rest time departure time string
     * @param {string} etaString - Visit estimated time arrival string
     * @param {number} visitDayOffset - Day offset of the visit
     * @param {number} initialRestDayOffset - Initial rest day offset from plan dates
     * @param {boolean} planSpansMultipleDays - Whether plan spans multiple days
     * @param {Object} timeUtils - Time utilities service
     * @returns {Object} Object with {crossesMidnight: boolean, adjustedRestDayOffset: number}
     */
    function _detectAndAdjustMidnightCrossing(restTime, restDeparture, etaString, visitDayOffset, initialRestDayOffset, planSpansMultipleDays, timeUtils) {
      var restTimeCrossesMidnight = false;
      var adjustedRestDayOffset = initialRestDayOffset;

      if (restTime.arrival && restDeparture && !timeUtils.isExtendedTimeFormat(restTime.arrival) && !timeUtils.isExtendedTimeFormat(restDeparture)) {
        var arrivalMinutes = timeUtils.parseExtendedTimeToMinutes(restTime.arrival);
        var departureMinutes = timeUtils.parseExtendedTimeToMinutes(restDeparture);

        // If departure is earlier than arrival, it means it crosses midnight
        // In this case, the departure is on the next day relative to arrival
        if (departureMinutes < arrivalMinutes) {
          restTimeCrossesMidnight = true;
          adjustedRestDayOffset = adjustedRestDayOffset + 1;
        } else if (planSpansMultipleDays && visitDayOffset === 0) {
          // If plan spans multiple days and visit is on day 0 (based on plan dates),
          // and rest time doesn't cross midnight, check if rest time should be on day 1
          // by comparing rest time arrival with visit time using plan dates context
          // Rest time is on day 1 if it's after midnight and visit is before midnight
          var visitTimeMinutes = timeUtils.parseExtendedTimeToMinutes(etaString);
          var minutesInDay = 24 * 60;

          // Use plan dates to determine: if visit is in day 0 and rest time arrival is earlier than visit time,
          // and the time difference suggests rest time is after midnight while visit is before midnight,
          // then rest time is on day 1
          // This uses the plan's day structure (planSpansMultipleDays) and relative time comparison
          // without arbitrary time thresholds
          var timeDiff = visitTimeMinutes - arrivalMinutes;
          // If visit time is much later than rest time arrival (more than half a day difference),
          // it suggests visit is before midnight and rest time is after midnight
          if (arrivalMinutes < visitTimeMinutes && timeDiff > (minutesInDay / 2)) {
            adjustedRestDayOffset = adjustedRestDayOffset + 1;
          }
        }
      }

      return {
        crossesMidnight: restTimeCrossesMidnight,
        adjustedRestDayOffset: adjustedRestDayOffset
      };
    }

    /**
     * Converts rest time departure to extended format considering midnight crossing
     * @param {string} restDeparture - Rest time departure time string
     * @param {number} restDayOffset - Rest day offset
     * @param {boolean} restTimeCrossesMidnight - Whether rest time crosses midnight
     * @param {number} visitDayOffset - Day offset of the visit
     * @param {string} etaString - Visit estimated time arrival string
     * @param {Object} timeUtils - Time utilities service
     * @returns {number} Rest departure in minutes (extended format)
     */
    function _convertRestDepartureToExtendedFormat(restDeparture, restDayOffset, restTimeCrossesMidnight, visitDayOffset, etaString, timeUtils) {
      var restDepartureMinutes = timeUtils.parseExtendedTimeToMinutes(restDeparture);

      // If not already in extended format, convert based on day offset
      if (!timeUtils.isExtendedTimeFormat(restDeparture)) {
        if (restTimeCrossesMidnight && visitDayOffset === 0) {
          var visitTimeMinutes = timeUtils.parseExtendedTimeToMinutes(etaString);
          var minutesInDay = 24 * 60;

          // Special handling for rest time that crosses midnight:
          // When rest time crosses midnight (e.g., 23:30-00:30), we need to compare correctly:
          // - If visit is AFTER midnight (e.g., 00:39) and departure is past midnight (e.g., 00:30),
          //   compare directly without day offset (both are just past midnight on day 0)
          // - If departure is exactly "00:00" (i.e., restDepartureMinutes === 0), the API has
          //   normalised an extended "24:00" back to standard "00:00". Always treat it as 1440 min
          //   (day 1 midnight) so it sorts after all same-day visits, matching optimizer behaviour.
          // - If visit is BEFORE midnight (e.g., 22:04), rest time should go AFTER visit (rest time is on day 1)
          if (visitTimeMinutes < (minutesInDay / 2) && restDepartureMinutes > 0) {
            // Visit is in early morning (before noon) and departure is past-midnight (e.g., 00:30)
            // Both rest time departure and visit are in day 0 after midnight — compare directly
            // Don't add day offset
          } else {
            // Either visit is before midnight, or departure is exactly midnight (00:00 → 24:00)
            // Use day offset to ensure rest time is on day 1
            restDepartureMinutes = restDepartureMinutes + (restDayOffset * 24 * 60);
          }
        } else if (restDayOffset > 0) {
          restDepartureMinutes = restDepartureMinutes + (restDayOffset * 24 * 60);
        }
      }

      return restDepartureMinutes;
    }

    /**
     * Determines if rest time should be inserted before a visit
     * Uses plan dates to determine day offsets instead of arbitrary time comparisons
     * @param {Object} restTime - Rest time configuration with departure time
     * @param {Object} visit - Visit with estimatedTimeArrival
     * @param {boolean} longRoutes - Whether long routes (multi-day) is enabled
     * @param {boolean} skipTimeValidation - Whether skip time validation is enabled
     * @param {string} planStartDate - Plan start date in YYYY-MM-DD format
     * @param {string} planEndDate - Plan end date in YYYY-MM-DD format
     * @param {boolean} isPlanNew - Whether the plan is new (true) or loaded from API (false)
     * @returns {boolean} true if rest time should be before the visit
     */
    function isRestTimeBeforeVisit(restTime, visit, longRoutes, skipTimeValidation, planStartDate, planEndDate, isPlanNew) {
      // Visits don't have ETA the first time they are manually added to the route
      if (!visit.estimatedTimeArrival) {
        return true;
      }

      // Prioritizing the position instead of ETA if visits are moved in a route
      // Use order comparison if restTime.order is a valid number (not null/undefined)
      // This applies to:
      // 1. New plans (isPlanNew = true)
      // 2. Edited plans where user manually moved rest time by drag and drop (order reflects user's intent)
      // When loading from API initially, order may not reflect actual position, but after user moves it, order is valid
      if (angular.isNumber(restTime.order) && restTime.order >= 0) {
        return restTime.order < visit.order;
      }

      var planSpansMultipleDays = planStartDate && planEndDate && planStartDate !== planEndDate;
      var useExtendedFormat = planSpansMultipleDays && skipTimeValidation;

      // Extract time strings
      var etaString = extractTimeFromETA(visit.estimatedTimeArrival);
      var restDeparture = restTime.departure;

      if (!restDeparture) {
        return true;
      }

      if (useExtendedFormat) {
        // Use plan dates to determine day offsets for both times
        // For rest time, check arrival first (might be ISO datetime), then departure
        var restTimeForDayOffset = restTime.arrival || restTime.departure;
        var visitDayOffset = getDayOffsetFromPlanDates(visit.estimatedTimeArrival, visit.programmedDate, planStartDate, planEndDate);
        var initialRestDayOffset = getDayOffsetFromPlanDates(restTimeForDayOffset, null, planStartDate, planEndDate);

        // Detect and adjust for midnight crossing
        var midnightInfo = _detectAndAdjustMidnightCrossing(
          restTime,
          restDeparture,
          etaString,
          visitDayOffset,
          initialRestDayOffset,
          planSpansMultipleDays,
          timeUtils
        );
        var restDayOffset = midnightInfo.adjustedRestDayOffset;
        var restTimeCrossesMidnight = midnightInfo.crossesMidnight;

        // Convert both to extended format based on their day offsets
        var etaMinutes = timeUtils.parseExtendedTimeToMinutes(etaString);
        if (!timeUtils.isExtendedTimeFormat(etaString) && visitDayOffset > 0) {
          etaMinutes = etaMinutes + (visitDayOffset * 24 * 60);
        }

        // Convert rest departure considering midnight crossing
        var restDepartureMinutes = _convertRestDepartureToExtendedFormat(
          restDeparture,
          restDayOffset,
          restTimeCrossesMidnight,
          visitDayOffset,
          etaString,
          timeUtils
        );

        var etaExtended = timeUtils.formatMinutesToExtendedTime(etaMinutes);
        var restDepartureExtended = timeUtils.formatMinutesToExtendedTime(restDepartureMinutes);

        return timeUtils.compareExtendedTimes(etaExtended, restDepartureExtended) >= 0;
      } else {
        // Standard comparison: use plan dates to determine if times are on different days
        var visitDayOffset = getDayOffsetFromPlanDates(visit.estimatedTimeArrival, visit.programmedDate, planStartDate, planEndDate);
        var initialRestDayOffset = getDayOffsetFromPlanDates(restTime.departure, null, planStartDate, planEndDate);

        // Detect and adjust for midnight crossing
        var midnightInfo = _detectAndAdjustMidnightCrossing(
          restTime,
          restDeparture,
          etaString,
          visitDayOffset,
          initialRestDayOffset,
          planSpansMultipleDays,
          timeUtils
        );
        var restDayOffset = midnightInfo.adjustedRestDayOffset;

        // If on different days, compare day offsets first
        if (visitDayOffset !== restDayOffset) {
          var dayOffsetResult = visitDayOffset > restDayOffset;
          return dayOffsetResult;
        }

        // Same day: compare times directly
        var etaTime = moment(etaString, 'HH:mm');
        var restDepartureTime = moment(restDeparture, 'HH:mm');
        var timeComparisonResult = etaTime.isSameOrAfter(restDepartureTime);

        return timeComparisonResult;
      }
    }

    function _setRestTime(restTime, previousVisit, currentVisit, routeId, plannerService) {
      restTime.lat = previousVisit ? previousVisit.latitude : currentVisit.latitude;
      restTime.lon = previousVisit ? previousVisit.longitude : currentVisit.longitude;
      restTime.order = previousVisit ? previousVisit.order : currentVisit.order - 1;
      plannerService.setRestTimeByRouteId(routeId, restTime);
      return restTime;
    }

    function createVTCBody(vehicle, optimizationOptions, plannerService) {
      var isPlanNew = plannerService.isNewPlan();
      var joinSimilar = Boolean(optimizationOptions.join);
      var joinSimilar_v2 = Boolean(optimizationOptions.join_v2);
      var enableRestTime = Boolean(optimizationOptions.enable_rest_time);
      var skipTimeValidation = getSkipTimeValidation(plannerService);

      var originDepot = {
        latitude: vehicle.locationStart.latitude,
        longitude: vehicle.locationStart.longitude,
        order: 0
      };

      var destinationDepot = {
        latitude: angular.isDefined(vehicle.locationEnd) ? vehicle.locationEnd.latitude : null,
        longitude: angular.isDefined(vehicle.locationEnd) ? vehicle.locationEnd.longitude : null
      };

      var vehicleShiftTime = plannerService.getVehicleShiftTime(vehicle);

      // Get plan dates and start time for window adjustments
      var planDate = plannerService.getPlanDate();
      var planStartDate = planDate ? moment(planDate.start).format('YYYY-MM-DD') : null;
      var planEndDate = planDate ? moment(planDate.end).format('YYYY-MM-DD') : null;
      var planStartTime = plannerService.getPlanStartTime();
      var allowExtendedHours = false;

      var body = {};
      var config = {
        country_id: store.get('country'),
        refill_time: vehicle.refill,
        speed_rate:  optimizationOptions.fmv || 2,
        depot_start: originDepot.latitude + ',' + originDepot.longitude,
        depot_end: destinationDepot.latitude && destinationDepot.longitude ?
          destinationDepot.latitude + ',' + destinationDepot.longitude : null,
        plan_start: vehicleShiftTime.start,
        plan_end: vehicleShiftTime.end,
        open_start: optimizationOptions.open_start,
        open_routes: Boolean(optimizationOptions.open_ended),
        avoid_waiting_times: Boolean(optimizationOptions.avoid_waiting_times),
        start_time: planStartTime,
        allow_extended_hours: false
      };

      if (optimizationOptions.avoid_tolls === true) {
        config.osrm_options = { avoid: "tolls" };
      }

      if (vehicleTypeUtils.shouldAddVehicleType(optimizationOptions)) {
        config.vehicle_type = vehicleTypeUtils.getVehicleType(optimizationOptions);
      }

      if (plannerService.isVehicularRestrictionEnabled()) {
        config.vehicle_id = vehicle.id;
      }

      // Determine longRoutes: use optimizationOptions.longRoutes if available, otherwise check if plan spans multiple days
      // This matches the logic in optimize.service.js
      // For VTC, we need to check if plan actually spans multiple days, not just if longRoutes option is enabled
      var planSpansMultipleDays = planStartDate && planEndDate && planStartDate !== planEndDate;
      var longRoutes = optimizationOptions.longRoutes !== undefined
        ? (optimizationOptions.longRoutes && planSpansMultipleDays)
        : planSpansMultipleDays;

      var routes = vehicle.routes.filter(function (route) {
        return route.visits.length > 0;
      }).map(function (route) {
        var isRestTimeAdded = false;
        var restTime = null;
        if (enableRestTime) {
          restTime = plannerService.getRestTimeByRouteId(route.id);
        }

        var newRoute = [];

        var previousVisit = config.open_start ? null : originDepot;

        route.visits.forEach(function (currentVisit, index) {
          if (!isRestTimeAdded && restTime && isRestTimeBeforeVisit(restTime, currentVisit, longRoutes, skipTimeValidation, planStartDate, planEndDate, isPlanNew)) {
            isRestTimeAdded = true;
            restTime = _setRestTime(restTime, previousVisit, currentVisit, route.id, plannerService);

            var breakVisit = createRestTimeVisit(restTime, vehicle, skipTimeValidation, planStartDate, planEndDate, longRoutes, plannerService, planStartTime);

            // Check if rest time visit has extended format windows (only when longRoutes and skipTimeValidation are enabled)
            if (longRoutes && skipTimeValidation && breakVisit.windows && breakVisit.windows.length > 0) {
              breakVisit.windows.forEach(function(window) {
                if (timeUtils.isExtendedTimeFormat(window.window_start) || timeUtils.isExtendedTimeFormat(window.window_end)) {
                  allowExtendedHours = true;
                }
              });
            }

            newRoute.push(breakVisit);
          }

          var visitInfo = {
            id: currentVisit.id,
            windows: [],
            coordinates: currentVisit.latitude + ',' + currentVisit.longitude,
            programmed_date: currentVisit.programmedDate ? currentVisit.programmedDate: null,
            service_time: Number(currentVisit.duration),
            is_similar_to_next: (joinSimilar || joinSimilar_v2) && index < route.visits.length-1
              ? plannerService.visitSimilarGraph.isSimilar(currentVisit, route.visits[index+1])
              : false
          };

          if (currentVisit.windowStart || currentVisit.windowEnd) {
            var windowStart = currentVisit.windowStart || DAY_START_TIME;
            var windowEnd = currentVisit.windowEnd || DAY_END_TIME;

            if (skipTimeValidation) {
              var adjustedTimes = plannerService.adjustWindowTimesWithPlanDatesAndAcrossMidnight({
                windowStart: windowStart,
                windowEnd: windowEnd,
                planStartDate: planStartDate,
                planEndDate: planEndDate,
                planStartTime: planStartTime
              });

              // Track if any visit requires extended hours
              if (adjustedTimes.allowExtendedHours) {
                allowExtendedHours = true;
              }

              // Handle new windows array structure
              if (adjustedTimes.windows) {
                adjustedTimes.windows.forEach(function(window) {
                  visitInfo.windows.push({
                    window_start: window[0],
                    window_end: window[1]
                  });
                });
              } else {
                // Fallback for backward compatibility
                visitInfo.windows.push({
                  window_start: adjustedTimes.windowStart,
                  window_end: adjustedTimes.windowEnd
                });
              }
            } else {
              visitInfo.windows.push({
                window_start: windowStart,
                window_end: windowEnd
              });
            }
          }

          if (currentVisit.windowStart2 || currentVisit.windowEnd2) {
            var windowStart2 = currentVisit.windowStart2 || DAY_START_TIME;
            var windowEnd2 = currentVisit.windowEnd2 || DAY_END_TIME;

            if (!isVisitSecondWindowDisabledForVtc(windowStart2, windowEnd2)) {
              if (skipTimeValidation) {
                var adjustedTimes2 = plannerService.adjustWindowTimesWithPlanDatesAndAcrossMidnight({
                  windowStart: windowStart2,
                  windowEnd: windowEnd2,
                  planStartDate: planStartDate,
                  planEndDate: planEndDate,
                  planStartTime: planStartTime
                });

                // Track if any visit requires extended hours
                if (adjustedTimes2.allowExtendedHours) {
                  allowExtendedHours = true;
                }

                // Handle new windows array structure
                if (adjustedTimes2.windows) {
                  adjustedTimes2.windows.forEach(function(window) {
                    visitInfo.windows.push({
                      window_start: window[0],
                      window_end: window[1]
                    });
                  });
                } else {
                  // Fallback for backward compatibility
                  visitInfo.windows.push({
                    window_start: adjustedTimes2.windowStart,
                    window_end: adjustedTimes2.windowEnd
                  });
                }
              } else {
                visitInfo.windows.push({
                  window_start: windowStart2,
                  window_end: windowEnd2
                });
              }
            }
          }

          newRoute.push(visitInfo);
          previousVisit = currentVisit;
        });

        if (restTime && !isRestTimeAdded) {
          isRestTimeAdded = true;
          restTime = _setRestTime(restTime, previousVisit, destinationDepot, route.id, plannerService);
          var breakVisit = createRestTimeVisit(restTime, vehicle, skipTimeValidation, planStartDate, planEndDate, longRoutes, plannerService, planStartTime);

          // Check if rest time visit has extended format windows (only when longRoutes and skipTimeValidation are enabled)
          if (longRoutes && skipTimeValidation && breakVisit.windows && breakVisit.windows.length > 0) {
            breakVisit.windows.forEach(function(window) {
              if (timeUtils.isExtendedTimeFormat(window.window_start) || timeUtils.isExtendedTimeFormat(window.window_end)) {
                allowExtendedHours = true;
              }
            });
          }

          newRoute.push(breakVisit);
        }
        return newRoute;
      });

      // Update allow_extended_hours based on tracked value from window adjustments
      config.allow_extended_hours = allowExtendedHours;

      body.config = config;
      body.routes = routes;
      return body;

    }

    /**
     * Adjusts rest time windows for extended format when crossing midnight.
     * Converts times like 00:30-02:30 to 24:30-26:30 when the window crosses midnight.
     *
     * Uses plan dates to determine day offsets. When window starts at 00:00 (wide window from drag and drop),
     * does not convert to extended format to allow VTC to calculate based on position.
     *
     * @param {string} restTimeStart - Rest time start in HH:mm format
     * @param {string} restTimeEnd - Rest time end in HH:mm format
     * @param {Object} planDate - Optional. Object with start and end properties in YYYY-MM-DD format
     * @param {string} planStartTime - Optional. Plan start time in ISO format
     * @param {string} vehicleShiftStart - Optional. Vehicle shift start time in HH:mm format (not used, kept for compatibility)
     * @returns {Object} Object with adjusted start and end times in extended format
     */
    function adjustRestTimeForExtendedFormat(restTimeStart, restTimeEnd, planDate, planStartTime, vehicleShiftStart) {
      if (!restTimeStart || !restTimeEnd) {
        return { start: restTimeStart, end: restTimeEnd };
      }

      var startMinutes = timeUtils.parseExtendedTimeToMinutes(restTimeStart);
      var endMinutes = timeUtils.parseExtendedTimeToMinutes(restTimeEnd);

      // If end time is before start time, it means the window crosses midnight
      // Convert to extended format: 00:30 becomes 24:30
      if (endMinutes < startMinutes) {
        endMinutes += 24 * 60;
      }

      // When window starts at 00:00, it indicates a wide window from drag and drop
      // Don't convert to extended format - VTC will calculate based on position
      var isWideWindow = startMinutes === 0;
      if (isWideWindow) {
        return {
          start: timeUtils.formatMinutesToExtendedTime(startMinutes),
          end: timeUtils.formatMinutesToExtendedTime(endMinutes)
        };
      }

      // Only adjust for extended format when plan dates are provided and plan spans multiple days
      // This ensures we use plan dates for validation, not arbitrary time conditions
      if (planDate && planDate.start && planDate.end) {
        var planStartDate = moment(planDate.start).format('YYYY-MM-DD');
        var planEndDate = moment(planDate.end).format('YYYY-MM-DD');

        // Only convert to extended format if plan actually spans multiple days
        // The conversion will be handled by adjustWindowTimesWithPlanDatesAndAcrossMidnight
        // which uses plan dates to determine the correct day offsets
        if (planStartDate !== planEndDate) {
          // Return times as-is - adjustWindowTimesWithPlanDatesAndAcrossMidnight will handle
          // the day offset conversion based on plan dates
          return {
            start: timeUtils.formatMinutesToExtendedTime(startMinutes),
            end: timeUtils.formatMinutesToExtendedTime(endMinutes)
          };
        }
      }

      // For same-day plans or when plan dates are not available, return times as-is
      return {
        start: timeUtils.formatMinutesToExtendedTime(startMinutes),
        end: timeUtils.formatMinutesToExtendedTime(endMinutes)
      };
    }

    /**
     * Creates a rest time visit object for VTC payload
     * @param {Object} restTime - Rest time configuration
     * @param {Object} vehicle - Vehicle with rest time settings
     * @param {boolean} skipTimeValidation - Whether skip time validation is enabled
     * @param {string} planStartDate - Plan start date in YYYY-MM-DD format
     * @param {string} planEndDate - Plan end date in YYYY-MM-DD format
     * @param {boolean} longRoutes - Whether long routes (multi-day) is enabled
     * @returns {Object} Rest time visit object with windows
     */
    function createRestTimeVisit(restTime, vehicle, skipTimeValidation, planStartDate, planEndDate, longRoutes, plannerService, planStartTime) {
      // For midnight-crossing shifts on multi-day plans with skipTimeValidation, use the
      // vehicle's configured rest-time window instead of the saved optimizer placement.
      // Reason: restTime.startTime/endTime from a previous optimization is the exact slot
      // the optimizer chose, not the acceptable window — reusing it collapses re-optimizer
      // flexibility. Drag-and-drop preservation is still honored in all other scenarios.
      var planSpansMultipleDays = planStartDate && planEndDate && planStartDate !== planEndDate;
      var vehicleShiftCrossesMidnight = (plannerService && typeof plannerService._shiftCrossesMidnight === 'function')
        ? plannerService._shiftCrossesMidnight(vehicle.shift && vehicle.shift.start, vehicle.shift && vehicle.shift.end)
        : false;

      var windowStart;
      var windowEnd;
      if (planSpansMultipleDays && skipTimeValidation && vehicleShiftCrossesMidnight) {
        windowStart = vehicle.restTimeStart;
        windowEnd = vehicle.restTimeEnd;
      } else {
        // Existing behavior: preserve drag-and-drop and saved rest-time placement when available.
        // Note: restTime.startTime/endTime may be in extended format when longRoutes is enabled.
        windowStart = restTime.startTime || vehicle.restTimeStart;
        windowEnd = restTime.endTime || vehicle.restTimeEnd;
      }

      var windows = [];

      // Adjust rest time for extended format only when plan actually spans multiple days AND skipTimeValidation is enabled
      // For same-day plans, skip extended format adjustments even if longRoutes option is enabled
      if (planSpansMultipleDays && skipTimeValidation && windowStart && windowEnd) {
        // Get vehicle shift start for better day offset calculation
        var vehicleShiftStart = plannerService ? plannerService.getVehicleShiftTime(vehicle).start : null;
        // Construct planDate object from individual date parameters if available
        var planDateForRestTime = (planStartDate && planEndDate) ? { start: planStartDate, end: planEndDate } : null;
        var adjustedRestTimes = adjustRestTimeForExtendedFormat(
          windowStart,
          windowEnd,
          planDateForRestTime,
          planStartTime,
          vehicleShiftStart
        );
        windowStart = adjustedRestTimes.start;
        windowEnd = adjustedRestTimes.end;
      }

      // When skipTimeValidation is enabled AND plan spans multiple days, use adjustWindowTimesWithPlanDatesAndAcrossMidnight
      // to handle multiple windows when crossing midnight (same as visits)
      // For same-day plans, use simple window without adjustments
      if (planSpansMultipleDays && skipTimeValidation && windowStart && windowEnd && plannerService) {
        var adjustedTimes = plannerService.adjustWindowTimesWithPlanDatesAndAcrossMidnight({
          windowStart: windowStart,
          windowEnd: windowEnd,
          planStartDate: planStartDate,
          planEndDate: planEndDate,
          planStartTime: planStartTime
        });

        // Handle new windows array structure (multiple windows when crossing midnight)
        if (adjustedTimes.windows) {
          adjustedTimes.windows.forEach(function(window) {
            windows.push({
              window_start: window[0],
              window_end: window[1]
            });
          });
        } else {
          // Fallback for backward compatibility
          windows.push({
            window_start: adjustedTimes.windowStart,
            window_end: adjustedTimes.windowEnd
          });
        }
      } else {
        windows.push({
          window_start: windowStart,
          window_end: windowEnd
        });
      }

      return {
        id: REST_TIME,
        coordinates: restTime.lat.toString() + "," + restTime.lon.toString(),
        is_similar_to_next: false,
        programmed_date: null,
        service_time: restTime.serviceTime,
        windows: windows
      };
    }

    /**
     * Converts ISO datetime to extended time format (HH:mm with hours >= 24 for next day)
     * Only converts to extended format when longRoutes (multi-day) and skip_time_validation are both enabled
     * @param {string} isoDatetime - ISO datetime string (e.g., "2025-12-13T01:13")
     * @param {Object} planStartMoment - Moment object of plan start date
     * @param {boolean} longRoutes - Whether long routes (multi-day) is enabled
     * @param {boolean} skipTimeValidation - Whether skip time validation is enabled
     * @returns {string} Time in extended format (e.g., "25:13" for 01:13 on day after plan start) or standard HH:mm format
     */
    function convertIsoToExtendedTime(isoDatetime, planStartMoment, longRoutes, skipTimeValidation) {
      if (!isoDatetime) {
        return '00:00';
      }

      var eventMoment = moment(isoDatetime);
      if (!eventMoment.isValid()) {
        return '00:00';
      }

      var hours = eventMoment.hours();
      var minutes = eventMoment.minutes();

      // Use extended format only when longRoutes (multi-day) and skip_time_validation are both enabled
      if (longRoutes && skipTimeValidation) {
        // Calculate days difference from plan start
        if (planStartMoment) {
          var eventDay = moment(isoDatetime).startOf('day');
          var daysDiff = eventDay.diff(planStartMoment, 'days');
          if (daysDiff > 0) {
            hours += daysDiff * 24;
          }
        }

        var hoursStr = hours < 10 ? '0' + hours : hours.toString();
        var minutesStr = minutes < 10 ? '0' + minutes : minutes.toString();

        return hoursStr + ':' + minutesStr;
      } else {
        // Standard format: return HH:mm
        var hoursStr = hours < 10 ? '0' + hours : hours.toString();
        var minutesStr = minutes < 10 ? '0' + minutes : minutes.toString();

        return hoursStr + ':' + minutesStr;
      }
    }

    function processVTCAnswer(vehicle, plannerService) {
      return function (resp) {
        if (vehicle.routes.length < 1) {
          return;
        }
        var schedule = resp.data;
        var routeIndex = -1;
        var visitIndex = 0;

        // Filter routes that have visits - VTC only returns events for non-empty routes
        var routes = vehicle.routes.filter(function (route) { return route.visits.length > 0; });

        // Get plan start date for extended hour calculation
        var planDate = plannerService.getPlanDate();
        var planStartMoment = planDate ? moment(planDate.start).startOf('day') : null;

        // Determine if longRoutes (multi-day) and skip_time_validation are enabled
        var longRoutes = planDate && planDate.start && planDate.end
          ? !moment(planDate.start).isSame(moment(planDate.end), 'day')
          : false;
        var skipTimeValidation = getSkipTimeValidation(plannerService);
        var useExtendedFormat = longRoutes && skipTimeValidation;

        schedule.forEach(function (event, index) {
          if (event.visit === REST_TIME) {
            var currentRoute = routes[routeIndex];
            var newRestTime = angular.copy(plannerService.getRestTimeByRouteId(currentRoute.id));

            // Convert ISO datetime to extended time format only when conditions are met
            newRestTime.arrival = convertIsoToExtendedTime(event.eta, planStartMoment, longRoutes, skipTimeValidation);
            newRestTime.departure = convertIsoToExtendedTime(event.etd, planStartMoment, longRoutes, skipTimeValidation);

            // Calculate service time using extended time support only when conditions are met
            if (useExtendedFormat) {
              var arrivalMinutes = timeUtils.parseExtendedTimeToMinutes(newRestTime.arrival);
              var departureMinutes = timeUtils.parseExtendedTimeToMinutes(newRestTime.departure);
              newRestTime.serviceTime = departureMinutes - arrivalMinutes;
            } else {
              // Standard moment-based calculation
              var arrivalMoment = moment(newRestTime.arrival, 'HH:mm');
              var departureMoment = moment(newRestTime.departure, 'HH:mm');
              var timeDiffMs = departureMoment - arrivalMoment;

              // Handle midnight crossing
              if (timeDiffMs < 0) {
                newRestTime.serviceTime = moment.duration(timeDiffMs + (24 * 60 * 60 * 1000), 'milliseconds').asMinutes();
              } else {
                newRestTime.serviceTime = moment.duration(timeDiffMs, 'milliseconds').asMinutes();
              }
            }

            plannerService.setRestTimeByRouteId(currentRoute.id, newRestTime);
            currentRoute.estimatedTimeEnd = event.etd;
          } else if (event.type === "visit") {
            var currentRoute = routes[routeIndex];
            var currentVisit = currentRoute.visits[visitIndex];
            if (event.error) {
              currentVisit.timeError = true;
              currentRoute.timeError = true;
            } else {
              currentVisit.timeError = false;
            }
            currentVisit.estimatedTimeArrival = event.eta;
            currentVisit.estimatedTimeDeparture = event.etd;
            currentRoute.estimatedTimeEnd = event.etd;
            ++visitIndex;
          } else if (event.type === "depot_start") {
            ++routeIndex;
            visitIndex = 0;
            var currentRoute = routes[routeIndex];
            var depot_departure_time = (schedule[index + 1] && schedule[index + 1].type === 'wait') ? schedule[index + 1].etd : event.etd;
            currentRoute.timeError = false;
            currentRoute.estimatedTimeStart = depot_departure_time;
            currentRoute.estimatedTimeEnd = depot_departure_time;
            if (routeIndex > 0) {
              routes[routeIndex - 1].estimatedTimeEnd = event.eta;
              assignTotalTimes(routes[routeIndex - 1]);
            }
          } else if (event.type === "depot_end") {
            routes[routeIndex].estimatedTimeEnd = event.eta;
          }

          assignTotalTimes(routes[routeIndex]);
        });
      };
    }

    function callVTC(vehicle, optimizations, plannerService) {
      var hasRoutesWithVisits = vehicle.routes.some(function (route) { return route.visits.length > 0; });
      if (!hasRoutesWithVisits) {
        var deferred = $q.defer();
        deferred.resolve();
        return deferred.promise;
      }

      var body = createVTCBody(vehicle, optimizations, plannerService);

      return getSchedule(body, plannerService.isVehicularRestrictionEnabled())
        .then(processVTCAnswer(vehicle, plannerService));
    }

    function assignTotalTimes(route) {
      var diff = moment(route.estimatedTimeEnd) - moment(route.estimatedTimeStart);
      route.totalTime = timeUtils.formatDuration(diff);
      route.totalTimeFormatted = route.totalTime;
    }
  }

})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("visitSimilarService", visitSimilarService);

  var DAY_START_TIME = "00:00";
  var DAY_END_TIME = "23:59";

  /** @ngInject */
  function visitSimilarService(lodash) {
    return {
      VisitSimilarGraph: VisitSimilarGraph
    };

    /**
     * Returns a new standart visit object
     * @param {Object} visit visit object
     * @returns {Object} window time normalized in camelCase
     */
    function _normalizeWindows(visit) {
      var smallVisit = {};
      smallVisit.windowStart =
        visit.windowStart || visit.window_start || DAY_START_TIME;
      smallVisit.windowEnd =
        visit.windowEnd || visit.window_end || DAY_END_TIME;
      smallVisit.windowStart2 =
        visit.windowStart2 || visit.window_start_2 || DAY_END_TIME;
      smallVisit.windowEnd2 =
        visit.windowEnd2 || visit.window_end_2 || DAY_END_TIME;
      return smallVisit;
    }

    /**
     * Convert a visit to key
     * @param {Object} visit visit object
     * @returns {String} visit as key
     */
    function _convertVisitToKey(visit) {
      var normalizedNode = _normalizeWindows(visit);

      var address = visit.address || '';

      var skillAsString = (
        angular.isArray(visit.skills_required) ? visit.skills_required : []
      ).join(':');

      var visitLatitude = visit.latitude || 0;
      var visitLongitude = visit.longitude || 0;
      var coordinates = [visitLatitude, visitLongitude].join(',');

      return address +
        coordinates +
        skillAsString +
        normalizedNode.windowStart +
        normalizedNode.windowEnd +
        normalizedNode.windowStart2 +
        normalizedNode.windowEnd2;
    }

    /**
     * Check if visit has valid priorities
     * @param {Object} visit visit object
     * @returns {Boolean} true if visit has valid priorities
     */
    function _hasPriority(visit) {
      var validPriorities = [1, 2];

      var priorityLevelVisit = visit.hasOwnProperty('priority_level')
        ? visit.priority_level
        : visit.priorityLevel;

      return lodash.includes(validPriorities, priorityLevelVisit);
    }

    /**
     * @class Create a new graph to join similar visits.
     * @param {Object} options special options to calc of similar visits, it isn't required
     */
    function VisitSimilarGraph(options) {
      var self = this;

      this.options = {
        splitByPriority: false
      };

      if (angular.isObject(options)) {
        angular.merge(this.options, options);
      }

      this.graph = {
        keys: {},
        ids: {},
      };

      /**
       * Check if both visits are similar
       * @param {Object} visitA visit object
       * @param {Object} visitB visit object
       * @returns {Boolean} boolean response
       */
      this.isSimilar = function (visitA, visitB) {
        if (!visitA || !visitB) {
          return false;
        }

        var itsDiffVisits = visitA.id !== visitB.id;
        var keyVisitA = _convertVisitToKey(visitA);
        var keyVisitB = _convertVisitToKey(visitB);

        if (self.options.splitByPriority) {
          var notSplit = !Boolean(_hasPriority(visitA) && _hasPriority(visitB));
          return keyVisitA === keyVisitB && itsDiffVisits && notSplit;
        } else {
          return keyVisitA === keyVisitB && itsDiffVisits;
        }
      };

      /**
       * Added a new visit to graph
       * @param {Object} visit visit object
       * @returns instance
       */
      this.set = function (visit) {
        var id = visit.id;
        var key = _convertVisitToKey(visit);
        var nodesExistent = self.graph.keys[key];

        if (
          angular.isUndefined(nodesExistent) ||
          self.options.splitByPriority && _hasPriority(Object.values(nodesExistent)[0]) && _hasPriority(visit)
        ) {
          var nodes = {};
          nodes[id] = visit;
          self.graph.keys[key] = nodes;
          self.graph.ids[id] = nodes;
        }
        else {
          nodesExistent[id] = visit;
          self.graph.ids[id] = nodesExistent;
        }
        return self;
      };

      /**
       * Return an array with similar visits to the visit to will be compared.
       * @param {Object} visit visit object
       * @returns array with similar visits
       */
      this.getSimilar = function (visit) {
        if (!visit) {
          return [];
        }
        var nodes = self.graph.ids[visit.id];
        if (angular.isUndefined(nodes)) {
          return [];
        }
        return Object.values(nodes).filter(function (similar) {
          return similar.id !== visit.id;
        });
      };

      /**
       * Return an array filtered by routeId with similar visits to the visit to will be compared.
       * @param {Object} visit visit object
       * @returns array with similar visits
       */
      this.getSimilarByRoute = function (visit) {
        var nodes = self.getSimilar(visit);

        if (!nodes.length || !Boolean(visit.routeId)) {
          return nodes.filter(function (node) {
            return !Boolean(node.routeId);
          });
        }

        var nodesDic = nodes.reduce(function (dict, node) {
          if (node.routeId === visit.routeId) {
            dict[node.order] = node;
          }
          return dict;
        }, {});

        var visitSimilar = {};
        var pre = visit.order-1;
        var pos = visit.order+1;

        while (pre+pos >= -1) {
          if (pre >= 0 && nodesDic[pre]) {
            visitSimilar[pre] = nodesDic[pre];
            pre--;
          }
          else {
            pre = -1;
          }
          if (pos >= 0 && nodesDic[pos]) {
            visitSimilar[pos] = nodesDic[pos];
            pos++;
          }
          else {
            pos = -1;
          }
        }
        return Object.values(visitSimilar);
      };

      /**
       * Return an array with visits grouped by similar.
       * @param {Object} visit visit object
       * @returns array of groups
       */
      this.getVisitsGroupedBySimilar = function (visits) {
        var self = this;
        var similarNodes = {};
        return visits.reduce(function (acc, visit) {
          if (!similarNodes[visit.id]) {
            var group = [];
            var similarVisits = self.getSimilarByRoute(visit);
            similarNodes[visit.id] = true;
            group.push(visit);
            similarVisits.forEach(function (similarVisit) {
              similarNodes[similarVisit.id] = true;
              group.push(similarVisit);
            });
            acc.push(group);
          }
          return acc;
        }, []);
      };

      /**
       * Groups an array of visit objects into sub-arrays based on their similarity and consecutive order.
       * Visits that are considered similar (based on the `isSimilar` method) are grouped together,
       * but only if they are consecutive in the input array.
       *
       * This means that even if two visits are similar, they will only be grouped together if they appear
       * one after the other in the `visits` array. Visits that are similar but not consecutive
       * will be placed in separate groups.
       *
       * @param {Array} visits - An array of visit objects, each containing an 'order' field and other data.
       * @returns {Array} An array of grouped visits, where each group is an array of consecutive similar visit objects.
       */
      this.groupConsecutiveSimilarVisits = function (visits) {
        if (!visits || visits.length === 0) {
          return [];
        }

        var groupsOfSimilarVisits = [];
        var lastGroupOfSimilarVisits;
        for (var i = 0; i < visits.length; i++) {
          var visit = visits[i];
          if (i > 0 && this.isSimilar(visits[i - 1], visit)) {
            lastGroupOfSimilarVisits.push(visit);
          } else {
            lastGroupOfSimilarVisits = [visit];
            groupsOfSimilarVisits.push(lastGroupOfSimilarVisits);
          }
        }

        return groupsOfSimilarVisits;
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("visitFilterService", visitFilterService);

  /** @ngInject */
  function visitFilterService(timeUtils) {
    var TIME_FORMAT = "HH:mm";
    var DEFAULT_MIN_SLIDER_TIME = "00:00";
    var DEFAULT_MAX_SLIDER_TIME = "23:59";

    var handlerState = {
      activeFilter: false,
      minSliderTime: DEFAULT_MIN_SLIDER_TIME,
      maxSliderTime: DEFAULT_MAX_SLIDER_TIME,
      visits: [],
      setActiveFilter: function (isActive) {
        this.activeFilter = isActive;
      },
      setMinSliderTime: function (time) {
        this.minSliderTime = time;
      },
      setMaxSliderTime: function (time) {
        this.maxSliderTime = time;
      },
      setVisits: function (visits) {
        this.visits = visits;
      },
      clear: function () {
        this.setActiveFilter(false);
        this.setMinSliderTime(DEFAULT_MIN_SLIDER_TIME);
        this.setMaxSliderTime(DEFAULT_MAX_SLIDER_TIME);
        this.setVisits([]);
      },
    };

    var filters = {
      filterByTimeWindow: _filterByTimeWindow,
    };

    return {
      getHandlerState: getHandlerState,
      getFilters: getFilters,
    };

    function getHandlerState() {
      return handlerState;
    }

    function getFilters() {
      return filters;
    }

    //// Private methods ////

    function _filterByTimeWindow(visits, minSliderTime, maxSliderTime) {
      var minTime = timeUtils.createTime(minSliderTime, TIME_FORMAT);
      var maxTime = timeUtils.createTime(maxSliderTime, TIME_FORMAT);
      return visits.filter(function (visit) {
        return (
          _matchTimeWindowWithTimeRange(visit.windowStart, visit.windowEnd, minTime, maxTime) ||
          _matchTimeWindowWithTimeRange(visit.windowStart2, visit.windowEnd2, minTime, maxTime)
        );
      });
    }

    function _matchTimeWindowWithTimeRange(windowStart, windowEnd, minTime, maxTime) {
      if (!windowStart || !windowEnd || windowStart === windowEnd) {
        return false;
      }

      var windowStartTime = timeUtils.createTime(windowStart, TIME_FORMAT);
      var windowEndTime = timeUtils.createTime(windowEnd, TIME_FORMAT);
      return (
        timeUtils.isBetween(minTime, windowStartTime, windowEndTime) ||
        timeUtils.isBetween(windowStartTime, minTime, maxTime)
      );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('visitService', visitServiceFactory);

  /** @ngInject */
  function visitServiceFactory($http, __env, arrayHelperService, $q, VISIT_PICKUP_AND_DELIVERY_BATCH_SIZE) {
    var visitsUrl = __env.API_URL + 'routes/visits/';
    var RELATIONSHIPS_PROPERTIES_PATH = visitsUrl + 'relationships/properties';

    return {
      patchVisits: patchVisits,
      retrieveVisitsRelationship: retrieveVisitsRelationship
    };

    function patchVisits(visits) {
      return $http.patch(visitsUrl, visits)
        .then(function (response) {
          return response.data;
        });
    }

    /**
     * It takes an array of visit ids, splits it into batches of size
     * Then makes a request for each batch, and returns a promise that
     * resolves to an array of all the responses
     * @param visitIds - An array of visit ids
     * @returns An array of objects.
     */
    function retrieveVisitsRelationship(visitIds) {
      var visitIdsBatch = arrayHelperService.chunkArray(visitIds, VISIT_PICKUP_AND_DELIVERY_BATCH_SIZE);
      var requestPromises = visitIdsBatch.map(function (visitIdsList) {
        return $http.get(RELATIONSHIPS_PROPERTIES_PATH + '?visit_ids=' + visitIdsList);
      });
      return $q.all(requestPromises).then(function (responses) {
        var relationship = [];
        responses.forEach(function (response) {
          relationship = relationship.concat(response.data);
        });
        return relationship;
      });
    }
  }

})();

/* global tinycolor:false, tinycolor:false, google:false  */
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('PlannerVisitModel', PlannerVisitModel);

  /** @ngInject */
  function PlannerVisitModel($log, $http, __env, $q, $rootScope, moment,
                             $filter, googleService, visitsUtils, utilsService,
                             RELATIONSHIP_TYPE, visitsMarkersService, accountConfigsService,
                             ACCOUNT_CONFIGS, VISIT_GEOCODE_ALERT, VISIT_STATUS, VISIT_TYPE,
                             timeUtils) {

    var DEFAULT_DURATION = 10;
    var DEFAULT_COLOR = "#A4A4A4";

    function PlannerVisit(id) {
      // Backend properties

      this.backendId = null;
      this.plannedDate = null;
      this.programmedDate = null;
      this.title = '';
      this.address = '';
      this.latitude = null;
      this.longitude = null;
      this.hashValue = null;
      this.contactName = '';
      this.contactPhone = '';
      this.contactEmail = '';
      this.duration = DEFAULT_DURATION;
      this.notes = '';
      this.reference = '';
      this.load = null;
      this.load2 = null;
      this.load3 = null;
      this.load4 = null;
      this.priority = false;
      this.windowStart = null;
      this.windowEnd = null;
      this.windowStart2 = null;
      this.windowEnd2 = null;
      this.routeId = null;
      this.sourceRouteId = null;
      this.vehicle = null;
      this.numRoute = null;
      this.country = '';
      this.administrative_area = '';
      this.estimatedTimeArrival = null;
      this.estimatedTimeDeparture = null;
      this.skills_required = [];
      this.skills_optional = [];
      this.order = null;
      this.zIndex = 0;
      // Local properties
      // guid is required to send to optimizator
      this.id = id || utilsService.guid();
      this.options = {
        animation: 0,
        visible: true,
        draggable: false,
        icon: {
          url: '/assets/images/marker-with-label/rd_maker_A4A4A4.png',
          anchor: {x: 10, y: 31}
        },
      };
      this.error = null;
      this.status = 1;
      this.editMode = false;
      this.highlight = false;
      this.active = false;
      this.capacityError = false;
      this.capacityError2 = false;
      this.capacityError3 = false;
      this.capacityError4 = false;
      this.timeError = false;
      this.skillsError = false;
      this.maximumTimeError = false;
      this.maxVisitError = false;
      this.selected = false;
      this.defaultColor = '#A4A4A4';
      this.windowOneError = false;
      this.windowTwoError = false;
      this.OverlappingWindowError = false;
      this.checked = false;
      this.hover = false;
      this.priorityLevel = null;
      this.zones = [];
      this.pickLoad = 0;
      this.pickLoad2 = 0;
      this.pickLoad3 = 0;
      this.visitType = null;
      this.tags = [];
      this.addedInCurrentRouting = false;
      this.checkoutTime = null;
      this.properties = {
        delivery_type: RELATIONSHIP_TYPE.DELIVERY
      };
      this.relationships = {
        picks_from: []
      };
      this.geocodeAlert = null;
      this.items = [];
      this.addressStatistics = {
        status: '',
        last_latitude: null,
        last_longitude: null,
        was_location_changed: false
      };
      this.seller = null;
      this.frontend_stop_id = null;
      this.frontend_id = null;
      this.isReused = false;
      this.type = VISIT_TYPE.VISIT;
    }
    PlannerVisit.prototype.save = function (_backendRouteId, plannedDate) {

      if (angular.isUndefined(plannedDate)) {
        plannedDate = this.plannedDate;
      }

      var VISITS_PATH = __env.API_URL + 'routes/visits/';
      var requestData = {
        title: this.title,
        address: this.address,
        latitude: this.latitude.toFixed(6),
        longitude: this.longitude.toFixed(6),
        load: parseFloat(parseFloat(this.load).toFixed(2)),
        load_2: (this.load2) ? parseFloat(parseFloat(this.load2).toFixed(2)) : 0,
        load_3: (this.load3) ? parseFloat(parseFloat(this.load3).toFixed(2)) : 0,
        load_4: (this.load4) ? parseFloat(parseFloat(this.load4).toFixed(2)) : 0,
        window_start: (this.windowStart === "" || this.windowStart === null) ? '00:00' : this.windowStart,
        window_end: (this.windowEnd === "" || this.windowEnd === null) ? '23:59' : this.windowEnd,
        window_start_2: (this.windowStart2 === "" || this.windowStart2 === null) ? '23:59' : this.windowStart2,
        window_end_2: (this.windowEnd2 === "" || this.windowEnd2 === null) ? '23:59' : this.windowEnd2,
        duration: timeUtils.formatVisitDuration(timeUtils.parseVisitDuration(this.duration)),
        contact_name: this.contactName,
        contact_phone: this.contactPhone,
        contact_email: this.contactEmail,
        reference: this.reference,
        notes: this.notes,
        order: this.order,
        priority: this.priority,
        planned_date: moment(plannedDate).format('YYYY-MM-DD'),
        programmed_date: this.programmedDate,
        route: _backendRouteId,
        estimated_time_arrival: this.estimatedTimeArrival,
        estimated_time_departure: this.estimatedTimeDeparture,
        skills_optional: this.skills_optional,
        skills_required: this.skills_required,
        visitType: this.visitType,
        tags: this.tags,
        request_status: this.request_status,
        seller_id: this.seller ? this.seller.id : null
      };

      var self = this;
      if (angular.isUndefined(self.backendId) || self.backendId === null) {
        return $http.post(VISITS_PATH, requestData)
          .then(_successSavingVisit, _errorSavingVisit);
      } else {
        return $http.put(VISITS_PATH + self.backendId + '/', requestData)
          .then(_successSavingVisit, _errorSavingVisit);
      }

      function _successSavingVisit(response) {
        if (response) {
          self.backendId = response.data.id;
        }
      }

      function _errorSavingVisit(error) {
        $log.error(error);
        return $q.reject(error);
      }
    };

    PlannerVisit.prototype.setEditMode = function (editMode) {
      if (angular.isUndefined(editMode)) {
        this.editMode = true;
      } else {
        this.editMode = editMode;
      }

      if (this.editMode) {
        this.setHighlight(false, true);
        this.options.draggable = true;
        this.setVisible();
      } else {
        this.options.draggable = false;
        this.setVisible(false);
      }

    };

    PlannerVisit.prototype.setVisible = function (visible, markerHasToBeUpdated) {
      if (angular.isUndefined(visible)) {
        visible = true;
      }
      if (angular.isUndefined(markerHasToBeUpdated)) {
        markerHasToBeUpdated = true;
      }

      this.options.visible = visible;

      if (markerHasToBeUpdated) {
        this.actionUpdateLight();
      }
    };

    PlannerVisit.prototype.setHighlight = function (highlight, highlightIcon) {
      if (this.active) {
        return;
      }
      if (angular.isUndefined(highlightIcon)) {
        highlightIcon = false;
      }
      this.highlight = !!highlight;
      if (highlightIcon && !this.selected) {
        if (this.highlight) {
          this.options.icon.fillColor = tinycolor(this.defaultColor).darken(25).toString();
        } else {
          this.options.icon.fillColor = this.defaultColor;
        }
      }
    };

    PlannerVisit.prototype.setSelected = function (selected, selectIcon, executeUpdateAction) {
      if (angular.isUndefined(selectIcon)) {
        selectIcon = false;
      }
      if (angular.isUndefined(executeUpdateAction)) {
        executeUpdateAction = true;
      }
      this.selected = selected;
      if (selectIcon) {
        if (selected) {
          this.options.icon.fillColor = tinycolor(this.defaultColor).darken(30).toString();
        } else {
          this.options.icon.fillColor = this.defaultColor;
        }
        if (executeUpdateAction) {
          this.actionUpdate(this);
        }
      }
    };

    PlannerVisit.prototype.setDarkerHighlight = function (highlight, highlightIcon) {
      if (this.active) {
        return;
      }
      if (angular.isUndefined(highlightIcon)) {
        highlightIcon = false;
      }
      var self = this;
      this.highlight = !!highlight;
      if (highlightIcon && !this.selected) {
        if (this.highlight) {
          $rootScope.$broadcast('Planner:Highlight:Visit', {
            visit: self
          });
        } else {
          $rootScope.$broadcast('Planner:notHighlight:Visit', {
            visit: self
          });
        }
      }
    };

    PlannerVisit.prototype.setActive = function (active) {
      this.active = Boolean(active);
    };

    PlannerVisit.prototype.setPosition = function (lat, long) {
      if (angular.isUndefined(lat) || angular.isUndefined(long)) {
        return;
      }

      this.latitude = lat;
      this.longitude = long;

      this.actionUpdate(this);

    };

    PlannerVisit.prototype.setError = function (error) {
      if (angular.isUndefined(error)) {
        return;
      }

      this.error = error;
      switch (error.type) {
        case 2:
          this.options.icon.fillColor = '#FFCC33';
          this.setDefaultColor('#FFCC33');
          this.status = 2;
          break;
        case 3:
          this.options.icon.fillColor = '#e67e22';
          this.setDefaultColor('#e67e22');
          this.status = 3;
          break;
        case 4:
          this.setDefaultColor('#FF5252');
          this.options.icon.fillColor = '#FF5252';
          this.status = 4;
          break;
        default:
          this.options.icon.fillColor = this.defaultColor;
          this.status = 1;
      }
      this.actionUpdate(this);
    };

    PlannerVisit.prototype.removeError = function (defaultColor) {

      if (angular.isUndefined(defaultColor)) {
        defaultColor = DEFAULT_COLOR;
      }

      this.error = null;
      this.status = 1;
      this.setDefaultColor(defaultColor);
      this.setGeocodeAlert(null);
      this.actionUpdate(this);
    };

    PlannerVisit.prototype.removeIndicatorsErrors = function () {
      this.capacityError = false;
      this.capacityError2 = false;
      this.capacityError3 = false;
      this.capacityError4 = false;
      this.timeError = false;
      this.skillsError = false;
    };

    PlannerVisit.prototype.setOpacity = function (opacity, markerHasToBeUpdated) {
      if (angular.isUndefined(markerHasToBeUpdated)) {
        markerHasToBeUpdated = true;
      }
      this.options.icon.fillOpacity = opacity;

      if (markerHasToBeUpdated) {
        this.actionUpdateLight();
      }
    };

    PlannerVisit.prototype.setDefaultColor = function (color) {
      this.defaultColor = color;
      this.options.icon.fillColor = color;
      this.options.icon.strokeColor = tinycolor(color).darken(15).toString();
    };

    PlannerVisit.prototype.setAlert = function (alertType) {
      switch (alertType) {
        case VISIT_GEOCODE_ALERT.ERROR_DISTANCE:
          this.status = VISIT_STATUS.STATUS_ERROR;
          this.error = {
            type: VISIT_STATUS.STATUS_ERROR,
            msg: $filter('translate')('Visits.alert_notification.error_distance')
          };
          this.procureVisitStatus();
          break;
        case VISIT_GEOCODE_ALERT.ERROR_COUNTRY:
          this.status = VISIT_STATUS.STATUS_ERROR;
          this.error = {
            type: VISIT_STATUS.STATUS_ERROR,
            msg: $filter('translate')('Visits.alert_notification.error_country')
          };
          this.procureVisitStatus();
          break;
        case VISIT_GEOCODE_ALERT.ERROR_WRONG_AREA:
          this.status = VISIT_STATUS.STATUS_WARNING_YELLOW;
          this.error = {
            type: VISIT_STATUS.STATUS_WARNING_YELLOW,
            msg: $filter('translate')('Visits.alert_notification.error_wrong_area')
          };
          this.procureVisitStatus();
          break;
        case VISIT_GEOCODE_ALERT.ERROR_AREA_CENTER:
          this.status = VISIT_STATUS.STATUS_WARNING_ORANGE;
          this.error = {
            type: VISIT_STATUS.STATUS_WARNING_ORANGE,
            msg: $filter('translate')('Visits.alert_notification.error_area_center')
          };
          this.procureVisitStatus();
          break;
        case VISIT_GEOCODE_ALERT.ERROR_HIGH:
          this.status = VISIT_STATUS.STATUS_ERROR;
          this.setGeocodeAlert(VISIT_GEOCODE_ALERT.ERROR_HIGH);
          this.error = {
            type: VISIT_STATUS.STATUS_ERROR,
            msg: $filter('translate')('Visits.new_alert_notification.alert_high')
          };
          this.procureVisitStatus();
          break;
        case VISIT_GEOCODE_ALERT.ERROR_MEDIUM:
          this.status = VISIT_STATUS.STATUS_WARNING_ORANGE;
          this.setGeocodeAlert(VISIT_GEOCODE_ALERT.ERROR_MEDIUM);
          this.error = {
            type: VISIT_STATUS.STATUS_WARNING_ORANGE,
            msg: $filter('translate')('Visits.new_alert_notification.alert_medium')
          };
          this.procureVisitStatus();
          break;
        case VISIT_GEOCODE_ALERT.ERROR_LOW:
          this.status = VISIT_STATUS.STATUS_WARNING_YELLOW;
          this.setGeocodeAlert(VISIT_GEOCODE_ALERT.ERROR_LOW);
          this.error = {
            type: VISIT_STATUS.STATUS_WARNING_YELLOW,
            msg: $filter('translate')('Visits.new_alert_notification.alert_low')
          };
          this.procureVisitStatus();
          break;
        default:
          this.status = VISIT_STATUS.STATUS_OK;
          this.error = null;
          this.procureVisitStatus();
          break;
      }
    };

    PlannerVisit.prototype.procureVisitStatus = function () {
      var status = this.status;
      switch (status) {
        case 2:
          this.setDefaultColor('#FFCC33');
          break;
        case 3:
          this.options.icon.fillColor = '#e67e22';
          this.setDefaultColor('#e67e22');
          break;
        case 4:
          this.setDefaultColor('#FF5252');
          break;
        default:
          this.setDefaultColor(DEFAULT_COLOR);
          this.status = VISIT_STATUS.STATUS_OK;
      }
    };

    PlannerVisit.prototype.setOriginalIconColor = function () {
      var status = this.status;
      switch (status) {
        case 2:
          this.setIconFillColor('#FFCC33');
          break;
        case 3:
          this.options.icon.fillColor = '#e67e22';
          this.setDefaultColor('#e67e22');
          break;
        case 4:
          this.setIconFillColor('#FF5252');
          break;
        default:
          this.setIconFillColor(this.defaultColor);
          this.status = VISIT_STATUS.STATUS_OK;
      }
    };

    PlannerVisit.prototype.setIconFillColor = function (color, markerHasToBeUpdated) {
      if (angular.isUndefined(markerHasToBeUpdated)) {
        markerHasToBeUpdated = true;
      }
      this.options.icon.fillColor = color;
      this.options.icon.strokeColor = tinycolor(color).darken(15).toString();

      if (markerHasToBeUpdated) {
        this.actionUpdateLight();
      }
    };

    PlannerVisit.prototype.setLabelContent = function (content, markerHasToBeUpdated) {
      if (angular.isUndefined(markerHasToBeUpdated)) {
        markerHasToBeUpdated = true;
      }
      this.options.labelContent = content || '';
      this.options.labelClass = (content !== null && content !== '') ? 'marker_labels' : 'marker_labels-empty';
      var strlen = this.options.labelContent.toString().length;
      switch (strlen) {
        case 1:
          this.options.labelAnchor = googleService.createPoint(-1, 27);
          break;
        case 2:
          this.options.labelAnchor = googleService.createPoint(2, 27);
          break;
        case 3:
          this.options.labelAnchor = googleService.createPoint(4, 27);
          break;
        default:
          this.options.labelAnchor = googleService.createPoint(-1, 27);
      }

      if($rootScope.isHighDemandRouteDesigner && markerHasToBeUpdated) {
        this.actionUpdateLight();
      }
    };

    PlannerVisit.prototype.updateOrder = function (order, markerHasToBeUpdated) {
      var updateVisit =  this.order !== order;
      this.order = order;
      this.setLabelContent(this.order, markerHasToBeUpdated);
      if (updateVisit) {
        $rootScope.$broadcast("Planner:Visit:EditMarker", {
          visit: this
        });
      }
    };

    PlannerVisit.prototype.setGeocodeAlert = function (geocodeAlert) {
      this.geocodeAlert = geocodeAlert;
    };

    PlannerVisit.prototype.getGeocodeAlert = function () {
      return this.geocodeAlert;
    };

    PlannerVisit.prototype.getPriority = function () {
      var priority = 0;
      if(this.priorityLevel !== null) {
        if(this.priorityLevel >= 0 && this.priorityLevel <= 12) {
          priority = this.priorityLevel;
        }
      } else {
        if (this.priority === 1 || this.priority === true) {
          priority = 1;
        }
      }
      return priority;
    };

    PlannerVisit.prototype.getCPriority = function () {
      var priority = false;
      switch (this.priority) {
        case 1:
          priority = true;
          break;
        case true:
          priority = true;
          break;
        default:
          priority = false;
      }
      return priority;
    };

    //map manager
    PlannerVisit.prototype.actionCreate = function (visit) {
      $rootScope.$broadcast("Planner:Visit:Create", {
        visit: visit
      });
    };

    PlannerVisit.prototype.actionUpdate = function (visit) {
      $rootScope.$broadcast("Planner:Visit:Update", {
        visit: visit
      });
    };

    PlannerVisit.prototype.actionUpdateLight = function (mustOverrideIcon) {
      $rootScope.$broadcast("Planner:Visit:CreateOrUpdateMarkerLight", {
        visit: this,
        mustOverrideIcon: mustOverrideIcon
      });
    };

    PlannerVisit.prototype.actionRemove = function (visit) {
      $rootScope.$broadcast("Planner:Visit:Remove", {
        visit: visit
      });
    };

    PlannerVisit.prototype.actionPaintOnMap = function () {
      var self = this;
      self.options.visible = true;
      $rootScope.$broadcast("Planner:Visit:Create", {
        visit: self
      });
    };

    PlannerVisit.prototype.updateLocation = function (marker) {
      var visit = this, newPosition = {};
      var geocoder = new google.maps.Geocoder();
      newPosition = marker.latLng;
      var requestData = {location: newPosition};
      geocoder.geocode(requestData, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            $rootScope.$broadcast("Planner:Visits:resetValidFormCoords");
            visit.latitude = newPosition.lat();
            visit.longitude = newPosition.lng();
            visit.address = results[0].formatted_address;
            visit.actionUpdate(visit);
            $rootScope.$apply();
          } else {
            $log.error('No reverse geocode results found', requestData);
          }
        } else {
          $log.error(status, requestData);
        }
      });
    };

    PlannerVisit.prototype.areValidVisitWindowTimes = function () {
      this.windowOneError = false;
      this.windowTwoError = false;
      this.OverlappingWindowError = false;

      var areValid = true;
      var momentWindowStart = this.windowStart ? moment(this.windowStart, 'HH:mm') : null;
      var momentWindowEnd = this.windowEnd ? moment(this.windowEnd, 'HH:mm') : null;
      var momentWindowStart2 = this.windowStart2 ? moment(this.windowStart2, 'HH:mm') : null;
      var momentWindowEnd2 = this.windowEnd2 ? moment(this.windowEnd2, 'HH:mm') : null;

      //check if window_start > window_end
      if (this.windowStart && this.windowEnd && (momentWindowStart.isAfter(momentWindowEnd))) {
        this.windowOneError = true;
        this.status = 4;
        this.error = {
          type: 4,
          msg: $filter('translate')('Visits.alert_notification.error_window')
        };
        areValid = false;
      } else if (this.windowStart2 && this.windowEnd2 && (momentWindowStart2.isAfter(momentWindowEnd2))) {
        this.windowTwoError = true;
        this.status = 4;
        this.error = {
          type: 4,
          msg: $filter('translate')('Visits.alert_notification.error_window')
        };
        areValid = false;

      }else if (this.windowStart && this.windowEnd && this.windowStart2 && this.windowEnd2
        && (momentWindowEnd.isAfter(momentWindowStart2))) {
        this.OverlappingWindowError = true;
        this.status = 4;
        this.error = {
          type: 4,
          msg: $filter('translate')('Visits.alert_notification.error_window')
        };
        areValid = false;

      }else if((this.windowStart || this.windowEnd) && (this.windowStart2 || this.windowEnd2) &&
        !(this.windowStart && this.windowEnd && this.windowStart2 && this.windowEnd2) &&
        !((!this.windowStart && this.windowEnd && this.windowStart2 && !this.windowEnd2) ||
        (this.windowStart && this.windowEnd && this.windowStart2 && !this.windowEnd2) ||
        (!this.windowStart && this.windowEnd && this.windowStart2 && this.windowEnd2))) {
        this.OverlappingWindowError = true;
        this.status = 4;
        this.error = {
          type: 4,
          msg: $filter('translate')('Visits.alert_notification.error_window')
        };
        areValid = false;
      }

      return areValid;
    };

    PlannerVisit.prototype.adjustToTimeWindow = function () {
      var estimatedTimes = utilsService.getEstimatedTimesAsDateTime(
        this.plannedDate, this.estimatedTimeArrival, this.estimatedTimeDeparture
      );

      this.timeError = false;
      this.estimatedTimeArrival = estimatedTimes.start;
      this.estimatedTimeDeparture = estimatedTimes.end;

      if (!this.windowStart && !this.windowEnd && !this.windowStart2 && !this.windowEnd2) {
        return;
      }

      var isWithinTimeWindow = false;
      var window = null;
      var windows = [
        { 'start': this.windowStart, 'end': this.windowEnd },
        { 'start': this.windowStart2, 'end': this.windowEnd2 }
      ];

      for (var index in windows) {
        window = windows[index];

        if (window.start && window.end && window.start !== window.end) {
          isWithinTimeWindow = visitsUtils.isWithinTimeWindow(
            window.start, window.end, this.estimatedTimeArrival
          );

          if (isWithinTimeWindow) {
            return;
          }
        }
      }

      this.timeError = true;
    };

    PlannerVisit.prototype.isVisible = function() {
      return this.options.visible;
    };

    PlannerVisit.prototype.getIconAsImage = function (is32Pixel) {
      if (is32Pixel) {
        return {
          url: visitsMarkersService.getImagesMarkerPath() + this.options.icon.fillColor.replace('#', '') + '-32.png',
          size: googleService.createMapSize(32, 32),
          anchor: googleService.createPoint(16, 32),
          origin: googleService.createPoint(0, 0)
        };
      }

      var isBigMarkerInRouteDesignerEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_BIG_MARKER_IN_ROUTE_DESIGNER);
      return {
        url: visitsMarkersService.getImagesMarkerPath() + this.options.icon.fillColor.replace('#', '') + '.png',
        size: isBigMarkerInRouteDesignerEnabled ? googleService.createMapSize(24, 34) : googleService.createMapSize(17, 17),
        anchor: isBigMarkerInRouteDesignerEnabled ? googleService.createPoint(10, 30) : googleService.createPoint(8, 16),
        origin: googleService.createPoint(0, 0)
      };
    };

    PlannerVisit.prototype.setAddedInCurrentRouting = function(isAddedInCurrentRouting) {
      this.addedInCurrentRouting = isAddedInCurrentRouting;
    };

    PlannerVisit.prototype.setMaximumTimeError = function (isError) {
      this.maximumTimeError = isError;
    };

    PlannerVisit.prototype.setMaxVisitError = function (isError) {
      this.maxVisitError = isError;
    };

    /**
     * Validates visit window times with support for overnight windows
     */
    PlannerVisit.prototype.areValidVisitWindowTimesWithOvernightSupport = function () {
      return visitsUtils.areValidVisitWindowTimesWithOvernightSupport(this);
    };

    return PlannerVisit;
  }

})();

(function () {
  angular
    .module('icarus.planner')
    .factory('visitTypeService', visitTypeServiceFactory);

  /** @ngInject */
  function visitTypeServiceFactory($http, __env) {
    var visitTypesUrl = __env.API_URL + 'accounts/visit-types/';
    return {
      'getVisitTypes': getVisitTypes
    };

    function getVisitTypes() {
      return $http.get(visitTypesUrl)
        .then(function (response) {
          return response.data;
        });
    }
  }

})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("visitListFilterService", visitListFilterService);

  /** @ngInject */
  function visitListFilterService(
    GLOBAL_INSENSITIVE_CASE,
    FILTER_ADDRESS_ATTR,
    FILTER_TITLE_ATTR,
    FILTER_REFERENCE_ATTR
  ) {

    var service = {};
    var searchData = {};

    /**
     * Escape all the special characters in a string so that it can be used in a regular expression.
     * @param string - The string to be escaped.
     * @returns a string with all the characters that are special to regular expressions escaped.
     */
    function escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    service.filterStatusHandler = {
      visits: {},
      activeFilter: false,
      matchedValue: null,
      clear: function () {
        this.matchedValue = null;
        this.visits = {};
        this.activeFilter = false;
      },
      removeVisit: function (visitId) {
        delete this.visits[visitId];
      }
    };

    service.filters = {
      title: _generate_visits_filter_object(FILTER_TITLE_ATTR),
      reference: _generate_visits_filter_object(FILTER_REFERENCE_ATTR),
      address: _generate_visits_filter_object(FILTER_ADDRESS_ATTR)
    };

    service.applyResultToVM = function (result) {
      service.filterStatusHandler.clear();
      service.filterStatusHandler.activeFilter = true;
      service.filterStatusHandler.matchedValue = result.matchedValue;

      result.elements.forEach(function (visit) {
        service.filterStatusHandler.visits[visit.id] = visit;
      });
    };

    service.removeResultFromVM = function () {
      service.filterStatusHandler.clear();
    };

    service.getSearchDataBinding = function (visits) {
      searchData = {};
      Object.defineProperty(searchData, "visits", {
        get: function () {
          return visits;
        },
      });
      return searchData;
    };

    service.setMatchValue = function (value) {
      service.filterStatusHandler.matchedValue = value;
    };

    service.getMatchValue = function () {
      return service.filterStatusHandler.matchedValue;
    };

    function _generate_visits_filter_object(visitAttr) {
      return {
        title: visitAttr,
        filter: function (data, pattern) {
          var regex = new RegExp(escapeRegExp(pattern), GLOBAL_INSENSITIVE_CASE);
          return data.visits.filter(function (visit) {
            return visit[visitAttr].match(regex);
          });
        },
        attrShowed: visitAttr,
      };
    }

    return service;
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("vehicleTypeUtils", vehicleTypeUtils);

  /** @ngInject */
  function vehicleTypeUtils(VEHICLE_TYPE) {
    return {
      shouldAddVehicleType: shouldAddVehicleType,
      getVehicleType: getVehicleType,
    };

    function shouldAddVehicleType(optimizationOptions) {
      return (
        optimizationOptions.vehicle_type ||
        optimizationOptions.enable_aircraft_routing
      );
    }

    function getVehicleType(optimizationOptions) {
      if (optimizationOptions.on_foot) {
        return VEHICLE_TYPE.FOOT;
      }

      if (optimizationOptions.enable_aircraft_routing) {
        return VEHICLE_TYPE.HELICOPTER;
      }

      return VEHICLE_TYPE.CAR;
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("vehicleAvailabilityService", vehicleAvailabilityService);

  /** @ngInject */
  function vehicleAvailabilityService($http, __env, plannerService, timeUtils, moment, $filter, VEHICLE_AVAILABILITY_STATUS) {

    var $translate = $filter("translate");

    return {
      getAvailability: getAvailability,
      setAvailability: setAvailability,
      shouldDisplayAvailableVehicleData: shouldDisplayAvailableVehicleData,
      shouldDisplayPartiallyAvailableVehicleData: shouldDisplayPartiallyAvailableVehicleData,
      shouldDisplayUnavailableVehicleData: shouldDisplayUnavailableVehicleData,
      shouldDisplayVehicleWithExpiredDocumentsData: shouldDisplayVehicleWithExpiredDocumentsData,
      shouldDisplayBlockedVehicleData: shouldDisplayBlockedVehicleData,
      isThereAnyVehicleUnavailable: isThereAnyVehicleUnavailable
    };


    /**
     * Retrieves the availability information of vehicles.
     *
     * @returns {Promise<Object<number, VehicleAvailability>>}
     *
     * The function retrieves the availability information of vehicles from the server. The response
     * data is an object where each key represents the ID of a vehicle, and the corresponding value is
     * an object containing the availability details of that vehicle, including whether it is available,
     * its status, busy time (if any), events, and expired documents.
     */

    /**
     * Represents the availability information of vehicles.
     *
     * @typedef {Object} VehicleAvailability
     * @property {boolean} available - Indicates whether the vehicle is available.
     * @property {BusyTime} busy_time - The time period during which the vehicle is busy, if any.
     * @property {string} status - The status of the vehicle, e.g., "AVAILABLE", "PARTIALLY_AVAILABLE", etc.
     * @property {Array} events - An array of events associated with the vehicle.
     * @property {Array} expired_documents - An array of expired documents associated with the vehicle.
     */

    /**
     * Represents the busy time period of a vehicle.
     *
     * @typedef {Object} BusyTime
     * @property {string|null} start - The start time of the busy period, or null if not busy.
     * @property {string|null} end - The end time of the busy period, or null if not busy.
     */

    function getAvailability(enableOrganizationSyncService) {
      var timezoneOffset = moment().utcOffset();
      var planDate = plannerService.getPlanDate();
      var planShift = plannerService.getShift();
      var startParameter = timeUtils.convertUnixTimeToTimezone(
        timeUtils.getUnixTime(planDate.start + " " + planShift.start), timezoneOffset);
      var endParameter = timeUtils.convertUnixTimeToTimezone(
        timeUtils.getUnixTime(planDate.end + " " + planShift.end), timezoneOffset);
      var queryParameters = {
        params: {
          start: startParameter,
          end: endParameter,
          fleet: plannerService.getFleetId(),
          plan_id: plannerService.getPlanId()
        }
      };

      return $http.get(_getVehiclesStatusPath(enableOrganizationSyncService), queryParameters);
    }

    function setAvailability(vehicle, availabilityInfo, isMultiDay, enableOrganizationSyncService) {
      var countOfExpiredDocuments = availabilityInfo.expired_documents.length;
      var vehicleAvailability = vehicle.availability;

      vehicleAvailability.isAvailable = availabilityInfo.available;
      vehicleAvailability.isPartiallyAvailable = (availabilityInfo.status === VEHICLE_AVAILABILITY_STATUS.PARTIAL_AVAILABILITY);
      vehicleAvailability.isBlocked = (availabilityInfo.status === VEHICLE_AVAILABILITY_STATUS.BLOCKED);
      vehicleAvailability.hasExpiredDocuments = countOfExpiredDocuments > 0;

      if (vehicleAvailability.isBlocked) {
        _setBlockedVehicle(vehicleAvailability);
      } else if (vehicleAvailability.isAvailable && !vehicleAvailability.isPartiallyAvailable) {
        _setAvailableVehicle(vehicleAvailability, vehicle, countOfExpiredDocuments);
      } else if (vehicleAvailability.isAvailable && vehicleAvailability.isPartiallyAvailable) {
        if (enableOrganizationSyncService) {
          vehicleAvailability.isAvailable = false;
          _setUnavailableVehicle(vehicleAvailability, availabilityInfo.busy_time, isMultiDay, countOfExpiredDocuments);
        } else {
          _setPartiallyAvailableVehicle(vehicleAvailability, vehicle, availabilityInfo.busy_time, isMultiDay, countOfExpiredDocuments);
        }
      } else {
        _setUnavailableVehicle(vehicleAvailability, availabilityInfo.busy_time, isMultiDay, countOfExpiredDocuments);
      }

      vehicleAvailability.finalMessage = vehicleAvailability.messages.join("\n");
      _setVehicleEvents(availabilityInfo, vehicle);
    }

    function shouldDisplayAvailableVehicleData(vehicleAvailability) {
      return (
        vehicleAvailability.isAvailable &&
        !vehicleAvailability.isPartiallyAvailable &&
        !vehicleAvailability.hasExpiredDocuments
      );
    }

    function shouldDisplayPartiallyAvailableVehicleData(vehicleAvailability) {
      return (
        vehicleAvailability.isAvailable &&
        vehicleAvailability.isPartiallyAvailable &&
        !vehicleAvailability.hasExpiredDocuments
      );
    }

    function shouldDisplayUnavailableVehicleData(vehicleAvailability) {
      return (
        !vehicleAvailability.isAvailable &&
        !vehicleAvailability.hasExpiredDocuments &&
        !vehicleAvailability.isBlocked
      );
    }

    function shouldDisplayVehicleWithExpiredDocumentsData(vehicleAvailability) {
      return vehicleAvailability.hasExpiredDocuments && !vehicleAvailability.isBlocked;
    }

    function shouldDisplayBlockedVehicleData(vehicleAvailability) {
      return vehicleAvailability.isBlocked;
    }

    function isThereAnyVehicleUnavailable(vehiclesResponse, vehicleIdsWithRoutes) {
      for (var i = 0; i < vehicleIdsWithRoutes.length; i++) {
        var id = vehicleIdsWithRoutes[i];
        var vehicle = vehiclesResponse[id];

        if (!vehicle) {
          continue;
        }

        var isUnavailable = (
          !vehicle.available ||
          vehicle.status === VEHICLE_AVAILABILITY_STATUS.BLOCKED ||
          vehicle.status === VEHICLE_AVAILABILITY_STATUS.PARTIAL_AVAILABILITY
        );

        if (isUnavailable) {
          return true;
        }
      }

      return false;
    }

    // Private methods //

    function _formatVehicleTime(dateTime, isMultiDay) {
      if (!isMultiDay) {
        return dateTime.format("LT");
      }

      return dateTime.format("L") + " " + dateTime.format("LT");
    }

    function _getTextFromUnavailableVehicle(busyTime, isMultiDay) {
      var start = moment(busyTime.start);
      var end = moment(busyTime.end);
      return (
        $translate("Vehicles.notAvailable.message1") + " " + _formatVehicleTime(start, isMultiDay) + " " +
        $translate("Vehicles.notAvailable.message2") + " " + _formatVehicleTime(end, isMultiDay)
      );
    }

    function _getTextFromExpiredDocuments(countOfExpiredDocuments) {
      if (countOfExpiredDocuments === 1) {
        return $translate("Vehicles.expired_documents_singular");
      }

      return $translate("Vehicles.expired_documents_plural", { countOfExpiredDocuments: countOfExpiredDocuments });
    }

    function _setBlockedVehicle(vehicleAvailability) {
      vehicleAvailability.isAvailable = false;
      vehicleAvailability.messages = [$translate("Vehicles.blocked")];
    }

    function _setAvailableVehicle(vehicleAvailability, vehicle, countOfExpiredDocuments) {
      vehicleAvailability.messages = [$translate("Vehicles.available.default")];
      if (!vehicle.isShiftTemporarilyEdited && plannerService.wasInitialShiftChanged()) {
        vehicle.shift.start = vehicle.shiftDefault.start || vehicle.shift.start;
        vehicle.shift.end = vehicle.shiftDefault.end || vehicle.shift.end;
      }

      if (vehicleAvailability.hasExpiredDocuments) {
        vehicleAvailability.messages = [_getTextFromExpiredDocuments(countOfExpiredDocuments)];
      }
    }

    function _setPartiallyAvailableVehicle(vehicleAvailability, vehicle, busyTime, isMultiDay, countOfExpiredDocuments) {
      var availableFrom = moment(busyTime.end).add(vehicle.refill, "minutes");
      var message = $filter("translate")("Vehicles.partiallyAvailable") + " " + _formatVehicleTime(availableFrom, isMultiDay);
      vehicleAvailability.messages = [message];
      if (!vehicle.isShiftTemporarilyEdited && plannerService.wasInitialShiftChanged()) {
        var planDate = plannerService.getPlanDate();
        var vehicleShiftEnd = moment(moment(planDate.end).format("YYYY-MM-DD") + " " + vehicle.shift.end);
        if (isMultiDay || availableFrom.isAfter(vehicleShiftEnd)) {
          vehicleAvailability.isAvailable = false;
          vehicleAvailability.isPartiallyAvailable = false;
          vehicleAvailability.messages = [_getTextFromUnavailableVehicle(busyTime, isMultiDay)];
        } else {
          vehicle.shift.start = availableFrom.format("HH:mm");
        }
      }

      if (vehicleAvailability.hasExpiredDocuments) {
        vehicleAvailability.messages.push(_getTextFromExpiredDocuments(countOfExpiredDocuments));
      }
    }

    function _setUnavailableVehicle(vehicleAvailability, busyTime, isMultiDay, countOfExpiredDocuments) {
      vehicleAvailability.messages = [_getTextFromUnavailableVehicle(busyTime, isMultiDay)];
      if (vehicleAvailability.hasExpiredDocuments) {
        vehicleAvailability.messages.push(_getTextFromExpiredDocuments(countOfExpiredDocuments));
      }
    }

    function _setVehicleEvents(availabilityInfo, vehicle) {
      var hasRestTimeEvent = false;
      availabilityInfo.events.forEach(function (event) {
        if (event.type === "rest_time") {
          hasRestTimeEvent = true;
          vehicle.restTimeStartDefault = vehicle.restTimeStart || vehicle.restTimeStartDefault;
          vehicle.restTimeEndDefault = vehicle.restTimeEnd || vehicle.restTimeEndDefault;
          vehicle.restTimeDurationDefault = vehicle.restTimeDuration || vehicle.restTimeDurationDefault;
          vehicle.restTimeStart = null;
          vehicle.restTimeEnd = null;
          vehicle.restTimeDuration = null;
        }
      });

      if (!hasRestTimeEvent) {
        if (vehicle.restTimeStartDefault && vehicle.restTimeEndDefault && vehicle.restTimeDurationDefault) {
          vehicle.restTimeStart = vehicle.restTimeStartDefault;
          vehicle.restTimeEnd = vehicle.restTimeEndDefault;
          vehicle.restTimeDuration = vehicle.restTimeDurationDefault;
        }
      }
    }

    function _getVehiclesStatusPath(enableOrganizationSyncService) {
      if (enableOrganizationSyncService) {
        return __env.API_URL + "aggregation/vehicles/organization/status/";
      }

      return __env.API_URL + "aggregation/vehicles/status/";
    }
   }
})();

/* global google:false, ConvexHullGrahamScan:false */
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('PlannerVehicleModel', PlannerVehicleModel);

  /** @ngInject */

  function PlannerVehicleModel(PlannerRouteModel, __env, $log, $q, moment, $rootScope, googleService,
                               $filter, vtcService, lodash, timeUtils, RELATIONSHIP_TYPE, visitsMarkersService,
                               revisedRoutesService, DATE_TIME_FORMAT) {

    var MILLISECONDS_PER_MINUTE = 60000;

    function PlannerVehicle(id) {

      if (!id) {
        throw new Error('PlannerVehicleModel: id required');
      } else if (typeof id !== 'string') {
        throw new Error('PlannerVehicleModel: id should be a string');
      }
      // Backend properties
      this.backendId = id;
      this.name = null;
      this.initials = '';
      this.capacity = null;
      this.capacity2 = null;
      this.capacity3 = null;
      this.capacity4 = null;
      this.driver = null;
      this.driverId = null;
      this.licensePlate = null;
      this.typeLoad = null;
      this.locationStart = {
        address: null,
        latitude: null,
        longitude: null
      };
      this.locationEnd = {
        address: null,
        latitude: null,
        longitude: null
      };
      this.skills = [];
      this.color = null;
      this.colorDarker = null;
      // Local properties
      this.id = id;
      this.locationStartMarker = null;
      this.locationEndMarker = null;
      this.shift = {
        start: null,
        end: null
      };
      this.shiftDefault = {
        start: null,
        end: null,
        maximumTime: null,
        formattedMaximumTime: ""
      };
      this.active = false;
      this.enabled = true;
      this.routes = [];
      this.refill = 0;
      this.options = {
        draggable: false,
        visible: false,
        icon: {
          path: 'M16,2.057c-5.633,0-10.215,4.582-10.215,10.214c0,5.39,9.1,16.896,9.486,17.383,c0.176,0.223,0.445,0.352,0.729,0.352s0.553-0.129,0.729-0.352c0.388-0.487,9.486-11.993,9.486-17.383,C26.215,6.639,21.632,2.057,16,2.057z',
          fillColor: '#41D3BD',
          fillOpacity: 1,
          strokeWeight: 0,
          anchor: {x: 8, y: 5} //new google.maps.Point(10, 18)
        }
      };
      this.optionsEnd = {
        draggable: false,
        visible: false,
        icon: {
          path: 'M16,2.057c-5.633,0-10.215,4.582-10.215,10.214c0,5.39,9.1,16.896,9.486,17.383,c0.176,0.223,0.445,0.352,0.729,0.352s0.553-0.129,0.729-0.352c0.388-0.487,9.486-11.993,9.486-17.383,C26.215,6.639,21.632,2.057,16,2.057z',
          fillColor: '#41D3BD',
          fillOpacity: 1,
          strokeWeight: 0,
          anchor: {x: 9, y: 5} //new google.maps.Point(10, 31)
        }
      };
      this.availability = {
        messages: [],
        finalMessage: "",
        isAvailable: true,
        isPartiallyAvailable: false,
        isBlocked: false,
        hasExpiredDocuments: false
      };
      this.showRoutes = true;
      this.maxVisit = null;
      this.minLoad = 0;
      this.minLoad2 = 0;
      this.minLoad3 = 0;
      this.rest_time_start = null;
      this.rest_time_end = null;
      this.rest_time_duration = null;
      this.restTimeStart = null;
      this.restTimeEnd = null;
      this.restTimeDuration = null;
      this.restTimeStartDefault = null;
      this.restTimeEndDefault = null;
      this.restTimeDurationDefault = null;
      this.maximumTimeError = false;
      this.codrivers = [];
      this.isShiftTemporarilyEdited = false;
      this.areAllRoutesRevised = false;
      this.modified = null;
      this.actionCreate(this);
      this.hasRoutesProccessed = false;
      this.referenceId = null;
      this.max_number_of_routes = null;
      this.max_route_distance = null;
    }

    PlannerVehicle.getShiftDefault = function(shiftStart, shiftEnd, vehicleData) {
      var maximumTime = vehicleData.max_time || null;
      // If maximumTime exists, it is in minutes
      var formattedMaximumTime = maximumTime ? timeUtils.formatDuration(maximumTime * MILLISECONDS_PER_MINUTE) : "";
      return {
        start: shiftStart || null,
        end: shiftEnd || null,
        maximumTime: maximumTime,
        formattedMaximumTime: formattedMaximumTime
      };
    };

    PlannerVehicle.fromJson = function(vehicleData) {
      var vehicle = new PlannerVehicle(vehicleData.id.toString());

      vehicle.name = vehicleData.name;
      vehicle.capacity = vehicleData.capacity;
      vehicle.capacity2 = vehicleData.capacity_2;
      vehicle.capacity3 = vehicleData.capacity_3;
      vehicle.capacity4 = vehicleData.capacity_4;
      vehicle.licensePlate = vehicleData.license_plate;
      vehicle.typeLoad = vehicleData.type_load;
      vehicle.locationStart = {
        address: vehicleData.location_start_address,
        latitude: parseFloat(vehicleData.location_start_latitude) || 0,
        longitude: parseFloat(vehicleData.location_start_longitude) || 0
      };
      vehicle.locationEnd = {
        address: vehicleData.location_end_address,
        latitude: parseFloat(vehicleData.location_end_latitude) || 0,
        longitude: parseFloat(vehicleData.location_end_longitude) || 0
      };
      vehicle.skills = vehicleData.skills.map(function (skill) {
        return skill.toString();
      });
      vehicle.shift = {
        start: vehicleData.shift_start || lodash.get(vehicleData, "shift.start"),
        end: vehicleData.shift_end || lodash.get(vehicleData, "shift.end")
      };
      vehicle.shiftDefault = this.getShiftDefault(vehicleData.shift_start, vehicleData.shift_end, vehicleData);
      vehicle.cost = vehicleData.cost;
      vehicle.maxVisit = vehicleData.max_visit;
      vehicle.minLoad = vehicleData.min_load;
      vehicle.minLoad2 = vehicleData.min_load_2;
      vehicle.minLoad3 = vehicleData.min_load_3;
      vehicle.restTimeStart = vehicleData.rest_time_start;
      vehicle.restTimeEnd = vehicleData.rest_time_end;
      vehicle.restTimeDuration = vehicleData.rest_time_duration;
      vehicle.codrivers = vehicleData.codrivers;
      vehicle.modified = moment(vehicleData.modified).format(DATE_TIME_FORMAT);
      vehicle.referenceId = vehicleData.reference_id || null;
      vehicle.max_number_of_routes = vehicleData.max_number_of_routes || null;
      vehicle.max_route_distance = vehicleData.max_route_distance || null;

      return vehicle;
    };

    PlannerVehicle.prototype.activate = function () {
      this.active = true;
    };

    PlannerVehicle.prototype.setLocationStart = function (address, latitude, longitude) {
      this.locationStart.address = address;
      this.locationStart.latitude = latitude;
      this.locationStart.longitude = longitude;
    };

    PlannerVehicle.prototype.setLocationEnd = function (address, latitude, longitude) {
      this.locationEnd.address = address;
      this.locationEnd.latitude = latitude;
      this.locationEnd.longitude = longitude;
    };

    PlannerVehicle.prototype.showAllRoutes = function (show, areVisitsVisible, optimizationOptions) {
      // TODO: deprecate function when solving REX-297 task
      var isBigClusterActive = optimizationOptions.big_cluster;
      var isOpenEndedActive = optimizationOptions.open_ended;

      if (angular.isUndefined(show)) {
        show = true;
      }
      if (angular.isUndefined(areVisitsVisible)) {
        areVisitsVisible = true;
      }
      if (angular.isUndefined(isBigClusterActive)) {
        isBigClusterActive = false;
      }
      if (angular.isUndefined(isOpenEndedActive)) {
        isOpenEndedActive = false;
      }

      if (show) {
        if (areVisitsVisible) {
          this.setVisible(true, isOpenEndedActive);
          this.setOpacity(1);
        }
        this.routes.forEach(function (route) {
          var markerHasToBeUpdated = !$rootScope.drawCluster || !route.collapse;
          route.setVisibleWithoutOpacity();
          if (isBigClusterActive) {
            route.setVisible();
            if (!route.collapse) {
              $rootScope.$broadcast('Planner:Routes:showMarkersOfRoute', {
                route: route
              });
            }
          } else {
            route.visits.forEach(function (visit) {
              visit.setVisible(true, markerHasToBeUpdated);
            });
          }
        });
      } else {
        this.setVisible(false, isOpenEndedActive);
        this.routes.forEach(function (route) {
          var markerHasToBeUpdated = !$rootScope.drawCluster || !route.collapse;
          route.setVisibleWithoutOpacity(false);
          if (isBigClusterActive) {
            route.setVisible(false);
            if (!route.collapse) {
              $rootScope.$broadcast('Planner:Routes:hideMarkersOfRoute', {
                route: route
              });
            }
          } else {
            route.visits.forEach(function (visit) {
              visit.setVisible(false, markerHasToBeUpdated);
            });
          }
        });
      }
    };

    PlannerVehicle.prototype.showAllRoutesV2 = function (areRoutesVisible, optimizationOptions, areGroupMarkersEnabled) {
      // TODO: rename function to showAllRoutes when solving REX-297 task
      areRoutesVisible = angular.isUndefined(areRoutesVisible) || areRoutesVisible;
      this.showRoutes = areRoutesVisible;

      var isOpenEndedActive = angular.isDefined(optimizationOptions.open_ended) && optimizationOptions.open_ended;
      this.setVisible(areRoutesVisible, isOpenEndedActive);

      var areVisitsMarkersVisible, opacity;
      var areVisitsMarkersVisibleInStepThree = visitsMarkersService.getAreMarkersVisibleInStepThree().status;

      this.routes.forEach(function (route) {
        route.setVisible(areRoutesVisible, true);
        areVisitsMarkersVisible = areVisitsMarkersVisibleInStepThree && route.areVisitsMarkersVisible;
        if (areVisitsMarkersVisible && (!$rootScope.drawCluster || !route.collapse)) {
          route.areVisitsMarkersVisible = !areGroupMarkersEnabled;

          opacity = revisedRoutesService.getRouteOpacity(route);
          visitsMarkersService.setOpacityInVisits(route.visits, opacity, false);

          visitsMarkersService.showVisitsOnMap(route.visits, areRoutesVisible);
        }
      });
    };

    PlannerVehicle.prototype.setEditMode = function (editMode) {
      if (angular.isUndefined(editMode)) {
        editMode = true;
      }

      if (editMode) {
        this.options.draggable = true;
        this.optionsEnd.draggable = true;
        this.setVisible();
      } else {
        this.options.draggable = false;
        this.optionsEnd.draggable = false;
        this.setVisible(false);
      }

    };

    PlannerVehicle.prototype.setVisible = function (visible, isOpenEndedActive, mustUpdateMarkers) {
      if (angular.isUndefined(visible)) {
        visible = true;
      }

      if (angular.isUndefined(isOpenEndedActive)) {
        isOpenEndedActive = false;
      }

      if (visible) {
        this.options.visible = true;
        if (!isOpenEndedActive) {
          this.optionsEnd.visible = true;
        }
      } else {
        this.options.visible = false;
        this.optionsEnd.visible = false;
      }

      mustUpdateMarkers = angular.isUndefined(mustUpdateMarkers) || mustUpdateMarkers;
      if (mustUpdateMarkers) {
        this.actionUpdate(this);
      }
    };

    PlannerVehicle.prototype.setOpacity = function (opacity, mustUpdateMarkers) {
      this.options.icon.fillOpacity = opacity;
      this.optionsEnd.icon.fillOpacity = opacity;

      mustUpdateMarkers = angular.isUndefined(mustUpdateMarkers) || mustUpdateMarkers;
      if (mustUpdateMarkers) {
        this.actionUpdate(this);
      }
    };

    PlannerVehicle.prototype.createRoute = function () {
      var availableTime = this.shift.start;
      if (this.routes.length > 0) {
        availableTime = this.routes[this.routes.length - 1].estimatedTimeEnd;
      }
      var route = new PlannerRouteModel(this.id);
      route.estimatedTimeStart = availableTime;
      route.estimatedTimeEnd = availableTime;
      angular.copy(this.locationStart, route.locationStart);
      angular.copy(this.locationEnd, route.locationEnd);
      this.routes.push(route);
      return route;
    };

    PlannerVehicle.prototype.addRoute = function (route, existRouteInDB) {
      if (existRouteInDB) {
        updateLocationIfDifferent(this.locationStart, route.locationStart);
        updateLocationIfDifferent(this.locationEnd, route.locationEnd);
      } else {
        route.driver = this.driverId;
        angular.copy(this.locationStart, route.locationStart);
        angular.copy(this.locationEnd, route.locationEnd);
      }

      route.setStrokeColor(this.color);
      this.routes.push(route);
      return route;
    };

    function updateLocationIfDifferent(vehicleLocation, routeLocation) {
      if (!angular.equals(vehicleLocation, routeLocation)) {
        angular.copy(routeLocation, vehicleLocation);
      }
    }

    PlannerVehicle.prototype.removeRoute = function (route) {
      route.clear();
      this.routes.splice(this.routes.indexOf(route), 1);
    };

    PlannerVehicle.prototype.clear = function () {
      this.color = null;
      this.routes.forEach(function (route) {
        route.clear();
      });
      this.routes.length = 0;
    };

    PlannerVehicle.prototype.setIconFillColorWithVehicleColor = function (mustUpdateMarkers) {
      this.options.icon.fillColor = this.color;
      this.optionsEnd.icon.fillColor = this.color;

      mustUpdateMarkers = angular.isUndefined(mustUpdateMarkers) || mustUpdateMarkers;
      if (mustUpdateMarkers) {
        this.actionUpdate(this);
      }
    };

    PlannerVehicle.prototype.setIconFillColorWithDefaultColor = function () {
      this.options.icon.fillColor = "#41D3BD";
      this.optionsEnd.icon.fillColor = "#41D3BD";
      this.actionUpdate(this);
    };

    /**
     * If the visit has skills, check that all visit required skills are provided
     * by the vehicle and at least one of the optional skills.
     * @param { VisitModel } visit the visit to check skills
     * @return { Boolean } 'true' if the validation fails, otherwise returns 'false'
     */

    PlannerVehicle.prototype.validateVisitSkills = function (visit) {
      var vehicle = this;

      var requiredSkillsFound = visit.skills_required.filter(function (skill) {
        return vehicle.skills.includes(String(skill));
      });

      if (requiredSkillsFound.length !== visit.skills_required.length) {
        return true;
      }

      if (visit.skills_optional.length === 0) {
        return false;
      }

      var optionalSkillsFound = visit.skills_optional.filter(function (skill) {
        return vehicle.skills.includes(String(skill));
      });

      return optionalSkillsFound.length === 0;
    };

    PlannerVehicle.prototype.recalculateMetricsAndErrors = function (plannerService) {
      return _recalculateRoutes(this, plannerService);
    };

    PlannerVehicle.prototype.recalculateRouteStartingAt = function (route, optimizationOptions, plannerService) {
      var routeIndex = this.routes.findIndex(function (r) {
        return r.id === route.id;
      });

      return _recalculateRouteStartingAt(routeIndex, this, this.routes, optimizationOptions, plannerService);
    };

    PlannerVehicle.prototype.recalculateAllRoutes = function (optimizationOptions, plannerService) {
      return _recalculateRouteStartingAt(0, this, this.routes, optimizationOptions, plannerService);
    };

    function _recalculateRouteStartingAt(routeIndex, vehicle, routes, optimizationOptions, plannerService) {
      var deferred = $q.defer();
      var promises = [];
      for (var i = routeIndex; i < routes.length; i++) {
        promises.push(routes[i].calculatePath(vehicle, optimizationOptions, plannerService.getPlanStartTime(), plannerService.isVehicularRestrictionEnabled()));
      }

      promises.push(
        vtcService.callVTC(vehicle, optimizationOptions, plannerService)
          .finally(function () {
            _recalculateRoutes(vehicle, plannerService);
            vehicle.updateRouteVisitsAndEvents(plannerService);
          })
      );

      $q.all(promises)
        .then(function() { deferred.resolve();})
        .catch(function(error) {deferred.reject(error);})
        .finally(function() {
          $rootScope.$broadcast("Planner:Plan:recalculate-statistics");
        });

      return deferred.promise;
    }

    /**
     * If there are delivery visits without pick-up on the route,
     * it means that the visit leaves from the depot,
     * so the loads of the route are updated with the loads of the visits.
     * @param { object } route
     * @param { Array } visits of the route
     */
    function updateRouteLoadsWithDeliveryVisits(route, visits) {
      visits.forEach(function (visit){
        if (visit.properties.delivery_type === RELATIONSHIP_TYPE.DELIVERY && !visit.relationships.picks_from.length) {
          route['totalLoad'] += Number(visit.load) || 0;
          route['totalLoad2'] += Number(visit.load2) || 0;
          route['totalLoad3'] += Number(visit.load3) || 0;
          route['totalLoad4'] += Number(visit.load4) || 0;
        }
      });
    }

    /**
     * Validates rest time against vehicle rest time window using extended time format
     * @param {Object} eventByRoute - Rest time event with arrival and departure times
     * @param {Object} vehicle - Vehicle with restTimeStart and restTimeEnd
     * @param {Object} timeUtils - Time utilities service
     * @returns {Object} Object with isEventStartingBefore and isEventFinishingAfter flags
     */
    function _validateRestTimeWithExtendedFormat(eventByRoute, vehicle, timeUtils) {
      var isEventStartingBefore = false;
      var isEventFinishingAfter = false;

      var eventArrivalMinutes = timeUtils.parseExtendedTimeToMinutes(eventByRoute.arrival);
      var eventDepartureMinutes = timeUtils.parseExtendedTimeToMinutes(eventByRoute.departure);

      // Calculate day offset from event arrival time to align vehicle window times
      var eventArrivalIsExtended = timeUtils.isExtendedTimeFormat(eventByRoute.arrival);
      var eventDayOffset = eventArrivalIsExtended ? Math.floor(eventArrivalMinutes / (24 * 60)) : 0;
      var minutesPerDay = 24 * 60;

      // Parse vehicle window times
      var vehicleRestStartMinutes = vehicle.restTimeStart ? timeUtils.parseExtendedTimeToMinutes(vehicle.restTimeStart) : 0;
      var vehicleRestEndMinutes = vehicle.restTimeEnd ? timeUtils.parseExtendedTimeToMinutes(vehicle.restTimeEnd) : 0;
      var vehicleRestStartIsExtended = vehicle.restTimeStart ? timeUtils.isExtendedTimeFormat(vehicle.restTimeStart) : false;
      var vehicleRestEndIsExtended = vehicle.restTimeEnd ? timeUtils.isExtendedTimeFormat(vehicle.restTimeEnd) : false;
      var windowCrossesMidnight = vehicleRestEndMinutes < vehicleRestStartMinutes && !vehicleRestStartIsExtended && !vehicleRestEndIsExtended;

      // If rest time window crosses midnight (end < start in standard format), convert end to extended format
      if (windowCrossesMidnight) {
        vehicleRestEndMinutes += minutesPerDay; // Add 24 hours (1440 minutes) for next day
      }

      // If event is in extended format but vehicle window is not, convert vehicle window to same day offset
      // Special handling: when window crosses midnight, the window already spans two days (day 0 to day 1)
      // so we should compare directly without adding day offset, as the window naturally covers both days
      if (eventArrivalIsExtended && !vehicleRestStartIsExtended && !vehicleRestEndIsExtended && eventDayOffset > 0) {
        if (windowCrossesMidnight) {
          // Window crosses midnight: it spans from day 0 to day 1
          // If event is on day 1, compare directly (window already covers day 1)
          // If event is on day 2+, we need to move the entire window forward
          if (eventDayOffset > 1) {
            vehicleRestStartMinutes += (eventDayOffset - 1) * minutesPerDay;
            vehicleRestEndMinutes += (eventDayOffset - 1) * minutesPerDay;
          }
          // For eventDayOffset === 1, window already covers day 1, so no adjustment needed
        } else {
          // Window doesn't cross midnight: move both start and end by same offset
          vehicleRestStartMinutes += eventDayOffset * minutesPerDay;
          vehicleRestEndMinutes += eventDayOffset * minutesPerDay;
        }
      }

      if (vehicle.restTimeStart) {
        // Check if event starts before vehicle rest time window
        // Special case: when window crosses midnight and event is on day 1+,
        // the window start (day 0) is considered "already passed" for events on day 1+
        if (windowCrossesMidnight && eventArrivalIsExtended && eventDayOffset >= 1) {
          // Window crosses midnight and event is on day 1+: window start is in the past
          isEventStartingBefore = false;
        } else {
          isEventStartingBefore = eventArrivalMinutes < vehicleRestStartMinutes;
        }
      }

      if (vehicle.restTimeEnd) {
        // Check if event finishes after vehicle rest time window
        isEventFinishingAfter = eventDepartureMinutes > vehicleRestEndMinutes;
      }

      return {
        isEventStartingBefore: isEventStartingBefore,
        isEventFinishingAfter: isEventFinishingAfter
      };
    }

    function _recalculateRoutes(vehicle, plannerService) {
      var maximumVehicleTime = vehicle.shiftDefault.maximumTime;
      var maxVisitVehicle = vehicle.maxVisit;
      var accumulatedWorkTime = 0;
      var isMaximumTimeError = false;
      var isMaxVisitError = false;

      vehicle.routes.forEach(function (route) {
        var visits = route.visits;
        var lastVisitIndex = visits.length - 1;
        var maximumLoad = [0,0,0,0];

        var isThereDeliveryVisit = visits.some(function (visit) {
          return visit.properties.delivery_type === RELATIONSHIP_TYPE.DELIVERY;
        });

        var isTherePickupVisit = visits.some(function (visit) {
          return visit.properties.delivery_type === RELATIONSHIP_TYPE.PICK;
        });

        var isTherePickupAndDeliveryOnRoute = isThereDeliveryVisit && isTherePickupVisit;

        route.capacityError = false;
        route.capacityError2 = false;
        route.capacityError3 = false;
        route.capacityError4 = false;
        route.skillsError = false;
        route.hasRestTimeError = false;
        route.totalLoad = 0;
        route.totalLoad2 = 0;
        route.totalLoad3 = 0;
        route.totalLoad4 = 0;
        route.resetAlertCounts();

        if (isTherePickupAndDeliveryOnRoute) {
          updateRouteLoadsWithDeliveryVisits(route, visits);
          maximumLoad[0] = route.totalLoad;
          maximumLoad[1] = route.totalLoad2;
          maximumLoad[2] = route.totalLoad3;
          maximumLoad[3] = route.totalLoad4;
        }

        for (var i = 0; i <= lastVisitIndex; i++) {
          var visitOrder = i + 1;
          visits[i].updateOrder(visitOrder, (!$rootScope.drawCluster || !route.collapse));

          ["", "2", "3", "4"].forEach(function (typeLoad, index) {
            var result;
            if(isTherePickupAndDeliveryOnRoute) {
              result = _accumulateLoadPDVisit(visits[i], vehicle, route, typeLoad, i);
            }else{
              result = _accumulateVisitLoad(visits[i], vehicle, route, typeLoad);
            }

            maximumLoad[index] =  Math.max(result.totalLoad, maximumLoad[index]);
            route["capacityError" + typeLoad] = result.visitAlert || route["capacityError" + typeLoad];
            visits[i]["capacityError" + typeLoad] = route["capacityError" + typeLoad];
            if(i === lastVisitIndex){
              route["totalLoad" + typeLoad] =  maximumLoad[index];
            }else{
              route["totalLoad" + typeLoad] = result.totalLoad;
            }
          });

          if (i === 0) {
            accumulatedWorkTime += timeUtils.diff(visits[i].estimatedTimeArrival, route.estimatedTimeStart, "minutes");
          }

          if (i === lastVisitIndex) {
            accumulatedWorkTime += timeUtils.diff(route.estimatedTimeEnd, visits[i].estimatedTimeArrival, "minutes");
          }

          accumulatedWorkTime += _accumulateVisitTime(visits[i], visits[i - 1]);
          isMaximumTimeError = Boolean(maximumVehicleTime) && accumulatedWorkTime > maximumVehicleTime;
          visits[i].setMaximumTimeError(isMaximumTimeError);
          isMaxVisitError = Boolean(maxVisitVehicle) && i + 1 > maxVisitVehicle;
          visits[i].setMaxVisitError(isMaxVisitError);
          visits[i].skillsError = vehicle.validateVisitSkills(visits[i]);
          route.skillsError = visits[i].skillsError || route.skillsError;
          route.calculateAlertCounts(visits[i]);
        }

        var eventByRoute = plannerService.isRestTimeEnabled() ? plannerService.getRestTimeByRouteId(route.id) : null;

        if (eventByRoute) {
          var pathFinderProperties = plannerService.getPathFinderProperties();
          var skipTimeValidation = pathFinderProperties && pathFinderProperties['skip_time_validation'] && pathFinderProperties['skip_time_validation'].toLowerCase() === 'true';
          var planDate = plannerService.getPlanDate();
          var isLongRoutes = planDate && planDate.start && planDate.end && !moment(planDate.start).isSame(moment(planDate.end), 'day');
          var useExtendedFormat = isLongRoutes && skipTimeValidation;

          var isEventStartingBefore = false;
          var isEventFinishingAfter = false;

          if (useExtendedFormat) {
            var validationResult = _validateRestTimeWithExtendedFormat(eventByRoute, vehicle, timeUtils);
            isEventStartingBefore = validationResult.isEventStartingBefore;
            isEventFinishingAfter = validationResult.isEventFinishingAfter;
          } else {
            var momentVehicleRestTimeStart = vehicle.restTimeStart ? moment(vehicle.restTimeStart, "HH:mm") : null;
            var momentVehicleRestTimeEnd = vehicle.restTimeEnd ? moment(vehicle.restTimeEnd, "HH:mm") : null;
            var momentEventArrival = moment(eventByRoute.arrival, "HH:mm");
            var momentEventDeparture = moment(eventByRoute.departure, "HH:mm");

            isEventStartingBefore = momentVehicleRestTimeStart ? momentEventArrival.isBefore(momentVehicleRestTimeStart) : false;
            isEventFinishingAfter = momentVehicleRestTimeEnd ? momentEventDeparture.isAfter(momentVehicleRestTimeEnd) : false;
          }

          eventByRoute.hasError = isEventStartingBefore || isEventFinishingAfter;
          route.hasRestTimeError = eventByRoute.hasError || route.hasRestTimeError;

          plannerService.setRestTimeByRouteId(route.id, eventByRoute);
        }

        route.totalLoadPercentage = (route.totalLoad / vehicle.capacity * 100).toFixed(1);
        route.formattedLoad = $filter('formatNumber')(route.totalLoad) + '/' + $filter('formatNumber')(vehicle.capacity);

        var existsVehicleCapacity2 = vehicle.capacity2 && vehicle.capacity2 > 0;
        if (existsVehicleCapacity2 || route.totalLoad2 > 0) {
          route.totalLoadPercentage2 = ((existsVehicleCapacity2 ? (route.totalLoad2 / vehicle.capacity2) : 0) * 100).toFixed(1);
          route.formattedLoad2 = $filter('formatNumber')(route.totalLoad2) + '/' + $filter('formatNumber')(vehicle.capacity2);
        }

        var existsVehicleCapacity3 = vehicle.capacity3 && vehicle.capacity3 > 0;
        if (existsVehicleCapacity3 || route.totalLoad3 > 0) {
          route.totalLoadPercentage3 = ((existsVehicleCapacity3 ? (route.totalLoad3 / vehicle.capacity3) : 0) * 100).toFixed(1);
          route.formattedLoad3 = $filter('formatNumber')(route.totalLoad3) + '/' + $filter('formatNumber')(vehicle.capacity3);
        }

        var existsVehicleCapacity4 = vehicle.capacity4 && vehicle.capacity4 > 0;
        if (existsVehicleCapacity4 || route.totalLoad4 > 0) {
          route.totalLoadPercentage4 = ((existsVehicleCapacity4 ? (route.totalLoad4 / vehicle.capacity4) : 0) * 100).toFixed(1);
          route.formattedLoad4 = $filter('formatNumber')(route.totalLoad4) + '/' + $filter('formatNumber')(vehicle.capacity4);
        }
      });

      vehicle.setMaximumTimeError(isMaximumTimeError);
    }

    /**
     * Accumulate the new visit's load to the route; does not modify the route
     * visitAlert is true if the new load exceeds the vehicle's capacity
     * returns new 'totalLoad' and 'visitAlert'
     * @param { VisitModel } visit the new visit
     * @param { VehicleModel } vehicle the vehicle for the route
     * @param { RouteModel } route the route where the load will be added
     * @param { String } typeLoad '' for load1, '2' for load2, '3' for load3
     * @return { Object } containing the new 'totalLoad' and 'visitAlert'
     */

    function _accumulateVisitLoad(visit, vehicle, route, typeLoad) {
      var result = {
        visitAlert: false,
        totalLoad: route["totalLoad" + typeLoad]
      };

      var visitLoad = visit["load" + typeLoad];
      var vehicleCapacity = vehicle["capacity" + typeLoad] || 0;

      if (!visitLoad) {
        return result;
      }

      result.totalLoad += visitLoad;
      if (result.totalLoad > vehicleCapacity) {
        result.visitAlert = true;
      }

      return result;
    }

    /**
     * Update the load of the route according to the p&d type visits,
     * if the visit is of the delivery type, the load is subtracted from the route
     * if the visit is of the pickup type, its load is added to the route
     * returns new 'totalLoad' and 'visitAlert'
     * @param { VisitModel } visit the new visit
     * @param { VehicleModel } vehicle the vehicle for the route
     * @param { RouteModel } route the route where the load will be added
     * @param { String } typeLoad '' for load1, '2' for load2, '3' for load3
     * @param { Integer } Visit index to check if there is overload from the first visit
     * @return { Object } containing the new 'totalLoad' and 'visitAlert'
     */
    function _accumulateLoadPDVisit(visit, vehicle, route, typeLoad, index) {
      var result = {
        visitAlert: false,
        totalLoad: route["totalLoad" + typeLoad]
      };

      var visitLoad = visit["load" + typeLoad];
      var vehicleCapacity = vehicle["capacity" + typeLoad] || 0;

      if(index === 0 && result.totalLoad > vehicleCapacity) {
        result.visitAlert = true;
        return result;
      }

      if (!visitLoad) {
        return result;
      }

      if (visit.properties.delivery_type === RELATIONSHIP_TYPE.DELIVERY) {
        result.totalLoad -= visitLoad;
      }
      else {
        result.totalLoad += visitLoad;
      }
      if (result.totalLoad > vehicleCapacity) {
        result.visitAlert = true;
      }

      return result;
    }

    function _accumulateVisitTime(currentVisit, previousVisit) {
      var sumTotalTime = 0;

      if (previousVisit) {
        sumTotalTime += timeUtils.diff(currentVisit.estimatedTimeArrival, previousVisit.estimatedTimeArrival, "minutes");
      }

      return sumTotalTime;
    }

    //Map manager
    PlannerVehicle.prototype.actionCreate = function (vehicle) {
      $rootScope.$broadcast("Planner:Vehicle:Create", {
        vehicle: vehicle
      });
    };

    PlannerVehicle.prototype.actionUpdate = function (vehicle) {
      $rootScope.$broadcast("Planner:Vehicle:Update", {
        vehicle: vehicle
      });
    };

    PlannerVehicle.prototype.actionRemove = function (vehicle) {
      $rootScope.$broadcast("Planner:Vehicle:Remove", {
        vehicle: vehicle
      });
    };

    PlannerVehicle.prototype.updateLocationStart = function (marker) {
      var vehicle = this, newPosition = {};
      var geocoder = googleService.createGeocode();
      newPosition = marker.latLng;
      var requestData = {location: newPosition};
      geocoder.geocode(requestData, function (results, status) {
        if (status === googleService.geocoderStatusOK()) {
          if (results[0]) {
            vehicle.locationStart.latitude = newPosition.lat().toFixed(6);
            vehicle.locationStart.longitude = newPosition.lng().toFixed(6);
            vehicle.locationStart.address = results[0].formatted_address;
            vehicle.actionUpdate(vehicle);
            $rootScope.$apply();
          } else {
            $log.error('No reverse geocode results found', requestData);
          }
        } else {
          $log.error(status, requestData);
        }
      });
    };

    PlannerVehicle.prototype.updateLocationEnd = function (marker) {
      var vehicle = this, newPosition = {};
      var geocoder = googleService.createGeocode();
      newPosition = marker.latLng;
      var requestData = {location: newPosition};
      geocoder.geocode(requestData, function (results, status) {
        if (status === googleService.geocoderStatusOK()) {
          if (results[0]) {
            vehicle.locationEnd.latitude = newPosition.lat().toFixed(6);
            vehicle.locationEnd.longitude = newPosition.lng().toFixed(6);
            vehicle.locationEnd.address = results[0].formatted_address;
            vehicle.actionUpdate(vehicle);
            $rootScope.$apply();
          } else {
            $log.error('No reverse geocode results found', requestData);
          }
        } else {
          $log.error(status, requestData);
        }
      });
    };

    PlannerVehicle.prototype.isTheFirstRoute = function (routeId) {
      return (this.routes[0].id === routeId);
    };

    PlannerVehicle.prototype.isAvailableIn = function (shiftStart, shiftEnd, routes, date) {
      var vehicleId = this.id;
      var busyHours = [];
      var result = {available: true, until: null};

      try {
        routes.forEach(function (route) {
          var routeStart = moment(date.start);
          var routeEnd = moment(date.start);
          if (parseInt(vehicleId) === parseInt(route.vehicleId)) {

            var startTime = _getRouteStartTime(route);
            var endTime = _getRouteEndTime(route);

            routeStart.set({
              'hour': parseInt(startTime.slice(0, 2)),
              'minute': parseInt(startTime.slice(3, 5)),
              'second': parseInt(startTime.slice(6, 8))
            });

            routeEnd.set({
              'hour': parseInt(endTime.slice(0, 2)),
              'minute': parseInt(endTime.slice(3, 5)),
              'second': parseInt(endTime.slice(6, 8))
            });

            // Copy busy hours to an array
            if (busyHours.length === 0) {
              busyHours.push({
                from: routeStart,
                to: routeEnd
              });
            } else {
              // Insert hours in ascending order
              var hour = null;
              for (var k = 0; k < busyHours.length; k++) {
                hour = busyHours[k];
                if (routeStart.isBefore(hour.from) && routeEnd.isBefore(hour.from)) {
                  busyHours.splice(k, 0, {from: routeStart, to: routeEnd});
                  break;
                } else if (routeStart.isSame(hour.from) && !routeEnd.isSame(hour.to)) {
                  if (routeEnd.isAfter(hour.to)) {
                    busyHours[k].to = routeEnd;
                    break;
                  }
                } else if (!routeStart.isSame(hour.from) && routeEnd.isSame(hour.to)) {
                  if (routeStart.isBefore(hour.from)) {
                    busyHours[k].from = routeStart;
                    break;
                  }
                } else if (routeStart.isSame(hour.to)) {
                  busyHours[k].to = routeEnd;
                  break;
                } else if (k === busyHours.length && routeStart.isAfter(hour.to)
                  && routeEnd.isAfter(hour.to)) {
                  busyHours.push({from: routeStart, to: routeEnd});
                  break;
                }
              }
            }
          }
        });

        // Check Availability

        var hour = null;
        for (var j = 0; j < busyHours.length; j++) {
          hour = busyHours[j];
          if (shiftStart.isSameOrBefore(hour.from) && shiftEnd.isSameOrAfter(hour.from) ||
            (shiftStart.isSameOrBefore(hour.from) && shiftEnd.isSameOrAfter(hour.to)) ||
            (shiftStart.isSameOrAfter(hour.from) && shiftEnd.isSameOrBefore(hour.to)) ||
            (shiftStart.isSameOrBefore(hour.to) && shiftEnd.isSameOrAfter(hour.to))) {
            result.available = false;
            result.until = hour.to;
          }
        }
      } catch (e) {
        $log.error(e);
      }

      return result;

    };

    function _getRouteStartTime(route) {
      var startTime = '00:00:00';
      if(route.startTime) {
        startTime = moment(route.startTime).format("HH:mm:ss");
      } else {
        startTime = route.estimatedTimeStart;
      }
      return startTime;
    }

    function _getRouteEndTime(route) {
      var endTime = '00:00:00';
      if(route.endTime) {
        endTime = moment(route.endTime).format("HH:mm:ss");
      } else {
        endTime = route.estimatedTimeEnd;
      }
      return endTime;
    }

    PlannerVehicle.prototype.setMaximumTimeError = function (isError) {
      this.maximumTimeError = isError;
    };

    PlannerVehicle.prototype.setColor = function (color) {
      this.color = color;
      this.colorDarker = tinycolor(color).darken(30).toString();
    };

    PlannerVehicle.prototype.setRelativePlanColor = function (color, mustUpdate) {
      this.setColor(color);
      this.setIconFillColorWithVehicleColor(mustUpdate);
      this.routes.forEach(function (route) {
        route.setStrokeColor(color);
        if (mustUpdate) {
          route.actionUpdate(route);
        }

        route.visits.forEach(function (visit){
          visit.setDefaultColor(color);
          visit.actionUpdateLight(mustUpdate);
        });
      });
    };

    PlannerVehicle.prototype.setIsShiftTemporarilyEdited = function (initialShift) {
      this.isShiftTemporarilyEdited = (
        this.isShiftTemporarilyEdited ||
        this.shift.start !== initialShift.start ||
        this.shift.end !== initialShift.end
      );
    };

    PlannerVehicle.prototype.setAreAllRoutesRevised = function () {
      this.areAllRoutesRevised = this.routes.every(function (route) {
        return route.isRevised;
      });
    };

    PlannerVehicle.prototype.isAnyRouteRevised = function () {
      return this.routes.some(function(route) {
        return route.isRevised;
      });
    };

    PlannerVehicle.prototype.removeUnrevisedRoutes = function () {
      var revisedRoutes = [];
      this.routes.forEach(function(route) {
        if (route.isRevised) {
          revisedRoutes.push(route);
        } else {
          route.clear();
        }
      });
      this.routes = revisedRoutes;
    };

    PlannerVehicle.prototype.updateRouteVisitsAndEvents = function (plannerService) {
      this.routes.forEach(function (route) {
        route.updateVisitsAndEvents(plannerService);
      });
    };

    return PlannerVehicle;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('validatorGeoreferenceService', validatorGeoreferenceService);

  /** @ngInject */
  function validatorGeoreferenceService($filter, CLEANER_CONFIG) {

    var LOCATION_START_COUNTRY_CODE = 'CL';
    var ERROR_COUNTRY = 'País diferente';
    var ERROR_COUNTRY_CENTER = 'Centro del país';
    var ERROR_DISTANCE = 'Demasiado lejos de la bodega';
    var ERROR_AREA_CENTER = 'Centro de la comuna';
    var ERROR_WRONG_AREA = 'Diferente comuna a la señalada en la dirección';
    var ERROR_DOUBT = 'Dirección dudosa';
    var MAX_DISTANCE = 150;
    var CENTER_COUNTRY;
    var configs = CLEANER_CONFIG;
    var N_A = 'N/A';

    return {
      validateVisit: validateVisit,
      validateCenterCountry: validateCenterCountry,
      validateCenterArea: validateCenterArea,
      validateMaxDistance: validateMaxDistance
    };

    //////////////////////////////////////////
    // Privates Methodsº
    /////////////////////////////////////////

    function _distance(lat1, lon1, lat2, lon2, unit) {
      var radlat1 = Math.PI * lat1 / 180;
      var radlat2 = Math.PI * lat2 / 180;
      var theta = lon1 - lon2;
      var radtheta = Math.PI * theta / 180;
      var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      dist = Math.acos(dist);
      dist = dist * 180 / Math.PI;
      dist = dist * 60 * 1.1515;
      if (unit === "K") {
        dist = dist * 1.609344;
      }
      if (unit === "N") {
        dist = dist * 0.8684;
      }
      return dist;
    }

    function _setTypeError(visit, error_type) {
      switch (error_type) {

        case ERROR_COUNTRY_CENTER:
          visit.status = 4;
          visit.error = {
            type: 4,
            msg: $filter('translate')('Visits.alert_notification.country_center')
          };
          visit.procureVisitStatus();
          break;
        case ERROR_DISTANCE:
          visit.status = 4;
          visit.error = {
            type: 4,
            msg: $filter('translate')('Visits.alert_notification.error_distance')
          };
          visit.procureVisitStatus();
          break;
        case ERROR_COUNTRY:
          visit.status = 4;
          visit.error = {
            type: 4,
            msg: $filter('translate')('Visits.alert_notification.error_country')
          };
          visit.procureVisitStatus();
          break;
        case ERROR_WRONG_AREA:
          visit.status = 2;
          visit.error = {
            type: 2,
            msg: $filter('translate')('Visits.alert_notification.error_wrong_area')
          };
          visit.procureVisitStatus();
          break;
        case ERROR_AREA_CENTER:
          visit.status = 3;
          visit.error = {
            type: 3,
            msg: $filter('translate')('Visits.alert_notification.error_area_center')
          };
          visit.procureVisitStatus();
          break;
        case ERROR_DOUBT:
          visit.status = 2;
          visit.error = {
            type: 2,
            msg: $filter('translate')('Visits.alert_notification.error_doubt')
          };
          visit.procureVisitStatus();
          break;
        default:
          visit.status = 1;
          visit.error = null;
          visit.procureVisitStatus();
          break;
      }
    }

    function _getConfigCenters() {
      var centers;
      if (configs[LOCATION_START_COUNTRY_CODE]) {
        centers = configs[LOCATION_START_COUNTRY_CODE].centersOfArea;
        CENTER_COUNTRY = configs[LOCATION_START_COUNTRY_CODE].centerOfCountry;
      } else {
        LOCATION_START_COUNTRY_CODE = 'CL';
        centers = configs[LOCATION_START_COUNTRY_CODE].centersOfArea;
        CENTER_COUNTRY = configs[LOCATION_START_COUNTRY_CODE].centerOfCountry;
      }

      return centers;
    }

    ////////////////////////////////////////////
    // Public Methods
    ////////////////////////////////////////////

    function validateVisit(visit, cleaned, vehicles, accountCountry, accountMaxDistance) {
      var error_type;
      var activeVehicles = vehicles;
      MAX_DISTANCE = accountMaxDistance || MAX_DISTANCE;

      LOCATION_START_COUNTRY_CODE = accountCountry;

      if (!visit.administrative_area && visit.locality) {
        visit.administrative_area = visit.locality;
      }

      error_type = validateErrors(activeVehicles, visit, cleaned);
      _setTypeError(visit, error_type);
    }

    function validateErrors(activeVehicles, visit, cleaned) {
      var error_type;

      if (visit.country && visit.country !== LOCATION_START_COUNTRY_CODE) { // visit with a different country than the account country
        error_type = ERROR_COUNTRY;
        return error_type;
      }

      error_type = validateMaxDistance(visit, activeVehicles);

      if (error_type === N_A) {
        error_type = validateCenter(visit, cleaned);
      }

      return error_type;
    }

    function validateCenter(visit, cleaned) {
      var centers;
      var error_type;

      centers = _getConfigCenters();

      if (validateCenterCountry(visit)) {
        error_type = ERROR_COUNTRY_CENTER;
      } else if (validateCenterArea(centers, visit)) {
        error_type = ERROR_AREA_CENTER;
      } else if (cleaned.administrative_area && cleaned.administrative_area !== visit.administrative_area) {
        error_type = ERROR_WRONG_AREA;
      }

      return error_type;
    }

    function validateCenterCountry(visit) {
      var error = false;
      if (visit.latitude === CENTER_COUNTRY.lat && visit.longitude === CENTER_COUNTRY.lng) {
        error = true;
      }
      return error;
    }

    function validateCenterArea(centers, visit) {
      var flag = false;
      var delta = 0.000001;
      var cityLat;
      var cityLng;

      centers.forEach(function (city) {
        if (flag) {
          return;
        }

        cityLat = parseFloat(city.lat);
        cityLng = parseFloat(city.lng);

        if ((cityLat === visit.latitude) || (cityLat === (visit.latitude + delta)) || (cityLat === (visit.latitude - delta)) ||
          (cityLng === visit.longitude) || (cityLng === (visit.longitude + delta)) || (cityLng === (visit.longitude - delta))) {
          flag = true;
        }
      });

      return flag;
    }

    function validateMaxDistance(visit, activeVehicles) {
      var error_type = N_A;

      for (var i = 0; i < activeVehicles.length; i++) {

        var distanceFromStart = _distance(
          activeVehicles[i].locationStart.latitude,
          activeVehicles[i].locationStart.longitude,
          visit.latitude,
          visit.longitude,
          'K'
        );

        if (distanceFromStart > MAX_DISTANCE) { // visit too far from the depot
          error_type = ERROR_DISTANCE;
        } else if (visit.error && visit.error.msg === ERROR_DOUBT) { // visit with doubtful address
          error_type = ERROR_DOUBT;
        } else {
          // there is at least one vehicle that can perform this visit, therefore, there is no more checking
          error_type = N_A;
          break;
        }
      }
      return error_type;
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('Utils', utils);

  /** @ngInject */
  function utils (){
    var latlngPattern = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/;
    var ChileCities = {"Arica":{"city":"Arica","location":{"lat":-18.4782534,"lng":-70.31259879999999}},"Camarones":{"city":"Arica","location":{"lat":-19.0111932,"lng":-69.8654656}},"Putre":{"city":"Parinacota","location":{"lat":-18.1969907,"lng":-69.55972729999996}},"General Lagos":{"city":"Parinacota","location":{"lat":-17.6533,"lng":-69.63470000000001}},"Iquique":{"city":"Iquique","location":{"lat":-20.2307033,"lng":-70.1356692}},"Alto Hospicio":{"city":"Iquique","location":{"lat":-20.2686722,"lng":-70.10491689999998}},"Pozo Almonte":{"city":"Tamarugal","location":{"lat":-20.2567092,"lng":-69.78601279999998}},"Camiña":{"city":"Tamarugal","location":{"lat":-19.3116281,"lng":-69.42986869999999}},"Colchane":{"city":"Tamarugal","location":{"lat":-19.7,"lng":-68.88329999999996}},"Huara":{"city":"Tamarugal","location":{"lat":-19.9972461,"lng":-69.77185150000003}},"Pica":{"city":"Tamarugal","location":{"lat":-20.489483,"lng":-69.330511}},"Antofagasta":{"city":"Antofagasta","location":{"lat":-23.6509279,"lng":-70.39750219999996}},"Mejillones":{"city":"Antofagasta","location":{"lat":-23.0985013,"lng":-70.4455041}},"Sierra Gorda":{"city":"Antofagasta","location":{"lat":-22.8860128,"lng":-69.31719950000002}},"Taltal":{"city":"Antofagasta","location":{"lat":-25.406494,"lng":-70.48030269999998}},"Calama":{"city":"El Loa","location":{"lat":-22.4543923,"lng":-68.92938190000001}},"Ollagüe":{"city":"El Loa","location":{"lat":-21.2256917,"lng":-68.25478020000003}},"San Pedro de Atacama":{"city":"El Loa","location":{"lat":-22.9087073,"lng":-68.19971559999999}},"Tocopilla":{"city":"Tocopilla","location":{"lat":-22.0857976,"lng":-70.1930064}},"María Elena":{"city":"Tocopilla","location":{"lat":-22.3450046,"lng":-69.6607055}},"Copiapó":{"city":"Copiapó","location":{"lat":-27.3665763,"lng":-70.33215869999998}},"Caldera":{"city":"Copiapó","location":{"lat":-27.0667,"lng":-70.81781419999999}},"Tierra Amarilla":{"city":"Copiapó","location":{"lat":-27.4671706,"lng":-70.26521960000002}},"Chañaral":{"city":"Chañaral","location":{"lat":-26.3450046,"lng":-70.62419299999999}},"Diego de Almagro":{"city":"Chañaral","location":{"lat":-26.3902488,"lng":-70.04753019999998}},"Vallenar":{"city":"Huasco","location":{"lat":-28.5757953,"lng":-70.75710090000001}},"Alto del Carmen":{"city":"Huasco","location":{"lat":-28.759444,"lng":-70.48666700000001}},"Freirina":{"city":"Huasco","location":{"lat":-28.512094,"lng":-71.07959670000002}},"Huasco":{"city":"Huasco","location":{"lat":-28.4664,"lng":-71.2192}},"La Serena":{"city":"Elqui","location":{"lat":-29.9026691,"lng":-71.25193739999997}},"Coquimbo":{"city":"Elqui","location":{"lat":-29.9590009,"lng":-71.33891829999999}},"Andacollo":{"city":"Elqui","location":{"lat":-30.2357949,"lng":-71.0828027}},"La Higuera":{"city":"Elqui","location":{"lat":-29.5119534,"lng":-71.20008439999998}},"Paihuano":{"city":"Elqui","location":{"lat":-30.0276898,"lng":-70.51781419999998}},"Vicuña":{"city":"Elqui","location":{"lat":-30.0319,"lng":-70.7081}},"Illapel":{"city":"Choapa","location":{"lat":-31.6308,"lng":-71.1653}},"Canela":{"city":"Choapa","location":{"lat":-31.398889,"lng":-71.45611099999996}},"Los Vilos":{"city":"Choapa","location":{"lat":-31.9121865,"lng":-71.51120170000002}},"Salamanca":{"city":"Choapa","location":{"lat":-31.782493,"lng":-70.9607105}},"Ovalle":{"city":"Limarí","location":{"lat":-30.604304,"lng":-71.19698819999996}},"Combarbalá":{"city":"Limarí","location":{"lat":-31.1790967,"lng":-71.00509579999999}},"Monte Patria":{"city":"Limarí","location":{"lat":-30.6978944,"lng":-70.95868889999997}},"Punitaqui":{"city":"Limarí","location":{"lat":-30.8260995,"lng":-71.25779119999999}},"Río Hurtado":{"city":"Limarí","location":{"lat":-30.266667,"lng":-70.66666700000002}},"Valparaíso":{"city":"Valparaíso","location":{"lat":-33.047238,"lng":-71.61268849999999}},"Casablanca":{"city":"Valparaíso","location":{"lat":-33.3190376,"lng":-71.40763179999999}},"Concón":{"city":"Valparaíso","location":{"lat":-32.9239368,"lng":-71.52347929999996}},"Juan Fernández":{"city":"Valparaíso","location":{"lat":-33.7744303,"lng":-80.77686130000001}},"Puchuncaví":{"city":"Valparaíso","location":{"lat":-32.722005,"lng":-71.41170039999997}},"Quintero":{"city":"Valparaíso","location":{"lat":-32.7723101,"lng":-71.5333}},"Viña del Mar":{"city":"Valparaíso","location":{"lat":-33.0153481,"lng":-71.55002760000002}},"Los Andes":{"city":"Los Andes","location":{"lat":-32.8337995,"lng":-70.59721789999998}},"Calle Larga":{"city":"Los Andes","location":{"lat":-32.857493,"lng":-70.62580689999999}},"Rinconada":{"city":"Los Andes","location":{"lat":-32.8352416,"lng":-70.70103670000003}},"San Esteban":{"city":"Los Andes","location":{"lat":-32.8004995,"lng":-70.57980320000001}},"La Ligua":{"city":"Petorca","location":{"lat":-32.44990180000001,"lng":-71.23259580000001}},"Cabildo":{"city":"Petorca","location":{"lat":-32.4258064,"lng":-71.06616209999999}},"Papudo":{"city":"Petorca","location":{"lat":-32.5072087,"lng":-71.44850129999998}},"Petorca":{"city":"Petorca","location":{"lat":-32.25,"lng":-70.93330000000003}},"Zapallar":{"city":"Petorca","location":{"lat":-32.5538059,"lng":-71.4581359}},"Quillota":{"city":"Quillota","location":{"lat":-32.8803027,"lng":-71.2497156}},"La Calera":{"city":"Quillota","location":{"lat":-32.7877958,"lng":-71.20399629999997}},"Hijuelas":{"city":"Quillota","location":{"lat":-32.7980018,"lng":-71.1437211}},"La Cruz":{"city":"Quillota","location":{"lat":-32.8258069,"lng":-71.2273055}},"Nogales":{"city":"Quillota","location":{"lat":-32.7333,"lng":-71.20421149999999}},"San Antonio":{"city":"San Antonio","location":{"lat":-33.5922807,"lng":-71.60551229999999}},"Algarrobo":{"city":"San Antonio","location":{"lat":-33.3647762,"lng":-71.67055340000002}},"Cartagena":{"city":"San Antonio","location":{"lat":-33.5482466,"lng":-71.60457450000001}},"El Quisco":{"city":"San Antonio","location":{"lat":-33.398596,"lng":-71.6981538}},"El Tabo":{"city":"San Antonio","location":{"lat":-33.4557162,"lng":-71.66693409999999}},"Santo Domingo":{"city":"San Antonio","location":{"lat":-33.635833,"lng":-71.62805600000002}},"San Felipe":{"city":"San Felipe de Aconcagua","location":{"lat":-32.75,"lng":-70.72081149999997}},"Catemu":{"city":"San Felipe de Aconcagua","location":{"lat":-32.7788041,"lng":-70.9627036}},"Llaillay":{"city":"San Felipe de Aconcagua","location":{"lat":-32.844379,"lng":-70.94281799999999}},"Panquehue":{"city":"San Felipe de Aconcagua","location":{"lat":-32.7670303,"lng":-70.83330000000001}},"Putaendo":{"city":"San Felipe de Aconcagua","location":{"lat":-32.628461,"lng":-70.71774340000002}},"Santa María":{"city":"San Felipe de Aconcagua","location":{"lat":-32.7470027,"lng":-70.6587073}},"Quilpué":{"city":"Marga Marga","location":{"lat":-33.0482707,"lng":-71.4408752}},"Limache":{"city":"Marga Marga","location":{"lat":-33.0095283,"lng":-71.25958880000002}},"Olmué":{"city":"Marga Marga","location":{"lat":-32.9981387,"lng":-71.18927830000001}},"Villa Alemana":{"city":"Marga Marga","location":{"lat":-33.0516935,"lng":-71.39062339999998}},"Rancagua":{"city":"Cachapoal","location":{"lat":-34.17013240000001,"lng":-70.7406259}},"Codegua":{"city":"Cachapoal","location":{"lat":-34.0370319,"lng":-70.67286410000003}},"Coinco":{"city":"Cachapoal","location":{"lat":-34.2661579,"lng":-70.95934169999998}},"Coltauco":{"city":"Cachapoal","location":{"lat":-34.2877978,"lng":-71.0855512}},"Doñihue":{"city":"Cachapoal","location":{"lat":-34.228986,"lng":-70.95792879999999}},"Graneros":{"city":"Cachapoal","location":{"lat":-34.0666916,"lng":-70.73256459999999}},"Las Cabras":{"city":"Cachapoal","location":{"lat":-34.2932184,"lng":-71.3126292}},"Machalí":{"city":"Cachapoal","location":{"lat":-34.179452,"lng":-70.65651509999998}},"Malloa":{"city":"Cachapoal","location":{"lat":-34.4423905,"lng":-70.9463887}},"Mostazal":{"city":"Cachapoal","location":{"lat":-33.9497607,"lng":-70.57408859999998}},"Olivar":{"city":"Cachapoal","location":{"lat":-34.233,"lng":-70.88299999999998}},"Peumo":{"city":"Cachapoal","location":{"lat":-34.3963392,"lng":-71.1700793}},"Pichidegua":{"city":"Cachapoal","location":{"lat":-34.3573785,"lng":-71.28725959999997}},"Quinta de Tilcoco":{"city":"Cachapoal","location":{"lat":-34.3554003,"lng":-70.9704681}},"Rengo":{"city":"Cachapoal","location":{"lat":-34.4023791,"lng":-70.86744110000001}},"Requínoa":{"city":"Cachapoal","location":{"lat":-34.2883749,"lng":-70.815833}},"San Vicente":{"city":"Cachapoal","location":{"lat":-34.4349435,"lng":-71.09137479999998}},"Pichilemu":{"city":"Cardenal Caro","location":{"lat":-34.3867245,"lng":-72.00477309999997}},"La Estrella":{"city":"Cardenal Caro","location":{"lat":-34.2051972,"lng":-71.6547276}},"Litueche":{"city":"Cardenal Caro","location":{"lat":-34.117272,"lng":-71.72517599999998}},"Marchihue":{"city":"Cardenal Caro","location":{"lat":-34.3984467,"lng":-71.62157150000002}},"Navidad":{"city":"Cardenal Caro","location":{"lat":-33.9593954,"lng":-71.82951880000002}},"Paredones":{"city":"Cardenal Caro","location":{"lat":-34.6519651,"lng":-71.90014480000002}},"San Fernando":{"city":"Colchagua","location":{"lat":-34.5858603,"lng":-70.9907801}},"Chépica":{"city":"Colchagua","location":{"lat":-34.7255387,"lng":-71.27259249999997}},"Chimbarongo":{"city":"Colchagua","location":{"lat":-34.70924,"lng":-71.0412713}},"Lolol":{"city":"Colchagua","location":{"lat":-34.7284166,"lng":-71.64582430000002}},"Nancagua":{"city":"Colchagua","location":{"lat":-34.6523209,"lng":-71.1968597}},"Palmilla":{"city":"Colchagua","location":{"lat":-34.5325061,"lng":-71.41299370000002}},"Peralillo":{"city":"Colchagua","location":{"lat":-34.4772681,"lng":-71.487259}},"Placilla":{"city":"Colchagua","location":{"lat":-34.6337953,"lng":-71.11082729999998}},"Pumanque":{"city":"Colchagua","location":{"lat":-34.6026565,"lng":-71.65529329999998}},"Santa Cruz":{"city":"Colchagua","location":{"lat":-34.6324213,"lng":-71.35921159999998}},"Talca":{"city":"Talca","location":{"lat":-35.4232444,"lng":-71.64848039999998}},"Constitución":{"city":"Talca","location":{"lat":-35.33330000000001,"lng":-72.41669999999999}},"Curepto":{"city":"Talca","location":{"lat":-35.0958545,"lng":-72.02088909999998}},"Empedrado":{"city":"Talca","location":{"lat":-35.589943,"lng":-72.2763046}},"Maule":{"city":"Talca","location":{"lat":-35.4232444,"lng":-71.64848039999998}},"Pelarco":{"city":"Talca","location":{"lat":-35.3838823,"lng":-71.44719199999997}},"Pencahue":{"city":"Talca","location":{"lat":-35.3960652,"lng":-71.79745630000002}},"Río Claro":{"city":"Talca","location":{"lat":-35.2808267,"lng":-71.25995069999999}},"San Clemente":{"city":"Talca","location":{"lat":-35.5364676,"lng":-71.4893705}},"San Rafael":{"city":"Talca","location":{"lat":-35.3074574,"lng":-71.52349859999998}},"Cauquenes":{"city":"Cauquenes","location":{"lat":-35.9676285,"lng":-72.3222331}},"Chanco":{"city":"Cauquenes","location":{"lat":-35.7333,"lng":-72.5333}},"Pelluhue":{"city":"Cauquenes","location":{"lat":-35.8141512,"lng":-72.57499789999997}},"Curicó":{"city":"Curicó","location":{"lat":-34.9779853,"lng":-71.25288030000002}},"Hualañé":{"city":"Curicó","location":{"lat":-34.9725157,"lng":-71.7993371}},"Licantén":{"city":"Curicó","location":{"lat":-34.9852447,"lng":-71.98498799999999}},"Molina":{"city":"Curicó","location":{"lat":-35.1164987,"lng":-71.2829759}},"Rauco":{"city":"Curicó","location":{"lat":-34.9253441,"lng":-71.3156315}},"Romeral":{"city":"Curicó","location":{"lat":-34.9622896,"lng":-71.1319939}},"Sagrada Familia":{"city":"Curicó","location":{"lat":-34.9984205,"lng":-71.34458219999999}},"Teno":{"city":"Curicó","location":{"lat":-34.8702993,"lng":-71.16640330000001}},"Vichuquén":{"city":"Curicó","location":{"lat":-34.8837446,"lng":-71.99539720000001}},"Linares":{"city":"Linares","location":{"lat":-35.846407,"lng":-71.59961369999996}},"Colbún":{"city":"Linares","location":{"lat":-35.699248,"lng":-71.4146915}},"Longaví":{"city":"Linares","location":{"lat":-35.9636265,"lng":-71.68312509999998}},"Parral":{"city":"Linares","location":{"lat":-36.1399593,"lng":-71.8244406}},"Retiro":{"city":"Linares","location":{"lat":-36.05,"lng":-71.76670000000001}},"San Javier":{"city":"Linares","location":{"lat":-35.5930962,"lng":-71.73250209999998}},"Villa Alegre":{"city":"Linares","location":{"lat":-35.6761961,"lng":-71.7439129}},"Yerbas Buenas":{"city":"Linares","location":{"lat":-35.750077,"lng":-71.5837328}},"Concepción":{"city":"Concepción","location":{"lat":-36.8201352,"lng":-73.0443904}},"Coronel":{"city":"Concepción","location":{"lat":-37.0340769,"lng":-73.14048379999997}},"Chiguayante":{"city":"Concepción","location":{"lat":-36.9532166,"lng":-73.01737800000001}},"Florida":{"city":"Concepción","location":{"lat":-36.8237875,"lng":-72.66847180000002}},"Hualqui":{"city":"Concepción","location":{"lat":-36.9737875,"lng":-72.9368437}},"Lota":{"city":"Concepción","location":{"lat":-37.0920575,"lng":-73.1545822}},"Penco":{"city":"Concepción","location":{"lat":-36.7333,"lng":-72.98329999999999}},"San Pedro de La Paz":{"city":"Concepción","location":{"lat":-36.8305354,"lng":-73.11673680000001}},"Santa Juana":{"city":"Concepción","location":{"lat":-37.1749687,"lng":-72.9457031}},"Talcahuano":{"city":"Concepción","location":{"lat":-36.7247834,"lng":-73.11698079999996}},"Tomé":{"city":"Concepción","location":{"lat":-36.6131562,"lng":-72.95885929999997}},"Hualpén":{"city":"Concepción","location":{"lat":-36.7866757,"lng":-73.10995309999998}},"Lebu":{"city":"Arauco","location":{"lat":-37.6097143,"lng":-73.64832939999997}},"Arauco":{"city":"Arauco","location":{"lat":-37.2457765,"lng":-73.31666439999998}},"Cañete":{"city":"Arauco","location":{"lat":-37.8058201,"lng":-73.39197389999998}},"Contulmo":{"city":"Arauco","location":{"lat":-38.0149266,"lng":-73.22928780000001}},"Curanilahue":{"city":"Arauco","location":{"lat":-37.4762431,"lng":-73.34212430000002}},"Los Álamos":{"city":"Arauco","location":{"lat":-37.6261237,"lng":-73.46226639999998}},"Tirúa":{"city":"Arauco","location":{"lat":-38.3419149,"lng":-73.49551600000001}},"Los Ángeles":{"city":"Biobío","location":{"lat":-37.4629159,"lng":-72.36122510000001}},"Antuco":{"city":"Biobío","location":{"lat":-37.3313164,"lng":-71.67642769999998}},"Cabrero":{"city":"Biobío","location":{"lat":-37.0332999,"lng":-72.39999999999998}},"Laja":{"city":"Biobío","location":{"lat":-37.271425,"lng":-72.71949059999997}},"Mulchén":{"city":"Biobío","location":{"lat":-37.7178812,"lng":-72.23743430000002}},"Nacimiento":{"city":"Biobío","location":{"lat":-37.5059062,"lng":-72.6737875}},"Negrete":{"city":"Biobío","location":{"lat":-37.5862531,"lng":-72.5320562}},"Quilaco":{"city":"Biobío","location":{"lat":-37.6875544,"lng":-71.99866259999999}},"Quilleco":{"city":"Biobío","location":{"lat":-37.4741645,"lng":-71.98362050000003}},"San Rosendo":{"city":"Biobío","location":{"lat":-37.2620301,"lng":-72.72311189999999}},"Santa Bárbara":{"city":"Biobío","location":{"lat":-37.66670000000001,"lng":-72.01670000000001}},"Tucapel":{"city":"Biobío","location":{"lat":-37.2923048,"lng":-71.9512186}},"Yumbel":{"city":"Biobío","location":{"lat":-37.0833,"lng":-72.56669999999997}},"Alto Biobío":{"city":"Biobío","location":{"lat":-38.05,"lng":-71.316667}},"Chillán":{"city":"Ñuble","location":{"lat":-36.6062618,"lng":-72.1023351}},"Bulnes":{"city":"Ñuble","location":{"lat":-36.7421593,"lng":-72.30177179999998}},"Cobquecura":{"city":"Ñuble","location":{"lat":-36.1386156,"lng":-72.79452179999998}},"Coelemu":{"city":"Ñuble","location":{"lat":-36.4833,"lng":-72.69999999999999}},"Coihueco":{"city":"Ñuble","location":{"lat":-36.6291031,"lng":-71.83270929999998}},"Chillán Viejo":{"city":"Ñuble","location":{"lat":-36.6291031,"lng":-72.1397968}},"El Carmen":{"city":"Ñuble","location":{"lat":-36.9,"lng":-72.0333}},"Ninhue":{"city":"Ñuble","location":{"lat":-36.4,"lng":-72.39999999999998}},"Ñiquén":{"city":"Ñuble","location":{"lat":-36.3,"lng":-71.89999999999998}},"Pemuco":{"city":"Ñuble","location":{"lat":-36.9667,"lng":-72.10000000000002}},"Pinto":{"city":"Ñuble","location":{"lat":-36.7,"lng":-71.89409369999998}},"Portezuelo":{"city":"Ñuble","location":{"lat":-36.5267723,"lng":-72.42821329999998}},"Quillón":{"city":"Ñuble","location":{"lat":-36.7338906,"lng":-72.4602031}},"Quirihue":{"city":"Ñuble","location":{"lat":-36.2832999,"lng":-72.5333}},"Ránquil":{"city":"Ñuble","location":{"lat":-36.65256600000001,"lng":-72.59729620000002}},"San Carlos":{"city":"Ñuble","location":{"lat":-36.42615,"lng":-71.97083429999998}},"San Fabián":{"city":"Ñuble","location":{"lat":-36.55,"lng":-71.55000000000001}},"San Ignacio":{"city":"Ñuble","location":{"lat":-36.533333,"lng":-72.433333}},"San Nicolás":{"city":"Ñuble","location":{"lat":-36.5,"lng":-72.2167}},"Treguaco":{"city":"Ñuble","location":{"lat":-36.4211406,"lng":-72.66059369999999}},"Yungay":{"city":"Ñuble","location":{"lat":-37.1220156,"lng":-72.01315620000003}},"Temuco":{"city":"Cautín","location":{"lat":-38.7359018,"lng":-72.59037390000003}},"Carahue":{"city":"Cautín","location":{"lat":-38.7088593,"lng":-73.16788120000001}},"Cunco":{"city":"Cautín","location":{"lat":-38.9320562,"lng":-72.02798430000001}},"Curarrehue":{"city":"Cautín","location":{"lat":-39.3616465,"lng":-71.58902760000001}},"Freire":{"city":"Cautín","location":{"lat":-38.9573,"lng":-72.6269289}},"Galvarino":{"city":"Cautín","location":{"lat":-38.4088593,"lng":-72.78211870000001}},"Gorbea":{"city":"Cautín","location":{"lat":-39.1005597,"lng":-72.67635999999999}},"Lautaro":{"city":"Cautín","location":{"lat":-38.5084312,"lng":-72.45413429999996}},"Loncoche":{"city":"Cautín","location":{"lat":-39.3681199,"lng":-72.63151270000003}},"Melipeuco":{"city":"Cautín","location":{"lat":-38.852306,"lng":-71.69294279999997}},"Nueva Imperial":{"city":"Cautín","location":{"lat":-38.7445218,"lng":-72.9482281}},"Padre Las Casas":{"city":"Cautín","location":{"lat":-38.7667,"lng":-72.60000000000002}},"Perquenco":{"city":"Cautín","location":{"lat":-38.4161093,"lng":-72.37562179999998}},"Pitrufquén":{"city":"Cautín","location":{"lat":-38.9833,"lng":-72.64173119999998}},"Pucón":{"city":"Cautín","location":{"lat":-39.2722541,"lng":-71.97762849999998}},"Saavedra":{"city":"Cautín","location":{"lat":-38.7832999,"lng":-73.39999999999998}},"Teodoro Schmidt":{"city":"Cautín","location":{"lat":-38.9991844,"lng":-73.09429690000002}},"Toltén":{"city":"Cautín","location":{"lat":-39.2043263,"lng":-73.20774360000001}},"Vilcún":{"city":"Cautín","location":{"lat":-38.6677187,"lng":-72.22444059999998}},"Villarrica":{"city":"Cautín","location":{"lat":-39.2820124,"lng":-72.2307798}},"Cholchol":{"city":"Cautín","location":{"lat":-38.6005906,"lng":-72.84114060000002}},"Angol":{"city":"Malleco","location":{"lat":-37.8060734,"lng":-72.70380469999998}},"Collipulli":{"city":"Malleco","location":{"lat":-37.9582687,"lng":-72.43211869999999}},"Curacautín":{"city":"Malleco","location":{"lat":-38.4401849,"lng":-71.88766950000002}},"Ercilla":{"city":"Malleco","location":{"lat":-38.0553156,"lng":-72.38329999999996}},"Lonquimay":{"city":"Malleco","location":{"lat":-38.4541781,"lng":-71.36978720000002}},"Los Sauces":{"city":"Malleco","location":{"lat":-37.9791031,"lng":-72.83448120000003}},"Lumaco":{"city":"Malleco","location":{"lat":-38.16402009999999,"lng":-72.90318460000003}},"Purén":{"city":"Malleco","location":{"lat":-38.0326817,"lng":-73.07182829999999}},"Renaico":{"city":"Malleco","location":{"lat":-37.6737875,"lng":-72.58920620000004}},"Traiguén":{"city":"Malleco","location":{"lat":-38.25,"lng":-72.68330000000003}},"Victoria":{"city":"Malleco","location":{"lat":-38.2326538,"lng":-72.3515084}},"Valdivia":{"city":"Valdivia","location":{"lat":-39.8173788,"lng":-73.24253329999999}},"Corral":{"city":"Valdivia","location":{"lat":-39.8885744,"lng":-73.4315987}},"Lanco":{"city":"Valdivia","location":{"lat":-39.4510195,"lng":-72.77961670000002}},"Los Lagos":{"city":"Valdivia","location":{"lat":-39.8624984,"lng":-72.8185588}},"Máfil":{"city":"Valdivia","location":{"lat":-39.6648976,"lng":-72.9571573}},"Mariquina":{"city":"Valdivia","location":{"lat":-39.540279,"lng":-72.96565199999998}},"Paillaco":{"city":"Valdivia","location":{"lat":-40.0684279,"lng":-72.87484139999998}},"Panguipulli":{"city":"Valdivia","location":{"lat":-39.6436316,"lng":-72.3364942}},"La Unión":{"city":"Ranco","location":{"lat":-40.2952749,"lng":-73.07932799999998}},"Futrono":{"city":"Ranco","location":{"lat":-40.12454109999999,"lng":-72.38084959999998}},"Lago Ranco":{"city":"Ranco","location":{"lat":-40.3211603,"lng":-72.48221230000001}},"Río Bueno":{"city":"Ranco","location":{"lat":-40.3313422,"lng":-72.94853660000001}},"Puerto Montt":{"city":"Llanquihue","location":{"lat":-41.468917,"lng":-72.9411364}},"Calbuco":{"city":"Llanquihue","location":{"lat":-41.7720156,"lng":-73.13270929999999}},"Cochamó":{"city":"Llanquihue","location":{"lat":-41.4923218,"lng":-72.30843119999997}},"Fresia":{"city":"Llanquihue","location":{"lat":-41.15,"lng":-73.41633430000002}},"Frutillar":{"city":"Llanquihue","location":{"lat":-41.116667,"lng":-73.05000000000001}},"Los Muermos":{"city":"Llanquihue","location":{"lat":-41.3994093,"lng":-73.4649905}},"Llanquihue":{"city":"Llanquihue","location":{"lat":-41.2606312,"lng":-73.00784060000001}},"Maullín":{"city":"Llanquihue","location":{"lat":-41.614807,"lng":-73.5990281}},"Puerto Varas":{"city":"Llanquihue","location":{"lat":-41.3167,"lng":-72.98329999999999}},"Castro":{"city":"Chiloé","location":{"lat":-42.4801402,"lng":-73.76241370000002}},"Ancud":{"city":"Chiloé","location":{"lat":-41.8675003,"lng":-73.8276965}},"Chonchi":{"city":"Chiloé","location":{"lat":-42.6232593,"lng":-73.77384990000002}},"Curaco de Vélez":{"city":"Chiloé","location":{"lat":-42.4405468,"lng":-73.60370690000002}},"Dalcahue":{"city":"Chiloé","location":{"lat":-42.377631,"lng":-73.651882}},"Puqueldón":{"city":"Chiloé","location":{"lat":-42.6014407,"lng":-73.67148480000003}},"Queilén":{"city":"Chiloé","location":{"lat":-42.6186043,"lng":-73.78004809999999}},"Quellón":{"city":"Chiloé","location":{"lat":-43.1169327,"lng":-73.61388210000001}},"Quemchi":{"city":"Chiloé","location":{"lat":-42.1427625,"lng":-73.47431819999997}},"Quinchao":{"city":"Chiloé","location":{"lat":-42.5381325,"lng":-73.41877290000002}},"Osorno":{"city":"Osorno","location":{"lat":-40.5761897,"lng":-73.1149469}},"Puerto Octay":{"city":"Osorno","location":{"lat":-40.9768373,"lng":-72.88196160000001}},"Purranque":{"city":"Osorno","location":{"lat":-40.9084312,"lng":-73.16610930000002}},"Puyehue":{"city":"Osorno","location":{"lat":-40.7685941,"lng":-72.236379}},"Río Negro":{"city":"Osorno","location":{"lat":-40.7832999,"lng":-73.23329999999999}},"San Juan de la Costa":{"city":"Osorno","location":{"lat":-40.516667,"lng":-73.39999999999998}},"San Pablo":{"city":"Osorno","location":{"lat":-40.4124031,"lng":-73.01256560000002}},"Chaitén":{"city":"Palena","location":{"lat":-42.9167,"lng":-72.7167}},"Futaleufú":{"city":"Palena","location":{"lat":-43.1833,"lng":-71.86669999999998}},"Hualaihué":{"city":"Palena","location":{"lat":-42.0216398,"lng":-72.6891622}},"Palena":{"city":"Palena","location":{"lat":-43.61669999999999,"lng":-71.80000000000001}},"Coyhaique":{"city":"Coyhaique","location":{"lat":-45.5712254,"lng":-72.068265}},"Lago Verde":{"city":"Coyhaique","location":{"lat":-44.2385218,"lng":-71.85112709999999}},"Aysén":{"city":"Aysén","location":{"lat":-46.5076086,"lng":-74.21337970000002}},"Cisnes":{"city":"Aysén","location":{"lat":-44.75,"lng":-72.69999999999999}},"Guaitecas":{"city":"Aysén","location":{"lat":-43.883333,"lng":-73.75}},"Cochrane":{"city":"Capitán Prat","location":{"lat":-47.2535728,"lng":-72.57298229999998}},"O'Higgins":{"city":"Capitán Prat","location":{"lat":-48.4674467,"lng":-72.55919180000001}},"Tortel":{"city":"Capitán Prat","location":{"lat":-47.8015353,"lng":-73.53584940000002}},"Chile Chico":{"city":"General Carrera","location":{"lat":-46.5409005,"lng":-71.72227950000001}},"Río Ibáñez":{"city":"General Carrera","location":{"lat":-46.3,"lng":-71.933333}},"Punta Arenas":{"city":"Magallanes","location":{"lat":-53.1638329,"lng":-70.91706829999998}},"Laguna Blanca":{"city":"Magallanes","location":{"lat":-52.25,"lng":-71.91666699999996}},"Río Verde":{"city":"Magallanes","location":{"lat":-52.58467899999999,"lng":-71.513733}},"San Gregorio":{"city":"Magallanes","location":{"lat":-52.5531325,"lng":-70.4082396}},"Cabo de Hornos":{"city":"Antártica Chilena","location":{"lat":-55.09916279999999,"lng":-69.27477440000001}},"Antártica":{"city":"Antártica Chilena","location":{"lat":-52.20643159999999,"lng":-72.16850010000002}},"Porvenir":{"city":"Tierra del Fuego","location":{"lat":-53.2957997,"lng":-70.36665449999998}},"Primavera":{"city":"Tierra del Fuego","location":{"lat":-52.716667,"lng":-69.25}},"Timaukel":{"city":"Tierra del Fuego","location":{"lat":-54.294722,"lng":-69.16750000000002}},"Natales":{"city":"Última Esperanza","location":{"lat":-51.73333299999999,"lng":-72.51666699999998}},"Torres del Paine":{"city":"Última Esperanza","location":{"lat":-51.259167,"lng":-72.34500000000003}},"Santiago":{"city":"Santiago","location":{"lat":-33.4488897,"lng":-70.6692655}},"Cerrillos":{"city":"Santiago","location":{"lat":-33.5041325,"lng":-70.71089949999998}},"Cerro Navia":{"city":"Santiago","location":{"lat":-33.4216593,"lng":-70.73468869999999}},"Conchalí":{"city":"Santiago","location":{"lat":-33.3846893,"lng":-70.68002130000002}},"El Bosque":{"city":"Santiago","location":{"lat":-33.5630463,"lng":-70.67521339999996}},"Estación Central":{"city":"Santiago","location":{"lat":-33.4590774,"lng":-70.6990045}},"Huechuraba":{"city":"Santiago","location":{"lat":-33.3742128,"lng":-70.63674249999997}},"Independencia":{"city":"Santiago","location":{"lat":-33.4133469,"lng":-70.6662915}},"La Cisterna":{"city":"Santiago","location":{"lat":-33.5264495,"lng":-70.66135109999999}},"La Florida":{"city":"Santiago","location":{"lat":-33.5226882,"lng":-70.59871420000002}},"La Granja":{"city":"Santiago","location":{"lat":-33.53779310000001,"lng":-70.620678}},"La Pintana":{"city":"Santiago","location":{"lat":-33.5855661,"lng":-70.6285838}},"La Reina":{"city":"Santiago","location":{"lat":-33.4411269,"lng":-70.53405909999998}},"Las Condes":{"city":"Santiago","location":{"lat":-33.4087844,"lng":-70.567069}},"Lo Barnechea":{"city":"Santiago","location":{"lat":-33.352669,"lng":-70.51851699999997}},"Lo Espejo":{"city":"Santiago","location":{"lat":-33.5139265,"lng":-70.69308409999996}},"Lo Prado":{"city":"Santiago","location":{"lat":-33.4442688,"lng":-70.7233493}},"Macul":{"city":"Santiago","location":{"lat":-33.4851471,"lng":-70.5992005}},"Maipú":{"city":"Santiago","location":{"lat":-33.5209155,"lng":-70.76313349999998}},"Ñuñoa":{"city":"Santiago","location":{"lat":-33.4566678,"lng":-70.59784150000002}},"Pedro Aguirre Cerda":{"city":"Santiago","location":{"lat":-33.4940901,"lng":-70.67650259999999}},"Peñalolén":{"city":"Santiago","location":{"lat":-33.4719116,"lng":-70.5627854}},"Providencia":{"city":"Santiago","location":{"lat":-33.4314474,"lng":-70.6093325}},"Pudahuel":{"city":"Santiago","location":{"lat":-33.4421135,"lng":-70.7640644}},"Quilicura":{"city":"Santiago","location":{"lat":-33.3576747,"lng":-70.72927179999999}},"Quinta Normal":{"city":"Santiago","location":{"lat":-33.4317378,"lng":-70.69239170000003}},"Recoleta":{"city":"Santiago","location":{"lat":-33.3972075,"lng":-70.6428148}},"Renca":{"city":"Santiago","location":{"lat":-33.4063601,"lng":-70.72799650000002}},"San Joaquín":{"city":"Santiago","location":{"lat":-33.496202,"lng":-70.62833610000001}},"San Miguel":{"city":"Santiago","location":{"lat":-33.4923545,"lng":-70.65179699999999}},"San Ramón":{"city":"Santiago","location":{"lat":-33.538901,"lng":-70.64249889999996}},"Vitacura":{"city":"Santiago","location":{"lat":-33.3905211,"lng":-70.57241239999996}},"Puente Alto":{"city":"Cordillera","location":{"lat":-33.6186082,"lng":-70.59060569999997}},"Pirque":{"city":"Cordillera","location":{"lat":-33.6793441,"lng":-70.58310689999996}},"San José de Maipo":{"city":"Cordillera","location":{"lat":-33.643169,"lng":-70.34520700000002}},"Colina":{"city":"Chacabuco","location":{"lat":-33.2044597,"lng":-70.67585050000002}},"Lampa":{"city":"Chacabuco","location":{"lat":-33.2827093,"lng":-70.87932799999999}},"Til Til":{"city":"Chacabuco","location":{"lat":-33.1380064,"lng":-70.91770529999997}},"San Bernardo":{"city":"Maipo","location":{"lat":-33.6005906,"lng":-70.7060687}},"Buin":{"city":"Maipo","location":{"lat":-33.7309374,"lng":-70.74232180000001}},"Calera de Tango":{"city":"Maipo","location":{"lat":-33.6291031,"lng":-70.76869679999999}},"Paine":{"city":"Maipo","location":{"lat":-33.8125656,"lng":-70.7375968}},"Melipilla":{"city":"Melipilla","location":{"lat":-33.6861588,"lng":-71.2166838}},"Alhué":{"city":"Melipilla","location":{"lat":-34.0264691,"lng":-71.1002881}},"Curacaví":{"city":"Melipilla","location":{"lat":-33.3977192,"lng":-71.12752119999999}},"María Pinto":{"city":"Melipilla","location":{"lat":-33.51766920000001,"lng":-71.12392210000002}},"San Pedro":{"city":"Melipilla","location":{"lat":-33.8950912,"lng":-71.4563779}},"Talagante":{"city":"Talagante","location":{"lat":-33.6637468,"lng":-70.92739369999998}},"El Monte":{"city":"Talagante","location":{"lat":-33.6815281,"lng":-70.98539679999999}},"Isla de Maipo":{"city":"Talagante","location":{"lat":-33.7464562,"lng":-70.89999999999998}},"Padre Hurtado":{"city":"Talagante","location":{"lat":-33.5749687,"lng":-70.81499050000002}},"Peñaflor":{"city":"Talagante","location":{"lat":-33.6060255,"lng":-70.87818370000002}}};
    var service = {};
    
    service.latlngPattern = latlngPattern;
    service.cities = {};
    service.cities.chile = ChileCities;
    
    
    
    
    
    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('toastService', toastService);

  /** @ngInject */
  function toastService (){
    return {
      toastActivate: toastActivate
    };

    function toastActivate(toastWindow, progressBar, windowClass, progressBarClass, closeCallback) {
      var width = 100;
      var intervalId = setInterval(frame, 200);
      toastWindow.classList.add(windowClass);
      progressBar.classList.add(progressBarClass);

      function frame() {
        if (width <= 0) {
          clearInterval(intervalId);
          intervalId = null;
        } else {
          width--;
          progressBar.style.width = width + '%';
        }
      }

      setTimeout(function () {
        closeCallback();
      }, 20000);

      return intervalId;
    }
  }
})();

(function () {
  angular
    .module('icarus.planner')
    .factory('textUtilsService', textUtilsServiceFactory);

  /** @ngInject */
  function textUtilsServiceFactory(naturalService) {
    return {
      'isBeforeThat': isBeforeThat
    };

    function isBeforeThat(text, textCompare) {
      var compareOptions = {
        sensitivity: 'base'
      };
      var textA = naturalService.naturalValue(text);
      var textB = naturalService.naturalValue(textCompare);
      var result = textA.toUpperCase().localeCompare(
        textB.toUpperCase(),
        undefined,
        compareOptions
      );
      return result < 0;
    }
  }

})();

(function () {
  angular
    .module('icarus.planner')
    .factory('tagService', tagServiceFactory);

  /** @ngInject */
  function tagServiceFactory($http, __env) {
    var tagsUrl = __env.API_URL + 'routes/tags/';
    return {
      'getTags': getTags
    };

    function getTags() {
      return $http.get(tagsUrl)
        .then(function (response) {
          return response.data;
        });
    }
  }

})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("statisticsService", statisticsService);

  function statisticsService(moment, $filter, timeUtils) {

    var MILLISECONDS_PER_MINUTE = 60000;
    var previousHistory = null;

    var statistics = {
      global: {
        vehicleCount: 0,
        routeCount: 0,
        routeCountWithManualChanges: 0,
        totalArrivals: 0,
        totalLoads: [0, 0, 0, 0],
        alertCounts: _getInitialAlertCounts(),
        totalRoutedLoads: [0, 0, 0, 0],
        totalVehiclesCapacity: [0, 0, 0, 0],
        totalPlanVehiclesCapacity: [0, 0, 0, 0]
      },
      byVehicle: {
        time: 0,
        kms: 0,
        loads: [0, 0, 0, 0]
      },
      byRoute: {
        time: 0,
        kms: 0,
        loads: [0, 0, 0, 0]
      }
    };

    var dataByVehicle = {};

    var service = {
      statistics: statistics,
      dataByVehicle: dataByVehicle,
      calculateVisitsTotalLoads: calculateVisitsTotalLoads,
      updateVisitsTotalLoads: updateVisitsTotalLoads,
      recalculateStatistics: recalculateStatistics,
      resetStatistics: resetStatistics,
      resetDataByVehicle: resetDataByVehicle,
      getStatistics: getStatistics,
      saveHistory: saveHistory,
      getHistory: getHistory,
      getTotalRoutedLoads: getTotalRoutedLoads,
      increaseTotalLoads: increaseTotalLoads,
      decreaseTotalLoads: decreaseTotalLoads,
      getTotalLoads: getTotalLoads,
      updateTotalVehiclesCapacity: updateTotalVehiclesCapacity,
      getTotalVehiclesCapacity: getTotalVehiclesCapacity
    };

    return service;

    ////////// public methods //////////

    function recalculateStatistics(vehicles) {
      var accumulator = {
        totalVehicles: 0,
        totalRoutes: 0,
        totalRoutesWithVisits: 0,
        totalRoutesWithManualChanges: 0,
        totalArrivals: 0,
        totalTime: 0,
        totalKmsByVisits: 0,
        loads: [0, 0, 0, 0],
        alertCounts: _getInitialAlertCounts(),
        totalCapacity: [0, 0, 0, 0]
      };

      vehicles.forEach(function (vehicle) {
        var vehicleRoutesLength = vehicle.routes.length;

        if (vehicleRoutesLength > 0) {
          var routesTotals = _calculateStatisticsRoutes(vehicle.routes);
          accumulator.totalVehicles++;
          accumulator.totalRoutes += vehicleRoutesLength;
          accumulator.totalRoutesWithVisits += routesTotals.routesWithVisits;
          accumulator.totalRoutesWithManualChanges += routesTotals.routesWithManualChanges;
          accumulator.totalArrivals += routesTotals.arrivals;
          accumulator.totalTime += routesTotals.duration;
          accumulator.totalKmsByVisits += routesTotals.kms;
          accumulator.loads[0] += routesTotals.loads[0];
          accumulator.loads[1] += routesTotals.loads[1];
          accumulator.loads[2] += routesTotals.loads[2];
          accumulator.loads[3] += routesTotals.loads[3];
          accumulator.alertCounts = _updateAlertCounts(accumulator.alertCounts, routesTotals.alertCounts);
          accumulator.totalCapacity[0] += Number(vehicle.capacity);
          accumulator.totalCapacity[1] += Number(vehicle.capacity2);
          accumulator.totalCapacity[2] += Number(vehicle.capacity3);
          accumulator.totalCapacity[3] += Number(vehicle.capacity4);
          service.dataByVehicle[vehicle.id] = _getVehicleData(routesTotals, vehicleRoutesLength);
        }
      });

      _updateStatistics(service.statistics, accumulator);
    }

    /**
     * Reset statistics
     * @param {Object} statisticsNotToReset contains statistics that should not be reset
     */
    function resetStatistics(statisticsNotToReset) {
      service.statistics.global.vehicleCount = 0;
      service.statistics.global.routeCount = 0;
      service.statistics.global.routeCountWithManualChanges = 0;
      service.statistics.global.totalArrivals = 0;
      service.statistics.global.totalRoutedLoads = [0, 0, 0, 0];
      service.statistics.global.totalLoads = [0, 0, 0, 0];
      service.statistics.byVehicle.time = 0;
      service.statistics.byVehicle.kms = 0;
      service.statistics.byVehicle.loads = [0, 0, 0, 0];
      service.statistics.byRoute.time = 0;
      service.statistics.byRoute.kms = 0;
      service.statistics.byRoute.loads = [0, 0, 0, 0];
      service.statistics.global.alertCounts = _getInitialAlertCounts();
      service.statistics.global.totalPlanVehiclesCapacity = [0, 0, 0, 0];
      resetDataByVehicle();

      if (!statisticsNotToReset.totalVehiclesCapacity) {
        service.statistics.global.totalVehiclesCapacity = [0, 0, 0, 0];
      }
    }

    function resetDataByVehicle() {
      for (var key in service.dataByVehicle) {
        delete service.dataByVehicle[key];
      }
    }

    function calculateVisitsTotalLoads(visits, bigCluster) {
      var totalLoads = {
        load: 0,
        load2: 0,
        load3: 0,
        load4: 0
      };

      return service.updateVisitsTotalLoads(totalLoads, visits, bigCluster);
    }

    function updateVisitsTotalLoads(totalLoads, visits, bigCluster) {
      if (!bigCluster) {
        totalLoads.load += _sumVisitsLoad(visits, "load");
        totalLoads.load2 += _sumVisitsLoad(visits, "load2");
        totalLoads.load3 += _sumVisitsLoad(visits, "load3");
        totalLoads.load4 += _sumVisitsLoad(visits, "load4");
        totalLoads = _formatTotalLoads(totalLoads);
      }

      return totalLoads;
    }

    function getStatistics() {
      return angular.merge({}, service.statistics);
    }

    function saveHistory() {
      previousHistory = angular.merge({}, service.statistics);
    }

    function getHistory() {
      return angular.merge({}, previousHistory);
    }

    ////// private methods //////

    function _calculateStatisticsRoutes(routes) {
      var totals = {
        kms: 0,
        kmsFixed: 0,
        duration: 0,
        routesWithVisits: 0,
        routesWithManualChanges: 0,
        arrivals: 0,
        visitCount: 0,
        clientCount: 0,
        loads: [0, 0, 0, 0],
        loadsPercentage: [0, 0, 0, 0],
        alertCounts: _getInitialAlertCounts()
      };

      routes.forEach(function (route) {
        var visitCount = route.visits.length;
        if (visitCount > 0) {
          totals.routesWithVisits++;
        }

        if (route.hasManualChanges) {
          totals.routesWithManualChanges++;
        }

        var routeDistance = route.totalDistance;
        totals.kms += routeDistance;
        totals.kmsFixed += Number(routeDistance.toFixed(2));
        totals.duration += moment.duration(route.totalTimeFormatted).asMinutes();
        totals.arrivals += route.arrivals.length;
        totals.visitCount += visitCount;
        totals.clientCount += route.clientCount;
        totals.loads[0] += route.totalLoad || 0;
        totals.loads[1] += route.totalLoad2 || 0;
        totals.loads[2] += route.totalLoad3 || 0;
        totals.loads[3] += route.totalLoad4 || 0;
        totals.loadsPercentage[0] += parseInt(Number(route.totalLoadPercentage));
        totals.loadsPercentage[1] += parseInt(Number(route.totalLoadPercentage2));
        totals.loadsPercentage[2] += parseInt(Number(route.totalLoadPercentage3));
        totals.loadsPercentage[3] += parseInt(Number(route.totalLoadPercentage4));
        totals.alertCounts = _updateAlertCounts(totals.alertCounts, route.alertCounts);
      });

      return totals;
    }

    function _getVehicleData(routesTotals, vehicleRoutesLength) {
      var vehicleData = {
        totalArrivals: 0,
        visitCount: 0,
        clientCount: 0,
        totalTime: 0,
        totalKms: 0,
        totalLoads: [],
        averageLoadsPercentage: []
      };

      vehicleData.totalArrivals = routesTotals.arrivals;
      vehicleData.visitCount = routesTotals.visitCount;
      vehicleData.clientCount = routesTotals.clientCount;
      vehicleData.totalTime = timeUtils.formatDuration(routesTotals.duration * MILLISECONDS_PER_MINUTE);
      vehicleData.totalKms = routesTotals.kmsFixed.toFixed(2);
      vehicleData.totalLoads = Array.from(routesTotals.loads);
      vehicleData.averageLoadsPercentage = routesTotals.loadsPercentage.map(function (totalLoadPercentage) {
        var averageLoadPercentage = (totalLoadPercentage / vehicleRoutesLength).toFixed(0);
        return $filter("formatNumber")(averageLoadPercentage, 0);
      });

      return vehicleData;
    }

    function _updateStatistics(statistics, accumulator) {
      var totalVehicles = accumulator.totalVehicles;
      var totalRoutesWithVisits = accumulator.totalRoutesWithVisits;

      statistics.global.vehicleCount = totalVehicles;
      statistics.global.routeCount = accumulator.totalRoutes;
      statistics.global.routeCountWithManualChanges = accumulator.totalRoutesWithManualChanges;
      statistics.global.totalArrivals = accumulator.totalArrivals;
      statistics.byVehicle.time = _getAverageTime(accumulator.totalTime, totalVehicles);
      statistics.byRoute.time = _getAverageTime(accumulator.totalTime, totalRoutesWithVisits);
      statistics.byVehicle.kms = _getAverageKms(accumulator.totalKmsByVisits, totalVehicles);
      statistics.byRoute.kms = _getAverageKms(accumulator.totalKmsByVisits, accumulator.totalRoutes);
      statistics.global.alertCounts = accumulator.alertCounts;

      accumulator.loads.forEach(function (load, i) {
        statistics.global.totalRoutedLoads[i] = load;
        statistics.byVehicle.loads[i] = (totalVehicles > 0 ? (load / totalVehicles) : 0).toFixed(1);
        statistics.byRoute.loads[i] = (totalRoutesWithVisits > 0 ? (load / totalRoutesWithVisits) : 0).toFixed(1);
      });
      accumulator.totalCapacity.forEach(function (capacity, i) {
        statistics.global.totalPlanVehiclesCapacity[i] = capacity;
      });
    }

    function _getAverageTime(totalTime, numberOfElements) {
      var averageMinutes = (numberOfElements > 0 ? (totalTime / numberOfElements) : 0).toFixed(0);
      var averageTime = moment.duration({ 'minutes': averageMinutes });
      return Math.floor(averageTime.asHours()) + moment.utc(averageTime.asMilliseconds()).format(":mm");
    }

    function _getAverageKms(totalKmsByVisits, numberOfElements) {
      var averageKms = (totalKmsByVisits / numberOfElements).toFixed(1);
      return $filter("formatNumber")(averageKms);
    }

    function _sumVisitsLoad(visits, typeLoad) {
      return visits.reduce(function(accLoad, visit) {
        var visitLoad = visit[typeLoad];
        return visitLoad ? accLoad + visitLoad : accLoad;
      }, 0);
    }

    function _formatTotalLoads(totalLoads) {
      return Object.entries(totalLoads).reduce(function(accFormattedLoads, value) {
        var key = value[0];
        var load = value[1];
        accFormattedLoads[key] = load > 0 ? $filter('formatNumber')(load) : 0;
        return accFormattedLoads;
      }, {});
    }

    function _getInitialAlertCounts() {
      return {
        capacityError: 0,
        capacityError2: 0,
        capacityError3: 0,
        capacityError4: 0,
        maximumTimeError: 0,
        maxVisitError: 0,
        skillsError: 0,
        timeError: 0
      };
    }

    function _updateAlertCounts(accumulator, routeAlerts) {
      var alerts = Object.keys(accumulator);
      alerts.forEach(function (key) {
        accumulator[key] += routeAlerts[key] || 0;
      });
      return accumulator;
    }

    function getTotalRoutedLoads() {
      return service.statistics.global.totalRoutedLoads;
    }

    function increaseTotalLoads(visit) {
      statistics.global.totalLoads[0] += Number(visit.load);
      statistics.global.totalLoads[1] += Number(visit.load2);
      statistics.global.totalLoads[2] += Number(visit.load3);
      statistics.global.totalLoads[3] += Number(visit.load4);
    }

    function decreaseTotalLoads(visit) {
      statistics.global.totalLoads[0] -= Number(visit.load);
      statistics.global.totalLoads[1] -= Number(visit.load2);
      statistics.global.totalLoads[2] -= Number(visit.load3);
      statistics.global.totalLoads[3] -= Number(visit.load4);
    }

    function getTotalLoads() {
      return service.statistics.global.totalLoads;
    }

    function updateTotalVehiclesCapacity(vehicles) {
      statistics.global.totalVehiclesCapacity = [0, 0, 0, 0];
      vehicles.forEach(function (vehicle) {
        statistics.global.totalVehiclesCapacity[0] += Number(vehicle.capacity);
        statistics.global.totalVehiclesCapacity[1] += Number(vehicle.capacity2);
        statistics.global.totalVehiclesCapacity[2] += Number(vehicle.capacity3);
        statistics.global.totalVehiclesCapacity[3] += Number(vehicle.capacity4);
      });
    }

    function getTotalVehiclesCapacity() {
      return service.statistics.global.totalVehiclesCapacity;
    }
  }
})();

/* global google:false, ConvexHullGrahamScan:false */
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('PlannerRouteModel', PlannerRouteModel);

  /** @ngInject */

  function PlannerRouteModel($log, $q, moment, __env, $http, $rootScope, googleService, osrmService, utilsService,
                             ROUTE_VISIBLE_OPACITY, VISIT_TYPE, START_TIME_WINDOW, END_TIME_WINDOW) {

    function PlannerRoute(vehicleId) {
      // Backend properties
      this.backendId = null;
      this.plannedDate = null;
      this.vehicleId = vehicleId;
      this.driver = null;
      this.codrivers = [];
      this.estimatedTimeStart = '00:00';
      this.estimatedTimeEnd = '00:00';
      this.totalTime = '00:00';
      this.totalTimeFormatted = '00:00';
      this.totalDistance = 0;
      this.routeDistance = null;
      this.totalLoad = 0;
      this.totalLoad2 = 0;
      this.totalLoad3 = 0;
      this.totalLoad4 = 0;
      this.totalLoadPercentage = 0;
      this.totalLoadPercentage2 = 0;
      this.totalLoadPercentage3 = 0;
      this.totalLoadPercentage4 = 0;
      this.visits = [];
      this.visitsAndEvents = [];
      this.arrivals = [];
      this.clientCount = 0;
      this.locationStart = {
        address: null,
        latitude: null,
        longitude: null
      };
      this.locationEnd = {
        address: null,
        latitude: null,
        longitude: null
      };
      this.comment = null;

      // Local properties
      this.collapse = true;
      this.id = utilsService.guid();
      this.path = [];
      this.visible = true;
      this.editable = false;
      this.geodesic = true;
      this.stroke = {
        color: '#586BA4',
        weight: 3,
        opacity: 1.0
      };
      this.capacityError = false;
      this.capacityError2 = false;
      this.capacityError3 = false;
      this.capacityError4 = false;
      this.timeError = false;
      this.skillsError = false;
      this.hasRestTimeError = false;
      this.areVisitsListed = false;
      this.createAt = null;
      this.formattedLoad = '';
      this.formattedLoad2 = '';
      this.formattedLoad3 = '';
      this.formattedLoad4 = '';
      this.startTime = null;
      this.endTime = null;
      this.hasManualChanges = false;
      this.editingSelected = false;
      this.alertCounts = {
        capacityError: 0,
        capacityError2: 0,
        capacityError3: 0,
        capacityError4: 0,
        timeError: 0,
        skillsError: 0,
        maximumTimeError: 0,
        maxVisitError: 0
      };
      this.areVisitsMarkersVisible = true;
      this.isRevised = false;
      this.status = null;
    }

    PlannerRoute.createInstance = function (vehicleId) {
      return new PlannerRoute(vehicleId);
    };

    PlannerRoute.prototype.save = function (vehicle, driverId, codrivers, planId, planDate, editing) {
      var self = this, ROUTES_PATH = __env.API_URL + 'routes/routes/';
      var totalTimeForSave;
      //proceso para obtener el total time
      var splitTimeFirst = this.totalTime.split(' ');
      if (splitTimeFirst.length > 1) { //have days
        totalTimeForSave = (splitTimeFirst[1].split(':').length >= 3) ? this.totalTime : this.totalTime + ":00";
      } else { // no days
        totalTimeForSave = (splitTimeFirst[0].split(':').length >= 3) ? this.totalTime : this.totalTime + ":00";
      }

      var requestData = {
        vehicle: this.vehicleId,
        driver: driverId,
        plan: planId,
        estimated_time_start: this.estimatedTimeStart,
        estimated_time_end: this.estimatedTimeEnd,
        status: "assigned",
        total_duration: totalTimeForSave,
        total_distance: (this.totalDistance * 1000).toFixed(0), //(editing) ? this.totalDistance :
        total_load: this.totalLoad,
        total_load_percentage: parseFloat(this.totalLoadPercentage).toFixed(0),
        total_load_2: this.totalLoad2,
        total_load_2_percentage: parseFloat(this.totalLoadPercentage2).toFixed(0),
        total_load_3: this.totalLoad3,
        total_load_3_percentage: parseFloat(this.totalLoadPercentage3).toFixed(0),
        total_load_4: this.totalLoad4,
        total_load_4_percentage: parseFloat(this.totalLoadPercentage4).toFixed(0),
        location_start_address: vehicle.locationStart.address,
        location_start_latitude: vehicle.locationStart.latitude,
        location_start_longitude: vehicle.locationStart.longitude,
        location_end_address: vehicle.locationEnd.address,
        location_end_latitude: vehicle.locationEnd.latitude,
        location_end_longitude: vehicle.locationEnd.longitude,
        comment: this.comment
      };

      if (!editing || (angular.isUndefined(self.backendId) || self.backendId === null)) {
        requestData.planned_date = moment(planDate.start).format('YYYY-MM-DD');
      }

      if (angular.isUndefined(self.backendId) || self.backendId === null) {
        return $http.post(ROUTES_PATH, requestData)
          .then(successSavingRoute, errorSavingRoute);
      } else {
        return $http.patch(ROUTES_PATH + self.backendId + '/', requestData)
          .then(successSavingRoute, errorSavingRoute);
      }

      function successSavingRoute(response) {
        if (response) {
          self.backendId = response.data.id;
        }
        return $q.resolve(response.data);
      }

      function errorSavingRoute(error) {
        $log.error(error);
        return $q.reject(error);
      }
    };

    PlannerRoute.prototype.addVisitToRoute = function (visit) {
      visit.routeId = this.id;
      visit.vehicle = this.vehicleId;
      visit.updateOrder(this.visits.length + 1, false);
      this.visits.push(visit);
      return visit;
    };

    PlannerRoute.prototype.addVisit = function (visit, isVisitVisible, markerHasToBeUpdated) {
      if (angular.isUndefined(isVisitVisible)) {
        isVisitVisible = true;
      }
      if (angular.isUndefined(markerHasToBeUpdated)) {
        markerHasToBeUpdated = true;
      }
      visit.routeId = this.id;
      visit.vehicle = this.vehicleId;
      visit.selected = false;
      if (this.visible && isVisitVisible) {
        visit.setVisible(true, false);
      }
      visit.updateOrder(this.visits.length + 1, markerHasToBeUpdated);
      this.visits.push(visit);
      return visit;
    };

    PlannerRoute.prototype.removeVisit = function (visit, doNotRemoveId) {
      visit.routeId = doNotRemoveId ? visit.routeId : null;
      visit.vehicle = null;
      visit.estimatedTimeArrival = null;
      visit.estimatedTimeDeparture = null;
      this.visits.splice(this.visits.indexOf(visit), 1);
    };

    /**
     * @description remove visits from route
     */
    PlannerRoute.prototype.clear = function () {
      this.clearVisits();
    };

    /**
     * @description delete the vehicle and route data in the visits and remove all visits
     */
    PlannerRoute.prototype.clearVisits = function () {
      var visit = this.visits.shift();
      while (visit) {
        visit.routeId = null;
        visit.vehicle = null;
        visit.estimatedTimeArrival = null;
        visit.estimatedTimeDeparture = null;
        visit = this.visits.shift();
      }
    };

    PlannerRoute.prototype.setVisible = function (visible, hasToBeUpdated) {
      if (angular.isUndefined(hasToBeUpdated)) {
        hasToBeUpdated = true;
      }
      if (angular.isUndefined(visible)) {
        visible = true;
        this.setOpacity(ROUTE_VISIBLE_OPACITY, hasToBeUpdated);
      }

      this.visible = visible;

      if (hasToBeUpdated) {
        this.actionUpdate(this);
      }
    };

    PlannerRoute.prototype.setVisibleWithoutOpacity = function (visible) {
      if (angular.isUndefined(visible)) {
        visible = true;
      }

      this.visible = visible;
      this.actionUpdate(this);
    };

    PlannerRoute.prototype.setOpacity = function (opacity, mustUpdateMapElement) {
      this.stroke.opacity = opacity;

      mustUpdateMapElement = angular.isUndefined(mustUpdateMapElement) || mustUpdateMapElement;
      if (mustUpdateMapElement) {
        this.actionUpdate(this);
      }
    };

    PlannerRoute.prototype.setVisitsListed = function (listed) {
      this.areVisitsListed = listed;
    };

    PlannerRoute.prototype.setStrokeColor = function (color) {
      this.stroke.color = color;
    };

    PlannerRoute.prototype.clearCapacityErrors = function () {
      this.capacityError = false;
      this.capacityError2 = false;
      this.capacityError3 = false;
    };

    PlannerRoute.prototype.createVisitsMarkers = function () {
      this.visits.forEach(function (visit) {
        visit.actionCreate(visit);
      });
    };

    PlannerRoute.prototype.calculatePath = function (vehicle, optimizationOptions, startTime, isVehicularRestrictionEnabled) {
      var isOpenStartActive = optimizationOptions.open_start;
      var isOpenEndedActive = optimizationOptions.open_ended;
      var isBigClusterActive = optimizationOptions.big_cluster;
      var isBigOrDrawClusterActive = isBigClusterActive || $rootScope.drawCluster;
      var routeIndex = vehicle.routes.indexOf(this);
      var isTheFirstRoute = routeIndex === 0;
      var isTheLastRoute = routeIndex === vehicle.routes.length - 1;
      var visitCoordinates = this.visits.map(function (visit) {
        return visit.latitude + ',' + visit.longitude;
      });
      var routeCoordinates = Array.from(visitCoordinates);

      if (!(isOpenStartActive && isTheFirstRoute)) {
        routeCoordinates.unshift(vehicle.locationStart.latitude + ',' + vehicle.locationStart.longitude);
      }

      if (!(isOpenEndedActive && !isBigClusterActive && isTheLastRoute)) {
        routeCoordinates.push(vehicle.locationEnd.latitude + ',' + vehicle.locationEnd.longitude);
      }

      if (isBigOrDrawClusterActive) {
        _createConvexHull(this, visitCoordinates);
      }

      return osrmService.callOSRMForDistance(
        this, routeCoordinates, isBigOrDrawClusterActive, optimizationOptions, startTime, isVehicularRestrictionEnabled, vehicle.id
      )
        .catch(function (error) {
          console.error('OSRM Error', error);
        });

      function _createConvexHull(route, coordinates) {
        var convexHull = new ConvexHullGrahamScan();
        coordinates.forEach(function (coord) {
          var point = coord.split(',');
          var lat = point[0].trim();
          var lng = point[1].trim();
          convexHull.addPoint(lng, lat);
        });

        // Two visits make a point on the convex hull.
        if (convexHull.points.length > 0) {
          var hullPoints = convexHull.getHull();

          //Convert to google latlng objects
          hullPoints = hullPoints.map(function (item) {
            return googleService.getGoogleMapsLatLng(item.y, item.x);
          });
          route.path = hullPoints;
        }
      }
    };

    //Map manager
    PlannerRoute.prototype.actionCreate = function (route) {
      $rootScope.$broadcast("Planner:Route:Create", {
        route: route
      });
    };

    PlannerRoute.prototype.actionUpdate = function (route) {
      $rootScope.$broadcast("Planner:Route:Update", {
        route: route
      });
    };

    PlannerRoute.prototype.actionRemove = function (route) {
      $rootScope.$broadcast("Planner:Route:Remove", {
        route: route
      });
    };

    PlannerRoute.prototype.setHasManualChanges = function (value) {
      this.hasManualChanges = value;
    };

    PlannerRoute.prototype.isStarted = function () {
      if (this.startTime || this.endTime) {
        return true;
      }
      for (var visitIndex in this.visits) {
        if (this.visits[visitIndex].checkoutTime) {
          return true;
        }
      }
      return false;
    };

    PlannerRoute.prototype.changeVehicle = function (vehicleSrc, vehicleDest) {
      var self = this;

      // Remove route from source vehicle
      var routeIndex = vehicleSrc.routes.findIndex(function (route) {
        return route.id === self.id;
      });

      vehicleSrc.routes.splice(routeIndex, 1);
      self.actionRemove(self);

      // Update route and add it to the destination vehicle
      self.collapse = true;
      self.vehicleId = vehicleDest.id;

      self.visits.forEach(function (visit) {
        visit.vehicle = vehicleDest.id;
        visit.setSelected(false);
        visit.setDefaultColor(vehicleDest.color);
        visit.actionUpdate(visit);
      });

      vehicleDest.addRoute(self);
      self.actionCreate(self);
    };

    PlannerRoute.prototype.resetAlertCounts = function () {
      this.alertCounts.capacityError = 0;
      this.alertCounts.capacityError2 = 0;
      this.alertCounts.capacityError3 = 0;
      this.alertCounts.timeError = 0;
      this.alertCounts.skillsError = 0;
      this.alertCounts.maximumTimeError = 0;
      this.alertCounts.maxVisitError = 0;
    };

    PlannerRoute.prototype.calculateAlertCounts = function (visit) {
      for (var alert in this.alertCounts) {
        if (visit[alert]) {
          this.alertCounts[alert]++;
        }
      }
    };

    PlannerRoute.prototype.hasLoads = function () {
      return this.totalLoad > 0 || this.totalLoad2 > 0 || this.totalLoad3 > 0 || this.totalLoad4 > 0;
    };

    PlannerRoute.prototype.updateVisitsAndEvents = function (plannerService) {
      var route = this;
      var eventByRoute = plannerService.isRestTimeEnabled() ? plannerService.getRestTimeByRouteId(route.id) : null;

      if (!eventByRoute) {
        route.visitsAndEvents = Array.from(route.visits);
        return;
      }

      var isEventAdded = false;
      route.visitsAndEvents = [];

      route.visits.forEach(function (visit) {
        if (isEventAdded) {
          route.visitsAndEvents.push(visit);
          return;
        }

        if (angular.isNumber(eventByRoute.order) && eventByRoute.order < visit.order) {
          route.visitsAndEvents.push(eventByRoute);
          isEventAdded = true;
        }

        route.visitsAndEvents.push(visit);
      });

      if (!isEventAdded) {
        route.visitsAndEvents.push(eventByRoute);
      }
    };

    PlannerRoute.prototype.updateVisits = function (updatedVisitsAndEvents) {
      var route = this;

      route.visits = updatedVisitsAndEvents.filter(function (visit) {
        return visit.type === VISIT_TYPE.VISIT;
      });

      route.visits.forEach(function (visit, index) {
        visit.updateOrder(index + 1, false);
      });
    };

    PlannerRoute.prototype.reverseVisits = function (plannerService) {
      var route = this;

      route.visits = route.visits.reverse().map(function (visit, index) {
        visit.updateOrder(index + 1, false);
        return visit;
      });

      var currentEventIndex = route.visitsAndEvents.findIndex(function (visit) {
        return visit.type === VISIT_TYPE.EVENT;
      });

      if (currentEventIndex >= 0) {
        var eventByRoute = plannerService.getRestTimeByRouteId(route.id);

        var lastIndex = route.visitsAndEvents.length - 1;
        var updatedEventIndex = lastIndex - currentEventIndex;

        eventByRoute.order = updatedEventIndex;
        eventByRoute.startTime = START_TIME_WINDOW;
        eventByRoute.endTime = END_TIME_WINDOW;

        plannerService.setRestTimeByRouteId(route.id, eventByRoute);
      }
    };

    return PlannerRoute;
  }

})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('routeHelperService', routeHelperService);

  function routeHelperService() {

    return {
      round: round,
      getValidLoad: getValidLoad,
      getValidLoadPercentage: getValidLoadPercentage
    };

    /**
     * Round a number to a maximum of n decimals places
     * @param {Number} number number source
     * @param {Int} decimalPlaces decimal places to fixed | default 0
     * @returns number result
     */
    function round(number, decimalPlaces) {
      if (!decimalPlaces) { decimalPlaces = 0; }
      var p = Math.pow(10, decimalPlaces);
      return Math.round(number * p) / p;
    }

    /**
     * Return a load with a valid format
     * @param {String | Number} loadSrc load source data
     * */
    function getValidLoad(loadSrc) {
      var load = Number(loadSrc);
      return load ? load : 0;
    }

    /**
     * Return the load percentage
     * @param {String | Number} loadSrc load source data
     * @param {String | Number} capacitySrc maximun of load
     * */
    function getValidLoadPercentage(loadSrc, capacitySrc) {
      var load = getValidLoad(loadSrc);
      var capacity = getValidLoad(capacitySrc);
      if (load > 0 && capacity > 0) {
        return round(100 * (load / capacity), 0);
      }
      return 0;
    }

  }

})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("routeDesignFilterService", routeDesignFilterService);

  /** @ngInject */
  function routeDesignFilterService(
    $location,
    $anchorScroll,
    $timeout,
    $rootScope
  ) {

    var service = {};
    var searchData = {};
    var REMOVE_SEARCH_EVENT = 'Clear search step 3';
    var SEARCH_EVENT = 'Search step 3';

    function escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    service.filterStatusHandler = {
      routes: {},
      visits: {},
      vehicles: {},
      activeFilter: false,
      visitsOffRoute: false,
      hoverActiveAnotherVisit: false,
      clear: function () {
        this.routes = {};
        this.visits = {};
        this.vehicles = {};
        this.activeFilter = false;
        this.visitsOffRoute = false;
      },
    };

    service.filters = {
      visits: {
        title: "visits",
        filter: function (data, pattern) {
          var regex = new RegExp(escapeRegExp(pattern), "gi");
          return data.visits.filter(function (visit) {
            return visit.title.match(regex);
          });
        },
        attrShowed: "title",
      },
      vehicles: {
        title: "vehicles",
        filter: function (data, pattern) {
          var regex = new RegExp(escapeRegExp(pattern), "gi");
          return data.vehicles.filter(function (vehicle) {
            return vehicle.name.match(regex);
          });
        },
        attrShowed: "name",
      },
      reference: {
        title: "references",
        filter: function (data, pattern) {
          var regex = new RegExp(escapeRegExp(pattern), "gi");
          return data.visits.filter(function (visit) {
            return visit.reference.match(regex);
          });
        },
        attrShowed: "reference",
      },
    };

    service.applyResultToVM = function (viewModel, result) {
      var visitsOffRoute = false;
      var anyVisitWithVehicle = false;
      var route;

      service.filterStatusHandler.clear();
      service.filterStatusHandler.activeFilter = true;

      if (result.type === "visits" || result.type === "reference") {
        result.elements.forEach(function (visit) {
          service.filterStatusHandler.visits[visit.id] = true;
          if (visit.vehicle) {
            anyVisitWithVehicle = true;
            service.filterStatusHandler.vehicles[visit.vehicle] = true;
            service.filterStatusHandler.routes[visit.routeId] = true;
          }
          else {
            visitsOffRoute = true;
          }
        });

        viewModel.showVisitsOutOfRoutes = visitsOffRoute;
        service.filterStatusHandler.visitsOffRoute = visitsOffRoute;
      }

      if (result.type === "vehicles") {
        result.elements[0].routes.forEach(function (route) {
          service.filterStatusHandler.routes[route.id] = true;
        });
        route = result.elements[0].routes[0];
        route.collapse = true;
        viewModel.toggleCollapseRoute(route);
        service.filterStatusHandler.vehicles[result.elements[0].id] = true;
      }

      searchData.showVehicles(
        service.filterStatusHandler,
        viewModel.optimizationOptions
      );

      service.trackSearchEvent(
        result.type, viewModel.showVisitsOutOfRoutes,
        anyVisitWithVehicle, service.filterStatusHandler
      );
    };

    service.trackSearchEvent = function (searchCriteria, visitOffRoute, normalVisit, filterStatusHandler) {
      var visitType = null;
      var resultAmount = null;
      var visitOnRouteProp = 'visit on route';
      var visitOffRouteProp = 'visit off route';
      var visitOffRouteAndOnRouteProp = 'visit off route and visit on route';

      if (searchCriteria === 'reference' || searchCriteria === 'visits') {
        resultAmount = Object.keys(filterStatusHandler.visits).length;
      } else if (searchCriteria === 'vehicles') {
        resultAmount = Object.keys(filterStatusHandler.vehicles).length;
      }

      if (searchCriteria !== "vehicles") {
        if (visitOffRoute) {
          visitType = normalVisit ?
            visitOffRouteAndOnRouteProp : visitOffRouteProp;
        } else {
          visitType = visitOnRouteProp;
        }
      }
    };

    service.moveToFirstResult = function (route) {
      if (!Object.keys(service.filterStatusHandler.visits).length) {
        return;
      }
      var visit = null;
      visit = route.visits.find(function (_visit) {
        return service.filterStatusHandler.visits[_visit.id];
      });

      $timeout(function () {
        var hash = "visit-" + visit.id;
        $location.hash(hash);
        $anchorScroll();
      }, 850);
    };

    service.removeResultFromVM = function (viewModel) {
      service.filterStatusHandler.activeFilter = false;
      searchData.showVehicles(
        service.filterStatusHandler,
        viewModel.optimizationOptions
      );
      viewModel.showVisitsOutOfRoutes = true;
      var routeNotCollapse = viewModel.routes.find(function (route) {
        return !route.collapse;
      });
      if (routeNotCollapse) {
        routeNotCollapse.collapse = true;
        viewModel.toggleCollapseRoute(routeNotCollapse);
      }
      service.filterStatusHandler.clear();
    };

    service.getSearchDataBinding = function (callbackToGetVehicles, visits) {
      var vehicles = callbackToGetVehicles();
      searchData = {
        showVehicles: function (
          filterHandler,
          optimizationOptions
        ) {
          vehicles.forEach(function (vehicle) {
            if (filterHandler.activeFilter) {
              vehicle.setVisible(
                Boolean(filterHandler.vehicles[vehicle.id]),
                optimizationOptions.isOpenEndedActive
              );
              vehicle.routes.map(function (route) {
                route.setVisibleWithoutOpacity(
                  Boolean(filterHandler.routes[route.id])
                );
                route.visits.map(function (visit) {
                  visit.setVisible(Boolean(filterHandler.routes[route.id]), !$rootScope.drawCluster);
                });
              });
            } else {
              vehicle.showAllRoutes(
                vehicle.showRoutes,
                vehicle.showRoutes,
                optimizationOptions
              );
            }
          });
        },
      };
      Object.defineProperty(searchData, "vehicles", {
        get: function () {
          return callbackToGetVehicles();
        },
      });
      Object.defineProperty(searchData, "visits", {
        get: function () {
          return visits;
        },
      });
      return searchData;
    };

    service.setHoverActiveAnotherVisit = function (active) {
      service.filterStatusHandler.hoverActiveAnotherVisit = active;
    };

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('rdMigrationOptinService', rdMigrationOptinService);

  /** @ngInject */
  function rdMigrationOptinService($http, $q, $log, __env, addonsService,
                                   PATH_FINDER_ADD_ON_KEY,
                                   PATH_FINDER_ADD_ON_PROPERTIES,
                                   RD_MIGRATION_DEADLINE) {
    var OPT_IN_PATH = __env.API_URL + 'rd-migration/opt-in';
    var LEGACY_ALLOWED_ROLES = ['is_admin', 'is_router', 'is_router_jr'];
    var RBAC_OPT_IN_PERMISSION = 'pathfinder.router.edit';

    return {
      hasApolloRdAccess: hasApolloRdAccess,
      isBannerEnabled: isBannerEnabled,
      canOptIn: canOptIn,
      getDeadline: getDeadline,
      optIn: optIn
    };

    function isBannerEnabled() {
      return _readPathFinderAddon()
        .then(function (addon) {
          if (!addon) return false;
          var props = _propertiesByKey(addon);
          var key = PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_APOLLO_ROUTE_DESIGNER;
          var raw = props[key];
          if (raw === undefined || raw === null) return false;
          var value = String(raw).trim().toLowerCase();
          if (value === '') return false;
          return value !== 'true';
        })
        .catch(function (err) {
          return false;
        });
    }

    function hasApolloRdAccess(userId) {
      if (!userId) {
        return $q.resolve(false);
      }
      return _readPathFinderAddon()
        .then(function (addon) {
          if (!addon) return false;
          var props = _propertiesByKey(addon);
          var accountWide = (props.enabled_apollo_route_designer || '').toLowerCase() === 'true';
          if (accountWide) return true;
          var ids = _parseUserIds(props.enabled_apollo_rd_for_user_ids);
          return ids.indexOf(userId) !== -1;
        })
        .catch(function (err) {
          $log.warn('rdMigrationOptinService.hasApolloRdAccess failed', err);
          return false;
        });
    }

    function canOptIn(user) {
      if (!user) return false;

      // RBAC-based (granular permissions)
      var role = user.role;
      if (role) {
        if (role.legacy_role && LEGACY_ALLOWED_ROLES.indexOf(role.legacy_role) !== -1) {
          return true;
        }
        if (Array.isArray(role.permissions) && role.permissions.indexOf(RBAC_OPT_IN_PERMISSION) !== -1) {
          return true;
        }
      }

      // Legacy flags
      if (user.is_owner || user.is_admin || user.is_router || user.is_router_jr) {
        return true;
      }

      return false;
    }

    function getDeadline() {
      return _readPathFinderAddon()
        .then(function (addon) {
          if (!addon) return null;
          var props = _propertiesByKey(addon);
          var override = props[PATH_FINDER_ADD_ON_PROPERTIES.RD_MIGRATION_DEADLINE];
          return override || RD_MIGRATION_DEADLINE || null;
        })
        .catch(function (err) {
          $log.warn('rdMigrationOptinService.getDeadline failed', err);
          return null;
        });
    }

    function optIn() {
      return $http.post(OPT_IN_PATH, {}).then(function (response) {
        return response.data;
      });
    }

    // --- Helpers --------------------------------------------------------------

    function _readPathFinderAddon() {
      return addonsService.getInfoAddonAndPropertiesByKey(PATH_FINDER_ADD_ON_KEY);
    }

    function _propertiesByKey(addon) {
      var properties = addon && addon.properties ? addon.properties : [];
      var map = {};
      for (var i = 0; i < properties.length; i++) {
        var p = properties[i];
        if (p && p.key) map[p.key] = p.value;
      }
      return map;
    }

    function _parseUserIds(rawJson) {
      if (!rawJson) return [];
      try {
        var parsed = JSON.parse(rawJson);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('plannerUtilsService', plannerUtilsService);

  /** @ngInject */
  function plannerUtilsService($location) {
    return {
      getLastSimilarWithMarker: getLastSimilarWithMarker,
      isEditModeActive: isEditModeActive
    };

    /**
     * Sort visits in descending order to return the last  similar visit
     * If the visit has no route, it returns the first visit found in the visits markers
     * @param {Object} visit object
     * @param {Array} similarVisits
     * @param {Object} visitsMarkers
     * @returns {Object} visit object
     */
    function getLastSimilarWithMarker(visit, similarVisits, visitsMarkers) {
      if (!visit.routeId) {
        var visitParent = similarVisits.find(function (visit) {
          return visit.id in visitsMarkers;
        });
        return visitParent || visit;
      }

      similarVisits.push(visit);
      similarVisits.sort(function (a, b) {
        return b.order - a.order;
      });

      return similarVisits[0];
    }

    function isEditModeActive() {
      return $location.path().includes('routes/edit');
    }
  }
})();

/* global Uint8Array:false , pdfMake:false */
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('plannerService', plannerService);

  /** @ngInject */
  function plannerService($log, $rootScope, $http, $q, moment, __env, PlannerVehicleModel, $state, STATE,
                          PlannerRouteModel, PlannerVisitModel, alertNotificationService, REQUEST_STATUS,
                          $window, lodash, $filter, FileSaver, Blob, googleService, planService, visitItemsService,
                          DATE_FORMAT, reportService, timeUtils, PRIORITY_LEVELS, revisedRoutesService,
                          utilsService, textUtilsService, visitTypeService, geocoderService, requestService,
                          DEFAULT_SHIFT_START, PDF_LOGO_BASE64, DEFAULT_SHIFT_END, saveDraftPlanService,
                          statisticsService, userService, visitService, visitsRelationshipService,
                          DEPOT_KEY, vehicleTypeUtils, VISIT_OUT_OF_ROUTE_DEFAULT_COLOR, ESTIMATED_TIME_FORMAT,
                          VISIT_OUT_OF_ROUTE_ORDER, EXTENDED_DATA, START_TIME_WINDOW, END_TIME_WINDOW,
                          accountConfigsService, ACCOUNT_CONFIGS, visitsMarkersService,
                          colorAssignerService, ROUTE_PROPERTIES_MAX_BATCH_SIZE, comparatorService,
                          ZOOM_NUMBER_TO_CENTER_MARKER, PLAN_STATUS, routeComparatorService, ROUTE_PROCESSED_STATUSES,
                          routesUtils, addressStatsService, addonsService, PATH_FINDER_ADD_ON_KEY,
                          SHOW_EXTRA_FIELD_VALUES_PDF_ADDON_PROPERTY, VISIT_TYPE, PATH_FINDER_ADD_ON_PROPERTIES, store) {

    var DRIVERS_PATH = __env.API_URL + 'accounts/drivers/';
    var CODRIVERS_PATH = __env.API_URL + 'accounts/codrivers/';
    var ROUTES_CODRIVERS_PATH = __env.API_URL + 'routes/codrivers/';
    var VEHICLES_PATH = __env.API_URL + 'routes/vehicles/';
    var ROUTES_PATH = __env.API_URL + 'routes/routes/';
    var SKILLS_PATH = __env.API_URL + 'routes/skills/';
    var SELLERS_PATH = __env.API_URL + 'sellers/';
    var PLAN_PATH = __env.API_URL + 'routes/plans/';
    var PLAN_PATH_PAGINATING = __env.API_URL + 'routes/plans/paginate/';
    var PLAN_EVENT_PATH = __env.API_URL + 'routes/events/';
    var VISITS_PATH_PAGINATING = __env.API_URL + 'routes/visits/paginated/';
    var ROUTE_PROPERTIES_BULK_SEARCH_PATH = __env.API_URL + 'routes/routes-properties/bulk-search/';

    var DEFAULT_FMB = 3;
    var DEFAULT_FMV = 2;
    var NO_RESET = 100;
    var ON_FOOT_ROUTING_OPTION = "on_foot";
    var ALL_VEHICLES_ROUTING_OPTION = "all_vehicles";
    var MINIMIZE_VEHICLES_ROUTING_OPTION = "minimize_vehicles";
    var WAVE_ROUTING_OPTION = "wave_routing";
    var ACCOUNT_CONFIGS_FOR_ROUTING_OPTIONS = [
      {
        name: "optimize_cluster",
        option: "big_cluster"
      },
      {
        name: "enable_join_similar_v2",
        option: "join_v2"
      },
      {
        name: "big_vrp",
        option: "big_vrp"
      },
      {
        name: "use_euclidean_distance",
        option: "use_euclidean_distance"
      },
      {
        name: "enable_graphs",
        option: "enable_graphs"
      },
      {
        name: "enable_auto_reorder",
        option: "auto_reorder"
      },
      {
        name: "vehicle_type",
        option: "on_foot"
      },
      {
        name: "enable_wave_routing",
        option: "wave_routing"
      }
    ];
    var ACCOUNT_CONFIGS_MULTI_DAY_ROUTES = "enable_multi_day_routes";

    var planDate = {
      start: null,
      end: null
    };
    var routeDeleted = false;
    var planEditingSelected = false;

    var updatingReturn = false;
    var planId = null;
    var newPlan = true;
    var planName = '';
    var planNameAux = '';
    var planStatus = null;
    var shift = {
      start: DEFAULT_SHIFT_START,
      end: DEFAULT_SHIFT_END
    };
    var drivers = [];
    var visitsPickupAndDeliveryRelationship = {};
    var codrivers = [];
    var codriversPlan = [];
    var vehicles = [];
    var vehiclesCodrivers = [];
    var routes = [];
    var visits = [];
    var events = [];
    var skills = [];
    var sellers = [];
    var plans = [];
    var routesAccount = [];
    var visitsToDelete = [];
    var routesToDelete = [];
    var disableStep = {next: false, vehicleDisabled: false};
    var originalPlan = {};
    var originalVisits = {};
    var optimizationIds = [];
    var restTimesDict = {};
    var pathFinderProperties = {};
    var defaultRoutingOptions = {
      balance: false,
      all_vehicles: true,
      big_cluster: false,
      open_start: false,
      open_ended: false,
      join: false,
      join_v2: false,
      single_tour: false,
      beauty: false,
      big_vrp: false,
      use_euclidean_distance: false,
      enable_graphs: false,
      auto_reorder: false,
      enable_soft_window: false,
      on_foot: false,
      wave_routing: false,
      distance_to_join_visits: null,
      avoid_tolls: false,
      one_seller_per_vehicle: false,
    };

    var optimizationOptions = {
      balance: false,
      all_vehicles: true,
      big_cluster: false,
      join: false,
      join_v2: false,
      open_start: false,
      open_ended: false,
      fmv: DEFAULT_FMV,
      fmb: DEFAULT_FMB,
      single_tour: false,
      beauty: false,
      big_vrp: false,
      enable_soft_window: false,
      on_foot: false,
      wave_routing: false,
      use_euclidean_distance: false,
      max_client: -1,
      min_load: -1,
      disable_soft_window: false,
      one_vehicle_zone: false,
      enable_graphs: false,
      auto_reorder: false,
      insertion_intensification: false,
      intensive_intra: false,
      open_routes_logic: false,
      vehicle_capacities_increment: 0,
      vehicle_journey_extention: 0,
      enable_rest_time: false,
      vehicle_type: false,
      enable_aircraft_routing: false,
      distance_to_join_visits: null,
      avoid_waiting_times: false,
      avoid_tolls: false,
      maximize_attended_load: false,
      one_seller_per_vehicle: false
    };
    var localOptimizationOptions = angular.copy(optimizationOptions);
    var optimizationOptionsDisplayed = [];
    var editModeRoutes = false;
    var previousActiveVisit = null;
    var getPlanPromise = null;
    var googleMap = null;
    var mapOptions = {
      lat: null,
      lng: null
    };
    var planDateModified = {
      start: null,
      end: null
    };
    var editingPlan = {
      status: false
    };
    var currentPlanEditing = {
      planId: null,
      planName: null
    };
    var initialShift = {
      start: null,
      end: null,
      edited: false
    };
    var backupVehicles = {};
    var backupVisits = {};
    var backupRoutes = {};
    var backupEvents = {};
    var priorityLevels = [];
    var userState = {};

    var selectedFleet = null;
    var fleetId = null;
    var visitTypes = null;
    var visitSimilarGraph;
    var isVisitsJoinedByDistance = false;

    // Last optimization id saved to API for this plan.
    // The last optimization ID only changes when the plan is saved.
    var lastOptimizationId = null;

    // Current optimization id for the plan. Changes every time an optimization is performed.
    // When the plan is saved, the current optimization ID becomes the last optimization ID.
    var currentOptimizationId = null;

    // cached total visits considering similars
    // keys are route.id or "visitsOFR"
    var totalArrivalsCache = {};

    var routesOnMapCache = {};

    var newPlanId = utilsService.guid();

    // demand predicting incremental routing parameters
    var waveRoutingData = {};

    var startedRoutes = {};

    var optimizationResults = [];

    var vehicularRestrictionEnabled = false;

    var shouldClearVisitSelectionsOnReturn = false;

    var courierEnabled = false;

    var restTimeEnabled = false;

    var visitsForRouting = [];

    var service = {
      visitsForRouting: visitsForRouting,
      setRestTimeByRouteId: setRestTimeByRouteId,
      planDate: planDate,
      planName: planName,
      shift: shift,
      initialShift: initialShift,
      vehicles: vehicles,
      routes: routes,
      events: events,
      fleetId: fleetId,
      visits: visits,
      skills: skills,
      sellers: sellers,
      plans: plans,
      visitsToDelete: visitsToDelete,
      routesAccount: routesAccount,
      restTimesDict: restTimesDict,
      pathFinderProperties: pathFinderProperties,
      getPlan: getPlan,
      backupPlan: backupPlan,
      restorePlan: restorePlan,
      setGmap: setGmap,
      setPlanDate: setPlanDate,
      setShift: setShift,
      getVehicle: getVehicle,
      getVehicleName: getVehicleName,
      getRouteById: getRouteById,
      getRouteObjById: getRouteObjById,
      removeRoute: removeRoute,
      optimizationOptions: optimizationOptions,
      createVisit: createVisit,
      getVisit: getVisit,
      removeVisit: removeVisit,
      resetVisitLook: resetVisitLook,
      setVisibleInRoutes: setVisibleInRoutes,
      hideRoutes: hideRoutes,
      getActiveVehicles: getActiveVehicles,
      hideVehicles: hideVehicles,
      showVisits: showVisits,
      hideVisits: hideVisits,
      mapFitBoundAllVisits: mapFitBoundAllVisits,
      centerVisit: centerVisit,
      putOffCenterVisit: putOffCenterVisit,
      showInfoWindow: showInfoWindow,
      hideInfoWindow: hideInfoWindow,
      deactivateVisits: deactivateVisits,
      filterVisibleVisits: filterVisibleVisits,
      clearPlan: clearPlan,
      collapseOtherRoutes: collapseOtherRoutes,
      getDrivers: getDrivers,
      getCodrivers: getCodrivers,
      setCodrivers: setCodrivers,
      getCodriversPlan: getCodriversPlan,
      getVehiclesCodrivers: getVehiclesCodrivers,
      setVehiclesCodrivers: setVehiclesCodrivers,
      saveCodrivers: saveCodrivers,
      setCodriversByPlan: setCodriversByPlan,
      centerVehicle: centerVehicle,
      getSkillById: getSkillById,
      getSkills: getSkills,
      getSellers: getSellers,
      getSellerById: getSellerById,
      getGmap: getGmap,
      setMapCenterOn: setMapCenterOn,
      getMapOptions: getMapOptions,
      getPlans: getPlans,
      mergePreviousPlan: mergePreviousPlan,
      previousActiveVisit: previousActiveVisit,
      clearMapVisits: clearMapVisits,
      orderVisitsByStatus: orderVisitsByStatus,
      returnVehicles: returnVehicles,
      returnDrivers: returnDrivers,
      returnSkills: returnSkills,
      getDriver: getDriver,
      setEditMode: setEditMode,
      deletePlan: deletePlan,
      loadVisits: _loadVisits,
      clearPlanPromise: clearPlanPromise,
      removeVehicle: removeVehicle,
      getPlanName: getPlanName,
      getCenter: getCenter,
      setMapOptions: setMapOptions,
      getShift: getShift,
      getTravelTimeDepot: getTravelTimeDepot,
      returnPlanMode: returnPlanMode,
      loadRoutes: loadRoutes,
      disableStep: disableStep,
      routeDeleted: routeDeleted,
      setVehiclesEnableEditPlan: setVehiclesEnableEditPlan,
      planNameAux: planNameAux,
      optimizationOptionsDisplayed: optimizationOptionsDisplayed,
      localOptimizationOptions: localOptimizationOptions,
      exportPlanPdf: exportPlanPdf,
      getSkillObjById: getSkillObjById,
      exportPlanTxt: exportPlanTxt,
      clearPlanner: clearPlanner,
      clearRestTimes: clearRestTimes,
      getPlanId: getPlanId,
      planDateModified: planDateModified,
      createPlan: createPlan,
      changeDateModal: changeDateModal,
      tryPreGeoreferenceBatch: tryPreGeoreferenceBatch,
      getVisits: getVisits,
      getAllVisits: getAllVisits,
      getRoutes: getRoutes,
      getPlanInfo: getPlanInfo,
      setPlanId: setPlanId,
      setFleetId: setFleetId,
      getFleetId: getFleetId,
      getVehicles: getVehicles,
      getPlanDate: getPlanDate,
      setlocalOptimizationOptions: setlocalOptimizationOptions,
      getlocalOptimizationOptions: getlocalOptimizationOptions,
      getDefaultRoutingOptions: getDefaultRoutingOptions,
      setDefaultRoutingOptions: setDefaultRoutingOptions,
      removeDefaultRoutingOption: removeDefaultRoutingOption,
      visitsBulkEdit: visitsBulkEdit,
      setVisits: setVisits,
      setVehicles: setVehicles,
      clearMapRoutes: clearMapRoutes,
      clearMapVisitsAndRoutes: clearMapVisitsAndRoutes,
      createRoutesPolyline: createRoutesPolyline,
      getVehiclesAvailableWithRoutes: getVehiclesAvailableWithRoutes,
      getVisitsBelongingAnyRoute: getVisitsBelongingAnyRoute,
      getVisitsOutOfRoute: getVisitsOutOfRoute,
      createRoute: createRoute,
      getVehiclesAvailable: getVehiclesAvailable,
      exportPlanExcel: exportPlanExcel,
      setRoutes: setRoutes,
      setPlanName: setPlanName,
      getPlanStatus: getPlanStatus,
      setPlanStatus: setPlanStatus,
      isPlanEditable: isPlanEditable,
      editPlan: editPlan,
      setEditPlanDate: setEditPlanDate,
      getPriorityLevels: getPriorityLevels,
      loadPlanDetail: loadPlanDetail,
      loadRoutesDetail: loadRoutesDetail,
      loadVisitDetail: loadVisitDetail,
      setVisibleInVehicles: setVisibleInVehicles,
      getOptimizationOptions: getOptimizationOptions,
      getAllOptimizationIds: getAllOptimizationIds,
      getPlanEditingSelected: getPlanEditingSelected,
      setUserVisualState: setUserVisualState,
      getUserVisualState: getUserVisualState,
      getVehicleById: _getVehicleByID,
      setBackupRoute: setBackupRoute,
      setBackupRoutes: setBackupRoutes,
      setBackupVehicles: setBackupVehicles,
      setBackupVisits: setBackupVisits,
      setBackupData: setBackupData,
      setZoomControlPosition: setZoomControlPosition,
      setMultipleVisitsSelected: setMultipleVisitsSelected,
      addOptimizationId: addOptimizationId,
      deselectVisitsSelected: deselectVisitsSelected,
      updateListDriver: updateListDriver,
      setDrivers: setDrivers,
      setOptimizationOptionsDisplayed: setOptimizationOptionsDisplayed,
      setOptimizationOptions: setOptimizationOptions,
      getOptimizationOptionsDisplayed: getOptimizationOptionsDisplayed,
      getBackupRoutes: getBackupRoutes,
      getBackupVehicles: getBackupVehicles,
      getBackupVisits: getBackupVisits,
      setSelectedFleet: setSelectedFleet,
      getPaginatedPlans: getPaginatedPlans,
      getSelectedFleet: getSelectedFleet,
      updateVehicles: updateVehicles,
      routeMarkAsRemoved: routeMarkAsRemoved,
      getOriginalPlan: getOriginalPlan,
      setOriginalPlan: setOriginalPlan,
      getOriginalVisits: getOriginalVisits,
      setOriginalVisits: setOriginalVisits,
      routesToDelete: routesToDelete,
      getUnusedRoutes: getUnusedRoutes,
      getRouteRequestStatus: getRouteRequestStatus,
      getRoutesToCreateRequest: getRoutesToCreateRequest,
      putVisitsToDelete: putVisitsToDelete,
      getAllRestTime: getAllRestTime,
      getRestTimeByRouteId: getRestTimeByRouteId,
      getRouteName: getRouteName,
      getVehicleRoutes: getVehicleRoutes,
      getRouteIndex: getRouteIndex,
      getVisitTypes: getVisitTypes,
      visitTypes: visitTypes,
      restTimeToEvent: restTimeToEvent,
      eventToRestTime: eventToRestTime,
      loadEventsDetail: loadEventsDetail,
      hasActiveVehicles: hasActiveVehicles,
      visitSimilarGraph: visitSimilarGraph,
      totalArrivalsCache: totalArrivalsCache,
      getTotalArrivalsCached: getTotalArrivalsCached,
      clearTotalArrivalsCached: clearTotalArrivalsCached,
      clearTotalArrivalsCachedByRoute: clearTotalArrivalsCachedByRoute,
      eventsToResetData: eventsToResetData,
      getSelectedOptimizations: getSelectedOptimizations,
      getEditingPlan: getEditingPlan,
      setCurrentPlanEditing: setCurrentPlanEditing,
      getCurrentPlanEditing: getCurrentPlanEditing,
      getRouteOnMapCache: getRouteOnMapCache,
      setRouteOnMapCache: setRouteOnMapCache,
      clearRoutesOnMapCache: clearRoutesOnMapCache,
      saveDraftPlan: saveDraftPlan,
      clearDraftPlanData: clearDraftPlanData,
      setOriginalPlanAndSaveDraftPlanFormat: setOriginalPlanAndSaveDraftPlanFormat,
      isNewPlan: isNewPlan,
      removeVehicleRoute: removeVehicleRoute,
      getVehicleShiftTime: getVehicleShiftTime,
      _shiftCrossesMidnight: _shiftCrossesMidnight,
      _getVehicleShiftStartWhenEditing: _getVehicleShiftStartWhenEditing,
      setWaveRoutingData: setWaveRoutingData,
      getWaveRoutingData: getWaveRoutingData,
      setCurrentOptimizationId: setCurrentOptimizationId,
      getCurrentOptimizationId: getCurrentOptimizationId,
      setLastOptimizationId: setLastOptimizationId,
      getLastOptimizationId: getLastOptimizationId,
      getSelectedVisits: getSelectedVisits,
      getStartedRoutes: getStartedRoutes,
      calculateStartedRoutes: calculateStartedRoutes,
      parseOptimizationRestTimeNode: parseOptimizationRestTimeNode,
      removeDriver: removeDriver,
      removeCodriver: removeCodriver,
      getCodriversByVehicleId: getCodriversByVehicleId,
      isTherePickupAndDelivery: isTherePickupAndDelivery,
      getVisitsPickupAndDeliveryRelationship: getVisitsPickupAndDeliveryRelationship,
      loadVisitsPickupAndDeliveryRelationship: loadVisitsPickupAndDeliveryRelationship,
      removeVisitPickupAndDeliveryRelationship: removeVisitPickupAndDeliveryRelationship,
      getVisitRelationships: getVisitRelationships,
      setVisitsOutOfRouteAttributes: setVisitsOutOfRouteAttributes,
      mustShowVisitWindows: mustShowVisitWindows,
      getScheduledPlanDaysOfWeek: getScheduledPlanDaysOfWeek,
      isStepOneActive: isStepOneActive,
      isStepThreeActive: isStepThreeActive,
      loadRouteProperties: loadRouteProperties,
      wasInitialShiftChanged: wasInitialShiftChanged,
      getActiveVehiclesWithoutRoutesInPlan: getActiveVehiclesWithoutRoutesInPlan,
      getPlanStartTime: getPlanStartTime,
      isVisitRouteRevised: isVisitRouteRevised,
      mergePreviousPartialPlan: mergePreviousPartialPlan,
      hasPlanRoutesProcessed: hasPlanRoutesProcessed,
      isRouteProcessed: isRouteProcessed,
      isVisitFromProcessedRoute: isVisitFromProcessedRoute,
      hasVehicleRoutesProcessed: hasVehicleRoutesProcessed,
      getOptimizationResults: getOptimizationResults,
      setOptimizationResults: setOptimizationResults,
      getDriverName: getDriverName,
      setVehicleDriver: setVehicleDriver,
      updateVehicleDriver: updateVehicleDriver,
      setVehicularRestrictionEnabled: setVehicularRestrictionEnabled,
      isVehicularRestrictionEnabled: isVehicularRestrictionEnabled,
      getCheckedVisits: getCheckedVisits,
      setShouldClearVisitSelectionsOnReturn: setShouldClearVisitSelectionsOnReturn,
      getShouldClearVisitSelectionsOnReturn: getShouldClearVisitSelectionsOnReturn,
      setCourierEnabled: setCourierEnabled,
      isCourierEnabled: isCourierEnabled,
      setRestTimeEnabled: setRestTimeEnabled,
      isRestTimeEnabled: isRestTimeEnabled,
      updateVehicleRouteVisitsAndEvents: updateVehicleRouteVisitsAndEvents,
      getPathFinderProperties: getPathFinderProperties,
      loadPathFinderProperties: _loadPathFinderProperties,
      shouldValidateEditableRoutes: shouldValidateEditableRoutes,
      isRouteEditable: isRouteEditable,
      isRouteEditableToMoveVisits: isRouteEditableToMoveVisits,
      adjustWindowTimesWithPlanDatesAndAcrossMidnight: adjustWindowTimesWithPlanDatesAndAcrossMidnight,
      adjustWindowTimesForReorderOptimization: adjustWindowTimesForReorderOptimization,
      isPrioritizeLoadOptionEnabled: isPrioritizeLoadOptionEnabled,
    };

    function getOptimizationResults() {
      return optimizationResults;
    }

    function setOptimizationResults(results) {
      optimizationResults = results;
      $rootScope.$broadcast("Planner:Plan:updateOptimizationResultsOptions");
    }

    function isNewPlan() {
      return newPlan;
    }

    function getStartedRoutes() {
      return startedRoutes;
    }

    function calculateStartedRoutes() {
      routes.forEach(function (route) {
        if (route.isStarted()) {
          startedRoutes[route.id] = route;
        }
      });
    }

    Object.defineProperty(service, 'originalPlan', {
      get: function() {
        return originalPlan;
      }
    });

    Object.defineProperty(service, 'ACCOUNT_CONFIGS_FOR_ROUTING_OPTIONS', {
      get: function() {
        return ACCOUNT_CONFIGS_FOR_ROUTING_OPTIONS;
      }
    });

    Object.defineProperty(service, 'ACCOUNT_CONFIGS', {
      get: function() {
        return ACCOUNT_CONFIGS;
      }
    });

    Object.defineProperty(service, 'ACCOUNT_CONFIGS_MULTI_DAY_ROUTES', {
      get: function() {
        return ACCOUNT_CONFIGS_MULTI_DAY_ROUTES;
      }
    });

    $window.plannerService = service;
    return service;

    //////////

    function hasActiveVehicles() {
      var activeVehicle = service.vehicles.find(function(vehicle) {
        return vehicle.active;
      });
      return Boolean(activeVehicle);
    }

    function returnVehicles() {
      var deferred = $q.defer();
      deferred.resolve(vehicles);
      return deferred.promise;
    }

    function returnDrivers() {
      var deferred = $q.defer();
      deferred.resolve(drivers);
      return deferred.promise;
    }

    function returnSkills() {
      var deferred = $q.defer();
      deferred.resolve(skills);
      return deferred.promise;
    }

    function setMapOptions(map) {
      mapOptions.lat = map.center.latitude;
      mapOptions.lng = map.center.longitude;
    }

    function getMapOptions() {
      var deferred = $q.defer();
      $http.get(__env.GOOGLE_MAP_OPTIONS)
        .then(function mapOptionsSuccess(response) {
          deferred.resolve(response.data);
        })
        .catch(function mapOptionsError(error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function getTravelTimeDepot() {
      return $http.get(DRIVERS_PATH + 'traveltime-depot/');
    }

    function setVehiclesEnableEditPlan(status) {
      planEditingSelected = status;
    }

    function getPlan() {
      if (getPlanPromise) {
        return getPlanPromise;
      }

      getPlanPromise = _loadDrivers()
        .then(_loadVehicles)
        .then(loadRoutes(planDate))
        // .then(_loadVisits)
        .then(_loadSkills)
        .then(_loadCodrivers)
        .then(_loadSellers)
        .then(_loadPathFinderProperties)
        .then(function () {
          return {
            planDate: planDate,
            planStatus: planStatus,
            shift: shift,
            vehicles: vehicles,
            routes: routes,
            visits: visits,
            drivers: drivers,
            skills: skills,
            codrivers: codrivers
          };
        });
      return getPlanPromise;
    }

    function getPlans() {
      return _loadPlans();
    }

    function getPaginatedPlans(params) {
      plans.length = 0;
      var options = {
        params: params
      };
      return $http.get(PLAN_PATH_PAGINATING, options)
        .then(function (response) {
          plans = response.data.results.map(function (planData) {
            return {
              'id': planData.id,
              'name': planData.name,
              'startDate': planData.start_date,
              'endDate': planData.end_date,
              'created': planData.created,
              'fleet' : planData.fleet,
              'totalRoutes': planData.routes.length,
              'status': planData.status,
              'saveStage': planData.save_stage
            };
          });
          response.data.results = plans;
          return response.data;
        });
    }

    function clearPlan() {
      vehicles.length = 0;
      drivers.length = 0;
      codrivers.length = 0;
      codriversPlan.length = 0;
      vehiclesCodrivers.length = 0;
      skills.length = 0;
      visits.length = 0;
      routes.length = 0;
      sellers.length = 0;
      backupRoutes = {};
      backupVehicles = {};
      planId = null;
      planName = null;
      newPlan = true;
      fleetId = null;
      getPlanPromise = null;
      selectedFleet = null;
      routeDeleted = false;
      visitTypes = null;
      visitsToDelete = [];
      routesToDelete = [];
      originalPlan = {};
      originalVisits = {};
      optimizationIds.length = 0;
      planDateModified = { start: null, end: null };
      planDate.start = moment().format('YYYY-MM-DD');
      planDate.end = planDate.start;
      restTimesDict = {};
      editingPlan.status = false;
      routesOnMapCache = {};
      setCurrentPlanEditing(null, null);
      eventsToResetData();
      currentOptimizationId = null;
      lastOptimizationId = null;
      startedRoutes = {};
      visitsPickupAndDeliveryRelationship = {};
      setInitialShift(null, null);
      planStatus = null;
      optimizationResults = [];
      pathFinderProperties = {};
      visitsForRouting.length = 0;
      setShift(DEFAULT_SHIFT_START, DEFAULT_SHIFT_END);

      if ('radial_routing' in localOptimizationOptions) {
        delete localOptimizationOptions.radial_routing;
      }

      if ('prioritize_load' in localOptimizationOptions) {
        delete localOptimizationOptions.prioritize_load;
      }
    }

    function clearPlanner() {
      visits.length = 0;
      routes.length = 0;
      backupRoutes = {};
      planId = null;
      planName = null;
      newPlan = true;
      fleetId = null;
      selectedFleet = null;
      getPlanPromise = null;
      routeDeleted = false;
      visitsToDelete = [];
      routesToDelete = [];
      originalPlan = {};
      originalVisits = {};
      optimizationIds.length = 0;
      planDate.start = moment().format('YYYY-MM-DD');
      planDate.end = planDate.start;
      restTimesDict = {};
      editingPlan.status = false;
      routesOnMapCache = {};
      setCurrentPlanEditing(null, null);
      eventsToResetData();
      vehicles.forEach(function (vehicle) {
        vehicle.routes.length = 0;
        vehicle.enable = false;
        vehicle.active = false;
        vehicle.isShiftTemporarilyEdited = false;
      });

      currentOptimizationId = null;
      lastOptimizationId = null;
      startedRoutes = {};
      visitsPickupAndDeliveryRelationship = {};
      setInitialShift(null, null);
      planStatus = null;
      optimizationResults = [];
      pathFinderProperties = {};
      visitsForRouting.length = 0;

      if ('radial_routing' in localOptimizationOptions) {
        delete localOptimizationOptions.radial_routing;
      }

      if ('prioritize_load' in localOptimizationOptions) {
        delete localOptimizationOptions.prioritize_load;
      }
    }

    function getPlanStatus() {
      return planStatus;
    }

    function isPlanEditable() {
      return !accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_PLAN_STATUS) || planStatus === PLAN_STATUS.draft || planStatus === null;
    }

    function hasPlanRoutesProcessed() {
      if (!accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.DISABLE_EDIT_FOR_ACTIVE_AND_FINISHED_ROUTES)) {
        return false;
      }

      return routes.some(function (route) {
        return ROUTE_PROCESSED_STATUSES.includes(route.status);
      });
    }

    function hasVehicleRoutesProcessed(vehicle) {
      if (!accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.DISABLE_EDIT_FOR_ACTIVE_AND_FINISHED_ROUTES)) {
        return false;
      }

      return vehicle.routes.some(function (route) {
        return ROUTE_PROCESSED_STATUSES.includes(route.status);
      });
    }

    function isRouteProcessed(route) {
      if (
        !accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.DISABLE_EDIT_FOR_ACTIVE_AND_FINISHED_ROUTES)
        || !route
      ) {
        return false;
      }

      return ROUTE_PROCESSED_STATUSES.includes(route.status);
    }

    function isVisitFromProcessedRoute(visit) {
      if (!accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.DISABLE_EDIT_FOR_ACTIVE_AND_FINISHED_ROUTES)) {
        return false;
      }

      var sourceRoute = getRouteObjById(visit.sourceRouteId);

      if ((visit.type === VISIT_TYPE.VISIT && !visit.backendId) || !sourceRoute) {
        return false;
      }

      return ROUTE_PROCESSED_STATUSES.includes(sourceRoute.status);
    }

    function setPlanStatus (newStatus) {
      planStatus = newStatus;
    }

    function setPlanId(id) {
      planId = id;
    }

    function getPlanId() {
      return planId;
    }

    function setFleetId(id) {
      fleetId = id;
    }

    function getFleetId() {
      return fleetId;
    }

    function getEditingPlan() {
      return editingPlan;
    }

    function setCurrentPlanEditing(planId, planName) {
      currentPlanEditing.planId = planId;
      currentPlanEditing.planName = planName;
    }

    function getCurrentPlanEditing() {
      return currentPlanEditing;
    }

    function returnPlanMode() {
      return {
        planId: planId,
        newPlan: newPlan,
        updatingReturn: updatingReturn
      };
    }

    function backupPlan() {
      backupRoutes = [];
      backupVehicles = [];
      backupVisits = [];

      var isMixLoadEnabled = utilsService.isAddonPropertyEnabled(
        pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD]
      );

      vehicles.forEach(function(vehicle) {
        backupVehicles[vehicle.id] = {
          driver: vehicle.driver,
          driverId: vehicle.driverId,
          active: vehicle.active,
          areAllRoutesRevised: vehicle.areAllRoutesRevised,
          color: vehicle.color
        };
      });

      visits.forEach(function (visit) {
        backupVisits[visit.id] = {
          routeId: visit.routeId,
          vehicle: visit.vehicle,
          order: visit.order,
          estimatedTimeArrival: visit.estimatedTimeArrival,
          estimatedTimeDeparture: visit.estimatedTimeDeparture,
          capacityError: visit.capacityError,
          capacityError2: visit.capacityError2,
          capacityError3: visit.capacityError3,
          capacityError4: isMixLoadEnabled ? visit.capacityError4 : 0,
          timeError: visit.timeError,
          skillsError: visit.skillsError,
          error: angular.copy(visit.error),
          options: angular.copy(visit.options),
          seller_id: visit.seller_id
        };
      });

      routes.forEach(function (route) {
        backupRoutes[route.id] = {
          vehicleId: route.vehicleId,
          driver: route.driver,
          estimatedTimeStart: route.estimatedTimeStart,
          estimatedTimeEnd: route.estimatedTimeEnd,
          totalTime: route.totalTime,
          totalTimeFormatted: route.totalTimeFormatted,
          totalDistance: route.totalDistance,
          totalLoad: route.totalLoad,
          totalLoadPercentage: route.totalLoadPercentage,
          totalLoad2: route.totalLoad2,
          totalLoadPercentage2: route.totalLoadPercentage2,
          totalLoad3: route.totalLoad3,
          totalLoadPercentage3: route.totalLoadPercentage3,
          totalLoad4: isMixLoadEnabled ? route.totalLoad4 : 0,
          totalLoadPercentage4: isMixLoadEnabled ? route.totalLoadPercentage4 : 0,
          path: route.path,
          capacityError: route.capacityError,
          capacityError2: route.capacityError2,
          capacityError3: route.capacityError3,
          capacityError4: isMixLoadEnabled ? route.capacityError4 : 0,
          timeError: route.timeError,
          skillsError: route.skillsError,
          hasRestTimeError: route.hasRestTimeError,
          hasManualChanges: route.hasManualChanges,
          visits: angular.extend([], route.visits),
          isRevised: route.isRevised
        };
      });

      backupEvents = {};

      for (var restTimeKey in restTimesDict) {
        backupEvents[restTimeKey] = Object.assign({}, restTimesDict[restTimeKey]);
      }
    }

    function restorePlan() {
      vehicles.forEach(function (vehicle) {
        for (var i = vehicle.routes.length - 1; i >= 0; i--) {
          var route = vehicle.routes[i];
          var backupRoute = backupRoutes[route.id];

          if (!backupRoute) {
            route.visible = false;
            vehicle.setVisible(false, localOptimizationOptions.open_ended);
            removeVehicleRoute(vehicle, route);
          }

          if (backupRoute && backupRoute.vehicleId !== route.vehicleId) {
            var targetVehicle = _getVehicleByID(backupRoute.vehicleId);
            vehicle.routes.splice(i, 1);
            targetVehicle.addRoute(route);
          }
        }
      });

      vehicles.forEach(function (vehicle) {
        var backupVehicle = backupVehicles[vehicle.id];
        if (backupVehicle) {
          angular.extend(vehicle, backupVehicle);
          vehicle.setRelativePlanColor(backupVehicle.color, true); // Restaurar el color original
        }
      });

      visits.forEach(function (visit) {
        angular.extend(visit, backupVisits[visit.id]);
      });

      routes.forEach(function (route) {
        angular.extend(route, backupRoutes[route.id]);
      });

      restTimesDict = {};

      for (var eventKey in backupEvents) {
        restTimesDict[eventKey] = Object.assign({}, backupEvents[eventKey]);
      }

      restoreDeletedRoutesInEditMode();
      orderVisitsOfRoutesByOrder();
      orderRoutesOfVehiclesByStartTime();

      vehicles.forEach(function (vehicle) {
        if (vehicle.routes.length > 0) {
          vehicle.recalculateMetricsAndErrors(service);
        }
      });
    }

    function orderRoutesOfVehiclesByStartTime() {
      // Mirror of the same midnight-crossing sort in _fillVehicles (loadPlan.service.js).
      // By this point routes use the processed `estimatedTimeStart` (HH:mm) and the
      // shift is already loaded into the `shift` object, so we derive the same
      // day-bucket logic from shift.start / shift.end.
      var shiftStart = shift.start || '00:00';
      var shiftCrossesMidnight = shift.end && shift.end < shiftStart;
      // Gate: only reorder for multi-day plans with skip_time_validation enabled,
      // to avoid affecting the ordering logic for the rest of the app.
      var shouldApplyMidnightSort = shiftCrossesMidnight && isLongRoutesEnabled() && getSkipTimeValidation();
      if (shouldApplyMidnightSort) {
        vehicles.forEach(function (vehicle) {
          vehicle.routes.sort(function (a, b) {
            var timeA = a.estimatedTimeStart || '';
            var timeB = b.estimatedTimeStart || '';
            // Assign day bucket: 0 = same evening as shift start, 1 = post-midnight.
            var dayA = timeA < shiftStart ? 1 : 0;
            var dayB = timeB < shiftStart ? 1 : 0;
            if (dayA !== dayB) { return dayA - dayB; }
            return timeA > timeB ? 1 : timeA < timeB ? -1 : 0;
          });
        });
      } else {
        vehicles.forEach(function (vehicle) {
          vehicle.routes.sort(
            function (a, b) {
              return (a.estimatedTimeStart > b.estimatedTimeStart) ? 1 : ((b.estimatedTimeStart > a.estimatedTimeStart) ? -1 : 0);
            });
        });
      }
    }

    function orderVisitsOfRoutesByOrder() {
      vehicles.forEach(function (vehicle) {
        vehicle.routes.forEach(function (route) {
          route.visits.sort(
            function (a, b) {
              return (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0);
            });
        });
      });
    }

    function restoreDeletedRoutesInEditMode() {
      var backupRouteIds = Object.keys(backupRoutes);
      backupRouteIds.forEach(function (backupRouteId) {
        var foundRoute = routes.find(function (route) {
          return route.id === backupRouteId;
        });

        if (!foundRoute) {
          var backupRoute = backupRoutes[backupRouteId];
          routes.push(backupRoute);

          visits.forEach(function (visit) {
            if (visit.routeId === backupRouteId) {
              backupRoute.visits.push(visit);
            }
          });

          var foundVehicle = vehicles.find(function (vehicle) {
            return vehicle.id === backupRoute.vehicleId;
          });

          if (foundVehicle) {
            foundVehicle.routes.push(backupRoute);
          }
        }
      });
    }

    function setGmap(map) {
      googleMap = map;
    }

    function getGmap() {
      return googleMap;
    }

    function getCenter() {
      if (googleMap) {
        var lat = null;
        var lng = null;
        var center = null;
        if (mapOptions.lat && mapOptions.lng) {
          lat = mapOptions.lat;
          lng = mapOptions.lng;
          center = googleService.getGoogleMapsLatLng(lat, lng);
          googleMap.setCenter(center);
        }
      }
    }

    function setPlanDate(startDate, endDate) {
      if (!getPlanName()) {
        planDate.start = startDate.format('YYYY-MM-DD');
        planDate.end = endDate ? endDate.format('YYYY-MM-DD') : planDate.start;
      }
    }

    function setEditPlanDate(start, end) {
      planDate.start = start;
      planDate.end = end;
    }

    function setPlanName(name) {
      planName = name;
    }

    function getShift() {
      return shift;
    }

    function setShift(start, end) {
      shift.start = start;
      shift.end = end;
      // TODO Set shift for each vehicle
    }

    function setInitialShift(startTime, endTime) {
      initialShift.start = startTime;
      initialShift.end = endTime;
      initialShift.edited = false;
    }

    function getVehicle(vehicleId) {
      return getPlan().then(function (plan) {
        for (var i = 0; i < plan.vehicles.length; i++) {
          if (plan.vehicles[i].id === vehicleId) {
            return plan.vehicles[i];
          }
        }
        var data = {status: 404};
        return $q.reject(data);
      }, function error(objError) {
        return $q.reject(objError);
      });
    }

    function getVehicleName(vehicleId) {
      var vehicle = service.vehicles.find(function(vehicle) {
        return vehicle.id === vehicleId;
      });
      return (vehicle && vehicle.name) ? vehicle.name : "";
    }

    function getDrivers() {
      return drivers;
    }

    function getCodrivers() {
      return codrivers;
    }

    function setCodrivers(data) {
      codrivers = data;
    }

    function getCodriversPlan() {
      return codriversPlan;
    }

    function getVehiclesCodrivers() {
      return vehiclesCodrivers;
    }

    function getDriver(driverId) {
      return getPlan().then(function (plan) {
        for (var i = 0; i < plan.drivers.length; i++) {
          if (plan.drivers[i].id === driverId) {
            return plan.drivers[i];
          }
        }
        return $q.reject('DRIVER NOT FOUND');
      });
    }

    function createRoute(vehicleId) {
      var route = new PlannerRouteModel(vehicleId);
      routes.push(route);
      return route;
    }

    function routeMarkAsRemoved(routeMarked) {
      if (routeMarked.backendId) {
        var alreadyExists = routesToDelete.find(function (routeToDelete) {
          return routeToDelete.id === routeMarked.id;
        });
        if (!alreadyExists) {
          routesToDelete.push(routeMarked);
        }
      }
    }

    function getOriginalPlan() {
      return originalPlan;
    }

    function getOriginalVisits() {
      return originalVisits;
    }

    function setOriginalVisits(originalVisitsMap) {
      originalVisits = {};
      if (!originalVisitsMap) {
        return;
      }

      Object.values(originalVisitsMap).forEach(function (visit) {
        if (visit) {
          addOriginalVisit(angular.copy(visit));
        }
      });
    }

    function setOriginalPlan(plan) {
      var originalPlanFromSaveDraftPlan = saveDraftPlanService.getOriginalPlan();
      originalPlan = originalPlanFromSaveDraftPlan || plan;
      ['vehicles', 'routes'].forEach(function (key) {
        var keyDict = key + "Dict";
        if (Array.isArray(originalPlan[key]) && !originalPlan.hasOwnProperty(keyDict)) {
          Object.defineProperty(originalPlan, keyDict, {
            value: originalPlan[key].reduce(function (dict, elemRef) {
              return Object.defineProperty(dict, elemRef.id, {
                value: elemRef,
                enumerable: true
              });
            }, {})
          });
        }
      });

      _setOriginalVisitsWithOriginalPlan(originalPlan.routes);
      setPlanDate(moment(plan.start_date), moment(plan.end_date));
    }

    function _setOriginalVisitsWithOriginalPlan(originalPlanRoutes) {
      if (!originalPlanRoutes || originalPlanRoutes.length < 1) {
        return;
      }
      originalPlanRoutes.forEach(function (route) {
        if (!route.visits || route.visits.length < 1) {
          return;
        }
        route.visits.forEach(function (visit) {
          addOriginalVisit(angular.copy(visit));
        });
      });
    }

    function _hasVehicleMultiDriver(vehicle) {
      var firstRoute = vehicle.routes[0];
      if (!firstRoute) {
        return false;
      }

      return !routesUtils.haveSameDriver(vehicle.routes, firstRoute.driver);
    }

    function removeRoute(route) {
      // TODO remove markers from map, remove route from vehicle
      if (route.vehicleId) {
        var vehicle = vehicles.filter(getVehicleById(route.vehicleId))[0];
        vehicle.removeRoute(route);
      }

      routes.splice(routes.indexOf(route), 1);

      $rootScope.$broadcast("Planner:Route:Remove", {
        route: route
      });
    }

    function removeVehicleRoute(vehicle, route) {
      vehicle.removeRoute(route);
      routes.splice(routes.indexOf(route), 1);
      route.actionRemove(route);
    }

    function createVisit(latitude, longitude) {
      var visit = new PlannerVisitModel();
      visit.plannedDate = planDate.start;
      visit.latitude = latitude;
      visit.longitude = longitude;
      visit.zIndex = (visits.length + 1) * 2;
      visit.seller_id = null;
      visits.push(visit);
      return visit;
    }

    function getVisit(visitId) {
      for (var i = 0; i < visits.length; i++) {
        if (visits[i].id === visitId) {
          return visits[i];
        }
      }
    }

    function putVisitsToDelete(visit) {
      var existVisit = visitsToDelete.find(function (visitToDelete) {
        return parseInt(visitToDelete.id) === parseInt(visit.id);
      });

      if (!existVisit) {
        visitsToDelete.push(visit);
      }
    }

    function removeVisit(visit, recalculateRoute) {
      if (angular.isUndefined(recalculateRoute)) {
        recalculateRoute = true;
      }

      if (visit.routeId) {
        putVisitsToDelete(angular.copy(visit));
        var route = getRouteObjById(visit.routeId);
        if (route) {
          route.removeVisit(visit);
          if (recalculateRoute) {
            //Buscamos el vehiculo al que pertenece la ruta en accion y recalculamos sus rutas
            var vehicle = vehicles.filter(getVehicleById(route.vehicleId))[0];
            vehicle.recalculateRouteStartingAt(route, localOptimizationOptions, this);
          }
        }
      }

      visits.splice(visits.indexOf(visit), 1);
      alertNotificationService.removeAlertNotification();
      $rootScope.$broadcast("Planner:Visit:Remove", {
        visit: visit
      });

      if (visitsForRouting.length > 0) {
        var index = visitsForRouting.indexOf(visit.id);
        if (index >= 0) {
          visitsForRouting.splice(index, 1);
        }
      }
    }

    function mapFitBoundAllVisits() {
      var bounds = googleService.getLatLngBounds();
      angular.forEach(visits, function (visit) {
        var position = googleService.getGoogleMapsLatLng(visit.latitude, visit.longitude);
        bounds.extend(position);
      });
      googleMap.fitBounds(bounds);
      if (visits.length <= 3) {
        if (visits.length === 0) {
          googleMap.setCenter(googleService.getGoogleMapsLatLng(-33.45, -70.666667));
          googleMap.setZoom(11);
          return;
        }
        googleMap.setZoom(12);
      }
      googleMap.panBy(1, 0);
    }

    function setlocalOptimizationOptions(options) {
      lodash.merge(localOptimizationOptions, options);
      localOptimizationOptions.fmv = parseFloat(options.fmv);
      localOptimizationOptions.fmb = parseInt(isNaN(options.fmb) ? DEFAULT_FMB : options.fmb);
    }

    function getlocalOptimizationOptions() {
      return localOptimizationOptions;
    }

    function setOptimizationOptions(options) {
      lodash.merge(optimizationOptions, options);
      optimizationOptions.fmv = parseFloat(options.fmv);
      optimizationOptions.fmb = parseInt(isNaN(options.fmb) ? DEFAULT_FMB : options.fmb);
    }

    function getOptimizationOptions() {
      if (!localOptimizationOptions.hasOwnProperty('fmv')) {
        localOptimizationOptions.fmv = DEFAULT_FMV;
      }

      if (!localOptimizationOptions.hasOwnProperty('fmb') || localOptimizationOptions.fmb == null) {
        localOptimizationOptions.fmb = DEFAULT_FMB;
      }

      return localOptimizationOptions;
    }

    function _updateOptimizations(routingOptions) {
      for (var key in routingOptions) {
        localOptimizationOptions[key] = routingOptions[key];
      }
    }

    function setOptimizationOptionsDisplayed(options) {
      // If the routing options are updated in the settings view,
      // the 'on_foot' option is lost. Remove this part when necessary
      if (localOptimizationOptions.vehicle_type && !options.includes(ON_FOOT_ROUTING_OPTION)) {
        options.push(ON_FOOT_ROUTING_OPTION);
      }
      if (localOptimizationOptions.wave_routing && !options.includes(WAVE_ROUTING_OPTION)) {
        options.push(WAVE_ROUTING_OPTION);
      }

      optimizationOptionsDisplayed = options;
    }

    function getOptimizationOptionsDisplayed() {
      return optimizationOptionsDisplayed;
    }

    function getDefaultRoutingOptions() {
      return angular.merge({}, defaultRoutingOptions);
    }

    function setDefaultRoutingOptions(routingOptions) {
      for (var key in defaultRoutingOptions) {
        // Add false by default, because on_foot might not be in routingOptions
        defaultRoutingOptions[key] = routingOptions[key] || false;
      }
    }

    function removeDefaultRoutingOption(routingOption) {
      delete defaultRoutingOptions[routingOption];
    }

    function getRouteById(routeId) {
      return routes.find(function (route) {
        return route.id === routeId;
      });
    }

    function getRouteObjById(routeId) {
      if (!routeId) {
        return null;
      }

      return routes.filter(function (route) {
        return route.id === routeId;
      })[0];
    }

    function getVehicleById(vehicleId) {
      return function (vehicle) {
        return vehicle.id === vehicleId;
      };
    }

    //////// Map Options ////////
    function setMapCenterOn(_visit) {
      if (googleMap) {
        googleMap.setCenter(googleService.getGoogleMapsLatLng(_visit.latitude, _visit.longitude));
      }
    }

    function setZoomControlPosition(position) {
      if (googleMap) {
        googleMap.setOptions({
          zoomControlOptions: {
            position: googleService.getZoomControlOptions(position)
          }
        });

      }
    }


    ////////// Drivers //////////

    function _loadDrivers() {
      return $http.get(DRIVERS_PATH)
        .then(successGetDrivers, errorGetDrivers);

      function successGetDrivers(response) {
        var formattedResponse = [];
        response.data.forEach(function (driverData) {
          if (!userService.isActiveUser(driverData)) {
            return;
          }

          var driver = {
            id: String(driverData.id),
            name: driverData.name,
            username: driverData.username,
            selected: false,
            expired_documents: driverData.expired_documents,
            status: driverData.status,
            group: $filter("translate")("Driver.group_available")
          };

          var driverAlreadyExists = drivers.some(function (driverObj) {
            return driverObj.id === driver.id;
          });

          if (!driverAlreadyExists) {
            drivers.push(driver);
          }

          formattedResponse.push(driver);
        });

        return formattedResponse;
      }

      function errorGetDrivers(response) {
        $log.error(response);
        return $q.reject(response);
      }
    }

    ////////// End Drivers //////////

    ////////// Codrivers //////////

    function _loadCodrivers() {
      return $http.get(CODRIVERS_PATH)
        .then(function (response) {
          codrivers = [];
          response.data.forEach(function (codriverData) {
            if (!userService.isActiveUser(codriverData)) {
              return;
            }

            var codriver = {
              id: String(codriverData.id),
              name: codriverData.name,
              username: codriverData.username
            };

            codrivers.push(codriver);
          });
        })
        .catch(function (error) {
          $log.error(error);
          return $q.reject(error);
        });
    }

    /**
     * save the codrivers data in the codriversPlan variable
     * @param {string} planId
     */
    function setCodriversByPlan(planId) {
      return $http
        .get(ROUTES_CODRIVERS_PATH, { params: { plan: planId } })
        .then(function (response) {
          codriversPlan = response.data;
        });
    }

    /**
     * Call the codrivers endpoing to save changes
     * codrivers items follow the structure {route_ids: array, codriver_ids: array}
     * @param {array} codrivers
     */
    function saveCodrivers(codrivers) {
      return $http.patch(ROUTES_CODRIVERS_PATH, codrivers);
    }

    function getCodriversByVehicleId(vehicleId) {
      var vehicle = vehiclesCodrivers.find(function (vehicle) {
        return vehicle.vehicleId === Number(vehicleId);
      });

      if (vehicle) {
        return vehicle.codriversId;
      }

      vehicle = vehicles.find(function (vehicle) {
        return vehicle.id === vehicleId;
      });
      return vehicle.codrivers.map(function (codriver) {
        return codriver.id;
      });
    }

    /**
     * save the codrivers data in codriversPlan for future plan edition
     * When a vehicle has multiple routes, aggregates all unique codrivers from all routes
     */
    function setVehiclesCodrivers() {
      var vehicleIds = originalPlan.vehiclesDict ? Object.keys(originalPlan.vehiclesDict) : [];
      vehiclesCodrivers = vehicleIds.map(function (vehicleId) {
        var vehicle = originalPlan.vehiclesDict[vehicleId];
        var routes = vehicle.routes || [];
        var allCodrivers = [];

        // Aggregate all codrivers from all routes of the vehicle
        routes.forEach(function (route) {
          var codriverByRoute = codriversPlan.find(function (codriverPlan) {
            return String(codriverPlan.route_id) === String(route.id);
          });
          if (codriverByRoute && codriverByRoute.codrivers) {
            codriverByRoute.codrivers.forEach(function (codriverId) {
              var normalizedId = String(codriverId);
              if (allCodrivers.indexOf(normalizedId) === -1) {
                allCodrivers.push(normalizedId);
              }
            });
          }
        });

        return {
          vehicleId: Number(vehicleId),
          codriversId: allCodrivers,
        };
      });
    }

    ////////// End Codrivers //////////

    ////////// Skills //////////

    function _loadSkills() {
      return $http.get(SKILLS_PATH)
        .then(successGetSkills, errorGetSkills);

      function successGetSkills(response) {
        return response.data.map(function (skillData) {
          var skill = {
            id: skillData.id,
            name: skillData.skill
          };
          if (angular.isUndefined(lodash.find(skills, function (o) {
            return o.id === skill.id;
          }))) {
            skills.push(skill);
          }
          return skill;
        });
      }

      function errorGetSkills(response) {
        $log.error(response);
        return $q.reject(response);
      }
    }

    function _loadSellers() {
      return $http.get(SELLERS_PATH)
        .then(successGetSellers, errorGetSellers);

      function successGetSellers(response) {
        response.data.forEach(function(sellerData, index) {
          var seller = {
            id: sellerData.id,
            name: sellerData.name,
            localIntId: index + 1 // this is a temporary numeric identifier for zone mapping in the optimization service.
          };
          var sellerExists = sellers.some(function(existingSeller) {
            return existingSeller.id === seller.id;
          });
          if (!sellerExists) {
            sellers.push(seller);
          }
        });
      }

      function errorGetSellers(response) {
        $log.error(response);
        return $q.reject(response);
      }
    }

    function getSkillObjById(skillId) {
      for (var i = 0; i < skills.length; i++) {
        if (skills[i].id === parseInt(skillId) || skills[i].id === skillId) {
          return skills[i];
        }
      }
      return;
    }

    function getSkillById(skillId) {
      return function (skill) {
        return skill.id === parseInt(skillId);
      };
    }

    function getSkills() {
      return skills;
    }

    function getSellers() {
      return sellers;
    }

    function getSellerById(sellerId) {
      return sellers.find(function (seller) {
        return seller.id === sellerId;
      });
    }

    ////////// End Skills //////////

    /// Routes ///
    function loadRoutes(date) {
      var plannedDate = date.start ? timeUtils.formatTime(date.start, DATE_FORMAT) : null;
      return $http.get(ROUTES_PATH, {params: {planned_date: plannedDate}})
        .then(successGetRoutes, errorGetRoutes);

      function successGetRoutes(response) {
        return response.data.map(function (routeData) {
          var route = new PlannerRouteModel();
          var isMixLoadEnabled = utilsService.isAddonPropertyEnabled(
            pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD]
          );

          angular.extend(route, {
            createAt: routeData.created,
            status: routeData.status,
            estimatedTimeStart: routeData.estimated_time_start,
            estimatedTimeEnd: routeData.estimated_time_end,
            vehicleId: routeData.vehicle.toString(),
            id: routeData.id,
            totalLoad: routeData.total_load,
            totalLoadPercentage: routeData.total_load,
            totalLoad2: routeData.total_load_2,
            totalLoadPercentage2: routeData.total_load_2_percentage,
            totalLoad3: routeData.total_load_3,
            totalLoadPercentage3: routeData.total_load_3_percentage,
            startTime: routeData.start_time,
            endTime: routeData.end_time
          });

          if (isMixLoadEnabled) {
            route.totalLoad4 = routeData.total_load_4;
            route.totalLoadPercentage4 = routeData.total_load_4_percentage;
          }
          // Searching for corresponding vehicle
          for (var i = 0; i < vehicles.length; i++) {
            if (vehicles[i].id === routeData.vehicle.toString()) {
              if ((vehicles[i].shift.start <= routeData.estimated_time_start) || (vehicles[i].shift.end <= routeData.estimated_time_end)) {
                vehicles[i].enabled = false;
              }
            }
          }
          routesAccount.push(route);
          return route;
        });
      }

      function errorGetRoutes(response) {
        $log.error(response);
        return $q.reject(response);
      }
    }

    /// End Routes ///
    ////////// Vehicles //////////
    function _loadVehicles(drivers) {
      return $http.get(VEHICLES_PATH)
        .then(successGetVehicles, errorGetVehicles);

      function successGetVehicles(response) {
        return response.data.map(function (vehicleData) {
          if (angular.isUndefined(lodash.find(vehicles, function (o) {
            return o.id === vehicleData.id.toString();
          }))) {

            if (vehicleData.rest_time_end) {
              vehicleData.rest_time_end = vehicleData.rest_time_end.split(':');
              vehicleData.rest_time_end = vehicleData.rest_time_end[0] + ':' + vehicleData.rest_time_end[1];
            }
            if (vehicleData.rest_time_start) {
              vehicleData.rest_time_start = vehicleData.rest_time_start.split(':');
              vehicleData.rest_time_start = vehicleData.rest_time_start[0] + ':' + vehicleData.rest_time_start[1];
            }
            if (vehicleData.shift_start) {
              vehicleData.shift_start = vehicleData.shift_start.slice(0, 5);
            }
            if (vehicleData.shift_end) {
              vehicleData.shift_end = vehicleData.shift_end.slice(0, 5);
            }

            var vehicle = PlannerVehicleModel.fromJson(vehicleData);
            if (vehicleData.default_driver) {
              var driverId = String(vehicleData.default_driver);
              var foundDriver = drivers.find(function (driver) {
                return driver.id === driverId;
              });

              if (foundDriver) {
                vehicle.driver = foundDriver;
                vehicle.driverId = driverId;
              }
            }

            if (!vehicle.shift.start) {
              vehicle.shift.start = shift.start;
            }

            if (!vehicle.shift.end) {
              vehicle.shift.end = shift.end;
            }

            vehicles.push(vehicle);
            if (vehicle.locationStart.latitude === 0) {
              vehicle.active = false;
            }

            colorAssignerService.setDefaultVehicleColorCache(
              vehicle.id, vehicleData.color
            );

            return vehicle;
          }
        });
      }

      function errorGetVehicles(response) {
        $log.error(response);
        return $q.reject(response);
      }
    }

    function hideVehicles() {
      if (angular.isDefined(vehicles)) {
        vehicles.forEach(function (vehicle) {
          vehicle.setVisible(false);
        });
      }
    }

    function setVisibleInVehicles(vehiclesToUpdate, areVehiclesVisible, isOpenEndedActive) {
      vehiclesToUpdate.forEach(function (vehicle) {
        if (vehicle.routes.length) {
          vehicle.setVisible(areVehiclesVisible, isOpenEndedActive);
        }
      });
    }

    function getActiveVehicles() {
      var activeVehicles = [];

      if (angular.isUndefined(vehicles)) {
        return [];
      }

      for (var i = 0; i < vehicles.length; i++) {
        if (vehicles[i].active) {
          activeVehicles.push(vehicles[i]);
        }
      }
      return activeVehicles;
    }

    function centerVehicle(vehicle) {
      vehicle.setVisible(true);
      var vehicleOrigin = googleService.getGoogleMapsLatLng(vehicle.locationStart.latitude, vehicle.locationStart.longitude);
      var vehicleDestiny = googleService.getGoogleMapsLatLng(vehicle.locationEnd.latitude, vehicle.locationEnd.longitude);
      var bounds = googleService.getLatLngBounds();
      bounds.extend(vehicleOrigin);
      bounds.extend(vehicleDestiny);
      googleMap.fitBounds(bounds);
    }

    function removeVehicle(vehicle) {
      // Liberamos las visitas de las rutas
      vehicle.routes.forEach(function (route) {
        route.visits.forEach(function (visit) {
          visit.setDefaultColor('#A4A4A4');
          visit.setVisible(true, false);
          visit.updateOrder(null);
        });

        removeVehicleRoute(vehicle, route);
      });
    }

    function wasInitialShiftChanged() {
      var edited = initialShift.edited || initialShift.start !== shift.start || initialShift.end !== shift.end;
      initialShift.edited = edited;
      return edited;
    }

    ////////// End Vehicles //////////

    function _getVisitBackend(backendId) {
      for (var i = 0; i < visits.length; i++) {
        if (visits[i].backendId === backendId) {
          return i;
        }
      }
      return -1;
    }


   ////////// Visits //////////
   /**
    * Load visits from icarus API
    *
    * @param {string} date - value of the planned_date field
    *
    * @param {string} status - csv of valid status (pending, completed, failed) (e.g. 'pending,completed') if
    * undefined or '', don't filter by statushe title of the book.
    *
    * @param {string} visitTypes - csv of valid visit type IDs; "null" corresponds to "no visit type" (e.g. '1,2,null');
    * if falsy, don't filter by visit type.
    *
    * @param {boolean} assignedToRoute - true if visits must be already assigned to a route; false if they must not be
    *
    * @param {boolean} duplicateVisits - If true, visits will have an empty ID and not marked with an "EDITED" request
    * status; this will, in effect, duplicate the visit for this plan if they are pushed. If false, visits keep their
    * ID and are marked with an "EDITED" request status; this means that they will be updated if they are ever pushed
    * to the API.
    *
    * @param {boolean} isCourierEnabled - true if account has courier feature enabled.
    *
    * @param {boolean} reuseVisits - true if imported visits must keep their original backend ID even when
    * duplicateVisits is true.
    */

    function _loadVisits(date, status, visitTypes, assignedToRoute, duplicateVisits, isCourierEnabled, endDate, reuseVisits) {
      var plannedDate;
      if (angular.isUndefined(status)) {
        status = '';
      }

      var arrayDeleteVisitsTemp = angular.copy(visits);

      date ? plannedDate = date : plannedDate = moment(planDate.start).format('YYYY-MM-DD');

      arrayDeleteVisitsTemp.forEach(function (visit) {
        if (moment(visit.plannedDate).isSame(moment(plannedDate), 'day') &&
            visit.backendId &&
            !getPlanName() &&
            visit.routeId === null) {
          visits.splice(_getVisitBackend(visit.id), 1);
        }
      });

      var queryParams = {
        not_assigned: !assignedToRoute,
        extended_data: EXTENDED_DATA
      };

      if(endDate) {
        queryParams.end_date =  moment(endDate).format('YYYY-MM-DD');
        queryParams.start_date = plannedDate;
      } else {
        queryParams.planned_date = plannedDate;
      }

      if (selectedFleet){
        queryParams.fleet = selectedFleet.id;
      }

      if (status !== '') {
        queryParams.status = status;
      }

      if (visitTypes) {
        queryParams.visit_types = visitTypes;
      }

      if (isCourierEnabled) {
        queryParams.not_courier = "true";
      }

     return requestService.httpGetPaginated(VISITS_PATH_PAGINATING, {
       params: queryParams
     })
        .then(successGetVisits, errorGetVisits);

      function successGetVisits(response) {
        var responseVisits = [];
        var isMixLoadEnabled = utilsService.isAddonPropertyEnabled(
          pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD]
        );
        response.data.forEach(function (visitData) {
          originalVisits[visitData.id] = angular.copy(visitData);
          if ((!visitData.route && !visitData.vehicle && !visitData.driver) || status !== '') {
            if (angular.isUndefined(lodash.find(visits, function (o) {
              return o.id === visitData.id.toString();
            }))) {
              var visit = new PlannerVisitModel();

              angular.extend(visit, {
                title: visitData.title.trim(),
                address: visitData.address.trim(),
                latitude: parseFloat(visitData.latitude),
                longitude: parseFloat(visitData.longitude),
                contactName: visitData.contact_name.trim(),
                contactPhone: visitData.contact_phone.trim(),
                contactEmail: visitData.contact_email,
                duration: timeUtils.parseVisitDuration(visitData.duration),
                notes: visitData.notes.trim(),
                reference: visitData.reference.trim(),
                load: parseFloat(visitData.load),
                load2: parseFloat(visitData.load_2),
                load3: parseFloat(visitData.load_3),
                priority: visitData.priority,
                priorityLevel: visitData.priority_level,
                plannedDate: moment(planDate.start).format('YYYY-MM-DD'),
                skills_required: visitData.skills_required,
                skills_optional: visitData.skills_optional,
                request_status: REQUEST_STATUS.CREATED,
                programmedDate: visitData.programmed_date,
                visitType: visitData.visit_type || null,
                tags: visitData.tags,
                properties: visitData.properties,
                relationships: visitData.relationships,
                extra_field_values: visitData.extra_field_values,
                items: visitData.items || [],
                seller_id: visitData.seller ? visitData.seller.id : null
              });

              if (isMixLoadEnabled) {
                visit.load4 = parseFloat(visitData.load_4);
              }
              // Properties that may be null
              if (visitData.contact_email) {
                visit.contactEmail = visitData.contact_email.trim();
              }
              if (visitData.window_start) {
                visit.windowStart = visitData.window_start.substring(0, 5);
              }
              if (visitData.window_end) {
                visit.windowEnd = visitData.window_end.substring(0, 5);
              }
              if (visitData.window_start_2) {
                visit.windowStart2 = visitData.window_start_2.substring(0, 5);
              }
              if (visitData.window_end_2) {
                visit.windowEnd2 = visitData.window_end_2.substring(0, 5);
              }
              if (visitData.estimated_time_arrival) {
                visit.estimatedTimeArrival = visitData.estimated_time_arrival.substring(0, 5);
              }
              if (visitData.estimated_time_departure) {
                visit.estimatedTimeDeparture = visitData.estimated_time_departure.substring(0, 5);
              }
              if (!duplicateVisits || reuseVisits) {
                visit.integration = true;
                visit.backendId = visitData.id.toString();
                visit.id = visitData.id.toString();
                visit.request_status = REQUEST_STATUS.EDITED;
                visit.isReused = reuseVisits;
              }
              if (visitData.geocode_alert) {
                visit.setAlert(visitData.geocode_alert);
              }
              visits.push(visit);
              responseVisits.push(visit);
            }
          }
        });
        return responseVisits;
      }

      function errorGetVisits(response) {
        $log.error(response);
        return $q.reject(response);
      }
    }

    function showVisits() {
      if (angular.isDefined(visits)) {
        visits.forEach(function (visit) {
          visit.setVisible();
        });
      }
    }

    function hideVisits(markerHasToBeUpdated) {
      if (angular.isUndefined(markerHasToBeUpdated)) {
        markerHasToBeUpdated = true;
      }

      if (angular.isDefined(visits)) {
        visits.forEach(function (visit) {
          visit.setVisible(false, markerHasToBeUpdated);
        });
      }
    }

    function centerVisit(visit, infowindow) {
      if (angular.isUndefined(infowindow)) {
        infowindow = true;
      }
      deactivateVisits();
      visit.setActive(true);
      visit.setVisible(true);
      // visit.showInfoWindow = true;
      var bounds = googleService.getLatLngBoundsOnPoint(googleService.getGoogleMapsLatLng(visit.latitude, visit.longitude));
      mapFitBounds(bounds, ZOOM_NUMBER_TO_CENTER_MARKER);
    }

    function putOffCenterVisit(visit) {
      visit.setActive(false);
      mapFitBoundAllVisits();
    }

    function deactivateVisits() {
      if (previousActiveVisit) {
        previousActiveVisit.setActive(false);
        previousActiveVisit.setHighlight(false, true);
      }
    }

    function filterVisibleVisits(status) {
      visits.map(function (visit) {
        if (status === 1) {
          visit.options.visible = true;
          return;
        }

        if (visit.status === status) {
          visit.options.visible = true;
        } else {
          visit.options.visible = false;
        }
      });
    }

    function orderVisitsByStatus() {
      service.visits.sort(_sortByStatus());

      function _sortByStatus() {
        return function (a, b) {
          if (a.status < b.status) {
            return 1;
          }
          if (a.status > b.status) {
            return -1;
          }
        };
      }
    }

    function resetVisitLook() {
      visits.forEach(function (visit) {
        if (visit.error) {
          switch (visit.error.type) {
            case 2:
              visit.setDefaultColor('#FFCC33');
              break;
            case 3:
              visit.setDefaultColor('#D9A60D');
              break;
            case 4:
              visit.setDefaultColor('#FF5252');
              break;
            default:
              visit.setDefaultColor('#A4A4A4');
          }
        } else {
          visit.setDefaultColor('#A4A4A4');
        }
        visit.setOpacity(1, !$rootScope.drawCluster);
      });
    }


    function setVisibleInRoutes(routes, areVisible, mustUpdateMapElements) {
      routes.forEach(function (route) {
        route.setVisible(areVisible, mustUpdateMapElements);
      });
    }

    function hideRoutes() {
      if (angular.isDefined(routes)) {
        routes.forEach(function (route) {
          route.setVisible(false);
        });
      }
    }

    function collapseOtherRoutes(route, isOpenEnded) {
      routes.forEach(function (obj) {
        if (obj.id !== route.id) {
          obj.collapse = true;
          var vehicle = _getVehicleByID(obj.vehicleId);
          vehicle.setVisible(false, isOpenEnded);
          obj.setVisitsListed(false);
        }
      });
    }

    function _getVehicleByID(vehicleId) {
      for (var i = 0; i < vehicles.length; i++) {
        if (vehicles[i].id === vehicleId) {
          return vehicles[i];
        }
      }
    }


    ////////// End Routes //////////

    function mapFitBounds(bounds, zoom) {
      googleMap.fitBounds(bounds);
      googleMap.setZoom(zoom);
    }

    function showInfoWindow(visit) {

      deactivateVisits();
      previousActiveVisit = visit;
      visit.setHighlight(true, true);
      visit.setActive(true);
    }

    function hideInfoWindow() {
      previousActiveVisit = null;
      $rootScope.$broadcast('Planner:Visit:hideInfoWindow', {});
    }

    function exportPlanTxt() {
      // Preparando Data
      var lineBreak = "\n";
      var tab = "\t";
      var textFinalTxt = "";

      var HEADERS =
        $filter('translate')('Excel_Header.driver') + tab +
        $filter('translate')('Excel_Header.vehicle') + tab +
        $filter('translate')('Excel_Header.route_Index') + tab +
        $filter('translate')('Excel_Header.stop') + tab +
        $filter('translate')('Excel_Header.title') + tab +
        $filter('translate')('Excel_Header.address') + tab +
        $filter('translate')('Excel_Header.service_Time') + tab +
        $filter('translate')('Excel_Header.arrival_Time') + tab +
        $filter('translate')('Excel_Header.distance') + tab +
        $filter('translate')('Excel_Header.order_size') + tab +
        $filter('translate')('Excel_Header.total_size') + tab +
        $filter('translate')('Excel_Header.latitude') + tab +
        $filter('translate')('Excel_Header.longitude') + tab +
        $filter('translate')('Excel_Header.reference') + tab +
        $filter('translate')('Excel_Header.warnings') + tab +
        $filter('translate')('Excel_Header.visit_load2') + tab +
        $filter('translate')('Excel_Header.visit_load3') + tab +
        $filter('translate')('Excel_Header.route_coment') + tab +
        $filter('translate')('Excel_Header.notes');

      textFinalTxt = textFinalTxt.concat(HEADERS) + lineBreak;

      var visitRows = "";

      vehicles.forEach(function (vehicle) {
        vehicle.routes.forEach(function (route, routeIndex) {
          var comment = route.comment || "";
          routeIndex = routeIndex + 1;
          var driverName = getDriverName(route.driver);

          // Location start for this route
          visitRows = visitRows.concat(
            driverName + tab +
            vehicle.name + tab +
            routeIndex + tab +
            0 + tab +
            'Inicio' + tab +
            route.locationStart.address + tab +
            '' + tab +
            route.estimatedTimeStart + tab +
            0 + tab +
            '' + tab +
            route.totalLoad + tab +
            parseFloat(route.locationStart.latitude) + tab +
            parseFloat(route.locationStart.longitude) + tab +
            comment
          ) + lineBreak;

          //Ordenamos el arreglo de visitas antes de mandarlo al excel
          route.visits.sort(function (a, b) {
            if (a.order > b.order) {
              return 1;
            }
            if (a.order < b.order) {
              return -1;
            }
            // a must be equal to b
            return 0;
          });

          route.visits.forEach(function (visit) {
            var visitError = visit.error ? visit.error.msg : tab;
            visitRows = visitRows.concat(
              driverName + tab +
              vehicle.name + tab +
              routeIndex + tab +
              visit.order + tab +
              visit.title + tab +
              visit.address + tab +
              visit.duration + tab +
              visit.estimatedTimeArrival + tab +
              " " + tab +
              visit.load + tab +
              route.totalLoad + tab +
              parseFloat(visit.latitude) + tab +
              parseFloat(visit.longitude) + tab +
              visit.reference + tab +
              visitError + tab +
              visit.load2 + tab +
              visit.load3 + tab +
              comment +
              visit.notes) + lineBreak;
          });

          // Location end for this route
          visitRows = visitRows.concat(
            driverName + tab +
            vehicle.name + tab +
            routeIndex + tab +
            route.visits.length + 1 + tab +
            'Fin' + tab +
            route.locationEnd.address + tab +
            '' + tab +
            route.estimatedTimeEnd + tab +
            route.totalDistance + tab +
            '' + tab +
            route.totalLoad + tab +
            parseFloat(route.locationEnd.latitude) + tab +
            parseFloat(route.locationEnd.longitude) + tab +
            comment
          ) + lineBreak;
        });
      });

      textFinalTxt = textFinalTxt.concat(visitRows);
      var data = new Blob([textFinalTxt], {type: 'text/plain;charset=utf-8'});
      FileSaver.saveAs(data, 'SimpliRoute_Plan_' + planDate.start + '.txt');
      $log.info("descargando reporte txt");
    }

    function getShowExtraFieldsEnabled() {
      return addonsService.listAddons()
        .then(function (addons) {
          var pathFinderAddon = addons.find(
             function(addon) { return addon.key === PATH_FINDER_ADD_ON_KEY && addon.enable; }
          );

          if (!pathFinderAddon) {
            return false; // No addon found
          }

          return addonsService
            .getAddonPropertiesByKey(
              pathFinderAddon.id,
              SHOW_EXTRA_FIELD_VALUES_PDF_ADDON_PROPERTY
            )
            .then(function (addonProperty) {
              return addonProperty.value.toLowerCase() === "true";
            });
        })
        .catch(function (error) {
          console.error(
            "Error getting addon property show_extra_field_values_pdf_detailed:",
            error
          );
          return false; // On error
        });
    }


    function exportPlanPdf() {
      var isShowExtraFieldValuesEnabled = false;

      getShowExtraFieldsEnabled().then(function (enabled) {
        isShowExtraFieldValuesEnabled = enabled;
        generatePlanPdf(isShowExtraFieldValuesEnabled);
      }, function (error) {
        console.error(
          "Error getting addon property show_extra_field_values_pdf_detailed:",
          error
        );
        generatePlanPdf(isShowExtraFieldValuesEnabled);
      });
    }

    function generatePlanPdf(isShowExtraFieldValuesEnabled) {

      var date = moment(planDate.start).format('LL');

      // parametros del pdf
      var docFinal = null;
      var tableDoc = [];

      // parametros del contenido
      var nameVehicle = null;
      var nameDriver = '';

      // parametros visitas
      var titleVisit = '';
      var addressVisit = '';
      var idVisit = '';
      var contactVisit = '';
      var phoneVisit = '';
      var skillsVisit = '';
      var timeWindows = '';
      var notes = '';

      //indices
      var countVisit = 0;
      var countRoute = 1;


      vehicles.forEach(function (vehicle) {
        if (vehicle.routes && vehicle.routes.length > 0) {
          nameVehicle = vehicle.name;
          if (vehicle.driver) {
            try {
              nameDriver = angular.fromJson(vehicle.driver).name;
            } catch (e) {
              nameDriver = vehicle.driver.name;
            }
          } else {
            nameDriver = $filter('translate')('Pdf.no_driver');
          }

          tableDoc.push({
            columns: [
              {
                alignment: 'left',
                image: 'simpli',
                width: 200,
                margin: [-20, -10]
              },
              {
                text: '',
                width: 150
              },
              {
                alignment: 'right',
                text: date + '\n' + $filter('translate')('Pdf.vehicle') + ': ' + nameVehicle + '\n ' + nameDriver
              }
            ]
          });

          vehicle.routes.forEach(function (route) {
            var comment = route.comment;
            if (angular.isUndefined(comment) || !comment) {
              comment = $filter('translate')('Pdf.no_route_comments');
            }
            route.visits.forEach(function (visit) {

              var streets_in_between = "";
              var customer_shipment_date = "";
              if (
                isShowExtraFieldValuesEnabled
                && visit.extra_field_values
                && Object.keys(visit.extra_field_values).length
              ) {
                streets_in_between = visit.extra_field_values.entre_calles_1 || streets_in_between;
                customer_shipment_date = visit.extra_field_values.fec_envio_cliente || customer_shipment_date;
              }

              titleVisit = visit.title;
              addressVisit = visit.address;
              idVisit = visit.reference;
              contactVisit = visit.contactName;
              phoneVisit = visit.contactPhone;
              notes = visit.notes;
              skillsVisit = _searchSkills(visit.skills_required);
              timeWindows= _buildTimeWindows(visit.windowStart, visit.windowEnd, visit.windowStart2, visit.windowEnd2);

              ++countVisit;

              tableDoc.push({text: ' ', margin: [0, 0, 0, 2]});
              tableDoc.push({
                table: {
                  headerRows: 1,
                  keepWithHeaderRows: 1,
                  dontBreakRows: true,
                  widths: [150, 120, 130, 100],
                  body: [
                    [
                      {
                        stack: [{
                          text: 'R - ' + countRoute + ' : ' + countVisit,
                          margin: [0, -5]
                        }]
                      }, {
                      canvas: [{type: 'line', x1: -115, y1: 8, x2: 360, y2: 8, lineWidth: 0.5}],
                      colSpan: 3
                    }, '', ' '
                    ],
                    [
                      {
                        text: [{
                          text: $filter('translate')('Pdf.name'),
                          style: 'tableHeader'
                        }, {text: '\n' + titleVisit, fontSize: 10}]
                      },
                      {
                        text: [{text: $filter('translate')('Pdf.id'), fontSize: 8}, {
                          text: '\n' + idVisit,
                          fontSize: 10
                        }]
                      },
                      {
                        text: $filter('translate')('Pdf.coments'),
                        alignment: 'left',
                        rowSpan: 2,
                        fontSize: 8,
                        style: 'tableHeader',
                        margin: [0, 2, 0, 0]
                      },
                      {
                        text: $filter('translate')('Pdf.signature'),
                        alignment: 'right',
                        rowSpan: 2,
                        fontSize: 8,
                        style: 'tableHeader',
                        margin: [0, 2, 5, 0]
                      }
                    ],
                    [
                      {
                        text: [{text: $filter('translate')('Pdf.address'), fontSize: 8}, {
                          text: '\n' + addressVisit,
                          fontSize: 10
                        }]
                      },
                      {
                        text: [{text: $filter('translate')('Pdf.contact'), fontSize: 8}, {
                          text: '\n' + contactVisit,
                          fontSize: 10
                        }]
                      },
                      {
                        text: [{text: '', fontSize: 8}, {text: '\n', fontSize: 10}]
                      },
                      {
                        text: [{text: '', fontSize: 8}, {text: '\n', fontSize: 10}]
                      }
                    ],
                    [
                      {
                        text: [{text: $filter('translate')('Pdf.windows'), fontSize: 8}, {
                          text: '\n' + timeWindows,
                          fontSize: 10
                        }]
                      },
                      {
                        text: [{text: $filter('translate')('Pdf.phone'), fontSize: 8}, {
                          text: '\n' + phoneVisit,
                          fontSize: 10
                        }]
                      },
                      {
                        text: [{
                          text: $filter('translate')('Pdf.skills_required'),
                          fontSize: 8
                        }, {text: '\n' + skillsVisit, fontSize: 10}]
                      },
                      isShowExtraFieldValuesEnabled ?
                      {
                        text: [{
                          text:  $filter('translate')('Pdf.between_streets'),
                          fontSize: 8
                        }, {text: '\n' + streets_in_between + ' ', fontSize: 8}],
                        alignment: 'right',
                        margin: [0, 0, 5, 0]
                      } : {
                        text: [{text: '', fontSize: 8}, {text: '\n', fontSize: 10}]
                      }
                    ],
                    [
                      {
                        text: [{
                          text: $filter('translate')('Pdf.route_comment'),
                          fontSize: 8,
                          colSpan: 2
                        }, {text: '\n' + comment, fontSize: 10, colSpan: 2}]
                      },
                      {
                        text: [{text: $filter('translate')('Pdf.notes'), fontSize: 8, colSpan: 2}, {
                          text: '\n' + notes,
                          fontSize: 10,
                          colSpan: 2
                        }]
                      },
                      '',
                      ''
                    ],
                    [
                      isShowExtraFieldValuesEnabled ?
                      {
                        text: [{
                          text: $filter('translate')('Pdf.customer_shipping_date'),
                          fontSize: 8
                        }, {text: '\n' + customer_shipment_date + ' ', fontSize: 8}]
                      } : {
                        text: [{text: '', fontSize: 8}, {text: '\n', fontSize: 10}]
                      },
                      {
                        text: [{text: '', fontSize: 8}, {text: '\n', fontSize: 10}]
                      },
                      {
                        text: [{text: '', fontSize: 8}, {text: '\n', fontSize: 10}]
                      },
                      {
                        text: [{text: '', fontSize: 8}, {text: '\n', fontSize: 10}]
                      }
                    ]
                  ]
                },
                layout: 'noBorders'
              });

            });
            countVisit = 0;
            ++countRoute;
            tableDoc.push({text: ' ', pageBreak: 'after'});
          });
          countRoute = 1;
          countVisit = 0;
        }
      });
      tableDoc.splice(-1, 1);
      docFinal = {
        content: tableDoc,
        styles: {
          tableHeader: {
            fontSize: 8
          }
        },
        images: {
          'simpli': PDF_LOGO_BASE64
        }
      };

      if (docFinal) {
        pdfMake.createPdf(docFinal).download('SimpliRoute_Plan_' + planDate.start, function () {
          $log.info('your pdf is done');
          $rootScope.isLoading = false;
        });
      }
    }

    function _buildTimeWindows(windowStart, windowEnd, windowStart2, windowEnd2) {

      var windowsStart = windowStart == null ? '00:00' : windowStart;
      var windowsEnd = windowEnd == null ? '23:59' : windowEnd;
      var windowsStart2 = windowStart2 == null ? '23:59' : windowStart2;
      var windowsEnd2 = windowEnd2 == null ? '23:59' : windowEnd2;

      if(windowsStart2 === windowsEnd2){
        return windowsStart + ' a ' + windowsEnd;
      } else {
        return windowsStart + ' a ' + windowsEnd + '\n' + windowsStart2 + ' a ' + windowsEnd2;
      }
    }

    function _searchSkills(skillsVisit) {
      var skillsString = '';
      skillsVisit.forEach(function (skillVisit) {
        skills.forEach(function (skill) {
          if (skillVisit === skill.id) {
            skillsString = skillsString + skill.name + ', ';
          }
        });
      });
      return skillsString;
    }

    function clearMapVisits() {
      visitsMarkersService.setVisibleInVisits(visits, false, false);
      $rootScope.$broadcast("Planner:Clear:Visits");
    }

    /////Plans Instance
    function _loadPlans() {
      plans.length = 0;
      return $http.get(PLAN_PATH, {})
        .then(successGetPlanInstance, errorGetPlanInstance);

      function successGetPlanInstance(response) {
        return response.data.map(function (planData) {
          var plan = {
            'id': planData.id,
            'name': planData.name,
            'startDate': planData.start_date,
            'endDate': planData.end_date,
            'created': planData.created,
            'fleet' : planData.fleet
          };
          plans.push(plan);
          return plan;
        });
      }

      function errorGetPlanInstance(response) {
        $log.error(response);
        return $q.reject(response);
      }
    }

    function resetVehicles(vehicles) {
      vehicles.forEach(function (vehicle) {
        vehicle.active = false;
        vehicle.clear();
      });
    }

    function mergePreviousPlan(plan, duplicatePlan) {
      // prioridad en vehiculos cargados en el plan
      planEditingSelected = false;
      // Removemos los markers y polylines del mapa
      $rootScope.$broadcast("Planner:Clear:Map", {
        mergePlan: true
      });

      visits.length = 0;
      routes.length = 0;
      backupRoutes = {};
      backupVehicles = {};
      planId = null;
      planName = null;
      planStatus = plan.status;

      lodash.merge(
        planDate,
        {
          'start': plan.start_date ? moment(plan.start_date).format('YYYY-MM-DD') : null,
          'end': plan.end_date ? moment(plan.end_date).format('YYYY-MM-DD') : null
        }
      );

      if (plan.start_time && plan.end_time) {
        var start_time = plan.start_time.slice(0,5);
        var end_time = plan.end_time.slice(0,5);
        setShift(start_time, end_time);
        if (!saveDraftPlanService.hasDraftPlan()) {
          setInitialShift(start_time, end_time);
        }
      }

      resetVehicles(vehicles);
      localOptimizationOptions.big_cluster = plan.is_cluster;
      lastOptimizationId = plan.plan_metadata ? plan.plan_metadata.last_optimization_id : null;
      currentOptimizationId = lastOptimizationId;
      planId = plan.id ? plan.id.toString() : null;
      newPlan = plan.isNewPlan || !planId;
      planName = newPlan ? null : plan.name;

      if (!duplicatePlan) {
        setCurrentPlanEditing(planId, planName);
      }

      plan.vehicles.forEach(function (vehicleIt) {
        var vehicle = vehicles.find(getVehicleById(vehicleIt.id));
        vehicle.active = true;
        vehicle.setColor(colorAssignerService.getVehicleColor(vehicle.id));
        vehicleIt.routes.forEach(function (route) {
          var newRoute = createRoute(vehicle.id);
          var routeCodrivers = route.codrivers;

          if ((!routeCodrivers || !Array.isArray(routeCodrivers) || routeCodrivers.length === 0) && route.id && codriversPlan && codriversPlan.length > 0) {
            var foundCodrivers = codriversPlan.find(function (codriverPlan) {
              return String(codriverPlan.route_id) === String(route.id);
            });
            if (foundCodrivers && foundCodrivers.codrivers && Array.isArray(foundCodrivers.codrivers)) {
              routeCodrivers = foundCodrivers.codrivers;
            }
          }

          angular.extend(newRoute, {
            vehicleId: String(route.vehicle),
            driver: route.driver,
            codrivers: (routeCodrivers && Array.isArray(routeCodrivers)) ? routeCodrivers.slice() : [],
            estimatedTimeStart: moment(route.estimated_time_start, ESTIMATED_TIME_FORMAT).format('HH:mm'),
            estimatedTimeEnd: moment(route.estimated_time_end, ESTIMATED_TIME_FORMAT).format('HH:mm'),
            totalTime: route.total_duration,
            totalTimeFormatted: bdDateTohourAndMinutes(route.total_duration),
            totalDistance: (route.total_distance / 1000),
            totalLoad: route.total_load,
            totalLoadPercentage: route.total_load_percentage,
            totalLoad2: route.total_load_2,
            totalLoadPercentage2: route.total_load_2_percentage,
            totalLoad3: route.total_load_3,
            totalLoadPercentage3: route.total_load_3_percentage,
            plannedDate: route.planned_date,
            locationStart: {
              address: route.location_start_address,
              latitude: parseFloat(route.location_start_latitude),
              longitude: parseFloat(route.location_start_longitude)
            },
            locationEnd: {
              address: route.location_end_address,
              latitude: parseFloat(route.location_end_latitude),
              longitude: parseFloat(route.location_end_longitude)
            },
            status: route.status,
            comment: route.comment,
            startTime: route.start_time,
            endTime: route.end_time,
            isRevised: route.is_revised
          });

          var isMixLoadEnabled = utilsService.isAddonPropertyEnabled(
            pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD]
          );

          if (isMixLoadEnabled) {
            newRoute.totalLoad4 = route.total_load_4;
            newRoute.totalLoadPercentage4 = route.total_load_4_percentage;
          }

          if (route.id) {
            newRoute.id = route.id.toString();
            newRoute.backendId = route.new_route ? null : route.id.toString();
          }
          if (route.events) {
            newRoute.events = route.events;
          }

          if (angular.isDefined(route.collapse)) {
            newRoute.collapse = route.collapse;
            newRoute.areVisitsListed = !route.collapse;
          }

          route.visits.sort(function (a, b) {
            if (a.order > b.order) {
              return 1;
            }
            if (a.order < b.order) {
              return -1;
            }
            // a must be equal to b
            return 0;
          });

          route.visits.forEach(function (visit) { //Visits
            var newVisit = createFullVisitObj(visit, duplicatePlan);
            if (duplicatePlan) {
              newVisit.request_status = REQUEST_STATUS.CREATED;
            }

            var skillError = vehicle.validateVisitSkills(newVisit);
            if (skillError) {
              newRoute.skillsError = true;
              newVisit.skillsError = true;
            }

            newVisit.setDefaultColor(vehicle.color);
            newVisit.setSelected(false);

            newRoute.addVisitToRoute(newVisit);
            statisticsService.increaseTotalLoads(newVisit);
          });

          var existRouteInDB = true;
          vehicle.addRoute(newRoute, existRouteInDB);
        });

        vehicle.setAreAllRoutesRevised();
        vehicle.driver = null;
        vehicle.driverId = null;
        if (!_hasVehicleMultiDriver(vehicleIt)) {
          var route = vehicleIt.routes[0];
          if (route && route.driver) {
            var driverId = route.driver;
            var foundDriver = drivers.find(function (driver) {
                return driver.id === driverId;
            });

            if (foundDriver) {
              vehicle.driver = foundDriver;
              vehicle.driverId = driverId;
            }
          }
        }
      });

      setVehiclesShiftTime(vehicles, plan.isDraft);
      statisticsService.updateTotalVehiclesCapacity(plan.vehicles);
      var deferred = $q.defer();
      var optimizations = _getOptimizations(plan.plan_metadata, localOptimizationOptions, duplicatePlan);
      var promises = [];
      if (duplicatePlan) {
        promises = routes.map(function (route) {
          var vehicle = vehicles.filter(getVehicleById(route.vehicleId))[0];
          return route.calculatePath(vehicle, optimizations, getPlanStartTime(), isVehicularRestrictionEnabled());
        });
      }

      if (!plan.isDraft) {
        promises.push(addressStatsService.fetchAndProcessAddressStats(visits));
      }

      loadVisitsOutOfRoute();
      $q.all(promises).then(function () {
        deferred.resolve();
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    }

    function mergePreviousPartialPlan(plan) {
      setPlanDate(moment(plan.start_date), moment(plan.end_date));
      setShift(plan.start_time, plan.end_time);

      plan.visits.forEach(function (visit) {
        var newVisit = createFullVisitObj(visit);
        newVisit.setSelected(false);
        statisticsService.increaseTotalLoads(newVisit);
      });

      var deferred = $q.defer();
      deferred.resolve();
      return deferred.promise;
    }

    function loadVisitsOutOfRoute() {
      if (saveDraftPlanService.hasDraftPlan()) {
        var visitsOutOfRoute = saveDraftPlanService.getVisitsDetail(saveDraftPlanService.unrouted);
        if (visitsOutOfRoute) {
          visitsOutOfRoute.forEach(function (visit) {
            createFullVisitObj(visit);
          });
        }
      }
    }

    function createFullVisitObj(visit, duplicatePlan) {
      var visitObject = createVisit(parseFloat(visit.latitude), parseFloat(visit.longitude));
      var isMixLoadEnabled = utilsService.isAddonPropertyEnabled(
        pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD]
      );
      angular.extend(visitObject, {
        backendId: visit.id && visit.request_status !== REQUEST_STATUS.CREATED ? visit.id.toString() : null,
        id: visit.id ? visit.id.toString() : null,
        title: visit.title.trim(),
        address: visit.address.trim(),
        latitude: parseFloat(visit.latitude),
        longitude: parseFloat(visit.longitude),
        contactName: visit.contact_name.trim(),
        contactPhone: visit.contact_phone.trim(),
        contactEmail: visit.contact_email,
        duration: timeUtils.parseVisitDuration(visit.duration),
        notes: visit.notes.trim(),
        reference: visit.reference.trim(),
        load: parseFloat(visit.load),
        load2: parseFloat(visit.load_2),
        load3: parseFloat(visit.load_3),
        priority: visit.priority,
        priorityLevel: visit.priority_level,
        order: visit.order,
        plannedDate: visit.planned_date,
        requiredSkills: visit.skills_required,
        optionalSkills: visit.skills_optional,
        skills_required: visit.skills_required,
        skills_optional: visit.skills_optional,
        estimatedTimeArrival: visit.estimated_time_arrival ? moment(visit.estimated_time_arrival , ESTIMATED_TIME_FORMAT).format('HH:mm') : null,
        estimatedTimeDeparture: visit.estimated_time_departure ? moment(visit.estimated_time_departure, ESTIMATED_TIME_FORMAT).format('HH:mm') : null,
        windowStart: (angular.isString(visit.window_start) && visit.window_start.length >= visit.window_start.length - 3) ?
          visit.window_start.substring(0, visit.window_start.length - 3) : '',
        windowEnd: (angular.isString(visit.window_end) && visit.window_end.length >= visit.window_end.length - 3) ?
          visit.window_end.substring(0, visit.window_end.length - 3) : '',
        windowStart2: (angular.isString(visit.window_start_2) && visit.window_start_2.length >= visit.window_start_2.length - 3) ?
          visit.window_start_2.substring(0, visit.window_start_2.length - 3) : '',
        windowEnd2: (angular.isString(visit.window_end_2) && visit.window_end_2.length >= visit.window_end_2.length - 3) ?
          visit.window_end_2.substring(0, visit.window_end_2.length - 3) : '',
        routeId: (visit.route) ? visit.route.toString() : null,
        sourceRouteId: getSourceRouteId(visit),
        zones: (angular.isUndefined(visit.zones) || !visit.zones) ? [] : visit.zones,
        programmedDate: visit.programmed_date,
        visitType: visit.visit_type,
        tags: visit.tags,
        checkoutTime: visit.checkout_time ? moment(visit.checkout_time, ESTIMATED_TIME_FORMAT).format("HH:mm") : null,
        items: visit.items || [],
        error: visit.error || null,
        pickLoad: visit.pickLoad || 0,
        pickLoad2: visit.pickLoad2 || 0,
        pickLoad3: visit.pickLoad3 || 0,
        hashValue: visit.hashValue || null,
        geocodeAlert: visit.geocodeAlert || null,
        timeError: visit.timeError || false,
        addedInCurrentRouting: visit.addedInCurrentRouting || false,
        seller_id: visit.seller_id || null,
        isReused: visit.isReused || false
      });
      if (isMixLoadEnabled) {
        visitObject.load4 = parseFloat(visit.load_4);
      }
      if (visit.extra_field_values) {
        visitObject.extra_field_values = visit.extra_field_values;
      }
      if (visit.request_status) {
        visitObject.request_status = visit.request_status;
      }

      if (typeof visit.status === 'number') {
        visitObject.status = visit.status;
      }

      if (visit.addressStatistics) {
        visitObject.addressStatistics = visit.addressStatistics;
      }

      if (duplicatePlan) {
        visitObject.extra_properties = visit.extra_properties ? angular.copy(visit.extra_properties) : {};
      }

      visitObject.properties = visit.properties;
      visitObject.relationships = visit.relationships;
      return visitObject;
    }

    function getSourceRouteId(visit) {
      var sourceRouteId = saveDraftPlanService.hasDraftPlan() ? visit.sourceRouteId : visit.route;
      return sourceRouteId ? sourceRouteId.toString() : null;
    }

    function setEditMode(active) {
      editModeRoutes = active;
    }

    function deletePlan(planId, deleteVisits) {
      var pathToKeepVisits = PLAN_PATH + planId + '/';
      var pathToDeleteVisits = PLAN_PATH + planId + '/delete-plan-and-visits/';
      return deleteVisits ? $http.delete(pathToDeleteVisits) : $http.delete(pathToKeepVisits);
    }

    function clearPlanPromise() {
      getPlanPromise = null;
    }

    function getPlanName() {
      return (angular.isUndefined(planName) || planName === '') ? null : planName;
    }

    function bdDateTohourAndMinutes(duration) {
      var totalMinutes = 0,
        splitTime,
        days,
        hours,
        minutes,
        timeMinutes;
      var splitTimeFirst = duration.split(' ');
      if (splitTimeFirst.length > 1) {
        days = splitTimeFirst[0];
        totalMinutes += ((parseInt(days) * 24) * 60);
        splitTime = splitTimeFirst[1].split(':');
        hours = splitTime[0];
        minutes = splitTime[1];
        timeMinutes = parseInt(hours * 60) + parseInt(minutes);
        totalMinutes += timeMinutes;
      } else {
        splitTime = splitTimeFirst[0].split(':');
        hours = splitTime[0];
        minutes = splitTime[1];
        timeMinutes = parseInt(hours * 60) + parseInt(minutes);
        totalMinutes += timeMinutes;
      }
      minutes = totalMinutes % 60;
      hours = totalMinutes / 60;
      var splitted = String(hours).split('.');
      return (("0" + Math.floor(hours)).slice((splitted[0].length * -1)) + ":" + ("0" + minutes).slice(-2));
    }

    function _formatEstimatedTimes(routes) {
      return routes.map(function (originalRoute) {
        var route = {};
        angular.copy(originalRoute, route);
        if (route.estimated_time_start && route.estimated_time_start.indexOf('T') > -1) {
          route.estimated_time_start = moment(route.estimated_time_start).format("HH:mm");
        }
        if (route.estimated_time_end && route.estimated_time_end.indexOf('T') > -1) {
          route.estimated_time_end = moment(route.estimated_time_end).format("HH:mm");
        }
        route.visits.forEach(function (visit) {
          if (visit.estimated_time_arrival && visit.estimated_time_arrival.indexOf('T') > -1) {
            visit.estimated_time_arrival = moment(visit.estimated_time_arrival).format("HH:mm");
          }
          if (visit.estimated_time_departure && visit.estimated_time_departure.indexOf('T') > -1) {
            visit.estimated_time_departure = moment(visit.estimated_time_departure).format("HH:mm");
          }
        });
        return route;
      });
    }

    function createPlan(planName, isMultiDayRouteEnabled, forceSave, planMetadata, status) {
      isVisitsJoinedByDistance = angular.isNumber(
        localOptimizationOptions.distance_to_join_visits
      ) && localOptimizationOptions.distance_to_join_visits >= 0;

      $rootScope.isLoading = true;
      var deferred = $q.defer();
      var routesRequestData = [];

      if (planDateModified.start) {
        planDate.start = planDateModified.start;
      }
      if (planDateModified.end) {
        planDate.end = planDateModified.end;
      }
      planDate.end = planDate.end || planDate.start;
      planNameAux = planName;

      routesRequestData = getRoutesToCreateRequest();

      var requestData = {
        'id': planId,
        'name': planName,
        'start_time': shift.start,
        'end_time': shift.end,
        'start_date': moment(planDate.start).format('YYYY-MM-DD'),
        'end_date': moment(planDate.end).format('YYYY-MM-DD'),
        'is_cluster': localOptimizationOptions.big_cluster,
        'status': status || PLAN_STATUS.completed,
        'routes': _formatEstimatedTimes(routesRequestData),
        'fleet': fleetId
      };

      if (isMultiDayRouteEnabled) {
        requestData.reset_day = NO_RESET;
      }

      if (forceSave) {
        requestData.force_save = true;
      }

      // planMetada can be null if a user duplicates an old plan
      if (planMetadata) {
        requestData.plan_metadata = planMetadata;
      } else if (planMetadata !== null) {
        requestData.plan_metadata = _getPlanMetadata(localOptimizationOptions, defaultRoutingOptions);
      }

      planService.isNonBlockingSavingEnabled()
        .then(function (async) {
          if (async) {
            requestData.plan_optimization_reference = service.getAllOptimizationIds();
            requestData.force_save = true;
          }

          return planService.savePlan(requestData, isVisitsJoinedByDistance, async)
            .then(function (response) {
              planService.saveOptimizationIds(response.data.id, service.getAllOptimizationIds(), async);

              if (async) {
                var draftPlanKey = planService.getDraftPlanKey(response.data.id);
                service.setOriginalPlanAndSaveDraftPlanFormat(draftPlanKey, __env.LOCAL_PLAN_SAVE_PENDING_EXPIRATION_MINUTES);
              } else {
                _updateDataPlan(response.data);
              }

              deferred.resolve();
            })
            .catch(function (e) {
              deferred.reject(e);
            })
            .finally(function () {
              $rootScope.isLoading = false;
            });
        });

      return deferred.promise;
    }

    function changeDateModal(date) {
      planDateModified.start = date;
      planDateModified.end = date;
    }

    function _updateDataPlan(planBackend) {
      if (planBackend.id) {
        setPlanId(planBackend.id);
        planBackend.routes.forEach(function (routeId, index) {
          routes[index] ? routes[index].backendId = routeId : null;
        });
      }
    }

    function tryPreGeoreferenceBatch(visits, country, geocoderQualityLevel) {
      return geocoderService.geocodeBatch(country, geocoderQualityLevel, visits)
        .then(function(response) {
            return response.data;
          })
        .catch(function(error) {
          $log.info(error);
          return null;
        })
        .finally(function(){
            $rootScope.isLoading = false;
          });
    }

    function getAllVisits() {
      return visits;
    }

    function getVisits() {
      if (utilsService.isAddonPropertyEnabled(pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.POSITIVE_SELECTION_VISITS])) {
        var checkedVisits = visits.filter(function (visit) {
          return visitsForRouting.includes(visit.id);
        });

        if (checkedVisits.length > 0) {
          return checkedVisits;
        }

        return visits;
      }

      return visits;
    }

    function getRoutes() {
      return routes;
    }

    function getPlanInfo(planName) {
      var plan = {
        'id': planId,
        'name': planName,
        'startDate': moment(planDate.start).format('YYYY-MM-DD'),
        'endDate': moment(planDate.end).format('YYYY-MM-DD')
      };
      return plan;
    }

    function getVehicles() {
      return vehicles;
    }

    function getPlanDate() {
      return planDate;
    }

    function setVisits(data) {
      visits = data;
    }

    function setVehicles(data) {
      vehicles = data;
    }

    function setRoutes(data) {
      routes = data;
    }

    function visitsBulkEdit(visitsId, data) {
      visits.map(function (visit) {
        if (visitsId.indexOf(visit.id) !== -1) {
          visit.request_status = visit.request_status ? visit.request_status : REQUEST_STATUS.EDITED;
          statisticsService.increaseTotalLoads(calculateLoadDifferences(visit, data));
          Object.assign(visit, data);
        }
      });
    }

    function createRoutesPolyline() {
      if (routes.length > 0) {
        service.setVisibleInRoutes(routes, true, false);
        routes.forEach(function (route) {
          route.actionCreate(route);
        });
      }
    }

    function clearMapRoutes() {
      service.setVisibleInRoutes(routes, false, false);
      $rootScope.$broadcast("Planner:Clear:Polylines");
      $rootScope.$broadcast("Planner:Clear:Polygons");
    }

    function clearMapVisitsAndRoutes() {
      clearMapVisits();
      clearMapRoutes();
    }

    function getVehiclesAvailableWithRoutes() {
      var deferred = $q.defer();
      var date = {
        start: moment(planDate.start).format('YYYY-MM-DD')
      };
      loadRoutes(date).then(function () {
        var vehiclesAvailable = proccessRoutesForVehiclesAvailability();
        deferred.resolve(vehiclesAvailable);
      }, function error(e) {
        $log.info(e);
        deferred.reject();
      });

      return deferred.promise;
    }

    function getActiveVehiclesWithoutRoutesInPlan() {
      return getVehicles().filter(function (vehicle) {
        return vehicle.active && vehicle.routes.length === 0;
      });
    }

    function proccessRoutesForVehiclesAvailability() {
      var routes = routesAccount;
      var activeVehicles = getActiveVehiclesWithoutRoutesInPlan();
      var vehiclesAvailables = [];

      for (var i = 0; i < activeVehicles.length; i++) {
        var vehicle = activeVehicles[i];
        var shiftStart = moment(planDate.start);
        var shiftEnd = moment(planDate.start);

        // Moment create a moment obj automatically with the current time so it's necessary update using shift
        shiftStart.set({
          'hour': parseInt(vehicle.shift.start.slice(0, 2)),
          'minute': parseInt(vehicle.shift.start.slice(3, 5))
        });

        shiftEnd.set({
          'hour': parseInt(vehicle.shift.end.slice(0, 2)),
          'minute': parseInt(vehicle.shift.end.slice(3, 5))
        });
        var proccessAvailableResult = vehicle.isAvailableIn(shiftStart, shiftEnd, routes, planDate);
        if (proccessAvailableResult.available) {
          vehiclesAvailables.push(vehicle);
        }
      }
      return vehiclesAvailables;
    }

    function getVisitsBelongingAnyRoute() {
      return visits.filter(function (visit) {
        return visit.routeId;
      });
    }

    function getVisitsOutOfRoute(visits) {
      return visits.filter(function (visit) {
        return !visit.routeId;
      });
    }

    function setVisitsOutOfRouteAttributes(visits) {
      var mustUpdateMarkers = false;
      visits.forEach(function(visit) {
        visit.setDefaultColor(VISIT_OUT_OF_ROUTE_DEFAULT_COLOR);
        visit.updateOrder(VISIT_OUT_OF_ROUTE_ORDER, mustUpdateMarkers);
      });
      return visits;
    }

    function getVehiclesAvailable() {
      return vehicles.filter(function (vehicle) {
        var isVehicleActive = vehicle.active || vehicle.availability.isAvailable;
        var vehicleActiveNoFleet = !selectedFleet && isVehicleActive;
        var isVehicleActiveInFleet = selectedFleet && selectedFleet.vehicles.indexOf(parseInt(vehicle.id)) !== -1 && isVehicleActive;
        return isVehicleActiveInFleet || vehicleActiveNoFleet;
      });
    }

    function exportPlanExcel() {
      var data = {
        vehicles: vehicles,
        drivers: drivers,
        date: timeUtils.formatTime(planDate.start, DATE_FORMAT),
        visitsOutOfRoute: getVisitsOutOfRoute(visits)
      };

      reportService.downloadReportExcelPlan(data, localOptimizationOptions);
    }

    function editPlan(planName, initialPlanName, forceSave, status) {
      $rootScope.isLoading = true;
      var deferred = $q.defer();
      var routesRequestData = [];
      isVisitsJoinedByDistance = angular.isNumber(
        localOptimizationOptions.distance_to_join_visits
      ) && localOptimizationOptions.distance_to_join_visits >= 0;
      var isIncrementalRoutingOptimize = optimizationOptions.reoptimization_action === 3; // 3 is incremental routing

      if (planDateModified.start) {
        planDate.start = planDateModified.start;
      }

      planNameAux = planName;
      routesRequestData = getRoutesToCreateRequest();

      var requestData = {
        'id': planId,
        'name': planName,
        'start_time': shift.start,
        'end_time': shift.end,
        'start_date': moment(planDate.start).format('YYYY-MM-DD'),
        'end_date': moment(planDate.end).format('YYYY-MM-DD'),
        'is_cluster': localOptimizationOptions.big_cluster,
        'status': status || PLAN_STATUS.completed,
        'routes': _formatEstimatedTimes(routesRequestData),
        'plan_metadata': _getPlanMetadata(localOptimizationOptions, defaultRoutingOptions, isIncrementalRoutingOptimize)
      };

      if (
        planName !== initialPlanName ||
        initialShift.start !== shift.start ||
        initialShift.end !== shift.end ||
        planStatus !== status
      ) {
        requestData["request_status"] = "edited";
      }

      if (forceSave) {
        requestData.force_save = true;
      }

      planService.isNonBlockingSavingEnabled()
        .then(function (async) {
          if (async) {
            requestData.plan_optimization_reference = service.getAllOptimizationIds();
            requestData.force_save = true;
          }

          return planService.editPlan(requestData, isVisitsJoinedByDistance, isIncrementalRoutingOptimize, async)
            .then(function (response) {
              planService.saveOptimizationIds(response.data.id, service.getAllOptimizationIds(), async);

              if (async) {
                var draftPlanKey = planService.getDraftPlanKey(response.data.id);
                service.setOriginalPlanAndSaveDraftPlanFormat(draftPlanKey, __env.LOCAL_PLAN_SAVE_PENDING_EXPIRATION_MINUTES);
              } else {
                _updateDataPlan(response.data);
              }
              deferred.resolve();
            })
            .catch(function (e) {
              deferred.reject(e);
            })
            .finally(function () {
              $rootScope.isLoading = false;
            });
        });

      return deferred.promise;
    }

    function createDataVisitObject(visit, saveVisitZoneId) {
      var isMixLoadEnabled = utilsService.isAddonPropertyEnabled(
        pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD]
      );
      var tempVisit = {
        address: visit.address,
        contact_name: visit.contactName,
        contact_phone: visit.contactPhone,
        contact_email: visit.contactEmail,
        duration: timeUtils.formatVisitDuration(timeUtils.parseVisitDuration(visit.duration)),
        estimated_time_arrival: visit.estimatedTimeArrival,
        estimated_time_departure: visit.estimatedTimeDeparture,
        latitude: parseFloat(visit.latitude).toFixed(6),
        longitude: parseFloat(visit.longitude).toFixed(6),
        geocoder_id: visit.hashValue,
        load: parseFloat(parseFloat(visit.load).toFixed(2)),
        load_2: (visit.load2) ? parseFloat(parseFloat(visit.load2).toFixed(2)) : 0,
        load_3: (visit.load3) ? parseFloat(parseFloat(visit.load3).toFixed(2)) : 0,
        order: visit.order,
        notes: visit.notes,
        priority: visit.getCPriority(),
        priority_level: visit.getPriority(),
        reference: visit.reference,
        skills_optional: visit.skills_optional,
        skills_required: visit.skills_required,
        title: visit.title,
        window_end: (visit.windowEnd === "" || visit.windowEnd === null) ? '23:59' : visit.windowEnd,
        window_end_2: (visit.windowEnd2 === "" || visit.windowEnd2 === null) ? '23:59' : visit.windowEnd2,
        window_start: (visit.windowStart === "" || visit.windowStart === null) ? '00:00' : visit.windowStart,
        window_start_2: (visit.windowStart2 === "" || visit.windowStart2 === null) ? '23:59' : visit.windowStart2,
        id: visit.request_status === REQUEST_STATUS.CREATED && !visit.integration ? null : visit.id,
        request_status: visit.request_status,
        programmed_date: (visit.programmedDate === "") ? null : visit.programmedDate,
        visit_type: visit.visitType || null,
        tags: visit.tags,
        seller_id: visit.seller_id || null
      };

      if (isMixLoadEnabled && visit.load4) {
        tempVisit.load_4 = parseFloat(parseFloat(visit.load4).toFixed(2));
      }

      if (visit.extra_field_values) {
        tempVisit.extra_field_values = visit.extra_field_values;
      }

      if (visit.getGeocodeAlert()) {
        tempVisit.geocode_alert = visit.getGeocodeAlert();
      }

      if (isVisitsJoinedByDistance) {
        tempVisit.frontend_stop_id = visit.stopId || null;
        tempVisit.frontend_id = visit.id || null;
      }

      var extraProperties = visit.extra_properties ? angular.copy(visit.extra_properties) : {};

      if (saveVisitZoneId && !extraProperties.hasOwnProperty('zone_id')) {
        extraProperties.zone_id = visit.zones && visit.zones.length > 0 ? visit.zones[0].id : null;
      }

      if (Object.keys(extraProperties).length > 0) {
        tempVisit.extra_properties = extraProperties;
      }

      return tempVisit;
    }

    function createDataRouteObject(route, totalTimeForSave, visitsRequestData) {
      var isMixLoadEnabled = utilsService.isAddonPropertyEnabled(
        pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD]
      );
      var routeObject = {
        id: route.backendId || null,
        driver: route.driver,
        codrivers: route.codrivers || [],
        vehicle: route.vehicleId,
        planned_date: route.plannedDate || timeUtils.formatTime(planDate.start, 'YYYY-MM-DD'),
        total_distance: (route.totalDistance * 1000).toFixed(0),
        total_duration: totalTimeForSave,
        total_load: route.totalLoad,
        total_load_percentage: parseInt(parseFloat(route.totalLoadPercentage).toFixed(0)),
        total_load_2: route.totalLoad2,
        total_load_2_percentage: parseInt(parseFloat(route.totalLoadPercentage2).toFixed(0)),
        total_load_3: route.totalLoad3,
        total_load_3_percentage: parseInt(parseFloat(route.totalLoadPercentage3).toFixed(0)),
        estimated_time_start: route.estimatedTimeStart,
        estimated_time_end: route.estimatedTimeEnd,
        comment: route.comment,
        location_start_address: route.locationStart.address,
        location_start_latitude: route.locationStart.latitude,
        location_start_longitude: route.locationStart.longitude,
        location_end_address: route.locationEnd.address,
        location_end_latitude: route.locationEnd.latitude,
        location_end_longitude: route.locationEnd.longitude,
        visits: visitsRequestData,
        request_status: route.request_status,
        events: route.events,
        polyline: route.polyline || '',
        is_revised: route.isRevised
      };

      if (isMixLoadEnabled) {
        routeObject.total_load_4 = route.totalLoad4;
        routeObject.total_load_4_percentage = parseInt(parseFloat(route.totalLoadPercentage4).toFixed(0));
      }

      if (route.request_status !== REQUEST_STATUS.EDITED) {
        routeObject.start_time = route.startTime;
        routeObject.end_time = route.endTime;
      }

      var routeRestTime = getRestTimeByRouteId(route.id);
      if (routeRestTime) {
        routeObject.events = restTimeToEvent(routeRestTime);
      }

      if (colorAssignerService.areColorsEnabled()) {
        routeObject.properties = {
          color: colorAssignerService.getVehicleColor(Number(route.vehicleId))
        };
      }

      return routeObject;
    }

    /**
     * Normalizes extended time format (hours >= 24) to standard 24-hour format
     * E.g., "25:13" → "01:13", "24:16" → "00:16"
     * @param {string} timeString - Time in HH:mm format (may have hours >= 24)
     * @returns {string} Normalized time in HH:mm format (hours 0-23)
     */
    function normalizeExtendedTime(timeString) {
      if (!timeString || typeof timeString !== 'string') {
        return timeString;
      }

      var parts = timeString.split(':');
      if (parts.length !== 2) {
        return timeString;
      }

      var hours = parseInt(parts[0], 10);
      var minutes = parts[1];

      // Normalize hours >= 24 to standard 24-hour format
      var normalizedHours = hours % 24;
      var paddedHours = normalizedHours < 10 ? '0' + normalizedHours : String(normalizedHours);

      return paddedHours + ':' + minutes;
    }

    /**
     * From restTime plannerService object to dataRoute event object
     * @param {object} restTime
     * @returns {Array} length 1 object array
     */
    function restTimeToEvent(restTime){
      var arrival = restTime.arrival;
      var departure = restTime.departure;

      // Normalize extended time format to standard 24-hour format for API compatibility
      // Only when longRoutes (multi-day) and skip_time_validation are both enabled
      if (isLongRoutesEnabled() && getSkipTimeValidation()) {
        arrival = normalizeExtendedTime(restTime.arrival);
        departure = normalizeExtendedTime(restTime.departure);
      }

      return [{
        type: "rest_time",
        latitude: parseFloat(restTime.lat).toFixed(6),
        longitude: parseFloat(restTime.lon).toFixed(6),
        start_time: arrival,
        end_time: departure
      }];
    }

    /**
     * From dataRoute event to restTime plannerService object
     * @param {object} event
     * @returns {object} restime format object
     */
    function eventToRestTime(event){
      var calculatedServiceTime;
      var arrival;
      var departure;

      // Handle extended time format only when longRoutes (multi-day) and skip_time_validation are both enabled
      if (isLongRoutesEnabled() && getSkipTimeValidation()) {
        // Check if we're dealing with extended time format (hours >= 24)
        var isExtendedFormat = timeUtils.isExtendedTimeFormat(event.start_time) ||
                               timeUtils.isExtendedTimeFormat(event.end_time);

        if (isExtendedFormat) {
          // Use extended time calculation for multi-day plans
          var startTimeMinutes = timeUtils.parseExtendedTimeToMinutes(event.start_time);
          var endTimeMinutes = timeUtils.parseExtendedTimeToMinutes(event.end_time);
          calculatedServiceTime = endTimeMinutes - startTimeMinutes;
          arrival = timeUtils.formatMinutesToExtendedTime(startTimeMinutes);
          departure = timeUtils.formatMinutesToExtendedTime(endTimeMinutes);
        } else {
          // Standard moment-based calculation
          var startTimeMoment = moment(event.start_time, 'HH:mm');
          var endTimeMoment = moment(event.end_time, 'HH:mm');
          var timeDiffMs = endTimeMoment - startTimeMoment;

          if (timeDiffMs < 0) {
            calculatedServiceTime = moment.duration(timeDiffMs + (24 * 60 * 60 * 1000), 'milliseconds').asMinutes();
          } else {
            calculatedServiceTime = moment.duration(timeDiffMs, 'milliseconds').asMinutes();
          }

          arrival = moment(event.start_time, ESTIMATED_TIME_FORMAT).format('HH:mm');
          departure = moment(event.end_time, ESTIMATED_TIME_FORMAT).format('HH:mm');
        }
      } else {
        // Standard moment-based calculation for non-extended times
        var startTimeMoment = moment(event.start_time, 'HH:mm');
        var endTimeMoment = moment(event.end_time, 'HH:mm');
        var timeDiffMs = endTimeMoment - startTimeMoment;

        // Handle midnight crossing: if end_time is earlier than start_time, it means the rest time crosses midnight
        // Add 24 hours (1440 minutes) to get the correct duration
        if (timeDiffMs < 0) {
          // Rest time crosses midnight, add 24 hours
          calculatedServiceTime = moment.duration(timeDiffMs + (24 * 60 * 60 * 1000), 'milliseconds').asMinutes();
        } else {
          calculatedServiceTime = moment.duration(timeDiffMs, 'milliseconds').asMinutes();
        }

        arrival = moment(event.start_time, ESTIMATED_TIME_FORMAT).format('HH:mm');
        departure = moment(event.end_time, ESTIMATED_TIME_FORMAT).format('HH:mm');
      }

      return {
        serviceTime: calculatedServiceTime,
        lat: event.latitude,
        lon: event.longitude,
        arrival: arrival,
        departure: departure
      };
    }

    function _getVisits(planRoutes) {
      var visitsArray = [];

      if (planRoutes) {
        planRoutes.forEach(function (route) {
          visitsArray.push(route.visits);
        });
      }

      return [].concat.apply([], visitsArray);
    }

    function didTheVisitChange(visit, originalVisits) {
      var originalVisit = originalVisits[visit.id];
      if (!originalVisit) {
        return false;
      }

      var isSellerIdChanged = false;
      if (originalVisit.seller_id && visit.seller_id) {
        isSellerIdChanged = originalVisit.seller_id !== visit.seller_id;
      } else {
        isSellerIdChanged = Boolean(originalVisit.seller_id) || Boolean(visit.seller_id);
      }

      return (originalVisit.route !== visit.routeId) || (originalVisit.order !== visit.order) ||
        (originalVisit.estimated_time_arrival !== moment(visit.estimatedTimeArrival).format(ESTIMATED_TIME_FORMAT)) ||
        (originalVisit.estimated_time_departure !== moment(visit.estimatedTimeDeparture).format(ESTIMATED_TIME_FORMAT)) ||
        isSellerIdChanged;
    }

    /**
     * Fill routesToDelete array if the route
     */
    function getUnusedRoutes() {
      if (originalPlan && originalPlan.routes) {
        originalPlan.routes.forEach(function (originalRoute) {
          var route = routes.find(function (route) {
            return route.id === originalRoute.id;
          });

          if (!route) {
            var exists = routesToDelete.find(function (routeToDelete) {
              return originalRoute.id === routeToDelete.id;
            });
            if (!exists) {
              routesToDelete.push(originalRoute);
            }
          }
        });

        var notToDelete = routesToDelete.filter(function (routeToDelete) {
          return routes.find(function (route) {
            return routeToDelete.id === route.id;
          }) !== undefined;
        });

        // filter all routes in noToDelete array from routesToDelete
        routesToDelete = routesToDelete.filter(function (routeToDelete) {
          return notToDelete.indexOf(routeToDelete) === -1;
        });

      } else {
        routesToDelete = [];
      }
      return routesToDelete;
    }

    function getRouteRequestStatus(originalRoute, currentRoute) {
      if (!originalRoute) {
        return REQUEST_STATUS.CREATED;
      }
      var isRouteUpdated = routeComparatorService.isRouteUpdated(originalRoute, currentRoute);
      return isRouteUpdated ? REQUEST_STATUS.EDITED : REQUEST_STATUS.NOT_EDITED;
    }

    function getUnusedVisits(originalVisits, actualVisits) {
      originalVisits.forEach(function (originalVisit) {
        var usedVisit = actualVisits.find(function (actualVisit) {
          return parseInt(actualVisit.id) === parseInt(originalVisit.id);
        });

        if (!usedVisit) {
          putVisitsToDelete(originalVisit);
        }
      });
    }

    function shouldTheRouteBeInserted(visitDataLength, requestStatus) {
      return !(visitDataLength === 0 &&
        (requestStatus === REQUEST_STATUS.CREATED || requestStatus === REQUEST_STATUS.NOT_EDITED));
    }

    function getOriginalRoute(originalPlan, route) {
      var originalRoutes = originalPlan.routes || [];
      return originalRoutes.find(function (originalRoute) {
        return originalRoute.id === route.id;
      });
    }

    function getRoutesToCreateRequest() {
      var routesRequestData = [];
      var saveVisitZoneId = utilsService.isAddonPropertyEnabled(pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.SAVE_VISIT_ZONE_ID]);

      getUnusedRoutes();
      getUnusedVisits(
        Object.values(originalVisits),
        _getVisits(routes)
      );

      routes.forEach(function (route) {
        var visitsRequestData = [];
        var finalTotalTime = route.totalTimeFormatted ? route.totalTimeFormatted : route.totalTime;
        var splitTimeFirst = finalTotalTime.split(' ');
        var totalTimeForSave = (splitTimeFirst.length > 1)
          ? (splitTimeFirst[1].split(':').length >= 3) ? finalTotalTime : finalTotalTime + ":00"
          : totalTimeForSave = (splitTimeFirst[0].split(':').length >= 3) ? finalTotalTime : finalTotalTime + ":00";

        route.visits.forEach(function (visit) {
          if (visit.request_status !== REQUEST_STATUS.CREATED && didTheVisitChange(visit, originalVisits)) {
            visit.request_status = REQUEST_STATUS.EDITED;
          }
          if (visit.request_status) {
            visitsRequestData.push(getVisitDataForRequest(visit, saveVisitZoneId));
          }
        });
        visitsToDelete.forEach(function (visit) {
          visit.routeId = visit.route ? visit.route : visit.routeId;
          if (visit.request_status !== REQUEST_STATUS.CREATED && route.id === visit.routeId) {
            visit.request_status = REQUEST_STATUS.DELETED;
            visit.getCPriority = function () {
            };
            visit.getPriority = function () {
            };
            if (!visit.integration && visit.id) {
              visitsRequestData.push({
                id: visit.id,
                request_status: REQUEST_STATUS.DELETED,
              });
            }
          }
        });

        var originalRoute = getOriginalRoute(originalPlan, route);
        route.request_status = getRouteRequestStatus(originalRoute, route);

        if (shouldTheRouteBeInserted(visitsRequestData.length, route.request_status)) {
          if (route.request_status === REQUEST_STATUS.NOT_EDITED) {
            routesRequestData.push({
              id: route.backendId,
              visits: visitsRequestData,
              planned_date: route.plannedDate || timeUtils.formatTime(planDate.start, 'YYYY-MM-DD'),
              request_status: REQUEST_STATUS.NOT_EDITED,
            });
          }

          else if (route.request_status === REQUEST_STATUS.CREATED) {
            routesRequestData.push(createDataRouteObject(route, totalTimeForSave, visitsRequestData));
          }
          else {
            if (colorAssignerService.areColorsEnabled()) {
              route.properties = {
                color: colorAssignerService.getVehicleColor(Number(route.vehicleId))
              };
            }
            var routeDataToRequest = comparatorService.getObjectDifferences(
              originalRoute || {},
              createDataRouteObject(route, totalTimeForSave, visitsRequestData),
              ["id", "planned_date"],
              comparatorService.validateRouteFields
            );
            routesRequestData.push(routeDataToRequest);
          }
        }
      });
      if (routesToDelete.length) {
        routesToDelete.forEach(function (route) {
          var visitsRequestData = [];

          visitsToDelete.forEach(function (visit) {
            if (visit.request_status !== REQUEST_STATUS.CREATED && route.id === visit.routeId) {
              visit.request_status = REQUEST_STATUS.DELETED;
              visit.getCPriority = function () {
              };
              visit.getPriority = function () {
              };
              if (!visit.integration && visit.id) {
                visitsRequestData.push({
                  id: visit.id,
                  request_status: REQUEST_STATUS.DELETED,
                });
              }
            }
          });
          routesRequestData.push({
            id: route.id,
            request_status: REQUEST_STATUS.DELETED,
            visits: visitsRequestData
          });
        });
      }
      return routesRequestData;
    }

    function getVisitDataForRequest(visit, saveVisitZoneId) {
      var originalVisit = originalVisits[visit.id] || {};
      var visitData = createDataVisitObject(visit, saveVisitZoneId);
      if (visit.request_status === REQUEST_STATUS.EDITED) {
        visitData = comparatorService.getObjectDifferences(
          originalVisit, visitData, ["id", "title", "seller_id"], comparatorService.validateVisitFields);
      }

      var itemsDataForRequest = visitItemsService.getItemsDataForRequest(originalVisit, visit);
      if (itemsDataForRequest.length) {
        visitData.items = itemsDataForRequest;
      }

      if (visit.request_status === REQUEST_STATUS.EDITED) {
        visitData.request_status = visit.isReused ? REQUEST_STATUS.REUSED : REQUEST_STATUS.EDITED;
      }

      return visitData;
    }

    function getPriorityLevels() {
      if (priorityLevels.length === 0) {
        priorityLevels = PRIORITY_LEVELS.map(function (priorityLevel) {
          return {
            'name': $filter('translate')('Visits.priority_levels.' + priorityLevel.label_name),
            'value': priorityLevel.value
          };
        });
      }
      return priorityLevels;
    }

    function clearDraftPlanData(planId) {
      // Clear currently open plan if nothing else is specified.
      var planIdToClear = planId || getPlanId();
      saveDraftPlanService.deleteDraftPlan(planIdToClear);
    }

    function loadWithSaveDraftPlan(cacheGetter, realGetter) {
      if (!saveDraftPlanService.hasDraftPlan()) {
        return realGetter();
      }

      var deferred = $q.defer();
      var response = {
        data: cacheGetter()
      };

      deferred.resolve(response);
      return deferred.promise;
    }

    function loadPlanDetail(planId) {
      return saveDraftPlanService.loadDraftPlan(planId)
        .then(function () {
          return loadWithSaveDraftPlan(saveDraftPlanService.getPlanDetail, function () {
            return $http.get(PLAN_PATH + planId + '/');
          });
        });
    }

    function addOriginalVisit(visit) {
      originalVisits[visit.id] = visit;
    }

    function loadRoutesDetail(plan) {
      return loadWithSaveDraftPlan(saveDraftPlanService.getRoutesDetail, function () {
        return $http.get(ROUTES_PATH, {params: {plan: plan.id}});
      });
    }

    function loadVisitDetail(route) {
      var queryParams = {
        route: route.id,
        extended_data: EXTENDED_DATA
      };
      return loadWithSaveDraftPlan(
        function () {
          return saveDraftPlanService.getVisitsDetail(route.id);
        },
        function () {
          return requestService.httpGetPaginated(VISITS_PATH_PAGINATING, {
            params: queryParams
          });
        }
      );
    }

    function loadEventsDetail(planId) {
      return loadWithSaveDraftPlan(saveDraftPlanService.getEventsDetail, function () {
        return $http.get(PLAN_EVENT_PATH,{ params: { plan: planId } });
      });
    }

    function getPlanEditingSelected() {
      return planEditingSelected;
    }

    function setUserVisualState(states) {
      userState = states;
    }

    function getUserVisualState() {
      return userState;
    }

    function setBackupRoute(route) {
      backupRoutes[route.id] = route;
    }

    function setBackupRoutes(value) {
      backupRoutes = value;
    }

    function setBackupVehicles(value) {
      backupVehicles = value;
    }

    function setBackupVisits(value) {
      backupVisits = value;
    }

    function setBackupData(backupRoutes, backupVehicles, backupVisits) {
      service.setBackupRoutes(backupRoutes);
      service.setBackupVehicles(backupVehicles);
      service.setBackupVisits(backupVisits);
    }

    function isVisitRouteRevised(visit) {
      if (!visit.routeId) {
        return false;
      }
      var route = service.getRouteById(visit.routeId);
      return revisedRoutesService.isRouteRevised(route);
    }

    function setMultipleVisitsSelected(polygon) {
      var visitsWithinPolygon = visits.filter(function (visit) {
        return visit.isVisible() && !service.isVisitRouteRevised(visit) &&
          polygon.contains(googleService.getGoogleMapsLatLng(visit.latitude, visit.longitude));
      });

      visitsWithinPolygon.forEach(function(visit) {
        visit.setSelected(true);
        $rootScope.$broadcast('Planner:Visit:toggleSelectedEditVisit', {visit: visit, multipleSelectionMode: true});
      });

      if (visitsWithinPolygon.length > 0) {
        $rootScope.$broadcast("Planner:Visit:setIsPolygonCreated", {isPolygonCreated: true});
      }
    }

    function deselectVisitsSelected() {
      visits.map(function (visit) {
        if (visit.selected) {
          visit.selected = false;
          $rootScope.$broadcast('Planner:Visit:toggleSelectedEditVisit', {visit: visit, multipleSelectionMode: true});
        }
      });
    }

    function setDrivers(data) {
      drivers = data;
    }

    function updateListDriver(driver) {
      var driverObj = {
        id: driver.id.toString(),
        name: driver.name,
        username: driver.username,
        selected: false,
        group: $filter("translate")("Driver.group_available")
      };
      var index = lodash.findIndex(drivers, function (obj) {
        return obj.id === driverObj.id;
      });

      if (index === -1) {
        drivers.push(driverObj);
      } else {
        lodash.merge(drivers[index], driverObj);
      }
    }

    function getBackupRoutes() {
      return backupRoutes;
    }

    function getBackupVehicles() {
      return backupVehicles;
    }

    function getBackupVisits() {
      return backupVisits;
    }

    function setSelectedFleet(fleet) {
      selectedFleet = fleet;
    }

    function getSelectedFleet() {
      return selectedFleet;
    }

    function updateVehicles(vehiclesIds) {
      return $http.get(VEHICLES_PATH)
        .then(function (response) {
          response.data.forEach(function (vehicle) {
            var exists = Boolean(
              vehiclesIds.find(function (vehicleId) {
                return vehicleId.toString() === vehicle.id.toString();
              })
            );

            if (!exists) {
              return;
            }

            if (vehicle.rest_time_end) {
              vehicle.rest_time_end = vehicle.rest_time_end.split(':');
              vehicle.rest_time_end = vehicle.rest_time_end[0] + ':' + vehicle.rest_time_end[1];
            }

            if (vehicle.rest_time_start) {
              vehicle.rest_time_start = vehicle.rest_time_start.split(':');
              vehicle.rest_time_start = vehicle.rest_time_start[0] + ':' + vehicle.rest_time_start[1];
            }

            if (vehicle.shift_start) {
              vehicle.shift_start = vehicle.shift_start.split(':');
              vehicle.shift_start = vehicle.shift_start[0] + ':' + vehicle.shift_start[1];
            }

            if (vehicle.shift_end) {
              vehicle.shift_end = vehicle.shift_end.split(':');
              vehicle.shift_end = vehicle.shift_end[0] + ':' + vehicle.shift_end[1];
            }

            var vehicleModel = PlannerVehicleModel.fromJson(vehicle);
            if (vehicle.default_driver) {
              // Searching for driver
              for (var i = 0; i < drivers.length; i++) {
                if (drivers[i].id === vehicle.default_driver.toString()) {
                  vehicleModel.driver = drivers[i];
                }
              }
            }

            if (vehicleModel.shift && !vehicleModel.shift.start) {
              vehicleModel.shift.start = shift.start;
            }

            if (vehicleModel.shift && !vehicleModel.shift.end) {
              vehicleModel.shift.end = shift.end;
            }

            if (vehicleModel.locationStart && vehicleModel.locationStart.latitude === 0) {
              vehicleModel.active = false;
            }

            var localIndex = service.vehicles.findIndex(function (sVehicle) {
              return sVehicle.id.toString() === vehicleModel.id.toString();
            });

            if (localIndex !== -1) {
              var mergedVehicle = {};
              lodash.merge(mergedVehicle, service.vehicles[localIndex], vehicleModel);
              service.vehicles[localIndex] = mergedVehicle;
            } else {
              service.vehicles.push(vehicleModel);
              colorAssignerService.setDefaultVehicleColorCache(
                vehicleModel.id, vehicle.color
              );
            }
          });
        });
    }

    function getRouteName(route) {
      var visits = route.visits;

      if (!visits || !visits.length) {
        return null;
      }
      var mostRepeatedName = {frequency: 0, label: ""};

      visits.reduce(function (types, visit) {
        var visitType = getLabelFromVisitType(visit.visitType) || null;
        if (!visitType) {
          return types;
        }

        types[visitType] = types[visitType] ? ++types[visitType] : 1;
        if (mostRepeatedName.frequency < types[visitType]) {
          mostRepeatedName.frequency = types[visitType];
          mostRepeatedName.label = visitType;
        } else if (mostRepeatedName.frequency === types[visitType]
          && textUtilsService.isBeforeThat(visitType, mostRepeatedName.label)
        ) {
          mostRepeatedName.label = visitType;
        }

        return types;
      }, {});

      return mostRepeatedName.frequency ? mostRepeatedName.label : null;
    }

    function getVehicleRoutes(vehicleId) {
      var vehicle = service.vehicles.find(function(vehicle) {
        return vehicle.id === vehicleId;
      });
      return (vehicle && vehicle.routes) ? vehicle.routes : [];
    }

    function getRouteIndex(vehicleRoutes, routeId) {
      var route = vehicleRoutes.find(function(route) {
        return route.id === routeId;
      });
      return angular.isDefined(route) ? vehicleRoutes.indexOf(route) + 1 : null;
    }

    function getVisitTypes() {
      if (visitTypes) {
        return visitTypes;
      }
      visitTypeService.getVisitTypes().then(function (vt) {
        visitTypes = vt;
      });
      return visitTypes;
    }

    function getLabelFromVisitType(key) {
      if (!key) {
        return null;
      }
      return visitTypes.find(function (visitType) {
        return visitType.key === key;
      }).label;
    }

    function getAllOptimizationIds() {
      return optimizationIds;
    }

    function addOptimizationId(optimizationId) {
      if (!optimizationIds.includes(optimizationId)) {
        optimizationIds.push(optimizationId);
      }
    }

    function getAllRestTime() {
      return Object.values(restTimesDict);
    }

    function getRestTimeByRouteId(routeId) {
      return restTimesDict[routeId];
    }

    function setRestTimeByRouteId(routeId, restTime) {
      var route = getRouteById(routeId);
      restTimesDict[routeId] = {
        arrival: restTime.arrival,
        departure: restTime.departure,
        lat: restTime.lat,
        lon: restTime.lon,
        serviceTime: restTime.serviceTime,
        order: restTime.order,
        type: VISIT_TYPE.EVENT,
        sourceRouteId: routeId,
        startTime: restTime.startTime || null,
        endTime: restTime.endTime || null,
        hasError: restTime.hasError || false
      };
      if (route) {
        route.events = restTimeToEvent(restTimesDict[routeId]);
      }
    }

    function clearRestTimes(routeId) {
      if (!routeId) {
        restTimesDict = {};
      }

      delete restTimesDict[routeId];
    }

    function getTotalArrivalsCached(visits, key) {
      var joinSimilar = service.visitSimilarGraph && (localOptimizationOptions.join || localOptimizationOptions.join_v2);
      if (!joinSimilar) {
        return visits;
      }

      var visitsLength = visits.length;
      if (totalArrivalsCache[key] && totalArrivalsCache[key].totalVisits === visitsLength) {
        return totalArrivalsCache[key].arrivals;
      }

      var arrivals = service.visitSimilarGraph.groupConsecutiveSimilarVisits(visits);
      totalArrivalsCache[key] = {
        arrivals: arrivals,
        totalVisits: visitsLength
      };

      return arrivals;
    }

    function clearTotalArrivalsCached() {
      totalArrivalsCache = {};
    }

    function clearTotalArrivalsCachedByRoute(routeId) {
      delete totalArrivalsCache[routeId];
    }

    function eventsToResetData() {
      $rootScope.$broadcast("Planner:Plan:reset-statistics");
    }

    function _getPlanMetadata(optimizations, defaultRoutingOptions, isIncrementalRoutingOptimize) {
      var routingOptions = {};
      for (var key in defaultRoutingOptions) {
        routingOptions[key] = optimizations[key];
      }
      var enableRadialRouting = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_RADIAL_ROUTING);
      if (enableRadialRouting) {
        routingOptions.radial_routing = optimizations.radial_routing;
      }
      if (isIncrementalRoutingOptimize === true) {
        routingOptions.incremental_routing = isIncrementalRoutingOptimize;
      }

      var vehicleType = vehicleTypeUtils.getVehicleType(optimizations);

      if (utilsService.isAddonPropertyEnabled(pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_PRIORITIZE_LOAD])) {
        routingOptions.prioritize_load = optimizations.prioritize_load;
      }

      return {
        "routing_options": routingOptions,
        "vehicle_type": vehicleType.toUpperCase(),
        "wave_routing": optimizations.wave_routing,
        "last_optimization_id": currentOptimizationId
      };
    }

    function _getOptimizations(planMetadata, optimizations, duplicatePlan) {
      var routingOptions = planMetadata ? angular.merge({}, planMetadata.routing_options) : {};

      if (!routingOptions.hasOwnProperty(ON_FOOT_ROUTING_OPTION) && optimizations.vehicle_type) {
        routingOptions.on_foot = false;
      }
      if (!routingOptions.hasOwnProperty(WAVE_ROUTING_OPTION) &&
        optimizations.wave_routing) {
        routingOptions.wave_routing = false;
      }

      // If I'm not duplicating the plan, then I'm loading it
      if (!duplicatePlan) {
        _updateOptimizations(routingOptions);
      }

      return angular.merge({}, optimizations, routingOptions);
    }

    function getSelectedOptimizations(localOptimizations, routingOptions) {
      var optimizations = routingOptions || defaultRoutingOptions;
      var selectedOptimizations = [];

      Object.keys(optimizations).forEach(function (optimization) {
        if (optimization === ALL_VEHICLES_ROUTING_OPTION && !localOptimizations[optimization]) {
          selectedOptimizations.push(MINIMIZE_VEHICLES_ROUTING_OPTION);
        }

        if (optimization !== ALL_VEHICLES_ROUTING_OPTION && localOptimizations[optimization]) {
          selectedOptimizations.push(optimization);
        }
      });

      return selectedOptimizations.sort();
    }

    function getRouteOnMapCache(route) {
      var key = [route.vehicleId, route.id].join("-");
      var routeOnMapCache = routesOnMapCache[key];

      if (routeOnMapCache && !routeOnMapCache.map) {
        routeOnMapCache.setMap(getGmap());
      }

      return routeOnMapCache;
    }



    function setRouteOnMapCache(route, routeOnMap) {
      // routeOnMap could be a polyline or a cluster
      var key = [route.vehicleId, route.id].join("-");
      routesOnMapCache[key] = routeOnMap;
    }

    function clearRoutesOnMapCache() {
      routesOnMapCache = {};
    }

    function SaveDraftPlanSource() {
      return {
        isNewPlan: isNewPlan,
        getOriginalPlan: getOriginalPlan,
        getOriginalVisits: getOriginalVisits,
        getLocalOptimizationOptions: getlocalOptimizationOptions,
        getShift: getShift,
        getPlanDate: getPlanDate,
        getPlanInfo: getPlanInfo,
        getFleetId: getFleetId,
        getRoutes: getRoutes,
        getVisits: getVisits,
        getPlanId: function () {
          var planId = getPlanId();
          if (!planId) {
            planId = newPlanId;
          }

          return planId;
        },
        getPlanMetadata: function () {

          if (planId) {
            return _getPlanMetadata(localOptimizationOptions, defaultRoutingOptions);
          }

          return null;
        },
        getEvents: function () {
          return Object.keys(restTimesDict).map(function (routeId) {
            var event = restTimeToEvent(restTimesDict[routeId])[0];
            event.route = routeId;
            return event;
          });
        },
        getVehicles: getActiveVehicles,
        getOptimizationResults: getOptimizationResults
      };
    }

    function saveDraftPlan() {
      var planDataSource = new SaveDraftPlanSource();
      return saveDraftPlanService.saveDraftPlan(planDataSource);
    }

    function setOriginalPlanAndSaveDraftPlanFormat(planDraftId, expirationMinutes) {
      var planDataSource = new SaveDraftPlanSource();
      return saveDraftPlanService.setOriginalPlanAndSaveDraftPlanFormat(planDataSource, planDraftId, expirationMinutes)
        .then(function () {
          // Keep track of the autosaved plan id, so we can continue saving onto the same one.
          // This will only be relevant for new plans.
          planId = planDataSource.getPlanId();
        });
    }

    function getVehicleShiftTime(vehicle) {
      var startDate = timeUtils.createTime(planDate.start).format("YYYY-MM-DD");
      var endDate = timeUtils.createTime(planDate.end).format("YYYY-MM-DD");
      return {
        start: startDate + " " + vehicle.shift.start,
        end: endDate + " " + vehicle.shift.end
      };
    }

    function _shiftCrossesMidnight(shiftStart, shiftEnd) {
      if (!shiftStart || !shiftEnd) return false;
      var startMinutes = moment(shiftStart, 'HH:mm').hours() * 60 + moment(shiftStart, 'HH:mm').minutes();
      var endMinutes   = moment(shiftEnd, 'HH:mm').hours() * 60 + moment(shiftEnd, 'HH:mm').minutes();
      return startMinutes > endMinutes;
    }

    function _getVehicleShiftStartWhenEditing(vehicleShiftDefault, firstRouteEstimatedTimeStart) {
      var defaultStart = (vehicleShiftDefault && vehicleShiftDefault.start) || shift.start;
      var defaultEnd   = (vehicleShiftDefault && vehicleShiftDefault.end)   || shift.end;

      // Same-day shift: keep existing behavior (use the route's actual start time).
      if (!_shiftCrossesMidnight(defaultStart, defaultEnd)) {
        return firstRouteEstimatedTimeStart;
      }

      // Midnight-crossing shift: the optimizer returns routes ordered by wall-clock, so
      // routes[0] may be a post-midnight route (e.g. 03:10) rather than the shift's first
      // route (e.g. 22:02). If the "first" route's wall-clock start is earlier than the
      // shift default start, it's actually a next-day route — fall back to the default.
      var defaultStartMinutes = moment(defaultStart, 'HH:mm').hours() * 60 + moment(defaultStart, 'HH:mm').minutes();
      var routeStartMinutes   = moment(firstRouteEstimatedTimeStart, 'HH:mm').hours() * 60 + moment(firstRouteEstimatedTimeStart, 'HH:mm').minutes();
      return routeStartMinutes < defaultStartMinutes ? defaultStart : firstRouteEstimatedTimeStart;
    }

    function _getVehicleShiftEndWhenEditing(vehicleShiftDefaultEnd, lastRouteEstimatedTimeEnd) {
      var shiftEnd = vehicleShiftDefaultEnd || shift.end;
      return moment(shiftEnd, 'HH:mm').isAfter(moment(lastRouteEstimatedTimeEnd, 'HH:mm'))
        ? shiftEnd
        : lastRouteEstimatedTimeEnd;
    }

    function setVehiclesShiftTime(vehicles, isDraftPlan) {
      vehicles.forEach(function (vehicle) {
        var vehicleRoutesLength = vehicle.routes.length;
        if (vehicleRoutesLength > 0) {
          if (!isDraftPlan) {
            vehicle.shift.start = _getVehicleShiftStartWhenEditing(vehicle.shiftDefault, vehicle.routes[0].estimatedTimeStart);
            vehicle.shift.end = _getVehicleShiftEndWhenEditing(vehicle.shiftDefault.end, vehicle.routes[vehicleRoutesLength - 1].estimatedTimeEnd);
          }
        } else {
          vehicle.shift.start = vehicle.shiftDefault.start || shift.start;
          vehicle.shift.end = vehicle.shiftDefault.end || shift.end;
        }

        var hasRestTimeEvent = vehicle.routes.some(function (route) {
          return route.events && route.events.some(function (event) {
            return event.type === 'rest_time';
          });
        });

        if (hasRestTimeEvent && vehicle.restTimeStartDefault && vehicle.restTimeEndDefault && vehicle.restTimeDurationDefault) {
          vehicle.restTimeStart = vehicle.restTimeStartDefault;
          vehicle.restTimeEnd = vehicle.restTimeEndDefault;
          vehicle.restTimeDuration = vehicle.restTimeDurationDefault;
        }
      });
    }

    function setWaveRoutingData(data) {
      waveRoutingData = data;
    }

    function getWaveRoutingData() {
      return waveRoutingData;
    }

    function setCurrentOptimizationId(id) {
      currentOptimizationId = id;
    }

    function getCurrentOptimizationId() {
      return currentOptimizationId;
    }

    function setLastOptimizationId(id) {
      lastOptimizationId = id;
    }

    function getLastOptimizationId() {
      return lastOptimizationId;
    }

    function getSelectedVisits(){
      return  visits.filter(function (visit) {
        return visit.selected;
      });
    }

    function getCheckedVisits(){
      return visits.filter(function (visit) {
        return visit.checked;
      });
    }

    function setShouldClearVisitSelectionsOnReturn (value) {
      shouldClearVisitSelectionsOnReturn = value;
    }

    function getShouldClearVisitSelectionsOnReturn() {
      return shouldClearVisitSelectionsOnReturn;
    }

    /**
     * Adjusts the optimizator's node relating to a Rest Time event, considering
     * the actual vehicle's rest time window and duration.
     *
     * The optimizator sometimes returns start and end times for nodes that are
     * larger than the actual window and service time; to properly handle this,
     * VTC needs to know the actual duration and start time.
     *
     * Actual arrival is max(vehicle.restTimeStart, node.arrival).
     * Actual departure is what the optimizator returns in node.departure.
     * Actual duration is the difference in minutes between actual arrival and actual departure.
     *
     * Supports extended hour format (hours >= 24) for multi-day plans only when
     * longRoutes (multi-day) and skip_time_validation are both enabled.
     *
     * @param {*} node the original node as returned by the optimizator
     * @param {*} vehicle the vehicle model instance the node is for
     * @returns {object} A node representing the rest time event with correct arrival, departure and duration.
     */
    function parseOptimizationRestTimeNode(node, vehicle) {
      var nodeArrival = node.arrival;
      var vehicleRestStart = vehicle.restTimeStart || '00:00';
      var actualDeparture = node.departure;

      var actualArrival;
      var serviceTime;

      // Use extended time format only when longRoutes (multi-day) and skip_time_validation are both enabled
      if (isLongRoutesEnabled() && getSkipTimeValidation()) {
        // Check if we're dealing with extended time format (hours >= 24)
        var isExtendedFormat = timeUtils.isExtendedTimeFormat(nodeArrival) ||
                               timeUtils.isExtendedTimeFormat(actualDeparture) ||
                               timeUtils.isExtendedTimeFormat(vehicleRestStart);

        if (isExtendedFormat) {
          // Use extended time comparison for multi-day plans
          var nodeArrivalMinutes = timeUtils.parseExtendedTimeToMinutes(nodeArrival);
          var vehicleRestStartMinutes = timeUtils.parseExtendedTimeToMinutes(vehicleRestStart);

          // actualArrival is max(node.arrival, vehicle.restTimeStart)
          var actualArrivalMinutes = Math.max(nodeArrivalMinutes, vehicleRestStartMinutes);
          actualArrival = timeUtils.formatMinutesToExtendedTime(actualArrivalMinutes);

          // Calculate service time using extended time minutes
          var departureMinutes = timeUtils.parseExtendedTimeToMinutes(actualDeparture);
          actualDeparture = timeUtils.formatMinutesToExtendedTime(departureMinutes);
          serviceTime = departureMinutes - actualArrivalMinutes;
        } else {
          // Standard moment-based calculation for non-extended times
          var momentArrival = moment.max(
            moment(nodeArrival, 'HH:mm'),
            moment(vehicleRestStart, 'HH:mm')
          );
          var momentDeparture = moment(actualDeparture, 'HH:mm');

          actualArrival = momentArrival.format('HH:mm');
          actualDeparture = momentDeparture.format('HH:mm');
          serviceTime = moment.duration(momentDeparture - momentArrival, 'milliseconds').asMinutes();
        }
      } else {
        // Standard moment-based calculation for non-extended times
        var momentArrival = moment.max(
          moment(nodeArrival, 'HH:mm'),
          moment(vehicleRestStart, 'HH:mm')
        );
        var momentDeparture = moment(actualDeparture, 'HH:mm');

        actualArrival = momentArrival.format('HH:mm');
        actualDeparture = momentDeparture.format('HH:mm');
        serviceTime = moment.duration(momentDeparture - momentArrival, 'milliseconds').asMinutes();
      }

      var result = Object.assign({}, node, {
        arrival: actualArrival,
        departure: actualDeparture,
        serviceTime: serviceTime,
        order: null,
        startTime: vehicle.restTimeStart,
        endTime: vehicle.restTimeEnd
      });
      return result;
    }

    function removeDriver(driverId) {
      for (var i = 0; i < drivers.length; i++) {
        if (drivers[i].id === driverId) {
          drivers.splice(i, 1);
          break;
        }
      }

      vehicles.forEach(function (vehicle) {
        if (vehicle.driverId === driverId) {
          vehicle.driver = null;
          vehicle.driverId = null;
        }
      });
    }

    function removeCodriver(codriverId) {
      var codriverIndex = codrivers.findIndex(function (codriver) {
        return codriver.id === codriverId;
      });

      if (codriverIndex > -1) {
        codrivers.splice(codriverIndex, 1);
      }

      vehicles.forEach(function (vehicle) {
        var vehicleCodriverIndex = vehicle.codrivers.findIndex(function (codriver) {
          return codriver.id === Number(codriverId);
        });

        if (vehicleCodriverIndex > -1) {
          vehicle.codrivers.splice(vehicleCodriverIndex, 1);
        }
      });
    }

    function getVisitsPickupAndDeliveryRelationship() {
      return visitsPickupAndDeliveryRelationship;
    }

    function getVisitRelationships(visit) {
      if (visitsPickupAndDeliveryRelationship[visit.id]) {
        return visitsPickupAndDeliveryRelationship[visit.id].picks_from;
      }

      var deliveryRelationship = Object.keys(visitsPickupAndDeliveryRelationship).find(function (key) {
        return visitsPickupAndDeliveryRelationship[key].picks_from.find(function (pick) {
          return pick.id === visit.id;
        });
      });

      if (deliveryRelationship !== DEPOT_KEY) {
        return [getVisit(deliveryRelationship)];
      }
      return [];
    }

    function removeVisitPickupAndDeliveryRelationship(visit) {
      visitsPickupAndDeliveryRelationship = visitsRelationshipService.removeVisitPickupAndDeliveryRelationship(visitsPickupAndDeliveryRelationship, visit);
    }

    /**
     * This function check if we have relationships visits with pickup&delivery
     * @returns {boolean}
     */
    function isTherePickupAndDelivery () {
      // visitsPickupAndDeliveryRelationship always it's gonna have one key
      // that is DEPOT
      return Object.keys(visitsPickupAndDeliveryRelationship).length > 1;
    }

    function loadVisitsPickupAndDeliveryRelationship () {
      var visitsBackendIds = [];
      visits.forEach(function (visit) {
        if (visit.backendId) {
          visitsBackendIds.push(visit.id);
        }
      });
      return visitService.retrieveVisitsRelationship(visitsBackendIds).then(function (response) {
        visitsPickupAndDeliveryRelationship = visitsRelationshipService.buildVisitsPickupAndDeliveryObject(
          response, visits
        );
      });
    }

    function mustShowVisitWindows(windowStart, windowEnd) {
      if (windowStart === START_TIME_WINDOW && windowEnd === END_TIME_WINDOW) {
        return false;
      }
      if (windowStart === END_TIME_WINDOW && windowEnd === END_TIME_WINDOW) {
        return false;
      }
      return timeUtils.isAValidTimeFormat(windowStart) && timeUtils.isAValidTimeFormat(windowEnd);
    }

    /**
     * Retrieves the weekday name(s) for a scheduled plan's date.
     * Returns an empty array if multi-day routes are enabled.
     *
     * @returns {Array} Array with the full weekday name(s) or empty.
     */
    function getScheduledPlanDaysOfWeek(planStartDate) {
      var isMultidayRouteEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.MULTI_DAY_ROUTES);

      // Note: Currently, the returned array may be empty or have a single day. Once multi-day routes are
      // implemented, the array will contain multiple days, making it more meaningful.
      if (isMultidayRouteEnabled) {
        return [];
      }

      // Clone planDate.start as a Moment.js object with English locale, without affecting the original.
      var startDate = moment(planStartDate || planDate.start).clone().locale('en');
      // 'dddd' represents the full weekday name extracted from the date in 'plan.start_date'.
      var dayOfWeek = timeUtils.formatTime(startDate, 'dddd');
      return [dayOfWeek];
    }

    function isStepOneActive() {
      return $state.includes(STATE.VEHICLES_LIST) || $state.includes(STATE.VEHICLES_DETAIL);
    }

    function isStepThreeActive() {
      return $state.includes(STATE.ROUTES) || $state.includes(STATE.ROUTES_DETAIL);
    }

    function loadRouteProperties(routeIds) {
      var batchesRouteIds = lodash.chunk(routeIds, ROUTE_PROPERTIES_MAX_BATCH_SIZE);
      var promises = batchesRouteIds.map(function(batchRouteIds) {
        return $http.post(ROUTE_PROPERTIES_BULK_SEARCH_PATH, {
          route_ids: batchRouteIds
        });
      });

      return $q.all(promises)
        .then(function(responses) {
          var routeProperties = responses.reduce(function(accumulator, response) {
            return accumulator.concat(response.data);
          }, []);

          return {
            data: routeProperties
          };
        });
    }

    function getPlanStartTime() {
      var startTime = moment.tz(planDate.start + ' ' + shift.start, 'YYYY-MM-DD HH:mm', timeUtils.getAccountTimezone());
      return startTime.format('YYYY-MM-DDTHH:mm:ssZ');
    }

    function calculateLoadDifferences(visit, bulkVisitData) {
      var isMixLoadEnabled = utilsService.isAddonPropertyEnabled(
        pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD]
      );
      return {
        load: bulkVisitData.load ? Number(bulkVisitData.load) - Number(visit.load) : 0,
        load2: bulkVisitData.load2 ? Number(bulkVisitData.load2) - Number(visit.load2) : 0,
        load3: bulkVisitData.load3 ? Number(bulkVisitData.load3) - Number(visit.load3) : 0,
        load4: isMixLoadEnabled && bulkVisitData.load4 ? Number(bulkVisitData.load4) - Number(visit.load4) : 0,
      };
    }

    function getDriverName(driverId) {
      if (!driverId) {
        return '';
      }

      var foundDriver = drivers.find(function (driver) {
        return driver.id === driverId;
      });

      if (foundDriver) {
        return foundDriver.name;
      }
    }

    function setVehicleDriver(vehicle, route, selectedDriver, vehicles) {
      route.driver = selectedDriver;
      routesUtils.setVehicleDriver(vehicle, route, drivers);
      routesUtils.updateSelectedDrivers(vehicles, drivers);
    }

    function updateVehicleDriver(vehicle, selectedDriver, vehicles) {
      vehicle.driverId = selectedDriver;
      routesUtils.updateVehicleDriver(vehicle, drivers);
      routesUtils.updateSelectedDrivers(vehicles, drivers);
    }

    function setVehicularRestrictionEnabled(value) {
      vehicularRestrictionEnabled = value;
    }

    function isVehicularRestrictionEnabled() {
      return vehicularRestrictionEnabled;
    }

    function setCourierEnabled(value) {
      courierEnabled = value;
    }

    function isCourierEnabled() {
      return courierEnabled;
    }

    function setRestTimeEnabled(value) {
      restTimeEnabled = value;
    }

    function isRestTimeEnabled() {
      return restTimeEnabled;
    }

    function updateVehicleRouteVisitsAndEvents() {
      vehicles.forEach(function (vehicle) {
        vehicle.updateRouteVisitsAndEvents(service);
      });
    }

    function _loadPathFinderProperties() {
      return addonsService.getInfoAddonAndPropertiesByKey(PATH_FINDER_ADD_ON_KEY)
        .then(function (properties) {
          if (properties && properties.properties) {
            properties.properties.forEach(function (property) {
              pathFinderProperties[property.key] = property.value;
            });
          }
        })
        .catch(function () {
          pathFinderProperties= {};
        });
    }

    function getPathFinderProperties() {
      return pathFinderProperties;
    }

    /**
     * Gets skip time validation value from pathfinder properties
     * @returns {boolean} true if skip time validation is enabled
     */
    function getSkipTimeValidation() {
      var skipTimeValidationValue = pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.SKIP_TIME_VALIDATION];
      return skipTimeValidationValue && skipTimeValidationValue.toLowerCase() === 'true';
    }

    /**
     * Checks if longRoutes (multi-day) is enabled by comparing plan start and end dates
     * @returns {boolean} true if plan spans multiple days
     */
    function isLongRoutesEnabled() {
      if (!planDate.start || !planDate.end) {
        return false;
      }
      return !moment(planDate.start).isSame(moment(planDate.end), 'day');
    }

    function shouldValidateEditableRoutes() {
      return (
        accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_SAFETY_MODE) ||
        accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_ENHANCED_SAFETY_MODE)
      );
    }

    function isRouteEditable(routeId) {
      if (!routeId || !angular.isString(routeId)) {
        return true;
      }

      var enableSafetyMode = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_SAFETY_MODE);
      var enableEnhancedSafetyMode = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_ENHANCED_SAFETY_MODE);

      return (
        (!enableSafetyMode && !enableEnhancedSafetyMode) ||
        !startedRoutes.hasOwnProperty(routeId)
      );
    }

    function isRouteEditableToMoveVisits(routeId) {
      if (!routeId || !angular.isString(routeId)) {
        return true;
      }

      var enableEnhancedSafetyMode = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_ENHANCED_SAFETY_MODE);

      return (
        !enableEnhancedSafetyMode ||
        !startedRoutes.hasOwnProperty(routeId)
      );
    }

    /**
      * Converts time to extended hour format with day offset
      * @param {string} time - Time in HH:mm format
      * @param {number} dayOffset - Number of days to add (0, 1, 2, etc.)
      * @returns {string} Time in extended hour format (e.g., "00:30" with dayOffset 1 -> "24:30")
     */
    function convertToExtendedFormat(time, dayOffset) {
      var hours = time.split(":")[0];
      var minutes = time.split(":")[1];
      var extendedHours = parseInt(hours) + 24 * dayOffset;
      return extendedHours + ':' + minutes;
    }

    /**
    * Adjusts window times based on plan start and end dates
    * If the plan spans multiple days, adds 24 hours to window times when plan start time is after them
    *
    * @param {Object} params - Parameters object
    * @param {string} params.windowStart - Start time in HH:mm format
    * @param {string} params.windowEnd - End time in HH:mm format
    * @param {string} params.planStartDate - Plan start date in YYYY-MM-DD format
    * @param {string} params.planEndDate - Plan end date in YYYY-MM-DD format
    * @param {string} params.planStartTime - Plan start time in HH:mm format
    * @returns {Object} Object with windows array and allowExtendedHours flag
    */
    function adjustWindowTimesWithPlanDatesAndAcrossMidnight(params) {
      var windowStart = params.windowStart;
      var windowEnd = params.windowEnd;
      var planStartDate = params.planStartDate;
      var planEndDate = params.planEndDate;
      var planStartTime = params.planStartTime;

      if (
        !windowStart ||
        !windowEnd ||
        !planStartDate ||
        !planEndDate ||
        !planStartTime
      ) {
        return {
          windowStart: windowStart,
          windowEnd: windowEnd,
          allowExtendedHours: false,
        };
      }

      // Check if plan spans the same day
      if (
        moment(planStartDate, "YYYY-MM-DD").isSame(
          moment(planEndDate, "YYYY-MM-DD")
        )
      ) {
        // Same day plan - return single window with original times
        return {
          windows: [[windowStart, windowEnd]],
          allowExtendedHours: false,
        };
      }

      // Plan spans multiple days
      if (
        moment(planStartDate, "YYYY-MM-DD").isBefore(
          moment(planEndDate, "YYYY-MM-DD")
        )
      ) {
        var startDate = moment(planStartDate, "YYYY-MM-DD");
        var endDate = moment(planEndDate, "YYYY-MM-DD");
        var daysDifference = endDate.diff(startDate, "days");

        var windows = [];
        var allowExtendedHours = false;

        var maxWindows = daysDifference + 1;
        var currentWindowEnd = windowEnd;

        for (var dayOffset = 0; dayOffset < maxWindows; dayOffset++) {
          var adjustedWindowStart = windowStart;
          var adjustedWindowEnd = currentWindowEnd;

          if (dayOffset === 0) {
            if (
              moment(windowStart, "HH:mm").isAfter(moment(windowEnd, "HH:mm"))
            ) {
              adjustedWindowEnd = convertToExtendedFormat(windowEnd, 1);
              currentWindowEnd = adjustedWindowEnd;
              allowExtendedHours = true;
            } else {
              adjustedWindowStart = windowStart;

              adjustedWindowEnd = windowEnd;
              currentWindowEnd = adjustedWindowEnd;
              allowExtendedHours = true;
            }
          } else {
            // Subsequent days: always extend hours
            adjustedWindowStart = convertToExtendedFormat(
              windowStart,
              dayOffset
            );

            adjustedWindowEnd = convertToExtendedFormat(currentWindowEnd, 1);
            currentWindowEnd = adjustedWindowEnd;
            allowExtendedHours = true;
          }

          windows.push([adjustedWindowStart, adjustedWindowEnd]);
        }

        return {
          windows: windows,
          allowExtendedHours: allowExtendedHours,
        };
      }

      // Fallback - return single window
      return {
        windows: [[windowStart, windowEnd]],
        allowExtendedHours: false,
      };
    }

    /**
     * Single extended window for reorder /sync (isReorder), using vehicle shift to place
     * overnight and pre-shift segments without duplicating per plan day.
     *
     * @param {Object} params - Parameters object
     * @param {string} params.windowStart - Start time in HH:mm format
     * @param {string} params.windowEnd - End time in HH:mm format
     * @param {string} params.planStartDate - Plan start date in YYYY-MM-DD format
     * @param {string} params.planEndDate - Plan end date in YYYY-MM-DD format
     * @param {string} params.planStartTime - Plan start time in HH:mm format
     * @param {string} [params.shiftStart] - Vehicle shift start HH:mm
     * @param {string} [params.shiftEnd] - Vehicle shift end HH:mm
     * @returns {Object} Object with windows array and allowExtendedHours flag
     */
    function adjustWindowTimesForReorderOptimization(params) {
      var windowStart = params.windowStart;
      var windowEnd = params.windowEnd;
      var planStartDate = params.planStartDate;
      var planEndDate = params.planEndDate;
      var planStartTime = params.planStartTime;
      var shiftStart = params.shiftStart;
      var shiftEnd = params.shiftEnd;

      if (
        !windowStart ||
        !windowEnd ||
        !planStartDate ||
        !planEndDate ||
        !planStartTime
      ) {
        return {
          windowStart: windowStart,
          windowEnd: windowEnd,
          allowExtendedHours: false,
        };
      }

      if (
        moment(planStartDate, "YYYY-MM-DD").isSame(
          moment(planEndDate, "YYYY-MM-DD")
        )
      ) {
        if (
          moment(windowStart, "HH:mm").isAfter(moment(windowEnd, "HH:mm"))
        ) {
          return {
            windows: [[windowStart, convertToExtendedFormat(windowEnd, 1)]],
            allowExtendedHours: true,
          };
        }
        return {
          windows: [[windowStart, windowEnd]],
          allowExtendedHours: false,
        };
      }

      if (
        moment(windowStart, "HH:mm").isAfter(moment(windowEnd, "HH:mm"))
      ) {
        return {
          windows: [[windowStart, convertToExtendedFormat(windowEnd, 1)]],
          allowExtendedHours: true,
        };
      }

      if (!shiftStart || !shiftEnd) {
        return {
          windows: [[windowStart, windowEnd]],
          allowExtendedHours: true,
        };
      }

      var wsM =
        moment(windowStart, "HH:mm").hours() * 60 +
        moment(windowStart, "HH:mm").minutes();
      var weM =
        moment(windowEnd, "HH:mm").hours() * 60 +
        moment(windowEnd, "HH:mm").minutes();
      var ssM =
        moment(shiftStart, "HH:mm").hours() * 60 +
        moment(shiftStart, "HH:mm").minutes();
      var seM =
        moment(shiftEnd, "HH:mm").hours() * 60 +
        moment(shiftEnd, "HH:mm").minutes();

      var shiftCrossesMidnight = _shiftCrossesMidnight(shiftStart, shiftEnd);

      if (!shiftCrossesMidnight) {
        return {
          windows: [[windowStart, windowEnd]],
          allowExtendedHours: true,
        };
      }

      if (wsM >= ssM) {
        return {
          windows: [[windowStart, windowEnd]],
          allowExtendedHours: true,
        };
      }

      if ((weM <= seM && wsM < ssM) || (weM <= ssM && wsM < ssM)) {
        return {
          windows: [
            [
              convertToExtendedFormat(windowStart, 1),
              convertToExtendedFormat(windowEnd, 1),
            ],
          ],
          allowExtendedHours: true,
        };
      }

      return {
        windows: [[windowStart, windowEnd]],
        allowExtendedHours: true,
      };
    }

    function isPrioritizeLoadOptionEnabled() {
      var pathFinderProperties = getPathFinderProperties();
      return utilsService.isAddonPropertyEnabled(pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_PRIORITIZE_LOAD]);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('plannerReportsService', plannerReportsService);

  /** @ngInject */
  function plannerReportsService($window, $filter, timeUtils, pdfService,
                                PDF_LOGO_BASE64, extraFieldsService, accountConfigsService, ACCOUNT_CONFIGS, $q,
                                SHOW_EXTRA_FIELD_VALUES_PDF_ADDON_PROPERTY, extraFieldsCheckerService) {

    var service = {
      exportSummarizedPlanPdf: exportSummarizedPlanPdf,
      generateSummarizedVisits: generateSummarizedVisits
    };

    $window.plannerReportsService = service;
    return service;

    function generateSummarizedVisits(visits, accountHasExtrafieldKey, streetsInBetweenPdfSummaryEnabled, isShowExtraFieldValuesEnabled) {
      //build headers
      var output = {
        style: 'defaultStyle',
        table: {
          // Ensure widths array is always valid based on the width of the page
          widths: isShowExtraFieldValuesEnabled ?
            [35, 110, 85, 80, 140, 80, 60, 60] :
            [25, 80, 65, 60, 110, 60, 45],
          headerRows: 1,
          body: [
            // Ensure header row is properly constructed
            [
              {text: '#', style: 'tableHeader'},
              {text: $filter('translate')('Summarized_Pdf.title'), style: 'tableHeader'},
              {text: $filter('translate')('Summarized_Pdf.id'), style: 'tableHeader'},
              {text: $filter('translate')('Summarized_Pdf.contact_phone'), style: 'tableHeader'},
              {text: $filter('translate')('Summarized_Pdf.address'), style: 'tableHeader'},
              {text: $filter('translate')('Summarized_Pdf.time_windows'), style: 'tableHeader'},
              {text: $filter('translate')('Summarized_Pdf.arrival'), style: 'tableHeader'}
            ].concat(isShowExtraFieldValuesEnabled ? [{
              text: $filter('translate')('Summarized_Pdf.customer_shipment_date'),
              style: 'tableHeader'
            }] : [])
          ]
        }
      };

      //data rows
      visits.sort(function (a, b) {
        return a.order - b.order;
      });

      visits.forEach(function (visit) {
        var timeWindow = _buildTimeWindows(visit.windowStart, visit.windowEnd, visit.windowStart2, visit.windowEnd2);
        var streets_in_between;
        var customer_shipment_date = "";

        if (streetsInBetweenPdfSummaryEnabled) {
          if (visit.extra_field_values && visit.extra_field_values.entre_calles_1) {
            streets_in_between = visit.extra_field_values.entre_calles_1;
          }
          else {
            streets_in_between = null;
          }
        }
        streets_in_between = _buildStreetsInBetween(streets_in_between, accountHasExtrafieldKey);

        // Get customer_shipment_date if enabled
        if (isShowExtraFieldValuesEnabled && visit.extra_field_values && visit.extra_field_values.fec_envio_cliente) {
          customer_shipment_date = visit.extra_field_values.fec_envio_cliente || "";
        }

        // Ensure row data matches header structure
        var baseRow = [
          {text: visit.order.toString(), style: 'cells'},
          {text: visit.title, style: 'cells'},
          {text: visit.reference !== ""? visit.reference : $filter('translate')('Summarized_Pdf.missing_id') , style: 'cells'},
          {text: visit.contactPhone !== ""? visit.contactPhone : $filter('translate')('Summarized_Pdf.missing_contact_phone') , style: 'cells'},
          {text: visit.address + streets_in_between, style: 'cells'},
          {text: timeWindow, style: 'cells'},
          {text: timeUtils.formatTime(visit.estimatedTimeArrival, 'DD-MM' + ' ' + 'HH:mm'), style: 'cells'}
        ];

        if (isShowExtraFieldValuesEnabled) {
          baseRow.push({
            text: customer_shipment_date,
            style: 'cells'
          });
        }

        output.table.body.push(baseRow);
      });

      return output;
    }

    function exportSummarizedPlanPdf(vehicles, planDate) {
      var date = timeUtils.formatTime(planDate, 'DD MMMM, YYYY');
      var title = 'SimpliRoute_Plan_' + timeUtils.formatTime(planDate, 'YYYY-MM-DD');
      var accountHasExtrafieldKey = false;

      var streetsInBetweenPdfSummaryEnabled = accountConfigsService.isConfigEnabled(
        ACCOUNT_CONFIGS.STREETS_IN_BETWEEN_PDF_SUMMARY
      );

      // First check if extra fields are enabled
      extraFieldsCheckerService.getShowExtraFieldsEnabled(SHOW_EXTRA_FIELD_VALUES_PDF_ADDON_PROPERTY)
        .then(function(isShowExtraFieldValuesEnabled) {
          // Then proceed with existing extraFields check
          var extraFieldsPromise = streetsInBetweenPdfSummaryEnabled ?
            extraFieldsService.getExtraFields() :
            $q.when();

          extraFieldsPromise
            .then(function (extraFields) {
              if (!extraFields) {
                return false;
              }
              return extraFields.some(function (extraField) {
                return extraField['key'] === 'entre_calles_1';
              });
            }, function () {
              return false;
            })
            .then(function (hasExtrafieldKey) {
              accountHasExtrafieldKey = hasExtrafieldKey;
              generateSummarizedPlanPdf(
                vehicles,
                accountHasExtrafieldKey,
                streetsInBetweenPdfSummaryEnabled,
                date,
                title,
                isShowExtraFieldValuesEnabled
              );
            });
        })
        .catch(function(error) {
          console.error("Error checking extra fields enabled status:", error);
          generateSummarizedPlanPdf(
            vehicles,
            accountHasExtrafieldKey,
            streetsInBetweenPdfSummaryEnabled,
            date,
            title,
            false
          );
        });
    }

    function generateSummarizedPlanPdf(vehicles, accountHasExtrafieldKey, streetsInBetweenPdfSummaryEnabled, date, title, isShowExtraFieldValuesEnabled) {
      var docFinal;
      var tableDoc = [];

      vehicles.forEach(function (vehicle) {
        if (vehicle.routes && vehicle.routes.length > 0) {
          var nameDriver = '';
          var nameVehicle = vehicle.name;
          if (vehicle.driver) {
            nameDriver = vehicle.driver.name;
          }
          tableDoc.push({
            columns: [
              {
                alignment: 'left',
                image: 'simpli',
                width: 200,
                margin: [-20, -10]
              },
              {
                text: '',
                width: 150
              },
              {
                alignment: 'right',
                text: date + '\n' + $filter('translate')('Pdf.vehicle') + ': ' + nameVehicle + '\n ' + nameDriver
              }
            ]
          });

          vehicle.routes.forEach(function (route) {
            if (route.visits.length > 0) {
              tableDoc.push(generateSummarizedVisits(route.visits, accountHasExtrafieldKey, streetsInBetweenPdfSummaryEnabled, isShowExtraFieldValuesEnabled));
            }
            tableDoc.push({text: ' ', pageBreak: 'after'});
          });
        }
      });

      tableDoc.splice(-1, 1);
      docFinal = {
        pageSize: 'A4',
        pageOrientation: isShowExtraFieldValuesEnabled ? 'landscape' : 'portrait',
        content: tableDoc,
        styles: {
          header: {
            fontSize: 15,
            bold: true,
            margin: [0, 0, 0, 10]
          },
          defaultStyle: {
            margin: [0, 5, 0, 15]
          },
          tableHeader: {
            bold: true,
            fontSize: 11,
            color: 'black',
            alignment: 'center'
          },
          cells: {
            alignment: 'center',
            fontSize: 8,
            color: 'black',
          },
        },
        images: {
          'simpli': PDF_LOGO_BASE64
        }
      };

      if (docFinal) {
        pdfService.create(docFinal, title);
      }
    }

    function _buildTimeWindows(windowStart, windowEnd, windowStart2, windowEnd2) {

      var windowsStart = windowStart == null ? '00:00' : windowStart;
      var windowsEnd = windowEnd == null ? '23:59' : windowEnd;
      var windowsStart2 = windowStart2 == null ? '23:59' : windowStart2;
      var windowsEnd2 = windowEnd2 == null ? '23:59' : windowEnd2;

      if(windowsStart2 === windowsEnd2){
        return windowsStart + ' a ' + windowsEnd;
      } else {
        return windowsStart + ' a ' + windowsEnd + '\n' + windowsStart2 + ' a ' + windowsEnd2;
      }
    }

    function _buildStreetsInBetween(streets_in_between, accountHasExtrafieldKey) {
      var resultingStreetsInBetween;

      // Account config is not enabled
      /// or account has no extra field key defined
      if (streets_in_between === undefined || !accountHasExtrafieldKey) {
        resultingStreetsInBetween = '';
      }
      // Account config enabled but value was empty
      // and extra field key is defined
      else if (streets_in_between === null) {
        resultingStreetsInBetween = ' || ' + $filter('translate')('Summarized_Pdf.missing_streets_in_between');
      }
      else {
        resultingStreetsInBetween = ' || ' + streets_in_between;
      }

      return resultingStreetsInBetween;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .service('optimizeService', optimizeService);

  /** @ngInject */
  function optimizeService(__env, $log, $http, $q, $rootScope, accountConfigsService, timeUtils,
                           plannerService, zoneService, DEPOT_KEY, vehicleTypeUtils, visitsMarkersService,
                           visitJoinerService, RELATIONSHIP_TYPE, optimizationUtilsService, visitsUtils,
                           PATH_FINDER_ADD_ON_PROPERTIES, VISIT_OUT_OF_ROUTE_DEFAULT_COLOR, VISIT_OUT_OF_ROUTE_ORDER) {

    var OPTIMIZE_K_MEANS_PATH = __env.API_URL + 'optimize/k-means';
    var OPTIMIZE_JDH_PATH = __env.VRP_URL + 'vrp/optimize/sync/';
    var OPTIMIZE_BIG_VRP_PATH = __env.VRP_URL + 'big-vrp/optimize/sync/';
    var OPTIMIZE_PD_PATH = __env.VRP_URL + "pd/optimize/sync/";
    var OPTIMIZATION_RESULT_PATH = __env.VRP_URL + "optimizations/";
    var OPTIMIZE_MULTI_RESULTS_PATH = __env.ROUTER_MS_URL + 'v2/routes/multi/vrp';
    var OPTIMIZE_BIG_VRP_MULTI_RESULTS_PATH = __env.ROUTER_MS_URL + 'v2/routes/multi/big-vrp';
    var OPTIMIZE_VEHICLE_RESTRICTIONS_PATH = __env.ROUTER_MS_URL + 'v2/optimize/vrp/vehicle_restrictions';

    var DAY_START_TIME = '00:00';
    var DAY_END_TIME = '23:59';
    var REST_TIME = 'BreakVisit';

    return {
      reoptimizePlan: reoptimizePlan,
      optimizePlan: optimizePlan,
      getVehiclesRequestData: getVehiclesRequestData,
      getVisitsRequestData: getVisitsRequestData,
      reorderRoute: reorderRoute,
      optimizePickupAndDeliveryPlan: optimizePickupAndDeliveryPlan,
      setOptimizationOptions: setOptimizationOptions,
      adjustOptimizationOptionsWithAccountConfigs: adjustOptimizationOptionsWithAccountConfigs,
      buildArrayOfTimeWindows: buildArrayOfTimeWindows,
      optimizeMultiResultsPlan: optimizeMultiResultsPlan,
      retrieveOptimizationResults: retrieveOptimizationResults
    };

    //////////////////////////////////////////
    // Public Methods
    /////////////////////////////////////////

    //TODO: cuando es big_cluster, no sumar sumar hora shift_end y sin longRoutes
    function reoptimizePlan(localOptimizationOptions, requestData, isBigVrp, isVehicularRestrictionEnabled) {
      requestData.start_time = plannerService.getPlanStartTime();
      if (localOptimizationOptions.big_cluster) {
        return $http.post(OPTIMIZE_K_MEANS_PATH, requestData);
      } else if (isVehicularRestrictionEnabled) {
        return $http.post(OPTIMIZE_VEHICLE_RESTRICTIONS_PATH, requestData);
      } else if (isBigVrp) {
        return $http.post(OPTIMIZE_BIG_VRP_PATH, requestData);
      } else {
        return $http.post(OPTIMIZE_JDH_PATH, requestData);
      }
    }

    function optimizeMultiResultsPlan(vehicles, visits, zones, params) {
      var deferred = $q.defer();
      var isReorder = false;
      var requestData = getRequestData(params, isReorder);
      requestData.vehicles = getVehiclesRequestData(vehicles, zones, params, requestData);
      requestData.nodes = getVisitsRequestData(visits, params, isReorder, zones);
      requestData.start_time = plannerService.getPlanStartTime();

      var paramsQuery = {
        'problem': requestData
      };

      var url = params.isBigVrp ? OPTIMIZE_BIG_VRP_MULTI_RESULTS_PATH : OPTIMIZE_MULTI_RESULTS_PATH;

      $http.post(url, paramsQuery)
        .then(function (response) {
          var data = response.data;
          if (data.solution.error) {
            deferred.reject({error: data.solution.error, status: 400});
            return;
          }
          var currentOptimizationId = data.solution.id;
          var alternativesResults = data.alternatives.map(function (alternative, index) {
            if (alternative.metrics) {
              alternative.position = index + 1;
              alternative.isCurrentOptimization = alternative.problem_id === currentOptimizationId;
              alternative.areFormatted = false;
              return alternative;
            }
          }).filter(function (alternative) {
            return angular.isDefined(alternative);
          });

          plannerService.setOptimizationResults(alternativesResults);
          deferred.resolve({
            data: data.solution
          });
        })
        .catch(function (error) {
          $log.error('reorderRoute', error);
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function retrieveOptimizationResults(optimizationId) {
      return $http.get(OPTIMIZATION_RESULT_PATH + optimizationId + "/results");
    }

    function optimizePlan(vehicles, visits, zones, params) {
      var isReorder = false;
      var requestData = getRequestData(params, isReorder);
      requestData.vehicles = getVehiclesRequestData(vehicles, zones, params, requestData);
      requestData.nodes = getVisitsRequestData(visits, params, isReorder, zones);
      requestData.start_time = plannerService.getPlanStartTime();
      if (params.optimizationOptions.big_cluster) {
        return $http.post(OPTIMIZE_K_MEANS_PATH, requestData);
      } else if (params.isVehicularRestrictionEnabled) {
        return $http.post(OPTIMIZE_VEHICLE_RESTRICTIONS_PATH, requestData);
      } else if (params.isBigVrp) {
        return $http.post(OPTIMIZE_BIG_VRP_PATH, requestData);
      } else {
        return $http.post(OPTIMIZE_JDH_PATH, requestData);
      }
    }

    function optimizePickupAndDeliveryPlan(vehicles, visits, zones, params) {
      var requestData = getRequestData(params);
      requestData.vehicles = getVehiclesRequestData(vehicles, zones, params, requestData);
      var ignorePiks = true;
      var nodes = getVisitsRequestData(visits, params, false, zones, true, ignorePiks);
      requestData.jobs = convertNodesToJobs(nodes);
      requestData.start_time = plannerService.getPlanStartTime();
      return $http.post(OPTIMIZE_PD_PATH, requestData);
    }

    function convertNodesToJobs(nodes) {
      var visitsRelationShip = plannerService.getVisitsPickupAndDeliveryRelationship();
      var jobs = [];

      // TODO: this must be removed on task PLAN-998
      // this object gather the ids of picks up and delivery that came from getVisitsPickupAndDeliveryRelationship
      var visitRelationshipJobs = {};

      nodes.forEach(function (node) {
        if(visitsRelationShip.hasOwnProperty(node.ident)) {
          visitRelationshipJobs[node.ident] = true; // TODO: remove on task PLAN-998
          visitsRelationShip[node.ident].picks_from.forEach(function (pickup) {
            visitRelationshipJobs[pickup.id] = true; // TODO: remove on task PLAN-998
          });
          var relationship = {delivery: node, picks_from: visitsRelationShip[node.ident].picks_from};
         jobs.push(_createJobObject(relationship, nodes));
        }
      });

      if(visitsRelationShip.hasOwnProperty(DEPOT_KEY) && visitsRelationShip[DEPOT_KEY].picks_from.length) {
        visitsRelationShip[DEPOT_KEY].picks_from.forEach(function (pickup){
          visitRelationshipJobs[pickup.id] = true; // TODO: remove on task PLAN-998
         jobs.push(_createJobObject({picks_from: [pickup]}, nodes));
       });
      }

      // TODO: remove on task PLAN-998
      if( Object.keys(visitRelationshipJobs).length < nodes.length) {
        nodes.forEach(function (node) {
          if (!visitRelationshipJobs.hasOwnProperty(node.ident)) {
            jobs.push(_createJobObject({delivery: node, picks_from: []}, nodes));
          }
        });
      }

      return jobs;
    }

    function _createJobObject(relationship, nodes) {
      var job = {
        pickNodes:[],
        deliveryNodes: []
      };
      if(relationship.hasOwnProperty('delivery')) {
        job.deliveryNodes.push(relationship.delivery);
      }
      job.pickNodes = relationship.picks_from.map(function (visit) {
        return nodes.find(function (node){
          return node.ident === visit.id;
        });
      });
      return job;
    }

    function convertVisitToOptimizationNode(visit, params, reorderRoute, zones, pickupDelivery) {
      var isOneSellerPerVehicleEnabled = params.optimizationOptions.one_seller_per_vehicle;
      var isMixLoadEnabled = isMixLoadAddonEnabled();

      var node = {
        ident: visit.id,
        group: [],
        group_id: null,
        address: visit.address,
        lat: visit.latitude,
        lon: visit.longitude,
        duration: visit.duration,
        window_start: visit.windowStart || DAY_START_TIME,
        window_end: visit.windowEnd || DAY_END_TIME,
        programmedDate: visit.programmedDate || '',
        cluster: 0,
        skills_required: [],
        skills_optional: [],
        priority_level: visit.getPriority(),
        zones: [],
        arrayOfTimeWindows: params.optimizationOptions.longRoutes ? buildArrayOfTimeWindows(params.planDate, params.planInHours, visit, params.optimizationOptions.longRoutes, reorderRoute, params.reorderVehicle) : []
      };

      if (isMixLoadEnabled) {
        // New format with loads array
        node.loads = [
          visit.load || 0,
          visit.load_2 || 0,
          visit.load_3 || 0,
          visit.load_4 || 0
        ];
      } else {
        // Legacy format with individual load properties
        node.load = 0;
        node.load_2 = 0;
        node.load_3 = 0;
      }

      if (!params.isJDH) {
        node.priority = visit.getCPriority();
      }

      if (!params.disableSkills) {
        node.skills_required = reorderRoute ? [] : visit.skills_required;
        node.skills_optional = reorderRoute ? [] : visit.skills_optional;
      }

      if (!params.disableZones && !isOneSellerPerVehicleEnabled) {
        node.zones =
          reorderRoute || zones.length === 0
            ? []
            : zoneService.getActiveZonesVisit(visit);

        var isRestrictionTypeAddonPropertyEnabled =
          zoneService.isRestrictionTypeAddonPropertyEnabled();

        if (isRestrictionTypeAddonPropertyEnabled) {
          node.flexible_zones = node.zones.filter(function (zoneId) {
            var zone = zoneService.findZoneById(zones, zoneId);
            return zone && zone.restriction_type === "flexible";
          });

          node.zones = node.zones.filter(function (zoneId) {
            var zone = zoneService.findZoneById(zones, zoneId);
            return zone && zone.restriction_type !== "flexible";
          });
        }
      }

      if (isOneSellerPerVehicleEnabled && visit.seller_id && !reorderRoute) {
        var seller = plannerService.getSellerById(visit.seller_id);
        node.zones = [seller.localIntId];
      }

      if (!pickupDelivery) {
        node.window_start_2 = visit.windowStart2 || DAY_END_TIME;
        node.window_end_2 = visit.windowEnd2 || DAY_END_TIME;
      }

      node.group.push(visit.id);

      return node;
    }

    function setNodeDuration(node, visit) {
      if (visit.duration && !node.duration) {
        node.duration = visit.duration;
      }
    }

    function setNodeLoads(node, visit, ignorePiks) {
      var isMixLoadEnabled = isMixLoadAddonEnabled();

      if (!ignorePiks && visit.properties.delivery_type === RELATIONSHIP_TYPE.PICK) {
        node.pickLoad = checkLoad(visit.load, node.pickLoad || 0);
        node.pickLoad_2 = checkLoad(visit.load2, node.pickLoad_2 || 0);
        node.pickLoad_3 = checkLoad(visit.load3, node.pickLoad_3 || 0);
      } else {
        if (isMixLoadEnabled) {
          node.loads = [
            checkLoad(visit.load, node.loads[0]),
            checkLoad(visit.load2, node.loads[1]),
            checkLoad(visit.load3, node.loads[2]),
            checkLoad(visit.load4, node.loads[3])
          ];
        } else {
          node.load = checkLoad(visit.load, node.load);
          node.load_2 = checkLoad(visit.load2, node.load_2);
          node.load_3 = checkLoad(visit.load3, node.load_3);
        }
        node.pickLoad = checkLoad(visit.pickLoad, node.pickLoad || 0);
        node.pickLoad_2 = checkLoad(visit.pickLoad2, node.pickLoad_2 || 0);
        node.pickLoad_3 = checkLoad(visit.pickLoad3, node.pickLoad_3 || 0);
      }
    }

    function setNodeWindows(node, visit) {
      node.window_start = checkWindow(visit.window_start, node.window_start);
      node.window_end = checkWindow(visit.window_end, node.window_end);
      node.window_start_2 = checkWindow(visit.window_start_2, node.window_start_2);
      node.window_end_2 = checkWindow(visit.window_end_2, node.window_end_2);
    }

    function mutateOptimizationNodeByVisitData(reorderRoute, node, visit, ignorePiks, shouldPrioritizeLoad) {

      setNodeDuration(node, visit);

      if (!reorderRoute || shouldPrioritizeLoad) {
        setNodeLoads(node, visit, ignorePiks);
      }

      setNodeWindows(node, visit);
    }

    function visitsToOptimizationNodes(visits, params, reorderRoute, zones, pickupDelivery, ignorePiks) {
      var shouldPrioritizeLoad = params.optimizationOptions.prioritize_load === true;
      return visits.reduce(function (nodes, visit) {
          var node =  convertVisitToOptimizationNode(visit, params, reorderRoute, zones, pickupDelivery);
          mutateOptimizationNodeByVisitData(reorderRoute, node, visit, ignorePiks, shouldPrioritizeLoad);
          return nodes.concat(node);
        }, []);
    }

    function visitsToOptimizationNodesJoinedV1(visits, params, reorderRoute, zones, ignorePiks) {
      var shouldPrioritizeLoad = params.optimizationOptions.prioritize_load === true;
      var similarNodes = {};
      return visits.reduce(function (nodes, visit) {
          if (!similarNodes[visit.id]) {
            var similarVisits = reorderRoute ?
            plannerService.visitSimilarGraph.getSimilarByRoute(visit)
            : plannerService.visitSimilarGraph.getSimilar(visit);

            // Filter out visits that don't match the current visit's type (legacy/new)
            var isLegacyVisit = visit.id.indexOf('-') === -1;
            similarVisits = similarVisits.filter(function(similar) {
              var isSimilarLegacy = similar.id.indexOf('-') === -1;
              return isLegacyVisit === isSimilarLegacy;
            });

            var node = convertVisitToOptimizationNode(visit, params, reorderRoute, zones);
            similarNodes[visit.id] = node;
            similarVisits.forEach(function (similar) {
              if (!params.incrementalRouting || visitsUtils.areVisitsFromSameOrNoSourceRoute(visit, similar)) {
                similarNodes[similar.id] = node;
                node.group.push(similar.id);
                node.duration = Math.max(node.duration, similar.duration);
              }
            });

            nodes.push(node);
          }

          mutateOptimizationNodeByVisitData(reorderRoute, similarNodes[visit.id], visit, ignorePiks, shouldPrioritizeLoad);
          return nodes;
        }, []);
    }

    function visitsToOptimizationNodesJoinedV2(visits, params, reorderRoute, zones, ignorePiks) {
      var shouldPrioritizeLoad = params.optimizationOptions.prioritize_load === true;
      var similarNodes = {};
      return visits.reduce(function (nodes, visit) {
          var node = convertVisitToOptimizationNode(visit, params, reorderRoute, zones);
          mutateOptimizationNodeByVisitData(reorderRoute, node, visit, ignorePiks, shouldPrioritizeLoad);
          if (!similarNodes[visit.id]) {
            var similarVisits = plannerService.visitSimilarGraph.getSimilar(visit);
            similarNodes[visit.id] = node;
            similarVisits.forEach(function (similar) {
              similarNodes[similar.id] = node;
            });
          }
          else {
            var groupId = similarNodes[visit.id].ident;
            similarNodes[visit.id].group_id = groupId;
            node.group_id = groupId;
          }
          return nodes.concat(node);
        }, []);
    }

    function getVisitsRequestData(visits, params, reorderRoute, zones, pickupDelivery, ignorePiks) {
      if (params.optimizationOptions.join_v2) {
        return visitsToOptimizationNodesJoinedV2(visits, params, reorderRoute, zones, ignorePiks);
      }

      if (params.optimizationOptions.join) {
        return visitsToOptimizationNodesJoinedV1(visits, params, reorderRoute, zones, ignorePiks);
      }

      return visitsToOptimizationNodes(visits, params, reorderRoute, zones, pickupDelivery, ignorePiks);
    }

    function reorderRoute(vehicle, route, visits, params, areVisitsVisible) {
      var deferred = $q.defer();
      var isReorder = true;
      params.reorderVehicle = vehicle;
      var requestData = getRequestData(params, isReorder);
      var nodesMap = [];
      requestData.isReorder = isReorder;
      requestData.vehicles = getVehiclesRequestDataReorderRoute(vehicle, params);
      requestData.nodes = getVisitsRequestData(route.visits, params, isReorder, []);
      nodesMap = requestData.nodes;
      areVisitsVisible = angular.isUndefined(areVisitsVisible) || areVisitsVisible;
      requestData.start_time = plannerService.getPlanStartTime();

      // If a sibling route already has the break time, don't send rest time params
      // so the API won't generate a duplicate break for this route
      var siblingHasRestTime = vehicle.routes && vehicle.routes.some(function (r) {
        return r.id !== route.id && plannerService.getRestTimeByRouteId(r.id);
      });
      if (siblingHasRestTime) {
        delete requestData.vehicles[0].rest_time_start;
        delete requestData.vehicles[0].rest_time_end;
        delete requestData.vehicles[0].rest_time_duration;
      }

      var url = params.isVehicularRestrictionEnabled ? OPTIMIZE_VEHICLE_RESTRICTIONS_PATH : OPTIMIZE_JDH_PATH;
      $http.post(url, requestData)
        .then(successOptimizeVehicles)
        .catch(errorOptimizePlan);

      function successOptimizeVehicles(response) {
        route.clearVisits();
        var restTimeNode = null;
        response.data.vehicles[0].tours.forEach(function (tour) {
          var depotStart = tour.nodes.shift();
          var depotEnd = tour.nodes.pop();

          if (params.isReorderOnMoveVisitsEnabled) {
            route.estimatedTimeStart = depotStart.departure;
            route.estimatedTimeEnd = depotEnd.arrival;
          }

          route.routeDistance = tour.route_distance || null;

          tour.nodes.forEach(function (node) {
            if (node.ident === REST_TIME) {
              restTimeNode = plannerService.parseOptimizationRestTimeNode(node, vehicle);
              return;
            }

            var visit = null;
            var nodeVisit = nodesMap.filter(function (nodeTmp) {
              return nodeTmp.ident === node.ident;
            })[0];

            nodeVisit.group.forEach(function (visitId) {
              for (var i = 0; i < visits.length; i++) {
                if (visits[i].id === visitId) {
                  visit = visits[i];
                  break;
                }
              }

              visit.removeIndicatorsErrors();

              visit.estimatedTimeArrival = node.arrival;
              visit.estimatedTimeDeparture = node.departure;
              visit.stopId = node.stop_id;

              visit.setDefaultColor(vehicle.color);
              route.addVisitToRoute(visit);
              visitsMarkersService.showVisitOnMap(visit, areVisitsVisible);
            });
          });
        });

        // Mark visits from unattendedClientsNodes as out of route
        var unattendedNodes = response.data.unattendedClientsNodes || response.data.unattended_clients_nodes || [];
        unattendedNodes.forEach(function (unattendedNode) {
          var unattendedNodeVisit = nodesMap.filter(function (nodeTmp) {
            return nodeTmp.ident === unattendedNode.ident;
          })[0];

          if (!unattendedNodeVisit) {
            return;
          }

          unattendedNodeVisit.group.forEach(function (visitId) {
            var visit = null;
            for (var i = 0; i < visits.length; i++) {
              if (visits[i].id === visitId) {
                visit = visits[i];
                break;
              }
            }

            if (!visit) {
              return;
            }

            visit.routeId = null;
            visit.vehicle = null;
            visit.estimatedTimeArrival = null;
            visit.estimatedTimeDeparture = null;
            visit.setDefaultColor(VISIT_OUT_OF_ROUTE_DEFAULT_COLOR);
            visit.updateOrder(VISIT_OUT_OF_ROUTE_ORDER, false);
            visit.removeIndicatorsErrors();
            visit.setSelected(false);
            visitsMarkersService.showVisitOnMap(visit, false);
          });
        });

        if (restTimeNode) {
          plannerService.setRestTimeByRouteId(route.id, restTimeNode);
        } else {
          plannerService.clearRestTimes(route.id);
        }

        if ($rootScope.drawCluster) {
          route.calculatePath(vehicle, params.optimizationOptions, plannerService.getPlanStartTime(), plannerService.isVehicularRestrictionEnabled());
        }

        deferred.resolve({
          optimizationId: response.data.id,
          route: route
        });
      }

      function errorOptimizePlan(error) {
        $log.error('reorderRoute', error);
        deferred.reject(error);
      }

      return deferred.promise;
    }

    function setOptimizationOptions(options, optionsPlanner, optionsPlannerLocal, optionsPlannerDisplayed) {
      // Save optimization options
      angular.forEach(options, function (v, k) {
        if (k !== 'id' && k !== 'created' && k !== 'modified' && k !== 'displayed_options') {
          optionsPlanner[k] = v;
          optionsPlannerLocal[k] = v;
        } else if (k === 'displayed_options') {
          optionsPlannerDisplayed = v;
        }
        if (k === 'fmv' || k === 'fmb') {
          optionsPlanner[k] = parseFloat(v);
          optionsPlannerLocal[k] = parseFloat(v);
        }
      });

      return adjustOptimizationOptionsWithAccountConfigs(optionsPlanner, optionsPlannerLocal, optionsPlannerDisplayed);

    }

    function adjustOptimizationOptionsWithAccountConfigs(optionsPlanner, optionsPlannerLocal, optionsPlannerDisplayed) {
      var deferred = $q.defer();
      var resolve = {
        optionsPlanner: optionsPlanner,
        optionsPlannerLocal: optionsPlannerLocal,
        optionsPlannerDisplayed: optionsPlannerDisplayed
      };

      accountConfigsService.getAllConfigs()
        .then(function (accountConfigs) {
          var accountConfigsForRoutingOptions = plannerService.ACCOUNT_CONFIGS_FOR_ROUTING_OPTIONS;
          accountConfigsForRoutingOptions.forEach(function(config) {
            if (!accountConfigs[config.name]) {
              _removeConfig(config.option, optionsPlanner, optionsPlannerLocal, optionsPlannerDisplayed);
              plannerService.removeDefaultRoutingOption(config.option);
            }
          });

          plannerService.setDefaultRoutingOptions(optionsPlanner);

          resolve.optionsPlannerDisplayed = optionsPlannerDisplayed;
          resolve.optionsPlanner = optionsPlanner;
          resolve.optionsPlannerLocal = optionsPlannerLocal;
          deferred.resolve(resolve);
        }
      ).catch(function (err) {
        $log.info(err);
        deferred.resolve(resolve);
      });

      return deferred.promise;
    }

    //////////////////////////////////////////
    // Privates Methodsº
    /////////////////////////////////////////

    function getRequestData(params, isReorder) {
      var avoidTollsValue = params.optimizationOptions.avoid_tolls;

      var result = {
        vehicles: [],
        nodes: [],
        balance: params.optimizationOptions.balance,
        all_vehicles: params.optimizationOptions.all_vehicles,
        big_cluster: params.optimizationOptions.big_cluster,
        join: params.optimizationOptions.join,
        join_v2: params.optimizationOptions.join_v2,
        open_ended: params.optimizationOptions.open_ended,
        fmv: params.optimizationOptions.fmv,
        fmb: params.optimizationOptions.fmb,
        single_tour: params.optimizationOptions.single_tour,
        beauty: params.optimizationOptions.beauty,
        avoid_tolls: avoidTollsValue,
        maximize_attended_load: params.optimizationOptions.maximize_attended_load,
        use_euclidean_distance: params.optimizationOptions.use_euclidean_distance,
        autoZone: params.optimizationOptions.autoZone,
        country: params.optimizationOptions.country,
        longRoutes: (params.longRoutes && !params.optimizationOptions.big_cluster) || false,
        enable_graphs: params.optimizationOptions.enable_graphs,
        auto_reorder: params.optimizationOptions.auto_reorder,
        insertion_intensification: params.optimizationOptions.insertion_intensification,
        intensive_intra: params.optimizationOptions.intensive_intra,
        open_routes_logic: params.optimizationOptions.open_routes_logic,
        vehicle_capacities_increment: params.optimizationOptions.vehicle_capacities_increment,
        vehicle_journey_extention: params.optimizationOptions.vehicle_journey_extention,
        enable_rest_time: params.optimizationOptions.enable_rest_time,
        enable_soft_window: params.optimizationOptions.enable_soft_window,
        load_balance: params.load_balance,
        time_balance: params.time_balance,
        visit_joiner: visitJoinerService.getVisitJoinerOptimizationParameter(params.optimizationOptions.distance_to_join_visits),
        oneSellerPerVehicle: !isReorder ? params.optimizationOptions.one_seller_per_vehicle : false
      };

      if (params.optimizationOptions.max_client && 0 <= params.optimizationOptions.max_client) {
        result.max_client = params.optimizationOptions.max_client;
      }

      if (optimizationUtilsService.isMinLoadValid(params.optimizationOptions.min_load)) {
        result.min_load = params.optimizationOptions.min_load;
      }

      if (params.optimizationOptions.disable_soft_window) {
        result.disable_soft_window = params.optimizationOptions.disable_soft_window;
      }

      if (params.optimizationOptions.one_vehicle_zone) {
        result.one_vehicle_zone = params.optimizationOptions.one_vehicle_zone;
      }

      if (params.optimizationOptions.radial_routing) {
        result.radial_routing = parseInt(params.optimizationOptions.radial_routing) || undefined;
      }

      if (params.optimizationOptions.prioritize_load) {
        result.prioritize_load = params.optimizationOptions.prioritize_load || false;
      }

      if (!isReorder) {
        result.wave_routing = params.optimizationOptions.wave_routing;
        if (params.optimizationOptions.wave_routing) {
          result.plan_id = params.plan_id;
          result.previous_optimization_id = params.previous_optimization_id;
          result.planned_date = timeUtils.toIsoStringByDate(params.planDate.start);
          result.wave_time = timeUtils.toIsoStringByDate(timeUtils.createTimeUTC(params.cutoffTime, "HH:mm:ss"));
          result.last_wave = params.lastWave;
        }
      }

      if (avoidTollsValue === true) {
        result.osrm_options = { avoid: "tolls" };
      }

      if (params.optimizationOptions.maximize_attended_load === true) {
        result.single_tour = true;
      }

      if (result.oneSellerPerVehicle)  {
        result.autoZone = true;
      }

      return result;
    }

    function getVehiclesRequestData(vehicles, zones, params, request) {
      var requestVehicles = [];
      var isMixLoadEnabled = isMixLoadAddonEnabled();

      vehicles.forEach(function (vehicle) {
        if (!vehicle.active) {
          return;
        }

        var requestVehicle = {
          ident: vehicle.id,
          location_start: {
            ident: 'vehicle-start-' + vehicle.id,
            lat: vehicle.locationStart.latitude,
            lon: vehicle.locationStart.longitude
          },
          location_end: {
            ident: 'vehicle-end-' + vehicle.id,
            lat: vehicle.locationEnd.latitude,
            lon: vehicle.locationEnd.longitude
          },
          shift_start: vehicle.shift.start,
          shift_end: request.longRoutes ? timeUtils.addHours(vehicle.shift.end, params.planInHours || 0) : vehicle.shift.end,
          max_tour_duration: vehicle.shiftDefault.maximumTime,
          skills: [],
          refill: parseInt(vehicle.refill),
          zones: [],
          cost: vehicle.cost,
          min_load: vehicle.minLoad,
          min_load_2: vehicle.minLoad2,
          min_load_3: vehicle.minLoad3,
          max_visit: vehicle.maxVisit,
          rest_time_start: vehicle.restTimeStart,
          rest_time_end: vehicle.restTimeEnd,
          rest_time_duration: vehicle.restTimeDuration,
          open_start: params.optimizationOptions.open_start,
          max_number_of_routes: vehicle.max_number_of_routes,
          max_route_distance: vehicle.max_route_distance != null && !isNaN(vehicle.max_route_distance) && Number(vehicle.max_route_distance) > 0 ? parseFloat(Number(vehicle.max_route_distance).toFixed(2)) : 0
        };

        if (isMixLoadEnabled) {
          // new format: capacities array
          requestVehicle.capacities = [
            vehicle.capacity || 0,
            (!vehicle.capacity2 || vehicle.capacity2 === 0) ? 0 : vehicle.capacity2,
            (!vehicle.capacity3 || vehicle.capacity3 === 0) ? 0 : vehicle.capacity3,
            (!vehicle.capacity4 || vehicle.capacity4 === 0) ? 0 : vehicle.capacity4
          ];
        } else {
          // legacy format: individual capacity properties
          requestVehicle.capacity = vehicle.capacity;
          requestVehicle.capacity_2 = (!vehicle.capacity2 || vehicle.capacity2 === 0) ? 0 : vehicle.capacity2;
          requestVehicle.capacity_3 = (!vehicle.capacity3 || vehicle.capacity3 === 0) ? 0 : vehicle.capacity3;
        }

        // Adjust rest time for extended format when longRoutes and skip_time_validation are enabled
        if (request.longRoutes && getSkipTimeValidation() && vehicle.restTimeStart && vehicle.restTimeEnd) {
          var adjustedRestTimes = timeUtils.adjustRestTimeForExtendedFormat(
            vehicle.restTimeStart,
            vehicle.restTimeEnd
          );
          requestVehicle.rest_time_start = adjustedRestTimes.start;
          requestVehicle.rest_time_end = adjustedRestTimes.end;
        }
        if (!params.disableZones && !params.optimizationOptions.one_seller_per_vehicle) {
          var activeZones = zoneService.getActiveZonesVehicle(vehicle, zones);

          // Keep existing zones logic for all optimizers
          requestVehicle.zones = activeZones;

          var isRestrictionTypeAddonPropertyEnabled =
          zoneService.isRestrictionTypeAddonPropertyEnabled();

          if (isRestrictionTypeAddonPropertyEnabled) {
            requestVehicle.flexible_zones = activeZones.filter(function(zoneId) {
              var zone = zoneService.findZoneById(zones, zoneId);
              return zone && zone.restriction_type === "flexible";
            });

            requestVehicle.zones = requestVehicle.zones.filter(function(zoneId) {
              var zone = zoneService.findZoneById(zones, zoneId);
              return zone && zone.restriction_type !== "flexible";
            });
          }
        }

        if (!params.disableSkills) {
          requestVehicle.skills = parseSkillsVehicles(vehicle.skills);
        }

        if (vehicleTypeUtils.shouldAddVehicleType(params.optimizationOptions)) {
          requestVehicle.type = vehicleTypeUtils.getVehicleType(params.optimizationOptions);
        }

        if(request.single_tour === true) {
          requestVehicle.max_number_of_routes = 1;
        }

        requestVehicles.push(requestVehicle);
      });

      return requestVehicles;
    }

    function checkWindow(windowStartA, windowStartB) {
      if (windowStartA && !windowStartB) {
        windowStartB = windowStartA;
      } else if (windowStartA && windowStartB) {
        if (windowStartA > windowStartB) {
          windowStartB = windowStartA;
        }
      }

      return windowStartB;
    }

    function checkLoad(loadA, loadB) {
      if (loadA) {
        loadB += (angular.isString(loadA)) ? 0 : loadA;
      }

      return loadB;
    }

    function parseSkillsVehicles(skills) {
      var result = [];
      skills.forEach(function (skill) {
        result.push(parseInt(skill));
      });

      return result;
    }

    function getVehiclesRequestDataReorderRoute(vehicle, params) {
      var optimizationOptions = params.optimizationOptions;
      var isMixLoadEnabled = isMixLoadAddonEnabled();
      var vehicleResponse = [
        {
          ident: vehicle.id,
          location_start: {
            ident: 'vehicle-start-' + vehicle.id,
            lat: vehicle.locationStart.latitude,
            lon: vehicle.locationStart.longitude
          },
          location_end: {
            ident: 'vehicle-end-' + vehicle.id,
            lat: vehicle.locationEnd.latitude,
            lon: vehicle.locationEnd.longitude
          },
          shift_start: vehicle.shift.start,
          skills: vehicle.skills,
          rest_time_start: vehicle.restTimeStart,
          rest_time_end: vehicle.restTimeEnd,
          rest_time_duration: vehicle.restTimeDuration,
          open_start: optimizationOptions.open_start,
          max_number_of_routes: vehicle.max_number_of_routes,
          max_route_distance: vehicle.max_route_distance != null && !isNaN(vehicle.max_route_distance) && Number(vehicle.max_route_distance) > 0 ? parseFloat(Number(vehicle.max_route_distance).toFixed(2)) : 0
        }
      ];

      if (isMixLoadEnabled) {
        // New format: capacities array
        vehicleResponse[0].capacities = [
          vehicle.capacity || 0,
          (!vehicle.capacity2 || vehicle.capacity2 === 0) ? 0 : vehicle.capacity2,
          (!vehicle.capacity3 || vehicle.capacity3 === 0) ? 0 : vehicle.capacity3,
          (!vehicle.capacity4 || vehicle.capacity4 === 0) ? 0 : vehicle.capacity4
        ];
      } else {
        // legacy format: individual capacity properties
        vehicleResponse[0].capacity = vehicle.capacity;
        vehicleResponse[0].capacity_2 = (!vehicle.capacity2 || vehicle.capacity2 === 0) ? 0 : vehicle.capacity2;
        vehicleResponse[0].capacity_3 = (!vehicle.capacity3 || vehicle.capacity3 === 0) ? 0 : vehicle.capacity3;
      }

      // Adjust rest time for extended format when longRoutes and skip_time_validation are enabled
      if (params.longRoutes && getSkipTimeValidation() && vehicle.restTimeStart && vehicle.restTimeEnd) {
        var adjustedRestTimes = timeUtils.adjustRestTimeForExtendedFormat(
          vehicle.restTimeStart,
          vehicle.restTimeEnd
        );
        vehicleResponse[0].rest_time_start = adjustedRestTimes.start;
        vehicleResponse[0].rest_time_end = adjustedRestTimes.end;
      }
      if (vehicleTypeUtils.shouldAddVehicleType(optimizationOptions)) {
        vehicleResponse[0].type = vehicleTypeUtils.getVehicleType(optimizationOptions);
      }

      return vehicleResponse;
    }

    /**
     * Resolves extended time windows for sync: full optimize uses multi-day expansion;
     * reorder uses a single window anchored with vehicle shift.
     *
     * @param {string} windowStart - HH:mm
     * @param {string} windowEnd - HH:mm
     * @param {string} planStartDate - YYYY-MM-DD
     * @param {string} planEndDate - YYYY-MM-DD
     * @param {string} planStartTime - HH:mm
     * @param {boolean} reorderRoute - isReorder visit serialization
     * @param {Object} [reorderVehicle] - vehicle when reorderRoute
     * @returns {Object} adjusted times (windows array or legacy windowStart/windowEnd)
     */
    function getAdjustedWindowTimesForSync(windowStart, windowEnd, planStartDate, planEndDate, planStartTime, reorderRoute, reorderVehicle) {
      if (reorderRoute && reorderVehicle) {
        return plannerService.adjustWindowTimesForReorderOptimization({
          windowStart: windowStart,
          windowEnd: windowEnd,
          planStartDate: planStartDate,
          planEndDate: planEndDate,
          planStartTime: planStartTime,
          shiftStart: reorderVehicle.shift && reorderVehicle.shift.start,
          shiftEnd: reorderVehicle.shift && reorderVehicle.shift.end
        });
      }
      return plannerService.adjustWindowTimesWithPlanDatesAndAcrossMidnight({
        windowStart: windowStart,
        windowEnd: windowEnd,
        planStartDate: planStartDate,
        planEndDate: planEndDate,
        planStartTime: planStartTime
      });
    }

    /**
     * Build array of time windows for current visit. Should only run when multi day routes are enabled.
     * If the visit has a valid programmed date, then the array of time windows will only have one value
     * matching the date input.
     *
     * @param {Object} planDate - Array with 2 values. Start & End Days. YYYY-MM-DD format.
     * @param {number} planInHours - (Number of days where plan is active - 1) * 24
     * @param {Object} visit - The current visit we are building
     * @param {boolean} longRoutes - long routes flag
     * @param {boolean} [reorderRoute] - reorder optimization
     * @param {Object} [reorderVehicle] - vehicle for reorder shift windows
     * @return {string[]} result - Array elements composed by a pair of strings.
     *
     */
    function buildArrayOfTimeWindows(planDate, planInHours, visit, longRoutes, reorderRoute, reorderVehicle) {
      var result = [];
      var hoursToAdd = 0;
      var planDateStart = (planDate && planDate.start) ? planDate.start : 0;
      var planDateEnd = (planDate && planDate.end) ? planDate.end : 0;
      var planStartDate = planDateStart ? moment(planDateStart).format('YYYY-MM-DD') : null;
      var planEndDate = planDateEnd ? moment(planDateEnd).format('YYYY-MM-DD') : null;
      var planStartTime = plannerService.getPlanStartTime();
      var visitHasValidProgrammedDate = (
        visit.programmedDate
        && timeUtils.diff(planDateEnd, visit.programmedDate, 'days') >= 0
        && timeUtils.diff(visit.programmedDate, planDateStart, 'days') >= 0
      );
      var fixedFirstStart = visit.windowStart || DAY_START_TIME;
      var fixedFirstEnd = visit.windowEnd || DAY_END_TIME;
      var firstWindowValid = fixedFirstStart !== fixedFirstEnd;
      var fixedSecondStart = visit.windowStart2 || DAY_START_TIME;
      var fixedSecondEnd = visit.windowEnd2 || DAY_END_TIME;
      var secondWindowValid = (visit.windowStart2 || visit.windowEnd2) && (fixedSecondStart !== fixedSecondEnd);

      var visitHasOutOfRangeProgrammedDate = (
        visit.programmedDate && (
          timeUtils.diff(planDateEnd, visit.programmedDate, 'days') < 0
          || timeUtils.diff(visit.programmedDate, planDateStart, 'days') < 0
        )
      );

      if (visitHasOutOfRangeProgrammedDate) {
        result.push([DAY_START_TIME, DAY_START_TIME]);
        return result;
      }

      if (visitHasValidProgrammedDate) {
        hoursToAdd = timeUtils.diff(visit.programmedDate, planDate.start, 'hours');
        if (firstWindowValid) {
          var fixedWindowStart = visit.windowStart || DAY_START_TIME;
          var fixedWindowEnd = visit.windowEnd || DAY_END_TIME;
          if (longRoutes && getSkipTimeValidation()) {
            var adjustedTimes = getAdjustedWindowTimesForSync(
              fixedWindowStart,
              fixedWindowEnd,
              planStartDate,
              planEndDate,
              planStartTime,
              reorderRoute,
              reorderVehicle
            );
            if (adjustedTimes.windows) {
              adjustedTimes.windows.forEach(function(window) {
                result.push(window);
              });
            } else {
              result.push([adjustedTimes.windowStart, adjustedTimes.windowEnd]);
            }
          } else {
            result.push([timeUtils.addHours(fixedWindowStart, hoursToAdd), timeUtils.addHours(fixedWindowEnd, hoursToAdd)]);
          }
        }
        if (secondWindowValid) {
          var fixedWindowStart2 = visit.windowStart2 || DAY_START_TIME;
          var fixedWindowEnd2 = visit.windowEnd2 || DAY_END_TIME;
          if (longRoutes && getSkipTimeValidation()) {
            var adjustedTimes2 = getAdjustedWindowTimesForSync(
              fixedWindowStart2,
              fixedWindowEnd2,
              planStartDate,
              planEndDate,
              planStartTime,
              reorderRoute,
              reorderVehicle
            );
            if (adjustedTimes2.windows) {
              adjustedTimes2.windows.forEach(function(window) {
                result.push(window);
              });
            } else {
              result.push([adjustedTimes2.windowStart, adjustedTimes2.windowEnd]);
            }
          } else {
            result.push([timeUtils.addHours(fixedWindowStart2, hoursToAdd), timeUtils.addHours(fixedWindowEnd2, hoursToAdd)]);
          }
        }
      } else {
        ArrayOfTimeWindowsWithoutProgrammedDate(planInHours, firstWindowValid, secondWindowValid, visit, result, longRoutes, planStartDate, planEndDate, planStartTime, reorderRoute, reorderVehicle);
      }

      return result;
    }

    function ArrayOfTimeWindowsWithoutProgrammedDate(planInHours, firstWindowValid, secondWindowValid, visit, result, longRoutes, planStartDate, planEndDate, planStartTime, reorderRoute, reorderVehicle) {
      if (longRoutes && getSkipTimeValidation()) {
        if (firstWindowValid) {
          var fixedWindowStart = visit.windowStart || DAY_START_TIME;
          var fixedWindowEnd = visit.windowEnd || DAY_END_TIME;
          var adjustedTimes = getAdjustedWindowTimesForSync(
            fixedWindowStart,
            fixedWindowEnd,
            planStartDate,
            planEndDate,
            planStartTime,
            reorderRoute,
            reorderVehicle
          );
          if (adjustedTimes.windows) {
            adjustedTimes.windows.forEach(function(window) {
              result.push(window);
            });
          } else {
            result.push([adjustedTimes.windowStart, adjustedTimes.windowEnd]);
          }
        }
        if (secondWindowValid) {
          var fixedWindowStart2 = visit.windowStart2 || DAY_START_TIME;
          var fixedWindowEnd2 = visit.windowEnd2 || DAY_END_TIME;
          var adjustedTimes2 = getAdjustedWindowTimesForSync(
            fixedWindowStart2,
            fixedWindowEnd2,
            planStartDate,
            planEndDate,
            planStartTime,
            reorderRoute,
            reorderVehicle
          );
          if (adjustedTimes2.windows) {
            adjustedTimes2.windows.forEach(function(window) {
              result.push(window);
            });
          } else {
            result.push([adjustedTimes2.windowStart, adjustedTimes2.windowEnd]);
          }
        }
      } else {
        for (var i = 0; i <= planInHours / 24; i++) {
          if (firstWindowValid) {
            var fixedWindowStart = visit.windowStart || DAY_START_TIME;
            var fixedWindowEnd = visit.windowEnd || DAY_END_TIME;
            result.push([timeUtils.addHours(fixedWindowStart, i * 24), timeUtils.addHours(fixedWindowEnd, i * 24)]);
          }
          if (secondWindowValid) {
            var fixedWindowStart2 = visit.windowStart2 || DAY_START_TIME;
            var fixedWindowEnd2 = visit.windowEnd2 || DAY_END_TIME;
            result.push([timeUtils.addHours(fixedWindowStart2, i * 24), timeUtils.addHours(fixedWindowEnd2, i * 24)]);
          }
        }
      }
      return result;
    }

    /**
     * Gets skip time validation value from pathfinder properties
     * @returns {boolean} true if skip time validation is enabled
     */
    function getSkipTimeValidation() {
      var pathFinderProperties = plannerService.getPathFinderProperties();
      var skipTimeValidationValue = pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.SKIP_TIME_VALIDATION];
      return skipTimeValidationValue && skipTimeValidationValue.toLowerCase() === 'true';
    }


    function _removeConfig(option, optionsPlanner, optionsPlannerLocal, optionsPlannerDisplayed) {
      delete optionsPlanner[option];
      delete optionsPlannerLocal[option];
      var indexOption = optionsPlannerDisplayed.indexOf(option);
      if (indexOption > -1) {
        optionsPlannerDisplayed.splice(indexOption, 1);
      }
    }

    function isMixLoadAddonEnabled() {
      var pathFinderProperties = plannerService.getPathFinderProperties();
      var enabledMaxLoad = pathFinderProperties[PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD];
      return enabledMaxLoad && enabledMaxLoad.toLowerCase() === 'true';
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('newValidatorGeoreferenceService', newValidatorGeoreferenceService);

  /** @ngInject */
  function newValidatorGeoreferenceService(VISIT_GEOCODE_ALERT) {
    var maxDistance = 150;

    var service = {
      validateMaxDistance: validateMaxDistance,
      validateVisit: validateVisit
    };

    return service;

    //////////////////////////////////////////
    // Private Methods
    /////////////////////////////////////////

    function _distance(lat1, lon1, lat2, lon2, unit) {
      var radLat1 = Math.PI * lat1 / 180;
      var radLat2 = Math.PI * lat2 / 180;
      var theta = lon1 - lon2;
      var radTheta = Math.PI * theta / 180;
      var dist = Math.sin(radLat1) * Math.sin(radLat2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.cos(radTheta);
      dist = Math.acos(dist);
      dist = dist * 180 / Math.PI;
      dist = dist * 60 * 1.1515;
      if (unit === "K") {
        dist = dist * 1.609344;
      }
      if (unit === "N") {
        dist = dist * 0.8684;
      }
      return dist;
    }

    ////////////////////////////////////////////
    // Public Methods
    ////////////////////////////////////////////

    function validateVisit(visit, georeferenceInaccuracy, vehicles, accountMaxDistance) {
      var maxDistanceAlert = service.validateMaxDistance(visit, vehicles, accountMaxDistance);
      visit.setAlert(
        maxDistanceAlert || georeferenceInaccuracy
      );
    }

    function validateMaxDistance(visit, vehicles, accountMaxDistance) {
      maxDistance = accountMaxDistance || maxDistance;

      var errorType = null;
      for (var i = 0; i < vehicles.length; i++) {
        var distanceFromStart = _distance(
          vehicles[i].locationStart.latitude,
          vehicles[i].locationStart.longitude,
          visit.latitude,
          visit.longitude,
          'K'
        );
        if (distanceFromStart > maxDistance) { // visit too far from the depot
          errorType = VISIT_GEOCODE_ALERT.ERROR_DISTANCE;
        } else {
          errorType = null;
          break;
        }
      }
      return errorType;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.main")
    .factory(
      "mobileCompatibilityMessageService",
      mobileCompatibilityMessageService
    );

  /** @ngInject */
  function mobileCompatibilityMessageService(store) {
    var service = {
      getContinueWithMobileStatus: getContinueWithMobileStatus,
      setContinueWithMobile: setContinueWithMobile
    };

    function detectDevice() {
      var userAgent = navigator.userAgent;

      var isMobileDevice =
        /iPhone|Android.*Mobile|Windows Phone|webOS|BlackBerry|Opera Mini|IEMobile|HarmonyOS/i.test(
          userAgent
        );
      var isTabletDevice =
        /iPad|Android(?!.*Mobile)|Kindle|Silk|PlayBook|Tablet|HarmonyOS/i.test(
          userAgent
        );

      return {
        isMobile: isMobileDevice,
        isTablet: isTabletDevice
      };
    }

    function getContinueWithMobileStatus() {
      var detectedDevice = detectDevice();

      var isMobileOrTable = detectedDevice.isMobile || detectedDevice.isTablet;

      var localStoreWantsContinue = store.get("continueWithMobile");

      return Boolean(!isMobileOrTable || localStoreWantsContinue);
    }

    function setContinueWithMobile() {
      store.set("continueWithMobile", true);
    }

    return service;
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.planner")
    .factory("loadPlanService", loadPlanService);

  /** @ngInject */
  function loadPlanService(__env, naturalService, plannerService, saveDraftPlanService, $q, zoneService,
                            colorAssignerService, accountConfigsService, fleetService, visitListFilterService,
                            $rootScope, DRAFT_FOR_APOLLO, lodash, $log, moment) {
    var service = {
      handleDraftPlanLoad: handleDraftPlanLoad,
      loadPlan: loadPlan,
      loadPlanResume: loadPlanResume,
      coloringRoutes: coloringRoutes,
      loadVisits: loadVisits
    };

    return service;

    function loadPlan(plan, hasToClearPlanner) {
      hasToClearPlanner = angular.isUndefined(hasToClearPlanner) || hasToClearPlanner;
      plannerService.setlocalOptimizationOptions(plannerService.optimizationOptions);
      if (hasToClearPlanner) {
        plannerService.clearPlanner();
      }

      return _loadRouteProperties(plan.routes)
        .then(loadVisits)
        .then(function(){
          return setVisitsZones(plan);
        })
        .then(function(){
          return setSellerId(plan);
        })
        .then(function () {
          return coloringRoutes(plan.routes, plan.vehicles);
        })
        .then(function () {
          return _loadFleets(plan);
        })
        .then(function () {
          if (plan.id && plannerService.getCodrivers() && plannerService.getCodrivers().length > 0) {
            return plannerService.setCodriversByPlan(plan.id);
          }
          return $q.when();
        })
        .then(function () {
          return plannerService.loadPathFinderProperties();
        })
        .then(function () {
          return plannerService.mergePreviousPlan(plan)
            .then(function () {
              handlePlanPostMerge(plan);
            });
        })
        .catch(handleError);
    }

    function handlePlanPostMerge(plan) {
      var blockVehicleChangeEnabled = accountConfigsService.isConfigEnabled('enable_block_vehicle_change');
      plan.routes.forEach(function(route) {
        if (route.events && route.events.length === 1) {
          var eventByRoute = plannerService.eventToRestTime(route.events[0]);

          eventByRoute.startTime = eventByRoute.arrival;
          eventByRoute.endTime = eventByRoute.departure;

          plannerService.setRestTimeByRouteId(route.id, eventByRoute);
        }
      });

      if (plan.isNewPlan) {
        if (saveDraftPlanService.hasDraftPlan()) {
          var originalVisitsFromDraft = saveDraftPlanService.getOriginalVisitsDetail();
          if (originalVisitsFromDraft) {
            plannerService.setOriginalVisits(originalVisitsFromDraft);
          }
        }
      } else {
        plannerService.setOriginalPlan(plan);
      }

      if (plannerService.shouldValidateEditableRoutes() || blockVehicleChangeEnabled) {
        plannerService.calculateStartedRoutes();
      }

      if (plannerService.getCodrivers()) {
        plannerService.setVehiclesCodrivers();
      }

      visitListFilterService.removeResultFromVM();
    }

    function loadPlanResume(planId) {
      var plan = {};
      var vehicleDrivers = {};
      return plannerService.loadPlanDetail(planId)
        .then(function (response) {
          plan = response.data;
          plan.isNewPlan = angular.isDefined(plan.isNewPlan) ? plan.isNewPlan : false;
          return _loadRoutes(plan, vehicleDrivers);
        })
        .then(function () {
          return _loadEvents(plan);
        })
        .then(function () {
          return _loadVehicles(plan, vehicleDrivers);
        })
        .then(function () {
          return {
            plan: plan
          };
        })
        .catch(handleError);
    }

    function handleDraftPlanLoad() {
      return plannerService.getPlan()
        .then(checkIfDraftPlanIsSaved)
        .then(loadAndProcessDraftPlan)
        .catch(handleError);
    }

    function checkIfDraftPlanIsSaved() {
      return saveDraftPlanService.isDraftPlanSaved(DRAFT_FOR_APOLLO);
    }

    function loadAndProcessDraftPlan(isDraftPlanSaved) {
      if (!isDraftPlanSaved) {
        return;
      }

      var plan = {};
      return loadPlanResume(DRAFT_FOR_APOLLO)
        .then(function(response) {
          plan = response.plan;
          plan.isDraft = true;
          if (!plan.routes.length) {
            plan.visits = saveDraftPlanService.getVisitList();
            _loadDraftVehicles(plannerService.getVehicles());
            plannerService.mergePreviousPartialPlan(plan);
            return _loadFleets(plan);
          } else {
            if (!plan.isNewPlan) {
              $rootScope.$broadcast("Planner:Plan:info", {planDate: plan.start_date, planName: plan.name});
            }
            return loadPlan(plan, false);
          }
        })
        .then(function() {
          visitListFilterService.setMatchValue(plan.activeVisitFilter);
          plannerService.setOptimizationResults(plan.optimizationResults);
          return saveDraftPlanService.deleteDraftPlan(DRAFT_FOR_APOLLO);
        });
    }

    function setVisitsZones(plan) {
      var zonesFilter = {
        schedules: plannerService.getScheduledPlanDaysOfWeek(plan.start_date),
        enabled: true
      };

      return zoneService.getZonesIfProceed(zonesFilter)
        .then(function(zones) {
          if (zones.length > 0) {
            var polygons = zoneService.buildPolygonsFromZones(zones);
            plan.routes.forEach(function(route) {
              route.visits.forEach(function(visit) {
                visit.zones = zoneService.getZonesIntoVisit(polygons, visit.latitude, visit.longitude);
              });
            });
          }
        })
        .catch(handleError);
    }

    function setSellerId(plan) {
      plan.routes.forEach(function(route) {
        route.visits.forEach(function(visit) {
          if (visit.seller) {
            visit.seller_id = visit.seller.id;
          }
        });
      });
    }

    function coloringRoutes(routes, vehicles) {
      return $q.when()
        .then(function () {
          var allRoutesHaveColor = routes.every(function (route) {
            return route.properties && route.properties.color;
          });

          if (allRoutesHaveColor) {
            return colorAssignerService.assignVehiclesColorFromRouteProperties(vehicles);
          }

          return colorAssignerService.assignVehiclesColor([], vehicles);
        });
    }

    function loadVisits(routes) {
      var visits = [];

      var visitPromises = routes.map(function(route) {
        return plannerService.loadVisitDetail(route)
          .then(function(response) {
            route.visits = response.data;
            visits = visits.concat(response.data);
          }, handleError);
      });

      return $q.all(visitPromises).then(function() {
        return visits;
      })
      .catch(handleError);
    }

    function _getVehicleByID(vehicles, vehicleId) {
      return vehicles.find(function (vehicle) {
        return vehicle.id === vehicleId;
      });
    }

    function _shallowCopyVehicles(source) {
      if (saveDraftPlanService.hasDraftPlan()) {
        _loadDraftVehicles(source);
      }

      var destination = [];
      source.forEach(function (vehicle) {
        var routesCopy = [];
        vehicle.routes.forEach(function (route) {
          var routeCopy = Object.assign({}, route);
          routesCopy.push(routeCopy);
        });

        var vehicleCopy = Object.assign({}, vehicle);
        vehicleCopy.routes = routesCopy;
        destination.push(vehicleCopy);
      });

      return destination;
    }

    function _fillVehicles(vehicleDrivers, plan, routesCodrivers, vehicles) {
      plan.vehicles = [];
      var vehiclesRoute = {};
      plan.routes.forEach(function (route) {
        var vehicle = _getVehicleByID(vehicles, String(route.vehicle));
        if (vehicle) {
          vehicle.routes.length = 0;
          vehiclesRoute[vehicle.id] = vehicle;
        }
      });

      plan.routes.forEach(function (route) {
        var vehicle = vehiclesRoute[String(route.vehicle)];
        if (!vehicle) {
          return;
        }

        vehicle.driverId = vehicleDrivers[vehicle.id] || null;
        var foundCodrivers = routesCodrivers.find(function (codriver) {
          return codriver.route_id === route.id;
        });

        route.codrivers = foundCodrivers ? foundCodrivers.codrivers : [];
        vehicle.routes.push(route);
        if (plan.vehicles.indexOf(vehicle) === -1) {
          plan.vehicles.push(vehicle);
        }
      });

      // The backend stores `planned_date` as the plan's start date for every route,
      // regardless of which calendar day each sub-route actually runs on. This means
      // we cannot rely on `planned_date` alone to order routes for vehicles whose
      // shift spans midnight (e.g. 22:00 → 06:00). Instead we use the plan's
      // shift window: any route whose `estimated_time_start` falls before
      // `plan.start_time` belongs to the post-midnight portion of the shift and
      // must sort AFTER the evening routes.
      var shiftStart = plan.start_time || '00:00:00';
      var shiftCrossesMidnight = plan.end_time && plan.end_time < shiftStart;
      // Gate: only reorder for multi-day plans with skip_time_validation enabled,
      // to avoid affecting the ordering logic for the rest of the app.
      var pathFinderProperties = plannerService.getPathFinderProperties();
      var skipTimeValidation = pathFinderProperties['skip_time_validation'] &&
        pathFinderProperties['skip_time_validation'].toLowerCase() === 'true';
      var isMultiDay = plan.start_date && plan.end_date &&
        !moment(plan.start_date).isSame(moment(plan.end_date), 'day');
      var shouldApplyMidnightSort = shiftCrossesMidnight && isMultiDay && skipTimeValidation;
      if (shouldApplyMidnightSort) {
        plan.vehicles.forEach(function (vehicle) {
          vehicle.routes.sort(function (a, b) {
            var timeA = a.estimated_time_start || '';
            var timeB = b.estimated_time_start || '';
            // Assign day bucket: 0 = same evening as shift start, 1 = post-midnight.
            var dayA = timeA < shiftStart ? 1 : 0;
            var dayB = timeB < shiftStart ? 1 : 0;
            if (dayA !== dayB) { return dayA - dayB; }
            return timeA > timeB ? 1 : timeA < timeB ? -1 : 0;
          });
        });
      }
    }

    function _loadRouteProperties(routesArray) {
      var routesMap = {};
      routesArray.forEach(function(route) {
        routesMap[route.id] = route;
      });

      return plannerService.loadRouteProperties(Object.keys(routesMap))
        .then(function(response) {
          response.data.forEach(function(routeProperty) {
            var routeObject = routesMap[routeProperty.route];
            if (routeObject) {
              routeObject.properties = {
                color: routeProperty.color
              };
            }
          });

          return routesArray;
        });
    }

    function _loadRoutes(plan, vehicleDrivers) {
      plan.routes = [];
      return plannerService.loadRoutesDetail(plan)
        .then(function (response) {
          response.data.forEach(function (route) {
            route.driver = route.driver ? String(route.driver) : null;
            if (vehicleDrivers.hasOwnProperty(route.vehicle)) {
              if (vehicleDrivers[route.vehicle] !== route.driver) {
                vehicleDrivers[route.vehicle] = null;
              }
            } else {
              vehicleDrivers[route.vehicle] = route.driver;
            }

            plan.routes.push(route);
          });

          return plan.routes;
        })
        .catch(handleError);
    }

    function _loadEvents(plan) {
      return plannerService.loadEventsDetail(plan.id)
        .then(function(response) {
          response.data.forEach(function (event) {
            plannerService.setRestTimeByRouteId(event.route, plannerService.eventToRestTime(event));
            var route = plan.routes.find(function (route) {
              return route.id === event.route;
            });

            if (route) {
              route.events = [event];
            }
          });
        })
        .catch(handleError);
    }

    function _loadVehicles(plan, vehicleDrivers) {
      return plannerService.setCodriversByPlan(plan.id)
        .then(function () {
          var routesCodrivers = [];
          var vehicles = _shallowCopyVehicles(plannerService.getVehicles());
          angular.copy(plannerService.getCodriversPlan(), routesCodrivers);
          _fillVehicles(vehicleDrivers, plan, routesCodrivers, vehicles);
          plan.vehicles = naturalService.naturalSort(plan.vehicles, 'name', false);
        });
    }

    function _loadDraftVehicles(vehicles) {
      var draftVehicles = saveDraftPlanService.getVehiclesDetail();
      var vehiclesToSeeRoutesInDetail =  plannerService.getUserVisualState();
      plannerService.setUserVisualState(vehiclesToSeeRoutesInDetail);
      draftVehicles.forEach(function (draftVehicle) {
        var vehicle = _getVehicleByID(vehicles, draftVehicle.id);
        if (vehicle && !moment(vehicle.modified).isAfter(moment(draftVehicle.modified))) {
          lodash.merge(vehicle, draftVehicle);
          vehiclesToSeeRoutesInDetail[parseInt(vehicle.id)] = draftVehicle.showRoutes;
        }
      });
    }

    function _loadFleets(plan) {
      return fleetService.getMyFleets()
        .then(function (fleets) {
          var fleetInPlan = fleets.find(function (fleet) {
            return fleet.id === plan.fleet;
          });

          if (fleetInPlan) {
            plannerService.setSelectedFleet(fleetInPlan);
            plannerService.setFleetId(fleetInPlan.id);
            var fleetsDic = fleetService.getVehiclesByFleets(plannerService.vehicles, fleets);
            fleetService.paintVehiclesByFleet(fleetsDic[fleetInPlan.id], fleetInPlan);
            $rootScope.$broadcast("Planner:Plan:change-fleet", {
              currentVehicles: fleetsDic[fleetInPlan.id]
            });
          }
        })
        .catch(handleError);
    }

    function handleError(error) {
      $log.error(error);
      return $q.reject(error);
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('extraFieldsCheckerService', extraFieldsCheckerService);

  /** @ngInject */
  function extraFieldsCheckerService(addonsService, PATH_FINDER_ADD_ON_KEY) {
    return {
      getShowExtraFieldsEnabled: getShowExtraFieldsEnabled
    };

    function getShowExtraFieldsEnabled(propertyKey) {
      return addonsService.listAddons()
        .then(function (addons) {
          var pathFinderAddon = addons.find(
            function(addon) { return addon.key === PATH_FINDER_ADD_ON_KEY && addon.enable; }
          );

          if (!pathFinderAddon) {
            return false;
          }

          return addonsService
            .getAddonPropertyByKeyFiltered(
              pathFinderAddon.id,
              propertyKey
            )
            .then(function (addonProperty) {
              return addonProperty.value.toLowerCase() === "true";
            })
            .catch(function (error) {
              console.error("Error getting addon property:", error);
              return false;
            });
        })
        .catch(function (error) {
          console.error(
            "Error getting addon property show_extra_field_values:",
            error
          );
          return false;
        });
    }
  }
})();

(function () {
  angular
    .module('icarus.planner')
    .factory('dnsUtilsService', dnsUtilsServiceFactory);

  /** @ngInject */
  function dnsUtilsServiceFactory() {

    var service = {
      getURLByRndDNSNum: getURLByRndDNSNum
    };

    /**
     * Replace a expression with a random number, there is represent a DNS
     * @param {string} url url of domain
     * @param {int} dnsCount number of domains
     * @returns {string} new url
     */
    function getURLByRndDNSNum(url, dnsCount) {
      var URLNumberAsString = '';
      var EXPRESSION_TO_REPLACE = '{}';
      if (dnsCount) {
        var URLNumber =  Math.floor((Math.random() * dnsCount) + 1);
        URLNumberAsString = URLNumber.toString();
      }
      return url.replace(EXPRESSION_TO_REPLACE, URLNumberAsString);
    }

    return service;
  }

})();

/* global angular:{}*/
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('cleanerService', cleanerService);

  function cleanerService(CLEANER_CONFIG) {
    var configs = CLEANER_CONFIG;
    var globalDistrict = {};

    var service = {
      setConfig: setConfig,
      cleanAddress: cleanAddress,
      replaceSpecialChars: replaceSpecialChars,
      latiniseString: latiniseString,
      cleanOfAbsoluteStopWords: cleanOfAbsoluteStopWords,
      applyRules: applyRules,
      getDistrict: getDistrict,
      getDistrictAndDeleteOthersOnString: getDistrictAndDeleteOthersOnString,
      recognizeAndGetDistrictFromUrbanization: recognizeAndGetDistrictFromUrbanization,
      sendDistrictConfig: sendDistrictConfig
    };

    return service;

    function setConfig(country) {
      configs = CLEANER_CONFIG[country];
    }

    function cleanAddress(address) {
      if (!isCleanerReady) {
        return address;
      }
      return applyRules(' ' + address + ' ').trim();
    }

    function isCleanerReady() {
      var isReady = true;
      if (angular.isUndefined(configs) || angular.isUndefined(configs.latinMap) ||
        angular.isUndefined(configs.specialChars || angular.isUndefined(configs.absoluteStopWords) ||
          angular.isUndefined(configs.continuationStopWords) || angular.isUndefined(configs.urbanizationStopWords) ||
          angular.isUndefined(configs.districts) || angular.isUndefined(configs.administrativeAreaLvl4))) {
        isReady = false;
      }
      return isReady;
    }

    function replaceSpecialChars(string) {
      var lowerCaseString = string.toLowerCase();
      for (var key in configs.specialChars) {
        if (configs.specialChars.hasOwnProperty(key)) {
          lowerCaseString = lowerCaseString.replace(new RegExp(RegExp.escape(key), 'g'), configs.specialChars[key]);
        }
      }
      return lowerCaseString;
    }

    function latiniseString(string) {
      return string.replace(/[^A-Za-z0-9\[\] ]/g, function (x) {
        return configs.latinMap[x] || x;
      });
    }

    function stringCleanSpecialChars(string) {
      var latinisedString = latiniseString(string);
      return replaceSpecialChars(latinisedString);
    }

    function cleanOfAbsoluteStopWords(string) {
      var stringSplitted = replaceSpecialChars(string).split(' ');
      configs.absoluteStopWords.forEach(function (absWord) {
        var index = 0;
        var indexesChecked = [];
        while (index !== -1 && indexesChecked.indexOf(index) === -1) {
          index = stringSplitted.indexOf(absWord.toLowerCase(), index);
          indexesChecked.push(index);
          if (index !== -1) {
            if (stringSplitted.length - 1 > index) {
              var nextWord = isNaN(parseInt(stringSplitted[index + 1])) ? stringSplitted[index + 1] : parseInt(stringSplitted[index + 1]);
              if (typeof nextWord === 'string') {
                stringSplitted.splice(index, 1);
              }
            } else {
              stringSplitted.splice(index, 1);
            }
          }
        }
      });
      return stringSplitted.join(' ');
    }

    function checkIfDistrictException(string, district) {
      var reg = new RegExp(district.toLowerCase(), 'g');
      var districtOcurrences = (string.toLowerCase().match(reg) || []).length;
      return configs.districtExceptions.some(function (districtException) {
        var districtInException = districtException.toLowerCase().indexOf(district.toLowerCase()) !== -1;
        var exceptionOnString = string.indexOf(districtException.toLowerCase()) !== -1;
        return districtOcurrences === 1 && districtInException && exceptionOnString;
      });
    }

    function getDistrictAndDeleteOthersOnString(string) {
      var found = false;
      var districtIdentified = {};
      var matchFirstNumber = string.match(/\d+/);
      var indexFirstNumber = matchFirstNumber ? matchFirstNumber.index : -1;
      configs.districts.forEach(function (district) {
        var districtWithSpaces = ' ' + district.toLowerCase() + ' ';
        var indexFound = string.lastIndexOf(districtWithSpaces.toLowerCase());
        if ( indexFound > indexFirstNumber && !checkIfDistrictException(string, district)) {
          if (found) {
            if (districtWithSpaces.indexOf(' ' + districtIdentified.districtName + ' ') !== -1) {
              districtIdentified.index = string.indexOf(districtWithSpaces.toLowerCase());
              districtIdentified.wordLength = district.split(' ').length;
              districtIdentified.districtName = district.toLowerCase();
            } else if (configs.sendAdministrativeAreaLv3) {
              string = string.replace(new RegExp(RegExp.escape(districtWithSpaces.toLowerCase()), 'g'), ' ');
            }
          } else {
            districtIdentified.index = string.indexOf(districtWithSpaces.toLowerCase());
            districtIdentified.wordLength = district.split(' ').length;
            districtIdentified.districtName = district.toLowerCase();
            found = true;
          }
        }

      });
      setGlobalDistrict(districtIdentified);
      return string;
    }

    function cleanOfContinuationStopWords(string) {
      var stringWithoutDistrict = string;
      var stringCleaned = '';
      var district = getGlobalDistrict();
      if (district.districtName && configs.sendAdministrativeAreaLv3) {
        stringWithoutDistrict = stringWithoutDistrict.replace(new RegExp(RegExp.escape(' ' + district.districtName.toLowerCase() + ' '), 'g'), ' ');
      }
      var stringSplitted = stringWithoutDistrict.split(' ');


      configs.continuationStopWords.forEach(function (contWord) {
        var index = 0;
        while (index !== -1) {
          index = stringSplitted.indexOf(contWord.toLowerCase());
          if (index !== -1) {
            var wordsToDelete = 1;
            if (stringSplitted.length - 1 > index) {
              for (var i = index + 1; i < stringSplitted.length; i++) {
                if (!isDistrict(stringSplitted, stringSplitted[i], i) &&
                  !isContinuationStopWord(stringSplitted[i]) &&
                  !isAbsoluteStopWord(stringSplitted[i])) {
                  wordsToDelete++;
                } else {
                  break;
                }
              }
            }
            stringSplitted.splice(index, wordsToDelete);
          }
        }
      });
      if (district.districtName && configs.sendAdministrativeAreaLv3) {
        stringCleaned = stringSplitted.join(' ') + ' ' + district.districtName;
      } else {
        stringCleaned = stringSplitted.join(' ');
      }
      return stringCleaned;
    }

    function isDistrict(stringSplitted, value, index) {
      var match = true;
      var district = getGlobalDistrict();
      if (district.hasOwnProperty('districtName') && district.districtName) {
        var districtSplitted = district.districtName.split(' ');
        if (value === districtSplitted[0]) {
          for (var i = 0; i < districtSplitted.length; i++) {
            if (districtSplitted[i] !== stringSplitted[index + i]) {
              match = false;
            }
          }
        } else {
          match = false;
        }
      } else {
        match = false;
      }

      return match;
    }

    function isContinuationStopWord(word) {
      var match = true;
      var lowerContinuationStopWords = configs.continuationStopWords.map(function (word) {
        return word.toLowerCase();
      });

      if (lowerContinuationStopWords.indexOf(word) === -1) {
        match = false;
      }
      return match;
    }

    function isAbsoluteStopWord(word) {
      var match = true;
      var lowerAbsoluteStopWords = configs.absoluteStopWords.map(function (word) {
        return word.toLowerCase();
      });

      if (lowerAbsoluteStopWords.indexOf(word) === -1) {
        match = false;
      }
      return match;
    }

    function isUrbanizationStopWord(word) {
      var match = true;
      var lowerUrbanizationStopWords = configs.urbanizationStopWords.map(function (word) {
        return word.toLowerCase();
      });

      if (lowerUrbanizationStopWords.indexOf(word) === -1) {
        match = false;
      }
      return match;
    }

    function setGlobalDistrict(district) {
      globalDistrict = district;
    }

    function getGlobalDistrict() {
      return globalDistrict;
    }

    function getDistrict() {
      var districtName = '';
      if (globalDistrict.hasOwnProperty('districtName') && globalDistrict.districtName) {
        districtName = globalDistrict.districtName;
      }
      return districtName;
    }

    function applyRules(string) {
      var cleanString = getDistrictAndDeleteOthersOnString(stringCleanSpecialChars(string));
      var districtRecognized = '';
      if (!getDistrict()) {
        districtRecognized = recognizeAndGetDistrictFromUrbanization(cleanString);
      }
      var cleanOfContWords = cleanOfContinuationStopWords(cleanString);
      var cleanOfAbsWords = cleanOfAbsoluteStopWords(cleanOfContWords);
      if (districtRecognized) {
        cleanOfAbsWords = cleanOfAbsWords.length > 1 ? cleanOfAbsWords + ', ' + districtRecognized : districtRecognized;
        setGlobalDistrict(
          {
            index: 0,
            wordLength: districtRecognized.split(' ').length,
            districtName: districtRecognized
          }
        );
      }
      return cleanOfAbsWords;
    }

    function getDistrictOfUrbanization(urbanization) {
      var district = '';
      if (configs.administrativeAreaLvl4.hasOwnProperty(urbanization)) {
        district = configs.administrativeAreaLvl4[urbanization];
      }
      return district;
    }

    function recognizeAndGetDistrictFromUrbanization(string) {
      var stringSplitted = string.split(' ');
      var district = '';
      var districtFounded = false;
      configs.urbanizationStopWords.forEach(function (urbWord) {
        if (!districtFounded) {
          var index = 0;
          var urbSplittedName = [];
          index = stringSplitted.indexOf(urbWord.toLowerCase());
          if (index !== -1) {
            if (stringSplitted.length - 1 > index) {
              for (var i = index + 1; i < stringSplitted.length; i++) {
                if (!isDistrict(stringSplitted, stringSplitted[i], i) &&
                  !isContinuationStopWord(stringSplitted[i]) &&
                  !isAbsoluteStopWord(stringSplitted[i]) &&
                  !isUrbanizationStopWord(stringSplitted[i])) {
                  urbSplittedName.push(stringSplitted[i]);
                } else if (!isUrbanizationStopWord(stringSplitted[i]) && i === index + 1) {
                  urbSplittedName.push(stringSplitted[i]);
                } else {
                  break;
                }
              }
            }
            district = getDistrictOfUrbanization(urbSplittedName.join(' ').trim().toUpperCase());
            if (district) {
              districtFounded = true;
            }
          }
        }
      });
      return district.toLowerCase();
    }

    function sendDistrictConfig() {
      return configs.sendAdministrativeAreaLv3;
    }
  }

})();

(function(){
'use strict';

angular
  .module('icarus.planner')
  .factory('alertNotificationService', alertNotificationService);

/** @ngInject */
function alertNotificationService($rootScope, $window){

  var service = {
    addAlertNotification: addAlertNotification,
    removeAlertNotification: removeAlertNotification
  };

  $window.alertNotificationService = service;
  return service;

  //////////

  function addAlertNotification(obj){
    $rootScope.$broadcast('NEW_ALERT_NOTIFICATION', {notification: obj});
  }

  function removeAlertNotification(){
    $rootScope.$broadcast('DELETE_ALERT_NOTIFICATION');
  }

}
})();

(function () {
  'use strict';

  /**
   * VisitsImport component Controller
   * @param {Object} $filter $filter directive
   * @param $scope
   */
  function visitsImportController ($filter, $scope) {
    var ctrl = this;

    ctrl.$translate = $filter('translate');
    ctrl.$scope = $scope;

    ctrl.isDisabledSubmitButton = false;
    var visitStatusList = ctrl.data.visitStatusList;
    ctrl.visitsStatusEnabled = visitStatusList.length > 0;
    var visitTypeList = ctrl.data.visitTypeList.map(function (visitType) {
      return angular.merge({}, visitType);
    });
    ctrl.visitsTypeEnabled = visitTypeList.length > 0;

    ctrl.allImportOptionsTitle = ctrl.$translate('Visits.component_visits_import.visits_list_option_all');

    ctrl.statusOptionsColumnTitle = ctrl.$translate('Visits.component_visits_import.select_visit_status');
    ctrl.statusOptionsList = ctrl.visitsStatusEnabled ? (visitStatusList || []) : [];
    ctrl.selectedStatusOptionsCounter = ctrl.statusOptionsList.length;
    ctrl.statusAllImportOptionsEnabled = ctrl.selectedStatusOptionsCounter === ctrl.statusOptionsList.length;
    
    ctrl.typeOptionsColumnTitle = ctrl.$translate('Visits.component_visits_import.select_visit_type');
    ctrl.typeOptionsList = ctrl.visitsTypeEnabled ? (visitTypeList || []) : [];
    ctrl.selectedTypeOptionsCounter = ctrl.typeOptionsList.length;
    ctrl.typeAllImportOptionsEnabled = ctrl.selectedTypeOptionsCounter === ctrl.typeOptionsList.length;

    ctrl.getVisits = getVisits;

    /**
     * Create a function to handle the select all check for status or type options
     * @param {String} optionType Status or type
     * @returns {Function} Function to handle the select all check
     */
    function createAllOptionsHandler(optionType) {
      return function() {
        const listVar = optionType.toLowerCase() + 'OptionsList';
        const allEnabledVar = optionType.toLowerCase() + 'AllImportOptionsEnabled';
        const counterVar = 'selected' + optionType + 'OptionsCounter';
        
        ctrl[listVar].forEach(function (option) {
          option.selected = ctrl[allEnabledVar];
        });
          
        ctrl[counterVar] = ctrl[allEnabledVar] ? ctrl[listVar].length : 0;
        
        _handleSubmitButtonDisabled();
      };
    }

    /**
     * Create a function to handle the import option check for status or type options
     * @param {String} optionType Status or type
     * @returns {Function} Function to handle the import option check
     */
    function createOptionHandler(optionType) {
      return function(option) {
        const counterVar = 'selected' + optionType + 'OptionsCounter';
        const listVar = optionType.toLowerCase() + 'OptionsList';
        const allEnabledVar = optionType.toLowerCase() + 'AllImportOptionsEnabled';
        
        ctrl[counterVar] += option.selected ? 1 : -1;
        ctrl[allEnabledVar] = ctrl[counterVar] === ctrl[listVar].length;
        _handleSubmitButtonDisabled();
      };
    }

    ctrl.handleStatusAllImportOptionsCheck = createAllOptionsHandler('Status');
    ctrl.handleTypeAllImportOptionsCheck = createAllOptionsHandler('Type');
    ctrl.handleStatusImportOptionCheck = createOptionHandler('Status');
    ctrl.handleTypeImportOptionCheck = createOptionHandler('Type');

    if (ctrl.visitsTypeEnabled) {
      ctrl.typeOptionsList.push({
        id: 'null',
        key: 'null',
        label: ctrl.$translate('Visits.component_visits_import.no_visit_type')
      });
      ctrl.handleTypeAllImportOptionsCheck();
    }

    if (ctrl.visitsStatusEnabled) {
      ctrl.handleStatusAllImportOptionsCheck();
    }

    /**
      * Validate date range
      * @param {Object} calendar calendar object
      * @returns {Boolean} true if the calendar is valid, false otherwise
    */

     ctrl.dateRangeError = false;

    ctrl.validateDateRange = function() {
      ctrl.dateRangeError = false;
      ctrl.dateOrderError = false;

      if (ctrl.data.calendar.startDate && ctrl.data.calendar.endDate) {
        var start = new Date(ctrl.data.calendar.startDate);
        var end = new Date(ctrl.data.calendar.endDate);

        if (end < start) {
          ctrl.dateOrderError = true;
          ctrl.isDisabledSubmitButton = true;
          return;
        }

        var diffDays = (end - start) / (1000 * 60 * 60 * 24);
        ctrl.dateRangeError = diffDays > 30;
      }

      ctrl.isDisabledSubmitButton = ctrl.dateRangeError || ctrl.dateOrderError;
      if (!ctrl.dateRangeError && !ctrl.dateOrderError) {
        _handleSubmitButtonDisabled();
      }
    };

    /**
     * trigger onGetVisits callback with the filter params
     * @param {String} date date as string format YYYY-MM-DD
     */
    function getVisits() {
      var params = {
        start_date: ctrl.data.calendar.startDate,
        end_date: ctrl.data.calendar.endDate,
      };

      if (ctrl.visitsStatusEnabled) {
        params.status = _getStatusOptionsParams();
      }

      if (ctrl.visitsTypeEnabled) {
        params.visitTypes = _getTypeOptionsParams();
      }

      ctrl.onGetVisits(params);
    }

    /**
     * Status handler of isDisabledSubmitButton and the import options
     * when the allImportOptionsEnabled is changed
     */
    function _handleSubmitButtonDisabled() {
      ctrl.isDisabledSubmitButton = (ctrl.visitsStatusEnabled && ctrl.selectedStatusOptionsCounter === 0) || (ctrl.visitsTypeEnabled && ctrl.selectedTypeOptionsCounter === 0);
    }

    /**
     * Convert the selected import options in a param value.
     * @returns {String} import options like params
     */
    function _getStatusOptionsParams() {
      var statusOptionsSelected = ctrl.statusOptionsList.reduce(function (statusOptionsList, statusOption) {
        if (statusOption.selected) {
          statusOptionsList.push(statusOption.id);
        }
        return statusOptionsList;
      }, []);
      return statusOptionsSelected.join(',');
    }

    /**
     * Convert the selected import options in a param value.
     * @returns {String} import options like params
     */
    function _getTypeOptionsParams() {
      var typeOptionsSelected = ctrl.typeOptionsList.reduce(function (typeOptionsList, typeOption) {
        if (typeOption.selected) {
          typeOptionsList.push(typeOption.id);
        }
        return typeOptionsList;
      }, []);
      return typeOptionsSelected.join(',');
    }
  }

  var visitsImport = {
    templateUrl: 'app/planner/components/visitsImport.html',
    controller: ['$filter', '$scope', visitsImportController],
    bindings: {
      data: '<',
      onGetVisits: '&'
    }
  };

  angular
    .module('icarus.planner')
    .component('visitsImport', visitsImport);

})();

(function () {
  'use strict';

  function infoBoxController () {
    var ctrl = this;

    ctrl.close = function () {
      ctrl.callToClose({'visitId': ctrl.data.visitObj.id});
    };
  }

  var infoBox = {
    templateUrl: 'app/planner/components/infoBox.html',
    controller: infoBoxController,
    bindings: {
      data: '<',
      callToClose: '&',
      viewCollapse: '<'
    }
  };

  angular
    .module('icarus.planner')
    .component('infoBox', infoBox);

})();

(function () {
  'use strict';

  function errorFinishModalController () {
    var ctrl = this;
  }

  var errorFinishModal = {
    templateUrl: 'app/planner/components/errorFinishModal.html',
    controller: errorFinishModalController,
    bindings: {
      data: '<'
    }
  };

  angular
    .module('icarus.planner')
    .component('errorFinishModal', errorFinishModal);

})();

(function () {
  'use strict';

  function breadCrumbsController (plannerService) {
    var ctrl = this;
    ctrl.changeStep = changeStep;

    function changeStep(state) {
      if (plannerService.isPlanEditable()) {
        ctrl.onChangeStep({state: state});
      }
    }
  }

  var breadCrumbs = {
    templateUrl: 'app/planner/components/breadCrumbs.html',
    controller: ['plannerService', breadCrumbsController],
    bindings: {
      data: '<',
      onChangeStep: '&'
    }
  };

  angular
    .module('icarus.planner')
    .component('breadCrumbs', breadCrumbs);

})();

/*
Ejemplo de uso del filtro:
<span> {vehicle.skills | searchVehicleFilter}</span>
*/

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .filter('searchVehicleFilter', searchVehicleFilter);

  /** @ngInject */
  function searchVehicleFilter() {
    return function (vehicles, filterHandler) {
      return filterHandler.activeFilter
        ? vehicles.filter(function (vehicle) {
            return filterHandler.vehicles[vehicle.id];
          }) 
        : vehicles;
    };
  }
})();

/*
Ejemplo de uso del filtro:
<span> {vehicle.skills | searchVehicleFilter}</span>
*/

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .filter('searchRouteFilter', searchRouteFilter);

  /** @ngInject */
  function searchRouteFilter() {
    return function (routes, filterHandler) {
      return filterHandler.activeFilter
        ? routes.filter(function (route) {
            return filterHandler.routes[route.id];
          }) 
        : routes;
    };
  }
})();

/*
Ejemplo de uso del filtro:
<div ng-repeat="o in visits | plannerVisitsStatusFilter:2:'name'">
</div>
*/

(function() {
	'use strict';

	angular
		.module('icarus.planner')
		.filter('plannerVisitsStatusFilter', plannerVisitsStatusFilter);

  /** @ngInject */
  function plannerVisitsStatusFilter(){
    return function (visits, status, orderBy) {

      if (visits === null) {
        return;
      }

      status = status || 1; //Tengo pensado 1:All, 2:Warnings, 3:errors
      orderBy = orderBy || "title";

      return visits.filter(filterByStatus(status))
            .sort(sortByField(orderBy));
    };

    function filterByStatus(status) {
      return function (visit) {
        if (status === 1) {
          return true;
        }

        if ('status' in visit && visit.status === status) {
          return true;
        } else {
          return false;
        }
      };
    }

    function sortByField(field){
      return function(a,b) {
        if (a.status < b.status) {
          return 1;
        }
        if (a.status > b.status) {
          return -1;
        }
        if (a[field] < b[field]) {
          return -1;
        }
        if (a[field] > b[field]) {
          return 1;
        }
        return 0;
      };
    }
  }

})();

/*
Ejemplo de uso del filtro:
<span> {vehicle.skills | plannerCommaSeparatedArrayFilter}</span>
*/

(function() {
  'use strict';

  angular
    .module('icarus.planner')
    .filter('plannerCommaSeparatedArrayFilter', plannerCommaSeparatedArrayFilter);

  /** @ngInject */
  function plannerCommaSeparatedArrayFilter($log, plannerService){
    return function (skills) {

      if (!skills || skills.length === 0) {
        return;
      }

      var skillsNames = [];

      angular.forEach(skills,function(skillId){
        if (skillId) {
          var skill = plannerService.skills.filter(plannerService.getSkillById(skillId));
          if (skill.length > 0) {
            skillsNames.push(skill[0].name);
          }
          
        }
      });

      return skillsNames.join(', ');
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .filter('matchingStartVehicleFilter', matchingStartVehicleFilter);

  /** @ngInject */
  function matchingStartVehicleFilter(
    accountConfigsService, plannerService, ACCOUNT_CONFIGS
  ) {

    function getComparatorKey(vehicle) {
      return vehicle.shift.start + vehicle.locationStart.address;
    };

    return function (vehicles, currentVehicle) {
      if (!accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.DISABLE_EDIT_FOR_ACTIVE_AND_FINISHED_ROUTES)) {
        return vehicles;
      }
      if (!plannerService.hasVehicleRoutesProcessed(currentVehicle)) {
        return vehicles;
      }
      var currentVehicleKey = getComparatorKey(currentVehicle);
      return vehicles.filter(function (vehicle) {
        var vehicleKey = getComparatorKey(vehicle);
        return currentVehicleKey === vehicleKey;
      });
    };
  }
})();

/* global angular */

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .directive('ngEnter', ngEnter);

  /** @ngInject */
  function ngEnter () {
    return function(scope, element, attrs) {
      element.bind("keydown keypress", function(event) {
        if(event.which === 13) {
          scope.$apply(function(){
            scope.$eval(attrs.ngEnter, {'event': event});
          });

          event.preventDefault();
        }
      });
    };
  }

})();/**
 * Created by Sergio on 12-08-16.
 */

/* global angular */
/**
 * Usage:
 * <alert-notification></alert-notification>
 */
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .directive('alertNotification', alertNotification);

  /** @ngInject */
  function alertNotification () {
    return {
      restrict: 'E',
      templateUrl: 'app/planner/directives/alert-notification-template.html',
      scope: {},
      link: function ($scope) {
        $scope.notification = null;
        $scope.hideFlag = false;
        $scope.hide = hide;

        $scope.$on('NEW_ALERT_NOTIFICATION', addNotification);
        $scope.$on('DELETE_ALERT_NOTIFICATION', deleteNotification);

        function addNotification(e, data) {
          $scope.hideFlag = false;
          $scope.notification = data.notification;
        }

        function deleteNotification(e) {
          $scope.notification = null;
        }

        function hide() {
          $scope.hideFlag = true;
        }
      }
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .constant('VISIT_CARDS_PER_PAGE', 500)
    .constant('VISIT_FOR_ROUTING_CARDS_PER_PAGE', 250)
    .constant('FILTER_ADDRESS_ATTR', 'address')
    .constant('FILTER_TITLE_ATTR', 'title')
    .constant('FILTER_REFERENCE_ATTR', 'reference')
    .constant('VISIT_OUT_OF_ROUTE_DEFAULT_COLOR', '#A4A4A4')
    .constant('VISIT_OUT_OF_ROUTE_ORDER', null)
    .constant('VISIT_OUT_OF_ROUTE_VISUAL_STATE_ID', 'outOfRoutes')
    .constant('VISIT_GEOCODE_ALERT', {
      'ERROR_COUNTRY': 'different_country',
      'ERROR_DISTANCE': 'depot_too_far',
      'ERROR_AREA_CENTER': 'center_area_level_3',
      'ERROR_WRONG_AREA': 'different_area_level_3',
      'ERROR_HIGH': 'high',
      'ERROR_MEDIUM': 'medium',
      'ERROR_LOW': 'low',
      'NO_ALERT': 'no_alert'
    })
    .constant('VISIT_STATUS', {
      'STATUS_ERROR': 4,
      'STATUS_WARNING_ORANGE': 3,
      'STATUS_WARNING_YELLOW': 2,
      'STATUS_OK': 1
    })
    .constant('ROUTES_REOPTIMIZATION_EVENT', 'Re-optimizar rutas paso 2')
    .constant('REOPTIMIZE_AND_OVERWRITE_PLAN', 'REOPTIMIZE_AND_OVERWRITE_PLAN')
    .constant('KEEP_PLAN_AND_REOPTIMIZE', 'KEEP_PLAN_AND_REOPTIMIZE')
    .constant('REOPTIMIZE_PARTIALS', 'REOPTIMIZE_PARTIALS')
    .constant('OPTION_FOR_HEAP', {
      'OVERWRITE_ROUTES': 'Overwrite routes',
      'KEEP_ROUTES': 'Keep routes',
      'INCREMENTAL_ROUTING': 'Incremental routing'
    })
    .constant('VISIT_TABS', {
      'DETAILS': 'details',
      'ITEMS': 'items'
    })
    .constant('VISIT_SOURCE', {
      'CLIENT': 'CLIENT'
    })
    .constant('VISIT_ADDRESS_STATUS', {
      'USED': 'used',
      'NEW': 'new',
      'FAILED': 'warn_qty_failed',
      'WARN_DIFF_LOC': 'warn_diff_loc'
    })
    .constant("VISIT_ADDRESS_STATUS_ICON_URL", {
      'used': '/assets/images/pin.svg',
      'new': '/assets/images/pin.svg',
      'warn_qty_failed': '/assets/images/alert.svg',
      'warn_diff_loc': '/assets/images/magic.svg'
    })
    .constant("VISIT_TYPE", {
      VISIT: "visit",
      EVENT: "event"
    })
    .constant("SEQUENCER_ROUTING_OPTIONS", {
      'DEFAULT': 0,
      'RADIAL': 1,
      'PRIORITIZE_LOAD': 2,
    });
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .constant('ROUTE_VISIBLE_OPACITY', 1.0)
    .constant('ROUTE_TRANSLUCENT_POLYGON_OPACITY', 0.2)
    .constant('ROUTE_PROPERTIES_MAX_BATCH_SIZE', 100)
    .constant('ROUTE_POLYGON_FILL_OPACITY', 0.35)
    .constant('ROUTE_PROCESSED_STATUSES', ['completed', 'finished', 'started'])
    .constant('ROUTE_FINISHED_STATUSES', ['completed', 'finished'])
    .constant('ROUTE_REVISED_OPACITY', 0.6)
    .constant('DRIVER_NAME_MAX_LENGTH', 60);
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .constant('VISIT_PICKUP_AND_DELIVERY_BATCH_SIZE', 180)
    .constant('DEPOT_KEY', 'DEPOT')
    .constant('ENABLE_PICKUP_AND_DELIVERY_MODE', 'enable_pickup_and_delivery_mode')
    .constant('RELATIONSHIP_TYPE', {
      'DELIVERY': 'DELIVERY',
      'PICK': 'PICK'
    });
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .constant('ITEMS_SUMMARY_ICON_PATH', '/assets/images/items.svg')
    .constant('MAX_ITEMS_IN_SUMMARY_LIST', 5)
    .constant('ITEMS_SUMMARY_LIST_SEPARATOR', '-')
    .constant('ITEMS_SUMMARY_BASE_TRANSLATE_PATH', 'Items_summary.')
    .constant('PAGINATION_OF_VISIT_ITEMS', {
      'CURRENT_PAGE': 1,
      'ITEMS_PER_PAGE': 12,
      'MAX_SIZE': 3,
    })
    .constant('ITEM_PROPERTIES', {
      'TITLE': 'title',
      'QUANTITY_PLANNED': 'quantity_planned'
    });
})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .constant('EVENT_CREATE_MARKERS_LIGHT_FROM_ARRAY', 'Planner:CreateMarkersLightFromArray:Visit')
    .constant('EVENT_CREATE_VISITS_FROM_ARRAY', 'Planner:CreateVisitsFromArray:Visit')
    .constant('EVENT_REMOVE_VISITS_FROM_ARRAY', 'Planner:RemoveVisitsFromArray:Visit')
    .constant('EVENT_CLEAR_ROUTES_GROUP_MARKERS', 'Planner:ClearRoutesGroupMarkers:Route')
    .constant('EVENT_ROUTE_CREATE', 'Planner:Route:Create')
    .constant('EVENT_ROUTE_UPDATE', 'Planner:Route:Update')
    .constant('EVENT_ROUTE_REMOVE', 'Planner:Route:Remove')
    .constant('EVENT_CLICK', 'click')
    .constant('EVENT_CONTEXTMENU', 'contextmenu')
    .constant('EVENT_MOUSEOVER', 'mouseover')
    .constant('EVENT_MOUSEOUT', 'mouseout')
    .constant('EVENT_DRAGEND', 'dragend')
    .constant('EVENT_WHEEL', 'wheel')
    .constant('EVENT_RECALCULATE_STATISTICS', 'Planner:Plan:recalculate-statistics');
})();

(function() {
    'use strict';
  
    angular
      .module('icarus')
      .factory('helperMap', helperMap);
  
    function helperMap($window) {
      var map = {
        sign : sign
      };
      $window.helperMap = map;
      return map;
      function removeWebSafe(safeEncodedString) {
        return safeEncodedString.replace(/-/g, "+").replace(/_/g, "/");
      }
      function makeWebSafe(encodedString) {
        return encodedString.replace(/\+/g, "-").replace(/\//g, "_");
      }
      function decodeBase64Hash(base64) {
        return CryptoJS.enc.Base64.parse(base64);
      }
      function encodeBase64Hash(key, path) {
        var hash = CryptoJS.HmacSHA1(path, key);
        return CryptoJS.enc.Base64.stringify(hash);
      }
    /** @ngInject */
      function sign(path, secret) {
        var safeSecret = decodeBase64Hash(removeWebSafe(secret));
        var hashedSignature = makeWebSafe(encodeBase64Hash(safeSecret, path));
        return path + "&signature=" + hashedSignature;
      }
    }
  })();
  
(function() {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('helperExcel', helperExcel);

  function helperExcel($window, XLSX) {
    var excel = {
      sheet_to_json_simpli : sheet_to_json_simpli
    };
    $window.helperExcel = excel;
    return excel;
  /** @ngInject */
    function sheet_to_json_simpli(sheet, opts) {
      var val, row, range, header = 0, offset = 1, r, hdr = [], isempty, R, C, v, vv;
      var o = opts != null ? opts : {};
      var raw = o.raw;
      if(sheet == null || sheet["!ref"] == null) return [];
      range = o.range != null ? o.range : sheet["!ref"];
      if(o.header === 1) header = 1;
      else if(o.header === "A") header = 2;
      else if(Array.isArray(o.header)) header = 3;

      switch(typeof range) {
        case 'string': r = XLSX.utils.decode_range(range); break;
        case 'number': r = XLSX.utils.decode_range(sheet["!ref"]); r.s.r = range; break;
        default: r = range;
      }
      if(header > 0) offset = 0;
      var rr = XLSX.utils.encode_row(r.s.r);
      var cols = new Array(r.e.c-r.s.c+1);
      var out = new Array(r.e.r-r.s.r-offset+1);
      var outi = 0;
      for(C = r.s.c; C <= r.e.c; ++C) {
        cols[C] = XLSX.utils.encode_col(C);
        val = sheet[cols[C] + rr];
        switch(header) {
          case 1:
            hdr[C] = C;
            break;
          case 2:
            hdr[C] = cols[C];
            break;
          case 3:
            hdr[C] = o.header[C - r.s.c];
            break;
          default:
            if(val == null) continue;
            vv = v = XLSX.utils.format_cell(val);
            var counter = 0;
            for(var CC = 0; CC < hdr.length; ++CC) if(hdr[CC] == vv) vv = v + "_" + (++counter);
            hdr[C] = vv;
        }
      }

      for (R = r.s.r + offset; R <= r.e.r; ++R) {
        rr = XLSX.utils.encode_row(R);
        isempty = true;
        if(header === 1) row = [];
        else {
          row = {};
          if(Object.defineProperty) {
            try {
              Object.defineProperty(row, '__rowNum__', {value: R, enumerable: false});
            } catch (e) {
              row.__rowNum__ = R;
            }
          }
          else row.__rowNum__ = R;
        }
        for (C = r.s.c; C <= r.e.c; ++C) {
          val = sheet[cols[C] + rr];
          if(val === undefined || val.t === undefined) continue;
          v = val.v;
          switch(val.t){
            case 'z':
              continue;
            case 'e':
              continue;
            case 's':
            case 'd':
            case 'b':
            case 'n':
              break;
            default: throw new Error('unrecognized type ' + val.t);
          }
          if(v !== undefined) {
            if(o.rawColum === cols[C]){
              row[hdr[C]] = raw ? v : v.toString();
            } else {
              row[hdr[C]] = raw ? v : XLSX.utils.format_cell(val,v,o);
            }
            isempty = false;
          }
        }
        if(!isempty || header === 1) {
          out[outi++] = row;
        }
      }
      out.length = outi;
      return out;
    }
  }
})();

(function () {
  "use strict";

  angular.module("icarus").factory("helperColor", helperColor);

  function helperColor($window) {
    var color = {
      lightenDarkenColor: lightenDarkenColor
    };

    $window.helperColor = color;

    return color;

    /*
     * Lighten or darken a color
     *
     * @param {string} col - A color in hex format
     * @param {integer} amt - Number between -255 and 255
     * @return {string} - A color in hex format
     */

    /** @ngInject */
    function lightenDarkenColor(col, amt) {
      var usePound = false;

      if (col[0] === "#") {
        col = col.slice(1);
        usePound = true;
      }

      var num = parseInt(col, 16);

      var r = (num >> 16) + amt;

      if (r > 255) {
        r = 255;
      } else if (r < 0) {
        r = 0;
      }

      var b = ((num >> 8) & 0x00ff) + amt;

      if (b > 255) {
        b = 255;
      } else if (b < 0) {
        b = 0;
      }

      var g = (num & 0x0000ff) + amt;

      if (g > 255) {
        g = 255;
      } else if (g < 0) {
        g = 0;
      }

      return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('icarus')
    .controller('VisitsGraphicsController', VisitsGraphicsController);

  /** @ngInject */
  function VisitsGraphicsController($log, $filter, $timeout, moment, lodash, dashboardService, timeUtils, PermissionToGraphics,
                                    accountConfigsService, ACCOUNT_CONFIGS, __env, $state, VISIT_DASHBOARD) {

    var vm = this;


    var $translate = $filter('translate');
    var MONTH_DATE_FORMAT = 'YYYY-MM';
    var MONTH_DATE_NAME_FORMAT = 'MMMM YYYY';
    var TOTAL_MONTHS = 5;

    // Constants for improved data Indicator
    var PERCE_DATA_LIMIT = "999%";
    var ICON_DEFAULT = "glyphicon glyphicon-minus icon";
    var ICON_UP = "glyphicon glyphicon-arrow-up icon";
    var ICON_DOWN = "glyphicon glyphicon-arrow-down icon";
    var CLASS_DOWN = "down";
    var CLASS_UP = "up";
    var CLASS_ZERO = "zero";

    // Load icons
    var ICON_LOAD_1 = 'sp-icon-carga-peso';
    var ICON_LOAD_2 = 'sp-icon-carga-volumen';
    var ICON_LOAD_3 = 'sp-icon-carga-valor';
    var colorsPallete = [
      '#F34235',
      '#C41061',
      '#A900FF',
      '#6100E9',
      '#2861FF',
      '#00B7D3',
      '#00C853',
      '#AEEA00',
      '#FFD600',
      '#FF6D00',
      '#DD2C00',
      '#880E4F',
      '#1A237E',
      '#006064',
      '#BF360C',
      '#76FF03',
      '#005EFF',
      '#BA68C8',
      '#FF5252',
      '#33691E'
    ];

    var monthSelected = {
      id: moment(moment().toDate()).format(MONTH_DATE_FORMAT),
      name: moment(moment().toDate()).format(MONTH_DATE_NAME_FORMAT)
    };

    var TYPE_OBSERVATION_DEFAULT = 'failed';

    //Load Indicators event icons
    var eventIcons = [{
      icon: ICON_LOAD_1,
      indicatorName: 'percLoad1',
      clickEvent: changeIndicator,
      active: true
    }, {
      icon: ICON_LOAD_2,
      indicatorName: 'percLoad2',
      clickEvent: changeIndicator,
      active: false
    }, {
      icon: ICON_LOAD_3,
      indicatorName: 'percLoad3',
      clickEvent: changeIndicator,
      active: false
    }];

    var vehicleLoadIndicators = {
      percLoad1: {
        title: $translate('Dashboard.Indicators.vehicle_average_load_title'),
        value: '-',
        dataUp: false,
        dataDown: false,
        dataZero: true,
        perceChange: '0%',
        classDiv: CLASS_ZERO,
        classIcon: ICON_DEFAULT,
        eventIcons: eventIcons
      },
      percLoad2: {
        title: $translate('Dashboard.Indicators.vehicle_average_load_title'),
        value: '-',
        dataUp: false,
        dataDown: false,
        dataZero: true,
        perceChange: '0%',
        classDiv: CLASS_ZERO,
        classIcon: ICON_DEFAULT,
        eventIcons: eventIcons
      },
      percLoad3: {
        title: $translate('Dashboard.Indicators.vehicle_average_load_title'),
        value: '-',
        dataUp: false,
        dataDown: false,
        dataZero: true,
        perceChange: '0%',
        classDiv: CLASS_ZERO,
        classIcon: ICON_DEFAULT,
        eventIcons: eventIcons
      }
    };

    vm.isDOMRender = false;
    vm.monthDates = [];
    vm.reportsDate = monthSelected;
    vm.graphics = {
      "bars": {
        "options": {
          chart: {
            type: 'multiBarChart',
            height: 350,
            margin: {
              top: 20,
              right: 0,
              bottom: 60,
              left: 0
            },
            clipEdge: true,
            staggerLabels: false,
            transitionDuration: 1000,
            tooltips: true,
            tooltipContent: function (key, x, y) {
              return '<p>' + key + ': ' + y + '</p>';
            },
            stacked: true,
            showControls: false,
            xAxis: {
              showMaxMin: false,
              tickFormat: function (d) {
                return (new Date(d)).getUTCDate();
              }
            },
            yAxis: {
              axisLabelDistance: 100,
              tickFormat: function (d) {
                return d3.format(',.f')(d);
              }
            },
            showLegend: false,
            showYAxis: false,
            reduceXTicks: false
          }
        },
        "data": []
      },
      "pies": {
        "type": "failed",
        "typeFailedActive": true,
        "options": {
          chart: {
            type: "pieChart",
            height: 282,
            donut: true,
            x: function (d) {
              return d.key;
            },
            y: function (d) {
              return d.y;
            },
            duration: 500,
            legend: {
              margin: {
                top: 5,
                right: 140,
                bottom: 5,
                left: 0
              }
            },
            showLegend: false,
            showLabels: false
          }
        },
        data: []
      },
      "area": {
        "options": {
          chart: {
            showLegend: false,
            type: 'multiChart',
            height: 250,
            reduceXTicks: false,
            yAxis2: {
              show: false,
              showMaxMin: false
            },
            yAxis1: {
              show: false,
              showMaxMin: false
            },
            margin: {
              top: 20,
              right: 20,
              bottom: 30,
              left: 40
            },
            color: d3.scale.category10().range(),
            useInteractiveGuideline: true,
            xAxis: {
              showMaxMin: false
            }
          }
        },
        data: [
          {
            "type": "area",
            "yAxis": 1,
            "key": $translate('Dashboard.checkoutGraph.visits_total'),
            "showYAxis": false,
            "color": "#B6BEC1",
            "values": []
          },

          {
            "type": "line",
            "yAxis": 1,
            "key": $translate('Dashboard.checkoutGraph.visits_window'),
            "showYAxis": false,
            "color": "#28BAA4",
            "values": []
          }
        ]
      }
    };
    vm.indicators = {
      totalVisits: {
        title: $translate('Dashboard.Indicators.total_visits_title'),
        value: '-',
        dataUp: false,
        dataDown: false,
        dataZero: true,
        perceChange: '0%',
        classDiv: CLASS_ZERO,
        classIcon: ICON_DEFAULT,
        eventIcons: []
      },
      maxVehicles: {
        title: $translate('Dashboard.Indicators.max_vehicles_title'),
        value: '-',
        dataUp: false,
        dataDown: false,
        dataZero: true,
        perceChange: '0%',
        classDiv: CLASS_ZERO,
        classIcon: ICON_DEFAULT,
        eventIcons: []
      },
      completedVisits: {
        title: $translate('Dashboard.Indicators.visits_completed_title'),
        value: '-',
        dataUp: false,
        dataDown: false,
        dataZero: true,
        perceChange: '0%',
        classDiv: CLASS_ZERO,
        classIcon: ICON_DEFAULT,
        eventIcons: []
      },
      checkoutVisitsInTimeWindow: {
        title: $translate('Dashboard.Indicators.checkouts_in_time_window_title'),
        value: '-',
        dataUp: false,
        dataDown: false,
        dataZero: true,
        perceChange: '0%',
        classDiv: CLASS_ZERO,
        classIcon: ICON_DEFAULT,
        eventIcons: []
      },
      activeLoad: {
        title: $translate('Dashboard.Indicators.perc_load_1_title'),
        value: '-',
        dataUp: false,
        dataDown: false,
        dataZero: true,
        perceChange: '0%',
        classDiv: CLASS_ZERO,
        classIcon: ICON_DEFAULT,
        eventIcons: eventIcons
      }
    };
    vm.userWithoutDashboard = false;

    vm.populateMonthSelect = populateMonthSelect;
    vm.updateReports = updateReports;
    vm.changeView = changeView;
    vm.changeIndicator = changeIndicator;

    activate();

    function activate() {
      vm.disableExternalDashboards = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.DISABLE_EXTERNAL_DASHBOARDS);
      if (__env.ENABLE_EXTERNAL_DASHBOARDS_FEATURE && !vm.disableExternalDashboards) {
        $state.go('dashboard.external', {dashboardId: VISIT_DASHBOARD});
      }
      PermissionToGraphics ? startGraphics() : startUserWithoutGraphics();
    }

    function startGraphics() {
      renderDom();
      vm.populateMonthSelect();
      updateReports();
    }

    function startUserWithoutGraphics() {
      vm.userWithoutDashboard = true;
    }

    function renderDom() {
      $timeout(function () {
        vm.isDOMRender = true;
      }, 0);
    }

    function changeIndicator(index) {
      eventIcons.forEach(function (eventIcon) {
        eventIcon.active = eventIcon.indicatorName === index;
      });
      vm.indicators.activeLoad = vehicleLoadIndicators[index];
      vm.indicators.activeLoad.eventIcons = eventIcons;
    }

    function populateMonthSelect() {
      vm.monthDates.push(monthSelected);
      for (var i = 1; i <= TOTAL_MONTHS; i++) {
        var month = {
          id: moment(moment().toDate()).subtract(i, 'months').format(MONTH_DATE_FORMAT),
          name: moment(moment().toDate()).subtract(i, 'months').format(MONTH_DATE_NAME_FORMAT)
        };
        vm.monthDates.push(month);
      }
    }

    function updateReports() {
      getVisitData(vm.reportsDate.id);
      getPieGraphData(vm.reportsDate.id, TYPE_OBSERVATION_DEFAULT);
      getVisitCheckoutData();
      getVehicleTotalsData();
    }

    function changeView(type) {
      type = type === 'completed' ? 'failed' : 'completed';
      vm.graphics.pies.typeFailedActive = type !== 'completed';
      getPieGraphData(vm.reportsDate.id, type);
    }

    //////////////////////////////////////////
    // Privates Methodsº
    /////////////////////////////////////////

    // function Graph donuts Visits observation

    function getPieGraphData(date, type) {
      var dateSplitted = date.split('-');
      dashboardService.getVisitsObservations(dateSplitted[0], dateSplitted[1], type)
        .then(function success(data) {
          var observations = data.data.map(function (observation, index) {
            observation.color = (colorsPallete[index]) ? colorsPallete[index] : null;
            return observation;
          });
          vm.graphics.pies.data = generatePieGraphData(observations);
          vm.graphics.pies.type = type;
          vm.graphics.pies.total = calculatePieDataTotal(data.data);
        })
        .catch(function error(e) {
          $log.error(e);
        });
    }

    function calculatePieDataTotal (data) {
      return (data.length > 0) ? data.reduce(function (a, b) {
        return {total: a.total + b.total};
      }) : 0;
    }

    function generatePieGraphData(data) {
      var pieGraphData = [];
      data.forEach(function (item) {
        var obj = {
          key: item.name,
          y: item.total
        };
        if(item.color) {
          obj.color = item.color;
        }
        pieGraphData.push(obj);
      });
      return pieGraphData;
    }


    // function Indicator Visits Total

    function sumVisits(data) {
      var visitsValues = {
        totalVisits: 0,
        completedVisits: 0
      };
      data.forEach(function (value) {
        visitsValues.totalVisits += value.total_completed + value.total_failed + value.total_pending;
        visitsValues.completedVisits += value.total_completed;
      });

      return visitsValues;
    }

    function setPercValue(value) {
      return value ? value.toFixed(0) + '%' : '-';
    }

    function completedVisitsPerc(completedVisits, totalVisits) {
      var visitsPerc = totalVisits ? completedVisits * 100 / totalVisits : 0;
      return setPercValue(visitsPerc);
    }

    function generateVisitsIndicatorsData(data) {
      var visitsData = sumVisits(data);
      vm.indicators.totalVisits.value = visitsData.totalVisits ? visitsData.totalVisits : '-';
      vm.indicators.completedVisits.value = completedVisitsPerc(visitsData.completedVisits, visitsData.totalVisits);
    }

    // funcion Graph Bar Visits Total
    function generateBarGraphData(year, month, data) {
      var values = [];
      var values0 = [];
      var values1 = [];
      var datesObj = getMonthDateRange(parseInt(year), parseInt(month));
      var quantityOfDays = datesObj.end.diff(datesObj.start, 'days') + 1;
      for (var i = 1; i <= quantityOfDays; i++) {
        var day = (String(i).length === 1) ? '0' + i : i;
        var date = year + '-' + month + '-' + day;
        var arrayObj = $filter("filter")(data, {date: date});
        if (arrayObj.length === 0) {
          values.push({
            x: date,
            y: 0
          });
          values0.push({
            x: date,
            y: 0
          });
          values1.push({
            x: date,
            y: 0
          });
        } else {
          arrayObj.map(function (visitTotalsRow) {
            values.push({
              x: visitTotalsRow.date,
              y: visitTotalsRow.total_pending
            });
            values0.push({
              x: visitTotalsRow.date,
              y: visitTotalsRow.total_failed
            });
            values1.push({
              x: visitTotalsRow.date,
              y: visitTotalsRow.total_completed
            });
          });
        }
      }

      return [
        {
          key: $translate('Dashboard.BarGraph.visits_failed'),
          color: '#e74c3c',
          values: values0
        },
        {
          key: $translate('Dashboard.BarGraph.visits_pending'),
          color: '#7f8c8d',
          values: values
        }, {
          key: $translate('Dashboard.BarGraph.visits_completed'),
          color: '#1abc9c',
          values: values1
        }];
    }

    function getMonthDateRange(year, month) {
      var startDate = moment([year, month - 1]);

      // Clone the value before .endOf()
      var endDate = moment(startDate).endOf('month');

      // make sure to call toDate() for plain JavaScript date type
      return {start: startDate, end: endDate};
    }

    function getVisitData(date) {
      var dateSplitted = date.split('-');
      getVisitTotals(dateSplitted[0], dateSplitted[1])
        .then(function success(data) {
          vm.graphics.bars.data = generateBarGraphData(dateSplitted[0], dateSplitted[1], data.data);
          generateVisitsIndicatorsData(data.data);
          getImprovedDataVisits();
        })
        .catch(function error(e) {
          $log.error(e);
        });
    }

    function getVisitTotals(year, month) {
      return dashboardService.getVisitTotals(year, month);
    }


    // function Graph Area Window Time Visits Checkouts
    function fillCheckoutData(data) {
      var totalHours = [
        {x: 0, y: 0}, {x: 1, y: 0}, {x: 2, y: 0}, {x: 3, y: 0}, {x: 4, y: 0}, {x: 5, y: 0},
        {x: 6, y: 0}, {x: 7, y: 0}, {x: 8, y: 0}, {x: 9, y: 0}, {x: 10, y: 0}, {x: 11, y: 0},
        {x: 12, y: 0}, {x: 13, y: 0}, {x: 14, y: 0}, {x: 15, y: 0}, {x: 16, y: 0}, {x: 17, y: 0},
        {x: 18, y: 0}, {x: 19, y: 0}, {x: 20, y: 0}, {x: 21, y: 0}, {x: 22, y: 0}, {x: 23, y: 0},
        {x: 24, y: 0}
      ];

      data.forEach(function (item) {
        totalHours.forEach(function (hour) {
          if (hour.x === parseInt(item.hour)) {
            hour.y = item.total_checkouts;
          }
        });
      });

      return totalHours;
    }

    function generateVisitsCheckoutData(data) {
      var visitTotalHour = fillCheckoutData(data.total_checkouts);
      var visitCheckoutsHour = fillCheckoutData(data.total_checkouts_in_window);

      return [visitTotalHour, visitCheckoutsHour];
    }

    function isCheckoutDataValid(checkoutData) {
      var isValid = false;
      if (!lodash.isEmpty(checkoutData)) {
        if (Object.keys(checkoutData.data).length > 0) {
          isValid = checkoutData.data.total_checkouts.length !== 0 && checkoutData.data.total_checkouts_in_window.length !== 0;
        }
      }
      return isValid;
    }

    function getVisitCheckoutData() {
      var dateSplitted = vm.reportsDate.id.split('-');
      getVisitsCheckouts(dateSplitted[0], dateSplitted[1])
        .then(function success(data) {
          generateCheckoutIndicatorsData(data);
          resetDataImprovedIndicator();
          getImprovedDataVisitsCheckouts();
          if (isCheckoutDataValid(data)) {
            var dataCheckout = generateVisitsCheckoutData(data.data);

            vm.graphics.area.data[0].values = dataCheckout[0];
            vm.graphics.area.data[1].values = dataCheckout[1];
          } else {
            vm.graphics.area.data[0].values = [];
            vm.graphics.area.data[1].values = [];
          }


        })
        .catch(function error(e) {
          $log.error(e);
        });
    }

    function getVisitsCheckouts(year, month) {
      return dashboardService.getVisitsCheckouts(year, month);
    }

    function calculateTotal(data, property) {
      return data.reduce(function (sum, value) {
        return sum + value[property];
      }, 0);
    }

    function checkoutsPerc(totalCheckouts, checkoutsInWindow) {
      var result = '-';
      if (totalCheckouts > 0) {
        result = (checkoutsInWindow * 100 / totalCheckouts).toFixed(0) + '%';
      }
      return result;
    }


    function generateCheckoutIndicatorsData(data) {
      if (isCheckoutDataValid(data)) {
        var checkoutData = data.data;
        var totalCheckouts = calculateTotal(checkoutData.total_checkouts, 'total_checkouts');
        var checkoutsInWindow = calculateTotal(checkoutData.total_checkouts_in_window, 'total_checkouts');
        vm.indicators.checkoutVisitsInTimeWindow.value = checkoutsPerc(totalCheckouts, checkoutsInWindow);
      }

    }

    // function to get improved data (arrow)
    function getImprovedDataVisits() {
      var dateSplitted = getLastDate();

      // Get Data Indicator Visit Totals
      getVisitTotals(dateSplitted[0], dateSplitted[1])
        .then(function success(data) {
          resetDataImprovedIndicator();

          if (data.data.length === 0) {
            return;
          }
          var dataLastMonth = sumVisits(data.data);
          var dataLast = parseFloat(((dataLastMonth.completedVisits / dataLastMonth.totalVisits) * 100).toFixed(0));

          // Generate perce for indicator Total Visits
          generatePerceIndicatorTotalVisits(dataLastMonth);

          // Generate perce for indicator Completed Visits
          generatePerceIndicatorCompletedVisits(dataLast);

        })
        .catch(function error(e) {
          $log.error(e);
        });
    }

    function getImprovedDataVisitsCheckouts() {
      var dateSplitted = getLastDate();

      getVisitsCheckouts(dateSplitted[0], dateSplitted[1])
        .then(function (data) {
          if (isCheckoutDataValid(data)) {
            var checkouts = calculateTotal(data.data.total_checkouts, 'total_checkouts');
            var checkoutsInWindow = calculateTotal(data.data.total_checkouts_in_window, 'total_checkouts');
            var total = checkouts > 0 ? ((checkoutsInWindow / checkouts) * 100) : 0;

            // Generate perce for indicator Checkout Visits
            generatePerceIndicatorCheckoutVisits(total);
          }


        })
        .catch(function (e) {
          $log.error(e);
        });
    }

    function resetDataImprovedIndicator() {
      resetIndicator(vm.indicators.totalVisits);
      resetIndicator(vm.indicators.completedVisits);
      resetIndicator(vm.indicators.checkoutVisitsInTimeWindow);
    }

    function resetIndicator(indicator) {
      indicator.dataUp = false;
      indicator.dataDown = false;
      indicator.dataZero = true;
      indicator.perceChange = '0%';
      indicator.classDiv = CLASS_ZERO;
      indicator.classIcon = ICON_DEFAULT;
      indicator.eventIcons = [];
    }

    function generatePerceIndicatorTotalVisits(dataLastMonth) {
      vm.indicators.totalVisits.dataZero = false;
      var dataActualMonth = vm.indicators.totalVisits.value !== '-' ? vm.indicators.totalVisits.value : 0;
      var perceData = perceChange(dataLastMonth.totalVisits, dataActualMonth);
      formatDataIndicator(perceData, vm.indicators.totalVisits);
    }

    function generatePerceIndicatorCompletedVisits(dataLastMonth) {
      var perceData = getDiffPercDataIndicator(dataLastMonth, vm.indicators.completedVisits);
      formatDataIndicator(perceData, vm.indicators.completedVisits);
    }

    function generatePerceIndicatorCheckoutVisits(dataLastMonth) {
      var perceData = getDiffPercDataIndicator(Math.round(dataLastMonth), vm.indicators.checkoutVisitsInTimeWindow);
      formatDataIndicator(parseInt(perceData), vm.indicators.checkoutVisitsInTimeWindow);
    }

    function getDiffPercDataIndicator(dataLastMonth, indicator) {
      var data = indicator.value !== '-' ? indicator.value : "0%";
      var dataActual = parseFloat(data.replace('%', ''));
      return (dataActual - dataLastMonth);
    }

    function perceChange(last, actual) {
      return last === 0 ? 0 : ((actual - last) / last) * 100;
    }

    function getLastDate() {
      return timeUtils.lastDateByMonth(vm.reportsDate.id + '-01', 1).split('-');
    }

    function formatDataIndicator(perceData, indicator) {
      if (perceData > 0) {
        indicator.dataUp = true;
        indicator.perceChange = perceData > 999 ? PERCE_DATA_LIMIT : String(parseInt(perceData)).replace('-', '') + "%";
        setClassIndicator(indicator, CLASS_UP, ICON_UP, false);

      } else if (perceData < 0) {
        indicator.dataDown = true;
        indicator.perceChange = perceData < -999 ? PERCE_DATA_LIMIT : String(parseInt(perceData)).replace('-', '') + "%";
        setClassIndicator(indicator, CLASS_DOWN, ICON_DOWN, false);
      }
    }

    function setClassIndicator(indicator, classDiv, classIcon, value) {
      indicator.classDiv = classDiv;
      indicator.classIcon = classIcon;
      indicator.dataZero = value;
    }

    function getVehicleTotals(year, month) {
      return dashboardService.getVehicleTotals(year, month);
    }

    function generatePercLoadIndicators(dataLastMonth, loadIndicator) {
      var vehicleLoadIndicator = vehicleLoadIndicators[loadIndicator];
      vehicleLoadIndicator.dataZero = false;
      var perceData = getDiffPercDataIndicator(Math.round(dataLastMonth), vehicleLoadIndicator);
      formatDataIndicator(perceData, vehicleLoadIndicator);
    }

    function resetVehicleIndicators() {
      resetIndicator(vm.indicators.maxVehicles);
      resetIndicator(vehicleLoadIndicators.percLoad1);
      resetIndicator(vehicleLoadIndicators.percLoad2);
      resetIndicator(vehicleLoadIndicators.percLoad3);
    }

    function generatePercVehiclesIndicators(dataLastMonth) {
      vm.indicators.maxVehicles.dataZero = false;
      var dataActualMonth = vm.indicators.maxVehicles.value !== '-' ? vm.indicators.maxVehicles.value : 0;
      var perceData = perceChange(dataLastMonth.total_max_vehicles, dataActualMonth);
      formatDataIndicator(perceData, vm.indicators.maxVehicles);
      generatePercLoadIndicators(dataLastMonth.avg_perc_load_1, 'percLoad1');
      generatePercLoadIndicators(dataLastMonth.avg_perc_load_2, 'percLoad2');
      generatePercLoadIndicators(dataLastMonth.avg_perc_load_3, 'percLoad3');
      changeIndicator('percLoad1');
    }

    function getImprovedDataVehicleTotals() {
      var dateSplit = getLastDate();
      getVehicleTotals(dateSplit[0], dateSplit[1])
        .then(function success(data) {
          resetVehicleIndicators();
          if (data.data.length === 0) {
            return;
          }
          generatePercVehiclesIndicators(data.data[0]);
        })
        .catch(function error(e) {
          $log.error(e);
        });
    }

    function generateVehicleIndicators(data) {
      vm.indicators.maxVehicles.value = data.total_max_vehicles;
      vehicleLoadIndicators.percLoad1.value = setPercValue(data.avg_perc_load_1);
      vehicleLoadIndicators.percLoad2.value = setPercValue(data.avg_perc_load_2);
      vehicleLoadIndicators.percLoad3.value = setPercValue(data.avg_perc_load_3);
    }

    function getVehicleTotalsData() {
      var dateSplit = vm.reportsDate.id.split('-');
      getVehicleTotals(dateSplit[0], dateSplit[1])
        .then(function success(data) {
          if (data.data.length > 0) {
            generateVehicleIndicators(data.data[0]);
            getImprovedDataVehicleTotals();
          }

        })
        .catch(function error(e) {
          $log.error(e);
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .controller('ConfirmModalController', ConfirmModalController);

  /** @ngInject */
  function ConfirmModalController($log, Toasts, dashboardService, $filter) {
    var vm = this;
    var $translate = $filter('translate');
    vm.sendEmail = sendEmail;

    function sendEmail() {
      dashboardService.sendEmailToGetDashboardGraphics()
        .then(function () {
        Toasts.push('success', $translate('Dashboard.Visits.Modal.success_email'));
      }).catch(function (err) {
        $log.error(err);
        Toasts.push('error', $translate('Dashboard.Visits.Modal.error_email'));
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('icarus.dashboard', []);

})();

(function () {
  'use strict';

  angular
    .module('icarus.dashboard')
    .factory('dashboardReportService', dashboardReportService);

  /** @ngInject */
  function dashboardReportService ($http, $q, __env, driversService, vehicleService,
                                   mobileGeneralService, skillsService, extraFieldsService,
                                   settingsService, sessionService) {

    var REPORT_VISIT_HISTORY_URL = 'routes/visits/history-visits/?';
    var CLIENTS_URL = __env.API_URL + 'accounts/clients/';
    var HISTORICAL_CHECKOUT_URL = __env.API_URL + 'reports/historical-checkouts/';

    return {
      getReportVisitHistory: getReportVisitHistory,
      getDataExternalForReports: getDataExternalForReports,
      getClientsList: getClientsList,
      getTimeServiceVisits: getTimeServiceVisits,
      getReportTimeServiceFromArrayPromises: getReportTimeServiceFromArrayPromises,
      getOptimizationPermissions: getOptimizationPermissions,
      sendHistoricalCheckoutReport: sendHistoricalCheckoutReport
    };

    //////
    function getReportVisitHistory(start, end) {
      return $http.get(getReportUrl(start, end));
    }

    function getHistoricalCheckoutUrl(from, to) {
      return HISTORICAL_CHECKOUT_URL +'from/' + from + '/to/' + to + '/';
    }


    function getReportUrl(start, end) {
      return ( __env.API_URL + REPORT_VISIT_HISTORY_URL + 'start_date=' + start + '&end_date=' + end);
    }

    function getDataExternalForReports() {
      return $q.all([
        driversService.list(),
        vehicleService.list(),
        mobileGeneralService.listObservations(),
        skillsService.list(),
        extraFieldsService.getExtraFields()
      ]);

    }

    function getClientsList(params) {
      return $http.get(CLIENTS_URL, {params: params});
    }

    function getTimeServiceVisits(params) {
      return settingsService.getTimeServiceVisits(params);
    }

    function getReportTimeServiceFromArrayPromises(dataPromises) {
      return $q.all(dataPromises);
    }

    function getOptimizationPermissions() {
      return sessionService.getUser();
    }

    function sendHistoricalCheckoutReport(email, from, to) {
      return $http.post(getHistoricalCheckoutUrl(from, to), {"email": email});
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('icarus.dashboard')
    .factory('dashboardService', dashboardService);

  /** @ngInject */

  function dashboardService ($http, __env) {

    var DASHBOARD_PATH = __env.API_URL + 'dashboards/';

    return {
      getVisitTotals: getVisitTotals,
      getVisitsObservations: getVisitsObservations,
      getVisitsCheckouts: getVisitsCheckouts,
      getVehicleTotals: getVehicleTotals,
      sendEmailToGetDashboardGraphics: sendEmailToGetDashboardGraphics
    };

    function getVisitTotals (year, month) {
      return $http.get(DASHBOARD_PATH + 'visit-totals/year/' + year + '/month/' + month + '/');
    }

    function getVisitsObservations(year, month, params) {
      return $http.get(DASHBOARD_PATH + 'visit-observations/year/' + year + '/month/' + month + '/', {params: {type: params}});
    }

    function getVisitsCheckouts(year, month) {
      return $http.get(DASHBOARD_PATH + 'visit-checkouts/year/' + year + '/month/' + month + '/');
    }

    function getVehicleTotals(year, month) {
      return $http.get(DASHBOARD_PATH + 'vehicle-totals/year/' + year + '/month/' + month + '/');
    }

    function sendEmailToGetDashboardGraphics() {
      return $http.post(DASHBOARD_PATH + 'request-dashboards/');
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('icarus.dashboard')
    .controller('ReportsController', ReportsController);

  /** @ngInject */
  function ReportsController($scope, $rootScope, $filter, $log, lodash, Toasts, timeUtils, XslxService,
                             extraFieldsService, dashboardReportService, reportService,
                             fileDownloaderService, xlsWriterService, DATE_FORMAT, sessionService, store) {
    var vm = this;
    var today = timeUtils.today();
    var lastReport = timeUtils.getTime(today);
    var $translate = $filter('translate');

    var reportRequest = [];
    var allClients = [];
    var lastReportDates = {start: null, end: null};


    // Visit History Report
    vm.disableReportBtn = false;
    vm.visitHistoryReportEnabled = false;
    vm.visitHistoryReport = {};
    vm.visitHistoryReportStart = {model: today, opened: false};
    vm.visitHistoryReportEnd = {model: today, opened: false};

    // Historical Checkout Report
    vm.enableHistoricalCheckoutBtn = true;
    vm.historicalCheckoutReportEnabled = false;
    vm.hc_report = {};
    vm.historicalCheckoutReport = {
      from: {model: today, opened: false},
      to: {model: today, opened: false},
      email: ''
    };

    // Kilometers report
    vm.kilometers_report = {};
    vm.kmReportClient = null;
    vm.generating_report = false;
    vm.kmReportStartDate = {model: today, opened: false};
    vm.kmReportEndDate = {model: today, opened: false};
    vm.kmReportTime = {start: null, end: null};

    // Download visit images report
    vm.visitImagesReport = {};
    vm.generatingDownloadReport = false;
    vm.downloadVisitReportStartDate = {model: today, opened: false};
    vm.downloadVisitReportEndDate = {model: today, opened: false};
    vm.downloadReportTime = {start: null, end: null};
    vm.downloadEmail = "";
    vm.pictureName   = "";

    // Tracking code report
    vm.emailTcReport = '';
    vm.tc_report = {};
    vm.disableTcReportBtn = false;
    vm.tcReportStart = {model: today, opened: false};
    vm.tcReportEnd = {model: today, opened: false};

    // Optimization Report
    vm.disableOrReportBtn = false;
    vm.or_report = {};
    vm.enableOptimizationRequestsReport = false;
    vm.orReportStart = {model: today, opened: false};
    vm.orReportEnd = {model: today, opened: false};

    // Log Report
    vm.enableLogReport = false;
    vm.log_report = {};
    vm.logReportClient = null;
    vm.logReportDate = {model: today, opened: false};
    vm.logReportStartDate = {model: today, opened: false};
    vm.logReportEndDate = {model: today, opened: false};

    // Time service report
    vm.ts_report = {};
    vm.enableTimeServiceReport = false;
    vm.tsReportClient = null;
    vm.tsReportDate = {model: today, opened: false};
    vm.tsReportStartDate = {model: today, opened: false};
    vm.tsReportEndDate = {model: today, opened: false};
    vm.tsReportRadioGeofence = false;
    vm.tsReportTime = {start: null, end: null};


    vm.clients = [];
    vm.drivers = [];
    vm.vehicles = [];
    vm.observations = [];
    vm.skills = [];
    vm.extraFields = [];


    // Date Options calendar
    vm.dateOptions = {
      formatYear: 'yyyy',
      formatDayTitle: 'MMMM',
      formatDay: 'dd',
      showWeeks: false,
      maxMode: 'day',
      startingDay: 1,
      minDate: timeUtils.minDateDataAvailavility()
    };

    vm.getTimeService = _getTimeService;
    vm.validateReportDate = validateReportDate;
    vm.exportVisitHistoryReport = exportVisitHistoryReport;
    vm.exportRoutesReport = exportRoutesReport;
    vm.exportTcReport = exportTcReport;
    vm.exportOrReport = exportOrReport;
    vm.exportLogReport = exportLogReport;
    vm.exportTimeServiceReport = exportTimeServiceReport;
    vm.generateVisitImagesReport = generateVisitImagesReport;
    vm.loadAllClients = loadAllClients;
    vm.refreshClients = refreshClients;
    vm.exportHistoricalCheckoutReport = exportHistoricalCheckoutReport;

    activate();

    //TODO: deprecate
    function enableVisitHistoryReport() {
      sessionService.getAccountConfigs().then(function success(configs) {
        var visitHistoryReportConfig = configs.find(function (element) {
          return element.key === 'enable_visit_history_report';
        });
        if (angular.isDefined(visitHistoryReportConfig)) {
          vm.visitHistoryReportEnabled = visitHistoryReportConfig.value;
        }
      });
    }

    function activate() {
      enableVisitHistoryReport();
      getDataExternalToReports();
      getOptimizationPermissions();
      vm.historicalCheckoutEnabled = isEnabledHistoricalCheckoutReport();

      sessionService.getUser().then(function (user) {
        vm.user = user;
        vm.userHasOrganization = user.organization !== null;
        vm.routesReportCheckbox = false;
        vm.visitsReportCheckbox = false;
      });
    }

    function getDataExternalToReports() {
      dashboardReportService.getDataExternalForReports()
        .then(function (values) {
          vm.drivers = values[0];
          vm.vehicles = values[1];
          vm.observations = values [2];
          vm.skills = values[3];
          vm.extraFields = values[4];
        }).catch(function (err) {
        $log.error(err);
      });
    }

    function getOptimizationPermissions() {
      dashboardReportService.getOptimizationPermissions()
        .then(function (user) {
          vm.enableTimeServiceReport = user.is_staff;
          vm.enableOptimizationRequestsReport = user.is_staff;
          vm.enableLogReport = user.is_staff;

          if (user.is_staff) {
            getClients()
              .then(function (response) {
                vm.clients = response.data.results;
                allClients = response.data.results;
              }).catch(function (err) {
              $log.error(err);
            });
          }
        }).catch(function (err) {
        $log.error(err);
      });
    }

    function getClients(search) {
      var params = {};
      if (search) {
        params.search = search;
      }
      return dashboardReportService.getClientsList(params);
    }

    function loadAllClients() {
      vm.clients = allClients;
    }

    function refreshClients(search) {
      return getClients(search)
        .then(function (response) {
          vm.clients = response.data.results;
        });
    }

    function validateReportDate(start, end, report) {
      var duration;

      validateStartDate(start, end, report);

      start = timeUtils.createTime(start);
      end = timeUtils.createTime(end);
      duration = timeUtils.duration(end.diff(start));


      if (timeUtils.asDays(duration) > 31 || timeUtils.asDays(duration) < -1) {
        vm.activateReportBtn = false;
        vm.validationErrorDate = true;
        $scope[report].startDate.$setTouched();
        $scope[report].startDate.$setDirty();
        $scope[report].startDate.$setValidity('endDate_gt_startDate', false);
        $scope[report].endDate.$setTouched();
        $scope[report].endDate.$setDirty();
        $scope[report].endDate.$setValidity('endDate_gt_startDate', false);

        if (!vm[report].settingsErrorDateStart) {
          vm[report].settingsErrorBetweenDates = true;
        }

      } else {
        vm.activateReportBtn = true;
        vm.validationErrorDate = false;
        $scope[report].startDate.$setValidity('endDate_gt_startDate', true);
        $scope[report].endDate.$setValidity('endDate_gt_startDate', true);
        vm[report].settingsErrorBetweenDates = false;
      }
    }

    function validateStartDate(start, end, report) {
      start = timeUtils.createTime(start);
      end = timeUtils.createTime(end);

      if (timeUtils.isAfter(start, end)) {
        vm.activateReportBtn = false;
        vm.validationErrorDate = true;
        $scope[report].endDate.$setTouched();
        $scope[report].endDate.$setDirty();
        $scope[report].endDate.$setValidity('endDate_gt_startDate', false);
        vm[report].settingsErrorDateStart = true;
      } else {
        vm.activateReportBtn = true;
        vm.validationErrorDate = false;
        $scope[report].endDate.$setValidity('endDate_gt_startDate', true);
        vm[report].settingsErrorDateStart = false;
      }
    }

    function exportVisitHistoryReport(startDate, endDate) {
      $rootScope.isLoading = true;
      var start = angular.copy(startDate);
      var end = angular.copy(endDate);
      var filename = getFileName($translate('General.excel_name'), start, end);

      vm.disableReportBtn = true;
      vm.reportLoading = true;
      if (((timeUtils.getTimeDate() - lastReport) / 60000) < 2 ||
        lastReportDates.start !== start ||
        lastReportDates.end !== end) {

        lastReportDates.start = start;
        lastReportDates.end = end;

        dashboardReportService
          .getReportVisitHistory(timeUtils.formatTime(start, DATE_FORMAT), timeUtils.formatTime(end, DATE_FORMAT))
          .then(function (rows) {
            reportRequest = getDataFromReportVisitHistory(rows);
            lastReport = timeUtils.getTimeDate();
            return createReport(reportRequest, filename);
          })
          .finally(function () {
            resetStatusReportVisiHistory();
          });
      } else {
        createReport(reportRequest, filename)
          .finally(function () {
            resetStatusReportVisiHistory();
          });
      }
    }

    function exportRoutesReport() {
      vm.generating_report = true;
      $rootScope.isLoading = true;
      var fromDate = timeUtils.formatTime(vm.kmReportStartDate.model, DATE_FORMAT);
      var toDate = timeUtils.formatTime(vm.kmReportEndDate.model, DATE_FORMAT);

      var params = {
        fromDate: fromDate,
        toDate: toDate
      };

      if (vm.routesReportCheckbox) {
        params.all_accounts = true;
      }

      reportService.getRoutesKilometersTravelingReport(params)
        .then(function success(response) {
          vm.generating_report = false;
          $rootScope.isLoading = false;

          var fileName = getFileName('Reporte_rutas_', timeUtils.formatTime(vm.kmReportStartDate.model, DATE_FORMAT), timeUtils.formatTime(vm.kmReportEndDate.model, DATE_FORMAT)) + '.xlsx';
          fileDownloaderService.donwloadFile(response.data, fileName);

        }).catch(function error(e) {
        $log.error(e);
        vm.generating_report = false;
        $rootScope.isLoading = false;
      });
    }

    /**
     * Validate and parse/format hour/datetime from form "visitImagesReport"
     * get the user info to make a request to downloadVisitImagesReport
     * send request to process visit images
     * show toast with status of the report
     */
    function generateVisitImagesReport() {
      vm.generating_report = true;
      $rootScope.isLoading = true;
      var fromDate = timeUtils.formatTime(vm.downloadVisitReportStartDate.model, DATE_FORMAT);
      var toDate = timeUtils.formatTime(vm.downloadVisitReportEndDate.model, DATE_FORMAT);
      var email = vm.downloadEmail;
      var pictureName = vm.pictureName;
      var accountId =  (vm.user && vm.user.account) ? vm.user.account.id : null;

      var params = {
        fromDate: fromDate,
        toDate: toDate,
        email: email,
        accountId: accountId,
        pictureName: pictureName
      };

      reportService.downloadVisitImagesReport(params)
        .then(function success(response) {
          vm.generatingDownloadReport = true;
          if(response.status === 201){
            Toasts.push('success', $translate('General.visit_images_toast_content_success'));
          } else if(response.status === 200){
            Toasts.push('warning', $translate('General.visit_images_toast_content_wait_report'));
          }
        }).catch(function error(e) {
          if(e.status === 404){
            Toasts.push('warning', $translate('General.visit_images_toast_content_no_images_found'));
          }else if(e.status === 403){
            Toasts.push('warning', $translate('General.visit_images_toast_max_images_reached'));
          }else{
            Toasts.push('error', $translate('General.visit_images_toast_content_error_report'));
          }
          $log.error(e);
          vm.generatingDownloadReport = false;
      }).finally(function () {
        $rootScope.isLoading = false;
      });

    }

    function exportTcReport(startDate, endDate) {
      $rootScope.isLoading = true;
      vm.disableTcReportBtn = true;

      reportService.visitsWithTrackingIdReport(startDate, endDate, vm.emailTcReport, vm.visitsReportCheckbox)
        .then(function () {
          $rootScope.isLoading = false;
          vm.disableTcReportBtn = false;
          Toasts.push('success', $translate('General.TC_REPORT.report_tc_success'));
        }).catch(function (e) {
          if (e.status === 403) {
            Toasts.push('warning', $translate('Dashboard.Reports.error_date_duration'));
          } else {
            Toasts.push('error', $translate('General.TC_REPORT.report_tc_error'));
          }
          $log.error(e);
          $rootScope.isLoading = false;
          vm.disableTcReportBtn = false;
        });
    }

    function exportOrReport(startDate, endDate) {
      $rootScope.isLoading = true;
      vm.disableOrReportBtn = true;
      reportService.optimizationRequestsReport(startDate, endDate)
        .then(function () {
          $rootScope.isLoading = false;
          vm.disableOrReportBtn = false;
        }).catch(function () {
        $rootScope.isLoading = false;
        vm.disableOrReportBtn = false;
        Toasts.push('error', $translate('General.error_creating_report'));
      });

    }

    function exportLogReport() {
      $rootScope.isLoading = true;
      vm.generating_report = true;

      reportService.logRequestsReport(vm.logReportClient.id, vm.logReportStartDate.model, vm.logReportEndDate.model)
        .then(function () {
          $rootScope.isLoading = false;
          vm.generating_report = false;
        }).catch(function (error) {
        $rootScope.isLoading = false;
        vm.generating_report = false;
        $log.error(error);
      });

    }

    function exportTimeServiceReport() {
      var hourFrom = vm.tsReportTime ? timeUtils.formatTime(vm.tsReportTime.start, 'HH:mm') : null;
      var hourTo = vm.tsReportTime ? timeUtils.formatTime(vm.tsReportTime.end, 'HH:mm') : null;
      var dates = getDatesToTimeServiceReport(timeUtils.formatTime(vm.tsReportStartDate.model, DATE_FORMAT), timeUtils.formatTime(vm.tsReportEndDate.model, DATE_FORMAT));
      var dataPromises = [];
      vm.generating_report = true;
      dates.forEach(function (date) {
        var params = {
          clientId: vm.tsReportClient.id,
          date: date,
          geofenseRadius: vm.tsReportRadioGeofence,
          from: hourFrom,
          to: hourTo
        };
        dataPromises.push(dashboardReportService.getTimeServiceVisits(params));
      });

      dashboardReportService.getReportTimeServiceFromArrayPromises(dataPromises)
        .then(function (responsesArray) {
          donwloadTimeServiceReport(responsesArray);
          vm.generating_report = false;
        })
        .catch(function (error) {
          $log.error(error);
          vm.generating_report = false;
        });
    }

    function getDatesToTimeServiceReport(startDate, stopDate) {
      var dateArray = [];
      var currentDate = timeUtils.createTime(startDate, "YYYY-MM-DD");
      var stopMomentDate = timeUtils.createTime(stopDate, 'YYYY-MM-DD');
      while (currentDate.isSameOrBefore(stopMomentDate.format('YYYY-MM-DD'))) {
        dateArray.push(currentDate.format('YYYY-MM-DD'));
        currentDate = currentDate.add(1, 'days');
      }
      return dateArray;
    }

    function donwloadTimeServiceReport(responseArray) {
      var date = timeUtils.formatTime(vm.tsReportDate.model, DATE_FORMAT);
      var client = vm.tsReportClient.name;
      var result = [];
      var HEADERS = [
        'Fecha',
        'Titulo',
        'Direccion',
        'Checkin',
        'Checkout',
        'Tiempo servicio estimado',
        'Tiempo servicio real',
        'ETA',
        'ETD',
        'Conductor',
        'Vehiculo'
      ];
      responseArray.forEach(function (response) {

        response.data.forEach(function (e) {
          result.push(
            [
              e.date,
              e.title,
              e.address,
              e.checkin_time ? timeUtils.formatTime(e.checkin_time, 'YYYY-MM-DDTHH:mm:ss') : null,
              e.checkout_time ? timeUtils.formatTime(e.checkout_time, 'YYYY-MM-DDTHH:mm:ss') : null,
              e.estimated_time_service,
              e.calculated_time_service,
              e.estimated_time_arrival,
              e.estimated_time_departure,
              e.driver_name,
              e.vehicle_name
            ]
          );
        });
      });

      getReport(HEADERS, result, date, 'Reporte_Tiempo_Servicio_', 'Plan', client);
    }

    function getReport(headers, data, reportDate, fileName, sheetName, client) {
      var date = timeUtils.formatTime(reportDate, DATE_FORMAT);

      var grid = {
        headers: headers,
        data: data
      };

      var workbook = xlsWriterService.createWorkbook(sheetName, grid);
      var file = xlsWriterService.writeWorkbook(workbook);

      fileName = generateFileNameToTimeServiceReport(fileName, date, client);

      fileDownloaderService.downloadXLSX(file, fileName);
    }

    function resetStatusReportVisiHistory() {
      $rootScope.isLoading = false;
      vm.reportLoading = false;
      vm.disableReportBtn = false;
    }

    function getFileName(name, start, end) {
      return name + timeUtils.formatTime(start, DATE_FORMAT) + '_' + timeUtils.formatTime(end, DATE_FORMAT);
    }

    function generateFileNameToTimeServiceReport(fileName, date, client) {
      // Nombre que se condiciona porque reporte de tiempo de servicio todavia usa la lista de clientes
      fileName = client ? fileName + client + '_' + date.replace(/-/g, '') + '.xlsx' : fileName + date.replace(/-/g, '_') + '.xlsx';
      return fileName;
    }

    function createReport(data, filename) {
      var workbook = {Sheets: {}, SheetNames: []};

      var HEADERS = [
        $translate('General.excel_headers_id'),
        $translate('General.excel_headers_reference_id'),
        $translate('General.excel_headers_planned_date'),
        $translate('General.excel_headers_driver'),
        $translate('General.excel_headers_vehicle'),
        $translate('General.excel_headers_title'),
        $translate('General.excel_headers_address'),
        $translate('General.excel_headers_eta'),
        $translate('General.excel_headers_etd'),
        $translate('General.excel_headers_checkin_time'),
        $translate('General.excel_headers_checkout_time'),
        $translate('General.excel_headers_time_service'),
        $translate('General.excel_headers_time_advance'),
        $translate('General.excel_headers_time_delay'),
        $translate('General.excel_headers_latitude'),
        $translate('General.excel_headers_longitude'),
        $translate('General.excel_headers_checkout_lat'),
        $translate('General.excel_headers_checkout_lng'),
        $translate('General.excel_headers_load'),
        $translate('General.excel_headers_load_2'),
        $translate('General.excel_headers_load_3'),
        $translate('General.excel_headers_status'),
        $translate('General.excel_headers_comment'),
        $translate('General.excel_headers_observation'),
        $translate('General.excel_headers_time_windowStart'),
        $translate('General.excel_headers_time_windowEnd'),
        $translate('General.excel_headers_time_windowStart2'),
        $translate('General.excel_headers_time_windowEnd2'),
        $translate('General.excel_headers_skills_required'),
        $translate('General.excel_headers_skills_optional'),
        $translate('General.notes')
      ];

      var sortedFields = extraFieldsService.sortDefinition(vm.extraFields);
      for (var i = 0, l = sortedFields.length; i < l; i++) {
        var field = sortedFields[i];
        if (field.enable) {
          HEADERS.push(sortedFields[i].label);
        }
      }

      workbook.Sheets.Plan = XslxService.sheetFromMatrix([HEADERS].concat(data));
      workbook.SheetNames.push('Plan');
      return XslxService.write(workbook, filename);
    }

    function getDataFromReportVisitHistory(rows) {
      var data = [];
      rows.data.map(function (e) {
        var visited = false;
        e.historic_visits.map(function (row) {
          if (row.status !== 'pending') {
            visited = true;
            data.push(parseRow(row));
          }
        });

        if (!visited) {
          data.push(parseRow(e));
        }
      });

      return data;
    }

    function parseRow(e) {
      var vehicle = null;
      var driver = null;
      var observation = null;
      var requiredSkills;
      var optionalSkills;
      var requiredSkillsNames = [];
      var optionalSkillsNames = [];

      if (e.vehicle) {
        vehicle = lodash.find(vm.vehicles, {id: e.vehicle});
      }

      if (e.driver) {
        driver = lodash.find(vm.drivers, {id: e.driver});
      }

      if (e.checkout_observation) {
        observation = lodash.find(vm.observations, {id: e.checkout_observation});
      }

      var diffTime = _getDiffTimes(
        e.planned_date,
        e.checkout_time,
        e.estimated_time_departure
      );

      var timeService = _getTimeService(e.checkin_time, e.checkout_time);

      //Getting the required skills
      requiredSkills = e.skills_required ? e.skills_required : null;
      for (var j = 0; j < requiredSkills.length; j++) {
        var skillReqObj = lodash.find(vm.skills, {id: requiredSkills[j]});
        if (skillReqObj && skillReqObj.skill) {
          requiredSkillsNames.push(skillReqObj.skill);
        }
      }

      optionalSkills = e.skills_optional ? e.skills_optional : null;
      for (var k = 0; k < optionalSkills.length; k++) {
        var skillOptObj = lodash.find(vm.skills, {id: optionalSkills[j]});
        if (skillOptObj && skillOptObj.skill) {
          optionalSkillsNames.push(skillOptObj.skill);
        }
      }

      var rowValues = [
        e.id,
        e.reference ? e.reference : null,
        e.planned_date ? timeUtils.todayByDate(timeUtils.createTimeUTC(e.planned_date)) : null,
        driver ? driver.name : e.driver,
        vehicle ? vehicle.name : e.vehicle,
        e.title ? e.title : null,
        e.address ? e.address : null,
        e.estimated_time_arrival ? e.estimated_time_arrival : null,
        e.estimated_time_departure ? e.estimated_time_departure : null,
        e.checkin_time ? timeUtils.formatTime(e.checkin_time, 'YYYY-MM-DDTHH:mm:ss') : null,
        e.checkout_time ? timeUtils.formatTime(e.checkout_time, 'YYYY-MM-DDTHH:mm:ss') : null,
        timeService,
        diffTime.advance,
        diffTime.delay,
        e.latitude ? parseFloat(e.latitude) : 0.0,
        e.longitude ? parseFloat(e.longitude) : 0.0,
        e.checkout_latitude ? parseFloat(e.checkout_latitude) : 0.0,
        e.checkout_longitude ? parseFloat(e.checkout_longitude) : 0.0,
        e.load ? e.load : 0,
        e.load_2 ? e.load_2 : 0,
        e.load_3 ? e.load_3 : 0,
        e.status,
        e.checkout_comment ? e.checkout_comment : null,
        observation ? observation.label : null,
        e.window_start ? e.window_start : null,
        e.window_end ? e.window_end : null,
        e.window_start2 ? e.window_start2 : null,
        e.window_end2 ? e.window_end2 : null,
        requiredSkillsNames.join(','),
        optionalSkillsNames.join(','),
        e.notes
      ];

      if (angular.isDefined(e.extra_field_values) && e.extra_field_values !== null) {
        var asExtraFieldJson = angular.fromJson(e.extra_field_values);
        var sortedFields = extraFieldsService.sortDefinition(vm.extraFields);
        for (var index = 0; index < sortedFields.length; index++) {
          var extraFieldDefinition = sortedFields[index];
          if (extraFieldDefinition.enable) {
            var key = extraFieldDefinition.key;
            if (asExtraFieldJson.hasOwnProperty(key)) {
              rowValues.push(asExtraFieldJson[key]);
            } else {
              rowValues.push("");
            }
          }
        }
      }


      return rowValues;
    }

    function _getDiffTimes(planned_date, checkout, etDeparture) {
      checkout ? checkout = checkout.replace('T', ' ') : checkout = null;
      var etd = timeUtils.createTime(planned_date + ' ' + etDeparture);
      var checkout_time = timeUtils.createTime(checkout);
      var response = {advance: '00:00:00', delay: '00:00:00'};

      if (timeUtils.isValidMoment(etd) && timeUtils.isValidMoment(checkout_time)) {
        var date = timeUtils.newDate(planned_date + ' ' + etDeparture);
        var diff = timeUtils.getTime(date) - timeUtils.getTime(timeUtils.todayByDate(checkout_time));
        response = {
          advance: diff > 0 ? _getDiffMoment(etd, checkout_time) : '00:00:00',
          delay: diff < 0 ? _getDiffMoment(checkout_time, etd) : '00:00:00'
        };
      }


      return response;
    }

    function _getDiffMoment(now, then) {
      var diff = timeUtils.diff(timeUtils.createTime(now), timeUtils.createTime(then));
      return timeUtils.formatTime(timeUtils.createTimeUTC(diff), "HH:mm:ss");
    }

    function _getTimeService(checkin_time, checkout_time) {
      var timeService = null;

      if (timeUtils.isValidMoment(checkin_time) && timeUtils.isValidMoment(checkout_time)) {
        var ms = timeUtils.diff(timeUtils.createTime(checkout_time), timeUtils.createTime(checkin_time)); // duferencua en milisegundos
        var d = timeUtils.duration(ms);
        timeService = Math.floor(timeUtils.asMinutes(d));
      }

      return timeService;
    }

    function isEnabledHistoricalCheckoutReport() {
      var accountConfigs = store.get('accountConfigs');
      var isEnabled = false;
      if (accountConfigs) {
        isEnabled = Boolean(accountConfigs.filter(function (config) {
          return config.key === 'enable_recurring_plans' && config.value;
        }).length);
      }
      return isEnabled;
    }

    function exportHistoricalCheckoutReport(email, fromDate, toDate) {
      var fromDateStr = timeUtils.formatTime(fromDate, DATE_FORMAT);
      var toDateStr = timeUtils.formatTime(toDate, DATE_FORMAT);
      $rootScope.isLoading = true;
      vm.enableHistoricalCheckoutBtn = false;
      dashboardReportService.sendHistoricalCheckoutReport(email, fromDateStr, toDateStr)
        .then(function() {
          $rootScope.isLoading = false;
          Toasts.push('success', $translate('General.TC_REPORT.report_tc_success'));
        })
        .catch(function() {
          $rootScope.isLoading = false;
          Toasts.push('error', $translate('General.TC_REPORT.report_tc_error'));
        })
        .finally(function() {
          vm.enableHistoricalCheckoutBtn = true;
        });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.dashboard")
    .controller("ExternalDashboardController", ExternalDashboardController);

  /** @ngInject */
  function ExternalDashboardController(shareState, USER_ROLE, __env, userService, UserModel) {
    var vm = this;

    vm.url = null;

    active();

    function active() {
      vm.url = _getDashboardUrl(
        shareState.dashboardId,
        shareState.user
      );
    }

    function _getDashboardUrl(dashboard, user) {
      return (
        __env.RETOOL_URL +
        dashboard +
        "#" +
        _getAsQueryParams({
          user_id: user.id,
          account_id: user.account.id,
          profile: userService.getTypeUser(
            UserModel.fromJson(user)
          ),
        })
      );
    }

    function _getAsQueryParams(options) {
      return Object.keys(options)
        .map(function (k) {
          return encodeURIComponent(k) + "=" + encodeURIComponent(options[k]);
        })
        .join("&");
    }
  }
})();

(function () {
  'use strict';

  function visitsGraphicsModalController (ngDialog) {
    var ctrl = this;

    ctrl.openModalConfirmation = openModalConfirmation;

    function openModalConfirmation() {
      ngDialog.open({
        template: 'app/dashboard/visits/confirm-modal.html',
        controller: 'ConfirmModalController',
        controllerAs: 'vm'
      });
    }

  }

  var visitsGraphicsModal = {
    templateUrl: 'app/dashboard/components/visitsGraphicsModal.html',
    controller: ['ngDialog', visitsGraphicsModalController],
    bindings: {
      data: '<'
    }
  };

  angular
    .module('icarus.dashboard')
    .component('visitsGraphicsModal', visitsGraphicsModal);

})();

(function () {
  'use strict';

  function reportController (timeUtils) {
    var ctrl = this;
    var today = timeUtils.today();

    ctrl.report = {};
    ctrl.dateOptions = {
      formatYear: 'yyyy',
      formatDayTitle: 'MMMM',
      formatDay: 'dd',
      showWeeks: false,
      maxMode: 'day',
      startingDay: 1
    };

    ctrl.reportStart = {model: today, opened: false};
    ctrl.reportEnd = {model: today, opened: false};
    ctrl.emailReport = '';
    ctrl.submitButtonActive = false;
    ctrl.formErrors = {
      startDateError: false,
      dateRangeError: false,
      emailError: false
    };

    ctrl.validateDates = validateDates;
    ctrl.validateEmail= validateEmail;

    function validateDates() {
      validateStartDate();
      validateDateRange();
      activateSubmit();
    }

    function validateEmail() {
      ctrl.formErrors.emailError = !!ctrl.report.$error.email;
      activateSubmit();
    }

    function setValidityInput(input, property, value) {
      input.$setTouched();
      input.$setDirty();
      input.$setValidity(property, value);
    }

    function validateStartDate() {
      var validStartDate = timeUtils.validateStartDate(ctrl.reportStart.model, ctrl.reportEnd.model);
      setValidityInput(ctrl.report.startDate, 'endDate_gt_startDate', validStartDate);
      ctrl.formErrors.startDateError = !validStartDate;
    }

    function validateDateRange() {
      if (ctrl.reportEnd.model) {
        var validDateRange = timeUtils.validateDateRange(ctrl.reportStart.model, ctrl.reportEnd.model, 31);
        setValidityInput(ctrl.report.startDate, 'invalid_dateRange', validDateRange);
        setValidityInput(ctrl.report.endDate, 'invalid_dateRange', validDateRange);
        ctrl.formErrors.dateRangeError = !validDateRange;
      }
    }

    function activateSubmit() {
      ctrl.submitButtonActive = ctrl.report.$valid;
    }
  }

  var report = {
    templateUrl: 'app/dashboard/components/report.html',
    controller: ['timeUtils', reportController],
    bindings: {
      data: '<',
      onSubmit: '=',
      loading: '<'
    }
  };

  angular
    .module('icarus.dashboard')
    .component('report', report);

})();

(function () {
  'use strict';

  function pieGraphController () {
    var ctrl = this;
    ctrl.changeView = changeView;

    function changeView(type) {
      ctrl.onChangeView({type: type});
    }
  }

  var pieGraph = {
    templateUrl: 'app/dashboard/components/pieGraph.html',
    controller: pieGraphController,
    bindings: {
      data: '<',
      onChangeView: '&'
    }
  };

  angular
    .module('icarus.dashboard')
    .component('pieGraph', pieGraph);

})();

(function () {
  'use strict';

  function indicatorController () {
    var ctrl = this;
  }

  var indicator = {
    templateUrl: 'app/dashboard/components/indicator.html',
    controller: indicatorController,
    bindings: {
      data: '<'
    }
  };

  angular
    .module('icarus.dashboard')
    .component('indicator', indicator);

})();

(function () {
  'use strict';

  function barGraphController () {
    var ctrl = this;
  }

  var barGraph = {

    templateUrl: 'app/dashboard/components/barGraph.html',
    controller: barGraphController,
    bindings: {
      data: '<'
    }
  };

  angular
    .module('icarus.dashboard')
    .component('barGraph', barGraph);

})();

(function () {
  'use strict';

  function areaGraphController () {
    var ctrl = this;
  }

  var areaGraph = {

    templateUrl: 'app/dashboard/components/areaGraph.html',
    controller: areaGraphController,
    bindings: {
      data: '<'
    }
  };

  angular
    .module('icarus.dashboard')
    .component('areaGraph', areaGraph);

})();

(function() {
  'use strict';

  angular
    .module('icarus.authentication', []);

})();

(function () {
  'use strict';

  angular
    .module('icarus.authentication')
    .factory('redirectService', redirectService);

  /** @ngInject */
  function redirectService($state) {

    return {
      handleEncryptionPassphraseRedirect: handleEncryptionPassphraseRedirect
    };

    //////

    function handleEncryptionPassphraseRedirect(stateToRedirect, redirectPath) {
      // Create state params object to pass to encryption-passphrase
      var stateParams = {};

      // Make sure we're passing the Apollo redirect parameters
      if (stateToRedirect) {
        stateParams.stateToRedirect = stateToRedirect;
      }

      if (redirectPath) {
        stateParams.redirectPath = redirectPath;
      }

      // Store Apollo parameters in session storage as a backup
      // This is crucial for preserving the parameters across state transitions
      sessionStorage.setItem('apollo_state', stateToRedirect || '');
      sessionStorage.setItem('apollo_path', redirectPath || '');

      $state.go('auth.encryption-passphrase', stateParams);
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('icarus.authentication')
    .factory('complianceService', complianceService);

  /** @ngInject */
  function complianceService($http, $q, __env, moduleHelpersService, $log) {

    var PENDING_DOCUMENTS_PATH = __env.API_URL + 'compliance/pending-documents/';
    var ACCEPTANCES_PATH = __env.API_URL + 'compliance/acceptances/';

    return {
      getPendingDocuments: getPendingDocuments,
      acceptDocuments: acceptDocuments,
      runComplianceGate: runComplianceGate
    };

    //////

    function getPendingDocuments(language, outputFormat) {
      return $http.get(PENDING_DOCUMENTS_PATH, {
        params: {
          language: language,
          output_format: outputFormat || 'html'
        }
      });
    }

    function acceptDocuments(legalDocumentIds) {
      return $http.post(ACCEPTANCES_PATH, {
        legal_document_ids: legalDocumentIds
      });
    }

    function runComplianceGate(user) {
      if (!user) {
        return $q.when({ shouldBlock: false, documents: [] });
      }

      var language = moduleHelpersService.getCurrentLanguage();

      return getPendingDocuments(language, 'html')
        .then(function (response) {
          var documents = response && response.data ? response.data : [];
          return {
            shouldBlock: documents.length > 0,
            documents: documents
          };
        })
        .catch(function (error) {
          if (error && error.status === 401) {
            return $q.reject(error);
          }
          $log.warn('complianceService.runComplianceGate failed; allowing user through', error);
          return { shouldBlock: false, documents: [] };
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.authentication')
    .factory('chatService', chatService);

  /** @ngInject */
  function chatService($http, __env, $q, sessionService, $window) {

    var INTERCOM_LEAD_PATH = __env.API_URL + 'accounts/intercom-leads/';
    var INTERCOM_COMPANY_PATH = __env.API_URL + 'accounts/intercom-companies/';
    var ENABLE_INTERCOM = __env.ENABLE_INTERCOM;

    return {
      createLeadIntercom: createLeadIntercom,
      createCompanyIntercom: createCompanyIntercom,
      setDataWindowChat: setDataWindowChat,
      closeChatSession: closeChatSession,
      initChat: initChat,
      getIntercomSettingsDataFromUser: getIntercomSettingsDataFromUser,
      notifyVehicleCreated: notifyVehicleCreated,
      notifyRouteCreated: notifyRouteCreated,
      notifySavePlan: notifySavePlan,
      notifyUserCreated: notifyUserCreated,
      notifyAccessesToProfileSection: notifyAccessesToProfileSection,
      getNotificationMetadataFromVehicle: getNotificationMetadataFromVehicle,
      getNotificationMetadataFromPlan: getNotificationMetadataFromPlan,
      getNotificationMetadataFromUser: getNotificationMetadataFromUser
    };

    //////

    function createLeadIntercom(user) {
      var deferred = $q.defer();
      var company = {
        "company_id": null,
        "name": user.company,
        "custom_attributes": {
          "vehicle_number_text": user.vehicle,
          "country": user.country
        }
      };
      var lead = {
        "email": user.email,
        "name": user.name,
        "phone": user.phone,
        "last_seen_ip": "",
        "companies": [company]
      };

      createCompanyIntercom(company)
        .then(function (companyResponse) {

          sessionService.getIP().then(function (ip) {
            lead.last_seen_ip = ip;
            lead.companies[0].company_id = companyResponse.data.company_id;
            $http.post(INTERCOM_LEAD_PATH, lead)
              .then(function (data) {
                deferred.resolve(data);
              }).catch(function (err) {
              deferred.reject(err);
            });

          }).catch(function (err) {
            deferred.reject(err);
          });

      }).catch(function (err) {
        deferred.reject(err);
      });

      return deferred.promise;

    }

    function createCompanyIntercom(company) {
      return $http.post(INTERCOM_COMPANY_PATH, company);
    }

    /**
     * Sets user data for the Intercom chat widget
     */
    function setDataWindowChat(user) {
      if (ENABLE_INTERCOM === true) {
        if ($window.Intercom) {
          $window.Intercom('hide');
          var intercomSettings = getIntercomSettingsDataFromUser(user);
          Object.assign($window.intercomSettings, intercomSettings);
          $window.Intercom('update', intercomSettings);
        }
      }
    }

    function closeChatSession() {
      if (
        ENABLE_INTERCOM === true &&
        $window.Intercom &&
        $window.intercomSettings
      ) {
        delete $window.intercomSettings.email;
        delete $window.intercomSettings.name;
        delete $window.intercomSettings.user_id;
        delete $window.intercomSettings.company;
        $window.Intercom("shutdown");
      }
    }

    /**
     * Initializes and shows the Intercom chat widget based on environment configuration
     */
    function initChat() {
      if (
        ENABLE_INTERCOM === true &&
        $window.Intercom &&
        $window.intercomSettings
      ) {
        $window.Intercom("boot", window.intercomSettings);
        $window.Intercom("show");
      }
    }

    /**
     * Envia un trackEvent a Intercom solo si el widget esta habilitado y
     * cargado. Evita "Intercom is not a function" en entornos donde Intercom
     * esta apagado (local dev o flag off), igual que initChat/closeChatSession.
     */
    function trackIntercomEvent(eventName, metadata) {
      if (ENABLE_INTERCOM === true && typeof $window.Intercom === 'function') {
        $window.Intercom('trackEvent', eventName, metadata);
      }
    }

    function notifyVehicleCreated(vehicle) {
      var metadataFromVehicle = getNotificationMetadataFromVehicle(vehicle);
      trackIntercomEvent('Vehicle Created', metadataFromVehicle);
    }

    function notifyRouteCreated() {
      trackIntercomEvent('Route Created');
    }

    function notifySavePlan(plan) {
      var metadataFromPlan = getNotificationMetadataFromPlan(plan);
      trackIntercomEvent('Save Plan', metadataFromPlan);
    }

    function notifyUserCreated(user) {
      var metadataFromUser = getNotificationMetadataFromUser(user);
      trackIntercomEvent('User Created', metadataFromUser);
    }

    function notifyAccessesToProfileSection() {
      trackIntercomEvent('Access to the profile section');
    }

    function getNotificationMetadataFromPlan(plan) {
      if (!plan || !plan.name) {
        return null;
      }
      return {
        name: plan.name
      };
    }

    function getNotificationMetadataFromUser(user) {
      if (!user || !user.name || !user.username) {
        return null;
      }
      return {
        name: user.name,
        username: user.username
      };
    }

    function getNotificationMetadataFromVehicle(vehicle) {
      if (!vehicle || !vehicle.data || !vehicle.data.name) {
        return null;
      }
      return {
        name: vehicle.data.name
      };
    }

    function getIntercomSettingsDataFromUser(user) {
      var intercomSettings = {};
      if (user.email) {
        intercomSettings.email = user.email;
      }

      intercomSettings.name = user.name;
      intercomSettings.user_id = user.id;

      if (user.account && user.account.id && user.account.name) {
        intercomSettings.company = {
          id: user.account.id,
          name: user.account.name
        };
      }

      return intercomSettings;
    }
  }

})();

(function () {
  'use strict';
  angular
    .module('icarus.authentication')
    .controller('UserBlockedController', UserBlockedController);

  /** @ngInject */
  function UserBlockedController($state, $scope, sessionService) {

    var vm = this;
    vm.username = '';
    vm.showError = false;
    vm.unlockUser = unlockUser;

    ////////////

    function unlockUser() {
      sessionService.unlockUser(vm.username).then(
        function () {
          $state.go('auth.user-unlock-progress');
        }, function () {
          vm.showError = true;
        }
      );
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('icarus.authentication')
    .controller('SignupController', SignupController);

  /** @ngInject */
  function SignupController($state, $translate, $scope, $log, $window,
                            sessionService, chatService, $stateParams) {
    var vm = this;

    vm.errorMsg = null;
    vm.moreData = false;
    vm.submiting = false;
    vm.linkToOtherReasons = "";
    vm.module_interest = "optimizer";
    vm.user = {};
    vm.signup = signup;
    vm.saveMoreData = saveMoreData;

    vm.error = true;

    vm.quantityVehicle = [{id: 5, num: "1 - 5"}, {id: 10, num: "6 - 10"}, {id: 20, num: "11 - 20"},
      {id: 20, num: "20"}];

    init();

    $scope.$watch('vm.user.email', function () {
      if (angular.isDefined(vm.user.email) && vm.user.email !== null) {
        vm.user.email = vm.user.email.toLowerCase();
      }
    });

    ////////////

    function _appendUTM(key) {
      if ($stateParams[key] !== undefined) {
        vm.utm += key + '=' + $stateParams[key] + '&';
      }
    }

    function init() {
      vm.utm = '';

      _appendUTM('utm_source');
      _appendUTM('utm_medium');
      _appendUTM('utm_campaign');
      _appendUTM('utm_term');
      _appendUTM('utm_content');

      var langKey = $translate.use();

      switch (langKey) {
        case 'es':
          vm.linkToOtherReasons = 'https://www.simpliroute.com/post/' +
            '10-razones-para-usar-un-software-optimizador-de-rutas';
          break;
        case 'pt':
          vm.linkToOtherReasons = 'https://www.simpliroute.com/postpt/' +
            '10-razoes-para-utilizar-um-software-de-otimizacao-de-rotas';
          break;
        default:
          vm.linkToOtherReasons = 'https://www.simpliroute.com/en-post/' +
            '10-reasons-to-use-a-route-planner-software';
      }

    }

    function signup() {
      vm.submiting = true;

      sessionService.checkUsername(vm.user.email).then(
        function checkUsernameSuccess(response) {
          if (response.data.exist) {
            vm.signupForm.signup_email.$error.invalid = 'Login.existing_user';
          }
          else {
            vm.moreData = true;
          }
        },
        function checkUsernameError(error) {
          if (error.data || error.data.username) {
            vm.error = true;
          }
          vm.submiting = false;
        }
      );
    }


    function saveMoreData() {
      if (vm.user.country === '-') {
        vm.moreDataForm.moreData_country.$error.invalid = 'Error';
        return;
      }

      var user = {
        username: vm.user.email,
        email: vm.user.email,
        name: vm.user.name,
        password: vm.user.password,
        phone: vm.user.phone,
        account: {
          name: vm.user.company,
          country: vm.user.country,
          vehicleQuantity: vm.user.vehicle,
          module_interest: vm.module_interest,
          utm: vm.utm
        }
      };

      vm.promiseLoading = sessionService.signUp(user)
        .then(function successSignup() {
          sessionService.login(vm.user.email, vm.user.password)
            .then(function successLogin() {
              $state.go('planner.vehicles-list');
            }, function errorLogin() {
              $log.info('error service login');
            });
        }, function errorSignup(error) {
          $log.info('error service signup', error.data[0]);
        });
    }

  }
})();

(function(){
  'use strict';
  angular
    .module('icarus.authentication')
    .controller('PasswordResetConfirmController', PasswordResetConfirmController);

  /** @ngInject */
  function PasswordResetConfirmController ($log, $state, $stateParams, $filter, sessionService, $timeout, securityService) {
    var vm = this;
    var $translate = $filter('translate');
    var uid = null;
    var token = null;

    vm.success = false;
    vm.submiting = false;
    vm.confirmed = false;
    vm.policies = {};
    vm.validation= {};
    vm.new_password = '';
    vm.new_password_repeat = '';
    vm.validate_repeat_password = validate_repeat_password;
    vm.confirm = confirm;
    vm.setNewPasswordType = setNewPasswordType;
    vm.setNewPasswordRepeatType = setNewPasswordRepeatType;

    activate();

    ////////////

    vm.newPasswordType = vm.newPasswordRepeatType = 'password';
    function activate () {
      uid = $stateParams.uid;
      token = $stateParams.token;

      sessionService.getUser().then(function (res) {
        $state.go('planner.vehicles-list');
      });
      var data = {
        'uid': uid,
        'token': token,
      };
      _getSecuritySetting(data);
    }

    function validate_repeat_password(confirmForm){
      securityService.validatePassword(vm.new_password, vm.validation, vm.policies);
      confirmForm.new_password_repeat.$error.policies = securityService.formPasswordValidation(vm.validation);
      confirmForm.new_password_repeat.$error.equal = document.getElementById("new-password-repeat-input").value !== document.getElementById("newPassword").value;
    }

    function confirm (new_password, new_password_repeat) {
      if (new_password !== new_password_repeat || securityService.formPasswordValidation(vm.validation) ) {
        return;
      }

      vm.submiting = true;
      sessionService.passwordResetConfirm(uid, token, new_password)
      .then(function () {
        vm.confirmed = true;
        vm.success = true;
        $timeout(function() {
          // Do something
        }, 4000).then(function() {
          $state.go('auth.login');
        });
      }, function (error) {
        if (error.status === 400) {
          vm.confirmed = true;
          vm.success = false;
        }
        $log.debug(error);
      })
      .finally(function () {
        vm.submiting = false;
      });
    }

    function setNewPasswordType(){
      vm.newPasswordType === 'password' ?
        vm.newPasswordType = 'text'
      : vm.newPasswordType = 'password';
    }

    function setNewPasswordRepeatType(){
      vm.newPasswordRepeatType === 'password' ?
        vm.newPasswordRepeatType = 'text'
      : vm.newPasswordRepeatType = 'password';
    }

    function _getSecuritySetting(data) {
      securityService.get(data).then( function (res){
        if(res.status !== 200){
          vm.policies = {
            "length": 8,
            "uppercase": false,
            "lowercase": false,
            "number": false,
            "symbol": false,
          };
        }else {
          var driver = res.data['is_mobile_user'];
          securityService.buildBodyToShow(res.data, driver, vm.policies );
        }
        securityService.buildValidation(vm.validation, vm.policies);
        if (res.status !== 404 && res.status !== 200) {
          throw 'Unexpected response status: ' + res.status;
        }
      }).catch(function(err) {
        $log.error(err);
      });
      showPoliciesInForm();
    }

    function showPoliciesInForm() {
      var form = document.getElementById('password-reset-form');
      var input = document.getElementById('newPassword');
      var policies = document.getElementById('password-reset-policies');
      var exceptions = document.getElementsByClassName('except_policies_hidden');
      if(form !== null && input !== null && policies !== null && exceptions !== null) {
        input.addEventListener('focus', function(event) {
          policies.style.display = "block";
        });
        form.addEventListener('click', function(event) {
          for(var i = 0; i < exceptions.length; i++){
            if(exceptions[i] === event.target) {
              return;
            };
          }
          policies.style.display = "none";
        });
      }
      }

  }
})();

(function(){
  'use strict';
  angular
    .module('icarus.authentication')
    .controller('PasswordResetController', PasswordResetController);

  /** @ngInject */
  function PasswordResetController ($log, $state, sessionService, $timeout) {
    var vm = this;

    vm.reseted = false;
    vm.submiting = false;

    vm.reset = reset;

    activate();

    ////////////

    function activate () {
      sessionService.getUser().then(function () {
        // Promise is resolved, means the user is authenticated
        $state.go('planner.vehicles-list');
      });
    }

    function reset (email) {
      vm.submiting = true;
      sessionService.passwordReset(email)
      .then(function () {
        vm.reseted = true;
        $timeout(function() {
          // Do something
        }, 2000).then(function() {
          $state.go('auth.login');
        });
      }, function (error) {
        if (error.status === 400) {
          vm.resetForm.email.$error.invalid = true;
        }
      })
      .finally(function () {
        vm.submiting = false;
      });
    }
  }
})();

(function () {
    'use strict';
    angular
      .module('icarus.authentication')
      .controller('LogoutController', LogoutController);

    /** @ngInject */
    function LogoutController(sessionService, $state, addonsService, SSO_LOGOUT_ADDON_KEY, store,
                              SSO_DOMAIN_IDENTIFIER, $log) {

      addonsService.isAddonEnable(SSO_LOGOUT_ADDON_KEY)
        .then(function (isSsoLogoutAddonEnabled) {
          sessionService.logout();
          if (isSsoLogoutAddonEnabled && store.get(SSO_DOMAIN_IDENTIFIER)) {
            var ssoDomain = store.get(SSO_DOMAIN_IDENTIFIER);
            store.remove(SSO_DOMAIN_IDENTIFIER);
            sessionService.ssoLogoutRedirect(ssoDomain);
            return;
          }
          $state.go('auth.login');
        })
        .catch(function (error) {
          $log.error(error);
          sessionService.logout();
          $state.go('auth.login');
        });
  }
})();

(function(){
  'use strict';
  angular
    .module('icarus.authentication')
    .controller('PasswordRenewalController', PasswordRenewalController);

  /** @ngInject */
  function PasswordRenewalController($log, $state, $stateParams, $filter,
                                     sessionService, $timeout,
                                     securityService, __env, lodash) {
    var vm = this;
    var $translate = $filter('translate');
    var uid = null;
    var token = null;

    vm.success = false;
    vm.submiting = false;
    vm.confirmed = false;
    vm.policies = {};
    vm.validation= {};
    vm.new_password = '';
    vm.new_password_repeat = '';
    vm.validate_repeat_password = validate_repeat_password;
    vm.confirm = confirm;
    vm.toggleInputType = toggleInputType;
    vm.clientError = '';
    vm.showClientError = true;

    activate();

    ////////////

    vm.newPasswordType = vm.newPasswordRepeatType = vm.currentPasswordType
    = 'password';

    function activate () {
      uid = $stateParams.uid;
      token = $stateParams.token;

      var data = {
        'uid': uid,
        'token': token,
      };
      _getSecuritySetting(data);
    }

    function validate_repeat_password(confirmForm){
      securityService.validatePassword(vm.new_password, vm.validation, vm.policies);
      confirmForm.new_password_repeat.$error.policies = securityService.formPasswordValidation(vm.validation);
      confirmForm.new_password_repeat.$error.equal = vm.new_password !== vm.new_password_repeat;
      if (vm.clientError) {
        // Hide client error messsage on password edit.
        vm.showClientError = false;
        vm.clientError = '';
      }
      // Needed for reset errors in form after 'required' error is hidden
      // (when new_password field is empty).
      if (vm.new_password == undefined) {
        confirmForm.$setPristine();
      }
    }

    function confirm (new_password, new_password_repeat, confirmForm) {
      // After client error, enable display again.
      vm.showClientError = true;
      if (new_password !== new_password_repeat || securityService.formPasswordValidation(vm.validation) ) {
        return;
      }

      vm.submiting = true;
      securityService.passwordRenewal(uid, token, new_password)
      .then(function () {
        vm.confirmed = true;
        vm.success = true;
        $timeout(function() {
        }, 4000).then(function() {
          $state.go('auth.login');
        });
      }, function (error) {
        if (error.status === 400) {
          var errors = Array();
          lodash.forOwn(error.data, function(value, key) {
            errors = errors.concat(value);
          });
          vm.clientError = errors;
          confirmForm.new_password_repeat.$error.client = true;
        } else {
          vm.confirmed = true;
          vm.success = false;
        }
        $log.error(error);
      })
      .finally(function () {
        vm.submiting = false;
      });
    }

    function toggleInputType(input, inputType){
      inputType = inputType === 'password' ? 'text' : 'password';
      input.$name == 'new_password' ?
        vm.newPasswordType = inputType
      : vm.newPasswordRepeatType = inputType;
    }

    function _getSecuritySetting(data) {
      securityService.get(data).then(function(res){
        if(res.status !== 200){
          vm.policies = {
            "length": __env.DEFAULT_MIN_PASSWORD_LENGTH,
            "uppercase": false,
            "lowercase": false,
            "number": false,
            "symbol": false,
          };
        }else {
          var driver = res.data['is_mobile_user'];
          securityService.buildBodyToShow(res.data, driver, vm.policies);
        }
        securityService.buildValidation(vm.validation, vm.policies);
        if (res.status !== 204 && res.status !== 200) {
          throw 'Unexpected response status: ' + res.status;
        }
      }).catch(function(err) {
        $log.error(err);
      });
      showPoliciesInForm();
    }

    function showPoliciesInForm() {
      var form = document.getElementById('password-reset-form');
      var input = document.getElementById('newPassword');
      var policies = document.getElementById('password-reset-policies');
      var exceptions = document.getElementsByClassName('except_policies_hidden');
      if(form !== null && input !== null && policies !== null && exceptions !== null) {
        input.addEventListener('focus', function(event) {
          policies.style.display = "block";
        });
        form.addEventListener('click', function(event) {
          for(var i = 0; i < exceptions.length; i++){
            if(exceptions[i] === event.target) {
              return;
            };
          }
          policies.style.display = "none";
        });
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.authentication')
    .controller('ComplianceModalController', ComplianceModalController);

  /** @ngInject */
  function ComplianceModalController($scope, $sce, $filter, $log, $state, $timeout,
                                     ngDialog, complianceService, sessionService, documents) {

    var vm = this;
    var ORDER_FRAGMENT_RE = /#order(\d+)$/;

    vm.documents = documents || [];
    vm.activeIndex = 0;
    vm.legalVersion = vm.documents[0] && vm.documents[0].legal_version;
    vm.progress = {};
    vm.maxProgress = {};
    vm.scrollPositions = {};
    vm.acceptances = {};
    vm.errorMessage = null;
    vm.canRetry = false;
    vm.submitting = false;
    vm.scrollElement = null;

    vm.activeDocument = activeDocument;
    vm.activeProgress = activeProgress;
    vm.selectTab = selectTab;
    vm.onScroll = onScroll;
    vm.canCheck = canCheck;
    vm.canSubmit = canSubmit;
    vm.accept = accept;
    vm.retry = retry;
    vm.logout = logout;
    vm.trustHtml = trustHtml;
    vm.formatDate = formatDate;
    vm.handleContentClick = handleContentClick;

    activate();

    //////

    function activate() {
      vm.documents.forEach(function (doc) {
        vm.progress[doc.id] = 0;
        vm.maxProgress[doc.id] = 0;
        vm.scrollPositions[doc.id] = 0;
        vm.acceptances[doc.id] = false;
      });
    }

    function activeDocument() {
      return vm.documents[vm.activeIndex] || {};
    }

    function activeProgress() {
      var id = activeDocument().id;
      return id != null ? (vm.progress[id] || 0) : 0;
    }

    function selectTab(index) {
      if (index === vm.activeIndex) {
        return;
      }
      var current = activeDocument();
      if (current.id != null && vm.scrollElement) {
        vm.scrollPositions[current.id] = vm.scrollElement.scrollTop;
      }
      vm.activeIndex = index;
      // ng-bind-html replaces innerHTML, so the browser resets scrollTop to 0.
      // Defer restoration until the next digest so the new content is rendered.
      $timeout(function () {
        if (!vm.scrollElement) {
          return;
        }
        var nextId = activeDocument().id;
        vm.scrollElement.scrollTop = vm.scrollPositions[nextId] || 0;
        onScroll({ target: vm.scrollElement });
      });
    }

    function onScroll(event) {
      var target = event && event.target;
      if (!target) {
        return;
      }
      vm.scrollElement = target;
      var doc = activeDocument();
      if (doc.id == null) {
        return;
      }
      // Percentage represents how much of the document the user has revealed —
      // the bottom edge of the viewport relative to the total content height.
      // Starts at the fraction initially visible (e.g. 20%) and grows to 100%
      // when the user reaches the end. If the content fits without scroll,
      // (scrollTop + clientHeight) >= scrollHeight, so it caps at 100%.
      var scrollHeight = target.scrollHeight || 0;
      var pct = scrollHeight <= 0
        ? 0
        : Math.min(100, Math.round(((target.scrollTop + target.clientHeight) / scrollHeight) * 100));
      vm.progress[doc.id] = pct;
      if (pct > (vm.maxProgress[doc.id] || 0)) {
        vm.maxProgress[doc.id] = pct;
      }
    }

    function canCheck(doc) {
      if (!doc) {
        return false;
      }
      var required = doc.required_read_percentage || 0;
      return (vm.maxProgress[doc.id] || 0) >= required;
    }

    function canSubmit() {
      if (!vm.documents.length) {
        return false;
      }
      return vm.documents.every(function (doc) {
        return Boolean(vm.acceptances[doc.id]);
      });
    }

    function accept() {
      vm.submitting = true;
      vm.errorMessage = null;
      vm.canRetry = false;
      var ids = vm.documents.map(function (doc) {
        return doc.id;
      });
      complianceService.acceptDocuments(ids)
        .then(function () {
          ngDialog.close($scope, 'accepted');
        })
        .catch(function (err) {
          vm.submitting = false;
          if (err && (err.status === 401 || err.status === 403)) {
            sessionService.logout();
            $state.go('auth.login');
            ngDialog.close($scope, 'logout');
            return;
          }
          $log.warn('ComplianceModalController: acceptance failed', err);
          vm.errorMessage = 'Login.compliance.errorMessage';
          vm.canRetry = true;
        });
    }

    function retry() {
      // Close with 'retry' so the parent re-runs runComplianceGate (re-fetching the
      // active version) and reopens the modal with fresh documents.
      ngDialog.close($scope, 'retry');
    }

    function logout() {
      sessionService.logout();
      $state.go('auth.login');
      ngDialog.close($scope, 'logout');
    }

    function trustHtml(html) {
      return $sce.trustAsHtml(html || '');
    }

    function formatDate(iso) {
      if (!iso) {
        return '';
      }
      return $filter('date')(iso, 'longDate');
    }

    function parseOrderFragment(href) {
      if (!href) {
        return null;
      }
      var match = ORDER_FRAGMENT_RE.exec(href);
      return match ? parseInt(match[1], 10) : null;
    }

    function handleContentClick($event) {
      var anchor = $event.target;
      while (anchor && anchor !== $event.currentTarget && anchor.tagName !== 'A') {
        anchor = anchor.parentNode;
      }
      if (!anchor || anchor.tagName !== 'A') {
        return;
      }
      var targetOrder = parseOrderFragment(anchor.getAttribute('href'));
      if (targetOrder === null) {
        return;
      }
      $event.preventDefault();
      $event.stopPropagation();
      var index = -1;
      for (var i = 0; i < vm.documents.length; i++) {
        if (vm.documents[i].order === targetOrder) {
          index = i;
          break;
        }
      }
      if (index === -1) {
        $log.warn('compliance: no tab with order', targetOrder);
        return;
      }
      vm.selectTab(index);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('icarus.authentication')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($state, $scope, $window, __env, sessionService, chatService, plannerService, vehicleService,
                           skillsService, mobileGeneralService, driversService, store, $filter, $location,
                           apolloAuthService, userService, STATES, $rootScope, addonsService, ACCOUNT_STATUS,
                           PASSPHRASE_IDENTIFIER, DATA_ENCRYPTION_ADD_ON_KEY, redirectService, $q, SSO_DOMAIN_IDENTIFIER,
                           moduleHelpersService, accountConfigsService, complianceService, ngDialog) {

    var vm = this;
    var $translate = $filter('translate');
    vm.sessionExpired = $state.params['expired'];
    vm.errorMsg = null;
    vm.submiting = false;
    vm.remainingAttempts = 0;
    vm.newPasswordType = 'password';
    vm.credentials = {};

    vm.login = login;
    vm.ssoTokenLogin = ssoTokenLogin;
    vm.ssoRedirect = ssoRedirect;
    vm.ssoLoginText = ssoLoginText;
    vm.setNewPasswordType = setNewPasswordType;
    vm.goToInternalLogin = goToInternalLogin;

    activate();

    $scope.$watch('vm.credentials.username', function () {
      if (angular.isDefined(vm.credentials.username) && vm.credentials.username !== null) {
        vm.credentials.username = vm.credentials.username.toLowerCase();
      }
    });

    function activate() {
      if ($state.current.name !== 'auth.sso-login' && !apolloAuthService.areAuthParamsValid()) {
        store.remove(SSO_DOMAIN_IDENTIFIER);
      }
      plannerService.clearPlan();
      handleUserLoginRedirect();
    }

    function login(credentials) {
      vm.submiting = true;
      vm.loginForm.password.$error = {};
      var username = credentials.username.trim();

      $window.grecaptcha.enterprise.ready(function() {
        $window.grecaptcha.enterprise.execute(__env.GRECAPTCHA_KEY, {action: 'login'}).then(
          sendVerification
        );
      });

      function sendVerification(token) {
        sessionService.recaptchaValidation(token, 'login').then(successVerification, errorVerification);
      }

      function successVerification() {
        vm.promiseLoading = sessionService.login(username, credentials.password)
          .then(successLogin, errorLogin);

        function successLogin() {
          handleUserLoginRedirect();
        }

        function errorLogin(error) {
          vm.submiting = false;
          if (error.status === 403) {
            $state.go('auth.user-blocked');
            return;
          }
          if (error.status === 401) {
            if (error.data.remaining) {
              vm.remainingAttempts = error.data.remaining;
              if (vm.remainingAttempts === 1) {
                vm.loginForm.password.$error.last_try = true;
              } else {
                vm.loginForm.password.$error.remaining = true;
              }
              return;
            }
            vm.loginForm.password.$error.invalid = true;
            vm.loginForm.password.$invalid = true;
          }
          if (error.status === 412) {
            $state.go('auth.password-renewal',
              { 'uid': error.data.uid, 'token': error.data.token });
          }
        }
      }

      function errorVerification() {
        $state.go('auth.login-failed');
      }
    }

    function ssoTokenLogin() {
      // performs a cleanup to make sure no other session is active
      sessionService.logout();
      chatService.closeChatSession();
      plannerService.clearPlan();
      vehicleService.clear();
      skillsService.clear();
      mobileGeneralService.clear();
      driversService.clear();
      vm.ssoDomain = $state.params['domain'] || __env.DEFAULT_SSO_DOMAIN;
      if (vm.ssoDomain !== "") {
        store.set(SSO_DOMAIN_IDENTIFIER, vm.ssoDomain);
      }

      var token = $state.params['token'];
      if (token != null) {
        sessionService.ssoLogin(token);
        var embedded = $state.params['embedded'];
        var isEmbedded = Boolean(embedded) && embedded.toLowerCase() === 'true';
        sessionService.setIsEmbedded(isEmbedded);
        handleUserLoginRedirect();
      } else {
        vm.showSsoLanding = true;
        vm.distributionCenter = $state.params['dc'];
        vm.allowInternalLogin = __env.ALLOW_INTERNAL_LOGIN;
      }
    }

    function ssoRedirect(domain, account){
      sessionService.ssoRedirect(domain, account);
    }

    function ssoLoginText() {
      return $translate('Login.login_sso');
    }

    function setNewPasswordType(){
      vm.newPasswordType === 'password' ?
        vm.newPasswordType = 'text'
        : vm.newPasswordType = 'password';
    }

    function goToInternalLogin() {
      $state.go('auth.login');
    }


    function handleUserLoginRedirect() {
      $rootScope.$broadcast('Authentication:ShowSpinner', {
        isAuthenticating: true
      });

      // Two valid sources of auth: a persisted token (returning user) or an
      // in-memory pending token from a fresh login that hasn't passed the
      // post-login gates yet (e.g. compliance acceptance).
      if (!store.get('token') && !sessionService.hasPendingAuth()) {
        $rootScope.$broadcast('Authentication:ShowSpinner', {
          isAuthenticating: false
        });

        return;
      }

      // allowPendingAuth=true lets the post-login flow read the in-memory token
      // before it has been persisted (deferred until compliance acceptance).
      return sessionService.getUser(false, true)
        .then(function (user) {
          // Run the compliance gate BEFORE any other post-login routing
          // (multi-account, encryption, Apollo, cancelled). After acceptance
          // we persist the token and resume the normal flow.
          return _runComplianceGateAndRedirect(user, function doRedirect() {
            // Persist the in-memory token to localStorage / cookies now that the
            // user has cleared the compliance gate. No-op if already persisted
            // (returning user).
            sessionService.persistAuth();
            return _continueLoginRedirect(user);
          });
        })
        .catch(function (err) {
          if (err && err.status === 401) {
            sessionService.logout();
            $state.go('auth.login');
          }
        });
    }

    function _continueLoginRedirect(user) {
      var stateToRedirectToApollo = apolloAuthService.areAuthParamsValid() ? $location.search().state : null;

      if (userService.hasMultiAccount(user) && !sessionService.isAccountSet()) {
        handleMultiAccountRedirect(stateToRedirectToApollo);
        return;
      }

      var accountStatusCancelled = Boolean(user.account) && user.account.status === ACCOUNT_STATUS.CANCELED;

      var isAddonEnablePromise = accountStatusCancelled ? $q.when(false) : addonsService.isAddonEnable(DATA_ENCRYPTION_ADD_ON_KEY);

      return isAddonEnablePromise.then(function (isEncryptionAddOnEnabled) {
          if (isEncryptionAddOnEnabled && !store.get(PASSPHRASE_IDENTIFIER)) {
            // Don't clear the URL parameters before redirecting to encryption-passphrase
            var stateToRedirect = $location.search().state;
            var redirectPath = $location.search().redirectPath;
            redirectService.handleEncryptionPassphraseRedirect(stateToRedirect, redirectPath);
            return;
          }

          // Only handle direct Apollo redirect if encryption is not enabled
          if (stateToRedirectToApollo) {
            apolloAuthService.redirect(apolloAuthService.buildAuthURL(stateToRedirectToApollo));
            return;
          }

          if (accountStatusCancelled) {
            $window.location.href = apolloAuthService.buildRedirectURL(moduleHelpersService.getCurrentLanguage() + "/profile");
            return;
          }

          return $q.all({
            isRouteDesignerEnabled: accountConfigsService.getConfigByKey("enable_route_designer"),
            isApolloRouteDesignerEnabled: addonsService.isApolloRouteDesignerEnabled()
          })
            .then(function (results) {
              var redirectState = userService.getRedirectStateByUserRole(user, results.isRouteDesignerEnabled, results.isApolloRouteDesignerEnabled);
              if (redirectState) {
                $state.go(redirectState);
              }
            });
        });
    }

    function _runComplianceGateAndRedirect(user, doRedirect) {
      return complianceService.runComplianceGate(user)
        .then(function (gateResult) {
          if (!gateResult.shouldBlock) {
            doRedirect();
            return;
          }
          _openComplianceModal(gateResult.documents, function (resolution) {
            if (resolution === 'accepted') {
              doRedirect();
            } else if (resolution === 'retry') {
              _runComplianceGateAndRedirect(user, doRedirect);
            }
            // 'logout' or anything else → modal already redirected to auth.login
          });
        });
    }

    function _openComplianceModal(documents, onResolution) {
      // Stop the auth spinner — the modal blocks the page anyway and the spinner
      // stays visible behind it because we're no longer navigating to the dashboard.
      $rootScope.$broadcast('Authentication:ShowSpinner', { isAuthenticating: false });

      var dialog = ngDialog.open({
        template: 'app/authentication/compliance-modal/compliance-modal.html',
        controller: 'ComplianceModalController',
        controllerAs: 'vm',
        className: 'ngdialog-theme-default sp-compliance-modal',
        showClose: false,
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,
        resolve: {
          documents: function () { return documents; }
        }
      });
      dialog.closePromise.then(function (data) {
        onResolution(data && data.value);
      });
    }

    function handleMultiAccountRedirect(stateToRedirectToApollo) {
      var params = {};
      if (stateToRedirectToApollo) {
        params['stateToRedirect'] = stateToRedirectToApollo;
      }

      $state.go(STATES.ACCOUNT_SELECTOR, params);
    }

  }
})();

(function() {
    'use strict';

    angular
        .module('icarus.authentication')
        .controller('EncryptionController', EncryptionController);

    /** @ngInject */
    function EncryptionController($rootScope, store, $http, saveDraftPlanService,
                                  DRAFT_FOR_APOLLO, $state, userService, sessionService,
                                  apolloAuthService, __env, PASSPHRASE_IDENTIFIER,
                                  addonsService, $location, SSO_DOMAIN_IDENTIFIER,
                                  SSO_LOGOUT_ADDON_KEY, accountConfigsService, $q,
                                  ssoChannelsService) {

        var vm = this;
        vm.storePassphrase = storePassphrase;
        vm.setNewPassphraseType = setNewPassphraseType;
        vm.goBack = goBack;
        vm.passphrase = '';
        vm.user = null;
        vm.ssoDomain = null;
        vm.ssoChannels = null;
        vm.newPassphraseType = "password";
        var CHECK_PASSPHRASE_URL = __env.API_URL + 'auth/check-passphrase';

        vm.stateToRedirectToApollo = $state.params.stateToRedirect || sessionStorage.getItem('apollo_state') || $location.search().state;
        vm.pathToRedirectToApollo = $state.params.redirectPath || sessionStorage.getItem('apollo_path') || $location.search().redirectPath;

        function _init() {
          return sessionService.getUser()
            .then(function (user) {
              vm.user = user;
              vm.ssoDomain = user.account.sso_domain;
              vm.ssoChannels = user.account.sso_channels;
            })
            .catch(function () {
              $state.go('auth.login');
            });
        }

        function activate() {
          $rootScope.$broadcast('Authentication:ShowSpinner', {
            isAuthenticating: false
          });

          _init();
        }

        activate();

        function storePassphrase() {
          if (!vm.passphrase) {
            return;
          }

          vm.passphrase = vm.passphrase.trim();
          setPassphrase(vm.passphrase);
        }

        function checkPassphraseValid(passphrase) {
          // Check if passphrase is valid by calling icarus-api
          return $http.get(CHECK_PASSPHRASE_URL, {headers: {Passphrase: passphrase}});
        }

        function setPassphrase(passphrase) {
          checkPassphraseValid(passphrase)
            .then(function () {
                store.set(PASSPHRASE_IDENTIFIER, passphrase);
                $http.defaults.headers.common[PASSPHRASE_IDENTIFIER] = passphrase;
                _handleRedirect();
              })
              .catch(function () {
                vm.passphraseForm.passphrase.$error.invalid = true;
                vm.passphraseForm.passphrase.$invalid = true;
                return;
              });
        }

        function _handleRedirect() {
          saveDraftPlanService.deleteDraftPlan(DRAFT_FOR_APOLLO);

          if (vm.stateToRedirectToApollo || vm.pathToRedirectToApollo) {
            handleRedirectToApollo();
            return;
          }

          return $q.all({
            isRouteDesignerEnabled: accountConfigsService.getConfigByKey("enable_route_designer"),
            isApolloRouteDesignerEnabled: addonsService.isApolloRouteDesignerEnabled()
          })
            .then(function (results) {
              $state.go(userService.getRedirectStateByUserRole(vm.user, results.isRouteDesignerEnabled, results.isApolloRouteDesignerEnabled));
            });
        }

        // Check if apollo login is needed
        function handleRedirectToApollo() {
          sessionStorage.removeItem('apollo_state');
          sessionStorage.removeItem('apollo_path');

          if (vm.stateToRedirectToApollo) {
            apolloAuthService.redirect(apolloAuthService.buildAuthURL(vm.stateToRedirectToApollo));
            return;
          }

          if (vm.pathToRedirectToApollo) {
            apolloAuthService.redirect(apolloAuthService.buildRedirectURL(vm.pathToRedirectToApollo));
            return;
          }

          return $q.all({
            isRouteDesignerEnabled: accountConfigsService.getConfigByKey("enable_route_designer"),
            isApolloRouteDesignerEnabled: addonsService.isApolloRouteDesignerEnabled()
          })
            .then(function (results) {
              $state.go(userService.getRedirectStateByUserRole(vm.user, results.isRouteDesignerEnabled, results.isApolloRouteDesignerEnabled));
            });
        }

        function setNewPassphraseType() {
          vm.newPassphraseType === 'password' ?
            vm.newPassphraseType = 'text'
            : vm.newPassphraseType = 'password';
        }

        function goBack() {
          addonsService.isAddonEnable(SSO_LOGOUT_ADDON_KEY).then(function (isSsoLogoutAddonEnabled) {

          if ($rootScope.previousStateObj) {
            if ($rootScope.previousStateObj.name === 'auth.account-selector') {
              $state.go('auth.account-selector');
              addonsService.clearAddons();
              addonsService.removeCache();
              return;
            } else if (['auth.sso-login', 'auth.login'].includes($rootScope.previousStateObj.name)) {
              sessionService.logout();
              if (ssoChannelsService.hasWebSso(vm.ssoDomain, vm.ssoChannels)) {
                if (isSsoLogoutAddonEnabled && store.get(SSO_DOMAIN_IDENTIFIER)) {
                  store.remove(SSO_DOMAIN_IDENTIFIER);
                  sessionService.ssoLogoutRedirect(vm.ssoDomain);
                } else {
                  $state.go('auth.sso-login', {domain: vm.ssoDomain});
                }
              } else if (ssoChannelsService.excludesWebSso(vm.ssoDomain, vm.ssoChannels)) {
                $state.go('auth.login');
              } else if (__env.USE_SSO_AS_MAIN_SCREEN && __env.DEFAULT_SSO_DOMAIN) {
                $state.go('auth.sso-login');
              } else {
                $state.go('auth.login');
              }
              return;
            }
          }

          _handleRedirect();
          });
        }
    }
})();

/**
 * Created by rodrigo on 05-02-18.
 */
(function() {
  'use strict';

  angular
    .module('icarus.assigner', []);
})();

(function () {
  'use strict';

  angular
    .module('icarus.assigner')
    .factory('assignerService', assignerService);

  /** ngInject*/
  function assignerService(geocoderService, $q, $http, __env, lodash, vehicleService, driverService, osrmService, timeUtils, plannerService, accountConfigsService) {
    var API_URL = accountConfigsService.isConfigEnabled('use_async_plan_creation') ? __env.APIV2_URL : __env.API_URL;
    var CREATE_PLAN_URL = API_URL + 'plans/create-plan/';
    var NO_VEHICLE = 'no-vehicle';
    var NO_ID = -1;

    return {
      buildRequest: buildRequest,
      createPlan: createPlan,
      listVehicles: listVehicles,
      listDrivers: listDrivers,
      prepareRowsAndFilterVehicles: prepareRowsAndFilterVehicles,
      calculateTimes: calculateTimes,
      getRowDataExtendedAndVehicles: getRowDataExtendedAndVehicles,
      isValidGeolocCoord: isValidGeolocCoord,
      emailValidation: emailValidation,
      contactValidation: contactValidation
    };

    function listVehicles() {
      var deferred = $q.defer();
      var vehicles = [];
      vehicleService.list().then(function (data) {
        data.forEach(function (vehicle) {
          vehicles.push({
            id: vehicle.id,
            name: vehicle.name,
            default_driver: vehicle.default_driver,
            color: vehicle.color,
            location_start_address: vehicle.location_start_address,
            location_start_latitude: vehicle.location_start_latitude,
            location_start_longitude: vehicle.location_start_longitude,
            location_end_address: vehicle.location_end_address,
            location_end_latitude: vehicle.location_end_latitude,
            location_end_longitude: vehicle.location_end_longitude
          });
        });
        deferred.resolve(vehicles);
      }).catch(function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    }

    function listDrivers() {
      var deferred = $q.defer();
      var drivers = [];
      driverService.list().then(function (data) {
        data.forEach(function (vehicle) {
          drivers.push({
            id: vehicle.id,
            name: vehicle.name
          });
        });
        deferred.resolve(drivers);
      }).catch(function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function buildCoordinates(vehicle, visits) {
      var coordinates = [{ latitude: vehicle.location_start_latitude, longitude: vehicle.location_start_longitude, duration: '00:00' }];
      visits.forEach(function (visit) {
        coordinates.push({ latitude: visit.latitude, longitude: visit.longitude, duration: visit.duration });
      });
      return coordinates;
    }

    function createPlan(request) {
      return $http.post(CREATE_PLAN_URL, request);
    }

    function getRowDataExtendedAndVehicles(rows, vehicles) {
      var output = { data: [], vehicles: {} };
      var i = 1;
      rows.forEach(function (row) {
        var vehicle = vehicles.find(function (vehicle) { return vehicle.name === row.vehicle; });
        var newRow = angular.copy(row);
        newRow.id = i;
        if (vehicle) {
          newRow.vehicleId = vehicle.id;
          output.vehicles[vehicle.id] = angular.copy(vehicle);

        } else {
          newRow.vehicleId = NO_ID;
          newRow.vehicle = NO_VEHICLE;
        }
        output.data.push(newRow);
        i++;
      });
      return output;
    }

    function prepareRowsAndFilterVehicles(startTime, rows, vehicles,
                                          visitsProgressCallback, estimationCallback, accountCountry, accountGeocoderQualityLevel) {
      var deferred = $q.defer();
      var output = getRowDataExtendedAndVehicles(rows, vehicles);
      var notifyProgress;
      var groupedVisits;

      visitsProgressCallback = visitsProgressCallback instanceof Function ? visitsProgressCallback : angular.noop;
      estimationCallback = estimationCallback instanceof Function ? estimationCallback : angular.noop;

      if (output.data.length > 0) {
        notifyProgress = notifyVisitsProgress.bind({ progress: 0, total: output.data.length }, visitsProgressCallback);

        prepareVisitsAndNotify(output.data, accountCountry, accountGeocoderQualityLevel, notifyProgress)
          .then(function (result) {
            var visitsPromises = [];
            groupedVisits = lodash.groupBy(result, 'vehicleId');

            lodash.each(groupedVisits, function (visits, key) {
              if (key !== NO_ID.toString()) {
                var orderedVisits = visits.map(function (visit, i) { return angular.extend({}, visit, { order: i + 1 }); });
                var routeVehicle = output.vehicles[orderedVisits[0].vehicleId];

                visitsPromises.push(calculateTimes(startTime, routeVehicle, orderedVisits, estimationCallback));
              }

            });

            return $q.all(visitsPromises);

          }).then(function (resolvedVisits) {
          var data = [];
          var vehiclesFiltered = [];
          resolvedVisits.forEach(function (resolvedVisitArray) {
            data = data.concat(resolvedVisitArray);
          });

          if (groupedVisits[-1]) {
            data = data.concat(groupedVisits['-1']);
          }

          lodash.each(output.vehicles, function (vehicle) {
            vehiclesFiltered.push(vehicle);
          });

          deferred.resolve({ data: data, vehicles: vehiclesFiltered });
        }).catch(function (error) {
          deferred.reject(error);
        });
      } else {
        deferred.reject('visitas inválidas');
      }

      return deferred.promise;
    }

    function isValidGeolocCoord(lat, long) {
      var parsedLat = parseFloat(lat);
      var parsedLong = parseFloat(long);
      var validLat = !isNaN(parsedLat) && parsedLat >= -90 && parsedLat <= 90;
      var validLong = !isNaN(parsedLong) && parsedLat >= -180 && parsedLat <= 180;
      return validLat && validLong;
    }

    function waitGeocode(accountCountry, accountGeocoderQualityLevel, addressesBatch, notify){
      return wrapPromiseAndNotify(geocoderService.geocodeBatch(accountCountry, accountGeocoderQualityLevel, addressesBatch), notify);
    }
    //simulate a sequencial request, executing one and wait the response
    function sequencialRequestAtTime(accountCountry, accountGeocoderQualityLevel, visits, notify) {
      var results =  [];
      var defer = $q.defer();
      //one batch represent batch[500] with index 500 or DEFAULT_BATCH_GEOCODER_SERVICE
      visits.reduce(function(visitPromise, oneBatch) {
        return visitPromise.then(function() {
            return waitGeocode(accountCountry, accountGeocoderQualityLevel, oneBatch, notify).then(function(result){
              results.push(result);
              return true;
            });
        });
      }, $q.when(true))
        .then(function() {
            defer.resolve(results);
        }, function(err) {
            defer.reject();
        });

      return defer.promise;
    }
    function fixGeoReference(geoPoint) {
      return parseFloat(parseFloat(geoPoint).toFixed(6));
    }

    function prepareVisitsAndNotify(visits, accountCountry, accountGeocoderQualityLevel, notify) {
      var deferred = $q.defer();
      var maxBatch = __env.DEFAULT_BATCH_GEOCODER_SERVICE || 500;
      var addressesBatch = [];

      visits.forEach(function (visit) {
        var validLatLon = isValidGeolocCoord(visit.latitude, visit.longitude);
        if (!validLatLon) {
          addressesBatch.push(
            {
              address: visit.address,
              id: visit.id
            }
          );
        }
      });

      var validateBatch = lodash.chunk(addressesBatch, maxBatch);
      sequencialRequestAtTime(accountCountry, accountGeocoderQualityLevel, validateBatch, notify).then(function (geocodedAddressResponse) {
          var geocodedAddress = {};
          geocodedAddressResponse.forEach(function(response){
            Object.keys(response.data).forEach(function(key) {
              geocodedAddress[key] = response.data[key];
            });
          });
          var newVisits = [];
          visits.forEach(function (visit) {
            var validLatLon = isValidGeolocCoord(visit.latitude, visit.longitude);
            if (!validLatLon) {
              visit.latitude = geocodedAddress.hasOwnProperty(visit.id)
                ? fixGeoReference(geocodedAddress[visit.id].latitude || 0)
                : 0;
              visit.longitude = geocodedAddress.hasOwnProperty(visit.id)
                ? fixGeoReference(geocodedAddress[visit.id].longitude || 0)
                : 0;
            } else {
              visit.latitude = fixGeoReference(visit.latitude);
              visit.longitude = fixGeoReference(visit.longitude);
            }
            visit.duration = '10:00';
            newVisits.push(visit);
          });
          deferred.resolve(newVisits);
        })
        .catch(function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    function wrapPromiseAndNotify(promise, notify) {
      var deferred = $q.defer();

      promise.then(function (val) {
        notify();
        deferred.resolve(val);
      }).catch(function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function notifyVisitsProgress(cb) {
      this.progress++;
      cb({ progress: this.progress, total: this.total });
    }


    function buildRequest(plan, rows, vehicles) {
      var request = {};
      var routes = [];
      var routeIndex = 0;
      var groupedData;

      request.name = plan.name;
      request.start_date = plan.plannedDate;
      request.end_date = plan.plannedDate;
      request.routes = routes;

      groupedData = lodash.groupBy(rows, 'vehicleId');
      lodash.each(groupedData, function (groupedVisits) {
        if (groupedVisits.length > 0) {
          var vehicle = lodash.find(vehicles, function (o) { return o.id === groupedVisits[0].vehicleId; });
          if (vehicle) {
            routes.push({
              vehicle: vehicle.id,
              driver: vehicle.default_driver,
              planned_date: plan.plannedDate,
              location_start_address: vehicle.location_start_address,
              location_start_latitude: vehicle.location_start_latitude,
              location_start_longitude: vehicle.location_start_longitude,
              location_end_address: '',
              location_end_latitude: 0,
              location_end_longitude: 0,
              estimated_time_start: groupedVisits[0].routeEstimatedTimeStart,
              estimated_time_end: groupedVisits[0].routeEstimatedTimeEnd,
              total_duration: groupedVisits[0].routeTotalTime,
              visits: []
            });

            groupedVisits.forEach(function (visit) {
              routes[routeIndex].visits.push({
                id: null,
                address: visit.address,
                title: visit.title,
                duration: visit.duration,
                planned_date: plan.plannedDate,
                latitude: visit.latitude,
                longitude: visit.longitude,
                order: visit.order,
                contact_name: visit.contact_name !== undefined ? contactValidation(visit.contact_name) : '',
                contact_phone: visit.contact_phone !== undefined ? contactValidation(visit.contact_phone) : '',
                contact_email: visit.contact_email !== undefined ? emailValidation(visit.contact_email) : '',
                reference: (visit.reference && angular.isString(visit.reference)) ?
                  visit.reference.substring(0, 254) : '',
                notes: visit.notes || '',
                skills_required: [],
                skills_optional: [],
                estimated_time_arrival: visit.estimatedTimeArrival,
                estimated_time_departure: visit.estimatedTimeDeparture
              });
            });

            routes[routeIndex].location_end_address = vehicle.location_end_address;
            routes[routeIndex].location_end_latitude = vehicle.location_end_latitude;
            routes[routeIndex].location_end_longitude = vehicle.location_end_longitude;

            routeIndex++;
          }
        }
      });

      return request;
    }

    function emailValidation(emails) {
      var notAnEmail=[];
      var isAnEmail = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      emails = emails.toString().replace(/\s/g, '').split(',');
      emails.forEach(function(email) {
        if(!isAnEmail.test(email)){
          notAnEmail.push(email);
        }
      });
      emails = removeItemsFromArray(emails, notAnEmail);
      emails = emails.toString().replace(/,/g, ', ');
      return emails;
    };

    function contactValidation(contact){
      typeof contact !== 'number' ? contact : contact = '';
      return contact;
    }

    function removeItemsFromArray(arr, items) {
      items.forEach(function(item) {
        var found = arr.indexOf(item);
        while (found !== -1) {
          arr.splice(found, 1);
          found = arr.indexOf(item);
        }
      });
      return arr;
    };

    function calculateTimes(startTime, vehicle, visits, cb) {
      var deferred = $q.defer();
      var newVisits = [];
      var coords = buildCoordinates(vehicle, visits);

      cb = cb instanceof Function ? cb : angular.noop;
      cb('started');

      var speedRate = plannerService.optimizationOptions.fmv;

      osrmService.addETAandETDToVisits(startTime, coords, speedRate)
        .then(function (times) {
          var routeStartTime = times[0].estimatedTimeArrival;
          var routeEndTime = times[times.length - 1].estimatedTimeDeparture;
          var routeTotalTime = timeUtils.diffWithFormat(routeStartTime, routeEndTime, 'HH:mm:ss');

          newVisits = visits.map(function (visit, i) {
            var newVisit = angular.copy(visit);
            newVisit.estimatedTimeArrival = times[i + 1].estimatedTimeArrival;
            newVisit.estimatedTimeDeparture = times[i + 1].estimatedTimeDeparture;
            newVisit.routeEstimatedTimeStart = times[0].estimatedTimeDeparture;
            newVisit.routeEstimatedTimeEnd = times[times.length - 1].estimatedTimeDeparture;
            newVisit.routeTotalTime = routeTotalTime;
            return newVisit;
          });

          cb('ended');
          deferred.resolve(newVisits);
        }).catch(function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    }
  }

})();

(function (){
  'use strict';

  angular
    .module('icarus.authentication')
    .controller('AccountNotConfirmedController', AccountNotConfirmedController);

  function AccountNotConfirmedController (sessionService, $scope, $state, ngDialog) {

    var vm = this;
    vm.disabledLink = false;
    vm.mailResend = false;
    vm.resendConfirmationEmail = resendConfirmationEmail;
    vm.deleteMessage = deleteMessage;
    vm.goOut = goOut;

    function resendConfirmationEmail () {
      vm.disabledLink = true;
      sessionService.resendConfirmationEmail()
        .then(function () {
          vm.mailResend = true;
          vm.deleteMessage();
        })
        .finally(function () {
          vm.disabledLink = false;
        });
    }

    function goOut () {
      sessionService.logout();
      ngDialog.closeAll();
      $state.go('auth.login');
    }

    function deleteMessage () {
      setTimeout(function ( ) {
        $scope.$apply(function () {
          vm.mailResend = false;
        });
      }, 2500);
    }
  }
})();

(function (){
  'use strict';

  angular
    .module('icarus.authentication')
    .controller('AccountConfirmedController', AccountConfirmedController);

  function AccountConfirmedController (sessionService, $stateParams, $log, __env) {

    var vm = this;
    var uid = '';
    var token = '';
    vm.showConfirmMessage = false;
    vm.showErrorMessage = false;
    vm.confirmAccount = confirmAccount;
    vm.accountTrialDays = __env.ACCOUNT_TRIAL_DAYS;

    activate();

    function activate () {
        uid = $stateParams.uid;
        token = $stateParams.token;
        vm.confirmAccount(uid, token);
    }

    function confirmAccount (uid, token) {
      vm.showConfirmMessage = false;
      sessionService.confirmAccount(uid, token, getBrowserLanguage())
        .then(function success () {
          vm.showConfirmMessage = true;
        })
        .catch(function error (e) {
          vm.showErrorMessage = true;
          $log.error(e);
        });
    }

    function getBrowserLanguage() {
      var language = 'en';
      var locale = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);

      if (locale.substring(0, 2).toLowerCase() === 'es') {
        language = 'es';
      } else if (locale.substring(0, 2).toLowerCase() === 'pt') {
        language = 'pt';
      }

      return language;
    }

  }
})();

(function () {
  'use strict';
  angular
    .module('icarus.authentication')
    .controller('AccountSelectorController', AccountSelectorController);

  /** @ngInject */
  function AccountSelectorController($state, __env, sessionService, plannerService, $filter,
                                      $location, apolloAuthService, userService, $rootScope,
                                      saveDraftPlanService, DRAFT_FOR_APOLLO, addonsService,
                                      DATA_ENCRYPTION_ADD_ON_KEY, store, PASSPHRASE_IDENTIFIER,
                                      redirectService, SSO_LOGOUT_ADDON_KEY, SSO_DOMAIN_IDENTIFIER,
                                      $log, accountConfigsService, $q, ssoChannelsService) {
    var vm = this;
    var $localeCompare = $filter("localeCompare");

    vm.user = null;
    vm.accounts = [];
    vm.ssoDomain = null;
    vm.ssoChannels = null;
    vm.currentAccount = null;
    vm.goBack = goBack;
    vm.selectAccount = selectAccount;

    activate();

    ////////////

    function _init() {
      vm.currentAccount = sessionService.unsetAccount();
      vm.stateToRedirectToApollo = $state.params['stateToRedirect'];
      vm.pathToRedirectToApollo = $location.search().redirectPath;

      return sessionService.getUser()
        .then(function (user) {
          vm.user = user;
          if (user.organization) {
            vm.accounts = user.organization.accounts || [];
          }

          vm.accounts.sort(function (accountA, accountB) {
            return $localeCompare(accountA.name, accountB.name);
          });

          vm.ssoDomain = user.account.sso_domain;
          vm.ssoChannels = user.account.sso_channels;
        })
        .catch(function () {
          vm.goBack();
        });
    }

    function goBack() {
      if (vm.currentAccount) {
        sessionService.setAccount(vm.currentAccount);
        _handleRedirect();
        return;
      }
      addonsService.isAddonEnable(SSO_LOGOUT_ADDON_KEY).then(function (isSsoLogoutAddonEnabled) {
        sessionService.logout();
        if (ssoChannelsService.hasWebSso(vm.ssoDomain, vm.ssoChannels)) {
          if (isSsoLogoutAddonEnabled && store.get(SSO_DOMAIN_IDENTIFIER)) {
            store.remove(SSO_DOMAIN_IDENTIFIER);
            sessionService.ssoLogoutRedirect(vm.ssoDomain);
          } else {
            $state.go('auth.sso-login', {domain: vm.ssoDomain});
          }
        } else if (ssoChannelsService.excludesWebSso(vm.ssoDomain, vm.ssoChannels)) {
          $state.go('auth.login');
        } else if (__env.USE_SSO_AS_MAIN_SCREEN && __env.DEFAULT_SSO_DOMAIN) {
          $state.go('auth.sso-login');
        } else {
          $state.go('auth.login');
        }
      })
      .catch(function (error) {
        $log.error(error);
        sessionService.logout();
        $state.go('auth.login');
      });
    }

    function selectAccount(account) {
      sessionService.setAccount(account.id);
      return addonsService.isAddonEnable(DATA_ENCRYPTION_ADD_ON_KEY)
        .then(function (isEncryptionAddOnEnabled) {
          if (isEncryptionAddOnEnabled && !store.get(PASSPHRASE_IDENTIFIER)) {
            redirectService.handleEncryptionPassphraseRedirect(vm.stateToRedirectToApollo, vm.pathToRedirectToApollo);
            return;
          }

          _handleRedirect();
        })
        .catch(function (error) {
          _handleRedirect();
        });

    }

    function activate() {
      $rootScope.$broadcast('Authentication:ShowSpinner', {
        isAuthenticating: false
      });

      plannerService.clearPlan();
      _init();
    }

    function _handleRedirect() {
      saveDraftPlanService.deleteDraftPlan(DRAFT_FOR_APOLLO);
      if (vm.stateToRedirectToApollo || vm.pathToRedirectToApollo) {
        handleRedirectToApollo();
      }

      return $q.all({
        isRouteDesignerEnabled: accountConfigsService.getConfigByKey("enable_route_designer"),
        isApolloRouteDesignerEnabled: addonsService.isApolloRouteDesignerEnabled()
      })
        .then(function (results) {
          $state.go(userService.getRedirectStateByUserRole(vm.user, results.isRouteDesignerEnabled, results.isApolloRouteDesignerEnabled));
        });
    }

    /**
     *  Handles the redirection to Apollo based on the provided state or path.
     *  If a state is specified, it means that authentication to apollo is required.
     *    therefore it is redirected using the Apollo Authentication URL.
     *  if a path is specified, it redirects using the Apollo redirect URL.
     *
     *  stateToRedirectToApollo - The state to be used in the Apollo authentication URL.
     *    This state is used to maintain the state of the user's in Apollo session during the authentication process.
     *    Example: "X5kmBcrTQamrG7i4_gH3yGD1WarrhcX_sS-oCX8j_e4"
     *
     *  pathToRedirectToApollo - The path to be used in the Apollo redirect URL.
     *    This is a standard URL path, such as "/visits".
     */
    function handleRedirectToApollo() {
      if (vm.stateToRedirectToApollo) {
        apolloAuthService.redirect(apolloAuthService.buildAuthURL(vm.stateToRedirectToApollo));
        return;
      }

      if (vm.pathToRedirectToApollo) {
        apolloAuthService.redirect(apolloAuthService.buildRedirectURL(vm.pathToRedirectToApollo));
        return;
      }
    }
  }
})();

(function() {
  'use strict';


  function visitRowCtrl($scope) {
    var ctrl = this;

  }

  var visitRowConfig = {
    templateUrl: 'app/assigner/components/visitRow.template.html',
    controller: ['$scope', visitRowCtrl],
    bindings: {
      data: '<',
      color: '<'
    }
  };

  angular
    .module('icarus.assigner')
    .component('visitRow', visitRowConfig);
})();

(function() {
  'use strict';


  function vehicleTabCtrl($scope) {
    var ctrl = this;

  }

  var vehicleTabConfig = {
    templateUrl: 'app/assigner/components/vehicleTab.template.html',
    controller: ['$scope', vehicleTabCtrl],
    bindings: {
      data: '<',
      width: '<',
      onClickHandler: '&',
      selected: '='
    }
  };


  angular
    .module('icarus.assigner')
    .component('vehicleTab', vehicleTabConfig);
})();

(function() {
  'use strict';

  function spCarLoaderCtrl($scope) {
    var vm = this;

    vm.properties = {
      show: false,
      width: '',
      value: 0,
      max: 100
    };

    this.$onInit = function() {
      checkValues(vm.value, vm.max);

      vm.properties.show = (vm.show === undefined || !!vm.show);
      vm.properties.value = vm.value;
      vm.properties.max = vm.max;
      vm.properties.width = calculateWidth(vm.value, vm.max);
    };

    this.$onChanges = function(o) {
      if(o.value && o.max) {
        vm.properties.value = o.value.currentValue;
        vm.properties.max = o.max.currentValue;
        vm.properties.width = calculateWidth(o.value.currentValue, o.max.currentValue);
      }else if(o.value) {
        vm.properties.value = o.value.currentValue;
        vm.properties.width = calculateWidth(o.value.currentValue, vm.max);
      }else if(o.max) {
        vm.properties.max = o.max.currentValue;
        vm.properties.width = calculateWidth(vm.value, o.max.currentValue);
      }

      if (o.show) {
        vm.properties.show = o.show.currentValue;
        if (!o.show.currentValue) {
          vm.properties.value = 0;
          vm.properties.max = vm.max;
          vm.properties.width = '0%';
        }

      }
    };

    function checkValues(val, max) {
      if (typeof max !== 'number' || max <= 0) {
        throw new Error('[spCarLoaderComponent]: max property should be defined and be greater than zero.');
      }else if(typeof val != 'number') {
        throw new Error('[spCarLoaderComponent]: value property should be a number.');
      }else if (val > max) {
        throw new Error('[spCarLoaderComponent]: value property can\'t be greater than max property.');
      }
    }

    function calculateWidth(val, max) {
      return Math.floor((val/max)*100) + '%';
    }
  }



  function getTemplate() {
    return '<div class="sp-car-loader" ng-if="$ctrl.properties.show">' +
        '<div class="sp-car-loader-container">'+
        '<div class="loading" style="width:{{$ctrl.properties.width}}">'+
        '<div class="sp-truck-on-move">'+
        '<img class="gif" ng-src="../../../assets/images/loader-progress.gif"/>'+
        '</div>'+
        '</div>'+
        '<uib-progressbar max="$ctrl.properties.max" value="$ctrl.properties.value"><i ng-transclude></i></uib-progressbar>'+
        '</div>'+
      '</div>';
  }

  var config = {
    transclude: true,
    template: getTemplate(),
    controller: ['$scope', spCarLoaderCtrl],
    bindings: {
      show:'<',
      max: '<',
      value: '<'
    }
  };

  angular
    .module('icarus.shared')
    .component('spCarLoader', config);

})();

(function() {
  'use strict';

  function routesTableCtrl($scope, $document, $state, lodash) {
    var ctrl = this;
    ctrl.selectedVehicleVisits = [];
    ctrl.visibleTabs = [];
    ctrl.tabWidth = 100;
    ctrl.indexSelected = 0;
    ctrl.selectedVehicleId = null;
    ctrl.tabsRange = [0, 5];
    ctrl.changeTab = changeTab;
    ctrl.scrollLeft = scrollLeft;
    ctrl.scrollRight = scrollRight;
    ctrl.goToVehicleCreate = goToVehicleCreate;

    var groupedVisits = {};

    this.$onChanges = function() {
      if (ctrl.vehicles.length) {
        var rangeEnd = ctrl.vehicles.length > 5 ? 5 : ctrl.vehicles.length;
        ctrl.vehicles = sortVehicles(ctrl.vehicles);
        ctrl.tabWidth = 100;
        ctrl.vehicles.forEach(function(vehicle) {
          vehicle.selected = false;
        });

        if (ctrl.selectedVehicleId) {
          var vehicle = ctrl.vehicles.find(function(vehicle) {return vehicle.id === ctrl.selectedVehicleId;});
          ctrl.selectedVehicleId = vehicle ? ctrl.selectedVehicleId : ctrl.vehicles[0].id;
          ctrl.indexSelected = vehicle ? ctrl.indexSelected : 0;
        }else {
          ctrl.selectedVehicleId = ctrl.vehicles[0].id;
          ctrl.indexSelected = 0;
        }

        ctrl.vehicles[ctrl.indexSelected].selected = true;
        ctrl.visibleTabs = ctrl.vehicles.slice(0, rangeEnd);
        groupedVisits = lodash.groupBy(ctrl.data, 'vehicleId');
        ctrl.selectedVehicleVisits = lodash.sortBy(groupedVisits[ctrl.selectedVehicleId], ['order']) || [];
      }
    };

    function sortVehicles(vehicles) {
      return vehicles.sort(function(a, b){
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    }

    function doShift(condition, first, shift, last) {
      if (condition) {
        ctrl.tabsRange = [first + (shift), last + (shift)];
        ctrl.visibleTabs = ctrl.vehicles.slice(ctrl.tabsRange[0] , ctrl.tabsRange[1]);
      }
    }

    function scrollLeft() {

      var first = ctrl.tabsRange[0];
      var last = ctrl.tabsRange[1];
      var condition = first > 0;
      var shift = -1;
      doShift(condition, first, shift, last);
    }

    function scrollRight() {
      var last = ctrl.tabsRange[1];
      var first = ctrl.tabsRange[0];
      var condition = last < ctrl.vehicles.length;
      var shift = 1;
      doShift(condition, first, shift, last);
    }

    function changeTab(id) {
      ctrl.selectedVehicleVisits = lodash.sortBy(groupedVisits[id], ['order']);
      ctrl.selectedVehicleId = id;
      ctrl.indexSelected = ctrl.vehicles.findIndex(function(vehicle) {
        return vehicle.id === id;
      });
      ctrl.vehicles.forEach(function(vehicle) {
        vehicle.selected = vehicle.id === id;
      });
    }

    function goToVehicleCreate() {
      $state.go('settings.vehicles.create');
    }
  }

  var routesTableConfig = {
    templateUrl: 'app/assigner/components/routesTable.template.html',
    controller: ['$scope', '$document', '$state', 'lodash', routesTableCtrl],
    bindings: {
      data: '<',
      vehicles: '<',
      totalVehicles: '<'
    }
  };

  angular
    .module('icarus.assigner')
    .component('routesTable', routesTableConfig);
})();

(function() {
  'use strict';


  function routeIndicatorCtrl($scope) {
    var ctrl = this;

  }

  var routeIndicatorConfig = {
    templateUrl: 'app/assigner/components/routeIndicator.template.html',
    controller: ['$scope', routeIndicatorCtrl],
    bindings: {
      icon: '@',
      value: '<',
      smallText: '@'
    }
  };

  angular
    .module('icarus.assigner')
    .component('routeIndicator', routeIndicatorConfig);
})();

(function () {
  'use strict';

  function importExcelButtonCtrl(xlsUploaderService, xlsParserService) {
    var ctrl = this;

    ctrl.import = importExcel;

    function importExcel(files) {
      xlsUploaderService.handleFile(files[0])
        .then(function (workbook) {
          var grid = xlsParserService.createGrid(workbook, ctrl.data.keys);
          var data = xlsParserService.gridToList(grid);
          ctrl.data.onImport(data);
        })
        .catch(function (error) {
          ctrl.data.onError(error);
        });
    }
  }

  var importExcelButtonConfig = {
    templateUrl: 'app/assigner/components/importExcelButton.template.html',
    controller: ['xlsUploaderService', 'xlsParserService', importExcelButtonCtrl],
    bindings: {
      data: '<',
      disabled: '='
    }
  };


  angular
    .module('icarus.assigner')
    .component('importExcelButton', importExcelButtonConfig);
})();

(function() {
  'use strict';

  function assignerTableCtrl($scope, orderByFilter, filterFilter) {
    var vm = this;
    var DEFAULT_PAGE_SIZE = 200;
    var search = '';
    var unWatchSearch;
    var structuredData = [];
    vm.enableReverseOrder = false;
    vm.currentOrder= null;
    vm.currentPage = 1;
    vm.filteredData = [];
    vm.pageSize = vm.options && vm.options.pagination.pageSize ? vm.options.pagination.pageSize : DEFAULT_PAGE_SIZE;
    vm.columns = [];
    vm.orderColumn = orderColumn;
    vm.handleCheck = handleCheck;

    this.$onInit = function() {
      validate();
      setInitData(vm.data);
      vm.columns = initColumns(vm.options.columns);
      unWatchSearch = $scope.$watch('$ctrl.options.search', onSearch);
    };

    this.$onChanges = function(o) {
      if (o.data && o.data.currentValue instanceof Array) {
        setInitData(o.data.currentValue);
      }else if (o.options) {
        vm.columns = initColumns(o.options.currentValue.columns);
      }
    };

    this.$onDestroy = function() {
      unWatchSearch();
    };

    /////////////////////////////////////

    function orderColumn(columnField){
      var cpFilteredData = angular.copy(vm.filteredData);
      vm.enableReverseOrder = vm.currentOrder === columnField ? !vm.enableReverseOrder : false;
      vm.currentOrder = columnField;
      setColumnOrder(columnField, vm.columns, vm.enableReverseOrder);
      vm.filteredData.length = 0;
      angular.extend(vm.filteredData, orderByFilter(cpFilteredData, vm.currentOrder, vm.enableReverseOrder));
    }

    function onSearch(newVal, oldVal) {
      var data;
      if (!newVal && search) {
        vm.filteredData.length = 0;
        data = angular.copy(structuredData);
        angular.extend(vm.filteredData, data);
      } else if(newVal) {
        vm.filteredData.length = 0;
        data = filterFilter(structuredData, newVal);
        angular.extend(vm.filteredData, data);
      }
      search = newVal;
    }

    function validate() {
      var requiredFields = ['columns'];
      for (var key in vm.options) {
        if (vm.options.hasOwnProperty(key) && requiredFields.indexOf(key) !== -1
          && !(vm.options[key] instanceof Array && vm.options[key].length > 0)) {
          throw new Error('[AssignerTable] property "'+ key +'" is required and can\'t be an empty array');
        }
      }
    }

    function copyAndStruct(data, options) {
      var arr = [];
      var renderFields = options.columns.map(function(c) { return c.field; });

      data.forEach(function(o) {
        var v = {};
        renderFields.forEach(function(k) {
          v[k] = o[k];
        });
        arr.push(v);
      });

      return arr;
    }

    function initColumns(columns) {
      var newColumns = [];
      columns.forEach(function(c) {
        newColumns.push({
          name: c.name,
          field: c.field,
          order: 0
        });
      });

      return newColumns;
    }

    function setColumnOrder(columnField, columns, order) {
      columns.forEach(function(c) {
        if(c.field === columnField) {
          c.order = order ? 1 : 2;
        }else {
          c.order = 0;
        }
      });
    }

    function setInitData(data) {
      vm.currentPage = 1;
      structuredData = copyAndStruct(data, vm.options);
      vm.filteredData.length = 0;
      angular.extend(vm.filteredData, angular.copy(structuredData));
    }

    function handleCheck(id, selected) {
      vm.onCheck(id, selected);
    }
  }

  var assignerTableConfig = {
    templateUrl: 'app/assigner/components/assignerTable.template.html',
    controller: ['$scope', 'orderByFilter', 'filterFilter', assignerTableCtrl],
    bindings: {
      data: '<',
      options:'<',
      onCheck: '<'
    }
  };

  angular
    .module('icarus.assigner')
    .component('assignerTable', assignerTableConfig);
})();

(function(){
  'use strict';
  angular
    .module('icarus')
    .controller('CheckoutSmsController', CheckoutSmsController);

  /** @ngInject */
  function  CheckoutSmsController($rootScope, $state, $log, addonsService, $filter, Toasts) {

    var vm = this;
    var $translate = $filter('translate');
    var KEY_CHECKOUT_SMS = "checkout_sms";

    vm.checkoutSms = {
      key: 'sms_body',
      title: $translate('checkout_sms.title'),
      description: $translate('checkout_sms.description')
    };
    vm.saveSmsCheckout = saveSmsCheckout;
    activate();

    ////////////

    function activate() {
      $rootScope.isLoading = true;
      addonsService.listAddons()
        .then( function successGetAddon(addons) {
          addons.forEach(function (addon) {
            if (addon.key === KEY_CHECKOUT_SMS && addon.enable) {
              vm.checkoutSms.add_on_id = addon.id;
              //buscar Addon Property SMS
              _getAddonProperty(addon.id);
            }
          });
          $rootScope.isLoading = false;
          // Mostrar mensaje de que no existe
          // la opcion SMS para esta cuenta
          if (!vm.checkoutSms.add_on_id) {
            vm.messageNotSMS = true;
          }
        }, function errorGetAddon(error) {
          $log.error('Error get list Addons');
          vm.messageNotSMS = true;
          $rootScope.isLoading = false;
        });
    }

    function saveSmsCheckout() {
      if (!vm.checkoutSms.value) {
        return;
      }
      $rootScope.isLoading = true;
      if (vm.checkoutSms.id) {
        addonsService.updateAddonProperty(vm.checkoutSms)
          .then(function successSave() {
            _showSuccessMessages();
          }, function errorSave(error) {
            _showErrors(error);
          });
      } else {
        addonsService.createAddonProperty(vm.checkoutSms)
          .then(function successSave(data) {
            _showSuccessMessages();
            vm.checkoutSms.id = data.id;
          }, function errorSave(error) {
            _showErrors(error);

          });
      }

    }

    function _getAddonProperty(id) {
      addonsService.getAddonPropertiesByKey(id, KEY_CHECKOUT_SMS)
        .then( function (addonProperty) {
          if (addonProperty) {
            vm.checkoutSms.key = addonProperty.key;
            vm.checkoutSms.title = addonProperty.title;
            vm.checkoutSms.value = addonProperty.value;
            vm.checkoutSms.description = addonProperty.description;
            vm.checkoutSms.add_on_id = addonProperty.add_on_id;
            vm.checkoutSms.id = addonProperty.id;
          }

        }, function error(errorMessage) {
          $log.info(errorMessage);
        });
    }

    function _showErrors(error) {
      Toasts.push('error', $translate('checkout_sms.error_save_sms'));
      $log.error(error);
      $rootScope.isLoading = false;
    }

    function _showSuccessMessages() {
      $rootScope.isLoading = false;
      Toasts.push('success', $translate('checkout_sms.success_message'));
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .factory('addonsUtilsService', addonsUtilsService);

  /** @ngInject */
  function addonsUtilsService(addonsService, PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES) {
    var service = {
      isSkipTimeValidationEnabled: isSkipTimeValidationEnabled
    };

    return service;

    //////////

    function isSkipTimeValidationEnabled() {
      return addonsService.isAddonPropertyEnabled(PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES.SKIP_TIME_VALIDATION, function (addonProperty) {
        return addonProperty.value.toLowerCase() === "true";
      }).then(function (isAddonPropertyEnabled) {
        return isAddonPropertyEnabled;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .factory('addonsService', addonsService);

  /** @ngInject */
  function addonsService($q, __env, $http, $cacheFactory, CACHE_KEYS, PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES) {
    var ADDONS_PATH = __env.API_URL + 'addons/addons/';
    var ADDONS_PROPERTY_PATH = __env.API_URL + 'addons/';
    var listAddonsPromise = null;
    var cache = $cacheFactory(CACHE_KEYS.CACHE_ADDONS_KEY);

    var service = {
      isAddonEnable: isAddonEnable,
      listAddons: listAddons,
      getAddonPropertiesByKey: getAddonPropertiesByKey,
      createAddonProperty: createAddonProperty,
      updateAddonProperty: updateAddonProperty,
      getInfoAddonAndPropertiesByKey: getInfoAddonAndPropertiesByKey,
      getAddonPropertyByKeyFiltered: getAddonPropertyByKeyFiltered,
      deleteProperty: deleteProperty,
      sendEmailPreview: sendEmailPreview,
      getAddonByIdAndPropertiesByKeys: getAddonByIdAndPropertiesByKeys,
      validatePDF: validatePDF,
      clearAddons: clearAddons,
      removeCache: removeCache,
      getAddOnPropertiesByAddOnId: getAddOnPropertiesByAddOnId,
      isAddonPropertyEnabled: isAddonPropertyEnabled,
      isApolloRouteDesignerEnabled: isApolloRouteDesignerEnabled
    };

    return service;

    //////////

    function listAddons() {
      if (listAddonsPromise) {
        return listAddonsPromise;
      }

      var deferred = $q.defer();
      $http.get(ADDONS_PATH)
        .then(function (response) {
          deferred.resolve(response.data);
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      listAddonsPromise = deferred.promise;
      return listAddonsPromise;
    }

    function getAddOnPropertiesByAddOnId(addOnId) {
      var httpOptions = {
        cache: cache
      };

      return $http.get(ADDONS_PROPERTY_PATH + addOnId + "/property/", httpOptions)
        .then(function (response) {
          return response.data;
        });
    }

    function getAddonPropertyByKeyFiltered(id, keyToFind) {
      var deferred = $q.defer();
      var httpOptions = {
        cache: cache
      };

      // Get all properties without query params
      $http.get(ADDONS_PROPERTY_PATH + id + "/property/", httpOptions)
        .then(function (response) {
          // Find the specific property with matching key
          var property = response.data.find(function(prop) {
            return prop.key === keyToFind;
          });

          if (property) {
            deferred.resolve(property);
          } else {
            deferred.reject('Property not found for key: ' + keyToFind);
          }
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function getAddonPropertiesByKey(id, key) {
      var deferred = $q.defer();
      var httpOptions = {
        params: key
      };

      $http.get(ADDONS_PROPERTY_PATH + id + "/property/", httpOptions)
        .then(function (addonProperty) {
          deferred.resolve(addonProperty.data[0]);
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function createAddonProperty(addonData) {
      var deferred = $q.defer();
      var id = addonData.add_on_id;
      $http.post(ADDONS_PROPERTY_PATH + id + '/property/', addonData)
        .then(function (response) {
            deferred.resolve(response.data);
          },
          function errorSave(error) {
            deferred.reject(error);
          });

      return deferred.promise;
    }

    function updateAddonProperty(addonData) {
      var deferred = $q.defer();
      var addon_id = addonData.add_on_id;
      var addon_property_id = addonData.id;

      $http.put(ADDONS_PROPERTY_PATH + addon_id + '/property/' + addon_property_id + '/', addonData)
        .then(function (response) {
            deferred.resolve(response.data);
          },
          function errorSave(error) {
            deferred.reject(error);
          });

      return deferred.promise;
    }

    function getInfoAddonAndPropertiesByKey(key) {
      var deferred = $q.defer();
      var httpOptions = {
        cache: cache
      };

      isAddonEnable(key)
        .then(function (enable) {
          if (!enable) {
            return;
          }

          return $http.get(ADDONS_PROPERTY_PATH + key + "/", httpOptions);
        })
        .then(function (response) {
          if (response) {
            deferred.resolve(response.data);
          } else {
            deferred.reject();
          }
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function getAddonByIdAndPropertiesByKeys(id, keys) {
      var deferred = $q.defer();

      var promises = [];

      keys.forEach(function (key) {
        promises.push($http.get(ADDONS_PROPERTY_PATH + id + '/property/' + key + '/'));
      });

      $q.all(promises)
        .then(function (addonProperties) {
          deferred.resolve(addonProperties);
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;

    }

    function deleteProperty(addonId, addonPropertyId) {
      var deferred = $q.defer();

      $http.delete(ADDONS_PROPERTY_PATH + addonId + '/property/' + addonPropertyId + '/')
        .then(function (response) {
          deferred.resolve(response.data);
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function sendEmailPreview(payload) {
      var deferred = $q.defer();

      $http.post(ADDONS_PROPERTY_PATH + 'preview/', payload)
        .then(function (response) {
          deferred.resolve(response);
        }).catch(function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function isAddonEnable(addOnKey) {
      var deferred = $q.defer();
      listAddons()
        .then(function (addons) {
          var enabled = false;
          for (var i = 0; i < addons.length; i++) {
            if (addons[i].key === addOnKey) {
              enabled = addons[i].enable;
              break;
            }
          }

          deferred.resolve(enabled);
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function validatePDF(pdf) {
      var deferred = $q.defer();
      $http.post(ADDONS_PROPERTY_PATH + 'validate-pdf/', {body: pdf})
        .then(function success(response) {
          deferred.resolve(response.data);
        },
        function errorListAddons(error) {
          deferred.reject(error);
        }
      );

      return deferred.promise;
    }

    function clearAddons() {
      listAddonsPromise = null;
    }

    function removeCache() {
      if ($cacheFactory.get(CACHE_KEYS.CACHE_ADDONS_KEY)) {
        $cacheFactory.get(CACHE_KEYS.CACHE_ADDONS_KEY).removeAll();
      }
    }

    function isAddonPropertyEnabled(addonKey, propertyKey, enabledCheckerCallback) {
      return listAddons()
        .then(function (addons) {
          var addonFound = addons.find(
            function(addon) { return addon.key === addonKey && addon.enable; }
          );

          if (!addonFound) {
            return false;
          }

          return getAddonPropertyByKeyFiltered(
            addonFound.id,
              propertyKey
            )
            .then(enabledCheckerCallback)
            .catch(function (error) {
              console.error("Error getting addon property:", error);
              return false;
            });
        })
        .catch(function (error) {
          console.error(
            "Error getting addon property show_extra_field_values:",
            error
          );
          return false;
        });
    }

    function isApolloRouteDesignerEnabled() {
      return isAddonPropertyEnabled(PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_APOLLO_ROUTE_DESIGNER, function (addonProperty) {
          return addonProperty.value.toLowerCase() === "true";
        })
        .catch(function () {
          return false;
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {

    //// Translate keys.
    $translateProvider.translations('es', {
      'pagination': {
        'firstText': 'Primero',
        'lastText': 'Último',
        'nexText': 'Siguiente',
        'previousText': 'Anterior'
      },
      'help_title': 'Ayuda',
      'visits': 'Visitas',
      'smchat.headerText': '¿Cómo podemos ayudar?',
      'smchat.inputPlaceholder': 'Escribe tu mensaje...',
      'smchat.sendButtonText': 'Enviar',
      'smchat.introductionText': 'Estamos aquí para hablar, pregúntanos lo que sea.',
      'in': 'en',
      'days': 'días',
      'idle_title': '¿Aún estás aquí?',
      'idle_remaining_time': 'Tu sesión cerrará en',
      'idle_info': 'Tu sesión se cerrará por inactividad. Como no has realizado ninguna acción en los últimos minutos, ¿deseas mantener tu sesión activa?',
      'idle_keep': 'Mantener sesión',
      'idle_logout': 'Cerrar sesión'
    });

    $translateProvider.translations('en', {
      'pagination': {
        'firstText': 'First',
        'lastText': 'Last',
        'nexText': 'Next',
        'previousText': 'Previous'
      },
      'help_title': 'Help',
      'visits': 'Visits',
      'smchat.headerText': 'How can we help?',
      'smchat.inputPlaceholder': 'Type a message...',
      'smchat.sendButtonText': 'Send',
      'smchat.introductionText': 'We\'re here to talk, so ask us anything!',
      'in': 'in',
      'days': 'days',
      'idle_title': 'Are you still here?',
      'idle_remaining_time': 'Your session will expire in',
      'idle_info': 'Your session will expire due to inactivity. You haven\'t done any action in the last minutes, do you want to keep your session active?',
      'idle_keep': 'Keep me logged in',
      'idle_logout': 'Sign out'
    });

    $translateProvider.translations('pt', {
      'pagination': {
        'firstText': 'Primeiro',
        'lastText': 'Último',
        'nexText': 'Próximo',
        'previousText': 'Anterior'
      },
      'help_title': 'Ajuda',
      'visits': 'Visitas',
      'smchat.headerText': 'Como podemos ajudá-lo(a)?',
      'smchat.inputPlaceholder': 'Escreva uma mensagem...',
      'smchat.sendButtonText': 'Enviar',
      'smchat.introductionText': 'Estamos aqui para falar, por isso pergunte-nos qualquer coisa!',
      'in': 'em',
      'days': 'dias',
      'idle_title': 'Você ainda está aqui?',
      'idle_remaining_time': 'Sua sessão expirará em',
      'idle_info': 'Sua sessão expirará devido à inatividade. Você não fez nenhuma ação nos últimos minutos, você quer manter sua sessão ativa?',
      'idle_keep': 'Manter sessão',
      'idle_logout': 'Terminar sessão'
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $log, $state, $rootScope, $uibModal, moment, sessionService,
                          plannerService, $locale, $translate, vehicleService, skillsService,
                          mobileGeneralService, driversService, store, ngDialog,
                          chatService, optimizeService, configs, addonsService, $window,
                          extensionsService, fleetService, zoneService, Idle, securityService, __env,
                          $q, ACCOUNT_STATUS, ACCOUNT_CONFIGS, colorAssignerService, apolloAuthService,
                          SIMPLI_CHAT_ADD_ON_KEY, TMS_ADD_ON_KEY, SIMPLI_VIRTUAL_ASSISTANT,
                          accountConfigsService, mobileCompatibilityMessageService,
                          VEHICULAR_RESTRICTION_ADD_ON_KEY, TERRITORY_PLANNER_ADD_ON_KEY,
                          FORCE_FIELD_ADD_ON_KEY, DATA_ENCRYPTION_ADD_ON_KEY, ENABLED_FOR_USER_IDS_ADD_ON_PROPERTY_KEY,
                          ENABLED_FOR_SELLER_ROLES_ADD_ON_PROPERTY_KEY, SSO_DOMAIN_IDENTIFIER, SSO_LOGOUT_ADDON_KEY,
                          COURIER_ADD_ON_KEY, sidebarModulesService, profileModulesService,
                          moduleHelpersService, notFoundPageService, REST_TIME_ADD_ON_KEY, LIVE_ROUTING_ADD_ON_KEY,
                          ssoChannelsService, rdMigrationOptinService) {

    var vm = this;
    var languageEs = "es";
    var languageEn = "en";
    var languagePt = "pt";
    var ON_FOOT_ROUTING_OPTION = "on_foot";
    var WAVE_ROUTING_OPTION = "wave_routing";

    var idleModal = null;
    var idleStartSub = null;
    var idleTimeoutSub = null;

    vm.user = null;
    vm.state = $state;
    vm.assignerVisible = false;
    vm.enablePlans = false;
    vm.enableAssigner = false;
    vm.enableRouteDesigner = true;
    vm.enableSimpliChat = false;
    vm.enableExtensions = false;
    vm.enableClientsModule = false;
    vm.sectionsToDisplay = null;
    vm.profile = null;
    vm.currentLanguage = null;
    vm.tmsAddOn = {
      enabled: false,
      properties: [],
      addOn: null
    };
    vm.isTerritoryPlannerEnabled = false;
    vm.isForceFieldEnabled = false;
    vm.isDataEncryptionEnabled = false;
    vm.simpliChatAddOn = {
      enabled: false,
      properties: [],
      addOn: null
    };

    vm.hasApolloRdAccess = false;
    vm.isLiveRoutingAddonEnabled = false;

    vm.virtualAssistantAddOn = {
      enabled: false,
      properties: [],
      addOn: null
    };

    vm.openVideo = openVideo;
    vm.chatInit = chatInit;
    vm.logout = logout;
    vm.goStateUprofile = goStateUprofile;
    vm.switchAccount = switchAccount;
    vm.closeTrial = closeTrial;
    vm.clearAllServices = clearAllServices;
    vm.shouldContinueWithMobile = shouldContinueWithMobile;
    vm.showNotFoundPage = notFoundPageService.getNotFoundPageStatus();

    activate();

    ////////////

    function shouldContinueWithMobile() {
      return mobileCompatibilityMessageService.getContinueWithMobileStatus();
    }

    function _isAccountStatusEqualTo(currentAccountStatus, expectedAccountStatus) {
      return currentAccountStatus === expectedAccountStatus;
    }

    function activate() {
      $rootScope.$broadcast('Authentication:ShowSpinner', {
        isAuthenticating: false
      });

      zoneService.initializeRestrictionTypeAddonPropertyCheck();

      saveConfigsInStore(configs);
      enableSections(configs);
      vm.currentLanguage = moduleHelpersService.getCurrentLanguage();
      vm.showVideoButton = vm.enableRouteDesigner;
      if ($rootScope.$locale) {
        _setLanguage();
      }

      return $q.all([checkAddonsEnable(), checkEnableExtensions()])
        .then(function () {
          return $q.all([
            fetchAddonProperties(vm.tmsAddOn),
            fetchAddonProperties(vm.virtualAssistantAddOn),
            fetchAddonProperties(vm.simpliChatAddOn)
          ]);
        })
        .finally(function () {
          return sessionService.getUser()
            .then(getUserComplete)
            .then(function () {
              vm.sectionsToDisplay = sidebarModulesService.setModulesToDisplay(_getSidebarModulesProps());
              vm.profile = profileModulesService.setModulesToDisplay(_getProfileModulesProps());
            })
            .catch(getUserFailed);
        });

      function getUserComplete(user) {
        store.set('country', user.country);
        if (!user) {
          throw 'No user!.';
        } else {
          vm.user = user;

          var accountStatus = user.account.status;
          if (_isAccountStatusEqualTo(accountStatus, ACCOUNT_STATUS.ACTIVE) && !user.is_monitor && !vm.hasApolloRdAccess) {
            $window.LogRocket && $window.LogRocket.init('rdpwz6/simpliroute-web');
            $window.LogRocket.identify(user.id, {name: user.name, email: user.email});
          }

          if (_isAccountStatusEqualTo(accountStatus, ACCOUNT_STATUS.TRIALING)) {
            $rootScope.showTrial = true;
          } else {
            $rootScope.showTrial = false;
          }

          // Idle Module Config
          Idle.watch();
          $scope.logout = logout;
          // Open modal when IdleStart event is triggered by ng-idle
          idleStartSub = $rootScope.$on('IdleStart', function() {
            idleModal = ngDialog.open({
              template: 'app/main/idle-alert-modal.html',
              controller: 'IdleAlertModalController',
              controllerAs: 'vm',
              scope: $scope,
              showClose: false,
              closeByEscape: false,
              closeByNavigation: false,
              closeByDocument: false
            });
          });
          // Logout when IdleTimeout is triggered
          idleTimeoutSub = $rootScope.$on('IdleTimeout', function() {
            if (idleModal) {idleModal.close();}
            logout(true);
          });

          // Set account-specific settings for timeout, otherwise defaults defined earlier are used
          securityService.get({}).then(function (res) {
            if (res.status === 200) {
              var idleTimeoutConfig = res.data.add_on_properties.find(function(property) {
                return property.key === 'idle_timeout';
              });
              if (idleTimeoutConfig && idleTimeoutConfig.value) {
                var minutesUntilAlert = idleTimeoutConfig.value - __env.DEFAULT_IDLE_WARNING_FOR_LOGOUT;
                minutesUntilAlert = minutesUntilAlert < 1 ? 1 : minutesUntilAlert;
                Idle.setIdle(60 * minutesUntilAlert);
              }
            }
          });

          optimizeService.setOptimizationOptions(vm.user.account.optimization_options, plannerService.optimizationOptions,
            plannerService.localOptimizationOptions, plannerService.optimizationOptionsDisplayed)
            .then(function (data) {
              var useEuclideanDistance = false;
              var maxClient = 0;
              var minLoad = 0;
              var disableSoftWindow = false;
              var one_vehicle_zone = false;
              var enableGraphs = false;
              var autoReorder = false;
              var intensiveIntra = false;
              var insertionIntensification = false;
              var openRoutesLogic = false;
              var vehicleCapacitiesIncrement = 0;
              var vehicleJourneyExtention = 0;
              var enableRestTime = false;
              var vehicleType = false;
              var waveRouting = false;
              var enableAircraftRouting = false;
              var avoidWaitingTimes = false;

              configs.forEach(function (config) {
                switch (config.key) {
                  case 'use_euclidean_distance':
                    useEuclideanDistance = config.value;
                    break;
                  case 'max_client':
                    maxClient = config.value;
                    break;
                  case 'min_load':
                    minLoad = config.value;
                    break;
                  case 'disable_soft_window':
                    disableSoftWindow = config.value;
                    break;
                  case 'one_vehicle_zone':
                    one_vehicle_zone = config.value;
                    break;
                  case 'enable_graphs':
                    enableGraphs = config.value;
                    break;
                  case 'enable_auto_reorder':
                    autoReorder = config.value;
                    break;
                  case 'insertion_intensification':
                    insertionIntensification = config.value;
                    break;
                  case 'use_intensive_intra':
                    intensiveIntra = config.value;
                    break;
                  case 'open_routes_logic':
                    openRoutesLogic = config.value;
                    break;
                  case 'vehicle_capacities_increment':
                    vehicleCapacitiesIncrement = parseFloat(config.value);
                    break;
                  case 'vehicle_journey_extention':
                    vehicleJourneyExtention = parseFloat(config.value);
                    break;
                  case 'enable_rest_time':
                    enableRestTime = config.value;
                    break;
                  case 'vehicle_type':
                    vehicleType = config.value;
                    break;
                  case 'enable_wave_routing':
                    waveRouting = config.value;
                    break;
                  case 'enable_aircraft_routing':
                    enableAircraftRouting = config.value;
                    break;
                  case 'avoid_waiting_times':
                    avoidWaitingTimes = config.value;
                    break;
                }
              });

              data.optionsPlanner.use_euclidean_distance = useEuclideanDistance;
              data.optionsPlannerLocal.use_euclidean_distance = useEuclideanDistance;
              data.optionsPlanner.max_client = maxClient;
              data.optionsPlannerLocal.max_client = maxClient;
              data.optionsPlanner.min_load = minLoad;
              data.optionsPlannerLocal.min_load = minLoad;
              data.optionsPlanner.disable_soft_window = disableSoftWindow;
              data.optionsPlannerLocal.disable_soft_window = disableSoftWindow;
              data.optionsPlanner.one_vehicle_zone = one_vehicle_zone;
              data.optionsPlannerLocal.one_vehicle_zone = one_vehicle_zone;
              data.optionsPlanner.enable_graphs = enableGraphs;
              data.optionsPlannerLocal.enable_graphs = enableGraphs;
              data.optionsPlanner.auto_reorder = autoReorder;
              data.optionsPlannerLocal.auto_reorder = autoReorder;
              data.optionsPlanner.insertion_intensification = insertionIntensification;
              data.optionsPlannerLocal.insertion_intensification = insertionIntensification;
              data.optionsPlanner.intensive_intra = intensiveIntra;
              data.optionsPlannerLocal.intensive_intra = intensiveIntra;
              data.optionsPlanner.open_routes_logic = openRoutesLogic;
              data.optionsPlannerLocal.open_routes_logic = openRoutesLogic;
              data.optionsPlanner.vehicle_capacities_increment = vehicleCapacitiesIncrement;
              data.optionsPlannerLocal.vehicle_capacities_increment = vehicleCapacitiesIncrement;
              data.optionsPlanner.vehicle_journey_extention = vehicleJourneyExtention;
              data.optionsPlannerLocal.vehicle_journey_extention = vehicleJourneyExtention;
              data.optionsPlanner.enable_rest_time = enableRestTime;
              data.optionsPlannerLocal.enable_rest_time = enableRestTime;
              data.optionsPlanner.vehicle_type = vehicleType;
              data.optionsPlannerLocal.vehicle_type = vehicleType;
              data.optionsPlanner.enable_aircraft_routing = enableAircraftRouting;
              data.optionsPlannerLocal.enable_aircraft_routing = enableAircraftRouting;
              data.optionsPlanner.avoid_waiting_times = avoidWaitingTimes;
              data.optionsPlannerLocal.avoid_waiting_times = avoidWaitingTimes;

              if (vehicleType) {
                data.optionsPlannerDisplayed.push(ON_FOOT_ROUTING_OPTION);
              }
              if (waveRouting) {
                data.optionsPlannerDisplayed.push(WAVE_ROUTING_OPTION);
              }

              plannerService.setOptimizationOptions(data.optionsPlanner);
              plannerService.setlocalOptimizationOptions(data.optionsPlannerLocal);
              plannerService.setOptimizationOptionsDisplayed(data.optionsPlannerDisplayed);
            });

          if (_isAccountStatusEqualTo(accountStatus, ACCOUNT_STATUS.PAST_DUE)) {
            vm.showPaymentPending = true;
          } else if (_isAccountStatusEqualTo(accountStatus, ACCOUNT_STATUS.TRIALING)) {
            vm.isInTrial = true;
            vm.trialEndTime = moment().to(user.account.active_until, true);
          } else if (_isAccountStatusEqualTo(accountStatus, ACCOUNT_STATUS.CANCELED)) {
            var defaultHref = apolloAuthService.buildRedirectURL(vm.currentLanguage + "/profile");
            $window.location.href = moduleHelpersService.resolveHref(defaultHref, vm.user);
          }

          setDataWindowChat(user);
        }
      }

      function getUserFailed(error) {
        $log.info(error);
        _returnToMainScreen(false);
      }
    }

    function isVirtualAssistantEnabledForUser(virtualAssistantAddOnProperties) {
      var enabledUserIdsProperty = virtualAssistantAddOnProperties.find(function (property) {
        return property.key === ENABLED_FOR_USER_IDS_ADD_ON_PROPERTY_KEY;
      });

      if (!enabledUserIdsProperty) {
        return false;
      }

      try {
        var enabledUserIds = JSON.parse(enabledUserIdsProperty.value);
        return angular.isArray(enabledUserIds) && enabledUserIds.includes(vm.user.id);
      } catch (error) {
        console.error('Invalid value in enabled_for_user_ids property:', enabledUserIdsProperty.value, error);
        return false;
      }
    }

    function isSimpliChatEnabledForSellers(simpliChatAddOnProperties) {
      var property = simpliChatAddOnProperties.find(function (property) {
        return property.key === ENABLED_FOR_SELLER_ROLES_ADD_ON_PROPERTY_KEY;
      });

      return property ? property.value.toLowerCase() === 'true' : false;
    }

    function fetchAddonProperties(addOn) {
      if (!addOn.enabled) {
        return;
      }

      return addonsService.getAddOnPropertiesByAddOnId(addOn.addOn.id)
        .then(function (properties) {
          if (properties) {
            addOn.properties = properties;
          }
        });
    }

    function checkAddonsEnable() {
      return addonsService.listAddons()
        .then(function (addons) {
          var addOnsByKey = addons.reduce(function (acc, addOn) {
            acc[addOn.key] = addOn;
            return acc;
          }, {});

          vm.simpliChatAddOn.enabled = addOnsByKey[SIMPLI_CHAT_ADD_ON_KEY] ? addOnsByKey[SIMPLI_CHAT_ADD_ON_KEY].enable : false;
          vm.simpliChatAddOn.addOn =  addOnsByKey[SIMPLI_CHAT_ADD_ON_KEY] || null;

          vm.virtualAssistantAddOn.enabled = addOnsByKey[SIMPLI_VIRTUAL_ASSISTANT] ? addOnsByKey[SIMPLI_VIRTUAL_ASSISTANT].enable : false;
          vm.virtualAssistantAddOn.addOn = addOnsByKey[SIMPLI_VIRTUAL_ASSISTANT] || null;

          vm.tmsAddOn.enabled = addOnsByKey[TMS_ADD_ON_KEY] ? addOnsByKey[TMS_ADD_ON_KEY].enable : false;
          vm.tmsAddOn.addOn =  addOnsByKey[TMS_ADD_ON_KEY] || null;

          var isVehicularRestrictionEnabled = addOnsByKey[VEHICULAR_RESTRICTION_ADD_ON_KEY] ? addOnsByKey[VEHICULAR_RESTRICTION_ADD_ON_KEY].enable : false;
          plannerService.setVehicularRestrictionEnabled(isVehicularRestrictionEnabled);

          vm.isTerritoryPlannerEnabled = addOnsByKey[TERRITORY_PLANNER_ADD_ON_KEY] ? addOnsByKey[TERRITORY_PLANNER_ADD_ON_KEY].enable : false;

          vm.isForceFieldEnabled = addOnsByKey[FORCE_FIELD_ADD_ON_KEY] ? addOnsByKey[FORCE_FIELD_ADD_ON_KEY].enable : false;

          vm.isDataEncryptionEnabled = addOnsByKey[DATA_ENCRYPTION_ADD_ON_KEY] ? addOnsByKey[DATA_ENCRYPTION_ADD_ON_KEY].enable : false;

          var isCourierEnabled = addOnsByKey[COURIER_ADD_ON_KEY] ? addOnsByKey[COURIER_ADD_ON_KEY].enable : false;
          plannerService.setCourierEnabled(isCourierEnabled);

          var isRestTimeEnabled = addOnsByKey[REST_TIME_ADD_ON_KEY] ? addOnsByKey[REST_TIME_ADD_ON_KEY].enable : false;
          plannerService.setRestTimeEnabled(isRestTimeEnabled);

          vm.isLiveRoutingAddonEnabled = addOnsByKey[LIVE_ROUTING_ADD_ON_KEY] ? addOnsByKey[LIVE_ROUTING_ADD_ON_KEY].enable : false;

          return rdMigrationOptinService.hasApolloRdAccess(vm.user && vm.user.id);
        })
        .then(function (hasApolloRdAccess) {
          vm.hasApolloRdAccess = hasApolloRdAccess;
        })
        .catch(function (error) {
          $log.info(error);
        });
    }

    function checkEnableExtensions() {
      var extensionsModule = configs.find(function (config) {
        return config.key === ACCOUNT_CONFIGS.ENABLE_EXTENSIONS_MODULE;
      });

      if (extensionsModule && extensionsModule.value) {
        return extensionsService.getMyExtensions()
          .then(function (numExt) {
            vm.enableExtensions = numExt.length > 0;
          });
      }
    }

    function saveConfigsInStore(configs) {
      store.set('accountConfigs', configs);
    }

    function setDataWindowChat(user) {
      chatService.setDataWindowChat(user);
    }

    function openVideo() {
      var language = $translate.use();

      if (language === languageEs) {
        $scope.srcVideo = 'https://www.youtube.com/embed/hNOZlX4oTgA';
      } else if (language === languageEn) {
        $scope.srcVideo = '//www.youtube.com/embed/u341_B4LTSU';
      } else if (language === languagePt) {
        $scope.srcVideo = '//www.youtube.com/embed/RDhlMwO_AlA?ecver=2';
      } else {
        $scope.srcVideo = '//www.youtube.com/embed/u341_B4LTSU';
      }

      var modalInstance = $uibModal.open({
        templateUrl: 'app/main/video.html',
        size: 'lg',
        scope: $scope
      });

      return modalInstance.result;
    }

    function chatInit() {
      chatService.initChat();
    }

    function clearAllServices() {
      chatService.closeChatSession();
      plannerService.clearPlan();
      vehicleService.clear();
      skillsService.clear();
      mobileGeneralService.clear();
      driversService.clear();
      fleetService.clearCache();
      $rootScope.drawCluster = null;
      addonsService.clearAddons();
      addonsService.removeCache();
      extensionsService.clearExtensions();
      colorAssignerService.clearColorLogic();
      zoneService.clearRestrictionTypeAddonProperty();
      accountConfigsService.removeCache();
    }

    function logout(timeout) {
      addonsService.isAddonEnable(SSO_LOGOUT_ADDON_KEY).then(function (isSsoLogoutAddonEnabled) {
        var isApolloSessionActive = store.get('apollo-session');
        timeout = timeout || false;
        // Clean up idle observers when logout
        if (idleStartSub) {idleStartSub();}
        if (idleTimeoutSub) {idleTimeoutSub();}
        Idle.unwatch();
        _closeDialogs();
        clearAllServices();
        if (isApolloSessionActive) {
          apolloAuthService.redirect(apolloAuthService.buildRedirectURL('logout'));
          return;
        }

        sessionService.logout();
        if (ssoChannelsService.hasWebSso(vm.user.account.sso_domain, vm.user.account.sso_channels)) {
          if (isSsoLogoutAddonEnabled && store.get(SSO_DOMAIN_IDENTIFIER)) {
            var ssoDomain = store.get(SSO_DOMAIN_IDENTIFIER);
            store.remove(SSO_DOMAIN_IDENTIFIER);
            sessionService.ssoLogoutRedirect(ssoDomain);
          } else {
            $state.go('auth.sso-login', {domain: vm.user.account.sso_domain, expired: timeout});
          }
        } else {
          _returnToMainScreen(timeout, vm.user.account);
        }
      });
    }

    function _closeDialogs() {
      var openDialogs = ngDialog.getOpenDialogs();
      openDialogs.forEach(function (dialog) {
        ngDialog.close(dialog, 'idle_logout');
      });
    }

    function _returnToMainScreen(timeout, account) {
      if (account && ssoChannelsService.excludesWebSso(account.sso_domain, account.sso_channels)) {
        $state.go('auth.login', {expired: timeout});
        return;
      }
      if (__env.USE_SSO_AS_MAIN_SCREEN && __env.DEFAULT_SSO_DOMAIN) {
        $state.go('auth.sso-login', {expired: timeout});
      } else {
        $state.go('auth.login', {expired: timeout});
      }
    }

    function switchAccount() {
      clearAllServices();
      $state.go('auth.account-selector');
    }

    function goStateUprofile() {
      var defaultHref = apolloAuthService.buildRedirectURL(vm.currentLanguage + "/profile");
      $window.location.href = moduleHelpersService.resolveHref(defaultHref, vm.user);
    }

    function _setLanguage() {
      var locales = {
        es: {
          "DATETIME_FORMATS": {
            "AMPMS": [
              "a. m.",
              "p. m."
            ],
            "DAY": [
              "domingo",
              "lunes",
              "martes",
              "mi\u00e9rcoles",
              "jueves",
              "viernes",
              "s\u00e1bado"
            ],
            "ERANAMES": [
              "antes de Cristo",
              "despu\u00e9s de Cristo"
            ],
            "ERAS": [
              "a. C.",
              "d. C."
            ],
            "FIRSTDAYOFWEEK": 0,
            "MONTH": [
              "enero",
              "febrero",
              "marzo",
              "abril",
              "mayo",
              "junio",
              "julio",
              "agosto",
              "septiembre",
              "octubre",
              "noviembre",
              "diciembre"
            ],
            "SHORTDAY": [
              "dom.",
              "lun.",
              "mar.",
              "mi\u00e9.",
              "jue.",
              "vie.",
              "s\u00e1b."
            ],
            "SHORTMONTH": [
              "ene.",
              "feb.",
              "mar.",
              "abr.",
              "may.",
              "jun.",
              "jul.",
              "ago.",
              "sept.",
              "oct.",
              "nov.",
              "dic."
            ],
            "STANDALONEMONTH": [
              "Enero",
              "Febrero",
              "Marzo",
              "Abril",
              "Mayo",
              "Junio",
              "Julio",
              "Agosto",
              "Septiembre",
              "Octubre",
              "Noviembre",
              "Diciembre"
            ],
            "WEEKENDRANGE": [
              5,
              6
            ],
            "fullDate": "EEEE, d 'de' MMMM 'de' y",
            "longDate": "d 'de' MMMM 'de' y",
            "medium": "d MMM y H:mm:ss",
            "mediumDate": "d MMM y",
            "mediumTime": "H:mm:ss",
            "short": "d/M/yy H:mm",
            "shortDate": "d/M/yy",
            "shortTime": "H:mm"
          },
          "NUMBER_FORMATS": {
            "CURRENCY_SYM": "\u20ac",
            "DECIMAL_SEP": ",",
            "GROUP_SEP": ".",
            "PATTERNS": [
              {
                "gSize": 3,
                "lgSize": 3,
                "maxFrac": 3,
                "minFrac": 0,
                "minInt": 1,
                "negPre": "-",
                "negSuf": "",
                "posPre": "",
                "posSuf": ""
              },
              {
                "gSize": 3,
                "lgSize": 3,
                "maxFrac": 2,
                "minFrac": 2,
                "minInt": 1,
                "negPre": "-",
                "negSuf": "\u00a0\u00a4",
                "posPre": "",
                "posSuf": "\u00a0\u00a4"
              }
            ]
          },
          "id": "es",
          "localeID": "es",
          "pluralCat": function (n, opt_precision) {
            if (n === 1) {
              return PLURAL_CATEGORY.ONE;
            }
            return PLURAL_CATEGORY.OTHER;
          }
        },
        en: {
          "DATETIME_FORMATS": {
            "AMPMS": [
              "AM",
              "PM"
            ],
            "DAY": [
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday"
            ],
            "ERANAMES": [
              "Before Christ",
              "Anno Domini"
            ],
            "ERAS": [
              "BC",
              "AD"
            ],
            "FIRSTDAYOFWEEK": 6,
            "MONTH": [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December"
            ],
            "SHORTDAY": [
              "Sun",
              "Mon",
              "Tue",
              "Wed",
              "Thu",
              "Fri",
              "Sat"
            ],
            "SHORTMONTH": [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec"
            ],
            "STANDALONEMONTH": [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December"
            ],
            "WEEKENDRANGE": [
              5,
              6
            ],
            "fullDate": "EEEE, MMMM d, y",
            "longDate": "MMMM d, y",
            "medium": "MMM d, y h:mm:ss a",
            "mediumDate": "MMM d, y",
            "mediumTime": "h:mm:ss a",
            "short": "M/d/yy h:mm a",
            "shortDate": "M/d/yy",
            "shortTime": "h:mm a"
          },
          "NUMBER_FORMATS": {
            "CURRENCY_SYM": "$",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [
              {
                "gSize": 3,
                "lgSize": 3,
                "maxFrac": 3,
                "minFrac": 0,
                "minInt": 1,
                "negPre": "-",
                "negSuf": "",
                "posPre": "",
                "posSuf": ""
              },
              {
                "gSize": 3,
                "lgSize": 3,
                "maxFrac": 2,
                "minFrac": 2,
                "minInt": 1,
                "negPre": "-\u00a4",
                "negSuf": "",
                "posPre": "\u00a4",
                "posSuf": ""
              }
            ]
          },
          "id": "en",
          "localeID": "en",
          "pluralCat": function (n, opt_precision) {
            var i = n | 0;
            var vf = getVF(n, opt_precision);
            if (i == 1 && vf.v === 0) {
              return PLURAL_CATEGORY.ONE;
            }
            return PLURAL_CATEGORY.OTHER;
          }
        },
        pt: {
          "DATETIME_FORMATS": {
            "AMPMS": [
              "AM",
              "PM"
            ],
            "DAY": [
              "domingo",
              "segunda-feira",
              "ter\u00e7a-feira",
              "quarta-feira",
              "quinta-feira",
              "sexta-feira",
              "s\u00e1bado"
            ],
            "ERANAMES": [
              "Antes de Cristo",
              "Ano do Senhor"
            ],
            "ERAS": [
              "a.C.",
              "d.C."
            ],
            "FIRSTDAYOFWEEK": 6,
            "MONTH": [
              "janeiro",
              "fevereiro",
              "mar\u00e7o",
              "abril",
              "maio",
              "junho",
              "julho",
              "agosto",
              "setembro",
              "outubro",
              "novembro",
              "dezembro"
            ],
            "SHORTDAY": [
              "dom",
              "seg",
              "ter",
              "qua",
              "qui",
              "sex",
              "s\u00e1b"
            ],
            "SHORTMONTH": [
              "jan",
              "fev",
              "mar",
              "abr",
              "mai",
              "jun",
              "jul",
              "ago",
              "set",
              "out",
              "nov",
              "dez"
            ],
            "STANDALONEMONTH": [
              "janeiro",
              "fevereiro",
              "mar\u00e7o",
              "abril",
              "maio",
              "junho",
              "julho",
              "agosto",
              "setembro",
              "outubro",
              "novembro",
              "dezembro"
            ],
            "WEEKENDRANGE": [
              5,
              6
            ],
            "fullDate": "EEEE, d 'de' MMMM 'de' y",
            "longDate": "d 'de' MMMM 'de' y",
            "medium": "d 'de' MMM 'de' y HH:mm:ss",
            "mediumDate": "d 'de' MMM 'de' y",
            "mediumTime": "HH:mm:ss",
            "short": "dd/MM/yy HH:mm",
            "shortDate": "dd/MM/yy",
            "shortTime": "HH:mm"
          },
          "NUMBER_FORMATS": {
            "CURRENCY_SYM": "R$",
            "DECIMAL_SEP": ",",
            "GROUP_SEP": ".",
            "PATTERNS": [
              {
                "gSize": 3,
                "lgSize": 3,
                "maxFrac": 3,
                "minFrac": 0,
                "minInt": 1,
                "negPre": "-",
                "negSuf": "",
                "posPre": "",
                "posSuf": ""
              },
              {
                "gSize": 3,
                "lgSize": 3,
                "maxFrac": 2,
                "minFrac": 2,
                "minInt": 1,
                "negPre": "-\u00a4",
                "negSuf": "",
                "posPre": "\u00a4",
                "posSuf": ""
              }
            ]
          },
          "id": "pt",
          "localeID": "pt",
          "pluralCat": function (n, opt_precision) {
            if (n >= 0 && n <= 2 && n != 2) {
              return PLURAL_CATEGORY.ONE;
            }
            return PLURAL_CATEGORY.OTHER;
          }
        }
      };

      var loc = $rootScope.$locale.substring(0, 2).toLowerCase();
      if (locales[loc]) {
        angular.copy(locales[loc], $locale);
      }

    }

    function snakeToCamelCase(key) {
      return key.split('_').reduce(function(prev, next, i) {
          return i === 0 ? next : prev + next.charAt(0).toUpperCase() + next.slice(1);
      }, '');
    }

    function enableSections(configs) {
      configs.forEach(function(config) {
        var variableName = snakeToCamelCase(config.key);
        if (vm.hasOwnProperty(variableName)) {
          vm[variableName] = config.value;
        }
      });
    }

    function closeTrial() {
      $rootScope.showTrial = false;
    }

    var onRouteChangeDestroyAdaChatScript = $rootScope.$on('$stateChangeStart',
      function () {
        $log.debug("Route changed - closing virtual assistant chat");
        sidebarModulesService.destroyAdaChatScript();
      }
    );

    var onShowNotFoundPage = $rootScope.$on("Main:showNotFoundPage", function (_args, data) {
      $scope.$applyAsync(function () {
        vm.showNotFoundPage = data.showNotFoundPage;
      });
      }
    );

    $scope.$on("$destroy", function () {
      if (onRouteChangeDestroyAdaChatScript) {
        onRouteChangeDestroyAdaChatScript();
      }

      if (onShowNotFoundPage) {
        onShowNotFoundPage();
      }
    });

    function _getSidebarModulesProps() {
      return {
        enablePlans: vm.enablePlans,
        userHasAdminPermissions: vm.user.is_owner || vm.user.is_admin,
        user: vm.user,
        enableRouteDesigner: vm.enableRouteDesigner,
        userHasRouterAndRouterJrPermissions: vm.user.is_owner || vm.user.is_admin || vm.user.is_router || vm.user.is_router_jr,
        enableAssigner: vm.enableAssigner,
        isNotDriver: vm.user.is_admin || vm.user.is_monitor || vm.user.is_owner || vm.user.is_staff || vm.user.is_router || vm.user.is_router_jr,
        userHasRouterPermissions: vm.user.is_owner || vm.user.is_admin || vm.user.is_router,
        isForceFieldEnabled: vm.isForceFieldEnabled,
        tmsAddOn: vm.tmsAddOn,
        isAccountCanceled: _isAccountStatusEqualTo(vm.user.account.status, ACCOUNT_STATUS.CANCELED),
        userHasRouterAndMonitorPermissions: vm.user.is_owner || vm.user.is_admin || vm.user.is_router || vm.user.is_monitor,
        isTerritoryPlannerEnabled: vm.isTerritoryPlannerEnabled,
        enableClientsModule: vm.enableClientsModule,
        enableExtensions: vm.enableExtensions,
        simpliChatAddOn: vm.simpliChatAddOn,
        simpliChatForSellerRolesEnabled: (vm.user.is_seller_viewer || vm.user.is_seller) && isSimpliChatEnabledForSellers(vm.simpliChatAddOn.properties),
        enableVirtualAssistant: isVirtualAssistantEnabledForUser(vm.virtualAssistantAddOn.properties),
        enableSettingsModuleForRouterUser: accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_SETTINGS_MODULE_FOR_ROUTER_USER),
        hasApolloRdAccess: vm.hasApolloRdAccess,
        enableLiveRouting: vm.isLiveRoutingAddonEnabled
      };
    }

    function _getProfileModulesProps() {
      return {
        user: vm.user,
        logout: logout,
        isDataEncryptionEnabled: vm.isDataEncryptionEnabled,
        canSwitchAccount: (vm.user.organization && vm.user.organization.accounts) && vm.user.organization.accounts.length > 1,
        switchAccount: switchAccount
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .constant("SECTIONS", {
      ROUTES: "routes",
      TRACKING: "tracking",
      CLIENTS: "clients",
      DASHBOARD: "dashboard",
      EXTENSIONS: "extensions",
      FLEET_MANAGEMENT: "fleet_management",
      SIMPLI_PLANNER: "simpliPlanner",
      CHAT: "chat",
      ADA: "ada",
      SETTINGS: "settings",
      HELP: "help",
      PROFILE: "Uprofile",
      DOCUMENTS: "documents",
      VISITS: "visits",
      PLANNER: "planner",
      ASSIGNER: "assigner",
      PLANS: "plans",
      TRANSPORTATION_PROVIDER_PAYMENT: 'transportation_provider_payment',
      INTEGRATIONS: 'integrations'
    })
    .constant("SUBSECTIONS", {
      ROUTES: {
        PLANS: "plans",
        PLANNER: "planner",
        ASSIGNER: "assigner"
      },
      TRACKING: {
        TRACKING: "tracking",
        VISITS: "visits",
        LIVE_ROUTING: "live_routing"
      },
      FLEET_MANAGEMENT: {
        DOCUMENTS: "documents",
        DOCUMENTATION: "documentation",
        DOCUMENT_MANAGEMENT: "document_management",
        CONTROL_PLANE: "control_plane",
        TRANSPORTATION_PROVIDER_PAYMENT: "transportation_provider_payment"
      },
      SIMPLI_PLANNER: {
        FORCE_FIELD: "forceField",
        PROJECTS: "projects"
      }
    })
    .constant("SIMPLI_CHAT_ADD_ON_KEY", "simpli_chat")
    .constant("SIMPLI_VIRTUAL_ASSISTANT", "virtual_assistant")
    .constant("VEHICULAR_RESTRICTION_ADD_ON_KEY", "vehicular_restriction")
    .constant("TMS_ADD_ON_KEY", "tms")
    .constant("TRANSPORTATION_PROVIDER_PAYMENT_URL_ADD_ON_PROPERTY_KEY", "transportation_provider_payment_url")
    .constant("ENABLE_DOCUMENT_MANAGEMENT_V1_ADD_ON_PROPERTY_KEY", "enable_document_management_v1")
    .constant("ENABLE_CONTROL_PLANE_ADD_ON_PROPERTY_KEY", "enable_control_plane")
    .constant('PASSPHRASE_IDENTIFIER', 'passphrase')
    .constant('TERRITORY_PLANNER_ADD_ON_KEY', "territory_planner")
    .constant('FORCE_FIELD_ADD_ON_KEY', "force_field")
    .constant('DATA_ENCRYPTION_ADD_ON_KEY', 'data_encryption')
    .constant('ENABLED_FOR_USER_IDS_ADD_ON_PROPERTY_KEY', 'enabled_for_user_ids')
    .constant('ENABLED_FOR_SELLER_ROLES_ADD_ON_PROPERTY_KEY', "enabled_for_seller_roles")
    .constant('SSO_DOMAIN_IDENTIFIER', 'sso-domain')
    .constant('SSO_LOGOUT_ADDON_KEY', 'enable_sso_logout')
    .constant("COURIER_ADD_ON_KEY", "courier")
    .constant("SELLER_MANAGEMENT_ADD_ON_KEY", "seller_management")
    .constant("REST_TIME_ADD_ON_KEY", "rest_time")
    .constant("LIVE_ROUTING_ADD_ON_KEY", "live_routing");
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .controller('IdleAlertModalController', IdleAlertModalController);

  /** @ngInject */
  function IdleAlertModalController($scope, Idle, __env, $rootScope, $timeout) {
    var vm = this;

    var idleWarnSub = null;

    vm.serviceLogout = $scope.logout;
    vm.keepLogged = keepLogged;
    vm.logout = logout;
    vm.countdownMinutes = __env.DEFAULT_IDLE_WARNING_FOR_LOGOUT;
    vm.countdownSeconds = '00';

    // Setup timer observer to update remaining time before logout
    idleWarnSub = $scope.$on('IdleWarn', function(e, countdown) {
      $timeout(function() {
        vm.countdownMinutes = Math.floor(countdown / 60);
        vm.countdownSeconds = String(countdown % 60).padStart(2, '0');
      });
    });

     // Broadcast idle warning when modal opens
     $timeout(function() {
      $rootScope.$broadcast('idleWarningShown');
    }, 0);

    function keepLogged() {
      // Reset Idle timeout, clean up timer observer and close dialog
      Idle.watch();
      idleWarnSub();
      $scope.closeThisDialog(0);
    }



    function logout() {
      // Clean up timer observer and call logout from parent controller
      $rootScope.$broadcast('userLoggedOut');
      idleWarnSub();
      $scope.closeThisDialog(0);
      vm.serviceLogout();
    }

    // Clean up when modal is destroyed
    $scope.$on('$destroy', function() {
      if (angular.isFunction(idleWarnSub)) {
        idleWarnSub();
      }
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

  $stateProvider
    .state('uprofile', {
      parent: 'main',
      url: '/uprofile',
      abstract: true,
      controller: 'UprofileController',
      controllerAs: 'vm',
      templateUrl: 'app/uprofile/uprofile.html',
      data:{
         authentication:  false
        },
      redirectTo: 'uprofile.info'
    })
    .state('uprofile.info', {
      url: '/info',
      views: {
        "viewAccount": {
          controller:'UprofileController',
          controllerAs:'vm',
          templateUrl: 'app/uprofile/account/account.html'
        },
        "viewPayment": {
          controller:'UprofilePaymentController',
          controllerAs:'vm',
          templateUrl: 'app/uprofile/payment/payment.html'
        }
      }
    })
    .state('uprofile.info.change-password', {
      url: '/password',
      views: {
        "viewAccount@uprofile": {
          controller:'UprofileChangePassController',
          controllerAs:'vm',
          templateUrl: 'app/uprofile/change-password/change-password.html'
        }
      }
    })
    .state('uprofile.info.add-payment', {
      url: '/payment',
      views: {
        "viewPayment@uprofile": {
          controller:'UprofilePaymentController',
          controllerAs:'vm',
          templateUrl: 'app/uprofile/payment/add-payment.html'
        }
      }
    })
    .state('uprofile.info.confirm-cancel-subscription', {
      url: '/subscription',
      onEnter: ['$state', '$uibModal', function($state, $uibModal) {
          $uibModal.open({
            controller:'UprofileSubscriptionController',
            controllerAs:'vm',
            templateUrl: 'app/uprofile/confirm-cancel-subscription/cancel-subscription.html'
          }).result.finally(function() {
            $state.go('^');
          });
        }]
    });
  }
})();

(function(){
  'use strict';

  angular
  .module('icarus')
  .config(configUprofileTranslations);

  function configUprofileTranslations ($translateProvider) {

    $translateProvider.translations('es', {
      'Uprofile': {
        'profile'                           : 'Perfil',
        'payment_information'               : 'información de pago',
        'test_will_end'                     : 'Tu prueba gratuita terminará',
        'select_payment_method'             : 'Ingresar método de pago',
        'test_finished'                     : 'Tu prueba ha terminado.',
        'select_payment_method_to_continue' : 'Ingresa un método de pago para seguir utilizando nuestra aplicación.',
        'next_billing'                      : 'próxima facturación',
        'next_payment_will_be'              : 'Tu próximo pago deberá ser realizado el',
        'update_payment_method'             : 'Actualizar método de pago',
        'unpaid_msg'                        : 'Usted no ha realizado el último pago, éste debe ser realizado antes del',
        'wish'                              : '¿Deseas',
        'cancel_subscription'               : 'cancelar tu suscripción?',
        'Payment' : {
          'not_payment_method'      : 'No existe un método de pago asociado',
          'payment_method'          : 'Método de pago',
          'payment_vehicles'        : 'vehículos pagados',
          'card'                    : 'tarjeta',
          'due_date'                : 'fecha de expiración',
          'edit'                    : 'Editar',
          'to_select_plan'          : 'Para seleccionar este plan debes',
          'delete_vehicles'         : 'eliminar vehículos',
          'maxium_vehicles'         : 'Máximo permitido de vehículos es 1000',
          'invalid_card_number'     : 'Error: ¡número de tarjeta inválido!',
          'due date'                : 'fecha de vencimiento',
          'invalid_expiry'          : 'Error: ¡expiración inválida!',
          'expiration_year_invalid' : 'Error: ¡el año de expiración de tu tarjeta es inválido!',
          'security_code'           : 'código de seguridad',
          'cvc_invalid'             : 'Error: ¡cvc inválido!',
          'discount_code_invalid'   : 'Error: ¡código de descuento inválido!',
          'success_msg'             : '¡Información guardada exitosamente!',
          'error_msg'               : 'Error con la tarjeta, por favor intenta nuevamente.',
          'error_coupon_msg'        : 'Error con el código de descuento, código de descuento no válido!',
          'cancel'                  : 'Cancelar',
          'save'                    : 'Guardar',
          'discount_code'           : 'Código de descuento'
        },
        'Payment_success': {
          'title'                   : 'Pago realizado',
          'msg'                     : '¡Tu pago se procesó exitosamente!',
          'accept'                  : 'Aceptar'
        },
        'CCSubscription': {
          'cancel_subscription' : 'Cancelar suscripción',
          'really_want_cancel'  : '¿Desea realmente cancelar la suscripción?',
          'close'               : 'Cerrar'
        },
        'ChangePassword': {
          'title'                         : 'Información de tu cuenta',
          'fullname'                      : 'nombre completo',
          'email'                         : 'email',
          'business'                      : 'empresa',
          'country'                       : 'país',
          'token'                         : 'token',
          'actual_password'               : 'contraseña actual',
          'actual_password_invalid'       : 'Contraseña actual inválida',
          'required_password'             : 'Contraseña requerida',
          'too_short_password'            : 'Longitud mínima de 8 caracteres',
          'new_password'                  : 'nueva contraseña',
          'repeat_new_password'           : 'repetir nueva contraseña',
          'passwords_not_equal'           : 'Las contraseñas no coinciden, por favor intente de nuevo.',
          'password_changed_successfully' : 'Su contraseña ha sido cambiada exitosamente!',
          'change_password'               : 'Cambiar contraseña',
          'cancel'                        : 'Cancelar'
        },
        'Account': {
          'title'              : 'Información de tu cuenta',
          'fullname'           : 'nombre completo',
          'email'              : 'email',
          'business'           : 'empresa',
          'country'            : 'país',
          'token'              : 'token',
          'change_password'    : 'Cambiar contraseña'
        }
      }
    });
    $translateProvider.translations('en', {
      'Uprofile': {
        'profile'                           : 'Profile',
        'payment_information'               : 'payment information',
        'test_will_end'                     : 'Your trial account will end',
        'select_payment_method'             : 'Add your payment information',
        'test_finished'                     : 'Your trial period has ended.',
        'select_payment_method_to_continue' : 'Add your payment information to continue using SimpliRoute',
        'next_billing'                      : 'next billing cycle',
        'next_payment_will_be'              : 'You next payment will be charged at',
        'update_payment_method'             : 'Update payment information',
        'unpaid_msg'                        : 'You have an overdue payment, this should be paid before',
        'wish'                              : '¿Do you',
        'cancel_subscription'               : 'want to cancel your subscription?',
        'Payment' : {
          'not_payment_method'      : 'No payment method associated to your account',
          'payment_method'          : 'Payment information',
          'payment_vehicles'        : 'paid vehicles',
          'card'                    : 'card',
          'due_date'                : 'expiration date',
          'edit'                    : 'Edit',
          'to_select_plan'          : 'To choose this plan you have to',
          'delete_vehicles'         : 'delete vehicles',
          'maxium_vehicles'         : 'Max number of vehicles is 1000',
          'invalid_card_number'     : 'Error: invalid credit card number!',
          'due date'                : 'due date',
          'invalid_expiry'          : 'Error: invalid expiration date!',
          'expiration_year_invalid' : 'Error: invalid expiration year!',
          'security_code'           : 'Security code',
          'cvc_invalid'             : 'Error: invalid CVC!',
          'discount_code_invalid'   : 'Error: invalid discount code!',
          'success_msg'             : 'Successfully saved information!',
          'error_msg'               : 'Error with your card, please try again.',
          'error_coupon_msg'        : 'Discount code error, invalid discount code!',
          'cancel'                  : 'Cancel',
          'save'                    : 'Save',
          'discount_code'           : 'Discount code'
        },
        'Payment_success': {
          'title'                   : 'Payment made',
          'msg'                     : 'Your payment was processed successfully!',
          'accept'                  : 'Accept'
        },
        'CCSubscription': {
          'cancel_subscription': 'Cancel subscription',
          'really_want_cancel' : 'Do you want to cancel your subscription?',
          'close'              : 'Close'
        },
        'ChangePassword': {
          'title'              : 'Account information',
          'fullname'           : 'Full name',
          'email'              : 'Email',
          'business'           : 'Company name',
          'country'            : 'Country',
          'token'              : 'Api token',
          'actual_password'    : 'Current password',
          'actual_password_invalid' : 'Invalid current password',
          'required_password'  : 'Password is required',
          'too_short_password' : 'Minimum length of 8 characters',
          'new_password'       : 'new password',
          'repeat_new_password': 'Repeat your password',
          'passwords_not_equal': 'Passwords don\'t match, please retype.',
          'password_changed_successfully': 'Password updated!',
          'change_password'    : 'Change password',
          'cancel'             : 'Cancel'
        },
        'Account': {
          'title'              : 'Account information',
          'fullname'           : 'Full name',
          'email'              : 'Email',
          'business'           : 'Company name',
          'country'            : 'Country',
          'token'              : 'Api token',
          'change_password'    : 'Change password'
        }
      }
    });
    $translateProvider.translations('pt', {
      'Uprofile': {
        'profile'                           : 'Perfil',
        'payment_information'               : 'Informaçāo de pagamento',
        'test_will_end'                     : 'Seu teste gratuito se encerrará',
        'select_payment_method'             : 'Inserir método de pagamento',
        'test_finished'                     : 'Seu teste terminou.',
        'select_payment_method_to_continue' : 'Introduza um método de pagamento para continuar usando nosso aplicativo.',
        'next_billing'                      : 'próximo faturamento',
        'next_payment_will_be'              : 'Seu próximo pagamento deve ser feito o',
        'update_payment_method'             : 'Atualização método de pagamento',
        'unpaid_msg'                        : 'Você não ter feito o pagamento final, isso deve ser feito antes',
        'wish'                              : 'Deseja',
        'cancel_subscription'               : 'cancelar sua assinatura?',
        'Payment' : {
          'not_payment_method'      : 'Não existe um método de pagamento associado',
          'payment_method'          : 'Método de pagamento',
          'payment_vehicles'        : 'veículos pagos',
          'card'                    : 'número do cartão',
          'due_date'                : 'data de expiração',
          'edit'                    : 'Editar',
          'to_select_plan'          : 'Para selecionar este plano você deve',
          'delete_vehicles'         : 'remover veículos',
          'maxium_vehicles'         : 'Máxima do veículo é de 1000',
          'invalid_card_number'     : 'Erro: número de cartão inválido!',
          'due date'                : 'data de expiração',
          'invalid_expiry'          : 'Erro: data de expiração inválido!',
          'expiration_year_invalid' : 'Erro: O ano de validade do cartão é inválido!',
          'security_code'           : 'código de segurança',
          'cvc_invalid'             : 'Error: código de segurança inválido!',
          'discount_code_invalid'   : 'Error: código de desconto inválido!',
          'success_msg'             : 'Informações salvas com sucesso!',
          'error_msg'               : 'Cartão de erro, por favor tente novamente.',
          'error_coupon_msg'        : 'Erro com o código de desconto, código de desconto inválido!',
          'cancel'                  : 'Cancelar',
          'save'                    : 'Salvar',
          'discount_code'           : 'Código de cupão'
        },
        'Payment_success': {
          'title'                   : 'Pagamento realizado',
          'msg'                     : 'O seu pagamento é processado com sucesso!.',
          'accept'                  : 'aceitar'
        },
        'CCSubscription': {
          'cancel_subscription': 'Cancelar assinatura?',
          'really_want_cancel' : 'Realmente você deseja cancelar a sua assinatura?',
          'close'              : 'Fechar'
        },
        'ChangePassword': {
          'title'                         : 'Informações de sua conta',
          'fullname'                      : 'nome completo',
          'email'                         : 'email',
          'business'                      : 'empresa',
          'country'                       : 'país',
          'token'                         : 'token',
          'actual_password'               : 'senha atual',
          'actual_password_invalid'       : 'Senha atual inválida',
          'required_password'             : 'senha necessária',
          'too_short_password'            : 'Comprimento mínimo de 8 caracteres',
          'new_password'                  : 'nova senha',
          'repeat_new_password'           : 'repetir nova senha',
          'passwords_not_equal'           : 'Las contraseñas no coinciden, por favor intente de nuevo.',
          'password_changed_successfully' : 'Su contraseña ha sido cambiada exitosamente!',
          'change_password'               : 'Cambiar contraseña',
          'cancel'                        : 'Fechar'
        },
        'Account': {
          'title'              : 'Informações de sua conta',
          'fullname'           : 'nome completo',
          'email'              : 'email',
          'business'           : 'empresa',
          'country'            : 'país',
          'token'              : 'token',
          'change_password'    : 'Trocar senha'
        }
      }
    });
  }
})();

/* global FileReader:false */
(function(){
  'use strict';

  angular
    .module('icarus')
    .controller('UprofileController', UprofileController);

  /** @ngInject */
  function UprofileController($rootScope) {
    $rootScope.isLoading = true;
  }
})();

(function() {
  "use strict";

  angular
    .module("icarus.transportationProviderPayment", []);

})();

(function() {
  "use strict";

  angular
    .module("icarus.transportationProviderPayment")
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state("transportation_provider_payment", {
        parent: "main",
        url:  "/transportation-provider-payment",
        controller: "TransportationProviderPaymentController",
        controllerAs: "vm",
        templateUrl: "app/transportationProviderPayment/transportationProviderPayment.html",
        data:{
          authentication:  true
        },
        params: {
          baseUrl: null,
          stripeCustomerId: null,
          userToken: null
        },
        resolve: {
          shareState: function ($stateParams, $q, sessionService, addonsService, TMS_ADD_ON_KEY,
                                TRANSPORTATION_PROVIDER_PAYMENT_URL_ADD_ON_PROPERTY_KEY) {
            var shareState = {
              baseUrl: $stateParams.baseUrl || null,
              stripeCustomerId: $stateParams.stripeCustomerId || null,
              userToken: $stateParams.userToken || null
            };

            if (shareState.baseUrl && shareState.stripeCustomerId && shareState.userToken) {
              return $q.when(shareState);
            }

            return $q.all([sessionService.getUser(), addonsService.getInfoAddonAndPropertiesByKey(TMS_ADD_ON_KEY)])
              .then(function (responses) {
                var user = responses[0];
                var tmsAddOn = responses[1];

                var transportationProviderPaymentUrlProperty = tmsAddOn.properties.find(function (property) {
                  return property.key === TRANSPORTATION_PROVIDER_PAYMENT_URL_ADD_ON_PROPERTY_KEY;
                });
                if (transportationProviderPaymentUrlProperty) {
                  shareState.baseUrl = transportationProviderPaymentUrlProperty.value;
                }

                shareState.stripeCustomerId = user.account.stripe_customer_id || null;
                shareState.userToken = user.api_token || null;
                return shareState;
              });
          }
        }
      });
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.transportationProviderPayment")
    .controller("TransportationProviderPaymentController", TransporationProviderPaymentController);

  /** @ngInject */
  function TransporationProviderPaymentController(shareState) {
    var vm = this;

    vm.url = null;

    function _getTransportationProviderPaymentUrl(baseUrl, stripeCustomerId, userToken) {
      var id = stripeCustomerId.replace("cus_", "");
      return baseUrl + "#id=" + id + "&token=" + userToken;
    }

    function active() {
      vm.url = _getTransportationProviderPaymentUrl(shareState.baseUrl, shareState.stripeCustomerId, shareState.userToken);
    }

    active();
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, moment, DATE_FORMAT) {

    $stateProvider
      .state('tracking', {
        parent: 'main',
        url: '/tracking/:trackingDate',
        params: {trackingDate: moment().format(DATE_FORMAT), filters: null},
        controller: 'TrackingController',
        controllerAs: 'vm',
        templateUrl: 'app/tracking/tracking.html',
        data: {
          authentication: true
        },
        redirectTo: 'tracking.vehicles'
      })
      .state('tracking.vehicles', {
        url: '/vehicles',
        params: {trackingDate: moment().format(DATE_FORMAT)},
        views: {
          "tab-content": {
            controller: 'VehiclesController',
            controllerAs: 'vm',
            templateUrl: 'app/tracking/vehicles/vehicles.html'
          }
        }
      })
      .state('tracking.all-dispatchs', {
        url: '/dispatchs',
        params: {
          trackingDate: moment().format(DATE_FORMAT),
          fromTracking: false
        },
        views: {
          "tab-content": {
            controller: 'TrackingDispatchListController',
            controllerAs: 'vm',
            templateUrl: 'app/tracking/dispatchs/all-dispatchs.html'
          }
        }
      })
      .state('tracking.all-dispatchs.detail', {
        url: "/:dispatchsId",
        onEnter: [
          '$state', 'ngDialog', '$stateParams', 'trackingService', 'extraFieldsService', '$q',
          onEnter.bind(this)
        ]
      })
      .state('tracking.vehicles.driver-dispatchs', {
        url: '/{vehicleId:int}/:driverId',
        views: {
          "item-detail@tracking": {
            controller: 'TrackingDriverDispatchListController',
            controllerAs: 'vm',
            templateUrl: 'app/tracking/dispatchs/driver-dispatchs.html'
          }
        }
      })
      .state('tracking.vehicles.driver-dispatchs.detail', {
        url: "/:dispatchsId",
        params: { planId: null, routeId: null, fatherVisit: null, subVisitPosition: null },
        onEnter: [
          '$state', 'ngDialog', '$stateParams', 'trackingService', 'extraFieldsService', '$q',
          onEnter.bind(this)
        ]
      })
      .state('tracking.events', {
        url: '/events',
        params: {
          trackingDate: moment().format(DATE_FORMAT),
          fromTracking: false
        },
        views: {
          "tab-content": {
            controller: 'EventsController',
            controllerAs: 'vm',
            templateUrl: 'app/tracking/events/events.html'
          }
        }
      })
      .state('tracking.events.detail', {
        url: '/:dispatchsId',
        onEnter: [
          '$state', 'ngDialog', '$stateParams', 'trackingService', 'extraFieldsService', '$q',
          onEnter.bind(this)
        ]
      });

    ///////////////////////////////////////

    function onEnter($state, ngDialog, $stateParams, trackingService, extraFieldsService, $q) {
      var dialog = ngDialog.open({
        controller: 'TrackingDispatchDetailController',
        controllerAs: 'vm',
        resolve: {
          'visit': _resolve
        },
        template: 'app/tracking/dispatchs/dispatch-detail.html',
        className: 'ngdialog-theme-default custom-modal-center'
      });

      dialog.closePromise.then(function (dialog) {
        if (dialog.value !== 'idle_logout') {
          $state.go('^', {}, {notify: false});
        }
      });

      function _resolve() {
        return trackingService.manageGetVisitForTrackingDetail($stateParams.dispatchsId);
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {

    $translateProvider.translations('es', {
      'Tracking' : {
        'vehicles'         : 'Vehículos',
        'without_pictures' : 'No se han ingresado imágenes',
        'download_pictures': 'Descargar adjuntos',
        'show_dispatchs'   : 'Ver todas las <br> visitas',
        'hide_dispatchs'   : 'Ocultar <br> visitas',
        'error_data'       : '¡Oh-oh!',
        'error_data_1'     : 'Hubo un problema al consultar la información del día. <br>',
        'error_data_2'     : 'Por favor vuelve a cargar la página',
        'tracking'         : 'Seguimiento',
        'visits'           : 'Visitas',
        'events'           : 'Eventos',
        'route'            : 'Ruta',
        'active_vehicles'  : 'Vehículos activos',
        'inactive_vehicles': 'Vehículos inactivos',
        'order_by'         : 'Ordenar por',
        'eta_tooltip'           : 'Hora programada',
        'checkout_time_tooltip' : 'Hora checkout'
      },
      'Indicators' : {
        'date_title'       : 'Fecha',
        'alerts_title'     : 'Alertas',
        'alerts_message'   : 'Atención urgente',
        'progress_bar'     : 'Progreso de visitas',
        'date_submit_button_title': 'Filtrar',
        'date_reset_button_title': 'Resetear'
      },
      'Visits' : {
        'alerts'                          : 'Alertas de visita',
        'visits'                          : 'Visitas',
        'search'                          : 'Buscar',
        'join_similar'                    : 'Unir Similares',
        'show_similar_visits'             : 'Mostrar Similares',
        'visits_failed'                   : 'Visitas fallidas',
        'create_route'                    : 'Crear una ruta',
        'without_visits_title'            : 'No encontramos visitas <br> para la fecha seleccionada',
        'without_visits_message'          : 'para agregar visitas a los vehículos.',
        'without_visits_filter'           : 'No hemos encontrado visitas',
        'without_visits_filter_message'   : '¡Ups! No obtuvimos resultados. Por favor intenta nuevamente',
        'modal_title_visit_failed'        : 'Visita fallida',
        'modal_title_visit_completed'     : 'Visita exitosa',
        'modal_title_visit_canceled'      : 'Visita cancelada',
        'modal_title_visit_pending'       : 'Visita pendiente',
        'modal_title_visit_partial'       : 'Entrega parcial',
        'modal_body_visit_location'       : 'Ubicación',
        'modal_body_visit_date'           : 'Fecha',
        'modal_body_visit_info'           : 'Información de visita',
        'modal_body_visit_estimated_time' : 'Hora estimada',
        'modal_body_visit_check_in'       : 'Check in',
        'modal_body_visit_check_out'      : 'Check out',
        'modal_body_visit_time_service'   : 'Tiempo de servicio',
        'modal_body_visit_comments'       : 'Comentarios',
        'modal_body_visit_observations'   : 'Motivos',
        'modal_body_visit_contact_name'   : 'Nombre',
        'modal_body_visit_contact_phone'  : 'Teléfono de contacto',
        'modal_body_visit_contact_email'  : 'Email',
        'modal_body_visit_time_window'    : 'Ventanas horarias',
        'modal_time_window_to'            : 'a',
        'modal_time_window_since'         : 'Desde las',
        'modal_time_window_until_to'      : 'Hasta las',
        'modal_checkout_pending'          : 'Esta visita aún no se ha completado',
        'modal_body_visit_load'           : 'Carga',
        'modal_body_visit_load_2'         : 'Carga 2',
        'modal_body_visit_load_3'         : 'Carga 3',
        'show_extra_fields'               : 'Ver más',
        'hide_extra_fields'               : 'Ocultar',
        'extra_fields_value'              : 'Más información',
        'notes'                           : 'Notas',
        'pending_checkout'                : 'Esta visita aún no se ha completado',
        'not_checkout'                    : 'Visita sin datos GPS',
        'attach'                          : 'Adjuntos',
        'map'                             : 'Mapa',
        'custom_alerts'                   : 'Alertas personalizadas',
        'view_image'                      : 'Ver imagen',
        'checkout_author'                 : 'Autor check out',
        'completed'                        : 'Exitosa',
        'pending'                         : 'Pendiente',
        'partial'                         : 'Entrega parcial',
        'failed'                          : 'Fallida',
        'canceled'                        : 'Cancelada',
        'show_left_tooltip'               : 'Mostrar visitas anteriores',
        'show_right_tooltip'              : 'Mostrar visitas siguientes'
      },
      'Driver' : {
        'driver'                  : 'Conductor',
        'driver_without_routes'   : 'Conductor sin rutas',
        'without_assigned_driver' : 'Sin conductor',
        'codrivers'               : 'Copilotos'
      },
      'Vehicle': {
        'vehicle'                 : 'Vehículo',
        'create_vehicle'          : 'Crear vehículo',
        'codriver'                : 'Copiloto',
        'without_vehicle_title'   : 'No existen vehículos con <br> rutas para la fecha <br> seleccionada.',
        'without_vehicle_message' : 'Crea tu primer vehículo',
        'vehicle_without_routes'  : 'Vehículo sin ruta asignada',
        'vehicle_without_routes_message': 'para agregar visitas a este vehículo.',
        'vehicle_filter_empty_results'           : 'Vehículo no encontrado',
        'vehicle_filter_empty_results_message'   :  '¡Ups! No obtuvimos resultados. Por favor intenta nuevamente',
        'vehicle_order_by'                       :  'Ordenar por:',
        'vehicle_sort_by_name_asc'              : 'Orden alfabético (ASC)',
        'vehicle_sort_by_name_desc'             : 'Orden alfabético (DESC)',
        'vehicle_sort_by_progress_asc'          : 'Cumplimiento de ruta (ASC)',
        'vehicle_sort_by_progress_desc'         : 'Cumplimiento de ruta (DESC)',
        'vehicle_sort_by_start_time_asc'        : 'Hora de inicio de ruta (ASC)',
        'vehicle_sort_by_start_time_desc'       : 'Hora de inicio de ruta (DESC)',
        'gps-ready-status-'                     : 'Sin GPS hace más de 10 min', // No at all GPS - RED
        'gps-ready-status-0'                    : 'Recibiendo GPS', // Recieveing GPS - GREEN
        'gps-ready-status-1'                    : 'Sin GPS hace más de 5 min', // Less than 10 min with no GPS - YELLOW
        'gps-ready-status-2'                    : 'Sin GPS hace más de 10 min', // More than 10 min with no GPS - RED
        'route_start_time': 'Hora de inicio: ',
        'rest_time_conector'                    : ' a ',
        'rest_time'                             : 'Hora de descanso'
      },
      'Info':{
        'unavailable_tracking'           : 'Seguimiento no disponible',
        'no_day_routes'                  : 'No hay rutas creadas para la fecha.',
        'please'                         : 'Por favor',
        'select_other_date'              : 'selecciona otra fecha',
        'or'                             : 'o',
        'create_route'                   : 'Crea una ruta',
        'actives'                        : 'Activos'
      },
      'Tracking_toast' : {
        'error_get_map'          : 'Error obteniendo el mapa, por favor revisar opciones del mapa',
        'error_get_options_map_1': 'Error en sintáxis del mapa.',
        'error_get_options_map_2': '¡Error! Mapa no encontrado.',
        'error_vehicle_not_found': '¡Error! vehículo no encontrado',
        'error_get_data_server'  : 'Error obteniendo información del servidor',
        'error_visit_not_found'  : '¡Error! visita no encontrada'
      },
      'Events' : {
        'without_events_title'   : 'No hay eventos <br> para mostrar',
        'completed'              : 'exitosa',
        'failed'                 : 'fallida',
        'partial'                : 'parcial',
        'window_broken'          : 'fuera de ventana horaria',
        'file_attached'          : 'archivo adjunto',
        'visit'                  : 'Visita',
        'route_started'          : 'inició ruta',
        'route_finished'          : 'terminó ruta',
        'gps_route_finished'      : 'Rutas finalizadas por el usuario',
        'next'                   : 'Siguientes',
        'previous'               : 'Anteriores',
        'next_tooltip'           : 'Mostrar eventos anteriores',
        'previous_tooltip'       : 'Mostrar eventos siguientes'
      },
      'Items' : {
        'items'                  : 'Ítems',
        'items_tooltip'          : 'Información de ítems',
        'assigned_items'         : 'Ítems asignados',
        'completed_total'        : 'Entregados',
        'partial_total'          : 'Parciales',
        'failed_total'           : 'No entregados',
        'show_items'             : 'Ver ítems',
        'quantity_summary'       : 'productos entregados de',
        'pickup_quantity_summary': 'ítems recolectados de',
        'motive'                 : 'MOTIVO',
        'comment'                : 'COMENTARIO'
      },
      'Directions': {
        'north'       : 'Norte',
        'northeast'   : 'Nordeste',
        'east'        : 'Este',
        'southeast'   : 'Sudeste',
        'south'       : 'Sur',
        'southwest'   : 'Suroeste',
        'west'        : 'Oeste',
        'northwest'   : 'Noroeste',
        'noInfo'      : 'Sin orientación',
      }
    });
    $translateProvider.translations('en', {
      'Tracking' : {
        'vehicles'          : 'Vehicles',
        'without_pictures'  : 'No images have been uploaded',
        'download_pictures' : 'Download attachments',
        'show_dispatchs'    : 'View all <br> visits',
        'hide_dispatchs'    : 'Hide <br> visits',
        'error_data'        : 'Uh-oh!',
        'error_data_1'      : 'There was a problem querying the day\'s information. <br>',
        'error_data_2'      : 'Please reload the website.',
        'tracking'          : 'Tracking',
        'visits'            : 'Visits',
        'events'            : 'Events',
        'route'             : 'Route',
        'active_vehicles'  : 'Active vehicles',
        'inactive_vehicles': 'Inactive vehicles',
        'order_by'         : 'Sort by',
        'eta_tooltip'           : 'Scheduled time',
        'checkout_time_tooltip' : 'Checkout time'
      },
      'Indicators' : {
        'progress_bar'  : 'Visits progress',
        'alerts_title'  : 'Alerts',
        'alerts_message': 'Urgent attention',
        'date_title'    : 'Date',
        'date_submit_button_title': 'Filter',
        'date_reset_button_title': 'Reset'
      },
      'Visits' : {
        'alerts'                          : 'Visit alerts',
        'visits'                          : 'Visits',
        'search'                          : 'Search',
        'join_similar'                    : 'Join Similars',
        'show_similar_visits'             : 'Show Similars',
        'visits_failed'                   : 'Failed visits',
        'create_route'                    : 'Create a route',
        'without_visits_title'            : 'No visits found <br> for the selected date',
        'without_visits_message'          : 'to add visits to vehicles.',
        'without_visits_filter'           : 'We did not find any visits.',
        'without_visits_filter_message'   : 'Oops! No results were found. Please try again',
        'modal_title_visit_failed'        : 'Visit failed',
        'modal_title_visit_completed'     : 'Visit succeeded',
        'modal_title_visit_canceled'      : 'Visit canceled',
        'modal_title_visit_pending'       : 'Visit pending',
        'modal_title_visit_partial'       : 'Partial dispatch',
        'modal_body_visit_location'       : 'Location',
        'modal_body_visit_date'           : 'Date',
        'modal_body_visit_info'           : 'Visit information',
        'modal_body_visit_estimated_time' : 'Estimated time',
        'modal_body_visit_check_in'       : 'Check in',
        'modal_body_visit_check_out'      : 'Check out',
        'modal_body_visit_time_service'   : 'Service time',
        'modal_body_visit_comments'       : 'Comments',
        'modal_body_visit_observations'   : 'Motives',
        'modal_body_visit_contact_name'   : 'Name',
        'modal_body_visit_contact_phone'  : 'Phone number',
        'modal_body_visit_contact_email'  : 'Email',
        'modal_body_visit_time_window'    : 'Time windows',
        'modal_time_window_to'            : 'to',
        'modal_time_window_since'         : 'Since',
        'modal_time_window_until_to'      : 'Until to',
        'modal_checkout_pending'          : 'This visit has not been completed yet',
        'modal_body_visit_load'           : 'Load',
        'modal_body_visit_load_2'         : 'Load 2',
        'modal_body_visit_load_3'         : 'Load 3',
        'show_extra_fields'               : 'View more',
        'hide_extra_fields'               : 'Hide',
        'extra_fields_value'              : 'More information',
        'notes'                           : 'Notes',
        'pending_checkout'                : 'This visit has not been completed yet',
        'not_checkout'                    : 'Visit without GPS data',
        'attach'                          : 'Attached',
        'map'                             : 'Map',
        'custom_alerts'                   : 'Custom alerts',
        'view_image'                      : 'View image',
        'checkout_author'                 : 'Checked out by',
        'completed'                       : 'Success',
        'pending'                         : 'Pending',
        'partial'                         : 'Partial delivery',
        'failed'                          : 'Failed',
        'canceled'                        : 'Canceled',
        'show_left_tooltip'               : 'Show previous visits',
        'show_right_tooltip'              : 'Show next visits'
      },
      'Driver' : {
        'driver'                  : 'Driver',
        'driver_without_routes'   : 'Driver without routes',
        'without_assigned_driver' : 'Without driver',
        'codrivers'               : 'Co-drivers'
      },
      'Vehicle': {
        'vehicle'                                 : 'Vehicle',
        'create_vehicle'                          : 'Create vehicle',
        'codriver'                                : 'Co-driver',
        'without_vehicle_title'                   : 'There are no vehicles with <br> routes for the <br> selected date.',
        'without_vehicle_message'                 : 'Create your first vehicle',
        'vehicle_without_routes'                  : 'Vehicles without assigned route',
        'vehicle_without_routes_message'          : 'to add visits to this vehicle.',
        'vehicle_filter_empty_results'             : 'Vehicle not found',
        'vehicle_filter_empty_results_message'     :  'Oops, no results. Please try again',
        'vehicle_order_by'                        :  'Sort by:',
        'vehicle_sort_by_name_asc'                : 'Alphabetical order (ASC)',
        'vehicle_sort_by_name_desc'               : 'Alphabetical order (DESC)',
        'vehicle_sort_by_progress_asc'            : 'Route completion (ASC)',
        'vehicle_sort_by_progress_desc'           : 'Route completion (DESC)',
        'vehicle_sort_by_start_time_asc'          : 'Route start time (ASC)',
        'vehicle_sort_by_start_time_desc'         : 'Route start time (DESC)',
        'gps-ready-status-'                       : 'Last GPS recieved: +10 min', // No at all GPS - RED
        'gps-ready-status-0'                      : 'Live GPS', // Recieveing GPS - GREEN
        'gps-ready-status-1'                      : 'Last GPS recieved: +5 min', // Less than 10 min with no GPS - YELLOW
        'gps-ready-status-2'                      : 'Last GPS recieved: +10 min', // More than 10 min with no GPS - RED
        'route_start_time'                        : 'Start time: ',
        'rest_time_conector'                      : ' to ',
        'rest_time'                               : 'Rest time:'
      },
      'Info':{
        'unavailable_tracking'           : 'Tracking unavailable',
        'no_day_routes'                  : 'No routes created for the date.',
        'please'                         : 'Please',
        'select_other_date'              : 'select another date',
        'or'                             : 'or',
        'create_route'                   : 'Create a route.'
      },
      'Tracking_toast' : {
        'error_get_map' : 'Error getting the map, please review map options',
        'error_get_options_map_1': 'Error in map syntax',
        'error_get_options_map_2': 'Error! map not found.',
        'error_vehicle_not_found': 'Error! Vehicle not found',
        'error_get_data_server'  : 'Error getting data from server.',
        'error_visit_not_found'  : 'Error! Visit not found'
      },
      'Events' : {
        'without_events_title'   : 'There are no events <br> to show',
        'completed'              : 'successful',
        'failed'                 : 'failed',
        'partial'                : 'partial',
        'window_broken'          : 'out of time window',
        'file_attached'          : 'attached file',
        'visit'                  : 'visit',
        'route_started'          : 'started route',
        'route_finished'          : 'finished route',
        'gps_route_finished'      : 'Routes finished by user',
        'next'                   : 'Next',
        'previous'               : 'Previous',
        'next_tooltip'           : 'Show next events',
        'previous_tooltip'       : 'Show previous events'
      },
      'Items' : {
        'items'                  : 'Items',
        'items_tooltip'          : 'Items information',
        'assigned_items'         : 'Items assigned',
        'completed_total'        : 'Delivered',
        'partial_total'          : 'Partial',
        'failed_total'           : 'Not delivered',
        'show_items'             : 'Items detail',
        'quantity_summary'       : 'products delivered of',
        'pickup_quantity_summary': 'items collected of',
        'motive'                 : 'REASON',
        'comment'                : 'COMMENT'
      },
      'Directions': {
        'north'       : 'North',
        'northeast'   : 'Northeast',
        'east'        : 'East',
        'southeast'   : 'Southeast',
        'south'       : 'South',
        'southwest'   : 'Southwest',
        'west'        : 'West',
        'northwest'   : 'Northwest',
        'noInfo'      : 'No orientation',
      }
    });
    $translateProvider.translations('pt', {
      'Tracking' : {
        'vehicles'          : 'Veículos',
        'without_pictures'  : 'NÃO HÁ IMAGENS ANEXADAS',
        'download_pictures' : 'Fazer download de anexos',
        'show_dispatchs'    : 'ver todas as <br> entregas',
        'hide_dispatchs'    : 'ocultar <br> entregas',
        'error_data'        : 'OH!',
        'error_data_1'      : 'Há um problema ao visualizar as informações do dia. <br>',
        'error_data_2'      : 'Por favor, atualize o site.',
        'visits'            : 'Entregas',
        'tracking'          : 'Rastreamento',
        'events'            : 'Eventos',
        'route'             : 'rota',
        'active_vehicles'  : 'ativos',
        'inactive_vehicles': 'inativos',
        'order_by'         : 'ordenar por',
        'eta_tooltip'           : 'Horário agendado',
        'checkout_time_tooltip' : 'Tempo de visita'
      },
      'Indicators' : {
        'date_title'    : 'Data',
        'alerts_title'  : 'atenção',
        'alerts_message': 'atendimento de urgência',
        'progress_bar'  : 'progresso de entregas',
        'date_submit_button_title': 'Filtro',
        'date_reset_button_title': 'Eliminar'
      },
      'Visits' : {
        'alerts'                      : 'Entregas com alerta',
        'visits'                      : 'Entregas',
        'search'                      : 'Busca',
        'join_similar'                : 'Unir similares',
        'show_similar_visits'         : 'Ver Similares',
        'visits_failed'               : 'Entregas não realizadas',
        'create_route'                : 'Crie uma rota',
        'without_visits_title'        : 'Não há entregas <br> marcadas para a data <br> selecionada',
        'without_visits_message'      : 'para designar entregas aos veículos.',
        'without_visits_filter'       : 'Entrega não encontrada',
        'without_visits_filter_message'   : 'A sua pesquisa não gerou resultados, por favor tente novamente.',
        'modal_title_visit_completed' : 'Entrega realizada',
        'modal_title_visit_canceled'  : 'Entrega cancelada',
        'modal_title_visit_pending'   : 'Entrega pendente',
        'modal_title_visit_failed'    : 'Entrega não realizada',
        'modal_title_visit_partial'   : 'Entrega parcial',
        'modal_body_visit_location'   : 'Localização',
        'modal_body_visit_date'       : 'Data',
        'modal_body_visit_info'       : 'Informações da entrega',
        'modal_body_visit_estimated_time' : 'Hora prevista',
        'modal_body_visit_check_in'       : 'Check in',
        'modal_body_visit_check_out'      : 'Check out',
        'modal_body_visit_time_service'   : 'Tempo de serviço',
        'modal_body_visit_comments'       : 'Comentários',
        'modal_body_visit_observations'   : 'Observação',
        'modal_body_visit_contact_name'   : 'Nome de contato',
        'modal_body_visit_contact_phone'  : 'Telefone',
        'modal_body_visit_contact_email'  : 'Email',
        'modal_body_visit_time_window'    : 'Janelas de horário',
        'modal_time_window_to'            : 'a',
        'modal_time_window_since'         : 'Das',
        'modal_time_window_until_to'      : 'às',
        'modal_checkout_pending'          : 'Entrega ainda não realizada',
        'modal_body_visit_load'           : 'Carga',
        'modal_body_visit_load_2'         : 'Carga 2',
        'modal_body_visit_load_3'         : 'Carga 3',
        'show_extra_fields'               : 'Veja mais',
        'hide_extra_fields'               : 'esconder',
        'extra_fields_value'              : 'Informações adicionais de entregas',
        'notes'                           : 'Notas',
        'pending_checkout'                : 'Esta visita ainda não foi finalizada',
        'not_checkout'                    : 'Visita sem dados GPS',
        'attach'                          : 'Anexos',
        'map'                             : 'Mapa',
        'custom_alerts'                   : 'Alertas customizados',
        'view_image'                      : 'Ver imagem',
        'checkout_author'                 : 'Autor do checkout',
        'completed'                       : 'Sucesso',
        'pending'                         : 'Pendente',
        'partial'                         : 'Entrega parcial',
        'failed'                          : 'Falha',
        'canceled'                        : 'Cancelada',
        'show_left_tooltip'               : 'Mostrar entregas anteriores',
        'show_right_tooltip'              : 'Mostrar entregas seguintes'
      },
      'Driver' : {
        'driver'                  : 'Motorista',
        'driver_without_routes'   : 'motorista sem rotas',
        'without_assigned_driver' : 'sem motorista designado',
        'codrivers'               : 'Co-pilotos'
      },
      'Vehicle': {
        'vehicle'                       : 'Veículo',
        'create_vehicle'                : 'Por favor',
        'codriver'                      : 'Copiloto',
        'without_vehicle_title'         : 'Não há veículos com <br> rotas para a data <br> selecionada.',
        'without_vehicle_message'       : 'criar o seu primeiro veículo',
        'vehicle_without_routes'        : 'Veículo sem rota designada',
        'vehicle_without_routes_message': 'para designar entregas para este veículo.',
        'vehicle_filter_empty_results'  : 'Veículo não encontrado',
        'vehicle_filter_empty_results_message'  :  'A sua pesquisa não gerou resultados, <br> por favor tente novamente.',
        'vehicle_order_by'                      :  'Organizar por:',
        'vehicle_sort_by_name_asc'     : 'Ordem alfabética (ASC)',
        'vehicle_sort_by_name_desc'    : 'Ordem alfabética (DESC)',
        'vehicle_sort_by_progress_asc' : 'Conformidade de rota (ASC)',
        'vehicle_sort_by_progress_desc': 'Conformidade de rota (DESC)',
        'vehicle_sort_by_start_time_asc'      : 'Hora inicial da rota (ASC)',
        'vehicle_sort_by_start_time_desc'     : 'Hora inicial da rota (DESC)',
        'gps-ready-status-'                   : 'Sem GPS há mais de 10min', // No at all GPS - RED
        'gps-ready-status-0'                  : 'GPS ativo', // Recieveing GPS - GREEN
        'gps-ready-status-1'                  : 'Sem GPS há mais de 5min', // Less than 10 min with no GPS - YELLOW
        'gps-ready-status-2'                  : 'Sem GPS há mais de 10min', // More than 10 min with no GPS - RED
        'route_start_time'                    : 'Hora de início: ',
        'rest_time_conector'                  : ' a ',
        'rest_time'                           : 'Intervalo para descanso'
      },
      'Info':{
        'unavailable_tracking'           : 'Acompanhamento não disponível',
        'no_day_routes'                  : 'Não há rotas criadas até esta data.',
        'please'                         : 'Por favor',
        'select_other_date'              : 'selecione outra data',
        'or'                             : 'o',
        'create_route'                   : 'crie uma rota'
      },
      'Tracking_toast' : {
        'error_get_options_map_1': 'Erro ao carregar o mapa',
        'error_get_options_map_2': 'Erro: mapa não encontrado',
        'error_get_map' : 'Erro ao obter o mapa.',
        'error_vehicle_not_found': 'Erro: veículo não encontrado',
        'error_get_data_server'  : 'Erro: veículo não encontrado',
        'error_visit_not_found'  : 'Erro: entrega não encontrada'
      },
      'Events' : {
        'without_events_title'   : 'Ainda não foram gerados <br> eventos',
        'completed'              : 'bem sucedido',
        'failed'                 : 'Falha',
        'partial'                : 'parcial',
        'window_broken'          : 'fora da janela de tempo',
        'file_attached'          : 'arquivo anexo',
        'visit'                  : 'Entrega',
        'route_started'          : 'rota iniciada',
        'route_finished'         : 'rota finalizada',
        'gps_route_finished'      : 'Rotas terminadas pelo usuário',
        'next'                   : 'Próximos',
        'previous'               : 'Anteriores',
        'next_tooltip'           : 'Mostrar próximos eventos',
        'previous_tooltip'       : 'Mostrar eventos anteriores'
      },
      'Items' : {
        'items'                  : 'Itens',
        'items_tooltip'          : 'Informações sobre os items',
        'assigned_items'         : 'Itens atribuídos',
        'completed_total'        : 'Concluído',
        'partial_total'          : 'Parcial',
        'failed_total'           : 'Não entregue',
        'show_items'             : 'Ver itens',
        'quantity_summary'       : 'productos entregados de',
        'pickup_quantity_summary': 'itens recolhidos de',
        'motive'                 : 'RAZÃO',
        'comment'                : 'COMENTE'
      },
      'Directions': {
        'north'       : 'Norte',
        'northeast'   : 'Nordeste',
        'east'        : 'Este',
        'southeast'   : 'Sudeste',
        'south'       : 'Sul',
        'southwest'   : 'Sudoeste',
        'west'        : 'Oeste',
        'northwest'   : 'Noroeste',
        'noInfo'      : 'Sem orientaçao',
      }
    });
  }

})();

/* global FileReader:false */
(function () {
  'use strict';

  angular
    .module('icarus')
    .controller('TrackingController', TrackingController);

  /** @ngInject */
  function TrackingController($scope, $rootScope, $log, $state, $stateParams, moment, lodash,
                              trackingService, $filter, planService, $q, $interval, DATE_FORMAT, TRACKING_EVENTS,
                              TrackingMapService, polylineService, timeUtils, fleetService, __env, ROUTE_STATUS_STARTED,
                              accountConfigsService, Idle, MapModel, ACCOUNT_CONFIGS, $window, VISIT_STATUS_CANCELED,
                              TRACKING_MAP_PROVIDER, ROUTE_STATUS_FINISHED, sessionService, RETOOL_WIDGET) {

    var vm = this;
    var $translate = $filter('translate');
    var trackingDate = $stateParams.trackingDate;
    var SIMPLI_GPS = 'simpli';

    //SLIDER
    var DEFAULT_TIME_SLIDER_MIN = '00:00';
    var DEFAULT_TIME_SLIDER_MAX = '23:59';

    var dateChanged = false;

    // MAP DATA
    vm.markersVehicles = {};
    vm.markers = {};
    vm.polylines = {};
    vm.allMarkerVisits = {};
    vm.driverPositions = [];
    vm.allDriverPositions = [];
    var mapBounds = {
      bounds: null
    };
    vm.mapProvider = null;
    vm.visitHoverIndicator = null;

    vm.driverActive = null;
    vm.vehicleActive = null;

    $rootScope.isLoading = true;
    $rootScope.trackingVehicles = [];
    $rootScope.trackingVehiclesColor = {};

    // Visits alerts
    vm.totalVisitsDone = 0;
    vm.totalVisitsSuccess = 0;
    vm.totalVisits = 0;
    vm.visitProgress = 0;
    vm.totalVisitsAlerts = 0;
    vm.routesStatus = {};
    vm.totalCustomAlerts = 0;
    vm.totalCheckoutFailedAlert = 0;
    vm.outOfWindowVisits = 0;

    vm.state = $state;
    vm.locations = {};
    vm.locationsArray = {};
    vm.loadingData = false;
    vm.interval = null;
    vm.$stateParams = $stateParams;
    vm.showDate = moment(trackingDate).format('LL');
    vm.date = moment(trackingDate);
    vm.mapInstance = null;

    vm.dateOptions = {
      formatYear: 'yyyy',
      formatDayHeader: 'EEE',
      formatDayTitle: 'MMMM',
      formatDay: 'd',
      showWeeks: false,
      startingDay: 0,
      minDate: timeUtils.minDateDataAvailavility()
    };
    vm.trackingDateFilterOpened = false;
    vm.popupOpened = false;
    vm.timeSlider = {
      min: DEFAULT_TIME_SLIDER_MIN,
      max: DEFAULT_TIME_SLIDER_MAX,
      options: {
        hideLimitLabels: true,
        pushRange: true,
        stepsArray: [{
            value: '00:00'
          },
          {
            value: '01:00'
          },
          {
            value: '02:00'
          },
          {
            value: '03:00'
          },
          {
            value: '04:00'
          },
          {
            value: '05:00'
          },
          {
            value: '06:00'
          },
          {
            value: '07:00'
          },
          {
            value: '08:00'
          },
          {
            value: '09:00'
          },
          {
            value: '10:00'
          },
          {
            value: '11:00'
          },
          {
            value: '12:00'
          },
          {
            value: '13:00'
          },
          {
            value: '14:00'
          },
          {
            value: '15:00'
          },
          {
            value: '16:00'
          },
          {
            value: '17:00'
          },
          {
            value: '18:00'
          },
          {
            value: '19:00'
          },
          {
            value: '20:00'
          },
          {
            value: '21:00'
          },
          {
            value: '22:00'
          },
          {
            value: '23:59'
          }
        ]
      }
    };

    vm.vehicles = [];
    vm.fleets = null;
    vm.fleetSelected = null;
    vm.previousFleetSelected = null;
    vm.enableFleetLogic = false;
    vm.multiDriversEnabled = false;
    vm.lastLocationVehicleOrDriver = [];
    vm.enableETALogic = false;
    vm.widgetRetool = null;

    vm.openListVehicleDriver = openListVehicleDriver;
    vm.applyFilters = applyFilters;
    vm.undoFilters = undoFilters;
    vm.isFilterActive = false;
    vm.refreshData = refreshData;
    vm.checkDateToRefresh = checkDateToRefresh;
    vm.loadLastVehiclesLocation = loadLastVehiclesLocation;
    vm.goToEvents = goToEvents;
    vm.goToDispatchs = goToDispatchs;
    vm.setTrackingDate = setTrackingDate;
    vm.calculateProgressPercentage = _calculateProgressPercentage;

    activate();

    $scope.$on(TRACKING_EVENTS.MAP.DRAW_VISITS, _drawVisitsOnMap);
    $scope.$on(TRACKING_EVENTS.MAP.DRAW_ROUTE_POLYLINE, _drawPolylineOnMap);
    $scope.$on(TRACKING_EVENTS.MAP.DRAW_ALL_VISITS, _drawAllVisitsOnMap);
    $scope.$on(TRACKING_EVENTS.MAP.CLEAR_MARKERS, _clearMarkers);
    $scope.$on(TRACKING_EVENTS.MAP.HIDE_MARKERS, _hideAllMarkers);
    $scope.$on(TRACKING_EVENTS.MAP.CLEAR_POLYLINES, _clearPolylines);
    $scope.$on(TRACKING_EVENTS.MAP.CLEAR_ALL_VISITS, _clearMapAllVisits);
    $rootScope.$on(TRACKING_EVENTS.MAP.FIT_BOUNDS_VEHICLES_LAST_POSITION, _fitBoundsVehiclesLastPosition);
    $scope.$on(TRACKING_EVENTS.MAP.CLEAR_VEHICLE_MARKERS, _clearVehicleMarkers);
    $scope.$on(TRACKING_EVENTS.MAP.FIT_BOUNDS_VISITS_MARKERS, _fitBoundsVisitsMarkers);
    $scope.$on('$stateChangeSuccess', _stateChangeSuccess);
    $scope.$on('$destroy', _stopTrackingController);
    $scope.$on(TRACKING_EVENTS.REFRESH.VEHICLE_SELECTED_CHANGE, _changeSelectedVehicle);
    $scope.$on(TRACKING_EVENTS.MAP.LOAD_VEHICLES_LAST_POSITION, loadLastVehiclesLocation);
    $scope.$on(TRACKING_EVENTS.MAP.UPDATE_FILTERED_VISIT_MARKERS, _updateFilteredVisitMarkers);
    $scope.$on(TRACKING_EVENTS.VISITS.CALL_VISIT_FILTER, _callFilterVisit);
    $scope.$on(TRACKING_EVENTS.MAP.SET_DEFAULT_TIME_FILTER, _setDefaultTimeFilter);
    $scope.$on(TRACKING_EVENTS.MAP.CALL_POLYLINES_FILTER, _callPolylinesFilter);
    $scope.$on(TRACKING_EVENTS.VEHICLES.RETURN_VEHICLE_DRIVER_ACTIVE, _filterVehiclesLastPosition);
    $scope.$on(TRACKING_EVENTS.VEHICLES.CLEAR_VEHICLE_DRIVER_ACTIVE, _clearVehicleDriverActive);

    $rootScope.$on('positionNavigator', function () {
      if (!$rootScope.mapInitCoord || !vm.mapInstance) {
        return;
      }

      vm.mapInstance.setCenter(parseFloat($rootScope.mapInitCoord.latitude), parseFloat($rootScope.mapInitCoord.longitude));
    });

    var elementResizedEvent = $scope.$on('elementResized', function () {
      if ($state.includes('tracking')) {
        $window.dispatchEvent(new Event('resize'));
      }
    });

    ///////////////////////////////////////////////////////

    function activate() {
      var promises = [];
      var vehiclesWithRoutes = [];
      var vehiclesWithRoutesByFleet = [];
      var date = $stateParams.trackingDate;

      $rootScope.trackingDate = date;
      $rootScope.isLoading = true;

      return _initializeMap()
        .then(function () {
          vm.multiDriversEnabled = accountConfigsService.isConfigEnabled('enable_multi_drivers');
          promises.push(planService.getAllVehicles()
            .then(function (vehicles) {
              vm.vehicles = vehicles;
            })
            .catch(function (error) {
              $log.error(error);
            })
          );

          promises.push(planService.getVehiclesWithRoutesByDate(date)
            .then(function (vehicles) {
              vehiclesWithRoutes = vehicles;
            })
            .catch(function (error) {
              $log.error(error);
            }));

            promises.push(sessionService.getUser()
            .then(function (user) {
              vm.widgetRetool = user.modules.find(function (module) {
                return module.label === RETOOL_WIDGET;
              });
            })
            .catch(function (error) {
              $log.error(error);
            }));

          if (accountConfigsService.isConfigEnabled('enable_fleets')) {
            promises.push(fleetService.getMyFleets().then(function (fleets) {
              vm.enableFleetLogic = true;
              if (fleets.length > 0) {
                vm.fleets = fleets;
                vm.fleetSelected = fleets[0];
                vm.previousFleetSelected = fleets[0];
                getGeneralProgress(date, false, vm.fleetSelected.id);
                return planService.getVehiclesWithRoutesByDateAndFleet(date, vm.fleetSelected.id)
                  .then(function (vehicles) {
                    vehiclesWithRoutesByFleet = vehicles;
                  });
              } else {
                vm.enableFleetLogic = false;
                getGeneralProgress(date, false);
              }
            }).catch(function (error) {
              $log.error(error);
            }));
          } else {
            vm.enableFleetLogic = false;
            getGeneralProgress(date, false);
          }

          vm.enableETALogic = isETAEnabled();
          promisesAreFinished(promises)
            .then(function () {
              var vehiclesToAdd = vm.enableFleetLogic ?
                vehiclesWithRoutesByFleet : vehiclesWithRoutes;
              _addVehicles(vehiclesToAdd);
              vm.checkDateToRefresh();
              $rootScope.isLoading = false;
              $scope.$broadcast(
                TRACKING_EVENTS.VEHICLES.VEHICLES_READY, {
                  date: date,
                  fleet: vm.fleetSelected ? vm.fleetSelected.id : null
                }
              );
            });
        });
    }

    function isETAEnabled() {
      return (
        accountConfigsService.getAccountConfigValue('update_eta_on_checkout') ||
        accountConfigsService.getAccountConfigValue('update_eta_on_start_route')
      );
    }

    function getGeneralProgress(date, checkProgress, fleetId) {
      $scope.$broadcast(TRACKING_EVENTS.FLEETS.READY);
      var promise = fleetId ? planService.getGeneralProgressByFleet(date, fleetId) :
        planService.getGeneralProgress(date);

      return promise.then(function (response) {
        var oldProgress = {
          totalVisitsSuccess: vm.totalVisitsSuccess,
          visitProgress: vm.visitProgress,
          totalVisits: vm.totalVisits,
          totalCustomAlerts: vm.totalCustomAlerts,
          totalCheckoutFailedAlert: vm.totalCheckoutFailedAlert,
          outOfWindowVisits: vm.outOfWindowVisits,
          routesStatus: vm.routesStatus
        };

        var newProgress;

        if (!fleetId) {
          // Fleets are not enabled
          newProgress = response.data.map(function (routeProgressObj) {
            return routeProgressObj.progress;
          });

          var initialProgress = {
            pending: 0,
            completed: 0,
            failed: 0,
            partial: 0,
            canceled: 0,
            total: 0,
            alerts: 0,
            out_of_window: 0,
            routesStatus: {}
          };

          var routesStatus = {};
          newProgress = newProgress.reduce(function (accumulatedProgress, routeProgress) {
            var aggregatedProgress = {};
            Object.keys(accumulatedProgress).forEach(function (statusKey) {
              aggregatedProgress[statusKey] = accumulatedProgress[statusKey] + routeProgress[statusKey];
            });
            for (var route in routeProgress.routes_status) {
              routesStatus[route] = routeProgress.routes_status[route];
            }
            return aggregatedProgress;
          }, initialProgress);
          newProgress.routesStatus = routesStatus;
        } else {
          // Fleets are enabled
          newProgress =  response.data;
          newProgress.routesStatus = newProgress.routes_status;
        }
        _updateProgress(newProgress);
        if (checkProgress) {
          checkProgressChange(oldProgress, date);
        }
      })
      .catch(function (error) {
        $log.error(error);
      });
    }

    function checkProgressChange(oldProgress, date) {
      var newProgress = {
        totalVisitsSuccess: vm.totalVisitsSuccess,
        visitProgress: vm.visitProgress,
        totalVisits: vm.totalVisits,
        totalCustomAlerts: vm.totalCustomAlerts,
        totalCheckoutFailedAlert: vm.totalCheckoutFailedAlert,
        outOfWindowVisits: vm.outOfWindowVisits,
        routesStatus: vm.routesStatus
      };

      if (_checkProgressChanged(oldProgress, newProgress)) {
        $scope.$broadcast(
          TRACKING_EVENTS.REFRESH.GENERAL_PROGRESS_CHANGED, {
            date: date,
            fleet: vm.fleetSelected ? vm.fleetSelected.id : null
          }
        );
      }
    }

    function setTrackingDate(newDate) {
      var dateString = timeUtils.formatTime(newDate, DATE_FORMAT);

      vm.showDate = timeUtils.formatTime(newDate, 'LL');

      if (dateString !== $stateParams.trackingDate) {
        dateChanged = true;
      } else {
        dateChanged = false;
      }
      vm.popupOpened = false;
    }

    function setStateParamsHoursFilter() {
      return {
        min: vm.timeSlider.min,
        max: vm.timeSlider.max
      };
    }


    function resetStateParamsFilters() {
      $stateParams.filters = null;
    }

    function setStateParamsFilters() {
      return {
        hourRange: setStateParamsHoursFilter(),
        selectedFleet: vm.fleetSelected
      };

    }

    function openListVehicleDriver(vehicle) {
      var params = {
        vehicleId: vehicle.id,
        driverId: vehicle.driver instanceof Object ? vehicle.driver.id : null
      };

      _initializeBounds();
      trackingService.selectVehicle(vehicle);
      $state.go('tracking.driver-dispatchs', params);
    }

    function startUpdateData() {
      return $interval(vm.refreshData, __env.TRACKING_REFRESH_TIME * 1000);
    }

    function _calculateProgressPercentage(progress) {
      var total = ((progress.completed + progress.failed + progress.partial) / progress.total) * 100;
      if (Math.ceil(total) === 100 && progress.completed + progress.failed + progress.partial < progress.total) {
        total = 99;
      } else {
        total = Math.ceil(total);
      }
      return progress.total ? total : 0;
    }

    function _initializeMap() {
      var trackingMapProvider = accountConfigsService.getConfigRawValue(ACCOUNT_CONFIGS.TRACKING_MAP_PROVIDER);
      vm.mapProvider = MapModel.getCurrentProviderName(trackingMapProvider, __env.DEFAULT_NAME_OF_TRACKING_MAP_PROVIDER);
      var htmlElementRef = document.getElementById('map');

      return MapModel.createInstance(trackingMapProvider, __env.DEFAULT_NAME_OF_TRACKING_MAP_PROVIDER, htmlElementRef)
        .then(function (map) {
          vm.mapInstance = map;
        });
    }

    function refreshData() {
      // Reset Idle timeout if tracking data is being refreshed
      Idle.watch();

      var date = $stateParams.trackingDate;
      planService.getAllVehicles()
        .then(function (vehicles) {
          vm.vehicles = vehicles;
          loadLastVehiclesLocation(null, {
            date: date,
            fitboundsFlag: false
          })
          .then(function () {
            if ($state.params.vehicleId && $state.params.driverId) {
              _clearPolylines();
              $scope.$broadcast(TRACKING_EVENTS.REFRESH.POLYLINES);
            }
          });
        });

      getGeneralProgress(date, true, (vm.fleetSelected && vm.fleetSelected.id));
    }

    function _deactivateInterval() {
      $interval.cancel(vm.interval);
    }

    function _stopTrackingController() {
      _deactivateInterval();
      _clearMapTrackingController();
      _clearPolylines();
      elementResizedEvent();
      vm.markersVehicles = {};
      $rootScope.trackingVehicles = null;
      if (!$state.includes('tracking') && vm.mapInstance) {
        vm.mapInstance.destroy();
      }
    }

    function _checkProgressChanged(oldProgress, newProgress) {
      var routesStatusChanged = false;
      var oldRoutesStatus = oldProgress.routesStatus;
      var newRoutesStatus = newProgress.routesStatus;
      var oldRoutes = Object.keys(oldProgress.routesStatus).sort();
      var newRoutes = Object.keys(newProgress.routesStatus).sort();
      if (JSON.stringify(oldRoutes) === JSON.stringify(newRoutes)) {
        for (var route in oldRoutesStatus) {

          if (oldRoutesStatus[route] !== newRoutesStatus[route]) {
            routesStatusChanged = true;
            break;
          }
        }
      } else {
        routesStatusChanged = true;
      }
      var result = (
        oldProgress.totalVisitsSuccess !== newProgress.totalVisitsSuccess ||
        oldProgress.visitProgress !== newProgress.visitProgress ||
        oldProgress.totalVisits !== newProgress.totalVisits ||
        oldProgress.totalCustomAlerts !== newProgress.totalCustomAlerts ||
        oldProgress.totalCheckoutFailedAlert !== newProgress.totalCheckoutFailedAlert ||
        oldProgress.outOfWindowVisits !== newProgress.outOfWindowVisits ||
        routesStatusChanged
      );
      return result;
    }


    function _drawVisitsOnMap(event, visits, fitboundsFlag, routesData) {
      if (!vm.mapInstance) {
        $log.error('Map could\'t be instantiate');
        return;
      }
      if (!visits.length) {
        return;
      }

      fitboundsFlag = angular.isUndefined(fitboundsFlag) || fitboundsFlag;
      routesData = routesData || {};

      visits.forEach(function (visit) {
        var visitId = visit.id.toString();
        if (vm.markers[visitId]) {
          TrackingMapService.updateMarker(vm.markers[visitId], visit);
        } else {
          var markerConfig = {
            visit: visit,
            visitRoute: routesData[visit.route_id] || {},
            isHoverIndicator: false
          };
          var markerOptions = getLabeledVisitMarkerOptions(markerConfig);
          var marker = vm.mapInstance.makeMarker(markerOptions);

          var eventData = {
            dispatchsId: visit.id
          };
          if (visit.joinedVisits) {
            eventData.fatherVisit = visit;
            eventData.subVisitPosition = 0;
          }

          marker.setEvent('click', function () {
            $state.go('tracking.vehicles.driver-dispatchs.detail',
              eventData,
              { notify: false }
            );
          });

          marker.setEvent('mouseover', function () {
            markerConfig.isHoverIndicator = true;
            var indicatorOptions = getLabeledVisitMarkerOptions(markerConfig);
            vm.visitHoverIndicator = vm.mapInstance.makeMarker(indicatorOptions);
          });
          marker.setEvent('mouseout', function () {
            vm.visitHoverIndicator.destroy();
            vm.visitHoverIndicator = null;
          });

          vm.markers[visitId] = marker;
        }
      });

      if (fitboundsFlag) {
        _initializeBounds();
        TrackingMapService.fitBoundsToMarkers(vm.mapInstance, mapBounds, vm.markers);
      }
    }

    function getLabeledVisitMarkerOptions(markerConfig) {
      var visit = markerConfig.visit;
      var visitRoute = markerConfig.visitRoute;
      var isHoverIndicator = markerConfig.isHoverIndicator;

      var hasOnlyCheckinTime = _doesVisitOnlyHaveCheckinTime(visit);
      var isInCurrentRoute = (visitRoute.status === ROUTE_STATUS_STARTED);

      var markerOptions = TrackingMapService.getVisitMarkerOptions(visit, hasOnlyCheckinTime, isInCurrentRoute,
        isHoverIndicator);
      markerOptions.icon.labelContent = _getVisitMarkerLabelContent(visit, isHoverIndicator, visitRoute.position);
      markerOptions.icon.labelX = _getVisitMarkerLabelX(hasOnlyCheckinTime, isInCurrentRoute, isHoverIndicator);
      markerOptions.icon.labelY = _getVisitMarkerLabelY(hasOnlyCheckinTime, isInCurrentRoute, isHoverIndicator);

      return markerOptions;
    }

    function _doesVisitOnlyHaveCheckinTime(visit) {
      return (visit.checkin_time !== null && visit.checkout_time === null);
    }

    function _getVisitMarkerLabelContent(visit, isHoverIndicator, visitRoutePosition) {
      if (isHoverIndicator) {
        return $translate('Tracking.route') + ' ' + visitRoutePosition;
      }
      return (visit.status === VISIT_STATUS_CANCELED) ? 'X' : visit.order;
    }

    function _getVisitMarkerLabelX(hasOnlyCheckinTime, isInCurrentRoute, isHoverIndicator) {
      if (isHoverIndicator) {
        return '64%';
      }
      if (!isInCurrentRoute) {
        return '48%';
      }
      return hasOnlyCheckinTime ? '13' : '50%';
    }

    function _getVisitMarkerLabelY(hasOnlyCheckinTime, isInCurrentRoute, isHoverIndicator) {
      if (isHoverIndicator) {
        return isInCurrentRoute ? '28pt' : '26pt';
      }
      if (!isInCurrentRoute) {
        return '12pt';
      }
      return hasOnlyCheckinTime ? '17pt' : '14pt';
    }

    function _drawVehiclesOnMap(data, fitboundsFlag) {
      if (!vm.mapInstance) {
        return;
      }

      fitboundsFlag = angular.isUndefined(fitboundsFlag) || fitboundsFlag;
      Object.values(data).forEach(function (vehicleOptions, index) {
        if (vehicleOptions.marker) {
          vehicleOptions.marker.setPosition(parseFloat(vehicleOptions.latitude), parseFloat(vehicleOptions.longitude));
        } else {
          var marker = vm.mapInstance.makeMarker(TrackingMapService.getVehicleMarkerOptions(vehicleOptions, index));
          if (!vm.multiDriversEnabled) {
            marker.setEvent('click', function () {
              $rootScope.$broadcast(TRACKING_EVENTS.VEHICLES.SCROLL_TO_VEHICLE, vehicleOptions.vehicleId + "-" + (vehicleOptions.driverId || "") + "-" + vehicleOptions.color);
              $state.go('tracking.vehicles.driver-dispatchs', {
                vehicleId: vehicleOptions.vehicleId,
                driverId: vehicleOptions.driverId
              });
            });
          }

          vehicleOptions.marker = marker;
        }
      });

      if (fitboundsFlag) {
        TrackingMapService.fitBoundsToVehicleMarkers(vm.mapInstance, mapBounds, data);
      }
    }

    function _getFinishedRoutes(routes) {
      return Object.values(routes).filter(function (route) {
        return route.status === ROUTE_STATUS_FINISHED;
      });
    }

    function _getLastRoute(finishedRoutes) {
      if (!finishedRoutes.length) {
        return;
      }

      finishedRoutes.sort(function(a, b) {
          return new Date(b.endTime) - new Date(a.endTime);
      });

      return finishedRoutes[0];
    }

    function _isLocationBeforeLastRoute(locationTimestamp, lastRouteEndTime) {
      return moment(locationTimestamp).isBefore(moment(lastRouteEndTime));
    }

    function _createPolyline(isPolylineOfCurrentRoute, polyline, vehicle, polylineInstances) {
      var map = vm.mapInstance;
      var driverName = vehicle.driver ? vehicle.driver.name : $translate('Driver.driver');
      var polylineOptions = TrackingMapService.getPolylineOptions(polyline, vehicle.color);
      var polylineInstance = map.makePolyline(polylineOptions, isPolylineOfCurrentRoute);
      if (polylineInstance) {
        polylineInstance.setPopup(function (event) {
          var eventPosition = map.getEventPosition(event);
          return TrackingMapService.getPolylineContent(map, polyline, eventPosition, driverName);
        });
        polylineInstances.push(polylineInstance);
      }
    }

    /**
     * Creates instances of polylines
     *
     * @param {Array} polylines - Array of polylines, where each polyline is a series of location points.
     * @param {Object} vehicle - Object representing the vehicle associated with the polylines.
     * @param {Object} routesData - Object containing data about the routes.
     * @returns {Array} polylineInstances - Array of created polyline instances.
     */
    function _getPolylineInstances(polylines, vehicle, routesData) {
      var polylineInstances = [];
      var finishedRoutes = _getFinishedRoutes(routesData);
      var areAllRoutesFinished = finishedRoutes.length === Object.keys(routesData).length;
      var isDrawingCurrentPolyline = !finishedRoutes.length;
      var lastRouteEndTime = _getLastRoute(finishedRoutes);

      polylines.forEach(function (polyline) {
        if (areAllRoutesFinished || isDrawingCurrentPolyline) {
          _createPolyline(isDrawingCurrentPolyline, polyline, vehicle, polylineInstances);
        }
        else {
          var polylineLength = polyline.length;
          var finishedRouteLocations = [];
          if(_isLocationBeforeLastRoute(polyline[polylineLength - 1].timestamp, lastRouteEndTime.endTime)) {
            // If the last point of the polyline is before the end time of the last route,
            // it means that the polyline belongs to the finished route.
            _createPolyline(false, polyline, vehicle, polylineInstances);
            return;
          }
          // Processes the polyline and creates polyline instances as needed.
          for (var index = 0; index < polylineLength; index++) {
            var location = polyline[index];
            if (_isLocationBeforeLastRoute(location.timestamp, lastRouteEndTime.endTime)) {
              finishedRouteLocations.push(location);
            } else {
              _createPolyline(isDrawingCurrentPolyline, finishedRouteLocations, vehicle, polylineInstances);
              // Create a polyline with the rest of the current polyline
              var remainingPolyline = polyline.slice(index);
              isDrawingCurrentPolyline = true;
              _createPolyline(isDrawingCurrentPolyline, remainingPolyline, vehicle, polylineInstances);
              break;
            }
          }
        }
      });

      return polylineInstances;
    }

    function _drawPolylineOnMap(event, vehicle, driver, fitboundsFlag, routesData) {
      var date = $stateParams.trackingDate;
      var driverId = driver ? driver.id : null;
      var vehicleId = vehicle ? vehicle.id : null;
      var key = vehicleId + '-' + driverId;
      fitboundsFlag = fitboundsFlag === undefined || fitboundsFlag;
      trackingService.getLocationsByVehicleOrDriver(date, vehicleId, driverId)
        .then(function (response) {
          var polylinesArray;
          vm.allDriverPositions = response.data;
          if (_isFilterActive()) {
            vm.driverPositions = _filterLocationsByTime();
            polylinesArray = polylineService.calculatePolylines(vm.driverPositions);
          } else {
            polylinesArray = polylineService.calculatePolylines(vm.allDriverPositions);
          }

          if (!vm.polylines[key]) {
            var polylines = _getPolylineInstances(polylinesArray, vehicle, routesData);
            if (polylines.length > 0) {
              vm.polylines[key] = polylines;
            }
          }

          if (fitboundsFlag) {
            TrackingMapService.fitBoundsToPolylines(vm.mapInstance, mapBounds, vm.polylines);
          }
        })
        .catch(function (e) {
          $log.error(e);
        });
    }

    function _drawAllVisitsOnMap(event, visits, fitboundsFlag) {
      if (!vm.mapInstance || !visits || visits.length > 500) {
        $log.error('Map could\'t be instantiate');
        return;
      }

      fitboundsFlag = fitboundsFlag === undefined || fitboundsFlag;
      visits.forEach(function (visit) {
        var visitId = visit.id.toString();
        if (vm.allMarkerVisits[visitId]) {
          visit.visible = _shouldSetVisibleVisitOnMap(visit);
          TrackingMapService.updateMarker(vm.allMarkerVisits[visitId], visit);
        } else {
          var hasOnlyCheckinTime = visit.checkin_time !== null && visit.checkout_time === null;
          var marker = vm.mapInstance.makeMarker(TrackingMapService.getVisitMarkerOptions(visit, hasOnlyCheckinTime));
          marker.setEvent('click', function () {
            $state.go('tracking.all-dispatchs.detail', { dispatchsId: visit.id });
          });

          vm.allMarkerVisits[visitId] = marker;
        }
      });

      if (fitboundsFlag) {
        _initializeBounds();
        TrackingMapService.fitBoundsToMarkers(vm.mapInstance, mapBounds, vm.allMarkerVisits);
      }
    }

    function _clearMapTrackingController() {
      for (var key in vm.markersVehicles) {
        var marker = vm.markersVehicles[key].marker;
        if (marker) {
          marker.destroy();
        }

        delete vm.markersVehicles[key];
      }
    }

    function _stateChangeSuccess(event, toState, toParams, fromState, fromParams) {
      _showAllLastPositionVehicles(true);
    }

    function _showAllLastPositionVehicles(isVisible) {
      for (var key in vm.markersVehicles) {
        var marker = vm.markersVehicles[key].marker;
        if (marker) {
          marker.setVisible(isVisible);
        }
      }
    }

    function _clearMarkers() {
      for (var key in vm.markers) {
        vm.markers[key].destroy();
        delete vm.markers[key];
      }
    }

    function _clearMapAllVisits() {
      _initializeBounds();
      for (var key in vm.allMarkerVisits) {
        vm.allMarkerVisits[key].destroy();
        delete vm.allMarkerVisits[key];
      }
    }

    function _clearVehicleMarkers() {
      _initializeBounds();
      _clearMapTrackingController();
    }

    function _hideAllMarkers() {
      for (var key in vm.markers) {
        vm.markers[key].setVisible(false);
      }
    }

    function _clearPolylines(event) {
      for (var key in vm.polylines) {
        vm.polylines[key].forEach(function (polyline) {
          polyline.destroy();
        });

        delete vm.polylines[key];
      }
    }

    function _initializeBounds() {
      mapBounds = {
        bounds: null
      };
    }

    function _addmarkersVehicles(data) {
      // Si marker ya existe
      var id = (data.vehicleId) ? data.vehicleId : data.driverId;

      if (vm.markersVehicles[id]) {
        vm.markersVehicles[id].timeStamp = data.timeStamp;
        vm.markersVehicles[id].latitude = data.latitude;
        vm.markersVehicles[id].longitude = data.longitude;
      } else {
        vm.markersVehicles[id] = data;
      }
    }

    function _addVehicleWithGps(locationData, data) {
      planService.getVehicleById(locationData.id).then(function (vehicleData) {
        data.vehicleId = vehicleData.id;
        data.nameVehicle = vehicleData.name;
        data.color = vehicleData.color;
        _addmarkersVehicles(data);
      });
    }

    function _checkStateRoute() {
      var state = $state.current.name;
      if (state === 'tracking' || state === 'tracking.all-dispatchs') {
        _showAllLastPositionVehicles(true);
      } else if (state === 'tracking.driver-dispatchs') {
        var driverId = $state.params.driverId;
        var vehicleId = $state.params.vehicleId;

        for (var key in vm.markersVehicles) {
          if (vm.markersVehicles[key].marker) {
            if (String(key) === String(vehicleId) || String(key) === String(driverId)) {
              vm.markersVehicles[key].marker.setVisible(true);
            } else {
              vm.markersVehicles[key].marker.setVisible(false);
            }
          }
        }
      }
    }

    function _updateProgress(data) {
      vm.visitProgress = _calculateProgressPercentage(data);
      vm.totalVisitsAlerts = parseInt(data.alerts) + parseInt(data.failed);
      vm.totalCustomAlerts = data.alerts;
      vm.totalCheckoutFailedAlert = data.failed;
      vm.totalVisits = data.total;
      vm.totalVisitsSuccess = data.completed;
      vm.totalVisitsDone = data.completed + data.failed + data.partial;
      vm.outOfWindowVisits = data.out_of_window;
      vm.routesStatus = data.routesStatus;
    }

    function checkDateToRefresh() {
      if (!moment($stateParams.trackingDate).isSame(moment(), 'day')) {
        _deactivateInterval();
      } else {
        vm.interval = startUpdateData();
      }
    }

    function _changeSelectedVehicle(event, data) {
      $scope.$broadcast(TRACKING_EVENTS.REFRESH.CHANGE_VEHICLE_SELECTED, data);
    }

    function _drawVehiclesLastPosition(event, data) {
      var markers = data.markers;
      var fitboundsFlag = data.fitboundsFlag;
      markers.forEach(function (markerVehicle) {
        _addmarkersVehicles(markerVehicle);
        if (markerVehicle.withoutRoute) {
          var locationData = {
            timeStamp: markerVehicle.timestamp,
            latitude: markerVehicle.latitude,
            longitude: markerVehicle.longitude
          };
          _addVehicleWithGps(locationData, markerVehicle);
        }
      });

      _drawVehiclesOnMap(vm.markersVehicles, fitboundsFlag);
      if (!$state.includes('tracking.vehicles.driver-dispatchs')) {
        _showAllLastPositionVehicles(true);
      }

      _checkStateRoute();
      _filterVehiclesLastPosition(TRACKING_EVENTS.VEHICLES.RETURN_VEHICLE_DRIVER_ACTIVE, {});
    }

    function _fitBoundsVisitsMarkers(event, visits) {
      var markers = [];
      visits.forEach(function (visit) {
        if (vm.allMarkerVisits[visit.id]) {
          markers.push(vm.allMarkerVisits[visit.id]);
        }
      });

      _initializeBounds();
      TrackingMapService.fitBoundsToMarkers(vm.mapInstance, mapBounds, markers);
    }

    function _fitBoundsVehiclesLastPosition() {
      _initializeBounds();
      TrackingMapService.fitBoundsToVehicleMarkers(vm.mapInstance, mapBounds, vm.markersVehicles);
    }

    function loadVehiclesOnFleet(fleetId, date) {
      return _loadVehicles(true, date, fleetId);
    }

    function _loadVehicles(usingFleets, date, fleetId) {
      usingFleets = !!usingFleets;
      date = date || $rootScope.trackingDate;

      var promise = !usingFleets ? planService.getVehiclesWithRoutesByDate(date) : planService.getVehiclesWithRoutesByDateAndFleet(date, fleetId);

      return promise
        .then(function successGetVehicles(vehicles) {
          _addVehicles(vehicles);
          $scope.$broadcast(TRACKING_EVENTS.VEHICLES.VEHICLES_READY, {
            date: date,
            fleet: fleetId
          });
        }, function errorGetVehicles(error) {
          $log.error(error);
        });
    }

    function _addVehicles(vehicles) {
      // If multidrivers is active we wont show fleet vehicles with no routes
      if (!$rootScope.trackingVehicles || vm.multiDriversEnabled) {
        $rootScope.trackingVehicles = [];
      }

      vehicles.forEach(function (vehicle) {
        if (vm.multiDriversEnabled) {
          var vehicleInstanceHasNoRoutes = false;
          for (var j = 0; j < $rootScope.trackingVehicles.length; j++) {
            if ($rootScope.trackingVehicles[j].id === vehicle.id) {
              // Different instances of the same vehicle should allways have the same color:
              $rootScope.trackingVehicles[j].color = vehicle.color;
              if (!vehicle.routes.length || !$rootScope.trackingVehicles[j].routes.length) {
                vehicleInstanceHasNoRoutes = true;
                lodash.merge($rootScope.trackingVehicles[j], vehicle);
                break;
              }
            }
          }

          if (!vehicleInstanceHasNoRoutes) {
            $rootScope.trackingVehicles.push(vehicle);
            $rootScope.trackingVehiclesColor[vehicle.id] = vehicle.color;
          }
        } else {
          var ifExist = false;
          for (var i = 0; i < $rootScope.trackingVehicles.length; i++) {
            if ($rootScope.trackingVehicles[i].id === vehicle.id) {
              lodash.merge($rootScope.trackingVehicles[i], vehicle);
              ifExist = true;
              break;
            }
          }

          if (!ifExist) {
            $rootScope.trackingVehicles.push(vehicle);
            $rootScope.trackingVehiclesColor[vehicle.id] = vehicle.color;
          }
        }
      });
    }

    function _addVehicle(vehicle) {
      if (!$rootScope.trackingVehicles) {
        $rootScope.trackingVehicles = [];
      }

      var ifExist = false;
      for (var i = 0; i < $rootScope.trackingVehicles.length; i++) {
        if ($rootScope.trackingVehicles[i].id === vehicle.id) {
          ifExist = true;
          break;
        }
      }

      if (!ifExist) {
        $rootScope.trackingVehicles.push(vehicle);
        $rootScope.trackingVehiclesColor[vehicle.id] = vehicle.color;
      }

    }

    function loadLastVehiclesLocation(event, data) {
      var fleetId = vm.fleetSelected ? vm.fleetSelected.id : null;
      return trackingService.getLastVehiclesLocation(data.date, {
        useFleets: vm.enableFleetLogic,
        fleetId: fleetId
      }).then(function (response) {
        var locations = response.data;
        trackingService.setLocationsGps(locations);
        var vehicleResolutionPromises = [];
        if (vm.vehicles) {
          locations.filter(function (location) {
            return location.type != 'simpli';
          }).forEach(function (location) {
            var vehicleData = vm.vehicles.filter(function (vehicle) {
              return vehicle.id == location.id;
            })[0];
            if (vehicleData) {
              vehicleData.active = true;
              _addVehicle(vehicleData);
            } else {
              vehicleResolutionPromises.push(planService.getVehicleById(location.id)
              .then(function (vehicleData) {
                _addVehicle(vehicleData);
              }));
            }
          });
        }

        var dataMarkers = [];
        return promisesAreFinished(vehicleResolutionPromises)
          .then(function () {
            locations.forEach(function (locationData) {
              var dataMarker = {
                driverId: null,
                vehicleId: null,
                nameVehicle: null,
                timeStamp: locationData.timestamp,
                latitude: locationData.latitude,
                longitude: locationData.longitude,
                color: null,
                marker: null,
                withoutRoute: true,
                type: locationData.type
              };

              for (var i = 0; i < $rootScope.trackingVehicles.length; i++) {
                var vehicle = $rootScope.trackingVehicles[i];

                var isVehicleLocation = vehicle.id === locationData.id;
                var isDriverLocation = vehicle.driver && vehicle.driver.id === locationData.id;
                var routeHasCheckouts = vehicle.progress > 0;
                var isLocationValid = locationData.latitude && locationData.longitude;

                if (
                  (Array.isArray(vehicle.routes) && vehicle.routes.length > 0) &&
                  (isVehicleLocation || isDriverLocation) &&
                  (routeHasCheckouts || isLocationValid)
                ) {

                  $rootScope.trackingVehicles[i].isActive = true;
                  dataMarker.nameVehicle = vehicle.name;
                  dataMarker.color = vehicle.color;

                  vehicle.gpsDataAge = ageOfDataSegmentationByRefreshTime(locationData.timestamp);
                  if (typeof vehicle.gpsDataAge !== 'undefined') {
                    vehicle.gpsTranslation = $translate('Vehicle.gps-ready-status-' + vehicle.gpsDataAge);
                  }

                  dataMarker.vehicleId = vehicle.id;

                  if (vehicle.driver) {
                    dataMarker.driverId = vehicle.driver.id;
                  }

                  var existingDataMarker = getDataMarker(vehicle, dataMarker, dataMarkers);

                  if (existingDataMarker.length > 0 &&
                    (locationData.type === existingDataMarker.type ||
                      (locationData.type !== existingDataMarker.type && locationData.type !== SIMPLI_GPS)) ||
                    (existingDataMarker.length === 0)) {
                      dataMarker.withoutRoute = false;
                      dataMarkers.push(dataMarker);
                      vm.lastLocationVehicleOrDriver.push(dataMarker);
                  }
                }

                if (vehicle.gpsDataAge === null) {
                  vehicle.gpsTranslation = $translate('Vehicle.gps-ready-status-');
                }
              }
            });
            if ($stateParams.filters) {
              setTimeSlider($stateParams.filters.hourRange);
              setSelectedFleet($stateParams.filters.selectedFleet);
              resetStateParamsFilters();
              applyTimeFilter();
              applyFleetFilter();
            }
          })
          .finally(function () {
            _drawVehiclesLastPosition(TRACKING_EVENTS.MAP.DRAW_VEHICLES_LAST_POSITION, {
              markers: dataMarkers,
              fitboundsFlag: data.fitboundsFlag
            });
          });
      });
    }

    function _updateFilteredVisitMarkers(event, data) {
      var visitFilteredMarkers = data.visitIds.map(function (visitId) {
        return String(visitId);
      });

      var markers = Object.keys(vm.markers).length > 0 ? vm.markers : vm.allMarkerVisits;
      for (var key in markers) {
        markers[key].setVisible(visitFilteredMarkers.indexOf(key) !== -1);
      }
    }

    function _filterLocationsByTime() {
      var startTime = moment(vm.timeSlider.min, "HH:mm");
      var endTime = moment(vm.timeSlider.max, "HH:mm");
      return lodash.filter(vm.allDriverPositions, function (location) {
        var timestamp = moment(location.timestamp).format("HH:mm");
        var locationTime = moment(timestamp, "HH:mm");
        return locationTime.isBetween(startTime, endTime, null, '[]');
      });
    }

    function setTimeSlider(hourRange) {
      vm.timeSlider.min = hourRange.min;
      vm.timeSlider.max = hourRange.max;
    }

    function setSelectedFleet(fleetFromStateParams) {
      vm.fleetSelected = fleetFromStateParams;
    }

    function applyTimeFilter() {
      var data = {
        startDate: vm.timeSlider.min,
        endDate: vm.timeSlider.max
      };

      $scope.$broadcast(TRACKING_EVENTS.VISITS.FILTER_VISIT_MARKERS_BY_TIME, data);
      $scope.$broadcast(TRACKING_EVENTS.MAP.FILTER_POLYLINES_BY_TIME, data);
      $scope.$broadcast(TRACKING_EVENTS.VEHICLES.GET_VEHICLE_DRIVER_ACTIVE);
    }

    function applyFleetFilter() {
      if (!vm.enableFleetLogic) {
        return;
      }

      var date = $stateParams.trackingDate;
      if (vm.previousFleetSelected && vm.fleetSelected.id !== vm.previousFleetSelected.id) {
        changeLastVehiclesLocations();
        getGeneralProgress(date, true, (vm.fleetSelected && vm.fleetSelected.id));
      }

      filterByFleet(date);
      vm.previousFleetSelected = angular.copy(vm.fleetSelected);
    }

    function applyFilters() {
      if (dateChanged) {
        var dateString = timeUtils.formatTime(vm.date, DATE_FORMAT);
        $rootScope.trackingDate = dateString;
        $stateParams.trackingDate = dateString;
        $stateParams.filters = setStateParamsFilters();
        vm.mapInstance.destroy();
        $state.go('tracking', $stateParams);
      } else {
        applyTimeFilter();
        applyFleetFilter();
        vm.isFilterActive = true;
        vm.trackingDateFilterOpened = false;
      }
    }

    function resetFilterDate() {
      var longDate = timeUtils.formatTime($stateParams.trackingDate, 'LL');
      vm.date = timeUtils.createTime($stateParams.trackingDate, DATE_FORMAT);
      vm.showDate = longDate;
    }

    function undoFilters() {
      vm.timeSlider.min = DEFAULT_TIME_SLIDER_MIN;
      vm.timeSlider.max = DEFAULT_TIME_SLIDER_MAX;
      var data = {
        startDate: vm.timeSlider.min,
        endDate: vm.timeSlider.max
      };
      $scope.$broadcast(TRACKING_EVENTS.VISITS.FILTER_VISIT_MARKERS_BY_TIME, data);
      $scope.$broadcast(TRACKING_EVENTS.MAP.FILTER_POLYLINES_BY_TIME);
      _showAllLastPositionFilteredVehicles();
      vm.isFilterActive = false;
      vm.trackingDateFilterOpened = false;
      resetFilterDate();

      if (vm.fleetSelected instanceof Object && vm.previousFleetSelected instanceof Object) {
        angular.extend(vm.fleetSelected, vm.previousFleetSelected);
      }
    }

    function _filterPolylines(vehicle, key, routesData) {
      var polylinesArray;
      if (_isFilterActive()) {
        vm.driverPositions = _filterLocationsByTime();
        polylinesArray = polylineService.calculatePolylines(vm.driverPositions);
      } else {
        polylinesArray = polylineService.calculatePolylines(vm.allDriverPositions);
      }

      _clearPolylines();
      var polylines = _getPolylineInstances(polylinesArray, vehicle, routesData);
      if (polylines.length > 0) {
        vm.polylines[key] = polylines;
      }
    }

    function _isFilterActive() {
      return (vm.timeSlider.min !== DEFAULT_TIME_SLIDER_MIN || vm.timeSlider.max !== DEFAULT_TIME_SLIDER_MAX);
    }

    function _callFilterVisit() {
      if (vm.timeSlider.min === DEFAULT_TIME_SLIDER_MIN && vm.timeSlider.max === DEFAULT_TIME_SLIDER_MAX) {
        return;
      }

      var data = {
        startDate: vm.timeSlider.min,
        endDate: vm.timeSlider.max
      };

      $scope.$broadcast(TRACKING_EVENTS.VISITS.FILTER_VISIT_MARKERS_BY_TIME, data);
    }

    function _shouldSetVisibleVisitOnMap(visit) {
      var momentStartTime = moment(vm.timeSlider.min, "HH:mm");
      var momentEndTime = moment(vm.timeSlider.max, "HH:mm");
      var estimatedTimeArrival = moment(visit.estimated_time_arrival, "HH:mm");
      return estimatedTimeArrival.isBetween(momentStartTime, momentEndTime, null, '[]');
    }

    function _setDefaultTimeFilter() {
      vm.timeSlider.min = DEFAULT_TIME_SLIDER_MIN;
      vm.timeSlider.max = DEFAULT_TIME_SLIDER_MAX;
      vm.trackingDateFilterOpened = false;
      vm.isFilterActive = false;
    }

    function _callPolylinesFilter(event, vehicle, driver, routesData) {
      var driverId = driver ? driver.id : null;
      var vehicleId = vehicle ? vehicle.id : null;
      var key = vehicleId + '-' + driverId;
      _filterPolylines(vehicle, key, routesData);
    }

    function _filterVehiclesLastPosition(event, data) {
      var filteredVehiclesLastPosition = trackingService.filterVehicleLastPosition(
        vm.lastLocationVehicleOrDriver,
        vm.timeSlider.min,
        vm.timeSlider.max
      );

      if (data && (data.vehicleId || data.driverId)) {
        vm.driverActive = parseInt(data.driverId);
        vm.vehicleActive = parseInt(data.vehicleId);
        vm.viewVehicleActive = true;
      }

      _showAllLastPositionVehicles(false);
      filteredVehiclesLastPosition.forEach(function (vehicle) {
        if (vm.markersVehicles[vehicle.vehicle] && vm.markersVehicles[vehicle.vehicle].marker && vehicle.vehicle === vm.vehicleActive) {
          vm.markersVehicles[vehicle.vehicle].marker.setVisible(true);
        } else if (vm.markersVehicles[vehicle.vehicle] && vm.markersVehicles[vehicle.vehicle].marker && !vm.vehicleActive) {
          vm.markersVehicles[vehicle.vehicle].marker.setVisible(true);
        }
      });
    }

    function _showAllLastPositionFilteredVehicles() {
      var driver = parseInt(vm.driverActive);
      var vehicle = parseInt(vm.vehicleActive);

      if (vm.markersVehicles[vehicle]) {
        vm.markersVehicles[vehicle].marker.setVisible(true);
      } else if (vm.markersVehicles[driver]) {
        vm.markersVehicles[driver].marker.setVisible(true);
      } else {
        _showAllLastPositionVehicles(true);
      }
    }

    function _clearVehicleDriverActive() {
      vm.driverActive = null;
      vm.vehicleActive = null;
      vm.viewVehicleActive = null;
    }

    function normalize_timezone(time){
      var hasTimeZone = time.includes("Z") || time.includes("GMT") || time.includes("UTC");
      return hasTimeZone ? time : time + "Z";
    }

    function ageOfDataSegmentationByRefreshTime(time) {
      if (time === null || time === undefined){
        return "";
      }
      var update_period = __env.TRACKING_REFRESH_TIME * 1000;
      var given_date = new Date(normalize_timezone(time));
      var age = Date.now() - given_date;
      var result = parseInt(age / update_period, 10);

      return result < 2 ? result : 2;
    }

    function getDataMarker(vehicle, dataMarker, dataMarkers) {
      // get element of data markers if exist
      var existingDataMarker = [];
      if (dataMarker.driverId) {
        existingDataMarker = dataMarkers.filter(function (el) {
          return el.vehicleId === vehicle.id &&
            el.driverId === vehicle.driver.id;
        });
      } else {
        existingDataMarker = dataMarkers.filter(function (el) {
          return el.vehicleId === vehicle.id;
        });
      }

      return existingDataMarker;
    }

    function filterByFleet(date) {
      planService.getVehiclesWithRoutesByDateAndFleet(date, vm.fleetSelected.id)
        .then(function (vehicles) {
          $rootScope.trackingVehicles = fleetService.getVehiclesListByFleet(
            vehicles,
            vm.fleetSelected
          );
          loadVehiclesOnFleet(vm.fleetSelected.id);
        });
    }

    function changeLastVehiclesLocations() {
      _clearMapTrackingController();
      vm.lastLocationVehicleOrDriver = [];
      vm.loadLastVehiclesLocation(null, {
        date: $stateParams.trackingDate,
        fitboundsFlag: false
      });
    }

    function promisesAreFinished(srcPromises) {
      var promises = [
        $q.resolve()
      ];

      srcPromises.forEach(function (promise) {
        var deferred = $q.defer();
        promise.then(function () {
          deferred.resolve();
        }).catch(function () {
          deferred.resolve();
        });

        promises.push(deferred.promise);
      });

      return $q.all(promises);
    }

    function goToEvents() {
      $state.go('tracking.events', {
        fromTracking: true
      });
    }

    function goToDispatchs() {
      $state.go('tracking.all-dispatchs', {
        fromTracking: true
      });
    }
  }
})();

/**
 * Created by rodrigo on 07-02-17.
 */
(function() {
  'use strict';

  angular
    .module('icarus')
    .constant('TRACKING_EVENTS', {
      'MAP': {
        'DRAW_VISITS': 'draw:visits',
        'DRAW_ALL_VISITS': 'draw:all-visits',
        'DRAW_VEHICLES': 'draw:vehicles',
        'DRAW_VEHICLES_LAST_POSITION': 'draw:vehicles:last-position',
        'DRAW_ROUTE_POLYLINE': 'draw:route-polyline',
        'CLEAR_VEHICLE_MARKERS' : 'erase:vehicles',
        'UPDATE_SHOW_MARKERS': 'update-show:markers',
        'HIDE_MARKERS': 'hide:markers',
        'CLEAR_MARKERS': 'erase:markers',
        'CLEAR_ALL_VISITS': 'erase:all-visits',
        'CLEAR_POLYLINES': 'erase:polylines',
        'CLEAR_ALL': 'erase:map',
        'FIT_BOUNDS_VISITS_MARKERS': 'fitbounds:visits-markers',
        'FIT_BOUNDS_VEHICLES_LAST_POSITION': 'fitbounds:vehicle-last-position',
        'LOAD_VEHICLES_LAST_POSITION': 'draw:load-vehicles-last-position',
        'UPDATE_FILTERED_VISIT_MARKERS': 'draw:update-filtered-visit-markers',
        'SET_DEFAULT_TIME_FILTER': 'draw:set-default-time-filter',
        'FILTER_POLYLINES_BY_TIME': 'draw:filter-polylines-by-time',
        'CALL_POLYLINES_FILTER': 'draw:call-polylines-filter'
      },
      'VEHICLES' : {
        'LOAD_VEHICLES_LAST_LOCATION': 'vehicles:load-last-location',
        'LOAD_ALL_VEHICLES': 'vehicles:load-all-vehicles',
        'VEHICLES_READY': 'vehicles:vehicles-ready',
        'GET_VEHICLE_DRIVER_ACTIVE': 'vehicles-driver-view-active',
        'RETURN_VEHICLE_DRIVER_ACTIVE': 'return-vehicles-driver-view-active',
        'CLEAR_VEHICLE_DRIVER_ACTIVE': 'vehicles:clear-vehicle-driver-active',
        'SCROLL_TO_VEHICLE': 'vehicles:scroll-to-vehicle'
      },
      'REFRESH': {
        'DATE_CHANGED': 'refresh:dateChanged',
        'GENERAL_PROGRESS_CHANGED': 'refresh:general-progress-changed',
        'VEHICLE_SELECTED_CHANGE': 'refresh:vehicle-selected-changed',
        'CHANGE_VEHICLE_SELECTED': 'refresh:change-vehicle-selected',
        'DATE_CHANGED_REFRESH_VISITS': 'refresh:date-changed-refresh-visits',
        'FLEET_CHANGED': 'refresh:fleet-changed',
        'POLYLINES': 'refresh:polylines'
      },
      'READY': {
        'VEHICLES_MARKERS_CREATED': 'ready:vehicles-markers-created'
      },
      'VISITS' : {
        'FILTER_VISIT_MARKERS_BY_TIME' : 'visits:filter-visit-markers-by-time',
        'CALL_VISIT_FILTER': 'visit:call-visits-filter'
      },
      'FLEETS': {
        'READY': 'fleets:ready'
      }
    })
    .constant('TRACKING_CONSTANTS', {
      'FILTER_OPTIONS': {
        'NAME_ASC':'nameAsc',
        'NAME_DESC':'nameDesc',
        'PROGRESS_ASC': 'progressAsc',
        'PROGRESS_DESC': 'progressDesc',
        'ROUTE_ASC': 'startTimeAsc',
        'ROUTE_DESC': 'startTimeDesc',
      }
    })
    .constant('ROUTE_STATUS_STARTED', 'started')
    .constant('ROUTE_STATUS_FINISHED', 'finished')
    .constant('TRACKING_IMAGES_FOLDER_PATH', '/assets/images/tracking/')
    .constant('TRACKING_VISIT_MARKER_SIZE_IDENTIFIER', {
      LARGE: 'large',
      SMALL: 'small'
    })
    .constant('TRACKING_MAP_PROVIDER', {
      GOOGLE: 'google',
      HERE: 'here'
    })
    .constant('RETOOL_WIDGET', 'retoolWidget');
})();

(function() {
  "use strict";

  angular
    .module("icarus.simpliPlanner", []);

})();

(function() {
  "use strict";

  angular
    .module("icarus.simpliPlanner")
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    var CURRENT_MODULE = "simpliPlanner";

    $stateProvider
      .state("simpliPlanner", {
        parent: "main",
        url:  "/simpliPlanner",
        controller: "SimpliPlannerController",
        controllerAs: "vm",
        templateUrl: "app/simpliPlanner/simpliPlanner.html",
        data:{
          authentication:  true
        },
        params: {
          url: null,
          user: null
        },
        resolve: {
          shareState: function ($stateParams, $q, sessionService) {
            var shareStatePromise = $q.defer();
            var shareState = {
              url: $stateParams.url || null,
              user: $stateParams.user || null
            };

            if (shareState.url && shareState.user) {
              shareStatePromise.resolve(shareState);
              return shareStatePromise.promise;
            }

            sessionService.getUser()
              .then(function (user) {
                var foundModule = user.modules.find(function (module) {
                  return module.label === CURRENT_MODULE;
                });

                shareState.url = foundModule ? foundModule.url : null;
                shareState.user = user;
                shareStatePromise.resolve(shareState);
              });

            return shareStatePromise.promise;
          }
        }
      });
  }

})();

(function () {
  "use strict";

  angular
    .module("icarus.simpliPlanner")
    .controller("SimpliPlannerController", SimpliPlannerController);

  /** @ngInject */
  function SimpliPlannerController(shareState, requestService, __env) {
    var vm = this;

    vm.url = null;

    active();

    function active() {
      vm.url = _getSimpliPlannerUrl(shareState.url, shareState.user);
    }

    function _getSimpliPlannerUrl(url, user) {
      var queryParams = {
        id: user.account.stripe_customer_id.replace("cus_", ""),
        key: user.api_token,
        env: __env.TERRITORY_PLANNER_ENV
      };
      return [url, requestService.convertOptionsToQueryParams(queryParams)].join("#");
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('XslxService', XlsxService);

    /* @ngInject */
    function XlsxService($q) {
      return {
        sheetFromMatrix: sheetFromMatrix,
        write: write
      };

      function sheetFromMatrix (data) {
        // Reference: http://sheetjs.com/demos/writexlsx.html
        var ws = {};
        var range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
        for(var R = 0; R !== data.length; ++R) {
          for(var C = 0; C !== data[R].length; ++C) {
            if(range.s.r > R) {range.s.r = R;}
            if(range.s.c > C) {range.s.c = C;}
            if(range.e.r < R) {range.e.r = R;}
            if(range.e.c < C) {range.e.c = C;}
            var cell = {v: data[R][C] };
            if(cell.v === null) {continue;}
            var cell_ref = XLSX.utils.encode_cell({c:C,r:R});

            if(angular.isNumber(cell.v)) {
                cell.t = 'n';
            }
            else if(typeof cell.v === 'boolean') {cell.t = 'b';}
            else if(cell.v instanceof Date) {
              cell.t = 'n'; cell.z = XLSX.SSF._table[14];
              cell.v = datenum(cell.v);
            }
            else {cell.t = 's';}

            ws[cell_ref] = cell;
          }
        }
        if(range.s.c < 10000000) {ws['!ref'] = XLSX.utils.encode_range(range);}
        return ws;

        function datenum(v, date1904) {
          if(date1904) {v+=1462;}
          var epoch = Date.parse(v);
          return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
        }
      }

      function write (workbook, filename) {
        // Reference: http://sheetjs.com/demos/writexlsx.html
        var wopts = { bookType:'xlsx', bookSST:false, type:'binary' };
        var wbout = XLSX.write(workbook, wopts);
        /* the saveAs call downloads a file on the local machine */
        return $q.when(saveAs(new Blob([s2ab(wbout)],{type:''}), filename+'.xlsx'));

        function s2ab(s) {
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);
          for (var i=0; i !== s.length; ++i) {
            view[i] = s.charCodeAt(i) & 0xFF;
          }
          return buf;
        }
      }
    }
})();

(function() {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('webEventService', webEventService);

  /* @ngInject */
  function webEventService($http, __env) {
    return {
      post: post
    };

    function post(originModule, eventType, identifier, extraData) {
      var payload = {
        timestamp: new Date().toISOString(),
        id: identifier,
        event_name: eventType,
        page_url: originModule,
        origin: "icarus_web"
      };
      if (extraData) {
        angular.extend(payload, extraData);
      }
      $http.post(__env.API_URL + 'events/web/', payload).then();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.shared')
    .filter('translateTo', translateTo);

  /** @ngInject */
  function translateTo($filter) {
    return function(input, language) {
      return $filter("translate")(input, {}, undefined, language);
    };
  }
})();
/*
Ejemplo de uso del filtro:
{{ng-repeat="d in data | startFrom:currentPage*pageSize }}
*/

(function() {
  'use strict';

  angular
  .module('icarus.shared')
  .filter('startFrom', startFrom);

  /** @ngInject */
  function startFrom () {
    return function(input, start) {
        start = +start;
        return input.slice(start);
    };
  }

})();

(function() {
  angular
    .module('icarus.shared')
    .directive('spSwitch', spSwitch);




  /* @ngInject */
  function spSwitch($compile) {
    return {
      restrict: 'E',
      scope: false,
      template: '<label class="sp-switch">'+
                '<input type="checkbox">'+
                '<div class="slider">'+
                '<div class="on">on</div>'+
                '<div class="off">off</div>'+
                '</div>'+
                '</label>',
      link: postLinkFunction
    };

    function postLinkFunction(scope, element, attrs) {
      var input = element.find('input');
      var allowedAttrs = ['ngModel', 'ngChange', 'ngTrueValue', 'ngFalseValue'];
      var attrKeys = {
        'ngModel': 'ng-model',
        'ngChange': 'ng-change',
        'ngTrueValue': 'ng-true-value',
        'ngFalseValue': 'ng-false-value'
      };

      for(var k in attrs) {
        if (attrs.hasOwnProperty(k) && allowedAttrs.indexOf(k) !== -1) {
          input.attr(attrKeys[k], attrs[k]);
        }
      }

      $compile(input)(scope);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('sortDriversByDocStatusService', sortDriversByDocStatusService);

  /** @ngInject */
  function sortDriversByDocStatusService(naturalService) {
    return {
      sort: sort
    };

    /**
     * Sorts users by documentation status:
     * 1. Users with enabled documents first (A-Z)
     * 2. Users with expired documents at the end (A-Z)
     *
     * @param {Array} items - Array of users to sort
     * @param {string} nameField - Field to sort by (default: 'name')
     * @returns {Array} Sorted array
     */
    function sort(items, nameField) {
      if (!items || !angular.isArray(items)) {
        return [];
      }

      nameField = nameField || 'name';

      var enabledItems = items.filter(function (item) {
        return !item.expired_documents || item.expired_documents.length === 0;
      });

      var expiredItems = items.filter(function (item) {
        return item.expired_documents && item.expired_documents.length > 0;
      });

      enabledItems = naturalService.naturalSort(enabledItems, nameField, false);
      expiredItems = naturalService.naturalSort(expiredItems, nameField, false);

      return enabledItems.concat(expiredItems);
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('icarus.shared')
    .factory('sessionService', sessionService);


  /** @ngInject */
  function sessionService($http, $log, $q, $window, $cacheFactory, moment, store, __env, $cookies,
                          lodash, CACHE_KEYS, COUNTRIES_BY_CODE_ISO_ALPHA_3, saveDraftPlanService,
                          DRAFT_FOR_APOLLO, PASSPHRASE_IDENTIFIER, addonsService) {

    var user = null;

    // Token from the most recent login call that has NOT yet been persisted to
    // localStorage / cookies. Used to defer persistence until any post-login
    // gates (e.g. compliance acceptance) succeed. While only this in-memory
    // value is set, refresh / deep-link bypass attempts will fail because the
    // global state-change handler can't read a stored token.
    var pendingAuthToken = null;

    var TOKEN_KEY = 'token';
    var ACCOUNT_IDENTIFIER = 'account';

    var LOGIN_PATH = __env.APIV2_URL + 'auth/login/';
    var GET_USER_PATH = __env.API_URL + 'accounts/me/';
    var REGISTER_PATH = __env.API_URL + 'accounts/register/';
    var PASSWORD_CHANGE_PATH = __env.API_URL + 'auth/password/';
    var PASSWORD_RESET_PATH = __env.API_URL + 'auth/password/reset/';
    var USERNAME_EXIST_PATH = __env.API_URL + 'accounts/user-exist/';
    var PASSWORD_RESET_CONFIRM_PATH = __env.API_URL + 'auth/password/reset/confirm/';
    var SUBSCRIPTION_PATH = __env.API_URL + 'accounts/subscription/';
    var UPDATE_ACCOUNT_PATH = __env.API_URL + 'accounts/account/';
    var ACCOUNT_CONFIG_PATH = __env.API_URL + 'accounts/configs/';
    var RESEND_CONFIRMATION_MAIL_PATH = __env.API_URL + 'accounts/resend-confirmation-mail/';
    var CONFIRM_ACCOUNT_PATH = __env.API_URL + 'accounts/activate/';
    var SSO_REQUEST_BUILD_PATH = __env.API_URL + 'accounts/sso/request_auth/';
    var SSO_LOGOUT_REDIRECT_PATH = __env.API_URL + 'accounts/sso/request_logout/';
    var RECAPTCHA_VALIDATION_PATH = __env.API_URL + 'auth/recaptcha/';
    var UNLOCK_USER_PATH = __env.APIV2_URL + 'auth/unlock/';

    var statusAccount = {
      active: 'active'
    };

    var getUserPromise = null;
    var embedded = false;

    ////////////

    var service = {
      initialize: initialize,
      login: login,
      logout: logout,
      signUp: signUp,
      getUser: getUser,
      setMapOptions: setMapOptions,
      passwordReset: passwordReset,
      checkUsername: checkUsername,
      changePassword: changePassword,
      setSubscription: setSubscription,
      cancelSubscription: cancelSubscription,
      passwordResetConfirm: passwordResetConfirm,
      updateOptimizationOptions: updateOptimizationOptions,
      changeStatusAccount: changeStatusAccount,
      changeAccountConfigs: changeAccountConfigs,
      saveAccountConfigs: saveAccountConfigs,
      setOptimizationOptions: setOptimizationOptions,
      getIP: _getIP,
      resendConfirmationEmail: resendConfirmationEmail,
      confirmAccount: confirmAccount,
      getAccountConfigs: getAccountConfigs,
      ssoLogin: ssoLogin,
      ssoRedirect: ssoRedirect,
      ssoLogoutRedirect: ssoLogoutRedirect,
      setAccount: setAccount,
      unsetAccount: unsetAccount,
      isAccountSet: isAccountSet,
      recaptchaValidation: recaptchaValidation,
      unlockUser: unlockUser,
      isEmbedded: isEmbedded,
      setIsEmbedded: setIsEmbedded,
      persistAuth: persistAuth,
      hasPendingAuth: hasPendingAuth
    };

    service.initialize();
    return service;

    ////////////

    function initialize() {
      service.getUser();
    }

    function getUser(force, allowPendingAuth) {
      if (user !== null && force !== true) {
        // We have a stored value which means we can pass it back right away.
        return $q.when(user);
      }

      if (getUserPromise) {
        return getUserPromise;
      }

      // Default: only a persisted token authenticates. The in-memory pendingAuthToken
      // is honored only when the caller is the post-login flow (allowPendingAuth=true)
      // — that way deep-link / URL-bar bypass attempts still fail until the user has
      // cleared all post-login gates and the token has been written to localStorage.
      var token = store.get(TOKEN_KEY);
      if (!token && allowPendingAuth) {
        token = pendingAuthToken;
      }
      if (!token) {
        return $q.reject('NOT_AUTHENTICATED');
      } else {
        $http.defaults.headers.common.Authorization = 'Token ' + token;
        var passphrase = store.get(PASSPHRASE_IDENTIFIER);
        if (passphrase) {
          $http.defaults.headers.common[PASSPHRASE_IDENTIFIER] = passphrase;
        }

        var account = store.get(ACCOUNT_IDENTIFIER);
        if (account != null) {
          $http.defaults.headers.common['Related-Account'] = account;
        }
      }

      getUserPromise = $http.get(GET_USER_PATH)
        .then(httpGetUserComplete, httpGetUserFailed);

      function httpGetUserComplete(response) {
        getUserPromise = null;
        var userData = response.data;

        user = {};
        angular.extend(user, {
          id: userData.id.toString()
        });

        user = userData;
        user.api_token = token;

        user.country = userData.account && userData.account.country ?
          userData.account.country : null;

        user.geocoder_quality_level = userData.account && userData.account.geocoder_quality_level ?
          userData.account.geocoder_quality_level : 1;

        user.mrr = userData.account && userData.account.mrr ?
          userData.account.mrr : null;

        user.countryCodeIsoAlpha3 = COUNTRIES_BY_CODE_ISO_ALPHA_3[user.country];

        // Translate dates to moment object
        user.created = moment(user.created);
        user.modified = moment(user.modified);
        user.last_login = moment(user.last_login);
        user.account.created = moment(user.account.created);
        user.account.active_until = moment(user.account.active_until);

        store.set('country', user.country);
        store.set('accountTimezone', user.account.timezone);
        return user;
      }

      function httpGetUserFailed(error) {
        $http.defaults.headers.common.Authorization = null;
        $log.error(error);
        return $q.reject(error);
      }

      return getUserPromise;
    }

    function signUp(user) {
      var requestData = {
        username: user.username,
        email: user.email,
        name: user.name,
        password: user.password,
        phone: user.phone,
        account: {
          name: user.account.name,
          country: user.account.country,
          vehicle_quantity: user.account.vehicleQuantity,
          module_interest: user.account.module_interest,
          utm: user.account.utm
        }

      };

      return $http.post(REGISTER_PATH, requestData)
        .then(httpSignUpComplete, httpSignUpFailed);
      // .catch(httpSignUpFailed);

      function httpSignUpComplete(response) {
        return response.data;
      }


      function httpSignUpFailed(error) {
        return $q.reject(error);
      }
    }

    function login(username, password) {
      user = null;
      var requestData = {
        username: username,
        password: password
      };
      return $http.post(LOGIN_PATH, requestData)
        .then(httpLoginComplete);
    }

    function ssoLogin(token){
      user = null;
      pendingAuthToken = token;
      $http.defaults.headers.common.Authorization = 'Token ' + token;
    }


    function httpLoginComplete(response) {
      var token = response.data.auth_token;
      pendingAuthToken = token;
      $http.defaults.headers.common.Authorization = 'Token ' + token;
      return token;
    }

    function persistAuth() {
      if (!pendingAuthToken) {
        return;
      }
      store.set(TOKEN_KEY, pendingAuthToken);
      $cookies.put(TOKEN_KEY, pendingAuthToken, { domain: 'simpliroute.com' });
      pendingAuthToken = null;
    }

    function hasPendingAuth() {
      return Boolean(pendingAuthToken);
    }

    function logout() {
      saveDraftPlanService.deleteDraftPlan(DRAFT_FOR_APOLLO);
      addonsService.clearAddons();
      removeCache($cacheFactory.get('extraFieldsDefinition'));
      removeCache($cacheFactory.get('dashboards'));
      removeCache($cacheFactory.get('zones'));
      removeCache($cacheFactory.get('fleets'));
      removeCache($cacheFactory.get(CACHE_KEYS.CACHE_ADDONS_KEY));
      removeCache($cacheFactory.get(CACHE_KEYS.CACHE_DELIVERY_ISSUE));
      removeCache($cacheFactory.get("accountConfigs"));

      user = null;
      getUserPromise = null;
      pendingAuthToken = null;
      store.remove(TOKEN_KEY);
      store.remove('accountConfigs');
      store.remove('country');
      store.remove('userAccountTimezone');
      store.remove('apollo-session');
      store.remove("continueWithMobile");
      store.remove(PASSPHRASE_IDENTIFIER);

      $http.defaults.headers.common.Authorization = null;
      delete $http.defaults.headers.common[PASSPHRASE_IDENTIFIER];
      unsetAccount();
    }

    function setAccount(account) {
      store.set(ACCOUNT_IDENTIFIER, account);
      $http.defaults.headers.common['Related-Account'] = account;
      user = null;
    }

    function unsetAccount() {
      var account = store.get(ACCOUNT_IDENTIFIER);
      store.remove(ACCOUNT_IDENTIFIER);
      delete $http.defaults.headers.common['Related-Account'];
      return account;
    }

    function isAccountSet() {
      return store.get(ACCOUNT_IDENTIFIER) != null;
    }

    function passwordReset(email) {
      var requestData = {
        email: email
      };
      return $http.post(PASSWORD_RESET_PATH, requestData)
        .then(httpPasswordResetComplete);
      // .catch(httpPasswordResetFailed);

      function httpPasswordResetComplete(response) {
        return response.data;
      }
    }

    function passwordResetConfirm(uid, token, newPassword) {
      var requestData = {
        uid: uid,
        token: token,
        new_password: newPassword
      };
      return $http.post(PASSWORD_RESET_CONFIRM_PATH, requestData)
        .then(httpPasswordResetConfirmComplete);
      // .catch(httpPasswordResetConfirmFailed);

      function httpPasswordResetConfirmComplete(response) {
        return response.data;
      }
    }

    function changePassword(newPassword, currentPassword) {
      var requestData = {
        new_password: newPassword,
        current_password: currentPassword
      };
      return $http.post(PASSWORD_CHANGE_PATH, requestData)
        .then(httpChangePasswordComplete);
      // .catch(httpChangePasswordFailed);

      function httpChangePasswordComplete(response) {
        return response.data;
      }
    }

    function setSubscription(plan_quantity, source, coupon) {
      var deferred = $q.defer();

      var requestData = {
        plan_quantity: plan_quantity
      };
      if (source) {
        requestData.source = source;
      }
      if (coupon) {
        requestData.coupon = coupon;
      }


      $http.put(SUBSCRIPTION_PATH, requestData)
        .success(function setSubscriptionSuccess(data) {
          lodash.merge(user.account, data);
          user.account.coupon = data.coupon;
          deferred.resolve(data);
        })
        .error(function setSubscriptionError(error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function cancelSubscription() {
      return $http.delete(SUBSCRIPTION_PATH)
        .then(cancelSubscriptionSuccess, cancelSubscriptionError);
      // .catch(cancelSubscriptionError);

      function cancelSubscriptionSuccess() {
        user.account.status = 'canceled';
        user.account.card_last4 = '';
        return user;
      }

      function cancelSubscriptionError(error) {
        $log.error(error);
        return $q.reject(error);
      }
    }

    function updateOptimizationOptions(options) {
      var request = {
        optimization_options: options
      };
      return $http.patch(UPDATE_ACCOUNT_PATH, request);
    }

    function checkUsername(username) {
      var deferred = $q.defer();

      $http.get(USERNAME_EXIST_PATH, {params: {username: username}}).then(
        function succesUsername(response) {
          deferred.resolve(response);
        })
        .catch(function errorUsername(error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function _getIP() {
      var deferred = $q.defer();
      $http.get(__env.IP_SERVICE_URL)
        .then(function (response) {
          deferred.resolve(response.data.ip);
        })
        .catch(function () {
          deferred.resolve(null);
        });
      return deferred.promise;
    }

    function setMapOptions() {
      getUser().then(function (data) {
        var address = {address: data.account.country};
        $http.post(__env.APIV2_URL + 'directory/geocode/', address).then(
          function searchAddressSuccess(response) {
            return _setAddressMap(response.data);
          },
          function searchAddressError(error) {
            $log.info(error);
          });

      }, function errorGetUser(error) {
        $log.info(error);
      });
    }

    function changeStatusAccount() {
      if (user) {
        user.account.status = statusAccount.active;
        user.has_suscription_id = true;
      }
    }

    // Remove when sessionService refactor
    function changeAccountConfigs(data) {
      if (user) {
        var configs = user.account.configs;
        configs.forEach(function (config) {
          if (config.key === data.key) {
            config.value = data.value;
          }
        });
      }
    }

    function saveAccountConfigs(configs) {
      var deferred = $q.defer();
      var promises = [];
      configs.forEach(function (config) {
        promises.push($http.post(ACCOUNT_CONFIG_PATH, config));
      });
      $q.all(promises).then(function (data) {
        configs.forEach(function (config) {
          changeAccountConfigs(config);
        });
        deferred.resolve(data);
      }).catch(function (error) {
        $log.info(error);
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function setOptimizationOptions(options) {
      if (user) {
        user.account.optimization_options = options;
      }
    }

    ////////////

    function _setAddressMap(data) {
      var deferred = $q.defer();
      $http.get(__env.GOOGLE_MAP_OPTIONS)
        .then(function setAddressMapSuccess(response) {
          var map = response.data;
          map.center.latitude = parseFloat(data.latitude);
          map.center.longitude = parseFloat(data.longitude);
          _updateMap(map);
        })
        .catch(function setAddressMapError(error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function _updateMap(map) {
      var deferred = $q.defer();
      $http.post(__env.GOOGLE_MAP_OPTIONS, map)
        .then(function updateMapSuccess(response) {
          return response.data;
        })
        .catch(function updateMapError(error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function removeCache(cache) {
      if (cache) {
        cache.removeAll();
      }
    }

    function resendConfirmationEmail () {
      return $http.post(RESEND_CONFIRMATION_MAIL_PATH, {});
    }

    function confirmAccount (uid, token, browserLanguage) {
      return $http.post(CONFIRM_ACCOUNT_PATH + uid + '/' + token + '/?browser_language=' + browserLanguage, {});
    }

    function getAccountConfigs() {
      var deferred = $q.defer();

      $http.get(ACCOUNT_CONFIG_PATH).then(function(response) {
        deferred.resolve(response.data);
      }).catch(function(error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function ssoRedirect(domain, account){
      if(account !== undefined)
        {$window.location.href = SSO_REQUEST_BUILD_PATH+'?domain='+domain+'&account='+account;}
      else
        {$window.location.href = SSO_REQUEST_BUILD_PATH+'?domain='+domain;}
    }

    function ssoLogoutRedirect(domain, account){
      if (account !== undefined)
        {$window.location.href = SSO_LOGOUT_REDIRECT_PATH +'?domain=' + domain + '&account=' + account;} // Check this
      else
        {$window.location.href = SSO_LOGOUT_REDIRECT_PATH +'?domain=' + domain;}
    }

    function recaptchaValidation(token, action) {
      var requestData = {
        token: token,
        action: action
      };
      return $http.post(RECAPTCHA_VALIDATION_PATH, requestData);
    }

    function unlockUser(username) {
      var requestData = {
        username: username
      };
      var deferred = $q.defer();
      $http.post(UNLOCK_USER_PATH, requestData).then(
        function (response) {
          deferred.resolve(response);
        },
        function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    function isEmbedded() {
      return embedded;
    }

    function setIsEmbedded(value) {
      embedded = value;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.shared')
    .directive('resizable', resizable);

  /* @ngInject */
  function resizable() {
    return {
      link: function ($scope, $element) {
        var resizeObserver = new ResizeObserver(function (entries) {
          if (!entries || !entries.length) {
            return;
          }

          $scope.$emit('elementResized');
        });

        resizeObserver.observe($element[0]);
  
        $scope.$on('$destroy', function() {
          resizeObserver.disconnect();
        });
      }
    };
  }
})();

(function () {

  'use strict';

  angular
    .module('icarus.shared')
    .factory('reportService', reportService);

  function reportService($http, __env, $filter, xlsWriterService, fileDownloaderService, moment, $q,
                         visitsUtils, DATE_FORMAT, SHOW_EXTRA_FIELD_VALUES_EXCEL_ADDON_PROPERTY, extraFieldsCheckerService) {

    var dateFormat = 'YYYY-MM-DD';
    var EXTENSION = '.xlsx';

    return {
      visitsWithTrackingIdReport: visitsWithTrackingIdReport,
      optimizationRequestsReport: optimizationRequestsReport,
      logRequestsReport: logRequestsReport,
      getRoutesKilometersTravelingReport: getRoutesKilometersTravelingReport,
      downloadReportExcelPlan: downloadReportExcelPlan,
      downloadVisitImagesReport: downloadVisitImagesReport,
      downloadRouteSummaryAsExcel: downloadRouteSummaryAsExcel
    };

    ////////////////Private Methods//////////////////////////
    /////////////////////////////////////////////////////////
    /**
    * Call the endpoint reports/visit-images/
    * @param {Object} request data from the vm
    * @returns {Object} a json with success or error
    */
    function downloadVisitImagesReport(request) {
      return $http.post(__env.API_URL + 'reports/visit-images/', request);
    }

    function getTcReportUrl(start, end) {
      return (__env.API_URL + 'reports/visits/from/' +
      moment(start).format('YYYY-MM-DD') + '/to/' +
      moment(end).format('YYYY-MM-DD') + '/');
    }

    function getOrReportUrl(start, end) {
      return (__env.API_URL + 'optimize/requests/from/' +
      moment(start).format('YYYY-MM-DD') + '/to/' +
      moment(end).format('YYYY-MM-DD') + '/');
    }

    function getLogReportUrl(clientId, start, end) {
      return (__env.API_URL + 'reports/logs/client/' + clientId + '/from/' +
      moment(start).format('YYYY-MM-DD') + '/to/' +
      moment(end).format('YYYY-MM-DD') + '/');
    }

    function downloadOrReport(data) {
      var date = moment().format(DATE_FORMAT);
      var client = 'sr';
      var result = [];
      var HEADERS = [
        'Empresa',
        'Visitas Totales',
        'Máximo de vehículos'
      ];

      data.data.forEach(function (e) {
        result.push(
          [
            e.account,
            e.total_visits,
            e.max_vehicles
          ]
        );
      });

      _getReport(HEADERS, result, date, 'Llamadas a Servicio de optimizacion ' + data.start_date + ' ' + data.end_date, 'Llamadas', client);
    }

    function _getReport(headers, data, reportDate, fileName, sheetName, client) {
      var date = moment(reportDate).format(DATE_FORMAT);

      var grid = {
        headers: headers,
        data: data
      };

      var workbook = xlsWriterService.createWorkbook(sheetName, grid);
      generateExcel(workbook,fileName + client + '_' + date.replace(/-/g, ''));
    }

    function _reportUrlRoutes(dates) {
      return (__env.API_URL + 'reports/routes/from/' +
      dates.fromDate + '/to/' +
      dates.toDate + '/');
    }

    function generateExcel(workbook, name) {
      var file = xlsWriterService.writeWorkbook(workbook);
      fileDownloaderService.downloadXLSX(file, name + EXTENSION);
    }

    ///////////////Public Methods////////////////////////////
    /////////////////////////////////////////////////////////

    function visitsWithTrackingIdReport(startDate, endDate, email, all_accounts) {
      var reqParams = {email: email};

      if (all_accounts) {
        reqParams.all_accounts = all_accounts;
      }

      var deferred = $q.defer();
      $http.get(getTcReportUrl(startDate, endDate), {params: reqParams})
        .then(function (rows) {
          deferred.resolve(rows);
        }).catch(function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    }

    function optimizationRequestsReport(startDate, endDate) {
      var deferred = $q.defer();
      $http
        .get(getOrReportUrl(startDate, endDate))
        .then(function (rows) {
          downloadOrReport(rows.data);
          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    function logRequestsReport(clientId, startDate, endDate) {
      var deferred = $q.defer();
      $http
        .get(getLogReportUrl(clientId, startDate, endDate))
        .then(function (data) {
          var anchor = angular.element('<a/>');
          anchor.css({display: 'none'}); // Make sure it's not visible
          angular.element(document.body).append(anchor); // Attach to document

          anchor.attr({
            href: 'data:attachment/csv;charset=utf-8,' + encodeURI(data.data),
            target: '_blank',
            download: 'Reporte_Logs_Cliente_' + clientId + '_' + moment(startDate).format(dateFormat)
            + '_a_' + moment(endDate).format(dateFormat) + '.csv'
          })[0].click();

          anchor.remove();
          deferred.resolve(data);
        })
        .catch(function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    function getRoutesKilometersTravelingReport(params) {
      var reqParams = { start_time: params.startTime, end_time: params.endTime};

      if (params.all_accounts) {
        reqParams.all_accounts = params.all_accounts;
      }

      return $http.get(_reportUrlRoutes(params), {
        params: reqParams,
        responseType: "blob"
      });
    }

    function downloadReportExcelPlan(data, localOptimizationOptions) {
      return extraFieldsCheckerService.getShowExtraFieldsEnabled(SHOW_EXTRA_FIELD_VALUES_EXCEL_ADDON_PROPERTY)
        .then(function(isShowExtraFieldValuesEnabled) {
          var visitOutOfRows;
          var workbook = {
            Sheets: {},
            SheetNames: []
          };

          var HEADERS = [
            $filter('translate')('Excel_Header.driver'),
            $filter('translate')('Excel_Header.vehicle'),
            $filter('translate')('Excel_Header.route_Index'),
            $filter('translate')('Excel_Header.stop'),
            $filter('translate')('Excel_Header.title'),
            $filter('translate')('Excel_Header.address'),
            $filter('translate')('Excel_Header.service_Time'),
            $filter('translate')('Excel_Header.arrival_Time'),
            $filter('translate')('Excel_Header.distance'),
            $filter('translate')('Excel_Header.order_size'),
            $filter('translate')('Excel_Header.total_size'),
            $filter('translate')('Excel_Header.latitude'),
            $filter('translate')('Excel_Header.longitude'),
            $filter('translate')('Excel_Header.reference'),
            $filter('translate')('Excel_Header.warnings'),
            $filter('translate')('Excel_Header.visit_load2'),
            $filter('translate')('Excel_Header.visit_load3'),
            $filter('translate')('Excel_Header.route_coment'),
            $filter('translate')('Excel_Header.notes'),
            $filter('translate')('Excel_Header.zones'),
            $filter('translate')('Excel_Header.visit_alerts')
          ];

          // Add extra header if enabled
          if (isShowExtraFieldValuesEnabled) {
            HEADERS.push($filter('translate')('Excel_Header.customer_shipment_date'));
          }

          var visitRows = [];

          var vehicles = data.vehicles || [];
          var drivers = data.drivers || [];
          var planDate = data.date;

          vehicles.forEach(function (vehicle) {
            vehicle.routes.forEach(function (route, routeIndex) {
              var comment = route.comment;
              var lastVisit = route.visits[route.visits.length - 1];
              var foundDriver = null;

              if (route.driver) {
                foundDriver = drivers.find(function (driver) {
                  return String(driver.id) === String(route.driver);
                });
              }

              routeIndex = routeIndex + 1;
              // Location start for this route
              visitRows.push([
                foundDriver ? foundDriver.name : "",
                vehicle.name,
                routeIndex,
                0,
                $filter('translate')('Routes.start'),
                route.locationStart.address,
                '',
                route.estimatedTimeStart,
                0,
                '',
                route.totalLoad,
                parseFloat(route.locationStart.latitude),
                parseFloat(route.locationStart.longitude),
                '',
                '',
                '',
                '',
                comment,
                '',
                '',
                ''
              ]);

              route.visits.sort(function (a, b) {
                if (a.order > b.order) {
                  return 1;
                }
                if (a.order < b.order) {
                  return -1;
                }
                // a must be equal to b
                return 0;
              });

              route.visits.forEach(function (visit) {
                var baseRow = [
                  foundDriver ? foundDriver.name : "",
                  vehicle.name,
                  routeIndex,
                  visit.order,
                  visit.title,
                  visit.address,
                  visit.duration,
                  visit.estimatedTimeArrival,
                  '',
                  visit.load,
                  route.totalLoad,
                  parseFloat(visit.latitude),
                  parseFloat(visit.longitude),
                  visit.reference,
                  visit.error ? visit.error.msg : '',
                  visit.load2,
                  visit.load3,
                  comment,
                  visit.notes,
                  (!angular.isUndefined(visit.zones) && visit.zones.length !== 0) ? visit.zones.map(
                    function (zone) {
                      return (!angular.isUndefined(zone.name)) ? zone.name : '';
                    }
                  ).join(', ') : '',
                  visitsUtils.getAlertString(visit)
                ];

                // Add extra field if enabled
                if (isShowExtraFieldValuesEnabled) {
                  var customer_shipment_date = "";
                  if (visit.extra_field_values && visit.extra_field_values.fec_envio_cliente) {
                    customer_shipment_date = visit.extra_field_values.fec_envio_cliente || "";
                  }
                  baseRow.push(customer_shipment_date);
                }

                visitRows.push(baseRow);
              });

              // Location end for this route
              visitRows.push([
                foundDriver ? foundDriver.name : "",
                vehicle.name,
                routeIndex,
                route.visits.length + 1,
                $filter('translate')('Routes.end'),
                localOptimizationOptions.open_ended ? lastVisit.address: route.locationEnd.address,
                  '',
                route.estimatedTimeEnd,
                route.totalDistance,
                '',
                route.totalLoad,
                localOptimizationOptions.open_ended ? parseFloat(lastVisit.latitude) : parseFloat(route.locationEnd.latitude),
                localOptimizationOptions.open_ended ? parseFloat(lastVisit.longitude) : parseFloat(route.locationEnd.longitude),
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                ''
              ]);
            });
          });

          visitOutOfRows = data.visitsOutOfRoute ? orderVisits(data.visitsOutOfRoute): [];

          visitOutOfRows.forEach(function (visit) {
            visitRows.push([
              '',
              $filter('translate')('Visits.out_of_route'),
              '',
              visit.order,
              visit.title,
              visit.address,
              visit.duration,
              '',
              '',
              visit.load,
              '',
              parseFloat(visit.latitude),
              parseFloat(visit.longitude),
              visit.reference,
              visit.error ? visit.error.msg : '',
              visit.load2,
              visit.load3,
              '',
              visit.notes,
              (!angular.isUndefined(visit.zones) && visit.zones.length !== 0)? visit.zones.map(
                function (zone) {
                  return (!angular.isUndefined(zone.name))? zone.name : '';
                }
              ).join(', ')  : '',
              ''
            ]);
          });

          workbook.Sheets['Plan'] = xlsWriterService.sheetFromMatrix([HEADERS].concat(visitRows));

          workbook.SheetNames.push('Plan');

          drivers.forEach(function (driver) {
            var driverRows = visitRows.filter(function (row) {
              return row[0] === driver.name;
            });

            if (driverRows.length > 0) {
              var fullSheetName = workbook.SheetNames.length + '. ' + xlsWriterService.sanitizeSheetName(driver.name);
              var sheetName = fullSheetName.slice(0, 20).trim();
              workbook.Sheets[sheetName] = xlsWriterService.sheetFromMatrix([HEADERS].concat(driverRows));
              workbook.SheetNames.push(sheetName);
            }
          });

          generateExcel(workbook, 'SimpliRoute_Plan_' + planDate);
          return visitRows;
        });
    }

    function orderVisits(visits) {
      visits.sort(function (a, b) {
        if (a.title > b.title) {
          return 1;
        }
        if (a.title < b.title) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });

      return visits;
    }

    function downloadRouteSummaryAsExcel(routeSummaryRows, isJoinSimilarActive, isMixLoadAddonEnabled) {
      var workbook =  {
        Sheets: {},
        SheetNames: []
      };

      var HEADERS = [
        '',
        $filter('translate')('Excel_Header.vehicle'),
        $filter('translate')('Excel_Header.route_name'),
        $filter('translate')('Excel_Header.origin'),
        $filter('translate')('Excel_Header.driver'),
        $filter('translate')('Excel_Header.start_time'),
        $filter('translate')('Excel_Header.end_time'),
        $filter('translate')('Excel_Header.distance'),
        $filter('translate')('Excel_Header.duration'),
        $filter('translate')('Excel_Header.visits'),
        $filter('translate')('Excel_Header.load1'),
        $filter('translate')('Excel_Header.load1') + ' (%)',
        $filter('translate')('Excel_Header.load2'),
        $filter('translate')('Excel_Header.load2') + ' (%)',
        $filter('translate')('Excel_Header.load3'),
        $filter('translate')('Excel_Header.load3') + ' (%)',
      ];

      if (isMixLoadAddonEnabled) {
        HEADERS.push($filter('translate')('Excel_Header.load4'));
        HEADERS.push($filter('translate')('Excel_Header.load4') + ' (%)');
      }

      if(isJoinSimilarActive) {
        HEADERS.push($filter('translate')('Excel_Header.stops'));
      }

      workbook.Sheets[$filter('translate')('Routes.routes_summary')] = xlsWriterService.sheetFromMatrix([HEADERS].concat(routeSummaryRows));

      workbook.SheetNames.push($filter('translate')('Routes.routes_summary'));

      generateExcel(workbook, $filter('translate')('Routes.routes_summary'));
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .factory('planService', planService);

  /** @ngInject */
  function planService($http, PlanModel, RouteModel, VisitModel, VisitDetailModel, $q, VehicleModel,
                       EventModel,  accountConfigsService, __env, addonsService, PATH_FINDER_ADD_ON_PROPERTIES,
                       PATH_FINDER_ADD_ON_KEY, saveDraftPlanService, PLAN_SAVE_PENDING) {
    return {
      getGeneralProgress: getGeneralProgress,
      getGeneralProgressByFleet: getGeneralProgressByFleet,
      getProgressVehicleByDateAndFleet: getProgressVehicleByDateAndFleet,
      getAllPlansByDate: getAllPlansByDate,
      getVehiclesWithRoutesByDate: getVehiclesWithRoutesByDate,
      getVehicleByIDAndDriverAndDate: getVehicleByIDAndDriverAndDate,
      getPlansByDate: getPlansByDate,
      getPlanByID: getPlanByID,
      getRouteByID: getRouteByID,
      getVisitByID: getVisitByID,
      getVisitDetailByID: getVisitDetailByID,
      getVehicleById: getVehicleById,
      getAllVisitsByDate: getAllVisitsByDate,
      savePlan: savePlan,
      getVisitsByRouteID: getVisitsByRouteID,
      getEventsByUrl: getEventsByUrl,
      getRouteEventsByUrl: getRouteEventsByUrl,
      getEventsByDate: getEventsByDate,
      getEventsByRoutes: getEventsByRoutes,
      getAllEventsByDateAndFleet: getAllEventsByDateAndFleet,
      searchVisit: searchVisit,
      getAllVehicles: getAllVehicles,
      editPlan: editPlan,
      getAllVisitsByDateAndFleet: getAllVisitsByDateAndFleet,
      searchVisitByFleet: searchVisitByFleet,
      getVehiclesWithRoutesByDateAndFleet: getVehiclesWithRoutesByDateAndFleet,
      saveOptimizationIds: saveOptimizationIds,
      isNonBlockingSavingEnabled: isNonBlockingSavingEnabled,
      getDraftPlanKey: getDraftPlanKey,
      getPendingDraftPlanIds: getPendingDraftPlanIds,
      getActiveDraftPlanIds: getActiveDraftPlanIds,
      getRoutesStatus: getRoutesStatus
    };

    //////////////////////////////////////////
    // Privates Methods
    /////////////////////////////////////////

    function planUrlById(id) {
      return __env.API_URL + 'plans/' + id + '/';
    }

    function planUrlByDate(date) {
      return __env.API_URL + 'plans/' + date + '/';
    }

    function routeUrl(route_id) {
      return __env.API_URL + 'plans/routes/' + route_id + '/';
    }

    function visitUrl(visit_id) {
      return __env.API_URL + 'plans/visits/' + visit_id + '/';
    }

    function vehiclesByDateURL(date) {
      return planUrlByDate(date) + 'vehicles/';
    }

    function allVehiclesUrl () {
      return __env.API_URL + 'routes/vehicles/';
    }

    function progressVehiclesUrl(date) {
      return planUrlByDate(date, true) + (accountConfigsService.isConfigEnabled('enable_multi_drivers') ?
        'tracking/progress' : 'routes/progress/');
    }

    function progressVehiclesUrlByFleet(date, fleetId) {
      return planUrlByDate(date, true ) + 'fleet/' + fleetId + '/progress/';
    }

    function allVisitsByDateURL(date) {
      return __env.API_URL + 'plans/visits/date/' + date + '/';
    }

    function allVisitsByDateAndFleetURL(date, fleetId) {
      return __env.API_URL + 'plans/visits/fleets/' + fleetId + '/?' + 'planned_date=' + date;
    }

    function allEventsByDateURL(date) {
      return __env.API_URL + 'events/all/' + date + '/';
    }

    function allEventsByRoutes(request) {
      return __env.API_URL + 'events/by-routes/';
    }

    function allEventsByDateAndFleet(date, fleetId) {
        return __env.API_URL + 'events/all/' + date + '/fleet/' + fleetId + '/';
    }

    function vehicleByIdURL(id) {
      return __env.API_URL + 'plans/vehicles/' + id + '/';
    }

    function savePlanUrl(isVisitsJoinedByDistance, async) {
      if (async) {
        return __env.ROUTER_MS_URL + 'v2/plans/create-plan-deferred/';
      }

      if (isVisitsJoinedByDistance) {
        return __env.ROUTER_MS_URL + 'v2/plans/create-plan/';
      }

      var API_URL = accountConfigsService.isConfigEnabled('use_async_plan_creation') ? __env.APIV2_URL : __env.API_URL;
      return API_URL + 'plans/create-plan/';
    }

    function visitSearchUrl(keyWord, date) {
      return __env.API_URL + 'plans/visits-filter/?planned_date=' + date + '&search=' + keyWord;
    }

    function visitSearchUrlByFleet(keyWord, date, fleetId) {
      return __env.API_URL + 'plans/visits-filter/fleets/' + fleetId + '/?planned_date=' + date + '&search=' + keyWord;
    }

    function editPlanUrl(isVisitsJoinedByDistance, isIncrementalRoutingOptimize, async) {
      if (async) {
        return __env.ROUTER_MS_URL + 'v2/plans/edit-plan-deferred/';
      }

      if (isVisitsJoinedByDistance && !isIncrementalRoutingOptimize) {
        return __env.ROUTER_MS_URL + 'v2/plans/edit-plan/';
      }

      return __env.APIV2_URL + 'plans/edit-plan/';
    }

    function vehiclesWithRoutesByDateAndFleetUrl(date, fleetId) {
      return __env.API_URL + 'plans/' + date + '/fleets/' + fleetId + '/';
    }

    function routesStatusUrl(planId) {
      return __env.APIV2_URL + 'plans/' + planId + '/routes-status/';
    }

    function getInstance(url, opts, modelFromJson) {
      var deferred = $q.defer();
      $http.get(url, opts)
        .then(function (response) {
          try {
            deferred.resolve(modelFromJson(response.data));
          } catch (e) {
            deferred.reject(e.message);
          }
        })
        .catch(function (response) {
          deferred.reject(response);
        });
      return deferred.promise;
    }

    function getInstanceUsingCallbacks(method, args, successCallback, errorCallback) {
      var deferred = $q.defer();
      if (!errorCallback) {
        errorCallback = function (e) {
          var error = angular.isObject(e) ? e.data : e;
          deferred.reject(error);
        };
      }

      method.apply(this, args)
        .then(function (response) {
          $q.when(successCallback(response))
            .then(function (models) {
              deferred.resolve(models);
            });
        })
        .catch(errorCallback);
      return deferred.promise;
    }

    ////////////////////////////////////////////
    // Public Methods
    ////////////////////////////////////////////

    function getGeneralProgress(date) {
      return $http.get(progressVehiclesUrl(date));
    }

    function getGeneralProgressByFleet(date, fleetId) {
      return $http.get(progressVehiclesUrlByFleet(date, fleetId));
    }

    function getProgressVehicleByDateAndFleet(date, fleet) {
      fleet = fleet ? fleet : null;
      var httpConfig = {params: {fleet: fleet}};
      return $http.get(progressVehiclesUrl(date), httpConfig);
    }

    function getPlansByDate(date) {
      return $http.get(planUrlByDate(date));
    }

    function getPlanByID(plan_id) {
      return getInstance(planUrlById(plan_id), null, PlanModel.fromJson);
    }

    function getRouteByID(route_id) {
      return getInstance(routeUrl(route_id), null, RouteModel.fromJson);
    }

    function getVisitByID(visit_id) {
      return getInstance(visitUrl(visit_id), null, VisitModel.fromJson);
    }

    function getVisitDetailByID(visit_id) {
      return getInstance(visitUrl(visit_id) + 'detail/', null, VisitDetailModel.fromJson);
    }

    function getAllPlansByDate(date) {
      function success(response) {
        var listPromisesPlans = [];

        angular.forEach(response.data.plans, function (planId) {
          listPromisesPlans.push(getPlanByID(planId));
        });

        return $q.all(listPromisesPlans)
          .then(function (plans) {
            return plans;
          });
      }

      return getInstanceUsingCallbacks(getPlansByDate, [date], success);
    }

    function getVehiclesWithRoutesByDate(date) {
      function success(response) {
        var vehicles = [];

        angular.forEach(response.data, function (data) {
          var vehicle = VehicleModel.fromJson(data);
          vehicles.push(vehicle);
        });

        return vehicles;
      }

      return getInstanceUsingCallbacks($http.get, [vehiclesByDateURL(date)], success);
    }

    function getVehicleByIDAndDriverAndDate(date, vehicle_id, driver_id) {
      function success(response) {
        if (response.data.length > 0) {
          return VehicleModel.fromJson(response.data[0]);
        }
        return [];
      }

      return getInstanceUsingCallbacks(
        $http.get, [vehiclesByDateURL(date), {params: {vehicle: vehicle_id, driver: driver_id}}], success);
    }

    function getVehicleById(vehicle_id) {
      function success(response) {
        return VehicleModel.fromJson(response.data);
      }

      return getInstanceUsingCallbacks(
        $http.get, [vehicleByIdURL(vehicle_id)], success);
    }

    function getAllVisitsByDate(date) {
      function success(response) {
        var visits = [];

        angular.forEach(response.data, function (data) {
          var visit = VisitModel.fromJson(data);
          visits.push(visit);
        });

        return visits;
      }
      return getInstanceUsingCallbacks($http.get, [allVisitsByDateURL(date)], success);
    }

    function getAllVisitsByDateAndFleet(date, fleetId) {
      return getInstanceUsingCallbacks(
        $http.get, [
          allVisitsByDateAndFleetURL(date, fleetId)
        ], function(response) {
        return response.data.map(function(data) {
          return VisitModel.fromJson(data);
        });
      });
    }

    function getVisitsByRouteID(routeId) {
      var deferred = $q.defer();
      var visits = [];
      $http.get(routeUrl(routeId) + 'visits/').then(function (response) {
          response.data.map(function (visit) {
            visits.push(VisitModel.fromJson(visit));
          });
          deferred.resolve(visits);
      });
      return deferred.promise;
    }

    function savePlan(requestData, isVisitsJoinedByDistance, async) {
      return $http.post(savePlanUrl(isVisitsJoinedByDistance, async), requestData);
    }

    function getEventsByUrl (url) {
      function success (response) {
        var events = [];

        angular.forEach(response.data.results, function (data) {
          var event = EventModel.fromJson(data);
          events.push(event);
        });

        return {
          events: events,
          next: response.data.next,
          previous: response.data.previous,
          count: response.data.count
        };
      }
      return getInstanceUsingCallbacks($http.get, [url], success);
    }

    function getEventsByDate (date) {
      function success (response) {
        var events = [];

        angular.forEach(response.data.results, function (data) {
          var event = EventModel.fromJson(data);
          events.push(event);
        });

        return {
          events: events,
          next: response.data.next,
          previous: response.data.previous,
          count: response.data.count
        };
      }
      return getInstanceUsingCallbacks($http.get, [allEventsByDateURL(date)], success);
    }

    function getAllEventsByDateAndFleet(date, fleetId) {
      function success (response) {
        var events = [];

        if (response.data.results) {
          response.data.results.map(function(data) {
            var event = EventModel.fromJson(data);
            events.push(event);
          });
        }

        return {
          events: events,
          next: response.data.next,
          previous: response.data.previous,
          count: response.data.count
        };
      }

      return getInstanceUsingCallbacks($http.get, [allEventsByDateAndFleet(date, fleetId)], success);
    }

    function getEventsByRoutes (request) {
      function success (response) {
        var events = [];

        angular.forEach(response.data.results, function (data) {
          var event = EventModel.fromJson(data);
          events.push(event);
        });

        return {
          events: events,
          next: response.data.next,
          previous: response.data.previous,
          count: response.data.count
        };
      }
      return getInstanceUsingCallbacks($http.post, [allEventsByRoutes(), request], success);
    }

    function getRouteEventsByUrl (request, url) {
      function success (response) {
        var events = [];

        angular.forEach(response.data.results, function (data) {
          var event = EventModel.fromJson(data);
          events.push(event);
        });

        return {
          events: events,
          next: response.data.next,
          previous: response.data.previous,
          count: response.data.count
        };
      }
      return getInstanceUsingCallbacks($http.post, [url, request], success);
    }

    function searchVisit(keyWord, planned_date) {
      var deferred = $q.defer();
      $http.get(visitSearchUrl(keyWord, planned_date), {cache: true})
        .then(function (response) {
          var visits = [];
          response.data.map(function (visit) {
            visit = VisitModel.fromJson(visit);
            visits.push(visit);
          });
          deferred.resolve(visits);
        });

      return deferred.promise;
    }


    function searchVisitByFleet(keyWord, planned_date, fleetId) {
      return getInstanceUsingCallbacks(
        $http.get, [
          visitSearchUrlByFleet(keyWord, planned_date, fleetId), {cache: true}
        ], function(response) {
          return response.data.map(function(data) {
            return VisitModel.fromJson(data);
          });
        });
    }


    function getAllVehicles () {
      function success(response) {
        var vehicles = [];

        angular.forEach(response.data, function (data) {
          data.driver = {};
          data.routes = [];
          var vehicle = VehicleModel.fromJson(data);
          vehicles.push(vehicle);
        });

        return vehicles;
      }

      return getInstanceUsingCallbacks($http.get, [allVehiclesUrl()], success);
    }

    function editPlan(requestData, isVisitsJoinedByDistance, isIncrementalRoutingOptimize, async) {
      return $http.post(editPlanUrl(isVisitsJoinedByDistance, isIncrementalRoutingOptimize, async), requestData);
    }

    function getVehiclesWithRoutesByDateAndFleet(date, fleetId) {
      function success(response) {
        var vehicles = [];

        angular.forEach(response.data, function (data) {
          var vehicle = VehicleModel.fromJson(data);
          vehicles.push(vehicle);
        });

        return vehicles;
      }

      return getInstanceUsingCallbacks(
        $http.get,
        [vehiclesWithRoutesByDateAndFleetUrl(date, fleetId)],
        success);
    }

    function saveOptimizationIds(planId, optimizationIds, planSavedAsync) {
      if (optimizationIds.length === 0 || planSavedAsync) {
        return $q.when();
      }

      var url = __env.API_URL  + 'plans/plan-optimization-reference/';
      var requestData = {
        plan_id: planId,
        optimization_ids: optimizationIds
      };

      return $http.post(url, requestData);
    }

    function isNonBlockingSavingEnabled() {
      return addonsService.isAddonPropertyEnabled(PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES.NON_BLOCKING_SAVING, function (addonProperty) {
        return addonProperty.value && addonProperty.value.toLowerCase() === "true";
      })
        .catch(function () {
          return false;
        });
    }

    function getDraftPlanKey(planId) {
      return PLAN_SAVE_PENDING + ":" + planId;
    }

    function getPendingDraftPlanIds(isNonBlockingSavingEnabled) {
      if (!isNonBlockingSavingEnabled) {
        return $q.when([]);
      }

      return saveDraftPlanService.getDraftPlanIdsByPrefix(PLAN_SAVE_PENDING);
    }

    function getActiveDraftPlanIds(isNonBlockingSavingEnabled, plans, activeDraftPlanIds) {
      if (!isNonBlockingSavingEnabled || activeDraftPlanIds.length === 0) {
        return [];
      }

      var activeDraftPlanIdsToKeep = Array.from(activeDraftPlanIds);
      var activeDraftPlanKeysToDelete = [];

      plans.forEach(function (plan) {
        if (!activeDraftPlanIdsToKeep.includes(plan.id)) {
          return;
        }

        if (!["saving", "error"].includes(plan.saveStage)) {
          var draftPlanKeyToDelete = getDraftPlanKey(plan.id);
          var draftPlanIdIndex = activeDraftPlanIdsToKeep.indexOf(plan.id);

          activeDraftPlanKeysToDelete.push(draftPlanKeyToDelete);
          activeDraftPlanIdsToKeep.splice(draftPlanIdIndex, 1);
          return;
        }
      });

      saveDraftPlanService.deleteDraftPlansByPlanKeys(activeDraftPlanKeysToDelete);

      return activeDraftPlanIdsToKeep;
    }

    function getRoutesStatus(planId) {
      var deferred = $q.defer();
      $http.get(routesStatusUrl(planId))
        .then(function(response) {
          deferred.resolve(response.data);
        })
        .catch(function(error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

  }
})();

/* global pdfMake:false */
(function() {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('pdfService', pdfService);

  /* @ngInject */
  function pdfService($log, $rootScope) {
    return {
      create: create
    };

    function create(doc, title) {
      pdfMake.createPdf(doc).download(title, function () {
        $log.info('your pdf is done');
        $rootScope.isLoading = false;
      });
    }
  }
})();

(function(){
'use strict';

angular
  .module('icarus.shared')
  .factory('naturalService', naturalService);

/** @ngInject */
function naturalService ($locale, $filter) {
  var natCache = {},
		// amount of extra zeros to padd for sorting
        padding = function(value) {
			return "00000000000000000000".slice(value.length);
		},

		// Converts a value to a string.  Null and undefined are converted to ''
		toString = function(value) {
			if(value === null || value === undefined) {return '';}
			return ''+value;
		},

		// Calculate the default out-of-order date format (dd/MM/yyyy vs MM/dd/yyyy)
    natDateMonthFirst = $locale.DATETIME_FORMATS.shortDate.charAt(0) === "M",
    // Replaces all suspected dates with a standardized yyyy-m-d, which is fixed below
    fixDates = function(value) {
      // first look for dd?-dd?-dddd, where "-" can be one of "-", "/", or "."
      return toString(value).replace(/(\d\d?)[-\/\.](\d\d?)[-\/\.](\d{4})/, function($0, $m, $d, $y) {
        // temporary holder for swapping below
        var t = $d;
        // if the month is not first, we'll swap month and day...
        if(!natDateMonthFirst) {
          // ...but only if the day value is under 13.
          if(Number($d) < 13) {
          $d = $m;
          $m = t;
          }
        } else if(Number($m) > 12) {
          // Otherwise, we might still swap the values if the month value is currently over 12.
          $d = $m;
          $m = t;
        }
        // return a standardized format.
        return $y+"-"+$m+"-"+$d;
      });
    },

    // Fix numbers to be correctly padded
    fixNumbers = function(value) {
      // First, look for anything in the form of d.d or d.d.d...
      return value.replace(/(\d+)((\.\d+)+)?/g, function ($0, integer, decimal, $3) {
        // If there's more than 2 sets of numbers...
        if (decimal !== $3) {
          // treat as a series of integers, like versioning,
          // rather than a decimal
          return $0.replace(/(\d+)/g, function ($d) {
          return padding($d) + $d;
          });
        } else {
          // add a decimal if necessary to ensure decimal sorting
          decimal = decimal || ".0";
          return padding(integer) + integer + decimal + padding(decimal);
        }
      });
    },

    // Finally, this function puts it all together.
    natValue = function (value) {
      if(natCache[value]) {
        return natCache[value];
      }
      natCache[value] = fixNumbers(fixDates(value));
      return natCache[value];
    };

	// The actual object used by this service
	return {
		naturalValue: natValue,
		naturalSort:  function(array, field, order) {
      return $filter('orderBy')(array, function (item) {
        return natValue(item[field]);
        }, order);
    }
	};
}
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {

    //// Translate keys.
    $translateProvider.translations('es', {
      Map: {
        map_label: 'Mapa',
        satellite_label: 'Satélite'
      }
    });

    $translateProvider.translations('en', {
      Map: {
        map_label: 'Map',
        satellite_label: 'Satellite'
      }
    });

    $translateProvider.translations('pt', {
      Map: {
        map_label: 'Mapa',
        satellite_label: 'Satélite'
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .constant('MAP_EVENTS', {
      RESIZE: 'resize',
      MAPVIEWCHANGEEND: 'mapviewchangeend',
      DRAGSTART: 'dragstart',
      DRAG: 'drag',
      DRAGEND: 'dragend',
      CLICK: 'click',
      TAP: 'tap',
      POINTERENTER: 'pointerenter',
      POINTERLEAVE: 'pointerleave',
      SET_AT: 'set_at',
      INSERT_AT: 'insert_at',
      REMOVE_AT: 'remove_at',
      POINTERMOVE: 'pointermove',
      FULLSCREENCHANGE: 'fullscreenchange',
      WEBKITFULLSCREENCHANGE: 'webkitfullscreenchange',
      MOUSEOVER: 'mouseover',
      MOUSEOUT: 'mouseout'
    })
    .constant('CURSOR', {
      GRAB: 'grab',
      POINTER: 'pointer',
      CROSSHAIR: 'crosshair'
    })
    .constant('CIRCLE_MARKER_URL', '/assets/images/circle_marker.svg')
    .constant('CIRCLE_MARKER_WITH_OPACITY_URL', '/assets/images/circle_marker_with_opacity.svg')
    .constant('MAP_CONTROL', {
      MAPSETTINGS: 'mapsettings',
      ZOOM: 'zoom',
      SCALEBAR: 'scalebar',
      CUSTOM_MAPSETTINGS: 'custom_mapsettings',
      FULLSCREEN: 'fullscreen',
      DRAWING: 'drawing'
    })
    .constant("ZOOM_NUMBER_TO_CENTER_MARKER", 18);
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('locationResolverService', locationResolverService);

  /** @ngInject */
  function locationResolverService($q, googleService) {
    return {
      getAddressByLatLng: getAddressByLatLng
    };

    function getAddressByLatLng(latitude, longitude) {
      var deferred = $q.defer();
      var geocoder = googleService.createGeocode();
      var address = null;
      var location = {
        lat: latitude,
        lng: longitude
      };

      geocoder.geocode({ location: location }, function (results, status) {
        if (status === googleService.geocoderStatusOK()) {
          results.forEach( function (result) {
            if (result.types.indexOf('street_address') > -1) {    
              address = result.formatted_address;
            }
          });
        }

        deferred.resolve(address);
      });

      return deferred.promise;
    }

  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.shared")
    .filter("localeCompare", localeCompare);

  /** @ngInject */
  function localeCompare() {
    return function (string, stringToCompare, language) {
      return string.localeCompare(stringToCompare, language, {
        sensitivity: "base",
        numeric: true,
      });
    };
  }
})();

(function(){
  'use strict';

  angular
  .module('icarus.shared')
  .directive('inputTimeValidator', inputTimeValidator);

  function inputTimeValidator () {
    return {
        restrict: "A",
        require: "ngModel",
        link: function(scope, el, attrs, ngModel) {
            var patternValidator,
                pattern = "/([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]/",
                required = true;

            if( pattern ) {
                if (pattern.match(/^\/(.*)\/$/)) {
                    pattern = new RegExp(pattern.substr(1, pattern.length - 2));
                    patternValidator = function(value) {
                        return validate(pattern, value);
                    };
                }
                else {
                    patternValidator = function(value) {
                        var patternObj = scope.$eval(pattern);
                        if (!patternObj || !patternObj.test) {
                            throw new Error('Expected ' + pattern + ' to be a RegExp but was ' + patternObj);
                        }
                        return validate(patternObj, value);
                    };
                }
            }

            ngModel.$formatters.push(patternValidator);
            ngModel.$parsers.push(patternValidator);

            attrs.$observe("required", function(newval) {
                required = newval;
                patternValidator(ngModel.$viewValue);
            });

            function validate(regexp, value) {
                if( value === null || value === "" || !required || regexp.test(value) ) {
                    ngModel.$setValidity('pattern', true);
                    return value;
                }
                else {
                    ngModel.$setValidity('pattern', false);
                    return;
                }
            }
        }
    };
  }

})();

/*
Ejemplo de uso del filtro:
{{number | formatNumber:2:'.':','}}
*/

(function() {
  'use strict';

  angular
    .module('icarus.shared')
    .filter('formatNumber', formatNumber);

  /** @ngInject */
  function formatNumber(){
    return function(number, digits) {
      var thoSeperator, decSeperator, i;
      var locale = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);

      // Quick exit
      if (isNaN(number) || number === '' || number === null) {
        return '0';
      }

      // si el idioma es espannol
      if (locale.substring(0, 2).toLowerCase() === 'es') {
        thoSeperator = '.';
        decSeperator = ',';
      } else {
        thoSeperator = ',';
        decSeperator = '.';
      }

      digits = (typeof digits === "undefined") ? 2 : digits;
      thoSeperator = (typeof thoSeperator === "undefined") ? "," : thoSeperator;
      decSeperator = (typeof decSeperator === "undefined") ? "." : decSeperator;
      number = number.toString();
      var _temp = number.split(".");
      var dig = (typeof _temp[1] === "undefined") ? "00" : _temp[1];
      dig = dig.toString();
      if (dig.length > digits) {
          dig = (Math.round(parseFloat("0." + dig) * Math.pow(10, digits))).toString();
      }
      for (i = dig.length; i < digits; i++) {
          dig += "0";
      }
      var num = _temp[0];
      var s = "",
          ii = 0;
      for (i = num.length - 1; i > -1; i--) {
          s = ((ii++ % 3 === 2) ? ((i > 0) ? thoSeperator : "") : "") + num.substr(i, 1) + s;
      }

      return (dig !== '00' && digits !== 0) ? s + decSeperator + dig : s;
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('extraFieldsService', extraFieldsService);

  extraFieldsService.$inject = ['$http', '$q', '$cacheFactory', '__env', 'ExtraFieldDefinition', '$filter'];

  /** @ngInject */
  function extraFieldsService($http, $q, $cacheFactory, __env, ExtraFieldDefinition, $filter) {
    var EXTRA_FIELDS = __env.API_URL + 'accounts/extra-fields/';
    var cache = $cacheFactory('extraFieldsDefinition');
    var $translate = $filter('translate');

    return {
      getExtraFields: getExtraFields,
      sortDefinition: sortDefinition,
      parseFieldUrls: parseFieldUrls
    };

    function parseFieldUrls(text) {
      if (!text) return '';
      var exp = /(\b(https?|ftp|file):\/\/([-A-Z0-9+&@#%?=~_|!:,.;]*)([-A-Z0-9+&@#%?\/=~_|!:,.;]*))/ig;

      return text.replace(exp, function(str, url) {
        if (url.match(/\.jpg|\.gif|\.jpeg|\.png/ig)) {
          return '<a href="'+url+'" target="_blank">['+$translate('Visits.view_image')+']</a>';
        } else {
          return '<a href="'+url+'" target="_blank">'+url+'</a>';
        }
      });
    }

    function getExtraFields() {
      var deferred = $q.defer();
      $http.get(EXTRA_FIELDS, {cache: cache}).success(function (response) {
        var fields = response.map(ExtraFieldDefinition.fromJson).filter(Boolean);
        fields = sortDefinition(fields);
        deferred.resolve(fields);
      }).error(function () {
        deferred.reject();
      });
      return deferred.promise;
    }

    function sortDefinition(unsortedFields) {
      return unsortedFields.sort(function compare(a, b) {
        return a.order - b.order;
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .directive('event', event);

  /** @ngInject */
  function event($state, timeUtils) {

    return {
      restrict: 'E',
      scope: {
        event: '=data',
        showdriver: '=showdriver'
      },
      templateUrl: 'app/shared/html/events-templates/base.html',
      link: function (scope, element, attrs) {
        scope.getTemplate = function () {
          scope.event.occurred_on = timeUtils.convertDateToFormatString(scope.event.occurred_on, 'HH:mm');
          return 'app/shared/html/events-templates/' + scope.event.data.type.toLowerCase() + '.html';
        };

        scope.openModal = function (visitId) {
          $state.go('tracking.events.detail', {dispatchsId: visitId}, {notify: false});
        };
      }
    };
  }

})();

(function(){
    'use strict';
    
    angular
      .module('icarus.shared')
      .factory('elementsService', elementsService);
    
    /** @ngInject */
    function elementsService () {
      return {
        "attachEvent": function (element, event, handler, scope) {
          if (!element) {
            return;
          }

          element.addEventListener(event, function(_event) {
            handler(_event);
            if(scope) {
              scope.$apply();
            }
          });
        }
      };
    }
})();
    
(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('driverService', driverService);


/** @ngInject */
function driverService($http, $q, __env, userService){
  var DRIVERS_PATH = __env.API_URL+'accounts/drivers/';

    return {
      list: list,
      getByFleet: getByFleet
    };

    function list() {
      return $http.get(DRIVERS_PATH).then(_successList, _errorList);
    }

    function getByFleet(fleetId) {
      return $http.get(DRIVERS_PATH + '?fleet=' + fleetId).then(_successList, _errorList);
    }

    function _successList(response) {
      return response.data.filter(function (driver) {
        return userService.isActiveUser(driver);
      });
    }

    function _errorList(response) {
      return $q.reject(response);
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.shared")
    .factory("codriverService", codriverService);

  function codriverService(__env, $http, userService) {
    var CODRIVERS_PATH = __env.API_URL + 'accounts/codrivers/';
    var ROUTES_CODRIVERS_PATH = __env.API_URL + 'routes/codrivers/';

    return {
      list: list,
      getPlanCodrivers: getPlanCodrivers,
      saveCodrivers: saveCodrivers
    };

    function list() {
      return $http.get(CODRIVERS_PATH)
        .then(function (response) {
          return response.data.filter(function (codriver) {
            return userService.isActiveUser(codriver);
          });
        });
    }

    function getPlanCodrivers(planId) {
      var options = {
        params: { plan: planId }
      };

      return $http.get(ROUTES_CODRIVERS_PATH, options)
        .then(function (response) {
          return response.data;
        });
    }

    function saveCodrivers(codrivers) {
      return $http.patch(ROUTES_CODRIVERS_PATH, codrivers);
    }
  }
})();

/* global angular */
/**
 * https://gist.github.com/mlynch/dd407b93ed288d499778
 *
 * the HTML5 autofocus property can be finicky when it comes to dynamically
 * loaded templates and such with AngularJS. Use this simple directive to tame
 * this beast once and for all.
 *
 * Usage:
 * <input type="text" autofocus>
 */
(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .directive('autofocus', autofocus);

  /** @ngInject */
  function autofocus ($timeout) {
    return {
      restrict: 'A',
      link: function ($scope, $element) {
        $timeout(function () {
          $element[0].focus();
        });
      }
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

    $stateProvider
      .state('settings', {
        parent: 'main',
        url: '/settings',
        controller: 'SettingsController',
        controllerAs: 'vm',
        templateUrl: 'app/settings/settings.html',
        data: {
          authentication: true
        },
        redirectTo: 'settings.users.list'
      })
      // --------------------------------------------------
      // -   Vehicles states
      .state('settings.vehicles', {
        parent: 'settings',
        abstract: true,
        url: '/vehicles',
        template: '<ui-view></ui-view>'
      })
      .state('settings.vehicles.list', {
        parent: 'settings.vehicles',
        url: '/',
        controller: 'VehiclesListController',
        controllerAs: 'vm',
        templateUrl: 'app/settings/vehicles/vehicles-list.html'
      })
      .state('settings.vehicles.create', {
        parent: 'settings.vehicles.list',
        url: 'create',
        controller: 'VehiclesDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/settings/vehicles/vehicles-detail.html'
      })
      .state('settings.vehicles.detail', {
        parent: 'settings.vehicles.list',
        url: ':vehicleId',
        controller: 'VehiclesDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/settings/vehicles/vehicles-detail.html'
      })
      // --------------------------------------------------
      // -   users states
      .state('settings.users', {
        parent: 'settings',
        abstract: true,
        url: '/users',
        template: '<ui-view></ui-view>'
      })
      .state('settings.users.list', {
        parent: 'settings.users',
        url: '/',
        controller: 'UsersListController',
        controllerAs: 'vm',
        templateUrl: 'app/settings/users/users-list.html'
      })
      .state('settings.users.create', {
        parent: 'settings.users.list',
        url: 'create',
        controller: 'UsersDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/settings/users/users-detail.html'
      })
      .state('settings.users.detail', {
        parent: 'settings.users.list',
        url: ':userId',
        controller: 'UsersDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/settings/users/users-detail.html'
      })
      // --------------------------------------------------
      // -   skills states
      .state('settings.skills', {
        parent: 'settings',
        abstract: true,
        url: '/skills',
        template: '<ui-view></ui-view>'
      })
      .state('settings.skills.list', {
        parent: 'settings.skills',
        url: '/',
        controller: 'SkillsListController',
        controllerAs: 'vm',
        templateUrl: 'app/settings/skills/skills-list.html'
      })
      // -----------------------------------------------------
      // -  general adjustments
      .state('settings.routing-options', {
        parent: 'settings',
        abstract: true,
        url: '/routing-options',
        template: '<ui-view></ui-view>'
      })
      .state('settings.routing-options.list', {
        parent: 'settings.routing-options',
        url: '/',
        controller: 'GeneralsListController',
        controllerAs: 'vm',
        templateUrl: 'app/settings/generals/generals-list.html'
      })
      // -----------------------------------------------------
      // -  mobile adjustments
      .state('settings.mobile-general', {
        parent: 'settings',
        abstract: true,
        url: '/mobile',
        template: '<ui-view></ui-view>'
      })
      .state('settings.mobile-general.list', {
        parent: 'settings.mobile-general',
        url: '/',
        controller: 'MobileGeneralsListController',
        controllerAs: 'vm',
        templateUrl: 'app/settings/mobile-general/mobile-general-list.html'
      })
      // --------------------------------------------------
      // -   account states
      .state('settings.account', {
        parent: 'settings',
        abstract: true,
        url: '/account',
        template: '<ui-view></ui-view>'
      })
      .state('settings.account.list', {
        parent: 'settings.account',
        url: '/',
        controller: 'AccountController',
        controllerAs: 'vm',
        templateUrl: 'app/settings/account/account.html'
      })
      // --------------------------------------------------
      // -   Security states
      .state('settings.security', {
        parent: 'settings',
        abstract: true,
        url: '/security',
        template: '<ui-view></ui-view>'
      })
      .state('settings.security.list', {
        parent: 'settings.security',
        url: '/',
        controller: 'SecurityController',
        controllerAs: 'sm',
        templateUrl: 'app/settings/security/security.html'
      })
      // --------------------------------------------------
      // -   Communication states
      .state('settings.communication', {
        parent: 'settings',
        abstract: true,
        url: '/communication',
        template: '<ui-view></ui-view>'
      })
      .state('settings.communication.list', {
        parent: 'settings.communication',
        url: '/',
        controller: 'CommunicationController',
        controllerAs: 'vm',
        templateUrl: 'app/settings/communication/communication.html'
      })
      .state('settings.communication.detail', {
        parent: 'settings.communication.list',
        url: ':addonId/:addonPropertyKey',
        controller: 'CommunicationDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/settings/communication/communication-detail.html'
      })
      // --------------------------------------------------
      // -   Zones states
      .state('settings.zones', {
        parent: 'settings',
        abstract: true,
        url: '/zones',
        template: '<ui-view></ui-view>'
      })
      .state('settings.zones.list', {
        parent: 'settings.zones',
        url: '/',
        controller: 'ZonesController',
        controllerAs: 'vm',
        templateUrl: 'app/settings/zones/zones.html'
      })

      // --------------------------------------------------
      // -   Fleets states
      .state('settings.fleets', {
        parent: 'settings',
        abstract: true,
        url: '/fleets',
        template: '<ui-view></ui-view>'
      })
      .state('settings.fleets.list', {
        parent: 'settings.fleets',
        url: '/',
        controller: 'FleetsController',
        controllerAs: 'vm',
        templateUrl: 'app/settings/fleets/fleets.html'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {

    $translateProvider.translations('es', {
      'settings': 'Ajustes',
      'users': 'Usuarios',
      'vehicles': 'Vehículos',
      'skills': 'Habilidades',
      'generals': 'Opciones de ruteo',
      'account': 'Ajustes de cuenta',
      'mobile': 'App móvil',
      'security': ' Seguridad',
      'communications': 'Comunicaciones',
      'whatsAppPro': 'WhatsApp Pro',
      'zones': 'Zonas',
      'total': 'Total',
      'fleets': 'Flotas',
      'optimizers': 'Creación de rutas',
      'customization': 'Personalización',
      "customizationMain": "Principal",
      'customizationLivetracking': 'Livetracking',
      'automations': 'Automatizaciones',
      'usersDetails': 'Detalle',
      'usersRoles': 'Roles',
      'Fleets': {
        'name': 'Nombre de flotas',
        'no_fleets': 'No se han creado flotas',
        'vehicles': 'Vehículos',
        'users': 'Usuarios',
        'no_vehicles': 'No tienes vehículos',
        'create_vehicle': 'Crear vehículo',
        'create_user': 'Crear usuario',
        'fleet_panel_title': 'Este es tu panel de flotas',
        'fleet_panel_description': 'Las flotas son agrupaciones de vehículos. <br> Permiten que tus usuarios solo vean los vehículos pertinentes a tu operación.',
        'fleet_name_placeholder': 'Nombre de la nueva flota',
        'add': 'Agregar',
        'save': 'Guardar',
        'create_fleet_success_msg': 'Flota creada exitosamente',
        'create_fleet_error_msg': 'Ocurrió un problema al intentar crear la flota',
        'create_fleet_duplicate_name_error_msg': 'Ya existe una flota con este nombre',
        'delete_confirmation_title': 'Eliminar flota',
        'delete_confirmation_continue': '¿Deseas continuar?',
        'delete_confirmation_cancel': 'Cancelar',
        'delete_confirmation_delete': 'Eliminar',
        'delete_fleet_success_msg': 'Flota eliminada exitosamente',
        'delete_fleet_error_msg': 'Ocurrió un problema al intentar eliminar la flota',
        'cancel': 'Cancelar',
        'update_fleet_success_msg': 'Flota actualizada exitosamente',
        'update_fleet_error_default': 'Ocurrió un problema al intentar actualizar la flota',
        'update_fleet_error_not_exist_msg': 'La flota que se intenta actualizar no existe',
        'update_fleet_error_vehicles_not_exists_msg': 'Hay vehículos asignados que no existen',
        'update_fleet_error_duplicated_name_msg': 'Ya existe una flota con este nombre',
        'tooltips': {
          'add': 'En el módulo de Flotas, puedes agrupar tus vehículos y asignarlos a distintos usuarios. Éstos solo podrán tener acceso a aquellas flotas que les hayan sido asignadas.'
        }
      },
      'Settings': {
        'account': 'Cuenta',
        'billing': 'Facturación',
        'vehicles': 'Vehículos',
        'users': 'Conductores',
        'required': 'Requerido',
        'optional': 'Opcional',
        'first_text': 'Primero',
        'last_text': 'Último',
        'next_text': 'Siguiente',
        'previous_text': 'Anterior'
      },
      'Users': {
        'type_1': 'Conductor',
        'type_2': 'Administrador',
        'type_3': 'Propietario',
        'type_4': 'Monitor',
        'type_5': 'Coordinador',
        'type_6': 'Ruteador',
        'type_7': 'Ruteador Jr',
        'type_8': 'Copiloto',
        'type_9': 'Monitor Coordinador',
        'without_drivers_1': 'No se han creado usuarios <br>',
        'without_drivers_2': ' haz <br>',
        'without_drivers_3': ' clic <br>',
        'without_drivers_4': 'aquí para crear uno.',

        'just_admin_user_1': 'No se han creado usuarios conductores',
        'just_admin_user_2': ' haz <br>',
        'just_admin_user_3': ' clic <br>',
        'just_admin_user_4': 'aquí para crear uno.',

        'title': 'Configuración de conductores',
        'noUsersTitle': 'Sin conductores',
        'noUsers': 'No existen conductores',
        'createUser': 'Crear conductor',
        'btn_more_info': 'Información opcional',
        'name_table_header': 'Nombre* (obligatorio)',
        'name_table_header_comment': 'Nombre para identificar al usuario',
        'role_table_header': 'Rol* (obligatorio)',
        'role_table_header_comment': 'admin / router / routerjr / monitor / coordinator / coordinator-monitor / driver / copilot',
        'phone_table_header': 'Teléfono (opcional)',
        'email_table_header': 'Email (opcional)',
        'username_table_header': 'Nombre de usuario* (obligatorio)',
        'username_table_header_comment': 'Debe ser único entre los usuarios',
        'password_table_header': 'Contraseña* (obligatorio)',
        'password_table_header_comment': 'Considerar política de seguridad de contraseñas configurada en plataforma',
        'btn_bulk_upload': 'Cargar archivo',
        'btn_bulk_download': 'Descargar listado',
        'btn_bulk_create': 'Creación masiva',
        'btn_bulk_update': 'Edición masiva',
        'btn_bulk_template_download': 'Descargar plantilla'
      },

      'Vehicles': {
        'modal_title_upgrade_plan': 'Llegaste al límite de tu cuenta',
        'modal_content_upgrade_plan': 'Ya tienes @:vehicles_created vehículos creados. Contáctate con nosotros para aumentar tu capacidad de cuenta y crear más vehículos.',
        'contact_us': 'Contáctanos',
        'without_vehicle_1': 'Este es tu panel de vehículos',
        'without_vehicle_2': 'En estos momentos no tienes vehículos creados. Haz clic en el botón ',
        'without_vehicle_3': ' Nuevo vehículo',
        'without_vehicle_4': ' y comienza a construír tu flota.',
        'without_vehicle_searching' : 'No se encontraron vehículos con los criterios de búsqueda indicados',
        'title': 'Configuración de vehículos',
        'no_vehicles': 'Sin vehículos',
        'no_vehicles_msg_1': 'No existen vehículos.',
        'no_vehicles_msg_2': 'Crear vehículo',
        'head_title': 'Información del vehículo',
        'error_name_vehicle_required': 'Nombre del vehículo requerido',
        'error_name_required': 'Por favor ingresa un nombre',
        'error_name_duplicated': 'El nombre del vehículo ya existe',
        'error_capacity_required': 'Por favor ingresa una capacidad',
        'error_name_duplicated_deleted': 'El nombre de este vehículo ya fue utilizado',
        'error_capacity_min': 'La capacidad debe ser mayor a cero',
        'error_limit_capacity': 'La capacidad de carga del vehículo es muy alta',
        'error_address_origin': 'Por favor ingresa una dirección de origen',
        'error_coordinate_pattern': 'Las coordenadas deben ser números válidos',
        'error_address_end': 'Por favor ingresa una dirección de destino',
        'without_drivers_1': 'No hay conductores disponibles, por favor',
        'without_drivers_2': 'haz clic aquí',
        'without_drivers_3': 'para crear conductores',
        'without_skill_1': 'No hay habilidades registradas, ',
        'without_skill_2': 'haz clic aquí',
        'without_skill_3': 'para crear habilidades',
        'save': 'Guardar',
        'cancel': 'Cancelar',
        'new_vehicle_btn': 'Nuevo vehículo',
        'import': 'Importar',
        'title_table_header': 'Nombre* (Obligatorio)',
        'title_table_header_comment': 'Nombre para identificar el vehículo',
        'capacity_table_header': 'Capacidad Máxima* (obligatorio)',
        'capacity_table_header_comment': 'Cantidad de productos, peso o carga que este vehículo puede llevar como máximo',
        'reference_id_table_header': 'ID referencia (opcional)',
        'capacity_2_table_header': 'Capacidad 2 (opcional)',
        'capacity_3_table_header': 'Capacidad 3 (opcional)',
        'origin_table_header': 'Dirección de origen* (Obligatorio)',
        'origin_table_header_comment': 'Dirección de inicio de la ruta del vehículo',
        'destination_table_header': 'Dirección de destino (opcional)',
        'driver_table_header': 'Conductor (opcional)',
        'shift_start_table_header': 'Inicio de turno (opcional)',
        'shift_end_table_header'  : 'Fin de turno (opcional)',
        'cost_table_header': 'Costo (opcional)',
        'max_visit_table_header': 'Máximo de visitas (opcional)',
        'min_load_table_header': '% Carga mínima (opcional)',
        'min_load_2_table_header': '% Carga mínima 2 (opcional)',
        'min_load_3_table_header': '% Carga mínima 3 (opcional)',
        'origin_latitude_table_header':'Latitud de origen (opcional)',
        'origin_longitude_table_header':'Longitud de origen (opcional)',
        'destination_latitude_table_header':'Latitud de destino (opcional)',
        'destination_longitude_table_header': 'Longitud de destino (opcional)',
        'location_start_latitude':'Latitud de origen',
        'location_start_longitude':'Longitud de origen',
        'location_end_latitude':'Latitud de destino',
        'location_end_longitude': 'Longitud de destino',
        'skills_table_header'  : 'Habilidades (opcional)',
        'rest_time_start_table_header': 'Hora inicio descanso (opcional)',
        'rest_time_end_table_header': 'Hora fin descanso (opcional)',
        'rest_time_duration_table_header': 'Duración en minutos descanso (opcional)',
        'max_time_header': 'Tiempo de operación (opcional)',
        'edit': 'Editar',
        'previous': 'Anterior',
        'next': 'Siguiente',
        'title_lbl': 'Nombre*',
        'capacity_lbl': 'Capacidad máxima*',
        'origin_lbl': 'Dirección de origen',
        'use_address_detination': 'Usar dirección de origen como dirección de destino',
        'destination_lbl': 'Dirección de destino',
        'driver_lbl': 'Conductor',
        'codrivers_lbl': 'Copilotos',
        'select_driver': '--Seleccionar conductor--',
        'skills_lbl': 'Habilidades',
        'close': 'Cerrar',
        'delete_vehicle': 'Eliminar vehículo',
        'cannot_delete_description_vehicle': 'Este vehículo pertenece a planes actualmente en curso o planificados: ',
        'cannot_delete_description_2_vehicle': 'Debes completar dichos planes o quitar el vehículo de estos.',
        'irreversible_action': 'Esta acción es irreversible',
        'want_continue': '¿Deseas continuar?',
        'delete': 'Eliminar',
        'default_start_shift': 'HH:MM',
        'default_end_shift': 'HH:MM',
        'default_rest_time_end': 'HH:MM',
        'default_rest_time_start': 'HH:MM',
        'error_format_date': '* Formato de hora incorrecto -- HH:MM',
        'error_between_date': '* Hora de inicio debe ser menor a la hora final.',
        'error_empty_date': '* Por favor ingresa ambas horas.',
        'error_exceeds_rest_time_duration': 'La duración excede el rango de la ventana horaria',
        'error_empty_rest_time_duration' : 'Debe ingresar ventana horaria y duración',
        'error_invalid_duration': 'Debe ingresar un valor entre 1 y 1440 minutos.',
        'error_invalid_difference_rest_shift_start': 'Hora de inicio debe ser mayor o igual al inicio de la jornada del vehículo.',
        'error_invalid_difference_rest_shift_end': 'Hora de fin debe ser menor o igual al fin de la jornada del vehículo.',
        'error_invalid_difference_shift_rest_start': 'Hora de inicio debe ser menor o igual al inicio de la hora de descanso.',
        'error_invalid_difference_shift_rest_end': 'Hora de fin debe ser mayor o igual al fin de la hora de descanso.',
        'reference_id_lbl': 'ID referencia',
        'capacity_lbl_2': 'Capacidad 2',
        'capacity_lbl_3': 'Capacidad 3',
        'cost_lbl': 'Costo',
        'min_load': '% Carga mínima',
        'min_load_2': '% Carga mínima 2',
        'min_load_3': '% Carga mínima 3',
        'max_visit': 'Máximo de visitas',
        'max_time': 'Tiempo de operación',
        'error_max_time': 'Debe ingresar un valor entero y mayor que 0',
        'error_limit_capacity_2': 'La capacidad 2 de carga del vehículo es muy alta',
        'error_limit_capacity_3': 'La capacidad 3 de carga del vehículo es muy alta',
        'required_empty_fields_message': 'Por favor completa los campos requeridos',
        'placeholder_name_vehicle': 'Asigna un nombre a tu vehículo.',
        'placeholder_reference_id': 'OC-2910',
        'placeholder_name_capacity': '10.000',
        'placeholder_name_capacity_2': '10.000',
        'placeholder_name_capacity_3': '10.000',
        'placeholder_name_cost': '10.000',
        'placeholder_longitude': '1.000001',
        'placeholder_latitude': '-1.000001',
        'placeholder_name_min_load': '% Carga mínima: 50',
        'placeholder_name_min_load_2': '% Carga mínima 2: 30',
        'placeholder_name_min_load_3': '% Carga mínima 3: 20',
        'placeholder_name_max_visit': 'Máximo de visitas: 10',
        'placeholder_origin': 'Santa María 2670, Providencia, Santiago',
        'placeholder_end': 'Martin de Zamora 2964, Las Condes, Santiago',
        'tooltip_max_time': 'Este campo limita el tiempo de operación de un vehículo dentro de un plan. Está en minutos y sus valores deben ser números enteros mayores que 0 o puede ser dejado en blanco',
        'tooltip_capacity': 'Cantidad de productos, peso o carga que este vehículo puede llevar como máximo.',
        'tooltip_reference_id': 'Código identificador para tu vehículo. Puede ser la patente o algún otro código interno de tu negocio',
        'tooltip_capacity_2': 'Completa este campo en caso de que tengas restricciones de capacidad y quieras agregar una capacidad opcional a la primera.',
        'tooltip_schedule': 'Completa este campo si este vehículo trabaja en un horario específico distinto a tus demás vehículos.',
        'tooltip_skills': 'Características especiales del vehículo. Por ejemplo, este vehículo tiene un container de frío, o puede entrar a zonas de la ciudad que otros no pueden.',
        'tooltip_addres_origin': 'La dirección donde este vehículo comienza el día.',
        'tooltip_addres_end': 'La dirección donde este vehículo termina su día.',
        'tooltip_address': 'Se puede agregar una dirección inválida en caso de que se vaya a ingresar manualmente un par de coordenadas para esta.',
        'tooltip_coordinates': 'Actualizar las coordenadas no actualiza la dirección. Ambas coordenadas deben ser ingresadas para ser consideradas. Y deben pertenecer al país de la cuenta',
        'tooltip_driver_default': 'Completa este campo si el vehículo es manejado siempre por una misma persona.',
        'tooltip_min_load': 'Porcentaje mínimo de carga principal que el vehículo debe llevar en una ruta. Si SimpliRoute no puede asignar este porcentaje al vehículo, no se le asignarán visitas al optimizar rutas.',
        'tooltip_min_load_2': 'Porcentaje mínimo de carga 2 que el vehículo debe llevar en una ruta. Si SimpliRoute no puede asignar este porcentaje al vehículo, no se le asignarán visitas al optimizar rutas.',
        'tooltip_min_load_3': 'Porcentaje mínimo de carga 3 que el vehículo debe llevar en una ruta. Si SimpliRoute no puede asignar este porcentaje al vehículo, no se le asignarán visitas al optimizar rutas.',
        'tooltip_max_visit': 'Cantidad máxima de visitas que este vehículo puede atender en una ruta.',
        'tooltip_cost': 'Costo fijo por utilizar este vehículo. SimpliRoute tomará en cuenta este valor para privilegiar vehículos de bajo costo por sobre vehículos de costo más alto.',
        'placeholder_duration_rest_time': '60',
        'tooltip_rest_time': 'Ventana Horaria en que el conductor podrá encontrarse inactivo, ya sea por descanso, colación u otro evento.',
        'tooltip_rest_time_duration': 'Duración (en minutos) del tiempo de descanso o colación permitida para el conductor.',
        'confirm_leave': 'Atención',
        'confirm_leave_message_1': 'Perderás la información que no ha sido guardada si abandonas el formulario',
        'confirm_leave_message_2': '¿Estás seguro de abandonar?',
        'confirm_leave_close': 'Permanecer aquí',
        'confirm_leave_yes': 'Abandonar',
        'confirm_leave_message_3': 'Las habilidades es información opcional',
        'confirm_leave_message_4': 'El conductor por defecto es información opcional',
        'btn_more_loads': 'Información opcional',
        'btn_download_list': 'Descargar lista',
        'import_vehicles'  : 'Carga masiva',
        'btn_new_vehicles' : 'Nuevos vehículos',
        'btn_edit_vehicles': 'Editar vehículos',
        'longitude': 'Longitud*',
        'latitude': 'Latitud*',
        'codrivers_modal_cancel': 'Cancelar',
        'codrivers_modal_set': 'Aplicar',
        'my_vehicles': 'Mis vehículos'
      },
      'Account': {
        'options': 'Opciones',
        'btn_save': 'Guardar',
        'configs_saved_success': 'Opciones guardadas correctamente',
        'configs_saved_fail': 'Hubo un error al guardar las opciones de cuenta, por favor intenta nuevamente',
        'default_values': 'valores por defecto',
        'setupOptions': {
          'send_gps': 'Activar envío de GPS',
          'enable_observations': 'Formulário opcional ou obrigatório',
          'max_distance': 'Máximo de distancia (KM)',
          'vehicle_refill_time': 'Tiempo de recarga de vehículos (MIN)',
          'eta_range_title': 'Rango de tiempo estimado de entrega (ETA)',
          'eta_range_scheduled_visit': 'Estado programado',
          'eta_range_visit_with_route_started': 'Estado En Ruta',
          'eta_range_visit_on_its_way': 'Estado En Camino'
        },
        'tooltipsOptions': {
          'send_gps': 'Al desactivar esta opción, los celulares de tus conductores dejarán de enviar datos GPS. Desactívala solo si tienes un proveedor de GPS externo',
          'enable_observations': 'Tus conductores deberán seleccionar una observación para seguir avanzando.',
          'max_distance': 'Distancia máxima lineal en kilómetros a la que realizas visitas. Visitas más lejos de esta distancia quedarán marcadas como "Demasiado lejos de la bodega"',
          'refill_time': 'Tiempo que toma cargar tus pedidos dentro del camión entre ruta y ruta.',
          'eta_range_scheduled_visit': 'Para generar el rango de tiempo estimado de entrega (ETA) al crear la ruta.',
          'eta_range_visit_with_route_started': 'Para generar el rango de tiempo estimado de entrega (ETA) al iniciar la ruta.',
          'eta_range_visit_on_its_way': 'Para generar el rango de tiempo estimado de entrega (ETA) al ir en camino a la dirección de entrega (acción notify).'
        },
        'error_input_required': 'Campo requerido',
        'error_input_number_valid': 'Ingresa un valor numérico',
        'error_input_number_min': 'El valor mínimo es de 1 km',
        'error_input_number_max': 'El valor máximo es de 10000 km',
        'error_input_refill_min': 'El valor mínimo es de 0 min',
        'error_input_refill_max': 'El valor máximo es de 10000 min',
        'account_logo': "Logotipo",
        'import_logo': 'Sube tu logo',
        'account_logo_tooltip': 'Sube una imagen PNG de 300x120px que no exceda los 50 kbs.',
        'logo_size_error': 'La imagen no puede exceder los 50 kbs',
        'logo_dimensions_error': 'El tamaño máximo es de 300 x 120 pixeles',
        'logo_type_error': 'La imagen debe tener extensión .png'
      },
      'Drivers': {
        'driver': 'Conductor',
        'codriver': 'Copiloto',
        'user_type': 'Rol',
        'admin': 'Administrador',
        'router': 'Ruteador',
        'router_jr': 'Ruteador Jr',
        'monitoring': 'Monitor',
        'coordinator': 'Coordinador',
        'monitor_coordinator': 'Monitor Coordinador',
        'without_drivers_1': 'Este es tu panel de usuarios',
        'without_drivers_2': 'En estos momentos no tienes usuarios creados. Haz clic en el botón ',
        'without_drivers_3': 'Nuevo usuario',
        'without_drivers_4': ' para crear uno.',
        'without_user_searching': 'No se encontraron usuarios con los criterios de búsqueda indicados.',
        'new_driver_btn': 'Nuevo conductor',
        'new_driver': 'Nuevo usuario',
        'information_user': 'Información de usuario',
        'username_error': 'El nombre de usuario no debe contener espacios.',
        'email_format': 'Formato no válido.',
        'email_repeated': 'Email ya se encuentra registrado.',
        'match_password': 'Las contraseñas no coinciden, por favor intenta nuevamente',
        'error_password': 'Contraseña actual es incorrecta, por favor intenta nuevamente',
        'name_table_header': 'Nombre',
        'class_table_header': 'Clase',
        'username_table_header': 'Nombre de usuario',
        'phone_table_header': 'Teléfono',
        'email_table_header': 'Email',
        'edit': 'Editar',
        'previous': 'Anterior',
        'next': 'Siguiente',
        'import': 'Importar',
        'driver_information': 'Nombre',
        'user_lbl': 'Nombre de usuario',
        'user_exist': 'El usuario ya existe.',
        'phone_lbl': 'Teléfono',
        'email': 'Correo electrónico',
        'invalid_format': 'Formato no válido.',
        'change_password': 'Cambiar contraseña',
        'password': 'Contraseña',
        'repeat_password': 'Repetir contraseña',
        'close': 'Cerrar',
        'save': 'Guardar',
        'delete_driver': 'Eliminar conductor',
        'irreversible_action': 'Esta acción es irreversible',
        'want_continue': '¿Deseas continuar?',
        'cancel': 'Cancelar',
        'delete': 'Eliminar',
        'optional': 'Opcional',
        'required': 'Requerido',
        'name_required': 'Este campo es obligatorio',
        'username_required': 'Este campo es obligatorio',
        'password_required': 'La contraseña debe cumplir con los requisitos indicados',
        'email_required': 'Este campo es obligatorio',
        'footer_message': 'Los conductores deben descargar la aplicación móvil para poder hacer seguimiento de tus visitas y despachos.',
        'close_sessions_warning': 'Cambiar la contraseña cerrará las sesiones abiertas y deshabilitará las integraciones que usen dicho token.',
        'unlock': 'Desbloquear',
        'unlock_driver': 'Desbloquear {{name}}',
        'unlock_info': 'Las instrucciones para reestablecer el usuario y crear una nueva contraseña serán enviadas a:',
        'enter_email': 'Se requiere una dirección de correo electrónico para enviar las instrucciones para una nueva contraseña',
        'unlock_email_info': 'El correo será automáticamente guardado con los datos de usuario',
        'edit_email': 'Editar correo electrónico',
        'confirm': 'Confirmar',
        'unlock_user_success': 'Desbloqueo pendiente. Se han enviado correctamente las instrucciones.',
        'unlock_user_error': 'Ha ocurrido un error desbloqueando la cuenta, por favor intenta nuevamente.'
      },
      'Skills': {
        'add': 'Agregar',
        'edit': 'Editar',
        'name': 'Nombre',
        'cancel': 'Cancelar',
        'delete': 'Eliminar',
        'required': 'Nombre de la habilidad requerida',
        'repeated': 'Habilidad ya se encuentra registrada',
        'select_all': 'Seleccionar todos',
        'skill_holder': 'Escribe una habilidad',
        'without_skill_1': 'No se han creado habilidades.',
        'without_skill_2': 'Utiliza la barra superior para crear tu primera habilidad.',
        'empty_skills_title': 'Este es tu panel de habilidades',
        'empty_skills_paragraph': 'Las habilidades son etiquetas que puedes crear para categorizar tipos de vehículos y visitas, así podemos asignar el vehículo correcto para una visita especial.',
        'empty_skills_note': 'Ejemplo: los productos congelados son asignados al camión en frío porque ambos poseen la misma habilidad.'
      },
      'Mobile_general': {
        'mobile_section_title': 'Configuraciones',
        'mobile_checkout_form': 'Formulario check-out',
        'title_form_1': 'Nueva observación',
        'title_form_2': 'Información de la observación',
        'label': 'Nombre',
        'status': 'Tipo',
        'required': 'Requerido',
        'type': 'Estado',
        'save': 'Guardar',
        'select_observation': '--Seleccionar un estado--',
        'completed': 'Exitoso',
        'failed': 'Fallido',
        'without_observations_1': 'No hay observaciones creadas',
        'without_observations_2': 'por favor cree una.',
        'error_create_observations': 'Error creando la observación, por favor intenta nuevamente.',
        'delete_observation': 'Eliminar observación',
        'irreversible_action': 'Esta acción es irreversible',
        'want_continue': '¿Deseas continuar?',
        'cancel': 'Cancelar',
        'delete': 'Eliminar',
        'error_duplicated_observations': 'La observación ya se encuentra registrada',
        'Accounts_settings': {
          'enable_observations': 'Activar obligación de observaciones',
          'error_save_configs': 'Hubo un error al guardar la configuración, por favor intenta nuevamente.',
          'enable_observations_message': "Tus conductores deberán escoger una observación para seguir avanzando.",
          'checkout_similars': 'Agrupar visitas en app móvil',
          'checkout_similars_message': 'Habilita esta opción para que tus conductores marquen todas las visitas similares con un solo clic en la app móvil.',
          'enable_signature': 'Firma digital',
          'enable_signature_message': 'Permite que tus clientes firmen la entrega de su pedido directamente en el celular de tus conductores.',
          'mandatory_checkout_picture': 'Fotografía obligatoria',
          'mandatory_checkout_picture_message': 'Tus conductores deberán adjuntar una fotografía para finalizar sus visitas.',
          'mandatory_success_checkout_picture': 'Visita exitosa',
          'mandatory_failed_checkout_picture': 'Visita fallida'
        }
      },
      'Log_report': {
        'edition': 'Reporte de Log en edición y eliminación de planes',
        'select_client': 'Seleccione un cliente',
        "client_required": "*Cliente es requerido"
      },
      'General': {
        'reports': 'Reportes',
        'optimization': 'Optimización',
        'report_from': 'Desde',
        'report_to': 'Hasta',
        'export': 'Exportar',
        'routes_report': 'Reporte de rutas',
        'visits_report': 'Reporte de visitas',
        'historical_checkout_report': 'Reporte histórico de visitas',
        'excel_name': 'Reporte_',
        'excel_headers_id': 'ID',
        'excel_headers_reference_id': 'ID de referencia',
        'excel_headers_planned_date': 'Fecha planificada',
        'excel_headers_driver': 'Conductor',
        'excel_headers_vehicle': 'Vehículo',
        'excel_headers_title': 'Título',
        'excel_headers_address': 'Dirección',
        'excel_headers_eta': 'ETA',
        'excel_headers_etd': 'ETD',
        'excel_headers_checkin_time': 'Check in',
        'excel_headers_checkout_time': 'Check out',
        'excel_headers_time_service': 'Tiempo de servicio',
        'excel_headers_time_advance': 'Anticipo',
        'excel_headers_time_delay': 'Atraso',
        'excel_headers_latitude': 'Latitud',
        'excel_headers_longitude': 'Longitud',
        'excel_headers_checkout_lat': 'Check out latitud',
        'excel_headers_checkout_lng': 'Check out longitud',
        'excel_headers_load': 'Carga',
        'excel_headers_status': 'Estado',
        'excel_headers_comment': 'Comentarios',
        'excel_headers_observation': 'Observaciones',
        'excel_headers_time_windowStart': 'Inicio de ventana horaria 1',
        'excel_headers_time_windowEnd': 'Final de ventana horaria 1 ',
        'excel_headers_time_windowStart2': 'Inicio de ventana horaria 2',
        'excel_headers_time_windowEnd2': 'Final de ventana horaria 2',
        'excel_headers_load_2': 'Carga 2',
        'excel_headers_load_3': 'Carga 3',
        'excel_headers_skills_required': 'Habilidades requeridas',
        'excel_headers_skills_optional': 'Habilidades opcionales',
        'optimization.all_vehicles': 'Minimizar vehículos',
        'optimization.balance': 'Balancear',
        'optimization.open_start': 'Rutas con inicio abierto',
        'optimization.open_ended': 'Rutas con final abierto',
        'optimization.join': 'Unir similares',
        'optimization.join_v2': 'Unir similares 2.0',
        'optimization.last_position_optimize': 'Usar posición actual',
        'optimization.displayed_options': 'Visualizar en menú',
        'optimization.default_values': 'Valores por defecto',
        'optimization.fmv': 'Factor de tráfico',
        'optimization.fmv.high': 'Lento',
        'optimization.fmv.normal': 'Normal',
        'optimization.fmv.low': 'Rápido',
        'optimization.single_tour' : 'Una ruta por vehículo',
        'optimization.beauty': 'SimpliFy',
        'optimization.big_vrp': 'Big VRP',
        'optimization.use_euclidean_distance': 'Distancia Euclidiana',
        'optimization.enable_graphs': 'Grafos',
        'optimization.auto_reorder': 'Auto Reordenar',
        'optimization.enable_soft_window': 'Ventanas horarias suaves',
        'optimization.distance_to_join_visits': 'Unir visitas por distancia',
        'saving': 'Guardando',
        'notes': 'Notas',
        'error_between_dates': '* El rango de fechas no puede superar los 31 días',
        'error_date_start': '* La fecha inicial es mayor a la fecha final',
        'tracking_codes_visits_report': 'Reporte de visitas',
        'excel_tracking_codes_name': 'Reporte_tracking_codes_',
        'TC_REPORT': {
          'tracking_id': 'Tracking ID',
          'planned_date': 'Fecha planeada',
          'title': 'Título',
          'address': 'Dirección',
          'window_start': 'Inicio de ventana horaria 1',
          'window_end': 'Final de ventana horaria 1 ',
          'window_start_2': 'Inicio de ventana horaria 2',
          'window_end_2': 'Final de ventana horaria 2',
          'comment': 'Comentarios',
          'contact_name': 'Persona de contacto',
          'contact_phone': 'Teléfono de contacto',
          'contact_email': 'Correo electrónico de contacto',
          'reference': 'ID de referencia',
          'time_service': 'Tiempo de servicio calculado',
          'visit_checking' : 'Check in',
          'report_tc_success': 'Estamos generando tu reporte. Lo enviaremos a tu correo electrónico.',
          'report_tc_error': 'Hubo un error generando tu reporte.'
        },
        'optimization_requests_report': 'Reporte de llamadas al servicio de optimización',
        'visit_images_title_report': 'Reporte de imágenes de visitas',
        'visit_images_name_picture': 'Nombre de la foto',
        'visit_images_select_option': 'Selecciona una opción',
        'visit_images_select_id_reference': 'ID de referencia',
        'visit_images_select_title_visit': 'Título de la visita',
        'visit_images_toast_content_success': 'Estamos generando tu reporte. Lo enviaremos a tu correo electrónico.',
        'visit_images_toast_content_wait_report': 'Debes esperar a que termine de ejecutarse el último reporte.',
        'visit_images_toast_content_error_report': 'Ocurrió un error inesperado.',
        'visit_images_toast_content_no_images_found': 'No hay imágenes en el rango de fechas seleccionado.',
        'visit_images_toast_max_images_reached': 'El rango de fechas seleccionado no permite generar el reporte. Debe seleccionar un rango de fechas menor.',
        'error_creating_report': 'Error al generar el reporte',
        'RK_REPORT': {
          'date': 'Fecha',
          'plan_name': 'Nombre de plan',
          'vehicle_name': 'Nombre de vehiculo',
          'real_kms': 'Kilómetros reales',
          'total_dispatchs': 'Visitas totales',
          'pending_dispatchs': 'Visitas pendientes',
          'completed_dispatchs': 'Visitas completadas',
          'failed_dispatchs': 'Visitas fallidas',
          'start_time': 'Hora inicio ruta',
          'end_time': 'Hora término ruta'
        },
        'save_changes': 'Guardar cambios',
        'optimization.parameters': 'Parámetros de optimización',
        'optimization.parameters.slow': 'Lento',
        'optimization.parameters.fast': 'Rápido',
        'optimization.parameters.traffic_factor': 'Factor de tráfico',
        'optimization.parameters.beauty_factor': 'Nivel de zonificación',
        'optimization.parameters.beauty_min': 'Menos zonificado',
        'optimization.parameters.beauty_max': 'Más zonificado',
        'tracking_code_user_email': 'Email destinatario',
        'optimization.tooltip': {
          'traffic_factor': 'Esta barra permite configurar la velocidad de desplazamiento entre las visitas que se tiene en cuenta a la hora de crear rutas. Ajustala solo si consideras que los tiempos de traslado calculados no se ajustan a tu flota',
          'balance': 'Al optimizar se usarán todos los vehículos activos y se les asignará una cantidad equilibrada de visitas',
          'all_vehicles': 'Se usará la menor cantidad de vehículos posible para atender las visitas ingresadas a plataforma',
          'open_start': 'Tus rutas comenzarán en la primera parada y no necesariamente en el depósito.',
          'open_ended': 'Tus rutas finalizarán en la última parada y no necesariamente en el depósito.',
          'join': 'Si tienes más de una visita con la misma dirección, la plataforma las considerará como una sola visita al optimizar',
          'join_v2': 'Si tienes más de una visita con la misma dirección, la plataforma las considerará como una sola visita al optimizar. Se dividirán las visitas si éstas sobrepasan el máximo de carga de los vehículos',
          'single_tour': 'La creación de rutas puede considerar más de una salida por vehículo. Al activar esta opción indicarás a la plataforma que deseas programar una sola salida por vehículo',
          'beauty': 'Algoritmo que entrega respuestas más zonificadas',
          'beauty_factor': 'Define qué tan zonificada es la respuesta del algoritmo SimpliFy',
          'big_vrp': 'Algoritmo resuelve problemas grandes de más de 1000 visitas',
          'use_euclidean_distance': 'Utiliza un promedio entre distancia euclidiana (en línea recta) y distancias obtenidas del mapa, permite una mejor representación del espacio.',
          'enable_graphs': 'Estructura de grafos para agilizar la optimización, permitiendo también rutas más compactas.',
          'auto_reorder': 'Se vuelven a optimizar las rutas para lograr un mejor orden y compacidad de estas.',
          'enable_soft_window': 'Se podrá romper las ventanas horarias de las visitas para incluir más visitas en las rutas.',
          'on_foot': 'Si tu flota son peatones, selecciona esta optimización',
          'wave_routing': 'Ruteará por oleajes con estimación de demanda',
          'distance_to_join_visits': 'Las visitas que estén a un radio menor o igual al definido serán asignadas de forma ' +
            'consecutiva en la ruta.',
          'radial_default': 'Tu ruta más óptima en distancia/tiempo, acorta tiempos de viaje desde y hacia tu depósito',
          'radial_to_near': 'Tu ruta iniciará en el punto más lejano y terminará en el más cercano a tu depósito',
          'radial_to_far': 'Tu ruta iniciará en el punto más cercano y terminará en el más lejano a tu depósito',
          'avoid_tolls': 'Tus rutas evitarán el tránsito por autopistas o avenidas con pago de peajes.',
          'maximize_attended_load': 'Se priorizarán las visitas con mayor carga 1. De ser necesario quedarán fuera aquellas de menor carga.',
          'prioritize_load': 'Ordena la ruta priorizando primero las visitas con mayor carga, considerando las restricciones de ventana horaria.',
          'one_seller_per_vehicle': 'Cada vehículo solo incluirá visitas de un mismo seller. Las rutas no combinarán visitas de distintos sellers.'
        },
        'optimization.distance_to_join_visits_input': {
          'title': 'Configurar radio (metros)*',
          'placeholder': 'Ingresar un valor entre 0 y 100 metros',
          'error_required': 'Debes ingresar un valor entero entre 0 a 100 metros',
          'error_max_value': 'Valor ingresado supera rango de distancia'
        }
      },
      'Toast_skill': {
        'unselected_skill': 'Debes seleccionar al menos una habilidad'
      },
      'Toast_vehicles': {
        'plan_vehicle_exceeded': 'Hubo un problema al crear vehículos. Intentaste crear @:vehicle_excel_quantity vehículos pero te quedan @:vehicle_available_create de @:vehicle_total_plan.',
        'error_path_skills': 'Hubo problemas al consultar las habilidades',
        'error_path_drivers': 'Hubo problemas al consultar los conductores',
        'error_path_vehicles': 'Hubo problemas al consultar los vehículos',
        'vehicle_not_found': 'Vehículo no encontrado',
        'error_set_position_marker': 'No se pudo obtener la ubicación, por favor intenta nuevamente.',
        'error_set_address': 'La dirección introducida no es correcta, por favor intenta con otra.',
        'error_set_address_origin_country': 'La dirección de origen está en un país diferente al de tu configuración de cuenta.',
        'error_set_address_destiny_country': 'La dirección de destino está en un país diferente al de tu configuración de cuenta.',
        'error_set_address_origin_latlng0': 'Dirección de origen incorrecta, por favor intenta con otra.',
        'error_set_address_destiny_latlng0': 'Dirección de destino incorrecta, por favor intenta con otra.',
        'can_create_routes': '¡Ya puedes ir a crear rutas!',
        'error_invalid_address_1'        : 'La dirección',
        'error_invalid_address_2'        : 'no existe',
        'success_import_vehicles'        : 'Los vehículos han sido importados correctamente',
        'error_empty_vehicles_list'      : 'Lista de vehículos vacía',
        'error_driver_not_found_1'       : 'El conductor',
        'error_driver_not_found_2'       : 'no se encuentra registrado',
        'error_data_format'             :   'El archivo que subiste no está en el formato correcto. Por favor corrige e intenta nuevamente',
        'error_duplicate_vehicle_name_1'  : 'El nombre de vehículo',
        'error_duplicate_vehicle_name_2'  : 'ya existe',
        'error_import'                    : 'Hubo problemas para importar los vehículos. Por favor, asegura que los datos están correctos',
        'invalid_vehicles_ids'            : 'Algunos IDs de vehículos no son válidos. Por favor asegura que los vehículos existen e intenta nuevamente',
        'invalid_max_time'                : 'Tiempo de operación: Debe ingresar un valor entero y mayor que 0 para @:vehicle.',
        'codrivers_retrieval_error'       : 'Hubo problemas al obtener copilotos, por favor intenta nuevamente'
      },
      'Toast_users': {
        'no_users_error': 'Lista de usuarios vacía',
        'successful_import': 'Los usuarios han sido importados correctamente',
        'invalid_id_error': 'Algunos IDs de usuarios no son válidos. Por favor, verifica que los usuarios existen e intenta nuevamente',
        'data_format_error': 'El archivo que subiste no está en el formato correcto. Por favor, revísalo e intenta nuevamente',
        'duplicate_username_error_1': 'El nombre de usuario',
        'duplicate_username_error_2': 'ya existe',
        'duplicate_email_error_1': 'El email',
        'duplicate_email_error_2': 'ya existe',
        'unsuccessful_import': 'Hubo problemas para importar los usuarios. Por favor asegúrate de que los datos están correctos'
      },
      'Security':{
        'title'                    : 'Parámetros de seguridad para contraseñas',
        'subtitle_web'             : 'Usuarios web',
        'subtitle_mobile'          : 'Usuarios móvil',
        'description_web'          : 'Estos parámetros se aplicarán a todos los usuarios que utilicen los módulos de la aplicación web (Route Designer, Seguimiento, etc)',
        'description_mobile'       : 'Estos parámetros se aplicarán a todos los usuarios que utilicen la aplicación móvil (conductores, copilotos)',
        'should_uppercase'         : 'Incluir al menos una mayúscula',
        'should_lowercase'         : 'Incluir al menos una minúscula',
        'should_numeric'           : 'Incluir al menos un número',
        'should_non_alphanumeric'  : 'Incluir al menos un caracter especial (no alfanumérico)',
        'should_min_length'        : 'Longitud mínima de caracteres',
        'default_min_length'       : '(Mínimo obligatorio 8)',
        'save'                     : 'Guardar',
        'error_message'            : 'Ha ocurrido un error guardando la configuración, por favor intenta nuevamente.',
        'successful_message'       : 'Configuración guardada exitosamente.',
        'invalid_password_length'  : 'Número debe ser mayor o igual a 8',
        'settings_retrieval_error' : 'Ocurrió un error cargando la configuración de contraseñas, por favor intenta nuevamente.',
        'password_expiration'      : 'Periodo de caducidad de contraseñas',
        'password_expiration_unit' : '(en días)',
        'invalid_password_renewal_value': 'Debe seleccionar una opción válida',
        'password_expiration_disabled'     : 'Nunca',
        'idle_title'               : 'Cierre de sesión automático',
        'idle_config'              : 'Cerrar sesión automáticamente luego de',
        'idle_description'         : 'Esta configuración sólo aplica para sesiones de la aplicación web',
        'idle_15'                  : '15 minutos',
        'idle_30'                  : '30 minutos',
        'idle_45'                  : '45 minutos',
        'idle_60'                  : '1 hora',
        'idle_120'                 : '2 horas',
        'idle_180'                 : '3 horas',
        'idle_240'                 : '4 horas'
      },
      'Communication': {
        'title': 'notificaciones al cliente final',
        'title_detail': 'Mensaje al cliente final',
        'delete_property_sms': 'Borrar SMS',
        'delete_property_wsp': 'Borrar Whatsapp',
        'label_sms': 'Mensaje',
        'warning_text_too_large': 'El contenido del mensaje es demasiado largo',
        'warning_maxlength': 'Texto demasiado largo',
        'warning_required': 'Campo requerido',
        'preview_title': 'Previsualización del mensaje',
        'close': 'Cerrar',
        'cancel': 'Cancelar',
        'save': 'Guardar',
        'delete': 'Eliminar',
        'modal_delete_event_title': 'Eliminar evento',
        'modal_message_1': 'Esta acción es irreversible',
        'modal_message_2': '¿Deseas continuar?',
        'visit_scheduled': 'Pedido programado',
        'route_started': 'Pedido en ruta',
        'checkout_success': 'Pedido exitoso',
        'checkout_failed': 'Pedido fallido',
        'on_its_way': 'En camino',
        'insert': 'Insertar',
        'rendering_type': 'Tipo',
        'insert_extrafields': 'Insertar campos adicionales',
        'delete_property_email': 'Borrar EMAIL',
        'label_email_subject': 'asunto',
        'label_email_msg': 'mensaje',
        'comments': 'Comentarios',
        'attachment': 'Adjuntar fotos',
        'attachment_tooltip': 'Adjunta al email las fotos tomadas por el conductor cuando realizó la visita al lugar',
        'id_reference': 'ID-REF-123',
        'signature_link': 'Firma',
        'timeline': 'Línea de tiempo',
        'checkout_status_pdf': 'Estado del checkout como PDF',
        'items_table': 'Tabla de items',
        'warning_repeated_tag': 'Ya existe la etiqueta en el asunto',
        'livetracking_widget': 'Livetracking widget',
        'generate_insertion_code': 'Generar código de inserción',
        'insertion_code': 'Código de inserción',
        'copy_code': 'Copiar código',
        'search': 'Buscar',
        'custom_tracking_code': 'Usar ID de visita como código de seguimiento',
        'custom_tracking_code_tooltip': 'Al usar esta opción, Live Tracking usará el texto que ingreses en cada visita en el campo "ID de referencia". Debes asegurarte que ese campo sea único y que no contenga caracteres extraños',
        'visit_title': 'Título de la visita',
        'visit_address': 'Dirección de la visita',
        'visit_observation': 'Motivos de la visita',
        'eta_range': 'Horario de llegada',
        'delivery_time_range_label': 'Rango horario de entrega',
        'delivery_time_range_preview': 'Horario AM',
        'from_name' : 'Nombre del remitente',
        'from_email' : 'Email del remitente',
        'success_msg' : 'Cambio realizado exitosamente',
        'visit_date_label' : 'Fecha de la visita',
        'visit_date_preview' : '10-12-2021',
        'send_preview_email': 'Enviar correo de prueba a: ',
        'preview_email_label': 'Ingresar correo',
        'preview_email_success': 'Enviado',
        'preview_email_failed': 'Envío fallido, intenta nuevamente',
        'preview_email_activate': 'Active su cuenta para habilitar el envío de correos de prueba',
        'preview_email_buttom': 'Enviar correo de prueba',
        'error_email_length_message'    : 'Uno de los correos es demasiado largo',
        'error_max_emails_message_1'    : 'Puedes añadir',
        'error_max_emails_message_2'    : 'correos como máximo',
        'msg_error_email_valid'   : '* email formato inválido',
        'user_checkout_label' : 'Autor del checkout',
        'wsp_title': 'Selecciona el mensaje de Whatsapp que mejor se adapte a tu operación',
        'wsp_orders': 'Pedidos',
        'wsp_services': 'Servicios',
        'wsp_visits': 'Visitas',
        'wsp': {
          'visit_scheduled': {
            'orders': {
              'template1': 'Tu pedido de {ACCOUNT_NAME} ha sido programado. Síguelo en {TRACKING_URL}',
              'template2': 'Tu pedido de {ACCOUNT_NAME} ha sido programado y será entregado en {VISIT_ADDRESS}. Síguelo en {TRACKING_URL}'
            },
            'services': {
              'template1': 'Hola {VISIT_TITLE}, tu servicio {ID_REFERENCE} ha sido programado y será realizado en {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su progreso.',
              'template2': 'Tu servicio de {ACCOUNT_NAME} ya fue programado y será entregado en {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su progreso.',
              'template3': 'Hola {ID_REFERENCE}, tu servicio {VISIT_TITLE} ha sido programado y será realizado en {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su progreso.'
            },
            'visits': {
              'template1': 'Tu visita de {ACCOUNT_NAME} ha sido programada y será realizada en {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su progreso.',
              'template2': 'Hola {VISIT_TITLE}, tu visita {ID_REFERENCE} ha sido programada y será realizada en {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su progreso.',
              'template3': 'Hola {ID_REFERENCE}, tu visita {VISIT_TITLE} ha sido programada y será realizada en {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su progreso.'
            }
          },
          'route_started': {
            'orders': {
              'template1': 'Tu pedido de {ACCOUNT_NAME} ya está en ruta. La hora estimada de llegada es {ETA_RANGE}. Síguelo en {TRACKING_URL}',
              'template2': 'Tu pedido de {ACCOUNT_NAME} ya está en ruta y será entregado en {VISIT_ADDRESS}. La hora estimada de llegada es {ETA_RANGE}. Síguelo en {TRACKING_URL}',
              'template3': 'Tu pedido de {ACCOUNT_NAME} ya está en ruta. Síguelo en {TRACKING_URL}',
              'template4': 'Tu pedido de {ACCOUNT_NAME} ya está en ruta y será entregado en {VISIT_ADDRESS}. Síguelo en {TRACKING_URL}'
            },
            'services': {
              'template1': 'Tu servicio de {ACCOUNT_NAME} llegará hoy a {VISIT_ADDRESS}. La hora estimada de llegada es {ETA_RANGE}. Sigue aquí {TRACKING_URL} su ruta.',
              'template2': 'Tu servicio de {ACCOUNT_NAME} llegará hoy a {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su ruta.',
              'template3': 'Tu servicio de {ID_REFERENCE} llegará hoy a {VISIT_ADDRESS}. La hora estimada de llegada es {ETA_RANGE}. Sigue aquí {TRACKING_URL} su ruta.',
              'template4': 'Tu servicio de {ID_REFERENCE} llegará hoy a {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su ruta.',
              'template5': 'Tu servicio de {VISIT_TITLE} llegará hoy a {VISIT_ADDRESS}. La hora estimada de llegada es {ETA_RANGE}. Sigue aquí {TRACKING_URL} su ruta.',
              'template6': 'Tu servicio de {VISIT_TITLE} llegará hoy a {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su ruta.'
            },
            'visits': {
              'template1': 'Tu visita de {ACCOUNT_NAME} llegará hoy a {VISIT_ADDRESS}. La hora estimada de llegada es {ETA_RANGE}. Sigue aquí {TRACKING_URL} su ruta.',
              'template2': 'Tu visita de {ACCOUNT_NAME} llegará hoy a {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su ruta.',
              'template3': 'Tu visita de {ID_REFERENCE} llegará hoy a {VISIT_ADDRESS}. La hora estimada de llegada es {ETA_RANGE}. Sigue aquí {TRACKING_URL} su ruta.',
              'template4': 'Tu visita de {ID_REFERENCE} llegará hoy a {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su ruta.',
              'template5': 'Tu visita de {VISIT_TITLE} llegará hoy a {VISIT_ADDRESS}. La hora estimada de llegada es {ETA_RANGE}. Sigue aquí {TRACKING_URL} su ruta.',
              'template6': 'Tu visita de {VISIT_TITLE} llegará hoy a {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su ruta.'
            }
          },
          'checkout_success':{
            'orders': {
              'template1': 'Tu pedido de {ACCOUNT_NAME} fue entregado con éxito. Revisa los detalles en {TRACKING_URL}',
              'template2': 'Tu pedido de {ACCOUNT_NAME} fue entregado con éxito en {VISIT_ADDRESS}. Revisa los detalles en {TRACKING_URL}'
            },
            'services': {
              'template1': 'Tu servicio de {ACCOUNT_NAME} fue realizado con éxito. Revisa aquí {TRACKING_URL} los detalles.',
              'template2': 'Tu servicio de {ACCOUNT_NAME} fue realizado con éxito en {VISIT_ADDRESS}. Revisa aquí {TRACKING_URL} los detalles.',
              'template3': 'Tu servicio de {ID_REFERENCE} fue realizado con éxito. Revisa aquí {TRACKING_URL} los detalles.',
              'template4': 'Tu servicio de {ID_REFERENCE} fue realizado con éxito en {VISIT_ADDRESS}. Revisa aquí {TRACKING_URL} los detalles.',
              'template5': 'Tu servicio de {VISIT_TITLE} fue realizado con éxito. Revisa aquí {TRACKING_URL} los detalles.',
              'template6': 'Tu servicio de {VISIT_TITLE} fue realizado con éxito en {VISIT_ADDRESS}. Revisa aquí {TRACKING_URL} los detalles.'
            },
            'visits': {
              'template1': 'Tu visita de {ACCOUNT_NAME} fue realizada con éxito. Revisa aquí {TRACKING_URL} los detalles.',
              'template2': 'Tu visita de {ACCOUNT_NAME} fue realizada con éxito en {VISIT_ADDRESS}. Revisa aquí {TRACKING_URL} los detalles.',
              'template3': 'Tu visita de {ID_REFERENCE} fue realizada con éxito. Revisa aquí {TRACKING_URL} los detalles.',
              'template4': 'Tu visita de {ID_REFERENCE} fue realizada con éxito en {VISIT_ADDRESS}. Revisa aquí {TRACKING_URL} los detalles.',
              'template5': 'Tu visita de {VISIT_TITLE} fue realizada con éxito. Revisa aquí {TRACKING_URL} los detalles.',
              'template6': 'Tu visita de {VISIT_TITLE} fue realizada con éxito en {VISIT_ADDRESS}. Revisa aquí {TRACKING_URL} los detalles.'
            }
          },
          'checkout_failed':{
            'orders': {
              'template1': 'Tu pedido de {ACCOUNT_NAME} no pudo ser entregado. Revisa los detalles en {TRACKING_URL}',
              'template2': 'Tu pedido de {ACCOUNT_NAME} no pudo ser entregado en {VISIT_ADDRESS}. Revisa los detalles en {TRACKING_URL}'
            },
            'services': {
              'template1': 'Tu servicio de {ACCOUNT_NAME} no pudo ser realizado. Revisa aquí {TRACKING_URL} los detalles.',
              'template2': 'Tu servicio de {ACCOUNT_NAME} no pudo ser realizado en {VISIT_ADDRESS}. Revisa aquí {TRACKING_URL} los detalles.',
              'template3': 'Tu servicio de {ID_REFERENCE} no pudo ser realizado. Revisa aquí {TRACKING_URL} los detalles.',
              'template4': 'Tu servicio de {ID_REFERENCE} no pudo ser realizado en {VISIT_ADDRESS}. Revisa aquí {TRACKING_URL} los detalles.',
              'template5': 'Tu servicio de {VISIT_TITLE} no pudo ser realizado. Revisa aquí {TRACKING_URL} los detalles.',
              'template6': 'Tu servicio de {VISIT_TITLE} no pudo ser realizado en {VISIT_ADDRESS}. Revisa aquí {TRACKING_URL} los detalles.'
            },
            'visits': {
              'template1': 'Tu visita de {ACCOUNT_NAME} no pudo ser realizada en {VISIT_ADDRESS}. Revisa aquí {TRACKING_URL} los detalles.',
              'template2': 'Tu visita de {ACCOUNT_NAME} no pudo ser realizada. Revisa aquí {TRACKING_URL} los detalles.',
              'template3': 'Tu visita de {ID_REFERENCE} no pudo ser realizada en {VISIT_ADDRESS}. Revisa aquí {TRACKING_URL} los detalles.',
              'template4': 'Tu visita de {ID_REFERENCE} no pudo ser realizada. Revisa aquí {TRACKING_URL} los detalles.',
              'template5': 'Tu visita de {VISIT_TITLE} no pudo ser realizada en {VISIT_ADDRESS}. Revisa aquí {TRACKING_URL} los detalles.',
              'template6': 'Tu visita de {VISIT_TITLE} no pudo ser realizada. Revisa aquí {TRACKING_URL} los detalles.'
            }
          },
          'on_its_way':{
            'orders': {
              'template1': 'Tu pedido de {ACCOUNT_NAME} ya va en camino. Síguelo en {TRACKING_URL}',
              'template2': 'Tu pedido de {ACCOUNT_NAME} ya va en camino y será entregado en {VISIT_ADDRESS}. Síguelo en {TRACKING_URL}'
            },
            'services': {
              'template1': 'Tu servicio de {ACCOUNT_NAME} ya va en camino y llegará a {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su recorrido.',
              'template2': 'Tu servicio de {ACCOUNT_NAME} ya va en camino. Sigue aquí {TRACKING_URL} su recorrido.',
              'template3': 'Tu servicio de {ID_REFERENCE} ya va en camino y llegará a {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su recorrido.',
              'template4': 'Tu servicio de {ID_REFERENCE} ya va en camino. Sigue aquí {TRACKING_URL} su recorrido.',
              'template5': 'Tu servicio de {VISIT_TITLE} ya va en camino y llegará a {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su recorrido.',
              'template6': 'Tu servicio de {VISIT_TITLE} ya va en camino. Sigue aquí {TRACKING_URL} su recorrido.'
            },
            'visits': {
              'template1': 'Tu visita de {ACCOUNT_NAME} ya va en camino y llegará a {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su recorrido.',
              'template2': 'Tu visita de {ACCOUNT_NAME} ya va en camino. Sigue aquí {TRACKING_URL} su recorrido.',
              'template3': 'Tu visita de {ID_REFERENCE} ya va en camino y llegará a {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su recorrido.',
              'template4': 'Tu visita de {ID_REFERENCE} ya va en camino. Sigue aquí {TRACKING_URL} su recorrido.',
              'template5': 'Tu visita de {VISIT_TITLE} ya va en camino y llegará a {VISIT_ADDRESS}. Sigue aquí {TRACKING_URL} su recorrido.',
              'template6': 'Tu visita de {VISIT_TITLE} ya va en camino. Sigue aquí {TRACKING_URL} su recorrido.'
            }
          }
        },
        'tooltips': {
          'title': 'Live Tracking permite enviar notificaciones a través de SMS y/o correo electrónico con cada cambio de estado de tus visitas. Puedes personalizar el mensaje que se enviará de forma automática',
          'visit_scheduled': 'Este mensaje se envía cuando envías las rutas a tus conductores (al guardar tu plan)',
          'route_started': 'Este mensaje se envía cuando el conductor inicia ruta en la aplicación móvil',
          'checkout_success': 'Este mensaje se envía cuando el conductor marca una visita como exitosa',
          'checkout_failed': 'Este mensaje se envía cuando el conductor marca una visita como fallida',
          'on_its_way': 'Este mensaje se envía cuando el conductor indica que va de camino a la visita'
        },
        'validate_pdf': {
          'fail': 'Parece que tu correo no es compatible con el formato PDF. Por favor corrige los errores e intenta nuevamente.',
          'error': 'Hubo un problema al comprobar el formato del PDF, por favor intenta nuevamente.'
        }
      },
      'Zones': {
        'enabled': 'Activado',
        'disabled': 'Desactivado',
        'button_edit': 'Editar',
        'add_zone': 'Crear nueva zona',
        'Map': {
          'clear': 'Resetear zonas'
        },
        'Edit': {
          'input_placeholder': 'Nombre de zona',
          'cancel': 'Cancelar',
          'save': 'Guardar',
          'save_success': 'Zona guardada exitosamente',
          'save_fail': 'Hubo un problema al guardar la zona'
        },
        'Items_list': {
          'title': 'vehículos',
          'msg_items_empty': 'no tienes vehículos',
          'call_action': 'Crear vehículo',
          'msg_empty_filter': 'La búsqueda no generó resultados, intenta nuevamente.'
        },
        'Delete': {
          'title': 'Borrar zona',
          'button_cancel': 'Cancelar',
          'button_delete': 'Borrar',
          'irreversible_action': 'Esta acción es irreversible',
          'want_continue': '¿Deseas continuar?',
          'delete_success': 'Zona borrada exitosamente',
          'delete_fail': 'Hubo un problema al borrar la zona'
        },
        'Bulk': {
          'btn_download_zones': 'Descargar zonas',
          'btn_import_zones': 'Importar zonas',
          'excel_header_vehicles': 'Vehículos',
          'excel_header_zones': 'Nombre de la zona',
          'excel_header_coordinates': 'Coordenadas',
          'error_no_data': 'El archivo no tiene datos válidos',
          'error_upload_failure': 'Error enviando el archivo de asignación de zonas',
          'result_modal_title': 'Zonas asignadas',
          'result_modal_upload_success': 'Tus asignaciones de zonas se realizaron correctamente',
          'resut_modal_upload_with_errors': 'Estas filas presentaron problemas:',
          'result_modal_row_header': 'Fila',
          'result_modal_error_header': 'Error',
          'result_modal_error_vehicle_not_found': 'Vehículo no existe en la cuenta',
          'result_modal_error_zone_not_found': 'Zona no existe en la cuenta'
        },
        'validation_error_name': 'Ya existe una zona con este nombre.',
        'autozones_warning': 'Zonas está desactivado, autozonas no tendrá efecto',
        'Actions': {
          'auto_zones': {
            'title': 'Asignación automática de zonas',
            'enable_auto_zones': 'Activada',
            'disable_auto_zones': 'Desactivada'
          },
          'use_zones': {
            'title': 'optimización de rutas',
            'use_zones': 'Usar zonas',
            'hide_zones': 'Ignorar zonas'
          },
          'save_actions_zones': 'Guardar cambios',
          'success_zone_property': 'Cambios guardados exitosamente',
          'error_zone_property': 'Hubo un problema al guardar los cambios, intenta nuevamente'
        },
        'weekdays' : {
          'selection_validation_error': 'Debes seleccionar al menos un día para guardar tu zona.',
          'active_days': 'Zona activa los días:',
          'every_day'  : 'Todos',
          'Monday'     : 'Lun',
          'Tuesday'    : 'Mar',
          'Wednesday'  : 'Mie',
          'Thursday'   : 'Jue',
          'Friday'     : 'Vie',
          'Saturday'   : 'Sab',
          'Sunday'     : 'Dom'
        },
        'view_zones': 'Ver zonas',
        'zone_configuration_title': 'Configuración de zonas',
        'activate_zone_usage': 'Activar uso de zonas',
        'automatic_assignment': 'Asignación automática',
      }
    });

    $translateProvider.translations('en', {
      'settings': 'Settings',
      'users': 'Users',
      'vehicles': 'Vehicles',
      'skills': 'Skills',
      'generals': 'Routing options',
      'account': 'Account',
      'mobile': 'Mobile app',
      'security': ' Security',
      'communications': 'Communications',
      'whatsAppPro': 'WhatsApp Pro',
      'zones': 'Zones',
      'total': 'Total',
      'fleets': 'Fleets',
      'optimizers': 'Route creation',
      'customization': 'Customization',
      "customizationMain": "Main",
      'customizationLivetracking': 'Livetracking',
      'automations': 'Automations',
      'usersDetails': 'Details',
      'usersRoles': 'Roles',
      'Fleets': {
        'name': 'Name',
        'no_fleets': 'No fleets created',
        'vehicles': 'Vehicles',
        'users': 'Users',
        'no_vehicles': 'You don\'t have any vehicles created yet',
        'create_vehicle': 'Create vehicle',
        'create_user': 'Create user',
        'fleet_panel_title': 'This is your fleet panel',
        'fleet_panel_description': 'Fleets are groups of vehicles. They allow your users to only see the vehicles related with your operation.',
        'fleet_name_placeholder': 'Name of the new fleet',
        'add': 'Add',
        'save': 'Save',
        'create_fleet_success_msg': 'Fleet created successfully',
        'create_fleet_error_msg': 'There was an error while creating the fleet',
        'create_fleet_duplicate_name_error_msg': 'There is already an existing fleet with that name',
        'delete_confirmation_title': 'Delete fleet',
        'delete_confirmation_continue': 'Do you want to continue?',
        'delete_confirmation_cancel': 'Cancel',
        'delete_confirmation_delete': 'Delete',
        'delete_fleet_success_msg': 'Fleet deleted successfully',
        'delete_fleet_error_msg': 'There was an error while deleting the fleet',
        'cancel': 'Cancel',
        'update_fleet_success_msg': 'Fleet updated successfully',
        'update_fleet_error_not_exist_msg': 'Fleet doesn\'t exist.',
        'update_fleet_error_vehicles_not_exists_msg': 'Nonexistent vehicles assigned',
        'update_fleet_error_duplicated_name_msg': 'There is already an existing fleet with that name',
        'update_fleet_error_default': 'There was an error updating the fleet.',
        'tooltips': {
          'add': 'In the Fleets module, you can group your vehicles in fleets and assign them to different users. The users of your account will only have access to those fleets that have been assigned to them.'
        }
      },
      'Settings': {
        'account': 'Account',
        'billing': 'Billing information',
        'vehicles': 'Vehicles',
        'users': 'Drivers',
        'empty_data': 'There isn\'t any data to be shown',
        'required': 'Required',
        'optional': 'Optional',
        'first_text': 'First',
        'last_text': 'Last',
        'next_text': 'Next',
        'previous_text': 'Previous'
      },
      'Users': {
        'type_1': 'Driver',
        'type_2': 'Admin',
        'type_3': 'Owner',
        'type_4': 'Monitor',
        'type_5': 'Coordinator',
        'type_6': 'Router',
        'type_7': 'Router Jr',
        'type_8': 'Co-driver',
        'type_9': 'Monitor Coordinator',
        'without_drivers_1': 'No users created',
        'without_drivers_2': ' please click <br>',
        'without_drivers_3': ' here <br>',
        'without_drivers_4': 'to create one.',

        'just_admin_user_1': 'No users drivers created',
        'just_admin_user_2': ' please click <br>',
        'just_admin_user_3': ' here <br>',
        'just_admin_user_4': 'to create one.',

        'title': 'Driver information',
        'noUsersTitle': 'No drivers',
        'noUsers': 'No drivers created',
        'createUser': 'Create one',
        'btn_more_info': 'Optional information',
        'name_table_header': 'Name* (required)',
        'name_table_header_comment': 'Name to identify the user',
        'role_table_header': 'Role* (required)',
        'role_table_header_comment': 'admin / router / routerjr / monitor / coordinator / coordinator-monitor / driver / copilot',
        'phone_table_header': 'Phone (optional)',
        'email_table_header': 'Email (optional)',
        'username_table_header': 'Username * (required)',
        'username_table_header_comment': 'Must be unique across users',
        'password_table_header': 'Password* (required)',
        'password_table_header_comment': 'Consider the password security policy configured in the platform',
        'btn_bulk_upload': 'Load file',
        'btn_bulk_download': 'Download list',
        'btn_bulk_create': 'Bulk create',
        'btn_bulk_update': 'Bulk edit',
        'btn_bulk_template_download': 'Download template'
      },
      'Vehicles': {
        'modal_title_upgrade_plan': 'Exceeds account limit',
        'modal_content_upgrade_plan': 'You already have @:vehicles_created vehicles created. Contact us to increase your account capacity and create more vehicles.',
        'contact_us': 'Contact us',
        'without_vehicle_1': 'This is your vehicle panel',
        'without_vehicle_2': 'No vehicles created yet. Click the button',
        'without_vehicle_3': 'New vehicle',
        'without_vehicle_4': ' and start building your fleet ',
        'without_vehicle_searching' : 'No vehicle was found with provided search terms.',
        'title': 'Vehicles information',
        'no_vehicles': 'No vehicles',
        'no_vehicles_msg_1': 'There are no vehicles in your account.',
        'no_vehicles_msg_2': 'create one',
        'head_title': 'Vehicle information',
        'error_name_vehicle_required': 'Vehicle name is required',
        'error_name_required': 'Name is required',
        'error_name_duplicated': 'Name already exists',
        'error_name_duplicated_deleted': 'This name has already been used',
        'error_capacity_required': 'Load capacity is required',
        'error_capacity_min': 'Load capacity must be greater or equal to zero',
        'error_limit_capacity': 'Vehicle load capacity too high',
        'error_address_origin': 'Address origin is required',
        'error_coordinate_pattern': 'Coordinates must be valid numbers',
        'error_address_end': 'Destination address is required',
        'without_drivers_1': 'There are no drivers available, please click ',
        'without_drivers_2': 'here',
        'without_drivers_3': 'to create a new driver',
        'without_skill_1': 'There are no skills registered, please click',
        'without_skill_2': 'here',
        'without_skill_3': 'to create skills',
        'save': 'Save',
        'cancel': 'Cancel',
        'new_vehicle_btn': 'New vehicle',
        'import': 'Import',
        'title_table_header': 'Name* (required)',
        'title_table_header_comment': 'Name to identify the vehicle',
        'capacity_table_header': 'Max load* (required)',
        'capacity_table_header_comment': 'Maximum amount of products, weight or load that this vehicle can carry',
        'reference_id_table_header': 'Reference id (optional)',
        'capacity_2_table_header': 'Load 2 (optional)',
        'capacity_3_table_header': 'Load 3 (optional)',
        'origin_table_header': 'Origin Address* (required)',
        'origin_table_header_comment': 'Start address of the vehicle route',
        'destination_table_header': 'Destination (optional)',
        'driver_table_header': 'Driver (optional)',
        'shift_start_table_header': 'Shift start (optional)',
        'shift_end_table_header'  : 'Shift end (optional)',
        'cost_table_header': 'Cost (optional)',
        'max_visit_table_header': 'Max visits (optional)',
        'min_load_table_header': '% Min load (optional)',
        'min_load_2_table_header': '% Min load 2 (optional)',
        'min_load_3_table_header': '% Min load 3 (optional)',
        'origin_latitude_table_header': 'Origin latitude (optional)',
        'origin_longitude_table_header': 'Origin longitude (optional)',
        'destination_latitude_table_header': 'Destination latitude (optional)',
        'destination_longitude_table_header': 'Destination longitude (optional)',
        'skills_table_header'  : 'Skills (optional)',
        'rest_time_start_table_header': 'Start break time (optional)',
        'rest_time_end_table_header': 'End break time (optional)',
        'rest_time_duration_table_header': 'Break time duration (optional)',
        'max_time_header': 'Working time (optional)',
        'edit': 'Edit',
        'previous': 'Back',
        'next': 'Next',
        'title_lbl': 'Name*',
        'capacity_lbl': 'Load*',
        'reference_id_lbl': 'Reference id',
        'capacity_lbl_2': 'Load 2',
        'capacity_lbl_3': 'Load 3',
        'cost_lbl': 'Cost',
        'min_load': '% Min load',
        'min_load_2': '% Min load 2',
        'min_load_3': '% Min load 3',
        'location_start_latitude':'Origin Latitude',
        'location_start_longitude':'Origin Longitude',
        'location_end_latitude':'Destination Latitude',
        'location_end_longitude': 'Destination Longitude',
        'max_visit': 'Max visits',
        'max_time': 'Working time',
        'error_max_time': 'You must enter an integer value and greater than 0',
        'origin_lbl': 'Start',
        'use_address_detination': 'Use origin address as destination address',
        'destination_lbl': 'Destination',
        'driver_lbl': 'Driver',
        'codrivers_lbl': 'Codrivers',
        'select_driver': '--Select driver--',
        'skills_lbl': 'Skills',
        'close': 'Close',
        'delete_vehicle': 'Delete vehicle',
        'cannot_delete_description_vehicle': 'This vehicle belongs to plans that are currently underway or planned:',
        'cannot_delete_description_2_vehicle': 'You must complete the plans or remove the vehicle from them.',
        'irreversible_action': 'This vehicle will be deleted',
        'want_continue': 'Do you want to continue?',
        'delete': 'Delete',
        'default_start_shift': 'HH:MM',
        'default_end_shift': 'HH:MM',
        'default_rest_time_end': 'HH:MM',
        'default_rest_time_start': 'HH:MM',
        'error_format_date': '* Wrong time format -- HH:MM',
        'error_between_date': '* Starting time must be before finishing time',
        'error_empty_date': '* You must enter two hours',
        'error_exceeds_rest_time_duration': 'Duration is longer than time window',
        'error_empty_rest_time_duration' : 'Time window and duration are both required for this feature',
        'error_invalid_duration': 'You must enter a value between 1 and 1440 minutes.',
        'error_invalid_difference_rest_shift_start': "Break start time must be equal or greater than vehicle start time.",
        'error_invalid_difference_rest_shift_end': "Break end time must be less than or equal to vehicle end time.",
        'error_invalid_difference_shift_rest_start': 'Vehicle start time must be less or equal to break start time.',
        'error_invalid_difference_shift_rest_end': 'Vehicle end time must be greater than or equal to break end time.',
        'required_empty_fields_message': 'Please fill in the required fields',
        'error_invalid_percentage_alert': 'Invalid percentage',
        'placeholder_name_vehicle': 'Name your vehicle.',
        'placeholder_reference_id': 'OC-2910',
        'placeholder_name_capacity': '10,000',
        'placeholder_name_capacity_2': '10,000',
        'placeholder_name_capacity_3': '10,000',
        'placeholder_name_cost': '10,000',
        'placeholder_longitude': '1.000001',
        'placeholder_latitude': '-1.000001',
        'placeholder_name_min_load': '% Min load: 50',
        'placeholder_name_min_load_2': '% Min load 2: 30',
        'placeholder_name_min_load_3': '% Min load 3: 20',
        'placeholder_name_max_visit': 'Max visits: 10',
        'placeholder_origin': '1152 Valencia St, San Francisco, CA 94110',
        'placeholder_end': '5801 Geary Blvd, San Francisco, CA 94121',
        'tooltip_max_time': 'This field limits the vehicle working time in a plan. It is in minutes and their value must be an integer greater than 0, but it can be left empty too',
        'tooltip_capacity': 'Quantity of products, weight or load that this vehicle can carry',
        'tooltip_reference_id': 'Reference id code for your vehicle. It could be its license plate or any other internal code for your business',
        'tooltip_capacity_2': 'Fill in this field in case you have capacity restrictions and would like to add an optional capacity to the first one.',
        'tooltip_schedule': 'Fill in this field if this vehicle works on a specific schedule different to your other vehicles',
        'tooltip_skills': 'The special skills of the vehicle. For example, this vehicle has a cold container, or it can enter areas of the city that others can not.',
        'tooltip_addres_origin': 'The address where this vehicle begins its day',
        'tooltip_addres_end': 'The address where this vehicle ends its day',
        'tooltip_address': 'The address can be invalid if their coordinates are added manually',
        'tooltip_coordinates': 'Updating coordinates will not change the address. Both coordinates should be set to be considered. And they must belong to the account country',
        'tooltip_driver_default': 'Fill this field if this vehicle is always handled by the same person.',
        'tooltip_min_load': 'Minimum main load percentage that this vehicle must carry per route. If SimpliRoute is not able to assign this percentage to the vehicle, no routes will be created for this vehicle.',
        'tooltip_min_load_2': 'Minimum load 2 percentage that this vehicle must carry per route. If SimpliRoute is not able to assign this percentage to the vehicle, no routes will be created for this vehicle.',
        'tooltip_min_load_3': 'Minimum load 3 percentage that this vehicle must carry per route. If SimpliRoute is not able to assign this percentage to the vehicle, no routes will be created for this vehicle.',
        'tooltip_max_visit': 'Maximum number of visits that this vehicle can deliver per route.',
        'tooltip_cost': 'Fixed cost for the use of this vehicle. SimpliRoute will use this value to favor vehicles with lower cost than vehicles with higher cost.',
        'placeholder_duration_rest_time': '60',
        'tooltip_rest_time': 'Time window in which the driver may be inactive, either by break time, snack or other event.',
        'tooltip_rest_time_duration': 'Duration (in minutes) of the break or snack time allowed for the driver.',
        'confirm_leave': 'Attention',
        'confirm_leave_message_1': 'If you leave without saving you may lose the data and your changes',
        'confirm_leave_message_2': 'Are you sure you want to leave?',
        'confirm_leave_close': 'Stay',
        'confirm_leave_yes': 'Leave anyway',
        'confirm_leave_message_3': 'Skills are optional information',
        'confirm_leave_message_4': 'The default driver is optional information',
        'btn_more_loads': 'Optional information',
        'btn_download_list': 'Download list',
        'import_vehicles'                : 'Import vehicles',
        'btn_new_vehicles' : 'New vehicles',
        'btn_edit_vehicles': 'Edit vehicles',
        'longitude': 'Longitude*',
        'latitude': 'Latitude*',
        'codrivers_modal_cancel': 'Cancel',
        'codrivers_modal_set': 'Set',
        'my_vehicles': 'My vehicles'
      },
      'Account': {
        'options': 'Options',
        'btn_save': 'Save',
        'configs_saved_success': 'Options saved successfully',
        'configs_saved_fail': 'There was an error saving the account options, please try again',
        'default_values': 'Default values',
        'setupOptions': {
          'send_gps': 'Enable GPS sending',
          'enable_observations': 'Optional or mandatory reasons',
          'max_distance': 'Maximum distance (KM)',
          'vehicle_refill_time': 'Vehicle refill time (MIN)',
          'eta_range_title': 'Estimated delivery time',
          'eta_range_scheduled_visit': 'Scheduled status',
          'eta_range_visit_with_route_started': 'Status on route',
          'eta_range_visit_on_its_way': 'Status on it’s way'
        },
        'tooltipsOptions': {
          'send_gps': "When you deactivate this option, your drivers' cell phones will stop sending GPS data. Turn it off only if you have an external GPS provider.",
          'enable_observations': 'If you make this field mandatory, your drivers will have to choose an observation to keep moving forward.',
          'max_distance': 'Maximum linear distance in kilometers to which you make dispatches. Visits further from this distance will be marked as "Too far from the depot"',
          'refill_time': 'Time that takes to load your orders inside the truck between routes',
          'eta_range_scheduled_visit': 'Generate the estimated delivery time (ETA) range when creating the route.',
          'eta_range_visit_with_route_started': 'Generate the estimated delivery time (ETA) range when starting the route.',
          'eta_range_visit_on_its_way': 'Generate the Estimated Delivery Time (ETA) range en route to the delivery address (notify action).'
        },
        'error_input_required': 'Required field',
        'error_input_number_valid': 'You did not enter a valid number',
        'error_input_number_min': 'The minimum value is 1 km',
        'error_input_number_max': 'The maximum value is 10000 km',
        'error_input_refill_min': 'The minimum value is 0 min',
        'error_input_refill_max': 'The maximum value is 10000 min',
        'account_logo': 'Account logo',
        'import_logo': 'Upload logo',
        'account_logo_tooltip': 'Image must be .png and can not exceed 50 kbs. The maximum dimensions are 300 x 120 pixels.',
        'logo_size_error': 'The image cannot exceed 50 kbs',
        'logo_dimensions_error': 'Dimensions must be 300 x 120 pixels max.',
        'logo_type_error': 'Image must have a PNG extension'
      },
      'Drivers': {
        'driver': 'Driver',
        'codriver': 'Co-driver',
        'user_type': 'Role',
        'admin': 'Admin',
        'router': 'Router',
        'router_jr': 'Router Jr',
        'monitoring': 'Monitoring',
        'coordinator': 'Coordinator',
        'monitor_coordinator': 'Monitor Coordinator',
        'without_drivers_1': 'This is your user panel',
        'without_drivers_2': 'you currently have no users created. Click the button ',
        'without_drivers_3': 'New user',
        'without_drivers_4': 'to create one.',
        'without_user_searching': 'No users were found with provided search terms.',
        'new_driver_btn': 'New driver',
        'new_driver': 'New user',
        'information_user': 'Information user',
        'username_error': 'The username must not contain spaces.',
        'email_format': 'Invalid format',
        'email_repeated': 'Email already registered.',
        'match_password': 'Passwords do not match, please try again.',
        'error_password': 'Current password is incorrect, please try again.',
        'name_table_header': 'Name',
        'class_table_header': 'Class',
        'username_table_header': 'Username',
        'phone_table_header': 'Phone',
        'email_table_header': 'Email',
        'edit': 'Edit',
        'previous': 'Back',
        'next': 'Next',
        'import': 'Import',
        'driver_information': 'Fullname',
        'user_lbl': 'Username',
        'user_exist': 'Username already taken',
        'phone_lbl': 'Phone',
        'email': 'Email',
        'invalid_format': 'Invalid format.',
        'change_password': 'Change password',
        'password': 'Password',
        'repeat_password': 'Repeat password',
        'close': 'Cancel',
        'save': 'Save',
        'delete_driver': 'Delete driver',
        'irreversible_action': 'This action can\'t be undone.',
        'want_continue': 'Do you want to continue?',
        'cancel': 'Cancel',
        'delete': 'Delete',
        'optional': 'Optional',
        'required': 'Required',
        'name_required': 'Name required',
        'username_required': 'Username required',
        'password_required': 'Password must meet the requested requirements',
        'email_required': 'Email required',
        'footer_message': 'Drivers must download our mobile app in order to track their visits and dispatches.',
        'close_sessions_warning': 'Password updating will close open sessions and will disable integrations related to their token.',
        'unlock': 'Unlock',
        'unlock_driver': 'Unlock {{name}}',
        'unlock_info': 'Instructions to unlock your account and reset your password will be sent to:',
        'enter_email': 'An email address is required in order to send instructions to create new password.',
        'unlock_email_info': 'The email will be automatically added to the user information',
        'edit_email': 'Edit email',
        'confirm': 'Confirm',
        'unlock_user_success': 'Pending unlock. Instructions were sent successfully.',
        'unlock_user_error': 'An error occurred unlocking the account, try again later.'
      },
      'Skills': {
        'add': 'Add',
        'edit': 'Edit',
        'name': 'Name',
        'cancel': 'Cancel',
        'delete': 'Delete',
        'skill_holder': 'Write a skill',
        'required': 'A skill name is required',
        'repeated': 'Skill is already registered',
        'select_all': 'Select all',
        'without_skill_1': 'No skills have been created.',
        'without_skill_2': 'Use the top bar to create your first skill.',
        'empty_skills_title': 'This is your skill panel',
        'empty_skills_paragraph': 'Skills are labels that you can create to categorize vehicle types and visits, so we can assign the right vehicle for a special visit.',
        'empty_skills_note': 'Example: frozen products are assigned to the cold truck because both have the same skill.'
      },
      'Mobile_general': {
        'mobile_section_title': 'Configurations',
        'mobile_checkout_form': 'Check-out form',
        'title_form_1': 'New observation',
        'title_form_2': 'Information observation',
        'label': 'Name',
        'status': 'Type',
        'required': 'Required',
        'type': 'Status',
        'save': 'Save',
        'select_observation': '--Select observation--',
        'completed': 'Completed',
        'failed': 'Failed',
        'name_required': 'Observation name is required',
        'type_required': 'Observation type is required',
        'without_observations_1': 'There are no observations created',
        'without_observations_2': 'please create one.',
        'error_create_observations': 'Error creating observation, please try again.',
        'delete_observation': 'Delete observation',
        'irreversible_action': 'This action can\'t be undone.',
        'want_continue': 'Do you want to continue?',
        'cancel': 'Cancel',
        'delete': 'Delete',
        'error_duplicated_observations': 'The observation already exists',
        'Accounts_settings': {
          'enable_observations': 'Enable obligation of observations',
          'error_save_configs': 'There was an error saving settings, please try again.',
          'enable_observations_message': 'If you make this field mandatory, your drivers will have to choose an observation to keep moving forward.',
          'checkout_similars': 'Join similars by default',
          'checkout_similars_message': 'Turn on this option so your drivers can select all of their similar visits on one click on their mobile app.',
          'enable_signature': 'Signature capture',
          'enable_signature_message': 'Allow your customers to sign the delivery of your order directly on your drivers\'s cellphone.',
          'mandatory_checkout_picture': 'Picture required',
          'mandatory_checkout_picture_message': 'If you activate this function, drivers won\'t be able to finish and send the visit information without a picture.',
          'mandatory_success_checkout_picture': 'Successful visit',
          'mandatory_failed_checkout_picture': 'Failed visit'
        }
      },
      'Log_report': {
        'edition': 'Plan Edits Report',
        'select_client': 'Select a client',
        'client_required': '*Required information'
      },
      'General': {
        'reports': 'Reports',
        'optimization': 'Optimization',
        'report_from': 'From',
        'report_to': 'To',
        'export': 'Export',
        'routes_report': 'Routes report',
        'visits_report': 'Visits report',
        'historical_checkout_report': 'Historical checkouts report',
        'excel_name': 'Report_',
        'excel_headers_id': 'Id',
        'excel_headers_reference_id': 'Reference id',
        'excel_headers_planned_date': 'Planned date',
        'excel_headers_driver': 'Driver',
        'excel_headers_vehicle': 'Vehicle',
        'excel_headers_title': 'Title',
        'excel_headers_address': 'address',
        'excel_headers_eta': 'ETA',
        'excel_headers_etd': 'ETD',
        'excel_headers_checkin_time': 'Checkin time',
        'excel_headers_checkout_time': 'Checkout time',
        'excel_headers_time_service': 'Service time',
        'excel_headers_time_advance': 'Advance',
        'excel_headers_time_delay': 'Delay',
        'excel_headers_latitude': 'Latitude',
        'excel_headers_longitude': 'Longitude',
        'excel_headers_checkout_lat': 'Checkout latitude',
        'excel_headers_checkout_lng': 'Checkout longitude',
        'excel_headers_load': 'Load',
        'excel_headers_status': 'Status',
        'excel_headers_comment': 'Comments',
        'excel_headers_observation': 'Observations',
        'excel_headers_time_windowStart': 'Start of time window 1',
        'excel_headers_time_windowEnd': 'End of time window 1 ',
        'excel_headers_time_windowStart2': 'Start of time window 2',
        'excel_headers_time_windowEnd2': 'End of time window 2',
        'excel_headers_load_2': 'Load 2',
        'excel_headers_load_3': 'Load 3',
        'excel_headers_skills_required': 'Required skills',
        'excel_headers_skills_optional': 'Optional skills',
        'optimization.all_vehicles': 'Minimize vehicles',
        'optimization.balance': 'Balance',
        'optimization.open_start': 'Open start routes',
        'optimization.open_ended': 'Open end routes',
        'optimization.join': 'Join similars',
        'optimization.join_v2': 'Join similars 2.0',
        'optimization.last_position_optimize': 'Use current location',
        'optimization.displayed_options': 'Visualize on menu',
        'optimization.default_values': 'Default values',
        'optimization.fmv': 'Traffic factor',
        'optimization.fmv.high': 'Slow',
        'optimization.fmv.normal': 'Normal',
        'optimization.fmv.low': 'Speedy',
        'optimization.single_tour' : 'Single tour',
        'optimization.beauty': 'SimpliFy',
        'optimization.big_vrp': 'Big VRP',
        'optimization.use_euclidean_distance': 'Euclidean Distance',
        'optimization.enable_graphs': 'Graphs',
        'optimization.auto_reorder': 'Auto Reorder',
        'optimization.enable_soft_window': 'Soft time windows',
        'optimization.distance_to_join_visits': 'Join visits by distance',
        'saving': 'Saving',
        'notes': 'Notes',
        'error_between_dates': '* Date range can not exceed 31 days',
        'error_date_start': '* The start date is greater than the end date',
        'tracking_codes_visits_report': 'Visits report',
        'excel_tracking_codes_name': 'Tracking_codes_report_',
        'TC_REPORT': {
          'tracking_id': 'Tracking ID',
          'planned_date': 'Planned date',
          'title': 'Title',
          'address': 'Address',
          'window_start': 'Start of time window 1',
          'window_end': 'End of time window 1',
          'window_start_2': 'Start of time window 2',
          'window_end_2': 'End of time window 2',
          'comment': 'Comments',
          'contact_name': 'Contact name',
          'contact_phone': 'Contact phone',
          'contact_email': 'Contact email',
          'reference': 'Reference id',
          'time_service': 'Calculated service time',
          'visit_checking' : 'Checkin',
          'report_tc_success': 'Your report is being generated. It will arrive to your email soon.',
          'report_tc_error': 'There was an error generating your report.'
        },
        'optimization_requests_report': 'Requests of optimization service report',
        'visit_images_title_report': 'Visits images report',
        'visit_images_name_picture': 'Name of the photo',
        'visit_images_select_option': 'Select an option',
        'visit_images_select_id_reference': 'Reference ID',
        'visit_images_select_title_visit': 'Visit title',
        'visit_images_toast_content_success': 'Your report is being generated. It will arrive in your mail soon.',
        'visit_images_toast_content_wait_report': 'You must wait for the last report to finish running.',
        'visit_images_toast_content_error_report': 'An unexpected error occurred.',
        'visit_images_toast_content_no_images_found': 'No images in the selected date range.',
        'visit_images_toast_max_images_reached': 'Report can’t be requested for selected dates. Select a shorter date range',
        'error_creating_report': 'Error creating report',
        'RK_REPORT': {
          'date': 'Date',
          'plan_name': 'Plan\'s name',
          'vehicle_name': 'Vehicles\'s name',
          'real_kms': 'Real KMs',
          'total_dispatchs': 'Total visits',
          'pending_dispatchs': 'Pending visits',
          'completed_dispatchs': 'Completed visits',
          'failed_dispatchs': 'Failed visits',
          'start_time': 'Route start time',
          'end_time': 'Route end time'
        },
        'save_changes': 'Save changes',
        'optimization.parameters': 'Optimization parameters',
        'optimization.parameters.traffic_factor': 'Traffic factor',
        'optimization.parameters.slow': 'Slow',
        'optimization.parameters.fast': 'Fast',
        'optimization.parameters.beauty_factor': 'Zoning level',
        'optimization.parameters.beauty_min': 'Less zoned',
        'optimization.parameters.beauty_max': 'More zoned',
        'tracking_code_user_email': 'Email recipient',
        'optimization.tooltip': {
          'traffic_factor': 'This bar allows you to set the travel speed between stops. Adjust it only if you consider that the calculated travel times are not accurate',
          'balance': 'Distributes visits more evenly across vehicles',
          'all_vehicles': 'Uses the smallest amount of vehicles possible',
          'open_start': 'Your routes will start on their first stop and not necessarily on your depot.',
          'open_ended': 'Your routes will end on their last stop and not necessarily on your depot.',
          'join': 'If you have more than one visit with the same address text, the platform will consider them as a single visit (they\'ll have a single ETA and service time).',
          'join_v2': 'If you have more than one visit with the same address text, the platform will consider them as a single visit (they\'ll have a single ETA and service time). Visits will be divided if they exceed the maximum load of vehicles.',
          'single_tour': 'Avoids more than one route per vehicle (per optimization)',
          'beauty': 'Algorithm that delivers zoned results',
          'beauty_factor': 'This bar allows you to configure how zoned the SimpliFy algorithm response is',
          'big_vrp': 'Algorithm to solve big problems of more than 1000 visits',
          'use_euclidean_distance': 'It uses an average between euclidean distance (in a straight line) and distances obtained from the map, allowing a better representation of the space.',
          'enable_graphs': 'Graph structure to speed up the optimization, allowing also more compact routes.',
          'auto_reorder': 'Routes are reoptimized to achieve a better order and compactness of these.',
          'enable_soft_window': 'Time windows could be broken in order to include more visits in the route.',
          'on_foot': 'If your fleet is pedestrian, select this optimization',
          'wave_routing': "You'll use part load routing with demand estimation",
          'distance_to_join_visits': 'Visits within a radius less than or equal to the defined radius will be assigned ' +
            'consecutively on the route.',
          'radial_default': 'Your most optimal distance/time route, shorten travel times to and from your depot',
          'radial_to_near': 'Your route will start at the furthest point and end at the closest one to your depot',
          'radial_to_far': 'Your route will start at the closest point and end at the furthest one to your depot',
          'avoid_tolls': 'Your routes will avoid transit on highways or avenues with tolls.',
          'maximize_attended_load': 'Priority will be given to the visits with the highest load 1. If necessary, those with the lowest load will be left out.',
          'prioritize_load': 'Orders the route by prioritizing visits with the heaviest loads first, while respecting the time window restrictions.',
          'one_seller_per_vehicle': 'Each vehicle will include visits from a single seller only. Routes will not combine visits from different sellers.'
        },
        'optimization.distance_to_join_visits_input': {
          'title': 'Configure radio (meters)*',
          'placeholder': 'Enter a value from 0 to 100 meters',
          'error_required': 'You must enter an integer value between 0 and 100 meters',
          'error_max_value': 'Entered value exceeds distance range'
        }
      },
      'Toast_skill': {
        'unselected_skill': 'You must select at least one skill'
      },
      'Toast_vehicles': {
        'plan_vehicle_exceeded': 'Error creating vehicles. You tried to import @:vehicle_excel_quantity vehicles, but you have @:vehicle_available_create of @:vehicle_total_plan remaining.',
        'error_path_skills': 'There was a problem querying skills path',
        'error_path_drivers': 'There was a problem querying drivers path',
        'error_path_vehicles': 'There was a problem querying vehicles path',
        'vehicle_not_found': 'Vehicle not found',
        'error_set_position_marker': 'Could not get the location, please try again.',
        'error_set_address': 'The address you entered is incorrect, please try again',
        'error_set_address_origin_country': 'Incorrect origin address, different from the country selected when setting up your account country.',
        'error_set_address_destiny_country': 'Incorrect destination address, different from the country selected when setting up your account country.',
        'error_set_address_origin_latlng0': 'Incorrect origin address, please try again',
        'error_set_address_destiny_latlng0': 'Destination address incorrect, please try again',
        'can_create_routes': 'You can now create routes!',
        'error_invalid_address_1'        : 'Address',
        'error_invalid_address_2'        : 'doesn\'t exist',
        'success_import_vehicles'        : 'Vehicles imported',
        'error_empty_vehicles_list'      : 'Empty vehicles list',
        'error_driver_not_found_1'       : 'Driver',
        'error_driver_not_found_2'       : 'is not registered',
        'error_data_format'              :  'The file you uploaded has the wrong format. Please correct it and try again',
        'error_duplicate_vehicle_name_1'  : 'Vehicle name',
        'error_duplicate_vehicle_name_2'  : 'already exists',
        'error_import'                    : 'There were problems importing vehicles. Please make sure the data is correct',
        'invalid_vehicles_ids'            : 'Some vehicles ids are invalid. Please make sure the vehicles exist and try again',
        'invalid_max_time'                : 'Working time: You must enter an integer value and greater than 0 for @:vehicle.',
        'codrivers_retrieval_error'       : 'There were problems while retrieving codrivers, please try again'
      },
      'Toast_users': {
        'no_users_error': 'Empty users list',
        'successful_import': 'Users imported',
        'invalid_id_error': 'Some user ids are invalid. Please make sure the users exist and try again',
        'data_format_error': 'The uploaded file have some issues. Please check and try again',
        'duplicate_username_error_1': 'The username',
        'duplicate_username_error_2': 'already exists',
        'duplicate_email_error_1': 'The email',
        'duplicate_email_error_2': 'already exists',
        'unsuccessful_import': 'There were some issues importing the users. Please make sure the data is correct'
      },
      'Security':{
        'title'                    : 'Password safety parameters',
        'subtitle_web'             : 'Web users',
        'subtitle_mobile'          : 'Web app users',
        'description_web'          : 'These parameters will apply to every web user (Route Designer, Tracking, etc)',
        'description_mobile'       : 'These parameters will apply to every mobile user (drivers, codrivers)',
        'should_uppercase'         : 'Must include at least one uppercase',
        'should_lowercase'         : 'Must include at least one lowercase',
        'should_numeric'           : 'Must include at least one number',
        'should_non_alphanumeric'  : 'Must include at least one special character (non-alphanumeric)',
        'should_min_length'        : 'Minimum character length',
        'default_min_length'       : '(Mandatory minimun 8)',
        'save'                     : 'Save',
        'error_message'            : 'An error occurred while saving your configuration, please try again.',
        'successful_message'       : 'Your configuration has been successfully saved.',
        'invalid_password_length'  : 'Value must be greater than or equal to 8',
        'settings_retrieval_error' : 'An error occurred while loading your password configuration, please try again.',
        'password_expiration'      : 'Password expiry period',
        'password_expiration_unit' : '(in days)',
        'invalid_password_renewal_value': 'You must choose a valid option',
        'password_expiration_disabled'     : 'Never',
        'idle_title'               : 'Automatic logout',
        'idle_config'              : 'Automatic logout after',
        'idle_description'         : 'This configuration applies to web users only',
        'idle_15'                  : '15 minutes',
        'idle_30'                  : '30 minutes',
        'idle_45'                  : '45 minutes',
        'idle_60'                  : '1 hour',
        'idle_120'                 : '2 hours',
        'idle_180'                 : '3 hours',
        'idle_240'                 : '4 hours'
      },
      'Communication': {
        'title': 'Notifications to end customer',
        'title_detail': 'Message to end customer',
        'delete_property_sms': 'Delete SMS',
        'delete_property_wsp': 'Delete Whatsapp',
        'label_sms': 'Message',
        'warning_text_too_large': 'The content of your message is too long',
        'warning_maxlength': 'Text too long',
        'warning_required': 'required field',
        'preview_title': 'Preview the message',
        'close': 'Close',
        'cancel': 'Cancel',
        'save': 'Save',
        'delete': 'Delete',
        'modal_delete_event_title': 'Delete event',
        'modal_message_1': 'This action is irreversible',
        'modal_message_2': 'Do you want to continue?',
        'visit_scheduled': 'Scheduled order',
        'route_started': 'Order in route',
        'checkout_success': 'Successful order',
        'checkout_failed': 'Failed order',
        'on_its_way': 'On its way',
        'insert': 'Insert',
        'rendering_type': 'Type',
        'insert_extrafields': 'Insert extra fields',
        'delete_property_email': 'Delete EMAIL',
        'label_email_subject': 'subject',
        'label_email_msg': 'message',
        'comments': 'Comments',
        'attachment': 'Attach photos',
        'attachment_tooltip': 'Attach to mail photos taken by driver on site',
        'id_reference': 'ID-REF-123',
        'signature_link': 'Signature',
        'timeline': 'Timeline',
        'checkout_status_pdf': 'Checkout status as PDF',
        'items_table': 'Items table',
        'warning_repeated_tag': 'The tag already exists in the subject',
        'livetracking_widget': 'Livetracking widget',
        'generate_insertion_code': 'Generate insertion code',
        'insertion_code': 'Insertion code',
        'copy_code': 'Copy code',
        'search': 'Search',
        'custom_tracking_code': 'Use visit id as tracking code',
        'custom_tracking_code_tooltip': 'By using this option, Live Tracking will use the text that you enter on each visit as "Reference id". You must make sure that the code you enter is unique for each visit, and that it doesn\'t contain spaces or other non conventional characters, or Live Tracking won\'t work properly',
        'visit_title': 'Visit title',
        'visit_address': 'Visit address',
        'visit_observation': 'Visit observation',
        'eta_range': 'Delivery time',
        'delivery_time_range_label': 'Delivery time range',
        'delivery_time_range_preview': 'AM Time',
        'from_name' : 'From name',
        'from_email' : 'From email',
        'success_msg' : 'Changes saved successfully',
        'visit_date_label' : 'Date of delivery',
        'visit_date_preview' : '10-12-2021',
        'send_preview_email': 'Send test email to: ',
        'preview_email_label': 'Insert email',
        'preview_email_success': 'Email sent',
        'preview_email_failed': 'Sending failed, please try again',
        'preview_email_activate': 'Activate your account to enable test emails',
        'preview_email_buttom': 'Send test email',
        'error_email_length_message'    : 'One of the emails is too long',
        'error_max_emails_message_1'    : 'You can add up to',
        'error_max_emails_message_2'    : 'emails',
        'msg_error_email_valid' : '* Invalid email format',
        'user_checkout_label' : 'Checked out by',
        'wsp_title': 'Select the WhatsApp message that best suits your operation.',
        'wsp_orders': 'Orders',
        'wsp_services': 'Services',
        'wsp_visits': 'Visits',
        'wsp':{
          'visit_scheduled': {
            'orders': {
              'template1': 'Your order from {ACCOUNT_NAME} has been scheduled. You can track it in {TRACKING_URL}',
              'template2': 'Your order from {ACCOUNT_NAME} has been scheduled and will be delivered to {VISIT_ADDRESS}. You can track it in {TRACKING_URL}'
            },
            'services': {
              'template1': 'Hi {VISIT_TITLE}, your {REFERENCE_ID} service has been scheduled. Track here {TRACKING_URL} its progress.',
              'template2': 'Your {ACCOUNT_NAME} service has been scheduled to arrive at {VISIT_ADDRESS}. Track here {TRACKING_URL} its progress.',
              'template3': 'Hi {ID_REFERENCE}, your {VISIT_TITLE} service has been scheduled to arrive at {VISIT_ADDRESS}.Track here {TRACKING_URL} its progress.'
            },
            'visits': {
              'template1': 'Your visit from {ACCOUNT_NAME} has been scheduled has been scheduled to arrive at {VISIT_ADDRESS} Track here {TRACKING_URL} its progress.',
              'template2': 'Hello {VISIT_TITLE}, your visit from {ID_REFERENCE} has been scheduled to arrive at {VISIT_ADDRESS}. Track here {TRACKING_URL} its progress.',
              'template3': 'Hello {ID_REFERENCE}, your visit from {VISIT_TITLE} has been scheduled to arrive at {VISIT_ADDRESS}. Track here {TRACKING_URL} its progress.'
            }
          },
          'route_started':{
            'orders': {
              'template1': 'Your order from {ACCOUNT_NAME} is already on route. The estimated time of arrival is between {ETA_RANGE}. You can track it in {TRACKING_URL}',
              'template2': 'Your order from {ACCOUNT_NAME} is already on route and will be delivered to {VISIT_ADDRESS}. The estimated time of arrival is between {ETA_RANGE}. You can track it in {TRACKING_URL}',
              'template3': 'Your order from {ACCOUNT_NAME} is already on route. You can track it in {TRACKING_URL}',
              'template4': 'Your order from {ACCOUNT_NAME} is already on route and will be delivered to {VISIT_ADDRESS}. You can track it in {TRACKING_URL}'
            },
            'services': {
              'template1': 'Your {ACCOUNT_NAME} service will arrive at {VISIT_ADDRESS} today. The estimated time of arrival is between {ETA_RANGE}. Track here {TRACKING_URL} its route.',
              'template2': 'Your {ACCOUNT_NAME} service will arrive today at {VISIT_ADDRESS}. Track here {TRACKING_URL} its route.',
              'template3': 'Your {ID_REFERENCE} service will arrive at {VISIT_ADDRESS} today. The estimated time of arrival is between {ETA_RANGE}. Track here {TRACKING_URL} its route.',
              'template4': 'Your {ID_REFERENCE} service will arrive today at {VISIT_ADDRESS}. Track here {TRACKING_URL} its route.',
              'template5': 'Your {VISIT_TITLE} service will arrive at {VISIT_ADDRESS} today. The estimated time of arrival is between {ETA_RANGE}. Track here {TRACKING_URL} its route.',
              'template6': 'Your {VISIT_TITLE} service will arrive today at {VISIT_ADDRESS}. Track here {TRACKING_URL} its route.'
            },
            'visits': {
              'template1': 'Your visit from {ACCOUNT_NAME} will arrive today at {VISIT_ADDRESS}. The estimated time of arrival is between {ETA_RANGE}. Track here {TRACKING_URL} its route.',
              'template2': 'Your visit from {ACCOUNT_NAME} will arrive today at {VISIT_ADDRESS}. Track here {TRACKING_URL} its route.',
              'template3': 'Your visit from {ID_REFERENCE} will arrive today at {VISIT_ADDRESS}. The estimated time of arrival is between {ETA_RANGE}. Track here {TRACKING_URL} its route.',
              'template4': 'Your visit from {ID_REFERENCE} will arrive today at {VISIT_ADDRESS}. Track here {TRACKING_URL} its route.',
              'template5': 'Your visit from {VISIT_TITLE} will arrive today at {VISIT_ADDRESS}. The estimated time of arrival is between {ETA_RANGE}. Track here {TRACKING_URL} its route.',
              'template6': 'Your visit from {VISIT_TITLE} will arrive today at {VISIT_ADDRESS}. Track here {TRACKING_URL} its route.'
            }
          },
          'checkout_success':{
            'orders': {
              'template1': 'Your order from {ACCOUNT_NAME} was successfully delivered. You can check the details in {TRACKING_URL}',
              'template2': 'Your order from {ACCOUNT_NAME} was successfully delivered to {VISIT_ADDRESS}. You can check the details in {TRACKING_URL}.'
            },
            'services': {
              'template1': 'Your {ACCOUNT_NAME} service was successfully completed. Here {TRACKING_URL} you can check out the details.',
              'template2': 'Your {ACCOUNT_NAME} service was successfully completed on {VISIT_ADDRESS}. Here {TRACKING_URL} you can check out the details.',
              'template3': 'Your {ID_REFERENCE} service was successfully completed. Here {TRACKING_URL} you can check out the details.',
              'template4': 'Your {ID_REFERENCE} service was successfully completed on {VISIT_ADDRESS}. Here {TRACKING_URL} you can check out the details.',
              'template5': 'Your {VISIT_TITLE} service was successfully completed. Here {TRACKING_URL} you can check out the details.',
              'template6': 'Your {VISIT_TITLE} service was successfully completed on {VISIT_ADDRESS}. Here {TRACKING_URL} you can check out the details.'
            },
            'visits': {
              'template1': 'Your visit from {ACCOUNT_NAME} was successfully completed. Here {TRACKING_URL} you can check out the details.',
              'template2': 'Your visit from {ACCOUNT_NAME} was successfully completed on {VISIT_ADDRESS}. Here {TRACKING_URL} you can check out the details.',
              'template3': 'Your visit from {ID_REFERENCE} was successfully completed. Here {TRACKING_URL} you can check out the details.',
              'template4': 'Your visit from {ID_REFERENCE} was successfully completed on {VISIT_ADDRESS}. Here {TRACKING_URL} you can check out the details.',
              'template5': 'Your visit from {VISIT_TITLE} was successfully completed. Here {TRACKING_URL} you can check out the details.',
              'template6': 'Your visit from {VISIT_TITLE} was successfully completed on {VISIT_ADDRESS}. Here {TRACKING_URL} you can check out the details.'
            }
          },
          'checkout_failed':{
            'orders': {
              'template1': 'Your order from {ACCOUNT_NAME} could not be delivered. You can check the details in {TRACKING_URL}',
              'template2': 'Your order from {ACCOUNT_NAME} could not be delivered to {VISIT_ADDRESS}. You can check the details in {TRACKING_URL}'
            },
            'services': {
              'template1': 'Your {ACCOUNT_NAME} service couldn’t be completed. Here {TRACKING_URL} you can check out the details.',
              'template2': 'Your {ACCOUNT_NAME} service couldn’t be completed at {VISIT_ADDRESS}. Here {TRACKING_URL} you can check out the details.',
              'template3': 'Your {ID_REFERENCE} service couldn’t be completed. Here {TRACKING_URL} you can check out the details.',
              'template4': 'Your {ID_REFERENCE} service couldn’t be completed at {VISIT_ADDRESS}. Here {TRACKING_URL} you can check out the details.',
              'template5': 'Your {VISIT_TITLE} service couldn’t be completed. Here {TRACKING_URL} you can check out the details.',
              'template6': 'Your {VISIT_TITLE} service couldn’t be completed at {VISIT_ADDRESS}. Here {TRACKING_URL} you can check out the details.'
            },
            'visits': {
              'template1': 'Your visit from {ACCOUNT_NAME} couldn’t be completed. Here {TRACKING_URL} you can check out the details.',
              'template2': 'Your visit from {ACCOUNT_NAME} couldn’t be completed at {VISIT_ADDRESS}. Here {TRACKING_URL} you can check out the details.',
              'template3': 'Your visit from {ID_REFERENCE} couldn’t be completed. Here {TRACKING_URL} you can check out the details.',
              'template4': 'Your visit from {ID_REFERENCE} couldn’t be completed at {VISIT_ADDRESS}. Here {TRACKING_URL} you can check out the details.',
              'template5': 'Your visit from {VISIT_TITLE} couldn’t be completed. Here {TRACKING_URL} you can check out the details.',
              'template6': 'Your visit from {VISIT_TITLE} couldn’t be completed at {VISIT_ADDRESS}. Here {TRACKING_URL} you can check out the details.'
            }
          },
          'on_its_way':{
            'orders': {
              'template1': 'Your order from {ACCOUNT_NAME} is on its way to your delivery address. You can track it in {TRACKING_URL}',
              'template2': 'Your order from {ACCOUNT_NAME} is on its way to your delivery address and will be delivered to {VISIT_ADDRESS}. You can track it in {TRACKING_URL}'
            },
            'services': {
              'template1': 'Your {ACCOUNT_NAME} service is on its way to {VISIT_ADDRESS}. Track here {TRACKING_URL} its route.',
              'template2': 'Your {ACCOUNT_NAME} service is on its way. Track here {TRACKING_URL} its route.',
              'template3': 'Your {ID_REFERENCE} service is on its way to {VISIT_ADDRESS}. Track here {TRACKING_URL} its route.',
              'template4': 'Your {ID_REFERENCE} service is on its way. Track here {TRACKING_URL} its route.',
              'template5': 'Your {VISIT_TITLE} service is on its way to {VISIT_ADDRESS}. Track here {TRACKING_URL} its route.',
              'template6': 'Your {VISIT_TITLE} service is on its way. Track here {TRACKING_URL} its route.'
            },
            'visits': {
              'template1': 'Your visit from {ACCOUNT_NAME} is already on its way to {VISIT_ADDRESS}. Track here {TRACKING_URL} its route.',
              'template2': 'Your visit from {ACCOUNT_NAME} is already on its way. Track here {TRACKING_URL} its route.',
              'template3': 'Your visit from {ID_REFERENCE} is already on its way to {VISIT_ADDRESS}. Track here {TRACKING_URL} its route.',
              'template4': 'Your visit from {ID_REFERENCE} is already on its way. Track here {TRACKING_URL} its route.',
              'template5': 'Your visit from {VISIT_TITLE} is already on its way to {VISIT_ADDRESS}. Track here {TRACKING_URL} its route.',
              'template6': 'Your visit from {VISIT_TITLE} is already on its way. Track here {TRACKING_URL} its route.'
            }
          }
        },
        'tooltips': {
          'title': 'Live Tracking allows you to send automatic notifications via SMS and / or email with each change of status of your visits. You can customize the messages.',
          'visit_scheduled': 'This message is sent when you dispatch the routes to your drivers (when you save your plan)',
          'route_started': 'This message is sent when drivers press "start route" in their apps',
          'checkout_success': 'This message is sent when drivers mark a visit as successful',
          'checkout_failed': 'This message is sent when drivers mark a visit as failed',
          'on_its_way': 'This message is sent when the driver is on their way to the visit'
        },
        'validate_pdf': {
          'fail': 'It seems your emails are not compatible with our PDF format. Please fix any errors and try again.',
          'error': 'There was a problem checking the PDF format, please try again.'
        }
      },
      'Zones': {
        'enabled': 'Enabled',
        'disabled': 'Disabled',
        'button_edit': 'Edit',
        'add_zone': 'Create new zone',
        'Map': {
          'clear': 'Reset zones'
        },
        'Edit': {
          'input_placeholder': 'Name of zone',
          'cancel': 'Cancel',
          'save': 'Save',
          'save_success': 'Zone successfully saved',
          'save_fail': 'There was a problem saving the zone'
        },
        'Items_list': {
          'title': 'Vehicles',
          'msg_items_empty': 'you don\'t have any vehicles',
          'call_action': 'Create a vehicle',
          'msg_empty_filter': 'Your search returned no results, please try again.'
        },
        'Delete': {
          'title': 'Delete zone',
          'button_cancel': 'Cancel',
          'button_delete': 'Delete',
          'irreversible_action': 'This action can\'t be undone.',
          'want_continue': 'Do you want to continue?',
          'delete_success': 'Zone successfully deleted',
          'delete_fail': 'There was a problem deleting the zone'
        },
        'Bulk': {
          'btn_download_zones': 'Download zones',
          'btn_import_zones': 'Import zones',
          'excel_header_vehicles': 'Vehicles',
          'excel_header_zones': 'Zone name',
          'excel_header_coordinates': 'Coordinates',
          'error_no_data': "The file doesn't have any valid data",
          'error_upload_failure': 'Error sending zones asignation file',
          'result_modal_title': 'Zones assigned',
          'result_modal_upload_success':  'Zones successfully assigned',
          'resut_modal_upload_with_errors': 'There were problems with these files',
          'result_modal_row_header': 'Row',
          'result_modal_error_header': 'Error',
          'result_modal_error_vehicle_not_found': 'Vehicle doesn\'t exist on your account',
          'result_modal_error_zone_not_found': 'Zone doesn\'t exist on your account'
        },
        'validation_error_name': 'A zone with this name already exists.',
        'autozones_warning': 'Zones are disabled, autozones will have no effect',
        'Actions': {
          'auto_zones': {
            'title': 'Automatic zone assignation',
            'enable_auto_zones': 'Enabled',
            'disable_auto_zones': 'Disabled'
          },
          'use_zones': {
            'title': 'route optimization',
            'use_zones': 'Use zones',
            'hide_zones': 'Ignore zones'
          },
          'save_actions_zones': 'Save changes',
          'success_zone_property': 'Changes successfully saved',
          'error_zone_property': 'There was a problem saving changes, try again'
        },
        'weekdays' : {
          'selection_validation_error': 'You must select at least 1 day to save your zone.',
          'active_days': 'Active zones on days:',
          'every_day'  : 'All',
          'Monday'     : 'Mon',
          'Tuesday'    : 'Tue',
          'Wednesday'  : 'Wed',
          'Thursday'   : 'Thu',
          'Friday'     : 'Fri',
          'Saturday'   : 'Sat',
          'Sunday'     : 'Sun'
        },
        'view_zones': 'View zones',
        'zone_configuration_title': 'Zone Configuration',
        'activate_zone_usage': 'Activate Zone Usage',
        'automatic_assignment': 'Automatic Assignment',
      }
    });

    $translateProvider.translations('pt', {
      'settings': 'Configurações',
      'users': 'Usuários',
      'vehicles': 'Veículos',
      'skills': 'Habilidades',
      'generals': 'Opções de roteamento',
      'account': 'Conta',
      'mobile': 'Aplicativo móvel',
      'security': 'Segurança',
      'communications': 'Comunicações',
      'whatsAppPro': 'WhatsApp Pro',
      'zones': 'Zonas',
      'total': 'Total',
      'fleets': 'Frotas',
      'optimizers': 'Criação de rotas',
      'customization': 'Personalização',
      "customizationMain": "Principal",
      'customizationLivetracking': 'Rastreamento ao vivo',
      'automations': 'Automações',
      'usersDetails': 'Detalhes',
      'usersRoles': 'Funções',
      'Fleets': {
        'name': 'Nome',
        'noFleets': 'Nenhuma frota criada',
        'vehicles': 'Veículos',
        'users': 'Usuário',
        'no_vehicles': 'Você não tem veículos criados',
        'create_vehicle': 'Criar veículo',
        'create_user': 'Criar usuário',
        'fleet_panel_title': 'Este é o seu painel da frota',
        'fleet_panel_description': 'As frotas são grupos de veículos. Permita que seus usuários vejam apenas os veículos relevantes para sua operação.',
        'fleet_name_placeholder': 'Nome da nova frota',
        'add': 'Adicionar',
        'save': 'Salvar',
        'create_fleet_success_msg': 'Frota criada com sucesso',
        'create_fleet_error_msg': 'Houve um problema ao tentar salvar a frota',
        'create_fleet_duplicate_name_error_msg': 'Já existe uma frota com esse nome',
        'delete_confirmation_title': 'Excluir frota',
        'delete_confirmation_continue': 'Do you want to continue?',
        'delete_confirmation_cancel': 'Cancelar',
        'delete_confirmation_delete': 'Excluir',
        'delete_fleet_success_msg': 'Frota excluída com sucesso',
        'delete_fleet_error_msg': 'Houve um problema ao tentar excluir a frota',
        'cancel': 'Cancelar',
        'update_fleet_success_msg': 'Frota atualizada com sucesso',
        'update_fleet_error_default': 'Ocorreu um problema ao tentar atualizar a frota',
        'update_fleet_error_not_exist_msg': 'A frota que você está tentando atualizar não existe',
        'update_fleet_error_vehicles_not_exists_msg': 'Existem veículos atribuídos não existentes',
        'update_fleet_error_duplicated_name_msg': 'Já existe uma frota com esse nome',
        'tooltips': {
          'add': 'No módulo Frotas, você pode agrupar seus veículos em frotas e atribuí-los a diferentes usuários. Você pode criar todas as frotas que desejar e os usuários de sua conta podem acessar apenas as frotas que foram atribuídas a elas.'
        }
      },
      'Settings': {
        'account': 'Cuenta',
        'billing': 'Faturamento',
        'vehicles': 'Veículos',
        'users': 'Motoristas',
        'required': 'Solicitado',
        'optional': 'Opcional',
        'first_text': 'Primeiro',
        'last_text': 'Último',
        'next_text': 'Próximo',
        'previous_text': 'Anterior'
      },
      'Users': {
        'type_1': 'Motorista',
        'type_2': 'Administrador',
        'type_3': 'Proprietário',
        'type_4': 'Monitor',
        'type_5': 'Coordenador',
        'type_6': 'Roteador',
        'type_7': 'Roteador Jr',
        'type_8': 'Co-piloto',
        'type_9': 'Monitor Coordenador',
        'without_drivers_1': 'Não há usuários',
        'without_drivers_2': 'faça ',
        'without_drivers_3': 'clique ',
        'without_drivers_4': 'para criar um.',

        'just_admin_user_1': 'Não há usuários',
        'just_admin_user_2': ' faça <br>',
        'just_admin_user_3': ' clique <br>',
        'just_admin_user_4': 'para criar um.',

        'title': 'Configuração do motorista',
        'noUsersTitle': 'Não motoristas',
        'noUsers': 'No existen motorista',
        'createUser': 'Criar um',
        'btn_more_info': 'Informações opcionais',
        'name_table_header': 'Nome* (obrigatório)',
        'name_table_header_comment': 'Nome para identificar o usuário',
        'role_table_header': 'Função* (obrigatório)',
        'role_table_header_comment': 'admin / router / routerjr / monitor / coordinator / coordinator-monitor / driver / copilot',
        'phone_table_header': 'Telefone (opcional)',
        'email_table_header': 'Email (opcional)',
        'username_table_header': 'Nome de usuário * (obrigatório)',
        'username_table_header_comment': 'Deve ser único entre os usuários',
        'password_table_header': 'Senha* (obrigatório)',
        'password_table_header_comment': 'Considere a política de segurança de senha configurada na plataforma',
        'btn_bulk_upload': 'Carregar arquivo',
        'btn_bulk_download': 'Baixar lista',
        'btn_bulk_create': 'Criação em massa',
        'btn_bulk_update': 'Edição em massa',
        'btn_bulk_template_download': 'Baixar modelo'
      },
      'Vehicles': {
        'modal_title_upgrade_plan': 'Excedeu-se o limite da conta',
        'modal_content_upgrade_plan': 'Você já tem @:vehicles_created veículos criados. Entre em contato para aumentar a capacidade de sua conta e criar mais veículos.',
        'contact_us': 'Contato',
        'without_vehicle_1': 'Este é o seu painel de veículo',
        'without_vehicle_2': 'No momento você não possui veículos cadastrados. Clique no botão ',
        'without_vehicle_3': 'Novo veículo',
        'without_vehicle_4': ' para começar a construir a sua frota.',
        'without_vehicle_searching' : 'Nenhum veículo foi encontrado com os termos de pesquisa fornecidos.',
        'title': 'Configuração do veículos',
        'no_vehicles': ' veículos',
        'no_vehicles_msg_1': 'Não há veículos.',
        'no_vehicles_msg_2': 'criar um',
        'head_title': 'Informação do veículo',
        'error_name_vehicle_required': 'Nome do veículo é solicitado',
        'error_name_required': 'Nome é solicitado',
        'error_name_duplicated': 'Nome de veículo ja existe',
        'error_name_duplicated_deleted': 'Esse nome já foi usado',
        'error_capacity_required': 'A capacidade é necessária',
        'error_capacity_min': 'Capacidade deve ser maior que zero',
        'error_limit_capacity': 'A capacidade de carga do veículo é muito alta',
        'error_address_origin': 'Endereço de origem é necessária',
        'error_coordinate_pattern': 'As coordenadas devem ser números válidos',
        'error_address_end': 'Endereço de destino é necessária',
        'without_drivers_1': 'Não há motoristas disponíveis, por favor clique ',
        'without_drivers_2': 'aqui',
        'without_drivers_3': 'para criar motorista',
        'without_skill_1': 'Não há habilidades registradas, clique aqui para criar habilidades',
        'without_skill_2': 'aqui',
        'without_skill_3': 'para criar habilidades',
        'save': 'Salvar',
        'cancel': 'Fechar',
        'new_vehicle_btn': 'Novo veículo',
        'import': 'Importar',
        'title_table_header': 'Nome* (obrigatório)',
        'title_table_header_comment': 'Nome para identificar o veículo',
        'capacity_table_header': 'Capacidade Máxima* (obrigatório)',
        'capacity_table_header_comment': 'Quantidade máxima de produtos, peso ou carga que este veículo pode transportar',
        'reference_id_table_header': 'Id referência (opcional)',
        'capacity_2_table_header': 'Capacidade 2 (opcional)',
        'capacity_3_table_header': 'Capacidade 3 (opcional)',
        'origin_table_header': 'Endereço de origem* (obrigatório)',
        'origin_table_header_comment': 'Endereço inicial da rota do veículo',
        'destination_table_header': 'Destino (opcional)',
        'driver_table_header': 'Motorista (opcional)',
        'shift_start_table_header': 'Início do turno (opcional)',
        'shift_end_table_header'  : 'Fin do turno (opcional)',
        'cost_table_header': 'Custo (opcional)',
        'max_visit_table_header': 'Máximo de visitas (opcional)',
        'min_load_table_header': '% Carga mínima (opcional)',
        'min_load_2_table_header': '% Carga mínima 2 (opcional)',
        'min_load_3_table_header': '% Carga mínima 3 (opcional)',
        'origin_latitude_table_header':'Latitude de origem (optional)',
        'origin_longitude_table_header':'Longitude de origem (optional)',
        'destination_latitude_table_header':'Latitude de destino (optional)',
        'destination_longitude_table_header': 'Longitude de destino (optional)',
        'skills_table_header'  : 'Habilidades (opcional)',
        'rest_time_start_table_header': 'Tempo de início do descanso (opcional)',
        'rest_time_end_table_header': 'Fim do tempo do descanso (opcional)',
        'rest_time_duration_table_header': 'Duração do descanso (opcional)',
        'max_time_header': 'Jornada de trabalho (opcional)',
        'edit': 'Editar',
        'previous': 'Anterior',
        'next': 'Próximo',
        'title_lbl': 'Nome*',
        'capacity_lbl': 'Capacidade*',
        'origin_lbl': 'Origem',
        'use_address_detination': 'Utilizar o endereço de origem como endereço de destino',
        'destination_lbl': 'Destino',
        'driver_lbl': 'Motorista',
        'codrivers_lbl': 'Co-pilotos',
        'select_driver': '--Seleccione motorista--',
        'skills_lbl': 'Habilidades',
        'close': 'Fechar',
        'delete_vehicle': 'Excluir veículo',
        'cannot_delete_description_vehicle': ' Este veículo pertence a planos que estão atualmente em andamento ou planejados:',
        'cannot_delete_description_2_vehicle': 'Você deve completar os planos ou retirar o veículo deles.',
        'irreversible_action': 'Esta ação é irreversível',
        'want_continue': 'Deseja continuar?',
        'delete': 'Excluir',
        'default_start_shift': 'HH:MM',
        'default_end_shift': 'HH:MM',
        'default_rest_time_end': 'HH:MM',
        'default_rest_time_start': 'HH:MM',
        'error_format_date': '* Formato da hora incorreto -- HH:MM',
        'error_between_date': '* A hora de início deve ser menor do que a última hora.',
        'error_empty_date': '* Você deve digitar duas horas.',
        'error_exceeds_rest_time_duration': 'A duração excede o intervalo da janela de tempo',
        'error_empty_rest_time_duration' : 'Você deve inserir a janela de tempo e duração',
        'error_invalid_duration': 'Você deve inserir um valor entre 1 e 1440 minutos.',
        'error_invalid_difference_rest_shift_start': "O horário de início deve ser maior ou igual ao início da jornada de trabalho do veículo.",
        'error_invalid_difference_rest_shift_end': "O horário de término deve ser menor ou igual ao final da jornada de trabalho do veículo.",
        'error_invalid_difference_shift_rest_start': 'O horário de início deve ser menor ou igual ao início do horário de descanso.',
        'error_invalid_difference_shift_rest_end': 'O horário de término deve ser maior ou igual ao término do horário de descanso.',
        'reference_id_lbl': 'Id referência',
        'capacity_lbl_2': 'Capacidade 2',
        'capacity_lbl_3': 'Capacidade 3',
        'cost_lbl': 'Custo',
        'min_load': '% Carga mínima',
        'min_load_2': '% Carga mínima 2',
        'min_load_3': '% Carga mínima 3',
        'location_start_latitude':'Latitude de origem',
        'location_start_longitude':'longitude de origem',
        'location_end_latitude':' latitude de destino',
        'location_end_longitude': 'longitude de destino',
        'max_visit': 'Máximo de visitas',
        'max_time': "Jornada de trabalho",
        'error_max_time': 'Você deve inserir um valor inteiro e maior que 0',
        'error_limit_capacity_2': 'A capacidade 2 do veículo é muito alta',
        'error_limit_capacity_3': 'A capacidade 3 do veículo é muito alta',
        'required_empty_fields_message': 'Por favor, preencha os campos obrigatórios',
        'error_invalid_percentage_alert': 'Invalid percentage',
        'placeholder_name_vehicle': 'Atribuir um nome ao seu veículo.',
        'placeholder_reference_id': 'OC-2910',
        'placeholder_name_capacity': '10,000',
        'placeholder_name_capacity_2': '10,000',
        'placeholder_name_capacity_3': '10,000',
        'placeholder_name_cost': '10,000',
        'placeholder_longitude': '1.000001',
        'placeholder_latitude': '-1.000001',
        'placeholder_name_min_load': '% Carga mínima: 50',
        'placeholder_name_min_load_2': '% Carga mínima 2: 30',
        'placeholder_name_min_load_3': '% Carga mínima 3: 20',
        'placeholder_name_max_visit': 'Máximo de visitas: 10',
        'placeholder_duration_rest_time': '60',
        'tooltip_rest_time': 'Período de tempo no qual o motorista pode estar inativo, seja para descansar, lanchar ou outro evento.',
        'tooltip_rest_time_duration': 'Duração (em minutos) do tempo de descanso ou lanche permitido para o motorista.',
        'placeholder_origin': '1152 Valencia St, San Francisco, CA 94110',
        'placeholder_end': '5801 Geary Blvd, San Francisco, CA 94121',
        'tooltip_max_time': 'Este campo limita a jornada de trabalho do veículo em um plano. Ele é em minutos e seu valor deve ser um número inteiro maior que 0, mas também pode ser deixado vazio',
        'tooltip_capacity': 'Número de produtos, o peso ou carga que o veículo pode transportar um máximo.',
        'tooltip_reference_id': 'Código identificador para o seu veículo. Pode ser sua patente ou algum outro código interno do seu negócio',
        'tooltip_capacity_2': 'Preencha este campo se você tiver restrições de capacidade e gostaria de adicionar um capacidade opcional para o primeiro.',
        'tooltip_schedule': 'Preencha este campo se este veículo funciona em um diferente específica agenda para seus outros veículos.',
        'tooltip_skills': 'As habilidades especiais do veículo. Por exemplo, este veículo tem um recipiente de frio, ou pode entrar em áreas da cidade que outros não podem.',
        'tooltip_addres_origin': 'O endereço em que o veículo começa o dia.',
        'tooltip_addres_end': 'O endereço onde este veículo termina o seu dia',
        'tooltip_address': 'O endereço pode ser inválido se as coordenadas forem adicionadas manualmente.',
        'tooltip_coordinates': 'Atualizar as coordenadas não atualiza o endereço. Ambas as coordenadas devem ser colocadas para serem válidas. E eles devem corresponder ao país da conta.',
        'tooltip_driver_default': 'preencher este campo se este veículo é sempre manipulados pela mesma pessoa.',
        'tooltip_min_load': 'Percentual mínimo de carga principal que o veículo deve transportar em uma rota. Se o SimpliRoute não puder atribuir essa porcentagem ao veículo, os visitantes não receberão visitas ao otimizar rotas.',
        'tooltip_min_load_2': 'Percentagem mínima de carga 2 que o veículo deve transportar numa rota. Se o SimpliRoute não puder atribuir essa porcentagem ao veículo, os visitantes não receberão visitas ao otimizar rotas.',
        'tooltip_min_load_3': 'Percentagem mínima de carga 3 que o veículo deve transportar numa rota. Se o SimpliRoute não puder atribuir essa porcentagem ao veículo, os visitantes não receberão visitas ao otimizar rotas.',
        'tooltip_max_visit': 'Número máximo de visitas que este veículo pode participar em uma rota.',
        "tooltip_cost": "Custo fixo para usar este veículo. O SimpliRoute levará esse valor em consideração para privilegiar os veículos de baixo custo sobre os de alto custo.",
        'confirm_leave': 'Atenção',
        'confirm_leave_message_1': 'Se você deixar o formulário de edição você poderá perder dados que não foram salvos',
        'confirm_leave_message_2': 'Tem certeza que deseja sair?',
        'confirm_leave_close': 'Fechar',
        'confirm_leave_yes': 'Sair',
        'confirm_leave_message_3': 'Habilidades é uma informação opcional',
        'confirm_leave_message_4': 'O padrão é de informação de motorista opcional',
        'btn_more_loads': 'Informações opcionais',
        'btn_download_list': 'Baixar lista',
        'import_vehicles'  : 'Importar veículos',
        'btn_new_vehicles' : 'Novos veículos',
        'btn_edit_vehicles': 'Editar veículos',
        'longitude': 'Longitude*',
        'latitude': 'Latitude*',
        'codrivers_modal_cancel': 'Cancelar',
        'codrivers_modal_set': 'Aplicar',
        'my_vehicles': 'Meus veículos'
      },
      'Account': {
        'options': 'Opções',
        'btn_save': 'Salvar',
        'configs_saved_success': 'Opções salvas com sucesso',
        'configs_saved_fail': 'Houve um erro ao salvar as opções da conta, por favor tente novamente',
        'default_values': 'Default',
        'setupOptions': {
          'send_gps': 'Permitir acesso ao GPS',
          'enable_observations': 'Formulário opcional ou obrigatório',
          'max_distance': 'Raio de distância máximo para a baixa (KM)',
          'vehicle_refill_time': 'Tempo de recarga de veículos (MIN)',
          'eta_range_title': 'Configurar janelas horárias (ETA)',
          'eta_range_scheduled_visit': 'Rota programada',
          'eta_range_visit_with_route_started': 'Em rota',
          'eta_range_visit_on_its_way': 'A caminho'
        },
        'tooltipsOptions': {
          'send_gps': 'Ao desativar essa opção, o sistema não capta os dados de GPS do motorista. Só desative essa opção se você tiver um GPS externo.',
          'enable_observations': 'Ao ativar essa opção, seus motoristas deverão obrigatoriamente preencher todas as informações do formulário de entrega antes de seguir para o próximo ponto.',
          'max_distance': 'Defina um limite de distância para que os motoristas dêem baixa na entrega. Quando estiverem fora do raio definido, não será possível marcar a entrega como concluída.',
          'refill_time': 'Tempo necessário para realizar o carregamento/descarregamento do veículo no ponto de entrega.',
          'eta_range_scheduled_visit': 'Gerencie o tempo estimado de entrega (ETA) ao criar a rota',
          'eta_range_visit_with_route_started': 'Gerencie o tempo estimado de entrega (ETA) ao iniciar a rota',
          'eta_range_visit_on_its_way': 'Gerencie o tempo estimado de entrega (ETA) à caminho do endereço',
        },
        'error_input_required': 'campo obrigatório',
        'error_input_number_valid': 'Você deve digitar um valor numérico',
        'error_input_number_min': 'O valor mínimo é de 1 km',
        'error_input_number_max': 'O valor máximo é 10000 km',
        'error_input_refill_min': 'O valor mínimo é 0 min',
        'error_input_refill_max': 'O valor máximo é 10000 min',
        'account_logo': 'Logotipo da conta',
        'import_logo': 'Importar',
        'account_logo_tooltip': 'A imagem deve ser .png e não pode exceder 50 kbs. As dimensões máximas são 300 x 120 pixels.',
        'logo_size_error': 'A imagem não pode exceder 50 kbs',
        'logo_dimensions_error': 'O tamanho máximo é 300 x 120 pixels',
        'logo_type_error': 'A imagem deve ter uma extensão .png'
      },
      'Drivers': {
        'driver': 'Motorista',
        'codriver': 'Co-piloto',
        'user_type': 'Função',
        'router': 'Roteador',
        'router_jr': 'Roteador Jr',
        'admin': 'Administrador',
        'monitoring': 'Monitoramento',
        'coordinator': 'Coordenador',
        'monitor_coordinator': 'Monitor Coordenador',
        'without_drivers_1': 'Este é o seu painel de usuário',
        'without_drivers_2': 'No momento você não possui usuários cadastrados. Clique no botão ',
        'without_drivers_3': 'Novo usuário',
        'without_drivers_4': ' para criar um.',
        'without_user_searching': 'Nenhum usuário foi encontrado com os termos de pesquisa fornecidos.',
        'new_driver_btn': 'Novo motorista',
        'new_driver': 'Novo usuário',
        'information_user': 'Informação do usuário',
        'username_error': 'O nome de usuário não deve conter espaços.',
        'email_format': 'formato inválido.',
        'email_repeated': 'Email já registrados.',
        'match_password': 'As senhas não correspondem, por favor tente novamente.',
        'error_password': 'senha atual está incorreto, por favor, tente novamente',
        'name_table_header': 'Nome',
        'class_table_header': 'Classe',
        'username_table_header': 'Nome de usuário',
        'phone_table_header': 'Telefone',
        'email_table_header': 'Email',
        'edit': 'Editar',
        'previous': 'Anterior',
        'next': 'Próximo',
        'import': 'Importar',
        'driver_information': 'Nome do motorista',
        'user_lbl': 'Usuario',
        'user_exist': 'O usuário já existe.',
        'phone_lbl': 'Telefone',
        'email': 'Email',
        'invalid_format': 'formato inválido.',
        'change_password': 'mudança de senha',
        'password': 'Senha',
        'repeat_password': 'Repetir a senha',
        'close': 'Fechar',
        'save': 'Salvar',
        'delete_driver': 'Excluir motorista',
        'irreversible_action': 'Esta ação é irreversível',
        'want_continue': 'Você deseja continuar?',
        'cancel': 'Cancelar',
        'delete': 'Excluir',
        'optional': 'Opcional',
        'required': 'Requerido',
        'name_required': 'Nome de usuário requerido',
        'username_required': 'Nome de usuário requerido',
        'password_required': 'A senha deve atender aos requisitos solicitados.',
        'email_required': 'Email requerido',
        'footer_message': 'Os motoristas devem baixar o aplicativo móvel para que você possa rastrear visitas e despachos.',
        'close_sessions_warning': 'A alteração da senha fechará as sessões abertas e desabilitará as integrações que usam esse token.',
        'unlock': 'Desbloquear',
        'unlock_driver': 'Desbloquear {{name}}',
        'unlock_info': 'Instruções para desbloquear sua conta e redefinir a sua senha serão enviadas para:',
        'enter_email': 'É necessário um endereço de e-mail para enviar instruções para criar uma nova senha.',
        'unlock_email_info': 'O e-mail será adicionado automaticamente às informações do usuário',
        'edit_email': 'Editar e-mail',
        'confirm': 'Confirmar',
        'unlock_user_success': 'Desbloqueio pendente. As instruções foram enviadas com sucesso.',
        'unlock_user_error': 'Ocorreu um erro enquanto desbloqueio de conta, tente mais tarde'
      },
      'Skills': {
        'add': 'Adicionar',
        'edit': 'Editar',
        'name': 'Nome',
        'cancel': 'Cancelar',
        'delete': 'Excluir',
        'skill_holder': 'Escrever uma habilidade',
        'required': 'Nomeie a habilidade necessária',
        'repeated': 'Habilidade já está registrado',
        'select_all': 'selecionar tudo',
        'without_skill_1': 'Não houve habilidades.',
        'without_skill_2': 'Use a barra de cima para criar a sua primeira habilidade.',
        'empty_skills_title': 'Este é o seu painel de habilidades',
        'empty_skills_paragraph': 'Habilidades são rótulos que você pode criar para categorizar os tipos de veículos e visita, por isso podemos atribuir o veículo correto para uma visita especial.',
        'empty_skills_note': 'Exemplo: congelado produtos são atribuídos ao frio caminhão porque ambos têm a mesma capacidade.'
      },
      'Mobile_general': {
        'mobile_section_title': 'Configurações do Aplicativo Móvel',
        'mobile_checkout_form': 'Formulário de check-out',
        'title_form_1': 'Nova observação',
        'title_form_2': 'Informação da observação',
        'label': 'Nome',
        'status': 'Tipo',
        'required': 'Requerido',
        'type': 'estado',
        'save': 'Salvar',
        'select_observation': '--Selecionar observação--',
        'completed': 'Realizado',
        'failed': 'Com falha',
        'name_required': 'Nome da observação é requerido',
        'type_required': 'Tipo de observação é requerido',
        'without_observations_1': 'Não há observações criadas',
        'without_observations_2': 'Por favor, crie uma.',
        'error_create_observations': 'Erro ao criar a observação, por favor tente novamente.',
        'delete_observation': 'Excluir observação',
        'irreversible_action': 'Esta ação é irreversível',
        'want_continue': 'Você deseja continuar?',
        'cancel': 'Cancelar',
        'delete': 'Excluir',
        'error_duplicated_observations': 'A observação já está registrado',
        'Accounts_settings': {
          'enable_observations': 'Formulário opcional ou obrigatório',
          'error_save_configs': 'Ocorreu um erro ao salvar suas configurações, por favor tente novamente.',
          'enable_observations_message': 'Se você fizer este campo de preenchimento obrigatório, os motoristas devem escolher uma observação a fazer mais progressos.',
          'checkout_similars': 'Mesclar padrão semelhante',
          'checkout_similars_message': 'Ative esta opção para que seus motoristas possam dar baixa em endereços semelhantes com apenas um clique em seu aplicativo',
          'enable_signature': 'Capturar assinatura',
          'enable_signature_message': 'Ative para permitir que os motoristas coletem a assinatura do recebedor direto no aplicativo móvel.',
          'mandatory_checkout_picture': 'Fotografia obrigatória',
          'mandatory_checkout_picture_message': 'Ao ativar esta funcionalidade, os motoristas não poderão finalizar uma visita sem tirar uma foto no local.',
          'mandatory_success_checkout_picture': 'Visita bem sucedida',
          'mandatory_failed_checkout_picture': 'Visita não completada'
        }
      },
      'Log_report': {
        'edition': 'Relatório de edições de planos',
        'select_client': 'Selecione um cliente',
        'client_required': '*Informação obrigatória'
      },
      'General': {
        'reports': 'Relatórios',
        'optimization': 'Otimização',
        'report_from': 'De',
        'report_to': 'À',
        'export': 'Exportar',
        'excel_name': 'Relatórios',
        'routes_report': 'Relatório de rotas',
        'visits_report': 'Relatório entregas',
        'historical_checkout_report': 'Histórico de visitas',
        'excel_headers_id': 'Id',
        'excel_headers_reference_id': 'referência id',
        'excel_headers_planned_date': 'Data prevista',
        'excel_headers_driver': 'Motorista',
        'excel_headers_vehicle': 'Veículo',
        'excel_headers_title': 'Título',
        'excel_headers_address': 'Endereço',
        'excel_headers_eta': 'ETA',
        'excel_headers_etd': 'ETD',
        'excel_headers_checkin_time': 'Checkin',
        'excel_headers_checkout_time': 'Checkout',
        'excel_headers_time_service': 'Tempo de serviço',
        'excel_headers_time_advance': 'Antecipação',
        'excel_headers_time_delay': 'Atraso',
        'excel_headers_latitude': 'Latitude',
        'excel_headers_longitude': 'Longitude',
        'excel_headers_checkout_lat': 'Checkout latitude',
        'excel_headers_checkout_lng': 'Checkout longitude',
        'excel_headers_load': 'Carga',
        'excel_headers_status': 'Estado',
        'excel_headers_comment': 'Comentários',
        'excel_headers_observation': 'Observações',
        'excel_headers_time_windowStart': 'Janela de horário inicial 1',
        'excel_headers_time_windowEnd': 'Janela de horário final 1',
        'excel_headers_time_windowStart2': 'Janela de horário inicial 2',
        'excel_headers_time_windowEnd2': 'Janela de horário final 2',
        'excel_headers_load_2': 'Carga 2',
        'excel_headers_load_3': 'Carga 3',
        'excel_headers_skills_required': 'Habilidades necessárias',
        'excel_headers_skills_optional': 'Habilidades adicionais',
        'optimization.all_vehicles': 'Minimizar veículos',
        'optimization.balance': 'Balancear',
        'optimization.open_start': 'Rotas com início aberto',
        'optimization.open_ended': 'Rotas com final aberto',
        'optimization.join': 'Unir similares',
        'optimization.join_v2': 'Unir similares 2.0',
        'optimization.last_position_optimize': 'Usar localização atual',
        'optimization.displayed_options': 'Exibir no menu',
        'optimization.default_values': 'Valores',
        'optimization.fmv': 'tráfego fator',
        'optimization.fmv.high': 'Lento',
        'optimization.fmv.normal': 'Normal',
        'optimization.fmv.low': 'Rápido',
        'optimization.single_tour' : 'Uma rota por veículo',
        'optimization.beauty': 'SimpliFy',
        'optimization.big_vrp': 'Big VRP',
        'optimization.use_euclidean_distance': 'Distância Euclidiana',
        'optimization.enable_graphs': 'Grafos',
        'optimization.auto_reorder': 'Reordenação automática',
        'optimization.enable_soft_window': 'Janelas de tempo flexíveis',
        'optimization.distance_to_join_visits': 'Juntar visitas por distância',
        'saving': 'Guardando',
        'notes': 'Notas',
        'error_between_dates': '* O intervalo de datas não pode exceder 31 dias',
        'error_date_start': '* A data de início é maior do que a data de término',
        'tracking_codes_visits_report': 'Relatório de visitas',
        'excel_tracking_codes_name': 'Relatório_de_tracking_codes_',
        'TC_REPORT': {
          'tracking_id': 'Tracking ID',
          'planned_date': 'Data prevista',
          'title': 'Título',
          'address': 'Endereço',
          'window_start': 'Janela de horário inicial 1',
          'window_end': 'Janela de horário final 1',
          'window_start_2': 'anela de horário inicial 2',
          'window_end_2': 'Janela de horário final 2',
          'comment': 'Comentários',
          'contact_name': 'Nome de contato',
          'contact_phone': 'Telefone de contato',
          'contact_email': 'Correio eletrônico de contato',
          'reference': 'Referência id',
          'time_service': 'tempo de serviço calculado',
          'visit_checking' : 'Checkin',
          'report_tc_success': 'Seu relatório foi gerado, em breve você receberá um email',
          'report_tc_error': 'Houve um erro ao gerar o relatório.'
        },
        'tracking_code_user_email': 'EMAIL DO DESTINATÁRIO',
        'optimization_requests_report': 'Relatório de otimizações',
        'visit_images_title_report': 'Relatório de imagens de visitas',
        'visit_images_name_picture': 'Nome da foto',
        'visit_images_select_option': 'Selecione uma opção',
        'visit_images_select_id_reference': 'referência ID',
        'visit_images_select_title_visit': 'Título da visita',
        'visit_images_toast_content_success': 'Seu relatório está sendo gerado. Ele chegará em seu e-mail em breve.',
        'visit_images_toast_content_wait_report': 'Você deve aguardar o término da execução do último relatório.',
        'visit_images_toast_content_error_report': 'Um erro inesperado ocorreu.',
        'visit_images_toast_content_no_images_found': 'Não há imagens na faixa de datas selecionada.',
        'visit_images_toast_max_images_reached': 'A gama de datas selecionadas não permite que o relatório gere. Você deve selecionar um intervalo de datas mais baixo.',
        'error_creating_report': 'Erro ao criar o relatório',
        'RK_REPORT': {
          'date': 'Data',
          'plan_name': 'Nome do plano',
          'vehicle_name': 'Nome do veículo',
          'real_kms': 'KMs reais',
          'total_dispatchs': 'Entregas totais',
          'pending_dispatchs': 'Entregas pendentes',
          'completed_dispatchs': 'Entregas realizadas',
          'failed_dispatchs': 'Entregas ñao realizadas',
          'start_time': 'Hora inicial da rota',
          'end_time': 'Hora final da rota'
        },
        'save_changes': 'Salvar alterações',
        'optimization.parameters': 'parâmetros de otimização',
        'optimization.parameters.traffic_factor': 'Fator de tráfego',
        'optimization.parameters.slow': 'Lento',
        'optimization.parameters.fast': 'Rápido',
        'optimization.parameters.beauty_factor': 'Nível de Zonificação',
        'optimization.parameters.beauty_min': 'Menos zonificado',
        'optimization.parameters.beauty_max': 'Mais zonificado',
        'optimization.tooltip': {
          'traffic_factor': 'Essa barra permite que você defina a velocidade da viagem entre as visitas que é levada em conta ao criar rotas. Ajuste-o apenas se considerar que os tempos de transferência calculados não se ajustam à sua frota',
          'balance': 'Todos os veículos ativos serão usados e um número equilibrado de visitas será atribuído entre eles.',
          'all_vehicles': 'As rotas serão criadas usando o menor número de veículos possível',
          'open_start': 'Suas rotas começarão na primeira parada e não necessariamente no depósito.',
          'open_ended': 'Suas rotas terminarão na última parada e não necessariamente no depósito.',
          'join': 'Se você tiver mais de uma visita com o mesmo endereço, a plataforma vai considerar como uma única visita ao criar a rota',
          'join_v2': 'Se você tiver mais de uma visita com o mesmo texto de endereço, a plataforma as considerará como uma única visita ao otimizar. As visitas serão divididas se excederem a carga máxima de veículos.',
          'single_tour': 'Às vezes, a rota criada pode propor que o veículo retorne ao depósito para depois sair de novo. Ao ativar esta opção, você indicar à plataforma que deseja programar apenas uma única saída por veículo.',
          'beauty': 'Algoritmo que cria rotas mais setorizadas',
          'beauty_factor': 'Essa barra permite que você configure como está zoneada a resposta do algoritmo SimpliFy',
          'big_vrp': 'Algoritmo para resolver grandes problemas de mais de 1000 visitas',
          'use_euclidean_distance': 'Utiliza uma média entre a distância euclidiana (em linha reta) e as distâncias obtidas do mapa, permitindo uma melhor representação do espaço.',
          'enable_graphs': 'Estrutura gráfica para acelerar a otimização, permitindo também rotas mais compactas.',
          'auto_reorder': 'As rotas são novamente otimizadas para alcançar uma melhor ordem e compacidade das mesmas.',
          'enable_soft_window': 'As janelas de tempo podem ser quebradas para incluir mais visitas nas rotas.',
          'on_foot': 'Se a sua frota é pedestre, seleccione esta optimização',
          'wave_routing': 'Você usará o roteamento de carga parcial com estimativa da demanda',
          'distance_to_join_visits': 'As visitas dentro do raio definido serão atribuídas consecutivamente no itinerário.',
          'radial_default': 'Sua rota mais otimizada em termos de distância/tempo, reduzindo os tempos de deslocamento de e para seu depósito.',
          'radial_to_near': 'Sua rota começará no ponto mais distante e terminará no ponto mais próximo de seu depósito.',
          'radial_to_far': 'Sua rota começará no ponto mais próximo e terminará no ponto mais distante de seu depósito.',
          'avoid_tolls': 'Suas rotas evitarão o trânsito em autoestradas ou estradas com pedágio.',
          'maximize_attended_load': 'A prioridade será dada às visitas com a carga mais alta 1. Se necessário, as visitas com a carga mais baixa serão deixadas de fora.',
          'prioritize_load': 'Ordena a rota priorizando primeiro as visitas com maior carga, considerando as restrições de janela de tempo.',
          'one_seller_per_vehicle': 'Cada veículo incluirá apenas visitas de um único seller. As rotas não combinarão visitas de sellers diferentes.'
        },
        'optimization.distance_to_join_visits_input': {
          'title': 'Configurar o rádio (metros)*',
          'placeholder': 'Digite um valor de 0 a 100 metros',
          'error_required': 'Você deve inserir um valor inteiro entre 0 e 100 metros',
          'error_max_value': 'O valor introduzido excede o intervalo de distância'
        }
      },
      'Toast_skill': {
        'unselected_skill': 'Você deve selecionar pelo menos uma habilidade'
      },
      'Toast_vehicles': {
        'plan_vehicle_exceeded':'Existem problemas para criar veículos. Você tentou importar @:vehicle_excel_quantity veículos, mas você tem @:vehicle_available_create de @:vehicle_total_plan restantes.',
        'error_path_skills': 'Houve problemas ao consultar habilidades',
        'error_path_drivers': 'Houve problemas ao consultar os motoristas',
        'error_path_vehicles': 'Houve problemas ao consultar os veículos',
        'vehicle_not_found': 'Veículo não encontrado',
        'error_set_position_marker': 'Não foi possível obter o endereço, por favor, tente novamente.',
        'error_set_address': 'O endereço digitado está incorreto, corrija e tente novamente',
        'error_set_address_origin_country': 'Endereço de origem incorreto, diferente do país selecionado na construção do seu próprio país.',
        'error_set_address_destiny_country': 'Endereço de destino incorreto, diferente do país selecionado na construção do seu próprio país.',
        'error_set_address_origin_latlng0': 'Endereço de origem incorreto, corrija e tente novamente',
        'error_set_address_destiny_latlng0': 'Endereço de destino incorreto, corrija e tente novamente',
        'can_create_routes': 'Você pode ir para criar rotas!',
        'error_invalid_address_1'        : 'O endereço',
        'error_invalid_address_2'        : 'não existe',
        'success_import_vehicles'        : 'Os veículos foram importados',
        'error_empty_vehicles_list'      : 'Lista dos veículos vazios',
        'error_driver_not_found_1'       : 'O motorista',
        'error_driver_not_found_2'       : 'não está registado',
        'error_data_format'             :   'O arquivo enviado não está no formato correto. Corrija e tente novamente',
        'error_duplicate_vehicle_name_1'  : 'O nome do veículo',
        'error_duplicate_vehicle_name_2'  : 'já existe',
        'error_import'                    : 'Houve problemas para importar os veículos. Certifique-se de que os dados estão corretos',
        'invalid_vehicles_ids'            : 'Alguns ids de veículos não são válidos. Por favor, certifique-se de que os veículos existem e tente novamente',
        'invalid_max_time'                : 'Jornada de trabalho: Você deve inserir um valor inteiro e maior que 0 para @:vehicle.',
        'codrivers_retrieval_error'       : 'Houve problemas ao consultar os co-pilotos, por favor tente novamente'
      },
      'Toast_users': {
        'no_users_error': 'Lista dos usuários vazios',
        'successful_import': 'Os usuários foram importados',
        'invalid_id_error': 'Alguns ids de usuários não são válidos. Por favor, certifique-se de que os usuários existem e tente novamente',
        'data_format_error': 'O arquivo enviado não está no formato correto. Corrija e tente novamente',
        'duplicate_username_error_1': 'O nome do usuário',
        'duplicate_username_error_2': 'já existe',
        'duplicate_email_error_1': 'O email',
        'duplicate_email_error_2': 'já existe',
        'unsuccessful_import': 'Houve problemas para importar os usuários. Certifique-se de que os dados estão corretos'
      },
      'Security': {
        'title'                    : 'Parâmetros de segurança de senha',
        'subtitle_web'             : 'Usuários da web',
        'subtitle_mobile'          : 'Usuários de aplicativo móvel',
        'description_web'          : 'Esses parâmetros se aplicarão a todos os usuários que usam os módulos da web (Planejamento de Rotas, Rastreamento, etc)',
        'description_mobile'       : 'Esses parâmetros se aplicarão a todos os usuários que usam o aplicativo móvel (piloto, co-piloto)',
        'should_uppercase'         : 'Deve conter pelo menos uma maiúscula',
        'should_lowercase'         : 'Deve conter pelo menos uma minúscula',
        'should_numeric'           : 'Deve conter pelo menos um dígito',
        'should_non_alphanumeric'  : 'Deve conter pelo menos um caractere especiais (não alfanumérico)',
        'should_min_length'        : 'Comprimento mínimo de caracteres',
        'default_min_length'       : '(Mínimo obrigatório 8)',
        'save'                     : 'Salvar',
        'error_message'            : 'Um erro ao salvar a sua configuração ocorreu, por favor, tente novamente.',
        'successful_message'       : 'A sua configuração foi salva com sucesso.',
        'invalid_password_length'  : 'O valor deve ser maior ou igual a 8',
        'settings_retrieval_error' : 'Um erro ao carregar a sua configuração de senha ocorreu, por favor, tente novamente.',
        'password_expiration'      : 'Período de expiração da senha',
        'password_expiration_unit' : '(em dias)',
        'invalid_password_renewal_value': 'Você deve selecionar uma opção válida',
        'password_expiration_disabled'     : 'Nunca',
        'idle_title'               : 'Logout automático',
        'idle_config'              : 'Logout automático após',
        'idle_description'         : 'Esta configuração se aplica apenas os usuários da web',
        'idle_15'                  : '15 minutos',
        'idle_30'                  : '30 minutos',
        'idle_45'                  : '45 minutos',
        'idle_60'                  : '1 hora',
        'idle_120'                 : '2 horas',
        'idle_180'                 : '3 horas',
        'idle_240'                 : '4 horas'
      },
      'Communication': {
        'title': 'notificações ao cliente final',
        'title_detail': 'Mensagem para o cliente final',
        'delete_property_sms': 'Excluir SMS',
        'delete_property_wsp': 'Excluir Whatsapp',
        'label_sms': 'Mensagem',
        'warning_text_too_large': 'O conteúdo da sua mensagem é muito longo',
        'warning_maxlength': 'Texto muito longo',
        'warning_required': 'Campo obrigatório',
        'preview_title': 'Visualização da mensagem',
        'close': 'Fechar',
        'cancel': 'Cancelar',
        'save': 'Salvar',
        'delete': 'Excluir',
        'modal_delete_event_title': 'Remover evento',
        'modal_message_1': 'Esta ação é irreversível',
        'modal_message_2': 'Você deseja continuar?',
        'visit_scheduled': 'Rota criada',
        'route_started': 'Rota iniciada',
        'checkout_success': 'Entregue com sucesso',
        'checkout_failed': 'Entrega não realizada',
        'on_its_way': 'A caminho',
        'insert': 'Inserir',
        'rendering_type': 'Tipo',
        'insert_extrafields': 'Insira campos extras',
        'delete_property_email': 'Suprimir o EMAIL',
        'label_email_subject': 'assunto',
        'label_email_msg': 'mensagem',
        'comments': 'Comentários',
        'attachment': 'Anexar fotos',
        'attachment_tooltip': 'Anexou ao correio as fotos tiradas pelo motorista quando fez a visita ao lugar',
        'id_reference': 'ID-REF-123',
        'signature_link': 'Assinatura',
        'timeline': 'Linha do tempo',
        'checkout_status_pdf': 'Estado do checkout como PDF',
        'items_table': 'Tabela de itens',
        'warning_repeated_tag': 'A etiqueta já existe no assunto',
        'livetracking_widget': 'Livetracking widget',
        'generate_insertion_code': 'Gerar código de inserção',
        'insertion_code': 'Código de inserção',
        'copy_code': 'Código de cópia',
        'search': 'Pesquisar',
        'custom_tracking_code': 'Use o id da visita como código de rastreamento',
        'custom_tracking_code_tooltip': 'Ao usar esta opçao, Live Tracking usará o texto que voçe inserium em cada visita no campo "Referência id". Voçe debe certificar-se de que este campo é exclusivo e que nao contém caracteres extranhos ou Live Tracking não funcionará corretamente',
        'visit_title': 'Título de visita',
        'visit_address': 'Endereço de visita',
        'visit_observation': 'Motivos de visita',
        'eta_range': 'Tempo de entrega',
        'delivery_time_range_label': 'Intervalo horário de entrega',
        'delivery_time_range_preview': 'Horário AM',
        'from_name' : 'Nome do remetente',
        'from_email' : 'Email do remetente',
        'success_msg' : 'Alteração feita com sucesso',
        'visit_date_label' : 'Data da visita',
        'visit_date_preview' : '10-12-2021',
        'send_preview_email': 'Enviar e-mail de teste para: ',
        'preview_email_label': 'Digite o e-mail',
        'preview_email_success': 'Enviado com sucesso',
        'preview_email_failed': 'Falha no envio, tente novamente',
        'preview_email_activate': 'Ative a sua conta para enviar e-mails de teste',
        'preview_email_buttom': 'Enviar e-mail de teste',
        'error_email_length_message'    : 'Um dos emails é muito longo',
        'error_max_emails_message_1'    : 'Você pode adicionar até',
        'error_max_emails_message_2'    : 'emails',
        'msg_error_email_valid' : '* email formato inválido',
        'user_checkout_label' : 'Autor do checkout',
        'wsp_title': 'Selecione a mensagem WhatsApp que melhor se adapta à sua operação.',
        'wsp_orders': 'Pedidos',
        'wsp_services': 'Serviços',
        'wsp_visits': 'Visitas',
        'wsp':{
          'visit_scheduled': {
            'orders': {
              'template1': 'O pedido de {ACCOUNT_NAME} foi programado. Siga seu tracking em {TRACKING_URL}',
              'template2': 'O pedido de {ACCOUNT_NAME} foi programado. Será entregue em {VISIT_ADDRESS}. Siga seu tracking em {TRACKING_URL}'
            },
            'services': {
              'template1': 'Olá {VISIT_TITLE}, seu serviço {ID_REFERENCE} foi agendado e será realizado em {VISIT_ADDRESS}. Siga aqui {TRACKING_URL} seu progresso.',
              'template2': 'Seu serviço {ACCOUNT_NAME} já foi agendado e será entregue em {VISIT_ADDRESS}. Acompanhe aqui {TRACKING_URL} seu progresso.',
              'template3': 'Olá {ID_REFERENCE}, seu serviço {VISIT_TITLE} foi agendado e será realizado em {VISIT_ADDRESS}. Acompanhe aqui {TRACKING_URL} seu progresso.'
            },
            'visits': {
              'template1': 'Sua visita {ACCOUNT_NAME} foi agendada e será realizada em {VISIT_ADDRESS}. Acompanhe aqui {TRACKING_URL} seu progresso.',
              'template2': 'Olá {VISIT_TITLE}, sua visita {ID_REFERENCE} foi agendada e será realizada em {VISIT_ADDRESS}. Acompanhe aqui {TRACKING_URL} seu progresso.',
              'template3': 'Olá {ID_REFERENCE}, sua visita {VISIT_TITLE} foi agendada e será realizada em {VISIT_ADDRESS}. Acompanhe aqui {TRACKING_URL} seu progresso.'
            }
          },
          'route_started':{
            'orders': {
              'template1': 'O pedido de {ACCOUNT_NAME} já está em rota de entrega. A hora estimada de chegada é {ETA_RANGE}. Siga seu tracking em {TRACKING_URL}',
              'template2': 'O pedido de {ACCOUNT_NAME} já está em rota e será entregue em {VISIT_ADDRESS}. A hora estimada de chegada é {ETA_RANGE}. Siga seu tracking em {TRACKING_URL}',
              'template3': 'O pedido de {ACCOUNT_NAME} já está em rota de entrega. Siga seu tracking em {TRACKING_URL}',
              'template4': 'O pedido de {ACCOUNT_NAME} já está em rota e será entregue em {VISIT_ADDRESS}. Siga seu tracking em {TRACKING_URL}'
            },
            'services': {
              'template1': 'Seu serviço {ACCOUNT_NAME} chegará hoje a {VISIT_ADDRESS}. A hora estimada de chegada é {ETA_RANGE}. Siga aqui {TRACKING_URL} a sua rota.',
              'template2': 'Seu serviço {ACCOUNT_NAME} chegará hoje a {VISIT_ADDRESS}. Siga aqui {TRACKING_URL} a sua rota.',
              'template3': 'Seu serviço de {ID_REFERENCE} chegará hoje a {VISIT_ADDRESS}. A hora estimada de chegada é {ETA_RANGE}. Siga aqui {TRACKING_URL} a sua rota.',
              'template4': 'Seu serviço de {ID_REFERENCE} chegará hoje a {VISIT_ADDRESS}. Siga aqui {TRACKING_URL} a sua rota.',
              'template5': 'Seu serviço {VISIT_TITLE} chegará hoje a {VISIT_ADDRESS}. A hora estimada de chegada é {ETA_RANGE}. Siga aqui {TRACKING_URL} a sua rota.',
              'template6': 'Seu serviço {VISIT_TITLE} chegará hoje a {VISIT_ADDRESS}. Siga aqui {TRACKING_URL} a sua rota.'
            },
            'visits': {
              'template1': 'A visita de {ACCOUNT_NAME} chegará hoje a {VISIT_ADDRESS}. A hora estimada de chegada é {ETA_RANGE}. Siga aqui {TRACKING_URL} a sua rota.',
              'template2': 'A visita de {ACCOUNT_NAME} chegará hoje a {VISIT_ADDRESS}. Siga aqui {TRACKING_URL} a sua rota.',
              'template3': 'A visita de {ID_REFERENCE} chegará hoje a {VISIT_ADDRESS}. A hora estimada de chegada é {ETA_RANGE}. Siga aqui {TRACKING_URL} a sua rota.',
              'template4': 'A visita de {ID_REFERENCE} chegará hoje a {VISIT_ADDRESS}. Siga aqui {TRACKING_URL} a sua rota.',
              'template5': 'A visita de {VISIT_TITLE} chegará hoje a {VISIT_ADDRESS}. A hora estimada de chegada é {ETA_RANGE}. Siga aqui {TRACKING_URL} a sua rota.',
              'template6': 'A visita de {VISIT_TITLE} chegará hoje a {VISIT_ADDRESS}. Siga aqui {TRACKING_URL} a sua rota.'
            }
          },
          'checkout_success':{
            'orders': {
              'template1': 'O pedido de {ACCOUNT_NAME} foi entregue corretamente. Por favor, revisar os detalhes em {TRACKING_URL}',
              'template2': 'O pedido de {ACCOUNT_NAME} foi entregue corretamente em {VISIT_ADDRESS}. Por favor, revisar os detalhes em {TRACKING_URL}'
            },
            'services': {
              'template1': 'Seu serviço de {ACCOUNT_NAME} foi realizado com sucesso. Revise aqui {TRACKING_URL} para obter mais detalhes.',
              'template2': 'Seu serviço de {ACCOUNT_NAME} foi concluído com sucesso em {VISIT_ADDRESS}. Revise aqui {TRACKING_URL} para obter mais detalhes.',
              'template3': 'Seu serviço de {ID_REFERENCE} foi realizado com sucesso. Revise aqui {TRACKING_URL} para obter mais detalhes.',
              'template4': 'Seu serviço de {ID_REFERENCE} foi concluído com sucesso em {VISIT_ADDRESS}. Revise aqui {TRACKING_URL} para obter mais detalhes.',
              'template5': 'Seu serviço de {VISIT_TITLE} foi realizado com sucesso. Revise aqui {TRACKING_URL} para obter mais detalhes.',
              'template6': 'Seu serviço de {VISIT_TITLE} foi concluído com sucesso em {VISIT_ADDRESS}. Revise aqui {TRACKING_URL} para obter mais detalhes.'
            },
            'visits': {
              'template1': 'Sua visita de {ACCOUNT_NAME} foi um sucesso. Revise aqui {TRACKING_URL} para obter mais detalhes.',
              'template2': 'Sua visita de {ACCOUNT_NAME} foi realizada com sucesso em {VISIT_ADDRESS}. Revise aqui {TRACKING_URL} para obter mais detalhes.',
              'template3': 'Sua visita de {ID_REFERENCE} foi um sucesso. Revise aqui {TRACKING_URL} para obter mais detalhes.',
              'template4': 'Sua visita de {ID_REFERENCE} foi realizada com sucesso em {VISIT_ADDRESS}. Revise aqui {TRACKING_URL} para obter mais detalhes.',
              'template5': 'Sua visita de {VISIT_TITLE} foi um sucesso. Revise aqui {TRACKING_URL} para obter mais detalhes.',
              'template6': 'Sua visita de {VISIT_TITLE} foi realizada com sucesso em {VISIT_ADDRESS}. Revise aqui {TRACKING_URL} para obter mais detalhes.'
            }
          },
          'checkout_failed':{
            'orders': {
              'template1': 'O pedido de {ACCOUNT_NAME} não pode ser entregue. Por favor, revisar os detalhes em {TRACKING_URL}',
              'template2': 'O pedido de {ACCOUNT_NAME} não pode ser entregue em {VISIT_ADDRESS}. Por favor, revisar os detalhes em {TRACKING_URL}'
            },
            'services': {
              'template1': 'Seu serviço de {ACCOUNT_NAME} não pôde ser realizado. Revise aqui {TRACKING_URL} para obter detalhes.',
              'template2': 'Seu serviço de {ACCOUNT_NAME} não pôde ser realizado em {VISIT_ADDRESS}. Por favor, revise aqui {TRACKING_URL} para mais detalhes.',
              'template3': 'Seu serviço de {ID_REFERENCE} não pôde ser realizado. Revise aqui {TRACKING_URL} para obter detalhes.',
              'template4': 'Seu serviço de {ID_REFERENCE} não pôde ser realizado em {VISIT_ADDRESS}. Por favor, revise aqui {TRACKING_URL} para obter mais detalhes.',
              'template5': 'Seu serviço de {VISIT_TITLE} não pôde ser realizado. Revise aqui {TRACKING_URL} para obter detalhes.',
              'template6': 'Seu serviço de {VISIT_TITLE} não pôde ser realizado em {VISIT_ADDRESS}. Por favor, revise aqui {TRACKING_URL} para obter mais detalhes.'
            },
            'visits': {
              'template1': 'Sua visita de {ACCOUNT_NAME} não pôde ser realizada. Por favor, revise aqui {TRACKING_URL} para mais detalhes.',
              'template2': 'Sua visita de {ACCOUNT_NAME} não pôde ser realizada em {VISIT_ADDRESS}. Por favor, revise aqui {TRACKING_URL} para obter mais detalhes.',
              'template3': 'Sua visita de {ID_REFERENCE} não pôde ser realizada. Por favor, revise aqui {TRACKING_URL} para obter mais detalhes.',
              'template4': 'Sua visita de {ID_REFERENCE} não pôde ser realizada em {VISIT_ADDRESS}. Por favor, revise aqui {TRACKING_URL} para obter mais detalhes.',
              'template5': 'Sua visita de {VISIT_TITLE} não pôde ser realizada em {VISIT_ADDRESS}. Por favor, revise aqui {TRACKING_URL} para obter mais detalhes.',
              'template6': 'Sua visita de {VISIT_TITLE} não pôde ser realizada. Por favor, revise aqui {TRACKING_URL} para obter mais detalhes.'
            }
          },
          'on_its_way':{
            'orders': {
              'template1': 'O pedido de {ACCOUNT_NAME} está a caminho. Siga seu tracking em {TRACKING_URL}',
              'template2': 'O pedido de {ACCOUNT_NAME} está a caminho e será entregue em {VISIT_ADDRESS}. Siga seu tracking em {TRACKING_URL}'
            },
            'services': {
              'template1': 'Seu serviço {ACCOUNT_NAME} está a caminho a {VISIT_ADDRESS}. Siga aqui {TRACKING_URL} em tempo real.',
              'template2': 'Seu serviço {ACCOUNT_NAME} está a caminho. Siga aqui {TRACKING_URL} em tempo real.',
              'template3': 'Seu serviço {ID_REFERENCE} está a caminho a {VISIT_ADDRESS}. Siga aqui {TRACKING_URL} em tempo real.',
              'template4': 'Seu serviço {ID_REFERENCE} está a caminho. Siga aqui {TRACKING_URL} em tempo real.',
              'template5': 'Seu serviço {VISIT_TITLE} está a caminho a {VISIT_ADDRESS}. Siga aqui {TRACKING_URL} em tempo real.',
              'template6': 'Seu serviço {VISIT_TITLE} está a caminho. Siga aqui {TRACKING_URL} em tempo real.'
            },
            'visits': {
              'template1': 'Sua visita de {ACCOUNT_NAME} está a caminho e chegará a {VISIT_ADDRESS}. Siga aqui {TRACKING_URL} em tempo real.',
              'template2': 'A visita de {ACCOUNT_NAME} está a caminho. Siga aqui {TRACKING_URL} em tempo real.',
              'template3': 'Sua visita de {ID_REFERENCE} está a caminho de {VISIT_ADDRESS}. Siga aqui {TRACKING_URL} em tempo real.',
              'template4': 'A visita de {ID_REFERENCE} está a caminho. Siga aqui {TRACKING_URL} em tempo real.',
              'template5': 'Sua visita de {VISIT_TITLE} está a caminho e chegará a {VISIT_ADDRESS}. Siga aqui o {TRACKING_URL} em tempo real.',
              'template6': 'A visita de {VISIT_TITLE} está a caminho. Siga aqui {TRACKING_URL} em tempo real.'
            }
          }
        },
        'tooltips': {
          'title': 'O Live Tracking permite enviar notificações via SMS e / ou email a cada alteração no status de suas visitas. Você pode personalizar a mensagem que será enviada automaticamente',
          'visit_scheduled': 'Esta mensagem é enviada quando você envia as rotas para os seus motoristas (ao salvar seu plano de rotas)',
          'route_started': 'Esta mensagem é enviada quando o motorista inicia a rota no aplicativo ',
          'checkout_success': 'Esta mensagem é enviada quando o motorista marca uma visita como sucesso',
          'checkout_failed': 'Esta mensagem é enviada quando o motorista marca uma visita como falhou',
          'on_its_way': 'Esta mensagem é enviada quando o motorista indica no aplicativo que está a caminho da visita'
        },
        'validate_pdf': {
          'fail': 'Parece o que o seu correio eletrónico não é compatível com o formato PDF. Corrija os errores e tente novamente.',
          'error': 'Houve um problema ao verificar o formato PDF. Tente novamente.'
        }
      },
      'Zones': {
        'enabled': 'Ativado',
        'disabled': 'Desativado',
        'button_edit': 'Editar',
        'add_zone': 'Criar nova zona',
        'Map': {
          'clear': 'Redefinir zonas'
        },
        'Edit': {
          'input_placeholder': 'Nome da zona',
          'cancel': 'Cancel',
          'save': 'Salvar',
          'save_success': 'Alterações salvas com sucesso.',
          'save_fail': 'Houve um problema ao salvar a zona'
        },
        'Items_list': {
          'title': 'Veículos',
          'msg_items_empty': 'você não tem veículos',
          'call_action': 'Criar veículo',
          'msg_empty_filter': 'Sua pesquisa não produziu resultados, tente novamente.'
        },
        'Delete': {
          'title': 'Excluir zona',
          'button_cancel': 'Cancel',
          'button_delete': 'Excluir',
          'irreversible_action': 'Esta ação é irreversível',
          'want_continue': 'Você deseja continuar?',
          'delete_success': 'Zona eliminada com sucesso',
          'delete_fail': 'Houve um problema ao excluir a zona'
        },
        'Bulk': {
          'btn_download_zones': 'Baixe zonas',
          'btn_import_zones': 'Atribuições de importação',
          'excel_header_vehicles': 'Veículos',
          'excel_header_coordinates': 'Coordenadas',
          'excel_header_zones': 'Nome da zona',
          'error_no_data': "O arquivo não possui dados válidos",
          'error_upload_failure': 'Erro ao enviar o arquivo de atribuição das zonas',
          'result_modal_title': 'Zonas atribuídas',
          'result_modal_upload_success':  'Suas atribuições de zonas foram feitas corretamente',
          'resut_modal_upload_with_errors': 'Ocorreram problemas ao carregar o arquivo',
          'result_modal_row_header': 'Linha',
          'result_modal_error_header': 'Error',
          'result_modal_error_vehicle_not_found': "O veículo não existe na sua conta",
          'result_modal_error_zone_not_found': "A zona não existe na sua conta"},
        'validation_error_name': 'Uma zona com este nome já existe.',
        'autozones_warning': 'As zonas estão desativadas, as zonas automáticas não terão efeito',
        'Actions': {
          'auto_zones': {
            'title': 'Atribuição automática de zona',
            'enable_auto_zones': 'Habilitado',
            'disable_auto_zones': 'Desabilitado'
          },
          'use_zones': {
            'title': 'otimização de rota',
            'use_zones': 'Use zones',
            'hide_zones': 'Esconder'
          },
          'save_actions_zones': 'Salvar',
          'success_zone_property': 'Alterações salvas com sucesso.',
          'error_zone_property': 'Ocorreu um problema, tente novamente'
        },
        'weekdays' : {
          'selection_validation_error': 'Você deve selecionar pelo menos um dia para salvar sua zona.',
          'active_days': 'Zona ativa os dias:',
          'every_day'  : 'Todos',
          'Monday'     : 'Seg',
          'Tuesday'    : 'Ter',
          'Wednesday'  : 'Qua',
          'Thursday'   : 'Qui',
          'Friday'     : 'Sex',
          'Saturday'   : 'Sab',
          'Sunday'     : 'Dom'
        },
        'view_zones': 'Visualizar zonas',
        'zone_configuration_title': 'Configuração de Zonas',
        'activate_zone_usage': 'Ativar uso de zonas',
        'automatic_assignment': 'Atribuição automática',
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.settings')
    .controller('SettingsController', SettingsController);

  /** @ngInject */
  function SettingsController($scope, $window, $filter, $log, driversService, vehicleService,
                              skillsService, addonsService, lodash, accountConfigsService,
                              $location, ACCOUNT_CONFIGS, $rootScope, sessionService,
                              sidebarUtils, settingsModulesService) {
    var vm = this;
    var $translateText = $filter('translate');
    var keyCommunication = 'live_tracking';
    var keyZones = 'zones';
    var keyWSP = 'wsp_pro';
    var keyActivepieces = 'activepieces';
    var keyRoles = 'roles';
    var keyLTAddon = 'live_tracking';
    var keyLTPersonalizationAddonProperty = 'live_tracking_personalization';
    var allowedRoutesForRouterUser = [
      '/settings/zones/',
      '/settings/optimizers/'
    ];

    $window.SettingsController = vm;

    vm.activeTab = 'vehicles';

    // Toggles
    vm.enableLiveTracking = false;
    vm.enableZones = false;
    vm.menuItems = null;
    vm.selectedItem = null;
    vm.enableWSP = false;
    vm.enableLTCustomization = false;
    vm.enableActivepieces = false;
    vm.enableRoles = false;
    vm.enableSettingsModuleForRouterUser = false;
    vm.user = null;

    vm.selectMenuItem = selectMenuItem;
    vm.isItemSelected = isItemSelected;
    vm.navigateTo = navigateTo;

    $scope.pagination = {
      firstText: $translateText('Settings.first_text'),
      lastText: $translateText('Settings.last_text'),
      nexText: $translateText('Settings.next_text'),
      previousText: $translateText('Settings.previous_text')
    };
    activate();


    ////////////

    function activate() {
      sessionService.getUser()
        .then(function(user) {
          vm.user = user;
          vm.enableSettingsModuleForRouterUser = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_SETTINGS_MODULE_FOR_ROUTER_USER) && user.is_router;
          return checkAddonsEnable();
        })
        .then(function () {
          vm.menuItems = settingsModulesService.setModulesToDisplay(_getSettingsModulesProps());
        })
        .then(initializeSelectedItem)
        .catch(function (error) {
          $log.info(error);
      });
    }

    function checkAddonsEnable() {
      return addonsService.listAddons()
        .then(function (addons) {
          vm.enableLiveTracking = searchAddon(addons, keyCommunication);
          vm.enableZones = searchAddon(addons, keyZones);
          vm.enableWSP = searchAddon(addons, keyWSP);
          vm.enableActivepieces = searchAddon(addons, keyActivepieces);
          vm.enableRoles = searchAddon(addons, keyRoles);
          // Check live_tracking_personalization addon property
          var livetrackingAddon = lodash.find(addons, function(obj) {
            return obj.key === keyLTAddon && obj.enable;
          });

          if (livetrackingAddon && livetrackingAddon.enable) {
            return addonsService
              .getAddonPropertyByKeyFiltered(livetrackingAddon.id, keyLTPersonalizationAddonProperty)
              .then(function (addonProperty) {
                vm.enableLTCustomization = addonProperty && String(addonProperty.value).toLowerCase() === "true";
              })
              .catch(function () {
                vm.enableLTCustomization = false;
              });
          }
      }).catch(function (error) {
        $log.info(error);
      });
    }

    function searchAddon(addons, key) {
      return lodash.result(lodash.find(addons, function(obj) {
        return obj.key === key;
      }), 'enable');
    }

    function isItemSelected(item) {
      if (item.submenu) {
        return item.submenu.items.some(function (item) {
          return $location.path().includes(item.href.slice(1));
        });
      }

      return $location.path().includes(item.href.slice(1));
    }

    function selectMenuItem(item) {
      if (vm.selectedItem && vm.selectedItem !== item && vm.selectedItem.submenu) {
        vm.selectedItem.submenu.isExpanded = false;
      }

      vm.selectedItem = item;
      if (vm.selectedItem.submenu) {
        vm.selectedItem.submenu.isExpanded = !vm.selectedItem.submenu.isExpanded;
      }
    }

    function initializeSelectedItem() {
      var itemSelected = false;

      Object.values(vm.menuItems).forEach(function (item) {
        if (isItemSelected(item)) {
          selectMenuItem(item);
          itemSelected = true;
        }
      });

      if (!itemSelected) {
        if (vm.enableSettingsModuleForRouterUser) {
          var defaultItem = vm.menuItems.optimizers;
          selectMenuItem(defaultItem);
          $location.path(defaultItem.href.slice(1));
        }
      }
    }

    var locationChangeListener = $rootScope.$on('$locationChangeStart', function (event) {
      var settingsPath = $location.path();
      if (vm.enableSettingsModuleForRouterUser && settingsPath.includes("/settings/")) {
        var isAllowedRoute = allowedRoutesForRouterUser.some(function (route) {
          return settingsPath.startsWith(route);
        });

        if (!isAllowedRoute) {
          event.preventDefault();
          $location.path('/settings/routing-options/');
        }
      }
    });

    function navigateTo(href) {
      if (href) {
        sidebarUtils.handleNavigation(href);
      }
    }

    $scope.$on('$destroy', function () {
      driversService.clear();
      vehicleService.clear();
      skillsService.clear();
      if (locationChangeListener) {
        locationChangeListener();
      }
    });

    function _getSettingsModulesProps() {
      return {
        user: vm.user,
        enableSettingsModuleForRouterUser: vm.enableSettingsModuleForRouterUser,
        enableZones: vm.enableZones,
        enableFleets: accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_FLEETS),
        enableLiveTracking: vm.enableLiveTracking,
        enableWSP: vm.enableWSP,
        enableActivepieces: vm.enableActivepieces,
        enableRoles: vm.enableRoles,
        enableLTCustomization: vm.enableLTCustomization
      };
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .constant("USER_ROLE", {
      "ADMIN": "admin",
      "DRIVER": "driver",
      "CODRIVER": "codriver",
      "MONITOR": "monitor",
      "COORDINATOR": "coordinator",
      "MONITOR_COORDINATOR": "monitor_coordinator",
      "ROUTER": "router",
      "ROUTER_JR": "router_jr"
    })
    .constant("USER_STATUS", {
      "ACTIVE": "active",
      "DELETED": "deleted",
      "BLOCKED": "blocked"
    })
    .constant("WEEKDAYS", ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]);
})();

(function() {
  'use strict';

  angular
    .module('icarus.plans', []);
})();

(function() {
  'use strict';

  var ENABLE_FLEETS = 'enable_fleets';
  var CAN_CREATE_CO_DRIVER = 'can_create_co_driver';

  angular
    .module('icarus.plans')
    .config(routeConfig);


  function onFailSetNull(methodPromise, returnedPromise) {
    methodPromise
      .then(function(data) {
        returnedPromise.resolve(data);
      })
      .catch(function() {
        returnedPromise.resolve(null);
      });

    return returnedPromise.promise;
  }

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('plans', {
        parent: 'main',
        url:  '/plans',
        controller: 'PlansController',
        controllerAs: 'vm',
        templateUrl: 'app/plans/plan-list.html',
        data:{
          authentication:  true
        }
      })
      .state('plans.detail', {
        url: '/:id',
        parent: 'plans',
        params: {
          plan: {},
          drivers: [],
          vehicles: [],
          fleet_id: null
        },
        resolve: {
          shareState: function($stateParams, $q, driverService, vehicleService, driverAssignService, store, codriverService) {
            var accountConfigs = store.get('accountConfigs');
            var promises = [null, null, null, null];
            var shareStatePromise = $q.defer();
            var shareState = {
              id: $stateParams.id,
              fleet_id: $stateParams.fleet_id,
              plan: $stateParams.plan,
              vehicles: $stateParams.vehicles,
              drivers: $stateParams.drivers,
              codrivers: null,
              planCodrivers: null,
              isEnabledConfigToCodrivers: isConfigEnabled(accountConfigs, CAN_CREATE_CO_DRIVER)
            };

            if (!shareState.vehicles || !shareState.vehicles.length) {
              promises[0] = onFailSetNull(vehicleService.list(), $q.defer());
            }

            if (!shareState.plan || !Object.keys(shareState.plan).length) {
              promises[1] = onFailSetNull(driverAssignService.getPlan(shareState.id), $q.defer());
            }

            if(shareState.isEnabledConfigToCodrivers) {
              promises[2] = onFailSetNull(codriverService.list(), $q.defer());
              promises[3] = onFailSetNull(codriverService.getPlanCodrivers(shareState.id), $q.defer());
            }


            $q.all(promises)
              .then(function(responses) {
                var indexMapping = { 0: 'vehicles', 1: 'plan', 2: 'codrivers', 3: 'planCodrivers' };
                responses.forEach(function(response, i) {
                  if (response) {
                    shareState[indexMapping[i]] = response;
                    if (indexMapping[i] === 'plan') {
                      shareState.fleet_id  = shareState.plan.fleet;
                    }
                  }
                });

                var driverPromise = null;

                if (shareState.fleet_id && isConfigEnabled(accountConfigs, ENABLE_FLEETS)) {
                  driverPromise = onFailSetNull(driverService.getByFleet(shareState.fleet_id), $q.defer());
                }
                else if (!shareState.drivers || !shareState.drivers.length) {
                  driverPromise = onFailSetNull(driverService.list(), $q.defer());
                }

                if (driverPromise !== null) {
                  driverPromise.then(function (drivers) {
                    shareState.drivers = drivers;
                    shareStatePromise.resolve(shareState);
                  });
                }
                else {
                  shareStatePromise.resolve(shareState);
                }

              });

            return shareStatePromise.promise;
          }
        },
        controller: 'PlansDetailController',
        controllerAs: 'vm',
        templateUrl: 'app/plans/plan-detail.html'
      });
  }

  function isConfigEnabled(accountConfigs, configName) {
    var enableConfig;
    if(accountConfigs) {
      enableConfig = accountConfigs.find(function (config) {
        return config.key === configName;
      });
    }
    return enableConfig ? enableConfig.value : false;
  }
})();

(function () {
  angular
    .module('icarus.plans')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {
    $translateProvider.translations('en', {
      'labels': {
        'eta': 'start time',
        'etd': 'end time'
      },
      'success': {
        'routes_updated': 'Routes updated'
      },
      'chips': {
        'saving': 'Saving...',
        'error': 'Error'
      },
      'errors': {
        'unable_to_fetch_plan': 'There was an error loading your plan',
        'unable_to_fetch_plans': 'There was an error loading your plans',
        'unable_to_fetch_drivers': 'There was an error loading your drivers',
        'unable_to_fetch_co_drivers': 'There was an error trying to fetch your co-drivers',
        'unable_to_fetch_co_drivers_by_plan': 'There was an error trying to fetch the co-drivers of the current plan',
        'unable_to_fetch_vehicles': 'There was an error loading your vehicles',
        'unable_to_fetch_routes': 'There was an error loading your routes',
        'unable_to_assign_drivers': 'There was a problem assigning drivers',
        'unable_to_fetch_fleets': 'There was an error loading your fleets',
      }
    });

    $translateProvider.translations('es', {
      'labels': {
        'eta': 'inicio',
        'etd': 'fin'
      },
      'success': {
        'routes_updated': 'Rutas actualizadas'
      },
      'chips': {
        'saving': 'Guardando...',
        'error': 'Error'
      },
      'errors': {
        'unable_to_fetch_plan': 'Hubo un error cargando tu plan',
        'unable_to_fetch_plans': 'Hubo un error cargando tus planes',
        'unable_to_fetch_drivers': 'Hubo un error cargando tus conductores',
        'unable_to_fetch_co_drivers': 'Hubo un error al tratar de cargar sus copilotos',
        'unable_to_fetch_co_drivers_by_plan': 'Hubo un error al tratar de cargar los copilotos del plan actual',
        'unable_to_fetch_vehicles': 'Hubo un error cargando tus vehículos',
        'unable_to_fetch_routes': 'Hubo un error cargando tus rutas',
        'unable_to_assign_drivers': 'Hubo un problema al asignar conductores',
        'unable_to_fetch_fleets': 'Hubo un error cargando tus flotas',
      }
    });

    $translateProvider.translations('pt', {
      'labels': {
        'eta': 'hora início',
        'etd': 'hora fim'
      },
      'success': {
        'routes_updated': 'Rotas atualizadas'
      },
      'chips': {
        'saving': 'Salvando...',
        'error': 'Erro'
      },
      'errors': {
        'unable_to_fetch_plan': 'Houve um erro ao tentar obter seu plano',
        'unable_to_fetch_plans': 'Houve um problema ao obter seus planos',
        'unable_to_fetch_drivers': 'Ocorreu um erro ao tentar procurar seus motoristas',
        'unable_to_fetch_co_drivers': 'Ocorreu um erro ao tentar buscar seus co-pilotos',
        'unable_to_fetch_co_drivers_by_plan': 'Ocorreu um erro ao tentar buscar os co-pilotos do plano atual',
        'unable_to_fetch_vehicles': 'Ocorreu um erro ao tentar procurar seus veículos',
        'unable_to_fetch_routes': 'Ocorreu um erro ao tentar procurar suas rotas',
        'unable_to_assign_drivers': 'Ocorreu um erro ao tentar atualizar os motoristas',
        'unable_to_fetch_fleets': 'Ocorreu um erro ao tentar procurar suas frotas',
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.plans')
    .controller('PlansController', plansController);

  /** @ngInject */
  function plansController(driverAssignService, Toasts, $filter, vehicleService, $state, plannerService,
                           store, driverService, fleetService, $q, planService) {
    var vm = this;
    var $translate = $filter('translate');
    var ENABLE_FLEETS = 'enable_fleets';
    var DRIVERS_DATA_INDEX = 1;
    var FLEETS_OR_DRIVER_DATA_INDEX = 2;
    var VEHICLES_DATA_INDEX = 3;
    var IS_NON_BLOCKING_SAVING_ENABLED_INDEX = 4;
    var FLEETS_DATA_INDEX = 0;
    var ENABLED = true;
    var DISABLED = false;

    vm.plans = [];
    vm.vehicles = null;
    vm.drivers = null;
    vm.fleets = null;
    vm.loadingPlans = false;

    vm.enabledFleetsConfig = false;
    vm.safeSrcPlans = [];
    vm.searchText = "";
    vm.enableFleetLogic = DISABLED;
    vm.fleetSelected = null;
    vm.isNonBlockingSavingEnabled = false;
    vm.activeDraftPlanIds = [];

    vm.onChangeSearch = onChangeSearch;
    vm.onChangeSelectedFleet = onChangeSelectedFleet;
    vm.selectPlan = selectPlan;

    vm.pagination = {
      currentPage: 1,
      itemsPerPage: 15,
      maxSize: 5,
      pageChanged: function () {
      }
    };

    init();

    function fetchData(methodPromise, translationKeyError) {
      return $q(function (resolve, reject) {
        methodPromise
          .then(function (data) {
            resolve(data);
          })
          .catch(function () {
            reject($translate(translationKeyError));
          });
      });
    }

    function fetchFleetOrDrivers() {
      return $q(function (resolve, reject) {
        fetchData(fleetService.getMyFleets(), 'errors.unable_to_fetch_fleets')
          .then(function (fleetData) {
            if (fleetData.length) {
              resolve([fleetData, null]);
            } else {
              fetchData(driverService.list(), 'errors.unable_to_fetch_drivers')
                .then(function (driverData) {
                  resolve([null, driverData]);
                })
                .catch(function (err) {
                  reject(err);
                });
            }
          })
          .catch(function (err) {
            reject(err);
          });
      });
    }

    function getFleetSelectedOrDefault() {
      var fleetFound = null;
      var fleetSelected = plannerService.getSelectedFleet();
      if (fleetSelected) {
        fleetFound = vm.fleets.find(function (fleet) {
          return fleet.id === fleetSelected.id;
        });
      }
      return fleetFound || vm.fleets[0];
    }

    function resolvePromiseDefault(value) {
      var returnedPromise = $q.defer();
      returnedPromise.resolve(value);
      return returnedPromise.promise;
    }

    function errorHandler(errorMsg) {
      Toasts.push('error', errorMsg);
    }

    function orderPlans() {
      vm.plans.sort(function (planA, planB) {
        return new Date(planB.created) - new Date(planA.created);
      });
    }

    function loadDataInView(results) {
      vm.vehicles = results[VEHICLES_DATA_INDEX];
      vm.fleets = results[FLEETS_OR_DRIVER_DATA_INDEX][FLEETS_DATA_INDEX];

      vm.enableFleetLogic = vm.enabledFleetsConfig && (Boolean(vm.fleets) && Boolean(vm.fleets.length));

      if (vm.enabledFleetsConfig === DISABLED) {
        vm.drivers = results[DRIVERS_DATA_INDEX];
      } else if (vm.enableFleetLogic === DISABLED) {
        vm.drivers = results[FLEETS_OR_DRIVER_DATA_INDEX][DRIVERS_DATA_INDEX];
      }

      if (vm.enableFleetLogic === ENABLED) {
        vm.fleetSelected = getFleetSelectedOrDefault();
        onChangeSelectedFleet();
      } else {
        fetchData(driverAssignService.getPlans(), 'errors.unable_to_fetch_plans')
          .then(function (plans) {
            vm.plans = plans;
            orderPlans();
            vm.safeSrcPlans = angular.copy(vm.plans);
            vm.activeDraftPlanIds = planService.getActiveDraftPlanIds(vm.isNonBlockingSavingEnabled, vm.safeSrcPlans, vm.activeDraftPlanIds);
            vm.loadingPlans = false;
          })
          .catch(errorHandler);
      }
    }

    function init() {
      vm.loadingPlans = true;
      var promises = Array(6);

      vm.enabledFleetsConfig = isFleetsEnabled();

      promises[VEHICLES_DATA_INDEX] = fetchData(vehicleService.list(), 'errors.unable_to_fetch_vehicles');

      promises[IS_NON_BLOCKING_SAVING_ENABLED_INDEX] = planService.isNonBlockingSavingEnabled();

      if (vm.enabledFleetsConfig === ENABLED) {
        promises[DRIVERS_DATA_INDEX] = resolvePromiseDefault(null);
        promises[FLEETS_OR_DRIVER_DATA_INDEX] = fetchFleetOrDrivers();
      } else {
        promises[DRIVERS_DATA_INDEX] = fetchData(driverService.list(), 'errors.unable_to_fetch_drivers');
        promises[FLEETS_OR_DRIVER_DATA_INDEX] = resolvePromiseDefault([null, null]);
      }

      return $q.all(promises)
        .then(function (results) {
          vm.isNonBlockingSavingEnabled = results[IS_NON_BLOCKING_SAVING_ENABLED_INDEX];
          return planService.getPendingDraftPlanIds(vm.isNonBlockingSavingEnabled)
            .then(function (draftPlanIds) {
              vm.activeDraftPlanIds = draftPlanIds;
              return results;
            });
        })
        .then(loadDataInView)
        .catch(errorHandler);
    }

    function onChangeSearch() {
      var text = vm.searchText.toLowerCase().trim();

      if (!Boolean(text) && vm.enableFleetLogic === DISABLED) {
        vm.safeSrcPlans = angular.copy(vm.plans);
      } else {
        vm.safeSrcPlans = angular.copy(vm.plans.filter(filteringCriteria(text)));
      }

      vm.activeDraftPlanIds = planService.getActiveDraftPlanIds(vm.isNonBlockingSavingEnabled, vm.safeSrcPlans, vm.activeDraftPlanIds);
    }

    function onChangeSelectedFleet() {
      vm.safeSrcPlans = [];
      vm.loadingPlans = true;
      if (vm.fleetSelected) {
        fetchData(
          driverAssignService.getPlansByFleet(vm.fleetSelected.id), 'errors.unable_to_fetch_plans'
        ).then(function (response) {
          vm.plans = response;
          orderPlans();
          onChangeSearch();
          vm.loadingPlans = false;
        }).catch(errorHandler);
      }
    }

    function filteringCriteria(text) {
      return function (plan) {
        return (plan.name.toLowerCase().includes(text)
          || plan.startDate.includes(text)
          || plan.endDate.includes(text));
      };
    }

    function selectPlan(plan) {
      var option = {id: plan.id, fleetId: null, plan: plan, vehicles: vm.vehicles, drivers: null};
      if (vm.enableFleetLogic === ENABLED) {
        option.fleetId = vm.fleetSelected.id;
      } else {
        option.drivers = vm.drivers;
      }
      $state.go('plans.detail', option);
    }

    function isFleetsEnabled() {
      var accountConfigs = store.get('accountConfigs');
      var enableFleetConfig;
      if (accountConfigs) {
        enableFleetConfig = accountConfigs.find(function (config) {
          return config.key === ENABLE_FLEETS;
        });
      }

      return enableFleetConfig ? enableFleetConfig.value : false;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.plans')
    .controller('PlansDetailController', planDetailController);

  /** @ngInject */
  function planDetailController(
    driverAssignService, shareState, Toasts, $filter, $state,
    timeUtils, ngDialog, driverSelectMapper, addonsService, TMS_ADD_ON_KEY,
    accountConfigsService, ACCOUNT_CONFIGS
  ) {
    var vm = this;
    var $translate = $filter('translate');
    var $localeCompare = $filter("localeCompare");
    vm.routes = null;
    vm.planVehicles = null;
    vm.isTmsEnable = false;
    vm.save = save;
    vm.enableSaveButton = true;
    vm.plan = shareState.plan;
    vm.drivers = shareState.drivers;
    vm.codrivers = shareState.codrivers;
    vm.planCodrivers = shareState.planCodrivers;
    vm.isEnabledConfigToCodrivers = shareState.isEnabledConfigToCodrivers;
    vm.isMultiDriversConfigEnabled = accountConfigsService.isConfigEnabled(ACCOUNT_CONFIGS.ENABLE_MULTI_DRIVERS);
    vm.existCodrivers = vm.codrivers && vm.codrivers.length > 0;
    vm.vehicles = shareState.vehicles;
    vm.fleet = shareState.fleetId;
    vm.dateOptions = {
      formatYear: 'yyyy',
      formatDayHeader: 'EEE',
      formatDayTitle: 'MMMM',
      formatDay: 'd',
      showWeeks: false,
      maxMode: 'day',
      startingDay: 0,
      minDate: new Date()
    };
    vm.driverSelectInfo = {
      drivers: [],
      onClickOption: onChangeDriverSelect
    };

    vm.showCodriversModal = showCodriversModal;

    init();

    function init() {
      notifyMissingData();
      if (vm.drivers) {
        vm.drivers.sort(function (driverA, driverB) {
          return $localeCompare(driverA.name, driverB.name);
        });
        vm.driverSelectInfo.drivers = driverSelectMapper.formatList(vm.drivers || []);
      }

      var routesPromise = vm.fleet ? driverAssignService.getRoutesByFleet(shareState.id, vm.fleet) : driverAssignService.getRoutes(shareState.id);
      routesPromise
        .then(function (routes) {
          vm.routes = routes.map(function (route) {
            return _getExtendedRouteInfo(route, vm.vehicles, vm.planCodrivers);
          });

          vm.planVehicles = _getVehiclesOfTheCurrentPlan(vm.routes);
        })
        .catch(function () {
          Toasts.push('error', $translate('errors.unable_to_fetch_routes'));
        });
      addonsService.isAddonEnable(TMS_ADD_ON_KEY).then(function(isTmsEnable) {
        vm.isTmsEnable = isTmsEnable;
      });
    }

    function notifyMissingData() {
      if (!vm.plan) {
        Toasts.push('error', $translate('errors.unable_to_fetch_plan'));
      }

      if (!vm.vehicles) {
        Toasts.push('error', $translate('errors.unable_to_fetch_vehicles'));
      }

      if (!vm.drivers) {
        Toasts.push('error', $translate('errors.unable_to_fetch_drivers'));
      }

      if (!vm.codrivers && vm.isEnabledConfigToCodrivers) {
        Toasts.push('error', $translate('errors.unable_to_fetch_co_drivers'));
      }

      if (!vm.planCodrivers && vm.isEnabledConfigToCodrivers) {
        Toasts.push('error', $translate('errors.unable_to_fetch_co_drivers_by_plan'));
      }
    }

    function save(routes) {
      vm.enableSaveButton = false;
      driverAssignService.assignDrivers(routes)
        .then(function () {
          Toasts.push('success', $translate('success.routes_updated'));
          $state.go('^', {}, {location: 'replace'});
        })
        .catch(function () {
          Toasts.push('error', $translate('errors.unable_to_assign_drivers'));
        })
        .finally(function () {
          vm.enableSaveButton = true;
        });
    }

    function _getExtendedRouteInfo(route, vehicles, planCodrivers) {
      var routeToTransform = Object.assign({}, route);

      // Add vehicle name
      if (vehicles instanceof Array && vehicles.length > 0 && routeToTransform.vehicleId) {
        var vehicle = vehicles.find(function (vehicle) {
          return vehicle.id === routeToTransform.vehicleId;
        });

        routeToTransform.vehicleName = vehicle ? vehicle.name : undefined;
      }

      // Format start and end time
      routeToTransform.estimatedTimeStart = timeUtils.formatTime(
        timeUtils.createTime(routeToTransform.estimatedTimeStart, "HH:mm:ss"), "HH:mm"
      );
      routeToTransform.estimatedTimeEnd = timeUtils.formatTime(
        timeUtils.createTime(routeToTransform.estimatedTimeEnd, "HH:mm:ss"), "HH:mm"
      );

      // Add codrivers
      if(planCodrivers) {
        var routeFound = planCodrivers.find(function (dataByRoute) {
          return dataByRoute.route_id === routeToTransform.id;
        });

        routeToTransform.codrivers = routeFound && routeFound.codrivers ? routeFound.codrivers : [];
      } else {
        routeToTransform.codrivers = [];
      }

      return routeToTransform;
    }

    /**
     * Return an array with all vehicles of the current plan.
     * Each element is an object and each object has the name of the vehicle,
     * the routes of the vehicle and its co-drivers (if the route has them).
     *  @param { Array }
     *  @return { Array }
     */

     function _getVehiclesOfTheCurrentPlan(routes) {
      var planVehicles = routes.reduce(function (accVehicles, route) {
        var vehicle = {
          name: route.vehicleName,
          routes: [route]
        };

        if(route.codrivers) vehicle.codrivers = route.codrivers;
        !accVehicles[route.vehicleId] ? accVehicles[route.vehicleId] = vehicle : accVehicles[route.vehicleId].routes.push(route);
        var positionOfRoute = accVehicles[route.vehicleId].routes.indexOf(route) + 1;
        route.name = $translate("Routes.route_text") + positionOfRoute;
        return accVehicles;
      }, {});

      return Object.values(planVehicles);
    }

    function showCodriversModal(vehicle, codrivers, route) {
      var routesToEdit = route && vm.isMultiDriversConfigEnabled ? [route] : (vehicle ? vehicle.routes : []);
      
      var dialog = ngDialog.open({
        template: "app/plans/codrivers-modal.html",
        className: "ngdialog-theme-default custom-width-800",
        controller: "CodriversModalController",
        controllerAs: "vm",
        showClose: false,
        closeByEscape: false,
        closeByDocument: false,
        resolve: {
          vehicleRoutes: function () {
            return routesToEdit;
          },
          vehicleName: function() {
            return vehicle ? vehicle.name : '';
          },
          codrivers: function () {
            return codrivers;
          },
          isSingleRoute: function() {
            return route && vm.isMultiDriversConfigEnabled;
          }
        }
      });

      return dialog.closePromise
        .then(function (response) {
          if (response.value) {
            routesToEdit.forEach(function (routeToUpdate) {
              angular.copy(response.value, routeToUpdate.codrivers);
            });
          }
        });
    }

    function onChangeDriverSelect(selectedId, context) {
      context.route.driverId = selectedId;
      vm.driverSelectInfo.drivers = driverSelectMapper.formatList(vm.drivers || []);
    }

  }
})();

(function () {
  angular
    .module('icarus.plans')
    .factory('driverAssignService', driverAssignFactory);

  /** @ngInject */
  function driverAssignFactory($http, __env, $q) {
    var plansUrl = __env.API_URL + 'routes/plans/';
    var routesUrl = __env.API_URL + 'routes/routes/';
    var plansByFleetUrl = __env.API_URL + 'routes/plans/fleet/';
    return {
      'getPlans': getPlans,
      'getPlan': getPlan,
      'assignDrivers': assignDrivers,
      'getRoutes': getRoutes,
      'getPlansByFleet': getPlansByFleet,
      'getRoutesByFleet': getRoutesByFleet,
    };

    function getPlans() {
      return $http.get(plansUrl)
        .then(function (response) {
          return response.data.map(function (plan) {
            return camelCaseObj(plan, ['modified']);
          });
        });
    }

    function getPlansByFleet(fleet_id) {
      return $http.get(plansByFleetUrl + fleet_id + '/')
        .then(function (response) {
          return response.data.map(function (plan) {
            return camelCaseObj(plan, ['modified']);
          });
        });
    }

    function getPlan(planId) {
      return $http.get(plansUrl + planId)
        .then(function(response) {
          return camelCaseObj(response.data, ['modified']);
        });
    }

    function getRoutes(planId) {
      return $http.get(routesUrl + '?plan=' + planId)
        .then(function (response) {
          return parseRoutes(response.data);
        });
    }

    function getRoutesByFleet(planId, fleetId) {
      return $http.get(routesUrl + '?plan=' + planId + '&fleet=' + fleetId)
        .then(function (response) {
          return parseRoutes(response.data);
        });
    }

    function parseKilometers(value) {
      return (value / 1000).toFixed(1).toString();
    }

    function parseRoutes(routes) {
      return routes.map(function (route) {
        return {
          driverId: route.driver ? route.driver : null,
          vehicleId: route.vehicle ? route.vehicle : null,
          kms: parseKilometers(route.total_distance),
          duration: route.total_duration,
          estimatedTimeStart: route.estimated_time_start,
          estimatedTimeEnd: route.estimated_time_end,
          plannedDate: route.planned_date,
          planId: route.plan,
          id: route.id
        };
      });
    }

    function patchRoutes(routeId, driverId) {
      return $http.patch(routesUrl + routeId + '/', {driver: driverId});
    }

    function assignDrivers(routes) {
      var promises = [];
      routes.forEach(function (route) {
        promises.push(patchRoutes(route.id, route.driverId));
      });

      return $q.all(promises).then(function (responses) {
        return responses.map(function (response) {
          return response.data;
        });
      });

    }

    function camelCase(key) {
      return key.split('_').reduce(function (prevVal, nextVal, i) {
        return i === 0 ? nextVal : prevVal + nextVal.charAt(0).toUpperCase() + nextVal.slice(1);
      }, '');
    }

    function camelCaseObj(obj, excludedFields) {
      var newObject = {};
      for (key in obj) {
        if (excludedFields.indexOf(key) === -1) {
          newObject[camelCase(key)] = obj[key];
        }
      }
      return newObject;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.plans')
    .controller('CodriversModalController', CodriversModalController);

    function CodriversModalController(vehicleRoutes, vehicleName, codrivers, codriverService, CODDRIVERS_ITEMS_PER_PAGE, isSingleRoute) {
      var vm = this;
      vm.vehicleName = vehicleName;
      vm.itemsPerPage = CODDRIVERS_ITEMS_PER_PAGE;
      vm.selectableCodrivers = {
        msgItemsEmpty: '',
        plansModule: true,
        itemsSelected: 0,
        items: [],
      };

      vm.saveCodrivers = saveCodrivers;
      vm.cancelAndCloseModal = cancelAndCloseModal;

      activate();

      function activate() {
        var routeCodrivers = vehicleRoutes && vehicleRoutes.length > 0 && vehicleRoutes[0].codrivers ? vehicleRoutes[0].codrivers : [];
        
        vm.selectableCodrivers.items = codrivers.map(function (codriver) {
          var isActivated = false;
          if (Array.isArray(routeCodrivers)) {
            isActivated = routeCodrivers.some(function (codriverId) {
              return String(codriverId) === String(codriver.id);
            });
          }
          
          return {
            id: codriver.id,
            name: codriver.name,
            activate: isActivated
          };
        });
        
        vm.selectableCodrivers.itemsSelected = vm.selectableCodrivers.items.filter(function (item) {
          return item.activate;
        }).length;
      }

      function saveCodrivers() {
        var selectedCodrivers = vm.selectableCodrivers.items.reduce(function (codriversIds, codriver) {
          return codriver.activate ? codriversIds.concat(codriver.id) : codriversIds;
        }, []);

        var routesIds = vehicleRoutes.map(function (route) { return route.id; });
        var body = [{ route_ids: routesIds, codriver_ids: selectedCodrivers }];
        codriverService.saveCodrivers(body);
        return selectedCodrivers;
      }

      function cancelAndCloseModal() { return null; }
    }

})();

(function() {
  'use strict';

  angular
    .module('icarus.planner')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

    $stateProvider
      .state('planner', {
        parent: 'main',
        url: '/planner',
        controller: 'PlannerController',
        controllerAs: 'vm',
        templateUrl: 'app/planner/planner.html',
        data:{
         authentication:  true
        },
        redirectTo: 'planner.vehicles-list'
      })
      // --------------------------------------------------
      // -   Vehicles states
      .state('planner.vehicles-list', {
        url:  '/vehicles',
        views: {
          "left-planner": {
            controller: 'PlannerVehiclesListController',
            controllerAs: 'vm',
            templateUrl: 'app/planner/vehicles/vehicles-list.html'
          }
        }
      })
      // --------------------------------------------------
      // -   Plans states
      .state('planner.vehicles-list.plans', {
        url: '/plans',
        views: {
          'plans@planner': {
            controller: 'PlannerPlansController',
            controllerAs: 'vm',
            templateUrl: 'app/planner/plans/plans-list.html'
          }
        }
      })
      .state('planner.vehicles-list.plans-draft', {
        url: '/plans/draft',
        views: {
          'plans@planner': {
            controller: 'PlannerDraftPlansController',
            controllerAs: 'vm',
            templateUrl: 'app/planner/plans/draft-plans.html'
          }
        }
      })
      .state('planner.vehicles-list.plans-detail', {
        url: '/plans/:planId?isCopy?isDraft',
        views: {
          'plans@planner': {
            controller: 'PlannerPlansDetailController',
            controllerAs: 'vm',
            templateUrl: 'app/planner/plans/plans-detail.html'
          }
        }
      })
      .state('planner.vehicles-list.plans-detail.codrivers', {
        url: '/codrivers/:vehicleId',
        params: {
          routes: []
        },
        views: {
          'plans@planner': {
            controller: 'PlannerPlansCodriversDetailController',
            controllerAs: 'vm',
            templateUrl: 'app/planner/plans/codrivers-detail.html'
          }
        }
      })
      .state('planner.vehicles-detail', {
        url: '/vehicles/:vehicleId',
        views: {
          "left-planner": {
            controller: 'PlannerVehiclesDetailController',
            controllerAs: 'vm',
            templateUrl: 'app/planner/vehicles/vehicles-detail.html'
          }
        }
      })
      // --------------------------------------------------
      // -   Visits states
      .state('planner.visits-list', {
        url:  '/visits?recent&fstatus&page',
        views: {
          "left-planner": {
            controller: 'PlannerVisitsListController',
            controllerAs: 'vm',
            templateUrl: 'app/planner/visits/visits-list.html'
          }
        }
      })
      .state('planner.visits-bulk-edit', {
        url: '/visits/bulk-edit?page',
        params: {
          visitsId: []
        },
        views: {
          "left-planner": {
            controller: 'PlannerVisitsBulkEditController',
            controllerAs: 'vm',
            templateUrl: 'app/planner/visits/visits-bulk-edit.html'
          }
        }
      })
      .state('planner.visits-create', {
        url: '/visits/create?fstatus&page',
        views: {
          "left-planner": {
            controller: 'PlannerVisitsDetailController',
            controllerAs: 'vm',
            templateUrl: 'app/planner/visits/visits-detail.html'
          }
        }
      })
      .state('planner.visits-detail', {
        url: '/visits/:visitId?fstatus&page',
        views: {
          "left-planner": {
            controller: 'PlannerVisitsDetailController',
            controllerAs: 'vm',
            templateUrl: 'app/planner/visits/visits-detail.html'
          }
        }
      })

      // --------------------------------------------------
      // -   Routes states
      .state('planner.redirect-routes', {
        url: '/redirect-routes',
        params: {
          draftPlanKey: null
        },
        views: {
          "left-planner": {
            controller: "PlannerRedirectRoutesController",
            controllerAs: "vm",
            templateUrl: "app/planner/routes/routes.html"
          }
        }
      })
      .state('planner.routes', {
        url: '/routes?optimize&jdh&vehicle_sort_key',
        params: {
          options: null,
          isEnhancedPlanEditModeEnabled: false,
          isOpeningPlanToEdit: false,
          comingFromEditMode: false,
          positiveSelectedVisits: false
        },
        views: {
          "left-planner": {
            controller: 'PlannerRoutesController',
            controllerAs: 'vm',
            templateUrl: 'app/planner/routes/routes.html'
          }
        }
      })
      .state('planner.routes-detail', {
        url: '/routes/edit/?route_opened&out_of_route_opened&vehicle_sort_key',
        views: {
          "left-planner": {
            controller: 'PlannerRoutesDetailController',
            controllerAs: 'vm',
            templateUrl: 'app/planner/routes/routes-detail.html'
          }
        }
      });
  }

})();

(function(){
  'use strict';

  angular
    .module('icarus.planner')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {

    //// Translate keys.
    $translateProvider.translations('es', {
      'Planner' : {
        'zones'                 : 'ZONAS',
        'visits'                : 'Visitas',
        'routes'                : 'Rutas',
        'to'                    : 'a',
        'btn_save'              : 'Guardar',
        'btn_assign_codrivers'  : 'Asignar copilotos',
        'btn_accept'            : 'Aceptar',
        'btn_save_draft'        : 'Guardar borrador',
        'btn_cancel'            : 'Cancelar',
        'btn_continue'          : 'Continuar',
        'btn_save_and_continue' : 'Guardar y continuar',
        'btn_back'              : 'Anterior',
        'btn_finish'            : 'Finalizar',
        'btn_export'            : 'Exportar',
        'btn_duplicate'         : 'Duplicar plan',
        'btn_balance'           : 'Balancear',
        'input_planName'        : 'Ingresa un nombre para el plan.',
        'used_vehicles'         : 'Vehículos \nutilizados',
        'your_fleet'            : 'tu flota',
        'created_routes'        : 'Rutas creadas',
        'total_departures'      : 'Salidas totales',
        'average_time'          : 'Tiempo',
        'vehicles'              : 'Vehículos',
        'load_plans'            : 'Editar planes guardados',
        'total_load_plans'      : 'Editar planes guardados:',
        'load_drafts'           : 'Cargar borradores',
        'total_load_drafts'     : 'Cargar borradores:',
        'empty_drafts_msg'      : 'No existen borradores creados.',
        'select_fleet'          : 'Seleccionar flota',
        'plan'                  : 'nombre',
        'start_date'            : 'fecha de inicio',
        'end_date'              : 'fecha de término',
        'empty_plans_msg'       : 'No existen planes creados.',
        'loading_plans_msg'     : 'Cargando planes creados.',
        'plan_resume'           : 'Edición del plan',
        'draft_plan_resume'     : 'Edición del borrador',
        'codrivers_edition'     : 'Edición de copilotos',
        'codrivers_select'      : 'Selecciona uno o más copilotos para este vehículo',
        'no_exist_plans_msg'    : 'No existe el plan seleccionado.',
        'select_vehicle'        : 'Selecciona un vehículo',
        'upload'                : 'Subir',
        'btn_download'          : 'Descargar',
        'btn_load'              : 'Ediciones avanzadas',
        'success_update_plan'   : '¡Plan actualizado exitosamente!',
        'error_update_plan'     : 'Error al actualizar los datos del plan, por favor intenta nuevamente.',
        'error_plan_name_exist' : 'El nombre del plan ingresado ya existe en la cuenta, por favor ingresa otro nombre.',
        'visits_edited'         : 'Visitas editadas',
        'total_visits'          : 'Visitas totales',
        'drivers'               : 'Conductores',
        'success_plan_uploaded' : 'Tu plan se ha subido exitosamente.',
        'success_plan_uploaded_but_no_changes' : 'No hubo cambios en los registros subidos.' ,
        'btn_confirm'     : 'Confirmar',
        'plan_name'       : 'Nombre del plan',
        'delete_plan'     : 'Eliminar plan',
        'delete_plan_keep_visits'     : 'Conservar',
        'delete_draft_plan'     : 'Eliminar borrador del plan',
        'delete_draft'    : 'Eliminar borrador',
        'delete_modal_message': 'Estás por eliminar un plan, ¿qué deseas hacer con tus visitas?',
        'delete_modal_message_2' : 'Estás por eliminar un plan en modo edición, ¿qué deseas hacer con tus visitas?',
        'delete_plan_and_visits_warning': '<b>Eliminarlas</b>, ya no se podrán recuperar.',
        'delete_plan_and_keep_visits_warning': '<b>Conservarlas</b>, puedes recuperarlas desde la opción agregar visitas desde integración.',
        'delete_modal_message_warning': '<b>Acepto que esta acción es irreversible.</b><br>Al hacer click en eliminar, el plan y las rutas dejarán de existir.',
        'delete_draft_modal_message_warning': 'Acepto que esta acción es <b>irreversible</b>. El borrador será eliminado y el plan volverá a su estado original.',
        'delete_plan_recommendation': 'Recomendado',
        'close'           : 'Cerrar',
        'delete'          : 'Eliminar',
        'select_day'      : 'Selecciona el día',
        'sunday'          : 'Domingo',
        'monday'          : 'Lunes',
        'tuesday'         : 'Martes',
        'wednesday'       : 'Miércoles',
        'thursday'        : 'Jueves',
        'friday'          : 'Viernes',
        'saturday'        : 'Sábado',
        'no_day'          : 'No aplica',
        'weekend_start_day' : 'inicio de semana',
        'editing_plan'      : 'editando plan',
        'planned_date'      : 'fecha plan actual',
        'infowindow_since'  : 'Desde las',
        'infowindow_to'     : 'a',
        'infowindow_until_to': 'Hasta las',
        'average_load'       : 'Carga 1',
        'average_load_2'     : 'Carga 2',
        'average_load_3'     : 'Carga 3',
        'average_load_4'     : 'Carga 4',
        'visit_singular'     : 'visita',
        'visit_plural'       : 'visitas',
        'average_kms'        : 'Kilómetros',
        'average_by_route'   : 'Por ruta',
        'average_by_vehicle' : 'Por vehículo',
        'number_of_routes'   : 'Cantidad \nde rutas',
        'headers_editing_plan'       : 'Editando plan',
        'headers_step_1'     : '1. Vehículos',
        'headers_step_2'     : '2. Visitas',
        'headers_step_3'     : '3. Rutas',
        'of'                 : 'de',
        'on_foot_option'     : 'Si tu flota son peatones, selecciona la optimización:',
        'MSOMC': {
          'alert_msg': 'Borrar selección'
        },
        'editing_current_plan': 'Estás editando este plan',
        'plan_not_deleted_message': 'No es posible eliminar Planes en curso',
        'draft_plan'                  : 'Borrador',
        'saving': 'Espera un momento, estamos guardando tu plan...',
        'error': 'Error al guardar el plan, por favor intenta nuevamente.',
        'color_picker': {
          'recolorer': 'Recolorear',
          'info_message': 'Cambiará el color de todas las rutas de este vehículo',
          'btn_cancel': 'Cancelar',
          'btn_save': 'Guardar'
        }
      },
      'Vehicles': {
        'origin'                      : 'Origen',
        'origin_placehd'              : 'Dirección de salida',
        'use_label'                   : 'Usar como dirección de destino',
        'schedule'                    : 'Horario',
        'destination'                 : 'Destino',
        'dest_placehd'                : 'Dirección de destino',
        'label_vehicles'              : 'Selecciona los vehículos a utilizar',
        'active'                      : 'activo',
        'inactive'                    : 'inactivo',
        'keep_routes'                 : 'Mantener rutas',
        'delete_routes'               : 'Eliminar rutas',
        'set_visits'                  : 'Visitas',
        'empty'                       : 'No has agregado vehículos aún.',
        'create'                      : 'Crea un',
        'new_vehicle'                 : 'nuevo vehículo',
        'select_all'                  : 'Todos',
        'select_only_available'       : 'Disponibles',
        'select_only_partially_available' : 'Disponibilidad parcial',
        'initial_information'         : 'Información inicial',
        'date'                        : 'Fecha',
        'to'                          : 'Hasta',
        'vehicle'                     : 'vehículo',
        'capacity'                    : 'capacidad',
        'license_plate'               : 'placa patente',
        'load_type'                   : 'tipo de carga',
        'load_type_values'            : {
          'light': 'Liviano',
          'heavy': 'Pesado'
        },
        'driver'                      : 'conductor',
        'codriver'                    : 'copiloto',
        'manage_vehicles'             : 'Administrar mis vehículos',
        'no_vehicles_selected'        : 'No hay vehículos seleccionados.',
        'origin_or_destiny_error_msg' : 'Algunos de los vehículos seleccionados no poseen origen o destino.',
        'disabled_vehicles_selected'  : 'Tienes vehículos ocupados en este horario. Cambia tu horario para continuar.',
        'title_edit_vehicle'          : 'Editar vehículo',
        'vehicle_name'                : 'Nombre',
        'vehicle_capacity'            : "@:Vehicles.capacity",
        'vehicle_driver'              : '@:Vehicles.driver',
        'vehicle_origin'              : '@:Vehicles.origin',
        'vehicle_destination'         : '@:Vehicles.destination',
        'vehicle_skills'              : 'Habilidades',
        'select_driver'               : '--- Selecciona un conductor ---',
        'more_vehicles'               : 'Más vehículos',
        'minus_vehicles'              : 'Menos vehículos',
        'error_format_date'           : '* Formato de hora incorrecto -- HH:MM',
        'error_between_date'          : '* Hora de inicio debe ser menor a la hora final.',
        'error_empty_date'            : '* Debes ingresar ambas horas.',
        'optional'                    : 'Opcional',
        'vehicle_capacity_2'          : 'Capacidad 2',
        'vehicle_capacity_3'          : 'Capacidad 3',
        'vehicle_capacity_4'          : 'Capacidad 4',
        'error_limit_capacity'        : 'La capacidad de carga del vehículo es muy alta',
        'error_limit_capacity_2'      : 'La capacidad 2 de carga del vehículo es muy alta',
        'error_limit_capacity_3'      : 'La capacidad 3 de carga del vehículo es muy alta',
        'error_limit_capacity_4'      : 'La capacidad 4 de carga del vehículo es muy alta',
        'required'                    : 'Requerido',
        'empty_vehicles_1'            : 'Aún no tienes vehículos creados.',
        'empty_vehicles_2'            : 'Crear tu primer vehículo',
        'available.default'           : 'Vehículo disponible para ruteo',
        'partiallyAvailable'          : 'Vehículo disponible a partir de',
        'notAvailable.message1'       : 'Vehículo ocupado desde',
        'notAvailable.message2'       : 'hasta',
        'blocked'                     : 'Vehículo bloqueado',
        'expired_documents_singular'  : 'Vehículo con documento vencido',
        'expired_documents_plural'    : 'Vehículo con {{countOfExpiredDocuments}} documentos vencidos',
        'start_date'                  : 'Fecha inicio',
        'end_date'                    : 'Fecha término',
        'start_time'                  : 'Hora inicio',
        'end_time'                    : 'Hora término',
        'rest_time_schedule'          : 'Ventana de descanso',
        'rest_time_duration'          : 'Duración',
        'total_kms'                   : 'Kilómetros recorridos',
        'time_routes'                 : 'Tiempo total',
        'total_routes'                : 'Rutas',
        'total_arrivals'              : 'Paradas',
        'visit_count'                 : 'Visitas',
        'client_count'                : 'Clientes',
        'average_load_1'              : 'Promedio de carga 1',
        'average_load_2'              : 'Promedio de carga 2',
        'average_load_3'              : 'Promedio de carga 3',
        'average_load_4'              : 'Promedio de carga 4',
        'tooltips': {
          'maximum_time_error': 'Tiempo máximo en ruta es:',
          'max_visit_error': 'Máximo de visitas del vehículo ({{max_visit_vehicle}}) excedido. Ajustar en configuración de vehículos.'
        },
        'selected_singular'      : 'Seleccionado',
        'selected_plural'        : 'Seleccionados',
        'vehicles_singular'      : 'vehículo',
        'vehicles_plural'        : 'vehículos',
        'of'                     : 'de'
      },
      'Visits': {
        'all_visits'       : 'Todas',
        'warnings'         : 'Alertas',
        'btn_import'       : 'Importar',
        'btn_new'          : '+ Nueva visita',
        'btn_remove'       : 'Borrar todas',
        'lbl_title'        : 'Título',
        'lbl_address'      : 'Dirección',
        'btn_more'         : 'Más opciones',
        'lbl_latitude'     : 'Latitud',
        'lbl_longitude'    : 'Longitud',
        'lbl_load'         : 'Carga',
        'tag'              : 'Etiqueta',
        'type_of_visit'    : 'Tipo de visita',
        'select_tags'      : 'Selecciona etiquetas',
        'select_type_of_visits': 'Selecciona el tipo de visitas',
        'start_time_window_1' : 'Inicio de ventana horaria',
        'start_time_window_2' : 'Inicio de ventana horaria 2',
        'end_time_window_1'   : 'Final de ventana horaria',
        'end_time_window_2'   : 'Final de ventana horaria 2',
        'lbl_service'      : 'Tiempo de servicio',
        'lbl_minutes'      : 'Minutos',
        'lbl_notes'        : 'Notas',
        'lbl_contact_name' : 'Persona de contacto',
        'lbl_contact_phone': 'Teléfono de contacto',
        'lbl_contact_email': 'Correo electrónico de contacto',
        'lbl_priority'     :  'Prioridad',
        'lbl_stop'         : 'Parada',
        'georeferencing'   : 'Georeferenciando',
        'of'               : 'de',
        'lbl_reference'    : 'ID de referencia',
        'remove_all'       : 'Remover todas',
        'back'             : 'Atrás',
        'optimize_btn'     : 'Crear rutas',
        'no_visits'        : 'No existen visitas',
        'may_use'          : 'Puedes usar esta ',
        'sample_template'  : 'plantilla de ejemplo',
        'or'               : 'ó',
        'create_visit'     : 'Crear una visita',
        'alert_high'       : 'Alerta alta',
        'alert_medium'     : 'Alerta media',
        'alert_low'        : 'Alerta baja',
        'error_country'    : 'País diferente',
        'error_distance'   : 'Demasiado lejos de la bodega',
        'error_area_center': 'Centro de la comuna',
        'error_wrong_area' : 'Diferente comuna a la señalada en la dirección',
        'title'            : 'Visitas',
        'errors'           : 'Errores',
        'import'           : 'Importar visitas',
        'warning_msg'      : 'Continuar a pesar de las alertas activas.',
        'edit_title'       : 'Editar visita',
        'create_title'     : 'Crear visita',
        'btn_less'         : 'Menos opciones',
        'to'               : 'Hasta',
        'required_skills'  : 'Habilidades requeridas',
        'optional_skills'  : 'Habilidades opcionales',
        'seller'           : 'Seller',
        'select_seller'    : 'Nombre del seller',
        'no_visits_for_date' : 'No hay pedidos programados para la fecha seleccionada.',
        'please'           : 'Por favor',
        'other_date'       : 'elige otra fecha',
        'or_go_to'         : 'o dirígete a',
        'orders'           : 'Pedidos',
        'to_add_new_visits': 'para ingresar nuevas visitas.',
        'not_available_vehicles': 'Vehículos no disponibles.',
        'invalid_date_plan': 'Fecha de plan inválida.',
        'msg_error_email_valid' : '* Formato de correo electrónico inválido',
        'msg_error_service_time': '* Formato de tiempo de servicio incorrecto, el valor debe estar entre 0 y 999999.',
        'msg_error_plan_date'   : 'Para utilizar las posiciones actuales de los vehículos la fecha del plan debe incluir el día de hoy.',
        'error_workday_exceeded': 'Los siguientes vehículos no pueden ser utilizados ya que están próximos a terminar su jornada laboral.',
        'delete_all_modals'     : 'Borrar las visitas',
        'delet_modal_message'   : '¿Estás seguro de querer eliminar las visitas programadas para esta fecha?.',
        'close'                 : 'Cerrar',
        'delete'                : 'Eliminar',
        'cancel_loading'        : 'Cancelar',
        'excel_name'            : 'example',
        'excel_title'           : 'Título*   Requerido',
        'excel_address'         : 'Dirección completa*   Requerida',
        'import_no_address'     : 'Dirección no especificada',
        'excel_load'            : 'Carga',
        'excel_hour_start'      : 'Hora inicial',
        'excel_hour_end'        : 'Hora final',
        'excel_service_time'    : 'Tiempo de servicio',
        'excel_notes'           : 'Notas',
        'excel_latitude'        : 'Latitud',
        'excel_longitude'       : 'Longitud',
        'excel_reference'       : 'ID de referencia',
        'excel_requires_skills' : 'Habilidades requeridas',
        'excel_optional_skills'  : 'Habilidades opcionales',
        'excel_contact_name'    : 'Persona de contacto',
        'excel_contact_phone'   : 'Teléfono de contacto',
        'excel_contact_email'   : 'Correo electrónico de contacto',
        'excel_hour_start_2'    : 'Hora inicial 2',
        'excel_hour_end_2'      : 'Hora final 2',
        'excel_load_2'          : 'Carga 2',
        'excel_load_3'          : 'Carga 3',
        'excel_load_4'          : 'Carga 4',
        'excel_priority'        : 'Prioridad',
        'excel_programmed_date' : 'Fecha programada',
        'excel_load_pick_1'     : 'Carga pick',
        'excel_load_pick_2'     : 'Carga pick 2',
        'excel_load_pick_3'     : 'Carga pick 3',
        'excel_visit_type'      : 'Tipo de visita',
        'excel_city'            : 'Ciudad',
        'excel_seller'          : 'Seller',
        'delete_visits'         : 'Eliminar visitas',
        'excel_sms'             : 'SMS',
        'bulk_edit'             : 'Edición múltiple',
        'deselect_all'          : 'Deseleccionar todos',
        'bulk_edit_message_1'   : 'Estás editando {{visitsQty}} visitas',
        'bulk_edit_message_2'   : 'Recuerda que las modificaciones sobrescribirán los datos anteriores.',
        'bulk_edit_warning'     : 'Está a punto de editar {{totalVisitsToEdit}} visitas',
        'contact_email_placeholder': 'Ingresa un correo electrónico',

        'delete_error_visits_message'   : '¿Estás seguro de querer eliminar las visitas con errores?',
        'delete_warning_visits_message' : '¿Estás seguro de querer eliminar las visitas con alertas?',
        'error_msg_routes_not_completed': 'Los vehiculos seleccionados aún no terminan sus entregas.',
        'error_format_date'             : '* Formato de hora incorrecto -- HH:MM',
        'error_between_date'            : '* Hora de inicio debe ser menor a la hora final.',
        'error_invalid_date'            : '* Fecha de inicio debe ser menor a la fecha de fin',
        'error_empty_date'              : '* Debe ingresar ambas horas.',
        'error_format_duration'         : 'Formato incorrecto en duración para la visita ',
        'error_format_capacity'         : 'Formato incorrecto en capacidad para la visita ',

        'error_email_length_message'    : 'Uno de los correos es demasiado largo',
        'error_max_emails_message_1'    : 'Puedes añadir',
        'error_max_emails_message_2'    : 'correos como máximo',

        'address_required'              : 'Dirección requerida',
        'load_required'                 : 'Carga requerida',
        'title_required'                : 'Título requerido',
        'lbl_load_2'                    : 'Carga 2',
        'lbl_load_3'                    : 'Carga 3',
        'lbl_load_4'                    : 'Carga 4',
        'required'                      : 'Requerido',
        'optional'                      : 'Opcional',
        'load_1_invalid'                : 'Carga 1 en formato erróneo, solo números son válidos.',
        'load_2_invalid'                : 'Carga 2 en formato erróneo, solo números son válidos.',
        'load_3_invalid'                : 'Carga 3 en formato erróneo, solo números son válidos.',
        'load_4_invalid'                : 'Carga 4 en formato erróneo, solo números son válidos.',

        'attention'                     : 'Atención',
        'remove_route_optimize_1'       : 'Tienes rutas creadas, elige una opción para continuar: ',
        'remove_route_optimize_2'       : 'Obtendrás una nueva optimización con los últimos cambios que realizaste en tus visitas (podría cambiar su orden respecto a la optimización anterior).',
        'positive_selection_visits_active' : 'Estás a punto de rutear {{checkedCount}} visitas de un total de {{totalCount}}. Las visitas pendientes (que no forman parte de este grupo) serán excluídas del ruteo.',
        'positive_selection_visits_active_note': 'Al seleccionar tus visitas, las rutas se crearán únicamente con ese grupo seleccionado. El resto NO pasarán al ruteo.',
        'move_to_dropdown'              : {
          'dropdown_title'              : 'Mover a',
          'visits_for_routing'          : 'Visitas por rutear',
          'pending_visits'              : 'Visitas pendientes',
        },
        'total_of_visits'               : 'Visitas totales ({{ totalLoadedVisits + totalLoadedVisitForRouting}})',
        'visits_for_routing'            : 'Visitas por rutear ({{totalVisitsForRouting}}) ',
        'pending_visits'                : 'Visitas pendientes ({{totalPendingVisits}})',
        'remove_route_cancel'           : 'Cancelar',
        'remove_route_accept'           : 'Aceptar',
        'btn_more_options'                : 'Más opciones',
        'btn_less_options'                : 'Menos opciones',
        'btn_more_loads'                : 'Otras cargas',
        'btn_less_loads'                : 'Una carga',
        'btn_optional_window_time'      : 'Ventana opcional',
        'btn_one_window_time'           : 'Una ventana',
        'excel_sms_enable'              : 'Enviar SMS',
        'alert_notification'            : {
          'error_country'               : 'País diferente',
          'error_wrong_area'            : 'Diferente comuna a la señalada en la dirección',
          'error_area_center'           : 'Centro de la comuna',
          'error_doubt'                 : 'Dirección dudosa',
          'error_distance'              : 'Demasiado lejos de la bodega',
          'error_window'                : 'Problema con las ventanas horarias',
          'error_overlapping'           : 'Ventanas horarias superpuestas',
          'country_center'              : 'No se encontraron resultados'
        },
        'new_alert_notification'            : {
          'alert_high'                  : 'Alerta alta',
          'alert_medium'                : 'Alerta media',
          'alert_low'                   : 'Alerta baja',
          'error_distance'              : 'Demasiado lejos de la bodega',
          'error_window'                : 'Problema con las ventanas horarias',
          'error_overlapping'           : 'Ventanas horarias superpuestas',
        },
        'no_title'                      : 'Visita sin título',
        'error_window_start_greater_than_window_end': 'Hora inicio es mayor a hora final',
        'optimize_btn_jdh'     : 'Crear rutas JDH',
        'create_visit_btn' : 'Agregar visitas <span class="caret"></span>',
        'create_visit_manual': 'Manual',
        'create_visit_excel': 'Desde excel',
        'create_visit_integration': 'Desde integración',
        'component_visits_import': {
          'title_visits_integration' : 'Agregar visitas desde integración',
          'button_title': 'Importar',
          'back_title': 'Volver',
          'select_date': 'Selecciona el rango de fechas',
          'select_visit_type': 'Selecciona el tipo de visita',
          'select_visit_status': 'Selecciona el estado de la visita',
          'visits_failed_label': 'visitas fallidas',
          'visits_pending_label': 'visitas pendientes',
          'visits_partial_label': 'visitas parciales',
          'title_visits_integration_not_completed': 'Agregar visitas no completadas',
          'title_visit_type_list': 'Tipos de visita',
          'visits_list_option_all': 'todas',
          'no_visit_type': 'Sin tipo de visita',
          'start_date': 'Fecha inicio',
          'end_date': 'Fecha fin',
          'error_date_range': 'El rango de fechas debe ser menor a 30 días.',
          'error_date_order': 'La fecha de fin debe ser mayor a la fecha de inicio.'
        },
        'remove_route_overwrite_routes_option': 'Sobrescribir rutas',
        'remove_route_keep_routes_option': 'Mantener rutas',
        'remove_route_keep_routes_partials': 'Ruteo incremental',
        'remove_route_optimize_3': 'Las rutas anteriores no serán modificadas. Las nuevas visitas serán agregadas a un vehículo disponible seleccionado, en caso de no haber vehículos disponibles quedarán fuera de ruta.',
        'remove_route_optimize_4': 'Las visitas anteriores no se moveran de sus respectivos vehículos. Las nuevas visitas serán asignadas a vehículos con capacidad disponible, de lo contrario aparecerán como fuera de ruta.',
        'incremental_routing_selection_message': {
          'part1': 'Importante: ',
          'part2': 'Ten presente que al seleccionar esta opción, la optimización no tomará en cuenta la',
          'part3': 'unión de visitas por distancia',
          'part4': 'configurada.'
        },
        'out_of_route': 'Fuera de ruta',
        'priority_levels': {
          'first_of_day'   : 'Primero del día',
          'last_of_route'  : 'Último de su ruta',
          'high_priority'  : 'Prioridad alta',
          'medium_priority': 'Prioridad media',
          'low_priority'   : 'Prioridad baja',
          'end-of-route-pickup': 'Recolección al final de la ruta'
        },
        'select_priority_level': 'Selecciona una prioridad',
        'tooltip_priority_level': 'Usa prioridades para definir si una visita es más importante que otra. O para escoger si quieres que la visita vaya primera o última en una ruta.',
        'create_visit_integration_not_completed': 'No completadas',
        'tooltips': {
          'new_visit': 'Nueva visita',
          'edit': 'Editar',
          'delete': 'Eliminar'
        },
        'wave_routing_modal': {
          'title': '¿Cuál es tu horario de corte?',
          'subtitle': 'Necesitamos esta información para continuar.',
          'time_input_title': 'Horario de corte',
          'time_format_error': 'Ingrese una hora válida.',
          'checkbox_message': 'Este es mi último oleaje'
        },
        'visits_utils': {
          'capacityError': 'Carga 1',
          'capacityError2': 'Carga 2',
          'capacityError3': 'Carga 3',
          'maximumTimeError': 'Tiempo de operación',
          'skillsError': 'Habilidades',
          'timeError': 'Ventana horaria'
        },
        "number_of_visits_selected": "Seleccionadas {{selectedVisits}} de {{totalVisits}}",
        "error_coordinate_pattern": "Las coordenadas deben ser números válidos",
        'visit_tabs': {
          'details': 'Detalles',
          'items': 'Items'
        },
        'sort_visits': {
          'sort': 'Ordenar',
          'sort_asc': 'Ascendente',
          'sort_desc': 'Descendente',
          'load': 'Carga 1',
          'load2': 'Carga 2',
          'load3': 'Carga 3',
          'load4': 'Carga 4',
          'title': 'Título',
          'remove_sort': 'Restablecer orden'
        },
        'placeholder': {
          'title' : 'Ingresa título',
          'id': 'Ingresa la ID',
          'address': 'Ingresa dirección',
          'latitude': 'Ingresa latitud',
          'longitude': 'Ingresa Longitud',
          'load_1': 'Ingresa carga 1',
          'load_2': 'Ingresa carga 2',
          'load_3': 'Ingresa carga 3',
          'load_4': 'Ingresa carga 4',
          'service_time': 'Ingresa los minutos',
          'contact_person': 'Ingresa persona de contacto',
          'phone_contact': 'Ingresa teléfono de contacto',
          'notes': 'Ingresa las notas de la visita'
        },
        'selected_singular'      : 'Seleccionado',
        'selected_plural'        : 'Seleccionados',
        'address_stats': {
          'status': {
            'new': 'Nueva',
            'used': 'Usada',
            'warn_qty_failed': 'Usada',
            'warn_diff_loc': 'Usada'
          },
          'tooltips': {
            'new': 'Dirección no utilizada anteriormente',
            'used': 'Dirección utilizada más de 5 veces',
            'warn_qty_failed': 'Dirección utilizada anteriormente con más del 50% de checkouts fallidos',
            'warn_diff_loc': 'Detectamos una ubicación distinta a la ingresada.',
            'change_location': 'Cambiar a ubicación sugerida',
            'undo_change_location': 'Deshacer'
          }
        },
        'toolSelectionOnMapNavbar': {
          'selected_visits_plural': 'visitas seleccionadas',
          'selected_visits_singular': 'visita seleccionada',
          'load1': '@:Routes.load1',
          'load2': '@:Routes.load2',
          'load3': '@:Routes.load3',
          'load4': '@:Routes.load4',
          'btn_deselect': 'Deseleccionar',
          'toast_delete_selected_visits_success': 'Tus visitas han sido eliminadas exitosamente'
        },
        'modal_warning_checked_visits': {
          'title': 'Advertencia',
          'subtitle': 'Confirmar ruteo parcial',
          'message': 'Estás seleccionado {{checkedCount}} visitas de {{totalCount}} totales. La ruta se creará únicamente con este grupo seleccionado.',
          'cta_continue': '¿Deseas continuar solo con {{checkedCount}} visitas?',
          'important': 'IMPORTANTE',
          'important_note': 'Al seleccionar tus visitas, las rutas se crearán únicamente con ese grupo seleccionado. El resto NO pasarán al ruteo.'
        }
      },
      'Routes': {
        'load1'                         : 'Carga 1',
        'load2'                         : 'Carga 2',
        'load3'                         : 'Carga 3',
        'load4'                         : 'Carga 4',
        'duration'                      : 'Duración (horas)',
        'average_kms'                   : '@:Planner.average_kms',
        'start_time'                    : 'Hr inicio',
        'end_time'                      : 'Hr término',
        'origin'                        : '@:Vehicles.origin',
        'routes_summary'                : 'Resumen de rutas',
        'btn_edition'                   : 'Editar rutas',
        'btn_moveTo'                    : 'Mover a',
        'btn_cancelMoveTo'              : 'Cancelar edición',
        'btn_optimize'                  : 'Optimizar',
        'unassigned'                    : 'Sin asignar',
        'route'                         : 'Salida',
        'start'                         : 'Inicio',
        'end'                           : 'Fin',
        'back'                          : 'Atrás',
        'optimize'                      : 'Optimizar',
        'export'                        : 'Exportar',
        'assign'                        : 'Asignar',
        'assignments.title'             : 'Asignación de rutas',
        'assignments.date'              : 'Fecha de salida',
        'assignments.assignBtn'         : 'Asignar',
        'assignments.endBtn'            : 'Finalizar',
        'assignments.unassigned'        : 'Sin asignar',
        'assignments.successMessage'    : '¡Todas las rutas fueron asignadas!',
        'the_vehicle'                   : 'El vehículo',
        'assignments.errorMessage'      : 'ya posee alguna ruta con la misma fecha y hora de inicio.',
        'assignments.isErrorInPlanInstance': 'Ya existe un plan con la misma fecha de inicio y fin a éstas.',
        'assignments.data_format_error.title': 'Error en los datos de las visitas',
        'assignments.data_format_error.message': 'Verifica que los datos de visita se encuentren en el formato correcto',
        'assignments.default_error.title': 'Se ha producido un error',
        'assignments.default_error.message': 'Ha ocurrido un error al momento de guardar el plan, inténtalo más tarde',
        'assignments.plan_name_error.title': 'Ya existe un plan con el mismo nombre',
        'assignments.route_started_or_finished_error.title': 'Rutas no editables',
        'assignments.route_started_or_finished_error.message': 'Las rutas que ya han iniciado o finalizado no pueden ser modificadas',
        'assignments.vehicle_unavailable_error.title': 'Vehículos no disponibles',
        'assignments.vehicle_unavailable_error.message': 'Hay vehículos que no están disponibles para rutear.',
        'pleaseCorrects'            : 'Por favor corrige esta inconsistencia y vuelve a intentarlo.',
        'go_back'                   : 'Volver',
        'goToRouteTracking'         : 'Si quieres comenzar a monitorear tus entregas ve a ',
        'routeTracking'             : 'Seguimiento',
        'new_routes'                : ' Rutas',
        'cancel_creation'           : 'Cancelar creación',
        'btn_addTo'                 : 'Crear en',
        'routes_title'              : 'Rutas',
        'routes_title_edit'         : 'Editando rutas',
        'btn_new'                   : '+ Nueva ruta',
        'btn_remake_routes'         : 'Rehacer rutas',
        'visits_out_of_route_title' : 'Visitas fuera de ruta',
        'select_all'                : 'Seleccionar todas',
        'hide_routes'               : 'Ocultar rutas',
        'show_routes'               : 'Mostrar rutas',
        'route_text'                : 'Ruta ',
        'reorder'                   : 'Reordenar ruta',
        'from'                      : 'Salida desde',
        'to'                        : 'LLegada a',
        'finish_title'              : 'Finalizar diseño de rutas',
        'finish_title_success'      : 'Tus rutas fueron enviadas a los conductores',
        'finish_title_success_async': 'Estamos guardando tu plan...',
        'finish_content_success'    : 'Te notificaremos por correo electrónico cuando tu plan esté completamente guardado. Si lo prefieres, puedes crear una nueva ruta en nuestro Ruteador o explorar otras secciones de nuestra plataforma.',
        'vehicle'                   : '@:Vehicles.vehicle',
        'driver'                    : '@:Vehicles.driver',
        'codriver'                  : '@:Vehicles.codriver',
        'routes'                    : 'Rutas',
        'route_singular'            : 'Ruta',
        'visits'                    : 'Visitas',
        'time'                      : 'Tiempo',
        'select_driver'             : '--- Selecciona un conductor ---',
        'confirm'                   : 'Confirmar',
        'save_draft'                : 'Guardar borrador de plan',
        'out_of_route'              : 'Fuera de ruta',
        'unselected_routes_remake'  : 'Debe seleccionar al menos un vehículo',
        'delete_route'              : 'Eliminar ruta',
        'delete_modal_message'      : '¿Quieres eliminar esta ruta?',
        'close'                     : 'Cerrar',
        'delete'                    : 'Eliminar',
        'delete_menu'               : 'Eliminar ruta',
        'prioritize_high_load'      : 'Priorizar carga alta al inicio',
        'reverse_route_order'       : 'Invertir orden de ruta',
        'reverse_route_order_success_title' : 'Se ha invertido la ruta',
        'reverse_route_order_success_msg' : 'Las visitas han cambiado de orden. Te recomendamos revisar el resultado.',
        'optimize.balance'          : 'Balancear',
        'optimize.all_vehicles'     : 'Minimizar vehículos',
        'optimize.join'             : 'Unir similares',
        'optimize.join_v2'          : 'Unir similares 2.0',
        'optimize.open_start'       : 'Rutas con inicio abierto',
        'optimize.open_ended'       : 'Rutas con final abierto',
        'optimize.avoid_tolls'      : 'Evitar peajes',
        'optimize.maximize_attended_load': 'Maximizar carga atendida',
        'optimize.prioritize_load': 'Priorizar carga alta al inicio',
        'optimize.last_position_optimize': 'Usar posición actual',
        'optimize.single_tour': 'Una ruta por vehículo',
        'optimize.beauty': 'SimpliFy',
        'optimize.big_vrp': 'Big VRP',
        'optimize.use_euclidean_distance': 'Distancia Euclidiana',
        'optimize.enable_graphs': 'Grafos',
        'optimize.auto_reorder': 'Auto Reordenar',
        'optimize.enable_soft_window': 'Ventanas horarias suaves',
        'optimize.on_foot' : 'Ruteo a pie',
        'optimize.wave_routing' : 'Ruteo por oleaje',
        'optimize.distance_to_join_visits': 'Unir visitas por distancia',
        'optimize.routing_options': 'Optimizadores',
        'optimize.radial_options': 'Secuenciadores',
        'optimize.radial_default': 'Por defecto',
        'optimize.radial_to_near': 'De lejos a cerca',
        'optimize.radial_to_far': 'De cerca a lejos',
        'optimize.one_seller_per_vehicle': 'Rutas por seller',
        'remake_visits_out_of_route_error' : 'No existen visitas fuera de ruta.',
        'remake_vehicles_error'     : 'Alguno de los vehículos seleccionados no posee visitas.',
        'no_vehicles_selected'      : 'Debes seleccionar al menos un vehículo.',
        'finish_modal.tracking_module' : 'Módulo de seguimiento',
        'finish_modal.planning_module' : 'Módulo de ruteo',
        'finish_modal.btn_tracking_module': 'Seguimiento de flota',
        'finish_modal.btn_planning_module': 'Diseño de Rutas',
        'finish_modal.text_tracking_module': 'Si quieres comenzar a monitorear tus entregas ve al',
        'finish_modal.text_planning_module': 'También puedes crear un nuevo plan volviendo al',
        'comments' : 'Comentario de la ruta (s)',
        'body_1'   : 'Este comentario se aplica a las siguientes rutas: ',
        'save_comments' : 'Guardar',
        'route_name' : 'Ruta',
        'finish_modal.footer_message': 'Recuerda decirle a tus conductores que descarguen la aplicación móvil.',
        'assign_driver': 'Asignar conductor',
        'assign_codrivers': 'Asignar copilotos',
        'comments_route': 'Comentario',
        'visits_and' : 'visitas y',
        'selected_routes': 'rutas seleccionadas',
        'single_tour': 'Una ruta por vehículo',
        'beauty': 'SimpliFy',
        'tooltips': {
          'visits_out_of_route_title': 'Las visitas pueden quedar fuera de ruta por distintas razones, las más comunes son: Horario de trabajo de los vehículos insuficiente, tiempos de servicio muy extensos, ventanas horarias de las visitas muy restrictivas o capacidad de carga insuficiente.',
          'edited_route'             :  'Ruta editada',
          'skills_error': 'No cumple con habilidades',
          'time_error': 'No cumple ventana horaria',
          'charge_error_one' : 'Sobrepasa carga 1',
          'charge_error_two': 'Sobrepasa carga 2',
          'charge_error_three': 'Sobrepasa carga 3',
          'charge_error_four': 'Sobrepasa carga 4',
          'route_locked': 'Esta ruta está bloqueada y no puede ser editada'
        },
        'filter_vehicle': {
          'high_low_kilometer': 'Kilometraje: Mayor a menor',
          'low_high_kilometer': 'Kilometraje: Menor a mayor',
          'high_low_load': '% de carga 1: Mayor a menor',
          'low_high_load': '% de carga 1: Menor a mayor',
          'high_low_load2': '% de carga 2: Mayor a menor',
          'low_high_load2': '% de carga 2: Menor a mayor',
          'high_low_load3': '% de carga 3: Mayor a menor',
          'low_high_load3': '% de carga 3: Menor a mayor',
          'high_low_hours': 'Hora por vehículo: Mayor a menor',
          'low_high_hours': 'Hora por vehículo: Menor a mayor ',
          'low_high_name': 'Nombre del vehículo',
          'sort_by': 'Ordenar por'
        },
        'support_badge': {
          'revised' : 'Revisada'
        },
        'status': {
          'pending': 'Ruta por iniciar',
          'started': 'Ruta iniciada',
          'completed': 'Ruta finalizada',
          'finished': 'Ruta finalizada'
        },
        'warning': {
          'started': 'Advertencia: Estás intentando editar una ruta que ya fue iniciada',
          'finished': 'Advertencia: Estás intentando editar una ruta que ya fue finalizada'
        },
        'displayVehiclesList': {
          'categories': {
            'all_vehicles': 'Todos los vehículos',
            'available_vehicles' : 'Vehículos disponibles',
            'occupied_vehicles' : 'Vehículos ocupados'
          },
          'vehicle_status_available': 'Libre',
          'vehicle_status_occupied': 'Ocupado'
        }
      },
      'Excel_Header': {
        'driver'          : 'Conductor',
        'vehicle'         : 'Vehículo',
        'route_Index'     : 'Índice de ruta',
        'stop'            : 'Parada',
        'arrival_Time'    : 'Tiempo estimado de llegada',
        'title'           : 'Título',
        'address'         : 'Dirección',
        'load'            : 'Carga',
        'window_Start'    : 'Inicio de ventana horaria 1',
        'window_End'      : 'Final de ventana horaria 1',
        'window_Start2'   : 'Inicio de ventana horaria 2',
        'window_End2'     : 'Final de ventana horaria 2',
        'service_Time'    : 'Tiempo de servicio',
        'notes'           : 'Notas',
        'latitude'        : 'Latitud',
        'longitude'       : 'Longitud',
        'reference'       : 'ID de referencia',
        'requires_Skills' : 'Habilidades requeridas',
        'optional_Skills' : 'Habilidades opcionales',
        'contact_Name'    : 'Persona de contacto',
        'contact_Phone'   : 'Teléfono de contacto',
        'contact_email'   : 'Correo electrónico de contacto',
        'distance'        : 'Distancia',
        'order_size'      : 'Carga',
        'total_size'      : 'Carga total',
        'warnings'        : 'Advertencias',
        'visit_load2'     : 'Capacidad 2',
        'visit_load3'     : 'Capacidad 3',
        'priority'        : 'Prioridad',
        'route_coment'    : 'Comentario de la ruta',
        'tags'            : 'Etiquetas',
        'zones'           : 'Zonas',
        'visit_alerts'    : 'Alertas de la visita',
        'route_name'      : '@:Routes.route_name',
        'origin'          : '@:Vehicles.origin',
        'start_time'      : '@:Routes.start_time',
        'end_time'        : '@:Routes.end_time',
        'visits'          : '@:Routes.visits',
        'load1'           : '@:Routes.load1',
        'load2'           : '@:Routes.load2',
        'load3'           : '@:Routes.load3',
        'load4'           : '@:Routes.load4',
        'total'           : 'total',
        'total_routes_summary': 'Total Resumen Rutas',
        'duration'        : 'Duración (horas)',
        'customer_shipment_date': 'Fecha Envío Cliente',
        'stops': 'Paradas'
      },

      'Pdf' : {
        'detailed_pdf' : 'PDF Detallado',
        'vehicle': 'Vehículo',
        'no_driver': 'Sin conductor asignado',
        'to': ' a ',
        'name': 'NOMBRE',
        'id': 'ID',
        'coments':'COMENTARIOS U OBSERVACIONES',
        'signature' : 'FIRMA DE QUIÉN RECIBE',
        'address' : 'UBICACIÓN',
        'contact': 'CONTACTO',
        'windows': 'VENTANAS HORARIAS',
        'phone' : 'TELÉFONO',
        'skills_required': 'HABILIDADES REQUERIDAS',
        'route_comment' : 'COMENTARIO DE LA RUTA',
        'no_route_comments' : 'Sin comentarios',
        'notes'           : 'NOTAS',
        'between_streets': 'ENTRE CALLES',
        'customer_shipping_date': 'FECHA ENVIO CLIENTE'
      },
      'Summarized_Pdf' : {
        'summarized_pdf'             : 'PDF Resumen',
        'title'                      : 'Título',
        'contact_phone'              : 'Teléfono',
        'missing_contact_phone'      : 'Sin información',
        'address'                    : 'Dirección',
        'time_windows'               : 'Ventanas Horarias',
        'arrival'                    : 'Llegada',
        'id'                         : 'ID de referencia',
        'missing_id'                 : 'Sin información',
        'missing_streets_in_between' : 'Sin información adicional',
        'customer_shipment_date'     : 'Fecha Envío Cliente'
      },

      'Planner_toast' : {
        'error_get_plans_1'       : 'Error en la carga de planes, ruta no existe',
        'error_get_plans_2'       : 'Error en la carga de planes desde el servidor',
        'error_get_plans_3'       : 'Plan no existe',
        'wrong_path'              : 'Error en la solicitud, ruta no existe',
        'not_permission'          : 'No tienes permiso para acceder al diseño de rutas',
        'vehicle_not_found'       : 'Vehículo no encontrado',
        'error_delete_plan'       : 'Error eliminando plan, por favor intenta nuevamente',
        'error_put_plan_found'    : 'Error actualizando plan, ruta no existe',
        'error_call_osrm'         : 'Error cargando el plan seleccionado',
        'error_visit_update_plan' : 'Error editando las visitas del plan',
        'error_optimize_capacity_vehicles' : 'Error en la capacidad de los vehículos, por favor corrige e intenta nuevamente.',
        'empty_file_excel'        : 'Archivo excel vacío, revisa el archivo e intenta nuevamente.',
        'wrong_row_excel'         : 'Se encontraron algunos errores en la información de visitas del archivo excel.',
        'error_optimize_500'      : 'Hubo un problema al optimizar, por favor intenta nuevamente.',
        'error_order_route'       : 'Hubo un error al reordenar la ruta, por favor intenta nuevamente.',
        'error_remake_routes'     : 'Hubo un error al rehacer rutas, por favor intenta nuevamente.',
        'error_save_plan_finish'  : 'Hubo un error al guardar el plan, por favor intenta nuevamente.',
        'error_delete_route'      : 'Error eliminando la ruta',
        'error_no_vehicles_for_reoptimize': 'No hay vehículos disponibles para ejecutar esta acción',
        'error_no_selected_vehicles_for_reoptimize': 'Las nuevas visitas quedaron fuera de ruta ya que no fueron seleccionados nuevos vehículos para reoptimizar',
        'error_no_visits_for_reoptimize': 'No hay visitas disponibles para ejecutar esta acción',
        'error_save_plan_finish_planned_date' : 'Ya existe un plan para la misma fecha, por favor corrige e intenta nuevamente',
        'error_save_plan_finish_plan_name': 'Ya existe un plan con el mismo nombre, por favor corrige e intenta nuevamente',
        'visits_imported'      : 'Total de visitas importadas: ',
        'error_move_visits'    : 'Algunas de las visitas seleccionadas no se pueden mover de la ruta original',
        'success_move_visits'  : 'Cambios realizados exitosamente',
        'error_move_visits_to_started_or_finished_route': 'Ruta no disponible para cambios',
        'msg_move_to_mode'     : 'Haz click en la ruta a la que deseas mover tus visitas seleccionadas',
        'error_seller'         : 'En {{count}} visitas no pudimos encontrar el seller indicado por lo que el campo ha quedado vacío',
        'error_city'           : 'Se encontraron {{count}} visitas sin ciudad (requerida para Colombia)',
        'error_check_routes_status': 'No se pudo verificar el estado de las rutas. Intente nuevamente.'
      },

      'Log' : {
        'actions': {
          'delete_plan': 'Eliminación de plan',
          'editing_plan': 'Edición de plan'
        }
      },
      'Plan': {
        'modal_cancel_edit_message_1' :  'Abandonarás la edición de planes y perderás los cambios que no hayas guardado.',
        'modal_cancel_edit_message_2': '¿Deseas continuar?',
        'modal_cancel_edit_title': 'Cancelar edición de plan',
        'button_cancel_modal': 'Cancelar',
        'button_accept_modal': 'Abandonar'
      },
      'Driver': {
        'group_available': '',
        'group_assigned': '✓'
      }
    });

    $translateProvider.translations('en', {
      'Planner' : {
        'zones'                 : 'ZONES',
        'visits'                : 'Visits',
        'routes'                : 'Routes',
        'to'                    : 'to',
        'btn_save'              : 'Save',
        'btn_assign_codrivers'  : 'Save',
        'btn_accept'            : 'Accept',
        'btn_save_draft'        : 'Save draft',
        'btn_cancel'            : 'Cancel',
        'btn_continue'          : 'Continue',
        'btn_save_and_continue' : 'Save and continue',
        'btn_back'              : 'Back',
        'btn_finish'            : 'Finish',
        'btn_export'            : 'Export',
        'btn_duplicate'         : 'Duplicate plan',
        'btn_balance'           : 'Balance',
        'input_planName'        : 'Entry a name for the plan',
        'used_vehicles'         : 'Used \nvehicles',
        'your_fleet'            : 'your fleet',
        'created_routes'        : 'Created routes',
        'total_departures'      : 'Total routes',
        'average_load'          : 'Load 1',
        'average_load_2'        : 'Load 2',
        'average_load_3'        : 'Load 3',
        'average_load_4'        : 'Load 4',
        'average_time'          : 'Time',
        'vehicles'              : 'Vehicles',
        'load_plans'            : 'Load older plans',
        'total_load_plans'      : 'Load older plans:',
        'load_drafts'           : 'Load draft plans',
        'total_load_drafts'     : 'Load draft plans:',
        'empty_drafts_msg'      : 'There aren\'t any draft plans.',
        'select_fleet'          : 'Select fleet',
        'plan'                  : 'plan',
        'start_date'            : 'starting date',
        'end_date'              : 'end date',
        'empty_plans_msg'       : 'There aren\'t any created plans.',
        'loading_plans_msg'     : 'Loading created plans.',
        'plan_resume'           : 'Plan summary',
        'draft_plan_resume'     : 'Draft plan summary',
        'codrivers_edition'     : 'Codrivers edition',
        'codrivers_select'      : 'Select one or more codrivers for this vehicle',
        'no_exist_plans_msg'    : 'Selected plan was\'nt found.',
        'select_vehicle'        : 'Select a vehicle',
        'upload'                : 'Upload',
        'btn_download'          : 'Download',
        'btn_load'              : 'Load',
        'success_update_plan'   : 'Plan was updated successfully!',
        'error_update_plan'     : 'Failed to update data plan, please try again.',
        'error_plan_name_exist' : 'The account already has a plan with that name. Please write a new one.',
        'visits_edited'         : 'Visits were edited',
        'total_visits'          : 'Total visits',
        'drivers'               : 'Drivers',
        'success_plan_uploaded' : 'Your plan has been successfully uploaded.',
        'success_plan_uploaded_but_no_changes' : 'There were no changes in the records uploaded.' ,
        'btn_confirm'           : 'Confirm',
        'plan_name'             : 'Plan name',
        'delete_plan'           : 'Remove plan',
        'delete_plan_keep_visits'     : 'Keep',
        'delete_draft_plan'     : 'Remove draft plan',
        'delete_draft'          : 'Delete draft',
        'delete_modal_message'  : "You're about to delete a plan, what do you want to do with their visits?",
        'delete_modal_message_2': "You're about to delete a plan in edit mode, what do you want to do with their visits?",
        'delete_plan_and_visits_warning' : '<b>Delete them</b>, they will be no longer available to recover.',
        'delete_plan_and_keep_visits_warning' : '<b>Keep them</b>, they can be recover from the option to add visits from integration.',
        'delete_modal_message_warning': '<b>I confirm this action is irreversible.</b><br>By clicking “Delete”, the plan and routes will no longer exist.',
        'delete_draft_modal_message_warning': 'I confirm this action is <b>irreversible</b>. The draft will be removed and the plan will return to it’s original version.',
        'delete_plan_recommendation': 'Recommended',
        'close'                 : 'Close',
        'delete'                : 'Delete',
        'select_day'            : 'Select a day',
        'sunday'                : 'Sunday',
        'monday'                : 'Monday',
        'tuesday'               : 'Tuesday',
        'wednesday'             : 'Wednesday',
        'thursday'              : 'Thursday',
        'friday'                : 'Friday',
        'saturday'              : 'Saturday',
        'no_day'                : 'Not applicable',
        'weekend_start_day'     : 'Week start',
        'editing_plan'          : 'editing plan',
        'planned_date'          : 'date current plan',
        'infowindow_since'  : 'Since',
        'infowindow_to'     : 'to',
        'infowindow_until_to': 'Until',
        'visit_singular'      : 'visit',
        'visit_plural'       : 'visits',
        'average_kms'        : 'Kilometers',
        'average_by_route'   : 'Per route',
        'average_by_vehicle' : 'Per vehicle',
        'number_of_routes'   : 'Number \nof routes',
        'headers_editing_plan'       : 'Editing plan',
        'headers_step_1'     : '1. Vehicles',
        'headers_step_2'     : '2. Visits',
        'headers_step_3'     : '3. Routes',
        'of'                 : 'of',
        'on_foot_option'     : 'If your fleet is pedestrian, select the optimization:',
        'MSOMC': {
          'alert_msg': 'Delete selected items'
        },
        'editing_current_plan': 'You are editing this plan',
        'plan_not_deleted_message': 'It is not possible to delete Plans in progress',
        'draft_plan'           : 'Draft',
        'saving': "Hold on a moment, we're saving your plan...",
        'error': "Error saving the plan, please try again.",
        'color_picker': {
          'recolorer': 'Recolor',
          'info_message': 'This will change the color of all routes for this vehicle.',
          'btn_cancel': 'Cancel',
          'btn_save': 'Save'
        }
      },
      'Vehicles': {
        'origin'               : 'Origin',
        'origin_placehd'       : 'Start address',
        'use_label'            : 'To use as a destination address',
        'schedule'             : 'Schedule',
        'destination'          : 'Destination',
        'dest_placehd'         : 'Destination address',
        'label_vehicles'       : 'Choose your vehicles to use',
        'active'               : 'active',
        'inactive'             : 'inactive',
        'keep_routes'          : 'Keep routes',
        'delete_routes'        : 'Delete routes',
        'set_visits'           : 'Set visits',
        'empty'                : 'You haven’t added any vehicles yet.',
        'create'               : 'Create a',
        'new_vehicle'          : 'new vehicle',
        'select_all'           : 'All',
        'select_only_available': 'Available',
        'select_only_partially_available' : 'Partial availability',
        'initial_information'  : 'Initial information',
        'date'                 : 'Date',
        'to'                   : 'To',
        'vehicle'              : 'vehicle',
        'capacity'             : 'capacity',
        'vehicle_capacity_2'   : 'capacity 2',
        'vehicle_capacity_3'   : 'capacity 3',
        'license_plate'        : 'license plate',
        'load_type'            : 'load type',
        'load_type_values'     : {
          'light': 'Light',
          'heavy': 'Heavy'
        },
        'driver'               : 'driver',
        'codriver'             : 'codriver',
        'manage_vehicles'      : 'Manage my vehicles',
        'no_vehicles_selected' : 'No selected vehicles.',
        'origin_or_destiny_error_msg' : 'Some of the selected vehicles don\'t have start or destination address.',
        'disabled_vehicles_selected'  : 'Some of the selected vehicles are not available at the indicated time.',
        'title_edit_vehicle'   : 'Edit vehicle',
        'vehicle_name'         : 'Name',
        'vehicle_capacity'     : "@:Vehicles.capacity",
        'vehicle_driver'       : '@:Vehicles.driver',
        'vehicle_origin'       : '@:Vehicles.origin',
        'vehicle_destination'  : '@:Vehicles.destination',
        'vehicle_skills'       : 'Skills',
        'select_driver'        : '--- Select a driver ---',
        'more_vehicles'        : 'More vehicles',
        'minus_vehicles'       : 'Less vehicles',
        'error_format_date'    : '* Wrong hour format -- HH:MM',
        'error_between_date'   : '* Start hour must be less than the final hour.',
        'error_empty_date'     : '* You must enter two hours.',
        'empty_vehicles_1'     : 'You do not have any vehicles created yet.',
        'empty_vehicles_2'     : 'Create your first vehicle',
        'available.default'           : 'Vehicle available for routing',
        'partiallyAvailable'          : 'Vehicle available from',
        'notAvailable.message1'       : 'Vehicle occupied from',
        'notAvailable.message2'       : 'to',
        'blocked'                     : 'Locked vehicle',
        'expired_documents_singular'  : 'Vehicle with expired document',
        'expired_documents_plural'    : 'Vehicle with {{countOfExpiredDocuments}} expired documents',
        'required'                    : 'Required',
        'optional'                    : 'Optional',
        'start_date'                  : 'Start date',
        'end_date'                    : 'End date',
        'start_time'                  : 'Start time',
        'end_time'                    : 'End time',
        'rest_time_schedule'          : 'Rest Time Window',
        'rest_time_duration'          : 'Duration',
        'total_kms'                   : 'Kilometers traveled',
        'time_routes'                 : 'Total time',
        'total_routes'                : 'Routes',
        'total_arrivals'              : 'Stops',
        'visit_count'                 : 'Visits',
        'client_count'                : 'Clients',
        'average_load_1'              : 'Load 1 average',
        'average_load_2'              : 'Load 2 average',
        'average_load_3'              : 'Load 3 average',
        'average_load_4'              : 'Load 4 average',
        'tooltips': {
          'maximum_time_error': 'Maximum time en route is:',
          'max_visit_error': 'Maximum number of vehicle visits ({{max_visit_vehicle}}) exceeded. Set in vehicle configuration.'
        },
        'selected_singular'      : 'Selected',
        'selected_plural'        : 'Selected',
        'vehicles_singular'      : 'vehicle',
        'vehicles_plural'        : 'vehicles',
        'of'                     : 'of'
      },
      'Visits': {
        'all_visits'          : 'All',
        'warnings'            : 'Warnings',
        'required'            : 'Required',
        'optional'            : 'Optional',
        'btn_import'          : 'Import',
        'btn_new'             : 'New visit',
        'btn_remove'          : 'Remove all',
        'lbl_title'           : 'Title',
        'lbl_address'         : 'Address',
        'address_placehd'     : 'Address',
        'btn_more'            : 'More options',
        'lbl_latitude'        : 'Latitude',
        'lbl_longitude'       : 'Longitude',
        'lbl_load'            : 'Load',
        'lbl_load_2'          : 'Load 2',
        'lbl_load_3'          : 'Load 3',
        'lbl_load_4'          : 'Load 4',
        'tag'                 : 'Label',
        'type_of_visit'       : 'Type of visit',
        'select_tags'         : 'Select labels',
        'select_type_of_visits': 'Select the type of visits',
        'start_time_window_1' : 'Start time window',
        'start_time_window_2' : 'Start time window 2',
        'end_time_window_1'   : 'End time window',
        'end_time_window_2'   : 'End time window 2',
        'lbl_service'         : 'Service time',
        'lbl_minutes'         : 'Minutes',
        'lbl_notes'           : 'Notes',
        'lbl_contact_name'    : 'Contact name',
        'lbl_contact_phone'   : 'Contact phone',
        'lbl_contact_email'   : 'Contact email',
        'lbl_priority'        :  'Priority',
        'lbl_stop'            : 'Stop',
        'georeferencing'      : 'Geocoding',
        'of'                  : 'of',
        'lbl_reference'       : 'Reference id',
        'remove_all'          : 'Remove all',
        'back'                : 'Back',
        'optimize_btn'        : 'Create routes',
        'no_visits'           : 'No visits yet',
        'may_use'             : 'You may use this ',
        'sample_template'     : 'sample template',
        'or'                  : 'or',
        'create_visit'        : 'Create a visit',
        'alert_high'          : 'High alert',
        'alert_medium'        : 'Medium alert',
        'alert_low'           : 'Low alert',
        'error_country'       : 'Different country',
        'error_distance'      : 'Too far from depot',
        'error_area_center'   : 'Center of administrative area',
        'error_wrong_area'    : 'Different area between address and geopoint',
        'title'               : 'Visits',
        'errors'              : 'Errors',
        'import'              : 'Import visits',
        'warning_msg'         : 'Continue despite active alerts.',
        'edit_title'          : 'Edit visits',
        'create_title'        : 'Create visit',
        'btn_less'            : 'Less options',
        'to'                  : 'to',
        'required_skills'     : 'Required skills',
        'optional_skills'     : 'Optional skills',
        'seller'              : 'Seller',
        'select_seller'       : 'Seller name',
        'no_visits_for_date'  : 'There are not visits for the selected date.',
        'please'              : 'Please',
        'other_date'          : 'choose another date',
        'or_go_to'            : 'or go to',
        'orders'              : 'Visits module',
        'to_add_new_visits'   : ' and add a new visit.',
        'not_available_vehicles': 'Not available vehicles',
        'invalid_date_plan'   : 'Invalid date plan',
        'msg_error_email_valid' : '* Invalid email format',
        'msg_error_service_time': '* Wrong time format service, the value must be between 0 and 999999.',
        'msg_error_plan_date'   : 'To use last locations of vehicules the plan date must contain the current day.',
        'error_workday_exceeded': 'The following vehicles can not be used because they are close to finishing their workday.',
        'delete_all_modals'     : 'Delete visits',
        'delet_modal_message'   : 'Are you sure you want to delete shipments scheduled for this date?.',
        'close'                 : 'Close',
        'delete'                : 'Delete',
        'cancel_loading'        : 'Cancel',
        'excel_name'            : 'example',
        'excel_title'           : 'Title*   Required',
        'excel_address'         : 'Full address*   Required',
        'import_no_address'     : 'Unspecified address',
        'excel_load'            : 'Load',
        'excel_hour_start'      : 'Hour start',
        'excel_hour_end'        : 'Hour end',
        'excel_service_time'    : 'Service time',
        'excel_notes'           : 'Notes',
        'excel_latitude'        : 'Latitude',
        'excel_longitude'       : 'Longitude',
        'excel_reference'       : 'Id reference',
        'excel_requires_skills' : 'Required skills',
        'excel_optional_skills' : 'Optional skills',
        'excel_contact_name'    : 'Contact name',
        'excel_contact_phone'   : 'Phone contact',
        'excel_contact_email'   : 'Email contact',
        'excel_hour_start_2'    : 'Hour start 2',
        'excel_hour_end_2'      : 'Hour end 2',
        'excel_priority'        : 'Priority',
        'excel_programmed_date' : 'Programmed date',
        'excel_load_pick_1'     : 'Load pick',
        'excel_load_pick_2'     : 'Load pick 2',
        'excel_load_pick_3'     : 'Load pick 3',
        'excel_visit_type'      : 'Visit type',
        'excel_city'            : 'City',
        'excel_seller'          : 'Seller',
        'delete_visits'         : 'Delete visits',
        'excel_load_2'          : 'Load 2',
        'excel_load_3'          : 'Load 3',
        'excel_load_4'          : 'Load 4',
        'excel_sms'             : 'SMS',
        'bulk_edit'             : 'Bulk edit',
        'deselect_all'          : 'Deselect all',
        'bulk_edit_message_1'   : 'You are editing {{visitsQty}} visits',
        'bulk_edit_message_2'   : 'Remember that the modifications will overwrite the previous data.',
        'bulk_edit_warning'     : 'You are about to edit {{totalVisitsToEdit}} visits',
        'contact_email_placeholder': 'Add an email',

        'delete_warning_visits_message' : 'Do you want to delete visits with warning?',
        'delete_error_visits_message'   : 'Do you want to delete visits with errors?',
        'error_msg_routes_not_completed': 'Selected vehicles are still making deliveries.',
        'error_format_date'             : '* Wrong hour format -- HH:MM',
        'error_between_date'            : '* Start time must be less than the final hour.',
        'error_invalid_date'            : '* Start date must be less or equal than end date',
        'error_empty_date'              : '* You must enter two hours.',
        'error_format_duration'         : 'Incorrect visit duration format',
        'error_format_capacity'         : 'Incorrect visit capacity format',

        'error_email_length_message'    : 'One of the emails is too long',
        'error_max_emails_message_1'    : 'You can add up to',
        'error_max_emails_message_2'    : 'emails',

        'address_required'              : 'Address required',
        'load_required'                 : 'Load required',
        'title_required'                : 'Title required',
        'load_1_invalid'                : 'Load 1 in wrong format, only numbers are valid.',
        'load_2_invalid'                : 'Load 2 in wrong format, only numbers are valid',
        'load_3_invalid'                : 'Load 3 in wrong format, only numbers are valid',
        'load_4_invalid'                : 'Load 4 in wrong format, only numbers are valid',
        'attention'               : 'Attention',
        'remove_route_optimize_1' : 'You already have routes created, choose an option to continue: ',
        'remove_route_optimize_2' : "You'll get a new optimization in order to consider your last changes in visits (this may change their order compared to last optimization).",
        'positive_selection_visits_active' : 'You are about to route  {{checkedCount}} visits out of a total of {{totalCount}}. The pending visits (which are not part of this group) will be excluded from the routing.',
        'positive_selection_visits_active_note': 'When selecting your visits, routes will be created solely with that selected group. The rest will NOT be included in the routing.',
        'move_to_dropdown'              : {
          'dropdown_title'              : 'Move to',
          'visits_for_routing'          : 'Visits to route',
          'pending_visits'              : 'Pendings visits',
        },
        'total_of_visits'               : 'Total visits ({{ totalLoadedVisits + totalLoadedVisitForRouting}})',
        'visits_for_routing'            : 'Visits to route ({{totalVisitsForRouting}}) ',
        'pending_visits'                : 'Pendings visits ({{totalPendingVisits}})',
        'remove_route_cancel'     : 'Cancel',
        'remove_route_accept'      : 'Accept',
        'btn_more_options'                : 'More options',
        'btn_less_options'                : 'Less options',
        'excel_sms_enable'              : 'Send SMS',
        'alert_notification'            : {
          'error_country'               : 'Different country',
          'error_wrong_area'            : 'Different area to the one indicated in the address',
          'error_area_center'           : 'Center of the area',
          'error_doubt'                 : 'Doubtful address',
          'error_distance'              : 'Too far from depot',
          'error_window'                : 'Problem with time windows',
          'error_overlapping'           : 'Overlapping time windows',
          'country_center'              : 'No results found'
        },
        'new_alert_notification'            : {
          'alert_high'                  : 'High alert',
          'alert_medium'                : 'Medium alert',
          'alert_low'                   : 'Low alert',
          'error_distance'              : 'Too far from depot',
          'error_window'                : 'Problem with time windows',
          'error_overlapping'           : 'Overlapping time windows',
        },
        'no_title'                      : 'Untitled visit',
        'error_window_start_greater_than_window_end': 'Start time is greater than end time',
        'optimize_btn_jdh'        : 'Create JDH routes',
        'create_visit_btn' : 'Add visits <span class="caret"></span>',
        'create_visit_manual': 'Single visit',
        'create_visit_excel': 'Import excel',
        'create_visit_integration': 'From integration',
        'component_visits_import': {
          'title_visits_integration' : 'Add integration visits',
          'button_title': 'Import',
          'back_title': 'Back',
          'select_date': 'Select the date range',
          'select_visit_type': 'Select the type of visit',
          'select_visit_status': 'Select visit status',
          'visits_failed_label': 'failed visits',
          'visits_pending_label': 'pending visits',
          'visits_partial_label': 'partial visits',
          'title_visits_integration_not_completed': 'Add incomplete visits',
          'title_visit_type_list': 'Visits type',
          'visits_list_option_all': 'all',
          'no_visit_type': 'No visit type',
          'start_date': 'Start date',
          'end_date': 'End date',
          'error_date_range': 'The date range must be less than 30 days.',
          'error_date_order': 'The end date must be greater than the start date.'
        },
        'remove_route_overwrite_routes_option': 'Overwrite routes',
        'remove_route_keep_routes_option': 'Keep routes',
        'remove_route_keep_routes_partials': 'Incremental routing',
        'remove_route_optimize_3': "The existing routes will remain unchanged and the new visits will be assigned to a selected available vehicle. If there are no vehicles available, you will find these new visits as unassigned.",
        'remove_route_optimize_4': 'The previous visits will remain in their respective vehicles and the new ones will be added to them if they have capacity, if not they\'ll appear as unassigned.',
        'incremental_routing_selection_message': {
          'part1': 'Important: ',
          'part2': 'Keep in mind that when selecting this option, the optimization will not take into account the configured linkage of',
          'part3': 'visits by distance.',
          'part4': ''
        },
        'out_of_route': 'Unassigned',
        'priority_levels': {
          'first_of_day'   : 'First of the day',
          'last_of_route'  : 'Last of its route',
          'high_priority'  : 'High priority',
          'medium_priority': 'Medium priority',
          'low_priority'   : 'Low priority',
          'end-of-route-pickup': 'End-of-route pickup'
        },
        'select_priority_level': 'Select a priority',
        'tooltip_priority_level': 'Use priorities to define whether a visit is more important than another. Or to choose if you want the visit to go first or last in a route.',
        'create_visit_integration_not_completed': 'Not completed',
        'tooltips': {
          'new_visit': 'New visit',
          'edit': 'Edit',
          'delete': 'Delete'
        },
        'wave_routing_modal': {
          'title': 'What is your time limit?',
          'subtitle': 'Please complete this information',
          'time_input_title': 'Time limit',
          'time_format_error': 'Enter a valid time.',
          'checkbox_message': 'This is the last load'
        },
        'visits_utils': {
          'capacityError': 'Load 1',
          'capacityError2': 'Load 2',
          'capacityError3': 'Load 3',
          'maximumTimeError': 'Working time',
          'skillsError': 'Skills',
          'timeError': 'Time window'
        },
        "number_of_visits_selected": "{{selectedVisits}} of {{totalVisits}} selected",
        "error_coordinate_pattern": "Coordinates must be valid numbers",
        'visit_tabs': {
          'details': 'Details',
          'items': 'Items'
        },
        'sort_visits': {
          'sort': 'Sort',
          'sort_asc': 'Ascending',
          'sort_desc': 'Descending',
          'load': 'Load 1',
          'load2': 'Load 2',
          'load3': 'Load 3',
          'load4': 'Load 4',
          'title': 'Title',
          'remove_sort': 'Reset order'
        },
        'placeholder': {
          'title' : 'Title of the visit',
          'id': 'Enter ID',
          'address': 'Street number',
          'latitude': 'Enter latitude',
          'longitude': 'Enter longitude',
          'load_1': 'Enter load 1',
          'load_2': 'Enter load 2',
          'load_3': 'Enter load 3',
          'load_4': 'Enter load 4',
          'service_time': 'Enter the minutes',
          'contact_person': 'Name of the contact person',
          'phone_contact': 'Phone contact',
          'notes': 'Write notes related to the visit'
        },
        'selected_singular'      : 'Selected',
        'selected_plural'        : 'Selected',
        'address_stats': {
          'status': {
            'new': 'New',
            'used': 'Used',
            'warn_qty_failed': 'Used',
            'warn_diff_loc': 'Used'
          },
          'tooltips': {
            'new': 'Previously unused address',
            'used': 'Address used more than 5 times',
            'warn_qty_failed': 'Previously used address with more than 50% of failed checkouts',
            'warn_diff_loc': 'We detected a location different from the one entered',
            'change_location': 'Change to suggested location',
            'undo_change_location': 'Undo'
          }
        },
        'toolSelectionOnMapNavbar': {
          'selected_visits_plural': 'visits selected',
          'selected_visits_singular': 'visit selected',
          'load1': '@:Routes.load1',
          'load2': '@:Routes.load2',
          'load3': '@:Routes.load3',
          'load4': '@:Routes.load4',
          'btn_deselect': 'Deselect',
          'toast_delete_selected_visits_success': 'Your visits have been successfully deleted'
        },
        'modal_warning_checked_visits': {
          'title': 'Warning',
          'subtitle': 'Confirm partial routing',
          'message': 'You have selected {{checkedCount}} visits out of a total of {{totalCount}}. The route will be created only with this selected group.',
          'cta_continue': 'Do you want to continue with only {{checkedCount}} visits?',
          'important': 'IMPORTANT',
          'important_note': 'By selecting your visits, the routes will be created only with that selected group. The rest will NOT be included in the routing.'
        }
      },
      'Routes': {
        'load1'                 : 'Load 1',
        'load2'                 : 'Load 2',
        'load3'                 : 'Load 3',
        'load4'                 : 'Load 4',
        'duration'              : 'Duration (hours)',
        'average_kms'           : '@:Planner.average_kms',
        'start_time'            : '@:Vehicles.start_time',
        'end_time'              : '@:Vehicles.end_time',
        'origin'                : '@:Vehicles.origin',
        'routes_summary'        : 'Routes\' summary',
        'btn_edition'           : 'Edit',
        'btn_moveTo'            : 'Move to',
        'btn_cancelMoveTo'      : 'Done edit',
        'btn_optimize'          : 'Optimize',
        'unassigned'            : 'Unassigned',
        'route'                 : 'Route',
        'start'                 : 'Start',
        'end'                   : 'End',
        'back'                  : 'Back',
        'optimize'              : 'Optimize',
        'export'                : 'Export',
        'assign'                : 'Assign',
        'assignments.title'     : 'Route assignments',
        'assignments.date'      : 'Delivery date',
        'assignments.assignBtn' : 'Assign',
        'assignments.endBtn'    : 'Finish',
        'assignments.unassigned': 'Unassigned',
        'assignments.successMessage': 'All routes were assigned!',
        'the_vehicle'             : 'The vehicle',
        'assignments.errorMessage': 'already has routes with the same date and start time.',
        'assignments.isErrorInPlanInstance': 'There is a plan with the same starting and ending date.',
        'assignments.data_format_error.title': 'There is an error in visits data.',
        'assignments.data_format_error.message': 'Please check out that visits data is in the correct format',
        'assignments.default_error.title': 'There is an error ',
        'assignments.default_error.message': 'An error occurred while saving the plan, try again later',
        'assignments.plan_name_error.title': 'A plan with the same name already exists',
        'assignments.route_started_or_finished_error.title': 'Non-editable routes',
        'assignments.route_started_or_finished_error.message': 'Routes that have already started or finished cannot be modified',
        'assignments.vehicle_unavailable_error.title': 'Unavailable vehicles',
        'assignments.vehicle_unavailable_error.message': 'Some vehicles are not available for routing.',
        'pleaseCorrects'    : 'Please correct the inconsistences and try again.',
        'go_back'           : 'Back',
        'goToRouteTracking' : 'If you want to start tracking your deliveries, go to',
        'routeTracking'     : 'Route Tracking',
        'new_routes'        : ' Routes',
        'cancel_creation'   : 'Cancel creation',
        'btn_addTo'         : 'Create into',
        'routes_title'      : 'Routes',
        'routes_title_edit' : 'Editing routes',
        'btn_new'           : '+ New route',
        'btn_remake_routes' : 'Redo routes',
        'visits_out_of_route_title' : 'Unassigned visits',
        'select_all'                : 'Select all',
        'hide_routes'               : 'Hide routes',
        'show_routes'               : 'Show routes',
        'route_text'                : 'Route ',
        'reorder'                   : 'Reorder route',
        'from'                      : 'Starting from',
        'to'                        : 'To ',
        'finish_title'              : 'Finish route design',
        'finish_title_success'      : "Your routes were sent to your drivers",
        'finish_title_success_async': "We are saving your plan...",
        'finish_content_success'    : "We will notify you by email when your plan is fully saved. If you prefer, you can create a new route in our Router or explore other sections of our platform.",
        'vehicle'                   : '@:Vehicles.vehicle',
        'driver'                    : '@:Vehicles.driver',
        'codriver'                  : '@:Vehicles.codriver',
        'routes'                    : 'Routes',
        'route_singular'            : 'Route',
        'visits'                    : 'Visits',
        'time'                      : 'Time',
        'select_driver'             : '-- Select a driver --',
        'confirm'                   : 'Confirm',
        'save_draft'                : 'Save draft plan',
        'out_of_route'              : 'Unassigned visits',
        'unselected_routes_remake'  : 'You must select at least one vehicle',
        'delete_route'              : 'Remove route',
        'delete_modal_message'      : 'Are you sure you want to delete this route?',
        'close'                     : 'Close',
        'delete'                    : 'Delete',
        'delete_menu'               : 'Delete route',
        'prioritize_high_load'      : 'Prioritize high load at the start',
        'reverse_route_order'       : 'Reverse route order',
        'reverse_route_order_success_title' : 'The route has been reversed',
        'reverse_route_order_success_msg' : 'The visits have changed order. We recommend that you check the result.',
        'remake_vehicles_error'     : 'Some of the selected vehicles don\'t have visits',
        'finish_modal.tracking_module' : 'Tracking module',
        'finish_modal.planning_module' : 'Design module',
        'finish_modal.btn_tracking_module': 'Fleet monitoring',
        'finish_modal.btn_planning_module': 'Route design',
        'finish_modal.text_tracking_module': 'If you want to start to monitoring your deliveries go to',
        'finish_modal.text_planning_module': 'You can create a new plan by going to',
        'optimize.balance'            : 'Balance',
        'optimize.all_vehicles'       : 'Minimize vehicles',
        'optimize.open_start'         : 'Open start routes',
        'optimize.avoid_tolls'        : 'Avoid tolls',
        'optimize.maximize_attended_load': 'Maximize load served',
        'optimize.prioritize_load': 'Prioritize heavy load first',
        'optimize.open_ended'         : 'Open end routes',
        'optimize.join'               : 'Join similars',
        'optimize.join_v2'            : 'Join similars 2.0',
        'optimize.last_position_optimize': 'Use current location',
        'optimize.single_tour': 'Single tour',
        'optimize.beauty': 'SimpliFy',
        'optimize.big_vrp': 'Big VRP',
        'optimize.use_euclidean_distance': 'Euclidean Distance',
        'optimize.enable_graphs': 'Graphs',
        'optimize.auto_reorder': 'Auto Reorder',
        'optimize.enable_soft_window': 'Soft time windows',
        'optimize.on_foot' : 'Routing on foot',
        'optimize.wave_routing' : 'Part load',
        'optimize.distance_to_join_visits': 'Join visits by distance',
        'optimize.routing_options': 'Optimizers',
        'optimize.radial_options': 'Sequencers',
        'optimize.radial_default': 'Default',
        'optimize.radial_to_near': 'From far to near',
        'optimize.radial_to_far': 'From near to far',
        'optimization.all_vehicles'       : 'Minimize vehicles',
        'optimization.balance'            : 'Balance',
        'optimization.open_ended'         : 'Open end routes',
        'optimization.join'               : 'Join similars',
        'optimization.last_position_optimize': 'Use current location',
        'optimization.displayed_options'  : 'Visualize on menu',
        'optimization.default_values'     : 'Default values',
        'optimize.one_seller_per_vehicle': 'Routes by seller',
        'comments' : 'Comment of the routes',
        'body_1'   : 'This comment applies to the following routes: ',
        'save_comments' : 'Save',
        'route_name' : 'Route',
        'finish_modal.footer_message': 'Remember to tell your drivers to download the mobile app.',
        'assign_driver': 'Assign driver',
        'assign_codrivers': 'Assign co-drivers',
        'comments_route': 'Comment',
        'visits_and' : 'visits and',
        'selected_routes': 'selected routes',
        'single_tour': 'Single tour',
        'beauty': 'SimpliFy',
        'tooltips': {
          'visits_out_of_route_title': 'Your visits can be left unassigned for different reasons: vehicles\' schedule is not long enough, services times too long, very restrictive time windows or insufficient load capacity.',
          'edited_route'             :  'Edited route',
          'skills_error': "Doesn't respect skills",
          'time_error': "Doesn't respect the time window",
          'charge_error_one' : 'Exceeds load 1',
          'charge_error_two': 'Exceeds load 2',
          'charge_error_three': 'Exceeds load 3',
          'charge_error_four': 'Exceeds load 4',
          'route_locked': 'This route is locked and cannot be edited'
        },
        'filter_vehicle': {
          'high_low_kilometer': 'Mileage: Highest to lowest',
          'low_high_kilometer': 'Mileage: Lowest to highest',
          'high_low_load': 'Load 1%.: Highest to lowest',
          'low_high_load': 'Load 1%.: Lowest to highest',
          'high_low_load2': 'Load 2%.: Highest to lowest',
          'low_high_load2': 'Load 2%.: Lowest to highest',
          'high_low_load3': 'Load 3%.: Highest to lowest',
          'low_high_load3': 'Load 3%.: Lowest to highest',
          'high_low_hours': 'Vehicle hours: Highest to lowest',
          'low_high_hours': 'Vehicle hours: Lowest to highest',
          'low_high_name': 'Vehicle name',
          'sort_by': 'Order by'
        },
        'support_badge': {
          'revised' : 'Revised'
        },
        'status': {
          'pending': 'Route not started',
          'started': 'Route started',
          'completed': 'Route finished',
          'finished': 'Route finished'
        },
        'warning': {
          'started': 'Warning: You are trying to edit a route that has already been started.',
          'finished': 'Warning: You are trying to edit a route that has already been finished.'
        },
        'displayVehiclesList': {
          'categories': {
            'all_vehicles': 'All vehicles',
            'available_vehicles' : 'Free vehicles',
            'occupied_vehicles' : 'Occupied vehicles'
          },
          'vehicle_status_available': 'Available',
          'vehicle_status_occupied': 'Occupied'
        }
      },
      'Excel_Header': {
        'driver'          : 'Driver',
        'vehicle'         : 'Vehicle',
        'route_Index'     : 'Index route',
        'stop'            : 'Stop',
        'arrival_Time'    : 'Estimated time of arrival',
        'title'           : 'Title',
        'address'         : 'Address',
        'load'            : 'Load',
        'window_Start'    : 'Start of time window 1',
        'window_End'      : 'End of time window 1',
        'window_Start2'   : 'Start of time window 2',
        'window_End2'     : 'End of time window 2',
        'service_Time'    : 'Service time',
        'notes'           : 'Notes',
        'latitude'        : 'Latitude',
        'longitude'       : 'Longitude',
        'reference'       : 'Id Reference',
        'requires_Skills' : 'Required skills',
        'optional_Skills' : 'Additional skills',
        'contact_Name'    : 'Contact person',
        'contact_Phone'   : 'Phone contact',
        'contact_email'   : 'Email contact',
        'distance'        : 'Distance',
        'order_size'      : 'Load',
        'total_size'      : 'Total load',
        'warnings'        : 'Warnings',
        'priority'        : 'Priority',
        'visit_load2'     : 'Load 2',
        'visit_load3'     : 'Load 3',
        'route_coment'    : 'Route comment',
        'tags'            : 'Tags',
        'zones'           : 'Zones',
        'visit_alerts'    : 'Visit alerts',
        'route_name'      : '@:Routes.route_name',
        'origin'          : '@:Vehicles.origin',
        'start_time'      : '@:Routes.start_time',
        'end_time'        : '@:Routes.end_time',
        'visits'          : '@:Routes.visits',
        'load1'           : '@:Routes.load1',
        'load2'           : '@:Routes.load2',
        'load3'           : '@:Routes.load3',
        'load4'           : '@:Routes.load4',
        'total'           : 'total',
        'total_routes_summary': 'Total Routes Summary',
        'duration'        : 'Duration (hours)',
        'customer_shipment_date': 'Customer Shipment Date',
        "stops": "Stops"
      },
      'Pdf' : {
        'detailed_pdf' : 'Detailed PDF',
        'vehicle': 'Vehicle',
        'no_driver': 'No assigned driver',
        'to': ' to ',
        'name': 'NAME',
        'id': 'ID',
        'coments':'COMMENTS OR OBSERVATIONS',
        'signature' : 'SIGNATURE OF WHO RECEIVES',
        'address' : 'ADDRESS',
        'contact': 'CONTACT',
        'windows': 'TIME WINDOWS',
        'phone' : 'PHONE',
        'skills_required': 'REQUIRED SKILLS',
        'route_comment' : 'ROUTE COMMENT',
        'no_route_comments': 'No comments',
        'notes'           : 'NOTES',
        'between_streets': 'BETWEEN STREETS',
        'customer_shipping_date': 'CUSTOMER SHIPPING DATE'
      },
      'Summarized_Pdf' : {
        'summarized_pdf'             : 'Summary PDF',
        'title'                      : 'Title',
        'contact_phone'              : 'Phone',
        'missing_contact_phone'      : 'No information',
        'address'                    : 'Address',
        'time_windows'               : 'Time Windows',
        'arrival'                    : 'Arrival',
        'id'                         : 'Reference ID',
        'missing_id'                 : 'No information',
        'missing_streets_in_between' : 'No additional information',
        'customer_shipment_date'     : 'Customer Shipment Date'
      },
      'Planner_toast' : {
        'error_get_plans_1'         : 'Error loading plans, path does not exist',
        'error_get_plans_2'         : 'Error loading plans from the servers',
        'wrong_path'                : 'Error in the request, path does not exist',
        'not_permission'            : 'You don\'t have permission to access route design',
        'vehicle_not_found'         : 'Vehicle not found',
        'error_get_plans_3'         : 'Plan not found',
        'error_delete_plan'         : 'Error removing plan, please try again',
        'error_put_plan_found'      : 'Error updating plan, path does not exist',
        'error_call_osrm'           : 'Error loading the selected plan',
        'error_visit_update_plan'   : 'Error editing visits plan',
        'error_optimize_capacity_vehicles' : 'Error in vehicle capacity, please edit it and try again.',
        'empty_file_excel'          : 'Empty excel file, check the file and try again.',
        'wrong_row_excel'           : 'Some errors were found in the file.',
        'error_optimize_500'        : 'There was a problem when optimizing, please try again.',
        'error_order_route'         : 'There was an error in ordering the route, please try again.',
        'error_remake_routes'       : 'There was an error when making routes, please try again.',
        'error_save_plan_finish'    : 'There was an error saving plan, please try again.',
        'error_delete_route'        : 'Error removing the route',
        'error_no_vehicles_for_reoptimize': 'No vehicles are available to execute this action',
        'error_no_selected_vehicles_for_reoptimize': 'The new visits were not assigned as new vehicles were not selected for reoptimization',
        'error_no_visits_for_reoptimize': 'No visits available to execute this action',
        'error_save_plan_finish_planned_date' : 'A plan already exists for the same date, please correct and try again',
        'error_save_plan_finish_plan_name': 'A plan with the same name already exists, please correct and try again',
        'visits_imported'           : 'Total visits imported: ',
        'error_move_visits'         : 'Some selected visits cannot be moved from the original route',
        'success_move_visits'       : 'Changes made successfully',
        'error_move_visits_to_started_or_finished_route': 'Route unavailable for changes',
        'msg_move_to_mode'          : 'Click on the route to which you want to move your selected visits',
        'error_seller'              : "We couldn't find the seller you specified in {{count}} visits, so the field is left empty.",
        "error_city"                : "{{count}} visits without a city were found (required for Colombia)",
        'error_check_routes_status': 'Could not verify the status of the routes. Please try again.'
      },

      'Log' : {
        'actions': {
          'delete_plan': 'Delete plan',
          'editing_plan': 'Edit plan'
        }
      },
      'Plan': {
        'modal_cancel_edit_message_1' :  'If you exit plan edition any unsaved changes will be lost.',
        'modal_cancel_edit_message_2': 'Do you want to continue?',
        'modal_cancel_edit_title': 'Cancel plan edit',
        'button_cancel_modal': 'Cancel',
        'button_accept_modal': 'Accept'
      },
      'Driver': {
        'group_available': '',
        'group_assigned': '✓'
      }
    });

    $translateProvider.translations('pt', {
      'Planner' : {
        'zones'                 : 'ZONAS',
        'visits'                : 'Visitas',
        'routes'                : 'Rotas',
        'to'                    : 'às',
        'btn_save'              : 'Salvar',
        'btn_assign_codrivers'  : 'Salvar',
        'btn_accept'            : 'Accept',
        'btn_save_draft'        : 'Salvar rascunho',
        'btn_cancel'            : 'Cancelar',
        'btn_continue'          : 'Aceitar',
        'btn_save_and_continue' : 'Salve e continue',
        'btn_back'              : 'Voltar',
        'btn_finish'            : 'Finalizar',
        'btn_export'            : 'Exportar',
        'btn_duplicate'         : 'Plano duplicado',
        'btn_balance'           : 'Balancear',
        'input_planName'        : 'Digite um nome para o plano',
        'used_vehicles'         : 'Veículos \nusados',
        'your_fleet'            : 'sua frota',
        'created_routes'        : 'Rotas criadas',
        'total_departures'      : 'Saídas totais',
        'average_time'          : 'Tempo',
        'vehicles'              : 'Veículos',
        'load_plans'            : 'Carregar planos anteriores',
        'total_load_plans'      : 'Carregar planos anteriores:',
        'load_drafts'           : 'Carregar rascunho do planos',
        'total_load_drafts'     : 'Carregar rascunho do planos:',
        'empty_drafts_msg'      : 'Não há rascunho do planos criados.',
        'select_fleet'          : 'Selecionar frota',
        'plan'                  : 'plano',
        'start_date'            : 'data de início',
        'end_date'              : 'data de término',
        'empty_plans_msg'       : 'Não há planos criados.',
        'loading_plans_msg'     : 'Carregando planos criados.',
        'plan_resume'           : 'Resumo plano',
        'draft_plan_resume'     : 'Resumo rascunho do plano',
        'codrivers_edition'     : 'Edição de co-pilotos',
        'codrivers_select'      : 'Selecione um ou mais co-pilotos para este veículo',
        'no_exist_plans_msg'    : 'No plano selecionado.',
        'select_vehicle'        : 'Selecione um veículos',
        'upload'                : 'Carregar',
        'btn_download'          : 'Baixar',
        'btn_load'              : 'Carregar',
        'success_update_plan'   : 'Plano atualizado com sucesso!',
        'error_update_plan'     : 'Falha ao atualizar o plano de dados, por favor, tente novamente.',
        'error_plan_name_exist' : 'A conta já tem um plano com esse nome, por favor escreva um novo.',
        'visits_edited'         : 'visitas editados',
        'total_visits'          : 'Total de visitas',
        'drivers'               : 'Motoristas',
        'success_plan_uploaded' : 'Seu plano foi enviada com sucesso.',
        'success_plan_uploaded_but_no_changes' : 'Não houve mudanças nos registros enviados.' ,
        'btn_confirm'           : 'Confirmar',
        'plan_name'             : 'nome do plano',
        'delete_plan'           : 'Excluir plano',
        'delete_plan_keep_visits'     : 'Manter',
        'delete_draft'          : 'Deletar rascunho do plano',
        'delete_draft_plan'     : 'Eliminar rascunho do plano',
        'delete_modal_message'  : 'Você está prestes a deletar um plano, o que você quer fazer com as visitas deles?',
        'delete_modal_message_2' : 'Você está prestes a excluir um plano em modo de edição, o que você quer fazer com as visitas deles?',
        'delete_plan_and_visits_warning' : '<b>Excluir visitas</b>, eles não estarão mais disponíveis para recuperação.',
        'delete_plan_and_keep_visits_warning' : '<b>Manter visitas</b>, eles podem ser recuperados da opção de adicionar visitas da integração.',
        'delete_modal_message_warning': '<b>Aceito que esta ação é irreversível.</b><br>Ao clicar em “Excluir”, o plano e as rotas deixarão de existir.',
        'delete_draft_modal_message_warning': 'Aceito que esta ação é <b>irreversível</b>. O rascunho será eliminado e o plano voltará à sua versão original.',
        'delete_plan_recommendation': 'Recomendado',
        'close'                 : 'Fechar',
        'delete'                : 'Excluir',
        'select_day'            : 'Escolha um dia',
        'sunday'                : 'Domingo',
        'monday'                : 'Segunda-feira',
        'tuesday'               : 'Terça-feira',
        'wednesday'             : 'Quarta-feira',
        'thursday'              : 'Quinta-feira',
        'friday'                : 'Sexta-feira',
        'saturday'              : 'Sábado',
        'no_day'                : 'Não aplicável',
        'weekend_start_day'     : 'Início da semana',
        'editing_plan'          : 'plano de edição',
        'planned_date'          : 'plano na data corrente',
        'infowindow_since'  : 'Desde as',
        'infowindow_to'     : 'a',
        'infowindow_until_to': 'Até',
        'average_load'       : 'Carga 1',
        'average_load_2'     : 'Carga 2',
        'average_load_3'     : 'Carga 3',
        'average_load_4'     : 'Carga 4',
        'visit_singular'     : 'visita',
        'visit_plural'       : 'visitas',
        'average_kms'        : 'Quilômetros',
        'average_by_route'   : 'Por rota',
        'average_by_vehicle' : 'Por veículo',
        'number_of_routes'   : 'Número \nde rotas',
        'headers_editing_plan' : 'Plano de edição',
        'headers_step_1'     : '1. Veículos',
        'headers_step_2'     : '2. Visitas',
        'headers_step_3'     : '3. Rotas',
        'of'                 : 'da',
        'on_foot_option'     : 'Se a sua frota for pedestre, seleccione a optimização:',
        'MSOMC': {
          'alert_msg': 'Excluir seleção'
        },
        'editing_current_plan': 'Você está editando este plano',
        'plan_not_deleted_message': 'Não é possível eliminar Planos em curso',
        'draft_plan'            : 'Esboço',
        'saving': 'Aguarde um momento, estamos salvando seu plano...',
        'error': 'Erro ao salvar o plano, por favor tente novamente.',
        'color_picker': {
          'recolorer': 'Recolorir',
          'info_message': 'Isso mudará a cor de todas as rotas para este veículo.',
          'btn_cancel': 'Cancelar',
          'btn_save': 'Salvar'
        }
      },
      'Vehicles': {
        'origin'                : 'Origem',
        'origin_placehd'        : 'Endereço inicial',
        'use_label'             : 'Para usar como endereço de destino',
        'schedule'              : 'Das',
        'destination'           : 'Destino',
        'dest_placehd'          : 'Endereço de destino',
        'label_vehicles'        : 'Escolha seus veículos para uso',
        'active'                : 'ativo',
        'inactive'              : 'inativo',
        'keep_routes'           : 'Mantenha rotas',
        'delete_routes'         : 'Excluir rotas',
        'set_visits'            : 'Definir visitas',
        'empty'                 : 'Você ainda não adicionou nenhum veículo.',
        'create'                : 'Criar um',
        'new_vehicle'           : 'novo veículo',
        'select_all'            : 'Todos',
        'select_only_available' : 'Disponível',
        'select_only_partially_available' : 'Disponibilidade parcial',
        'initial_information'   : 'Informações iniciais',
        'date'                  : 'Data',
        'to'                    : 'às',
        'vehicle'               : 'veículo',
        'capacity'              : 'capacidade',
        'vehicle_capacity_2'    : 'capacidade 2',
        'vehicle_capacity_3'    : 'capacidade 3',
        'license_plate'         : 'placa do veículo',
        'load_type'             : 'tipo de carga',
        'load_type_values'      : {
          'light': 'Leve',
          'heavy': 'Pesada'
        },
        'driver'                : 'motorista',
        'codriver'              : 'co-piloto',
        'manage_vehicles'       : 'Gerenciar os meus veículos',
        'no_vehicles_selected'  : 'Sem veículos escolhidos.',
        'origin_or_destiny_error_msg' : 'Alguns dos veículos seleccionados não tem origem ou destino.',
        'disabled_vehicles_selected'  : 'Alguns dos veículos seleccionados não está disponível no momento indicado.',
        'title_edit_vehicle'    : 'Editar veículo',
        'vehicle_name'          : 'Nome',
        'vehicle_capacity'      : "@:Vehicles.capacity",
        'vehicle_driver'        : '@:Vehicles.driver',
        'vehicle_origin'        : '@:Vehicles.origin',
        'vehicle_destination'   : '@:Vehicles.destination',
        'vehicle_skills'        : 'Habilidades',
        'select_driver'         : '--- Selecione um motorista ---',
        'more_vehicles'         : 'Mais veículos',
        'minus_vehicles'        : 'Menos veículos',
        'error_format_date'     : '* Formato da hora incorreta -- HH:MM',
        'error_between_date'    : '* A hora de início deve ser menor do que a hora final.',
        'error_empty_date'      : '* Deve digitar duas horas.',
        'empty_vehicles_1'      : 'Você não tem veículos criados',
        'empty_vehicles_2'      : 'Criar o seu primeiro veículo',
        'available.default'           : 'Veículo disponível para roteamento',
        'partiallyAvailable'          : 'Veículo disponível a partir das',
        'notAvailable.message1'       : 'Veículo ocupado das',
        'notAvailable.message2'       : 'às',
        'blocked'                     : 'Veículo trancado',
        'expired_documents_singular'  : 'Veículo com documento vencido',
        'expired_documents_plural'    : 'Veículo com {{countOfExpiredDocuments}} documentos vencidos',
        'required'                    : 'Requerida',
        'optional'                    : 'Opcional',
        'start_date'                  : 'Data início',
        'end_date'                    : 'Data término',
        'start_time'                  : 'Hora início',
        'end_time'                    : 'Hora término',
        'rest_time_schedule'          : 'Janela de tempo',
        'rest_time_duration'          : 'Duração',
        'total_kms'                   : 'Quilômetros percorridos',
        'time_routes'                 : 'Tempo total',
        'total_routes'                : 'Rotas',
        'total_arrivals'              : 'Paradas',
        'visit_count'                 : 'Visitas',
        'client_count'                : 'Clientes',
        'average_load_1'              : 'Carga 1 média',
        'average_load_2'              : 'Carga 2 média',
        'average_load_3'              : 'Carga 3 média',
        'average_load_4'              : 'Carga 4 média',
        'tooltips': {
          'maximum_time_error': 'O tempo máximo em rota é:',
          'max_visit_error': 'Máximo de visitas de veículos ({{max_visit_vehicle}}) excedido. Conjunto na configuração do veículo.'
        },
        'selected_singular'      : 'Selecionado',
        'selected_plural'        : 'Selecionados',
        'vehicles_singular'      : 'veículo',
        'vehicles_plural'        : 'veículos',
        'of'                     : 'de'

      },
      'Visits': {
        'all_visits'            : 'Todas',
        'warnings'              : 'Advertência',
        'btn_import'            : 'Importar',
        'btn_new'               : '+ Nova visita',
        'btn_remove'            : 'Remover tudo',
        'lbl_title'             : 'Título',
        'lbl_address'           : 'Endereço',
        'required'              : 'Requerido',
        'optional'              : 'Opcional',
        'btn_more'              : 'Mais opções',
        'btn_less'              : 'Menos opções',
        'lbl_latitude'          : 'Latitude',
        'lbl_longitude'         : 'Longitude',
        'lbl_load'              : 'Carga',
        'lbl_load_2'            : 'Carga 2',
        'lbl_load_3'            : 'Carga 3',
        'lbl_load_4'            : 'Carga 4',
        'tag'                   : 'Etiqueta',
        'type_of_visit'         : 'Tipo de visita',
        'select_tags'           : 'Seleciona etiquetas',
        'select_type_of_visits'  : 'Seleciona o tipo de visitas',
        'start_time_window_1'   : 'Janela de horário de início',
        'start_time_window_2'   : 'Janela de horário de início 2',
        'end_time_window_1'     : 'Janela de fim de tempo',
        'end_time_window_2'     : 'Janela de fim de tempo 2',
        'lbl_service'           : 'Tempo de serviço',
        'lbl_minutes'           : 'Minutos',
        'lbl_notes'             : 'Notas',
        'lbl_contact_name'      : 'Pessoa de contato',
        'lbl_contact_phone'     : 'Número de contato',
        'lbl_contact_email'     : 'Email',
        'lbl_priority'          : 'Prioridade',
        'lbl_stop'              : 'Parada',
        'georeferencing'        : 'Geocodificação',
        'of'                    : 'de',
        'lbl_reference'         : 'Identificação de referêcia',
        'required_skills'       : 'Habilidades necessárias',
        'optional_skills'       : 'Habilidades opcionais',
        'seller'                : 'Seller',
        'select_seller'         : 'Nome do seller',
        'remove_all'            : 'Remover todas',
        'back'                  : 'Voltar',
        'optimize_btn'          : 'Criar rotas',
        'no_visits'             : 'Sem visitas ainda',
        'may_use'               : 'Você pode usar este ',
        'sample_template'       : 'modelo de exemplo',
        'or'                    : 'ou',
        'create_visit'          : 'Crie uma visita',
        'alert_high'            : 'Alerta alta',
        'alert_medium'          : 'Alerta média',
        'alert_low'             : 'Alerta baixa',
        'error_country'         : 'País diferente',
        'error_distance'        : 'Muito longe do depósito',
        'error_area_center'     : 'Centro da área administrativa',
        'error_wrong_area'      :  'Área diferente entre o endereço e GeoPoint',
        'title'                 : 'Visitas',
        'errors'                : 'Erros',
        'import'                : 'Importar visitas',
        'warning_msg'           : 'Continue apesar alertas ativos',
        'edit_title'            : 'Editar visita',
        'create_title'          : 'Criar visita',
        'to'                    : 'Às',
        'no_visits_for_date'    : 'Sem visitas agendadas para esta data.',
        'please'                : 'Por favor',
        'other_date'            : 'escolha outra data',
        'or_go_to'              : 'o dirigete a',
        'orders'                : 'Pedidos',
        'to_add_new_visits'     : 'para introduzir novas visitas.',
        'msg_error_email_valid' : '* email formato inválido',
        'msg_error_service_time': '* Formato de tempo de serviço incorreto, o valor deve estar entre 0 e 999999.',
        'delete_all_modals'     : 'Excluir as visitas',
        'delet_modal_message'   : 'Tem certeza de que deseja excluir as visitas programados para esta data?.',
        'close'                 : 'Fechar',
        'delete'                : 'Excluir',
        'cancel_loading'        : 'Cancelar',
        'excel_name'            : 'example',
        'excel_title'           : 'Titulo*    Solicitado',
        'excel_address'         : 'endereço completo*    Solicitado',
        'import_no_address'     : 'Endereço indeterminado',
        'excel_load'            : 'Carga',
        'excel_hour_start'      : 'Janela de horário inicial',
        'excel_hour_end'        : 'Janela de horário final',
        'excel_service_time'    : 'Tempo de serviço',
        'excel_notes'           : 'Anotações',
        'excel_latitude'        : 'Latitude',
        'excel_longitude'       : 'Longitude',
        'excel_reference'       : 'Identificação de referência',
        'excel_requires_skills' : 'Habilidade necessária',
        'excel_optional_skills' : 'Habilidade opcional',
        'excel_contact_name'    : 'Pessoa de contato',
        'excel_contact_phone'   : 'Telefone de contato',
        'excel_contact_email'   : 'Correio eletrônico de contato',
        'excel_hour_start_2'    : 'Janela de horário inicial 2',
        'excel_hour_end_2'      : 'Janela de horário final 2',
        'excel_load_2'          : 'Capacidade 2',
        'excel_load_3'          : 'Capacidade 3',
        'excel_load_4'          : 'Capacidade 4',
        'excel_priority'        : 'Prioridade',
        'excel_programmed_date' : 'Data agendada',
        'excel_load_pick_1'     : 'Carga pick',
        'excel_load_pick_2'     : 'Carga pick 2',
        'excel_load_pick_3'     : 'Carga pick 3',
        'excel_visit_type'      : 'Tipo de visita',
        'excel_city'             : 'Cidade',
        'excel_seller'          : 'Seller',
        'delete_visits'         : 'Eliminar visitas',
        'excel_sms'             : 'SMS',
        'bulk_edit'             : 'Edição em massa',
        'deselect_all'          : 'Desmarcar todos',
        'bulk_edit_message_1'   : 'Você está editando {{visitsQty}} visitas',
        'bulk_edit_message_2'   : 'Lembre-se de que as alterações sobrescreverão os dados anteriores.',
        'bulk_edit_warning'     : 'Você está prestes a editar {{totalVisitsToEdit}} visitas',
        'contact_email_placeholder': 'Adicionar um email',

        'delete_error_visits_message'   : 'Tem certeza de que deseja excluir visitas com erros?',
        'delete_warning_visits_message' : 'Tem certeza de que deseja excluir visitas com alertas?',
        'error_format_date'             : '* Formato de hora incorreta -- HH:MM',
        'error_between_date'            : '* A hora de início deve ser maior do que a última hora.',
        'error_invalid_date'            : '* A data de início deve ser menor ou igual à data final',
        'error_empty_date'              : '* Você deve digitar duas horas.',
        'error_format_duration'         : 'duração malformado para a visita',
        'error_format_capacity'         : 'capacidade malformado de visita ',
        'error_email_length_message'    : 'Um dos emails é muito longo',
        'error_max_emails_message_1'    : 'Você pode adicionar até',
        'error_max_emails_message_2'    : 'emails',

        'address_required'              : 'Endereço necessário',
        'load_required'                 : 'Carga solicitada',
        'title_required'                : 'Titulo solicitado',
        'load_1_invalid'                : 'Carrega 1 no formato errado, apenas números são válidos.',
        'load_2_invalid'                : 'Carrega 2 no formato errado, apenas números são válidos.',
        'load_3_invalid'                : 'Carrega 3 no formato errado, apenas números são válidos',
        'load_4_invalid'                : 'Carrega 4 no formato errado, apenas números são válidos',
        'attention'                     : 'Atenção',
        'remove_route_optimize_1'       : 'você tenha criado rotas, escolha uma opção para continuar: ',
        'remove_route_optimize_2'       : 'Você terá como resultado uma nova otimização que incluirá suas últimas mudanças nas visitas (isto pode mudar seu orden em comparação com a última otimização).',
        'positive_selection_visits_active' : 'Você está prestes a roteirizar {{checkedCount}} visitas de um total de {{totalCount}}. As visitas pendentes (que não fazem parte deste grupo) serão excluídas do roteamento.',
        'positive_selection_visits_active_note': 'Ao selecionar suas visitas, as rotas serão criadas exclusivamente com esse grupo selecionado. O restante NÃO será incluído no roteamento.',
        'move_to_dropdown'              : {
          'dropdown_title'              : 'Mudar para',
          'visits_for_routing'          : 'Visitas para encaminhar',
          'pending_visits'              : 'Visitas pendentes',
        },
        'total_of_visits'               : 'Total de visitas ({{ totalLoadedVisits + totalLoadedVisitForRouting}})',
        'visits_for_routing'            : 'Visitas para encaminhar ({{totalVisitsForRouting}}) ',
        'pending_visits'                : 'Visitas pendentes ({{totalPendingVisits}})',
        'remove_route_cancel'           : 'Cancelar',
        'remove_route_accept'           : 'Aceitar',
        'btn_more_options'              : 'Mais opções',
        'btn_less_options'              : 'Menos opções',
        'btn_more_loads'                : 'Ver mais capacidades de carga',
        'btn_less_loads'                : 'Ver menos capacidades de carga',
        'btn_optional_window_time'      : 'Janela de horário opcional',
        'btn_one_window_time'           : 'Janela de horário única',
        'excel_sms_enable'              : 'Enviar SMS',
        'alert_notification'            : {
          'error_country'               : 'País diferente',
          'error_wrong_area'            : 'Commune diferente para o endereço indicado no',
          'error_area_center'           : 'Centro commune',
          'error_doubt'                 : 'Endereço duvidoso',
          'error_distance'              : 'Muito longe do ponto de partida',
          'error_window'                : 'Problema com janelas de tempo',
          'error_overlapping'           : 'Janelas de tempo sobreposto',
          'country_center'              : 'Nenhum resultado encontrado'
        },
        'new_alert_notification'            : {
          'alert_high'                  : 'Alerta alta',
          'alert_medium'                : 'Alerta média',
          'alert_low'                   : 'Alerta baixa',
          'error_distance'              : 'Muito longe do ponto de partida',
          'error_window'                : 'Problema com janelas de tempo',
          'error_overlapping'           : 'Janelas de tempo sobreposto',
        },
        'no_title'                      : 'Visita sem título',
        'error_window_start_greater_than_window_end': 'A hora de início é maior do que o tempo final',
        'optimize_btn_jdh'          : 'Criar rotas JDH',
        'create_visit_btn' : 'Adicionar visitas <span class="caret"></span>',
        'create_visit_manual': 'Manualmente',
        'create_visit_excel': 'Excel',
        'create_visit_integration': 'Integração',
        'component_visits_import': {
          'title_visits_integration' : 'Adicionar a integração visitas',
          'button_title': 'Importação',
          'back_title': 'Voltar',
          'select_date': 'Seleciona o intervalo de datas',
          'select_visit_type': 'Seleccione o tipo de visita',
          'select_visit_status': 'Selecciona o estado da visita',
          'visits_failed_label': 'visitas fracassadas',
          'visits_pending_label': 'visitas pendentes',
          'visits_partial_label': 'visitas parciais',
          'title_visits_integration_not_completed': 'Adicionar visitas incompletas',
          'title_visit_type_list': 'Tipo de visitas',
          'visits_list_option_all': 'tudo',
          'no_visit_type': 'Sin tipo de visita',
          'start_date': 'Data de início',
          'end_date': 'Data de término',
          'error_date_range': 'O intervalo de datas deve ser menor que 30 dias.',
          'error_date_order': 'A data final deve ser posterior à data inicial.'
        },
        'remove_route_overwrite_routes_option': 'Substituir rotas',
        'remove_route_keep_routes_option': 'Manter rotas',
        'remove_route_keep_routes_partials': 'Roteamento incremental',
        'remove_route_optimize_3': 'As rotas anteriores não mudarão e as novas visitas serão designadas a um veículo disponível selecionado. Se não houver veículos disponíveis, você encontrará estas novas visitas como fora da rota.',
        'remove_route_optimize_4': 'As visitas anteriores permanecerão em seus respectivos veículos e as novas visitas serão acrescentadas a eles se tiverem capacidade, caso contrário aparecerão como fora da rota.',
        'incremental_routing_selection_message': {
          'part1': 'Importante: ',
          'part2': 'Ao selecionar esta opção, a otimização não terá em conta a ligação configurada de ',
          'part3': 'visitas por distância.',
          'part4': ''
        },
        'out_of_route': 'Fora da rota',
        'priority_levels': {
          'first_of_day'   : 'Primeiro dia',
          'last_of_route'  : 'Último da sua rota',
          'high_priority'  : 'Prioridade máxima',
          'medium_priority': 'Prioridade média',
          'low_priority'   : 'Baixa prioridade',
          'end-of-route-pickup': 'Coleta no final da rota'
        },
        'select_priority_level': 'Selecione uma prioridade',
        'tooltip_priority_level': 'Use prioridades para definir se uma visita é mais importante do que outra. Ou para escolher se você deseja que a visita entre primeiro ou a última em uma rota.',
        'create_visit_integration_not_completed': 'Não completadas',
        'tooltips': {
          'new_visit': 'Nova visita',
          'edit': 'Editar',
          'delete': 'Eliminar'
        },
        'wave_routing_modal': {
          'title': 'Qual é o seu horário limite?',
          'subtitle': 'É necessário para continuar',
          'time_input_title': 'Horário limite',
          'time_format_error': 'Introduzir uma hora válida.',
          'checkbox_message': 'Esta é a última carga'
        },
        'visits_utils': {
          'capacityError': 'Carga 1',
          'capacityError2': 'Carga 2',
          'capacityError3': 'Carga 3',
          'maximumTimeError': 'Jornada de trabalho',
          'skillsError': 'Habilidades',
          'timeError': 'Janela de horário'
        },
        "number_of_visits_selected": "Seleccionado {{selectedVisits}} de {{totalVisits}}",
        "error_coordinate_pattern": "As coordenadas devem ser números válidos",
        'visit_tabs': {
          'details': 'Detalhes',
          'items': 'Unid'
        },
        'sort_visits': {
          'sort': 'Ordenar',
          'sort_asc': 'Crescente',
          'sort_desc': 'Decrescente',
          'load': 'Carga 1',
          'load2': 'Carga 2',
          'load3': 'Carga 3',
          'load4': 'Carga 4',
          'title': 'Titulo',
          'remove_sort': 'Redefinir ordem'
        },
        'placeholder': {
          'title' : 'Título da visita',
          'id': 'Insira o ID',
          'address': 'Street number',
          'latitude': 'Insira a latitude',
          'longitude': 'Insira a longitude',
          'load_1': 'Insira carga 1',
          'load_2': 'Insira carga 2',
          'load_3': 'Insira carga 3',
          'load_4': 'Insira carga 4',
          'service_time': 'Insira os minutos',
          'contact_person': 'Nome da pessoa de contato',
          'phone_contact': 'Telefone de contato',
          'notes': 'Escreva notas relacionadas à visita'
        },
        'selected_singular'      : 'Selecionado',
        'selected_plural'        : 'Selecionados',
        'address_stats': {
          'status': {
            'new': 'Novo',
            'used': 'Usado',
            'warn_qty_failed': 'Usado',
            'warn_diff_loc': 'Usado'
          },
          'tooltips': {
            'new': 'Endereço não utilizado anteriormente',
            'used': 'Endereço usado mais de 5 vezes',
            'warn_qty_failed': 'Endereço usado anteriormente com mais de 50% de checkouts com falha',
            'warn_diff_loc': 'Detectamos um local diferente do informado',
            'change_location': 'Alterar para o local sugerido',
            'undo_change_location': 'Desfazer'
          }
        },
        'toolSelectionOnMapNavbar': {
          'selected_visits_plural': 'visitas selecionadas',
          'selected_visits_singular': 'visita selecionada',
          'load1': '@:Routes.load1',
          'load2': '@:Routes.load2',
          'load3': '@:Routes.load3',
          'load4': '@:Routes.load4',
          'btn_deselect': 'Desmarcar',
          'toast_delete_selected_visits_success': 'Suas visitas foram eliminadas com sucesso'
        },
        'modal_warning_checked_visits': {
          'title': 'Aviso',
          'subtitle': 'Confirmar roteamento parcial',
          'message': 'Você selecionou {{checkedCount}} visitas de um total de {{totalCount}}. A rota será criada apenas com este grupo selecionado.',
          'cta_continue': '¿Você deseja continuar apenas com {{checkedCount}} visitas??',
          'important': 'IMPORTANTE',
          'important_note': 'Ao selecionar suas visitas, as rotas serão criadas apenas com esse grupo selecionado. O restante NÃO será incluído no roteamento.'
        }
      },
      'Routes': {
        'load1'                     : 'Carga 1',
        'load2'                     : 'Carga 2',
        'load3'                     : 'Carga 3',
        'load4'                     : 'Carga 4',
        'duration'                  : 'Duração (horas)',
        'average_kms'               : '@:Planner.average_kms',
        'start_time'                : 'Hr inicio',
        'end_time'                  : 'Hr término',
        'origin'                    : '@:Vehicles.origin',
        'routes_summary'            : 'Resumo da rota',
        'btn_edition'               : 'Editar',
        'btn_moveTo'                : 'Mover para',
        'btn_cancelMoveTo'          : 'Edição realizada',
        'btn_optimize'              : 'Otimizar',
        'visits_out_of_route_title' : 'Sem atribuição',
        'route'                     : 'Rotas',
        'start'                     : 'Start',
        'end'                       : 'End',
        'back'                      : 'Voltar',
        'optimize'                  : 'Otimizar',
        'export'                    : 'Exportar',
        'assign'                    : 'Atribuir',
        'assignments.title'         : 'Rotas atribuídas',
        'assignments.date'          : 'Data de entrega',
        'assignments.assignBtn'     : 'Atribuído',
        'assignments.endBtn'        : 'Terminar',
        'assignments.unassigned'    : 'Não atribuído',
        'assignments.successMessage': 'Todas as rotas foram atribuídas!',
        'the_vehicle'               : 'O veículo',
        'assignments.errorMessage'  : 'Já tem um percurso com a mesma data e hora de início.',
        'assignments.isErrorInPlanInstance': 'Um plano com a mesma data de início e fim destes já existe.',
        'assignments.data_format_error.title': 'Há um erro nos dados de visitas.',
        'assignments.data_format_error.message': 'Verifique se os dados das visitas estão no formato correto',
        'assignments.default_error.title': 'Ocorreu um erro',
        'assignments.default_error.message': 'Ocorreu um erro enquanto se guardava o plano, mais tarde',
        'assignments.plan_name_error.title': 'Já existe um plano com o mesmo nome',
        'assignments.route_started_or_finished_error.title': 'Rotas não editáveis',
        'assignments.route_started_or_finished_error.message': 'Rotas que já começaram ou terminaram não podem ser modificadas',
        'assignments.vehicle_unavailable_error.title': 'Veículos indisponíveis',
        'assignments.vehicle_unavailable_error.message': 'Há veículos que não estão disponíveis para roteamento.',
        'pleaseCorrects'            : 'Por favor, corrija esta inconsistência e tente novamente.',
        'go_back'                   : 'Voltar',
        'goToRouteTracking'         : 'Se você quiser iniciar o controle de suas entregas, vá para o',
        'routeTracking'             : 'Acompanhamento de Rotas',
        'new_routes'                : ' Rotas',
        'cancel_creation'           : 'Feito criar',
        'btn_addTo'                 : 'Criar em',
        'routes_title'              : 'Rotas',
        'routes_title_edit'         : 'Editando rotas',
        'btn_new'                   : '+ Nova rota',
        'btn_remake_routes'         : 'Reotimizar',
        'select_all'                : 'Selecionar tudo',
        'hide_routes'               : 'Esconder rotas',
        'show_routes'               : 'Mostrar rotas',
        'route_text'                : 'Rota ',
        'reorder'                   : 'Reordenar a rota',
        'from'                      : 'De',
        'to'                        : 'Para ',
        'finish_title'              : 'Plano de rotas final',
        'finish_title_success'      : 'Suas rotas foram enviadas para os motoristas',
        'finish_title_success_async': "Estamos salvando seu plano...",
        'finish_content_success'    : 'Nós o notificaremos por e-mail quando seu plano estiver totalmente salvo. Se preferir, você pode criar uma nova rota em nosso Roteador ou explorar outras seções da nossa plataforma.',
        'vehicle'                   : '@:Vehicles.vehicle',
        'driver'                    : '@:Vehicles.driver',
        'routes'                    : 'Rotas',
        'route_singular'            : 'Rota',
        'visits'                    : 'Visitas',
        'time'                      : 'Tempo',
        'select_driver'             : '-- Selecione um motorista --',
        'confirm'                   : 'Confirmar',
        'save_draft'                : 'Salvar rascunho do plano',
        'out_of_route'              : 'Fora da rota',
        'unselected_routes_remake'  : 'Você deve selecionar pelo menos um veículo',
        'delete_route'              : 'Excluir rota',
        'delete_modal_message'      : 'Tem certeza de que deseja excluir esta rota?',
        'close'                     : 'Cerrar',
        'delete'                    : 'Excluir',
        'delete_menu'               : 'Eliminar a rota',
        'prioritize_high_load'      : 'Priorizar carga alta no início',
        'reverse_route_order'       : 'Inverter a ordem da rota',
        'reverse_route_order_success_title' : 'A rota foi invertida',
        'reverse_route_order_success_msg' : 'As visitas mudaram de ordem. Recomendamos que você verifique o resultado.',
        'remake_vehicles_error'     : 'Alguns dos veículos selecionados tem visitas.',
        'finish_modal.tracking_module' : 'Rastreamento',
        'finish_modal.planning_module' : 'Planejador de rotas',
        'finish_modal.btn_tracking_module': 'Rastreamento',
        'finish_modal.btn_planning_module': 'Planejador de rotas',
        'finish_modal.text_tracking_module': 'Se você quiser começar a monitorar suas entregas, vá para',
        'finish_modal.text_planning_module': 'Você pode criar um novo plano em',
        'optimize.balance'          : 'Balancear',
        'optimize.all_vehicles'     : 'Minimizar veículos',
        'optimize.join'             : 'Unir similares',
        'optimize.join_v2'          : 'Unir similares 2.0',
        'optimize.open_start'       : 'Rotas com início aberto',
        'optimize.avoid_tolls'       : 'Evite depágio',
        'optimize.maximize_attended_load': 'Maximização da carga atendida',
        'optimize.prioritize_load': 'Priorizar carga alta no início',
        'optimize.open_ended'       : 'Rotas com final aberto',
        'optimize.last_position_optimize': 'Usar posición actual',
        'optimize.single_tour': 'Uma rota por veículo',
        'optimize.beauty': 'SimpliFy',
        'optimize.big_vrp': 'Big VRP',
        'optimize.use_euclidean_distance': 'Distância Euclidiana',
        'optimize.enable_graphs': 'Grafos',
        'optimize.auto_reorder': 'Reordenação automática',
        'optimize.enable_soft_window': 'Janelas de tempo suaves',
        'optimize.on_foot' : 'Roteiro a pé',
        'optimize.wave_routing' : 'Carga parcial',
        'optimize.distance_to_join_visits': 'Juntar visitas por distância',
        'optimize.routing_options': 'Otimizadores',
        'optimize.radial_options': 'Sequenciadores',
        'optimize.radial_default': 'Por padrão',
        'optimize.radial_to_near': 'De perto para longe',
        'optimize.radial_to_far': 'De longe para perto',
        'optimization.all_vehicles'       : 'Minimizar veículos',
        'optimization.balance'            : 'Balançea',
        'optimization.open_ended'         : 'Rotas com final aberto',
        'optimization.join'               : 'Unir similares',
        'optimization.last_position_optimize': 'Usar localização atual',
        'optimize.one_seller_per_vehicle': 'Rotas por seller',
        'comments' : 'Rotas comentário',
        'body_1'   : 'Este comentário se aplica aos seguintes rotas: ',
        'save_comments' : 'Salvar',
        'route_name' : 'Rota',
        'finish_modal.footer_message': 'Lembre-se de dizer a seus motoristas para baixar o aplicativo móvel.',
        'assign_driver': 'Atribuir motorista',
        'assign_codrivers': 'Atribuir co-pilotos',
        'comments_route': 'Comentário',
        'visits_and' : 'visitas e',
        'selected_routes': 'rotas selecionas',
        'single_tour': 'Uma rota por veiculo',
        'beauty': 'SimpliFy',
        'tooltips': {
          'visits_out_of_route_title': 'As visitas podem estar fora de rota por diferentes razões, as mais comuns são: Horas de trabalho dos veículos insuficientes, tempos de serviço muito longos, janelas de tempo de visitas muito restritivas ou capacidade de carga insuficiente.',
          'edited_route'             : 'Rota editada',
          'skills_error': 'Não atende às habilidades',
          'time_error': 'Não cumpre janela de tempo',
          'charge_error_one' : 'Execede à carga 1',
          'charge_error_two': 'Execede à carga 2',
          'charge_error_three': 'Execede à carga 3',
          'charge_error_four': 'Execede à carga 4',
          'route_locked': 'Esta rota está bloqueada e não pode ser editada'
        },
        'filter_vehicle': {
          'high_low_kilometer': 'Quilometragem: maior a menor',
          'low_high_kilometer': 'Quilometragem: menor a maior',
          'high_low_load': '% de carga 1: maior a menor',
          'low_high_load': '% de carga 1: menor a maior',
          'high_low_load2': '% de carga 2: maior a menor',
          'low_high_load2': '% de carga 2: menor a maior',
          'high_low_load3': '% de carga 3: maior a menor',
          'low_high_load3': '% de carga 3: menor a maior',
          'high_low_hours': 'Hora do veículo: Maior a menor',
          'low_high_hours': 'Hora do veículo: Menor a maior',
          'low_high_name': 'Nome do veículo',
          'sort_by': 'Ordenar por'
        },
        'support_badge': {
          'revised' : 'Revisto'
        },
        'status': {
          'pending': 'Rota não iniciada',
          'started': 'Rota em andamento',
          'completed': 'Rota finalizada',
          'finished': 'Rota finalizada'
        },
        'warning': {
          'started': 'Aviso: Você está tentando editar uma rota que já foi iniciada',
          'finished': 'Aviso: Você está tentando editar uma rota que já foi finalizada'
        },
        'displayVehiclesList': {
          'categories': {
            'all_vehicles': 'Todos os veículos',
            'available_vehicles' : 'Veículos disponíveis',
            'occupied_vehicles' : 'Veículos ocupados'
          },
          'vehicle_status_available': 'Disponível',
          'vehicle_status_occupied': 'Ocupado'
        }
      },

      'Excel_Header': {
        'driver'          : 'Motorista',
        'vehicle'         : 'Veículo',
        'route_Index'     : 'Índice de rota',
        'stop'            : 'Ordem de entrega',
        'arrival_Time'    : 'Tempo estimado de chegada',
        'title'           : 'Título',
        'address'         : 'Endereço',
        'load'            : 'Carga',
        'window_Start'    : 'Janela de horário inicial',
        'window_End'      : 'Janela de horário final',
        'window_Start2'   : 'Janela de horário inicial 2',
        'window_End2'     : 'Janela de horário final 2',
        'service_Time'    : 'Tempo de serviço',
        'notes'           : 'Anotações',
        'latitude'        : 'Latitude',
        'longitude'       : 'Longitude',
        'reference'       : 'ID de referêncua',
        'requires_Skills' : 'Habilidades requeridas',
        'optional_Skills' : 'Habilidades operacionais',
        'contact_Name'    : 'Pessoa de contato',
        'contact_Phone'   : 'Telefone de contato',
        'contact_email'   : 'Correio eletrônico de contato',
        'distance'        : 'Distância',
        'order_size'      : 'Carga',
        'total_size'      : 'Carga total',
        'warnings'        : 'Advertências',
        'priority'        : 'Prioridade',
        'visit_load2'     : 'Capacidade 2',
        'visit_load3'     : 'Capacidade 3',
        'route_coment'    : 'Rota comentário',
        'tags'            : 'Tags',
        'zones'           : 'Zonas',
        'visit_alerts'    : 'Advertências de visita',
        'route_name'      : '@:Routes.route_name',
        'origin'          : '@:Vehicles.origin',
        'start_time'      : '@:Routes.start_time',
        'end_time'        : '@:Routes.end_time',
        'visits'          : '@:Routes.visits',
        'load1'           : '@:Routes.load1',
        'load2'           : '@:Routes.load2',
        'load3'           : '@:Routes.load3',
        'load4'           : '@:Routes.load4',
        'total'           : 'total',
        'total_routes_summary': 'Resumo Total da Rotas',
        'duration'         : 'Duração (horas)',
        'customer_shipment_date': 'Data de Envio ao Cliente',
        'stops': 'Pontos'
      },
      'Pdf' : {
        'detailed_pdf' : 'PDF Detalhado',
        'vehicle': 'Veículo',
        'no_driver': 'Nenhum driver atribuído',
        'to': ' a ',
        'name': 'NOME',
        'id': 'ID',
        'coments':'COMENTÁRIOS OU OBSERVAÇÕES',
        'signature' : 'ASSINATURA DO RECEBIMENTO',
        'address' : 'LOCALIZAÇÃO',
        'contact': 'CONTATO',
        'windows': 'JANELA DE HORÁRIO',
        'phone' : 'TELEFONE',
        'skills_required': 'HABILIDADES NECESSÁRIAS',
        'route_comment' : 'ROTA COMENTÁRIO',
        'no_route_comments': 'No comentário',
        'notes'           : 'ANOTAÇÕES',
        'between_streets': 'ENTRE RUAS',
        'customer_shipping_date': 'DATA DE ENVIO DO CLIENTE'
      },
      'Summarized_Pdf' : {
        'summarized_pdf'             : 'PDF Resumo',
        'title'                      : 'Título',
        'contact_phone'              : 'Telefone',
        'missing_contact_phone'      : 'Sem informação',
        'address'                    : 'Endereço',
        'time_windows'               : 'Janela de horário',
        'arrival'                    : 'Chegada',
        'id'                         : 'ID de referêncua',
        'missing_id'                 : 'Sem informação',
        'missing_streets_in_between' : 'Sem informação adicional',
        'customer_shipment_date'     : 'Fecha Envío Cliente'
      },
      'Planner_toast' : {
        'error_get_plans_1'       : 'Planos de carregamento com erro, rota não existe',
        'error_get_plans_2'       : 'Erro: plano de carregamento no servidor',
        'wrong_path'              : 'Erro na aplicação, rota não existe',
        'not_permission'          : 'Você não tem permissão para acessar a roteirizador',
        'vehicle_not_found'       : 'Veículo não encontrado',
        'error_get_plans_3'       : 'Plano não existe',
        'error_delete_plan'       : 'Erro: Plano eliminado, por favor tente novamente',
        'error_put_plan_found'    : 'Erro: Plano atualizado, rota não existe',
        'error_call_osrm'         : 'Erro: carregando plano selecionao',
        'error_visit_update_plan' : 'Erro: editando as visitas do plano',
        'error_optimize_capacity_vehicles' : 'Erro na capacidade dos veículos, por favor corrija e tente novamente.',
        'empty_file_excel'        : 'Arquivos de excel vazio, revise o arquivo e tente novamente.',
        'wrong_row_excel'         : 'Foram encontrados alguns erros na informação de visitas do arquivo de excel',
        'error_optimize_500'      : 'Houve um problema ao otimizar, por favor tente novamente',
        'error_order_route'       : 'Houve um erro ao reordenar a rota, por favor tente novamente',
        'error_remake_routes'     : 'Houve um erro ao refazer as rotas, por favor tente novamente',
        'error_save_plan_finish'  : 'Houve um erro ao salvar o plano, por favor tente novamente',
        'error_delete_route'      : 'Erro ao remover rota',
        'error_no_vehicles_for_reoptimize': 'Nenhum veículo está disponível para executar esta ação',
        'error_no_selected_vehicles_for_reoptimize': 'As novas visitas ocorreram fora da rota, pois nenhum veículo novo foi selecionado para reotimização',
        'error_no_visits_for_reoptimize': 'Nenhuma visita disponível para executar esta ação',
        'error_save_plan_finish_planned_date' : 'Um plano já existe para a mesma data, corrija e tente novamente',
        'error_save_plan_finish_plan_name': 'Já existe um plano com o mesmo nome, corrija e tente novamente',
        'visits_imported'         : 'Total de visitas importadas: ',
        'error_move_visits'       : 'Algumas das visitas selecionadas não podem ser transferidas da rota original',
        'success_move_visits'     : 'Modificações feitas com sucesso',
        'error_move_visits_to_started_or_finished_route': 'Rota indisponível para alterações',
        'msg_move_to_mode'        : 'Clique na rota para a qual você deseja mover suas visitas selecionadas',
        'error_seller'            : "Não foi possível encontrar o vendedor que você especificou em {{count}} visitas, então o campo fica vazio.",
        "error_city"              : "Foram encontradas {{count}} visitas sem cidade (obrigatória para a Colômbia)",
        'error_check_routes_status': 'Não foi possível verificar o estado das rotas. Tente novamente.'
      },
      'Log' : {
        'actions': {
          'delete_plan': 'Plano eliminado',
          'editing_plan': 'Plano atualizado'
        }
      },
      'Plan': {
        'modal_cancel_edit_message_1' : 'Vocé abandonara a ediçao de planos e perderá o que não tenha salvo.',
        'modal_cancel_edit_message_2': 'Deseja continuar?',
        'modal_cancel_edit_title': 'Anular edição plano',
        'button_cancel_modal': 'Rejeitar',
        'button_accept_modal': 'Aceitar'
      },
      'Driver': {
        'group_available': '',
        'group_assigned': '✓'
      }
    });

    $translateProvider.determinePreferredLanguage();
  }
})();

/* global google:false, MarkerWithLabel:false, tinycolor:false */
(function () {
  'use strict';

  angular
    .module('icarus.planner')
    .controller('PlannerController', PlannerController);

  /** @ngInject */
  function PlannerController($log, $rootScope, $scope, $state, moment, $filter, Toasts, timeUtils, colorAssignerService,
                             ngDialog, $window, $timeout, alertNotificationService, plannerService, EVENT_ROUTE_CREATE,
                             mapService, googleService, accountConfigsService, zoneService, visitsMarkersService,
                             store, ACCOUNT_CONFIGS, statisticsService, arrayHelperService,
                             plannerUtilsService, ENABLE_PICKUP_AND_DELIVERY_MODE, EVENT_CLICK, revisedRoutesService,
                             EVENT_CLEAR_ROUTES_GROUP_MARKERS, EVENT_ROUTE_UPDATE, EVENT_ROUTE_REMOVE, EVENT_MOUSEOVER,
                             EVENT_MOUSEOUT, EVENT_CONTEXTMENU, ROUTE_POLYGON_FILL_OPACITY, routesGroupMarkersService,
                             EVENT_DRAGEND, mapHandlerService, MARKER_WITH_LABEL_PATH, $compile,
                             HOUR_AND_MINUTE_DEFAULT, INFOWINDOW_TEMPLATE_URL, $templateRequest, POLYLINE_STYLES,
                             addonsService, PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES, polylineEventService) {
    var vm = this;
    var $translate = $filter('translate');
    var vehiclesMarkers = {};
    var routesPolylines = {};
    var routesPolygons = {};
    var infoWindow = {};
    var optimizationOptions = {};
    var INFOBOX_SIZE = 218;
    var BASE_MARKER_ZINDEX = 2000000001; // Lowest z-index necessary to ensure proper hover behavior when using polygon selection
    var visitsOffRouteCollapsed = true;
    var boundsChangedListener = null;
    var highlightRouteOnHoverIsEnabled = false;


    $scope.isMultiDayRouteEnabled = accountConfigsService.getValueByKeyFrom(
      ACCOUNT_CONFIGS.MULTI_DAY_ROUTES, store.get(ACCOUNT_CONFIGS.CONFIGS)
    );

    $rootScope.isHighDemandRouteDesigner = accountConfigsService.getValueByKeyFrom(
      ACCOUNT_CONFIGS.HIGH_DEMAND_ROUTE_DESIGNER, store.get(ACCOUNT_CONFIGS.CONFIGS)
    );

    $rootScope.isEnableRoutesGroupMarkers = accountConfigsService.getValueByKeyFrom(
      ACCOUNT_CONFIGS.ENABLE_ROUTES_GROUP_MARKERS, store.get(ACCOUNT_CONFIGS.CONFIGS)
    );

    addonsService.isAddonPropertyEnabled(PATH_FINDER_ADD_ON_KEY, PATH_FINDER_ADD_ON_PROPERTIES.HIGHLIGHT_ROUTE_ON_HOVER, function (addonProperty) {
      return addonProperty.value.toLowerCase() === "true";
    }).then(function (isAddonPropertyEnabled) {
      highlightRouteOnHoverIsEnabled = isAddonPropertyEnabled;
    });

    vm.infoBoxesPerPage = 2;
    vm.infoBoxesPage = 0;
    vm.noPrevPage = true;
    vm.noNextPage = true;
    vm.zonesPolygons = {};
    vm.zoneWindow = {};
    vm.visits = [];
    vm.vehicles = [];
    vm.fleetVehicles = [];
    vm.routes = [];
    vm.infoBoxVisits = [];
    vm.state = $state;
    vm.visitsMarkers = {};
    vm.routeCodes = {};
    vm.routesGroupMarkers = {};
    vm.headerStatistics = statisticsService.statistics;
    vm.planDate = null;
    vm.editingPlan = plannerService.getEditingPlan();
    vm.infoBoxCollapse = true;
    vm.loadsCollapse = true;
    vm.isMultipleEditingModeActivated = false;
    vm.drawingManager = null;
    vm.map = null;
    vm.isZonesEnabled = false;
    vm.visibleZones = false;
    vm.msomAlertData = {
      'msg': '',
      'load': '',
      'load2': '',
      'load3': '',
      'load4': '',
      'callToActionMsg': ''
    };
    vm.optimizationResultsOptions = [];
    vm.isDrawingActive = false;
    vm.isVisitsLoaded = false;
    vm.isToolSelectionCollapsed = true;
    vm.toolSelectionOnMap = {
      msg: '',
      load: '',
      load2: '',
      load3: '',
      load4: '',
      callToActionMsg: ''
    };

    vm.changeState = changeState;
    vm.highlightMarker = highlightMarker;
    vm.backwardMarker = backwardMarker;
    vm.openModalCancelEditPlan = openModalCancelEditPlan;
    vm.cancelEditPlan = cancelEditPlan;
    vm.removeVisitInfoBox = removeVisitInfoBox;
    vm.onMultipleSelectionCompleted = onMultipleSelectionCompleted;
    vm.onEnterOnMultipleSelectionMode = onEnterOnMultipleSelectionMode;
    vm.onExitMultipleSelectionMode = onExitMultipleSelectionMode;
    vm.deselectVisits = deselectVisits;
    vm.nextPage = nextPage;
    vm.prevPage = prevPage;
    vm.toggleZones = toggleZones;
    vm.paintPlanOnMap = paintPlanOnMap;
    vm.isEnhancedPlanEditModeEnable = accountConfigsService.isConfigEnabled('enable_enhanced_plan_edit_mode');
    vm.detailedRouteIndicators = accountConfigsService.isConfigEnabled('detailed_route_indicators');
    vm.stepTwoIsActive = stepTwoIsActive;
    vm.isCapacityOfVehiclesUsed = isCapacityOfVehiclesUsed;
    vm.enablePickupAndDeliveryMode = accountConfigsService.isConfigEnabled(ENABLE_PICKUP_AND_DELIVERY_MODE);
    vm.showTotalRoutedLoads = showTotalRoutedLoads;
    vm.isMoveToModeActivated = false;
    vm.onMoveToMode = onMoveToMode;
    vm.moveVisitsToRoute = moveVisitsToRoute;
    vm.showIndicatorsPerVehicle = showIndicatorsPerVehicle;
    vm.showRoutesGroupMarkersInViewport = showRoutesGroupMarkersInViewport;
    vm.isJoinSimilarActive = isJoinSimilarActive;
    vm.getVisitIconForRouteIndicator = getVisitIconForRouteIndicator;
    vm.getVisitCountForRouteIndicator = getVisitCountForRouteIndicator;
    vm.updateOptimizationResult = updateOptimizationResult;
    vm.showColorPicker = showColorPicker;
    vm.handDrawingModeActivated = handDrawingModeActivated;
    vm.deselectVisitsChecked = deselectVisitsChecked;
    vm.toggleToolSelectionOnMap = toggleToolSelectionOnMap;
    vm.moveVisitsRoute = true;
    vm.highlight_route_on_hover = true;
    vm.shouldHideGeneralIndicatorsInRouteEdition = false;
    vm.isMixLoadAddonEnabled = false;

    var eventClearListenerHandDrawing = $scope.$on('Planner:clearListenerHandDrawing', function () {
      googleService.clearListenerHandDrawing(vm.map);
      vm.isDrawingActive = false;
    });

    var eventDisabledHandDrawingButton = $scope.$on('Planner:disabledHandDrawingButton', function () {
      vm.isVisitsLoaded = false;
      vm.isDrawingActive = false;
      googleService.clearListenerHandDrawing(vm.map);
    });

    var updateToolSelectionOnMapNavbar = $scope.$on('planner:update:toolSelectionOnMapNavbar', function(event, data) {
      var selectedVisits = data.visits;

      var totalLoad = 0;
      var totalLoad2 = 0;
      var totalLoad3 = 0;
      var totalLoad4 = 0;

      angular.forEach(selectedVisits, function(visit) {
        totalLoad += visit.load || 0;
        totalLoad2 += visit.load2 || 0;
        totalLoad3 += visit.load3 || 0;
        totalLoad4 += visit.load4 || 0;
      });

      vm.toolSelectionOnMap = {
        msg: selectedVisits.length + ' ' + $translate(selectedVisits.length === 1
                                                      ? 'Visits.toolSelectionOnMapNavbar.selected_visits_singular'
                                                      : 'Visits.toolSelectionOnMapNavbar.selected_visits_plural'),
        load: totalLoad ? ($translate('Visits.toolSelectionOnMapNavbar.load1') + ': ' + totalLoad) : null,
        load2: totalLoad2 ? ($translate('Visits.toolSelectionOnMapNavbar.load2') + ': ' + totalLoad2) : null,
        load3: totalLoad3 ? ($translate('Visits.toolSelectionOnMapNavbar.load3') + ': ' + totalLoad3) : null,
        load4: totalLoad4 ? ($translate('Visits.toolSelectionOnMapNavbar.load4') + ': ' + totalLoad4) : null,
        callToActionMsg: $translate('Visits.toolSelectionOnMapNavbar.btn_deselect')
      };
    });

    var eventHideAlertBarSelectedVisits = $scope.$on('visits:hideAlertBarSelectedVisits', function() {
      vm.toolSelectionOnMap = {
        msg: '',
        load: null,
        load2: null,
        load3: null,
        load4: null,
        callToActionMsg: ''
      };
    });

    vm.statusBar = {
      element: null,
      routeName: null,
      route: {},
      vehicle: {}
    };

    vm.indicatorsData = {
      element: null,
      route: {},
      routeName: null,
      vehicle: {}
    };

    vm.contextMenu = {
      routeCodes: vm.routeCodes,
      showContextMenu: false,
      routesInArea: [],
      routeId: null,
      vehicleId: null
    };

    vm.routeColorOverwrite = false;
    vm.colorPicker = false;
    vm.currentRoute = null; // Ruta seleccionada actualmente
    vm.originalRouteColor = null; // Color original de la ruta seleccionada

    $scope.$watch(
      function () {
        return vm.visits;
      },
      function (newVisits) {
        if (newVisits && newVisits.length > 0) {
          vm.isVisitsLoaded = true; // Enable the button
        } else {
          vm.isVisitsLoaded = false; // Disable the button
        }
      }
    );

    // Plan Info e indicators
    var eventPlanInfo = $scope.$on("Planner:Plan:info", function (_args, data) {
      vm.planDate = timeUtils.formatTime(data.planDate, 'DD MMMM, YYYY');
      vm.planName = data.planName;
      if (vm.planName) {
        vm.editingPlan.status = true;
      }
    });

    var eventPlanSteps = $scope.$on("Planner:Plan:steps", function (_args, data) {
      vm.steps[data.key].visible = data.value;
    });

    var eventPlanStepsReset = $scope.$on("Planner:Plan:steps-reset", resetSteps);

    var eventPlanEditing = $scope.$on("Planner:Plan-editing", function (_args, data) {
      vm.editingPlan.status = Boolean(data.value);
      if (!vm.editingPlan.status) {
        vm.planName = null;
      }
    });

    var eventInfoBoxCollapse = $scope.$on('Planner:Reset:InfoBoxCollapse', resetInfoBoxCollapse);

    var eventShowAlertMSC = $scope.$on("Planner:Plan:ShowAlertMSC", showAlertMSC);

    var eventPlanRecalculateStatistics = $scope.$on("Planner:Plan:recalculate-statistics", function (_args, _data) {
      statisticsService.recalculateStatistics(plannerService.vehicles);
    });

    var eventPlanResetStatistics = $scope.$on("Planner:Plan:reset-statistics", function (_args, data) {
      var statisticsNotToReset = data || {};
      statisticsService.resetStatistics(statisticsNotToReset);
    });

    var eventPlanChangeFleet = $scope.$on("Planner:Plan:change-fleet", function (_args, data) {
      vm.fleetVehicles = data.currentVehicles;
    });

    // Listen to requests for current general indicators state
    var eventRequestGeneralIndicatorsState = $scope.$on('Planner:RequestGeneralIndicatorsState', function () {
      $scope.$broadcast('Planner:GeneralIndicatorsHideStateChange', {
        hide: vm.shouldHideGeneralIndicatorsInRouteEdition,
        detailedIndicatorsEnabled: vm.detailedRouteIndicators
      });
    });

    var eventPaintPlanOnMap = $scope.$on("planner:drawZonesOnMap", function () {
      _drawZonesOnMap();
    });

    var eventEditMarker = $scope.$on("Planner:Visit:EditMarker", function (_args, data) {
        if (plannerUtilsService.isEditModeActive()) {
        _createVisitMarker(data.visit);
      }
    });

    var eventAddboundsChangedEvent = $scope.$on('Planner:Add:boundsChangedEvent', function () {
      boundsChangedListener = googleService.googleMapsAddListener(vm.map, 'bounds_changed', vm.showRoutesGroupMarkersInViewport);
    });

    var openModalCancelEditPlanEvent = $rootScope.$on('Planner:openModalCancelEditPlan', function () {
      openModalCancelEditPlan();
    });

    var eventSetResultsOptimization = $scope.$on("Planner:Plan:updateOptimizationResultsOptions", function () {
      vm.optimizationResultsOptions = plannerService.getOptimizationResults().map(function(optimization) {
        if (!optimization.metrics.areFormatted) {
          optimization.metrics.vehicles_used =  Math.round(100 * optimization.metrics.vehicles_used / vm.fleetVehicles.length);
          optimization.metrics.avg_route_load_occupancy = (optimization.metrics.avg_route_load_occupancy * 100).toFixed(1);
          optimization.metrics.areFormatted = true;
        }
        return optimization;
      });
    });

    ////Vehicles

    function getVehicleImageMarker(color, markerId) {
      if ($state.current.name.includes("vehicles")) {
        return {
          url: markerId.includes('-start') ? '/assets/images/vehicle_origin_marker.svg' : '/assets/images/vehicle_destination_marker.svg',
          anchor: {x: 16, y: 40}
        };
      }

      // For route planning, use PNG files with specific colors
      var colorCode = color.replace('#', '');
      return {
        url: MARKER_WITH_LABEL_PATH + 'rd_vehicle_maker_' + colorCode + '.png',
        anchor: {x: 16, y: 40}
      };
    }

    var createMarkerFromVehicle = function(vehicle, markerId, location) {
      var latlng = googleService.getGoogleMapsLatLng(location.latitude, location.longitude);
      var iconOptions = getVehicleImageMarker(vehicle.color, markerId);

      return new google.maps.Marker({
        ident: markerId,
        title: vehicle.name,
        icon: iconOptions,
        position: latlng,
        map: plannerService.getGmap(),
        draggable: vehicle.options.draggable,
        visible: vehicle.options.visible,
        opacity: vehicle.options.icon.fillOpacity
      });
    };

    var updateMarkerFromVehicle = function(vehicle, marker, location) {
      if (!marker) {
        return;
      }

      var latlng = googleService.getGoogleMapsLatLng(location.latitude, location.longitude);
      var iconOptions = getVehicleImageMarker(vehicle.color, marker.ident);

      var options = {
        position: latlng,
        map: plannerService.getGmap(),
        draggable: vehicle.options.draggable,
        visible: vehicle.options.visible,
        icon: iconOptions,
        opacity: vehicle.options.icon.fillOpacity
      };

      marker.setOptions(options);
    };

    // Creates map markers for vehicle start/end locations, if they don't already exist. Do nothing otherwise.
    var createVehicleMarkers = function (vehicle) {
      var originMarkerId = vehicle.id + "-start";
      var destinationMarkerId = vehicle.id + "-end";

      if (!(originMarkerId in vehiclesMarkers)) {
        var marker = createMarkerFromVehicle(vehicle, originMarkerId, vehicle.locationStart);
        marker.addListener(EVENT_DRAGEND, vehicle.updateLocationStart.bind(vehicle));
        vehiclesMarkers[originMarkerId] = marker;
      }

      if (!(destinationMarkerId in vehiclesMarkers)) {
        var marker = createMarkerFromVehicle(vehicle, destinationMarkerId, vehicle.locationEnd);
        marker.addListener(EVENT_DRAGEND, vehicle.updateLocationEnd.bind(vehicle));
        vehiclesMarkers[destinationMarkerId] = marker;
      }
    };

    // Update map markers for vehicle start/end locations, if they exists. Do nothing otherwise.
    var updateVehicleMarkers = function(vehicle) {
      var originMarkerId = vehicle.id + "-start";
      var destinationMarkerId = vehicle.id + "-end";

      updateMarkerFromVehicle(vehicle, vehiclesMarkers[originMarkerId], vehicle.locationStart);
      updateMarkerFromVehicle(vehicle, vehiclesMarkers[destinationMarkerId], vehicle.locationEnd);
    };

    // Destroy map markers for vehicle start/end locations, if they exist. Do nothing otherwise.
    var destroyVehicleMarkers = function (vehicle) {
      if (vehiclesMarkers[vehicle.id + "-start"]) {
        vehiclesMarkers[vehicle.id + "-start"].setMap(null);
        delete vehiclesMarkers[vehicle.id + "-start"];
      }

      if (vehiclesMarkers[vehicle.id + "-end"]) {
        vehiclesMarkers[vehicle.id + "-end"].setMap(null);
        delete vehiclesMarkers[vehicle.id + "-end"];
      }
    };

    var eventVehicleUpdate = $scope.$on("Planner:Vehicle:Update", function (args, data) {
      var vehicle = data.vehicle;

      if (vehicle.options.visible) {
        createVehicleMarkers(vehicle);
        updateVehicleMarkers(vehicle);
      } else {
        destroyVehicleMarkers(vehicle);
      }
    });

    ////Visits

    var eventVisitCreate = $scope.$on("Planner:Visit:Create", function (args, data) {
      var visit = data.visit;
      _createVisitMarker(visit);
    });

    function _getLocationOptions(visitOptions, latitude, longitude, icon) {
      return {
        position: googleService.getGoogleMapsLatLng(latitude, longitude),
        draggable: visitOptions.draggable,
        visible: visitOptions.visible,
        icon: icon,
        labelAnchor: visitOptions.labelAnchor,
        labelClass: visitOptions.labelClass,
        labelContent: plannerService.isStepThreeActive() ? visitOptions.labelContent : ""
      };
    }

    var eventVisitCreateOrUpdateMarkerLight = $scope.$on("Planner:Visit:CreateOrUpdateMarkerLight", function (args, data) {
      var visit = data.visit;
      var mustOverrideIcon = data.mustOverrideIcon;
      var visitMarker = vm.visitsMarkers[visit.id];
      if (!visitMarker) {
        createVisitMarkerLight(visit);
        return;
      }

      var icon = mustOverrideIcon ? visit.getIconAsImage(): visitMarker.icon;
      var visitOptions = visit.options;
      var visitOptionsIcon = visitOptions.icon;
      var locationOptions = _getLocationOptions(visitOptions, visit.latitude, visit.longitude, icon);
      var locationOptionsIcon = locationOptions.icon;
      locationOptionsIcon.strokeColor = visitOptionsIcon.strokeColor;
      locationOptionsIcon.fillColor = visitOptionsIcon.fillColor;
      locationOptionsIcon.fillOpacity = visitOptionsIcon.fillOpacity;
      visitMarker.setOptions(locationOptions);
    });

    var eventVisitUpdate = $scope.$on("Planner:Visit:Update", function (args, data) {
      var visit = data.visit;
      if (plannerUtilsService.isEditModeActive() && !$rootScope.drawCluster) {
        visit.options.visible && _createVisitMarker(visit);
      } else {
        _updateVisitMarker(visit);
      }
    });

    function _updateVisitMarker(visit) {
      var visitMarker = vm.visitsMarkers[visit.id];
      if (!visitMarker) {
        return;
      }

      var visitOptions = visit.options;
      var visitOptionsIcon = visitOptions.icon;
      var locationOptions = _getLocationOptions(visitOptions, visit.latitude, visit.longitude, visitOptionsIcon);
      locationOptions.color = visitOptionsIcon.fillColor;

      if (plannerUtilsService.isEditModeActive()) {
        Object.assign(locationOptions, {
          icon: createIconForVisitMarker(visit, visit.selected),
        });
      }

      visitMarker.setOptions(locationOptions);
      visitMarker.setShape();
    }

    var eventVisitRemove = $scope.$on("Planner:Visit:Remove", function (args, data) {
      var visit = data.visit;
      if (vm.visitsMarkers[visit.id]) {
        //Elimino el marker
        // delete vm.visitsMarkers[visit.id].label;
        vm.visitsMarkers[visit.id].setMap(null);
        delete vm.visitsMarkers[visit.id];
      }
    });

    var eventVisitShowInfoWindow = $scope.$on("Planner:Visit:showInfoWindow", function (args, data) {
      var visit = data.visit;
      showMarkerInfo(visit);
    });

    var eventVisitHideInfoWindow = $scope.$on("Planner:Visit:hideInfoWindow", function () {
      try {
        if (infoWindow.setContent) {
          infoWindow.setContent('');
          infoWindow.close();
        }
      } catch (error) {
        $log.error(error);
      }
    });

    var eventClearVisits = $scope.$on("Planner:Clear:Visits", function () {
      _clearVisitMarkers();
    });

    var eventClearRoutesGroupMarkers = $scope.$on(EVENT_CLEAR_ROUTES_GROUP_MARKERS, function () {
      _clearRoutesGroupMarkers();
      _removeboundsChangedListener();
    });

    var eventHideVisits = $scope.$on("Planner:Hide:Visits", function () {
      _hideMarkers();
    });

    var eventShowVisits = $scope.$on("Planner:Show:Visits", function () {
      _showMarkers();
    });

    var eventHighlightVisit = $scope.$on("Planner:Highlight:Visit", function (args, data) {
      var visit = data.visit;
      highlightMarker(visit);
    });

    var eventNotHighlightVisit = $scope.$on("Planner:notHighlight:Visit", function (args, data) {
      var visit = data.visit;
      backwardMarker(visit);
    });

    var eventVisitCreateVisitsFromArray = $scope.$on("Planner:CreateVisitsFromArray:Visit", function (args, data) {
      var visits = data.visits;
      _createMarkersFromArray(visits);
    });

    var eventVisitCreateMarkersLightFromArray = $scope.$on("Planner:CreateMarkersLightFromArray:Visit", function (
      args, data) {
      _createMarkersLightFromArray(data.visits);
    });

    var eventVisitsRemoveVisitsFromArray = $scope.$on("Planner:RemoveVisitsFromArray:Visit", function (args, data) {
      var visits = data.visits;
      _removeMarkersFromArray(visits);
    });

    var eventUpdateRouteCode = $scope.$on("Planner:UpdateRouteCodes", function (args, data) {
      vm.routeCodes[data.routeId] = data.routeCode;
    });

    var eventVisitAddVisitInfoBoxContainerVisit = $scope.$on("Planner:AddVisitInfoBoxContainer:Visit", function (args, data) {
      var visitObj = data.visitObj;
      var indexVisit = vm.infoBoxVisits.findIndex(function (visitInfoBox) {
        return visitInfoBox.visitObj.id === visitObj.id;
      });
      if (indexVisit === -1) {
        vm.infoBoxVisits.push(data);
        if (vm.infoBoxVisits.length === 1) {
          plannerService.setZoomControlPosition('RIGHT_CENTER');
        }
      } else if (!visitObj.selected) {
        vm.infoBoxVisits.splice(indexVisit, 1);
        if (vm.infoBoxVisits.length === 0) {
          plannerService.setZoomControlPosition('RIGHT_BOTTOM');
        }
      }
      updatePagination();
      $timeout(function () {
        updateItemsToshowPerPage();
      }, 10);
    });

    var eventResetInfoBoxContainer = $scope.$on("Planner:Reset:InfoBoxContainer", function () {
      vm.infoBoxVisits = [];
      vm.noNextPage = true;
      vm.noNextPage = true;
      plannerService.setZoomControlPosition('RIGHT_BOTTOM');
    });

    var eventUpdateInfoBoxColors = $scope.$on("Planner:Update:InfoBoxColors", function (args, data) {
      data.visits.forEach(function (visit) {
        var infoBoxIndex = vm.infoBoxVisits.findIndex(function (infoBox) {
          return infoBox.visitObj.id === visit.id;
        });
        if (infoBoxIndex !== -1) {
          vm.infoBoxVisits[infoBoxIndex].color = data.color;
          vm.infoBoxVisits[infoBoxIndex].visitObj.order = '';
        }
      });
    });

    //Routes
    var eventRouteCreate = $scope.$on(EVENT_ROUTE_CREATE, function (_args, data) {
      var route = data.route;
      _createRouteGroupMarker(route);

      var routeOnMapCache = plannerService.getRouteOnMapCache(route);
      if (routeOnMapCache) {
        if ($rootScope.drawCluster) {
          routesPolygons[route.id] = routeOnMapCache;
        } else {
          routesPolylines[route.id] = routeOnMapCache;
        }

        return;
      }

      var vehicle = {};
      plannerService.getVehicle(route.vehicleId)
        .then(function (obj) {
          vehicle = obj;
          route.stroke.color = vehicle.color;
          var routeElementOptions = {
            ident: route.id,
            map: plannerService.getGmap(),
            strokeColor: route.stroke.color,
            strokeOpacity: route.stroke.opacity,
            strokeWeight: route.stroke.weight,
            visible: route.visible
          };
          var routeElement;

          if ($rootScope.drawCluster) {
            routeElementOptions.paths = route.path;
            routeElementOptions.fillColor = route.stroke.color;
            routeElementOptions.fillOpacity = ROUTE_POLYGON_FILL_OPACITY;

            routeElement = googleService.createPolygon(routeElementOptions);
            routeElement.addListener(EVENT_CLICK, _listenerPolygonClick);
            routesPolygons[route.id] = routeElement;
          } else {
            var routeIndex = vehicle.routes.indexOf(route);
            applyPolylineStyle(routeElementOptions, routeIndex);
            routeElementOptions.path = route.path;
            routeElementOptions.geodesic = route.geodesic;

            routeElement = googleService.createPolyline(routeElementOptions);
            routeElement.addListener(EVENT_CLICK, _listenerPolylineClick);
            routeElement.addListener(EVENT_CONTEXTMENU, function(e) {
              polylineEventService.contextMenu(
                e, route, routesPolylines, setContextMenu, showColorPicker
              );
            }, false);

            routesPolylines[route.id] = routeElement;
          }
          routeElement.addListener(EVENT_MOUSEOVER, function() {
            if (highlightRouteOnHoverIsEnabled) {
              polylineEventService.highlightRouteOnHover(EVENT_MOUSEOVER, route.id, routesPolylines);
            }
            if (vm.detailedRouteIndicators) {
              _detailedIndicatorsHover(EVENT_MOUSEOVER, route, vehicle);
            } else {
              _listenerRouteHover(route, vehicle, EVENT_MOUSEOVER);
            }
          });

          routeElement.addListener(EVENT_MOUSEOUT, function() {
            if (highlightRouteOnHoverIsEnabled) {
              polylineEventService.highlightRouteOnHover(EVENT_MOUSEOUT, route.id, routesPolylines);
            }
            if (vm.detailedRouteIndicators) {
              _detailedIndicatorsHover(EVENT_MOUSEOUT);
            } else {
              _listenerRouteHover(route, vehicle, EVENT_MOUSEOUT);
            }
          });

          plannerService.setRouteOnMapCache(route, routeElement);
        });
    });

    var eventRouteUpdate = $scope.$on(EVENT_ROUTE_UPDATE, function (_args, data) {
      var route = data.route;
      var routeElementOptions = {
        path: route.path,
        map: plannerService.getGmap(),
        strokeColor: route.stroke.color,
        strokeOpacity: route.stroke.opacity,
        strokeWeight: route.stroke.weight,
        visible: route.visible
      };

      if ($rootScope.drawCluster) {
        if (routesPolygons[route.id]) {
          routeElementOptions.fillColor = route.stroke.color;
          routeElementOptions.fillOpacity = ROUTE_POLYGON_FILL_OPACITY;
          routesPolygons[route.id].setOptions(routeElementOptions);
        }
      } else {
        if (routesPolylines[route.id]) {
          var vehicle = plannerService.getVehicleById(route.vehicleId);
          var routeIndex = vehicle.routes.indexOf(route);
          applyPolylineStyle(routeElementOptions, routeIndex);
          routeElementOptions.geodesic = route.geodesic;
          routesPolylines[route.id].setOptions(routeElementOptions);
          _updateRouteGroupMarker(route);
        }
      }
    });

    /**
     *  Applies a specific style to a polyline based on its index in the route list.
     *  @param {Object} routeElementOptions - The options object used to configure the polyline.
     *  @param {number} index - The index of the route in the vehicle's route list.
     *
     * This function cycles through a predefined set of styles (POLYLINE_STYLES) using the modulo operator.
     *  The modulo operation ensures the styles loop back to the start once the index exceeds the
     *  length of the style array. This means every 3 routes, the styles reset, maintaining a consistent visual pattern.
     */
    function applyPolylineStyle(routeElementOptions, index) {
      var styleIndex = index % POLYLINE_STYLES.length;

      if (styleIndex === 0) {
        return;
      }

      var selectedStyle = POLYLINE_STYLES[styleIndex];
      var lineSymbol = {
        path: 'M 0,-1 0,1',
        strokeOpacity: 1,
        strokeWeight: 3,
        scale: selectedStyle.scale
      };

      routeElementOptions.strokeOpacity = 0;
      routeElementOptions.icons = [{
        icon: lineSymbol,
        offset: '0',
        repeat: selectedStyle.repeat
      }];
    }

    var eventRouteRemove = $scope.$on(EVENT_ROUTE_REMOVE, function (_args, data) {
      var route = data.route;
      if ($rootScope.drawCluster) {
        if (routesPolygons[route.id]) {
          routesPolygons[route.id].setMap(null);
          delete routesPolygons[route.id];
        }
      } else {
        if (routesPolylines[route.id]) {
          routesPolylines[route.id].setMap(null);
          delete routesPolylines[route.id];
        }
        _removeRouteGroupMarker(route);
      }
    });

    var eventRoutesShowMarkersOfRoute = $scope.$on("Planner:Routes:showMarkersOfRoute", function (args, data) {
      var route = data.route;
      _createRouteMarkers(route);
    });

    var eventHideMarkersOfRoute = $scope.$on("Planner:Routes:hideMarkersOfRoute", function (args, data) {
      var route = data.route;
      _hideRouteMarkers(route);
    });

    //Map
    var eventClearMap = $scope.$on("Planner:Clear:Map", plannerClearMap);

    var eventClearPolygons = $scope.$on("Planner:Clear:Polygons", function () {
      for (var polygon in routesPolygons) {
        if (routesPolygons.hasOwnProperty(polygon)) {
          routesPolygons[polygon].setMap(null);
          delete routesPolygons[polygon];
        }
      }
    });

    var eventClearPolylines = $scope.$on("Planner:Clear:Polylines", function () {
      for (var polyline in routesPolylines) {
        if (routesPolylines.hasOwnProperty(polyline)) {
          routesPolylines[polyline].setMap(null);
          delete routesPolylines[polyline];
        }
      }
    });

    var eventPositionNavigator = $rootScope.$on('positionNavigator', function () {
      if ($rootScope.mapInitCoord) {
        plannerService.setMapCenterOn($rootScope.mapInitCoord);
      }
    });

    // Edition
    $scope.$on('Planner:Plan:isMultipleEditingModeActivated', function () {
      $scope.$broadcast('Planner:Plan:returnIsMultipleEditingModeActivated', vm.isMultipleEditingModeActivated);
    });

    var eventVisitOffRouteCollapsed = $scope.$on('Planner:visit-off-route:collapsed', function (args, data) {
      visitsOffRouteCollapsed = data.collapse;
    });

    var eventToggleClickPolygons = $scope.$on("Planner:Routes:toggleClickPolygons", function (_args, data) {
      toggleClickPolygons(data.isClickable);
    });

    $scope.$on('$destroy', clearEventListeners);

    angular.element($window).on('resize', function () {
      updateItemsToshowPerPage();
      updatePagination();
    });

    activate();

    function activate() {
      initializeColorPicker();
      vm.steps = {
        vehicle: {title: $translate('Planner.headers_step_1'), visible: false, link: "planner.vehicles-list"},
        visit: {title: $translate('Planner.headers_step_2'), visible: false, link: "planner.visits-list"},
        route: {title: $translate('Planner.headers_step_3'), visible: false, link: "planner.routes"}
      };
      plannerService.setPlanDate(moment());


      addonsService.isAddonEnable(PATH_FINDER_ADD_ON_KEY)
      .then(function (isEnable) {
        vm.routeColorOverwrite = false;
        if (isEnable) {
          addonsService.getInfoAddonAndPropertiesByKey(PATH_FINDER_ADD_ON_KEY)
            .then(function (pathFinderProperties) {
              if (pathFinderProperties && pathFinderProperties.properties) {
                var routeColorOverwrite = pathFinderProperties.properties.find(function (property) {
                  return property.key === PATH_FINDER_ADD_ON_PROPERTIES.ROUTE_COLOR_OVERWRITE;
                });
                vm.routeColorOverwrite = routeColorOverwrite && routeColorOverwrite.value.toLowerCase()  === 'true';

                var hideGeneralIndicatorsInRouteEdition = pathFinderProperties.properties.find(function (property) {
                  return property.key === PATH_FINDER_ADD_ON_PROPERTIES.HIDE_GENERAL_INDICATORS_IN_ROUTE_EDITION;
                });
                vm.shouldHideGeneralIndicatorsInRouteEdition = hideGeneralIndicatorsInRouteEdition && hideGeneralIndicatorsInRouteEdition.value.toLowerCase() === 'true';

                var mixLoadAddon = pathFinderProperties.properties.find(function (property) {
                  return property.key === PATH_FINDER_ADD_ON_PROPERTIES.ENABLED_MIX_LOAD;
                });
                vm.isMixLoadAddonEnabled = mixLoadAddon && mixLoadAddon.value.toLowerCase() === 'true';

                // Broadcast general indicators hide state so other components (e.g., loadsTable) can adjust their styles
                $rootScope.$broadcast('Planner:GeneralIndicatorsHideStateChange', {
                  hide: vm.shouldHideGeneralIndicatorsInRouteEdition,
                  detailedIndicatorsEnabled: vm.detailedRouteIndicators
                });
              }
            }
          );
        }
      });

      return plannerService.getPlan()
        .then(successGetPlan, errorGetPlan);

      function successGetPlan(plan) {
        vm.visits = plan.visits;
        vm.routes = plan.routes;
        optimizationOptions = plannerService.localOptimizationOptions;
        _initializeMap();
        setDataPlanInfo(plan);
        vm.steps.vehicle.visible = true;
        vm.msomAlertData.callToActionMsg = $translate('Planner.MSOMC.alert_msg');
        setConfigToDrawCluster();
        colorAssignerService.initializeService();
      }

      function errorGetPlan(error) {
        if (error.status === 403) {
          Toasts.push('error', $translate('Planner_toast.not_permission'));
          $state.go('uprofile.info');
        }
        if (error.status === 404) {
          Toasts.push('error', $translate('Planner_toast.wrong_path'));
        }
        if (error.status === 500) {
          Toasts.push('error', $translate('Planner_toast.error_get_plans_2'));
        }
      }
    }

    function removeVisitInfoBox(visitId) {
      var visitIndex = vm.infoBoxVisits.findIndex(function (visit) {
        return visit.visitObj.id === visitId;
      });
      if (visitIndex !== -1) {
        $rootScope.$broadcast('Planner:Visit:deselectEditVisit', {
          visitId: visitId
        });
      }
    }

    function setDataPlanInfo(plan) {
      vm.planName = plannerService.getPlanName();
      if (vm.planName) {
        vm.editingPlan.status = true;
        vm.planDate = timeUtils.formatTime(plan.planDate.start, 'DD MMMM, YYYY');
      }
    }

    function setConfigToDrawCluster() {
      accountConfigsService.getConfigByKey('draw_cluster')
        .then(function (value) {
          $rootScope.drawCluster = (value || optimizationOptions.big_cluster);
        });
    }

    function changeState(state) {
      if(plannerService.hasActiveVehicles()) {
        $state.go(state);
      }
    }

    function toggleClickPolygons(isClickable) {
      Object.values(vm.zonesPolygons).forEach(function (polygon) {
        polygon.setOptions({clickable: isClickable});
      });

      Object.values(routesPolygons).forEach(function (polygon) {
        polygon.setOptions({clickable: isClickable});
      });
    }

    function toggleZones() {
      vm.visibleZones = !vm.visibleZones;
      Object.keys(vm.zonesPolygons).forEach(function (key) {
        vm.zonesPolygons[key].setVisible(vm.visibleZones);
      });
      if (!vm.visibleZones) {
        vm.zoneWindow.close();
      }
    }

    /**
     * Draws and updates active zones on the map, creating and removing polygons based
     * on zone changes, and checks if the zone functionality is enabled.
     */
    function _drawZonesOnMap() {
      var zonesFilter = {
        schedules: plannerService.getScheduledPlanDaysOfWeek(),
        enabled: true
      };

      var isRestrictionTypeAddonPropertyEnabled = zoneService.isRestrictionTypeAddonPropertyEnabled();

      zoneService.listZones(zonesFilter)
        .then(function(activeZones) {

          var zones = arrayHelperService.indexByProperty(activeZones, 'id');
          var zoneIdsToCreate = arrayHelperService.arrayDifference(Object.keys(zones), Object.keys(vm.zonesPolygons));
          var zoneIdsToDelete = arrayHelperService.arrayDifference(Object.keys(vm.zonesPolygons), Object.keys(zones));

          zoneIdsToCreate.forEach(function(zoneId) {
            var zone = zones[zoneId];

            var zoneColor = "#335F72";

            if (isRestrictionTypeAddonPropertyEnabled) {
              zoneColor = zone.restriction_type === 'flexible' ? "#00804A" : "#335F72";
            }

            var zoneCoordinates = zone.coordinates.map(function(coordinate) {
                return {
                    lat: parseFloat(coordinate.lat),
                    lng: parseFloat(coordinate.lng)
                };
            });

            var zonePolygon = googleService.createPolygon({
                ident: "Zone-" + zone.id,
                paths: zoneCoordinates,
                map: plannerService.getGmap(),
                strokeColor: "#335F72",
                strokeOpacity: 1,
                strokeWeight: 0.5,
                fillColor: zoneColor,
                fillOpacity: 0.35,
                visible: vm.visibleZones
            });

            zonePolygon.addListener('click', function(event) {
                var zoneName = zone.name;
                vm.zoneWindow.setContent('<center>' + zoneName + '</center>');
                var latLng = event.latLng;
                vm.zoneWindow.setPosition(latLng);
                var zoneNameLength = zoneName.length;
                vm.zoneWindow.setOptions({
                    maxWidth: zoneNameLength < 4 ? 55 : 15 * zoneNameLength
                });
                vm.zoneWindow.open(plannerService.getGmap());
            });

            vm.zonesPolygons[zone.id] = zonePolygon;
          });

          zoneIdsToDelete.forEach(function(zoneId) {
            vm.zonesPolygons[zoneId].setMap(null);
            delete vm.zonesPolygons[zoneId];
          });

          zoneService.isEnableZonesProperty()
            .then(function(data) {
              vm.isZonesEnabled = data.useZones;
            });
        });
    }

    function paintPlanOnMap() {
      var map = plannerService.getGmap();

      _drawZonesOnMap();

      if ($rootScope.drawCluster) {
        if (Object.keys(routesPolygons).length === 0) {
          //Routes
          vm.routes.forEach(function (route) {
            plannerService.getVehicle(route.vehicleId).then(function (vehicle) {
              route.stroke.color = vehicle.color;
              var routePolygon = googleService.createPolygon({
                ident: route.id,
                paths: route.path,
                map: map,
                strokeColor: route.stroke.color,
                strokeOpacity: route.stroke.opacity,
                strokeWeight: route.stroke.weight,
                fillColor: route.stroke.color,
                fillOpacity: 0.35,
                'visible': route.visible
              });

              routePolygon.addListener('click', _listenerPolygonClick);
              routesPolygons[route.id] = routePolygon;
            });
          });
        }
      } else {
        if (Object.keys(routesPolylines).length === 0) {
          //Routes
          vm.routes.map(function (route) {
            plannerService.getVehicle(route.vehicleId).then(function (vehicle) {
              route.stroke.color = vehicle.color;
              routesPolylines[route.id] = googleService.createPolyline({
                path: route.path,
                map: map,
                geodesic: route.geodesic,
                strokeColor: route.stroke.color,
                strokeOpacity: route.stroke.opacity,
                strokeWeight: route.stroke.weight,
                visible: route.visible
              });
            });
          });
        }
      }
    }

    function getMarkerOptions(visit) {
      return {
        ident: visit.id,
        title: visit.name,
        position: googleService.getGoogleMapsLatLng(visit.latitude, visit.longitude),
        map: plannerService.getGmap(),
        zIndex: visit.zIndex + BASE_MARKER_ZINDEX,
        color: visit.defaultColor,
        opacity: visit.options.icon.fillOpacity
      };
    }

    function createIconForVisitMarker(visit, highlighted) {
      var icon = Object.assign({}, visit.options.icon);
      var color = highlighted ? tinycolor(visit.defaultColor).darken(25).toString() : visit.defaultColor;
      var label = plannerService.isStepThreeActive() && visit.routeId && visit.order ? '_' + visit.order.toString() : '';
      icon.url = MARKER_WITH_LABEL_PATH + 'rd_maker_' + color.replace('#', '') + label + '.png';
      return icon;
    }

    function createMarkerWithLabel(visit) {
      return new google.maps.Marker(
        Object.assign({},
          getMarkerOptions(visit),
          {
            icon: createIconForVisitMarker(visit, visit.selected),
            isLabel: true
          }
      ));
    }

    function createMarkerWithIcon(visit, is32Pixel) {
      return new google.maps.Marker(
        Object.assign({},
          getMarkerOptions(visit),
          {
            icon: visit.getIconAsImage(is32Pixel),
            isLabel: false
          }
      ));
    }

    function getVisitToDisplay(visit) {
      if (plannerUtilsService.isEditModeActive() && isJoinSimilarActive()) {
        var similarVisits = plannerService.visitSimilarGraph.getSimilarByRoute(visit);
        return plannerUtilsService.getLastSimilarWithMarker(visit, similarVisits, vm.visitsMarkers);
      }
      return  visit;
    }

    function _createVisitMarker(_visit) {
      var visit = getVisitToDisplay(_visit);
      var route = plannerService.getRouteObjById(visit.routeId);
      var vehicle = route && plannerService.vehicles.find(function (vehicle) {
        return route.vehicleId === vehicle.id;
      });
      var mustBeLabel = true;
      var makeLabel = createMarkerWithLabel;

      if (plannerUtilsService.isEditModeActive()) {
        if (!$rootScope.drawCluster) {
          if (isJoinSimilarActive()) {
            _removeMarkersFromArrayAndSimilars(visit);
          }

          var marker = vm.visitsMarkers[visit.id];
          var collapsed = route ? route.collapse : visitsOffRouteCollapsed;
          mustBeLabel = !collapsed || visit.selected;

          if (marker && marker.color === visit.defaultColor && ((marker.isLabel &&
            !$rootScope.isHighDemandRouteDesigner) || (marker.isLabel === mustBeLabel))) {
            backwardMarker(visit);
            return;
          }

          if ($rootScope.isHighDemandRouteDesigner && !mustBeLabel) {
            makeLabel = createMarkerWithIcon;
          }
        }
      }

      _removeMarkersFromArray([visit]);
      var newMarker = makeLabel(visit, mustBeLabel && !route);
      newMarker.addListener(EVENT_DRAGEND, visit.updateLocation.bind(visit));
      newMarker.addListener(EVENT_CLICK, function(e) { _listenerMarkerClick(e, visit); });
      newMarker.addListener(EVENT_CONTEXTMENU, function(e) { _listenerMarkerContextmenu(e, visit); }, false);
      newMarker.addListener(EVENT_MOUSEOVER, function() {
        if (highlightRouteOnHoverIsEnabled && route) {
          polylineEventService.highlightRouteOnHover(EVENT_MOUSEOVER, route.id, routesPolylines);
        }
        if (vm.detailedRouteIndicators) {
          _detailedIndicatorsHover(EVENT_MOUSEOVER, route, vehicle);
        } else {
          _listenerRouteHover(route, vehicle, EVENT_MOUSEOVER);
        }
      });
      newMarker.addListener(EVENT_MOUSEOUT, function() {
        if (highlightRouteOnHoverIsEnabled && route) {
          polylineEventService.highlightRouteOnHover(EVENT_MOUSEOUT, route.id, routesPolylines);
        }
        if (vm.detailedRouteIndicators) {
          _detailedIndicatorsHover(EVENT_MOUSEOUT);
        } else {
          _listenerRouteHover(route, vehicle, EVENT_MOUSEOUT);
        }
      });

      vm.visitsMarkers[visit.id] = newMarker;
    }

    function _createRouteGroupMarker(route) {
      if (!routesGroupMarkersService.areGroupMarkersEnabled()) {
        return;
      }
      var options = routesGroupMarkersService.getOptionsToCreateGroupMarker(route);
      var routeGroupMarker = googleService.createMarker(options);
      routeGroupMarker.addListener(EVENT_CLICK, _listenerRouteGroupMarkerClick);
      vm.routesGroupMarkers[route.id] = routeGroupMarker;
    }

    function _listenerRouteGroupMarkerClick(event) {
      var routeGroupMarker = this;
      var route = plannerService.getRouteById(routeGroupMarker.ident);
      if (revisedRoutesService.isRouteRevised(route)) {
        return;
      }

      route.areVisitsMarkersVisible = !route.areVisitsMarkersVisible;
      visitsMarkersService.showVisitsOnMap(route.visits, route.areVisitsMarkersVisible);
      if (!route.areVisitsMarkersVisible) {
        vm.routesGroupMarkers[route.id].setOptions({
          position: routesGroupMarkersService.getGroupMarkerPosition(route.visits, route)
        });
      }
    }

    function _updateRouteGroupMarker(route) {
      if (!routesGroupMarkersService.areGroupMarkersEnabled() || !vm.routesGroupMarkers[route.id]) {
        return;
      }
      var options = routesGroupMarkersService.getOptionsToUpdateGroupMarker(route);
      vm.routesGroupMarkers[route.id].setOptions(options);
    }

    function _removeRouteGroupMarker(route) {
      if (vm.routesGroupMarkers[route.id]) {
        vm.routesGroupMarkers[route.id].setMap(null);
        delete vm.routesGroupMarkers[route.id];
      }
    }

    function _clearRoutesGroupMarkers() {
      for (var routeGroupMarker in vm.routesGroupMarkers) {
        if (vm.routesGroupMarkers.hasOwnProperty(routeGroupMarker)) {
          vm.routesGroupMarkers[routeGroupMarker].setMap(null);
        }
      }
      vm.routesGroupMarkers = {};
    }

    function moveVisitsToRoute(routeId, vehicleId) {
      $rootScope.$broadcast("Planner:Route:moveVisitsToRoute", {
        route_id: routeId,
        vehicle_id: vehicleId
      });
    }

    function _removeMarkersFromArrayAndSimilars(visit) {
      var visits = plannerService.visitSimilarGraph.getSimilarByRoute(visit);
      _removeMarkersFromArray(visits);
    }

    function _getIconAsImage(visit) {
      var isImage32px = (!visit.routeId && (!visitsOffRouteCollapsed || visit.selected));
      var HIGHLIGHT_VISIT_COLOR_DEFAULT = '324376';
      var HIGHLIGHT_BLACK_VISIT_COLOR = 'FFFFFF';
      var HIGHLIGHT_VISIT_OFFROUTE_COLOR = '6C6E6F';
      var imageName = {
        '#080404': HIGHLIGHT_BLACK_VISIT_COLOR,
        '#A4A4A4': HIGHLIGHT_VISIT_OFFROUTE_COLOR,
        '#312F2F': HIGHLIGHT_BLACK_VISIT_COLOR
      }[$scope.vm.visitsMarkers[visit.id].color] || HIGHLIGHT_VISIT_COLOR_DEFAULT;

      return angular.extend({},
        visit.getIconAsImage(isImage32px),
        {
          url: visitsMarkersService.getImagesMarkerPath() + imageName + (isImage32px ? '-32': '') + '.png'
        }
      );
    }

    function highlightMarker(_visit) {
      var visit = getVisitToDisplay(_visit);

      var marker = vm.visitsMarkers[visit.id];
      if (!marker) {
        return;
      }

      var isSmallMarker = marker.icon.url.endsWith('.png') && !marker.icon.url.includes('with-label');
      if (isSmallMarker) {
        marker.setIcon(_getIconAsImage(visit));
        marker.setZIndex(googleService.googleMapsMarkerMaxZIndex() + BASE_MARKER_ZINDEX);
        return;
      }
      var icon;

      if (plannerUtilsService.isEditModeActive()) {
        icon = createIconForVisitMarker(_visit, true);
      } else {
        icon = createIconForVisitMarker(visit, true);
      }
      marker.setIcon(icon);
      marker.setZIndex(googleService.googleMapsMarkerMaxZIndex() + BASE_MARKER_ZINDEX);
    }

    function backwardMarker(_visit) {
      var visit = getVisitToDisplay(_visit);

      var marker = vm.visitsMarkers[visit.id];
      if (!marker) {
        return;
      }

      var isSmallMarker = marker.icon.url.endsWith('.png') && !marker.icon.url.includes('with-label');
      var not32Pixel = visit.routeId || (visitsOffRouteCollapsed && !visit.selected);
      var opacity = visit.options.icon.fillOpacity;

      if (isSmallMarker && not32Pixel) {
        marker.setIcon(visit.getIconAsImage());
        marker.setZIndex(visit.zIndex + BASE_MARKER_ZINDEX);
        marker.setOpacity(opacity);
        return;
      }

      var icon = createIconForVisitMarker(visit, visit.selected);

      marker.setIcon(icon);
      marker.setZIndex(visit.zIndex + BASE_MARKER_ZINDEX);
      marker.setOpacity(opacity);
    }

    function _listenerMarkerClick(event, visit) {
      if (plannerService.isVisitRouteRevised(visit)) {
          return;
      }

      if (vm.isMoveToModeActivated && visit.routeId) {
        vm.isMoveToModeActivated = false;
        var route_id = visit.routeId;
        var vehicle_id = visit.vehicle;
        vm.moveVisitsToRoute(route_id, vehicle_id);
        return;
      }

      if (!plannerUtilsService.isEditModeActive()) {
        var marker = vm.visitsMarkers[visit.id];
        if (marker.icon.url.endsWith('.png') && !marker.icon.url.includes('with-label')) {
          return;
        }
        showMarkerInfo(visit);
        $rootScope.$broadcast("visitClickedOnMap", {
          visit: visit
        });
      } else {
        var matchVisits = [];
        var joinSimilar = optimizationOptions.join;
        var joinSimilarV2 = optimizationOptions.join_v2;

        visit.selected = !visit.selected;
        selectVisitToEdit(visit);

        if (joinSimilar || joinSimilarV2) {
          matchVisits = plannerService.visitSimilarGraph.getSimilarByRoute(visit);
          matchVisits.forEach(function (visitMatched) {
            visitMatched.selected = visit.selected;
            selectVisitToEdit(visitMatched);
          });
        }
      }
    }

    function selectVisitToEdit(_visit) {
      $rootScope.$broadcast('Planner:Visit:toggleSelectedEditVisit', {
        visit: _visit,
        multipleSelectionMode: vm.isMultipleEditingModeActivated
      });
    }

    function showMarkerInfo(_visit) {
      if (_visit.editMode || _visit.highlight) {
        return;
      }

      getInfoWindowHTML(_visit)
        .then(function (contentInfoWindow) {
          infoWindow.setContent(contentInfoWindow);
          infoWindow.open(plannerService.getGmap(), vm.visitsMarkers[_visit.id]);
          var listener = googleService.googleMapsAddListener(infoWindow, 'closeclick', function () {
            _visit.setActive(false);
            _visit.setHighlight(false, true);
            alertNotificationService.removeAlertNotification();
            plannerService.hideInfoWindow();
            googleService.googleMapsRemoveListener(listener);
            if (!$scope.$$phase) {
              $scope.$apply();
            }
          });

          plannerService.showInfoWindow(_visit);
        })
        .catch(function (error) {
          $log.info(error);
        });
    }

    function _clearVisitMarkers() {
      for (var visit in vm.visitsMarkers) {
        if (vm.visitsMarkers.hasOwnProperty(visit)) {
          vm.visitsMarkers[visit].setMap(null);
        }
      }
      vm.visitsMarkers = {};
    }

    function _createRouteMarkers(route) {
      route.visits.forEach(function (visit) {
        visit.options.visible = true;
        _createVisitMarker(visit);
      });
    }

    function _hideRouteMarkers(route) {
      route.visits.forEach(function (visit) {
        _hideVisitMarker(visit);
      });
    }

    function _createMarkersFromArray(_visits) {
      _visits.forEach(function (visit) {
        if (visit.options.visible) {
          _createVisitMarker(visit);
        }
      });
    }

    function _createMarkersLightFromArray(visits) {
      visits.forEach(function (visit) {
        if (visit.options.visible) {
          createVisitMarkerLight(visit);
        }
      });
    }

    function _removeMarkersFromArray(_visits) {
      _visits.forEach(function (visit) {
        if (vm.visitsMarkers[visit.id]) {
          vm.visitsMarkers[visit.id].setMap(null);
          delete vm.visitsMarkers[visit.id];
        }
      });
    }

    function _hideMarkers() {
      for (var visit in vm.visitsMarkers) {
        if (vm.visitsMarkers.hasOwnProperty(visit)) {
          vm.visitsMarkers[visit].setMap(null);
        }
      }
    }

    function _hideVisitMarker(visit) {
      if (vm.visitsMarkers[visit.id]) {
        visit.options.visible = false;
        var locationOptions = {
          visible: visit.options.visible
        };
        vm.visitsMarkers[visit.id].setOptions(locationOptions);
      }
    }

    function _showMarkers() {
      for (var visit in vm.visitsMarkers) {
        if (vm.visitsMarkers.hasOwnProperty(visit)) {
          vm.visitsMarkers[visit].setMap(plannerService.getGmap());
        }
      }
    }

    function createVisitMarkerLight(visit) {
      var originLatln = googleService.getGoogleMapsLatLng(visit.latitude, visit.longitude);

      var visitMarker = googleService.createMarker({
        ident: visit.id,
        title: visit.name,
        position: originLatln,
        map: plannerService.getGmap(),
        icon: visit.getIconAsImage(),
        visible: visit.options.visible,
        zIndex: visit.zIndex + BASE_MARKER_ZINDEX,
        color: visit.defaultColor
      });

      var route = plannerService.getRouteObjById(visit.routeId);
      var vehicle = route && plannerService.getVehicleById(route.vehicleId);

      visitMarker.addListener(EVENT_CONTEXTMENU, function(e) { _listenerMarkerContextmenu(e, visit); }, false);

      visitMarker.addListener(EVENT_MOUSEOVER, function() {
        if (highlightRouteOnHoverIsEnabled && route) {
          polylineEventService.highlightRouteOnHover(EVENT_MOUSEOVER, route.id, routesPolylines);
        }
        if (vm.detailedRouteIndicators) {
          _detailedIndicatorsHover(EVENT_MOUSEOVER, route, vehicle);
        } else {
          _listenerRouteHover(route, vehicle, EVENT_MOUSEOVER);
        }
      });

      visitMarker.addListener(EVENT_MOUSEOUT, function() {
        if (highlightRouteOnHoverIsEnabled && route) {
          polylineEventService.highlightRouteOnHover(EVENT_MOUSEOUT, route.id, routesPolylines);
        }
        if (vm.detailedRouteIndicators) {
          _detailedIndicatorsHover(EVENT_MOUSEOUT);
        } else {
          _listenerRouteHover(route, vehicle, EVENT_MOUSEOUT);
        }
      });

      visitMarker.addListener(EVENT_CLICK, function(e) { _listenerMarkerClick(e, visit); });

      vm.visitsMarkers[visit.id] = visitMarker;
    }

    function _listenerPolylineClick() {
      var polyline = this;
      var route = plannerService.getRouteById(polyline.ident);
      if (revisedRoutesService.isRouteRevised(route)) {
        return;
      }

      var routeId = route.id;
      var vehicleId = route.vehicleId;

      if (vm.isMoveToModeActivated) {
        vm.isMoveToModeActivated = false;
        vm.moveVisitsToRoute(routeId, vehicleId);
      } else if (routesGroupMarkersService.areGroupMarkersEnabled()) {
        var areVisitsMarkersVisible = !route.areVisitsMarkersVisible;
        route.areVisitsMarkersVisible = areVisitsMarkersVisible;
        visitsMarkersService.showVisitsOnMap(route.visits, areVisitsMarkersVisible);
      } else {
        $rootScope.$broadcast("Planner:Routes:toggleCollapseRoute:clickOnRoute", {
          route_id: routeId,
          vehicle_id: vehicleId
        });
      }
    }

    function _listenerPolygonClick() {
      var polygon = this;
      var route = plannerService.getRouteObjById(polygon.ident);
      if (revisedRoutesService.isRouteRevised(route)) {
        return;
      }

      if (vm.isMoveToModeActivated) {
        vm.isMoveToModeActivated = false;
        vm.moveVisitsToRoute(route.id, route.vehicleId);
      } else {
        $rootScope.$broadcast("Planner:Route:toggleCollapseRoute", { route: route });
      }
    }

    function _detailedIndicatorsHover(eventType, route, vehicle) {
      if (!plannerService.isStepThreeActive()) {
        return;
      }
      var thisEvent = {
        eventType: eventType,
        indicatorsData: vm.indicatorsData,
        route: route || null,
        vehicle: vehicle || null
      };

      _plannerRouteDetailedHover(thisEvent);
    }

    function _listenerRouteHover(route, vehicle, eventType) {
      if (!plannerService.isStepThreeActive()) {
        return;
      }
      var thisEvent = {
        statusBar: vm.statusBar,
        route: route,
        vehicle: vehicle,
        eventType: eventType
      };

      _plannerRouteHover(thisEvent);
    }

    function _plannerRouteHover(data) {
      var isEnabledStatusBar = data.eventType === EVENT_MOUSEOVER && Boolean(data.route) && Boolean(data.vehicle);

      data.statusBar.element = isEnabledStatusBar ? "route" : null;
      data.statusBar.routeName = isEnabledStatusBar ? vm.routeCodes[data.route.id] : null;
      data.statusBar.route = isEnabledStatusBar ? data.route : {};
      data.statusBar.vehicle = isEnabledStatusBar ? data.vehicle : {};

      $scope.$apply();
    }

    function _plannerRouteDetailedHover(data) {
      var showIndicatorData = data.eventType === EVENT_MOUSEOVER && Boolean(data.route) && Boolean(data.vehicle);

      data.indicatorsData.element = data.route ? "route" : null;
      data.indicatorsData.routeName = showIndicatorData ? vm.routeCodes[data.route.id] : null;
      data.indicatorsData.route = showIndicatorData ? data.route : {};
      data.indicatorsData.vehicle = showIndicatorData ? data.vehicle : {};

      $scope.$apply();
    }

    function _listenerMarkerContextmenu(event, visit) {
      if (!visit.routeId) {
        return false;
      }
      var route = plannerService.getRouteById(visit.routeId);
      if (!route || revisedRoutesService.isRouteRevised(route)) {
        return;
      }
      polylineEventService.contextMenu(
        event, route, routesPolylines, setContextMenu, showColorPicker
      );
      return false;
    }

    function initializeColorPicker() {
      var colorPickerContainer = document.getElementById('color-picker-container');
      if (!colorPickerContainer) {
        console.error('Color picker container not found in the DOM.');
        return;
      }

      vm.colorPicker = Pickr.create({
        el: '#pickr-container',
        theme: 'nano',
        closeOnScroll: false,
        useAsButton: false,
        autoReposition: false,
        comparison: false,
        swatches: [
          // blue tones
          '#0000FF',
          '#00008B',
          '#037C8A',
          // red tones
          '#D50000',
          '#FF3D00',
          '#721C1F',
          '#FF6905',
          '#FFA500',
          // yellow tones
          '#FFD000',
          '#936E10',
          // purple tonos
          '#9400D3',
          '#640075',
          '#5C21FF',
          // pink tones
          '#FF00FF',
          '#FF0883',
          '#FA6997',
          // green tones
          '#006400',
          '#03B500',
          '#004D00',
          // sky blue tones
          '#40C4FF',
          '#2962FF'
        ],
        components: {
          preview: true,
          opacity: false,
          hue: false,
          interaction: {
            hex: false,
            rgba: false,
            input: false,
            cancel: true,
            save: true
          }
        },
        i18n: {
          'btn:cancel': $translate('Planner.color_picker.btn_cancel'),
          'btn:save': $translate('Planner.color_picker.btn_save')
      }
      });
      // Add custom classes to the "Save" and "Cancel" buttons
      $timeout(function () {
        var cancelButton = document.querySelector('.pcr-cancel');
        var saveButton = document.querySelector('.pcr-save');

        if (cancelButton) {
          cancelButton.classList.add('btn', 'sp-btn-default');
        }

        if (saveButton) {
          saveButton.classList.add('btn', 'btn-success');
        }
      }, 0);

      var pickrElement = document.querySelector('.pickr');
      if (pickrElement) {
        pickrElement.style.display = 'none';
      }

      vm.colorPicker.on('swatchselect', function (color) {
        if (!color) {
          console.error('No color selected.');
          return;
        }
        var selectedColor = color.toHEXA().toString();

        // Change the color of the route temporarily
        if (vm.currentRoute) {
          var vehicleId = vm.currentRoute.vehicleId;
          var vehicle = plannerService.getVehicleById(vehicleId);
          colorAssignerService.setPlanVehicleColor(vehicleId, selectedColor);

          vehicle.setRelativePlanColor(
            selectedColor,
            true
          );

          $rootScope.$broadcast('Planner:UpdateVehicleLists');
        }
        // Hide the color container
        var colorPickerContainer = document.getElementById('color-picker-container');
        if (colorPickerContainer) {
          colorPickerContainer.style.display = 'none';
        }
      });
      vm.colorPicker.on('cancel', function () {
        var vehicleId = vm.currentRoute.vehicleId;
        var vehicle = plannerService.getVehicleById(vehicleId);

        vehicle.setRelativePlanColor(
          vm.originalRouteColor,
          true
        );
        // Destruye la instancia del color picker
        if (vm.colorPicker) {
          vm.colorPicker.hide();
        }

      });
      vm.colorPicker.on('save', function (color) {
        if (!color) {
          console.error('No color selected.');
          return;
        }
        var selectedColor = color.toHEXA().toString();

        // Changes the color of the route permanently
        if (vm.currentRoute) {
          var vehicleId = vm.currentRoute.vehicleId;
          var vehicle = plannerService.getVehicleById(vehicleId);
          if (vehicle) {
            vehicle.setRelativePlanColor(selectedColor, true);
          }
        }
        if (vm.colorPicker) {
          vm.colorPicker.hide();
        }
      });

      $scope.$on('$destroy', function () {
        if (vm.colorPicker) {
          vm.colorPicker.destroyAndRemove(); // Pickr method to destroy the instance
          vm.colorPicker = null;
        }
      });
    }

    function truncateText(element, maxLines, lineHeight) {
      var maxHeight = maxLines * lineHeight;
      if (element.scrollHeight > maxHeight) {
        var text = element.textContent;
        while (element.scrollHeight > maxHeight && text.length > 0) {
          text = text.slice(0, -1);
          element.textContent = text + '...';
        }
      }
    }


    function showColorPicker( route) {
      if (!$state.includes("*.routes-detail")) {
        return;
      }
      // Save the original color of the path before opening the color picker
      vm.originalRouteColor = route.stroke.color;

      // Update current route
      vm.currentRoute = route;

      // Removes swatcher highlighting (class `pcr-active`)
      var activeSwatches = document.querySelectorAll('.pcr-app .pcr-swatches .pcr-active');
      activeSwatches.forEach(function (swatch) {
        swatch.classList.remove('pcr-active');
      });

      var vehicle = plannerService.getVehicleById(route.vehicleId);
      var vehicleName = vehicle.name;
      var pcrApp = document.querySelector('.pcr-app');
      if (pcrApp) {
        // Add a `div` with the vehicle name if it doesn't exist
        var vehicleInfoDiv = document.querySelector('.vehicle-info');
        if (!vehicleInfoDiv) {
          vehicleInfoDiv = document.createElement('div');
          vehicleInfoDiv.className = 'vehicle-info';
          vehicleInfoDiv.style.padding = '10px';

          // Create the new div for "Recolor" and the cross icon
          var recolorDiv = document.createElement('div');
          recolorDiv.className = 'recolor-header';
          recolorDiv.style.display = 'flex';
          recolorDiv.style.justifyContent = 'space-between';
          recolorDiv.style.alignItems = 'center';
          recolorDiv.style.marginBottom = '10px';

          // "Recolor" text on the far left
          var recolorText = document.createElement('span');
          recolorText.textContent = $translate('Planner.color_picker.recolorer');
          recolorText.style.fontSize = '14px';
          recolorDiv.appendChild(recolorText);

          // Cross icon on the far right
          var closeIcon = document.createElement('img');
          closeIcon.src = '/assets/images/close_mobile_sidebar.svg';
          closeIcon.alt = 'Cerrar';
          closeIcon.style.cursor = 'pointer';
          closeIcon.style.width = '16px';
          closeIcon.style.height = '16px';
          closeIcon.addEventListener('click', function () {
            vm.colorPicker.hide();
          });
          recolorDiv.appendChild(closeIcon);

          // Add the new div to the top of the `vehicle-info` container
          vehicleInfoDiv.appendChild(recolorDiv);

          // Create the h4 for the vehicle name
          var vehicleNameHeader = document.createElement('h4');
          vehicleNameHeader.textContent = vehicleName;
          vehicleInfoDiv.appendChild(vehicleNameHeader);

          // Create the p for the additional text
          var vehicleDescription = document.createElement('p');
          vehicleDescription.textContent = $translate('Planner.color_picker.info_message');
          vehicleInfoDiv.appendChild(vehicleDescription);

          // Add the div to the beginning of the color picker container
          pcrApp.prepend(vehicleInfoDiv);
        } else {
          // Updates the content if the div already exists
          vehicleInfoDiv.querySelector('h4').textContent = vehicleName;
          vehicleInfoDiv.querySelector('p').textContent = $translate('Planner.color_picker.info_message');
        }
        var vehicleNameElement = document.querySelector('.pcr-app .vehicle-info h4');
        truncateText(vehicleNameElement, 2, 24);

      } else {
        console.error('pcr-app element not found.');
      }
    }

    function _initializeMap() {
      $rootScope.mapInitCoord = null;
      mapService.getMapOptions().then(
        function success(map) {
          try {
            var mapInstance = googleService.createMap(document.getElementById('map'), map.options);

            mapInstance.setCenter(googleService.getGoogleMapsLatLng(map.center.latitude, map.center.longitude));
            googleService.googleMapsEventTrigger(mapInstance, 'resize');
            plannerService.setGmap(mapInstance);
            vm.map = mapInstance;
            if ($state.current.name.includes("planner")) {
              paintPlanOnMap();
            }

            //Inicializamos el infoWindow
            infoWindow = googleService.createInfoWindow({
              maxWidth: 250
            });

            //Inicializamos el zoneWindow
            vm.zoneWindow  = googleService.createInfoWindow();

          } catch (error) {
            $log.error(error);
          }
        }, function errorGetMapOptions(error) {
          $log.info(error);
          if (error.message) {
            Toasts.push('error', $translate('Toast.error_get_options_map_1'));
          }
          if (error.status === 404) {
            Toasts.push('error', $translate('Toast.error_get_options_map_2'));
          }
        });
    }

    function showRoutesGroupMarkersInViewport() {
      var routesWithVisibleVisits =  vm.routes.filter(function (route) {
        return route.areVisitsMarkersVisible;
      });

      if (!routesWithVisibleVisits.length) {
        return;
      }

      var bounds = plannerService.getGmap().getBounds();
      routesWithVisibleVisits.forEach(function (route) {
        var positionMarker = vm.routesGroupMarkers[route.id].position;
        var visitsInViewport = mapHandlerService.getVisitsInViewport(route.visits, bounds);
        var isRouteGroupMarkerInViewport = mapHandlerService.isRouteGroupMarkerInViewport(positionMarker, bounds);
        if (visitsInViewport.length && !isRouteGroupMarkerInViewport) {
          vm.routesGroupMarkers[route.id].setOptions({
            position: routesGroupMarkersService.getGroupMarkerPosition(visitsInViewport, route)
          });
        }
      });
    }

    function plannerClearMap(event, data) {

      var mergePlan = false;
      vm.optimizationResultsOptions = [];
      if (!angular.isUndefined(data) && !angular.isUndefined(data.mergePlan)) {
        mergePlan = data.mergePlan;
      }

      for (var visit in vm.visitsMarkers) {
        if (vm.visitsMarkers.hasOwnProperty(visit)) {
          vm.visitsMarkers[visit].setMap(null);
        }
      }
      vm.visitsMarkers = {};
      for (var polyline in routesPolylines) {
        if (routesPolylines.hasOwnProperty(polyline)) {
          routesPolylines[polyline].setMap(null);
        }
      }

      if (!mergePlan) {
        for (var vehicle in vehiclesMarkers) {
          if (vehiclesMarkers.hasOwnProperty(vehicle)) {
            vehiclesMarkers[vehicle].setMap(null);
          }
        }
        vehiclesMarkers = {};
      }

      routesPolylines = {};
      for (var polygon in routesPolygons) {
        if (routesPolygons.hasOwnProperty(polygon)) {
          routesPolygons[polygon].setMap(null);
        }
      }

      routesPolygons = {};
      vm.routeCodes = {};

      _clearRoutesGroupMarkers();
    }

    function resetSteps(event) {
      vm.steps['vehicle'].visible = true;
      vm.steps['visit'].visible = false;
      vm.steps['route'].visible = false;
    }

    function openModalCancelEditPlan() {
      $scope.cancelEditPlan = cancelEditPlan;
      ngDialog.open({
        template: 'app/planner/routes/cancel-edit-plan-modal.html',
        scope: $scope
      });
    }

    function cancelEditPlan() {
      plannerService.clearDraftPlanData();
      plannerClearMap();
      plannerService.clearPlan();
      resetSteps();
      vm.planName = null;

      // Init Zones on map
      _drawZonesOnMap();

      if ($state.current.name.includes("vehicles")) {
        $scope.$broadcast("Vehicles:Init-activate");
      } else {
        $state.go('planner.vehicles-list', {});
      }

      plannerService.setUserVisualState({});
      plannerService.setlocalOptimizationOptions(plannerService.optimizationOptions);
    }

    function nextPage() {
      if (isInfoBoxesNextPageAvailable()) {
        vm.infoBoxesPage += 1;
        vm.noPrevPage = false;
        if (!isInfoBoxesNextPageAvailable()) {
          vm.noNextPage = true;
        }
      }
    }

    function isInfoBoxesNextPageAvailable() {
      var available = false;
      if ((vm.infoBoxesPerPage * (vm.infoBoxesPage + 1) < vm.infoBoxVisits.length)) {
        available = true;
      }
      return available;
    }

    function prevPage() {
      if (vm.infoBoxVisits[(vm.infoBoxesPerPage * (vm.infoBoxesPage - 1))]) {
        vm.infoBoxesPage -= 1;
        vm.noNextPage = false;
        if (!vm.infoBoxVisits[(vm.infoBoxesPerPage * (vm.infoBoxesPage - 1))]) {
          vm.noPrevPage = true;
        }
      }
    }

    function resetInfoBoxCollapse() {
      vm.infoBoxCollapse = true;
    }


    function clearEventListeners() {
      eventClearMap();
      eventClearPolygons();
      eventClearPolylines();
      eventClearRoutesGroupMarkers();
      eventClearVisits();
      eventHideMarkersOfRoute();
      eventHideVisits();
      eventHighlightVisit();
      eventInfoBoxCollapse();
      eventNotHighlightVisit();
      eventPlanEditing();
      eventPlanInfo();
      eventPlanSteps();
      eventEditMarker();
      eventPlanStepsReset();
      eventPositionNavigator();
      eventResetInfoBoxContainer();
      eventRouteCreate();
      eventRouteRemove();
      eventRoutesShowMarkersOfRoute();
      eventRouteUpdate();
      eventUpdateRouteCode();
      eventShowVisits();
      eventVehicleUpdate();
      eventVisitCreate();
      eventVisitCreateVisitsFromArray();
      eventVisitAddVisitInfoBoxContainerVisit();
      eventVisitHideInfoWindow();
      eventVisitRemove();
      eventVisitShowInfoWindow();
      eventVisitCreateMarkersLightFromArray();
      eventVisitsRemoveVisitsFromArray();
      eventVisitUpdate();
      eventVisitCreateOrUpdateMarkerLight();
      eventShowAlertMSC();
      eventUpdateInfoBoxColors();
      eventPlanRecalculateStatistics();
      eventPlanResetStatistics();
      eventVisitOffRouteCollapsed();
      eventPlanChangeFleet();
      eventRequestGeneralIndicatorsState();
      eventToggleClickPolygons();
      eventPaintPlanOnMap();
      eventAddboundsChangedEvent();
      openModalCancelEditPlanEvent();
      eventSetResultsOptimization();
      updateToolSelectionOnMapNavbar();
      eventClearListenerHandDrawing();
      eventHideAlertBarSelectedVisits();
      eventDisabledHandDrawingButton();
    }

    function onMultipleSelectionCompleted(polygon) {
      plannerService.setMultipleVisitsSelected(polygon);
    }

    function onEnterOnMultipleSelectionMode() {
      vm.isMultipleEditingModeActivated = true;
      vm.infoBoxVisits = [];
      plannerService.setZoomControlPosition('RIGHT_BOTTOM');
      $scope.$broadcast('Planner:Plan:returnIsMultipleEditingModeActivated', {
        isMultipleEditingModeActivated: vm.isMultipleEditingModeActivated,
        selectedVisits: plannerService.getSelectedVisits()
      });
    }

    function onExitMultipleSelectionMode() {
      vm.isMultipleEditingModeActivated = false;
      vm.isMoveToModeActivated = false;
      vm.msomAlertData.msg = null;
      vm.infoBoxVisits = [];
      plannerService.setZoomControlPosition('RIGHT_BOTTOM');
      $scope.$broadcast('Planner:Plan:returnIsMultipleEditingModeActivated', {
        isMultipleEditingModeActivated: vm.isMultipleEditingModeActivated,
        selectedVisits: plannerService.getSelectedVisits()
      });
    }

    function deselectVisits() {
      plannerService.deselectVisitsSelected();
    }

    function showAlertMSC(args, data) {
      vm.msomAlertData.msg = null;
      if (data.msg) {
        vm.msomAlertData.msg = {
          msg: data.msg.msg,
          load: data.msg.load,
          load2: data.msg.load2,
          load3: data.msg.load3,
          load4: data.msg.load4,
        };
      }
    }

    function updateItemsToshowPerPage() {
      var element = document.getElementById('info-boxes-area');
      if (element) {
        vm.infoBoxesPerPage = parseInt(element.offsetWidth / INFOBOX_SIZE);
        if (!$scope.$$phase) {
          $scope.$apply();
        }
      }
    }

    function updatePagination() {
      if (vm.infoBoxesPage > 0 && ((vm.infoBoxesPerPage * vm.infoBoxesPage) >= vm.infoBoxVisits.length)) {
        vm.infoBoxesPage -= 1;
        if (vm.infoBoxesPage === 0) {
          vm.noPrevPage = true;
        }
      }
      if (isInfoBoxesNextPageAvailable()) {
        vm.noNextPage = false;
      } else {
        vm.noNextPage = true;
      }
    }

    function isJoinSimilarActive() {
      return optimizationOptions.join_v2 || optimizationOptions.join;
    }

    function stepTwoIsActive() {
      return $state.includes('*.visits-list') || $state.includes('*.visits-create') || $state.includes('*.visits-detail') || $state.includes('*.visits-bulk-edit');
    }

    function isCapacityOfVehiclesUsed() {
       return !vm.enablePickupAndDeliveryMode && (vm.headerStatistics.global.totalLoads[0] > 0 && vm.headerStatistics.global.totalVehiclesCapacity[0] > 0
              || vm.headerStatistics.global.totalLoads[1] > 0 && vm.headerStatistics.global.totalVehiclesCapacity[1] > 0
              || vm.headerStatistics.global.totalLoads[2] > 0 && vm.headerStatistics.global.totalVehiclesCapacity[2] > 0);
    }

    function showTotalRoutedLoads() {
      return !vm.enablePickupAndDeliveryMode && (vm.headerStatistics.global.totalRoutedLoads[0] > 0
              || vm.headerStatistics.global.totalRoutedLoads[1] > 0
              || vm.headerStatistics.global.totalRoutedLoads[2] > 0);
    }

    function onMoveToMode(status) {
      vm.isMoveToModeActivated = status;
    }

    function showIndicatorsPerVehicle() {
      return plannerService.isStepThreeActive() && vm.headerStatistics.global.routeCount > vm.headerStatistics.global.vehicleCount && !vm.shouldHideGeneralIndicatorsInRouteEdition;
    }

    function _removeboundsChangedListener() {
      if (boundsChangedListener !== null) {
        googleService.googleMapsRemoveListener(boundsChangedListener);
      }
    }

    function getInfoWindowHTML(visit) {
      var vehicle = null;
      var indexRoute = null;
      var estimatedTimeArrival = null;
      if(visit.vehicle) {
          vehicle = plannerService.getVehicleById(visit.vehicle);
          indexRoute = plannerService.getRouteIndex(vehicle.routes, visit.routeId);
          estimatedTimeArrival = timeUtils.formatTime(visit.estimatedTimeArrival, 'YYYY-MM-DD LT');
      }

      return $templateRequest(INFOWINDOW_TEMPLATE_URL)
        .then(function (template) {
          var templateFn = $compile(template);
          var templateScope = $scope.$new();
          templateScope.visit = visit;
          templateScope.vehicle = vehicle;
          templateScope.indexRoute = indexRoute;
          templateScope.HOUR_AND_MINUTE_DEFAULT = HOUR_AND_MINUTE_DEFAULT;
          templateScope.estimatedTimeArrival = estimatedTimeArrival;

          var templateElement = templateFn(templateScope);
          return templateElement[0];
        });
    }

    function getVisitIconForRouteIndicator() {
      if (isJoinSimilarActive()) {
        return '/assets/images/vehicle_stats/marker_filled_16.svg';
      }

      return '/assets/images/vehicle_stats/location_filled_16.svg';
    }

    function getVisitCountForRouteIndicator() {
      if (isJoinSimilarActive()) {
        return vm.statusBar.route.arrivals.length;
      }

      return vm.statusBar.route.visits.length;
    }

    function updateOptimizationResult(optimizationId) {
      $rootScope.$broadcast("Planner:Routes:updateOptimizationResult", {
        optimization_id: optimizationId
      });
    }

    function toggleToolSelectionOnMap() {
      vm.isToolSelectionCollapsed = !vm.isToolSelectionCollapsed;
      if (vm.isToolSelectionCollapsed ) {
        $scope.$emit('Planner:clearListenerHandDrawing');
      }
    }

    function handDrawingModeActivated () {
       // Check if there are visits in the list
      if (!vm.visits || vm.visits.length === 0) {
        console.warn('No visits available to activate hand drawing mode.');
        return;
      }
      if(!vm.isDrawingActive) {
        googleService.createHandDrawing(vm.map, function (obj){
          var visitsWithinPolygon = vm.visits.filter(function (visit) {
            return visit.options.visible && obj.polygon.contains(googleService.getGoogleMapsLatLng(visit.latitude, visit.longitude));
          });
          $scope.$emit('visitController:Visit:check', {
            visits: visitsWithinPolygon
          });
        });
      } else {
        googleService.clearListenerHandDrawing(vm.map);
      }
      vm.isDrawingActive = !vm.isDrawingActive;
    }

    function deselectVisitsChecked() {
      $rootScope.$broadcast('visits:deselectVisitsChecked');

      if($state.includes('*.visits-detail')|| $state.includes('*.visits-bulk-edit')) {
        $rootScope.$broadcast('visits:uncheckVisit');
        plannerService.setShouldClearVisitSelectionsOnReturn(true);
        $state.go('planner.visits-list');
      }
    }

    function setContextMenu (contextMenuObj) {
      $scope.$applyAsync(function () {
        vm.contextMenu.routesInArea = contextMenuObj.routesInArea;
        vm.contextMenu.routeId = contextMenuObj.routeId;
        vm.contextMenu.vehicleId = contextMenuObj.vehicleId;
        vm.contextMenu.showContextMenu = contextMenuObj.showContextMenu;
        vm.contextMenu.routeCodes = vm.routeCodes;
      });
    }

  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .constant(
      "PDF_LOGO_BASE64",
      "data:image/png;base64,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"
    )
    .constant("SHOW_MARKER_IN_VIEWPORT_DEBOUNCE", 300)
    .constant("AUTOSAVE_PLAN_INTERVAL", 180000)
    .constant("ROUTE_STATUS_CHECK_DEBOUNCE", 500)
    .constant("ROUTE_STATUS_TOAST_DEBOUNCE", 500)
    .constant("GLOBAL_INSENSITIVE_CASE", "gi")
    .constant("VEHICLE_TYPE", {
      CAR: "car",
      FOOT: "foot",
      HELICOPTER: "helicopter",
    })
    .constant("EXTENDED_DATA", true)
    .constant("SHOW_VISIT_WINDOWS", "show_visit_windows")
    .constant("START_TIME_WINDOW", "00:00")
    .constant("END_TIME_WINDOW", "23:59")
    .constant("VEHICLE_AVAILABILITY_STATUS", {
      PARTIAL_AVAILABILITY: "PARTIAL_AVAILABILITY",
      BLOCKED: "BLOCKED"
    })
    .constant("STATE", {
      ROUTES_DETAIL: "*.routes-detail",
      ROUTES: "*.routes",
      VEHICLES_LIST: "*.vehicles-list",
      VEHICLES_DETAIL: "*.vehicles-detail"
    })
    .constant("STEP_TWO_OPTIMIZATION_OPTIONS", {
      BALANCE: "balance",
      ALL_VEHICLES: "all_vehicles",
      JOIN: "join",
      JOIN_V2: "join_v2",
      OPEN_START: "open_start",
      OPEN_ENDED: "open_ended",
      SINGLE_TOUR: "single_tour",
      BEAUTY: "beauty",
      BIG_VRP: "big_vrp",
      USE_EUCLIDEAN_DISTANCE: "use_euclidean_distance",
      ENABLE_GRAPHS: "enable_graphs",
      AUTO_REORDER: "auto_reorder",
      ENABLE_SOFT_WINDOW: "enable_soft_window",
      ON_FOOT: "on_foot",
      WAVE_ROUTING: "wave_routing",
      DISTANCE_TO_JOIN_VISITS: "distance_to_join_visits",
      AVOID_TOLLS: "avoid_tolls",
      MAXIMIZE_ATTENDED_LOAD: "maximize_attended_load",
      ONE_SELLER_PER_VEHICLE: "one_seller_per_vehicle"

    })
    .constant("DISABLED_CHECKBOX_STYLE", {color: "#bbb", "border-color": "#bbb"})
    .constant("DISABLED_LABEL_STYLE", {color: "#bbb"})
    .constant("DISABLED_SPAN_STYLE", {cursor: "default"})
    .constant("MARKER_WITH_LABEL_PATH", "/assets/images/marker-with-label/")
    .constant("HOUR_AND_MINUTE_DEFAULT", "23:59")
    .constant("INFOWINDOW_TEMPLATE_URL", "app/planner/visit-infowindow.tpl.html")
    .constant("REQUEST_STATUS", {
      CREATED: "created",
      NOT_EDITED: "not_edited",
      DELETED: "deleted",
      EDITED: "edited",
      REUSED: "reused"
    })
    .constant("NONE_STRING", "none")
    .constant("PLAN_STATUS", {
      draft: "draft",
      completed: "completed"
    })
    .constant("ESTIMATED_TIME_FORMAT", "HH:mm:ss")
    .constant("AVAILABILITY_ICON_URL", {
      AVAILABLE: "/assets/images/check_circle_filled.svg",
      PARTIALLY_AVAILABLE: "/assets/images/clock_filled.svg",
      UNAVAILABLE: "/assets/images/close_circle_filled.svg",
      WITH_EXPIRED_DOCUMENTS: "/assets/images/document_filled.svg",
      BLOCKED: "/assets/images/lock_close_filled.svg"
    })
    .constant("REVERSE_ROUTE_EVENT", "Invertir ruta")
    .constant("MARK_AS_REVIEWED_EVENT", "Marcar como revisada")
    .constant("DELETE_ROUTE_EVENT", "Eliminar ruta")
    .constant("REORDER_ROUTE_EVENT", "Reordenar ruta")
    .constant("DRAFT_FOR_APOLLO", 'draft_for_apollo')
    .constant("DATE_TIME_FORMAT", "YYYY-MM-DDTHH:mm:ss")
    .constant('PATH_FINDER_ADD_ON_KEY', 'path_finder')
    .constant('PATH_FINDER_ADD_ON_PROPERTIES', {
      ROUTE_COLOR_OVERWRITE: 'route_color_overwrite',
      MOVE_VISITS_ROUTE: 'move_visits_route',
      HIGHLIGHT_ROUTE_ON_HOVER: 'highlight_route_on_hover',
      ENABLED_AVOID_TOLLS: 'enabled_avoid_tolls',
      ENABLED_MAXIMIZE_ATTENDED_LOAD: 'enabled_maximize_attended_load',
      NON_BLOCKING_SAVING: 'non_blocking_saving',
      ENABLED_APOLLO_ROUTE_DESIGNER: 'enabled_apollo_route_designer',
      ENABLED_PRIORITIZE_LOAD: 'enabled_prioritize_load',
      SKIP_TIME_VALIDATION: 'skip_time_validation',
      HIDE_GENERAL_INDICATORS_IN_ROUTE_EDITION: 'hide_general_indicators_in_route_edition',
      POSITIVE_SELECTION_VISITS: 'positive_selection_visits',
      SAVE_VISIT_ZONE_ID: 'save_visit_zone_id',
      ENABLED_MIX_LOAD: 'enabled_mix_load',
      DISABLE_MANUAL_INTAKE_VISITS: 'disable_manual_intake_visits',
      ENABLED_APOLLO_RD_FOR_USER_IDS: 'enabled_apollo_rd_for_user_ids',
      RD_MIGRATION_DEADLINE: 'rd_migration_deadline'
    })
    .constant('SHOW_EXTRA_FIELD_VALUES_PDF_ADDON_PROPERTY', 'show_extra_field_values_pdf')
    .constant('SHOW_EXTRA_FIELD_VALUES_EXCEL_ADDON_PROPERTY', 'show_extra_field_values_excel')
    .constant('POLYLINE_STYLES', [
      { type: 'full' },
      { type: 'dashed', scale: 5, repeat: '20px' },
      { type: 'dotted', scale: 1, repeat: '10px' }
    ])
    .constant("PLAN_SAVE_PENDING", "plan-save-pending")
    .constant("ROUTE_STARTED_OR_FINISHED_ERROR_CODE", "ROUTE_STARTED_OR_FINISHED")
    .constant("SELLER_MANAGEMENT_ADD_ON_PROPERTIES", {
      ENABLE_ONE_SELLER_PER_VEHICLE: 'enable_one_seller_per_vehicle'
    })
    .constant("CODDRIVERS_ITEMS_PER_PAGE", 20)
    .constant("VEHICLE_UNAVAILABLE_ERROR_CODE", "VEHICLE_UNAVAILABLE")
    .constant("RD_MIGRATION_DEADLINE", "2026-06-29T00:00:00Z");
})();

/**
 * Created by rodrigo on 25-01-17.
 */
(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('VisitModel', VisitModel);

  function VisitModel (timeUtils) {

    function VisitModel(id, route_id, status, title, address, latitude, longitude, checkout_time,
                        estimated_time_arrival, order, reference, has_alert, window_start, window_end, window_start_2,
                        window_end_2, programmed_date, current_eta, checkin_time, items, status_changed) {
      this.id = id;
      this.route_id = route_id;
      this.status = status;
      this.title = title;
      this.address = address;
      this.latitude = latitude;
      this.longitude = longitude;
      this.checkout_time = checkout_time;
      this.estimated_time_arrival = estimated_time_arrival;
      this.order = order;
      this.reference = reference;
      this.hasAlert = has_alert;
      this.windowStart = window_start;
      this.windowEnd = window_end;
      this.windowStart2 = window_start_2;
      this.windowEnd2 = window_end_2;
      this.programmedDate = programmed_date;
      this.current_eta = current_eta;
      this.checkin_time = checkin_time;
      this.items = items;
      this.status_changed = status_changed;
    }

    VisitModel.fromJson = function (data) {
      if (!data || !data.id || !data.title || !data.address || !data.route_id || !data.status) {
        throw new Error('Json is not a valid VisitModel');
      }
      var fieldsToLocalize = ['checkout_time', 'checkin_time', 'current_eta'];
      timeUtils.convertUTCStringTimeFieldsToMomentTimezone(data, fieldsToLocalize, timeUtils.getAccountTimezone());
      return new VisitModel(
        data.id,
        data.route_id,
        data.status,
        data.title,
        data.address,
        data.latitude,
        data.longitude,
        data.checkout_time,
        data.estimated_time_arrival,
        data.order,
        data.reference,
        data.has_alert,
        data.window_start,
        data.window_end,
        data.window_start_2,
        data.window_end_2,
        data.programmed_date,
        data.current_eta,
        data.checkin_time,
        data.items,
        data.status_changed
      );
    };

    VisitModel.fromStringJson = function (stringJson) {
      var data = angular.fromJson(stringJson);
      return VisitModel.fromJson(data);
    };

    return VisitModel;

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('VisitDetailModel', VisitDetailModel);

  function VisitDetailModel($filter, timeUtils) {

    function VisitDetailModel(data) {
      this.id = data.id;
      this.title = data.title;
      this.address = data.address;
      this.latitude = data.latitude;
      this.longitude = data.longitude;
      this.planned_date = data.planned_date;
      this.reference = data.reference;
      this.status = data.status;
      this.estimated_time_arrival = data.estimated_time_arrival;
      this.order = data.order;
      this.pictures = data.pictures;
      this.checkout_observation = data.checkout_observation;
      this.checkin_time = data.checkin_time;
      this.checkout_time = data.checkout_time;
      this.checkout_comment = data.checkout_comment;
      this.checkout_latitude = data.checkout_latitude;
      this.checkout_longitude = data.checkout_longitude;
      this.checkout_author = data.checkout_user;
      this.time_service = data.time_service;
      this.driver_name = data.driver_name;
      this.vehicle_name = data.vehicle_name;
      this.window_start = data.window_start;
      this.window_end = data.window_end;
      this.window_start_2 = data.window_start_2;
      this.window_end_2 = data.window_end_2;
      this.duration = data.duration;
      this.extra_field_values = data.extra_field_values;
      this.notes = data.notes;
      this.load = data.load;
      this.load2 = data.load_2;
      this.load3 = data.load_3;
      this.calculated_service_time = data.calculated_service_time;
      this.current_eta = data.current_eta;
      this.codrivers = data.codrivers;
      this.invoices = data.invoices;
      this.items = data.items;
      this.itemsStatistics = data.itemsStatistics;
      this.pickupItems = data.pickup_items;
      this.pickupItemsStatistics = data.pickupItemsStatistics;
      this.contact_name = data.contact_name;
      this.contact_phone = data.contact_phone;
      this.contact_email = data.contact_email;
    }

    VisitDetailModel.fromJson = function (data) {
      if (!_isValidVisitDetail(data)) {
        throw new Error('Json is not a valid VisitDetailModel');
      }
      _formatData(data);
      return new VisitDetailModel(data);
    };

    function _isValidVisitDetail(data) {
      return (data && data.id && data.title && data.address && data.status);
    }

    function _cut(value, count) {
      return $filter('limitTo')(value, count);
    }

    function _formatData(data) {

      if (data.time_service) {
        data.time_service = _cut(data.time_service, 5);
      }

      if (data.calculated_service_time) {
        data.calculated_service_time = _cut(data.calculated_service_time, 5);
      }

      if (data.estimated_time_arrival) {
        data.estimated_time_arrival = $filter('limitTo')(data.estimated_time_arrival, 5);
      }

      if (data.window_start) {
        data.window_start = $filter('limitTo')(data.window_start, 5);
      }
      if (data.window_end) {
        data.window_end = $filter('limitTo')(data.window_end, 5);
      }
      if (data.window_start_2) {
        data.window_start_2 = $filter('limitTo')(data.window_start_2, 5);
      }
      if (data.window_end_2) {
        data.window_end_2 = $filter('limitTo')(data.window_end_2, 5);
      }

      if (data.signature) {
        data.pictures.push(data.signature);
      }

      if (data.items) {
        data.itemsStatistics = {
          totalQuantityPlanned: 0,
          totalQuantityDelivered: 0
        };

        data.items.forEach(function(item) {
          data.itemsStatistics.totalQuantityPlanned += item.quantity_planned;
          data.itemsStatistics.totalQuantityDelivered += item.quantity_delivered;
        });
      }

      if (data.pickup_items) {
        data.pickupItemsStatistics = _getPickupItemsStatistics(data);
      }

      timeUtils.convertUTCStringTimeFieldsToMomentTimezone(data,
        ['checkout_time', 'current_eta', 'checkin_time'], timeUtils.getAccountTimezone());
    }

    function _getPickupItemsStatistics(data) {
      var pickupItemsStatistics = {
        totalSubItemsQuantityCollectedPerItem: {},
        totalSubItemsQuantityCollected: 0,
        totalQuantityPlanned: 0,
        totalQuantityCollected: 0
      };

      var subItemsAccQuantityCollected, subItemQuantityCollected;
      data.pickup_items.forEach(function(item) {
        subItemsAccQuantityCollected = 0;
        item.sub_items.forEach(function(subItem) {
          subItemQuantityCollected = subItem.quantity_collected || 0;
          subItemsAccQuantityCollected += subItemQuantityCollected;
        });

        pickupItemsStatistics.totalSubItemsQuantityCollectedPerItem[item.id] = subItemsAccQuantityCollected;
        pickupItemsStatistics.totalSubItemsQuantityCollected += subItemsAccQuantityCollected;
        pickupItemsStatistics.totalQuantityPlanned += item.quantity_planned;
        pickupItemsStatistics.totalQuantityCollected += item.quantity_collected;
      });

      return pickupItemsStatistics;
    }


    return VisitDetailModel;

  }

})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('VehicleModel', VehicleModel);

  function VehicleModel () {
    function VehicleModel (id, name, driver, codrivers, color, routes, cost) {
      this.id = id;
      this.name = name;
      this.driver = driver;
      this.codrivers = codrivers;
      this.routes = routes;
      this.progress = 0;
      this.color = color;
      this.isActive = false;
      this.cost = cost;
    }

    VehicleModel.fromJson = function (data) {
      if (!data || !data.id || !data.name || (!angular.isObject(data.driver) && data.driver !== null) ||
        !angular.isArray(data.routes)) {
        throw new Error('Json is not a valid VehicleModel');
      }
      return new VehicleModel(
        data.id,
        data.name,
        data.driver,
        data.codrivers,
        data.color,
        data.routes,
        data.cost
      );
    };

    VehicleModel.fromStringJson = function (stringJson) {
      var data = angular.fromJson(stringJson);
      return VehicleModel.fromJson(data);
    };

    return VehicleModel;

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('RouteModel', RouteModel);

  function RouteModel() {

    function RouteModel(id, location_start_address, location_start_latitude, location_start_longitude, location_end_address,
                        location_end_latitude, location_end_longitude, driver_id, vehicle_id, plan_id, status, visits,
                        estimated_time_start, start_time, total_duration, total_load_percentage, total_load_2_percentage,
                        total_load_3_percentage, end_time, reference) {
      this.id = id;
      this.location_start_address = location_start_address;
      this.location_start_latitude = location_start_latitude;
      this.location_start_longitude = location_start_longitude;
      this.location_end_address = location_end_address;
      this.location_end_latitude = location_end_latitude;
      this.location_end_longitude = location_end_longitude;
      this.driver_id = driver_id;
      this.vehicle_id = vehicle_id;
      this.plan_id = plan_id;
      this.status = status;
      this.visits = visits;
      this.reference = reference;
      this.estimatedTimeStart = estimated_time_start;
      this.startTime = start_time;
      this.endTime = end_time;
      this.totalTimeFormatted = total_duration && total_duration.length ? total_duration.slice(0, -3) : '';
      this.totalLoadPercentage = total_load_percentage;
      this.totalLoad2Percentage = total_load_2_percentage;
      this.totalLoad3Percentage = total_load_3_percentage;
      this.expandedIndicators = false;
    }

    RouteModel.fromJson = function (data) {
      if (!data || !data.id || !data.location_start_address || !data.location_start_latitude || !data.location_start_longitude ||
        !data.location_end_address || !data.location_end_latitude || !data.location_end_longitude  ||
        !data.vehicle_id || !data.plan_id || !data.status || !data.visits) {
        throw new Error('Json is not a valid RouteModel');
      }

      return new RouteModel(
        data.id,
        data.location_start_address,
        data.location_start_latitude,
        data.location_start_longitude,
        data.location_end_address,
        data.location_end_latitude,
        data.location_end_longitude,
        data.driver_id,
        data.vehicle_id,
        data.plan_id,
        data.status,
        data.visits,
        data.estimated_time_start,
        data.start_time,
        data.total_duration,
        data.total_load_percentage,
        data.total_load_2_percentage,
        data.total_load_3_percentage,
        data.end_time,
        data.reference
      );
    };

    RouteModel.fromStringJson = function (stringJson) {
      var data = angular.fromJson(stringJson);
      return RouteModel.fromJson(data);
    };

    return RouteModel;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('PlanModel', PlanModel);

  function PlanModel() {

    function PlanModel(plan_id, name, account_id, routes) {
      this.plan_id = plan_id;
      this.name = name;
      this.account_id = account_id;
      this.routes = routes;
    }

    PlanModel.fromJson = function (data) {
      if (!data || !data.plan_id || !data.name || !data.account_id || !data.routes) {
        throw new Error('Json is not a valid PlanModel');
      }
      return new PlanModel(
        data.plan_id,
        data.name,
        data.account_id,
        data.routes);
    };

    PlanModel.fromStringJson = function (stringJson) {
      var data = angular.fromJson(stringJson);
      return PlanModel.fromJson(data);
    };

    return PlanModel;
  }
})();

(function(){
  'use strict';

  angular
    .module('icarus.log',[])
    .factory('Log', LogModel);

  function LogModel() {

    function Log(account_id, user_id, username, json, type_action) {
      this.accountId = account_id;
      this.userId = user_id;
      this.username = username;
      this.json = json;
      this.typeAction = type_action;
    }

    Log.fromJson = function (data) {
      return new Log(
        data.account_id,
        data.user_id,
        data.username,
        data.json,
        data.type_action);
    };

    Log.fromStringJson = function (stringJson) {
      var data = angular.fromJson(stringJson);
      return Log.fromJson(data);
    };

    return Log;
  }
})();

(function(){
  'use strict';

  angular
    .module('icarus.extraFieldDefinition',[])
    .factory('ExtraFieldDefinition', ExtraFieldDefinitionModel);

  function ExtraFieldDefinitionModel() {

    function ExtraFieldDefinition(account_id, label, key, order, enable, type, is_read, is_write) {
      this.account_id = account_id;
      this.label = label;
      this.key = key;
      this.order = order;
      this.enable = enable;
      this.type = type;
      this.is_read = is_read;
      this.is_write = is_write;
    }

    ExtraFieldDefinition.fromJson = function (data) {
      return new ExtraFieldDefinition(
        data.account_id,
        data.label,
        data.key,
        data.order,
        data.enable,
        data.type,
        data.is_read,
        data.is_write
        );
    };

    ExtraFieldDefinition.fromStringJson = function (stringJson) {
      var data = angular.fromJson(stringJson);
      return ExtraFieldDefinition.fromJson(data);
    };

    return ExtraFieldDefinition;
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.shared')
    .factory('EventModel', EventModel);

  function EventModel (timeUtils) {

    var TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
    var ACCOUNT_TIMEZONE = timeUtils.getAccountTimezone();

    function EventModel (occurred_on, version, data, aggregate_id, reference) {
      this.occurred_on = occurred_on;
      this.reference = reference;
      this.version = version;
      this.data = data;
      this.aggregate_id = aggregate_id;
    }

    EventModel.fromJson = function (data) {
      if (!data || !data.occurred_on || !data.version || !data.data || !data.aggregate_id) {
        throw new Error('Json is not a valid EventModel');
      }
      data.data = JSON.parse(data.data);
      timeUtils.convertUTCStringTimeFieldsToMomentTimezone(data, ['occurred_on', 'checkout_time'], ACCOUNT_TIMEZONE);
      data.data.service_time = moment.duration(data.data.service_time).asMinutes();
      if(data.data.type === 'VISIT_CHECKOUT'){
        data.data['isCheckoutOnTime'] = _checkIfEventIsCheckoutOnTime(data.data);
      }
      return new EventModel(
        data.occurred_on,
        data.version,
        data.data,
        data.aggregate_id
      );
    };

    EventModel.fromStringJson = function (stringJson) {
      var data = angular.fromJson(stringJson);
      return EventModel.fromJson(data);
    };


    function _checkIfEventIsCheckoutOnTime (event) {
      var checkout_time = moment.utc(event.checkout_time).tz(ACCOUNT_TIMEZONE);

      var window_start_time = event.window_start_time ?
        moment.tz(event.planned_date + ' ' + event.window_start_time, TIME_FORMAT, ACCOUNT_TIMEZONE) :
        moment.tz(event.planned_date + ' 00:00:00', TIME_FORMAT, ACCOUNT_TIMEZONE);
      var window_end_time = event.window_end_time ?
        moment.tz(event.planned_date + ' ' +  event.window_end_time, TIME_FORMAT, ACCOUNT_TIMEZONE) :
        moment.tz(event.planned_date + ' 23:59:59', TIME_FORMAT, ACCOUNT_TIMEZONE);

      if(!event.window_start_time && !event.window_end_time){
        return true;
      }

      if(checkout_time.isBetween(window_start_time, window_end_time, '[]')){
        return true;
      }

      var window_start_2_time = event.window_start_2_time ?
        moment.tz(event.planned_date + ' ' + event.window_start_2_time, TIME_FORMAT, ACCOUNT_TIMEZONE) :
        moment.tz(event.planned_date + ' 00:00:00', TIME_FORMAT, ACCOUNT_TIMEZONE);
      var window_end_2_time = event.window_end_2_time ?
        moment.tz(event.planned_date + ' ' + event.window_end_2_time, TIME_FORMAT, ACCOUNT_TIMEZONE) :
        moment.tz(event.planned_date + ' 23:59:59', TIME_FORMAT, ACCOUNT_TIMEZONE);

      if(!event.window_start_2_time && !event.window_end_2_time){
        return true;
      }

      if(checkout_time.isBetween(window_start_2_time, window_end_2_time, '[]')){
        return true;
      }

      return false;
    }
    return EventModel;

  }
})();

(function() {
    'use strict';

    angular
      .module('icarus.extensions', []);

})();

(function () {
  'use strict';

  angular
    .module('icarus.extensions')
    .factory('extensionsService', extensionsService);

  /** @ngInject */
  function extensionsService ($http, __env, $q) {
    var EXTENSIONS_PATH = __env.API_URL + 'extensions/me';
    var getMyExtensionsPromise = null;


    return {
      getMyExtensions: getMyExtensions,
      clearExtensions: clearExtensions
    };

    function getMyExtensions() {
      if (getMyExtensionsPromise) {
        return getMyExtensionsPromise;
      }

      var deferred = $q.defer();
      $http.get(EXTENSIONS_PATH)
        .then(function(response) {
          deferred.resolve(response.data);
        });

      getMyExtensionsPromise = deferred.promise;
      return getMyExtensionsPromise;
    }

    function clearExtensions() {
      getMyExtensionsPromise = null;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.extensions')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('extensions', {
        parent: 'main',
        url:  '/extensions',
        controller: 'ExtensionsController',
        controllerAs: 'vm',
        templateUrl: 'app/extensions/extensions.html',
        data:{
          authentication:  true
        }
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('icarus.extensions')
    .controller('ExtensionsController', extensionsController);

  /** @ngInject */
  function extensionsController($rootScope, store, extensionsService,
    $log, $timeout, $scope, RETOOL_SIMPLI_BASE_URL
  ) {
    var TOKEN_KEY = 'token';
    var vm = this;

    vm.tabs = [];
    vm.showExtension = showExtension;
    vm.selectedExtension = null;

    init();

    function init() {
      $rootScope.isLoading = true;

      extensionsService.getMyExtensions()
        .then(getMyExtensionsSuccess)
        .catch(getMyExtensionsError);

      function getMyExtensionsSuccess(extensions) {
        if (extensions.length > 0) {
          extensions.forEach(function (tab) {
            vm.tabs.push(tab);
          });
          vm.showExtension(0);
        }
        $rootScope.isLoading = false;
        $timeout(function () {
          $scope.$apply();
        });
      }

      function getMyExtensionsError(err) {
        $rootScope.isLoading = false;
        $log.error(err);
      }
    }

    function showExtension (index) {
      var token = store.get(TOKEN_KEY);
      vm.extensionUrl = vm.tabs[index].url;
      vm.selectedExtension = index;
      if (vm.extensionUrl.includes(RETOOL_SIMPLI_BASE_URL)) {
        var areThereParamsInTheUrl = vm.extensionUrl.includes("#");
        var tokenParam = areThereParamsInTheUrl ? "&token=" + token : "#token="+ token;
        vm.extensionUrl += tokenParam;
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .constant("RETOOL_SIMPLI_BASE_URL", "simpliroute.tryretool.com");
})();

(function() {
  "use strict";

  angular
    .module("icarus.documents", []);

})();

(function() {
  "use strict";

  angular
    .module("icarus.documents")
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state("documents", {
        parent: "main",
        url:  "/documents",
        controller: "DocumentsController",
        controllerAs: "vm",
        templateUrl: "app/documents/documents.html",
        data:{
          authentication:  true
        }
      });
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus.documents")
    .controller("DocumentsController", DocumentsController);

  /** @ngInject */
  function DocumentsController(sessionService, DOCUMENT_MANAGEMENT_RETOOL_URL) {
    var vm = this;

    vm.url = null;

    function _getDocumentManagementUrl(stripeCustomerId, userToken) {
      var id = stripeCustomerId.replace("cus_", "");
      return DOCUMENT_MANAGEMENT_RETOOL_URL + "#id=" + id + "&token=" + userToken;
    }

    function active() {
      sessionService.getUser()
        .then(function (user) {
          vm.url = _getDocumentManagementUrl(user.account.stripe_customer_id, user.api_token);
        });
    }

    active();
  }
})();

(function () {
  "use strict";

  angular
    .module("icarus")
    .constant("DOCUMENT_MANAGEMENT_RETOOL_URL", "https://simpliroute.tryretool.com/embedded/public/ec990dae-2ae1-4376-88d4-9b753ca89d78");
})();

(function() {
  'use strict';

  angular
    .module('icarus.dashboard')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

    $stateProvider
      .state('dashboard', {
        parent: 'main',
        url: '/dashboard',
        controller: 'DashboardController',
        controllerAs: 'vm',
        templateUrl: 'app/dashboard/dashboard.html',
        data:{
          authentication:  true
        },
        redirectTo: 'dashboard.visits-graphics'
      })
      .state('dashboard.visits-graphics', {
        parent: 'dashboard',
        url: '/visits',
        controller: 'VisitsGraphicsController',
        controllerAs: 'vm',
        templateUrl: 'app/dashboard/visits/visits-graphics.html',
        resolve: {
          PermissionToGraphics:  function(accountConfigsService){
            return accountConfigsService.getConfigByKey('dashboards')
              .then (function resolve (data) {
                return data;
              }, function reject () {
                return false;
              });
          }
        }
      })
      .state('dashboard.reports', {
        parent: 'dashboard',
        url: '/reports',
        controller: 'ReportsController',
        controllerAs: 'vm',
        templateUrl: 'app/dashboard/reports/reports.html'
      })
      .state("dashboard.external", {
        parent: "dashboard",
        url:  "/:dashboardId",
        controller: "ExternalDashboardController",
        controllerAs: "vm",
        templateUrl: "app/dashboard/externalDashboard/externalDashboard.html",
        data:{
          authentication:  true
        },
        params: {
          dashboardId: null
        },
        resolve: {
          shareState: function ($stateParams, $q, sessionService) {
            var shareStatePromise = $q.defer();
            var shareState = {
              user: $stateParams.user || null,
              dashboardId: $stateParams.dashboardId || null
            };

            if (shareState.user) {
              shareStatePromise.resolve(shareState);
              return shareStatePromise.promise;
            }

            sessionService.getUser()
              .then(function (user) {
                shareState.user = user;
                shareStatePromise.resolve(shareState);
              });

            return shareStatePromise.promise;
          }
        }
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('icarus.dashboard')
    .config(config);

  /** @ngInject */
  function config ($translateProvider) {
    $translateProvider.translations('es', {
      'Dashboard': {
        'reports': 'Reportes',
        'current_period': 'Período actual',
        'BarGraph': {
          'title': 'Estado de visitas por día',
          'visits_failed': 'Visitas fallidas',
          'visits_completed': 'Visitas exitosas',
          'visits_pending': 'Visitas pendientes'
        },
        'ObservationPieGraph': {
          'title_failed': 'Motivo de visitas fallidas',
          'title_completed': 'Motivo de visitas completadas',
          'failed': 'fallidas',
          'completed': 'completadas',
          'total_text_failed': 'visitas<br>fallidas',
          'total_text_completed': 'visitas<br>completadas'
        },
        'Indicators': {
          'total_visits_title': 'Total de visitas ruteadas',
          'max_vehicles_title': 'Total de vehículos utilizados',
          'visits_completed_title': 'Visitas exitosas',
          'checkouts_in_time_window_title': 'Visitas dentro de ventana horaria',
          'message_tooltip': 'En relación con el mes anterior',
          'vehicle_average_load_title': 'Promedio de carga por vehículo'
        },
        'Reports': {
          'title': 'Descargas',
          'visits_report_title': 'Reporte de visitas',
          'report_from': 'Desde',
          'report_to': 'Hasta',
          'recipient_email': 'Email destinatario',
          'send_report': 'Enviar reporte',
          'report_sending_success': 'Tu reporte se está generando. Llegará a tu correo en breve.',
          'report_sending_error': 'Hubo un error generando tu reporte.',
          'error_between_dates': '* El rango de fechas no puede superar los 31 días',
          'error_date_start': '* La fecha inicial es mayor a la fecha final',
          'error_invalid_email' : '* Correo inválido, por favor intenta nuevamente',
          'include_all_accounts': 'Incluir información consolidada de cuentas asociadas',
          'all_accounts_checkbox': 'El reporte incluirá la información de todas tus cuentas. Podrás diferenciarlas en las columnas “Nombre de cuenta” e “ID de cuenta”.',
          'error_date_duration': 'El rango de fechas seleccionado no permite generar el reporte. Debe seleccionar un rango de fechas menor.'
        },
        'checkoutGraph': {
          'title': 'Comportamiento de visitas por hora',
          'visits_total': 'Total de visitas',
          'visits_window': 'Visitas en ventana horaria'
        },
        'Visits': {
          'title': 'Visitas',
          'Modal': {
            'title': 'No tienes activada la visualización de reportes',
            'footer-message': 'Activa la sección de Reportes y revisa el estado de tus visitas mensuales; por qué fallan tus entregas, cómo se han cumplido tus ventanas horarias y más!',
            'footer-button': 'Quiero saber más',
            'confirm-message': 'Te enviaremos un email para contarte más sobre los reportes que SimpliRoute ofrece',
            'confirm-title': 'Confirmación',
            'close': 'Cerrar',
            'error_email': 'Hubo un problema al contactarnos, por favor intenta nuevamente.',
            'success_email': 'Solicitud registrada con éxito, pronto te contactaremos.'
          }
        },
        'ExternalDashboard': {
          'driverPerformance': 'Efectividad de Conductores',
          'routePerformance': 'Cumplimiento de Ruta',
        },
      }
    });
    $translateProvider.translations('en', {
      'Dashboard': {
        'reports': 'Reports',
        'current_period': 'Current period',
        'BarGraph': {
          'title': 'State of visits per day',
          'visits_failed': 'Failed visits',
          'visits_completed': 'Successful visits',
          'visits_pending': 'Pending visits'
        },
        'ObservationPieGraph': {
          'title_failed': 'Reason for unsuccessful visits',
          'title_completed': 'Reason for completed visits',
          'failed': 'failed',
          'completed': 'completed',
          'total_text_failed': 'failed<br>visits',
          'total_text_completed': 'completed<br>visits'
        },
        'Indicators': {
          'total_visits_title': 'Total routed visits',
          'max_vehicles_title': 'Total vehicles used',
          'visits_completed_title': 'Successful visits',
          'checkouts_in_time_window_title': 'Visits within the time window',
          'message_tooltip': 'In relation to the previous month',
          'vehicle_average_load_title': ' Average load per vehicle'
        },
        'Reports': {
          'title': 'Downloads',
          'visits_report_title': 'Visits report',
          'report_from': 'From',
          'report_to': 'To',
          'recipient_email': 'Recipient email',
          'send_report': 'Send report',
          'report_sending_success': 'Your report is being generated. It will arrive in your inbox shortly.',
          'report_sending_error': 'There was an error generating your report.',
          'error_between_dates': '* Date range cannot exceed 31 days',
          'error_date_start': '* Start date is greater than end date',
          'error_invalid_email' : '* Invalid email, please try again',
          'include_all_accounts': 'Include consolidated information on associated accounts',
          'all_accounts_checkbox': 'The report will include the information of all your accounts. You will be able to differentiate them in the columns "Account name" and "Account ID".',
          'error_date_duration': 'Report can’t be requested for selected dates. Select a shorter date range.'
        },
        'checkoutGraph': {
          'title': 'Visits per hour behavior',
          'visits_total': 'Total visits',
          'visits_window': 'Visits in time window'
        },
        'Visits': {
          'title': 'Visits',
          'Modal': {
            'title': 'You do not have report display enabled',
            'footer-message': 'Activate the Reports section and check the status of your monthly visits, why your deliveries fail, how your time windows have been fulfilled and more!',
            'footer-button': 'I want more information',
            'confirm-message': 'We will send you an email to tell you more about the reports that SimpliRoute offers',
            'confirm-title': 'Confirmation',
            'close': 'Close',
            'error_email': 'There was a problem contacting us, please try again.',
            'success_email': 'Your request has been registered successfully, we will contact you soon.'
          }
        },
        'ExternalDashboard': {
          'driverPerformance': 'Driver Effectiveness',
          'routePerformance': 'Route Compliance',
        },
      }
    });
    $translateProvider.translations('pt', {
      'Dashboard': {
        'reports': 'Relatórios',
        'current_period': 'Período atual',
        'BarGraph': {
          'title': 'Status das visitas por dia',
          'visits_failed': 'Visitas não realizadas',
          'visits_completed': 'Visitas bem sucedidas',
          'visits_pending': 'Visitas pendentes'
        },
        'ObservationPieGraph': {
          'title_failed': 'Observações de visitas que falharam',
          'title_completed': 'Observações de visitas finalizadas',
          'failed': 'falhou',
          'completed': 'finalizadas',
          'total_text_failed': 'visitas<br>não realizadas',
          'total_text_completed': 'visitas<br>completadas'
        },
        'Indicators': {
          'total_visits_title': 'Total de visitas roteirizadas',
          'max_vehicles_title': 'Total de veículos usados',
          'visits_completed_title': 'Visitas bem sucedidas',
          'checkouts_in_time_window_title': 'Janela de tempo por visita',
          'message_tooltip': 'Em relação ao mês anterior',
          'vehicle_average_load_title': 'Carga média por veículo'
        },
        'Reports': {
          'title': 'Downloads',
          'visits_report_title': 'Relatório de entregas',
          'report_from': 'De',
          'report_to': 'Para',
          'recipient_email': 'Email destinatário',
          'send_report': 'Enviar relatório',
          'report_sending_success': 'Seu relatório está sendo gerado. Você irá recebê-lo no seu correio em breve',
          'report_sending_error': 'Houve um erro ao gerar o relatório.',
          'error_between_dates': '* O intervalo de datas não pode ultrapassar 31 dias',
          'error_date_start': '* A data de início é maior do que a data de término',
          'error_invalid_email' : '* Você não inseriu um email válido',
          'include_all_accounts': 'Incluir informações consolidadas sobre as contas associadas',
          'all_accounts_checkbox': 'O relatório incluirá informações sobre todas as suas contas. Você poderá diferenciá-las nas colunas "Nome da conta" e "ID da conta".',
          'error_date_duration': 'A gama de datas selecionadas não permite que o relatório gere. Você deve selecionar um intervalo de datas mais baixo.'
        },
        'checkoutGraph': {
          'title': 'Comportamento de visitas por hora',
          'visits_total': 'Total de visitas',
          'visits_window': 'Janela de tempo visitantes'
        },
        'Visits': {
          'title': 'Visitas',
          'Modal': {
            'title': 'A visualização de relatórios não se encontra ativada.',
            'footer-message': 'Ative a seção de Relatórios e verifique a evolução mensal das suas visitas; os motivos das suas entregas não terem sido realizadas; as janelas de entregas e muito mais!',
            'footer-button': 'Mais informações',
            'confirm-message': 'Nós enviaremos um e-mail com maiores informações de como ativar os relatórios que a SimpliRoute oferece.',
            'confirm-title': 'Confirmação',
            'close': 'Fechar',
            'error_email': 'Houve um problema, tente novamente',
            'success_email': 'Seu pedido foi registrado com sucesso, entraremos em contato em breve.'
          }
        },
        'ExternalDashboard': {
          'driverPerformance': 'Eficácia do Motorista',
          'routePerformance': 'Conformidade de Rota',
        },
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.dashboard')
    .controller('DashboardController', DashboardController);

  /** @ngInject */
  function DashboardController(
    $window, $translate, apolloAuthService
  ) {


    var language = $translate.use();
    var currentLanguage = ['es', 'en', 'pt'].includes(language) ? language : 'en';

    // redirect to new dashboard in apollo web
    $window.location.href = apolloAuthService.buildRedirectURL(currentLanguage + '/reports');
  }

})();
(function () {
  'use strict';

  angular
    .module('icarus')
    .constant('VISIT_DASHBOARD', 'cf9a8af6-b7a7-4733-bf78-c03b2e52eaea')
    .constant('DRIVER_PERFORMANCE_DASHBOARD', 'b7816268-1f22-4e96-af72-580909f4c034')
    .constant('ROUTE_PERFORMANCE_DASHBOARD', '56dc2efb-c53a-44ad-831b-5aed92eb01b1');
})();

(function() {
    'use strict';

    angular
      .module('icarus.chat', []);

})();

(function() {
  'use strict';

  angular
    .module('icarus.chat')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('chat', {
        parent: 'main',
        url:  '/chat',
        controller: 'ChatController',
        controllerAs: 'vm',
        templateUrl: 'app/chat/chat.html',
        data:{
          authentication:  true
        }
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('icarus.chat')
    .controller('ChatController', chatController);

  /** @ngInject */
  function chatController(store, __env, moment) {
    var vm = this;
    var TOKEN_KEY = 'token';

    vm.chatUrl = "";

    init();

    function init() {
      var token = store.get(TOKEN_KEY);
      var timestamp = moment().format('X');
      vm.chatUrl = __env.SIMPLI_CHAT_URL + token + "?version=" + timestamp;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.bulk')
    .factory('xlsWriterService', XlsWriterService);

  /** @ngInject */
  function XlsWriterService(lodash) {

    return {
      listToGrid: listToGrid,
      createWorkbook: createWorkbook,
      createWorkbooks: createWorkbooks,
      writeWorkbook: writeWorkbook,
      insertValues: insertValues,
      sheetFromMatrix: sheetFromMatrix,
      addHeadersComments: addHeadersComments,
      sanitizeSheetName: sanitizeSheetName
    };

    function headerHasValues(headers) {
      return headers.length !== 0;
    }

    function inputHasValues(input) {
      return input.length !== 0;
    }

    function getObjectValues(keys, object) {
      return keys.map(function (key) {
        return object[key] ? object[key].toString().trim() : '';
      });
    }

    function getObjectValuesArray(objectsList) {
      return objectsList.map(function (object) {
        var keys = Object.keys(object);
        return getObjectValues(keys, object);
      });
    }

    function compareObjectsListKeys(objectsList, headers) {
      return lodash.every(objectsList, function (object) {
        return Object.keys(object).length === headers.length;
      });
    }

    function objectsKeysAreEqual(objectsList, headers) {
      return compareObjectsListKeys(objectsList, headers);
    }

    function validate(input, headers) {
      if (!inputHasValues(input) || !(headerHasValues(headers))) {
        throw new Error('Empty input');
      }

      if (!objectsKeysAreEqual(input, headers)) {
        throw new Error('Keys do not match');
      }
    }

    function listToGrid(input, headers, isNotTemplate) {
      // Karma throws an error assigning a default value to isNotTemplate.
      if (isNotTemplate === undefined) {
        validate(input, headers);
      }

      var data = getObjectValuesArray(input);

      return {
        headers: headers,
        headers_comments: [],
        data: data
      };
    }

    function addHeadersComments (grid, headers_comments) {
      grid.headers_comments = headers_comments;
      return grid;
    }

    function generateColumnName(cellNumber) {
      var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
      var numeric = cellNumber % 26;
      var letter = alphabet[numeric];
      var num2 = parseInt(cellNumber / 26);
      if (num2 > 0) {
        return generateColumnName(num2 - 1) + letter;
      } else {
        return letter;
      }
    }

    function insertValues(data) {
      var cell = '';
      var values = {};
      for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].length; j++) {
          var cellLetter = '';
          cellLetter = generateColumnName(j);
          cell = cellLetter + (i + 2);
          if(data[i][j] && typeof data[i][j] === 'object' && data[i][j].hasOwnProperty('v') && data[i][j].hasOwnProperty('t')){
            values[cell] = {
              v: (!angular.isUndefined(data[i][j].v) && data[i][j].v !== null) ? data[i][j].v : '',
              t: data[i][j].t
            };
          }else{
            values[cell] = {
              v: (!angular.isUndefined(data[i][j]) && data[i][j] !== null) ? data[i][j].toString() : '',
              t: 's'
            };
          }
        }
      }
      return {
        data: values,
        lastCell: cell
      };
    }


    function insertHeaders(headers, headers_comments) {
      var row = {};
      var cell = '';
      for (var i = 0; i < headers.length; i++) {
        var header_comment = headers_comments[i];
        var cellName = generateColumnName(i);
        cell = cellName + 1;
        row[cell] = {
          v: headers[i],
          t: 's'
        };
        if (header_comment) {
          row[cell].c = [{t: header_comment}];
          row[cell].c.hidden = true;
        }

      }
      return {
        data: row,
        lastCell: cell
      };
    }

    function createSheet(sheetName, grid) {
      var sheet = {};
      var headers = insertHeaders(grid.headers, grid.headers_comments);
      sheet[sheetName] = headers.data;
      var values = insertValues(grid.data);
      sheet[sheetName] = Object.assign(sheet[sheetName], values.data);
      if (headers.lastCell) {
        sheet[sheetName]['!ref'] = 'A1:' + (values.lastCell ? values.lastCell : headers.lastCell);
      }
      return sheet;
    }

    function createWorkbook(sheetName, grid) {
      var sheetNames = [];
      var formattedSheetName = sheetName.trim().replace(/ /g, '_');
      var sheets = createSheet(formattedSheetName, grid);
      sheetNames.push(formattedSheetName);
      return {
        Sheets: sheets,
        SheetNames: sheetNames
      };
    }

    // Allow creating more than one workbook at time
    function createWorkbooks(sheetName, grid) {
      var sheetNames = [];
      var sheets = {};
      for(var idx = 0; idx !== sheetName.length; ++idx) {
        var formattedSheetName = sheetName[idx].trim().replace(/ /g, '_');
        sheetNames.push(formattedSheetName);
        sheets[sheetName[idx]] = createSheet(formattedSheetName, grid[idx])[sheetName[idx]];
      }
      return {
        Sheets: sheets,
        SheetNames: sheetNames
      };
    }

    function writeWorkbook(workbook) {
      var wopts = {bookType: 'xlsx', bookSST: false, type: 'binary'};
      return XLSX.write(workbook, wopts);
    }

    function sheetFromMatrix (data) {
      // Reference: http://sheetjs.com/demos/writexlsx.html
      var ws = {};
      var range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
      for(var R = 0; R !== data.length; ++R) {
        for(var C = 0; C !== data[R].length; ++C) {
          if(range.s.r > R) {range.s.r = R;}
          if(range.s.c > C) {range.s.c = C;}
          if(range.e.r < R) {range.e.r = R;}
          if(range.e.c < C) {range.e.c = C;}
          var cell = {v: data[R][C] };
          if(cell.v === null) {continue;}
          var cell_ref = XLSX.utils.encode_cell({c:C,r:R});

          if(angular.isNumber(cell.v)) {
            cell.t = 'n';
          }
          else if(typeof cell.v === 'boolean') {cell.t = 'b';}
          else if(cell.v instanceof Date) {
            cell.t = 'n'; cell.z = XLSX.SSF._table[14];
            cell.v = datenum(cell.v);
          }
          else {cell.t = 's';}

          ws[cell_ref] = cell;
        }
      }
      if(range.s.c < 10000000) {ws['!ref'] = XLSX.utils.encode_range(range);}
      return ws;

      function datenum(v, date1904) {
        if(date1904) {v+=1462;}
        var epoch = Date.parse(v);
        return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
      }
    }

    function sanitizeSheetName(name) {
      return name
        .replace(/[\\/:?*\[\]]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.bulk')
    .factory('xlsUploaderService', XlsUploaderService);

  /** @ngInject */
  function XlsUploaderService($q) {
    return {
      handleFile: handleFile
    };

    function fixdata(data) {
      var o = "", l = 0, w = 10240;
      for(; l<data.byteLength/w; ++l) {o+=String.fromCharCode.apply(null,new Uint8Array(data.slice(l*w,l*w+w)));}
      o+=String.fromCharCode.apply(null, new Uint8Array(data.slice(l*w)));
      return o;
    }

    function handleFile(file) {
      var deferred = $q.defer();
      try {
        var rABS = typeof FileReader !== "undefined" && typeof FileReader.prototype !== "undefined" && typeof FileReader.prototype.readAsBinaryString !== "undefined";
        var reader = new FileReader();
        reader.onload = function(e) {
          try {
            var data = e.target.result;
            var workbook;
            if(rABS) {
              workbook = XLSX.read(data, {type: 'binary'});
            } else {
              var arr = fixdata(data);
              workbook = XLSX.read(btoa(arr), {type: 'base64'});
            }
            deferred.resolve({
              SheetNames: workbook.SheetNames,
              Sheets: workbook.Sheets
            });
          } catch (e) {
            deferred.reject(e);
          }
        };
        reader.readAsBinaryString(file);
      } catch (e) {
        deferred.reject(e);
      }

      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.bulk')
    .factory('xlsParserService', XlsParserService);

  /** @ngInject */
  function XlsParserService(lodash) {

    return {
      createGrid: createGrid,
      gridToList: gridToList,
      convertToArray: convertToArray
    };

    function columnToInt(col) {
      var base = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      var result = 0;
      var j = col.length - 1;
      for (var i = 0; i < col.length; i += 1, j -= 1) {
        result += Math.pow(base.length, j) * (base.indexOf(col[i]) + 1);
      }
      return result;
    }

    function columnNameFromCell(cellNumber) {
      var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
      var numeric = cellNumber % 26;
      var letter = alphabet[numeric];
      var num2 = parseInt(cellNumber / 26);
      if (num2 > 0) {
        return columnNameFromCell(num2 - 1) + letter;
      } else {
        return letter;
      }
    }

    function getRowFromCell(cell) {
      return cell.replace(/^\D+/g, '');
    }

    function getColumnFromCell(cell) {
      return cell.replace(/[0-9]/g, '');
    }


    function gridToList(input) {
      var output = [];
      var keys = input.headers;
      lodash.forEach(input.data, function (value) {
        var element = {};
        for (var i = 0; i < keys.length; i++) {
          element[keys[i]] = value[i];
        }
        output.push(element);
      });
      return output;
    }

    function cellValue(sheet, row, columnName) {
      var cell = sheet[columnName + row];
      var value = '';
      if (cell) {
        if (cell.w) {
          value = cell.w;
        } else if (cell.v) {
          value = cell.v;
        }
      }
      return value;
    }

    function setHeaders(firstColumnIndex, lastColumnIndex, sheet, output) {
      for (var j = firstColumnIndex; j <= lastColumnIndex; j++) {
        var columnName = columnNameFromCell(j - 1);
        var cellData = cellValue(sheet, 1, columnName);
        output.push(cellData);
      }
    }

    function setValues(lastRow, firstColumnIndex, lastColumnIndex, sheet, output) {
      for (var i = 2; i <= lastRow; i++) {
        var dataRow = [];
        for (var j = firstColumnIndex; j <= lastColumnIndex; j++) {
          var columnName = columnNameFromCell(j - 1);
          dataRow.push(cellValue(sheet, i, columnName));
        }
        var emptyRow = dataRow.every(function(value) {
          return !value;
        });
        if (!emptyRow) {
          dataRow.push(i);
          output.push(dataRow);
        }
      }
    }

    function createGrid(input, headers) {
      var output = {
        headers: [],
        data: []
      };
      var sheetName = input.SheetNames[0];
      var sheet = input.Sheets[sheetName];
      var limits = input.Sheets[sheetName]['!ref'];
      if (limits) {
        var rangeCells = limits.split(':');
        var firstColumn = getColumnFromCell(rangeCells[0]);
        var lastRow = parseInt(getRowFromCell(rangeCells[1]));
        var lastColumn = getColumnFromCell(rangeCells[1]);
        //get headers
        var firstColumnIndex = columnToInt(firstColumn);
        var lastColumnIndex = columnToInt(lastColumn);
        output.headers = headers;
        output.headers.push('!row');
        setValues(lastRow, firstColumnIndex, lastColumnIndex, sheet, output.data);
      }
      return output;
    }

    function convertToArray(input, keys) {
      var output = input.map(function (value) {
        keys.forEach(function (key) {
          value[key] = String(value[key]).split(",").map(function (item) {
            return item.trim();
          });
        });
        return value;
      });
      return output;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.bulk')
    .factory('bulkService', BulkService);

  /** @ngInject */
  function BulkService($http, __env, $q, $log, lodash, sessionService, plannerService) {

    var VEHICLES_UPLOAD_PATH = __env.API_URL + 'bulk/upload/vehicles/';
    var VEHICLES_UPDATE_PATH = __env.API_URL + 'bulk/update/vehicles/';

    return {
      uploadVehicles: uploadVehicles,
      updateVehicles: updateVehicles,
      listUsers: listUsers,
      createUsers: createUsers,
      updateUsers: updateUsers
    };

    function uploadVehicles(inputVehicles) {
      var deferred = $q.defer();
      var vehicles = addTempId(inputVehicles);
      var vehiclesAddresses = buildAddressList(vehicles);
      tryPreGeoreferenceBatch(vehiclesAddresses.start).then(
        function successTryPreGeoreferenceBatch(startLocations) {
          tryPreGeoreferenceBatch(vehiclesAddresses.end).then(
            function successEndAddresses(endLocations) {
              var vehiclesLocations = {
                start: startLocations,
                end: endLocations
              };
              validateLocations(vehiclesLocations).then(function (result) {
                if (!result.error) {
                  vehicles = addLocations(vehicles, vehiclesLocations);
                  $http.post(VEHICLES_UPLOAD_PATH, vehicles).then(
                    function success(resp) {
                      updateVehiclesOnPlannerService(resp.data.vehicles_uploaded);
                      deferred.resolve(resp.data);
                    },
                    function errorCreateVehicle(error) {
                      deferred.reject(error);
                    });
                }
              }, function (err) {
                deferred.reject(err);
              });
            }, function (err) {
              deferred.reject(err);
            });
        }, function (err) {
          deferred.reject(err);
        });
      return deferred.promise;
    }

    function errorTryPreGeoreferenceBatch(error) {
      $log.error(error);
    }

    function updateVehicles(inputVehicles) {
      var deferred = $q.defer();
      var vehicles = addTempId(inputVehicles);
      var vehiclesAddresses = buildAddressList(vehicles);
      tryPreGeoreferenceBatch(vehiclesAddresses.start).then(
        function successTryPreGeoreferenceBatch(startLocations) {
          tryPreGeoreferenceBatch(vehiclesAddresses.end).then(
            function successEndAddresses(endLocations) {
              var vehiclesLocations = {
                start: startLocations,
                end: endLocations
              };
              validateLocations(vehiclesLocations).then(function (result) {
                if (!result.error) {
                  vehicles = addLocations(vehicles, vehiclesLocations);
                  $http.put(VEHICLES_UPDATE_PATH, vehicles).then(
                    function success(resp) {
                      updateVehiclesOnPlannerService(resp.data.vehicles_updated);
                      deferred.resolve(resp);
                    },
                    function errorCreateVehicle(error) {
                      deferred.reject(error);
                    });
                }
              }, function (err) {
                deferred.reject(err);
              });
            }, function (err) {
              deferred.reject(err);
            });
        }, function (err) {
          deferred.reject(err);
        });
      return deferred.promise;
    }

    function addTempId(list) {
      return list.map(function (element, index) {
        element.tempId = index.toString();
        return element;
      });
    }

    function validateCountry(locationsList) {
      var deferred = $q.defer();
      var errorObject = {
        error: false
      };
      sessionService.getUser().then(function (user) {
        var userAccount = user.account;
        for (var i = 0; i < locationsList.start.length; i++) {
          if (locationsList.start[i].country && locationsList.start[i].country !== userAccount.country) {
            errorObject.error = true;
            errorObject.type = 'LOCATION_ERROR';
            errorObject.location = locationsList.start[i];
          }
          if (locationsList.end[i].country && locationsList.end[i].country !== userAccount.country) {
            errorObject.error = true;
            errorObject.type = 'LOCATION_ERROR';
            errorObject.location = locationsList.end[i];
          }
        }
        if (errorObject.error) {
          deferred.reject(errorObject);
        } else {
          deferred.resolve(errorObject);
        }

      }, function error(e) {
        deferred.reject(e);
        $log.info(e);
      });

      return deferred.promise;
    }

    function validateLocations(locationsList) {
      var deferred = $q.defer();
      validateCountry(locationsList).then(function () {
        deferred.resolve({error: false});
      }, function (error) {
        deferred.reject(error);
      });
      return deferred.promise;
    }

    function addLocations(vehiclesList, locationsList) {
      return vehiclesList.map(function (vehicle) {
        var locationObject = {
          start: lodash.find(locationsList.start, {ref_id: vehicle.tempId.toString()}),
          end: lodash.find(locationsList.end, {ref_id: vehicle.tempId.toString()})
        };
        vehicle.location_start_address = vehicle.location_start_address || locationsList.start[0].address ;
        vehicle.location_end_address = vehicle.location_end_address || locationsList.end[0].address ;
        if(!vehicle.location_start_latitude || !vehicle.location_start_longitude){
          vehicle.location_start_latitude =  locationObject.start.latitude;
          vehicle.location_start_longitude = locationObject.start.longitude;
        }

        if(!vehicle.location_end_latitude || !vehicle.location_end_longitude ){
          vehicle.location_end_latitude = vehicle.location_start_latitude || locationObject.end.latitude;
          vehicle.location_end_longitude = vehicle.location_start_longitude || locationObject.end.longitude;
        }
        return vehicle;
      });
    }

    function buildAddressList(list) {
      var startAddressList = [];
      var endAddressList = [];

      for (var i = 0; i < list.length; i++) {
        var startAddress = {
          address: list[i].location_start_address,
          latitude: Number(list[i].location_start_latitude) || 0,
          longitude: Number(list[i].location_start_longitude) || 0,
          ref_id: list[i].tempId
        };

        var endAddress = {
          address: list[i].location_end_address,
          latitude: Number(list[i].location_end_latitude) || Number(list[i].location_start_latitude) || 0,
          longitude: Number(list[i].location_end_longitude) || Number(list[i].location_start_longitude) || 0,
          ref_id: list[i].tempId
        };
        startAddressList.push(startAddress);
        endAddressList.push(endAddress);
      }
      return {
        start: startAddressList,
        end: endAddressList
      };
    }


    function _coordinateValidateRange (cord, limit) {
      return !/^(-?\d+(\.\d+)?)$/.test(cord) || parseFloat(cord) > limit || parseFloat(cord) < limit * -1;
    }

    function tryPreGeoreferenceBatch(visits) {
      var deferred = $q.defer();
      var elementsWithCoordinates = [];
      var elementsNoCoordinates = [];
      var result = [];

      for(var idx = 0; idx< visits.length; idx++ ){
        if(visits[idx]['latitude'] && visits[idx]['longitude']
          && !_coordinateValidateRange(visits[idx]['latitude'])
          && !_coordinateValidateRange(visits[idx]['longitude'])){
          elementsWithCoordinates.push(visits[idx]);
          result = elementsWithCoordinates;
        }else {
          elementsNoCoordinates.push(visits[idx]);
        }
      }

      if (elementsNoCoordinates.length) {
        $http.post(__env.APIV2_URL + 'directory/geocode/', elementsNoCoordinates).then(
          function searchAddressSuccess(response) {
            result = elementsWithCoordinates.concat(response.data);
            deferred.resolve(result);
          },
          function searchAddressError(error) {
            deferred.reject(error);
          });
      }else {
        deferred.resolve(result);
      }

        return deferred.promise;
    }

    function updateVehiclesOnPlannerService(ids) {
      plannerService.updateVehicles(ids);
    }

    function listUsers(users) {
      var deferred = $q.defer();
      $http.get(__env.API_URL + 'bulk/user/create/', null).then(
        function successListUsers(response) {
          deferred.resolve(response.data);
        },
        function errorListUsers(error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    function createUsers(users) {
      var deferred = $q.defer();
      $http.post(__env.API_URL + 'bulk/user/create/', users).then(
        function successCreateUsers(response) {
          deferred.resolve(response.data);
        },
        function errorCreateUsers(error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

    function updateUsers(users) {
      var deferred = $q.defer();
      $http.put(__env.API_URL + 'bulk/user/update/', users).then(
        function successUpdateUsers(response) {
          deferred.resolve(response.data);
        },
        function errorUpdateUsers(error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.authentication')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

    $stateProvider
      .state('auth', {
        abstract: true,
        url: '',
        controller: 'AuthenticationController',
        controllerAs: 'vm',
        templateUrl: 'app/authentication/authentication.html',
        data:{
         authentication: false
        }
      })
      .state('auth.login', {
        url: '/login?utm_source&utm_medium&utm_campaign&utm_term&utm_content',
        params:{
          utm_source: undefined,
          utm_medium: undefined,
          utm_campaign: undefined,
          utm_term: undefined,
          utm_content: undefined,
          expired: undefined
        },
        controller: 'LoginController',
        controllerAs: 'vm',
        templateUrl: 'app/authentication/login/login.html'
      })
      .state('auth.password-reset', {
        url:  '/password/reset',
        controller: 'PasswordResetController',
        controllerAs: 'vm',
        templateUrl: 'app/authentication/password-reset/password-reset.html'
      })
      .state('auth.password-reset-confirm', {
        url:  '/password/reset/confirm/:uid/:token',
        controller: 'PasswordResetConfirmController',
        controllerAs: 'vm',
        templateUrl: 'app/authentication/password-reset-confirm/password-reset-confirm.html'
      })
      .state('auth.signup', {
        url:'/signup?utm_source&utm_medium&utm_campaign&utm_term&utm_content',
        params:{
          utm_source: undefined,
          utm_medium: undefined,
          utm_campaign: undefined,
          utm_term: undefined,
          utm_content: undefined
        },
        controller: 'SignupController',
        controllerAs: 'vm',
        templateUrl: 'app/authentication/signup/signup.html'
      })
      .state('auth.sso-login', {
        url:'/login/sso?token&domain&dc&embedded',
        params:{
          token: undefined,
          domain: undefined,
          dc: undefined,
          expired: undefined,
          embedded: undefined
        },
        controller: 'LoginController',
        controllerAs: 'vm',
        templateUrl: 'app/authentication/login/login-sso.html'
      })
      .state('auth.account-not-confirmed', {
        url:'/account/not-confirmed',
        onEnter: [
          '$state', 'ngDialog',
          onEnterNotConfirmed.bind(this)
        ],
        templateUrl: 'app/authentication/login/login.html'
      })
      .state('auth.account-confirmed', {
        url:'/account/activate/:uid/:token/',
        onEnter: [
          '$state', 'ngDialog',
          onEnterConfirmed.bind(this)
        ],
        templateUrl: 'app/authentication/login/login.html'
      })
      .state('auth.encryption-passphrase', {
        url: '/encryption-passphrase',
        controller: 'EncryptionController',
        controllerAs: 'vm',
        templateUrl: 'app/authentication/encryption/encryption-passphrase.html'
      }
      )
      .state('auth.account-selector', {
        url: '/login/account',
        params: {
          returnToAccount: null,
          stateToRedirect: null
        },
        controller: 'AccountSelectorController',
        controllerAs: 'vm',
        templateUrl: 'app/authentication/account-selector/account-selector.html'
      })
      .state('auth.user-blocked', {
        url: '/login',
        controller: 'UserBlockedController',
        controllerAs: 'vm',
        templateUrl: 'app/authentication/user-blocked/user-blocked.html'
      })
      .state('auth.user-unlock-progress', {
        url: '/login',
        templateUrl: 'app/authentication/user-blocked/user-unlock-progress.html'
      })
      .state('auth.password-renewal', {
        url: '/password/renewal/:uid/:token',
        controller: 'PasswordRenewalController',
        controllerAs: 'vm',
        templateUrl: 'app/authentication/password-renewal/password-renewal.html'
      })
      .state('auth.logout', {
        url: '/logout',
        controller: 'LogoutController',
        templateUrl: 'app/authentication/logout/logout.html'
      })
      .state('auth.login-failed', {
        url: '/login/failed',
        templateUrl: 'app/authentication/login-failed/login-failed.html'
      });

    function onEnterNotConfirmed($state, ngDialog) {
      ngDialog.open({
        controller: 'AccountNotConfirmedController',
        controllerAs: 'vm',
        template: 'app/authentication/account/not-confirmed.html',
        closeByEscape: false,
        closeByDocument: false,
        showClose: false
      });
    }

    function onEnterConfirmed($state, ngDialog) {
      var dialog = ngDialog.open({
        controller: 'AccountConfirmedController',
        controllerAs: 'vm',
        template: 'app/authentication/account/confirmed.html',
        closeByEscape: false,
        closeByDocument: false
      });

      dialog.closePromise.then(function () {
        $state.go('auth.login', {});
      });
    }
  }

})();

(function () {
  'use strict';
  angular
    .module('icarus.authentication')
    .controller('AuthenticationController', AuthenticationController);

  /** @ngInject */
  function AuthenticationController($state, $scope) {
    var vm = this;

    vm.state = $state;
    vm.loginLink = loginLink;
    vm.isAuthenticating = false;

    function _extractUtm(source) {
      return angular.isDefined($state.params[source]) ? source + '=' + $state.params[source] + '&' : '';
    }

    $scope.$on("Authentication:ShowSpinner", function (args, data) {
      vm.isAuthenticating = data.isAuthenticating;
    });

    function loginLink() {
      var utms = '#/signup?';
      utms += _extractUtm('utm_source');
      utms += _extractUtm('utm_medium');
      utms += _extractUtm('utm_campaign');
      utms += _extractUtm('utm_term');
      utms += _extractUtm('utm_content');
      return utms.substring(0, utms.length - 1);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.authentication')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {

    //// Translate keys.
    $translateProvider.translations('es', {
      'Login' : {
        'title'                 : 'La solución más completa para hacer realidad la logística que necesitas',
        'login'                 : 'Entrar',
        'login_sso'             : 'Entrar con tu cuenta',
        'login_link'            : '¿Tienes una cuenta?',
        'email'                 : 'Correo electrónico',
        'password'              : 'Contraseña',
        'welcome'               : '¡Hola nuevamente! Por favor ingresa a tu cuenta.',
        'forgotPassword'        : 'Recuperar contraseña',
        'newPasswordInfo'       : 'Te enviaremos un correo electrónico con las instrucciones para crear una nueva contraseña.',
        'termsAndConditions'    : 'Términos y Condiciones',
        'privacyPolicy'         : 'Política de Privacidad',
        'disclaimer'            : 'Al ingresar aceptas los Términos y Condiciones y la Política de Privacidad',
        'send'                  : 'Enviar',
        'cancel'                : 'Cancelar',
        'logout'                : 'Salir',
        'back'                  : 'Volver atrás',
        'signup'                : 'Ingresa a la aplicación',
        'signup_email'          : 'Correo electrónico',
        'signup_passwd'         : 'Contraseña',
        'get_started'           : 'CREA TU CUENTA',
        'wrong_password'        : 'No es posible entrar, revisa las credenciales.',
        'remaining'             : 'No es posible entrar, revisa las credenciales.<br>Te quedan {{attempts}} intentos.',
        'last_try'              : 'No es posible entrar, revisa las credenciales.<br>Te queda un intento.',
        'existing_user'         : 'El usuario ya existe, por favor intenta nuevamente',
        'field_required'        : 'Este campo es requerido',
        'username'              : 'Usuario',
        'reset_message_success' : '',
        'session_expired'       : 'Tu sesión expiró',
        'session_expired_info'  : 'Tu sesión ha sido cerrada por inactividad. Debes volver a iniciar sesión.',
        'to_internal_login'     : 'Entrar con usuario y contraseña',
        'compliance': {
          'badge'         : 'Actualización requerida',
          'title'         : 'Términos, Condiciones y Políticas de Privacidad',
          'subtitle'      : 'Hemos actualizado nuestros documentos legales. Debes revisarlos y aceptarlos para continuar usando la plataforma.',
          'scrollHint'    : 'Desplázate para leer',
          'acceptButton'  : 'Aceptar y continuar',
          'logoutButton'  : 'Cerrar sesión',
          'versionFooter' : 'Versión {{version}} — vigente desde {{effectiveDate}}',
          'errorTitle'    : 'No fue posible registrar tu aceptación',
          'errorMessage'  : 'Inténtalo nuevamente o cierra sesión.',
          'retryButton'   : 'Reintentar'
        }
      },
      'PasswordReset': {
        'incorrect_email'       : 'Email incorrecto',
        'new_password'          : 'Nueva contraseña',
        'repeat_password'       : 'Repetir contraseña',
        'reset_password'        : 'Restablecer la contraseña',
        'error_reset_password'  : 'Solicitud de cambio de contraseña expiró',
        'reset_message_success' : 'En unos minutos recibirás un correo electrónico con las instrucciones para restablecer la contraseña de tu cuenta.',
        'reset_password_message': 'Has cambiado tu contraseña.',
        'too_short_password'    : 'Longitud mínima de 8 caracteres',
        'match_password'        : 'Las contraseñas no coinciden, por favor intenta nuevamente.',
      },
      'Signin': {
        'signin': 'Ingresa a la aplicación',
      },
      'Signup': {
        'quantity'                    : 'Vehículos',
        'quantity_more'               : 'o más vehículos',
        'signup'                      : 'Registrarse',
        'title'                       : 'Comienza hoy a optimizar tus rutas de despacho',
        'title_more_data'             : 'Solo unas preguntas antes de comenzar...',
        'signup_name'                 : 'Nombre completo',
        'message_footer'              : 'Para más información puedes escribirnos a <br><span class="sp-enhance">contacto@simpliroute.com</span>',
        'more_data_company'           : 'Empresa',
        'more_data_country'           : 'País',
        'more_data_unselected_country': 'Debes seleccionar un país',
        'more_data_vehicle'           : 'Cantidad de vehículos',
        'wrong_form'                  : 'Algo falló. Por favor inténtalo nuevamente.',
        'message_reason_li_1'         : 'Obtén toda la información en tiempo real.',
        'message_reason_li_2'         : 'Monitorea todo tu equipo logístico',
        'message_reason_li_3'         : 'Reduce un 30% de tus costos de logística.',
        'message_reason_li_4'         : 'otras 10 razones más.',
        'incorrect_email'             : 'No has ingresado una dirección de correo correcta.',
        'module_interest_tracking'    : 'El seguimiento de mis pedidos en la calle',
        'module_interest_optimizer'   : 'La planificación de mis rutas de entrega.',
        'module_interest_question'    : '¿Qué esperas mejorar con SimpliRoute?',
        'too_short_password'          : 'Longitud mínima de 8 caracteres',
      },
      'Security': {
        'length'                      : 'Longitud mínima de {{length_policy}} caracteres',
        'uppercase'                   : 'Incluir al menos una mayúscula',
        'lowercase'                   : 'Incluir al menos una minúscula',
        'number'                      : 'Incluir al menos un número',
        'symbol'                      : 'Incluir al menos un caracter especial',
      },
      'PasswordRenewal': {
        'title'                 : 'Tu contraseña debe ser actualizada',
        'description'           : 'Tu contraseña ha caducado y debe ser cambiada para poder ingresar.',
        'new_password'          : 'Nueva contraseña',
        'repeat_new_password'   : 'Repite tu nueva contraseña',
        'button'                : 'Cambiar contraseña',
        'success'               : 'Contraseña cambiada exitosamente',
        'error'                 : 'Error cambiando contraseña. Por favor inténtalo nuevamente',
        'match_password'        : 'Las contraseñas no coinciden. Por favor inténtalo nuevamente.'
      },
      'Confirmation': {
        'not_confirmed_title'           :  '¡Estás a un click de comenzar tu demo!',
        'not_confirmed_subject'         :  'Verifica tu correo electrónico',
        'not_confirmed_body'            :  'Te hemos enviado un email. Por favor valida <br> tu correo para activar tu demo de SimpliRoute',
        'not_confirmed_link'            :  'Reenviar correo',
        'not-confirmed-logout'          :  'Ir al login',
        'confirmed_subject'             :  '¡Bienvenido a SimpliRoute!',
        'confirmed_body'                :  'Gracias por activar tu cuenta. Desde <br> hoy puedes comenzar tu prueba <br> gratis de {{trialDays}} días en SimpliRoute',
        'confirmed_loading'             :  'Confirmando cuenta ...',
        'confirmed_link_error'          :  'Estimado usuario, el link de activación es inválido',
        'confirmed_link_error_subject'  :  '¡Oops!',
        'mail_resend'                   :  'Te hemos enviado un nuevo email de validación',
      },
      'AccountSelector': {
        'title'     : 'Escoge una cuenta',
        'select'    : 'Elige una de tus cuentas para ingresar a la plataforma.',
        'go_back'   : 'Volver atrás',
        'enter'     : 'Entrar',
      },
      'UserBlocked': {
        'title'           : 'Tu cuenta ha sido bloqueada',
        'info'            : 'Has superado el máximo de intentos de ingreso.<br>' +
          'Por favor ingresa tu usuario para enviarte un correo y ayudarte a desbloquear tu cuenta. ' +
          'Si no recuerdas tu nombre de usuario, contáctate con el administrador de tu organización.<br>' +
          'En caso de que seas el administrador de tu cuenta, por favor contáctanos a ' +
          '<a href="mailto:soporte@simpliroute.com">soporte@simpliroute.com</a> para ayudarte.',
        'unlock_error'    : 'Ha ocurrido un error, vuelve a intentarlo.',
        'unlock_progress' : '¡Listo! Revisa tu correo',
        'email_sent'      : 'Por favor sigue las instrucciones que ahí se detallan.<br>' +
          'No olvides chequear la carpeta de Spam.<br>' +
          'Si no recibiste el correo contáctanos a ' +
          '<a href="mailto:soporte@simpliroute.com">soporte@simpliroute.com</a> para poder ayudarte.'
      },
      'Logout': {
        'title'     : 'Estamos cerrando tu sesión.'
      },
      'LoginFailed': {
        'title'     : 'Tuvimos un problema iniciando tu sesión.',
        'info'      : 'No hemos podido validar tu usuario. Por favor vuelve a intentarlo.<br>' +
          'Si el error persiste, contáctanos a <a href="mailto:soporte@simpliroute.com">soporte@simpliroute.com</a> para poder ayudarte.'
      },
      'Encryption': {
        'passphrase' : 'Palabra secreta',
        'placeholder': 'Ingresa tu palabra secreta',
        'error'      : 'La palabra secreta es incorrecta',
        'required'   : 'Este campo es obligatorio',
        'button'     : 'Enviar',
        'go_back'    : 'Volver atrás'
      }
    });

    $translateProvider.translations('en', {
      'Login' : {
        'title'                 : 'The most comprehensive solution to achieve the logistics you need',
        'login'                 : 'Log in',
        'login_sso'             : 'Log in using',
        'login_link'            : 'Do you already have an account?',
        'email'                 : 'Email',
        'password'              : 'Password',
        'welcome'               : 'Welcome back. Please log in to your account.',
        'forgotPassword'        : 'Recover password',
        'newPasswordInfo'       : 'We will send you an email with instructions to create a new password.',
        'termsAndConditions'    : 'Terms and Conditions',
        'privacyPolicy'         : 'Privacy Policy',
        'disclaimer'            : 'By entering you accept the Terms and Conditions and the Privacy Policy',
        'send'                  : 'Send',
        'cancel'                : 'Cancel',
        'logout'                : 'Logout',
        'back'                  : 'Back',
        'signup'                : 'Sign up',
        'signup_passwd'         : 'Password',
        'username'              : 'Username',
        'get_started'           : 'CREATE YOUR ACCOUNT',
        'wrong_password'        : 'Unable to login with provided credentials.',
        'remaining'             : 'Unable to login with provided credentials.<br>You have {{attempts}} attempts left.',
        'last_try'              : 'Unable to login with provided credentials.<br>You have an attempt left.',
        'existing_user'         : 'Username already taken, please try again',
        'field_required'        : 'This field is required',
        'message_footer'        : 'For more information you can write us to <br><span class="sp-enhance">contact@simpliroute.com</span>',
        'session_expired'       : 'Your session expired',
        'session_expired_info'  : 'Your session has ended due to inactivity. You must login again.',
        'to_internal_login'     : 'Log in using username and password',
        'compliance': {
          'badge'         : 'Update required',
          'title'         : 'Terms, Conditions and Privacy Policies',
          'subtitle'      : 'We have updated our legal documents. You must review and accept them to continue using the platform.',
          'scrollHint'    : 'Scroll to read',
          'acceptButton'  : 'Accept and continue',
          'logoutButton'  : 'Log out',
          'versionFooter' : 'Version {{version}} — effective {{effectiveDate}}',
          'errorTitle'    : 'We couldn\'t register your acceptance',
          'errorMessage'  : 'Please try again or log out.',
          'retryButton'   : 'Try again'
        }
      },
      'PasswordReset': {
        'email_incorrect'       : 'Incorrect email, please check and try again',
        'new_password'          : 'New password',
        'repeat_password'       : 'Repeat password',
        'reset_password'        : 'Reset password',
        'error_reset_password'  : 'Your request for password change just expired',
        'reset_message_success' : 'You should receive an email shortly with instructions on how to reset your account password.',
        'reset_password_message': 'You have changed your password.',
        'too_short_password'    : 'Minimum length of 8 characters',
        'match_password'        : 'Passwords do not match, please try again.',
      },
      'Signin': {
        'signin': 'Log in'
      },
      'Signup': {
        'signup'                        : 'Sign up',
        'quantity'                      : 'Vehicles',
        'quantity_more'                 : 'or more vehicles',
        'title'                         : 'Start optimizing your <br> delivery routes today',
        'title_more_data'               : 'Just a few more questions...',
        'signup_name'                   : 'Full name',
        'message_footer'                : 'For more information you can write us to <br><span class="sp-enhance">contact@simpliroute.com</span>',
        'more_data_company'             : 'Company',
        'more_data_country'             : 'Country',
        'more_data_unselected_country'  : 'You must select a country',
        'more_data_vehicle'             : 'Number of vehicles',
        'wrong_form'                    : 'Something went wrong. Please try again.',
        'message_reason_li_1'           : 'Get information in real time.',
        'message_reason_li_2'           : 'Visibility of your complete logistics chain.',
        'message_reason_li_3'           : 'Reduce 30% your logistics costs.',
        'message_reason_li_4'           : '10 other reasons.',
        'incorrect_email'               : 'You didn\'t enter a valid email ',
        'module_interest_tracking'      : 'Tracking my operation on the street.',
        'module_interest_optimizer'     : 'Planning my delivery routes.',
        'module_interest_question'      : 'What do you expect to improve with SimpliRoute?',
        'too_short_password'            : 'Minimum length of 8 characters'
      },
      'Security': {
        'length'                      : 'Minimum length of {{length_policy}} characters',
        'uppercase'                   : 'Must include at least one uppercase',
        'lowercase'                   : 'Must include at least one lowercase',
        'number'                      : 'Must include at least one number',
        'symbol'                      : 'Must include at least one special character',
      },
      'PasswordRenewal': {
        'title'                 : 'Your password needs to be updated',
        'description'           : 'Your password has expired and must be changed in order to continue.',
        'new_password'          : 'New password',
        'repeat_new_password'   : 'Repeat your new password',
        'button'                : 'Change password',
        'success'               : 'Password changed successfully',
        'error'                 : 'Password change failed. Please try again',
        'match_password'        : 'Passwords do not match. Please try again.'
      },
      'Confirmation': {
        'not_confirmed_title'           :  'You are one click away from starting your demo!',
        'not_confirmed_subject'         :  'Verify your email',
        'not_confirmed_body'            :  'We have sent you an email. Please validate <br> your account before you can start your SimpliRoute trial',
        'not_confirmed_link'            :  'Resend mail',
        'not-confirmed-logout'          :  'Go to login',
        'confirmed_subject'             :  'Welcome to SimpliRoute!',
        'confirmed_body'                :  'Thank you for activating your account. <br> Starting today you can begin <br> your free {{trialDays}} day trial of SimpliRoute',
        'confirmed_loading'             :  'Confirming account ...',
        'confirmed_link_error'          :  'Dear user, the activation link is invalid',
        'confirmed_link_error_subject'  :  'Oops!',
        'mail_resend'                   :  'We\'ve sent you a new validation email',
      },
      'AccountSelector': {
        'title'   : 'Select account',
        'select'  : 'Choose one of your accounts to access the platform.',
        'go_back' : 'Go back',
        'enter'   : 'Enter',
      },
      'UserBlocked': {
        'title'           : 'Your account has been locked',
        'info'            : 'You have exceeded the maximum login attempts.<br>' +
          'Please enter your user to send you an email and help you to unlock your account. ' +
          'If you do not remember your username, please contact your account administrator.<br>' +
          'But if you are the account administrator, please send an email to ' +
          '<a href="mailto:soporte@simpliroute.com">soporte@simpliroute.com</a> in order to help you.',
        'unlock_error'    : 'An error occurred, please try again.',
        'unlock_progress' : 'Done! Check your email',
        'email_sent'      : 'Please follow the instructions on the email.<br>' +
          'Do not forget to check the spam folder.<br>' +
          'If you don\'t receive the email, contact us to ' +
          '<a href="mailto:soporte@simpliroute.com">soporte@simpliroute.com</a> in order to help you.'
      },
      'Logout': {
        'title'     : 'We are closing your session.'
      },
      'LoginFailed': {
        'title'     : 'We had a problem logging you in.',
        'info'      : 'We were unable to validate your user. Please try again later.<br>' +
          'If this problem persists, contact us at <a href="mailto:soporte@simpliroute.com">soporte@simpliroute.com</a> so we can help you.'
      },
      'Encryption': {
        'passphrase' : 'Passphrase',
        'placeholder': 'Enter your passphrase',
        'error'      : 'Passphrase is incorrect',
        'required'   : 'This field is required',
        'button'     : 'Enter',
        'go_back'    : 'Go back'
      }
    });

    $translateProvider.translations('pt', {
      'Login' : {
        'title'                 : 'A solução mais completa para tornar realidade a logística que você precisa',
        'login'                 : 'Entrar',
        'login_sso'             : 'Acessar usando sua conta',
        'login_link'            : 'Você tem uma conta?',
        'email'                 : 'Correio eletrônico',
        'password'              : 'Senha',
        'welcome'               : 'Bem vindo de volta. Por favor insira sua conta.',
        'forgotPassword'        : 'Recuperar senha',
        'newPasswordInfo'       : 'Enviaremos um e-mail com as instruções para criar uma nova senha.',
        'termsAndConditions'    : 'Termos e condições',
        'privacyPolicy'         : 'Política de privacidade',
        'disclaimer'            : 'Ao entrar estarás aceitando com os Termos e condições e a Política de privacidade',
        'send'                  : 'Mandar',
        'cancel'                : 'Cancelar',
        'logout'                : 'Sair',
        'back'                  : 'Volte',
        'signup'                : 'Efetue login no aplicativo',
        'signup_passwd'         : 'Senha',
        'username'              : 'Usuário',
        'get_started'           : 'CRIAR SEUS CONTA',
        'wrong_password'        : 'Não é possível iniciar a sessão com as credenciais fornecidas.',
        'remaining'             : 'Não é possível iniciar a sessão com as credenciais fornecidas.<br>Você tem {{attempts}} tentativas restantes.',
        'last_try'              : 'Não é possível iniciar a sessão com as credenciais fornecidas.<br>Você tem uma tentativa restante.',
        'existing_user'         : 'Nome de usuário já tomadas, por favor, tente novamente',
        'field_required'        : 'Este campo é obrigatório',
        'message_footer'        : 'Para mais informações escreva-nos para <br> <span class ="sp-enhance">contato@simpliroute.com</span>',
        'session_expired'       : 'Sua sessão expirou',
        'session_expired_info'  : 'Sua sessão foi encerrada devido à inatividade. Você deve fazer o login novamente.',
        'to_internal_login'     : 'Acessar usando sua usuário e senha',
        'compliance': {
          'badge'         : 'Atualização necessária',
          'title'         : 'Termos, Condições e Políticas de Privacidade',
          'subtitle'      : 'Atualizamos nossos documentos legais. Você deve revisá-los e aceitá-los para continuar usando a plataforma.',
          'scrollHint'    : 'Role para ler',
          'acceptButton'  : 'Aceitar e continuar',
          'logoutButton'  : 'Sair',
          'versionFooter' : 'Versão {{version}} — vigente desde {{effectiveDate}}',
          'errorTitle'    : 'Não foi possível registrar sua aceitação',
          'errorMessage'  : 'Tente novamente ou saia da sessão.',
          'retryButton'   : 'Tentar novamente'
        }
      },
      'PasswordReset': {
        'email_incorrect'       : 'Email incorreto, por favor corrigi-lo.',
        'new_password'          : 'Nova sehna',
        'repeat_password'       : 'Repita a senha',
        'reset_password'        : 'Trocar a senha',
        'error_reset_password'  : 'O seu pedido de alteração de senha caducado',
        'reset_message_success' : 'Em breve você receberá um email com instruções para redefinir a senha de sua conta',
        'reset_password_message': 'Você mudou sua senha.',
        'too_short_password'    : 'Comprimento mínimo de 8 caracteres',
        'match_password'        : 'As senhas não correspondem, por favor tente novamente',
      },
      'Signin': {
        'signin': 'Acessar'
      },
      'Signup': {
        'signup'                       : 'Inscrever-se',
        'quantity'                     : 'Veículos',
        'quantity_more'                : 'o más veículos',
        'title'                        : 'Otimize hoje mesmo suas rotas de entregas',
        'title_more_data'              : 'Apenas algumas perguntas antes de começar...',
        'signup_name'                  : 'Nome completo',
        'message_footer'               : 'Para mais informações escreva-nos para <br> <span class ="sp-enhance">contato@simpliroute.com</span>',
        'more_data_company'            : 'Companhia',
        'more_data_country'            : 'País',
        'more_data_unselected_country' : 'Você deve selecionar um país',
        'more_data_vehicle'            : 'Número de veículos',
        'wrong_form'                   : 'Algo está errado. Por favor, tente novamente.',
        'message_reason_li_1'          : 'Obtenha informação em tempo real',
        'message_reason_li_2'          : 'Dê total visibilidade a sua cadeia logística',
        'message_reason_li_3'          : 'Reduza em até 30% seus custos logísticos',
        'message_reason_li_4'          : '10 outras razões.',
        'incorrect_email'              : 'Você não inserir um email válido',
        'module_interest_tracking'     : 'O acompanhamento da minha operação em rota',
        'module_interest_optimizer'    : 'A planificacion de mis rotas de despacho',
        'module_interest_question'     : 'Que espera melhorar com SimpliRoute?',
        'too_short_password'           : 'Comprimento mínimo de 8 caracteres',
      },
      'Security': {
        'length'                      : 'Comprimento mínimo de {{length_policy}} caracteres',
        'uppercase'                   : 'Deve conter pelo menos uma maiúscula',
        'lowercase'                   : 'Deve conter pelo menos uma minúscula',
        'number'                      : 'Deve conter pelo menos um dígito',
        'symbol'                      : 'Deve conter pelo menos um caractere especiais',
      },
      'PasswordRenewal': {
        'title'                 : 'Sua senha precisa ser atualizada',
        'description'           : 'Sua senha expirou e deve ser alterada para que possa continuar.',
        'new_password'          : 'Nova senha',
        'repeat_new_password'   : 'Repetir sua nova senha',
        'button'                : 'Mudar a senha',
        'success'               : 'Senha mudada com sucesso',
        'error'                 : 'Erro ao mudar senha. Por favor, tente novamente',
        'match_password'        : 'As senhas não correspondem. Por favor, tente novamente.'
      },
      'Confirmation': {
        'not_confirmed_title'           :  '¡Você está a um clique de distância da sua demonstração!',
        'not_confirmed_subject'         :  'Verifique seu email',
        'not_confirmed_body'            :  'Enviamos um email para você. Valide seu email <br> para ativar sua demonstração do SimpliRoute',
        'not_confirmed_link'            :  'Reenviar o correio',
        'not-confirmed-logout'          :  'Vá para o login',
        'confirmed_subject'             :  '¡Bem-vindo ao SimpliRoute!',
        'confirmed_body'                :  'Obrigado para ativar sua conta. <br> A partir de hoje você pode começar a sua versão <br> gratuita de {{trialDays}} dias do SimpliRoute',
        'confirmed_loading'             :  'Confirmar conta ...',
        'confirmed_link_error'          :  'Caro usuário, o link de ativação é inválido',
        'confirmed_link_error_subject'  :  '¡Oops!',
        'mail_resend'                   :  'Enviamos um novo email de validação',
      },
      'AccountSelector': {
        'title'   : 'Escolha uma conta',
        'select'  : 'Escolha uma de suas contas para entrar na plataforma.',
        'go_back' : 'Volte',
        'enter'   : 'Entrar',
      },
      'UserBlocked': {
        'title': 'Sua conta foi desativada',
        'info': 'Você esgotou o número máximo de tentativas para fazer login.<br>' +
          'Por favor insira seu nome de usuário para enviar um e-mail com as instruções para desbloquear sua conta. ' +
          'Se vôce esqueceu seu nome de usuário etre em contato com seu administrador.<br>' +
          'Caso seja administrador de sua conta, envie um e-mail para ' +
          '<a href="mailto:soporte@simpliroute.com">soporte@simpliroute.com</a>.',
        'unlock_error': 'Um erro ocorreu, por favor tente novamente.',
        'unlock_progress': 'Pronto! Verifique seu e-mail',
        'email_sent': 'Por favor, siga as instruções no e-mail.<br>' +
          'Não se esqueça de verificar a pasta de correio indesejado.<br>' +
          'Se não receber o e-mail, contacte-nos para ' +
          '<a href="mailto:soporte@simpliroute.com">soporte@simpliroute.com</a> a fim de o ajudar.'
      },
      'Logout': {
        'title'     : 'Estamos encerrando sua sessão.'
      },
      'LoginFailed': {
        'title'     : 'Ocorreu um problema ao iniciar sessão.',
        'info'      : 'Não foi possível verificar seu nome de usuário. Por favor tente novamente mais tarde.<br>' +
          'Se o problema persistir, entre em contato com nossa equipe de suporte em <a href="mailto:soporte@simpliroute.com">soporte@simpliroute.com</a> para ajudá-lo.'
      },
      'Encryption': {
        'passphrase' : 'Palavra secreta',
        'placeholder': 'Digite sua palavra secreta',
        'error'      : 'A palavra secreta está incorreta',
        'required'   : 'Este campo é obrigatório',
        'button'     : 'Submit',
        'go_back'    : 'Volte'
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.assigner')
    .controller('CreatePlanController', CreatePlanController);

  /** @ngInject */
  function CreatePlanController(planData, assignerService, Toasts, $filter, $log, lodash, naturalService,
                                timeUtils, $rootScope, ngDialog) {

    var vm = this;
    var $translate = $filter('translate');

    var vehicles = [];

    vm.rows = [];
    vm.vehiclesWithRoutes = [];
    vm.drivers = [];
    vm.form = {};

    vm.plan = {
      startTime: '',
      name: '',
      plannedDate: ''
    };

    vm.dateOptions = {
      formatYear: 'yyyy',
      formatDayHeader: 'EEE',
      formatDayTitle: 'MMMM',
      formatDay: 'd',
      showWeeks: false,
      maxMode: 'day',
      startingDay: 0
    };
    vm.popupPlanDate = { opened: false };

    vm.openPopupPlanDate = openPopupPlanDate;
    vm.savePlan = savePlan;
    vm.naturalSort = naturalSort;

    activate();

    function activate() {
      vm.plan.name = timeUtils.formatTime(timeUtils.today(), 'DD-MM-YYYY HH:mm:ss');
      vm.plan.plannedDate = timeUtils.today();
      vm.plan.startTime = planData.startTime ? planData.startTime : '';
      vm.rows = planData.rows ? planData.rows : [];
      vehicles = planData.vehicles ? planData.vehicles : [];
      vm.drivers = planData.drivers ? planData.drivers : [];
      vm.vehiclesWithRoutes = getVehiclesWithRoutes(vm.rows, vehicles);
    }

    function naturalSort(field) {
      return function (item) {
        return naturalService.naturalValue(item[field]);
      };
    }

    function addRouteTotalTime(vehicles, groupedRows) {
      return vehicles.map(function(vehicle) {
        vehicle.routeTotalTime = groupedRows[vehicle.id][0].routeTotalTime;
        return vehicle;
      });
    }
    function getVehiclesWithRoutes(rows,vehicles) {
      var groupedRows = lodash.groupBy(rows, 'vehicleId');
      var vehiclesId = Object.keys(groupedRows);
      return addRouteTotalTime(vehicles.filter(function(vehicle) {
        return vehiclesId.indexOf(vehicle.id.toString()) !== -1;
      }), groupedRows);
    }

    function savePlan() {
      $rootScope.isLoading = true;
      var modalParams = {
        type: '',
        msg: ''
      };

      var planData = {
        name: vm.plan.name,
        plannedDate: timeUtils.formatTime(vm.plan.plannedDate, "YYYY-MM-DD")
      };

      var requestData = assignerService.buildRequest(planData, vm.rows, vm.vehiclesWithRoutes);

      assignerService.createPlan(requestData).then(function() {
        modalParams.type = 'success';
        modalParams.msg =  $translate('Assigner.plan_create_success');
      }).catch(function (response) {
        var errorMessageKey = 'Assigner.plan_create_error';
        var regex = /vehicle.*planned_date.*estimated_time_start/g;

        if(response.status === 400 && response.data.hasOwnProperty('non_field_errors') &&
          response.data.non_field_errors[0].match(regex)) {
          errorMessageKey = 'Assigner.plan_create_error_with_busy_vehicles';
        }

        modalParams.type = 'error';
        modalParams.msg =  $translate(errorMessageKey);
      }).finally(function () {
        $rootScope.isLoading = false;
        ngDialog.close();
        Toasts.push(modalParams.type, modalParams.msg);
      });
    }

    function openPopupPlanDate() {
      vm.popupPlanDate.opened = true;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus.assigner')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

    $stateProvider
      .state('assigner', {
        parent: 'main',
        url: '/assigner',
        controller: 'AssignerController',
        controllerAs: 'vm',
        templateUrl: 'app/assigner/assigner.html',
        data:{
          authentication:  true
        }
      });
  }

})();

(function() {
  'use strict';

  angular
    .module('icarus.assigner')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {

    //// Translate keys.
    $translateProvider.translations('es', {
      'Assigner': {
        'section_name': 'Asignador',
        'import_plan': 'Importar plan',
        'plan_create_success': 'El plan ha sido creado',
        'plan_create_error': 'Un error ha ocurrido creando el plan',
        'plan_create_error_with_busy_vehicles': 'Uno de tus vehículos ya tiene rutas en este horario',
        'plan_name': 'Nombre del plan',
        'plan_date': 'Fecha del plan',
        'plan_time': 'Hora del plan',
        'no_visits': 'No existen visitas',
        'may_use_this': 'Puedes usar esta',
        'sample_template': 'plantilla de ejemplo',
        'or': 'ó',
        'vehicle_table_header': 'Vehículo',
        'driver_table_header': 'Conductor',
        'duration_table_header': 'Duración',
        'save_plan': 'Guardar plan',
        'departure_time': 'Hora de salida',
        'confirm': 'Confirmar',
        'save': 'Guardar',
        'plan_generate_error': 'Un error ha ocurrido generando el plan',
        'no_vehicles': 'No tienes vehículos creados',
        'click_here_to_create': 'Haz click aquí para crear tu primer vehículo',
        'create_vehicle': 'Nuevo vehículo',
        'load_visits_file': 'Carga un archivo con visitas',
        'routes_will_appear_here': 'y tus rutas aparecerán aquí',
        'delete_confirmation_title': 'Borrar visitas',
        'delete_confirmation_continue': '¿Deseas continuar?',
        'delete_confirmation_cancel': 'Cancelar',
        'delete_confirmation_delete': 'Borrar',
        'btn_filter_all_visits': 'Todas',
        'btn_filter_not_assigned': 'Sin asignar',
        'dropdown_assign_to': 'Asignar a',
        'out_of_route': 'Fuera de ruta',
        'empty_visits': 'Todas sus visitas están asignadas a un vehículo'
      }
    });

    $translateProvider.translations('en', {
      'Assigner': {
        'section_name': 'Assigner',
        'import_plan': 'Import plan',
        'plan_create_success': 'The plan has been created',
        'plan_create_error': 'An error has occurred creating the plan',
        'plan_create_error_with_busy_vehicles': 'One of your vehicles already has routes in this schedule',
        'plan_name': 'Plan name',
        'plan_date': 'Plan date',
        'plan_time': 'Plan time',
        'no_visits': 'No visits yet',
        'may_use_this': 'You may use this',
        'sample_template': 'sample_template',
        'or': 'or',
        'vehicle_table_header': 'Vehicle',
        'driver_table_header': 'Driver',
        'duration_table_header': 'Duration',
        'save_plan': 'Save plan',
        'departure_time': 'Time of departure',
        'confirm': 'Confirm',
        'save': 'Save',
        'plan_generate_error': 'An error occurred while generating the plan',
        'no_vehicles': 'You do not have vehicles created yet',
        'click_here_to_create': 'Click here to create your first vehicle',
        'create_vehicle': 'New vehicle',
        'load_visits_file': 'Load a file with visits',
        'routes_will_appear_here': 'and your routes will appear here',
        'delete_confirmation_title': 'Delete visits',
        'delete_confirmation_continue': 'Do you want to continue?',
        'delete_confirmation_cancel': 'Cancel',
        'delete_confirmation_delete': 'Delete',
        'btn_filter_all_visits': 'All',
        'btn_filter_not_assigned': 'Not assigned',
        'dropdown_assign_to': 'Assign to',
        'out_of_route': 'Out of route',
        'empty_visits': 'All your visits are assigned to a vehicle'
      }
    });

    $translateProvider.translations('pt', {
      'Assigner': {
        'section_name': 'Designador',
        'import_plan': 'Importar plano',
        'plan_create_success': 'O plano foi criado',
        'plan_create_error': 'Ocorreu um erro ao criar o plano',
        'plan_create_error_with_busy_vehicles': 'Um dos seus veículos já possui rotas nesta programação',
        'plan_name': 'Nome do plano',
        'plan_date': 'Data do plano',
        'plan_time': 'Hora do plano',
        'no_visits': 'Sem visitas ainda',
        'may_use_this': 'Você pode usar este',
        'sample_template': 'modelo de exemplo',
        'or': 'ou',
        'vehicle_table_header': 'Veículo',
        'driver_table_header': 'Motorista',
        'duration_table_header': 'Duração',
        'save_plan': 'Salvar plano',
        'departure_time': 'Tempo de partida',
        'confirm': 'Confirme',
        'save': 'Salvar',
        'plan_generate_error': 'Ocorreu um erro ao gerar o plano',
        'no_vehicles': 'Você não tem veículos criados',
        'click_here_to_create': 'Clique aqui para criar seu primeiro veículo',
        'create_vehicle': 'Novo veículo',
        'load_visits_file': 'Carregar um arquivo com visitas',
        'routes_will_appear_here': 'e suas rotas aparecerão aqui',
        'delete_confirmation_title': 'Eliminar visitas',
        'delete_confirmation_continue': 'Você deseja continuar?',
        'delete_confirmation_cancel': 'Cancelar',
        'delete_confirmation_delete': 'Eliminar',
        'btn_filter_all_visits': 'Todas',
        'btn_filter_not_assigned': 'Não designado',
        'dropdown_assign_to': 'Designar a',
        'out_of_route': 'Fora da rota',
        'empty_visits': 'Todas as suas visitas são designadas a um veículo'
      }
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus.assigner')
    .controller('AssignerController', AssignerController);

  /** @ngInject */
  function AssignerController(
    assignerService, plannerService, sessionService, $rootScope, Toasts, $filter, timeUtils, ngDialog, $q,
    DEFAULT_SHIFT_START
  ) {
    var vm = this;
    var optimizationOptions = {};
    var $translate = $filter('translate');

    var downloadLinks = {
      'en' : '../../../../assets/sample-templates/assigner_en.xlsx',
      'es' : '../../../../assets/sample-templates/assigner_es.xlsx',
      'pt' : '../../../../assets/sample-templates/assigner_pt.xlsx'
    };

    vm.visitsWithNoRoutes = [];
    vm.allVisits = [];
    vm.planStartTime =  DEFAULT_SHIFT_START;
    vm.createPlanDisabled = true;
    vm.importExcelDisabled = true;
    vm.filterNotAssignedVisits = false;
    vm.vehicles = [];
    vm.vehiclesWithRoutes = [];

    vm.drivers = [];
    vm.assignerTableData = [];
    vm.routesTableData = [];
    vm.form = {};
    vm.assignerTableOptions = {
      columns: [
        {name: 'id', field: 'id'},
        {name: 'Título', field: 'title'},
        {name: 'Dirección', field: 'address'},
        {name: 'Vehículo', field: 'vehicle'}],
      search: '',
      pagination: {
        pageSize: 15,
        maxSize: 5
      }
    };

    vm.data = {
      label: $translate('Assigner.import_plan'),
      keys: ['vehicle', 'title', 'address', 'latitude', 'longitude', 'reference', 'notes', 'contact_name', 'contact_phone', 'contact_email'],
      onImport: importExcelData,
      onError: notifyError
    };

    vm.loader = {
      value: 0,
      max: 100,
      text: '',
      show: false
    };

    vm.onVisitsProgress = onVisitsProgress;
    vm.onCalculateTime = onCalculateTime;
    vm.hasVisitData = hasVisitData;
    vm.getTemplateDownloadLink = getTemplateDownloadLink;
    vm.openSaveModal = openSaveModal;
    vm.openResetDataModal = openResetDataModal;
    vm.setNotAssignedVisitsFilter = setNotAssignedVisitsFilter;
    vm.selectVisit = selectVisit;
    vm.assignTo = assignTo;

    activate();

    function activate() {
      assignerService.listVehicles().then(function(list) {
        vm.vehicles = list;
        vm.importExcelDisabled = vm.vehicles.length === 0;
      });
      assignerService.listDrivers().then(function(list) {
        vm.drivers = list;
      });
      optimizationOptions = plannerService.getOptimizationOptions();

      var userInfo = sessionService.getUser();
      vm.accountCountry = userInfo.$$state.value.country;
      vm.accountGeocoderQualityLevel = userInfo.$$state.value.geocoder_quality_level;
    }

    function hasVisitData() {
      return vm.allVisits.length > 0;
    }

    function getLocale() {
      var regEx = /(es|en|pt)/g;
      var result =  regEx.exec($rootScope.$locale);
      return result ? result[0] : 'en';
    }

    function getTemplateDownloadLink() {
      var language = getLocale();
      return downloadLinks[language];
    }

    function filterNotAssignedVisits(rows) {
      return rows.filter(function(row) {
        return row.vehicleId === -1;
      });
    }

    function filterAssignedVisits(rows) {
      return rows.filter(function(row) {
        return row.vehicleId !== -1;
      });
    }

    function importExcelData(rows) {
      vm.loader.show = true;
      assignerService.prepareRowsAndFilterVehicles(vm.planStartTime, rows, vm.vehicles,
        vm.onVisitsProgress, vm.onCalculateTime, vm.accountCountry, vm.accountGeocoderQualityLevel)
        .then(function(response) {
          vm.allVisits = response.data;
          vm.assignerTableData = vm.allVisits;
          vm.routesTableData = filterAssignedVisits(response.data);
          vm.visitsWithNoRoutes = filterNotAssignedVisits(response.data);
          vm.vehiclesWithRoutes = response.vehicles;
          vm.createPlanDisabled = false;
        })
        .catch(function (error) {
          notifyError(error);
          vm.assignerTableData = [];
        })
        .finally(function() {
          vm.loader.show = false;
        });
    }

    function notifyError() {
      Toasts.push('error', $translate('Assigner.plan_generate_error'));
    }

    function onVisitsProgress(state) {
      vm.loader.value = state.progress;
      vm.loader.max = state.total;
    }

    function onCalculateTime(action) {
      vm.loader.text = action === 'started' ? 'Calculando tiempos y distancias...' : '';
    }

    function openSaveModal() {
      var visitsAssigned = vm.allVisits.filter(function(visit) {return visit.vehicleId !== -1;});
      ngDialog.open({
        template: 'app/assigner/create-plan.modal.html',
        controller: 'CreatePlanController',
        controllerAs: 'vm',
        className: 'ngdialog-theme-default custom-width-600 zone-modal',
        resolve: {
          planData: function () {
            return {
              startTime: vm.planStartTime,
              rows: visitsAssigned,
              vehicles: vm.vehiclesWithRoutes,
              drivers: vm.drivers
            };
          }
        }
      });
    }

    function resetData() {
      vm.planStartTime = DEFAULT_SHIFT_START;
      vm.createPlanDisabled = true;
      vm.assignerTableData = [];
      vm.allVisits = [];
      vm.routesTableData = [];
      vm.visitsWithNoRoutes = [];
      vm.vehiclesWithRoutes = [];
      vm.filterNotAssignedVisits = false;
    }

    function openResetDataModal() {
      ngDialog.openConfirm({
        template: 'app/assigner/reset-plan-data.modal.html'
      }).then(function () {
        resetData();
      });
    }

    function setNotAssignedVisitsFilter(value) {
      vm.filterNotAssignedVisits = value;
      value ? vm.assignerTableData = vm.visitsWithNoRoutes : vm.assignerTableData = vm.allVisits;
    }

    function selectVisit(visitId, selected) {
      var visitIndex = vm.allVisits.findIndex(function(visit) {
        return visit.id === visitId;
      });

      var visitWithoutRouteIndex = vm.visitsWithNoRoutes.findIndex(function(visit) {
        return visit.id === visitId;
      });

      if (visitIndex !== -1) {
        vm.allVisits[visitIndex].selected = selected;
      }
      if (visitWithoutRouteIndex !== -1) {
        vm.visitsWithNoRoutes[visitWithoutRouteIndex].selected =  selected;
      }
    }

    function assignTo(vehicle) {
      var vehicles = vehicle.id !== - 1 ? [vehicle] : [];
      var calculateTimesPromises = [];
      var previousStates = [];

      var visitsSelected = vm.allVisits.filter(function(data) {
        return data.selected && data.vehicleId !== vehicle.id;
      });

      visitsSelected.forEach(function(visit) {
        var vehicle = vm.vehicles.find(function(vehicle) {return vehicle.id === visit.vehicleId;});
        if (vehicle && vehicles.indexOf(vehicle) === -1) {
           vehicles.push(vehicle);
        }
      });

      vm.allVisits.forEach(function(visit) {
        var selectedVisit = visitsSelected.find(function(visitSelected) {
          return visitSelected.id === visit.id;
        });

        if(selectedVisit) {
          previousStates.push(angular.copy(selectedVisit));
          visit.vehicleId = vehicle.id;
          visit.vehicle = vehicle.name;
        }
        visit.selected = false;
      });

      vehicles.forEach(function(vehicleUsed) {
        var vehicleVisits = vm.allVisits.filter(function(visit) {return visit.vehicleId === vehicleUsed.id;});
        if(vehicleUsed.id === vehicle.id) {
          var startPoint = vehicleVisits.length - visitsSelected.length;

          vehicleVisits.forEach(function(visit) {
            var selected = visitsSelected.find(function(selected) {return selected.id === visit.id;});
            if (selected) {
              visit.order = ++startPoint;
            }
          });

          vehicleVisits.sort(function(a, b) {
            return a.order > b.order ? 1 : (a.order < b.order ? -1 : 0);
          });
        }else {
          vehicleVisits.sort(function(a, b) {
            return a.order > b.order ? 1 : (a.order < b.order ? -1 : 0);
          });

          vehicleVisits.forEach(function(visit, i) {
            visit.order = i + 1;
          });
        }

        calculateTimesPromises.push(assignerService.calculateTimes(vm.planStartTime, vehicleUsed, vehicleVisits));
      });

      $q.all(calculateTimesPromises).then(function(visitsMatrixWithTimes) {
          var visitsWithTimes = visitsMatrixWithTimes.reduce(function(prev, current) {
            return prev.concat(current);
            }, []);

          vm.allVisits.forEach(function(visit) {
            var selectedVisit = visitsWithTimes.find(function(visitWithTime) {
              return visitWithTime.id === visit.id;
            });

            if (selectedVisit) {
              angular.extend(visit, selectedVisit);
            }
          });
        })
        .catch(function(error) {
          // Undo assignation
          vm.allVisits.forEach(function(visit) {
            var selectedVisit = previousStates.find(function(previousVisitState) {
              return previousVisitState.id === visit.id;
            });

            if (selectedVisit) {
              angular.extend(visit, selectedVisit);
            }
          });
        })
        .finally(function() {
          var newVehicle = vm.vehiclesWithRoutes.find(function(v) {return v.id === vehicle.id;});

          if( !newVehicle && vehicle.id !== -1) {
            vm.vehiclesWithRoutes.push(vehicle);
          }
          vm.visitsWithNoRoutes = filterNotAssignedVisits(vm.allVisits);
          vm.routesTableData = filterAssignedVisits(vm.allVisits);
          vm.assignerTableData = vm.filterNotAssignedVisits ? angular.copy(vm.visitsWithNoRoutes) : angular.copy(vm.allVisits);
        });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('icarus')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

    $stateProvider
      .state('addons', {
        parent: 'main',
        url: '/addons',
        controller: 'AddonsController',
        controllerAs: 'vm',
        templateUrl: 'app/addons/addons.html',
        data:{
          authentication:  true
        }
      })
      .state('addons.checkout-sms', {
        url: '/checkout-sms',
        views: {
          "viewForm@addons": {
            controller: 'CheckoutSmsController',
            controllerAs: 'vm',
            templateUrl: 'app/addons/sms/checkout-sms.html'
          }
        }
      })
      .state('addons.email', {
        url: '/email',
        views: {
          "viewForm@addons": {
            templateUrl: 'app/addons/email/email.html'
          }
        }
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('icarus')
    .config(config);

  /** @ngInject */
  function config($translateProvider) {

    //// Translate keys.
    $translateProvider.translations('es', {
      'Addons'           : {
        'title': 'Complementos',
        'options': 'Opciones',
        'selection': 'Selección',
        'option_name': {
          'checkout_sms': 'Checkout SMS'
        }
      },
      'checkout_sms' : {
        'btn_save': 'Guardar',
        'title': 'Mensaje SMS',
        'description': 'Mensaje que estará en el cuerpo del SMS',
        'success_message': 'El contenido de tu mensaje ha sido guardado exitosamente',
        'without_option_sms': 'Tu cuenta no tiene opción de envío de SMS, por favor comunícate con el equipo de soporte.',
        'error_save_sms': 'Ha ocurrido un error guardando tu mensaje, por favor intenta nuevamente.'
      }

    });
    $translateProvider.translations('en', {
      'Addons'           : {
        'title': 'Addons',
        'options': 'Options',
        'selection': 'Selection',
        'option_name': {
          'checkout_sms': 'SMS Checkout'
        }
      },
      'checkout_sms' : {
        'btn_save': 'Save',
        'title': 'SMS Message',
        'description': 'Message that will be in the SMS body',
        'success_message': 'The content of your message has been successfully saved.',
        'without_option_sms': 'Your account does not have an SMS feature, please contact the support team.',
        'error_save_sms': 'An error has occurred saving your message, please try again.'
      }

    });
    $translateProvider.translations('pt', {
      'Addons'           : {
        'title': 'Complementos',
        'options': 'Options',
        'selection': 'Selección',
        'option_name': {
          'checkout_sms': 'Checkout SMS'
        }
      },
      'checkout_sms' : {
        'btn_save': 'Salvar',
        'title': 'mensagem SMS',
        'description': 'Mensagem que estará no corpo do SMS',
        'success_message': 'O conteúdo da sua mensagem foi salvo com sucesso',
        'without_option_sms': 'A sua conta não tem opção envio de SMS, entre em contato com a equipe de suporte.',
        'error_save_sms': 'Ocorreu  um erro ao salvar a sua mensagem, por favor, tente novamente.'
      }

    });
  }

})();

(function(){
  'use strict';

  angular
    .module('icarus')
    .controller('AddonsController', AddonsController);

  /** @ngInject */
  function  AddonsController($state) {

    var vm = this;
    vm.addonsOptions = {
      sms_checkout: {value: false, view: '.sms-checkout'}
    };

    vm.activeView = activeView;
    activate();

    ////////////

    function activate() {
    }

    function activeView(val) {
      $state.go(val.view);
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .run(run);

  /** @ngInject */
  function run($log, $rootScope, $filter, $state, $window, __env, Toasts,
               plannerService, sessionService, moduleHelpersService,
               DATA_ENCRYPTION_ADD_ON_KEY, PASSPHRASE_IDENTIFIER, addonsService,
               apolloAuthService, store, ROUTE_STATES, modulesPermissionService,
               notFoundPageService, $q, accountConfigsService, rdMigrationOptinService) {

    var $translation = $filter('translate');

    $rootScope.online = navigator.onLine;
    $window.addEventListener("offline", function () {
      $rootScope.$apply(function () {
        $rootScope.online = false;
        Toasts.push('error', $translation('Toast.error_connection_internet'));
      });
    }, false);

    $window.addEventListener("online", function () {
      $rootScope.$apply(function () {
        $rootScope.online = true;
      });
    }, false);

    $rootScope.$locale = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);
    $rootScope.$on('$stateChangeStart', stateChangeStartHandler);
    $rootScope.$on('$stateChangeSuccess', function (_event, to, _toParams, from) {
      $rootScope.previousStateObj = from;
      if(from.name === 'planner.routes-detail' && to.name !== 'planner.routes-detail') {
        $rootScope.$broadcast('Planner:MSOMC:CLEAR_DRAWING_MANAGER');
      }
    });

    function stateChangeStartHandler(event, toState, toParams, fromState, fromParams) {
      var mustUSeGeolocation = !toState.name.includes('planner');
      activate(mustUSeGeolocation);

      if (!toState.data.authentication) {
        return;
      }

      if (toState.retryInProgress) {
        toState.retryInProgress = false;
        return;
      }

      // Post-login gates (compliance modal) not cleared yet: an in-memory
      // token exists but hasn't been persisted. Block any navigation to
      // authenticated states; the modal flow will $state.go explicitly once
      // persistAuth() runs. Without this, deep-linking via the URL bar
      // (e.g. /#/planner/vehicles) would bypass the modal.
      if (sessionService.hasPendingAuth()) {
        event.preventDefault();
        return;
      }

      // Cancelar transicion hasta que se resuelva la promesa
      event.preventDefault();

      sessionService.getUser()
        .then(function (user) {
          if (!user) {
            throw 'No user!.';
          }

          if (user.account.status === "registered") {
            $state.go("auth.account-not-confirmed");
            return;
          }

          return $q.all({
            enablePlans: accountConfigsService.getConfigByKey("enable_plans"),
            enableRouteDesigner: accountConfigsService.getConfigByKey("enable_route_designer"),
            enableAssigner: accountConfigsService.getConfigByKey("enable_assigner"),
            enableSettingsModuleForRouterUser: accountConfigsService.getConfigByKey("enable_settings_module_for_router_user"),
            isEncryptionAddOnEnabled: addonsService.isAddonEnable(DATA_ENCRYPTION_ADD_ON_KEY),
            enableLiveTracking: addonsService.isAddonEnable("live_tracking"),
            hasApolloRdAccess: rdMigrationOptinService.hasApolloRdAccess(user.id)
          })
            .then(function (results) {
              if (results.isEncryptionAddOnEnabled && !store.get(PASSPHRASE_IDENTIFIER)) {
                $state.go("auth.encryption-passphrase");
                return;
              }

              if (user.account.status === "canceled") {
                $window.location.href = apolloAuthService.buildRedirectURL(moduleHelpersService.getCurrentLanguage() + "/profile");
                return;
              }

              var currentLanguage = moduleHelpersService.getCurrentLanguage();

              var modulesPermissionProps = _getModulesPermissionProps(user, results);

              if (toState.name.indexOf(ROUTE_STATES.PLANS) === 0) {
                var isPlansSubModuleAvailable = modulesPermissionService.isPlansSubModuleAvailable(modulesPermissionProps);
                _showNotFoundPage(!isPlansSubModuleAvailable);
                toState.retryInProgress = true;
                if (isPlansSubModuleAvailable) {
                  var nextStatePlans = toState.redirectTo || toState;
                  $state.go(nextStatePlans, toParams, {location: "replace"});
                } else {
                  $state.go(toState, toParams, {location: "replace"});
                }

                return;
              }

              if (toState.name.indexOf(ROUTE_STATES.PLANNER) === 0) {
                if (results.hasApolloRdAccess) {
                  $window.location.href = apolloAuthService.buildRedirectURL(currentLanguage + "/pathfinder/planner");
                  return;
                }

                var isPlannerSubModuleAvailable = modulesPermissionService.isPlannerSubModuleAvailable(modulesPermissionProps);
                _showNotFoundPage(!isPlannerSubModuleAvailable);
                toState.retryInProgress = true;
                if (isPlannerSubModuleAvailable) {
                  var nextStatePlanner = toState.redirectTo || toState;
                  $state.go(nextStatePlanner, toParams, {location: "replace"});
                } else {
                  $state.go(toState, toParams, {location: "replace"});
                }

                return;
              }

              if (toState.name.indexOf(ROUTE_STATES.ASSIGNER) === 0) {
                var isAssignerSubModuleAvailable = modulesPermissionService.isAssignerSubModuleAvailable(modulesPermissionProps);
                _showNotFoundPage(!isAssignerSubModuleAvailable);
                toState.retryInProgress = true;
                if (isAssignerSubModuleAvailable) {
                  var nextStateAssigner = toState.redirectTo || toState;
                  $state.go(nextStateAssigner, toParams, {location: "replace"});
                } else {
                  $state.go(toState, toParams, {location: "replace"});
                }

                return;
              }

              if (toState.name.indexOf(ROUTE_STATES.SETTINGS_ACCOUNT) === 0) {
                var isCustomizationModuleAvailable = (
                  modulesPermissionService.isSettingsModuleAvailable(modulesPermissionProps) &&
                  modulesPermissionService.isCustomizationModuleAvailable(modulesPermissionProps)
                );
                _showNotFoundPage(!isCustomizationModuleAvailable);
                toState.retryInProgress = true;
                if (isCustomizationModuleAvailable) {
                  var nextStateSettingsAccount = toState.redirectTo || toState;
                  $state.go(nextStateSettingsAccount, toParams, {location: "replace"});
                } else {
                  $state.go(toState, toParams, {location: "replace"});
                }

                return;
              }

              if (
                toState.name.indexOf(ROUTE_STATES.DOCUMENTS) === 0 ||
                toState.name.indexOf(ROUTE_STATES.SIMPLI_PLANNER) === 0 ||
                toState.name.indexOf(ROUTE_STATES.TRANSPORTATION_PROVIDER_PAYMENT) === 0 ||
                toState.name.indexOf(ROUTE_STATES.AUTH) === 0
              ) {
                _showNotFoundPage(false);
                toState.retryInProgress = true;
                var nextState = toState.redirectTo || toState;
                $state.go(nextState, toParams, {location: "replace"});
                return;
              }

              if (toState.name.indexOf(ROUTE_STATES.CHAT) === 0) {
                $window.location.href = apolloAuthService.buildRedirectURL(currentLanguage + "/chat");
                return;
              }

              if (toState.name.indexOf(ROUTE_STATES.DASHBOARD) === 0) {
                $window.location.href = apolloAuthService.buildRedirectURL(currentLanguage + "/reports");
                return;
              }

              if (toState.name.indexOf(ROUTE_STATES.EXTENSIONS) === 0) {
                $window.location.href = apolloAuthService.buildRedirectURL(currentLanguage + "/extensions");
                return;
              }

              if (toState.name.indexOf(ROUTE_STATES.SETTINGS) === 0) {
                $window.location.href = apolloAuthService.buildRedirectURL(currentLanguage + "/settings/users");
                return;
              }

              if (toState.name.indexOf(ROUTE_STATES.SETTINGS_COMMUNICATION) === 0) {
                $window.location.href = apolloAuthService.buildRedirectURL(currentLanguage + "/settings/communication");
                return;
              }

               if (toState.name.indexOf(ROUTE_STATES.TRACKING) === 0) {
                $window.location.href = apolloAuthService.buildRedirectURL(currentLanguage + "/tracking");
                return;
              }

              if (toState.name.indexOf(ROUTE_STATES.PROFILE) === 0) {
                $window.location.href = apolloAuthService.buildRedirectURL(currentLanguage + "/profile");
                return;
              }

              // Show the 404 page by default if the route does not match any predefined states.
              _showNotFoundPage(true);
              toState.retryInProgress = true;
              $state.go(toState, toParams, {location: "replace"});
            });
        })
        .catch(function (error) {
          $log.info(error);
          if (__env.USE_SSO_AS_MAIN_SCREEN && __env.DEFAULT_SSO_DOMAIN) {
            $state.go('auth.sso-login');
          } else {
            $state.go('auth.login');
          }
        });

      if (fromState.name.includes("vehicles") && toState.name.includes('routes')) {
        plannerService.getPlan()
          .then(function (data) {
            if (data.visits.length === 0) {
              event.preventDefault();
              $state.go(fromState, fromParams);
            }
          })
          .catch(function () {
            $rootScope.isLoading = false;
          });
      }
    }

    function checkGeolocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          $rootScope.mapInitCoord = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          };

          $rootScope.$broadcast('positionNavigator');
        }, function (error) {
          $log.log(error);
        });
      }
    }

    function activate(mustUSeGeolocation) {
      if (mustUSeGeolocation) {
        checkGeolocation();
      }
    }

    function _showNotFoundPage(showNotFoundPageStatus) {
      notFoundPageService.setNotFoundPageStatus(showNotFoundPageStatus);
      $rootScope.$broadcast("Main:showNotFoundPage", {
        showNotFoundPage: showNotFoundPageStatus
      });
    }

    function _getModulesPermissionProps(user, results) {
      return {
        user: user,
        userHasAdminPermissions: user.is_owner || user.is_admin,
        userHasRouterAndRouterJrPermissions: user.is_owner || user.is_admin || user.is_router || user.is_router_jr,
        enablePlans: results.enablePlans,
        enableRouteDesigner: results.enableRouteDesigner,
        enableAssigner: results.enableAssigner,
        enableSettingsModuleForRouterUser: results.enableSettingsModuleForRouterUser,
        enableLiveTracking: results.enableLiveTracking
      };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {

    $stateProvider
      .state('main', {
        abstract: true,
        url: '',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'vm',
        resolve: {
          translateAdwordsGoogle: function ($translate) {
            window.translateAdwords = $translate.use();
          },
          configs: ['sessionService', function (sessionService){
            return sessionService.getAccountConfigs();
          }]
        }
      });

    $urlRouterProvider.otherwise( function($injector, $location) {
      var $state = $injector.get("$state");
      $state.go("planner.vehicles-list");
    });

  }

})();

/* moment:false, _:false,  XLSX:false, tinycolor:false */
(function () {
  'use strict';

  var CLEANER_CONFIG = {};

  if (window) {
    Object.assign(CLEANER_CONFIG, window.CLEANER_CONFIG);
  }


  angular
    .module('icarus')
    .constant("CLEANER_CONFIG", CLEANER_CONFIG)
    .constant('tinycolor', tinycolor)
    .constant('moment', moment)
    .constant('lodash', _)
    .constant('XLSX', XLSX)
    .constant("AMOUNT_PER_VEHICLE", 44)
    .constant("DEFAULT_SHIFT_START", "09:00")
    .constant("DEFAULT_SHIFT_END", "17:00")
    .constant("ROUTE_TRACKING_URL", "http://web.simpliroute.com/#/estadoActual")
    .constant("DATE_FORMAT", "YYYY-MM-DD")
    .constant('IMAGES_MARKER_PATH', '../../assets/images/marker/')
    .constant('IMAGES_BORDERLESS_MARKER_PATH', '../../assets/images/marker/borderless/')
    .constant('IMAGES_BIG_MARKER_PATH', '../../assets/images/big-marker/')
    .constant('IMAGES_BORDERLESS_BIG_MARKER_PATH', '../../assets/images/big-marker/borderless/')
    .constant('PRIORITY_LEVELS', [
      {
        'label_name' : 'first_of_day',
        'value': 1
      },
      {
        'label_name' : 'last_of_route',
        'value': 2
      },
      {
        'label_name' : 'high_priority',
        'value': 3
      },
      {
        'label_name' : 'medium_priority',
        'value': 4
      },
      {
        'label_name' : 'low_priority',
        'value': 5
      },
      {
        'label_name' : 'end-of-route-pickup',
        'value': 12
      }
    ])
    .constant('MAP_OPTIONS', {
        "center": {
          "longitude": -70.6072,
          "latitude": -33.4217454
        },
        "control" : {},
        "options":{
          "zoom": 11,
          "zoomControl": true,
          "scaleControl": true,
          "streetViewControl": false,
          "mapTypeControlOptions": {
            "position": 3,
            "style": 1
          },
          "styles":
            [{
              "featureType": "landscape.man_made",
              "elementType": "geometry",
              "stylers": [{
                "color": "#f7f1df"
              }]
            }, {
              "featureType": "landscape.natural",
              "elementType": "geometry",
              "stylers": [{
                "color": "#d0e3b4"
              }]
            }, {
              "featureType": "landscape.natural.terrain",
              "elementType": "geometry",
              "stylers": [{
                "visibility": "off"
              }]
            }, {
              "featureType": "poi",
              "elementType": "labels",
              "stylers": [{
                "visibility": "on"
              }]
            }, {
              "featureType": "poi.business",
              "elementType": "all",
              "stylers": [{
                "visibility": "off"
              }]
            }, {
              "featureType": "poi.medical",
              "elementType": "geometry",
              "stylers": [{
                "color": "#fbd3da"
              }]
            }, {
              "featureType": "poi.park",
              "elementType": "geometry",
              "stylers": [{
                "color": "#bde6ab"
              }]
            }, {
              "featureType": "road",
              "elementType": "geometry.stroke",
              "stylers": [{
                "visibility": "off"
              }]
            }, {
              "featureType": "road",
              "elementType": "labels",
              "stylers": [{
                "visibility": "on"
              }]
            }, {
              "featureType": "road.highway",
              "elementType": "geometry.fill",
              "stylers": [{
                "color": "#ffe15f"
              }]
            }, {
              "featureType": "road.highway",
              "elementType": "geometry.stroke",
              "stylers": [{
                "color": "#efd151"
              }]
            }, {
              "featureType": "road.arterial",
              "elementType": "geometry.fill",
              "stylers": [{
                "color": "#ffffff"
              }]
            }, {
              "featureType": "road.local",
              "elementType": "geometry.fill",
              "stylers": [{
                "color": "white"
              }]
            }, {
              "featureType": "transit.station.airport",
              "elementType": "geometry.fill",
              "stylers": [{
                "color": "#cfb2db"
              }]
            }, {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [{
                "color": "#a2daf2"
              }]
            }]
        }
      })
    .constant('JOINED_EMAILS_MAX_LENGTH', 815)
    .constant('MAX_EMAILS_INPUT', 10)
    .constant('MAX_PREVIEW_EMAILS_INPUT', 2)
    .constant('OSRMStatus', {
      NO_ROUTES_BETWEEN_POINTS: 207,
      FOUND_ROUTE_BETWEEN_POINTS: 0
    })
    .constant('ALLOWED_SECTIONS_FOR', {
      'coordinator': ['plans', 'uprofile', 'login', 'chat', 'extensions'],
      'monitor': ['tracking', 'uprofile', 'dashboard', 'login', 'chat', 'extensions'],
      'monitor_coordinator': ['plans', 'tracking', 'uprofile', 'dashboard', 'login', 'chat', 'extensions'],
      'router': ['tracking', 'uprofile', 'dashboard', 'assigner', 'login', 'planner', 'chat', 'extensions', 'simpliPlanner',
                 'documents', 'transportation_provider_payment'],
      'router_jr': ['tracking', 'uprofile', 'dashboard', 'assigner', 'login', 'planner', 'chat', 'extensions']
    })
    .constant('ACCOUNT_CONFIGS', {
      'MULTI_DAY_ROUTES': 'enable_multi_day_routes',
      'HIGH_DEMAND_ROUTE_DESIGNER': 'high_demand_route_designer',
      'CONFIGS': 'accountConfigs',
      'ENABLE_VISITS_OUT_OF_ROUTE_FILTER': 'enable_visits_out_of_route_filter',
      'ENABLE_EXTENSIONS_MODULE': 'enable_extensions_module',
      'CUSTOM_ROUTE_NAME': 'custom_route_name',
      'ENABLE_MULTI_DRIVERS': 'enable_multi_drivers',
      'ENABLE_COLORS_FOR_CONTIGUOUS_ROUTES': 'enable_colors_for_contiguous_routes',
      'MAP_PROVIDER': 'map_provider',
      'ENABLE_LOAD_BALANCE': 'enable_load_balance',
      'ENABLE_ROUTES_GROUP_MARKERS': 'enable_routes_group_markers',
      'ENABLE_TIME_BALANCE': 'enable_time_balance',
      'TRACKING_MAP_PROVIDER': 'tracking_map_provider',
      'ZONE_MAP_PROVIDER': 'zone_map_provider',
      'BORDERLESS_MARKERS': 'borderless_markers',
      'ENABLE_BIG_MARKER_IN_ROUTE_DESIGNER': 'enable_big_marker_in_route_designer',
      'DISABLE_EXTERNAL_DASHBOARDS': 'disable_external_dashboards',
      'SEND_GPS': 'send_gps',
      'ENABLE_OBSERVATIONS': 'enable_observations',
      'MAX_DISTANCE': 'max_distance',
      'VEHICLE_REFILL_TIME': 'vehicle_refill_time',
      'ETA_RANGE_SCHEDULED_VISIT': 'eta_range_scheduled_visit',
      'ETA_RANGE_VISIT_WITH_ROUTE_STARTED': 'eta_range_visit_with_route_started',
      'ETA_RANGE_VISIT_ON_ITS_WAY': 'eta_range_visit_on_its_way',
      'INCREMENTAL_ROUTING': 'incremental_routing',
      'AUTOCOMPLETE_PROVIDER': 'autocomplete_provider',
      'ENABLE_HIDING_VISIT_NOTES': 'enable_hiding_visit_notes',
      'STREETS_IN_BETWEEN_PDF_SUMMARY': 'streets_in_between_pdf_summary',
      'ENABLE_MANAGE_VISIT_ITEMS': 'enable_manage_visit_items',
      'ENABLE_ORDER_BY_VISIBILITY': 'enable_order_by_visibility',
      'ENABLE_PICKUP_AND_DELIVERY_MODE': 'enable_pickup_and_delivery_mode',
      'ENABLE_PLAN_STATUS': 'enable_plan_status',
      'ENABLE_FLEETS': 'enable_fleets',
      'ENABLE_RADIAL_ROUTING': 'enable_radial_routing',
      'ENABLE_SETTINGS_MODULE_FOR_ROUTER_USER': 'enable_settings_module_for_router_user',
      'ENABLE_MULTIPLE_ACTIVE_ROUTES': 'enable_multiple_active_routes',
      'AVOID_END_ROUTE_PENDING_VISITS': 'avoid_end_route_pending_visits',
      'DISABLE_DUPLICATION_PLAN': 'disable_plan_duplication',
      'ENABLE_CHECKOUT_STATUS_PDF': 'enable_checkout_status_pdf',
      'ENABLE_CLIENTS_MODULE': 'enable_clients_module',
      'DISABLE_EDIT_FOR_ACTIVE_AND_FINISHED_ROUTES': 'disable_edit_for_active_and_finished_routes',
      'ENABLE_SAFETY_MODE': 'enable_safety_mode',
      'MULTI_RESULTS': 'multi_results',
      'GEOCODER_PROVIDER': 'geocoder_provider',
      'ENABLE_ENHANCED_SAFETY_MODE': 'enable_enhanced_safety_mode',
      'CAN_CREATE_CO_DRIVER': 'can_create_co_driver',
      'ENABLE_ORGANIZATION_SYNC_SERVICE': "enable_organization_sync_service",
      'ENABLE_VISIT_ITEMS': 'enable_visit_items'
    })
    .constant("SLIDER_TIME_STEPS", [
      { value: "00:00" },
      { value: "00:30" },
      { value: "01:00" },
      { value: "01:30" },
      { value: "02:00" },
      { value: "02:30" },
      { value: "03:00" },
      { value: "03:30" },
      { value: "04:00" },
      { value: "04:30" },
      { value: "05:00" },
      { value: "05:30" },
      { value: "06:00" },
      { value: "06:30" },
      { value: "07:00" },
      { value: "07:30" },
      { value: "08:00" },
      { value: "08:30" },
      { value: "09:00" },
      { value: "09:30" },
      { value: "10:00" },
      { value: "10:30" },
      { value: "11:00" },
      { value: "11:30" },
      { value: "12:00" },
      { value: "12:30" },
      { value: "13:00" },
      { value: "13:30" },
      { value: "14:00" },
      { value: "14:30" },
      { value: "15:00" },
      { value: "15:30" },
      { value: "16:00" },
      { value: "16:30" },
      { value: "17:00" },
      { value: "17:30" },
      { value: "18:00" },
      { value: "18:30" },
      { value: "19:00" },
      { value: "19:30" },
      { value: "20:00" },
      { value: "20:30" },
      { value: "21:00" },
      { value: "21:30" },
      { value: "22:00" },
      { value: "22:30" },
      { value: "23:00" },
      { value: "23:59" },
    ])
    .constant("ACCOUNT_STATUS", {
      ACTIVE: "active",
      TRIALING: "trialing",
      CANCELED: "canceled",
      PAST_DUE: "past_due"
    })
    .constant("HTTP_STATUS_CODE", {
      BAD_REQUEST: 400,
      NOT_FOUND: 404,
      CONFLICT: 409
    })
    .constant("CACHE_KEYS", {
      CACHE_ADDONS_KEY: 'addons',
      CACHE_DELIVERY_ISSUE: 'delivery_issue'
    })
    .constant("COUNTRIES_BY_CODE_ISO_ALPHA_3", {
      AX:	'ALA',
      AL:	'ALB',
      DZ:	'DZA',
      AS:	'ASM',
      AD:	'AND',
      AO:	'AGO',
      AI:	'AIA',
      AQ:	'ATA',
      AG:	'ATG',
      AR:	'ARG',
      AM:	'ARM',
      AW:	'ABW',
      AU:	'AUS',
      AT:	'AUT',
      AZ:	'AZE',
      BS:	'BHS',
      BH:	'BHR',
      BD:	'BGD',
      BB:	'BRB',
      BY:	'BLR',
      BE:	'BEL',
      BZ:	'BLZ',
      BJ:	'BEN',
      BM:	'BMU',
      BT:	'BTN',
      BO:	'BOL',
      BQ:	'BES',
      BA:	'BIH',
      BW:	'BWA',
      BV:	'BVT',
      BR:	'BRA',
      IO:	'IOT',
      BN:	'BRN',
      BG:	'BGR',
      BF:	'BFA',
      BI:	'BDI',
      CV:	'CPV',
      KH:	'KHM',
      CM:	'CMR',
      CA:	'CAN',
      KY:	'CYM',
      CF:	'CAF',
      TD:	'TCD',
      CL:	'CHL',
      CN:	'CHN',
      CX:	'CXR',
      CC:	'CCK',
      CO:	'COL',
      KM:	'COM',
      CG:	'COG',
      CD:	'COD',
      CK:	'COK',
      CR:	'CRI',
      CI:	'CIV',
      HR:	'HRV',
      CU:	'CUB',
      CW:	'CUW',
      CY:	'CYP',
      CZ:	'CZE',
      DK:	'DNK',
      DJ:	'DJI',
      DM:	'DMA',
      DO:	'DOM',
      EC:	'ECU',
      EG:	'EGY',
      SV:	'SLV',
      GQ:	'GNQ',
      ER:	'ERI',
      EE:	'EST',
      SZ:	'SWZ',
      ET:	'ETH',
      FK:	'FLK',
      FO:	'FRO',
      FJ:	'FJI',
      FI:	'FIN',
      FR:	'FRA',
      GF:	'GUF',
      PF:	'PYF',
      TF:	'ATF',
      GA:	'GAB',
      GM:	'GMB',
      GE:	'GEO',
      DE:	'DEU',
      GH:	'GHA',
      GI:	'GIB',
      GR:	'GRC',
      GL:	'GRL',
      GD:	'GRD',
      GP:	'GLP',
      GU:	'GUM',
      GT:	'GTM',
      GG:	'GGY',
      GN:	'GIN',
      GW:	'GNB',
      GY:	'GUY',
      HT:	'HTI',
      HM:	'HMD',
      VA:	'VAT',
      HN:	'HND',
      HK:	'HKG',
      HU:	'HUN',
      IS:	'ISL',
      IN:	'IND',
      ID:	'IDN',
      IR:	'IRN',
      IQ:	'IRQ',
      IE:	'IRL',
      IM:	'IMN',
      IL:	'ISR',
      IT:	'ITA',
      JM:	'JAM',
      JP:	'JPN',
      JE:	'JEY',
      JO:	'JOR',
      KZ:	'KAZ',
      KE:	'KEN',
      KI:	'KIR',
      KP:	'PRK',
      KR:	'KOR',
      KW:	'KWT',
      KG:	'KGZ',
      LA:	'LAO',
      LV:	'LVA',
      LB:	'LBN',
      LS:	'LSO',
      LR:	'LBR',
      LY:	'LBY',
      LI:	'LIE',
      LT:	'LTU',
      LU:	'LUX',
      MO:	'MAC',
      MG:	'MDG',
      MW:	'MWI',
      MY:	'MYS',
      MV:	'MDV',
      ML:	'MLI',
      MT:	'MLT',
      MH:	'MHL',
      MQ:	'MTQ',
      MR:	'MRT',
      MU:	'MUS',
      YT:	'MYT',
      MX:	'MEX',
      FM:	'FSM',
      MD:	'MDA',
      MC:	'MCO',
      MN:	'MNG',
      ME:	'MNE',
      MS:	'MSR',
      MA:	'MAR',
      MZ:	'MOZ',
      MM:	'MMR',
      NA:	'NAM',
      NR:	'NRU',
      NP:	'NPL',
      NL:	'NLD',
      NC:	'NCL',
      NZ:	'NZL',
      NI:	'NIC',
      NE:	'NER',
      NG:	'NGA',
      NU:	'NIU',
      NF:	'NFK',
      MK:	'MKD',
      MP:	'MNP',
      NO:	'NOR',
      OM:	'OMN',
      PK:	'PAK',
      PW:	'PLW',
      PS:	'PSE',
      PA:	'PAN',
      PG:	'PNG',
      PY:	'PRY',
      PE:	'PER',
      PH:	'PHL',
      PN:	'PCN',
      PL:	'POL',
      PT:	'PRT',
      PR:	'PRI',
      QA:	'QAT',
      RE:	'REU',
      RO:	'ROU',
      RU:	'RUS',
      RW:	'RWA',
      BL:	'BLM',
      SH:	'SHN',
      KN:	'KNA',
      LC:	'LCA',
      MF:	'MAF',
      PM:	'SPM',
      VC:	'VCT',
      WS:	'WSM',
      SM:	'SMR',
      ST:	'STP',
      SA:	'SAU',
      SN:	'SEN',
      RS:	'SRB',
      SC:	'SYC',
      SL:	'SLE',
      SG:	'SGP',
      SX:	'SXM',
      SK:	'SVK',
      SI:	'SVN',
      SB:	'SLB',
      SO:	'SOM',
      ZA:	'ZAF',
      GS:	'SGS',
      SS:	'SSD',
      ES:	'ESP',
      LK:	'LKA',
      SD:	'SDN',
      SR:	'SUR',
      SJ:	'SJM',
      SE:	'SWE',
      CH:	'CHE',
      SY:	'SYR',
      TW:	'TWN',
      TJ:	'TJK',
      TZ:	'TZA',
      TH:	'THA',
      TL:	'TLS',
      TG:	'TGO',
      TK:	'TKL',
      TO:	'TON',
      TT:	'TTO',
      TN:	'TUN',
      TR:	'TUR',
      TM:	'TKM',
      TC:	'TCA',
      TV:	'TUV',
      UG:	'UGA',
      UA:	'UKR',
      AE:	'ARE',
      GB:	'GBR',
      US:	'USA',
      UM:	'UMI',
      UY:	'URY',
      UZ:	'UZB',
      VU:	'VUT',
      VE:	'VEN',
      VN:	'VNM',
      VG:	'VGB',
      VI:	'VIR',
      WF:	'WLF',
      EH:	'ESH',
      YE:	'YEM',
      ZM:	'ZMB',
      ZW:	'ZWE'
    })
    .constant('CURSOR_CSS_PROPERTY', {
      'DEFAULT': 'default',
      'POINTER': 'pointer'
    })
    .constant("STATES", {
      PLANS: "plans",
      TRACKING: "tracking",
      VEHICLES_LIST: "planner.vehicles-list",
      PROFILE: "uprofile.info",
      ACCOUNT_SELECTOR: "auth.account-selector",
      ASSIGNER: "assigner",
      COMMUNICATION_LIST: "settings.communication.list",
      ACCOUNT_LIST: "settings.account.list"
    })
    .constant('WEB_EVENTS', {
      'STEP2_ARRIVAL': 'step2_arrival',
      'PLAN_CREATED': 'plan_created',
      'PLAN_EDITED': 'plan_edited',
      'PLAN_SAVED': 'plan_saved',
      'PLAN_FAILED': 'plan_failed',
      'MULTIVRP_SELECTED': 'multivrp_selected',
    });
})();

(function() {
  'use strict';

  angular
    .module('icarus')
    .config(config)
    .config(['$provide', Decorate])
    .config(configTranslate)
    .config(['$provide', configQAllSelected])
    .config(configStripe)
    .config(['KeepaliveProvider', 'IdleProvider', '__env', configIdleModule])
    .config(['TitleProvider', configTitleModule]);

  /** @ngInject */
  function config(moment) {

    var locale = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);
    if (locale.indexOf('en') === -1 && locale.indexOf('es') === -1 && locale.indexOf('pt') === -1) {
      locale = 'en';
    }
    moment.locale(locale);
  }

  /** @ngInject */
  function Decorate($provide) { // Usado solo en el calendario.
    $provide.decorator('$locale', function ($delegate) {
      var value = $delegate.DATETIME_FORMATS;

      value.SHORTDAY = ["S","M","T","W","T","F","S"];

      return $delegate;
    });
  }

  /** @ngInject */
  function configTranslate ($logProvider, $translateProvider) {

    $translateProvider.useSanitizeValueStrategy('escaped');

    var langMap = {'en-AU': 'en','en-BZ': 'en','en-CA': 'en','en-GB': 'en',
                  'en-IE': 'en','en-IN': 'en','en-JM': 'en','en-MY': 'en',
                  'en-NZ': 'en','en-PH': 'en','en-SG': 'en','en-TT': 'en',
                  'en-US': 'en','en-ZA': 'en','en-ZW': 'en','es_ES': 'es',
                  'es_CA': 'es','es_MX': 'es','es_CL': 'es','es-CO': 'es',
                  'es-CR': 'es','es-DO': 'es','es-EC': 'es','es-ES': 'es',
                  'es-GT': 'es','es-HN': 'es','es-MX': 'es','es-NI': 'es',
                  'es-PA': 'es','es-PE': 'es','es-PR': 'es','es-PY': 'es',
                  'es-SV': 'es','es-US': 'es','es-UY': 'es','es-VE': 'es',
                  'pt-BR': 'pt','pt-PT': 'pt'
    };

    $translateProvider
    .registerAvailableLanguageKeys(['en', 'es', 'pt'], langMap)
    .determinePreferredLanguage()
    .fallbackLanguage(['en']);
  }

  /** @ngInject */
  function configStripe (stripeProvider, __env) {
    stripeProvider.setPublishableKey(__env.STRIPE_KEY);
  }


  /** @ngInject */
  function configQAllSelected ($provide) {
    $provide.decorator("$q", function ($delegate) {
      function allSettled(promises) {
        var deferred = $delegate.defer(),
            counter = 0,
            results = angular.isArray(promises) ? [] : {};

        angular.forEach(promises, function(promise, key) {
          counter++;
          $delegate.when(promise).then(function(value) {
            if (results.hasOwnProperty(key)) return;
            results[key] = { status: "fulfilled", value: value };
            if (!(--counter)) deferred.resolve(results);
          }, function(reason) {
            if (results.hasOwnProperty(key)) return;
            results[key] = { status: "rejected", reason: reason };
            if (!(--counter)) deferred.resolve(results);
          });
        });

        if (counter === 0) {
          deferred.resolve(results);
        }

        return deferred.promise;
      }
      $delegate.allSettled = allSettled;
      return $delegate;
    });
  }

  /** @ngInject */
  function configIdleModule (KeepaliveProvider, IdleProvider, __env) {
    // Set up Idle settings and default timeouts
    IdleProvider.autoResume('notIdle');
    IdleProvider.idle(__env.DEFAULT_IDLE_TIMEOUT * 60 || 3420);
    IdleProvider.timeout(__env.DEFAULT_IDLE_WARNING_FOR_LOGOUT * 60 || 180);
  }

  /** @ngInject */
  function configTitleModule(TitleProvider) {
    // Disable timer in Title
    TitleProvider.enabled(false);
  }


})();

(function () {
  'use strict';

  angular
    .module('icarus')
    .constant("__env", {
  API_URL: "https://api.simpliroute.com/v1/",
  APIV2_URL: "https://api.simpliroute.com/v2/",
  API_TRACK_URL: "https://api.simpliroute.com/v1/",
  ADA_CHAT_URL: "https://ada-qa.simpliroute.com",
  ADA_CHAT_URL_INITIATION_URL: "https://www.unpkg.com/ada-chat-initiation-script@1.0.1/index.js",
  VRP_URL: "https://optimizer-beta.simpliroute.com/",
  OSRM_URL: "https://api.simpliroute.com/",
  OSRM_PROXY_URL: "https://api.simpliroute.com/",
  OSRM_VIAROUTE_URL: "https://api.simpliroute.com/viaroute",
  OSRM_VIAROUTE_COUNT: 0,
  SIMPLI_CHAT_URL: "https://chat.simpliroute.com/",
  GOOGLE_MAP_OPTIONS: "/app/shared/map-options/google.json",
  HERE_MAP_OPTIONS: "/app/shared/map-options/here.json",
  DEFAULT_BATCH: 10,
  DEFAULT_BATCH_GEOCODER_SERVICE: 500,
  GEOCODING_MAX_PARALLEL_REQUESTS: 6,
  SLEEP_BETWEEN_GEOCODING_REQUESTS_MS: 500,
  APP_MOBILE_GOOGLEPLAY_LINK: "https://play.google.com/store/apps/details?id=com.simpliroute.helios&hl=en",
  APP_MOBILE_APPSTORE_LINK: "https://apps.apple.com/us/app/simpliroute/id1347906594",
  STRIPE_KEY: "pk_live_haOwloDycRIxm3zzqilir8Gc",
  GOOGLE_MAPS_KEY: "AIzaSyB8B04MTIk7abJDVESr6SUF6f3Hgt1DPAY",
  GIT_COMMIT: "-",
  GOOGLE_MAPS_KEY_PAY: "AIzaSyB8B04MTIk7abJDVESr6SUF6f3Hgt1DPAY",
  GOOGLE_MAPS_SECRET_KEY_PAY: "uIIvNS3nnafm8zbIQ2tFgFY9MnA=",
  IP_SERVICE_URL: "https://ipapi.co/json/",
  TOGGLES: {"REPORT_VISIT_HISTORY":false},
  APP_INTERCOM_KEY: "rt4s7wnc",
  ENABLE_INTERCOM: false,
  URL_ROOT: "https://beta.simpliroute.com/",
  LIVE_TRACKING_URL: "https://livetracking.simpliroute.com/",
  TRACKING_REFRESH_TIME: 180,
  VISIT_TIME_CALC_URL: "https://api.simpliroute.com/vtc",
  VISIT_TIME_CALC_URL_COUNT: 0,
  GRAPH_COLORER_URL: "https://us-central1-misc-integrations.cloudfunctions.net/graph-colorer",
  ROUTER_MS_URL: "https://api.simpliroute.com/router/",
  BASE_URL_NEW_GEOCODER: "https://us-central1-geocoding-265816.cloudfunctions.net/",
  NEW_GEOCODER_PATH: "geocoder_dev",
  NEW_GPS_RENDERER: true,
  DEFAULT_ACCURACY_MIN_VALUE: 30,
  GPS_ACCURACY_MIN_VALUES: {still: 30,on_foot: 40,running: 50,on_bicycle: 70,in_vehicle: 100},
  enableDebug: true,
  ACCOUNT_TRIAL_DAYS: 7,
  GRECAPTCHA_KEY: "6Lfe27sfAAAAAB9Jre259Jso4DrWiH5U05DO4kPT",
  DEFAULT_MIN_PASSWORD_LENGTH: 8,
  DEFAULT_IDLE_TIMEOUT: 57,
  DEFAULT_IDLE_WARNING_FOR_LOGOUT: 3,
  LOCAL_PLAN_AUTOSAVE_EXPIRATION_MINUTES: 720,
  USE_SSO_AS_MAIN_SCREEN: false,
  DEFAULT_SSO_DOMAIN: "",
  ALLOW_INTERNAL_LOGIN: false,
  MAX_TIME_SERVICE_VALUE: 999999,
  APOLLO_REDIRECT_URI: "https://app3-beta.simpliroute.com/api/auth/callback/simpliroute",
  APOLLO_URI: "https://app3-beta.simpliroute.com/",
  HERE_MAPS_KEY: "Dha4EtInlZw2tAonEc-b8Izu8Jcx6NbvzBhSWwAA9HI",
  DEFAULT_NAME_OF_VEHICLE_MAP_PROVIDER: "here",
  DEFAULT_NAME_OF_TRACKING_MAP_PROVIDER: "here",
  DEFAULT_NAME_OF_ZONE_MAP_PROVIDER: "here",
  ENABLE_VISITS_MODULE_FEATURE: true,
  RETOOL_URL: "https://simpliroute.tryretool.com/embedded/public/",
  ENABLE_EXTERNAL_DASHBOARDS_FEATURE: false,
  VISUALIZE_VISIT_ITEMS: true,
  TERRITORY_PLANNER_ENV: "prod",
  FEATURE_STORE_API_URL: "https://api.simpliroute.com/feature-store-api/v1/",
  LOCAL_PLAN_SAVE_PENDING_EXPIRATION_MINUTES: 4320
});

})();

(function () {
    'use strict';

    angular
      .module('icarus')
      .service('allowedSectionsService', allowedSectionsService);

    function allowedSectionsService() {
      var allowedSections = {
        'coordinator': ['plans', 'uprofile', 'login', 'chat', 'extensions'],
        'monitor': ['tracking', 'uprofile', 'dashboard', 'login', 'chat', 'extensions'],
        'monitor_coordinator': ['plans', 'tracking', 'uprofile', 'dashboard', 'login', 'chat', 'extensions'],
        'router': ['tracking', 'uprofile', 'dashboard', 'assigner', 'login', 'planner', 'chat', 'extensions', 'simpliPlanner', 'documents', 'transportation_provider_payment'],
        'router_jr': ['tracking', 'uprofile', 'dashboard', 'assigner', 'login', 'planner', 'chat', 'extensions'],
        'seller': ['extensions'],
        'is_seller_viewer': ['extensions']
      };

      function getAllowedSections() {
        return allowedSections;
      }

      function updateAllowedSections(role, sections) {
        allowedSections[role] = sections;
      }

      return {
        getAllowedSections: getAllowedSections,
        updateAllowedSections: updateAllowedSections
      };
    }
  })();

angular.module("icarus").run(["$templateCache", function($templateCache) {$templateCache.put("app/addons/addons.html","<div class=sp-addons-container><div class=sp-addons-headers><span translate=Addons.title></span></div><div class=\"row sp-addons-body\"><div class=\"col-md-4 sp-addons-form-right\"><div ui-view=viewForm></div></div></div></div>");
$templateCache.put("app/assigner/assigner.html","<div class=sp-assigner-container><sp-car-loader show=vm.loader.show value=vm.loader.value max=vm.loader.max>{{vm.loader.text}}</sp-car-loader><div class=\"sp-assigner-header sp-header-title\"><span translate=Assigner.section_name></span></div><div class=notifications-section><p ng-if=\"vm.form.time.$error.pattern && vm.form.time.$dirty \" class=sp-settings-invalid-help-block translate=Visits.error_format_date></p></div><div class=sp-assigner-content><div class=tables-container><div class=sp-assigner-table-container><div class=inputs-container><div class=left-section><div class=assigner-form><form class=sp-form name=vm.form><div class=form-group><label class=control-label translate=Assigner.plan_time></label><input type=text class=form-control name=time ng-model=vm.planStartTime ng-required=true pattern=(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]></div></form></div><div class=assigner-search-table><i class=sp-icon-search></i> <input type=text ng-model=vm.assignerTableOptions.search></div></div><div class=right-section><div class=actions-buttons><button class=btn ng-class=\"[{\'button-active\': !vm.filterNotAssignedVisits}, {\'button-deactivated\': vm.filterNotAssignedVisits}]\" ng-click=vm.setNotAssignedVisitsFilter(false)><span translate=Assigner.btn_filter_all_visits></span></button> <button class=btn ng-class=\"[{\'button-active\': vm.filterNotAssignedVisits}, {\'button-deactivated\': !vm.filterNotAssignedVisits}]\" ng-click=vm.setNotAssignedVisitsFilter(true)><span translate=Assigner.btn_filter_not_assigned></span></button></div><div class=select-vehicle-dropdown uib-dropdown><div class=\"form-control sp-select-box\" uib-dropdown-toggle><span translate=Assigner.dropdown_assign_to></span> <i class=sp-icon-triangle-down></i></div><ul class=\"dropdown-menu dropdown-scrollable\" uib-dropdown-menu role=menu><li class=sp-dropdown-menu-item role=menuitem ng-click=\"vm.assignTo({id: -1, name: \'no-vehicle\'})\"><div class=sp-circle-option ng-style=\"{\'border\': \'none\', \'background-color\': \'grey\' }\"></div><a class=sp-name-option href=\"\"><span translate=Assigner.out_of_route></span></a></li><li class=sp-dropdown-menu-item role=menuitem ng-repeat=\"vehicle in vm.vehicles\" ng-click=vm.assignTo(vehicle)><div class=sp-circle-option ng-style=\"{\'border\': \'none\', \'background-color\': vehicle.color }\"></div><a class=sp-name-option href=\"\">{{vehicle.name}}</a></li></ul></div><div class=delete-icon ng-if=vm.hasVisitData()><a class=\"btn btn-link sp-delete\" ng-click=vm.openResetDataModal() href=\"\"><i class=sp-icon-delete></i></a></div></div></div><div class=no-visits ng-if=!vm.hasVisitData()><i class=sp-icon-map-pin></i> <span class=no-visits-msg translate=Assigner.no_visits></span><import-excel-button data=vm.data disabled></import-excel-button><span translate=Assigner.or></span><div class=download-template-msg><span translate=Assigner.may_use_this></span> <a ng-href={{vm.getTemplateDownloadLink()}}><span translate=Assigner.sample_template></span></a></div></div><assigner-table ng-if=vm.hasVisitData() data=vm.assignerTableData options=vm.assignerTableOptions on-check=vm.selectVisit></assigner-table></div><div class=routes-table-container><div class=inputs-container></div><routes-table data=vm.routesTableData vehicles=vm.vehiclesWithRoutes total-vehicles=vm.vehicles.length></routes-table><div class=save-btn-container><button type=button class=\"btn btn-success\" ng-click=vm.openSaveModal() ng-disabled=vm.createPlanDisabled><span translate=Assigner.save></span></button></div></div></div></div></div>");
$templateCache.put("app/assigner/create-plan.modal.html","<div class=sp-create-plan-modal><div class=sp-modal-content><div class=\"modal-header modal-header-info\"><h3 class=modal-title translate=Assigner.save_plan></h3></div><div class=modal-body><form class=sp-form name=vm.form><div class=form-inputs><div class=col-sm-7><div class=form-group><div class=row><label class=control-label translate=Assigner.plan_name></label></div><div class=row><input type=text class=form-control name=title ng-model=vm.plan.name ng-required=true></div></div></div><div class=col-sm-4><div class=form-group><div class=row><label class=control-label translate=Assigner.plan_date></label></div><div class=\"row sp-block-relative sp-plan-date-input\"><input type=text class=form-control name=date uib-datepicker-popup=dd-MM-yyyy ng-model=vm.plan.plannedDate ng-required=true is-open=vm.popupPlanDate.opened datepicker-options=vm.dateOptions popup-placement=right-top show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-plan-date\" ng-click=vm.openPopupPlanDate()><span class=sp-icon-calendario></span></button></span></div></div></div></div></form><div class=assigner-vehicle-list><div class=\"vehicle-row header\"><div class=\"cell vehicle\" translate=Assigner.vehicle_table_header></div><div class=\"cell driver\" translate=Assigner.driver_table_header></div><div class=\"cell time\" translate=Assigner.duration_table_header></div></div><div class=vehicle-row ng-repeat=\"vehicle in vm.vehiclesWithRoutes\"><div class=\"cell vehicle\"><span class=color-circle ng-style=\"{\'background-color\': vehicle.color}\"></span> {{vehicle.name}}</div><div class=\"cell driver\"><select class=\"form-control sp-select-box\" name=driver ng-model=vehicle.default_driver value={{driver.id}} ng-change=vm.testChange() ng-options=\"driver.id as driver.name for driver in vm.drivers | orderBy:vm.naturalSort(\'name\'):false\"><option value=\"\" translate=Routes.select_driver selected></option></select></div><div class=\"cell time\">{{vehicle.routeTotalTime}} <small class=sp-xx-small-text>HRS</small></div></div></div><hr></div><div class=sp-modal-buttons><div class=plan-date-container><div class=plan-date-title translate=Assigner.departure_time></div><div class=plan-date-info>{{vm.plan.startTime}}</div></div><div class=save-btn-container><button type=button class=\"btn sp-btn-default\" ng-click=vm.savePlan()><span translate=Assigner.confirm></span></button></div></div></div></div>");
$templateCache.put("app/assigner/reset-plan-data.modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Assigner.delete_confirmation_title></h3></div><div class=modal-body><p style=\"text-align: center\"><span translate=Assigner.delete_confirmation_continue></span></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog() translate=Assigner.delete_confirmation_cancel></button> <button type=button class=\"btn btn-danger\" ng-click=confirm() translate=Assigner.delete_confirmation_delete></button></div></div>");
$templateCache.put("app/authentication/authentication.html","<div class=sp-loader ng-class=\"[{\'display-hidden\': !vm.isAuthenticating}, {\'display-block\': vm.isAuthenticating}]\"><img src=/assets/images/loading.gif width=180 height=180></div><div class=\"row sp-auth-container\" ng-class=\"[{\'display-hidden\': vm.isAuthenticating}, {\'display-block\': !vm.isAuthenticating}]\"><div class=row><div class=\"col-md-5 sp-auth-header\"><img src=../../assets/images/logo_oficial.svg class=\"img-responsive sp-auth-logo\" alt=\"Responsive image\"></div></div><div ui-view class=row></div></div>");
$templateCache.put("app/dashboard/dashboard.html","<div class=sp-dashboard-container><div class=sp-dashboard-header><span translate=Dashboard.reports></span></div><div class=sp-dashboard-content><ul class=sp-dashboard-tab><li ng-if=\"!vm.enableExternalDashboardFeature || (vm.enableExternalDashboardFeature && vm.disableExternalDashboards)\" class=tab ng-class=\"{\'active\': vm.state.includes(\'**.visits-graphics.**\')}\"><a ui-sref=dashboard.visits-graphics translate=Dashboard.Visits.title></a></li><li ng-if=\"vm.enableExternalDashboardFeature && !vm.disableExternalDashboards\" class=tab ng-class=\"{\'active\': vm.state.includes(\'**.external.**\') && vm.state.params.dashboardId === vm.visitDashboard }\"><a ui-sref=\"dashboard.external({ dashboardId: vm.visitDashboard })\" translate=Dashboard.Visits.title></a></li><li ng-if=\"vm.enableExternalDashboardFeature && !vm.disableExternalDashboards\" class=tab ng-class=\"{\'active\': vm.state.includes(\'**.external.**\') && vm.state.params.dashboardId === vm.driverPerformanceDashboard }\"><a ui-sref=\"dashboard.external({ dashboardId: vm.driverPerformanceDashboard })\" translate=Dashboard.ExternalDashboard.driverPerformance></a></li><li ng-if=\"vm.enableExternalDashboardFeature && !vm.disableExternalDashboards\" class=tab ng-class=\"{\'active\': vm.state.includes(\'**.external.**\') && vm.state.params.dashboardId === vm.routePerformanceDashboard }\"><a ui-sref=\"dashboard.external({ dashboardId: vm.routePerformanceDashboard })\" translate=Dashboard.ExternalDashboard.routePerformance></a></li><li class=tab ng-class=\"{\'active\': vm.state.includes(\'**.reports.**\')}\"><a ui-sref=dashboard.reports translate=Dashboard.Reports.title></a></li></ul></div><div class=sp-dashboard-tab-content ui-view></div></div>");
$templateCache.put("app/chat/chat.html","<div ui-view class=sp-chat-map-container><div class=iframe-embed-container><iframe-directive site-url={{vm.chatUrl}}></iframe-directive></div></div>");
$templateCache.put("app/extensions/extensions.html","<div ui-view class=sp-extensions-map-container><ul class=\"nav nav-tabs extensions\"><li role=presentation ng-repeat=\"tab in vm.tabs\" ng-class=\"{true:[\'active\']}[$index===vm.selectedExtension]\"><a ng-click=vm.showExtension($index)>{{ tab.label }}</a></li></ul><div ng-repeat=\"tab in vm.tabs\" class=\"iframe-extension iframe-embed-container\"><iframe-directive ng-if=\"$index===vm.selectedExtension\" site-url={{vm.extensionUrl}}></iframe-directive></div></div>");
$templateCache.put("app/documents/documents.html","<div ui-view class=sp-documents><iframe-directive class=sp-module-extension site-url={{vm.url}}></iframe-directive></div>");
$templateCache.put("app/planner/planner.html","<div class=sp-planner-with-banner><rd-migration-banner></rd-migration-banner><div class=sp-planner-layout><div class=sp-planner-content ui-view=left-planner></div><div class=sp-planner-content-overlay ng-if=\"vm.state.includes(\'*.vehicles-list.plans\') || vm.state.includes(\'*.vehicles-list.plans-draft\') || vm.state.includes(\'*.vehicles-list.plans-detail\')\"></div><div class=\"sp-planner-map-container bg-map-container\"><div class=\"row sp-planner-map-header\"><div class=\"col-sm-5 sp-planner-plan\"><div class=sp-planner-plan-info ng-if=\"vm.state.includes(\'*.visits-list\') || vm.state.includes(\'*.visits-create\')\n         || vm.state.includes(\'*.visits-detail\') || vm.state.includes(\'*.routes\')\n         || vm.state.includes(\'*.routes-detail\') || vm.editingPlan.status\"><div class=info><div class=title><p translate=Planner.planned_date></p></div><div class=body-info>{{vm.planDate}}</div></div><div class=info ng-if=vm.editingPlan.status><div class=title><span translate=Planner.editing_plan></span></div><div class=body-info>{{vm.planName}}</div></div></div><div class=sp-planner-cancel-edition ng-if=\"vm.editingPlan.status && !vm.state.includes(\'*.routes-detail\')\"><div class=info><div class=content-view-route-list><div class=sp-cancel-edit-plan><a ng-click=vm.openModalCancelEditPlan()><i class=sp-icon-close></i></a></div></div></div></div></div><div class=\"col-sm-7 sp-planner-bread-crumbs\"><bread-crumbs data=vm.steps on-change-step=vm.changeState(state) class=sp-list-arrow></bread-crumbs></div></div><div id=mapContainer class=sp-planner-map><div ng-if=\"vm.stepTwoIsActive() && vm.isCapacityOfVehiclesUsed()\" ng-show=\"vm.state.includes(\'*.visits-list\')\"><load-capacity total-loads=vm.headerStatistics.global.totalLoads total-capacity=vm.headerStatistics.global.totalVehiclesCapacity></load-capacity></div><tool-selection-on-map class=planner-step-2 ng-show=vm.stepTwoIsActive() alert-call-to-action=vm.deselectVisitsChecked() alert-data=vm.toolSelectionOnMap is-visits-loaded=vm.isVisitsLoaded is-collapsed=vm.isToolSelectionCollapsed on-collapse=vm.toggleToolSelectionOnMap()><button-item type=button on-click=vm.handDrawingModeActivated() is-button-active=vm.isDrawingActive icon-path=/assets/images/hand_drawing/hand_16.svg></button-item></tool-selection-on-map><div id=indicatorBar class=sp-planner-indicators ng-style=\"!vm.loadsCollapse && {\'z-index\': 10}\" ng-if=\"!vm.shouldHideGeneralIndicatorsInRouteEdition && (vm.state.includes(\'*.routes-detail\') || vm.state.includes(\'*.routes\')) && vm.headerStatistics.global.routeCount === vm.headerStatistics.global.vehicleCount\"><div class=sp-indicator-container><div class=\"sp-indicator-global-statistics sp-indicator-statistics--bg sp-indicator-statistics--bt h-100\"><div class=sp-indicator-header><i class=sp-icon-vehiculos></i><div class=sp-indicator-content><div class=sp-indicator-texts><span class=sp-indicator-title translate=Planner.used_vehicles></span></div><div class=sp-indicator-value><span>{{ vm.headerStatistics.global.vehicleCount }}</span><div class=\"sp-indicator-subtitle sp-indicator-subtitle__percentage-container\"><div><span>{{ 100 * vm.headerStatistics.global.vehicleCount/vm.fleetVehicles.length | number:0 }}% </span><span translate=Planner.of></span></div><span translate=Planner.your_fleet></span></div></div></div></div></div></div><div class=sp-indicator-container><div class=\"sp-indicator-statistics sp-indicator-statistics--bg sp-indicator-statistics--bt h-100\"><div class=sp-indicator-header><i class=sp-icon-tiempo-servicio></i><div class=sp-indicator-content><div class=sp-indicator-texts><span class=sp-indicator-title translate=Planner.average_time></span> <span class=sp-indicator-subtitle translate=Planner.average_by_route></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.byRoute.time }}</span></div></div></div></div><div class=sp-indicator-container><div class=\"sp-indicator-statistics sp-indicator-statistics--bg sp-indicator-statistics--bt h-100\"><div class=sp-indicator-header><svg version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 32 32\" enable-background=\"new 0 0 32 32\" xml:space=preserve><g id=kms><path d=\"M21.9,17.5L21.9,17.5c0.1-0.2,0.2-0.4,0.2-0.6c0-0.6-0.4-1-1-1c-0.3,0-0.5,0.1-0.7,0.3l-5.4,4c-0.2,0.1-0.3,0.2-0.5,0.4\n                  l0,0l0,0C14.2,21,14,21.5,14,22c0,1.1,0.9,2,2,2c0.6,0,1.1-0.3,1.5-0.7l0,0l0.1-0.1c0.1-0.1,0.1-0.1,0.1-0.2L21.9,17.5z\"/><path d=\"M30,22c0-7.7-6.3-14-14-14C8.3,8,2,14.3,2,22c0,0.7,0.1,1.4,0.2,2h0c0,0.5,0.5,1,1,1c0.5,0,1-0.4,1-1h0c0,0,0,0,0,0\n                  c0,0,0,0,0,0c0,0,0,0,0,0C4.1,23.3,4,22.7,4,22c0-6.6,5.4-12,12-12c6.6,0,12,5.4,12,12c0,0.7-0.1,1.4-0.2,2h0c0,0.5,0.5,1,1,1\n                  c0.5,0,1-0.4,1-1h0C29.9,23.4,30,22.7,30,22z\"/></g></svg><div class=sp-indicator-content><div class=sp-indicator-texts><span class=sp-indicator-title translate=Planner.average_kms></span> <span class=\"sp-indicator-subtitle km-svg\" translate=Planner.average_by_route></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.byRoute.kms }}</span></div></div></div></div><div ng-if=vm.showTotalRoutedLoads() class=sp-indicator-container-collapse ng-class=\"{ \'deactive-collapse\': !vm.loadsCollapse }\"><div class=sp-arrow-collapse ng-style=\"vm.loadsCollapse ? { \'left\': 0 } : { \'right\': \'-30px\' }\" ng-click=\"vm.loadsCollapse = !vm.loadsCollapse;\"><i class=sp-icon-chevron-thin-right ng-class=\"{ \'solid-arrow\': vm.loadsCollapse, \'fading-arrow\': !vm.loadsCollapse }\"></i> <i class=sp-icon-chevron-thin-left ng-class=\"{ \'solid-arrow\': !vm.loadsCollapse, \'fading-arrow\': vm.loadsCollapse }\"></i></div><div class=sp-indicator-container ng-class=\"{ \'solid-indicator\': !vm.loadsCollapse, \'fading-indicator\': vm.loadsCollapse }\" ng-if=\"vm.headerStatistics.global.totalRoutedLoads[0] > 0\" uib-tooltip=\"{{ vm.headerStatistics.global.totalRoutedLoads[0] | formatNumber }}\"><div class=\"sp-indicator-statistics sp-indicator-statistics--bg sp-indicator-statistics--bt h-100\"><div class=sp-indicator-header><i class=sp-icon-carga-peso></i><div class=sp-indicator-content><div class=\"sp-indicator-texts miw-one-row\"><span class=sp-indicator-title translate=Planner.average_load></span> <span class=sp-indicator-subtitle translate=Planner.average_by_route></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.byRoute.loads[0] | formatNumber }}</span></div></div></div></div><div class=sp-indicator-container ng-class=\"{ \'solid-indicator\': !vm.loadsCollapse, \'fading-indicator\': vm.loadsCollapse }\" ng-if=\"vm.headerStatistics.global.totalRoutedLoads[1] > 0\" uib-tooltip=\"{{ vm.headerStatistics.global.totalRoutedLoads[1] | formatNumber }}\"><div class=\"sp-indicator-statistics sp-indicator-statistics--bg sp-indicator-statistics--bt h-100\"><div class=sp-indicator-header><i class=sp-icon-carga-volumen></i><div class=sp-indicator-content><div class=\"sp-indicator-texts miw-one-row\"><span class=sp-indicator-title translate=Planner.average_load_2></span> <span class=sp-indicator-subtitle translate=Planner.average_by_route></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.byRoute.loads[1] | formatNumber }}</span></div></div></div></div><div class=sp-indicator-container ng-class=\"{ \'solid-indicator\': !vm.loadsCollapse, \'fading-indicator\': vm.loadsCollapse }\" ng-if=\"vm.headerStatistics.global.totalRoutedLoads[2] > 0\" uib-tooltip=\"{{ vm.headerStatistics.global.totalRoutedLoads[2] | formatNumber }}\"><div class=\"sp-indicator-statistics sp-indicator-statistics--bg sp-indicator-statistics--bt h-100\"><div class=sp-indicator-header><i class=sp-icon-carga-valor></i><div class=sp-indicator-content><div class=\"sp-indicator-texts miw-one-row\"><span class=sp-indicator-title translate=Planner.average_load_3></span> <span class=sp-indicator-subtitle translate=Planner.average_by_route></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.byRoute.loads[2] | formatNumber }}</span></div></div></div></div></div></div><div id=indicatorBar class=sp-planner-indicators ng-style=\"!vm.shouldHideGeneralIndicatorsInRouteEdition && !vm.loadsCollapse && {\'z-index\': 10}\" ng-if=vm.showIndicatorsPerVehicle()><div class=sp-indicator-container><div class=\"sp-indicator-global-statistics sp-indicator-statistics--bg sp-indicator-statistics--bt h-50\"><div class=sp-indicator-header><i class=sp-icon-rutas></i><div class=sp-indicator-content><div class=sp-indicator-texts><span class=sp-indicator-title translate=Planner.number_of_routes></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.global.routeCount }}</span></div></div></div><div class=\"sp-indicator-global-statistics h-50\"><div class=sp-indicator-header><i class=sp-icon-vehiculos></i><div class=sp-indicator-content><div class=sp-indicator-texts><span class=sp-indicator-title translate=Planner.used_vehicles></span></div><div class=sp-indicator-value><span>{{ vm.headerStatistics.global.vehicleCount }}</span><div class=\"sp-indicator-subtitle sp-indicator-subtitle__percentage-container\"><div><span>{{ 100 * vm.headerStatistics.global.vehicleCount/vm.fleetVehicles.length | number:0 }}% </span><span translate=Planner.of></span></div><span translate=Planner.your_fleet></span></div></div></div></div></div></div><div class=sp-indicator-container><div class=\"sp-indicator-statistics sp-indicator-statistics--bg sp-indicator-statistics--bt h-50\"><div class=sp-indicator-header><i class=sp-icon-tiempo-servicio></i><div class=sp-indicator-content><div class=sp-indicator-texts><span class=sp-indicator-title translate=Planner.average_time></span> <span class=sp-indicator-subtitle translate=Planner.average_by_route></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.byRoute.time }}</span></div></div></div><div class=\"sp-indicator-statistics h-50\"><div class=sp-indicator-header><i class=sp-icon-tiempo-servicio></i><div class=sp-indicator-content><div class=sp-indicator-texts><span class=sp-indicator-title translate=Planner.average_time></span> <span class=sp-indicator-subtitle translate=Planner.average_by_vehicle></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.byVehicle.time }}</span></div></div></div></div><div class=sp-indicator-container><div class=\"sp-indicator-statistics sp-indicator-statistics--bg sp-indicator-statistics--bt h-50\"><div class=sp-indicator-header><svg version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 32 32\" enable-background=\"new 0 0 32 32\" xml:space=preserve><g id=kms><path d=\"M21.9,17.5L21.9,17.5c0.1-0.2,0.2-0.4,0.2-0.6c0-0.6-0.4-1-1-1c-0.3,0-0.5,0.1-0.7,0.3l-5.4,4c-0.2,0.1-0.3,0.2-0.5,0.4\n                  l0,0l0,0C14.2,21,14,21.5,14,22c0,1.1,0.9,2,2,2c0.6,0,1.1-0.3,1.5-0.7l0,0l0.1-0.1c0.1-0.1,0.1-0.1,0.1-0.2L21.9,17.5z\"/><path d=\"M30,22c0-7.7-6.3-14-14-14C8.3,8,2,14.3,2,22c0,0.7,0.1,1.4,0.2,2h0c0,0.5,0.5,1,1,1c0.5,0,1-0.4,1-1h0c0,0,0,0,0,0\n                  c0,0,0,0,0,0c0,0,0,0,0,0C4.1,23.3,4,22.7,4,22c0-6.6,5.4-12,12-12c6.6,0,12,5.4,12,12c0,0.7-0.1,1.4-0.2,2h0c0,0.5,0.5,1,1,1\n                  c0.5,0,1-0.4,1-1h0C29.9,23.4,30,22.7,30,22z\"/></g></svg><div class=sp-indicator-content><div class=sp-indicator-texts><span class=sp-indicator-title translate=Planner.average_kms></span> <span class=\"sp-indicator-subtitle km-svg\" translate=Planner.average_by_route></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.byRoute.kms }}</span></div></div></div><div class=\"sp-indicator-statistics h-50\"><div class=sp-indicator-header><svg version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 32 32\" enable-background=\"new 0 0 32 32\" xml:space=preserve><g id=kms><path d=\"M21.9,17.5L21.9,17.5c0.1-0.2,0.2-0.4,0.2-0.6c0-0.6-0.4-1-1-1c-0.3,0-0.5,0.1-0.7,0.3l-5.4,4c-0.2,0.1-0.3,0.2-0.5,0.4\n                  l0,0l0,0C14.2,21,14,21.5,14,22c0,1.1,0.9,2,2,2c0.6,0,1.1-0.3,1.5-0.7l0,0l0.1-0.1c0.1-0.1,0.1-0.1,0.1-0.2L21.9,17.5z\"/><path d=\"M30,22c0-7.7-6.3-14-14-14C8.3,8,2,14.3,2,22c0,0.7,0.1,1.4,0.2,2h0c0,0.5,0.5,1,1,1c0.5,0,1-0.4,1-1h0c0,0,0,0,0,0\n                  c0,0,0,0,0,0c0,0,0,0,0,0C4.1,23.3,4,22.7,4,22c0-6.6,5.4-12,12-12c6.6,0,12,5.4,12,12c0,0.7-0.1,1.4-0.2,2h0c0,0.5,0.5,1,1,1\n                  c0.5,0,1-0.4,1-1h0C29.9,23.4,30,22.7,30,22z\"/></g></svg><div class=sp-indicator-content><div class=sp-indicator-texts><span class=sp-indicator-title translate=Planner.average_kms></span> <span class=\"sp-indicator-subtitle km-svg\" translate=Planner.average_by_vehicle></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.byVehicle.kms }}</span></div></div></div></div><div ng-if=vm.showTotalRoutedLoads() class=sp-indicator-container-collapse ng-class=\"{ \'deactive-collapse\': !vm.loadsCollapse }\"><div class=sp-arrow-collapse ng-style=\"vm.loadsCollapse ? { \'left\': 0 } : { \'right\': \'-30px\' }\" ng-click=\"vm.loadsCollapse = !vm.loadsCollapse;\"><i class=sp-icon-chevron-thin-right ng-class=\"{ \'solid-arrow\': vm.loadsCollapse, \'fading-arrow\': !vm.loadsCollapse }\"></i> <i class=sp-icon-chevron-thin-left ng-class=\"{ \'solid-arrow\': !vm.loadsCollapse, \'fading-arrow\': vm.loadsCollapse }\"></i></div><div class=sp-indicator-container ng-class=\"{ \'solid-indicator\': !vm.loadsCollapse, \'fading-indicator\': vm.loadsCollapse }\" ng-if=\"vm.headerStatistics.global.totalRoutedLoads[0] > 0\" uib-tooltip=\"{{ vm.headerStatistics.global.totalRoutedLoads[0] | formatNumber }}\"><div class=\"sp-indicator-statistics sp-indicator-statistics--bg sp-indicator-statistics--bt h-50\"><div class=sp-indicator-header><i class=sp-icon-carga-peso></i><div class=sp-indicator-content><div class=\"sp-indicator-texts miw-two-rows\"><span class=sp-indicator-title translate=Planner.average_load></span> <span class=sp-indicator-subtitle translate=Planner.average_by_route></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.byRoute.loads[0] | formatNumber }}</span></div></div></div><div class=\"sp-indicator-statistics h-50\"><div class=sp-indicator-header><i class=sp-icon-carga-peso></i><div class=sp-indicator-content><div class=\"sp-indicator-texts miw-two-rows\"><span class=sp-indicator-title translate=Planner.average_load></span> <span class=sp-indicator-subtitle translate=Planner.average_by_vehicle></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.byVehicle.loads[0] | formatNumber }}</span></div></div></div></div><div class=sp-indicator-container ng-class=\"{ \'solid-indicator\': !vm.loadsCollapse, \'fading-indicator\': vm.loadsCollapse }\" ng-if=\"vm.headerStatistics.global.totalRoutedLoads[1] > 0\" uib-tooltip=\"{{ vm.headerStatistics.global.totalRoutedLoads[1] | formatNumber }}\"><div class=\"sp-indicator-statistics sp-indicator-statistics--bg sp-indicator-statistics--bt h-50\"><div class=sp-indicator-header><i class=sp-icon-carga-volumen></i><div class=sp-indicator-content><div class=\"sp-indicator-texts miw-two-rows\"><span class=sp-indicator-title translate=Planner.average_load_2></span> <span class=sp-indicator-subtitle translate=Planner.average_by_route></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.byRoute.loads[1] | formatNumber }}</span></div></div></div><div class=\"sp-indicator-statistics h-50\"><div class=sp-indicator-header><i class=sp-icon-carga-volumen></i><div class=sp-indicator-content><div class=\"sp-indicator-texts miw-two-rows\"><span class=sp-indicator-title translate=Planner.average_load_2></span> <span class=sp-indicator-subtitle translate=Planner.average_by_vehicle></span></div><span class=sp-indicator-value>{{vm.headerStatistics.byVehicle.loads[1] | formatNumber }}</span></div></div></div></div><div class=sp-indicator-container ng-class=\"{ \'solid-indicator\': !vm.loadsCollapse, \'fading-indicator\': vm.loadsCollapse }\" ng-if=\"vm.headerStatistics.global.totalRoutedLoads[2] > 0\" uib-tooltip=\"{{ vm.headerStatistics.global.totalRoutedLoads[2] | formatNumber }}\"><div class=\"sp-indicator-statistics sp-indicator-statistics--bg sp-indicator-statistics--bt h-50\"><div class=sp-indicator-header><i class=sp-icon-carga-valor></i><div class=sp-indicator-content><div class=\"sp-indicator-texts miw-two-rows\"><span class=sp-indicator-title translate=Planner.average_load_3></span> <span class=sp-indicator-subtitle translate=Planner.average_by_route></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.byRoute.loads[2] | formatNumber }}</span></div></div></div><div class=\"sp-indicator-statistics h-50\"><div class=sp-indicator-header><i class=sp-icon-carga-valor></i><div class=sp-indicator-content><div class=\"sp-indicator-texts miw-two-rows\"><span class=sp-indicator-title translate=Planner.average_load_3></span> <span class=sp-indicator-subtitle translate=Planner.average_by_vehicle></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.byVehicle.loads[2] | formatNumber }}</span></div></div></div></div><div class=sp-indicator-container ng-class=\"{ \'solid-indicator\': !vm.loadsCollapse, \'fading-indicator\': vm.loadsCollapse }\" ng-if=\"vm.isMixLoadAddonEnabled && vm.headerStatistics.global.totalRoutedLoads[3] > 0\" uib-tooltip=\"{{ vm.headerStatistics.global.totalRoutedLoads[3] | formatNumber }}\"><div class=\"sp-indicator-statistics sp-indicator-statistics--bg sp-indicator-statistics--bt h-50\"><div class=sp-indicator-header><i class=sp-icon-carga-valor></i><div class=sp-indicator-content><div class=\"sp-indicator-texts miw-two-rows\"><span class=sp-indicator-title translate=Planner.average_load_4></span> <span class=sp-indicator-subtitle translate=Planner.average_by_route></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.byRoute.loads[3] | formatNumber }}</span></div></div></div><div class=\"sp-indicator-statistics h-50\"><div class=sp-indicator-header><i class=sp-icon-carga-valor></i><div class=sp-indicator-content><div class=\"sp-indicator-texts miw-two-rows\"><span class=sp-indicator-title translate=Planner.average_load_4></span> <span class=sp-indicator-subtitle translate=Planner.average_by_vehicle></span></div><span class=sp-indicator-value>{{ vm.headerStatistics.byVehicle.loads[3] | formatNumber }}</span></div></div></div></div></div></div><div class=sp-planner-zone-switch><div class=sp-zone-switch-container ng-if=vm.isZonesEnabled><div class=sp-zone-switch-text><span translate=Planner.zones></span></div><div id=zone-switch-planner class=sp-zone-switch ng-click=vm.toggleZones()><div ng-include=\"\'/assets/images/show_hide/show_icon.svg\'\" class=switch-icon ng-show=vm.visibleZones style=\"color: #4c3bef\"></div><div ng-include=\"\'/assets/images/show_hide/hide_icon.svg\'\" class=switch-icon ng-show=!vm.visibleZones></div></div></div></div><div ng-if=\"vm.state.includes(\'*.routes\') && vm.optimizationResultsOptions.length\"><optimization-results-dropdown optimization-results-options=vm.optimizationResultsOptions update-optimization-result=vm.updateOptimizationResult(optimizationId)></optimization-results-dropdown></div><div class=sp-plans-container ui-view=plans ng-if=\"vm.state.includes(\'*.vehicles-list.plans\') || vm.state.includes(\'*.vehicles-list.plans-draft\') || vm.state.includes(\'*.vehicles-list.plans-detail\') || vm.state.includes(\'*.vehicles-list.plans-detail.codrivers\')\"></div><alert-notification></alert-notification><div id=color-picker-container><div id=pickr-container></div></div><multiple-selection-on-map class=planner-edit-step-3 alert-data=vm.msomAlertData show-if=\"vm.state.includes(\'*.routes-detail\')\" map=vm.map on-multiple-selection-completed=vm.onMultipleSelectionCompleted(polygon) on-enter-on-mode=vm.onEnterOnMultipleSelectionMode() on-exit-mode=vm.onExitMultipleSelectionMode() alert-call-to-action=vm.deselectVisits() default-polygon-option=vm.isEnhancedPlanEditModeEnable pickup-and-delivery-mode=vm.enablePickupAndDeliveryMode is-move-to-mode-activated=vm.isMoveToModeActivated on-move-to-mode=vm.onMoveToMode(status)></multiple-selection-on-map><div id=map></div><div class=sp-planner-info-box-container ng-if=vm.infoBoxVisits.length ng-class=\"{\'collapse\': vm.infoBoxCollapse}\"><div class=container-relative id=container-info-box><div class=expand-button ng-click=\"vm.infoBoxCollapse = !vm.infoBoxCollapse\"><i class=sp-icon-chevron-thin-up ng-if=vm.infoBoxCollapse></i> <i class=sp-icon-chevron-thin-down ng-if=!vm.infoBoxCollapse></i></div><div class=container-absolute><div class=pagination-button ng-click=vm.prevPage() ng-class=\"{\'disabled\': vm.noPrevPage}\"><i class=sp-icon-chevron-thin-left></i></div><div class=info-boxs-area id=info-boxes-area><info-box ng-repeat=\"visit in vm.infoBoxVisits | limitTo: vm.infoBoxesPerPage : vm.infoBoxesPerPage * vm.infoBoxesPage\" data=visit call-to-close=vm.removeVisitInfoBox(visitId) view-collapse=vm.infoBoxCollapse></info-box></div><div class=pagination-button ng-click=vm.nextPage() ng-class=\"{\'disabled\': vm.noNextPage}\"><i class=sp-icon-chevron-thin-right></i></div></div></div></div><div ng-if=\"!vm.detailedRouteIndicators && vm.statusBar.element === \'route\'\" class=sp-planner-status-bar><div ng-style=\"{ \'background-color\': vm.statusBar.route.stroke.color }\" class=sp-planner-status-bar__data><div class=sp-planner-status-bar__statistics><div class=\"sp-planner-status-bar__property sp-planner-status-bar__property--mw-route\"><i class=sp-icon-rutas></i> <span class=sp-planner-status-bar__property__content>{{ vm.statusBar.routeName }}</span></div><div class=\"sp-planner-status-bar__property sp-planner-status-bar__property--mw-vehicle\"><i class=sp-icon-vehiculos></i> <span class=sp-planner-status-bar__property__content>{{ vm.statusBar.vehicle.name }}</span></div></div><div class=sp-planner-status-bar__statistics><div class=sp-planner-status-bar__property><div class=sp-flex-container ng-include=vm.getVisitIconForRouteIndicator()></div><span>{{ vm.getVisitCountForRouteIndicator() | formatNumber:0 }}</span></div><div class=sp-planner-status-bar__property><i class=sp-icon-rutas></i> <span>{{ vm.statusBar.route.totalDistance.toFixed(2) | formatNumber }} kms</span></div><div class=sp-planner-status-bar__property><i class=sp-icon-tiempo-servicio></i> <span>{{ vm.statusBar.route.totalTimeFormatted }} hrs</span></div><div class=sp-planner-status-bar__property ng-if=!vm.enablePickupAndDeliveryMode><i class=sp-icon-carga-peso></i> <span>{{ vm.statusBar.route.totalLoadPercentage | formatNumber:0 }}%</span></div><div ng-if=\"vm.statusBar.route.totalLoad2 > 0 && !vm.enablePickupAndDeliveryMode\" class=sp-planner-status-bar__property><i class=sp-icon-carga-volumen></i> <span>{{ vm.statusBar.route.totalLoadPercentage2 | formatNumber:0 }}%</span></div><div ng-if=\"vm.statusBar.route.totalLoad3 > 0 && !vm.enablePickupAndDeliveryMode\" class=sp-planner-status-bar__property><i class=sp-icon-carga-valor></i> <span>{{ vm.statusBar.route.totalLoadPercentage3 | formatNumber:0 }}%</span></div><div ng-if=\"vm.statusBar.route.totalLoad4 > 0 && !vm.enablePickupAndDeliveryMode\" class=\"sp-planner-status-bar__property sp-mix-load-icon\"><div class=\"sp-flex-container sp-\" ng-include=\"\'/assets/images/vehicle_stats/box_filled.svg\'\"></div><span>{{ vm.statusBar.route.totalLoadPercentage4 | formatNumber:0 }}%</span></div></div></div></div><detailed-indicators ng-if=\"(vm.state.includes(\'*.routes-detail\') || vm.state.includes(\'*.routes\')) && vm.detailedRouteIndicators\" join-similar=vm.isJoinSimilarActive() data=vm.indicatorsData should-move-to-top=vm.shouldHideGeneralIndicatorsInRouteEdition are-indicators-per-vehicle-shown=\"!vm.shouldHideGeneralIndicatorsInRouteEdition && vm.showIndicatorsPerVehicle()\"></detailed-indicators></div><context-menu-on-map context-menu=vm.contextMenu move-visits-to-route=\"vm.moveVisitsToRoute(routeId, vehicleId)\"></context-menu-on-map><polyline-context-menu context-menu=vm.contextMenu move-visits-to-route=vm.moveVisitsToRoute></polyline-context-menu><div ng-if=vm.isMoveToModeActivated class=sp-msg-move-to-mode><div class=icon-move-to ng-include=\"\'/assets/images/forward/forward_filled_16.svg\'\"></div><span class=msg-move-to translate=Planner_toast.msg_move_to_mode></span></div></div></div></div>");
$templateCache.put("app/planner/visit-infowindow.tpl.html","<div class=sp-planner-infowindow><div class=sp-planner-infowindow-title>{{visit.title}}</div><div class=sp-planner-infowindow-content><div class=sp-planner-infowindow-content ng-if=visit.address><div class=sp-planner-infowindow-prop><div class=sp-planner-infowindow-icon-container><i class=sp-icon-map-pin></i></div><div class=sp-planner-infowindow-desc-container><span style=\"font-style: italic\">{{visit.address}}</span></div></div></div><div class=\"container-reference-id sp-planner-infowindow-reference\" ng-if=visit.reference><visit-reference class=visit-reference-container visit=visit></visit-reference></div><div class=sp-planner-infowindow-prop ng-if=visit.load><div class=sp-planner-infowindow-icon-container><i class=sp-icon-carga-peso-outline ng-class=\"{\'sp-text-color-danger\': visit.capacityError}\"></i></div><div class=sp-planner-infowindow-desc-container><span>{{visit.load | formatNumber:2:\'.\':\',\'}}</span></div></div><div class=sp-planner-infowindow-prop ng-if=visit.load2><div class=sp-planner-infowindow-icon-container><i class=sp-icon-carga-volumen-outline ng-class=\"{\'sp-text-color-danger\': visit.capacityError2}\"></i></div><div class=sp-planner-infowindow-desc-container><span>{{visit.load2 | formatNumber:2:\'.\':\',\'}}</span></div></div><div class=sp-planner-infowindow-prop ng-if=visit.load3><div class=sp-planner-infowindow-icon-container><i class=sp-icon-carga-valor-outline ng-class=\"{\'sp-text-color-danger\': visit.capacityError3}\"></i></div><div class=sp-planner-infowindow-desc-container><span>{{visit.load3 | formatNumber:2:\'.\':\',\'}}</span></div></div><div class=sp-planner-infowindow-prop ng-if=visit.load4><div class=sp-planner-infowindow-icon-container><div class=sp-icon-carga-mixta ng-include=\"\'assets/images/box_outline.svg\'\"></div></div><div class=sp-planner-infowindow-desc-container><span>{{visit.load4 | formatNumber:2:\'.\':\',\'}}</span></div></div><skills-summary class=skills-container visit=visit></skills-summary><div class=sp-planner-infowindow-prop ng-if=\"visit.windowStart || visit.windowEnd\"><div class=sp-planner-infowindow-icon-container><i class=sp-icon-ventana-horaria ng-class=\"{\'sp-text-color-danger\': visit.timeError}\"></i></div><div class=sp-planner-infowindow-desc-container><span ng-if=\"visit.windowStart && !visit.windowEnd\">{{ \'Planner.infowindow_since\' |translate }} {{visit.windowStart}} </span><span ng-if=\"visit.windowStart && visit.windowEnd\">{{visit.windowStart}} {{ \'Planner.infowindow_to\' |translate }} {{visit.windowEnd}} </span><span ng-if=\"!visit.windowStart && visit.windowEnd\">{{ \'Planner.infowindow_until_to\' |translate }} {{visit.windowEnd}}</span></div></div><div class=sp-planner-infowindow-prop ng-if=\"(visit.windowStart2 || visit.windowEnd2) &&\n            (visit.windowStart2 != HOUR_AND_MINUTE_DEFAULT && visit.windowEnd2 !== HOUR_AND_MINUTE_DEFAULT)\"><div class=sp-planner-infowindow-icon-container><i class=sp-icon-ventana-horaria ng-class=\"{\'sp-text-color-danger\': visit.timeError}\"></i></div><div class=sp-planner-infowindow-desc-container><span ng-if=\"visit.windowStart2 && !visit.windowEnd2\">{{ \'Planner.infowindow_since\' |translate }} {{visit.windowStart2}} </span><span ng-if=\"visit.windowStart2 && visit.windowEnd2\">{{visit.windowStart2}} {{ \'Planner.infowindow_to\' |translate }} {{visit.windowEnd2}} </span><span ng-if=\"!visit.windowStart2 && visit.windowEnd2\">{{ \'Planner.infowindow_until_to\' |translate }} {{visit.windowEnd2}}</span></div></div><div class=sp-planner-infowindow-prop ng-if=visit.duration><div class=sp-planner-infowindow-icon-container><i class=sp-icon-tiempo-servicio></i></div><div class=sp-planner-infowindow-desc-container><span>{{visit.duration}}</span></div></div><div class=sp-planner-infowindow-prop ng-if=visit.notes><div class=sp-planner-infowindow-icon-container><i class=sp-icon-notes></i></div><div class=sp-planner-infowindow-desc-container><span>{{visit.notes}}</span></div></div><div class=sp-planner-infowindow-prop ng-if=visit.estimatedTimeArrival><div class=sp-planner-infowindow-icon-container><i class=\"fa fa-clock-o\"></i></div><div class=sp-planner-infowindow-desc-container><span>{{estimatedTimeArrival}}</span></div></div><div class=sp-planner-infowindow-prop ng-if=vehicle><div class=sp-planner-infowindow-icon-container><i class=sp-icon-vehiculos></i></div><div class=sp-planner-infowindow-desc-container><span>{{vehicle.name}}</span></div></div><div class=sp-planner-infowindow-prop ng-if=indexRoute><div class=sp-planner-infowindow-icon-container><i class=sp-icon-rutas></i></div><div class=sp-planner-infowindow-desc-container><span>{{ \'Routes.route_text\' |translate }} {{indexRoute}}</span></div></div><div class=sp-planner-infowindow-prop ng-if=visit.zones.length><div class=sp-planner-infowindow-icon-container><i class=sp-icon-tracking></i></div><div class=sp-planner-infowindow-desc-container><span ng-repeat=\"zone in visit.zones\">{{zone.name}}</span></div></div><div class=\"sp-planner-infowindow-prop items-container\" ng-if=visit.items.length><items-summary-in-visit-card items=visit.items class=card-item></items-summary-in-visit-card></div></div></div>");
$templateCache.put("app/main/idle-alert-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-info\"><h3 class=modal-title translate=idle_title></h3></div><div class=\"modal-body unlock-user-modal\"><p style=\"text-align: left\"><span translate=idle_remaining_time></span> <span>{{ vm.countdownMinutes + \':\' + vm.countdownSeconds }}</span></p><p style=\"text-align: left\" translate=idle_info></p></div><div class=sp-modal-buttons><button type=button class=\"btn sp-btn-default\" ng-click=vm.keepLogged() translate=idle_keep></button> <button type=button class=\"btn btn-primary\" ng-click=vm.logout() translate=idle_logout></button></div></div>");
$templateCache.put("app/main/main.html","<div class=sp-loader ng-if=isLoading><img src=../../assets/images/loading.gif width=180 height=180></div><not-found-page ng-if=vm.showNotFoundPage></not-found-page><mobile-sidebar ng-if=!vm.showNotFoundPage sections-to-display=vm.sectionsToDisplay profile=vm.profile></mobile-sidebar><sidebar ng-if=!vm.showNotFoundPage sections-to-display=vm.sectionsToDisplay profile=vm.profile></sidebar><mobile-compatibility-message ng-if=\"!vm.shouldContinueWithMobile() && !vm.showNotFoundPage\" class=main-mobile-compatibility-message></mobile-compatibility-message><div ng-if=\"vm.shouldContinueWithMobile() && !vm.showNotFoundPage\" class=sp-main-content><trial show-trial=showTrial account-active-until=vm.user.account.active_until go-state-uprofile=vm.goStateUprofile() close-trial=vm.closeTrial()></trial><div class=sp-main-module ui-view></div></div><toast></toast>");
$templateCache.put("app/main/video.html","<div class=modal-body><div class=\"embed-responsive embed-responsive-16by9\"><iframe class=embed-responsive-item ng-src=\"{{srcVideo | trusted}}\" allowfullscreen></iframe></div></div>");
$templateCache.put("app/plans/codrivers-modal.html","<div><header class=modal-cod-header><span class=modal-cod-header__vehicle-name>{{ vm.vehicleName }}</span> <span class=modal-cod-header__cancel ng-click=closeThisDialog(vm.cancelAndCloseModal())>X</span></header><div class=modal-cod-body><div><span translate=Planner.codrivers_select></span><selectable-items-list data=vm.selectableCodrivers items-selected=vm.selectableCodrivers.itemsSelected items-per-page=vm.itemsPerPage></selectable-items-list></div></div><footer class=modal-cod-footer><button class=\"btn sp-btn-default\" type=button ng-click=closeThisDialog(vm.cancelAndCloseModal()) translate=Planner.close></button> <button class=\"btn btn-saved btn-success\" type=button ng-click=closeThisDialog(vm.saveCodrivers()) translate=Planner.btn_save></button></footer></div>");
$templateCache.put("app/plans/plan-detail.html","<div ui-view class=sp-planner-map-container><div class=\"sp-widget-header view-mode\"><div class=left-icon><a ui-sref=plans href=#/plans><i class=sp-icon-chevron-left></i></a></div><div class=title><span>{{vm.plan.name}}</span></div><div class=right-icon><a ui-sref=plans><i class=sp-icon-close></i></a></div></div><div class=sp-widget-plan-body><div class=\"row sp-row\"><div class=\"col-sm-3 text-left\"><div class=col-sm-3><b><span class=sp-small-caps translate=Planner.start_date></span></b></div><div class=\"col-sm-3 sp-block-relative sp-plan-date-input\"><span class=sp-small-caps>{{vm.plan.startDate}}</span></div></div><div class=\"col-sm-3 text-left\"><div class=col-sm-3><b><span class=sp-small-caps translate=Planner.end_date></span></b></div><div class=\"col-sm-3 sp-block-relative sp-plan-date-input\"><span class=sp-small-caps>{{vm.plan.endDate}}</span></div></div></div><div><div class=\"table view-mode\"><header class=\"sp-widget-table-rows sp-main-headers\" ng-class=\"{ \'add-column\': vm.existCodrivers }\"><span class=\"sp-widget-table-th sp-justify-start\" translate=Routes.vehicle></span> <span class=sp-widget-table-th translate=Routes.codriver ng-if=vm.existCodrivers></span> <span class=sp-widget-table-th translate=Routes.driver></span> <span class=sp-widget-table-th translate=Routes.route_text></span> <span class=sp-widget-table-th translate=labels.eta></span> <span class=sp-widget-table-th translate=labels.etd></span> <span class=sp-widget-table-th>KMS</span> <span class=sp-widget-table-th translate=Routes.time></span></header><section><article ng-repeat=\"vehicle in vm.planVehicles | orderBy: \'name\'\"><div class=\"sp-widget-table-rows sp-custom-vehicle sp-custom-vehicle--one-route sp-bottom-5px\" ng-class=\"{ \'add-column\': vm.existCodrivers }\" ng-if=\"vehicle.routes.length === 1\"><span class=\"sp-widget-ellipsis-name sp-justify-start\">{{ vehicle.name }}</span><div class=sp-widget-co-driver ng-if=\"vm.existCodrivers && vehicle.codrivers.length === 0\" ng-click=\"vm.showCodriversModal(vehicle, vm.codrivers)\"><i class=\"sp-icon-user sp-icon-form sp-icon-form-inactive\"></i> <span class=\"fa fa-stack-1x sp-icon-over-inactive\"><i class=\"fa fa-plus-circle\"></i></span></div><div class=sp-widget-co-driver ng-if=\"vm.existCodrivers && vehicle.codrivers.length > 0\" ng-click=\"vm.showCodriversModal(vehicle, vm.codrivers)\"><span class=fa-stack><i class=\"sp-icon-user sp-icon-form fa-stack-2x\"></i> <span class=\"fa fa-stack-1x\"><div class=sp-icon-over-active><i class=\"fa fa-circle fa-stack-1x\"></i> <span class=\"fa fa-stack-1x sp-icon-over-text\">{{ vehicle.codrivers.length > 9 ? \'+9\' : vehicle.codrivers.length }}</span></div></span></span></div><div class=sp-widget-custom-select><select ng-if=!vm.isTmsEnable class=\"form-control sp-select-box sp-widget-custom-select__dropdown\" ng-model=vehicle.routes[0].driverId ng-options=\"driver.id as driver.name for driver in vm.drivers\"><option value=\"\" translate=Routes.select_driver></option></select><custom-select ng-if=vm.isTmsEnable data=vm.driverSelectInfo.drivers selected-id=vehicle.routes[0].driverId on-click-option=vm.driverSelectInfo.onClickOption context=\"{vehicle: vehicle, route: vehicle.routes[0]}\" additional-width=50></custom-select><i class=\"fa fa-chevron-down sp-widget-custom-select__arrow\"></i></div><span class=\"sp-widget-ellipsis-name route\">{{ vehicle.routes[0].name }} </span><span>{{ vehicle.routes[0].estimatedTimeStart }} <small class=sp-xx-small-text>HRS</small> </span><span>{{ vehicle.routes[0].estimatedTimeEnd }} <small class=sp-xx-small-text>HRS</small> </span><span>{{ vehicle.routes[0].kms }} </span><span>{{ vehicle.routes[0].duration }} <small class=sp-xx-small-text>HRS</small></span></div><div class=sp-bottom-5px ng-if=\"vehicle.routes.length > 1\"><header class=\"sp-widget-table-rows sp-custom-vehicle sp-custom-vehicle--multi-route\" ng-class=\"{ \'add-column\': vm.existCodrivers && !vm.isMultiDriversConfigEnabled }\"><span class=\"sp-widget-ellipsis-name sp-justify-start\">{{ vehicle.name }}</span><div class=sp-widget-co-driver ng-if=\"vm.existCodrivers && !vm.isMultiDriversConfigEnabled && vehicle.codrivers.length === 0\" ng-click=\"vm.showCodriversModal(vehicle, vm.codrivers)\"><i class=\"sp-icon-user sp-icon-form sp-icon-form-inactive\"></i> <span class=\"fa fa-stack-1x sp-icon-over-inactive\"><i class=\"fa fa-plus-circle\"></i></span></div><div class=sp-widget-co-driver ng-if=\"vm.existCodrivers && !vm.isMultiDriversConfigEnabled && vehicle.codrivers.length > 0\" ng-click=\"vm.showCodriversModal(vehicle, vm.codrivers)\"><span class=fa-stack><i class=\"sp-icon-user sp-icon-form fa-stack-2x\"></i> <span class=\"fa fa-stack-1x\"><div class=sp-icon-over-active><i class=\"fa fa-circle fa-stack-1x\"></i> <span class=\"fa fa-stack-1x sp-icon-over-text\">{{ vehicle.codrivers.length > 9 ? \'+9\' : vehicle.codrivers.length }}</span></div></span></span></div></header><div class=sp-widget-bg-multi-route><div class=\"sp-widget-table-rows sp-custom-route\" ng-class=\"{ \'add-column\': vm.existCodrivers }\" ng-repeat=\"route in vehicle.routes | orderBy: \'name\'\"><span ng-if=\"vm.existCodrivers && vm.isMultiDriversConfigEnabled\"></span><div class=sp-widget-co-driver ng-if=\"vm.existCodrivers && vm.isMultiDriversConfigEnabled && (!route.codrivers || route.codrivers.length === 0)\" ng-click=\"vm.showCodriversModal(vehicle, vm.codrivers, route)\"><i class=\"sp-icon-user sp-icon-form sp-icon-form-inactive\"></i> <span class=\"fa fa-stack-1x sp-icon-over-inactive\"><i class=\"fa fa-plus-circle\"></i></span></div><div class=sp-widget-co-driver ng-if=\"vm.existCodrivers && vm.isMultiDriversConfigEnabled && route.codrivers && route.codrivers.length > 0\" ng-click=\"vm.showCodriversModal(vehicle, vm.codrivers, route)\"><span class=fa-stack><i class=\"sp-icon-user sp-icon-form fa-stack-2x\"></i> <span class=\"fa fa-stack-1x\"><div class=sp-icon-over-active><i class=\"fa fa-circle fa-stack-1x\"></i> <span class=\"fa fa-stack-1x sp-icon-over-text\">{{ route.codrivers.length > 9 ? \'+9\' : route.codrivers.length }}</span></div></span></span></div><div class=\"sp-widget-custom-select sp-widget-custom-select--multi-route\" ng-class=\"{ \'order-column\': vm.existCodrivers }\"><select ng-if=!vm.isTmsEnable class=\"form-control sp-select-box sp-widget-custom-select__dropdown\" ng-model=route.driverId ng-options=\"driver.id as driver.name for driver in vm.drivers\"><option value=\"\" translate=Routes.select_driver></option></select><custom-select ng-if=vm.isTmsEnable data=vm.driverSelectInfo.drivers selected-id=route.driverId on-click-option=vm.driverSelectInfo.onClickOption context=\"{route: route}\" additional-width=50></custom-select><i class=\"fa fa-chevron-down sp-widget-custom-select__arrow\"></i></div><span class=\"sp-widget-ellipsis-name route\">{{ route.name }} </span><span>{{ route.estimatedTimeStart }} <small class=sp-xx-small-text>HRS</small> </span><span>{{ route.estimatedTimeEnd }} <small class=sp-xx-small-text>HRS</small> </span><span>{{ route.kms }} </span><span>{{ route.duration }} <small class=sp-xx-small-text>HRS</small></span></div></div></div></article></section></div></div><div class=sp-empty-msg ng-if=\"vm.safeSrcPlans.length === 0\" translate=Planner.empty_plans_msg></div></div><div class=sp-widget-footer><div class=\"sp-button text-right\"><button type=button class=\"btn btn-success\" ng-click=vm.save(vm.routes) ng-disabled=\"!vm.enableSaveButton || !vm.routes.length\"><span translate=Planner.btn_save></span></button></div></div></div>");
$templateCache.put("app/plans/plan-list.html","<div ui-view class=sp-planner-map-container><div class=\"sp-widget-header view-mode\"><div class=left-icon></div><div class=title><span translate=Planner.load_plans></span></div><div ng-if=vm.enableFleetLogic><div class=sp-fake-table><div class=\"sp-select-fleet sp-plan-fleet-drop\"><p class=sp-fleet-text translate=Planner.select_fleet></p><select ng-options=\"fleet.name for fleet in vm.fleets\" ng-model=vm.fleetSelected ng-change=vm.onChangeSelectedFleet()></select></div></div></div><form class=\"form-inline md-form form-sm active-cyan-2\"><input class=\"form-control form-control-sm mr-3 w-75\" type=text placeholder=Search aria-label=Search ng-model=vm.searchText ng-change=vm.onChangeSearch() ng-model-options=\"{ debounce: 250 }\"></form></div><div class=sp-widget-plan-body><div class=table-responsive ng-if=\"vm.safeSrcPlans.length > 0\"><table class=\"table tbl-view-mode\"><thead><tr><th class=sp-widget-table-th translate=Planner.plan></th><th class=\"sp-widget-table-th text-center\" translate=Planner.start_date></th><th class=\"sp-widget-table-th text-center\" translate=Planner.end_date></th><th>&nbsp;</th></tr></thead><tbody><tr class=\"sp-cursor-pointer sp-plan-row\" ng-repeat=\"plan in vm.safeSrcPlans.slice(((vm.pagination.currentPage-1)*vm.pagination.itemsPerPage), ((vm.pagination.currentPage)*vm.pagination.itemsPerPage)) | orderBy:\'created\':true\" ng-click=\"![\'saving\', \'error\'].includes(plan.saveStage) && vm.selectPlan(plan)\"><td class=text-left><div ng-class=\"{\'sp-container-plan-name\': [\'saving\', \'error\'].includes(plan.saveStage)}\">{{plan.name}} <span ng-if=\"plan.saveStage === \'saving\'\" class=sp-chip-saving-plan uib-tooltip=\"{{\'Planner.saving\' | translate}}\" translate=chips.saving></span><chip-error-plan ng-if=\"plan.saveStage === \'error\'\" show-recovery-btn=vm.activeDraftPlanIds.includes(plan.id) plan-id=plan.id></chip-error-plan></div></td><td class=text-center>{{plan.startDate}}</td><td class=text-center>{{plan.endDate}}</td><td class=text-center></td></tr></tbody></table></div><div class=sp-empty-msg ng-if=\"vm.safeSrcPlans.length === 0 && vm.loadingPlans === false\" translate=Planner.empty_plans_msg></div><div class=sp-empty-msg ng-if=\"vm.safeSrcPlans.length === 0 && vm.loadingPlans === true\" translate=Planner.loading_plans_msg></div><div ng-show=\"vm.safeSrcPlans.length > 0\" class=\"sp-settings-pagination text-right\"><uib-pagination total-items=vm.safeSrcPlans.length ng-model=vm.pagination.currentPage max-size=vm.pagination.maxSize class=pagination-sm boundary-links=true items-per-page=vm.pagination.itemsPerPage ng-change=vm.pagination.pageChanged() first-text={{pagination.firstText}} last-text={{pagination.lastText}} next-text={{pagination.nexText}} previous-text={{pagination.previousText}}></uib-pagination></div></div><div class=sp-widget-footer></div></div>");
$templateCache.put("app/settings/settings.html","<div class=sp-settings-container><div class=sp-vertical-settings-menu><h1 class=\"title-menu sp-header-title\" translate=settings></h1><ul><li ng-class=\"{\'selected-item\': vm.isItemSelected(item)}\" ng-repeat=\"item in vm.menuItems\" ng-click=vm.selectMenuItem(item) ng-if=item.isVisible><a class=\"menu-item container-item\" ng-click=vm.navigateTo(item.href)><div class=item><div class=menu-item-icon ng-include=item.icon></div><span translate={{item.title}}></span></div><div class=submenu-icon><div ng-include=\"\'/assets/images/plus.svg\'\" class=\"menu-item-icon plus-icon\" ng-if=\"item.submenu && !item.submenu.isExpanded\"></div><div ng-include=\"\'/assets/images/minus.svg\'\" class=menu-item-icon ng-if=\"item.submenu && item.submenu.isExpanded\"></div></div></a><ul ng-if=\"item.submenu && item.submenu.isExpanded\"><li class=submenu-item ng-if=subItem.isVisible id={{subItem.id}} ng-click=$event.stopPropagation() ng-repeat=\"subItem in item.submenu.items\"><a class=\"menu-item submenu-item\" ng-if=!subItem.isDisabled ng-click=vm.navigateTo(subItem.href) ng-class=\"{\'active\': vm.isItemSelected(subItem)}\"><div class=submenu-ellipse></div><span>{{ subItem.title }}</span></a><div class=\"menu-item submenu-item disabled\" ng-if=subItem.isDisabled><span>{{ subItem.title }}</span></div></li></ul></li></ul></div><div class=sp-settings-tab-content ui-view></div></div>");
$templateCache.put("app/simpliPlanner/simpliPlanner.html","<div ui-view class=sp-simpliPlanner><iframe-directive class=sp-simpliPlanner__extension site-url={{vm.url}}></iframe-directive></div>");
$templateCache.put("app/tracking/tracking.html","<div class=sp-tracking><div class=\"sp-tracking-panel sp-tracking-drivers\"><div class=\"sp-tracking-header sp-header-title\"><span translate=Tracking.tracking></span></div><div class=sp-tracking-scrollable><ul class=sp-tracking-tabs-container><li class=tab ng-class=\"{\'active\': vm.state.includes(\'tracking.vehicles\')}\"><a ui-sref=tracking.vehicles translate=Tracking.vehicles></a></li><li class=\"tab cursor\" ng-class=\"{\'active\': vm.state.includes(\'tracking.all-dispatchs\')}\"><a ng-click=vm.goToDispatchs() translate=Tracking.visits></a></li><li class=\"tab cursor\" ng-class=\"{\'active\': vm.state.includes(\'tracking.events\')}\"><a ng-click=vm.goToEvents() translate=Tracking.events></a></li></ul><div class=sp-tracking-tabs-content ui-view=tab-content></div></div><!-- end sp-tracking-scrollable --></div><!-- end sp-tracking-drivers --><div class=sp-tracking-map-container><div class=sp-tracking-indicators><!-- Div barra de progreso despachos --><div class=sp-tracking-progress><!-- <h5 translate=\"{{ \'Indicators.progress_bar\' }}\"></h5> --><h5 translate=Indicators.progress_bar></h5><div class=progreso-despachos><div class=progress tooltip-placement=bottom uib-tooltip=\"{{vm.totalVisitsDone}} / {{vm.totalVisits }}\"><div class=progress-bar role=progressbar aria-valuenow=\"{{ vm.visitProgress}}\" aria-valuemin=0 aria-valuemax=100 style=\"width:{{ vm.visitProgress}}%\"><strong class=strong>{{vm.visitProgress}}%</strong></div></div></div></div><!-- Div out-of-window alerts --><div class=\"btn-group sp-tracking-time-alert\" ng-if=vm.enableETALogic><div class=wrapper-alert><i class=\"sp-icon-despacho-atrasado is-delayed\" id=icon-delayed-top-bar></i> <span class=badge>{{ vm.outOfWindowVisits }}</span></div></div><!-- Div alertas --><div class=\"btn-group sp-tracking-alerts\" uib-dropdown><button type=button class=\"alertas alertas-danger\" uib-dropdown-toggle><span>{{vm.totalVisitsAlerts}}</span></button> <button type=button class=\"alertas alertas-default\" uib-dropdown-toggle><h5 translate=Indicators.alerts_title></h5></button><ul uib-dropdown-menu><li><a href=\"\"><b>{{vm.totalCustomAlerts}}</b> <span translate=Visits.custom_alerts></span> </a><a href=\"\"><b>{{vm.totalCheckoutFailedAlert}}</b> <span translate=Visits.visits_failed></span></a></li></ul></div><!-- Div fecha datepicker --><div class=sp-tracking-date><button type=button class=\"btn-group alertas alertas-ok filter-icon\" ng-click=\"vm.trackingDateFilterOpened=!vm.trackingDateFilterOpened\"><svg version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" enable-background=\"new 0 0 32 32\" xml:space=preserve ng-if=vm.isFilterActive><path class=sp-filter-icon id=FILTRO d=\"M29.929,2.576C29.785,2.228,29.444,2,29.066,2H2.933C2.556,2,2.215,2.228,2.071,2.576\n              c-0.145,0.349-0.065,0.75,0.202,1.017L13.5,14.82v14.198c0,0.856,0.458,1.189,1,1l3-1c0.656-0.222,1-0.447,1-1V14.82L29.727,3.593\n              C29.993,3.326,30.074,2.925,29.929,2.576z\"/></svg> <svg version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" enable-background=\"new 0 0 32 32\" xml:space=preserve ng-if=!vm.isFilterActive><g id=no_filter><g><path class=sp-filter-icon d=M13.846,22.71v5.51c0,0.687,0.451,0.983,0.862,0.861l2.585-1c0.504-0.253,0.861-0.386,0.861-0.861V15.985L13.846,22.71z /><path class=sp-filter-icon d=M18.116,4.938H4.74c-0.325,0-0.619,0.196-0.743,0.497C3.873,5.735,3.942,6.08,4.172,6.311l7.963,7.963L18.116,4.938z /><path class=sp-filter-icon d=\"M28.002,5.434c-0.123-0.3-0.417-0.497-0.742-0.497h-2.343c-0.052,0.355-0.162,0.703-0.343,1.026l-6.419,10.02l9.673-9.673\n                  C28.058,6.08,28.128,5.735,28.002,5.434z\"/></g><path class=sp-filter-icon d=\"M7.75,26.836c-0.711-0.425-0.983-1.317-0.579-2.04L20.646,3.769c0.402-0.724,1.317-0.982,2.041-0.579\n                c0.723,0.404,0.981,1.318,0.577,2.041L9.791,26.259C9.476,26.805,8.449,27.255,7.75,26.836z\"/></g></svg></button><div class=\"btn-group sp-filter-info\"><button type=button class=\"btn-group alertas date-info-button\" ng-click=\"vm.trackingDateFilterOpened=!vm.trackingDateFilterOpened\"><p>{{vm.showDate}}</p><span class=\"sp-icon-triangle-down expand-filter\"></span></button></div><div class=sp-filter-container ng-show=vm.trackingDateFilterOpened><div class=\"sp-select-fleet form-control\" ng-if=vm.enableFleetLogic><select ng-options=\"fleet.name for fleet in vm.fleets track by fleet.id\" ng-model=vm.fleetSelected></select></div><button type=button class=\"alertas alertas-default date-info\" ng-click=\"vm.popupOpened=!vm.popupOpened\"><h5 translate=Indicators.date_title></h5><p><span class=\"sp-icon-calendario calendar-icon\"></span>{{vm.showDate}}</p></button><div class=btn-group ng-model=vm.date ng-change=vm.setTrackingDate(vm.date) uib-datepicker show-button-bar=false datepicker-options=vm.dateOptions ng-show=vm.popupOpened></div><div class=slider-container><rzslider class=custom-slider rz-slider-model=vm.timeSlider.min rz-slider-high=vm.timeSlider.max rz-slider-options=vm.timeSlider.options></rzslider></div><button type=button class=\"filter-button-reset btn\" translate=Indicators.date_reset_button_title ng-click=vm.undoFilters()></button> <button type=button class=\"filter-button-submit btn\" translate=Indicators.date_submit_button_title ng-click=vm.applyFilters()></button></div></div></div><!-- end sp-tracking-indicators --><!-- Div mapa --><div class=sp-tracking-map ng-class=\"{\'active\': vm.state.includes(\'tracking.vehicles.driver-dispatchs\')}\"><div class=sp-tracking-panel ui-view=item-detail></div><!-- end sp-tracking-dispatchs --><div id=map resizable></div></div><div ng-if=vm.widgetRetool><retool-widget url=vm.widgetRetool.url></div></div><!-- end sp-tracking-map-container --></div>");
$templateCache.put("app/transportationProviderPayment/transportationProviderPayment.html","<div ui-view class=sp-transportation-provider-module><iframe-directive site-url={{vm.url}} class=sp-module-extension></iframe-directive></div>");
$templateCache.put("app/uprofile/uprofile.html","<div class=sp-uprofile-container></div>");
$templateCache.put("app/addons/email/email.html","<h1>email</h1>");
$templateCache.put("app/addons/sms/checkout-sms.html","<div class=container-sms-checkout><form ng-show=!vm.messageNotSMS class=\"form-inline form-sms-checkout\" name=vm.formSkills id=form-sms-checkout ng-submit=vm.saveSmsCheckout() novalidate><div class=\"form-group row\"><label class=\"control-label col-md-3\">{{vm.checkoutSms.title}}</label><div class=\"text-area-sms col-md-9\"><textarea name=comment class=text-area-sms maxlength=70 ng-model=vm.checkoutSms.value placeholder={{vm.checkoutSms.description}}></textarea></div></div><button type=submit class=\"btn btn-primary btn-save-sms\" translate=checkout_sms.btn_save></button></form><div><h1 ng-show=\"vm.messageNotSMS && !$rootScope.isLoading\" translate=checkout_sms.without_option_sms></h1></div></div>");
$templateCache.put("app/assigner/components/assignerTable.template.html","<div class=assigner-table><div class=flex-table><div class=\"assigner-row header\"><div class=\"assigner-cell checkbox\"></div><div class=assigner-cell ng-repeat=\"column in $ctrl.columns\" ng-if=\"column.name !== \'id\'\" ng-click=$ctrl.orderColumn(column.field)>{{::column.name}} <i class=sp-icon-triangle-up ng-show=\"column.order === 2\"></i> <i class=sp-icon-triangle-down ng-show=\"column.order === 1\"></i></div></div><div class=assigner-body ng-if=\"$ctrl.data.length > 0\"><div class=\"assigner-row data\" ng-repeat=\"row in $ctrl.filteredData.slice(($ctrl.currentPage - 1)*$ctrl.pageSize, $ctrl.currentPage*$ctrl.pageSize)\"><div class=\"assigner-cell checkbox\"><div class=sp-checkbox-select-all><input type=checkbox ng-model=row.selected ng-change=\"$ctrl.handleCheck(row.id, row.selected)\"><label><span class=sp-icon-check></span></label></div></div><div class=assigner-cell>{{row.title}}</div><div class=assigner-cell>{{row.address}}</div><div class=assigner-cell>{{row.vehicle}}</div></div></div><div class=assigner-empty ng-if=\"$ctrl.data.length === 0\"><span translate=Assigner.empty_visits></span></div></div><div class=sp-table-pagination ng-if=\"$ctrl.data.length > 0\"><uib-pagination total-items=$ctrl.filteredData.length ng-model=$ctrl.currentPage max-size=$ctrl.options.pagination.maxSize class=pagination-sm items-per-page=$ctrl.pageSize previous-text=&lsaquo; next-text=&rsaquo;></uib-pagination></div></div>");
$templateCache.put("app/assigner/components/importExcelButton.template.html","<button type=button class=\"btn btn-primary import-excel-button\" ng-class=\"{ \'disabled\': $ctrl.disabled }\"><input type=file sp-file-change=$ctrl.import($files)> <span>{{$ctrl.data.label}}</span></button>");
$templateCache.put("app/assigner/components/routeIndicator.template.html","<div class=sp-route-indicator><i ng-class=$ctrl.icon></i> {{$ctrl.value}} <small class=sp-xx-small-text>{{$ctrl.smallText}}</small></div>");
$templateCache.put("app/assigner/components/routesTable.template.html","<div class=sp-routes-table><div class=sp-routes-table-empty ng-if=!$ctrl.totalVehicles><img src=../../../assets/images/sin-vehiculos-tracking.svg> <span class=empty-table-text translate=Assigner.no_vehicles></span> <span class=empty-table-text translate=Assigner.click_here_to_create></span> <button type=button class=\"btn btn-primary\" ng-click=$ctrl.goToVehicleCreate() ng-disabled=vm.createPlanDisabled><span translate=Assigner.create_vehicle></span></button></div><div class=sp-routes-table-empty ng-if=\"!$ctrl.data.length && $ctrl.totalVehicles\"><span class=empty-table-text translate=Assigner.load_visits_file></span> <span class=empty-table-text translate=Assigner.routes_will_appear_here></span></div><div class=tabs-container ng-if=$ctrl.data.length><div class=scroll-button ng-click=$ctrl.scrollLeft() ng-disabled=\"$ctrl.tabsRange[0] === 0\" ng-if=\"$ctrl.vehicles.length > 5\"><i class=sp-icon-chevron-thin-left></i></div><div class=sp-vehicle-tab-container><vehicle-tab ng-repeat=\"vehicle in $ctrl.visibleTabs\" data=vehicle on-click-handler=$ctrl.changeTab(vehicle.id) width=$ctrl.tabWidth selected></vehicle-tab></div><div class=scroll-button ng-click=$ctrl.scrollRight() ng-disabled=\"$ctrl.tabsRange[1] === $ctrl.vehicles.length\" ng-if=\"$ctrl.vehicles.length > 5\"><i class=sp-icon-chevron-thin-right></i></div></div><div class=sp-vehicle-info ng-if=$ctrl.data.length><route-indicator icon=sp-icon-map-pin value=$ctrl.selectedVehicleVisits.length></route-indicator><route-indicator icon=sp-icon-verificando value=$ctrl.selectedVehicleVisits[0].routeTotalTime small-text=HRS></route-indicator></div><div class=sp-table ng-if=$ctrl.data.length><div class=sp-depot-info><div class=start-time><i class=sp-icon-home ng-style=\"{\'color\':  $ctrl.vehicles[$ctrl.indexSelected].color}\"></i> {{$ctrl.selectedVehicleVisits[0].time_start}}</div><div class=depot-address><span translate=Routes.from></span> {{$ctrl.vehicles[$ctrl.indexSelected].location_start_address}}</div></div><div class=sp-table-body><visit-row ng-repeat=\"row in $ctrl.selectedVehicleVisits\" data=row color=$ctrl.vehicles[$ctrl.indexSelected].color></visit-row></div></div></div>");
$templateCache.put("app/assigner/components/vehicleTab.template.html","<div class=sp-vehicle-tab uib-tooltip={{$ctrl.data.name}} ng-style=\"{\'background-color\': $ctrl.data.color, \'width\': $ctrl.width}\" ng-click=$ctrl.onClickHandler() ng-class=\"{\'selected\': $ctrl.selected}\">{{$ctrl.data.name}}</div>");
$templateCache.put("app/assigner/components/visitRow.template.html","<div class=sp-visit-row><div class=order-section><div class=order-number ng-style=\"{\'background-color\':  $ctrl.color}\">{{$ctrl.data.order}}</div><div>{{$ctrl.data.estimatedTimeArrival}}</div><div class=sp-line ng-style=\"{\'background-color\':  $ctrl.color}\"></div></div><div class=visit-info-section ng-style=\"{\'border-color\': $ctrl.color}\"><div class=visit-title>{{$ctrl.data.title}}</div><div class=visit-address>{{$ctrl.data.address}}</div></div></div>");
$templateCache.put("app/authentication/account/confirmed.html","<div class=confirmed><div class=\"modal-body sp-restrict-height-to-400 min-height-400\"><div><div class=picture><img src=../../../assets/images/Alvaro.svg alt=Alvaro></div><div class=message><div class=subject translate=Confirmation.confirmed_loading ng-if=\"!vm.showConfirmMessage && !vm.showErrorMessage\"></div><div class=subject translate=Confirmation.confirmed_subject ng-if=vm.showConfirmMessage></div><div class=body translate=Confirmation.confirmed_body translate-values=\"{ trialDays: vm.accountTrialDays }\" ng-if=vm.showConfirmMessage></div><div class=subject translate=Confirmation.confirmed_link_error_subject ng-if=vm.showErrorMessage></div><div class=body translate=Confirmation.confirmed_link_error ng-if=vm.showErrorMessage></div></div></div></div></div>");
$templateCache.put("app/authentication/account/not-confirmed.html","<div class=not-confirmed><div class=modal-header><h3 class=modal-title translate=Confirmation.not_confirmed_title></h3></div><div class=\"modal-body sp-restrict-height-to-400\"><div class=picture><img src=../../../assets/images/Fede.svg alt=Fede></div><div class=message><div class=subject translate=Confirmation.not_confirmed_subject></div><div class=body translate=Confirmation.not_confirmed_body></div><div class=link><a href=\"\" ng-click=vm.resendConfirmationEmail() ng-disabled=vm.disabledLink translate=Confirmation.not_confirmed_link></a> <span class=text-success translate=Confirmation.mail_resend ng-if=vm.mailResend></span></div></div></div><div class=\"modal-footer sp-modal-footer\"><a href=\"\" ng-click=vm.goOut() ng-disabled=vm.disabledLink translate=Confirmation.not-confirmed-logout></a></div></div>");
$templateCache.put("app/authentication/account-selector/account-selector.html","<div class=\"col-md-5 sp-auth-content\"><div class=sp-auth-content-right><div class=sp-auth-panel cg-busy=\"{promise: vm.promiseLoading, backdrop:true, templateUrl:\'app/shared/html/loading.html\'}\"><div class=sp-auth-panel-title><h4 translate=AccountSelector.title></h4><h6 translate=AccountSelector.select></h6></div><div class=\"login-form sp-auth-panel-body\"><div class=account-selector-option ng-repeat=\"account in vm.accounts\" ng-click=vm.selectAccount(account)><div class=account-name>{{account.name}}</div><div class=account-option><span translate=AccountSelector.enter></span> <i class=\"fa fa-arrow-circle-right\"></i></div></div></div></div><div class=login-disclaimer ng-click=vm.goBack()><a translate=AccountSelector.go_back></a></div></div></div>");
$templateCache.put("app/authentication/compliance-modal/compliance-modal.html","<div class=sp-compliance-modal><div class=sp-compliance-modal__header><span class=sp-compliance-modal__badge>{{ \'Login.compliance.badge\' | translate }}</span><h3 class=sp-compliance-modal__title>{{ \'Login.compliance.title\' | translate }}</h3><p class=sp-compliance-modal__subtitle>{{ \'Login.compliance.subtitle\' | translate }}</p></div><div class=sp-compliance-modal__tab-bar ng-if=\"vm.documents.length > 1\"><button type=button class=sp-compliance-modal__tab ng-class=\"{ \'is-active\': $index === vm.activeIndex }\" ng-repeat=\"doc in vm.documents track by doc.id\" ng-click=vm.selectTab($index)>{{ doc.title }}</button></div><div class=sp-compliance-modal__interactive ng-click=vm.handleContentClick($event)><div class=sp-compliance-modal__content-body sp-track-scroll=vm.onScroll($event) ng-bind-html=vm.trustHtml(vm.activeDocument().content)></div><div class=sp-compliance-modal__progress><span class=sp-compliance-modal__scroll-hint>{{ \'Login.compliance.scrollHint\' | translate }}</span><div class=sp-compliance-modal__progress-bar><div class=sp-compliance-modal__progress-bar-fill ng-style=\"{ width: vm.activeProgress() + \'%\' }\"></div></div><span class=sp-compliance-modal__progress-percent>{{ vm.activeProgress() }}%</span></div><div class=sp-compliance-modal__footer><label class=sp-compliance-modal__checkbox-row ng-repeat=\"doc in vm.documents track by doc.id\"><input type=checkbox class=sp-compliance-modal__checkbox ng-model=vm.acceptances[doc.id] ng-disabled=!vm.canCheck(doc)> <span class=sp-compliance-modal__checkbox-label ng-bind-html=vm.trustHtml(doc.checkbox_label)></span></label><div class=sp-compliance-modal__error ng-if=vm.errorMessage><strong class=sp-compliance-modal__error-title>{{ \'Login.compliance.errorTitle\' | translate }}</strong><p class=sp-compliance-modal__error-message>{{ vm.errorMessage | translate }}</p></div><button type=button class=sp-compliance-modal__primary-btn ng-if=!vm.canRetry ng-click=vm.accept() ng-disabled=\"!vm.canSubmit() || vm.submitting\">{{ \'Login.compliance.acceptButton\' | translate }}</button> <button type=button class=sp-compliance-modal__primary-btn ng-if=vm.canRetry ng-click=vm.retry()>{{ \'Login.compliance.retryButton\' | translate }}</button> <button type=button class=sp-compliance-modal__logout-link ng-click=vm.logout()>{{ \'Login.compliance.logoutButton\' | translate }}</button><p class=sp-compliance-modal__version ng-if=vm.legalVersion><span translate=Login.compliance.versionFooter translate-values=\"{ version: vm.legalVersion.version,\n                                  effectiveDate: vm.formatDate(vm.legalVersion.effective_date) }\"></span></p></div></div></div>");
$templateCache.put("app/authentication/encryption/encryption-passphrase.html","<div class=\"col-md-5 sp-auth-content\"><div class=sp-auth-content-right><div class=sp-auth-panel cg-busy=\"{promise: vm.promiseLoading, backdrop:true, templateUrl:\'app/shared/html/loading.html\'}\"><div class=sp-auth-panel-title></div><div class=\"login-form sp-auth-panel-body\"><form name=vm.passphraseForm class=form-horizontal ng-submit=vm.storePassphrase(vm.passphrase)><div class=form-group><!-- Translate --><label class=\"login-field-icon fui-user\" for=passphrase translate=Encryption.passphrase></label><div class=\"sp-block-relative sp-input-block-password\"><input type=text id=passphrase class=\"form-control login-field\" name=passphrase ng-model=vm.passphrase required translate translate-attr-placeholder=Encryption.placeholder ng-attr-type={{vm.newPassphraseType}}> <span class=input-group-btn><button type=button class=\"btn btn-default except_policies_hidden except-policies-hidden-extended\" ng-click=vm.setNewPassphraseType()><span class=\"sp-icon-show-hide except_policies_hidden\"></span></button></span></div><ng-messages for=\" vm.passphraseForm.passphrase.$error\" class=sp-form-messages role=alert ng-if=vm.passphraseForm.passphrase.$dirty><!-- Translate --><ng-message class=sp-error-txt when=required translate=Encryption.required></ng-message><ng-message class=sp-error-txt when=invalid translate=Encryption.error></ng-message></ng-messages></div><div class=action-group><button type=submit class=\"btn btn-block btn-auth\"><!-- The \"span\" solves the animation duration from font-awesome spinner --> <span ng-show=vm.submiting><i class=\"fa fa-spinner fa-spin\"></i> </span><!-- Translate --> <span translate=Encryption.button></span></button></div><div class=recaptcha-notice>This site is protected by reCAPTCHA and the Google <a href=https://policies.google.com/privacy>Privacy Policy</a> and <a href=https://policies.google.com/terms>Terms of Service</a> apply.</div></form></div></div><div class=login-disclaimer ng-click=vm.goBack()><!-- Translate --> <a translate=Encryption.go_back></a></div></div></div>");
$templateCache.put("app/authentication/login/login-sso.html","<div ng-init=vm.ssoTokenLogin()></div><div class=\"col-md-5 sp-auth-content\" ng-if=vm.showSsoLanding><div class=sp-auth-content-right><div class=sp-auth-panel cg-busy=\"{promise: vm.promiseLoading, backdrop:true, templateUrl:\'app/shared/html/loading.html\'}\"><div class=sp-auth-panel-title><h4 ng-if=!vm.sessionExpired translate=Login.title></h4><h4 ng-if=vm.sessionExpired translate=Login.session_expired></h4><h6 ng-if=!vm.sessionExpired translate=Login.welcome></h6><h6 ng-if=vm.sessionExpired translate=Login.session_expired_info></h6></div><div class=\"login-form sp-auth-panel-body\"><form class=form-horizontal><div class=action-group><button ng-click=\"vm.ssoRedirect(vm.ssoDomain, vm.distributionCenter)\" class=\"btn btn-block btn-auth\"><span>{{vm.ssoLoginText()}} {{vm.ssoDomain}}</span></button></div></form></div><div ng-if=vm.allowInternalLogin class=\"login-form sp-auth-panel-body\"><form class=form-horizontal><div class=action-group><button ng-click=vm.goToInternalLogin() class=\"btn btn-block btn-auth\"><span translate=Login.to_internal_login></span></button></div></form></div></div><div class=login-disclaimer><a href=https://www.simpliroute.com/terminos-y-condiciones target=_blank translate=Login.termsAndConditions></a> | <a href=https://www.simpliroute.com/privacy-policy target=_blank translate=Login.privacyPolicy></a><p translate=Login.disclaimer></p></div></div></div>");
$templateCache.put("app/authentication/login/login.html","<div class=\"col-md-5 sp-auth-content\"><div class=sp-auth-content-right><div class=sp-auth-panel cg-busy=\"{promise: vm.promiseLoading, backdrop:true, templateUrl:\'app/shared/html/loading.html\'}\"><div class=sp-auth-panel-title><h4 ng-if=!vm.sessionExpired translate=Login.title></h4><h4 ng-if=vm.sessionExpired translate=Login.session_expired></h4><h6 ng-if=!vm.sessionExpired translate=Login.welcome></h6><h6 ng-if=vm.sessionExpired translate=Login.session_expired_info></h6></div><div class=\"login-form sp-auth-panel-body\"><form name=vm.loginForm class=form-horizontal ng-submit=vm.login(vm.credentials)><div class=form-group><label class=\"login-field-icon fui-user\" for=loginUser translate=Login.username></label><input type=text id=loginUser class=\"form-control login-field\" name=username ng-model=vm.credentials.username required><ng-messages for=vm.loginForm.username.$error class=sp-form-messages role=alert ng-if=vm.loginForm.username.$dirty><ng-message class=sp-error-txt when=required translate=Login.field_required></ng-message></ng-messages></div><div class=form-group><label class=\"login-field-icon fui-lock\" for=loginPass translate=Login.password></label><div class=\"sp-block-relative sp-input-block-password\"><input id=loginPass class=\"form-control login-field\" name=password ng-model=vm.credentials.password ng-attr-type={{vm.newPasswordType}} required> <span class=input-group-btn><button type=button class=\"btn btn-default except_policies_hidden except-policies-hidden-extended\" ng-click=vm.setNewPasswordType()><span class=\"sp-icon-show-hide except_policies_hidden\"></span></button></span></div><ng-messages for=vm.loginForm.password.$error class=sp-form-messages role=alert ng-show=vm.loginForm.password.$dirty><ng-message class=sp-error-txt when=pattern></ng-message><ng-message class=sp-error-txt when=required translate=Login.field_required></ng-message><ng-message class=sp-error-txt when=invalid translate=Login.wrong_password></ng-message><ng-message class=sp-error-txt when=remaining translate=Login.remaining translate-values=\"{ attempts: vm.remainingAttempts }\"></ng-message><ng-message class=sp-error-txt when=last_try translate=Login.last_try></ng-message></ng-messages></div><span class=error-flag ng-show=vm.errorMsg>{{vm.errorMsg}}</span><div class=login-link><a ui-sref=^.password-reset translate=Login.forgotPassword></a></div><div class=action-group><button type=submit class=\"btn btn-block btn-auth\"><!-- The \"span\" solves the animation duration from font-awesome spinner --> <span ng-show=vm.submiting><i class=\"fa fa-spinner fa-spin\"></i> </span><span translate=Login.login></span></button></div><div class=recaptcha-notice>This site is protected by reCAPTCHA and the Google <a href=https://policies.google.com/privacy>Privacy Policy</a> and <a href=https://policies.google.com/terms>Terms of Service</a> apply.</div></form></div><div ng-show=vm.reseted><div class=\"alert alert-success\" translate=Login.reset_message_success></div></div></div><div class=login-disclaimer><a href=https://www.simpliroute.com/terminos-y-condiciones target=_blank translate=Login.termsAndConditions></a> | <a href=https://www.simpliroute.com/privacy-policy target=_blank translate=Login.privacyPolicy></a><p translate=Login.disclaimer></p></div></div></div>");
$templateCache.put("app/authentication/login-failed/login-failed.html","<div class=\"col-md-5 sp-auth-content\"><div class=sp-auth-content-right><div class=sp-auth-panel><div class=\"sp-auth-panel-title sp-auth-panel-title-center\"><div class=picture><img src=../../../assets/images/Ada_sad.svg alt=\"\"></div><h4 translate=LoginFailed.title></h4><h6 translate=LoginFailed.info></h6></div></div><div class=login-disclaimer><a href=https://www.simpliroute.com/terms-conditions target=_blank translate=Login.termsAndConditions></a> | <a href=https://www.simpliroute.com/privacy-policy target=_blank translate=Login.privacyPolicy></a><p translate=Login.disclaimer></p></div></div></div>");
$templateCache.put("app/authentication/logout/logout.html","<div class=\"col-md-5 sp-auth-content\"><div class=sp-auth-content-right><div class=sp-auth-panel><div class=\"sp-auth-panel-title sp-auth-panel-title-center\"><h4 translate=Logout.title></h4></div></div><div class=login-disclaimer><a href=https://www.simpliroute.com/terms-conditions target=_blank translate=Login.termsAndConditions></a> | <a href=https://www.simpliroute.com/privacy-policy target=_blank translate=Login.privacyPolicy></a><p translate=Login.disclaimer></p></div></div></div>");
$templateCache.put("app/authentication/password-renewal/password-renewal.html","<div class=\"col-md-5 sp-auth-content\"><div class=sp-auth-content-right><div class=sp-auth-panel><div class=sp-auth-panel-title><h4 translate=PasswordRenewal.title></h4><h6 translate=PasswordRenewal.description></h6></div><div class=\"login-form sp-auth-panel-body\" ng-hide=vm.confirmed><form name=confirmForm class=form-horizontal id=password-reset-form ng-submit=\"confirmForm.$valid &&\n                     vm.confirm(vm.new_password, vm.new_password_repeat, confirmForm)\" novalidate><div class=form-group><label class=login-field-icon for=newPassword translate=PasswordRenewal.new_password></label><div class=\"sp-block-relative sp-input-block-password\"><input type=password id=newPassword class=\"form-control login-field except_policies_hidden\" name=new_password ng-model=vm.new_password ng-change=vm.validate_repeat_password(confirmForm) required ng-attr-type={{vm.newPasswordType}} style=\"border-radius:.5em 0 0 .5em\"> <span class=input-group-btn><button type=button class=\"btn btn-default except_policies_hidden\" ng-click=\"vm.toggleInputType(confirmForm.new_password,\n                                                     vm.newPasswordType)\" style=\"height:42px;border-radius:0 .5em .5em 0\"><span class=\"sp-icon-show-hide except_policies_hidden\"></span></button></span></div><ng-messages for=confirmForm.new_password.$error class=sp-form-messages role=alert ng-show=confirmForm.new_password.$touched><ng-message class=sp-error-txt when=required></ng-message></ng-messages></div><div style=display:none id=password-reset-policies><password-policies data=vm.policies validation=vm.validation></password-policies></div><div class=form-group style=margin-top:35px><label class=login-field-icon for=newPasswordRepeat translate=PasswordRenewal.repeat_new_password></label><div class=\"sp-block-relative sp-input-block-password\"><input type=password id=newPasswordRepeat class=\"form-control login-field\" name=new_password_repeat ng-change=vm.validate_repeat_password(confirmForm) ng-model=vm.new_password_repeat required ng-attr-type={{vm.newPasswordRepeatType}} style=\"border-radius:.5em 0 0 .5em\"> <span class=input-group-btn><button type=button class=\"btn btn-default except_policies_hidden\" ng-click=\"vm.toggleInputType(confirmForm.new_password_repeat,\n                                                      vm.newPasswordRepeatType)\" style=\"height:42px;border-radius:0 .5em .5em 0\"><span class=\"sp-icon-show-hide except_policies_hidden\"></span></button></span></div><!--vm.new_password_repeat required in ng-show for proper \'equal\'\n                error display when $setPristine() is called in controller.\n                ng-if=\"vm.new_password\" needed for hide \'required\' error when\n                vm.new_password field is empty.--><ng-messages for=confirmForm.new_password_repeat.$error class=sp-form-messages role=alert ng-show=\"confirmForm.new_password_repeat.$dirty || vm.new_password_repeat\"><ng-message ng-if=vm.new_password class=sp-error-txt when=required translate=Login.field_required></ng-message><ng-message class=sp-error-txt when=equal translate=PasswordRenewal.match_password></ng-message><ng-message class=sp-error-txt when=policies></ng-message></ng-messages></div><div class=action-group style=margin-top:90px><!--vm.clientError is now displayed in a dedicated div.--><div ng-show=vm.showClientError><div style=color:red;font-size:12px><ul style=list-style-type:none;padding:0;margin:0 ng-repeat=\"errorMsg in vm.clientError\"><li>{{errorMsg}}</li></ul></div></div><!--Now is also disabled on vm.clientError.--> <button type=submit class=\"btn btn-block btn-auth\" ng-disabled=\"confirmForm.$invalid ||\n                                 confirmForm.new_password_repeat.$error.equal ||\n                                 confirmForm.new_password_repeat.$error.policies ||\n                                 vm.clientError\"><!-- The \"span\" solves the animation duration from font-awesome spinner --> <span ng-show=vm.submiting><i class=\"fa fa-spinner fa-spin\"></i> </span><span translate=PasswordRenewal.button class=except_policies_hidden></span></button></div><center><a class=login-link ui-sref=^.login translate=Login.back></a></center></form></div><div ng-show=vm.confirmed><div class=\"alert alert-success except_policies_hidden\" ng-show=vm.success><center translate=PasswordRenewal.success></center></div><div class=\"alert alert-danger except_policies_hidden\" ng-show=!vm.success><center translate=PasswordRenewal.error></center></div></div></div><div class=login-disclaimer><a href=https://www.simpliroute.com/terms-conditions target=_blank translate=Login.termsAndConditions></a> | <a href=https://www.simpliroute.com/privacy-policy target=_blank translate=Login.privacyPolicy></a><p translate=Login.disclaimer></p></div></div></div>");
$templateCache.put("app/authentication/password-reset/password-reset.html","<div class=\"col-md-5 sp-auth-content\"><div class=sp-auth-content-right><div class=sp-auth-panel><div class=sp-auth-panel-title><h4 translate=Login.forgotPassword></h4><h6 translate=Login.newPasswordInfo></h6></div><div class=\"login-form sp-auth-panel-body\" ng-hide=vm.reseted><form name=vm.resetForm class=form-horizontal ng-submit=\"vm.resetForm.$valid && vm.reset(vm.email)\" novalidate><div class=form-group><label class=\"login-field-icon fui-user\" for=resetEmail translate=Login.email></label><input type=email id=resetEmail class=\"form-control login-field\" name=email ng-model=vm.email required><ng-messages for=vm.resetForm.email.$error class=sp-form-messages role=alert ng-if=vm.resetForm.$dirty><ng-message class=sp-error-txt when=pattern translate=PasswordReset.incorrect_email></ng-message><ng-message class=sp-error-txt when=required translate=Login.field_required></ng-message><ng-message class=sp-error-txt when=invalid translate=PasswordReset.incorrect_email></ng-message></ng-messages></div><div class=action-group><button type=submit class=\"btn btn-block btn-auth\" ng-disabled=vm.submiting><span ng-show=vm.submiting><i class=\"fa fa-spinner fa-spin\"></i> </span><span translate=Login.send></span></button></div><center><a class=login-link ui-sref=^.login translate=Login.back></a></center></form></div><div ng-show=vm.reseted><div class=\"alert alert-success\" translate=PasswordReset.reset_message_success></div></div></div><div class=login-disclaimer><a href=https://www.simpliroute.com/terminos-y-condiciones target=_blank translate=Login.termsAndConditions></a> | <a href=https://www.simpliroute.com/privacy-policy target=_blank translate=Login.privacyPolicy></a><p translate=Login.disclaimer></p></div></div></div>");
$templateCache.put("app/authentication/password-reset-confirm/password-reset-confirm.html","<div class=\"col-md-5 sp-auth-content\"><div class=sp-auth-content-right><div class=sp-auth-panel><div class=sp-auth-panel-title><h4 translate=Login.welcome></h4></div><div class=\"login-form sp-auth-panel-body\" ng-hide=vm.confirmed><form name=confirmForm class=form-horizontal id=password-reset-form ng-submit=\"confirmForm.$valid && vm.confirm(vm.new_password, vm.new_password_repeat)\" novalidate><div class=form-group><label class=login-field-icon for=newPassword></label><div class=\"sp-block-relative sp-input-block-password\"><input type=password id=newPassword class=\"form-control login-field except_policies_hidden\" name=new_password translate translate-attr-placeholder=PasswordReset.new_password ng-model=vm.new_password ng-change=vm.validate_repeat_password(confirmForm) required ng-attr-type={{vm.newPasswordType}} style=\"border-radius:.5em 0 0 .5em\"> <span class=input-group-btn><button type=button class=\"btn btn-default except_policies_hidden\" ng-click=vm.setNewPasswordType() style=\"height:42px;border-radius:0 .5em .5em 0\"><span class=\"sp-icon-show-hide except_policies_hidden\"></span></button></span></div><ng-messages for=confirmForm.new_password.$error class=sp-form-messages role=alert ng-show=confirmForm.new_password.$touched><ng-message class=sp-error-txt when=required></ng-message></ng-messages></div><div style=display:none id=password-reset-policies><password-policies data=vm.policies validation=vm.validation></password-policies></div><div class=form-group><label class=login-field-icon for=newPasswordRepeat></label><div class=\"sp-block-relative sp-input-block-password\"><input type=password id=new-password-repeat-input class=\"form-control login-field\" name=new_password_repeat translate translate-attr-placeholder=PasswordReset.repeat_password ng-change=vm.validate_repeat_password(confirmForm) ng-model=vm.new_password_repeat required ng-attr-type={{vm.newPasswordRepeatType}} style=\"border-radius:.5em 0 0 .5em\"> <span class=input-group-btn><button type=button class=\"btn btn-default except_policies_hidden\" ng-click=vm.setNewPasswordRepeatType() style=\"height:42px;border-radius:0 .5em .5em 0\"><span class=\"sp-icon-show-hide except_policies_hidden\"></span></button></span></div><ng-messages for=confirmForm.new_password_repeat.$error class=sp-form-messages role=alert ng-show=confirmForm.new_password_repeat.$dirty><ng-message class=sp-error-txt when=required translate=Login.field_required></ng-message><ng-message class=sp-error-txt when=equal translate=PasswordReset.match_password></ng-message><ng-message class=sp-error-txt when=policies></ng-message></ng-messages></div><div class=action-group><button type=submit class=\"btn btn-block btn-auth\" ng-disabled=\"confirmForm.$invalid ||\n                                 confirmForm.new_password_repeat.$error.equal ||\n                                 confirmForm.new_password_repeat.$error.policies\"><!-- The \"span\" solves the animation duration from font-awesome spinner --> <span ng-show=vm.submiting><i class=\"fa fa-spinner fa-spin\"></i> </span><span translate=PasswordReset.reset_password class=except_policies_hidden></span></button></div></form></div><div ng-show=vm.confirmed><div class=\"alert alert-success except_policies_hidden\" ng-show=vm.success><center translate=PasswordReset.reset_password_message></center></div><div class=\"alert alert-danger except_policies_hidden\" ng-show=!vm.success><center translate=PasswordReset.error_reset_password></center></div></div><center><a class=login-link ui-sref=^.login translate=Login.login></a></center></div></div></div>");
$templateCache.put("app/authentication/signup/signup.html","<div class=\"col-md-5 sp-auth-content\" ng-if=!vm.moreData><div class=sp-auth-content-left><ul><li><span class=sp-icon-check></span><span translate=Signup.message_reason_li_1></span></li><li><span class=sp-icon-check></span><span translate=Signup.message_reason_li_2></span></li><li><span class=sp-icon-check></span><span translate=Signup.message_reason_li_3></span></li><li class=sp-reasons><a translate=Signup.message_reason_li_4 ng-href={{vm.linkToOtherReasons}}></a></li></ul></div><div class=sp-auth-content-right><div class=sp-auth-panel><div class=sp-auth-panel-title><h4 translate=Signup.title></h4></div><div class=sp-auth-panel-body><form name=vm.signupForm class=form-horizontal ng-submit=vm.signup(vm.user) novalidate><div class=form-group><input type=text id=signup_name class=\"form-control signup-name\" name=signup_name translate translate-attr-placeholder=Signup.signup_name ng-model=vm.user.name required><ng-messages for=vm.signupForm.signup_name.$error class=sp-form-messages role=alert ng-show=vm.signupForm.signup_name.$dirty><ng-message class=sp-error-txt when=pattern></ng-message><ng-message class=sp-error-txt when=required translate=Login.field_required></ng-message></ng-messages></div><div class=form-group><input type=email id=signup_email class=\"form-control signup-email\" name=signup_email translate translate-attr-placeholder=Login.email ng-model=vm.user.email required><ng-messages for=vm.signupForm.signup_email.$error class=sp-form-messages role=alert ng-show=vm.signupForm.signup_email.$dirty><ng-message class=sp-error-txt when=pattern translate=Signup.incorrect_email></ng-message><ng-message class=sp-error-txt when=invalid translate=Login.existing_user></ng-message><ng-message class=sp-error-txt when=required translate=Login.field_required></ng-message></ng-messages></div><div class=form-group><input type=password id=password class=\"form-control signup-password\" name=signup_password ng-minlength=8 translate translate-attr-placeholder=Login.password ng-model=vm.user.password ng-focus=\"vm.focused = true\" ng-blur=\"vm.focused = false\" required><ng-messages for=vm.signupForm.signup_password.$error class=sp-form-messages role=alert ng-show=vm.signupForm.signup_password.$dirty><ng-message class=sp-error-txt when=pattern></ng-message><ng-message class=sp-error-txt when=minlength></ng-message><ng-message class=sp-error-txt when=required></ng-message></ng-messages><p ng-if=vm.focused><i ng-if=\"!vm.signupForm.signup_password.$error.minlength && !vm.signupForm.signup_password.$error.required\" class=\"fa fa-check-circle\" aria-hidden=true style=\"color: #32BEA8\"></i> <span translate=Signup.too_short_password ng-style=\"{color: vm.signupForm.signup_password.$error.minlength ||\n                    vm.signupForm.signup_password.$error.required ? \'#CCCCCC\' : \'#000000\'}\"></span></p></div><button type=submit class=\"btn btn-block btn-auth\" ng-disabled=vm.signupForm.$invalid translate=Login.signup></button></form></div><div class=sp-auth-panel-footer><p translate=Signup.message_footer></p></div></div></div></div><div class=\"col-md-5 sp-auth-content\" ng-if=vm.moreData><div class=sp-auth-content-right><div class=sp-auth-panel cg-busy=\"{promise: vm.promiseLoading, backdrop:true, templateUrl:\'app/shared/html/loading.html\'}\"><div class=sp-auth-panel-title><h4 translate=Signup.title_more_data></h4></div><div class=sp-auth-panel-body><form name=vm.moreDataForm class=form-horizontal ng-submit=vm.saveMoreData(vm.user) novalidate><div class=form-group><input type=text id=moreData_company class=\"form-control moreData-company\" name=moreData_company translate translate-attr-placeholder=Signup.more_data_company ng-model=vm.user.company required><ng-messages for=vm.moreDataForm.moreData_company.$error class=sp-form-messages role=alert ng-show=vm.moreDataForm.moreData_company.$dirty><ng-message class=sp-error-txt when=pattern></ng-message><ng-message class=sp-error-txt when=required translate=Login.field_required></ng-message></ng-messages></div><div class=\"form-group country\"><country-select class=form-control name=moreData_country ng-model=vm.user.country cs-priorities=\"CL,US, BR, PE, ES, MX\" cs-required></country-select><label translate=Signup.more_data_country></label><ng-messages for=vm.moreDataForm.moreData_country.$error class=sp-form-messages role=alert ng-show=vm.moreDataForm.moreData_country.$dirty><ng-message class=sp-error-txt when=pattern></ng-message><ng-message class=sp-error-txt when=required translate=Login.field_required></ng-message><ng-message class=sp-error-txt when=invalid translate=Signup.more_data_unselected_country></ng-message></ng-messages></div><div class=form-group><select name=moreData_vehicle ng-model=vm.user.vehicle class=form-control id=moreData_vehicle required><option value=\"\" selected disabled translate=Signup.more_data_vehicle></option><option value=\"1 - 5\">1 - 5 {{ \'Signup.quantity\' | translate}}</option><option value=\"6 - 10\">6 - 10 {{ \'Signup.quantity\' | translate}}</option><option value=\"11 - 20\">11 - 20 {{ \'Signup.quantity\' | translate}}</option><option value=20>20 {{ \'Signup.quantity_more\' | translate}}</option></select><ng-messages for=vm.moreDataForm.moreData_country.$error class=sp-form-messages role=alert ng-show=vm.moreDataForm.moreData_vehicle.$dirty><ng-message class=sp-error-txt when=pattern></ng-message><ng-message class=sp-error-txt when=required translate=Login.field_required></ng-message></ng-messages></div><div class=form-group><bc-phone-number id=userRegisterPhone class=form-control name=phone ng-model=vm.user.phone ng-required=true default-country=cl selected-country=cl preferred-countries=\"br cl mx pe es us\"></bc-phone-number></div><button type=submit class=\"btn btn-block btn-auth\" ng-disabled=vm.moreDataForm.$invalid translate=Signup.signup></button><ng-messages for=vm.moreDataForm.$error class=sp-form-messages role=alert><ng-message class=sp-error-txt when=pattern></ng-message><ng-message class=sp-error-txt when=invalidForm translate=Signup.wrong_form></ng-message></ng-messages></form></div></div></div></div>");
$templateCache.put("app/authentication/user-blocked/user-blocked.html","<div class=\"col-md-5 sp-auth-content\"><div class=sp-auth-content-right><div class=sp-auth-panel><div class=\"sp-auth-panel-title sp-auth-panel-title-center\"><div class=picture><img src=../../../assets/images/Ada_sad.svg alt=\"\"></div><h4 translate=UserBlocked.title></h4><h6 translate=UserBlocked.info></h6></div><div class=\"login-form sp-auth-panel-body\"><form class=form-horizontal ng-submit=vm.unlockUser()><div class=form-group><label class=\"login-field-icon fui-user\" for=usernameBlocked translate=Login.username></label><input type=text id=usernameBlocked class=\"form-control login-field\" ng-model=vm.username required> <span class=sp-error-txt ng-if=vm.showError translate=UserBlocked.unlock_error></span></div><div class=action-group><button type=submit class=\"btn btn-block btn-auth\" ng-disabled=vm.submiting><span ng-show=vm.submiting><i class=\"fa fa-spinner fa-spin\"></i> </span><span translate=Login.send></span></button></div></form></div></div><div class=login-disclaimer><a href=https://www.simpliroute.com/terminos-y-condiciones target=_blank translate=Login.termsAndConditions></a> | <a href=https://www.simpliroute.com/privacy-policy target=_blank translate=Login.privacyPolicy></a><p translate=Login.disclaimer></p></div></div></div>");
$templateCache.put("app/authentication/user-blocked/user-unlock-progress.html","<div class=\"col-md-5 sp-auth-content\"><div class=sp-auth-content-right><div class=sp-auth-panel><div class=\"sp-auth-panel-title sp-auth-panel-title-center\"><div class=picture><img src=../../../assets/images/Ada_happy.svg alt=\"\"></div><h4 translate=UserBlocked.unlock_progress></h4><h6 translate=UserBlocked.email_sent></h6></div></div><div class=login-disclaimer><a href=https://www.simpliroute.com/terminos-y-condiciones target=_blank translate=Login.termsAndConditions></a> | <a href=https://www.simpliroute.com/privacy-policy target=_blank translate=Login.privacyPolicy></a><p translate=Login.disclaimer></p></div></div></div>");
$templateCache.put("app/dashboard/components/areaGraph.html","<div class=\"sp-dashboards-widget visit-checkouts-widget\"><div class=widget-title><span translate=Dashboard.checkoutGraph.title></span></div><div class=widget-body><div class=row><div class=col-sm-3><div class=sp-legend-item><div class=\"color-box in-window\"></div><div class=text translate=Dashboard.checkoutGraph.visits_total></div></div></div><div class=\"col-sm-7 pull-right\"><div class=sp-legend-item><div><hr></div><div class=text translate=Dashboard.checkoutGraph.visits_window></div></div></div></div></div></div><div class=sp-checkout-wrapper><nvd3 options=$ctrl.data.options data=$ctrl.data.data></nvd3></div>");
$templateCache.put("app/dashboard/components/barGraph.html","<div class=sp-dashboards-widget><div class=widget-title><span translate=Dashboard.BarGraph.title></span></div><div class=widget-body><div class=sp-legends><div class=sp-legend-item><div class=\"color-box succeded\"></div><div class=text translate=Dashboard.BarGraph.visits_completed></div></div><div class=sp-legend-item><div class=\"color-box failed\"></div><div class=text translate=Dashboard.BarGraph.visits_failed></div></div><div class=sp-legend-item><div class=\"color-box pending\"></div><div class=text translate=Dashboard.BarGraph.visits_pending></div></div></div></div></div><div class=sp-graphic-wrapper><nvd3 options=$ctrl.data.options data=$ctrl.data.data></nvd3></div>");
$templateCache.put("app/dashboard/components/indicator.html","<div class=sp-indicator-widget><div class=sp-indicator-title>{{$ctrl.data.title}}</div><div class=sp-indicator-value>{{$ctrl.data.value}}</div><div class=\"row sp-indicator-icons\"><div class=col-sm-6><span class=sp-indicator-icon ng-repeat=\"eventIcon in $ctrl.data.eventIcons\"><i class={{eventIcon.icon}} ng-class=\"{\'active\' : eventIcon.active}\" ng-click=eventIcon.clickEvent(eventIcon.indicatorName)></i></span></div><div class=col-sm-6><div class=sp-indicator-data-improvement><div class={{$ctrl.data.classDiv}}><a href=\"\" class=content tooltip-placement=top uib-tooltip=\"{{\'Dashboard.Indicators.message_tooltip\' | translate}}\"><div class={{$ctrl.data.classIcon}}></div><div class=data>{{$ctrl.data.perceChange}}</div></a></div></div></div></div></div>");
$templateCache.put("app/dashboard/components/pieGraph.html","<div class=\"sp-dashboards-widget observation-widget\"><div class=widget-title><span translate=Dashboard.ObservationPieGraph.title_failed ng-if=$ctrl.data.typeFailedActive></span> <span translate=Dashboard.ObservationPieGraph.title_completed ng-if=!$ctrl.data.typeFailedActive></span><div class=change-view><a href=\"\" ng-click=$ctrl.changeView($ctrl.data.type) ng-class=\"{\'active\': $ctrl.data.type === \'failed\'}\" translate=Dashboard.ObservationPieGraph.failed></a> | <a href=\"\" ng-click=$ctrl.changeView($ctrl.data.type) ng-class=\"{\'active\': $ctrl.data.type === \'completed\'}\" translate=Dashboard.ObservationPieGraph.completed></a></div></div><div class=graph-container><div class=observations-legend><div class=observation ng-repeat=\"observation in $ctrl.data.data | limitTo:6\"><div class=ident-color ng-style=\"observation.color && {\'border\':\'2px solid\', \'border-color\':observation.color}\"></div><span>{{observation.key}}</span></div></div><div class=observations-graph><nvd3 options=$ctrl.data.options data=$ctrl.data.data></nvd3><div class=total ng-if=\"$ctrl.data.total.total > 0\"><div class=number>{{$ctrl.data.total.total}}</div><div class=text ng-if=\"$ctrl.data.type === \'failed\'\" translate=Dashboard.ObservationPieGraph.total_text_failed></div><div class=text ng-if=\"$ctrl.data.type === \'completed\'\" translate=Dashboard.ObservationPieGraph.total_text_completed></div></div></div></div></div>");
$templateCache.put("app/dashboard/components/report.html","<div class=\"sp-dashboards-widget sp-report-widget\"><div class=widget-title><span translate={{$ctrl.data.title}}></span></div><div class=sp-report-widget-container><form class=sp-form name=$ctrl.report><div class=row><label class=\"col-sm-12 control-label\" translate=Dashboard.Reports.report_from></label></div><div class=row><div class=\"col-sm-12 sp-block-relative sp-plan-date-input\"><input type=text class=form-control name=startDate uib-datepicker-popup=dd-MM-yyyy ng-model=$ctrl.reportStart.model ng-change=$ctrl.validateDates() ng-required=true form-reference=report is-open=$ctrl.reportStart.opened datepicker-options=$ctrl.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-plan-date\" ng-class=\"{\'btn-border-invalid\':$ctrl.report.startDate.$error.endDate_gt_startDate || $ctrl.report.startDate.$error.invalid_dateRange}\" ng-click=\"$ctrl.reportStart.opened = !$ctrl.reportStart.opened\"><span class=sp-icon-calendario></span></button></span></div></div><div class=row><label class=\"col-sm-1 control-label\" translate=Dashboard.Reports.report_to></label></div><div class=row><div class=\"col-sm-12 sp-block-relative sp-plan-date-input\"><input type=text class=form-control name=endDate uib-datepicker-popup=dd-MM-yyyy ng-model=$ctrl.reportEnd.model ng-change=$ctrl.validateDates() ng-required=true form-reference=report is-open=$ctrl.reportEnd.opened datepicker-options=$ctrl.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-plan-date\" ng-class=\"{\'btn-border-invalid\':report.endDate.$error.endDate_gt_startDate || $ctrl.report.startDate.$error.invalid_dateRange} \" ng-click=\"$ctrl.reportEnd.opened=!$ctrl.reportEnd.opened\"><span class=sp-icon-calendario></span></button></span></div></div><div class=row><label class=\"col-sm-12 control-label\" translate=Dashboard.Reports.recipient_email></label></div><div class=\"row sp-row-form-report\"><div class=\"col-sm-12 sp-block-relative\"><input type=email class=form-control name=email ng-model=$ctrl.emailReport ng-required=true ng-change=$ctrl.validateEmail()></div></div><div class=\"row warning-section\" ng-messages=$ctrl.formErrors><span ng-message=dateRangeError translate=Dashboard.Reports.error_between_dates></span> <span ng-message=startDateError translate=Dashboard.Reports.error_date_start></span> <span ng-message=emailError translate=Dashboard.Reports.error_invalid_email></span></div><div class=\"row sp-row-form-report\"><div class=\"col-xs-10 col-xs-offset-1\"><button type=button class=\"col-xs-12 btn btn-primary sp-button-tc-report\" ng-disabled=\"!$ctrl.submitButtonActive || $ctrl.data.loading\" ng-click=\"$ctrl.onSubmit($ctrl.reportStart.model, $ctrl.reportEnd.model, $ctrl.emailReport)\"><span translate={{$ctrl.data.submitButtonLabel}}></span></button></div></div></form></div></div>");
$templateCache.put("app/dashboard/components/visitsGraphicsModal.html","<div class=sp-image-without-graphics-bg></div><div class=sp-modal><div class=sp-visits-graphic-modal-without><div class=title><span translate=Dashboard.Visits.Modal.title></span></div><div class=sp-image><svg version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 250 250\" enable-background=\"new 0 0 250 250\" xml:space=preserve width=285 height=294><g><g><path fill=#BDDDF4 d=M105.6,211.3v-39.3c0-21.2-18.6-38.6-41.3-38.6h0c-22.7,0-41.3,17.4-41.3,38.6v39.3H105.6z /><circle fill=#616262 cx=64.3 cy=58.4 r=41.9 /><path fill=#CCA181 d=\"M64.3,155.9L64.3,155.9c-5.4,0-9.9-4.5-9.9-9.9v-22.2c0-5.4,4.5-9.9,9.9-9.9h0c5.4,0,9.9,4.5,9.9,9.9V146\n			C74.3,151.4,69.8,155.9,64.3,155.9z\"/><g><circle fill=#EBC19C cx=101 cy=79.1 r=8.3 /><circle fill=#DFB28B cx=101 cy=79.1 r=4.6 /></g><g><circle fill=#EBC19C cx=27.7 cy=79.1 r=8.3 /><circle fill=#DFB28B cx=27.7 cy=79.1 r=4.6 /></g><path fill=#EBC19C d=\"M64.3,126.3L64.3,126.3c-20.2,0-36.6-16.4-36.6-36.6V61.4c0-20.2,16.4-36.6,36.6-36.6l0,0\n			c20.2,0,36.6,16.4,36.6,36.6v28.3C101,109.9,84.6,126.3,64.3,126.3z\"/><path fill=#212121 d=\"M91.4,56.5c0,1-0.8,1.8-1.8,1.8H77c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h12.6\n			C90.6,54.7,91.4,55.5,91.4,56.5L91.4,56.5z\"/><path fill=#212121 d=\"M53.4,60.1c0,1-0.8,1.8-1.8,1.8H39c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h12.6\n			C52.6,58.3,53.4,59.1,53.4,60.1L53.4,60.1z\"/><path fill=#263238 d=\"M47.2,68.8v1.6c0,1-0.8,1.9-1.9,1.9l0,0c-1,0-1.9-0.8-1.9-1.9v-1.6c0-1,0.8-1.9,1.9-1.9l0,0\n			C46.4,66.9,47.2,67.8,47.2,68.8z\"/><path fill=#263238 d=\"M85.2,68.8v1.6c0,1-0.8,1.9-1.9,1.9l0,0c-1,0-1.9-0.8-1.9-1.9v-1.6c0-1,0.8-1.9,1.9-1.9l0,0\n			C84.4,66.9,85.2,67.8,85.2,68.8z\"/><path fill=#DC9D95 d=\"M71.6,91.5c0,4-3.3,7.3-7.3,7.3l0,0c-4,0-7.3-3.3-7.3-7.3V74.2c0-4,3.3-7.3,7.3-7.3l0,0\n			c4,0,7.3,3.3,7.3,7.3V91.5z\"/><g><path fill=none d=M44,84.4c6.5,0,12-4.6,13.3-10.7H30.7C32,79.8,37.5,84.4,44,84.4z /><path fill=none d=M71.3,73.7c0.3,1.5,0.9,2.9,1.7,4.2l4.2-4.2H71.3z /><path fill=none d=M84.7,84.4c6.5,0,12-4.6,13.3-10.7H83.7l-7.6,7.6C78.4,83.3,81.4,84.4,84.7,84.4z /><g><path fill=none d=M30.7,73.7c0.3,1.4,0.8,2.7,1.5,3.9l3.9-3.9H30.7z /><path fill=none d=M44,84.4c6.5,0,12-4.6,13.3-10.7H42.5l-7.4,7.4C37.5,83.2,40.6,84.4,44,84.4z /><path fill=#ECEFF0 d=M32.2,77.6c0.8,1.3,1.8,2.5,2.9,3.5l7.4-7.4h-6.4L32.2,77.6z /></g><path fill=#ECEFF0 d=M73.1,78c0.8,1.3,1.8,2.4,3,3.4l7.6-7.6h-6.4L73.1,78z /><path fill=#010101 d=\"M86.7,70.7h-6.4h-9H68h-7.4h-2.6H45.5h-6.4H27.3c0,3.3,1,6.4,2.7,9c0.8,1.3,1.8,2.4,3,3.4\n				c2.9,2.6,6.8,4.2,11,4.2c8.2,0,15-6,16.4-13.8h7.9c0.4,2.4,1.3,4.6,2.6,6.5c0.9,1.3,1.9,2.4,3,3.4c2.9,2.4,6.6,3.9,10.7,3.9\n				c9.2,0,16.7-7.5,16.7-16.7H86.7z M44,84.4c-3.4,0-6.5-1.2-8.9-3.3c-1.2-1-2.1-2.2-2.9-3.5c-0.7-1.2-1.2-2.5-1.5-3.9h5.4h6.4h14.8\n				C56,79.8,50.5,84.4,44,84.4z M84.7,84.4c-3.2,0-6.2-1.1-8.6-3c-1.2-1-2.2-2.1-3-3.4c-0.8-1.3-1.4-2.7-1.7-4.2h6h6.4H98\n				C96.6,79.8,91.2,84.4,84.7,84.4z\"/></g><path fill=#DFB28B d=\"M114.6,210.9L114.6,210.9c-4.1,1.3-8.5-0.9-9.9-5l-29.6-91.5c-1.3-4.1,0.9-8.5,5-9.9l0,0\n			c4.1-1.3,8.5,0.9,9.9,5l29.6,91.5C121,205.1,118.7,209.6,114.6,210.9z\"/><path fill=#DFB28B d=\"M87.1,91.4L87.1,91.4c-1.7,0-3,1.3-3,3v7.1c-0.3-0.1-0.7-0.2-1-0.2H40.9c-1.6,0-3,1.3-3,3v0.1\n			c0,1.6,1.3,3,3,3l9.6,0c-1.6,0-3,1.3-3,3v0.1c0,1.6,1.3,3,3,3c-1.6,0-3,1.3-3,3v0.1c0,1.6,1.3,3,3,3h3.2c-1.6,0-3,1.3-3,3v0.1\n			c0,1.6,1.3,3,3,3h32.9c1.6,0,3-1.3,3-3v-0.1c0-0.2,0-0.4-0.1-0.5c0.3-0.4,0.4-1,0.4-1.5v-3.8v-0.1v-5.9v-0.1V94.3\n			C90.1,92.7,88.7,91.4,87.1,91.4z\"/><g><path fill=#434343 d=\"M77.6,27.2c-0.5,5.2-2,10-4.3,14.5c3.7,9.7,13.1,16.6,24.1,16.6c1.2,0,2.3-0.1,3.4-0.2\n				C99.6,44,90.3,32.2,77.6,27.2z\"/><path fill=#616262 d=\"M72.8,24.4c-2.7-0.6-5.9-0.1-8.8-0.1c-20.2,0-36.8,17-36.8,37.2l0.4,2.5c2.7,0.5,5.4,0.8,8.2,0.8\n				c16.3,0,30.5-9.4,37.4-23c2.2-4.4,3.9-10.1,4.4-15.2C76.1,25.9,74.5,24.8,72.8,24.4z\"/></g></g><g><g><polygon fill=#CDCCCC points=\"120.2,182.2 94.3,156.3 89.3,156.3 120.2,187.4 			\"/><path fill=#CDCCCC d=M114.1,156l-10.8,0.3l16.9,16.8V162C120.2,158.6,117.5,156,114.1,156z /><path fill=#CDCCCC d=\"M12.1,164l4.6,63.9c0,3.5,2.8,6.3,6.3,6.3l88.7,0c3.2-0.6,5.5-3.3,5.5-6.6l2.9-30.9l-40-40.2H19.2\n				C15.3,156.5,12.1,160,12.1,164z\"/><polygon fill=#CDCCCC points=\"120.2,173.1 103.3,156.3 94.3,156.3 120.2,182.2 			\"/><polygon opacity=0.5 fill=#FFFFFF points=\"120.2,173.1 103.3,156.3 94.3,156.3 120.2,182.2 			\"/><polygon fill=#CDCCCC points=\"89.3,156.3 80.4,156.3 120.2,196.6 120.2,187.4 			\"/><polygon opacity=0.5 fill=#FFFFFF points=\"89.3,156.3 80.3,156.3 120.2,196.6 120.2,187.4 			\"/></g><g opacity=0.5><g><g><path fill=#FFFFFF d=\"M67.6,188.5c0,0.7-0.4,1.2-1,1.5v4.5c0.2,0.1,0.4,0.2,0.6,0.3l3-2.6c0-0.2-0.1-0.3-0.1-0.5\n						c0-0.8,0.5-1.4,1.2-1.7c-1-0.9-2.3-1.6-3.7-1.9C67.6,188.3,67.6,188.4,67.6,188.5L67.6,188.5z\"/></g></g><g><g><path fill=#FFFFFF d=\"M71.8,193.5c-0.3,0-0.6-0.1-0.9-0.3l-2.9,2.6c0.1,0.2,0.1,0.5,0.1,0.7l0,0.1c0,0.4-0.1,0.7-0.2,1\n						l2.2,2.8c0.2-0.1,0.3-0.1,0.5-0.1c0.7,0,1.3,0.5,1.6,1.1c1.1-1.4,1.8-3.2,1.8-5.1c0-1.3-0.3-2.5-0.8-3.6\n						C72.9,193.2,72.4,193.5,71.8,193.5z\"/></g></g><g><g><path fill=#FFFFFF d=\"M68.8,202c0-0.4,0.1-0.8,0.3-1.1l-2.1-2.6c-0.3,0.2-0.8,0.4-1.2,0.4c-0.3,0-0.6-0.1-0.9-0.2l-2.4,2.4\n						c0.1,0.2,0.1,0.4,0.1,0.6l0,0c0,0.7-0.4,1.3-1.1,1.6c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c1.2,0.7,2.6,1.1,4,1.1\n						c1.3,0,2.6-0.3,3.7-0.9C69.1,203.1,68.8,202.6,68.8,202z\"/></g></g><g><g><path fill=#FFFFFF d=\"M61,199.9c0.2,0,0.4,0,0.6,0.1l2.3-2.4c-0.2-0.3-0.3-0.7-0.3-1.1c0-1,0.7-1.9,1.6-2.1V190\n						c-0.6-0.2-1-0.8-1-1.5c0-0.1,0-0.2,0-0.3c-3.8,0.7-6.6,4-6.6,8c0,1.9,0.6,3.6,1.7,5C59.6,200.4,60.3,199.9,61,199.9z\n						 M61.1,193.6c0.6,0,1,0.5,1,1l0,0c0,0.6-0.5,1.1-1,1.1c-0.6,0-1-0.5-1-1.1C60.1,194.1,60.6,193.6,61.1,193.6z\"/></g></g></g></g><path fill=#FAFBFB stroke=#90A4AE stroke-miterlimit=10 d=\"M225.5,95.5h-94.7c-2.8,0-5-2.3-5-5V32.2c0-2.8,2.3-5,5-5h94.7\n		c2.8,0,5,2.3,5,5v58.2C230.5,93.2,228.3,95.5,225.5,95.5z\"/><g><polyline fill=#FAFBFB points=\"131.4,87.3 146.4,44.4 162.9,72.3 167.9,56.5 179.7,64.8 187.4,44.4 199.4,53.6 220.7,35.9 		\"/><g><polyline fill=none stroke=#607D8B stroke-width=2 stroke-linecap=round stroke-linejoin=round points=\"131.4,87.3\n				146.4,44.4 162.9,72.3 167.9,56.5 179.7,64.8 187.4,44.4 199.4,53.6 215.2,40.5 			\"/><g><polygon fill=#607D8B points=\"217.3,45.3 220.7,35.9 210.9,37.6 				\"/></g></g></g><circle fill=#A0A8D5 cx=154.6 cy=137.5 r=21.5 /><g><path fill=#5E6BB2 d=M180.5,130.9c-3-11.6-13.4-20.1-25.9-20.1v26.7L180.5,130.9z /></g><g><path fill=#25A69A d=\"M209.9,184.9l-12.8-12.8c-0.4-0.4-1-0.4-1.4,0l-12.8,12.8c-0.4,0.4-0.4,1,0,1.4h7.5v13\n			c0,0.7,0.6,1.3,1.3,1.3h9.3c0.7,0,1.3-0.6,1.3-1.3v-13h7.5C210.3,185.9,210.3,185.3,209.9,184.9z\"/><g><path fill=#4E4E4E d=\"M222,182c0,2.2-0.4,3.8-1.3,4.9c-0.8,1.1-2.1,1.6-3.7,1.6c-1.6,0-2.8-0.6-3.6-1.7\n				c-0.9-1.1-1.3-2.7-1.3-4.9c0-4.3,1.6-6.5,4.9-6.5c1.6,0,2.8,0.6,3.7,1.7C221.5,178.4,222,180,222,182z M215.7,182.1\n				c0,1.2,0.1,2.1,0.3,2.7s0.6,0.9,1,0.9c0.9,0,1.4-1.2,1.4-3.6c0-2.4-0.5-3.5-1.4-3.5c-0.5,0-0.8,0.3-1,0.9\n				S215.7,180.9,215.7,182.1z M231.7,175.9l-11.5,20.7h-3.4l11.5-20.7H231.7z M236.5,190.3c0,2.2-0.4,3.8-1.3,4.9\n				c-0.8,1.1-2.1,1.6-3.7,1.6c-1.6,0-2.8-0.6-3.6-1.7c-0.9-1.1-1.3-2.7-1.3-4.8c0-4.3,1.6-6.5,4.9-6.5c1.6,0,2.8,0.6,3.7,1.7\n				C236.1,186.6,236.5,188.2,236.5,190.3z M230.2,190.4c0,1.2,0.1,2.1,0.3,2.7c0.2,0.6,0.6,0.9,1,0.9c0.9,0,1.4-1.2,1.4-3.6\n				c0-2.4-0.5-3.5-1.4-3.5c-0.5,0-0.8,0.3-1,0.9C230.3,188.3,230.2,189.2,230.2,190.4z\"/></g></g><g><g><line fill=none stroke=#013F52 stroke-miterlimit=10 x1=123.2 y1=204.4 x2=125.7 y2=204.4 /><line fill=none stroke=#013F52 stroke-miterlimit=10 stroke-dasharray=5.2799,5.2799 x1=131 y1=204.4 x2=149.5 y2=204.4 /><polyline fill=none stroke=#013F52 stroke-miterlimit=10 points=\"152.1,204.4 154.6,204.4 154.6,201.9 			\"/><line fill=none stroke=#013F52 stroke-miterlimit=10 stroke-dasharray=4.6019,4.6019 x1=154.6 y1=197.3 x2=154.6 y2=171.9 /><line fill=none stroke=#013F52 stroke-miterlimit=10 x1=154.6 y1=169.6 x2=154.6 y2=167.1 /></g></g><polyline fill=none stroke=#013F52 stroke-miterlimit=10 stroke-dasharray=5,5 points=\"123.2,175.6 128.2,175.6\n		128.2,104.1 	\"/><polyline fill=none stroke=#013F52 stroke-miterlimit=10 stroke-dasharray=5,5 points=\"123.2,217.6 210.2,217.6\n		210.2,200.6 	\"/></g></svg></div><div class=footer-message><span translate=Dashboard.Visits.Modal.footer-message></span></div><div class=footer-buttons><button class=\"btn btn-primary\" translate=Dashboard.Visits.Modal.footer-button ng-click=$ctrl.openModalConfirmation()></button></div></div></div>");
$templateCache.put("app/dashboard/externalDashboard/externalDashboard.html","<iframe-directive class=sp-external-dashboard__extension site-url={{vm.url}}></iframe-directive>");
$templateCache.put("app/dashboard/reports/reports.html","<!-- Reports --><div class=sp-dashboard-download-reports><div class=sp-panel-container><div class=row><!-- visit history --><div class=\"col-xs-12 col-sm-6\" ng-if=vm.visitHistoryReportEnabled><div class=\"panel sp-panel-report-dashboard\"><div class=panel-heading translate=General.visits_report></div><div class=panel-body><form class=sp-form name=visitHistoryReport><div class=form-group><label class=\"col-sm-1 control-label\" translate=General.report_from></label><div class=\"col-sm-5 sp-block-relative sp-plan-date-input-on-white-bg\"><input type=text class=\"form-control input-form\" name=startDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.visitHistoryReportStart.model ng-change=\"vm.validateReportDate(vm.visitHistoryReportStart.model, vm.visitHistoryReportEnd.model, \'visitHistoryReport\')\" ng-required=true is-open=vm.visitHistoryReportStart.opened datepicker-options=vm.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-report-date\" ng-class=\"{\'btn-border-invalid\':visitHistoryReport.startDate.$error.endDate_gt_startDate}\" ng-click=\"vm.visitHistoryReportStart.opened = !vm.visitHistoryReportStart.opened\"><span class=\"sp-icon-calendario input-icon\"></span></button></span></div><label class=\"col-sm-1 control-label text-center\" translate=General.report_to></label><div class=\"col-sm-5 sp-block-relative sp-plan-date-input-on-white-bg\"><input type=text class=\"form-control input-form\" name=endDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.visitHistoryReportEnd.model ng-change=\"vm.validateReportDate(vm.visitHistoryReportStart.model, vm.visitHistoryReportEnd.model, \'visitHistoryReport\')\" ng-required=true is-open=vm.visitHistoryReportEnd.opened datepicker-options=vm.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-report-date\" ng-class=\"{\'btn-border-invalid\':visitHistoryReport.endDate.$error.endDate_gt_startDate}\" ng-click=\"vm.visitHistoryReportEnd.opened = !vm.visitHistoryReportEnd.opened\"><span class=\"sp-icon-calendario input-icon\"></span></button></span></div><br><div class=\"col-md-10 col-md-offset-1 settings-error-between-dates\"><span ng-show=vm.visitHistoryReport.settingsErrorBetweenDates translate=General.error_between_dates></span> <span ng-show=vm.visitHistoryReport.settingsErrorDateStart translate=General.error_date_start></span></div></div><div class=sp-flex-form-group><button type=button class=\"btn btn-primary btn-export\" ng-disabled=\"!visitHistoryReport.$valid || vm.disableReportBtn\" ng-click=\"vm.exportVisitHistoryReport(vm.visitHistoryReportStart.model, vm.visitHistoryReportEnd.model)\"><span translate=General.export></span></button></div></form></div></div></div><!-- kilometers report --><div class=\"col-xs-12 col-sm-6\"><div class=\"panel sp-panel-report-dashboard\"><div class=panel-heading translate=General.routes_report></div><div class=panel-body><form class=\"form-horizontal sp-form\" name=kilometers_report novalidate><div class=\"form-group sp-margin-bottom-5\"><label class=\"col-sm-1 control-label\" translate=General.report_from></label><div class=\"col-sm-5 sp-block-relative sp-plan-date-input-on-white-bg\"><input type=text class=\"form-control input-form\" name=startDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.kmReportStartDate.model ng-change=\"vm.validateReportDate(vm.kmReportStartDate.model, vm.kmReportEndDate.model, \'kilometers_report\')\" ng-required=true is-open=vm.kmReportStartDate.opened datepicker-options=vm.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-report-date\" ng-class=\"{\'btn-border-invalid\':kilometers_report.startDate.$error.endDate_gt_startDate}\" ng-click=\"vm.kmReportStartDate.opened=!vm.kmReportStartDate.opened\"><span class=\"sp-icon-calendario input-icon\"></span></button></span></div><label class=\"col-sm-1 control-label text-center\" translate=General.report_to></label><div class=\"col-sm-5 sp-block-relative sp-plan-date-input-on-white-bg\"><input type=text class=\"form-control input-form\" name=endDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.kmReportEndDate.model ng-change=\"vm.validateReportDate(vm.kmReportStartDate.model, vm.kmReportEndDate.model, \'kilometers_report\')\" ng-required=true is-open=vm.kmReportEndDate.opened datepicker-options=vm.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-report-date\" ng-class=\"{\'btn-border-invalid\':kilometers_report.endDate.$error.endDate_gt_startDate}\" ng-click=\"vm.kmReportEndDate.opened=!vm.kmReportEndDate.opened\"><span class=\"sp-icon-calendario input-icon\"></span></button></span></div><div class=\"col-md-10 col-md-offset-1 settings-error-between-dates text-center\"><span ng-show=vm.kilometers_report.settingsErrorBetweenDates translate=General.error_between_dates></span> <span ng-show=vm.kilometers_report.settingsErrorDateStart translate=General.error_date_start></span></div></div><div class=\"item sp-select-all checkbox-report\" ng-show=vm.userHasOrganization tooltip-class=tooltip-checkbox-reports uib-tooltip=\"{{ \'Dashboard.Reports.all_accounts_checkbox\' | translate }}\"><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-model=vm.routesReportCheckbox><label><span class=sp-icon-check></span></label></div><span class=report-label translate=Dashboard.Reports.include_all_accounts></span></div><div class=sp-flex-form-group><button type=button ng-click=\"kilometers_report.$valid && vm.exportRoutesReport()\" ng-disabled=\"kilometers_report.$invalid || vm.generating_report\" class=\"btn btn-primary btn-large btn-export col-sm-2\"><span translate=General.export></span></button></div></form></div></div></div><!-- Tracking code report --><div class=\"col-xs-12 col-sm-6\"><div class=\"panel sp-panel-report-dashboard\"><div class=panel-heading translate=General.tracking_codes_visits_report></div><div class=panel-body><form class=sp-form name=tc_report><div class=row><label class=\"col-sm-1 control-label\" translate=General.report_from></label><div class=\"col-sm-5 sp-block-relative sp-plan-date-input-on-white-bg\"><input type=text class=\"form-control input-form\" name=startDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.tcReportStart.model ng-change=\"vm.validateReportDate(vm.tcReportStart.model, vm.tcReportEnd.model, \'tc_report\')\" ng-required=true is-open=vm.tcReportStart.opened datepicker-options=vm.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-report-date\" ng-class=\"{\'btn-border-invalid\':tc_report.startDate.$error.endDate_gt_startDate}\" ng-click=\"vm.tcReportStart.opened = !vm.tcReportStart.opened\"><span class=\"sp-icon-calendario input-icon\"></span></button></span></div><label class=\"col-sm-1 control-label text-center\" translate=General.report_to></label><div class=\"col-sm-5 sp-block-relative sp-plan-date-input-on-white-bg\"><input type=text class=\"form-control input-form\" name=endDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.tcReportEnd.model ng-change=\"vm.validateReportDate(vm.tcReportStart.model, vm.tcReportEnd.model, \'tc_report\')\" ng-required=true is-open=vm.tcReportEnd.opened datepicker-options=vm.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-report-date\" ng-class=\"{\'btn-border-invalid\':tc_report.endDate.$error.endDate_gt_startDate}\" ng-click=\"vm.tcReportEnd.opened=!vm.tcReportEnd.opened\"><span class=\"sp-icon-calendario input-icon\"></span></button></span></div><div class=\"col-md-10 col-md-offset-1 sp-tc-report-span\"><span ng-show=vm.tc_report.settingsErrorBetweenDates translate=General.error_between_dates></span> <span ng-show=vm.tc_report.settingsErrorDateStart translate=General.error_date_start></span></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=General.tracking_code_user_email></label><div class=\"col-sm-9 sp-block-relative\"><input type=email class=\"form-control form-input-new-white-bg\" name=email ng-model=vm.emailTcReport ng-required=true></div></div><div class=\"item sp-select-all checkbox-report\" ng-show=vm.userHasOrganization tooltip-class=tooltip-checkbox-reports uib-tooltip=\"{{ \'Dashboard.Reports.all_accounts_checkbox\' | translate }}\"><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-model=vm.visitsReportCheckbox><label><span class=sp-icon-check></span></label></div><span class=report-label translate=Dashboard.Reports.include_all_accounts></span></div><div class=sp-flex-form-group><button type=button class=\"btn btn-primary btn-export sp-button-tc-report\" ng-disabled=\"!tc_report.$valid || vm.disableTcReportBtn\" ng-click=\"vm.exportTcReport(vm.tcReportStart.model, vm.tcReportEnd.model)\"><span translate=General.export></span></button></div></form></div></div></div><!-- Optimization report --><div class=\"col-xs-12 col-sm-6\" ng-show=vm.enableOptimizationRequestsReport><div class=\"panel sp-panel-report-dashboard\"><div class=panel-heading translate=General.optimization_requests_report></div><div class=panel-body><form class=sp-form name=or_report><div class=form-group><label class=\"col-sm-1 control-label\" translate=General.report_from></label><div class=\"col-sm-5 sp-block-relative sp-plan-date-input-on-white-bg\"><input type=text class=\"form-control input-form\" name=startDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.orReportStart.model ng-required=true ng-change=\"vm.validateReportDate(vm.orReportStart.model, vm.orReportEnd.model, \'or_report\')\" is-open=vm.orReportStart.opened datepicker-options=vm.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-report-date\" ng-class=\"{\'btn-border-invalid\':or_report.startDate.$error.endDate_gt_startDate}\" ng-click=\"vm.orReportStart.opened = !vm.orReportStart.opened\"><span class=\"sp-icon-calendario input-icon\"></span></button></span></div><label class=\"col-sm-1 control-label text-center\" translate=General.report_to></label><div class=\"col-sm-5 sp-block-relative sp-plan-date-input-on-white-bg\"><input type=text class=\"form-control input-form\" name=endDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.orReportEnd.model ng-required=true ng-change=\"vm.validateReportDate(vm.orReportStart.model, vm.orReportEnd.model, \'or_report\')\" is-open=vm.orReportEnd.opened datepicker-options=vm.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-report-date\" ng-class=\"{\'btn-border-invalid\':or_report.endDate.$error.endDate_gt_startDate}\" ng-click=\"vm.orReportEnd.opened=!vm.orReportEnd.opened\"><span class=\"sp-icon-calendario input-icon\"></span></button></span></div><div class=\"col-md-10 col-md-offset-1 settings-error-between-dates text-center\"><span ng-show=vm.or_report.settingsErrorBetweenDates translate=General.error_between_dates></span> <span ng-show=vm.or_report.settingsErrorDateStart translate=General.error_date_start></span></div></div><div class=sp-flex-form-group><button type=button class=\"btn btn-primary btn-export\" ng-disabled=\"!or_report.$valid || vm.disableOrReportBtn\" ng-click=\"vm.exportOrReport(vm.orReportStart.model, vm.orReportEnd.model)\"><span translate=General.export></span></button></div></form></div></div></div><!-- Logs report --><div class=\"col-xs-12 col-sm-6\" ng-show=vm.enableLogReport><div class=\"panel sp-panel-report-dashboard\"><div class=panel-heading translate=Log_report.edition></div><div class=panel-body><form class=\"form-horizontal sp-form\" name=log_report novalidate><div class=form-group><label class=\"control-label col-sm-1\">Cliente</label><ui-select class=col-sm-11 name=clientName ng-model=vm.logReportClient spinner-enabled=true spinner-class=\"fa fa-spinner fa-pulse\" theme=bootstrap reset-search-input=true ng-click=vm.loadAllClients() required><ui-select-match class=form-select-on-white-bg placeholder=\"{{\'Log_report.select_client\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"client in vm.clients track by client.id\" refresh=vm.refreshClients($select.search) refresh-delay=0 minimum-input-length=3 position=\"\'auto\'\" class=form-select-on-white-bg><div ng-bind-html=client.name></div></ui-select-choices></ui-select><ng-messages for=log_report.clientName.$error class=\"sp-form-messages col-sm-6 col-sm-offset-3\"><ng-message translate=Log_report.client_required class=sp-settings-invalid-help-block when=required></ng-message></ng-messages></div><div class=form-group><label class=\"col-sm-1 control-label\" translate=General.report_from></label><div class=\"col-sm-5 sp-block-relative sp-plan-date-input-on-white-bg\"><input type=text class=\"form-control input-form\" name=startDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.logReportStartDate.model ng-change=\"vm.validateReportDate(vm.logReportStartDate.model, vm.logReportEndDate.model, \'log_report\')\" ng-required=true is-open=vm.logReportStartDate.opened datepicker-options=vm.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-report-date\" ng-class=\"{\'btn-border-invalid\':log_report.startDate.$error.endDate_gt_startDate}\" ng-click=\"vm.logReportStartDate.opened=!vm.logReportEndDate.opened\"><span class=\"sp-icon-calendario input-icon\"></span></button></span></div><label class=\"col-sm-1 control-label text-center\" translate=General.report_to></label><div class=\"col-sm-5 sp-block-relative sp-plan-date-input-on-white-bg\"><input type=text class=\"form-control input-form\" name=endDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.logReportEndDate.model ng-change=\"vm.validateReportDate(vm.logReportEndDate.model, vm.logReportEndDate.model, \'log_report\')\" ng-required=true is-open=vm.logReportEndDate.opened datepicker-options=vm.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-report-date\" ng-class=\"{\'btn-border-invalid\':log_report.endDate.$error.endDate_gt_startDate}\" ng-click=\"vm.logReportEndDate.opened=!vm.logReportEndDate.opened\"><span class=\"sp-icon-calendario input-icon\"></span></button></span></div><div class=\"col-md-10 col-md-offset-1 settings-error-between-dates text-center\"><span ng-show=vm.log_report.settingsErrorBetweenDates translate=General.error_between_dates></span> <span ng-show=vm.log_report.settingsErrorDateStart translate=General.error_date_start></span></div></div><div class=sp-flex-form-group><button type=button ng-click=\"log_report.$valid && vm.exportLogReport()\" ng-disabled=\"log_report.$invalid || vm.generating_report\" class=\"btn btn-primary btn-large btn-export\"><span translate=General.export></span></button></div></form></div></div></div><!-- download visit images report --><div class=\"col-xs-12 col-sm-6\"><div class=\"panel sp-panel-report-dashboard\"><div class=panel-heading translate=General.visit_images_title_report></div><div class=panel-body><form class=sp-form name=visitImagesReport novalidate><div class=\"form-group sp-margin-bottom-5\"><label class=\"col-sm-1 control-label\" translate=General.report_from></label><div class=\"col-sm-5 sp-block-relative sp-plan-date-input-on-white-bg\"><input type=text class=\"form-control input-form\" name=startDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.downloadVisitReportStartDate.model ng-change=\"vm.validateReportDate(vm.downloadVisitReportStartDate.model, vm.downloadVisitReportEndDate.model, \'visitImagesReport\')\" ng-required=true is-open=vm.downloadVisitReportStartDate.opened datepicker-options=vm.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-report-date\" ng-class=\"{\'btn-border-invalid\':kilometers_report.startDate.$error.endDate_gt_startDate}\" ng-click=\"vm.downloadVisitReportStartDate.opened=!vm.downloadVisitReportStartDate.opened\"><span class=\"sp-icon-calendario input-icon\"></span></button></span></div><label class=\"col-sm-1 control-label text-center\" translate=General.report_to></label><div class=\"col-sm-5 sp-block-relative sp-plan-date-input-on-white-bg\"><input type=text class=\"form-control input-form\" name=endDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.downloadVisitReportEndDate.model ng-change=\"vm.validateReportDate(vm.downloadVisitReportStartDate.model, vm.downloadVisitReportEndDate.model, \'visitImagesReport\')\" ng-required=true is-open=vm.downloadVisitReportEndDate.opened datepicker-options=vm.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-report-date\" ng-class=\"{\'btn-border-invalid\':visitImagesReport.endDate.$error.endDate_gt_startDate}\" ng-click=\"vm.downloadVisitReportEndDate.opened=!vm.downloadVisitReportEndDate.opened\"><span class=\"sp-icon-calendario input-icon\"></span></button></span></div><div class=\"col-md-10 col-md-offset-1 settings-error-between-dates text-center\"><span ng-show=vm.visitImagesReport.settingsErrorBetweenDates translate=General.error_between_dates></span> <span ng-show=vm.visitImagesReport.settingsErrorDateStart translate=General.error_date_start></span></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=General.tracking_code_user_email></label><div class=\"col-sm-9 sp-block-relative\"><input type=email class=\"form-control form-input-new-white-bg\" name=historical_email ng-model=vm.downloadEmail ng-required=true></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=General.visit_images_name_picture></label><div class=\"col-sm-9 sp-block-relative\"><select name=moreData_vehicle ng-model=vm.pictureName class=\"form-control form-input-new-white-bg\" id=picture_image required><option value=\"\" selected translate=General.visit_images_select_option></option><option value=reference translate=General.visit_images_select_id_reference></option><option value=title translate=General.visit_images_select_title_visit></option></select></div></div><div class=sp-flex-form-group><button type=button ng-click=\"visitImagesReport.$valid && vm.generateVisitImagesReport()\" ng-disabled=visitImagesReport.$invalid class=\"btn btn-primary btn-large btn-export col-sm-2\"><span translate=General.export></span></button></div></form></div></div></div><!-- Time service report --><div class=\"col-xs-12 col-sm-6\" ng-show=vm.enableTimeServiceReport><div class=\"panel sp-panel-report-dashboard\"><div class=panel-heading>Reporte de tiempo de servicio de visitas</div><div class=panel-body><form class=\"form-horizontal sp-form\" name=ts_report novalidate><div class=form-group><label class=\"control-label col-sm-3\">Cliente</label><ui-select class=\"col-sm-6 select-position\" name=clientName ng-model=vm.tsReportClient spinner-enabled=true spinner-class=\"fa fa-spinner fa-pulse\" theme=bootstrap reset-search-input=true ng-click=vm.loadAllClients() required><ui-select-match class=form-select-on-white-bg placeholder=\"{{\'Log_report.select_client\' | translate }}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"client in vm.clients track by client.id\" refresh=vm.refreshClients($select.search) refresh-delay=0 minimum-input-length=3 position=\"\'auto\'\"><div ng-bind-html=client.name></div></ui-select-choices></ui-select><ng-messages for=ts_report.clientName.$error class=\"sp-form-messages col-sm-6 col-sm-offset-3\"><ng-message translate=Log_report.client_required class=sp-settings-invalid-help-block when=required></ng-message></ng-messages></div><div class=form-group><label class=\"control-label col-sm-3\">Radio</label><select class=\"col-sm-6 form-control select-report-settings form-input-new-white-bg\" ng-model=vm.tsReportRadioGeofence><option value=\"\" selected>---Seleccione radio---</option><option value=50>50</option><option value=100>100</option><option value=300>300</option><option value=500>500</option><option value=700>700</option><option value=1000>1000</option></select></div><div class=form-group><label class=\"col-sm-3 control-label label-right\" translate=General.report_from></label><div class=\"col-sm-3 col-md-2 sp-block-relative sp-plan-date-input-on-white-bg\"><input type=text class=\"form-control input-form\" name=startDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.tsReportStartDate.model ng-change=\"vm.validateReportDate(vm.tsReportStartDate.model, vm.tsReportEndDate.model, \'ts_report\')\" ng-required=true is-open=vm.tsReportStartDate.opened datepicker-options=vm.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-report-date\" ng-class=\"{\'btn-border-invalid\':ts_report.startDate.$error.endDate_gt_startDate}\" ng-click=\"vm.tsReportStartDate.opened=!vm.tsReportStartDate.opened\"><span class=\"sp-icon-calendario input-icon\"></span></button></span></div><label class=\"col-sm-1 control-label label-right\" translate=General.report_to></label><div class=\"col-sm-3 col-md-2 sp-block-relative sp-plan-date-input-on-white-bg\"><input type=text class=\"form-control input-form\" name=endDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.tsReportEndDate.model ng-change=\"vm.validateReportDate(vm.tsReportStartDate.model, vm.tsReportEndDate.model, \'ts_report\')\" ng-required=true is-open=vm.tsReportEndDate.opened datepicker-options=vm.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-report-date\" ng-class=\"{\'btn-border-invalid\':ts_report.endDate.$error.endDate_gt_startDate}\" ng-click=\"vm.tsReportEndDate.opened=!vm.tsReportEndDate.opened\"><span class=\"sp-icon-calendario input-icon\"></span></button></span></div><div class=\"col-md-10 col-md-offset-1 settings-error-between-dates text-center\"><span ng-show=vm.ts_report.settingsErrorBetweenDates translate=General.error_between_dates></span> <span ng-show=vm.ts_report.settingsErrorDateStart translate=General.error_date_start></span></div></div><div class=sp-flex-form-group><button type=button ng-click=\"ts_report.$valid && vm.exportTimeServiceReport()\" ng-disabled=\"ts_report.$invalid || vm.generating_report\" class=\"btn btn-primary btn-large btn-export col-sm-2\"><span translate=General.export></span></button></div></form></div></div></div><!-- Historical checkout report --><div class=\"col-xs-12 col-sm-6\" ng-show=vm.historicalCheckoutEnabled><div class=\"panel sp-panel-report-dashboard\"><div class=panel-heading translate=General.historical_checkout_report></div><div class=panel-body><form class=sp-form name=hc_report novalidate><div class=row><label class=\"col-sm-1 control-label\" translate=General.report_from></label><div class=\"col-sm-5 sp-block-relative sp-plan-date-input-on-white-bg\"><input type=text class=\"form-control input-form\" name=startDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.historicalCheckoutReport.from.model ng-change=\"vm.validateReportDate(vm.historicalCheckoutReport.from.model, vm.historicalCheckoutReport.to.model, \'hc_report\')\" ng-required=true is-open=vm.historicalCheckoutReport.from.opened datepicker-options=vm.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-report-date\" ng-class=\"{\'btn-border-invalid\':hc_report.startDate.$error.endDate_gt_startDate}\" ng-click=\"vm.historicalCheckoutReport.from.opened = !vm.historicalCheckoutReport.from.opened\"><span class=\"sp-icon-calendario input-icon\"></span></button></span></div><label class=\"col-sm-1 control-label text-center\" translate=General.report_to></label><div class=\"col-sm-5 sp-block-relative sp-plan-date-input-on-white-bg\"><input type=text class=\"form-control input-form\" name=endDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.historicalCheckoutReport.to.model ng-change=\"vm.validateReportDate(vm.historicalCheckoutReport.from.model, vm.historicalCheckoutReport.to.model, \'hc_report\')\" ng-required=true is-open=vm.historicalCheckoutReport.to.opened datepicker-options=vm.dateOptions on-open-focus=true popup-placement=bottom-left show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-report-date\" ng-class=\"{\'btn-border-invalid\':hc_report.endDate.$error.endDate_gt_startDate}\" ng-click=\"vm.historicalCheckoutReport.to.opened=!vm.historicalCheckoutReport.to.opened\"><span class=\"sp-icon-calendario input-icon\"></span></button></span></div><div class=\"col-md-10 col-md-offset-1 sp-tc-report-span\"><span ng-show=vm.hc_report.settingsErrorBetweenDates translate=General.error_between_dates></span> <span ng-show=vm.hc_report.settingsErrorDateStart translate=General.error_date_start></span></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=General.tracking_code_user_email></label><div class=\"col-sm-9 sp-block-relative\"><input type=email class=\"form-control form-input-new-white-bg\" name=historical_email ng-model=vm.historicalCheckoutReport.email ng-required=true></div></div><div class=sp-flex-form-group><button type=button class=\"btn btn-primary btn-export sp-button-tc-report\" ng-disabled=\"!hc_report.$valid || !vm.enableHistoricalCheckoutBtn\" ng-click=\"vm.exportHistoricalCheckoutReport(vm.historicalCheckoutReport.email, vm.historicalCheckoutReport.from.model, vm.historicalCheckoutReport.to.model)\"><span translate=General.export></span></button></div></form></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/visits/confirm-modal.html","<div class=\"modal-content sp-modal-confirm-dashboard-visits\"><div class=\"modal-header modal-header-success\"><h3 class=modal-title translate=Dashboard.Visits.Modal.confirm-title></h3></div><div class=modal-body><p translate=Dashboard.Visits.Modal.confirm-message></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-close\" ng-click=closeThisDialog(0) translate=Dashboard.Visits.Modal.close></button> <button type=button class=\"btn btn-success\" ng-click=\"vm.sendEmail(); closeThisDialog(0)\">Ok</button></div></div><!-- end modal-content -->");
$templateCache.put("app/dashboard/visits/visits-graphics.html","<div class=visits-graphics-container><div class=graphics ng-if=!vm.userWithoutDashboard><div class=sp-module-body><div class=row><div class=col-sm-2><div class=sp-dashboards-widget><div class=widget-title><span translate=Dashboard.current_period></span></div><div class=\"widget-body select-date\"><div class=row><div class=col-sm-12><select class=form-control name=default_month ng-options=\"month.name for month in vm.monthDates track by month.id\" ng-model=vm.reportsDate ng-change=vm.updateReports()></select><indicator ng-repeat=\"indicator in vm.indicators\" data=indicator></indicator></div></div></div></div></div><div class=row ng-if=vm.isDOMRender><div class=\"col-sm-10 padding-left-20\"><bar-graph data=vm.graphics.bars></bar-graph></div><div class=row><div class=\"col-xs-5 col-sm-5 padding-left-20\"><area-graph data=vm.graphics.area></area-graph></div><div class=\"col-xs-5 col-sm-5 padding-left-20\"><pie-graph data=vm.graphics.pies on-change-view=vm.changeView(type)></pie-graph></div></div></div></div></div></div><div class=sp-user-without-dashboard ng-if=vm.userWithoutDashboard><visits-graphics-modal></visits-graphics-modal></div></div>");
$templateCache.put("app/planner/components/breadCrumbs.html","<div class=sp-planner-steps><div class=sp-planner-steps-list-arrow ng-repeat=\"step in $ctrl.data\"><a href=\"\" ng-click=$ctrl.changeStep(step.link) class=\"btn btn-primary btn-arrow-right\" ng-class=\"{\'disabled-steps\':!step.visible}\">{{step.title}}</a></div></div>");
$templateCache.put("app/planner/components/errorFinishModal.html","<div class=sp-confirm-plan><div class=sp-icon-error-container><i class=sp-icon-close></i></div><p class=text><span class=msg-error><span>{{$ctrl.data.vehicleTitle}}</span> <span class=vehicle-name><b>{{$ctrl.data.vehicleName}}</b></span> <span>{{$ctrl.data.title}} </span></span><span class=subtitle><span>{{$ctrl.data.msg}}</span></span></p></div>");
$templateCache.put("app/planner/components/infoBox.html","<div class=sp-planner-info-box ng-class=\"{\'collapse\': $ctrl.viewCollapse}\"><div ng-if=\"!$ctrl.viewCollapse && $ctrl.data.vehicleName && $ctrl.data.routeName\"><div class=\"item highlight\"><i class=sp-icon-vehiculos></i><p title={{$ctrl.data.vehicleName}}>{{$ctrl.data.vehicleName}}</p><div class=close><a ng-click=$ctrl.close()><i class=sp-icon-close></i></a></div></div><div class=\"sp-planner-route-section highlight\"><img src=../../../assets/images/route-solid.svg class=route-icon-infobox><p title={{$ctrl.data.routeName}}>{{$ctrl.data.routeName}}</p></div></div><div class=header><div class=order ng-style=\"{\'background-color\': $ctrl.data.color }\">{{$ctrl.data.visitObj.order}}</div><div class=\"title highlight\">{{$ctrl.data.visitObj.title}}</div><div class=close ng-if=\"$ctrl.viewCollapse || (!$ctrl.data.vehicleName && !$ctrl.data.routeName)\"><a ng-click=$ctrl.close()><i class=sp-icon-close></i></a></div></div><div class=address><i class=sp-icon-map-pin></i> <span>{{$ctrl.data.visitObj.address}}</span></div><div class=notes><i ng-if=\"$ctrl.data.notes !== \'\'\" class=sp-icon-notes></i> <span>{{$ctrl.data.notes}}</span></div><div ng-if=!$ctrl.viewCollapse><div class=reference-id ng-if=$ctrl.data.visitObj.reference><visit-reference class=visit-reference-container visit=$ctrl.data.visitObj></visit-reference></div><div class=item ng-if=$ctrl.data.visitObj.load><i class=sp-icon-carga-outline></i> <span>{{$ctrl.data.visitObj.load}}</span></div><div class=item ng-if=$ctrl.data.visitObj.load2><i class=sp-icon-carga-volumen-outline></i> <span>{{$ctrl.data.visitObj.load2}}</span></div><div class=item ng-if=$ctrl.data.visitObj.load3><i class=sp-icon-carga-valor-outline></i> <span>{{$ctrl.data.visitObj.load3}}</span></div><div class=item ng-if=$ctrl.data.visitObj.load4><div class=\"visit-card-icon-padding sp-icon-mix-load\" ng-include=\"\'/assets/images/box_outline.svg\'\"></div><span>{{$ctrl.data.visitObj.load4}}</span></div><skills-summary visit=$ctrl.data.visitObj></skills-summary><div class=item ng-if=\"$ctrl.data.visitObj.windowStart || $ctrl.data.visitObj.windowEnd\"><i class=sp-icon-ventana-horaria ng-class=\"{\'sp-text-color-danger\': $ctrl.data.visitObj.timeError}\"></i> <span ng-show=\"$ctrl.data.visitObj.windowStart && !$ctrl.data.visitObj.windowEnd\">{{ \'Planner.infowindow_since\' | translate }} {{$ctrl.data.visitObj.windowStart}}</span> <span ng-show=\"$ctrl.data.visitObj.windowStart && $ctrl.data.visitObj.windowEnd\">{{$ctrl.data.visitObj.windowStart}} {{ \'Planner.infowindow_to\' | translate }} {{$ctrl.data.visitObj.windowEnd}}</span> <span ng-show=\"!$ctrl.data.visitObj.windowStart && $ctrl.data.visitObj.windowEnd\">{{ \'Planner.infowindow_until_to\' | translate }} {{$ctrl.data.visitObj.windowEnd}}</span></div><div class=item ng-if=\"$ctrl.data.visitObj.windowStart2 || $ctrl.data.visitObj.windowEnd2\"><i class=sp-icon-ventana-horaria ng-class=\"{\'sp-text-color-danger\': $ctrl.data.visitObj.timeError}\"></i> <span ng-show=\"$ctrl.data.visitObj.windowStart2 && !$ctrl.data.visitObj.windowEnd2\">{{ \'Planner.infowindow_since\' | translate }} {{$ctrl.data.visitObj.windowStart2}}</span> <span ng-show=\"$ctrl.data.visitObj.windowStart2 && $ctrl.data.visitObj.windowEnd2\">{{$ctrl.data.visitObj.windowStart2}} {{ \'Planner.infowindow_to\' | translate }} {{$ctrl.data.visitObj.windowEnd2}}</span> <span ng-show=\"!$ctrl.data.visitObj.windowStart2 && $ctrl.data.visitObj.windowEnd2\">{{ \'Planner.infowindow_until_to\' | translate }} {{$ctrl.data.visitObj.windowEnd2}}</span></div><div class=item ng-if=$ctrl.data.visitObj.duration><i class=sp-icon-tiempo-servicio></i> <span>{{$ctrl.data.visitObj.duration}}</span></div><div class=item ng-if=$ctrl.data.priorityLevel.value><i class=\"fa fa-level-up\"></i> <span>{{$ctrl.data.priorityLevel.name}}</span></div></div></div>");
$templateCache.put("app/planner/components/visitsImport.html","<div class=sp-visits-import-container><h1>{{$ctrl.data.title}}</h1><div class=sp-visits-import-flex><div class=sp-visits-import-title><h1>{{ $ctrl.$translate(\'Visits.component_visits_import.select_date\') }}</h1></div><div class=sp-visits-import-calendar><div><p>{{ $ctrl.$translate(\'Visits.component_visits_import.start_date\') }}:</p><div ng-model=$ctrl.data.calendar.startDate uib-datepicker=dd-MM-yyyy datepicker-options=$ctrl.data.calendar.options show-button-bar=false ng-change=$ctrl.validateDateRange()></div></div><div><p>{{ $ctrl.$translate(\'Visits.component_visits_import.end_date\') }}:</p><div ng-model=$ctrl.data.calendar.endDate uib-datepicker=dd-MM-yyyy datepicker-options=$ctrl.data.calendar.options show-button-bar=false ng-change=$ctrl.validateDateRange()></div></div></div><div class=sp-visits-import-calendar><div ng-if=$ctrl.dateOrderError class=text-danger style=\"margin-top: 5px\">{{ $ctrl.$translate(\'Visits.component_visits_import.error_date_order\') }}</div><div ng-if=$ctrl.dateRangeError class=text-danger style=\"margin-top: 5px\">{{ $ctrl.$translate(\'Visits.component_visits_import.error_date_range\') }}</div></div><div class=sp-visits-import-button><div ng-if=$ctrl.visitsStatusEnabled><div class=sp-visits-import-title><h1>{{ $ctrl.statusOptionsColumnTitle }}</h1></div><!-- Visit status options --><div class=sp-visits-import-list-group-container><div class=sp-visits-import-list-controlls><span class=sp-header-option><input type=checkbox ng-model=$ctrl.statusAllImportOptionsEnabled ng-change=$ctrl.handleStatusAllImportOptionsCheck()> {{ $ctrl.allImportOptionsTitle }}</span></div><div class=sp-visits-import-list-group ng-class=\"{\'shrink\': $ctrl.visitsTypeEnabled}\"><li class=sp-list-group-item ng-repeat=\"option in $ctrl.statusOptionsList\"><div><input type=checkbox ng-model=option.selected ng-change=$ctrl.handleStatusImportOptionCheck(option)><label>{{ option.label }}</label></div></li></div></div></div><div ng-if=$ctrl.visitsTypeEnabled><div class=sp-visits-import-title><h1>{{ $ctrl.typeOptionsColumnTitle }}</h1></div><!-- Visit type options --><div class=sp-visits-import-list-group-container><div class=sp-visits-import-list-controlls><span class=sp-header-option><input type=checkbox ng-model=$ctrl.typeAllImportOptionsEnabled ng-change=$ctrl.handleTypeAllImportOptionsCheck()> {{ $ctrl.allImportOptionsTitle }}</span></div><div class=sp-visits-import-list-group><li class=sp-list-group-item ng-repeat=\"option in $ctrl.typeOptionsList\"><div><input type=checkbox ng-model=option.selected ng-change=$ctrl.handleTypeImportOptionCheck(option)><label>{{ option.label }}</label></div></li></div></div></div></div></div><div class=sp-visits-import-button-list><button type=button class=\"btn btn-success\" ng-click=$ctrl.getVisits() ng-disabled=$ctrl.isDisabledSubmitButton>{{$ctrl.data.button.title}}</button> <button type=button class=\"btn btn-gray-bg\" ng-click=$ctrl.data.closePopupVisitsIntegration()>{{ $ctrl.$translate(\'Visits.component_visits_import.back_title\') }}</button></div></div>");
$templateCache.put("app/planner/directives/alert-notification-template.html","<div class=\"alert sp-planner-map-alert\" ng-class=\"{\'alert-info\': notification.type === 1,\n				\'alert-warning\': notification.type === 2,\n				\'alert-warning-dark\': notification.type === 3,\n				\'alert-danger\': notification.type === 4,\n				\'alert-success\': notification.type === 5 }\" ng-if=\"notification && !hideFlag\"><a href=\"\" class=close data-dismiss=alert aria-label=close title=close ng-click=hide()>×</a> {{notification.msg}}</div>");
$templateCache.put("app/planner/directives/busy-loading-template.html","");
$templateCache.put("app/planner/plans/codrivers-detail.html","<div class=sp-widget-header><div class=left-icon><a ui-sref=planner.vehicles-list.plans-detail><i class=sp-icon-chevron-left></i></a></div><div class=title><span translate=Planner.codrivers_edition></span></div><div class=right-icon><a ui-sref=planner.vehicles-list><i class=sp-icon-close></i></a></div></div><form class=\"form-horizontal sp-plans-form\"><div class=sp-widget-body><div class=text><span translate=Planner.codrivers_select></span></div><selectable-items-list data=vm.selectableCodrivers items-selected=vm.selectableCodrivers.itemsSelected items-per-page=vm.itemsPerPage></selectable-items-list></div><div class=\"sp-widget-footer sp-widget-footer--flex-end\"><button class=\"btn btn-success btn-saved pull-right\" ng-click=vm.saveCodrivers()><span translate=Planner.btn_save class=ng-scope></span></button></div></form>");
$templateCache.put("app/planner/plans/draft-plans-delete-modal.html","<div class=\"sp-modal-content sp-modal-delete-plan\"><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Planner.delete_draft_plan></h3><p class=sp-modal-plan-delete-name>{{vm.plan.name}}</p></div><div class=\"modal-body text-left\"><label class=sp-checkbox-container><span class=\"sp-warning-text sp-modal-warning\" translate=Planner.delete_draft_modal_message_warning></span> <input type=checkbox ng-model=vm.checkDeletePlan> <span class=sp-checkmark></span></label></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Planner.close></button> <button type=button class=\"btn btn-danger\" ng-click=\"vm.deletePlan(vm.plan); closeThisDialog(0)\" translate=Planner.delete ng-disabled=!vm.checkDeletePlan></button></div></div>");
$templateCache.put("app/planner/plans/draft-plans.html","<div class=sp-widget-header><div class=left-icon><!-- <i class=\"sp-icon-chevron-left\"></i> --></div><div class=title><span translate=Planner.total_load_drafts></span> <span>{{vm.draftPlans.length}}</span></div><div class=right-icon><a ui-sref=planner.vehicles-list><i class=sp-icon-close></i></a></div></div><div class=sp-widget-body><div class=table-responsive ng-if=\"vm.draftPlans.length > 0\"><table class=table><thead><tr><th class=\"sp-widget-table-th p-5\" translate=Planner.plan></th><th class=\"sp-widget-table-th text-center p-5\" translate=Planner.start_date></th><th class=\"sp-widget-table-th text-center p-5\" translate=Planner.end_date></th><th>&nbsp;</th></tr></thead><tbody><tr class=\"sp-cursor-pointer sp-plan-row\" ng-repeat=\"plan in vm.draftPlans\" ng-click=vm.goToDetail(plan.id)><td class=\"text-left px-5\">{{plan.name}}</td><td class=\"text-center px-5\">{{plan.startDate}}</td><td class=\"text-center px-5\">{{plan.endDate}}</td><td class=\"text-center px-5\"><a class=\"btn btn-link sp-delete\" ng-click=\"vm.showDeleteModal($event, plan)\" href=\"\"><i class=sp-icon-delete></i></a></td></tr></tbody></table></div><div class=sp-empty-msg ng-if=\"vm.draftPlans.length === 0\" translate=Planner.empty_drafts_msg></div></div>");
$templateCache.put("app/planner/plans/plans-delete-modal.html","<div class=\"sp-modal-content sp-modal-delete-plan\"><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Planner.delete_plan></h3><p class=sp-modal-plan-delete-name>{{vm.plan.name}}</p></div><div class=\"modal-body text-left\" ng-if=vm.plan.canBeDeleted><!-- <i class=\"sp-icon-warning sp-icon-delete-modal\"></i> --><p class=sp-delete-message ng-if=vm.isEditingCurrentPlan translate=Planner.delete_modal_message_2></p><p class=sp-delete-message ng-if=!vm.isEditingCurrentPlan translate=Planner.delete_modal_message></p><div class=sp-delete-recommendation><div class=badge><p translate=Planner.delete_plan_recommendation></p></div></div><div class=sp-delete-plan-choose-about-visits><div><input id=deletePlanAndKeepVisits type=radio name=chooseAboutVisits ng-model=vm.deleteVisits ng-value=false><label for=deletePlanAndKeepVisits class=sp-warning-text translate=Planner.delete_plan_and_keep_visits_warning></label></div><div><input id=deletePlanAndVisits type=radio name=chooseAboutVisits ng-model=vm.deleteVisits ng-value=true><label for=deletePlanAndVisits class=sp-warning-text translate=Planner.delete_plan_and_visits_warning></label></div></div><!-- <h4>{{vm.plan.name}}</h4> --><label class=sp-checkbox-container><p class=sp-modal-warning translate=Planner.delete_modal_message_warning></p><input type=checkbox ng-model=vm.checkDeletePlan> <span class=sp-checkmark></span></label></div><div class=modal-body ng-if=!vm.plan.canBeDeleted><p class=sp-plan-not-deleted-message translate=Planner.plan_not_deleted_message></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Planner.btn_cancel></button> <button ng-if=\"vm.plan.canBeDeleted && vm.deleteVisits === true\" type=button class=\"btn btn-danger\" ng-click=\"vm.deletePlan(vm.plan, vm.deleteVisits);\" translate=Planner.delete ng-disabled=\"!vm.checkDeletePlan || vm.deleteVisits === null\"></button> <button ng-if=\"vm.plan.canBeDeleted && vm.deleteVisits === false\" type=button class=\"btn btn-success\" ng-click=\"vm.deletePlan(vm.plan, vm.deleteVisits);\" translate=Planner.delete_plan_keep_visits ng-disabled=\"!vm.checkDeletePlan || vm.deleteVisits === null\"></button></div></div>");
$templateCache.put("app/planner/plans/plans-detail.html","<div class=sp-widget-header><div class=left-icon><a ui-sref={{vm.pathToPreviousView}}><i class=sp-icon-chevron-left></i></a></div><div class=title><span translate=Planner.plan_resume ng-if=\"!vm.isCopy && !vm.isDraft\"></span> <span translate=Planner.draft_plan_resume ng-if=\"!vm.isCopy && vm.isDraft\"></span> <input type=text placeholder=\"{{\'Planner.input_planName\' | translate }}\" class=form-control ng-if=vm.isCopy name=\"\" ng-model=vm.plan.name></div><div class=right-icon><a ui-sref=planner.vehicles-list><i class=sp-icon-close></i></a></div></div><form class=\"form-horizontal sp-plans-form\" name=vm.plansForm><div class=sp-widget-body><div class=row ng-if=vm.planUploaded><div class=\"col-sm-12 sp-msg-container\"><span translate=Planner.success_plan_uploaded></span><br><span translate=Planner.success_plan_uploaded_but_no_changes ng-if=\"vm.visitsUpdated === 0\"></span></div><div class=\"col-sm-12 sp-indicators-container\"><div class=sp-indicator-box><div class=title><span translate=Planner.visits_edited></span><hr></div><div class=value><span>{{vm.visitsUpdated}}</span></div></div><div class=sp-indicator-box><div class=title><span translate=Planner.total_visits></span><hr></div><div class=value><span>{{vm.totalExcelVisits}}</span></div></div><div class=sp-indicator-box><div class=title><span translate=Planner.drivers></span><hr></div><div class=value><span>{{vm.driversAfterEdit.length}}</span></div></div></div></div><div ng-if=\"!vm.planUploaded && !vm.isCopy\"><span class=\"sp-small-caps sp-text-input-label\" translate=Planner.plan_name></span> <input ng-disabled=\"vm.isDraft || !vm.isPlanEditable()\" class=\"form-control plan-name\" type=text maxlength=250 name=planName ng-model=vm.editedPlanName></div><div class=\"row sp-row\" ng-if=!vm.planUploaded><div class=\"col-sm-4 text-left\"><span class=\"sp-small-caps sp-text-input-label\" translate=Planner.start_date></span><div class=\"sp-block-relative sp-plan-date-input sp-plan-form-input\"><input type=text class=form-control name=startDate ng-disabled=\"vm.isDraft || !vm.isPlanEditable()\" uib-datepicker-popup=dd-MM-yyyy ng-model=vm.planDate.start ng-change=\"vm.validatePlanDate(vm.planDate.start, vm.planDate.end)\" ng-required=true is-open=vm.popupPlanDateStart.opened datepicker-options=vm.dateOptions popup-placement=right-top show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-plan-date\" ng-disabled=\"vm.isDraft || !vm.isPlanEditable()\" ng-click=vm.openPopupPlanDateStart()><span class=sp-icon-calendario></span></button></span></div></div><div class=\"col-sm-4 text-left\" ng-if=!vm.isCopy><span class=\"sp-small-caps sp-text-input-label\" translate=Planner.end_date></span><div class=\"sp-block-relative sp-plan-date-input sp-plan-form-input\"><input type=text class=form-control name=endDate ng-disabled=\"vm.isDraft || !vm.isPlanEditable()\" uib-datepicker-popup=dd-MM-yyyy ng-model=vm.planDate.end ng-change=\"vm.validatePlanDate(vm.planDate.start, vm.planDate.end)\" ng-required=true is-open=vm.popupPlanDateEnd.opened datepicker-options=vm.dateOptions popup-placement=right-top show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-plan-date\" ng-disabled=\"vm.isDraft || !vm.isPlanEditable()\" ng-click=vm.openPopupPlanDateEnd()><span class=sp-icon-calendario></span></button></span></div></div><div class=\"col-sm-4 text-left\"><span class=\"sp-small-caps sp-text-input-label\" translate=Planner.weekend_start_day></span><div class=\"sp-block-relative sp-plan-form-input\"><select class=form-control ng-disabled=\"vm.isDraft || !vm.isPlanEditable()\" ng-options=\"weekend_day.name for weekend_day in vm.weekend_days track by weekend_day.id\" ng-model=vm.resetDay no-dirty-check></select></div></div></div><div class=\"row sp-row\" ng-if=!vm.planUploaded><div class=\"col-sm-12 settings-error-between-dates text-center\"><span ng-show=vm.settingsErrorDateStart translate=General.error_date_start></span></div></div><routing-summary-table ng-if=!vm.planUploaded vehicles=vm.vehicles drivers=vm.drivers co-drivers=\"vm.isEnabledConfigToCodrivers ? vm.codrivers : null\" show-comments=false is-field-editable=\"!vm.isDraft && vm.isPlanEditable()\" go-to-co-drivers=vm.goToCodrivers(vehicle)></routing-summary-table><!-- vehicle error --><div class=\"sp-confirm-plan sp-confirm-plan-sm\" ng-show=\"vm.notSavedPlan && vm.failedVehicle\"><p class=text><span class=msg-error><span translate=Routes.the_vehicle></span> <span class=vehicle-name><b>{{vm.failedVehicle.name}}</b></span> <span translate=Routes.assignments.errorMessage></span></span></p></div><div class=sp-empty-msg ng-if=!vm.plan translate=Planner.no_exist_plans_msg></div></div><div class=row ng-show=\"vm.planUpdated !== null || vm.showErrorPlanNameExist\"><div class=\"col-sm-12 text-center\"><span class=sp-success-msg translate=Planner.success_update_plan ng-show=\"vm.planUpdated === true\"></span> <span class=sp-text-color-danger translate=Planner.error_update_plan ng-show=\"vm.planUpdated === false\"></span> <span class=sp-text-color-danger translate=Planner.error_plan_name_exist ng-show=vm.showErrorPlanNameExist></span></div></div><div class=sp-widget-footer><div class=\"sp-button sp-align-bottom\" ng-if=\"!vm.planUploaded && !vm.isCopy\"><button type=button class=\"btn btn-primary sp-btn-margin-right-separation\" ng-click=vm.exportPlan() ng-disabled=vm.isDraft><i class=\"fa fa-download\"></i> <span translate=Planner.btn_download></span></button><div class=sp-btn-file-container ng-if=vm.isPlanEditable()><a class=\"btn btn-primary btn-file\" ng-click=$event.preventDefault(); ng-disabled=vm.isDraft><i class=\"fa fa-upload\"></i> <span translate=Planner.upload></span> </a><input type=file sp-file-change=vm.uploadExcel($files) ng-disabled=vm.isDraft></div></div><div class=\"sp-button text-right\"><button type=button class=\"btn btn-primary sp-btn-margin-right-separation\" ng-click=vm.loadPlan() ng-if=\"!vm.planUploaded && !vm.isCopy\"><span translate=Planner.btn_load></span></button> <button type=button class=\"btn btn-primary sp-btn-margin-right-separation\" ng-click=vm.duplicatePlan() ng-if=\"!vm.planUploaded && vm.isCopy\" ng-disabled=\"vm.isDraft || vm.plan.name.length == 0 || !vm.planDate.start\"><span translate=Planner.btn_duplicate></span></button> <button type=button class=\"btn btn-success\" ng-click=vm.updatePlanData() ng-disabled=\"vm.isDraft || !vm.activateSaveBtn || !vm.editedPlanName\" ng-if=\"!vm.isDraft && !vm.planUploaded && !vm.isCopy && vm.isPlanEditable()\"><span translate=Planner.btn_save></span></button> <button type=button class=\"btn btn-success\" ng-click=vm.goToPlans() ng-if=\"vm.planUploaded && !vm.isCopy\" ng-disabled=vm.isDraft><span translate=Planner.btn_confirm></span></button> <button type=button class=\"btn btn-danger\" ng-click=\"vm.showDeleteModal($event, vm.plan)\" ng-if=vm.isDraft><span translate=Planner.delete_draft></span></button></div></div></form>");
$templateCache.put("app/planner/plans/plans-list.html","<div class=sp-widget-header><div class=left-icon></div><div class=title><span translate=Planner.total_load_plans></span> <span></span>{{vm.pagination.totalItems}}</div><form class=\"form-inline md-form form-sm active-cyan-2\"><input class=\"form-control form-control-sm mr-3 w-75\" type=text placeholder=\"{{ \'Communication.search\' | translate }}\" aria-label=Search ng-model=vm.searchText ng-change=vm.onChangeSearch() ng-model-options=\"{ debounce: 250 }\"></form><div class=right-icon><a ui-sref=planner.vehicles-list><i class=sp-icon-close></i></a></div></div><div class=sp-widget-body><div class=table-responsive ng-if=\"vm.safeSrcPlans.length > 0\"><table class=table><thead><tr><th class=\"sp-widget-table-th p-5\" translate=Planner.plan></th><th class=\"sp-widget-table-th text-center p-5\" translate=Planner.start_date></th><th class=\"sp-widget-table-th text-center p-5\" translate=Planner.end_date></th><th>&nbsp;</th></tr></thead><tbody><tr class=\"sp-cursor-pointer sp-plan-row\" ng-repeat=\"plan in vm.safeSrcPlans\" ng-click=\"![\'saving\', \'error\'].includes(plan.saveStage) && vm.goToDetail(plan.id)\"><td class=\"text-left px-5\">{{plan.name}}<p class=editing_current_plan ng-if=\"vm.isPlanStatusEnabled && plan.status === \'draft\' && ![\'saving\', \'error\'].includes(plan.saveStage)\" translate=Planner.draft_plan></p><span ng-if=\"plan.saveStage === \'saving\'\" class=sp-chip-saving-plan uib-tooltip=\"{{\'Planner.saving\' | translate}}\" translate=chips.saving></span><chip-error-plan ng-if=\"plan.saveStage === \'error\' && vm.currentPlanEditing.planId !== plan.id\" show-recovery-btn=vm.activeDraftPlanIds.includes(plan.id) plan-id=plan.id></chip-error-plan><p class=editing_current_plan ng-if=\"vm.currentPlanEditing.planId === plan.id\" translate=Planner.editing_current_plan></p></td><td class=\"text-center px-5\">{{plan.startDate}}</td><td class=\"text-center px-5\">{{plan.endDate}}</td><td class=\"text-center px-5\"><a ng-if=!vm.disableDuplicationPlan ng-disabled=\"[\'saving\', \'error\'].includes(plan.saveStage)\" class=\"btn btn-link fa fa-files-o\" ng-click=\"![\'saving\', \'error\'].includes(plan.saveStage) && vm.duplicatePlan($event, plan.id)\" uib-tooltip=\"{{\'Planner.btn_duplicate\' | translate}}\" href=\"\"></a> <a class=\"btn btn-link sp-delete\" ng-disabled=\"plan.saveStage === \'saving\'\" ng-click=\"plan.saveStage !== \'saving\' && vm.showDeleteModal($event,plan.id)\" href=\"\"><i class=sp-icon-delete></i></a></td></tr></tbody></table></div><div class=sp-empty-msg ng-if=\"vm.safeSrcPlans.length === 0\" translate=Planner.empty_plans_msg></div></div><div class=sp-widget-footer><div ng-show=\"vm.safeSrcPlans.length > 0\" class=\"sp-settings-pagination text-right\"><uib-pagination total-items=vm.pagination.totalItems ng-model=vm.pagination.currentPage max-size=vm.pagination.maxSize class=pagination-sm boundary-links=true items-per-page=vm.pagination.itemsPerPage ng-change=vm.pagination.pageChanged() first-text={{pagination.firstText}} last-text={{pagination.lastText}} next-text={{pagination.nexText}} previous-text={{pagination.previousText}}></uib-pagination></div></div>");
$templateCache.put("app/planner/routes/cancel-edit-plan-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-warning\"><h3 class=modal-title translate=Plan.modal_cancel_edit_title></h3></div><div class=modal-body><p translate=Plan.modal_cancel_edit_message_1></p><p translate=Plan.modal_cancel_edit_message_2></p></div><div class=sp-modal-buttons><button type=button class=\"btn sp-btn-default\" ng-click=closeThisDialog(0) translate=Plan.button_cancel_modal></button> <button type=button class=\"btn btn-success\" ng-click=\"cancelEditPlan(); closeThisDialog(0)\" translate=Plan.button_accept_modal></button></div></div>");
$templateCache.put("app/planner/routes/expand-modal.html","<div class=sp-expand-modal ng-controller=ExpandModalController><div class=sp-expand-modal__header><div class=sp-expand-modal__header-content><div class=sp-expand-modal__order>{{vm.visit.order}}</div><div class=sp-expand-modal__title><p class=sp-expand-modal__vehicle-id>{{vm.getVehicleName(vm.visit.vehicle)}} - {{vm.routeIndex}}</p><p class=sp-expand-modal__name>{{vm.visit.title}}</p></div></div><button type=button class=sp-expand-modal__close ng-click=vm.close()><div class=sp-expand-modal__close-icon ng-include=\"\'/assets/images/close_expand_modal.svg\'\"></div></button></div><div class=sp-expand-modal__body><div class=sp-expand-modal__tabs><div class=sp-expand-modal__tab-list><div ng-repeat=\"tab in vm.tabs\" class=sp-expand-modal__tab-item ng-class=\"{\'sp-expand-modal__tab-item--active\': tab.active}\" ng-click=vm.switchTab(tab.id)><span>{{tab.name}}</span></div></div></div><div ng-show=\"vm.isTabActive(\'information\')\" class=sp-expand-modal__tab-pane><div class=sp-expand-modal__visit-details><h4 class=sp-expand-modal__section-title translate=Expand_modal.visit></h4><div class=sp-expand-modal__section><p class=sp-expand-modal__section-subtitle translate=Expand_modal.loads></p><div class=sp-expand-modal__section-body><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content-capacities-modal><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visit.capacityError}\"><div class=icon-wrapper ng-class=\"{\'sp-text-color-danger\': visit.capacityError}\" ng-include=\"\'/assets/images/weight_Filled.svg\'\"></div><p>{{vm.visit.load | formatNumber:2:\'.\':\',\'}}</p></div><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visit.capacityError2}\"><div class=icon-wrapper ng-class=\"{\'sp-text-color-danger\': visit.capacityError2}\" ng-include=\"\'/assets/images/volume_Filled.svg\'\"></div><p>{{vm.visit.load2 | formatNumber:2:\'.\':\',\'}}</p></div><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visit.capacityError3}\"><div class=icon-wrapper ng-class=\"{\'sp-text-color-danger\': visit.capacityError3}\" ng-include=\"\'/assets/images/money-circle_Filled.svg\'\"></div><p>{{vm.visit.load3 | formatNumber:2:\'.\':\',\'}}</p></div><div ng-if=vm.isMixLoadAddonEnabled() class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visit.capacityError4}\"><div class=icon-wrapper ng-class=\"{\'sp-text-color-danger\': visit.capacityError4}\" ng-include=\"\'/assets/images/box_filled.svg\'\"></div><p>{{vm.visit.load4 | formatNumber:2:\'.\':\',\'}}</p></div></div></div></div><div class=sp-expand-modal__section><p class=sp-expand-modal__section-subtitle translate=Expand_modal.address></p><p class=sp-expand-modal__section-item>{{vm.visit.address}}</p></div><div class=sp-expand-modal__section ng-if=vm.isSellerManagementEnabled><p class=sp-expand-modal__section-subtitle translate=Expand_modal.seller></p><p class=sp-expand-modal__section-item>{{vm.sellerName}}</p></div><div class=\"sp-expand-modal__section sp-expand-modal__section-row\"><div class=sp-expand-modal__section-item-right><p class=sp-expand-modal__section-subtitle translate=Expand_modal.time_windows.title_1></p><p class=sp-expand-modal__section-item>{{vm.formatTimeWindow(vm.visit.windowStart, vm.visit.windowEnd)}}</p></div><div class=sp-expand-modal__section-item-left><p class=sp-expand-modal__section-subtitle translate=Expand_modal.time_windows.title_2></p><p class=sp-expand-modal__section-item>{{vm.formatTimeWindow(vm.visit.windowStart2, vm.visit.windowEnd2)}}</p></div></div><div class=\"sp-expand-modal__section sp-expand-modal__section-row\"><div class=sp-expand-modal__section-item-right><p class=sp-expand-modal__section-subtitle translate=Expand_modal.service_time></p><p class=sp-expand-modal__section-item>{{vm.formatMinutesToHHMM(vm.visit.duration)}}</p></div><div class=sp-expand-modal__section-item-left><p class=sp-expand-modal__section-subtitle translate=Expand_modal.priority></p><p class=sp-expand-modal__section-item>{{vm.getPriorityName(vm.visit.priorityLevel)}}</p></div></div><div class=\"sp-expand-modal__section sp-expand-modal__section-row\"><div class=sp-expand-modal__section-item-right><p class=sp-expand-modal__section-subtitle translate=Expand_modal.notes></p><p class=sp-expand-modal__section-item>{{vm.visit.notes}}</p></div><div class=sp-expand-modal__section-item-left><p class=sp-expand-modal__section-subtitle translate=Expand_modal.visit_type></p><p class=sp-expand-modal__section-item>{{vm.getVisitTypeName(vm.visit.visitType)}}</p></div></div><div class=sp-expand-modal__section><p class=sp-expand-modal__section-subtitle translate=Expand_modal.tags></p><div class=sp-expand-modal__section-body><div class=sp-expand-modal__tags-container><div class=sp-expand-modal__tag ng-repeat=\"tag in vm.matchedTags\" ng-style=\"{\'background-color\': tag.color}\">{{tag.label}}</div></div></div></div><h4 class=sp-expand-modal__section-title translate=Expand_modal.contact.title></h4><div class=\"sp-expand-modal__section sp-expand-modal__section-row\"><div class=sp-expand-modal__section-item-right><p class=sp-expand-modal__section-subtitle translate=Expand_modal.contact.name></p><p class=sp-expand-modal__section-item>{{vm.visit.contactName}}</p></div><div class=sp-expand-modal__section-item-left><p class=sp-expand-modal__section-subtitle translate=Expand_modal.contact.email></p><p class=sp-expand-modal__section-item>{{vm.visit.contactEmail}}</p></div></div><div class=sp-expand-modal__section><p class=sp-expand-modal__section-subtitle translate=Expand_modal.contact.phone></p><p>{{vm.visit.contactPhone}}</p></div><h4 class=sp-expand-modal__section-title translate=Expand_modal.skills.title></h4><div class=\"sp-expand-modal__section sp-expand-modal__section-row\"><div class=sp-expand-modal__section-item-right><p class=sp-expand-modal__section-subtitle translate=Expand_modal.skills.required></p><p class=sp-expand-modal__section-item><span ng-repeat=\"skill in vm.matchedRequiredSkills\">{{skill.skill}}{{!$last ? \', \' : \'\'}}</span></p></div><div class=sp-expand-modal__section-item-left><p class=sp-expand-modal__section-subtitle translate=Expand_modal.skills.optional></p><p class=sp-expand-modal__section-item><span ng-repeat=\"skill in vm.matchedOptionalSkills\">{{skill.skill}}{{!$last ? \', \' : \'\'}}</span></p></div></div></div></div><div ng-show=\"vm.isTabActive(\'document\')\" class=sp-expand-modal__tab-pane><div class=sp-expand-modal__visit-details><h4 class=sp-expand-modal__section-title translate=Expand_modal.document.title></h4><div class=sp-expand-modal__section><!-- Loading state --><div ng-if=vm.isLoadingInvoices class=sp-expand-modal__loading><i class=\"fa fa-spinner fa-spin\"></i></div><!-- Docuemnt info --><div class=sp-expand-modal__document-info ng-if=\"!vm.isLoadingInvoices && vm.invoices.length\"><div class=sp-expand-modal__document-card><!-- Document header with dollar icon and status --><div class=sp-expand-modal__document-header><div class=sp-expand-modal__header-left><div class=sp-expand-modal__document-icon ng-include=\"\'/assets/images/dollar.svg\'\"></div><span class=sp-expand-modal__document-label>{{vm.invoices[vm.currentInvoiceIndex].label}}</span></div></div><!-- Document details --><div class=sp-expand-modal__document-details><div class=sp-expand-modal__document-detail><div class=sp-expand-modal__document-detail-row><span class=sp-expand-modal__document-detail-label translate=Expand_modal.document.reference></span> <span class=sp-expand-modal__document-detail-value>{{vm.invoices[vm.currentInvoiceIndex].reference | translate}}</span></div><div class=sp-expand-modal__document-detail-row><span class=sp-expand-modal__document-detail-label translate=Expand_modal.document.type></span> <span class=sp-expand-modal__document-detail-value>{{vm.invoices[vm.currentInvoiceIndex].type | translate}}</span></div><div class=sp-expand-modal__document-detail-row ng-if=vm.invoices[vm.currentInvoiceIndex].payment_method><span class=sp-expand-modal__document-detail-label translate=Expand_modal.document.payment_method></span> <span class=sp-expand-modal__document-detail-value>{{vm.invoices[vm.currentInvoiceIndex].payment_method | translate}}</span></div></div></div></div></div><!-- Document items table --><div ng-if=\"!vm.isLoadingInvoices && vm.invoices.length\" class=sp-expand-modal__items-table><h4 class=sp-expand-modal__section-title translate=Expand_modal.tabs.items></h4><div class=\"sp-expand-modal__items-row sp-expand-modal__items-header\"><div class=\"sp-expand-modal__items-cell sp-expand-modal__items-cell--title\" translate=Expand_modal.items.item></div><div class=\"sp-expand-modal__items-cell sp-expand-modal__items-cell--title\" translate=Expand_modal.items.quantity></div><div class=\"sp-expand-modal__items-cell sp-expand-modal__items-cell--title\">SKU</div></div><div class=sp-expand-modal__items-row ng-repeat=\"item in vm.invoices[vm.currentInvoiceIndex].items\"><div class=\"sp-expand-modal__items-cell sp-expand-modal__items-cell--ellipsis\"><span uib-tooltip={{item.title}} tooltip-class=sp-planner-tooltip tooltip-placement=auto tooltip-enable=showTooltip ellipsis-tooltip>{{item.title}}</span></div><div class=\"sp-expand-modal__items-cell sp-expand-modal__items-cell--ellipsis\"><span uib-tooltip={{item.planned_units}} tooltip-class=sp-planner-tooltip tooltip-placement=auto tooltip-enable=showTooltip ellipsis-tooltip>{{item.planned_units}}</span></div><div class=\"sp-expand-modal__items-cell sp-expand-modal__items-cell--ellipsis\"><span uib-tooltip={{item.sku}} tooltip-class=sp-planner-tooltip tooltip-placement=auto tooltip-enable=showTooltip ellipsis-tooltip>{{item.sku}}</span></div></div></div><!-- Navigation buttons --><div ng-if=\"!vm.isLoadingInvoices && vm.invoices.length > 1\" class=sp-expand-modal__document-navigation><button class=\"sp-expand-modal__nav-button sp-expand-modal__nav-button--previous\" ng-click=vm.previousInvoice() ng-disabled=!vm.hasPreviousInvoice()><div class=sp-expand-modal__nav-icon ng-include=\"\'/assets/images/previous_arrow.svg\'\"></div><span translate=Expand_modal.document.previous></span></button> <span ng-if=\"vm.invoices.length > 1\" class=sp-expand-modal__document-counter>{{vm.currentInvoiceIndex + 1}}/{{vm.invoices.length}} </span><button class=\"sp-expand-modal__nav-button sp-expand-modal__nav-button--next\" ng-click=vm.nextInvoice() ng-disabled=!vm.hasNextInvoice()><span translate=Expand_modal.document.next></span><div class=sp-expand-modal__nav-icon ng-include=\"\'/assets/images/next_arrow.svg\'\"></div></button></div><!-- No documents message --><div ng-if=\"!vm.isLoadingInvoices && !vm.invoices.length\" class=sp-expand-modal__no-data><p translate=Expand_modal.document.no_invoices></p></div></div></div></div><div ng-show=\"vm.isTabActive(\'items\')\" class=sp-expand-modal__tab-pane><div class=sp-expand-modal__visit-details><h4 class=sp-expand-modal__section-title translate=Expand_modal.tabs.items></h4><div class=sp-expand-modal__section><div class=sp-expand-modal__items-table><div class=\"sp-expand-modal__items-row sp-expand-modal__items-header\"><div class=\"sp-expand-modal__items-cell sp-expand-modal__items-cell--title\" translate=Expand_modal.items.item></div><div class=\"sp-expand-modal__items-cell sp-expand-modal__items-cell--title\" translate=Expand_modal.items.quantity></div><div class=\"sp-expand-modal__items-cell sp-expand-modal__items-cell--title\">SKU</div></div><div class=sp-expand-modal__items-row ng-repeat=\"item in vm.visit.items\"><div class=sp-expand-modal__items-cell><p uib-tooltip={{item.title}} tooltip-class=sp-planner-tooltip tooltip-placement=auto tooltip-append-to-body=true tooltip-enable=showTooltip ellipsis-tooltip class=sp-expand-modal__items-cell--ellipsis>{{item.title}}</p></div><div class=sp-expand-modal__items-cell><p uib-tooltip={{item.quantity_planned}} tooltip-class=sp-planner-tooltip tooltip-placement=auto tooltip-append-to-body=true tooltip-enable=showTooltip ellipsis-tooltip class=sp-expand-modal__items-cell--ellipsis>{{item.quantity_planned}}</p></div><div class=sp-expand-modal__items-cell><p uib-tooltip={{item.id}} tooltip-class=sp-planner-tooltip tooltip-placement=auto tooltip-append-to-body=true tooltip-enable=showTooltip ellipsis-tooltip class=sp-expand-modal__items-cell--ellipsis>{{item.id}}</p></div></div></div></div></div></div></div></div>");
$templateCache.put("app/planner/routes/finish-codrivers-modal.html","<div class=sp-widget-header><div class=title><span translate=Planner.codrivers_edition></span></div><div class=right-icon><a ng-click=closeThisDialog(vm.cancelAndCloseModal())><i class=sp-icon-close></i></a></div></div><form class=\"form-horizontal sp-plans-form\"><div class=sp-widget-body><div class=text><span translate=Planner.codrivers_select></span></div><selectable-items-list data=vm.selectableCodrivers items-selected=vm.selectableCodrivers.itemsSelected items-per-page=vm.itemsPerPage></selectable-items-list></div><div class=\"sp-widget-footer sp-widget-footer--flex-end\"><button class=\"btn sp-btn-default sp-btn-margin-right-separation\" ng-click=closeThisDialog(vm.cancelAndCloseModal())><span translate=Routes.go_back class=ng-scope></span></button> <button class=\"btn btn-success btn-saved\" ng-click=closeThisDialog(vm.saveCodrivers())><span translate=Planner.btn_assign_codrivers class=ng-scope></span></button></div></form>");
$templateCache.put("app/planner/routes/finish-modal.html","<div id=assignModal class=\"info modal-content sp-finish-modal\"><div class=\"modal-header sp-padding-x-to-10\" ng-class=\"{\'modal-header-info\': !vm.savedPlan}\"><h3 class=modal-title translate=Routes.finish_title ng-if=!vm.savedPlan></h3><span ng-if=\"vm.isNonBlockingSavingEnabled && vm.savedPlan\" class=sp-finish-title-success translate=Routes.finish_title_success_async></span><h3 ng-if=\"!vm.isNonBlockingSavingEnabled && vm.savedPlan\" class=modal-title translate=Routes.finish_title_success></h3></div><save-plan-error-modal ng-show=vm.savePlanErrorData.type visits-titles=vm.savePlanErrorData.visitsTitles not-saved-plan=vm.notSavedPlan is-error-in-plan-instance=vm.isErrorInPlanInstance remove-canceled-visits=vm.removeCanceledVisits() close-modal=vm.closeModal() save-plan-error-type=vm.savePlanErrorData.type save-plan=vm.savePlan(forceSave)></save-plan-error-modal><div ng-show=!vm.savePlanErrorData.type ng-class=\"{\'sp-restrict-height-to-500\': vm.isNonBlockingSavingEnabled, \'sp-restrict-height-to-400\': !vm.isNonBlockingSavingEnabled}\" class=\"modal-body sp-padding-to-10\"><div class=sp-confirm-plan ng-if=vm.savedPlan><span ng-if=vm.isNonBlockingSavingEnabled class=sp-finish-content-success translate=Routes.finish_content_success></span><div class=sp-icon-success-container><i class=sp-icon-check></i> <img class=sp-image-finish-modal src=../../assets/images/rutasenviadas2.png></div><div class=sp-modal-options><div class=sp-modal-options-block><span><span translate=\"{{\'Routes.finish_modal.text_tracking_module\'}}\"></span> <a href=\"\" ng-click=\"vm.clearAndGoTo(\'tracking\'); vm.closeModal()\" translate=\"{{\'Routes.finish_modal.tracking_module\'}}\"></a></span> <button class=\"btn btn-lg btn-primary sp-btn-left\" ng-click=\"vm.clearAndGoTo(\'tracking\'); vm.closeModal()\"><i class=\"sp-icon-tracking sp-icon-xl\"></i> <span translate=\"{{\'Routes.finish_modal.btn_tracking_module\'}}\"></span></button></div><div class=sp-modal-options-block><span><span translate=\"{{\'Routes.finish_modal.text_planning_module\'}}\"></span> <a href=\"\" ng-click=\"vm.clearAndGoTo(\'planner.vehicles-list\');  vm.closeModal()\" translate=\"{{\'Routes.finish_modal.planning_module\'}}\"></a></span> <button class=\"btn btn-lg btn-primary sp-btn-right\" ng-click=\"vm.clearAndGoTo(\'planner.vehicles-list\'); vm.closeModal()\"><i class=\"sp-icon-rutas sp-icon-xl\"></i> <span translate=\"{{\'Routes.finish_modal.btn_planning_module\'}}\"></span></button></div></div><div class=sp-planner-drivers-footer><div class=row><div class=\"col-sm-7 sp-left-block sp-vcenter\"><p translate=Routes.finish_modal.footer_message></p></div><div class=\"col-sm-4 text-right sp-right-block sp-vcenter\"><div class=sp-vcenter-apps-icons><a href={{::vm.appStoreAppLink}} target=_blank><img class=sp-footer-app-image src=../../../assets/images/appstore.png alt=appstore> </a><a href={{::vm.androidAppLink}} target=_blank><img class=sp-footer-app-image src=../../../assets/images/android_playstore.png alt=playstore></a></div></div></div></div></div><error-finish-modal data=vm.dataError ng-if=vm.notSavedPlan></error-finish-modal><toast-finish ng-if=\"!vm.savedPlan && vm.isPlanStatusEnabled && vm.planStatus !== \'completed\'\"></toast-finish><div class=vehicles-content ng-if=\"!vm.savedPlan && !vm.notSavedPlan && !vm.isErrorInPlanInstance\"><div class=row><form class=form-horizontal name=vm.form ng-submit=vm.savePlan()><div class=\"col-sm-12 text-left sp-padding-10-top-down\"><div class=col-sm-3><span class=sp-small-caps translate=Planner.plan_name></span></div><div class=col-sm-6><input type=text class=\"form-control sp_finish_modal_input\" name=planName ng-model=vm.planName ng-required=true ng-if=!vm.planMergedName ng-disabled=\"vm.isPlanStatusEnabled && vm.planStatus === \'completed\'\"> <input type=text maxlength=250 class=\"form-control sp_finish_modal_input\" name=planNameMerged ng-model=vm.planName ng-if=vm.planMergedName ng-disabled=\"vm.isPlanStatusEnabled && vm.planStatus === \'completed\'\"></div></div></form></div><routing-summary-table vehicles=vm.vehicles drivers=vm.drivers co-drivers=\"vm.isEnabledConfigToCodrivers ? vm.codrivers : null\" show-comments=true is-field-editable=vm.isPlanEditable() go-to-co-drivers=vm.goToCodrivers(vehicle) join-similar=vm.joinSimilar></routing-summary-table></div></div><div ng-if=!vm.savedPlan><div class=sp-modal-footer-buttons-date ng-if=!vm.isMultiDayRouteEnabled><span class=sp-subtitle-uppercase-text translate=Routes.assignments.date></span> <span ng-show=\"vm.plannedDate !== null && vm.editing\">{{vm.plannedDate}}</span><div ng-show=!vm.editing class=sp-planned-datepicker><a href=\"\" ng-show=\"vm.plannedDate !== null\" ng-model=vm.plannedDate uib-datepicker-popup show-button-bar=false is-open=vm.popupOpened datepicker-options=vm.dateOptions ng-click=vm.changeDate() ng-change=vm.setDate()>{{vm.plannedDateLabel}}</a> <span class=input-group-btn><button type=button class=\"btn btn-default btn-plan-date\" ng-click=vm.changeDate()><span class=sp-icon-calendario></span></button></span></div></div></div><div class=\"modal-footer sp-modal-footer\" ng-if=\"!vm.savedPlan && !vm.savePlanErrorData.type\"><div ng-if=\"vm.isPlanStatusEnabled && vm.planStatus !== \'completed\'\"><button type=button class=\"btn sp-btn-default sp_new_button pull-right\" ng-click=\"vm.savePlan(false, \'draft\')\" translate=Routes.save_draft ng-disabled=\"vm.form.$invalid || vm.saving || !vm.planName\" ng-show=!vm.notSavedPlan ng-hide=vm.savedPlan></button></div><div class=sp-modal-footer-buttons-right><!-- Reports --> <span uib-dropdown class=pull-right><a class=\"sp-planner-export-btn pull-right\" uib-dropdown-toggle href=\"\"><span translate=Planner.btn_export></span><!--<i class=\"sp-icon-erp\" uib-dropdown-toggle>--></a><ul class=\"dropdown-multiselection dropdown-bottom dropdown-menu dropdown-menu-right sp-dropdown-container\" uib-dropdown-menu aria-haspopup=true aria-expanded=false><li role=menuitem><div class=sp-optimize-option><a class=sp-report href=\"\" ng-click=vm.downloadReportTxt();><span>TXT</span> <i class=\"fa fa-download\"></i></a></div></li><li role=menuitem><div class=sp-optimize-option><a class=sp-report href=\"\" ng-click=vm.downloadReportExcel();><span>EXCEL</span> <i class=\"fa fa-download\"></i></a></div></li><li role=menuitem><div class=sp-optimize-option><a class=sp-report href=\"\" ng-click=vm.downloadReportPdf();><span>{{\'Pdf.detailed_pdf\' | translate}}</span> <i class=\"fa fa-download\"></i></a></div></li><li role=menuitem><div class=sp-optimize-option><a class=sp-report href=\"\" ng-click=vm.downloadReportSummarizedPdf();><span>{{\'Summarized_Pdf.summarized_pdf\' | translate}}</span> <i class=\"fa fa-download\"></i></a></div></li></ul></span><button ng-if=\"!vm.isPlanStatusEnabled || vm.planStatus === \'completed\'\" type=button class=\"btn btn-primary sp_new_button pull-right\" ng-click=\"vm.savePlan(false, \'completed\')\" translate=Routes.confirm ng-disabled=\"vm.form.$invalid || vm.saving || !vm.planName\" ng-show=!vm.notSavedPlan ng-hide=vm.savedPlan></button> <button ng-if=\"vm.isPlanStatusEnabled && vm.planStatus !== \'completed\'\" type=button class=\"btn btn-primary sp_new_button pull-right\" ng-click=vm.confirmCompletePlan() translate=Routes.confirm ng-disabled=\"vm.form.$invalid || vm.saving || !vm.planName\" ng-show=!vm.notSavedPlan ng-hide=vm.savedPlan></button> <button type=button class=\"btn btn-primary sp_new_button pull-right\" ng-click=\"vm.notSavedPlan = null; vm.isErrorInPlanInstance = false;  vm.closeModal()\" translate=Routes.go_back ng-disabled=vm.saving ng-show=vm.notSavedPlan></button></div></div></div><!-- end modal-content --><div class=ngdialog-close ng-click=ngDialog.close() ng-if=!vm.savedPlan></div>");
$templateCache.put("app/planner/routes/info-modal.html","<div class=\"info modal-content info-sp-info-modal\"><div class=\"modal-header modal-header-info\"><h3 class=modal-title translate=Routes.routes_summary></h3></div><div class=info-modal-button-block><div class=info-modal-button-container><a class=\"btn btn-primary sp_new_button pull-right\" ng-click=vm.downloadRouteSummary()><i class=\"fa fa-download\"></i> <span translate=Planner.btn_download></span></a></div></div><div class=\"info-modal-body sp-restrict-height-to-400\"><div class=info-table-header><div class=\"table-row header\"><div class=\"wrapper text-4\"><div class=\"wrapper text-2\"><div class=\"text sp-subtitle-uppercase-text\"></div><div class=\"address sp-subtitle-uppercase-text\" translate=Routes.origin></div></div><div class=\"wrapper text-2\"><div class=\"text sp-subtitle-uppercase-text\" translate=Routes.driver></div><div class=\"num sp-subtitle-uppercase-text\" translate=Routes.start_time></div></div></div><div class=\"wrapper text-4\"><div class=\"wrapper text-2\"><div class=\"num sp-subtitle-uppercase-text\" translate=Routes.end_time></div><div class=\"num sp-subtitle-uppercase-text\" translate=Routes.average_kms></div></div><div class=\"wrapper text-2\"><div class=\"num sp-subtitle-uppercase-text\" translate=Routes.duration></div><div class=\"num sp-subtitle-uppercase-text\" translate=Routes.visits></div></div></div><div class=\"wrapper text-4\"><div class=\"wrapper text-2\"><div class=\"num sp-subtitle-uppercase-text\" translate=Routes.load1></div><div class=\"num sp-subtitle-uppercase-text\" translate=Routes.load2></div></div><div class=\"wrapper text-2\"><div class=\"num sp-subtitle-uppercase-text\" translate=Routes.load3></div><div ng-if=vm.isMixLoadAddonEnabled class=\"num sp-subtitle-uppercase-text\" translate=Routes.load4></div></div></div></div><div class=\"table-row header\"><div class=\"wrapper text-4\"><div class=\"wrapper text-2\"><div class=\"text sp-subtitle-uppercase-text\"></div><div class=\"address sp-subtitle-uppercase-text\"></div></div><div class=\"wrapper text-2\"><div class=\"text sp-subtitle-uppercase-text\"></div><div class=\"num sp-subtitle-uppercase-text\"></div></div></div><div class=\"wrapper text-4\"><div class=\"wrapper text-2\"><div class=\"num sp-subtitle-uppercase-text\"></div><div class=\"num sp-subtitle-uppercase-text\">{{vm.getTotalDistance() | number:2}}</div></div><div class=\"wrapper text-2\"><div class=\"num sp-subtitle-uppercase-text\">{{vm.formatTime(vm.getAverageTime())}}</div><div class=\"num sp-subtitle-uppercase-text\">{{vm.getTotalVisits()}}</div></div></div><div class=\"wrapper text-4\"><div class=\"wrapper text-2\"><div class=\"num sp-subtitle-uppercase-text\">{{vm.getTotalLoad1() | number:0}}</div><div class=\"num sp-subtitle-uppercase-text\">{{vm.getTotalLoad2() | number:0}}</div></div><div class=\"wrapper text-2\"><div class=\"num sp-subtitle-uppercase-text\">{{vm.getTotalLoad3() | number:0}}</div><div ng-if=vm.isMixLoadAddonEnabled class=\"num sp-subtitle-uppercase-text\">{{vm.getTotalLoad4() | number:0}}</div></div></div></div></div><div class=vehicles-content><!-- Data --><div ng-repeat=\"vehicle in vm.vehicles | orderBy:vm.naturalSort(\'name\'):false\" ng-if=\"vehicle.routes.length > 0\" class=vehicle-item><div class=\"table-row vehicle-header\"><div class=\"wrapper text-4\"><div class=\"wrapper text-2\"><div class=\"vehicle-name info-row-flex\" uib-tooltip={{vehicle.name}}><div class=info-colored-circle ng-style=\"{\'background-color\': vehicle.color}\"></div>{{vehicle.name}}</div></div><div class=\"wrapper text-2\"><div class=text></div><div class=num></div></div></div><div class=\"wrapper text-4\"><div class=\"wrapper text-2\"><div class=num></div><div class=num>{{vm.getVehicleTotalDistance(vehicle) | number:2}}</div></div><div class=\"wrapper text-2\"><div class=num></div><div class=num>{{vm.getVehicleTotalVisits(vehicle)}}</div></div></div><div class=\"wrapper text-4\"><div class=\"wrapper text-2\"><div class=num>{{vm.getVehicleTotalLoad1(vehicle) | number:0}}</div><div class=num>{{vm.getVehicleTotalLoad2(vehicle) | number:0}}</div></div><div class=\"wrapper text-2\"><div class=num>{{vm.getVehicleTotalLoad3(vehicle) | number:0}}</div><div class=num ng-if=vm.isMixLoadAddonEnabled>{{vm.getVehicleTotalLoad4(vehicle) | number:0}}</div></div></div></div><div class=table-row ng-repeat=\"route in vehicle.routes\"><div class=\"wrapper text-4\"><div class=\"wrapper text-2\"><div class=\"text info-row-flex\" uib-tooltip=\"{{vm.getRouteName(route, $index)}}\"><div class=info-colored-circle></div>{{vm.getRouteName(route, $index)}}</div><div class=address uib-tooltip={{route.locationStart.address}}>{{route.locationStart.address}}</div></div><div class=\"wrapper text-2\"><div class=text uib-tooltip=\"{{vm.getDriverName(route.driver) || \'No seleccionado\'}}\">{{vm.getDriverName(route.driver) || \'No seleccionado\'}}</div><div class=num>{{vm.formatToTime(route.estimatedTimeStart)}}</div></div></div><div class=\"wrapper text-4\"><div class=\"wrapper text-2\"><div class=num>{{vm.formatToTime(route.estimatedTimeEnd)}}</div><div class=num>{{route.totalDistance | number:2}}</div></div><div class=\"wrapper text-2\"><div class=num>{{route.totalTime}}</div><div class=num>{{route.visits.length}}</div></div></div><div class=\"wrapper text-4\"><div class=\"wrapper text-2\"><div class=num>{{route.totalLoad | number:0}} / {{100*(route.totalLoad/vehicle.capacity) | number:0}}%</div><div class=num>{{route.totalLoad2 | number:0}} / {{100*(route.totalLoad2/vehicle.capacity2) | number:0}}%</div></div><div class=\"wrapper text-2\"><div class=num>{{route.totalLoad3 | number:0}} / {{100*(route.totalLoad3/vehicle.capacity3) | number:0}}%</div><div class=num ng-if=vm.isMixLoadAddonEnabled>{{route.totalLoad4 | number:0}} / {{100*(route.totalLoad4/vehicle.capacity4) | number:0}}%</div></div></div></div></div><!-- End Data --></div></div></div><!-- end modal-content --><div class=ngdialog-close ng-click=ngDialog.close()></div>");
$templateCache.put("app/planner/routes/routes-comment.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Routes.comments></h3></div><div class=modal-body><span class=sp-routes-comments-body translate=Routes.body_1></span> <span class=sp-routes-comments-p ng-repeat=\"route in vehicle.routes\"><p translate=Routes.route_name></p><p>{{$index+1}}</p><p ng-hide=\"$index+1 === vehicle.routes.length\">,</p><p></p></span><center><textarea class=\"form-control sp-routes-comments-text-area\" rows=3 ng-model=vm.routeComment></textarea></center></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Visits.remove_route_cancel></button> <button type=button class=\"btn btn-success\" ng-click=closeThisDialog(0);saveRouteComments(); translate=Routes.save_comments></button></div></div>");
$templateCache.put("app/planner/routes/routes-detail-delete-modal.html","");
$templateCache.put("app/planner/routes/routes-detail.html","<div id=mapContainer class=sp-planner-map><div ng-if=vm.showLoadsTable><loads-table join-similar=\"vm.optimizationOptions.join || vm.optimizationOptions.join_v2\" route=vm.selectedRouteForLoads header-text=vm.headerTextForLoadTable reverse-order=vm.reverseOrderLoadsTable show-table=vm.showLoadsTable close=vm.closeLoadsTable() select-visit=\"vm.selectVisitForLoadTable(routeId, visit, deselectSimilar)\" select-route=vm.selectRouteForLoadTable(route)></loads-table></div></div><div class=sp-planner-routes-header><div class=sp-planner-routes-edition-actions><div class=title><h2 class=sp-planner-new-header-title translate=Routes.routes_title_edit></h2></div><div class=\"sp-planner-routes-edition-buttons-header no-padding\"><div class=add-route uib-dropdown auto-close=outsideClick><a class=\"btn sp-btn-default sp_new_button\" uib-dropdown-toggle translate=Routes.btn_new href=\"\"></a><ul class=\"dropdown-menu dropdown-scrollable sp-vehicle-dropdown\" uib-dropdown-menu role=menu><li class=\"sp-dropdown-menu-item vehicle-menu-item\" role=menuitem ng-repeat=\"vehicle in vm.vehiclesAvailable | orderBy:[\'routes.length > 0\', vm.naturalSort(\'name\')]:false\" ng-mouseenter=\"vm.fillVehiclesOptions(vehicle, true)\" ng-mouseleave=\"vm.fillVehiclesOptions(vehicle, false)\" ng-click=vm.addRouteToVehicle(vehicle) uib-tooltip={{vehicle.availability.finalMessage}} tooltip-append-to-body=true tooltip-class=tooltip-enable-line-break ng-class=\"{\n              \'item-available\': vm.shouldDisplayAvailableVehicleData(vehicle.availability),\n              \'item-partially-available\': vm.shouldDisplayPartiallyAvailableVehicleData(vehicle.availability),\n              \'item-with-expired-documents\': vm.shouldDisplayVehicleWithExpiredDocumentsData(vehicle.availability),\n              \'item-row-gap\': !$first}\"><div class=vehicle-availability-icon ng-include=vm.getAvailabilityIconUrl(vehicle.availability) ng-style=\"{\'color\': vehicle.color}\"></div><a class=\"sp-name-option menu-vehicle-name\" href=\"\">{{ vm.getVehicleNameWithRouteMarking(vehicle) }}</a></li></ul></div><div class=sp-move-to-container ng-class=\"{\'uncollapsed\': !vm.isMoveToCollapsed}\"><div class=btn-move-to ng-click=\"vm.isMoveToCollapsed = !vm.isMoveToCollapsed\"><span translate=Routes.btn_moveTo></span><div ng-if=vm.isMoveToCollapsed class=sp-collapse-icon ng-include=\"\'/assets/images/navegation_down/navegation_down_16.svg\'\"></div><div ng-if=!vm.isMoveToCollapsed class=\"sp-collapse-icon up\" ng-include=\"\'/assets/images/navegation_up/navegation_up_16.svg\'\"></div></div><div uib-collapse=vm.isMoveToCollapsed class=sp-move-to-content><move-to-options options=vm.moveToOptions is-revised-option=false fill-circle-option=\"vm.fillCircleOption(route, highlight)\" move-visit-to=\"vm.moveVisitTo(vehicleId, routeId)\" is-container-collapsed=vm.isMoveToCollapsed></move-to-options><move-to-options options=vm.revisedRoutes is-revised-option=true fill-circle-option=\"vm.fillCircleOption(route, highlight)\" is-container-collapsed=vm.isMoveToCollapsed></move-to-options><div class=move-to-out-of-route ng-mouseenter=\"vm.fillCircleOption(vm.optionOutOfRoute, true)\" ng-mouseleave=\"vm.fillCircleOption(vm.optionOutOfRoute, false)\" ng-click=\"vm.moveVisitTo(vm.optionOutOfRoute.vehicleId, vm.optionOutOfRoute.routeId)\"><span>{{vm.optionOutOfRoute.name}}</span></div></div></div></div></div></div><search-bar data=vm.searchData filters=vm.filters on-click=vm.onClick on-remove=vm.onRemove no-results-found-text=\"\'SearchBar.Routes.noResultsFound\'\" min-text=\"\'SearchBar.Routes.minText\'\" placeholder=\"\'SearchBar.Routes.placeholder\'\"></search-bar><div id=scrollable-vehicles-list class=\"sp-planner-scrollable sp-planner-scrollable-edit\"><div class=sp-planner-routes-content><div id=parent-vehicles-list class=overflow><div ng-if=\"vm.filterHandler.visitsOffRoute || !vm.filterHandler.activeFilter\" class=sp-planner-routes-dispatchs-out-of-routes-header><div class=sp-planner-routes-dispatchs-out-of-routes-header-first-row><div class=sp-planner-routes-vehicle-header-hide-icon><div class=toggle-visibility ng-click=vm.toggleVisitsOutOfRoutes()><div ng-include=\"\'/assets/images/show_hide/show_icon.svg\'\" class=visiblity-icon ng-show=vm.showVisitsOutOfRoutes style=\"color: #73768C\"></div><div ng-include=\"\'/assets/images/show_hide/hide_icon.svg\'\" class=visiblity-icon ng-show=!vm.showVisitsOutOfRoutes style=\"color: #C7C9D1\"></div></div></div><div class=sp-planner-routes-dispatchs-out-of-routes-title ng-class=\"{\'title-less-visible\' : !vm.showVisitsOutOfRoutes}\" translate=Routes.visits_out_of_route_title></div><div class=planner-route-info-container><div class=sp-planner-routes-dispatchs-out-of-routes-title-indicator><i class=sp-icon-map-pin></i> <span>{{vm.calculateArrivalsOutOfRoute(vm.visitsOutOfRoute)}}</span><div class=sp-planner-out-of-route-loads><div class=sp-capacity><i class=sp-icon-carga-peso></i> {{ vm.visitsOutOfRouteFormattedLoads.load }}</div><div class=sp-capacity ng-if=vm.visitsOutOfRouteFormattedLoads.load2><i class=sp-icon-carga-volumen></i> {{ vm.visitsOutOfRouteFormattedLoads.load2 }}</div><div class=sp-capacity ng-if=vm.visitsOutOfRouteFormattedLoads.load3><i class=sp-icon-carga-valor></i> {{ vm.visitsOutOfRouteFormattedLoads.load3 }}</div><div class=\"sp-planner-route-single-indicator sp-capacity-container\" ng-if=\"vm.isMixLoadAddonEnabled() && vm.visitsOutOfRouteFormattedLoads.load4\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/box_filled.svg\'\"></div>{{ vm.visitsOutOfRouteFormattedLoads.load4 }}</div></div></div><div class=sp-planner-routes-dispatchs-out-of-routes-collapsed-icon><button class=\"btn btn-link sp-btn-collapse pull-right\" type=button ng-click=vm.collapseOrExpandVisitsOutOfRoute(!vm.visitsOutOfRouteActions.collapse)><div><i class=sp-icon-chevron-thin-up ng-if=!vm.visitsOutOfRouteActions.collapse></i> <i class=sp-icon-chevron-thin-down ng-if=vm.visitsOutOfRouteActions.collapse></i></div></button></div></div></div></div><div ng-if=\"vm.filterHandler.visitsOffRoute || !vm.filterHandler.activeFilter\" class=sp-planner-routes-dispatchs-out-of-routes-content><div uib-collapse=vm.visitsOutOfRouteActions.collapse><visit-filter ng-if=vm.isVisitsOutOfRouteFilterVisible() active-filter=vm.visitFilterHandler.activeFilter previous-min-slider-time=vm.visitFilterHandler.minSliderTime previous-max-slider-time=vm.visitFilterHandler.maxSliderTime filtered-visits=vm.visitFilterHandler.visits.length total-visits=vm.visitsOutOfRoute.length filter-visits=\"vm.filterVisitsOutOfRoute(minSliderTime, maxSliderTime)\"></visit-filter><div ng-if=\"vm.visitsOutOfRouteActions.visits.length > 0\" class=\"sp-select-all sp-select-all-vfrs\" ng-class=\"{\'visible\': vm.isVisitsOutOfRouteFilterVisible()}\"><div class=\"sp-display-flex sp-select-all-container\"><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-model=vm.selectAllVisitsOutOfRoute ng-change=vm.toggleSelectAllVisitsOutOfRoute()><label><span class=sp-icon-check></span></label></div><div class=sp-label><div class=sp-select-all-vfrs-header-container><span ng-click=\"vm.selectAllVisitsOutOfRoute = !vm.selectAllVisitsOutOfRoute; vm.toggleSelectAllVisitsOutOfRoute()\" translate=Routes.select_all></span><div ng-if=vm.visitsOutOfRouteForLoadTable.hasLoads() id=loads-table-open-btn ng-include=\"\'/assets/images/indicators/table.svg\'\" class=\"sp-planner-route-indicators-item sp-cursor-pointer\" ng-class=\"{\'sp-planner-route-indicators-item-selected\': vm.selectedRouteForLoads.id === vm.visitsOutOfRouteForLoadTable.id}\" ng-click=\"vm.setLoadsTableRoute(vm.visitsOutOfRouteForLoadTable, 0)\"></div></div><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content-capacities><div class=sp-text-selected>{{(\'Visits.number_of_visits_selected\' | translate:{selectedVisits: vm.selectedVisitsOutOfRouteCount, totalVisits: vm.visitsOutOfRouteActions.visits.length})}}</div><div class=all-capacity><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError}\"><i class=sp-icon-carga ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError}\"></i> {{ vm.selectedVisitOutOfRoute.load > 999 ? \'999+\' : vm.selectedVisitOutOfRoute.load }}</div><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError2}\"><i class=sp-icon-carga-volumen ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError2}\"></i> {{ vm.selectedVisitOutOfRoute.load2 > 999 ? \'999+\' : vm.selectedVisitOutOfRoute.load2 }}</div><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError3}\"><i class=sp-icon-carga-valor ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError3}\"></i> {{ vm.selectedVisitOutOfRoute.load3 > 999 ? \'999+\' : vm.selectedVisitOutOfRoute.load3 }}</div><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError4}\"><div class=sp-capacity-mix-load-icon ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError4}\" ng-include=\"\'/assets/images/vehicle_stats/box_filled.svg\'\"></div>{{ vm.selectedVisitOutOfRoute.load4 > 999 ? \'999+\' : vm.selectedVisitOutOfRoute.load4 }}</div></div></div></div></div></div><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit id={{::visitOFR.id}} ng-mouseenter=\"vm.onMouseHoverVisit(\n                  visitOFR, vm.filterHandler.activeFilter, vm.filterHandler.visits[visitOFR.id]\n                 )\" ng-mouseleave=\"vm.onMouseLeaveVisit(visitOFR, vm.filterHandler.activeFilter)\" ng-repeat=\"visitOFR in vm.visitsOutOfRouteActions.visits track by visitOFR.id\"><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-left-side><div class=sp-select-all><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-model=visitOFR.selected ng-change=vm.toggleVisitOutOfRoute(visitOFR)><label><span class=sp-icon-check></span></label></div></div></div><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side id=visit-{{::visitOFR.id}} ng-style=limitLoadStyleOut ng-class=\"{\'focus-binding-visit\': vm.filterHandler.visits[visitOFR.id] && !vm.filterHandler.hoverActiveAnotherVisit}\" ng-init=\"limitLoadStyleOut=vm.routesUtils.getStyleByLoadLimit(visitOFR, \'init\')\" ng-mouseleave=\"limitLoadStyleOut=vm.routesUtils.getStyleByLoadLimit(visitOFR, \'leave\')\" ng-mouseover=\"limitLoadStyleOut=vm.routesUtils.getStyleByLoadLimit(visitOFR, \'over\')\"><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content-wrapper><span class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-header-title>{{visitOFR.title}}</span><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content-address><div class=sp-left-block><i class=\"sp-icon-map-pin visit-card-icon-padding\"></i></div><div class=sp-right-block><span>{{visitOFR.address}}</span></div></div></div><div ng-if=\"(vm.enableNotesInRouteDesigner && visitOFR.notes.trim() !== \'\')\" class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content-address><div class=sp-left-block><i class=\"sp-icon-notes visit-card-icon-padding\"></i></div><div class=sp-right-block><span>{{visitOFR.notes}}</span></div></div></div><div ng-if=\"(\n                    vm.mustShowVisitWindows(visitOFR.windowStart, visitOFR.windowEnd) ||\n                    vm.mustShowVisitWindows(visitOFR.windowStart2, visitOFR.windowEnd2)\n                  )\" class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content-address><div class=sp-left-block><i class=\"sp-icon-ventana-horaria visit-card-icon-padding\"></i></div><div class=sp-right-block><span>{{vm.displayWindows(visitOFR)}}</span></div></div></div><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content-capacities><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError}\"><i class=\"sp-icon-carga visit-card-icon-padding\" ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError}\"></i> {{visitOFR.load | formatNumber:2:\'.\':\',\'}}</div><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError2}\"><i class=\"sp-icon-carga-volumen visit-card-icon-padding\" ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError2}\"></i> {{visitOFR.load2 | formatNumber:2:\'.\':\',\'}}</div><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError3}\"><i class=\"sp-icon-carga-valor visit-card-icon-padding\" ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError3}\"></i> {{visitOFR.load3 | formatNumber:2:\'.\':\',\'}}</div><div class=\"sp-capacity sp-flex-container\" ng-if=vm.isMixLoadAddonEnabled()><div class=visit-card-icon-padding ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError4}\" ng-include=\"\'/assets/images/vehicle_stats/box_filled.svg\'\"></div>{{visitOFR.load4 | formatNumber:2:\'.\':\',\'}}</div></div><div class=\"items-container out-of-route-visit-items-summary\"><items-summary-in-visit-card items=visitOFR.items class=card-item></items-summary-in-visit-card></div></div><div ng-if=visitOFR.addedInCurrentRouting class=sp-planner-new-visit-element uib-tooltip=\"{{ \'Visits.tooltips.new_visit\' | translate }}\"></div></div></div></div></div></div><div ng-if=!vm.filterHandler.activeFilter class=sp-planner-routes-hide-routes><div class=sp-planner-routes-filter-header><reorder-routes ng-if=!vm.hasPlanRoutesProcessed on-click=vm.reorderEditedRoutes></reorder-routes><vehicle-sort-by algorithm=vm.vehicleSort desc=vm.vehicleSortDesc sort-key=vm.vehicleSortKey total-loads=vm.totalRoutedLoads></vehicle-sort-by></div><div class=sp-planner-routes-filter-header><p class=m-0>{{vm.routes.length}} <span ng-if=\"vm.routes.length !== 1\" translate=Routes.routes></span> <span ng-if=\"vm.routes.length === 1\" translate=Routes.route_singular></span></p><div><p class=\"text-left m-0\" ng-show=vm.visibleAllRoutes><a href=\"\" ng-click=vm.toggleVisibleAllRoutes() translate=Routes.hide_routes></a></p><p class=\"text-left m-0\" ng-show=!vm.visibleAllRoutes><a href=\"\" ng-click=vm.toggleVisibleAllRoutes() translate=Routes.show_routes></a></p></div></div></div><div ng-repeat=\"isVehicleInGroupFn in ::vm.vehiclesGroupingCriteria\"><div ng-if=isVehicleInGroupFn(vehicle) id=vehicle-list-item-{{::vehicle.id}} class=sp-planner-routes-vehicle ng-repeat=\"(vehicleIndex, vehicle) in vm.vehicles | searchVehicleFilter:vm.filterHandler | orderBy:vm.vehicleSort:vm.vehicleSortDesc\"><div class=sp-planner-routes-vehicle-header><div class=sp-planner-routes-vehicle-header-title-box><div class=toggle-visibility ng-click=vm.toggleShowRoutes(vehicle)><div ng-include=\"\'/assets/images/show_hide/show_icon.svg\'\" class=visiblity-icon ng-show=vehicle.showRoutes ng-style=\"{color: vehicle.color}\"></div><div ng-include=\"\'/assets/images/show_hide/hide_icon.svg\'\" class=visiblity-icon ng-show=!vehicle.showRoutes ng-style=\"{color: vehicle.color}\"></div></div><div class=sp-planner-routes-vehicle-header-title ng-style=\"vm.showVehicleList[$index] && { display: \'flex\', \'align-items\': \'center\', \'column-gap\': 2 }\"><div class=sp-planner-routes-vehicle-select-container><button ng-disabled=!vm.canVehicleBeInterchanged(vehicle) ng-click=\"vm.canVehicleBeInterchanged(vehicle) && vm.toggleShowVehicleList($index)\" ng-class=vm.getVehicleNameNgClass(vehicle)>{{vehicle.name}}</button> <span ng-if=\"!vm.hasMultipleRoute(vehicle) && vehicle.driverId\" class=sp-planner-driver-name>{{ vm.getDriverFullName(vehicle.driverId) }}</span><rich-select ng-if=vm.showVehicleList[$index] class=rich-select-container current-selected-item=vm.selectedItemId display-data=vm.displayVehiclesList on-click=vm.selectVehicleId(item) on-interchange-route=\"vm.interchangeRoute(vehicle.id, vm.selectedItemId)\"></div><a href=\"\" ng-click=vm.toggleShowVehicleList($index) ng-show=vm.showVehicleList[$index]><i class=\"glyphicon glyphicon-remove\"></i></a></div><driver ng-if=\"!vm.showVehicleList[$index] && !vm.isMultiDriverVehicle(vehicle)\" driver-id=vehicle.driverId drivers=vm.drivers on-change=\"vm.updateVehicleDriver(vehicle, selectedDriver, vm.vehicles)\" is-driver-assignment-disabled=vehicle.areAllRoutesRevised></driver></div><div ng-if=!vm.hasMultipleRoute(vehicle) class=sp-planner-routes-vehicle-statistics ng-class=vm.getVehicleStatisticsNgClass(vehicle)><div class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{\'Vehicles.total_routes\' | translate}}\" tooltip-enable={{!vehicle.areAllRoutesRevised}}><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/routing_filled_16.svg\'\"></div><span>{{ vehicle.routes.length | formatNumber:0 }}</span></div><div ng-if=\"vm.optimizationOptions.join || vm.optimizationOptions.join_v2\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\'Vehicles.total_arrivals\' | translate}}\" tooltip-enable={{!vehicle.areAllRoutesRevised}}><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/marker_filled_16.svg\'\"></div><span>{{ vm.calculateRouteArrivals(vehicle.routes[0]) | formatNumber:0 }}</span></div><div class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                  vehicle.routes[0].alertCounts.maxVisitError\n                  ? (\'Vehicles.tooltips.max_visit_error\' | translate:{ max_visit_vehicle: vehicle.maxVisit })\n                  : (\'Vehicles.visit_count\' | translate)\n                }}\" tooltip-enable={{!vehicle.areAllRoutesRevised}} ng-class=\"{\'sp-container-color-danger\': vehicle.routes[0].alertCounts.maxVisitError}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/location_filled_16.svg\'\"></div><span>{{ vehicle.routes[0].visits.length | formatNumber:0 }}</span></div><div ng-if=\"vm.isClientsModuleEnabled && vm.calculateRouteClients(vehicle.routes[0]) > 0\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\'Vehicles.client_count\' | translate}}\" tooltip-enable={{!vehicle.areAllRoutesRevised}}><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/user_filled_16.svg\'\"></div><span>{{ vehicle.routes[0].clientCount | formatNumber:0 }}</span></div><div class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                  vehicle.maximumTimeError\n                  ? (\'Vehicles.tooltips.maximum_time_error\' | translate) + \'\\n\' + vehicle.shiftDefault.formattedMaximumTime + \' hrs\'\n                  : (\'Vehicles.time_routes\' | translate)\n                }}\" tooltip-enable={{!vehicle.areAllRoutesRevised}} ng-class=\"{\'sp-container-color-danger\': vehicle.maximumTimeError}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/timer_filled_16.svg\'\"></div><span>{{ vehicle.routes[0].totalTimeFormatted }} <small>hrs</small></span></div><div class=sp-planner-routes-vehicle-header-kpis ng-class=\"{\'sp-container-color-danger\': vm.doesVehicleHaveRouteExceedingMaxDistance(vehicle)}\" uib-tooltip=\"{{\'Vehicles.total_kms\' | translate}}\" tooltip-enable={{!vehicle.areAllRoutesRevised}}><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/odometer_filled_24.svg\'\"></div><span>{{ vehicle.routes[0].totalDistance.toFixed(2) | formatNumber }} <small>kms</small></span></div><div class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                  vehicle.routes[0].formattedLoad && vehicle.routes[0].capacityError\n                  ? (\'Routes.tooltips.charge_error_one\' | translate) + \'\\n\' + vehicle.routes[0].formattedLoad\n                  : vehicle.routes[0].formattedLoad\n                }}\" tooltip-enable={{!vehicle.areAllRoutesRevised}} ng-class=\"{\'sp-text-color-danger\': vehicle.routes[0].capacityError}\"><i class=\"sp-icon-carga-peso fs-12\"></i> <span>{{ vehicle.routes[0].totalLoadPercentage | formatNumber:0 }}%</span></div><div ng-if=\"vehicle.routes[0].totalLoad2 > 0\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                  vehicle.routes[0].formattedLoad2 && vehicle.routes[0].capacityError2\n                  ? (\'Routes.tooltips.charge_error_two\' | translate) + \'\\n\' + vehicle.routes[0].formattedLoad2\n                  : vehicle.routes[0].formattedLoad2\n                }}\" tooltip-enable={{!vehicle.areAllRoutesRevised}} ng-class=\"{\'sp-text-color-danger\': vehicle.routes[0].capacityError2}\"><i class=\"sp-icon-carga-volumen fs-12\"></i> <span>{{ vehicle.routes[0].totalLoadPercentage2 | formatNumber:0 }}%</span></div><div ng-if=\"vehicle.routes[0].totalLoad3 > 0\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                  vehicle.routes[0].formattedLoad3 && vehicle.routes[0].capacityError3\n                  ? (\'Routes.tooltips.charge_error_three\' | translate) + \'\\n\' + vehicle.routes[0].formattedLoad3\n                  : vehicle.routes[0].formattedLoad3\n                }}\" tooltip-enable={{!vehicle.areAllRoutesRevised}} ng-class=\"{\'sp-text-color-danger\': vehicle.routes[0].capacityError3}\"><i class=\"sp-icon-carga-valor fs-12\"></i> <span>{{ vehicle.routes[0].totalLoadPercentage3 | formatNumber:0 }}%</span></div><div ng-if=\"vm.isMixLoadAddonEnabled() && vehicle.routes[0].totalLoad4 > 0\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                  vehicle.routes[0].formattedLoad4 && vehicle.routes[0].capacityError4\n                  ? (\'Routes.tooltips.charge_error_four\' | translate) + \'\\n\' + vehicle.routes[0].formattedLoad4\n                  : vehicle.routes[0].formattedLoad4\n                }}\"><div class=sp-flex-container ng-class=\"{\'sp-text-color-danger\': vehicle.routes[0].capacityError4}\" ng-include=\"\'/assets/images/vehicle_stats/box_filled.svg\'\"></div><span>{{ vehicle.routes[0].totalLoadPercentage4 | formatNumber:0 }}%</span></div></div><div ng-if=vm.hasMultipleRoute(vehicle) class=sp-planner-routes-vehicle-statistics ng-class=vm.getVehicleStatisticsNgClass(vehicle)><div class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{\'Vehicles.total_routes\' | translate}}\" tooltip-enable={{!vehicle.areAllRoutesRevised}}><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/routing_filled_16.svg\'\"></div><span>{{ vehicle.routes.length | formatNumber:0 }}</span></div><div ng-if=\"vm.optimizationOptions.join || vm.optimizationOptions.join_v2\" class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{\'Vehicles.total_arrivals\' | translate}}\" tooltip-enable={{!vehicle.areAllRoutesRevised}}><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/marker_filled_16.svg\'\"></div><span>{{ vm.dataByVehicle[vehicle.id].totalArrivals | formatNumber:0 }}</span></div><div class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{\'Vehicles.visit_count\' | translate}}\" tooltip-enable={{!vehicle.areAllRoutesRevised}}><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/location_filled_16.svg\'\"></div><span>{{ vm.dataByVehicle[vehicle.id].visitCount | formatNumber:0 }}</span></div><div ng-if=\"vm.dataByVehicle[vehicle.id].clientCount > 0\" class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{\'Vehicles.client_count\' | translate}}\" tooltip-enable={{!vehicle.areAllRoutesRevised}}><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/user_filled_16.svg\'\"></div><span>{{ vm.dataByVehicle[vehicle.id].clientCount | formatNumber:0 }}</span></div><div class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{\n                  vehicle.maximumTimeError\n                  ? (\'Vehicles.tooltips.maximum_time_error\' | translate) + \'\\n\' + vehicle.shiftDefault.formattedMaximumTime + \' hrs\'\n                  : (\'Vehicles.time_routes\' | translate)\n                }}\" tooltip-enable={{!vehicle.areAllRoutesRevised}} ng-class=\"{\'sp-container-color-danger\': vehicle.maximumTimeError}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/timer_filled_16.svg\'\"></div><span>{{ vm.dataByVehicle[vehicle.id].totalTime }} hrs</span></div><div class=sp-planner-routes-vehicle-header-kpis ng-class=\"{\'sp-container-color-danger\': vm.doesVehicleHaveRouteExceedingMaxDistance(vehicle)}\" uib-tooltip=\"{{ \'Vehicles.total_kms\' | translate }}\" tooltip-enable={{!vehicle.areAllRoutesRevised}}><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/odometer_filled_24.svg\'\"></div><span>{{ vm.dataByVehicle[vehicle.id].totalKms | formatNumber }} kms</span></div><div class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{ \'Vehicles.average_load_1\' | translate }}\" tooltip-enable={{!vehicle.areAllRoutesRevised}}><i class=\"sp-icon-carga-peso fs-12\"></i> <span>{{ vm.dataByVehicle[vehicle.id].averageLoadsPercentage[0] }}%</span></div><div ng-if=\"vm.dataByVehicle[vehicle.id].totalLoads[1] > 0\" class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{ \'Vehicles.average_load_2\' | translate }}\" tooltip-enable={{!vehicle.areAllRoutesRevised}}><i class=\"sp-icon-carga-volumen fs-12\"></i> <span>{{ vm.dataByVehicle[vehicle.id].averageLoadsPercentage[1] }}%</span></div><div ng-if=\"vm.dataByVehicle[vehicle.id].totalLoads[2] > 0\" class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{ \'Vehicles.average_load_3\' | translate }}\" tooltip-enable={{!vehicle.areAllRoutesRevised}}><i class=\"sp-icon-carga-valor fs-12\"></i> <span>{{ vm.dataByVehicle[vehicle.id].averageLoadsPercentage[2] }}%</span></div><div ng-if=\"vm.dataByVehicle[vehicle.id].totalLoads[3] > 0 && vm.isMixLoadAddonEnabled()\" class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{ \'Vehicles.average_load_4\' | translate }}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/box_filled.svg\'\"></div><span>{{ vm.dataByVehicle[vehicle.id].averageLoadsPercentage[3] }}%</span></div></div></div><div id={{::route.id}} ng-if=vm.showRoutesDiv class=sp-planner-routes-vehicle-content ng-repeat=\"route in vehicle.routes | searchRouteFilter:vm.filterHandler\" ng-init=\"routeIndex = $index\"><div uib-collapse=vehicle.collapseRoutes><div class=sp-planner-routes-vehicle-content-route><div class=sp-planner-routes-vehicle-content-route-collapse ng-class=\"{\'route-card-disabled\' : route.isRevised}\" ng-click=vm.toggleCollapseRoute(route)><div class=sp-planner-routes-vehicle-content-route-header ng-style=\"vm.hasMultipleRoute(vehicle) && {\'padding-bottom\': \'8px\', \'border-bottom\': \'1px solid #CACDE7\'}\"><div class=\"sp-planner-routes-vehicle-content-route-detail-header-checkbox route-element\"><div class=\"sp-select-all sp-select-all--edit\"><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-model=route.editingSelected ng-click=$event.stopPropagation(); ng-change=vm.toggleEditingVisitsOfRoute(route) ng-disabled=route.isRevised><label><span class=sp-icon-check></span></label></div></div></div><i class=\"fs-20 route-element\" ng-class=\"{\'sp-icon-triangle-down\': !route.collapse, \'sp-icon-triangle-right\': route.collapse}\"></i><div class=sp-planner-route-title style=\"display: flex\"><span class=route-element>{{ vm.getRouteName(route, $index + 1) }}<div ng-if=\"vm.isEditingPlan && vm.shouldCheckRouteStatus && route.status && !route.isRevised\" class=sp-route-status-badge ng-class=\"{\n                            \'status-started\': route.status === \'started\',\n                            \'status-pending\': route.status === \'pending\',\n                            \'status-completed\': route.status === \'completed\',\n                            \'status-finished\': route.status === \'finished\'\n                          }\"><span translate=Routes.status.{{route.status}}></span></div></span><span ng-if=\"vm.hasMultipleRoute(vehicle) && route.driver\" class=sp-planner-route-driver-name>{{ vm.getDriverFullName(route.driver) }}</span><div ng-if=route.isRevised class=sp-support-badge><div ng-include=\"\'/assets/images/check_circle_filled.svg\'\" class=icon-check></div><span translate=Routes.support_badge.revised></span></div></div><div class=sp-planner-route-indicators-options><div class=\"sp-planner-route-indicators route-element\"><i ng-if=\"route.timeError || route.hasRestTimeError\" uib-tooltip=\"{{ \'Routes.tooltips.time_error\' | translate }}\" tooltip-enable={{!route.isRevised}} class=\"sp-icon-ventana-horaria sp-planner-routes-vehicle-content-route-header-statistics-warning-icon fs-14\"></i> <img ng-if=route.skillsError class=sp-icon-skills-error uib-tooltip=\"{{ \'Routes.tooltips.skills_error\' | translate }}\" tooltip-enable={{!route.isRevised}} src=../../../assets/images/skills_error.svg alt=\"skills error\"><driver ng-if=\"!route.isRevised && vm.isMultiDriverVehicle(vehicle)\" driver-id=route.driver drivers=vm.drivers on-change=\"vm.setVehicleDriver(vehicle, route, selectedDriver, vm.vehicles)\"></driver><div id=loads-table-open-btn ng-if=\"!route.isRevised && route.hasLoads()\" ng-include=\"\'/assets/images/indicators/table.svg\'\" class=sp-planner-route-indicators-item ng-class=\"{\'sp-planner-route-indicators-item-selected\': vm.selectedRouteForLoads.id === route.id}\" ng-click=\"vm.setLoadsTableRoute(route, $index)\"></div><i ng-if=\"!route.isRevised && vm.enableRouteEditIndicator\" ng-class=\"{\'sp-text-color-success\': route.routeEditIndicator}\" uib-tooltip=\"{{\'Routes.tooltips.edited_route\' | translate}}\" tooltip-enable=route.routeEditIndicator class=\"sp-icon-check fs-14\" ng-click=vm.changeEditIndicator(route)></i><route-menu-dropdown ng-if=!route.isRevised route=route toggle-options-menu=vm.toggleOptionsMenu(route) mark-as-revised=vm.markRouteAsRevised(route) reorder-route=vm.reorderRoute(route) go-to-delete-route=\"vm.goToDeleteRoute($event, vehicle, route, $index+1)\" reverse-route-order=\"vm.reverseRouteOrder(vehicle, route)\" prioritize-load=\"vm.reorderRoute(route, true)\"></route-menu-dropdown></div><div ng-if=route.isRevised class=\"sp-planner-route-indicators edit-revised-route-btn\"><p class=\"text-left m-0\"><a href=\"\" ng-click=vm.openRevisedRouteModal(route) translate=Revised_routes.edit_route></a></p></div></div></div><div ng-if=vm.hasMultipleRoute(vehicle) class=\"sp-planner-routes-vehicle-statistics route-element\"><div ng-if=\"vm.optimizationOptions.join || vm.optimizationOptions.join_v2\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\'Vehicles.total_arrivals\' | translate}}\" tooltip-enable={{!route.isRevised}}><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/marker_filled_16.svg\'\"></div><span>{{ vm.calculateRouteArrivals(route) | formatNumber:0 }}</span></div><div class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                        route.alertCounts.maxVisitError\n                        ? (\'Vehicles.tooltips.max_visit_error\' | translate:{ max_visit_vehicle: vehicle.maxVisit })\n                        : (\'Vehicles.visit_count\' | translate)\n                      }}\" tooltip-enable={{!route.isRevised}} ng-class=\"{\'sp-container-color-danger\': route.alertCounts.maxVisitError}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/location_filled_16.svg\'\"></div><span>{{ route.visits.length | formatNumber:0 }}</span></div><div ng-if=\"vm.isClientsModuleEnabled && vm.calculateRouteClients(route) > 0\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\'Vehicles.client_count\' | translate}}\" tooltip-enable={{!route.isRevised}}><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/user_filled_16.svg\'\"></div><span>{{ route.clientCount | formatNumber:0 }}</span></div><div class=sp-planner-routes-vehicle-header-kpis><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/timer_filled_16.svg\'\"></div><span>{{ route.totalTimeFormatted }} <small>hrs</small></span></div><div class=sp-planner-routes-vehicle-header-kpis ng-class=\"{\'sp-container-color-danger\': vm.doesRouteExceedMaxDistance(route, vehicle)}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/odometer_filled_24.svg\'\"></div><span>{{ route.totalDistance.toFixed(2) | formatNumber }} <small>kms</small></span></div><div class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                        route.formattedLoad && route.capacityError\n                        ? (\'Routes.tooltips.charge_error_one\' | translate) + \'\\n\' + route.formattedLoad\n                        : route.formattedLoad\n                      }}\" tooltip-enable={{!route.isRevised}} ng-class=\"{\'sp-text-color-danger\': route.capacityError}\"><i class=\"sp-icon-carga-peso fs-12\"></i> <span>{{ route.totalLoadPercentage | formatNumber:0 }}%</span></div><div ng-if=\"route.totalLoad2 > 0\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                        route.formattedLoad2 && route.capacityError2\n                        ? (\'Routes.tooltips.charge_error_two\' | translate) + \'\\n\' + route.formattedLoad2\n                        : route.formattedLoad2\n                      }}\" tooltip-enable={{!route.isRevised}} ng-class=\"{\'sp-text-color-danger\': route.capacityError2}\"><i class=\"sp-icon-carga-volumen fs-12\"></i> <span>{{ route.totalLoadPercentage2 | formatNumber:0 }}%</span></div><div ng-if=\"route.totalLoad3 > 0\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                        route.formattedLoad3 && route.capacityError3\n                        ? (\'Routes.tooltips.charge_error_three\' | translate) + \'\\n\' + route.formattedLoad3\n                        : route.formattedLoad3\n                      }}\" tooltip-enable={{!route.isRevised}} ng-class=\"{\'sp-text-color-danger\': route.capacityError3}\"><i class=\"sp-icon-carga-valor fs-12\"></i> <span>{{ route.totalLoadPercentage3 | formatNumber:0 }}%</span></div><div ng-if=\"route.totalLoad4 > 0  && vm.isMixLoadAddonEnabled()\" class=\"sp-planner-routes-vehicle-header-kpis sp-capacity-mix-load-icon\" tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                        route.formattedLoad4 && route.capacityError4\n                        ? (\'Routes.tooltips.charge_error_four\' | translate) + \'\\n\' + route.formattedLoad4\n                        : route.formattedLoad4\n                      }}\" tooltip-enable={{!route.isRevised}} ng-class=\"{\'sp-text-color-danger\': route.capacityError4}\"><div class=sp-flex-container ng-class=\"{\'sp-text-color-danger\': route.capacityError4}\" ng-include=\"\'/assets/images/vehicle_stats/box_filled.svg\'\"></div><span>{{ route.totalLoadPercentage4 | formatNumber:0 }}%</span></div></div></div><div class=sp-planner-routes-vehicle-content-route-content><div class=\"sp-collapse-route sp-route-{{vehicle.id}}-{{$index}}\" uib-collapse=route.collapse ui-tree=vm.dragControlListeners data-empty-placeholder-enabled=false><ul class=sp-planner-routes-vehicle-content-route-content-visits-info ui-tree-nodes data-type=visit ng-model=route.visitsAndEvents route-in-drag-status={{route.status}}><li ng-if=\"!(vm.optimizationOptions.open_start && $first)\" class=sp-planner-routes-vehicle-content-route-content-visits-info-location-start no-drag><div class=sp-planner-routes-vehicle-content-route-content-visits-info-location-start-left-side><div class=sp-planner-routes-vehicle-content-route-content-visits-info-location-start-left-side-icon><i class=sp-icon-home ng-style=\"{\'color\':vehicle.color}\"></i></div><div ng-if=\"vm.isMultidayRouteEnabled  || vm.moment(visit.estimatedTimeArrival).format(\'DD/MM\') !== vm.moment(route.estimatedTimeStart).format(\'DD/MM\')\" class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-left-side-time>{{vm.moment(route.estimatedTimeStart).format(\'DD/MM\')}}</div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-left-side-time>{{vm.moment(route.estimatedTimeStart).format(\'LT\')}}</div></div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-location-start-right-side><span translate=Routes.from></span> {{vehicle.locationStart.address}}</div></li><li ng-if=route.areVisitsListed ng-repeat=\"visit in route.visitsAndEvents\" ui-tree-node data-nodrop-enabled=true data-nodrag={{vm.isVisitFromProcessedRoute(visit)}} data-scroll-container=.sp-route-{{vehicle.id}}-{{routeIndex}} class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-container><div ng-if=\"visit.type === vm.VISIT_TYPE.VISIT\" ng-mouseenter=\"vm.onMouseHoverVisit(visit, vm.filterHandler.activeFilter, vm.filterHandler.visits[visit.id])\" ng-mouseleave=\"vm.onMouseLeaveVisit(visit, vm.filterHandler.activeFilter)\" class=sp-planner-routes-vehicle-content-route-content-visits-info-visit ng-class=\"{\'sp-error\': (\n                            visit.timeError || visit.capacityError || visit.capacityError2 || visit.capacityError3 ||\n                            visit.skillsError || visit.maximumTimeError || visit.maxVisitError\n                          )}\"><visit-similarity-marker current-visit=visit previous-visit=\"vm.getPreviousVisit(route.visitsAndEvents, $index)\" next-visit=\"vm.getNextVisit(route.visitsAndEvents, $index)\" vehicle-color=vehicle.color join-similar=\"vm.optimizationOptions.join || vm.optimizationOptions.join_v2\"></visit-similarity-marker><div id=visit-{{visit.id}} class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-left-side><div class=sp-select-all><div class=sp-planner-routes-edit-checkbox ng-style=\"visit.selected ? {\'background-color\': vehicle.colorDarker, \'border-color\': vehicle.color} : {\'border-color\': vehicle.color}\" ng-mouseenter=\"visit.hover = true\" ng-mouseleave=\"visit.hover = false\"><input type=checkbox class=sp-checkbox-input ng-model=visit.selected ng-change=vm.toggleSelectedEditVisit(visit)><label ng-if=visit.hover ng-style=\"visit.selected ? {\'color\': \'white\'} : {\'color\': vehicle.colorDarker}\"><span class=sp-icon-check></span></label><label ng-if=!visit.hover ng-style=\"visit.selected ? {\'color\': \'white\'} : {\'color\': vehicle.color}\"><span>{{visit.order}}</span></label></div></div><div ng-if=\"vm.isMultidayRouteEnabled || vm.moment(visit.estimatedTimeArrival).format(\'DD/MM\') !== vm.moment(route.estimatedTimeStart).format(\'DD/MM\')\" class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-left-side-time>{{vm.moment(visit.estimatedTimeArrival).format(\'DD/MM\')}}</div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-left-side-time>{{vm.moment(visit.estimatedTimeArrival).format(\'LT\')}}</div></div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side ng-style=limitLoadStyle ng-init=\"limitLoadStyle=vm.routesUtils.getStyleByLoadLimit(visit, \'init\')\" ng-mouseleave=\"limitLoadStyle=vm.routesUtils.getStyleByLoadLimit(visit, \'leave\')\" ng-mouseover=\"limitLoadStyle=vm.routesUtils.getStyleByLoadLimit(visit, \'over\')\" ng-class=\"{\n                              \'focus-binding-visit\': vm.filterHandler.visits[visit.id] && !vm.filterHandler.hoverActiveAnotherVisit,\n                              \'visit_edit_block_by_route_processed\': vm.isVisitFromProcessedRoute(visit)\n                            }\" ui-tree-handle><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content-wrapper><span class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-header-title>{{visit.title}}</span><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content-address><i class=\"sp-icon-map-pin visit-card-icon-padding\"></i> {{visit.address}}</div></div><div ng-if=visit.reference class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content><div class=\"sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content-address container-reference-id\"><div ng-include=\"\'/assets/images/file-report.svg\'\" class=icon-file-report></div><span class=sp-text-ellipsis>{{visit.reference}}</span></div></div><div ng-if=\"(vm.enableNotesInRouteDesigner && visit.notes.trim() !== \'\')\" class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content-address><i class=\"sp-icon-notes visit-card-icon-padding\"></i> {{visit.notes}}</div></div><div ng-if=\"(\n                                  vm.mustShowVisitWindows(visit.windowStart, visit.windowEnd) ||\n                                  vm.mustShowVisitWindows(visit.windowStart2, visit.windowEnd2)\n                                )\" class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content-address><i class=\"sp-icon-ventana-horaria visit-card-icon-padding\"></i> {{vm.displayWindows(visit)}}</div></div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content-capacities><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visit.capacityError}\"><i class=\"sp-icon-carga visit-card-icon-padding\" ng-class=\"{\'sp-text-color-danger\': visit.capacityError}\"></i> {{visit.load | formatNumber:2:\'.\':\',\'}}</div><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visit.capacityError2}\"><i class=\"sp-icon-carga-volumen visit-card-icon-padding\" ng-class=\"{\'sp-text-color-danger\': visit.capacityError2}\"></i> {{visit.load2 | formatNumber:2:\'.\':\',\'}}</div><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visit.capacityError3}\"><i class=\"sp-icon-carga-valor visit-card-icon-padding\" ng-class=\"{\'sp-text-color-danger\': visit.capacityError3}\"></i> {{visit.load3 | formatNumber:2:\'.\':\',\'}}</div><div ng-if=vm.isMixLoadAddonEnabled() class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visit.capacityError4}\"><div class=\"sp-flex-container visit-card-icon-padding\" style=\"display: inline; vertical-align: middle\" ng-class=\"{\'sp-text-color-danger\': visit.capacityError4}\" ng-include=\"\'/assets/images/vehicle_stats/box_filled.svg\'\"></div>{{visit.load4 | formatNumber:2:\'.\':\',\'}}</div></div></div><div ng-if=visit.addedInCurrentRouting class=sp-planner-new-visit-element></div></div><div class=sp-expand-visit-icon-container><div class=\"sp-expand-visit-icon sp-background-grey\" ng-click=\"vm.expandVisit(visit, route)\"><div ng-include=\"\'/assets/images/expand_visit.svg\'\"></div></div></div></div><rest-time-card ng-if=\"visit.type === vm.VISIT_TYPE.EVENT\" rest-time=visit show-drag-handle=true is-event-from-processed-route=vm.isVisitFromProcessedRoute(visit) vehicle=vehicle></rest-time-card></li><li ng-if=\"!(vm.optimizationOptions.open_ended && !vm.optimizationOptions.big_cluster && $last)\" class=sp-planner-routes-vehicle-content-route-content-visits-info-location-end no-drag><div class=sp-planner-routes-vehicle-content-route-content-visits-info-location-end-left-side><div ng-if=\"vm.isMultidayRouteEnabled || vm.moment(visit.estimatedTimeArrival).format(\'DD/MM\') !== vm.moment(route.estimatedTimeStart).format(\'DD/MM\')\" class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-left-side-time>{{vm.moment(route.estimatedTimeEnd).format(\'DD/MM\')}}</div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-left-side-time>{{vm.moment(route.estimatedTimeEnd).format(\'LT\')}}</div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-location-end-left-side-icon><i class=sp-icon-destino ng-style=\"{\'color\':vehicle.color}\"></i></div></div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-location-end-right-side><span translate=Routes.to></span> {{vehicle.locationEnd.address}}</div></li></ul></div></div></div></div></div></div></div></div><!-- end sp-planner-scrollable --><footer class=sp-planner-footer><div class=row><button class=\"btn sp-btn-default pull-left sp_new_button_thin\" ng-click=vm.cancelEditing() translate=Planner.btn_cancel></button><div class=pull-right><button ng-if=\"vm.rebalanceRoutesEnabled && !vm.hasPlanRoutesProcessed\" class=\"btn sp-btn-default sp-btn-margin-right-separation sp_new_button_thin\" ng-click=vm.rebalanceRoutes() translate=Planner.btn_balance></button> <button ng-if=vm.draftsEnabled class=\"btn sp-btn-default sp-btn-margin-right-separation sp_new_button_thin\" ng-click=vm.confirmEditingChangesForSaveDraftPlan() translate=Planner.btn_save_draft></button> <button class=\"btn btn-success sp_new_button_thin\" ng-click=vm.confirmEditingChanges() translate=Planner.btn_save></button></div></div></footer></div></div>");
$templateCache.put("app/planner/routes/routes.html","<div class=sp-loader-planner ng-if=isLoadingBigData><div class=sp-loader-container><div class=loading style=\"width: {{vm.widthDynamic}}\"><div class=sp-truck-on-move><img class=gif ng-src=../../../assets/images/loader-progress.gif></div></div><uib-progressbar animate=false max=vm.maxProgressBar value=vm.routesCompleted></uib-progressbar></div></div><div class=sp-planner-routes-header><div class=sp-planner-routes-edition-actions><div class=title><h2 class=sp-planner-new-header-title translate=Routes.routes_title></h2></div><div class=\"sp-planner-routes-edition-action text-right\"><button class=\"btn btn-primary sp_new_button\" translate=Routes.btn_edition ng-click=vm.goToRoutesDetail() ng-if=\"!vm.isRouterJr && vm.isPlanEditable()\"></button><label type=button class=\"btn btn-primary sp-planner-routes-summary-button sp_new_button\" ng-click=vm.openInfoModal()><i class=sp-icon-table></i></label></div></div></div><search-bar data=vm.searchData filters=vm.filters on-click=vm.onClick on-remove=vm.onRemove no-results-found-text=\"\'SearchBar.Routes.noResultsFound\'\" min-text=\"\'SearchBar.Routes.minText\'\" placeholder=\"\'SearchBar.Routes.placeholder\'\"></search-bar><div id=scrollable-vehicles-list class=sp-planner-scrollable><div class=sp-planner-routes-content><div id=parent-vehicles-list class=overflow><div ng-if=\"vm.filterHandler.visitsOffRoute || !vm.filterHandler.activeFilter\" class=sp-planner-routes-dispatchs-out-of-routes-header><div class=sp-planner-routes-dispatchs-out-of-routes-header-first-row><div class=sp-planner-routes-vehicle-header-hide-icon><div class=toggle-visibility ng-click=vm.toggleVisitsOutOfRoutes()><div ng-include=\"\'/assets/images/show_hide/show_icon.svg\'\" class=visiblity-icon ng-show=vm.showVisitsOutOfRoutes style=\"color: #73768C\"></div><div ng-include=\"\'/assets/images/show_hide/hide_icon.svg\'\" class=visiblity-icon ng-show=!vm.showVisitsOutOfRoutes style=\"color: #C7C9D1\"></div></div></div><div class=\"sp-planner-routes-dispatchs-out-of-routes-title sp-planner-routes-section-title\"><div class=routes-title-text ng-class=\"{\'title-less-visible\' : !vm.showVisitsOutOfRoutes}\" translate=Routes.visits_out_of_route_title></div><i class=\"sp-icon-info title-icon\" uib-tooltip=\"{{\'Routes.tooltips.visits_out_of_route_title\' | translate}}\" tooltip-placement=right></i></div><!-- <div class=\"planner-route-info-container\">\n            <div class=\"sp-planner-routes-dispatchs-out-of-routes-title-indicator\">\n              <i class=\"sp-icon-map-pin\"></i>\n              <span>{{vm.calculateArrivalsOutOfRoute(vm.visitsOutOfRoute)}}</span>\n              <div class=\"sp-planner-out-of-route-loads\">\n                <div class=\"sp-planner-route-single-indicator sp-capacity-container\">\n                  <i class=\"sp-icon-carga-peso \"></i>\n                  {{ vm.visitsOutOfRouteFormattedLoads.load }}\n                </div>\n                <div class=\"sp-planner-route-single-indicator sp-capacity-container\" ng-if=\"vm.visitsOutOfRouteFormattedLoads.load2\">\n                  <i class=\"sp-icon-carga-volumen \"></i>\n                  {{ vm.visitsOutOfRouteFormattedLoads.load2 }}\n                </div>\n                <div class=\"sp-planner-route-single-indicator sp-capacity-container\" ng-if=\"vm.visitsOutOfRouteFormattedLoads.load3\">\n                  <i class=\"sp-icon-carga-valor \"></i>\n                  {{ vm.visitsOutOfRouteFormattedLoads.load3 }}\n                </div>\n                <div class=\"sp-planner-route-single-indicator sp-capacity-container\" ng-if=\"vm.isMixLoadAddonEnabled() && vm.visitsOutOfRouteFormattedLoads.load4\">\n                  <div\n                    class=\"sp-flex-container\"\n                    ng-include=\"\'/assets/images/vehicle_stats/box_filled.svg\'\"\n                  >\n                  </div>\n                  {{ vm.visitsOutOfRouteFormattedLoads.load4 }}\n                </div>\n              </div>\n            </div> --><div class=sp-planner-routes-dispatchs-out-of-routes-collapsed-icon><button class=\"btn btn-link sp-btn-collapse pull-right\" type=button ng-click=vm.collapseOrExpandVisitsOutOfRoute(!vm.visitsOutOfRouteActions.collapse)><div><i class=sp-icon-chevron-thin-up ng-if=!vm.visitsOutOfRouteActions.collapse></i> <i class=sp-icon-chevron-thin-down ng-if=vm.visitsOutOfRouteActions.collapse></i></div></button></div></div><div style=\"margin: 0 15px\" class=planner-route-info-container><div class=sp-planner-routes-dispatchs-out-of-routes-title-indicator><i class=sp-icon-map-pin></i> <span>{{vm.calculateArrivalsOutOfRoute(vm.visitsOutOfRoute)}}</span><div class=sp-planner-out-of-route-loads><div class=\"sp-planner-route-single-indicator sp-capacity-container\"><i class=sp-icon-carga-peso></i> {{ vm.visitsOutOfRouteFormattedLoads.load }}</div><div class=\"sp-planner-route-single-indicator sp-capacity-container\" ng-if=vm.visitsOutOfRouteFormattedLoads.load2><i class=sp-icon-carga-volumen></i> {{ vm.visitsOutOfRouteFormattedLoads.load2 }}</div><div class=\"sp-planner-route-single-indicator sp-capacity-container\" ng-if=vm.visitsOutOfRouteFormattedLoads.load3><i class=sp-icon-carga-valor></i> {{ vm.visitsOutOfRouteFormattedLoads.load3 }}</div><div class=\"sp-planner-route-single-indicator sp-capacity-container\" ng-if=\"vm.isMixLoadAddonEnabled() && vm.visitsOutOfRouteFormattedLoads.load4\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/box_filled.svg\'\"></div>{{ vm.visitsOutOfRouteFormattedLoads.load4 }}</div></div></div></div></div><div ng-if=\"vm.filterHandler.visitsOffRoute || !vm.filterHandler.activeFilter\" class=sp-planner-routes-dispatchs-out-of-routes-content><div uib-collapse=vm.visitsOutOfRouteActions.collapse><visit-filter ng-if=vm.isVisitsOutOfRouteFilterVisible() active-filter=vm.visitFilterHandler.activeFilter previous-min-slider-time=vm.visitFilterHandler.minSliderTime previous-max-slider-time=vm.visitFilterHandler.maxSliderTime filtered-visits=vm.visitFilterHandler.visits.length total-visits=vm.visitsOutOfRoute.length filter-visits=\"vm.filterVisitsOutOfRoute(minSliderTime, maxSliderTime)\"></visit-filter><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit id={{::visitOFR.id}} ng-mouseenter=\"vm.onMouseHoverVisit(\n                  visitOFR, vm.filterHandler.activeFilter, vm.filterHandler.visits[visitOFR.id]\n                 )\" ng-mouseleave=\"vm.onMouseLeaveVisit(visitOFR, vm.filterHandler.activeFilter)\" ng-repeat=\"visitOFR in vm.visitsOutOfRouteActions.visits track by visitOFR.id\"><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side id=visit-{{::visitOFR.id}} ng-style=limitLoadStyleOut ng-class=\"{\'focus-binding-visit\': vm.filterHandler.visits[visitOFR.id] && !vm.filterHandler.hoverActiveAnotherVisit}\" ng-init=\"limitLoadStyleOut=vm.routesUtils.getStyleByLoadLimit(visitOFR, \'init\')\" ng-mouseleave=\"limitLoadStyleOut=vm.routesUtils.getStyleByLoadLimit(visitOFR,\'leave\')\" ng-mouseover=\"limitLoadStyleOut=vm.routesUtils.getStyleByLoadLimit(visitOFR,\'over\')\"><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content-wrapper><span class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-header-title>{{visitOFR.title}}</span><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content-address><div class=sp-left-block><i class=\"sp-icon-map-pin visit-card-icon-padding\"></i></div><div class=sp-right-block><span>{{visitOFR.address}}</span></div></div></div><div ng-if=\"(vm.enableNotesInRouteDesigner && visitOFR.notes.trim() !== \'\')\" class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content-address><div class=sp-left-block><i class=\"sp-icon-notes visit-card-icon-padding\"></i></div><div class=sp-right-block><span>{{visitOFR.notes}}</span></div></div></div><div ng-if=\"(\n                    vm.mustShowVisitWindows(visitOFR.windowStart, visitOFR.windowEnd) ||\n                    vm.mustShowVisitWindows(visitOFR.windowStart2, visitOFR.windowEnd2)\n                  )\" class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content-address><div class=sp-left-block><i class=\"sp-icon-ventana-horaria visit-card-icon-padding\"></i></div><div class=sp-right-block><span>{{vm.displayWindows(visitOFR)}}</span></div></div></div><div class=sp-planner-routes-dispatchs-out-of-routes-content-visits-info-visit-right-side-content-capacities><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError}\"><i class=\"sp-icon-carga visit-card-icon-padding\" ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError}\"></i> {{visitOFR.load | formatNumber:2:\'.\':\',\'}}</div><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError2}\"><i class=\"sp-icon-carga-volumen visit-card-icon-padding\" ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError2}\"></i> {{visitOFR.load2 | formatNumber:2:\'.\':\',\'}}</div><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError3}\"><i class=\"sp-icon-carga-valor visit-card-icon-padding\" ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError3}\"></i> {{visitOFR.load3 | formatNumber:2:\'.\':\',\'}}</div><div class=sp-capacity ng-if=vm.isMixLoadAddonEnabled()><div class=\"visit-card-icon-padding sp-mix-load-icon\" ng-class=\"{\'sp-text-color-danger\': visitOFR.capacityError4}\" ng-include=\"\'/assets/images/vehicle_stats/box_filled.svg\'\"></div>{{visitOFR.load4 | formatNumber:2:\'.\':\',\'}}</div></div><div class=\"items-container out-of-route-visit-items-summary\"><items-summary-in-visit-card items=visitOFR.items class=card-item></items-summary-in-visit-card></div></div><div ng-if=visitOFR.addedInCurrentRouting class=sp-planner-new-visit-element uib-tooltip=\"{{ \'Visits.tooltips.new_visit\' | translate }}\"></div></div></div></div></div></div><div ng-if=!vm.filterHandler.activeFilter class=sp-planner-routes-hide-routes><div class=\"sp-planner-routes-filter-header justify-content-end\"><vehicle-sort-by algorithm=vm.vehicleSort desc=vm.vehicleSortDesc sort-key=vm.vehicleSortKey total-loads=vm.totalRoutedLoads></vehicle-sort-by></div><div class=sp-planner-routes-filter-header><p class=m-0>{{vm.routes.length}} <span ng-if=\"vm.routes.length !== 1\" translate=Routes.routes></span> <span ng-if=\"vm.routes.length === 1\" translate=Routes.route_singular></span></p><div><p class=\"text-left m-0\" ng-show=vm.visibleAllRoutes><a href=\"\" ng-click=vm.toggleVisibleAllRoutes() translate=Routes.hide_routes></a></p><p class=\"text-left m-0\" ng-show=!vm.visibleAllRoutes><a href=\"\" ng-click=vm.toggleVisibleAllRoutes() translate=Routes.show_routes></a></p></div></div></div><toast-routes ng-if=!vm.isPlanEditable()></toast-routes><div ng-repeat=\"showRoutesCriteria in vm.divideByVisibilityOptions\"><div class=sp-planner-routes-vehicle ng-repeat=\"(vehicleIndex, vehicle) in vm.vehicles | searchVehicleFilter:vm.filterHandler | orderBy:vm.vehicleSort:vm.vehicleSortDesc\" id=vehicle-list-item-{{::vehicle.id}} ng-if=\"(vehicle.showRoutes === showRoutesCriteria || !vm.enableOrderByVisibility)\"><div class=sp-planner-routes-vehicle-header><div class=sp-planner-routes-vehicle-header-title-box><div class=toggle-visibility ng-click=vm.toggleShowRoutes(vehicle)><div ng-include=\"\'/assets/images/show_hide/show_icon.svg\'\" class=visiblity-icon ng-show=vehicle.showRoutes style=\"color: {{vehicle.color}}\"></div><div ng-include=\"\'/assets/images/show_hide/hide_icon.svg\'\" class=visiblity-icon ng-show=!vehicle.showRoutes style=\"color: {{vehicle.color}}\"></div></div><span class=sp-planner-routes-vehicle-header-title ng-class=\"{\'title-less-visible\': !vehicle.showRoutes}\"><span class=sp-planner-vehicle-name>{{ vehicle.name }} </span><span ng-if=\"!vm.hasMultipleRoute(vehicle) && vehicle.driverId\" class=sp-planner-driver-name>{{ vm.getDriverFullName(vehicle.driverId) }}</span></span><driver ng-if=!vm.isMultiDriverVehicle(vehicle) driver-id=vehicle.driverId drivers=vm.drivers on-change=\"vm.updateVehicleDriver(vehicle, selectedDriver, vm.vehicles)\" is-driver-assignment-disabled=\"vehicle.areAllRoutesRevised || !vm.isPlanEditable()\"></driver></div><div ng-if=!vm.hasMultipleRoute(vehicle) class=sp-planner-routes-vehicle-statistics><div class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{\'Vehicles.total_routes\' | translate}}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/routing_filled_16.svg\'\"></div><span>{{ vehicle.routes.length | formatNumber:0 }}</span></div><div ng-if=\"vm.optimizationOptions.join || vm.optimizationOptions.join_v2\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\'Vehicles.total_arrivals\' | translate}}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/marker_filled_16.svg\'\"></div><span>{{ vm.calculateRouteArrivals(vehicle.routes[0]) | formatNumber:0 }}</span></div><div class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                  vehicle.routes[0].alertCounts.maxVisitError\n                  ? (\'Vehicles.tooltips.max_visit_error\' | translate:{ max_visit_vehicle: vehicle.maxVisit })\n                  : (\'Vehicles.visit_count\' | translate)\n                }}\" ng-class=\"{\'sp-container-color-danger\': vehicle.routes[0].alertCounts.maxVisitError}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/location_filled_16.svg\'\"></div><span>{{ vehicle.routes[0].visits.length | formatNumber:0 }}</span></div><div ng-if=\"vm.isClientsModuleEnabled && vm.calculateRouteClients(vehicle.routes[0]) > 0\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\'Vehicles.client_count\' | translate}}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/user_filled_16.svg\'\"></div><span>{{ vehicle.routes[0].clientCount | formatNumber:0 }}</span></div><div class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                  vehicle.maximumTimeError\n                  ? (\'Vehicles.tooltips.maximum_time_error\' | translate) + \'\\n\' + vehicle.shiftDefault.formattedMaximumTime + \' hrs\'\n                  : (\'Vehicles.time_routes\' | translate)\n                }}\" ng-class=\"{\'sp-container-color-danger\': vehicle.maximumTimeError}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/timer_filled_16.svg\'\"></div><span>{{ vehicle.routes[0].totalTimeFormatted }} <small>hrs</small></span></div><div class=sp-planner-routes-vehicle-header-kpis ng-class=\"{\'sp-container-color-danger\': vm.doesVehicleHaveRouteExceedingMaxDistance(vehicle)}\" uib-tooltip=\"{{ \'Vehicles.total_kms\' | translate }}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/odometer_filled_24.svg\'\"></div><span>{{ vehicle.routes[0].totalDistance.toFixed(2) | formatNumber }} <small>kms</small></span></div><div class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                  vehicle.routes[0].formattedLoad && vehicle.routes[0].capacityError\n                  ? (\'Routes.tooltips.charge_error_one\' | translate) + \'\\n\' + vehicle.routes[0].formattedLoad\n                  : vehicle.routes[0].formattedLoad\n                }}\" ng-class=\"{\'sp-text-color-danger\': vehicle.routes[0].capacityError}\"><i class=\"sp-icon-carga-peso fs-12\"></i> <span>{{ vehicle.routes[0].totalLoadPercentage | formatNumber:0 }}%</span></div><div ng-if=\"vehicle.routes[0].totalLoad2 > 0\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                  vehicle.routes[0].formattedLoad2 && vehicle.routes[0].capacityError2\n                  ? (\'Routes.tooltips.charge_error_two\' | translate) + \'\\n\' + vehicle.routes[0].formattedLoad2\n                  : vehicle.routes[0].formattedLoad2\n                }}\" ng-class=\"{\'sp-text-color-danger\': vehicle.routes[0].capacityError2}\"><i class=\"sp-icon-carga-volumen fs-12\"></i> <span>{{ vehicle.routes[0].totalLoadPercentage2 | formatNumber:0 }}%</span></div><div ng-if=\"vehicle.routes[0].totalLoad3 > 0\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                  vehicle.routes[0].formattedLoad3 && vehicle.routes[0].capacityError3\n                  ? (\'Routes.tooltips.charge_error_three\' | translate) + \'\\n\' + vehicle.routes[0].formattedLoad3\n                  : vehicle.routes[0].formattedLoad3\n                }}\" ng-class=\"{\'sp-text-color-danger\': vehicle.routes[0].capacityError3}\"><i class=\"sp-icon-carga-valor fs-12\"></i> <span>{{ vehicle.routes[0].totalLoadPercentage3 | formatNumber:0 }}%</span></div><div ng-if=\"vm.isMixLoadAddonEnabled() && vehicle.routes[0].totalLoad4 > 0\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                  vehicle.routes[0].formattedLoad4 && vehicle.routes[0].capacityError4\n                  ? (\'Routes.tooltips.charge_error_four\' | translate) + \'\\n\' + vehicle.routes[0].formattedLoad4\n                  : vehicle.routes[0].formattedLoad4\n                }}\" ng-class=\"{\'sp-text-color-danger\': vehicle.routes[0].capacityError4}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/box_filled.svg\'\"></div><span>{{ vehicle.routes[0].totalLoadPercentage4 | formatNumber:0 }}%</span></div></div><div ng-if=vm.hasMultipleRoute(vehicle) class=sp-planner-routes-vehicle-statistics><div class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{ \'Vehicles.total_routes\' | translate }}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/routing_filled_16.svg\'\"></div><span>{{ vehicle.routes.length | formatNumber:0 }}</span></div><div ng-if=\"vm.optimizationOptions.join || vm.optimizationOptions.join_v2\" class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{\'Vehicles.total_arrivals\' | translate}}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/marker_filled_16.svg\'\"></div><span>{{ vm.dataByVehicle[vehicle.id].totalArrivals | formatNumber:0 }}</span></div><div class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{\'Vehicles.visit_count\' | translate}}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/location_filled_16.svg\'\"></div><span>{{ vm.dataByVehicle[vehicle.id].visitCount | formatNumber:0 }}</span></div><div ng-if=\"vm.dataByVehicle[vehicle.id].clientCount > 0\" class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{\'Vehicles.client_count\' | translate}}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/user_filled_16.svg\'\"></div><span>{{ vm.dataByVehicle[vehicle.id].clientCount | formatNumber:0 }}</span></div><div class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{\n                  vehicle.maximumTimeError\n                  ? (\'Vehicles.tooltips.maximum_time_error\' | translate) + \'\\n\' + vehicle.shiftDefault.formattedMaximumTime + \' hrs\'\n                  : (\'Vehicles.time_routes\' | translate)\n                }}\" ng-class=\"{\'sp-container-color-danger\': vehicle.maximumTimeError}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/timer_filled_16.svg\'\"></div><span>{{ vm.dataByVehicle[vehicle.id].totalTime }} hrs</span></div><div class=sp-planner-routes-vehicle-header-kpis ng-class=\"{\'sp-container-color-danger\': vm.doesVehicleHaveRouteExceedingMaxDistance(vehicle)}\" uib-tooltip=\"{{ \'Vehicles.total_kms\' | translate }}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/odometer_filled_24.svg\'\"></div><span>{{ vm.dataByVehicle[vehicle.id].totalKms | formatNumber }} kms</span></div><div class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{ \'Vehicles.average_load_1\' | translate }}\"><i class=\"sp-icon-carga-peso fs-12\"></i> <span>{{ vm.dataByVehicle[vehicle.id].averageLoadsPercentage[0] }}%</span></div><div ng-if=\"vm.dataByVehicle[vehicle.id].totalLoads[1] > 0\" class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{ \'Vehicles.average_load_2\' | translate }}\"><i class=\"sp-icon-carga-volumen fs-12\"></i> <span>{{ vm.dataByVehicle[vehicle.id].averageLoadsPercentage[1] }}%</span></div><div ng-if=\"vm.dataByVehicle[vehicle.id].totalLoads[2] > 0\" class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{ \'Vehicles.average_load_3\' | translate }}\"><i class=\"sp-icon-carga-valor fs-12\"></i> <span>{{ vm.dataByVehicle[vehicle.id].averageLoadsPercentage[2] }}%</span></div><div ng-if=\"vm.dataByVehicle[vehicle.id].totalLoads[3] > 0 && vm.isMixLoadAddonEnabled()\" class=sp-planner-routes-vehicle-header-kpis uib-tooltip=\"{{ \'Vehicles.average_load_4\' | translate }}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/box_filled.svg\'\"></div><span>{{ vm.dataByVehicle[vehicle.id].averageLoadsPercentage[3] }}%</span></div></div></div><div class=\"row sp-planner-routes-vehicle-content\" ng-repeat=\"route in vehicle.routes | searchRouteFilter:vm.filterHandler\" ng-init=\"routeIndex = $index\"><div uib-collapse=vehicle.collapseRoutes><div class=sp-planner-routes-vehicle-content-route><div class=sp-planner-routes-vehicle-content-route-collapse ng-click=vm.toggleCollapseRoute(route)><div class=sp-planner-routes-vehicle-content-route-header ng-style=\"vm.hasMultipleRoute(vehicle) && { \'border-bottom\': \'1px solid #CACDE7\', \'padding-bottom\': \'8px\' }\"><i class=fs-20 ng-class=\"{\'sp-icon-triangle-down\': !route.collapse, \'sp-icon-triangle-right\': route.collapse}\"></i> <span class=sp-planner-route-title><span class=sp-planner-route-name>{{ vm.getRouteName(route, $index + 1) }} </span><span ng-if=\"vm.hasMultipleRoute(vehicle) && route.driver\" class=sp-planner-route-driver-name>{{ vm.getDriverFullName(route.driver) }}</span></span><div class=sp-planner-route-indicators-options><div class=sp-planner-route-indicators><i ng-if=\"route.timeError || route.hasRestTimeError\" uib-tooltip=\"{{ \'Routes.tooltips.time_error\' | translate }}\" class=\"sp-icon-ventana-horaria sp-planner-routes-vehicle-content-route-header-statistics-warning-icon fs-14\"></i> <img ng-if=route.skillsError class=sp-icon-skills-error uib-tooltip=\"{{ \'Routes.tooltips.skills_error\' | translate }}\" src=../../../assets/images/skills_error.svg alt=\"skills error\"><driver ng-if=vm.isMultiDriverVehicle(vehicle) driver-id=route.driver drivers=vm.drivers on-change=\"vm.setVehicleDriver(vehicle, route, selectedDriver, vm.vehicles)\" is-driver-assignment-disabled=\"route.isRevised || !vm.isPlanEditable()\"></driver><i ng-if=\"!route.isRevised && vm.enableRouteEditIndicator\" ng-class=\"{\'sp-text-color-success\': route.routeEditIndicator}\" uib-tooltip=\"{{\'Routes.tooltips.edited_route\' | translate}}\" tooltip-enable=route.routeEditIndicator class=\"sp-icon-check fs-14\" ng-click=vm.changeEditIndicator(route)></i><route-menu-dropdown ng-if=!vm.isPlanEditable() route=route toggle-options-menu=vm.toggleOptionsMenu(route) go-to-delete-route=\"vm.goToDeleteRoute($event, vehicle, route, $index+1)\"></route-menu-dropdown></div></div></div><div ng-if=vm.hasMultipleRoute(vehicle) class=sp-planner-routes-vehicle-statistics><div ng-if=\"vm.optimizationOptions.join || vm.optimizationOptions.join_v2\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\'Vehicles.total_arrivals\' | translate}}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/marker_filled_16.svg\'\"></div><span>{{ vm.calculateRouteArrivals(route) | formatNumber:0 }}</span></div><div class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                        route.alertCounts.maxVisitError\n                        ? (\'Vehicles.tooltips.max_visit_error\' | translate:{ max_visit_vehicle: vehicle.maxVisit })\n                        : (\'Vehicles.visit_count\' | translate)\n                      }}\" ng-class=\"{\'sp-container-color-danger\': route.alertCounts.maxVisitError}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/location_filled_16.svg\'\"></div><span>{{ route.visits.length | formatNumber:0 }}</span></div><div ng-if=\"vm.isClientsModuleEnabled && vm.calculateRouteClients(route) > 0\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\'Vehicles.client_count\' | translate}}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/user_filled_16.svg\'\"></div><span>{{ route.clientCount | formatNumber:0 }}</span></div><div class=sp-planner-routes-vehicle-header-kpis><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/timer_filled_16.svg\'\"></div><span>{{ route.totalTimeFormatted }} <small>hrs</small></span></div><div class=sp-planner-routes-vehicle-header-kpis ng-class=\"{\'sp-container-color-danger\': vm.doesRouteExceedMaxDistance(route, vehicle)}\"><div class=sp-flex-container ng-include=\"\'/assets/images/vehicle_stats/odometer_filled_24.svg\'\"></div><span>{{ route.totalDistance.toFixed(2) | formatNumber }} <small>kms</small></span></div><div class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                        route.formattedLoad && route.capacityError\n                        ? (\'Routes.tooltips.charge_error_one\' | translate) + \'\\n\' + route.formattedLoad\n                        : route.formattedLoad\n                      }}\" ng-class=\"{\'sp-text-color-danger\': route.capacityError}\"><i class=\"sp-icon-carga-peso fs-12\"></i> <span>{{ route.totalLoadPercentage | formatNumber:0 }}%</span></div><div ng-if=\"route.totalLoad2 > 0\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                        route.formattedLoad2 && route.capacityError2\n                        ? (\'Routes.tooltips.charge_error_two\' | translate) + \'\\n\' + route.formattedLoad2\n                        : route.formattedLoad2\n                      }}\" ng-class=\"{\'sp-text-color-danger\': route.capacityError2}\"><i class=\"sp-icon-carga-volumen fs-12\"></i> <span>{{ route.totalLoadPercentage2 | formatNumber:0 }}%</span></div><div ng-if=\"route.totalLoad3 > 0\" class=sp-planner-routes-vehicle-header-kpis tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{\n                        route.formattedLoad3 && route.capacityError3\n                        ? (\'Routes.tooltips.charge_error_three\' | translate) + \'\\n\' + route.formattedLoad3\n                        : route.formattedLoad3\n                      }}\" ng-class=\"{\'sp-text-color-danger\': route.capacityError3}\"><i class=\"sp-icon-carga-valor fs-12\"></i> <span>{{ route.totalLoadPercentage3 | formatNumber:0 }}%</span></div></div></div><div class=sp-planner-routes-vehicle-content-route-content><div class=\"sp-collapse-route sp-route-{{vehicle.id}}-{{$index}}\" uib-collapse=route.collapse><ul class=sp-planner-routes-vehicle-content-route-content-visits-info><li ng-if=\"!(vm.optimizationOptions.open_start && $first)\" class=sp-planner-routes-vehicle-content-route-content-visits-info-location-start><div class=sp-planner-routes-vehicle-content-route-content-visits-info-location-start-left-side><div class=sp-planner-routes-vehicle-content-route-content-visits-info-location-start-left-side-icon><i class=sp-icon-home ng-style=\"{\'color\':vehicle.color}\"></i></div><div ng-if=\"vm.isMultidayRouteEnabled || vm.moment(visit.estimatedTimeArrival).format(\'DD/MM\') !== vm.moment(route.estimatedTimeStart).format(\'DD/MM\')\" class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-left-side-time>{{vm.moment(route.estimatedTimeStart).format(\'DD/MM\')}}</div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-left-side-time>{{vm.moment(route.estimatedTimeStart).format(\'LT\')}}</div></div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-location-start-right-side><span translate=Routes.from></span> {{vehicle.locationStart.address}}</div></li><li ng-if=route.areVisitsListed ng-repeat=\"visit in route.visitsAndEvents\"><div ng-if=\"visit.type === vm.VISIT_TYPE.VISIT\" class=sp-planner-routes-vehicle-content-route-content-visits-info-visit ng-mouseenter=\"vm.onMouseHoverVisit(visit, vm.filterHandler.activeFilter, vm.filterHandler.visits[visit.id])\" ng-mouseleave=\"vm.onMouseLeaveVisit(visit, vm.filterHandler.activeFilter)\" ng-class=\"{\'sp-error\': (\n                            visit.timeError || visit.capacityError || visit.capacityError2 || visit.capacityError3 ||\n                            visit.skillsError || visit.maximumTimeError || visit.maxVisitError\n                          )}\"><visit-similarity-marker current-visit=visit previous-visit=\"vm.getPreviousVisit(route.visitsAndEvents, $index)\" next-visit=\"vm.getNextVisit(route.visitsAndEvents, $index)\" vehicle-color=vehicle.color join-similar=\"vm.optimizationOptions.join || vm.optimizationOptions.join_v2\"></visit-similarity-marker><div id=visit-{{::visit.id}} class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-left-side><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-left-side-icon-container ng-style=\"{\'background-color\': vehicle.color}\"><i ng-if=visit.timeError class=sp-icon-ventana-horaria></i> <img ng-if=visit.skillsError class=sp-icon-skills-error-detail src=../../../assets/images/skills_error.svg alt=\"skills error\"> <span class=sp-visit-number ng-hide=\"(visit.timeError || visit.skillsError)\">{{visit.order}}</span></div><div ng-if=\"vm.isMultidayRouteEnabled || vm.moment(visit.estimatedTimeArrival).format(\'DD/MM\') !== vm.moment(route.estimatedTimeStart).format(\'DD/MM\')\" class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-left-side-time>{{vm.moment(visit.estimatedTimeArrival).format(\'DD/MM\')}}</div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-left-side-time>{{vm.moment(visit.estimatedTimeArrival).format(\'LT\')}}</div></div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side ng-style=limitLoadStyle ng-class=\"{\'focus-binding-visit\': vm.filterHandler.visits[visit.id] && !vm.filterHandler.hoverActiveAnotherVisit}\" ng-init=\"limitLoadStyle=vm.routesUtils.getStyleByLoadLimit(visit, \'init\')\" ng-mouseleave=\"limitLoadStyle=vm.routesUtils.getStyleByLoadLimit(visit, \'leave\')\" ng-mouseover=\"limitLoadStyle=vm.routesUtils.getStyleByLoadLimit(visit, \'over\')\"><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content-wrapper><span class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-header-title>{{visit.title}}</span><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content-address><i class=\"sp-icon-map-pin visit-card-icon-padding\"></i> {{visit.address}}</div></div><div ng-if=visit.reference class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content><div class=\"sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content-address container-reference-id\"><visit-reference class=visit-reference-container visit=visit></visit-reference></div></div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content><div ng-if=\"(vm.enableNotesInRouteDesigner && visit.notes.trim() !== \'\')\" class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content-address><i class=\"sp-icon-notes visit-card-icon-padding\"></i> {{visit.notes}}</div></div><div ng-if=\"(\n                                  vm.mustShowVisitWindows(visit.windowStart, visit.windowEnd) ||\n                                  vm.mustShowVisitWindows(visit.windowStart2, visit.windowEnd2)\n                                )\" class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content-address><i class=\"sp-icon-ventana-horaria visit-card-icon-padding\"></i> {{vm.displayWindows(visit)}}</div></div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content-capacities><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visit.capacityError}\"><i class=\"sp-icon-carga visit-card-icon-padding\" ng-class=\"{\'sp-text-color-danger\': visit.capacityError}\"></i> {{visit.load | formatNumber:2:\'.\':\',\'}}</div><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visit.capacityError2}\"><i class=\"sp-icon-carga-volumen visit-card-icon-padding\" ng-class=\"{\'sp-text-color-danger\': visit.capacityError2}\"></i> {{visit.load2 | formatNumber:2:\'.\':\',\'}}</div><div class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visit.capacityError3}\"><i class=\"sp-icon-carga-valor visit-card-icon-padding\" ng-class=\"{\'sp-text-color-danger\': visit.capacityError3}\"></i> {{visit.load3 | formatNumber:2:\'.\':\',\'}}</div><div ng-if=vm.isMixLoadAddonEnabled() class=sp-capacity ng-class=\"{\'sp-text-color-danger\': visit.capacityError4}\"><div class=\"sp-flex-container visit-card-icon-padding sp-mix-load-icon\" ng-class=\"{\'sp-text-color-danger\': visit.capacityError4}\" ng-include=\"\'/assets/images/vehicle_stats/box_filled.svg\'\"></div>{{visit.load4 | formatNumber:2:\'.\':\',\'}}</div></div></div><div ng-if=visit.addedInCurrentRouting class=sp-planner-new-visit-element uib-tooltip=\"{{ \'Visits.tooltips.new_visit\' | translate }}\"></div><div class=\"sp-expand-visit-icon sp-background-grey\" ng-click=\"vm.expandVisit(visit, route)\"><div ng-include=\"\'/assets/images/expand_visit.svg\'\"></div></div></div></div><rest-time-card ng-if=\"visit.type === vm.VISIT_TYPE.EVENT\" rest-time=visit vehicle=vehicle></rest-time-card></li><li ng-if=\"!(vm.optimizationOptions.open_ended && !vm.optimizationOptions.big_cluster && $last)\" class=sp-planner-routes-vehicle-content-route-content-visits-info-location-end><div class=sp-planner-routes-vehicle-content-route-content-visits-info-location-end-left-side><div ng-if=\"vm.isMultidayRouteEnabled || vm.moment(route.estimatedTimeEnd).format(\'DD/MM\') !== vm.moment(route.estimatedTimeStart).format(\'DD/MM\')\" class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-left-side-time>{{vm.moment(route.estimatedTimeEnd).format(\'DD/MM\')}}</div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-left-side-time>{{vm.moment(route.estimatedTimeEnd).format(\'LT\')}}</div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-location-end-left-side-icon><i class=sp-icon-destino ng-style=\"{\'color\':vehicle.color}\"></i></div></div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-location-end-right-side><span translate=Routes.to></span> {{vehicle.locationEnd.address}}</div></li></ul></div></div></div></div></div></div></div></div></div></div><!-- end sp-planner-scrollable --><div class=sp-planner-footer><div class=row><a ng-click=vm.goToVisitList() class=\"btn pull-left sp-back-button\"><i class=sp-icon-chevron-left></i> <span translate=Planner.btn_back></span> </a><button id=assignBtn type=button class=\"btn btn-primary pull-right sp_new_button\" ng-disabled=\"vm.routes=== null || vm.routes.length <= 0\" ng-click=vm.deployFinishModal() translate=Planner.btn_finish></button></div><div class=row><span uib-dropdown class=pull-right><a class=\"sp-planner-export-btn pull-right\" uib-dropdown-toggle href=\"\"><span translate=Planner.btn_export></span> <i class=sp-icon-triangle-right uib-dropdown-toggle></i></a><ul class=\"dropdown-multiselection dropdown-up dropdown-menu dropdown-menu-right sp-dropdown-container\" uib-dropdown-menu aria-haspopup=true aria-expanded=false><li role=menuitem><div class=sp-optimize-option><a class=sp-report href=\"\" ng-click=\"vm.report.txt=true;vm.downloadReport();\"><span ng-model=vm.report.txt>TXT</span> <i class=\"fa fa-download\"></i></a></div></li><li role=menuitem><div class=sp-optimize-option><a class=sp-report href=\"\" ng-click=\"vm.report.excel=true;vm.downloadReport();\"><span ng-model=vm.report.excel>EXCEL</span> <i class=\"fa fa-download\"></i></a></div></li><li role=menuitem><div class=sp-optimize-option><a class=sp-report href=\"\" ng-click=\"vm.report.pdf=true;vm.downloadReport();\"><span ng-model=vm.report.pdf>{{\'Pdf.detailed_pdf\' | translate}}</span> <i class=\"fa fa-download\"></i></a></div></li><li role=menuitem><div class=sp-optimize-option><a class=sp-report href=\"\" ng-click=\"vm.report.summarizedPdf=true;vm.downloadReport();\"><span ng-model=vm.report.summarizedPdf>{{\'Summarized_Pdf.summarized_pdf\' | translate}}</span> <i class=\"fa fa-download\"></i></a></div></li></ul></span></div></div>");
$templateCache.put("app/planner/vehicles/vehicles-detail.html","<div class=sp-planner-header><div class=sp-planner-header-row><h2 class=sp-planner-header-title translate=Vehicles.title_edit_vehicle></h2></div></div><div class=sp-planner-scrollable><form class=\"form-horizontal sp-form\" id=vehicle-form name=vm.form ng-submit=vm.save() novalidate><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.vehicle_name></label><div class=col-sm-9><input type=text class=form-control name=title required placeholder=required ng-model=vm.vehicle.name autofocus><ng-messages for=vm.form.title.$error class=sp-form-messages role=alert ng-show=\"vm.form.title.$dirty || vm.form.$submitted\"><ng-message class=sp-settings-invalid-help-block when=pattern></ng-message><ng-message class=sp-settings-invalid-help-block when=required translate=Vehicles.error_name_vehicle_required></ng-message></ng-messages></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.vehicle_capacity></label><div class=col-sm-9><input type=text class=form-control name=capacity required translate translate-attr-placeholder=Vehicles.required ng-model=vm.vehicle.capacity capacity-input-format><ng-messages for=vm.form.capacity.$error class=sp-form-messages role=alert ng-show=\"vm.form.capacity.$dirty || vm.form.$submitted\"><ng-message class=sp-settings-invalid-help-block when=required translate=Vehicles.error_capacity_required></ng-message><ng-message class=sp-settings-invalid-help-block when=invalid translate=Vehicles.error_limit_capacity></ng-message></ng-messages></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.vehicle_capacity_2></label><div class=col-sm-9><input type=text class=form-control name=capacity_2 translate translate-attr-placeholder=Vehicles.optional ng-model=vm.vehicle.capacity2 capacity-input-format><ng-messages for=vm.form.capacity_2.$error class=sp-form-messages role=alert ng-show=\"vm.form.capacity_2.$dirty || vm.form.$submitted\"><ng-message class=sp-settings-invalid-help-block when=invalid translate=Vehicles.error_limit_capacity_2></ng-message></ng-messages></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.vehicle_capacity_3></label><div class=col-sm-9><input type=text class=form-control name=capacity_3 translate translate-attr-placeholder=Vehicles.optional ng-model=vm.vehicle.capacity3 capacity-input-format><ng-messages for=vm.form.capacity_3.$error class=sp-form-messages role=alert ng-show=\"vm.form.capacity_3.$dirty || vm.form.$submitted\"><ng-message class=sp-settings-invalid-help-block when=invalid translate=Vehicles.error_limit_capacity_3></ng-message></ng-messages></div></div><div ng-if=vm.isMixLoadAddonEnabled class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.vehicle_capacity_4></label><div class=col-sm-9><input type=text class=form-control name=capacity_4 translate translate-attr-placeholder=Vehicles.optional ng-model=vm.vehicle.capacity4 capacity-input-format><ng-messages for=vm.form.capacity_4.$error class=sp-form-messages role=alert ng-show=\"vm.form.capacity_4.$dirty || vm.form.$submitted\"><ng-message class=sp-settings-invalid-help-block when=invalid translate=Vehicles.error_limit_capacity_4></ng-message></ng-messages></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.vehicle_driver></label><div class=col-sm-9><select class=form-control name=driver ng-if=!vm.isTmsEnable ng-model=vm.vehicle.driverId ng-options=\"driver.id as driver.name for driver in vm.drivers\"><option value=\"\" translate=Vehicles.select_driver></option></select><custom-select ng-if=vm.isTmsEnable data=vm.driverSelectInfo.drivers selected-id=vm.driverSelectInfo.selectedId on-click-option=vm.driverSelectInfo.onClickOption></custom-select></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.schedule></label><div class=col-sm-3><input type=text class=form-control name=shiftStart ng-model=vm.vehicle.shift.start ng-blur=vm.validateTime()></div><label class=\"col-sm-3 text-center form-control-static\" translate=Vehicles.to></label><div class=col-sm-3><input type=text class=form-control name=shiftEnd ng-model=vm.vehicle.shift.end ng-blur=vm.validateTime()></div><div class=\"planner-error-date settings-error-date\"><p ng-if=vm.invalidDate class=sp-settings-invalid-help-block translate=Vehicles.error_format_date></p><p ng-if=vm.timeBetweenDate class=sp-settings-invalid-help-block translate=Vehicles.error_between_date></p><p ng-if=vm.emptyDate class=sp-settings-invalid-help-block translate=Vehicles.error_empty_date></p></div></div><!-- end shift form-group --><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.vehicle_origin></label><div class=col-sm-9><autocomplete input-name=\"\'locationStartAddress\'\" address=vm.vehicle.locationStart.address update-address=\"vm.updateVehicleLocation(location, address, vm.isStartLocation)\"></autocomplete><ng-messages for=vm.form.locationStartAddress.$error class=sp-form-messages role=alert ng-show=\"vm.form.locationStartAddress.$dirty || vm.form.$submitted\"><ng-message class=sp-settings-invalid-help-block when=pattern></ng-message><ng-message class=sp-settings-invalid-help-block when=required translate=Vehicles.error_address_origin></ng-message></ng-messages></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.vehicle_destination></label><div class=col-sm-9><autocomplete input-name=\"\'locationEndAddress\'\" address=vm.vehicle.locationEnd.address update-address=\"vm.updateVehicleLocation(location, address, !vm.isStartLocation)\"></autocomplete></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.vehicle_skills></label><div class=col-sm-9><div class=\"btn-group sp-btn-group-abilities\"><label class=\"btn sp-btn-abilities btn-primary\" ng-model=vm.skillsVehicle[skill.id] uib-btn-checkbox ng-repeat=\"skill in vm.skills track by skill.id\">{{skill.name}}</label></div></div></div></form></div><!-- end sp-planner-scrollable --><div class=sp-planner-footer><a class=\"btn btn-default pull-left\" ui-sref=^.vehicles-list translate=Planner.btn_cancel></a> <button class=\"btn btn-success pull-right\" type=submit form=vehicle-form translate=Planner.btn_save></button></div>");
$templateCache.put("app/planner/vehicles/vehicles-list.html","<div class=sp-planner-header ng-if=!vm.seeAllVehicles><div class=sp-planner-header-row><h2 class=\"sp-planner-header-title margin-top-1\"><span translate=Vehicles.initial_information></span></h2></div></div><form id=selectDate class=\"form-horizontal sp-form\" name=vm.scheduleForm ng-if=!vm.seeAllVehicles style=\"padding: 5px 15px 5px 15px\"><div ng-if=!vm.isMultiDayRouteEnabled><div class=form-group ng-if=!vm.isMultiDayRouteEnabled><label class=\"col-sm-2 control-label text-left\" translate=Vehicles.date></label><!-- start date --><div class=\"col-sm-10 sp-block-relative sp-plan-date-input\"><input type=text class=form-control name=startDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.planDate.start ng-change=vm.selectDateOneDayPlanner() ng-required=true is-open=vm.popupPlanDate.start datepicker-options=vm.startDateOptions popup-placement=right-top show-button-bar=false datepicker-append-to-body=true readonly ng-disabled=vm.isEditingPlan> <span class=input-group-btn><button type=button class=\"btn btn-default btn-plan-date\" ng-disabled=vm.isEditingPlan ng-click=\"vm.openPopupPlanDate(\'start\')\"><span class=sp-icon-calendario></span></button></span></div><div class=\"col-sm-12 text-right\" ng-if=!vm.isRouterJr><a ui-sref=planner.vehicles-list.plans-draft class=\"sp-link sp-planner-load-draft-plans\" translate=Planner.load_drafts ng-if=vm.draftsEnabled></a> <a ui-sref=planner.vehicles-list.plans class=sp-link translate=Planner.load_plans></a></div></div><div class=\"form-group margin-bottom-5\"><label class=\"col-sm-2 control-label\" translate=Vehicles.schedule></label><div class=col-sm-3><input type=text ng-disabled=vm.hasPlanRoutesProcessed class=form-control name=shiftStart ng-model=vm.shift.start ng-blur=\"vm.validateTime(vm.planDate, vm.shift)\"></div><label class=\"col-sm-3 text-center form-control-static\" translate=Vehicles.to></label><div class=col-sm-3><input type=text ng-disabled=vm.hasPlanRoutesProcessed class=form-control name=shiftEnd ng-model=vm.shift.end ng-blur=\"vm.validateTime(vm.planDate, vm.shift)\"></div><div class=planner-error-date><p ng-if=vm.invalidTimeFormat class=sp-settings-invalid-help-block translate=Visits.error_format_date></p><p ng-if=vm.timeBetweenDate class=sp-settings-invalid-help-block translate=Visits.error_between_date></p></div></div><!-- end shift form-group --></div><!-- conditional block: enabled when account config enable_multi_days_route is true --><div ng-if=vm.isMultiDayRouteEnabled><div class=\"form-group margin-bottom-5\"><div class=row><label class=\"col-sm-6 sp-plan-date-label control-label\" translate=Vehicles.start_date></label><label class=\"col-sm-3 col-sm-offset-2 sp-plan-date-label control-label\" translate=Vehicles.start_time></label></div><div class=row><div class=\"col-sm-6 sp-block-relative sp-plan-date-input\"><input type=text class=form-control name=startDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.planDate.start ng-change=vm.validateDates(vm.planDate) ng-required=true is-open=vm.popupPlanDate.start datepicker-options=vm.startDateOptions popup-placement=right-top show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-plan-date\" ng-disabled=vm.isEditingPlan ng-click=\"vm.openPopupPlanDate(\'start\')\"><span class=sp-icon-calendario></span></button></span></div><div class=\"col-sm-3 col-sm-offset-2\"><input ng-disabled=vm.hasPlanRoutesProcessed type=text class=form-control name=shiftStart ng-model=vm.shift.start ng-blur=\"vm.validateTime(vm.planDate, vm.shift)\"></div></div></div><div class=\"form-group margin-bottom-5\"><div class=row><label class=\"col-sm-6 sp-plan-date-label control-label\" translate=Vehicles.end_date></label><label class=\"col-sm-3 col-sm-offset-2 sp-plan-date-label control-label\" translate=Vehicles.end_time></label></div><div class=row><div class=\"col-sm-6 sp-block-relative sp-plan-date-input\"><input type=text class=form-control name=endDate uib-datepicker-popup=dd-MM-yyyy ng-model=vm.planDate.end ng-change=vm.validateDates(vm.planDate) ng-required=true is-open=vm.popupPlanDate.end datepicker-options=vm.endDateOptions popup-placement=right-top show-button-bar=false datepicker-append-to-body=true readonly> <span class=input-group-btn><button type=button class=\"btn btn-default btn-plan-date\" ng-disabled=vm.isEditingPlan ng-click=\"vm.openPopupPlanDate(\'end\')\"><span class=sp-icon-calendario></span></button></span></div><div class=\"col-sm-3 col-sm-offset-2\"><input ng-disabled=vm.hasPlanRoutesProcessed type=text class=form-control name=shiftEnd ng-model=vm.shift.end ng-blur=\"vm.validateTime(vm.planDate, vm.shift)\"></div></div><div class=\"col-sm-12 planner-error-date\"><p ng-if=vm.invalidTimeFormat class=sp-settings-invalid-help-block translate=Visits.error_format_date></p><p ng-if=vm.timeBetweenDate class=sp-settings-invalid-help-block translate=Visits.error_between_date></p><p ng-if=vm.invalidDate class=sp-settings-invalid-help-block translate=Visits.error_invalid_date></p></div><div class=\"col-sm-12 text-right\" ng-if=!vm.isRouterJr><a ui-sref=planner.vehicles-list.plans-draft class=\"sp-link sp-planner-load-draft-plans\" translate=Planner.load_drafts ng-if=vm.draftsEnabled></a> <a ui-sref=planner.vehicles-list.plans class=sp-link translate=Planner.load_plans></a></div></div></div><!-- end conditional block --></form><!-- end scheduleForm --><div ui-view class=sp-vehicles-content><div class=sp-planner-header><div class=sp-planner-header-row><h2 class=\"sp-planner-header-title margin-top-0\" translate=Vehicles.label_vehicles></h2><div class=\"sp-flex-width-35 sp-display-flex text-right sp-select-all more-vehicles-style\"><div class=\"sp-justify-content-space sp-cursor-pointer\" ng-if=!vm.seeAllVehicles ng-click=\"vm.seeAllVehicles = !vm.seeAllVehicles\"><span translate=Vehicles.more_vehicles></span> <i class=sp-icon-chevron-thin-up></i></div><div class=\"sp-justify-content-space sp-cursor-pointer\" ng-if=vm.seeAllVehicles ng-click=\"vm.seeAllVehicles = !vm.seeAllVehicles\"><span translate=Vehicles.minus_vehicles></span> <i class=sp-icon-chevron-thin-down></i></div></div></div></div><div class=\"sp-fake-table sp-vehicles-table\" ng-show=\"vm.vehiclesRendered.length > 0 && !isLoading\"><div class=\"sp-select-fleet form-control\" ng-if=vm.enableFleetLogic><select ng-options=\"fleet.name for fleet in vm.fleets\" ng-model=vm.fleetSelected ng-change=vm.selectFleet(vm.fleetSelected) ng-init=vm.selectFleet(vm.fleetSelected)></select></div><multi-tag-input class=multi-tag-margin get-suggestion=vm.getVehicleSuggestions placeholder=\"(\'multiTagInputVehicle.placeholder\' | translate)\" tags=vm.vehicleSearchInfo.searchValues handle-search=vm.handleSearch clean-search=vm.cleanSearch is-search-active=vm.vehicleSearchInfo.isSearchTrigger not-found-alert=\"vm.searchHasNotFoundVehicles() ? (\'multiTagInputVehicle.notFoundAlert\' | translate) : \'\'\"></multi-tag-input><div class=\"sp-select-all margin-top-5\"><div class=\"sp-flex-width-65 sp-display-flex\"><div class=sp-select-checkbox-container><div class=sp-vehicle-checkbox><input id=checkbox-available-vehicles type=checkbox class=sp-checkbox-input ng-checked=vm.areAvailableSelected() ng-click=vm.toggleAvailable() ng-disabled=\"vm.getVehiclesAvailable(vm.vehiclesRendered).length === 0\"><label><span class=sp-icon-check></span></label></div><span class=sp-select-label ng-class=\"{\'sp-text-disabled\': vm.getVehiclesAvailable(vm.vehiclesRendered).length === 0}\" translate=Vehicles.select_only_available></span></div><div class=sp-select-checkbox-container><div class=sp-vehicle-checkbox><input id=checkbox-partially-available-vehicles type=checkbox class=sp-checkbox-input ng-checked=vm.arePartiallyAvailableSelected() ng-click=vm.togglePartiallyAvailable() ng-disabled=\"vm.getVehiclesPartiallyAvailable(vm.vehiclesRendered).length === 0\"><label><span class=sp-icon-check></span></label></div><span class=sp-select-label ng-class=\"{\'sp-text-disabled\': vm.getVehiclesPartiallyAvailable(vm.vehiclesRendered).length === 0}\" translate=Vehicles.select_only_partially_available></span></div></div></div><div class=sp-selected-vehicles-container ng-bind-html=vm.getTextOfActiveVehicles() ng-if=\"!vm.vehicleSearchInfo.isSearchTrigger || vm.searchHasNotFoundVehicles()\"></div><div class=vehicle-multi-tag-input-result ng-if=\"vm.vehicleSearchInfo.isSearchTrigger && !vm.searchHasNotFoundVehicles()\"><p class=title translate=multiTagInputVehicle.foundVehiclesMessage translate-values=\"{ notFoundLength: vm.vehicleSearchInfo.foundIdsOnSearch.length }\"></p><p class=warning translate=multiTagInputVehicle.notFoundAllSearch ng-if=vm.vehicleSearchInfo.notFoundSearchValues.length></p></div><div class=sp-vehicles-list><header class=sp-vehicles-list__header><div class=sp-vehicles-list__header-checkbox><div class=sp-vehicle-checkbox><input id=checkbox-all-vehicles type=checkbox class=sp-checkbox-input ng-checked=vm.areAllVehiclesSelected() ng-click=vm.toggleAllVehicles()><label><span class=sp-icon-check></span></label></div></div><div class=sp-vehicles-list__header-title><span translate=Vehicles.vehicle></span></div><div class=sp-vehicles-list__header-title><span translate=Vehicles.driver></span></div><div class=sp-vehicles-list__header-title><span translate=Vehicles.capacity></span></div><div class=sp-vehicles-list__header-title><span translate=Vehicles.load_type></span></div><div class=sp-vehicles-list__header-title><span translate=Vehicles.license_plate></span></div><div class=sp-vehicles-list__header-action></div></header><section><article class=sp-vehicle-item ng-repeat=\"vehicle in vm.vehiclesRendered | filter:vm.filterBySearchResult | orderBy:[vm.customOrderByAvailability, vm.naturalSort(\'name\')]\" ng-init=\"vehicle.collapsed = true\" ng-click=vm.toggleSelectedVehicle(vehicle) ng-class=\"{\'sp-unavailable-vehicle-row\': !vehicle.availability.isAvailable}\"><div class=sp-vehicle-item__checkbox ng-class=\"{\'sp-vehicle-item--bordered\': vehicle !== vm.selectedVehicle}\"><div class=sp-vehicle-checkbox><input type=checkbox class=sp-checkbox-input ng-model=vehicle.active ng-change=vm.toggleVehicle(vehicle) ng-click=$event.stopPropagation() ng-disabled=!vehicle.availability.isAvailable><label><span class=sp-icon-check></span></label></div></div><div class=sp-vehicle-item__name ng-class=\"{\'sp-vehicle-item--bordered\': vehicle !== vm.selectedVehicle}\"><div class=vehicle-name-chip ng-class=\"{\n                \'vehicle-available\': vm.shouldDisplayAvailableVehicleData(vehicle.availability),\n                \'vehicle-partially-available\': vm.shouldDisplayPartiallyAvailableVehicleData(vehicle.availability),\n                \'vehicle-unavailable\': vm.shouldDisplayUnavailableVehicleData(vehicle.availability),\n                \'vehicle-with-expired-documents\': vm.shouldDisplayVehicleWithExpiredDocumentsData(vehicle.availability),\n                \'blocked-vehicle\': vm.shouldDisplayBlockedVehicleData(vehicle.availability)}\n              \"><div uib-tooltip={{vehicle.availability.finalMessage}} tooltip-append-to-body=true tooltip-class=tooltip-enable-line-break ng-include=vm.getAvailabilityIconUrl(vehicle.availability) class=icon tooltip-placement=top-left></div><div class=sp-vehicle-item__container uib-tooltip={{::vehicle.name}} tooltip-append-to-body=true tooltip-class=tooltip-enable-line-break><div class=sp-text-ellipsis><span>{{ ::vehicle.name }}</span></div></div></div></div><div class=sp-vehicle-item__driver ng-class=\"{\'sp-vehicle-item--bordered\': vehicle !== vm.selectedVehicle}\"><div class=sp-vehicle-item__container uib-tooltip={{::vehicle.driver.name}} tooltip-append-to-body=true tooltip-class=tooltip-enable-line-break><div class=sp-text-ellipsis><span>{{ ::vehicle.driver.name }}</span></div></div></div><div class=sp-vehicle-item__capacity ng-class=\"{\'sp-vehicle-item--bordered\': vehicle !== vm.selectedVehicle}\"><span>{{ ::vehicle.capacity | formatNumber:2 }}</span></div><div class=sp-vehicle-item__load-type ng-class=\"{\'sp-vehicle-item--bordered\': vehicle !== vm.selectedVehicle}\"><span>{{ vehicle.typeLoad ? (\'Vehicles.load_type_values.\' + vehicle.typeLoad | translate): \'\' }}</span></div><div class=sp-vehicle-item__license-plate ng-class=\"{\'sp-vehicle-item--bordered\': vehicle !== vm.selectedVehicle}\"><span>{{ ::vehicle.licensePlate }}</span></div><div class=sp-vehicle-item__action ng-class=\"{\'sp-vehicle-item--bordered\': vehicle !== vm.selectedVehicle}\"><div class=\"sp-vehicle-item__edit-button btn btn-link sp-btn-collapse\" ng-if=::!vm.hasVehicleRoutesProcessed(vehicle)><a class=\"btn btn-link sp-btn-collapse\" ui-sref=\"^.vehicles-detail({vehicleId: vehicle.id})\"><div ng-include=\"\'/assets/images/edit.svg\'\" class=sp-btn-link-edit></div></a></div></div><div ng-class=\"{\'sp-vehicle-item--bordered\': vehicle === vm.selectedVehicle}\"></div><div class=sp-vehicle-item__expanded ng-class=\"{\'sp-vehicle-item--bordered\': vehicle === vm.selectedVehicle}\"><div class=sp-vehicle-item__expanded-content uib-collapse=\"vehicle !== vm.selectedVehicle\"><div class=sp-vehicle-item__additional-info><span>{{ vehicle.locationStart.address }}</span> <span>{{ vehicle.locationEnd.address }}</span><div class=sp-vehicle-item__shift><span class=sp-icon-ventana-horaria></span> <span>{{ vehicle.shift.start}} - {{ vehicle.shift.end}}</span></div><div ng-if=\"vehicle.skills.length > 0\" class=sp-vehicle-item__skills><span class=sp-icon-skills></span><div><span ng-repeat=\"skill in vehicle.skills\">{{ vm.plannerService.getSkillObjById(skill).name }},</span></div></div></div></div></div></article></section></div><a class=sp-manage-text href=# ng-if=vm.showManageVehicles ng-click=\"vm.onClickManageVehiclesLink(\'/settings/vehicles\')\"><span translate=Vehicles.manage_vehicles></span></a></div><div id=vehiclesEmpty ng-show=\"vm.vehiclesRendered.length === 0 && !isLoading\" class=sp-vehicles-empty><div class=span-vehicles-empty><span translate=Vehicles.empty_vehicles_1></span></div><div class=image-vehicles-empty><img src=../../../assets/images/sin-vehiculos-img.svg></div><div class=button-vehicles-empty ng-if=vm.showManageVehicles><a class=\"btn btn-primary\" ng-click=\"vm.onClickManageVehiclesLink(\'/settings/vehicles/create\')\" translate=Vehicles.empty_vehicles_2></a></div></div><div id=goToVisitBtn class=\"sp-planner-footer text-right margin-top-5 padding-bottom-15\"><div style=\"display:flex; flex-direction:row-reverse; align-content: center\"><button type=button class=\"btn btn-primary\" ng-click=vm.goNext() ng-disabled=\"vm.existAnErrorOnVehiclesSelected() || vm.scheduleForm.$invalid\" style=\"margin-left: 10px; height: 31px\"><span translate=Planner.btn_save_and_continue></span> <i class=sp-icon-chevron-right></i></button><p class=\"sp-text-color-danger sp-error-msg\" ng-show=vm.errorMissingOriginOrDestiny>* <span translate=Vehicles.origin_or_destiny_error_msg></span></p><p class=\"sp-text-color-danger sp-error-msg\" ng-show=\"vm.errorVehiclesNotSelected && !vm.errorMissingOriginOrDestiny && !vm.errorVehicleUnavailable\">* <span translate=Vehicles.no_vehicles_selected></span></p><p class=\"sp-text-color-danger sp-error-msg\" ng-show=vm.errorVehicleUnavailable>* <span translate=Vehicles.disabled_vehicles_selected></span></p></div></div></div>");
$templateCache.put("app/planner/visits/visits-bulk-edit.html","<div class=sp-planner-header><div class=sp-planner-header-row><h2 class=sp-planner-header-title translate=Visits.bulk_edit></h2></div></div><div class=sp-warning-bulk-edit style=\"padding-bottom: 0px\"><span>{{(\'Visits.bulk_edit_message_1\' | translate:{visitsQty: vm.visitsQty})}}</span><div class=sp-summary-visits-container><div class=visit-title ng-repeat=\"v in vm.visits | limitTo:vm.MAX_VISITS_TO_SHOW\" uib-tooltip={{v.title}} tooltip-placement=bottom-left tooltip-append-to-body=true tooltip-class=tooltip-bulk-edit-visit><span>{{v.title}}</span></div><div class=summary-visits ng-if=vm.summaryVisits tooltip-placement=bottom-left uib-tooltip-html=vm.summaryVisits tooltip-append-to-body=true tooltip-class=\"tooltip-bulk-edit-visit summary-visits\"><span>+{{vm.totalVisitsNotShow}}</span></div></div><span class=sp-warning-msg translate=Visits.bulk_edit_message_2></span></div><div class=sp-planner-scrollable><form class=\"form-horizontal sp-form\" name=vm.form style=\"padding-top: 4px\"><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_title></label><input type=text translate translate-attr-placeholder=Visits.placeholder.title class=styled-input name=title ng-model=vm.visit.title autofocus ng-required=false><p ng-if=\"vm.form.title.$touched && vm.form.title.$error.required\" class=\"sp-text-color-danger sp-error-msg\" translate=Visits.title_required></p></div><div class=column-container><label class=input-label>ID</label><input type=text translate translate-attr-placeholder=Visits.placeholder.id class=styled-input name=reference ng-model=vm.visit.reference></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_address></label><autocomplete input-name=\"\'address\'\" address=vm.visit.address update-address=\"vm.updateVisitLocation(location, address)\" class=address-visit is-required=false></autocomplete><p ng-if=\"vm.form.address.$touched && vm.form.address.$error.required\" class=\"sp-text-color-danger sp-error-msg\" translate=Visits.address_required></p></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_latitude></label><input type=text translate translate-attr-placeholder=Visits.placeholder.latitude class=styled-input name=latitude ng-model=vm.visit.latitude ng-blur=vm.coordsChanged(vm.visit)></div><div class=column-container><label class=input-label translate=Visits.lbl_longitude></label><input type=text translate translate-attr-placeholder=Visits.placeholder.longitude class=styled-input name=longitude ng-model=vm.visit.longitude ng-blur=vm.coordsChanged(vm.visit)></div></div><div class=sp-visit-detail-container><p ng-if=!vm.validForm.coords class=\"sp-text-color-danger sp-error-msg\" translate=Visits.error_coordinate_pattern></p></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_load></label><input type=number translate translate-attr-placeholder=Visits.placeholder.load_1 class=styled-input style=\"width: 100%\" name=load ng-model=vm.visit.load><p ng-if=vm.form.load.$invalid class=\"sp-text-color-danger sp-error-msg\" translate=Visits.load_1_invalid></p></div><div class=column-container><label class=input-label translate=Visits.lbl_load_2></label><input type=number translate translate-attr-placeholder=Visits.placeholder.load_2 class=styled-input style=\"width: 100%\" name=load_2 ng-model=vm.visit.load2><p ng-if=vm.form.load_2.$invalid class=\"sp-text-color-danger sp-error-msg\" translate=Visits.load_2_invalid></p></div><div ng-if=!vm.isMixLoadAddonEnabled class=column-container><label class=input-label translate=Visits.lbl_load_3></label><input type=number translate translate-attr-placeholder=Visits.placeholder.load_3 class=styled-input style=\"width: 100%\" name=load_3 ng-model=vm.visit.load3><p ng-if=vm.form.load_3.$invalid class=\"sp-text-color-danger sp-error-msg\" translate=Visits.load_3_invalid></p></div></div><!-- CON ADDON MIX LOAD --><div ng-if=vm.isMixLoadAddonEnabled class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_load_3></label><input type=number translate translate-attr-placeholder=Visits.placeholder.load_3 class=styled-input style=\"width: 100%\" name=load_3 ng-model=vm.visit.load3><p ng-if=vm.form.load_3.$invalid class=\"sp-text-color-danger sp-error-msg\" translate=Visits.load_3_invalid></p></div><div class=column-container><label class=input-label translate=Visits.lbl_load_4></label><input type=number translate translate-attr-placeholder=Visits.placeholder.load_4 class=styled-input style=\"width: 100%\" name=load_4 ng-model=vm.visit.load4><p ng-if=vm.form.load_4.$invalid class=\"sp-text-color-danger sp-error-msg\" translate=Visits.load4_invalid></p></div></div><!-- FIN con addon mix load --><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.tag></label><div class=skills-container><div class=tag-skill ng-repeat=\"tag in vm.tags track by tag.id\" ng-click=\"vm.tagsHandler(tag.id, vm.visit.tags)\" ng-class=\"{active: vm.isTagSelected(tag.id, vm.visit.tags)}\"><label><span class=sp-icon-check></span></label>{{tag.label}}</div></div></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.type_of_visit></label><select class=\"styled-input select-priority\" name=visitType.key ng-model=vm.visit.visitType ng-options=\"visitType.key as visitType.label for visitType in vm.visitTypes\"><option value=\"\" translate=Visits.select_type_of_visits></option></select></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.start_time_window_1></label><input type=text placeholder=00:00 class=styled-input name=window_start ng-model=vm.visit.windowStart ng-blur=\"vm.validateTime(); vm.validateWindowTimes()\"></div><div class=column-container><label class=input-label translate=Visits.end_time_window_1></label><input type=text placeholder=23:59 class=styled-input name=window_end ng-model=vm.visit.windowEnd ng-blur=\"vm.validateTime(); vm.validateWindowTimes()\"></div></div><div class=sp-visit-detail-container><p ng-if=vm.invalidDate class=\"sp-text-color-danger sp-error-msg\" translate=Visits.error_format_date></p><p ng-if=vm.timeBetweenDate class=\"sp-text-color-danger sp-error-msg\" translate=Visits.error_between_date></p><p ng-if=vm.emptyDate class=\"sp-text-color-danger sp-error-msg\" translate=Visits.error_empty_date></p></div><div class=sp-visit-detail-container ng-if=vm.visit.OverlappingWindowError><div class=\"col-sm-12 text-center\"><p class=\"sp-text-color-danger sp-error-msg\" translate=Visits.alert_notification.error_overlapping></p></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.start_time_window_2></label><input type=text placeholder=00:00 class=styled-input name=window_start_2 ng-model=vm.visit.windowStart2 ng-blur=\"vm.validateTime(); vm.validateWindowTimes()\"></div><div class=column-container><label class=input-label translate=Visits.end_time_window_2></label><input type=text placeholder=23:59 class=styled-input name=window_end_2 ng-model=vm.visit.windowEnd2 ng-blur=\"vm.validateTime(); vm.validateWindowTimes()\"></div></div><div class=sp-visit-detail-container><p ng-if=vm.invalidDate2 class=\"sp-text-color-danger sp-error-msg\" translate=Visits.error_format_date></p><p ng-if=vm.timeBetweenDate2 class=\"sp-text-color-danger sp-error-msg\" translate=Visits.error_between_date></p><p ng-if=vm.emptyDate2 class=\"sp-text-color-danger sp-error-msg\" translate=Visits.error_empty_date></p></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_service></label><input type=text translate translate-attr-placeholder=Visits.placeholder.service_time class=styled-input name=duration ng-model=vm.visit.duration ng-required=false ng-blur=vm.validateTimeService()><p class=\"sp-text-color-danger sp-error-msg\" ng-show=vm.serviceTimeError translate=Visits.msg_error_service_time></p></div><div class=column-container><label class=input-label translate=Visits.lbl_priority></label><select class=\"styled-input select-priority\" name=priority_level ng-model=vm.visit.priorityLevel ng-options=\"priority.value as priority.name for priority in vm.priorityLevels | orderBy:priority.value:false\"><option value=\"\" translate=Visits.select_priority_level></option></select></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_contact_name></label><input type=text translate translate-attr-placeholder=Visits.placeholder.contact_person class=styled-input name=contactName ng-model=vm.visit.contactName></div><div class=column-container><label class=input-label translate=Visits.lbl_contact_phone></label><input type=text translate translate-attr-placeholder=Visits.placeholder.phone_contact class=styled-input name=contactPhone ng-model=vm.visit.contactPhone></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_contact_email></label><div class=visit-email-tags-container><tags-input ng-model=vm.emails placeholder=\"{{\'Visits.contact_email_placeholder\' | translate}}\" class=visit-email-tags max-tags={{MAX_EMAILS_INPUT}} add-on-space=true add-on-comma=true enable-editing-last-tag=true on-tag-adding=vm.validateEmailInput($tag)></tags-input><p ng-if=vm.emailInputError.invalidFormat class=\"sp-text-color-danger sp-error-msg\" translate=Visits.msg_error_email_valid></p><p ng-if=vm.emailInputError.maxQuantity class=\"sp-text-color-danger sp-error-msg\"><span translate=Visits.error_max_emails_message_1></span> {{vm.maxEmails}} <span translate=Visits.error_max_emails_message_2></span></p><p ng-if=vm.emailInputError.maxLength class=\"sp-text-color-danger sp-error-msg\" translate=Visits.error_email_length_message></p></div></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_notes></label><textarea class=styled-input name=notes rows=10 ng-model=vm.visit.notes ng-disabled=\"vm.isVisitBeingEdited && vm.enableHidingVisitNotes\" translate translate-attr-placeholder=Visits.placeholder.notes>\n        </textarea></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.required_skills></label><div class=skills-container><div class=tag-skill ng-repeat=\"requiredSkill in vm.requiredSkills track by requiredSkill.id\" ng-show=requiredSkill.visible ng-click=\"vm.skillsHandler(requiredSkill.id, \'skills_required\', vm.optionalSkills)\" ng-class=\"{active: vm.isSkillSelected(requiredSkill.id, vm.visit.skills_required)}\"><label><span class=sp-icon-check></span></label>{{requiredSkill.name}}</div></div></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.optional_skills></label><div class=skills-container><div class=tag-skill ng-repeat=\"optionalSkill in vm.optionalSkills track by optionalSkill.id\" ng-show=optionalSkill.visible ng-click=\"vm.skillsHandler(optionalSkill.id, \'skills_optional\', vm.requiredSkills)\" ng-class=\"{active: vm.isSkillSelected(optionalSkill.id, vm.visit.skills_optional)}\"><label><span class=sp-icon-check></span></label>{{optionalSkill.name}}</div></div></div></div><div class=sp-visit-detail-container ng-if=\"vm.sellers.length > 0 && vm.isSellerManagementEnabled\"><div class=column-container><label class=input-label translate=Visits.seller></label><select class=\"styled-input select-priority\" name=seller.id ng-model=vm.visit.seller_id ng-options=\"seller.id as seller.name for seller in vm.sellers \"><option value=\"\" translate=Visits.select_seller></option></select></div></div></form></div><div class=sp-planner-footer><button class=\"btn btn-default pull-left sp-button-default\" type=button ng-click=vm.cancel() translate=Planner.btn_cancel></button> <button class=\"btn btn-success pull-right\" type=submit ng-click=vm.showSaveModal() ng-disabled=vm.isInvalidForm() translate=Planner.btn_save></button></div>");
$templateCache.put("app/planner/visits/visits-date-error-visits-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Visits.invalid_date_plan></h3></div><div class=modal-body><p translate=Visits.msg_error_plan_date></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Visits.close></button></div></div>");
$templateCache.put("app/planner/visits/visits-delete-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Visits.delete_all_modals></h3></div><div class=modal-body><p translate=Visits.delet_modal_message></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Visits.close></button> <button type=button class=\"btn btn-danger\" ng-click=\"deleteAllVisits(); closeThisDialog(0)\" translate=Visits.delete ng-if=allVisitsChecked></button> <button type=button class=\"btn btn-danger\" ng-click=\"removeSelectedVisits(); closeThisDialog(0)\" translate=Visits.delete ng-if=!allVisitsChecked></button></div></div>");
$templateCache.put("app/planner/visits/visits-detail.html","<div class=sp-planner-header><div class=sp-planner-header-row><h2 class=sp-planner-header-title ng-if=vm.visit.id translate=Visits.edit_title></h2><h2 class=sp-planner-header-title ng-if=!vm.visit.id translate=Visits.create_title></h2></div></div><div class=tabs-container ng-if=vm.enableManageVisitItems><ul class=tabs-options><li class=tab ng-repeat=\"tab in vm.VISIT_TABS\" ng-class=\"{ \'active\': vm.selectedTab == tab }\"><a class=\"btn btn-link\" ng-click=\"vm.selectedTab = tab\" translate=Visits.visit_tabs.{{tab}}></a></li></ul></div><div class=\"sp-planner-scrollable visit-details\" ng-show=\"vm.selectedTab == vm.VISIT_TABS.DETAILS\"><form class=\"form-horizontal sp-form\" name=vm.form><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_title></label><input type=text translate translate-attr-placeholder=Visits.placeholder.title class=styled-input name=title ng-model=vm.visit.title autofocus ng-required=true><p ng-if=\"vm.form.title.$touched && vm.form.title.$error.required\" class=\"sp-text-color-danger sp-error-msg\" translate=Visits.title_required></p></div><div class=column-container><label class=input-label>ID</label><input type=text translate translate-attr-placeholder=Visits.placeholder.id class=styled-input name=reference ng-model=vm.visit.reference></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_address></label><autocomplete input-name=\"\'address\'\" address=vm.visit.address update-address=\"vm.updateVisitLocation(location, address)\" class=address-visit></autocomplete><p ng-if=\"vm.form.address.$touched && vm.form.address.$error.required\" class=\"sp-text-color-danger sp-error-msg\" translate=Visits.address_required></p></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_latitude></label><input type=text translate translate-attr-placeholder=Visits.placeholder.latitude class=styled-input name=latitude ng-model=vm.visit.latitude ng-blur=vm.coordsChanged(vm.visit)></div><div class=column-container><label class=input-label translate=Visits.lbl_longitude></label><input type=text translate translate-attr-placeholder=Visits.placeholder.longitude class=styled-input name=longitude ng-model=vm.visit.longitude ng-blur=vm.coordsChanged(vm.visit)></div></div><div class=sp-visit-detail-container><p ng-if=!vm.validForm.coords class=\"sp-text-color-danger sp-error-msg\" translate=Visits.error_coordinate_pattern></p></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_load></label><input type=number translate translate-attr-placeholder=Visits.placeholder.load_1 class=styled-input style=\"width: 100%\" name=load ng-model=vm.visit.load><p ng-if=vm.form.load.$invalid class=\"sp-text-color-danger sp-error-msg\" translate=Visits.load_1_invalid></p></div><div class=column-container><label class=input-label translate=Visits.lbl_load_2></label><input type=number translate translate-attr-placeholder=Visits.placeholder.load_2 class=styled-input style=\"width: 100%\" name=load_2 ng-model=vm.visit.load2><p ng-if=vm.form.load_2.$invalid class=\"sp-text-color-danger sp-error-msg\" translate=Visits.load_2_invalid></p></div><div ng-if=!vm.isMixLoadAddonEnabled class=column-container><label class=input-label translate=Visits.lbl_load_3></label><input type=number translate translate-attr-placeholder=Visits.placeholder.load_3 class=styled-input style=\"width: 100%\" name=load_3 ng-model=vm.visit.load3><p ng-if=vm.form.load_3.$invalid class=\"sp-text-color-danger sp-error-msg\" translate=Visits.load_3_invalid></p></div></div><!-- CON ADDON MIX LOAD --><div ng-if=vm.isMixLoadAddonEnabled class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_load_3></label><input type=number translate translate-attr-placeholder=Visits.placeholder.load_3 class=styled-input style=\"width: 100%\" name=load_3 ng-model=vm.visit.load3><p ng-if=vm.form.load_3.$invalid class=\"sp-text-color-danger sp-error-msg\" translate=Visits.load_3_invalid></p></div><div class=column-container><label class=input-label translate=Visits.lbl_load_4></label><input type=number translate translate-attr-placeholder=Visits.placeholder.load_4 class=styled-input style=\"width: 100%\" name=load_4 ng-model=vm.visit.load4><p ng-if=vm.form.load4.$invalid class=\"sp-text-color-danger sp-error-msg\" translate=Visits.load4_invalid></p></div></div><!-- FIN con addon mix load --><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.tag></label><div class=skills-container><div class=tag-skill ng-repeat=\"tag in vm.tags track by tag.id\" ng-click=\"vm.tagSelectedHandler(tag.id, vm.visit.tags)\" ng-class=\"{active: vm.isTagSelected(tag.id, vm.visit.tags)}\"><label><span class=sp-icon-check></span></label>{{tag.label}}</div></div></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.type_of_visit></label><select class=\"styled-input select-priority\" name=visitType.key ng-model=vm.visit.visitType ng-options=\"visitType.key as visitType.label for visitType in vm.visitTypes \"><option value=\"\" translate=Visits.select_type_of_visits></option></select></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.start_time_window_1></label><input type=text placeholder=00:00 class=styled-input name=window_start ng-model=vm.visit.windowStart ng-blur=\"vm.validateTime(); vm.validateWindowTimes()\"></div><div class=column-container><label class=input-label translate=Visits.end_time_window_1></label><input type=text placeholder=23:59 class=styled-input name=window_end ng-model=vm.visit.windowEnd ng-blur=\"vm.validateTime(); vm.validateWindowTimes()\"></div></div><div class=sp-visit-detail-container><p ng-if=vm.invalidDate class=\"sp-text-color-danger sp-error-msg\" translate=Visits.error_format_date></p><p ng-if=vm.timeBetweenDate class=\"sp-text-color-danger sp-error-msg\" translate=Visits.error_between_date></p><p ng-if=vm.emptyDate class=\"sp-text-color-danger sp-error-msg\" translate=Visits.error_empty_date></p></div><div class=sp-visit-detail-container ng-if=vm.visit.OverlappingWindowError><div class=\"col-sm-12 text-center\"><p class=\"sp-text-color-danger sp-error-msg\" translate=Visits.alert_notification.error_overlapping></p></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.start_time_window_2></label><input type=text placeholder=00:00 class=styled-input name=window_start_2 ng-model=vm.visit.windowStart2 ng-blur=\"vm.validateTime(); vm.validateWindowTimes()\"></div><div class=column-container><label class=input-label translate=Visits.end_time_window_2></label><input type=text placeholder=23:59 class=styled-input name=window_end_2 ng-model=vm.visit.windowEnd2 ng-blur=\"vm.validateTime(); vm.validateWindowTimes()\"></div></div><div class=sp-visit-detail-container><p ng-if=vm.invalidDate2 class=\"sp-text-color-danger sp-error-msg\" translate=Visits.error_format_date></p><p ng-if=vm.timeBetweenDate2 class=\"sp-text-color-danger sp-error-msg\" translate=Visits.error_between_date></p><p ng-if=vm.emptyDate2 class=\"sp-text-color-danger sp-error-msg\" translate=Visits.error_empty_date></p></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_service></label><input type=text translate translate-attr-placeholder=Visits.placeholder.service_time class=styled-input name=duration ng-model=vm.visit.duration ng-required=true ng-blur=vm.validateTimeService()><p class=\"sp-text-color-danger sp-error-msg\" ng-show=vm.serviceTimeError translate=Visits.msg_error_service_time></p></div><div class=column-container><label class=input-label translate=Visits.lbl_priority></label><select class=\"styled-input select-priority\" name=priority_level ng-model=vm.visit.priorityLevel ng-options=\"priority.value as priority.name for priority in vm.priorityLevels | orderBy:priority.value:false\"><option value=\"\" translate=Visits.select_priority_level></option></select></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_contact_name></label><input type=text translate translate-attr-placeholder=Visits.placeholder.contact_person class=styled-input name=contactName ng-model=vm.visit.contactName></div><div class=column-container><label class=input-label translate=Visits.lbl_contact_phone></label><input type=text translate translate-attr-placeholder=Visits.placeholder.phone_contact class=styled-input name=contactPhone ng-model=vm.visit.contactPhone></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_contact_email></label><div class=visit-email-tags-container><tags-input ng-model=vm.emails placeholder=\"{{\'Visits.contact_email_placeholder\' | translate}}\" class=visit-email-tags max-tags={{MAX_EMAILS_INPUT}} add-on-space=true add-on-comma=true enable-editing-last-tag=true on-tag-adding=vm.validateEmailInput($tag)></tags-input><p ng-if=vm.emailInputError.invalidFormat class=\"sp-text-color-danger sp-error-msg\" translate=Visits.msg_error_email_valid></p><p ng-if=vm.emailInputError.maxQuantity class=\"sp-text-color-danger sp-error-msg\"><span translate=Visits.error_max_emails_message_1></span> {{vm.maxEmails}} <span translate=Visits.error_max_emails_message_2></span></p><p ng-if=vm.emailInputError.maxLength class=\"sp-text-color-danger sp-error-msg\" translate=Visits.error_email_length_message></p></div></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.lbl_notes></label><textarea class=styled-input name=notes rows=10 ng-model=vm.visit.notes ng-disabled=\"vm.isVisitBeingEdited && vm.enableHidingVisitNotes\" translate translate-attr-placeholder=Visits.placeholder.notes>\n        </textarea></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.required_skills></label><div class=skills-container><div class=tag-skill ng-repeat=\"requiredSkill in vm.requiredSkills track by requiredSkill.id\" ng-show=requiredSkill.visible ng-click=\"vm.skillsHandler(requiredSkill.id, vm.visit.skills_required, vm.optionalSkills)\" ng-class=\"{active: vm.isSkillSelected(requiredSkill.id, vm.visit.skills_required)}\"><label><span class=sp-icon-check></span></label>{{requiredSkill.name}}</div></div></div></div><div class=sp-visit-detail-container><div class=column-container><label class=input-label translate=Visits.optional_skills></label><div class=skills-container><div class=tag-skill ng-repeat=\"optionalSkill in vm.optionalSkills track by optionalSkill.id\" ng-show=optionalSkill.visible ng-click=\"vm.skillsHandler(optionalSkill.id, vm.visit.skills_optional, vm.requiredSkills)\" ng-class=\"{active: vm.isSkillSelected(optionalSkill.id, vm.visit.skills_optional)}\"><label><span class=sp-icon-check></span></label>{{optionalSkill.name}}</div></div></div></div><div class=sp-visit-detail-container ng-if=\"vm.sellers.length > 0 && vm.isSellerManagementEnabled\"><div class=column-container><label class=input-label translate=Visits.seller></label><select class=\"styled-input select-priority\" name=seller.id ng-model=vm.visit.seller_id ng-options=\"seller.id as seller.name for seller in vm.sellers \"><option value=\"\" translate=Visits.select_seller></option></select></div></div></form></div><!-- end sp-planner-scrollable --><div class=visit-items-container ng-show=\"vm.selectedTab == vm.VISIT_TABS.ITEMS\"><items-table class=visit-items-table items=vm.visit.items on-delete=vm.deleteVisitItems() on-add=vm.addVisitItem() on-change=vm.invalidateItemForm(itemFormValidationStatus)></items-table></div><div class=sp-planner-footer><button class=\"btn btn-default pull-left sp-button-default\" type=button ng-click=vm.cancel() translate=Planner.btn_cancel></button> <button class=\"btn btn-success pull-right\" type=button ng-click=vm.save() ng-disabled=vm.isInvalidForm() translate=Planner.btn_save></button></div>");
$templateCache.put("app/planner/visits/visits-incompleted-vehicles-error-visits-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Visits.not_available_vehicles></h3></div><div class=modal-body><p translate=Visits.error_msg_routes_not_completed></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Visits.close></button></div></div>");
$templateCache.put("app/planner/visits/visits-list.html","<div class=sp-loader-planner ng-if=isLoadingPlanner><div class=sp-loader-container><div class=loading ng-style=\"{width: vm.widthDynamic}\"><img width=120 height=81 class=gif src=../../../assets/images/loader-progress.gif></div><uib-progressbar animate=false max=vm.maxProgressBar value=vm.visitsGeoreference></uib-progressbar></div></div><div class=sp-planner-header><div class=sp-planner-header-row><h2 class=sp-planner-header-title translate=Visits.title></h2><div class=\"btn-group pull-right menu\"><button type=button class=\"btn btn-primary dropdown-toggle\" data-toggle=dropdown aria-expanded=false ng-click=vm.openMenuToAddVisits() translate=Visits.create_visit_btn></button><ul class=\"dropdown-menu sp-visits-import-menu\" role=menu ng-if=vm.menuVisitIsOpen><!-- Create Visit--><li ng-if=!vm.disableManualIntakeVisits><div class=sp-create-visits-option><div class=sp-label><a ui-sref=^.visits-create href=\"\" translate=Visits.create_visit_manual></a></div></div></li><!-- Export Visit--><li ng-if=!vm.disableManualIntakeVisits><div class=sp-create-visits-option><div class=sp-label><span class=create-visit-btn-file><input type=file sp-file-change=\"vm.importExcel($files, vm.excelDropdownLoadType)\"> <span translate=Visits.create_visit_excel></span></span></div></div></li><!-- Visit Integration API --><li><div class=sp-create-visits-option><div class=sp-label><a href=\"\" ng-click=vm.openComponentVisitsIntegration() translate=Visits.create_visit_integration></a></div></div><ul class=\"sub-menu dropdown-menu\" ng-if=vm.popupVisitsIntegration><li class=sub-menu-open><visits-import data=vm.dataVisitsImport on-get-visits=\"vm.loadUnroutedVisits(start_date, end_date, visitTypes)\"></visits-import></li></ul></li><!-- Visit Integration API not completed --><li ng-if=!vm.disableManualIntakeVisits><div class=sp-create-visits-option><div class=sp-label><a href=\"\" ng-click=vm.openComponentVisitsIntegrationNotCompleted() translate=Visits.create_visit_integration_not_completed></a></div></div><ul class=\"sub-menu dropdown-menu\" ng-if=vm.popupVisitsIntegrationNotCompleted><li class=sub-menu-open><visits-import data=vm.dataVisitsImportNotCompleted on-get-visits=\"vm.loadIncompleteVisits(start_date, end_date, status, visitTypes)\"></visits-import></li></ul></li></ul></div></div></div><search-bar data=vm.searchData filters=vm.filters on-click=vm.onClickSearch on-remove=vm.onRemoveSearch must-return-all-matched-result=true no-results-found-text=\"\'SearchBar.Visits.noResultsFound\'\" matched-value=vm.filterHandler.matchedValue min-text=\"\'SearchBar.Visits.minText\'\" placeholder=\"\'SearchBar.Visits.placeholder\'\" to-reset=vm.setResetSearchBar(reset)></search-bar><div class=\"btn-group sp-planner-visits-filter\"><div class=\"btn sp-filtered active\"><label translate=Visits.all_visits></label><span class=sp-short-notification-info ng-if=\"vm.visitCardsCurrentPage.length || vm.visitForRoutingCardsCurrentPage.length\">({{vm.totalLoadedVisitCards + vm.totalLoadedVisitForRoutingCards }})</span></div><div class=\"btn sp-filtered sp-not-cursor-pointer\" ng-click=vm.goToAlertVisits() ng-disabled=\"vm.warningVisitsQty === 0\"><label translate=Visits.warnings></label><span class=sp-short-notification-info ng-if=\"vm.warningVisitsQty > 0\">({{vm.warningVisitsQty}})</span> <span class=\"close sp-text-color-brand-primary sp-text-opacity-1 sp-margin-top-minus-4\" ng-click=vm.showRemoveWarningVisitsModal() ng-if=\"vm.warningVisitsQty > 0\"><i class=sp-icon-delete></i></span></div><div class=\"btn sp-filtered sp-not-cursor-pointer\" ng-click=vm.goToErrorVisits() ng-disabled=\"vm.errorVisitsQty === 0\"><label translate=Visits.errors></label><span class=sp-short-notification-info ng-if=\"vm.errorVisitsQty > 0\">({{vm.errorVisitsQty}})</span> <span class=\"close sp-text-color-brand-primary sp-text-opacity-1 sp-margin-top-minus-4\" ng-click=vm.showRemoveErrorVisitsModal() ng-if=\"vm.errorVisitsQty > 0\"><i class=sp-icon-delete></i></span></div></div><div class=sp-actions-visits-container ng-if=\"vm.visitCardsCurrentPage.length > 0 || vm.visitForRoutingCardsCurrentPage.length > 0\"><div class=sp-visit-checkbox-container><div class=sp-visit-checkbox ng-click=vm.checkAllVisits() id=check-select-all-visits ng-if=\"vm.areVisitsEditable && !vm.positiveSelectionVisitsEnabled\"><input type=checkbox ng-model=vm.allVisitsChecked><label><span class=sp-icon-check></span></label><div class=horizontal-bar-icon ng-if=\"!vm.allVisitsChecked && vm.totalSelectedVisits\" ng-include=\"\'assets/images/horizontal-bar.svg\'\"></div></div><div class=total-selected-visits ng-if=\"vm.totalSelectedVisits && !vm.positiveSelectionVisitsEnabled\"><span style=\"color: #4C3BEF\">{{vm.getTextOfSelectedVisits()}}</span></div><div class=total-selected-visits ng-if=vm.positiveSelectionVisitsEnabled><span style=\"color: #4C3BEF; font-size: 12px\">{{(\'Visits.total_of_visits\' | translate: {totalLoadedVisits: vm.totalLoadedVisitCards, totalLoadedVisitForRouting: vm.totalLoadedVisitForRoutingCards})}}</span></div></div><div class=sp-actions-on-visits id=actions-on-visits><div uib-dropdown class=btn-group is-open=vm.moveDropdownOpen ng-if=vm.positiveSelectionVisitsEnabled><button type=button class=btn-move-to ng-disabled=\"vm.selectedVisits.length === 0\" uib-dropdown-toggle><span translate=Visits.move_to_dropdown.dropdown_title></span> <span ng-if=!vm.moveDropdownOpen ng-include=\"\'/assets/images/navegation_down/navegation_down_16.svg\'\" style=\"color: #4C3BEF\"></span> <span ng-if=vm.moveDropdownOpen ng-include=\"\'/assets/images/navegation_up/navegation_up_16.svg\'\" style=\"color: #4C3BEF\"></span></button><ul class=\"dropdown-menu move-to-dropdown\" uib-dropdown-menu role=menu><li role=menuitem><a href=# ng-click=\"$event.preventDefault(); vm.addingVisitsToVisitsForRouting()\"><span translate=Visits.move_to_dropdown.visits_for_routing></span></a></li><li role=menuitem><a href=# ng-click=\"$event.preventDefault(); vm.removingVisitsToVisitsForRouting()\"><span translate=Visits.move_to_dropdown.pending_visits></span></a></li></ul></div><div class=sort-visits-container><button class=\"sp-btn-action-visit enabled\" id=sort-visits-btn ng-click=\"vm.showOptionsToSort = !vm.showOptionsToSort\"><div ng-if=\"vm.titleForOrderButton !== vm.DEFAULT_TITLE_FOR_ORDER_BUTTON\" ng-include=\"\'/assets/images/up-arrow.svg\'\" class=icon ng-class=\"{\'down-arrow\' : vm.typeOfSort !== vm.DEFAULT_TYPE_OF_SORT}\"></div><span translate=Visits.sort_visits.{{vm.titleForOrderButton}}></span></button><div ng-if=vm.showOptionsToSort style=\"position: relative\"><div class=sort-visits-content><div class=options-to-sort-visits><div uib-dropdown class=dropdown-options-to-sort><button class=\"btn btn-sort-visits\" uib-dropdown-toggle><span translate=Visits.sort_visits.{{vm.propertyToSort}}></span><div ng-include=\"\'/assets/images/arrow-down.svg\'\" class=sp-collapse-icon></div></button><ul class=dropdown-menu uib-dropdown-menu role=menu><li ng-repeat=\"property in vm.optionsToSortingVisits.properties\" role=menuitem ng-class=\"{\'active\': vm.propertyToSort === property}\" ng-click=\"vm.propertyToSort=property; vm.updateSortingOptions()\"><span translate=Visits.sort_visits.{{property}}></span> <span ng-if=\"vm.propertyToSort === property\" class=sp-icon-check></span></li></ul></div><div uib-dropdown class=\"dropdown-options-to-sort type-of-sort\"><button class=\"btn btn-sort-visits\" uib-dropdown-toggle><span translate=Visits.sort_visits.{{vm.typeOfSort}}></span><div ng-include=\"\'/assets/images/arrow-down.svg\'\" class=sp-collapse-icon></div></button><ul class=dropdown-menu uib-dropdown-menu role=menu><li ng-repeat=\"type in vm.optionsToSortingVisits.typeOfSort\" role=menuitem ng-class=\"{\'active\': vm.typeOfSort === type}\" ng-click=\"vm.typeOfSort=type; vm.updateSortingOptions()\"><span translate=Visits.sort_visits.{{type}}></span> <span ng-if=\"vm.typeOfSort === type\" class=sp-icon-check></span></li></ul></div><div class=close-sort-container ng-click=\"vm.showOptionsToSort = !vm.showOptionsToSort\"><div ng-include=\"\'assets/images/arrow-down.svg\'\"></div></div></div><div class=remove-sort><button class=btn-remove-sort ng-click=vm.removeSortingOptions()><div ng-include=\"\'assets/images/delete.svg\'\"></div><span translate=Visits.sort_visits.remove_sort></span></button></div></div></div></div><button class=\"btn sp-btn-action-visit\" id=edit-visits-btn ng-disabled=\"vm.selectedVisits.length === 0\" ng-class=\"{\'enabled\' : vm.selectedVisits.length}\" ng-click=vm.goToEdit() uib-tooltip=\"{{\'Visits.tooltips.edit\' | translate }}\"><div class=icon ng-include=\"\'assets/images/edit_filled.svg\'\"></div></button> <button class=\"btn sp-btn-action-visit\" id=delete-visits-btn ng-disabled=\"vm.selectedVisits.length === 0\" ng-class=\"{\'enabled\' : vm.selectedVisits.length}\" ng-click=vm.showDeleteModal() uib-tooltip=\"{{\'Visits.tooltips.delete\' | translate }}\"><div class=icon ng-include=\"\'assets/images/delete_filled.svg\'\"></div></button></div></div><div class=sp-planner-scrollable><div id=emptyVisits class=sp-planner-empty-data ng-if=\"!vm.visitCardsCurrentPage.length && !vm.visitForRoutingCardsCurrentPage.length\"><i class=sp-icon-map-pin style=\"color: #bac7ce\"></i><h4 translate=Visits.no_visits></h4><p><span class=\"btn btn-primary btn-file\"><input type=file sp-file-change=\"vm.importExcel($files, vm.excelButtonLoadType)\"> <span translate=Visits.import></span></span></p><p><small translate=Visits.or></small></p><p><span translate=Visits.may_use></span> <a target=_self href=\"\" ng-click=vm.downloadExcelVisit() translate=Visits.sample_template></a></p></div><!-- | plannerVisitsStatusFilter:vm.activeFilter:\'title\' --><div id=visitsList class=\"list-group sp-planner-visit-list\" ng-if=!vm.positiveSelectionVisitsEnabled><div id={{::visit.id}} ng-repeat=\"visit in vm.visitCardsCurrentPage\" class=list-group-item-visit><div class=sp-visit-checkbox-container ng-class=\"{\'visit-not-editable\' : !vm.canVisitBeEditedOrRemoved(visit) && vm.areVisitsEditable}\"><div class=sp-visit-checkbox ng-if=vm.canVisitBeEditedOrRemoved(visit)><input type=checkbox ng-model=visit.checked ng-click=vm.checkVisit(visit)><label><span class=sp-icon-check></span></label></div></div><div class=\"list-group-item sp-planner-default-position\" ng-click=vm.activateVisit(visit) ng-mouseenter=$parent.$parent.vm.highlightMarker(visit) ng-mouseleave=\"!visit.checked && $parent.$parent.vm.backwardMarker(visit)\" ng-class=\"{\'highlight\': visit.active,\n                   \'list-group-item-warning\': visit.status === 2,\n                   \'list-group-item-warning-dark\': visit.status === 3,\n                   \'list-group-item-danger\': visit.status === 4\n                  }\"><div class=sp-visits-left-block><div class=sp-planner-hover-options><a class=sp-planner-hover-option ui-sref=\"^.visits-detail({visitId: \'{{::visit.id}}\', fstatus: {{::vm.activeFilter}}, page: vm.currentPage})\" ng-click=$event.stopPropagation();><i class=sp-icon-edit></i> </a><a class=sp-planner-hover-option ng-click=\"vm.removeAlert($event, visit)\"><i class=sp-icon-close></i> </a><a class=sp-planner-hover-option ng-click=vm.remove(visit)><i class=sp-icon-delete></i></a></div></div><div class=sp-visits-right-block><div class=\"sp-visits-content-wrapper sp-text-ellipsis\"><div class=\"list-group-item-heading sp-text-ellipsis\">{{::visit.title}}</div><div class=list-group-item-text><span ng-if=!visit.addressStatistics.status class=\"sp-icon-map-pin list-group-item-text-left\"></span><div class=sp-stats-address-visit ng-if=visit.addressStatistics.status ng-class=\"{\n                  \'new-address\': visit.addressStatistics.status === \'new\',\n                  \'used-address\': visit.addressStatistics.status === \'used\',\n                  \'failed-address\': visit.addressStatistics.status === \'warn_qty_failed\',\n                  \'warn_diff_loc\': visit.addressStatistics.status === \'warn_diff_loc\'\n                }\" uib-tooltip=\"{{(\'Visits.address_stats.tooltips.\' + visit.addressStatistics.status) | translate }}\" tooltip-placement=top-left><div ng-include=vm.getAlertStatsIconURL(visit) class=sp-stats-icon></div><div class=sp-stats-text id=visit_address_stats_{{visit.id}} translate=Visits.address_stats.status.{{visit.addressStatistics.status}}></div></div><div class=\"list-group-item-text-right sp-text-ellipsis\"><span>{{::visit.address}}</span></div></div><div ng-if=visit.reference class=list-group-item-text><visit-reference class=visit-reference-container visit=visit></visit-reference></div><div ng-if=\"(vm.enableNotesInRouteDesigner && visit.notes.trim() !== \'\')\" class=list-group-item-text><span class=\"sp-icon-notes list-group-item-text-left\"></span><div class=\"list-group-item-text-right sp-text-ellipsis\"><span>{{::visit.notes}}</span></div></div><div ng-if=\"(\n              vm.mustShowVisitWindows(visit.windowStart, visit.windowEnd) ||\n              vm.mustShowVisitWindows(visit.windowStart2, visit.windowEnd2)\n            )\" class=list-group-item-text><span class=\"sp-icon-ventana-horaria list-group-item-text-left\" ng-class=\"{\'sp-text-color-danger\': $ctrl.data.visitObj.timeError}\"></span><div class=\"list-group-item-text-right sp-text-ellipsis\"><span>{{vm.displayWindows(visit)}}</span></div></div><items-summary-in-visit-card items=visit.items></items-summary-in-visit-card><div class=sp-container-load-visits><div class=load-visit><div class=icon ng-include=\"\'assets/images/weight/weight_filled_16.svg\'\"></div><span>{{visit.load | formatNumber:2:\'.\':\',\'}}</span></div><div class=load-visit><div class=icon ng-include=\"\'assets/images/volume/volume_filled_16.svg\'\"></div><span>{{visit.load2 | formatNumber:2:\'.\':\',\'}}</span></div><div class=load-visit><div class=icon ng-include=\"\'assets/images/money/money_filled_16.svg\'\"></div><span>{{visit.load3 | formatNumber:2:\'.\':\',\'}}</span></div><div class=load-visit ng-if=vm.isMixLoadAddonEnabled><div class=icon ng-include=\"\'assets/images/box_filled.svg\'\"></div><span>{{visit.load4 | formatNumber:2:\'.\':\',\'}}</span></div></div></div><div class=sp-visits-alerts-wrapper><div ng-if=visit.addedInCurrentRouting class=sp-planner-new-visit-element uib-tooltip=\"{{ \'Visits.tooltips.new_visit\' | translate }}\"></div><div class=sp-alert-location-container ng-if=\"visit.addressStatistics.status === \'warn_diff_loc\'\" ng-click=\"vm.changeLocation(visit); $event.stopPropagation()\"><div class=change-location-icon ng-if=!visit.addressStatistics.was_location_changed ng-include=\"\'assets/images/change-horizontal.svg\'\" uib-tooltip=\"{{(\'Visits.address_stats.tooltips.change_location\') | translate }}\"></div><div class=undo-icon ng-if=visit.addressStatistics.was_location_changed ng-include=\"\'assets/images/undo.svg\'\" uib-tooltip=\"{{(\'Visits.address_stats.tooltips.undo_change_location\') | translate }}\"></div></div></div></div></div></div></div><div id=visitsListForRouting class=\"list-group sp-planner-visit-list\" ng-if=vm.shouldShowVisitSections()><div><!-- Visitas por rutear --><div class=collapsible-section><div class=\"section-header padding-t-b-10\" ng-click=vm.toggleVisitsForRoutingCollapse()><div class=sp-visit-checkbox-container><div class=sp-visit-checkbox><input type=checkbox ng-model=vm.allVisitsForRoutingChecked ng-click=\"$event.stopPropagation(); vm.checkAllVisitsForRouting();\"><label><span class=sp-icon-check></span></label></div><span style=\"color: #4C3BEF\">{{(\'Visits.visits_for_routing\' | translate: {totalVisitsForRouting: vm.totalLoadedVisitForRoutingCards })}} </span><!-- Botón de visibilidad para visitas por rutear --><div class=toggle-visibility ng-click=vm.toggleVisitsForRoutingVisibility($event)><div ng-include=\"\'/assets/images/show_hide/show_icon.svg\'\" class=visiblity-icon ng-show=vm.showVisitsForRoutingOnMap style=\"color: #4C3BEF\"></div><div ng-include=\"\'/assets/images/show_hide/hide_icon.svg\'\" class=visiblity-icon ng-show=!vm.showVisitsForRoutingOnMap style=\"color: #4C3BEF\"></div></div><div class=collapse-icon ng-class=\"{\'rotated\': !vm.isVisitsForRoutingCollapsed}\"><div ng-if=vm.isVisitsForRoutingCollapsed ng-include=\"\'/assets/images/navegation_down/navegation_down_16.svg\'\"></div><div ng-if=!vm.isVisitsForRoutingCollapsed ng-include=\"\'/assets/images/navegation_up/navegation_up_16.svg\'\" class=collapse-icon></div></div></div></div><div uib-collapse=vm.isVisitsForRoutingCollapsed><div class=sp-planner-scrollable-content style=\"max-height: 300px; overflow-y: auto\"><!-- Contenido de visitas por rutear --><div id={{::visit.id}} ng-repeat=\"visit in vm.visitForRoutingCardsCurrentPage\" class=list-group-item-visit ng-click=$event.stopPropagation()><div class=sp-visit-checkbox-container ng-class=\"{\'visit-not-editable\' : !vm.canVisitBeEditedOrRemoved(visit) && vm.areVisitsEditable}\"><div class=sp-visit-checkbox ng-if=vm.canVisitBeEditedOrRemoved(visit)><input type=checkbox ng-model=visit.checked ng-click=\"vm.checkVisit(visit); $event.stopPropagation()\"><label><span class=sp-icon-check></span></label></div></div><div class=\"list-group-item sp-planner-default-position\" ng-click=vm.activateVisit(visit) ng-mouseenter=$parent.$parent.vm.highlightMarker(visit) ng-mouseleave=\"!visit.checked && $parent.$parent.vm.backwardMarker(visit)\" ng-class=\"{\'highlight\': visit.active,\n                          \'list-group-item-warning\': visit.status === 2,\n                          \'list-group-item-warning-dark\': visit.status === 3,\n                          \'list-group-item-danger\': visit.status === 4\n                          }\"><div class=sp-visits-left-block><div class=sp-planner-hover-options><a class=sp-planner-hover-option ui-sref=\"^.visits-detail({visitId: \'{{::visit.id}}\', fstatus: {{::vm.activeFilter}}, page: vm.currentPage})\" ng-click=$event.stopPropagation();><i class=sp-icon-edit></i> </a><a class=sp-planner-hover-option ng-click=\"vm.removeAlert($event, visit)\"><i class=sp-icon-close></i> </a><a class=sp-planner-hover-option ng-click=\"vm.remove(visit); $event.stopPropagation()\"><i class=sp-icon-delete></i></a></div><!-- end dp-hover-options  --></div><div class=sp-visits-right-block><div class=\"sp-visits-content-wrapper sp-text-ellipsis\"><div class=\"list-group-item-heading sp-text-ellipsis\">{{::visit.title}}</div><div class=list-group-item-text><span ng-if=!visit.addressStatistics.status class=\"sp-icon-map-pin list-group-item-text-left\"></span><div class=sp-stats-address-visit ng-if=visit.addressStatistics.status ng-class=\"{\n                          \'new-address\': visit.addressStatistics.status === \'new\',\n                          \'used-address\': visit.addressStatistics.status === \'used\',\n                          \'failed-address\': visit.addressStatistics.status === \'warn_qty_failed\',\n                          \'warn_diff_loc\': visit.addressStatistics.status === \'warn_diff_loc\'\n                        }\" uib-tooltip=\"{{(\'Visits.address_stats.tooltips.\' + visit.addressStatistics.status) | translate }}\" tooltip-placement=top-left><div ng-include=vm.getAlertStatsIconURL(visit) class=sp-stats-icon></div><div class=sp-stats-text id=visit_address_stats_{{visit.id}} translate=Visits.address_stats.status.{{visit.addressStatistics.status}}></div></div><div class=\"list-group-item-text-right sp-text-ellipsis\"><span>{{::visit.address}}</span></div></div><div ng-if=visit.reference class=list-group-item-text><visit-reference class=visit-reference-container visit=visit></visit-reference></div><div ng-if=\"(vm.enableNotesInRouteDesigner && visit.notes.trim() !== \'\')\" class=list-group-item-text><span class=\"sp-icon-notes list-group-item-text-left\"></span><div class=\"list-group-item-text-right sp-text-ellipsis\"><span>{{::visit.notes}}</span></div></div><div ng-if=\"(\n                      vm.mustShowVisitWindows(visit.windowStart, visit.windowEnd) ||\n                      vm.mustShowVisitWindows(visit.windowStart2, visit.windowEnd2)\n                    )\" class=list-group-item-text><span class=\"sp-icon-ventana-horaria list-group-item-text-left\" ng-class=\"{\'sp-text-color-danger\': $ctrl.data.visitObj.timeError}\"></span><div class=\"list-group-item-text-right sp-text-ellipsis\"><span>{{vm.displayWindows(visit)}}</span></div></div><items-summary-in-visit-card items=visit.items></items-summary-in-visit-card><div class=sp-container-load-visits><div class=load-visit><div class=icon ng-include=\"\'assets/images/weight/weight_filled_16.svg\'\"></div><span>{{visit.load | formatNumber:2:\'.\':\',\'}}</span></div><div class=load-visit><div class=icon ng-include=\"\'assets/images/volume/volume_filled_16.svg\'\"></div><span>{{visit.load2 | formatNumber:2:\'.\':\',\'}}</span></div><div class=load-visit><div class=icon ng-include=\"\'assets/images/money/money_filled_16.svg\'\"></div><span>{{visit.load3 | formatNumber:2:\'.\':\',\'}}</span></div></div></div><div class=sp-visits-alerts-wrapper><div ng-if=visit.addedInCurrentRouting class=sp-planner-new-visit-element uib-tooltip=\"{{ \'Visits.tooltips.new_visit\' | translate }}\"></div><div class=sp-alert-location-container ng-if=\"visit.addressStatistics.status === \'warn_diff_loc\'\" ng-click=\"vm.changeLocation(visit); $event.stopPropagation()\"><div class=change-location-icon ng-if=!visit.addressStatistics.was_location_changed ng-include=\"\'assets/images/change-horizontal.svg\'\" uib-tooltip=\"{{(\'Visits.address_stats.tooltips.change_location\') | translate }}\"></div><div class=undo-icon ng-if=visit.addressStatistics.was_location_changed ng-include=\"\'assets/images/undo.svg\'\" uib-tooltip=\"{{(\'Visits.address_stats.tooltips.undo_change_location\') | translate }}\"></div></div></div></div></div></div></div></div><div class=row ng-if=\"vm.totalLoadedVisitForRoutingCards > vm.VISIT_CARDS_PER_PAGE && !vm.filterHandler.activeFilter\"><div class=\"col-sm-12 text-center sp-pagination-row\" ng-click=$event.stopPropagation()><ul uib-pagination total-items=vm.totalLoadedVisitForRoutingCards ng-model=vm.currentVisitForRoutingCardsPage items-per-page=vm.VISIT_CARDS_PER_PAGE max-size=3 class=pagination-sm boundary-links=true rotate=false ng-change=vm.refreshVisits() first-text=\"{{ \'pagination.firstText\' | translate }}\" last-text=\"{{ \'pagination.lastText\' | translate }}\" next-text=\"{{ \'pagination.nexText\' | translate }}\" previous-text=\"{{ \'pagination.previousText\' | translate }}\"></ul></div></div></div></div></div><div id=visitsListsPendings class=\"list-group sp-planner-visit-list\" ng-if=vm.shouldShowVisitSections()><div><!-- Visitas pendientes --><div class=collapsible-section><div class=\"section-header padding-t-b-10\" ng-click=vm.togglePendingVisitsCollapse()><div class=sp-visit-checkbox-container><div class=sp-visit-checkbox><input type=checkbox ng-model=vm.allPendingVisitsChecked ng-click=\"$event.stopPropagation(); vm.checkAllPendingVisits()\"><label><span class=sp-icon-check></span></label></div><span style=\"color: #4C3BEF\">{{(\'Visits.pending_visits\' | translate: {totalPendingVisits: vm.totalLoadedVisitCards })}}</span><!-- Botón de visibilidad para visitas pendientes --><div class=toggle-visibility ng-click=vm.togglePendingVisitsVisibility($event)><div ng-include=\"\'/assets/images/show_hide/show_icon.svg\'\" class=visiblity-icon ng-show=vm.showPendingVisitsOnMap style=\"color: #4C3BEF\"></div><div ng-include=\"\'/assets/images/show_hide/hide_icon.svg\'\" class=visiblity-icon ng-show=!vm.showPendingVisitsOnMap style=\"color: #4C3BEF\"></div></div><div class=collapse-icon ng-class=\"{\'rotated\': !vm.isPendingVisitsCollapsed}\"><div ng-if=vm.isPendingVisitsCollapsed ng-include=\"\'/assets/images/navegation_down/navegation_down_16.svg\'\"></div><div ng-if=!vm.isPendingVisitsCollapsed ng-include=\"\'/assets/images/navegation_up/navegation_up_16.svg\'\" class=collapse-icon></div></div></div><div uib-collapse=vm.isPendingVisitsCollapsed><div class=sp-planner-scrollable-content style=\"max-height: 300px; overflow-y: auto\"><!-- Listado actual visitas --><div id={{::visit.id}} ng-repeat=\"visit in vm.visitCardsCurrentPage\" class=list-group-item-visit ng-click=$event.stopPropagation()><div class=sp-visit-checkbox-container ng-class=\"{\'visit-not-editable\' : !vm.canVisitBeEditedOrRemoved(visit) && vm.areVisitsEditable}\"><div class=sp-visit-checkbox ng-if=vm.canVisitBeEditedOrRemoved(visit)><input type=checkbox ng-model=visit.checked ng-click=\"vm.checkVisit(visit); $event.stopPropagation()\"><label><span class=sp-icon-check></span></label></div></div><div class=\"list-group-item sp-planner-default-position\" ng-click=vm.activateVisit(visit) ng-mouseenter=$parent.$parent.vm.highlightMarker(visit) ng-mouseleave=\"!visit.checked && $parent.$parent.vm.backwardMarker(visit)\" ng-class=\"{\'highlight\': visit.active,\n                            \'list-group-item-warning\': visit.status === 2,\n                            \'list-group-item-warning-dark\': visit.status === 3,\n                            \'list-group-item-danger\': visit.status === 4\n                            }\"><div class=sp-visits-left-block><div class=sp-planner-hover-options><a class=sp-planner-hover-option ui-sref=\"^.visits-detail({visitId: \'{{::visit.id}}\', fstatus: {{::vm.activeFilter}}, page: vm.currentPage})\" ng-click=$event.stopPropagation();><i class=sp-icon-edit></i> </a><a class=sp-planner-hover-option ng-click=\"vm.removeAlert($event, visit)\"><i class=sp-icon-close></i> </a><a class=sp-planner-hover-option ng-click=\"vm.remove(visit); $event.stopPropagation()\"><i class=sp-icon-delete></i></a></div><!-- end dp-hover-options  --></div><div class=sp-visits-right-block><div class=\"sp-visits-content-wrapper sp-text-ellipsis\"><div class=\"list-group-item-heading sp-text-ellipsis\">{{::visit.title}}</div><div class=list-group-item-text><span ng-if=!visit.addressStatistics.status class=\"sp-icon-map-pin list-group-item-text-left\"></span><div class=sp-stats-address-visit ng-if=visit.addressStatistics.status ng-class=\"{\n                            \'new-address\': visit.addressStatistics.status === \'new\',\n                            \'used-address\': visit.addressStatistics.status === \'used\',\n                            \'failed-address\': visit.addressStatistics.status === \'warn_qty_failed\',\n                            \'warn_diff_loc\': visit.addressStatistics.status === \'warn_diff_loc\'\n                          }\" uib-tooltip=\"{{(\'Visits.address_stats.tooltips.\' + visit.addressStatistics.status) | translate }}\" tooltip-placement=top-left><div ng-include=vm.getAlertStatsIconURL(visit) class=sp-stats-icon></div><div class=sp-stats-text id=visit_address_stats_{{visit.id}} translate=Visits.address_stats.status.{{visit.addressStatistics.status}}></div></div><div class=\"list-group-item-text-right sp-text-ellipsis\"><span>{{::visit.address}}</span></div></div><div ng-if=visit.reference class=list-group-item-text><visit-reference class=visit-reference-container visit=visit></visit-reference></div><div ng-if=\"(vm.enableNotesInRouteDesigner && visit.notes.trim() !== \'\')\" class=list-group-item-text><span class=\"sp-icon-notes list-group-item-text-left\"></span><div class=\"list-group-item-text-right sp-text-ellipsis\"><span>{{::visit.notes}}</span></div></div><div ng-if=\"(\n                        vm.mustShowVisitWindows(visit.windowStart, visit.windowEnd) ||\n                        vm.mustShowVisitWindows(visit.windowStart2, visit.windowEnd2)\n                      )\" class=list-group-item-text><span class=\"sp-icon-ventana-horaria list-group-item-text-left\" ng-class=\"{\'sp-text-color-danger\': $ctrl.data.visitObj.timeError}\"></span><div class=\"list-group-item-text-right sp-text-ellipsis\"><span>{{vm.displayWindows(visit)}}</span></div></div><items-summary-in-visit-card items=visit.items></items-summary-in-visit-card><div class=sp-container-load-visits><div class=load-visit><div class=icon ng-include=\"\'assets/images/weight/weight_filled_16.svg\'\"></div><span>{{visit.load | formatNumber:2:\'.\':\',\'}}</span></div><div class=load-visit><div class=icon ng-include=\"\'assets/images/volume/volume_filled_16.svg\'\"></div><span>{{visit.load2 | formatNumber:2:\'.\':\',\'}}</span></div><div class=load-visit><div class=icon ng-include=\"\'assets/images/money/money_filled_16.svg\'\"></div><span>{{visit.load3 | formatNumber:2:\'.\':\',\'}}</span></div></div></div><div class=sp-visits-alerts-wrapper><div ng-if=visit.addedInCurrentRouting class=sp-planner-new-visit-element uib-tooltip=\"{{ \'Visits.tooltips.new_visit\' | translate }}\"></div><div class=sp-alert-location-container ng-if=\"visit.addressStatistics.status === \'warn_diff_loc\'\" ng-click=\"vm.changeLocation(visit); $event.stopPropagation()\"><div class=change-location-icon ng-if=!visit.addressStatistics.was_location_changed ng-include=\"\'assets/images/change-horizontal.svg\'\" uib-tooltip=\"{{(\'Visits.address_stats.tooltips.change_location\') | translate }}\"></div><div class=undo-icon ng-if=visit.addressStatistics.was_location_changed ng-include=\"\'assets/images/undo.svg\'\" uib-tooltip=\"{{(\'Visits.address_stats.tooltips.undo_change_location\') | translate }}\"></div></div></div></div></div></div><!-- end list-group-item --></div></div><div class=row ng-if=\"vm.totalLoadedVisitCards > vm.VISIT_CARDS_PER_PAGE && !vm.filterHandler.activeFilter\"><div class=\"col-sm-12 text-center sp-pagination-row\" ng-click=$event.stopPropagation()><ul uib-pagination total-items=vm.totalLoadedVisitCards ng-model=vm.currentVisitCardsPage items-per-page=vm.VISIT_CARDS_PER_PAGE max-size=3 class=pagination-sm boundary-links=true rotate=false ng-change=vm.refreshVisits() first-text=\"{{ \'pagination.firstText\' | translate }}\" last-text=\"{{ \'pagination.lastText\' | translate }}\" next-text=\"{{ \'pagination.nexText\' | translate }}\" previous-text=\"{{ \'pagination.previousText\' | translate }}\"></ul></div></div></div></div></div></div><!-- end list-group --></div><!-- end sp-planner-scrollable --><div class=row ng-if=\"vm.totalLoadedVisitCards > vm.VISIT_CARDS_PER_PAGE && !vm.filterHandler.activeFilter && !vm.positiveSelectionVisitsEnabled\"><div class=\"col-sm-12 text-center sp-pagination-row\" ng-if=\"vm.visitCardsCurrentPage.length > 0\"><ul uib-pagination total-items=vm.totalLoadedVisitCards ng-model=vm.currentVisitCardsPage items-per-page=vm.VISIT_CARDS_PER_PAGE max-size=3 class=pagination-sm boundary-links=true rotate=false ng-change=vm.refreshVisits() first-text=\"{{ \'pagination.firstText\' | translate }}\" last-text=\"{{ \'pagination.lastText\' | translate }}\" next-text=\"{{ \'pagination.nexText\' | translate }}\" previous-text=\"{{ \'pagination.previousText\' | translate }}\"></ul></div></div><div class=\"sp-planner-footer sp-planner-footer__wrapper\"><div><div class=sp-planner-footer-confirmation ng-if=vm.showNextStepCheckbox()><div class=checkbox><label><input type=checkbox ng-model=vm.nextStep> <span class=\"text-muted sp-planner-footer-confirmation-text\" translate=Visits.warning_msg></span></label></div></div><a ui-sref=^.vehicles-list class=\"btn pull-left sp-back-button\"><i class=sp-icon-chevron-left></i> <span translate=Planner.btn_back></span></a><div class=\"btn-group pull-right\" uib-dropdown><button id=split-button type=button class=\"btn btn-primary\" ng-disabled=vm.isGoNextDisabled() ng-click=vm.goNext() translate=Visits.optimize_btn></button> <button type=button class=\"btn btn-primary\" ng-disabled=vm.isGoNextDisabled() uib-dropdown-toggle><span class=caret></span></button><ul class=\"dropdown-multiselection dropdown-up dropdown-menu sp-dropdown-container dropdown-routing\" uib-dropdown-menu aria-haspopup=true aria-expanded=false><div ng-if=vm.enableRadialRouting class=sp-routing-title translate=Routes.optimize.routing_options></div><li ng-repeat=\"optimizationOption in vm.DROPDOWN_OPTIMIZATION_OPTIONS\" role=menuitem ng-if=vm.isAllowedToDisplayOption(optimizationOption)><div class=sp-optimize-option><div class=sp-checkbox-select-all ng-style=\"vm.isOptimizationOptionDisabled(optimizationOption) && vm.DISABLED_CHECKBOX_STYLE\"><input type=checkbox class=sp-checkbox-input ng-model=vm.optimizationOptions[optimizationOption] ng-true-value={{vm.getOptimizationOptionTrueValue(optimizationOption)}} ng-false-value={{vm.getOptimizationOptionFalseValue(optimizationOption)}} ng-click=$event.stopPropagation(); ng-change=vm.checkOptionOptimize(optimizationOption) ng-disabled=vm.isOptimizationOptionDisabled(optimizationOption)><label><span class=sp-icon-check></span></label></div><div class=sp-label ng-style=\"vm.isOptimizationOptionDisabled(optimizationOption) && vm.DISABLED_LABEL_STYLE\"><span ng-style=\"vm.isOptimizationOptionDisabled(optimizationOption) && vm.DISABLED_SPAN_STYLE\" ng-click=\"vm.selectedOptimizationOption(optimizationOption, $event)\">{{\'Routes.optimize.\' + optimizationOption | translate}} </span><i ng-if=!vm.isOptimizationOptionDisabled(optimizationOption) class=\"sp-icon-info capacity-icon\" uib-tooltip=\"{{\'General.optimization.tooltip.\' + optimizationOption | translate}}\" tooltip-placement=left></i> <i ng-if=vm.isOptimizationOptionDisabled(optimizationOption) class=\"sp-icon-info capacity-icon\" tooltip-placement=left></i></div></div></li><div ng-if=vm.routingSequencers.length><div class=sp-routing-title translate=Routes.optimize.radial_options></div><li ng-repeat=\"sequencer in vm.routingSequencers\"><div class=sp-optimize-option style=\"width: 100%\" ng-click=\"vm.selectSequencerRoutingOption(sequencer.value, $event)\"><div class=sp-radio><input type=radio ng-model=vm.sequencerRoutingOption ng-value=sequencer.value><label><span class=sp-icon-check></span></label></div><div class=sp-label style=\"width: 70%\"><span translate=Routes.optimize.{{sequencer.option}}></span></div><div><i class=\"sp-icon-info capacity-icon\" uib-tooltip=\"{{\'General.optimization.tooltip.\' + sequencer.option | translate}}\" tooltip-placement=left></i></div></div></li></div></ul></div></div><div ng-if=\"vm.isAllowedToDisplayOption(\'on_foot\') && !vm.isOnFootRoutingDisabled\" class=sp-planner-footer__message><span translate=Planner.on_foot_option></span> <span translate=Routes.optimize.on_foot></span></div></div>");
$templateCache.put("app/planner/visits/visits-modal.html","<div class=\"info modal-content\"><div class=\"modal-header modal-header-danger\"><button type=button class=close ng-click=$dismiss()>&times;</button><h2 class=modal-title translate=Visits.no_visits></h2></div><div class=modal-body><p translate=Visits.no_visits_for_date></p><p><span translate=Visits.please></span> <a ui-sref=^ ui-sref-opts=\"{location: \'replace\'}\" ng-click=$dismiss() translate=Visits.other_date></a> <span translate=Visits.or_go_to></span> <a ui-sref=^ ng-click=$dismiss() translate=Visits.orders></a> <span translate=Visits.to_add_new_visits></span></p></div></div><!-- end modal-content -->");
$templateCache.put("app/planner/visits/visits-remove-error-visits-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Visits.delete_visits></h3></div><div class=modal-body><p translate=Visits.delete_error_visits_message></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Visits.close></button> <button type=button class=\"btn btn-danger\" ng-click=\"removeErrorVisits(); closeThisDialog(0)\" translate=Visits.delete></button></div></div>");
$templateCache.put("app/planner/visits/visits-remove-route-modal.html","<div class=\"sp-modal-content sp-modal-visit-remove-route\"><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Visits.attention></h3></div><div class=modal-body><center><p class=sp-modal-visit-remove-route-title translate=Visits.remove_route_optimize_1></p></center><div class=row><!-- check for display --><div ng-if=\"vm.isEditingPlan && vm.isPositiveSelectionVisitsActive && !vm.isAllVisitsChecked\" class=\"col-sm-12 positive-selected-visits\"><span>{{(\'Visits.positive_selection_visits_active\' | translate:{checkedCount: vm.checkedCount, totalCount: vm.totalCount})}}</span></div><div class=col-sm-12><div ng-if=!vm.hasPlanRoutesProcessed class=sp-modal-visit-remove-route-item><div class=sp-modal-visit-remove-route-head ng-click=vm.updateDistanceToJoinVisitsMsgVisibility()><div class=sp-radio><input type=radio id=overwrite_plan class=sp-checkbox-input ng-model=vm.action ng-value=\"\'REOPTIMIZE_AND_OVERWRITE_PLAN\'\"><label><span class=sp-icon-check></span></label></div><label class=no-bold for=overwrite_plan translate=Visits.remove_route_overwrite_routes_option></label></div><p class=sp-modal-visit-remove-route-description translate=Visits.remove_route_optimize_2></p></div></div><div class=col-sm-12><div class=sp-modal-visit-remove-route-item><div class=sp-modal-visit-remove-route-head ng-click=vm.updateDistanceToJoinVisitsMsgVisibility()><div class=sp-radio><input type=radio id=keep_plan class=sp-checkbox-input ng-model=vm.action ng-value=\"\'KEEP_PLAN_AND_REOPTIMIZE\'\"><label><span class=sp-icon-check></span></label></div><label class=no-bold for=keep_plan translate=Visits.remove_route_keep_routes_option></label></div><p class=sp-modal-visit-remove-route-description translate=Visits.remove_route_optimize_3></p></div></div><div class=col-sm-12 ng-if=vm.incrementalRouting><div class=sp-modal-visit-remove-route-item><div class=sp-modal-visit-remove-route-head ng-click=vm.updateDistanceToJoinVisitsMsgVisibility()><div class=sp-radio><input type=radio id=route_partial class=sp-checkbox-input ng-model=vm.action ng-value=\"\'REOPTIMIZE_PARTIALS\'\"><label><span class=sp-icon-check></span></label></div><label class=no-bold for=route_partial translate=Visits.remove_route_keep_routes_partials></label></div><p class=sp-modal-visit-remove-route-description translate=Visits.remove_route_optimize_4></p></div><div class=incremental-routing-selection-message ng-if=vm.showMsgForDistanceToJoinVisits><div class=icon><i class=sp-icon-info></i></div><div class=msg-content><span class=highlight-text translate=Visits.incremental_routing_selection_message.part1></span> <span translate=Visits.incremental_routing_selection_message.part2></span> <span class=highlight-text translate=Visits.incremental_routing_selection_message.part3></span> <span translate=Visits.incremental_routing_selection_message.part4></span></div></div></div><div ng-if=\"vm.isEditingPlan && vm.isPositiveSelectionVisitsActive && !vm.isAllVisitsChecked\" class=\"col-sm-12 positive-selected-visits\"><p translate=Visits.modal_warning_checked_visits.important></p><span translate=Visits.positive_selection_visits_active_note></span></div></div></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Visits.remove_route_cancel></button> <button type=button class=\"btn btn-success\" ng-click=vm.executeAction(closeThisDialog); ng-disabled=\"vm.action === null\" translate=Visits.remove_route_accept></button></div></div>");
$templateCache.put("app/planner/visits/visits-remove-warning-visits-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Visits.delete_visits></h3></div><div class=modal-body><p translate=Visits.delete_warning_visits_message></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Visits.close></button> <button type=button class=\"btn btn-danger\" ng-click=\"removeWarningVisits(); closeThisDialog(0)\" translate=Visits.delete></button></div></div>");
$templateCache.put("app/planner/visits/visits-save-bulk-edit-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Visits.bulk_edit></h3></div><div class=modal-body><p>{{(\'Visits.bulk_edit_warning\' | translate:{totalVisitsToEdit: totalVisitsToEdit})}}</p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Planner.btn_cancel></button> <button type=button class=\"btn btn-danger\" ng-click=\"save(); closeThisDialog(0)\" translate=Planner.btn_accept></button></div></div>");
$templateCache.put("app/planner/visits/visits-warning-checked-visits-modal.html","<div class=\"sp-modal-content modal-header-warning-info\"><div class=modal-header><h3 class=modal-title><strong translate=Visits.modal_warning_checked_visits.title></strong></h3></div><div class=modal-body><h5><strong translate=Visits.modal_warning_checked_visits.subtitle></strong></h5><span class=message-warning>{{(\'Visits.modal_warning_checked_visits.message\' | translate:{checkedCount: vm.checkedCount, totalCount: vm.totalCount})}}</span><p class=cta-continue>{{(\'Visits.modal_warning_checked_visits.cta_continue\' | translate: {checkedCount: vm.checkedCount})}}</p><div class=important-note><span translate=Visits.modal_warning_checked_visits.important></span><p translate=Visits.modal_warning_checked_visits.important_note></p></div></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Planner.btn_cancel></button> <button type=button class=\"btn btn-success\" ng-click=vm.executeAction(closeThisDialog) translate=Planner.btn_accept></button></div></div>");
$templateCache.put("app/planner/visits/visits-wave-routing-modal.html","<div class=sp-modal-content><div class=wave-routing-header><h3 class=\"modal-title wave-routing-title\" translate=Visits.wave_routing_modal.title></h3></div><div class=wave-routing-modal><p class=wave-routing-subtitle translate=Visits.wave_routing_modal.subtitle></p><div class=\"row wave-routing-time-box\"><div class=col-sm-12><span translate=Visits.wave_routing_modal.time_input_title></span></div><div class=col-sm-5><input type=text class=\"{{vm.timeFormatError ? vm.invalidTimeInputCssClass : vm.timeInputCssClass}}\" ng-model=vm.cutoffTime ng-blur=vm.validateTimeFormat(vm.cutoffTime)></div><div class=col-sm-12><p ng-if=vm.timeFormatError class=sp-settings-invalid-help-block translate=Visits.wave_routing_modal.time_format_error></p></div></div><div class=\"row wave-routing-checkbox\" ng-if=vm.editingPlan><input type=checkbox class=sp-checkbox-input ng-model=vm.lastWave> <span translate=Visits.wave_routing_modal.checkbox_message></span></div></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Planner.btn_cancel></button> <button type=button class=\"btn btn-success\" ng-click=vm.executeAction(closeThisDialog); ng-disabled=vm.timeFormatError translate=Planner.btn_continue></button></div></div>");
$templateCache.put("app/planner/visits/visits-workday-exceeded-visits-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Visits.not_available_vehicles></h3></div><div class=modal-body><p translate=Visits.error_workday_exceeded></p><ul><li ng-repeat=\"vehicle in vehicles\">{{vehicle.name}}</li></ul></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Visits.close></button></div></div>");
$templateCache.put("app/settings/account/account.html","<div class=left-side><h1 class=section-title translate=customization></h1><section><div class=sp-header><h4 class=sp-header-title translate=Account.options></h4></div><div class=\"panel panel-default sp-form panel-account-settings\"><div class=row><div class=\"col-xs-12 col-sm-4 col-sm-offset-4 text-center\"><label class=control-label translate=Account.default_values></label></div></div><form name=vm.form ng-submit=vm.saveAccountConfigs() novalidate><!-- Send GPS --><div ng-if=vm.accountConfigs.hasOwnProperty(vm.SEND_GPS) class=\"row tooltip-input\"><div class=\"col-xs-12 col-sm-4\"><label translate=\"{{\'Account.setupOptions.send_gps\'}}\"></label></div><div class=\"col-xs-12 col-sm-4 text-center\"><sp-switch ng-model=vm.accountConfigs[vm.SEND_GPS]></sp-switch></div><div class=\"col-xs-12 col-sm-4\"><a tooltip-placement=right tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Account.tooltipsOptions.send_gps\' | translate}}\"><i class=\"sp-icon-info tooltip-icon\"></i></a></div></div><!-- Enable Observations --><div ng-if=vm.accountConfigs.hasOwnProperty(vm.ENABLE_OBSERVATIONS) class=\"row tooltip-input\"><div class=\"col-xs-12 col-sm-4\"><label translate=\"{{\'Account.setupOptions.enable_observations\'}}\"></label></div><div class=\"col-xs-12 col-sm-4 text-center\"><sp-switch ng-model=vm.accountConfigs[vm.ENABLE_OBSERVATIONS]></sp-switch></div><div class=\"col-xs-12 col-sm-4\"><a tooltip-placement=right tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Account.tooltipsOptions.enable_observations\' | translate}}\"><i class=\"sp-icon-info tooltip-icon\"></i></a></div></div><button type=submit ng-disabled=vm.form.$invalid class=\"btn btn-success btn-large col-sm-2 btn-account-settings-save\">{{\'Account.btn_save\' | translate}}</button></form></div></section></div>");
$templateCache.put("app/settings/billing/change-plan.html","<div class=billing-module><legend><i class=\"fa fa-credit-card\"></i> <span translate=Billing.title_2></span> - <span translate=Billing.change_plan_lbl></span></legend><form class=form-horizontal name=changePlanForm novalidate><div class=form-group><label class=\"col-sm-2 control-label\" for=vehiclesQty translate=Billing.n_vehicles_lbl></label><div class=col-sm-2><input type=number class=\"col-sm-2 form-control\" id=vehiclesQty name=vehiclesQty min={{vm.minVehiclesQty}} max=1000 ng-model=vm.vehiclesQty></div></div><div class=form-group ng-show=changePlanForm.vehiclesQty.$error><div class=\"col-sm-offset-2 col-sm-10 text-muted\"><small ng-show=changePlanForm.vehiclesQty.$error.min><i class=\"fa fa-question-circle\"></i> <span translate=Billing.error_min_vehicles_lbl_1></span> <a ui-sref=settings.vehicles translate=Billing.error_min_vehicles_lbl_2></a>. <a href=“vehicles.html”></a> </small><small ng-show=changePlanForm.vehiclesQty.$error.max><i class=\"fa fa-question-circle\"></i> <span translate=Billing.error_max_vehicles_lbl></span></small></div></div><div class=form-group><label class=\"col-sm-2 control-label\" for=amount translate=Billing.Amount_lbl></label><div class=col-sm-10><p class=form-control-static>{{vm.vehiclesQty * vm.AMOUNT_PER_VEHICLE | currency:\"USD$\"}}</p></div></div><div class=form-group><div class=\"col-sm-offset-2 col-sm-10\"><button type=button class=\"btn btn-primary\" ng-disabled=\"changePlanForm.$invalid || vm.updating\" ng-click=vm.updatePlan(vm.vehiclesQty)><!-- The \"span\" solves the animation duration from font-awesome spinner --> <span ng-show=vm.updating><i class=\"fa fa-spinner fa-spin\"></i> </span><span translate=Billing.update_plan_btn></span></button></div></div></form></div>");
$templateCache.put("app/settings/billing/info.html","<div class=billing-module><legend><i class=\"fa fa-credit-card\"></i> <span translate=Billing.title_2></span></legend><p ng-if=\"vm.user.account.status === \'trialing\'\"><span translate=Billing.trial_expire></span> {{ vm.trialExpireTime }}</p><div ng-if=\"vm.user.account.status === \'trialing\' || vm.user.account.status === \'canceled\'\"><a class=\"btn btn-primary\" ui-sref=^.upgrade><span translate=Billing.upgrade></span></a></div><div ng-if=\"vm.user.account.status === \'active\' || vm.user.account.status === \'past_due\'\"><p><span translate=Billing.max_vehicles_lbl></span>: {{vm.user.account.plan_quantity}} <small><a ui-sref=^.change-plan><span translate=Billing.change_btn></span></a></small></p><p><span translate=Billing.next_billing_lbl></span>: {{vm.nextBillingCycle}}</p><p><span translate=Billing.credit_card_lbl></span>: xxxx xxxx xxxx {{vm.user.account.card_last4}} <small><a href=\"\" ng-hide=vm.changingCard stripe-checkout=vm.processChangeCard data-key=pk_test_zyWHJjXkDVo3APH5z0c9gd5H data-allow-remember-me=false data-locale=auto data-name=SimpliRoute data-image=/assets/images/logo-login.png data-description=\"\" data-amount=\"\" data-email={{vm.user.email}} data-panel-label=\"{{\'Billing.change_card\' | translate }}\"><span translate=Billing.change_btn></span> </a><span class=\"alert alert-info\" ng-show=vm.changingCard><i class=\"fa fa-spinner fa-spin\"></i> <span translate=Billing.processing_lbl></span></span></small></p><button type=button class=\"btn btn-default\" ng-hide=vm.canceling ng-click=vm.cancel()><span translate=Billing.cancel_btn></span></button> <span class=\"alert alert-info\" ng-show=vm.canceling><i class=\"fa fa-spinner fa-spin\"></i> <span translate=Billing.canceling_lbl></span></span></div></div>");
$templateCache.put("app/settings/billing/upgrade.html","<div class=billing-module><legend><i class=\"fa fa-credit-card\"></i> <span translate=Billing.title_2></span> - <span translate=Billing.upgrading_lbl></span></legend><form class=form-horizontal name=upgradeForm novalidate><div class=form-group><label class=\"col-sm-2 control-label\" for=vehiclesQty><span translate=Billing.n_vehicles_lbl></span></label><div class=col-sm-2><input type=number class=form-control id=vehiclesQty name=vehiclesQty min={{vm.minVehiclesQty}} max=1000 ng-model=vm.vehiclesQty></div></div><div class=form-group ng-show=upgradeForm.vehiclesQty.$error><div class=\"col-sm-offset-2 col-sm-10 text-muted\"><small ng-show=upgradeForm.vehiclesQty.$error.min><i class=\"fa fa-question-circle\"></i> <span translate=Billing.error_min_vehicles_lbl_1></span> <a ui-sref=settings.vehicles translate=Billing.error_min_vehicles_lbl_2></a>. <a href=“vehicles.html”></a> </small><small ng-show=upgradeForm.vehiclesQty.$error.max><i class=\"fa fa-question-circle\"></i> <span translate=Billing.error_max_vehicles_lbl></span></small></div></div><div class=form-group><label class=\"col-sm-2 control-label\" for=amount translate=Billing.Amount_lbl></label><div class=col-sm-10><p class=form-control-static>{{vm.vehiclesQty * vm.AMOUNT_PER_VEHICLE | currency:\"USD$\"}}</p></div></div><div class=form-group><div class=\"col-sm-offset-2 col-sm-10\"><button type=button class=\"btn btn-primary\" ng-disabled=upgradeForm.$invalid ng-hide=\"vm.upgrading || vm.upgraded\" stripe-checkout=vm.processUpgrade data-key=pk_test_zyWHJjXkDVo3APH5z0c9gd5H data-allow-remember-me=false data-locale=auto data-name=SimpliRoute data-image=/assets/images/logo-login.png data-description=\"Max {{vm.vehiclesQty}} vehicles per month\" data-amount=\"{{vm.vehiclesQty * vm.AMOUNT_PER_VEHICLE * 100}}\" data-email={{vm.user.email}} translate=Billing.upgrade_btn></button><div class=\"alert alert-info\" ng-show=vm.upgrading><i class=\"fa fa-spinner fa-spin\"></i> <span translate=Billing.processing></span></div><div class=\"alert alert-success\" ng-show=vm.upgraded translate=Billing.welcome_lbl></div></div></div></form></div>");
$templateCache.put("app/settings/components/actions-zones.html","<div class=actions-config-zones><div class=actions-header><span class=actions-title>{{$ctrl.data.title}}</span></div><div class=actions-buttons><button class=btn ng-class=\"[{\'button-active\': $ctrl.data.value}, {\'button-deactivated\': !$ctrl.data.value}]\" ng-click=\"$ctrl.data.value = true\">{{$ctrl.data.btn1.title}}</button> <button class=btn ng-class=\"[{\'button-active\': !$ctrl.data.value}, {\'button-deactivated\': $ctrl.data.value}]\" ng-click=\"$ctrl.data.value = false\">{{$ctrl.data.btn2.title}}</button></div></div>");
$templateCache.put("app/settings/components/fleetList.template.html","<div class=list-fleet><div class=fleets-header translate=Fleets.name></div><div class=fleets-body-container ng-show=\"$ctrl.data.length > 0\"><div class=\"selectable-fleet fleets-row row\" ng-class=\"{\'active-fleet\' : (fleet.id == $ctrl.selectedFleet.id)}\" ng-repeat=\"fleet in $ctrl.data\"><span ng-click=$ctrl.selectFleetHandler(fleet) class=row><span class=\"col-md-9 fleet-name\">{{fleet.name}}</span><div class=\"col-md-3 fleet-list-icons-wrapper pull-right\"><span class=col-md-6><i class=sp-icon-user></i> {{fleet.users ? fleet.users.length : \'-\' }} </span><span class=col-md-6><i class=sp-icon-vehiculos></i> {{fleet.vehicles ? fleet.vehicles.length : \'-\' }}</span></div></span></div></div><div class=\"empty-fleets row\" ng-show=\"$ctrl.data.length === 0\"><div class=empty-fleets-text translate=Fleets.no_fleets></div></div></div>");
$templateCache.put("app/settings/components/passwordPolicy.template.html","<div class=security-policies><div ng-repeat=\"(key, value) in $ctrl.validation\"><p ng-if=\"(key===\'length\' || $ctrl.data[key])\"><i ng-if=value class=\"fa fa-check-circle\" aria-hidden=true style=\"color: #32BEA8\"></i> <span translate=Security.{{key}} translate-values=\"{ length_policy: $ctrl.data.length }\" ng-style=\"{color: !value? \'#777777\' : \'#000000\'}\"></span></p></div></div>");
$templateCache.put("app/settings/components/zone.html","<div id=settings-zones-card-{{$ctrl.data.id}} class=sp-comp-zone-list><div class=sp-comp-zone-title><span uib-tooltip={{$ctrl.data.name}}>{{$ctrl.data.name}}</span> <a ng-click=$ctrl.delete() uib-tooltip=\"{{\'Zones.Delete.button_delete\' | translate}}\" id=settings-zones-card-{{$ctrl.data.id}}-delete-btn><div ng-include=\"\'/assets/images/delete_filled.svg\'\"></div></a><a ng-click=$ctrl.edit() uib-tooltip=\"{{\'Zones.button_edit\' | translate}}\" id=settings-zones-card-edit-btn-{{$ctrl.data.id}}><div ng-include=\"\'/assets/images/edit_filled.svg\'\"></div></a></div><div class=sp-comp-zone-map><static-map width=320 height=220 zone=$ctrl.zone map-provider=$ctrl.mapProvider></static-map></div><div class=sp-comp-zone-footer><div class=sp-zone-vehicles id=settings-zones-card-{{$ctrl.data.id}}-total-vehicles><div class=icon-zone-footer ng-include=\"\'/assets/images/truck.svg\'\"></div><span class=text-zone-footer>{{$ctrl.data.vehicles.length}}</span></div><div class=sp-zone-calendar ng-if=!$ctrl.isMultidayRouteEnabled id=settings-zones-card-{{$ctrl.data.id}}-calendar><div class=icon-zone-footer ng-include=\"\'/assets/images/calendar.svg\'\"></div><span class=text-zone-footer>{{$ctrl.zoneSchedules}}</span></div><div class=sp-comp-zone-footer-enabled><toggle-switch input-id=settings-zones-card-{{$ctrl.data.id}}-enabled-switch is-active=$ctrl.data.enabled on-change=$ctrl.save(isActive)></toggle-switch></div></div></div>");
$templateCache.put("app/settings/components/zoneMap.html","<button class=\"btn btn-default sp-add-zone-button-reset\" ng-click=$ctrl.resetZone() ng-if=$ctrl.resetAvailable translate=Zones.Map.clear></button><div id=map class=sp-add-zone-map></div>");
$templateCache.put("app/settings/communication/communication-delete-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Communication.modal_delete_event_title></h3></div><div class=modal-body><p style=\"text-align: center\"><span translate=Communication.modal_message_1></span><br><span translate=Communication.modal_message_2></span></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Communication.cancel></button> <button type=button class=\"btn btn-danger\" ng-click=\"deleteAddonProperty(); closeThisDialog(0)\" translate=Communication.delete></button></div></div>");
$templateCache.put("app/settings/communication/communication-detail.html","<div class=right-side-content><div class=sp-settings-right-side-form><div class=sp-addons-detail-title><span translate=Communication.title_detail></span></div><uib-tabset active=active class=sp-addons-tab-container><!-- Tab SMS--><uib-tab index=0 heading=SMS class=sp-addons-tab-items ng-if=vm.enableSms ng-click=\"vm.navigateTab(\'sms\')\"><form name=vm.formSms><div class=\"row tab-content-row sms-header\" ng-show=vm.properties.smsBody.id><div class=\"col-md-10 tab-content-delete\"><label translate=Communication.delete_property_sms></label></div><div class=\"col-md-1 tab-content-delete-icon\"><a ng-click=\"vm.showDeleteModal([\n                  {\'addonId\': vm.properties.smsBody.addonId,\n                  \'id\': vm.properties.smsBody.id,\n                  \'key\': vm.properties.smsBody.key}\n                 ])\" href=\"\"><div class=delete-addon-btn ng-include=\"\'/assets/images/delete.svg\'\"></div></a></div></div><div class=\"row tab-content-row\"><div class=\"col-md-2 tab-content-label\"><label translate=Communication.label_sms></label></div><div class=\"col-md-9 tab-content-input\"><textarea name=inputSms ng-model=vm.properties.smsBody.value rows=3 ng-change=\"vm.updateTextPreview(\'smsBody\')\" maxlength=140 ng-required=vm.smsRequired></textarea><div ng-messages=vm.formSms.inputSms.$error class=sp-settings-invalid-help-block><div ng-message=maxlength translate=Communication.warning_text_too_large></div><div ng-message=required translate=Communication.warning_required></div></div></div></div><div class=\"row tab-content-row\"><div class=\"col-md-2 tab-content-label\"><label translate=Communication.insert></label></div><div class=\"col-md-9 tab-content-tags\"><span ng-repeat=\"(key, tag) in vm.tags\"><label ng-if=\"tag.values.sms && tag.propertyKeys[vm.addonPropertyKey]\" class=\"btn sp-btn-abilities sp-btn-default\" ng-model=tag.checked uib-btn-checkbox ng-click=\"vm.addTagToInputValue(\'smsBody\', tag.id)\">{{tag.label}}</label></span></div></div><div class=sp-addons-property-preview><div class=\"div sp-addons-detail-title\"><span translate=Communication.preview_title></span></div><div class=\"talk-bubble tri-right round btm-left-in\"><div class=talktext><p>{{vm.textSmsPreview}}</p></div></div></div></form></uib-tab><!-- Tab Email --><uib-tab index=1 heading=EMAIL class=sp-addons-tab-items ng-click=\"vm.navigateTab(\'email\')\"><form name=vm.formEmail><div class=\"row tab-content-row email-header\" ng-show=vm.properties.emailSubject.id><div class=\"col-md-10 tab-content-delete\"><label translate=Communication.delete_property_email></label></div><div class=\"col-md-1 tab-content-delete-icon\"><a ng-click=\"vm.showDeleteModal([\n                  {\'addonId\': vm.properties.emailSubject.addonId,\n                  \'id\': vm.properties.emailSubject.id,\n                  \'key\': vm.properties.emailSubject.key},\n                  {\'addonId\': vm.properties.emailBody.addonId,\n                  \'id\': vm.properties.emailBody.id,\n                  \'key\': vm.properties.emailBody.key}\n                 ])\" href=\"\"><div class=delete-addon-btn ng-include=\"\'/assets/images/delete.svg\'\"></div></a></div></div><div class=\"row tab-content-row\"><div class=\"col-md-2 tab-content-label\"><label translate=Communication.label_email_subject></label></div><div class=\"col-md-9 tab-content-input\"><input type=text name=emailSubject ng-model=vm.properties.emailSubject.value maxlength=256 ng-required=vm.emailRequired><div ng-messages=vm.formEmail.emailSubject.$error class=sp-settings-invalid-help-block><div ng-message=required translate=Communication.warning_required></div><div ng-message=maxlength translate=Communication.warning_maxlenght></div></div></div><div class=\"col-md-10 warning-tabs-subject\" ng-if=vm.repeatedSubjectTag><span translate=Communication.warning_repeated_tag></span></div></div><div class=\"row tab-content-row\"><div class=\"col-md-2 tab-content-label\"><label translate=Communication.insert></label></div><div class=\"col-md-9 tab-content-tags\"><span ng-repeat=\"(key, tag) in vm.tagsSubject\"><label ng-if=tag.propertyKeys[vm.addonPropertyKey] class=\"btn sp-btn-abilities sp-btn-default btn-tag\" ng-model=tag.checked uib-btn-checkbox ng-click=vm.addTagToInputSubjectValue(tag.id)>{{tag.label}}</label></span></div></div><div ng-if=\"vm.addonPropertyKey==\'visit_scheduled\' && vm.showExtraFields\" class=\"row tab-content-row\"><div class=\"col-md-2 tab-content-label\"><label translate=Communication.insert_extrafields></label></div><div class=\"col-md-9 tab-content-tags\"><span ng-repeat=\"(key, extraField) in vm.readTypeExtraFields\"><label class=\"btn sp-btn-abilities sp-btn-default\" ng-click=\"vm.addTagToInputValueFromExtraField(\'emailSubject\', extraField.key)\">{{extraField.label}}</label></span></div></div><div class=\"row tab-content-row\" ng-if=vm.properties.renderingType><div class=\"col-md-2 tab-content-label\"><label translate=Communication.rendering_type></label></div><div class=\"col-md-9 tab-content-tags\"><div class=sp-box-check-settings><div class=sp-box-type-communication><input type=radio ng-model=vm.properties.renderingType.value value=html> <span class=sp-checkbox-edit-communication>HTML</span></div><div class=sp-box-type-communication><input type=radio ng-model=vm.properties.renderingType.value value=pdf> <span class=sp-checkbox-edit-communication>PDF</span></div></div></div></div><div class=\"row tab-content-row text-email-body\"><div class=\"col-md-2 tab-content-label\"><label translate=Communication.label_email_msg></label></div><div class=\"col-md-9 tab-content-input\"><textarea name=emailMsg ng-model=vm.properties.emailBody.value rows=8 cols=8 ng-change=\"vm.updateTextPreview(\'emailBody\')\" ng-required=vm.emailRequired></textarea><div ng-messages=vm.formEmail.emailMsg.$error class=sp-settings-invalid-help-block><div ng-message=required translate=Communication.warning_required></div></div></div></div><div class=\"row tab-content-row\"><div class=\"col-md-2 tab-content-label\"><label translate=Communication.insert></label></div><div class=\"col-md-9 tab-content-tags\"><span ng-repeat=\"(key, tag) in vm.tags\"><label ng-if=\"tag.values.email && tag.propertyKeys[vm.addonPropertyKey]\" class=\"btn sp-btn-abilities sp-btn-default btn-tag\" ng-model=tag.checked uib-btn-checkbox ng-click=\"vm.addTagToInputValue(\'emailBody\', tag.id)\">{{tag.label}}</label></span></div></div><div ng-if=(vm.showExtraFields) class=\"row tab-content-row\"><div class=\"col-md-2 tab-content-label\"><label translate=Communication.insert_extrafields></label></div><div class=\"col-md-9 tab-content-tags\"><span ng-if=\"vm.addonPropertyKey!==\'visit_scheduled\'\" ng-repeat=\"(key, extraField) in vm.extraFields\"><label class=\"btn sp-btn-abilities sp-btn-default\" ng-click=\"vm.addTagToInputValueFromExtraField(\'emailBody\', extraField.key)\">{{extraField.label}}</label></span><span ng-if=\"vm.addonPropertyKey==\'visit_scheduled\'\" ng-repeat=\"(key, extraField) in vm.readTypeExtraFields\"><label class=\"btn sp-btn-abilities sp-btn-default\" ng-click=\"vm.addTagToInputValueFromExtraField(\'emailBody\', extraField.key)\">{{extraField.label}}</label></span></div></div><div class=\"row tab-content-row sp-communication-attachment\" ng-if=vm.enableSendAttachment><div class=\"col-md-2 tab-content-label\"><label translate=Communication.attachment></label></div><div class=col-md-9><input type=checkbox ng-model=vm.sendAttachment.value> <a tooltip-placement=right uib-tooltip=\"{{\'Communication.attachment_tooltip\' | translate}}\"><i class=sp-icon-help></i></a></div></div></form><div class=\"row email-preview-container\"><div class=\"row email-preview-title\"><label translate=Communication.send_preview_email></label></div><div class=row><tags-input ng-model=vm.emails placeholder=\"{{\'Communication.preview_email_label\' | translate}}\" class=email-tags max-tags={{MAX_PREVIEW_EMAILS_INPUT}} add-on-space=true add-on-comma=true enable-editing-last-tag=true on-tag-adding=vm.validateEmailInput($tag)></tags-input><p ng-if=vm.emailInputError.invalidFormat class=\"sp-text-color-danger error-msg\" translate=Communication.msg_error_email_valid></p><p ng-if=vm.emailInputError.maxQuantity class=\"sp-text-color-danger error-msg\"><span translate=Communication.error_max_emails_message_1></span> {{vm.maxEmails}} <span translate=Communication.error_max_emails_message_2></span></p><p ng-if=vm.emailInputError.maxLength class=\"sp-text-color-danger error-msg\" translate=Communication.error_email_length_message></p></div><div class=\"row send-email-buttom-container\"><img ng-if=vm.emailSentSuccess class=icon-preview-email ng-src=/assets/images/check-circle.svg><p ng-if=vm.emailSentSuccess class=sent-text translate=Communication.preview_email_success></p><img ng-if=vm.emailSentFailed class=icon-preview-email ng-src=/assets/images/close-circle.svg><p ng-if=vm.emailSentFailed class=sent-text translate=Communication.preview_email_failed></p><img ng-if=vm.emailNotActive class=icon-preview-email ng-src=/assets/images/close-circle.svg><p ng-if=vm.emailNotActive class=sent-text translate=Communication.preview_email_activate></p><button class=\"btn btn-send-email\" type=button ng-click=vm.processEmailPreview() translate=Communication.preview_email_buttom></button></div></div></uib-tab><!-- Tab WSP--><uib-tab index=2 heading=WHATSAPP class=sp-addons-tab-items ng-if=vm.enableWsp ng-click=\"vm.navigateTab(\'wsp\')\"><div class=wsp-selection-header><span translate=Communication.wsp_title></span> <a ng-if=vm.properties.wspBody.id ng-click=\"vm.showDeleteModal([\n            {\'addonId\': vm.properties.wspBody.addonId,\n            \'id\': vm.properties.wspBody.id,\n            \'key\': vm.properties.wspBody.key}\n           ])\" href=\"\"><div class=delete-addon-btn ng-include=\"\'/assets/images/delete.svg\'\"></div></a></div><form name=vm.formWsp><!-- Orders WSP Templates --><div class=wsp-selection-list><div class=wsp-selection-list-header ng-click=\"vm.showWspTemplates(\'orders\')\"><span translate=Communication.wsp_orders></span> <img src=../../../assets/images/arrow-down-blue.svg ng-if=\"!vm.templatesToShow[\'orders\']\"> <img src=../../../assets/images/arrow-up-blue.svg ng-if=\"vm.templatesToShow[\'orders\']\"></div><div class=wsp-selection-list-body ng-if=\"vm.templatesToShow[\'orders\']\"><div class=wsp-selection-list-item ng-repeat=\"templateNumber in vm.getIterations(vm.whatsappTemplateQuantity[vm.addonPropertyKey].orders) track by $index\"><input class=checked-wsp ng-disabled=\"vm.checkRadioWsp(vm.properties.wspBody.value, $index, \'orders\')\" id=$index type=radio name=vm.addonPropertyKey ng-value=\"buildWspTemplate(vm.addonPropertyKey, \'orders\', $index)\" ng-click=\"vm.updateWspPreview($index, \'orders\')\"><label ng-bind-html=\"vm.replaceHtml($index, \'orders\')\" class=label-wsp></label></div></div></div><!-- Services WSP Templates --><div class=wsp-selection-list><div class=wsp-selection-list-header ng-click=\"vm.showWspTemplates(\'services\')\"><span translate=Communication.wsp_services></span> <img src=../../../assets/images/arrow-down-blue.svg ng-if=\"!vm.templatesToShow[\'services\']\"> <img src=../../../assets/images/arrow-up-blue.svg ng-if=\"vm.templatesToShow[\'services\']\"></div><div class=wsp-selection-list-body ng-if=\"vm.templatesToShow[\'services\']\"><div class=wsp-selection-list-item ng-repeat=\"templateNumber in vm.getIterations(vm.whatsappTemplateQuantity[vm.addonPropertyKey].services) track by $index\"><input class=checked-wsp ng-disabled=\"vm.checkRadioWsp(vm.properties.wspBody.value, $index, \'services\')\" id=$index type=radio name=vm.addonPropertyKey ng-value=\"buildWspTemplate(vm.addonPropertyKey, \'services\', $index)\" ng-click=\"vm.updateWspPreview($index, \'services\')\"><label ng-bind-html=\"vm.replaceHtml($index, \'services\')\" class=label-wsp></label></div></div></div><!-- Visits WSP Templates --><div class=wsp-selection-list><div class=wsp-selection-list-header ng-click=\"vm.showWspTemplates(\'visits\')\"><span translate=Communication.wsp_visits></span> <img src=../../../assets/images/arrow-down-blue.svg ng-if=\"!vm.templatesToShow[\'visits\']\"> <img src=../../../assets/images/arrow-up-blue.svg ng-if=\"vm.templatesToShow[\'visits\']\"></div><div class=wsp-selection-list-body ng-if=\"vm.templatesToShow[\'visits\']\"><div class=wsp-selection-list-item ng-repeat=\"templateNumber in vm.getIterations(vm.whatsappTemplateQuantity[vm.addonPropertyKey].visits) track by $index\"><input class=checked-wsp ng-disabled=\"vm.checkRadioWsp(vm.properties.wspBody.value, $index, \'visits\')\" id=$index type=radio name=vm.addonPropertyKey ng-value=\"buildWspTemplate(vm.addonPropertyKey, \'visits\', $index)\" ng-click=\"vm.updateWspPreview($index, \'visits\')\"><label ng-bind-html=\"vm.replaceHtml($index, \'visits\')\" class=label-wsp></label></div></div></div><div class=sp-addons-property-preview><div class=\"div sp-addons-detail-title wsp\"><span translate=Communication.preview_title></span></div><div><div class=wsp-box><p>{{vm.textWspPreview}}</p></div></div></div><br></form></uib-tab></uib-tabset><div class=\"sp-settings-right-side-form-action-buttons sp-addons-property-buttons\"><div class=form-group><button class=\"btn btn-close pull-left\" type=button ng-click=vm.cancel() translate=Communication.close></button> <button ng-show=vm.tabWsp class=\"btn btn-success pull-right\" type=submit ng-click=vm.savePropertyEventHandler() ng-disabled=vm.formWsp.$invalid translate=Communication.save></button> <button ng-show=vm.tabEmail class=\"btn btn-success pull-right\" type=submit ng-click=vm.savePropertyEventHandler() ng-disabled=vm.formEmail.$invalid translate=Communication.save></button> <button ng-show=vm.tabSms class=\"btn btn-success pull-right\" type=submit ng-click=vm.savePropertyEventHandler() ng-disabled=vm.formSms.$invalid translate=Communication.save></button></div></div></div></div>");
$templateCache.put("app/settings/communication/communication.html","<link rel=stylesheet href=https://pro.fontawesome.com/releases/v5.10.0/css/all.css integrity=sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p crossorigin=anonymous><div class=left-side><h1 class=section-title translate=communications></h1><div class=sp-settings-list-container><div class=sp-settings-action-bar></div><div class=sp-settings-content-list><div class=sp-table><div class=\"sp-table-row sp-table-header\"><div class=sp-table-row-item-property><p class=title translate=Communication.title></p></div><div class=sp-table-row-item-property><i class=\"sp-icon-info title-icon\" uib-tooltip=\"{{\'Communication.tooltips.title\' | translate}}\" tooltip-placement=left></i></div></div><div cg-busy=\"{promise: vm.promiseLoading, backdrop:true, templateUrl:\'app/shared/html/loading.html\'}\" ng-if=!vm.ready style=height:200px></div><div class=sp-table-row ng-repeat=\"property in vm.addonProperties\" ng-class=\"{\'active\': vm.activeRows[property.propertyKey]}\" cg-busy=\"{promise: vm.promiseLoading, backdrop:true, templateUrl:\'app/shared/html/loading.html\'}\"><div class=sp-table-row-item-property>{{property.label}} <i class=\"sp-icon-info title-icon\" uib-tooltip=\"{{\'Communication.tooltips.\' + property.propertyKey | translate}}\" tooltip-placement=right></i></div><div class=sp-table-row-item-property><i class=\"sp-icon-email sp-icon-property\" ng-class=\"{\'sp-addons-property-active\': property.email.value != \'\'}\"></i></div><div class=sp-table-row-item-property ng-if=vm.enableSms><i class=\"sp-icon-mobile sp-icon-property\" ng-class=\"{\'sp-addons-property-active\': property.sms.value != \'\'}\"></i></div><div class=sp-table-row-item-property ng-if=vm.enableWsp><i class=\"fab fa-whatsapp sp-icon-property\" ng-class=\"{\'sp-addons-property-active\': property.wsp.value != \'\'}\"></i></div><div class=sp-table-row-item-property><a href=\"\" ng-click=\"vm.changeStateToDetail(property.addonId, property.propertyKey);\" class=sp-property-edit><i class=sp-icon-edit></i></a></div></div></div><div class=sp-widget-options><div><!-- labels --><label translate=\"{{\'Communication.custom_tracking_code\'}}\"></label></div><div><sr-toggle-button id=toggle-button-custom-tracking-code></sr-toggle-button></div><div><a tooltip-placement=right tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Communication.custom_tracking_code_tooltip\' | translate}}\"><i class=\"sp-icon-info tooltip-icon\"></i></a></div><button type=button ng-click=vm.showWidgetModal() class=\"btn btn-primary btn-large btn-generate-widget\">{{\'Communication.generate_insertion_code\' | translate}}</button></div><div class=sp-widget-options><form class=\"form-horizontal sp-form col-sm-6\" name=vm.form novalidate ng-submit=vm.saveProperty()><div class=form-group><label class=\"col-sm-2 control-label\" translate=Communication.from_name style=\"width: 75px\"></label><div class=col-sm-4><input type=text style=\"width: 240px\" class=\"form-control form-input-on-white-bg\" name=from_name translate placeholder={{vm.addonsProps.email_from_name.value}} ng-model=vm.addonsProps.email_from_name.value ng-change=vm.disableMsg()></div></div><div class=form-group><label class=\"col-sm-2 control-label\" translate=Communication.from_email style=\"width: 75px\"></label><div class=col-sm-4><input type=text style=\"width: 240px\" class=\"form-control form-input-on-white-bg\" name=from_email translate placeholder={{vm.addonsProps.email_from_email.value}} ng-pattern=\'/^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\' ng-model=vm.addonsProps.email_from_email.value ng-change=vm.disableMsg()></div></div><div class=sp-mobile-form-action-buttons><div class=form-group><button class=\"btn btn-success ng-scope\" type=submit translate=Communication.save></button><label ng-if=vm.msg>{{\'Communication.success_msg\' | translate}}</label></div></div></form></div></div></div></div><div class=right-side ng-show=\"!vm.state.includes(\'**.settings.communication.list\')\" ui-view></div>");
$templateCache.put("app/settings/communication/widget-code-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-success\"><h3 class=modal-title translate=Communication.livetracking_widget></h3></div><div class=modal-body><span class=sp-container-desc translate=Communication.insertion_code></span><div class=row><div class=col-lg-12><div class=sp-widget-code-container><div class=sp-embed-code>{{widgetCode}}</div></div><button type=button sp-copy={{widgetCode}} class=\"btn btn-success btn-large btn-copy-to-clipboard\">{{\'Communication.copy_code\' | translate}}</button></div></div></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Visits.close></button></div></div>");
$templateCache.put("app/settings/fleets/confirm-delete-fleet.modal.html","<div class=\"sp-modal-content confirm-delete-fleet-modal\"><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Fleets.delete_confirmation_title></h3></div><div class=modal-body><p><span translate=Fleets.delete_confirmation_continue></span></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog() translate=Fleets.delete_confirmation_cancel></button> <button type=button class=\"btn btn-danger\" ng-click=confirm() translate=Fleets.delete_confirmation_delete></button></div></div>");
$templateCache.put("app/settings/fleets/fleets.html","<div class=left-side><h1 class=section-title translate=fleets></h1><div class=\"sp-fleets-controller row\"><div class=\"sp-fleets-container col-md-4\"><div class=\"sp-fleets-new-name-input row\"><div class=col-md-12><form class=form-inline name=vm.fleetName ng-submit=vm.openVehicleListForNewFleet() novalidate><div class=form-group><input type=text class=form-control id=newFleetName ng-model=vm.newFleetName name=name translate translate-attr-placeholder=Fleets.fleet_name_placeholder required></div><button type=submit class=\"btn btn-primary\" translate=Fleets.add ng-disabled=!vm.newFleetName></button> <i class=\"sp-icon-info title-icon\" uib-tooltip=\"{{\'Fleets.tooltips.add\' | translate}}\" tooltip-placement=right></i></form></div></div><div class=\"sp-fleets-list-section row\"><fleet-list select-fleet-handler=vm.selectFleet data=vm.fleets selected-fleet=vm.selectedFleet></fleet-list></div></div><div class=col-md-8><div><div class=fleet-vehicles-container ng-if=vm.showVehicleList><editable-input model=vm.fleetNameEdited edition-disabled=!vm.enableEdition></editable-input><div class=delete-icon ng-if=\"vm.selectedFleet !== null\"><a class=\"btn btn-link sp-delete\" ng-click=vm.openDeleteConfirmModal() href=\"\"><i class=sp-icon-delete></i></a></div><selectable-items-list data=vm.dataSelectableItemsVehicles items-selected=vm.dataSelectableItemsVehicles.itemsSelected items-per-page=16></selectable-items-list><selectable-items-list data=vm.dataSelectableItemsUsers items-selected=vm.dataSelectableItemsUsers.itemsSelected items-per-page=16></selectable-items-list></div><div class=no-vehicle-container ng-if=!vm.showVehicleList><img class=empty-panel-image src=../.././../assets/images/personajes1.png alt=\"\"> <img class=empty-panel-image src=../.././../assets/images/personajes2.png alt=\"\"><div class=title translate=Fleets.fleet_panel_title></div><br><p translate=Fleets.fleet_panel_description></p></div></div><div class=sp-fleets-buttons-container ng-if=vm.showVehicleList><button class=\"btn btn-default\" ng-click=vm.cancel()><span translate=Fleets.cancel></span></button> <button class=\"btn btn-success btn-saved pull-right\" ng-disabled=!vm.isSaveEnabled() ng-click=vm.saveFleet()><span translate=Fleets.save></span></button></div></div></div></div>");
$templateCache.put("app/settings/generals/generals-list.html","<div class=\"left-side general-settings\"><h1 class=section-title translate=optimizers></h1><form name=vm.form ng-submit=vm.optimizationChanged(vm.optimizationOptions) novalidate><div class=row><button type=submit class=\"btn btn-success pull-right\" ng-disabled=vm.form.$invalid><i class=\"fa fa-spinner fa-pulse\" ng-if=vm.optimizationOptionsLoader></i> <span translate=General.save_changes></span></button></div><div class=sp-panel-container><div class=row><div class=\"col-xs-12 col-sm-6\"><div class=\"panel sp-panel-settings\"><div class=panel-heading translate=General.optimization></div><div class=panel-body><ul><li ng-repeat=\"(key, value) in vm.optimizationOptions\" ng-if=!vm.isNumericOptimizationOption(key)><label id={{vm.getOptimizationOptionId(key)}}>{{vm.getTranslatedOptimizationOption(key)}}</label><i class=\"sp-icon-info capacity-icon\" uib-tooltip={{vm.tooltipMessages[key]}} tooltip-placement=right></i><sp-switch ng-if=\"key === vm.ALL_VEHICLES_OPTION\" ng-model=value.value ng-true-value=false ng-false-value=true ng-change=vm.checkOptions(key)></sp-switch><sp-switch ng-if=\"key === vm.DISTANCE_TO_JOIN_VISITS_OPTION\" ng-model=value.isEnabled ng-change=vm.checkOptions(key)></sp-switch><sp-switch ng-if=\"key !== vm.ALL_VEHICLES_OPTION && key !== vm.DISTANCE_TO_JOIN_VISITS_OPTION\" ng-model=value.value ng-change=vm.checkOptions(key)></sp-switch><label class=displayed-options-lbl translate=General.optimization.displayed_options></label><sp-switch ng-model=value.editable ng-change=vm.checkOptions(key)></sp-switch><div class=distance-to-join-visits-input ng-if=\"vm.mustShowDistanceToJoinVisitsInput(key, value.isEnabled)\"><label>{{vm.distanceToJoinVisitsInputMessages.title}}</label><label for={{vm.DISTANCE_TO_JOIN_VISITS_INPUT_ID}}><input type=number id={{vm.DISTANCE_TO_JOIN_VISITS_INPUT_ID}} name=distanceToJoinVisitsInput ng-model=value.value ng-required=true min={{vm.MIN_DISTANCE_TO_JOIN_VISITS}} max={{vm.MAX_DISTANCE_TO_JOIN_VISITS}} placeholder={{vm.distanceToJoinVisitsInputMessages.placeholder}} step={{vm.DISTANCE_TO_JOIN_VISITS_INPUT_STEP}} ng-change=vm.validateDistanceToJoinVisitsInput()></label><div ng-messages=vm.form.distanceToJoinVisitsInput.$error class=sp-settings-invalid-help-block><div ng-if=vm.form.distanceToJoinVisitsInput.$dirty ng-message=\"number || required || min\"><span>{{vm.distanceToJoinVisitsInputMessages.error_required}}</span></div><div ng-if=vm.form.distanceToJoinVisitsInput.$dirty ng-message=max><span>{{vm.distanceToJoinVisitsInputMessages.error_max_value}}</span></div></div></div></li></ul></div></div></div><div class=\"col-xs-12 col-sm-6\"><div class=\"panel sp-panel-settings\"><div class=panel-heading translate=General.optimization.parameters></div><div class=panel-body><ul><li><div class=sp-panel-configuration><span translate=General.optimization.parameters.traffic_factor></span> <i class=\"sp-icon-info capacity-icon\" uib-tooltip={{vm.tooltipMessages.traffic_factor}} tooltip-placement=right></i><div class=sp-traffic-factor><rzslider class=sp-settings-slider rz-slider-model=vm.optimizationOptions.fmv.value rz-slider-options=vm.trafficSlider.options></rzslider><div class=min-limit translate=General.optimization.parameters.slow></div><div class=max-limit translate=General.optimization.parameters.fast></div></div></div></li><li><div class=sp-panel-configuration><span translate=General.optimization.parameters.beauty_factor></span> <i class=\"sp-icon-info capacity-icon\" uib-tooltip={{vm.tooltipMessages.beauty_factor}} tooltip-placement=right></i><div class=sp-traffic-factor><rzslider class=sp-settings-slider rz-slider-model=vm.optimizationOptions.fmb.value rz-slider-options=vm.beautySlider.options></rzslider><div class=min-limit translate=General.optimization.parameters.beauty_min></div><div class=max-limit translate=General.optimization.parameters.beauty_max></div></div></div></li></ul></div></div></div></div></div></form></div>");
$templateCache.put("app/settings/mobile-general/mobile-general-list.html","<div class=sp-settings-mobile-general-container><h1 class=section-title translate=mobile></h1><div class=sp-mobile-general-activation><div class=\"panel panel-default sp-form\"><div class=row ng-repeat=\"(key,value) in vm.accountConfigs\" ng-if=\"key !== \'mandatory_success_checkout_picture\' && key !== \'mandatory_failed_checkout_picture\'\"><div class=\"col-xs-12 col-sm-4\"><!-- labels --><label translate=\"{{\'Mobile_general.Accounts_settings.\'+key}}\"></label></div><div class=\"col-xs-12 col-sm-4\"><!-- selection --><div class=\"checkbox switcher text-center\"><sp-switch ng-model=vm.accountConfigs[key]></sp-switch></div></div><div class=\"col-xs-12 col-sm-4\"><p class=sp-config-mobile-message translate=\"{{\'Mobile_general.Accounts_settings.\' + key + \'_message\'}}\"></p></div></div><div class=row><div class=\"col-xs-12 col-sm-4\"><!-- labels --><div class=row><label translate=Mobile_general.Accounts_settings.mandatory_checkout_picture></label></div><div class=\"row col-sm-offset-2\" ng-show=vm.mandatory_checkout_picture><input type=checkbox ng-model=vm.accountConfigs.mandatory_success_checkout_picture ng-click=vm.checkMandatoryPictureOptions()><label translate=Mobile_general.Accounts_settings.mandatory_success_checkout_picture></label></div><div class=\"row col-sm-offset-2\" ng-show=vm.mandatory_checkout_picture><input type=checkbox ng-model=vm.accountConfigs.mandatory_failed_checkout_picture ng-click=vm.checkMandatoryPictureOptions()><label translate=Mobile_general.Accounts_settings.mandatory_failed_checkout_picture></label></div></div><div class=\"col-xs-12 col-sm-4\"><!-- selection --><div class=\"checkbox switcher text-center\"><sp-switch ng-model=vm.mandatory_checkout_picture ng-click=vm.toggleMandatoryCheckoutPictures()></sp-switch></div></div><div class=\"col-xs-12 col-sm-4\"><p class=sp-config-mobile-message translate=Mobile_general.Accounts_settings.mandatory_checkout_picture_message></p></div></div><button class=\"btn btn-success btn-large col-sm-2 btn-account-settings-save\" translate=Account.btn_save ng-click=vm.saveConfigsMobile()></button></div></div><div class=sp-mobile-general-table><div class=sp-mobile-table><div class=sp-table><div class=\"sp-table-row sp-table-header\"><div class=sp-table-row-item><span translate=Mobile_general.status></span></div><div class=sp-table-row-item><span translate=Mobile_general.label></span></div><div class=sp-table-row-item>&nbsp;</div></div><div class=sp-table-row ng-repeat=\"observation in vm.observations.slice((vm.currentPage - 1)*vm.itemsPerPage, vm.currentPage*vm.itemsPerPage) | orderObservationsSettings\"><div class=sp-table-row-item><span translate=Mobile_general.{{observation.type}}></span></div><div class=sp-table-row-item><span>{{observation.label}}</span></div><div class=sp-table-row-item><a href=\"\" ng-click=vm.editObservation(observation) translate=Vehicles.edit></a></div></div><div ng-show=\"vm.observations.length === 0\" class=\"sp-table-row sp-empty-data\"><span class=title translate=Mobile_general.without_observations_1></span><div class=content><span translate=Mobile_general.without_observations_2></span></div></div><div ng-if=\"vm.observations.length > vm.itemsPerPage\" class=\"sp-settings-pagination text-right\"><uib-pagination total-items=vm.observations.length ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-links=true items-per-page=vm.itemsPerPage first-text={{pagination.firstText}} last-text={{pagination.lastText}} next-text={{pagination.nexText}} previous-text={{pagination.previousText}}></uib-pagination></div></div></div><div class=sp-mobile-form><div class=sp-mobile-form-title><span ng-show=!vm.editing translate=Mobile_general.title_form_1></span> <span ng-show=vm.editing translate=Mobile_general.title_form_2></span> <a class=\"btn btn-link sp-delete pull-right\" ng-show=vm.editing ng-click=vm.showDeleteModal() href=\"\"><i class=sp-icon-delete></i></a></div><form class=\"form-horizontal sp-form\" name=vm.form ng-submit=vm.save() novalidate><div class=form-group><label class=\"col-sm-3 control-label\" translate=Mobile_general.label></label><div class=col-sm-9><input type=text class=form-control name=name required translate translate-attr-placeholder=Mobile_general.required ng-model=vm.mobile.label autofocus><ng-messages for=vm.form.name.$error class=\"sp-form-messages ng-messages-skills\" role=alert ng-if=vm.form.$submitted><ng-message class=sp-settings-invalid-help-block when=pattern></ng-message><ng-message class=sp-settings-invalid-help-block when=required translate=Mobile_general.name_required></ng-message><ng-message class=sp-settings-invalid-help-block when=invalid translate=Skills.repeated></ng-message></ng-messages><!--  <span class=\"sp-settings-invalid-help-block\"\n                              ng-show=\"vm.nameRequired\" translate=\"Mobile_general.name_required\"></span> --></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Mobile_general.type></label><div class=col-sm-9><select class=form-control ng-options=\"observation.name for observation in vm.typeObservation track by observation.id\" ng-model=vm.mobile.type name=type required><option value=\"\" translate=Mobile_general.select_observation></option></select><ng-messages for=vm.form.type.$error class=\"sp-form-messages ng-messages-skills\" role=alert ng-if=vm.form.$submitted><ng-message class=sp-settings-invalid-help-block when=pattern></ng-message><ng-message class=sp-settings-invalid-help-block when=required translate=Mobile_general.type_required></ng-message><ng-message class=sp-settings-invalid-help-block when=invalid translate=Skills.repeated></ng-message></ng-messages></div></div><div class=sp-mobile-form-action-buttons><div class=form-group><button class=\"btn btn-lg btn-success btn-saved\" type=submit ng-click=vm.form.submit() translate=Mobile_general.save></button></div></div></form></div></div></div>");
$templateCache.put("app/settings/mobile-general/observation-delete-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Mobile_general.delete_observation></h3></div><div class=modal-body><p style=\"text-align: center\"><span translate=Mobile_general.irreversible_action></span><br><span translate=Mobile_general.want_continue></span></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Mobile_general.cancel></button> <button type=button class=\"btn btn-danger\" ng-click=\"deleteObservation(); closeThisDialog(0)\" translate=Mobile_general.delete></button></div></div>");
$templateCache.put("app/settings/security/security.html","<div class=left-side><h1 class=section-title translate=security></h1><div class=sp-header><div class=sp-settings-action-bar><div class=col-md-6><div class=\"left-side sp-settings-list-container sp-settings-action-bar pull-left\"><div class=sp-header><h4 class=sp-header-title translate=Security.title></h4></div></div></div><div class=col-md-6><div class=\"btn-group pull-right\"><button class=\"btn btn-success btn-saved\" translate=Security.save ng-click=sm.saveSecuritySetting(sm.security) ng-disabled=\"sm.security.web_length === null ||\n                         sm.security.web_length === undefined ||\n                         sm.security.mobile_length === null ||\n                         sm.security.mobile_length === undefined ||\n                         sm.security.password_expiration === null ||\n                         sm.security.password_expiration === undefined\"></button></div></div></div></div><div class=sp-security-container><div><section class=\"sp-security-section col-lg-6\"><div><p class=sp-security-subtitle translate=Security.subtitle_web></p></div><div><p class=sp-security-description translate=Security.description_web></p></div><div class=sp-security-form><div class=\"item sp-btn-group-abilities\"><div><span class=sp-security-item translate=Security.should_min_length></span> <span class=sp-security-span translate=Security.default_min_length></span></div><div><input type=number name=web_length class=sp-numeric-input ng-model=sm.security.web_length min=8 ng-min=8 ng-focus=\"sm.webLengthFocus = true\" ng-blur=\"sm.webLengthFocus = false\" ng-required=true ng-disabled=sm.webLengthDisabled></div></div><div ng-if=\"sm.webLengthFocus &&\n                     (sm.security.web_length === null ||\n                      sm.security.web_length === undefined)\" class=sp-error-txt style=\"text-align:right; margin:2px auto 0px auto\" translate=Security.invalid_password_length></div><div class=\"item sp-select-all\"><div class=sp-checkbox-select-all><input type=checkbox name=web_uppercase class=sp-checkbox-input ng-model=sm.security.web_uppercase ng-disabled=sm.webUppercaseDisabled><label><span class=sp-icon-check></span></label></div><span class=sp-security-label translate=Security.should_uppercase></span></div><div class=\"item sp-select-all\"><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-model=sm.security.web_lowercase ng-disabled=sm.webLowercaseDisabled><label><span class=sp-icon-check></span></label></div><span class=sp-security-label translate=Security.should_lowercase></span></div><div class=\"item sp-select-all\"><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-model=sm.security.web_number ng-disabled=sm.webNumberDisabled><label><span class=sp-icon-check></span></label></div><span class=sp-security-label translate=Security.should_numeric></span></div><div class=\"item sp-select-all\"><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-model=sm.security.web_symbol ng-disabled=sm.webSymbolDisabled><label><span class=sp-icon-check></span></label></div><span class=sp-security-label translate=Security.should_non_alphanumeric></span></div><div class=\"item sp-btn-group-abilities\" style=\"margin-top: 2em\"><div><span class=sp-security-item translate=Security.password_expiration></span> <span class=sp-security-span translate=Security.password_expiration_unit></span></div><div><select name=password_expiration class=sp-select-input style=\"border: 1px solid #8f8f9d\" ng-required=true ng-model=sm.security.password_expiration ng-focus=\"sm.passwordExpirationFocus = true\" ng-blur=\"sm.passwordExpirationFocus = false\" ng-disabled=sm.passwordExpirationDisabled><option value=0 translate=Security.password_expiration_disabled></option><option value=30>30</option><option value=60>60</option><option value=90>90</option><option value=180>180</option><option value=365>365</option></select></div></div><div ng-if=\"sm.passwordExpirationFocus &&\n                     (sm.security.password_expiration === null ||\n                      sm.security.password_expiration === undefined)\" class=sp-error-txt style=\"text-align:right; margin:2px auto 0px auto\" translate=Security.invalid_password_expiration_value></div></div></section><section class=\"sp-security-section col-lg-6\"><div><p class=sp-security-subtitle translate=Security.subtitle_mobile></p></div><div><p class=sp-security-description translate=Security.description_mobile></p></div><div class=sp-security-form><div class=\"item sp-btn-group-abilities\"><div><span class=sp-security-item translate=Security.should_min_length></span> <span class=sp-security-span translate=Security.default_min_length></span></div><div><input type=number name=mobile_length class=sp-numeric-input ng-model=sm.security.mobile_length min=8 ng-min=8 ng-focus=\"sm.mobileLengthFocus = true\" ng-blur=\"sm.mobileLengthFocus = false\" ng-required=true ng-disabled=sm.mobileLengthDisabled></div></div><div ng-if=\"sm.mobileLengthFocus &&\n                     (sm.security.mobile_length === null ||\n                      sm.security.mobile_length === undefined)\" class=sp-error-txt style=\"text-align:right; margin:2px auto 0px auto\" translate=Security.invalid_password_length></div><div class=\"item sp-select-all\"><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-model=sm.security.mobile_uppercase ng-disabled=sm.mobileUppercaseDisabled><label><span class=sp-icon-check></span></label></div><span class=sp-security-label translate=Security.should_uppercase></span></div><div class=\"item sp-select-all\"><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-model=sm.security.mobile_lowercase ng-disabled=sm.mobileLowercaseDisabled><label><span class=sp-icon-check></span></label></div><span class=sp-security-label translate=Security.should_lowercase></span></div><div class=\"item sp-select-all\"><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-model=sm.security.mobile_number ng-disabled=sm.mobileNumberDisabled><label><span class=sp-icon-check></span></label></div><span class=sp-security-label translate=Security.should_numeric></span></div><div class=\"item sp-select-all\"><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-model=sm.security.mobile_symbol ng-disabled=sm.mobileSymbolDisabled><label><span class=sp-icon-check></span></label></div><span class=sp-security-label translate=Security.should_non_alphanumeric></span></div></div></section></div></div><div class=sp-header><div class=sp-settings-action-bar><div class=col-md-6><div class=\"left-side sp-settings-list-container sp-settings-action-bar pull-left\"><div class=sp-header><h4 class=sp-header-title translate=Security.idle_title></h4></div></div></div></div></div><div class=\"sp-security-container sp-btn-group-abilities\"><div class=sp-security-section><p class=sp-security-subtitle translate=Security.idle_config></p><p class=sp-security-description translate=Security.idle_description></p></div><div><select ng-model=sm.security.idle_timeout ng-disabled=sm.idleTimeoutDisabled><option value=15 translate=Security.idle_15></option><option value=30 translate=Security.idle_30></option><option value=45 translate=Security.idle_45></option><option value=60 translate=Security.idle_60></option><option value=120 translate=Security.idle_120></option><option value=180 translate=Security.idle_180></option><option value=240 translate=Security.idle_240></option></select></div></div></div>");
$templateCache.put("app/settings/skills/skills-list.html","<div class=\"skills-panel-list row\"><h1 class=section-title translate=skills></h1><div class=\"skills-panel-list-left col-md-4\"><!-- skills form create --><div ng-show=!vm.editing class=\"row form-skills\"><div class=col-md-10><form class=form-inline name=vm.formSkills ng-submit=vm.saveSkills() novalidate><div class=form-group><input type=text class=form-control id=skill ng-model=vm.skill.name name=name translate translate-attr-placeholder=Skills.skill_holder required></div><button type=submit class=\"btn btn-primary\" translate=Skills.add></button><ng-messages for=vm.formSkills.name.$error class=\"sp-form-messages ng-messages-skills\" role=alert ng-if=vm.formSkills.$submitted><ng-message class=sp-settings-invalid-help-block when=pattern></ng-message><ng-message class=sp-settings-invalid-help-block when=required translate=Skills.required></ng-message><ng-message class=sp-settings-invalid-help-block when=invalid translate=Skills.repeated></ng-message></ng-messages></form></div><div class=col-md-2><!-- enlace que activa el modo edicion --> <a href=\"\" ng-click=\"vm.editing = true\" ng-show=\"vm.skills.length > 0\" translate=Skills.edit></a></div></div><!-- div \"seleccionar todos\" que se muestra en modo edicion --><div ng-show=vm.editing class=\"row select-all-skills\"><input ng-show=vm.editing ng-model=vm.select_all_skills ng-change=vm.selectAllSkills() type=checkbox class=col-md-2> <a class=col-md-10 href=\"\" ng-click=vm.selectAllSkillsHref() translate=Skills.select_all></a></div><!-- skills list --><div class=\"row list-skills\"><div class=list-skills-header translate=Skills.name></div><div class=list-skills-body ng-show=\"vm.skills.length > 0\"><div class=\"list-skills-body-list row\" ng-repeat=\"skill in vm.skills | orderBy:\'skill\'\"><!-- input checkbox que se muestra en modo edicion --> <input class=col-md-2 type=checkbox ng-show=vm.editing ng-model=skill.isChecked ng-change=vm.selectSkill()> <span ng-class=\"{\'col-md-10\':vm.editing || \'col-md-12: !vm.editing\'}\">{{skill.skill}}</span></div></div><!-- botones que se muestran al estar en modo edicion--><div ng-show=vm.editing class=\"list-skills-body buttons\"><button class=\"btn sp-btn-default\" ng-click=vm.cancel() translate=Skills.cancel></button> <button class=\"btn btn-primary\" ng-click=vm.deletSkills() translate=Skills.delete></button></div><div ng-show=\"vm.skills.length === 0\" class=empty-skills><span translate=Skills.without_skill_1></span><p translate=Skills.without_skill_2></p></div></div></div><!--skills button --><div ng-show=\"vm.skills.length > 0\" class=\"col-md-8 skills-panel-button\"><div class=\"btn-group sp-btn-group-abilities\"><label class=\"btn sp-btn-abilities btn-primary\" ng-repeat=\"skill in vm.skills\" ng-model=vm.skills_vehicle[skill.id] uib-btn-checkbox ng-class=\"{\'btn-disabled\': !vm.editing}\" ng-click=vm.activeCheckbox()>{{skill.skill}}</label></div></div><div ng-show=\"vm.skills.length === 0\" class=\"col-md-8 skills-panel-empty\"><!--<img src=\"../../../assets/images/sin-vehiculos-skills.svg\">--> <span class=title translate=Skills.empty_skills_title></span> <span class=paragraph translate=Skills.empty_skills_paragraph></span><p class=note translate=Skills.empty_skills_note></p></div></div>");
$templateCache.put("app/settings/users/users-delete-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Drivers.delete_driver></h3></div><div class=modal-body><p style=\"text-align: center\"><span translate=Drivers.irreversible_action></span><br><span translate=Drivers.want_continue></span></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Drivers.cancel></button> <button type=button class=\"btn btn-danger\" ng-click=\"deleteUser(); closeThisDialog(0)\" translate=Drivers.delete></button></div></div>");
$templateCache.put("app/settings/users/users-detail.html","<div class=right-side-content><div class=error-update ng-show=vm.errorDeleteOwner><span>Usuario no puede ser eliminado.</span></div><div class=sp-settings-right-side-form><div class=sp-form-title><span ng-show=vm.stateParams.userId translate=Drivers.information_user></span> <span ng-show=!vm.stateParams.userId translate=Drivers.new_driver></span> <a class=\"btn btn-link sp-delete pull-right\" ng-show=vm.stateParams.userId ng-click=vm.showDeleteModal() href=\"\"><i class=sp-icon-delete></i></a></div><form class=\"form-horizontal sp-form\" name=vm.form ng-submit=vm.save() novalidate id=user-detail-form><div class=form-group><label class=\"col-sm-3 control-label\" translate=Drivers.driver_information></label><div class=col-sm-9><input type=text class=form-control name=name required translate translate-attr-placeholder=Drivers.required ng-model=vm.user.name autofocus> <span class=sp-settings-invalid-help-block ng-show=vm.user.nameRequired translate=Drivers.name_required></span></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Drivers.user_lbl></label><div class=col-sm-9><input type=text class=form-control name=username ng-required=true translate translate-attr-placeholder=Drivers.required ng-model=vm.user.username ng-blur=vm.checkUsername(vm.user) ng-class=\"{\'sp-settings-invalid-input\': vm.user.usernameDuplicated}\"> <span class=sp-settings-invalid-help-block ng-show=vm.user.usernameDuplicated translate=Drivers.user_exist></span> <span class=sp-settings-invalid-help-block ng-show=vm.user.usernameError translate=Drivers.username_error></span> <span class=sp-settings-invalid-help-block ng-show=vm.user.usernameRequired translate=Drivers.username_required></span></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Drivers.email></label><div class=col-sm-9><input ng-if=\"vm.ssoUsers && !vm.isDriverOrCodriver(vm.user)\" type=email class=form-control name=email translate translate-attr-placeholder=Drivers.required ng-model=vm.user.email ng-required=true> <input ng-if=\"!vm.ssoUsers || vm.isDriverOrCodriver(vm.user)\" type=email class=form-control name=email translate translate-attr-placeholder=Drivers.optional ng-model=vm.user.email ng-required=false> <span class=sp-settings-invalid-help-block ng-show=\"vm.ssoUsers && !vm.isDriverOrCodriver(vm.user) && !vm.form.email.$valid\" translate=Drivers.email_format></span> <span class=sp-settings-invalid-help-block ng-show=vm.user.emailError translate=Drivers.email_repeated></span> <span class=sp-settings-invalid-help-block ng-show=\"vm.user.emailRequired && !vm.form.email.$valid\" translate=Drivers.email_required></span></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Drivers.user_type></label><div class=col-sm-9><select class=form-control ng-change=vm.changePolicies() ng-model=vm.user.typeUser required><option value=driver translate=Drivers.driver ng-if=\"vm.isAdmin.value || vm.isOwner.value\"></option><option value=codriver translate=Drivers.codriver ng-if=\"(vm.isAdmin.value || vm.isOwner.value) && vm.canCreateCoDriver\"></option><option value=monitor translate=Drivers.monitoring ng-if=\"vm.isAdmin.value || vm.isOwner.value\"></option><option value=admin translate=Drivers.admin ng-if=vm.isOwner.value></option><option value=coordinator translate=Drivers.coordinator ng-if=vm.enableCoordinator></option><option value=monitor_coordinator translate=Drivers.monitor_coordinator ng-if=vm.enableCoordinator></option><option value=router translate=Drivers.router ng-if=\"vm.isAdmin.value || vm.isOwner.value\"></option><option value=router_jr translate=Drivers.router_jr ng-if=\"(vm.isAdmin.value || vm.isOwner.value) && vm.canCreateRouterJr\"></option></select></div></div><div class=form-group ng-show=\"vm.supportsPassword(vm.user) && !vm.changePassword && vm.user.id\"><label class=\"col-sm-3 control-label\"></label><div class=col-sm-9><button class=\"btn btn-link sp-btn-collapse\" type=button ng-click=\"vm.changePassword = true\"><div class=sp-btn-collapse-text translate=Drivers.change_password></div></button></div></div><div ng-show=\"vm.supportsPassword(vm.user) && (vm.changePassword || !vm.user.id)\"><div class=\"form-group password_policy_focus\"><label class=\"col-sm-3 control-label\" translate=Drivers.password></label><div class=\"col-sm-9 sp-block-relative\"><input class=\"form-control except_policies_hidden\" ng-attr-type={{vm.user.newPassword.type}} name=password translate translate-attr-placeholder=Drivers.required ng-change=vm.validatePassword() ng-model=vm.user.newPassword.value autocomplete=off id=user-detail-password required> <span class=\"input-group-btn except_policies_hidden\"><button type=button class=\"btn btn-default except_policies_hidden\" ng-click=vm.changeTypeInput(vm.user.newPassword)><span class=\"sp-icon-show-hide except_policies_hidden\"></span></button></span></div><div class=col-sm-offset-3 id=user-detail-policies><password-policies data=vm.policies validation=vm.validation></password-policies></div><p class=col-sm-offset-3><span class=sp-settings-invalid-help-block ng-show=vm.user.passwordRequired translate=Drivers.password_required></span></p></div><!--repetir contrasena--><div class=form-group><label class=\"col-sm-3 control-label\" translate=Drivers.repeat_password></label><div class=\"col-sm-9 sp-block-relative\"><input class=form-control ng-attr-type={{vm.user.confirmNewPassword.type}} name=confirm_password translate translate-attr-placeholder=Drivers.required ng-model=vm.user.confirmNewPassword.value autocomplete=off required> <span class=\"input-group-btn except_policies_hidden\"><button type=button class=\"btn btn-default except_policies_hidden\" ng-click=vm.changeTypeInput(vm.user.confirmNewPassword)><span class=\"sp-icon-show-hide except_policies_hidden\"></span></button></span></div><div class=col-sm-offset-3><ng-messages for=vm.form.confirm_password.$error class=sp-form-messages role=alert ng-show=vm.form.confirm_password.$dirty><ng-message class=sp-error-txt when=required></ng-message></ng-messages></div><span class=\"sp-settings-invalid-help-block col-sm-offset-3\" ng-show=vm.errorMatchPassword translate=Drivers.match_password></span></div><div class=sp-settings-warning-box ng-show=\"vm.user.id && (vm.user.typeUser === \'driver\' || vm.user.typeUser === \'codriver\')\"><span translate=Drivers.close_sessions_warning></span></div></div><div class=\"col-md-offset-7 col-md-5\"><div class=form-group><button class=\"btn btn-link sp-btn-collapse\" type=button ng-click=\"vm.moreInfo = !vm.moreInfo\"><div class=sp-btn-collapse-text>{{\'Users.btn_more_info\'| translate}}</div><div><i class=sp-icon-triangle-up ng-show=vm.moreInfo></i> <i class=sp-icon-triangle-down ng-show=!vm.moreInfo></i></div></button></div></div><div uib-collapse=!vm.moreInfo><div class=form-group><label class=\"col-sm-3 control-label\" translate=Drivers.phone_lbl></label><div class=col-sm-9><bc-phone-number name=phone ng-model=vm.user.phone ng-required=false default-country=cl selected-country=cl preferred-countries=\"cl br co\"></bc-phone-number><span class=sp-settings-invalid-help-block ng-show=!vm.user.phoneIsValid translate=Drivers.invalid_format></span></div></div></div><div class=sp-settings-right-side-form-action-buttons><div class=form-group><button class=\"btn btn-close pull-left except_policies_hidden\" type=button ng-click=vm.cancel() translate=Drivers.close></button> <button class=\"btn btn-success pull-right except_policies_hidden\" type=submit ng-click=vm.form.submit() translate=Drivers.save></button></div></div></form></div></div>");
$templateCache.put("app/settings/users/users-list.html","<div class=left-side><h1 class=section-title translate=users></h1><div class=sp-settings-list-container><div class=sp-settings-action-bar><div class=col-md-4><div class=\"left-side sp-settings-list-container sp-settings-action-bar pull-left\"><form class=\"form-inline md-form form-sm active-cyan-2\"><input class=\"form-control form-control-sm mr-3 w-75\" type=text placeholder=\"{{ \'Communication.search\' | translate }}\" aria-label=Search ng-model=vm.searchText ng-change=vm.onChangeSearch() ng-model-options=\"{ debounce: 250 }\"> <span><i class=clean-icon ng-show=\"vm.searchText.length > 0\" ng-click=vm.cleanSearch()>✕</i></span></form></div></div><div class=col-md-8><div class=\"btn-group pull-right\" uib-dropdown><button id=btn-bulk-update-users type=button class=\"btn btn-primary\" uib-dropdown-toggle><span translate=Users.btn_bulk_update></span>&nbsp;<i class=caret></i></button><ul class=\"dropdown-menu sp-dropdown-container\" uib-dropdown-menu aria-haspopup=true aria-expanded=false><li role=menuitem><span class=\"btn btn-primary btn-file btn-excel-download\"><input type=file sp-file-change=\"vm.bulkCreate = false; vm.importUsers($files)\"> <span translate=Users.btn_bulk_upload></span></span></li><li role=menuitem><button class=\"btn btn-primary btn-file btn-excel-download\" type=button ng-click=vm.downloadList()><i class=sp-icon-excel></i> <span translate=Users.btn_bulk_download></span></button></li></ul></div><div class=\"btn-group pull-right\" uib-dropdown><button id=btn-bulk-create-users type=button class=\"btn btn-primary\" uib-dropdown-toggle><span translate=Users.btn_bulk_create></span>&nbsp;<i class=caret></i></button><ul class=\"dropdown-menu sp-dropdown-container\" uib-dropdown-menu aria-haspopup=true aria-expanded=false><li role=menuitem><span class=\"btn btn-primary btn-file btn-excel-download\"><input type=file sp-file-change=\"vm.bulkCreate = true; vm.importUsers($files)\"> <span translate=Users.btn_bulk_upload></span></span></li><li role=menuitem><button class=\"btn btn-primary btn-file btn-excel-download\" type=button ng-click=vm.downloadTemplate()><i class=sp-icon-excel></i> <span translate=Users.btn_bulk_template_download></span></button></li></ul></div><button id=btn-create-user class=\"btn btn-primary pull-right\" type=button ng-click=vm.createUser() ng-disabled=\"vm.state.includes(\'settings.users.create\') || vm.state.includes(\'settings.users.detail\')\"><i class=sp-icon-circle-with-plus></i> <span translate=Drivers.new_driver></span></button><div class=\"pull-right total-items\" total-items=vm.safeSrcUsers.length><span translate=total></span>: {{vm.safeSrcUsers.length}}</div></div></div><div class=sp-settings-content-list><div class=sp-table><div class=\"sp-table-row sp-table-header\"><div class=sp-table-row-item translate=Drivers.name_table_header></div><div class=sp-table-row-item translate=Drivers.class_table_header></div><div class=sp-table-row-item translate=Drivers.phone_table_header></div><div class=sp-table-row-item translate=Drivers.email_table_header></div><div class=sp-table-row-item translate=Drivers.username_table_header></div><div class=sp-table-row-item ng-hide=\"vm.state.includes(\'settings.users.create\') || vm.state.includes(\'settings.users.detail\')\">&nbsp;</div></div><div cg-busy=\"{promise: vm.promiseLoading, backdrop:true, templateUrl:\'app/shared/html/loading.html\'}\" ng-show=!vm.ready style=height:200px></div><div class=sp-table-row ng-show=\"vm.safeSrcUsers.length > 0\" ng-repeat=\"user in vm.safeSrcUsers.slice(((vm.currentPage-1)*vm.itemsPerPage), ((vm.currentPage)*vm.itemsPerPage)) | filter:searchText\" cg-busy=\"{promise: vm.promiseLoading, backdrop:true, templateUrl:\'app/shared/html/loading.html\'}\"><div class=sp-table-row-item><i class=\"fa fa-lock\" ng-if=user.blocked></i> <span>{{user.name}}</span></div><div class=sp-table-row-item ng-show=\"user.isDriver && !user.isAdmin\"><span translate=Users.type_1></span></div><div class=sp-table-row-item ng-show=user.isAdmin><span translate=Users.type_2></span></div><div class=sp-table-row-item ng-show=\"user.isMonitor && !user.isAdmin && !user.isCoordinator\"><span translate=Users.type_4></span></div><div class=sp-table-row-item ng-show=\"user.isCoordinator && !user.isMonitor\"><span translate=Users.type_5></span></div><div class=sp-table-row-item ng-show=user.isRouter><span translate=Users.type_6></span></div><div class=sp-table-row-item ng-show=user.isRouterJr><span translate=Users.type_7></span></div><div class=sp-table-row-item ng-show=user.isCodriver><span translate=Users.type_8></span></div><div class=sp-table-row-item ng-show=\"user.isMonitor && user.isCoordinator\"><span translate=Users.type_9></span></div><div class=sp-table-row-item>{{user.phone !== \"\" ? user.phone: \'---\'}}</div><div class=sp-table-row-item>{{user.email !== \"\" ? user.email: \'---\'}}</div><div class=sp-table-row-item>{{user.username}}</div><div class=sp-table-row-item uib-dropdown ng-hide=\"vm.state.includes(\'settings.users.create\') || vm.state.includes(\'settings.users.detail\')\"><button class=btn uib-dropdown-toggle><i class=\"fa fa-ellipsis-v\"></i></button><ul class=\"dropdown-menu sp-dropdown-container\" uib-dropdown-menu aria-haspopup=true aria-expanded=false><li role=menuitem ng-if=!user.blocked><span class=btn ui-sref=\"settings.users.detail({userId: user.id})\" translate=Vehicles.edit></span></li><li role=menuitem ng-if=user.blocked><span class=btn ng-click=vm.openUnlockModal(user) translate=Drivers.unlock></span></li><li role=menuitem><span class=btn ng-click=vm.openDeleteModal(user) translate=Vehicles.delete></span></li></ul></div></div><div class=\"sp-settings-pagination text-right\" ng-show=\"vm.safeSrcUsers.length > vm.itemsPerPage\"><uib-pagination total-items=vm.safeSrcUsers.length ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-links=true items-per-page=vm.itemsPerPage ng-change=vm.pageChanged() first-text={{pagination.firstText}} last-text={{pagination.lastText}} next-text={{pagination.nexText}} previous-text={{pagination.previousText}}></uib-pagination></div><div ng-if=vm.showNotUsersMessage class=\"sp-table-row sp-empty-data\"><span class=title translate=Drivers.without_drivers_1></span><div class=content><span class=paragraph translate=Drivers.without_drivers_2></span> <a ui-sref=settings.users.create translate=Drivers.without_drivers_3 class=link></a> <span class=paragraph translate=Drivers.without_drivers_4></span></div></div><div ng-show=\"vm.safeSrcUsers.length === 0 && vm.searching && vm.ready && !vm.errorPath\" class=\"sp-table-row sp-empty-data\"><span class=title translate=Drivers.without_user_searching></span></div></div></div><div class=sp-settings-drivers-footer><div class=row><div class=\"sp-left-block sp-vcenter\" ng-class=\"{\'col-sm-5\': vm.state.includes(\'**.settings.users.list\'), \'col-sm-8\': !vm.state.includes(\'**.settings.users.list\')}\"><p translate=Drivers.footer_message></p></div><div class=\"sp-right-block sp-vcenter\" ng-class=\"{\'col-sm-2\': vm.state.includes(\'**.settings.users.list\'), \'col-sm-3 text-right\': !vm.state.includes(\'**.settings.users.list\')}\"><div class=sp-vcenter-apps-icons><a href={{::vm.appStoreAppLink}} target=_blank><img class=sp-footer-app-image src=../../../assets/images/appstore.png alt=appstore> </a><a href={{::vm.androidAppLink}} target=_blank><img class=sp-footer-app-image src=../../../assets/images/android_playstore.png alt=playstore></a></div></div></div></div></div></div><div class=right-side ng-show=\"!vm.state.includes(\'**.settings.users.list\')\" ui-view></div>");
$templateCache.put("app/settings/users/users-unlock-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-info\"><h3 class=modal-title translate=Drivers.unlock_driver translate-values=\"{ name: vm.user.name }\"></h3></div><div class=\"modal-body unlock-user-modal\"><p style=\"text-align: center\" ng-if=vm.user.email translate=Drivers.unlock_info></p><p style=\"text-align: center\" ng-if=!vm.user.email translate=Drivers.enter_email></p><form name=vm.form novalidate><label><input type=email name=email ng-model=vm.emailCopy ng-disabled=!vm.emailInputEnabled ng-required=true></label><p class=sp-settings-invalid-help-block ng-show=!vm.form.email.$valid translate=Drivers.email_format></p></form><p ng-show=vm.emailInputEnabled translate=Drivers.unlock_email_info></p><p><a ng-show=!vm.emailInputEnabled translate=Drivers.edit_email href=\"\" ng-click=vm.editEmail()></a></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Drivers.cancel></button> <button type=button class=\"btn btn-info\" ng-click=vm.unlockUser() translate=Drivers.confirm></button></div></div>");
$templateCache.put("app/settings/vehicles/vehicle-cannot-delete-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Vehicles.delete_vehicle></h3></div><div class=modal-body><p class=sp-modal-description><span translate=Vehicles.cannot_delete_description_vehicle></span></p><ul class=sp-modal-list><li ng-repeat=\"name in error[\'data\'] track by $index\">{{name}}</li></ul><p class=sp-modal-description><span translate=Vehicles.cannot_delete_description_2_vehicle></span></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Vehicles.cancel></button></div></div>");
$templateCache.put("app/settings/vehicles/vehicle-codrivers-modal.html","<div><header class=modal-cod-header><span class=modal-cod-header__vehicle-name>{{ vm.vehicleName ? vm.vehicleName : \'--\'}} </span><span class=modal-cod-header__cancel ng-click=closeThisDialog(vm.cancelAndCloseModal())>X</span></header><div class=modal-cod-body><div><span translate=Planner.codrivers_select></span><selectable-items-list data=vm.availableCodrivers items-selected=vm.availableCodrivers.itemsSelected></selectable-items-list></div><footer class=modal-cod-footer><button class=\"btn btn-default\" type=button ng-click=closeThisDialog(vm.cancelAndCloseModal()) translate=Vehicles.codrivers_modal_cancel></button> <button class=\"btn btn-saved btn-success\" type=button ng-click=closeThisDialog(vm.setCodrivers()) translate=Vehicles.codrivers_modal_set></button></footer></div></div>");
$templateCache.put("app/settings/vehicles/vehicle-delete-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Vehicles.delete_vehicle></h3></div><div class=modal-body><p style=\"text-align: center\"><span translate=Vehicles.irreversible_action></span><br><span translate=Vehicles.want_continue></span></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Vehicles.cancel></button> <button type=button class=\"btn btn-danger\" ng-click=\"deleteVehicle(); closeThisDialog(0)\" translate=Vehicles.delete></button></div></div>");
$templateCache.put("app/settings/vehicles/vehicle-update-plan-modal.html","<div class=sp-modal-content><div class=\"modal-body text-center\"><h1 class=modal-update-plan-title><span translate=Vehicles.modal_title_upgrade_plan></span></h1><span>{{vm.modalUpgradePlanContent}}</span><div class=text-center><img src=../../assets/images/sin-vehiculos-tracking.svg></div></div><div class=text-center><button type=button class=\"btn btn-upgrade-plan\" style=margin:10px ng-click=\"closeThisDialog(0); vm.chatInit();\"><i class=\"fa fa-star\"></i> <span translate=Vehicles.contact_us></span></button><br></div></div>");
$templateCache.put("app/settings/vehicles/vehicles-confirm-leave.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Vehicles.confirm_leave></h3></div><div class=\"modal-body text-center\"><p translate=Vehicles.confirm_leave_message_1></p><p translate=Vehicles.confirm_leave_message_2></p><p translate=Vehicles.confirm_leave_message_3 ng-show=vm.skillsMessageLeave class=sp-messages-leave-modal></p><p translate=Vehicles.confirm_leave_message_4 ng-show=vm.driverMessageLeave class=sp-messages-leave-modal></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Vehicles.confirm_leave_close></button> <button type=button class=\"btn btn-danger\" ng-click=\"vm.changeStateVehicle(vm.state); closeThisDialog(0)\" translate=Vehicles.confirm_leave_yes></button></div></div>");
$templateCache.put("app/settings/vehicles/vehicles-detail.html","<div class=right-side-content><div class=sp-settings-right-side-header><span ng-show=vm.stateParams.vehicleId>{{vm.vehicle.name}}</span> <span ng-hide=vm.stateParams.vehicleId>--</span> <a class=\"btn btn-link sp-delete pull-right\" ng-show=vm.stateParams.vehicleId ng-click=vm.showDeleteModal() href=\"\"><i class=sp-icon-delete></i></a></div><div class=sp-settings-right-side-map-container><div id=map></div></div><div class=sp-settings-right-side-form><div class=sp-form-title translate=Vehicles.head_title></div><form class=\"form-horizontal sp-form\" name=vm.form ng-submit=vm.save() novalidate><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.title_lbl></label><div class=col-sm-7><input type=text class=form-control name=title required translate translate-attr-placeholder=Vehicles.placeholder_name_vehicle ng-model=vm.vehicle.name autofocus><ng-messages for=vm.form.title.$error class=sp-form-messages role=alert ng-show=\"vm.form.title.$dirty || vm.form.$submitted\"><ng-message class=sp-settings-invalid-help-block when=pattern></ng-message><ng-message class=sp-settings-invalid-help-block when=required translate=Vehicles.error_name_vehicle_required></ng-message><ng-message class=sp-settings-invalid-help-block when=invalid translate=Vehicles.error_name_duplicated></ng-message><ng-message class=sp-settings-invalid-help-block when=deleted translate=Vehicles.error_name_duplicated_deleted></ng-message></ng-messages></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.capacity_lbl></label><div class=col-sm-7><input type=text class=form-control name=capacity required translate translate-attr-placeholder=Vehicles.placeholder_name_capacity ng-model=vm.vehicle.capacity capacity-input-format><ng-messages for=vm.form.capacity.$error class=sp-form-messages role=alert ng-show=\"vm.form.capacity.$dirty || vm.form.$submitted\"><ng-message class=sp-settings-invalid-help-block when=required translate=Vehicles.error_capacity_required></ng-message><ng-message class=sp-settings-invalid-help-block when=invalid translate=Vehicles.error_limit_capacity></ng-message></ng-messages></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_capacity\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.origin_lbl></label><div class=col-sm-7><autocomplete input-name=\"\'originAddress\'\" input-id=\"\'location_start_address\'\" address=vm.vehicle.location_start_address update-address=\"vm.updateStartLocation(location, address)\" on-focus=\"vm.changeMarker(\'origin\')\"></autocomplete><ng-messages for=vm.form.originAddress.$error class=sp-form-messages role=alert ng-show=\"vm.form.originAddress.$dirty || vm.form.$submitted\"><ng-message class=sp-settings-invalid-help-block when=required translate=Vehicles.error_address_origin></ng-message></ng-messages></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_address\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.latitude></label><div class=col-sm-7><div class=col-sm-4><input type=text class=\"form-control text-input-schedule\" name=originLatitude id=latitude_origin ng-change=\"vm.setPositionMarker(null,vm.vehicle.location_start_latitude, vm.vehicle.location_start_longitude, \'origin\')\" ng-model=vm.vehicle.location_start_latitude ng-focus=\"vm.changeMarker(\'origin\')\" ng-blur=\"vm.setDecimals(\'origin\')\" translate translate-attr-placeholder=Vehicles.placeholder_latitude></div><label class=\"col-sm-4 text-center form-control-static\" translate=Vehicles.longitude></label><div class=col-sm-4><input type=text class=\"form-control text-input-schedule\" name=originLongitude id=longitude_origin ng-change=\"vm.setPositionMarker(null,vm.vehicle.location_start_latitude, vm.vehicle.location_start_longitude, \'origin\')\" ng-model=vm.vehicle.location_start_longitude ng-focus=\"vm.changeMarker(\'origin\')\" ng-blur=\"vm.setDecimals(\'origin\')\" translate translate-attr-placeholder=Vehicles.placeholder_longitude></div><ng-messages for=vm.form.originLatitude.$error class=sp-form-messages role=alert ng-show=\"vm.form.$dirty || vm.form.$submitted\"><ng-message class=sp-settings-invalid-help-block when=pattern translate=Vehicles.error_coordinate_pattern></ng-message></ng-messages></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_coordinates\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><div class=\"col-md-offset-7 col-md-5\"><div class=form-group><button class=\"btn btn-link sp-btn-collapse\" type=button ng-click=\"vm.moreLoads = !vm.moreLoads\"><div class=sp-btn-collapse-text>{{\'Vehicles.btn_more_loads\'| translate}}</div><div><i class=sp-icon-triangle-up ng-hide=vm.moreLoads></i> <i class=sp-icon-triangle-down ng-show=vm.moreLoads></i></div></button></div></div><div uib-collapse=vm.moreLoads><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.reference_id_lbl></label><div class=col-sm-7><input type=text class=form-control name=reference_id translate translate-attr-placeholder=Vehicles.placeholder_reference_id ng-model=vm.vehicle.reference_id></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_reference_id\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.capacity_lbl_2></label><div class=col-sm-7><input type=text class=form-control name=capacity_2 translate translate-attr-placeholder=Vehicles.placeholder_name_capacity_2 ng-model=vm.vehicle.capacity2 capacity-input-format><ng-messages for=vm.form.capacity_2.$error class=sp-form-messages role=alert ng-show=\"vm.form.capacity_2.$dirty || vm.form.$submitted\"><ng-message class=sp-settings-invalid-help-block when=invalid translate=Vehicles.error_limit_capacity_2></ng-message></ng-messages></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_capacity_2\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.capacity_lbl_3></label><div class=col-sm-7><input type=text class=form-control name=capacity_3 translate translate-attr-placeholder=Vehicles.placeholder_name_capacity_3 ng-model=vm.vehicle.capacity3 capacity-input-format><ng-messages for=vm.form.capacity_3.$error class=sp-form-messages role=alert ng-show=\"vm.form.capacity_3.$dirty || vm.form.$submitted\"><ng-message class=sp-settings-invalid-help-block when=invalid translate=Vehicles.error_limit_capacity_3></ng-message></ng-messages></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_capacity_2\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.destination_lbl></label><div class=col-sm-7><autocomplete input-name=\"\'endAddress\'\" input-id=\"\'location_end_address\'\" address=vm.vehicle.location_end_address update-address=\"vm.updateEndLocation(location, address)\" on-focus=\"vm.changeMarker(\'end\')\"></autocomplete><ng-messages for=vm.form.endAddress.$error class=sp-form-messages role=alert ng-show=\"vm.form.endAddress.$dirty || vm.form.$submitted\"><ng-message class=sp-settings-invalid-help-block when=required translate=Vehicles.error_address_end></ng-message></ng-messages></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_address\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.latitude></label><div class=col-sm-7><div class=col-sm-4><input type=text class=\"form-control text-input-schedule\" name=destinationLatitude id=latitude_destination ng-model=vm.vehicle.location_end_latitude ng-change=\"vm.setPositionMarker(null, vm.vehicle.location_end_latitude, vm.vehicle.location_end_longitude, \'destination\')\" ng-blur=\"vm.setDecimals(\'destination\')\" ng-focus=\"vm.changeMarker(\'end\')\" ng-disabled=vm.shouldMirrorAddresses translate translate-attr-placeholder=Vehicles.placeholder_latitude></div><label class=\"col-sm-4 text-center form-control-static\" translate=Vehicles.longitude></label><div class=col-sm-4><input type=text class=\"form-control text-input-schedule\" name=destinationLongitude id=longitude_destination ng-model=vm.vehicle.location_end_longitude ng-change=\"vm.setPositionMarker(null, vm.vehicle.location_end_latitude, vm.vehicle.location_end_longitude, \'destination\')\" ng-focus=\"vm.changeMarker(\'end\')\" ng-blur=\"vm.setDecimals(\'destination\')\" ng-disabled=vm.shouldMirrorAddresses translate translate-attr-placeholder=Vehicles.placeholder_longitude></div><ng-messages for=vm.form.destinationLatitude.$error class=sp-form-messages role=alert ng-show=\"vm.form.$dirty|| vm.form.$submitted\"><ng-message class=sp-settings-invalid-help-block when=pattern translate=Vehicles.error_coordinate_pattern></ng-message></ng-messages></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_coordinates\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><div class=form-group><div class=col-sm-offset-3><div class=checkbox><label><input type=checkbox ng-model=vm.shouldMirrorAddresses ng-change=vm.mirrorAddresses()> <span translate=Vehicles.use_address_detination></span></label></div></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.driver_lbl></label><div class=col-sm-7><select class=form-control name=default_driver ng-options=\"driver.name for driver in vm.drivers | orderBy:vm.naturalSort(\'name\'):false track by driver.id\" ng-model=vm.vehicle.default_driver ng-show=\"vm.drivers.length > 0\"><option value=\"\" translate=Vehicles.select_driver></option></select><div class=\"btn-group sp-btn-group-abilities-empty\" ng-show=\"vm.drivers.length === 0\"><span translate=Vehicles.without_drivers_1></span> <a href=\"\" ng-click=\"vm.changeState(\'settings.drivers.create\')\" translate=Vehicles.without_drivers_2></a> <span translate=Vehicles.without_drivers_3></span></div><ng-messages for=vm.form.default_driver.$error class=sp-form-messages role=alert ng-show=\"vm.form.default_driver.$dirty || vm.form.$submitted\"><ng-message class=sp-settings-invalid-help-block when=required translate=Vehicles.error_default_driver_required></ng-message><ng-message class=sp-settings-invalid-help-block when=invalid translate=Vehicles.error_limit_default_driver></ng-message></ng-messages></div></div><!-- Codrivers --><div class=form-group ng-if=\"vm.codrivers.length > 0\"><label class=\"col-sm-3 control-label\" translate=Vehicles.codrivers_lbl></label><div class=col-sm-7><!-- Vehicle with codrivers --><div class=sp-widget-co-driver-vehicle-settings ng-if=\"vm.vehicle.codrivers.length > 0\" ng-click=\"vm.showCodriversModal(vm.vehicle.name,\n                                                 vm.vehicle.codrivers,\n                                                 vm.codrivers)\"><span class=fa-stack><i class=\"sp-icon-user sp-icon-form fa-stack-2x\"></i> <span class=\"fa fa-stack-1x\"><div class=sp-icon-over-active><i class=\"fa fa-circle fa-stack-1x\"></i> <span class=\"fa fa-stack-1x sp-icon-over-text\">{{vm.vehicle.codrivers.length > 9 ? \'+9\' : vm.vehicle.codrivers.length}}</span></div></span></span></div><!-- Vehicle without codrivers --><div class=sp-widget-co-driver-vehicle-settings ng-if=\"vm.vehicle.codrivers.length == 0\" ng-click=\"vm.showCodriversModal(vm.vehicle.name,\n                                                 vm.vehicle.codrivers,\n                                                 vm.codrivers)\"><span class=fa-stack><i class=\"sp-icon-user sp-icon-form sp-icon-form-inactive\"></i> <span class=\"fa fa-stack-1x\"><div class=sp-icon-over-inactive><span class=\"fa fa-stack-1x sp-icon-over-inactive\"><i class=\"fa fa-plus-circle\"></i></span></div></span></span></div></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.schedule></label><div class=col-sm-7><div class=col-sm-4><input type=text class=\"form-control text-input-schedule\" name=shiftStart ng-model=vm.vehicle.shift_start ng-blur=vm.validateTime() translate translate-attr-placeholder=Vehicles.default_start_shift></div><label class=\"col-sm-4 text-center form-control-static\" translate=Vehicles.to></label><div class=col-sm-4><input type=text class=\"form-control text-input-schedule\" name=shiftEnd ng-model=vm.vehicle.shift_end ng-blur=vm.validateTime() translate translate-attr-placeholder=Vehicles.default_end_shift></div><div class=\"planner-error-date settings-error-date\"><p ng-if=vm.invalidDate class=sp-settings-invalid-help-block translate=Vehicles.error_format_date></p><p ng-if=vm.timeBetweenDate class=sp-settings-invalid-help-block translate=Vehicles.error_between_date></p><p ng-if=vm.emptyDate class=sp-settings-invalid-help-block translate=Vehicles.error_empty_date></p><p ng-if=vm.invalidDifferenceShiftRestStart class=sp-settings-invalid-help-block translate=Vehicles.error_invalid_difference_shift_rest_start></p><p ng-if=vm.invalidDifferenceShiftRestEnd class=sp-settings-invalid-help-block translate=Vehicles.error_invalid_difference_shift_rest_end></p></div></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_schedule\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><!-- Start rest time --><div class=form-group ng-if=vm.enableRestTime><label class=\"col-sm-3 control-label\" translate=Vehicles.rest_time_schedule></label><div class=col-sm-7><div class=col-sm-4><input type=text class=\"form-control text-input-schedule\" name=restTimeStart ng-model=vm.vehicle.rest_time_start ng-blur=vm.validateRestTime() translate translate-attr-placeholder=Vehicles.default_rest_time_start></div><label class=\"col-sm-4 text-center form-control-static\" translate=Vehicles.to></label><div class=col-sm-4><input type=text class=\"form-control text-input-schedule\" name=restTimeEnd ng-model=vm.vehicle.rest_time_end ng-blur=vm.validateRestTime() translate translate-attr-placeholder=Vehicles.default_rest_time_end></div><div class=\"planner-error-date settings-error-date\"><p ng-if=vm.invalidRestTime class=sp-settings-invalid-help-block translate=Vehicles.error_format_date></p><p ng-if=vm.restTimeBetweenDate class=sp-settings-invalid-help-block translate=Vehicles.error_between_date></p><p ng-if=vm.emptyRestTime class=sp-settings-invalid-help-block translate=Vehicles.error_empty_date></p><p ng-if=vm.invalidDifferenceShiftRestStart class=sp-settings-invalid-help-block translate=Vehicles.error_invalid_difference_rest_shift_start></p><p ng-if=vm.invalidDifferenceShiftRestEnd class=sp-settings-invalid-help-block translate=Vehicles.error_invalid_difference_rest_shift_end></p></div></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_rest_time\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><div class=form-group ng-if=vm.enableRestTime><label class=\"col-sm-3 control-label\" translate=Vehicles.rest_time_duration></label><div class=col-sm-7><input type=text maxlength=5 class=form-control name=rest_time_duration translate ng-blur=vm.validateRestTime() translate-attr-placeholder=Vehicles.placeholder_duration_rest_time ng-model=vm.vehicle.rest_time_duration capacity-input-format><div class=\"planner-error-date settings-error-date\"><p ng-if=vm.exceedsRestTimeDuration class=sp-settings-invalid-help-block translate=Vehicles.error_exceeds_rest_time_duration></p><p ng-if=vm.emptyRestTimeDuration class=sp-settings-invalid-help-block translate=Vehicles.error_empty_rest_time_duration></p><p ng-if=vm.invalidDuration class=sp-settings-invalid-help-block translate=Vehicles.error_invalid_duration></p></div></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_rest_time_duration\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><!-- End rest time --><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.cost_lbl></label><div class=col-sm-7><input type=text class=form-control name=cost translate translate-attr-placeholder=Vehicles.placeholder_name_cost ng-model=vm.vehicle.cost capacity-input-format><ng-messages for=vm.form.cost.$error class=sp-form-messages role=alert ng-show=\"vm.form.cost.$dirty || vm.form.$submitted\"></ng-messages></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_cost\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.skills_lbl></label><div class=\"col-sm-7 sp-style-skills\"><div class=\"btn-group sp-btn-group-abilities\" ng-show=\"vm.skills.length > 0\"><label class=\"btn sp-btn-abilities btn-primary\" ng-model=vm.skills_vehicle[skill.id] uib-btn-checkbox ng-repeat=\"skill in vm.skills\">{{skill.skill}}</label></div><div class=\"btn-group sp-btn-group-abilities-empty\" ng-show=\"vm.skills.length === 0\"><span translate=Vehicles.without_skill_1></span> <a href=\"\" ng-click=\"vm.changeState(\'settings.skills.list\')\" translate=Vehicles.without_skill_2></a> <span translate=Vehicles.without_skill_3></span></div></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_skills\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.min_load></label><div class=col-sm-7><input type=text class=form-control name=min_load translate translate-attr-placeholder=Vehicles.placeholder_name_min_load ng-model=vm.vehicle.min_load percentage-input-format><ng-messages for=vm.form.min_load.$error class=sp-form-messages role=alert ng-show=\"vm.form.min_load.$dirty || vm.form.$submitted\"></ng-messages></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_min_load\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.min_load_2></label><div class=col-sm-7><input type=text class=form-control name=min_load_2 translate translate-attr-placeholder=Vehicles.placeholder_name_min_load_2 ng-model=vm.vehicle.min_load_2 percentage-input-format><ng-messages for=vm.form.min_load_2.$error class=sp-form-messages role=alert ng-show=\"vm.form.min_load_2.$dirty || vm.form.$submitted\"></ng-messages></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_min_load_2\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.min_load_3></label><div class=col-sm-7><input type=text class=form-control name=min_load_3 translate translate-attr-placeholder=Vehicles.placeholder_name_min_load_3 ng-model=vm.vehicle.min_load_3 percentage-input-format><ng-messages for=vm.form.min_load_3.$error class=sp-form-messages role=alert ng-show=\"vm.form.min_load_3.$dirty || vm.form.$submitted\"></ng-messages></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_min_load_3\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.max_visit></label><div class=col-sm-7><input type=text class=form-control name=max_visit translate translate-attr-placeholder=Vehicles.placeholder_name_max_visit ng-model=vm.vehicle.max_visit capacity-input-format><ng-messages for=vm.form.max_visit.$error class=sp-form-messages role=alert ng-show=\"vm.form.max_visit.$dirty || vm.form.$submitted\"></ng-messages></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_max_visit\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Vehicles.max_time></label><div class=col-sm-7><input type=text class=form-control name=max_time translate ng-model=vm.vehicle.max_time id=max_time ng-change=vm.validateIsInteger(vm.vehicle.max_time)><ng-messages for=vm.form.max_visit.$error class=sp-form-messages role=alert ng-show=\"vm.form.max_time.$dirty || vm.form.$submitted\"><ng-message class=sp-settings-invalid-help-block when=integer translate=Vehicles.error_max_time></ng-message></ng-messages></div><div class=\"col-sm-2 capacity-input\"><button tooltip-placement=left type=button tooltip-class=tooltip-capacity-vehicles-detail uib-tooltip=\"{{\'Vehicles.tooltip_max_time\' | translate}}\"><i class=\"sp-icon-info capacity-icon\"></i></button></div></div></div><div class=form-group><div class=\"col-md-offset-3 col-md-9\"><p class=sp-settings-invalid-help-block ng-show=\"(vm.form.title.$dirty && vm.form.title.$invalid) ||\n             (vm.form.capacity.$dirty && vm.form.capacity.$invalid) ||\n             (vm.form.originAddress.$submitted && vm.form.originAddress.$invalid)\" translate=Vehicles.required_empty_fields_message></p></div></div><div class=\"col-md-12 sp-settings-right-side-form-action-buttons\"><div class=form-group><button class=\"btn btn-close pull-left\" type=button ng-click=vm.cancel() translate=Vehicles.close></button> <button class=\"btn btn-success pull-right\" type=submit ng-click=vm.form.submit() translate=Vehicles.save></button></div></div></form></div></div>");
$templateCache.put("app/settings/vehicles/vehicles-list.html","<div class=left-side><h1 class=section-title translate=vehicles></h1><div class=sp-settings-list-container><div class=sp-settings-action-bar><div class=col-md-6><div class=\"left-side sp-settings-list-container sp-settings-action-bar pull-left\"><form class=\"form-inline md-form form-sm active-cyan-2\"><input class=\"form-control form-control-sm mr-3 w-75\" type=text placeholder=\"{{ \'Communication.search\' | translate }}\" aria-label=Search ng-model=vm.searchText ng-change=vm.onChangeSearch() ng-model-options=\"{ debounce: 250 }\"> <span><i class=clean-icon ng-show=\"vm.searchText.length > 0\" ng-click=vm.cleanSearch()>✕</i></span></form></div></div><div class=col-md-6><div class=\"btn-group pull-right\" uib-dropdown><button id=single-button type=button class=\"btn btn-primary\" uib-dropdown-toggle><span translate=Vehicles.import_vehicles></span>&nbsp;<i class=caret></i></button><ul class=\"dropdown-menu sp-dropdown-container\" uib-dropdown-menu aria-haspopup=true aria-expanded=false><li role=menuitem><span ng-show=\"(vm.totalQuantityVehiclePlan > vm.safeSrcVehicles.length) && vm.ready\" class=\"btn btn-primary btn-file btn-excel-download\"><input type=file sp-file-change=\"vm.bulkCreate = true; vm.importVehicles($files)\"> <span translate=Vehicles.btn_new_vehicles></span> </span><button ng-show=\"(vm.totalQuantityVehiclePlan <= vm.safeSrcVehicles.length) && vm.ready\" class=\"btn btn-primary btn-file btn-excel-download\" type=button ng-click=vm.showUpdatePlanModal()><i class=sp-icon-circle-with-plus></i> <span style=color:#D59600 translate=Vehicles.btn_new_vehicles></span></button></li><li role=menuitem><span class=\"btn btn-primary btn-file btn-excel-download\"><input type=file sp-file-change=\"vm.bulkCreate = false; vm.importVehicles($files)\"> <span translate=Vehicles.btn_edit_vehicles></span></span></li><li role=menuitem><button class=\"btn btn-primary btn-file btn-excel-download\" type=button ng-click=vm.downloadList()><i class=sp-icon-excel></i> <span translate=Vehicles.btn_download_list></span></button></li></ul></div><button ng-show=\"(vm.totalQuantityVehiclePlan > vm.safeSrcVehicles.length) && vm.ready\" class=\"btn btn-primary pull-right\" type=button ng-click=vm.createVehicle() ng-disabled=\"vm.state.includes(\'settings.vehicles.create\') || vm.state.includes(\'settings.vehicles.detail\')\"><i class=sp-icon-circle-with-plus></i> <span translate=Vehicles.new_vehicle_btn></span></button> <button ng-show=\"(vm.totalQuantityVehiclePlan <= vm.safeSrcVehicles.length) && vm.ready\" class=\"btn btn-upgrade-plan pull-right\" type=button ng-click=vm.showUpdatePlanModal()><i class=sp-icon-circle-with-plus></i> <span translate=Vehicles.new_vehicle_btn></span></button><div class=\"pull-right total-items\" total-items=vm.safeSrcVehicles.length><span translate=total></span>: {{vm.safeSrcVehicles.length}}/{{vm.totalQuantityVehiclePlan}}</div></div></div><div class=sp-settings-content-list><div class=sp-table><div class=\"sp-table-row sp-table-header\"><div class=sp-table-row-item translate=Vehicles.title_table_header></div><div class=sp-table-row-item translate=Vehicles.capacity_table_header></div><div class=sp-table-row-item translate=Vehicles.origin_table_header></div><div class=sp-table-row-item translate=Vehicles.destination_table_header></div><div class=sp-table-row-item translate=Vehicles.driver_table_header></div><div class=sp-table-row-item ng-hide=\"vm.state.includes(\'settings.vehicles.create\') || vm.state.includes(\'settings.vehicles.detail\')\">&nbsp;</div></div><div cg-busy=\"{promise: vm.promiseLoading, backdrop:true, templateUrl:\'app/shared/html/loading.html\'}\" ng-show=!vm.ready style=height:200px></div><div ng-show=\"(vm.safeSrcVehicles.length > 0) && vm.ready\" class=sp-table-row ng-repeat=\"vehicle in vm.safeSrcVehicles.slice(((vm.pagination.currentPage-1)*vm.pagination.itemsPerPage),\n             ((vm.pagination.currentPage)*vm.pagination.itemsPerPage)) | filter:searchText \"><div class=sp-table-row-item>{{vehicle.name}}</div><div class=sp-table-row-item>{{vehicle.capacity | formatNumber:2}}</div><div class=sp-table-row-item alt={{vehicle.location_start_address}}>{{vehicle.location_start_address}}</div><div class=sp-table-row-item>{{vehicle.location_end_address}}</div><div class=sp-table-row-item>{{vehicle.default_driver.name ? vehicle.default_driver.name: vm.getDriverName(vehicle.default_driver)}}</div><div class=sp-table-row-item ng-hide=\"vm.state.includes(\'settings.vehicles.create\') || vm.state.includes(\'settings.vehicles.detail\')\"><a ui-sref=\"settings.vehicles.detail({vehicleId: vehicle.id})\" translate=Vehicles.edit></a></div></div><div ng-show=\"vm.safeSrcVehicles.length > 0\" class=\"sp-settings-pagination text-right\"><uib-pagination total-items=vm.safeSrcVehicles.length ng-model=vm.pagination.currentPage max-size=vm.pagination.maxSize class=pagination-sm boundary-links=true items-per-page=vm.pagination.itemsPerPage ng-change=vm.pagination.pageChanged() first-text={{pagination.firstText}} last-text={{pagination.lastText}} next-text={{pagination.nexText}} previous-text={{pagination.previousText}}></uib-pagination></div><div ng-show=\"vm.safeSrcVehicles.length === 0 && !vm.searching && vm.ready && !vm.errorPath\" class=\"sp-table-row sp-empty-data\"><span class=title translate=Vehicles.without_vehicle_1></span><div class=content><span class=paragraph translate=Vehicles.without_vehicle_2></span> <a ui-sref=settings.vehicles.create class=link translate=Vehicles.without_vehicle_3></a> <span class=paragraph translate=Vehicles.without_vehicle_4></span><br></div></div><div ng-show=\"vm.safeSrcVehicles.length === 0 && vm.searching && vm.ready && !vm.errorPath\" class=\"sp-table-row sp-empty-data\"><span class=title translate=Vehicles.without_vehicle_searching></span></div></div></div></div></div><div class=right-side ng-show=\"!vm.state.includes(\'**.settings.vehicles.list\')\" ui-view></div>");
$templateCache.put("app/settings/zones/zone-delete-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Zones.Delete.title></h3></div><div class=modal-body><p style=\"text-align: center\"><span translate=Zones.Delete.irreversible_action></span><br><span translate=Zones.Delete.want_continue></span></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog() translate=Zones.Delete.button_cancel></button> <button type=button class=\"btn btn-danger\" ng-click=confirm() translate=Zones.Delete.button_delete></button></div></div>");
$templateCache.put("app/settings/zones/zone-edit.html","<div class=sp-add-zone-container><div class=sp-add-zone-title><input class=form-control type=text ng-model=vm.zone.name translate translate-attr-placeholder=Zones.Edit.input_placeholder></div><zone-map data=vm.zone></zone-map><selectable-items-list data=vm.dataSelectableItemsList items-selected=vm.dataSelectableItemsSelected items-per-page=12></selectable-items-list><div class=\"row validation-error-name\" ng-if=vm.nameError><div class=\"col-sm-12 text-center\"><span class=text-danger translate=Zones.validation_error_name></span></div></div><div ng-if=!vm.isMultidayRouteEnabled><p translate=Zones.weekdays.active_days></p><div class=\"sp-select-all sp-check-day\"><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-checked=vm.isEveryDaySelected ng-model=vm.isEveryDaySelected ng-click=vm.selectEveryDay()><label><span class=sp-icon-check></span></label></div><span class=sp-day-name translate=Zones.weekdays.every_day></span></div><div class=\"sp-select-all sp-check-day\" ng-repeat=\"day in vm.weekdays\"><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-model=day.checked ng-click=vm.updateZoneSchedules(day.name)><label><span class=sp-icon-check></span></label></div><span class=sp-day-name translate=Zones.weekdays.{{day.name}}></span></div><div class=row ng-if=!vm.zone.schedules.length><div class=col-sm-12><span class=text-danger translate=Zones.weekdays.selection_validation_error></span></div></div></div><div class=sp-add-zone-buttons><button class=\"btn sp-btn-default\" ng-click=vm.closeModal() translate=Zones.Edit.cancel></button> <button class=\"btn btn-success\" ng-click=vm.saveZone() ng-disabled=\"!vm.zone.coordinates || vm.zone.coordinates.length === 0 || !vm.zone.name || !vm.zone.schedules.length\" translate=Zones.Edit.save></button></div></div>");
$templateCache.put("app/settings/zones/zones-bulk-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-success\"><h3 class=modal-title translate=Zones.Bulk.result_modal_title></h3></div><div class=modal-body><p translate=Zones.Bulk.result_modal_upload_success></p><p ng-if=\"validRequest === \'WITH_ERRORS\'\" translate=Zones.Bulk.resut_modal_upload_with_errors></p></div><div class=bulk-result-container ng-if=\"validRequest === \'WITH_ERRORS\'\"><div class=\"sp-bulk-result-row header\"><div class=\"sp-bulk-result-column row-number\"><span translate=Zones.Bulk.result_modal_row_header></span></div><div class=\"sp-bulk-result-column error\"><span translate=Zones.Bulk.result_modal_error_header></span></div></div><div ng-repeat=\"obj in errorInfo\"><div ng-if=obj.errors.length class=sp-bulk-result-data-row><div class=row-number>{{obj.rowNumber}}</div><div class=error-description><div ng-repeat=\"error in obj.errors\"><div ng-if=\"error.desc === \'VEHICLE_NOT_FOUND\'\">{{error.value}}: <span translate=Zones.Bulk.result_modal_error_vehicle_not_found></span></div><div ng-if=\"error.desc === \'ZONE_NOT_FOUND\'\">{{error.value}}: <span translate=Zones.Bulk.result_modal_error_zone_not_found></span></div></div></div></div></div></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Visits.close></button></div></div>");
$templateCache.put("app/settings/zones/zones.html","<div class=sp-zones-container><h1 class=section-title translate=zones></h1><div class=control-bar><div class=group-control-bar><div class=control-element><button type=button class=\"btn btn-primary btn-file-zones\"><input type=file sp-file-change=vm.importZones($files)> <span translate=Zones.Bulk.btn_import_zones></span></button></div><div class=control-element><button class=\"btn btn-primary\" type=button ng-click=vm.downloadZones()><i class=sp-icon-excel></i> <span translate=Zones.Bulk.btn_download_zones></span></button></div></div><div class=config-zone-container><div class=\"group-control-bar fix-control\" ng-if=!vm.isMultidayRouteEnabled><div class=control-element><weekday-checkbox-group title={{vm.filterTitle}} component-id=settings-zones-weekday-filter on-change=vm.onSelectedWeekdaysChanged(selectedWeekdays)></weekday-checkbox-group></div></div><div id=zone-configuration-menu class=\"pull-right container-zone-config-options\" uib-dropdown auto-close=outsideClick is-open=vm.isZoneConfigMenuOpen><button type=button uib-dropdown-toggle class=setting-button ng-class=\"{\'clicked\': vm.isZoneConfigMenuOpen }\"><div ng-include=\"\'/assets/images/setting.svg\'\" class=setting-icon ng-class=\"{\'light\': vm.isZoneConfigMenuOpen }\"></div></button><ul class=\"dropdown-menu zone-config-options\" uib-dropdown-menu><span class=zone-config-title translate=Zones.zone_configuration_title></span><li role=menuitem id=activate-zone-use><toggle-switch input-id={{vm.actionUseZones.inputId}} input-name={{vm.actionUseZones.inputName}} is-active=vm.actionUseZones.value on-change=\"vm.handleZoneSwitchChange(name, isActive)\" label-text=\"{{vm.translate(\'Zones.activate_zone_usage\')}}\"></toggle-switch></li><li role=menuitem id=auto-zone-assignment><toggle-switch input-id={{vm.actionUseAutoZones.inputId}} input-name={{vm.actionUseAutoZones.inputName}} is-active=vm.actionUseAutoZones.value on-change=\"vm.handleZoneSwitchChange(name, isActive)\" is-disabled=!vm.actionUseZones.value label-text=\"{{vm.translate(\'Zones.automatic_assignment\')}}\"></toggle-switch></li></ul></div></div></div><div class=row><div class=\"sp-zones-add col-md-3\" ng-click=vm.addZone()><div class=sp-zones-add-action><svg version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 32 32\" enable-background=\"new 0 0 32 32\" xml:space=preserve><g id=mas><path d=\"M16,5c6,0,11,4.9,11,11c0,6-4.9,11-11,11c-6,0-11-4.9-11-11C5.1,10,10,5,16,5 M16,2c-7.7,0-14,6.3-14,14\n            c0,7.7,6.3,14,14,14c7.7,0,14-6.3,14-14C30,8.3,23.8,2,16,2L16,2z\"/><path d=\"M22.8,14.7h-5.5V9.3C17.3,8.6,16.7,8,16,8c-0.7,0-1.3,0.6-1.3,1.3v5.4H9.3c-0.7,0-1.3,0.6-1.3,1.3\n            c0,0.7,0.6,1.3,1.3,1.3h5.4v5.5c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3v-5.5h5.5c0.7,0,1.3-0.6,1.3-1.3\n            C24.1,15.2,23.5,14.7,22.8,14.7z\"/></g></svg> <span translate=Zones.add_zone></span></div></div><zone class=\"sp-zones-item col-md-3\" ng-repeat=\"zone in vm.zones | orderBy:vm.naturalSort(\'name\'):false\" data=zone schedules=zone.schedules coordinates=zone.coordinates call-to-edit=vm.editZone(zoneObj) call-to-delete=vm.confirmDelete(zoneId) call-to-save=vm.updateZone(zoneObj)></zone></div></div>");
$templateCache.put("app/shared/components/editableInput.html","<div class=editable-input><div class=info ng-if=!$ctrl.enableEdition><span>{{$ctrl.model}}</span> <button class=\"btn btn-default btn-xs editable-btn\" ng-click=$ctrl.setEdition(true) ng-if=!$ctrl.editionDisabled><i class=sp-icon-edit></i></button></div><div class=edition ng-if=$ctrl.enableEdition><input type=text class=form-control ng-blur=$ctrl.setEdition(false) ng-enter=$ctrl.setEdition(false) ng-model=$ctrl.model autofocus></div></div>");
$templateCache.put("app/shared/components/selectableItemsList.html","<div class=sp-item-container><div class=sp-item-container-top><!-- Title Component --><div class=sp-item-container-title ng-if=$ctrl.data.title><i class={{$ctrl.data.icon}}></i> <span>{{$ctrl.data.title}}</span> <span>({{$ctrl.data.itemsSelected}})</span></div><div class=sp-item-container-search ng-class=\"{ \'complete-width\': $ctrl.data.plansModule }\"><input type=text class=\"form-control dispatchs-input-header\" ng-model=$ctrl.searchKeyword placeholder=\"{{ $ctrl.data.plansModule ? (\'Communication.search\' | translate) : \'\' }}\"> <i class=sp-icon-search ng-if=!$ctrl.searchKeyword></i></div></div><div class=\"row sp-item-container-list\" ng-class=\"{ \'specific-height\': $ctrl.data.plansModule }\"><div class=\"col-sm-3 item sp-select-all\" ng-repeat=\"item in $ctrl.listFilter = ($ctrl.data.items | filter:$ctrl.searchKeyword | orderBy:$ctrl.naturalSort(\'name\'):false) |\n         limitTo: $ctrl.itemsPerPage : (($ctrl.currentPage -1) * $ctrl.itemsPerPage)\"><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-model=item.activate ng-change=$ctrl.updateItemSelected(item.activate)><label><span class=sp-icon-check></span></label></div><span class=item-name>{{item.name}}</span></div><div class=sp-item-filter-empty ng-if=\"$ctrl.listFilter.length === 0 && $ctrl.data.items.length > 0\"><span translate=Zones.Items_list.msg_empty_filter></span></div><div class=sp-item-list-empty ng-if=\"$ctrl.data.items.length === 0 && $ctrl.data.callActionUrl\"><span>{{$ctrl.data.msgItemsEmpty}}</span> <button class=\"btn btn-primary\" ng-click=$ctrl.goToAction()>{{$ctrl.data.callAction}}</button></div></div><div class=sp-item-pagination ng-show=\"$ctrl.data.items.length > $ctrl.itemsPerPage\"><uib-pagination total-items=$ctrl.listFilter.length class=pagination-sm ng-change=$ctrl.pageChanged() boundary-links=true ng-model=$ctrl.currentPage max-size=$ctrl.maxSize items-per-page=$ctrl.itemsPerPage previous-text=\"<\" next-text=\">\"></uib-pagination></div></div>");
$templateCache.put("app/shared/html/loading.html","<div style=\"background-image:url(\'../../../assets/images/loading.gif\');background-position:50% 50%;background-repeat:no-repeat;background-size:180px 180px\"></div>");
$templateCache.put("app/shared/toast/toast.html","<ul class=toasts><li class={{toast.type}} ng-class=\"{\'dismiss\': toast.dismiss}\" ng-repeat=\"toast in toasts\"><div class=\"toast-icon mg-r-15\"><i class=\"fa {{getIcon(toast.type)}}\"></i></div><div class=toast-message ng-bind-html=toast.message></div><div class=dismiss-btn ng-if=toast.dismiss ng-click=remove(toast)>{{ \'Toast.accept\' | translate }}</div></li></ul>");
$templateCache.put("app/tracking/dispatchs/all-dispatchs.html","<div class=sp-tracking-dispatchs><div class=\"sp-tracking-header sp-tracking-search-input\" ng-if=!vm.withoutVisits><form class=form-inline ng-submit=vm.searchVisit()><input type=text class=\"form-control dispatchs-input-header\" ng-model=vm.searchKeyword ng-change=vm.checkClearKeyWord()> <button type=submit class=\"btn btn-primary btn-search-visits\" ng-disabled=\"vm.searchKeyword.length < 3\" ng-click=vm.searchVisit()><i class=sp-icon-search></i></button> <button type=button class=\"btn btn-clear-visit\" ng-show=vm.searchKeyword ng-click=vm.clearInputVisit()><i class=\"fa fa-close\"></i></button></form></div><!-- end sp-tracking-header --><div class=sp-tracking-scrollable><div class=list-group ng-if=\"!vm.withoutVisits && !vm.loadingData\"><a class=\"list-group-item sp-tracking-dispatch-item\" ng-repeat=\"visit in vm.visits | trackingSearchVisits: searchKeyword track by visit.id\" ng-class=vm.getVisitNgClass(visit) ng-click=vm.openModal(visit.id) href=\"\" callback=vm.filterVehicles(vm.visits);><div class=sp-tracking-dispatch-content><div class=sp-tracking-dispatch-header><div class=sp-tracking-dispatch-title>{{visit.title}}<div class=has-alert ng-if=::visit.hasAlert></div></div><div class=sp-tracking-dispatch-status-container><i class=sp-icon-despacho-fallido ng-show=\"visit.status === \'canceled\'\" style=color:gray></i> <i class=sp-icon-despacho-entregado ng-show=\"visit.status === \'completed\'\" style=color:#41D3BD></i> <i class=sp-icon-despacho-fallido ng-show=\"visit.status === \'failed\'\" style=color:#FF5252></i> <img class=sp-icon-despacho-parcial ng-show=\"visit.status === \'partial\'\" ng-src=/assets/images/entrega-parcial.svg style=\"margin-left: 10px\"> <i class=sp-icon-despacho-atrasado ng-show=\"visit.status === \'pending\'\"></i></div></div><!-- end sp-tracking-dispatch-header --><div class=\"text-muted sp-tracking-dispatch-address all\">{{visit.address}}</div></div><!-- end sp-tracking-dispatch-content--> </a><!-- end sp-tracking-dispatch-item --></div><!-- end list-group --><div ng-if=\"vm.withoutVisits && !vm.visitsFiltersEmpty && !vm.loadingData\" class=sp-tracking-scrollable-empty-data><h3 translate=Visits.without_visits_title></h3><img ng-src=/assets/images/sin-visitas.svg></div><!-- end empty-data --><div ng-if=vm.visitsFiltersEmpty class=sp-tracking-scrollable-empty-data><h3 translate=Visits.without_visits_filter></h3><p><span translate=Visits.without_visits_filter_message></span></p><img ng-src=/assets/images/sin-visitas.svg></div><!-- end empty-data --><!--Loading Data--><div class=sp-container-loading ng-if=vm.loadingData><img src=/assets/images/loading.gif width=180 height=180></div></div><!-- end sp-tracking-scrollable --></div><!-- end sp-tracking-dispatchs -->");
$templateCache.put("app/tracking/dispatchs/dispatch-detail.html","<div class=sp-modal-content><div class=modal-header ng-class=\"{\'modal-header-danger\': vm.visit.status === \'failed\',\n         \'modal-header-success\': vm.visit.status === \'completed\', \'modal-header-canceled\': vm.visit.status === \'canceled\',\n         \'modal-header-pending\': vm.visit.status === \'pending\', \'modal-header-partial\': vm.visit.status === \'partial\'}\"><div class=header-info><div class=header-number>{{vm.visit.order}}</div><div><h4 class=modal-title>{{vm.visit.title}}</h4><h5 class=modal-title>{{vm.visitStatusTranslation}}</h5></div></div></div><div class=join-similar-info-container ng-show=vm.visitsOnListDisplay.length><div class=similar-notify style=\"background-color: {{vm.color}}\"><img src=../../../assets/images/unite-similars-white.svg> <span translate=Visits.join_similar></span></div><div class=image-list-container><div class=navigation-container ng-show=vm.showLeftArrow ng-click=\"vm.changeVisitsOnDisplay(\'left\')\"><div class=navigation-arrow><img src=../../../assets/images/navigate-left.svg alt=\"\"></div></div><div class=visit-list-display><div class=visit-info ng-style=\"vm.visit.id === visit.id ? {\'background-color\': vm.lighterColor, \'border-color\': vm.color, \'border-width\': \'1px\', \'border-style\': \'solid\'} : {}\" ng-repeat=\"visit in vm.visitsOnListDisplay track by $index\" ng-click=vm.changeVisit(visit.id)>{{visit.displayTitle}}</div></div><div class=navigation-container ng-show=vm.showRightArrow ng-click=\"vm.changeVisitsOnDisplay(\'right\')\"><div class=navigation-arrow><img src=../../../assets/images/navigate-right.svg alt=\"\"></div></div></div></div><div class=modal-subheader><!-- address --><div class=info-column><div class=label-row translate=Visits.modal_body_visit_location></div><div class=content-row>{{vm.visit.address}}</div></div><!-- reference --><div class=info-column><div class=label-row>ID</div><div class=content-row ng-show=vm.visit.reference>{{vm.visit.reference}}</div><div class=content-row ng-show=!vm.visit.reference>-</div></div><!-- planned date --><div class=info-column><div class=label-row translate=Visits.modal_body_visit_date></div><div class=content-row>{{vm.visit.planned_date}}</div></div></div><div class=invoice-back-btn-container><div class=\"invoice-back-btn btn-back-items\" ng-show=vm.isInvoicesTableVisible><button class=\"btn btn-primary btn-back-items\" ng-click=vm.hideInvoicesTable()><img ng-src=/assets/images/arrow_back_white.svg alt=\"\"> <span translate=Items.go_back></span></button></div></div><div class=\"modal-body sp-tracking-modal\" ng-show=!vm.isInvoicesTableVisible><div class=sp-tracking-modal-info><div ng-show=\"!vm.moreData && !vm.areItemsDetailsVisible\" class=info-view><!-- Info visit --><div class=title><span class=span-info-visit translate=Visits.modal_body_visit_info></span></div><!-- Invoices button --><div ng-show=vm.shouldShowInvoicesBtn()><div class=info-row><span class=label-row translate=Invoices.items></span><div class=content-row><span>{{vm.totalInvoicesDeliveredUnits()}}</span> <span translate=Invoices.delivered_products></span> <span>{{vm.totalInvoicesUnits()}}</span></div></div><div class=info-row><span class=label-row></span><div class=content-row><div class=items-button ng-click=vm.showInvoicesTable()><img ng-src=/assets/images/list_alt_white.svg alt=\"\"> <span translate=Invoices.see_invoices></span></div></div></div></div><!-- Items --><div class=info-row ng-show=\"vm.shouldShowItemsRow(vm.visit, vm.ITEMS)\"><span class=label-row translate=Items.items></span> <span class=content-row>{{vm.visit.itemsQuantitySummary}}</span></div><div class=info-row ng-show=\"vm.shouldShowItemsRow(vm.visit, vm.ITEMS)\"><span class=label-row></span><div class=content-row><div class=items-button ng-click=\"vm.showItemsDetailsTable(vm.visit, vm.ITEMS)\"><img ng-src=/assets/images/list_alt_white.svg alt=\"\"> <span translate=Items.show_items></span></div></div></div><!-- Pickup items --><div class=info-row ng-show=\"vm.shouldShowItemsRow(vm.visit, vm.PICKUP_ITEMS)\"><span class=label-row translate=Items.items></span> <span class=content-row>{{vm.visit.pickupItemsQuantitySummary}}</span></div><div class=info-row ng-show=\"vm.shouldShowItemsRow(vm.visit, vm.PICKUP_ITEMS)\"><span class=label-row></span><div class=content-row><div class=items-button ng-click=\"vm.showItemsDetailsTable(vm.visit, vm.PICKUP_ITEMS)\"><img ng-src=/assets/images/list_alt_white.svg alt=\"\"> <span translate=Items.show_items></span></div></div></div><!-- ETA --><div class=info-row><span class=label-row translate=Visits.modal_body_visit_estimated_time></span> <span class=content-row>{{vm.calculateETA()}}</span></div><!-- Checkin --><div class=info-row ng-if=vm.visit.checkin_time><span class=label-row translate=Visits.modal_body_visit_check_in></span> <span class=content-row>{{vm.visit.checkin_time}}</span></div><!-- Checkout --><div class=info-row><span class=label-row translate=Visits.modal_body_visit_check_out></span> <span class=content-row ng-show=\"vm.visit.status !== \'pending\' && vm.visit.checkout_time\">{{vm.visit.checkout_time}} <a href=\"\" ng-click=\"active = 1\" ng-show=vm.distanceCheckoutVisit class=link-to-map>{{vm.distanceCheckoutVisit}}</a> </span><span class=content-row ng-if=\"vm.visit.status === \'pending\' && !vm.visit.checkout_time\" translate=Visits.modal_checkout_pending></span></div><!-- Service Time --><div class=info-row ng-show=vm.visit.time_service><span class=label-row translate=Visits.modal_body_visit_time_service></span> <span class=content-row>{{vm.visit.calculated_service_time}}</span></div><!-- Window --><div class=info-row ng-show=\"vm.visit.window_start || vm.visit.window_end || vm.visit.window_start_2 || vm.visit.window_end\"><span class=label-row translate=Visits.modal_body_visit_time_window></span><div class=content-row><!-- inicio de ventana horaria 1 --><div class=\"col-sm-12 sp-tracking-time-window\" ng-show=\"vm.visit.window_start && vm.visit.window_end\"><p>{{vm.visit.window_start}}</p><p class=text-separator translate=Visits.modal_time_window_to></p><p>{{vm.visit.window_end}}</p></div><div class=\"col-sm-12 sp-tracking-time-window\" ng-show=\"!vm.visit.window_start && vm.visit.window_end\"><p translate=Visits.modal_time_window_until_to></p><p>{{vm.visit.window_end}}</p></div><div class=\"col-sm-12 sp-tracking-time-window\" ng-show=\"vm.visit.window_start && !vm.visit.window_end\"><p translate=Visits.modal_time_window_since></p><p>{{vm.visit.window_start}}</p></div><!-- fin de ventana horaria 1--><!-- inicio de ventana horaria 2 --><div class=\"col-sm-12 sp-tracking-time-window\" ng-show=\"vm.visit.window_start_2 && vm.visit.window_end_2 && vm.hasSecondTimeWindow\"><p>{{vm.visit.window_start_2}}</p><p class=text-separator translate=Visits.modal_time_window_to></p><p>{{vm.visit.window_end_2}}</p></div><div class=\"col-sm-12 sp-tracking-time-window\" ng-show=\"!vm.visit.window_start_2 && vm.visit.window_end_2 && vm.hasSecondTimeWindow\"><p translate=Visits.modal_time_window_until_to></p><p>{{vm.visit.window_end_2}}</p></div><div class=\"col-sm-12 sp-tracking-time-window\" ng-show=\"vm.visit.window_start_2 && !vm.visit.window_end_2 && vm.hasSecondTimeWindow\"><p translate=Visits.modal_time_window_since></p><p>{{vm.visit.window_start_2}}</p></div><!-- fin de ventana horaria 2--></div></div><!-- Driver--><div class=info-row><span class=label-row translate=Driver.driver></span> <span class=content-row>{{vm.visit.driver_name}}</span></div><!-- Codriver--><div class=info-row ng-show=\"vm.visit.codrivers && vm.visit.codrivers.length\"><span class=label-row translate=Driver.codrivers></span><div><span class=multivalued-content-row ng-repeat=\"codriver in vm.visit.codrivers\">{{codriver.name}}</span></div></div><!-- Checkout author --><div class=info-row ng-show=\"vm.visit.status !== \'pending\' && vm.visit.checkout_author && vm.visit.checkout_author.name\"><span class=label-row translate=Visits.checkout_author></span> <span class=content-row>{{vm.visit.checkout_author.name}}</span></div><!-- Vehicle --><div class=info-row><strong class=label-row translate=Vehicle.vehicle></strong> <strong class=content-row>{{vm.visit.vehicle_name}}</strong></div><!-- Checkout observation --><div class=info-row ng-show=vm.visit.checkout_observation><span class=label-row translate=Visits.modal_body_visit_observations></span> <span class=content-row>{{vm.visit.checkout_observation}}</span></div><!-- Checkout comment --><div class=info-row ng-show=vm.visit.checkout_comment><span class=label-row translate=Visits.modal_body_visit_comments></span> <span class=\"content-row text-oblique\">{{vm.visit.checkout_comment}}</span></div><!-- Contact Name --><div class=info-row ng-show=\"vm.visit.contact_name && vm.showContactInfo\"><span class=label-row translate=Visits.modal_body_visit_contact_name></span> <span class=\"content-row text-break-word\">{{vm.visit.contact_name}}</span></div><!-- Contact Phone --><div class=info-row ng-show=\"vm.visit.contact_phone && vm.showContactInfo\"><span class=label-row translate=Visits.modal_body_visit_contact_phone></span> <span class=\"content-row text-break-all\">{{vm.visit.contact_phone}}</span></div><!-- Contact Email--><div class=info-row ng-show=\"vm.visit.contact_email && vm.showContactInfo\"><span class=label-row translate=Visits.modal_body_visit_contact_email></span> <span class=\"content-row text-break-all\">{{vm.visit.contact_email}}</span></div></div><!-- Action more data --><div class=action-to-more-data ng-if=\"(vm.enableMoreData) && !vm.moreData && !vm.areItemsDetailsVisible\"><a href=\"\" class=sp-link-more-information ng-click=\"vm.moreData = true\" translate=Visits.show_extra_fields></a></div><div ng-show=vm.moreData class=\"info-view info-more-data\"><!-- Title --><div class=\"title title-visit\"><span translate=Visits.extra_fields_value></span></div><table><tr ng-show=vm.visit.notes><td translate=Visits.notes class=visit-extrafield-label></td><td class=visit-extrafield-content>{{vm.visit.notes}}</td></tr><tr ng-show=vm.visit.load><td translate=Visits.modal_body_visit_load class=visit-extrafield-label></td><td class=visit-extrafield-content>{{vm.visit.load}}</td></tr><tr ng-show=vm.visit.load2><td translate=Visits.modal_body_visit_load_2 class=visit-extrafield-label></td><td class=visit-extrafield-content>{{vm.visit.load2}}</td></tr><tr ng-show=vm.visit.load3><td translate=Visits.modal_body_visit_load_3 class=visit-extrafield-label></td><td class=visit-extrafield-content>{{vm.visit.load3}}</td></tr><tbody ng-repeat=\"extrafield in vm.extraFields\"><tr ng-if=\"extrafield.type !== \'RDD\' && extrafield.type !== \'PIC\'\"><td class=visit-extrafield-label>{{extrafield.label}}</td><td class=visit-extrafield-content>{{extrafield.value}}</td></tr><tr ng-if=\"extrafield.type === \'RDD\'\"><td class=visit-extrafield-label>{{extrafield.topLabel}}</td><td class=visit-extrafield-content>{{extrafield.topLabelValue}}</td></tr><tr ng-if=\"extrafield.type === \'RDD\'\"><td class=visit-extrafield-label>{{extrafield.secondLabel}}</td><td class=visit-extrafield-content>{{extrafield.secondLabelValue}}</td></tr><tr ng-if=\"extrafield.type === \'PIC\'\"><td class=visit-extrafield-label>{{extrafield.label}}</td><td class=visit-extrafield-content ng-bind-html=extrafield.url></td></tr></tbody></table></div><div class=action-to-more-data ng-if=\"vm.moreData && !areItemsDetailsVisible\"><a href=\"\" class=sp-link-more-information ng-click=\"vm.moreData = false\" translate=Visits.hide_extra_fields></a></div></div><div class=sp-tracking-modal-tab-container ng-show=!vm.areItemsDetailsVisible><uib-tabset active=active justified=true class=sp-tracking-modal-tab><uib-tab index=0 heading=\"{{\'Visits.attach\' | translate}}\"><div id=image-download class=sp-tracking-modal-carousel ng-if=\" vm.visit.pictures.length > 0\"><uib-carousel active=active no-wrap=false><uib-slide ng-repeat=\"slide in  vm.visit.pictures track by $index\" index=$index><img ng-src={{slide}} style=margin:auto></uib-slide></uib-carousel><a href=\"\" class=attach-image-carousel id=download-picture ng-click=vm.download(vm.visit) translate=Tracking.download_pictures></a></div><div class=sp-tracking-modal-no-picture ng-if=\"!vm.visit.pictures.length > 0\"><span translate=Tracking.without_pictures></span></div></uib-tab><uib-tab index=1 heading=\"{{\'Visits.map\' | translate}}\"><div class=empty-checkout><div class=tab-not-checkout ng-if=vm.infoNotCheckout><span translate=Visits.pending_checkout></span></div><div class=tab-not-checkout ng-if=vm.infoNotCheckoutLatLng><span translate=Visits.not_checkout></span></div></div><div class=static-map ng-if=vm.showMap><static-map width=350 height=560 markers=vm.markers map-provider=vm.mapProvider></static-map></div></uib-tab></uib-tabset></div></div><items-details-table ng-if=vm.areItemsDetailsVisible are-items-details-visible=vm.areItemsDetailsVisible items-type=vm.itemsType items-quantity-summary=vm.itemsQuantitySummary items=vm.items visit-status=vm.visit.status items-statistics=vm.itemsStatistics></items-details-table><div class=invoice-modal-content ng-show=vm.isInvoicesTableVisible><invoice-details-table visit=vm.visit ng-if=vm.visit.invoices.length></invoice-details-table></div></div>");
$templateCache.put("app/tracking/dispatchs/driver-dispatchs.html","<div class=sp-tracking-dispatchs><div class=sp-tracking-header><div class=sp-tracking-dispatchs-driver-heading-title><div class=tracking-dispatchs-driver-main uib-tooltip={{vm.driverTranslate}}><img src=../../../assets/images/driver-icon-tracking.svg class=driver-icon-tracking> <span class=driver-name ng-if=vm.vehicle.driver>{{vm.vehicle.driver.name}}</span> <span class=driver-name-empty ng-if=!vm.vehicle.driver translate=Driver.without_assigned_driver></span></div><div class=tracking-dispatchs-driver-details ng-if=\"vm.vehicle.driver && vm.vehicle.driver.batteryLevel\"><img src=../../../assets/images/{{vm.checkBatteryLevel(vm.vehicle.driver.batteryLevel)}} class=phone-icon-tracking> <span class=phone>{{vm.vehicle.driver.batteryLevel}}%</span></div><div class=tracking-dispatchs-driver-details ng-if=vm.vehicle.driver.phone><img src=../../../assets/images/cellphone.svg class=phone-icon-tracking> <span class=phone>{{vm.vehicle.driver.phone}}</span></div><div class=tracking-dispatchs-codriver-container uib-tooltip={{vm.codriverTranslate}} ng-if=\"vm.vehicle.codrivers && vm.vehicle.codrivers.length\" ng-repeat=\"codriver in vm.vehicle.codrivers\"><img src=../../../assets/images/codriver-icon-tracking.svg class=codriver-icon-tracking> <span class=codriver-name>{{codriver.name}}</span></div></div></div><!-- end sp-tracking-header --><!--tracking detail tabs--><div class=sp-tracking-dispatchs-driver-tabs><div class=tab ng-class=\"{\'selected\': vm.visitsTabSelected}\" ng-click=\"vm.selectTab(\'visits\')\" translate=Tracking.visits></div><div class=tab ng-class=\"{\'selected\': vm.eventsTabSelected}\" ng-click=\"vm.selectTab(\'events\')\" translate=Tracking.events></div></div><!--end tracking detail tabs--><div class=sp-tracking-scrollable><div class=list-group ng-if=\"!vm.loadingData && vm.visitsTabSelected && vm.visits.length > 0\"><div class=item-info-container ng-show=vm.showItemsInformation uib-tooltip=\"{{\'Items.items_tooltip\' | translate}}\"><div><span>{{vm.itemsInformation.quantity}}</span> <span class=item-data-text translate=Items.assigned_items></span></div><div><span>{{vm.itemsInformation.completedPercentage}}%</span> <span class=item-data-text translate=Items.completed_total></span></div><div><span>{{vm.itemsInformation.partialPercentage}}%</span> <span class=item-data-text translate=Items.partial_total></span></div><div><span>{{vm.itemsInformation.failedPercentage}}%</span> <span class=item-data-text translate=Items.failed_total></span></div></div><div class=list-group-route ng-repeat=\"route in vm.routes track by route.id\"><div class=route-title><div uib-tooltip=\"{{route.reference.length > 7 ? route.reference : \'\'}}\"><span translate=Tracking.route></span> {{$index+1}}: {{vm.shortRefNumber(route.reference)}}</div><div class=sp-tracking-visits-order-options-container ng-if=!$index><span translate=Tracking.order_by class=sp-tracking-visits-order-text></span> <a class=\"btn btn-primary order-by-button\" ng-click=\"vm.orderVisitsBy(\'order\')\" ng-class=\"{\'deselected\': vm.orderVisitsProperty === \'order\'}\" uib-tooltip=\"{{\'Tracking.eta_tooltip\' | translate}}\"><i class=sp-icon-ventana-horaria></i> </a><a class=\"btn btn-primary order-by-button\" ng-click=\"vm.orderVisitsBy(\'checkout_time\')\" ng-class=\"{\'deselected\': vm.orderVisitsProperty === \'checkout_time\'}\" uib-tooltip=\"{{\'Tracking.checkout_time_tooltip\' | translate}}\"><i class=sp-icon-vehiculos></i></a></div></div><div class=sp-tracking-route-indicators ng-class=\"{\'expanded\': route.expandedIndicators}\"><div class=sp-indicators-container ng-if=route.expandedIndicators><div class=sp-indicator ng-if=route.totalLoadPercentage><i class=sp-icon-carga-peso></i> <span>{{route.totalLoadPercentage | formatNumber:0:\'.\':\',\'}}%</span></div><div class=sp-indicator ng-if=route.totalLoad2Percentage><i class=sp-icon-carga-volumen></i> <span>{{route.totalLoad2Percentage | formatNumber:0:\'.\':\',\'}}%</span></div><div class=sp-indicator ng-if=route.totalLoad3Percentage><i class=sp-icon-carga-valor></i> <span>{{route.totalLoad3Percentage | formatNumber:0:\'.\':\',\'}}%</span></div><div class=sp-indicator ng-if=route.totalTimeFormatted><i class=sp-icon-verificando></i> <span>{{route.totalTimeFormatted}}<small>HRS</small></span></div></div><div class=expand-button ng-click=vm.showRouteIndicators(route)><i class=sp-icon-chevron-thin-up ng-if=route.expandedIndicators></i> <i class=sp-icon-chevron-thin-down ng-if=!route.expandedIndicators></i></div></div><a class=list-group-item href=\"\" ng-repeat=\"visit in vm.visitsToList | orderBy: vm.orderVisitsProperty | filter: { route_id: route.id } : true track by visit.id\" ng-class=\"{\'disabled\':visit.status === \'pending\'}\"><!-- Regular visits (Without join similar)--><div class=sp-tracking-dispatch-item ng-if=!visit.joinedVisits ng-click=\"vm.openModal(visit, null, null)\" ng-class=vm.getVisitNgClass(visit)><div class=sp-tracking-dispatch-timeline><div class=sp-tracking-dispatch-timeline-number style=\"background-color: {{vm.getTimelineNumberBackgroundColor(visit, vm.vehicle)}}\">{{visit.order}}</div><div class=sp-tracking-dispatch-timeline-hour>{{vm.calculateETA(visit.estimated_time_arrival, visit.ETARecalculated)}}</div><div class=sp-tracking-dispatch-timeline-line style=\"background-color: {{vm.getTimelineNumberBackgroundColor(visit, vm.vehicle)}}\"></div></div><div class=sp-tracking-dispatch-content><div class=sp-tracking-dispatch-header><div class=sp-tracking-dispatch-title>{{::visit.title}}<div class=has-alert ng-if=visit.hasAlert></div></div></div><div class=\"text-muted sp-tracking-dispatch-address\">{{::visit.address}}</div></div><div class=sp-tracking-dispatch-status-container><div class=sp-tracking-dispatch-status><i class=sp-icon-despacho-fallido ng-show=\"visit.status === \'canceled\'\" style=color:gray uib-tooltip={{vm.visitIconTooltipMessages.canceled}} tooltip-placement=\"auto top\"></i> <i class=sp-icon-despacho-entregado ng-show=\"visit.status === \'completed\'\" style=color:#41D3BD uib-tooltip={{vm.visitIconTooltipMessages.completed}} tooltip-placement=\"auto top\"></i> <i class=sp-icon-despacho-fallido ng-show=\"visit.status === \'failed\'\" style=color:#FF5252 uib-tooltip={{vm.visitIconTooltipMessages.failed}} tooltip-placement=\"auto top\"></i> <img class=sp-icon-despacho-parcial ng-show=\"visit.status === \'partial\'\" ng-src=/assets/images/entrega-parcial.svg uib-tooltip={{vm.visitIconTooltipMessages.partial}} tooltip-placement=\"auto top\"> <i class=sp-icon-despacho-atrasado ng-show=\"visit.status === \'pending\'\" ng-class=\"{\'is-delayed\': vm.isWindowBroken(visit)}\" uib-tooltip={{vm.visitIconTooltipMessages.pending}} tooltip-placement=\"auto top\"></i></div><div class=sp-tracking-dispatch-checkout-time>{{vm.getVisitCheckoutTime(visit)}}</div></div><div ng-if=\"vm.visitBeforeRestTime === visit.id\" class=rest-time-container><div translate=Vehicle.rest_time class=rest-time-translation></div><div class=rest-time><div>{{vm.getRestTimePeriod()}}</div></div></div></div><!-- Visits joined together --><div class=joined-visits-container ng-if=visit.joinedVisits style=\"border: 1px solid {{vm.getTimelineNumberBackgroundColor(visit, vm.vehicle)}}\" ng-class=vm.getVisitNgClass(visit)><div class=joined-visits-header ng-click=vm.handleShowJoinedDropDown(visit)><div class=join-similars-icon-container><div class=join-similars-icon-box style=\"background-color: {{vm.getTimelineNumberBackgroundColor(visit, vm.vehicle)}}\"><img src=../../../assets/images/unite-similars-white.svg></div><div class=eta-text>{{vm.calculateETA(visit.estimated_time_arrival,visit.ETARecalculated)}}</div></div><div class=information-container><div class=join-similar-text><span translate=Visits.join_similar></span> <span class=join-similar-text-address>{{visit.address}}</span><div></div></div><div class=join-similar-visit-indicators><i class=sp-icon-despacho-entregado style=color:#41D3BD uib-tooltip={{vm.visitIconTooltipMessages.completed}} tooltip-placement=\"auto top\"></i> <span>{{visit.subVisitStates.completed}}</span> <i class=sp-icon-despacho-pendiente style=color:gray uib-tooltip={{vm.visitIconTooltipMessages.pending}} tooltip-placement=\"auto top\"></i> <span>{{visit.subVisitStates.pending}}</span> <img class=sp-icon-despacho-parcial style=color:#F1CB0D uib-tooltip={{vm.visitIconTooltipMessages.partial}} tooltip-placement=\"auto top\" ng-src=/assets/images/entrega-parcial.svg ng-show=vm.enableVisitItems><span ng-show=vm.enableVisitItems>{{visit.subVisitStates.partial}}</span> <i class=sp-icon-despacho-fallido style=color:#FF5252 uib-tooltip={{vm.visitIconTooltipMessages.failed}} tooltip-placement=\"auto top\"></i> <span>{{visit.subVisitStates.failed}}</span> <i class=sp-icon-despacho-fallido style=color:gray uib-tooltip={{vm.visitIconTooltipMessages.canceled}} tooltip-placement=\"auto top\"></i> <span>{{visit.subVisitStates.canceled}}</span></div></div><div class=drop-icon><img src=../../../assets/images/arrow-down.svg ng-if=!visit.showJoinedVisits> <img src=../../../assets/images/arrow-up.svg ng-if=visit.showJoinedVisits></div></div><div class=joined-visits-list ng-if=visit.showJoinedVisits ng-repeat=\"subVisit in visit.joinedVisits track by subVisit.id\" ng-click=\"vm.openModal(subVisit, visit, $index)\" ng-class=vm.getVisitNgClass(subVisit)><div class=visit-number-container><div class=visit-number style=\"background-color: {{vm.getTimelineNumberBackgroundColor(subVisit, vm.vehicle)}}\">{{subVisit.order}}</div><div class=eta-text>{{vm.calculateETA(subVisit.estimated_time_arrival,subVisit.ETARecalculated)}}</div></div><div class=sub-visit-text-container><span class=sub-visit-title>{{subVisit.title}}</span> <span class=sub-visit-address>{{subVisit.address}}</span></div><div class=visit-list-status-info><div class=visit-list-indicator><i class=sp-icon-despacho-fallido ng-show=\"subVisit.status === \'canceled\'\" style=color:gray uib-tooltip={{vm.visitIconTooltipMessages.canceled}} tooltip-placement=\"auto top\"></i> <i class=sp-icon-despacho-entregado ng-show=\"subVisit.status === \'completed\'\" style=color:#41D3BD uib-tooltip={{vm.visitIconTooltipMessages.completed}} tooltip-placement=\"auto top\"></i> <i class=sp-icon-despacho-fallido ng-show=\"subVisit.status === \'failed\'\" style=color:#FF5252 uib-tooltip={{vm.visitIconTooltipMessages.failed}} tooltip-placement=\"auto top\"></i> <img class=sp-icon-despacho-parcial ng-show=\"subVisit.status === \'partial\'\" ng-src=/assets/images/entrega-parcial.svg uib-tooltip={{vm.visitIconTooltipMessages.partial}} tooltip-placement=\"auto top\"> <i class=sp-icon-despacho-atrasado ng-show=\"subVisit.status === \'pending\'\" ng-class=\"{\'is-delayed\': vm.isWindowBroken(subVisit)}\" uib-tooltip={{vm.visitIconTooltipMessages.pending}} tooltip-placement=\"auto top\"></i></div><div class=visit-list-checkout>{{vm.getVisitCheckoutTime(subVisit)}}</div></div></div></div></a></div></div><!-- end list-group --><div class=event-tab ng-if=\"!vm.loadingData && vm.eventsTabSelected && vm.events.length > 0\"><div class=event-list><div class=sp-event ng-repeat=\"event in vm.events track by event.aggregate_id+event.version\"><div ng-show=\"event.data.type === \'VISIT_CHECKOUT\'\"><div class=left uib-tooltip={{event.data.vehicle_name}}><img ng-src=/assets/images/vehicle-event.svg></div><div class=center><div class=title><span class=visit-text translate=Events.visit></span><div class=truncate><a href=\"\" ng-click=\"vm.openModal(event.data.visit_id, null, null)\">{{event.data.visit_title}}</a></div><span ng-if=\"event.data.visit_status === \'completed\'\" translate=Events.completed></span> <span ng-if=\"event.data.visit_status === \'failed\'\" translate=Events.failed></span> <span ng-if=\"event.data.visit_status === \'partial\'\" translate=Events.partial></span> <i class=\"icon indicator-icon sp-icon-ventana-horaria\" ng-if=!event.data.isCheckoutOnTime uib-tooltip=\"{{\'Events.window_broken\' | translate}}\"></i></div><div class=others-indicators><div><i class=\"indicator-icon sp-icon-user\"></i> <span>{{event.data.driver_name}}</span></div><div ng-if=event.data.has_attachments uib-tooltip=\"{{\'Events.file_attached\' | translate}}\"><img ng-src=/assets/images/file-event.svg></div></div></div><div class=right>{{event.occurred_on}}</div></div><div ng-show=\"event.data.type === \'ROUTE_STARTED\'\"><div class=left uib-tooltip={{event.data.vehicle_name}}><img ng-src=/assets/images/vehicle-event.svg></div><div class=center><div class=title><div class=truncate>{{event.data.vehicle_name}}</div><span class=visit-text translate=Events.route_started></span></div><div class=others-indicators><div><i class=\"indicator-icon sp-icon-user\"></i> <span>{{event.data.driver_name}}</span> <span>{{vm.getReferenceById(event.aggregate_id)}}</span></div></div></div><div class=right>{{event.occurred_on}}</div></div><div ng-show=\"event.data.type === \'ROUTE_FINISHED\'\"><div class=left uib-tooltip={{event.data.vehicle_name}}><img ng-src=/assets/images/vehicle-event.svg></div><div class=center><div class=title><div class=truncate>{{event.data.vehicle_name}}</div><span class=visit-text translate=Events.route_finished></span></div><div class=others-indicators><div><i class=\"indicator-icon sp-icon-user\"></i> <span>{{event.data.driver_name}}</span></div></div></div><div class=right>{{event.occurred_on}}</div></div></div></div><pagination class=events-pagination-container ng-if=\"!vm.loadingData && vm.events.length > 0\"><div class=pagination-info><span class=events-text translate=Tracking.events></span> <span>{{vm.currentLow}} - {{vm.currentTop}}</span></div><div class=pagination-btn-container><div class=\"pagination-btn previous-btn\" ng-show=vm.previous ng-click=\"vm.loadPaginationEvents(vm.previous, \'previous\')\" uib-tooltip={{vm.previousEventsTranslate}}><img ng-src=/assets/images/arrow_back_black.svg></div><div class=\"pagination-btn next-btn\" ng-show=vm.next ng-click=\"vm.loadPaginationEvents(vm.next, \'next\')\" uib-tooltip={{vm.nextEventsTranslate}}><img ng-src=/assets/images/arrow_forward_black.svg></div></div></pagination></div><!-- end list-group --><div ng-if=\"vm.visits.length === 0 && !vm.loadingData && vm.visitsTabSelected\" class=sp-tracking-scrollable-empty-data><h3 translate=Visits.without_visits_title></h3><img ng-src=/assets/images/sin-visitas.svg></div><!-- end empty-data --><div ng-if=\"vm.events.length === 0 && !vm.loadingData && vm.eventsTabSelected\" class=sp-tracking-scrollable-empty-data><h3 translate=Events.without_events_title></h3><img ng-src=/assets/images/sin-eventos.svg></div><!-- end empty-data --><!--Loading Data--><div class=sp-container-loading ng-if=vm.loadingData><img src=/assets/images/loading.gif width=180 height=180></div></div><!-- end sp-tracking-scrollable --></div><!-- end sp-tracking-dispatchs -->");
$templateCache.put("app/tracking/events/events.html","<div class=event-tab ng-if=\"!vm.loadingData && vm.events.length > 0\"><div class=event-list><event class=sp-event data=event showdriver=true ng-repeat=\"event in vm.events track by event.aggregate_id+event.version\"></event></div><pagination class=events-pagination-container ng-if=\"!vm.loadingData && vm.events.length > 0\"><div class=pagination-info><span class=events-text translate=Tracking.events></span> <span>{{vm.currentLow}} - {{vm.currentTop}}</span></div><div class=pagination-btn-container><div class=\"pagination-btn previous-btn\" ng-show=vm.previous ng-click=\"vm.loadPaginationEvents(vm.previous, \'previous\')\" uib-tooltip={{vm.previousEventsTranslate}}><img ng-src=/assets/images/arrow_back_black.svg></div><div class=\"pagination-btn next-btn\" ng-show=vm.next ng-click=\"vm.loadPaginationEvents(vm.next, \'next\')\" uib-tooltip={{vm.nextEventsTranslate}}><img ng-src=/assets/images/arrow_forward_black.svg></div></div></pagination></div><div ng-if=\"vm.events.length === 0 && !vm.loadingData\" class=sp-tracking-scrollable-empty-data><h3 translate=Events.without_events_title></h3><img ng-src=/assets/images/sin-eventos.svg></div><!-- end empty-data --><!--Loading Data--><div class=sp-container-loading ng-if=vm.loadingData><img src=/assets/images/loading.gif width=180 height=180></div>");
$templateCache.put("app/tracking/info/info.html","<div class=\"info modal-content\"><div class=\"modal-header modal-header-danger\"><button type=button class=close data-dismiss=modal ng-click=$dismiss() aria-hidden=true>&times;</button><h2 class=modal-title translate=Info.unavailable_tracking></h2></div><div class=modal-body><p translate=Info.no_day_routes></p><p><span translate=Info.please></span> <a ng-click=$dismiss() href=\"\" translate=Info.select_other_date></a> <span translate=Info.or></span> <a ui-sref=planner.vehicles-list ng-click=$dismiss() translate=Info.create_route></a></p></div></div>");
$templateCache.put("app/tracking/loading/loading.html","<div style=\"position: absolute; top: 50%; background-image:url(\'../../assets/images/loading.gif\');background-position:50% 20px;background-repeat:no-repeat;background-size:180px 180px\"></div>");
$templateCache.put("app/tracking/vehicles/vehicles.html","<div class=list-group ng-if=!vm.loadingData><div class=sp-tracking-header ng-if=vm.vehicles.length><div class=dispatchs-search-container><input type=text class=\"form-control dispatchs-input-header\" ng-model=vm.searchKeyword ng-keyup=vm.checkKey($event)> <button type=button class=\"btn btn-primary btn-search-visits\" ng-click=vm.filterVehicles()><i class=sp-icon-search></i></button> <button type=button class=\"btn btn-clear-visit\" ng-show=vm.searchKeyword ng-click=vm.clearFilter()><i class=\"fa fa-close\"></i></button></div><div class=vehicle-filter-container><div class=vehicle-filter-label><span translate=Vehicle.vehicle_order_by class=order-by-text></span></div><div class=vehicle-filter-dropdown-container><select class=\"form-control vehicle-filter-dropdown\" name=vehicles_sort ng-options=\"sort.value as sort.label for sort in vm.vehiclesSortOptions\" ng-model=vm.vehicleSort ng-change=vm.sortVehicles(vm.vehiclesFilters)></select></div></div></div><div ng-if=\"vm.vehiclesFilters.length === 0 && vm.vehicles.length > 0\" class=sp-tracking-scrollable-empty-data><h3 translate=Vehicle.vehicle_filter_empty_results></h3><p><span translate=Vehicle.vehicle_filter_empty_results_message></span></p><img ng-src=/assets/images/sin-vehiculos-tracking.svg></div><!-- end empty-data --><div class=sp-tracking-scrollable><div class=active-vehicles-div ng-if=\"vm.vehicles.length > 0 && vm.vehiclesFilters.length > 0\"><div class=tracking-section-title><span translate=Tracking.active_vehicles></span> <span class=sp-vehicles-number>({{activeVehicles.length}})</span></div><div class=sp-vehicle ng-repeat=\"vehicle in activeVehicles = (vm.vehiclesFilters | filter:{isActive:true} ) track by vehicle.driver.id + \'_\' + vehicle.id + \'_\' + vehicle.color\" ng-click=vm.toggleListVehicleDriver(vehicle) id={{vehicle.id}}-{{vehicle.driver.id}}-{{vehicle.color}} ng-class=\"{\'selected\': vm.selectedVehicleId && vm.selectedVehicleId === vehicle.id\n            && ((!vm.selectedVehicleDriver && !vehicle.driver.id) || (vm.selectedVehicleDriver === vehicle.driver.id))}\"><div class=\"list-group-item sp-tracking-driver-item\" ng-class=\"{\'disabled\':!vehicle.routes.length && vehicle.locations.length === 0 && !vehicle.driver}\"><div class=sp-tracking-driver-item-heading><div class=vehicle-container><div class=vehicle-info uib-tooltip={{vehicle.name}}><!--Vehicle Icon--> <svg class=img version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" enable-background=\"new 0 0 32 32\" xml:space=preserve><g id=vehiculos><g><circle style=fill:{{vehicle.color}} cx=22.54 cy=23.501 r=2.499 /><circle style=fill:{{vehicle.color}} cx=9.452 cy=23.501 r=2.499 /></g><path d=\"M27.844,17.914l-2.584-7.308l-0.006-0.004c-0.144-0.364-0.492-0.62-0.905-0.629l-0.021-0.015h-3.245V8\n                  c0-1.104-0.969-2-2.165-2H5.165C3.969,6,3,6.896,3,8v9.914c0,0.201,0.042,0.393,0.102,0.576C3.041,18.62,3,18.761,3,18.914v3.587\n                  c0,0.553,0.448,1,1,1h1.452c0-2.205,1.794-3.999,4-3.999s4,1.794,4,3.999h5.089c0-2.205,1.794-3.999,3.999-3.999\n                  c2.206,0,4.001,1.794,4.001,3.999h1.303c0.552,0,1-0.447,1-1v-3.587C28.844,18.361,28.396,17.914,27.844,17.914z M24.924,17.5\n                  l-0.002,0.002h-3.339L21.58,17.5c-0.274-0.002-0.497-0.225-0.497-0.5v-4.542c0-0.276,0.224-0.5,0.5-0.5h0.001h1.666\n                  c0.226,0,0.408,0.152,0.471,0.356c0,0,1.701,4.596,1.701,4.685C25.422,17.275,25.199,17.499,24.924,17.5z\" style=fill:{{vehicle.color}} /></g></svg><!--Vehicle Icon--> <span class=subtitle>{{vehicle.name}}</span></div><div class=alerts-container><div ng-show=\"vehicle.out_of_window > 0\"><i class=\"sp-icon-despacho-atrasado is-delayed\"></i></div><div class=\"text-muted sp-tracking-driver-item-alert\"><img ng-if=vehicle.hasUnfinishedRoutes class=\"vehicle-gps-icon gps-ready-status-{{vehicle.gpsDataAge}} glyphicon\" src=../../../assets/images/gps-icon.svg uib-tooltip={{vehicle.gpsTranslation}} tooltip-placement=\"auto top\"> <img ng-if=!vehicle.hasUnfinishedRoutes class=\"vehicle-gps-icon gps-routes-finished glyphicon\" src=../../../assets/images/gps-icon.svg uib-tooltip={{vm.routeFinishedTranslation}} tooltip-placement=\"auto top\"> <b>{{vehicle.countAlertedVisits}} </b><i class=sp-icon-flag-notification ng-class=\"{\'sp-icon-on\': vehicle.hasAlertedVisits}\" uib-tooltip={{vm.visitAlert}} tooltip-placement=\"auto top\"></i></div></div></div><div class=drivers-cointainer><div class=driver-info><img src=../../../assets/images/driver-icon-tracking.svg class=vehicle-list-driver-icon> <span class=name ng-show=vehicle.driver>{{vehicle.driver.name}}</span> <span class=\"name sp-tracking-driver-item-empty\" ng-show=!vehicle.driver.name translate=Driver.without_assigned_driver></span></div><div class=codrivers-info ng-if=\"vm.canCreateCoDriver && vehicle.codrivers.length\"><img src=../../../assets/images/codriver-icon-tracking.svg uib-tooltip={{vm.codriverTranslate}} class=vehicle-list-codriver-icon><div class=codrivers-count>{{vehicle.codrivers.length}}</div></div></div><div class=route-start ng-show=vehicle.startTime><span translate=Vehicle.route_start_time></span> {{vehicle.formatStartTime}}</div><span ng-show=\"vehicle.routes.length === 0\" class=sp-tracking-driver-item-empty translate=Driver.driver_without_routes></span></div></div><div class=\"progress sp-tracking-driver-item-progress\" ng-show=vehicle.routes.length tooltip-placement=bottom uib-tooltip=\"{{vehicle.madeVisits}} / {{vehicle.totalVisits}}\"><div class=progress-container><div class=progress-bar role=progressbar aria-valuenow={{vehicle.progress}} aria-valuemin=0 aria-valuemax=100 style=\"height: 5px; width:{{vehicle.progress}}%; background-color:{{vehicle.color}}\"></div></div></div></div></div><div class=inactive-vehicles-div ng-if=\"vm.vehicles.length > 0 && vm.vehiclesFilters.length > 0\"><div class=tracking-section-title><span translate=Tracking.inactive_vehicles></span> <span class=sp-vehicles-number>({{inactiveVehicles.length}})</span></div><div class=\"sp-vehicle inactive\" ng-repeat=\"vehicle in inactiveVehicles = (vm.vehiclesFilters | filter:{isActive:false} ) track by vehicle.driver.id + \'_\' + vehicle.id + \'_\' + vehicle.color\" ng-click=vm.toggleListVehicleDriver(vehicle) id={{vehicle.id}}-{{vehicle.driver.id}}-{{vehicle.color}} ng-class=\"{\'selected\': vm.selectedVehicleId && vm.selectedVehicleId === vehicle.id\n            && ((!vm.selectedVehicleDriver && !vehicle.driver.id) || (vm.selectedVehicleDriver === vehicle.driver.id))}\"><div class=\"list-group-item sp-tracking-driver-item\" ng-class=\"{\'disabled\':!vehicle.routes.length && vehicle.locations.length === 0 && !vehicle.driver}\"><div class=sp-tracking-driver-item-heading><div class=vehicle-container><div class=vehicle-info uib-tooltip={{vehicle.name}}><!--Vehicle Icon--> <svg class=img version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" enable-background=\"new 0 0 32 32\" xml:space=preserve><g id=vehiculos><g><circle style=fill:{{vehicle.color}} cx=22.54 cy=23.501 r=2.499 /><circle style=fill:{{vehicle.color}} cx=9.452 cy=23.501 r=2.499 /></g><path d=\"M27.844,17.914l-2.584-7.308l-0.006-0.004c-0.144-0.364-0.492-0.62-0.905-0.629l-0.021-0.015h-3.245V8\n                  c0-1.104-0.969-2-2.165-2H5.165C3.969,6,3,6.896,3,8v9.914c0,0.201,0.042,0.393,0.102,0.576C3.041,18.62,3,18.761,3,18.914v3.587\n                  c0,0.553,0.448,1,1,1h1.452c0-2.205,1.794-3.999,4-3.999s4,1.794,4,3.999h5.089c0-2.205,1.794-3.999,3.999-3.999\n                  c2.206,0,4.001,1.794,4.001,3.999h1.303c0.552,0,1-0.447,1-1v-3.587C28.844,18.361,28.396,17.914,27.844,17.914z M24.924,17.5\n                  l-0.002,0.002h-3.339L21.58,17.5c-0.274-0.002-0.497-0.225-0.497-0.5v-4.542c0-0.276,0.224-0.5,0.5-0.5h0.001h1.666\n                  c0.226,0,0.408,0.152,0.471,0.356c0,0,1.701,4.596,1.701,4.685C25.422,17.275,25.199,17.499,24.924,17.5z\" style=fill:{{vehicle.color}} /></g></svg><!--Vehicle Icon--> <span class=subtitle>{{vehicle.name}}</span></div><div class=alerts-container><div ng-show=\"vehicle.out_of_window > 0\"><i class=\"sp-icon-despacho-atrasado is-delayed\"></i></div><div class=\"text-muted sp-tracking-driver-item-alert\"><b>{{vehicle.countAlertedVisits}} </b><i class=sp-icon-flag-notification ng-class=\"{\'sp-icon-on\': vehicle.hasAlertedVisits}\"></i></div></div></div><div class=drivers-cointainer><div class=driver-info><img src=../../../assets/images/driver-icon-tracking.svg class=vehicle-list-driver-icon> <span class=name ng-show=vehicle.driver>{{vehicle.driver.name}}</span> <span class=\"name sp-tracking-driver-item-empty\" ng-show=!vehicle.driver.name translate=Driver.without_assigned_driver></span></div><div class=codrivers-info ng-if=\"vm.canCreateCoDriver && vehicle.codrivers.length\"><img src=../../../assets/images/codriver-icon-tracking.svg uib-tooltip={{vm.codriverTranslate}} class=vehicle-list-codriver-icon> <span class=codrivers-count>{{vehicle.codrivers.length}}</span></div></div><span ng-show=\"vehicle.routes.length === 0\" class=sp-tracking-driver-item-empty translate=Driver.driver_without_routes></span></div></div><div class=\"progress sp-tracking-driver-item-progress\" ng-show=vehicle.routes.length tooltip-placement=bottom uib-tooltip=\"{{vehicle.madeVisits}} / {{vehicle.totalVisits}}\"><div class=progress-container><div class=progress-bar role=progressbar aria-valuenow={{vehicle.progress}} aria-valuemin=0 aria-valuemax=100 style=\"height: 5px; width:{{vehicle.progress}}%; background-color:{{::vehicle.color}}\"></div></div></div></div></div></div></div><!-- end list-group --><div ng-show=\"(vm.vehicles.length === 0) && !vm.loadingData\" class=sp-tracking-scrollable-empty-data><h3 translate=Vehicle.without_vehicle_title></h3><img ng-src=/assets/images/sin-vehiculos-tracking.svg></div><!-- end empty-data --><!--Loading Data--><div class=sp-container-loading ng-if=vm.loadingData><img src=/assets/images/loading.gif width=180 height=180></div>");
$templateCache.put("app/uprofile/account/account.html","<div class=sp-uprofile-content-title><h2 translate=Uprofile.Account.title></h2></div><div class=sp-uprofile-content-account-body><form class=\"form-horizontal sp-form\"><div class=form-group><label class=\"col-sm-3 control-label\" translate=Uprofile.Account.fullname></label><div class=col-sm-9><p class=form-control-static>{{vm.user.name}}</p></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Uprofile.Account.email></label><div class=col-sm-9><p class=form-control-static>{{vm.user.email}}</p></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Uprofile.Account.business></label><div class=col-sm-9><p class=form-control-static>{{vm.user.account.name}}</p></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Uprofile.Account.country></label><div class=col-sm-9><p class=form-control-static>{{vm.user.account.country}}</p></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Uprofile.Account.token></label><div class=col-sm-9><p class=\"form-control-static token\">{{vm.user.api_token}}</p></div></div></form><center><a ui-sref=.change-password translate=Uprofile.Account.change_password ng-if=!vm.ssoUsers></a></center></div>");
$templateCache.put("app/uprofile/change-password/change-password.html","<div class=sp-uprofile-content-title><h2 translate=Uprofile.ChangePassword.title></h2></div><div class=sp-uprofile-content-account-body><form class=\"form-horizontal sp-form\" name=vm.formChangePassword ng-submit=\"vm.formChangePassword.$valid && vm.saveData()\" id=change-password-form novalidate><div class=form-group><label class=\"col-sm-3 control-label\" translate=Uprofile.ChangePassword.fullname></label><div class=col-sm-9><p class=form-control-static>{{vm.user.name}}</p><!-- <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"vm.user.name\" readonly required> --></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Uprofile.ChangePassword.email></label><div class=col-sm-9><p class=form-control-static>{{vm.user.email}}</p><!-- <input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"vm.user.email\" readonly required> --></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Uprofile.ChangePassword.business></label><div class=col-sm-9><p class=form-control-static>{{vm.user.account.name}}</p><!-- <input type=\"text\" class=\"form-control\" name=\"company\" ng-model=\"vm.user.account.name\" readonly required> --></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Uprofile.ChangePassword.country></label><div class=col-sm-9><p class=form-control-static>{{vm.user.account.country}}</p><!-- <input type=\"text\" class=\"form-control\" name=\"country\" ng-model=\"vm.user.account.country\" readonly required> --></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Uprofile.ChangePassword.token></label><div class=col-sm-9><p class=\"form-control-static token\">{{vm.user.api_token}}</p></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Uprofile.ChangePassword.actual_password></label><div class=\"col-sm-9 sp-block-relative\"><input class=\"form-control except_policies_hidden\" name=password ng-attr-type={{vm.password.type}} ng-model=vm.password.value ng-minlength=0 required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.changeTypeInput(vm.password)><span class=sp-icon-show-hide></span></button></span></div><ng-messages for=vm.formChangePassword.password.$error class=sp-form-messages role=alert ng-if=vm.formChangePassword.password.$dirty><ng-message class=sp-error-txt when=required translate=Uprofile.ChangePassword.required_password></ng-message><ng-message class=sp-error-txt when=minlength translate=Uprofile.ChangePassword.too_short_password></ng-message></ng-messages></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Uprofile.ChangePassword.new_password></label><div class=\"col-sm-9 sp-block-relative\"><input class=\"form-control except_policies_hidden\" name=new_password ng-attr-type={{vm.new_password.type}} ng-model=vm.new_password.value ng-change=vm.validatePassword() id=change-password-input required> <span class=\"input-group-btn except_policies_hidden\"><button type=button class=\"btn btn-default except_policies_hidden\" ng-click=vm.changeTypeInput(vm.new_password)><span class=\"sp-icon-show-hide except_policies_hidden\"></span></button></span></div><ng-messages for=vm.formChangePassword.new_password.$error class=sp-form-messages role=alert ng-if=vm.formChangePassword.new_password.$dirty><ng-message class=sp-error-txt when=required></ng-message></ng-messages></div><div class=col-sm-offset-3 id=change-password-policies><password-policies data=vm.policies validation=vm.validation></password-policies></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Uprofile.ChangePassword.repeat_new_password></label><div class=\"col-sm-9 sp-block-relative\"><input class=form-control name=password_repeat ng-attr-type={{vm.confirm_password.type}} ng-model=vm.confirm_password.value ng-focus=\"vm.focused2 = true\" ng-blur=\"vm.focused2 = false\" required> <span class=\"input-group-btn except_policies_hidden\"><button type=button class=\"btn btn-default except_policies_hidden\" ng-click=vm.changeTypeInput(vm.confirm_password)><span class=\"sp-icon-show-hide except_policies_hidden\"></span></button></span></div></div><div><ng-messages for=vm.formChangePassword.password_repeat.$error class=sp-form-messages role=alert ng-if=vm.formChangePassword.password_repeat.$dirty><ng-message class=sp-error-txt when=required translate=Uprofile.ChangePassword.required_password></ng-message></ng-messages></div><center><div ng-if=vm.error_match_password><p class=sp-error-txt translate=Uprofile.ChangePassword.passwords_not_equal></p></div><div ng-if=vm.error_invalid_password><p class=sp-error-txt translate=Uprofile.ChangePassword.actual_password_invalid></p></div><div ng-if=vm.error_invalid_password_policies><p class=sp-error-txt translate=Drivers.password_required></p></div><div ng-if=vm.success_change_password><p class=success-payment translate=Uprofile.ChangePassword.password_changed_successfully></p></div></center><div class=sp-settings-warning-box ng-if=\"(vm.user.is_driver || vm.user.is_codriver) && !vm.user.is_admin\"><span translate=Drivers.close_sessions_warning></span></div><br><button class=\"btn btn-success pull-right except_policies_hidden\" ng-disabled=vm.formChangePassword.$invalid translate=Uprofile.ChangePassword.change_password></button> <button class=\"btn btn-default pull-right except_policies_hidden\" ng-click=vm.goBack() translate=Uprofile.ChangePassword.cancel></button></form></div>");
$templateCache.put("app/uprofile/confirm-cancel-subscription/cancel-subscription.html","<!-- <div class=\"sp-modal-content\">\n  <div class=\"modal-header modal-header-danger\">\n    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"$dismiss()\" aria-hidden=\"true\">&times;</button>\n    <h2 class=\"modal-title\" translate=\"Uprofile.CCSubscription.cancel_subscription\"></h2>\n  </div>\n  <div class=\"modal-body\">\n    <p translate=\"Uprofile.CCSubscription.really_want_cancel\"></p>\n  </div>\n  <div class=\"modal-footer modal-subscription\">\n    <button type=\"button\" class=\"btn btn-default\" ng-click=\"$dismiss()\" translate=\"Uprofile.CCSubscription.close\"></button>\n    <button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.cancelSubscription()\">Ok</button>\n  </div>\n</div> --><div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Uprofile.CCSubscription.cancel_subscription></h3></div><div class=modal-body><p translate=Uprofile.CCSubscription.really_want_cancel></p></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Uprofile.CCSubscription.close></button> <button type=button class=\"btn btn-danger\" ng-click=\"cancelSubscription(); closeThisDialog(0)\">Ok</button></div></div>");
$templateCache.put("app/uprofile/payment/add-payment.html","<div class=active><h4 class=title translate=Uprofile.Payment.payment_method></h4><form class=\"form-horizontal sp-form\" name=vm.paymentForm stripe-form=stripeCallback><div class=form-group><label class=\"col-sm-3 control-label editing\" translate=Uprofile.Payment.payment_vehicles></label><div class=\"col-sm-9 payment-vehicle\"><input type=number class=form-control name=quantity_vehicle ng-model=vm.planQuantity min={{vm.minVehicle}} max=1000 required><p class=form-control-static>{{vm.planQuantity * vm.AMOUNT_PER_VEHICLE | currency:\"USD$\"}}</p></div><div class=form-group ng-show=vm.paymentForm.quantity_vehicle.$error><div class=\"col-sm-offset-2 col-sm-10 text-muted\"><small class=sp-error-txt ng-show=vm.paymentForm.quantity_vehicle.$error.min><i class=\"fa fa-question-circle\"></i> <span translate=Uprofile.Payment.to_select_plan></span> <a ui-sref=settings.vehicles.list translate=Uprofile.Payment.delete_vehicles></a>. </small><small class=sp-error-txt ng-show=vm.paymentForm.quantity_vehicle.$error.max><i class=\"fa fa-question-circle\"></i> <span translate=Uprofile.Payment.maxium_vehicles></span></small></div></div></div><div class=form-group><label class=\"col-sm-3 control-label editing\" translate=Uprofile.Payment.card></label><div class=col-sm-9><input class=form-control name=card ng-model=number placeholder=\"Card Number\" payments-format=card payments-validate=card required></div><div class=sp-error-txt ng-if=\"vm.paymentForm.card.$invalid && vm.paymentForm.card.$dirty\" translate=Uprofile.Payment.invalid_card_number></div></div><div class=form-group><label class=\"col-sm-3 control-label editing\" translate=Uprofile.Payment.due_date></label><div class=col-sm-9><input class=form-control name=expiry ng-model=expiry placeholder=\"MM / YY\" payments-format=expiry payments-validate=expiry required></div><div class=sp-error-txt ng-if=\"vm.paymentForm.expiry.$invalid && vm.paymentForm.expiry.$dirty\" translate=Uprofile.Payment.invalid_expiry></div><div class=sp-error-txt ng-if=vm.expiry_invalid translate=Uprofile.Payment.expiration_year_invalid></div></div><div class=form-group><label class=\"col-sm-3 control-label editing\" translate=Uprofile.Payment.security_code></label><div class=col-sm-9><input class=form-control name=cvc ng-model=cvc placeholder=CVC payments-format=cvc payments-validate=cvc required></div><div class=sp-error-txt ng-if=\"vm.paymentForm.cvc.$invalid && vm.paymentForm.cvc.$dirty\" translate=Uprofile.Payment.cvc_invalid></div></div><div class=form-group><label class=\"col-sm-3 control-label editing\" translate=Uprofile.Payment.discount_code></label><div class=col-sm-1><input type=checkbox class=sp-checkbox-discount name=enable_discount_code ng-model=vm.enable_discount_code></div><div class=col-sm-8 ng-show=vm.enable_discount_code><input class=form-control name=discount_code ng-model=vm.discount_code ng-required=vm.enable_discount_code></div><div class=sp-error-txt ng-if=\"vm.paymentForm.discount_code.$invalid && vm.paymentForm.discount_code.$dirty\" translate=Uprofile.Payment.discount_code_invalid></div></div><div class=success-payment ng-if=vm.successPayment translate=Uprofile.Payment.success_msg></div><div class=sp-error-txt ng-if=vm.errorPayment translate=Uprofile.Payment.error_msg></div><div class=sp-error-txt ng-if=vm.errorCoupon translate=Uprofile.Payment.error_coupon_msg></div><button type=submit class=\"btn btn-success pull-right\" ng-disabled=vm.paymentForm.$invalid translate=Uprofile.Payment.save ng-hide=vm.successPayment></button> <button class=\"btn btn-default pull-right\" ng-click=vm.goBack() translate=Uprofile.Payment.cancel ng-hide=vm.successPayment></button></form></div><div id=loadScript></div>");
$templateCache.put("app/uprofile/payment/payment-success-modal.html","<div class=\"info modal-content sp-finish-modal\"><div class=\"modal-header modal-header-success\"><h3 class=modal-title translate=Uprofile.Payment_success.title></h3></div><div class=modal-body><div class=sp-confirm-plan><div class=sp-icon-success-container><i class=\"sp-icon-check sp-icon-check-uprofile\"></i></div><div class=\"sp-modal-options sp-modal-options-uprofile\"><div class=\"sp-modal-options-block text-center\"><div class=row><div class=col-sm-12><span><span translate=\"{{\'Uprofile.Payment_success.msg\'}}\"></span></span></div></div><div class=row><div class=col-sm-12><button class=\"btn btn-lg btn-success sp-btn-margin-top-15\" ng-click=closeThisDialog(0)><span translate=\"{{\'Uprofile.Payment_success.accept\'}}\"></span></button></div></div></div></div></div></div></div><!-- end modal-content -->");
$templateCache.put("app/uprofile/payment/payment.html","<div class=active ng-show=\"vm.user.account.status === \'trialing\' || vm.user.account.status === \'canceled\'\"><p translate=Uprofile.Payment.not_payment_method></p></div><div class=active ng-show=\"vm.user.account.status === \'active\' || vm.user.account.status === \'past_due\'\"><h4 class=title translate=Uprofile.Payment.payment_method></h4><form class=\"form-horizontal sp-form\"><div class=form-group><label class=\"col-sm-3 control-label\" translate=Uprofile.Payment.payment_vehicles></label><div class=col-sm-9><p class=form-control-static>{{vm.user.account.plan_quantity}}</p></div></div><div class=form-group><label class=\"col-sm-3 control-label\" translate=Uprofile.Payment.card></label><div class=col-sm-9><p class=form-control-static>xxxx xxxx xxxx {{vm.user.account.card_last4}}</p></div></div><div class=form-group ng-show=vm.user.account.coupon><label class=\"col-sm-3 control-label\" translate=Uprofile.Payment.discount_code></label><div class=col-sm-9><p class=form-control-static>{{vm.user.account.coupon}}</p></div></div></form><a ui-sref=.add-payment ng-show=\"(vm.user.account.status === \'active\' || vm.user.account.status === \'past_due\') && vm.user.is_owner\" translate=Uprofile.Payment.edit></a></div>");
$templateCache.put("app/planner/components/contextMenuOnMap/contextMenuOnMap.html","<div id=mapContextMenu ng-show=$ctrl.contextMenu.showContextMenu><ul><li><button type=button ng-click=\"$ctrl.moveVisitsToRoute({routeId: $ctrl.contextMenu.routeId, vehicleId: $ctrl.contextMenu.vehicleId})\"><div class=icon ng-include=\"\'/assets/images/move_here_icon.svg\'\"></div><span translate=ContextMenu.move_here_option></span></button></li></ul></div>");
$templateCache.put("app/planner/components/buttonItem/buttonItem.html","<div class=button-container><button id=hand-drawing-selection-mode class=button-action type=button ng-click=$ctrl.clickButton() ng-class=\"{\'active\': $ctrl.isButtonActive}\"><div class=button-icon ng-include=$ctrl.iconPath ng-class=\"{\'active\': $ctrl.isButtonActive}\"></div><span translate=ToolSelectionOnMap.hand_drawing_selection_mode></span></button></div>");
$templateCache.put("app/planner/components/detailedIndicators/detailedIndicators.html","<div class=detailed-indicators ng-class=\"{\'reposition\': $ctrl.areIndicatorsPerVehicleShown, \'move-to-top\': $ctrl.shouldMoveToTop}\"><detailed-indicators-collapsed join-similar=$ctrl.joinSimilar data=$ctrl.data></detailed-indicators-collapsed><!-- TODO: Add detailed indictaros expanded: If isExpanded, show this other component --></div>");
$templateCache.put("app/planner/components/customSelect/customSelect.html","<div class=custom-select-wrapper><div class=select-display ng-click=$ctrl.onClick()><span>{{$ctrl.getSelectedItem().title || (\'Routes.select_driver\' | translate)}}</span></div><ul class=select-list ng-if=$ctrl.openSelect ng-style=$ctrl.selectListStyle><li class=option><span class=title ng-click=$ctrl.onClickSelectOption(null) translate=Routes.select_driver></span></li><li class=option ng-click=\"!element.disabled && $ctrl.onClickSelectOption(element.id)\" ng-class=\"[{\'disabled\': element.disabled}, {\'selected\': element.id == $ctrl.getSelectedItem().id}]\" ng-repeat=\"element in $ctrl.data track by element.id\"><div class=upper_content><span class=title>{{element.title}}</span> <img ng-if=\"element.id == $ctrl.getSelectedItem().id || element.selected\" class=check src=../../../assets/images/check.svg alt=check></div><span class=\"description warning\" ng-class=\"[{\'expired\': element.disabled}]\">{{element.description}}</span></li></ul></div>");
$templateCache.put("app/planner/components/detailedIndicatorsCollapsed/detailedIndicatorsCollapsed.html","<div class=detailed-indicators-collapsed><div class=detailed-indicators-collapsed-no-info ng-if=\"!$ctrl.data.element  || !$ctrl.data.routeName\"><div class=detailed-indicators-collapsed-no-info-icon tooltip-placement=top uib-tooltip=\"{{\'indicators.collapsed_tooltip\' | translate}}\"><img src=../../../../assets/images/indicators/info_blue.svg></div><span translate=indicators.indicators></span></div><div class=detailed-indicators-collapsed-route ng-if=\"$ctrl.data.element === \'route\' && $ctrl.data.routeName\"><div class=\"detailed-indicators-collapsed-route-row collapsed-header\"><div class=title-indicators-left-side><div class=detailed-indicators-collapsed-info-icon><div ng-include=\"\'/assets/images/indicators/vehicle.svg\'\" ng-style=\"{\'fill\': $ctrl.data.vehicle.color}\"></div></div><span class=detailed-indicators-collapsed-vehicle-name>{{$ctrl.data.vehicle.name.slice(0, 10)}}</span></div><div class=title-indicators-right-side><div class=detailed-indicators-collapsed-info-icon><div ng-include=\"\'/assets/images/indicators/route.svg\'\"></div></div><span class=detailed-indicators-collapsed-route-name>{{$ctrl.data.routeName}}</span></div></div><div class=detailed-indicators-container><div class=indicators-left-side><div class=indicator><div class=\"sp-flex-container indicator-icon-container\" ng-include=$ctrl.getVisitIconForRouteIndicator()></div><span class=detailed-indicators-collapsed-info-text>{{$ctrl.getVisitCountForRouteIndicator()}}</span></div><div class=indicator><div ng-include=\"\'/assets/images/indicators/route.svg\'\" style=\"color: #1D0DA5\"></div><span class=detailed-indicators-collapsed-info-text>{{$ctrl.data.route.totalDistance.toFixed(2) | formatNumber}} kms</span></div><div class=indicator><img src=../../../../assets/images/indicators/clock.svg> <span class=detailed-indicators-collapsed-info-text>{{$ctrl.data.route.totalTimeFormatted}} hrs</span></div></div><div class=indicators-right-side><div class=indicator ng-if=!$ctrl.enablePickupAndDeliveryMode><div ng-include=\"\'/assets/images/indicators/weight.svg\'\" class=indicator-icon-container></div><span class=detailed-indicators-collapsed-info-text>{{$ctrl.data.route.totalLoadPercentage | formatNumber:0}}% ({{$ctrl.data.route.totalLoad | formatNumber}})</span></div><div class=indicator ng-if=!$ctrl.enablePickupAndDeliveryMode><img src=../../../../assets/images/indicators/expand.svg> <span class=detailed-indicators-collapsed-info-text>{{$ctrl.data.route.totalLoadPercentage2 | formatNumber:0}}% ({{$ctrl.data.route.totalLoad2 | formatNumber}})</span></div><div class=indicator ng-if=!$ctrl.enablePickupAndDeliveryMode><img src=../../../../assets/images/indicators/money.svg> <span class=detailed-indicators-collapsed-info-text>{{$ctrl.data.route.totalLoadPercentage3 | formatNumber:0}}% ({{$ctrl.data.route.totalLoad3 | formatNumber}})</span></div><div class=\"indicator sp-mix-load-icon\" ng-if=!$ctrl.enablePickupAndDeliveryMode><div ng-include=\"\'/assets/images/box_filled.svg\'\" class=indicator-icon-container></div><span class=detailed-indicators-collapsed-info-text>{{$ctrl.data.route.totalLoadPercentage4 | formatNumber:0}}% ({{$ctrl.data.route.totalLoad4 | formatNumber}})</span></div></div></div><div class=revised-route-info-container ng-if=::$ctrl.isRouteRevised($ctrl.data.route)><div class=revised-route-info><div class=info-icon ng-include=\"\'/assets/images/indicators/info.svg\'\"></div><span class=info-text translate=indicators.revised_route_info></span></div></div></div></div>");
$templateCache.put("app/planner/components/driver/driver.html","<div class=sp-planner-routes-vehicle-header-select-driver ng-style=$ctrl.getDriverComponentNgStyle()><!-- Icon User --> <a href=\"\" ng-click=$ctrl.toggleVehicleDriversList() tooltip-placement=top tooltip-enable=\"{{!$ctrl.isDriverAssignmentDisabled || $ctrl.driverId}}\" uib-tooltip={{$ctrl.getNameDriverAssigned()}} tooltip-append-to-body=true tooltip-class=driver-long-tooltip ng-style=$ctrl.getDriverIconNgStyle()><i class=\"sp-icon-user fs-18\" ng-class=$ctrl.getDriverIconNgClass()></i> </a><!-- Dropdown List Users --><div ng-if=$ctrl.isVehicleDriversListOpen() class=sp-planner-routes-vehicle-header-routes-indicator><select ng-if=!$ctrl.isTmsEnable class=\"form-control border-color\" ng-click=$event.stopPropagation() ng-model=$ctrl.driverId ng-change=$ctrl.updateDriverId() ng-options=\"driver.id as driver.group + \' \' + driver.name for driver in drivers\"><option value=\"\" translate=Driver.select_driver selected></option></select><custom-select ng-click=$event.stopPropagation() ng-if=$ctrl.isTmsEnable data=$ctrl.driverSelectInfo.drivers selected-id=$ctrl.driverId additional-width=80 is-absolute=true on-click-option=$ctrl.driverSelectInfo.onClickOption ng-style=\"{\'width\': \'170px\'}\"></custom-select></div></div>");
$templateCache.put("app/planner/components/itemsSummaryInVisitCard/itemsSummaryInVisitCard.html","<div ng-if=shouldShowItemsSummaryContainer(items) class=\"list-group-item-text text-muted items-container-component\"><span ng-include=ITEMS_SUMMARY_ICON_PATH class=\"sp-icon-items list-group-item-text-left\"></span><div ng-if=shouldShowItemsSummaryList(items) class=\"list-group-item-text-right items-summary-list\"><div ng-repeat=\"item in items\" class=\"list-group-item-text items-summary-row\"><small class=\"sp-text-ellipsis items-summary-title\">{{::item.title}} </small><small ng-if=item.quantity_planned class=items-summary-list-separator>{{::ITEMS_SUMMARY_LIST_SEPARATOR}} </small><small ng-if=item.quantity_planned class=items-summary-quantity-planned>{{::item.quantity_planned}}</small></div></div><div ng-if=!shouldShowItemsSummaryList(items) class=\"list-group-item-text-right sp-text-ellipsis\"><small>{{::itemsTotalQuantityPlannedSummary}}</small></div></div>");
$templateCache.put("app/planner/components/itemsTable/itemsTable.html","<div class=buttons-items-options><button class=btn-delete-items ng-class=\"{\'actived\': $ctrl.isAnyItemSelected}\" ng-disabled=!$ctrl.isAnyItemSelected ng-click=$ctrl.deleteItems()><div ng-include=\"\'/assets/images/delete.svg\'\" class=\"icon-item icon-delete\" ng-class=\"[{\'actived\': $ctrl.isAnyItemSelected}]\"></div><span translate=Items_table.btn_delete></span></button> <button class=btn-add-item ng-click=$ctrl.onAdd()><div ng-include=\"\'/assets/images/plus.svg\'\" class=\"icon-item add-item\"></div><span translate=Items_table.btn_add></span></button></div><div class=\"sp-fake-table sp-items-table\" ng-if=\"$ctrl.items.length > 0\"><div class=\"sp-thead items-list\"><div class=sp-vehicle-all-checkbox-column><div class=sp-item-checkbox><input id=checkbox-all-items type=checkbox class=sp-checkbox-input ng-model=$ctrl.areAllItemsSelected ng-click=$ctrl.toggleAllItems()><label><span class=sp-icon-check></span></label></div></div><div class=\"sp-tcell-header sp-cursor-pointer sp-th-item-title\" translate=Items_table.title ng-click=\"$ctrl.sortItemsBy($ctrl.ITEM_PROPERTIES.TITLE, !$ctrl.itemSortDesc);\"></div><div class=\"sp-tcell-header sp-cursor-pointer sp-th-item-qty\" translate=Items_table.amount ng-click=\"$ctrl.sortItemsBy($ctrl.ITEM_PROPERTIES.QUANTITY_PLANNED, !$ctrl.itemSortDesc)\"></div><div class=\"sp-tcell-header sp-th-item-icon\" ng-include=\"\'/assets/images/change-vertical.svg\'\"></div></div><div class=\"sp-tbody item-list\"><form name=$ctrl.itemForm><div class=\"sp-trow sp-item\" ng-repeat=\"item in $ctrl.itemsCurrentPage\" ng-class=\"{\'selected\' :$ctrl.isItemSelected(item.id)}\"><div class=sp-item-checkbox-column><div class=sp-item-checkbox><input type=checkbox class=sp-checkbox-input ng-model=item.selected ng-change=$ctrl.updateSelectionStatus()><label><span class=sp-icon-check></span></label></div></div><div class=\"sp-cursor-pointer cell-hover sp-td-item-title\" ng-click=\"$ctrl.activateEditMode($ctrl.ITEM_PROPERTIES.TITLE, item.id)\" ng-class=\"{error: $ctrl.itemForm[\'item-title-{{item.id}}\'].$error.required}\"><div class=sp-text-ellipsis><span class=text-title-item ng-if=\"!$ctrl.isEditingItemProperty($ctrl.ITEM_PROPERTIES.TITLE, item.id)\">{{ item.title || \'Items_table.new_item\' | translate }}</span><textarea class=edit-item-title name=item-title-{{item.id}} id=item-title-{{item.id}} ng-model=item.title ng-show=$ctrl.isEditingItemProperty($ctrl.ITEM_PROPERTIES.TITLE,item.id) ng-enter=$ctrl.handleChanges() ng-blur=$ctrl.handleChanges() ng-focus=$ctrl.adjustElementHeight($event) ng-keyup=$ctrl.adjustElementHeight($event) required>\n                            {{item.title}}\n                        </textarea></div></div><div class=\"sp-cursor-pointer cell-hover sp-td-item-qty\" ng-click=\"$ctrl.activateEditMode($ctrl.ITEM_PROPERTIES.QUANTITY_PLANNED, item.id)\" ng-class=\"{\'error\': $ctrl.itemForm[\'item-qty-\' + item.id].$invalid}\"><span ng-if=\"!$ctrl.isEditingItemProperty($ctrl.ITEM_PROPERTIES.QUANTITY_PLANNED, item.id)\">{{ item.quantity_planned }} </span><input class=edit-item-qty name=item-qty-{{item.id}} id=item-quantity_planned-{{item.id}} type=number min=0.01 step=any ng-model=item.quantity_planned ng-show=$ctrl.isEditingItemProperty($ctrl.ITEM_PROPERTIES.QUANTITY_PLANNED,item.id) ng-enter=$ctrl.handleChanges() ng-blur=$ctrl.handleChanges() value={{item.quantity_planned}} required><ng-messages for=\"$ctrl.itemForm[\'item-qty-\' + item.id].$error\" class=sp-form-messages role=alert ng-show=\"$ctrl.itemForm[\'item-qty-\' + item.id].$dirty\"><ng-message class=sp-error-txt when=required translate=Items_table.error_required></ng-message><ng-message class=sp-error-txt when=min translate=Items_table.error_min></ng-message><ng-message class=sp-error-txt when=number translate=Items_table.error_number></ng-message></ng-messages></div><div class=\"sp-trow sp-td-item-icon\"></div></div></form></div></div><div class=row ng-show=\"$ctrl.items.length > $ctrl.pagination.ITEMS_PER_PAGE\"><div class=\"col-sm-12 text-center sp-pagination-row\"><ul uib-pagination total-items=$ctrl.items.length ng-model=$ctrl.pagination.CURRENT_PAGE items-per-page=$ctrl.pagination.ITEMS_PER_PAGE max-size=$ctrl.pagination.MAX_SIZE class=pagination-sm boundary-links=true rotate=false ng-change=$ctrl.getItemsPerPage()></ul></div></div>");
$templateCache.put("app/planner/components/loadCapacity/loadCapacity.html","<div class=sp-load-capacity-container><div class=sp-load-capacity-header><div class=\"sp-load-capacity-title text-left\" translate=LoadCapacity.title></div><div class=\"title-icon sp-load-capacity-alerts\" ng-if=$ctrl.totalOverloads><div ng-include=\"\'/assets/images/alert/alert_16.svg\'\" class=sp-load-capacity-alert-icon></div><span class=sp-load-capacity-total-overloads>{{$ctrl.totalOverloads}}</span></div><div class=sp-load-capacity-collapsed><button class=\"btn btn-link sp-btn-collapse pull-right\" type=button ng-click=\"$ctrl.collapse = !$ctrl.collapse;\"><div ng-include=\"\'/assets/images/navegation_down/navegation_down_16.svg\'\" class=sp-load-capacity-collapse-icon ng-if=$ctrl.collapse></div><div ng-include=\"\'/assets/images/navegation_up/navegation_up_16.svg\'\" class=sp-load-capacity-collapse-icon ng-if=!$ctrl.collapse></div></button></div></div><div class=sp-load-capacity-content-progress-bar><div uib-collapse=$ctrl.collapse><div><progress-bar ng-repeat=\"load in $ctrl.totalLoads track by $index\" type-load=$ctrl.typeOfLoads[$index] used-capacity=load available-capacity=$ctrl.totalCapacity[$index] update-overloads=\"$ctrl.updateTotalOverloads(typeLoad, load)\" ng-if=\"load > 0 && $ctrl.totalCapacity[$index] > 0 && ($index < 3 || $ctrl.isMixLoadAddonEnabled())\"></progress-bar></div></div></div></div>");
$templateCache.put("app/planner/components/loadsTable/cellLoadTable.html","<span ng-if=!$ctrl.isArray class=sp-truncate-tooltip uib-tooltip={{$ctrl.value}} tooltip-enable=$ctrl.isTruncated tooltip-placement=right ng-class=\"{\'load-cell\': $ctrl.canBeHidden, \'load-cell\': $ctrl.fixed}\">{{$ctrl.value}} </span><span ng-if=\"$ctrl.isArray && $ctrl.value\" class=sp-loads-table-chip-number>{{$ctrl.value}} </span><span ng-if=$ctrl.otherSkills.length uib-tooltip=\"{{$ctrl.otherSkills.join(\', \')}}\" tooltip-placement=right class=sp-loads-table-chip-number>+{{$ctrl.otherSkills.length}} </span>");
$templateCache.put("app/planner/components/loadsTable/columnsList.html","<div id=show-columns-list-container><ul id=show-columns-list columns-list-sortable><p class=show-columns-list-title translate=ColumnsList.displayed></p><li ng-repeat=\"column in $ctrl.columns\" ng-if=\"column.isVisible($ctrl.joinSimilar) && !column.canBeHidden\"><span class=show-columns-handle>⋮⋮</span> {{ column.label | translate }} <span ng-include=\"\'/assets/images/show_hide/show_icon.svg\'\" class=\"show-columns-visiblity-icon disable\"></span></li><li ng-repeat=\"column in $ctrl.columns\" ng-if=\"column.visible && column.canBeHidden\" class=draggable-column><span class=show-columns-handle>⋮⋮</span> {{ column.label | translate }} <span ng-include=\"\'/assets/images/show_hide/show_icon.svg\'\" class=show-columns-visiblity-icon ng-click=$ctrl.toggleVisible(column)></span></li><p class=show-columns-list-title translate=ColumnsList.hidden></p><li ng-repeat=\"column in $ctrl.columns\" ng-if=\"!column.visible && column.canBeHidden\"><span class=show-columns-handle>⋮⋮</span> {{ column.label | translate }} <span ng-include=\"\'/assets/images/show_hide/hide_icon.svg\'\" class=show-columns-visiblity-icon ng-click=$ctrl.toggleVisible(column)></span></li></ul><div class=show-columns-reset-container><button class=show-columns-reset-btn ng-click=$ctrl.resetColumnsList()><span ng-include=\"\'/assets/images/reset.svg\'\" class=show-columns-reset-icon></span> <span translate=ColumnsList.reset></span></button></div></div>");
$templateCache.put("app/planner/components/loadsTable/loadsTable.html","<div class=sp-loads-table-container ng-class=\"{\'push-up\': $ctrl.generalIndicatorsHidden, \'push-down\': $ctrl.detailedIndicatorsEnabled}\"><div class=sp-loads-table-container-header><div class=sp-loads-table-title ng-bind-html=$ctrl.headerText></div><div class=sp-loads-table-visit-order><span class=visit-order-title translate=LoadsTable.visit_order></span> <button id=show-columns-list-button ng-click=$ctrl.toggleColumnsOptions()><svg aria-hidden=true viewBox=\"0 0 24 24\" xmlns=http://www.w3.org/2000/svg fill=currentColor class=size-6><path d=\"M12 15.433a3.332 3.332 0 1 0 0-6.664 3.332 3.332 0 0 0 0 6.664\"></path><path d=\"M21.389 9.85C20.097 7.746 17.159 4.215 12 4.215S3.903 7.745 2.611 9.85a4.09 4.09 0 0 0 0 4.3c1.292 2.104 4.23 5.635 9.389 5.635s8.097-3.53 9.389-5.635a4.09 4.09 0 0 0 0-4.3M12 16.998a4.998 4.998 0 1 1 0-9.996 4.998 4.998 0 0 1 0 9.996\"></path></svg></button><div class=\"close-icon-container sp-cursor-pointer\"><i id=loads-table-close-btn class=\"close-icon sp-icon-chevron-left\" ng-click=$ctrl.close()></i></div></div></div><columns-list ng-show=$ctrl.showColumnsOptions table-columns=$ctrl.tableColumns update-column=\"$ctrl.updateColumn(columnKey, column)\" update-columns-array=$ctrl.updateColumnsArray(columns) reset-columns-width=$ctrl.resetColumnsWidth() join-similar=$ctrl.joinSimilar></columns-list><div id=loads-table-container class=sp-loads-table-scroll ng-class=\"{\'push-down\': $ctrl.detailedIndicatorsEnabled && !$ctrl.generalIndicatorsHidden}\"><table class=\"sp-loads-table-main sp-loads-table-header\"><thead><tr><th id=loads-table-select-header class=\"check-cell sp-cursor-pointer\"><div class=\"sp-select-all sp-select-all--edit\"><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-model=$ctrl.route.editingSelected ng-change=$ctrl.selectAll()><label><span class=sp-icon-check></span></label></div></div></th><th ng-repeat=\"column in $ctrl.columns | orderBy:\'position\'\" ng-if=column.isVisible($ctrl.joinSimilar) ng-class=\"[{ \'selected-cell\': $ctrl.orderBy === column.propertyName }]\" ng-style=column.style columns-list-resizer=column clr-update-column=\"$ctrl.updateColumn(columnKey, column)\" clr-hovered-column-key=ctrl.hoveredColumnKey class=text-left><div ng-class=\"{\'sp-cursor-pointer\': column.changeOrder, \'selected-cell\': $ctrl.orderBy === column.orderBy}\" ng-click=\"column.changeOrder && $ctrl.changeOrder(column.propertyName, column.changeOrder !== undefined)\" style=\"width: 55px\"><span>{{::column.label | translate}}</span> <span ng-if=column.changeOrder class=reorder-icon ng-include=\"\'/assets/images/indicators/reorder.svg\'\"></span></div></th></tr></thead><tbody class=sp-loads-table-body><tr ng-repeat=\"visit in $ctrl.visibleVisits track by visit.id\"><td class=\"text-left check-cell sp-cursor-pointer\"><div class=\"sp-select-all sp-select-all--edit\"><div class=sp-checkbox-select-all><input type=checkbox class=sp-checkbox-input ng-model=visit.selected ng-change=$ctrl.select(visit)><label><span class=sp-icon-check></span></label></div></div></td><td ng-repeat=\"column in $ctrl.columns | orderBy:\'position\'\" ng-if=column.isVisible($ctrl.joinSimilar) ng-class=\"[{ \'selected-cell\': $ctrl.orderBy === column.propertyName }]\" class=text-left><cell-load-table data=visit property-name=column.propertyName fixed=column.canBeHidden skills=$ctrl.accountSkills></cell-load-table></td></tr></tbody></table></div></div>");
$templateCache.put("app/planner/components/moveToOptions/moveToOptions.html","<div class=container-options><div class=option-title ng-click=\"$ctrl.isCollapsed = !$ctrl.isCollapsed\"><span>{{$ctrl.title}}</span><div ng-include=\"\'/assets/images/navegation_down/navegation_down_16.svg\'\" class=sp-collapse-icon ng-if=$ctrl.isCollapsed></div><div ng-include=\"\'/assets/images/navegation_up/navegation_up_16.svg\'\" class=\"sp-collapse-icon up\" ng-if=!$ctrl.isCollapsed></div></div><div class=content-options uib-collapse=$ctrl.isCollapsed><ul class=list-options><li ng-repeat=\"option in $ctrl.options | orderBy:$ctrl.naturalSort(\'name\'):false\" ng-mouseenter=\"$ctrl.handleMouseEvent(option, true)\" ng-mouseleave=\"$ctrl.handleMouseEvent(option, false)\" ng-click=\"$ctrl.onMoveVisitTo(option.vehicleId, option.routeId)\" ng-class=\"{\'revised-route-option\': $ctrl.isRevisedOption}\"><div class=sp-options-circle ng-style=\"{\'border-color\': option.color, \'background-color\': option.background_color}\"></div><span class=sp-options-name>{{option.name}}</span></li></ul></div></div><div class=divider></div>");
$templateCache.put("app/planner/components/multiTagInput/multi-tag-input.html","<div class=\"multi-tag container\"><div class=tag-input-container ng-class=\"{\n        \'compact-mode\': $ctrl.compactMode,\n        \'error\': $ctrl.notFoundAlert.length,\n        \'typing\': $ctrl.inputValue && $ctrl.inputValue.length\n    }\"><div class=tags-and-input-wrapper id=tags-and-input-wrapper ng-ref=tagsContainerRef ng-click=$ctrl.handleInputClick($event)><div class=tag ng-repeat=\"tag in $ctrl.visibleTags track by $index\"><span class=tag-text uib-tooltip={{tag}} tooltip-class=sp-planner-tooltip tooltip-placement=auto tooltip-append-to-body=true>{{ tag }}</span> <span class=tag-close ng-click=\"$ctrl.removeTag($index, $event)\"><img class=icon src=../../../assets/images/multi-tag-input/close-tag.svg alt=close-tag-multi-tag-input></span></div><div class=\"tag hidden-count-tag\" ng-if=\"$ctrl.hiddenTagsCount > 0\">+{{ $ctrl.hiddenTagsCount }} <span class=tag-close ng-click=$ctrl.exitCompactMode($event)><img class=icon src=../../../assets/images/multi-tag-input/close-tag.svg alt=close-tag-multi-tag-input></span></div><input ng-if=!$ctrl.compactMode type=text ng-model=$ctrl.inputValue ng-change=$ctrl.handleInputChange() ng-keydown=$ctrl.handleKeyDown($event) ng-paste=$ctrl.handlePaste($event) ng-click=$ctrl.handleInputClick($event) placeholder=\"{{ $ctrl.tags.length === 0 ? $ctrl.placeholder : \'\' }}\" id=multi-tag-input maxlength=254></div><div class=search-icon ng-if=!$ctrl.showClearButton ng-click=$ctrl.toggleSearchAndClear()><img class=icon src=../../../assets/images/multi-tag-input/search.svg alt=search-multi-tag-input></div><div class=clear-all-button ng-if=$ctrl.showClearButton ng-click=$ctrl.clearAllTags()><img class=icon src=../../../assets/images/multi-tag-input/close.svg alt=close-multi-tag-input></div><div class=suggestions-dropdown ng-if=$ctrl.suggestions.length><div ng-repeat=\"suggestion in $ctrl.suggestions\" class=suggestion-item ng-click=$ctrl.onClickSuggestion(suggestion.matchValue) uib-tooltip={{suggestion.matchValue}} tooltip-class=sp-planner-tooltip tooltip-placement=auto tooltip-append-to-body=true>{{suggestion.before}}<span class=suggestion-item-match>{{suggestion.match}}</span>{{suggestion.after}}</div></div></div><div><p class=error-message>{{$ctrl.notFoundAlert}}</p></div></div>");
$templateCache.put("app/planner/components/multipleSelectionOnMap/multipleSelectionOnMap.html","<div class=multiple-selection-on-map-container ng-if=$ctrl.showIf><div class=multiple-selection-on-map-header><div class=\"title text-left\"><span translate=MultipleSelectionOnMap.title></span></div><div class=collapsed><button class=\"btn btn-link sp-btn-collapse pull-right\" type=button><div ng-include=\"\'/assets/images/navegation_down/navegation_down_16.svg\'\" class=collapse-icon ng-if=$ctrl.isCollapsed ng-click=$ctrl.enterOnMultipleEditingMode()></div><div ng-include=\"\'/assets/images/navegation_up/navegation_up_16.svg\'\" class=collapse-icon ng-if=!$ctrl.isCollapsed ng-click=$ctrl.exitMultipleEditingMode()></div></button></div></div><div class=multiple-selection-on-map-buttons><div uib-collapse=$ctrl.isCollapsed><div class=button-container><button id=single-select-mode class=button-action type=button ng-click=$ctrl.updateMoveToMode(false) ng-class=\"{\'active\': $ctrl.isSingleSelectModeActivated()}\"><div class=button-icon ng-include=\"\'/assets/images/add_cursor/add_cursor_16.svg\'\" ng-class=\"{\'active\': $ctrl.isSingleSelectModeActivated()}\"></div><span translate=MultipleSelectionOnMap.single_select_mode></span></button></div><div class=button-container><button id=polygonal-selection-mode class=button-action type=button ng-click=$ctrl.initDrawingPolygon() ng-class=\"{\'active\':  $ctrl.isPolygonalSelectionModeActivated}\"><div class=button-icon ng-include=\"\'/assets/images/polygon/polygon_16.svg\'\" ng-class=\"{\'active\':  $ctrl.isPolygonalSelectionModeActivated}\"></div><span translate=MultipleSelectionOnMap.polygonal_selection_mode></span></button></div><div class=button-container><button id=hand-drawing-selection-mode class=button-action type=button ng-click=$ctrl.initHandDrawing() ng-class=\"{\'active\':  $ctrl.isHandDrawingSelectionModeActivated}\"><div class=button-icon ng-include=\"\'/assets/images/hand_drawing/hand_16.svg\'\" ng-class=\"{\'active\':  $ctrl.isHandDrawingSelectionModeActivated}\"></div><span translate=MultipleSelectionOnMap.hand_drawing_selection_mode></span></button></div><div class=divider></div><div class=button-container><button id=move-to-mode class=button-action type=button ng-click=$ctrl.updateMoveToMode(true) ng-disabled=!$ctrl.alertData.msg ng-class=\"{\'disabled\': !$ctrl.alertData.msg, \'active\': $ctrl.isMoveToModeActivated}\"><div class=button-icon ng-include=\"\'/assets/images/forward/forward_16.svg\'\" ng-class=\"{\'disabled\': !$ctrl.alertData.msg, \'active\': $ctrl.isMoveToModeActivated}\"></div><span translate=MultipleSelectionOnMap.move_to_mode></span></button></div></div></div></div><div class=sp-alert-msc ng-if=\"$ctrl.showIf && $ctrl.alertData.msg\"><div class=relative><div class=sp-alert-msc__content><span>{{$ctrl.alertData.msg.msg}}</span><div ng-if=!$ctrl.pickupAndDeliveryMode><span ng-if=!!$ctrl.alertData.msg.load>{{$ctrl.alertData.msg.load}} <i class=sp-icon-carga></i></span> <span ng-if=!!$ctrl.alertData.msg.load2>{{$ctrl.alertData.msg.load2}} <i class=sp-icon-carga-volumen></i></span> <span ng-if=!!$ctrl.alertData.msg.load3>{{$ctrl.alertData.msg.load3}} <i class=sp-icon-carga-valor></i></span> <span ng-if=!!$ctrl.alertData.msg.load4>{{$ctrl.alertData.msg.load4}}<div class=\"visit-card-icon-padding sp-icon-mix-load\" ng-include=\"\'/assets/images/vehicle_stats/box_filled.svg\'\"></div></span></div></div><span class=link-to-action><a class=\"sp-link sp-clicked-element\" ng-click=$ctrl.deselectSelection()>{{$ctrl.alertData.callToActionMsg}}</a></span></div></div>");
$templateCache.put("app/planner/components/optimizationResultsDropdown/optimizationResultsDropdown.html","<div class=sp-planner-optimization-results id=optimization-results-options><button class=sp-optimization-results-container ng-class=\"{\'sp-disabled-options\': $ctrl.optimizationResultsOptions.length === 1}\" ng-click=\"$ctrl.isCollapsed = !$ctrl.isCollapsed\" ng-disabled=\"$ctrl.optimizationResultsOptions.length === 1\"><div class=sp-option-title><span translate=OptimizationResults.title></span> <span class=pill-option uib-tooltip={{$ctrl.getTypeDescription($ctrl.currentOptimizationOption.type)}} tooltip-placement=bottom tooltip-append-to-body=true>{{$ctrl.getTypeLabel($ctrl.currentOptimizationOption.type)}}</span></div><div ng-include=\"\'/assets/images/navegation_down/navegation_down_24.svg\'\" class=sp-collapse-icon ng-if=$ctrl.isCollapsed></div><div ng-include=\"\'/assets/images/navegation_up/navegation_up_24.svg\'\" class=sp-collapse-icon ng-if=!$ctrl.isCollapsed></div></button><div class=sp-content-results uib-collapse=$ctrl.isCollapsed><ul class=sp-list-options><li ng-repeat=\"option in $ctrl.optimizationResultsOptions\" ng-class=\"{\'selected-option\': option.isCurrentOptimization }\" ng-click=$ctrl.selectOptimizationAlternative(option.problem_id) id=alternative-optimization-{{$index}}><span class=pill-option uib-tooltip={{$ctrl.getTypeDescription(option.type)}} tooltip-placement=left tooltip-append-to-body=true>{{$ctrl.getTypeLabel(option.type)}}</span><div class=sp-option-metrics><div class=sp-metric><div class=sp-metric-icon ng-include=\"\'/assets/images/indicators/pin.svg\'\"></div><div class=sp-metric-text>{{(\'OptimizationResults.out_of_route\' | translate:{qty: option.metrics.off_route_visits})}}</div></div><div class=sp-metric><div class=sp-metric-icon ng-include=\"\'/assets/images/indicators/vehicle.svg\'\"></div><div class=sp-metric-text>{{(\'OptimizationResults.fleet\' | translate:{qty: option.metrics.vehicles_used})}}</div></div><div class=sp-metric><div class=sp-metric-icon ng-include=\"\'/assets/images/indicators/weight.svg\'\"></div><div class=sp-metric-text>{{(\'OptimizationResults.load_1\' | translate:{qty: (option.metrics.avg_route_load_occupancy | formatNumber:0)})}}</div></div></div></li></ul></div></div>");
$templateCache.put("app/planner/components/polylineContextMenu/polylineContextMenu.html","<div id=polylineMapContextMenu ng-show=$ctrl.contextMenu.routesInArea.length><div class=title><img class=icon src=../../../assets/images/move_visit_to_route.svg alt=\"\"> <span translate=PolylineContextMenu.move_here_option></span></div><div class=route-list ng-repeat=\"route in $ctrl.contextMenu.routesInArea\" ng-click=\"$ctrl.moveVisitsToRoute(route.id, route.vehicleId)\"><button class=route-button ng-disabled=$ctrl.isRouteRevised(route)><span class=dot style=\"background-color: {{route.stroke.color}}\"></span> <span class=label>{{$ctrl.contextMenu.routeCodes[route.id]}}</span></button></div></div>");
$templateCache.put("app/planner/components/progressBar/progressBar.html","<div class=sp-progress-bar-container><div class=load-icon-container><div ng-include=$ctrl.iconUrl[$ctrl.typeLoad] class=load-icon></div></div><div class=sp-progress-bar-content><div class=sp-progress-bar><div class=sp-progress-bar-used-capacity-container><span class=text-bold translate=progressBar.{{$ctrl.typeLoad}}></span> <span class=\"used-capacity text-bold\" ng-class=\"{\'sp-progress-bar-text-overlad\': $ctrl.overload }\">{{$ctrl.round($ctrl.usedCapacity)}}/{{$ctrl.availableCapacity}}</span></div><uib-progressbar ng-class=\"{\'sp-progress-bar-overload\': $ctrl.overload }\" animate=false max=$ctrl.availableCapacity value=$ctrl.usedCapacity></uib-progressbar><div class=sp-progress-bar-used-capacity-container><span class=used-capacity ng-class=\"{\'sp-progress-bar-text-overlad\': $ctrl.overload }\">{{$ctrl.percentageOfCapacityUsed}}%</span></div></div></div><div class=sp-progress-bar-alert-icon-container ng-class=\"{\'hidden-alert\': !$ctrl.overload}\"><div ng-include=\"\'/assets/images/alert/alert_16.svg\'\" class=alert-icon></div></div></div>");
$templateCache.put("app/planner/components/rdMigrationBanner/rdMigrationBanner.html","<div class=sp-rd-migration-banner ng-if=$ctrl.ready ng-class=\"{\n       \'sp-rd-migration-banner--urgency\': $ctrl.state === \'urgency\',\n       \'sp-rd-migration-banner--critical\': $ctrl.state === \'critical\',\n       \'sp-rd-migration-banner--collapsed\': $ctrl.collapsed\n     }\"><div class=sp-rd-migration-banner__icon aria-hidden=true><i class=\"fa fa-exclamation-triangle\"></i></div><div class=sp-rd-migration-banner__content><div class=sp-rd-migration-banner__title><span ng-if=\"$ctrl.state === \'urgency\'\" translate=RdMigrationBanner.urgency_title translate-values=\"{ N: $ctrl.countdown.days }\"></span> <span ng-if=\"$ctrl.state === \'critical\'\" translate=RdMigrationBanner.critical_title></span></div><div class=sp-rd-migration-banner__body><span ng-if=\"$ctrl.state === \'urgency\'\"><span translate=RdMigrationBanner.urgency_body_prefix></span><span class=sp-rd-migration-banner__date>{{ $ctrl.deadlineDate | date:\'longDate\':\'UTC\' }}</span><span translate=RdMigrationBanner.urgency_body_suffix></span> </span><span ng-if=\"$ctrl.state === \'critical\'\" translate=RdMigrationBanner.critical_body></span></div><a class=sp-rd-migration-banner__whats-new ng-href=\"{{ $ctrl.whatsNewUrl }}\" target=_blank rel=\"noopener noreferrer\"><span translate=RdMigrationBanner.whats_new></span> <i class=\"fa fa-external-link sp-rd-migration-banner__whats-new-icon\" aria-hidden=true></i></a></div><div class=sp-rd-migration-banner__countdown><div class=sp-rd-migration-banner__countdown-block ng-if=\"$ctrl.state === \'urgency\'\"><span class=sp-rd-migration-banner__countdown-value>{{ $ctrl.pad($ctrl.countdown.days) }}</span> <span class=sp-rd-migration-banner__countdown-label translate=RdMigrationBanner.days></span></div><span class=sp-rd-migration-banner__countdown-sep ng-if=\"$ctrl.state === \'urgency\'\">:</span><div class=sp-rd-migration-banner__countdown-block ng-if=\"$ctrl.state === \'urgency\'\"><span class=sp-rd-migration-banner__countdown-value>{{ $ctrl.pad($ctrl.countdown.hours) }}</span> <span class=sp-rd-migration-banner__countdown-label translate=RdMigrationBanner.hours></span></div><span class=sp-rd-migration-banner__countdown-sep ng-if=\"$ctrl.state === \'urgency\'\">:</span><div class=sp-rd-migration-banner__countdown-block ng-if=\"$ctrl.state === \'urgency\'\"><span class=sp-rd-migration-banner__countdown-value>{{ $ctrl.pad($ctrl.countdown.minutes) }}</span> <span class=sp-rd-migration-banner__countdown-label translate=RdMigrationBanner.minutes></span></div><div class=sp-rd-migration-banner__countdown-block ng-if=\"$ctrl.state === \'critical\'\"><span class=sp-rd-migration-banner__countdown-value>{{ $ctrl.pad($ctrl.countdown.hours) }}</span> <span class=sp-rd-migration-banner__countdown-label translate=RdMigrationBanner.hours></span></div><span class=sp-rd-migration-banner__countdown-sep ng-if=\"$ctrl.state === \'critical\'\">:</span><div class=sp-rd-migration-banner__countdown-block ng-if=\"$ctrl.state === \'critical\'\"><span class=sp-rd-migration-banner__countdown-value>{{ $ctrl.pad($ctrl.countdown.minutes) }}</span> <span class=sp-rd-migration-banner__countdown-label translate=RdMigrationBanner.minutes></span></div><span class=sp-rd-migration-banner__countdown-sep ng-if=\"$ctrl.state === \'critical\'\">:</span><div class=sp-rd-migration-banner__countdown-block ng-if=\"$ctrl.state === \'critical\'\"><span class=sp-rd-migration-banner__countdown-value>{{ $ctrl.pad($ctrl.countdown.seconds) }}</span> <span class=sp-rd-migration-banner__countdown-label translate=RdMigrationBanner.seconds></span></div></div><button type=button class=sp-rd-migration-banner__cta ng-click=$ctrl.openOptInModal()><i class=\"fa fa-arrow-right sp-rd-migration-banner__cta-icon\" aria-hidden=true></i> <span ng-if=\"$ctrl.state === \'urgency\'\" translate=RdMigrationBanner.cta_try></span> <span ng-if=\"$ctrl.state === \'critical\'\" translate=RdMigrationBanner.cta_go></span></button> <button type=button class=sp-rd-migration-banner__collapse ng-click=$ctrl.toggleCollapsed() aria-label=\"{{ ($ctrl.collapsed ? \'RdMigrationBanner.expand\' : \'RdMigrationBanner.collapse\') | translate }}\"><i class=\"fa fa-chevron-up\"></i></button></div>");
$templateCache.put("app/planner/components/rdMigrationBanner/rdMigrationBanner.modal.html","<div class=sp-rd-migration-modal><div class=sp-rd-migration-modal__icon aria-hidden=true><svg viewBox=\"0 0 24 24\" width=22 height=22 fill=none stroke=currentColor stroke-width=2 stroke-linecap=round stroke-linejoin=round><line x1=5 y1=12 x2=19 y2=12></line><polyline points=\"12 5 19 12 12 19\"></polyline></svg></div><h3 class=sp-rd-migration-modal__title translate=RdMigrationBanner.modal_title></h3><p class=sp-rd-migration-modal__body><span translate=RdMigrationBanner.modal_body_p1_prefix></span><strong translate=RdMigrationBanner.modal_body_p1_highlight></strong><span translate=RdMigrationBanner.modal_body_p1_middle></span><strong>{{ deadlineFormatted }}</strong><span translate=RdMigrationBanner.modal_body_p1_suffix></span></p><p class=sp-rd-migration-modal__body translate=RdMigrationBanner.modal_body_p2></p><p class=sp-rd-migration-modal__error ng-if=errorKey translate=\"{{ errorKey }}\"></p><div class=sp-rd-migration-modal__buttons><button type=button class=\"btn btn-default sp-rd-migration-modal__cancel\" ng-click=cancel() ng-disabled=loading translate=RdMigrationBanner.modal_cancel></button> <button type=button class=\"btn btn-primary sp-rd-migration-modal__confirm\" ng-click=confirm() ng-disabled=loading><svg ng-if=!loading class=sp-rd-migration-modal__confirm-icon viewBox=\"0 0 24 24\" width=14 height=14 fill=none stroke=currentColor stroke-width=2.5 stroke-linecap=round stroke-linejoin=round aria-hidden=true><polyline points=\"20 6 9 17 4 12\"></polyline></svg> <i class=\"fa fa-spinner fa-spin sp-rd-migration-modal__confirm-icon\" aria-hidden=true ng-if=loading></i> <span ng-if=!loading translate=RdMigrationBanner.modal_confirm></span> <span ng-if=loading translate=RdMigrationBanner.modal_loading></span></button></div></div>");
$templateCache.put("app/planner/components/reorderRoutes/reorderRoutes.html","<div><button type=button class=\"btn sp-btn-default button-size sp_new_button\" ng-click=$ctrl.buttonAction() translate=ReorderRoutes.route_optimize></button></div>");
$templateCache.put("app/planner/components/restTimeCard/restTimeCard.html","<div class=sp-rest-time-card-container ng-class=\"{\'error\': $ctrl.restTime.hasError}\"><div class=sp-rest-time-card-title-container><div ng-if=$ctrl.showDragHandle ui-tree-handle class=sp-rest-time-card-title-dragger ng-class=\"{\'visit_edit_block_by_route_processed\': $ctrl.isEventFromProcessedRoute}\" ng-include=\"\'/assets/images/menu_burger.svg\'\"></div><div ng-if=$ctrl.restTime.hasError class=sp-rest-time-card-title-alert uib-tooltip={{$ctrl.alertTooltip}} tooltip-class=sp-rest-time-tooltip tooltip-placement=auto tooltip-append-to-body=true ng-include=\"\'/assets/images/alert_circle.svg\'\"></div><span class=sp-rest-time-card-title-text translate=RestTimeCard.title></span></div><div class=sp-rest-time-card-time-container ng-class=\"{\'error\': $ctrl.restTime.hasError}\"><span>{{$ctrl.restTimeArrival}}</span> <span translate=RestTimeCard.to></span> <span>{{$ctrl.restTimeDeparture}}</span></div></div>");
$templateCache.put("app/planner/components/richSelect/richSelect.html","<ul ng-repeat=\"category in $ctrl.displayData.categories\"><div class=category-title ng-click=$ctrl.toggleCollapse(category)><p>{{category.title}}</p><div ng-include=\"\'/assets/images/navegation_down/navegation_down_16.svg\'\" class=sp-collapse-icon ng-if=category.isCollapsed ng-click=\"$event.stopPropagation(); $ctrl.toggleCollapse(category)\"></div><div ng-include=\"\'/assets/images/navegation_up/navegation_up_16.svg\'\" class=\"sp-collapse-icon up\" ng-if=!category.isCollapsed ng-click=\"$event.stopPropagation(); $ctrl.toggleCollapse(category)\"></div></div><div class=container-items uib-collapse=category.isCollapsed><li class=card-item ng-repeat=\"item in category.items\" ng-click=$ctrl.itemSelected(item)><div class=card-top><div class=card-title><div class=sp-options-circle ng-style=\"{\'border-color\': item.color, \'background-color\': item.color}\"></div><span class=item-title tooltip-class=tooltip-indicators-alerts uib-tooltip={{item.title}}>{{item.title}}</span></div><div class=sp-planner-routes-vehicle-content-route-content-visits-info-visit-right-side-content-capacities><div class=sp-capacity ng-repeat=\"kpi in item.kpis\" tooltip-class=tooltip-indicators-alerts uib-tooltip={{kpi.description}} ng-class=\"{\'sp-text-color-danger\': kpi.classError}\"><i class=\"{{kpi.icon}} visit-card-icon-padding\" ng-class=\"{\'sp-text-color-danger\': kpi.classError}\"></i> {{ kpi.value }}%</div></div></div><div class=card-footer><div><span class=item-tag ng-repeat=\"tag in $ctrl.getVisibleTags(item.tags)\">{{ tag.value }}</span> <span class=item-tag ng-if=$ctrl.hasMoreTags(item.tags) tooltip-class=tooltip-indicators-alerts uib-tooltip=\"{{ item.hiddenTagsTooltip }}\" tooltip-enable=true>+{{item.tags.length - 3}}</span></div><span class=item-status ng-bind=item.status.value ng-style=\"{\'background-color\': item.status.color}\"></span></div></li></div></ul>");
$templateCache.put("app/planner/components/routeMenuDropdown/routeMenuDropdown.html","<div class=route-menu uib-dropdown auto-close=outsideClick is-open=$ctrl.route.isOptionsMenuOpen><div id=route-menu-open-btn ng-include=\"\'/assets/images/indicators/kebab.svg\'\" class=sp-planner-route-indicators-item ng-click=$ctrl.toggleOptionsMenu() ng-class=\"{\'route-menu-icon-open\': $ctrl.route.isOptionsMenuOpen}\"></div><ul class=dropdown-menu uib-dropdown-menu role=menu><li class=sp-dropdown-menu-item role=menuitem id=route-menu-revised-btn ng-click=\"$ctrl.activeOptions() && $ctrl.markAsRevised(); $event.stopPropagation()\" translate=Revised_routes.mark_revised ng-class=\"{\'sp-dropdown-menu-item-disabled\': !$ctrl.activeOptions()}\"></li><li ng-if=!$ctrl.isRouteProcessed class=sp-dropdown-menu-item role=menuitem ng-click=\"$ctrl.reverseRouteOrder(); $event.stopPropagation()\" id=route-menu-reverse_order-btn translate=Routes.reverse_route_order></li><li ng-if=!$ctrl.isRouteProcessed class=sp-dropdown-menu-item role=menuitem translate=Routes.reorder data-simpliroute-edited-route={{$ctrl.route.hasManualChanges}} ng-click=\"$ctrl.activeOptions() && $ctrl.reorderRoute(); $event.stopPropagation()\" id=route-menu-reorder-btn ng-class=\"{\'sp-dropdown-menu-item-disabled\': !$ctrl.activeOptions()}\"></li><li ng-if=\"!$ctrl.isRouteProcessed && $ctrl.canRouteBeRemoved()\" class=sp-dropdown-menu-item role=menuitem ng-click=\"$ctrl.goToDeleteRoute(); $event.stopPropagation()\" id=route-menu-delete-btn translate=Routes.delete_menu></li><li ng-if=$ctrl.isPrioritizeLoadActive class=sp-dropdown-menu-item role=menuitem ng-click=\"$ctrl.activeOptions() && $ctrl.prioritizeLoad(); $event.stopPropagation()\" translate=Routes.prioritize_high_load></li></ul></div>");
$templateCache.put("app/planner/components/routingSummaryTable/routingSummaryTable.html","<div id=routing-summary-table class=sp-routing-summary-table><header class=grid-layout ng-class=$ctrl.getSummaryColumnClass()><span class=\"align-start full-column\" translate=RoutingSummaryTable.vehicle></span> <span class=\"align-start full-column\" translate=RoutingSummaryTable.driver></span> <span ng-if=$ctrl.showCoDrivers() translate=RoutingSummaryTable.co_driver></span> <span translate=RoutingSummaryTable.routes></span> <span ng-if=$ctrl.joinSimilar translate=RoutingSummaryTable.stops></span> <span translate=RoutingSummaryTable.visits></span> <span>KMS</span> <span translate=RoutingSummaryTable.time></span> <span ng-if=$ctrl.showComments class=\"align-start full-column\" translate=RoutingSummaryTable.comment_route></span></header><section><article ng-repeat=\"vehicle in $ctrl.vehicles\"><div ng-if=$ctrl.isMultiDriversConfigEnabled><div class=\"grid-layout row-padding\" ng-class=$ctrl.getSummaryColumnClass() ng-repeat=\"route in vehicle.routes\"><span ng-if=$first class=\"align-start full-column ellipsis-text\" uib-tooltip={{::vehicle.name}}>{{ ::vehicle.name }}</span><select class=\"start-second-column full-column\" ng-model=route.driver ng-change=\"$ctrl.onChangeDriverPerRoute(vehicle, route)\" ng-if=\"!$ctrl.isTmsEnable || !$ctrl.isFieldEditable\" ng-disabled=!$ctrl.isFieldEditable ng-options=\"driver.id as driver.group + \' \' + driver.name for driver in $ctrl.sortedDrivers\" ng-class=\"{\'sp-cursor-not-allowed\': !$ctrl.isFieldEditable}\"><option value=\"\" translate=RoutingSummaryTable.select_driver></option></select><custom-select ng-if=\"$ctrl.isTmsEnable && $ctrl.isFieldEditable\" class=\"start-second-column full-column\" data=$ctrl.driverSelectInfo.drivers selected-id=route.driver on-click-option=$ctrl.driverSelectInfo.onClickOption context=\"{vehicle: vehicle, route: route}\" ng-style=\"{\'width\': \'200px\'}\" additional-width=80></custom-select><widget-co-driver ng-if=$ctrl.showCoDrivers() co-drivers=route.codrivers is-editable=$ctrl.isFieldEditable go-to-co-drivers=\"$ctrl.goToCoDrivers({vehicle: {vehicle: vehicle, route: route}})\"></widget-co-driver><span class=break-text>{{ ::$ctrl.getRouteName(route, $index + 1) }}</span> <span ng-if=$ctrl.joinSimilar>{{ $ctrl.getRouteStops(route) }} </span><span>{{ ::$ctrl.getRouteTotalVisits(route) }} </span><span>{{ ::$ctrl.getRouteTotalDistance(route).toFixed(1) | formatNumber:2:\'.\':\',\' }}</span> <span>{{ ::$ctrl.getRouteTotalTime(route) }}<small class=sp-xx-small-text>HRS</small></span><div ng-if=$ctrl.showComments class=full-column><input ng-if=$ctrl.isCustomRouteNameConfigEnabled class=\"full-column non-editable-input\" type=text ng-model=route.comment readonly> <input ng-if=!$ctrl.isCustomRouteNameConfigEnabled class=full-column type=text ng-model=route.comment></div></div><div ng-if=$ctrl.hasMultipleRoutes(vehicle) class=\"grid-layout row-padding\" ng-class=$ctrl.getSummaryColumnClass()><span class=total-label translate=RoutingSummaryTable.total ng-class=$ctrl.getInitColumnClass()></span> <span>{{ ::vehicle.routes.length }} </span><span ng-if=$ctrl.joinSimilar>{{ $ctrl.getVehicleTotalStops(vehicle) }} </span><span>{{ ::$ctrl.getVehicleTotalVisits(vehicle) }} </span><span>{{ ::$ctrl.getVehicleTotalDistance(vehicle) | formatNumber:2:\'.\':\',\'}} </span><span>{{ ::$ctrl.getVehicleTotalTime(vehicle) }}<small class=sp-xx-small-text>HRS</small></span></div></div><div ng-if=!$ctrl.isMultiDriversConfigEnabled class=\"grid-layout row-padding\" ng-class=$ctrl.getSummaryColumnClass()><span class=\"align-start full-column ellipsis-text\" uib-tooltip={{::vehicle.name}}>{{ ::vehicle.name }}</span><select class=full-column ng-model=vehicle.driverId ng-change=$ctrl.onChangeDriverPerVehicle(vehicle) ng-if=\"!$ctrl.isTmsEnable || !$ctrl.isFieldEditable\" ng-disabled=!$ctrl.isFieldEditable ng-options=\"driver.id as driver.group + \' \' + driver.name for driver in $ctrl.sortedDrivers\" ng-class=\"{\'sp-cursor-not-allowed\': !$ctrl.isFieldEditable}\"><option value=\"\" translate=RoutingSummaryTable.select_driver></option></select><custom-select ng-if=\"$ctrl.isTmsEnable && $ctrl.isFieldEditable\" class=\"start-second-column full-column\" data=$ctrl.driverSelectInfo.drivers selected-id=vehicle.driverId on-click-option=$ctrl.driverSelectInfo.onClickOption context=\"{vehicle: vehicle, route: vehicle.routes[0]}\" ng-style=\"{\'width\': \'200px\'}\" additional-width=80></custom-select><widget-co-driver ng-if=$ctrl.showCoDrivers() co-drivers=vehicle.routes[0].codrivers is-editable=$ctrl.isFieldEditable go-to-co-drivers=\"$ctrl.goToCoDrivers({vehicle: vehicle})\"></widget-co-driver><span>{{ ::vehicle.routes.length }} </span><span ng-if=$ctrl.joinSimilar>{{ $ctrl.getRouteStops(vehicle.routes[0]) }} </span><span>{{ ::$ctrl.getVehicleTotalVisits(vehicle) }} </span><span>{{ ::$ctrl.getVehicleTotalDistance(vehicle) | formatNumber:2:\'.\':\',\' }} </span><span>{{ ::$ctrl.getVehicleTotalTime(vehicle) }}<small class=sp-xx-small-text>HRS</small></span><div ng-if=$ctrl.showComments class=full-column><input ng-if=$ctrl.isCustomRouteNameConfigEnabled class=\"full-column non-editable-input\" type=text ng-model=vehicle.routes[0].comment readonly> <input ng-if=!$ctrl.isCustomRouteNameConfigEnabled class=full-column type=text ng-model=vehicle.routes[0].comment ng-blur=$ctrl.checkRouteComments(vehicle.routes)></div></div></article></section></div>");
$templateCache.put("app/planner/components/searchBar/search-bar-template.html","<div class=search-visit-vehicle><div class=search-input><input type=text class=\"form-control sp_new_input\" ng-model=inputValue ng-keyup=onKeyUp($event) ng-change=onChangeSearchInput() ng-blur=onBlurSearchInput($event) ng-focus=onFocusSearchInput($event) placeholder={{placeholder}} ng-model-options=\"{ debounce: 500 }\"><div class=search-icon><i ng-show=!inputValue class=sp-icon-search></i> <i ng-show=inputValue ng-click=removeFilter() class=sp-icon-close></i></div></div><div class=\"datalist{{activeOptions ? \'-active\': \'\'}}\" ng-if=onFocus><div ng-show=!resultsFound><p class=datalist-label>{{noResultsFoundText}}</p></div><div ng-repeat=\"(typeKey, typeValue) in results\"><p ng-init=\"parentIndex = $index\" class=datalist-label>{{(\'SearchBar.Results.\' + filters[typeKey].title) | translate}}</p><div ng-repeat=\"(key, value) in typeValue\"><p id={{parentIndex}}-{{$index}} ng-mousedown=\"onMouseDown(value, key, typeKey)\" class=\"datalist-option{{listFocusHandler.focusIndex === parentIndex + \'-\' + $index ? \'-active\': \'\' }}\">{{key}}</p></div></div></div><div class=\"datalist{{isBetweenMinActivationLength() ? \'-active\': \'\'}}\" ng-if=onFocus><p class=datalist-label>{{minText}}</p></div></div>");
$templateCache.put("app/planner/components/skillsSummary/skillsSummary.html","<div class=skills-content id=summary_of_visit_skills ng-class=\"{\'error\': $ctrl.skillsError}\" ng-if=\"$ctrl.requiredSkills.length || $ctrl.optionalSkills.length\"><div class=icon-lamp ng-include=\"\'/assets/images/lamp.svg\'\" ng-class=\"{\'error\': $ctrl.skillsError}\"></div><div class=skills-list><div class=\"sp-text-ellipsis skill-name required-skills\" ng-class=\"{\'error\': $ctrl.skillsError}\" uib-tooltip={{skill.name}} tooltip-append-to-body=true ng-repeat=\"skill in $ctrl.requiredSkills | limitTo:$ctrl.limitRequiredSkills\"><span>{{skill.name}}</span></div><div class=\"remaining-skills required-skills\" ng-class=\"{\'error\': $ctrl.skillsError}\" ng-if=$ctrl.showRemainingRequired tooltip-placement=top-right tooltip-append-to-body=true uib-tooltip={{$ctrl.remainingRequiredSkill}}><span>...</span></div><div class=\"sp-text-ellipsis skill-name optional-skill\" ng-class=\"{\'error\': $ctrl.skillsError}\" tooltip-placement=top-right tooltip-append-to-body=true uib-tooltip={{skill.name}} ng-repeat=\"skill in $ctrl.optionalSkills | limitTo:$ctrl.limitOptionalSkills\"><span>{{skill.name}}</span></div><div class=\"remaining-skills optional-skill\" ng-class=\"{\'error\': $ctrl.skillsError}\" ng-if=$ctrl.showRemainingOptional tooltip-placement=top-right tooltip-append-to-body=true uib-tooltip={{$ctrl.remainingOptionalSkill}}><span>...</span></div></div></div>");
$templateCache.put("app/planner/components/toastFinish/toastFinish.html","<div class=toast_finish><div class=toast_finish_icon_section><div class=toast_finish_icon_section_icon></div></div><div class=toast_finish_content_section><div class=toast_finish_content_section_header><div class=title><p translate=ToastFinish.info></p></div><div class=close><i class=sp-icon-close ng-click=$ctrl.close()></i></div></div></div></div><div class=toast_finish_loading></div>");
$templateCache.put("app/planner/components/toastRoutes/toastRoutes.html","<div class=toast_routes><div class=toast_routes_icon_section><div class=toast_routes_icon_section_icon></div></div><div class=toast_routes_content_section><div class=toast_routes_content_section_header><div class=title><p translate=ToastRoutes.title></p></div><div class=close><i class=sp-icon-close ng-click=$ctrl.close()></i></div></div><p translate=ToastRoutes.description></p></div></div><div class=toast_loading></div>");
$templateCache.put("app/planner/components/toolSelectionOnMap/toolSelectionOnMap.html","<div class=tool-selection-on-map-container><div class=tool-selection-on-map-header><div class=\"title text-left\"><span translate=ToolSelectionOnMap.title></span></div><div class=collapsed><button class=\"btn btn-link sp-btn-collapse pull-right\" type=button><div ng-include=\"\'/assets/images/navegation_down/navegation_down_16.svg\'\" class=collapse-icon ng-if=$ctrl.isCollapsed ng-click=$ctrl.toggleCollapse()></div><div ng-include=\"\'/assets/images/navegation_up/navegation_up_16.svg\'\" class=collapse-icon ng-if=!$ctrl.isCollapsed ng-click=$ctrl.toggleCollapse()></div></button></div></div><div class=tool-selection-on-map-buttons><div uib-collapse=$ctrl.isCollapsed><div ng-transclude></div></div></div></div><div class=sp-alert-msc ng-if=\"$ctrl.alertData.msg && $ctrl.alertData.msg.length > 0\"><div class=relative><div class=sp-alert-msc__content><span>{{$ctrl.alertData.msg}}</span><div ng-if=$ctrl.loads><span ng-if=!!$ctrl.alertData.load>{{$ctrl.alertData.load}} <i class=sp-icon-carga></i></span> <span ng-if=!!$ctrl.alertData.load2>{{$ctrl.alertData.load2}} <i class=sp-icon-carga-volumen></i></span> <span ng-if=!!$ctrl.alertData.load3>{{$ctrl.alertData.load3}}<i class=sp-icon-carga-valor></i></span> <span ng-if=!!$ctrl.alertData.load4>{{$ctrl.alertData.load4}}<div class=\"visit-card-icon-padding sp-icon-mix-load\" ng-include=\"\'/assets/images/vehicle_stats/box_filled.svg\'\"></div></span></div></div><span class=link-to-action><a class=\"sp-link sp-clicked-element\" ng-click=$ctrl.deselectSelection()>{{$ctrl.alertData.callToActionMsg}}</a></span></div></div>");
$templateCache.put("app/planner/components/vehicleSortBy/vehicleSortBy.html","<div class=\"select-fleet sp-planner-filter-vehicles\" data-test-id=order-vehicle><select class=sp_new_input ng-change=$ctrl.handleChange() ng-model=$ctrl.sortBy ng-init=$ctrl.sortByDefault data-testid=filter-select><option value=\"\" translate=Routes.filter_vehicle.sort_by disabled data-testid=initial-option></option><option value=LHN translate=Routes.filter_vehicle.low_high_name data-testid=option-name></option><option value=LHV translate=Routes.filter_vehicle.low_high_hours data-testid=option-hours-lh></option><option value=HLV translate=Routes.filter_vehicle.high_low_hours data-testid=option-hours-hl></option><option value=LHK translate=Routes.filter_vehicle.low_high_kilometer data-testid=option-kilometer-lh></option><option value=HLK translate=Routes.filter_vehicle.high_low_kilometer data-testid=option-kilometer-hl></option><option ng-if=\"$ctrl.totalLoads[0] > 0\" value=LHC translate=Routes.filter_vehicle.low_high_load data-testid=option-load-lh></option><option ng-if=\"$ctrl.totalLoads[0] > 0\" value=HLC translate=Routes.filter_vehicle.high_low_load data-testid=option-load-hl></option><option ng-if=\"$ctrl.totalLoads[1] > 0\" value=LHC2 translate=Routes.filter_vehicle.low_high_load2 data-testid=option-load2-lh></option><option ng-if=\"$ctrl.totalLoads[1] > 0\" value=HLC2 translate=Routes.filter_vehicle.high_low_load2 data-testid=option-load2-hl></option><option ng-if=\"$ctrl.totalLoads[2] > 0\" value=LHC3 translate=Routes.filter_vehicle.low_high_load3 data-testid=option-load3-lh></option><option ng-if=\"$ctrl.totalLoads[2] > 0\" value=HLC3 translate=Routes.filter_vehicle.high_low_load3 data-testid=option-load3-hl></option></select></div>");
$templateCache.put("app/planner/components/visitFilter/visitFilter.html","<div class=visit-filter><div class=button-container><button type=button class=button ng-click=$ctrl.toggleFilter() ng-class=\"{\'selected\': $ctrl.open}\"><div class=icon ng-include=\"\'/assets/images/filter_icon.svg\'\" ng-class=\"{\'selected\': $ctrl.open}\"></div><span translate=VisitFilter.filter_button></span></button> <span ng-if=$ctrl.activeFilter class=\"text--color text--size-m\">{{(\'VisitFilter.number_of_visits_shown\' | translate:{filteredVisits: $ctrl.filteredVisits, totalVisits: $ctrl.totalVisits})}}</span></div><div ng-if=$ctrl.open class=slider><span class=\"text--color text--size-h\" translate=VisitFilter.time_window></span><rzslider class=custom-slider rz-slider-model=$ctrl.sliderTime.min rz-slider-high=$ctrl.sliderTime.max rz-slider-options=$ctrl.sliderTime.options></rzslider></div></div>");
$templateCache.put("app/planner/components/visitReference/visitReference.html","<div class=visit-reference><div ng-include=\"\'/assets/images/file-report.svg\'\" class=icon-file-report></div><span id=ref-{{$ctrl.visit.id}} class=sp-text-ellipsis tooltip-class=tooltip-reference-id tooltip-append-to-body=true tooltip-enable=$ctrl.shouldDisplayTooltip($ctrl.visit.id) uib-tooltip={{$ctrl.visit.reference}} tooltip-placement=top-right>{{$ctrl.visit.reference}}</span></div>");
$templateCache.put("app/planner/components/widgetCoDriver/widgetCoDriver.html","<div><div class=sp-widget-co-driver ng-click=\"$ctrl.isEditable && $ctrl.goToCoDrivers()\" ng-class=\"{\'sp-cursor-not-allowed\': !$ctrl.isEditable}\"><div class=fa-stack ng-if=$ctrl.hasCoDrivers()><i class=\"sp-icon-user sp-icon-form fa-stack-2x\" ng-class=\"{\'sp-icon-form-inactive\': !$ctrl.isEditable}\"></i><div class=\"fa fa-stack-1x\"><div class=sp-icon-over-active><i class=\"fa fa-circle fa-stack-1x\"></i> <span class=\"fa fa-stack-1x sp-icon-over-text\">{{$ctrl.hasExceededCoDriversLimit() ? \'+\' + $ctrl.MAX_CO_DRIVERS_LIMIT : $ctrl.getCoDriversCount()}}</span></div></div></div><div ng-if=!$ctrl.hasCoDrivers()><i class=\"sp-icon-user sp-icon-form sp-icon-form-inactive\"></i> <span class=\"fa fa-stack-1x sp-icon-over-inactive\"><i class=\"fa fa-plus-circle\"></i></span></div></div></div>");
$templateCache.put("app/main/components/logo/logo.html","<svg viewBox=\"0 0 40 40\" fill=currentColor xmlns=http://www.w3.org/2000/svg class=sp-logo><path d=\"M8.057 28.876c.572 0 1.086.115 1.6.346l5.6-5.937c-.457-.807-.743-1.729-.743-2.709 0-2.536 1.486-4.668 4-5.302V4.207c-1.6-.576-2.628-2.074-2.628-3.861V.058C6.8 1.902 0 10.028 0 19.769c0 4.611 1.543 8.819 4.057 12.22.514-1.787 2.114-3.113 4-3.113Zm.229-15.735c1.485 0 2.628 1.21 2.628 2.652 0 1.498-1.2 2.65-2.628 2.65-1.486 0-2.629-1.21-2.629-2.65 0-1.441 1.2-2.652 2.629-2.652ZM30.572 10.029c-.115-.461-.229-.922-.229-1.383 0-1.902 1.2-3.459 2.8-4.093A19.882 19.882 0 0 0 24.172 0v.288c0 1.787-1.315 3.285-2.686 3.92v11.181c.228.173 1.143.461 1.657.807l7.429-6.167ZM34.686 13.026c-.857 0-1.657-.23-2.286-.692l-7.428 6.168c.228.634.4 1.325.4 2.074a5.252 5.252 0 0 1-.8 2.825l5.6 6.57c.457-.173.914-.23 1.428-.23 1.829 0 3.314 1.095 4 2.709A20.242 20.242 0 0 0 40 19.827c0-3.055-.686-5.937-1.886-8.53-.742 1.037-2 1.729-3.428 1.729ZM17.314 25.36l-5.542 5.88c.285.576.4 1.152.4 1.844 0 1.786-1.143 3.285-2.686 3.919C12.514 38.905 16.114 40 20 40c3.314 0 6.457-.807 9.2-2.248a4.436 4.436 0 0 1-1.886-3.631c0-.807.229-1.614.629-2.248l-5.429-6.398c-.742.404-1.6.634-2.514.634-1.028-.057-1.886-.345-2.686-.749Z\"/></svg>");
$templateCache.put("app/main/components/mobileCompatibilityMessage/mobileCompatibilityMessage.html","<div class=mobile-compatibility-message-container><img ng-src=../../../assets/images/ada_idea_chiquita.png width=130 height=160 alt=mobile-device-alert><h3 class=title translate=mobileCompatibilityMessage.title></h3><p class=text-description translate=mobileCompatibilityMessage.description></p><button class=button type=button ng-click=$ctrl.onContinueWithMobile()><span translate=mobileCompatibilityMessage.buttonLabel></span> <i class=sp-icon-chevron-thin-right></i></button></div>");
$templateCache.put("app/main/components/mobileSidebar/mobileSidebar.html","<div class=sp-open-mobile-sidebar-button><button type=button ng-include=\"\'/assets/images/menu_burger.svg\'\" ng-click=$ctrl.openMobileSidebar()></button> <span translate=MobileHeader.{{$ctrl.sectionTitle}}_title></span></div><div class=sp-mobile-sidebar ng-if=$ctrl.isMobileSidebarDisplayed><div class=background-container></div><div class=mobile-sidebar-container ng-click=$ctrl.closeMobileSidebarThroughBackground($event)><div id=mobile-sidebar-menu class=mobile-sidebar-menu><div class=close-button-container><button type=button ng-include=\"\'assets/images/close_mobile_sidebar.svg\'\" ng-click=$ctrl.closeMobileSidebarThroughButton()></button></div><div class=menu-container><div class=logo-container><div class=sr-logo ng-include=\"\'/assets/images/logo_sr.svg\'\"></div></div><div class=nav-items-container-mobile><nav><ul class=navbar-modules-container id=nav-bar-modules-list ng-class=\"{\'border-bottom\': $ctrl.isNavbarHeightExceeded()}\"><nav-item ng-repeat=\"item in $ctrl.sectionsToDisplay.modules track by item.title\" item=item go-to-module=$ctrl.goToModule(item) is-sidebar-expanded=true on-toggle=$ctrl.onToggle(indexItem) current-index=$ctrl.currentIndex index-item=$index></nav-item></ul><ul id=nav-bar-configs-list class=navbar-configs-container><nav-item ng-repeat=\"item in $ctrl.sectionsToDisplay.configs track by item.title\" item=item go-to-module=$ctrl.goToModule(item) is-sidebar-expanded=true current-index=$ctrl.currentIndex index-item=$index></nav-item></ul></nav></div></div><div class=profile-container ng-class=\"{\'selected-profile\' : $ctrl.profile.isSubmenuOpen}\"><profile class=profile-menu-mobile item=$ctrl.profile is-sidebar-expanded=true go-to-module=$ctrl.goToModule(item)></profile></div></div></div></div>");
$templateCache.put("app/main/components/navItem/navItem.html","<li id=\"{{\'nav-item-\' + $ctrl.item.title}}\" class=sp-nav-item><a id=\"{{\'nav-item-action-\' + $ctrl.item.title}}\" href=\"\" ng-class=\"[\n      {\'active\': $ctrl.isItemActive()},\n      {\'disabled\': $ctrl.item.disabled},\n      {\'expanded-sidebar\': $ctrl.isSidebarExpanded}\n    ]\" ng-click=\"$ctrl.handleItemSelection(); $event.stopPropagation()\"><div class=item><div class=nav-item-icon ng-include=$ctrl.item.icon></div><div ng-show=$ctrl.isSidebarExpanded class=\"nav-item-title lang-{{$ctrl.currentLanguage}}\" translate=NavItem.{{$ctrl.item.title}}_title></div></div><div class=expand-icon-container ng-if=\"$ctrl.item.subsections && $ctrl.isSidebarExpanded\"><div class=expand-icon ng-include=$ctrl.getExpandIconURL()></div></div></a><ul class=\"subsection-container nav-subitem-lang-{{$ctrl.currentLanguage}}\" ng-show=$ctrl.shouldShowSubsections()><nav-subitem ng-repeat=\"subItem in $ctrl.item.subsections.items\" item=subItem go-to-module=$ctrl.callGoToModule(subItem)></nav-subitem></ul></li>");
$templateCache.put("app/main/components/navSubitem/navSubitem.html","<li id=\"{{\'nav-subitem-\' + $ctrl.item.title}}\" class=sp-nav-subitem><a id=\"{{\'nav-subitem-action-\' + $ctrl.item.title}}\" href=\"\" ng-click=$ctrl.goToModule($ctrl.item) ng-class=\"{\'active\': $ctrl.isItemActive(), \'disabled\': $ctrl.item.disabled}\"><div ng-if=$ctrl.item.icon ng-include=$ctrl.item.icon></div><div ng-if=!$ctrl.item.icon class=subitem-ellipse ng-class=\"{\'subitem-active\': $ctrl.isItemActive()}\"></div><div class=subitem-title>{{(\'NavSubitem.\' + $ctrl.item.title + \'_title\' | translate)}}</div></a></li>");
$templateCache.put("app/main/components/notFoundPage/notFoundPage.html","<div class=sr-not-found-page__container><img alt=\"Empty table\" width=207 height=207 src=../../../assets/images/new_ada_sad.svg> <span class=sr-not-found-page__title>{{ \'NotFoundPage.title\' | translate }} </span><span class=sr-not-found-page__text>{{ \'NotFoundPage.text1\' | translate }}<br>{{ \'NotFoundPage.text2\' | translate }}<br>{{ \'NotFoundPage.text3\' | translate }} </span><button type=button class=sr-not-found-page__button ng-click=$ctrl.handleGoToProfile()><span>{{ \'NotFoundPage.button\' | translate }}</span></button></div>");
$templateCache.put("app/main/components/profile/profile.html","<div class=profile-content ng-click=$ctrl.toggleSubmenu()><button type=button class=sp-profile>{{$ctrl.item.nameInitials}}</button> <span class=sp-profile-title ng-show=$ctrl.isSidebarExpanded translate=NavItem.profile></span></div><submenu parent-item=$ctrl.item go-to-module=$ctrl.callGoToModule(item)></submenu>");
$templateCache.put("app/main/components/sidebar/sidebar.html","<div class=sp-sidebar ng-mouseenter=$ctrl.handleMouseEnter() ng-mouseleave=$ctrl.handleMouseLeave() ng-class=\"{\'expanded\': $ctrl.isSidebarExpanded}\"><div class=sidebar-container><div class=nav-items-container><div class=logo-container><div class=toggle-icon-expand ng-click=$ctrl.toggleFixedSidebar()><div class=icon-arrow-bar ng-class=\"{\'icon-arrow-bar-left\' :$ctrl.isSidebarExpanded}\" ng-include=\"\'/assets/images/arrow-bar-right.svg\'\"></div></div><logo ng-show=!$ctrl.isSidebarExpanded class=logo></logo><div ng-if=$ctrl.isSidebarExpanded class=sr-logo ng-include=\"\'/assets/images/logo_sr.svg\'\"></div></div><nav><ul class=navbar-modules-container id=nav-bar-modules-list ng-class=\"{\'border-bottom\': $ctrl.isNavbarHeightExceeded()}\"><nav-item ng-repeat=\"item in $ctrl.sectionsToDisplay.modules track by item.title\" item=item go-to-module=$ctrl.goToModule(item) is-sidebar-expanded=$ctrl.isSidebarExpanded on-toggle=$ctrl.onToggle(indexItem) current-index=$ctrl.currentIndex index-item=$index></nav-item></ul><ul id=nav-bar-configs-list class=navbar-configs-container><nav-item ng-repeat=\"item in $ctrl.sectionsToDisplay.configs track by item.title\" item=item go-to-module=$ctrl.goToModule(item) is-sidebar-expanded=$ctrl.isSidebarExpanded current-index=$ctrl.currentIndex index-item=$index></nav-item></ul></nav></div><div class=profile-container ng-class=\"{\'selected-profile\' : $ctrl.profile.isSubmenuOpen}\"><profile item=$ctrl.profile is-sidebar-expanded=$ctrl.isSidebarExpanded go-to-module=$ctrl.goToModule(item)></profile></div></div></div>");
$templateCache.put("app/main/components/submenu/submenu.html","<div id=submenu-avatar class=sp-submenu ng-if=$ctrl.parentItem.isSubmenuOpen><header><div class=back-btn-mobile ng-include=\"\'/assets/images/left-arrow.svg\'\" ng-click=$ctrl.closeSubmenu()></div><div class=titles><span ng-repeat=\"title in $ctrl.parentItem.submenu.titles\">{{title}}</span></div></header><nav><ul><nav-subitem ng-repeat=\"item in $ctrl.parentItem.submenu.items track by item.title\" item=item go-to-module=$ctrl.callGoToModule(item)></nav-subitem></ul></nav></div>");
$templateCache.put("app/main/components/trial/trial.html","<div class=sp-trial ng-if=$ctrl.showTrial><div><span>{{::$ctrl.getTrialMessage()}}</span> <a href=\"\" ng-click=$ctrl.goStateUprofile()>{{(\'Trial.test_active_account\' | translate)}} <i class=sp-icon-chevron-thin-right></i></a></div><i class=sp-icon-close ng-click=$ctrl.closeTrial()></i></div>");
$templateCache.put("app/shared/components/autocomplete/autocomplete.html","<input type=text class=\"form-control input-address\" name={{$ctrl.inputName}} autocomplete=off id={{$ctrl.inputId}} ng-model=$ctrl.address uib-typeahead=\"$ctrl.getTypeaheadExpression(place) for place in $ctrl.getPlaces($viewValue)\" typeahead-min-length=3 typeahead-wait-ms=300 typeahead-on-select=$ctrl.selectPlace($item) ng-enter=$ctrl.selectPlace($item) ng-required={{$ctrl.isRequired}} translate translate-attr-placeholder=Autocomplete.placeholder ng-focus=$ctrl.onFocus()>");
$templateCache.put("app/shared/components/checkbox/checkbox.html","<label class=sr-checkbox-container><input id={{$ctrl.inputId}} name={{$ctrl.inputName}} type=checkbox ng-model=$ctrl.isChecked ng-change=\"$ctrl.onCheckboxStateChanged($ctrl.inputId, $ctrl.inputName, $ctrl.isChecked)\"> <span class=sr-checkmark><svg width=12 height=12 viewBox=\"0 0 12 12\" fill=none xmlns=http://www.w3.org/2000/svg><path d=\"M11.68.42c.33.23.42.69.19 1.02L4.99 11.39c-.13.19-.33.31-.57.32-.21.01-.42-.1-.57-.28L.16 6.9c-.25-.31-.21-.77.11-1.03.31-.25.77-.21 1.03.11l3.04 3.77L10.67.6c.23-.33.68-.42 1.01-.18z\"/></svg> </span><span class=sr-checkbox-label>{{$ctrl.labelText}}</span></label>");
$templateCache.put("app/shared/components/chipErrorPlan/chipErrorPlan.html","<div class=sp-chip-error-plan-container><span class=sp-chip-error-plan-text uib-tooltip=\"{{\'Planner.error\' | translate}}\" translate=chips.error></span> <button ng-if=$ctrl.showRecoveryBtn class=sp-chip-error-plan-btn ng-click=$ctrl.recoverPlan($event)><div class=sp-chip-error-plan-btn-container-image ng-include=\"\'/assets/images/undo.svg\'\"></div></button></div>");
$templateCache.put("app/shared/components/toggleSwitch/toggleSwitch.html","<div class=toggle-switch-container><label class=toggle-switch uib-tooltip=\"{{$ctrl.isActive ? \'toggleSwitch.enabled\' : \'toggleSwitch.disabled\' | translate}}\"><input id={{$ctrl.inputId}} name={{$ctrl.inputName}} type=checkbox ng-model=$ctrl.isActive ng-disabled=$ctrl.isDisabled ng-change=\"$ctrl.save($ctrl.inputId, $ctrl.inputName, $ctrl.isActive)\"> <span class=slider-round></span></label><span ng-if=$ctrl.labelText class=toggle-switch-label ng-class=\"{\'toggle-switch-label-disabled\': $ctrl.isDisabled}\">{{$ctrl.labelText}}</span></div>");
$templateCache.put("app/shared/components/weekdayCheckboxGroup/weekdayCheckboxGroup.html","<div id={{$ctrl.componentId}} class=checkboxes-wrapper><span class=weekdayCheckboxGroup-label>{{$ctrl.title}}</span><div class=checkboxes-container><sr-checkbox input-id={{$ctrl.componentId}}-every-day input-name={{$ctrl.componentId}}-every-day label-text=\"{{$ctrl.translate(\'Zones.weekdays.every_day\')}}\" is-checked=$ctrl.isEveryDaySelected on-change=$ctrl.onDaySelectionChanged(checkboxState)></sr-checkbox><sr-checkbox ng-repeat=\"(day, value) in $ctrl.weekdays\" input-id={{$ctrl.componentId}}-{{day}} input-name={{$ctrl.componentId}}-{{day}} label-text=\"{{$ctrl.translate(\'Zones.weekdays.\' + day)}}\" is-checked=$ctrl.weekdays[day] on-change=$ctrl.onDaySelectionChanged(checkboxState)></sr-checkbox></div></div>");
$templateCache.put("app/shared/directives/iframe/iframe-template.html","<iframe width=560 height=315 ng-src={{embedUrl}} frameborder=0 allowfullscreen></iframe>");
$templateCache.put("app/shared/html/events-templates/base.html","<div ng-include=getTemplate()></div>");
$templateCache.put("app/shared/html/events-templates/route_finished.html","<div class=left uib-tooltip={{event.data.vehicle_name}}><!--Vehicle Icon--> <svg class=img version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" enable-background=\"new 0 0 32 32\" xml:space=preserve><g id=vehiculos><g><circle style=fill:{{event.data.vehicle_color}} cx=22.54 cy=23.501 r=2.499 /><circle style=fill:{{event.data.vehicle_color}} cx=9.452 cy=23.501 r=2.499 /></g><path d=\"M27.844,17.914l-2.584-7.308l-0.006-0.004c-0.144-0.364-0.492-0.62-0.905-0.629l-0.021-0.015h-3.245V8\n                c0-1.104-0.969-2-2.165-2H5.165C3.969,6,3,6.896,3,8v9.914c0,0.201,0.042,0.393,0.102,0.576C3.041,18.62,3,18.761,3,18.914v3.587\n                c0,0.553,0.448,1,1,1h1.452c0-2.205,1.794-3.999,4-3.999s4,1.794,4,3.999h5.089c0-2.205,1.794-3.999,3.999-3.999\n                c2.206,0,4.001,1.794,4.001,3.999h1.303c0.552,0,1-0.447,1-1v-3.587C28.844,18.361,28.396,17.914,27.844,17.914z M24.924,17.5\n                l-0.002,0.002h-3.339L21.58,17.5c-0.274-0.002-0.497-0.225-0.497-0.5v-4.542c0-0.276,0.224-0.5,0.5-0.5h0.001h1.666\n                c0.226,0,0.408,0.152,0.471,0.356c0,0,1.701,4.596,1.701,4.685C25.422,17.275,25.199,17.499,24.924,17.5z\" style=fill:{{event.data.vehicle_color}} /></g></svg><!--Vehicle Icon--></div><div class=center><div class=title><div class=truncate>{{event.data.vehicle_name}}</div><span class=visit-text translate=Events.route_finished></span></div><div class=others-indicators><div ng-if=showdriver><i class=\"indicator-icon sp-icon-user\"></i> <span>{{event.data.driver_name}}</span></div></div></div><div class=right>{{event.occurred_on}}</div>");
$templateCache.put("app/shared/html/events-templates/route_started.html","<div class=left uib-tooltip={{event.data.vehicle_name}}><!--Vehicle Icon--> <svg class=img version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" enable-background=\"new 0 0 32 32\" xml:space=preserve><g id=vehiculos><g><circle style=fill:{{event.data.vehicle_color}} cx=22.54 cy=23.501 r=2.499 /><circle style=fill:{{event.data.vehicle_color}} cx=9.452 cy=23.501 r=2.499 /></g><path d=\"M27.844,17.914l-2.584-7.308l-0.006-0.004c-0.144-0.364-0.492-0.62-0.905-0.629l-0.021-0.015h-3.245V8\n                c0-1.104-0.969-2-2.165-2H5.165C3.969,6,3,6.896,3,8v9.914c0,0.201,0.042,0.393,0.102,0.576C3.041,18.62,3,18.761,3,18.914v3.587\n                c0,0.553,0.448,1,1,1h1.452c0-2.205,1.794-3.999,4-3.999s4,1.794,4,3.999h5.089c0-2.205,1.794-3.999,3.999-3.999\n                c2.206,0,4.001,1.794,4.001,3.999h1.303c0.552,0,1-0.447,1-1v-3.587C28.844,18.361,28.396,17.914,27.844,17.914z M24.924,17.5\n                l-0.002,0.002h-3.339L21.58,17.5c-0.274-0.002-0.497-0.225-0.497-0.5v-4.542c0-0.276,0.224-0.5,0.5-0.5h0.001h1.666\n                c0.226,0,0.408,0.152,0.471,0.356c0,0,1.701,4.596,1.701,4.685C25.422,17.275,25.199,17.499,24.924,17.5z\" style=fill:{{event.data.vehicle_color}} /></g></svg><!--Vehicle Icon--></div><div class=center><div class=title><div class=truncate>{{event.data.vehicle_name}}</div><span class=visit-text translate=Events.route_started></span></div><div class=others-indicators><div ng-if=showdriver><i class=\"indicator-icon sp-icon-user\"></i> <span>{{event.data.driver_name}}</span></div></div></div><div class=right>{{event.occurred_on}}</div>");
$templateCache.put("app/shared/html/events-templates/visit_checkout.html","<div class=left uib-tooltip={{event.data.vehicle_name}}><!--Vehicle Icon--> <svg class=img version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" enable-background=\"new 0 0 32 32\" xml:space=preserve><g id=vehiculos><g><circle style=fill:{{event.data.vehicle_color}} cx=22.54 cy=23.501 r=2.499 /><circle style=fill:{{event.data.vehicle_color}} cx=9.452 cy=23.501 r=2.499 /></g><path d=\"M27.844,17.914l-2.584-7.308l-0.006-0.004c-0.144-0.364-0.492-0.62-0.905-0.629l-0.021-0.015h-3.245V8\n                c0-1.104-0.969-2-2.165-2H5.165C3.969,6,3,6.896,3,8v9.914c0,0.201,0.042,0.393,0.102,0.576C3.041,18.62,3,18.761,3,18.914v3.587\n                c0,0.553,0.448,1,1,1h1.452c0-2.205,1.794-3.999,4-3.999s4,1.794,4,3.999h5.089c0-2.205,1.794-3.999,3.999-3.999\n                c2.206,0,4.001,1.794,4.001,3.999h1.303c0.552,0,1-0.447,1-1v-3.587C28.844,18.361,28.396,17.914,27.844,17.914z M24.924,17.5\n                l-0.002,0.002h-3.339L21.58,17.5c-0.274-0.002-0.497-0.225-0.497-0.5v-4.542c0-0.276,0.224-0.5,0.5-0.5h0.001h1.666\n                c0.226,0,0.408,0.152,0.471,0.356c0,0,1.701,4.596,1.701,4.685C25.422,17.275,25.199,17.499,24.924,17.5z\" style=fill:{{event.data.vehicle_color}} /></g></svg><!--Vehicle Icon--></div><div class=center><div class=title><span class=visit-text translate=Events.visit></span><div class=truncate><a href=\"\" ng-click=openModal(event.data.visit_id)>{{event.data.visit_title}}</a></div><span ng-if=\"event.data.visit_status === \'completed\'\" translate=Events.completed></span> <span ng-if=\"event.data.visit_status === \'failed\'\" translate=Events.failed></span> <span ng-if=\"event.data.visit_status === \'partial\'\" translate=Events.partial></span> <i class=\"icon indicator-icon sp-icon-ventana-horaria\" ng-if=!event.data.isCheckoutOnTime uib-tooltip=\"{{\'Events.window_broken\' | translate}}\"></i></div><div class=others-indicators><div ng-if=showdriver><i class=\"indicator-icon sp-icon-user\"></i> <span>{{event.data.driver_name}}</span></div><div ng-if=event.data.has_attachments uib-tooltip=\"{{\'Events.file_attached\' | translate}}\"><!--File icon--> <svg class=indicator-icon version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px width=32px height=32px viewBox=\"0 0 32 32\" enable-background=\"new 0 0 32 32\" xml:space=preserve><g id=adjunto><path d=\"M27.626,5.877c-1.543-1.543-3.618-2.397-5.812-2.375c-2.203,0.011-4.271,0.874-5.826,2.428l-7.178,7.178L3.836,18.08\n              c-2.418,2.42-2.461,6.312-0.097,8.675c1.165,1.165,2.699,1.744,4.247,1.744c1.593,0,3.199-0.615,4.426-1.842l9.073-9.072\n              c0.001,0,0.001-0.002,0.002-0.002l3.126-3.127c0.814-0.813,1.271-1.891,1.285-3.035c0.015-1.152-0.417-2.228-1.22-3.03\n              c-1.653-1.654-4.375-1.626-6.066,0.063L7.648,19.418c-0.328,0.329-0.328,0.86,0,1.188c0.165,0.164,0.379,0.246,0.594,0.246\n              c0.216,0,0.431-0.082,0.594-0.246L19.8,9.642c1.034-1.036,2.69-1.064,3.689-0.064c0.479,0.479,0.737,1.125,0.729,1.82\n              c-0.01,0.703-0.291,1.367-0.792,1.868l-3.239,3.239c-0.001,0.001-0.001,0.002-0.002,0.003l-8.961,8.96\n              c-1.763,1.763-4.587,1.806-6.297,0.099c-1.708-1.71-1.666-4.535,0.098-6.299l0.56-0.559c0-0.001,0.002-0.001,0.002-0.003\n              L17.177,7.118c1.238-1.24,2.89-1.928,4.646-1.936c1.75,0.012,3.394,0.659,4.615,1.883c2.539,2.539,2.516,6.695-0.053,9.263\n              l-9.533,9.531c-0.328,0.328-0.328,0.859,0,1.188c0.163,0.164,0.38,0.246,0.594,0.246c0.215,0,0.431-0.082,0.595-0.246l9.532-9.532\n              C30.796,14.292,30.82,9.071,27.626,5.877z\"/></g></svg><!--File icon--></div></div></div><div class=right>{{event.occurred_on}}</div>");
$templateCache.put("app/shared/map-components/static-map/static-map.html","<img ng-src={{$ctrl.url}}>");
$templateCache.put("app/tracking/components/invoiceDetailsTable/invoiceDetailsTable.html","<div class=invoice-details-container><div class=invoice-details ng-if=$ctrl.visit><div class=invoice-details-status ng-class=\"{\n          \'status-pending\': $ctrl.currentInvoice.status === \'pending\' ||\n          $ctrl.currentInvoice.status === \'partial\',\n          \'status-failed\': $ctrl.currentInvoice.status === \'failed\' || $ctrl.currentInvoice.status === \'canceled\',\n          \'status-delivered\': $ctrl.currentInvoice.status === \'completed\'\n        }\">{{$ctrl.changeCompletedStatus($ctrl.translateDetailOfInvoice($ctrl.currentInvoice.status))}}</div><div class=invoice-details-id><div class=\"invoice-details-value invoice-details-type\">{{$ctrl.translateDetailOfInvoice($ctrl.currentInvoice.type)}}</div><span>#{{$ctrl.currentInvoice.reference}}</span></div><div class=invoice-details-item><div class=invoice-details-label>Total:</div><div class=invoice-details-value>${{$ctrl.formatCurrency($ctrl.getTotalInvoiceAmount())}} {{$ctrl.currentInvoice.currency !== \'None\' ? $ctrl.currentInvoice.currency : \'\'}}</div></div><div class=invoice-details-item><div class=invoice-details-label translate=Invoices.payment_method></div><div>:</div><div class=invoice-details-value>{{$ctrl.translateDetailOfInvoice($ctrl.currentInvoice.payment_method)}}</div></div><div class=invoice-details-item ng-if=$ctrl.currentInvoice.payment_method_details><div class=invoice-details-label translate=Invoices.payment_method_details></div><div>:</div><div class=invoice-details-value>{{$ctrl.currentInvoice.payment_method_details}}</div></div><div class=invoice-details-item ng-if=$ctrl.currentInvoice.delivery_issue><div class=invoice-details-label translate=Invoices.failed_invoice></div><div>:</div><div class=invoice-details-value>{{$ctrl.getDeliveryIssue($ctrl.currentInvoice.delivery_issue)}}</div></div></div><div class=invoice-items-info><span class=invoice-details-title translate=Invoices.dispatched></span><div class=invoice-details-progress><span>{{$ctrl.totalInvoiceDeliveredUnits()}}</span> <span translate=Invoices.delivered_products></span> <span>{{$ctrl.totalInvoiceUnits()}}</span></div></div><div class=invoice-table><div class=invoice-table-header><div class=invoice-detail-title translate=Invoices.items></div><div class=invoice-detail-title translate=Invoices.quantity_planned></div><div class=invoice-detail-title translate=Invoices.quantity_delivered></div><div class=invoice-detail-title translate=Invoices.price></div><div class=invoice-detail-title translate=Invoices.amount_delivered></div><div class=invoice-detail-title>SKU</div><div class=invoice-detail-title translate=Invoices.status></div><div class=invoice-detail-title translate=Invoices.motive></div></div></div><div class=invoice-items-table-container><div ng-repeat=\"item in $ctrl.currentInvoice.items\"><div class=invoice-table-row><div class=invoice-detail-item uib-tooltip=\"{{ item.title }}\">{{ $ctrl.trimString(item.title) }}</div><div class=invoice-detail-item>{{ item.planned_units || 0 }}</div><div class=invoice-detail-item>{{ item.delivered_units || 0 }}</div><div class=invoice-detail-item>${{ $ctrl.formatCurrency(item.unit_price) || 0 }}</div><div class=invoice-detail-item>${{ $ctrl.formatCurrency(item.unit_price * item.delivered_units) || 0 }}</div><div class=invoice-detail-item>{{ $ctrl.trimString(item.sku) }}</div><div class=invoice-detail-item><div class=invoice-status ng-class=\"{\n                \'status-pending\': item.status === \'pending\' ||\n                item.status === \'partial\',\n                \'status-failed\': item.status === \'failed\',\n                \'status-delivered\': item.status === \'completed\'\n              }\">{{ $ctrl.translateDetailOfInvoice(item.status) }}</div></div><div class=invoice-detail-item uib-tooltip=\"{{ $ctrl.getDeliveryIssue(item.delivery_issue) }}\">{{ $ctrl.trimString($ctrl.getDeliveryIssue(item.delivery_issue)) }}</div></div></div></div><div class=invoice-detail-summary ng-class=\"{\n        \'status-summary-pending\': $ctrl.currentInvoice.status === \'pending\' ||\n        $ctrl.currentInvoice.status === \'partial\',\n        \'status-summary-failed\': $ctrl.currentInvoice.status === \'failed\',\n        \'status-summary-success\': $ctrl.currentInvoice.status === \'completed\'\n      }\"><div class=invoice-detail-item>Total</div><div class=invoice-detail-item>{{$ctrl.getTotalPlannedQuantities()}}</div><div class=invoice-detail-item>{{$ctrl.getTotalDeliveredUnits()}}</div><div class=invoice-detail-item></div><div class=invoice-detail-item>${{$ctrl.formatCurrency($ctrl.getTotalDeliveredAmount())}}</div><div class=invoice-detail-item></div><div class=invoice-detail-item></div></div><div class=invoice-footer><div class=invoice-details-page><button class=invoice-footer-btn ng-click=$ctrl.prevInvoice() ng-if=\"$ctrl.invoiceIndex + 1 !== 1\"><img ng-src=/assets/images/arrow_back_black.svg alt=\"\"> <span translate=Invoices.prev></span></button></div><div class=invoice-details-page>{{ $ctrl.invoiceIndex + 1 }}/{{ $ctrl.invoices.length }}</div><div class=invoice-details-page><button class=invoice-footer-btn ng-click=$ctrl.nextInvoice() ng-if=\"$ctrl.invoiceIndex + 1 !== $ctrl.invoices.length\"><span translate=Invoices.next></span> <img ng-src=/assets/images/arrow_forward_black.svg alt=\"\"></button></div></div></div>");
$templateCache.put("app/tracking/components/retoolWidget/retoolWidget.html","<div class=sp-retool-widget><div class=widget-icon><button ng-click=$ctrl.openRetool()><div ng-include=\"\'/assets/images/plus.svg\'\" style=\"display: flex; color: white\"></div></button></div><div class=widget-content ng-show=$ctrl.isOpen><button class=close-button ng-click=$ctrl.closeRetool()><div class=close-icon ng-include=\"\'/assets/images/close_mobile_sidebar.svg\'\"></div></button><iframe-directive class=widget-iframe site-url={{$ctrl.url}}></iframe-directive></div></div>");
$templateCache.put("app/tracking/components/itemsDetailsTable/itemsDetailsTable.html","<div class=items-details-container><button class=\"btn btn-primary btn-back-items\" ng-click=goBack()><img ng-src=/assets/images/arrow_back_white.svg alt=\"\"> <span translate=Items.go_back></span></button> <span class=items-details-title>{{tableTitle}}</span> <span class=items-details-progress>{{itemsQuantitySummary}}</span><div class=items-table><div class=items-table-header><div class={{itemsColumnHeaderClass}} translate=Items.items_table></div><div ng-if=shouldShowSubItemsColumn() class={{subItemsColumnClass}} translate=Items.sub_items_header></div><div class={{middleColumnsClass}} translate=Items.quantity_planned></div><div class={{middleColumnsClass}}>{{fractionQuantityColumnHeader}}</div><div class={{middleColumnsClass}} translate=Items.status.header></div><div ng-if=shouldShowSubItemsColumn() class={{subItemsButtonClass}}></div></div><div ng-repeat=\"item in items track by item.id\"><div class={{getItemRowClass(item)}} ng-click=showSubItemsDetailsTable(item)><div class={{itemsColumnElementsClass}}>{{getItemTitle(item)}}</div><div ng-if=shouldShowSubItemsColumn() class={{subItemsColumnClass}}>{{itemsStatistics.totalSubItemsQuantityCollectedPerItem[item.id]}}</div><div class={{middleColumnsClass}}>{{item.quantity_planned}}</div><div class={{middleColumnsClass}}>{{getItemFractionQuantity(item)}}</div><div class={{statusColumnClass}} ng-class=getItemStatusNgClass(item)><div ng-include=getItemStatusIconPath(item) class=status-icon></div>{{getTranslatedItemStatus(item)}}</div><div ng-if=shouldShowSubItemsColumn() class={{subItemsButtonClass}}><span ng-if=item.sub_items.length><i ng-if=!shouldShowSubItemsDetails(item) class=sp-icon-chevron-right></i> <i ng-if=shouldShowSubItemsDetails(item) class=sp-icon-chevron-down></i></span></div></div><sub-items-details-table ng-if=shouldShowSubItemsDetails(item) item=currentExpandedItem></sub-items-details-table></div><div class={{tableFooterClass}}><div class={{itemsColumnElementsClass}} translate=Items.total></div><div ng-if=shouldShowSubItemsColumn() class={{subItemsColumnClass}}>{{itemsStatistics.totalSubItemsQuantityCollected}}</div><div class={{middleColumnsClass}}>{{itemsStatistics.totalQuantityPlanned}}</div><div class={{middleColumnsClass}}>{{totalFractionQuantity}}</div><div class={{middleColumnsClass}}></div><div ng-if=shouldShowSubItemsColumn() class={{subItemsButtonClass}}></div></div></div></div>");
$templateCache.put("app/tracking/components/subItemsDetailsTable/subItemsDetailsTable.html","<div class=sub-items-table><div class=sub-items-table-header><div class={{subItemsDetailColumnClass}} translate=Items.sub_items_detail></div><div class={{subItemsQuantityColumnClass}} translate=Items.sub_items_quantity></div></div><div class=sub-items-table-content><div class=sub-items-table-row ng-repeat=\"sub_item in item.sub_items\"><div class={{subItemsDetailColumnClass}}>{{sub_item.subtype_name}}</div><div class={{subItemsQuantityColumnClass}}>{{sub_item.quantity_collected}}</div></div></div></div>");
$templateCache.put("app/planner/routes/components/visitSimilarityMarker/visitSimilarityMarker.html","<div class=sp-visit-similarity-marker><div class=sp-similarity-connector ng-style=\"$ctrl.areSimilarVisits($ctrl.currentVisit, $ctrl.previousVisit) && {\'background-color\': $ctrl.vehicleColor}\"></div><div ng-if=$ctrl.shouldShowVisitMarker() class=sp-similarity-marker ng-style=\"{\'border-color\': $ctrl.vehicleColor}\"></div><div class=sp-similarity-connector ng-style=\"$ctrl.areSimilarVisits($ctrl.currentVisit, $ctrl.nextVisit) && {\'background-color\': $ctrl.vehicleColor}\"></div></div>");
$templateCache.put("app/planner/routes/components/savePlanErrorModal/savePlanErrorModal.html","<div class=\"modal-body sp-restrict-height-to-400\"><h4 class=modal-title>{{$ctrl.getModalFirstSentence()}}</h4></div><div class=\"info-modal-body sp-restrict-height-to-400\"><div class=save-plan-error-table-wrapper><div class=save-plan-error-table-content><div class=save-plan-error-table-header><table class=\"table table-striped save-plan-error-table-row\"><thead><tr><th class=sp-text-center translate=Routes.save_plan_error_modal.list_heading></th></tr></thead></table></div><table class=\"table table-striped save-plan-error-table-row\"><tbody><tr ng-repeat=\"visitTitle in $ctrl.visitsTitles track by $index\"><td class=\"text-left col-100\">{{visitTitle}}</td></tr></tbody></table></div></div></div><div class=\"modal-body sp-restrict-height-to-400\"><h4 ng-show=$ctrl.areInvalidVisits() class=modal-title translate=Routes.save_plan_error_modal.second_sentence></h4><div class=\"sp-confirm-plan save-plan-error-buttons-block\"><div class=sp-modal-options><div class=sp-modal-options-block><button type=button class=\"btn btn-primary pull-right\" ng-click=$ctrl.goBack()>{{$ctrl.getGoBackBtnText()}}</button></div><div ng-show=$ctrl.areInvalidVisits() class=sp-modal-options-block><button type=button class=\"btn btn-success pull-right\" ng-click=$ctrl.confirm() translate=Routes.save_plan_error_modal.confirm_btn_text></button></div></div></div></div>");
$templateCache.put("app/planner/routes/routes-modals/confirm-complete-modal/confirm-complete-modal.html","<div class=confirm_complete_modal><div class=confirm_complete_modal_header><p class=confirm_complete_modal_header_title translate=ConfirmCompletePlan.title></p></div><div class=confirm_complete_modal_content><p class=confirm_complete_modal_content_text translate=ConfirmCompletePlan.message></p><div class=confirm_complete_modal_content_options><button class=sp_btn_confirm ng-click=closeThisDialog(1) translate=ConfirmCompletePlan.confirm></button> <button class=sp_btn_cancel ng-click=closeThisDialog(0) translate=ConfirmCompletePlan.cancel></button></div></div></div>");
$templateCache.put("app/planner/routes/routes-modals/reoptimizer-modal/reoptimizer-modal.html","<div id=reoptimizer-modal class=sp-modal-content><div class=\"modal-header modal-header-warning\"><h4 class=modal-title translate=Reoptimizer_modal.reoptimizer_title></h4></div><div class=modal-body><p translate=Reoptimizer_modal.reoptimizer_message></p><p translate=Reoptimizer_modal.reoptimizer_question></p></div><div class=reoptimizer-modal-footer><button type=button class=\"btn btn-success\" ng-click=closeThisDialog(vm.MODAL_REOPTIMIZER_OPTION) translate=Reoptimizer_modal.button_reoptimizer></button> <button type=button class=btn-link ng-click=closeThisDialog(vm.MODAL_CONTINUE_OPTION) translate=Reoptimizer_modal.button_not_reoptimizer></button></div></div>");
$templateCache.put("app/planner/routes/routes-modals/revised-route-modal/revised-route-modal.html","<div id=revised-route-modal class=sp-modal-content><div class=revised-route-modal-header><h4 class=revised-route-modal-title translate=Revised_route_modal.title></h4></div><div class=modal-body><p translate=Revised_route_modal.body_first_line></p><p translate=Revised_route_modal.body_second_line></p></div><div class=revised-route-modal-footer><button type=button class=\"btn btn-success\" ng-click=\"markRouteAsUnrevised(route); closeThisDialog(0);\" translate=Planner.btn_continue></button> <button type=button class=btn-link ng-click=closeThisDialog(0) translate=Planner.btn_cancel></button></div></div>");
$templateCache.put("app/planner/routes/routes-modals/route-delete-modal/route-delete-modal.html","<div class=route_delete_modal><div class=route_delete_modal_header><p class=route_delete_modal_header_title translate=Routes.delete_route></p></div><div class=route_delete_modal_content><p class=route_delete_modal_content_text translate=Routes.delete_modal_message></p><span class=route_delete_modal_content_text>{{vehicle.name}} - {{ routeName }}</span><div class=route_delete_modal_content_options><button class=sp_btn_confirm ng-click=\"deleteRoute(vehicle, route); closeThisDialog(0)\" translate=Routes.delete></button> <button class=sp_btn_cancel ng-click=closeThisDialog(0) translate=Routes.close></button></div></div></div>");
$templateCache.put("app/planner/routes/routes-modals/delete-route-modal/delete-route-modal.html","<div class=sp-modal-content><div class=\"modal-header modal-header-danger\"><h3 class=modal-title translate=Routes.delete_route></h3></div><div class=\"modal-body text-center\"><p translate=Routes.delete_modal_message></p><h4>{{vehicle.name}} -- <span>{{ routeName }}</span></h4></div><div class=sp-modal-buttons><button type=button class=\"btn btn-default\" ng-click=closeThisDialog(0) translate=Routes.close></button> <button type=button class=\"btn btn-danger\" ng-click=\"deleteRoute(vehicle, route); closeThisDialog(0)\" translate=Routes.delete></button></div></div>");}]);